'use strict';
var $i_$0040hpcc$002djs$002fwasm$002dgraphviz = require("@hpcc-js/wasm-graphviz");
var $fileLevelThis = this;
var $getOwnPropertyDescriptors = (Object.getOwnPropertyDescriptors || (() => {
  var ownKeysFun;
  if ((((typeof Reflect) !== "undefined") && Reflect.ownKeys)) {
    ownKeysFun = Reflect.ownKeys;
  } else {
    var getOwnPropertySymbols = (Object.getOwnPropertySymbols || ((o) => []));
    ownKeysFun = ((o) => Object.getOwnPropertyNames(o).concat(getOwnPropertySymbols(o)));
  }
  return ((o) => {
    var ownKeys = ownKeysFun(o);
    var descriptors = ({});
    var len = (ownKeys.length | 0);
    var i = 0;
    while ((i !== len)) {
      var key = ownKeys[i];
      Object.defineProperty(descriptors, key, ({
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": Object.getOwnPropertyDescriptor(o, key)
      }));
      i = ((i + 1) | 0);
    }
    return descriptors;
  });
})());
function $Char(c) {
  this.c = c;
}
$Char.prototype.toString = (function() {
  return String.fromCharCode(this.c);
});
function $Long(lo, hi) {
  this.l = lo;
  this.h = hi;
}
$Long.prototype.toString = (function() {
  return $s_RTLong__toString__I__I__T(this.l, this.h);
});
function $valueDescription(arg0) {
  return (((typeof arg0) === "number") ? (((arg0 === 0) && ((1 / arg0) < 0)) ? "number(-0)" : (("number(" + arg0) + ")")) : ((arg0 instanceof $Long) ? "long" : ((arg0 instanceof $Char) ? "char" : ((!(!(arg0 && arg0.$classData))) ? arg0.$classData.name : (typeof arg0)))));
}
function $throwClassCastException(arg0, arg1) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_ClassCastException__T__(new $c_jl_ClassCastException(), (($valueDescription(arg0) + " cannot be cast to ") + arg1)));
}
function $throwArrayCastException(arg0, arg1, arg2) {
  while ((--arg2)) {
    arg1 = ("[" + arg1);
  }
  $throwClassCastException(arg0, arg1);
}
function $throwArrayIndexOutOFBoundsException(arg0) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((arg0 === null) ? null : ("" + arg0))));
}
function $throwArrayStoreException(arg0) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_ArrayStoreException(((arg0 === null) ? null : $valueDescription(arg0))));
}
function $throwNegativeArraySizeException() {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_NegativeArraySizeException());
}
function $throwNullPointerException() {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_NullPointerException__(new $c_jl_NullPointerException()));
}
function $n(arg0) {
  if ((arg0 === null)) {
    $throwNullPointerException();
  }
  return arg0;
}
function $noIsInstance(arg0) {
  throw new TypeError("Cannot call isInstance() on a Class representing a JS trait/object");
}
function $objectClone(arg0) {
  return Object.create(Object.getPrototypeOf(arg0), $getOwnPropertyDescriptors(arg0));
}
function $objectOrArrayClone(arg0) {
  return (arg0.$classData.isArrayClass ? arg0.clone__O() : $objectClone(arg0));
}
function $aJCheckGet(arg0, arg1) {
  if (((arg1 >>> 0) >= (arg0.length >>> 1))) {
    $throwArrayIndexOutOFBoundsException(arg1);
  }
  return (arg1 << 1);
}
function $objectGetClass(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return $d_T.getClassOf();
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return $d_jl_Byte.getClassOf();
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return $d_jl_Short.getClassOf();
        } else {
          return $d_jl_Integer.getClassOf();
        }
      } else if ($isFloat(arg0)) {
        return $d_jl_Float.getClassOf();
      } else {
        return $d_jl_Double.getClassOf();
      }
    }
    case "boolean": {
      return $d_jl_Boolean.getClassOf();
    }
    case "undefined": {
      return $d_jl_Void.getClassOf();
    }
    default: {
      if ((arg0 instanceof $Long)) {
        return $d_jl_Long.getClassOf();
      } else if ((arg0 instanceof $Char)) {
        return $d_jl_Character.getClassOf();
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.getClassOf();
      } else {
        return null;
      }
    }
  }
}
function $objectClassName(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return "java.lang.String";
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return "java.lang.Byte";
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return "java.lang.Short";
        } else {
          return "java.lang.Integer";
        }
      } else if ($isFloat(arg0)) {
        return "java.lang.Float";
      } else {
        return "java.lang.Double";
      }
    }
    case "boolean": {
      return "java.lang.Boolean";
    }
    case "undefined": {
      return "java.lang.Void";
    }
    default: {
      if ((arg0 instanceof $Long)) {
        return "java.lang.Long";
      } else if ((arg0 instanceof $Char)) {
        return "java.lang.Character";
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.name;
      } else {
        return $throwNullPointerException();
      }
    }
  }
}
function $dp_codePointAt__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__codePointAt__I__I(instance, x0);
  } else {
    return instance.codePointAt__I__I(x0);
  }
}
function $dp_compareTo__O__I(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__compareTo__O__I(instance, x0);
    }
    case "number": {
      return $f_jl_Double__compareTo__O__I(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__compareTo__O__I(instance, x0);
    }
    default: {
      if ((instance instanceof $Long)) {
        return $f_jl_Long__compareTo__O__I(instance.l, instance.h, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__compareTo__O__I(instance.c, x0);
      } else {
        return instance.compareTo__O__I(x0);
      }
    }
  }
}
function $dp_compareTo__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareTo__T__I(instance, x0);
  } else {
    return instance.compareTo__T__I(x0);
  }
}
function $dp_equals__O__Z(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__equals__O__Z(instance, x0);
    }
    case "number": {
      return $f_jl_Double__equals__O__Z(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__equals__O__Z(instance, x0);
    }
    case "undefined": {
      return $f_jl_Void__equals__O__Z(instance, x0);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.equals__O__Z(x0);
      } else if ((instance instanceof $Long)) {
        return $f_jl_Long__equals__O__Z(instance.l, instance.h, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__equals__O__Z(instance.c, x0);
      } else {
        return $c_O.prototype.equals__O__Z.call(instance, x0);
      }
    }
  }
}
function $dp_getChars__I__I__AC__I__V(instance, x0, x1, x2, x3) {
  if (((typeof instance) === "string")) {
    return $f_T__getChars__I__I__AC__I__V(instance, x0, x1, x2, x3);
  } else {
    return instance.getChars__I__I__AC__I__V(x0, x1, x2, x3);
  }
}
function $dp_hashCode__I(instance) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__hashCode__I(instance);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(instance);
    }
    case "boolean": {
      return $f_jl_Boolean__hashCode__I(instance);
    }
    case "undefined": {
      return $f_jl_Void__hashCode__I(instance);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.hashCode__I();
      } else if ((instance instanceof $Long)) {
        return $f_jl_Long__hashCode__I(instance.l, instance.h);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__hashCode__I(instance.c);
      } else {
        return $c_O.prototype.hashCode__I.call(instance);
      }
    }
  }
}
function $dp_indexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I(instance, x0);
  } else {
    return instance.indexOf__I__I(x0);
  }
}
function $dp_lastIndexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__lastIndexOf__I__I(instance, x0);
  } else {
    return instance.lastIndexOf__I__I(x0);
  }
}
function $dp_length__I(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__length__I(instance);
  } else {
    return instance.length__I();
  }
}
function $dp_repeat__I__T(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__repeat__I__T(instance, x0);
  } else {
    return instance.repeat__I__T(x0);
  }
}
function $dp_replaceAll__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceAll__T__T__T(instance, x0, x1);
  } else {
    return instance.replaceAll__T__T__T(x0, x1);
  }
}
function $dp_replaceFirst__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceFirst__T__T__T(instance, x0, x1);
  } else {
    return instance.replaceFirst__T__T__T(x0, x1);
  }
}
function $dp_split__T__I__AT(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__split__T__I__AT(instance, x0, x1);
  } else {
    return instance.split__T__I__AT(x0, x1);
  }
}
function $dp_subSequence__I__I__jl_CharSequence(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__subSequence__I__I__jl_CharSequence(instance, x0, x1);
  } else {
    return instance.subSequence__I__I__jl_CharSequence(x0, x1);
  }
}
function $dp_toCharArray__AC(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__toCharArray__AC(instance);
  } else {
    return instance.toCharArray__AC();
  }
}
function $dp_toString__T(instance) {
  return ((instance === (void 0)) ? "undefined" : instance.toString());
}
function $dp_trim__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__trim__T(instance);
  } else {
    return instance.trim__T();
  }
}
function $checkIntDivisor(arg0) {
  if ((arg0 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  } else {
    return arg0;
  }
}
function $doubleToInt(arg0) {
  return ((arg0 > 2147483647) ? 2147483647 : ((arg0 < (-2147483648)) ? (-2147483648) : (arg0 | 0)));
}
function $cToS(arg0) {
  return String.fromCharCode(arg0);
}
function $charAt(arg0, arg1) {
  var r = arg0.charCodeAt(arg1);
  if ((r !== r)) {
    throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_StringIndexOutOfBoundsException(arg1));
  } else {
    return r;
  }
}
var $fpBitsDataView = new DataView(new ArrayBuffer(8));
function $floatToBits(arg0) {
  var dataView = $fpBitsDataView;
  dataView.setFloat32(0, arg0, true);
  return dataView.getInt32(0, true);
}
function $floatFromBits(arg0) {
  var dataView = $fpBitsDataView;
  dataView.setInt32(0, arg0, true);
  return dataView.getFloat32(0, true);
}
function $doubleToBits(arg0) {
  var dataView = $fpBitsDataView;
  return $s_RTLong__fromDoubleBits__D__O__J(arg0, dataView);
}
function $doubleFromBits(arg0) {
  var dataView = $fpBitsDataView;
  return $s_RTLong__bitsToDouble__I__I__O__D(arg0.l, arg0.h, dataView);
}
function $resolveSuperRef(arg0, arg1) {
  var getPrototypeOf = Object.getPrototyeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var superProto = arg0.prototype;
  while ((superProto !== null)) {
    var desc = getOwnPropertyDescriptor(superProto, arg1);
    if ((desc !== (void 0))) {
      return desc;
    }
    superProto = getPrototypeOf(superProto);
  }
}
function $superGet(arg0, arg1, arg2) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var getter = desc.get;
    return ((getter !== (void 0)) ? getter.call(arg1) : getter.value);
  }
}
function $superSet(arg0, arg1, arg2, arg3) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var setter = desc.set;
    if ((setter !== (void 0))) {
      setter.call(arg1, arg3);
      return (void 0);
    }
  }
  throw new TypeError((("super has no setter '" + arg2) + "'."));
}
function $moduleDefault(arg0) {
  return (((arg0 && ((typeof arg0) === "object")) && ("default" in arg0)) ? arg0["default"] : arg0);
}
function $arraycopyCheckBounds(arg0, arg1, arg2, arg3, arg4) {
  if ((((((arg1 | arg3) | arg4) < 0) || (arg1 > ((arg0 - arg4) | 0))) || (arg3 > ((arg2 - arg4) | 0)))) {
    $throwArrayIndexOutOFBoundsException(null);
  }
}
function $arraycopyGeneric(arg0, arg1, arg2, arg3, arg4) {
  $arraycopyCheckBounds(arg0.length, arg1, arg2.length, arg3, arg4);
  if (((arg0 !== arg2) || (((arg3 - arg1) >>> 0) > (arg4 >>> 0)))) {
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  } else {
    for (var i = ((arg4 - 1) | 0); (i >= 0); i = ((i - 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  }
}
function $systemArraycopy(arg0, arg1, arg2, arg3, arg4) {
  arg0.copyTo(arg1, arg2, arg3, arg4);
}
function $systemArraycopyRefs(arg0, arg1, arg2, arg3, arg4) {
  if (arg2.$classData.isAssignableFrom(arg0.$classData)) {
    $arraycopyGeneric(arg0.u, arg1, arg2.u, arg3, arg4);
  } else {
    var srcArray = arg0.u;
    $arraycopyCheckBounds(srcArray.length, arg1, arg2.u.length, arg3, arg4);
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2.set(((arg3 + i) | 0), srcArray[((arg1 + i) | 0)]);
    }
  }
}
function $systemArraycopyFull(arg0, arg1, arg2, arg3, arg4) {
  var srcData = (arg0 && arg0.$classData);
  if ((srcData === (arg2 && arg2.$classData))) {
    if ((srcData && srcData.isArrayClass)) {
      $systemArraycopy(arg0, arg1, arg2, arg3, arg4);
    } else {
      $throwArrayStoreException(null);
    }
  } else if (((arg0 instanceof $ac_O) && (arg2 instanceof $ac_O))) {
    $systemArraycopyRefs(arg0, arg1, arg2, arg3, arg4);
  } else {
    $throwArrayStoreException(null);
  }
}
var $lastIDHash = 0;
var $idHashCodeMap = new WeakMap();
function $systemIdentityHashCode(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj);
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj);
      }
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32));
      }
      return biHash;
    }
    case "boolean": {
      return (obj ? 1231 : 1237);
    }
    case "undefined": {
      return 0;
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description));
    }
    default: {
      if ((obj === null)) {
        return 0;
      } else {
        var hash = $idHashCodeMap.get(obj);
        if ((hash === (void 0))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          $idHashCodeMap.set(obj, hash);
        }
        return hash;
      }
    }
  }
}
function $isByte(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 24) >> 24) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isShort(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 16) >> 16) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isInt(arg0) {
  return ((((typeof arg0) === "number") && ((arg0 | 0) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
function $isFloat(arg0) {
  return (((typeof arg0) === "number") && ((arg0 !== arg0) || (Math.fround(arg0) === arg0)));
}
function $bC(arg0) {
  return new $Char(arg0);
}
var $bC0 = $bC(0);
function $bL(arg0, arg1) {
  return new $Long(arg0, arg1);
}
var $bL0 = $bL(0, 0);
function $uV(arg0) {
  return (((arg0 === (void 0)) || (arg0 === null)) ? (void 0) : $throwClassCastException(arg0, "java.lang.Void"));
}
function $uZ(arg0) {
  return ((((typeof arg0) === "boolean") || (arg0 === null)) ? (!(!arg0)) : $throwClassCastException(arg0, "java.lang.Boolean"));
}
function $uC(arg0) {
  return (((arg0 instanceof $Char) || (arg0 === null)) ? ((arg0 === null) ? 0 : arg0.c) : $throwClassCastException(arg0, "java.lang.Character"));
}
function $uB(arg0) {
  return (($isByte(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Byte"));
}
function $uS(arg0) {
  return (($isShort(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Short"));
}
function $uI(arg0) {
  return (($isInt(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Integer"));
}
function $uJ(arg0) {
  return (((arg0 instanceof $Long) || (arg0 === null)) ? ((arg0 === null) ? $bL0 : arg0) : $throwClassCastException(arg0, "java.lang.Long"));
}
function $uF(arg0) {
  return (($isFloat(arg0) || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Float"));
}
function $uD(arg0) {
  return ((((typeof arg0) === "number") || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Double"));
}
function $uT(arg0) {
  return ((((typeof arg0) === "string") || (arg0 === null)) ? ((arg0 === null) ? "" : arg0) : $throwClassCastException(arg0, "java.lang.String"));
}
function $ct_O__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_O() {
}
$c_O.prototype.constructor = $c_O;
/** @constructor */
function $h_O() {
}
$h_O.prototype = $c_O.prototype;
$c_O.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_O.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_O.prototype.toString__T = (function() {
  var i = this.hashCode__I();
  return (($objectClassName(this) + "@") + $as_T((i >>> 0.0).toString(16)));
});
$c_O.prototype.toString = (function() {
  return this.toString__T();
});
function $ac_O(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = null;
    }
  } else {
    this.u = arg;
  }
}
$ac_O.prototype = new $h_O();
$ac_O.prototype.constructor = $ac_O;
$ac_O.prototype.get = (function(i) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_O.prototype.set = (function(i, v) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_O.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
});
$ac_O.prototype.clone__O = (function() {
  return new $ac_O(this.u.slice());
});
function $ah_O() {
}
$ah_O.prototype = $ac_O.prototype;
function $ac_Z(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = false;
    }
  } else {
    this.u = arg;
  }
}
$ac_Z.prototype = new $h_O();
$ac_Z.prototype.constructor = $ac_Z;
$ac_Z.prototype.get = (function(i) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_Z.prototype.set = (function(i, v) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_Z.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
});
$ac_Z.prototype.clone__O = (function() {
  return new $ac_Z(this.u.slice());
});
function $ac_C(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Uint16Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_C.prototype = new $h_O();
$ac_C.prototype.constructor = $ac_C;
$ac_C.prototype.get = (function(i) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_C.prototype.set = (function(i, v) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_C.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_C.prototype.clone__O = (function() {
  return new $ac_C(this.u.slice());
});
function $ac_B(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Int8Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_B.prototype = new $h_O();
$ac_B.prototype.constructor = $ac_B;
$ac_B.prototype.get = (function(i) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_B.prototype.set = (function(i, v) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_B.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_B.prototype.clone__O = (function() {
  return new $ac_B(this.u.slice());
});
function $ac_S(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Int16Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_S.prototype = new $h_O();
$ac_S.prototype.constructor = $ac_S;
$ac_S.prototype.get = (function(i) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_S.prototype.set = (function(i, v) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_S.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_S.prototype.clone__O = (function() {
  return new $ac_S(this.u.slice());
});
function $ac_I(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Int32Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_I.prototype = new $h_O();
$ac_I.prototype.constructor = $ac_I;
$ac_I.prototype.get = (function(i) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_I.prototype.set = (function(i, v) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_I.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_I.prototype.clone__O = (function() {
  return new $ac_I(this.u.slice());
});
function $ac_J(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    arg = (arg << 1);
    this.u = new Int32Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_J.prototype = new $h_O();
$ac_J.prototype.constructor = $ac_J;
$ac_J.prototype.set = (function(i, v, w) {
  if (((i >>> 0) >= (((this.u.length >>> 1) | 0) >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  i = (i << 1);
  this.u[i] = v;
  this.u[((i + 1) | 0)] = w;
});
$ac_J.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(((this.u.length >>> 1) | 0), srcPos, ((dest.u.length >>> 1) | 0), destPos, length);
  dest.u.set(this.u.subarray((srcPos << 1), (((srcPos + length) | 0) << 1)), (destPos << 1));
});
$ac_J.prototype.clone__O = (function() {
  return new $ac_J(this.u.slice());
});
function $ac_F(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Float32Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_F.prototype = new $h_O();
$ac_F.prototype.constructor = $ac_F;
$ac_F.prototype.get = (function(i) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_F.prototype.set = (function(i, v) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_F.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_F.prototype.clone__O = (function() {
  return new $ac_F(this.u.slice());
});
function $ac_D(arg) {
  if (((typeof arg) === "number")) {
    if ((arg < 0)) {
      $throwNegativeArraySizeException();
    }
    this.u = new Float64Array(arg);
  } else {
    this.u = arg;
  }
}
$ac_D.prototype = new $h_O();
$ac_D.prototype.constructor = $ac_D;
$ac_D.prototype.get = (function(i) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  return this.u[i];
});
$ac_D.prototype.set = (function(i, v) {
  if (((i >>> 0) >= (this.u.length >>> 0))) {
    $throwArrayIndexOutOFBoundsException(i);
  }
  this.u[i] = v;
});
$ac_D.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_D.prototype.clone__O = (function() {
  return new $ac_D(this.u.slice());
});
function $TypeData() {
  this.constr = (void 0);
  this.ancestors = null;
  this.componentData = null;
  this.arrayBase = null;
  this.arrayDepth = 0;
  this.zero = null;
  this.arrayEncodedName = "";
  this._classOf = (void 0);
  this._arrayOf = (void 0);
  this.isAssignableFromFun = (void 0);
  this.wrapArray = (void 0);
  this.isJSType = false;
  this.name = "";
  this.isPrimitive = false;
  this.isInterface = false;
  this.isArrayClass = false;
  this.isInstance = (void 0);
}
$TypeData.prototype.initPrim = (function(zero, arrayEncodedName, displayName, arrayClass, typedArrayClass) {
  this.ancestors = ({});
  this.zero = zero;
  this.arrayEncodedName = arrayEncodedName;
  var self = this;
  this.isAssignableFromFun = ((that) => (that === self));
  this.name = displayName;
  this.isPrimitive = true;
  this.isInstance = ((obj) => false);
  if ((arrayClass !== (void 0))) {
    this._arrayOf = new $TypeData().initSpecializedArray(this, arrayClass, typedArrayClass, (arrayEncodedName === "J"));
  }
  return this;
});
$TypeData.prototype.initClass = (function(kindOrCtor, fullName, ancestors, isInstance) {
  var internalName = Object.getOwnPropertyNames(ancestors)[0];
  this.ancestors = ancestors;
  this.arrayEncodedName = (("L" + fullName) + ";");
  this.isAssignableFromFun = ((that) => (!(!that.ancestors[internalName])));
  this.isJSType = (kindOrCtor === 2);
  this.name = fullName;
  this.isInterface = (kindOrCtor === 1);
  this.isInstance = (isInstance || ((obj) => (!(!((obj && obj.$classData) && obj.$classData.ancestors[internalName])))));
  if (((typeof kindOrCtor) !== "number")) {
    kindOrCtor.prototype.$classData = this;
  }
  return this;
});
$TypeData.prototype.initSpecializedArray = (function(componentData, arrayClass, typedArrayClass, isLongArray, isAssignableFromFun) {
  arrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = arrayClass;
  this.ancestors = ({
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  });
  this.componentData = componentData;
  this.arrayBase = componentData;
  this.arrayDepth = 1;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var self = this;
  this.isAssignableFromFun = (isAssignableFromFun || ((that) => (self === that)));
  this.wrapArray = (isLongArray ? ((array) => {
    var len = (array.length | 0);
    var result = new arrayClass(len);
    var u = result.u;
    for (var i = 0; (i < len); i = ((i + 1) | 0)) {
      var srcElem = array[i];
      u[(i << 1)] = srcElem.l;
      u[(((i << 1) + 1) | 0)] = srcElem.h;
    }
    return result;
  }) : (typedArrayClass ? ((array) => new arrayClass(new typedArrayClass(array))) : ((array) => new arrayClass(array))));
  this.isInstance = ((obj) => (obj instanceof arrayClass));
  return this;
});
$TypeData.prototype.initArray = (function(componentData) {
  function ArrayClass(arg) {
    if (((typeof arg) === "number")) {
      if ((arg < 0)) {
        $throwNegativeArraySizeException();
      }
      this.u = new Array(arg);
      for (var i = 0; (i < arg); (i++)) {
        this.u[i] = null;
      }
    } else {
      this.u = arg;
    }
  }
  ArrayClass.prototype = new $ah_O();
  ArrayClass.prototype.constructor = ArrayClass;
  ArrayClass.prototype.set = (function(i, v) {
    if (((i >>> 0) >= (this.u.length >>> 0))) {
      $throwArrayIndexOutOFBoundsException(i);
    }
    if ((((v !== null) && (!componentData.isJSType)) && (!componentData.isInstance(v)))) {
      $throwArrayStoreException(v);
    }
    this.u[i] = v;
  });
  ArrayClass.prototype.copyTo = (function(srcPos, dest, destPos, length) {
    $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
  });
  ArrayClass.prototype.clone__O = (function() {
    return new ArrayClass(this.u.slice());
  });
  ArrayClass.prototype.$classData = this;
  var arrayBase = (componentData.arrayBase || componentData);
  var arrayDepth = (componentData.arrayDepth + 1);
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = ArrayClass;
  this.ancestors = ({
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  });
  this.componentData = componentData;
  this.arrayBase = arrayBase;
  this.arrayDepth = arrayDepth;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var isAssignableFromFun = ((that) => {
    var thatDepth = that.arrayDepth;
    return ((thatDepth === arrayDepth) ? arrayBase.isAssignableFromFun(that.arrayBase) : ((thatDepth > arrayDepth) && (arrayBase === $d_O)));
  });
  this.isAssignableFromFun = isAssignableFromFun;
  this.wrapArray = ((array) => new ArrayClass(array));
  var self = this;
  this.isInstance = ((obj) => {
    var data = (obj && obj.$classData);
    return ((!(!data)) && ((data === self) || isAssignableFromFun(data)));
  });
  return this;
});
$TypeData.prototype.getArrayOf = (function() {
  if ((!this._arrayOf)) {
    this._arrayOf = new $TypeData().initArray(this);
  }
  return this._arrayOf;
});
$TypeData.prototype.getClassOf = (function() {
  if ((!this._classOf)) {
    this._classOf = new $c_jl_Class(this);
  }
  return this._classOf;
});
$TypeData.prototype.isAssignableFrom = (function(that) {
  return ((this === that) || this.isAssignableFromFun(that));
});
$TypeData.prototype.cast = (function(obj) {
  if ((((obj !== null) && (!this.isJSType)) && (!this.isInstance(obj)))) {
    $throwClassCastException(obj, this.name);
  }
  return obj;
});
$TypeData.prototype.getSuperclass = (function() {
  return (this.parentData ? this.parentData.getClassOf() : null);
});
$TypeData.prototype.getComponentType = (function() {
  return (this.componentData ? this.componentData.getClassOf() : null);
});
$TypeData.prototype.newArray = (function(length) {
  if ((this === $d_V)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  return new (this.getArrayOf().constr)(length);
});
function $isArrayOf_O(obj, depth) {
  var data = (obj && obj.$classData);
  if ((!data)) {
    return false;
  } else {
    var arrayDepth = data.arrayDepth;
    return ((arrayDepth === depth) ? (!data.arrayBase.isPrimitive) : (arrayDepth > depth));
  }
}
function $isArrayOf_Z(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_Z))));
}
function $isArrayOf_C(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_C))));
}
function $isArrayOf_B(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_B))));
}
function $isArrayOf_S(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_S))));
}
function $isArrayOf_I(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_I))));
}
function $isArrayOf_J(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_J))));
}
function $isArrayOf_F(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_F))));
}
function $isArrayOf_D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_D))));
}
function $asArrayOf_O(obj, depth) {
  if (($isArrayOf_O(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "Ljava.lang.Object;", depth);
  }
}
function $asArrayOf_Z(obj, depth) {
  if (($isArrayOf_Z(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "Z", depth);
  }
}
function $asArrayOf_C(obj, depth) {
  if (($isArrayOf_C(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "C", depth);
  }
}
function $asArrayOf_B(obj, depth) {
  if (($isArrayOf_B(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "B", depth);
  }
}
function $asArrayOf_S(obj, depth) {
  if (($isArrayOf_S(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "S", depth);
  }
}
function $asArrayOf_I(obj, depth) {
  if (($isArrayOf_I(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "I", depth);
  }
}
function $asArrayOf_J(obj, depth) {
  if (($isArrayOf_J(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "J", depth);
  }
}
function $asArrayOf_F(obj, depth) {
  if (($isArrayOf_F(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "F", depth);
  }
}
function $asArrayOf_D(obj, depth) {
  if (($isArrayOf_D(obj, depth) || (obj === null))) {
    return obj;
  } else {
    $throwArrayCastException(obj, "D", depth);
  }
}
var $d_O = new $TypeData();
$d_O.ancestors = ({});
$d_O.arrayEncodedName = "Ljava.lang.Object;";
$d_O.isAssignableFromFun = ((that) => (!that.isPrimitive));
$d_O.name = "java.lang.Object";
$d_O.isInstance = ((obj) => (obj !== null));
$d_O._arrayOf = new $TypeData().initSpecializedArray($d_O, $ac_O, (void 0), false, ((that) => {
  var thatDepth = that.arrayDepth;
  return ((thatDepth === 1) ? (!that.arrayBase.isPrimitive) : (thatDepth > 1));
}));
$c_O.prototype.$classData = $d_O;
var $d_V = new $TypeData().initPrim((void 0), "V", "void", (void 0), (void 0));
var $d_Z = new $TypeData().initPrim(false, "Z", "boolean", $ac_Z, (void 0));
var $d_C = new $TypeData().initPrim(0, "C", "char", $ac_C, Uint16Array);
var $d_B = new $TypeData().initPrim(0, "B", "byte", $ac_B, Int8Array);
var $d_S = new $TypeData().initPrim(0, "S", "short", $ac_S, Int16Array);
var $d_I = new $TypeData().initPrim(0, "I", "int", $ac_I, Int32Array);
var $d_J = new $TypeData().initPrim($bL0, "J", "long", $ac_J, Int32Array);
var $d_F = new $TypeData().initPrim(0.0, "F", "float", $ac_F, Float32Array);
var $d_D = new $TypeData().initPrim(0.0, "D", "double", $ac_D, Float64Array);
/** @constructor */
function $c_Lcats_Eval$FnStack() {
}
$c_Lcats_Eval$FnStack.prototype = new $h_O();
$c_Lcats_Eval$FnStack.prototype.constructor = $c_Lcats_Eval$FnStack;
/** @constructor */
function $h_Lcats_Eval$FnStack() {
}
$h_Lcats_Eval$FnStack.prototype = $c_Lcats_Eval$FnStack.prototype;
/** @constructor */
function $c_Lcats_EvalInstances1() {
}
$c_Lcats_EvalInstances1.prototype = new $h_O();
$c_Lcats_EvalInstances1.prototype.constructor = $c_Lcats_EvalInstances1;
/** @constructor */
function $h_Lcats_EvalInstances1() {
}
$h_Lcats_EvalInstances1.prototype = $c_Lcats_EvalInstances1.prototype;
function $f_Lcats_FlatMapArityFunctions__flatMap2__O__O__F2__O($thiz, f0, f1, f) {
  return $n($as_Lcats_FlatMap($thiz)).flatten__O__O($n($as_Lcats_FlatMap($thiz)).map2__O__O__F2__O(f0, f1, f));
}
function $f_Lcats_FlatMapArityFunctions__flatMap4__O__O__O__O__F4__O($thiz, f0, f1, f2, f3, f) {
  var $x_1 = $n($as_Lcats_FlatMap($thiz));
  var this$1 = $n($as_Lcats_FlatMap($thiz));
  var this$2 = $m_Lcats_Semigroupal$();
  return $x_1.flatten__O__O($f_Lcats_SemigroupalArityFunctions__map4__O__O__O__O__F4__Lcats_Semigroupal__Lcats_Functor__O(this$2, f0, f1, f2, f3, f, this$1, this$1));
}
function $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval($thiz, f$19, lb$2, it) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => ($n(it).hasNext__Z() ? $as_Lcats_Eval($n(f$19).apply__O__O__O($n(it).next__O(), $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval($thiz, f$19, lb$2, it))) : lb$2)));
  return new $c_Lcats_Eval$$anon$5(a);
}
/** @constructor */
function $c_Lcats_Foldable$() {
}
$c_Lcats_Foldable$.prototype = new $h_O();
$c_Lcats_Foldable$.prototype.constructor = $c_Lcats_Foldable$;
/** @constructor */
function $h_Lcats_Foldable$() {
}
$h_Lcats_Foldable$.prototype = $c_Lcats_Foldable$.prototype;
$c_Lcats_Foldable$.prototype.iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval = (function(iterable, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(iterable).iterator__sc_Iterator()));
  return new $c_Lcats_Always(a).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((it) => {
    var it$1 = $as_sc_Iterator(it);
    return $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval(this, f, lb, it$1);
  })));
});
var $d_Lcats_Foldable$ = new $TypeData().initClass($c_Lcats_Foldable$, "cats.Foldable$", ({
  Lcats_Foldable$: 1
}));
var $n_Lcats_Foldable$;
function $m_Lcats_Foldable$() {
  if ((!$n_Lcats_Foldable$)) {
    $n_Lcats_Foldable$ = new $c_Lcats_Foldable$();
  }
  return $n_Lcats_Foldable$;
}
/** @constructor */
function $c_Lcats_Foldable$Source() {
}
$c_Lcats_Foldable$Source.prototype = new $h_O();
$c_Lcats_Foldable$Source.prototype.constructor = $c_Lcats_Foldable$Source;
/** @constructor */
function $h_Lcats_Foldable$Source() {
}
$h_Lcats_Foldable$Source.prototype = $c_Lcats_Foldable$Source.prototype;
function $as_Lcats_Foldable$Source(obj) {
  return (((obj instanceof $c_Lcats_Foldable$Source) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Foldable$Source"));
}
function $isArrayOf_Lcats_Foldable$Source(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Foldable$Source)));
}
function $asArrayOf_Lcats_Foldable$Source(obj, depth) {
  return (($isArrayOf_Lcats_Foldable$Source(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Foldable$Source;", depth));
}
/** @constructor */
function $c_Lcats_Foldable$Source$() {
  this.Lcats_Foldable$Source$__f_Empty = null;
  $n_Lcats_Foldable$Source$ = this;
  this.Lcats_Foldable$Source$__f_Empty = new $c_Lcats_Foldable$Source$$anon$3();
}
$c_Lcats_Foldable$Source$.prototype = new $h_O();
$c_Lcats_Foldable$Source$.prototype.constructor = $c_Lcats_Foldable$Source$;
/** @constructor */
function $h_Lcats_Foldable$Source$() {
}
$h_Lcats_Foldable$Source$.prototype = $c_Lcats_Foldable$Source$.prototype;
$c_Lcats_Foldable$Source$.prototype.fromFoldable__O__Lcats_Foldable__Lcats_Foldable$Source = (function(fa, F) {
  var value = this.Lcats_Foldable$Source$__f_Empty;
  return $as_Lcats_Foldable$Source($n($n(F).foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Now(value), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a, evalSrc) => {
    var evalSrc$1 = $as_Lcats_Eval(evalSrc);
    var a$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => new $c_Lcats_Foldable$Source$$anon$4(a, evalSrc$1)));
    return new $c_Lcats_Later(a$1);
  })))).value__O());
});
var $d_Lcats_Foldable$Source$ = new $TypeData().initClass($c_Lcats_Foldable$Source$, "cats.Foldable$Source$", ({
  Lcats_Foldable$Source$: 1
}));
var $n_Lcats_Foldable$Source$;
function $m_Lcats_Foldable$Source$() {
  if ((!$n_Lcats_Foldable$Source$)) {
    $n_Lcats_Foldable$Source$ = new $c_Lcats_Foldable$Source$();
  }
  return $n_Lcats_Foldable$Source$;
}
function $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f, semigroupal, functor) {
  return $n(functor).map__O__F1__O($n(semigroupal).product__O__O__O(f0, f1), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a0 = $n(x$1$1)._1__O();
      var a1 = $n(x$1$1)._2__O();
      return $n(f).apply__O__O__O(a0, a1);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $f_Lcats_SemigroupalArityFunctions__imap2__O__O__F2__F1__Lcats_Semigroupal__Lcats_Invariant__O($thiz, f0, f1, f, g, semigroupal, invariant) {
  return $n(invariant).imap__O__F1__F1__O($n(semigroupal).product__O__O__O(f0, f1), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a0 = $n(x$1$1)._1__O();
      var a1 = $n(x$1$1)._2__O();
      return $n(f).apply__O__O__O(a0, a1);
    }
    throw new $c_s_MatchError(x$1$1);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((z) => {
    matchResult4: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x10 = $as_T2($n(g).apply__O__O(z));
      if ((x10 !== null)) {
        var a0$1 = $n(x10)._1__O();
        var a1$1 = $n(x10)._2__O();
        var \u03b42$___1 = a0$1;
        var \u03b42$___2 = a1$1;
        break matchResult4;
      }
      throw new $c_s_MatchError(x10);
    }
    var a0$2 = \u03b42$___1;
    var a1$2 = \u03b42$___2;
    return new $c_T2(a0$2, a1$2);
  })));
}
function $f_Lcats_SemigroupalArityFunctions__tuple2__O__O__Lcats_Semigroupal__Lcats_Invariant__O($thiz, f0, f1, semigroupal, invariant) {
  var f = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_1, _2) => new $c_T2(_1, _2)));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => {
    var x$1 = $as_T2(x);
    return x$1;
  }));
  return $f_Lcats_SemigroupalArityFunctions__imap2__O__O__F2__F1__Lcats_Semigroupal__Lcats_Invariant__O($thiz, f0, f1, f, g, semigroupal, invariant);
}
function $f_Lcats_SemigroupalArityFunctions__map4__O__O__O__O__F4__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f2, f3, f, semigroupal, functor) {
  return $n(functor).map__O__F1__O($n(semigroupal).product__O__O__O(f0, $n(semigroupal).product__O__O__O(f1, $n(semigroupal).product__O__O__O(f2, f3))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x41 = $as_T2($n(x$1$1)._2__O());
      var a0 = $n(x$1$1)._1__O();
      if ((x41 !== null)) {
        var x43 = $as_T2($n(x41)._2__O());
        var a1 = $n(x41)._1__O();
        if ((x43 !== null)) {
          var a2 = $n(x43)._1__O();
          var a3 = $n(x43)._2__O();
          return $n(f).apply__O__O__O__O__O(a0, a1, a2, a3);
        }
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
/** @constructor */
function $c_Lcats_Traverse$() {
}
$c_Lcats_Traverse$.prototype = new $h_O();
$c_Lcats_Traverse$.prototype.constructor = $c_Lcats_Traverse$;
/** @constructor */
function $h_Lcats_Traverse$() {
}
$h_Lcats_Traverse$.prototype = $c_Lcats_Traverse$.prototype;
$c_Lcats_Traverse$.prototype.traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O = (function(fa, f, G) {
  var this$5 = $n($n(fa).iterator__sc_Iterator());
  var $x_1 = $n(G);
  var this$1 = $m_Lcats_data_Chain$();
  var z = $x_1.pure__O__O(this$1.Lcats_data_Chain$__f_nil);
  var f$1 = ((x$1, x$2) => $f_Lcats_FlatMap__map2__O__O__F2__O($n(G), x$1, $n(f).apply__O__O(x$2), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1$2, x$2$2) => {
    var x$1$1 = $as_Lcats_data_Chain(x$1$2);
    var this$4 = $n(x$1$1);
    return this$4.append__O__Lcats_data_Chain(x$2$2);
  }))));
  if ($is_sc_IndexedSeq(this$5)) {
    var x2 = $as_sc_IndexedSeq(this$5);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = z;
    while (true) {
      if ((at === end)) {
        return acc;
      } else {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = $n(x2).apply__I__O(at);
        var temp$acc = f$1(x0, x1);
        at = temp$at;
        acc = temp$acc;
      }
    }
  } else {
    var result = z;
    while (this$5.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = this$5.next__O();
      result = f$1(x0$1, x1$1);
    }
    return result;
  }
});
$c_Lcats_Traverse$.prototype.traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O = (function(fa, f, G) {
  var iter = $n(fa).iterator__sc_Iterator();
  if ($n(iter).hasNext__Z()) {
    var first = $n(iter).next__O();
    var $x_2 = $n(G);
    var this$2 = $n(iter);
    var z = $n(f).apply__O__O(first);
    var f$1 = ((x$1, x$2) => $n(G).productR__O__O__O(x$1, $n(f).apply__O__O(x$2)));
    if ($is_sc_IndexedSeq(this$2)) {
      var x2 = $as_sc_IndexedSeq(this$2);
      var at = 0;
      var end = $n(x2).length__I();
      var acc = z;
      var $x_1;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var x0 = acc;
          var x1 = $n(x2).apply__I__O(at);
          var temp$acc = f$1(x0, x1);
          at = temp$at;
          acc = temp$acc;
          continue;
        }
        var $x_1 = acc;
        break;
      }
    } else {
      var result = z;
      while (this$2.hasNext__Z()) {
        var x0$1 = result;
        var x1$1 = this$2.next__O();
        result = f$1(x0$1, x1$1);
      }
      var $x_1 = result;
    }
    return $x_2.void__O__O($x_1);
  } else {
    return $n(G).unit__O();
  }
});
var $d_Lcats_Traverse$ = new $TypeData().initClass($c_Lcats_Traverse$, "cats.Traverse$", ({
  Lcats_Traverse$: 1
}));
var $n_Lcats_Traverse$;
function $m_Lcats_Traverse$() {
  if ((!$n_Lcats_Traverse$)) {
    $n_Lcats_Traverse$ = new $c_Lcats_Traverse$();
  }
  return $n_Lcats_Traverse$;
}
/** @constructor */
function $c_Lcats_data_AndThenInstances1() {
}
$c_Lcats_data_AndThenInstances1.prototype = new $h_O();
$c_Lcats_data_AndThenInstances1.prototype.constructor = $c_Lcats_data_AndThenInstances1;
/** @constructor */
function $h_Lcats_data_AndThenInstances1() {
}
$h_Lcats_data_AndThenInstances1.prototype = $c_Lcats_data_AndThenInstances1.prototype;
function $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain($thiz, s) {
  var lc = $n(s).lengthCompare__I__I(1);
  if ((lc < 0)) {
    return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  } else if ((lc > 0)) {
    return new $c_Lcats_data_Chain$Wrap(s);
  } else {
    $m_Lcats_data_Chain$();
    var a = $n(s).head__O();
    return new $c_Lcats_data_Chain$Singleton(a);
  }
}
/** @constructor */
function $c_Lcats_data_ChainInstances3() {
}
$c_Lcats_data_ChainInstances3.prototype = new $h_O();
$c_Lcats_data_ChainInstances3.prototype.constructor = $c_Lcats_data_ChainInstances3;
/** @constructor */
function $h_Lcats_data_ChainInstances3() {
}
$h_Lcats_data_ChainInstances3.prototype = $c_Lcats_data_ChainInstances3.prototype;
function $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli($thiz, x) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_Lcats_data_StrictConstFunction1(x);
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli($thiz, x, F) {
  var x$1 = $n(F).pure__O__O(x);
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli($thiz, x$1);
}
/** @constructor */
function $c_Lcats_data_KleisliInstances9() {
}
$c_Lcats_data_KleisliInstances9.prototype = new $h_O();
$c_Lcats_data_KleisliInstances9.prototype.constructor = $c_Lcats_data_KleisliInstances9;
/** @constructor */
function $h_Lcats_data_KleisliInstances9() {
}
$h_Lcats_data_KleisliInstances9.prototype = $c_Lcats_data_KleisliInstances9.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances1() {
}
$c_Lcats_data_NonEmptyListInstances1.prototype = new $h_O();
$c_Lcats_data_NonEmptyListInstances1.prototype.constructor = $c_Lcats_data_NonEmptyListInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances1() {
}
$h_Lcats_data_NonEmptyListInstances1.prototype = $c_Lcats_data_NonEmptyListInstances1.prototype;
/** @constructor */
function $c_Lcats_data_ValidatedInstances2() {
}
$c_Lcats_data_ValidatedInstances2.prototype = new $h_O();
$c_Lcats_data_ValidatedInstances2.prototype.constructor = $c_Lcats_data_ValidatedInstances2;
/** @constructor */
function $h_Lcats_data_ValidatedInstances2() {
}
$h_Lcats_data_ValidatedInstances2.prototype = $c_Lcats_data_ValidatedInstances2.prototype;
/** @constructor */
function $c_Lcats_effect_ContState$() {
  this.Lcats_effect_ContState$__f_cats$effect$ContState$$$waitingSentinel = null;
  $n_Lcats_effect_ContState$ = this;
  this.Lcats_effect_ContState$__f_cats$effect$ContState$$$waitingSentinel = new $c_s_util_Right(null);
}
$c_Lcats_effect_ContState$.prototype = new $h_O();
$c_Lcats_effect_ContState$.prototype.constructor = $c_Lcats_effect_ContState$;
/** @constructor */
function $h_Lcats_effect_ContState$() {
}
$h_Lcats_effect_ContState$.prototype = $c_Lcats_effect_ContState$.prototype;
var $d_Lcats_effect_ContState$ = new $TypeData().initClass($c_Lcats_effect_ContState$, "cats.effect.ContState$", ({
  Lcats_effect_ContState$: 1
}));
var $n_Lcats_effect_ContState$;
function $m_Lcats_effect_ContState$() {
  if ((!$n_Lcats_effect_ContState$)) {
    $n_Lcats_effect_ContState$ = new $c_Lcats_effect_ContState$();
  }
  return $n_Lcats_effect_ContState$;
}
/** @constructor */
function $c_Lcats_effect_IOCompanionPlatform() {
}
$c_Lcats_effect_IOCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_IOCompanionPlatform.prototype.constructor = $c_Lcats_effect_IOCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_IOCompanionPlatform() {
}
$h_Lcats_effect_IOCompanionPlatform.prototype = $c_Lcats_effect_IOCompanionPlatform.prototype;
$c_Lcats_effect_IOCompanionPlatform.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_IO = (function(hint, thunk) {
  var this$1 = $n($as_Lcats_effect_IO$(this));
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IOCompanionPlatform.prototype.fromPromise__Lcats_effect_IO__Lcats_effect_IO = (function(iop) {
  return $as_Lcats_effect_IO($f_Lcats_effect_kernel_AsyncPlatform__fromPromise__O__O($n($n($as_Lcats_effect_IO$(this)).Lcats_effect_IO$__f__asyncForIO), iop));
});
/** @constructor */
function $c_Lcats_effect_IOFiber$() {
  this.Lcats_effect_IOFiber$__f_TypeBlocking = null;
  this.Lcats_effect_IOFiber$__f_OutcomeCanceled = null;
  this.Lcats_effect_IOFiber$__f_RightUnit = null;
  $n_Lcats_effect_IOFiber$ = this;
  this.Lcats_effect_IOFiber$__f_TypeBlocking = $m_Lcats_effect_kernel_Sync$Type$Blocking$();
  this.Lcats_effect_IOFiber$__f_OutcomeCanceled = new $c_Lcats_effect_kernel_Outcome$Canceled();
  this.Lcats_effect_IOFiber$__f_RightUnit = new $c_s_util_Right((void 0));
}
$c_Lcats_effect_IOFiber$.prototype = new $h_O();
$c_Lcats_effect_IOFiber$.prototype.constructor = $c_Lcats_effect_IOFiber$;
/** @constructor */
function $h_Lcats_effect_IOFiber$() {
}
$h_Lcats_effect_IOFiber$.prototype = $c_Lcats_effect_IOFiber$.prototype;
$c_Lcats_effect_IOFiber$.prototype.onFatalFailure__jl_Throwable__E = (function(t) {
  var interrupted = $m_jl_Thread$().interrupted__Z();
  if ($n($m_Lcats_effect_unsafe_IORuntime$().Lcats_effect_unsafe_IORuntime$__f_globalFatalFailureHandled).compareAndSet__Z__Z__Z(false, true)) {
    if (($m_Lcats_effect_unsafe_IORuntime$().Lcats_effect_unsafe_IORuntime$__f_allRuntimes === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
    var r = 0;
    var runtimes = $n($m_Lcats_effect_unsafe_IORuntime$().Lcats_effect_unsafe_IORuntime$__f_allRuntimes).Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
    var length = $n(runtimes).u.length;
    while ((r < length)) {
      var ref = $n(runtimes).get(r);
      if ((ref instanceof $c_Lcats_effect_unsafe_IORuntime)) {
        var rt = $as_Lcats_effect_unsafe_IORuntime(ref);
        $n($n(rt).Lcats_effect_unsafe_IORuntime__f_shutdown).apply__O();
        $m_jl_Thread$().interrupted__Z();
        var idx = 0;
        var tables = $n($n(rt).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).Lcats_effect_unsafe_StripedHashtable__f_tables;
        var numTables = $n($n(rt).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).numTables__I();
        while ((idx < numTables)) {
          var table = $n(tables).get(idx);
          if ((table === null)) {
            throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
          }
          var hashtable = $n(table).Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
          var len = $n(hashtable).u.length;
          var i = 0;
          while ((i < len)) {
            var ref$2 = $n(hashtable).get(i);
            if ($is_F1(ref$2)) {
              var cb = $as_F1(ref$2);
              $n(cb).apply__O__O(t);
            }
            i = ((1 + i) | 0);
          }
          idx = ((1 + idx) | 0);
        }
      }
      r = ((1 + r) | 0);
    }
  }
  if (interrupted) {
    var this$1 = $n($m_jl_Thread$().jl_Thread$__f_SingleThread);
    this$1.jl_Thread__f_java$lang$Thread$$interruptedState = true;
  }
  var $x_1 = $n(t);
  throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
});
var $d_Lcats_effect_IOFiber$ = new $TypeData().initClass($c_Lcats_effect_IOFiber$, "cats.effect.IOFiber$", ({
  Lcats_effect_IOFiber$: 1
}));
var $n_Lcats_effect_IOFiber$;
function $m_Lcats_effect_IOFiber$() {
  if ((!$n_Lcats_effect_IOFiber$)) {
    $n_Lcats_effect_IOFiber$ = new $c_Lcats_effect_IOFiber$();
  }
  return $n_Lcats_effect_IOFiber$;
}
/** @constructor */
function $c_Lcats_effect_IOPlatform() {
}
$c_Lcats_effect_IOPlatform.prototype = new $h_O();
$c_Lcats_effect_IOPlatform.prototype.constructor = $c_Lcats_effect_IOPlatform;
/** @constructor */
function $h_Lcats_effect_IOPlatform() {
}
$h_Lcats_effect_IOPlatform.prototype = $c_Lcats_effect_IOPlatform.prototype;
function $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T($thiz, ste) {
  return ((((((($n(ste).jl_StackTraceElement__f_declaringClass + ".") + $n(ste).jl_StackTraceElement__f_methodName) + " (") + $n(ste).jl_StackTraceElement__f_fileName) + ":") + $n(ste).jl_StackTraceElement__f_lineNumber) + ")");
}
/** @constructor */
function $c_Lcats_effect_Trace(frames) {
  this.Lcats_effect_Trace__f_frames = null;
  this.Lcats_effect_Trace__f_frames = frames;
}
$c_Lcats_effect_Trace.prototype = new $h_O();
$c_Lcats_effect_Trace.prototype.constructor = $c_Lcats_effect_Trace;
/** @constructor */
function $h_Lcats_effect_Trace() {
}
$h_Lcats_effect_Trace.prototype = $c_Lcats_effect_Trace.prototype;
$c_Lcats_effect_Trace.prototype.compact__T = (function() {
  var this$2 = $n(this.Lcats_effect_Trace__f_frames);
  var f = ((ste) => {
    var ste$1 = $as_jl_StackTraceElement(ste);
    return $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T(this, ste$1);
  });
  if ((this$2 === $m_sci_Nil$())) {
    var this$3 = $m_sci_Nil$();
  } else {
    var x0 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var this$3 = h;
  }
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ", ", "");
});
$c_Lcats_effect_Trace.prototype.toString__T = (function() {
  return this.compact__T();
});
var $d_Lcats_effect_Trace = new $TypeData().initClass($c_Lcats_effect_Trace, "cats.effect.Trace", ({
  Lcats_effect_Trace: 1
}));
/** @constructor */
function $c_Lcats_effect_Trace$() {
}
$c_Lcats_effect_Trace$.prototype = new $h_O();
$c_Lcats_effect_Trace$.prototype.constructor = $c_Lcats_effect_Trace$;
/** @constructor */
function $h_Lcats_effect_Trace$() {
}
$h_Lcats_effect_Trace$.prototype = $c_Lcats_effect_Trace$.prototype;
$c_Lcats_effect_Trace$.prototype.apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace = (function(events) {
  return new $c_Lcats_effect_Trace($m_Lcats_effect_tracing_Tracing$().getFrames__Lcats_effect_tracing_RingBuffer__sci_List(events));
});
var $d_Lcats_effect_Trace$ = new $TypeData().initClass($c_Lcats_effect_Trace$, "cats.effect.Trace$", ({
  Lcats_effect_Trace$: 1
}));
var $n_Lcats_effect_Trace$;
function $m_Lcats_effect_Trace$() {
  if ((!$n_Lcats_effect_Trace$)) {
    $n_Lcats_effect_Trace$ = new $c_Lcats_effect_Trace$();
  }
  return $n_Lcats_effect_Trace$;
}
function $f_Lcats_effect_kernel_AsyncPlatform__fromPromise__O__O($thiz, iop) {
  return $f_Lcats_effect_kernel_AsyncPlatform__fromThenable__O__O($thiz, ($n($as_Lcats_effect_kernel_Async($thiz)), iop));
}
function $f_Lcats_effect_kernel_AsyncPlatform__fromThenable__O__O($thiz, iot) {
  return $n($as_Lcats_effect_kernel_Async($thiz)).flatMap__O__F1__O(iot, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => $n($as_Lcats_effect_kernel_Async($thiz)).async___F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cb) => {
    var cb$1 = $as_F1(cb);
    t.then(((v) => $n(cb$1).apply__O__O(new $c_s_util_Right(v))), $m_sjs_js_defined$().apply__O__sjs_js_$bar(((a) => {
      if ((a instanceof $c_jl_Throwable)) {
        var th = $as_jl_Throwable(a);
        var e = th;
      } else {
        var e = new $c_sjs_js_JavaScriptException(a);
      }
      return $n(cb$1).apply__O__O(new $c_s_util_Left(e));
    })));
  }))))));
}
/** @constructor */
function $c_Lcats_effect_kernel_GenConcurrent$() {
}
$c_Lcats_effect_kernel_GenConcurrent$.prototype = new $h_O();
$c_Lcats_effect_kernel_GenConcurrent$.prototype.constructor = $c_Lcats_effect_kernel_GenConcurrent$;
/** @constructor */
function $h_Lcats_effect_kernel_GenConcurrent$() {
}
$h_Lcats_effect_kernel_GenConcurrent$.prototype = $c_Lcats_effect_kernel_GenConcurrent$.prototype;
$c_Lcats_effect_kernel_GenConcurrent$.prototype.genConcurrentForKleisli__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_GenConcurrent = (function(F0) {
  if ($is_Lcats_effect_kernel_Async(F0)) {
    var async = $as_Lcats_effect_kernel_Async(F0);
    return new $c_Lcats_effect_kernel_Async$$anon$9(async);
  } else if ($is_Lcats_effect_kernel_GenTemporal(F0)) {
    var temporal = $as_Lcats_effect_kernel_GenTemporal(F0);
    return new $c_Lcats_effect_kernel_GenTemporal$$anon$3(temporal);
  } else {
    return new $c_Lcats_effect_kernel_GenConcurrent$$anon$3(F0);
  }
});
var $d_Lcats_effect_kernel_GenConcurrent$ = new $TypeData().initClass($c_Lcats_effect_kernel_GenConcurrent$, "cats.effect.kernel.GenConcurrent$", ({
  Lcats_effect_kernel_GenConcurrent$: 1
}));
var $n_Lcats_effect_kernel_GenConcurrent$;
function $m_Lcats_effect_kernel_GenConcurrent$() {
  if ((!$n_Lcats_effect_kernel_GenConcurrent$)) {
    $n_Lcats_effect_kernel_GenConcurrent$ = new $c_Lcats_effect_kernel_GenConcurrent$();
  }
  return $n_Lcats_effect_kernel_GenConcurrent$;
}
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$() {
}
$c_Lcats_effect_kernel_MonadCancel$.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$() {
}
$h_Lcats_effect_kernel_MonadCancel$.prototype = $c_Lcats_effect_kernel_MonadCancel$.prototype;
$c_Lcats_effect_kernel_MonadCancel$.prototype.monadCancelForKleisli__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_MonadCancel = (function(F0) {
  if ($is_Lcats_effect_kernel_Async(F0)) {
    var async = $as_Lcats_effect_kernel_Async(F0);
    return new $c_Lcats_effect_kernel_Async$$anon$9(async);
  } else if ($is_Lcats_effect_kernel_Sync(F0)) {
    var sync = $as_Lcats_effect_kernel_Sync(F0);
    return new $c_Lcats_effect_kernel_Sync$$anon$6(sync);
  } else if ($is_Lcats_effect_kernel_GenTemporal(F0)) {
    var temporal = $as_Lcats_effect_kernel_GenTemporal(F0);
    return new $c_Lcats_effect_kernel_GenTemporal$$anon$3(temporal);
  } else if ($is_Lcats_effect_kernel_GenConcurrent(F0)) {
    var concurrent = $as_Lcats_effect_kernel_GenConcurrent(F0);
    return new $c_Lcats_effect_kernel_GenConcurrent$$anon$3(concurrent);
  } else if ($is_Lcats_effect_kernel_GenSpawn(F0)) {
    var spawn = $as_Lcats_effect_kernel_GenSpawn(F0);
    return new $c_Lcats_effect_kernel_GenSpawn$$anon$3(spawn);
  } else {
    return new $c_Lcats_effect_kernel_MonadCancel$$anon$4(F0, F0);
  }
});
var $d_Lcats_effect_kernel_MonadCancel$ = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$, "cats.effect.kernel.MonadCancel$", ({
  Lcats_effect_kernel_MonadCancel$: 1
}));
var $n_Lcats_effect_kernel_MonadCancel$;
function $m_Lcats_effect_kernel_MonadCancel$() {
  if ((!$n_Lcats_effect_kernel_MonadCancel$)) {
    $n_Lcats_effect_kernel_MonadCancel$ = new $c_Lcats_effect_kernel_MonadCancel$();
  }
  return $n_Lcats_effect_kernel_MonadCancel$;
}
function $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O($thiz, fa, fin) {
  return fa;
}
/** @constructor */
function $c_Lcats_effect_kernel_Par$() {
  this.Lcats_effect_kernel_Par$__f_instance = null;
  $n_Lcats_effect_kernel_Par$ = this;
  this.Lcats_effect_kernel_Par$__f_instance = new $c_Lcats_effect_kernel_Par$$anon$1();
}
$c_Lcats_effect_kernel_Par$.prototype = new $h_O();
$c_Lcats_effect_kernel_Par$.prototype.constructor = $c_Lcats_effect_kernel_Par$;
/** @constructor */
function $h_Lcats_effect_kernel_Par$() {
}
$h_Lcats_effect_kernel_Par$.prototype = $c_Lcats_effect_kernel_Par$.prototype;
var $d_Lcats_effect_kernel_Par$ = new $TypeData().initClass($c_Lcats_effect_kernel_Par$, "cats.effect.kernel.Par$", ({
  Lcats_effect_kernel_Par$: 1
}));
var $n_Lcats_effect_kernel_Par$;
function $m_Lcats_effect_kernel_Par$() {
  if ((!$n_Lcats_effect_kernel_Par$)) {
    $n_Lcats_effect_kernel_Par$ = new $c_Lcats_effect_kernel_Par$();
  }
  return $n_Lcats_effect_kernel_Par$;
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceFOInstances1() {
}
$c_Lcats_effect_kernel_ResourceFOInstances1.prototype = new $h_O();
$c_Lcats_effect_kernel_ResourceFOInstances1.prototype.constructor = $c_Lcats_effect_kernel_ResourceFOInstances1;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceFOInstances1() {
}
$h_Lcats_effect_kernel_ResourceFOInstances1.prototype = $c_Lcats_effect_kernel_ResourceFOInstances1.prototype;
function $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O($thiz, wrapped, F) {
  return wrapped;
}
function $f_Lcats_effect_kernel_syntax_MonadCancelSyntax__monadCancelOps__O__Lcats_effect_kernel_MonadCancel__O($thiz, wrapped, F) {
  return wrapped;
}
/** @constructor */
function $c_Lcats_effect_package$IOLocalState$() {
  this.Lcats_effect_package$IOLocalState$__f_empty = null;
  $n_Lcats_effect_package$IOLocalState$ = this;
  this.Lcats_effect_package$IOLocalState$__f_empty = $m_sci_Map$EmptyMap$();
}
$c_Lcats_effect_package$IOLocalState$.prototype = new $h_O();
$c_Lcats_effect_package$IOLocalState$.prototype.constructor = $c_Lcats_effect_package$IOLocalState$;
/** @constructor */
function $h_Lcats_effect_package$IOLocalState$() {
}
$h_Lcats_effect_package$IOLocalState$.prototype = $c_Lcats_effect_package$IOLocalState$.prototype;
var $d_Lcats_effect_package$IOLocalState$ = new $TypeData().initClass($c_Lcats_effect_package$IOLocalState$, "cats.effect.package$IOLocalState$", ({
  Lcats_effect_package$IOLocalState$: 1
}));
var $n_Lcats_effect_package$IOLocalState$;
function $m_Lcats_effect_package$IOLocalState$() {
  if ((!$n_Lcats_effect_package$IOLocalState$)) {
    $n_Lcats_effect_package$IOLocalState$ = new $c_Lcats_effect_package$IOLocalState$();
  }
  return $n_Lcats_effect_package$IOLocalState$;
}
/** @constructor */
function $c_Lcats_effect_process$() {
}
$c_Lcats_effect_process$.prototype = new $h_O();
$c_Lcats_effect_process$.prototype.constructor = $c_Lcats_effect_process$;
/** @constructor */
function $h_Lcats_effect_process$() {
}
$h_Lcats_effect_process$.prototype = $c_Lcats_effect_process$.prototype;
$c_Lcats_effect_process$.prototype.env__T__s_Option = (function(key) {
  var this$1 = $m_Lcats_effect_std_Env$();
  var F = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var env = new $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv(this$1, F);
  var value = env.get__T__O(key);
  return $as_s_Option($n($as_Lcats_effect_SyncIO($n(new $c_Lcats_data_OptionT(value).orElseF__F0__Lcats_Monad__Lcats_data_OptionT(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $as_Lcats_effect_SyncIO(env.get__T__O(("REACT_APP_" + key))))), $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO)).Lcats_data_OptionT__f_value)).unsafeRunSync__O());
});
var $d_Lcats_effect_process$ = new $TypeData().initClass($c_Lcats_effect_process$, "cats.effect.process$", ({
  Lcats_effect_process$: 1
}));
var $n_Lcats_effect_process$;
function $m_Lcats_effect_process$() {
  if ((!$n_Lcats_effect_process$)) {
    $n_Lcats_effect_process$ = new $c_Lcats_effect_process$();
  }
  return $n_Lcats_effect_process$;
}
/** @constructor */
function $c_Lcats_effect_std_AtomicCell() {
}
$c_Lcats_effect_std_AtomicCell.prototype = new $h_O();
$c_Lcats_effect_std_AtomicCell.prototype.constructor = $c_Lcats_effect_std_AtomicCell;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell() {
}
$h_Lcats_effect_std_AtomicCell.prototype = $c_Lcats_effect_std_AtomicCell.prototype;
function $as_Lcats_effect_std_AtomicCell(obj) {
  return (((obj instanceof $c_Lcats_effect_std_AtomicCell) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.AtomicCell"));
}
function $isArrayOf_Lcats_effect_std_AtomicCell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_AtomicCell)));
}
function $asArrayOf_Lcats_effect_std_AtomicCell(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_AtomicCell(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.AtomicCell;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_AtomicCell$() {
}
$c_Lcats_effect_std_AtomicCell$.prototype = new $h_O();
$c_Lcats_effect_std_AtomicCell$.prototype.constructor = $c_Lcats_effect_std_AtomicCell$;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell$() {
}
$h_Lcats_effect_std_AtomicCell$.prototype = $c_Lcats_effect_std_AtomicCell$.prototype;
$c_Lcats_effect_std_AtomicCell$.prototype.async__O__Lcats_effect_kernel_Async__O = (function(init, F) {
  var target = $m_Lcats_effect_std_Mutex$().apply__Lcats_effect_kernel_GenConcurrent__O(F);
  var this$2 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((mutex) => {
    var mutex$1 = $as_Lcats_effect_std_Mutex(mutex);
    return new $c_Lcats_effect_std_AtomicCell$AsyncImpl(init, mutex$1, F);
  }));
  return $n(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lcats_effect_std_AtomicCell$.prototype.concurrent__O__Lcats_effect_kernel_GenConcurrent__O = (function(init, F) {
  var mk = new $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1(F);
  var _1 = mk.refOf__O__O(init);
  var _2 = $m_Lcats_effect_std_Mutex$().apply__Lcats_effect_kernel_GenConcurrent__O(F);
  var t = new $c_T2(_1, _2);
  return new $c_Lcats_syntax_Tuple2SemigroupalOps(t).mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((ref, m) => {
    var ref$1 = $as_Lcats_effect_kernel_Ref(ref);
    var m$1 = $as_Lcats_effect_std_Mutex(m);
    return new $c_Lcats_effect_std_AtomicCell$ConcurrentImpl(ref$1, m$1, F);
  })), F, F);
});
var $d_Lcats_effect_std_AtomicCell$ = new $TypeData().initClass($c_Lcats_effect_std_AtomicCell$, "cats.effect.std.AtomicCell$", ({
  Lcats_effect_std_AtomicCell$: 1
}));
var $n_Lcats_effect_std_AtomicCell$;
function $m_Lcats_effect_std_AtomicCell$() {
  if ((!$n_Lcats_effect_std_AtomicCell$)) {
    $n_Lcats_effect_std_AtomicCell$ = new $c_Lcats_effect_std_AtomicCell$();
  }
  return $n_Lcats_effect_std_AtomicCell$;
}
/** @constructor */
function $c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$() {
}
$c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype = new $h_O();
$c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype.constructor = $c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$() {
}
$h_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype = $c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype;
$c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$.prototype.of$extension__Z__O__Lcats_effect_kernel_GenConcurrent__O = (function(this$, init, F) {
  if ($is_Lcats_effect_kernel_Async(F)) {
    var f = $as_Lcats_effect_kernel_Async(F);
    return $m_Lcats_effect_std_AtomicCell$().async__O__Lcats_effect_kernel_Async__O(init, f);
  } else {
    return $m_Lcats_effect_std_AtomicCell$().concurrent__O__Lcats_effect_kernel_GenConcurrent__O(init, F);
  }
});
var $d_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$ = new $TypeData().initClass($c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$, "cats.effect.std.AtomicCell$ApplyPartiallyApplied$", ({
  Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$: 1
}));
var $n_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$;
function $m_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$() {
  if ((!$n_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$)) {
    $n_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$ = new $c_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$();
  }
  return $n_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$;
}
/** @constructor */
function $c_Lcats_effect_std_ConsoleCompanionCrossPlatform() {
}
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype = new $h_O();
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype.constructor = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform;
/** @constructor */
function $h_Lcats_effect_std_ConsoleCompanionCrossPlatform() {
}
$h_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform.prototype;
function $p_Lcats_effect_std_Dispatcher$__impl__Z__Z__Z__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource($thiz, parallel, await$1, cancelable, evidence$1) {
  var value = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$9) => {
    $as_Lcats_effect_kernel_Outcome(_$9);
    return true;
  }));
  var always = new $c_s_Some(value);
  var this$38 = $n($m_Lcats_effect_std_Supervisor$().apply__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(await$1, always, evidence$1));
  var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((supervisor) => {
    var supervisor$1 = $as_Lcats_effect_std_Supervisor(supervisor);
    var termination = $m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource($n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $c_ju_concurrent_atomic_AtomicBoolean(), false)))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((doneR) => {
      var doneR$1 = $as_ju_concurrent_atomic_AtomicBoolean(doneR);
      return $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        $n(doneR$1).ju_concurrent_atomic_AtomicBoolean__f_value = true;
      })));
    })), evidence$1);
    var awaitTermination = $m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource($n(evidence$1).deferred__O(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
      var _$10$1 = $as_Lcats_effect_kernel_Deferred(_$10);
      var target = $n(_$10$1).complete__O__O((void 0));
      var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, evidence$1);
      return $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    })), evidence$1);
    var t = new $c_T2(awaitTermination, termination);
    return $as_Lcats_effect_kernel_Resource(new $c_Lcats_syntax_Tuple2SemigroupalOps(t).flatMapN__F2__Lcats_FlatMap__O(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((terminationLatch, doneR$2) => {
      var terminationLatch$1 = $as_Lcats_effect_kernel_Deferred(terminationLatch);
      var doneR$3 = $as_ju_concurrent_atomic_AtomicBoolean(doneR$2);
      if (parallel) {
        var executorF = $m_Lcats_effect_std_Dispatcher$Executor$().parallel__Z__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(await$1, evidence$1);
      } else if (cancelable) {
        var executorF = $m_Lcats_effect_std_Dispatcher$Executor$().sequential__Lcats_effect_std_Supervisor__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(supervisor$1, evidence$1);
      } else {
        var a = new $c_Lcats_effect_std_Dispatcher$Executor$$anon$3(evidence$1);
        var executorF = new $c_Lcats_effect_kernel_Resource$Pure(a);
      }
      var this$35 = $n(executorF);
      var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((executor) => {
        var executor$1 = $as_Lcats_effect_std_Dispatcher$Executor(executor);
        var workerF = $m_Lcats_effect_std_Dispatcher$Worker$().apply__Lcats_effect_std_Dispatcher$Executor__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(executor$1, terminationLatch$1, evidence$1);
        if (parallel) {
          var n = $thiz.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus;
          var F = new $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9(evidence$1);
          var workersF = $n($as_Lcats_effect_kernel_Resource($f_Lcats_Applicative__replicateA__I__O__O(F, n, workerF))).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$11) => {
            var _$11$1 = $as_sci_List(_$11);
            var this$17 = $n(_$11$1);
            if ((this$17.knownSize__I() >= 0)) {
              var len = this$17.knownSize__I();
              var destination = new ($d_Lcats_effect_std_Dispatcher$Worker.getArrayOf().constr)(len);
              $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$17, destination, 0, 2147483647);
              return destination;
            } else {
              var capacity = 0;
              var size = 0;
              var jsElems = null;
              capacity = 0;
              size = 0;
              jsElems = [];
              var it = this$17.iterator__sc_Iterator();
              while ($n(it).hasNext__Z()) {
                var elem = $n(it).next__O();
                var unboxedElem = ((elem === null) ? null : elem);
                jsElems.push(unboxedElem);
              }
              return new ($d_Lcats_effect_std_Dispatcher$Worker.getArrayOf().constr)(jsElems);
            }
          })));
        } else {
          var workersF = $n(workerF).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((w) => {
            var w$1 = $as_Lcats_effect_std_Dispatcher$Worker(w);
            return new ($d_Lcats_effect_std_Dispatcher$Worker.getArrayOf().constr)([w$1]);
          })));
        }
        return $n(workersF).evalMap__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((workers) => {
          var workers$1 = $asArrayOf_Lcats_effect_std_Dispatcher$Worker(workers, 1);
          var target$1 = $n(evidence$1).executionContext__O();
          var this$34 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, evidence$1);
          var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ec) => {
            var ec$1 = $as_s_concurrent_ExecutionContext(ec);
            var end = $n(workers$1).u.length;
            var isEmpty = (end <= 0);
            var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
            var this$28 = $m_sci_Nil$();
            if (isEmpty) {
              var $x_1 = 0;
            } else {
              if ((end <= 0)) {
                $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, end, 1, false);
              }
              var $x_1 = end;
            }
            if (($x_1 === 0)) {
              var target$2 = this$28;
            } else {
              var iter = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
              if (iter.sci_RangeIterator__f__hasNext) {
                var result = new $c_sci_$colon$colon(iter.next__I(), this$28);
                var curr = result;
                while (iter.sci_RangeIterator__f__hasNext) {
                  var temp = new $c_sci_$colon$colon(iter.next__I(), this$28);
                  $n(curr).sci_$colon$colon__f_next = temp;
                  curr = temp;
                }
                var target$2 = result;
              } else {
                var target$2 = this$28;
              }
            }
            $m_Lcats_UnorderedFoldable$();
            var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
            var this$31 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$2, tc);
            var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i) => {
              var i$1 = $uI(i);
              return $n(supervisor$1).supervise__O__O($n($n(workers$1).get(i$1)).run__O());
            }));
            var launchAll = $n(this$31.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverseVoid__O__F1__Lcats_Applicative__O(this$31.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, evidence$1);
            var this$33 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(launchAll, evidence$1);
            var b = new $c_Lcats_effect_std_Dispatcher$$anon$2(doneR$3, evidence$1, parallel, workers$1, ec$1);
            return $n(this$33.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$33.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
          }));
          return $n(this$34.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$34.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        })));
      }));
      return new $c_Lcats_effect_kernel_Resource$Bind(this$35, f$2);
    })), new $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9(evidence$1)));
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$38, f$3);
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$() {
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$parasiticEC = null;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus = 0;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$RightUnit = null;
  $n_Lcats_effect_std_Dispatcher$ = this;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$parasiticEC = new $c_Lcats_effect_std_Dispatcher$$anon$1();
  var this$1 = $m_jl_Runtime$();
  $n(this$1.jl_Runtime$__f_currentRuntime);
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus = 1;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$RightUnit = new $c_s_util_Right((void 0));
}
$c_Lcats_effect_std_Dispatcher$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$() {
}
$h_Lcats_effect_std_Dispatcher$.prototype = $c_Lcats_effect_std_Dispatcher$.prototype;
var $d_Lcats_effect_std_Dispatcher$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$, "cats.effect.std.Dispatcher$", ({
  Lcats_effect_std_Dispatcher$: 1
}));
var $n_Lcats_effect_std_Dispatcher$;
function $m_Lcats_effect_std_Dispatcher$() {
  if ((!$n_Lcats_effect_std_Dispatcher$)) {
    $n_Lcats_effect_std_Dispatcher$ = new $c_Lcats_effect_std_Dispatcher$();
  }
  return $n_Lcats_effect_std_Dispatcher$;
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor() {
}
$c_Lcats_effect_std_Dispatcher$Executor.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor() {
}
$h_Lcats_effect_std_Dispatcher$Executor.prototype = $c_Lcats_effect_std_Dispatcher$Executor.prototype;
function $as_Lcats_effect_std_Dispatcher$Executor(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Executor) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor;", depth));
}
function $p_Lcats_effect_std_Dispatcher$Executor$__TaskState$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$($thiz, TaskState$lzy1$1) {
  if ((TaskState$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(($n(TaskState$lzy1$1).sr_LazyRef__f__initialized ? $n(TaskState$lzy1$1).sr_LazyRef__f__value : $n(TaskState$lzy1$1).initialize__O__O(new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$1))));
}
function $p_Lcats_effect_std_Dispatcher$Executor$__loop$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__O__O($thiz, loop$lzy1$1, doneR$7, evidence$1$20, step$2) {
  if ((loop$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ($n(loop$lzy1$1).sr_LazyRef__f__initialized) {
    return $n(loop$lzy1$1).sr_LazyRef__f__value;
  } else {
    var $x_1 = $n(loop$lzy1$1);
    var fa = $n(doneR$7).get__O();
    var ifTrue = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(evidence$1$20).unit__O()));
    var ifFalse = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(step$2, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $p_Lcats_effect_std_Dispatcher$Executor$__loop$1__sr_LazyRef__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__O__O($thiz, loop$lzy1$1, doneR$7, evidence$1$20, step$2))), evidence$1$20)));
    return $x_1.initialize__O__O($f_Lcats_FlatMap__ifM__O__F0__F0__O($n(evidence$1$20), fa, ifTrue, ifFalse));
  }
}
function $p_Lcats_effect_std_Dispatcher$Executor$__loop$1__sr_LazyRef__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__O__O($thiz, loop$lzy1$3, doneR$9, evidence$1$23, step$4) {
  return ($n(loop$lzy1$3).sr_LazyRef__f__initialized ? $n(loop$lzy1$3).sr_LazyRef__f__value : $p_Lcats_effect_std_Dispatcher$Executor$__loop$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__O__O($thiz, loop$lzy1$3, doneR$9, evidence$1$23, step$4));
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$() {
}
$c_Lcats_effect_std_Dispatcher$Executor$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$.prototype.sequential__Lcats_effect_std_Supervisor__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(supervisor, evidence$1) {
  var TaskState$lzy1 = new $c_sr_LazyRef();
  var fa = $m_Lcats_effect_std_Queue$().unbounded__Lcats_effect_kernel_GenConcurrent__O(evidence$1);
  var this$37 = new $c_Lcats_effect_kernel_Resource$Eval(fa);
  var TaskState$lzy1$2$1 = TaskState$lzy1;
  var f$7 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((TaskState$lzy1$2) => ((tasks) => {
    var tasks$1 = $as_Lcats_effect_std_Queue(tasks);
    var target = $n(evidence$1).ref__O__O($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$());
    var this$6 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, evidence$1);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$24) => {
      var _$24$1 = $as_Lcats_effect_kernel_Ref(_$24);
      return $n(tasks$1).offer__O__O(_$24$1);
    }));
    var evict = $n(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    return $n($m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource($n(evidence$1).ref__O__O(false), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => {
      var r$1 = $as_Lcats_effect_kernel_Ref(r);
      var fa$1 = $n(r$1).set__O__O(true);
      return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => evict)), evidence$1);
    })), evidence$1)).evalMap__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((doneR) => {
      var doneR$1 = $as_Lcats_effect_kernel_Ref(doneR);
      var target$1 = $n(evidence$1).ref__O__O($m_s_None$());
      var this$36 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, evidence$1);
      var f$6 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((shutoff) => {
        var shutoff$1 = $as_Lcats_effect_kernel_Ref(shutoff);
        var loop$lzy1 = new $c_sr_LazyRef();
        var target$2 = $n(tasks$1).take__O();
        var this$30 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, evidence$1);
        var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((taskR) => {
          var taskR$1 = $as_Lcats_effect_kernel_Ref(taskR);
          var target$3 = $n(taskR$1).getAndSet__O__O($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Executing__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$());
          var this$29 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, evidence$1);
          var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
            var x$1$1 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$1(x$1);
            if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$1$1)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer === this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)))) {
              $n($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1);
              var x$1$2 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$1$1);
              var this$14 = $n(x$1$2);
              var x86 = this$14.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task;
              var target$4 = $n(taskR$1).getAndSet__O__O($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$());
              var this$22 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$4, evidence$1);
              var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$1) => {
                var x$1$3 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$1(x$1$2$1);
                if (((x$1$3 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$3)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer === this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)))) {
                  $n($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1);
                  var x$1$4 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$3);
                  var this$18 = $n(x$1$4);
                  var x79 = this$18.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
                  var target$5 = $n(x79).complete__O__O((void 0));
                  var this$20 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, evidence$1);
                  return $n(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
                } else {
                  return $n(evidence$1).unit__O();
                }
              }));
              var fin = $n(this$22.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$22.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
              return $n(evidence$1).guarantee__O__O__O(x86, fin);
            }
            matchAlts3: {
              matchAlts4: {
                var x = $n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Executing__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$();
                if ((x === null)) {
                  var $x_1 = (x$1$1 === null);
                } else {
                  var this$24 = $n(x);
                  var $x_1 = (this$24 === x$1$1);
                }
                if ($x_1) {
                  break matchAlts4;
                }
                if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$1)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer === this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)))) {
                  $n($n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1);
                  var x$1$5 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$1);
                  $n(x$1$5);
                  break matchAlts4;
                }
                var x$3 = $n(this.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$2)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$();
                if ((x$3 === null)) {
                  var $x_2 = (x$1$1 === null);
                } else {
                  var this$27 = $n(x$3);
                  var $x_2 = (this$27 === x$1$1);
                }
                if ($x_2) {
                  break matchAlts4;
                }
                break matchAlts3;
              }
              return $n(evidence$1).unit__O();
            }
            throw new $c_s_MatchError(x$1$1);
          }));
          return $n(this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
        }));
        var step = $n(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
        var spawnExecutor = $n(supervisor).supervise__O__O($p_Lcats_effect_std_Dispatcher$Executor$__loop$1__sr_LazyRef__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__O__O(this, loop$lzy1, doneR$1, evidence$1, step));
        var this$35 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(spawnExecutor, evidence$1);
        var f$5 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fiber) => {
          var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
          var target$6 = $n(evidence$1).ref__O__O(fiber$1);
          var this$34 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$6, evidence$1);
          var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fiberR) => {
            var fiberR$1 = $as_Lcats_effect_kernel_Ref(fiberR);
            return new $c_Lcats_effect_std_Dispatcher$Executor$$anon$4(evidence$1, shutoff$1, tasks$1, fiberR$1, spawnExecutor, TaskState$lzy1$2);
          }));
          return $n(this$34.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$34.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$4);
        }));
        return $n(this$35.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$35.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$5);
      }));
      return $n(this$36.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$36.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$6);
    })));
  }))(TaskState$lzy1$2$1));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$37, f$7);
});
$c_Lcats_effect_std_Dispatcher$Executor$.prototype.parallel__Z__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(await$1, evidence$1) {
  var this$1 = $m_Lcats_effect_std_Supervisor$();
  return $n(this$1.apply__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(await$1, $m_s_None$(), evidence$1)).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((supervisor) => {
    var supervisor$1 = $as_Lcats_effect_std_Supervisor(supervisor);
    return new $c_Lcats_effect_std_Dispatcher$Executor$$anon$5(supervisor$1, evidence$1);
  })));
});
$c_Lcats_effect_std_Dispatcher$Executor$.prototype.cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$ = (function(TaskState$lzy1$2) {
  return $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(($n(TaskState$lzy1$2).sr_LazyRef__f__initialized ? $n(TaskState$lzy1$2).sr_LazyRef__f__value : $p_Lcats_effect_std_Dispatcher$Executor$__TaskState$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this, TaskState$lzy1$2)));
});
var $d_Lcats_effect_std_Dispatcher$Executor$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$, "cats.effect.std.Dispatcher$Executor$", ({
  Lcats_effect_std_Dispatcher$Executor$: 1
}));
var $n_Lcats_effect_std_Dispatcher$Executor$;
function $m_Lcats_effect_std_Dispatcher$Executor$() {
  if ((!$n_Lcats_effect_std_Dispatcher$Executor$)) {
    $n_Lcats_effect_std_Dispatcher$Executor$ = new $c_Lcats_effect_std_Dispatcher$Executor$();
  }
  return $n_Lcats_effect_std_Dispatcher$Executor$;
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration() {
}
$c_Lcats_effect_std_Dispatcher$Registration.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Registration.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration() {
}
$h_Lcats_effect_std_Dispatcher$Registration.prototype = $c_Lcats_effect_std_Dispatcher$Registration.prototype;
function $as_Lcats_effect_std_Dispatcher$Registration(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Worker(queue, supervisor, executor, terminationLatch, evidence$1) {
  this.Lcats_effect_std_Dispatcher$Worker__f_queue = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_supervisor = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_executor = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_terminationLatch = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1 = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_doneR = null;
  this.Lcats_effect_std_Dispatcher$Worker__f_queue = queue;
  this.Lcats_effect_std_Dispatcher$Worker__f_supervisor = supervisor;
  this.Lcats_effect_std_Dispatcher$Worker__f_executor = executor;
  this.Lcats_effect_std_Dispatcher$Worker__f_terminationLatch = terminationLatch;
  this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1 = evidence$1;
  this.Lcats_effect_std_Dispatcher$Worker__f_doneR = $ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $c_ju_concurrent_atomic_AtomicBoolean(), false);
}
$c_Lcats_effect_std_Dispatcher$Worker.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Worker.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Worker;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Worker() {
}
$h_Lcats_effect_std_Dispatcher$Worker.prototype = $c_Lcats_effect_std_Dispatcher$Worker.prototype;
$c_Lcats_effect_std_Dispatcher$Worker.prototype.run__O = (function() {
  var target = $n(this.Lcats_effect_std_Dispatcher$Worker__f_queue).take__O();
  var tc = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
  var this$35 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lcats_effect_std_Dispatcher$Registration(x$1);
    if ((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Registration$Primary)) {
      var reg = $as_Lcats_effect_std_Dispatcher$Registration$Primary(x$1$1);
      var F = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
      return $f_Lcats_effect_kernel_Sync__defer__F0__O($n(F), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        var x43 = $as_Lcats_effect_std_Dispatcher$RegState($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).ju_concurrent_atomic_AtomicReference__f_value);
        if ((x43 instanceof $c_Lcats_effect_std_Dispatcher$RegState$Unstarted)) {
          var x50 = $as_Lcats_effect_std_Dispatcher$RegState$Unstarted(x43);
          var this$5 = $n(x50);
          var x52 = this$5.Lcats_effect_std_Dispatcher$RegState$Unstarted__f_action;
          return $n(this.Lcats_effect_std_Dispatcher$Worker__f_executor).apply__O__F1__O(x52, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cancelF) => {
            var F$1 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
            return $f_Lcats_effect_kernel_Sync__defer__F0__O($n(F$1), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
              if ($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).compareAndSet__O__O__Z(x50, new $c_Lcats_effect_std_Dispatcher$RegState$Running(cancelF))) {
                var instance = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
                return $n(instance).unit__O();
              } else {
                var x39 = $as_Lcats_effect_std_Dispatcher$RegState($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).ju_concurrent_atomic_AtomicReference__f_value);
                if ((x39 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
                  var x40 = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x39);
                  var this$10 = $n(x40);
                  var x42 = this$10.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
                  if ($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).compareAndSet__O__O__Z(x40, new $c_Lcats_effect_std_Dispatcher$RegState$Running(cancelF))) {
                    var $x_1 = $n(this.Lcats_effect_std_Dispatcher$Worker__f_supervisor);
                    var F$2 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
                    var fin = $n(F$2).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
                      var this$14 = $n(x42);
                      $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$14, (void 0));
                    })));
                    var F$3 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
                    var target$1 = $x_1.supervise__O__O($n(F$3).guarantee__O__O__O(cancelF, fin));
                    var tc$1 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
                    var this$17 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
                    return $n(this$17.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$17.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
                  } else {
                    var x38 = $as_Lcats_effect_std_Dispatcher$RegState($n($n(reg).Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR).ju_concurrent_atomic_AtomicReference__f_value);
                    var x = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
                    if ((x === x38)) {
                      var instance$1 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
                      return $n(instance$1).unit__O();
                    }
                    throw new $c_jl_AssertionError(("e => " + x38));
                  }
                }
                var x$3 = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
                if ((x$3 === x39)) {
                  var instance$2 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
                  return $n(instance$2).unit__O();
                }
                throw new $c_jl_AssertionError(("b => " + x39));
              }
            })));
          })));
        }
        matchAlts1: {
          matchAlts2: {
            if ((x43 instanceof $c_Lcats_effect_std_Dispatcher$RegState$Running)) {
              var x$1$2 = $as_Lcats_effect_std_Dispatcher$RegState$Running(x43);
              $n(x$1$2);
              break matchAlts2;
            }
            var x$2 = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
            if ((x$2 === x43)) {
              break matchAlts2;
            }
            break matchAlts1;
          }
          throw new $c_jl_AssertionError(("c => " + x43));
        }
        if ((x43 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
          var x$1$3 = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x43);
          var this$23 = $n(x$1$3);
          var x46 = this$23.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
          var F$4 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
          var target$2 = $n(F$4).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
            var this$25 = $n(x46);
            return $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$25, (void 0));
          })));
          var tc$2 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
          var this$27 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
          return $n(this$27.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$27.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        }
        throw new $c_s_MatchError(x43);
      })));
    }
    if ((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Registration$Finalizer)) {
      var x$1$4 = $as_Lcats_effect_std_Dispatcher$Registration$Finalizer(x$1$1);
      var this$29 = $n(x$1$4);
      var x57 = this$29.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action;
      var target$3 = $n(this.Lcats_effect_std_Dispatcher$Worker__f_supervisor).supervise__O__O(x57);
      var tc$3 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
      var this$31 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$3);
      var fu = $n(this$31.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$31.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
      var F$5 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
      return $f_Lcats_ApplicativeError__voidError__O__O($n(F$5), fu);
    }
    if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill) && ($as_Lcats_effect_std_Dispatcher$Registration$PoisonPill(x$1$1), true))) {
      var F$6 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
      return $n(F$6).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        $n(this.Lcats_effect_std_Dispatcher$Worker__f_doneR).ju_concurrent_atomic_AtomicBoolean__f_value = true;
      })));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var step = $n(this$35.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$35.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  var F$7 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
  var fa = $n(F$7).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(this.Lcats_effect_std_Dispatcher$Worker__f_doneR).ju_concurrent_atomic_AtomicBoolean__f_value)));
  var ifTrue = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var fa$1 = $n(this.Lcats_effect_std_Dispatcher$Worker__f_terminationLatch).get__O();
    return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      var F$8 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
      return $n(F$8).cede__O();
    })), this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1);
  }));
  var ifFalse = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(step, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.run__O())), this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1)));
  var F$9 = this.Lcats_effect_std_Dispatcher$Worker__f_evidence$1;
  return $f_Lcats_FlatMap__ifM__O__F0__F0__O($n(F$9), fa, ifTrue, ifFalse);
});
function $as_Lcats_effect_std_Dispatcher$Worker(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Worker) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Worker"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Worker(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Worker)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Worker(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Worker(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Worker;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Worker = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Worker, "cats.effect.std.Dispatcher$Worker", ({
  Lcats_effect_std_Dispatcher$Worker: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Worker$() {
}
$c_Lcats_effect_std_Dispatcher$Worker$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Worker$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Worker$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Worker$() {
}
$h_Lcats_effect_std_Dispatcher$Worker$.prototype = $c_Lcats_effect_std_Dispatcher$Worker$.prototype;
$c_Lcats_effect_std_Dispatcher$Worker$.prototype.apply__Lcats_effect_std_Dispatcher$Executor__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource = (function(executor, terminationLatch, evidence$1) {
  var this$1 = $m_Lcats_effect_std_Supervisor$();
  var this$5 = $n(this$1.apply__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(false, $m_s_None$(), evidence$1));
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((supervisor) => {
    var supervisor$1 = $as_Lcats_effect_std_Supervisor(supervisor);
    var initF = $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => new $c_Lcats_effect_std_Dispatcher$Worker(new $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue(evidence$1), supervisor$1, executor, terminationLatch, evidence$1))));
    return $m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource(initF, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((w) => {
      var w$1 = $as_Lcats_effect_std_Dispatcher$Worker(w);
      return $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        $n($n(w$1).Lcats_effect_std_Dispatcher$Worker__f_queue).unsafeOffer__O__V(new $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill());
      })));
    })), evidence$1);
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$5, f);
});
var $d_Lcats_effect_std_Dispatcher$Worker$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Worker$, "cats.effect.std.Dispatcher$Worker$", ({
  Lcats_effect_std_Dispatcher$Worker$: 1
}));
var $n_Lcats_effect_std_Dispatcher$Worker$;
function $m_Lcats_effect_std_Dispatcher$Worker$() {
  if ((!$n_Lcats_effect_std_Dispatcher$Worker$)) {
    $n_Lcats_effect_std_Dispatcher$Worker$ = new $c_Lcats_effect_std_Dispatcher$Worker$();
  }
  return $n_Lcats_effect_std_Dispatcher$Worker$;
}
/** @constructor */
function $c_Lcats_effect_std_EnvCompanionPlatform() {
}
$c_Lcats_effect_std_EnvCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_std_EnvCompanionPlatform.prototype.constructor = $c_Lcats_effect_std_EnvCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_std_EnvCompanionPlatform() {
}
$h_Lcats_effect_std_EnvCompanionPlatform.prototype = $c_Lcats_effect_std_EnvCompanionPlatform.prototype;
/** @constructor */
function $c_Lcats_effect_std_Mutex() {
}
$c_Lcats_effect_std_Mutex.prototype = new $h_O();
$c_Lcats_effect_std_Mutex.prototype.constructor = $c_Lcats_effect_std_Mutex;
/** @constructor */
function $h_Lcats_effect_std_Mutex() {
}
$h_Lcats_effect_std_Mutex.prototype = $c_Lcats_effect_std_Mutex.prototype;
function $as_Lcats_effect_std_Mutex(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Mutex) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Mutex"));
}
function $isArrayOf_Lcats_effect_std_Mutex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Mutex)));
}
function $asArrayOf_Lcats_effect_std_Mutex(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Mutex(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Mutex;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Mutex$() {
}
$c_Lcats_effect_std_Mutex$.prototype = new $h_O();
$c_Lcats_effect_std_Mutex$.prototype.constructor = $c_Lcats_effect_std_Mutex$;
/** @constructor */
function $h_Lcats_effect_std_Mutex$() {
}
$h_Lcats_effect_std_Mutex$.prototype = $c_Lcats_effect_std_Mutex$.prototype;
$c_Lcats_effect_std_Mutex$.prototype.apply__Lcats_effect_kernel_GenConcurrent__O = (function(F) {
  var mk = new $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1(F);
  var target = mk.refOf__O__O(null);
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    return new $c_Lcats_effect_std_Mutex$ConcurrentImpl(state$1, F);
  }));
  return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
var $d_Lcats_effect_std_Mutex$ = new $TypeData().initClass($c_Lcats_effect_std_Mutex$, "cats.effect.std.Mutex$", ({
  Lcats_effect_std_Mutex$: 1
}));
var $n_Lcats_effect_std_Mutex$;
function $m_Lcats_effect_std_Mutex$() {
  if ((!$n_Lcats_effect_std_Mutex$)) {
    $n_Lcats_effect_std_Mutex$ = new $c_Lcats_effect_std_Mutex$();
  }
  return $n_Lcats_effect_std_Mutex$;
}
/** @constructor */
function $c_Lcats_effect_std_Queue$() {
  this.Lcats_effect_std_Queue$__f_cats$effect$std$Queue$$$EitherUnit = null;
  $n_Lcats_effect_std_Queue$ = this;
  this.Lcats_effect_std_Queue$__f_cats$effect$std$Queue$$$EitherUnit = new $c_s_util_Right((void 0));
}
$c_Lcats_effect_std_Queue$.prototype = new $h_O();
$c_Lcats_effect_std_Queue$.prototype.constructor = $c_Lcats_effect_std_Queue$;
/** @constructor */
function $h_Lcats_effect_std_Queue$() {
}
$h_Lcats_effect_std_Queue$.prototype = $c_Lcats_effect_std_Queue$.prototype;
$c_Lcats_effect_std_Queue$.prototype.boundedForConcurrent__I__Lcats_effect_kernel_GenConcurrent__O = (function(capacity, F) {
  var $x_1 = $n(F);
  var queue = $m_sci_Queue$EmptyQueue$();
  var takers = $m_sci_Queue$EmptyQueue$();
  var offerers = $m_sci_Queue$EmptyQueue$();
  var target = $x_1.ref__O__O(new $c_Lcats_effect_std_Queue$State(queue, 0, takers, offerers));
  var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
    var _$5$1 = $as_Lcats_effect_kernel_Ref(_$5);
    return new $c_Lcats_effect_std_Queue$BoundedQueue(capacity, _$5$1, F);
  }));
  return $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lcats_effect_std_Queue$.prototype.unboundedForAsync__Lcats_effect_kernel_Async__O = (function(F) {
  return $n(F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => new $c_Lcats_effect_std_Queue$UnboundedAsyncQueue(F))));
});
$c_Lcats_effect_std_Queue$.prototype.unbounded__Lcats_effect_kernel_GenConcurrent__O = (function(F) {
  if ($is_Lcats_effect_kernel_Async(F)) {
    var f0 = $as_Lcats_effect_kernel_Async(F);
    return this.unboundedForAsync__Lcats_effect_kernel_Async__O(f0);
  } else {
    return this.boundedForConcurrent__I__Lcats_effect_kernel_GenConcurrent__O(2147483647, F);
  }
});
var $d_Lcats_effect_std_Queue$ = new $TypeData().initClass($c_Lcats_effect_std_Queue$, "cats.effect.std.Queue$", ({
  Lcats_effect_std_Queue$: 1
}));
var $n_Lcats_effect_std_Queue$;
function $m_Lcats_effect_std_Queue$() {
  if ((!$n_Lcats_effect_std_Queue$)) {
    $n_Lcats_effect_std_Queue$ = new $c_Lcats_effect_std_Queue$();
  }
  return $n_Lcats_effect_std_Queue$;
}
function $p_Lcats_effect_std_QueueSource$__loop$1__Lcats_Monad__O__I__I__sci_List__O($thiz, F$1, tryTake$1, i, limit, acc) {
  if ((i >= limit)) {
    return $n(F$1).pure__O__O($n(acc).reverse__sci_List());
  } else {
    var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(tryTake$1, F$1);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_s_Option(x$1);
      if ((x$1$1 instanceof $c_s_Some)) {
        var a = $n($as_s_Some(x$1$1)).s_Some__f_value;
        var this$3 = $n(acc);
        return $p_Lcats_effect_std_QueueSource$__loop$1__Lcats_Monad__O__I__I__sci_List__O($thiz, F$1, tryTake$1, ((1 + i) | 0), limit, new $c_sci_$colon$colon(a, this$3));
      }
      var x = $m_s_None$();
      if ((x === x$1$1)) {
        return $n(F$1).pure__O__O($n(acc).reverse__sci_List());
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
}
/** @constructor */
function $c_Lcats_effect_std_QueueSource$() {
}
$c_Lcats_effect_std_QueueSource$.prototype = new $h_O();
$c_Lcats_effect_std_QueueSource$.prototype.constructor = $c_Lcats_effect_std_QueueSource$;
/** @constructor */
function $h_Lcats_effect_std_QueueSource$() {
}
$h_Lcats_effect_std_QueueSource$.prototype = $c_Lcats_effect_std_QueueSource$.prototype;
$c_Lcats_effect_std_QueueSource$.prototype.tryTakeN__s_Option__O__Lcats_Monad__O = (function(maxN, tryTake, F) {
  $m_Lcats_effect_std_QueueSource$().assertMaxNPositive__s_Option__V(maxN);
  if ((maxN instanceof $c_s_Some)) {
    var limit = $uI($n($as_s_Some(maxN)).s_Some__f_value);
    return $p_Lcats_effect_std_QueueSource$__loop$1__Lcats_Monad__O__I__I__sci_List__O(this, F, tryTake, 0, limit, $m_sci_Nil$());
  }
  var x = $m_s_None$();
  if ((x === maxN)) {
    return $p_Lcats_effect_std_QueueSource$__loop$1__Lcats_Monad__O__I__I__sci_List__O(this, F, tryTake, 0, 2147483647, $m_sci_Nil$());
  }
  throw new $c_s_MatchError(maxN);
});
$c_Lcats_effect_std_QueueSource$.prototype.assertMaxNPositive__s_Option__V = (function(maxN) {
  if ((maxN instanceof $c_s_Some)) {
    var n = $uI($n($as_s_Some(maxN)).s_Some__f_value);
    if ((n <= 0)) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Provided maxN parameter must be positive, was " + n));
    }
  }
});
var $d_Lcats_effect_std_QueueSource$ = new $TypeData().initClass($c_Lcats_effect_std_QueueSource$, "cats.effect.std.QueueSource$", ({
  Lcats_effect_std_QueueSource$: 1
}));
var $n_Lcats_effect_std_QueueSource$;
function $m_Lcats_effect_std_QueueSource$() {
  if ((!$n_Lcats_effect_std_QueueSource$)) {
    $n_Lcats_effect_std_QueueSource$ = new $c_Lcats_effect_std_QueueSource$();
  }
  return $n_Lcats_effect_std_QueueSource$;
}
/** @constructor */
function $c_Lcats_effect_std_Semaphore() {
}
$c_Lcats_effect_std_Semaphore.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore.prototype.constructor = $c_Lcats_effect_std_Semaphore;
/** @constructor */
function $h_Lcats_effect_std_Semaphore() {
}
$h_Lcats_effect_std_Semaphore.prototype = $c_Lcats_effect_std_Semaphore.prototype;
function $as_Lcats_effect_std_Semaphore(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Semaphore) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Semaphore"));
}
function $isArrayOf_Lcats_effect_std_Semaphore(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore)));
}
function $asArrayOf_Lcats_effect_std_Semaphore(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Semaphore(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Semaphore;", depth));
}
function $s_Lcats_effect_std_Semaphore$__cats$effect$std$Semaphore$impl$$anon$1$$_$fulfil$1__J__sci_Queue__sci_Queue__T3(n_$_lo, n_$_hi, requests, wakeup) {
  var wakeup$tailLocal1 = wakeup;
  var requests$tailLocal1 = requests;
  var n$tailLocal1_$_lo = n_$_lo;
  var n$tailLocal1_$_hi = n_$_hi;
  while (true) {
    matchResult15: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x25 = $n(requests$tailLocal1).dequeue__T2();
      if ((x25 !== null)) {
        var req = $as_Lcats_effect_std_Semaphore$impl$Request($n(x25)._1__O());
        var tail = $as_sci_Queue($n(x25)._2__O());
        var \u03b42$___1 = req;
        var \u03b42$___2 = tail;
        break matchResult15;
      }
      throw new $c_s_MatchError(x25);
    }
    var req$2 = $as_Lcats_effect_std_Semaphore$impl$Request(\u03b42$___1);
    var tail$2 = $as_sci_Queue(\u03b42$___2);
    var x_$_lo = n$tailLocal1_$_lo;
    var x_$_hi = n$tailLocal1_$_hi;
    var x$1_$_lo = $n(req$2).Lcats_effect_std_Semaphore$impl$Request__f_n_$lo;
    var x$1_$_hi = $n(req$2).Lcats_effect_std_Semaphore$impl$Request__f_n_$hi;
    if (((x_$_hi === x$1_$_hi) ? ((x_$_lo >>> 0) < (x$1_$_lo >>> 0)) : (x_$_hi < x$1_$_hi))) {
      var $x_1 = $n(req$2);
      var x$2_$_lo = $n(req$2).Lcats_effect_std_Semaphore$impl$Request__f_n_$lo;
      var x$2_$_hi = $n(req$2).Lcats_effect_std_Semaphore$impl$Request__f_n_$hi;
      var x$3_$_lo = n$tailLocal1_$_lo;
      var x$3_$_hi = n$tailLocal1_$_hi;
      var lo = ((x$2_$_lo - x$3_$_lo) | 0);
      var hi = ((((x$2_$_hi - x$3_$_hi) | 0) + ((((~x$2_$_lo) & x$3_$_lo) | ((~(x$2_$_lo ^ x$3_$_lo)) & lo)) >> 31)) | 0);
      var elem$1 = $x_1.of__J__Lcats_effect_std_Semaphore$impl$Request(lo, hi);
      var this$4 = $n(tail$2);
      var _2 = this$4.prepended__O__sci_Queue(elem$1);
      var _3 = wakeup$tailLocal1;
      return new $c_T3($bL(0, 0), _2, _3);
    } else {
      var x$4_$_lo = n$tailLocal1_$_lo;
      var x$4_$_hi = n$tailLocal1_$_hi;
      var x$5_$_lo = $n(req$2).Lcats_effect_std_Semaphore$impl$Request__f_n_$lo;
      var x$5_$_hi = $n(req$2).Lcats_effect_std_Semaphore$impl$Request__f_n_$hi;
      var lo$1 = ((x$4_$_lo - x$5_$_lo) | 0);
      var hi$1 = ((((x$4_$_hi - x$5_$_hi) | 0) + ((((~x$4_$_lo) & x$5_$_lo) | ((~(x$4_$_lo ^ x$5_$_lo)) & lo$1)) >> 31)) | 0);
      var newWakeup = $n(wakeup$tailLocal1).enqueue__O__sci_Queue(req$2);
      if (($n(tail$2).isEmpty__Z() || ((lo$1 | hi$1) === 0))) {
        return new $c_T3($bL(lo$1, hi$1), tail$2, newWakeup);
      } else {
        n$tailLocal1_$_lo = lo$1;
        n$tailLocal1_$_hi = hi$1;
        requests$tailLocal1 = tail$2;
        wakeup$tailLocal1 = newWakeup;
      }
    }
  }
}
/** @constructor */
function $c_Lcats_effect_std_Semaphore$() {
}
$c_Lcats_effect_std_Semaphore$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$.prototype.constructor = $c_Lcats_effect_std_Semaphore$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$() {
}
$h_Lcats_effect_std_Semaphore$.prototype = $c_Lcats_effect_std_Semaphore$.prototype;
$c_Lcats_effect_std_Semaphore$.prototype.apply__J__Lcats_effect_kernel_GenConcurrent__O = (function(n_$_lo, n_$_hi, F) {
  var impl = new $c_Lcats_effect_std_Semaphore$impl(n_$_lo, n_$_hi, F);
  var target = $n(F).ref__O__O(impl.initialState__Lcats_effect_std_Semaphore$impl$State());
  var this$2 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    return new $c_Lcats_effect_std_Semaphore$impl$$anon$1(state$1, impl);
  }));
  return $n(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
var $d_Lcats_effect_std_Semaphore$ = new $TypeData().initClass($c_Lcats_effect_std_Semaphore$, "cats.effect.std.Semaphore$", ({
  Lcats_effect_std_Semaphore$: 1
}));
var $n_Lcats_effect_std_Semaphore$;
function $m_Lcats_effect_std_Semaphore$() {
  if ((!$n_Lcats_effect_std_Semaphore$)) {
    $n_Lcats_effect_std_Semaphore$ = new $c_Lcats_effect_std_Semaphore$();
  }
  return $n_Lcats_effect_std_Semaphore$;
}
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl(n_$_lo, n_$_hi, F) {
  this.Lcats_effect_std_Semaphore$impl__f_n_$lo = 0;
  this.Lcats_effect_std_Semaphore$impl__f_n_$hi = 0;
  this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F = null;
  this.Lcats_effect_std_Semaphore$impl__f_Request$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_State$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_Wait$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_Waitbitmap$1 = false;
  this.Lcats_effect_std_Semaphore$impl__f_Done$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_Donebitmap$1 = false;
  this.Lcats_effect_std_Semaphore$impl__f_n_$lo = n_$_lo;
  this.Lcats_effect_std_Semaphore$impl__f_n_$hi = n_$_hi;
  this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F = F;
  this.Lcats_effect_std_Semaphore$impl__f_Request$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$Request$(this);
  this.Lcats_effect_std_Semaphore$impl__f_State$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$State$(this);
  this.requireNonNegative__J__V(n_$_lo, n_$_hi);
}
$c_Lcats_effect_std_Semaphore$impl.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl() {
}
$h_Lcats_effect_std_Semaphore$impl.prototype = $c_Lcats_effect_std_Semaphore$impl.prototype;
$c_Lcats_effect_std_Semaphore$impl.prototype.requireNonNegative__J__V = (function(n_$_lo, n_$_hi) {
  var requirement = (n_$_hi >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "n must be nonnegative, was: ") + $s_RTLong__toString__I__I__T(n_$_lo, n_$_hi)));
  }
});
$c_Lcats_effect_std_Semaphore$impl.prototype.newRequest__O = (function() {
  var target = $n(this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F).deferred__O();
  var tc = this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$7) => {
    var _$7$1 = $as_Lcats_effect_kernel_Deferred(_$7);
    return $n(this.Lcats_effect_std_Semaphore$impl__f_Request$lzy1).apply__J__Lcats_effect_kernel_Deferred__Lcats_effect_std_Semaphore$impl$Request(0, 0, _$7$1);
  }));
  return $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lcats_effect_std_Semaphore$impl.prototype.initialState__Lcats_effect_std_Semaphore$impl$State = (function() {
  var $x_3 = $n(this.Lcats_effect_std_Semaphore$impl__f_State$lzy1);
  var $x_2_$_lo = this.Lcats_effect_std_Semaphore$impl__f_n_$lo;
  var $x_2_$_hi = this.Lcats_effect_std_Semaphore$impl__f_n_$hi;
  var xs = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var $x_1 = $m_sci_Nil$();
  var this$2 = $n(xs);
  return $x_3.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State($x_2_$_lo, $x_2_$_hi, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $x_1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2)));
});
$c_Lcats_effect_std_Semaphore$impl.prototype.Wait__Lcats_effect_std_Semaphore$impl$Wait$ = (function() {
  if ((!this.Lcats_effect_std_Semaphore$impl__f_Waitbitmap$1)) {
    this.Lcats_effect_std_Semaphore$impl__f_Wait$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$Wait$();
    this.Lcats_effect_std_Semaphore$impl__f_Waitbitmap$1 = true;
  }
  return this.Lcats_effect_std_Semaphore$impl__f_Wait$lzy1;
});
$c_Lcats_effect_std_Semaphore$impl.prototype.Done__Lcats_effect_std_Semaphore$impl$Done$ = (function() {
  if ((!this.Lcats_effect_std_Semaphore$impl__f_Donebitmap$1)) {
    this.Lcats_effect_std_Semaphore$impl__f_Done$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$Done$();
    this.Lcats_effect_std_Semaphore$impl__f_Donebitmap$1 = true;
  }
  return this.Lcats_effect_std_Semaphore$impl__f_Done$lzy1;
});
var $d_Lcats_effect_std_Semaphore$impl = new $TypeData().initClass($c_Lcats_effect_std_Semaphore$impl, "cats.effect.std.Semaphore$impl", ({
  Lcats_effect_std_Semaphore$impl: 1
}));
function $is_Lcats_effect_std_Semaphore$impl$Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Semaphore$impl$Action)));
}
function $as_Lcats_effect_std_Semaphore$impl$Action(obj) {
  return (($is_Lcats_effect_std_Semaphore$impl$Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Semaphore$impl$Action"));
}
function $isArrayOf_Lcats_effect_std_Semaphore$impl$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore$impl$Action)));
}
function $asArrayOf_Lcats_effect_std_Semaphore$impl$Action(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Semaphore$impl$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Semaphore$impl$Action;", depth));
}
function $is_Lcats_effect_std_Supervisor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Supervisor)));
}
function $as_Lcats_effect_std_Supervisor(obj) {
  return (($is_Lcats_effect_std_Supervisor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Supervisor"));
}
function $isArrayOf_Lcats_effect_std_Supervisor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Supervisor)));
}
function $asArrayOf_Lcats_effect_std_Supervisor(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Supervisor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Supervisor;", depth));
}
function $p_Lcats_effect_std_Supervisor$__supervisor__F1__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource($thiz, mkState, await$1, checkRestart, F) {
  var fa = $n(F).ref__O__O(false);
  var this$11 = new $c_Lcats_effect_kernel_Resource$Eval(fa);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((doneR) => {
    var doneR$1 = $as_Lcats_effect_kernel_Ref(doneR);
    return $n($m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource($n(mkState).apply__O__O(doneR$1), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
      var x$1$1 = $as_Lcats_effect_std_Supervisor$State(x$1);
      var x$2$1 = $as_Lcats_effect_kernel_Resource$ExitCase(x$2);
      var x = $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
      if (((x === x$2$1) && await$1)) {
        var fa$1 = $n(doneR$1).set__O__O(true);
        var fb = $n(x$1$1).joinAll__O();
        var this$7 = $n(F);
        return this$7.productR__O__O__O(fa$1, fb);
      } else {
        var fa$2 = $n(doneR$1).set__O__O(true);
        var fb$1 = $n(x$1$1).cancelAll__O();
        var this$10 = $n(F);
        return this$10.productR__O__O__O(fa$2, fb$1);
      }
    })), F)).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((state) => {
      var state$1 = $as_Lcats_effect_std_Supervisor$State(state);
      return new $c_Lcats_effect_std_Supervisor$$anon$1(F, checkRestart, doneR$1, state$1);
    })));
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$11, f);
}
function $p_Lcats_effect_std_Supervisor$__mkState$3__Lcats_effect_kernel_Async__Lcats_effect_kernel_Ref__O($thiz, F$15, doneR) {
  return $n(F$15).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var state = $ct_ju_concurrent_ConcurrentHashMap__(new $c_ju_concurrent_ConcurrentHashMap());
    return new $c_Lcats_effect_std_Supervisor$$anon$4(F$15, state, doneR);
  })));
}
/** @constructor */
function $c_Lcats_effect_std_Supervisor$() {
}
$c_Lcats_effect_std_Supervisor$.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$.prototype.constructor = $c_Lcats_effect_std_Supervisor$;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$() {
}
$h_Lcats_effect_std_Supervisor$.prototype = $c_Lcats_effect_std_Supervisor$.prototype;
$c_Lcats_effect_std_Supervisor$.prototype.apply__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(await$1, checkRestart, F) {
  if ($is_Lcats_effect_kernel_Async(F)) {
    var asyncF = $as_Lcats_effect_kernel_Async(F);
    return this.applyForAsync__Z__s_Option__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(await$1, checkRestart, asyncF);
  } else {
    return this.applyForConcurrent__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(await$1, checkRestart, F);
  }
});
$c_Lcats_effect_std_Supervisor$.prototype.applyForConcurrent__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(await$1, checkRestart, F) {
  var target = $n(F).ref__O__O($m_sci_Map$EmptyMap$());
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((stateRef) => {
    var stateRef$1 = $as_Lcats_effect_kernel_Ref(stateRef);
    return new $c_Lcats_effect_std_Supervisor$$anon$3(stateRef$1, F);
  }));
  var mkState = $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  return $p_Lcats_effect_std_Supervisor$__supervisor__F1__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$17) => {
    $as_Lcats_effect_kernel_Ref(_$17);
    return mkState;
  })), await$1, checkRestart, F);
});
$c_Lcats_effect_std_Supervisor$.prototype.applyForAsync__Z__s_Option__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource = (function(await$1, checkRestart, F) {
  return $p_Lcats_effect_std_Supervisor$__supervisor__F1__Z__s_Option__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((doneR) => {
    var doneR$1 = $as_Lcats_effect_kernel_Ref(doneR);
    return $p_Lcats_effect_std_Supervisor$__mkState$3__Lcats_effect_kernel_Async__Lcats_effect_kernel_Ref__O(this, F, doneR$1);
  })), await$1, checkRestart, F);
});
var $d_Lcats_effect_std_Supervisor$ = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$, "cats.effect.std.Supervisor$", ({
  Lcats_effect_std_Supervisor$: 1
}));
var $n_Lcats_effect_std_Supervisor$;
function $m_Lcats_effect_std_Supervisor$() {
  if ((!$n_Lcats_effect_std_Supervisor$)) {
    $n_Lcats_effect_std_Supervisor$ = new $c_Lcats_effect_std_Supervisor$();
  }
  return $n_Lcats_effect_std_Supervisor$;
}
/** @constructor */
function $c_Lcats_effect_std_Supervisor$State() {
}
$c_Lcats_effect_std_Supervisor$State.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$State.prototype.constructor = $c_Lcats_effect_std_Supervisor$State;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$State() {
}
$h_Lcats_effect_std_Supervisor$State.prototype = $c_Lcats_effect_std_Supervisor$State.prototype;
function $as_Lcats_effect_std_Supervisor$State(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Supervisor$State) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Supervisor$State"));
}
function $isArrayOf_Lcats_effect_std_Supervisor$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Supervisor$State)));
}
function $asArrayOf_Lcats_effect_std_Supervisor$State(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Supervisor$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Supervisor$State;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_UnsafeUnbounded() {
  this.Lcats_effect_std_UnsafeUnbounded__f_first = null;
  this.Lcats_effect_std_UnsafeUnbounded__f_last = null;
  this.Lcats_effect_std_UnsafeUnbounded__f_FailureSignal = null;
  this.Lcats_effect_std_UnsafeUnbounded__f_first = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
  this.Lcats_effect_std_UnsafeUnbounded__f_last = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
  this.Lcats_effect_std_UnsafeUnbounded__f_FailureSignal = $m_Lcats_effect_std_FailureSignal$();
}
$c_Lcats_effect_std_UnsafeUnbounded.prototype = new $h_O();
$c_Lcats_effect_std_UnsafeUnbounded.prototype.constructor = $c_Lcats_effect_std_UnsafeUnbounded;
/** @constructor */
function $h_Lcats_effect_std_UnsafeUnbounded() {
}
$h_Lcats_effect_std_UnsafeUnbounded.prototype = $c_Lcats_effect_std_UnsafeUnbounded.prototype;
$c_Lcats_effect_std_UnsafeUnbounded.prototype.size__I = (function() {
  var current = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(this.Lcats_effect_std_UnsafeUnbounded__f_first).ju_concurrent_atomic_AtomicReference__f_value);
  var count = 0;
  while ((current !== null)) {
    count = ((1 + count) | 0);
    current = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(current).ju_concurrent_atomic_AtomicReference__f_value);
  }
  return count;
});
$c_Lcats_effect_std_UnsafeUnbounded.prototype.put__O__F0 = (function(data) {
  var cell = new $c_Lcats_effect_std_UnsafeUnbounded$Cell(data);
  var prevLast = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(this.Lcats_effect_std_UnsafeUnbounded__f_last).getAndSet__O__O(cell));
  if ((prevLast === null)) {
    $n(this.Lcats_effect_std_UnsafeUnbounded__f_first).ju_concurrent_atomic_AtomicReference__f_value = cell;
  } else {
    $n(prevLast).ju_concurrent_atomic_AtomicReference__f_value = cell;
  }
  return cell;
});
$c_Lcats_effect_std_UnsafeUnbounded.prototype.take__O = (function() {
  while (true) {
    var taken = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(this.Lcats_effect_std_UnsafeUnbounded__f_first).ju_concurrent_atomic_AtomicReference__f_value);
    if ((taken !== null)) {
      var next = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(taken).ju_concurrent_atomic_AtomicReference__f_value);
      if ($n(this.Lcats_effect_std_UnsafeUnbounded__f_first).compareAndSet__O__O__Z(taken, next)) {
        if (((next === null) && (!$n(this.Lcats_effect_std_UnsafeUnbounded__f_last).compareAndSet__O__O__Z(taken, null)))) {
          var next2 = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(taken).ju_concurrent_atomic_AtomicReference__f_value);
          while ((next2 === null)) {
            next2 = $as_Lcats_effect_std_UnsafeUnbounded$Cell($n(taken).ju_concurrent_atomic_AtomicReference__f_value);
          }
          $n(this.Lcats_effect_std_UnsafeUnbounded__f_first).ju_concurrent_atomic_AtomicReference__f_value = next2;
        }
        var ret = $n(taken).Lcats_effect_std_UnsafeUnbounded$Cell__f__data;
        $n(taken).apply__V();
        return ret;
      }
    } else if (($n(this.Lcats_effect_std_UnsafeUnbounded__f_last).ju_concurrent_atomic_AtomicReference__f_value !== null)) {
    } else {
      throw $n(this.Lcats_effect_std_UnsafeUnbounded__f_FailureSignal);
    }
  }
});
var $d_Lcats_effect_std_UnsafeUnbounded = new $TypeData().initClass($c_Lcats_effect_std_UnsafeUnbounded, "cats.effect.std.UnsafeUnbounded", ({
  Lcats_effect_std_UnsafeUnbounded: 1
}));
/** @constructor */
function $c_Lcats_effect_tracing_RingBuffer(logSize) {
  this.Lcats_effect_tracing_RingBuffer__f_length = 0;
  this.Lcats_effect_tracing_RingBuffer__f_mask = 0;
  this.Lcats_effect_tracing_RingBuffer__f_buffer = null;
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
  this.Lcats_effect_tracing_RingBuffer__f_length = (1 << logSize);
  this.Lcats_effect_tracing_RingBuffer__f_mask = ((this.Lcats_effect_tracing_RingBuffer__f_length - 1) | 0);
  var dimensions = new $ac_I(new Int32Array([this.Lcats_effect_tracing_RingBuffer__f_length]));
  this.Lcats_effect_tracing_RingBuffer__f_buffer = $asArrayOf_Lcats_effect_tracing_TracingEvent($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_tracing_TracingEvent.getClassOf(), dimensions), 1);
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
}
$c_Lcats_effect_tracing_RingBuffer.prototype = new $h_O();
$c_Lcats_effect_tracing_RingBuffer.prototype.constructor = $c_Lcats_effect_tracing_RingBuffer;
/** @constructor */
function $h_Lcats_effect_tracing_RingBuffer() {
}
$h_Lcats_effect_tracing_RingBuffer.prototype = $c_Lcats_effect_tracing_RingBuffer.prototype;
$c_Lcats_effect_tracing_RingBuffer.prototype.push__Lcats_effect_tracing_TracingEvent__V = (function(te) {
  var idx = (this.Lcats_effect_tracing_RingBuffer__f_index & this.Lcats_effect_tracing_RingBuffer__f_mask);
  $n(this.Lcats_effect_tracing_RingBuffer__f_buffer).set(idx, te);
  this.Lcats_effect_tracing_RingBuffer__f_index = ((1 + this.Lcats_effect_tracing_RingBuffer__f_index) | 0);
});
$c_Lcats_effect_tracing_RingBuffer.prototype.toList__sci_List = (function() {
  var result = $m_sci_Nil$();
  var buf = this.Lcats_effect_tracing_RingBuffer__f_buffer;
  if ((buf !== null)) {
    var msk = this.Lcats_effect_tracing_RingBuffer__f_mask;
    var idx = this.Lcats_effect_tracing_RingBuffer__f_index;
    var x = ((idx - this.Lcats_effect_tracing_RingBuffer__f_length) | 0);
    var start = ((x > 0) ? x : 0);
    var i = start;
    while ((i < idx)) {
      var this$4 = $n(result);
      var elem = $n(buf).get((i & msk));
      result = new $c_sci_$colon$colon(elem, this$4);
      i = ((1 + i) | 0);
    }
  }
  return result;
});
$c_Lcats_effect_tracing_RingBuffer.prototype.invalidate__V = (function() {
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
  this.Lcats_effect_tracing_RingBuffer__f_buffer = null;
});
function $as_Lcats_effect_tracing_RingBuffer(obj) {
  return (((obj instanceof $c_Lcats_effect_tracing_RingBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.RingBuffer"));
}
function $isArrayOf_Lcats_effect_tracing_RingBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_RingBuffer)));
}
function $asArrayOf_Lcats_effect_tracing_RingBuffer(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_RingBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.RingBuffer;", depth));
}
var $d_Lcats_effect_tracing_RingBuffer = new $TypeData().initClass($c_Lcats_effect_tracing_RingBuffer, "cats.effect.tracing.RingBuffer", ({
  Lcats_effect_tracing_RingBuffer: 1
}));
/** @constructor */
function $c_Lcats_effect_tracing_TracingConstants$() {
  this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing = false;
  this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing = false;
  this.Lcats_effect_tracing_TracingConstants$__f_isStackTracing = false;
  $n_Lcats_effect_tracing_TracingConstants$ = this;
  var this$1 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_MODE"));
  if (this$1.isEmpty__Z()) {
    var $x_1 = true;
  } else {
    var x0 = this$1.get__O();
    var _$1 = $as_T(x0);
    var this$2 = $n(_$1);
    var $x_1 = (!(this$2 === ""));
  }
  if ($x_1) {
    var this$3 = this$1;
  } else {
    var this$3 = $m_s_None$();
  }
  if (this$3.isEmpty__Z()) {
    if ((($as_T((typeof process)) !== "undefined") && ($as_T((typeof process.release)) !== "undefined"))) {
      var x = process.release.name;
      var $x_3 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, "node");
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var $x_2 = "cached";
    } else {
      var $x_2 = "none";
    }
  } else {
    var $x_2 = this$3.get__O();
  }
  var stackTracingMode = $as_T($x_2);
  var this$4 = $n(stackTracingMode);
  _return: {
    var len = this$4.length;
    if ((len === 6)) {
      var i = 0;
      while ((i !== len)) {
        var thisCP = $f_T__codePointAt__I__I(this$4, i);
        var $x_5 = $m_jl_Character$().toLowerCase__I__I($m_jl_Character$().toUpperCase__I__I(thisCP));
        var cp = $f_T__codePointAt__I__I("cached", i);
        if (($x_5 !== $m_jl_Character$().toLowerCase__I__I($m_jl_Character$().toUpperCase__I__I(cp)))) {
          var $x_4 = false;
          break _return;
        }
        i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
      }
      var $x_4 = true;
    } else {
      var $x_4 = false;
    }
  }
  this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing = $x_4;
  var this$6 = $n(stackTracingMode);
  _return$1: {
    var len$1 = this$6.length;
    if ((len$1 === 4)) {
      var i$1 = 0;
      while ((i$1 !== len$1)) {
        var thisCP$1 = $f_T__codePointAt__I__I(this$6, i$1);
        var $x_7 = $m_jl_Character$().toLowerCase__I__I($m_jl_Character$().toUpperCase__I__I(thisCP$1));
        var cp$1 = $f_T__codePointAt__I__I("full", i$1);
        if (($x_7 !== $m_jl_Character$().toLowerCase__I__I($m_jl_Character$().toUpperCase__I__I(cp$1)))) {
          var $x_6 = false;
          break _return$1;
        }
        i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
      }
      var $x_6 = true;
    } else {
      var $x_6 = false;
    }
  }
  this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing = $x_6;
  this.Lcats_effect_tracing_TracingConstants$__f_isStackTracing = (this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing || this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing);
}
$c_Lcats_effect_tracing_TracingConstants$.prototype = new $h_O();
$c_Lcats_effect_tracing_TracingConstants$.prototype.constructor = $c_Lcats_effect_tracing_TracingConstants$;
/** @constructor */
function $h_Lcats_effect_tracing_TracingConstants$() {
}
$h_Lcats_effect_tracing_TracingConstants$.prototype = $c_Lcats_effect_tracing_TracingConstants$.prototype;
var $d_Lcats_effect_tracing_TracingConstants$ = new $TypeData().initClass($c_Lcats_effect_tracing_TracingConstants$, "cats.effect.tracing.TracingConstants$", ({
  Lcats_effect_tracing_TracingConstants$: 1
}));
var $n_Lcats_effect_tracing_TracingConstants$;
function $m_Lcats_effect_tracing_TracingConstants$() {
  if ((!$n_Lcats_effect_tracing_TracingConstants$)) {
    $n_Lcats_effect_tracing_TracingConstants$ = new $c_Lcats_effect_tracing_TracingConstants$();
  }
  return $n_Lcats_effect_tracing_TracingConstants$;
}
function $ct_Lcats_effect_tracing_TracingPlatform__($thiz) {
  $thiz.Lcats_effect_tracing_TracingPlatform__f_cache = $f_scm_Map__withDefaultValue__O__scm_Map($n($as_scm_Map($m_scm_Map$().empty__O())), null);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_function0Property = $as_T(Object.getOwnPropertyNames(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (void 0))))[0]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_function1Property = $as_T(Object.getOwnPropertyNames(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    $as_jl_Void(_$1);
  })))[0]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing ? new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((key) => {
    var current = $as_Lcats_effect_tracing_TracingEvent($n($thiz.Lcats_effect_tracing_TracingPlatform__f_cache).apply__O__O(key));
    if ((current === null)) {
      $n($as_Lcats_effect_tracing_Tracing$($thiz));
      var event = new $c_Lcats_effect_tracing_TracingEvent$StackTrace();
      $n($thiz.Lcats_effect_tracing_TracingPlatform__f_cache).update__O__O__V(key, event);
      return event;
    } else {
      return current;
    }
  })) : ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing ? new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
    $n($as_Lcats_effect_tracing_Tracing$($thiz));
    return new $c_Lcats_effect_tracing_TracingEvent$StackTrace();
  })) : new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => null))));
  $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = new ($d_T.getArrayOf().constr)(["githubusercontent.com/typelevel/cats-effect/", "githubusercontent.com/typelevel/cats/", "githubusercontent.com/scala-js/", "githubusercontent.com/scala/"]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = new ($d_T.getArrayOf().constr)(["_Lcats_effect_", "_jl_", "_Lorg_scalajs_"]);
  return $thiz;
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z($thiz, fileName) {
  var i = 0;
  var len = $n($thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter).u.length;
  while ((i < len)) {
    var this$1 = $n(fileName);
    var s = $n($thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter).get(i);
    var this$2 = $n(s);
    if (($uI(this$1.indexOf(this$2)) !== (-1))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z($thiz, methodName) {
  var i = 0;
  var len = $n($thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter).u.length;
  while ((i < len)) {
    var this$1 = $n(methodName);
    var s = $n($thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter).get(i);
    var this$2 = $n(s);
    if (($uI(this$1.indexOf(this$2)) !== (-1))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z($thiz, callSiteFileName$1) {
  if ((callSiteFileName$1 !== null)) {
    var this$1 = $n(callSiteFileName$1);
    var $x_1 = (!$uZ(this$1.endsWith(".js")));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z($thiz, callSiteFileName$1);
  } else {
    return false;
  }
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z($thiz, callSiteClassName$1, callSiteMethodName$1, callSiteFileName$2) {
  return ((callSiteClassName$1 === "<jscode>") && ($p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z($thiz, callSiteFileName$2) || $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z($thiz, callSiteMethodName$1)));
}
/** @constructor */
function $c_Lcats_effect_tracing_TracingPlatform() {
  this.Lcats_effect_tracing_TracingPlatform__f_cache = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function0Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function1Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = null;
}
$c_Lcats_effect_tracing_TracingPlatform.prototype = new $h_O();
$c_Lcats_effect_tracing_TracingPlatform.prototype.constructor = $c_Lcats_effect_tracing_TracingPlatform;
/** @constructor */
function $h_Lcats_effect_tracing_TracingPlatform() {
}
$h_Lcats_effect_tracing_TracingPlatform.prototype = $c_Lcats_effect_tracing_TracingPlatform.prototype;
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__F0__Lcats_effect_tracing_TracingEvent = (function(f) {
  return $as_Lcats_effect_tracing_TracingEvent($n(this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent).apply__O__O($dp_toString__T($n(f[this.Lcats_effect_tracing_TracingPlatform__f_function0Property]))));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent = (function(f) {
  return $as_Lcats_effect_tracing_TracingEvent($n(this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent).apply__O__O($dp_toString__T($n(f[this.Lcats_effect_tracing_TracingPlatform__f_function1Property]))));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__Lcats_effect_kernel_Cont__Lcats_effect_tracing_TracingEvent = (function(cont) {
  var $x_1 = this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent;
  var this$1 = $n(cont);
  return $as_Lcats_effect_tracing_TracingEvent($n($x_1).apply__O__O($objectGetClass(this$1)));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.applyStackTraceFilter__T__T__T__Z = (function(callSiteClassName, callSiteMethodName, callSiteFileName) {
  return ($p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z(this, callSiteClassName, callSiteMethodName, callSiteFileName) || $n($as_Lcats_effect_tracing_Tracing$(this)).isInternalClass__T__Z(callSiteClassName));
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.decodeMethodName__T__T = (function(name) {
  var this$1 = $n(name);
  var junk = $uI(this$1.indexOf("__"));
  var $x_2 = $m_s_reflect_NameTransformer$();
  if ((junk === (-1))) {
    var $x_1 = name;
  } else {
    var this$2 = $n(name);
    if ((junk > this$2.length)) {
      $charAt(this$2, junk);
    }
    if ((junk < 0)) {
      $charAt(this$2, (-1));
    }
    var $x_1 = $as_T(this$2.substring(0, junk));
  }
  return $x_2.decode__T__T($x_1);
});
function $ct_Lcats_effect_unsafe_FiberMonitorPlatform__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitorPlatform() {
}
$c_Lcats_effect_unsafe_FiberMonitorPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_FiberMonitorPlatform.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitorPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitorPlatform() {
}
$h_Lcats_effect_unsafe_FiberMonitorPlatform.prototype = $c_Lcats_effect_unsafe_FiberMonitorPlatform.prototype;
$c_Lcats_effect_unsafe_FiberMonitorPlatform.prototype.apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_FiberMonitor = (function(compute) {
  if (this.weakRefsAvailable__Z()) {
    if ((compute instanceof $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor)) {
      var bmec = $as_Lcats_effect_unsafe_BatchingMacrotaskExecutor(compute);
      return new $c_Lcats_effect_unsafe_FiberMonitorImpl(bmec);
    } else {
      return new $c_Lcats_effect_unsafe_FiberMonitorImpl(null);
    }
  } else {
    return new $c_Lcats_effect_unsafe_NoOpFiberMonitor();
  }
});
$c_Lcats_effect_unsafe_FiberMonitorPlatform.prototype.weakRefsAvailable__Z = (function() {
  return (($as_T((typeof WeakRef)) !== "undefined") && ($as_T((typeof FinalizationRegistry)) !== "undefined"));
});
function $ct_Lcats_effect_unsafe_FiberMonitorShared__($thiz) {
  $thiz.Lcats_effect_unsafe_FiberMonitorShared__f_newline = "\n";
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitorShared() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
}
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype = new $h_O();
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitorShared;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitorShared() {
}
$h_Lcats_effect_unsafe_FiberMonitorShared.prototype = $c_Lcats_effect_unsafe_FiberMonitorShared.prototype;
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntime(compute, blocking, scheduler, pollers, fiberMonitor, shutdown, config, metrics) {
  this.Lcats_effect_unsafe_IORuntime__f_compute = null;
  this.Lcats_effect_unsafe_IORuntime__f_blocking = null;
  this.Lcats_effect_unsafe_IORuntime__f_scheduler = null;
  this.Lcats_effect_unsafe_IORuntime__f_fiberMonitor = null;
  this.Lcats_effect_unsafe_IORuntime__f_shutdown = null;
  this.Lcats_effect_unsafe_IORuntime__f_config = null;
  this.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs = null;
  this.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold = 0;
  this.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold = 0;
  this.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions = false;
  this.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize = 0;
  this.Lcats_effect_unsafe_IORuntime__f_compute = compute;
  this.Lcats_effect_unsafe_IORuntime__f_blocking = blocking;
  this.Lcats_effect_unsafe_IORuntime__f_scheduler = scheduler;
  this.Lcats_effect_unsafe_IORuntime__f_fiberMonitor = fiberMonitor;
  this.Lcats_effect_unsafe_IORuntime__f_shutdown = shutdown;
  this.Lcats_effect_unsafe_IORuntime__f_config = config;
  this.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs = new $c_Lcats_effect_unsafe_StripedHashtable();
  this.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold = $n(config).Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
  this.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold = $n(config).Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
  this.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions = $n(config).Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions;
  this.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize = $n(config).Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize;
}
$c_Lcats_effect_unsafe_IORuntime.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntime.prototype.constructor = $c_Lcats_effect_unsafe_IORuntime;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntime() {
}
$h_Lcats_effect_unsafe_IORuntime.prototype = $c_Lcats_effect_unsafe_IORuntime.prototype;
$c_Lcats_effect_unsafe_IORuntime.prototype.toString__T = (function() {
  return (((((("IORuntime(" + this.Lcats_effect_unsafe_IORuntime__f_compute) + ", ") + this.Lcats_effect_unsafe_IORuntime__f_scheduler) + ", ") + this.Lcats_effect_unsafe_IORuntime__f_config) + ")");
});
function $as_Lcats_effect_unsafe_IORuntime(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_IORuntime) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.IORuntime"));
}
function $isArrayOf_Lcats_effect_unsafe_IORuntime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntime)));
}
function $asArrayOf_Lcats_effect_unsafe_IORuntime(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_IORuntime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.IORuntime;", depth));
}
var $d_Lcats_effect_unsafe_IORuntime = new $TypeData().initClass($c_Lcats_effect_unsafe_IORuntime, "cats.effect.unsafe.IORuntime", ({
  Lcats_effect_unsafe_IORuntime: 1
}));
function $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__($thiz) {
  $thiz.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
}
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform() {
}
$h_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype = $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.createBatchingMacrotaskExecutor$default$2__F1 = (function() {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    var _$1$1 = $as_jl_Throwable(_$1);
    var this$1 = $n(_$1$1);
    this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
  }));
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.resetGlobal__V = (function() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.global__Lcats_effect_unsafe_IORuntime = (function() {
  if ((this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
    if ((this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
      var this$3 = $m_Lcats_effect_unsafe_IORuntime$();
      var reportFailure = this.createBatchingMacrotaskExecutor$default$2__F1();
      var compute = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(64, reportFailure);
      var reportFailure$1 = this.createBatchingMacrotaskExecutor$default$2__F1();
      var blocking = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(64, reportFailure$1);
      var scheduler = $as_Lcats_effect_unsafe_Scheduler($n($m_Lcats_effect_unsafe_Scheduler$().createDefaultScheduler__T2())._1__O());
      var shutdown = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        this.resetGlobal__V();
      }));
      var this$2 = $m_Lcats_effect_unsafe_IORuntimeConfig$();
      var config = this$2.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default;
      this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = this$3.apply__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__F0__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_IORuntime(compute, blocking, scheduler, $m_sci_Nil$(), shutdown, config);
    }
  }
  return this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global;
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.registerFiberMonitorMBean__Lcats_effect_unsafe_FiberMonitor__F0 = (function(fiberMonitor) {
  return new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (void 0)));
});
function $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__($thiz) {
  var this$1 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CANCELATION_CHECK_THRESHOLD"));
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var x = $as_T(x0);
    try {
      var this$5 = $m_jl_Integer$();
      var r1 = this$5.java$lang$Integer$$parseIntImpl__T__I__I__I(x, 10, 214748364);
      var $x_2 = new $c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_2;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          var $x_2 = new $c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    var $x_1 = $x_2.toOption__s_Option();
  }
  var this$6 = $n($x_1);
  var cancelationCheckThreshold = $uI((this$6.isEmpty__Z() ? 512 : this$6.get__O()));
  var this$7 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_AUTO_YIELD_THRESHOLD_MULTIPLIER"));
  if (this$7.isEmpty__Z()) {
    var $x_3 = $m_s_None$();
  } else {
    var x0$1 = this$7.get__O();
    var x$1 = $as_T(x0$1);
    try {
      var this$11 = $m_jl_Integer$();
      var r1$1 = this$11.java$lang$Integer$$parseIntImpl__T__I__I__I(x$1, 10, 214748364);
      var $x_4 = new $c_s_util_Success(r1$1);
    } catch (e$1) {
      var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      matchEnd8$1: {
        var $x_4;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$1)) {
          var $x_4 = new $c_s_util_Failure(e$2$1);
          break matchEnd8$1;
        }
        throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : e$2$1);
      }
    }
    var $x_3 = $x_4.toOption__s_Option();
  }
  var this$12 = $n($x_3);
  var autoYieldThreshold = Math.imul($uI((this$12.isEmpty__Z() ? 2 : this$12.get__O())), cancelationCheckThreshold);
  var this$13 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_EXCEPTIONS_ENHANCED"));
  if (this$13.isEmpty__Z()) {
    var $x_5 = $m_s_None$();
  } else {
    var x0$2 = this$13.get__O();
    var x$2 = $as_T(x0$2);
    try {
      var r1$2 = $m_sc_StringOps$().toBooleanImpl$extension__T__T__Z(x$2, x$2);
      var $x_6 = new $c_s_util_Success(r1$2);
    } catch (e$3) {
      var e$2$2 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
      matchEnd8$2: {
        var $x_6;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$2)) {
          var $x_6 = new $c_s_util_Failure(e$2$2);
          break matchEnd8$2;
        }
        throw ((e$2$2 instanceof $c_sjs_js_JavaScriptException) ? e$2$2.sjs_js_JavaScriptException__f_exception : e$2$2);
      }
    }
    var $x_5 = $x_6.toOption__s_Option();
  }
  var this$17 = $n($x_5);
  var enhancedExceptions = $uZ((this$17.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), true) : this$17.get__O()));
  var this$18 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_BUFFER_SIZE"));
  if (this$18.isEmpty__Z()) {
    var $x_7 = $m_s_None$();
  } else {
    var x0$3 = this$18.get__O();
    var x$3 = $as_T(x0$3);
    try {
      var this$22 = $m_jl_Integer$();
      var r1$3 = this$22.java$lang$Integer$$parseIntImpl__T__I__I__I(x$3, 10, 214748364);
      var $x_8 = new $c_s_util_Success(r1$3);
    } catch (e$4) {
      var e$2$3 = ((e$4 instanceof $c_jl_Throwable) ? e$4 : new $c_sjs_js_JavaScriptException(e$4));
      matchEnd8$3: {
        var $x_8;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$3)) {
          var $x_8 = new $c_s_util_Failure(e$2$3);
          break matchEnd8$3;
        }
        throw ((e$2$3 instanceof $c_sjs_js_JavaScriptException) ? e$2$3.sjs_js_JavaScriptException__f_exception : e$2$3);
      }
    }
    var $x_7 = $x_8.toOption__s_Option();
  }
  var this$23 = $n($x_7);
  var traceBufferSize = $uI((this$23.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), 16) : this$23.get__O()));
  var this$24 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_SHUTDOWN_HOOK_TIMEOUT"));
  if (this$24.isEmpty__Z()) {
    var $x_9 = $m_s_None$();
  } else {
    var x0$4 = this$24.get__O();
    var x$4 = $as_T(x0$4);
    try {
      var r1$4 = $m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(x$4);
      var $x_10 = new $c_s_util_Success(r1$4);
    } catch (e$5) {
      var e$2$4 = ((e$5 instanceof $c_jl_Throwable) ? e$5 : new $c_sjs_js_JavaScriptException(e$5));
      matchEnd8$4: {
        var $x_10;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$4)) {
          var $x_10 = new $c_s_util_Failure(e$2$4);
          break matchEnd8$4;
        }
        throw ((e$2$4 instanceof $c_sjs_js_JavaScriptException) ? e$2$4.sjs_js_JavaScriptException__f_exception : e$2$4);
      }
    }
    var $x_9 = $x_10.toOption__s_Option();
  }
  var this$26 = $n($x_9);
  var shutdownHookTimeout = $as_s_concurrent_duration_Duration((this$26.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf) : this$26.get__O()));
  var this$28 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_REPORT_UNHANDLED_FIBER_ERRORS"));
  if (this$28.isEmpty__Z()) {
    var $x_11 = $m_s_None$();
  } else {
    var x0$5 = this$28.get__O();
    var x$5 = $as_T(x0$5);
    try {
      var r1$5 = $m_sc_StringOps$().toBooleanImpl$extension__T__T__Z(x$5, x$5);
      var $x_12 = new $c_s_util_Success(r1$5);
    } catch (e$6) {
      var e$2$5 = ((e$6 instanceof $c_jl_Throwable) ? e$6 : new $c_sjs_js_JavaScriptException(e$6));
      matchEnd8$5: {
        var $x_12;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$5)) {
          var $x_12 = new $c_s_util_Failure(e$2$5);
          break matchEnd8$5;
        }
        throw ((e$2$5 instanceof $c_sjs_js_JavaScriptException) ? e$2$5.sjs_js_JavaScriptException__f_exception : e$2$5);
      }
    }
    var $x_11 = $x_12.toOption__s_Option();
  }
  var this$32 = $n($x_11);
  var reportUnhandledFiberErrors = $uZ((this$32.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), true) : this$32.get__O()));
  var this$33 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CPU_STARVATION_CHECK_INTERVAL"));
  if (this$33.isEmpty__Z()) {
    var this$34 = $m_s_None$();
  } else {
    var x0$6 = this$33.get__O();
    var _$1 = $as_T(x0$6);
    var this$34 = new $c_s_Some($m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(_$1));
  }
  if (this$34.isEmpty__Z()) {
    var $x_13 = $m_s_None$();
  } else {
    var x0$7 = this$34.get__O();
    var d = $as_s_concurrent_duration_Duration(x0$7);
    try {
      var r1$6 = $as_s_concurrent_duration_FiniteDuration(d);
      var $x_14 = new $c_s_util_Success(r1$6);
    } catch (e$7) {
      var e$2$6 = ((e$7 instanceof $c_jl_Throwable) ? e$7 : new $c_sjs_js_JavaScriptException(e$7));
      matchEnd8$6: {
        var $x_14;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$6)) {
          var $x_14 = new $c_s_util_Failure(e$2$6);
          break matchEnd8$6;
        }
        throw ((e$2$6 instanceof $c_sjs_js_JavaScriptException) ? e$2$6.sjs_js_JavaScriptException__f_exception : e$2$6);
      }
    }
    var $x_13 = $x_14.toOption__s_Option();
  }
  var this$36 = $n($x_13);
  var cpuStarvationCheckInterval = $as_s_concurrent_duration_FiniteDuration((this$36.isEmpty__Z() ? $n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)).DefaultCpuStarvationCheckInterval__s_concurrent_duration_FiniteDuration() : this$36.get__O()));
  var this$37 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CPU_STARVATION_CHECK_INITIAL_DELAY"));
  if (this$37.isEmpty__Z()) {
    var this$38 = $m_s_None$();
  } else {
    var x0$8 = this$37.get__O();
    var _$2 = $as_T(x0$8);
    var this$38 = new $c_s_Some($m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(_$2));
  }
  var cpuStarvationCheckInitialDelay = $as_s_concurrent_duration_Duration((this$38.isEmpty__Z() ? $n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)).DefaultCpuStarvationCheckInitialDelay__s_concurrent_duration_FiniteDuration() : this$38.get__O()));
  var this$39 = $n($m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CPU_STARVATION_CHECK_THRESHOLD"));
  if (this$39.isEmpty__Z()) {
    var $x_15 = $m_s_None$();
  } else {
    var x0$9 = this$39.get__O();
    var p = $as_T(x0$9);
    try {
      var r1$7 = $m_jl_Double$().parseDouble__T__D(p);
      var $x_16 = new $c_s_util_Success(r1$7);
    } catch (e$8) {
      var e$2$7 = ((e$8 instanceof $c_jl_Throwable) ? e$8 : new $c_sjs_js_JavaScriptException(e$8));
      matchEnd8$7: {
        var $x_16;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$7)) {
          var $x_16 = new $c_s_util_Failure(e$2$7);
          break matchEnd8$7;
        }
        throw ((e$2$7 instanceof $c_sjs_js_JavaScriptException) ? e$2$7.sjs_js_JavaScriptException__f_exception : e$2$7);
      }
    }
    var $x_15 = $x_16.toOption__s_Option();
  }
  var this$43 = $n($x_15);
  var cpuStarvationCheckThreshold = $uD((this$43.isEmpty__Z() ? ($n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)), 0.1) : this$43.get__O()));
  $thiz.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = $n($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz)).apply__I__I__Z__I__s_concurrent_duration_Duration__Z__s_concurrent_duration_FiniteDuration__s_concurrent_duration_Duration__D__Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold);
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform() {
  this.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = null;
}
$c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform() {
}
$h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype = $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype;
/** @constructor */
function $c_Lcats_effect_unsafe_JSArrayQueue() {
  this.Lcats_effect_unsafe_JSArrayQueue__f_buffer = null;
  this.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = 0;
  this.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = 0;
  this.Lcats_effect_unsafe_JSArrayQueue__f_empty = false;
  this.Lcats_effect_unsafe_JSArrayQueue__f_buffer = [null];
  this.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = 0;
  this.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = 1;
  this.Lcats_effect_unsafe_JSArrayQueue__f_empty = true;
}
$c_Lcats_effect_unsafe_JSArrayQueue.prototype = new $h_O();
$c_Lcats_effect_unsafe_JSArrayQueue.prototype.constructor = $c_Lcats_effect_unsafe_JSArrayQueue;
/** @constructor */
function $h_Lcats_effect_unsafe_JSArrayQueue() {
}
$h_Lcats_effect_unsafe_JSArrayQueue.prototype = $c_Lcats_effect_unsafe_JSArrayQueue.prototype;
var $d_Lcats_effect_unsafe_JSArrayQueue = new $TypeData().initClass($c_Lcats_effect_unsafe_JSArrayQueue, "cats.effect.unsafe.JSArrayQueue", ({
  Lcats_effect_unsafe_JSArrayQueue: 1
}));
function $is_Lcats_effect_unsafe_Scheduler(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_unsafe_Scheduler)));
}
function $as_Lcats_effect_unsafe_Scheduler(obj) {
  return (($is_Lcats_effect_unsafe_Scheduler(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.Scheduler"));
}
function $isArrayOf_Lcats_effect_unsafe_Scheduler(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_Scheduler)));
}
function $asArrayOf_Lcats_effect_unsafe_Scheduler(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_Scheduler(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.Scheduler;", depth));
}
function $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__($thiz) {
  var this$2 = new $c_s_concurrent_duration_package$DurationInt(2147483647);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = new $c_s_concurrent_duration_FiniteDuration(this$, hi, unit);
  if (($as_T((typeof clearTimeout)) === "function")) {
    var $x_1 = ((handle) => new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1(handle, $thiz));
  } else {
    var noop = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2($thiz);
    var $x_1 = ((_$1) => noop);
  }
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable = $x_1;
  var this$7 = $n($ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__browsers$1__s_Option());
  var this$8 = $n((this$7.isEmpty__Z() ? $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__nodeJS$1__s_Option() : this$7));
  if (this$8.isEmpty__Z()) {
    var this$9 = $m_s_None$();
  } else {
    var x0 = this$8.get__O();
    var this$9 = new $c_s_Some((() => {
      var value = (1000.0 * ($uD(x0.timeOrigin) + $uD(x0.now())));
      return $m_RTLong$().fromDouble__D__J(value);
    }));
  }
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl = (this$9.isEmpty__Z() ? (() => {
    var value$1 = $uD(Date.now());
    var $x_2 = $m_RTLong$().fromDouble__D__J(value$1);
    var x_$_lo = $x_2.l;
    var x_$_hi = $x_2.h;
    var b0 = (65535 & x_$_lo);
    var b1 = ((x_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(1000, b0);
    var a0b1 = Math.imul(1000, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(1000, x_$_hi) + ((c1part >>> 16) | 0)) | 0);
    return $bL(lo, hi$1);
  }) : this$9.get__O());
  return $thiz;
}
function $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z(performance) {
  var x = ($uD(performance.timeOrigin) + $uD(performance.now()));
  return (!(x !== x));
}
function $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__browsers$1__s_Option() {
  try {
    var x = performance;
    var r1 = (((x === (void 0)) || $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z(x)) ? x : (void 0));
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  var this$7 = $n($x_1.toOption__s_Option());
  if (this$7.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var x0 = this$7.get__O();
    return ((x0 === (void 0)) ? $m_s_None$() : new $c_s_Some(x0));
  }
}
function $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__nodeJS$1__s_Option() {
  try {
    var x = require("perf_hooks").performance;
    var r1 = (((x === (void 0)) || $ps_Lcats_effect_unsafe_SchedulerCompanionPlatform__test$1__Lcats_effect_unsafe_Performance__Z(x)) ? x : (void 0));
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  var this$8 = $n($x_1.toOption__s_Option());
  if (this$8.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var x0 = this$8.get__O();
    return ((x0 === (void 0)) ? $m_s_None$() : new $c_s_Some(x0));
  }
}
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform() {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl = null;
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype.createDefaultScheduler__T2 = (function() {
  var _1 = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3(this);
  var _2 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (void 0)));
  return new $c_T2(_1, _2);
});
/** @constructor */
function $c_Lcats_effect_unsafe_StripedHashtable() {
  this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables = 0;
  this.Lcats_effect_unsafe_StripedHashtable__f_mask = 0;
  this.Lcats_effect_unsafe_StripedHashtable__f_tables = null;
  this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables = $m_Lcats_effect_unsafe_StripedHashtable$().Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables;
  this.Lcats_effect_unsafe_StripedHashtable__f_mask = ((this.numTables__I() - 1) | 0);
  var dimensions = new $ac_I(new Int32Array([this.numTables__I()]));
  var array = $asArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_ThreadSafeHashtable.getClassOf(), dimensions), 1);
  var i = 0;
  while ((i < this.numTables__I())) {
    $n(array).set(i, new $c_Lcats_effect_unsafe_ThreadSafeHashtable(8));
    i = ((1 + i) | 0);
  }
  this.Lcats_effect_unsafe_StripedHashtable__f_tables = array;
}
$c_Lcats_effect_unsafe_StripedHashtable.prototype = new $h_O();
$c_Lcats_effect_unsafe_StripedHashtable.prototype.constructor = $c_Lcats_effect_unsafe_StripedHashtable;
/** @constructor */
function $h_Lcats_effect_unsafe_StripedHashtable() {
}
$h_Lcats_effect_unsafe_StripedHashtable.prototype = $c_Lcats_effect_unsafe_StripedHashtable.prototype;
$c_Lcats_effect_unsafe_StripedHashtable.prototype.numTables__I = (function() {
  return (1 << this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables);
});
$c_Lcats_effect_unsafe_StripedHashtable.prototype.put__F1__V = (function(cb) {
  var hash = $systemIdentityHashCode(cb);
  var idx = (hash & this.Lcats_effect_unsafe_StripedHashtable__f_mask);
  $n($n(this.Lcats_effect_unsafe_StripedHashtable__f_tables).get(idx)).put__O__I__V(cb, (hash >> this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables));
});
$c_Lcats_effect_unsafe_StripedHashtable.prototype.remove__F1__V = (function(cb) {
  var hash = $systemIdentityHashCode(cb);
  var idx = (hash & this.Lcats_effect_unsafe_StripedHashtable__f_mask);
  $n($n(this.Lcats_effect_unsafe_StripedHashtable__f_tables).get(idx)).remove__O__I__V(cb, (hash >> this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables));
});
var $d_Lcats_effect_unsafe_StripedHashtable = new $TypeData().initClass($c_Lcats_effect_unsafe_StripedHashtable, "cats.effect.unsafe.StripedHashtable", ({
  Lcats_effect_unsafe_StripedHashtable: 1
}));
function $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I($thiz) {
  var this$1 = $m_jl_Runtime$();
  $n(this$1.jl_Runtime$__f_currentRuntime);
  return (1 << 2);
}
/** @constructor */
function $c_Lcats_effect_unsafe_StripedHashtable$() {
  this.Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables = 0;
  $n_Lcats_effect_unsafe_StripedHashtable$ = this;
  var result = 0;
  var x = $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I(this);
  while ((x !== 0)) {
    result = ((1 + result) | 0);
    x = (x >> 1);
  }
  this.Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables = result;
}
$c_Lcats_effect_unsafe_StripedHashtable$.prototype = new $h_O();
$c_Lcats_effect_unsafe_StripedHashtable$.prototype.constructor = $c_Lcats_effect_unsafe_StripedHashtable$;
/** @constructor */
function $h_Lcats_effect_unsafe_StripedHashtable$() {
}
$h_Lcats_effect_unsafe_StripedHashtable$.prototype = $c_Lcats_effect_unsafe_StripedHashtable$.prototype;
var $d_Lcats_effect_unsafe_StripedHashtable$ = new $TypeData().initClass($c_Lcats_effect_unsafe_StripedHashtable$, "cats.effect.unsafe.StripedHashtable$", ({
  Lcats_effect_unsafe_StripedHashtable$: 1
}));
var $n_Lcats_effect_unsafe_StripedHashtable$;
function $m_Lcats_effect_unsafe_StripedHashtable$() {
  if ((!$n_Lcats_effect_unsafe_StripedHashtable$)) {
    $n_Lcats_effect_unsafe_StripedHashtable$ = new $c_Lcats_effect_unsafe_StripedHashtable$();
  }
  return $n_Lcats_effect_unsafe_StripedHashtable$;
}
function $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V($thiz, table, mask, a, hash) {
  var idx = (hash & mask);
  var remaining = mask;
  while ((remaining >= 0)) {
    var cur = $n(table).get(idx);
    if (((cur === null) || Object.is(cur, $thiz.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone))) {
      $n(table).set(idx, a);
      return (void 0);
    } else {
      idx = (((1 + idx) | 0) & mask);
    }
    remaining = ((remaining - 1) | 0);
  }
}
/** @constructor */
function $c_Lcats_effect_unsafe_ThreadSafeHashtable(initialCapacity) {
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = null;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone = null;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity = initialCapacity;
  var dimensions = new $ac_I(new Int32Array([initialCapacity]));
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = ((initialCapacity - 1) | 0);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = initialCapacity;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables = $m_Lcats_effect_unsafe_StripedHashtable$().Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone = $m_Lcats_effect_unsafe_ThreadSafeHashtable$().Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone;
}
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype = new $h_O();
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.constructor = $c_Lcats_effect_unsafe_ThreadSafeHashtable;
/** @constructor */
function $h_Lcats_effect_unsafe_ThreadSafeHashtable() {
}
$h_Lcats_effect_unsafe_ThreadSafeHashtable.prototype = $c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype;
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.put__O__I__V = (function(a, hash) {
  var sz = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size;
  var cap = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity;
  if (((sz << 1) >= cap)) {
    var newCap = (cap << 1);
    var newMask = ((newCap - 1) | 0);
    var dimensions = new $ac_I(new Int32Array([newCap]));
    var newHashtable = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var table = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
    var i = 0;
    while ((i < cap)) {
      var cur = $n(table).get(i);
      if (((cur !== null) && (!Object.is(cur, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone)))) {
        $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V(this, newHashtable, newMask, cur, ($systemIdentityHashCode(cur) >> this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables));
      }
      i = ((1 + i) | 0);
    }
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = newHashtable;
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = newMask;
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = newCap;
  }
  $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V(this, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask, a, hash);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = ((1 + sz) | 0);
});
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.remove__O__I__V = (function(a, hash) {
  var msk = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask;
  var init = (hash & msk);
  var idx = init;
  var table = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
  var remaining = msk;
  while ((remaining >= 0)) {
    var cur = $n(table).get(idx);
    if (Object.is(a, cur)) {
      $n(table).set(idx, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone);
      this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = ((this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size - 1) | 0);
      var sz = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size;
      var cap = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity;
      if (((cap > this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity) && ((sz << 2) < cap))) {
        var newCap = ((cap >>> 1) | 0);
        var newMask = ((newCap - 1) | 0);
        var dimensions = new $ac_I(new Int32Array([newCap]));
        var newHashtable = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
        var table$2 = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
        var i = 0;
        while ((i < cap)) {
          var cur$2 = $n(table$2).get(i);
          if (((cur$2 !== null) && (!Object.is(cur$2, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone)))) {
            $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AO__I__O__I__V(this, newHashtable, newMask, cur$2, ($systemIdentityHashCode(cur$2) >> this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables));
          }
          i = ((1 + i) | 0);
        }
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = newHashtable;
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = newMask;
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = newCap;
      }
      return (void 0);
    } else if ((cur !== null)) {
      idx = (((1 + idx) | 0) & msk);
    } else {
      return (void 0);
    }
    remaining = ((remaining - 1) | 0);
  }
});
function $as_Lcats_effect_unsafe_ThreadSafeHashtable(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_ThreadSafeHashtable) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.ThreadSafeHashtable"));
}
function $isArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_ThreadSafeHashtable)));
}
function $asArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.ThreadSafeHashtable;", depth));
}
var $d_Lcats_effect_unsafe_ThreadSafeHashtable = new $TypeData().initClass($c_Lcats_effect_unsafe_ThreadSafeHashtable, "cats.effect.unsafe.ThreadSafeHashtable", ({
  Lcats_effect_unsafe_ThreadSafeHashtable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_ThreadSafeHashtable$() {
  this.Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone = null;
  $n_Lcats_effect_unsafe_ThreadSafeHashtable$ = this;
  this.Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone = $ct_O__(new $c_O());
}
$c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype = new $h_O();
$c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype.constructor = $c_Lcats_effect_unsafe_ThreadSafeHashtable$;
/** @constructor */
function $h_Lcats_effect_unsafe_ThreadSafeHashtable$() {
}
$h_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype = $c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype;
var $d_Lcats_effect_unsafe_ThreadSafeHashtable$ = new $TypeData().initClass($c_Lcats_effect_unsafe_ThreadSafeHashtable$, "cats.effect.unsafe.ThreadSafeHashtable$", ({
  Lcats_effect_unsafe_ThreadSafeHashtable$: 1
}));
var $n_Lcats_effect_unsafe_ThreadSafeHashtable$;
function $m_Lcats_effect_unsafe_ThreadSafeHashtable$() {
  if ((!$n_Lcats_effect_unsafe_ThreadSafeHashtable$)) {
    $n_Lcats_effect_unsafe_ThreadSafeHashtable$ = new $c_Lcats_effect_unsafe_ThreadSafeHashtable$();
  }
  return $n_Lcats_effect_unsafe_ThreadSafeHashtable$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_UnsafeNonFatal$() {
}
$c_Lcats_effect_unsafe_UnsafeNonFatal$.prototype = new $h_O();
$c_Lcats_effect_unsafe_UnsafeNonFatal$.prototype.constructor = $c_Lcats_effect_unsafe_UnsafeNonFatal$;
/** @constructor */
function $h_Lcats_effect_unsafe_UnsafeNonFatal$() {
}
$h_Lcats_effect_unsafe_UnsafeNonFatal$.prototype = $c_Lcats_effect_unsafe_UnsafeNonFatal$.prototype;
$c_Lcats_effect_unsafe_UnsafeNonFatal$.prototype.apply__jl_Throwable__Z = (function(t) {
  matchAlts1: {
    matchAlts2: {
      if ((t instanceof $c_jl_VirtualMachineError)) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if ((t instanceof $c_s_util_control_ControlThrowable)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return false;
  }
  return true;
});
var $d_Lcats_effect_unsafe_UnsafeNonFatal$ = new $TypeData().initClass($c_Lcats_effect_unsafe_UnsafeNonFatal$, "cats.effect.unsafe.UnsafeNonFatal$", ({
  Lcats_effect_unsafe_UnsafeNonFatal$: 1
}));
var $n_Lcats_effect_unsafe_UnsafeNonFatal$;
function $m_Lcats_effect_unsafe_UnsafeNonFatal$() {
  if ((!$n_Lcats_effect_unsafe_UnsafeNonFatal$)) {
    $n_Lcats_effect_unsafe_UnsafeNonFatal$ = new $c_Lcats_effect_unsafe_UnsafeNonFatal$();
  }
  return $n_Lcats_effect_unsafe_UnsafeNonFatal$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_WeakBag() {
  this.Lcats_effect_unsafe_WeakBag__f_MaxSizePow2 = 0;
  this.Lcats_effect_unsafe_WeakBag__f_queue = null;
  this.Lcats_effect_unsafe_WeakBag__f_capacity = 0;
  this.Lcats_effect_unsafe_WeakBag__f_table = null;
  this.Lcats_effect_unsafe_WeakBag__f_index = 0;
  this.Lcats_effect_unsafe_WeakBag__f_MaxSizePow2 = 1073741824;
  this.Lcats_effect_unsafe_WeakBag__f_queue = new $c_Lcats_effect_unsafe_ref_ReferenceQueue();
  this.Lcats_effect_unsafe_WeakBag__f_capacity = 256;
  var dimensions = new $ac_I(new Int32Array([this.Lcats_effect_unsafe_WeakBag__f_capacity]));
  this.Lcats_effect_unsafe_WeakBag__f_table = $asArrayOf_Lcats_effect_unsafe_WeakBag$Entry($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_WeakBag$Entry.getClassOf(), dimensions), 1);
  this.Lcats_effect_unsafe_WeakBag__f_index = 0;
}
$c_Lcats_effect_unsafe_WeakBag.prototype = new $h_O();
$c_Lcats_effect_unsafe_WeakBag.prototype.constructor = $c_Lcats_effect_unsafe_WeakBag;
/** @constructor */
function $h_Lcats_effect_unsafe_WeakBag() {
}
$h_Lcats_effect_unsafe_WeakBag.prototype = $c_Lcats_effect_unsafe_WeakBag.prototype;
$c_Lcats_effect_unsafe_WeakBag.prototype.insert__O__Lcats_effect_unsafe_WeakBag$Handle = (function(a) {
  while (true) {
    var oldEntry = $as_Lcats_effect_unsafe_WeakBag$Entry($n(this.Lcats_effect_unsafe_WeakBag__f_queue).poll__Lcats_effect_unsafe_ref_Reference());
    var cap = this.Lcats_effect_unsafe_WeakBag__f_capacity;
    var idx = this.Lcats_effect_unsafe_WeakBag__f_index;
    if ((oldEntry !== null)) {
      var oldIndex = $n(oldEntry).Lcats_effect_unsafe_WeakBag$Entry__f_index;
      var entry = new $c_Lcats_effect_unsafe_WeakBag$Entry(a, oldIndex, this.Lcats_effect_unsafe_WeakBag__f_queue);
      $n(this.Lcats_effect_unsafe_WeakBag__f_table).set(oldIndex, entry);
      return entry;
    } else if ((idx < cap)) {
      var entry$2 = new $c_Lcats_effect_unsafe_WeakBag$Entry(a, idx, this.Lcats_effect_unsafe_WeakBag__f_queue);
      $n(this.Lcats_effect_unsafe_WeakBag__f_table).set(idx, entry$2);
      this.Lcats_effect_unsafe_WeakBag__f_index = ((1 + this.Lcats_effect_unsafe_WeakBag__f_index) | 0);
      return entry$2;
    } else {
      if ((cap === 2147483647)) {
        return new $c_Lcats_effect_unsafe_WeakBag$$anon$1(this);
      }
      var oldTable = this.Lcats_effect_unsafe_WeakBag__f_table;
      var newCap = ((cap === this.Lcats_effect_unsafe_WeakBag__f_MaxSizePow2) ? 2147483647 : (cap << 1));
      var dimensions = new $ac_I(new Int32Array([newCap]));
      var newTable = $asArrayOf_Lcats_effect_unsafe_WeakBag$Entry($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_WeakBag$Entry.getClassOf(), dimensions), 1);
      $systemArraycopyRefs($n(oldTable), 0, $n(newTable), 0, idx);
      this.Lcats_effect_unsafe_WeakBag__f_table = newTable;
      this.Lcats_effect_unsafe_WeakBag__f_capacity = newCap;
    }
  }
});
var $d_Lcats_effect_unsafe_WeakBag = new $TypeData().initClass($c_Lcats_effect_unsafe_WeakBag, "cats.effect.unsafe.WeakBag", ({
  Lcats_effect_unsafe_WeakBag: 1
}));
function $is_Lcats_effect_unsafe_WeakBag$Handle(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_unsafe_WeakBag$Handle)));
}
function $as_Lcats_effect_unsafe_WeakBag$Handle(obj) {
  return (($is_Lcats_effect_unsafe_WeakBag$Handle(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.WeakBag$Handle"));
}
function $isArrayOf_Lcats_effect_unsafe_WeakBag$Handle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WeakBag$Handle)));
}
function $asArrayOf_Lcats_effect_unsafe_WeakBag$Handle(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_WeakBag$Handle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.WeakBag$Handle;", depth));
}
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler(counter, clockDriftCurrent, clockDriftMax) {
}
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler.prototype = new $h_O();
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler.prototype.constructor = $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_CpuStarvationSampler() {
}
$h_Lcats_effect_unsafe_metrics_CpuStarvationSampler.prototype = $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler.prototype;
var $d_Lcats_effect_unsafe_metrics_CpuStarvationSampler = new $TypeData().initClass($c_Lcats_effect_unsafe_metrics_CpuStarvationSampler, "cats.effect.unsafe.metrics.CpuStarvationSampler", ({
  Lcats_effect_unsafe_metrics_CpuStarvationSampler: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$() {
}
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype = new $h_O();
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype.constructor = $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_CpuStarvationSampler$() {
}
$h_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype = $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype;
$c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$.prototype.apply__Lcats_effect_unsafe_metrics_CpuStarvationSampler = (function() {
  return new $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler(new $c_ju_concurrent_atomic_AtomicLong(0, 0), new $c_ju_concurrent_atomic_AtomicLong(0, 0), new $c_ju_concurrent_atomic_AtomicLong(0, 0));
});
var $d_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ = new $TypeData().initClass($c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$, "cats.effect.unsafe.metrics.CpuStarvationSampler$", ({
  Lcats_effect_unsafe_metrics_CpuStarvationSampler$: 1
}));
var $n_Lcats_effect_unsafe_metrics_CpuStarvationSampler$;
function $m_Lcats_effect_unsafe_metrics_CpuStarvationSampler$() {
  if ((!$n_Lcats_effect_unsafe_metrics_CpuStarvationSampler$)) {
    $n_Lcats_effect_unsafe_metrics_CpuStarvationSampler$ = new $c_Lcats_effect_unsafe_metrics_CpuStarvationSampler$();
  }
  return $n_Lcats_effect_unsafe_metrics_CpuStarvationSampler$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform() {
}
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform() {
}
$h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype = $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform.prototype.apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_metrics_IORuntimeMetrics = (function(ec) {
  return new $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1();
});
function $ct_Lcats_effect_unsafe_ref_Reference__O__Lcats_effect_unsafe_ref_ReferenceQueue__($thiz, referent, queue) {
  $thiz.Lcats_effect_unsafe_ref_Reference__f_queue = queue;
  new WeakRef(referent);
  $thiz.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
  if ((queue !== null)) {
    $n(queue).register__Lcats_effect_unsafe_ref_Reference__O__V($thiz, referent);
  }
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_unsafe_ref_Reference() {
  this.Lcats_effect_unsafe_ref_Reference__f_queue = null;
  this.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
}
$c_Lcats_effect_unsafe_ref_Reference.prototype = new $h_O();
$c_Lcats_effect_unsafe_ref_Reference.prototype.constructor = $c_Lcats_effect_unsafe_ref_Reference;
/** @constructor */
function $h_Lcats_effect_unsafe_ref_Reference() {
}
$h_Lcats_effect_unsafe_ref_Reference.prototype = $c_Lcats_effect_unsafe_ref_Reference.prototype;
$c_Lcats_effect_unsafe_ref_Reference.prototype.enqueue__Z = (function() {
  return (((this.Lcats_effect_unsafe_ref_Reference__f_queue !== null) && $n(this.Lcats_effect_unsafe_ref_Reference__f_queue).enqueue__Lcats_effect_unsafe_ref_Reference__Z(this)) && ($n(this.Lcats_effect_unsafe_ref_Reference__f_queue).unregister__Lcats_effect_unsafe_ref_Reference__V(this), true));
});
function $as_Lcats_effect_unsafe_ref_Reference(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_ref_Reference) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.ref.Reference"));
}
function $isArrayOf_Lcats_effect_unsafe_ref_Reference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_ref_Reference)));
}
function $asArrayOf_Lcats_effect_unsafe_ref_Reference(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_ref_Reference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.ref.Reference;", depth));
}
/** @constructor */
function $c_Lcats_effect_unsafe_ref_ReferenceQueue() {
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs = null;
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry = null;
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs = [];
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry = new FinalizationRegistry(((ref) => {
    var ref$1 = $as_Lcats_effect_unsafe_ref_Reference(ref);
    return this.enqueue__Lcats_effect_unsafe_ref_Reference__Z(ref$1);
  }));
}
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype = new $h_O();
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.constructor = $c_Lcats_effect_unsafe_ref_ReferenceQueue;
/** @constructor */
function $h_Lcats_effect_unsafe_ref_ReferenceQueue() {
}
$h_Lcats_effect_unsafe_ref_ReferenceQueue.prototype = $c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype;
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.register__Lcats_effect_unsafe_ref_Reference__O__V = (function(ref, referent) {
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry.register(referent, ref, ref);
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.unregister__Lcats_effect_unsafe_ref_Reference__V = (function(ref) {
  $uZ(this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry.unregister(ref));
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.enqueue__Lcats_effect_unsafe_ref_Reference__Z = (function(ref) {
  if ((!$n(ref).Lcats_effect_unsafe_ref_Reference__f_enqueued)) {
    $n(ref).Lcats_effect_unsafe_ref_Reference__f_enqueued = true;
    this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs.push(ref);
    return true;
  } else {
    return false;
  }
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.poll__Lcats_effect_unsafe_ref_Reference = (function() {
  return (($uI(this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs.length) === 0) ? null : $as_Lcats_effect_unsafe_ref_Reference(this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs.pop()));
});
var $d_Lcats_effect_unsafe_ref_ReferenceQueue = new $TypeData().initClass($c_Lcats_effect_unsafe_ref_ReferenceQueue, "cats.effect.unsafe.ref.ReferenceQueue", ({
  Lcats_effect_unsafe_ref_ReferenceQueue: 1
}));
function $f_Lcats_instances_InvariantInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V(new $c_Lcats_instances_InvariantInstances$$anon$10());
  $thiz.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V(new $c_Lcats_instances_InvariantInstances$$anon$12());
}
function $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$1());
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$4());
}
function $f_Lcats_instances_NTupleBifunctorInstances__catsStdBifunctorForTuple2__Lcats_Bifunctor($thiz) {
  var bim = new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((fab, f, g) => {
    var fab$1 = $as_T2(fab);
    var f$1 = $as_F1(f);
    var g$1 = $as_F1(g);
    $n(fab$1);
    var _1 = $n(f$1).apply__O__O($n(fab$1)._1__O());
    var _2 = $n(g$1).apply__O__O($n(fab$1)._2__O());
    return new $c_T2(_1, _2);
  }));
  return new $c_Lcats_instances_NTupleBifunctorInstances$$anon$1(bim);
}
/** @constructor */
function $c_Lcats_kernel_EqFunctions() {
}
$c_Lcats_kernel_EqFunctions.prototype = new $h_O();
$c_Lcats_kernel_EqFunctions.prototype.constructor = $c_Lcats_kernel_EqFunctions;
/** @constructor */
function $h_Lcats_kernel_EqFunctions() {
}
$h_Lcats_kernel_EqFunctions.prototype = $c_Lcats_kernel_EqFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_SemigroupFunctions() {
}
$c_Lcats_kernel_SemigroupFunctions.prototype = new $h_O();
$c_Lcats_kernel_SemigroupFunctions.prototype.constructor = $c_Lcats_kernel_SemigroupFunctions;
/** @constructor */
function $h_Lcats_kernel_SemigroupFunctions() {
}
$h_Lcats_kernel_SemigroupFunctions.prototype = $c_Lcats_kernel_SemigroupFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_compat_HashCompat() {
}
$c_Lcats_kernel_compat_HashCompat.prototype = new $h_O();
$c_Lcats_kernel_compat_HashCompat.prototype.constructor = $c_Lcats_kernel_compat_HashCompat;
/** @constructor */
function $h_Lcats_kernel_compat_HashCompat() {
}
$h_Lcats_kernel_compat_HashCompat.prototype = $c_Lcats_kernel_compat_HashCompat.prototype;
$c_Lcats_kernel_compat_HashCompat.prototype.orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I = (function(xs, A) {
  var it = $n(xs).iterator__sc_Iterator();
  var h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_seqSeed;
  if ((!$n(it).hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 0);
  }
  var x0 = $n(it).next__O();
  if ((!$n(it).hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, $n(A).hash__O__I(x0)), 1);
  }
  var x1 = $n(it).next__O();
  var initial = $n(A).hash__O__I(x0);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, initial);
  var h0 = h;
  var prev = $n(A).hash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while ($n(it).hasNext__Z()) {
    h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, prev);
    var hash = $n(A).hash__O__I($n(it).next__O());
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while ($n(it).hasNext__Z()) {
        h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, $n(A).hash__O__I($n(it).next__O()));
        i = ((1 + i) | 0);
      }
      return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, i);
    }
    prev = hash;
    i = ((1 + i) | 0);
  }
  return this.avalanche__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h0, rangeDiff), prev));
});
$c_Lcats_kernel_compat_HashCompat.prototype.avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
function $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BigDecimalOrder());
  $thiz.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigDecimalGroup());
}
function $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BigIntOrder());
  $thiz.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_BigIntGroup());
}
function $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_BitSetPartialOrder());
  $thiz.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_BitSetSemilattice());
}
function $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_ByteOrder());
  $thiz.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ByteGroup());
}
function $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_DoubleOrder());
  $thiz.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DoubleGroup());
}
function $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_DurationOrder());
  $thiz.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_DurationGroup());
}
function $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_FiniteDurationOrder());
  $thiz.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FiniteDurationGroup());
}
function $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_FloatOrder());
  $thiz.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_FloatGroup());
}
function $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_IntOrder());
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_IntGroup());
}
/** @constructor */
function $c_Lcats_kernel_instances_LazyListMonoid$() {
  this.Lcats_kernel_instances_LazyListMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_LazyListMonoid$ = this;
  this.Lcats_kernel_instances_LazyListMonoid$__f_singleton = new $c_Lcats_kernel_instances_LazyListMonoid();
}
$c_Lcats_kernel_instances_LazyListMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_LazyListMonoid$.prototype.constructor = $c_Lcats_kernel_instances_LazyListMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_LazyListMonoid$() {
}
$h_Lcats_kernel_instances_LazyListMonoid$.prototype = $c_Lcats_kernel_instances_LazyListMonoid$.prototype;
var $d_Lcats_kernel_instances_LazyListMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_LazyListMonoid$, "cats.kernel.instances.LazyListMonoid$", ({
  Lcats_kernel_instances_LazyListMonoid$: 1
}));
var $n_Lcats_kernel_instances_LazyListMonoid$;
function $m_Lcats_kernel_instances_LazyListMonoid$() {
  if ((!$n_Lcats_kernel_instances_LazyListMonoid$)) {
    $n_Lcats_kernel_instances_LazyListMonoid$ = new $c_Lcats_kernel_instances_LazyListMonoid$();
  }
  return $n_Lcats_kernel_instances_LazyListMonoid$;
}
/** @constructor */
function $c_Lcats_kernel_instances_ListMonoid$() {
  this.Lcats_kernel_instances_ListMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_ListMonoid$ = this;
  this.Lcats_kernel_instances_ListMonoid$__f_singleton = new $c_Lcats_kernel_instances_ListMonoid();
}
$c_Lcats_kernel_instances_ListMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_ListMonoid$.prototype.constructor = $c_Lcats_kernel_instances_ListMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_ListMonoid$() {
}
$h_Lcats_kernel_instances_ListMonoid$.prototype = $c_Lcats_kernel_instances_ListMonoid$.prototype;
var $d_Lcats_kernel_instances_ListMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_ListMonoid$, "cats.kernel.instances.ListMonoid$", ({
  Lcats_kernel_instances_ListMonoid$: 1
}));
var $n_Lcats_kernel_instances_ListMonoid$;
function $m_Lcats_kernel_instances_ListMonoid$() {
  if ((!$n_Lcats_kernel_instances_ListMonoid$)) {
    $n_Lcats_kernel_instances_ListMonoid$ = new $c_Lcats_kernel_instances_ListMonoid$();
  }
  return $n_Lcats_kernel_instances_ListMonoid$;
}
function $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_LongOrder());
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_LongGroup());
}
/** @constructor */
function $c_Lcats_kernel_instances_QueueMonoid$() {
  this.Lcats_kernel_instances_QueueMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_QueueMonoid$ = this;
  this.Lcats_kernel_instances_QueueMonoid$__f_singleton = new $c_Lcats_kernel_instances_QueueMonoid();
}
$c_Lcats_kernel_instances_QueueMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_QueueMonoid$.prototype.constructor = $c_Lcats_kernel_instances_QueueMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_QueueMonoid$() {
}
$h_Lcats_kernel_instances_QueueMonoid$.prototype = $c_Lcats_kernel_instances_QueueMonoid$.prototype;
var $d_Lcats_kernel_instances_QueueMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_QueueMonoid$, "cats.kernel.instances.QueueMonoid$", ({
  Lcats_kernel_instances_QueueMonoid$: 1
}));
var $n_Lcats_kernel_instances_QueueMonoid$;
function $m_Lcats_kernel_instances_QueueMonoid$() {
  if ((!$n_Lcats_kernel_instances_QueueMonoid$)) {
    $n_Lcats_kernel_instances_QueueMonoid$ = new $c_Lcats_kernel_instances_QueueMonoid$();
  }
  return $n_Lcats_kernel_instances_QueueMonoid$;
}
/** @constructor */
function $c_Lcats_kernel_instances_SeqMonoid$() {
  this.Lcats_kernel_instances_SeqMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_SeqMonoid$ = this;
  this.Lcats_kernel_instances_SeqMonoid$__f_singleton = new $c_Lcats_kernel_instances_SeqMonoid();
}
$c_Lcats_kernel_instances_SeqMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_SeqMonoid$.prototype.constructor = $c_Lcats_kernel_instances_SeqMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_SeqMonoid$() {
}
$h_Lcats_kernel_instances_SeqMonoid$.prototype = $c_Lcats_kernel_instances_SeqMonoid$.prototype;
var $d_Lcats_kernel_instances_SeqMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_SeqMonoid$, "cats.kernel.instances.SeqMonoid$", ({
  Lcats_kernel_instances_SeqMonoid$: 1
}));
var $n_Lcats_kernel_instances_SeqMonoid$;
function $m_Lcats_kernel_instances_SeqMonoid$() {
  if ((!$n_Lcats_kernel_instances_SeqMonoid$)) {
    $n_Lcats_kernel_instances_SeqMonoid$ = new $c_Lcats_kernel_instances_SeqMonoid$();
  }
  return $n_Lcats_kernel_instances_SeqMonoid$;
}
function $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_ShortOrder());
  $thiz.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_ShortGroup());
}
function $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_StringOrder());
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V(new $c_Lcats_kernel_instances_StringMonoid());
}
function $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_UnitOrder());
  $thiz.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V(new $c_Lcats_kernel_instances_UnitAlgebra());
}
/** @constructor */
function $c_Lcats_kernel_instances_VectorMonoid$() {
  this.Lcats_kernel_instances_VectorMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_VectorMonoid$ = this;
  this.Lcats_kernel_instances_VectorMonoid$__f_singleton = new $c_Lcats_kernel_instances_VectorMonoid();
}
$c_Lcats_kernel_instances_VectorMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_VectorMonoid$.prototype.constructor = $c_Lcats_kernel_instances_VectorMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_VectorMonoid$() {
}
$h_Lcats_kernel_instances_VectorMonoid$.prototype = $c_Lcats_kernel_instances_VectorMonoid$.prototype;
var $d_Lcats_kernel_instances_VectorMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_VectorMonoid$, "cats.kernel.instances.VectorMonoid$", ({
  Lcats_kernel_instances_VectorMonoid$: 1
}));
var $n_Lcats_kernel_instances_VectorMonoid$;
function $m_Lcats_kernel_instances_VectorMonoid$() {
  if ((!$n_Lcats_kernel_instances_VectorMonoid$)) {
    $n_Lcats_kernel_instances_VectorMonoid$ = new $c_Lcats_kernel_instances_VectorMonoid$();
  }
  return $n_Lcats_kernel_instances_VectorMonoid$;
}
/** @constructor */
function $c_Lcats_package$() {
  this.Lcats_package$__f_catsInstancesForId = null;
  this.Lcats_package$__f_Eq = null;
  this.Lcats_package$__f_PartialOrder = null;
  this.Lcats_package$__f_Order = null;
  this.Lcats_package$__f_Hash = null;
  this.Lcats_package$__f_Semigroup = null;
  $n_Lcats_package$ = this;
  this.Lcats_package$__f_catsInstancesForId = new $c_Lcats_package$$anon$1();
  new $c_Lcats_package$$anon$2();
  new $c_Lcats_package$$anon$3();
  var evidence$1 = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  new $c_Lcats_Parallel$$anon$2(evidence$1);
  this.Lcats_package$__f_Eq = $m_Lcats_kernel_Eq$();
  this.Lcats_package$__f_PartialOrder = $m_Lcats_kernel_PartialOrder$();
  this.Lcats_package$__f_Order = $m_Lcats_kernel_Order$();
  $m_Lcats_kernel_Comparison$();
  this.Lcats_package$__f_Hash = $m_Lcats_kernel_Hash$();
  this.Lcats_package$__f_Semigroup = $m_Lcats_kernel_Semigroup$();
}
$c_Lcats_package$.prototype = new $h_O();
$c_Lcats_package$.prototype.constructor = $c_Lcats_package$;
/** @constructor */
function $h_Lcats_package$() {
}
$h_Lcats_package$.prototype = $c_Lcats_package$.prototype;
var $d_Lcats_package$ = new $TypeData().initClass($c_Lcats_package$, "cats.package$", ({
  Lcats_package$: 1
}));
var $n_Lcats_package$;
function $m_Lcats_package$() {
  if ((!$n_Lcats_package$)) {
    $n_Lcats_package$ = new $c_Lcats_package$();
  }
  return $n_Lcats_package$;
}
/** @constructor */
function $c_Lcats_syntax_ApplicativeErrorOps$() {
}
$c_Lcats_syntax_ApplicativeErrorOps$.prototype = new $h_O();
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.constructor = $c_Lcats_syntax_ApplicativeErrorOps$;
/** @constructor */
function $h_Lcats_syntax_ApplicativeErrorOps$() {
}
$h_Lcats_syntax_ApplicativeErrorOps$.prototype = $c_Lcats_syntax_ApplicativeErrorOps$.prototype;
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.orElse$extension__O__F0__Lcats_ApplicativeError__O = (function(this$, other, F) {
  return $n(F).handleErrorWith__O__F1__O(this$, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$7) => $n(other).apply__O())));
});
var $d_Lcats_syntax_ApplicativeErrorOps$ = new $TypeData().initClass($c_Lcats_syntax_ApplicativeErrorOps$, "cats.syntax.ApplicativeErrorOps$", ({
  Lcats_syntax_ApplicativeErrorOps$: 1
}));
var $n_Lcats_syntax_ApplicativeErrorOps$;
function $m_Lcats_syntax_ApplicativeErrorOps$() {
  if ((!$n_Lcats_syntax_ApplicativeErrorOps$)) {
    $n_Lcats_syntax_ApplicativeErrorOps$ = new $c_Lcats_syntax_ApplicativeErrorOps$();
  }
  return $n_Lcats_syntax_ApplicativeErrorOps$;
}
/** @constructor */
function $c_Lcats_syntax_EitherUtil$() {
  this.Lcats_syntax_EitherUtil$__f_unit = null;
  $n_Lcats_syntax_EitherUtil$ = this;
  this.Lcats_syntax_EitherUtil$__f_unit = new $c_s_util_Right((void 0));
}
$c_Lcats_syntax_EitherUtil$.prototype = new $h_O();
$c_Lcats_syntax_EitherUtil$.prototype.constructor = $c_Lcats_syntax_EitherUtil$;
/** @constructor */
function $h_Lcats_syntax_EitherUtil$() {
}
$h_Lcats_syntax_EitherUtil$.prototype = $c_Lcats_syntax_EitherUtil$.prototype;
var $d_Lcats_syntax_EitherUtil$ = new $TypeData().initClass($c_Lcats_syntax_EitherUtil$, "cats.syntax.EitherUtil$", ({
  Lcats_syntax_EitherUtil$: 1
}));
var $n_Lcats_syntax_EitherUtil$;
function $m_Lcats_syntax_EitherUtil$() {
  if ((!$n_Lcats_syntax_EitherUtil$)) {
    $n_Lcats_syntax_EitherUtil$ = new $c_Lcats_syntax_EitherUtil$();
  }
  return $n_Lcats_syntax_EitherUtil$;
}
/** @constructor */
function $c_Lcats_syntax_EqOps(lhs, evidence$1) {
  this.Lcats_syntax_EqOps__f_lhs = null;
  this.Lcats_syntax_EqOps__f_evidence$1 = null;
  this.Lcats_syntax_EqOps__f_lhs = lhs;
  this.Lcats_syntax_EqOps__f_evidence$1 = evidence$1;
}
$c_Lcats_syntax_EqOps.prototype = new $h_O();
$c_Lcats_syntax_EqOps.prototype.constructor = $c_Lcats_syntax_EqOps;
/** @constructor */
function $h_Lcats_syntax_EqOps() {
}
$h_Lcats_syntax_EqOps.prototype = $c_Lcats_syntax_EqOps.prototype;
$c_Lcats_syntax_EqOps.prototype.$eq$eq$eq__O__Z = (function(rhs) {
  $n($m_Lcats_package$().Lcats_package$__f_Eq);
  var ev = this.Lcats_syntax_EqOps__f_evidence$1;
  return $n(ev).eqv__O__O__Z(this.Lcats_syntax_EqOps__f_lhs, rhs);
});
var $d_Lcats_syntax_EqOps = new $TypeData().initClass($c_Lcats_syntax_EqOps, "cats.syntax.EqOps", ({
  Lcats_syntax_EqOps: 1
}));
/** @constructor */
function $c_Lcats_syntax_FlatMapOps$() {
}
$c_Lcats_syntax_FlatMapOps$.prototype = new $h_O();
$c_Lcats_syntax_FlatMapOps$.prototype.constructor = $c_Lcats_syntax_FlatMapOps$;
/** @constructor */
function $h_Lcats_syntax_FlatMapOps$() {
}
$h_Lcats_syntax_FlatMapOps$.prototype = $c_Lcats_syntax_FlatMapOps$.prototype;
$c_Lcats_syntax_FlatMapOps$.prototype.$greater$greater$extension__O__F0__Lcats_FlatMap__O = (function(this$, fb, F) {
  return $n(F).flatMap__O__F1__O(this$, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => $n(fb).apply__O())));
});
var $d_Lcats_syntax_FlatMapOps$ = new $TypeData().initClass($c_Lcats_syntax_FlatMapOps$, "cats.syntax.FlatMapOps$", ({
  Lcats_syntax_FlatMapOps$: 1
}));
var $n_Lcats_syntax_FlatMapOps$;
function $m_Lcats_syntax_FlatMapOps$() {
  if ((!$n_Lcats_syntax_FlatMapOps$)) {
    $n_Lcats_syntax_FlatMapOps$ = new $c_Lcats_syntax_FlatMapOps$();
  }
  return $n_Lcats_syntax_FlatMapOps$;
}
/** @constructor */
function $c_Lcats_syntax_MonadErrorRethrowOps$() {
}
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype = new $h_O();
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype.constructor = $c_Lcats_syntax_MonadErrorRethrowOps$;
/** @constructor */
function $h_Lcats_syntax_MonadErrorRethrowOps$() {
}
$h_Lcats_syntax_MonadErrorRethrowOps$.prototype = $c_Lcats_syntax_MonadErrorRethrowOps$.prototype;
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype.rethrow$extension__O__Lcats_MonadError__O = (function(this$, F) {
  return $n(F).flatMap__O__F1__O(this$, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
    var _$5$1 = $as_s_util_Either(_$5);
    var this$1 = $n(_$5$1);
    if ((this$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$1);
      var b = $n(x2).s_util_Right__f_value;
      return $n(F).pure__O__O(b);
    } else if ((this$1 instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(this$1);
      var a = $n(x3).s_util_Left__f_value;
      return $n(F).raiseError__O__O(a);
    } else {
      throw new $c_s_MatchError(this$1);
    }
  })));
});
var $d_Lcats_syntax_MonadErrorRethrowOps$ = new $TypeData().initClass($c_Lcats_syntax_MonadErrorRethrowOps$, "cats.syntax.MonadErrorRethrowOps$", ({
  Lcats_syntax_MonadErrorRethrowOps$: 1
}));
var $n_Lcats_syntax_MonadErrorRethrowOps$;
function $m_Lcats_syntax_MonadErrorRethrowOps$() {
  if ((!$n_Lcats_syntax_MonadErrorRethrowOps$)) {
    $n_Lcats_syntax_MonadErrorRethrowOps$ = new $c_Lcats_syntax_MonadErrorRethrowOps$();
  }
  return $n_Lcats_syntax_MonadErrorRethrowOps$;
}
/** @constructor */
function $c_Lcats_syntax_OrderOps(lhs, evidence$1) {
  this.Lcats_syntax_OrderOps__f_lhs = null;
  this.Lcats_syntax_OrderOps__f_evidence$1 = null;
  this.Lcats_syntax_OrderOps__f_lhs = lhs;
  this.Lcats_syntax_OrderOps__f_evidence$1 = evidence$1;
}
$c_Lcats_syntax_OrderOps.prototype = new $h_O();
$c_Lcats_syntax_OrderOps.prototype.constructor = $c_Lcats_syntax_OrderOps;
/** @constructor */
function $h_Lcats_syntax_OrderOps() {
}
$h_Lcats_syntax_OrderOps.prototype = $c_Lcats_syntax_OrderOps.prototype;
$c_Lcats_syntax_OrderOps.prototype.min__O__O = (function(rhs) {
  $n($m_Lcats_package$().Lcats_package$__f_Order);
  var ev = this.Lcats_syntax_OrderOps__f_evidence$1;
  return $n(ev).min__O__O__O(this.Lcats_syntax_OrderOps__f_lhs, rhs);
});
var $d_Lcats_syntax_OrderOps = new $TypeData().initClass($c_Lcats_syntax_OrderOps, "cats.syntax.OrderOps", ({
  Lcats_syntax_OrderOps: 1
}));
function $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target($thiz, F) {
  if ($is_Lcats_effect_kernel_Async(F)) {
    var async = $as_Lcats_effect_kernel_Async(F);
    return new $c_Lfs2_Compiler$Target$ConcurrentTarget(async);
  } else {
    return new $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(F);
  }
}
/** @constructor */
function $c_Lfs2_Pull() {
}
$c_Lfs2_Pull.prototype = new $h_O();
$c_Lfs2_Pull.prototype.constructor = $c_Lfs2_Pull;
/** @constructor */
function $h_Lfs2_Pull() {
}
$h_Lfs2_Pull.prototype = $c_Lfs2_Pull.prototype;
function $as_Lfs2_Pull(obj) {
  return (((obj instanceof $c_Lfs2_Pull) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull"));
}
function $isArrayOf_Lfs2_Pull(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull)));
}
function $asArrayOf_Lfs2_Pull(obj, depth) {
  return (($isArrayOf_Lfs2_Pull(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$IdOps$() {
}
$c_Lfs2_Pull$IdOps$.prototype = new $h_O();
$c_Lfs2_Pull$IdOps$.prototype.constructor = $c_Lfs2_Pull$IdOps$;
/** @constructor */
function $h_Lfs2_Pull$IdOps$() {
}
$h_Lfs2_Pull$IdOps$.prototype = $c_Lfs2_Pull$IdOps$.prototype;
$c_Lfs2_Pull$IdOps$.prototype.covaryId$extension__Lfs2_Pull__Lcats_Applicative__Lfs2_Pull = (function(this$, evidence$1) {
  return $m_Lfs2_Pull$().translate__Lfs2_Pull__Lcats_arrow_FunctionK__Lfs2_Pull(this$, new $c_Lfs2_Pull$IdOps$$anon$10(evidence$1));
});
var $d_Lfs2_Pull$IdOps$ = new $TypeData().initClass($c_Lfs2_Pull$IdOps$, "fs2.Pull$IdOps$", ({
  Lfs2_Pull$IdOps$: 1
}));
var $n_Lfs2_Pull$IdOps$;
function $m_Lfs2_Pull$IdOps$() {
  if ((!$n_Lfs2_Pull$IdOps$)) {
    $n_Lfs2_Pull$IdOps$ = new $c_Lfs2_Pull$IdOps$();
  }
  return $n_Lfs2_Pull$IdOps$;
}
function $is_Lfs2_Pull$Run$1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_Pull$Run$1)));
}
function $as_Lfs2_Pull$Run$1(obj) {
  return (($is_Lfs2_Pull$Run$1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Run$1"));
}
function $isArrayOf_Lfs2_Pull$Run$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Run$1)));
}
function $asArrayOf_Lfs2_Pull$Run$1(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Run$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Run$1;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$StreamPullOps$() {
}
$c_Lfs2_Pull$StreamPullOps$.prototype = new $h_O();
$c_Lfs2_Pull$StreamPullOps$.prototype.constructor = $c_Lfs2_Pull$StreamPullOps$;
/** @constructor */
function $h_Lfs2_Pull$StreamPullOps$() {
}
$h_Lfs2_Pull$StreamPullOps$.prototype = $c_Lfs2_Pull$StreamPullOps$.prototype;
$c_Lfs2_Pull$StreamPullOps$.prototype.flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull = (function(this$, f) {
  if ((this$ instanceof $c_Lfs2_Pull$AlgEffect)) {
    var a = $as_Lfs2_Pull$AlgEffect(this$);
    var $x_1 = a;
  } else if ((this$ instanceof $c_Lfs2_Pull$Terminal)) {
    var r = $as_Lfs2_Pull$Terminal(this$);
    var $x_1 = r;
  } else {
    var $x_1 = new $c_Lfs2_Pull$FlatMapOutput(this$, f);
  }
  return $as_Lfs2_Pull($x_1);
});
$c_Lfs2_Pull$StreamPullOps$.prototype.unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull = (function(this$, f) {
  var this$3 = $n(this.uncons$extension__Lfs2_Pull__Lfs2_Pull(this$));
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return $m_Lfs2_Pull$().Lfs2_Pull$__f_done;
    }
    if ((x$1$1 instanceof $c_s_Some)) {
      var x35 = $as_T2($n($as_s_Some(x$1$1)).s_Some__f_value);
      if ((x35 !== null)) {
        var hd = $as_Lfs2_Chunk($n(x35)._1__O());
        var tl = $as_Lfs2_Pull($n(x35)._2__O());
        var this$2 = $n($as_Lfs2_Pull($n(f).apply__O__O(hd)));
        var post = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_Lfs2_Pull$StreamPullOps$().unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull(($m_Lfs2_Pull$(), tl), f)));
        return new $c_Lfs2_Pull$$anon$2(post, this$2);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return new $c_Lfs2_Pull$$anon$1(f$1, this$3);
});
$c_Lfs2_Pull$StreamPullOps$.prototype.uncons$extension__Lfs2_Pull__Lfs2_Pull = (function(this$) {
  if ((this$ instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$1 = $as_Lfs2_Pull$Succeeded(this$);
    var this$2 = $n(x$1);
    $as_jl_Void(this$2.Lfs2_Pull$Succeeded__f_r);
    var r = $m_s_None$();
    var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
  } else if ((this$ instanceof $c_Lfs2_Pull$Output)) {
    var x$1$1 = $as_Lfs2_Pull$Output(this$);
    var this$5 = $n(x$1$1);
    var x43 = this$5.Lfs2_Pull$Output__f_values;
    var y = $m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit;
    var value = new $c_T2(x43, y);
    var r$1 = new $c_s_Some(value);
    var $x_1 = new $c_Lfs2_Pull$Succeeded(r$1);
  } else if ((this$ instanceof $c_Lfs2_Pull$Fail)) {
    var ff = $as_Lfs2_Pull$Fail(this$);
    var $x_1 = ff;
  } else if ((this$ instanceof $c_Lfs2_Pull$Interrupted)) {
    var it = $as_Lfs2_Pull$Interrupted(this$);
    var $x_1 = it;
  } else {
    var $x_1 = new $c_Lfs2_Pull$Uncons(this$);
  }
  return $as_Lfs2_Pull($x_1);
});
var $d_Lfs2_Pull$StreamPullOps$ = new $TypeData().initClass($c_Lfs2_Pull$StreamPullOps$, "fs2.Pull$StreamPullOps$", ({
  Lfs2_Pull$StreamPullOps$: 1
}));
var $n_Lfs2_Pull$StreamPullOps$;
function $m_Lfs2_Pull$StreamPullOps$() {
  if ((!$n_Lfs2_Pull$StreamPullOps$)) {
    $n_Lfs2_Pull$StreamPullOps$ = new $c_Lfs2_Pull$StreamPullOps$();
  }
  return $n_Lfs2_Pull$StreamPullOps$;
}
/** @constructor */
function $c_Lfs2_Stream(underlying) {
  this.Lfs2_Stream__f_underlying = null;
  this.Lfs2_Stream__f_underlying = underlying;
}
$c_Lfs2_Stream.prototype = new $h_O();
$c_Lfs2_Stream.prototype.constructor = $c_Lfs2_Stream;
/** @constructor */
function $h_Lfs2_Stream() {
}
$h_Lfs2_Stream.prototype = $c_Lfs2_Stream.prototype;
$c_Lfs2_Stream.prototype.$plus$plus__F0__Lfs2_Stream = (function(s2) {
  $m_Lfs2_Pull$();
  var this$1 = $n(this.Lfs2_Stream__f_underlying);
  var post = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n($as_Lfs2_Stream($n(s2).apply__O())).Lfs2_Stream__f_underlying));
  var self = new $c_Lfs2_Pull$$anon$2(post, this$1);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.attempt__Lfs2_Stream = (function() {
  return $n(this.map__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => new $c_s_util_Right(_$3))))).handleErrorWith__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => {
    var e$1 = $as_jl_Throwable(e);
    return $m_Lfs2_Stream$().emit__O__Lfs2_Stream(new $c_s_util_Left(e$1));
  })));
});
$c_Lfs2_Stream.prototype.foreach__F1__Lfs2_Stream = (function(f) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var self = this.Lfs2_Stream__f_underlying;
  var self$1 = $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((o) => {
    $m_Lfs2_Pull$();
    var fr = $n(f).apply__O__O(o);
    return new $c_Lfs2_Pull$Eval(fr);
  })));
  return new $c_Lfs2_Stream(self$1);
});
$c_Lfs2_Stream.prototype.handleErrorWith__F1__Lfs2_Stream = (function(h) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var s = this.Lfs2_Stream__f_underlying;
  var this$3 = new $c_Lfs2_Pull$InScope(s, false);
  var handler = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => {
    var e$1 = $as_jl_Throwable(e);
    return $n($as_Lfs2_Stream($n(h).apply__O__O(e$1))).Lfs2_Stream__f_underlying;
  }));
  var self = new $c_Lfs2_Pull$$anon$3(handler, this$3);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.map__F1__Lfs2_Stream = (function(f) {
  $m_Lfs2_Pull$();
  var self = $m_Lfs2_Pull$().mapOutput__Lfs2_Stream__F1__Lfs2_Pull(this, f);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream.prototype.repeat__Lfs2_Stream = (function() {
  return this.$plus$plus__F0__Lfs2_Stream(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.repeat__Lfs2_Stream())));
});
$c_Lfs2_Stream.prototype.toString__T = (function() {
  return "Stream(..)";
});
function $as_Lfs2_Stream(obj) {
  return (((obj instanceof $c_Lfs2_Stream) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Stream"));
}
function $isArrayOf_Lfs2_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Stream)));
}
function $asArrayOf_Lfs2_Stream(obj, depth) {
  return (($isArrayOf_Lfs2_Stream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Stream;", depth));
}
var $d_Lfs2_Stream = new $TypeData().initClass($c_Lfs2_Stream, "fs2.Stream", ({
  Lfs2_Stream: 1
}));
/** @constructor */
function $c_Lfs2_Stream$CompileOps(underlying, compiler) {
  this.Lfs2_Stream$CompileOps__f_underlying = null;
  this.Lfs2_Stream$CompileOps__f_compiler = null;
  this.Lfs2_Stream$CompileOps__f_underlying = underlying;
  this.Lfs2_Stream$CompileOps__f_compiler = compiler;
}
$c_Lfs2_Stream$CompileOps.prototype = new $h_O();
$c_Lfs2_Stream$CompileOps.prototype.constructor = $c_Lfs2_Stream$CompileOps;
/** @constructor */
function $h_Lfs2_Stream$CompileOps() {
}
$h_Lfs2_Stream$CompileOps.prototype = $c_Lfs2_Stream$CompileOps.prototype;
$c_Lfs2_Stream$CompileOps.prototype.drain__O = (function() {
  return this.foldChunks__O__F2__O((void 0), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$216, _$217) => {
    $as_jl_Void(_$216);
    $as_Lfs2_Chunk(_$217);
  })));
});
$c_Lfs2_Stream$CompileOps.prototype.foldChunks__O__F2__O = (function(init, f) {
  return $n(this.Lfs2_Stream$CompileOps__f_compiler).apply__Lfs2_Pull__O__F2__O(this.Lfs2_Stream$CompileOps__f_underlying, init, f);
});
var $d_Lfs2_Stream$CompileOps = new $TypeData().initClass($c_Lfs2_Stream$CompileOps, "fs2.Stream$CompileOps", ({
  Lfs2_Stream$CompileOps: 1
}));
/** @constructor */
function $c_Lfs2_Stream$StepLeg(head, scopeId, next) {
}
$c_Lfs2_Stream$StepLeg.prototype = new $h_O();
$c_Lfs2_Stream$StepLeg.prototype.constructor = $c_Lfs2_Stream$StepLeg;
/** @constructor */
function $h_Lfs2_Stream$StepLeg() {
}
$h_Lfs2_Stream$StepLeg.prototype = $c_Lfs2_Stream$StepLeg.prototype;
var $d_Lfs2_Stream$StepLeg = new $TypeData().initClass($c_Lfs2_Stream$StepLeg, "fs2.Stream$StepLeg", ({
  Lfs2_Stream$StepLeg: 1
}));
/** @constructor */
function $c_Lfs2_Stream$ToPull(self) {
  this.Lfs2_Stream$ToPull__f_self = null;
  this.Lfs2_Stream$ToPull__f_self = self;
}
$c_Lfs2_Stream$ToPull.prototype = new $h_O();
$c_Lfs2_Stream$ToPull.prototype.constructor = $c_Lfs2_Stream$ToPull;
/** @constructor */
function $h_Lfs2_Stream$ToPull() {
}
$h_Lfs2_Stream$ToPull.prototype = $c_Lfs2_Stream$ToPull.prototype;
$c_Lfs2_Stream$ToPull.prototype.hashCode__I = (function() {
  var this$ = this.Lfs2_Stream$ToPull__f_self;
  var this$2 = $n(this$);
  return $systemIdentityHashCode(this$2);
});
$c_Lfs2_Stream$ToPull.prototype.equals__O__Z = (function(x$0) {
  return $m_Lfs2_Stream$ToPull$().equals$extension__Lfs2_Stream__O__Z(this.Lfs2_Stream$ToPull__f_self, x$0);
});
function $as_Lfs2_Stream$ToPull(obj) {
  return (((obj instanceof $c_Lfs2_Stream$ToPull) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Stream$ToPull"));
}
function $isArrayOf_Lfs2_Stream$ToPull(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Stream$ToPull)));
}
function $asArrayOf_Lfs2_Stream$ToPull(obj, depth) {
  return (($isArrayOf_Lfs2_Stream$ToPull(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Stream$ToPull;", depth));
}
var $d_Lfs2_Stream$ToPull = new $TypeData().initClass($c_Lfs2_Stream$ToPull, "fs2.Stream$ToPull", ({
  Lfs2_Stream$ToPull: 1
}));
/** @constructor */
function $c_Lfs2_Stream$ToPull$() {
}
$c_Lfs2_Stream$ToPull$.prototype = new $h_O();
$c_Lfs2_Stream$ToPull$.prototype.constructor = $c_Lfs2_Stream$ToPull$;
/** @constructor */
function $h_Lfs2_Stream$ToPull$() {
}
$h_Lfs2_Stream$ToPull$.prototype = $c_Lfs2_Stream$ToPull$.prototype;
$c_Lfs2_Stream$ToPull$.prototype.equals$extension__Lfs2_Stream__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lfs2_Stream$ToPull)) {
    var x$0$2 = ((x$0 === null) ? null : $n($as_Lfs2_Stream$ToPull(x$0)).Lfs2_Stream$ToPull__f_self);
    if ((this$ === null)) {
      return (x$0$2 === null);
    } else {
      var this$1 = $n(this$);
      return (this$1 === x$0$2);
    }
  } else {
    return false;
  }
});
var $d_Lfs2_Stream$ToPull$ = new $TypeData().initClass($c_Lfs2_Stream$ToPull$, "fs2.Stream$ToPull$", ({
  Lfs2_Stream$ToPull$: 1
}));
var $n_Lfs2_Stream$ToPull$;
function $m_Lfs2_Stream$ToPull$() {
  if ((!$n_Lfs2_Stream$ToPull$)) {
    $n_Lfs2_Stream$ToPull$ = new $c_Lfs2_Stream$ToPull$();
  }
  return $n_Lfs2_Stream$ToPull$;
}
/** @constructor */
function $c_Lfs2_internal_InterruptContext$() {
}
$c_Lfs2_internal_InterruptContext$.prototype = new $h_O();
$c_Lfs2_internal_InterruptContext$.prototype.constructor = $c_Lfs2_internal_InterruptContext$;
/** @constructor */
function $h_Lfs2_internal_InterruptContext$() {
}
$h_Lfs2_internal_InterruptContext$.prototype = $c_Lfs2_internal_InterruptContext$.prototype;
$c_Lfs2_internal_InterruptContext$.prototype.apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O = (function(newScopeId, cancelParent, F) {
  var target = $n(F).ref__O__O($m_s_None$());
  var this$5 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ref) => {
    var ref$1 = $as_Lcats_effect_kernel_Ref(ref);
    var target$1 = $n(F).deferred__O();
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((deferred) => {
      var deferred$1 = $as_Lcats_effect_kernel_Deferred(deferred);
      return new $c_Lfs2_internal_InterruptContext(deferred$1, ref$1, newScopeId, cancelParent, F);
    }));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return $n(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
});
var $d_Lfs2_internal_InterruptContext$ = new $TypeData().initClass($c_Lfs2_internal_InterruptContext$, "fs2.internal.InterruptContext$", ({
  Lfs2_internal_InterruptContext$: 1
}));
var $n_Lfs2_internal_InterruptContext$;
function $m_Lfs2_internal_InterruptContext$() {
  if ((!$n_Lfs2_internal_InterruptContext$)) {
    $n_Lfs2_internal_InterruptContext$ = new $c_Lfs2_internal_InterruptContext$();
  }
  return $n_Lfs2_internal_InterruptContext$;
}
function $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O($thiz, resource) {
  return $n($thiz.Lfs2_internal_Scope__f_state).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
      $n(s);
      var this$1 = $n($n(s).Lfs2_internal_Scope$State$Open__f_resources);
      var resources = this$1.prepend__O__Lcats_data_Chain(resource);
      var this$2 = $n(s);
      var children = this$2.Lfs2_internal_Scope$State$Open__f_children;
      var _1 = new $c_Lfs2_internal_Scope$State$Open(resources, children);
      return new $c_T2(_1, true);
    }
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var s$2 = $as_Lfs2_internal_Scope$State$Closed(x$1$1);
      return new $c_T2(s$2, false);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O($thiz, id) {
  return $n($thiz.Lfs2_internal_Scope__f_state).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
      return $n(s).unregisterChild__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope$State(id);
    }
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var s$2 = $as_Lfs2_internal_Scope$State$Closed(x$1$1);
      return s$2;
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $p_Lfs2_internal_Scope__close___Lcats_effect_kernel_Resource$ExitCase__O($thiz, ec) {
  var target = $n($thiz.Lfs2_internal_Scope__f_state).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => {
    var s$1 = $as_Lfs2_internal_Scope$State(s);
    var self = $m_Lfs2_internal_Scope$State$().Lfs2_internal_Scope$State$__f_closed_;
    return new $c_T2(self, s$1);
  })));
  var tc = $thiz.Lfs2_internal_Scope__f_F;
  var this$20 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var previous = $as_Lfs2_internal_Scope$State$Open(x$1$1);
      var target$1 = $thiz.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O($n(previous).Lfs2_internal_Scope$State$Open__f_children, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
        var _$5$1 = $as_Lfs2_internal_Scope(_$5);
        return $p_Lfs2_internal_Scope__close___Lcats_effect_kernel_Resource$ExitCase__O($n(_$5$1), ec);
      })));
      var tc$1 = $thiz.Lfs2_internal_Scope__f_F;
      var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
      var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((resultChildren) => {
        var resultChildren$1 = $as_s_util_Either(resultChildren);
        var target$2 = $thiz.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O($n(previous).Lfs2_internal_Scope$State$Open__f_resources, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => {
          var _$6$1 = $as_Lfs2_internal_ScopedResource(_$6);
          return $n(_$6$1).release__Lcats_effect_kernel_Resource$ExitCase__O(ec);
        })));
        var tc$2 = $thiz.Lfs2_internal_Scope__f_F;
        var this$16 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
        var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((resultResources) => {
          var resultResources$1 = $as_s_util_Either(resultResources);
          var this$7 = $n($thiz.Lfs2_internal_Scope__f_interruptible);
          if (this$7.isEmpty__Z()) {
            var this$8 = $m_s_None$();
          } else {
            var x0 = this$7.get__O();
            var _$7 = $as_Lfs2_internal_InterruptContext(x0);
            var this$8 = new $c_s_Some($n(_$7).Lfs2_internal_InterruptContext__f_cancelParent);
          }
          if (this$8.isEmpty__Z()) {
            var this$9 = $n($thiz.Lfs2_internal_Scope__f_F);
            var target$3 = $n(this$9.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
          } else {
            var target$3 = this$8.get__O();
          }
          var tc$3 = $thiz.Lfs2_internal_Scope__f_F;
          var this$15 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$3);
          var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
            $as_jl_Void(x$1$2);
            var this$11 = $n($thiz.Lfs2_internal_Scope__f_parent);
            if (this$11.isEmpty__Z()) {
              var this$12 = $n($thiz.Lfs2_internal_Scope__f_F);
              var target$4 = $n(this$12.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
            } else {
              var x0$1 = this$11.get__O();
              var _$8 = $as_Lfs2_internal_Scope(x0$1);
              var target$4 = $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O($n(_$8), $thiz.Lfs2_internal_Scope__f_id);
            }
            var tc$4 = $thiz.Lfs2_internal_Scope__f_F;
            var this$14 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$4);
            var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$1) => {
              $as_jl_Void(x$1$2$1);
              return $m_Lfs2_CompositeFailure$().fromResults__s_util_Either__s_util_Either__s_util_Either(resultChildren$1, resultResources$1);
            }));
            return $n(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
          }));
          return $n(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        }));
        return $n(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }));
      return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
    }
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var this$19 = $n($thiz.Lfs2_internal_Scope__f_F);
      var a = new $c_s_util_Right((void 0));
      return $n(this$19.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
}
function $p_Lfs2_internal_Scope__openScope__O($thiz) {
  var target = $n($thiz.Lfs2_internal_Scope__f_state).get__O();
  var tc = $thiz.Lfs2_internal_Scope__f_F;
  var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var this$3 = $n($thiz.Lfs2_internal_Scope__f_F);
      return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O($thiz);
    }
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      return $thiz.openAncestor__O();
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
}
function $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($thiz, scopeId) {
  var x = $thiz.Lfs2_internal_Scope__f_id;
  if ((x === null)) {
    var $x_1 = (scopeId === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === scopeId);
  }
  if ($x_1) {
    var this$3 = $n($thiz.Lfs2_internal_Scope__f_F);
    var a = new $c_s_Some($thiz);
    return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  } else {
    var target = $n($thiz.Lfs2_internal_Scope__f_state).get__O();
    var tc = $thiz.Lfs2_internal_Scope__f_F;
    var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
        return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId, $n(s).Lfs2_internal_Scope$State$Open__f_children);
      }
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        var this$6 = $n($thiz.Lfs2_internal_Scope__f_F);
        var a$1 = $m_s_None$();
        return $n(this$6.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
}
function $ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I(scope, acc) {
  var acc$tailLocal1 = acc;
  var scope$tailLocal1 = scope;
  while (true) {
    var x1 = $n(scope$tailLocal1).Lfs2_internal_Scope__f_parent;
    var x = $m_s_None$();
    if ((x === x1)) {
      return acc$tailLocal1;
    }
    if ((x1 instanceof $c_s_Some)) {
      var s = $as_Lfs2_internal_Scope($n($as_s_Some(x1)).s_Some__f_value);
      var acc$tailLocal1$tmp1 = ((1 + acc$tailLocal1) | 0);
      scope$tailLocal1 = s;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
      continue;
    }
    throw new $c_s_MatchError(x1);
  }
}
function $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId$1, curr) {
  var curr$tailLocal2 = curr;
  while (true) {
    var x = $n(curr$tailLocal2).Lfs2_internal_Scope__f_id;
    if ((x === null)) {
      var $x_1 = (scopeId$1 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === scopeId$1);
    }
    if ($x_1) {
      var value = curr$tailLocal2;
      return new $c_s_Some(value);
    } else {
      var x68 = $n(curr$tailLocal2).Lfs2_internal_Scope__f_parent;
      if ((x68 instanceof $c_s_Some)) {
        var scope = $as_Lfs2_internal_Scope($n($as_s_Some(x68)).s_Some__f_value);
        curr$tailLocal2 = scope;
        continue;
      }
      var x$3 = $m_s_None$();
      if ((x$3 === x68)) {
        return $m_s_None$();
      }
      throw new $c_s_MatchError(x68);
    }
  }
}
function $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, scopes) {
  var x77 = $n(scopes).uncons__s_Option();
  var x = $m_s_None$();
  if ((x === x77)) {
    var this$1 = $n($thiz.Lfs2_internal_Scope__f_F);
    var a = $m_s_None$();
    return $n(this$1.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  }
  if ((x77 instanceof $c_s_Some)) {
    var x79 = $as_T2($n($as_s_Some(x77)).s_Some__f_value);
    if ((x79 !== null)) {
      var scope = $as_Lfs2_internal_Scope($n(x79)._1__O());
      var tail = $as_Lcats_data_Chain($n(x79)._2__O());
      var x$3 = $n(scope).Lfs2_internal_Scope__f_id;
      if ((x$3 === null)) {
        var $x_1 = (scopeId$3 === null);
      } else {
        var this$2 = $n(x$3);
        var $x_1 = (this$2 === scopeId$3);
      }
      if ($x_1) {
        var this$4 = $n($thiz.Lfs2_internal_Scope__f_F);
        var a$1 = new $c_s_Some(scope);
        return $n(this$4.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
      } else {
        var target = $n($n(scope).Lfs2_internal_Scope__f_state).get__O();
        var tc = $thiz.Lfs2_internal_Scope__f_F;
        var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
        var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
          var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
          if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
            var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
            if ($n($n(s).Lfs2_internal_Scope$State$Open__f_children).isEmpty__Z()) {
              return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, tail);
            } else {
              var target$1 = $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, $n(s).Lfs2_internal_Scope$State$Open__f_children);
              var tc$1 = $thiz.Lfs2_internal_Scope__f_F;
              var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
              var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
                var x$1$3 = $as_s_Option(x$1$2);
                var x$2 = $m_s_None$();
                if ((x$2 === x$1$3)) {
                  return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, tail);
                }
                if ((x$1$3 instanceof $c_s_Some)) {
                  var scope$1 = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$3)).s_Some__f_value);
                  var this$9 = $n($thiz.Lfs2_internal_Scope__f_F);
                  var a$2 = new $c_s_Some(scope$1);
                  return $n(this$9.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$2);
                }
                throw new $c_s_MatchError(x$1$3);
              }));
              return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
            }
          }
          if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
            return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, tail);
          }
          throw new $c_s_MatchError(x$1$1);
        }));
        return $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
      }
    }
  }
  throw new $c_s_MatchError(x77);
}
function $ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope(scope) {
  var scope$tailLocal2 = scope;
  while (true) {
    var x88 = $n(scope$tailLocal2).Lfs2_internal_Scope__f_parent;
    var x = $m_s_None$();
    if ((x === x88)) {
      return scope$tailLocal2;
    }
    if ((x88 instanceof $c_s_Some)) {
      var parent = $as_Lfs2_internal_Scope($n($as_s_Some(x88)).s_Some__f_value);
      scope$tailLocal2 = parent;
      continue;
    }
    throw new $c_s_MatchError(x88);
  }
}
/** @constructor */
function $c_Lfs2_internal_Scope(id, parent, interruptible, state, F) {
  this.Lfs2_internal_Scope__f_id = null;
  this.Lfs2_internal_Scope__f_parent = null;
  this.Lfs2_internal_Scope__f_interruptible = null;
  this.Lfs2_internal_Scope__f_state = null;
  this.Lfs2_internal_Scope__f_F = null;
  this.Lfs2_internal_Scope__f_id = id;
  this.Lfs2_internal_Scope__f_parent = parent;
  this.Lfs2_internal_Scope__f_interruptible = interruptible;
  this.Lfs2_internal_Scope__f_state = state;
  this.Lfs2_internal_Scope__f_F = F;
}
$c_Lfs2_internal_Scope.prototype = new $h_O();
$c_Lfs2_internal_Scope.prototype.constructor = $c_Lfs2_internal_Scope;
/** @constructor */
function $h_Lfs2_internal_Scope() {
}
$h_Lfs2_internal_Scope.prototype = $c_Lfs2_internal_Scope.prototype;
$c_Lfs2_internal_Scope.prototype.open__Z__O = (function(interruptible) {
  var target = $n(this.Lfs2_internal_Scope__f_F).unique__O();
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((newScopeId) => {
    var newScopeId$1 = $as_Lcats_effect_kernel_Unique$Token(newScopeId);
    var x7 = this.Lfs2_internal_Scope__f_interruptible;
    var x = $m_s_None$();
    if ((x === x7)) {
      var optFCtx = (interruptible ? $n(this.Lfs2_internal_Scope__f_F).interruptContext__Lcats_effect_kernel_Unique$Token__s_Option(newScopeId$1) : $m_s_None$());
      $m_Lcats_UnorderedFoldable$();
      var tc$1 = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
      var this$6 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(optFCtx, tc$1);
      var ev$2 = this.Lfs2_internal_Scope__f_F;
      var target$1 = $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O($n(this$6.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance), this$6.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, ev$2);
      var tc$2 = this.Lfs2_internal_Scope__f_F;
      var this$9 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$2);
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((iCtx) => {
        var iCtx$1 = $as_s_Option(iCtx);
        return $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(newScopeId$1, new $c_s_Some(this), iCtx$1, this.Lfs2_internal_Scope__f_F);
      }));
      return $n(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    }
    if ((x7 instanceof $c_s_Some)) {
      var parentICtx = $as_Lfs2_internal_InterruptContext($n($as_s_Some(x7)).s_Some__f_value);
      var target$2 = $n(parentICtx).childContext__Z__Lcats_effect_kernel_Unique$Token__O(interruptible, newScopeId$1);
      var tc$3 = this.Lfs2_internal_Scope__f_F;
      var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$3);
      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((iCtx$2) => {
        var iCtx$3 = $as_Lfs2_internal_InterruptContext(iCtx$2);
        return $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(newScopeId$1, new $c_s_Some(this), new $c_s_Some(iCtx$3), this.Lfs2_internal_Scope__f_F);
      }));
      return $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    }
    throw new $c_s_MatchError(x7);
  }));
  var createScope = $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  var tc$4 = this.Lfs2_internal_Scope__f_F;
  var this$32 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(createScope, tc$4);
  var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((scope) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var target$3 = $n(this.Lfs2_internal_Scope__f_state).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        var s = $as_Lfs2_internal_Scope$State$Closed(x$1$1);
        var _2 = $m_s_None$();
        return new $c_T2(s, _2);
      }
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var s$2 = $as_Lfs2_internal_Scope$State$Open(x$1$1);
        var this$17 = $n($n(s$2).Lfs2_internal_Scope$State$Open__f_children);
        var children$1 = this$17.prepend__O__Lcats_data_Chain(scope$1);
        var this$18 = $n(s$2);
        var resources$1 = this$18.Lfs2_internal_Scope$State$Open__f_resources;
        $n(s$2);
        var _1 = new $c_Lfs2_internal_Scope$State$Open(resources$1, children$1);
        var _2$1 = new $c_s_Some(scope$1);
        return new $c_T2(_1, _2$1);
      }
      throw new $c_s_MatchError(x$1$1);
    })));
    var tc$5 = this.Lfs2_internal_Scope__f_F;
    var this$31 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$5);
    var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
      var x$1$3 = $as_s_Option(x$1$2);
      if ((x$1$3 instanceof $c_s_Some)) {
        var s$1 = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$3)).s_Some__f_value);
        var this$24 = $n(this.Lfs2_internal_Scope__f_F);
        var a = new $c_s_util_Right(s$1);
        return $n(this$24.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
      }
      var x$2 = $m_s_None$();
      if ((x$2 === x$1$3)) {
        var x13 = this.Lfs2_internal_Scope__f_parent;
        if ((x13 instanceof $c_s_Some)) {
          var parent = $as_Lfs2_internal_Scope($n($as_s_Some(x13)).s_Some__f_value);
          var this$25 = $n(this.Lfs2_internal_Scope__f_interruptible);
          if (this$25.isEmpty__Z()) {
            var this$26 = $m_s_None$();
          } else {
            var x0 = this$25.get__O();
            var _$2 = $as_Lfs2_internal_InterruptContext(x0);
            var this$26 = new $c_s_Some($n(_$2).Lfs2_internal_InterruptContext__f_cancelParent);
          }
          if (this$26.isEmpty__Z()) {
            var this$27 = $n(this.Lfs2_internal_Scope__f_F);
            var fa = $n(this$27.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
          } else {
            var fa = this$26.get__O();
          }
          return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(parent).open__Z__O(interruptible))), this.Lfs2_internal_Scope__f_F);
        }
        var x$3 = $m_s_None$();
        if ((x$3 === x13)) {
          var this$30 = $n(this.Lfs2_internal_Scope__f_F);
          var value = $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "cannot re-open root scope");
          var a$1 = new $c_s_util_Left(value);
          return $n(this$30.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
        }
        throw new $c_s_MatchError(x13);
      }
      throw new $c_s_MatchError(x$1$3);
    }));
    return $n(this$31.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$31.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  }));
  return $n(this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$32.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
});
$c_Lfs2_internal_Scope.prototype.acquireResource__F1__F2__O = (function(acquire, release) {
  var target = $m_Lfs2_internal_ScopedResource$().create__Lfs2_Compiler$Target__O(this.Lfs2_internal_Scope__f_F);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$24 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((resource) => {
    var resource$1 = $as_Lfs2_internal_ScopedResource(resource);
    var this$23 = $n(this.Lfs2_internal_Scope__f_F);
    var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var fa = $n(acquire).apply__O__O(poll$1);
      var recover = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => {
        var t$1 = $as_jl_Throwable(t);
        var this$5 = $n(this.Lfs2_internal_Scope__f_F);
        var a = new $c_s_util_Left(t$1);
        return $n(this$5.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
      }));
      var bind = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => {
        var finalizer = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ec) => {
          var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
          var this$6 = $n(this.Lfs2_internal_Scope__f_F);
          var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
            $as_Lcats_effect_kernel_Poll(_$3);
            return $n(release).apply__O__O__O(r, ec$1);
          }));
          return $n(this$6.F__Lcats_effect_kernel_MonadCancel()).uncancelable__F1__O(f);
        }));
        var target$1 = $n(resource$1).acquired__F1__O(finalizer);
        var tc$1 = this.Lfs2_internal_Scope__f_F;
        var this$21 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
        var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((result) => {
          var result$1 = $as_s_util_Either(result);
          var this$8 = $n(result$1);
          if ((this$8 instanceof $c_s_util_Right)) {
            var x2 = $as_s_util_Right(this$8);
            var b = $n(x2).s_util_Right__f_value;
            var x = $uZ(b);
            var $x_1 = x;
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            var target$2 = $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O(this, resource$1);
            var tc$2 = this.Lfs2_internal_Scope__f_F;
            var this$16 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
            var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
              var x$1$1 = $uZ(x$1);
              if ((x$1$1 === false)) {
                var target$3 = finalizer.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
                var tc$3 = this.Lfs2_internal_Scope__f_F;
                var this$13 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$3);
                var value = $m_Lfs2_internal_AcquireAfterScopeClosed$();
                var b$1 = new $c_s_util_Left(value);
                return $n(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
              }
              if ((x$1$1 === true)) {
                var this$15 = $n(this.Lfs2_internal_Scope__f_F);
                var a$1 = new $c_s_util_Right(r);
                return $n(this$15.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
              }
              throw new $c_s_MatchError(x$1$1);
            }));
            return $n(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          } else {
            var target$4 = finalizer.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
            var tc$4 = this.Lfs2_internal_Scope__f_F;
            var this$20 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$4);
            var this$18 = $n($n(result$1).swap__s_util_Either());
            if ((this$18 instanceof $c_s_util_Right)) {
              var x2$1 = $as_s_util_Right(this$18);
              var b$2 = $n(x2$1).s_util_Right__f_value;
              var value$1 = b$2;
            } else {
              var value$1 = $m_Lfs2_internal_AcquireAfterScopeClosed$();
            }
            var b$3 = new $c_s_util_Left(value$1);
            return $n(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$3);
          }
        }));
        return $n(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }));
      var F$1 = this.Lfs2_internal_Scope__f_F;
      return $f_Lcats_MonadError__redeemWith__O__F1__F1__O($n(F$1), fa, recover, bind);
    }));
    return $n(this$23.F__Lcats_effect_kernel_MonadCancel()).uncancelable__F1__O(f$3);
  }));
  var target$5 = this.interruptibleEval__O__O($n(this$24.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$24.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4));
  var tc$5 = this.Lfs2_internal_Scope__f_F;
  var this$37 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, tc$5);
  var f$5 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_s_util_Either(x$1$2);
    if ((x$1$3 instanceof $c_s_util_Left)) {
      var x38 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Left(x$1$3)).s_util_Left__f_value);
      if ((x38 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$4 = $as_Lcats_effect_kernel_Outcome$Errored(x38);
        var this$27 = $n(x$1$4);
        var x41 = $as_jl_Throwable(this$27.Lcats_effect_kernel_Outcome$Errored__f_e);
        return new $c_Lcats_effect_kernel_Outcome$Errored(x41);
      }
      if (((x38 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x38), true))) {
        return new $c_Lcats_effect_kernel_Outcome$Canceled();
      }
      if ((x38 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$5 = $as_Lcats_effect_kernel_Outcome$Succeeded(x38);
        var this$31 = $n(x$1$5);
        var x33 = $as_Lcats_effect_kernel_Unique$Token(this$31.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        var fa$1 = new $c_s_util_Left(x33);
        return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1);
      }
    }
    if ((x$1$3 instanceof $c_s_util_Right)) {
      var x26 = $as_s_util_Either($n($as_s_util_Right(x$1$3)).s_util_Right__f_value);
      if ((x26 instanceof $c_s_util_Left)) {
        var t$2 = $as_jl_Throwable($n($as_s_util_Left(x26)).s_util_Left__f_value);
        return new $c_Lcats_effect_kernel_Outcome$Errored(t$2);
      }
      if ((x26 instanceof $c_s_util_Right)) {
        var r$1 = $n($as_s_util_Right(x26)).s_util_Right__f_value;
        var fa$2 = new $c_s_util_Right(r$1);
        return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$2);
      }
    }
    throw new $c_s_MatchError(x$1$3);
  }));
  return $n(this$37.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$37.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$5);
});
$c_Lfs2_internal_Scope.prototype.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O = (function(ca, f) {
  var instance = $as_Lcats_Traverse($m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain);
  var target = $n(instance).traverse__O__F1__Lcats_Applicative__O(ca, f, this.Lfs2_internal_Scope__f_F);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((results) => {
    var results$1 = $as_Lcats_data_Chain(results);
    var this$3 = $n($m_Lfs2_CompositeFailure$().fromList__sci_List__s_Option($n($n(results$1).collect__s_PartialFunction__Lcats_data_Chain(new $c_Lfs2_internal_Scope$$anon$1())).toList__sci_List()));
    return (this$3.isEmpty__Z() ? new $c_s_util_Right((void 0)) : new $c_s_util_Left(this$3.get__O()));
  }));
  return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
});
$c_Lfs2_internal_Scope.prototype.close__Lcats_effect_kernel_Resource$ExitCase__O = (function(ec) {
  var this$2 = $n(this.Lfs2_internal_Scope__f_F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
    $as_Lcats_effect_kernel_Poll(_$4);
    return $p_Lfs2_internal_Scope__close___Lcats_effect_kernel_Resource$ExitCase__O(this, ec);
  }));
  return $n(this$2.F__Lcats_effect_kernel_MonadCancel()).uncancelable__F1__O(f);
});
$c_Lfs2_internal_Scope.prototype.openAncestor__O = (function() {
  var this$1 = $n(this.Lfs2_internal_Scope__f_parent);
  if (this$1.isEmpty__Z()) {
    var this$2 = $n(this.Lfs2_internal_Scope__f_F);
    return $n(this$2.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(this);
  } else {
    var x0 = this$1.get__O();
    var parent = $as_Lfs2_internal_Scope(x0);
    var target = $n($n(parent).Lfs2_internal_Scope__f_state).get__O();
    var tc = this.Lfs2_internal_Scope__f_F;
    var this$6 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var this$5 = $n(this.Lfs2_internal_Scope__f_F);
        return $n(this$5.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(parent);
      }
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        return $n(parent).openAncestor__O();
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
});
$c_Lfs2_internal_Scope.prototype.descendsFrom__Lcats_effect_kernel_Unique$Token__Z = (function(scopeId) {
  var this$1 = $n($ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId, this));
  return (!this$1.isEmpty__Z());
});
$c_Lfs2_internal_Scope.prototype.findInLineage__Lcats_effect_kernel_Unique$Token__O = (function(scopeId) {
  var a = $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId, this);
  var F = this.Lfs2_internal_Scope__f_F;
  var this$3 = $n(F);
  var fa = $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  return $m_Lcats_syntax_ApplicativeErrorOps$().orElse$extension__O__F0__Lcats_ApplicativeError__O(fa, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(this, scopeId))), this.Lfs2_internal_Scope__f_F);
});
$c_Lfs2_internal_Scope.prototype.shiftScope__Lcats_effect_kernel_Unique$Token__F0__O = (function(scopeId, context) {
  var target = this.findStepScope__Lcats_effect_kernel_Unique$Token__O(scopeId);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var scope = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$1)).s_Some__f_value);
      var this$3 = $n(this.Lfs2_internal_Scope__f_F);
      return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(scope);
    }
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var x$2 = ((("|Scope lookup failure!\n              |\n              |This is typically caused by uncons-ing from two or more streams in the same Pull.\n              |To do this safely, use `s.pull.stepLeg` instead of `s.pull.uncons` or a variant\n              |thereof. See the implementation of `Stream#zipWith_` for an example.\n              |\n              |Scope id: " + this.Lfs2_internal_Scope__f_id) + "\n              |Step: ") + $n(context).apply__O());
      var msg = $m_sc_StringOps$().stripMargin$extension__T__C__T(x$2, 124);
      var this$6 = $n(this.Lfs2_internal_Scope__f_F);
      var e = $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), msg);
      return $n(this$6.F__Lcats_effect_kernel_MonadCancel()).raiseError__O__O(e);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_internal_Scope.prototype.findStepScope__Lcats_effect_kernel_Unique$Token__O = (function(scopeId) {
  var x$2 = this.Lfs2_internal_Scope__f_id;
  if ((scopeId === null)) {
    var $x_1 = (x$2 === null);
  } else {
    var this$1 = $n(scopeId);
    var $x_1 = (this$1 === x$2);
  }
  if ($x_1) {
    var this$3 = $n(this.Lfs2_internal_Scope__f_F);
    var a = new $c_s_Some(this);
    return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  } else {
    var x94 = this.Lfs2_internal_Scope__f_parent;
    var x$3 = $m_s_None$();
    if ((x$3 === x94)) {
      return $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(this, scopeId);
    }
    if ((x94 instanceof $c_s_Some)) {
      var parent = $as_Lfs2_internal_Scope($n($as_s_Some(x94)).s_Some__f_value);
      var target = $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($n(parent), scopeId);
      var tc = this.Lfs2_internal_Scope__f_F;
      var this$8 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_s_Option(x$1);
        if ((x$1$1 instanceof $c_s_Some)) {
          var scope = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$1)).s_Some__f_value);
          var this$7 = $n(this.Lfs2_internal_Scope__f_F);
          var a$1 = new $c_s_Some(scope);
          return $n(this$7.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a$1);
        }
        var x = $m_s_None$();
        if ((x === x$1$1)) {
          return $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($n($ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope(this)), scopeId);
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    }
    throw new $c_s_MatchError(x94);
  }
});
$c_Lfs2_internal_Scope.prototype.interruptWhen__O__O = (function(haltWhen) {
  var x97 = this.Lfs2_internal_Scope__f_interruptible;
  var x = $m_s_None$();
  if ((x === x97)) {
    var this$1 = $n(this.Lfs2_internal_Scope__f_F);
    var a = new $c_Lfs2_internal_Scope$$anon$2(this);
    return $n(this$1.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
  }
  if ((x97 instanceof $c_s_Some)) {
    var iCtx = $as_Lfs2_internal_InterruptContext($n($as_s_Some(x97)).s_Some__f_value);
    var tc = this.Lfs2_internal_Scope__f_F;
    var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(haltWhen, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$9) => {
      var _$9$1 = $as_s_util_Either(_$9);
      var this$3 = $n(_$9$1);
      if ((this$3 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$3);
        var b = $n(x2).s_util_Right__f_value;
        $as_jl_Void(b);
        var fa = $n(iCtx).Lfs2_internal_InterruptContext__f_interruptRoot;
        var $x_1 = new $c_Lcats_effect_kernel_Outcome$Succeeded(fa);
      } else {
        if ((!(this$3 instanceof $c_s_util_Left))) {
          throw new $c_s_MatchError(this$3);
        }
        var x3 = $as_s_util_Left(this$3);
        var a$1 = $n(x3).s_util_Left__f_value;
        var t = $as_jl_Throwable(a$1);
        var $x_1 = new $c_Lcats_effect_kernel_Outcome$Errored(t);
      }
      return $as_Lcats_effect_kernel_Outcome($x_1);
    }));
    var outcome = $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
    return $n(iCtx).completeWhen__O__O(outcome);
  }
  throw new $c_s_MatchError(x97);
});
$c_Lfs2_internal_Scope.prototype.isInterrupted__O = (function() {
  var target = $p_Lfs2_internal_Scope__openScope__O(this);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((scope) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var x100 = $n(scope$1).Lfs2_internal_Scope__f_interruptible;
    var x = $m_s_None$();
    if ((x === x100)) {
      var this$3 = $n(this.Lfs2_internal_Scope__f_F);
      var a = $m_s_None$();
      return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
    }
    if ((x100 instanceof $c_s_Some)) {
      var iCtx = $as_Lfs2_internal_InterruptContext($n($as_s_Some(x100)).s_Some__f_value);
      return $n($n(iCtx).Lfs2_internal_InterruptContext__f_ref).get__O();
    }
    throw new $c_s_MatchError(x100);
  }));
  return $n(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_internal_Scope.prototype.interruptibleEval__O__O = (function(f) {
  var target = $p_Lfs2_internal_Scope__openScope__O(this);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$2 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$11) => {
    var _$11$1 = $as_Lfs2_internal_Scope(_$11);
    return $n(_$11$1).Lfs2_internal_Scope__f_interruptible;
  }));
  var target$1 = $n(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  var tc$1 = this.Lfs2_internal_Scope__f_F;
  var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
  var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var F$1 = this.Lfs2_internal_Scope__f_F;
      var target$2 = $f_Lcats_ApplicativeError__attempt__O__O($n(F$1), f);
      var tc$2 = this.Lfs2_internal_Scope__f_F;
      var this$13 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
      var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$12) => {
        var _$12$1 = $as_s_util_Either(_$12);
        if ((_$12$1 instanceof $c_s_util_Left)) {
          var a = $n($as_s_util_Left(_$12$1)).s_util_Left__f_value;
          var t = $as_jl_Throwable(a);
          var value = new $c_Lcats_effect_kernel_Outcome$Errored(t);
          return new $c_s_util_Left(value);
        }
        if ((_$12$1 instanceof $c_s_util_Right)) {
          var r = $as_s_util_Right(_$12$1);
          $m_Lcats_syntax_EitherUtil$();
          return r;
        }
        throw new $c_s_MatchError(_$12$1);
      }));
      return $n(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$2);
    }
    if ((x$1$1 instanceof $c_s_Some)) {
      var iCtx = $as_Lfs2_internal_InterruptContext($n($as_s_Some(x$1$1)).s_Some__f_value);
      return $n(iCtx).eval__O__O(f);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
});
$c_Lfs2_internal_Scope.prototype.toString__T = (function() {
  var $x_1 = this.Lfs2_internal_Scope__f_id;
  var this$1 = $n(this.Lfs2_internal_Scope__f_interruptible);
  return (((("Scope(id=" + $x_1) + ",interruptible=") + (!this$1.isEmpty__Z())) + ")");
});
function $as_Lfs2_internal_Scope(obj) {
  return (((obj instanceof $c_Lfs2_internal_Scope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope"));
}
function $isArrayOf_Lfs2_internal_Scope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope)));
}
function $asArrayOf_Lfs2_internal_Scope(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope;", depth));
}
var $d_Lfs2_internal_Scope = new $TypeData().initClass($c_Lfs2_internal_Scope, "fs2.internal.Scope", ({
  Lfs2_internal_Scope: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$() {
}
$c_Lfs2_internal_Scope$.prototype = new $h_O();
$c_Lfs2_internal_Scope$.prototype.constructor = $c_Lfs2_internal_Scope$;
/** @constructor */
function $h_Lfs2_internal_Scope$() {
}
$h_Lfs2_internal_Scope$.prototype = $c_Lfs2_internal_Scope$.prototype;
$c_Lfs2_internal_Scope$.prototype.fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O = (function(id, parent, interruptible, F) {
  var target = $n(F).ref__O__O($m_Lfs2_internal_Scope$State$().Lfs2_internal_Scope$State$__f_initial_);
  var this$2 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    return new $c_Lfs2_internal_Scope(id, parent, interruptible, state$1, F);
  }));
  return $n(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$2.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
});
$c_Lfs2_internal_Scope$.prototype.newRoot__Lfs2_Compiler$Target__O = (function(F) {
  var target = $n(F).unique__O();
  var this$2 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$18) => {
    var _$18$1 = $as_Lcats_effect_kernel_Unique$Token(_$18);
    return $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(_$18$1, $m_s_None$(), $m_s_None$(), F);
  }));
  return $n(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
var $d_Lfs2_internal_Scope$ = new $TypeData().initClass($c_Lfs2_internal_Scope$, "fs2.internal.Scope$", ({
  Lfs2_internal_Scope$: 1
}));
var $n_Lfs2_internal_Scope$;
function $m_Lfs2_internal_Scope$() {
  if ((!$n_Lfs2_internal_Scope$)) {
    $n_Lfs2_internal_Scope$ = new $c_Lfs2_internal_Scope$();
  }
  return $n_Lfs2_internal_Scope$;
}
function $is_Lfs2_internal_Scope$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_internal_Scope$State)));
}
function $as_Lfs2_internal_Scope$State(obj) {
  return (($is_Lfs2_internal_Scope$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope$State"));
}
function $isArrayOf_Lfs2_internal_Scope$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State)));
}
function $asArrayOf_Lfs2_internal_Scope$State(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope$State;", depth));
}
/** @constructor */
function $c_Lfs2_internal_ScopedResource() {
}
$c_Lfs2_internal_ScopedResource.prototype = new $h_O();
$c_Lfs2_internal_ScopedResource.prototype.constructor = $c_Lfs2_internal_ScopedResource;
/** @constructor */
function $h_Lfs2_internal_ScopedResource() {
}
$h_Lfs2_internal_ScopedResource.prototype = $c_Lfs2_internal_ScopedResource.prototype;
function $as_Lfs2_internal_ScopedResource(obj) {
  return (((obj instanceof $c_Lfs2_internal_ScopedResource) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.ScopedResource"));
}
function $isArrayOf_Lfs2_internal_ScopedResource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_ScopedResource)));
}
function $asArrayOf_Lfs2_internal_ScopedResource(obj, depth) {
  return (($isArrayOf_Lfs2_internal_ScopedResource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.ScopedResource;", depth));
}
/** @constructor */
function $c_Lfs2_internal_ScopedResource$() {
  this.Lfs2_internal_ScopedResource$__f_initial = null;
  $n_Lfs2_internal_ScopedResource$ = this;
  var finalizer = $m_s_None$();
  this.Lfs2_internal_ScopedResource$__f_initial = new $c_Lfs2_internal_ScopedResource$State(true, finalizer, 0);
}
$c_Lfs2_internal_ScopedResource$.prototype = new $h_O();
$c_Lfs2_internal_ScopedResource$.prototype.constructor = $c_Lfs2_internal_ScopedResource$;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$() {
}
$h_Lfs2_internal_ScopedResource$.prototype = $c_Lfs2_internal_ScopedResource$.prototype;
$c_Lfs2_internal_ScopedResource$.prototype.create__Lfs2_Compiler$Target__O = (function(F) {
  $m_Lcats_implicits$();
  var target = $n(F).ref__O__O(this.Lfs2_internal_ScopedResource$__f_initial);
  var this$5 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    $m_Lcats_implicits$();
    var target$1 = $n(F).unique__O();
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((token) => {
      var token$1 = $as_Lcats_effect_kernel_Unique$Token(token);
      return new $c_Lfs2_internal_ScopedResource$$anon$1(token$1, F, state$1);
    }));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return $n(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
});
var $d_Lfs2_internal_ScopedResource$ = new $TypeData().initClass($c_Lfs2_internal_ScopedResource$, "fs2.internal.ScopedResource$", ({
  Lfs2_internal_ScopedResource$: 1
}));
var $n_Lfs2_internal_ScopedResource$;
function $m_Lfs2_internal_ScopedResource$() {
  if ((!$n_Lfs2_internal_ScopedResource$)) {
    $n_Lfs2_internal_ScopedResource$ = new $c_Lfs2_internal_ScopedResource$();
  }
  return $n_Lfs2_internal_ScopedResource$;
}
/** @constructor */
function $c_Lio_circe_DecodingFailure$() {
  this.Lio_circe_DecodingFailure$__f_eqDecodingFailure = null;
  this.Lio_circe_DecodingFailure$__f_showDecodingFailure = null;
  $n_Lio_circe_DecodingFailure$ = this;
  $n($m_Lcats_package$().Lcats_package$__f_Eq);
  var f = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a, b) => {
    var a$1 = $as_Lio_circe_DecodingFailure(a);
    var b$1 = $as_Lio_circe_DecodingFailure(b);
    var this$2 = $n(a$1);
    var x = $as_Lio_circe_DecodingFailure$Reason($n(this$2.Lio_circe_DecodingFailure__f_lazyReason).value__O());
    var this$3 = $n(b$1);
    var x$2 = $as_Lio_circe_DecodingFailure$Reason($n(this$3.Lio_circe_DecodingFailure__f_lazyReason).value__O());
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      return $n($m_Lio_circe_CursorOp$().Lio_circe_CursorOp$__f_eqCursorOpList).eqv__O__O__Z($n(a$1).history__sci_List(), $n(b$1).history__sci_List());
    } else {
      return false;
    }
  }));
  this.Lio_circe_DecodingFailure$__f_eqDecodingFailure = new $c_Lcats_kernel_Eq$$anon$5(f);
  this.Lio_circe_DecodingFailure$__f_showDecodingFailure = new $c_Lcats_Show$$anon$5();
}
$c_Lio_circe_DecodingFailure$.prototype = new $h_O();
$c_Lio_circe_DecodingFailure$.prototype.constructor = $c_Lio_circe_DecodingFailure$;
/** @constructor */
function $h_Lio_circe_DecodingFailure$() {
}
$h_Lio_circe_DecodingFailure$.prototype = $c_Lio_circe_DecodingFailure$.prototype;
$c_Lio_circe_DecodingFailure$.prototype.apply__T__F0__Lio_circe_DecodingFailure = (function(message, ops) {
  return $m_Lio_circe_DecodingFailure$DecodingFailureImpl$().apply__Lio_circe_DecodingFailure$Reason__s_Option__Lcats_Eval__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$CustomReason(message), $m_s_None$(), ($m_Lcats_Eval$(), new $c_Lcats_Later(ops)));
});
$c_Lio_circe_DecodingFailure$.prototype.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure = (function(reason, ops) {
  return $m_Lio_circe_DecodingFailure$DecodingFailureImpl$().apply__Lio_circe_DecodingFailure$Reason__s_Option__Lcats_Eval__Lio_circe_DecodingFailure(reason, $m_s_None$(), ($m_Lcats_Eval$(), new $c_Lcats_Later(ops)));
});
var $d_Lio_circe_DecodingFailure$ = new $TypeData().initClass($c_Lio_circe_DecodingFailure$, "io.circe.DecodingFailure$", ({
  Lio_circe_DecodingFailure$: 1
}));
var $n_Lio_circe_DecodingFailure$;
function $m_Lio_circe_DecodingFailure$() {
  if ((!$n_Lio_circe_DecodingFailure$)) {
    $n_Lio_circe_DecodingFailure$ = new $c_Lio_circe_DecodingFailure$();
  }
  return $n_Lio_circe_DecodingFailure$;
}
/** @constructor */
function $c_Lio_circe_DecodingFailure$DecodingFailureImpl$() {
}
$c_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype = new $h_O();
$c_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype.constructor = $c_Lio_circe_DecodingFailure$DecodingFailureImpl$;
/** @constructor */
function $h_Lio_circe_DecodingFailure$DecodingFailureImpl$() {
}
$h_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype = $c_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype;
$c_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype.apply__Lio_circe_DecodingFailure$Reason__s_Option__Lcats_Eval__Lio_circe_DecodingFailure = (function(reason, pathToRoot, ops) {
  $m_Lcats_Eval$();
  var reason$1 = new $c_Lcats_Now(reason);
  return new $c_Lio_circe_DecodingFailure$DecodingFailureImpl(reason$1, pathToRoot, ops);
});
var $d_Lio_circe_DecodingFailure$DecodingFailureImpl$ = new $TypeData().initClass($c_Lio_circe_DecodingFailure$DecodingFailureImpl$, "io.circe.DecodingFailure$DecodingFailureImpl$", ({
  Lio_circe_DecodingFailure$DecodingFailureImpl$: 1
}));
var $n_Lio_circe_DecodingFailure$DecodingFailureImpl$;
function $m_Lio_circe_DecodingFailure$DecodingFailureImpl$() {
  if ((!$n_Lio_circe_DecodingFailure$DecodingFailureImpl$)) {
    $n_Lio_circe_DecodingFailure$DecodingFailureImpl$ = new $c_Lio_circe_DecodingFailure$DecodingFailureImpl$();
  }
  return $n_Lio_circe_DecodingFailure$DecodingFailureImpl$;
}
/** @constructor */
function $c_Lio_circe_DecodingFailure$Reason() {
}
$c_Lio_circe_DecodingFailure$Reason.prototype = new $h_O();
$c_Lio_circe_DecodingFailure$Reason.prototype.constructor = $c_Lio_circe_DecodingFailure$Reason;
/** @constructor */
function $h_Lio_circe_DecodingFailure$Reason() {
}
$h_Lio_circe_DecodingFailure$Reason.prototype = $c_Lio_circe_DecodingFailure$Reason.prototype;
function $as_Lio_circe_DecodingFailure$Reason(obj) {
  return (((obj instanceof $c_Lio_circe_DecodingFailure$Reason) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.DecodingFailure$Reason"));
}
function $isArrayOf_Lio_circe_DecodingFailure$Reason(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_DecodingFailure$Reason)));
}
function $asArrayOf_Lio_circe_DecodingFailure$Reason(obj, depth) {
  return (($isArrayOf_Lio_circe_DecodingFailure$Reason(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.DecodingFailure$Reason;", depth));
}
/** @constructor */
function $c_Lio_circe_JsonObject$() {
  this.Lio_circe_JsonObject$__f_empty = null;
  this.Lio_circe_JsonObject$__f_eqJsonObject = null;
  $n_Lio_circe_JsonObject$ = this;
  this.Lio_circe_JsonObject$__f_empty = new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($m_sci_Map$EmptyMap$(), ($m_sci_Vector$(), $m_sci_Vector0$()));
  this.Lio_circe_JsonObject$__f_eqJsonObject = ($n($m_Lcats_package$().Lcats_package$__f_Eq), new $c_Lcats_kernel_Eq$$anon$6());
}
$c_Lio_circe_JsonObject$.prototype = new $h_O();
$c_Lio_circe_JsonObject$.prototype.constructor = $c_Lio_circe_JsonObject$;
/** @constructor */
function $h_Lio_circe_JsonObject$() {
}
$h_Lio_circe_JsonObject$.prototype = $c_Lio_circe_JsonObject$.prototype;
$c_Lio_circe_JsonObject$.prototype.fromIterable__sc_Iterable__Lio_circe_JsonObject = (function(fields) {
  if ($n(fields).isEmpty__Z()) {
    return this.Lio_circe_JsonObject$__f_empty;
  } else {
    var map = $ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap());
    var iterator = $n(fields).iterator__sc_Iterator();
    while ($n(iterator).hasNext__Z()) {
      matchResult7: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x22 = $as_T2($n(iterator).next__O());
        if ((x22 !== null)) {
          var key = $as_T($n(x22)._1__O());
          var value = $as_Lio_circe_Json($n(x22)._2__O());
          var \u03b41$___1 = key;
          var \u03b41$___2 = value;
          break matchResult7;
        }
        throw new $c_s_MatchError(x22);
      }
      var key$2 = $as_T(\u03b41$___1);
      var value$2 = $as_Lio_circe_Json(\u03b41$___2);
      if ((key$2 === null)) {
        var $x_1 = 0;
      } else {
        var originalHash = $f_T__hashCode__I($n(key$2));
        var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
      }
      map.java$util$HashMap$$put0__O__O__I__Z__O(key$2, value$2, $x_1, false);
    }
    return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject(map);
  }
});
var $d_Lio_circe_JsonObject$ = new $TypeData().initClass($c_Lio_circe_JsonObject$, "io.circe.JsonObject$", ({
  Lio_circe_JsonObject$: 1
}));
var $n_Lio_circe_JsonObject$;
function $m_Lio_circe_JsonObject$() {
  if ((!$n_Lio_circe_JsonObject$)) {
    $n_Lio_circe_JsonObject$ = new $c_Lio_circe_JsonObject$();
  }
  return $n_Lio_circe_JsonObject$;
}
/** @constructor */
function $c_Lio_circe_KeyEncoder$() {
  this.Lio_circe_KeyEncoder$__f_encodeKeyString = null;
  $n_Lio_circe_KeyEncoder$ = this;
  this.Lio_circe_KeyEncoder$__f_encodeKeyString = new $c_Lio_circe_KeyEncoder$$anon$2();
}
$c_Lio_circe_KeyEncoder$.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$.prototype.constructor = $c_Lio_circe_KeyEncoder$;
/** @constructor */
function $h_Lio_circe_KeyEncoder$() {
}
$h_Lio_circe_KeyEncoder$.prototype = $c_Lio_circe_KeyEncoder$.prototype;
var $d_Lio_circe_KeyEncoder$ = new $TypeData().initClass($c_Lio_circe_KeyEncoder$, "io.circe.KeyEncoder$", ({
  Lio_circe_KeyEncoder$: 1
}));
var $n_Lio_circe_KeyEncoder$;
function $m_Lio_circe_KeyEncoder$() {
  if ((!$n_Lio_circe_KeyEncoder$)) {
    $n_Lio_circe_KeyEncoder$ = new $c_Lio_circe_KeyEncoder$();
  }
  return $n_Lio_circe_KeyEncoder$;
}
/** @constructor */
function $c_Lio_circe_PathToRoot$() {
  this.Lio_circe_PathToRoot$__f_empty = null;
  $n_Lio_circe_PathToRoot$ = this;
  $m_Lio_circe_PathToRoot$();
  $m_sci_Vector$();
  var value = $m_sci_Vector0$();
  this.Lio_circe_PathToRoot$__f_empty = value;
}
$c_Lio_circe_PathToRoot$.prototype = new $h_O();
$c_Lio_circe_PathToRoot$.prototype.constructor = $c_Lio_circe_PathToRoot$;
/** @constructor */
function $h_Lio_circe_PathToRoot$() {
}
$h_Lio_circe_PathToRoot$.prototype = $c_Lio_circe_PathToRoot$.prototype;
$c_Lio_circe_PathToRoot$.prototype.toPathString__sci_Vector__T = (function(path) {
  var this$1 = $n(path);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    return "";
  } else {
    var this$3 = $n(path);
    var this$2 = $n(path);
    var z = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), Math.imul(5, this$2.length__I()));
    var at = 0;
    var end = this$3.length__I();
    var acc = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$3.apply__I__O(at);
        var x$1 = $as_scm_StringBuilder(x0);
        var x$2 = $as_Lio_circe_PathToRoot$PathElem(x1);
        matchResult11: {
          var temp$acc;
          var x16 = new $c_T2(x$1, x$2);
          var x22 = $as_scm_StringBuilder(x16.T2__f__1);
          var x23 = $as_Lio_circe_PathToRoot$PathElem(x16.T2__f__2);
          if ((x23 instanceof $c_Lio_circe_PathToRoot$PathElem$ObjectKey)) {
            var x$1$1 = $as_Lio_circe_PathToRoot$PathElem$ObjectKey(x23);
            var this$6 = $n(x$1$1);
            var x26 = this$6.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName;
            var temp$acc = $n($n(x22).append__T__scm_StringBuilder(".")).append__T__scm_StringBuilder(x26);
            break matchResult11;
          }
          if ((x23 instanceof $c_Lio_circe_PathToRoot$PathElem$ArrayIndex)) {
            var x$1$2 = $as_Lio_circe_PathToRoot$PathElem$ArrayIndex(x23);
            var this$8 = $n(x$1$2);
            var x21_$_lo = this$8.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$lo;
            var x21_$_hi = this$8.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$hi;
            var temp$acc = $n($n($n(x22).append__T__scm_StringBuilder("[")).append__T__scm_StringBuilder($m_RTLong$().toString__I__I__T(x21_$_lo, x21_$_hi))).append__T__scm_StringBuilder("]");
            break matchResult11;
          }
          throw new $c_s_MatchError(x16);
        }
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
    var this$9 = $n($as_scm_StringBuilder($x_1));
    return $n(this$9.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
$c_Lio_circe_PathToRoot$.prototype.fromHistory__sci_List__s_util_Either = (function(ops) {
  var target = $n(ops).reverse__sci_List();
  $m_Lcats_UnorderedFoldable$();
  var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  var this$50 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
  $m_sci_Vector$();
  var z = $m_sci_Vector0$();
  var f = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
    var x$1$1 = $as_sci_Vector(x$1);
    var x$2$1 = $as_Lio_circe_CursorOp(x$2);
    if ((x$1$1 !== null)) {
      var x104 = $m_sc_package$$colon$plus$().unapply__sc_SeqOps__s_Option(x$1$1);
      if ((!$n(x104).isEmpty__Z())) {
        var x105 = $as_T2($n(x104).get__O());
        var x106 = $as_sci_Vector($n(x105)._1__O());
        var x107 = $as_Lio_circe_PathToRoot$PathElem($n(x105)._2__O());
        if ((x107 instanceof $c_Lio_circe_PathToRoot$PathElem$ArrayIndex)) {
          var x$1$2 = $as_Lio_circe_PathToRoot$PathElem$ArrayIndex(x107);
          var this$6 = $n(x$1$2);
          var x110_$_lo = this$6.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$lo;
          var x110_$_hi = this$6.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$hi;
          var x = $m_Lio_circe_CursorOp$MoveLeft$();
          if (((x === x$2$1) && ((x110_$_hi === 0) ? (x110_$_lo === 0) : (x110_$_hi < 0)))) {
            return new $c_s_util_Left("Attempt to move beyond beginning of array in cursor history.");
          }
          var x$4 = $m_Lio_circe_CursorOp$MoveLeft$();
          if ((x$4 === x$2$1)) {
            var this$11 = $n(x106);
            var lo = ((x110_$_lo - 1) | 0);
            var hi = ((((x110_$_hi - 1) | 0) + (((x110_$_lo | (~lo)) >>> 31) | 0)) | 0);
            var elem = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(lo, hi);
            var value = this$11.appended__O__O(elem);
            return new $c_s_util_Right(value);
          }
          var x$6 = $m_Lio_circe_CursorOp$MoveRight$();
          if ((x$6 === x$2$1)) {
            var evidence$1 = $as_Lcats_kernel_Hash($m_Lcats_kernel_instances_long_package$().Lcats_kernel_instances_long_package$__f_catsKernelStdOrderForLong);
            if (new $c_Lcats_syntax_EqOps($bL(x110_$_lo, x110_$_hi), evidence$1).$eq$eq$eq__O__Z($bL(2147483647, 0))) {
              return new $c_s_util_Left("Attempt to move to index > Int.MaxValue in array in cursor history.");
            }
            var this$18 = $n(x106);
            var lo$1 = ((1 + x110_$_lo) | 0);
            var hi$1 = ((x110_$_hi + (((x110_$_lo & (~lo$1)) >>> 31) | 0)) | 0);
            var elem$1 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(lo$1, hi$1);
            var value$1 = this$18.appended__O__O(elem$1);
            return new $c_s_util_Right(value$1);
          }
        }
        var x$8 = $m_Lio_circe_CursorOp$MoveUp$();
        if ((x$8 === x$2$1)) {
          return new $c_s_util_Right(x106);
        }
      }
    }
    var x$10 = $m_Lio_circe_CursorOp$MoveUp$();
    if ((x$10 === x$2$1)) {
      return new $c_s_util_Left("Attempt to move up above the root of the JSON.");
    }
    if ((x$1$1 !== null)) {
      var x60 = $m_sc_package$$colon$plus$().unapply__sc_SeqOps__s_Option(x$1$1);
      if ((!$n(x60).isEmpty__Z())) {
        var x61 = $as_T2($n(x60).get__O());
        var acc$7 = $as_sci_Vector($n(x61)._1__O());
        if (($n(x61)._2__O() instanceof $c_Lio_circe_PathToRoot$PathElem$ObjectKey)) {
          var x$1$3 = $as_Lio_circe_PathToRoot$PathElem$ObjectKey($n(x61)._2__O());
          $n(x$1$3);
          if (false) {
            var x$1$4 = $as_Lio_circe_CursorOp$Field(x$2$1);
            var x59 = $n(x$1$4)._1__T();
            var this$26 = $n(acc$7);
            var elem$2 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(x59);
            var value$2 = this$26.appended__O__O(elem$2);
            return new $c_s_util_Right(value$2);
          }
        }
      }
    }
    if (false) {
      var x$1$5 = $as_Lio_circe_CursorOp$Field(x$2$1);
      $n(x$1$5)._1__T();
      return new $c_s_util_Left("Attempt to move to sibling field, but cursor history didn't indicate we were in an object.");
    }
    if ((x$2$1 instanceof $c_Lio_circe_CursorOp$DownField)) {
      var x$1$6 = $as_Lio_circe_CursorOp$DownField(x$2$1);
      var this$31 = $n(x$1$6);
      var x49 = this$31.Lio_circe_CursorOp$DownField__f_k;
      var this$33 = $n(x$1$1);
      var elem$3 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(x49);
      var value$3 = this$33.appended__O__O(elem$3);
      return new $c_s_util_Right(value$3);
    }
    var x$12 = $m_Lio_circe_CursorOp$DownArray$();
    if ((x$12 === x$2$1)) {
      var this$37 = $n(x$1$1);
      var elem$4 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(0, 0);
      var value$4 = this$37.appended__O__O(elem$4);
      return new $c_s_util_Right(value$4);
    }
    if (false) {
      var x$1$7 = $as_Lio_circe_CursorOp$DownN(x$2$1);
      var x42 = $n(x$1$7)._1__I();
      var this$43 = $n(x$1$1);
      var hi$2 = (x42 >> 31);
      var elem$5 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(x42, hi$2);
      var value$5 = this$43.appended__O__O(elem$5);
      return new $c_s_util_Right(value$5);
    }
    if ((x$1$1 !== null)) {
      var x34 = $m_sc_package$$colon$plus$().unapply__sc_SeqOps__s_Option(x$1$1);
      if ((!$n(x34).isEmpty__Z())) {
        var x35 = $as_T2($n(x34).get__O());
        var acc$11 = $as_sci_Vector($n(x35)._1__O());
        var x$14 = $m_Lio_circe_CursorOp$DeleteGoParent$();
        if ((x$14 === x$2$1)) {
          return new $c_s_util_Right(acc$11);
        }
      }
    }
    var x$16 = $m_Lio_circe_CursorOp$DeleteGoParent$();
    if ((x$16 === x$2$1)) {
      return new $c_s_util_Left("Attempt to move up above the root of the JSON.");
    }
    var value$6 = ("Invalid cursor history state: " + x$2$1);
    return new $c_s_util_Left(value$6);
  }));
  $m_Lcats_instances_package$either$();
  var G = new $c_Lcats_instances_EitherInstances$$anon$2();
  var this$51 = $n($as_s_util_Either($n(this$50.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).foldM__O__O__F2__Lcats_Monad__O(this$50.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, z, f, G)));
  if ((this$51 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$51);
    var b = $n(x2).s_util_Right__f_value;
    var value$7 = $as_sci_Vector(b);
    return new $c_s_util_Right(new $c_Lio_circe_PathToRoot(($m_Lio_circe_PathToRoot$(), value$7)));
  } else {
    return this$51;
  }
});
$c_Lio_circe_PathToRoot$.prototype.equals$extension__sci_Vector__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lio_circe_PathToRoot)) {
    var x$0$2 = ((x$0 === null) ? null : $n($as_Lio_circe_PathToRoot(x$0)).Lio_circe_PathToRoot__f_value);
    return ((this$ === null) ? (x$0$2 === null) : $n(this$).equals__O__Z(x$0$2));
  } else {
    return false;
  }
});
$c_Lio_circe_PathToRoot$.prototype.toString$extension__sci_Vector__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lio_circe_PathToRoot(this$));
});
$c_Lio_circe_PathToRoot$.prototype.productElement$extension__sci_Vector__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_PathToRoot$.prototype.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector = (function(this$, elem) {
  $m_Lio_circe_PathToRoot$();
  var this$1 = $n(this$);
  var value = this$1.prepended__O__sci_Vector(elem);
  return value;
});
var $d_Lio_circe_PathToRoot$ = new $TypeData().initClass($c_Lio_circe_PathToRoot$, "io.circe.PathToRoot$", ({
  Lio_circe_PathToRoot$: 1
}));
var $n_Lio_circe_PathToRoot$;
function $m_Lio_circe_PathToRoot$() {
  if ((!$n_Lio_circe_PathToRoot$)) {
    $n_Lio_circe_PathToRoot$ = new $c_Lio_circe_PathToRoot$();
  }
  return $n_Lio_circe_PathToRoot$;
}
function $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal($thiz, unscaled, scale_$_lo, scale_$_hi) {
  var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(unscaled, yn)) {
    return $thiz.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero;
  } else {
    var current = unscaled;
    var depth_$_lo = scale_$_lo;
    var depth_$_hi = scale_$_hi;
    var divAndRem = $n(current).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
    while (true) {
      var xn = $n(divAndRem).get(1);
      var yn$1 = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn$1)) {
        current = $n(divAndRem).get(0);
        var x_$_lo = depth_$_lo;
        var x_$_hi = depth_$_hi;
        var lo = ((x_$_lo - 1) | 0);
        var hi = ((((x_$_hi - 1) | 0) + (((x_$_lo | (~lo)) >>> 31) | 0)) | 0);
        depth_$_lo = lo;
        depth_$_hi = hi;
        divAndRem = $n(current).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
      } else {
        break;
      }
    }
    var $x_1 = current;
    var lVal_$_lo = depth_$_lo;
    var lVal_$_hi = depth_$_hi;
    return new $c_Lio_circe_numbers_SigAndExp($x_1, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(lVal_$_lo, lVal_$_hi));
  }
}
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$() {
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxInt = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MinInt = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero = null;
  $n_Lio_circe_numbers_BiggerDecimal$ = this;
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(262144, 0);
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxInt = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(2147483647, 0);
  this.Lio_circe_numbers_BiggerDecimal$__f_MinInt = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger((-2147483648), (-1));
  $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), (-1), 2147483647);
  $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648));
  this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero = new $c_Lio_circe_numbers_BiggerDecimal$$anon$1();
  this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero = new $c_Lio_circe_numbers_BiggerDecimal$$anon$2();
}
$c_Lio_circe_numbers_BiggerDecimal$.prototype = new $h_O();
$c_Lio_circe_numbers_BiggerDecimal$.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$() {
}
$h_Lio_circe_numbers_BiggerDecimal$.prototype = $c_Lio_circe_numbers_BiggerDecimal$.prototype;
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromLong__J__Lio_circe_numbers_BiggerDecimal = (function(d_$_lo, d_$_hi) {
  return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(d_$_lo, d_$_hi), 0, 0);
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromDoubleUnsafe__D__Lio_circe_numbers_BiggerDecimal = (function(d) {
  if (($m_jl_Double$().compare__D__D__I(d, (-0)) === 0)) {
    return this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero;
  } else {
    var d$1 = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
    var this$1 = $n(d$1);
    var $x_1 = this$1.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var this$2 = $n(d$1);
    var value = this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $x_1, value, hi);
  }
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.parseBiggerDecimalUnsafe__T__Lio_circe_numbers_BiggerDecimal = (function(input) {
  var this$1 = $n(input);
  var len = this$1.length;
  if ((len === 0)) {
    return null;
  } else {
    var zeros = 0;
    var decIndex = (-1);
    var expIndex = (-1);
    var this$2 = $n(input);
    if (($charAt(this$2, 0) === 45)) {
      var i = 1;
    } else {
      var i = 0;
    }
    var startIndex = i;
    var parsedNonZeroIntegralDigit = false;
    if ((i >= len)) {
      return null;
    } else {
      var state = 6;
      while (((i < len) && (state !== 0))) {
        var this$3 = $n(input);
        var index = i;
        var c = $charAt(this$3, index);
        var x10 = state;
        switch (x10) {
          case 6: {
            if ((c === 48)) {
              if (parsedNonZeroIntegralDigit) {
                zeros = ((1 + zeros) | 0);
              }
            } else if (((((c - 49) | 0) >>> 0) <= 8)) {
              parsedNonZeroIntegralDigit = true;
              zeros = 0;
            } else if ((c === 46)) {
              state = 1;
            } else if ((((c === 69) || (c === 101)) && (i !== startIndex))) {
              state = 3;
            } else {
              state = 0;
            }
            break;
          }
          case 1: {
            decIndex = ((i - 1) | 0);
            if ((c === 48)) {
              zeros = ((1 + zeros) | 0);
              state = 2;
            } else if (((((c - 49) | 0) >>> 0) <= 8)) {
              zeros = 0;
              state = 2;
            } else {
              state = 0;
            }
            break;
          }
          case 3: {
            expIndex = ((i - 1) | 0);
            if (((((c - 48) | 0) >>> 0) <= 9)) {
              state = 5;
            } else if (((c === 43) || (c === 45))) {
              state = 4;
            } else {
              state = 0;
            }
            break;
          }
          case 2: {
            if ((c === 48)) {
              zeros = ((1 + zeros) | 0);
              state = 2;
            } else if (((((c - 49) | 0) >>> 0) <= 8)) {
              zeros = 0;
              state = 2;
            } else if (((c === 69) || (c === 101))) {
              state = 3;
            } else {
              state = 0;
            }
            break;
          }
          case 4: {
            if (((((c - 48) | 0) >>> 0) <= 9)) {
              state = 5;
            } else {
              state = 0;
            }
            break;
          }
          case 5: {
            if (((((c - 48) | 0) >>> 0) <= 9)) {
              state = 5;
            } else {
              state = 0;
            }
            break;
          }
          default: {
            throw new $c_s_MatchError(x10);
          }
        }
        i = ((1 + i) | 0);
      }
      if (((((state >>> 0) < 2) || (state === 3)) || (state === 4))) {
        return null;
      } else {
        if ((decIndex >= 0)) {
          var this$4 = $n(input);
          var endIndex = decIndex;
          if ((endIndex > this$4.length)) {
            $charAt(this$4, endIndex);
          }
          if ((endIndex < 0)) {
            $charAt(this$4, (-1));
          }
          var integral = $as_T(this$4.substring(0, endIndex));
        } else if ((expIndex === (-1))) {
          var integral = input;
        } else {
          var this$5 = $n(input);
          var endIndex$1 = expIndex;
          if ((endIndex$1 > this$5.length)) {
            $charAt(this$5, endIndex$1);
          }
          if ((endIndex$1 < 0)) {
            $charAt(this$5, (-1));
          }
          var integral = $as_T(this$5.substring(0, endIndex$1));
        }
        if ((decIndex === (-1))) {
          var fractional = "";
        } else if ((expIndex === (-1))) {
          var this$6 = $n(input);
          var beginIndex = ((1 + decIndex) | 0);
          if (((beginIndex < 0) || (beginIndex > this$6.length))) {
            $charAt(this$6, beginIndex);
          }
          var fractional = $as_T(this$6.substring(beginIndex));
        } else {
          var this$7 = $n(input);
          var beginIndex$1 = ((1 + decIndex) | 0);
          var endIndex$2 = expIndex;
          if ((beginIndex$1 < 0)) {
            $charAt(this$7, beginIndex$1);
          }
          if ((endIndex$2 > this$7.length)) {
            $charAt(this$7, endIndex$2);
          }
          if ((endIndex$2 < beginIndex$1)) {
            $charAt(this$7, (-1));
          }
          var fractional = $as_T(this$7.substring(beginIndex$1, endIndex$2));
        }
        var unscaledString = (("" + integral) + fractional);
        var endIndex$3 = ((unscaledString.length - zeros) | 0);
        if ((endIndex$3 > unscaledString.length)) {
          $charAt(unscaledString, endIndex$3);
        }
        if ((endIndex$3 < 0)) {
          $charAt(unscaledString, (-1));
        }
        var trimmed = $as_T(unscaledString.substring(0, endIndex$3));
        var this$8 = $n(trimmed);
        if (((this$8 === "") || (trimmed === "-"))) {
          var unscaled = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
        } else {
          var unscaled = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), trimmed);
        }
        var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
        if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(unscaled, yn)) {
          var this$9 = $n(input);
          if (($charAt(this$9, 0) === 45)) {
            return this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero;
          } else {
            return this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero;
          }
        } else {
          var this$10 = $n(fractional);
          var value = ((this$10.length - zeros) | 0);
          var hi = (value >> 31);
          var rescale = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(value, hi);
          if ((expIndex === (-1))) {
            var scale = rescale;
          } else {
            var this$13 = $n(rescale);
            var this$12 = $n(input);
            var beginIndex$2 = ((1 + expIndex) | 0);
            if (((beginIndex$2 < 0) || (beginIndex$2 > this$12.length))) {
              $charAt(this$12, beginIndex$2);
            }
            var bi = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), $as_T(this$12.substring(beginIndex$2)));
            var scale = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$13, bi);
          }
          return new $c_Lio_circe_numbers_SigAndExp(unscaled, scale);
        }
      }
    }
  }
});
var $d_Lio_circe_numbers_BiggerDecimal$ = new $TypeData().initClass($c_Lio_circe_numbers_BiggerDecimal$, "io.circe.numbers.BiggerDecimal$", ({
  Lio_circe_numbers_BiggerDecimal$: 1
}));
var $n_Lio_circe_numbers_BiggerDecimal$;
function $m_Lio_circe_numbers_BiggerDecimal$() {
  if ((!$n_Lio_circe_numbers_BiggerDecimal$)) {
    $n_Lio_circe_numbers_BiggerDecimal$ = new $c_Lio_circe_numbers_BiggerDecimal$();
  }
  return $n_Lio_circe_numbers_BiggerDecimal$;
}
/** @constructor */
function $c_Lio_circe_scalajs_package$() {
}
$c_Lio_circe_scalajs_package$.prototype = new $h_O();
$c_Lio_circe_scalajs_package$.prototype.constructor = $c_Lio_circe_scalajs_package$;
/** @constructor */
function $h_Lio_circe_scalajs_package$() {
}
$h_Lio_circe_scalajs_package$.prototype = $c_Lio_circe_scalajs_package$.prototype;
$c_Lio_circe_scalajs_package$.prototype.convertAnyToJsonUnsafe__O__Lio_circe_Json = (function(input) {
  if (((typeof input) === "string")) {
    var s = $as_T(input);
    return $m_Lio_circe_Json$().fromString__T__Lio_circe_Json(s);
  }
  if (((typeof input) === "number")) {
    var n = $uD(input);
    return $m_Lio_circe_Json$().fromDoubleOrNull__D__Lio_circe_Json(n);
  }
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(true, input)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_True;
  }
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(false, input)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_False;
  }
  if ((input === null)) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null;
  }
  if ($uZ((input instanceof Array))) {
    var $x_2 = $m_Lio_circe_Json$();
    var len = $uI(input.length);
    var res = new Array(len);
    var i = 0;
    while ((i < len)) {
      var $x_1 = i;
      var x0 = input[i];
      res[$x_1] = $m_Lio_circe_scalajs_package$().convertAnyToJsonUnsafe__O__Lio_circe_Json(x0);
      i = ((1 + i) | 0);
    }
    return $x_2.fromValues__sc_Iterable__Lio_circe_Json($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), res));
  }
  if ($uZ((input instanceof Object))) {
    var $x_3 = $m_Lio_circe_Json$();
    var this$5 = new $c_sjs_js_WrappedDictionary(input);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((input$2) => $m_Lio_circe_scalajs_package$().convertAnyToJsonUnsafe__O__Lio_circe_Json(input$2)));
    var this$6 = new $c_sc_MapView$MapValues(this$5, f);
    return $x_3.fromFields__sc_Iterable__Lio_circe_Json($m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$6));
  }
  if ((input === (void 0))) {
    return $m_Lio_circe_Json$().Lio_circe_Json$__f_Null;
  }
  throw new $c_s_MatchError(input);
});
$c_Lio_circe_scalajs_package$.prototype.convertJsToJson__sjs_js_Any__s_util_Either = (function(input) {
  try {
    var value = $m_Lio_circe_scalajs_package$().convertAnyToJsonUnsafe__O__Lio_circe_Json(input);
    return new $c_s_util_Right(value);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x7 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(x7).isEmpty__Z())) {
      var x8 = $as_jl_Throwable($n(x7).get__O());
      return new $c_s_util_Left(x8);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
var $d_Lio_circe_scalajs_package$ = new $TypeData().initClass($c_Lio_circe_scalajs_package$, "io.circe.scalajs.package$", ({
  Lio_circe_scalajs_package$: 1
}));
var $n_Lio_circe_scalajs_package$;
function $m_Lio_circe_scalajs_package$() {
  if ((!$n_Lio_circe_scalajs_package$)) {
    $n_Lio_circe_scalajs_package$ = new $c_Lio_circe_scalajs_package$();
  }
  return $n_Lio_circe_scalajs_package$;
}
/** @constructor */
function $c_Lio_circe_syntax_package$KeyOps$() {
}
$c_Lio_circe_syntax_package$KeyOps$.prototype = new $h_O();
$c_Lio_circe_syntax_package$KeyOps$.prototype.constructor = $c_Lio_circe_syntax_package$KeyOps$;
/** @constructor */
function $h_Lio_circe_syntax_package$KeyOps$() {
}
$h_Lio_circe_syntax_package$KeyOps$.prototype = $c_Lio_circe_syntax_package$KeyOps$.prototype;
$c_Lio_circe_syntax_package$KeyOps$.prototype.$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2 = (function(this$, a, evidence$1, keyEncoder) {
  var _1 = $n(keyEncoder).apply__O__T(this$);
  var _2 = $n(evidence$1).apply__O__Lio_circe_Json(a);
  return new $c_T2(_1, _2);
});
var $d_Lio_circe_syntax_package$KeyOps$ = new $TypeData().initClass($c_Lio_circe_syntax_package$KeyOps$, "io.circe.syntax.package$KeyOps$", ({
  Lio_circe_syntax_package$KeyOps$: 1
}));
var $n_Lio_circe_syntax_package$KeyOps$;
function $m_Lio_circe_syntax_package$KeyOps$() {
  if ((!$n_Lio_circe_syntax_package$KeyOps$)) {
    $n_Lio_circe_syntax_package$KeyOps$ = new $c_Lio_circe_syntax_package$KeyOps$();
  }
  return $n_Lio_circe_syntax_package$KeyOps$;
}
function $is_jl_Comparable(obj) {
  return ((((((!(!((obj && obj.$classData) && obj.$classData.ancestors.jl_Comparable))) || ((typeof obj) === "string")) || ((typeof obj) === "number")) || ((typeof obj) === "boolean")) || (obj instanceof $Long)) || (obj instanceof $Char));
}
function $as_jl_Comparable(obj) {
  return (($is_jl_Comparable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Comparable"));
}
function $isArrayOf_jl_Comparable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Comparable)));
}
function $asArrayOf_jl_Comparable(obj, depth) {
  return (($isArrayOf_jl_Comparable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Comparable;", depth));
}
/** @constructor */
function $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, radixPowLengthInverse, paddingZeros, overflowBarrier_$_lo, overflowBarrier_$_hi) {
  this.jl_Long$StringRadixInfo__f_chunkLength = 0;
  this.jl_Long$StringRadixInfo__f_radixPowLength = 0;
  this.jl_Long$StringRadixInfo__f_radixPowLengthInverse = 0.0;
  this.jl_Long$StringRadixInfo__f_paddingZeros = null;
  this.jl_Long$StringRadixInfo__f_overflowBarrier_$lo = 0;
  this.jl_Long$StringRadixInfo__f_overflowBarrier_$hi = 0;
  this.jl_Long$StringRadixInfo__f_chunkLength = chunkLength;
  this.jl_Long$StringRadixInfo__f_radixPowLength = radixPowLength;
  this.jl_Long$StringRadixInfo__f_radixPowLengthInverse = radixPowLengthInverse;
  this.jl_Long$StringRadixInfo__f_paddingZeros = paddingZeros;
  this.jl_Long$StringRadixInfo__f_overflowBarrier_$lo = overflowBarrier_$_lo;
  this.jl_Long$StringRadixInfo__f_overflowBarrier_$hi = overflowBarrier_$_hi;
}
$c_jl_Long$StringRadixInfo.prototype = new $h_O();
$c_jl_Long$StringRadixInfo.prototype.constructor = $c_jl_Long$StringRadixInfo;
/** @constructor */
function $h_jl_Long$StringRadixInfo() {
}
$h_jl_Long$StringRadixInfo.prototype = $c_jl_Long$StringRadixInfo.prototype;
function $as_jl_Long$StringRadixInfo(obj) {
  return (((obj instanceof $c_jl_Long$StringRadixInfo) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long$StringRadixInfo"));
}
function $isArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long$StringRadixInfo)));
}
function $asArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (($isArrayOf_jl_Long$StringRadixInfo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long$StringRadixInfo;", depth));
}
var $d_jl_Long$StringRadixInfo = new $TypeData().initClass($c_jl_Long$StringRadixInfo, "java.lang.Long$StringRadixInfo", ({
  jl_Long$StringRadixInfo: 1
}));
/** @constructor */
function $c_jl_Math$() {
}
$c_jl_Math$.prototype = new $h_O();
$c_jl_Math$.prototype.constructor = $c_jl_Math$;
/** @constructor */
function $h_jl_Math$() {
}
$h_jl_Math$.prototype = $c_jl_Math$.prototype;
$c_jl_Math$.prototype.nextUp__F__F = (function(a) {
  var bits = $floatToBits(a);
  var x = (bits >> 31);
  var y = (1 | x);
  var newBits = ((bits + y) | 0);
  var x$1 = (bits ^ newBits);
  var y$1 = (x$1 >> 8);
  var bits$1 = (newBits | y$1);
  var x$2 = (2139095040 & bits$1);
  if ((x$2 !== 2139095040)) {
    return $floatFromBits(newBits);
  } else {
    var x$3 = Math.fround((a + a));
    return Math.fround((x$3 + 1.401298464324817E-45));
  }
});
$c_jl_Math$.prototype.nextDown__F__F = (function(a) {
  var bits = $floatToBits(a);
  var x = (bits >> 31);
  var y = (1 | x);
  var newBits = ((bits - y) | 0);
  var x$1 = (bits ^ newBits);
  var y$1 = (x$1 >> 8);
  var bits$1 = (newBits | y$1);
  var x$2 = (2139095040 & bits$1);
  if ((x$2 !== 2139095040)) {
    return $floatFromBits(newBits);
  } else {
    var x$3 = Math.fround((a + a));
    return Math.fround((x$3 - 1.401298464324817E-45));
  }
});
$c_jl_Math$.prototype.scalb__D__I__D = (function(d, scaleFactor) {
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setFloat64(0, d, true);
  var lo = $uI(fpBitsDataView.getInt32(0, true));
  var hi = $uI(fpBitsDataView.getInt32(4, true));
  var lo$1 = ((hi >>> 20) | 0);
  var e = (2047 & lo$1);
  var newE = ((e + scaleFactor) | 0);
  var hi$1 = ((-2146435073) & hi);
  var java$lang$IntFloatBits$Int64Box$$value_$_lo = 0;
  var java$lang$IntFloatBits$Int64Box$$value_$_hi = 0;
  java$lang$IntFloatBits$Int64Box$$value_$_lo = lo;
  java$lang$IntFloatBits$Int64Box$$value_$_hi = hi$1;
  var x = ((e - 1) | 0);
  if ((!((x >>> 0) <= 2045))) {
    var hi$2 = (2147483647 & hi);
    if ((((lo | hi$2) === 0) || (hi$2 >= 2146435072))) {
      return d;
    }
    var hi$3 = (1048575 & hi);
    var clz = ((hi$3 !== 0) ? Math.clz32(hi$3) : ((32 + Math.clz32(lo)) | 0));
    newE = ((newE - ((clz - 12) | 0)) | 0);
    var hi$4 = ((-2147483648) & hi);
    var y = ((clz - 11) | 0);
    var lo$2 = (((32 & y) === 0) ? (lo << y) : 0);
    var hi$5 = (((32 & y) === 0) ? (((((lo >>> 1) | 0) >>> (~y)) | 0) | (hi << y)) : (lo << y));
    var hi$6 = (1048575 & hi$5);
    var hi$7 = (hi$4 | hi$6);
    java$lang$IntFloatBits$Int64Box$$value_$_lo = lo$2;
    java$lang$IntFloatBits$Int64Box$$value_$_hi = hi$7;
  }
  var e$1 = newE;
  var x$1 = ((e$1 - 1) | 0);
  if (((x$1 >>> 0) <= 2045)) {
    var finalNewE = newE;
    var finalSignAndMantissa_$_lo = java$lang$IntFloatBits$Int64Box$$value_$_lo;
    var finalSignAndMantissa_$_hi = java$lang$IntFloatBits$Int64Box$$value_$_hi;
    var hi$8 = (finalNewE << 20);
    var hi$9 = (hi$8 | finalSignAndMantissa_$_hi);
    var fpBitsDataView$1 = $fpBitsDataView;
    fpBitsDataView$1.setInt32(0, finalSignAndMantissa_$_lo, true);
    fpBitsDataView$1.setInt32(4, hi$9, true);
    return $uD(fpBitsDataView$1.getFloat64(0, true));
  } else {
    var x$2 = newE;
    var x$3 = ((53 + x$2) | 0);
    if (((x$3 >>> 0) <= 53)) {
      var finalNewE$1 = ((54 + newE) | 0);
      var finalSignAndMantissa$1_$_lo = java$lang$IntFloatBits$Int64Box$$value_$_lo;
      var finalSignAndMantissa$1_$_hi = java$lang$IntFloatBits$Int64Box$$value_$_hi;
      var hi$10 = (finalNewE$1 << 20);
      var hi$11 = (hi$10 | finalSignAndMantissa$1_$_hi);
      var fpBitsDataView$2 = $fpBitsDataView;
      fpBitsDataView$2.setInt32(0, finalSignAndMantissa$1_$_lo, true);
      fpBitsDataView$2.setInt32(4, hi$11, true);
      var x$4 = $uD(fpBitsDataView$2.getFloat64(0, true));
      return (5.551115123125783E-17 * x$4);
    } else {
      var finalNewE$2 = (2047 & (~(scaleFactor >> 31)));
      var hi$12 = ((-2147483648) & hi);
      var hi$13 = (finalNewE$2 << 20);
      var hi$14 = (hi$13 | hi$12);
      var fpBitsDataView$3 = $fpBitsDataView;
      fpBitsDataView$3.setInt32(0, 0, true);
      fpBitsDataView$3.setInt32(4, hi$14, true);
      return $uD(fpBitsDataView$3.getFloat64(0, true));
    }
  }
});
$c_jl_Math$.prototype.java$lang$Math$$longOverflow__E = (function() {
  throw new $c_jl_ArithmeticException("Long overflow");
});
var $d_jl_Math$ = new $TypeData().initClass($c_jl_Math$, "java.lang.Math$", ({
  jl_Math$: 1
}));
var $n_jl_Math$;
function $m_jl_Math$() {
  if ((!$n_jl_Math$)) {
    $n_jl_Math$ = new $c_jl_Math$();
  }
  return $n_jl_Math$;
}
function $is_jl_Runnable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.jl_Runnable)));
}
function $as_jl_Runnable(obj) {
  return (($is_jl_Runnable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Runnable"));
}
function $isArrayOf_jl_Runnable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Runnable)));
}
function $asArrayOf_jl_Runnable(obj, depth) {
  return (($isArrayOf_jl_Runnable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Runnable;", depth));
}
var $d_jl_Runnable = new $TypeData().initClass(1, "java.lang.Runnable", ({
  jl_Runnable: 1
}));
/** @constructor */
function $c_jl_Runtime() {
}
$c_jl_Runtime.prototype = new $h_O();
$c_jl_Runtime.prototype.constructor = $c_jl_Runtime;
/** @constructor */
function $h_jl_Runtime() {
}
$h_jl_Runtime.prototype = $c_jl_Runtime.prototype;
var $d_jl_Runtime = new $TypeData().initClass($c_jl_Runtime, "java.lang.Runtime", ({
  jl_Runtime: 1
}));
/** @constructor */
function $c_jl_Runtime$() {
  this.jl_Runtime$__f_currentRuntime = null;
  $n_jl_Runtime$ = this;
  this.jl_Runtime$__f_currentRuntime = new $c_jl_Runtime();
}
$c_jl_Runtime$.prototype = new $h_O();
$c_jl_Runtime$.prototype.constructor = $c_jl_Runtime$;
/** @constructor */
function $h_jl_Runtime$() {
}
$h_jl_Runtime$.prototype = $c_jl_Runtime$.prototype;
var $d_jl_Runtime$ = new $TypeData().initClass($c_jl_Runtime$, "java.lang.Runtime$", ({
  jl_Runtime$: 1
}));
var $n_jl_Runtime$;
function $m_jl_Runtime$() {
  if ((!$n_jl_Runtime$)) {
    $n_jl_Runtime$ = new $c_jl_Runtime$();
  }
  return $n_jl_Runtime$;
}
function $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines) {
  var NormalizedFrameLine = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^([^@]*)@(.*?):([0-9]+)(?::([0-9]+))?$");
  var trace = [];
  var i = 0;
  while ((i < $uI(lines.length))) {
    var line = $as_T(lines[i]);
    var this$1 = $n(line);
    if ((!(this$1 === ""))) {
      var mtch = NormalizedFrameLine.exec(line);
      if ((mtch !== null)) {
        var x = mtch[1];
        var classAndMethodName = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, $as_T(x));
        var $x_6 = $as_T(classAndMethodName[0]);
        var $x_5 = $as_T(classAndMethodName[1]);
        var x$1 = mtch[2];
        var $x_4 = $as_T(x$1);
        var x$2 = mtch[3];
        var s = $as_T(x$2);
        var $x_3 = $uI(parseInt(s));
        var x$3 = mtch[4];
        if ((x$3 !== (void 0))) {
          var t = $as_T(x$3);
          var $x_2 = $uI(parseInt(t));
        } else {
          var $x_2 = (-1);
        }
        var $x_1 = trace.push($ct_jl_StackTraceElement__T__T__T__I__I__(new $c_jl_StackTraceElement(), $x_6, $x_5, $x_4, $x_3, $x_2));
        $uI($x_1);
      } else {
        $uI(trace.push($ct_jl_StackTraceElement__T__T__T__I__I__(new $c_jl_StackTraceElement(), "<jscode>", line, null, (-1), (-1))));
      }
    }
    i = ((1 + i) | 0);
  }
  var len = $uI(trace.length);
  var result = new ($d_jl_StackTraceElement.getArrayOf().constr)(len);
  i = 0;
  while ((i < len)) {
    result.set(i, $as_jl_StackTraceElement(trace[i]));
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractClassMethod__T__O($thiz, functionName) {
  var PatBC = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$[bc]_([^\\.]+)(?:\\.prototype)?\\.([^\\.]+)$");
  var PatS = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$(?:ps?|s|f)_((?:_[^_]|[^_])+)__([^\\.]+)$");
  var PatCT = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$ct_((?:_[^_]|[^_])+)__([^\\.]*)$");
  var PatN = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^new (?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$c_([^\\.]+)$");
  var PatM = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$m_([^\\.]+)$");
  var matchBC = PatBC.exec(functionName);
  var matchBCOrS = ((matchBC !== null) ? matchBC : PatS.exec(functionName));
  if ((matchBCOrS !== null)) {
    var x = matchBCOrS[1];
    var $x_1 = $p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x));
    var x$1 = matchBCOrS[2];
    return [$x_1, $p_jl_StackTrace$__decodeMethodName__T__T($thiz, $as_T(x$1))];
  } else {
    var matchCT = PatCT.exec(functionName);
    var matchCTOrN = ((matchCT !== null) ? matchCT : PatN.exec(functionName));
    if ((matchCTOrN !== null)) {
      var x$2 = matchCTOrN[1];
      return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$2)), "<init>"];
    } else {
      var matchM = PatM.exec(functionName);
      if ((matchM !== null)) {
        var x$3 = matchM[1];
        return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$3)), "<clinit>"];
      } else {
        return ["<jscode>", functionName];
      }
    }
  }
}
function $p_jl_StackTrace$__decodeClassName__T__T($thiz, encodedName) {
  var dict = $p_jl_StackTrace$__decompressedClasses__O($thiz);
  if ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, encodedName))) {
    var dict$1 = $p_jl_StackTrace$__decompressedClasses__O($thiz);
    var base = $as_T(dict$1[encodedName]);
  } else {
    var base = $p_jl_StackTrace$__loop$1__I__T__T($thiz, 0, encodedName);
  }
  var this$3 = $n(base);
  var this$4 = $n($as_T(this$3.split("_").join(".")));
  return $as_T(this$4.split("\uff3f").join("_"));
}
function $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.O = "java_lang_Object";
    dict.T = "java_lang_String";
    var index = 0;
    while ((index <= 22)) {
      if ((index >= 2)) {
        var key = ("T" + index);
        var value = ("scala_Tuple" + index);
        dict[key] = value;
      }
      var key$1 = ("F" + index);
      var value$1 = ("scala_Function" + index);
      dict[key$1] = value$1;
      index = ((1 + index) | 0);
    }
    $thiz.jl_StackTrace$__f_decompressedClasses = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((1 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_StackTrace$__f_decompressedClasses;
}
function $p_jl_StackTrace$__decompressedClasses__O($thiz) {
  return (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedClasses);
}
function $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.sjsr_ = "scala_scalajs_runtime_";
    dict.sjs_ = "scala_scalajs_";
    dict.sci_ = "scala_collection_immutable_";
    dict.scm_ = "scala_collection_mutable_";
    dict.scg_ = "scala_collection_generic_";
    dict.sc_ = "scala_collection_";
    dict.sr_ = "scala_runtime_";
    dict.s_ = "scala_";
    dict.jl_ = "java_lang_";
    dict.ju_ = "java_util_";
    $thiz.jl_StackTrace$__f_decompressedPrefixes = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((2 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_StackTrace$__f_decompressedPrefixes;
}
function $p_jl_StackTrace$__decompressedPrefixes__O($thiz) {
  return (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedPrefixes);
}
function $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) {
  if (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_StackTrace$__f_compressedPrefixes = Object.keys($p_jl_StackTrace$__decompressedPrefixes__O($thiz));
    $thiz.jl_StackTrace$__f_bitmap$0 = (((4 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_StackTrace$__f_compressedPrefixes;
}
function $p_jl_StackTrace$__compressedPrefixes__O($thiz) {
  return (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_compressedPrefixes);
}
function $p_jl_StackTrace$__decodeMethodName__T__T($thiz, encodedName) {
  var this$1 = $n(encodedName);
  if ($uZ(this$1.startsWith("init___"))) {
    return "<init>";
  } else {
    var this$2 = $n(encodedName);
    var methodNameLen = $uI(this$2.indexOf("__"));
    return ((methodNameLen < 0) ? encodedName : $as_T(encodedName.substring(0, methodNameLen)));
  }
}
function $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, e) {
  return ($uZ((!(!(!e)))) ? [] : ($uZ((!(!(e.arguments && e.stack)))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : ($uZ((!(!(e.stack && e.sourceURL)))) ? $p_jl_StackTrace$__extractSafari__O__O($thiz, e) : ($uZ((!(!(e.stack && e.number)))) ? $p_jl_StackTrace$__extractIE__O__O($thiz, e) : ($uZ((!(!(e.stack && e.fileName)))) ? $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) : ($uZ((!(!(e.message && e["opera#sourceloc"])))) ? ($uZ((!(!(!e.stacktrace)))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : ($uZ((!(!((e.message.indexOf("\n") > (-1.0)) && (e.message.split("\n").length > e.stacktrace.split("\n").length))))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e))) : ($uZ((!(!((e.message && e.stack) && e.stacktrace)))) ? ($uZ((!(!(e.stacktrace.indexOf("called from line") < 0.0)))) ? $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera11__O__O($thiz, e)) : ($uZ((!(!(e.stack && (!e.fileName))))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : $p_jl_StackTrace$__extractOther__O__O($thiz, e)))))))));
}
function $p_jl_StackTrace$__extractChrome__O__O($thiz, e) {
  return $as_T($as_T($as_T($as_T($as_T(($as_T(e.stack) + "\n").replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("^[\\s\\S]+?\\s+at\\s+"), " at ")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^\\s+(at eval )?at\\s+", "gm"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+?)([\\n])", "gm"), "{anonymous}() ($1)$2")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^Object.<anonymous>\\s*\\(([^\\)]+)\\)", "gm"), "{anonymous}() ($1)")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\)) \\((.+)\\)$", "gm"), "$1@$2")).split("\n").slice(0, (-1));
}
function $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) {
  return $as_T($as_T($as_T(e.stack).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("(?:\\n@:0)?\\s+$", "m"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^(?:\\((\\S*)\\))?@", "gm"), "{anonymous}($1)@")).split("\n");
}
function $p_jl_StackTrace$__extractIE__O__O($thiz, e) {
  var qual$1 = $as_T($as_T($as_T($as_T(e.stack).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^\\s*at\\s+(.*)$", "gm"), "$1")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^Anonymous function\\s+", "gm"), "{anonymous}() ")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\))\\s+\\((.+)\\)$", "gm"), "$1@$2")).split("\n");
  return qual$1.slice(1);
}
function $p_jl_StackTrace$__extractSafari__O__O($thiz, e) {
  return $as_T($as_T($as_T($as_T(e.stack).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("\\[native code\\]\\n", "m"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^(?=\\w+Error\\:).*$\\n", "m"), "")).replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^@", "gm"), "{anonymous}()@")).split("\n");
}
function $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension1__T__T__O("Line (\\d+).*script (?:in )?(\\S+)", "i");
  var lines = $as_T(e.message).split("\n");
  var result = [];
  var i = 2;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[2];
      var x$1 = mtch[1];
      var $x_1 = result.push(((("{anonymous}()@" + x) + ":") + x$1));
      $uI($x_1);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension1__T__T__O("Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$", "i");
  var lines = $as_T(e.stacktrace).split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[3];
      var fnName = $as_T(((x !== (void 0)) ? x : "{anonymous}"));
      var x$1 = mtch[2];
      var x$2 = mtch[1];
      var $x_1 = result.push(((((fnName + "()@") + x$1) + ":") + x$2));
      $uI($x_1);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(.*)@(.+):(\\d+)$");
  var lines = $as_T(e.stacktrace).split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[1];
      if ((x !== (void 0))) {
        var t = $as_T(x);
        var fnName = (t + "()");
      } else {
        var fnName = "global code";
      }
      var x$1 = mtch[2];
      var x$2 = mtch[3];
      var $x_1 = result.push(((((fnName + "@") + x$1) + ":") + x$2));
      $uI($x_1);
    }
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOpera11__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^.*line (\\d+), column (\\d+)(?: in (.+))? in (\\S+):$");
  var lines = $as_T(e.stacktrace).split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x = mtch[4];
      var $x_1 = $as_T(x);
      var x$1 = mtch[1];
      var x$2 = mtch[2];
      var location = (((($x_1 + ":") + x$1) + ":") + x$2);
      var x$3 = mtch[2];
      var fnName0 = $as_T(((x$3 !== (void 0)) ? x$3 : "global code"));
      var fnName = $as_T($as_T(fnName0.replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("<anonymous function: (\\S+)>"), "$1")).replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("<anonymous function>"), "{anonymous}"));
      $uI(result.push(((fnName + "@") + location)));
    }
    i = ((2 + i) | 0);
  }
  return result;
}
function $p_jl_StackTrace$__extractOther__O__O($thiz, e) {
  return [];
}
function $p_jl_StackTrace$__loop$1__I__T__T($thiz, i, encodedName$1) {
  while (true) {
    if ((i < $uI($p_jl_StackTrace$__compressedPrefixes__O($thiz).length))) {
      var prefix = $as_T($p_jl_StackTrace$__compressedPrefixes__O($thiz)[i]);
      var this$1 = $n(encodedName$1);
      if ($uZ(this$1.startsWith($n(prefix)))) {
        var dict = $p_jl_StackTrace$__decompressedPrefixes__O($thiz);
        var $x_2 = $as_T(dict[prefix]);
        var this$3 = $n(prefix);
        var $x_1 = encodedName$1.substring(this$3.length);
        return (("" + $x_2) + $as_T($x_1));
      } else {
        i = ((1 + i) | 0);
      }
    } else {
      var this$4 = $n(encodedName$1);
      if ($uZ(this$4.startsWith("L"))) {
        return $as_T(encodedName$1.substring(1));
      } else {
        return encodedName$1;
      }
    }
  }
}
/** @constructor */
function $c_jl_StackTrace$() {
  this.jl_StackTrace$__f_decompressedClasses = null;
  this.jl_StackTrace$__f_decompressedPrefixes = null;
  this.jl_StackTrace$__f_compressedPrefixes = null;
  this.jl_StackTrace$__f_bitmap$0 = 0;
}
$c_jl_StackTrace$.prototype = new $h_O();
$c_jl_StackTrace$.prototype.constructor = $c_jl_StackTrace$;
/** @constructor */
function $h_jl_StackTrace$() {
}
$h_jl_StackTrace$.prototype = $c_jl_StackTrace$.prototype;
$c_jl_StackTrace$.prototype.extract__O__Ajl_StackTraceElement = (function(jsError) {
  var lines = $p_jl_StackTrace$__normalizeStackTraceLines__O__O(this, jsError);
  return $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement(this, lines);
});
var $d_jl_StackTrace$ = new $TypeData().initClass($c_jl_StackTrace$, "java.lang.StackTrace$", ({
  jl_StackTrace$: 1
}));
var $n_jl_StackTrace$;
function $m_jl_StackTrace$() {
  if ((!$n_jl_StackTrace$)) {
    $n_jl_StackTrace$ = new $c_jl_StackTrace$();
  }
  return $n_jl_StackTrace$;
}
/** @constructor */
function $c_jl_StackTrace$StringRE$() {
}
$c_jl_StackTrace$StringRE$.prototype = new $h_O();
$c_jl_StackTrace$StringRE$.prototype.constructor = $c_jl_StackTrace$StringRE$;
/** @constructor */
function $h_jl_StackTrace$StringRE$() {
}
$h_jl_StackTrace$StringRE$.prototype = $c_jl_StackTrace$StringRE$.prototype;
$c_jl_StackTrace$StringRE$.prototype.re$extension0__T__O = (function(this$) {
  return new RegExp(this$);
});
$c_jl_StackTrace$StringRE$.prototype.re$extension1__T__T__O = (function(this$, mods) {
  return new RegExp(this$, mods);
});
var $d_jl_StackTrace$StringRE$ = new $TypeData().initClass($c_jl_StackTrace$StringRE$, "java.lang.StackTrace$StringRE$", ({
  jl_StackTrace$StringRE$: 1
}));
var $n_jl_StackTrace$StringRE$;
function $m_jl_StackTrace$StringRE$() {
  if ((!$n_jl_StackTrace$StringRE$)) {
    $n_jl_StackTrace$StringRE$ = new $c_jl_StackTrace$StringRE$();
  }
  return $n_jl_StackTrace$StringRE$;
}
/** @constructor */
function $c_jl_System$NanoTime$() {
  this.jl_System$NanoTime$__f_highPrecisionTimer = null;
  $n_jl_System$NanoTime$ = this;
  if (($as_T((typeof performance)) !== "undefined")) {
    var x = performance.now;
    var $x_1 = (!(x === (void 0)));
  } else {
    var $x_1 = false;
  }
  this.jl_System$NanoTime$__f_highPrecisionTimer = ($x_1 ? performance : Date);
}
$c_jl_System$NanoTime$.prototype = new $h_O();
$c_jl_System$NanoTime$.prototype.constructor = $c_jl_System$NanoTime$;
/** @constructor */
function $h_jl_System$NanoTime$() {
}
$h_jl_System$NanoTime$.prototype = $c_jl_System$NanoTime$.prototype;
var $d_jl_System$NanoTime$ = new $TypeData().initClass($c_jl_System$NanoTime$, "java.lang.System$NanoTime$", ({
  jl_System$NanoTime$: 1
}));
var $n_jl_System$NanoTime$;
function $m_jl_System$NanoTime$() {
  if ((!$n_jl_System$NanoTime$)) {
    $n_jl_System$NanoTime$ = new $c_jl_System$NanoTime$();
  }
  return $n_jl_System$NanoTime$;
}
/** @constructor */
function $c_jl_System$Streams$() {
  this.jl_System$Streams$__f_err = null;
  $n_jl_System$Streams$ = this;
  this.jl_System$Streams$__f_err = new $c_jl_JSConsoleBasedPrintStream(true);
}
$c_jl_System$Streams$.prototype = new $h_O();
$c_jl_System$Streams$.prototype.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
}
$h_jl_System$Streams$.prototype = $c_jl_System$Streams$.prototype;
var $d_jl_System$Streams$ = new $TypeData().initClass($c_jl_System$Streams$, "java.lang.System$Streams$", ({
  jl_System$Streams$: 1
}));
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$();
  }
  return $n_jl_System$Streams$;
}
function $p_jl_System$SystemProperties$__loadSystemProperties__O($thiz) {
  var result = ({});
  result["java.version"] = "1.8";
  result["java.vm.specification.version"] = "1.8";
  result["java.vm.specification.vendor"] = "Oracle Corporation";
  result["java.vm.specification.name"] = "Java Virtual Machine Specification";
  result["java.vm.name"] = "Scala.js";
  result["java.vm.version"] = "1.21.0";
  result["java.specification.version"] = "1.8";
  result["java.specification.vendor"] = "Oracle Corporation";
  result["java.specification.name"] = "Java Platform API Specification";
  result["file.separator"] = "/";
  result["path.separator"] = ":";
  result["line.separator"] = "\n";
  return result;
}
/** @constructor */
function $c_jl_System$SystemProperties$() {
  this.jl_System$SystemProperties$__f_dict = null;
  this.jl_System$SystemProperties$__f_properties = null;
  $n_jl_System$SystemProperties$ = this;
  this.jl_System$SystemProperties$__f_dict = $p_jl_System$SystemProperties$__loadSystemProperties__O(this);
  this.jl_System$SystemProperties$__f_properties = null;
}
$c_jl_System$SystemProperties$.prototype = new $h_O();
$c_jl_System$SystemProperties$.prototype.constructor = $c_jl_System$SystemProperties$;
/** @constructor */
function $h_jl_System$SystemProperties$() {
}
$h_jl_System$SystemProperties$.prototype = $c_jl_System$SystemProperties$.prototype;
$c_jl_System$SystemProperties$.prototype.getProperty__T__T__T = (function(key, default$1) {
  if ((this.jl_System$SystemProperties$__f_dict !== null)) {
    var dict = this.jl_System$SystemProperties$__f_dict;
    return $as_T(($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, key)) ? dict[key] : default$1));
  } else {
    return $n(this.jl_System$SystemProperties$__f_properties).getProperty__T__T__T(key, default$1);
  }
});
var $d_jl_System$SystemProperties$ = new $TypeData().initClass($c_jl_System$SystemProperties$, "java.lang.System$SystemProperties$", ({
  jl_System$SystemProperties$: 1
}));
var $n_jl_System$SystemProperties$;
function $m_jl_System$SystemProperties$() {
  if ((!$n_jl_System$SystemProperties$)) {
    $n_jl_System$SystemProperties$ = new $c_jl_System$SystemProperties$();
  }
  return $n_jl_System$SystemProperties$;
}
/** @constructor */
function $c_jl_Thread$() {
  this.jl_Thread$__f_SingleThread = null;
  $n_jl_Thread$ = this;
  this.jl_Thread$__f_SingleThread = new $c_jl_Thread((void 0));
}
$c_jl_Thread$.prototype = new $h_O();
$c_jl_Thread$.prototype.constructor = $c_jl_Thread$;
/** @constructor */
function $h_jl_Thread$() {
}
$h_jl_Thread$.prototype = $c_jl_Thread$.prototype;
$c_jl_Thread$.prototype.interrupted__Z = (function() {
  var this$1 = $n(this.jl_Thread$__f_SingleThread);
  var ret = this$1.jl_Thread__f_java$lang$Thread$$interruptedState;
  $n(this.jl_Thread$__f_SingleThread).jl_Thread__f_java$lang$Thread$$interruptedState = false;
  return ret;
});
var $d_jl_Thread$ = new $TypeData().initClass($c_jl_Thread$, "java.lang.Thread$", ({
  jl_Thread$: 1
}));
var $n_jl_Thread$;
function $m_jl_Thread$() {
  if ((!$n_jl_Thread$)) {
    $n_jl_Thread$ = new $c_jl_Thread$();
  }
  return $n_jl_Thread$;
}
function $ct_jl_ThreadLocal__($thiz) {
  $thiz.jl_ThreadLocal__f_hasValue = false;
  return $thiz;
}
/** @constructor */
function $c_jl_ThreadLocal() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
}
$c_jl_ThreadLocal.prototype = new $h_O();
$c_jl_ThreadLocal.prototype.constructor = $c_jl_ThreadLocal;
/** @constructor */
function $h_jl_ThreadLocal() {
}
$h_jl_ThreadLocal.prototype = $c_jl_ThreadLocal.prototype;
$c_jl_ThreadLocal.prototype.initialValue__O = (function() {
  return null;
});
$c_jl_ThreadLocal.prototype.get__O = (function() {
  if ((!this.jl_ThreadLocal__f_hasValue)) {
    this.set__O__V(this.initialValue__O());
  }
  return this.jl_ThreadLocal__f_v;
});
$c_jl_ThreadLocal.prototype.set__O__V = (function(o) {
  this.jl_ThreadLocal__f_v = o;
  this.jl_ThreadLocal__f_hasValue = true;
});
var $d_jl_ThreadLocal = new $TypeData().initClass($c_jl_ThreadLocal, "java.lang.ThreadLocal", ({
  jl_ThreadLocal: 1
}));
/** @constructor */
function $c_jl_Utils$Cache$() {
  this.jl_Utils$Cache$__f_safeHasOwnProperty = null;
  $n_jl_Utils$Cache$ = this;
  this.jl_Utils$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty;
}
$c_jl_Utils$Cache$.prototype = new $h_O();
$c_jl_Utils$Cache$.prototype.constructor = $c_jl_Utils$Cache$;
/** @constructor */
function $h_jl_Utils$Cache$() {
}
$h_jl_Utils$Cache$.prototype = $c_jl_Utils$Cache$.prototype;
var $d_jl_Utils$Cache$ = new $TypeData().initClass($c_jl_Utils$Cache$, "java.lang.Utils$Cache$", ({
  jl_Utils$Cache$: 1
}));
var $n_jl_Utils$Cache$;
function $m_jl_Utils$Cache$() {
  if ((!$n_jl_Utils$Cache$)) {
    $n_jl_Utils$Cache$ = new $c_jl_Utils$Cache$();
  }
  return $n_jl_Utils$Cache$;
}
function $f_jl_Void__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_jl_Void__hashCode__I($thiz) {
  return 0;
}
function $f_jl_Void__toString__T($thiz) {
  return "undefined";
}
function $as_jl_Void(obj) {
  return (((obj === (void 0)) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Void"));
}
function $isArrayOf_jl_Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Void)));
}
function $asArrayOf_jl_Void(obj, depth) {
  return (($isArrayOf_jl_Void(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Void;", depth));
}
var $d_jl_Void = new $TypeData().initClass(0, "java.lang.Void", ({
  jl_Void: 1
}), ((x) => (x === (void 0))));
function $p_jl_reflect_Array$__mismatch__O__E($thiz, array) {
  $n(array);
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument type mismatch");
}
function $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O($thiz, componentType, offset, dimensions$1) {
  var length = $n(dimensions$1).get(offset);
  var result = $n(componentType).data.newArray(length);
  var innerOffset = ((1 + offset) | 0);
  if ((innerOffset < $n(dimensions$1).u.length)) {
    var result2 = $asArrayOf_O(result, 1);
    var this$1 = $n(componentType);
    var innerComponentType = this$1.data.getComponentType();
    var i = 0;
    while ((i !== length)) {
      $n(result2).set(i, $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O($thiz, innerComponentType, innerOffset, dimensions$1));
      i = ((1 + i) | 0);
    }
  }
  return result;
}
/** @constructor */
function $c_jl_reflect_Array$() {
}
$c_jl_reflect_Array$.prototype = new $h_O();
$c_jl_reflect_Array$.prototype.constructor = $c_jl_reflect_Array$;
/** @constructor */
function $h_jl_reflect_Array$() {
}
$h_jl_reflect_Array$.prototype = $c_jl_reflect_Array$.prototype;
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__AI__O = (function(componentType, dimensions) {
  var len = $n(dimensions).u.length;
  if ((len === 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  var outermostComponentType = componentType;
  var i = 1;
  while ((i !== len)) {
    var componentType$1 = outermostComponentType;
    var this$1 = $n(componentType$1).data.newArray(0);
    outermostComponentType = $objectGetClass(this$1);
    i = ((1 + i) | 0);
  }
  return $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O(this, outermostComponentType, 0, dimensions);
});
$c_jl_reflect_Array$.prototype.getLength__O__I = (function(array) {
  if ((array instanceof $ac_O)) {
    var x2 = $asArrayOf_O(array, 1);
    return $n(x2).u.length;
  } else if ((array instanceof $ac_Z)) {
    var x3 = $asArrayOf_Z(array, 1);
    return $n(x3).u.length;
  } else if ((array instanceof $ac_C)) {
    var x4 = $asArrayOf_C(array, 1);
    return $n(x4).u.length;
  } else if ((array instanceof $ac_B)) {
    var x5 = $asArrayOf_B(array, 1);
    return $n(x5).u.length;
  } else if ((array instanceof $ac_S)) {
    var x6 = $asArrayOf_S(array, 1);
    return $n(x6).u.length;
  } else if ((array instanceof $ac_I)) {
    var x7 = $asArrayOf_I(array, 1);
    return $n(x7).u.length;
  } else if ((array instanceof $ac_J)) {
    var x8 = $asArrayOf_J(array, 1);
    return (($n(x8).u.length >>> 1) | 0);
  } else if ((array instanceof $ac_F)) {
    var x9 = $asArrayOf_F(array, 1);
    return $n(x9).u.length;
  } else if ((array instanceof $ac_D)) {
    var x10 = $asArrayOf_D(array, 1);
    return $n(x10).u.length;
  } else {
    $p_jl_reflect_Array$__mismatch__O__E(this, array);
  }
});
var $d_jl_reflect_Array$ = new $TypeData().initClass($c_jl_reflect_Array$, "java.lang.reflect.Array$", ({
  jl_reflect_Array$: 1
}));
var $n_jl_reflect_Array$;
function $m_jl_reflect_Array$() {
  if ((!$n_jl_reflect_Array$)) {
    $n_jl_reflect_Array$ = new $c_jl_reflect_Array$();
  }
  return $n_jl_reflect_Array$;
}
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = quot;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = rem;
}
$c_Ljava_math_BigInteger$QuotAndRem.prototype = new $h_O();
$c_Ljava_math_BigInteger$QuotAndRem.prototype.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
}
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $c_Ljava_math_BigInteger$QuotAndRem.prototype;
$c_Ljava_math_BigInteger$QuotAndRem.prototype.toArray__ALjava_math_BigInteger = (function() {
  return new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$QuotAndRem__f_quot, this.Ljava_math_BigInteger$QuotAndRem__f_rem]);
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $TypeData().initClass($c_Ljava_math_BigInteger$QuotAndRem, "java.math.BigInteger$QuotAndRem", ({
  Ljava_math_BigInteger$QuotAndRem: 1
}));
/** @constructor */
function $c_Ljava_math_BitLevel$() {
}
$c_Ljava_math_BitLevel$.prototype = new $h_O();
$c_Ljava_math_BitLevel$.prototype.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
}
$h_Ljava_math_BitLevel$.prototype = $c_Ljava_math_BitLevel$.prototype;
$c_Ljava_math_BitLevel$.prototype.bitLength__Ljava_math_BigInteger__I = (function(bi) {
  if (($n(bi).Ljava_math_BigInteger__f_sign === 0)) {
    return 0;
  } else {
    var bLength = ($n(bi).Ljava_math_BigInteger__f_numberLength << 5);
    var highDigit = $n($n(bi).Ljava_math_BigInteger__f_digits).get((($n(bi).Ljava_math_BigInteger__f_numberLength - 1) | 0));
    if (($n(bi).Ljava_math_BigInteger__f_sign < 0)) {
      var i = $n(bi).getFirstNonzeroDigit__I();
      if ((i === (($n(bi).Ljava_math_BigInteger__f_numberLength - 1) | 0))) {
        highDigit = ((highDigit - 1) | 0);
      }
    }
    var $x_1 = bLength;
    var i$1 = highDigit;
    bLength = (($x_1 - Math.clz32(i$1)) | 0);
    return bLength;
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  var offset = ((andCount === 0) ? 0 : 1);
  var resLength = (((($n(source).Ljava_math_BigInteger__f_numberLength + intCount) | 0) + offset) | 0);
  $m_Ljava_math_BigInteger$().checkRangeBasedOnIntArrayLength__I__V(resLength);
  var resDigits = new $ac_I(resLength);
  this.shiftLeft__AI__AI__I__I__V(resDigits, $n(source).Ljava_math_BigInteger__f_digits, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), $n(source).Ljava_math_BigInteger__f_sign, resLength, resDigits);
  result.cutOffLeadingZeroes__V();
  return result;
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__AI__AI__I__I__V = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var x4 = (($n(result).u.length - intCount) | 0);
    $systemArraycopy($n(source), 0, $n(result), intCount, x4);
  } else {
    var rightShiftCount = ((32 - count) | 0);
    $n(result).set((($n(result).u.length - 1) | 0), 0);
    var i = (($n(result).u.length - 1) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      $n(result).set(ev$1, ($n(result).get(ev$1) | (($n(source).get(((((i - intCount) | 0) - 1) | 0)) >>> rightShiftCount) | 0)));
      $n(result).set(((i - 1) | 0), ($n(source).get(((((i - intCount) | 0) - 1) | 0)) << count));
      i = ((i - 1) | 0);
    }
  }
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var value = i$1;
    $n(result).set(value, 0);
    i$1 = ((1 + i$1) | 0);
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(source) {
  var srcLen = $n(source).Ljava_math_BigInteger__f_numberLength;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $ac_I(resLen);
  this.shiftLeftOneBit__AI__AI__I__V(resDigits, $n(source).Ljava_math_BigInteger__f_digits, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), $n(source).Ljava_math_BigInteger__f_sign, resLen, resDigits);
  result.cutOffLeadingZeroes__V();
  return result;
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__AI__AI__I__V = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var value = i;
    var iVal = $n(source).get(value);
    $n(result).set(value, ((iVal << 1) | elem));
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0);
  }
  if ((elem !== 0)) {
    $n(result).set(srcLen, elem);
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  if ((intCount >= $n(source).Ljava_math_BigInteger__f_numberLength)) {
    return (($n(source).Ljava_math_BigInteger__f_sign < 0) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO);
  } else {
    var resLength = (($n(source).Ljava_math_BigInteger__f_numberLength - intCount) | 0);
    var resDigits = new $ac_I(((1 + resLength) | 0));
    this.shiftRight__AI__I__AI__I__I__Z(resDigits, resLength, $n(source).Ljava_math_BigInteger__f_digits, intCount, andCount);
    if (($n(source).Ljava_math_BigInteger__f_sign < 0)) {
      var i = 0;
      while (((i < intCount) && ($n($n(source).Ljava_math_BigInteger__f_digits).get(i) === 0))) {
        i = ((1 + i) | 0);
      }
      var cmp = (($n($n(source).Ljava_math_BigInteger__f_digits).get(i) << ((-andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && (resDigits.get(i) === (-1)))) {
          resDigits.set(i, 0);
          i = ((1 + i) | 0);
        }
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0);
        }
        var ev$1 = i;
        resDigits.set(ev$1, ((1 + resDigits.get(ev$1)) | 0));
      }
    }
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), $n(source).Ljava_math_BigInteger__f_sign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result;
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__AI__I__AI__I__I__Z = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & ($n(source).get(i) === 0))));
    i = ((1 + i) | 0);
  }
  if ((count === 0)) {
    $systemArraycopy($n(source), intCount, $n(result), 0, resultLen);
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & (($n(source).get(i) << leftShiftCount) === 0))));
    i = 0;
    while ((i < ((resultLen - 1) | 0))) {
      $n(result).set(i, ((($n(source).get(((i + intCount) | 0)) >>> count) | 0) | ($n(source).get(((1 + ((i + intCount) | 0)) | 0)) << leftShiftCount)));
      i = ((1 + i) | 0);
    }
    $n(result).set(i, (($n(source).get(((i + intCount) | 0)) >>> count) | 0));
    i = ((1 + i) | 0);
  }
  return allZero;
});
var $d_Ljava_math_BitLevel$ = new $TypeData().initClass($c_Ljava_math_BitLevel$, "java.math.BitLevel$", ({
  Ljava_math_BitLevel$: 1
}));
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$();
  }
  return $n_Ljava_math_BitLevel$;
}
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var this$1 = $n(s);
  var len = this$1.length;
  while (true) {
    if ((zeroPrefixLength < len)) {
      var this$2 = $n(s);
      var index = zeroPrefixLength;
      var $x_1 = ($charAt(this$2, index) === 48);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      zeroPrefixLength = ((1 + zeroPrefixLength) | 0);
    } else {
      break;
    }
  }
  var this$3 = $n(s);
  var beginIndex = zeroPrefixLength;
  if (((beginIndex < 0) || (beginIndex > this$3.length))) {
    $charAt(this$3, beginIndex);
  }
  return $as_T(this$3.substring(beginIndex));
}
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.Ljava_math_Conversion$__f_DigitFitInInt = null;
  this.Ljava_math_Conversion$__f_BigRadices = null;
  $n_Ljava_math_Conversion$ = this;
  this.Ljava_math_Conversion$__f_DigitFitInInt = new $ac_I(new Int32Array([(-1), (-1), 31, 19, 15, 13, 11, 11, 10, 9, 9, 8, 8, 8, 8, 7, 7, 7, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 5]));
  this.Ljava_math_Conversion$__f_BigRadices = new $ac_I(new Int32Array([(-2147483648), 1162261467, 1073741824, 1220703125, 362797056, 1977326743, 1073741824, 387420489, 1000000000, 214358881, 429981696, 815730721, 1475789056, 170859375, 268435456, 410338673, 612220032, 893871739, 1280000000, 1801088541, 113379904, 148035889, 191102976, 244140625, 308915776, 387420489, 481890304, 594823321, 729000000, 887503681, 1073741824, 1291467969, 1544804416, 1838265625, 60466176]));
}
$c_Ljava_math_Conversion$.prototype = new $h_O();
$c_Ljava_math_Conversion$.prototype.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
}
$h_Ljava_math_Conversion$.prototype = $c_Ljava_math_Conversion$.prototype;
$c_Ljava_math_Conversion$.prototype.bigInteger2String__Ljava_math_BigInteger__I__T = (function(bi, radix) {
  var sign = $n(bi).Ljava_math_BigInteger__f_sign;
  var numberLength = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var digits = $n(bi).Ljava_math_BigInteger__f_digits;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var highDigit = $n(digits).get(((numberLength - 1) | 0));
    var v_$_lo = highDigit;
    var v_$_hi = 0;
    if ((sign < 0)) {
      var x_$_lo = v_$_lo;
      var x_$_hi = v_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$1 = ((((-x_$_hi) | 0) + ((x_$_lo | lo) >> 31)) | 0);
      v_$_lo = lo;
      v_$_hi = hi$1;
    }
    var this$4 = $m_jl_Long$();
    var i_$_lo = v_$_lo;
    var i_$_hi = v_$_hi;
    return (((radix === 10) || ((((radix - 2) | 0) >>> 0) > 34)) ? $m_RTLong$().toString__I__I__T(i_$_lo, i_$_hi) : this$4.java$lang$Long$$toStringImplJS__J__I__T(i_$_lo, i_$_hi, radix));
  } else if (((radix === 10) || ((((radix - 2) | 0) >>> 0) > 34))) {
    var this$7 = $n(bi);
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$7);
  } else {
    var bitsForRadixDigit = 0.0;
    var a = radix;
    bitsForRadixDigit = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
    var addForSign = ((sign < 0) ? 1 : 0);
    var this$10 = $n($n(bi).abs__Ljava_math_BigInteger());
    var biAbsLen = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$10);
    var resLenInChars = ((1 + $doubleToInt(((biAbsLen / bitsForRadixDigit) + addForSign))) | 0);
    var elem = null;
    elem = "";
    var elem$1 = 0;
    elem$1 = resLenInChars;
    var elem$2 = 0;
    elem$2 = 0;
    if ((radix !== 16)) {
      var temp = new $ac_I(numberLength);
      $systemArraycopy($n(digits), 0, temp, 0, numberLength);
      var elem$3 = 0;
      elem$3 = numberLength;
      var charsPerInt = $n(this.Ljava_math_Conversion$__f_DigitFitInInt).get(radix);
      var bigRadix = $n(this.Ljava_math_Conversion$__f_BigRadices).get(((radix - 2) | 0));
      while (true) {
        elem$2 = $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(temp, temp, elem$3, bigRadix);
        var previous = elem$1;
        while (true) {
          elem$1 = ((elem$1 - 1) | 0);
          var this$15 = $m_jl_Character$().forDigit__I__I__C(((elem$2 % $checkIntDivisor(radix)) | 0), radix);
          elem = (("" + $cToS(this$15)) + $as_T(elem));
          elem$2 = ((elem$2 / $checkIntDivisor(radix)) | 0);
          if (((elem$2 !== 0) && (elem$1 !== 0))) {
            continue;
          }
          break;
        }
        var delta = ((((charsPerInt - previous) | 0) + elem$1) | 0);
        var i$1 = 0;
        while (((i$1 < delta) && (elem$1 > 0))) {
          elem$1 = ((elem$1 - 1) | 0);
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0);
        }
        i$1 = ((elem$3 - 1) | 0);
        while (((i$1 > 0) && (temp.get(i$1) === 0))) {
          i$1 = ((i$1 - 1) | 0);
        }
        elem$3 = ((1 + i$1) | 0);
        if ((!((elem$3 === 1) && (temp.get(0) === 0)))) {
          continue;
        }
        break;
      }
    } else {
      var i$2 = 0;
      while ((i$2 < numberLength)) {
        var value = i$2;
        var j = 0;
        while (((j < 8) && (elem$1 > 0))) {
          elem$2 = (15 & ($n(digits).get(value) >> (j << 2)));
          elem$1 = ((elem$1 - 1) | 0);
          var i$3 = elem$2;
          elem = (("" + $as_T((i$3 >>> 0.0).toString(16))) + $as_T(elem));
          j = ((1 + j) | 0);
        }
        i$2 = ((1 + i$2) | 0);
      }
    }
    var dropLen = 0;
    while (true) {
      var this$22 = $n($as_T(elem));
      var index = dropLen;
      if (($charAt(this$22, index) === 48)) {
        dropLen = ((1 + dropLen) | 0);
      } else {
        break;
      }
    }
    if ((dropLen !== 0)) {
      var this$23 = $n($as_T(elem));
      var beginIndex = dropLen;
      if (((beginIndex < 0) || (beginIndex > this$23.length))) {
        $charAt(this$23, beginIndex);
      }
      elem = $as_T(this$23.substring(beginIndex));
    }
    return ((sign === (-1)) ? ("-" + $as_T(elem)) : $as_T(elem));
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__Ljava_math_BigInteger__T = (function(bi) {
  var sign = $n(bi).Ljava_math_BigInteger__f_sign;
  var numberLength = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var digits = $n(bi).Ljava_math_BigInteger__f_digits;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var i = $n(digits).get(0);
    var absStr = $as_T((i >>> 0.0).toString(10));
    return ((sign < 0) ? ("-" + absStr) : absStr);
  } else {
    var result = "";
    var temp = new $ac_I(numberLength);
    var tempLen = numberLength;
    var x4 = tempLen;
    $systemArraycopy($n(digits), 0, temp, 0, x4);
    while (true) {
      var rem = 0;
      var i$1 = ((tempLen - 1) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = temp.get(i$1);
        var hi$2 = ((value + (((value$1 & (~value$1)) >>> 31) | 0)) | 0);
        var b0 = (65535 & value$1);
        var b1 = ((value$1 >>> 16) | 0);
        var a0b0 = Math.imul(48770, b0);
        var a1b0 = Math.imul(4832, b0);
        var a0b1 = Math.imul(48770, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$3 = ((((Math.imul(4832, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var b0$1 = (65535 & value$1);
        var b1$1 = ((value$1 >>> 16) | 0);
        var a0b0$1 = Math.imul(19247, b0$1);
        var a1b0$1 = Math.imul(28009, b0$1);
        var a0b1$1 = Math.imul(19247, b1$1);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$4 = ((((Math.imul(28009, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$2 = ((lo + hi$4) | 0);
        var hi$5 = ((hi$3 + ((((lo & hi$4) | ((lo | hi$4) & (~lo$2))) >>> 31) | 0)) | 0);
        var b0$2 = (65535 & hi$2);
        var b1$2 = ((hi$2 >>> 16) | 0);
        var a0b0$2 = Math.imul(48770, b0$2);
        var a1b0$2 = Math.imul(4832, b0$2);
        var a0b1$2 = Math.imul(48770, b1$2);
        var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
        var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
        var hi$6 = ((((Math.imul(4832, b1$2) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
        var lo$4 = ((lo$3 + hi$5) | 0);
        var hi$7 = ((hi$6 + ((((lo$3 & hi$5) | ((lo$3 | hi$5) & (~lo$4))) >>> 31) | 0)) | 0);
        var b0$3 = (65535 & hi$2);
        var b1$3 = ((hi$2 >>> 16) | 0);
        var a0b0$3 = Math.imul(19247, b0$3);
        var a1b0$3 = Math.imul(28009, b0$3);
        var a0b1$3 = Math.imul(19247, b1$3);
        var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
        var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
        var hi$8 = ((((Math.imul(28009, b1$3) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
        var lo$6 = ((lo$2 + lo$5) | 0);
        var hi$9 = ((hi$8 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
        var lo$7 = ((lo$4 + hi$9) | 0);
        var hi$10 = ((hi$7 + ((((lo$4 & hi$9) | ((lo$4 | hi$9) & (~lo$7))) >>> 31) | 0)) | 0);
        var lo$8 = ((value$1 - lo$7) | 0);
        var hi$11 = ((((hi$2 - hi$10) | 0) + ((((~value$1) & lo$7) | ((~(value$1 ^ lo$7)) & lo$8)) >> 31)) | 0);
        var lo$9 = (((lo$8 >>> 1) | 0) | (hi$11 << 31));
        var hi$12 = ((hi$11 >>> 1) | 0);
        var lo$10 = ((lo$9 + lo$7) | 0);
        var hi$13 = ((((hi$12 + hi$10) | 0) + ((((lo$9 & lo$7) | ((lo$9 | lo$7) & (~lo$10))) >>> 31) | 0)) | 0);
        var lo$11 = (((lo$10 >>> 29) | 0) | (hi$13 << 3));
        temp.set(i$1, lo$11);
        var b0$4 = (65535 & lo$11);
        var b1$4 = ((lo$11 >>> 16) | 0);
        var a0b0$4 = Math.imul(51712, b0$4);
        var a1b0$4 = Math.imul(15258, b0$4);
        var a0b1$4 = Math.imul(51712, b1$4);
        var lo$12 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
        var lo$13 = ((value$1 - lo$12) | 0);
        rem = lo$13;
        i$1 = ((i$1 - 1) | 0);
      }
      var this$33 = rem;
      var remStr = ("" + this$33);
      var beginIndex = remStr.length;
      if (((beginIndex >>> 0) > 9)) {
        $charAt("000000000", beginIndex);
      }
      var padding = $as_T("000000000".substring(beginIndex));
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && (temp.get(((tempLen - 1) | 0)) === 0))) {
        tempLen = ((tempLen - 1) | 0);
      }
      if ((tempLen !== 0)) {
      } else {
        break;
      }
    }
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result);
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__J__I__T = (function(value_$_lo, value_$_hi, scale) {
  if (((value_$_lo | value_$_hi) === 0)) {
    switch (scale) {
      case 0: {
        return "0";
        break;
      }
      case 1: {
        return "0.0";
        break;
      }
      case 2: {
        return "0.00";
        break;
      }
      case 3: {
        return "0.000";
        break;
      }
      case 4: {
        return "0.0000";
        break;
      }
      case 5: {
        return "0.00000";
        break;
      }
      case 6: {
        return "0.000000";
        break;
      }
      default: {
        if ((scale === (-2147483648))) {
          var scaleVal = "2147483648";
        } else {
          var i = ((-scale) | 0);
          var scaleVal = ("" + i);
        }
        var result = ((scale < 0) ? "0E+" : "0E");
        return (result + scaleVal);
      }
    }
  } else {
    var negNumber = (value_$_hi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var lo = ((-value_$_lo) | 0);
      var hi = ((((-value_$_hi) | 0) + ((value_$_lo | lo) >> 31)) | 0);
      var v_$_lo = lo;
      var v_$_hi = hi;
    } else {
      var v_$_lo = value_$_lo;
      var v_$_hi = value_$_hi;
    }
    while (true) {
      var prev_$_lo = v_$_lo;
      var prev_$_hi = v_$_hi;
      var num_$_lo = v_$_lo;
      var num_$_hi = v_$_hi;
      var hi$1 = (num_$_hi >> 31);
      var b0 = (65535 & num_$_lo);
      var b1 = ((num_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(26214, b0);
      var a1b0 = Math.imul(26214, b0);
      var a0b1 = Math.imul(26214, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(26214, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var b0$1 = (65535 & num_$_lo);
      var b1$1 = ((num_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(26215, b0$1);
      var a1b0$1 = Math.imul(26214, b0$1);
      var a0b1$1 = Math.imul(26215, b1$1);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$3 = ((((Math.imul(26214, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var lo$3 = ((lo$1 + hi$3) | 0);
      var hi$4 = ((hi$2 + ((((lo$1 & hi$3) | ((lo$1 | hi$3) & (~lo$3))) >>> 31) | 0)) | 0);
      var b0$2 = (65535 & num_$_hi);
      var b1$2 = ((num_$_hi >>> 16) | 0);
      var a0b0$2 = Math.imul(26214, b0$2);
      var a1b0$2 = Math.imul(26214, b0$2);
      var a0b1$2 = Math.imul(26214, b1$2);
      var lo$4 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$5 = ((((((Math.imul(1717986918, hi$1) + Math.imul(26214, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
      var hi$6 = (hi$4 >> 31);
      var lo$5 = ((lo$4 + hi$4) | 0);
      var hi$7 = ((((hi$5 + hi$6) | 0) + ((((lo$4 & hi$4) | ((lo$4 | hi$4) & (~lo$5))) >>> 31) | 0)) | 0);
      var b0$3 = (65535 & num_$_hi);
      var b1$3 = ((num_$_hi >>> 16) | 0);
      var a0b0$3 = Math.imul(26215, b0$3);
      var a1b0$3 = Math.imul(26214, b0$3);
      var a0b1$3 = Math.imul(26215, b1$3);
      var lo$6 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$8 = ((((((Math.imul(1717986919, hi$1) + Math.imul(26214, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
      var lo$7 = ((lo$3 + lo$6) | 0);
      var hi$9 = ((hi$8 + ((((lo$3 & lo$6) | ((lo$3 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
      var hi$10 = (hi$9 >> 31);
      var lo$8 = ((lo$5 + hi$9) | 0);
      var hi$11 = ((((hi$7 + hi$10) | 0) + ((((lo$5 & hi$9) | ((lo$5 | hi$9) & (~lo$8))) >>> 31) | 0)) | 0);
      var lo$9 = (((lo$8 >>> 2) | 0) | (hi$11 << 30));
      var hi$12 = (hi$11 >> 2);
      var lo$10 = ((num_$_hi >>> 31) | 0);
      var lo$11 = ((lo$9 + lo$10) | 0);
      var hi$13 = ((hi$12 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
      v_$_lo = lo$11;
      v_$_hi = hi$13;
      currentChar = ((currentChar - 1) | 0);
      var x_$_lo = v_$_lo;
      var x_$_hi = v_$_hi;
      var b0$4 = (65535 & x_$_lo);
      var b1$4 = ((x_$_lo >>> 16) | 0);
      var a0b0$4 = Math.imul(10, b0$4);
      var a0b1$4 = Math.imul(10, b1$4);
      var lo$12 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
      var lo$13 = ((prev_$_lo - lo$12) | 0);
      elem = (("" + lo$13) + $as_T(elem));
      var x$1_$_lo = v_$_lo;
      var x$1_$_hi = v_$_hi;
      if (((x$1_$_lo | x$1_$_hi) !== 0)) {
      } else {
        break;
      }
    }
    var value$1 = ((18 - currentChar) | 0);
    var hi$16 = (value$1 >> 31);
    var hi$17 = (scale >> 31);
    var lo$14 = ((value$1 - scale) | 0);
    var hi$18 = ((((hi$16 - hi$17) | 0) + ((((~value$1) & scale) | ((~(value$1 ^ scale)) & lo$14)) >> 31)) | 0);
    var lo$15 = ((lo$14 - 1) | 0);
    var hi$19 = ((((hi$18 - 1) | 0) + (((lo$14 | (~lo$15)) >>> 31) | 0)) | 0);
    if (((scale > 0) && ((hi$19 === (-1)) ? ((lo$15 >>> 0) >= 4294967290) : (hi$19 > (-1))))) {
      var index = ((1 + lo$15) | 0);
      if ((index > 0)) {
        var this$34 = $n($as_T(elem));
        if ((index > this$34.length)) {
          $charAt(this$34, index);
        }
        if ((index < 0)) {
          $charAt(this$34, (-1));
        }
        var $x_1 = $as_T(this$34.substring(0, index));
        var this$35 = $n($as_T(elem));
        if (((index < 0) || (index > this$35.length))) {
          $charAt(this$35, index);
        }
        elem = (($x_1 + ".") + $as_T(this$35.substring(index)));
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0);
        }
        elem = ("0." + $as_T(elem));
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$19 === 0) ? (lo$15 !== 0) : (hi$19 > 0)) ? ("E+" + $s_RTLong__toString__I__I__T(lo$15, hi$19)) : ("E" + $s_RTLong__toString__I__I__T(lo$15, hi$19)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$39 = $n($as_T(elem));
        if ((this$39.length < 1)) {
          $charAt(this$39, 1);
        }
        var $x_2 = $as_T(this$39.substring(0, 1));
        var this$40 = $n($as_T(elem));
        if ((this$40.length < 1)) {
          $charAt(this$40, 1);
        }
        elem = ((($x_2 + ".") + $as_T(this$40.substring(1))) + exponentStr);
      } else {
        elem = ($as_T(elem) + exponentStr);
      }
    }
    return (negNumber ? ("-" + $as_T(elem)) : $as_T(elem));
  }
});
var $d_Ljava_math_Conversion$ = new $TypeData().initClass($c_Ljava_math_Conversion$, "java.math.Conversion$", ({
  Ljava_math_Conversion$: 1
}));
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$();
  }
  return $n_Ljava_math_Conversion$;
}
/** @constructor */
function $c_Ljava_math_Division$() {
}
$c_Ljava_math_Division$.prototype = new $h_O();
$c_Ljava_math_Division$.prototype.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
}
$h_Ljava_math_Division$.prototype = $c_Ljava_math_Division$.prototype;
$c_Ljava_math_Division$.prototype.divide__AI__I__AI__I__AI__I__AI = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $ac_I(((1 + aLength) | 0));
  var normB = new $ac_I(((1 + bLength) | 0));
  var i = $n(b).get(((bLength - 1) | 0));
  var divisorShift = Math.clz32(i);
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normA, a, 0, divisorShift);
  } else {
    $systemArraycopy($n(a), 0, normA, 0, aLength);
    $systemArraycopy($n(b), 0, normB, 0, bLength);
  }
  var firstDivisorDigit = normB.get(((bLength - 1) | 0));
  var i$1 = ((quotLength - 1) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if ((normA.get(elem) === firstDivisorDigit)) {
      elem$1 = (-1);
    } else {
      var value = normA.get(elem);
      var value$1 = normA.get(((elem - 1) | 0));
      var hi$2 = ((value + (((value$1 & (~value$1)) >>> 31) | 0)) | 0);
      var this$13 = $m_RTLong$();
      var $x_1 = this$13.divideUnsignedImpl__I__I__I__I__J(value$1, hi$2, firstDivisorDigit, 0);
      var quotient_$_lo = $x_1.l;
      var quotient_$_hi = $x_1.h;
      elem$1 = quotient_$_lo;
      var a0 = (65535 & quotient_$_lo);
      var a1 = ((quotient_$_lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var lo$1 = ((value$1 - lo) | 0);
      var elem$2 = 0;
      elem$2 = lo$1;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = ((elem$1 - 1) | 0);
          var value$2 = elem$1;
          var value$3 = normB.get(((bLength - 2) | 0));
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = Math.imul(a0$1, b0$1);
          var a1b0$1 = Math.imul(a1$1, b0$1);
          var a0b1$1 = Math.imul(a0$1, b1$1);
          var lo$2 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$8 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = normA.get(((elem - 2) | 0));
          var hi$11 = ((value$4 + (((value$5 & (~value$5)) >>> 31) | 0)) | 0);
          var value$6 = elem$2;
          var lo$3 = ((value$6 + firstDivisorDigit) | 0);
          var hi$14 = ((((value$6 & firstDivisorDigit) | ((value$6 | firstDivisorDigit) & (~lo$3))) >>> 31) | 0);
          if ((hi$14 === 0)) {
            elem$2 = lo$3;
            if (((hi$8 === hi$11) ? ((lo$2 >>> 0) > (value$5 >>> 0)) : ((hi$8 >>> 0) > (hi$11 >>> 0)))) {
              continue;
            }
          }
          break;
        }
      }
    }
    if ((elem$1 !== 0)) {
      var borrow = $m_Ljava_math_Division$().multiplyAndSubtract__AI__I__AI__I__I__I(normA, ((elem - bLength) | 0), normB, bLength, elem$1);
      if ((borrow !== 0)) {
        elem$1 = ((elem$1 - 1) | 0);
        var elem$3_$_lo = 0;
        var elem$3_$_hi = 0;
        elem$3_$_lo = 0;
        elem$3_$_hi = 0;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var value$7 = i$2;
          var x_$_lo = elem$3_$_lo;
          var x_$_hi = elem$3_$_hi;
          var value$8 = normA.get(((((elem - bLength) | 0) + value$7) | 0));
          var value$9 = normB.get(value$7);
          var lo$4 = ((value$8 + value$9) | 0);
          var hi$17 = ((((value$8 & value$9) | ((value$8 | value$9) & (~lo$4))) >>> 31) | 0);
          var lo$5 = ((x_$_lo + lo$4) | 0);
          var hi$18 = ((((x_$_hi + hi$17) | 0) + ((((x_$_lo & lo$4) | ((x_$_lo | lo$4) & (~lo$5))) >>> 31) | 0)) | 0);
          elem$3_$_lo = lo$5;
          elem$3_$_hi = hi$18;
          var $x_2 = elem;
          var x$1_$_lo = elem$3_$_lo;
          var x$1_$_hi = elem$3_$_hi;
          normA.set((((($x_2 - bLength) | 0) + value$7) | 0), x$1_$_lo);
          var x$2_$_lo = elem$3_$_lo;
          var x$2_$_hi = elem$3_$_hi;
          elem$3_$_lo = x$2_$_hi;
          elem$3_$_hi = 0;
          i$2 = ((1 + i$2) | 0);
        }
      }
    }
    if ((quot !== null)) {
      $n(quot).set(i$1, elem$1);
    }
    elem = ((elem - 1) | 0);
    i$1 = ((i$1 - 1) | 0);
  }
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftRight__AI__I__AI__I__I__Z(normB, bLength, normA, 0, divisorShift);
    return normB;
  } else {
    $systemArraycopy(normA, 0, normB, 0, bLength);
    return normA;
  }
});
$c_Ljava_math_Division$.prototype.divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem = (function(bi, divisor, divisorSign) {
  var valDigits = $n(bi).Ljava_math_BigInteger__f_digits;
  var valLen = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var valSign = $n(bi).Ljava_math_BigInteger__f_sign;
  if ((valLen === 1)) {
    var valDigit = $n(valDigits).get(0);
    var value = (((valDigit >>> 0) / ($checkIntDivisor(divisor) >>> 0)) | 0);
    var quo_$_lo = value;
    var quo_$_hi = 0;
    var value$1 = (((valDigit >>> 0) % ($checkIntDivisor(divisor) >>> 0)) | 0);
    var rem_$_lo = value$1;
    var rem_$_hi = 0;
    if ((valSign !== divisorSign)) {
      var x_$_lo = quo_$_lo;
      var x_$_hi = quo_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$2 = ((((-x_$_hi) | 0) + ((x_$_lo | lo) >> 31)) | 0);
      quo_$_lo = lo;
      quo_$_hi = hi$2;
    }
    if ((valSign < 0)) {
      var x$1_$_lo = rem_$_lo;
      var x$1_$_hi = rem_$_hi;
      var lo$1 = ((-x$1_$_lo) | 0);
      var hi$3 = ((((-x$1_$_hi) | 0) + ((x$1_$_lo | lo$1) >> 31)) | 0);
      rem_$_lo = lo$1;
      rem_$_hi = hi$3;
    }
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(quo_$_lo, quo_$_hi), $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(rem_$_lo, rem_$_hi));
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $ac_I(valLen);
    var div = this.divideArrayByInt__AI__AI__I__I__I(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $ac_I(new Int32Array([div]));
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.cutOffLeadingZeroes__V();
    result1.cutOffLeadingZeroes__V();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
  }
});
$c_Ljava_math_Division$.prototype.divideArrayByInt__AI__AI__I__I__I = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = ((srcLength - 1) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = $n(src).get(i);
    var this$9 = $m_RTLong$();
    var $x_1 = this$9.divideUnsignedImpl__I__I__I__I__J(value$1, value, divisor, 0);
    var quot_$_lo = $x_1.l;
    var quot_$_hi = $x_1.h;
    var a0 = (65535 & quot_$_lo);
    var a1 = ((quot_$_lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    var b1 = ((divisor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var lo$1 = ((value$1 - lo) | 0);
    rem = lo$1;
    $n(dest).set(i, quot_$_lo);
    i = ((i - 1) | 0);
  }
  return rem;
});
$c_Ljava_math_Division$.prototype.multiplyAndSubtract__AI__I__AI__I__I__I = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = $n(b).get(value);
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((hi$2 + ((((lo & c$1) | ((lo | c$1) & (~lo$1))) >>> 31) | 0)) | 0);
    var value$1 = $n(a).get(((start + value) | 0));
    var lo$2 = ((value$1 - lo$1) | 0);
    var hi$6 = ((((~value$1) & lo$1) | ((~(value$1 ^ lo$1)) & lo$2)) >> 31);
    var value$2 = elem$1;
    var hi$7 = (value$2 >> 31);
    var lo$3 = ((lo$2 + value$2) | 0);
    var hi$8 = ((((hi$6 + hi$7) | 0) + ((((lo$2 & value$2) | ((lo$2 | value$2) & (~lo$3))) >>> 31) | 0)) | 0);
    $n(a).set(((start + value) | 0), lo$3);
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  var value$3 = $n(a).get(((start + bLen) | 0));
  var value$4 = elem;
  var lo$4 = ((value$3 - value$4) | 0);
  var hi$13 = ((((~value$3) & value$4) | ((~(value$3 ^ value$4)) & lo$4)) >> 31);
  var value$5 = elem$1;
  var hi$14 = (value$5 >> 31);
  var lo$5 = ((lo$4 + value$5) | 0);
  var hi$15 = ((((hi$13 + hi$14) | 0) + ((((lo$4 & value$5) | ((lo$4 | value$5) & (~lo$5))) >>> 31) | 0)) | 0);
  $n(a).set(((start + bLen) | 0), lo$5);
  return hi$15;
});
var $d_Ljava_math_Division$ = new $TypeData().initClass($c_Ljava_math_Division$, "java.math.Division$", ({
  Ljava_math_Division$: 1
}));
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$();
  }
  return $n_Ljava_math_Division$;
}
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = $n(a).get(0);
  var value$1 = $n(b).get(0);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((value & value$1) | ((value | value$1) & (~lo))) >>> 31) | 0);
  $n(res).set(0, lo);
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = $n(a).get(i);
      var value$3 = $n(b).get(i);
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = ((((value$2 & value$3) | ((value$2 | value$3) & (~lo$1))) >>> 31) | 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((hi$6 + ((((lo$1 & value$4) | ((lo$1 | value$4) & (~lo$2))) >>> 31) | 0)) | 0);
      $n(res).set(i, lo$2);
      carry = hi$8;
      i = ((1 + i) | 0);
    }
    while ((i < aSize)) {
      var value$5 = $n(a).get(i);
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = ((((value$5 & value$6) | ((value$5 | value$6) & (~lo$3))) >>> 31) | 0);
      $n(res).set(i, lo$3);
      carry = hi$12;
      i = ((1 + i) | 0);
    }
  } else {
    while ((i < aSize)) {
      var value$7 = $n(a).get(i);
      var value$8 = $n(b).get(i);
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = ((((value$7 & value$8) | ((value$7 | value$8) & (~lo$4))) >>> 31) | 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((hi$16 + ((((lo$4 & value$9) | ((lo$4 | value$9) & (~lo$5))) >>> 31) | 0)) | 0);
      $n(res).set(i, lo$5);
      carry = hi$18;
      i = ((1 + i) | 0);
    }
    while ((i < bSize)) {
      var value$10 = $n(b).get(i);
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = ((((value$10 & value$11) | ((value$10 | value$11) & (~lo$6))) >>> 31) | 0);
      $n(res).set(i, lo$6);
      carry = hi$22;
      i = ((1 + i) | 0);
    }
  }
  if ((carry !== 0)) {
    $n(res).set(i, carry);
  }
}
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = $n(a).get(i);
    var value$1 = $n(b).get(i);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((~value) & value$1) | ((~(value ^ value$1)) & lo)) >> 31);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((hi$2 + hi$3) | 0) + ((((lo & value$2) | ((lo | value$2) & (~lo$1))) >>> 31) | 0)) | 0);
    $n(res).set(i, lo$1);
    borrow = hi$4;
    i = ((1 + i) | 0);
  }
  while ((i < aSize)) {
    var value$3 = $n(a).get(i);
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((hi$7 + ((((value$3 & value$4) | ((value$3 | value$4) & (~lo$2))) >>> 31) | 0)) | 0);
    $n(res).set(i, lo$2);
    borrow = hi$8;
    i = ((1 + i) | 0);
  }
}
/** @constructor */
function $c_Ljava_math_Elementary$() {
}
$c_Ljava_math_Elementary$.prototype = new $h_O();
$c_Ljava_math_Elementary$.prototype.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
}
$h_Ljava_math_Elementary$.prototype = $c_Ljava_math_Elementary$.prototype;
$c_Ljava_math_Elementary$.prototype.add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = $n(op1).Ljava_math_BigInteger__f_sign;
  var op2Sign = $n(op2).Ljava_math_BigInteger__f_sign;
  var op1Len = $n(op1).Ljava_math_BigInteger__f_numberLength;
  var op2Len = $n(op2).Ljava_math_BigInteger__f_numberLength;
  if ((op1Sign === 0)) {
    return op2;
  } else if ((op2Sign === 0)) {
    return op1;
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = $n($n(op1).Ljava_math_BigInteger__f_digits).get(0);
    var value$1 = $n($n(op2).Ljava_math_BigInteger__f_digits).get(0);
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = ((((value & value$1) | ((value | value$1) & (~lo))) >>> 31) | 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
    } else {
      var $x_2 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((((~value$1) & value) | ((~(value$1 ^ value)) & lo$1)) >> 31);
        var $x_1_$_lo = lo$1;
        var $x_1_$_hi = hi$3;
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((((~value) & value$1) | ((~(value ^ value$1)) & lo$2)) >> 31);
        var $x_1_$_lo = lo$2;
        var $x_1_$_hi = hi$4;
      }
      return $x_2.valueOf__J__Ljava_math_BigInteger($x_1_$_lo, $x_1_$_hi);
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var res$2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len));
      var x1___1 = op1Sign;
      var x1___2 = res$2;
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.compareArrays__AI__AI__I__I($n(op1).Ljava_math_BigInteger__f_digits, $n(op2).Ljava_math_BigInteger__f_digits, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      }
      if ((cmp === 1)) {
        var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len);
        var x1___1 = op1Sign;
        var x1___2 = _2;
      } else {
        var _2$1 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len);
        var x1___1 = op2Sign;
        var x1___2 = _2$1;
      }
    }
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, $n(resDigits).u.length, resDigits);
    res$3.cutOffLeadingZeroes__V();
    return res$3;
  }
});
$c_Ljava_math_Elementary$.prototype.compareArrays__AI__AI__I__I = (function(a, b, size) {
  var i = ((size - 1) | 0);
  while (((i >= 0) && ($n(a).get(i) === $n(b).get(i)))) {
    i = ((i - 1) | 0);
  }
  if ((i < 0)) {
    return 0;
  } else {
    var value = $n(a).get(i);
    var value$1 = $n(b).get(i);
    if (((value >>> 0) < (value$1 >>> 0))) {
      return (-1);
    } else {
      return 1;
    }
  }
});
$c_Ljava_math_Elementary$.prototype.inplaceAdd__AI__I__I__I = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = $n(a).get(i);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((value & value$1) | ((value | value$1) & (~lo))) >>> 31) | 0);
    $n(a).set(i, lo);
    carry = hi$2;
    i = ((1 + i) | 0);
  }
  return carry;
});
$c_Ljava_math_Elementary$.prototype.subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = $n(op1).Ljava_math_BigInteger__f_sign;
  var op2Sign = $n(op2).Ljava_math_BigInteger__f_sign;
  var op1Len = $n(op1).Ljava_math_BigInteger__f_numberLength;
  var op2Len = $n(op2).Ljava_math_BigInteger__f_numberLength;
  if ((op2Sign === 0)) {
    return op1;
  } else if ((op1Sign === 0)) {
    return $n(op2).negate__Ljava_math_BigInteger();
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = $n($n(op1).Ljava_math_BigInteger__f_digits).get(0);
    var a_$_lo = value;
    var a_$_hi = 0;
    var value$1 = $n($n(op2).Ljava_math_BigInteger__f_digits).get(0);
    var b_$_lo = value$1;
    var b_$_hi = 0;
    if ((op1Sign < 0)) {
      var x_$_lo = a_$_lo;
      var x_$_hi = a_$_hi;
      var lo = ((-x_$_lo) | 0);
      var hi$2 = ((((-x_$_hi) | 0) + ((x_$_lo | lo) >> 31)) | 0);
      a_$_lo = lo;
      a_$_hi = hi$2;
    }
    if ((op2Sign < 0)) {
      var x$1_$_lo = b_$_lo;
      var x$1_$_hi = b_$_hi;
      var lo$1 = ((-x$1_$_lo) | 0);
      var hi$3 = ((((-x$1_$_hi) | 0) + ((x$1_$_lo | lo$1) >> 31)) | 0);
      b_$_lo = lo$1;
      b_$_hi = hi$3;
    }
    var $x_1 = $m_Ljava_math_BigInteger$();
    var x$2_$_lo = a_$_lo;
    var x$2_$_hi = a_$_hi;
    var x$3_$_lo = b_$_lo;
    var x$3_$_hi = b_$_hi;
    var lo$2 = ((x$2_$_lo - x$3_$_lo) | 0);
    var hi$4 = ((((x$2_$_hi - x$3_$_hi) | 0) + ((((~x$2_$_lo) & x$3_$_lo) | ((~(x$2_$_lo ^ x$3_$_lo)) & lo$2)) >> 31)) | 0);
    return $x_1.valueOf__J__Ljava_math_BigInteger(lo$2, hi$4);
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I($n(op1).Ljava_math_BigInteger__f_digits, $n(op2).Ljava_math_BigInteger__f_digits, op1Len));
    if ((((op1Sign ^ op2Sign) | cmp) === 0)) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
    }
    if ((cmp === (-1))) {
      var res = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op2).Ljava_math_BigInteger__f_digits, op2Len, $n(op1).Ljava_math_BigInteger__f_digits, op1Len));
      var _1 = ((-op2Sign) | 0);
      var x1___1 = _1;
      var x1___2 = res;
    } else if ((op1Sign === op2Sign)) {
      var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2;
    } else {
      var _2$1 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, $n(op1).Ljava_math_BigInteger__f_digits, op1Len, $n(op2).Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2$1;
    }
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, $n(resDigits).u.length, resDigits);
    res$2.cutOffLeadingZeroes__V();
    return res$2;
  }
});
var $d_Ljava_math_Elementary$ = new $TypeData().initClass($c_Ljava_math_Elementary$, "java.math.Elementary$", ({
  Ljava_math_Elementary$: 1
}));
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$();
  }
  return $n_Ljava_math_Elementary$;
}
/** @constructor */
function $c_Ljava_math_MathContext(setPrecision, setRoundingMode) {
  this.Ljava_math_MathContext__f_precision = 0;
  this.Ljava_math_MathContext__f_roundingMode = null;
  if ((setPrecision < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Negative precision: " + setPrecision));
  }
  this.Ljava_math_MathContext__f_precision = setPrecision;
  this.Ljava_math_MathContext__f_roundingMode = $n(setRoundingMode);
}
$c_Ljava_math_MathContext.prototype = new $h_O();
$c_Ljava_math_MathContext.prototype.constructor = $c_Ljava_math_MathContext;
/** @constructor */
function $h_Ljava_math_MathContext() {
}
$h_Ljava_math_MathContext.prototype = $c_Ljava_math_MathContext.prototype;
$c_Ljava_math_MathContext.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_MathContext)) {
    var x2 = $as_Ljava_math_MathContext(x);
    if ((this.Ljava_math_MathContext__f_precision === $n(x2).Ljava_math_MathContext__f_precision)) {
      var x$2 = this.Ljava_math_MathContext__f_roundingMode;
      var x$3 = $n(x2).Ljava_math_MathContext__f_roundingMode;
      if ((x$2 === null)) {
        return (x$3 === null);
      } else {
        var this$1 = $n(x$2);
        return (this$1 === x$3);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ljava_math_MathContext.prototype.hashCode__I = (function() {
  return ((this.Ljava_math_MathContext__f_precision << 3) | $n(this.Ljava_math_MathContext__f_roundingMode).jl_Enum__f__ordinal);
});
$c_Ljava_math_MathContext.prototype.toString__T = (function() {
  return ((("precision=" + this.Ljava_math_MathContext__f_precision) + " roundingMode=") + this.Ljava_math_MathContext__f_roundingMode);
});
function $as_Ljava_math_MathContext(obj) {
  return (((obj instanceof $c_Ljava_math_MathContext) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.MathContext"));
}
function $isArrayOf_Ljava_math_MathContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_MathContext)));
}
function $asArrayOf_Ljava_math_MathContext(obj, depth) {
  return (($isArrayOf_Ljava_math_MathContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.MathContext;", depth));
}
var $d_Ljava_math_MathContext = new $TypeData().initClass($c_Ljava_math_MathContext, "java.math.MathContext", ({
  Ljava_math_MathContext: 1
}));
/** @constructor */
function $c_Ljava_math_MathContext$() {
  this.Ljava_math_MathContext$__f_DECIMAL128 = null;
  $n_Ljava_math_MathContext$ = this;
  var roundingMode = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL128 = new $c_Ljava_math_MathContext(34, roundingMode);
  var roundingMode$1 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  new $c_Ljava_math_MathContext(7, roundingMode$1);
  var roundingMode$2 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  new $c_Ljava_math_MathContext(16, roundingMode$2);
  var roundingMode$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
  new $c_Ljava_math_MathContext(0, roundingMode$3);
}
$c_Ljava_math_MathContext$.prototype = new $h_O();
$c_Ljava_math_MathContext$.prototype.constructor = $c_Ljava_math_MathContext$;
/** @constructor */
function $h_Ljava_math_MathContext$() {
}
$h_Ljava_math_MathContext$.prototype = $c_Ljava_math_MathContext$.prototype;
var $d_Ljava_math_MathContext$ = new $TypeData().initClass($c_Ljava_math_MathContext$, "java.math.MathContext$", ({
  Ljava_math_MathContext$: 1
}));
var $n_Ljava_math_MathContext$;
function $m_Ljava_math_MathContext$() {
  if ((!$n_Ljava_math_MathContext$)) {
    $n_Ljava_math_MathContext$ = new $c_Ljava_math_MathContext$();
  }
  return $n_Ljava_math_MathContext$;
}
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem_$_lo = 0;
  var elem_$_hi = 0;
  elem_$_lo = 1;
  elem_$_hi = 0;
  var i = 0;
  while ((i < 32)) {
    var value = i;
    if ((value <= 18)) {
      $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).set(value, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(elem_$_lo, elem_$_hi));
      var $x_2 = $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows);
      var $x_1 = $m_Ljava_math_BigInteger$();
      var x_$_lo = elem_$_lo;
      var x_$_hi = elem_$_hi;
      var lo = (((32 & value) === 0) ? (x_$_lo << value) : 0);
      var hi = (((32 & value) === 0) ? (((((x_$_lo >>> 1) | 0) >>> (~value)) | 0) | (x_$_hi << value)) : (x_$_lo << value));
      $x_2.set(value, $x_1.valueOf__J__Ljava_math_BigInteger(lo, hi));
      var x$1_$_lo = elem_$_lo;
      var x$1_$_hi = elem_$_hi;
      var b0 = (65535 & x$1_$_lo);
      var b1 = ((x$1_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(5, b0);
      var a0b1 = Math.imul(5, b1);
      var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(5, x$1_$_hi) + ((c1part >>> 16) | 0)) | 0);
      elem_$_lo = lo$1;
      elem_$_hi = hi$1;
    } else {
      $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).set(value, $n($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).get(((value - 1) | 0))).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows).get(1)));
      $n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).set(value, $n($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).get(((value - 1) | 0))).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN));
    }
    i = ((1 + i) | 0);
  }
}
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = $n(a).get(value);
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((hi$2 + ((((lo & c) | ((lo | c) & (~lo$1))) >>> 31) | 0)) | 0);
    $n(res).set(value, lo$1);
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  return elem;
}
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.square__AI__I__AI__AI(a, aLen, t);
  } else {
    var i = 0;
    while ((i < aLen)) {
      var value = i;
      var elem = 0;
      elem = 0;
      var aI = $n(a).get(value);
      var i$1 = 0;
      while ((i$1 < bLen)) {
        var value$1 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = $n(b).get(value$1);
        var c = $n(t).get(((value + value$1) | 0));
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((hi$2 + ((((lo & c) | ((lo | c) & (~lo$1))) >>> 31) | 0)) | 0);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((hi$4 + ((((lo$1 & d) | ((lo$1 | d) & (~lo$2))) >>> 31) | 0)) | 0);
        $n(t).set(((value + value$1) | 0), lo$2);
        elem = hi$6;
        i$1 = ((1 + i$1) | 0);
      }
      $n(t).set(((value + bLen) | 0), elem);
      i = ((1 + i) | 0);
    }
  }
}
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  var result = new $ac_I(len);
  result.set(0, 1);
  var i = 1;
  while ((i < len)) {
    var value = i;
    result.set(value, Math.imul(result.get(((value - 1) | 0)), pow));
    i = ((1 + i) | 0);
  }
  return result;
}
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.Ljava_math_Multiplication$__f_TenPows = null;
  this.Ljava_math_Multiplication$__f_BigTenPows = null;
  this.Ljava_math_Multiplication$__f_BigFivePows = null;
  $n_Ljava_math_Multiplication$ = this;
  this.Ljava_math_Multiplication$__f_TenPows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.Ljava_math_Multiplication$__f_BigTenPows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  this.Ljava_math_Multiplication$__f_BigFivePows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this);
}
$c_Ljava_math_Multiplication$.prototype = new $h_O();
$c_Ljava_math_Multiplication$.prototype.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
}
$h_Ljava_math_Multiplication$.prototype = $c_Ljava_math_Multiplication$.prototype;
$c_Ljava_math_Multiplication$.prototype.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(bi, factor) {
  var resSign = $n(bi).Ljava_math_BigInteger__f_sign;
  var aNumberLength = $n(bi).Ljava_math_BigInteger__f_numberLength;
  var aDigits = $n(bi).Ljava_math_BigInteger__f_digits;
  if ((resSign === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  } else if ((aNumberLength === 1)) {
    var a = $n(aDigits).get(0);
    var a0 = (65535 & a);
    var a1 = ((a >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var resLength = ((1 + aNumberLength) | 0);
    var resDigits = new $ac_I(resLength);
    resDigits.set(aNumberLength, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aNumberLength, factor));
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result;
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger = (function(bi, exp_$_lo, exp_$_hi) {
  var value = $n(this.Ljava_math_Multiplication$__f_TenPows).u.length;
  var hi = (value >> 31);
  if (((exp_$_hi === hi) ? ((exp_$_lo >>> 0) < (value >>> 0)) : (exp_$_hi < hi))) {
    return this.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger(bi, $n(this.Ljava_math_Multiplication$__f_TenPows).get(exp_$_lo));
  } else {
    return $n(bi).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.powerOf10__J__Ljava_math_BigInteger(exp_$_lo, exp_$_hi));
  }
});
$c_Ljava_math_Multiplication$.prototype.square__AI__I__AI__AI = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var value = i;
    elem = 0;
    var _\uff3fself = ((1 + value) | 0);
    var i$1 = _\uff3fself;
    while ((i$1 < aLen)) {
      var value$1 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = $n(a).get(value);
      var b = $n(a).get(value$1);
      var c = $n(res).get(((value + value$1) | 0));
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((hi$2 + ((((lo & c) | ((lo | c) & (~lo$1))) >>> 31) | 0)) | 0);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((hi$4 + ((((lo$1 & d) | ((lo$1 | d) & (~lo$2))) >>> 31) | 0)) | 0);
      $n(res).set(((value + value$1) | 0), lo$2);
      elem = hi$6;
      i$1 = ((1 + i$1) | 0);
    }
    $n(res).set(((value + aLen) | 0), elem);
    i = ((1 + i) | 0);
  }
  $m_Ljava_math_BitLevel$().shiftLeftOneBit__AI__AI__I__V(res, res, (aLen << 1));
  elem = 0;
  var i$2 = 0;
  var index = 0;
  while ((i$2 < aLen)) {
    var a$2 = $n(a).get(i$2);
    var b$1 = $n(a).get(i$2);
    var c$1 = $n(res).get(index);
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((hi$9 + ((((lo$3 & c$1) | ((lo$3 | c$1) & (~lo$4))) >>> 31) | 0)) | 0);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((hi$11 + ((((lo$4 & d$1) | ((lo$4 | d$1) & (~lo$5))) >>> 31) | 0)) | 0);
    $n(res).set(index, lo$5);
    index = ((1 + index) | 0);
    var value$2 = $n(res).get(index);
    var lo$6 = ((hi$13 + value$2) | 0);
    var hi$15 = ((((hi$13 & value$2) | ((hi$13 | value$2) & (~lo$6))) >>> 31) | 0);
    $n(res).set(index, lo$6);
    elem = hi$15;
    i$2 = ((1 + i$2) | 0);
    index = ((1 + index) | 0);
  }
  return res;
});
$c_Ljava_math_Multiplication$.prototype.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(val1, val2) {
  if (($n(val2).Ljava_math_BigInteger__f_numberLength > $n(val1).Ljava_math_BigInteger__f_numberLength)) {
    var x1___1 = val2;
    var x1___2 = val1;
  } else {
    var x1___1 = val1;
    var x1___2 = val2;
  }
  var op1 = $as_Ljava_math_BigInteger(x1___1);
  var op2 = $as_Ljava_math_BigInteger(x1___2);
  if (($n(op2).Ljava_math_BigInteger__f_numberLength < 63)) {
    return this.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, op2);
  } else {
    var ndiv2 = (((-2) & $n(op1).Ljava_math_BigInteger__f_numberLength) << 4);
    var upperOp1 = $n(op1).shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var upperOp2 = $n(op2).shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var this$1 = $n(op1);
    var bi = $n(upperOp1).shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$1, bi);
    var this$2 = $n(op2);
    var bi$1 = $n(upperOp2).shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp2 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, bi$1);
    var upper = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, upperOp2);
    var lower = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp1, lowerOp2);
    var this$3 = $n(upperOp1);
    var $x_1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, lowerOp1);
    var this$4 = $n(lowerOp2);
    var middle = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger($x_1, $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, upperOp2));
    var this$5 = $n(middle);
    var bi$2 = upper;
    var this$6 = $n($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$5, bi$2));
    middle = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$6, lower);
    middle = $n(middle).shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    upper = $n(upper).shiftLeft__I__Ljava_math_BigInteger((ndiv2 << 1));
    var this$7 = $n(upper);
    var bi$3 = middle;
    var this$8 = $n($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$7, bi$3));
    return $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, lower);
  }
});
$c_Ljava_math_Multiplication$.prototype.multArraysPAP__AI__I__AI__I__AI__V = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      $n(resDigits).set(bLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, $n(aDigits).get(0)));
    } else if ((bLen === 1)) {
      $n(resDigits).set(aLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, $n(bDigits).get(0)));
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen);
    }
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(a, b) {
  var aLen = $n(a).Ljava_math_BigInteger__f_numberLength;
  var bLen = $n(b).Ljava_math_BigInteger__f_numberLength;
  var resLength = ((aLen + bLen) | 0);
  var resSign = (($n(a).Ljava_math_BigInteger__f_sign !== $n(b).Ljava_math_BigInteger__f_sign) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = $n($n(a).Ljava_math_BigInteger__f_digits).get(0);
    var b$1 = $n($n(b).Ljava_math_BigInteger__f_digits).get(0);
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var aDigits = $n(a).Ljava_math_BigInteger__f_digits;
    var bDigits = $n(b).Ljava_math_BigInteger__f_digits;
    var resDigits = new $ac_I(resLength);
    this.multArraysPAP__AI__I__AI__I__AI__V(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result;
  }
});
$c_Ljava_math_Multiplication$.prototype.pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc) : res);
    if (($n(acc).Ljava_math_BigInteger__f_numberLength === 1)) {
      var acc2 = $n(acc).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc);
    } else {
      var a = new $ac_I(($n(acc).Ljava_math_BigInteger__f_numberLength << 1));
      var sq = this.square__AI__I__AI__AI($n(acc).Ljava_math_BigInteger__f_digits, $n(acc).Ljava_math_BigInteger__f_numberLength, a);
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, sq);
    }
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2;
  }
  return $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc);
});
$c_Ljava_math_Multiplication$.prototype.powerOf10__J__Ljava_math_BigInteger = (function(exp_$_lo, exp_$_hi) {
  var value = $n(this.Ljava_math_Multiplication$__f_BigTenPows).u.length;
  var hi = (value >> 31);
  if (((exp_$_hi === hi) ? ((exp_$_lo >>> 0) < (value >>> 0)) : (exp_$_hi < hi))) {
    return $n(this.Ljava_math_Multiplication$__f_BigTenPows).get(exp_$_lo);
  } else if (((exp_$_hi === 0) ? ((exp_$_lo >>> 0) <= 50) : (exp_$_hi < 0))) {
    return $n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(exp_$_lo);
  } else if (((exp_$_hi === 0) ? ((exp_$_lo >>> 0) <= 2147483647) : (exp_$_hi < 0))) {
    return $n($n($n(this.Ljava_math_Multiplication$__f_BigFivePows).get(1)).pow__I__Ljava_math_BigInteger(exp_$_lo)).shiftLeft__I__Ljava_math_BigInteger(exp_$_lo);
  } else {
    var powerOfFive = $n($n(this.Ljava_math_Multiplication$__f_BigFivePows).get(1)).pow__I__Ljava_math_BigInteger(2147483647);
    var res = powerOfFive;
    var lo = ((exp_$_lo - 2147483647) | 0);
    var hi$1 = ((((exp_$_hi - 1) | 0) + (((exp_$_lo | (~lo)) >>> 31) | 0)) | 0);
    var longExp_$_lo = lo;
    var longExp_$_hi = hi$1;
    var hi$2 = (exp_$_hi >> 31);
    var b0 = (65535 & exp_$_lo);
    var b1 = ((exp_$_lo >>> 16) | 0);
    var a1b0 = (b0 << 15);
    var lo$1 = ((b0 + (((a1b0 + b1) | 0) << 16)) | 0);
    var c1part = ((((b0 >>> 16) | 0) + b1) | 0);
    var hi$3 = ((((((((-exp_$_lo) | 0) + (b1 << 15)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var b0$1 = (65535 & exp_$_lo);
    var b1$1 = ((exp_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(3, b0$1);
    var a0b1 = Math.imul(3, b1$1);
    var c1part$1 = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((c1part$1 >>> 16) | 0);
    var lo$3 = ((lo$1 + hi$4) | 0);
    var hi$5 = ((hi$3 + ((((lo$1 & hi$4) | ((lo$1 | hi$4) & (~lo$3))) >>> 31) | 0)) | 0);
    var b0$2 = (65535 & exp_$_hi);
    var b1$2 = ((exp_$_hi >>> 16) | 0);
    var a1b0$1 = (b0$2 << 15);
    var lo$4 = ((b0$2 + (((a1b0$1 + b1$2) | 0) << 16)) | 0);
    var c1part$2 = ((((b0$2 >>> 16) | 0) + b1$2) | 0);
    var hi$6 = ((((((((Math.imul((-2147483647), hi$2) + ((-exp_$_hi) | 0)) | 0) + (b1$2 << 15)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var hi$7 = (hi$5 >> 31);
    var lo$5 = ((lo$4 + hi$5) | 0);
    var hi$8 = ((((hi$6 + hi$7) | 0) + ((((lo$4 & hi$5) | ((lo$4 | hi$5) & (~lo$5))) >>> 31) | 0)) | 0);
    var b0$3 = (65535 & exp_$_hi);
    var b1$3 = ((exp_$_hi >>> 16) | 0);
    var a0b0$1 = Math.imul(3, b0$3);
    var a0b1$1 = Math.imul(3, b1$3);
    var lo$6 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
    var c1part$3 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((Math.imul(3, hi$2) + ((c1part$3 >>> 16) | 0)) | 0);
    var lo$7 = ((lo$3 + lo$6) | 0);
    var hi$10 = ((hi$9 + ((((lo$3 & lo$6) | ((lo$3 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
    var hi$11 = (hi$10 >> 31);
    var lo$8 = ((lo$5 + hi$10) | 0);
    var hi$12 = ((((hi$8 + hi$11) | 0) + ((((lo$5 & hi$10) | ((lo$5 | hi$10) & (~lo$8))) >>> 31) | 0)) | 0);
    var lo$9 = ((lo$8 + exp_$_lo) | 0);
    var hi$13 = ((((hi$12 + exp_$_hi) | 0) + ((((lo$8 & exp_$_lo) | ((lo$8 | exp_$_lo) & (~lo$9))) >>> 31) | 0)) | 0);
    var lo$10 = (((lo$9 >>> 30) | 0) | (hi$13 << 2));
    var lo$11 = ((exp_$_hi >>> 31) | 0);
    var lo$12 = ((lo$10 + lo$11) | 0);
    var b0$4 = (65535 & lo$12);
    var b1$4 = ((lo$12 >>> 16) | 0);
    var a0b0$2 = Math.imul(65535, b0$4);
    var a1b0$2 = Math.imul(32767, b0$4);
    var a0b1$2 = Math.imul(65535, b1$4);
    var lo$13 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
    var lo$14 = ((exp_$_lo - lo$13) | 0);
    while (true) {
      var x_$_lo = longExp_$_lo;
      var x_$_hi = longExp_$_hi;
      if (((x_$_hi === 0) ? ((x_$_lo >>> 0) > 2147483647) : (x_$_hi > 0))) {
        res = $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(powerOfFive);
        var x$1_$_lo = longExp_$_lo;
        var x$1_$_hi = longExp_$_hi;
        var lo$15 = ((x$1_$_lo - 2147483647) | 0);
        var hi$18 = ((((x$1_$_hi - 1) | 0) + (((x$1_$_lo | (~lo$15)) >>> 31) | 0)) | 0);
        longExp_$_lo = lo$15;
        longExp_$_hi = hi$18;
      } else {
        break;
      }
    }
    res = $n(res).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($n(this.Ljava_math_Multiplication$__f_BigFivePows).get(1)).pow__I__Ljava_math_BigInteger(lo$14));
    res = $n(res).shiftLeft__I__Ljava_math_BigInteger(2147483647);
    var lo$16 = ((exp_$_lo - 2147483647) | 0);
    var hi$19 = ((((exp_$_hi - 1) | 0) + (((exp_$_lo | (~lo$16)) >>> 31) | 0)) | 0);
    longExp_$_lo = lo$16;
    longExp_$_hi = hi$19;
    while (true) {
      var x$2_$_lo = longExp_$_lo;
      var x$2_$_hi = longExp_$_hi;
      if (((x$2_$_hi === 0) ? ((x$2_$_lo >>> 0) > 2147483647) : (x$2_$_hi > 0))) {
        res = $n(res).shiftLeft__I__Ljava_math_BigInteger(2147483647);
        var x$3_$_lo = longExp_$_lo;
        var x$3_$_hi = longExp_$_hi;
        var lo$17 = ((x$3_$_lo - 2147483647) | 0);
        var hi$20 = ((((x$3_$_hi - 1) | 0) + (((x$3_$_lo | (~lo$17)) >>> 31) | 0)) | 0);
        longExp_$_lo = lo$17;
        longExp_$_hi = hi$20;
      } else {
        break;
      }
    }
    return $n(res).shiftLeft__I__Ljava_math_BigInteger(lo$14);
  }
});
var $d_Ljava_math_Multiplication$ = new $TypeData().initClass($c_Ljava_math_Multiplication$, "java.math.Multiplication$", ({
  Ljava_math_Multiplication$: 1
}));
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$();
  }
  return $n_Ljava_math_Multiplication$;
}
/** @constructor */
function $c_Ljava_time_Clock() {
}
$c_Ljava_time_Clock.prototype = new $h_O();
$c_Ljava_time_Clock.prototype.constructor = $c_Ljava_time_Clock;
/** @constructor */
function $h_Ljava_time_Clock() {
}
$h_Ljava_time_Clock.prototype = $c_Ljava_time_Clock.prototype;
/** @constructor */
function $c_Ljava_time_Duration$() {
  this.Ljava_time_Duration$__f_ZERO$lzy1 = null;
  this.Ljava_time_Duration$__f_ZERObitmap$1 = false;
}
$c_Ljava_time_Duration$.prototype = new $h_O();
$c_Ljava_time_Duration$.prototype.constructor = $c_Ljava_time_Duration$;
/** @constructor */
function $h_Ljava_time_Duration$() {
}
$h_Ljava_time_Duration$.prototype = $c_Ljava_time_Duration$.prototype;
$c_Ljava_time_Duration$.prototype.ZERO__Ljava_time_Duration = (function() {
  if ((!this.Ljava_time_Duration$__f_ZERObitmap$1)) {
    this.Ljava_time_Duration$__f_ZERO$lzy1 = new $c_Ljava_time_Duration(0, 0, 0);
    this.Ljava_time_Duration$__f_ZERObitmap$1 = true;
  }
  return this.Ljava_time_Duration$__f_ZERO$lzy1;
});
$c_Ljava_time_Duration$.prototype.ofSeconds__J__J__Ljava_time_Duration = (function(seconds_$_lo, seconds_$_hi, nanoAdjustment_$_lo, nanoAdjustment_$_hi) {
  var hi = (nanoAdjustment_$_hi >> 31);
  var b0 = (65535 & nanoAdjustment_$_lo);
  var b1 = ((nanoAdjustment_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(3048, b0);
  var a1b0 = Math.imul(4398, b0);
  var a0b1 = Math.imul(3048, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(4398, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & nanoAdjustment_$_lo);
  var b1$1 = ((nanoAdjustment_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(38067, b0$1);
  var a1b0$1 = Math.imul(9942, b0$1);
  var a0b1$1 = Math.imul(38067, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(9942, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & nanoAdjustment_$_hi);
  var b1$2 = ((nanoAdjustment_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(3048, b0$2);
  var a1b0$2 = Math.imul(4398, b0$2);
  var a0b1$2 = Math.imul(3048, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(288230376, hi) + Math.imul(4398, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & nanoAdjustment_$_hi);
  var b1$3 = ((nanoAdjustment_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(38067, b0$3);
  var a1b0$3 = Math.imul(9942, b0$3);
  var a0b1$3 = Math.imul(38067, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(651596979, hi) + Math.imul(9942, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 26) | 0) | (hi$10 << 6));
  var hi$11 = (hi$10 >> 26);
  var lo$9 = ((nanoAdjustment_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  if ((nanoAdjustment_$_hi >= 0)) {
    var $x_1 = true;
  } else {
    var b0$4 = (65535 & lo$10);
    var b1$4 = ((lo$10 >>> 16) | 0);
    var a0b0$4 = Math.imul(51712, b0$4);
    var a1b0$4 = Math.imul(15258, b0$4);
    var a0b1$4 = Math.imul(51712, b1$4);
    var lo$12 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$13 = ((((((Math.imul(1000000000, hi$12) + Math.imul(15258, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
    var $x_1 = (((lo$12 ^ nanoAdjustment_$_lo) | (hi$13 ^ nanoAdjustment_$_hi)) === 0);
  }
  if ($x_1) {
    var b_$_lo = lo$10;
    var b_$_hi = hi$12;
  } else {
    var lo$13 = ((lo$10 - 1) | 0);
    var hi$14 = ((((hi$12 - 1) | 0) + (((lo$10 | (~lo$13)) >>> 31) | 0)) | 0);
    var b_$_lo = lo$13;
    var b_$_hi = hi$14;
  }
  var this$24 = $m_jl_Math$();
  var lo$14 = ((seconds_$_lo + b_$_lo) | 0);
  var hi$15 = ((((seconds_$_hi + b_$_hi) | 0) + ((((seconds_$_lo & b_$_lo) | ((seconds_$_lo | b_$_lo) & (~lo$14))) >>> 31) | 0)) | 0);
  var hi$16 = (hi$15 ^ seconds_$_hi);
  var hi$17 = (hi$15 ^ b_$_hi);
  var hi$18 = (hi$16 & hi$17);
  if ((hi$18 < 0)) {
    this$24.java$lang$Math$$longOverflow__E();
  }
  var hi$19 = (nanoAdjustment_$_hi >> 31);
  var b0$5 = (65535 & nanoAdjustment_$_lo);
  var b1$5 = ((nanoAdjustment_$_lo >>> 16) | 0);
  var a0b0$5 = Math.imul(3048, b0$5);
  var a1b0$5 = Math.imul(4398, b0$5);
  var a0b1$5 = Math.imul(3048, b1$5);
  var lo$18 = ((a0b0$5 + (((a1b0$5 + a0b1$5) | 0) << 16)) | 0);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$20 = ((((Math.imul(4398, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var b0$6 = (65535 & nanoAdjustment_$_lo);
  var b1$6 = ((nanoAdjustment_$_lo >>> 16) | 0);
  var a0b0$6 = Math.imul(38067, b0$6);
  var a1b0$6 = Math.imul(9942, b0$6);
  var a0b1$6 = Math.imul(38067, b1$6);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$21 = ((((Math.imul(9942, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var lo$20 = ((lo$18 + hi$21) | 0);
  var hi$22 = ((hi$20 + ((((lo$18 & hi$21) | ((lo$18 | hi$21) & (~lo$20))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & nanoAdjustment_$_hi);
  var b1$7 = ((nanoAdjustment_$_hi >>> 16) | 0);
  var a0b0$7 = Math.imul(3048, b0$7);
  var a1b0$7 = Math.imul(4398, b0$7);
  var a0b1$7 = Math.imul(3048, b1$7);
  var lo$21 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$23 = ((((((Math.imul(288230376, hi$19) + Math.imul(4398, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var hi$24 = (hi$22 >> 31);
  var lo$22 = ((lo$21 + hi$22) | 0);
  var hi$25 = ((((hi$23 + hi$24) | 0) + ((((lo$21 & hi$22) | ((lo$21 | hi$22) & (~lo$22))) >>> 31) | 0)) | 0);
  var b0$8 = (65535 & nanoAdjustment_$_hi);
  var b1$8 = ((nanoAdjustment_$_hi >>> 16) | 0);
  var a0b0$8 = Math.imul(38067, b0$8);
  var a1b0$8 = Math.imul(9942, b0$8);
  var a0b1$8 = Math.imul(38067, b1$8);
  var lo$23 = ((a0b0$8 + (((a1b0$8 + a0b1$8) | 0) << 16)) | 0);
  var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
  var hi$26 = ((((((Math.imul(651596979, hi$19) + Math.imul(9942, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$8) | 0) >>> 16) | 0)) | 0);
  var lo$24 = ((lo$20 + lo$23) | 0);
  var hi$27 = ((hi$26 + ((((lo$20 & lo$23) | ((lo$20 | lo$23) & (~lo$24))) >>> 31) | 0)) | 0);
  var hi$28 = (hi$27 >> 31);
  var lo$25 = ((lo$22 + hi$27) | 0);
  var hi$29 = ((((hi$25 + hi$28) | 0) + ((((lo$22 & hi$27) | ((lo$22 | hi$27) & (~lo$25))) >>> 31) | 0)) | 0);
  var lo$26 = (((lo$25 >>> 26) | 0) | (hi$29 << 6));
  var hi$30 = (hi$29 >> 26);
  var lo$27 = ((nanoAdjustment_$_hi >>> 31) | 0);
  var lo$28 = ((lo$26 + lo$27) | 0);
  var hi$31 = ((hi$30 + ((((lo$26 & lo$27) | ((lo$26 | lo$27) & (~lo$28))) >>> 31) | 0)) | 0);
  var b0$9 = (65535 & lo$28);
  var b1$9 = ((lo$28 >>> 16) | 0);
  var a0b0$9 = Math.imul(51712, b0$9);
  var a1b0$9 = Math.imul(15258, b0$9);
  var a0b1$9 = Math.imul(51712, b1$9);
  var lo$29 = ((a0b0$9 + (((a1b0$9 + a0b1$9) | 0) << 16)) | 0);
  var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
  var hi$32 = ((((((Math.imul(1000000000, hi$31) + Math.imul(15258, b1$9)) | 0) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$9) | 0) >>> 16) | 0)) | 0);
  var lo$30 = ((nanoAdjustment_$_lo - lo$29) | 0);
  var hi$33 = ((((nanoAdjustment_$_hi - hi$32) | 0) + ((((~nanoAdjustment_$_lo) & lo$29) | ((~(nanoAdjustment_$_lo ^ lo$29)) & lo$30)) >> 31)) | 0);
  if (((nanoAdjustment_$_hi >= 0) || ((lo$30 | hi$33) === 0))) {
    var x_$_lo = lo$30;
    var x_$_hi = hi$33;
  } else {
    var lo$32 = ((1000000000 + lo$30) | 0);
    var hi$34 = ((hi$33 + (((lo$30 & (~lo$32)) >>> 31) | 0)) | 0);
    var x_$_lo = lo$32;
    var x_$_hi = hi$34;
  }
  return this.java$time$Duration$$$create__J__I__Ljava_time_Duration(lo$14, hi$15, x_$_lo);
});
$c_Ljava_time_Duration$.prototype.ofNanos__J__Ljava_time_Duration = (function(nanos_$_lo, nanos_$_hi) {
  var hi = (nanos_$_hi >> 31);
  var b0 = (65535 & nanos_$_lo);
  var b1 = ((nanos_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(3048, b0);
  var a1b0 = Math.imul(4398, b0);
  var a0b1 = Math.imul(3048, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(4398, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & nanos_$_lo);
  var b1$1 = ((nanos_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(38067, b0$1);
  var a1b0$1 = Math.imul(9942, b0$1);
  var a0b1$1 = Math.imul(38067, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(9942, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & nanos_$_hi);
  var b1$2 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(3048, b0$2);
  var a1b0$2 = Math.imul(4398, b0$2);
  var a0b1$2 = Math.imul(3048, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(288230376, hi) + Math.imul(4398, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & nanos_$_hi);
  var b1$3 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(38067, b0$3);
  var a1b0$3 = Math.imul(9942, b0$3);
  var a0b1$3 = Math.imul(38067, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(651596979, hi) + Math.imul(9942, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 26) | 0) | (hi$10 << 6));
  var hi$11 = (hi$10 >> 26);
  var lo$9 = ((nanos_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  var secs_$_lo = lo$10;
  var secs_$_hi = hi$12;
  var hi$13 = (nanos_$_hi >> 31);
  var b0$4 = (65535 & nanos_$_lo);
  var b1$4 = ((nanos_$_lo >>> 16) | 0);
  var a0b0$4 = Math.imul(3048, b0$4);
  var a1b0$4 = Math.imul(4398, b0$4);
  var a0b1$4 = Math.imul(3048, b1$4);
  var lo$11 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$14 = ((((Math.imul(4398, b1$4) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var b0$5 = (65535 & nanos_$_lo);
  var b1$5 = ((nanos_$_lo >>> 16) | 0);
  var a0b0$5 = Math.imul(38067, b0$5);
  var a1b0$5 = Math.imul(9942, b0$5);
  var a0b1$5 = Math.imul(38067, b1$5);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$15 = ((((Math.imul(9942, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var lo$13 = ((lo$11 + hi$15) | 0);
  var hi$16 = ((hi$14 + ((((lo$11 & hi$15) | ((lo$11 | hi$15) & (~lo$13))) >>> 31) | 0)) | 0);
  var b0$6 = (65535 & nanos_$_hi);
  var b1$6 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$6 = Math.imul(3048, b0$6);
  var a1b0$6 = Math.imul(4398, b0$6);
  var a0b1$6 = Math.imul(3048, b1$6);
  var lo$14 = ((a0b0$6 + (((a1b0$6 + a0b1$6) | 0) << 16)) | 0);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$17 = ((((((Math.imul(288230376, hi$13) + Math.imul(4398, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var hi$18 = (hi$16 >> 31);
  var lo$15 = ((lo$14 + hi$16) | 0);
  var hi$19 = ((((hi$17 + hi$18) | 0) + ((((lo$14 & hi$16) | ((lo$14 | hi$16) & (~lo$15))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & nanos_$_hi);
  var b1$7 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$7 = Math.imul(38067, b0$7);
  var a1b0$7 = Math.imul(9942, b0$7);
  var a0b1$7 = Math.imul(38067, b1$7);
  var lo$16 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$20 = ((((((Math.imul(651596979, hi$13) + Math.imul(9942, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var lo$17 = ((lo$13 + lo$16) | 0);
  var hi$21 = ((hi$20 + ((((lo$13 & lo$16) | ((lo$13 | lo$16) & (~lo$17))) >>> 31) | 0)) | 0);
  var hi$22 = (hi$21 >> 31);
  var lo$18 = ((lo$15 + hi$21) | 0);
  var hi$23 = ((((hi$19 + hi$22) | 0) + ((((lo$15 & hi$21) | ((lo$15 | hi$21) & (~lo$18))) >>> 31) | 0)) | 0);
  var lo$19 = (((lo$18 >>> 26) | 0) | (hi$23 << 6));
  var lo$20 = ((nanos_$_hi >>> 31) | 0);
  var lo$21 = ((lo$19 + lo$20) | 0);
  var b0$8 = (65535 & lo$21);
  var b1$8 = ((lo$21 >>> 16) | 0);
  var a0b0$8 = Math.imul(51712, b0$8);
  var a1b0$8 = Math.imul(15258, b0$8);
  var a0b1$8 = Math.imul(51712, b1$8);
  var lo$22 = ((a0b0$8 + (((a1b0$8 + a0b1$8) | 0) << 16)) | 0);
  var lo$23 = ((nanos_$_lo - lo$22) | 0);
  var nos = lo$23;
  if ((nos < 0)) {
    nos = ((1000000000 + nos) | 0);
    var x_$_lo = secs_$_lo;
    var x_$_hi = secs_$_hi;
    var lo$24 = ((x_$_lo - 1) | 0);
    var hi$28 = ((((x_$_hi - 1) | 0) + (((x_$_lo | (~lo$24)) >>> 31) | 0)) | 0);
    secs_$_lo = lo$24;
    secs_$_hi = hi$28;
  }
  return this.java$time$Duration$$$create__J__I__Ljava_time_Duration(secs_$_lo, secs_$_hi, nos);
});
$c_Ljava_time_Duration$.prototype.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration = (function(startInclusive, endExclusive) {
  var $x_1 = $n(startInclusive).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(endExclusive, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit());
  var secs_$_lo = $x_1.l;
  var secs_$_hi = $x_1.h;
  var nanos_$_lo = 0;
  var nanos_$_hi = 0;
  if (($n(startInclusive).isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField()) && $n(endExclusive).isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    try {
      var $x_2 = $n(startInclusive).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
      var startNos_$_lo = $x_2.l;
      var startNos_$_hi = $x_2.h;
      var $x_3 = $n(endExclusive).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
      var x_$_lo = $x_3.l;
      var x_$_hi = $x_3.h;
      var lo = ((x_$_lo - startNos_$_lo) | 0);
      var hi = ((((x_$_hi - startNos_$_hi) | 0) + ((((~x_$_lo) & startNos_$_lo) | ((~(x_$_lo ^ startNos_$_lo)) & lo)) >> 31)) | 0);
      nanos_$_lo = lo;
      nanos_$_hi = hi;
      var x$1_$_lo = secs_$_lo;
      var x$1_$_hi = secs_$_hi;
      if (((x$1_$_hi === 0) ? (x$1_$_lo !== 0) : (x$1_$_hi > 0))) {
        var x$2_$_lo = nanos_$_lo;
        var x$2_$_hi = nanos_$_hi;
        var $x_4 = (x$2_$_hi < 0);
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        var x$3_$_lo = nanos_$_lo;
        var x$3_$_hi = nanos_$_hi;
        var lo$1 = ((1000000000 + x$3_$_lo) | 0);
        var hi$1 = ((x$3_$_hi + (((x$3_$_lo & (~lo$1)) >>> 31) | 0)) | 0);
        nanos_$_lo = lo$1;
        nanos_$_hi = hi$1;
      } else {
        var x$4_$_lo = secs_$_lo;
        var x$4_$_hi = secs_$_hi;
        if ((x$4_$_hi < 0)) {
          var x$5_$_lo = nanos_$_lo;
          var x$5_$_hi = nanos_$_hi;
          var $x_5 = ((x$5_$_hi === 0) ? (x$5_$_lo !== 0) : (x$5_$_hi > 0));
        } else {
          var $x_5 = false;
        }
        if ($x_5) {
          var x$6_$_lo = nanos_$_lo;
          var x$6_$_hi = nanos_$_hi;
          var lo$2 = ((x$6_$_lo - 1000000000) | 0);
          var hi$2 = ((((x$6_$_hi - 1) | 0) + (((x$6_$_lo | (~lo$2)) >>> 31) | 0)) | 0);
          nanos_$_lo = lo$2;
          nanos_$_hi = hi$2;
        } else {
          var x$7_$_lo = secs_$_lo;
          var x$7_$_hi = secs_$_hi;
          if (((x$7_$_lo | x$7_$_hi) === 0)) {
            var x$8_$_lo = nanos_$_lo;
            var x$8_$_hi = nanos_$_hi;
            var $x_6 = ((x$8_$_lo | x$8_$_hi) !== 0);
          } else {
            var $x_6 = false;
          }
          if ($x_6) {
            var adjustedEnd = $n(endExclusive).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), startNos_$_lo, startNos_$_hi);
            var $x_7 = $n(startInclusive).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(adjustedEnd, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit());
            secs_$_lo = $x_7.l;
            secs_$_hi = $x_7.h;
          }
        }
      }
    } catch (e) {
      if ((!(e instanceof $c_Ljava_time_DateTimeException))) {
        if ((!(e instanceof $c_jl_ArithmeticException))) {
          throw e;
        }
      }
    }
  }
  return this.ofSeconds__J__J__Ljava_time_Duration(secs_$_lo, secs_$_hi, nanos_$_lo, nanos_$_hi);
});
$c_Ljava_time_Duration$.prototype.java$time$Duration$$$create__J__I__Ljava_time_Duration = (function(seconds_$_lo, seconds_$_hi, nanoAdjustment) {
  var hi = (nanoAdjustment >> 31);
  var lo = (seconds_$_lo | nanoAdjustment);
  var hi$1 = (seconds_$_hi | hi);
  if (((lo | hi$1) === 0)) {
    return this.ZERO__Ljava_time_Duration();
  } else {
    return new $c_Ljava_time_Duration(seconds_$_lo, seconds_$_hi, nanoAdjustment);
  }
});
var $d_Ljava_time_Duration$ = new $TypeData().initClass($c_Ljava_time_Duration$, "java.time.Duration$", ({
  Ljava_time_Duration$: 1
}));
var $n_Ljava_time_Duration$;
function $m_Ljava_time_Duration$() {
  if ((!$n_Ljava_time_Duration$)) {
    $n_Ljava_time_Duration$ = new $c_Ljava_time_Duration$();
  }
  return $n_Ljava_time_Duration$;
}
/** @constructor */
function $c_Ljava_time_Instant$() {
  this.Ljava_time_Instant$__f_EPOCH$lzy1 = null;
  this.Ljava_time_Instant$__f_EPOCHbitmap$1 = false;
}
$c_Ljava_time_Instant$.prototype = new $h_O();
$c_Ljava_time_Instant$.prototype.constructor = $c_Ljava_time_Instant$;
/** @constructor */
function $h_Ljava_time_Instant$() {
}
$h_Ljava_time_Instant$.prototype = $c_Ljava_time_Instant$.prototype;
$c_Ljava_time_Instant$.prototype.EPOCH__Ljava_time_Instant = (function() {
  if ((!this.Ljava_time_Instant$__f_EPOCHbitmap$1)) {
    this.Ljava_time_Instant$__f_EPOCH$lzy1 = new $c_Ljava_time_Instant(0, 0, 0);
    this.Ljava_time_Instant$__f_EPOCHbitmap$1 = true;
  }
  return this.Ljava_time_Instant$__f_EPOCH$lzy1;
});
$c_Ljava_time_Instant$.prototype.ofEpochSecond__J__J__Ljava_time_Instant = (function(epochSecond_$_lo, epochSecond_$_hi, nanoAdjustment_$_lo, nanoAdjustment_$_hi) {
  var hi = (nanoAdjustment_$_hi >> 31);
  var b0 = (65535 & nanoAdjustment_$_lo);
  var b1 = ((nanoAdjustment_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(3048, b0);
  var a1b0 = Math.imul(4398, b0);
  var a0b1 = Math.imul(3048, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(4398, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & nanoAdjustment_$_lo);
  var b1$1 = ((nanoAdjustment_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(38067, b0$1);
  var a1b0$1 = Math.imul(9942, b0$1);
  var a0b1$1 = Math.imul(38067, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(9942, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & nanoAdjustment_$_hi);
  var b1$2 = ((nanoAdjustment_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(3048, b0$2);
  var a1b0$2 = Math.imul(4398, b0$2);
  var a0b1$2 = Math.imul(3048, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(288230376, hi) + Math.imul(4398, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & nanoAdjustment_$_hi);
  var b1$3 = ((nanoAdjustment_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(38067, b0$3);
  var a1b0$3 = Math.imul(9942, b0$3);
  var a0b1$3 = Math.imul(38067, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(651596979, hi) + Math.imul(9942, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 26) | 0) | (hi$10 << 6));
  var hi$11 = (hi$10 >> 26);
  var lo$9 = ((nanoAdjustment_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  if ((nanoAdjustment_$_hi >= 0)) {
    var $x_1 = true;
  } else {
    var b0$4 = (65535 & lo$10);
    var b1$4 = ((lo$10 >>> 16) | 0);
    var a0b0$4 = Math.imul(51712, b0$4);
    var a1b0$4 = Math.imul(15258, b0$4);
    var a0b1$4 = Math.imul(51712, b1$4);
    var lo$12 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$13 = ((((((Math.imul(1000000000, hi$12) + Math.imul(15258, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
    var $x_1 = (((lo$12 ^ nanoAdjustment_$_lo) | (hi$13 ^ nanoAdjustment_$_hi)) === 0);
  }
  if ($x_1) {
    var b_$_lo = lo$10;
    var b_$_hi = hi$12;
  } else {
    var lo$13 = ((lo$10 - 1) | 0);
    var hi$14 = ((((hi$12 - 1) | 0) + (((lo$10 | (~lo$13)) >>> 31) | 0)) | 0);
    var b_$_lo = lo$13;
    var b_$_hi = hi$14;
  }
  var this$24 = $m_jl_Math$();
  var lo$14 = ((epochSecond_$_lo + b_$_lo) | 0);
  var hi$15 = ((((epochSecond_$_hi + b_$_hi) | 0) + ((((epochSecond_$_lo & b_$_lo) | ((epochSecond_$_lo | b_$_lo) & (~lo$14))) >>> 31) | 0)) | 0);
  var hi$16 = (hi$15 ^ epochSecond_$_hi);
  var hi$17 = (hi$15 ^ b_$_hi);
  var hi$18 = (hi$16 & hi$17);
  if ((hi$18 < 0)) {
    this$24.java$lang$Math$$longOverflow__E();
  }
  var hi$19 = (nanoAdjustment_$_hi >> 31);
  var b0$5 = (65535 & nanoAdjustment_$_lo);
  var b1$5 = ((nanoAdjustment_$_lo >>> 16) | 0);
  var a0b0$5 = Math.imul(3048, b0$5);
  var a1b0$5 = Math.imul(4398, b0$5);
  var a0b1$5 = Math.imul(3048, b1$5);
  var lo$18 = ((a0b0$5 + (((a1b0$5 + a0b1$5) | 0) << 16)) | 0);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$20 = ((((Math.imul(4398, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var b0$6 = (65535 & nanoAdjustment_$_lo);
  var b1$6 = ((nanoAdjustment_$_lo >>> 16) | 0);
  var a0b0$6 = Math.imul(38067, b0$6);
  var a1b0$6 = Math.imul(9942, b0$6);
  var a0b1$6 = Math.imul(38067, b1$6);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$21 = ((((Math.imul(9942, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var lo$20 = ((lo$18 + hi$21) | 0);
  var hi$22 = ((hi$20 + ((((lo$18 & hi$21) | ((lo$18 | hi$21) & (~lo$20))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & nanoAdjustment_$_hi);
  var b1$7 = ((nanoAdjustment_$_hi >>> 16) | 0);
  var a0b0$7 = Math.imul(3048, b0$7);
  var a1b0$7 = Math.imul(4398, b0$7);
  var a0b1$7 = Math.imul(3048, b1$7);
  var lo$21 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$23 = ((((((Math.imul(288230376, hi$19) + Math.imul(4398, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var hi$24 = (hi$22 >> 31);
  var lo$22 = ((lo$21 + hi$22) | 0);
  var hi$25 = ((((hi$23 + hi$24) | 0) + ((((lo$21 & hi$22) | ((lo$21 | hi$22) & (~lo$22))) >>> 31) | 0)) | 0);
  var b0$8 = (65535 & nanoAdjustment_$_hi);
  var b1$8 = ((nanoAdjustment_$_hi >>> 16) | 0);
  var a0b0$8 = Math.imul(38067, b0$8);
  var a1b0$8 = Math.imul(9942, b0$8);
  var a0b1$8 = Math.imul(38067, b1$8);
  var lo$23 = ((a0b0$8 + (((a1b0$8 + a0b1$8) | 0) << 16)) | 0);
  var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
  var hi$26 = ((((((Math.imul(651596979, hi$19) + Math.imul(9942, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$8) | 0) >>> 16) | 0)) | 0);
  var lo$24 = ((lo$20 + lo$23) | 0);
  var hi$27 = ((hi$26 + ((((lo$20 & lo$23) | ((lo$20 | lo$23) & (~lo$24))) >>> 31) | 0)) | 0);
  var hi$28 = (hi$27 >> 31);
  var lo$25 = ((lo$22 + hi$27) | 0);
  var hi$29 = ((((hi$25 + hi$28) | 0) + ((((lo$22 & hi$27) | ((lo$22 | hi$27) & (~lo$25))) >>> 31) | 0)) | 0);
  var lo$26 = (((lo$25 >>> 26) | 0) | (hi$29 << 6));
  var hi$30 = (hi$29 >> 26);
  var lo$27 = ((nanoAdjustment_$_hi >>> 31) | 0);
  var lo$28 = ((lo$26 + lo$27) | 0);
  var hi$31 = ((hi$30 + ((((lo$26 & lo$27) | ((lo$26 | lo$27) & (~lo$28))) >>> 31) | 0)) | 0);
  var b0$9 = (65535 & lo$28);
  var b1$9 = ((lo$28 >>> 16) | 0);
  var a0b0$9 = Math.imul(51712, b0$9);
  var a1b0$9 = Math.imul(15258, b0$9);
  var a0b1$9 = Math.imul(51712, b1$9);
  var lo$29 = ((a0b0$9 + (((a1b0$9 + a0b1$9) | 0) << 16)) | 0);
  var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
  var hi$32 = ((((((Math.imul(1000000000, hi$31) + Math.imul(15258, b1$9)) | 0) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$9) | 0) >>> 16) | 0)) | 0);
  var lo$30 = ((nanoAdjustment_$_lo - lo$29) | 0);
  var hi$33 = ((((nanoAdjustment_$_hi - hi$32) | 0) + ((((~nanoAdjustment_$_lo) & lo$29) | ((~(nanoAdjustment_$_lo ^ lo$29)) & lo$30)) >> 31)) | 0);
  if (((nanoAdjustment_$_hi >= 0) || ((lo$30 | hi$33) === 0))) {
    var x_$_lo = lo$30;
    var x_$_hi = hi$33;
  } else {
    var lo$32 = ((1000000000 + lo$30) | 0);
    var hi$34 = ((hi$33 + (((lo$30 & (~lo$32)) >>> 31) | 0)) | 0);
    var x_$_lo = lo$32;
    var x_$_hi = hi$34;
  }
  return this.java$time$Instant$$$create__J__I__Ljava_time_Instant(lo$14, hi$15, x_$_lo);
});
$c_Ljava_time_Instant$.prototype.ofEpochMilli__J__Ljava_time_Instant = (function(epochMilli_$_lo, epochMilli_$_hi) {
  var hi = (epochMilli_$_hi >> 31);
  var b0 = (65535 & epochMilli_$_lo);
  var b1 = ((epochMilli_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(39845, b0);
  var a1b0 = Math.imul(8388, b0);
  var a0b1 = Math.imul(39845, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(8388, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & epochMilli_$_lo);
  var b1$1 = ((epochMilli_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(63439, b0$1);
  var a1b0$1 = Math.imul(58195, b0$1);
  var a0b1$1 = Math.imul(63439, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(58195, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & epochMilli_$_hi);
  var b1$2 = ((epochMilli_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(39845, b0$2);
  var a1b0$2 = Math.imul(8388, b0$2);
  var a0b1$2 = Math.imul(39845, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(549755813, hi) + Math.imul(8388, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & epochMilli_$_hi);
  var b1$3 = ((epochMilli_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(63439, b0$3);
  var a1b0$3 = Math.imul(58195, b0$3);
  var a0b1$3 = Math.imul(63439, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-481036337), hi) + Math.imul(58195, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 7) | 0) | (hi$10 << 25));
  var hi$11 = (hi$10 >> 7);
  var lo$9 = ((epochMilli_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  if ((epochMilli_$_hi >= 0)) {
    var $x_1 = true;
  } else {
    var b0$4 = (65535 & lo$10);
    var b1$4 = ((lo$10 >>> 16) | 0);
    var a0b0$4 = Math.imul(1000, b0$4);
    var a0b1$4 = Math.imul(1000, b1$4);
    var lo$12 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$13 = ((Math.imul(1000, hi$12) + ((c1part$4 >>> 16) | 0)) | 0);
    var $x_1 = (((lo$12 ^ epochMilli_$_lo) | (hi$13 ^ epochMilli_$_hi)) === 0);
  }
  if ($x_1) {
    var secs_$_lo = lo$10;
    var secs_$_hi = hi$12;
  } else {
    var lo$13 = ((lo$10 - 1) | 0);
    var hi$14 = ((((hi$12 - 1) | 0) + (((lo$10 | (~lo$13)) >>> 31) | 0)) | 0);
    var secs_$_lo = lo$13;
    var secs_$_hi = hi$14;
  }
  var hi$15 = (epochMilli_$_hi >> 31);
  var b0$5 = (65535 & epochMilli_$_lo);
  var b1$5 = ((epochMilli_$_lo >>> 16) | 0);
  var a0b0$5 = Math.imul(39845, b0$5);
  var a1b0$4 = Math.imul(8388, b0$5);
  var a0b1$5 = Math.imul(39845, b1$5);
  var lo$14 = ((a0b0$5 + (((a1b0$4 + a0b1$5) | 0) << 16)) | 0);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$16 = ((((Math.imul(8388, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var b0$6 = (65535 & epochMilli_$_lo);
  var b1$6 = ((epochMilli_$_lo >>> 16) | 0);
  var a0b0$6 = Math.imul(63439, b0$6);
  var a1b0$5 = Math.imul(58195, b0$6);
  var a0b1$6 = Math.imul(63439, b1$6);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$17 = ((((Math.imul(58195, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var lo$16 = ((lo$14 + hi$17) | 0);
  var hi$18 = ((hi$16 + ((((lo$14 & hi$17) | ((lo$14 | hi$17) & (~lo$16))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & epochMilli_$_hi);
  var b1$7 = ((epochMilli_$_hi >>> 16) | 0);
  var a0b0$7 = Math.imul(39845, b0$7);
  var a1b0$6 = Math.imul(8388, b0$7);
  var a0b1$7 = Math.imul(39845, b1$7);
  var lo$17 = ((a0b0$7 + (((a1b0$6 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$19 = ((((((Math.imul(549755813, hi$15) + Math.imul(8388, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var hi$20 = (hi$18 >> 31);
  var lo$18 = ((lo$17 + hi$18) | 0);
  var hi$21 = ((((hi$19 + hi$20) | 0) + ((((lo$17 & hi$18) | ((lo$17 | hi$18) & (~lo$18))) >>> 31) | 0)) | 0);
  var b0$8 = (65535 & epochMilli_$_hi);
  var b1$8 = ((epochMilli_$_hi >>> 16) | 0);
  var a0b0$8 = Math.imul(63439, b0$8);
  var a1b0$7 = Math.imul(58195, b0$8);
  var a0b1$8 = Math.imul(63439, b1$8);
  var lo$19 = ((a0b0$8 + (((a1b0$7 + a0b1$8) | 0) << 16)) | 0);
  var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
  var hi$22 = ((((((Math.imul((-481036337), hi$15) + Math.imul(58195, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var lo$20 = ((lo$16 + lo$19) | 0);
  var hi$23 = ((hi$22 + ((((lo$16 & lo$19) | ((lo$16 | lo$19) & (~lo$20))) >>> 31) | 0)) | 0);
  var hi$24 = (hi$23 >> 31);
  var lo$21 = ((lo$18 + hi$23) | 0);
  var hi$25 = ((((hi$21 + hi$24) | 0) + ((((lo$18 & hi$23) | ((lo$18 | hi$23) & (~lo$21))) >>> 31) | 0)) | 0);
  var lo$22 = (((lo$21 >>> 7) | 0) | (hi$25 << 25));
  var hi$26 = (hi$25 >> 7);
  var lo$23 = ((epochMilli_$_hi >>> 31) | 0);
  var lo$24 = ((lo$22 + lo$23) | 0);
  var hi$27 = ((hi$26 + ((((lo$22 & lo$23) | ((lo$22 | lo$23) & (~lo$24))) >>> 31) | 0)) | 0);
  var b0$9 = (65535 & lo$24);
  var b1$9 = ((lo$24 >>> 16) | 0);
  var a0b0$9 = Math.imul(1000, b0$9);
  var a0b1$9 = Math.imul(1000, b1$9);
  var lo$25 = ((a0b0$9 + (a0b1$9 << 16)) | 0);
  var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
  var hi$28 = ((Math.imul(1000, hi$27) + ((c1part$9 >>> 16) | 0)) | 0);
  var lo$26 = ((epochMilli_$_lo - lo$25) | 0);
  var hi$29 = ((((epochMilli_$_hi - hi$28) | 0) + ((((~epochMilli_$_lo) & lo$25) | ((~(epochMilli_$_lo ^ lo$25)) & lo$26)) >> 31)) | 0);
  if (((epochMilli_$_hi >= 0) || ((lo$26 | hi$29) === 0))) {
    var x_$_lo = lo$26;
    var x_$_hi = hi$29;
  } else {
    var lo$28 = ((1000 + lo$26) | 0);
    var hi$30 = ((hi$29 + (((lo$26 & (~lo$28)) >>> 31) | 0)) | 0);
    var x_$_lo = lo$28;
    var x_$_hi = hi$30;
  }
  return this.java$time$Instant$$$create__J__I__Ljava_time_Instant(secs_$_lo, secs_$_hi, Math.imul(1000000, x_$_lo));
});
$c_Ljava_time_Instant$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant = (function(temporal) {
  try {
    var $x_1 = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
    var instantSecs_$_lo = $x_1.l;
    var instantSecs_$_hi = $x_1.h;
    var nanoOfSecond = $n(temporal).get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var $x_2 = $m_Ljava_time_Instant$();
    var hi = (nanoOfSecond >> 31);
    return $x_2.ofEpochSecond__J__J__Ljava_time_Instant(instantSecs_$_lo, instantSecs_$_hi, nanoOfSecond, hi);
  } catch (e) {
    if ((e instanceof $c_Ljava_time_DateTimeException)) {
      var ex = $as_Ljava_time_DateTimeException(e);
      var this$2 = $n(temporal);
      var this$3 = $objectGetClass(this$2);
      throw $ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain Instant from TemporalAccessor: " + temporal) + ", type ") + this$3.data.name), ex);
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_Instant$.prototype.java$time$Instant$$$create__J__I__Ljava_time_Instant = (function(seconds_$_lo, seconds_$_hi, nanoOfSecond) {
  var hi = (nanoOfSecond >> 31);
  var lo = (seconds_$_lo | nanoOfSecond);
  var hi$1 = (seconds_$_hi | hi);
  if (((lo | hi$1) === 0)) {
    return this.EPOCH__Ljava_time_Instant();
  } else if ((((seconds_$_hi === (-7347440)) ? ((seconds_$_lo >>> 0) < 342103040) : (seconds_$_hi < (-7347440))) || ((seconds_$_hi === 7347410) ? ((seconds_$_lo >>> 0) > 4204099839) : (seconds_$_hi > 7347410)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Instant exceeds minimum or maximum instant");
  } else {
    return new $c_Ljava_time_Instant(seconds_$_lo, seconds_$_hi, nanoOfSecond);
  }
});
var $d_Ljava_time_Instant$ = new $TypeData().initClass($c_Ljava_time_Instant$, "java.time.Instant$", ({
  Ljava_time_Instant$: 1
}));
var $n_Ljava_time_Instant$;
function $m_Ljava_time_Instant$() {
  if ((!$n_Ljava_time_Instant$)) {
    $n_Ljava_time_Instant$ = new $c_Ljava_time_Instant$();
  }
  return $n_Ljava_time_Instant$;
}
function $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate($thiz, year, month, dayOfMonth) {
  if ((dayOfMonth > 28)) {
    var $x_2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var hi = (year >> 31);
    var $x_1 = (dayOfMonth > $n(month).length__Z__I($n($x_2).isLeapYear__J__Z(year, hi)));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    if ((dayOfMonth === 29)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Invalid date 'February 29' as '" + year) + "' is not a leap year"));
    } else {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (((("Invalid date '" + $n(month).jl_Enum__f__name) + " ") + dayOfMonth) + "'"));
    }
  } else {
    return new $c_Ljava_time_LocalDate(year, $n(month).getValue__I(), dayOfMonth);
  }
}
/** @constructor */
function $c_Ljava_time_LocalDate$() {
  this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE = 0;
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970_$lo = 0;
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970_$hi = 0;
  $n_Ljava_time_LocalDate$ = this;
  this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE = 146097;
  var value = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(5, b0);
  var a0b1 = Math.imul(5, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(5, hi) + ((c1part >>> 16) | 0)) | 0);
  var lo$1 = ((lo - 10957) | 0);
  var hi$2 = ((((hi$1 - 1) | 0) + (((lo | (~lo$1)) >>> 31) | 0)) | 0);
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970_$lo = lo$1;
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970_$hi = hi$2;
}
$c_Ljava_time_LocalDate$.prototype = new $h_O();
$c_Ljava_time_LocalDate$.prototype.constructor = $c_Ljava_time_LocalDate$;
/** @constructor */
function $h_Ljava_time_LocalDate$() {
}
$h_Ljava_time_LocalDate$.prototype = $c_Ljava_time_LocalDate$.prototype;
$c_Ljava_time_LocalDate$.prototype.of__I__I__I__Ljava_time_LocalDate = (function(year, month, dayOfMonth) {
  var this$2 = $n($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
  var hi = (year >> 31);
  $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(year, hi, this$2);
  var this$4 = $n($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
  var hi$1 = (month >> 31);
  $n(this$4.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(month, hi$1, this$4);
  var this$6 = $n($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
  var hi$2 = (dayOfMonth >> 31);
  $n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(dayOfMonth, hi$2, this$6);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, $m_Ljava_time_Month$().of__I__Ljava_time_Month(month), dayOfMonth);
});
$c_Ljava_time_LocalDate$.prototype.ofYearDay__I__I__Ljava_time_LocalDate = (function(year, dayOfYear) {
  var this$2 = $n($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
  var hi = (year >> 31);
  $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(year, hi, this$2);
  var this$4 = $n($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
  var hi$1 = (dayOfYear >> 31);
  $n(this$4.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(dayOfYear, hi$1, this$4);
  var $x_1 = $n($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
  var hi$2 = (year >> 31);
  var leap = $x_1.isLeapYear__J__Z(year, hi$2);
  if (((dayOfYear === 366) && (!leap))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Invalid date 'DayOfYear 366' as '" + year) + "' is not a leap year"));
  }
  var moy = $m_Ljava_time_Month$().of__I__Ljava_time_Month(((1 + ((((dayOfYear - 1) | 0) / 31) | 0)) | 0));
  var monthEnd = (((($n(moy).firstDayOfYear__Z__I(leap) + $n(moy).length__Z__I(leap)) | 0) - 1) | 0);
  if ((dayOfYear > monthEnd)) {
    moy = $n(moy).plus__J__Ljava_time_Month(1, 0);
  }
  var dom = ((1 + ((dayOfYear - $n(moy).firstDayOfYear__Z__I(leap)) | 0)) | 0);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, moy, dom);
});
$c_Ljava_time_LocalDate$.prototype.ofEpochDay__J__Ljava_time_LocalDate = (function(epochDay_$_lo, epochDay_$_hi) {
  var this$1 = $n($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField());
  $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(epochDay_$_lo, epochDay_$_hi, this$1);
  var x_$_lo = this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970_$lo;
  var x_$_hi = this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970_$hi;
  var lo = ((epochDay_$_lo + x_$_lo) | 0);
  var hi = ((((epochDay_$_hi + x_$_hi) | 0) + ((((epochDay_$_lo & x_$_lo) | ((epochDay_$_lo | x_$_lo) & (~lo))) >>> 31) | 0)) | 0);
  var zeroDay_$_lo = lo;
  var zeroDay_$_hi = hi;
  var x$1_$_lo = zeroDay_$_lo;
  var x$1_$_hi = zeroDay_$_hi;
  var lo$1 = ((x$1_$_lo - 60) | 0);
  var hi$1 = ((((x$1_$_hi - 1) | 0) + (((x$1_$_lo | (~lo$1)) >>> 31) | 0)) | 0);
  zeroDay_$_lo = lo$1;
  zeroDay_$_hi = hi$1;
  var adjust_$_lo = 0;
  var adjust_$_hi = 0;
  var x$2_$_lo = zeroDay_$_lo;
  var x$2_$_hi = zeroDay_$_hi;
  if ((x$2_$_hi < 0)) {
    var x$3_$_lo = zeroDay_$_lo;
    var x$3_$_hi = zeroDay_$_hi;
    var lo$2 = ((1 + x$3_$_lo) | 0);
    var hi$2 = ((x$3_$_hi + (((x$3_$_lo & (~lo$2)) >>> 31) | 0)) | 0);
    var value = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
    var hi$3 = (value >> 31);
    var $x_1 = $m_RTLong$().divide__I__I__I__I__J(lo$2, hi$2, value, hi$3);
    var x$4_$_lo = $x_1.l;
    var x$4_$_hi = $x_1.h;
    var lo$3 = ((x$4_$_lo - 1) | 0);
    var hi$4 = ((((x$4_$_hi - 1) | 0) + (((x$4_$_lo | (~lo$3)) >>> 31) | 0)) | 0);
    var b0 = (65535 & lo$3);
    var b1 = ((lo$3 >>> 16) | 0);
    var a0b0 = Math.imul(400, b0);
    var a0b1 = Math.imul(400, b1);
    var lo$4 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$5 = ((Math.imul(400, hi$4) + ((c1part >>> 16) | 0)) | 0);
    adjust_$_lo = lo$4;
    adjust_$_hi = hi$5;
    var x$5_$_lo = zeroDay_$_lo;
    var x$5_$_hi = zeroDay_$_hi;
    var lo$5 = ((-lo$3) | 0);
    var hi$6 = ((((-hi$4) | 0) + ((lo$3 | lo$5) >> 31)) | 0);
    var value$1 = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
    var hi$7 = (value$1 >> 31);
    var a0 = (65535 & lo$5);
    var a1 = ((lo$5 >>> 16) | 0);
    var b0$1 = (65535 & value$1);
    var b1$1 = ((value$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0, b0$1);
    var a1b0 = Math.imul(a1, b0$1);
    var a0b1$1 = Math.imul(a0, b1$1);
    var lo$6 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$8 = ((((((((Math.imul(lo$5, hi$7) + Math.imul(hi$6, value$1)) | 0) + Math.imul(a1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$7 = ((x$5_$_lo + lo$6) | 0);
    var hi$9 = ((((x$5_$_hi + hi$8) | 0) + ((((x$5_$_lo & lo$6) | ((x$5_$_lo | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
    zeroDay_$_lo = lo$7;
    zeroDay_$_hi = hi$9;
  }
  var x$6_$_lo = zeroDay_$_lo;
  var x$6_$_hi = zeroDay_$_hi;
  var b0$2 = (65535 & x$6_$_lo);
  var b1$2 = ((x$6_$_lo >>> 16) | 0);
  var a0b0$2 = Math.imul(400, b0$2);
  var a0b1$2 = Math.imul(400, b1$2);
  var lo$8 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$10 = ((Math.imul(400, x$6_$_hi) + ((c1part$2 >>> 16) | 0)) | 0);
  var lo$9 = ((591 + lo$8) | 0);
  var hi$11 = ((hi$10 + (((lo$8 & (~lo$9)) >>> 31) | 0)) | 0);
  var value$2 = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
  var hi$12 = (value$2 >> 31);
  var $x_2 = $m_RTLong$().divide__I__I__I__I__J(lo$9, hi$11, value$2, hi$12);
  var yearEst_$_lo = $x_2.l;
  var yearEst_$_hi = $x_2.h;
  var x$8_$_lo = zeroDay_$_lo;
  var x$8_$_hi = zeroDay_$_hi;
  var x$7_$_lo = yearEst_$_lo;
  var x$7_$_hi = yearEst_$_hi;
  var b0$3 = (65535 & x$7_$_lo);
  var b1$3 = ((x$7_$_lo >>> 16) | 0);
  var a0b0$3 = Math.imul(365, b0$3);
  var a0b1$3 = Math.imul(365, b1$3);
  var lo$10 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$13 = ((Math.imul(365, x$7_$_hi) + ((c1part$3 >>> 16) | 0)) | 0);
  var num_$_lo = yearEst_$_lo;
  var num_$_hi = yearEst_$_hi;
  var hi$14 = (num_$_hi >> 1);
  var lo$12 = ((hi$14 >>> 30) | 0);
  var lo$13 = ((num_$_lo + lo$12) | 0);
  var hi$15 = ((num_$_hi + ((((num_$_lo & lo$12) | ((num_$_lo | lo$12) & (~lo$13))) >>> 31) | 0)) | 0);
  var lo$14 = (((lo$13 >>> 2) | 0) | (hi$15 << 30));
  var hi$16 = (hi$15 >> 2);
  var lo$15 = ((lo$10 + lo$14) | 0);
  var hi$17 = ((((hi$13 + hi$16) | 0) + ((((lo$10 & lo$14) | ((lo$10 | lo$14) & (~lo$15))) >>> 31) | 0)) | 0);
  var num$1_$_lo = yearEst_$_lo;
  var num$1_$_hi = yearEst_$_hi;
  var hi$18 = (num$1_$_hi >> 31);
  var b0$4 = (65535 & num$1_$_lo);
  var b1$4 = ((num$1_$_lo >>> 16) | 0);
  var a0b0$4 = Math.imul(2621, b0$4);
  var a1b0$1 = Math.imul(41943, b0$4);
  var a0b1$4 = Math.imul(2621, b1$4);
  var lo$16 = ((a0b0$4 + (((a1b0$1 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$19 = ((((((((-num$1_$_lo) | 0) + Math.imul(41943, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var b0$5 = (65535 & num$1_$_lo);
  var b1$5 = ((num$1_$_lo >>> 16) | 0);
  var a0b0$5 = Math.imul(55051, b0$5);
  var a1b0$2 = Math.imul(28835, b0$5);
  var a0b1$5 = Math.imul(55051, b1$5);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$20 = ((((Math.imul(28835, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var lo$18 = ((lo$16 + hi$20) | 0);
  var hi$21 = ((hi$19 + ((((lo$16 & hi$20) | ((lo$16 | hi$20) & (~lo$18))) >>> 31) | 0)) | 0);
  var b0$6 = (65535 & num$1_$_hi);
  var b1$6 = ((num$1_$_hi >>> 16) | 0);
  var a0b0$6 = Math.imul(2621, b0$6);
  var a1b0$3 = Math.imul(41943, b0$6);
  var a0b1$6 = Math.imul(2621, b1$6);
  var lo$19 = ((a0b0$6 + (((a1b0$3 + a0b1$6) | 0) << 16)) | 0);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$22 = ((((((((Math.imul((-1546188227), hi$18) + ((-num$1_$_hi) | 0)) | 0) + Math.imul(41943, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var hi$23 = (hi$21 >> 31);
  var lo$20 = ((lo$19 + hi$21) | 0);
  var hi$24 = ((((hi$22 + hi$23) | 0) + ((((lo$19 & hi$21) | ((lo$19 | hi$21) & (~lo$20))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & num$1_$_hi);
  var b1$7 = ((num$1_$_hi >>> 16) | 0);
  var a0b0$7 = Math.imul(55051, b0$7);
  var a1b0$4 = Math.imul(28835, b0$7);
  var a0b1$7 = Math.imul(55051, b1$7);
  var lo$21 = ((a0b0$7 + (((a1b0$4 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$25 = ((((((Math.imul(1889785611, hi$18) + Math.imul(28835, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var lo$22 = ((lo$18 + lo$21) | 0);
  var hi$26 = ((hi$25 + ((((lo$18 & lo$21) | ((lo$18 | lo$21) & (~lo$22))) >>> 31) | 0)) | 0);
  var hi$27 = (hi$26 >> 31);
  var lo$23 = ((lo$20 + hi$26) | 0);
  var hi$28 = ((((hi$24 + hi$27) | 0) + ((((lo$20 & hi$26) | ((lo$20 | hi$26) & (~lo$23))) >>> 31) | 0)) | 0);
  var lo$24 = ((lo$23 + num$1_$_lo) | 0);
  var hi$29 = ((((hi$28 + num$1_$_hi) | 0) + ((((lo$23 & num$1_$_lo) | ((lo$23 | num$1_$_lo) & (~lo$24))) >>> 31) | 0)) | 0);
  var lo$25 = (((lo$24 >>> 6) | 0) | (hi$29 << 26));
  var hi$30 = (hi$29 >> 6);
  var lo$26 = ((num$1_$_hi >>> 31) | 0);
  var lo$27 = ((lo$25 + lo$26) | 0);
  var hi$31 = ((hi$30 + ((((lo$25 & lo$26) | ((lo$25 | lo$26) & (~lo$27))) >>> 31) | 0)) | 0);
  var lo$28 = ((lo$15 - lo$27) | 0);
  var hi$32 = ((((hi$17 - hi$31) | 0) + ((((~lo$15) & lo$27) | ((~(lo$15 ^ lo$27)) & lo$28)) >> 31)) | 0);
  var num$2_$_lo = yearEst_$_lo;
  var num$2_$_hi = yearEst_$_hi;
  var hi$33 = (num$2_$_hi >> 31);
  var b0$8 = (65535 & num$2_$_lo);
  var b1$8 = ((num$2_$_lo >>> 16) | 0);
  var a0b0$8 = Math.imul(2621, b0$8);
  var a1b0$5 = Math.imul(41943, b0$8);
  var a0b1$8 = Math.imul(2621, b1$8);
  var lo$29 = ((a0b0$8 + (((a1b0$5 + a0b1$8) | 0) << 16)) | 0);
  var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
  var hi$34 = ((((((((-num$2_$_lo) | 0) + Math.imul(41943, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var b0$9 = (65535 & num$2_$_lo);
  var b1$9 = ((num$2_$_lo >>> 16) | 0);
  var a0b0$9 = Math.imul(55051, b0$9);
  var a1b0$6 = Math.imul(28835, b0$9);
  var a0b1$9 = Math.imul(55051, b1$9);
  var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
  var hi$35 = ((((Math.imul(28835, b1$9) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var lo$31 = ((lo$29 + hi$35) | 0);
  var hi$36 = ((hi$34 + ((((lo$29 & hi$35) | ((lo$29 | hi$35) & (~lo$31))) >>> 31) | 0)) | 0);
  var b0$10 = (65535 & num$2_$_hi);
  var b1$10 = ((num$2_$_hi >>> 16) | 0);
  var a0b0$10 = Math.imul(2621, b0$10);
  var a1b0$7 = Math.imul(41943, b0$10);
  var a0b1$10 = Math.imul(2621, b1$10);
  var lo$32 = ((a0b0$10 + (((a1b0$7 + a0b1$10) | 0) << 16)) | 0);
  var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
  var hi$37 = ((((((((Math.imul((-1546188227), hi$33) + ((-num$2_$_hi) | 0)) | 0) + Math.imul(41943, b1$10)) | 0) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var hi$38 = (hi$36 >> 31);
  var lo$33 = ((lo$32 + hi$36) | 0);
  var hi$39 = ((((hi$37 + hi$38) | 0) + ((((lo$32 & hi$36) | ((lo$32 | hi$36) & (~lo$33))) >>> 31) | 0)) | 0);
  var b0$11 = (65535 & num$2_$_hi);
  var b1$11 = ((num$2_$_hi >>> 16) | 0);
  var a0b0$11 = Math.imul(55051, b0$11);
  var a1b0$8 = Math.imul(28835, b0$11);
  var a0b1$11 = Math.imul(55051, b1$11);
  var lo$34 = ((a0b0$11 + (((a1b0$8 + a0b1$11) | 0) << 16)) | 0);
  var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
  var hi$40 = ((((((Math.imul(1889785611, hi$33) + Math.imul(28835, b1$11)) | 0) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$8) | 0) >>> 16) | 0)) | 0);
  var lo$35 = ((lo$31 + lo$34) | 0);
  var hi$41 = ((hi$40 + ((((lo$31 & lo$34) | ((lo$31 | lo$34) & (~lo$35))) >>> 31) | 0)) | 0);
  var hi$42 = (hi$41 >> 31);
  var lo$36 = ((lo$33 + hi$41) | 0);
  var hi$43 = ((((hi$39 + hi$42) | 0) + ((((lo$33 & hi$41) | ((lo$33 | hi$41) & (~lo$36))) >>> 31) | 0)) | 0);
  var lo$37 = ((lo$36 + num$2_$_lo) | 0);
  var hi$44 = ((((hi$43 + num$2_$_hi) | 0) + ((((lo$36 & num$2_$_lo) | ((lo$36 | num$2_$_lo) & (~lo$37))) >>> 31) | 0)) | 0);
  var lo$38 = (((lo$37 >>> 8) | 0) | (hi$44 << 24));
  var hi$45 = (hi$44 >> 8);
  var lo$39 = ((num$2_$_hi >>> 31) | 0);
  var lo$40 = ((lo$38 + lo$39) | 0);
  var hi$46 = ((hi$45 + ((((lo$38 & lo$39) | ((lo$38 | lo$39) & (~lo$40))) >>> 31) | 0)) | 0);
  var lo$41 = ((lo$28 + lo$40) | 0);
  var hi$47 = ((((hi$32 + hi$46) | 0) + ((((lo$28 & lo$40) | ((lo$28 | lo$40) & (~lo$41))) >>> 31) | 0)) | 0);
  var lo$42 = ((x$8_$_lo - lo$41) | 0);
  var hi$48 = ((((x$8_$_hi - hi$47) | 0) + ((((~x$8_$_lo) & lo$41) | ((~(x$8_$_lo ^ lo$41)) & lo$42)) >> 31)) | 0);
  var doyEst_$_lo = lo$42;
  var doyEst_$_hi = hi$48;
  var x$9_$_lo = doyEst_$_lo;
  var x$9_$_hi = doyEst_$_hi;
  if ((x$9_$_hi < 0)) {
    var x$10_$_lo = yearEst_$_lo;
    var x$10_$_hi = yearEst_$_hi;
    var lo$43 = ((x$10_$_lo - 1) | 0);
    var hi$49 = ((((x$10_$_hi - 1) | 0) + (((x$10_$_lo | (~lo$43)) >>> 31) | 0)) | 0);
    yearEst_$_lo = lo$43;
    yearEst_$_hi = hi$49;
    var x$12_$_lo = zeroDay_$_lo;
    var x$12_$_hi = zeroDay_$_hi;
    var x$11_$_lo = yearEst_$_lo;
    var x$11_$_hi = yearEst_$_hi;
    var b0$12 = (65535 & x$11_$_lo);
    var b1$12 = ((x$11_$_lo >>> 16) | 0);
    var a0b0$12 = Math.imul(365, b0$12);
    var a0b1$12 = Math.imul(365, b1$12);
    var lo$44 = ((a0b0$12 + (a0b1$12 << 16)) | 0);
    var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
    var hi$50 = ((Math.imul(365, x$11_$_hi) + ((c1part$12 >>> 16) | 0)) | 0);
    var num$3_$_lo = yearEst_$_lo;
    var num$3_$_hi = yearEst_$_hi;
    var hi$51 = (num$3_$_hi >> 1);
    var lo$46 = ((hi$51 >>> 30) | 0);
    var lo$47 = ((num$3_$_lo + lo$46) | 0);
    var hi$52 = ((num$3_$_hi + ((((num$3_$_lo & lo$46) | ((num$3_$_lo | lo$46) & (~lo$47))) >>> 31) | 0)) | 0);
    var lo$48 = (((lo$47 >>> 2) | 0) | (hi$52 << 30));
    var hi$53 = (hi$52 >> 2);
    var lo$49 = ((lo$44 + lo$48) | 0);
    var hi$54 = ((((hi$50 + hi$53) | 0) + ((((lo$44 & lo$48) | ((lo$44 | lo$48) & (~lo$49))) >>> 31) | 0)) | 0);
    var num$4_$_lo = yearEst_$_lo;
    var num$4_$_hi = yearEst_$_hi;
    var hi$55 = (num$4_$_hi >> 31);
    var b0$13 = (65535 & num$4_$_lo);
    var b1$13 = ((num$4_$_lo >>> 16) | 0);
    var a0b0$13 = Math.imul(2621, b0$13);
    var a1b0$9 = Math.imul(41943, b0$13);
    var a0b1$13 = Math.imul(2621, b1$13);
    var lo$50 = ((a0b0$13 + (((a1b0$9 + a0b1$13) | 0) << 16)) | 0);
    var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
    var hi$56 = ((((((((-num$4_$_lo) | 0) + Math.imul(41943, b1$13)) | 0) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$9) | 0) >>> 16) | 0)) | 0);
    var b0$14 = (65535 & num$4_$_lo);
    var b1$14 = ((num$4_$_lo >>> 16) | 0);
    var a0b0$14 = Math.imul(55051, b0$14);
    var a1b0$10 = Math.imul(28835, b0$14);
    var a0b1$14 = Math.imul(55051, b1$14);
    var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
    var hi$57 = ((((Math.imul(28835, b1$14) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$10) | 0) >>> 16) | 0)) | 0);
    var lo$52 = ((lo$50 + hi$57) | 0);
    var hi$58 = ((hi$56 + ((((lo$50 & hi$57) | ((lo$50 | hi$57) & (~lo$52))) >>> 31) | 0)) | 0);
    var b0$15 = (65535 & num$4_$_hi);
    var b1$15 = ((num$4_$_hi >>> 16) | 0);
    var a0b0$15 = Math.imul(2621, b0$15);
    var a1b0$11 = Math.imul(41943, b0$15);
    var a0b1$15 = Math.imul(2621, b1$15);
    var lo$53 = ((a0b0$15 + (((a1b0$11 + a0b1$15) | 0) << 16)) | 0);
    var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
    var hi$59 = ((((((((Math.imul((-1546188227), hi$55) + ((-num$4_$_hi) | 0)) | 0) + Math.imul(41943, b1$15)) | 0) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$11) | 0) >>> 16) | 0)) | 0);
    var hi$60 = (hi$58 >> 31);
    var lo$54 = ((lo$53 + hi$58) | 0);
    var hi$61 = ((((hi$59 + hi$60) | 0) + ((((lo$53 & hi$58) | ((lo$53 | hi$58) & (~lo$54))) >>> 31) | 0)) | 0);
    var b0$16 = (65535 & num$4_$_hi);
    var b1$16 = ((num$4_$_hi >>> 16) | 0);
    var a0b0$16 = Math.imul(55051, b0$16);
    var a1b0$12 = Math.imul(28835, b0$16);
    var a0b1$16 = Math.imul(55051, b1$16);
    var lo$55 = ((a0b0$16 + (((a1b0$12 + a0b1$16) | 0) << 16)) | 0);
    var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
    var hi$62 = ((((((Math.imul(1889785611, hi$55) + Math.imul(28835, b1$16)) | 0) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$12) | 0) >>> 16) | 0)) | 0);
    var lo$56 = ((lo$52 + lo$55) | 0);
    var hi$63 = ((hi$62 + ((((lo$52 & lo$55) | ((lo$52 | lo$55) & (~lo$56))) >>> 31) | 0)) | 0);
    var hi$64 = (hi$63 >> 31);
    var lo$57 = ((lo$54 + hi$63) | 0);
    var hi$65 = ((((hi$61 + hi$64) | 0) + ((((lo$54 & hi$63) | ((lo$54 | hi$63) & (~lo$57))) >>> 31) | 0)) | 0);
    var lo$58 = ((lo$57 + num$4_$_lo) | 0);
    var hi$66 = ((((hi$65 + num$4_$_hi) | 0) + ((((lo$57 & num$4_$_lo) | ((lo$57 | num$4_$_lo) & (~lo$58))) >>> 31) | 0)) | 0);
    var lo$59 = (((lo$58 >>> 6) | 0) | (hi$66 << 26));
    var hi$67 = (hi$66 >> 6);
    var lo$60 = ((num$4_$_hi >>> 31) | 0);
    var lo$61 = ((lo$59 + lo$60) | 0);
    var hi$68 = ((hi$67 + ((((lo$59 & lo$60) | ((lo$59 | lo$60) & (~lo$61))) >>> 31) | 0)) | 0);
    var lo$62 = ((lo$49 - lo$61) | 0);
    var hi$69 = ((((hi$54 - hi$68) | 0) + ((((~lo$49) & lo$61) | ((~(lo$49 ^ lo$61)) & lo$62)) >> 31)) | 0);
    var num$5_$_lo = yearEst_$_lo;
    var num$5_$_hi = yearEst_$_hi;
    var hi$70 = (num$5_$_hi >> 31);
    var b0$17 = (65535 & num$5_$_lo);
    var b1$17 = ((num$5_$_lo >>> 16) | 0);
    var a0b0$17 = Math.imul(2621, b0$17);
    var a1b0$13 = Math.imul(41943, b0$17);
    var a0b1$17 = Math.imul(2621, b1$17);
    var lo$63 = ((a0b0$17 + (((a1b0$13 + a0b1$17) | 0) << 16)) | 0);
    var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
    var hi$71 = ((((((((-num$5_$_lo) | 0) + Math.imul(41943, b1$17)) | 0) + ((c1part$17 >>> 16) | 0)) | 0) + (((((65535 & c1part$17) + a1b0$13) | 0) >>> 16) | 0)) | 0);
    var b0$18 = (65535 & num$5_$_lo);
    var b1$18 = ((num$5_$_lo >>> 16) | 0);
    var a0b0$18 = Math.imul(55051, b0$18);
    var a1b0$14 = Math.imul(28835, b0$18);
    var a0b1$18 = Math.imul(55051, b1$18);
    var c1part$18 = ((((a0b0$18 >>> 16) | 0) + a0b1$18) | 0);
    var hi$72 = ((((Math.imul(28835, b1$18) + ((c1part$18 >>> 16) | 0)) | 0) + (((((65535 & c1part$18) + a1b0$14) | 0) >>> 16) | 0)) | 0);
    var lo$65 = ((lo$63 + hi$72) | 0);
    var hi$73 = ((hi$71 + ((((lo$63 & hi$72) | ((lo$63 | hi$72) & (~lo$65))) >>> 31) | 0)) | 0);
    var b0$19 = (65535 & num$5_$_hi);
    var b1$19 = ((num$5_$_hi >>> 16) | 0);
    var a0b0$19 = Math.imul(2621, b0$19);
    var a1b0$15 = Math.imul(41943, b0$19);
    var a0b1$19 = Math.imul(2621, b1$19);
    var lo$66 = ((a0b0$19 + (((a1b0$15 + a0b1$19) | 0) << 16)) | 0);
    var c1part$19 = ((((a0b0$19 >>> 16) | 0) + a0b1$19) | 0);
    var hi$74 = ((((((((Math.imul((-1546188227), hi$70) + ((-num$5_$_hi) | 0)) | 0) + Math.imul(41943, b1$19)) | 0) + ((c1part$19 >>> 16) | 0)) | 0) + (((((65535 & c1part$19) + a1b0$15) | 0) >>> 16) | 0)) | 0);
    var hi$75 = (hi$73 >> 31);
    var lo$67 = ((lo$66 + hi$73) | 0);
    var hi$76 = ((((hi$74 + hi$75) | 0) + ((((lo$66 & hi$73) | ((lo$66 | hi$73) & (~lo$67))) >>> 31) | 0)) | 0);
    var b0$20 = (65535 & num$5_$_hi);
    var b1$20 = ((num$5_$_hi >>> 16) | 0);
    var a0b0$20 = Math.imul(55051, b0$20);
    var a1b0$16 = Math.imul(28835, b0$20);
    var a0b1$20 = Math.imul(55051, b1$20);
    var lo$68 = ((a0b0$20 + (((a1b0$16 + a0b1$20) | 0) << 16)) | 0);
    var c1part$20 = ((((a0b0$20 >>> 16) | 0) + a0b1$20) | 0);
    var hi$77 = ((((((Math.imul(1889785611, hi$70) + Math.imul(28835, b1$20)) | 0) + ((c1part$20 >>> 16) | 0)) | 0) + (((((65535 & c1part$20) + a1b0$16) | 0) >>> 16) | 0)) | 0);
    var lo$69 = ((lo$65 + lo$68) | 0);
    var hi$78 = ((hi$77 + ((((lo$65 & lo$68) | ((lo$65 | lo$68) & (~lo$69))) >>> 31) | 0)) | 0);
    var hi$79 = (hi$78 >> 31);
    var lo$70 = ((lo$67 + hi$78) | 0);
    var hi$80 = ((((hi$76 + hi$79) | 0) + ((((lo$67 & hi$78) | ((lo$67 | hi$78) & (~lo$70))) >>> 31) | 0)) | 0);
    var lo$71 = ((lo$70 + num$5_$_lo) | 0);
    var hi$81 = ((((hi$80 + num$5_$_hi) | 0) + ((((lo$70 & num$5_$_lo) | ((lo$70 | num$5_$_lo) & (~lo$71))) >>> 31) | 0)) | 0);
    var lo$72 = (((lo$71 >>> 8) | 0) | (hi$81 << 24));
    var hi$82 = (hi$81 >> 8);
    var lo$73 = ((num$5_$_hi >>> 31) | 0);
    var lo$74 = ((lo$72 + lo$73) | 0);
    var hi$83 = ((hi$82 + ((((lo$72 & lo$73) | ((lo$72 | lo$73) & (~lo$74))) >>> 31) | 0)) | 0);
    var lo$75 = ((lo$62 + lo$74) | 0);
    var hi$84 = ((((hi$69 + hi$83) | 0) + ((((lo$62 & lo$74) | ((lo$62 | lo$74) & (~lo$75))) >>> 31) | 0)) | 0);
    var lo$76 = ((x$12_$_lo - lo$75) | 0);
    var hi$85 = ((((x$12_$_hi - hi$84) | 0) + ((((~x$12_$_lo) & lo$75) | ((~(x$12_$_lo ^ lo$75)) & lo$76)) >> 31)) | 0);
    doyEst_$_lo = lo$76;
    doyEst_$_hi = hi$85;
  }
  var x$13_$_lo = yearEst_$_lo;
  var x$13_$_hi = yearEst_$_hi;
  var x$14_$_lo = adjust_$_lo;
  var x$14_$_hi = adjust_$_hi;
  var lo$77 = ((x$13_$_lo + x$14_$_lo) | 0);
  var hi$86 = ((((x$13_$_hi + x$14_$_hi) | 0) + ((((x$13_$_lo & x$14_$_lo) | ((x$13_$_lo | x$14_$_lo) & (~lo$77))) >>> 31) | 0)) | 0);
  yearEst_$_lo = lo$77;
  yearEst_$_hi = hi$86;
  var x$15_$_lo = doyEst_$_lo;
  var x$15_$_hi = doyEst_$_hi;
  var marchMonth0 = ((((2 + Math.imul(5, x$15_$_lo)) | 0) / 153) | 0);
  var month = ((1 + ((((2 + marchMonth0) | 0) % 12) | 0)) | 0);
  var dom = ((1 + ((x$15_$_lo - ((((5 + Math.imul(306, marchMonth0)) | 0) / 10) | 0)) | 0)) | 0);
  var x$16_$_lo = yearEst_$_lo;
  var x$16_$_hi = yearEst_$_hi;
  var value$3 = ((marchMonth0 / 10) | 0);
  var hi$87 = (value$3 >> 31);
  var lo$78 = ((x$16_$_lo + value$3) | 0);
  var hi$88 = ((((x$16_$_hi + hi$87) | 0) + ((((x$16_$_lo & value$3) | ((x$16_$_lo | value$3) & (~lo$78))) >>> 31) | 0)) | 0);
  yearEst_$_lo = lo$78;
  yearEst_$_hi = hi$88;
  var this$112 = $n($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
  var value$4_$_lo = yearEst_$_lo;
  var value$4_$_hi = yearEst_$_hi;
  var year = $n(this$112.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(value$4_$_lo, value$4_$_hi, this$112);
  return new $c_Ljava_time_LocalDate(year, month, dom);
});
$c_Ljava_time_LocalDate$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate = (function(temporal) {
  var date = $as_Ljava_time_LocalDate($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()));
  if ((date === null)) {
    var this$1 = $n(temporal);
    var this$2 = $objectGetClass(this$1);
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalDate from TemporalAccessor: " + temporal) + ", type ") + this$2.data.name));
  }
  return date;
});
$c_Ljava_time_LocalDate$.prototype.java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate = (function(year, month, day) {
  var _day;
  switch (month) {
    case 2: {
      var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      var hi = (year >> 31);
      if ($n($x_1).isLeapYear__J__Z(year, hi)) {
        var b = 29;
      } else {
        var b = 28;
      }
      var _day = ((day < b) ? day : b);
      break;
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      var _day = ((day < 30) ? day : 30);
      break;
    }
    default: {
      var _day = day;
    }
  }
  return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, month, _day);
});
var $d_Ljava_time_LocalDate$ = new $TypeData().initClass($c_Ljava_time_LocalDate$, "java.time.LocalDate$", ({
  Ljava_time_LocalDate$: 1
}));
var $n_Ljava_time_LocalDate$;
function $m_Ljava_time_LocalDate$() {
  if ((!$n_Ljava_time_LocalDate$)) {
    $n_Ljava_time_LocalDate$ = new $c_Ljava_time_LocalDate$();
  }
  return $n_Ljava_time_LocalDate$;
}
/** @constructor */
function $c_Ljava_time_LocalDateTime$() {
}
$c_Ljava_time_LocalDateTime$.prototype = new $h_O();
$c_Ljava_time_LocalDateTime$.prototype.constructor = $c_Ljava_time_LocalDateTime$;
/** @constructor */
function $h_Ljava_time_LocalDateTime$() {
}
$h_Ljava_time_LocalDateTime$.prototype = $c_Ljava_time_LocalDateTime$.prototype;
$c_Ljava_time_LocalDateTime$.prototype.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime = (function(epochSecond_$_lo, epochSecond_$_hi, nanoOfSecond, offset) {
  $n(offset);
  var this$1 = $n(offset);
  var value = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  var lo = ((epochSecond_$_lo + value) | 0);
  var hi$1 = ((((epochSecond_$_hi + hi) | 0) + ((((epochSecond_$_lo & value) | ((epochSecond_$_lo | value) & (~lo))) >>> 31) | 0)) | 0);
  var hi$2 = (hi$1 >> 31);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(51360, b0);
  var a1b0 = Math.imul(6213, b0);
  var a0b1 = Math.imul(51360, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$3 = ((((Math.imul(6213, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & lo);
  var b1$1 = ((lo >>> 16) | 0);
  var a0b0$1 = Math.imul(10583, b0$1);
  var a1b0$1 = Math.imul(52817, b0$1);
  var a0b1$1 = Math.imul(10583, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$4 = ((((Math.imul(52817, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$3 = ((lo$1 + hi$4) | 0);
  var hi$5 = ((hi$3 + ((((lo$1 & hi$4) | ((lo$1 | hi$4) & (~lo$3))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & hi$1);
  var b1$2 = ((hi$1 >>> 16) | 0);
  var a0b0$2 = Math.imul(51360, b0$2);
  var a1b0$2 = Math.imul(6213, b0$2);
  var a0b1$2 = Math.imul(51360, b1$2);
  var lo$4 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$6 = ((((((Math.imul(407226528, hi$2) + Math.imul(6213, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$7 = (hi$5 >> 31);
  var lo$5 = ((lo$4 + hi$5) | 0);
  var hi$8 = ((((hi$6 + hi$7) | 0) + ((((lo$4 & hi$5) | ((lo$4 | hi$5) & (~lo$5))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & hi$1);
  var b1$3 = ((hi$1 >>> 16) | 0);
  var a0b0$3 = Math.imul(10583, b0$3);
  var a1b0$3 = Math.imul(52817, b0$3);
  var a0b1$3 = Math.imul(10583, b1$3);
  var lo$6 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$9 = ((((((Math.imul((-833541801), hi$2) + Math.imul(52817, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$7 = ((lo$3 + lo$6) | 0);
  var hi$10 = ((hi$9 + ((((lo$3 & lo$6) | ((lo$3 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
  var hi$11 = (hi$10 >> 31);
  var lo$8 = ((lo$5 + hi$10) | 0);
  var hi$12 = ((((hi$8 + hi$11) | 0) + ((((lo$5 & hi$10) | ((lo$5 | hi$10) & (~lo$8))) >>> 31) | 0)) | 0);
  var lo$9 = (((lo$8 >>> 13) | 0) | (hi$12 << 19));
  var hi$13 = (hi$12 >> 13);
  var lo$10 = ((hi$1 >>> 31) | 0);
  var lo$11 = ((lo$9 + lo$10) | 0);
  var hi$14 = ((hi$13 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
  if ((hi$1 >= 0)) {
    var $x_1 = true;
  } else {
    var b0$4 = (65535 & lo$11);
    var b1$4 = ((lo$11 >>> 16) | 0);
    var a0b0$4 = Math.imul(20864, b0$4);
    var a0b1$4 = Math.imul(20864, b1$4);
    var lo$13 = ((a0b0$4 + (((b0$4 + a0b1$4) | 0) << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$15 = ((((((Math.imul(86400, hi$14) + b1$4) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + b0$4) | 0) >>> 16) | 0)) | 0);
    var $x_1 = (((lo$13 ^ lo) | (hi$15 ^ hi$1)) === 0);
  }
  if ($x_1) {
    var localEpochDay_$_lo = lo$11;
    var localEpochDay_$_hi = hi$14;
  } else {
    var lo$14 = ((lo$11 - 1) | 0);
    var hi$16 = ((((hi$14 - 1) | 0) + (((lo$11 | (~lo$14)) >>> 31) | 0)) | 0);
    var localEpochDay_$_lo = lo$14;
    var localEpochDay_$_hi = hi$16;
  }
  var hi$17 = (hi$1 >> 31);
  var b0$5 = (65535 & lo);
  var b1$5 = ((lo >>> 16) | 0);
  var a0b0$5 = Math.imul(51360, b0$5);
  var a1b0$4 = Math.imul(6213, b0$5);
  var a0b1$5 = Math.imul(51360, b1$5);
  var lo$15 = ((a0b0$5 + (((a1b0$4 + a0b1$5) | 0) << 16)) | 0);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$18 = ((((Math.imul(6213, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var b0$6 = (65535 & lo);
  var b1$6 = ((lo >>> 16) | 0);
  var a0b0$6 = Math.imul(10583, b0$6);
  var a1b0$5 = Math.imul(52817, b0$6);
  var a0b1$6 = Math.imul(10583, b1$6);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$19 = ((((Math.imul(52817, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var lo$17 = ((lo$15 + hi$19) | 0);
  var hi$20 = ((hi$18 + ((((lo$15 & hi$19) | ((lo$15 | hi$19) & (~lo$17))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & hi$1);
  var b1$7 = ((hi$1 >>> 16) | 0);
  var a0b0$7 = Math.imul(51360, b0$7);
  var a1b0$6 = Math.imul(6213, b0$7);
  var a0b1$7 = Math.imul(51360, b1$7);
  var lo$18 = ((a0b0$7 + (((a1b0$6 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$21 = ((((((Math.imul(407226528, hi$17) + Math.imul(6213, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var hi$22 = (hi$20 >> 31);
  var lo$19 = ((lo$18 + hi$20) | 0);
  var hi$23 = ((((hi$21 + hi$22) | 0) + ((((lo$18 & hi$20) | ((lo$18 | hi$20) & (~lo$19))) >>> 31) | 0)) | 0);
  var b0$8 = (65535 & hi$1);
  var b1$8 = ((hi$1 >>> 16) | 0);
  var a0b0$8 = Math.imul(10583, b0$8);
  var a1b0$7 = Math.imul(52817, b0$8);
  var a0b1$8 = Math.imul(10583, b1$8);
  var lo$20 = ((a0b0$8 + (((a1b0$7 + a0b1$8) | 0) << 16)) | 0);
  var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
  var hi$24 = ((((((Math.imul((-833541801), hi$17) + Math.imul(52817, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var lo$21 = ((lo$17 + lo$20) | 0);
  var hi$25 = ((hi$24 + ((((lo$17 & lo$20) | ((lo$17 | lo$20) & (~lo$21))) >>> 31) | 0)) | 0);
  var hi$26 = (hi$25 >> 31);
  var lo$22 = ((lo$19 + hi$25) | 0);
  var hi$27 = ((((hi$23 + hi$26) | 0) + ((((lo$19 & hi$25) | ((lo$19 | hi$25) & (~lo$22))) >>> 31) | 0)) | 0);
  var lo$23 = (((lo$22 >>> 13) | 0) | (hi$27 << 19));
  var hi$28 = (hi$27 >> 13);
  var lo$24 = ((hi$1 >>> 31) | 0);
  var lo$25 = ((lo$23 + lo$24) | 0);
  var hi$29 = ((hi$28 + ((((lo$23 & lo$24) | ((lo$23 | lo$24) & (~lo$25))) >>> 31) | 0)) | 0);
  var b0$9 = (65535 & lo$25);
  var b1$9 = ((lo$25 >>> 16) | 0);
  var a0b0$9 = Math.imul(20864, b0$9);
  var a0b1$9 = Math.imul(20864, b1$9);
  var lo$26 = ((a0b0$9 + (((b0$9 + a0b1$9) | 0) << 16)) | 0);
  var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
  var hi$30 = ((((((Math.imul(86400, hi$29) + b1$9) | 0) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + b0$9) | 0) >>> 16) | 0)) | 0);
  var lo$27 = ((lo - lo$26) | 0);
  var hi$31 = ((((hi$1 - hi$30) | 0) + ((((~lo) & lo$26) | ((~(lo ^ lo$26)) & lo$27)) >> 31)) | 0);
  if (((hi$1 >= 0) || ((lo$27 | hi$31) === 0))) {
    var x_$_lo = lo$27;
    var x_$_hi = hi$31;
  } else {
    var lo$29 = ((86400 + lo$27) | 0);
    var hi$32 = ((hi$31 + (((lo$27 & (~lo$29)) >>> 31) | 0)) | 0);
    var x_$_lo = lo$29;
    var x_$_hi = hi$32;
  }
  var date = $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(localEpochDay_$_lo, localEpochDay_$_hi);
  var $x_2 = $m_Ljava_time_LocalTime$();
  var hi$33 = (x_$_lo >> 31);
  var time = $x_2.ofSecondOfDay__J__I__Ljava_time_LocalTime(x_$_lo, hi$33, nanoOfSecond);
  return new $c_Ljava_time_LocalDateTime(date, time);
});
$c_Ljava_time_LocalDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_LocalDateTime)) {
    var l = $as_Ljava_time_LocalDateTime(temporal);
    return l;
  } else if ((temporal instanceof $c_Ljava_time_ZonedDateTime)) {
    var z = $as_Ljava_time_ZonedDateTime(temporal);
    var this$1 = $n(z);
    return this$1.Ljava_time_ZonedDateTime__f_dateTime;
  } else {
    try {
      var date = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
      var time = $m_Ljava_time_LocalTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(temporal);
      return new $c_Ljava_time_LocalDateTime(date, time);
    } catch (e) {
      if ((e instanceof $c_Ljava_time_DateTimeException)) {
        var this$2 = $n(temporal);
        var this$3 = $objectGetClass(this$2);
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalDateTime from TemporalAccessor: " + temporal) + ", type ") + this$3.data.name));
      } else {
        throw e;
      }
    }
  }
});
var $d_Ljava_time_LocalDateTime$ = new $TypeData().initClass($c_Ljava_time_LocalDateTime$, "java.time.LocalDateTime$", ({
  Ljava_time_LocalDateTime$: 1
}));
var $n_Ljava_time_LocalDateTime$;
function $m_Ljava_time_LocalDateTime$() {
  if ((!$n_Ljava_time_LocalDateTime$)) {
    $n_Ljava_time_LocalDateTime$ = new $c_Ljava_time_LocalDateTime$();
  }
  return $n_Ljava_time_LocalDateTime$;
}
function $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime($thiz) {
  if ((!$thiz.Ljava_time_LocalTime$__f_HOURSbitmap$1)) {
    var dimensions = new $ac_I(new Int32Array([24]));
    var hours = $asArrayOf_Ljava_time_LocalTime($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_LocalTime.getClassOf(), dimensions), 1);
    var i = 0;
    while ((i < $n(hours).u.length)) {
      $n(hours).set(i, new $c_Ljava_time_LocalTime(i, 0, 0, 0));
      i = ((1 + i) | 0);
    }
    $thiz.Ljava_time_LocalTime$__f_HOURS$lzy1 = hours;
    $thiz.Ljava_time_LocalTime$__f_HOURSbitmap$1 = true;
  }
  return $thiz.Ljava_time_LocalTime$__f_HOURS$lzy1;
}
/** @constructor */
function $c_Ljava_time_LocalTime$() {
  this.Ljava_time_LocalTime$__f_HOURS$lzy1 = null;
  this.Ljava_time_LocalTime$__f_HOURSbitmap$1 = false;
}
$c_Ljava_time_LocalTime$.prototype = new $h_O();
$c_Ljava_time_LocalTime$.prototype.constructor = $c_Ljava_time_LocalTime$;
/** @constructor */
function $h_Ljava_time_LocalTime$() {
}
$h_Ljava_time_LocalTime$.prototype = $c_Ljava_time_LocalTime$.prototype;
$c_Ljava_time_LocalTime$.prototype.ofSecondOfDay__J__I__Ljava_time_LocalTime = (function(secondOfDay_$_lo, secondOfDay_$_hi, nanoOfSecond) {
  var _secondOfDay_$_lo = secondOfDay_$_lo;
  var _secondOfDay_$_hi = secondOfDay_$_hi;
  var this$1 = $n($s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField());
  var value_$_lo = _secondOfDay_$_lo;
  var value_$_hi = _secondOfDay_$_hi;
  $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(value_$_lo, value_$_hi, this$1);
  var this$3 = $n($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  var hi = (nanoOfSecond >> 31);
  $n(this$3.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(nanoOfSecond, hi, this$3);
  var num_$_lo = _secondOfDay_$_lo;
  var num_$_hi = _secondOfDay_$_hi;
  var hi$1 = (num_$_hi >> 31);
  var b0 = (65535 & num_$_lo);
  var b1 = ((num_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(23010, b0);
  var a1b0 = Math.imul(18641, b0);
  var a0b1 = Math.imul(23010, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((((Math.imul(18641, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & num_$_lo);
  var b1$1 = ((num_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(31749, b0$1);
  var a1b0$1 = Math.imul(27379, b0$1);
  var a0b1$1 = Math.imul(31749, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((Math.imul(27379, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$3) | 0);
  var hi$4 = ((hi$2 + ((((lo & hi$3) | ((lo | hi$3) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & num_$_hi);
  var b1$2 = ((num_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(23010, b0$2);
  var a1b0$2 = Math.imul(18641, b0$2);
  var a0b1$2 = Math.imul(23010, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$5 = ((((((Math.imul(1221679586, hi$1) + Math.imul(18641, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$6 = (hi$4 >> 31);
  var lo$4 = ((lo$3 + hi$4) | 0);
  var hi$7 = ((((hi$5 + hi$6) | 0) + ((((lo$3 & hi$4) | ((lo$3 | hi$4) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & num_$_hi);
  var b1$3 = ((num_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(31749, b0$3);
  var a1b0$3 = Math.imul(27379, b0$3);
  var a0b1$3 = Math.imul(31749, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$8 = ((((((Math.imul(1794341893, hi$1) + Math.imul(27379, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$9 = ((hi$8 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$10 = (hi$9 >> 31);
  var lo$7 = ((lo$4 + hi$9) | 0);
  var hi$11 = ((((hi$7 + hi$10) | 0) + ((((lo$4 & hi$9) | ((lo$4 | hi$9) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 10) | 0) | (hi$11 << 22));
  var lo$9 = ((num_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var x_$_lo = _secondOfDay_$_lo;
  var x_$_hi = _secondOfDay_$_hi;
  var value$1 = Math.imul(3600, lo$10);
  var hi$14 = (value$1 >> 31);
  var lo$11 = ((x_$_lo - value$1) | 0);
  var hi$15 = ((((x_$_hi - hi$14) | 0) + ((((~x_$_lo) & value$1) | ((~(x_$_lo ^ value$1)) & lo$11)) >> 31)) | 0);
  _secondOfDay_$_lo = lo$11;
  _secondOfDay_$_hi = hi$15;
  var num$1_$_lo = _secondOfDay_$_lo;
  var num$1_$_hi = _secondOfDay_$_hi;
  var hi$16 = (num$1_$_hi >> 31);
  var b0$4 = (65535 & num$1_$_lo);
  var b1$4 = ((num$1_$_lo >>> 16) | 0);
  var a0b0$4 = Math.imul(34952, b0$4);
  var a1b0$4 = Math.imul(34952, b0$4);
  var a0b1$4 = Math.imul(34952, b1$4);
  var lo$12 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$17 = ((((((((-num$1_$_lo) | 0) + Math.imul(34952, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var b0$5 = (65535 & num$1_$_lo);
  var b1$5 = ((num$1_$_lo >>> 16) | 0);
  var a0b0$5 = Math.imul(34953, b0$5);
  var a1b0$5 = Math.imul(34952, b0$5);
  var a0b1$5 = Math.imul(34953, b1$5);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$18 = ((((Math.imul(34952, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var lo$14 = ((lo$12 + hi$18) | 0);
  var hi$19 = ((hi$17 + ((((lo$12 & hi$18) | ((lo$12 | hi$18) & (~lo$14))) >>> 31) | 0)) | 0);
  var b0$6 = (65535 & num$1_$_hi);
  var b1$6 = ((num$1_$_hi >>> 16) | 0);
  var a0b0$6 = Math.imul(34952, b0$6);
  var a1b0$6 = Math.imul(34952, b0$6);
  var a0b1$6 = Math.imul(34952, b1$6);
  var lo$15 = ((a0b0$6 + (((a1b0$6 + a0b1$6) | 0) << 16)) | 0);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$20 = ((((((((Math.imul((-2004318072), hi$16) + ((-num$1_$_hi) | 0)) | 0) + Math.imul(34952, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var hi$21 = (hi$19 >> 31);
  var lo$16 = ((lo$15 + hi$19) | 0);
  var hi$22 = ((((hi$20 + hi$21) | 0) + ((((lo$15 & hi$19) | ((lo$15 | hi$19) & (~lo$16))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & num$1_$_hi);
  var b1$7 = ((num$1_$_hi >>> 16) | 0);
  var a0b0$7 = Math.imul(34953, b0$7);
  var a1b0$7 = Math.imul(34952, b0$7);
  var a0b1$7 = Math.imul(34953, b1$7);
  var lo$17 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$23 = ((((((Math.imul((-2004318071), hi$16) + Math.imul(34952, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var lo$18 = ((lo$14 + lo$17) | 0);
  var hi$24 = ((hi$23 + ((((lo$14 & lo$17) | ((lo$14 | lo$17) & (~lo$18))) >>> 31) | 0)) | 0);
  var hi$25 = (hi$24 >> 31);
  var lo$19 = ((lo$16 + hi$24) | 0);
  var hi$26 = ((((hi$22 + hi$25) | 0) + ((((lo$16 & hi$24) | ((lo$16 | hi$24) & (~lo$19))) >>> 31) | 0)) | 0);
  var lo$20 = ((lo$19 + num$1_$_lo) | 0);
  var hi$27 = ((((hi$26 + num$1_$_hi) | 0) + ((((lo$19 & num$1_$_lo) | ((lo$19 | num$1_$_lo) & (~lo$20))) >>> 31) | 0)) | 0);
  var lo$21 = (((lo$20 >>> 5) | 0) | (hi$27 << 27));
  var lo$22 = ((num$1_$_hi >>> 31) | 0);
  var lo$23 = ((lo$21 + lo$22) | 0);
  var x$1_$_lo = _secondOfDay_$_lo;
  var x$1_$_hi = _secondOfDay_$_hi;
  var value$2 = Math.imul(60, lo$23);
  var hi$30 = (value$2 >> 31);
  var lo$24 = ((x$1_$_lo - value$2) | 0);
  var hi$31 = ((((x$1_$_hi - hi$30) | 0) + ((((~x$1_$_lo) & value$2) | ((~(x$1_$_lo ^ value$2)) & lo$24)) >> 31)) | 0);
  _secondOfDay_$_lo = lo$24;
  _secondOfDay_$_hi = hi$31;
  var x$2_$_lo = _secondOfDay_$_lo;
  var x$2_$_hi = _secondOfDay_$_hi;
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$10, lo$23, x$2_$_lo, nanoOfSecond);
});
$c_Ljava_time_LocalTime$.prototype.ofNanoOfDay__J__Ljava_time_LocalTime = (function(nanoOfDay_$_lo, nanoOfDay_$_hi) {
  var _nanoOfDay_$_lo = nanoOfDay_$_lo;
  var _nanoOfDay_$_hi = nanoOfDay_$_hi;
  var this$1 = $n($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField());
  var value_$_lo = _nanoOfDay_$_lo;
  var value_$_hi = _nanoOfDay_$_hi;
  $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(value_$_lo, value_$_hi, this$1);
  var num_$_lo = _nanoOfDay_$_lo;
  var num_$_hi = _nanoOfDay_$_hi;
  var hi = (num_$_hi >> 31);
  var b0 = (65535 & num_$_lo);
  var b1 = ((num_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(65318, b0);
  var a1b0 = Math.imul(40031, b0);
  var a0b1 = Math.imul(65318, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((-num_$_lo) | 0) + Math.imul(40031, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & num_$_lo);
  var b1$1 = ((num_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(60757, b0$1);
  var a1b0$1 = Math.imul(60789, b0$1);
  var a0b1$1 = Math.imul(60757, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(60789, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & num_$_hi);
  var b1$2 = ((num_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(65318, b0$2);
  var a1b0$2 = Math.imul(40031, b0$2);
  var a0b1$2 = Math.imul(65318, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((((Math.imul((-1671430362), hi) + ((-num_$_hi) | 0)) | 0) + Math.imul(40031, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & num_$_hi);
  var b1$3 = ((num_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(60757, b0$3);
  var a1b0$3 = Math.imul(60789, b0$3);
  var a0b1$3 = Math.imul(60757, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-311038635), hi) + Math.imul(60789, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = ((lo$7 + num_$_lo) | 0);
  var hi$11 = ((((hi$10 + num_$_hi) | 0) + ((((lo$7 & num_$_lo) | ((lo$7 | num_$_lo) & (~lo$8))) >>> 31) | 0)) | 0);
  var lo$9 = (hi$11 >> 9);
  var lo$10 = ((num_$_hi >>> 31) | 0);
  var lo$11 = ((lo$9 + lo$10) | 0);
  var x_$_lo = _nanoOfDay_$_lo;
  var x_$_hi = _nanoOfDay_$_hi;
  var hi$14 = (lo$11 >> 31);
  var b0$4 = (65535 & lo$11);
  var b1$4 = ((lo$11 >>> 16) | 0);
  var a0b0$4 = Math.imul(40960, b0$4);
  var a1b0$4 = Math.imul(12472, b0$4);
  var a0b1$4 = Math.imul(40960, b1$4);
  var lo$12 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$15 = ((((((((Math.imul(817405952, hi$14) + Math.imul(838, lo$11)) | 0) + Math.imul(12472, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var lo$13 = ((x_$_lo - lo$12) | 0);
  var hi$16 = ((((x_$_hi - hi$15) | 0) + ((((~x_$_lo) & lo$12) | ((~(x_$_lo ^ lo$12)) & lo$13)) >> 31)) | 0);
  _nanoOfDay_$_lo = lo$13;
  _nanoOfDay_$_hi = hi$16;
  var num$1_$_lo = _nanoOfDay_$_lo;
  var num$1_$_hi = _nanoOfDay_$_hi;
  var hi$17 = (num$1_$_hi >> 31);
  var b0$5 = (65535 & num$1_$_lo);
  var b1$5 = ((num$1_$_lo >>> 16) | 0);
  var a0b0$5 = Math.imul(13310, b0$5);
  var a1b0$5 = Math.imul(293, b0$5);
  var a0b1$5 = Math.imul(13310, b1$5);
  var lo$14 = ((a0b0$5 + (((a1b0$5 + a0b1$5) | 0) << 16)) | 0);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$18 = ((((Math.imul(293, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var b0$6 = (65535 & num$1_$_lo);
  var b1$6 = ((num$1_$_lo >>> 16) | 0);
  var a0b0$6 = Math.imul(15645, b0$6);
  var a1b0$6 = Math.imul(26877, b0$6);
  var a0b1$6 = Math.imul(15645, b1$6);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$19 = ((((Math.imul(26877, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var lo$16 = ((lo$14 + hi$19) | 0);
  var hi$20 = ((hi$18 + ((((lo$14 & hi$19) | ((lo$14 | hi$19) & (~lo$16))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & num$1_$_hi);
  var b1$7 = ((num$1_$_hi >>> 16) | 0);
  var a0b0$7 = Math.imul(13310, b0$7);
  var a1b0$7 = Math.imul(293, b0$7);
  var a0b1$7 = Math.imul(13310, b1$7);
  var lo$17 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$21 = ((((((Math.imul(19215358, hi$17) + Math.imul(293, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var hi$22 = (hi$20 >> 31);
  var lo$18 = ((lo$17 + hi$20) | 0);
  var hi$23 = ((((hi$21 + hi$22) | 0) + ((((lo$17 & hi$20) | ((lo$17 | hi$20) & (~lo$18))) >>> 31) | 0)) | 0);
  var b0$8 = (65535 & num$1_$_hi);
  var b1$8 = ((num$1_$_hi >>> 16) | 0);
  var a0b0$8 = Math.imul(15645, b0$8);
  var a1b0$8 = Math.imul(26877, b0$8);
  var a0b1$8 = Math.imul(15645, b1$8);
  var lo$19 = ((a0b0$8 + (((a1b0$8 + a0b1$8) | 0) << 16)) | 0);
  var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
  var hi$24 = ((((((Math.imul(1761426717, hi$17) + Math.imul(26877, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$8) | 0) >>> 16) | 0)) | 0);
  var lo$20 = ((lo$16 + lo$19) | 0);
  var hi$25 = ((hi$24 + ((((lo$16 & lo$19) | ((lo$16 | lo$19) & (~lo$20))) >>> 31) | 0)) | 0);
  var hi$26 = (hi$25 >> 31);
  var lo$21 = ((lo$18 + hi$25) | 0);
  var hi$27 = ((((hi$23 + hi$26) | 0) + ((((lo$18 & hi$25) | ((lo$18 | hi$25) & (~lo$21))) >>> 31) | 0)) | 0);
  var lo$22 = (((lo$21 >>> 28) | 0) | (hi$27 << 4));
  var lo$23 = ((num$1_$_hi >>> 31) | 0);
  var lo$24 = ((lo$22 + lo$23) | 0);
  var x$1_$_lo = _nanoOfDay_$_lo;
  var x$1_$_hi = _nanoOfDay_$_hi;
  var hi$30 = (lo$24 >> 31);
  var b0$9 = (65535 & lo$24);
  var b1$9 = ((lo$24 >>> 16) | 0);
  var a0b0$9 = Math.imul(22528, b0$9);
  var a1b0$9 = Math.imul(63559, b0$9);
  var a0b1$9 = Math.imul(22528, b1$9);
  var lo$25 = ((a0b0$9 + (((a1b0$9 + a0b1$9) | 0) << 16)) | 0);
  var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
  var hi$31 = ((((((((Math.imul((-129542144), hi$30) + Math.imul(13, lo$24)) | 0) + Math.imul(63559, b1$9)) | 0) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$9) | 0) >>> 16) | 0)) | 0);
  var lo$26 = ((x$1_$_lo - lo$25) | 0);
  var hi$32 = ((((x$1_$_hi - hi$31) | 0) + ((((~x$1_$_lo) & lo$25) | ((~(x$1_$_lo ^ lo$25)) & lo$26)) >> 31)) | 0);
  _nanoOfDay_$_lo = lo$26;
  _nanoOfDay_$_hi = hi$32;
  var num$2_$_lo = _nanoOfDay_$_lo;
  var num$2_$_hi = _nanoOfDay_$_hi;
  var hi$33 = (num$2_$_hi >> 31);
  var b0$10 = (65535 & num$2_$_lo);
  var b1$10 = ((num$2_$_lo >>> 16) | 0);
  var a0b0$10 = Math.imul(3048, b0$10);
  var a1b0$10 = Math.imul(4398, b0$10);
  var a0b1$10 = Math.imul(3048, b1$10);
  var lo$27 = ((a0b0$10 + (((a1b0$10 + a0b1$10) | 0) << 16)) | 0);
  var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
  var hi$34 = ((((Math.imul(4398, b1$10) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$10) | 0) >>> 16) | 0)) | 0);
  var b0$11 = (65535 & num$2_$_lo);
  var b1$11 = ((num$2_$_lo >>> 16) | 0);
  var a0b0$11 = Math.imul(38067, b0$11);
  var a1b0$11 = Math.imul(9942, b0$11);
  var a0b1$11 = Math.imul(38067, b1$11);
  var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
  var hi$35 = ((((Math.imul(9942, b1$11) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$11) | 0) >>> 16) | 0)) | 0);
  var lo$29 = ((lo$27 + hi$35) | 0);
  var hi$36 = ((hi$34 + ((((lo$27 & hi$35) | ((lo$27 | hi$35) & (~lo$29))) >>> 31) | 0)) | 0);
  var b0$12 = (65535 & num$2_$_hi);
  var b1$12 = ((num$2_$_hi >>> 16) | 0);
  var a0b0$12 = Math.imul(3048, b0$12);
  var a1b0$12 = Math.imul(4398, b0$12);
  var a0b1$12 = Math.imul(3048, b1$12);
  var lo$30 = ((a0b0$12 + (((a1b0$12 + a0b1$12) | 0) << 16)) | 0);
  var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
  var hi$37 = ((((((Math.imul(288230376, hi$33) + Math.imul(4398, b1$12)) | 0) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$12) | 0) >>> 16) | 0)) | 0);
  var hi$38 = (hi$36 >> 31);
  var lo$31 = ((lo$30 + hi$36) | 0);
  var hi$39 = ((((hi$37 + hi$38) | 0) + ((((lo$30 & hi$36) | ((lo$30 | hi$36) & (~lo$31))) >>> 31) | 0)) | 0);
  var b0$13 = (65535 & num$2_$_hi);
  var b1$13 = ((num$2_$_hi >>> 16) | 0);
  var a0b0$13 = Math.imul(38067, b0$13);
  var a1b0$13 = Math.imul(9942, b0$13);
  var a0b1$13 = Math.imul(38067, b1$13);
  var lo$32 = ((a0b0$13 + (((a1b0$13 + a0b1$13) | 0) << 16)) | 0);
  var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
  var hi$40 = ((((((Math.imul(651596979, hi$33) + Math.imul(9942, b1$13)) | 0) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$13) | 0) >>> 16) | 0)) | 0);
  var lo$33 = ((lo$29 + lo$32) | 0);
  var hi$41 = ((hi$40 + ((((lo$29 & lo$32) | ((lo$29 | lo$32) & (~lo$33))) >>> 31) | 0)) | 0);
  var hi$42 = (hi$41 >> 31);
  var lo$34 = ((lo$31 + hi$41) | 0);
  var hi$43 = ((((hi$39 + hi$42) | 0) + ((((lo$31 & hi$41) | ((lo$31 | hi$41) & (~lo$34))) >>> 31) | 0)) | 0);
  var lo$35 = (((lo$34 >>> 26) | 0) | (hi$43 << 6));
  var lo$36 = ((num$2_$_hi >>> 31) | 0);
  var lo$37 = ((lo$35 + lo$36) | 0);
  var x$2_$_lo = _nanoOfDay_$_lo;
  var x$2_$_hi = _nanoOfDay_$_hi;
  var hi$46 = (lo$37 >> 31);
  var b0$14 = (65535 & lo$37);
  var b1$14 = ((lo$37 >>> 16) | 0);
  var a0b0$14 = Math.imul(51712, b0$14);
  var a1b0$14 = Math.imul(15258, b0$14);
  var a0b1$14 = Math.imul(51712, b1$14);
  var lo$38 = ((a0b0$14 + (((a1b0$14 + a0b1$14) | 0) << 16)) | 0);
  var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
  var hi$47 = ((((((Math.imul(1000000000, hi$46) + Math.imul(15258, b1$14)) | 0) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$14) | 0) >>> 16) | 0)) | 0);
  var lo$39 = ((x$2_$_lo - lo$38) | 0);
  var hi$48 = ((((x$2_$_hi - hi$47) | 0) + ((((~x$2_$_lo) & lo$38) | ((~(x$2_$_lo ^ lo$38)) & lo$39)) >> 31)) | 0);
  _nanoOfDay_$_lo = lo$39;
  _nanoOfDay_$_hi = hi$48;
  var x$3_$_lo = _nanoOfDay_$_lo;
  var x$3_$_hi = _nanoOfDay_$_hi;
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$11, lo$24, lo$37, x$3_$_lo);
});
$c_Ljava_time_LocalTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime = (function(temporal) {
  var time = $as_Ljava_time_LocalTime($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery()));
  if ((time === null)) {
    var this$1 = $n(temporal);
    var this$2 = $objectGetClass(this$1);
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalTime from TemporalAccessor: " + temporal) + ", type ") + this$2.data.name));
  } else {
    return time;
  }
});
$c_Ljava_time_LocalTime$.prototype.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second, nanoOfSecond) {
  return ((((minute | second) | nanoOfSecond) === 0) ? $n($p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this)).get(hour) : new $c_Ljava_time_LocalTime(hour, minute, second, nanoOfSecond));
});
var $d_Ljava_time_LocalTime$ = new $TypeData().initClass($c_Ljava_time_LocalTime$, "java.time.LocalTime$", ({
  Ljava_time_LocalTime$: 1
}));
var $n_Ljava_time_LocalTime$;
function $m_Ljava_time_LocalTime$() {
  if ((!$n_Ljava_time_LocalTime$)) {
    $n_Ljava_time_LocalTime$ = new $c_Ljava_time_LocalTime$();
  }
  return $n_Ljava_time_LocalTime$;
}
/** @constructor */
function $c_Ljava_time_OffsetDateTime$() {
}
$c_Ljava_time_OffsetDateTime$.prototype = new $h_O();
$c_Ljava_time_OffsetDateTime$.prototype.constructor = $c_Ljava_time_OffsetDateTime$;
/** @constructor */
function $h_Ljava_time_OffsetDateTime$() {
}
$h_Ljava_time_OffsetDateTime$.prototype = $c_Ljava_time_OffsetDateTime$.prototype;
$c_Ljava_time_OffsetDateTime$.prototype.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime = (function(instant, zone) {
  $n(instant);
  $n(zone);
  var this$1 = $n(zone);
  var rules = $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$1);
  var this$2 = $n(rules);
  var offset = this$2.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  var $x_2 = $m_Ljava_time_LocalDateTime$();
  var this$3 = $n(instant);
  var $x_1_$_lo = this$3.Ljava_time_Instant__f_seconds_$lo;
  var $x_1_$_hi = this$3.Ljava_time_Instant__f_seconds_$hi;
  var this$4 = $n(instant);
  var ldt = $x_2.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime($x_1_$_lo, $x_1_$_hi, this$4.Ljava_time_Instant__f_nanos, offset);
  return new $c_Ljava_time_OffsetDateTime(ldt, offset);
});
$c_Ljava_time_OffsetDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_OffsetDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_OffsetDateTime)) {
    var time = $as_Ljava_time_OffsetDateTime(temporal);
    return time;
  } else {
    try {
      var offset = $m_Ljava_time_ZoneOffset$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset(temporal);
      try {
        var ldt = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal);
        return new $c_Ljava_time_OffsetDateTime(ldt, offset);
      } catch (e) {
        if ((e instanceof $c_Ljava_time_DateTimeException)) {
          var instant = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(temporal);
          return $m_Ljava_time_OffsetDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime(instant, offset);
        } else {
          throw e;
        }
      }
    } catch (e$2) {
      if ((e$2 instanceof $c_Ljava_time_DateTimeException)) {
        var this$2 = $n(temporal);
        var this$3 = $objectGetClass(this$2);
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain OffsetDateTime from TemporalAccessor: " + temporal) + ", type ") + this$3.data.name));
      } else {
        throw e$2;
      }
    }
  }
});
var $d_Ljava_time_OffsetDateTime$ = new $TypeData().initClass($c_Ljava_time_OffsetDateTime$, "java.time.OffsetDateTime$", ({
  Ljava_time_OffsetDateTime$: 1
}));
var $n_Ljava_time_OffsetDateTime$;
function $m_Ljava_time_OffsetDateTime$() {
  if ((!$n_Ljava_time_OffsetDateTime$)) {
    $n_Ljava_time_OffsetDateTime$ = new $c_Ljava_time_OffsetDateTime$();
  }
  return $n_Ljava_time_OffsetDateTime$;
}
/** @constructor */
function $c_Ljava_time_Year$() {
  this.Ljava_time_Year$__f_MIN_VALUE$lzy1 = 0;
  this.Ljava_time_Year$__f_MIN_VALUEbitmap$1 = false;
  this.Ljava_time_Year$__f_MAX_VALUE$lzy1 = 0;
  this.Ljava_time_Year$__f_MAX_VALUEbitmap$1 = false;
}
$c_Ljava_time_Year$.prototype = new $h_O();
$c_Ljava_time_Year$.prototype.constructor = $c_Ljava_time_Year$;
/** @constructor */
function $h_Ljava_time_Year$() {
}
$h_Ljava_time_Year$.prototype = $c_Ljava_time_Year$.prototype;
$c_Ljava_time_Year$.prototype.MIN_VALUE__I = (function() {
  if ((!this.Ljava_time_Year$__f_MIN_VALUEbitmap$1)) {
    this.Ljava_time_Year$__f_MIN_VALUE$lzy1 = (-999999999);
    this.Ljava_time_Year$__f_MIN_VALUEbitmap$1 = true;
  }
  return this.Ljava_time_Year$__f_MIN_VALUE$lzy1;
});
$c_Ljava_time_Year$.prototype.MAX_VALUE__I = (function() {
  if ((!this.Ljava_time_Year$__f_MAX_VALUEbitmap$1)) {
    this.Ljava_time_Year$__f_MAX_VALUE$lzy1 = 999999999;
    this.Ljava_time_Year$__f_MAX_VALUEbitmap$1 = true;
  }
  return this.Ljava_time_Year$__f_MAX_VALUE$lzy1;
});
var $d_Ljava_time_Year$ = new $TypeData().initClass($c_Ljava_time_Year$, "java.time.Year$", ({
  Ljava_time_Year$: 1
}));
var $n_Ljava_time_Year$;
function $m_Ljava_time_Year$() {
  if ((!$n_Ljava_time_Year$)) {
    $n_Ljava_time_Year$ = new $c_Ljava_time_Year$();
  }
  return $n_Ljava_time_Year$;
}
/** @constructor */
function $c_Ljava_time_ZoneId$() {
}
$c_Ljava_time_ZoneId$.prototype = new $h_O();
$c_Ljava_time_ZoneId$.prototype.constructor = $c_Ljava_time_ZoneId$;
/** @constructor */
function $h_Ljava_time_ZoneId$() {
}
$h_Ljava_time_ZoneId$.prototype = $c_Ljava_time_ZoneId$.prototype;
$c_Ljava_time_ZoneId$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId = (function(temporal) {
  var obj = $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery()));
  if ((obj === null)) {
    var this$1 = $n(temporal);
    var this$2 = $objectGetClass(this$1);
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZoneId from TemporalAccessor: " + temporal) + ", type ") + this$2.data.name));
  } else {
    return obj;
  }
});
var $d_Ljava_time_ZoneId$ = new $TypeData().initClass($c_Ljava_time_ZoneId$, "java.time.ZoneId$", ({
  Ljava_time_ZoneId$: 1
}));
var $n_Ljava_time_ZoneId$;
function $m_Ljava_time_ZoneId$() {
  if ((!$n_Ljava_time_ZoneId$)) {
    $n_Ljava_time_ZoneId$ = new $c_Ljava_time_ZoneId$();
  }
  return $n_Ljava_time_ZoneId$;
}
function $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHEbitmap$1)) {
    $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHE$lzy1 = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHEbitmap$1 = true;
  }
  return $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHE$lzy1;
}
function $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_ZoneOffset$__f_ID_CACHEbitmap$1)) {
    $thiz.Ljava_time_ZoneOffset$__f_ID_CACHE$lzy1 = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_ZoneOffset$__f_ID_CACHEbitmap$1 = true;
  }
  return $thiz.Ljava_time_ZoneOffset$__f_ID_CACHE$lzy1;
}
/** @constructor */
function $c_Ljava_time_ZoneOffset$() {
  this.Ljava_time_ZoneOffset$__f_SECONDS_CACHE$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_SECONDS_CACHEbitmap$1 = false;
  this.Ljava_time_ZoneOffset$__f_ID_CACHE$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_ID_CACHEbitmap$1 = false;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR = 0;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE = 0;
  this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR = 0;
  this.Ljava_time_ZoneOffset$__f_MAX_SECONDS = 0;
  this.Ljava_time_ZoneOffset$__f_UTC$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_UTCbitmap$1 = false;
  $n_Ljava_time_ZoneOffset$ = this;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR = 3600;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE = 60;
  this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR = 60;
  this.Ljava_time_ZoneOffset$__f_MAX_SECONDS = Math.imul(18, this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR);
}
$c_Ljava_time_ZoneOffset$.prototype = new $h_O();
$c_Ljava_time_ZoneOffset$.prototype.constructor = $c_Ljava_time_ZoneOffset$;
/** @constructor */
function $h_Ljava_time_ZoneOffset$() {
}
$h_Ljava_time_ZoneOffset$.prototype = $c_Ljava_time_ZoneOffset$.prototype;
$c_Ljava_time_ZoneOffset$.prototype.UTC__Ljava_time_ZoneOffset = (function() {
  if ((!this.Ljava_time_ZoneOffset$__f_UTCbitmap$1)) {
    this.Ljava_time_ZoneOffset$__f_UTC$lzy1 = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(0);
    this.Ljava_time_ZoneOffset$__f_UTCbitmap$1 = true;
  }
  return this.Ljava_time_ZoneOffset$__f_UTC$lzy1;
});
$c_Ljava_time_ZoneOffset$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset = (function(temporal) {
  var offset = $as_Ljava_time_ZoneOffset($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()));
  if ((offset === null)) {
    var this$1 = $n(temporal);
    var this$2 = $objectGetClass(this$1);
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZoneOffset from TemporalAccessor: " + temporal) + ", type ") + this$2.data.name));
  }
  return offset;
});
$c_Ljava_time_ZoneOffset$.prototype.ofTotalSeconds__I__Ljava_time_ZoneOffset = (function(totalSeconds) {
  var sign = (totalSeconds >> 31);
  if (((((totalSeconds ^ sign) - sign) | 0) > this.Ljava_time_ZoneOffset$__f_MAX_SECONDS)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset not in valid range: -18:00 to +18:00");
  } else if ((((totalSeconds % $checkIntDivisor(Math.imul(15, this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE))) | 0) === 0)) {
    var result = $as_Ljava_time_ZoneOffset($n($p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this)).get__O__O(totalSeconds));
    if ((result === null)) {
      result = new $c_Ljava_time_ZoneOffset(totalSeconds);
      $n($p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this)).put__O__O__O(totalSeconds, result);
      result = $as_Ljava_time_ZoneOffset($n($p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this)).get__O__O(totalSeconds));
      $n($p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map(this)).put__O__O__O($n(result).Ljava_time_ZoneOffset__f_id, result);
    }
    return result;
  } else {
    return new $c_Ljava_time_ZoneOffset(totalSeconds);
  }
});
$c_Ljava_time_ZoneOffset$.prototype.java$time$ZoneOffset$$$buildId__I__T = (function(totalSeconds) {
  if ((totalSeconds === 0)) {
    return "Z";
  } else {
    var sign = (totalSeconds >> 31);
    var absTotalSeconds = (((totalSeconds ^ sign) - sign) | 0);
    var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
    var absHours = ((absTotalSeconds / $checkIntDivisor(this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR)) | 0);
    var absMinutes = ((((absTotalSeconds / $checkIntDivisor(this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE)) | 0) % $checkIntDivisor(this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR)) | 0);
    $n($n($n($n(buf.append__T__scm_StringBuilder(((totalSeconds < 0) ? "-" : "+"))).append__T__scm_StringBuilder(((absHours < 10) ? "0" : ""))).append__I__scm_StringBuilder(absHours)).append__T__scm_StringBuilder(((absMinutes < 10) ? ":0" : ":"))).append__I__scm_StringBuilder(absMinutes);
    var absSeconds = ((absTotalSeconds % $checkIntDivisor(this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE)) | 0);
    if ((absSeconds !== 0)) {
      $n(buf.append__T__scm_StringBuilder(((absSeconds < 10) ? ":0" : ":"))).append__I__scm_StringBuilder(absSeconds);
    }
    return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
var $d_Ljava_time_ZoneOffset$ = new $TypeData().initClass($c_Ljava_time_ZoneOffset$, "java.time.ZoneOffset$", ({
  Ljava_time_ZoneOffset$: 1
}));
var $n_Ljava_time_ZoneOffset$;
function $m_Ljava_time_ZoneOffset$() {
  if ((!$n_Ljava_time_ZoneOffset$)) {
    $n_Ljava_time_ZoneOffset$ = new $c_Ljava_time_ZoneOffset$();
  }
  return $n_Ljava_time_ZoneOffset$;
}
/** @constructor */
function $c_Ljava_time_ZonedDateTime$() {
}
$c_Ljava_time_ZonedDateTime$.prototype = new $h_O();
$c_Ljava_time_ZonedDateTime$.prototype.constructor = $c_Ljava_time_ZonedDateTime$;
/** @constructor */
function $h_Ljava_time_ZonedDateTime$() {
}
$h_Ljava_time_ZonedDateTime$.prototype = $c_Ljava_time_ZonedDateTime$.prototype;
$c_Ljava_time_ZonedDateTime$.prototype.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime = (function(localDateTime, zone, preferredOffset) {
  $n(localDateTime);
  $n(zone);
  var _localDateTime = localDateTime;
  if ((zone instanceof $c_Ljava_time_ZoneOffset)) {
    var offset = $as_Ljava_time_ZoneOffset(zone);
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, offset, zone);
  } else {
    var this$1 = $n(zone);
    var rules = $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$1);
    var this$2 = $n(rules);
    var o = this$2.Ljava_time_zone_ZoneRules$Fixed__f_offset;
    var validOffsets = $m_ju_Collections$().singletonList__O__ju_List(o);
    var offset$2 = null;
    if (($n(validOffsets).size__I() === 1)) {
      offset$2 = $as_Ljava_time_ZoneOffset($n(validOffsets).get__I__O(0));
    } else if (($n(validOffsets).size__I() === 0)) {
      $n(rules);
      var trans = null;
      $n(_localDateTime);
      $n(trans);
      $n(trans);
    } else if (((preferredOffset !== null) && $n(validOffsets).contains__O__Z(preferredOffset))) {
      offset$2 = preferredOffset;
    } else {
      var obj = $n(validOffsets).get__I__O(0);
      offset$2 = $as_Ljava_time_ZoneOffset($n(obj));
    }
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, offset$2, zone);
  }
});
$c_Ljava_time_ZonedDateTime$.prototype.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(instant, zone) {
  $n(instant);
  $n(zone);
  var this$1 = $n(instant);
  var $x_1_$_lo = this$1.Ljava_time_Instant__f_seconds_$lo;
  var $x_1_$_hi = this$1.Ljava_time_Instant__f_seconds_$hi;
  var this$2 = $n(instant);
  return this.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($x_1_$_lo, $x_1_$_hi, this$2.Ljava_time_Instant__f_nanos, zone);
});
$c_Ljava_time_ZonedDateTime$.prototype.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(epochSecond_$_lo, epochSecond_$_hi, nanoOfSecond, zone) {
  var this$1 = $n(zone);
  var rules = $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$1);
  var $x_1 = $m_Ljava_time_Instant$();
  var hi = (nanoOfSecond >> 31);
  $x_1.ofEpochSecond__J__J__Ljava_time_Instant(epochSecond_$_lo, epochSecond_$_hi, nanoOfSecond, hi);
  var this$3 = $n(rules);
  var offset = this$3.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return new $c_Ljava_time_ZonedDateTime($m_Ljava_time_LocalDateTime$().ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(epochSecond_$_lo, epochSecond_$_hi, nanoOfSecond, offset), offset, zone);
});
$c_Ljava_time_ZonedDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZonedDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_ZonedDateTime)) {
    var time = $as_Ljava_time_ZonedDateTime(temporal);
    return time;
  } else {
    try {
      var zone = $m_Ljava_time_ZoneId$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId(temporal);
      if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
        try {
          var $x_1 = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
          var epochSecond_$_lo = $x_1.l;
          var epochSecond_$_hi = $x_1.h;
          var nanoOfSecond = $n(temporal).get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
          return this.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(epochSecond_$_lo, epochSecond_$_hi, nanoOfSecond, zone);
        } catch (e) {
          if ((!(e instanceof $c_Ljava_time_DateTimeException))) {
            throw e;
          }
        }
      }
      var ldt = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal);
      return this.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(ldt, zone, null);
    } catch (e$2) {
      if ((e$2 instanceof $c_Ljava_time_DateTimeException)) {
        var this$1 = $n(temporal);
        var this$2 = $objectGetClass(this$1);
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZonedDateTime from TemporalAccessor: " + temporal) + ", type ") + this$2.data.name));
      } else {
        throw e$2;
      }
    }
  }
});
var $d_Ljava_time_ZonedDateTime$ = new $TypeData().initClass($c_Ljava_time_ZonedDateTime$, "java.time.ZonedDateTime$", ({
  Ljava_time_ZonedDateTime$: 1
}));
var $n_Ljava_time_ZonedDateTime$;
function $m_Ljava_time_ZonedDateTime$() {
  if ((!$n_Ljava_time_ZonedDateTime$)) {
    $n_Ljava_time_ZonedDateTime$ = new $c_Ljava_time_ZonedDateTime$();
  }
  return $n_Ljava_time_ZonedDateTime$;
}
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology$() {
  this.Ljava_time_chrono_IsoChronology$__f_INSTANCE$lzy1 = null;
  this.Ljava_time_chrono_IsoChronology$__f_INSTANCEbitmap$1 = false;
}
$c_Ljava_time_chrono_IsoChronology$.prototype = new $h_O();
$c_Ljava_time_chrono_IsoChronology$.prototype.constructor = $c_Ljava_time_chrono_IsoChronology$;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology$() {
}
$h_Ljava_time_chrono_IsoChronology$.prototype = $c_Ljava_time_chrono_IsoChronology$.prototype;
$c_Ljava_time_chrono_IsoChronology$.prototype.INSTANCE__Ljava_time_chrono_IsoChronology = (function() {
  if ((!this.Ljava_time_chrono_IsoChronology$__f_INSTANCEbitmap$1)) {
    this.Ljava_time_chrono_IsoChronology$__f_INSTANCE$lzy1 = new $c_Ljava_time_chrono_IsoChronology();
    this.Ljava_time_chrono_IsoChronology$__f_INSTANCEbitmap$1 = true;
  }
  return this.Ljava_time_chrono_IsoChronology$__f_INSTANCE$lzy1;
});
var $d_Ljava_time_chrono_IsoChronology$ = new $TypeData().initClass($c_Ljava_time_chrono_IsoChronology$, "java.time.chrono.IsoChronology$", ({
  Ljava_time_chrono_IsoChronology$: 1
}));
var $n_Ljava_time_chrono_IsoChronology$;
function $m_Ljava_time_chrono_IsoChronology$() {
  if ((!$n_Ljava_time_chrono_IsoChronology$)) {
    $n_Ljava_time_chrono_IsoChronology$ = new $c_Ljava_time_chrono_IsoChronology$();
  }
  return $n_Ljava_time_chrono_IsoChronology$;
}
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter(printerParser, locale, decimalStyle, resolverStyle, resolverFields, chrono, zone) {
  this.Ljava_time_format_DateTimeFormatter__f_printerParser = null;
  this.Ljava_time_format_DateTimeFormatter__f_locale = null;
  this.Ljava_time_format_DateTimeFormatter__f_decimalStyle = null;
  this.Ljava_time_format_DateTimeFormatter__f_resolverStyle = null;
  this.Ljava_time_format_DateTimeFormatter__f_resolverFields = null;
  this.Ljava_time_format_DateTimeFormatter__f_chrono = null;
  this.Ljava_time_format_DateTimeFormatter__f_zone = null;
  this.Ljava_time_format_DateTimeFormatter__f_printerParser = printerParser;
  this.Ljava_time_format_DateTimeFormatter__f_locale = locale;
  this.Ljava_time_format_DateTimeFormatter__f_decimalStyle = decimalStyle;
  this.Ljava_time_format_DateTimeFormatter__f_resolverStyle = resolverStyle;
  this.Ljava_time_format_DateTimeFormatter__f_resolverFields = resolverFields;
  this.Ljava_time_format_DateTimeFormatter__f_chrono = chrono;
  this.Ljava_time_format_DateTimeFormatter__f_zone = zone;
  $n(printerParser);
  $n(locale);
  $n(decimalStyle);
  $n(resolverStyle);
}
$c_Ljava_time_format_DateTimeFormatter.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatter.prototype.constructor = $c_Ljava_time_format_DateTimeFormatter;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter() {
}
$h_Ljava_time_format_DateTimeFormatter.prototype = $c_Ljava_time_format_DateTimeFormatter.prototype;
$c_Ljava_time_format_DateTimeFormatter.prototype.withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter = (function(resolverStyle) {
  $n(resolverStyle);
  var a = this.Ljava_time_format_DateTimeFormatter__f_resolverStyle;
  if ((a === null)) {
    var $x_1 = (resolverStyle === null);
  } else {
    var this$2 = $n(a);
    var $x_1 = (this$2 === resolverStyle);
  }
  if ($x_1) {
    return this;
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.Ljava_time_format_DateTimeFormatter__f_printerParser, this.Ljava_time_format_DateTimeFormatter__f_locale, this.Ljava_time_format_DateTimeFormatter__f_decimalStyle, resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields, this.Ljava_time_format_DateTimeFormatter__f_chrono, this.Ljava_time_format_DateTimeFormatter__f_zone);
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.format__Ljava_time_temporal_TemporalAccessor__T = (function(temporal) {
  var buf = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
  this.formatTo__Ljava_time_temporal_TemporalAccessor__jl_Appendable__V(temporal, buf);
  return buf.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljava_time_format_DateTimeFormatter.prototype.formatTo__Ljava_time_temporal_TemporalAccessor__jl_Appendable__V = (function(temporal, appendable) {
  $n(temporal);
  $n(appendable);
  try {
    var context = $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__(new $c_Ljava_time_format_internal_TTBPDateTimePrintContext(), temporal, this);
    if ((appendable instanceof $c_jl_StringBuilder)) {
      $n(this.Ljava_time_format_DateTimeFormatter__f_printerParser).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, $as_jl_StringBuilder(appendable));
    } else {
      var buf = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
      $n(this.Ljava_time_format_DateTimeFormatter__f_printerParser).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf);
      $n(appendable).append__jl_CharSequence__jl_Appendable(buf);
    }
  } catch (e) {
    if (false) {
      var ex = $as_Ljava_io_IOException(e);
      throw $ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $c_Ljava_time_DateTimeException(), $n(ex).getMessage__T(), ex);
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.toString__T = (function() {
  var pattern = $n(this.Ljava_time_format_DateTimeFormatter__f_printerParser).toString__T();
  var this$1 = $n(pattern);
  if ($uZ(this$1.startsWith("["))) {
    return pattern;
  } else {
    var this$3 = $n(pattern);
    var this$2 = $n(pattern);
    var endIndex = ((this$2.length - 1) | 0);
    if ((endIndex > this$3.length)) {
      $charAt(this$3, endIndex);
    }
    if ((endIndex < 1)) {
      $charAt(this$3, (-1));
    }
    return $as_T(this$3.substring(1, endIndex));
  }
});
var $d_Ljava_time_format_DateTimeFormatter = new $TypeData().initClass($c_Ljava_time_format_DateTimeFormatter, "java.time.format.DateTimeFormatter", ({
  Ljava_time_format_DateTimeFormatter: 1
}));
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter$() {
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANTbitmap$1 = false;
}
$c_Ljava_time_format_DateTimeFormatter$.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatter$.prototype.constructor = $c_Ljava_time_format_DateTimeFormatter$;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter$() {
}
$h_Ljava_time_format_DateTimeFormatter$.prototype = $c_Ljava_time_format_DateTimeFormatter$.prototype;
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_INSTANT__Ljava_time_format_DateTimeFormatter = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANTbitmap$1)) {
    var this$1 = $n($n($ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder()).appendInstant__Ljava_time_format_DateTimeFormatterBuilder());
    var style = $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT$lzy1 = $n(this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale)).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style);
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANTbitmap$1 = true;
  }
  return this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT$lzy1;
});
var $d_Ljava_time_format_DateTimeFormatter$ = new $TypeData().initClass($c_Ljava_time_format_DateTimeFormatter$, "java.time.format.DateTimeFormatter$", ({
  Ljava_time_format_DateTimeFormatter$: 1
}));
var $n_Ljava_time_format_DateTimeFormatter$;
function $m_Ljava_time_format_DateTimeFormatter$() {
  if ((!$n_Ljava_time_format_DateTimeFormatter$)) {
    $n_Ljava_time_format_DateTimeFormatter$ = new $c_Ljava_time_format_DateTimeFormatter$();
  }
  return $n_Ljava_time_format_DateTimeFormatter$;
}
function $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, parent, optional) {
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_parent = parent;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_optional = optional;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active = $thiz;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
  return $thiz;
}
function $ct_Ljava_time_format_DateTimeFormatterBuilder__($thiz) {
  $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, null, false);
  return $thiz;
}
function $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp) {
  var _pp = pp;
  var obj = _pp;
  $n(obj);
  if (($n($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth > 0)) {
    if ((_pp !== null)) {
      _pp = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(_pp, $n($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth, $n($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar);
    }
    $n($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
    $n($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
  }
  $n($n($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers).add__O__Z(_pp);
  $n($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active);
  return (($n($n($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers).size__I() - 1) | 0);
}
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder() {
  this.Ljava_time_format_DateTimeFormatterBuilder__f_parent = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_optional = false;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
}
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder() {
}
$h_Ljava_time_format_DateTimeFormatterBuilder.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser());
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendInstant__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser((-2)));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  if (($n(this.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_parent === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot call optionalEnd() as there was no previous call to optionalStart()");
  }
  if (($n($n(this.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers).size__I() > 0)) {
    var cpp = $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), $n(this.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers, $n(this.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_optional);
    this.Ljava_time_format_DateTimeFormatterBuilder__f_active = $n(this.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_parent;
    $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, cpp);
  } else {
    this.Ljava_time_format_DateTimeFormatterBuilder__f_active = $n(this.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_parent;
  }
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter = (function(locale) {
  $n(locale);
  while (($n(this.Ljava_time_format_DateTimeFormatterBuilder__f_active).Ljava_time_format_DateTimeFormatterBuilder__f_parent !== null)) {
    this.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder();
  }
  var pp = $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers, false);
  return new $c_Ljava_time_format_DateTimeFormatter(pp, locale, $m_Ljava_time_format_DecimalStyle$().STANDARD__Ljava_time_format_DecimalStyle(), $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle(), null, null, null);
});
var $d_Ljava_time_format_DateTimeFormatterBuilder = new $TypeData().initClass($c_Ljava_time_format_DateTimeFormatterBuilder, "java.time.format.DateTimeFormatterBuilder", ({
  Ljava_time_format_DateTimeFormatterBuilder: 1
}));
/** @constructor */
function $c_Ljava_time_format_DecimalStyle(zeroDigit, positiveSign, negativeSign, decimalSeparator) {
  this.Ljava_time_format_DecimalStyle__f_zeroDigit = 0;
  this.Ljava_time_format_DecimalStyle__f_positiveSign = 0;
  this.Ljava_time_format_DecimalStyle__f_negativeSign = 0;
  this.Ljava_time_format_DecimalStyle__f_decimalSeparator = 0;
  this.Ljava_time_format_DecimalStyle__f_zeroDigit = zeroDigit;
  this.Ljava_time_format_DecimalStyle__f_positiveSign = positiveSign;
  this.Ljava_time_format_DecimalStyle__f_negativeSign = negativeSign;
  this.Ljava_time_format_DecimalStyle__f_decimalSeparator = decimalSeparator;
}
$c_Ljava_time_format_DecimalStyle.prototype = new $h_O();
$c_Ljava_time_format_DecimalStyle.prototype.constructor = $c_Ljava_time_format_DecimalStyle;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle() {
}
$h_Ljava_time_format_DecimalStyle.prototype = $c_Ljava_time_format_DecimalStyle.prototype;
$c_Ljava_time_format_DecimalStyle.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_format_DecimalStyle)) {
    var other = $as_Ljava_time_format_DecimalStyle(obj);
    return ((this === other) || ((((this.Ljava_time_format_DecimalStyle__f_zeroDigit === $n(other).Ljava_time_format_DecimalStyle__f_zeroDigit) && (this.Ljava_time_format_DecimalStyle__f_positiveSign === $n(other).Ljava_time_format_DecimalStyle__f_positiveSign)) && (this.Ljava_time_format_DecimalStyle__f_negativeSign === $n(other).Ljava_time_format_DecimalStyle__f_negativeSign)) && (this.Ljava_time_format_DecimalStyle__f_decimalSeparator === $n(other).Ljava_time_format_DecimalStyle__f_decimalSeparator)));
  } else {
    return false;
  }
});
$c_Ljava_time_format_DecimalStyle.prototype.hashCode__I = (function() {
  return ((((((this.Ljava_time_format_DecimalStyle__f_zeroDigit + this.Ljava_time_format_DecimalStyle__f_positiveSign) | 0) + this.Ljava_time_format_DecimalStyle__f_negativeSign) | 0) + this.Ljava_time_format_DecimalStyle__f_decimalSeparator) | 0);
});
$c_Ljava_time_format_DecimalStyle.prototype.toString__T = (function() {
  return ((((("DecimalStyle[" + $cToS(this.Ljava_time_format_DecimalStyle__f_zeroDigit)) + $cToS(this.Ljava_time_format_DecimalStyle__f_positiveSign)) + $cToS(this.Ljava_time_format_DecimalStyle__f_negativeSign)) + $cToS(this.Ljava_time_format_DecimalStyle__f_decimalSeparator)) + "]");
});
function $as_Ljava_time_format_DecimalStyle(obj) {
  return (((obj instanceof $c_Ljava_time_format_DecimalStyle) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.DecimalStyle"));
}
function $isArrayOf_Ljava_time_format_DecimalStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_DecimalStyle)));
}
function $asArrayOf_Ljava_time_format_DecimalStyle(obj, depth) {
  return (($isArrayOf_Ljava_time_format_DecimalStyle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.DecimalStyle;", depth));
}
var $d_Ljava_time_format_DecimalStyle = new $TypeData().initClass($c_Ljava_time_format_DecimalStyle, "java.time.format.DecimalStyle", ({
  Ljava_time_format_DecimalStyle: 1
}));
/** @constructor */
function $c_Ljava_time_format_DecimalStyle$() {
  this.Ljava_time_format_DecimalStyle$__f_STANDARD$lzy1 = null;
  this.Ljava_time_format_DecimalStyle$__f_STANDARDbitmap$1 = false;
}
$c_Ljava_time_format_DecimalStyle$.prototype = new $h_O();
$c_Ljava_time_format_DecimalStyle$.prototype.constructor = $c_Ljava_time_format_DecimalStyle$;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle$() {
}
$h_Ljava_time_format_DecimalStyle$.prototype = $c_Ljava_time_format_DecimalStyle$.prototype;
$c_Ljava_time_format_DecimalStyle$.prototype.STANDARD__Ljava_time_format_DecimalStyle = (function() {
  if ((!this.Ljava_time_format_DecimalStyle$__f_STANDARDbitmap$1)) {
    this.Ljava_time_format_DecimalStyle$__f_STANDARD$lzy1 = new $c_Ljava_time_format_DecimalStyle(48, 43, 45, 46);
    this.Ljava_time_format_DecimalStyle$__f_STANDARDbitmap$1 = true;
  }
  return this.Ljava_time_format_DecimalStyle$__f_STANDARD$lzy1;
});
var $d_Ljava_time_format_DecimalStyle$ = new $TypeData().initClass($c_Ljava_time_format_DecimalStyle$, "java.time.format.DecimalStyle$", ({
  Ljava_time_format_DecimalStyle$: 1
}));
var $n_Ljava_time_format_DecimalStyle$;
function $m_Ljava_time_format_DecimalStyle$() {
  if ((!$n_Ljava_time_format_DecimalStyle$)) {
    $n_Ljava_time_format_DecimalStyle$ = new $c_Ljava_time_format_DecimalStyle$();
  }
  return $n_Ljava_time_format_DecimalStyle$;
}
function $is_Ljava_time_format_internal_DateTimePrinterParser(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_format_internal_DateTimePrinterParser)));
}
function $as_Ljava_time_format_internal_DateTimePrinterParser(obj) {
  return (($is_Ljava_time_format_internal_DateTimePrinterParser(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.format.internal.DateTimePrinterParser"));
}
function $isArrayOf_Ljava_time_format_internal_DateTimePrinterParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_DateTimePrinterParser)));
}
function $asArrayOf_Ljava_time_format_internal_DateTimePrinterParser(obj, depth) {
  return (($isArrayOf_Ljava_time_format_internal_DateTimePrinterParser(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.format.internal.DateTimePrinterParser;", depth));
}
var $d_Ljava_time_format_internal_DateTimePrinterParser = new $TypeData().initClass(1, "java.time.format.internal.DateTimePrinterParser", ({
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970 = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS = $bL(2036907392, 73);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970 = $bL(2037677056, 14);
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser$", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$: 1
}));
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
}
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, temporal, locale, symbols) {
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal = temporal;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = 0;
  return $thiz;
}
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__($thiz, temporal, formatter) {
  var $x_2 = $m_Ljava_time_format_internal_TTBPDateTimePrintContext$().adjust__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__Ljava_time_temporal_TemporalAccessor(temporal, formatter);
  var this$1 = $n(formatter);
  var $x_1 = this$1.Ljava_time_format_DateTimeFormatter__f_locale;
  var this$2 = $n(formatter);
  $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, $x_2, $x_1, this$2.Ljava_time_format_DateTimeFormatter__f_decimalStyle);
  return $thiz;
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = 0;
}
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext() {
}
$h_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.startOptional__V = (function() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = ((1 + this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional) | 0);
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.endOptional__V = (function() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = ((this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional - 1) | 0);
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.getValue__Ljava_time_temporal_TemporalField__jl_Long = (function(field) {
  try {
    var $x_1 = $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal).getLong__Ljava_time_temporal_TemporalField__J(field);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    return $bL(x_$_lo, x_$_hi);
  } catch (e) {
    if ((e instanceof $c_Ljava_time_DateTimeException)) {
      var ex = $as_Ljava_time_DateTimeException(e);
      if ((this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional > 0)) {
        return null;
      } else {
        throw $n(ex);
      }
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.toString__T = (function() {
  return $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal).toString__T();
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimePrintContext, "java.time.format.internal.TTBPDateTimePrintContext", ({
  Ljava_time_format_internal_TTBPDateTimePrintContext: 1
}));
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
}
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
}
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.adjust__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__Ljava_time_temporal_TemporalAccessor = (function(temporal, formatter) {
  var this$1 = $n(formatter);
  var elem = this$1.Ljava_time_format_DateTimeFormatter__f_chrono;
  var overrideChrono = new $c_sr_ObjectRef(elem);
  var this$3 = $n(formatter);
  var overrideZone = this$3.Ljava_time_format_DateTimeFormatter__f_zone;
  if ((($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) === null) && (overrideZone === null))) {
    return temporal;
  } else {
    var temporalChrono = $as_Ljava_time_chrono_Chronology($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()));
    var temporalZone = $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()));
    var b = $as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem);
    if ((temporalChrono === null)) {
      var $x_1 = (b === null);
    } else {
      var this$5 = $n(temporalChrono);
      var $x_1 = $f_Ljava_time_chrono_Chronology__equals__O__Z(this$5, b);
    }
    if ($x_1) {
      var ev$2 = null;
      overrideChrono.sr_ObjectRef__f_elem = ev$2;
    }
    var b$1 = overrideZone;
    if (((temporalZone === null) ? (b$1 === null) : $n(temporalZone).equals__O__Z(b$1))) {
      overrideZone = null;
    }
    if ((($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) === null) && (overrideZone === null))) {
      return temporal;
    }
    var effectiveChrono = (($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) !== null) ? $as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) : temporalChrono);
    var effectiveZone = ((overrideZone !== null) ? overrideZone : temporalZone);
    if ((overrideZone !== null)) {
      if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
        var chrono = ((effectiveChrono !== null) ? effectiveChrono : $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
        $n(chrono);
        var instant = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(temporal);
        var zone = overrideZone;
        return $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(instant, zone);
      }
      var normalizedOffset = $n(overrideZone).normalized__Ljava_time_ZoneId();
      var temporalOffset = $as_Ljava_time_ZoneOffset($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()));
      if ((((normalizedOffset instanceof $c_Ljava_time_ZoneOffset) && (temporalOffset !== null)) && (!((normalizedOffset === null) ? (temporalOffset === null) : $n(normalizedOffset).equals__O__Z(temporalOffset))))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid override zone for temporal: " + overrideZone) + " ") + temporal));
      }
    }
    if (($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) !== null)) {
      if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
        $n(effectiveChrono);
        var effectiveDate = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
      } else {
        if ((!(($as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem) === $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()) && (temporalChrono === null)))) {
          var xs = $m_Ljava_time_temporal_ChronoField$().values__ALjava_time_temporal_ChronoField();
          var f$2 = ((f) => {
            var f$1 = $as_Ljava_time_temporal_ChronoField(f);
            if (($n(f$1).isDateBased__Z() && $n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z(f$1))) {
              throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid override chronology for temporal: " + $as_Ljava_time_chrono_Chronology(overrideChrono.sr_ObjectRef__f_elem)) + " ") + temporal));
            }
          });
          var len = $n(xs).u.length;
          var i = 0;
          if ((xs !== null)) {
            while ((i < len)) {
              var x0 = $n(xs).get(i);
              f$2(x0);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_I)) {
            var x3 = $asArrayOf_I(xs, 1);
            while ((i < len)) {
              var x0$1 = $n(x3).get(i);
              f$2(x0$1);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_D)) {
            var x4 = $asArrayOf_D(xs, 1);
            while ((i < len)) {
              var x0$2 = $n(x4).get(i);
              f$2(x0$2);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_J)) {
            var x5 = $asArrayOf_J(xs, 1);
            while ((i < len)) {
              var $x_2 = $n(x5).u;
              var $x_3 = $aJCheckGet($x_2, i);
              var x0$3_$_lo = $x_2[$x_3];
              var x0$3_$_hi = $x_2[(($x_3 + 1) | 0)];
              f$2($bL(x0$3_$_lo, x0$3_$_hi));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_F)) {
            var x6 = $asArrayOf_F(xs, 1);
            while ((i < len)) {
              var x0$4 = $n(x6).get(i);
              f$2(x0$4);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_C)) {
            var x7 = $asArrayOf_C(xs, 1);
            while ((i < len)) {
              var x0$5 = $n(x7).get(i);
              f$2($bC(x0$5));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_B)) {
            var x8 = $asArrayOf_B(xs, 1);
            while ((i < len)) {
              var x0$6 = $n(x8).get(i);
              f$2(x0$6);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_S)) {
            var x9 = $asArrayOf_S(xs, 1);
            while ((i < len)) {
              var x0$7 = $n(x9).get(i);
              f$2(x0$7);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_Z)) {
            var x10 = $asArrayOf_Z(xs, 1);
            while ((i < len)) {
              var x0$8 = $n(x10).get(i);
              f$2(x0$8);
              i = ((1 + i) | 0);
            }
          } else {
            throw new $c_s_MatchError(xs);
          }
        }
        var effectiveDate = null;
      }
    } else {
      var effectiveDate = null;
    }
    return new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1(temporal, effectiveChrono, effectiveZone, effectiveDate);
  }
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimePrintContext$, "java.time.format.internal.TTBPDateTimePrintContext$", ({
  Ljava_time_format_internal_TTBPDateTimePrintContext$: 1
}));
var $n_Ljava_time_format_internal_TTBPDateTimePrintContext$;
function $m_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimePrintContext$)) {
    $n_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimePrintContext$;
}
function $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange($thiz, field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ($thiz.isSupported__Ljava_time_temporal_TemporalField__Z(field)) {
      var this$1 = $n(field);
      return this$1.Ljava_time_temporal_ChronoField__f__range;
    } else {
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
    }
  } else {
    var this$2 = $n(field);
    return $thiz.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$2);
  }
}
function $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  var $x_2 = $n($thiz.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field));
  var $x_1 = $thiz.getLong__Ljava_time_temporal_TemporalField__J(field);
  return $x_2.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($x_1.l, $x_1.h, field);
}
function $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  matchAlts1: {
    matchAlts2: {
      var x = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x === null)) {
        var $x_1 = (query === null);
      } else {
        var this$1 = $n(x);
        var $x_1 = (this$1 === query);
      }
      if ($x_1) {
        break matchAlts2;
      }
      var x$3 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
      if ((x$3 === null)) {
        var $x_2 = (query === null);
      } else {
        var this$2 = $n(x$3);
        var $x_2 = (this$2 === query);
      }
      if ($x_2) {
        break matchAlts2;
      }
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === null)) {
        var $x_3 = (query === null);
      } else {
        var this$3 = $n(x$5);
        var $x_3 = (this$3 === query);
      }
      if ($x_3) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O($thiz);
}
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$() {
  this.Ljava_time_temporal_TemporalQueries$__f_zoneId$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_zoneIdbitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_chronology$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_chronologybitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_precision$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_precisionbitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_offset$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_offsetbitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_zone$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_zonebitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_localDate$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_localDatebitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_localTime$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_localTimebitmap$1 = false;
}
$c_Ljava_time_temporal_TemporalQueries$.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$() {
}
$h_Ljava_time_temporal_TemporalQueries$.prototype = $c_Ljava_time_temporal_TemporalQueries$.prototype;
$c_Ljava_time_temporal_TemporalQueries$.prototype.zoneId__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_zoneIdbitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_zoneId$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$1();
    this.Ljava_time_temporal_TemporalQueries$__f_zoneIdbitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_zoneId$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.chronology__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_chronologybitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_chronology$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$2();
    this.Ljava_time_temporal_TemporalQueries$__f_chronologybitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_chronology$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.precision__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_precisionbitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_precision$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$3();
    this.Ljava_time_temporal_TemporalQueries$__f_precisionbitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_precision$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.offset__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_offsetbitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_offset$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$4();
    this.Ljava_time_temporal_TemporalQueries$__f_offsetbitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_offset$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.zone__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_zonebitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_zone$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$5();
    this.Ljava_time_temporal_TemporalQueries$__f_zonebitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_zone$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.localDate__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_localDatebitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_localDate$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$6();
    this.Ljava_time_temporal_TemporalQueries$__f_localDatebitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_localDate$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.localTime__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_localTimebitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_localTime$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$7();
    this.Ljava_time_temporal_TemporalQueries$__f_localTimebitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_localTime$lzy1;
});
var $d_Ljava_time_temporal_TemporalQueries$ = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$, "java.time.temporal.TemporalQueries$", ({
  Ljava_time_temporal_TemporalQueries$: 1
}));
var $n_Ljava_time_temporal_TemporalQueries$;
function $m_Ljava_time_temporal_TemporalQueries$() {
  if ((!$n_Ljava_time_temporal_TemporalQueries$)) {
    $n_Ljava_time_temporal_TemporalQueries$ = new $c_Ljava_time_temporal_TemporalQueries$();
  }
  return $n_Ljava_time_temporal_TemporalQueries$;
}
function $is_Ljava_time_temporal_TemporalUnit(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_temporal_TemporalUnit)));
}
function $as_Ljava_time_temporal_TemporalUnit(obj) {
  return (($is_Ljava_time_temporal_TemporalUnit(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.TemporalUnit"));
}
function $isArrayOf_Ljava_time_temporal_TemporalUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_TemporalUnit)));
}
function $asArrayOf_Ljava_time_temporal_TemporalUnit(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_TemporalUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.TemporalUnit;", depth));
}
/** @constructor */
function $c_Ljava_time_temporal_ValueRange$() {
}
$c_Ljava_time_temporal_ValueRange$.prototype = new $h_O();
$c_Ljava_time_temporal_ValueRange$.prototype.constructor = $c_Ljava_time_temporal_ValueRange$;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange$() {
}
$h_Ljava_time_temporal_ValueRange$.prototype = $c_Ljava_time_temporal_ValueRange$.prototype;
$c_Ljava_time_temporal_ValueRange$.prototype.of__J__J__Ljava_time_temporal_ValueRange = (function(min_$_lo, min_$_hi, max_$_lo, max_$_hi) {
  if (((min_$_hi === max_$_hi) ? ((min_$_lo >>> 0) > (max_$_lo >>> 0)) : (min_$_hi > max_$_hi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value");
  } else {
    return new $c_Ljava_time_temporal_ValueRange(min_$_lo, min_$_hi, min_$_lo, min_$_hi, max_$_lo, max_$_hi, max_$_lo, max_$_hi);
  }
});
$c_Ljava_time_temporal_ValueRange$.prototype.of__J__J__J__J__Ljava_time_temporal_ValueRange = (function(minSmallest_$_lo, minSmallest_$_hi, minLargest_$_lo, minLargest_$_hi, maxSmallest_$_lo, maxSmallest_$_hi, maxLargest_$_lo, maxLargest_$_hi) {
  if (((minSmallest_$_hi === minLargest_$_hi) ? ((minSmallest_$_lo >>> 0) > (minLargest_$_lo >>> 0)) : (minSmallest_$_hi > minLargest_$_hi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Smallest minimum value must be less than largest minimum value");
  }
  if (((maxSmallest_$_hi === maxLargest_$_hi) ? ((maxSmallest_$_lo >>> 0) > (maxLargest_$_lo >>> 0)) : (maxSmallest_$_hi > maxLargest_$_hi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Smallest maximum value must be less than largest maximum value");
  }
  if (((minLargest_$_hi === maxLargest_$_hi) ? ((minLargest_$_lo >>> 0) > (maxLargest_$_lo >>> 0)) : (minLargest_$_hi > maxLargest_$_hi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value");
  }
  return new $c_Ljava_time_temporal_ValueRange(minSmallest_$_lo, minSmallest_$_hi, minLargest_$_lo, minLargest_$_hi, maxSmallest_$_lo, maxSmallest_$_hi, maxLargest_$_lo, maxLargest_$_hi);
});
var $d_Ljava_time_temporal_ValueRange$ = new $TypeData().initClass($c_Ljava_time_temporal_ValueRange$, "java.time.temporal.ValueRange$", ({
  Ljava_time_temporal_ValueRange$: 1
}));
var $n_Ljava_time_temporal_ValueRange$;
function $m_Ljava_time_temporal_ValueRange$() {
  if ((!$n_Ljava_time_temporal_ValueRange$)) {
    $n_Ljava_time_temporal_ValueRange$ = new $c_Ljava_time_temporal_ValueRange$();
  }
  return $n_Ljava_time_temporal_ValueRange$;
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRules() {
}
$c_Ljava_time_zone_ZoneRules.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRules.prototype.constructor = $c_Ljava_time_zone_ZoneRules;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules() {
}
$h_Ljava_time_zone_ZoneRules.prototype = $c_Ljava_time_zone_ZoneRules.prototype;
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$() {
}
$c_Ljava_time_zone_ZoneRules$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRules$.prototype.constructor = $c_Ljava_time_zone_ZoneRules$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$() {
}
$h_Ljava_time_zone_ZoneRules$.prototype = $c_Ljava_time_zone_ZoneRules$.prototype;
$c_Ljava_time_zone_ZoneRules$.prototype.of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules = (function(offset) {
  $n(offset);
  return new $c_Ljava_time_zone_ZoneRules$Fixed(offset);
});
var $d_Ljava_time_zone_ZoneRules$ = new $TypeData().initClass($c_Ljava_time_zone_ZoneRules$, "java.time.zone.ZoneRules$", ({
  Ljava_time_zone_ZoneRules$: 1
}));
var $n_Ljava_time_zone_ZoneRules$;
function $m_Ljava_time_zone_ZoneRules$() {
  if ((!$n_Ljava_time_zone_ZoneRules$)) {
    $n_Ljava_time_zone_ZoneRules$ = new $c_Ljava_time_zone_ZoneRules$();
  }
  return $n_Ljava_time_zone_ZoneRules$;
}
/** @constructor */
function $c_ju_Arrays$() {
}
$c_ju_Arrays$.prototype = new $h_O();
$c_ju_Arrays$.prototype.constructor = $c_ju_Arrays$;
/** @constructor */
function $h_ju_Arrays$() {
}
$h_ju_Arrays$.prototype = $c_ju_Arrays$.prototype;
$c_ju_Arrays$.prototype.sort__AI__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_I(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AI__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = ((toIndex - 1) | 0);
    $n(a).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_I(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AJ__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var end = (($n(a).u.length >>> 1) | 0);
  if ((end > 16)) {
    var length = (($n(a).u.length >>> 1) | 0);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_J(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AJ__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    var $x_1 = $n(a).u;
    var $x_2 = $aJCheckGet($x_1, fromIndex);
  }
  if ((toIndex > 0)) {
    var i = ((toIndex - 1) | 0);
    var $x_3 = $n(a).u;
    var $x_4 = $aJCheckGet($x_3, i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = (($n(a).u.length >>> 1) | 0);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_J(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AS__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_S(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AS__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = ((toIndex - 1) | 0);
    $n(a).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_S(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AC__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_C(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AC__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = ((toIndex - 1) | 0);
    $n(a).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_C(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AB__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var end = $n(a).u.length;
  if ((end > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_B(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AB__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = ((toIndex - 1) | 0);
    $n(a).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(a).u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_B(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AO__ju_Comparator__V = (function(array, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  var end = $n(array).u.length;
  if ((end > 16)) {
    var length = $n(array).u.length;
    var this$2 = $n(array);
    var clazz = $objectGetClass(this$2);
    var componentType = clazz.data.getComponentType();
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, $asArrayOf_O($n(componentType).data.newArray(length), 1), 0, end, comparator$1, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, 0, end, comparator$1, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AO__I__I__ju_Comparator__V = (function(array, fromIndex, toIndex, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(array).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = ((toIndex - 1) | 0);
    $n(array).get(i);
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = $n(array).u.length;
    var this$2 = $n(array);
    var clazz = $objectGetClass(this$2);
    var componentType = clazz.data.getComponentType();
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, $asArrayOf_O($n(componentType).data.newArray(length), 1), fromIndex, toIndex, comparator$1, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, fromIndex, toIndex, comparator$1, ops);
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V = (function(a, temp, start, end, comparator, ops) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + (((length + ((length >>> 31) | 0)) | 0) >> 1)) | 0);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, temp, start, middle, comparator, ops);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, temp, middle, end, comparator, ops);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || ($n(comparator).compare__O__O__I($n(ops).get__O__I__O(a, leftInIndex), $n(ops).get__O__I__O(a, rightInIndex)) <= 0)))) {
        $n(ops).set__O__I__O__V(temp, outIndex, $n(ops).get__O__I__O(a, leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0);
      } else {
        $n(ops).set__O__I__O__V(temp, outIndex, $n(ops).get__O__I__O(a, rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0);
      }
      outIndex = ((1 + outIndex) | 0);
    }
    $systemArraycopyFull($n(temp), start, $n(a), start, length);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, start, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V = (function(a, start, end, comparator, ops) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    var aStart = $n(ops).get__O__I__O(a, start);
    var aStartPlusOne = $n(ops).get__O__I__O(a, ((1 + start) | 0));
    if (($n(comparator).compare__O__O__I(aStart, aStartPlusOne) > 0)) {
      $n(ops).set__O__I__O__V(a, start, aStartPlusOne);
      $n(ops).set__O__I__O__V(a, ((1 + start) | 0), aStart);
    }
    var m = 2;
    while ((m < n)) {
      var next = $n(ops).get__O__I__O(a, ((start + m) | 0));
      if (($n(comparator).compare__O__O__I(next, $n(ops).get__O__I__O(a, ((((start + m) | 0) - 1) | 0))) < 0)) {
        var iA = start;
        var iB = ((((start + m) | 0) - 1) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if (($n(comparator).compare__O__O__I(next, $n(ops).get__O__I__O(a, ix)) < 0)) {
            iB = ix;
          } else {
            iA = ix;
          }
        }
        var ix$2 = ((iA + (($n(comparator).compare__O__O__I(next, $n(ops).get__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          $n(ops).set__O__I__O__V(a, i, $n(ops).get__O__I__O(a, ((i - 1) | 0)));
          i = ((i - 1) | 0);
        }
        $n(ops).set__O__I__O__V(a, ix$2, next);
      }
      m = ((1 + m) | 0);
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AJ__J__I = (function(a, key_$_lo, key_$_hi) {
  var startIndex = 0;
  var endIndex = (($n(a).u.length >>> 1) | 0);
  while (true) {
    if ((startIndex === endIndex)) {
      return (~startIndex);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var $x_1 = $n(a).u;
      var $x_2 = $aJCheckGet($x_1, mid);
      var elem_$_lo = $x_1[$x_2];
      var elem_$_hi = $x_1[(($x_2 + 1) | 0)];
      var cmp = ((key_$_hi === elem_$_hi) ? ((key_$_lo === elem_$_lo) ? 0 : (((key_$_lo >>> 0) < (elem_$_lo >>> 0)) ? (-1) : 1)) : ((key_$_hi < elem_$_hi) ? (-1) : 1));
      if ((cmp < 0)) {
        endIndex = mid;
      } else if ((cmp === 0)) {
        return mid;
      } else {
        startIndex = ((1 + mid) | 0);
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AI__I__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = $n(a).u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (~startIndex);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = $n(a).get(mid);
      var cmp = ((key === elem) ? 0 : ((key < elem) ? (-1) : 1));
      if ((cmp < 0)) {
        endIndex = mid;
      } else if ((cmp === 0)) {
        return mid;
      } else {
        startIndex = ((1 + mid) | 0);
      }
    }
  }
});
$c_ju_Arrays$.prototype.equals__AJ__AJ__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = (($n(a).u.length >>> 1) | 0);
  if (((($n(b).u.length >>> 1) | 0) !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var $x_1 = $n(a).u;
    var $x_2 = $aJCheckGet($x_1, i$1);
    var a$1_$_lo = $x_1[$x_2];
    var a$1_$_hi = $x_1[(($x_2 + 1) | 0)];
    var i$2 = i;
    var $x_3 = $n(b).u;
    var $x_4 = $aJCheckGet($x_3, i$2);
    var b$1_$_lo = $x_3[$x_4];
    var b$1_$_hi = $x_3[(($x_4 + 1) | 0)];
    if ((!(((a$1_$_lo ^ b$1_$_lo) | (a$1_$_hi ^ b$1_$_hi)) === 0))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AI__AI__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AS__AS__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AC__AC__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AB__AB__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AZ__AZ__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = $n(a).u.length;
  if (($n(b).u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = $n(a).get(i$1);
    var i$2 = i;
    var b$1 = $n(b).get(i$2);
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.fill__AJ__I__I__J__V = (function(a, fromIndex, toIndex, value_$_lo, value_$_hi) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    var $x_1 = $n(a).u;
    var $x_2 = $aJCheckGet($x_1, fromIndex);
  }
  if ((toIndex > 0)) {
    var i = ((toIndex - 1) | 0);
    var $x_3 = $n(a).u;
    var $x_4 = $aJCheckGet($x_3, i);
  }
  var i$1 = fromIndex;
  while ((i$1 !== toIndex)) {
    var i$2 = i$1;
    $n(a).set(i$2, value_$_lo, value_$_hi);
    i$1 = ((1 + i$1) | 0);
  }
});
$c_ju_Arrays$.prototype.fill__AO__O__V = (function(a, value) {
  var toIndex = $n(a).u.length;
  var i = 0;
  while ((i !== toIndex)) {
    var i$1 = i;
    $n(a).set(i$1, value);
    i = ((1 + i) | 0);
  }
});
$c_ju_Arrays$.prototype.fill__AO__I__I__O__V = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((fromIndex < 0)) {
    $n(a).get(fromIndex);
  }
  if ((toIndex > 0)) {
    var i = ((toIndex - 1) | 0);
    $n(a).get(i);
  }
  var i$1 = fromIndex;
  while ((i$1 !== toIndex)) {
    var i$2 = i$1;
    $n(a).set(i$2, value);
    i$1 = ((1 + i$1) | 0);
  }
});
$c_ju_Arrays$.prototype.copyOf__AO__I__AO = (function(original, newLength) {
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var this$3 = $n(original);
  var clazz = $objectGetClass(this$3);
  var componentType = clazz.data.getComponentType();
  var ret = $asArrayOf_O($n(componentType).data.newArray(newLength), 1);
  $systemArraycopyRefs($n(original), 0, $n(ret), 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AO__I__jl_Class__AO = (function(original, newLength, newType) {
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var this$4 = $n(newType);
  var componentType = this$4.data.getComponentType();
  var ret = $asArrayOf_O($n(componentType).data.newArray(newLength), 1);
  $systemArraycopyRefs($n(original), 0, $n(ret), 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AB__I__AB = (function(original, newLength) {
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_B(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AS__I__AS = (function(original, newLength) {
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_S(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AI__I__AI = (function(original, newLength) {
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_I(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AJ__I__AJ = (function(original, newLength) {
  var b = (($n(original).u.length >>> 1) | 0);
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_J(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AC__I__AC = (function(original, newLength) {
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_C(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AF__I__AF = (function(original, newLength) {
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_F(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AD__I__AD = (function(original, newLength) {
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_D(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AZ__I__AZ = (function(original, newLength) {
  var b = $n(original).u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_Z(newLength);
  $systemArraycopy($n(original), 0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AO__I__I__AO = (function(original, from, to) {
  if ((from > to)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((from + " > ") + to));
  }
  var len = $n(original).u.length;
  var retLength = ((to - from) | 0);
  var b = ((len - from) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var this$3 = $n(original);
  var clazz = $objectGetClass(this$3);
  var componentType = clazz.data.getComponentType();
  var ret = $asArrayOf_O($n(componentType).data.newArray(retLength), 1);
  $systemArraycopyRefs($n(original), from, $n(ret), 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AB__I__I__AB = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_B(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AS__I__I__AS = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_S(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AI__I__I__AI = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_I(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AJ__I__I__AJ = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = (($n(original).u.length >>> 1) | 0);
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_J(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AC__I__I__AC = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_C(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AF__I__I__AF = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_F(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AD__I__I__AD = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_D(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AZ__I__I__AZ = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = $n(original).u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_Z(retLength);
  $systemArraycopy($n(original), start, ret, 0, copyLength);
  return ret;
});
var $d_ju_Arrays$ = new $TypeData().initClass($c_ju_Arrays$, "java.util.Arrays$", ({
  ju_Arrays$: 1
}));
var $n_ju_Arrays$;
function $m_ju_Arrays$() {
  if ((!$n_ju_Arrays$)) {
    $n_ju_Arrays$ = new $c_ju_Arrays$();
  }
  return $n_ju_Arrays$;
}
/** @constructor */
function $c_ju_Collections$() {
}
$c_ju_Collections$.prototype = new $h_O();
$c_ju_Collections$.prototype.constructor = $c_ju_Collections$;
/** @constructor */
function $h_ju_Collections$() {
}
$h_ju_Collections$.prototype = $c_ju_Collections$.prototype;
$c_ju_Collections$.prototype.singletonList__O__ju_List = (function(o) {
  return new $c_ju_Collections$ImmutableList(new $c_ju_Collections$$anon$15(o));
});
var $d_ju_Collections$ = new $TypeData().initClass($c_ju_Collections$, "java.util.Collections$", ({
  ju_Collections$: 1
}));
var $n_ju_Collections$;
function $m_ju_Collections$() {
  if ((!$n_ju_Collections$)) {
    $n_ju_Collections$ = new $c_ju_Collections$();
  }
  return $n_ju_Collections$;
}
function $is_ju_Formattable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Formattable)));
}
function $as_ju_Formattable(obj) {
  return (($is_ju_Formattable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Formattable"));
}
function $isArrayOf_ju_Formattable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Formattable)));
}
function $asArrayOf_ju_Formattable(obj, depth) {
  return (($isArrayOf_ju_Formattable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Formattable;", depth));
}
/** @constructor */
function $c_ju_Formatter$() {
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = null;
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = null;
  $n_ju_Formatter$ = this;
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = new RegExp("(?:(\\d+)\\$)?([-#+ 0,\\(<]*)(\\d+)?(?:\\.(\\d+))?[%A-Za-z]", "g");
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = new $ac_I(new Int32Array([96, 126, 638, 770, 32, 256, 2, 126, (-1), (-1), (-1), (-1), (-1), (-1), 800, (-1), (-1), (-1), 124, (-1), (-1), (-1), (-1), 544, (-1), (-1)]));
}
$c_ju_Formatter$.prototype = new $h_O();
$c_ju_Formatter$.prototype.constructor = $c_ju_Formatter$;
/** @constructor */
function $h_ju_Formatter$() {
}
$h_ju_Formatter$.prototype = $c_ju_Formatter$.prototype;
$c_ju_Formatter$.prototype.java$util$Formatter$$strOfZeros__I__T = (function(count) {
  if ((count <= 20)) {
    if ((count > 20)) {
      $charAt("00000000000000000000", count);
    }
    if ((count < 0)) {
      $charAt("00000000000000000000", (-1));
    }
    return $as_T("00000000000000000000".substring(0, count));
  } else {
    var result = "";
    var remaining = count;
    while ((remaining > 20)) {
      result = (result + "00000000000000000000");
      remaining = ((remaining - 20) | 0);
    }
    var $x_1 = result;
    var endIndex = remaining;
    if ((endIndex > 20)) {
      $charAt("00000000000000000000", endIndex);
    }
    if ((endIndex < 0)) {
      $charAt("00000000000000000000", (-1));
    }
    return (("" + $x_1) + $as_T("00000000000000000000".substring(0, endIndex)));
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal = (function(x) {
  if ((x === 0.0)) {
    var negative = ((1.0 / x) < 0.0);
    return new $c_ju_Formatter$Decimal(negative, "0", 0);
  } else {
    var negative$2 = (x < 0.0);
    var d = (negative$2 ? (-x) : x);
    var s = ("" + d);
    var ePos = $f_T__indexOf__I__I(s, 101);
    if ((ePos < 0)) {
      var e = 0;
    } else {
      var $x_2 = parseInt;
      var beginIndex = ((1 + ePos) | 0);
      if (((beginIndex < 0) || (beginIndex > s.length))) {
        $charAt(s, beginIndex);
      }
      var $x_1 = $x_2($as_T(s.substring(beginIndex)));
      var e = $uI($x_1);
    }
    var significandEnd = ((ePos < 0) ? s.length : ePos);
    var dotPos = $f_T__indexOf__I__I(s, 46);
    if ((dotPos < 0)) {
      if ((significandEnd > s.length)) {
        $charAt(s, significandEnd);
      }
      if ((significandEnd < 0)) {
        $charAt(s, (-1));
      }
      var unscaledValue = $as_T(s.substring(0, significandEnd));
      var scale = ((-e) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue, scale);
    } else {
      if ((dotPos > s.length)) {
        $charAt(s, dotPos);
      }
      if ((dotPos < 0)) {
        $charAt(s, (-1));
      }
      var $x_3 = $as_T(s.substring(0, dotPos));
      var beginIndex$1 = ((1 + dotPos) | 0);
      if ((beginIndex$1 < 0)) {
        $charAt(s, beginIndex$1);
      }
      if ((significandEnd > s.length)) {
        $charAt(s, significandEnd);
      }
      if ((significandEnd < beginIndex$1)) {
        $charAt(s, (-1));
      }
      var digits = (("" + $x_3) + $as_T(s.substring(beginIndex$1, significandEnd)));
      var digitsLen = digits.length;
      var i = 0;
      while (true) {
        if ((i < digitsLen)) {
          var index = i;
          var $x_4 = ($charAt(digits, index) === 48);
        } else {
          var $x_4 = false;
        }
        if ($x_4) {
          i = ((1 + i) | 0);
        } else {
          break;
        }
      }
      var beginIndex$2 = i;
      if (((beginIndex$2 < 0) || (beginIndex$2 > digits.length))) {
        $charAt(digits, beginIndex$2);
      }
      var unscaledValue$2 = $as_T(digits.substring(beginIndex$2));
      var scale$2 = ((((-e) | 0) + ((significandEnd - ((1 + dotPos) | 0)) | 0)) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue$2, scale$2);
    }
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal = (function(x) {
  var this$1 = $n(x);
  var this$2 = $n(this$1.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
  var unscaledValueWithSign = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$2);
  if ((unscaledValueWithSign === "0")) {
    return new $c_ju_Formatter$Decimal(false, "0", 0);
  } else {
    var this$4 = $n(unscaledValueWithSign);
    var negative = ($charAt(this$4, 0) === 45);
    if (negative) {
      var this$5 = $n(unscaledValueWithSign);
      if ((this$5.length < 1)) {
        $charAt(this$5, 1);
      }
      var unscaledValue = $as_T(this$5.substring(1));
    } else {
      var unscaledValue = unscaledValueWithSign;
    }
    var this$6 = $n(x);
    var scale = this$6.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    return new $c_ju_Formatter$Decimal(negative, unscaledValue, scale);
  }
});
var $d_ju_Formatter$ = new $TypeData().initClass($c_ju_Formatter$, "java.util.Formatter$", ({
  ju_Formatter$: 1
}));
var $n_ju_Formatter$;
function $m_ju_Formatter$() {
  if ((!$n_ju_Formatter$)) {
    $n_ju_Formatter$ = new $c_ju_Formatter$();
  }
  return $n_ju_Formatter$;
}
function $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal($thiz, roundingPos) {
  var digits = $thiz.ju_Formatter$Decimal__f_unscaledValue;
  var this$1 = $n(digits);
  var digitsLen = this$1.length;
  if ((roundingPos < 0)) {
    var negative = $thiz.ju_Formatter$Decimal__f_negative;
    return new $c_ju_Formatter$Decimal(negative, "0", 0);
  } else if ((roundingPos >= digitsLen)) {
    return $thiz;
  } else {
    var this$3 = $n(digits);
    if (($charAt(this$3, roundingPos) < 53)) {
      if ((roundingPos === 0)) {
        var negative$1 = $thiz.ju_Formatter$Decimal__f_negative;
        return new $c_ju_Formatter$Decimal(negative$1, "0", 0);
      } else {
        var $x_1 = $thiz.ju_Formatter$Decimal__f_negative;
        var this$5 = $n(digits);
        if ((roundingPos > this$5.length)) {
          $charAt(this$5, roundingPos);
        }
        if ((roundingPos < 0)) {
          $charAt(this$5, (-1));
        }
        return new $c_ju_Formatter$Decimal($x_1, $as_T(this$5.substring(0, roundingPos)), (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - roundingPos) | 0)) | 0));
      }
    } else {
      var lastNonNinePos = ((roundingPos - 1) | 0);
      while (true) {
        if ((lastNonNinePos >= 0)) {
          var this$6 = $n(digits);
          var index = lastNonNinePos;
          var $x_2 = ($charAt(this$6, index) === 57);
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          lastNonNinePos = ((lastNonNinePos - 1) | 0);
        } else {
          break;
        }
      }
      if ((lastNonNinePos < 0)) {
        var newUnscaledValue = "1";
      } else {
        var this$7 = $n(digits);
        var endIndex = lastNonNinePos;
        if ((endIndex > this$7.length)) {
          $charAt(this$7, endIndex);
        }
        if ((endIndex < 0)) {
          $charAt(this$7, (-1));
        }
        var $x_3 = $as_T(this$7.substring(0, endIndex));
        var this$8 = $n(digits);
        var index$1 = lastNonNinePos;
        var newUnscaledValue = ($x_3 + $cToS((65535 & ((1 + $charAt(this$8, index$1)) | 0))));
      }
      var pos = ((1 + lastNonNinePos) | 0);
      var newScale = (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - pos) | 0)) | 0);
      return new $c_ju_Formatter$Decimal($thiz.ju_Formatter$Decimal__f_negative, newUnscaledValue, newScale);
    }
  }
}
/** @constructor */
function $c_ju_Formatter$Decimal(negative, unscaledValue, scale) {
  this.ju_Formatter$Decimal__f_negative = false;
  this.ju_Formatter$Decimal__f_unscaledValue = null;
  this.ju_Formatter$Decimal__f_scale = 0;
  this.ju_Formatter$Decimal__f_negative = negative;
  this.ju_Formatter$Decimal__f_unscaledValue = unscaledValue;
  this.ju_Formatter$Decimal__f_scale = scale;
}
$c_ju_Formatter$Decimal.prototype = new $h_O();
$c_ju_Formatter$Decimal.prototype.constructor = $c_ju_Formatter$Decimal;
/** @constructor */
function $h_ju_Formatter$Decimal() {
}
$h_ju_Formatter$Decimal.prototype = $c_ju_Formatter$Decimal.prototype;
$c_ju_Formatter$Decimal.prototype.isZero__Z = (function() {
  return (this.ju_Formatter$Decimal__f_unscaledValue === "0");
});
$c_ju_Formatter$Decimal.prototype.round__I__ju_Formatter$Decimal = (function(precision) {
  $m_ju_Formatter$();
  var condition = (precision > 0);
  if ((!condition)) {
    throw new $c_jl_AssertionError("Decimal.round() called with non-positive precision");
  }
  return $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, precision);
});
$c_ju_Formatter$Decimal.prototype.setScale__I__ju_Formatter$Decimal = (function(newScale) {
  var this$1 = $n(this.ju_Formatter$Decimal__f_unscaledValue);
  var roundingPos = ((((this$1.length + newScale) | 0) - this.ju_Formatter$Decimal__f_scale) | 0);
  var rounded = $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, roundingPos);
  $m_ju_Formatter$();
  var condition = ($n(rounded).isZero__Z() || ($n(rounded).ju_Formatter$Decimal__f_scale <= newScale));
  if ((!condition)) {
    throw new $c_jl_AssertionError("roundAtPos returned a non-zero value with a scale too large");
  }
  return (($n(rounded).isZero__Z() || ($n(rounded).ju_Formatter$Decimal__f_scale === newScale)) ? rounded : new $c_ju_Formatter$Decimal(this.ju_Formatter$Decimal__f_negative, (("" + $n(rounded).ju_Formatter$Decimal__f_unscaledValue) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((newScale - $n(rounded).ju_Formatter$Decimal__f_scale) | 0))), newScale));
});
$c_ju_Formatter$Decimal.prototype.toString__T = (function() {
  return (((((("Decimal(" + this.ju_Formatter$Decimal__f_negative) + ", ") + this.ju_Formatter$Decimal__f_unscaledValue) + ", ") + this.ju_Formatter$Decimal__f_scale) + ")");
});
var $d_ju_Formatter$Decimal = new $TypeData().initClass($c_ju_Formatter$Decimal, "java.util.Formatter$Decimal", ({
  ju_Formatter$Decimal: 1
}));
/** @constructor */
function $c_ju_Formatter$LocaleInfo() {
}
$c_ju_Formatter$LocaleInfo.prototype = new $h_O();
$c_ju_Formatter$LocaleInfo.prototype.constructor = $c_ju_Formatter$LocaleInfo;
/** @constructor */
function $h_ju_Formatter$LocaleInfo() {
}
$h_ju_Formatter$LocaleInfo.prototype = $c_ju_Formatter$LocaleInfo.prototype;
function $p_ju_Locale__updateSpecialLanguages__T__T($thiz, l) {
  switch (l) {
    case "iw": {
      return "he";
      break;
    }
    case "ji": {
      return "yi";
      break;
    }
    case "in": {
      return "id";
      break;
    }
    default: {
      return l;
    }
  }
}
function $p_ju_Locale__translateSpecialLanguages__T__T($thiz, l) {
  return l;
}
function $p_ju_Locale__isEqual__ju_Locale__Z($thiz, l) {
  if (((($thiz.ju_Locale__f_language === $n(l).getLanguage__T()) && ($thiz.ju_Locale__f_country === $n(l).getCountry__T())) && ($thiz.ju_Locale__f_variant === $n(l).ju_Locale__f_variant))) {
    var this$1 = $n($thiz.ju_Locale__f_script);
    if (this$1.isEmpty__Z()) {
      var $x_1 = true;
    } else {
      var x0 = this$1.get__O();
      var _$13 = $as_T(x0);
      var $x_1 = (_$13 === $n(l).getScript__T());
    }
  } else {
    var $x_1 = false;
  }
  if ((($x_1 && $n($thiz.ju_Locale__f_extensions).forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var k = $uC($n(x$1$1)._1__O());
      var v = $as_T($n(x$1$1)._2__O());
      return ($n(l).getExtension__C__T(k) === v);
    }
    throw new $c_s_MatchError(x$1$1);
  })))) && $n($thiz.ju_Locale__f_unicodeExtensions).forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    if ((x$1$3 !== null)) {
      var k$1 = $as_T($n(x$1$3)._1__O());
      var v$1 = $as_T($n(x$1$3)._2__O());
      return ($n(l).getUnicodeLocaleType__T__T(k$1) === v$1);
    }
    throw new $c_s_MatchError(x$1$3);
  }))))) {
    var x = $thiz.ju_Locale__f_unicodeAttributes;
    var this$2 = $m_s_jdk_CollectionConverters$();
    var s = $n(l).getUnicodeLocaleAttributes__ju_Set();
    var x$2 = new $c_sc_convert_AsScalaExtensions$SetHasAsScala(this$2, s).asScala__scm_Set();
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
}
/** @constructor */
function $c_ju_Locale(language, country, variant, script, _extensions, unicodeExtensions, unicodeAttributes, supportSpecialCases) {
  this.ju_Locale__f_language = null;
  this.ju_Locale__f_country = null;
  this.ju_Locale__f_variant = null;
  this.ju_Locale__f_script = null;
  this.ju_Locale__f_unicodeExtensions = null;
  this.ju_Locale__f_unicodeAttributes = null;
  this.ju_Locale__f_cachedLanguageTag = null;
  this.ju_Locale__f_cachedHashCode = 0;
  this.ju_Locale__f_extensions = null;
  this.ju_Locale__f_language = language;
  this.ju_Locale__f_country = country;
  this.ju_Locale__f_variant = variant;
  this.ju_Locale__f_script = script;
  this.ju_Locale__f_unicodeExtensions = unicodeExtensions;
  this.ju_Locale__f_unicodeAttributes = unicodeAttributes;
  this.ju_Locale__f_cachedLanguageTag = null;
  this.ju_Locale__f_cachedHashCode = 0;
  if ((((language === null) || (country === null)) || (variant === null))) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Null argument to constructor not allowed");
  }
  var x = new $c_T3(language, country, variant);
  var x$2 = new $c_T3("ja", "JP", "JP");
  if ((x.equals__O__Z(x$2) && supportSpecialCases)) {
    var this$5 = $n(_extensions);
    var $x_3 = $m_sc_Map$();
    var $x_2 = $m_sr_ScalaRunTime$();
    var self = $m_ju_Locale$().ju_Locale$__f_UNICODE_LOCALE_EXTENSION;
    var xs = $as_sc_IterableOnce($x_3.apply__sci_Seq__O($x_2.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2($bC(self), "ca-japanese")]))));
    var $x_1 = $as_sc_Map(this$5.concat__sc_IterableOnce__sc_IterableOps(xs));
  } else {
    var x$3 = new $c_T3(language, country, variant);
    var x$4 = new $c_T3("th", "TH", "TH");
    if ((x$3.equals__O__Z(x$4) && supportSpecialCases)) {
      var this$10 = $n(_extensions);
      var $x_5 = $m_sc_Map$();
      var $x_4 = $m_sr_ScalaRunTime$();
      var self$1 = $m_ju_Locale$().ju_Locale$__f_UNICODE_LOCALE_EXTENSION;
      var xs$1 = $as_sc_IterableOnce($x_5.apply__sci_Seq__O($x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2($bC(self$1), "nu-thai")]))));
      var $x_1 = $as_sc_Map(this$10.concat__sc_IterableOnce__sc_IterableOps(xs$1));
    } else {
      var $x_1 = _extensions;
    }
  }
  this.ju_Locale__f_extensions = $x_1;
}
$c_ju_Locale.prototype = new $h_O();
$c_ju_Locale.prototype.constructor = $c_ju_Locale;
/** @constructor */
function $h_ju_Locale() {
}
$h_ju_Locale.prototype = $c_ju_Locale.prototype;
$c_ju_Locale.prototype.getLanguage__T = (function() {
  var this$1 = $n(this.ju_Locale__f_language);
  return $p_ju_Locale__translateSpecialLanguages__T__T(this, $as_T(this$1.toLowerCase()));
});
$c_ju_Locale.prototype.getScript__T = (function() {
  var this$1 = $n(this.ju_Locale__f_script);
  return $as_T((this$1.isEmpty__Z() ? "" : this$1.get__O()));
});
$c_ju_Locale.prototype.getCountry__T = (function() {
  var this$1 = $n(this.ju_Locale__f_country);
  return $as_T(this$1.toUpperCase());
});
$c_ju_Locale.prototype.hasExtensions__Z = (function() {
  var this$1 = $n(this.ju_Locale__f_extensions);
  if ((!this$1.isEmpty__Z())) {
    return true;
  } else {
    var this$2 = $n(this.ju_Locale__f_unicodeExtensions);
    return (!this$2.isEmpty__Z());
  }
});
$c_ju_Locale.prototype.getExtension__C__T = (function(key) {
  if ((key === $m_ju_Locale$().ju_Locale$__f_UNICODE_LOCALE_EXTENSION)) {
    var this$1 = $n(this.ju_Locale__f_unicodeExtensions);
    var $x_1 = (!this$1.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var this$2 = $n($as_sc_IterableOnceOps($n(this.ju_Locale__f_unicodeExtensions).collect__s_PartialFunction__O(new $c_ju_Locale$$anon$1())));
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "-", "");
  } else {
    var this$4 = $n($n(this.ju_Locale__f_extensions).get__O__s_Option($bC(key)));
    var this$3 = $m_s_$less$colon$less$();
    var ev = this$3.s_$less$colon$less$__f_singleton;
    return $as_T((this$4.isEmpty__Z() ? ($n(ev), null) : this$4.get__O()));
  }
});
$c_ju_Locale.prototype.getUnicodeLocaleAttributes__ju_Set = (function() {
  var this$1 = $m_s_jdk_CollectionConverters$();
  var s = this.ju_Locale__f_unicodeAttributes;
  return new $c_sc_convert_AsJavaExtensions$SetHasAsJava(this$1, s).asJava__ju_Set();
});
$c_ju_Locale.prototype.getUnicodeLocaleType__T__T = (function(key) {
  var this$2 = $n($n(this.ju_Locale__f_unicodeExtensions).get__O__s_Option(key));
  var this$1 = $m_s_$less$colon$less$();
  var ev = this$1.s_$less$colon$less$__f_singleton;
  return $as_T((this$2.isEmpty__Z() ? ($n(ev), null) : this$2.get__O()));
});
$c_ju_Locale.prototype.toString__T = (function() {
  var x = this.ju_Locale__f_variant;
  var this$3 = $n(x);
  var hasVariant = (!(this$3 === ""));
  var x$1 = this.getCountry__T();
  var this$6 = $n(x$1);
  var hasCountry = (!(this$6 === ""));
  var x$2 = this.getLanguage__T();
  var this$9 = $n(x$2);
  var hasLanguage = (!(this$9 === ""));
  var x$3 = this.getScript__T();
  var this$12 = $n(x$3);
  var hasScript = (!(this$12 === ""));
  var countryPart = (hasCountry ? ("_" + this.getCountry__T()) : ((hasVariant || hasScript) ? "_" : ""));
  var variantPart = (hasVariant ? ("_" + this.ju_Locale__f_variant) : (hasScript ? "_" : ""));
  var scriptPart = ((hasScript && this.hasExtensions__Z()) ? (("#" + this.getScript__T()) + "_") : (hasScript ? ("#" + this.getScript__T()) : (this.hasExtensions__Z() ? "_#" : "")));
  var this$13 = $n($as_sc_IterableOnceOps($n(this.ju_Locale__f_extensions).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$1) => {
    var x$1$2 = $as_T2(x$1$1);
    if ((x$1$2 !== null)) {
      var x$4 = $uC($n(x$1$2)._1__O());
      var v = $as_T($n(x$1$2)._2__O());
      return (($cToS(x$4) + "-") + v);
    }
    throw new $c_s_MatchError(x$1$2);
  })))));
  var extensionsPart = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$13, "", "", "");
  return ((hasLanguage || hasCountry) ? ((((this.getLanguage__T() + countryPart) + variantPart) + scriptPart) + extensionsPart) : "");
});
$c_ju_Locale.prototype.toLanguageTag__T = (function() {
  if ((this.ju_Locale__f_cachedLanguageTag === null)) {
    var x = this.getLanguage__T();
    var this$3 = $n(x);
    if (((!(this$3 === "")) && $m_ju_Locale$().checkLanguage__T__Z(this.getLanguage__T()))) {
      var language = $p_ju_Locale__updateSpecialLanguages__T__T(this, this.getLanguage__T());
    } else {
      var language = "und";
    }
    var country = ($m_ju_Locale$().checkRegion__T__Z(this.getCountry__T()) ? ("-" + this.getCountry__T()) : "");
    var this$4 = $n(this.ju_Locale__f_variant);
    var variantSegments = $f_T__split__T__I__AT(this$4, "-|_", 0);
    _return: {
      var i = 0;
      while ((i < $n(variantSegments).u.length)) {
        var x1 = i;
        var x0 = $n(variantSegments).get(x1);
        if ((!$m_ju_Locale$().checkVariantSegment__T__Z(x0))) {
          var allSegmentsWellFormed = false;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var allSegmentsWellFormed = true;
    }
    _return$1: {
      var i$1 = 0;
      while ((i$1 < $n(variantSegments).u.length)) {
        var x1$1 = i$1;
        var x0$1 = $n(variantSegments).get(x1$1);
        if ((!$m_ju_Locale$().checkAcceptableVariantSegment__T__Z(x0$1))) {
          var allAcceptableSegments = false;
          break _return$1;
        }
        i$1 = ((1 + i$1) | 0);
      }
      var allAcceptableSegments = true;
    }
    if (allSegmentsWellFormed) {
      var this$9 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(variantSegments));
      var variant = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$9, "-", "-", "");
    } else if (allAcceptableSegments) {
      var $x_1 = $m_s_reflect_ClassTag$();
      var this$13 = $n(variantSegments);
      var this$14 = $objectGetClass(this$13);
      var evidence$1 = $x_1.apply__jl_Class__s_reflect_ClassTag(this$14.data.getComponentType());
      var res1 = new $c_scm_ArrayBuilder$generic($n(evidence$1).runtimeClass__jl_Class());
      var $x_2 = $m_s_reflect_ClassTag$();
      var this$18 = $n(variantSegments);
      var this$19 = $objectGetClass(this$18);
      var evidence$1$1 = $x_2.apply__jl_Class__s_reflect_ClassTag(this$19.data.getComponentType());
      var res2 = new $c_scm_ArrayBuilder$generic($n(evidence$1$1).runtimeClass__jl_Class());
      var i$2 = 0;
      while ((i$2 < $n(variantSegments).u.length)) {
        var x1$2 = i$2;
        var x$1 = $n(variantSegments).get(x1$2);
        var this$22 = ($m_ju_Locale$().checkVariantSegment__T__Z(x$1) ? res1 : res2);
        this$22.addOne__O__scm_ArrayBuilder$generic(x$1);
        i$2 = ((1 + i$2) | 0);
      }
      var _1 = res1.result__O();
      var _2 = res2.result__O();
      var wellFormed = $asArrayOf_T(_1, 1);
      var acceptable = $asArrayOf_T(_2, 1);
      var \u03b41$___1 = wellFormed;
      var \u03b41$___2 = acceptable;
      var wellFormed$2 = $asArrayOf_T(\u03b41$___1, 1);
      var acceptable$2 = $asArrayOf_T(\u03b41$___2, 1);
      if (($n(wellFormed$2).u.length !== 0)) {
        var this$28 = $n($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($asArrayOf_O($m_sc_ArrayOps$().slice$extension__O__I__I__O(wellFormed$2, 0, 1), 1)));
        var pre = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$28, "-", "-", "-");
      } else {
        var pre = "-";
      }
      var $x_3 = $m_s_Predef$();
      var xs = $m_sc_ArrayOps$().drop$extension__O__I__O(wellFormed$2, 1);
      var newLength = (($n(acceptable$2).u.length + $m_jl_reflect_Array$().getLength__O__I(xs)) | 0);
      var this$36 = $n(acceptable$2);
      var this$37 = $objectGetClass(this$36);
      var that = this$37.data.getComponentType();
      if ($d_T.isAssignableFrom($n(that).data)) {
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(acceptable$2, newLength, $d_T.getArrayOf().getClassOf());
      } else {
        var dest = new ($d_T.getArrayOf().constr)(newLength);
        $m_s_Array$().copy__O__I__O__I__I__V(acceptable$2, 0, dest, 0, $n(acceptable$2).u.length);
        var dest$1 = dest;
      }
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest$1, $n(acceptable$2).u.length, $m_jl_reflect_Array$().getLength__O__I(xs));
      var this$42 = $n($x_3.wrapRefArray__AO__scm_ArraySeq$ofRef($asArrayOf_O(dest$1, 1)));
      var variant = ((pre + "x-lvariant") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$42, "-", "-", ""));
    } else {
      var variant = "";
    }
    var this$43 = $n(this.ju_Locale__f_extensions);
    if ((!this$43.isEmpty__Z())) {
      var ext = $f_sc_IterableOnceOps__mkString__T__T__T__T($n($as_sc_IterableOnceOps($n(this.ju_Locale__f_extensions).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$1) => {
        var x$1$2 = $as_T2(x$1$1);
        if ((x$1$2 !== null)) {
          var x$2 = $uC($n(x$1$2)._1__O());
          var v = $as_T($n(x$1$2)._2__O());
          return (($cToS(x$2) + "-") + v);
        }
        throw new $c_s_MatchError(x$1$2);
      }))))), "-", "-", "");
    } else {
      var ext = "";
    }
    var this$44 = $n(this.ju_Locale__f_script);
    if (this$44.isEmpty__Z()) {
      var this$45 = $m_s_None$();
    } else {
      var x0$2 = this$44.get__O();
      $as_T(x0$2);
      var this$45 = new $c_s_Some(("-" + this.getScript__T()));
    }
    var script = $as_T((this$45.isEmpty__Z() ? "" : this$45.get__O()));
    this.ju_Locale__f_cachedLanguageTag = ((((this.getLanguage__T() === "no") && (this.getCountry__T() === "NO")) && (this.ju_Locale__f_variant === "NY")) ? "nn-NO" : ((((("" + language) + script) + country) + ext) + variant));
  }
  return this.ju_Locale__f_cachedLanguageTag;
});
$c_ju_Locale.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_ju_Locale)) {
    var l = $as_ju_Locale(x);
    return $p_ju_Locale__isEqual__ju_Locale__Z(this, l);
  } else {
    return false;
  }
});
$c_ju_Locale.prototype.hashCode__I = (function() {
  if ((this.ju_Locale__f_cachedHashCode === 0)) {
    this.ju_Locale__f_cachedHashCode = $f_T__hashCode__I($n(this.toLanguageTag__T()));
  }
  return this.ju_Locale__f_cachedHashCode;
});
function $as_ju_Locale(obj) {
  return (((obj instanceof $c_ju_Locale) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Locale"));
}
function $isArrayOf_ju_Locale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale)));
}
function $asArrayOf_ju_Locale(obj, depth) {
  return (($isArrayOf_ju_Locale(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Locale;", depth));
}
var $d_ju_Locale = new $TypeData().initClass($c_ju_Locale, "java.util.Locale", ({
  ju_Locale: 1
}));
/** @constructor */
function $c_ju_Locale$() {
  this.ju_Locale$__f_ROOT$lzy1 = null;
  this.ju_Locale$__f_ROOTbitmap$1 = false;
  this.ju_Locale$__f_UNICODE_LOCALE_EXTENSION = 0;
  this.ju_Locale$__f_defaultLocale = null;
  $n_ju_Locale$ = this;
  this.ju_Locale$__f_UNICODE_LOCALE_EXTENSION = 117;
  this.ju_Locale$__f_defaultLocale = $m_Llocales_DefaultLocale$().platformLocale__ju_Locale();
  var $x_12 = $m_s_Predef$();
  var xs = $m_ju_Locale$Category$().values__Aju_Locale$Category();
  var f = ((_$5) => {
    var _$5$1 = $as_ju_Locale$Category(_$5);
    var value = this.ju_Locale$__f_defaultLocale;
    var y = new $c_s_Some(value);
    return new $c_T2(_$5$1, y);
  });
  var len = $n(xs).u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = $n(xs).get(i);
        ys.set($x_1, $as_T2(f(x0)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = $n(x3).get(i);
        ys.set($x_2, $as_T2(f(x0$1)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = $n(x4).get(i);
        ys.set($x_3, $as_T2(f(x0$2)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var $x_6 = i;
        var $x_4 = $n(x5).u;
        var $x_5 = $aJCheckGet($x_4, i);
        var x0$3_$_lo = $x_4[$x_5];
        var x0$3_$_hi = $x_4[(($x_5 + 1) | 0)];
        ys.set($x_6, $as_T2(f($bL(x0$3_$_lo, x0$3_$_hi))));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var $x_7 = i;
        var x0$4 = $n(x6).get(i);
        ys.set($x_7, $as_T2(f(x0$4)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var $x_8 = i;
        var x0$5 = $n(x7).get(i);
        ys.set($x_8, $as_T2(f($bC(x0$5))));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var $x_9 = i;
        var x0$6 = $n(x8).get(i);
        ys.set($x_9, $as_T2(f(x0$6)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var $x_10 = i;
        var x0$7 = $n(x9).get(i);
        ys.set($x_10, $as_T2(f(x0$7)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var $x_11 = i;
        var x0$8 = $n(x10).get(i);
        ys.set($x_11, $as_T2(f(x0$8)));
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
  }
  var this$10 = $n($x_12.wrapRefArray__AO__scm_ArraySeq$ofRef(ys));
  $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$10);
}
$c_ju_Locale$.prototype = new $h_O();
$c_ju_Locale$.prototype.constructor = $c_ju_Locale$;
/** @constructor */
function $h_ju_Locale$() {
}
$h_ju_Locale$.prototype = $c_ju_Locale$.prototype;
$c_ju_Locale$.prototype.ROOT__ju_Locale = (function() {
  if ((!this.ju_Locale$__f_ROOTbitmap$1)) {
    this.ju_Locale$__f_ROOT$lzy1 = $n($m_Llocales_LocalesDb$().Llocales_LocalesDb$__f_root).toLocale__ju_Locale();
    this.ju_Locale$__f_ROOTbitmap$1 = true;
  }
  return this.ju_Locale$__f_ROOT$lzy1;
});
$c_ju_Locale$.prototype.checkRegex__s_util_matching_Regex__T__Z = (function(regex, s) {
  if ((s !== null)) {
    var x32 = $n(regex).unapplySeq__jl_CharSequence__s_Option(s);
    if ((!$n(x32).isEmpty__Z())) {
      var x33 = $as_sci_List($n(x32).get__O());
      if (($n(x33).lengthCompare__I__I(0) === 0)) {
        return true;
      }
    }
  }
  return false;
});
$c_ju_Locale$.prototype.checkLanguage__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{2,8}", $m_sci_Nil$()), l);
});
$c_ju_Locale$.prototype.checkScript__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{4}", $m_sci_Nil$()), l);
});
$c_ju_Locale$.prototype.checkRegion__T__Z = (function(l) {
  return (this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{2}", $m_sci_Nil$()), l) || this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9]{3}", $m_sci_Nil$()), l));
});
$c_ju_Locale$.prototype.checkAcceptableVariantSegment__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9a-zA-Z]{1,8}", $m_sci_Nil$()), l);
});
$c_ju_Locale$.prototype.checkVariantSegment__T__Z = (function(l) {
  return (this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9][0-9a-zA-Z]{3}", $m_sci_Nil$()), l) || this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9a-zA-Z]{5,8}", $m_sci_Nil$()), l));
});
$c_ju_Locale$.prototype.checkVariant__T__Z = (function(l) {
  var this$1 = $n(l);
  var parts = $f_T__split__T__I__AT(this$1, "-|_", 0);
  var i = 0;
  while ((i < $n(parts).u.length)) {
    var x1 = i;
    var x0 = $n(parts).get(x1);
    if ((!this.checkVariantSegment__T__Z(x0))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
var $d_ju_Locale$ = new $TypeData().initClass($c_ju_Locale$, "java.util.Locale$", ({
  ju_Locale$: 1
}));
var $n_ju_Locale$;
function $m_ju_Locale$() {
  if ((!$n_ju_Locale$)) {
    $n_ju_Locale$ = new $c_ju_Locale$();
  }
  return $n_ju_Locale$;
}
/** @constructor */
function $c_ju_Locale$Builder() {
  this.ju_Locale$Builder__f_builder = null;
  var language = $m_s_None$();
  var region = $m_s_None$();
  var variant = $m_s_None$();
  var script = $m_s_None$();
  var extensions = $as_sc_Map($m_sc_Map$().empty__O());
  var unicodeExtensions = $as_sc_Map($m_sc_Map$().empty__O());
  var unicodeAttributes = $as_sc_Set($m_sc_Set$().empty__O());
  this.ju_Locale$Builder__f_builder = new $c_ju_Locale$LocaleBuilder(true, language, region, variant, script, extensions, unicodeExtensions, unicodeAttributes);
}
$c_ju_Locale$Builder.prototype = new $h_O();
$c_ju_Locale$Builder.prototype.constructor = $c_ju_Locale$Builder;
/** @constructor */
function $h_ju_Locale$Builder() {
}
$h_ju_Locale$Builder.prototype = $c_ju_Locale$Builder.prototype;
$c_ju_Locale$Builder.prototype.setLanguage__T__ju_Locale$Builder = (function(language) {
  var this$1 = $n($n(this.ju_Locale$Builder__f_builder).language__T__s_Option(language));
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid language " + language));
  }
  var x0 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(x0);
  this.ju_Locale$Builder__f_builder = x;
  return this;
});
$c_ju_Locale$Builder.prototype.setScript__T__ju_Locale$Builder = (function(script) {
  var this$1 = $n($n(this.ju_Locale$Builder__f_builder).script__T__s_Option(script));
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid script " + script));
  }
  var x0 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(x0);
  this.ju_Locale$Builder__f_builder = x;
  return this;
});
$c_ju_Locale$Builder.prototype.setRegion__T__ju_Locale$Builder = (function(region) {
  var this$1 = $n($n(this.ju_Locale$Builder__f_builder).region__T__s_Option(region));
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid region " + region));
  }
  var x0 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(x0);
  this.ju_Locale$Builder__f_builder = x;
  return this;
});
$c_ju_Locale$Builder.prototype.setVariant__T__ju_Locale$Builder = (function(variant) {
  var this$1 = $n($n(this.ju_Locale$Builder__f_builder).variant__T__s_Option(variant));
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid variant " + variant));
  }
  var x0 = this$1.get__O();
  var x = $as_ju_Locale$LocaleBuilder(x0);
  this.ju_Locale$Builder__f_builder = x;
  return this;
});
$c_ju_Locale$Builder.prototype.build__ju_Locale = (function() {
  return $n(this.ju_Locale$Builder__f_builder).build__ju_Locale();
});
var $d_ju_Locale$Builder = new $TypeData().initClass($c_ju_Locale$Builder, "java.util.Locale$Builder", ({
  ju_Locale$Builder: 1
}));
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map)));
}
function $as_ju_Map(obj) {
  return (($is_ju_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map"));
}
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map)));
}
function $asArrayOf_ju_Map(obj, depth) {
  return (($isArrayOf_ju_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map;", depth));
}
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map$Entry)));
}
function $as_ju_Map$Entry(obj) {
  return (($is_ju_Map$Entry(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map$Entry"));
}
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map$Entry)));
}
function $asArrayOf_ju_Map$Entry(obj, depth) {
  return (($isArrayOf_ju_Map$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map$Entry;", depth));
}
function $p_ju_regex_PatternCompiler__parseError__T__E($thiz, desc) {
  throw new $c_ju_regex_PatternSyntaxException(desc, $thiz.ju_regex_PatternCompiler__f_pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
}
function $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V($thiz) {
  var m = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp.exec($thiz.ju_regex_PatternCompiler__f_pattern);
  if ((m !== null)) {
    var x = m[1];
    if ((x !== (void 0))) {
      var t = $as_T(x);
      var this$3 = $n(t);
      var end = this$3.length;
      var i = 0;
      while ((i < end)) {
        var value = i;
        var $x_2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags;
        var $x_1 = $m_ju_regex_PatternCompiler$();
        var this$5 = $n(t);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($x_2 | $x_1.java$util$regex$PatternCompiler$$charToFlag__C__I($charAt(this$5, value)));
        i = ((1 + i) | 0);
      }
    }
    if (((256 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags);
    }
    var x$1 = m[2];
    if ((x$1 !== (void 0))) {
      var t$1 = $as_T(x$1);
      var this$8 = $n(t$1);
      var end$1 = this$8.length;
      var i$1 = 0;
      while ((i$1 < end$1)) {
        var value$1 = i$1;
        var $x_4 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags;
        var $x_3 = $m_ju_regex_PatternCompiler$();
        var this$10 = $n(t$1);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($x_4 & (~$x_3.java$util$regex$PatternCompiler$$charToFlag__C__I($charAt(this$10, value$1))));
        i$1 = ((1 + i$1) | 0);
      }
    }
    var $x_5 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var x$2 = m[0];
    var this$12 = $n($as_T(x$2));
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($x_5 + this$12.length) | 0);
  }
}
function $p_ju_regex_PatternCompiler__literal__T__T($thiz, s) {
  var result = "";
  var this$1 = $n(s);
  var len = this$1.length;
  var i = 0;
  while ((i !== len)) {
    var cp = $f_T__codePointAt__I__I($n(s), i);
    result = (("" + result) + $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp));
    i = ((i + ((cp >= 65536) ? 2 : 1)) | 0);
  }
  return result;
}
function $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(cp);
  if ((cp < 128)) {
    switch (cp) {
      case 94:
      case 36:
      case 92:
      case 46:
      case 42:
      case 43:
      case 63:
      case 40:
      case 41:
      case 91:
      case 93:
      case 123:
      case 125:
      case 124: {
        return ("\\" + s);
        break;
      }
      default: {
        return (((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 2) ? s : (((((cp - 65) | 0) >>> 0) <= 25) ? ((("[" + s) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + cp) | 0))) + "]") : (((((cp - 97) | 0) >>> 0) <= 25) ? ((("[" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((cp - 32) | 0))) + s) + "]") : s)));
      }
    }
  } else {
    return ((((-1024) & cp) === 56320) ? (("(?:" + s) + ")") : s);
  }
}
function $p_ju_regex_PatternCompiler__skipComments__V($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$2 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1 = $charAt(this$2, index);
      switch (x1) {
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          continue;
          break;
        }
        case 35: {
          $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V();
          continue;
          break;
        }
      }
    }
    break;
  }
}
function $p_ju_regex_PatternCompiler__compileRepeater__I__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((startOfRepeater === len)) {
    var repeaterDispatchChar = 46;
  } else {
    var this$2 = $n(pattern);
    var repeaterDispatchChar = $charAt(this$2, startOfRepeater);
  }
  if (((((repeaterDispatchChar === 42) || (repeaterDispatchChar === 63)) || (repeaterDispatchChar === 43)) || (repeaterDispatchChar === 123))) {
    var this$3 = $n(compiledToken);
    var x1 = $charAt(this$3, 0);
    switch (x1) {
      case 94:
      case 36: {
        var isTokenAnAssertion = true;
        break;
      }
      case 40: {
        var this$4 = $n(compiledToken);
        if (($charAt(this$4, 1) === 63)) {
          var this$5 = $n(compiledToken);
          var isTokenAnAssertion = ($charAt(this$5, 2) !== 58);
        } else {
          var isTokenAnAssertion = false;
        }
        break;
      }
      case 92: {
        var this$6 = $n(compiledToken);
        var c = $charAt(this$6, 1);
        var isTokenAnAssertion = ((c === 66) || (c === 98));
        break;
      }
      default: {
        var isTokenAnAssertion = false;
      }
    }
    var wrappedToken = (isTokenAnAssertion ? (("(?:" + compiledToken) + ")") : compiledToken);
    var baseRepeater = $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar);
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$7 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1$2 = $charAt(this$7, index);
      switch (x1$2) {
        case 43: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, wrappedToken, baseRepeater);
          break;
        }
        case 63: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return ((("" + wrappedToken) + baseRepeater) + "?");
          break;
        }
        default: {
          return (("" + wrappedToken) + baseRepeater);
        }
      }
    } else {
      return (("" + wrappedToken) + baseRepeater);
    }
  } else {
    return compiledToken;
  }
}
function $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if ((repeaterDispatchChar === 123)) {
    var this$1 = $n(pattern);
    var len = this$1.length;
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $x_1 = true;
    } else {
      var this$2 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = $charAt(this$2, index);
      var $x_1 = (!((((c - 48) | 0) >>> 0) <= 9));
    }
    if ($x_1) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    while (true) {
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
        var this$4 = $n(pattern);
        var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var c$1 = $charAt(this$4, index$1);
        var $x_2 = ((((c$1 - 48) | 0) >>> 0) <= 9);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      } else {
        break;
      }
    }
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    var this$6 = $n(pattern);
    var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    if (($charAt(this$6, index$2) === 44)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      while (true) {
        if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
          var this$7 = $n(pattern);
          var index$3 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c$2 = $charAt(this$7, index$3);
          var $x_3 = ((((c$2 - 48) | 0) >>> 0) <= 9);
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        } else {
          break;
        }
      }
    }
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $x_4 = true;
    } else {
      var this$9 = $n(pattern);
      var index$4 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var $x_4 = ($charAt(this$9, index$4) !== 125);
    }
    if ($x_4) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  }
  return $as_T(pattern.substring(startOfRepeater, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex));
}
function $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater) {
  var end = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length);
  var i = 0;
  while ((i < end)) {
    var value = i;
    var mapped = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[value]);
    if ((mapped > compiledGroupCountBeforeThisToken)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[value] = ((1 + mapped) | 0);
    }
    i = ((1 + i) | 0);
  }
  var amendedToken = $as_T(compiledToken.replace($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp, ((arg1$2, arg2$2, arg3$2) => {
    var arg1 = $as_T(arg1$2);
    var arg2 = $as_T(arg2$2);
    var arg3 = $as_T(arg3$2);
    var this$3 = $n(arg2);
    var num = this$3.length;
    var t = ((num >>> 31) | 0);
    if (((((1 & ((num + t) | 0)) - t) | 0) === 0)) {
      return arg1;
    } else {
      var groupNumber = $uI(parseInt(arg3, 10));
      return ((groupNumber > compiledGroupCountBeforeThisToken) ? (("" + arg2) + ((1 + groupNumber) | 0)) : arg1);
    }
  })));
  $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
  var myGroupNumber = ((1 + compiledGroupCountBeforeThisToken) | 0);
  return ((((("(?:(?=(" + amendedToken) + baseRepeater) + "))\\") + myGroupNumber) + ")");
}
function $p_ju_regex_PatternCompiler__compileEscape__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  if ((((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0) === len)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\ at end of pattern");
  }
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var this$2 = $n(pattern);
  var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  var dispatchChar = $charAt(this$2, index);
  switch (dispatchChar) {
    case 100:
    case 68:
    case 104:
    case 72:
    case 115:
    case 83:
    case 118:
    case 86:
    case 119:
    case 87:
    case 112:
    case 80: {
      var cls = $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar);
      var x1$2 = $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_kind;
      switch (x1$2) {
        case 0: {
          return (("\\p{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break;
        }
        case 1: {
          return (("\\P{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break;
        }
        case 2: {
          return (("[" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data) + "]");
          break;
        }
        case 3: {
          return $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data);
          break;
        }
        default: {
          throw new $c_jl_AssertionError(x1$2);
        }
      }
      break;
    }
    case 98: {
      if (($as_T(pattern.substring($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0))) === "b{g}")) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\b{g} is not supported");
      } else if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\b with UNICODE_CASE", "2018");
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\b";
      }
      break;
    }
    case 66: {
      if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\B with UNICODE_CASE", "2018");
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\B";
      }
      break;
    }
    case 65: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "^";
      break;
    }
    case 71: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\G in the middle of a pattern is not supported");
      break;
    }
    case 90: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var lineTerminator = (((1 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "(?:\r\n?|[\n\u0085\u2028\u2029])");
      return (("(?=" + lineTerminator) + "?$)");
      break;
    }
    case 122: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "$";
      break;
    }
    case 82: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:\r\n|[\n-\r\u0085\u2028\u2029])";
      break;
    }
    case 88: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\X is not supported");
      break;
    }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57: {
      var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var end = ((1 + start) | 0);
      while (true) {
        if ((end !== len)) {
          var this$7 = $n(pattern);
          var index$1 = end;
          var c = $charAt(this$7, index$1);
          var $x_2 = ((((c - 48) | 0) >>> 0) <= 9);
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var s = $as_T(pattern.substring(start, ((1 + end) | 0)));
          var $x_1 = ($uI(parseInt(s, 10)) <= (($uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length) - 1) | 0));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          end = ((1 + end) | 0);
        } else {
          break;
        }
      }
      var groupString = $as_T(pattern.substring(start, end));
      var groupNumber = $uI(parseInt(groupString, 10));
      if ((groupNumber > (($uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length) - 1) | 0))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("numbered capturing group <" + groupNumber) + "> does not exist"));
      }
      var compiledGroupNumber = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
      return (("(?:\\" + compiledGroupNumber) + ")");
      break;
    }
    case 107: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
        var $x_3 = true;
      } else {
        var this$11 = $n(pattern);
        var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var $x_3 = ($charAt(this$11, index$2) !== 60);
      }
      if ($x_3) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\k is not followed by '<' for named capturing group");
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var groupName = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
      var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
      if ((!$uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, groupName)))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + groupName) + "> does not exit"));
      }
      var groupNumber$2 = $uI(dict[groupName]);
      var compiledGroupNumber$2 = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber$2]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (("(?:\\" + compiledGroupNumber$2) + ")");
      break;
    }
    case 81: {
      var start$2 = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var this$13 = $n(pattern);
      var end$2 = $uI(this$13.indexOf("\\E", start$2));
      if ((end$2 < 0)) {
        var this$14 = $n(pattern);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = this$14.length;
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2)));
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end$2) | 0);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2, end$2)));
      }
      break;
    }
    default: {
      return $p_ju_regex_PatternCompiler__literal__I__T($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz));
    }
  }
}
function $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var x1 = $f_T__codePointAt__I__I($n(pattern), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
  switch (x1) {
    case 48: {
      return $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz);
      break;
    }
    case 120: {
      return $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz);
      break;
    }
    case 117: {
      return $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz);
      break;
    }
    case 78: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\N is not supported");
      break;
    }
    case 97: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 7;
      break;
    }
    case 116: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 9;
      break;
    }
    case 110: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 10;
      break;
    }
    case 102: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 12;
      break;
    }
    case 114: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 13;
      break;
    }
    case 101: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 27;
      break;
    }
    case 99: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var $x_1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var this$1 = $n(pattern);
      if (($x_1 === this$1.length)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal control escape sequence");
      }
      var cp = $f_T__codePointAt__I__I($n(pattern), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cp >= 65536) ? 2 : 1)) | 0);
      return (64 ^ cp);
      break;
    }
    default: {
      if ((((((x1 - 65) | 0) >>> 0) <= 25) || ((((x1 - 97) | 0) >>> 0) <= 25))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal/unsupported escape sequence");
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      return x1;
    }
  }
}
function $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) < len)) {
    var this$2 = $n(pattern);
    var index = ((1 + start) | 0);
    var d1 = (($charAt(this$2, index) - 48) | 0);
  } else {
    var d1 = (-1);
  }
  if (((d1 >>> 0) > 7)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal octal escape sequence");
  }
  if ((((2 + start) | 0) < len)) {
    var this$3 = $n(pattern);
    var index$1 = ((2 + start) | 0);
    var d2 = (($charAt(this$3, index$1) - 48) | 0);
  } else {
    var d2 = (-1);
  }
  if (((d2 >>> 0) > 7)) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return d1;
  } else if ((d1 > 3)) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return (((d1 << 3) + d2) | 0);
  } else {
    if ((((3 + start) | 0) < len)) {
      var this$4 = $n(pattern);
      var index$2 = ((3 + start) | 0);
      var d3 = (($charAt(this$4, index$2) - 48) | 0);
    } else {
      var d3 = (-1);
    }
    if (((d3 >>> 0) > 7)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((d1 << 3) + d2) | 0);
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((((d1 << 6) + (d2 << 3)) | 0) + d3) | 0);
    }
  }
}
function $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if ((start !== len)) {
    var this$2 = $n(pattern);
    var $x_1 = ($charAt(this$2, start) === 123);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var innerStart = ((1 + start) | 0);
    var this$3 = $n(pattern);
    var innerEnd = $uI(this$3.indexOf("}", innerStart));
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed hexadecimal escape sequence");
    }
    var cp = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, innerStart, innerEnd, "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + innerEnd) | 0);
    return cp;
  } else {
    var cp$2 = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, ((2 + start) | 0), "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + start) | 0);
    return cp$2;
  }
}
function $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var end = ((4 + start) | 0);
  var codeUnit = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, "Unicode");
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
  var lowStart = ((2 + end) | 0);
  var lowEnd = ((4 + lowStart) | 0);
  if (((((-1024) & codeUnit) === 55296) && ($as_T(pattern.substring(end, lowStart)) === "\\u"))) {
    var low = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, lowStart, lowEnd, "Unicode");
    if ((((-1024) & low) === 56320)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = lowEnd;
      return ((((64 + (1023 & codeUnit)) | 0) << 10) | (1023 & low));
    } else {
      return codeUnit;
    }
  } else {
    return codeUnit;
  }
}
function $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, nameForError) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  if (((end === start) || (end > len))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
  }
  var i = start;
  while ((i < end)) {
    var value = i;
    var this$4 = $n(pattern);
    var c = $charAt(this$4, value);
    if ((!((((((c - 48) | 0) >>> 0) <= 9) || ((((c - 65) | 0) >>> 0) <= 5)) || ((((c - 97) | 0) >>> 0) <= 5)))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
    }
    i = ((1 + i) | 0);
  }
  if ((((end - start) | 0) > 6)) {
    var cp = 1114112;
  } else {
    var s = $as_T(pattern.substring(start, end));
    var cp = $uI(parseInt(s, 16));
  }
  if ((cp > 1114111)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Hexadecimal codepoint is too big");
  }
  return cp;
}
function $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar) {
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  switch (dispatchChar) {
    case 100:
    case 68: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit;
      break;
    }
    case 104:
    case 72: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace;
      break;
    }
    case 115:
    case 83: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace;
      break;
    }
    case 118:
    case 86: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace;
      break;
    }
    case 119:
    case 87: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar;
      break;
    }
    case 112:
    case 80: {
      var positive = $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz);
      break;
    }
    default: {
      var positive;
      throw new $c_jl_AssertionError($bC(dispatchChar));
    }
  }
  return ((dispatchChar >= 97) ? positive : $n(positive).negated__ju_regex_PatternCompiler$CompiledCharClass());
}
function $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((start === len)) {
    var property = "?";
  } else {
    var this$2 = $n(pattern);
    if (($charAt(this$2, start) === 123)) {
      var innerStart = ((1 + start) | 0);
      var this$3 = $n(pattern);
      var innerEnd = $uI(this$3.indexOf("}", innerStart));
      if ((innerEnd < 0)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character family");
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = innerEnd;
      var property = $as_T(pattern.substring(innerStart, innerEnd));
    } else {
      var property = $as_T(pattern.substring(start, ((1 + start) | 0)));
    }
  }
  var dict = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  if ((!$uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, property)))) {
    $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Unicode character family", "2018");
  }
  var property2 = ((((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2) && ((property === "Lower") || (property === "Upper"))) ? "Alpha" : property);
  var dict$1 = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  var result = $as_ju_regex_PatternCompiler$CompiledCharClass(dict$1[property2]);
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  return result;
}
function $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var this$2 = $n(pattern);
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var isNegated = ($charAt(this$2, index) === 94);
  } else {
    var isNegated = false;
  }
  if (isNegated) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  }
  var builder = new $c_ju_regex_PatternCompiler$CharacterClassBuilder(((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2), isNegated);
  while (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var x1 = $f_T__codePointAt__I__I($n(pattern), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (x1) {
        case 93: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return builder.finish__T();
          break;
        }
        case 38: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
            var this$3 = $n(pattern);
            var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
            var $x_1 = ($charAt(this$3, index$1) === 38);
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            builder.startNewConjunct__V();
            break matchResult;
          } else {
            $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, 38, len, pattern, builder);
            break matchResult;
          }
          break;
        }
        case 91: {
          var cls = $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz);
          $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(builder, cls);
          break matchResult;
          break;
        }
        case 92: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
            $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal escape sequence");
          }
          var this$4 = $n(pattern);
          var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c2 = $charAt(this$4, index$2);
          switch (c2) {
            case 100:
            case 68:
            case 104:
            case 72:
            case 115:
            case 83:
            case 118:
            case 86:
            case 119:
            case 87:
            case 112:
            case 80: {
              builder.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V($p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, c2));
              break matchResult;
              break;
            }
            case 81: {
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
              var this$5 = $n(pattern);
              var fromIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
              var end = $uI(this$5.indexOf("\\E", fromIndex));
              if ((end < 0)) {
                $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
              }
              builder.addCodePointsInString__T__I__I__V(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, end);
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end) | 0);
              break matchResult;
              break;
            }
            default: {
              $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz), len, pattern, builder);
              break matchResult;
            }
          }
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            break matchResult;
          }
          break;
        }
        case 35: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V();
            break matchResult;
          }
          break;
        }
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, x1, len, pattern, builder);
    }
  }
  $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
}
function $p_ju_regex_PatternCompiler__compileGroup__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) === len)) {
    var $x_1 = true;
  } else {
    var this$2 = $n(pattern);
    var index = ((1 + start) | 0);
    var $x_1 = ($charAt(this$2, index) !== 63);
  }
  if ($x_1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + start) | 0);
    $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
    return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")");
  } else {
    if ((((2 + start) | 0) === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
    }
    var this$3 = $n(pattern);
    var index$1 = ((2 + start) | 0);
    var c1 = $charAt(this$3, index$1);
    if ((((c1 === 58) || (c1 === 61)) || (c1 === 33))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      return ((("" + $as_T(pattern.substring(start, ((3 + start) | 0)))) + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")");
    } else if ((c1 === 60)) {
      if ((((3 + start) | 0) === len)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
      }
      var this$4 = $n(pattern);
      var index$2 = ((3 + start) | 0);
      var c2 = $charAt(this$4, index$2);
      if ((((((c2 - 65) | 0) >>> 0) <= 25) || ((((c2 - 97) | 0) >>> 0) <= 25))) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
        var name = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
        var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        if ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, name))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + name) + "> is already defined"));
        }
        $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
        var dict$1 = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        var value = (($uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length) - 1) | 0);
        dict$1[name] = value;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")");
      } else {
        if (((c2 !== 33) && (c2 !== 61))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unknown look-behind group");
        }
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Look-behind group", "2018");
      }
    } else if ((c1 === 62)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
      var groupNumber = $thiz.ju_regex_PatternCompiler__f_compiledGroupCount;
      return (((("(?:(?=(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + "))\\") + groupNumber) + ")");
    } else {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Embedded flag expression in the middle of a pattern is not supported");
    }
  }
}
function $p_ju_regex_PatternCompiler__parseGroupName__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$2 = $n(pattern);
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = $charAt(this$2, index);
      var $x_1 = ((((((c - 65) | 0) >>> 0) <= 25) || ((((c - 97) | 0) >>> 0) <= 25)) || ((((c - 48) | 0) >>> 0) <= 9));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    } else {
      break;
    }
  }
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
    var $x_2 = true;
  } else {
    var this$4 = $n(pattern);
    var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $x_2 = ($charAt(this$4, index$1) !== 62);
  }
  if ($x_2) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "named capturing group is missing trailing '>'");
  }
  return $as_T(pattern.substring(start, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex));
}
function $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, startCodePoint, len$2, pattern$3, builder$1) {
  if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__skipComments__V($thiz);
  }
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len$2)) {
    var this$1 = $n(pattern$3);
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $x_1 = ($charAt(this$1, index) === 45);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $p_ju_regex_PatternCompiler__skipComments__V($thiz);
    }
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len$2)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
    }
    var cpEnd = $f_T__codePointAt__I__I($n(pattern$3), $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    if (((cpEnd === 91) || (cpEnd === 93))) {
      $n(builder$1).addSingleCodePoint__I__V(startCodePoint);
      $n(builder$1).addSingleCodePoint__I__V(45);
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cpEnd >= 65536) ? 2 : 1)) | 0);
      var endCodePoint = ((cpEnd === 92) ? $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) : cpEnd);
      if ((endCodePoint < startCodePoint)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal character range");
      }
      $n(builder$1).addCodePointRange__I__I__V(startCodePoint, endCodePoint);
    }
  } else {
    $n(builder$1).addSingleCodePoint__I__V(startCodePoint);
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler(pattern, flags) {
  this.ju_regex_PatternCompiler__f_pattern = null;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = 0;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = null;
  this.ju_regex_PatternCompiler__f_namedGroups = null;
  this.ju_regex_PatternCompiler__f_pattern = pattern;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = flags;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = [0];
  this.ju_regex_PatternCompiler__f_namedGroups = ({});
}
$c_ju_regex_PatternCompiler.prototype = new $h_O();
$c_ju_regex_PatternCompiler.prototype.constructor = $c_ju_regex_PatternCompiler;
/** @constructor */
function $h_ju_regex_PatternCompiler() {
}
$h_ju_regex_PatternCompiler.prototype = $c_ju_regex_PatternCompiler.prototype;
$c_ju_regex_PatternCompiler.prototype.compile__ju_regex_Pattern = (function() {
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags);
  }
  var isLiteral = ((16 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0);
  if ((!isLiteral)) {
    $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V(this);
  }
  if (((128 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "CANON_EQ is not supported");
  }
  if (((8 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("MULTILINE", "2018");
  }
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("UNICODE_CHARACTER_CLASS", "2018");
  }
  if (isLiteral) {
    var jsPattern = $p_ju_regex_PatternCompiler__literal__T__T(this, this.ju_regex_PatternCompiler__f_pattern);
  } else {
    if (($as_T(this.ju_regex_PatternCompiler__f_pattern.substring(this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0))) === "\\G")) {
      this.ju_regex_PatternCompiler__f_sticky = true;
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    }
    var jsPattern = this.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(false);
  }
  var baseJSFlags = ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "us" : "u");
  var jsFlags = (((66 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 66) ? (baseJSFlags + "i") : baseJSFlags);
  return new $c_ju_regex_Pattern(this.ju_regex_PatternCompiler__f_pattern, this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags, jsPattern, jsFlags, this.ju_regex_PatternCompiler__f_sticky, (($uI(this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length) - 1) | 0), this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap, this.ju_regex_PatternCompiler__f_namedGroups);
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E = (function(purpose, es) {
  $p_ju_regex_PatternCompiler__parseError__T__E(this, (((((((purpose + " is not supported because it requires RegExp features of ECMAScript ") + es) + ".\n") + ((("If you only target environments with ES" + es) + "+, you can enable ES") + es)) + " features with\n") + ("  scalaJSLinkerConfig ~= { _.withESFeatures(_.withESVersion(ESVersion.ES" + es)) + ")) }\nor an equivalent configuration depending on your build tool."));
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T = (function(insideGroup) {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  var result = "";
  while ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var dispatchCP = $f_T__codePointAt__I__I($n(pattern), this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (dispatchCP) {
        case 41: {
          if ((!insideGroup)) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unmatched closing ')'");
          }
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return result;
          break;
        }
        case 124: {
          if ((this.ju_regex_PatternCompiler__f_sticky && (!insideGroup))) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "\\G is not supported when there is an alternative at the top level");
          }
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          result = (result + "|");
          break matchResult;
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            break matchResult;
          }
          break;
        }
        case 35: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.java$util$regex$PatternCompiler$$skipSharpComment__V();
            break matchResult;
          }
          break;
        }
        case 63:
        case 42:
        case 43:
        case 123: {
          $p_ju_regex_PatternCompiler__parseError__T__E(this, (("Dangling meta character '" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(dispatchCP)) + "'"));
          break;
        }
      }
      var compiledGroupCountBeforeThisToken = this.ju_regex_PatternCompiler__f_compiledGroupCount;
      switch (dispatchCP) {
        case 92: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileEscape__T(this);
          break;
        }
        case 91: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileCharacterClass__T(this);
          break;
        }
        case 40: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileGroup__T(this);
          break;
        }
        case 94: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "^";
          break;
        }
        case 36: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "$";
          break;
        }
        case 46: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var rejected = (((32 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "" : (((1 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "\n\r\u0085\u2028\u2029"));
          var compiledToken = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(rejected);
          break;
        }
        default: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
          var compiledToken = $p_ju_regex_PatternCompiler__literal__I__T(this, dispatchCP);
        }
      }
      result = (("" + result) + $p_ju_regex_PatternCompiler__compileRepeater__I__T__T(this, compiledGroupCountBeforeThisToken, compiledToken));
    }
  }
  if (insideGroup) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unclosed group");
  }
  return result;
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$skipSharpComment__V = (function() {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var this$1 = $n(pattern);
  var len = this$1.length;
  while (true) {
    if ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var this$2 = $n(pattern);
      var index = this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = $charAt(this$2, index);
      var $x_1 = (!(((((c === 10) || (c === 13)) || (c === 133)) || (c === 8232)) || (c === 8233)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    } else {
      break;
    }
  }
});
var $d_ju_regex_PatternCompiler = new $TypeData().initClass($c_ju_regex_PatternCompiler, "java.util.regex.PatternCompiler", ({
  ju_regex_PatternCompiler: 1
}));
function $p_ju_regex_PatternCompiler$__featureTest__T__Z($thiz, flags) {
  try {
    new RegExp("", flags);
    return true;
  } catch (e) {
    return false;
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler$() {
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = null;
  $n_ju_regex_PatternCompiler$ = this;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = new RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = new RegExp("(\\\\+)(\\d+)", "g");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "us");
  $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "d");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "Nd");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t \u00a0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "White_Space");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\n-\r\u0085\u2028\u2029");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-zA-Z_0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\\p{Alphabetic}\\p{Mn}\\p{Me}\\p{Mc}\\p{Nd}\\p{Pc}\\p{Join_Control}");
  var r = ({});
  var value = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-z");
  r.Lower = value;
  var value$1 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Z");
  r.Upper = value$1;
  var value$2 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u007f");
  r.ASCII = value$2;
  var value$3 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Za-z");
  r.Alpha = value$3;
  var value$4 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  r.Digit = value$4;
  var value$5 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Za-z");
  r.Alnum = value$5;
  var value$6 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-/:-@[-`{-~");
  r.Punct = value$6;
  var value$7 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-~");
  r.Graph = value$7;
  var value$8 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, " -~");
  r.Print = value$8;
  var value$9 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t ");
  r.Blank = value$9;
  var value$10 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u001f\u007f");
  r.Cntrl = value$10;
  var value$11 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Fa-f");
  r.XDigit = value$11;
  var value$12 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  r.Space = value$12;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = r;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = new RegExp("(?:^|_)[a-z]", "g");
}
$c_ju_regex_PatternCompiler$.prototype = new $h_O();
$c_ju_regex_PatternCompiler$.prototype.constructor = $c_ju_regex_PatternCompiler$;
/** @constructor */
function $h_ju_regex_PatternCompiler$() {
}
$h_ju_regex_PatternCompiler$.prototype = $c_ju_regex_PatternCompiler$.prototype;
$c_ju_regex_PatternCompiler$.prototype.compile__T__I__ju_regex_Pattern = (function(regex, flags) {
  return new $c_ju_regex_PatternCompiler(regex, flags).compile__ju_regex_Pattern();
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$charToFlag__C__I = (function(c) {
  switch (c) {
    case 105: {
      return 2;
      break;
    }
    case 100: {
      return 1;
      break;
    }
    case 109: {
      return 8;
      break;
    }
    case 115: {
      return 32;
      break;
    }
    case 117: {
      return 64;
      break;
    }
    case 120: {
      return 4;
      break;
    }
    case 85: {
      return 256;
      break;
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "bad in-pattern flag");
    }
  }
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointNotAmong__T__T = (function(characters) {
  return ((characters !== "") ? (("[^" + characters) + "]") : ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "." : "[\\d\\D]"));
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointToString__I__T = (function(codePoint) {
  return $as_T(String.fromCodePoint(codePoint));
});
var $d_ju_regex_PatternCompiler$ = new $TypeData().initClass($c_ju_regex_PatternCompiler$, "java.util.regex.PatternCompiler$", ({
  ju_regex_PatternCompiler$: 1
}));
var $n_ju_regex_PatternCompiler$;
function $m_ju_regex_PatternCompiler$() {
  if ((!$n_ju_regex_PatternCompiler$)) {
    $n_ju_regex_PatternCompiler$ = new $c_ju_regex_PatternCompiler$();
  }
  return $n_ju_regex_PatternCompiler$;
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V($thiz, alt) {
  if (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "")) {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = alt;
  } else {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct + "|") + alt);
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T($thiz) {
  if ($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated) {
    var negThisSegment = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? negThisSegment : (((("(?:(?!" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")") + negThisSegment) + ")"));
  } else {
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment === "") ? (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? "[^\\d\\D]" : (("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")")) : (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? (("[" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "]") : (((("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + "|[") + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "])")));
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T($thiz, codePoint) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(codePoint);
  return (((((((codePoint - 92) | 0) >>> 0) <= 1) || (codePoint === 45)) || (codePoint === 94)) ? ("\\" + s) : s);
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CharacterClassBuilder(asciiCaseInsensitive, isNegated) {
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = asciiCaseInsensitive;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = isNegated;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = "";
}
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.constructor = $c_ju_regex_PatternCompiler$CharacterClassBuilder;
/** @constructor */
function $h_ju_regex_PatternCompiler$CharacterClassBuilder() {
}
$h_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = $c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype;
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.finish__T = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  return ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction === "") ? conjunct : ((("(?:" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction) + conjunct) + ")"));
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.startNewConjunct__V = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction + (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated ? (conjunct + "|") : (("(?=" + conjunct) + ")")));
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = "";
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V = (function(cls) {
  var x1 = $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_kind;
  switch (x1) {
    case 0: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\p{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break;
    }
    case 1: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\P{" + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break;
    }
    case 2: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data);
      break;
    }
    case 3: {
      $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(this, $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($n(cls).ju_regex_PatternCompiler$CompiledCharClass__f_data));
      break;
    }
    default: {
      throw new $c_jl_AssertionError(x1);
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointsInString__T__I__I__V = (function(str, start, end) {
  var i = start;
  while ((i !== end)) {
    var codePoint = $f_T__codePointAt__I__I($n(str), i);
    this.addSingleCodePoint__I__V(codePoint);
    i = ((i + ((codePoint >= 65536) ? 2 : 1)) | 0);
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addSingleCodePoint__I__V = (function(codePoint) {
  var s = $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, codePoint);
  if ((((-1024) & codePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + s) + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + s);
  }
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    if (((((codePoint - 65) | 0) >>> 0) <= 25)) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + codePoint) | 0)));
    } else if (((((codePoint - 97) | 0) >>> 0) <= 25)) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((codePoint - 32) | 0)));
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointRange__I__I__V = (function(startCodePoint, endCodePoint) {
  var s = (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, startCodePoint) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, endCodePoint));
  if ((((-1024) & startCodePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (s + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + s);
  }
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    var start = ((startCodePoint > 65) ? startCodePoint : 65);
    var end = ((endCodePoint < 90) ? endCodePoint : 90);
    if ((start <= end)) {
      var $x_1 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$1 = ((32 + start) | 0);
      var end$1 = ((32 + end) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($x_1 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$1) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$1)));
    }
    var start$2 = ((startCodePoint > 97) ? startCodePoint : 97);
    var end$2 = ((endCodePoint < 122) ? endCodePoint : 122);
    if ((start$2 <= end$2)) {
      var $x_2 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$3 = ((start$2 - 32) | 0);
      var end$3 = ((end$2 - 32) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($x_2 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$3) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$3)));
    }
  }
});
var $d_ju_regex_PatternCompiler$CharacterClassBuilder = new $TypeData().initClass($c_ju_regex_PatternCompiler$CharacterClassBuilder, "java.util.regex.PatternCompiler$CharacterClassBuilder", ({
  ju_regex_PatternCompiler$CharacterClassBuilder: 1
}));
function $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  if ((!$thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0)) {
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated = new $c_ju_regex_PatternCompiler$CompiledCharClass((1 ^ $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_kind), $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_data);
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = true;
  }
  return $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated;
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CompiledCharClass(kind, data) {
  this.ju_regex_PatternCompiler$CompiledCharClass__f_negated = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = 0;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = false;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = kind;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = data;
}
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.constructor = $c_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $h_ju_regex_PatternCompiler$CompiledCharClass() {
}
$h_ju_regex_PatternCompiler$CompiledCharClass.prototype = $c_ju_regex_PatternCompiler$CompiledCharClass.prototype;
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.negated__ju_regex_PatternCompiler$CompiledCharClass = (function() {
  return ((!this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0) ? $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass(this) : this.ju_regex_PatternCompiler$CompiledCharClass__f_negated);
});
function $as_ju_regex_PatternCompiler$CompiledCharClass(obj) {
  return (((obj instanceof $c_ju_regex_PatternCompiler$CompiledCharClass) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.regex.PatternCompiler$CompiledCharClass"));
}
function $isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_regex_PatternCompiler$CompiledCharClass)));
}
function $asArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (($isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.regex.PatternCompiler$CompiledCharClass;", depth));
}
var $d_ju_regex_PatternCompiler$CompiledCharClass = new $TypeData().initClass($c_ju_regex_PatternCompiler$CompiledCharClass, "java.util.regex.PatternCompiler$CompiledCharClass", ({
  ju_regex_PatternCompiler$CompiledCharClass: 1
}));
/** @constructor */
function $c_Llocales_DefaultLocale$() {
  this.Llocales_DefaultLocale$__f_window$lzy1 = null;
  this.Llocales_DefaultLocale$__f_windowbitmap$1 = false;
}
$c_Llocales_DefaultLocale$.prototype = new $h_O();
$c_Llocales_DefaultLocale$.prototype.constructor = $c_Llocales_DefaultLocale$;
/** @constructor */
function $h_Llocales_DefaultLocale$() {
}
$h_Llocales_DefaultLocale$.prototype = $c_Llocales_DefaultLocale$.prototype;
$c_Llocales_DefaultLocale$.prototype.window__Llocales_Window = (function() {
  if ((!this.Llocales_DefaultLocale$__f_windowbitmap$1)) {
    this.Llocales_DefaultLocale$__f_window$lzy1 = window;
    this.Llocales_DefaultLocale$__f_windowbitmap$1 = true;
  }
  return this.Llocales_DefaultLocale$__f_window$lzy1;
});
$c_Llocales_DefaultLocale$.prototype.platformLocale__ju_Locale = (function() {
  try {
    var value = $as_T(this.window__Llocales_Window().navigator.language);
    var lang = new $c_s_Some(value);
  } catch (e) {
    var lang = $m_s_None$();
  }
  if (lang.isEmpty__Z()) {
    var $x_1 = true;
  } else {
    var x0 = lang.get__O();
    var key = $as_T(x0);
    var $x_1 = $n($m_Llocales_LocalesDb$().Llocales_LocalesDb$__f_ldmls).contains__O__Z(key);
  }
  if ($x_1) {
    var this$3 = lang;
  } else {
    var this$3 = $m_s_None$();
  }
  var l = $as_T((this$3.isEmpty__Z() ? "en" : this$3.get__O()));
  var this$4 = $n($m_Llocales_LocalesDb$().localeForLanguageTag__T__s_Option(l));
  return $as_ju_Locale((this$4.isEmpty__Z() ? $n($m_Llocales_LocalesDb$().Llocales_LocalesDb$__f_root).toLocale__ju_Locale() : this$4.get__O()));
});
var $d_Llocales_DefaultLocale$ = new $TypeData().initClass($c_Llocales_DefaultLocale$, "locales.DefaultLocale$", ({
  Llocales_DefaultLocale$: 1
}));
var $n_Llocales_DefaultLocale$;
function $m_Llocales_DefaultLocale$() {
  if ((!$n_Llocales_DefaultLocale$)) {
    $n_Llocales_DefaultLocale$ = new $c_Llocales_DefaultLocale$();
  }
  return $n_Llocales_DefaultLocale$;
}
/** @constructor */
function $c_Llocales_LocalesDb$() {
  this.Llocales_LocalesDb$__f_provider = null;
  this.Llocales_LocalesDb$__f_root = null;
  this.Llocales_LocalesDb$__f_ldmls = null;
  $n_Llocales_LocalesDb$ = this;
  var this$2 = $m_sjs_reflect_Reflect$();
  var this$3 = $n($n(this$2.sjs_reflect_Reflect$__f_loadableModuleClasses).get__O__s_Option("locales.cldr.data.LocalesProvider$"));
  if (this$3.isEmpty__Z()) {
    var this$4 = $m_s_None$();
  } else {
    var x0 = this$3.get__O();
    var m = $as_sjs_reflect_LoadableModuleClass(x0);
    var this$4 = new $c_s_Some($as_Llocales_cldr_LocalesProvider($n(m).loadModule__O()));
  }
  this.Llocales_LocalesDb$__f_provider = $as_Llocales_cldr_LocalesProvider((this$4.isEmpty__Z() ? $m_Llocales_cldr_fallback_LocalesProvider$() : this$4.get__O()));
  this.Llocales_LocalesDb$__f_root = ($n(this.Llocales_LocalesDb$__f_provider), $m_Llocales_cldr_fallback_data_\uff3froot$());
  $n(this.Llocales_LocalesDb$__f_provider);
  $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  this.Llocales_LocalesDb$__f_ldmls = $n(this.Llocales_LocalesDb$__f_provider).ldmls__sci_Map();
  $n(this.Llocales_LocalesDb$__f_provider).metadata__Llocales_cldr_CLDRMetadata();
  $n(this.Llocales_LocalesDb$__f_provider).currencyData__Llocales_cldr_CurrencyData();
}
$c_Llocales_LocalesDb$.prototype = new $h_O();
$c_Llocales_LocalesDb$.prototype.constructor = $c_Llocales_LocalesDb$;
/** @constructor */
function $h_Llocales_LocalesDb$() {
}
$h_Llocales_LocalesDb$.prototype = $c_Llocales_LocalesDb$.prototype;
$c_Llocales_LocalesDb$.prototype.localeForLanguageTag__T__s_Option = (function(languageTag) {
  if ((languageTag === "und")) {
    var value = $m_ju_Locale$().ROOT__ju_Locale();
    return new $c_s_Some(value);
  } else {
    var this$2 = $n($n($n(this.Llocales_LocalesDb$__f_provider).ldmls__sci_Map()).get__O__s_Option(languageTag));
    if (this$2.isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var x0 = this$2.get__O();
      var _$1 = $as_Llocales_cldr_LDML(x0);
      return new $c_s_Some($n(_$1).toLocale__ju_Locale());
    }
  }
});
var $d_Llocales_LocalesDb$ = new $TypeData().initClass($c_Llocales_LocalesDb$, "locales.LocalesDb$", ({
  Llocales_LocalesDb$: 1
}));
var $n_Llocales_LocalesDb$;
function $m_Llocales_LocalesDb$() {
  if ((!$n_Llocales_LocalesDb$)) {
    $n_Llocales_LocalesDb$ = new $c_Llocales_LocalesDb$();
  }
  return $n_Llocales_LocalesDb$;
}
function $is_Llocales_cldr_LocalesProvider(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Llocales_cldr_LocalesProvider)));
}
function $as_Llocales_cldr_LocalesProvider(obj) {
  return (($is_Llocales_cldr_LocalesProvider(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.LocalesProvider"));
}
function $isArrayOf_Llocales_cldr_LocalesProvider(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LocalesProvider)));
}
function $asArrayOf_Llocales_cldr_LocalesProvider(obj, depth) {
  return (($isArrayOf_Llocales_cldr_LocalesProvider(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.LocalesProvider;", depth));
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all$lzy1 = null;
  this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_allbitmap$1 = false;
}
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = new $h_O();
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
}
$h_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype;
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.all__ALlocales_cldr_LDML = (function() {
  if ((!this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_allbitmap$1)) {
    this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all$lzy1 = new ($d_Llocales_cldr_LDML.getArrayOf().constr)([$m_Llocales_cldr_fallback_data_\uff3fen$(), $m_Llocales_cldr_fallback_data_\uff3froot$()]);
    this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_allbitmap$1 = true;
  }
  return this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all$lzy1;
});
var $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $TypeData().initClass($c_Llocales_cldr_fallback_data_\uff3fall\uff3f$, "locales.cldr.fallback.data._all_$", ({
  Llocales_cldr_fallback_data_\uff3fall\uff3f$: 1
}));
var $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
function $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fall\uff3f$)) {
    $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$();
  }
  return $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_numericsystems$() {
  this.Llocales_cldr_fallback_data_numericsystems$__f_latn$lzy1 = null;
  this.Llocales_cldr_fallback_data_numericsystems$__f_latnbitmap$1 = false;
}
$c_Llocales_cldr_fallback_data_numericsystems$.prototype = new $h_O();
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.constructor = $c_Llocales_cldr_fallback_data_numericsystems$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_numericsystems$() {
}
$h_Llocales_cldr_fallback_data_numericsystems$.prototype = $c_Llocales_cldr_fallback_data_numericsystems$.prototype;
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.latn__Llocales_cldr_NumberingSystem = (function() {
  if ((!this.Llocales_cldr_fallback_data_numericsystems$__f_latnbitmap$1)) {
    var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([48, 49, 50, 51, 52, 53, 54, 55, 56, 57])));
    var digits = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    this.Llocales_cldr_fallback_data_numericsystems$__f_latn$lzy1 = new $c_Llocales_cldr_NumberingSystem("latn", digits);
    this.Llocales_cldr_fallback_data_numericsystems$__f_latnbitmap$1 = true;
  }
  return this.Llocales_cldr_fallback_data_numericsystems$__f_latn$lzy1;
});
var $d_Llocales_cldr_fallback_data_numericsystems$ = new $TypeData().initClass($c_Llocales_cldr_fallback_data_numericsystems$, "locales.cldr.fallback.data.numericsystems$", ({
  Llocales_cldr_fallback_data_numericsystems$: 1
}));
var $n_Llocales_cldr_fallback_data_numericsystems$;
function $m_Llocales_cldr_fallback_data_numericsystems$() {
  if ((!$n_Llocales_cldr_fallback_data_numericsystems$)) {
    $n_Llocales_cldr_fallback_data_numericsystems$ = new $c_Llocales_cldr_fallback_data_numericsystems$();
  }
  return $n_Llocales_cldr_fallback_data_numericsystems$;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_Dag$() {
}
$c_Lnet_andimiller_hedgehogs_Dag$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_Dag$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_Dag$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_Dag$() {
}
$h_Lnet_andimiller_hedgehogs_Dag$.prototype = $c_Lnet_andimiller_hedgehogs_Dag$.prototype;
$c_Lnet_andimiller_hedgehogs_Dag$.prototype.validate__Lnet_andimiller_hedgehogs_SimpleGraph__Lcats_Eval = (function(g) {
  var this$1 = $n(g);
  var hasInbound = $as_sci_Set($n($n(this$1.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).keySet__sci_Set()).filter__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((id) => {
    var this$2 = $n($n(g).inbound__O__sci_Set(id));
    return (!this$2.isEmpty__Z());
  }))));
  var this$3 = $n(g);
  var this$4 = $n($n(this$3.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).keySet__sci_Set());
  var removeMe = $as_sci_Set(this$4.removedAll__sc_IterableOnce__sci_SetOps(hasInbound));
  if ($n(removeMe).isEmpty__Z()) {
    var this$5 = $n(g);
    var this$6 = $n($n(this$5.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).keySet__sci_Set());
    if ((!this$6.isEmpty__Z())) {
      $m_Lcats_Eval$();
      var this$7 = $n(g);
      var this$8 = $n($n(this$7.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).keySet__sci_Set());
      var value = ("Detected cycles between: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "", ",", ""));
      var a = new $c_s_util_Left(value);
      return new $c_Lcats_Now(a);
    } else {
      $m_Lcats_Eval$();
      var a$1 = new $c_s_util_Right((void 0));
      return new $c_Lcats_Now(a$1);
    }
  } else {
    $m_Lcats_Eval$();
    var a$2 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      var this$16 = $n(removeMe);
      var f = ((_$1, _$2) => {
        var _$1$1 = $as_Lnet_andimiller_hedgehogs_SimpleGraph(_$1);
        var this$15 = $n(_$1$1);
        return this$15.removeNode__O__Lnet_andimiller_hedgehogs_DataGraph(_$2);
      });
      if ($is_sc_IndexedSeq(this$16)) {
        var x2 = $as_sc_IndexedSeq(this$16);
        var at = 0;
        var end = $n(x2).length__I();
        var acc = g;
        var $x_1;
        while (true) {
          if ((at !== end)) {
            var temp$at = ((1 + at) | 0);
            var x0 = acc;
            var x1 = $n(x2).apply__I__O(at);
            var temp$acc = f(x0, x1);
            at = temp$at;
            acc = temp$acc;
            continue;
          }
          var $x_1 = acc;
          break;
        }
      } else {
        var result = g;
        var it = this$16.iterator__sc_Iterator();
        while ($n(it).hasNext__Z()) {
          var x0$1 = result;
          var x1$1 = $n(it).next__O();
          result = f(x0$1, x1$1);
        }
        var $x_1 = result;
      }
      return $as_Lnet_andimiller_hedgehogs_SimpleGraph($x_1);
    }));
    return new $c_Lcats_Later(a$2).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((g$4) => {
      var g$1 = $as_Lnet_andimiller_hedgehogs_SimpleGraph(g$4);
      return $m_Lnet_andimiller_hedgehogs_Dag$().validate__Lnet_andimiller_hedgehogs_SimpleGraph__Lcats_Eval(g$1);
    })));
  }
});
$c_Lnet_andimiller_hedgehogs_Dag$.prototype.isDag__Lnet_andimiller_hedgehogs_SimpleGraph__Lcats_Eval = (function(g) {
  return $n(this.validate__Lnet_andimiller_hedgehogs_SimpleGraph__Lcats_Eval(g)).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
    var _$3$1 = $as_s_util_Either(_$3);
    return $n(_$3$1).isRight__Z();
  })));
});
var $d_Lnet_andimiller_hedgehogs_Dag$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_Dag$, "net.andimiller.hedgehogs.Dag$", ({
  Lnet_andimiller_hedgehogs_Dag$: 1
}));
var $n_Lnet_andimiller_hedgehogs_Dag$;
function $m_Lnet_andimiller_hedgehogs_Dag$() {
  if ((!$n_Lnet_andimiller_hedgehogs_Dag$)) {
    $n_Lnet_andimiller_hedgehogs_Dag$ = new $c_Lnet_andimiller_hedgehogs_Dag$();
  }
  return $n_Lnet_andimiller_hedgehogs_Dag$;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_DataGraph$() {
}
$c_Lnet_andimiller_hedgehogs_DataGraph$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_DataGraph$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_DataGraph$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_DataGraph$() {
}
$h_Lnet_andimiller_hedgehogs_DataGraph$.prototype = $c_Lnet_andimiller_hedgehogs_DataGraph$.prototype;
$c_Lnet_andimiller_hedgehogs_DataGraph$.prototype.empty__Lnet_andimiller_hedgehogs_DataGraph = (function() {
  return new $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph($m_sci_Map$EmptyMap$(), $m_sci_Map$EmptyMap$(), $m_s_None$(), $m_s_None$());
});
var $d_Lnet_andimiller_hedgehogs_DataGraph$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_DataGraph$, "net.andimiller.hedgehogs.DataGraph$", ({
  Lnet_andimiller_hedgehogs_DataGraph$: 1
}));
var $n_Lnet_andimiller_hedgehogs_DataGraph$;
function $m_Lnet_andimiller_hedgehogs_DataGraph$() {
  if ((!$n_Lnet_andimiller_hedgehogs_DataGraph$)) {
    $n_Lnet_andimiller_hedgehogs_DataGraph$ = new $c_Lnet_andimiller_hedgehogs_DataGraph$();
  }
  return $n_Lnet_andimiller_hedgehogs_DataGraph$;
}
function $is_Lnet_andimiller_hedgehogs_SimpleGraph(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lnet_andimiller_hedgehogs_SimpleGraph)));
}
function $as_Lnet_andimiller_hedgehogs_SimpleGraph(obj) {
  return (($is_Lnet_andimiller_hedgehogs_SimpleGraph(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.SimpleGraph"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_SimpleGraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_SimpleGraph)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_SimpleGraph(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_SimpleGraph(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.SimpleGraph;", depth));
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$.prototype.set__T__T__Lcats_effect_kernel_Sync__Ltyrian_Cmd = (function(name, value, evidence$1) {
  return $m_Ltyrian_Cmd$SideEffect$().apply__F0__Lcats_effect_kernel_Sync__Ltyrian_Cmd$SideEffect(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var root = document.documentElement;
    root.style.setProperty(name, value);
  })), evidence$1);
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$, "net.andimiller.hedgehogs.dag.visitor.CssVariables$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$;
}
function $is_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode)));
}
function $as_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode(obj) {
  return (($is_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.DagVisitor$RunMode"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.DagVisitor$RunMode;", depth));
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$.prototype.apply__Lnet_andimiller_hedgehogs_DataGraph__T = (function(g) {
  var this$1 = $n($n(g).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap);
  var this$3 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1));
  var f = ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var n = $as_T($n(x$1$1)._1__O());
      var node = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node($n(x$1$1)._2__O());
      var x = $s_Lnet_andimiller_hedgehogs_dag_visitor_Node$__Approval__Lnet_andimiller_hedgehogs_dag_visitor_Node();
      if (((x === null) ? (node === null) : $n(x).equals__O__Z(node))) {
        var shape = " shape=hexagon";
      } else {
        var shape = "";
      }
      return (((((((("  " + n) + " [id=\"") + n) + "\" fillcolor=\"var(--") + n) + "-fill)\"") + shape) + "];");
    }
    throw new $c_s_MatchError(x$1$1);
  });
  if ((this$3 === $m_sci_Nil$())) {
    var this$4 = $m_sci_Nil$();
  } else {
    var x0 = this$3.head__O();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$3.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var this$4 = h;
  }
  var $x_1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$4, "", "\n", "");
  var this$5 = $n(g);
  var this$6 = $n($as_sc_IterableOnceOps($n($n(this$5.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap).keySet__sci_Set()).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    if ((x$1$3 !== null)) {
      var from = $as_T($n(x$1$3)._1__O());
      var to = $as_T($n(x$1$3)._2__O());
      return (((("  " + from) + " -> ") + to) + ";");
    }
    throw new $c_s_MatchError(x$1$3);
  })))));
  var x$2 = (((("\n     |digraph G {\n     |  bgcolor=transparent;\n     |  node [shape=circle style=filled fontname=\"Arial\"];\n     |  edge [color=grey];\n     |\n     |  " + $x_1) + "\n     |\n     |  ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$6, "", "\n", "")) + "\n     |}\n     ");
  return $m_sc_StringOps$().stripMargin$extension__T__C__T(x$2, 124);
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$, "net.andimiller.hedgehogs.dag.visitor.Digraph$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Digraph$: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$;
}
function $is_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_NodeState)));
}
function $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(obj) {
  return (($is_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.NodeState"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_NodeState)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.NodeState;", depth));
}
function $is_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent)));
}
function $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent(obj) {
  return (($is_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.RunEvent"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.RunEvent;", depth));
}
function $is_Lnet_andimiller_hedgehogs_dag_visitor_RunResult(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunResult)));
}
function $as_Lnet_andimiller_hedgehogs_dag_visitor_RunResult(obj) {
  return (($is_Lnet_andimiller_hedgehogs_dag_visitor_RunResult(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.RunResult"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunResult)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunResult(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.RunResult;", depth));
}
function $is_Lnet_andimiller_hedgehogs_dag_visitor_StepResult(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_StepResult)));
}
function $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult(obj) {
  return (($is_Lnet_andimiller_hedgehogs_dag_visitor_StepResult(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.StepResult"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_StepResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_StepResult)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_StepResult(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_StepResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.StepResult;", depth));
}
function $p_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$__validated__Lnet_andimiller_hedgehogs_DataGraph__Lcats_effect_kernel_GenConcurrent__O($thiz, g, evidence$1) {
  var x95 = $as_s_util_Either($n($m_Lnet_andimiller_hedgehogs_Dag$().validate__Lnet_andimiller_hedgehogs_SimpleGraph__Lcats_Eval(g)).value__O());
  if ((x95 instanceof $c_s_util_Left)) {
    var err = $as_T($n($as_s_util_Left(x95)).s_util_Left__f_value);
    $m_Lcats_implicits$();
    var e = new $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag(err);
    return $n(evidence$1).raiseError__O__O(e);
  }
  if ((x95 instanceof $c_s_util_Right)) {
    var x$2 = $n($as_s_util_Right(x95)).s_util_Right__f_value;
    var $x_1 = (x$2 === (void 0));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $m_Lcats_implicits$();
    var ev$9 = (void 0);
    return $n(evidence$1).pure__O__O(ev$9);
  }
  throw new $c_s_MatchError(x95);
}
function $p_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$__runSegment__Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor__Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode__Lnet_andimiller_hedgehogs_DataGraph__sci_Map__F1__Lcats_effect_kernel_GenConcurrent__O($thiz, visitor, direction, initial, completions, events, evidence$1) {
  $m_Lcats_implicits$();
  var target = $m_Lcats_effect_std_Queue$().unbounded__Lcats_effect_kernel_GenConcurrent__O(evidence$1);
  var this$187 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, evidence$1);
  var f$26 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((completed) => {
    var completed$1 = $as_Lcats_effect_std_Queue(completed);
    $m_Lcats_implicits$();
    var mk = new $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1(evidence$1);
    var target$1 = mk.refOf__O__O(initial);
    var this$186 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, evidence$1);
    var f$25 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((stateGraph) => {
      var stateGraph$1 = $as_Lcats_effect_kernel_Ref(stateGraph);
      $m_Lcats_implicits$();
      var target$2 = $n(evidence$1).deferred__O();
      var this$185 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, evidence$1);
      var f$24 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((errored) => {
        var errored$1 = $as_Lcats_effect_kernel_Deferred(errored);
        $m_Lcats_implicits$();
        var a = $m_sci_Set$EmptySet$();
        var mk$1 = new $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1(evidence$1);
        var target$3 = mk$1.refOf__O__O(a);
        var this$184 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, evidence$1);
        var f$23 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((startedSet) => {
          var startedSet$1 = $as_Lcats_effect_kernel_Ref(startedSet);
          $m_Lcats_implicits$();
          var a$1 = $m_sci_Map$EmptyMap$();
          var mk$2 = new $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1(evidence$1);
          var target$4 = mk$2.refOf__O__O(a$1);
          var this$183 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$4, evidence$1);
          var f$22 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((backgroundTasks) => {
            var backgroundTasks$1 = $as_Lcats_effect_kernel_Ref(backgroundTasks);
            $m_Lcats_implicits$();
            $m_Lcats_implicits$();
            var target$5 = $m_Lcats_effect_std_Semaphore$().apply__J__Lcats_effect_kernel_GenConcurrent__O(1, 0, evidence$1);
            var this$122 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, evidence$1);
            var f$10 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((tickLock) => {
              var tickLock$1 = $as_Lcats_effect_std_Semaphore(tickLock);
              var isDone = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => {
                var s$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(s);
                if ((s$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
                  var x$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(s$1);
                  $n(x$1);
                  return true;
                } else {
                  return false;
                }
              }));
              var tick = $n($n(tickLock$1).permit__Lcats_effect_kernel_Resource()).use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$11) => {
                $as_jl_Void(_$11);
                $m_Lcats_implicits$();
                var target$6 = $n(errored$1).tryGet__O();
                var this$120 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$6, evidence$1);
                var f$9 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err) => {
                  var err$1 = $as_s_Option(err);
                  $m_Lcats_implicits$();
                  if ((err$1 instanceof $c_s_Some)) {
                    var e = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed($n($as_s_Some(err$1)).s_Some__f_value);
                    $m_Lcats_implicits$();
                    var target$7 = $n(evidence$1).raiseError__O__O(e);
                  } else {
                    $m_Lcats_implicits$();
                    var ev$11 = (void 0);
                    var target$7 = $n(evidence$1).pure__O__O(ev$11);
                  }
                  var this$119 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$7, evidence$1);
                  var f$8 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$1) => {
                    $as_jl_Void(x$1$1);
                    $m_Lcats_implicits$();
                    var target$8 = $n(stateGraph$1).get__O();
                    var this$118 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$8, evidence$1);
                    var f$7 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((graph) => {
                      var graph$1 = $as_Lnet_andimiller_hedgehogs_DataGraph(graph);
                      $m_Lcats_implicits$();
                      $m_Lcats_implicits$();
                      var target$9 = $n(startedSet$1).get__O();
                      var this$36 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$9, evidence$1);
                      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((started) => {
                        var started$1 = $as_sci_Set(started);
                        matchResult56$1: {
                          var getInbound;
                          var x = $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$();
                          if ((x === direction)) {
                            var getInbound = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((id) => $n(graph$1).inbound__O__sci_Set(id)));
                            break matchResult56$1;
                          }
                          var x$3 = $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$();
                          if ((x$3 === direction)) {
                            var getInbound = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((id$2) => $n(graph$1).outgoing__O__sci_Set(id$2)));
                            break matchResult56$1;
                          }
                          throw new $c_s_MatchError(direction);
                        }
                        var this$27 = $n(graph$1);
                        var runnable = $as_sci_Set($n($as_sc_IterableOps($n($as_sc_IterableOps($n($n(this$27.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).keySet__sci_Set()).filterNot__F1__O(started$1))).filter__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((id$3) => {
                          var x108 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState($n($n(graph$1).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).apply__O__O(id$3));
                          if ((x108 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)) {
                            var x$1$3 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(x108);
                            $n(x$1$3);
                            return true;
                          }
                          if ((x108 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
                            var x$1$4 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(x108);
                            $n(x$1$4);
                            $n(x$1$4);
                            return $n(completions).contains__O__Z(id$3);
                          }
                          if ((x108 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
                            var x$1$5 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x108);
                            $n(x$1$5);
                            return false;
                          }
                          throw new $c_s_MatchError(x108);
                        }))))).filter__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((id$4) => $n($as_sc_IterableOnceOps(getInbound.apply__O__O(id$4))).forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((id2) => $uZ(isDone.apply__O__O($n($n(graph$1).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).apply__O__O(id2))))))))));
                        return new $c_T3(started$1, getInbound, runnable);
                      }));
                      var target$10 = $n(this$36.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$36.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
                      var this$117 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$10, evidence$1);
                      var f$6 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$6) => {
                        var x$1$7 = $as_T3(x$1$6);
                        if ((x$1$7 !== null)) {
                          $as_sci_Set($n(x$1$7).T3__f__1);
                          var getInbound$1 = $as_F1($n(x$1$7).T3__f__2);
                          var runnable$1 = $as_sci_Set($n(x$1$7).T3__f__3);
                          $m_Lcats_implicits$();
                          $m_Lcats_implicits$();
                          var this$38 = $n(runnable$1);
                          var target$11 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$38);
                          var tc = $as_Lcats_Traverse($m_Lcats_implicits$().Lcats_implicits$__f_catsStdInstancesForList);
                          var this$114 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(target$11, tc);
                          var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((id$1) => {
                            var $x_1 = $n($as_sc_IterableOnceOps($n($as_sc_IterableOps($n($as_sc_IterableOps($n(getInbound$1).apply__O__O(id$1))).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((from) => {
                              var y = $n($n(graph$1).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).apply__O__O(from);
                              return new $c_T2(from, y);
                            }))))).collect__s_PartialFunction__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1(direction, graph$1, id$1))));
                            var this$43 = $m_s_$less$colon$less$();
                            var inputs = $x_1.toMap__s_$less$colon$less__sci_Map(this$43.s_$less$colon$less$__f_singleton);
                            var state = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState($n($n(graph$1).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).apply__O__O(id$1));
                            matchResult61$1: {
                              var announce;
                              if ((state instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)) {
                                var x$1$8 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(state);
                                $n(x$1$8);
                                var announce = $n(events).apply__O__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted(id$1));
                                break matchResult61$1;
                              }
                              if ((state instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
                                var x$1$9 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(state);
                                $n(x$1$9);
                                var this$49 = $n(x$1$9);
                                var x139 = this$49.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle;
                                var announce = $n(events).apply__O__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed(id$1, x139));
                                break matchResult61$1;
                              }
                              if ((state instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
                                var x$1$10 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(state);
                                $n(x$1$10);
                                $m_Lcats_implicits$();
                                var ev$15 = (void 0);
                                var announce = $n(evidence$1).pure__O__O(ev$15);
                                break matchResult61$1;
                              }
                              throw new $c_s_MatchError(state);
                            }
                            matchResult62$1: {
                              var step;
                              if ((state instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)) {
                                var x$1$11 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(state);
                                var this$56 = $n(x$1$11);
                                var x153 = this$56.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending__f_input;
                                var this$57 = $n(visitor);
                                var step = $f_Lnet_andimiller_hedgehogs_dag_visitor_SimpleSuspendableDagVisitor__run__O__O__Lnet_andimiller_hedgehogs_DataGraph__sci_Map__O(this$57, id$1, x153, graph$1, inputs);
                                break matchResult62$1;
                              }
                              if ((state instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
                                var x$1$12 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(state);
                                var this$59 = $n(x$1$12);
                                var x149 = this$59.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_input;
                                var this$60 = $n(x$1$12);
                                var x150 = this$60.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle;
                                var this$61 = $n(visitor);
                                var payload = $n(completions).apply__O__O(id$1);
                                var step = $f_Lnet_andimiller_hedgehogs_dag_visitor_SimpleSuspendableDagVisitor__resume__O__O__O__O__Lnet_andimiller_hedgehogs_DataGraph__sci_Map__O(this$61, id$1, x149, x150, payload, graph$1, inputs);
                                break matchResult62$1;
                              }
                              if ((state instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
                                var x$1$13 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(state);
                                $n(x$1$13);
                                $m_Lcats_implicits$();
                                var e$1 = $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), (("Done node " + id$1) + " was scheduled"));
                                var step = $n(evidence$1).raiseError__O__O(e$1);
                                break matchResult62$1;
                              }
                              throw new $c_s_MatchError(state);
                            }
                            $m_Lcats_implicits$();
                            $m_Lcats_implicits$();
                            $m_Lcats_implicits$();
                            var this$68 = $n(evidence$1);
                            var target$12 = this$68.productR__O__O__O(announce, step);
                            var this$101 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$12, evidence$1);
                            var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((result) => {
                              var result$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult(result);
                              matchResult63$1: {
                                var $x_2;
                                var x154 = new $c_T2(result$1, state);
                                var x180 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult(x154.T2__f__1);
                                var x181 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(x154.T2__f__2);
                                if ((x180 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete)) {
                                  var x$1$14 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(x180);
                                  var this$72 = $n(x$1$14);
                                  var x184 = this$72.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete__f_output;
                                  var $x_2 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x184);
                                  break matchResult63$1;
                                }
                                if ((x180 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend)) {
                                  var x$1$15 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(x180);
                                  var this$75 = $n(x$1$15);
                                  var x179 = this$75.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend__f_handle;
                                  if ((x181 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)) {
                                    var x$1$16 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(x181);
                                    var this$77 = $n(x$1$16);
                                    var x176 = this$77.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending__f_input;
                                    var $x_2 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(x176, x179);
                                    break matchResult63$1;
                                  }
                                }
                                if ((x180 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend)) {
                                  var x$1$17 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(x180);
                                  var this$80 = $n(x$1$17);
                                  var x171 = this$80.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend__f_handle;
                                  if ((x181 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
                                    var x$1$18 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(x181);
                                    var this$82 = $n(x$1$18);
                                    var x167 = this$82.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_input;
                                    $n(x$1$18);
                                    var $x_2 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(x167, x171);
                                    break matchResult63$1;
                                  }
                                }
                                if ((x180 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend)) {
                                  var x$1$19 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(x180);
                                  $n(x$1$19);
                                  if ((x181 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
                                    var x$1$20 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x181);
                                    var this$88 = $n(x$1$20);
                                    var x159 = this$88.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output;
                                    var $x_2 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x159);
                                    break matchResult63$1;
                                  }
                                }
                                throw new $c_s_MatchError(x154);
                              }
                              var newState = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState($x_2);
                              matchResult64$1: {
                                var event;
                                if ((result$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete)) {
                                  var x$1$21 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(result$1);
                                  $n(x$1$21);
                                  var event = $n(events).apply__O__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted(id$1));
                                  break matchResult64$1;
                                }
                                if ((result$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend)) {
                                  var x$1$22 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(result$1);
                                  var this$94 = $n(x$1$22);
                                  var x188 = this$94.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend__f_handle;
                                  var event = $n(events).apply__O__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended(id$1, x188));
                                  break matchResult64$1;
                                }
                                throw new $c_s_MatchError(result$1);
                              }
                              $m_Lcats_implicits$();
                              var target$13 = $n(stateGraph$1).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$12) => {
                                var _$12$1 = $as_Lnet_andimiller_hedgehogs_DataGraph(_$12);
                                return $n(_$12$1).addNode__O__O__Lnet_andimiller_hedgehogs_DataGraph(id$1, newState);
                              })));
                              var this$100 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$13, evidence$1);
                              var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$13) => {
                                $as_jl_Void(_$13);
                                $m_Lcats_implicits$();
                                var fb = $n(completed$1).offer__O__O(id$1);
                                var this$99 = $n(evidence$1);
                                return this$99.productR__O__O__O(event, fb);
                              }));
                              return $f_Lcats_FlatMap__flatTap__O__F1__O($n(this$100.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance), this$100.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
                            }));
                            var fa = $n(this$101.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$101.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
                            var pf = new $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2(errored$1, id$1, completed$1, evidence$1);
                            var task = $n(evidence$1).onError__O__s_PartialFunction__O(fa, pf);
                            $m_Lcats_implicits$();
                            var fa$1 = $n(startedSet$1).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$14) => {
                              var _$14$1 = $as_sci_Set(_$14);
                              var this$104 = $n(_$14$1);
                              return $as_sci_Set(this$104.incl__O__sci_SetOps(id$1));
                            })));
                            $m_Lcats_implicits$();
                            $m_Lcats_implicits$();
                            var this$106 = $m_Lcats_effect_implicits$();
                            var ev$21 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$106, task, evidence$1);
                            var target$14 = $n(evidence$1).start__O__O(ev$21);
                            var this$109 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$14, evidence$1);
                            var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fibre) => {
                              var fibre$1 = $as_Lcats_effect_kernel_Fiber(fibre);
                              return $n(backgroundTasks$1).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$15) => {
                                var _$15$1 = $as_sci_Map(_$15);
                                return $as_sci_Map($n(_$15$1).updated__O__O__sci_MapOps(id$1, fibre$1));
                              })));
                            }));
                            var target$15 = $n(this$109.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$109.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
                            var this$111 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$15, evidence$1);
                            var fb$1 = $n(this$111.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$111.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
                            var this$113 = $n(evidence$1);
                            return this$113.productR__O__O__O(fa$1, fb$1);
                          }));
                          var target$16 = $n(this$114.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance).traverse__O__F1__Lcats_Applicative__O(this$114.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, f$4, evidence$1);
                          var this$116 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$16, evidence$1);
                          var f$5 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$1) => {
                            $as_sci_List(x$1$2$1);
                            return $n(runnable$1).size__I();
                          }));
                          return $n(this$116.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$116.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$5);
                        }
                        throw new $c_s_MatchError(x$1$7);
                      }));
                      return $n(this$117.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$117.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$6);
                    }));
                    return $n(this$118.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$118.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$7);
                  }));
                  return $n(this$119.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$119.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$8);
                }));
                return $n(this$120.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$120.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$9);
              })), evidence$1);
              return new $c_T3(tickLock$1, isDone, tick);
            }));
            var target$17 = $n(this$122.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$122.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$10);
            var this$182 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$17, evidence$1);
            var f$21 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$24) => {
              var x$1$25 = $as_T3(x$1$24);
              if ((x$1$25 !== null)) {
                $as_Lcats_effect_std_Semaphore($n(x$1$25).T3__f__1);
                var isDone$1 = $as_F1($n(x$1$25).T3__f__2);
                var tick$1 = $n(x$1$25).T3__f__3;
                $m_Lcats_implicits$();
                $m_Lcats_implicits$();
                $m_Lcats_implicits$();
                var target$18 = $n(backgroundTasks$1).get__O();
                var this$129 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$18, evidence$1);
                var f$12 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$16) => {
                  var _$16$1 = $as_sci_Map(_$16);
                  $m_Lcats_implicits$();
                  var this$125 = $n(_$16$1);
                  var target$19 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$125);
                  var tc$1 = $as_Lcats_Traverse($m_Lcats_implicits$().Lcats_implicits$__f_catsStdInstancesForList);
                  var this$128 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(target$19, tc$1);
                  var f$11 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$26) => {
                    var x$1$27 = $as_T2(x$1$26);
                    if ((x$1$27 !== null)) {
                      var fibre$2 = $as_Lcats_effect_kernel_Fiber($n(x$1$27)._2__O());
                      return $n(fibre$2).cancel__O();
                    }
                    throw new $c_s_MatchError(x$1$27);
                  }));
                  return $n(this$128.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance).traverse__O__F1__Lcats_Applicative__O(this$128.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, f$11, evidence$1);
                }));
                var target$20 = $n(this$129.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$129.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$12);
                var this$131 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$20, evidence$1);
                var release = $n(this$131.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$131.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
                var target$24 = $n(new $c_Lcats_effect_kernel_Resource$Pure((void 0)).onFinalize__O__Lcats_Applicative__Lcats_effect_kernel_Resource(release, evidence$1)).use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$17) => {
                  $as_jl_Void(_$17);
                  $m_Lcats_implicits$();
                  $m_Lcats_implicits$();
                  $m_Lcats_implicits$();
                  var this$135 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(tick$1, evidence$1);
                  var f$13 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((outstanding) => {
                    var outstanding$1 = $uI(outstanding);
                    return $p_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$__drive$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_std_Queue__O__I__O($thiz, evidence$1, completed$1, tick$1, outstanding$1);
                  }));
                  var fa$2 = $n(this$135.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$135.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$13);
                  $m_Lcats_implicits$();
                  var target$21 = $n(backgroundTasks$1).get__O();
                  var this$146 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$21, evidence$1);
                  var f$16 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$18) => {
                    var _$18$1 = $as_sci_Map(_$18);
                    $m_Lcats_implicits$();
                    var this$138 = $n(_$18$1);
                    var this$139 = new $c_sc_MapOps$$anon$1(this$138);
                    var target$22 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$139);
                    var tc$2 = $as_Lcats_Foldable($m_Lcats_implicits$().Lcats_implicits$__f_catsStdInstancesForList);
                    var this$145 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$22, tc$2);
                    var f$15 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$19) => {
                      var _$19$1 = $as_Lcats_effect_kernel_Fiber(_$19);
                      $m_Lcats_implicits$();
                      var $x_3 = $n(_$19$1);
                      var this$142 = $m_s_$less$colon$less$();
                      var fa$3 = $f_Lcats_effect_kernel_Fiber__joinWithUnit__Lcats_effect_kernel_MonadCancel__s_$less$colon$less__O($x_3, evidence$1, this$142.s_$less$colon$less$__f_singleton);
                      var f$14 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$20) => {
                        $as_jl_Throwable(_$20);
                      }));
                      return $n(evidence$1).handleError__O__F1__O(fa$3, f$14);
                    }));
                    return $n(this$145.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverseVoid__O__F1__Lcats_Applicative__O(this$145.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$15, evidence$1);
                  }));
                  var fb$2 = $n(this$146.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$146.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$16);
                  var this$148 = $n(evidence$1);
                  var fa$4 = this$148.productR__O__O__O(fa$2, fb$2);
                  $m_Lcats_implicits$();
                  var target$23 = $n(errored$1).tryGet__O();
                  var this$155 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$23, evidence$1);
                  var f$17 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$28) => {
                    var x$1$29 = $as_s_Option(x$1$28);
                    if ((x$1$29 instanceof $c_s_Some)) {
                      var e$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed($n($as_s_Some(x$1$29)).s_Some__f_value);
                      $m_Lcats_implicits$();
                      return $n(evidence$1).raiseError__O__O(e$2);
                    }
                    var x$2 = $m_s_None$();
                    if ((x$2 === x$1$29)) {
                      $m_Lcats_implicits$();
                      var ev$28 = (void 0);
                      return $n(evidence$1).pure__O__O(ev$28);
                    }
                    throw new $c_s_MatchError(x$1$29);
                  }));
                  var fb$3 = $n(this$155.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$155.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$17);
                  var this$157 = $n(evidence$1);
                  return this$157.productR__O__O__O(fa$4, fb$3);
                })), evidence$1);
                var this$181 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$24, evidence$1);
                var f$20 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$2) => {
                  $as_jl_Void(x$1$2$2);
                  $m_Lcats_implicits$();
                  var target$25 = $n(stateGraph$1).get__O();
                  var this$180 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$25, evidence$1);
                  var f$19 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((graph$2) => {
                    var graph$3 = $as_Lnet_andimiller_hedgehogs_DataGraph(graph$2);
                    $m_Lcats_implicits$();
                    var this$160 = $n($n(graph$3).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap);
                    var states = new $c_sc_MapOps$$anon$1(this$160);
                    if ($f_sc_IterableOnceOps__forall__F1__Z(states, isDone$1)) {
                      $m_Lcats_implicits$();
                      var graph$4 = $n(graph$3).mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$31) => {
                        var x$1$32 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(x$1$31);
                        if ((x$1$32 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
                          var x$1$33 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x$1$32);
                          var this$162 = $n(x$1$33);
                          var x209 = this$162.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output;
                          return x209;
                        }
                        throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("Unexpected state in finished run: " + x$1$32));
                      })));
                      var a$2 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished(graph$4);
                      var target$26 = $n(evidence$1).pure__O__O(a$2);
                    } else {
                      var p = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$3) => {
                        var x$1$34 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(x$1$2$3);
                        if ((x$1$34 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
                          var x$1$35 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(x$1$34);
                          $n(x$1$35);
                          $n(x$1$35);
                          return true;
                        } else {
                          return false;
                        }
                      }));
                      if ($f_sc_IterableOnceOps__exists__F1__Z(states, p)) {
                        $m_Lcats_implicits$();
                        var snapshot = new $c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot(graph$3, direction, 1);
                        var a$3 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended(snapshot);
                        var target$26 = $n(evidence$1).pure__O__O(a$3);
                      } else {
                        var pending = $as_sci_Iterable($n($n(graph$3).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).collect__s_PartialFunction__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3()));
                        $m_Lcats_implicits$();
                        var this$174 = $n(pending);
                        var message = ("Run stopped with pending nodes and nothing waiting: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$174, "", ",", ""));
                        var e$3 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag(message);
                        var target$26 = $n(evidence$1).raiseError__O__O(e$3);
                      }
                    }
                    var this$179 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$26, evidence$1);
                    var f$18 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((result$2) => {
                      var result$3 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunResult(result$2);
                      return result$3;
                    }));
                    return $n(this$179.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$179.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$18);
                  }));
                  return $n(this$180.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$180.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$19);
                }));
                return $n(this$181.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$181.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$20);
              }
              throw new $c_s_MatchError(x$1$25);
            }));
            return $n(this$182.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$182.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$21);
          }));
          return $n(this$183.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$183.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$22);
        }));
        return $n(this$184.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$184.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$23);
      }));
      return $n(this$185.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$185.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$24);
    }));
    return $n(this$186.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$186.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$25);
  }));
  return $n(this$187.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$187.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$26);
}
function $p_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$__drive$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_std_Queue__O__I__O($thiz, evidence$1$20, completed$17, tick$2, outstanding) {
  if ((outstanding <= 0)) {
    $m_Lcats_implicits$();
    var ev$23 = (void 0);
    return $n(evidence$1$20).pure__O__O(ev$23);
  } else {
    $m_Lcats_implicits$();
    var fa = $n(completed$17).take__O();
    $m_Lcats_implicits$();
    var this$6 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(tick$2, evidence$1$20);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((spawned) => {
      var spawned$1 = $uI(spawned);
      return $p_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$__drive$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_std_Queue__O__I__O($thiz, evidence$1$20, completed$17, tick$2, ((((outstanding - 1) | 0) + spawned$1) | 0));
    }));
    var fb = $n(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    var this$8 = $n(evidence$1$20);
    return this$8.productR__O__O__O(fa, fb);
  }
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$.prototype.start__Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor__Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode__F1__Lnet_andimiller_hedgehogs_DataGraph__Lcats_effect_kernel_GenConcurrent__O = (function(visitor, direction, events, initialDag, evidence$1) {
  $m_Lcats_implicits$();
  var fa = $p_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$__validated__Lnet_andimiller_hedgehogs_DataGraph__Lcats_effect_kernel_GenConcurrent__O(this, initialDag, evidence$1);
  var fb = $p_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$__runSegment__Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor__Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode__Lnet_andimiller_hedgehogs_DataGraph__sci_Map__F1__Lcats_effect_kernel_GenConcurrent__O(this, visitor, direction, $n(initialDag).mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((in$1) => new $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(in$1)))), $m_sci_Map$EmptyMap$(), events, evidence$1);
  var this$5 = $n(evidence$1);
  return this$5.productR__O__O__O(fa, fb);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$.prototype.resume__Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor__F1__Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__sci_Map__Lcats_effect_kernel_GenConcurrent__O = (function(visitor, events, snapshot, completions, evidence$1) {
  var this$1 = $n($n(completions).keySet__sci_Set());
  var this$3 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1));
  var rest = this$3;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = $n(rest).head__O();
    matchResult52: {
      var $x_1;
      var x86 = $n($n($n(snapshot).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).get__O__s_Option(x0);
      if ((x86 instanceof $c_s_Some)) {
        if (($n($as_s_Some(x86)).s_Some__f_value instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
          var x$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting($n($as_s_Some(x86)).s_Some__f_value);
          $n(x$1);
          $n(x$1);
          var $x_1 = $m_s_None$();
          break matchResult52;
        }
        var value = (x0 + " is not Waiting");
        var $x_1 = new $c_s_Some(value);
        break matchResult52;
      }
      var x = $m_s_None$();
      if ((x === x86)) {
        var value$1 = (x0 + " is not in the graph");
        var $x_1 = new $c_s_Some(value$1);
        break matchResult52;
      }
      throw new $c_s_MatchError(x86);
    }
    var it = $x_1.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        $n(t).sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = $as_sci_List($n(rest).tail__O());
  }
  var badCompletions = ((h === null) ? $m_sci_Nil$() : h);
  $m_Lcats_implicits$();
  $m_Lcats_implicits$();
  var this$9 = $n(badCompletions);
  if ((!this$9.isEmpty__Z())) {
    $m_Lcats_implicits$();
    var this$10 = $n(badCompletions);
    var message = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$10, "", ", ", "");
    var e = new $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions(message);
    var fa = $n(evidence$1).raiseError__O__O(e);
  } else {
    $m_Lcats_implicits$();
    var ev$5 = (void 0);
    var fa = $n(evidence$1).pure__O__O(ev$5);
  }
  var fb = $p_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$__validated__Lnet_andimiller_hedgehogs_DataGraph__Lcats_effect_kernel_GenConcurrent__O(this, $n(snapshot).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph, evidence$1);
  var this$18 = $n(evidence$1);
  var fa$1 = this$18.productR__O__O__O(fa, fb);
  var fb$1 = $p_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$__runSegment__Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor__Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode__Lnet_andimiller_hedgehogs_DataGraph__sci_Map__F1__Lcats_effect_kernel_GenConcurrent__O(this, visitor, $n(snapshot).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_direction, $n(snapshot).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph, completions, events, evidence$1);
  var this$21 = $n(evidence$1);
  return this$21.productR__O__O__O(fa$1, fb$1);
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$() {
  this.Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$__f_runModeEncoder = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$__f_runModeDecoder = null;
  $n_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$ = this;
  var instance = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var this$3 = $n(instance);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode(x$1);
    var x = $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$();
    if ((x === x$1$1)) {
      return "flow";
    }
    var x$3 = $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$();
    if ((x$3 === x$1$1)) {
      return "dependency";
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  this.Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$__f_runModeEncoder = new $c_Lio_circe_Encoder$$anon$1(f, this$3);
  $m_Lio_circe_Decoder$();
  var instance$1 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var this$8 = $n(instance$1);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_T(x$1$2);
    if ((x$1$3 === "flow")) {
      var value = $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$();
      return new $c_s_util_Right(value);
    } else if ((x$1$3 === "dependency")) {
      var value$1 = $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$();
      return new $c_s_util_Right(value$1);
    } else {
      var value$2 = ("Unknown RunMode: " + x$1$3);
      return new $c_s_util_Left(value$2);
    }
  }));
  this.Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$__f_runModeDecoder = new $c_Lio_circe_Decoder$$anon$13(f$1, this$8);
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$.prototype.nodeStateEncoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder = (function(evidence$1, evidence$2, evidence$3) {
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(x$1);
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)) {
      var x$1$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(x$1$1);
      var this$2 = $n(x$1$2);
      var x13 = this$2.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending__f_input;
      var this$5 = $m_Lio_circe_Json$();
      var fields = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("type", "pending", $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString), $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("input", x13, evidence$1, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString)]));
      return this$5.fromFields__sc_Iterable__Lio_circe_Json(fields);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
      var x$1$3 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(x$1$1);
      var this$7 = $n(x$1$3);
      var x9 = this$7.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_input;
      var this$8 = $n(x$1$3);
      var x10 = this$8.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle;
      var this$12 = $m_Lio_circe_Json$();
      var fields$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("type", "waiting", $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString), $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("input", x9, evidence$1, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString), $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("handle", x10, evidence$3, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString)]));
      return this$12.fromFields__sc_Iterable__Lio_circe_Json(fields$1);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
      var x$1$4 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x$1$1);
      var this$14 = $n(x$1$4);
      var x6 = this$14.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output;
      var this$17 = $m_Lio_circe_Json$();
      var fields$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("type", "done", $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString), $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("output", x6, evidence$2, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString)]));
      return this$17.fromFields__sc_Iterable__Lio_circe_Json(fields$2);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return new $c_Lio_circe_Encoder$$anon$21(f);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$.prototype.nodeStateDecoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder = (function(evidence$1, evidence$2, evidence$3) {
  $m_Lio_circe_Decoder$();
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((c) => {
    var c$1 = $as_Lio_circe_HCursor(c);
    var this$1 = $n($n(c$1).get__T__Lio_circe_Decoder__s_util_Either("type", $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString));
    if ((this$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$1);
      var b = $n(x2).s_util_Right__f_value;
      var x$1 = $as_T(b);
      switch (x$1) {
        case "pending": {
          var this$2 = $n($n(c$1).get__T__Lio_circe_Decoder__s_util_Either("input", evidence$1));
          if ((this$2 instanceof $c_s_util_Right)) {
            var x2$1 = $as_s_util_Right(this$2);
            var b$1 = $n(x2$1).s_util_Right__f_value;
            return new $c_s_util_Right(new $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(b$1));
          } else {
            return this$2;
          }
          break;
        }
        case "waiting": {
          $m_Lcats_implicits$();
          var _1 = $n(c$1).get__T__Lio_circe_Decoder__s_util_Either("input", evidence$1);
          var _2 = $n(c$1).get__T__Lio_circe_Decoder__s_util_Either("handle", evidence$3);
          var t = new $c_T2(_1, _2);
          var this$8 = new $c_Lcats_syntax_Tuple2SemigroupalOps(t);
          $m_Lcats_implicits$();
          $m_Lcats_implicits$();
          var semigroupal = new $c_Lcats_instances_EitherInstances$$anon$2();
          $m_Lcats_Semigroupal$();
          var f0 = $n(this$8.Lcats_syntax_Tuple2SemigroupalOps__f_t)._1__O();
          var f1 = $n(this$8.Lcats_syntax_Tuple2SemigroupalOps__f_t)._2__O();
          var fa = $f_Lcats_FlatMap__product__O__O__O(semigroupal, f0, f1);
          var fa$1 = $as_s_util_Either(fa);
          var this$10 = $n(fa$1);
          if ((this$10 instanceof $c_s_util_Right)) {
            var x2$2 = $as_s_util_Right(this$10);
            var b$2 = $n(x2$2).s_util_Right__f_value;
            var x$1$1 = $as_T2(b$2);
            matchResult1: {
              var $x_1;
              if ((x$1$1 !== null)) {
                var a0 = $n(x$1$1)._1__O();
                var a1 = $n(x$1$1)._2__O();
                var $x_1 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(a0, a1);
                break matchResult1;
              }
              throw new $c_s_MatchError(x$1$1);
            }
            return new $c_s_util_Right($x_1);
          } else {
            return this$10;
          }
          break;
        }
        case "done": {
          var this$12 = $n($n(c$1).get__T__Lio_circe_Decoder__s_util_Either("output", evidence$2));
          if ((this$12 instanceof $c_s_util_Right)) {
            var x2$3 = $as_s_util_Right(this$12);
            var b$3 = $n(x2$3).s_util_Right__f_value;
            return new $c_s_util_Right(new $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(b$3));
          } else {
            return this$12;
          }
          break;
        }
        default: {
          var value = $m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure(("Unknown NodeState type: " + x$1), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(c$1).history__sci_List())));
          return new $c_s_util_Left(value);
        }
      }
    } else {
      return this$1;
    }
  }));
  return new $c_Lio_circe_Decoder$$anon$36(f);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$.prototype.dagSnapshotEncoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder = (function(evidence$1, evidence$2, evidence$3, evidence$4, evidence$5) {
  var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((snapshot) => {
    var snapshot$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot(snapshot);
    var this$20 = $m_Lio_circe_Json$();
    var $x_8 = $m_sr_ScalaRunTime$();
    var $x_7 = $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("version", $n(snapshot$1).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_version, $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeInt, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString);
    var $x_6 = $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("direction", $n(snapshot$1).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_direction, $m_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$().Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$__f_runModeEncoder, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString);
    var $x_5 = $m_Lio_circe_syntax_package$KeyOps$();
    var this$4 = $n($n($n(snapshot$1).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap);
    var this$9 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4));
    var f = ((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var id = $n(x$1$1)._1__O();
        var state = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState($n(x$1$1)._2__O());
        var this$8 = $m_Lio_circe_Json$();
        var fields = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("id", id, evidence$1, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString), $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("state", state, $m_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$().nodeStateEncoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder(evidence$2, evidence$3, evidence$4), $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString)]));
        return this$8.fromFields__sc_Iterable__Lio_circe_Json(fields);
      }
      throw new $c_s_MatchError(x$1$1);
    });
    if ((this$9 === $m_sci_Nil$())) {
      var $x_4 = $m_sci_Nil$();
    } else {
      var x0 = this$9.head__O();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$9.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var $x_4 = h;
    }
    var this$10 = $m_Lio_circe_Encoder$();
    var encodeA = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeJson;
    var $x_3 = $x_5.$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("nodes", $x_4, new $c_Lio_circe_Encoder$$anon$28(encodeA, this$10), $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString);
    var $x_2 = $m_Lio_circe_syntax_package$KeyOps$();
    var this$12 = $n($n($n(snapshot$1).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap);
    var this$18 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$12));
    var f$1 = ((x$1$2) => {
      var x$1$3 = $as_T2(x$1$2);
      if ((x$1$3 !== null)) {
        var x19 = $as_T2($n(x$1$3)._1__O());
        if ((x19 !== null)) {
          var from = $n(x19)._1__O();
          var to = $n(x19)._2__O();
          var data = $n(x$1$3)._2__O();
          var this$17 = $m_Lio_circe_Json$();
          var fields$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("from", from, evidence$1, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString), $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("to", to, evidence$1, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString), $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("data", data, evidence$5, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString)]));
          return this$17.fromFields__sc_Iterable__Lio_circe_Json(fields$1);
        }
      }
      throw new $c_s_MatchError(x$1$3);
    });
    if ((this$18 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0$2 = this$18.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(this$18.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = $n(rest$1).head__O();
        var nx$1 = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
        $n(t$1).sci_$colon$colon__f_next = nx$1;
        t$1 = nx$1;
        rest$1 = $as_sci_List($n(rest$1).tail__O());
      }
      var $x_1 = h$1;
    }
    var this$19 = $m_Lio_circe_Encoder$();
    var encodeA$1 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeJson;
    var fields$2 = $x_8.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_7, $x_6, $x_3, $x_2.$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("edges", $x_1, new $c_Lio_circe_Encoder$$anon$28(encodeA$1, this$19), $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString)]));
    return this$20.fromFields__sc_Iterable__Lio_circe_Json(fields$2);
  }));
  return new $c_Lio_circe_Encoder$$anon$21(f$2);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$.prototype.dagSnapshotDecoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder = (function(evidence$1, evidence$2, evidence$3, evidence$4, evidence$5) {
  $m_Lio_circe_Decoder$();
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((c) => {
    var c$1 = $as_Lio_circe_HCursor(c);
    $m_Lcats_implicits$();
    var _1 = $n(c$1).get__T__Lio_circe_Decoder__s_util_Either("id", evidence$1);
    var _2 = $n(c$1).get__T__Lio_circe_Decoder__s_util_Either("state", $m_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$().nodeStateDecoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder(evidence$2, evidence$3, evidence$4));
    var t = new $c_T2(_1, _2);
    return $as_s_util_Either(new $c_Lcats_syntax_Tuple2SemigroupalOps(t).tupled__Lcats_Invariant__Lcats_Semigroupal__O(($m_Lcats_implicits$(), new $c_Lcats_instances_EitherInstances$$anon$2()), ($m_Lcats_implicits$(), new $c_Lcats_instances_EitherInstances$$anon$2())));
  }));
  var nodeEntry = new $c_Lio_circe_Decoder$$anon$36(f);
  $m_Lio_circe_Decoder$();
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((c$2) => {
    var c$3 = $as_Lio_circe_HCursor(c$2);
    $m_Lcats_implicits$();
    var _1$1 = $n(c$3).get__T__Lio_circe_Decoder__s_util_Either("from", evidence$1);
    var _2$1 = $n(c$3).get__T__Lio_circe_Decoder__s_util_Either("to", evidence$1);
    var _3 = $n(c$3).get__T__Lio_circe_Decoder__s_util_Either("data", evidence$5);
    var t$1 = new $c_T3(_1$1, _2$1, _3);
    var this$10 = new $c_Lcats_syntax_Tuple3SemigroupalOps(t$1);
    $m_Lcats_implicits$();
    $m_Lcats_implicits$();
    var semigroupal = new $c_Lcats_instances_EitherInstances$$anon$2();
    $m_Lcats_Semigroupal$();
    var f0 = $n(this$10.Lcats_syntax_Tuple3SemigroupalOps__f_t).T3__f__1;
    var f1 = $n(this$10.Lcats_syntax_Tuple3SemigroupalOps__f_t).T3__f__2;
    var f2 = $n(this$10.Lcats_syntax_Tuple3SemigroupalOps__f_t).T3__f__3;
    var fb = $f_Lcats_FlatMap__product__O__O__O(semigroupal, f1, f2);
    var fa = $f_Lcats_FlatMap__product__O__O__O(semigroupal, f0, fb);
    var fa$1 = $as_s_util_Either(fa);
    var this$12 = $n(fa$1);
    if ((this$12 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$12);
      var b = $n(x2).s_util_Right__f_value;
      var x$1 = $as_T2(b);
      matchResult6$1: {
        var $x_1;
        if ((x$1 !== null)) {
          var x18 = $as_T2($n(x$1)._2__O());
          var a0 = $n(x$1)._1__O();
          if ((x18 !== null)) {
            var a1 = $n(x18)._1__O();
            var a2 = $n(x18)._2__O();
            var _1$2 = new $c_T2(a0, a1);
            var $x_1 = new $c_T2(_1$2, a2);
            break matchResult6$1;
          }
        }
        throw new $c_s_MatchError(x$1);
      }
      return new $c_s_util_Right($x_1);
    } else {
      return this$12;
    }
  }));
  var edgeEntry = new $c_Lio_circe_Decoder$$anon$36(f$1);
  $m_Lio_circe_Decoder$();
  var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((c$3$1) => {
    var c$4 = $as_Lio_circe_HCursor(c$3$1);
    $m_Lcats_implicits$();
    var _1$3 = $n(c$4).get__T__Lio_circe_Decoder__s_util_Either("version", $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeInt);
    var _2$2 = $n(c$4).get__T__Lio_circe_Decoder__s_util_Either("direction", $m_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$().Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$__f_runModeDecoder);
    var _3$1 = $n(c$4).get__T__Lio_circe_Decoder__s_util_Either("nodes", ($m_Lio_circe_Decoder$(), new $c_Lio_circe_Decoder$$anon$48(nodeEntry)));
    var _4 = $n(c$4).get__T__Lio_circe_Decoder__s_util_Either("edges", ($m_Lio_circe_Decoder$(), new $c_Lio_circe_Decoder$$anon$48(edgeEntry)));
    var t$2 = new $c_T4(_1$3, _2$2, _3$1, _4);
    var this$23 = new $c_Lcats_syntax_Tuple4SemigroupalOps(t$2);
    $m_Lcats_implicits$();
    $m_Lcats_implicits$();
    var semigroupal$1 = new $c_Lcats_instances_EitherInstances$$anon$2();
    $m_Lcats_Semigroupal$();
    var f0$1 = $n(this$23.Lcats_syntax_Tuple4SemigroupalOps__f_t).T4__f__1;
    var f1$1 = $n(this$23.Lcats_syntax_Tuple4SemigroupalOps__f_t).T4__f__2;
    var f2$1 = $n(this$23.Lcats_syntax_Tuple4SemigroupalOps__f_t).T4__f__3;
    var f3 = $n(this$23.Lcats_syntax_Tuple4SemigroupalOps__f_t).T4__f__4;
    var fb$1 = $f_Lcats_FlatMap__product__O__O__O(semigroupal$1, f2$1, f3);
    var fb$2 = $f_Lcats_FlatMap__product__O__O__O(semigroupal$1, f1$1, fb$1);
    var fa$2 = $f_Lcats_FlatMap__product__O__O__O(semigroupal$1, f0$1, fb$2);
    var fa$3 = $as_s_util_Either(fa$2);
    var this$25 = $n(fa$3);
    if ((this$25 instanceof $c_s_util_Right)) {
      var x2$1 = $as_s_util_Right(this$25);
      var b$1 = $n(x2$1).s_util_Right__f_value;
      var x$1$1 = $as_T2(b$1);
      matchResult11: {
        var $x_2;
        if ((x$1$1 !== null)) {
          var x41 = $as_T2($n(x$1$1)._2__O());
          var a0$1 = $n(x$1$1)._1__O();
          if ((x41 !== null)) {
            var x43 = $as_T2($n(x41)._2__O());
            var a1$1 = $n(x41)._1__O();
            if ((x43 !== null)) {
              var a2$1 = $n(x43)._1__O();
              var a3 = $n(x43)._2__O();
              var x$1$2 = $uI(a0$1);
              var x$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode(a1$1);
              var x$3 = $as_sci_List(a2$1);
              var x$4 = $as_sci_List(a3);
              var this$28 = $n(x$3);
              var nodeMap = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$28);
              var this$30 = $n(x$4);
              var edgeMap = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$30);
              var emptyNode = $m_s_None$();
              var emptyEdge = $m_s_None$();
              var graph = new $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(nodeMap, edgeMap, emptyNode, emptyEdge);
              var $x_2 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot(graph, x$2, x$1$2);
              break matchResult11;
            }
          }
        }
        throw new $c_s_MatchError(x$1$1);
      }
      return new $c_s_util_Right($x_2);
    } else {
      return this$25;
    }
  }));
  return new $c_Lio_circe_Decoder$$anon$36(f$2);
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$, "net.andimiller.hedgehogs.dag.visitor.circe.DagSnapshotCodecs$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$;
}
function $s_RTLong__remainderUnsigned__I__I__I__I__J(alo, ahi, blo, bhi) {
  var this$1 = $m_RTLong$();
  return this$1.remainderUnsignedImpl__I__I__I__I__J(alo, ahi, blo, bhi);
}
function $s_RTLong__remainder__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().remainder__I__I__I__I__J(alo, ahi, blo, bhi);
}
function $s_RTLong__divideUnsigned__I__I__I__I__J(alo, ahi, blo, bhi) {
  var this$1 = $m_RTLong$();
  return this$1.divideUnsignedImpl__I__I__I__I__J(alo, ahi, blo, bhi);
}
function $s_RTLong__divide__I__I__I__I__J(alo, ahi, blo, bhi) {
  return $m_RTLong$().divide__I__I__I__I__J(alo, ahi, blo, bhi);
}
function $s_RTLong__fromDoubleBits__D__O__J(value, fpBitsDataView) {
  fpBitsDataView.setFloat64(0, value, true);
  var lo = $uI(fpBitsDataView.getInt32(0, true));
  var hi = $uI(fpBitsDataView.getInt32(4, true));
  return $bL(lo, hi);
}
function $s_RTLong__fromDouble__D__J(value) {
  return $m_RTLong$().fromDouble__D__J(value);
}
function $s_RTLong__fromUnsignedInt__I__J(value) {
  return $bL(value, 0);
}
function $s_RTLong__fromInt__I__J(value) {
  var hi = (value >> 31);
  return $bL(value, hi);
}
function $s_RTLong__clz__I__I__I(lo, hi) {
  return ((hi !== 0) ? Math.clz32(hi) : ((32 + Math.clz32(lo)) | 0));
}
function $s_RTLong__toFloat__I__I__F(lo, hi) {
  var compressedLo = (((((-2097152) & (hi ^ (hi >> 10))) === 0) || ((65535 & lo) === 0)) ? lo : (32768 | ((-32768) & lo)));
  return Math.fround(((4.294967296E9 * hi) + (compressedLo >>> 0.0)));
}
function $s_RTLong__toDouble__I__I__D(lo, hi) {
  return ((4.294967296E9 * hi) + (lo >>> 0.0));
}
function $s_RTLong__toInt__I__I__I(lo, hi) {
  return lo;
}
function $s_RTLong__toString__I__I__T(lo, hi) {
  return $m_RTLong$().toString__I__I__T(lo, hi);
}
function $s_RTLong__bitsToDouble__I__I__O__D(lo, hi, fpBitsDataView) {
  fpBitsDataView.setInt32(0, lo, true);
  fpBitsDataView.setInt32(4, hi, true);
  return $uD(fpBitsDataView.getFloat64(0, true));
}
function $s_RTLong__mul__I__I__I__I__J(alo, ahi, blo, bhi) {
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, bhi) + Math.imul(ahi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__sub__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = ((alo - blo) | 0);
  var hi = ((((ahi - bhi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__add__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = ((alo + blo) | 0);
  var hi = ((((ahi + bhi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
  return $bL(lo, hi);
}
function $s_RTLong__sar__I__I__I__J(lo, hi, n) {
  var lo$1 = (((32 & n) === 0) ? (((lo >>> n) | 0) | ((hi << 1) << (~n))) : (hi >> n));
  var hi$1 = (((32 & n) === 0) ? (hi >> n) : (hi >> 31));
  return $bL(lo$1, hi$1);
}
function $s_RTLong__shr__I__I__I__J(lo, hi, n) {
  var lo$1 = (((32 & n) === 0) ? (((lo >>> n) | 0) | ((hi << 1) << (~n))) : ((hi >>> n) | 0));
  var hi$1 = (((32 & n) === 0) ? ((hi >>> n) | 0) : 0);
  return $bL(lo$1, hi$1);
}
function $s_RTLong__shl__I__I__I__J(lo, hi, n) {
  var lo$1 = (((32 & n) === 0) ? (lo << n) : 0);
  var hi$1 = (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> (~n)) | 0) | (hi << n)) : (lo << n));
  return $bL(lo$1, hi$1);
}
function $s_RTLong__xor__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = (alo ^ blo);
  var hi = (ahi ^ bhi);
  return $bL(lo, hi);
}
function $s_RTLong__and__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = (alo & blo);
  var hi = (ahi & bhi);
  return $bL(lo, hi);
}
function $s_RTLong__or__I__I__I__I__J(alo, ahi, blo, bhi) {
  var lo = (alo | blo);
  var hi = (ahi | bhi);
  return $bL(lo, hi);
}
function $s_RTLong__geu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) >= (blo >>> 0)) : ((ahi >>> 0) > (bhi >>> 0)));
}
function $s_RTLong__gtu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) > (blo >>> 0)) : ((ahi >>> 0) > (bhi >>> 0)));
}
function $s_RTLong__leu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) <= (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)));
}
function $s_RTLong__ltu__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)));
}
function $s_RTLong__ge__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) >= (blo >>> 0)) : (ahi > bhi));
}
function $s_RTLong__gt__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) > (blo >>> 0)) : (ahi > bhi));
}
function $s_RTLong__le__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) <= (blo >>> 0)) : (ahi < bhi));
}
function $s_RTLong__lt__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo >>> 0) < (blo >>> 0)) : (ahi < bhi));
}
function $s_RTLong__notEquals__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return (((alo ^ blo) | (ahi ^ bhi)) !== 0);
}
function $s_RTLong__equals__I__I__I__I__Z(alo, ahi, blo, bhi) {
  return (((alo ^ blo) | (ahi ^ bhi)) === 0);
}
/** @constructor */
function $c_RTLong$() {
}
$c_RTLong$.prototype = new $h_O();
$c_RTLong$.prototype.constructor = $c_RTLong$;
/** @constructor */
function $h_RTLong$() {
}
$h_RTLong$.prototype = $c_RTLong$.prototype;
$c_RTLong$.prototype.toString__I__I__T = (function(lo, hi) {
  if ((hi === (lo >> 31))) {
    return ("" + lo);
  } else if ((((-2097152) & (hi ^ (hi >> 10))) === 0)) {
    var this$2 = ((4.294967296E9 * hi) + (lo >>> 0.0));
    return ("" + this$2);
  } else {
    var sign = (hi >> 31);
    var xlo = (lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var approxNum = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var approxQuot = $uD(Math.floor((1.0E-9 * approxNum)));
    var x = approxQuot;
    var approxRem = ((rlo - Math.imul(1000000000, (x | 0.0))) | 0);
    if ((approxRem < 0)) {
      approxQuot = (approxQuot - 1.0);
      approxRem = ((1000000000 + approxRem) | 0);
    } else if ((approxRem >= 1000000000)) {
      approxQuot = (approxQuot + 1.0);
      approxRem = ((approxRem - 1000000000) | 0);
    }
    var this$7 = approxRem;
    var remStr = ("" + this$7);
    var this$9 = approxQuot;
    var start = remStr.length;
    var s = ((("" + this$9) + $as_T("000000000".substring(start))) + remStr);
    return ((hi < 0) ? ("-" + s) : s);
  }
});
$c_RTLong$.prototype.fromDouble__D__J = (function(value) {
  if ((value < (-9.223372036854776E18))) {
    return $bL(0, (-2147483648));
  } else if ((value >= 9.223372036854776E18)) {
    return $bL((-1), 2147483647);
  } else {
    var rawLo = (value | 0.0);
    var x = (2.3283064365386963E-10 * value);
    var rawHi = (x | 0.0);
    var hi = (((value < 0.0) && (rawLo !== 0)) ? ((rawHi - 1) | 0) : rawHi);
    return $bL(rawLo, hi);
  }
});
$c_RTLong$.prototype.divide__I__I__I__I__J = (function(alo, ahi, blo, bhi) {
  var sign = (ahi >> 31);
  var xlo = (alo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((ahi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
  var sign$1 = (bhi >> 31);
  var xlo$1 = (blo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((bhi ^ sign$1) + (((xlo$1 & (~rlo$1)) >>> 31) | 0)) | 0);
  var b = ((-2097152) & rlo$1);
  if (((rhi$1 | b) === 0)) {
    var quotHi = (((rhi >>> 0) / ($checkIntDivisor(rlo$1) >>> 0)) | 0);
    var k = ((rhi - Math.imul(rlo$1, quotHi)) | 0);
    var x = (((4.294967296E9 * k) + (rlo >>> 0.0)) / rlo$1);
    var quotLo = (x | 0.0);
    var absR_$_lo = quotLo;
    var absR_$_hi = quotHi;
  } else if ((((-1073741824) & rhi$1) === 0)) {
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var bHat = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
    var x$1 = (aHat / bHat);
    var lo = (x$1 | 0.0);
    var x$2 = (2.3283064365386963E-10 * x$1);
    var hi = (x$2 | 0.0);
    var a0 = (65535 & rlo$1);
    var a1 = ((rlo$1 >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(rlo$1, hi) + Math.imul(rhi$1, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((rlo - lo$1) | 0);
    var hi$2 = ((((rhi - hi$1) | 0) + ((((~rlo) & lo$1) | ((~(rlo ^ lo$1)) & lo$2)) >> 31)) | 0);
    if ((hi$2 < 0)) {
      var lo$3 = ((lo - 1) | 0);
      var hi$3 = ((((hi - 1) | 0) + (((lo | (~lo$3)) >>> 31) | 0)) | 0);
      var absR_$_lo = lo$3;
      var absR_$_hi = hi$3;
    } else if (((hi$2 === rhi$1) ? ((lo$2 >>> 0) >= (rlo$1 >>> 0)) : ((hi$2 >>> 0) > (rhi$1 >>> 0)))) {
      var lo$4 = ((1 + lo) | 0);
      var hi$4 = ((hi + (((lo & (~lo$4)) >>> 31) | 0)) | 0);
      var absR_$_lo = lo$4;
      var absR_$_hi = hi$4;
    } else {
      var absR_$_lo = lo;
      var absR_$_hi = hi;
    }
  } else {
    var $x_1 = this.org$scalajs$linker$runtime$RuntimeLong$$unsignedDivModHugeDivisor__I__I__I__I__Z__J(rlo, rhi, rlo$1, rhi$1, true);
    var absR_$_lo = $x_1.l;
    var absR_$_hi = $x_1.h;
  }
  if (((ahi ^ bhi) >= 0)) {
    return $bL(absR_$_lo, absR_$_hi);
  } else {
    var lo$5 = ((-absR_$_lo) | 0);
    var hi$5 = ((((-absR_$_hi) | 0) + ((absR_$_lo | lo$5) >> 31)) | 0);
    return $bL(lo$5, hi$5);
  }
});
$c_RTLong$.prototype.divideUnsignedImpl__I__I__I__I__J = (function(alo, ahi, blo, bhi) {
  var b = ((-2097152) & blo);
  if (((bhi | b) === 0)) {
    var quotHi = (((ahi >>> 0) / ($checkIntDivisor(blo) >>> 0)) | 0);
    var k = ((ahi - Math.imul(blo, quotHi)) | 0);
    var x = (((4.294967296E9 * k) + (alo >>> 0.0)) / blo);
    var quotLo = (x | 0.0);
    return $bL(quotLo, quotHi);
  } else if ((((-1073741824) & bhi) === 0)) {
    var aHat = ((4.294967296E9 * (ahi >>> 0.0)) + (alo >>> 0.0));
    var bHat = ((4.294967296E9 * (bhi >>> 0.0)) + (blo >>> 0.0));
    var x$1 = (aHat / bHat);
    var lo = (x$1 | 0.0);
    var x$2 = (2.3283064365386963E-10 * x$1);
    var hi = (x$2 | 0.0);
    var a0 = (65535 & blo);
    var a1 = ((blo >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(blo, hi) + Math.imul(bhi, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((alo - lo$1) | 0);
    var hi$2 = ((((ahi - hi$1) | 0) + ((((~alo) & lo$1) | ((~(alo ^ lo$1)) & lo$2)) >> 31)) | 0);
    if ((hi$2 < 0)) {
      var lo$3 = ((lo - 1) | 0);
      var hi$3 = ((((hi - 1) | 0) + (((lo | (~lo$3)) >>> 31) | 0)) | 0);
      return $bL(lo$3, hi$3);
    } else if (((hi$2 === bhi) ? ((lo$2 >>> 0) >= (blo >>> 0)) : ((hi$2 >>> 0) > (bhi >>> 0)))) {
      var lo$4 = ((1 + lo) | 0);
      var hi$4 = ((hi + (((lo & (~lo$4)) >>> 31) | 0)) | 0);
      return $bL(lo$4, hi$4);
    } else {
      return $bL(lo, hi);
    }
  } else {
    return this.org$scalajs$linker$runtime$RuntimeLong$$unsignedDivModHugeDivisor__I__I__I__I__Z__J(alo, ahi, blo, bhi, true);
  }
});
$c_RTLong$.prototype.remainder__I__I__I__I__J = (function(alo, ahi, blo, bhi) {
  var sign = (ahi >> 31);
  var xlo = (alo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((ahi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
  var sign$1 = (bhi >> 31);
  var xlo$1 = (blo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((bhi ^ sign$1) + (((xlo$1 & (~rlo$1)) >>> 31) | 0)) | 0);
  var b = ((-2097152) & rlo$1);
  if (((rhi$1 | b) === 0)) {
    var k$2 = (((rhi >>> 0) % ($checkIntDivisor(rlo$1) >>> 0)) | 0);
    var x = (((4.294967296E9 * k$2) + (rlo >>> 0.0)) / rlo$1);
    var quotLo$2 = (x | 0.0);
    var remLo = ((rlo - Math.imul(rlo$1, quotLo$2)) | 0);
    var absR_$_lo = remLo;
    var absR_$_hi = 0;
  } else if ((((-1073741824) & rhi$1) === 0)) {
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var bHat = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
    var x$1 = (aHat / bHat);
    var lo = (x$1 | 0.0);
    var x$2 = (2.3283064365386963E-10 * x$1);
    var hi = (x$2 | 0.0);
    var a0 = (65535 & rlo$1);
    var a1 = ((rlo$1 >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(rlo$1, hi) + Math.imul(rhi$1, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((rlo - lo$1) | 0);
    var hi$2 = ((((rhi - hi$1) | 0) + ((((~rlo) & lo$1) | ((~(rlo ^ lo$1)) & lo$2)) >> 31)) | 0);
    if ((hi$2 < 0)) {
      var lo$3 = ((lo$2 + rlo$1) | 0);
      var hi$3 = ((((hi$2 + rhi$1) | 0) + ((((lo$2 & rlo$1) | ((lo$2 | rlo$1) & (~lo$3))) >>> 31) | 0)) | 0);
      var absR_$_lo = lo$3;
      var absR_$_hi = hi$3;
    } else if (((hi$2 === rhi$1) ? ((lo$2 >>> 0) >= (rlo$1 >>> 0)) : ((hi$2 >>> 0) > (rhi$1 >>> 0)))) {
      var lo$4 = ((lo$2 - rlo$1) | 0);
      var hi$4 = ((((hi$2 - rhi$1) | 0) + ((((~lo$2) & rlo$1) | ((~(lo$2 ^ rlo$1)) & lo$4)) >> 31)) | 0);
      var absR_$_lo = lo$4;
      var absR_$_hi = hi$4;
    } else {
      var absR_$_lo = lo$2;
      var absR_$_hi = hi$2;
    }
  } else {
    var $x_1 = this.org$scalajs$linker$runtime$RuntimeLong$$unsignedDivModHugeDivisor__I__I__I__I__Z__J(rlo, rhi, rlo$1, rhi$1, false);
    var absR_$_lo = $x_1.l;
    var absR_$_hi = $x_1.h;
  }
  if ((ahi < 0)) {
    var lo$5 = ((-absR_$_lo) | 0);
    var hi$5 = ((((-absR_$_hi) | 0) + ((absR_$_lo | lo$5) >> 31)) | 0);
    return $bL(lo$5, hi$5);
  } else {
    return $bL(absR_$_lo, absR_$_hi);
  }
});
$c_RTLong$.prototype.remainderUnsignedImpl__I__I__I__I__J = (function(alo, ahi, blo, bhi) {
  var b = ((-2097152) & blo);
  if (((bhi | b) === 0)) {
    var k$2 = (((ahi >>> 0) % ($checkIntDivisor(blo) >>> 0)) | 0);
    var x = (((4.294967296E9 * k$2) + (alo >>> 0.0)) / blo);
    var quotLo$2 = (x | 0.0);
    var remLo = ((alo - Math.imul(blo, quotLo$2)) | 0);
    return $bL(remLo, 0);
  } else if ((((-1073741824) & bhi) === 0)) {
    var aHat = ((4.294967296E9 * (ahi >>> 0.0)) + (alo >>> 0.0));
    var bHat = ((4.294967296E9 * (bhi >>> 0.0)) + (blo >>> 0.0));
    var x$1 = (aHat / bHat);
    var lo = (x$1 | 0.0);
    var x$2 = (2.3283064365386963E-10 * x$1);
    var hi = (x$2 | 0.0);
    var a0 = (65535 & blo);
    var a1 = ((blo >>> 16) | 0);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(blo, hi) + Math.imul(bhi, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((alo - lo$1) | 0);
    var hi$2 = ((((ahi - hi$1) | 0) + ((((~alo) & lo$1) | ((~(alo ^ lo$1)) & lo$2)) >> 31)) | 0);
    if ((hi$2 < 0)) {
      var lo$3 = ((lo$2 + blo) | 0);
      var hi$3 = ((((hi$2 + bhi) | 0) + ((((lo$2 & blo) | ((lo$2 | blo) & (~lo$3))) >>> 31) | 0)) | 0);
      return $bL(lo$3, hi$3);
    } else if (((hi$2 === bhi) ? ((lo$2 >>> 0) >= (blo >>> 0)) : ((hi$2 >>> 0) > (bhi >>> 0)))) {
      var lo$4 = ((lo$2 - blo) | 0);
      var hi$4 = ((((hi$2 - bhi) | 0) + ((((~lo$2) & blo) | ((~(lo$2 ^ blo)) & lo$4)) >> 31)) | 0);
      return $bL(lo$4, hi$4);
    } else {
      return $bL(lo$2, hi$2);
    }
  } else {
    return this.org$scalajs$linker$runtime$RuntimeLong$$unsignedDivModHugeDivisor__I__I__I__I__Z__J(alo, ahi, blo, bhi, false);
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$unsignedDivModHugeDivisor__I__I__I__I__Z__J = (function(alo, ahi, blo, bhi, askQuotient) {
  var quot1 = 0;
  if ((bhi >= 0)) {
    var lo = (blo << 1);
    var hi = (((blo >>> 31) | 0) | (bhi << 1));
    if (((ahi === hi) ? ((alo >>> 0) >= (lo >>> 0)) : ((ahi >>> 0) > (hi >>> 0)))) {
      quot1 = 2;
      var lo$1 = ((alo - lo) | 0);
      var hi$1 = ((((ahi - hi) | 0) + ((((~alo) & lo) | ((~(alo ^ lo)) & lo$1)) >> 31)) | 0);
      var rem1_$_lo = lo$1;
      var rem1_$_hi = hi$1;
    } else {
      var rem1_$_lo = alo;
      var rem1_$_hi = ahi;
    }
  } else {
    var rem1_$_lo = alo;
    var rem1_$_hi = ahi;
  }
  var rem1LTUb = ((rem1_$_hi === bhi) ? ((rem1_$_lo >>> 0) < (blo >>> 0)) : ((rem1_$_hi >>> 0) < (bhi >>> 0)));
  if (askQuotient) {
    if (rem1LTUb) {
      var lo$2 = quot1;
      return $bL(lo$2, 0);
    } else {
      var lo$3 = ((1 + quot1) | 0);
      return $bL(lo$3, 0);
    }
  } else if (rem1LTUb) {
    return $bL(rem1_$_lo, rem1_$_hi);
  } else {
    var lo$4 = ((rem1_$_lo - blo) | 0);
    var hi$2 = ((((rem1_$_hi - bhi) | 0) + ((((~rem1_$_lo) & blo) | ((~(rem1_$_lo ^ blo)) & lo$4)) >> 31)) | 0);
    return $bL(lo$4, hi$2);
  }
});
var $d_RTLong$ = new $TypeData().initClass($c_RTLong$, "org.scalajs.linker.runtime.RuntimeLong$", ({
  RTLong$: 1
}));
var $n_RTLong$;
function $m_RTLong$() {
  if ((!$n_RTLong$)) {
    $n_RTLong$ = new $c_RTLong$();
  }
  return $n_RTLong$;
}
/** @constructor */
function $c_s_Array$EmptyArrays$() {
  this.s_Array$EmptyArrays$__f_emptyIntArray = null;
  this.s_Array$EmptyArrays$__f_emptyObjectArray = null;
  $n_s_Array$EmptyArrays$ = this;
  this.s_Array$EmptyArrays$__f_emptyIntArray = new $ac_I(0);
  this.s_Array$EmptyArrays$__f_emptyObjectArray = new $ac_O(0);
}
$c_s_Array$EmptyArrays$.prototype = new $h_O();
$c_s_Array$EmptyArrays$.prototype.constructor = $c_s_Array$EmptyArrays$;
/** @constructor */
function $h_s_Array$EmptyArrays$() {
}
$h_s_Array$EmptyArrays$.prototype = $c_s_Array$EmptyArrays$.prototype;
var $d_s_Array$EmptyArrays$ = new $TypeData().initClass($c_s_Array$EmptyArrays$, "scala.Array$EmptyArrays$", ({
  s_Array$EmptyArrays$: 1
}));
var $n_s_Array$EmptyArrays$;
function $m_s_Array$EmptyArrays$() {
  if ((!$n_s_Array$EmptyArrays$)) {
    $n_s_Array$EmptyArrays$ = new $c_s_Array$EmptyArrays$();
  }
  return $n_s_Array$EmptyArrays$;
}
function $is_F0(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F0)));
}
function $as_F0(obj) {
  return (($is_F0(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function0"));
}
function $isArrayOf_F0(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F0)));
}
function $asArrayOf_F0(obj, depth) {
  return (($isArrayOf_F0(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function0;", depth));
}
function $f_F1__compose__F1__F1($thiz, g) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => $thiz.apply__O__O($n(g).apply__O__O(x$2$2))));
}
function $f_F1__andThen__F1__F1($thiz, g) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => $n(g).apply__O__O($thiz.apply__O__O(x$2$2))));
}
function $is_F1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F1)));
}
function $as_F1(obj) {
  return (($is_F1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function1"));
}
function $isArrayOf_F1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F1)));
}
function $asArrayOf_F1(obj, depth) {
  return (($isArrayOf_F1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function1;", depth));
}
var $d_F1 = new $TypeData().initClass(1, "scala.Function1", ({
  F1: 1
}));
function $is_F2(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F2)));
}
function $as_F2(obj) {
  return (($is_F2(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function2"));
}
function $isArrayOf_F2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F2)));
}
function $asArrayOf_F2(obj, depth) {
  return (($isArrayOf_F2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function2;", depth));
}
/** @constructor */
function $c_s_LowPriorityImplicits2() {
}
$c_s_LowPriorityImplicits2.prototype = new $h_O();
$c_s_LowPriorityImplicits2.prototype.constructor = $c_s_LowPriorityImplicits2;
/** @constructor */
function $h_s_LowPriorityImplicits2() {
}
$h_s_LowPriorityImplicits2.prototype = $c_s_LowPriorityImplicits2.prototype;
/** @constructor */
function $c_s_PartialFunction$() {
  this.s_PartialFunction$__f_fallback_fn = null;
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = null;
  this.s_PartialFunction$__f_empty_pf = null;
  $n_s_PartialFunction$ = this;
  this.s_PartialFunction$__f_fallback_fn = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2$2) => $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn));
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3$2$2) => false));
  this.s_PartialFunction$__f_empty_pf = new $c_s_PartialFunction$$anon$1();
}
$c_s_PartialFunction$.prototype = new $h_O();
$c_s_PartialFunction$.prototype.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
}
$h_s_PartialFunction$.prototype = $c_s_PartialFunction$.prototype;
$c_s_PartialFunction$.prototype.scala$PartialFunction$$fallbackOccurred__O__Z = (function(x) {
  return (this.s_PartialFunction$__f_fallback_fn === x);
});
var $d_s_PartialFunction$ = new $TypeData().initClass($c_s_PartialFunction$, "scala.PartialFunction$", ({
  s_PartialFunction$: 1
}));
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$();
  }
  return $n_s_PartialFunction$;
}
function $f_s_Proxy__toString__T($thiz) {
  return ("" + $thiz.self__O());
}
function $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len$1, \u03b4this$2, ord$1) {
  if ((len$1 < 300)) {
    var a = $m_sr_ScalaRunTime$().array_clone__O__O(\u03b4this$2);
    var this$1 = $m_s_util_Sorting$();
    this$1.stableSort__O__I__I__s_math_Ordering__V(a, 0, $m_jl_reflect_Array$().getLength__O__I(a), ord$1);
    return a;
  } else {
    var this$4 = $n(\u03b4this$2);
    var this$5 = $n($objectGetClass(this$4));
    var that = this$5.data.getComponentType();
    if ($d_O.isAssignableFrom($n(that).data)) {
      var original = $asArrayOf_O(\u03b4this$2, 1);
      var a$2 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, len$1, $d_O.getArrayOf().getClassOf());
    } else {
      var dest = new $ac_O(len$1);
      $m_s_Array$().copy__O__I__O__I__I__V(\u03b4this$2, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(\u03b4this$2));
      var a$2 = dest;
    }
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a$2, ord$1);
    var $x_2 = $m_s_Array$();
    var $x_1 = $m_s_reflect_ClassTag$();
    var this$10 = $n(\u03b4this$2);
    var this$11 = $n($objectGetClass(this$10));
    return $x_2.copyAs__O__I__s_reflect_ClassTag__O(a$2, len$1, $x_1.apply__jl_Class__s_reflect_ClassTag(this$11.data.getComponentType()));
  }
}
/** @constructor */
function $c_sc_ArrayOps$() {
  this.sc_ArrayOps$__f_fallback = null;
  $n_sc_ArrayOps$ = this;
  this.sc_ArrayOps$__f_fallback = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $m_sc_ArrayOps$().sc_ArrayOps$__f_fallback));
}
$c_sc_ArrayOps$.prototype = new $h_O();
$c_sc_ArrayOps$.prototype.constructor = $c_sc_ArrayOps$;
/** @constructor */
function $h_sc_ArrayOps$() {
}
$h_sc_ArrayOps$.prototype = $c_sc_ArrayOps$.prototype;
$c_sc_ArrayOps$.prototype.last$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) !== 0)) {
    return $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, (($m_jl_reflect_Array$().getLength__O__I(this$) - 1) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty array");
  }
});
$c_sc_ArrayOps$.prototype.slice$extension__O__I__I__O = (function(this$, from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = $m_jl_reflect_Array$().getLength__O__I(this$);
  var hi = ((until < b) ? until : b);
  if ((hi > lo)) {
    if ((this$ instanceof $ac_O)) {
      var x2 = $asArrayOf_O(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AO__I__I__AO(x2, lo, hi);
    } else if ((this$ instanceof $ac_I)) {
      var x3 = $asArrayOf_I(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AI__I__I__AI(x3, lo, hi);
    } else if ((this$ instanceof $ac_D)) {
      var x4 = $asArrayOf_D(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AD__I__I__AD(x4, lo, hi);
    } else if ((this$ instanceof $ac_J)) {
      var x5 = $asArrayOf_J(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AJ__I__I__AJ(x5, lo, hi);
    } else if ((this$ instanceof $ac_F)) {
      var x6 = $asArrayOf_F(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AF__I__I__AF(x6, lo, hi);
    } else if ((this$ instanceof $ac_C)) {
      var x7 = $asArrayOf_C(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AC__I__I__AC(x7, lo, hi);
    } else if ((this$ instanceof $ac_B)) {
      var x8 = $asArrayOf_B(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AB__I__I__AB(x8, lo, hi);
    } else if ((this$ instanceof $ac_S)) {
      var x9 = $asArrayOf_S(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AS__I__I__AS(x9, lo, hi);
    } else if ((this$ instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AZ__I__I__AZ(x10, lo, hi);
    } else {
      throw new $c_s_MatchError(this$);
    }
  } else {
    var $x_1 = $m_s_reflect_ClassTag$();
    var this$5 = $n(this$);
    var this$6 = $n($objectGetClass(this$5));
    return $n($x_1.apply__jl_Class__s_reflect_ClassTag(this$6.data.getComponentType())).newArray__I__O(0);
  }
});
$c_sc_ArrayOps$.prototype.tail$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty array");
  } else {
    return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 1, $m_jl_reflect_Array$().getLength__O__I(this$));
  }
});
$c_sc_ArrayOps$.prototype.drop$extension__O__I__O = (function(this$, n) {
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, n, $m_jl_reflect_Array$().getLength__O__I(this$));
});
$c_sc_ArrayOps$.prototype.dropRight$extension__O__I__O = (function(this$, n) {
  var n$1 = (($m_jl_reflect_Array$().getLength__O__I(this$) - ((n > 0) ? n : 0)) | 0);
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, n$1);
});
$c_sc_ArrayOps$.prototype.sorted$extension__O__s_math_Ordering__O = (function(this$, ord) {
  var len = $m_jl_reflect_Array$().getLength__O__I(this$);
  if ((len <= 1)) {
    return $m_sr_ScalaRunTime$().array_clone__O__O(this$);
  } else if ((this$ instanceof $ac_O)) {
    var x2 = $asArrayOf_O(this$, 1);
    var a = $m_ju_Arrays$().copyOf__AO__I__AO(x2, len);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return a;
  } else if ((this$ instanceof $ac_I)) {
    var x3 = $asArrayOf_I(this$, 1);
    if ((ord === $m_s_math_Ordering$Int$())) {
      var a$2 = $m_ju_Arrays$().copyOf__AI__I__AI(x3, len);
      $m_ju_Arrays$().sort__AI__V(a$2);
      return a$2;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_J)) {
    var x4 = $asArrayOf_J(this$, 1);
    if ((ord === $m_s_math_Ordering$Long$())) {
      var a$3 = $m_ju_Arrays$().copyOf__AJ__I__AJ(x4, len);
      $m_ju_Arrays$().sort__AJ__V(a$3);
      return a$3;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_C)) {
    var x5 = $asArrayOf_C(this$, 1);
    if ((ord === $m_s_math_Ordering$Char$())) {
      var a$4 = $m_ju_Arrays$().copyOf__AC__I__AC(x5, len);
      $m_ju_Arrays$().sort__AC__V(a$4);
      return a$4;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_B)) {
    var x6 = $asArrayOf_B(this$, 1);
    if ((ord === $m_s_math_Ordering$Byte$())) {
      var a$5 = $m_ju_Arrays$().copyOf__AB__I__AB(x6, len);
      $m_ju_Arrays$().sort__AB__V(a$5);
      return a$5;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_S)) {
    var x7 = $asArrayOf_S(this$, 1);
    if ((ord === $m_s_math_Ordering$Short$())) {
      var a$6 = $m_ju_Arrays$().copyOf__AS__I__AS(x7, len);
      $m_ju_Arrays$().sort__AS__V(a$6);
      return a$6;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_Z)) {
    var x8 = $asArrayOf_Z(this$, 1);
    if ((ord === $m_s_math_Ordering$Boolean$())) {
      var a$7 = $m_ju_Arrays$().copyOf__AZ__I__AZ(x8, len);
      var this$2 = $m_s_util_Sorting$();
      var evidence$3 = $m_s_math_Ordering$Boolean$();
      this$2.stableSort__O__I__I__s_math_Ordering__V(a$7, 0, $n(a$7).u.length, evidence$3);
      return a$7;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else {
    return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
  }
});
var $d_sc_ArrayOps$ = new $TypeData().initClass($c_sc_ArrayOps$, "scala.collection.ArrayOps$", ({
  sc_ArrayOps$: 1
}));
var $n_sc_ArrayOps$;
function $m_sc_ArrayOps$() {
  if ((!$n_sc_ArrayOps$)) {
    $n_sc_ArrayOps$ = new $c_sc_ArrayOps$();
  }
  return $n_sc_ArrayOps$;
}
/** @constructor */
function $c_sc_BitSetOps$() {
}
$c_sc_BitSetOps$.prototype = new $h_O();
$c_sc_BitSetOps$.prototype.constructor = $c_sc_BitSetOps$;
/** @constructor */
function $h_sc_BitSetOps$() {
}
$h_sc_BitSetOps$.prototype = $c_sc_BitSetOps$.prototype;
$c_sc_BitSetOps$.prototype.updateArray__AJ__I__J__AJ = (function(elems, idx, w_$_lo, w_$_hi) {
  var len = (($n(elems).u.length >>> 1) | 0);
  while (true) {
    if ((len > 0)) {
      var $x_2 = $n(elems).u;
      var $x_3 = $aJCheckGet($x_2, ((len - 1) | 0));
      var x_$_lo = $x_2[$x_3];
      var x_$_hi = $x_2[(($x_3 + 1) | 0)];
      if (((x_$_lo | x_$_hi) === 0)) {
        var $x_1 = true;
      } else {
        var $x_1 = (((w_$_lo | w_$_hi) === 0) && (idx === ((len - 1) | 0)));
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      len = ((len - 1) | 0);
    } else {
      break;
    }
  }
  var newlen = len;
  if (((idx >= newlen) && ((w_$_lo | w_$_hi) !== 0))) {
    newlen = ((1 + idx) | 0);
  }
  var newelems = new $ac_J(newlen);
  $m_s_Array$().copy__O__I__O__I__I__V(elems, 0, newelems, 0, len);
  if ((idx < newlen)) {
    newelems.set(idx, w_$_lo, w_$_hi);
  } else {
    $m_s_Predef$().assert__Z__V(((w_$_lo | w_$_hi) === 0));
  }
  return newelems;
});
$c_sc_BitSetOps$.prototype.computeWordForFilter__F1__Z__J__I__J = (function(pred, isFlipped, oldWord_$_lo, oldWord_$_hi, wordIndex) {
  if (((oldWord_$_lo | oldWord_$_hi) === 0)) {
    return $bL(0, 0);
  } else {
    var w_$_lo = oldWord_$_lo;
    var w_$_hi = oldWord_$_hi;
    var l_$_lo = w_$_lo;
    var l_$_hi = w_$_hi;
    if ((l_$_lo !== 0)) {
      var i = ((~l_$_lo) & ((l_$_lo - 1) | 0));
      var trailingZeroes = ((32 - Math.clz32(i)) | 0);
    } else {
      var i$1 = ((~l_$_hi) & ((l_$_hi - 1) | 0));
      var trailingZeroes = ((64 - Math.clz32(i$1)) | 0);
    }
    var lo = (((32 & trailingZeroes) === 0) ? (1 << trailingZeroes) : 0);
    var hi = (((32 & trailingZeroes) === 0) ? 0 : (1 << trailingZeroes));
    var jmask_$_lo = lo;
    var jmask_$_hi = hi;
    var j = (((wordIndex << 6) + trailingZeroes) | 0);
    var l$1_$_lo = w_$_lo;
    var l$1_$_hi = w_$_hi;
    var maxJ = (((((1 + wordIndex) | 0) << 6) - ((l$1_$_hi !== 0) ? Math.clz32(l$1_$_hi) : ((32 + Math.clz32(l$1_$_lo)) | 0))) | 0);
    while ((j !== maxJ)) {
      var x_$_lo = w_$_lo;
      var x_$_hi = w_$_hi;
      var x$1_$_lo = jmask_$_lo;
      var x$1_$_hi = jmask_$_hi;
      var lo$1 = (x_$_lo & x$1_$_lo);
      var hi$1 = (x_$_hi & x$1_$_hi);
      if (((lo$1 | hi$1) !== 0)) {
        if (($n(pred).apply$mcZI$sp__I__Z(j) === isFlipped)) {
          var x$3_$_lo = w_$_lo;
          var x$3_$_hi = w_$_hi;
          var x$2_$_lo = jmask_$_lo;
          var x$2_$_hi = jmask_$_hi;
          var lo$2 = (~x$2_$_lo);
          var hi$2 = (~x$2_$_hi);
          var lo$3 = (x$3_$_lo & lo$2);
          var hi$3 = (x$3_$_hi & hi$2);
          w_$_lo = lo$3;
          w_$_hi = hi$3;
        }
      }
      var x$4_$_lo = jmask_$_lo;
      var x$4_$_hi = jmask_$_hi;
      var lo$4 = (x$4_$_lo << 1);
      var hi$4 = (((x$4_$_lo >>> 31) | 0) | (x$4_$_hi << 1));
      jmask_$_lo = lo$4;
      jmask_$_hi = hi$4;
      j = ((1 + j) | 0);
    }
    return $bL(w_$_lo, w_$_hi);
  }
});
var $d_sc_BitSetOps$ = new $TypeData().initClass($c_sc_BitSetOps$, "scala.collection.BitSetOps$", ({
  sc_BitSetOps$: 1
}));
var $n_sc_BitSetOps$;
function $m_sc_BitSetOps$() {
  if ((!$n_sc_BitSetOps$)) {
    $n_sc_BitSetOps$ = new $c_sc_BitSetOps$();
  }
  return $n_sc_BitSetOps$;
}
/** @constructor */
function $c_sc_Hashing$() {
}
$c_sc_Hashing$.prototype = new $h_O();
$c_sc_Hashing$.prototype.constructor = $c_sc_Hashing$;
/** @constructor */
function $h_sc_Hashing$() {
}
$h_sc_Hashing$.prototype = $c_sc_Hashing$.prototype;
$c_sc_Hashing$.prototype.improve__I__I = (function(hcode) {
  var h = ((hcode + (~(hcode << 9))) | 0);
  h = (h ^ ((h >>> 14) | 0));
  h = ((h + (h << 4)) | 0);
  return (h ^ ((h >>> 10) | 0));
});
var $d_sc_Hashing$ = new $TypeData().initClass($c_sc_Hashing$, "scala.collection.Hashing$", ({
  sc_Hashing$: 1
}));
var $n_sc_Hashing$;
function $m_sc_Hashing$() {
  if ((!$n_sc_Hashing$)) {
    $n_sc_Hashing$ = new $c_sc_Hashing$();
  }
  return $n_sc_Hashing$;
}
function $is_sc_IterableOnce(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnce)));
}
function $as_sc_IterableOnce(obj) {
  return (($is_sc_IterableOnce(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnce"));
}
function $isArrayOf_sc_IterableOnce(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnce)));
}
function $asArrayOf_sc_IterableOnce(obj, depth) {
  return (($isArrayOf_sc_IterableOnce(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnce;", depth));
}
function $f_sc_IterableOnceOps__foreach__F1__V($thiz, f) {
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    $n(f).apply__O__O($n(it).next__O());
  }
}
function $f_sc_IterableOnceOps__forall__F1__Z($thiz, p) {
  var res = true;
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ((res && $n(it).hasNext__Z())) {
    res = $uZ($n(p).apply__O__O($n(it).next__O()));
  }
  return res;
}
function $f_sc_IterableOnceOps__exists__F1__Z($thiz, p) {
  var res = false;
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while (((!res) && $n(it).hasNext__Z())) {
    res = $uZ($n(p).apply__O__O($n(it).next__O()));
  }
  return res;
}
function $f_sc_IterableOnceOps__foldLeft__O__F2__O($thiz, z, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    var x2 = $as_sc_IndexedSeq($thiz);
    return $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, 0, $n(x2).length__I(), z, op, x2);
  } else {
    var result = z;
    var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      result = $n(op).apply__O__O__O(result, $n(it).next__O());
    }
    return result;
  }
}
function $f_sc_IterableOnceOps__isEmpty__Z($thiz) {
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  switch (x1) {
    case (-1): {
      return (!$n($n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator()).hasNext__Z());
      break;
    }
    case 0: {
      return true;
      break;
    }
    default: {
      return false;
    }
  }
}
function $f_sc_IterableOnceOps__size__I($thiz) {
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() >= 0)) {
    return $n($as_sc_IterableOnce($thiz)).knownSize__I();
  } else {
    var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
    var len = 0;
    while ($n(it).hasNext__Z()) {
      len = ((1 + len) | 0);
      $n(it).next__O();
    }
    return len;
  }
}
function $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, dest, start, n) {
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  var i = start;
  var x1 = $n($as_sc_IterableOnce($thiz)).knownSize__I();
  var srclen = ((x1 === (-1)) ? $m_jl_reflect_Array$().getLength__O__I(dest) : x1);
  var destLen = $m_jl_reflect_Array$().getLength__O__I(dest);
  var limit = ((n < srclen) ? n : srclen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var end = ((start + ((total < 0) ? 0 : total)) | 0);
  while (((i < end) && $n(it).hasNext__Z())) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest, i, $n(it).next__O());
    i = ((1 + i) | 0);
  }
  return ((i - start) | 0);
}
function $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, sep, end) {
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() === 0)) {
    return (("" + start) + end);
  } else {
    var this$1 = $n($thiz.addString__scm_StringBuilder__T__T__T__scm_StringBuilder($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), start, sep, end));
    return $n(this$1.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
}
function $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, b, start, sep, end) {
  var jsb = $n(b).scm_StringBuilder__f_underlying;
  var this$1 = $n(start);
  if ((this$1.length !== 0)) {
    var this$2 = $n(jsb);
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  }
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var this$3 = $n(jsb);
    var obj = $n(it).next__O();
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    while ($n(it).hasNext__Z()) {
      var this$4 = $n(sep);
      if ((this$4.length !== 0)) {
        var this$5 = $n(jsb);
        this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      }
      var this$6 = $n(jsb);
      var obj$1 = $n(it).next__O();
      this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
    }
  }
  var this$7 = $n(end);
  if ((this$7.length !== 0)) {
    var this$8 = $n(jsb);
    this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  }
  return b;
}
function $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($thiz, evidence$2) {
  if (($n($as_sc_IterableOnce($thiz)).knownSize__I() >= 0)) {
    var destination = $n(evidence$2).newArray__I__O($n($as_sc_IterableOnce($thiz)).knownSize__I());
    $thiz.copyToArray__O__I__I__I(destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = $n(evidence$2).runtimeClass__jl_Class();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var xs = $as_sc_IterableOnce($thiz);
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(elementClass).data.zero : elem));
      jsElems.push(unboxedElem);
    }
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return $n(elemRuntimeClass).data.getArrayOf().wrapArray(jsElems);
  }
}
function $f_sc_IterableOnceOps__reversed__sc_Iterable($thiz) {
  var xs = $m_sci_Nil$();
  var it = $n($as_sc_IterableOnce($thiz)).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var rassoc$1 = $n(it).next__O();
    var this$1 = $n(xs);
    xs = new $c_sci_$colon$colon(rassoc$1, this$1);
  }
  return xs;
}
function $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, at, end, acc, op$1, seq$1) {
  while (true) {
    if ((at === end)) {
      return acc;
    } else {
      var temp$at = ((1 + at) | 0);
      var temp$acc = $n(op$1).apply__O__O__O(acc, $n(seq$1).apply__I__O(at));
      at = temp$at;
      acc = temp$acc;
    }
  }
}
function $is_sc_IterableOnceOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnceOps)));
}
function $as_sc_IterableOnceOps(obj) {
  return (($is_sc_IterableOnceOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnceOps"));
}
function $isArrayOf_sc_IterableOnceOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnceOps)));
}
function $asArrayOf_sc_IterableOnceOps(obj, depth) {
  return (($isArrayOf_sc_IterableOnceOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnceOps;", depth));
}
/** @constructor */
function $c_sc_Iterator$ConcatIteratorCell(head, tail) {
  this.sc_Iterator$ConcatIteratorCell__f_head = null;
  this.sc_Iterator$ConcatIteratorCell__f_tail = null;
  this.sc_Iterator$ConcatIteratorCell__f_head = head;
  this.sc_Iterator$ConcatIteratorCell__f_tail = tail;
}
$c_sc_Iterator$ConcatIteratorCell.prototype = new $h_O();
$c_sc_Iterator$ConcatIteratorCell.prototype.constructor = $c_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $h_sc_Iterator$ConcatIteratorCell() {
}
$h_sc_Iterator$ConcatIteratorCell.prototype = $c_sc_Iterator$ConcatIteratorCell.prototype;
$c_sc_Iterator$ConcatIteratorCell.prototype.headIterator__sc_Iterator = (function() {
  return $n($as_sc_IterableOnce($n(this.sc_Iterator$ConcatIteratorCell__f_head).apply__O())).iterator__sc_Iterator();
});
var $d_sc_Iterator$ConcatIteratorCell = new $TypeData().initClass($c_sc_Iterator$ConcatIteratorCell, "scala.collection.Iterator$ConcatIteratorCell", ({
  sc_Iterator$ConcatIteratorCell: 1
}));
function $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps($thiz) {
  if ((!$thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0)) {
    $thiz.sc_LinearSeqIterator$LazyCell__f_v = $as_sc_LinearSeqOps($n($thiz.sc_LinearSeqIterator$LazyCell__f_st).apply__O());
    $thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = true;
  }
  $thiz.sc_LinearSeqIterator$LazyCell__f_st = null;
  return $thiz.sc_LinearSeqIterator$LazyCell__f_v;
}
/** @constructor */
function $c_sc_LinearSeqIterator$LazyCell(outer, st) {
  this.sc_LinearSeqIterator$LazyCell__f_v = null;
  this.sc_LinearSeqIterator$LazyCell__f_st = null;
  this.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = false;
  this.sc_LinearSeqIterator$LazyCell__f_st = st;
}
$c_sc_LinearSeqIterator$LazyCell.prototype = new $h_O();
$c_sc_LinearSeqIterator$LazyCell.prototype.constructor = $c_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $h_sc_LinearSeqIterator$LazyCell() {
}
$h_sc_LinearSeqIterator$LazyCell.prototype = $c_sc_LinearSeqIterator$LazyCell.prototype;
$c_sc_LinearSeqIterator$LazyCell.prototype.v__sc_LinearSeqOps = (function() {
  return ((!this.sc_LinearSeqIterator$LazyCell__f_bitmap$0) ? $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps(this) : this.sc_LinearSeqIterator$LazyCell__f_v);
});
var $d_sc_LinearSeqIterator$LazyCell = new $TypeData().initClass($c_sc_LinearSeqIterator$LazyCell, "scala.collection.LinearSeqIterator$LazyCell", ({
  sc_LinearSeqIterator$LazyCell: 1
}));
/** @constructor */
function $c_sc_StringOps$() {
  this.sc_StringOps$__f_fallback = null;
  $n_sc_StringOps$ = this;
  this.sc_StringOps$__f_fallback = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $m_sc_StringOps$().sc_StringOps$__f_fallback));
}
$c_sc_StringOps$.prototype = new $h_O();
$c_sc_StringOps$.prototype.constructor = $c_sc_StringOps$;
/** @constructor */
function $h_sc_StringOps$() {
}
$h_sc_StringOps$.prototype = $c_sc_StringOps$.prototype;
$c_sc_StringOps$.prototype.slice$extension__T__I__I__T = (function(this$, from, until) {
  var start = ((from > 0) ? from : 0);
  var this$6 = $n(this$);
  var that = this$6.length;
  var end = ((until < that) ? until : that);
  if ((start >= end)) {
    return "";
  } else {
    var this$10 = $n(this$);
    if ((start < 0)) {
      $charAt(this$10, start);
    }
    if ((end > this$10.length)) {
      $charAt(this$10, end);
    }
    if ((end < start)) {
      $charAt(this$10, (-1));
    }
    return $as_T(this$10.substring(start, end));
  }
});
$c_sc_StringOps$.prototype.stripSuffix$extension__T__T__T = (function(this$, suffix) {
  var this$1 = $n(this$);
  if ($uZ(this$1.endsWith($n(suffix)))) {
    var this$4 = $n(this$);
    var this$2 = $n(this$);
    var this$3 = $n(suffix);
    var endIndex = ((this$2.length - this$3.length) | 0);
    if ((endIndex > this$4.length)) {
      $charAt(this$4, endIndex);
    }
    if ((endIndex < 0)) {
      $charAt(this$4, (-1));
    }
    return $as_T(this$4.substring(0, endIndex));
  } else {
    return this$;
  }
});
$c_sc_StringOps$.prototype.stripMargin$extension__T__C__T = (function(this$, marginChar) {
  var this$1 = $n(this$);
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), this$1.length);
  var this$4 = new $c_sc_StringOps$$anon$1(this$, false);
  while ((this$4.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this$4.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var x0 = this$4.next__T();
    var this$5 = $n(x0);
    var len = this$5.length;
    var index = 0;
    while (true) {
      if ((index < len)) {
        var this$6 = $n(x0);
        var index$1 = index;
        var $x_1 = ($charAt(this$6, index$1) <= 32);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        index = ((1 + index) | 0);
      } else {
        break;
      }
    }
    if ((index < len)) {
      var this$7 = $n(x0);
      var index$2 = index;
      var $x_2 = ($charAt(this$7, index$2) === marginChar);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var this$8 = $n(x0);
      var beginIndex = ((1 + index) | 0);
      if (((beginIndex < 0) || (beginIndex > this$8.length))) {
        $charAt(this$8, beginIndex);
      }
      var stripped = $as_T(this$8.substring(beginIndex));
    } else {
      var stripped = x0;
    }
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + stripped);
  }
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sc_StringOps$.prototype.toBooleanImpl$extension__T__T__Z = (function(this$, s) {
  if ((s === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "For input string: \"null\"");
  } else {
    var this$1 = $n(s);
    _return: {
      var len = this$1.length;
      if ((len === 4)) {
        var i = 0;
        while ((i !== len)) {
          var thisCP = $f_T__codePointAt__I__I(this$1, i);
          var $x_2 = $m_jl_Character$().toLowerCase__I__I($m_jl_Character$().toUpperCase__I__I(thisCP));
          var cp = $f_T__codePointAt__I__I("true", i);
          if (($x_2 !== $m_jl_Character$().toLowerCase__I__I($m_jl_Character$().toUpperCase__I__I(cp)))) {
            var $x_1 = false;
            break _return;
          }
          i = ((i + ((thisCP >= 65536) ? 2 : 1)) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      return true;
    } else {
      var this$3 = $n(s);
      _return$1: {
        var len$1 = this$3.length;
        if ((len$1 === 5)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var thisCP$1 = $f_T__codePointAt__I__I(this$3, i$1);
            var $x_4 = $m_jl_Character$().toLowerCase__I__I($m_jl_Character$().toUpperCase__I__I(thisCP$1));
            var cp$1 = $f_T__codePointAt__I__I("false", i$1);
            if (($x_4 !== $m_jl_Character$().toLowerCase__I__I($m_jl_Character$().toUpperCase__I__I(cp$1)))) {
              var $x_3 = false;
              break _return$1;
            }
            i$1 = ((i$1 + ((thisCP$1 >= 65536) ? 2 : 1)) | 0);
          }
          var $x_3 = true;
        } else {
          var $x_3 = false;
        }
      }
      if ((!$x_3)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("For input string: \"" + s) + "\""));
      }
      return false;
    }
  }
});
$c_sc_StringOps$.prototype.unwrapArg$extension__T__O__O = (function(this$, arg) {
  if ((arg instanceof $c_s_math_ScalaNumber)) {
    var x2 = $as_s_math_ScalaNumber(arg);
    return $n(x2).underlying__O();
  } else {
    return arg;
  }
});
$c_sc_StringOps$.prototype.format$extension__T__sci_Seq__T = (function(this$, args) {
  var args$1 = $asArrayOf_O($n($as_sc_IterableOnceOps($n(args).map__F1__O(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((arg$2$2) => $m_sc_StringOps$().unwrapArg$extension__T__O__O(this$, arg$2$2)))))).toArray__s_reflect_ClassTag__O($m_s_reflect_ManifestFactory$ObjectManifest$()), 1);
  return $m_jl_String$().format__T__AO__T(this$, args$1);
});
$c_sc_StringOps$.prototype.reverse$extension__T__T = (function(this$) {
  return $n($ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), this$).reverse__jl_StringBuilder()).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sc_StringOps$.prototype.take$extension__T__I__T = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var this$1 = $n(this$);
  var y = this$1.length;
  return $x_1.slice$extension__T__I__I__T(this$, 0, ((n < y) ? n : y));
});
$c_sc_StringOps$.prototype.drop$extension__T__I__T = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var this$1 = $n(this$);
  var y = this$1.length;
  var this$4 = $n(this$);
  return $x_1.slice$extension__T__I__I__T(this$, ((n < y) ? n : y), this$4.length);
});
$c_sc_StringOps$.prototype.dropRight$extension__T__I__T = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var this$1 = $n(this$);
  return $x_1.take$extension__T__I__T(this$, ((this$1.length - ((n > 0) ? n : 0)) | 0));
});
var $d_sc_StringOps$ = new $TypeData().initClass($c_sc_StringOps$, "scala.collection.StringOps$", ({
  sc_StringOps$: 1
}));
var $n_sc_StringOps$;
function $m_sc_StringOps$() {
  if ((!$n_sc_StringOps$)) {
    $n_sc_StringOps$ = new $c_sc_StringOps$();
  }
  return $n_sc_StringOps$;
}
function $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option($thiz, i, agg_$_lo, agg_$_hi, isPositive, len$3, from$3) {
  while (true) {
    if ((i === len$3)) {
      if (isPositive) {
        var x_$_lo = agg_$_lo;
        var x_$_hi = agg_$_hi;
        var $x_1 = ((x_$_lo | ((-2147483648) ^ x_$_hi)) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return $m_s_None$();
      } else if (isPositive) {
        var x$1_$_lo = agg_$_lo;
        var x$1_$_hi = agg_$_hi;
        var lo = ((-x$1_$_lo) | 0);
        var hi = ((((-x$1_$_hi) | 0) + ((x$1_$_lo | lo) >> 31)) | 0);
        return new $c_s_Some($bL(lo, hi));
      } else {
        return new $c_s_Some($bL(agg_$_lo, agg_$_hi));
      }
    } else {
      var x$2_$_lo = agg_$_lo;
      var x$2_$_hi = agg_$_hi;
      if (((x$2_$_hi === (-214748365)) ? ((x$2_$_lo >>> 0) < 858993460) : (x$2_$_hi < (-214748365)))) {
        return $m_s_None$();
      } else {
        var this$4 = $n(from$3);
        var index = i;
        var ch = $charAt(this$4, index);
        var this$5 = $m_jl_Character$();
        var codePoint = ch;
        var digit = this$5.digitWithValidRadix__I__I__I(codePoint, 10);
        if ((digit === (-1))) {
          var $x_2 = true;
        } else {
          var x$3_$_lo = agg_$_lo;
          var x$3_$_hi = agg_$_hi;
          if ((((858993460 ^ x$3_$_lo) | ((-214748365) ^ x$3_$_hi)) === 0)) {
            var $x_2 = (digit === 9);
          } else {
            var $x_2 = false;
          }
        }
        if ($x_2) {
          return $m_s_None$();
        } else {
          var temp$i = ((1 + i) | 0);
          var x$4_$_lo = agg_$_lo;
          var x$4_$_hi = agg_$_hi;
          var b0 = (65535 & x$4_$_lo);
          var b1 = ((x$4_$_lo >>> 16) | 0);
          var a0b0 = Math.imul(10, b0);
          var a0b1 = Math.imul(10, b1);
          var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$1 = ((Math.imul(10, x$4_$_hi) + ((c1part >>> 16) | 0)) | 0);
          var hi$2 = (digit >> 31);
          var lo$2 = ((lo$1 - digit) | 0);
          var hi$3 = ((((hi$1 - hi$2) | 0) + ((((~lo$1) & digit) | ((~(lo$1 ^ digit)) & lo$2)) >> 31)) | 0);
          i = temp$i;
          agg_$_lo = lo$2;
          agg_$_hi = hi$3;
        }
      }
    }
  }
}
/** @constructor */
function $c_sc_StringParsers$() {
}
$c_sc_StringParsers$.prototype = new $h_O();
$c_sc_StringParsers$.prototype.constructor = $c_sc_StringParsers$;
/** @constructor */
function $h_sc_StringParsers$() {
}
$h_sc_StringParsers$.prototype = $c_sc_StringParsers$.prototype;
$c_sc_StringParsers$.prototype.parseLong__T__s_Option = (function(from) {
  var this$1 = $n(from);
  var len = this$1.length;
  if ((len === 0)) {
    return $m_s_None$();
  } else {
    var this$2 = $n(from);
    var first = $charAt(this$2, 0);
    var this$3 = $m_jl_Character$();
    var codePoint = first;
    var value = this$3.digitWithValidRadix__I__I__I(codePoint, 10);
    var hi = (value >> 31);
    if ((len === 1)) {
      return ((hi > (-1)) ? new $c_s_Some($bL(value, hi)) : $m_s_None$());
    } else if ((hi > (-1))) {
      var lo = ((-value) | 0);
      var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
      return $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, lo, hi$1, true, len, from);
    } else {
      return ((first === 43) ? $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, 0, 0, true, len, from) : ((first === 45) ? $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, 0, 0, false, len, from) : $m_s_None$()));
    }
  }
});
var $d_sc_StringParsers$ = new $TypeData().initClass($c_sc_StringParsers$, "scala.collection.StringParsers$", ({
  sc_StringParsers$: 1
}));
var $n_sc_StringParsers$;
function $m_sc_StringParsers$() {
  if ((!$n_sc_StringParsers$)) {
    $n_sc_StringParsers$ = new $c_sc_StringParsers$();
  }
  return $n_sc_StringParsers$;
}
function $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set($thiz, s) {
  if ((s === null)) {
    return null;
  } else if ((s instanceof $c_sc_convert_JavaCollectionWrappers$JSetWrapper)) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$JSetWrapper(s);
    return $n(x3).sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying;
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$SetWrapper(s);
  }
}
/** @constructor */
function $c_sc_convert_AsJavaExtensions$SetHasAsJava(outer, s) {
  this.sc_convert_AsJavaExtensions$SetHasAsJava__f_s = null;
  this.sc_convert_AsJavaExtensions$SetHasAsJava__f_s = s;
  $n(outer);
}
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype = new $h_O();
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype.constructor = $c_sc_convert_AsJavaExtensions$SetHasAsJava;
/** @constructor */
function $h_sc_convert_AsJavaExtensions$SetHasAsJava() {
}
$h_sc_convert_AsJavaExtensions$SetHasAsJava.prototype = $c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype;
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype.asJava__ju_Set = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var s = this.sc_convert_AsJavaExtensions$SetHasAsJava__f_s;
  return $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set(this$1, s);
});
var $d_sc_convert_AsJavaExtensions$SetHasAsJava = new $TypeData().initClass($c_sc_convert_AsJavaExtensions$SetHasAsJava, "scala.collection.convert.AsJavaExtensions$SetHasAsJava", ({
  sc_convert_AsJavaExtensions$SetHasAsJava: 1
}));
function $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator($thiz, i) {
  if ((i === null)) {
    return null;
  } else if (false) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$IteratorWrapper(i);
    return $n(x3).underlying__sc_Iterator();
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(i);
  }
}
function $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set($thiz, s) {
  if ((s === null)) {
    return null;
  } else if (false) {
    var x3 = $as_sc_convert_JavaCollectionWrappers$MutableSetWrapper(s);
    return $n(x3).underlying__scm_Set();
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$JSetWrapper(s);
  }
}
/** @constructor */
function $c_sc_convert_AsScalaExtensions$IteratorHasAsScala(outer, i) {
  this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i = null;
  this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i = i;
  $n(outer);
}
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = new $h_O();
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.constructor = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala;
/** @constructor */
function $h_sc_convert_AsScalaExtensions$IteratorHasAsScala() {
}
$h_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype;
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.asScala__sc_Iterator = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var i = this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i;
  return $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator(this$1, i);
});
var $d_sc_convert_AsScalaExtensions$IteratorHasAsScala = new $TypeData().initClass($c_sc_convert_AsScalaExtensions$IteratorHasAsScala, "scala.collection.convert.AsScalaExtensions$IteratorHasAsScala", ({
  sc_convert_AsScalaExtensions$IteratorHasAsScala: 1
}));
/** @constructor */
function $c_sc_convert_AsScalaExtensions$SetHasAsScala(outer, s) {
  this.sc_convert_AsScalaExtensions$SetHasAsScala__f_s = null;
  this.sc_convert_AsScalaExtensions$SetHasAsScala__f_s = s;
  $n(outer);
}
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype = new $h_O();
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype.constructor = $c_sc_convert_AsScalaExtensions$SetHasAsScala;
/** @constructor */
function $h_sc_convert_AsScalaExtensions$SetHasAsScala() {
}
$h_sc_convert_AsScalaExtensions$SetHasAsScala.prototype = $c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype;
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype.asScala__scm_Set = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var s = this.sc_convert_AsScalaExtensions$SetHasAsScala__f_s;
  return $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set(this$1, s);
});
var $d_sc_convert_AsScalaExtensions$SetHasAsScala = new $TypeData().initClass($c_sc_convert_AsScalaExtensions$SetHasAsScala, "scala.collection.convert.AsScalaExtensions$SetHasAsScala", ({
  sc_convert_AsScalaExtensions$SetHasAsScala: 1
}));
/** @constructor */
function $c_scg_CommonErrors$() {
}
$c_scg_CommonErrors$.prototype = new $h_O();
$c_scg_CommonErrors$.prototype.constructor = $c_scg_CommonErrors$;
/** @constructor */
function $h_scg_CommonErrors$() {
}
$h_scg_CommonErrors$.prototype = $c_scg_CommonErrors$.prototype;
$c_scg_CommonErrors$.prototype.indexOutOfBounds__I__I__jl_IndexOutOfBoundsException = (function(index, max) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + max) + ")"));
});
$c_scg_CommonErrors$.prototype.indexOutOfBounds__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (min 0, max unknown)"));
});
var $d_scg_CommonErrors$ = new $TypeData().initClass($c_scg_CommonErrors$, "scala.collection.generic.CommonErrors$", ({
  scg_CommonErrors$: 1
}));
var $n_scg_CommonErrors$;
function $m_scg_CommonErrors$() {
  if ((!$n_scg_CommonErrors$)) {
    $n_scg_CommonErrors$ = new $c_scg_CommonErrors$();
  }
  return $n_scg_CommonErrors$;
}
function $ps_sci_IndexedSeqDefaults$__liftedTree1$1__I() {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.IndexedSeq.defaultApplyPreferredMaxLength", "64");
    var this$4 = $m_jl_Integer$();
    return this$4.java$lang$Integer$$parseIntImpl__T__I__I__I(x, 10, 214748364);
  } catch (e) {
    if (false) {
      return 64;
    } else {
      throw e;
    }
  }
}
/** @constructor */
function $c_sci_IndexedSeqDefaults$() {
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = 0;
  $n_sci_IndexedSeqDefaults$ = this;
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = $ps_sci_IndexedSeqDefaults$__liftedTree1$1__I();
}
$c_sci_IndexedSeqDefaults$.prototype = new $h_O();
$c_sci_IndexedSeqDefaults$.prototype.constructor = $c_sci_IndexedSeqDefaults$;
/** @constructor */
function $h_sci_IndexedSeqDefaults$() {
}
$h_sci_IndexedSeqDefaults$.prototype = $c_sci_IndexedSeqDefaults$.prototype;
var $d_sci_IndexedSeqDefaults$ = new $TypeData().initClass($c_sci_IndexedSeqDefaults$, "scala.collection.immutable.IndexedSeqDefaults$", ({
  sci_IndexedSeqDefaults$: 1
}));
var $n_sci_IndexedSeqDefaults$;
function $m_sci_IndexedSeqDefaults$() {
  if ((!$n_sci_IndexedSeqDefaults$)) {
    $n_sci_IndexedSeqDefaults$ = new $c_sci_IndexedSeqDefaults$();
  }
  return $n_sci_IndexedSeqDefaults$;
}
/** @constructor */
function $c_sci_LazyList$Deferrer$() {
}
$c_sci_LazyList$Deferrer$.prototype = new $h_O();
$c_sci_LazyList$Deferrer$.prototype.constructor = $c_sci_LazyList$Deferrer$;
/** @constructor */
function $h_sci_LazyList$Deferrer$() {
}
$h_sci_LazyList$Deferrer$.prototype = $c_sci_LazyList$Deferrer$.prototype;
$c_sci_LazyList$Deferrer$.prototype.$hash$colon$colon$extension__F0__F0__sci_LazyList = (function(this$, elem) {
  $m_sci_LazyList$();
  var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_LazyList$();
    var hd = $n(elem).apply__O();
    $m_sci_LazyList$();
    var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), this$);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
});
var $d_sci_LazyList$Deferrer$ = new $TypeData().initClass($c_sci_LazyList$Deferrer$, "scala.collection.immutable.LazyList$Deferrer$", ({
  sci_LazyList$Deferrer$: 1
}));
var $n_sci_LazyList$Deferrer$;
function $m_sci_LazyList$Deferrer$() {
  if ((!$n_sci_LazyList$Deferrer$)) {
    $n_sci_LazyList$Deferrer$ = new $c_sci_LazyList$Deferrer$();
  }
  return $n_sci_LazyList$Deferrer$;
}
/** @constructor */
function $c_sci_LazyList$EmptyMarker$() {
}
$c_sci_LazyList$EmptyMarker$.prototype = new $h_O();
$c_sci_LazyList$EmptyMarker$.prototype.constructor = $c_sci_LazyList$EmptyMarker$;
/** @constructor */
function $h_sci_LazyList$EmptyMarker$() {
}
$h_sci_LazyList$EmptyMarker$.prototype = $c_sci_LazyList$EmptyMarker$.prototype;
var $d_sci_LazyList$EmptyMarker$ = new $TypeData().initClass($c_sci_LazyList$EmptyMarker$, "scala.collection.immutable.LazyList$EmptyMarker$", ({
  sci_LazyList$EmptyMarker$: 1
}));
var $n_sci_LazyList$EmptyMarker$;
function $m_sci_LazyList$EmptyMarker$() {
  if ((!$n_sci_LazyList$EmptyMarker$)) {
    $n_sci_LazyList$EmptyMarker$ = new $c_sci_LazyList$EmptyMarker$();
  }
  return $n_sci_LazyList$EmptyMarker$;
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder$DeferredState() {
  this.sci_LazyList$LazyBuilder$DeferredState__f__tail = null;
}
$c_sci_LazyList$LazyBuilder$DeferredState.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.constructor = $c_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $h_sci_LazyList$LazyBuilder$DeferredState() {
}
$h_sci_LazyList$LazyBuilder$DeferredState.prototype = $c_sci_LazyList$LazyBuilder$DeferredState.prototype;
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.eval__sci_LazyList = (function() {
  var state = this.sci_LazyList$LazyBuilder$DeferredState__f__tail;
  if ((state === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "uninitialized");
  }
  return $as_sci_LazyList($n(state).apply__O());
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.init__F0__V = (function(state) {
  if ((this.sci_LazyList$LazyBuilder$DeferredState__f__tail !== null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "already initialized");
  }
  this.sci_LazyList$LazyBuilder$DeferredState__f__tail = state;
});
var $d_sci_LazyList$LazyBuilder$DeferredState = new $TypeData().initClass($c_sci_LazyList$LazyBuilder$DeferredState, "scala.collection.immutable.LazyList$LazyBuilder$DeferredState", ({
  sci_LazyList$LazyBuilder$DeferredState: 1
}));
/** @constructor */
function $c_sci_LazyList$MidEvaluation$() {
}
$c_sci_LazyList$MidEvaluation$.prototype = new $h_O();
$c_sci_LazyList$MidEvaluation$.prototype.constructor = $c_sci_LazyList$MidEvaluation$;
/** @constructor */
function $h_sci_LazyList$MidEvaluation$() {
}
$h_sci_LazyList$MidEvaluation$.prototype = $c_sci_LazyList$MidEvaluation$.prototype;
var $d_sci_LazyList$MidEvaluation$ = new $TypeData().initClass($c_sci_LazyList$MidEvaluation$, "scala.collection.immutable.LazyList$MidEvaluation$", ({
  sci_LazyList$MidEvaluation$: 1
}));
var $n_sci_LazyList$MidEvaluation$;
function $m_sci_LazyList$MidEvaluation$() {
  if ((!$n_sci_LazyList$MidEvaluation$)) {
    $n_sci_LazyList$MidEvaluation$ = new $c_sci_LazyList$MidEvaluation$();
  }
  return $n_sci_LazyList$MidEvaluation$;
}
/** @constructor */
function $c_sci_MapNode$() {
  this.sci_MapNode$__f_EmptyMapNode = null;
  $n_sci_MapNode$ = this;
  this.sci_MapNode$__f_EmptyMapNode = new $c_sci_BitmapIndexedMapNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
$c_sci_MapNode$.prototype = new $h_O();
$c_sci_MapNode$.prototype.constructor = $c_sci_MapNode$;
/** @constructor */
function $h_sci_MapNode$() {
}
$h_sci_MapNode$.prototype = $c_sci_MapNode$.prototype;
var $d_sci_MapNode$ = new $TypeData().initClass($c_sci_MapNode$, "scala.collection.immutable.MapNode$", ({
  sci_MapNode$: 1
}));
var $n_sci_MapNode$;
function $m_sci_MapNode$() {
  if ((!$n_sci_MapNode$)) {
    $n_sci_MapNode$ = new $c_sci_MapNode$();
  }
  return $n_sci_MapNode$;
}
function $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException($thiz, as, ix) {
  return $ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((ix + " is out of bounds (min 0, max ") + (($m_jl_reflect_Array$().getLength__O__I(as) - 1) | 0)));
}
/** @constructor */
function $c_sci_Node() {
}
$c_sci_Node.prototype = new $h_O();
$c_sci_Node.prototype.constructor = $c_sci_Node;
/** @constructor */
function $h_sci_Node() {
}
$h_sci_Node.prototype = $c_sci_Node.prototype;
$c_sci_Node.prototype.removeElement__AI__I__AI = (function(as, ix) {
  if ((ix < 0)) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix));
  }
  if ((ix > (($n(as).u.length - 1) | 0))) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix));
  }
  var result = new $ac_I((($n(as).u.length - 1) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  var srcPos = ((1 + ix) | 0);
  var length = (((($n(as).u.length - ix) | 0) - 1) | 0);
  $systemArraycopy($n(as), srcPos, result, ix, length);
  return result;
});
$c_sci_Node.prototype.insertElement__AI__I__I__AI = (function(as, ix, elem) {
  if ((ix < 0)) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix));
  }
  if ((ix > $n(as).u.length)) {
    throw $n($p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix));
  }
  var result = new $ac_I(((1 + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = (($n(as).u.length - ix) | 0);
  $systemArraycopy($n(as), ix, result, destPos, length);
  return result;
});
var $d_sci_Node = new $TypeData().initClass(0, "scala.collection.immutable.Node", ({
  sci_Node: 1
}));
/** @constructor */
function $c_sci_Node$() {
  this.sci_Node$__f_MaxDepth = 0;
  $n_sci_Node$ = this;
  this.sci_Node$__f_MaxDepth = $doubleToInt($uD(Math.ceil(6.4)));
}
$c_sci_Node$.prototype = new $h_O();
$c_sci_Node$.prototype.constructor = $c_sci_Node$;
/** @constructor */
function $h_sci_Node$() {
}
$h_sci_Node$.prototype = $c_sci_Node$.prototype;
$c_sci_Node$.prototype.maskFrom__I__I__I = (function(hash, shift) {
  return (31 & ((hash >>> shift) | 0));
});
$c_sci_Node$.prototype.bitposFrom__I__I = (function(mask) {
  return (1 << mask);
});
$c_sci_Node$.prototype.indexFrom__I__I__I = (function(bitmap, bitpos) {
  var i = (bitmap & ((bitpos - 1) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_Node$.prototype.indexFrom__I__I__I__I = (function(bitmap, mask, bitpos) {
  return ((bitmap === (-1)) ? mask : this.indexFrom__I__I__I(bitmap, bitpos));
});
var $d_sci_Node$ = new $TypeData().initClass($c_sci_Node$, "scala.collection.immutable.Node$", ({
  sci_Node$: 1
}));
var $n_sci_Node$;
function $m_sci_Node$() {
  if ((!$n_sci_Node$)) {
    $n_sci_Node$ = new $c_sci_Node$();
  }
  return $n_sci_Node$;
}
/** @constructor */
function $c_sci_SetNode$() {
  this.sci_SetNode$__f_EmptySetNode = null;
  $n_sci_SetNode$ = this;
  this.sci_SetNode$__f_EmptySetNode = new $c_sci_BitmapIndexedSetNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
$c_sci_SetNode$.prototype = new $h_O();
$c_sci_SetNode$.prototype.constructor = $c_sci_SetNode$;
/** @constructor */
function $h_sci_SetNode$() {
}
$h_sci_SetNode$.prototype = $c_sci_SetNode$.prototype;
var $d_sci_SetNode$ = new $TypeData().initClass($c_sci_SetNode$, "scala.collection.immutable.SetNode$", ({
  sci_SetNode$: 1
}));
var $n_sci_SetNode$;
function $m_sci_SetNode$() {
  if ((!$n_sci_SetNode$)) {
    $n_sci_SetNode$ = new $c_sci_SetNode$();
  }
  return $n_sci_SetNode$;
}
function $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, n, a, lo, hi) {
  while (true) {
    if ((n === 1)) {
      var a$1 = a;
      var start = lo;
      var end = hi;
      $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, 1, (((start === 0) && (end === $n(a$1).u.length)) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, start, end)));
    } else {
      var bitsN = Math.imul(5, ((n - 1) | 0));
      var widthN = (1 << bitsN);
      var loN = ((lo >>> bitsN) | 0);
      var hiN = ((hi >>> bitsN) | 0);
      var loRest = (lo & ((widthN - 1) | 0));
      var hiRest = (hi & ((widthN - 1) | 0));
      if ((loRest === 0)) {
        if ((hiRest === 0)) {
          var $x_1 = n;
          var a$2 = a;
          $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_1, (((loN === 0) && (hiN === $n(a$2).u.length)) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, loN, hiN)));
        } else {
          if ((hiN > loN)) {
            var $x_2 = n;
            var a$3 = a;
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_2, (((loN === 0) && (hiN === $n(a$3).u.length)) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, loN, hiN)));
          }
          var temp$n = ((n - 1) | 0);
          var temp$a = $asArrayOf_O($n(a).get(hiN), 1);
          n = temp$n;
          a = temp$a;
          lo = 0;
          hi = hiRest;
          continue;
        }
      } else if ((hiN === loN)) {
        var temp$n$2 = ((n - 1) | 0);
        var temp$a$2 = $asArrayOf_O($n(a).get(loN), 1);
        n = temp$n$2;
        a = temp$a$2;
        lo = loRest;
        hi = hiRest;
        continue;
      } else {
        $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, ((n - 1) | 0), $asArrayOf_O($n(a).get(loN), 1), loRest, widthN);
        if ((hiRest === 0)) {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_3 = n;
            var a$4 = a;
            var start$1 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_3, (((start$1 === 0) && (hiN === $n(a$4).u.length)) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, start$1, hiN)));
          }
        } else {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_4 = n;
            var a$5 = a;
            var start$2 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_4, (((start$2 === 0) && (hiN === $n(a$5).u.length)) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, start$2, hiN)));
          }
          var temp$n$3 = ((n - 1) | 0);
          var temp$a$3 = $asArrayOf_O($n(a).get(hiN), 1);
          n = temp$n$3;
          a = temp$a$3;
          lo = 0;
          hi = hiRest;
          continue;
        }
      }
    }
    return (void 0);
  }
}
function $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, n, a) {
  if ((n <= $thiz.sci_VectorSliceBuilder__f_maxDim)) {
    var idx = ((11 - n) | 0);
  } else {
    $thiz.sci_VectorSliceBuilder__f_maxDim = n;
    var idx = ((n - 1) | 0);
  }
  $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(idx, a);
}
function $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, n) {
  if (($n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(((n - 1) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((n - 1) | 0), $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(((11 - n) | 0)));
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((11 - n) | 0), null);
    } else {
      $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, ((1 + n) | 0));
      var $x_1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var preN1 = $asArrayOf_O($n($x_1).get(((n$1 - 1) | 0)), 2);
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((n - 1) | 0), $n(preN1).get(0));
      if (($n(preN1).u.length === 1)) {
        var $x_2 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$2 = ((1 + n) | 0);
        $x_2.set(((n$2 - 1) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $x_4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $x_3 = ($n($x_4).get(((11 - n$3) | 0)) === null);
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n;
        }
      } else {
        var $x_5 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$4 = ((1 + n) | 0);
        var to = $n(preN1).u.length;
        $x_5.set(((n$4 - 1) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(preN1, 1, to));
      }
    }
  }
}
function $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, n) {
  if (($n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(((11 - n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((11 - n) | 0), $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(((n - 1) | 0)));
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((n - 1) | 0), null);
    } else {
      $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, ((1 + n) | 0));
      var $x_1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var sufN1 = $asArrayOf_O($n($x_1).get(((11 - n$1) | 0)), 2);
      $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).set(((11 - n) | 0), $n(sufN1).get((($n(sufN1).u.length - 1) | 0)));
      if (($n(sufN1).u.length === 1)) {
        var $x_2 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$2 = ((1 + n) | 0);
        $x_2.set(((11 - n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $x_4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $x_3 = ($n($x_4).get(((n$3 - 1) | 0)) === null);
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n;
        }
      } else {
        var $x_5 = $n($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
        var n$4 = ((1 + n) | 0);
        var to = (($n(sufN1).u.length - 1) | 0);
        $x_5.set(((11 - n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(sufN1, 0, to));
      }
    }
  }
}
/** @constructor */
function $c_sci_VectorSliceBuilder(lo, hi) {
  this.sci_VectorSliceBuilder__f_lo = 0;
  this.sci_VectorSliceBuilder__f_hi = 0;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = null;
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
  this.sci_VectorSliceBuilder__f_lo = lo;
  this.sci_VectorSliceBuilder__f_hi = hi;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = new ($d_O.getArrayOf().getArrayOf().constr)(11);
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
}
$c_sci_VectorSliceBuilder.prototype = new $h_O();
$c_sci_VectorSliceBuilder.prototype.constructor = $c_sci_VectorSliceBuilder;
/** @constructor */
function $h_sci_VectorSliceBuilder() {
}
$h_sci_VectorSliceBuilder.prototype = $c_sci_VectorSliceBuilder.prototype;
$c_sci_VectorSliceBuilder.prototype.consider__I__AO__V = (function(n, a) {
  var count = Math.imul($n(a).u.length, (1 << Math.imul(5, ((n - 1) | 0))));
  var a$1 = ((this.sci_VectorSliceBuilder__f_lo - this.sci_VectorSliceBuilder__f_pos) | 0);
  var lo0 = ((a$1 > 0) ? a$1 : 0);
  var a$2 = ((this.sci_VectorSliceBuilder__f_hi - this.sci_VectorSliceBuilder__f_pos) | 0);
  var hi0 = ((a$2 < count) ? a$2 : count);
  if ((hi0 > lo0)) {
    $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V(this, n, a, lo0, hi0);
    this.sci_VectorSliceBuilder__f_len = ((this.sci_VectorSliceBuilder__f_len + ((hi0 - lo0) | 0)) | 0);
  }
  this.sci_VectorSliceBuilder__f_pos = ((this.sci_VectorSliceBuilder__f_pos + count) | 0);
});
$c_sci_VectorSliceBuilder.prototype.result__sci_Vector = (function() {
  if ((this.sci_VectorSliceBuilder__f_len <= 32)) {
    if ((this.sci_VectorSliceBuilder__f_len === 0)) {
      return $m_sci_Vector0$();
    } else {
      var prefix1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(0);
      var suffix1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(10);
      if ((prefix1 !== null)) {
        if ((suffix1 !== null)) {
          var newLength = (($n(prefix1).u.length + $n(suffix1).u.length) | 0);
          var dest = $m_ju_Arrays$().copyOf__AO__I__AO(prefix1, newLength);
          var destPos = $n(prefix1).u.length;
          var length = $n(suffix1).u.length;
          $systemArraycopyRefs($n(suffix1), 0, $n(dest), destPos, length);
          var a = dest;
        } else {
          var a = prefix1;
        }
      } else if ((suffix1 !== null)) {
        var a = suffix1;
      } else {
        var prefix2 = $asArrayOf_O($n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1), 2);
        if ((prefix2 !== null)) {
          var a = $n(prefix2).get(0);
        } else {
          var suffix2 = $asArrayOf_O($n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9), 2);
          var a = $n(suffix2).get(0);
        }
      }
      return new $c_sci_Vector1(a);
    }
  } else {
    $p_sci_VectorSliceBuilder__balancePrefix__I__V(this, 1);
    $p_sci_VectorSliceBuilder__balanceSuffix__I__V(this, 1);
    var resultDim = this.sci_VectorSliceBuilder__f_maxDim;
    if ((resultDim < 6)) {
      var $x_1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
      var n = this.sci_VectorSliceBuilder__f_maxDim;
      var pre = $x_1.get(((n - 1) | 0));
      var $x_2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
      var n$1 = this.sci_VectorSliceBuilder__f_maxDim;
      var suf = $x_2.get(((11 - n$1) | 0));
      if (((pre !== null) && (suf !== null))) {
        if (((($n(pre).u.length + $n(suf).u.length) | 0) <= 30)) {
          var $x_3 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
          var n$2 = this.sci_VectorSliceBuilder__f_maxDim;
          var newLength$1 = (($n(pre).u.length + $n(suf).u.length) | 0);
          var dest$1 = $m_ju_Arrays$().copyOf__AO__I__AO(pre, newLength$1);
          var destPos$1 = $n(pre).u.length;
          var length$1 = $n(suf).u.length;
          $systemArraycopyRefs($n(suf), 0, $n(dest$1), destPos$1, length$1);
          $x_3.set(((n$2 - 1) | 0), dest$1);
          var $x_4 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices);
          var n$3 = this.sci_VectorSliceBuilder__f_maxDim;
          $x_4.set(((11 - n$3) | 0), null);
        } else {
          resultDim = ((1 + resultDim) | 0);
        }
      } else {
        var one = ((pre !== null) ? pre : suf);
        if (($n(one).u.length > 30)) {
          resultDim = ((1 + resultDim) | 0);
        }
      }
    }
    var prefix1$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(0);
    var suffix1$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(10);
    var len1 = $n(prefix1$2).u.length;
    var x1 = resultDim;
    switch (x1) {
      case 2: {
        var a$1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        if ((p !== null)) {
          var $x_5 = p;
        } else {
          var s = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
          var $x_5 = ((s !== null) ? s : a$1);
        }
        var data2 = $asArrayOf_O($x_5, 2);
        var res = new $c_sci_Vector2(prefix1$2, len1, data2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 3: {
        var a$2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$2 = $asArrayOf_O(((p$1 !== null) ? p$1 : a$2), 2);
        var a$3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        if ((p$2 !== null)) {
          var $x_6 = p$2;
        } else {
          var s$1 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
          var $x_6 = ((s$1 !== null) ? s$1 : a$3);
        }
        var data3 = $asArrayOf_O($x_6, 3);
        var a$4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$2 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$2 = $asArrayOf_O(((s$2 !== null) ? s$2 : a$4), 2);
        var len12 = ((len1 + ($n(prefix2$2).u.length << 5)) | 0);
        var res = new $c_sci_Vector3(prefix1$2, len1, prefix2$2, len12, data3, suffix2$2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 4: {
        var a$5 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$3 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$3 = $asArrayOf_O(((p$3 !== null) ? p$3 : a$5), 2);
        var a$6 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$4 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        var prefix3 = $asArrayOf_O(((p$4 !== null) ? p$4 : a$6), 3);
        var a$7 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$5 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(3);
        if ((p$5 !== null)) {
          var $x_7 = p$5;
        } else {
          var s$3 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(7);
          var $x_7 = ((s$3 !== null) ? s$3 : a$7);
        }
        var data4 = $asArrayOf_O($x_7, 4);
        var a$8 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$4 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
        var suffix3 = $asArrayOf_O(((s$4 !== null) ? s$4 : a$8), 3);
        var a$9 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$5 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$3 = $asArrayOf_O(((s$5 !== null) ? s$5 : a$9), 2);
        var len12$2 = ((len1 + ($n(prefix2$3).u.length << 5)) | 0);
        var len123 = ((len12$2 + ($n(prefix3).u.length << 10)) | 0);
        var res = new $c_sci_Vector4(prefix1$2, len1, prefix2$3, len12$2, prefix3, len123, data4, suffix3, suffix2$3, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 5: {
        var a$10 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$6 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$4 = $asArrayOf_O(((p$6 !== null) ? p$6 : a$10), 2);
        var a$11 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$7 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        var prefix3$2 = $asArrayOf_O(((p$7 !== null) ? p$7 : a$11), 3);
        var a$12 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$8 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(3);
        var prefix4 = $asArrayOf_O(((p$8 !== null) ? p$8 : a$12), 4);
        var a$13 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$9 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(4);
        if ((p$9 !== null)) {
          var $x_8 = p$9;
        } else {
          var s$6 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(6);
          var $x_8 = ((s$6 !== null) ? s$6 : a$13);
        }
        var data5 = $asArrayOf_O($x_8, 5);
        var a$14 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$7 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(7);
        var suffix4 = $asArrayOf_O(((s$7 !== null) ? s$7 : a$14), 4);
        var a$15 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$8 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
        var suffix3$2 = $asArrayOf_O(((s$8 !== null) ? s$8 : a$15), 3);
        var a$16 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$9 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$4 = $asArrayOf_O(((s$9 !== null) ? s$9 : a$16), 2);
        var len12$3 = ((len1 + ($n(prefix2$4).u.length << 5)) | 0);
        var len123$2 = ((len12$3 + ($n(prefix3$2).u.length << 10)) | 0);
        var len1234 = ((len123$2 + ($n(prefix4).u.length << 15)) | 0);
        var res = new $c_sci_Vector5(prefix1$2, len1, prefix2$4, len12$3, prefix3$2, len123$2, prefix4, len1234, data5, suffix4, suffix3$2, suffix2$4, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 6: {
        var a$17 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$10 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(1);
        var prefix2$5 = $asArrayOf_O(((p$10 !== null) ? p$10 : a$17), 2);
        var a$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$11 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(2);
        var prefix3$3 = $asArrayOf_O(((p$11 !== null) ? p$11 : a$18), 3);
        var a$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$12 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(3);
        var prefix4$2 = $asArrayOf_O(((p$12 !== null) ? p$12 : a$19), 4);
        var a$20 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$13 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(4);
        var prefix5 = $asArrayOf_O(((p$13 !== null) ? p$13 : a$20), 5);
        var a$21 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
        var p$14 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(5);
        if ((p$14 !== null)) {
          var $x_9 = p$14;
        } else {
          var s$10 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(5);
          var $x_9 = ((s$10 !== null) ? s$10 : a$21);
        }
        var data6 = $asArrayOf_O($x_9, 6);
        var a$22 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var s$11 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(6);
        var suffix5 = $asArrayOf_O(((s$11 !== null) ? s$11 : a$22), 5);
        var a$23 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$12 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(7);
        var suffix4$2 = $asArrayOf_O(((s$12 !== null) ? s$12 : a$23), 4);
        var a$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$13 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(8);
        var suffix3$3 = $asArrayOf_O(((s$13 !== null) ? s$13 : a$24), 3);
        var a$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$14 = $n(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices).get(9);
        var suffix2$5 = $asArrayOf_O(((s$14 !== null) ? s$14 : a$25), 2);
        var len12$4 = ((len1 + ($n(prefix2$5).u.length << 5)) | 0);
        var len123$3 = ((len12$4 + ($n(prefix3$3).u.length << 10)) | 0);
        var len1234$2 = ((len123$3 + ($n(prefix4$2).u.length << 15)) | 0);
        var len12345 = ((len1234$2 + ($n(prefix5).u.length << 20)) | 0);
        var res = new $c_sci_Vector6(prefix1$2, len1, prefix2$5, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data6, suffix5, suffix4$2, suffix3$3, suffix2$5, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      default: {
        var res;
        throw new $c_s_MatchError(x1);
      }
    }
    return res;
  }
});
$c_sci_VectorSliceBuilder.prototype.toString__T = (function() {
  return (((((((((("VectorSliceBuilder(lo=" + this.sci_VectorSliceBuilder__f_lo) + ", hi=") + this.sci_VectorSliceBuilder__f_hi) + ", len=") + this.sci_VectorSliceBuilder__f_len) + ", pos=") + this.sci_VectorSliceBuilder__f_pos) + ", maxDim=") + this.sci_VectorSliceBuilder__f_maxDim) + ")");
});
var $d_sci_VectorSliceBuilder = new $TypeData().initClass($c_sci_VectorSliceBuilder, "scala.collection.immutable.VectorSliceBuilder", ({
  sci_VectorSliceBuilder: 1
}));
/** @constructor */
function $c_sci_VectorStatics$() {
  this.sci_VectorStatics$__f_empty1 = null;
  this.sci_VectorStatics$__f_empty2 = null;
  this.sci_VectorStatics$__f_empty3 = null;
  this.sci_VectorStatics$__f_empty4 = null;
  this.sci_VectorStatics$__f_empty5 = null;
  this.sci_VectorStatics$__f_empty6 = null;
  $n_sci_VectorStatics$ = this;
  this.sci_VectorStatics$__f_empty1 = new $ac_O(0);
  this.sci_VectorStatics$__f_empty2 = new ($d_O.getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
}
$c_sci_VectorStatics$.prototype = new $h_O();
$c_sci_VectorStatics$.prototype.constructor = $c_sci_VectorStatics$;
/** @constructor */
function $h_sci_VectorStatics$() {
}
$h_sci_VectorStatics$.prototype = $c_sci_VectorStatics$.prototype;
$c_sci_VectorStatics$.prototype.copyAppend1__AO__O__AO = (function(a, elem) {
  var alen = $n(a).u.length;
  var ac = new $ac_O(((1 + alen) | 0));
  $systemArraycopyRefs($n(a), 0, ac, 0, alen);
  ac.set(alen, elem);
  return ac;
});
$c_sci_VectorStatics$.prototype.copyAppend__AO__O__AO = (function(a, elem) {
  var newLength = ((1 + $n(a).u.length) | 0);
  var ac = $m_ju_Arrays$().copyOf__AO__I__AO(a, newLength);
  $n(ac).set((($n(ac).u.length - 1) | 0), elem);
  return ac;
});
$c_sci_VectorStatics$.prototype.copyPrepend1__O__AO__AO = (function(elem, a) {
  var ac = new $ac_O(((1 + $n(a).u.length) | 0));
  var length = $n(a).u.length;
  $systemArraycopyRefs($n(a), 0, ac, 1, length);
  ac.set(0, elem);
  return ac;
});
$c_sci_VectorStatics$.prototype.copyPrepend__O__AO__AO = (function(elem, a) {
  var this$1 = $n(a);
  var this$2 = $objectGetClass(this$1);
  var componentType = this$2.data.getComponentType();
  var length = ((1 + $n(a).u.length) | 0);
  var ac = $asArrayOf_O($n(componentType).data.newArray(length), 1);
  var length$1 = $n(a).u.length;
  $systemArraycopyRefs($n(a), 0, $n(ac), 1, length$1);
  $n(ac).set(0, elem);
  return ac;
});
$c_sci_VectorStatics$.prototype.foreachRec__I__AO__F1__V = (function(level, a, f) {
  var i = 0;
  var len = $n(a).u.length;
  if ((level === 0)) {
    while ((i < len)) {
      $n(f).apply__O__O($n(a).get(i));
      i = ((1 + i) | 0);
    }
  } else {
    var l = ((level - 1) | 0);
    while ((i < len)) {
      this.foreachRec__I__AO__F1__V(l, $asArrayOf_O($n(a).get(i), 1), f);
      i = ((1 + i) | 0);
    }
  }
});
$c_sci_VectorStatics$.prototype.mapElems1__AO__F1__AO = (function(a, f) {
  var i = 0;
  while ((i < $n(a).u.length)) {
    var v1 = $n(a).get(i);
    var v2 = $n(f).apply__O__O(v1);
    if ((!Object.is(v1, v2))) {
      return this.mapElems1Rest__AO__F1__I__O__AO(a, f, i, v2);
    }
    i = ((1 + i) | 0);
  }
  return a;
});
$c_sci_VectorStatics$.prototype.mapElems1Rest__AO__F1__I__O__AO = (function(a, f, at, v2) {
  var ac = new $ac_O($n(a).u.length);
  if ((at > 0)) {
    $systemArraycopyRefs($n(a), 0, ac, 0, at);
  }
  ac.set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < $n(a).u.length)) {
    ac.set(i, $n(f).apply__O__O($n(a).get(i)));
    i = ((1 + i) | 0);
  }
  return ac;
});
$c_sci_VectorStatics$.prototype.mapElems__I__AO__F1__AO = (function(n, a, f) {
  if ((n === 1)) {
    return this.mapElems1__AO__F1__AO(a, f);
  } else {
    var i = 0;
    while ((i < $n(a).u.length)) {
      var v1 = $n(a).get(i);
      var v2 = this.mapElems__I__AO__F1__AO(((n - 1) | 0), $asArrayOf_O(v1, 1), f);
      if ((v1 !== v2)) {
        return this.mapElemsRest__I__AO__F1__I__O__AO(n, a, f, i, v2);
      }
      i = ((1 + i) | 0);
    }
    return a;
  }
});
$c_sci_VectorStatics$.prototype.mapElemsRest__I__AO__F1__I__O__AO = (function(n, a, f, at, v2) {
  var this$1 = $n(a);
  var this$2 = $objectGetClass(this$1);
  var componentType = this$2.data.getComponentType();
  var length = $n(a).u.length;
  var ac = $asArrayOf_O($n(componentType).data.newArray(length), 1);
  if ((at > 0)) {
    $systemArraycopyRefs($n(a), 0, $n(ac), 0, at);
  }
  $n(ac).set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < $n(a).u.length)) {
    $n(ac).set(i, this.mapElems__I__AO__F1__AO(((n - 1) | 0), $asArrayOf_O($n(a).get(i), 1), f));
    i = ((1 + i) | 0);
  }
  return ac;
});
$c_sci_VectorStatics$.prototype.append1IfSpace__AO__sc_IterableOnce__AO = (function(suffix1, xs) {
  if ($is_sci_Iterable(xs)) {
    var x2 = $as_sci_Iterable(xs);
    if (($n(x2).sizeCompare__I__I(((32 - $n(suffix1).u.length) | 0)) <= 0)) {
      var x1$2 = $n(x2).size__I();
      switch (x1$2) {
        case 0: {
          return null;
          break;
        }
        case 1: {
          return this.copyAppend__AO__O__AO(suffix1, $n(x2).head__O());
          break;
        }
        default: {
          var newLength = (($n(suffix1).u.length + x1$2) | 0);
          var suffix1b = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength);
          var this$1 = $n(x2);
          var start = $n(suffix1).u.length;
          this$1.copyToArray__O__I__I__I(suffix1b, start, 2147483647);
          return suffix1b;
        }
      }
    } else {
      return null;
    }
  } else {
    var s = $n(xs).knownSize__I();
    if (((s > 0) && (s <= ((32 - $n(suffix1).u.length) | 0)))) {
      var newLength$1 = (($n(suffix1).u.length + s) | 0);
      var suffix1b$2 = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength$1);
      var this$2 = $n($n(xs).iterator__sc_Iterator());
      var start$1 = $n(suffix1).u.length;
      this$2.copyToArray__O__I__I__I(suffix1b$2, start$1, 2147483647);
      return suffix1b$2;
    } else {
      return null;
    }
  }
});
var $d_sci_VectorStatics$ = new $TypeData().initClass($c_sci_VectorStatics$, "scala.collection.immutable.VectorStatics$", ({
  sci_VectorStatics$: 1
}));
var $n_sci_VectorStatics$;
function $m_sci_VectorStatics$() {
  if ((!$n_sci_VectorStatics$)) {
    $n_sci_VectorStatics$ = new $c_sci_VectorStatics$();
  }
  return $n_sci_VectorStatics$;
}
/** @constructor */
function $c_scm_HashMap$Node(_key, _hash, _value, _next) {
  this.scm_HashMap$Node__f__key = null;
  this.scm_HashMap$Node__f__hash = 0;
  this.scm_HashMap$Node__f__value = null;
  this.scm_HashMap$Node__f__next = null;
  this.scm_HashMap$Node__f__key = _key;
  this.scm_HashMap$Node__f__hash = _hash;
  this.scm_HashMap$Node__f__value = _value;
  this.scm_HashMap$Node__f__next = _next;
}
$c_scm_HashMap$Node.prototype = new $h_O();
$c_scm_HashMap$Node.prototype.constructor = $c_scm_HashMap$Node;
/** @constructor */
function $h_scm_HashMap$Node() {
}
$h_scm_HashMap$Node.prototype = $c_scm_HashMap$Node.prototype;
$c_scm_HashMap$Node.prototype.findNode__O__I__scm_HashMap$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === $n(_$this).scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(_$this).scm_HashMap$Node__f__key))) {
      return _$this;
    } else if ((($n(_$this).scm_HashMap$Node__f__next === null) || ($n(_$this).scm_HashMap$Node__f__hash > h))) {
      return null;
    } else {
      _$this = $n(_$this).scm_HashMap$Node__f__next;
    }
  }
});
$c_scm_HashMap$Node.prototype.foreachEntry__F2__V = (function(f) {
  var _$this = this;
  while (true) {
    $n(f).apply__O__O__O($n(_$this).scm_HashMap$Node__f__key, $n(_$this).scm_HashMap$Node__f__value);
    if (($n(_$this).scm_HashMap$Node__f__next !== null)) {
      _$this = $n(_$this).scm_HashMap$Node__f__next;
      continue;
    }
    break;
  }
});
$c_scm_HashMap$Node.prototype.toString__T = (function() {
  return ((((((("Node(" + this.scm_HashMap$Node__f__key) + ", ") + this.scm_HashMap$Node__f__value) + ", ") + this.scm_HashMap$Node__f__hash) + ") -> ") + this.scm_HashMap$Node__f__next);
});
function $as_scm_HashMap$Node(obj) {
  return (((obj instanceof $c_scm_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap$Node"));
}
function $isArrayOf_scm_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap$Node)));
}
function $asArrayOf_scm_HashMap$Node(obj, depth) {
  return (($isArrayOf_scm_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap$Node;", depth));
}
var $d_scm_HashMap$Node = new $TypeData().initClass($c_scm_HashMap$Node, "scala.collection.mutable.HashMap$Node", ({
  scm_HashMap$Node: 1
}));
/** @constructor */
function $c_scm_HashSet$Node(_key, _hash, _next) {
  this.scm_HashSet$Node__f__key = null;
  this.scm_HashSet$Node__f__hash = 0;
  this.scm_HashSet$Node__f__next = null;
  this.scm_HashSet$Node__f__key = _key;
  this.scm_HashSet$Node__f__hash = _hash;
  this.scm_HashSet$Node__f__next = _next;
}
$c_scm_HashSet$Node.prototype = new $h_O();
$c_scm_HashSet$Node.prototype.constructor = $c_scm_HashSet$Node;
/** @constructor */
function $h_scm_HashSet$Node() {
}
$h_scm_HashSet$Node.prototype = $c_scm_HashSet$Node.prototype;
$c_scm_HashSet$Node.prototype.findNode__O__I__scm_HashSet$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === $n(_$this).scm_HashSet$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, $n(_$this).scm_HashSet$Node__f__key))) {
      return _$this;
    } else if ((($n(_$this).scm_HashSet$Node__f__next === null) || ($n(_$this).scm_HashSet$Node__f__hash > h))) {
      return null;
    } else {
      _$this = $n(_$this).scm_HashSet$Node__f__next;
    }
  }
});
$c_scm_HashSet$Node.prototype.toString__T = (function() {
  return ((((("Node(" + this.scm_HashSet$Node__f__key) + ", ") + this.scm_HashSet$Node__f__hash) + ") -> ") + this.scm_HashSet$Node__f__next);
});
function $as_scm_HashSet$Node(obj) {
  return (((obj instanceof $c_scm_HashSet$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet$Node"));
}
function $isArrayOf_scm_HashSet$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet$Node)));
}
function $asArrayOf_scm_HashSet$Node(obj, depth) {
  return (($isArrayOf_scm_HashSet$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet$Node;", depth));
}
var $d_scm_HashSet$Node = new $TypeData().initClass($c_scm_HashSet$Node, "scala.collection.mutable.HashSet$Node", ({
  scm_HashSet$Node: 1
}));
function $as_scm_LinkedHashMap$LinkedEntry(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashMap$LinkedEntry"));
}
function $isArrayOf_scm_LinkedHashMap$LinkedEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashMap$LinkedEntry)));
}
function $asArrayOf_scm_LinkedHashMap$LinkedEntry(obj, depth) {
  return (($isArrayOf_scm_LinkedHashMap$LinkedEntry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashMap$LinkedEntry;", depth));
}
function $as_scm_LinkedHashSet$Entry(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashSet$Entry"));
}
function $isArrayOf_scm_LinkedHashSet$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashSet$Entry)));
}
function $asArrayOf_scm_LinkedHashSet$Entry(obj, depth) {
  return (($isArrayOf_scm_LinkedHashSet$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashSet$Entry;", depth));
}
/** @constructor */
function $c_scm_MutationTracker$() {
}
$c_scm_MutationTracker$.prototype = new $h_O();
$c_scm_MutationTracker$.prototype.constructor = $c_scm_MutationTracker$;
/** @constructor */
function $h_scm_MutationTracker$() {
}
$h_scm_MutationTracker$.prototype = $c_scm_MutationTracker$.prototype;
$c_scm_MutationTracker$.prototype.checkMutations__I__I__T__V = (function(expectedCount, actualCount, message) {
  if ((actualCount !== expectedCount)) {
    throw new $c_ju_ConcurrentModificationException(message);
  }
});
var $d_scm_MutationTracker$ = new $TypeData().initClass($c_scm_MutationTracker$, "scala.collection.mutable.MutationTracker$", ({
  scm_MutationTracker$: 1
}));
var $n_scm_MutationTracker$;
function $m_scm_MutationTracker$() {
  if ((!$n_scm_MutationTracker$)) {
    $n_scm_MutationTracker$ = new $c_scm_MutationTracker$();
  }
  return $n_scm_MutationTracker$;
}
function $is_scm_Shrinkable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Shrinkable)));
}
function $as_scm_Shrinkable(obj) {
  return (($is_scm_Shrinkable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Shrinkable"));
}
function $isArrayOf_scm_Shrinkable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Shrinkable)));
}
function $asArrayOf_scm_Shrinkable(obj, depth) {
  return (($isArrayOf_scm_Shrinkable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Shrinkable;", depth));
}
/** @constructor */
function $c_sc_package$$colon$plus$() {
}
$c_sc_package$$colon$plus$.prototype = new $h_O();
$c_sc_package$$colon$plus$.prototype.constructor = $c_sc_package$$colon$plus$;
/** @constructor */
function $h_sc_package$$colon$plus$() {
}
$h_sc_package$$colon$plus$.prototype = $c_sc_package$$colon$plus$.prototype;
$c_sc_package$$colon$plus$.prototype.unapply__sc_SeqOps__s_Option = (function(t) {
  if ($n(t).isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var self = $n(t).init__O();
    var y = $n(t).last__O();
    return new $c_s_Some(new $c_T2(self, y));
  }
});
var $d_sc_package$$colon$plus$ = new $TypeData().initClass($c_sc_package$$colon$plus$, "scala.collection.package$$colon$plus$", ({
  sc_package$$colon$plus$: 1
}));
var $n_sc_package$$colon$plus$;
function $m_sc_package$$colon$plus$() {
  if ((!$n_sc_package$$colon$plus$)) {
    $n_sc_package$$colon$plus$ = new $c_sc_package$$colon$plus$();
  }
  return $n_sc_package$$colon$plus$;
}
function $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable($thiz, curSize) {
  var curOther = $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
  var curLen = $n(curOther).u.length;
  if ((curSize <= curLen)) {
    return curOther;
  } else {
    var newLen = ((curLen === 0) ? 4 : (curLen << 1));
    if ((newLen <= curLen)) {
      throw new $c_jl_StackOverflowError(("Space limit of asynchronous stack reached: " + curLen));
    }
    var newOther = new ($d_jl_Runnable.getArrayOf().constr)(newLen);
    $systemArraycopyRefs($n(curOther), 0, newOther, 0, curLen);
    $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = newOther;
    return newOther;
  }
}
function $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__($thiz, outer, first, other, size) {
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_first = first;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = other;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_size = size;
  $n(outer);
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = outer;
  return $thiz;
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$AbstractBatch() {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null;
}
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype = new $h_O();
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$AbstractBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$AbstractBatch() {
}
$h_s_concurrent_BatchingExecutor$AbstractBatch.prototype = $c_s_concurrent_BatchingExecutor$AbstractBatch.prototype;
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.push__jl_Runnable__V = (function(r) {
  var sz = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
  if ((sz === 0)) {
    this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = r;
  } else {
    $n($p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable(this, sz)).set(((sz - 1) | 0), r);
  }
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = ((1 + sz) | 0);
});
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.runN__I__V = (function(n) {
  while (true) {
    if ((n > 0)) {
      var x1 = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
      switch (x1) {
        case 0: {
          break;
        }
        case 1: {
          var next = this.s_concurrent_BatchingExecutor$AbstractBatch__f_first;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
          $n(next).run__V();
          n = ((n - 1) | 0);
          continue;
          break;
        }
        default: {
          var o = this.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
          var next$2 = $n(o).get(((x1 - 2) | 0));
          $n(o).set(((x1 - 2) | 0), null);
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = ((x1 - 1) | 0);
          $n(next$2).run__V();
          n = ((n - 1) | 0);
          continue;
        }
      }
    }
    return (void 0);
  }
});
/** @constructor */
function $c_s_concurrent_BatchingExecutorStatics$() {
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = null;
  $n_s_concurrent_BatchingExecutorStatics$ = this;
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = new ($d_jl_Runnable.getArrayOf().constr)(0);
}
$c_s_concurrent_BatchingExecutorStatics$.prototype = new $h_O();
$c_s_concurrent_BatchingExecutorStatics$.prototype.constructor = $c_s_concurrent_BatchingExecutorStatics$;
/** @constructor */
function $h_s_concurrent_BatchingExecutorStatics$() {
}
$h_s_concurrent_BatchingExecutorStatics$.prototype = $c_s_concurrent_BatchingExecutorStatics$.prototype;
var $d_s_concurrent_BatchingExecutorStatics$ = new $TypeData().initClass($c_s_concurrent_BatchingExecutorStatics$, "scala.concurrent.BatchingExecutorStatics$", ({
  s_concurrent_BatchingExecutorStatics$: 1
}));
var $n_s_concurrent_BatchingExecutorStatics$;
function $m_s_concurrent_BatchingExecutorStatics$() {
  if ((!$n_s_concurrent_BatchingExecutorStatics$)) {
    $n_s_concurrent_BatchingExecutorStatics$ = new $c_s_concurrent_BatchingExecutorStatics$();
  }
  return $n_s_concurrent_BatchingExecutorStatics$;
}
function $is_s_concurrent_ExecutionContext(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_ExecutionContext)));
}
function $as_s_concurrent_ExecutionContext(obj) {
  return (($is_s_concurrent_ExecutionContext(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.ExecutionContext"));
}
function $isArrayOf_s_concurrent_ExecutionContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_ExecutionContext)));
}
function $asArrayOf_s_concurrent_ExecutionContext(obj, depth) {
  return (($isArrayOf_s_concurrent_ExecutionContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.ExecutionContext;", depth));
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$() {
  this.s_concurrent_ExecutionContext$__f_defaultReporter = null;
  $n_s_concurrent_ExecutionContext$ = this;
  this.s_concurrent_ExecutionContext$__f_defaultReporter = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
    var x$1$2 = $as_jl_Throwable(x$1$2$2);
    var this$1 = $n(x$1$2);
    this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
  }));
}
$c_s_concurrent_ExecutionContext$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$.prototype.constructor = $c_s_concurrent_ExecutionContext$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$() {
}
$h_s_concurrent_ExecutionContext$.prototype = $c_s_concurrent_ExecutionContext$.prototype;
var $d_s_concurrent_ExecutionContext$ = new $TypeData().initClass($c_s_concurrent_ExecutionContext$, "scala.concurrent.ExecutionContext$", ({
  s_concurrent_ExecutionContext$: 1
}));
var $n_s_concurrent_ExecutionContext$;
function $m_s_concurrent_ExecutionContext$() {
  if ((!$n_s_concurrent_ExecutionContext$)) {
    $n_s_concurrent_ExecutionContext$ = new $c_s_concurrent_ExecutionContext$();
  }
  return $n_s_concurrent_ExecutionContext$;
}
/** @constructor */
function $c_s_concurrent_Future$() {
  this.s_concurrent_Future$__f_collectFailed = null;
  this.s_concurrent_Future$__f_filterFailure = null;
  this.s_concurrent_Future$__f_failedFailure = null;
  this.s_concurrent_Future$__f_recoverWithFailedMarker = null;
  this.s_concurrent_Future$__f_recoverWithFailed = null;
  $n_s_concurrent_Future$ = this;
  var this$22 = $m_sci_Map$();
  var x0 = new $c_T2($d_Z.getClassOf(), $d_jl_Boolean.getClassOf());
  var x1 = new $c_T2($d_B.getClassOf(), $d_jl_Byte.getClassOf());
  var x2 = new $c_T2($d_C.getClassOf(), $d_jl_Character.getClassOf());
  var x3 = new $c_T2($d_S.getClassOf(), $d_jl_Short.getClassOf());
  var x4 = new $c_T2($d_I.getClassOf(), $d_jl_Integer.getClassOf());
  var x5 = new $c_T2($d_J.getClassOf(), $d_jl_Long.getClassOf());
  var x6 = new $c_T2($d_F.getClassOf(), $d_jl_Float.getClassOf());
  var x7 = new $c_T2($d_D.getClassOf(), $d_jl_Double.getClassOf());
  var x8 = new $c_T2($d_V.getClassOf(), $d_jl_Void.getClassOf());
  var array = [x0, x1, x2, x3, x4, x5, x6, x7, x8];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this$22.from__sc_IterableOnce__sci_Map(elems);
  this.s_concurrent_Future$__f_collectFailed = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2$2) => {
    throw new $c_s_concurrent_Future$$anon$1(t$2$2);
  }));
  this.s_concurrent_Future$__f_filterFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$2());
  this.s_concurrent_Future$__f_failedFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$3());
  this.fromTry__s_util_Try__s_concurrent_Future(this.s_concurrent_Future$__f_failedFailure);
  this.s_concurrent_Future$__f_recoverWithFailedMarker = this.failed__jl_Throwable__s_concurrent_Future(new $c_s_concurrent_Future$$anon$4());
  this.s_concurrent_Future$__f_recoverWithFailed = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((t$2$2$1) => {
    $as_jl_Throwable(t$2$2$1);
    return $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker;
  }));
  this.fromTry__s_util_Try__s_concurrent_Future(new $c_s_util_Success((void 0)));
}
$c_s_concurrent_Future$.prototype = new $h_O();
$c_s_concurrent_Future$.prototype.constructor = $c_s_concurrent_Future$;
/** @constructor */
function $h_s_concurrent_Future$() {
}
$h_s_concurrent_Future$.prototype = $c_s_concurrent_Future$.prototype;
$c_s_concurrent_Future$.prototype.failed__jl_Throwable__s_concurrent_Future = (function(exception) {
  return $n($m_s_concurrent_Promise$().failed__jl_Throwable__s_concurrent_Promise(exception));
});
$c_s_concurrent_Future$.prototype.successful__O__s_concurrent_Future = (function(result) {
  return $n($m_s_concurrent_Promise$().successful__O__s_concurrent_Promise(result));
});
$c_s_concurrent_Future$.prototype.fromTry__s_util_Try__s_concurrent_Future = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result);
});
var $d_s_concurrent_Future$ = new $TypeData().initClass($c_s_concurrent_Future$, "scala.concurrent.Future$", ({
  s_concurrent_Future$: 1
}));
var $n_s_concurrent_Future$;
function $m_s_concurrent_Future$() {
  if ((!$n_s_concurrent_Future$)) {
    $n_s_concurrent_Future$ = new $c_s_concurrent_Future$();
  }
  return $n_s_concurrent_Future$;
}
function $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result) {
  if ($thiz.tryComplete__s_util_Try__Z(result)) {
    return $thiz;
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Promise already completed.");
  }
}
function $f_s_concurrent_Promise__success__O__s_concurrent_Promise($thiz, value) {
  var result = new $c_s_util_Success(value);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result);
}
function $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise($thiz, cause) {
  var result = new $c_s_util_Failure(cause);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result);
}
/** @constructor */
function $c_s_concurrent_Promise$() {
}
$c_s_concurrent_Promise$.prototype = new $h_O();
$c_s_concurrent_Promise$.prototype.constructor = $c_s_concurrent_Promise$;
/** @constructor */
function $h_s_concurrent_Promise$() {
}
$h_s_concurrent_Promise$.prototype = $c_s_concurrent_Promise$.prototype;
$c_s_concurrent_Promise$.prototype.failed__jl_Throwable__s_concurrent_Promise = (function(exception) {
  var result = new $c_s_util_Failure(exception);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result);
});
$c_s_concurrent_Promise$.prototype.successful__O__s_concurrent_Promise = (function(result) {
  var result$1 = new $c_s_util_Success(result);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result$1);
});
var $d_s_concurrent_Promise$ = new $TypeData().initClass($c_s_concurrent_Promise$, "scala.concurrent.Promise$", ({
  s_concurrent_Promise$: 1
}));
var $n_s_concurrent_Promise$;
function $m_s_concurrent_Promise$() {
  if ((!$n_s_concurrent_Promise$)) {
    $n_s_concurrent_Promise$ = new $c_s_concurrent_Promise$();
  }
  return $n_s_concurrent_Promise$;
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt$() {
}
$c_s_concurrent_duration_package$DurationInt$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt$.prototype.constructor = $c_s_concurrent_duration_package$DurationInt$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt$() {
}
$h_s_concurrent_duration_package$DurationInt$.prototype = $c_s_concurrent_duration_package$DurationInt$.prototype;
$c_s_concurrent_duration_package$DurationInt$.prototype.equals$extension__I__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationInt)) {
    var DurationInt$1 = $n($as_s_concurrent_duration_package$DurationInt(x$1)).s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    return (this$ === DurationInt$1);
  } else {
    return false;
  }
});
var $d_s_concurrent_duration_package$DurationInt$ = new $TypeData().initClass($c_s_concurrent_duration_package$DurationInt$, "scala.concurrent.duration.package$DurationInt$", ({
  s_concurrent_duration_package$DurationInt$: 1
}));
var $n_s_concurrent_duration_package$DurationInt$;
function $m_s_concurrent_duration_package$DurationInt$() {
  if ((!$n_s_concurrent_duration_package$DurationInt$)) {
    $n_s_concurrent_duration_package$DurationInt$ = new $c_s_concurrent_duration_package$DurationInt$();
  }
  return $n_s_concurrent_duration_package$DurationInt$;
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong$() {
}
$c_s_concurrent_duration_package$DurationLong$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong$.prototype.constructor = $c_s_concurrent_duration_package$DurationLong$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong$() {
}
$h_s_concurrent_duration_package$DurationLong$.prototype = $c_s_concurrent_duration_package$DurationLong$.prototype;
$c_s_concurrent_duration_package$DurationLong$.prototype.equals$extension__J__O__Z = (function(this$_$_lo, this$_$_hi, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationLong)) {
    var $x_1 = $as_s_concurrent_duration_package$DurationLong(x$1);
    var DurationLong$1_$_lo = $n($x_1).s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
    var DurationLong$1_$_hi = $n($x_1).s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
    return (((this$_$_lo ^ DurationLong$1_$_lo) | (this$_$_hi ^ DurationLong$1_$_hi)) === 0);
  } else {
    return false;
  }
});
var $d_s_concurrent_duration_package$DurationLong$ = new $TypeData().initClass($c_s_concurrent_duration_package$DurationLong$, "scala.concurrent.duration.package$DurationLong$", ({
  s_concurrent_duration_package$DurationLong$: 1
}));
var $n_s_concurrent_duration_package$DurationLong$;
function $m_s_concurrent_duration_package$DurationLong$() {
  if ((!$n_s_concurrent_duration_package$DurationLong$)) {
    $n_s_concurrent_duration_package$DurationLong$ = new $c_s_concurrent_duration_package$DurationLong$();
  }
  return $n_s_concurrent_duration_package$DurationLong$;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$() {
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = null;
  $n_s_concurrent_impl_Promise$ = this;
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 0, null, $m_s_concurrent_ExecutionContext$parasitic$());
}
$c_s_concurrent_impl_Promise$.prototype = new $h_O();
$c_s_concurrent_impl_Promise$.prototype.constructor = $c_s_concurrent_impl_Promise$;
/** @constructor */
function $h_s_concurrent_impl_Promise$() {
}
$h_s_concurrent_impl_Promise$.prototype = $c_s_concurrent_impl_Promise$.prototype;
$c_s_concurrent_impl_Promise$.prototype.scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try = (function(value) {
  if (($n(value) instanceof $c_s_util_Success)) {
    return value;
  } else {
    var t = $n($as_s_util_Failure(value)).s_util_Failure__f_exception;
    return ((((t instanceof $c_s_util_control_ControlThrowable) || false) || (t instanceof $c_jl_Error)) ? ((t instanceof $c_sr_NonLocalReturnControl) ? new $c_s_util_Success($n($as_sr_NonLocalReturnControl(t)).sr_NonLocalReturnControl__f_value) : new $c_s_util_Failure(new $c_ju_concurrent_ExecutionException("Boxed Exception", t))) : value);
  }
});
var $d_s_concurrent_impl_Promise$ = new $TypeData().initClass($c_s_concurrent_impl_Promise$, "scala.concurrent.impl.Promise$", ({
  s_concurrent_impl_Promise$: 1
}));
var $n_s_concurrent_impl_Promise$;
function $m_s_concurrent_impl_Promise$() {
  if ((!$n_s_concurrent_impl_Promise$)) {
    $n_s_concurrent_impl_Promise$ = new $c_s_concurrent_impl_Promise$();
  }
  return $n_s_concurrent_impl_Promise$;
}
function $is_s_concurrent_impl_Promise$Callbacks(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_impl_Promise$Callbacks)));
}
function $as_s_concurrent_impl_Promise$Callbacks(obj) {
  return (($is_s_concurrent_impl_Promise$Callbacks(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Callbacks"));
}
function $isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Callbacks)));
}
function $asArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Callbacks;", depth));
}
function $ct_s_math_Numeric$NumericOps__s_math_Numeric__O__($thiz, outer, lhs) {
  $thiz.s_math_Numeric$NumericOps__f_lhs = lhs;
  $n(outer);
  $thiz.s_math_Numeric$NumericOps__f_$outer = outer;
  return $thiz;
}
/** @constructor */
function $c_s_math_Numeric$NumericOps() {
  this.s_math_Numeric$NumericOps__f_lhs = null;
  this.s_math_Numeric$NumericOps__f_$outer = null;
}
$c_s_math_Numeric$NumericOps.prototype = new $h_O();
$c_s_math_Numeric$NumericOps.prototype.constructor = $c_s_math_Numeric$NumericOps;
/** @constructor */
function $h_s_math_Numeric$NumericOps() {
}
$h_s_math_Numeric$NumericOps.prototype = $c_s_math_Numeric$NumericOps.prototype;
$c_s_math_Numeric$NumericOps.prototype.$plus__O__O = (function(rhs) {
  return $n(this.s_math_Numeric$NumericOps__f_$outer).plus__O__O__O(this.s_math_Numeric$NumericOps__f_lhs, rhs);
});
$c_s_math_Numeric$NumericOps.prototype.$minus__O__O = (function(rhs) {
  return $n(this.s_math_Numeric$NumericOps__f_$outer).minus__O__O__O(this.s_math_Numeric$NumericOps__f_lhs, rhs);
});
$c_s_math_Numeric$NumericOps.prototype.$times__O__O = (function(rhs) {
  return $n(this.s_math_Numeric$NumericOps__f_$outer).times__O__O__O(this.s_math_Numeric$NumericOps__f_lhs, rhs);
});
$c_s_math_Numeric$NumericOps.prototype.unary_$minus__O = (function() {
  return $n(this.s_math_Numeric$NumericOps__f_$outer).negate__O__O(this.s_math_Numeric$NumericOps__f_lhs);
});
function $f_s_math_ScalaNumericAnyConversions__isValidByte__Z($thiz) {
  return ($thiz.isWhole__Z() && ($thiz.intValue__I() === $thiz.byteValue__B()));
}
function $f_s_math_ScalaNumericAnyConversions__isValidShort__Z($thiz) {
  return ($thiz.isWhole__Z() && ($thiz.intValue__I() === $thiz.shortValue__S()));
}
function $f_s_math_ScalaNumericAnyConversions__isValidInt__Z($thiz) {
  if ($thiz.isWhole__Z()) {
    var $x_1 = $thiz.longValue__J();
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var value = $thiz.intValue__I();
    var hi = (value >> 31);
    return (((x_$_lo ^ value) | (x_$_hi ^ hi)) === 0);
  } else {
    return false;
  }
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var $x_1 = $thiz.longValue__J();
  var lv_$_lo = $x_1.l;
  var lv_$_hi = $x_1.h;
  return ((((lv_$_hi === (-1)) ? ((lv_$_lo >>> 0) >= 2147483648) : (lv_$_hi > (-1))) && ((lv_$_hi === 0) ? ((lv_$_lo >>> 0) <= 2147483647) : (lv_$_hi < 0))) ? lv_$_lo : $m_sr_Statics$().longHash__J__I(lv_$_lo, lv_$_hi));
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return ($thiz.isValidChar__Z() && ($thiz.intValue__I() === x2));
  } else if ($isByte(x)) {
    var x3 = $uB(x);
    return ($thiz.isValidByte__Z() && ($thiz.byteValue__B() === x3));
  } else if ($isShort(x)) {
    var x4 = $uS(x);
    return ($thiz.isValidShort__Z() && ($thiz.shortValue__S() === x4));
  } else if ($isInt(x)) {
    var x5 = $uI(x);
    return ($thiz.isValidInt__Z() && ($thiz.intValue__I() === x5));
  } else if ((x instanceof $Long)) {
    var $x_1 = $uJ(x);
    var x6_$_lo = $x_1.l;
    var x6_$_hi = $x_1.h;
    var $x_2 = $thiz.longValue__J();
    var x$1_$_lo = $x_2.l;
    var x$1_$_hi = $x_2.h;
    return (((x$1_$_lo ^ x6_$_lo) | (x$1_$_hi ^ x6_$_hi)) === 0);
  } else if ($isFloat(x)) {
    var x7 = $uF(x);
    return ($thiz.floatValue__F() === x7);
  } else if (((typeof x) === "number")) {
    var x8 = $uD(x);
    return ($thiz.doubleValue__D() === x8);
  } else {
    return false;
  }
}
/** @constructor */
function $c_s_math_package$() {
}
$c_s_math_package$.prototype = new $h_O();
$c_s_math_package$.prototype.constructor = $c_s_math_package$;
/** @constructor */
function $h_s_math_package$() {
}
$h_s_math_package$.prototype = $c_s_math_package$.prototype;
$c_s_math_package$.prototype.signum__J__J = (function(x_$_lo, x_$_hi) {
  var lo = (x_$_hi >> 31);
  var lo$1 = ((-x_$_lo) | 0);
  var hi$1 = ((((-x_$_hi) | 0) + ((x_$_lo | lo$1) >> 31)) | 0);
  var lo$2 = ((hi$1 >>> 31) | 0);
  var lo$3 = (lo | lo$2);
  var hi$2 = (lo$3 >> 31);
  return $bL(lo$3, hi$2);
});
var $d_s_math_package$ = new $TypeData().initClass($c_s_math_package$, "scala.math.package$", ({
  s_math_package$: 1
}));
var $n_s_math_package$;
function $m_s_math_package$() {
  if ((!$n_s_math_package$)) {
    $n_s_math_package$ = new $c_s_math_package$();
  }
  return $n_s_math_package$;
}
function $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$($thiz) {
  if (((((1 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigDecimal = $m_s_math_BigDecimal$();
    $thiz.s_package$__f_bitmap$0 = (((1 | $thiz.s_package$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.s_package$__f_BigDecimal;
}
function $p_s_package$__BigInt$lzycompute__s_math_BigInt$($thiz) {
  if (((((2 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigInt = $m_s_math_BigInt$();
    $thiz.s_package$__f_bitmap$0 = (((2 | $thiz.s_package$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.s_package$__f_BigInt;
}
/** @constructor */
function $c_s_package$() {
  this.s_package$__f_BigDecimal = null;
  this.s_package$__f_BigInt = null;
  this.s_package$__f_Seq = null;
  this.s_package$__f_Iterator = null;
  this.s_package$__f_List = null;
  this.s_package$__f_Nil = null;
  this.s_package$__f_$colon$plus = null;
  this.s_package$__f_Stream = null;
  this.s_package$__f_LazyList = null;
  this.s_package$__f_Vector = null;
  this.s_package$__f_Ordering = null;
  this.s_package$__f_Either = null;
  this.s_package$__f_Left = null;
  this.s_package$__f_Right = null;
  this.s_package$__f_bitmap$0 = 0;
  $n_s_package$ = this;
  this.s_package$__f_Seq = $m_sci_Seq$();
  $m_sci_IndexedSeq$();
  this.s_package$__f_Iterator = $m_sc_Iterator$();
  this.s_package$__f_List = $m_sci_List$();
  this.s_package$__f_Nil = $m_sci_Nil$();
  this.s_package$__f_$colon$plus = $m_sc_package$$colon$plus$();
  this.s_package$__f_Stream = $m_sci_Stream$();
  this.s_package$__f_LazyList = $m_sci_LazyList$();
  this.s_package$__f_Vector = $m_sci_Vector$();
  this.s_package$__f_Ordering = $m_s_math_Ordering$();
  this.s_package$__f_Either = $m_s_util_Either$();
  this.s_package$__f_Left = $m_s_util_Left$();
  this.s_package$__f_Right = $m_s_util_Right$();
}
$c_s_package$.prototype = new $h_O();
$c_s_package$.prototype.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
}
$h_s_package$.prototype = $c_s_package$.prototype;
$c_s_package$.prototype.BigDecimal__s_math_BigDecimal$ = (function() {
  return (((((1 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$(this) : this.s_package$__f_BigDecimal);
});
$c_s_package$.prototype.BigInt__s_math_BigInt$ = (function() {
  return (((((2 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigInt$lzycompute__s_math_BigInt$(this) : this.s_package$__f_BigInt);
});
var $d_s_package$ = new $TypeData().initClass($c_s_package$, "scala.package$", ({
  s_package$: 1
}));
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$();
  }
  return $n_s_package$;
}
/** @constructor */
function $c_s_package$$hash$colon$colon$() {
}
$c_s_package$$hash$colon$colon$.prototype = new $h_O();
$c_s_package$$hash$colon$colon$.prototype.constructor = $c_s_package$$hash$colon$colon$;
/** @constructor */
function $h_s_package$$hash$colon$colon$() {
}
$h_s_package$$hash$colon$colon$.prototype = $c_s_package$$hash$colon$colon$.prototype;
$c_s_package$$hash$colon$colon$.prototype.unapply__sci_Stream__s_Option = (function(s) {
  var this$1 = $n(s);
  if ((!this$1.isEmpty__Z())) {
    return new $c_s_Some(new $c_T2($n(s).head__O(), $n(s).tail__O()));
  } else {
    return $m_s_None$();
  }
});
var $d_s_package$$hash$colon$colon$ = new $TypeData().initClass($c_s_package$$hash$colon$colon$, "scala.package$$hash$colon$colon$", ({
  s_package$$hash$colon$colon$: 1
}));
var $n_s_package$$hash$colon$colon$;
function $m_s_package$$hash$colon$colon$() {
  if ((!$n_s_package$$hash$colon$colon$)) {
    $n_s_package$$hash$colon$colon$ = new $c_s_package$$hash$colon$colon$();
  }
  return $n_s_package$$hash$colon$colon$;
}
function $p_s_reflect_NameTransformer$__enterOp__C__T__V($thiz, op, code) {
  $n($thiz.s_reflect_NameTransformer$__f_op2code).set(op, code);
  var this$1 = $n(code);
  var this$2 = $n(code);
  var c = ((((Math.imul(26, (($charAt(this$1, 1) - 97) | 0)) + $charAt(this$2, 2)) | 0) - 97) | 0);
  $n($thiz.s_reflect_NameTransformer$__f_code2op).set(c, new $c_s_reflect_NameTransformer$OpCodes(op, code, $n($thiz.s_reflect_NameTransformer$__f_code2op).get(c)));
}
/** @constructor */
function $c_s_reflect_NameTransformer$() {
  this.s_reflect_NameTransformer$__f_nops = 0;
  this.s_reflect_NameTransformer$__f_ncodes = 0;
  this.s_reflect_NameTransformer$__f_op2code = null;
  this.s_reflect_NameTransformer$__f_code2op = null;
  $n_s_reflect_NameTransformer$ = this;
  this.s_reflect_NameTransformer$__f_nops = 128;
  this.s_reflect_NameTransformer$__f_ncodes = 676;
  this.s_reflect_NameTransformer$__f_op2code = new ($d_T.getArrayOf().constr)(this.s_reflect_NameTransformer$__f_nops);
  this.s_reflect_NameTransformer$__f_code2op = new ($d_s_reflect_NameTransformer$OpCodes.getArrayOf().constr)(this.s_reflect_NameTransformer$__f_ncodes);
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 126, "$tilde");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 61, "$eq");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 60, "$less");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 62, "$greater");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 33, "$bang");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 35, "$hash");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 37, "$percent");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 94, "$up");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 38, "$amp");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 124, "$bar");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 42, "$times");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 47, "$div");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 43, "$plus");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 45, "$minus");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 58, "$colon");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 92, "$bslash");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 63, "$qmark");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 64, "$at");
}
$c_s_reflect_NameTransformer$.prototype = new $h_O();
$c_s_reflect_NameTransformer$.prototype.constructor = $c_s_reflect_NameTransformer$;
/** @constructor */
function $h_s_reflect_NameTransformer$() {
}
$h_s_reflect_NameTransformer$.prototype = $c_s_reflect_NameTransformer$.prototype;
$c_s_reflect_NameTransformer$.prototype.decode__T__T = (function(name0) {
  var this$1 = $n(name0);
  if ($uZ(this$1.endsWith("<init>"))) {
    var name = ($m_sc_StringOps$().stripSuffix$extension__T__T__T(name0, "<init>") + "this");
  } else {
    var name = name0;
  }
  var buf = null;
  var this$3 = $n(name);
  var len = this$3.length;
  var i = 0;
  while ((i < len)) {
    var ops = null;
    var unicode = false;
    var this$4 = $n(name);
    var index = i;
    var c = $charAt(this$4, index);
    if (((c === 36) && (((2 + i) | 0) < len))) {
      var this$5 = $n(name);
      var index$1 = ((1 + i) | 0);
      var ch1 = $charAt(this$5, index$1);
      if (((((ch1 - 97) | 0) >>> 0) <= 25)) {
        var this$6 = $n(name);
        var index$2 = ((2 + i) | 0);
        var ch2 = $charAt(this$6, index$2);
        if (((((ch2 - 97) | 0) >>> 0) <= 25)) {
          ops = $n(this.s_reflect_NameTransformer$__f_code2op).get(((((Math.imul(26, ((ch1 - 97) | 0)) + ch2) | 0) - 97) | 0));
          while (true) {
            if ((ops !== null)) {
              var this$7 = $n(name);
              var prefix = $n(ops).s_reflect_NameTransformer$OpCodes__f_code;
              var toffset = i;
              var $x_1 = (!(((toffset <= this$7.length) && (toffset >= 0)) && $uZ(this$7.startsWith($n(prefix), toffset))));
            } else {
              var $x_1 = false;
            }
            if ($x_1) {
              ops = $n(ops).s_reflect_NameTransformer$OpCodes__f_next;
            } else {
              break;
            }
          }
          if ((ops !== null)) {
            if ((buf === null)) {
              buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
              var $x_2 = $n(buf);
              var this$8 = $n(name);
              var endIndex = i;
              if ((endIndex > this$8.length)) {
                $charAt(this$8, endIndex);
              }
              if ((endIndex < 0)) {
                $charAt(this$8, (-1));
              }
              $x_2.append__T__scm_StringBuilder($as_T(this$8.substring(0, endIndex)));
            }
            $n(buf).append__C__scm_StringBuilder($n(ops).s_reflect_NameTransformer$OpCodes__f_op);
            var $x_3 = i;
            var this$9 = $n($n(ops).s_reflect_NameTransformer$OpCodes__f_code);
            i = (($x_3 + this$9.length) | 0);
          }
        } else {
          if (((((len - i) | 0) >= 6) && (ch1 === 117))) {
            var this$10 = $m_jl_Character$();
            if (this$10.isDigit__I__Z(ch2)) {
              var $x_4 = true;
            } else {
              var $x_4 = ((((ch2 - 65) | 0) >>> 0) <= 5);
            }
          } else {
            var $x_4 = false;
          }
          if ($x_4) {
            var this$11 = $n(name);
            var beginIndex = ((2 + i) | 0);
            var endIndex$1 = ((6 + i) | 0);
            if ((beginIndex < 0)) {
              $charAt(this$11, beginIndex);
            }
            if ((endIndex$1 > this$11.length)) {
              $charAt(this$11, endIndex$1);
            }
            if ((endIndex$1 < beginIndex)) {
              $charAt(this$11, (-1));
            }
            var hex = $as_T(this$11.substring(beginIndex, endIndex$1));
            try {
              var this$12 = $m_jl_Integer$();
              var str = (65535 & this$12.java$lang$Integer$$parseIntImpl__T__I__I__I(hex, 16, 134217728));
              if ((buf === null)) {
                buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
                var $x_5 = $n(buf);
                var this$14 = $n(name);
                var endIndex$2 = i;
                if ((endIndex$2 > this$14.length)) {
                  $charAt(this$14, endIndex$2);
                }
                if ((endIndex$2 < 0)) {
                  $charAt(this$14, (-1));
                }
                $x_5.append__T__scm_StringBuilder($as_T(this$14.substring(0, endIndex$2)));
              }
              $n(buf).append__C__scm_StringBuilder(str);
              i = ((6 + i) | 0);
              unicode = true;
            } catch (e) {
              if ((!(e instanceof $c_jl_NumberFormatException))) {
                throw e;
              }
            }
          }
        }
      }
    }
    if (((ops === null) && (!unicode))) {
      if ((buf !== null)) {
        $n(buf).append__C__scm_StringBuilder(c);
      }
      i = ((1 + i) | 0);
    }
  }
  if ((buf === null)) {
    return name;
  } else {
    var this$15 = $n(buf);
    return $n(this$15.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
var $d_s_reflect_NameTransformer$ = new $TypeData().initClass($c_s_reflect_NameTransformer$, "scala.reflect.NameTransformer$", ({
  s_reflect_NameTransformer$: 1
}));
var $n_s_reflect_NameTransformer$;
function $m_s_reflect_NameTransformer$() {
  if ((!$n_s_reflect_NameTransformer$)) {
    $n_s_reflect_NameTransformer$ = new $c_s_reflect_NameTransformer$();
  }
  return $n_s_reflect_NameTransformer$;
}
/** @constructor */
function $c_s_reflect_NameTransformer$OpCodes(op, code, next) {
  this.s_reflect_NameTransformer$OpCodes__f_op = 0;
  this.s_reflect_NameTransformer$OpCodes__f_code = null;
  this.s_reflect_NameTransformer$OpCodes__f_next = null;
  this.s_reflect_NameTransformer$OpCodes__f_op = op;
  this.s_reflect_NameTransformer$OpCodes__f_code = code;
  this.s_reflect_NameTransformer$OpCodes__f_next = next;
}
$c_s_reflect_NameTransformer$OpCodes.prototype = new $h_O();
$c_s_reflect_NameTransformer$OpCodes.prototype.constructor = $c_s_reflect_NameTransformer$OpCodes;
/** @constructor */
function $h_s_reflect_NameTransformer$OpCodes() {
}
$h_s_reflect_NameTransformer$OpCodes.prototype = $c_s_reflect_NameTransformer$OpCodes.prototype;
var $d_s_reflect_NameTransformer$OpCodes = new $TypeData().initClass($c_s_reflect_NameTransformer$OpCodes, "scala.reflect.NameTransformer$OpCodes", ({
  s_reflect_NameTransformer$OpCodes: 1
}));
/** @constructor */
function $c_sr_BoxesRunTime$() {
}
$c_sr_BoxesRunTime$.prototype = new $h_O();
$c_sr_BoxesRunTime$.prototype.constructor = $c_sr_BoxesRunTime$;
/** @constructor */
function $h_sr_BoxesRunTime$() {
}
$h_sr_BoxesRunTime$.prototype = $c_sr_BoxesRunTime$.prototype;
$c_sr_BoxesRunTime$.prototype.equals__O__O__Z = (function(x, y) {
  if ((x === y)) {
    return true;
  } else if ($is_jl_Number(x)) {
    var x2 = $as_jl_Number(x);
    return this.equalsNumObject__jl_Number__O__Z(x2, y);
  } else if ((x instanceof $Char)) {
    var x3 = $as_jl_Character(x);
    return this.equalsCharObject__jl_Character__O__Z(x3, y);
  } else {
    return ((x === null) ? (y === null) : $dp_equals__O__Z($n(x), y));
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumObject__jl_Number__O__Z = (function(xn, y) {
  if ($is_jl_Number(y)) {
    var x2 = $as_jl_Number(y);
    return this.equalsNumNum__jl_Number__jl_Number__Z(xn, x2);
  } else if ((y instanceof $Char)) {
    var x3 = $as_jl_Character(y);
    if (((typeof xn) === "number")) {
      var x2$1 = $uD(xn);
      var this$1 = $n(x3).c;
      return (x2$1 === this$1);
    } else if ((xn instanceof $Long)) {
      var $x_1 = $uJ(xn);
      var x3$1_$_lo = $x_1.l;
      var x3$1_$_hi = $x_1.h;
      var this$2 = $n(x3).c;
      var value = this$2;
      var hi = (value >> 31);
      return (((x3$1_$_lo ^ value) | (x3$1_$_hi ^ hi)) === 0);
    } else {
      return ((xn === null) ? (x3 === null) : $dp_equals__O__Z($n(xn), x3));
    }
  } else {
    return ((xn === null) ? (y === null) : $dp_equals__O__Z($n(xn), y));
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumNum__jl_Number__jl_Number__Z = (function(xn, yn) {
  if (((typeof xn) === "number")) {
    var x2 = $uD(xn);
    if (((typeof yn) === "number")) {
      var x2$2 = $uD(yn);
      return (x2 === x2$2);
    } else if ((yn instanceof $Long)) {
      var $x_1 = $uJ(yn);
      var x3_$_lo = $x_1.l;
      var x3_$_hi = $x_1.h;
      return (x2 === ((4.294967296E9 * x3_$_hi) + (x3_$_lo >>> 0.0)));
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4 = $as_s_math_ScalaNumber(yn);
      return $n(x4).equals__O__Z(x2);
    } else {
      return false;
    }
  } else if ((xn instanceof $Long)) {
    var $x_2 = $uJ(xn);
    var x3$2_$_lo = $x_2.l;
    var x3$2_$_hi = $x_2.h;
    if ((yn instanceof $Long)) {
      var $x_3 = $uJ(yn);
      var x2$3_$_lo = $x_3.l;
      var x2$3_$_hi = $x_3.h;
      return (((x3$2_$_lo ^ x2$3_$_lo) | (x3$2_$_hi ^ x2$3_$_hi)) === 0);
    } else if (((typeof yn) === "number")) {
      var x3$3 = $uD(yn);
      return (((4.294967296E9 * x3$2_$_hi) + (x3$2_$_lo >>> 0.0)) === x3$3);
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4$2 = $as_s_math_ScalaNumber(yn);
      return $n(x4$2).equals__O__Z($bL(x3$2_$_lo, x3$2_$_hi));
    } else {
      return false;
    }
  } else {
    return ((xn === null) ? (yn === null) : $dp_equals__O__Z($n(xn), yn));
  }
});
$c_sr_BoxesRunTime$.prototype.equalsCharObject__jl_Character__O__Z = (function(xc, y) {
  if ((y instanceof $Char)) {
    var x2 = $as_jl_Character(y);
    var this$1 = $n(xc).c;
    var this$2 = $n(x2).c;
    return (this$1 === this$2);
  } else if ($is_jl_Number(y)) {
    var x3 = $as_jl_Number(y);
    if (((typeof x3) === "number")) {
      var x2$1 = $uD(x3);
      var this$3 = $n(xc).c;
      return (x2$1 === this$3);
    } else if ((x3 instanceof $Long)) {
      var $x_1 = $uJ(x3);
      var x3$1_$_lo = $x_1.l;
      var x3$1_$_hi = $x_1.h;
      var this$4 = $n(xc).c;
      var value = this$4;
      var hi = (value >> 31);
      return (((x3$1_$_lo ^ value) | (x3$1_$_hi ^ hi)) === 0);
    } else {
      return ((x3 === null) ? (xc === null) : $dp_equals__O__Z($n(x3), xc));
    }
  } else {
    return ((xc === null) && (y === null));
  }
});
var $d_sr_BoxesRunTime$ = new $TypeData().initClass($c_sr_BoxesRunTime$, "scala.runtime.BoxesRunTime$", ({
  sr_BoxesRunTime$: 1
}));
var $n_sr_BoxesRunTime$;
function $m_sr_BoxesRunTime$() {
  if ((!$n_sr_BoxesRunTime$)) {
    $n_sr_BoxesRunTime$ = new $c_sr_BoxesRunTime$();
  }
  return $n_sr_BoxesRunTime$;
}
var $d_sr_Null$ = new $TypeData().initClass(0, "scala.runtime.Null$", ({
  sr_Null$: 1
}));
/** @constructor */
function $c_sr_RichChar$() {
}
$c_sr_RichChar$.prototype = new $h_O();
$c_sr_RichChar$.prototype.constructor = $c_sr_RichChar$;
/** @constructor */
function $h_sr_RichChar$() {
}
$h_sr_RichChar$.prototype = $c_sr_RichChar$.prototype;
$c_sr_RichChar$.prototype.equals$extension__C__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichChar)) {
    var RichChar$1 = $n($as_sr_RichChar(x$1)).sr_RichChar__f_self;
    return (this$ === RichChar$1);
  } else {
    return false;
  }
});
var $d_sr_RichChar$ = new $TypeData().initClass($c_sr_RichChar$, "scala.runtime.RichChar$", ({
  sr_RichChar$: 1
}));
var $n_sr_RichChar$;
function $m_sr_RichChar$() {
  if ((!$n_sr_RichChar$)) {
    $n_sr_RichChar$ = new $c_sr_RichChar$();
  }
  return $n_sr_RichChar$;
}
/** @constructor */
function $c_sr_RichLong$() {
}
$c_sr_RichLong$.prototype = new $h_O();
$c_sr_RichLong$.prototype.constructor = $c_sr_RichLong$;
/** @constructor */
function $h_sr_RichLong$() {
}
$h_sr_RichLong$.prototype = $c_sr_RichLong$.prototype;
$c_sr_RichLong$.prototype.isValidByte$extension__J__Z = (function(this$_$_lo, this$_$_hi) {
  var value = ((this$_$_lo << 24) >> 24);
  var hi = (value >> 31);
  return (((value ^ this$_$_lo) | (hi ^ this$_$_hi)) === 0);
});
$c_sr_RichLong$.prototype.isValidShort$extension__J__Z = (function(this$_$_lo, this$_$_hi) {
  var value = ((this$_$_lo << 16) >> 16);
  var hi = (value >> 31);
  return (((value ^ this$_$_lo) | (hi ^ this$_$_hi)) === 0);
});
$c_sr_RichLong$.prototype.isValidChar$extension__J__Z = (function(this$_$_lo, this$_$_hi) {
  var value = (65535 & this$_$_lo);
  var hi = (value >> 31);
  return (((value ^ this$_$_lo) | (hi ^ this$_$_hi)) === 0);
});
$c_sr_RichLong$.prototype.isValidInt$extension__J__Z = (function(this$_$_lo, this$_$_hi) {
  var hi = (this$_$_lo >> 31);
  return (((this$_$_lo ^ this$_$_lo) | (hi ^ this$_$_hi)) === 0);
});
$c_sr_RichLong$.prototype.equals$extension__J__O__Z = (function(this$_$_lo, this$_$_hi, x$1) {
  if ((x$1 instanceof $c_sr_RichLong)) {
    var $x_1 = $as_sr_RichLong(x$1);
    var RichLong$1_$_lo = $n($x_1).sr_RichLong__f_self_$lo;
    var RichLong$1_$_hi = $n($x_1).sr_RichLong__f_self_$hi;
    return (((this$_$_lo ^ RichLong$1_$_lo) | (this$_$_hi ^ RichLong$1_$_hi)) === 0);
  } else {
    return false;
  }
});
var $d_sr_RichLong$ = new $TypeData().initClass($c_sr_RichLong$, "scala.runtime.RichLong$", ({
  sr_RichLong$: 1
}));
var $n_sr_RichLong$;
function $m_sr_RichLong$() {
  if ((!$n_sr_RichLong$)) {
    $n_sr_RichLong$ = new $c_sr_RichLong$();
  }
  return $n_sr_RichLong$;
}
/** @constructor */
function $c_sr_Scala3RunTime$() {
}
$c_sr_Scala3RunTime$.prototype = new $h_O();
$c_sr_Scala3RunTime$.prototype.constructor = $c_sr_Scala3RunTime$;
/** @constructor */
function $h_sr_Scala3RunTime$() {
}
$h_sr_Scala3RunTime$.prototype = $c_sr_Scala3RunTime$.prototype;
$c_sr_Scala3RunTime$.prototype.assertFailed__E = (function() {
  throw new $c_jl_AssertionError("assertion failed");
});
var $d_sr_Scala3RunTime$ = new $TypeData().initClass($c_sr_Scala3RunTime$, "scala.runtime.Scala3RunTime$", ({
  sr_Scala3RunTime$: 1
}));
var $n_sr_Scala3RunTime$;
function $m_sr_Scala3RunTime$() {
  if ((!$n_sr_Scala3RunTime$)) {
    $n_sr_Scala3RunTime$ = new $c_sr_Scala3RunTime$();
  }
  return $n_sr_Scala3RunTime$;
}
/** @constructor */
function $c_sr_ScalaRunTime$() {
}
$c_sr_ScalaRunTime$.prototype = new $h_O();
$c_sr_ScalaRunTime$.prototype.constructor = $c_sr_ScalaRunTime$;
/** @constructor */
function $h_sr_ScalaRunTime$() {
}
$h_sr_ScalaRunTime$.prototype = $c_sr_ScalaRunTime$.prototype;
$c_sr_ScalaRunTime$.prototype.array_apply__O__I__O = (function(xs, idx) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    return $n(x2).get(idx);
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    return $n(x3).get(idx);
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    return $n(x4).get(idx);
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    var $x_1 = $n(x5).u;
    var $x_2 = $aJCheckGet($x_1, idx);
    return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    return $n(x6).get(idx);
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    return $bC($n(x7).get(idx));
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    return $n(x8).get(idx);
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    return $n(x9).get(idx);
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    return $n(x10).get(idx);
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$c_sr_ScalaRunTime$.prototype.array_update__O__I__O__V = (function(xs, idx, value) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    $n(x2).set(idx, value);
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    $n(x3).set(idx, $uI(value));
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    $n(x4).set(idx, $uD(value));
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    var $x_2 = $n(x5);
    var $x_1 = $uJ(value);
    $x_2.set(idx, $x_1.l, $x_1.h);
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    $n(x6).set(idx, $uF(value));
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    $n(x7).set(idx, $uC(value));
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    $n(x8).set(idx, $uB(value));
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    $n(x9).set(idx, $uS(value));
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    $n(x10).set(idx, $uZ(value));
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$c_sr_ScalaRunTime$.prototype.array_clone__O__O = (function(xs) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    var this$1 = $n(x2);
    return this$1.clone__O();
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    var this$2 = $n(x3);
    return this$2.clone__O();
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    var this$3 = $n(x4);
    return this$3.clone__O();
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    var this$4 = $n(x5);
    return this$4.clone__O();
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    var this$5 = $n(x6);
    return this$5.clone__O();
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    var this$6 = $n(x7);
    return this$6.clone__O();
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    var this$7 = $n(x8);
    return this$7.clone__O();
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    var this$8 = $n(x9);
    return this$8.clone__O();
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    var this$9 = $n(x10);
    return this$9.clone__O();
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$c_sr_ScalaRunTime$.prototype._toString__s_Product__T = (function(x) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($n($n(x).productIterator__sc_Iterator()), ($n(x).productPrefix__T() + "("), ",", ")");
});
$c_sr_ScalaRunTime$.prototype.genericWrapArray__O__sci_ArraySeq = (function(xs) {
  return ((xs === null) ? null : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(xs));
});
$c_sr_ScalaRunTime$.prototype.wrapRefArray__AO__sci_ArraySeq = (function(xs) {
  if ((xs === null)) {
    return null;
  } else if (($n(xs).u.length === 0)) {
    var this$1 = $m_sci_ArraySeq$();
    return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$1);
  } else {
    return new $c_sci_ArraySeq$ofRef(xs);
  }
});
$c_sr_ScalaRunTime$.prototype.wrapCharArray__AC__sci_ArraySeq = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofChar(xs) : null);
});
var $d_sr_ScalaRunTime$ = new $TypeData().initClass($c_sr_ScalaRunTime$, "scala.runtime.ScalaRunTime$", ({
  sr_ScalaRunTime$: 1
}));
var $n_sr_ScalaRunTime$;
function $m_sr_ScalaRunTime$() {
  if ((!$n_sr_ScalaRunTime$)) {
    $n_sr_ScalaRunTime$ = new $c_sr_ScalaRunTime$();
  }
  return $n_sr_ScalaRunTime$;
}
/** @constructor */
function $c_sr_Statics$() {
}
$c_sr_Statics$.prototype = new $h_O();
$c_sr_Statics$.prototype.constructor = $c_sr_Statics$;
/** @constructor */
function $h_sr_Statics$() {
}
$h_sr_Statics$.prototype = $c_sr_Statics$.prototype;
$c_sr_Statics$.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return ((Math.imul(5, h) - 430675100) | 0);
});
$c_sr_Statics$.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$c_sr_Statics$.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.avalanche__I__I((hash ^ length));
});
$c_sr_Statics$.prototype.avalanche__I__I = (function(h0) {
  var h = h0;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$c_sr_Statics$.prototype.longHash__J__I = (function(lv_$_lo, lv_$_hi) {
  return ((lv_$_hi === (lv_$_lo >> 31)) ? lv_$_lo : (lv_$_lo ^ lv_$_hi));
});
$c_sr_Statics$.prototype.doubleHash__D__I = (function(dv) {
  var iv = $doubleToInt(dv);
  if ((iv === dv)) {
    return iv;
  } else {
    var $x_1 = $m_RTLong$().fromDouble__D__J(dv);
    var lv_$_lo = $x_1.l;
    var lv_$_hi = $x_1.h;
    if ((((4.294967296E9 * lv_$_hi) + (lv_$_lo >>> 0.0)) === dv)) {
      return (lv_$_lo ^ lv_$_hi);
    } else {
      var valueInt = (dv | 0);
      if (((valueInt === dv) && ((1.0 / dv) !== (-Infinity)))) {
        return valueInt;
      } else if ((dv !== dv)) {
        return 2146959360;
      } else {
        var fpBitsDataView = $fpBitsDataView;
        fpBitsDataView.setFloat64(0, dv, true);
        var lo = $uI(fpBitsDataView.getInt32(0, true));
        var hi = $uI(fpBitsDataView.getInt32(4, true));
        return (lo ^ hi);
      }
    }
  }
});
$c_sr_Statics$.prototype.anyHash__O__I = (function(x) {
  if ((x === null)) {
    return 0;
  } else if (((typeof x) === "number")) {
    var x3 = $uD(x);
    return this.doubleHash__D__I(x3);
  } else if ((x instanceof $Long)) {
    var $x_1 = $uJ(x);
    var x4_$_lo = $x_1.l;
    var x4_$_hi = $x_1.h;
    return this.longHash__J__I(x4_$_lo, x4_$_hi);
  } else {
    return $dp_hashCode__I($n(x));
  }
});
$c_sr_Statics$.prototype.ioobe__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_sr_Statics$ = new $TypeData().initClass($c_sr_Statics$, "scala.runtime.Statics$", ({
  sr_Statics$: 1
}));
var $n_sr_Statics$;
function $m_sr_Statics$() {
  if ((!$n_sr_Statics$)) {
    $n_sr_Statics$ = new $c_sr_Statics$();
  }
  return $n_sr_Statics$;
}
/** @constructor */
function $c_sr_Statics$PFMarker$() {
}
$c_sr_Statics$PFMarker$.prototype = new $h_O();
$c_sr_Statics$PFMarker$.prototype.constructor = $c_sr_Statics$PFMarker$;
/** @constructor */
function $h_sr_Statics$PFMarker$() {
}
$h_sr_Statics$PFMarker$.prototype = $c_sr_Statics$PFMarker$.prototype;
var $d_sr_Statics$PFMarker$ = new $TypeData().initClass($c_sr_Statics$PFMarker$, "scala.runtime.Statics$PFMarker$", ({
  sr_Statics$PFMarker$: 1
}));
var $n_sr_Statics$PFMarker$;
function $m_sr_Statics$PFMarker$() {
  if ((!$n_sr_Statics$PFMarker$)) {
    $n_sr_Statics$PFMarker$ = new $c_sr_Statics$PFMarker$();
  }
  return $n_sr_Statics$PFMarker$;
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty;
}
$c_sjs_js_WrappedDictionary$Cache$.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$Cache$.prototype.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
}
$h_sjs_js_WrappedDictionary$Cache$.prototype = $c_sjs_js_WrappedDictionary$Cache$.prototype;
var $d_sjs_js_WrappedDictionary$Cache$ = new $TypeData().initClass($c_sjs_js_WrappedDictionary$Cache$, "scala.scalajs.js.WrappedDictionary$Cache$", ({
  sjs_js_WrappedDictionary$Cache$: 1
}));
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$();
  }
  return $n_sjs_js_WrappedDictionary$Cache$;
}
/** @constructor */
function $c_sjs_js_defined$() {
}
$c_sjs_js_defined$.prototype = new $h_O();
$c_sjs_js_defined$.prototype.constructor = $c_sjs_js_defined$;
/** @constructor */
function $h_sjs_js_defined$() {
}
$h_sjs_js_defined$.prototype = $c_sjs_js_defined$.prototype;
$c_sjs_js_defined$.prototype.apply__O__sjs_js_$bar = (function(a) {
  return a;
});
var $d_sjs_js_defined$ = new $TypeData().initClass($c_sjs_js_defined$, "scala.scalajs.js.defined$", ({
  sjs_js_defined$: 1
}));
var $n_sjs_js_defined$;
function $m_sjs_js_defined$() {
  if ((!$n_sjs_js_defined$)) {
    $n_sjs_js_defined$ = new $c_sjs_js_defined$();
  }
  return $n_sjs_js_defined$;
}
/** @constructor */
function $c_sjs_js_timers_package$() {
}
$c_sjs_js_timers_package$.prototype = new $h_O();
$c_sjs_js_timers_package$.prototype.constructor = $c_sjs_js_timers_package$;
/** @constructor */
function $h_sjs_js_timers_package$() {
}
$h_sjs_js_timers_package$.prototype = $c_sjs_js_timers_package$.prototype;
$c_sjs_js_timers_package$.prototype.setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle = (function(interval, body) {
  var $x_2 = setTimeout;
  var this$2 = $n(interval);
  var $x_1 = $n(this$2.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$2.s_concurrent_duration_FiniteDuration__f_length_$lo, this$2.s_concurrent_duration_FiniteDuration__f_length_$hi);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  return $x_2((() => {
    var this$1 = $n(body);
    this$1.apply__O();
  }), ((4.294967296E9 * x_$_hi) + (x_$_lo >>> 0.0)));
});
$c_sjs_js_timers_package$.prototype.clearTimeout__sjs_js_timers_SetTimeoutHandle__V = (function(handle) {
  clearTimeout(handle);
});
var $d_sjs_js_timers_package$ = new $TypeData().initClass($c_sjs_js_timers_package$, "scala.scalajs.js.timers.package$", ({
  sjs_js_timers_package$: 1
}));
var $n_sjs_js_timers_package$;
function $m_sjs_js_timers_package$() {
  if ((!$n_sjs_js_timers_package$)) {
    $n_sjs_js_timers_package$ = new $c_sjs_js_timers_package$();
  }
  return $n_sjs_js_timers_package$;
}
function $as_sjs_reflect_LoadableModuleClass(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.reflect.LoadableModuleClass"));
}
function $isArrayOf_sjs_reflect_LoadableModuleClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_reflect_LoadableModuleClass)));
}
function $asArrayOf_sjs_reflect_LoadableModuleClass(obj, depth) {
  return (($isArrayOf_sjs_reflect_LoadableModuleClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.reflect.LoadableModuleClass;", depth));
}
/** @constructor */
function $c_sjs_reflect_Reflect$() {
  this.sjs_reflect_Reflect$__f_loadableModuleClasses = null;
  $n_sjs_reflect_Reflect$ = this;
  this.sjs_reflect_Reflect$__f_loadableModuleClasses = $ct_scm_HashMap__(new $c_scm_HashMap());
  $ct_scm_HashMap__(new $c_scm_HashMap());
}
$c_sjs_reflect_Reflect$.prototype = new $h_O();
$c_sjs_reflect_Reflect$.prototype.constructor = $c_sjs_reflect_Reflect$;
/** @constructor */
function $h_sjs_reflect_Reflect$() {
}
$h_sjs_reflect_Reflect$.prototype = $c_sjs_reflect_Reflect$.prototype;
var $d_sjs_reflect_Reflect$ = new $TypeData().initClass($c_sjs_reflect_Reflect$, "scala.scalajs.reflect.Reflect$", ({
  sjs_reflect_Reflect$: 1
}));
var $n_sjs_reflect_Reflect$;
function $m_sjs_reflect_Reflect$() {
  if ((!$n_sjs_reflect_Reflect$)) {
    $n_sjs_reflect_Reflect$ = new $c_sjs_reflect_Reflect$();
  }
  return $n_sjs_reflect_Reflect$;
}
/** @constructor */
function $c_s_sys_package$() {
}
$c_s_sys_package$.prototype = new $h_O();
$c_s_sys_package$.prototype.constructor = $c_s_sys_package$;
/** @constructor */
function $h_s_sys_package$() {
}
$h_s_sys_package$.prototype = $c_s_sys_package$.prototype;
$c_s_sys_package$.prototype.error__T__E = (function(message) {
  throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), message);
});
var $d_s_sys_package$ = new $TypeData().initClass($c_s_sys_package$, "scala.sys.package$", ({
  s_sys_package$: 1
}));
var $n_s_sys_package$;
function $m_s_sys_package$() {
  if ((!$n_s_sys_package$)) {
    $n_s_sys_package$ = new $c_s_sys_package$();
  }
  return $n_s_sys_package$;
}
/** @constructor */
function $c_s_util_Sorting$() {
}
$c_s_util_Sorting$.prototype = new $h_O();
$c_s_util_Sorting$.prototype.constructor = $c_s_util_Sorting$;
/** @constructor */
function $h_s_util_Sorting$() {
}
$h_s_util_Sorting$.prototype = $c_s_util_Sorting$.prototype;
$c_s_util_Sorting$.prototype.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V = (function(a, i0, iN, ord) {
  var n = ((iN - i0) | 0);
  if ((n < 2)) {
    return (void 0);
  }
  if (($n(ord).compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0))) > 0)) {
    var temp = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0);
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i0, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0)));
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ((1 + i0) | 0), temp);
  }
  var m = 2;
  while ((m < n)) {
    var next = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((i0 + m) | 0));
    if (($n(ord).compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((((i0 + m) | 0) - 1) | 0))) < 0)) {
      var iA = i0;
      var iB = ((((i0 + m) | 0) - 1) | 0);
      while ((((iB - iA) | 0) > 1)) {
        var ix = ((((iA + iB) | 0) >>> 1) | 0);
        if (($n(ord).compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ix)) < 0)) {
          iB = ix;
        } else {
          iA = ix;
        }
      }
      var ix$2 = ((iA + (($n(ord).compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
      var i = ((i0 + m) | 0);
      while ((i > ix$2)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((i - 1) | 0)));
        i = ((i - 1) | 0);
      }
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ix$2, next);
    }
    m = ((1 + m) | 0);
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V = (function(a, i0, iN, ord, scratch, evidence$2) {
  if ((((iN - i0) | 0) < 32)) {
    this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, i0, iN, ord);
  } else {
    var iK = ((((i0 + iN) | 0) >>> 1) | 0);
    var sc = ((scratch === null) ? $n(evidence$2).newArray__I__O(((iK - i0) | 0)) : scratch);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, i0, iK, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK, iN, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, i0, iK, iN, ord, sc);
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V = (function(a, i0, iK, iN, ord, scratch) {
  if (($n(ord).compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((iK - 1) | 0)), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iK)) > 0)) {
    var i = i0;
    var jN = ((iK - i0) | 0);
    var j = 0;
    while ((i < iK)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(scratch, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
      i = ((1 + i) | 0);
      j = ((1 + j) | 0);
    }
    var k = i0;
    j = 0;
    while (((i < iN) && (j < jN))) {
      if (($n(ord).compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i), $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j)) < 0)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
        i = ((1 + i) | 0);
      } else {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
        j = ((1 + j) | 0);
      }
      k = ((1 + k) | 0);
    }
    while ((j < jN)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
      j = ((1 + j) | 0);
      k = ((1 + k) | 0);
    }
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$booleanSort__AZ__I__I__V = (function(a, from, until) {
  var i = from;
  var n = 0;
  while ((i < until)) {
    if ((!$n(a).get(i))) {
      n = ((1 + n) | 0);
    }
    i = ((1 + i) | 0);
  }
  i = 0;
  while ((i < n)) {
    $n(a).set(((from + i) | 0), false);
    i = ((1 + i) | 0);
  }
  while ((((from + i) | 0) < until)) {
    $n(a).set(((from + i) | 0), true);
    i = ((1 + i) | 0);
  }
});
$c_s_util_Sorting$.prototype.stableSort__O__I__I__s_math_Ordering__V = (function(a, from, until, evidence$4) {
  if ((a instanceof $ac_O)) {
    if ((($m_jl_reflect_Array$().getLength__O__I(a) > 1) && (evidence$4 === null))) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Ordering");
    }
    var array = $asArrayOf_O(a, 1);
    $m_ju_Arrays$().sort__AO__I__I__ju_Comparator__V(array, from, until, evidence$4);
  } else if ((a instanceof $ac_I)) {
    var x3 = $asArrayOf_I(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Int$())) {
      $m_ju_Arrays$().sort__AI__I__I__V(x3, from, until);
    } else {
      var evidence$2 = $m_s_reflect_ManifestFactory$IntManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, until, evidence$4);
      } else {
        var iK = ((((from + until) | 0) >>> 1) | 0);
        var len = ((iK - from) | 0);
        var sc = new $ac_I(len);
        if ((((iK - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, iK, evidence$4);
        } else {
          var iK$1 = ((((from + iK) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, from, iK$1, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$1, iK, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK$1, iK, evidence$4, sc);
        }
        if ((((until - iK) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, iK, until, evidence$4);
        } else {
          var iK$2 = ((((iK + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK, iK$2, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$2, until, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, iK, iK$2, until, evidence$4, sc);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK, until, evidence$4, sc);
      }
    }
  } else if ((a instanceof $ac_D)) {
    var x4 = $asArrayOf_D(a, 1);
    var evidence$2$1 = $m_s_reflect_ManifestFactory$DoubleManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, until, evidence$4);
    } else {
      var iK$3 = ((((from + until) | 0) >>> 1) | 0);
      var len$1 = ((iK$3 - from) | 0);
      var sc$1 = new $ac_D(len$1);
      if ((((iK$3 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, iK$3, evidence$4);
      } else {
        var iK$4 = ((((from + iK$3) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, from, iK$4, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$4, iK$3, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$4, iK$3, evidence$4, sc$1);
      }
      if ((((until - iK$3) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, iK$3, until, evidence$4);
      } else {
        var iK$5 = ((((iK$3 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$3, iK$5, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$5, until, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, iK$3, iK$5, until, evidence$4, sc$1);
      }
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$3, until, evidence$4, sc$1);
    }
  } else if ((a instanceof $ac_J)) {
    var x5 = $asArrayOf_J(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Long$())) {
      $m_ju_Arrays$().sort__AJ__I__I__V(x5, from, until);
    } else {
      var evidence$2$2 = $m_s_reflect_ManifestFactory$LongManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, until, evidence$4);
      } else {
        var iK$6 = ((((from + until) | 0) >>> 1) | 0);
        var len$2 = ((iK$6 - from) | 0);
        var sc$2 = new $ac_J(len$2);
        if ((((iK$6 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, iK$6, evidence$4);
        } else {
          var iK$7 = ((((from + iK$6) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, from, iK$7, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$7, iK$6, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$7, iK$6, evidence$4, sc$2);
        }
        if ((((until - iK$6) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, iK$6, until, evidence$4);
        } else {
          var iK$8 = ((((iK$6 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$6, iK$8, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$8, until, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, iK$6, iK$8, until, evidence$4, sc$2);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$6, until, evidence$4, sc$2);
      }
    }
  } else if ((a instanceof $ac_F)) {
    var x6 = $asArrayOf_F(a, 1);
    var evidence$2$3 = $m_s_reflect_ManifestFactory$FloatManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, until, evidence$4);
    } else {
      var iK$9 = ((((from + until) | 0) >>> 1) | 0);
      var len$3 = ((iK$9 - from) | 0);
      var sc$3 = new $ac_F(len$3);
      if ((((iK$9 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, iK$9, evidence$4);
      } else {
        var iK$10 = ((((from + iK$9) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, from, iK$10, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$10, iK$9, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$10, iK$9, evidence$4, sc$3);
      }
      if ((((until - iK$9) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, iK$9, until, evidence$4);
      } else {
        var iK$11 = ((((iK$9 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$9, iK$11, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$11, until, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, iK$9, iK$11, until, evidence$4, sc$3);
      }
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$9, until, evidence$4, sc$3);
    }
  } else if ((a instanceof $ac_C)) {
    var x7 = $asArrayOf_C(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Char$())) {
      $m_ju_Arrays$().sort__AC__I__I__V(x7, from, until);
    } else {
      var evidence$2$4 = $m_s_reflect_ManifestFactory$CharManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, until, evidence$4);
      } else {
        var iK$12 = ((((from + until) | 0) >>> 1) | 0);
        var len$4 = ((iK$12 - from) | 0);
        var sc$4 = new $ac_C(len$4);
        if ((((iK$12 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, iK$12, evidence$4);
        } else {
          var iK$13 = ((((from + iK$12) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, from, iK$13, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$13, iK$12, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$13, iK$12, evidence$4, sc$4);
        }
        if ((((until - iK$12) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, iK$12, until, evidence$4);
        } else {
          var iK$14 = ((((iK$12 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$12, iK$14, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$14, until, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, iK$12, iK$14, until, evidence$4, sc$4);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$12, until, evidence$4, sc$4);
      }
    }
  } else if ((a instanceof $ac_B)) {
    var x8 = $asArrayOf_B(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Byte$())) {
      $m_ju_Arrays$().sort__AB__I__I__V(x8, from, until);
    } else {
      var evidence$2$5 = $m_s_reflect_ManifestFactory$ByteManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, until, evidence$4);
      } else {
        var iK$15 = ((((from + until) | 0) >>> 1) | 0);
        var len$5 = ((iK$15 - from) | 0);
        var sc$5 = new $ac_B(len$5);
        if ((((iK$15 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, iK$15, evidence$4);
        } else {
          var iK$16 = ((((from + iK$15) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, from, iK$16, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$16, iK$15, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$16, iK$15, evidence$4, sc$5);
        }
        if ((((until - iK$15) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, iK$15, until, evidence$4);
        } else {
          var iK$17 = ((((iK$15 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$15, iK$17, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$17, until, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, iK$15, iK$17, until, evidence$4, sc$5);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$15, until, evidence$4, sc$5);
      }
    }
  } else if ((a instanceof $ac_S)) {
    var x9 = $asArrayOf_S(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Short$())) {
      $m_ju_Arrays$().sort__AS__I__I__V(x9, from, until);
    } else {
      var evidence$2$6 = $m_s_reflect_ManifestFactory$ShortManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, until, evidence$4);
      } else {
        var iK$18 = ((((from + until) | 0) >>> 1) | 0);
        var len$6 = ((iK$18 - from) | 0);
        var sc$6 = new $ac_S(len$6);
        if ((((iK$18 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, iK$18, evidence$4);
        } else {
          var iK$19 = ((((from + iK$18) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, from, iK$19, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$19, iK$18, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$19, iK$18, evidence$4, sc$6);
        }
        if ((((until - iK$18) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, iK$18, until, evidence$4);
        } else {
          var iK$20 = ((((iK$18 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$18, iK$20, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$20, until, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, iK$18, iK$20, until, evidence$4, sc$6);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$18, until, evidence$4, sc$6);
      }
    }
  } else if ((a instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Boolean$())) {
      this.scala$util$Sorting$$booleanSort__AZ__I__I__V(x10, from, until);
    } else {
      var evidence$2$7 = $m_s_reflect_ManifestFactory$BooleanManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, until, evidence$4);
      } else {
        var iK$21 = ((((from + until) | 0) >>> 1) | 0);
        var len$7 = ((iK$21 - from) | 0);
        var sc$7 = new $ac_Z(len$7);
        if ((((iK$21 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, iK$21, evidence$4);
        } else {
          var iK$22 = ((((from + iK$21) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, from, iK$22, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$22, iK$21, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$22, iK$21, evidence$4, sc$7);
        }
        if ((((until - iK$21) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, iK$21, until, evidence$4);
        } else {
          var iK$23 = ((((iK$21 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$21, iK$23, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$23, until, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, iK$21, iK$23, until, evidence$4, sc$7);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$21, until, evidence$4, sc$7);
      }
    }
  } else if ((a === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(a);
  }
});
var $d_s_util_Sorting$ = new $TypeData().initClass($c_s_util_Sorting$, "scala.util.Sorting$", ({
  s_util_Sorting$: 1
}));
var $n_s_util_Sorting$;
function $m_s_util_Sorting$() {
  if ((!$n_s_util_Sorting$)) {
    $n_s_util_Sorting$ = new $c_s_util_Sorting$();
  }
  return $n_s_util_Sorting$;
}
function $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable($thiz) {
  var this$1 = $m_s_util_control_NoStackTrace$();
  if (this$1.s_util_control_NoStackTrace$__f__noSuppression) {
    return $c_jl_Throwable.prototype.fillInStackTrace__jl_Throwable.call($thiz);
  } else {
    return $as_jl_Throwable($thiz);
  }
}
/** @constructor */
function $c_s_util_control_NonFatal$() {
}
$c_s_util_control_NonFatal$.prototype = new $h_O();
$c_s_util_control_NonFatal$.prototype.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
}
$h_s_util_control_NonFatal$.prototype = $c_s_util_control_NonFatal$.prototype;
$c_s_util_control_NonFatal$.prototype.apply__jl_Throwable__Z = (function(t) {
  return (!((t instanceof $c_jl_VirtualMachineError) || (false || (false || (false || (t instanceof $c_s_util_control_ControlThrowable))))));
});
$c_s_util_control_NonFatal$.prototype.unapply__jl_Throwable__s_Option = (function(t) {
  return (this.apply__jl_Throwable__Z(t) ? new $c_s_Some(t) : $m_s_None$());
});
var $d_s_util_control_NonFatal$ = new $TypeData().initClass($c_s_util_control_NonFatal$, "scala.util.control.NonFatal$", ({
  s_util_control_NonFatal$: 1
}));
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$();
  }
  return $n_s_util_control_NonFatal$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3() {
}
$c_s_util_hashing_MurmurHash3.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3.prototype.constructor = $c_s_util_hashing_MurmurHash3;
/** @constructor */
function $h_s_util_hashing_MurmurHash3() {
}
$h_s_util_hashing_MurmurHash3.prototype = $c_s_util_hashing_MurmurHash3.prototype;
$c_s_util_hashing_MurmurHash3.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return ((Math.imul(5, h) - 430675100) | 0);
});
$c_s_util_hashing_MurmurHash3.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$c_s_util_hashing_MurmurHash3.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I((hash ^ length));
});
$c_s_util_hashing_MurmurHash3.prototype.scala$util$hashing$MurmurHash3$$avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$c_s_util_hashing_MurmurHash3.prototype.tuple2Hash__I__I__I__I = (function(x, y, seed) {
  var h = seed;
  h = this.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  h = this.mix__I__I__I(h, x);
  h = this.mix__I__I__I(h, y);
  return this.finalizeHash__I__I__I(h, 2);
});
$c_s_util_hashing_MurmurHash3.prototype.productHash__s_Product__I__Z__I = (function(x, seed, ignorePrefix) {
  var arr = $n(x).productArity__I();
  if ((arr === 0)) {
    return ((!ignorePrefix) ? $f_T__hashCode__I($n($n(x).productPrefix__T())) : seed);
  } else {
    var h = seed;
    if ((!ignorePrefix)) {
      h = this.mix__I__I__I(h, $f_T__hashCode__I($n($n(x).productPrefix__T())));
    }
    var i = 0;
    while ((i < arr)) {
      var $x_1 = h;
      var x$1 = $n(x).productElement__I__O(i);
      h = this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x$1));
      i = ((1 + i) | 0);
    }
    return this.finalizeHash__I__I__I(h, arr);
  }
});
$c_s_util_hashing_MurmurHash3.prototype.caseClassHash__s_Product__I__T__I = (function(x, seed, caseClassName) {
  var arr = $n(x).productArity__I();
  var aye = $f_T__hashCode__I($n(((caseClassName !== null) ? caseClassName : $n(x).productPrefix__T())));
  if ((arr === 0)) {
    return aye;
  } else {
    var h = seed;
    h = this.mix__I__I__I(h, aye);
    var i = 0;
    while ((i < arr)) {
      var $x_1 = h;
      var x$1 = $n(x).productElement__I__O(i);
      h = this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x$1));
      i = ((1 + i) | 0);
    }
    return this.finalizeHash__I__I__I(h, arr);
  }
});
$c_s_util_hashing_MurmurHash3.prototype.stringHash__T__I__I = (function(str, seed) {
  var h = seed;
  var i = 0;
  while (true) {
    var $x_1 = i;
    var this$1 = $n(str);
    if ((((1 + $x_1) | 0) < this$1.length)) {
      var this$2 = $n(str);
      var index = i;
      var this$3 = $n(str);
      var index$1 = ((1 + i) | 0);
      var data = ((($charAt(this$2, index) << 16) + $charAt(this$3, index$1)) | 0);
      h = this.mix__I__I__I(h, data);
      i = ((2 + i) | 0);
    } else {
      break;
    }
  }
  var $x_2 = i;
  var this$4 = $n(str);
  if (($x_2 < this$4.length)) {
    var $x_3 = h;
    var this$5 = $n(str);
    var index$2 = i;
    h = this.mixLast__I__I__I($x_3, $charAt(this$5, index$2));
  }
  var $x_4 = h;
  var this$6 = $n(str);
  return this.finalizeHash__I__I__I($x_4, this$6.length);
});
$c_s_util_hashing_MurmurHash3.prototype.unorderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var a = 0;
  var b = 0;
  var n = 0;
  var c = 1;
  var iterator = $n(xs).iterator__sc_Iterator();
  while ($n(iterator).hasNext__Z()) {
    var x = $n(iterator).next__O();
    var h = $m_sr_Statics$().anyHash__O__I(x);
    a = ((a + h) | 0);
    b = (b ^ h);
    c = Math.imul(c, (1 | h));
    n = ((1 + n) | 0);
  }
  var h$2 = seed;
  h$2 = this.mix__I__I__I(h$2, a);
  h$2 = this.mix__I__I__I(h$2, b);
  h$2 = this.mixLast__I__I__I(h$2, c);
  return this.finalizeHash__I__I__I(h$2, n);
});
$c_s_util_hashing_MurmurHash3.prototype.orderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var it = $n(xs).iterator__sc_Iterator();
  var h = seed;
  if ((!$n(it).hasNext__Z())) {
    return this.finalizeHash__I__I__I(h, 0);
  }
  var x0 = $n(it).next__O();
  if ((!$n(it).hasNext__Z())) {
    return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $m_sr_Statics$().anyHash__O__I(x0)), 1);
  }
  var x1 = $n(it).next__O();
  var initial = $m_sr_Statics$().anyHash__O__I(x0);
  h = this.mix__I__I__I(h, initial);
  var h0 = h;
  var prev = $m_sr_Statics$().anyHash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while ($n(it).hasNext__Z()) {
    h = this.mix__I__I__I(h, prev);
    var x = $n(it).next__O();
    var hash = $m_sr_Statics$().anyHash__O__I(x);
    if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
      h = this.mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while ($n(it).hasNext__Z()) {
        var $x_1 = h;
        var x$1 = $n(it).next__O();
        h = this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x$1));
        i = ((1 + i) | 0);
      }
      return this.finalizeHash__I__I__I(h, i);
    }
    prev = hash;
    i = ((1 + i) | 0);
  }
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash__O__I__I = (function(a, seed) {
  var h = seed;
  var l = $m_jl_reflect_Array$().getLength__O__I(a);
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var x = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break;
    }
    default: {
      var x$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var x$4 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.rangeHash__I__I__I__I__I = (function(start, step, last, seed) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(this.mix__I__I__I(seed, start), step), last));
});
$c_s_util_hashing_MurmurHash3.prototype.indexedSeqHash__sc_IndexedSeq__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).length__I();
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var x = $n(a).apply__I__O(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break;
    }
    default: {
      var x$1 = $n(a).apply__I__O(0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $n(a).apply__I__O(1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $n(a).apply__I__O(i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var x$4 = $n(a).apply__I__O(i);
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.listHash__sci_List__I__I = (function(xs, seed) {
  var n = 0;
  var h = seed;
  var rangeState = 0;
  var rangeDiff = 0;
  var prev = 0;
  var initial = 0;
  var elems = xs;
  while ((!$n(elems).isEmpty__Z())) {
    var head = $n(elems).head__O();
    var tail = $as_sci_List($n(elems).tail__O());
    var hash = $m_sr_Statics$().anyHash__O__I(head);
    h = this.mix__I__I__I(h, hash);
    var x1 = rangeState;
    switch (x1) {
      case 0: {
        initial = hash;
        rangeState = 1;
        break;
      }
      case 1: {
        rangeDiff = ((hash - prev) | 0);
        rangeState = 2;
        break;
      }
      case 2: {
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          rangeState = 3;
        }
        break;
      }
    }
    prev = hash;
    n = ((1 + n) | 0);
    elems = tail;
  }
  return ((rangeState === 2) ? this.rangeHash__I__I__I__I__I(initial, rangeDiff, prev, seed) : this.finalizeHash__I__I__I(h, n));
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mZc$sp__AZ__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, ($n(a).get(0) ? 1231 : 1237)), 1);
      break;
    }
    default: {
      var initial = ($n(a).get(0) ? 1231 : 1237);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = ($n(a).get(1) ? 1231 : 1237);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = ($n(a).get(i) ? 1231 : 1237);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, ($n(a).get(i) ? 1231 : 1237));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mBc$sp__AB__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break;
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mCc$sp__AC__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break;
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mDc$sp__AD__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var dv = $n(a).get(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().doubleHash__D__I(dv)), 1);
      break;
    }
    default: {
      var dv$1 = $n(a).get(0);
      var initial = $m_sr_Statics$().doubleHash__D__I(dv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var dv$2 = $n(a).get(1);
      var prev = $m_sr_Statics$().doubleHash__D__I(dv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var dv$3 = $n(a).get(i);
        var hash = $m_sr_Statics$().doubleHash__D__I(dv$3);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var dv$4 = $n(a).get(i);
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().doubleHash__D__I(dv$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mFc$sp__AF__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var fv = $n(a).get(0);
      var this$1 = $m_sr_Statics$();
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, this$1.doubleHash__D__I(fv)), 1);
      break;
    }
    default: {
      var fv$1 = $n(a).get(0);
      var this$2 = $m_sr_Statics$();
      var initial = this$2.doubleHash__D__I(fv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var fv$2 = $n(a).get(1);
      var this$3 = $m_sr_Statics$();
      var prev = this$3.doubleHash__D__I(fv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var fv$3 = $n(a).get(i);
        var this$4 = $m_sr_Statics$();
        var hash = this$4.doubleHash__D__I(fv$3);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var fv$4 = $n(a).get(i);
            var this$5 = $m_sr_Statics$();
            h = this.mix__I__I__I($x_2, this$5.doubleHash__D__I(fv$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mIc$sp__AI__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break;
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mJc$sp__AJ__I__I = (function(a, seed) {
  var h = seed;
  var l = (($n(a).u.length >>> 1) | 0);
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_2 = h;
      var $x_1 = $n(a).u;
      $aJCheckGet($x_1, 0);
      var lv_$_lo = $x_1[0];
      var lv_$_hi = $x_1[1];
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_2, $m_sr_Statics$().longHash__J__I(lv_$_lo, lv_$_hi)), 1);
      break;
    }
    default: {
      var $x_3 = $n(a).u;
      $aJCheckGet($x_3, 0);
      var lv$1_$_lo = $x_3[0];
      var lv$1_$_hi = $x_3[1];
      var initial = $m_sr_Statics$().longHash__J__I(lv$1_$_lo, lv$1_$_hi);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var $x_4 = $n(a).u;
      $aJCheckGet($x_4, 1);
      var lv$2_$_lo = $x_4[2];
      var lv$2_$_hi = $x_4[3];
      var prev = $m_sr_Statics$().longHash__J__I(lv$2_$_lo, lv$2_$_hi);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var $x_5 = $n(a).u;
        var $x_6 = $aJCheckGet($x_5, i);
        var lv$3_$_lo = $x_5[$x_6];
        var lv$3_$_hi = $x_5[(($x_6 + 1) | 0)];
        var hash = $m_sr_Statics$().longHash__J__I(lv$3_$_lo, lv$3_$_hi);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_9 = h;
            var $x_7 = $n(a).u;
            var $x_8 = $aJCheckGet($x_7, i);
            var lv$4_$_lo = $x_7[$x_8];
            var lv$4_$_hi = $x_7[(($x_8 + 1) | 0)];
            h = this.mix__I__I__I($x_9, $m_sr_Statics$().longHash__J__I(lv$4_$_lo, lv$4_$_hi));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mSc$sp__AS__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $n(a).get(0)), 1);
      break;
    }
    default: {
      var initial = $n(a).get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = $n(a).get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = $n(a).get(i);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, $n(a).get(i));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mVc$sp__Ajl_Void__I__I = (function(a, seed) {
  var h = seed;
  var l = $n(a).u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, 0), 1);
      break;
    }
    default: {
      h = this.mix__I__I__I(h, 0);
      var h0 = h;
      var prev = 0;
      var rangeDiff = prev;
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        if (((rangeDiff !== ((-prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, 0);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, 0);
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = 0;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
function $is_Lsnabbdom_AttrValue(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_AttrValue)));
}
function $as_Lsnabbdom_AttrValue(obj) {
  return (($is_Lsnabbdom_AttrValue(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.AttrValue"));
}
function $isArrayOf_Lsnabbdom_AttrValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_AttrValue)));
}
function $asArrayOf_Lsnabbdom_AttrValue(obj, depth) {
  return (($isArrayOf_Lsnabbdom_AttrValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.AttrValue;", depth));
}
function $is_Lsnabbdom_CreateHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_CreateHook)));
}
function $as_Lsnabbdom_CreateHook(obj) {
  return (($is_Lsnabbdom_CreateHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.CreateHook"));
}
function $isArrayOf_Lsnabbdom_CreateHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_CreateHook)));
}
function $asArrayOf_Lsnabbdom_CreateHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_CreateHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.CreateHook;", depth));
}
function $is_Lsnabbdom_DestroyHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_DestroyHook)));
}
function $as_Lsnabbdom_DestroyHook(obj) {
  return (($is_Lsnabbdom_DestroyHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.DestroyHook"));
}
function $isArrayOf_Lsnabbdom_DestroyHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_DestroyHook)));
}
function $asArrayOf_Lsnabbdom_DestroyHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_DestroyHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.DestroyHook;", depth));
}
function $is_Lsnabbdom_DomApi(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_DomApi)));
}
function $as_Lsnabbdom_DomApi(obj) {
  return (($is_Lsnabbdom_DomApi(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.DomApi"));
}
function $isArrayOf_Lsnabbdom_DomApi(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_DomApi)));
}
function $asArrayOf_Lsnabbdom_DomApi(obj, depth) {
  return (($isArrayOf_Lsnabbdom_DomApi(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.DomApi;", depth));
}
/** @constructor */
function $c_Lsnabbdom_EventHandler(cbs) {
  this.Lsnabbdom_EventHandler__f_cbs = null;
  this.Lsnabbdom_EventHandler__f_cbs = cbs;
}
$c_Lsnabbdom_EventHandler.prototype = new $h_O();
$c_Lsnabbdom_EventHandler.prototype.constructor = $c_Lsnabbdom_EventHandler;
/** @constructor */
function $h_Lsnabbdom_EventHandler() {
}
$h_Lsnabbdom_EventHandler.prototype = $c_Lsnabbdom_EventHandler.prototype;
function $as_Lsnabbdom_EventHandler(obj) {
  return (((obj instanceof $c_Lsnabbdom_EventHandler) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.EventHandler"));
}
function $isArrayOf_Lsnabbdom_EventHandler(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_EventHandler)));
}
function $asArrayOf_Lsnabbdom_EventHandler(obj, depth) {
  return (($isArrayOf_Lsnabbdom_EventHandler(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.EventHandler;", depth));
}
var $d_Lsnabbdom_EventHandler = new $TypeData().initClass($c_Lsnabbdom_EventHandler, "snabbdom.EventHandler", ({
  Lsnabbdom_EventHandler: 1
}));
/** @constructor */
function $c_Lsnabbdom_EventHandler$() {
}
$c_Lsnabbdom_EventHandler$.prototype = new $h_O();
$c_Lsnabbdom_EventHandler$.prototype.constructor = $c_Lsnabbdom_EventHandler$;
/** @constructor */
function $h_Lsnabbdom_EventHandler$() {
}
$h_Lsnabbdom_EventHandler$.prototype = $c_Lsnabbdom_EventHandler$.prototype;
$c_Lsnabbdom_EventHandler$.prototype.apply__sci_Seq__Lsnabbdom_EventHandler = (function(cbs) {
  return new $c_Lsnabbdom_EventHandler($as_sci_Seq($n(cbs).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cb) => {
    var cb$1 = $as_F1(cb);
    return new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((ev, _$1) => {
      $as_Lsnabbdom_VNode(_$1);
      $n(cb$1).apply__O__O(ev);
    }));
  })))));
});
var $d_Lsnabbdom_EventHandler$ = new $TypeData().initClass($c_Lsnabbdom_EventHandler$, "snabbdom.EventHandler$", ({
  Lsnabbdom_EventHandler$: 1
}));
var $n_Lsnabbdom_EventHandler$;
function $m_Lsnabbdom_EventHandler$() {
  if ((!$n_Lsnabbdom_EventHandler$)) {
    $n_Lsnabbdom_EventHandler$ = new $c_Lsnabbdom_EventHandler$();
  }
  return $n_Lsnabbdom_EventHandler$;
}
function $is_Lsnabbdom_InitHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_InitHook)));
}
function $as_Lsnabbdom_InitHook(obj) {
  return (($is_Lsnabbdom_InitHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.InitHook"));
}
function $isArrayOf_Lsnabbdom_InitHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_InitHook)));
}
function $asArrayOf_Lsnabbdom_InitHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_InitHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.InitHook;", depth));
}
function $is_Lsnabbdom_InsertHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_InsertHook)));
}
function $as_Lsnabbdom_InsertHook(obj) {
  return (($is_Lsnabbdom_InsertHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.InsertHook"));
}
function $isArrayOf_Lsnabbdom_InsertHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_InsertHook)));
}
function $asArrayOf_Lsnabbdom_InsertHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_InsertHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.InsertHook;", depth));
}
function $is_Lsnabbdom_PatchedVNode(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PatchedVNode)));
}
function $as_Lsnabbdom_PatchedVNode(obj) {
  return (($is_Lsnabbdom_PatchedVNode(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PatchedVNode"));
}
function $isArrayOf_Lsnabbdom_PatchedVNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PatchedVNode)));
}
function $asArrayOf_Lsnabbdom_PatchedVNode(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PatchedVNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PatchedVNode;", depth));
}
var $d_Lsnabbdom_PatchedVNode = new $TypeData().initClass(1, "snabbdom.PatchedVNode", ({
  Lsnabbdom_PatchedVNode: 1
}));
function $is_Lsnabbdom_PostHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PostHook)));
}
function $as_Lsnabbdom_PostHook(obj) {
  return (($is_Lsnabbdom_PostHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PostHook"));
}
function $isArrayOf_Lsnabbdom_PostHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PostHook)));
}
function $asArrayOf_Lsnabbdom_PostHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PostHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PostHook;", depth));
}
function $is_Lsnabbdom_PostPatchHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PostPatchHook)));
}
function $as_Lsnabbdom_PostPatchHook(obj) {
  return (($is_Lsnabbdom_PostPatchHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PostPatchHook"));
}
function $isArrayOf_Lsnabbdom_PostPatchHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PostPatchHook)));
}
function $asArrayOf_Lsnabbdom_PostPatchHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PostPatchHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PostPatchHook;", depth));
}
function $is_Lsnabbdom_PreHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PreHook)));
}
function $as_Lsnabbdom_PreHook(obj) {
  return (($is_Lsnabbdom_PreHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PreHook"));
}
function $isArrayOf_Lsnabbdom_PreHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PreHook)));
}
function $asArrayOf_Lsnabbdom_PreHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PreHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PreHook;", depth));
}
function $is_Lsnabbdom_PrePatchHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PrePatchHook)));
}
function $as_Lsnabbdom_PrePatchHook(obj) {
  return (($is_Lsnabbdom_PrePatchHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PrePatchHook"));
}
function $isArrayOf_Lsnabbdom_PrePatchHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PrePatchHook)));
}
function $asArrayOf_Lsnabbdom_PrePatchHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PrePatchHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PrePatchHook;", depth));
}
function $is_Lsnabbdom_RemoveHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_RemoveHook)));
}
function $as_Lsnabbdom_RemoveHook(obj) {
  return (($is_Lsnabbdom_RemoveHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.RemoveHook"));
}
function $isArrayOf_Lsnabbdom_RemoveHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_RemoveHook)));
}
function $asArrayOf_Lsnabbdom_RemoveHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_RemoveHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.RemoveHook;", depth));
}
function $is_Lsnabbdom_UpdateHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_UpdateHook)));
}
function $as_Lsnabbdom_UpdateHook(obj) {
  return (($is_Lsnabbdom_UpdateHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.UpdateHook"));
}
function $isArrayOf_Lsnabbdom_UpdateHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_UpdateHook)));
}
function $asArrayOf_Lsnabbdom_UpdateHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_UpdateHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.UpdateHook;", depth));
}
function $is_Lsnabbdom_VNode(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_VNode)));
}
function $as_Lsnabbdom_VNode(obj) {
  return (($is_Lsnabbdom_VNode(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNode"));
}
function $isArrayOf_Lsnabbdom_VNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNode)));
}
function $asArrayOf_Lsnabbdom_VNode(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNode;", depth));
}
function $p_Lsnabbdom_h$__isSvg__T__Z($thiz, sel) {
  var this$1 = $n(sel);
  if ($uZ(this$1.startsWith("svg"))) {
    var this$2 = $n(sel);
    if ((this$2.length === 3)) {
      var $x_1 = true;
    } else {
      var this$5 = $n(sel);
      var $x_1 = ($charAt(this$5, 3) === 46);
    }
    if ($x_1) {
      return true;
    } else {
      var this$8 = $n(sel);
      return ($charAt(this$8, 3) === 35);
    }
  } else {
    return false;
  }
}
/** @constructor */
function $c_Lsnabbdom_h$() {
  this.Lsnabbdom_h$__f_svgNamespace = null;
  this.Lsnabbdom_h$__f_svgNamespace = "http://www.w3.org/2000/svg";
}
$c_Lsnabbdom_h$.prototype = new $h_O();
$c_Lsnabbdom_h$.prototype.constructor = $c_Lsnabbdom_h$;
/** @constructor */
function $h_Lsnabbdom_h$() {
}
$h_Lsnabbdom_h$.prototype = $c_Lsnabbdom_h$.prototype;
$c_Lsnabbdom_h$.prototype.apply__T__Lsnabbdom_VNodeData__sci_List__Lsnabbdom_VNode$Element = (function(sel, data, children) {
  var svg = $p_Lsnabbdom_h$__isSvg__T__Z(this, sel);
  if (svg) {
    var ns$6 = new $c_s_Some("http://www.w3.org/2000/svg");
    var this$2 = $n(data);
    var props$6 = this$2.Lsnabbdom_VNodeData__f_props;
    var this$3 = $n(data);
    var attrs$6 = this$3.Lsnabbdom_VNodeData__f_attrs;
    var this$4 = $n(data);
    var classes$6 = this$4.Lsnabbdom_VNodeData__f_classes;
    var this$5 = $n(data);
    var style$6 = this$5.Lsnabbdom_VNodeData__f_style;
    var this$6 = $n(data);
    var dataset$6 = this$6.Lsnabbdom_VNodeData__f_dataset;
    var this$7 = $n(data);
    var on$6 = this$7.Lsnabbdom_VNodeData__f_on;
    var this$8 = $n(data);
    var hook$6 = this$8.Lsnabbdom_VNodeData__f_hook;
    var this$9 = $n(data);
    var key$6 = this$9.Lsnabbdom_VNodeData__f_key;
    var this$10 = $n(data);
    var fn$6 = this$10.Lsnabbdom_VNodeData__f_fn;
    var this$11 = $n(data);
    var args$6 = this$11.Lsnabbdom_VNodeData__f_args;
    var this$12 = $n(data);
    var is$6 = this$12.Lsnabbdom_VNodeData__f_is;
    $n(data);
    var data$1 = new $c_Lsnabbdom_VNodeData(props$6, attrs$6, classes$6, style$6, dataset$6, on$6, hook$6, key$6, ns$6, fn$6, args$6, is$6);
  } else {
    var data$1 = data;
  }
  if (svg) {
    var this$15 = $n(children);
    var f = ((vnode) => {
      var vnode$1 = $as_Lsnabbdom_VNode(vnode);
      return this.addNS__Lsnabbdom_VNode__Lsnabbdom_VNode(vnode$1);
    });
    if ((this$15 === $m_sci_Nil$())) {
      var children$1 = $m_sci_Nil$();
    } else {
      var x0 = this$15.head__O();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$15.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var children$1 = h;
    }
  } else {
    var children$1 = children;
  }
  return new $c_Lsnabbdom_VNode$Element(sel, data$1, children$1);
});
$c_Lsnabbdom_h$.prototype.addNS__Lsnabbdom_PatchedVNode__Lsnabbdom_PatchedVNode = (function(vnode) {
  if ((vnode instanceof $c_Lsnabbdom_PatchedVNode$Comment)) {
    var x$1 = $as_Lsnabbdom_PatchedVNode$Comment(vnode);
    $n(x$1);
    $n(x$1);
    return vnode;
  }
  if ((vnode instanceof $c_Lsnabbdom_PatchedVNode$Text)) {
    var x$1$1 = $as_Lsnabbdom_PatchedVNode$Text(vnode);
    $n(x$1$1);
    $n(x$1$1);
    return vnode;
  }
  if ((vnode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var x$1$2 = $as_Lsnabbdom_PatchedVNode$Element(vnode);
    var this$8 = $n(x$1$2);
    var x4 = this$8.Lsnabbdom_PatchedVNode$Element__f_sel;
    var this$9 = $n(x$1$2);
    var x5 = this$9.Lsnabbdom_PatchedVNode$Element__f_data;
    var this$10 = $n(x$1$2);
    var x6 = this$10.Lsnabbdom_PatchedVNode$Element__f_children;
    var this$11 = $n(x$1$2);
    var x7 = this$11.Lsnabbdom_PatchedVNode$Element__f_node;
    var ns$8 = new $c_s_Some("http://www.w3.org/2000/svg");
    var this$13 = $n(x5);
    var props$8 = this$13.Lsnabbdom_VNodeData__f_props;
    var this$14 = $n(x5);
    var attrs$8 = this$14.Lsnabbdom_VNodeData__f_attrs;
    var this$15 = $n(x5);
    var classes$8 = this$15.Lsnabbdom_VNodeData__f_classes;
    var this$16 = $n(x5);
    var style$8 = this$16.Lsnabbdom_VNodeData__f_style;
    var this$17 = $n(x5);
    var dataset$8 = this$17.Lsnabbdom_VNodeData__f_dataset;
    var this$18 = $n(x5);
    var on$8 = this$18.Lsnabbdom_VNodeData__f_on;
    var this$19 = $n(x5);
    var hook$8 = this$19.Lsnabbdom_VNodeData__f_hook;
    var this$20 = $n(x5);
    var key$8 = this$20.Lsnabbdom_VNodeData__f_key;
    var this$21 = $n(x5);
    var fn$8 = this$21.Lsnabbdom_VNodeData__f_fn;
    var this$22 = $n(x5);
    var args$8 = this$22.Lsnabbdom_VNodeData__f_args;
    var this$23 = $n(x5);
    var is$8 = this$23.Lsnabbdom_VNodeData__f_is;
    $n(x5);
    var data = new $c_Lsnabbdom_VNodeData(props$8, attrs$8, classes$8, style$8, dataset$8, on$8, hook$8, key$8, ns$8, fn$8, args$8, is$8);
    if ((x4 !== "foreignObject")) {
      var this$26 = $n(x6);
      var f = ((vnode$2) => {
        var vnode$1 = $as_Lsnabbdom_PatchedVNode(vnode$2);
        return this.addNS__Lsnabbdom_PatchedVNode__Lsnabbdom_PatchedVNode(vnode$1);
      });
      if ((this$26 === $m_sci_Nil$())) {
        var children = $m_sci_Nil$();
      } else {
        var x0 = this$26.head__O();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$26.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        var children = h;
      }
    } else {
      var children = x6;
    }
    return new $c_Lsnabbdom_PatchedVNode$Element(x4, data, children, x7);
  }
  throw new $c_s_MatchError(vnode);
});
$c_Lsnabbdom_h$.prototype.addNS__Lsnabbdom_VNode__Lsnabbdom_VNode = (function(vnode) {
  if ((vnode instanceof $c_Lsnabbdom_VNode$Comment)) {
    var x$1 = $as_Lsnabbdom_VNode$Comment(vnode);
    $n(x$1);
    return vnode;
  }
  if ((vnode instanceof $c_Lsnabbdom_VNode$Text)) {
    var x$1$1 = $as_Lsnabbdom_VNode$Text(vnode);
    $n(x$1$1);
    return vnode;
  }
  if ((vnode instanceof $c_Lsnabbdom_VNode$Element)) {
    var x$1$2 = $as_Lsnabbdom_VNode$Element(vnode);
    var this$6 = $n(x$1$2);
    var x19 = this$6.Lsnabbdom_VNode$Element__f_sel;
    var this$7 = $n(x$1$2);
    var x20 = this$7.Lsnabbdom_VNode$Element__f_data;
    var this$8 = $n(x$1$2);
    var x21 = this$8.Lsnabbdom_VNode$Element__f_children;
    var ns$9 = new $c_s_Some("http://www.w3.org/2000/svg");
    var this$10 = $n(x20);
    var props$9 = this$10.Lsnabbdom_VNodeData__f_props;
    var this$11 = $n(x20);
    var attrs$9 = this$11.Lsnabbdom_VNodeData__f_attrs;
    var this$12 = $n(x20);
    var classes$9 = this$12.Lsnabbdom_VNodeData__f_classes;
    var this$13 = $n(x20);
    var style$9 = this$13.Lsnabbdom_VNodeData__f_style;
    var this$14 = $n(x20);
    var dataset$9 = this$14.Lsnabbdom_VNodeData__f_dataset;
    var this$15 = $n(x20);
    var on$9 = this$15.Lsnabbdom_VNodeData__f_on;
    var this$16 = $n(x20);
    var hook$9 = this$16.Lsnabbdom_VNodeData__f_hook;
    var this$17 = $n(x20);
    var key$9 = this$17.Lsnabbdom_VNodeData__f_key;
    var this$18 = $n(x20);
    var fn$9 = this$18.Lsnabbdom_VNodeData__f_fn;
    var this$19 = $n(x20);
    var args$9 = this$19.Lsnabbdom_VNodeData__f_args;
    var this$20 = $n(x20);
    var is$9 = this$20.Lsnabbdom_VNodeData__f_is;
    $n(x20);
    var data = new $c_Lsnabbdom_VNodeData(props$9, attrs$9, classes$9, style$9, dataset$9, on$9, hook$9, key$9, ns$9, fn$9, args$9, is$9);
    if ((x19 !== "foreignObject")) {
      var this$23 = $n(x21);
      var f = ((vnode$2) => {
        var vnode$1 = $as_Lsnabbdom_VNode(vnode$2);
        return this.addNS__Lsnabbdom_VNode__Lsnabbdom_VNode(vnode$1);
      });
      if ((this$23 === $m_sci_Nil$())) {
        var children = $m_sci_Nil$();
      } else {
        var x0 = this$23.head__O();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$23.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        var children = h;
      }
    } else {
      var children = x21;
    }
    return new $c_Lsnabbdom_VNode$Element(x19, data, children);
  }
  throw new $c_s_MatchError(vnode);
});
var $d_Lsnabbdom_h$ = new $TypeData().initClass($c_Lsnabbdom_h$, "snabbdom.h$", ({
  Lsnabbdom_h$: 1
}));
var $n_Lsnabbdom_h$;
function $m_Lsnabbdom_h$() {
  if ((!$n_Lsnabbdom_h$)) {
    $n_Lsnabbdom_h$ = new $c_Lsnabbdom_h$();
  }
  return $n_Lsnabbdom_h$;
}
function $p_Lsnabbdom_init$__sameVnode__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Z($thiz, vnode1, vnode2) {
  var _1 = $n(vnode1).toVNode__Lsnabbdom_VNode();
  if ((_1 instanceof $c_Lsnabbdom_VNode$Text)) {
    var x$1 = $as_Lsnabbdom_VNode$Text(_1);
    $n(x$1);
    if ((vnode2 instanceof $c_Lsnabbdom_VNode$Text)) {
      var x$1$1 = $as_Lsnabbdom_VNode$Text(vnode2);
      $n(x$1$1);
      return true;
    }
  }
  if ((_1 instanceof $c_Lsnabbdom_VNode$Element)) {
    var x$1$2 = $as_Lsnabbdom_VNode$Element(_1);
    var this$7 = $n(x$1$2);
    var x225 = this$7.Lsnabbdom_VNode$Element__f_sel;
    var this$8 = $n(x$1$2);
    var x226 = this$8.Lsnabbdom_VNode$Element__f_data;
    $n(x$1$2);
    if ((vnode2 instanceof $c_Lsnabbdom_VNode$Element)) {
      var x$1$3 = $as_Lsnabbdom_VNode$Element(vnode2);
      var this$11 = $n(x$1$3);
      var x220 = this$11.Lsnabbdom_VNode$Element__f_sel;
      var this$12 = $n(x$1$3);
      var x221 = this$12.Lsnabbdom_VNode$Element__f_data;
      $n(x$1$3);
      var x = $n(x226).Lsnabbdom_VNodeData__f_key;
      var x$2 = $n(x221).Lsnabbdom_VNodeData__f_key;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = $n(x226).Lsnabbdom_VNodeData__f_is;
        var x$4 = $n(x221).Lsnabbdom_VNodeData__f_is;
        var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return (x225 === x220);
      } else {
        return false;
      }
    }
  }
  return false;
}
function $p_Lsnabbdom_init$__createRmCb$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Node__I__F0($thiz, api$3, childElm, listeners) {
  var listeners0 = new $c_sr_IntRef(listeners);
  return new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var ev$2 = ((listeners0.sr_IntRef__f_elem - 1) | 0);
    listeners0.sr_IntRef__f_elem = ev$2;
    if ((listeners0.sr_IntRef__f_elem === 0)) {
      $n(api$3);
      var parent = $m_s_Option$().apply__O__s_Option(childElm.parentNode);
      var this$4 = $n(parent);
      if ((!this$4.isEmpty__Z())) {
        var x0 = this$4.get__O();
        $n(api$3);
        x0.removeChild(childElm);
      }
    }
  }));
}
function $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$5, cbs$1, vnode00, insertedVNodeQueue) {
  var vnode0 = $m_Lsnabbdom_VNode$().applyInitHook__Lsnabbdom_VNode__Lsnabbdom_VNode(vnode00);
  if ((vnode0 instanceof $c_Lsnabbdom_VNode$Comment)) {
    var x$1 = $as_Lsnabbdom_VNode$Comment(vnode0);
    var this$2 = $n(x$1);
    var x18 = this$2.Lsnabbdom_VNode$Comment__f_content;
    $n(api$5);
    var node = document.createComment(x18);
    return new $c_Lsnabbdom_PatchedVNode$Comment(x18, node);
  }
  if ((vnode0 instanceof $c_Lsnabbdom_VNode$Text)) {
    var x$1$1 = $as_Lsnabbdom_VNode$Text(vnode0);
    var this$7 = $n(x$1$1);
    var x15 = this$7.Lsnabbdom_VNode$Text__f_content;
    $n(api$5);
    var node$1 = document.createTextNode(x15);
    return new $c_Lsnabbdom_PatchedVNode$Text(x15, node$1);
  }
  if ((vnode0 instanceof $c_Lsnabbdom_VNode$Element)) {
    var x$1$2 = $as_Lsnabbdom_VNode$Element(vnode0);
    var this$11 = $n(x$1$2);
    var x10 = this$11.Lsnabbdom_VNode$Element__f_sel;
    var this$12 = $n(x$1$2);
    var x11 = this$12.Lsnabbdom_VNode$Element__f_data;
    var this$13 = $n(x$1$2);
    var x12 = this$13.Lsnabbdom_VNode$Element__f_children;
    var this$14 = $n(x10);
    var hashIdx = $uI(this$14.indexOf("#"));
    var this$15 = $n(x10);
    var dotIdx = $uI(this$15.indexOf(".", hashIdx));
    if ((hashIdx > 0)) {
      var hash = hashIdx;
    } else {
      var this$16 = $n(x10);
      var hash = this$16.length;
    }
    if ((dotIdx > 0)) {
      var dot = dotIdx;
    } else {
      var this$17 = $n(x10);
      var dot = this$17.length;
    }
    var tag = ((((~hashIdx) | (~dotIdx)) !== 0) ? $m_sc_StringOps$().slice$extension__T__I__I__T(x10, 0, ((hash < dot) ? hash : dot)) : x10);
    matchResult2: {
      var elm;
      var x4 = $n(x11).Lsnabbdom_VNodeData__f_ns;
      if ((x4 instanceof $c_s_Some)) {
        var ns = $as_T($n($as_s_Some(x4)).s_Some__f_value);
        $n(api$5);
        var elm = document.createElementNS(ns, tag);
        break matchResult2;
      }
      var x = $m_s_None$();
      if ((x === x4)) {
        $n(api$5);
        var elm = document.createElement(tag);
        break matchResult2;
      }
      throw new $c_s_MatchError(x4);
    }
    var this$24 = $n(x12);
    var f = ((_$11) => {
      var _$11$1 = $as_Lsnabbdom_VNode(_$11);
      return $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$5, cbs$1, _$11$1, insertedVNodeQueue);
    });
    if ((this$24 === $m_sci_Nil$())) {
      var children = $m_sci_Nil$();
    } else {
      var x0 = this$24.head__O();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$24.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var children = h;
    }
    var pvnode0 = new $c_Lsnabbdom_PatchedVNode$Element(x10, x11, children, elm);
    if ((hash < dot)) {
      elm.setAttribute("id", $m_sc_StringOps$().slice$extension__T__I__I__T(x10, ((1 + hash) | 0), dot));
    }
    if ((dotIdx > 0)) {
      var $x_1 = $m_sc_StringOps$();
      var this$28 = $n(x10);
      elm.setAttribute("class", $f_T__replaceAll__T__T__T($n($x_1.slice$extension__T__I__I__T(x10, ((1 + dot) | 0), this$28.length)), "\\.", " "));
    }
    var this$29 = $n($n(cbs$1).Lsnabbdom_ModuleHooks__f_create);
    var these = this$29;
    while ((!$n(these).isEmpty__Z())) {
      var x0$2 = $n(these).head__O();
      var hook = $as_Lsnabbdom_CreateHook(x0$2);
      $n(hook).apply__Lsnabbdom_PatchedVNode__V(pvnode0);
      these = $as_sci_List($n(these).tail__O());
    }
    var this$30 = $n(pvnode0.Lsnabbdom_PatchedVNode$Element__f_children);
    var these$1 = this$30;
    while ((!$n(these$1).isEmpty__Z())) {
      var x0$3 = $n(these$1).head__O();
      var child = $as_Lsnabbdom_PatchedVNode(x0$3);
      $n(api$5);
      var child$1 = $n(child).node__Lorg_scalajs_dom_Node();
      elm.appendChild(child$1);
      these$1 = $as_sci_List($n(these$1).tail__O());
    }
    var this$32 = $n($n(x11).Lsnabbdom_VNodeData__f_hook);
    if (this$32.isEmpty__Z()) {
      var $x_2 = $m_s_None$();
    } else {
      var x0$4 = this$32.get__O();
      var _$12 = $as_Lsnabbdom_Hooks(x0$4);
      var $x_2 = $n(_$12).create__s_Option();
    }
    var this$33 = $n($x_2);
    if ((!this$33.isEmpty__Z())) {
      var x0$5 = this$33.get__O();
      var hook$1 = $as_Lsnabbdom_CreateHook(x0$5);
      $n(hook$1).apply__Lsnabbdom_PatchedVNode__V(pvnode0);
    }
    var this$34 = $n($n(x11).Lsnabbdom_VNodeData__f_hook);
    if (this$34.isEmpty__Z()) {
      var $x_3 = $m_s_None$();
    } else {
      var x0$6 = this$34.get__O();
      var _$13 = $as_Lsnabbdom_Hooks(x0$6);
      var $x_3 = $n(_$13).insert__s_Option();
    }
    var this$35 = $n($x_3);
    if ((!this$35.isEmpty__Z())) {
      var x0$7 = this$35.get__O();
      $as_Lsnabbdom_InsertHook(x0$7);
      var this$36 = $n(insertedVNodeQueue);
      this$36.addOne__O__scm_ArrayBuffer(pvnode0);
    }
    return pvnode0;
  }
  throw new $c_s_MatchError(vnode0);
}
function $p_Lsnabbdom_init$__invokeDestroyHook$1__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__V($thiz, cbs$3, vnode) {
  if ((vnode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var x$1 = $as_Lsnabbdom_PatchedVNode$Element(vnode);
    $n(x$1);
    var this$3 = $n(x$1);
    var x23 = this$3.Lsnabbdom_PatchedVNode$Element__f_data;
    var this$4 = $n(x$1);
    var x24 = this$4.Lsnabbdom_PatchedVNode$Element__f_children;
    $n(x$1);
    var this$6 = $n($n(x23).Lsnabbdom_VNodeData__f_hook);
    if (this$6.isEmpty__Z()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = this$6.get__O();
      var _$15 = $as_Lsnabbdom_Hooks(x0);
      var $x_1 = $n(_$15).destroy__s_Option();
    }
    var this$7 = $n($x_1);
    if ((!this$7.isEmpty__Z())) {
      var x0$1 = this$7.get__O();
      var _$16 = $as_Lsnabbdom_DestroyHook(x0$1);
      $n(_$16);
      $m_Lsnabbdom_modules_EventListeners$();
      if ((vnode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
        var elm = $as_Lsnabbdom_PatchedVNode$Element(vnode);
        $n($n($n(elm).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_on).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$1) => {
          var x$1$2 = $as_T2(x$1$1);
          matchResult4$1: {
            if ((x$1$2 !== null)) {
              var name = $as_T($n(x$1$2)._1__O());
              $n(elm).Lsnabbdom_PatchedVNode$Element__f_node.removeEventListener(name, $n(elm).listener__sjs_js_Function1(), false);
              break matchResult4$1;
            }
            throw new $c_s_MatchError(x$1$2);
          }
        })));
      }
    }
    var this$10 = $n($n(cbs$3).Lsnabbdom_ModuleHooks__f_destroy);
    var these = this$10;
    while ((!$n(these).isEmpty__Z())) {
      var x0$2 = $n(these).head__O();
      var _$17 = $as_Lsnabbdom_DestroyHook(x0$2);
      $n(_$17);
      $m_Lsnabbdom_modules_EventListeners$();
      if ((vnode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
        var elm$1 = $as_Lsnabbdom_PatchedVNode$Element(vnode);
        $n($n($n(elm$1).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_on).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((elm$1) => ((x$1$3) => {
          var x$1$4 = $as_T2(x$1$3);
          matchResult4$2: {
            if ((x$1$4 !== null)) {
              var name$1 = $as_T($n(x$1$4)._1__O());
              $n(elm$1).Lsnabbdom_PatchedVNode$Element__f_node.removeEventListener(name$1, $n(elm$1).listener__sjs_js_Function1(), false);
              break matchResult4$2;
            }
            throw new $c_s_MatchError(x$1$4);
          }
        }))(elm$1)));
      }
      these = $as_sci_List($n(these).tail__O());
    }
    var this$13 = $n(x24);
    var these$1 = this$13;
    while ((!$n(these$1).isEmpty__Z())) {
      var x0$3 = $n(these$1).head__O();
      var vnode$1 = $as_Lsnabbdom_PatchedVNode(x0$3);
      $p_Lsnabbdom_init$__invokeDestroyHook$1__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__V($thiz, cbs$3, vnode$1);
      these$1 = $as_sci_List($n(these$1).tail__O());
    }
  }
}
function $p_Lsnabbdom_init$__removeAllVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__sci_List__V($thiz, api$8, cbs$4, parentElm, vnodes) {
  var this$1 = $n(vnodes);
  var these = this$1;
  while ((!$n(these).isEmpty__Z())) {
    var x0 = $n(these).head__O();
    var x$1 = $as_Lsnabbdom_PatchedVNode(x0);
    if ((x$1 instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
      var x31 = $as_Lsnabbdom_PatchedVNode$Element(x$1);
      $n(x31);
      var this$4 = $n(x31);
      var x34 = this$4.Lsnabbdom_PatchedVNode$Element__f_data;
      $n(x31);
      var this$6 = $n(x31);
      var x36 = this$6.Lsnabbdom_PatchedVNode$Element__f_node;
      $p_Lsnabbdom_init$__invokeDestroyHook$1__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__V($thiz, cbs$4, x31);
      var listeners = ((1 + $n($n(cbs$4).Lsnabbdom_ModuleHooks__f_remove).length__I()) | 0);
      var rm = $p_Lsnabbdom_init$__createRmCb$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Node__I__F0($thiz, api$8, x36, listeners);
      var this$7 = $n($n(cbs$4).Lsnabbdom_ModuleHooks__f_remove);
      var these$1 = this$7;
      while ((!$n(these$1).isEmpty__Z())) {
        var x0$1 = $n(these$1).head__O();
        var _$18 = $as_Lsnabbdom_RemoveHook(x0$1);
        $n(_$18).apply__Lsnabbdom_PatchedVNode__F0__V(x31, rm);
        these$1 = $as_sci_List($n(these$1).tail__O());
      }
      var this$8 = $n($n(x34).Lsnabbdom_VNodeData__f_hook);
      if (this$8.isEmpty__Z()) {
        var $x_1 = $m_s_None$();
      } else {
        var x0$2 = this$8.get__O();
        var _$19 = $as_Lsnabbdom_Hooks(x0$2);
        var $x_1 = $n(_$19).remove__s_Option();
      }
      var this$9 = $n($x_1);
      if (this$9.isEmpty__Z()) {
        $n(rm).apply__O();
      } else {
        var x0$3 = this$9.get__O();
        var hook = $as_Lsnabbdom_RemoveHook(x0$3);
        $n(hook).apply__Lsnabbdom_PatchedVNode__F0__V(x31, rm);
      }
    } else if ((x$1 instanceof $c_Lsnabbdom_PatchedVNode$Text)) {
      var x$1$1 = $as_Lsnabbdom_PatchedVNode$Text(x$1);
      $n(x$1$1);
      var this$12 = $n(x$1$1);
      var x30 = this$12.Lsnabbdom_PatchedVNode$Text__f_node;
      $n(api$8);
      parentElm.removeChild(x30);
    }
    these = $as_sci_List($n(these).tail__O());
  }
}
function $p_Lsnabbdom_init$__merge$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Node__sci_List__sci_List__sci_List__sci_List($thiz, api$13, parentElm$3, v1, v2, acc) {
  var v1$tailLocal1 = v1;
  var acc$tailLocal1 = acc;
  var v2$tailLocal1 = v2;
  while (true) {
    var _1 = v1$tailLocal1;
    var _2 = v2$tailLocal1;
    var x104 = new $c_T2(_1, _2);
    var x121 = $as_sci_List(x104.T2__f__1);
    var x122 = $as_sci_List(x104.T2__f__2);
    if ((x121 instanceof $c_sci_$colon$colon)) {
      var x128 = $as_sci_$colon$colon(x121);
      var x129 = $as_T2($n(x128).sci_$colon$colon__f_head);
      var x130 = $n(x128).sci_$colon$colon__f_next;
      if ((x129 !== null)) {
        var h1 = $as_Lsnabbdom_PatchedVNode($n(x129)._1__O());
        var i = $uI($n(x129)._2__O());
        if ((x122 instanceof $c_sci_$colon$colon)) {
          var x123 = $as_sci_$colon$colon(x122);
          var x124 = $as_T2($n(x123).sci_$colon$colon__f_head);
          var x125 = $n(x123).sci_$colon$colon__f_next;
          if ((x124 !== null)) {
            var h2 = $as_Lsnabbdom_PatchedVNode($n(x124)._1__O());
            var j = $uI($n(x124)._2__O());
            if ((j < i)) {
              $n(api$13);
              var newNode = $n(h2).node__Lorg_scalajs_dom_Node();
              var value = $n(h1).node__Lorg_scalajs_dom_Node();
              var referenceNode = new $c_s_Some(value);
              parentElm$3.insertBefore(newNode, (referenceNode.isEmpty__Z() ? null : referenceNode.s_Some__f_value));
              var this$4 = $n(acc$tailLocal1);
              var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon(h2, this$4);
              v2$tailLocal1 = x125;
              acc$tailLocal1 = acc$tailLocal1$tmp1;
              continue;
            } else {
              if ((j <= i)) {
                $m_sr_Scala3RunTime$().assertFailed__E();
              }
              var this$5 = $n(acc$tailLocal1);
              var acc$tailLocal1$tmp2 = new $c_sci_$colon$colon(h1, this$5);
              v1$tailLocal1 = x130;
              acc$tailLocal1 = acc$tailLocal1$tmp2;
              continue;
            }
          }
        }
      }
    }
    var x = $m_sci_Nil$();
    if ((x.equals__O__Z(x121) && (x122 instanceof $c_sci_$colon$colon))) {
      var x116 = $as_sci_$colon$colon(x122);
      var x117 = $as_T2($n(x116).sci_$colon$colon__f_head);
      var x118 = $n(x116).sci_$colon$colon__f_next;
      if ((x117 !== null)) {
        var h2$2 = $as_Lsnabbdom_PatchedVNode($n(x117)._1__O());
        $n(api$13);
        var newNode$1 = $n(h2$2).node__Lorg_scalajs_dom_Node();
        var referenceNode$1 = $m_s_None$();
        parentElm$3.insertBefore(newNode$1, (referenceNode$1.isEmpty__Z() ? null : referenceNode$1.get__E()));
        var v1$tailLocal1$tmp2 = $m_sci_Nil$();
        var this$7 = $n(acc$tailLocal1);
        var acc$tailLocal1$tmp3 = new $c_sci_$colon$colon(h2$2, this$7);
        v1$tailLocal1 = v1$tailLocal1$tmp2;
        v2$tailLocal1 = x118;
        acc$tailLocal1 = acc$tailLocal1$tmp3;
        continue;
      }
    }
    if ((x121 instanceof $c_sci_$colon$colon)) {
      var x109 = $as_sci_$colon$colon(x121);
      var x110 = $as_T2($n(x109).sci_$colon$colon__f_head);
      var x111 = $n(x109).sci_$colon$colon__f_next;
      if ((x110 !== null)) {
        var h1$2 = $as_Lsnabbdom_PatchedVNode($n(x110)._1__O());
        var x$3 = $m_sci_Nil$();
        if (x$3.equals__O__Z(x122)) {
          var v2$tailLocal1$tmp3 = $m_sci_Nil$();
          var this$8 = $n(acc$tailLocal1);
          var acc$tailLocal1$tmp4 = new $c_sci_$colon$colon(h1$2, this$8);
          v1$tailLocal1 = x111;
          v2$tailLocal1 = v2$tailLocal1$tmp3;
          acc$tailLocal1 = acc$tailLocal1$tmp4;
          continue;
        }
      }
    }
    var x$5 = $m_sci_Nil$();
    if (x$5.equals__O__Z(x121)) {
      var x$7 = $m_sci_Nil$();
      var $x_1 = x$7.equals__O__Z(x122);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return acc$tailLocal1;
    }
    throw new $c_s_MatchError(x104);
  }
}
function $p_Lsnabbdom_init$__updateChildren$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__sci_List__sci_List__scm_ArrayBuffer__sci_List($thiz, api$11, cbs$7, parentElm, oldCh, newCh, insertedVnodeQueue) {
  matchResult7: {
    var \u03b41$___1;
    var \u03b41$___2;
    var \u03b41$___3;
    var \u03b41$___4;
    var this$1 = $n(newCh);
    var $x_1 = $as_sc_LinearSeqOps($f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this$1));
    var _2 = $n(oldCh).reverse__sci_List();
    var _3 = $m_sci_Nil$();
    var _4 = $m_sci_Nil$();
    var x68 = $as_T4($n($x_1).foldLeft__O__F2__O(new $c_T4(oldCh, _2, _3, _4), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
      var x$1$1 = $as_T4(x$1);
      var x$2$1 = $as_T2(x$2);
      var x37 = new $c_T2(x$1$1, x$2$1);
      var x54 = $as_T4(x37.T2__f__1);
      var x55 = $as_T2(x37.T2__f__2);
      if ((x54 !== null)) {
        var x58 = $as_sci_List($n(x54).T4__f__1);
        var x59 = $as_sci_List($n(x54).T4__f__2);
        var x60 = $as_sci_List($n(x54).T4__f__3);
        var x61 = $as_sci_List($n(x54).T4__f__4);
        if ((x58 instanceof $c_sci_$colon$colon)) {
          var x65 = $as_sci_$colon$colon(x58);
          var x67 = $n(x65).sci_$colon$colon__f_next;
          var oh = $as_Lsnabbdom_PatchedVNode($n(x65).sci_$colon$colon__f_head);
          if ((x59 instanceof $c_sci_$colon$colon)) {
            var x62 = $as_sci_$colon$colon(x59);
            var x64 = $n(x62).sci_$colon$colon__f_next;
            var oh2 = $as_Lsnabbdom_PatchedVNode($n(x62).sci_$colon$colon__f_head);
            if ((x55 !== null)) {
              var newCh$1 = $as_Lsnabbdom_VNode($n(x55)._1__O());
              var i = $uI($n(x55)._2__O());
              if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Z($thiz, oh, newCh$1)) {
                var pn = $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$11, cbs$7, oh, newCh$1, insertedVnodeQueue);
                if (((oh === null) ? (oh2 === null) : $n(oh).equals__O__Z(oh2))) {
                  var _1 = $m_sci_Nil$();
                  var _2$1 = $m_sci_Nil$();
                  var elem$1 = new $c_T2(pn, i);
                  var this$8 = $n(x60);
                  var _3$1 = new $c_sci_$colon$colon(elem$1, this$8);
                  return new $c_T4(_1, _2$1, _3$1, x61);
                } else {
                  var this$10 = $n(x64);
                  var _2$2 = new $c_sci_$colon$colon(oh2, this$10);
                  var elem$2 = new $c_T2(pn, i);
                  var this$12 = $n(x60);
                  var _3$2 = new $c_sci_$colon$colon(elem$2, this$12);
                  return new $c_T4(x67, _2$2, _3$2, x61);
                }
              } else if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Z($thiz, oh2, newCh$1)) {
                var pn$2 = $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$11, cbs$7, oh2, newCh$1, insertedVnodeQueue);
                $n(api$11);
                var newNode = $n(pn$2).node__Lorg_scalajs_dom_Node();
                var value = $n(oh).node__Lorg_scalajs_dom_Node();
                var referenceNode = new $c_s_Some(value);
                parentElm.insertBefore(newNode, (referenceNode.isEmpty__Z() ? null : referenceNode.s_Some__f_value));
                if (((oh === null) ? (oh2 === null) : $n(oh).equals__O__Z(oh2))) {
                  var _1$1 = $m_sci_Nil$();
                  var _2$3 = $m_sci_Nil$();
                  var elem$3 = new $c_T2(pn$2, i);
                  var this$17 = $n(x60);
                  var _3$3 = new $c_sci_$colon$colon(elem$3, this$17);
                  return new $c_T4(_1$1, _2$3, _3$3, x61);
                } else {
                  var this$19 = $n(x67);
                  var _1$2 = new $c_sci_$colon$colon(oh, this$19);
                  var elem$4 = new $c_T2(pn$2, i);
                  var this$21 = $n(x60);
                  var _3$4 = new $c_sci_$colon$colon(elem$4, this$21);
                  return new $c_T4(_1$2, x64, _3$4, x61);
                }
              } else {
                var this$25 = $n(($m_Lsnabbdom_VNode$(), $m_Lsnabbdom_VNode$().snabbdom$VNode$$$key__Lsnabbdom_VNode__s_Option(newCh$1)));
                if ((!this$25.isEmpty__Z())) {
                  var this$26 = $n(x67);
                  var _1$3 = new $c_sci_$colon$colon(oh, this$26);
                  var this$27 = $n(x64);
                  var _2$4 = new $c_sci_$colon$colon(oh2, this$27);
                  var elem$5 = new $c_T2(newCh$1, i);
                  var this$29 = $n(x61);
                  var _4$1 = new $c_sci_$colon$colon(elem$5, this$29);
                  return new $c_T4(_1$3, _2$4, x60, _4$1);
                } else {
                  var pn$3 = $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$11, cbs$7, newCh$1, insertedVnodeQueue);
                  $n(api$11);
                  var newNode$1 = $n(pn$3).node__Lorg_scalajs_dom_Node();
                  var value$1 = $n(oh).node__Lorg_scalajs_dom_Node();
                  var referenceNode$1 = new $c_s_Some(value$1);
                  parentElm.insertBefore(newNode$1, (referenceNode$1.isEmpty__Z() ? null : referenceNode$1.s_Some__f_value));
                  var this$33 = $n(x67);
                  var _1$4 = new $c_sci_$colon$colon(oh, this$33);
                  var this$34 = $n(x64);
                  var _2$5 = new $c_sci_$colon$colon(oh2, this$34);
                  var elem$6 = new $c_T2(pn$3, i);
                  var this$36 = $n(x60);
                  var _3$5 = new $c_sci_$colon$colon(elem$6, this$36);
                  return new $c_T4(_1$4, _2$5, _3$5, x61);
                }
              }
            }
          }
        }
        var x$6 = $m_sci_Nil$();
        if (x$6.equals__O__Z(x58)) {
          if ((x55 !== null)) {
            var newCh$2 = $as_Lsnabbdom_VNode($n(x55)._1__O());
            var i$2 = $uI($n(x55)._2__O());
            var pn$4 = $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$11, cbs$7, newCh$2, insertedVnodeQueue);
            $n(api$11);
            var newNode$2 = $n(pn$4).node__Lorg_scalajs_dom_Node();
            var referenceNode$2 = $m_s_None$();
            parentElm.insertBefore(newNode$2, (referenceNode$2.isEmpty__Z() ? null : referenceNode$2.get__E()));
            var _1$5 = $m_sci_Nil$();
            var _2$6 = $m_sci_Nil$();
            var elem$7 = new $c_T2(pn$4, i$2);
            var this$40 = $n(x60);
            var _3$6 = new $c_sci_$colon$colon(elem$7, this$40);
            return new $c_T4(_1$5, _2$6, _3$6, x61);
          }
        }
        var x$8 = $m_sci_Nil$();
        if (x$8.equals__O__Z(x59)) {
          if ((x55 !== null)) {
            var newCh$3 = $as_Lsnabbdom_VNode($n(x55)._1__O());
            var i$3 = $uI($n(x55)._2__O());
            var pn$5 = $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$11, cbs$7, newCh$3, insertedVnodeQueue);
            $n(api$11);
            var newNode$3 = $n(pn$5).node__Lorg_scalajs_dom_Node();
            var referenceNode$3 = $m_s_None$();
            parentElm.insertBefore(newNode$3, (referenceNode$3.isEmpty__Z() ? null : referenceNode$3.get__E()));
            var _1$6 = $m_sci_Nil$();
            var _2$7 = $m_sci_Nil$();
            var elem$8 = new $c_T2(pn$5, i$3);
            var this$44 = $n(x60);
            var _3$7 = new $c_sci_$colon$colon(elem$8, this$44);
            return new $c_T4(_1$6, _2$7, _3$7, x61);
          }
        }
      }
      throw new $c_s_MatchError(x37);
    }))));
    if ((x68 !== null)) {
      var toDelete1 = $as_sci_List($n(x68).T4__f__1);
      var toDelete2 = $as_sci_List($n(x68).T4__f__2);
      var patchedChildrenWithIndex = $as_sci_List($n(x68).T4__f__3);
      var newKeyed = $as_sci_List($n(x68).T4__f__4);
      var \u03b41$___1 = toDelete1;
      var \u03b41$___2 = toDelete2;
      var \u03b41$___3 = patchedChildrenWithIndex;
      var \u03b41$___4 = newKeyed;
      break matchResult7;
    }
    throw new $c_s_MatchError(x68);
  }
  var toDelete1$2 = $as_sci_List(\u03b41$___1);
  var toDelete2$2 = $as_sci_List(\u03b41$___2);
  var patchedChildrenWithIndex$2 = $as_sci_List(\u03b41$___3);
  var newKeyed$2 = $as_sci_List(\u03b41$___4);
  matchResult9: {
    var toDelete$2;
    var this$49 = $n($n(toDelete1$2).reverse__sci_List());
    var _2$8 = $m_sci_Nil$();
    var z = new $c_T2(toDelete2$2, _2$8);
    var acc = z;
    var these = this$49;
    while ((!$n(these).isEmpty__Z())) {
      var x0 = acc;
      var x1 = $n(these).head__O();
      var x$1$2 = $as_T2(x0);
      var x$2$2 = $as_Lsnabbdom_PatchedVNode(x1);
      matchResult8$1: {
        var x73 = new $c_T2(x$1$2, x$2$2);
        var x78 = $as_T2(x73.T2__f__1);
        if ((x78 !== null)) {
          var x80 = $as_sci_List($n(x78)._1__O());
          var x81 = $as_sci_List($n(x78)._2__O());
          if ((x80 instanceof $c_sci_$colon$colon)) {
            var x82 = $as_sci_$colon$colon(x80);
            var x84 = $n(x82).sci_$colon$colon__f_next;
            var h = $as_Lsnabbdom_PatchedVNode($n(x82).sci_$colon$colon__f_head);
            var vnode = $as_Lsnabbdom_PatchedVNode(x73.T2__f__2);
            if (((vnode === null) ? (h === null) : $n(vnode).equals__O__Z(h))) {
              var this$51 = $n(x81);
              var _2$9 = new $c_sci_$colon$colon(h, this$51);
              acc = new $c_T2(x84, _2$9);
              break matchResult8$1;
            } else {
              var this$53 = $n(x84);
              var _1$7 = new $c_sci_$colon$colon(h, this$53);
              acc = new $c_T2(_1$7, x81);
              break matchResult8$1;
            }
          }
          var x$4 = $m_sci_Nil$();
          if (x$4.equals__O__Z(x80)) {
            var _1$8 = $m_sci_Nil$();
            acc = new $c_T2(_1$8, x81);
            break matchResult8$1;
          }
        }
        throw new $c_s_MatchError(x73);
      }
      these = $as_sc_LinearSeq($n(these).tail__O());
    }
    var x85 = $as_T2(acc);
    if ((x85 !== null)) {
      var toDelete = $as_sci_List($n(x85)._2__O());
      var toDelete$2 = toDelete;
      break matchResult9;
    }
    throw new $c_s_MatchError(x85);
  }
  matchResult10: {
    var \u03b42$___1;
    var \u03b42$___2;
    var this$56 = $n(toDelete$2);
    if (this$56.isEmpty__Z()) {
      var x88 = $m_sci_List$().sci_List$__f_scala$collection$immutable$List$$TupleOfNil;
    } else {
      var l = new $c_scm_ListBuffer();
      var r = new $c_scm_ListBuffer();
      var this$59 = $n(this$56.iterator__sc_Iterator());
      while (this$59.hasNext__Z()) {
        var x0$1 = this$59.next__O();
        var vnode$1 = $as_Lsnabbdom_PatchedVNode(x0$1);
        var this$60 = $n($m_Lsnabbdom_PatchedVNode$().key__Lsnabbdom_PatchedVNode__s_Option(vnode$1));
        if ((!this$60.isEmpty__Z())) {
          var this$61 = l;
        } else {
          var this$61 = r;
        }
        this$61.addOne__O__scm_ListBuffer(x0$1);
      }
      var x1$1 = new $c_T2(l.toList__sci_List(), r.toList__sci_List());
      matchEnd7$1: {
        var x88;
        var p2 = $as_sci_List(x1$1.T2__f__1);
        var x = $m_sci_Nil$();
        if (x.equals__O__Z(p2)) {
          var x88 = new $c_T2($m_sci_Nil$(), this$56);
          break matchEnd7$1;
        }
        var p4 = $as_sci_List(x1$1.T2__f__2);
        var x$3 = $m_sci_Nil$();
        if (x$3.equals__O__Z(p4)) {
          var x88 = new $c_T2(this$56, $m_sci_Nil$());
          break matchEnd7$1;
        }
        var x88 = x1$1;
      }
    }
    if ((x88 !== null)) {
      var toDeleteKeyed = $as_sci_List($n(x88)._1__O());
      var toDeleteUnkeyed = $as_sci_List($n(x88)._2__O());
      var \u03b42$___1 = toDeleteKeyed;
      var \u03b42$___2 = toDeleteUnkeyed;
      break matchResult10;
    }
    throw new $c_s_MatchError(x88);
  }
  var toDeleteKeyed$2 = $as_sci_List(\u03b42$___1);
  var toDeleteUnkeyed$2 = $as_sci_List(\u03b42$___2);
  var this$65 = $n(toDeleteKeyed$2);
  var f = ((n) => {
    var n$1 = $as_Lsnabbdom_PatchedVNode(n);
    var self = $n($m_Lsnabbdom_PatchedVNode$().key__Lsnabbdom_PatchedVNode__s_Option(n$1)).get__O();
    var ev$1 = $as_T(self);
    return new $c_T2(ev$1, n$1);
  });
  if ((this$65 === $m_sci_Nil$())) {
    var this$67 = $m_sci_Nil$();
  } else {
    var x0$2 = this$65.head__O();
    var h$1 = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
    var t = h$1;
    var rest = $as_sci_List(this$65.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var x0$3 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var this$67 = h$1;
  }
  var oldKeyed = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$67);
  matchResult13: {
    var \u03b43$___1;
    var \u03b43$___2;
    var this$70 = $n(newKeyed$2);
    var _1$9 = $m_sci_Nil$();
    var z$1 = new $c_T2(_1$9, oldKeyed);
    var acc$1 = z$1;
    var these$1 = this$70;
    while ((!$n(these$1).isEmpty__Z())) {
      var x0$4 = acc$1;
      var x1$2 = $n(these$1).head__O();
      var x$1$3 = $as_T2(x0$4);
      var x$2$3 = $as_T2(x1$2);
      matchResult12$1: {
        var x94 = new $c_T2(x$1$3, x$2$3);
        var x95 = $as_T2(x94.T2__f__1);
        var x96 = $as_T2(x94.T2__f__2);
        if ((x95 !== null)) {
          var acc1 = $as_sci_List($n(x95)._1__O());
          var acc2 = $as_sci_Map($n(x95)._2__O());
          if ((x96 !== null)) {
            var vnode$2 = $as_Lsnabbdom_VNode($n(x96)._1__O());
            var i$1 = $uI($n(x96)._2__O());
            var x91 = $n(acc2).get__O__s_Option($n(($m_Lsnabbdom_VNode$(), $m_Lsnabbdom_VNode$().snabbdom$VNode$$$key__Lsnabbdom_VNode__s_Option(vnode$2))).get__O());
            if ((x91 instanceof $c_s_Some)) {
              var pvnode = $as_Lsnabbdom_PatchedVNode($n($as_s_Some(x91)).s_Some__f_value);
              if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Z($thiz, pvnode, vnode$2)) {
                var _1$10 = $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$11, cbs$7, pvnode, vnode$2, insertedVnodeQueue);
                var elem$9 = new $c_T2(_1$10, i$1);
                var this$75 = $n(acc1);
                var _1$11 = new $c_sci_$colon$colon(elem$9, this$75);
                var this$78 = $n(acc2);
                var key = $n(($m_Lsnabbdom_VNode$(), $m_Lsnabbdom_VNode$().snabbdom$VNode$$$key__Lsnabbdom_VNode__s_Option(vnode$2))).get__O();
                var _2$10 = this$78.removed__O__sci_MapOps(key);
                acc$1 = new $c_T2(_1$11, _2$10);
                break matchResult12$1;
              }
            }
            var _1$12 = $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$11, cbs$7, vnode$2, insertedVnodeQueue);
            var elem$10 = new $c_T2(_1$12, i$1);
            var this$81 = $n(acc1);
            var _1$13 = new $c_sci_$colon$colon(elem$10, this$81);
            acc$1 = new $c_T2(_1$13, acc2);
            break matchResult12$1;
          }
        }
        throw new $c_s_MatchError(x94);
      }
      these$1 = $as_sc_LinearSeq($n(these$1).tail__O());
    }
    var x101 = $as_T2(acc$1);
    if ((x101 !== null)) {
      var patchedKeyedChildrenWithIndex = $as_sci_List($n(x101)._1__O());
      var toDeleteKeyed0 = $as_sci_Map($n(x101)._2__O());
      var \u03b43$___1 = patchedKeyedChildrenWithIndex;
      var \u03b43$___2 = toDeleteKeyed0;
      break matchResult13;
    }
    throw new $c_s_MatchError(x101);
  }
  var patchedKeyedChildrenWithIndex$2 = $as_sci_List(\u03b43$___1);
  var toDeleteKeyed0$2 = $as_sci_Map(\u03b43$___2);
  $p_Lsnabbdom_init$__removeAllVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__sci_List__V($thiz, api$11, cbs$7, parentElm, toDeleteUnkeyed$2);
  var this$84 = $n(toDeleteKeyed0$2);
  var this$85 = new $c_sc_MapOps$$anon$1(this$84);
  $p_Lsnabbdom_init$__removeAllVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__sci_List__V($thiz, api$11, cbs$7, parentElm, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$85));
  return $n($p_Lsnabbdom_init$__merge$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Node__sci_List__sci_List__sci_List__sci_List($thiz, api$11, parentElm, $n(patchedChildrenWithIndex$2).reverse__sci_List(), patchedKeyedChildrenWithIndex$2, $m_sci_Nil$())).reverse__sci_List();
}
function $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$14, cbs$9, oldVnode, vnode00, insertedVNodeQueue) {
  if ((vnode00 instanceof $c_Lsnabbdom_VNode$Element)) {
    var x$1 = $as_Lsnabbdom_VNode$Element(vnode00);
    $n(x$1);
    var this$3 = $n(x$1);
    var x137 = this$3.Lsnabbdom_VNode$Element__f_data;
    $n(x$1);
    var this$5 = $n($n(x137).Lsnabbdom_VNodeData__f_hook);
    if (this$5.isEmpty__Z()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = this$5.get__O();
      var _$20 = $as_Lsnabbdom_Hooks(x0);
      var $x_1 = $n(_$20).prepatch__s_Option();
    }
    var this$6 = $n($x_1);
    if (this$6.isEmpty__Z()) {
      var vnode = vnode00;
    } else {
      var x0$1 = this$6.get__O();
      var hook = $as_Lsnabbdom_PrePatchHook(x0$1);
      var vnode = $n(hook).apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Lsnabbdom_VNode(oldVnode, vnode00);
    }
  } else {
    var vnode = vnode00;
  }
  var x$2 = $n(oldVnode).toVNode__Lsnabbdom_VNode();
  if (((vnode === null) ? (x$2 === null) : $n(vnode).equals__O__Z(x$2))) {
    return oldVnode;
  } else {
    var this$7 = $n($n(cbs$9).Lsnabbdom_ModuleHooks__f_update);
    var these = this$7;
    while ((!$n(these).isEmpty__Z())) {
      var x0$2 = $n(these).head__O();
      var hook$1 = $as_Lsnabbdom_UpdateHook(x0$2);
      $n(hook$1).apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__V(oldVnode, vnode);
      these = $as_sci_List($n(these).tail__O());
    }
    if ((vnode instanceof $c_Lsnabbdom_VNode$Element)) {
      var x$1$1 = $as_Lsnabbdom_VNode$Element(vnode);
      $n(x$1$1);
      var this$10 = $n(x$1$1);
      var x143 = this$10.Lsnabbdom_VNode$Element__f_data;
      $n(x$1$1);
      var this$12 = $n($n(x143).Lsnabbdom_VNodeData__f_hook);
      if (this$12.isEmpty__Z()) {
        var $x_2 = $m_s_None$();
      } else {
        var x0$3 = this$12.get__O();
        var _$21 = $as_Lsnabbdom_Hooks(x0$3);
        var $x_2 = $n(_$21).update__s_Option();
      }
      var this$13 = $n($x_2);
      if ((!this$13.isEmpty__Z())) {
        var x0$4 = this$13.get__O();
        var hook$2 = $as_Lsnabbdom_UpdateHook(x0$4);
        $n(hook$2).apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__V(oldVnode, vnode);
      }
    }
    matchResult18: {
      var patchedVNode;
      if ((oldVnode instanceof $c_Lsnabbdom_PatchedVNode$Comment)) {
        var x$1$2 = $as_Lsnabbdom_PatchedVNode$Comment(oldVnode);
        var this$16 = $n(x$1$2);
        var x196 = this$16.Lsnabbdom_PatchedVNode$Comment__f_content;
        var this$17 = $n(x$1$2);
        var x197 = this$17.Lsnabbdom_PatchedVNode$Comment__f_node;
        if ((vnode instanceof $c_Lsnabbdom_VNode$Comment)) {
          var x$1$3 = $as_Lsnabbdom_VNode$Comment(vnode);
          var this$19 = $n(x$1$3);
          var x193 = this$19.Lsnabbdom_VNode$Comment__f_content;
          if ((x196 !== x193)) {
            $n(api$14);
            var text = new $c_s_Some(x193);
            x197.textContent = $as_T((text.isEmpty__Z() ? null : text.s_Some__f_value));
          }
          var patchedVNode = new $c_Lsnabbdom_PatchedVNode$Comment(x193, x197);
          break matchResult18;
        }
      }
      if ((oldVnode instanceof $c_Lsnabbdom_PatchedVNode$Text)) {
        var x$1$4 = $as_Lsnabbdom_PatchedVNode$Text(oldVnode);
        var this$24 = $n(x$1$4);
        var x187 = this$24.Lsnabbdom_PatchedVNode$Text__f_content;
        var this$25 = $n(x$1$4);
        var x188 = this$25.Lsnabbdom_PatchedVNode$Text__f_node;
        if ((vnode instanceof $c_Lsnabbdom_VNode$Text)) {
          var x$1$5 = $as_Lsnabbdom_VNode$Text(vnode);
          var this$27 = $n(x$1$5);
          var x184 = this$27.Lsnabbdom_VNode$Text__f_content;
          if ((x187 !== x184)) {
            $n(api$14);
            var text$1 = new $c_s_Some(x184);
            x188.textContent = $as_T((text$1.isEmpty__Z() ? null : text$1.s_Some__f_value));
          }
          var patchedVNode = new $c_Lsnabbdom_PatchedVNode$Text(x184, x188);
          break matchResult18;
        }
      }
      if ((oldVnode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
        var x$1$6 = $as_Lsnabbdom_PatchedVNode$Element(oldVnode);
        $n(x$1$6);
        $n(x$1$6);
        var this$34 = $n(x$1$6);
        var x178 = this$34.Lsnabbdom_PatchedVNode$Element__f_children;
        var this$35 = $n(x$1$6);
        var x179 = this$35.Lsnabbdom_PatchedVNode$Element__f_node;
        if ((vnode instanceof $c_Lsnabbdom_VNode$Element)) {
          var x$1$7 = $as_Lsnabbdom_VNode$Element(vnode);
          var this$37 = $n(x$1$7);
          var x171 = this$37.Lsnabbdom_VNode$Element__f_sel;
          var this$38 = $n(x$1$7);
          var x172 = this$38.Lsnabbdom_VNode$Element__f_data;
          var this$39 = $n(x$1$7);
          var x173 = this$39.Lsnabbdom_VNode$Element__f_children;
          var x145 = new $c_T2(x178, x173);
          var x158 = $as_sci_List(x145.T2__f__1);
          var x159 = $as_sci_List(x145.T2__f__2);
          if ((x158 instanceof $c_sci_$colon$colon)) {
            $n($as_sci_$colon$colon(x158));
            var oldCh$2 = $as_sci_$colon$colon(x158);
            if ((x159 instanceof $c_sci_$colon$colon)) {
              $n($as_sci_$colon$colon(x159));
              var ch$2 = $as_sci_$colon$colon(x159);
              var this$41 = $n(oldCh$2);
              var f = ((_$22) => {
                var _$22$1 = $as_Lsnabbdom_PatchedVNode(_$22);
                return $n(_$22$1).toVNode__Lsnabbdom_VNode();
              });
              if ((this$41 === $m_sci_Nil$())) {
                var x$3 = $m_sci_Nil$();
              } else {
                var x0$5 = this$41.sci_$colon$colon__f_head;
                var h = new $c_sci_$colon$colon(f(x0$5), $m_sci_Nil$());
                var t = h;
                var rest = this$41.sci_$colon$colon__f_next;
                while ((rest !== $m_sci_Nil$())) {
                  var x0$6 = $n(rest).head__O();
                  var nx = new $c_sci_$colon$colon(f(x0$6), $m_sci_Nil$());
                  $n(t).sci_$colon$colon__f_next = nx;
                  t = nx;
                  rest = $as_sci_List($n(rest).tail__O());
                }
                var x$3 = h;
              }
              if ((!x$3.equals__O__Z(ch$2))) {
                var children = $p_Lsnabbdom_init$__updateChildren$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__sci_List__sci_List__scm_ArrayBuffer__sci_List($thiz, api$14, cbs$9, x179, oldCh$2, ch$2, insertedVNodeQueue);
                var patchedVNode = new $c_Lsnabbdom_PatchedVNode$Element(x171, x172, children, x179);
                break matchResult18;
              } else {
                var patchedVNode = new $c_Lsnabbdom_PatchedVNode$Element(x171, x172, oldCh$2, x179);
                break matchResult18;
              }
            }
          }
          var x$5 = $m_sci_Nil$();
          if ((x$5.equals__O__Z(x158) && (x159 instanceof $c_sci_$colon$colon))) {
            $n($as_sci_$colon$colon(x159));
            var ch$3 = $as_sci_$colon$colon(x159);
            var this$47 = $n(ch$3);
            var f$1 = ((vnode$4) => {
              var vnode$1 = $as_Lsnabbdom_VNode(vnode$4);
              var pvnode = $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode($thiz, api$14, cbs$9, vnode$1, insertedVNodeQueue);
              $n(api$14);
              var newNode = $n(pvnode).node__Lorg_scalajs_dom_Node();
              var referenceNode = $m_s_None$();
              x179.insertBefore(newNode, (referenceNode.isEmpty__Z() ? null : referenceNode.get__E()));
              return pvnode;
            });
            if ((this$47 === $m_sci_Nil$())) {
              var patchedChildren = $m_sci_Nil$();
            } else {
              var x0$7 = this$47.sci_$colon$colon__f_head;
              var h$1 = new $c_sci_$colon$colon(f$1(x0$7), $m_sci_Nil$());
              var t$1 = h$1;
              var rest$1 = this$47.sci_$colon$colon__f_next;
              while ((rest$1 !== $m_sci_Nil$())) {
                var x0$8 = $n(rest$1).head__O();
                var nx$1 = new $c_sci_$colon$colon(f$1(x0$8), $m_sci_Nil$());
                $n(t$1).sci_$colon$colon__f_next = nx$1;
                t$1 = nx$1;
                rest$1 = $as_sci_List($n(rest$1).tail__O());
              }
              var patchedChildren = h$1;
            }
            var patchedVNode = new $c_Lsnabbdom_PatchedVNode$Element(x171, x172, patchedChildren, x179);
            break matchResult18;
          }
          if ((x158 instanceof $c_sci_$colon$colon)) {
            $n($as_sci_$colon$colon(x158));
            var oldCh$3 = $as_sci_$colon$colon(x158);
            var x$7 = $m_sci_Nil$();
            if (x$7.equals__O__Z(x159)) {
              $p_Lsnabbdom_init$__removeAllVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__sci_List__V($thiz, api$14, cbs$9, x179, oldCh$3);
              var children$1 = $m_sci_Nil$();
              var patchedVNode = new $c_Lsnabbdom_PatchedVNode$Element(x171, x172, children$1, x179);
              break matchResult18;
            }
          }
          var x$9 = $m_sci_Nil$();
          if (x$9.equals__O__Z(x158)) {
            var x$11 = $m_sci_Nil$();
            var $x_3 = x$11.equals__O__Z(x159);
          } else {
            var $x_3 = false;
          }
          if ($x_3) {
            var children$2 = $m_sci_Nil$();
            var patchedVNode = new $c_Lsnabbdom_PatchedVNode$Element(x171, x172, children$2, x179);
            break matchResult18;
          }
          throw new $c_s_MatchError(x145);
        }
      }
      throw new $c_jl_AssertionError("trying to patch incompatible nodes");
    }
    var this$51 = $n($n(cbs$9).Lsnabbdom_ModuleHooks__f_postPatch);
    var these$1 = this$51;
    while ((!$n(these$1).isEmpty__Z())) {
      var x0$9 = $n(these$1).head__O();
      var hook$3 = $as_Lsnabbdom_PostPatchHook(x0$9);
      $n(hook$3);
      var this$53 = $m_Lsnabbdom_modules_EventListeners$();
      matchResult3: {
        if ((oldVnode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
          var a = $as_Lsnabbdom_PatchedVNode$Element(oldVnode);
          if ((patchedVNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
            var b = $as_Lsnabbdom_PatchedVNode$Element(patchedVNode);
            $p_Lsnabbdom_modules_EventListeners$__updateEventListeners__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_PatchedVNode$Element__V(this$53, a, b);
            break matchResult3;
          }
        }
      }
      these$1 = $as_sci_List($n(these$1).tail__O());
    }
    if ((patchedVNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
      var x$1$8 = $as_Lsnabbdom_PatchedVNode$Element(patchedVNode);
      $n(x$1$8);
      var this$57 = $n(x$1$8);
      var x202 = this$57.Lsnabbdom_PatchedVNode$Element__f_data;
      $n(x$1$8);
      $n(x$1$8);
      var this$60 = $n($n(x202).Lsnabbdom_VNodeData__f_hook);
      if (this$60.isEmpty__Z()) {
        var $x_4 = $m_s_None$();
      } else {
        var x0$10 = this$60.get__O();
        var _$23 = $as_Lsnabbdom_Hooks(x0$10);
        var $x_4 = $n(_$23).postpatch__s_Option();
      }
      var this$61 = $n($x_4);
      if ((!this$61.isEmpty__Z())) {
        var x0$11 = this$61.get__O();
        var hook$4 = $as_Lsnabbdom_PostPatchHook(x0$11);
        $n(hook$4);
        var this$63 = $m_Lsnabbdom_modules_EventListeners$();
        matchResult3$1: {
          if ((oldVnode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
            var a$1 = $as_Lsnabbdom_PatchedVNode$Element(oldVnode);
            if ((patchedVNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
              var b$1 = $as_Lsnabbdom_PatchedVNode$Element(patchedVNode);
              $p_Lsnabbdom_modules_EventListeners$__updateEventListeners__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_PatchedVNode$Element__V(this$63, a$1, b$1);
              break matchResult3$1;
            }
          }
        }
      }
    }
    return patchedVNode;
  }
}
/** @constructor */
function $c_Lsnabbdom_init$() {
}
$c_Lsnabbdom_init$.prototype = new $h_O();
$c_Lsnabbdom_init$.prototype.constructor = $c_Lsnabbdom_init$;
/** @constructor */
function $h_Lsnabbdom_init$() {
}
$h_Lsnabbdom_init$.prototype = $c_Lsnabbdom_init$.prototype;
$c_Lsnabbdom_init$.prototype.apply__sci_Seq__s_Option__Lsnabbdom_Patch = (function(modules, domApi) {
  var this$1 = $n(domApi);
  var api = $as_Lsnabbdom_DomApi((this$1.isEmpty__Z() ? new $c_Lsnabbdom_DomApi$$anon$1() : this$1.get__O()));
  var create = $m_sci_Nil$();
  var update = $m_sci_Nil$();
  var postPatch = $m_sci_Nil$();
  var remove = $m_sci_Nil$();
  var destroy = $m_sci_Nil$();
  var pre = $m_sci_Nil$();
  var post = $m_sci_Nil$();
  var cbs = $as_Lsnabbdom_ModuleHooks($n(modules).foldLeft__O__F2__O(new $c_Lsnabbdom_ModuleHooks(create, update, postPatch, remove, destroy, pre, post), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
    var x$1$1 = $as_Lsnabbdom_ModuleHooks(x$1);
    var x$2$1 = $as_Lsnabbdom_Module(x$2);
    $n(x$1$1);
    var this$6 = $n($n(x$2$1).Lsnabbdom_Module__f_create);
    if (this$6.isEmpty__Z()) {
      var $x_1 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_create;
    } else {
      var x0 = this$6.get__O();
      var _$1 = $as_Lsnabbdom_CreateHook(x0);
      var this$7 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_create);
      var $x_1 = new $c_sci_$colon$colon(_$1, this$7);
    }
    var create$1 = $as_sci_List($x_1);
    var this$8 = $n($n(x$2$1).Lsnabbdom_Module__f_update);
    if (this$8.isEmpty__Z()) {
      var $x_2 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_update;
    } else {
      var x0$1 = this$8.get__O();
      var _$2 = $as_Lsnabbdom_UpdateHook(x0$1);
      var this$9 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_update);
      var $x_2 = new $c_sci_$colon$colon(_$2, this$9);
    }
    var update$1 = $as_sci_List($x_2);
    var this$10 = $n($n(x$2$1).Lsnabbdom_Module__f_postPatch);
    if (this$10.isEmpty__Z()) {
      var $x_3 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_postPatch;
    } else {
      var x0$2 = this$10.get__O();
      var _$3 = $as_Lsnabbdom_PostPatchHook(x0$2);
      var this$11 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_postPatch);
      var $x_3 = new $c_sci_$colon$colon(_$3, this$11);
    }
    var postPatch$1 = $as_sci_List($x_3);
    var this$12 = $n($n(x$2$1).Lsnabbdom_Module__f_remove);
    if (this$12.isEmpty__Z()) {
      var $x_4 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_remove;
    } else {
      var x0$3 = this$12.get__O();
      var _$4 = $as_Lsnabbdom_RemoveHook(x0$3);
      var this$13 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_remove);
      var $x_4 = new $c_sci_$colon$colon(_$4, this$13);
    }
    var remove$1 = $as_sci_List($x_4);
    var this$14 = $n($n(x$2$1).Lsnabbdom_Module__f_destroy);
    if (this$14.isEmpty__Z()) {
      var $x_5 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_destroy;
    } else {
      var x0$4 = this$14.get__O();
      var _$5 = $as_Lsnabbdom_DestroyHook(x0$4);
      var this$15 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_destroy);
      var $x_5 = new $c_sci_$colon$colon(_$5, this$15);
    }
    var destroy$1 = $as_sci_List($x_5);
    var this$16 = $n($n(x$2$1).Lsnabbdom_Module__f_pre);
    if (this$16.isEmpty__Z()) {
      var $x_6 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_pre;
    } else {
      var x0$5 = this$16.get__O();
      var _$6 = $as_Lsnabbdom_PreHook(x0$5);
      var this$17 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_pre);
      var $x_6 = new $c_sci_$colon$colon(_$6, this$17);
    }
    var pre$1 = $as_sci_List($x_6);
    var this$18 = $n($n(x$2$1).Lsnabbdom_Module__f_post);
    if (this$18.isEmpty__Z()) {
      var $x_7 = $n(x$1$1).Lsnabbdom_ModuleHooks__f_post;
    } else {
      var x0$6 = this$18.get__O();
      var _$7 = $as_Lsnabbdom_PostHook(x0$6);
      var this$19 = $n($n(x$1$1).Lsnabbdom_ModuleHooks__f_post);
      var $x_7 = new $c_sci_$colon$colon(_$7, this$19);
    }
    var post$1 = $as_sci_List($x_7);
    return new $c_Lsnabbdom_ModuleHooks(create$1, update$1, postPatch$1, remove$1, destroy$1, pre$1, post$1);
  }))));
  return new $c_Lsnabbdom_init$$anon$1(api, cbs);
});
$c_Lsnabbdom_init$.prototype.snabbdom$init$$$_$emptyNodeAt$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Element__Lsnabbdom_PatchedVNode = (function(api$1, elm) {
  var this$1 = $n($m_s_Option$().apply__O__s_Option($as_T(elm.id)));
  if (this$1.isEmpty__Z()) {
    var $x_1 = true;
  } else {
    var x0 = this$1.get__O();
    var _$8 = $as_T(x0);
    var this$4 = $n(_$8);
    var $x_1 = (!(this$4 === ""));
  }
  if ($x_1) {
    var this$5 = this$1;
  } else {
    var this$5 = $m_s_None$();
  }
  if (this$5.isEmpty__Z()) {
    var id = "";
  } else {
    var x0$1 = this$5.get__O();
    var _$9 = $as_T(x0$1);
    var id = ("#" + _$9);
  }
  var classes = $m_s_Option$().apply__O__s_Option($as_T(elm.getAttribute("class")));
  var this$6 = $n(classes);
  if (this$6.isEmpty__Z()) {
    var this$9 = $m_s_None$();
  } else {
    var x0$2 = this$6.get__O();
    var _$10 = $as_T(x0$2);
    var $x_2 = $m_s_Predef$();
    var this$7 = $n(_$10);
    var this$8 = $n($x_2.wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$7, " ", 0)));
    var this$9 = new $c_s_Some(("." + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "", ".", "")));
  }
  var c = $as_T((this$9.isEmpty__Z() ? "" : this$9.get__O()));
  var this$11 = $n(($n(api$1), $as_T(elm.tagName)));
  var sel = (($as_T(this$11.toLowerCase()) + id) + c);
  var data = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
  var children = $m_sci_Nil$();
  return new $c_Lsnabbdom_PatchedVNode$Element(sel, data, children, elm);
});
$c_Lsnabbdom_init$.prototype.snabbdom$init$$$_$patch$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Lsnabbdom_PatchedVNode = (function(api$16, cbs$11, oldVnode, vnode) {
  $m_scm_ArrayBuffer$();
  var insertedVNodeQueue = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var this$2 = $n($n(cbs$11).Lsnabbdom_ModuleHooks__f_pre);
  var these = this$2;
  while ((!$n(these).isEmpty__Z())) {
    var x0 = $n(these).head__O();
    var _$24 = $as_Lsnabbdom_PreHook(x0);
    $n(_$24).apply__V();
    these = $as_sci_List($n(these).tail__O());
  }
  if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Z(this, oldVnode, vnode)) {
    var vnode0 = $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode(this, api$16, cbs$11, oldVnode, vnode, insertedVNodeQueue);
  } else {
    var elm = $n(oldVnode).node__Lorg_scalajs_dom_Node();
    $n(api$16);
    var parent = $m_s_Option$().apply__O__s_Option(elm.parentNode);
    var vnode1 = $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lsnabbdom_PatchedVNode(this, api$16, cbs$11, vnode, insertedVNodeQueue);
    matchResult20: {
      if ((parent instanceof $c_s_Some)) {
        var parent$2 = $n($as_s_Some(parent)).s_Some__f_value;
        $n(api$16);
        var newNode = $n(vnode1).node__Lorg_scalajs_dom_Node();
        $n(api$16);
        var referenceNode = $m_s_Option$().apply__O__s_Option(elm.nextSibling);
        var this$6 = $n(referenceNode);
        parent$2.insertBefore(newNode, (this$6.isEmpty__Z() ? null : this$6.get__O()));
        var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsnabbdom_PatchedVNode.getArrayOf().constr)([oldVnode]));
        $p_Lsnabbdom_init$__removeAllVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__sci_List__V(this, api$16, cbs$11, parent$2, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
        break matchResult20;
      }
      var x = $m_s_None$();
      if ((x === parent)) {
        break matchResult20;
      }
      throw new $c_s_MatchError(parent);
    }
    var vnode0 = vnode1;
  }
  var it = $n(insertedVNodeQueue.view__scm_ArrayBufferView()).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var x0$1 = $n(it).next__O();
    var x$1 = $as_Lsnabbdom_PatchedVNode(x0$1);
    if ((x$1 instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
      var x209 = $as_Lsnabbdom_PatchedVNode$Element(x$1);
      $n(x209);
      var this$10 = $n(x209);
      var x212 = this$10.Lsnabbdom_PatchedVNode$Element__f_data;
      $n(x209);
      $n(x209);
      var this$13 = $n($n(x212).Lsnabbdom_VNodeData__f_hook);
      if (this$13.isEmpty__Z()) {
        var $x_1 = $m_s_None$();
      } else {
        var x0$2 = this$13.get__O();
        var _$25 = $as_Lsnabbdom_Hooks(x0$2);
        var $x_1 = $n(_$25).insert__s_Option();
      }
      var this$14 = $n($x_1);
      if ((!this$14.isEmpty__Z())) {
        var x0$3 = this$14.get__O();
        var _$26 = $as_Lsnabbdom_InsertHook(x0$3);
        $n(_$26).apply__Lsnabbdom_PatchedVNode__V(x209);
      }
    }
  }
  var this$15 = $n($n(cbs$11).Lsnabbdom_ModuleHooks__f_post);
  var these$1 = this$15;
  while ((!$n(these$1).isEmpty__Z())) {
    var x0$4 = $n(these$1).head__O();
    var _$27 = $as_Lsnabbdom_PostHook(x0$4);
    $n(_$27).apply__V();
    these$1 = $as_sci_List($n(these$1).tail__O());
  }
  return vnode0;
});
var $d_Lsnabbdom_init$ = new $TypeData().initClass($c_Lsnabbdom_init$, "snabbdom.init$", ({
  Lsnabbdom_init$: 1
}));
var $n_Lsnabbdom_init$;
function $m_Lsnabbdom_init$() {
  if ((!$n_Lsnabbdom_init$)) {
    $n_Lsnabbdom_init$ = new $c_Lsnabbdom_init$();
  }
  return $n_Lsnabbdom_init$;
}
/** @constructor */
function $c_Lsnabbdom_modules_Attributes$() {
  this.Lsnabbdom_modules_Attributes$__f_module = null;
  this.Lsnabbdom_modules_Attributes$__f_xlinkNS = null;
  this.Lsnabbdom_modules_Attributes$__f_xmlNS = null;
  $n_Lsnabbdom_modules_Attributes$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var postPatch = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, postPatch, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Attributes$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Attributes$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var postPatch$1 = \u03b41$.Lsnabbdom_Module__f_postPatch;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Attributes$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, postPatch$1, destroy$1, remove$1, post$1);
  this.Lsnabbdom_modules_Attributes$__f_xlinkNS = "http://www.w3.org/1999/xlink";
  this.Lsnabbdom_modules_Attributes$__f_xmlNS = "http://www.w3.org/XML/1998/namespace";
}
$c_Lsnabbdom_modules_Attributes$.prototype = new $h_O();
$c_Lsnabbdom_modules_Attributes$.prototype.constructor = $c_Lsnabbdom_modules_Attributes$;
/** @constructor */
function $h_Lsnabbdom_modules_Attributes$() {
}
$h_Lsnabbdom_modules_Attributes$.prototype = $c_Lsnabbdom_modules_Attributes$.prototype;
$c_Lsnabbdom_modules_Attributes$.prototype.snabbdom$modules$Attributes$$$setAttrs__Lsnabbdom_PatchedVNode$Element__V = (function(vnode) {
  var elm = $n(vnode).Lsnabbdom_PatchedVNode$Element__f_node;
  $n($n($n(vnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_attrs).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult3: {
      if ((x$1$1 !== null)) {
        var x14 = $as_T($n(x$1$1)._1__O());
        var x15 = $as_Lsnabbdom_AttrValue($n(x$1$1)._2__O());
        if (false) {
          var x$1$2 = $as_Lsnabbdom_AttrValue$BooleanAttrValue(x15);
          var x18 = $n(x$1$2)._1__Z();
          if (x18) {
            elm.setAttribute(x14, "");
          } else {
            elm.removeAttribute(x14);
          }
          break matchResult3;
        }
        if ((x15 instanceof $c_Lsnabbdom_AttrValue$StringAttrValue)) {
          var x$1$3 = $as_Lsnabbdom_AttrValue$StringAttrValue(x15);
          var this$4 = $n(x$1$3);
          var x13 = this$4.Lsnabbdom_AttrValue$StringAttrValue__f_value;
          var this$5 = $n(x14);
          if (($charAt(this$5, 0) !== 120)) {
            elm.setAttribute(x14, x13);
            break matchResult3;
          } else {
            var this$6 = $n(x14);
            if ((this$6.length > 3)) {
              var this$7 = $n(x14);
              var $x_1 = ($charAt(this$7, 3) === 58);
            } else {
              var $x_1 = false;
            }
            if ($x_1) {
              elm.setAttributeNS(this.Lsnabbdom_modules_Attributes$__f_xmlNS, x14, x13);
              break matchResult3;
            } else {
              var this$8 = $n(x14);
              if ((this$8.length > 5)) {
                var this$9 = $n(x14);
                var $x_2 = ($charAt(this$9, 5) === 58);
              } else {
                var $x_2 = false;
              }
              if ($x_2) {
                elm.setAttributeNS(this.Lsnabbdom_modules_Attributes$__f_xlinkNS, x14, x13);
                break matchResult3;
              } else {
                elm.setAttribute(x14, x13);
                break matchResult3;
              }
            }
          }
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
});
$c_Lsnabbdom_modules_Attributes$.prototype.snabbdom$modules$Attributes$$$updateAttrs__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V = (function(oldVnode, vnode) {
  var elm = $n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_node;
  var oldAttrs = $n($n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_attrs;
  var attrs = $n($n(vnode).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_attrs;
  $n(attrs).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult5: {
      if ((x$1$1 !== null)) {
        var key = $as_T($n(x$1$1)._1__O());
        var cur = $as_Lsnabbdom_AttrValue($n(x$1$1)._2__O());
        var this$2 = $n($n(oldAttrs).get__O__s_Option(key));
        if (this$2.isEmpty__Z()) {
          var $x_1 = true;
        } else {
          var x0 = this$2.get__O();
          var _$1 = $as_Lsnabbdom_AttrValue(x0);
          var $x_1 = (!((_$1 === null) ? (cur === null) : $n(_$1).equals__O__Z(cur)));
        }
        if ($x_1) {
          if (false) {
            var x$1$2 = $as_Lsnabbdom_AttrValue$BooleanAttrValue(cur);
            var x25 = $n(x$1$2)._1__Z();
            if (x25) {
              elm.setAttribute(key, "");
            } else {
              elm.removeAttribute(key);
            }
            break matchResult5;
          }
          if ((cur instanceof $c_Lsnabbdom_AttrValue$StringAttrValue)) {
            var x$1$3 = $as_Lsnabbdom_AttrValue$StringAttrValue(cur);
            var this$5 = $n(x$1$3);
            var x22 = this$5.Lsnabbdom_AttrValue$StringAttrValue__f_value;
            var this$6 = $n(key);
            if (($charAt(this$6, 0) !== 120)) {
              elm.setAttribute(key, x22);
              break matchResult5;
            } else {
              var this$7 = $n(key);
              if ((this$7.length > 3)) {
                var this$8 = $n(key);
                var $x_2 = ($charAt(this$8, 3) === 58);
              } else {
                var $x_2 = false;
              }
              if ($x_2) {
                elm.setAttributeNS(this.Lsnabbdom_modules_Attributes$__f_xmlNS, key, x22);
                break matchResult5;
              } else {
                var this$9 = $n(key);
                if ((this$9.length > 5)) {
                  var this$10 = $n(key);
                  var $x_3 = ($charAt(this$10, 5) === 58);
                } else {
                  var $x_3 = false;
                }
                if ($x_3) {
                  elm.setAttributeNS(this.Lsnabbdom_modules_Attributes$__f_xlinkNS, key, x22);
                  break matchResult5;
                } else {
                  elm.setAttribute(key, x22);
                  break matchResult5;
                }
              }
            }
          }
          throw new $c_s_MatchError(cur);
        } else {
          break matchResult5;
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
  $n(oldAttrs).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$1) => {
    var x$1$4 = $as_T2(x$1$2$1);
    matchResult6: {
      if ((x$1$4 !== null)) {
        var key$1 = $as_T($n(x$1$4)._1__O());
        if ((!$n(attrs).contains__O__Z(key$1))) {
          elm.removeAttribute(key$1);
          break matchResult6;
        } else {
          break matchResult6;
        }
      }
      throw new $c_s_MatchError(x$1$4);
    }
  })));
});
var $d_Lsnabbdom_modules_Attributes$ = new $TypeData().initClass($c_Lsnabbdom_modules_Attributes$, "snabbdom.modules.Attributes$", ({
  Lsnabbdom_modules_Attributes$: 1
}));
var $n_Lsnabbdom_modules_Attributes$;
function $m_Lsnabbdom_modules_Attributes$() {
  if ((!$n_Lsnabbdom_modules_Attributes$)) {
    $n_Lsnabbdom_modules_Attributes$ = new $c_Lsnabbdom_modules_Attributes$();
  }
  return $n_Lsnabbdom_modules_Attributes$;
}
function $p_Lsnabbdom_modules_Classes$__setClasses__Lsnabbdom_PatchedVNode$Element__V($thiz, vnode) {
  var elm = $n(vnode).Lsnabbdom_PatchedVNode$Element__f_node;
  $n($n($n(vnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_classes).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult3: {
      if ((x$1$1 !== null)) {
        var name = $as_T($n(x$1$1)._1__O());
        var cur = $uZ($n(x$1$1)._2__O());
        if (cur) {
          elm.classList.add(name);
        } else {
          elm.classList.remove(name);
        }
        break matchResult3;
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
}
function $p_Lsnabbdom_modules_Classes$__updateClasses__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V($thiz, oldVnode, vnode) {
  var elm = $n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_node;
  var oldClasses = $n($n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_classes;
  var classes = $n($n(vnode).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_classes;
  $n(oldClasses).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult4: {
      if ((x$1$1 !== null)) {
        var name = $as_T($n(x$1$1)._1__O());
        var flag = $uZ($n(x$1$1)._2__O());
        if ((flag && (!$n(classes).contains__O__Z(name)))) {
          elm.classList.remove(name);
          break matchResult4;
        } else {
          break matchResult4;
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
  $n(classes).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult5: {
      if ((x$1$3 !== null)) {
        var name$1 = $as_T($n(x$1$3)._1__O());
        var cur = $uZ($n(x$1$3)._2__O());
        var this$3 = $n($n(oldClasses).get__O__s_Option(name$1));
        if (this$3.isEmpty__Z()) {
          var $x_1 = true;
        } else {
          var x0 = this$3.get__O();
          var _$1 = $uZ(x0);
          var $x_1 = (_$1 !== cur);
        }
        if ($x_1) {
          if (cur) {
            elm.classList.add(name$1);
          } else {
            elm.classList.remove(name$1);
          }
          break matchResult5;
        } else {
          break matchResult5;
        }
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_Classes$() {
  this.Lsnabbdom_modules_Classes$__f_module = null;
  $n_Lsnabbdom_modules_Classes$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var postPatch = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, postPatch, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Classes$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Classes$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var postPatch$1 = \u03b41$.Lsnabbdom_Module__f_postPatch;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Classes$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, postPatch$1, destroy$1, remove$1, post$1);
}
$c_Lsnabbdom_modules_Classes$.prototype = new $h_O();
$c_Lsnabbdom_modules_Classes$.prototype.constructor = $c_Lsnabbdom_modules_Classes$;
/** @constructor */
function $h_Lsnabbdom_modules_Classes$() {
}
$h_Lsnabbdom_modules_Classes$.prototype = $c_Lsnabbdom_modules_Classes$.prototype;
var $d_Lsnabbdom_modules_Classes$ = new $TypeData().initClass($c_Lsnabbdom_modules_Classes$, "snabbdom.modules.Classes$", ({
  Lsnabbdom_modules_Classes$: 1
}));
var $n_Lsnabbdom_modules_Classes$;
function $m_Lsnabbdom_modules_Classes$() {
  if ((!$n_Lsnabbdom_modules_Classes$)) {
    $n_Lsnabbdom_modules_Classes$ = new $c_Lsnabbdom_modules_Classes$();
  }
  return $n_Lsnabbdom_modules_Classes$;
}
function $p_Lsnabbdom_modules_Dataset$__setDataset__Lsnabbdom_PatchedVNode$Element__V($thiz, vnode) {
  var elm = $n(vnode).Lsnabbdom_PatchedVNode$Element__f_node;
  var d = elm.dataset;
  var dataset = $n($n(vnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_dataset;
  $n(dataset).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var key = $as_T($n(x$1$1)._1__O());
      var value = $as_T($n(x$1$1)._2__O());
      if ((d !== (void 0))) {
        var this$6 = new $c_sjs_js_WrappedDictionary(d);
        var dict = this$6.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
        dict[key] = value;
        return this$6;
      } else {
        var this$8 = $n($f_T__replaceAll__T__T__T($n(key), $thiz.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX, "-$&"));
        elm.setAttribute(("data-" + $as_T(this$8.toLowerCase())), value);
        return (void 0);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $p_Lsnabbdom_modules_Dataset$__updateDataset__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V($thiz, oldVnode, vnode) {
  var elm = $n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_node;
  var oldDataset = $n($n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_dataset;
  var dataset = $n($n(vnode).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_dataset;
  var d = elm.dataset;
  $n(oldDataset).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var key = $as_T($n(x$1$1)._1__O());
      var x11 = $n(dataset).get__O__s_Option(key);
      var x = $m_s_None$();
      if ((x === x11)) {
        if ((d !== (void 0))) {
          var this$4 = new $c_sjs_js_WrappedDictionary(d);
          return this$4.subtractOne__T__sjs_js_WrappedDictionary(key);
        } else {
          var this$5 = $n($f_T__replaceAll__T__T__T($n(key), $thiz.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX, "-$&"));
          elm.removeAttribute(("data-" + $as_T(this$5.toLowerCase())));
          return (void 0);
        }
      }
      if ((x11 instanceof $c_s_Some)) {
        return (void 0);
      }
      throw new $c_s_MatchError(x11);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  $n(dataset).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult6: {
      if ((x$1$3 !== null)) {
        var key$1 = $as_T($n(x$1$3)._1__O());
        var value = $as_T($n(x$1$3)._2__O());
        var this$6 = $n($n(oldDataset).get__O__s_Option(key$1));
        if (this$6.isEmpty__Z()) {
          var $x_1 = true;
        } else {
          var x0 = this$6.get__O();
          var _$1 = $as_T(x0);
          var $x_1 = (_$1 !== value);
        }
        if ($x_1) {
          if ((d !== (void 0))) {
            d[key$1] = value;
            break matchResult6;
          } else {
            var this$12 = $n($f_T__replaceAll__T__T__T($n(key$1), $thiz.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX, "-$&"));
            elm.setAttribute(("data-" + $as_T(this$12.toLowerCase())), value);
            break matchResult6;
          }
        } else {
          break matchResult6;
        }
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_Dataset$() {
  this.Lsnabbdom_modules_Dataset$__f_module = null;
  this.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX = null;
  $n_Lsnabbdom_modules_Dataset$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var postPatch = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, postPatch, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Dataset$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Dataset$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var postPatch$1 = \u03b41$.Lsnabbdom_Module__f_postPatch;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Dataset$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, postPatch$1, destroy$1, remove$1, post$1);
  this.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX = "[A-Z]";
}
$c_Lsnabbdom_modules_Dataset$.prototype = new $h_O();
$c_Lsnabbdom_modules_Dataset$.prototype.constructor = $c_Lsnabbdom_modules_Dataset$;
/** @constructor */
function $h_Lsnabbdom_modules_Dataset$() {
}
$h_Lsnabbdom_modules_Dataset$.prototype = $c_Lsnabbdom_modules_Dataset$.prototype;
var $d_Lsnabbdom_modules_Dataset$ = new $TypeData().initClass($c_Lsnabbdom_modules_Dataset$, "snabbdom.modules.Dataset$", ({
  Lsnabbdom_modules_Dataset$: 1
}));
var $n_Lsnabbdom_modules_Dataset$;
function $m_Lsnabbdom_modules_Dataset$() {
  if ((!$n_Lsnabbdom_modules_Dataset$)) {
    $n_Lsnabbdom_modules_Dataset$ = new $c_Lsnabbdom_modules_Dataset$();
  }
  return $n_Lsnabbdom_modules_Dataset$;
}
function $p_Lsnabbdom_modules_EventListeners$__updateEventListeners__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_PatchedVNode$Element__V($thiz, oldVnode, vnode) {
  var elm = $n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_node;
  $n($n($n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_on).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult6: {
      if ((x$1$1 !== null)) {
        var name = $as_T($n(x$1$1)._1__O());
        elm.removeEventListener(name, $n(oldVnode).listener__sjs_js_Function1(), false);
        break matchResult6;
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
  $n($n($n(vnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_on).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult7: {
      if ((x$1$3 !== null)) {
        var name$1 = $as_T($n(x$1$3)._1__O());
        elm.addEventListener(name$1, $n(vnode).listener__sjs_js_Function1(), false);
        break matchResult7;
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$() {
  this.Lsnabbdom_modules_EventListeners$__f_module = null;
  $n_Lsnabbdom_modules_EventListeners$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var postPatch = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, postPatch, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_EventListeners$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_EventListeners$$anon$2();
  var postPatch$1 = new $c_s_Some(value$1);
  var value$2 = new $c_Lsnabbdom_modules_EventListeners$$anon$3();
  var destroy$1 = new $c_s_Some(value$2);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var update$1 = \u03b41$.Lsnabbdom_Module__f_update;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_EventListeners$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, postPatch$1, destroy$1, remove$1, post$1);
}
$c_Lsnabbdom_modules_EventListeners$.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$() {
}
$h_Lsnabbdom_modules_EventListeners$.prototype = $c_Lsnabbdom_modules_EventListeners$.prototype;
var $d_Lsnabbdom_modules_EventListeners$ = new $TypeData().initClass($c_Lsnabbdom_modules_EventListeners$, "snabbdom.modules.EventListeners$", ({
  Lsnabbdom_modules_EventListeners$: 1
}));
var $n_Lsnabbdom_modules_EventListeners$;
function $m_Lsnabbdom_modules_EventListeners$() {
  if ((!$n_Lsnabbdom_modules_EventListeners$)) {
    $n_Lsnabbdom_modules_EventListeners$ = new $c_Lsnabbdom_modules_EventListeners$();
  }
  return $n_Lsnabbdom_modules_EventListeners$;
}
function $p_Lsnabbdom_modules_Props$__setProps__Lsnabbdom_PatchedVNode$Element__V($thiz, vnode) {
  if ((vnode !== null)) {
    $n($n($n(vnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_props).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var key = $as_T($n(x$1$1)._1__O());
        var cur = $n(x$1$1)._2__O();
        var dict = $n(vnode).Lsnabbdom_PatchedVNode$Element__f_node;
        var this$5 = new $c_sjs_js_WrappedDictionary(dict);
        var dict$1 = this$5.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
        dict$1[key] = cur;
        return this$5;
      }
      throw new $c_s_MatchError(x$1$1);
    })));
    return (void 0);
  }
  throw new $c_s_MatchError(vnode);
}
function $p_Lsnabbdom_modules_Props$__updateProps__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V($thiz, oldVnode, vnode) {
  var elm = $n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_node;
  var oldProps = $n($n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_props;
  var props = $n($n(vnode).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_props;
  $n(props).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult5: {
      if ((x$1$1 !== null)) {
        var key = $as_T($n(x$1$1)._1__O());
        var cur = $n(x$1$1)._2__O();
        var this$2 = $n($n(oldProps).get__O__s_Option(key));
        if (this$2.isEmpty__Z()) {
          var $x_1 = true;
        } else {
          var x0 = this$2.get__O();
          var $x_1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x0, cur));
        }
        if ($x_1) {
          elm[key] = cur;
          break matchResult5;
        } else {
          break matchResult5;
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
  $n(oldProps).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult6: {
      if ((x$1$3 !== null)) {
        var key$1 = $as_T($n(x$1$3)._1__O());
        if ((!$n(props).contains__O__Z(key$1))) {
          if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(elm, key$1))) {
            delete elm[key$1];
            break matchResult6;
          } else {
            break matchResult6;
          }
        } else {
          break matchResult6;
        }
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_Props$() {
  this.Lsnabbdom_modules_Props$__f_module = null;
  $n_Lsnabbdom_modules_Props$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var postPatch = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, postPatch, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Props$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Props$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var postPatch$1 = \u03b41$.Lsnabbdom_Module__f_postPatch;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Props$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, postPatch$1, destroy$1, remove$1, post$1);
}
$c_Lsnabbdom_modules_Props$.prototype = new $h_O();
$c_Lsnabbdom_modules_Props$.prototype.constructor = $c_Lsnabbdom_modules_Props$;
/** @constructor */
function $h_Lsnabbdom_modules_Props$() {
}
$h_Lsnabbdom_modules_Props$.prototype = $c_Lsnabbdom_modules_Props$.prototype;
var $d_Lsnabbdom_modules_Props$ = new $TypeData().initClass($c_Lsnabbdom_modules_Props$, "snabbdom.modules.Props$", ({
  Lsnabbdom_modules_Props$: 1
}));
var $n_Lsnabbdom_modules_Props$;
function $m_Lsnabbdom_modules_Props$() {
  if ((!$n_Lsnabbdom_modules_Props$)) {
    $n_Lsnabbdom_modules_Props$ = new $c_Lsnabbdom_modules_Props$();
  }
  return $n_Lsnabbdom_modules_Props$;
}
function $p_Lsnabbdom_modules_Styles$__setStyle__Lsnabbdom_PatchedVNode$Element__V($thiz, vnode) {
  $n($n($n(vnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_style).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult3: {
      if ((x$1$1 !== null)) {
        var name = $as_T($n(x$1$1)._1__O());
        var cur = $as_T($n(x$1$1)._2__O());
        var this$2 = $n(name);
        if ($uZ(this$2.startsWith("--"))) {
          var \u03b42$ = $n(vnode).Lsnabbdom_PatchedVNode$Element__f_node.style;
          \u03b42$.setProperty(name, cur);
          break matchResult3;
        } else {
          var dict = $n(vnode).Lsnabbdom_PatchedVNode$Element__f_node.style;
          dict[name] = cur;
          break matchResult3;
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
}
function $p_Lsnabbdom_modules_Styles$__updateStyle__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V($thiz, oldVnode, vnode) {
  var elm = $n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_node;
  var oldStyle = $n($n(oldVnode).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_style;
  var style = $n($n(vnode).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_style;
  $n(oldStyle).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult4: {
      if ((x$1$1 !== null)) {
        var name = $as_T($n(x$1$1)._1__O());
        if ((!$n(style).contains__O__Z(name))) {
          var this$2 = $n(name);
          if ($uZ(this$2.startsWith("--"))) {
            elm.style.removeProperty(name);
            break matchResult4;
          } else {
            var dict = elm.style;
            dict[name] = "";
            break matchResult4;
          }
        } else {
          break matchResult4;
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }
  })));
  $n(style).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult5: {
      if ((x$1$3 !== null)) {
        var name$1 = $as_T($n(x$1$3)._1__O());
        var cur = $as_T($n(x$1$3)._2__O());
        var this$4 = $n($n(oldStyle).get__O__s_Option(name$1));
        if (this$4.isEmpty__Z()) {
          var $x_1 = true;
        } else {
          var x0 = this$4.get__O();
          var _$1 = $as_T(x0);
          var $x_1 = (_$1 !== cur);
        }
        if ($x_1) {
          var this$5 = $n(name$1);
          if ($uZ(this$5.startsWith("--"))) {
            var \u03b43$ = elm.style;
            \u03b43$.setProperty(name$1, cur);
            break matchResult5;
          } else {
            var dict$1 = elm.style;
            dict$1[name$1] = cur;
            break matchResult5;
          }
        } else {
          break matchResult5;
        }
      }
      throw new $c_s_MatchError(x$1$3);
    }
  })));
}
/** @constructor */
function $c_Lsnabbdom_modules_Styles$() {
  this.Lsnabbdom_modules_Styles$__f_module = null;
  $n_Lsnabbdom_modules_Styles$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var postPatch = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, postPatch, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Styles$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Styles$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var postPatch$1 = \u03b41$.Lsnabbdom_Module__f_postPatch;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Styles$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, postPatch$1, destroy$1, remove$1, post$1);
}
$c_Lsnabbdom_modules_Styles$.prototype = new $h_O();
$c_Lsnabbdom_modules_Styles$.prototype.constructor = $c_Lsnabbdom_modules_Styles$;
/** @constructor */
function $h_Lsnabbdom_modules_Styles$() {
}
$h_Lsnabbdom_modules_Styles$.prototype = $c_Lsnabbdom_modules_Styles$.prototype;
var $d_Lsnabbdom_modules_Styles$ = new $TypeData().initClass($c_Lsnabbdom_modules_Styles$, "snabbdom.modules.Styles$", ({
  Lsnabbdom_modules_Styles$: 1
}));
var $n_Lsnabbdom_modules_Styles$;
function $m_Lsnabbdom_modules_Styles$() {
  if ((!$n_Lsnabbdom_modules_Styles$)) {
    $n_Lsnabbdom_modules_Styles$ = new $c_Lsnabbdom_modules_Styles$();
  }
  return $n_Lsnabbdom_modules_Styles$;
}
/** @constructor */
function $c_Lsnabbdom_toVNode$() {
}
$c_Lsnabbdom_toVNode$.prototype = new $h_O();
$c_Lsnabbdom_toVNode$.prototype.constructor = $c_Lsnabbdom_toVNode$;
/** @constructor */
function $h_Lsnabbdom_toVNode$() {
}
$h_Lsnabbdom_toVNode$.prototype = $c_Lsnabbdom_toVNode$.prototype;
$c_Lsnabbdom_toVNode$.prototype.apply__Lorg_scalajs_dom_Node__s_Option__Lsnabbdom_PatchedVNode = (function(node, domApi) {
  var this$1 = $n(domApi);
  var api = $as_Lsnabbdom_DomApi((this$1.isEmpty__Z() ? new $c_Lsnabbdom_DomApi$$anon$1() : this$1.get__O()));
  if (($n(api), ($uI(node.nodeType) === 1))) {
    var this$4 = $n($m_s_Option$().apply__O__s_Option($as_T(node.id)));
    if (this$4.isEmpty__Z()) {
      var $x_1 = true;
    } else {
      var x0 = this$4.get__O();
      var _$1 = $as_T(x0);
      var this$7 = $n(_$1);
      var $x_1 = (!(this$7 === ""));
    }
    if ($x_1) {
      var this$8 = this$4;
    } else {
      var this$8 = $m_s_None$();
    }
    if (this$8.isEmpty__Z()) {
      var id = "";
    } else {
      var x0$1 = this$8.get__O();
      var _$2 = $as_T(x0$1);
      var id = ("#" + _$2);
    }
    var this$9 = $n($m_s_Option$().apply__O__s_Option($as_T(node.getAttribute("class"))));
    var cn = $as_T((this$9.isEmpty__Z() ? "" : this$9.get__O()));
    if ((cn !== "")) {
      var $x_2 = $m_s_Predef$();
      var this$10 = $n(cn);
      var this$11 = $n($x_2.wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$10, " ", 0)));
      var c = ("." + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$11, "", ".", ""));
    } else {
      var c = "";
    }
    var this$13 = $n(($n(api), $as_T(node.tagName)));
    var sel = (($as_T(this$13.toLowerCase()) + id) + c);
    var attrs = $as_scm_Map($m_scm_Map$().empty__O());
    var datasets = $as_scm_Map($m_scm_Map$().empty__O());
    var children = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    var elmAttrs = node.attributes;
    var elmChildren = node.childNodes;
    var this$15 = new $c_Lorg_scalajs_dom_NamedNodeMapMap(elmAttrs);
    var it = new $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(this$15);
    while (it.hasNext__Z()) {
      var x0$2 = it.next__T2();
      matchResult1: {
        if ((x0$2 !== null)) {
          var attr = $n(x0$2)._2__O();
          var name = $as_T(attr.nodeName);
          var this$16 = $n(name);
          if ($uZ(this$16.startsWith("data-"))) {
            var this$21 = $n(datasets);
            var self = $m_sc_StringOps$().drop$extension__T__I__T(name, 5);
            var this$19 = $n($m_s_Option$().apply__O__s_Option($as_T(attr.nodeValue)));
            var y = (this$19.isEmpty__Z() ? "" : this$19.get__O());
            var elem = new $c_T2(self, y);
            this$21.addOne__O__scm_Growable(elem);
            break matchResult1;
          } else if (((name !== "id") && (name !== "class"))) {
            var this$25 = $n(attrs);
            var this$23 = $n($m_s_Option$().apply__O__s_Option($as_T(attr.nodeValue)));
            var y$1 = (this$23.isEmpty__Z() ? "" : this$23.get__O());
            var elem$1 = new $c_T2(name, y$1);
            this$25.addOne__O__scm_Growable(elem$1);
            break matchResult1;
          } else {
            break matchResult1;
          }
        }
        throw new $c_s_MatchError(x0$2);
      }
    }
    var this$27 = new $c_Lorg_scalajs_dom_DOMList$DOMListSeq(elmChildren);
    var it$1 = this$27.iterator__sc_Iterator();
    while ($n(it$1).hasNext__Z()) {
      var x0$3 = $n(it$1).next__O();
      var elem$2 = $m_Lsnabbdom_toVNode$().apply__Lorg_scalajs_dom_Node__s_Option__Lsnabbdom_PatchedVNode(x0$3, domApi);
      children.addOne__O__scm_ArrayBuffer(elem$2);
    }
    var this$29 = $n(attrs);
    var attrs$1 = $as_sci_Map($n($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$29)).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
      var x$1 = $as_T2(x$1$2);
      if ((x$1 !== null)) {
        var key = $as_T($n(x$1)._1__O());
        var value = $as_T($n(x$1)._2__O());
        var y$2 = new $c_Lsnabbdom_AttrValue$StringAttrValue(value);
        return new $c_T2(key, y$2);
      }
      throw new $c_s_MatchError(x$1);
    }))));
    var this$34 = $n(datasets);
    if ((!this$34.isEmpty__Z())) {
      var this$36 = $n(datasets);
      var dataset$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$36);
    } else {
      var dataset$1 = $m_sci_Map$EmptyMap$();
    }
    $m_Lsnabbdom_VNodeData$();
    var props$1 = $m_sci_Map$EmptyMap$();
    $m_Lsnabbdom_VNodeData$();
    var classes$1 = $m_sci_Map$EmptyMap$();
    $m_Lsnabbdom_VNodeData$();
    var style$1 = $m_sci_Map$EmptyMap$();
    $m_Lsnabbdom_VNodeData$();
    var on$1 = $m_sci_Map$EmptyMap$();
    $m_Lsnabbdom_VNodeData$();
    var hook$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var key$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var ns$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var fn$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var args$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var is$1 = $m_s_None$();
    $m_Lsnabbdom_VNodeData$();
    var data = new $c_Lsnabbdom_VNodeData(props$1, attrs$1, classes$1, style$1, dataset$1, on$1, hook$1, key$1, ns$1, fn$1, args$1, is$1);
    var children$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children);
    var vnode = new $c_Lsnabbdom_PatchedVNode$Element(sel, data, children$1, node);
    return (($uZ(sel.startsWith("svg")) && (((sel.length === 3) || ($charAt(sel, 3) === 46)) || ($charAt(sel, 3) === 35))) ? $m_Lsnabbdom_h$().addNS__Lsnabbdom_PatchedVNode__Lsnabbdom_PatchedVNode(vnode) : vnode);
  } else if (($n(api), ($uI(node.nodeType) === 3))) {
    var this$61 = $n(($n(api), $m_s_Option$().apply__O__s_Option($as_T(node.textContent))));
    var text = $as_T((this$61.isEmpty__Z() ? "" : this$61.get__O()));
    return new $c_Lsnabbdom_PatchedVNode$Text(text, node);
  } else if (($n(api), ($uI(node.nodeType) === 8))) {
    var this$66 = $n(($n(api), $m_s_Option$().apply__O__s_Option($as_T(node.textContent))));
    var text$2 = $as_T((this$66.isEmpty__Z() ? "" : this$66.get__O()));
    return new $c_Lsnabbdom_PatchedVNode$Comment(text$2, node);
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Unexpected node type: " + node));
  }
});
var $d_Lsnabbdom_toVNode$ = new $TypeData().initClass($c_Lsnabbdom_toVNode$, "snabbdom.toVNode$", ({
  Lsnabbdom_toVNode$: 1
}));
var $n_Lsnabbdom_toVNode$;
function $m_Lsnabbdom_toVNode$() {
  if ((!$n_Lsnabbdom_toVNode$)) {
    $n_Lsnabbdom_toVNode$ = new $c_Lsnabbdom_toVNode$();
  }
  return $n_Lsnabbdom_toVNode$;
}
function $is_Ltyrian_Attr(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Attr)));
}
function $as_Ltyrian_Attr(obj) {
  return (($is_Ltyrian_Attr(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Attr"));
}
function $isArrayOf_Ltyrian_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Attr)));
}
function $asArrayOf_Ltyrian_Attr(obj, depth) {
  return (($isArrayOf_Ltyrian_Attr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Attr;", depth));
}
var $d_Ltyrian_Attr = new $TypeData().initClass(1, "tyrian.Attr", ({
  Ltyrian_Attr: 1
}));
/** @constructor */
function $c_Ltyrian_AttributeName(name) {
  this.Ltyrian_AttributeName__f_name = null;
  this.Ltyrian_AttributeName__f_name = name;
}
$c_Ltyrian_AttributeName.prototype = new $h_O();
$c_Ltyrian_AttributeName.prototype.constructor = $c_Ltyrian_AttributeName;
/** @constructor */
function $h_Ltyrian_AttributeName() {
}
$h_Ltyrian_AttributeName.prototype = $c_Ltyrian_AttributeName.prototype;
$c_Ltyrian_AttributeName.prototype.$colon$eq__O__Ltyrian_Attribute = (function(value) {
  if (((typeof value) === "string")) {
    var x = $as_T(value);
    $m_Ltyrian_Attribute$();
    var this$1 = $n(this.Ltyrian_AttributeName__f_name);
    return new $c_Ltyrian_Attribute(this$1, x);
  }
  if ($isInt(value)) {
    var x$2 = $uI(value);
    $m_Ltyrian_Attribute$();
    var this$3 = $n(this.Ltyrian_AttributeName__f_name);
    var value$1 = ("" + x$2);
    return new $c_Ltyrian_Attribute(this$3, value$1);
  }
  if (((typeof value) === "number")) {
    var x$3 = $uD(value);
    $m_Ltyrian_Attribute$();
    var this$6 = $n(this.Ltyrian_AttributeName__f_name);
    var value$2 = ("" + x$3);
    return new $c_Ltyrian_Attribute(this$6, value$2);
  }
  if (((typeof value) === "boolean")) {
    var x$4 = $uZ(value);
    $m_Ltyrian_Attribute$();
    var this$9 = $n(this.Ltyrian_AttributeName__f_name);
    var value$3 = ("" + x$4);
    return new $c_Ltyrian_Attribute(this$9, value$3);
  }
  throw new $c_s_MatchError(value);
});
var $d_Ltyrian_AttributeName = new $TypeData().initClass($c_Ltyrian_AttributeName, "tyrian.AttributeName", ({
  Ltyrian_AttributeName: 1
}));
/** @constructor */
function $c_Ltyrian_AttributeNameString(name) {
  this.Ltyrian_AttributeNameString__f_name = null;
  this.Ltyrian_AttributeNameString__f_name = name;
}
$c_Ltyrian_AttributeNameString.prototype = new $h_O();
$c_Ltyrian_AttributeNameString.prototype.constructor = $c_Ltyrian_AttributeNameString;
/** @constructor */
function $h_Ltyrian_AttributeNameString() {
}
$h_Ltyrian_AttributeNameString.prototype = $c_Ltyrian_AttributeNameString.prototype;
$c_Ltyrian_AttributeNameString.prototype.$colon$eq__T__Ltyrian_Attribute = (function(value) {
  $m_Ltyrian_Attribute$();
  var this$1 = $n(this.Ltyrian_AttributeNameString__f_name);
  return new $c_Ltyrian_Attribute(this$1, value);
});
var $d_Ltyrian_AttributeNameString = new $TypeData().initClass($c_Ltyrian_AttributeNameString, "tyrian.AttributeNameString", ({
  Ltyrian_AttributeNameString: 1
}));
function $is_Ltyrian_Cmd(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Cmd)));
}
function $as_Ltyrian_Cmd(obj) {
  return (($is_Ltyrian_Cmd(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd"));
}
function $isArrayOf_Ltyrian_Cmd(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd)));
}
function $asArrayOf_Ltyrian_Cmd(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd;", depth));
}
var $d_Ltyrian_Cmd = new $TypeData().initClass(1, "tyrian.Cmd", ({
  Ltyrian_Cmd: 1
}));
/** @constructor */
function $c_Ltyrian_Cmd$() {
}
$c_Ltyrian_Cmd$.prototype = new $h_O();
$c_Ltyrian_Cmd$.prototype.constructor = $c_Ltyrian_Cmd$;
/** @constructor */
function $h_Ltyrian_Cmd$() {
}
$h_Ltyrian_Cmd$.prototype = $c_Ltyrian_Cmd$.prototype;
$c_Ltyrian_Cmd$.prototype.merge__Ltyrian_Cmd__Ltyrian_Cmd__Ltyrian_Cmd = (function(a, b) {
  var x = $m_Ltyrian_Cmd$None$();
  if ((x === a)) {
    var x$3 = $m_Ltyrian_Cmd$None$();
    if ((x$3 === b)) {
      return $m_Ltyrian_Cmd$None$();
    }
    return b;
  }
  var x$5 = $m_Ltyrian_Cmd$None$();
  if ((x$5 === b)) {
    return a;
  }
  return new $c_Ltyrian_Cmd$Combine(a, b);
});
var $d_Ltyrian_Cmd$ = new $TypeData().initClass($c_Ltyrian_Cmd$, "tyrian.Cmd$", ({
  Ltyrian_Cmd$: 1
}));
var $n_Ltyrian_Cmd$;
function $m_Ltyrian_Cmd$() {
  if ((!$n_Ltyrian_Cmd$)) {
    $n_Ltyrian_Cmd$ = new $c_Ltyrian_Cmd$();
  }
  return $n_Ltyrian_Cmd$;
}
/** @constructor */
function $c_Ltyrian_Cmd$Run$() {
}
$c_Ltyrian_Cmd$Run$.prototype = new $h_O();
$c_Ltyrian_Cmd$Run$.prototype.constructor = $c_Ltyrian_Cmd$Run$;
/** @constructor */
function $h_Ltyrian_Cmd$Run$() {
}
$h_Ltyrian_Cmd$Run$.prototype = $c_Ltyrian_Cmd$Run$.prototype;
$c_Ltyrian_Cmd$Run$.prototype.apply__O__Lcats_Applicative__Ltyrian_Cmd$Run = (function(task, evidence$1) {
  var toMsg = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => x));
  return new $c_Ltyrian_Cmd$Run(task, toMsg, evidence$1);
});
var $d_Ltyrian_Cmd$Run$ = new $TypeData().initClass($c_Ltyrian_Cmd$Run$, "tyrian.Cmd$Run$", ({
  Ltyrian_Cmd$Run$: 1
}));
var $n_Ltyrian_Cmd$Run$;
function $m_Ltyrian_Cmd$Run$() {
  if ((!$n_Ltyrian_Cmd$Run$)) {
    $n_Ltyrian_Cmd$Run$ = new $c_Ltyrian_Cmd$Run$();
  }
  return $n_Ltyrian_Cmd$Run$;
}
/** @constructor */
function $c_Ltyrian_Cmd$SideEffect$() {
}
$c_Ltyrian_Cmd$SideEffect$.prototype = new $h_O();
$c_Ltyrian_Cmd$SideEffect$.prototype.constructor = $c_Ltyrian_Cmd$SideEffect$;
/** @constructor */
function $h_Ltyrian_Cmd$SideEffect$() {
}
$h_Ltyrian_Cmd$SideEffect$.prototype = $c_Ltyrian_Cmd$SideEffect$.prototype;
$c_Ltyrian_Cmd$SideEffect$.prototype.apply__F0__Lcats_effect_kernel_Sync__Ltyrian_Cmd$SideEffect = (function(thunk, evidence$1) {
  var task = $n(evidence$1).delay__F0__O(thunk);
  return new $c_Ltyrian_Cmd$SideEffect(task, evidence$1);
});
var $d_Ltyrian_Cmd$SideEffect$ = new $TypeData().initClass($c_Ltyrian_Cmd$SideEffect$, "tyrian.Cmd$SideEffect$", ({
  Ltyrian_Cmd$SideEffect$: 1
}));
var $n_Ltyrian_Cmd$SideEffect$;
function $m_Ltyrian_Cmd$SideEffect$() {
  if ((!$n_Ltyrian_Cmd$SideEffect$)) {
    $n_Ltyrian_Cmd$SideEffect$ = new $c_Ltyrian_Cmd$SideEffect$();
  }
  return $n_Ltyrian_Cmd$SideEffect$;
}
function $is_Ltyrian_Elem(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Elem)));
}
function $as_Ltyrian_Elem(obj) {
  return (($is_Ltyrian_Elem(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Elem"));
}
function $isArrayOf_Ltyrian_Elem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Elem)));
}
function $asArrayOf_Ltyrian_Elem(obj, depth) {
  return (($isArrayOf_Ltyrian_Elem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Elem;", depth));
}
var $d_Ltyrian_Elem = new $TypeData().initClass(1, "tyrian.Elem", ({
  Ltyrian_Elem: 1
}));
/** @constructor */
function $c_Ltyrian_HTMLRendering$package$() {
  this.Ltyrian_HTMLRendering$package$__f_spacer = null;
  $n_Ltyrian_HTMLRendering$package$ = this;
  this.Ltyrian_HTMLRendering$package$__f_spacer = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((str) => {
    var str$1 = $as_T(str);
    var this$2 = $n(str$1);
    if ((this$2 === "")) {
      return str$1;
    } else {
      return (" " + str$1);
    }
  }));
}
$c_Ltyrian_HTMLRendering$package$.prototype = new $h_O();
$c_Ltyrian_HTMLRendering$package$.prototype.constructor = $c_Ltyrian_HTMLRendering$package$;
/** @constructor */
function $h_Ltyrian_HTMLRendering$package$() {
}
$h_Ltyrian_HTMLRendering$package$.prototype = $c_Ltyrian_HTMLRendering$package$.prototype;
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Elem__T = (function(elem) {
  if ((elem === $m_Ltyrian_Empty$())) {
    return "";
  }
  if ((elem instanceof $c_Ltyrian_Text)) {
    var t = $as_Ltyrian_Text(elem);
    return $n(t).Ltyrian_Text__f_value;
  }
  if ($is_Ltyrian_Html(elem)) {
    var h = $as_Ltyrian_Html(elem);
    return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Html__T(h);
  }
  throw new $c_s_MatchError(elem);
});
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Html__T = (function(html) {
  if ((html instanceof $c_Ltyrian_RawTag)) {
    var tag = $as_Ltyrian_RawTag(html);
    var $x_1 = $m_Ltyrian_HTMLRendering$package$().Ltyrian_HTMLRendering$package$__f_spacer;
    var this$1 = $n($n(tag).Ltyrian_RawTag__f_attributes);
    var f = ((_$1) => {
      var _$1$1 = $as_Ltyrian_Attr(_$1);
      return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(_$1$1);
    });
    if ((this$1 === $m_sci_Nil$())) {
      var this$3 = $m_sci_Nil$();
    } else {
      var x0 = this$1.head__O();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$1.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var this$3 = h;
    }
    var f$1 = ((_$2) => {
      var _$2$1 = $as_T(_$2);
      var this$2 = $n(_$2$1);
      return (this$2 === "");
    });
    var l = this$3;
    block: {
      var result;
      while (true) {
        if ($n(l).isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break;
        } else {
          var h$1 = $n(l).head__O();
          var t$1 = $as_sci_List($n(l).tail__O());
          if (($uZ(f$1(h$1)) === true)) {
            l = t$1;
            continue;
          }
          var start = l;
          var remaining = t$1;
          while (true) {
            if ($n(remaining).isEmpty__Z()) {
              var result = start;
              break block;
            } else {
              var x = $n(remaining).head__O();
              if (($uZ(f$1(x)) !== true)) {
                remaining = $as_sci_List($n(remaining).tail__O());
                continue;
              }
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List($n(start).tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
                $n(currentLast).sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List($n(toProcess).tail__O());
              }
              var next = $as_sci_List($n(firstMiss).tail__O());
              var nextToCopy = next;
              while ((!$n(next).isEmpty__Z())) {
                var head = $n(next).head__O();
                if (($uZ(f$1(head)) !== true)) {
                  next = $as_sci_List($n(next).tail__O());
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                    $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                  }
                  nextToCopy = $as_sci_List($n(next).tail__O());
                  next = $as_sci_List($n(next).tail__O());
                }
              }
              if ((!$n(nextToCopy).isEmpty__Z())) {
                $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
              }
              var result = newHead;
              break block;
            }
          }
        }
      }
    }
    var this$4 = $n(result);
    var attributes = $as_T($n($x_1).apply__O__O($f_sc_IterableOnceOps__mkString__T__T__T__T(this$4, "", " ", "")));
    return ((((((("<" + $n(tag).Ltyrian_RawTag__f_name) + attributes) + ">") + $n(tag).Ltyrian_RawTag__f_innerHTML) + "</") + $n(tag).Ltyrian_RawTag__f_name) + ">");
  }
  if ((html instanceof $c_Ltyrian_Tag)) {
    var tag$2 = $as_Ltyrian_Tag(html);
    var $x_2 = $m_Ltyrian_HTMLRendering$package$().Ltyrian_HTMLRendering$package$__f_spacer;
    var this$5 = $n($n(tag$2).Ltyrian_Tag__f_attributes);
    var f$2 = ((_$3) => {
      var _$3$1 = $as_Ltyrian_Attr(_$3);
      return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(_$3$1);
    });
    if ((this$5 === $m_sci_Nil$())) {
      var this$7 = $m_sci_Nil$();
    } else {
      var x0$2 = this$5.head__O();
      var h$2 = new $c_sci_$colon$colon(f$2(x0$2), $m_sci_Nil$());
      var t$2 = h$2;
      var rest$1 = $as_sci_List(this$5.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = $n(rest$1).head__O();
        var nx$1 = new $c_sci_$colon$colon(f$2(x0$3), $m_sci_Nil$());
        $n(t$2).sci_$colon$colon__f_next = nx$1;
        t$2 = nx$1;
        rest$1 = $as_sci_List($n(rest$1).tail__O());
      }
      var this$7 = h$2;
    }
    var f$3 = ((_$4) => {
      var _$4$1 = $as_T(_$4);
      var this$6 = $n(_$4$1);
      return (this$6 === "");
    });
    var l$1 = this$7;
    block$2: {
      var result$1;
      while (true) {
        if ($n(l$1).isEmpty__Z()) {
          var result$1 = $m_sci_Nil$();
          break;
        } else {
          var h$3 = $n(l$1).head__O();
          var t$3 = $as_sci_List($n(l$1).tail__O());
          if (($uZ(f$3(h$3)) === true)) {
            l$1 = t$3;
            continue;
          }
          var start$1 = l$1;
          var remaining$1 = t$3;
          while (true) {
            if ($n(remaining$1).isEmpty__Z()) {
              var result$1 = start$1;
              break block$2;
            } else {
              var x$1 = $n(remaining$1).head__O();
              if (($uZ(f$3(x$1)) !== true)) {
                remaining$1 = $as_sci_List($n(remaining$1).tail__O());
                continue;
              }
              var firstMiss$1 = remaining$1;
              var newHead$1 = new $c_sci_$colon$colon($n(start$1).head__O(), $m_sci_Nil$());
              var toProcess$1 = $as_sci_List($n(start$1).tail__O());
              var currentLast$1 = newHead$1;
              while ((toProcess$1 !== firstMiss$1)) {
                var newElem$1 = new $c_sci_$colon$colon($n(toProcess$1).head__O(), $m_sci_Nil$());
                $n(currentLast$1).sci_$colon$colon__f_next = newElem$1;
                currentLast$1 = newElem$1;
                toProcess$1 = $as_sci_List($n(toProcess$1).tail__O());
              }
              var next$1 = $as_sci_List($n(firstMiss$1).tail__O());
              var nextToCopy$1 = next$1;
              while ((!$n(next$1).isEmpty__Z())) {
                var head$1 = $n(next$1).head__O();
                if (($uZ(f$3(head$1)) !== true)) {
                  next$1 = $as_sci_List($n(next$1).tail__O());
                } else {
                  while ((nextToCopy$1 !== next$1)) {
                    var newElem$2$1 = new $c_sci_$colon$colon($n(nextToCopy$1).head__O(), $m_sci_Nil$());
                    $n(currentLast$1).sci_$colon$colon__f_next = newElem$2$1;
                    currentLast$1 = newElem$2$1;
                    nextToCopy$1 = $as_sci_List($n(nextToCopy$1).tail__O());
                  }
                  nextToCopy$1 = $as_sci_List($n(next$1).tail__O());
                  next$1 = $as_sci_List($n(next$1).tail__O());
                }
              }
              if ((!$n(nextToCopy$1).isEmpty__Z())) {
                $n(currentLast$1).sci_$colon$colon__f_next = nextToCopy$1;
              }
              var result$1 = newHead$1;
              break block$2;
            }
          }
        }
      }
    }
    var this$8 = $n(result$1);
    var attributes$2 = $as_T($n($x_2).apply__O__O($f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "", " ", "")));
    var this$9 = $n($n(tag$2).Ltyrian_Tag__f_children);
    var f$4 = ((x$1$1) => {
      var x$1$2 = $as_Ltyrian_Elem(x$1$1);
      if ((x$1$2 === $m_Ltyrian_Empty$())) {
        return "";
      }
      if ((x$1$2 instanceof $c_Ltyrian_Text)) {
        var t$4 = $as_Ltyrian_Text(x$1$2);
        return $n(t$4).Ltyrian_Text__f_value;
      }
      if ($is_Ltyrian_Html(x$1$2)) {
        var h$4 = $as_Ltyrian_Html(x$1$2);
        return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Html__T(h$4);
      }
      throw new $c_s_MatchError(x$1$2);
    });
    if ((this$9 === $m_sci_Nil$())) {
      var this$10 = $m_sci_Nil$();
    } else {
      var x0$4 = this$9.head__O();
      var h$5 = new $c_sci_$colon$colon(f$4(x0$4), $m_sci_Nil$());
      var t$5 = h$5;
      var rest$2 = $as_sci_List(this$9.tail__O());
      while ((rest$2 !== $m_sci_Nil$())) {
        var x0$5 = $n(rest$2).head__O();
        var nx$2 = new $c_sci_$colon$colon(f$4(x0$5), $m_sci_Nil$());
        $n(t$5).sci_$colon$colon__f_next = nx$2;
        t$5 = nx$2;
        rest$2 = $as_sci_List($n(rest$2).tail__O());
      }
      var this$10 = h$5;
    }
    var children = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$10, "", "", "");
    return ((((((("<" + $n(tag$2).Ltyrian_Tag__f_name) + attributes$2) + ">") + children) + "</") + $n(tag$2).Ltyrian_Tag__f_name) + ">");
  }
  throw new $c_s_MatchError(html);
});
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Attr__T = (function(a) {
  if ((a instanceof $c_Ltyrian_Event)) {
    return "";
  }
  if ((a instanceof $c_Ltyrian_Attribute)) {
    var a$2 = $as_Ltyrian_Attribute(a);
    return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attribute__T(a$2);
  }
  if ($is_Ltyrian_Property(a)) {
    var p = $as_Ltyrian_Property(a);
    return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Property__T(p);
  }
  if (false) {
    var a$3 = $as_Ltyrian_NamedAttribute(a);
    return $n(a$3).name__T();
  }
  if ((a === $m_Ltyrian_EmptyAttribute$())) {
    return "";
  }
  throw new $c_s_MatchError(a);
});
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Attribute__T = (function(a) {
  return ((($n(a).Ltyrian_Attribute__f_name + "=\"") + $n(a).Ltyrian_Attribute__f_value) + "\"");
});
$c_Ltyrian_HTMLRendering$package$.prototype.render__Ltyrian_Property__T = (function(p) {
  matchResult5: {
    var asStr;
    var this$1 = $n(p);
    var x18 = this$1.Ltyrian_PropertyString__f_valueOf;
    if (((typeof x18) === "boolean")) {
      var x = $uZ(x18);
      var asStr = ("" + x);
      break matchResult5;
    }
    if ((x18 !== null)) {
      var asStr = x18;
      break matchResult5;
    }
    throw new $c_s_MatchError(x18);
  }
  return ((($n(p).Ltyrian_PropertyString__f_name + "=\"") + asStr) + "\"");
});
var $d_Ltyrian_HTMLRendering$package$ = new $TypeData().initClass($c_Ltyrian_HTMLRendering$package$, "tyrian.HTMLRendering$package$", ({
  Ltyrian_HTMLRendering$package$: 1
}));
var $n_Ltyrian_HTMLRendering$package$;
function $m_Ltyrian_HTMLRendering$package$() {
  if ((!$n_Ltyrian_HTMLRendering$package$)) {
    $n_Ltyrian_HTMLRendering$package$ = new $c_Ltyrian_HTMLRendering$package$();
  }
  return $n_Ltyrian_HTMLRendering$package$;
}
function $f_Ltyrian_HtmlAttributes__$init$__V($thiz) {
  $thiz.Ltyrian_Html$__f_id$minusString = new $c_Ltyrian_AttributeNameString("id");
  $thiz.Ltyrian_Html$__f_style$minusString = new $c_Ltyrian_AttributeNameString("style");
  $thiz.Ltyrian_Html$__f_value$minusString = new $c_Ltyrian_PropertyNameString("value");
}
function $f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Event($thiz, msg) {
  var msg$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => msg));
  return new $c_Ltyrian_Event("click", msg$1, true, true, true);
}
function $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html($thiz, attributes, plainText) {
  var attributes$1 = $n(attributes).toList__sci_List();
  var children = new $c_sci_$colon$colon(($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText)), $m_sci_Nil$());
  var key = $m_s_None$();
  return new $c_Ltyrian_Tag("button", attributes$1, children, key);
}
function $f_Ltyrian_HtmlTags__h1$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_sci_Nil$();
  var children = new $c_sci_$colon$colon(($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText)), $m_sci_Nil$());
  var key = $m_s_None$();
  return new $c_Ltyrian_Tag("h1", attributes, children, key);
}
function $f_Ltyrian_HtmlTags__h2$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_sci_Nil$();
  var children = new $c_sci_$colon$colon(($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText)), $m_sci_Nil$());
  var key = $m_s_None$();
  return new $c_Ltyrian_Tag("h2", attributes, children, key);
}
function $f_Ltyrian_HtmlTags__span$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html($thiz, attributes, plainText) {
  var attributes$1 = $n(attributes).toList__sci_List();
  var children = new $c_sci_$colon$colon(($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText)), $m_sci_Nil$());
  var key = $m_s_None$();
  return new $c_Ltyrian_Tag("span", attributes$1, children, key);
}
function $is_Ltyrian_Location(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Location)));
}
function $as_Ltyrian_Location(obj) {
  return (($is_Ltyrian_Location(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Location"));
}
function $isArrayOf_Ltyrian_Location(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Location)));
}
function $asArrayOf_Ltyrian_Location(obj, depth) {
  return (($isArrayOf_Ltyrian_Location(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Location;", depth));
}
function $f_Ltyrian_LocationPlatform__fromJsLocation__Lorg_scalajs_dom_Location__Ltyrian_Location$Internal($thiz, location) {
  var locationDetails = $m_Ltyrian_LocationDetails$().fromUrl__T__Ltyrian_LocationDetails($as_T(location.href));
  return new $c_Ltyrian_Location$Internal(locationDetails);
}
/** @constructor */
function $c_Ltyrian_PropertyNameString(name) {
  this.Ltyrian_PropertyNameString__f_name = null;
  this.Ltyrian_PropertyNameString__f_name = name;
}
$c_Ltyrian_PropertyNameString.prototype = new $h_O();
$c_Ltyrian_PropertyNameString.prototype.constructor = $c_Ltyrian_PropertyNameString;
/** @constructor */
function $h_Ltyrian_PropertyNameString() {
}
$h_Ltyrian_PropertyNameString.prototype = $c_Ltyrian_PropertyNameString.prototype;
$c_Ltyrian_PropertyNameString.prototype.$colon$eq__T__Ltyrian_PropertyString = (function(value) {
  var this$1 = $n(this.Ltyrian_PropertyNameString__f_name);
  return new $c_Ltyrian_PropertyString(this$1, value);
});
var $d_Ltyrian_PropertyNameString = new $TypeData().initClass($c_Ltyrian_PropertyNameString, "tyrian.PropertyNameString", ({
  Ltyrian_PropertyNameString: 1
}));
/** @constructor */
function $c_Ltyrian_Routing$() {
}
$c_Ltyrian_Routing$.prototype = new $h_O();
$c_Ltyrian_Routing$.prototype.constructor = $c_Ltyrian_Routing$;
/** @constructor */
function $h_Ltyrian_Routing$() {
}
$h_Ltyrian_Routing$.prototype = $c_Ltyrian_Routing$.prototype;
$c_Ltyrian_Routing$.prototype.none__O__F1 = (function(ignore) {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Ltyrian_Location(x$1);
    if ((x$1$1 instanceof $c_Ltyrian_Location$Internal)) {
      var x$1$2 = $as_Ltyrian_Location$Internal(x$1$1);
      $n(x$1$2);
      $as_Ltyrian_Location$Internal(x$1$1);
      return ignore;
    }
    if ((x$1$1 instanceof $c_Ltyrian_Location$External)) {
      var x$1$3 = $as_Ltyrian_Location$External(x$1$1);
      $n(x$1$3);
      $as_Ltyrian_Location$External(x$1$1);
      return ignore;
    }
    throw new $c_s_MatchError(x$1$1);
  }));
});
var $d_Ltyrian_Routing$ = new $TypeData().initClass($c_Ltyrian_Routing$, "tyrian.Routing$", ({
  Ltyrian_Routing$: 1
}));
var $n_Ltyrian_Routing$;
function $m_Ltyrian_Routing$() {
  if ((!$n_Ltyrian_Routing$)) {
    $n_Ltyrian_Routing$ = new $c_Ltyrian_Routing$();
  }
  return $n_Ltyrian_Routing$;
}
function $is_Ltyrian_Sub(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Sub)));
}
function $as_Ltyrian_Sub(obj) {
  return (($is_Ltyrian_Sub(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub"));
}
function $isArrayOf_Ltyrian_Sub(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub)));
}
function $asArrayOf_Ltyrian_Sub(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub;", depth));
}
var $d_Ltyrian_Sub = new $TypeData().initClass(1, "tyrian.Sub", ({
  Ltyrian_Sub: 1
}));
function $f_Ltyrian_TyrianApp__launch__T__V($thiz, containerId) {
  var this$1 = $m_sci_Map$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]));
  $p_Ltyrian_TyrianApp__runReadyOrError__T__sci_Map__V($thiz, containerId, this$1.from__sc_IterableOnce__sci_Map(elems));
}
function $f_Ltyrian_TyrianApp__launch__Lorg_scalajs_dom_Element__V($thiz, node) {
  var this$1 = $m_sci_Map$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]));
  var flags = this$1.from__sc_IterableOnce__sci_Map(elems);
  $f_Ltyrian_TyrianApp__ready__Lorg_scalajs_dom_Element__sci_Map__V($thiz, node, flags);
}
function $f_Ltyrian_TyrianApp__launch__T__sjs_js_Dictionary__V($thiz, containerId, flags) {
  var this$3 = new $c_sjs_js_WrappedDictionary(flags);
  $p_Ltyrian_TyrianApp__runReadyOrError__T__sci_Map__V($thiz, containerId, $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3));
}
function $f_Ltyrian_TyrianApp__launch__Lorg_scalajs_dom_Element__sjs_js_Dictionary__V($thiz, node, flags) {
  var this$3 = new $c_sjs_js_WrappedDictionary(flags);
  var flags$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3);
  $f_Ltyrian_TyrianApp__ready__Lorg_scalajs_dom_Element__sci_Map__V($thiz, node, flags$1);
}
function $p_Ltyrian_TyrianApp__routeCurrentLocation__F1__Lcats_effect_kernel_Async__Ltyrian_Cmd($thiz, router, evidence$1) {
  var task = $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var this$2 = $m_Ltyrian_Location$();
    var location = window.location;
    return $f_Ltyrian_LocationPlatform__fromJsLocation__Lorg_scalajs_dom_Location__Ltyrian_Location$Internal(this$2, location);
  })));
  return new $c_Ltyrian_Cmd$Run(task, router, evidence$1);
}
function $p_Ltyrian_TyrianApp___init__sci_Map__T2($thiz, flags) {
  matchResult1: {
    var \u03b41$___1;
    var \u03b41$___2;
    var x1 = $thiz.init__sci_Map__T2(flags);
    if ((x1 !== null)) {
      var m = $n(x1)._1__O();
      var cmd = $as_Ltyrian_Cmd($n(x1)._2__O());
      var \u03b41$___1 = m;
      var \u03b41$___2 = cmd;
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  var m$2 = \u03b41$___1;
  var cmd$2 = $as_Ltyrian_Cmd(\u03b41$___2);
  var this$2 = $n(cmd$2);
  var other = $p_Ltyrian_TyrianApp__routeCurrentLocation__F1__Lcats_effect_kernel_Async__Ltyrian_Cmd($thiz, $m_Ltyrian_Routing$().none__O__F1($s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__NoOp__Lnet_andimiller_hedgehogs_dag_visitor_Msg()), $thiz.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_tyrian$TyrianApp$$evidence$1);
  var _2 = $m_Ltyrian_Cmd$().merge__Ltyrian_Cmd__Ltyrian_Cmd__Ltyrian_Cmd(this$2, other);
  return new $c_T2(m$2, _2);
}
function $p_Ltyrian_TyrianApp___update__O__F1($thiz, model) {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((msg) => $as_T2($n($thiz.update__Lnet_andimiller_hedgehogs_dag_visitor_Model__F1($as_Lnet_andimiller_hedgehogs_dag_visitor_Model(model))).apply__O__O(msg))));
}
function $p_Ltyrian_TyrianApp__onUrlChange__F1__Lcats_effect_kernel_Async__Ltyrian_Sub($thiz, router, evidence$1) {
  var subs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Sub.getArrayOf().constr)([$m_Ltyrian_Sub$().fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub("DOMContentLoaded", window, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => $ps_Ltyrian_TyrianApp__makeMsg$1__F1__s_Option(router))), evidence$1), $m_Ltyrian_Sub$().fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub("popstate", window, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => $ps_Ltyrian_TyrianApp__makeMsg$1__F1__s_Option(router))), evidence$1)]));
  var this$2 = $n(subs);
  var subs$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2);
  return new $c_Ltyrian_Sub$Batch(subs$1);
}
function $p_Ltyrian_TyrianApp___subscriptions__O__Ltyrian_Sub($thiz, model) {
  var this$1 = $n($p_Ltyrian_TyrianApp__onUrlChange__F1__Lcats_effect_kernel_Async__Ltyrian_Sub($thiz, $m_Ltyrian_Routing$().none__O__F1($s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__NoOp__Lnet_andimiller_hedgehogs_dag_visitor_Msg()), $thiz.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_tyrian$TyrianApp$$evidence$1));
  var other = $thiz.subscriptions__Lnet_andimiller_hedgehogs_dag_visitor_Model__Ltyrian_Sub($as_Lnet_andimiller_hedgehogs_dag_visitor_Model(model));
  return $m_Ltyrian_Sub$().merge__Ltyrian_Sub__Ltyrian_Sub__Ltyrian_Sub(this$1, other);
}
function $f_Ltyrian_TyrianApp__ready__Lorg_scalajs_dom_Element__sci_Map__V($thiz, node, flags) {
  var $x_1 = $n($thiz.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_run);
  var router = $m_Ltyrian_Routing$().none__O__F1($s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__NoOp__Lnet_andimiller_hedgehogs_dag_visitor_Msg());
  var init = $p_Ltyrian_TyrianApp___init__sci_Map__T2($thiz, flags);
  var update = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((model) => $p_Ltyrian_TyrianApp___update__O__F1($thiz, model)));
  var view = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((model$2) => $thiz.view__Lnet_andimiller_hedgehogs_dag_visitor_Model__Ltyrian_Html($as_Lnet_andimiller_hedgehogs_dag_visitor_Model(model$2))));
  var subscriptions = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((model$3) => $p_Ltyrian_TyrianApp___subscriptions__O__Ltyrian_Sub($thiz, model$3)));
  var evidence$1 = $thiz.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_tyrian$TyrianApp$$evidence$1;
  $x_1.apply__O__O($m_Ltyrian_runtime_TyrianRuntime$().apply__F1__Lorg_scalajs_dom_Element__O__Ltyrian_Cmd__F1__F1__F1__Lcats_effect_kernel_Async__O(router, node, $n(init)._1__O(), $as_Ltyrian_Cmd($n(init)._2__O()), update, view, subscriptions, evidence$1));
}
function $p_Ltyrian_TyrianApp__runReadyOrError__T__sci_Map__V($thiz, containerId, flags) {
  var x4 = $m_s_Option$().apply__O__s_Option(document.getElementById(containerId));
  if ((x4 instanceof $c_s_Some)) {
    var e = $n($as_s_Some(x4)).s_Some__f_value;
    $f_Ltyrian_TyrianApp__ready__Lorg_scalajs_dom_Element__sci_Map__V($thiz, e, flags);
    return (void 0);
  }
  var x = $m_s_None$();
  if ((x === x4)) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Missing Element! Could not find an element with id '" + containerId) + "' on the page."));
  }
  throw new $c_s_MatchError(x4);
}
function $ps_Ltyrian_TyrianApp__makeMsg$1__F1__s_Option(router$1) {
  var $x_1 = $m_s_Option$();
  var this$1 = $m_Ltyrian_Location$();
  var location = window.location;
  return $x_1.apply__O__s_Option($n(router$1).apply__O__O($f_Ltyrian_LocationPlatform__fromJsLocation__Lorg_scalajs_dom_Location__Ltyrian_Location$Internal(this$1, location)));
}
function $p_Ltyrian_runtime_CmdHelper$__rec$1__scm_ListBuffer__Lcats_Applicative__sci_List__sci_List($thiz, acc$1, evidence$1$1, remaining) {
  var remaining$tailLocal1 = remaining;
  while (true) {
    var x12 = remaining$tailLocal1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x12)) {
      return $n(acc$1).toList__sci_List();
    }
    if ((x12 instanceof $c_sci_$colon$colon)) {
      var x13 = $as_sci_$colon$colon(x12);
      var x15 = $n(x13).sci_$colon$colon__f_next;
      var cmd = $as_Ltyrian_Cmd($n(x13).sci_$colon$colon__f_head);
      var x$3 = $m_Ltyrian_Cmd$None$();
      if ((x$3 === cmd)) {
        remaining$tailLocal1 = x15;
        continue;
      }
      if ((cmd instanceof $c_Ltyrian_Cmd$Emit)) {
        var c = $as_Ltyrian_Cmd$Emit(cmd);
        var this$2 = $n(acc$1);
        var elem = $n(evidence$1$1).map__O__F1__O($n(c).toTask__Lcats_Applicative__O(evidence$1$1), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$5) => $m_s_Option$().apply__O__s_Option(x$5))));
        this$2.addOne__O__scm_ListBuffer(elem);
        remaining$tailLocal1 = x15;
        continue;
      }
      if ((cmd instanceof $c_Ltyrian_Cmd$SideEffect)) {
        var c$2 = $as_Ltyrian_Cmd$SideEffect(cmd);
        var this$5 = $n(acc$1);
        var elem$1 = $n(evidence$1$1).map__O__F1__O($n(c$2).toTask__O(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
          $as_jl_Void(_$2);
          return $m_s_None$();
        })));
        this$5.addOne__O__scm_ListBuffer(elem$1);
        remaining$tailLocal1 = x15;
        continue;
      }
      if ((cmd instanceof $c_Ltyrian_Cmd$Run)) {
        var c$3 = $as_Ltyrian_Cmd$Run(cmd);
        var this$7 = $n(acc$1);
        var elem$2 = $n(evidence$1$1).map__O__F1__O($n(c$3).toTask__O(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$6) => $m_s_Option$().apply__O__s_Option(x$6))));
        this$7.addOne__O__scm_ListBuffer(elem$2);
        remaining$tailLocal1 = x15;
        continue;
      }
      if ((cmd instanceof $c_Ltyrian_Cmd$Combine)) {
        var x$1 = $as_Ltyrian_Cmd$Combine(cmd);
        var this$9 = $n(x$1);
        var x7 = this$9.Ltyrian_Cmd$Combine__f_cmd1;
        var this$10 = $n(x$1);
        var x8 = this$10.Ltyrian_Cmd$Combine__f_cmd2;
        var this$11 = $n(x15);
        var this$12 = new $c_sci_$colon$colon(x8, this$11);
        remaining$tailLocal1 = new $c_sci_$colon$colon(x7, this$12);
        continue;
      }
      if ((cmd instanceof $c_Ltyrian_Cmd$Batch)) {
        var x$1$1 = $as_Ltyrian_Cmd$Batch(cmd);
        var this$14 = $n(x$1$1);
        var x4 = this$14.Ltyrian_Cmd$Batch__f_cmds;
        var this$15 = $n(x4);
        remaining$tailLocal1 = this$15.appendedAll__sc_IterableOnce__sci_List(x15);
        continue;
      }
      throw new $c_s_MatchError(cmd);
    }
    throw new $c_s_MatchError(x12);
  }
}
/** @constructor */
function $c_Ltyrian_runtime_CmdHelper$() {
}
$c_Ltyrian_runtime_CmdHelper$.prototype = new $h_O();
$c_Ltyrian_runtime_CmdHelper$.prototype.constructor = $c_Ltyrian_runtime_CmdHelper$;
/** @constructor */
function $h_Ltyrian_runtime_CmdHelper$() {
}
$h_Ltyrian_runtime_CmdHelper$.prototype = $c_Ltyrian_runtime_CmdHelper$.prototype;
$c_Ltyrian_runtime_CmdHelper$.prototype.cmdToTaskList__Ltyrian_Cmd__Lcats_Applicative__sci_List = (function(cmd, evidence$1) {
  var acc = new $c_scm_ListBuffer();
  return $p_Ltyrian_runtime_CmdHelper$__rec$1__scm_ListBuffer__Lcats_Applicative__sci_List__sci_List(this, acc, evidence$1, new $c_sci_$colon$colon(cmd, $m_sci_Nil$()));
});
var $d_Ltyrian_runtime_CmdHelper$ = new $TypeData().initClass($c_Ltyrian_runtime_CmdHelper$, "tyrian.runtime.CmdHelper$", ({
  Ltyrian_runtime_CmdHelper$: 1
}));
var $n_Ltyrian_runtime_CmdHelper$;
function $m_Ltyrian_runtime_CmdHelper$() {
  if ((!$n_Ltyrian_runtime_CmdHelper$)) {
    $n_Ltyrian_runtime_CmdHelper$ = new $c_Ltyrian_runtime_CmdHelper$();
  }
  return $n_Ltyrian_runtime_CmdHelper$;
}
function $p_Ltyrian_runtime_Rendering$__buildNodeData__sci_List__F1__s_Option__Lsnabbdom_VNodeData($thiz, attrs, onMsg, key) {
  var as = $n(attrs).collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$1());
  var props = $n(attrs).collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$2());
  var events = $n(attrs).collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$3(onMsg));
  var this$2 = $n(props);
  var props$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$2);
  var this$4 = $n(as);
  var attrs$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$4);
  var this$6 = $n(events);
  var on$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$6);
  var this$7 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var classes$1 = this$7.Lsnabbdom_VNodeData__f_classes;
  var this$8 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var style$1 = this$8.Lsnabbdom_VNodeData__f_style;
  var this$9 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var dataset$1 = this$9.Lsnabbdom_VNodeData__f_dataset;
  var this$10 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var hook$1 = this$10.Lsnabbdom_VNodeData__f_hook;
  var this$11 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var ns$1 = this$11.Lsnabbdom_VNodeData__f_ns;
  var this$12 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var fn$1 = this$12.Lsnabbdom_VNodeData__f_fn;
  var this$13 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var args$1 = this$13.Lsnabbdom_VNodeData__f_args;
  var this$14 = $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  var is$1 = this$14.Lsnabbdom_VNodeData__f_is;
  $n($m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty);
  return new $c_Lsnabbdom_VNodeData(props$1, attrs$1, classes$1, style$1, dataset$1, on$1, hook$1, key, ns$1, fn$1, args$1, is$1);
}
function $p_Ltyrian_runtime_Rendering$__interceptHref__sci_List__Z($thiz, attrs) {
  var this$1 = $n(attrs);
  _return: {
    var these = this$1;
    while ((!$n(these).isEmpty__Z())) {
      var x0 = $n(these).head__O();
      var x$1 = $as_Ltyrian_Attr(x0);
      matchResult7: {
        var $x_1;
        if ((x$1 instanceof $c_Ltyrian_Attribute)) {
          $m_Ltyrian_Attribute$();
          var x$1$1 = $as_Ltyrian_Attribute(x$1);
          var this$3 = $n(x$1$1);
          var x54 = this$3.Ltyrian_Attribute__f_name;
          $n(x$1$1);
          if ((x54 === "href")) {
            var $x_1 = true;
            break matchResult7;
          }
        }
        var $x_1 = false;
      }
      if ($x_1) {
        var href = true;
        break _return;
      }
      these = $as_sci_List($n(these).tail__O());
    }
    var href = false;
  }
  var this$5 = $n(attrs);
  _return$1: {
    var these$1 = this$5;
    while ((!$n(these$1).isEmpty__Z())) {
      var x0$1 = $n(these$1).head__O();
      var x$1$2 = $as_Ltyrian_Attr(x0$1);
      matchResult8: {
        var $x_2;
        if ((x$1$2 instanceof $c_Ltyrian_Event)) {
          var x$1$3 = $as_Ltyrian_Event(x$1$2);
          var this$7 = $n(x$1$3);
          var x59 = this$7.Ltyrian_Event__f_name;
          $n(x$1$3);
          $n(x$1$3);
          $n(x$1$3);
          $n(x$1$3);
          if ((x59 === "click")) {
            var $x_2 = true;
            break matchResult8;
          }
        }
        var $x_2 = false;
      }
      if ($x_2) {
        var onClick = true;
        break _return$1;
      }
      these$1 = $as_sci_List($n(these$1).tail__O());
    }
    var onClick = false;
  }
  return (href && (!onClick));
}
function $p_Ltyrian_runtime_Rendering$__onClickPreventDefault__sci_List__F1__F1__T2($thiz, attrs, onMsg, router) {
  var newLocation = $n($n(attrs).collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$4())).headOption__s_Option();
  var callback = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => {
    e.preventDefault();
    matchResult11: {
      var x = $m_s_None$();
      if ((x === newLocation)) {
        break matchResult11;
      }
      if ((newLocation instanceof $c_s_Some)) {
        var loc = $as_T($n($as_s_Some(newLocation)).s_Some__f_value);
        var this$1 = $m_Ltyrian_Location$();
        var location = window.location;
        var jsLoc = $f_Ltyrian_LocationPlatform__fromJsLocation__Lorg_scalajs_dom_Location__Ltyrian_Location$Internal(this$1, location);
        var locationToRoute = $m_Ltyrian_Location$().fromUrl__T__Ltyrian_Location$Internal__Ltyrian_Location(loc, jsLoc);
        if ($n(locationToRoute).isInternal__Z()) {
          window.history.pushState(({}), "", loc);
        }
        $n(onMsg).apply__O__O($n(router).apply__O__O(locationToRoute));
        break matchResult11;
      }
      throw new $c_s_MatchError(newLocation);
    }
  }));
  var y = $m_Lsnabbdom_EventHandler$().apply__sci_Seq__Lsnabbdom_EventHandler($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([callback])));
  return new $c_T2("click", y);
}
function $p_Ltyrian_runtime_Rendering$__patch__Lsnabbdom_Patch($thiz) {
  if ((!$thiz.Ltyrian_runtime_Rendering$__f_patchbitmap$1)) {
    $thiz.Ltyrian_runtime_Rendering$__f_patch$lzy1 = $m_Lsnabbdom_init$().apply__sci_Seq__s_Option__Lsnabbdom_Patch(new $c_sci_$colon$colon($m_Lsnabbdom_modules_Attributes$().Lsnabbdom_modules_Attributes$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_Classes$().Lsnabbdom_modules_Classes$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_Props$().Lsnabbdom_modules_Props$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_Styles$().Lsnabbdom_modules_Styles$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_EventListeners$().Lsnabbdom_modules_EventListeners$__f_module, new $c_sci_$colon$colon($m_Lsnabbdom_modules_Dataset$().Lsnabbdom_modules_Dataset$__f_module, $m_sci_Nil$())))))), $m_s_None$());
    $thiz.Ltyrian_runtime_Rendering$__f_patchbitmap$1 = true;
  }
  return $thiz.Ltyrian_runtime_Rendering$__f_patch$lzy1;
}
/** @constructor */
function $c_Ltyrian_runtime_Rendering$() {
  this.Ltyrian_runtime_Rendering$__f_patch$lzy1 = null;
  this.Ltyrian_runtime_Rendering$__f_patchbitmap$1 = false;
}
$c_Ltyrian_runtime_Rendering$.prototype = new $h_O();
$c_Ltyrian_runtime_Rendering$.prototype.constructor = $c_Ltyrian_runtime_Rendering$;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$() {
}
$h_Ltyrian_runtime_Rendering$.prototype = $c_Ltyrian_runtime_Rendering$.prototype;
$c_Ltyrian_runtime_Rendering$.prototype.toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode = (function(html, onMsg, router) {
  if ((html instanceof $c_Ltyrian_RawTag)) {
    var x$1 = $as_Ltyrian_RawTag(html);
    var this$2 = $n(x$1);
    var x102 = this$2.Ltyrian_RawTag__f_name;
    var this$3 = $n(x$1);
    var x103 = this$3.Ltyrian_RawTag__f_attributes;
    var this$4 = $n(x$1);
    var x104 = this$4.Ltyrian_RawTag__f_innerHTML;
    var this$5 = $n(x$1);
    var x105 = this$5.Ltyrian_RawTag__f_key;
    var data = $p_Ltyrian_runtime_Rendering$__buildNodeData__sci_List__F1__s_Option__Lsnabbdom_VNodeData(this, x103, onMsg, x105);
    var elm = document.createElement(x102);
    elm.innerHTML = x104;
    var x77 = $m_Lsnabbdom_toVNode$().apply__Lorg_scalajs_dom_Node__s_Option__Lsnabbdom_PatchedVNode(elm, $m_s_None$());
    if ((x77 instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
      var e = $as_Lsnabbdom_PatchedVNode$Element(x77);
      $n(e);
      var this$7 = $n(e);
      var sel = this$7.Lsnabbdom_PatchedVNode$Element__f_sel;
      var this$8 = $n(e);
      var children = this$8.Lsnabbdom_PatchedVNode$Element__f_children;
      var this$9 = $n(e);
      var node = this$9.Lsnabbdom_PatchedVNode$Element__f_node;
      return new $c_Lsnabbdom_PatchedVNode$Element(sel, data, children, node).toVNode__Lsnabbdom_VNode();
    }
    return $n(x77).toVNode__Lsnabbdom_VNode();
  }
  if ((html instanceof $c_Ltyrian_Tag)) {
    var x$1$1 = $as_Ltyrian_Tag(html);
    var this$12 = $n(x$1$1);
    var x96 = this$12.Ltyrian_Tag__f_name;
    var this$13 = $n(x$1$1);
    var x97 = this$13.Ltyrian_Tag__f_attributes;
    var this$14 = $n(x$1$1);
    var x98 = this$14.Ltyrian_Tag__f_children;
    var this$15 = $n(x$1$1);
    var x99 = this$15.Ltyrian_Tag__f_key;
    if ((x96 === "a")) {
      if ($p_Ltyrian_runtime_Rendering$__interceptHref__sci_List__Z(this, x97)) {
        var data$2 = $p_Ltyrian_runtime_Rendering$__buildNodeData__sci_List__F1__s_Option__Lsnabbdom_VNodeData(this, x97, onMsg, x99);
        var this$18 = $n(x98);
        var f = ((x$1$2) => {
          var x$1$3 = $as_Ltyrian_Elem(x$1$2);
          if ((x$1$3 === $m_Ltyrian_Empty$())) {
            return $m_Lsnabbdom_VNode$().Lsnabbdom_VNode$__f_empty;
          }
          if ((x$1$3 instanceof $c_Ltyrian_Text)) {
            var t = $as_Ltyrian_Text(x$1$3);
            $m_Lsnabbdom_VNode$();
            var content = $n(t).Ltyrian_Text__f_value;
            return new $c_Lsnabbdom_VNode$Text(content);
          }
          if ($is_Ltyrian_Html(x$1$3)) {
            var subHtml = $as_Ltyrian_Html(x$1$3);
            return $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode(subHtml, onMsg, router);
          }
          throw new $c_s_MatchError(x$1$3);
        });
        if ((this$18 === $m_sci_Nil$())) {
          var childrenElem = $m_sci_Nil$();
        } else {
          var x0 = this$18.head__O();
          var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
          var t$1 = h;
          var rest = $as_sci_List(this$18.tail__O());
          while ((rest !== $m_sci_Nil$())) {
            var x0$1 = $n(rest).head__O();
            var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
            $n(t$1).sci_$colon$colon__f_next = nx;
            t$1 = nx;
            rest = $as_sci_List($n(rest).tail__O());
          }
          var childrenElem = h;
        }
        var $x_1 = $m_Lsnabbdom_h$();
        var this$19 = $n($n(data$2).Lsnabbdom_VNodeData__f_on);
        var kv = $p_Ltyrian_runtime_Rendering$__onClickPreventDefault__sci_List__F1__F1__T2(this, x97, onMsg, router);
        var on$2 = $as_sci_Map(this$19.updated__O__O__sci_MapOps($n(kv)._1__O(), $n(kv)._2__O()));
        var this$20 = $n(data$2);
        var props$2 = this$20.Lsnabbdom_VNodeData__f_props;
        var this$21 = $n(data$2);
        var attrs$2$2 = this$21.Lsnabbdom_VNodeData__f_attrs;
        var this$22 = $n(data$2);
        var classes$2 = this$22.Lsnabbdom_VNodeData__f_classes;
        var this$23 = $n(data$2);
        var style$2 = this$23.Lsnabbdom_VNodeData__f_style;
        var this$24 = $n(data$2);
        var dataset$2 = this$24.Lsnabbdom_VNodeData__f_dataset;
        var this$25 = $n(data$2);
        var hook$2 = this$25.Lsnabbdom_VNodeData__f_hook;
        var this$26 = $n(data$2);
        var key$1 = this$26.Lsnabbdom_VNodeData__f_key;
        var this$27 = $n(data$2);
        var ns$2 = this$27.Lsnabbdom_VNodeData__f_ns;
        var this$28 = $n(data$2);
        var fn$2 = this$28.Lsnabbdom_VNodeData__f_fn;
        var this$29 = $n(data$2);
        var args$2 = this$29.Lsnabbdom_VNodeData__f_args;
        var this$30 = $n(data$2);
        var is$2 = this$30.Lsnabbdom_VNodeData__f_is;
        $n(data$2);
        return $x_1.apply__T__Lsnabbdom_VNodeData__sci_List__Lsnabbdom_VNode$Element("a", new $c_Lsnabbdom_VNodeData(props$2, attrs$2$2, classes$2, style$2, dataset$2, on$2, hook$2, key$1, ns$2, fn$2, args$2, is$2), childrenElem);
      }
    }
    var data$3 = $p_Ltyrian_runtime_Rendering$__buildNodeData__sci_List__F1__s_Option__Lsnabbdom_VNodeData(this, x97, onMsg, x99);
    var this$34 = $n(x98);
    var f$1 = ((x$1$2$1) => {
      var x$1$4 = $as_Ltyrian_Elem(x$1$2$1);
      if ((x$1$4 === $m_Ltyrian_Empty$())) {
        return $m_Lsnabbdom_VNode$().Lsnabbdom_VNode$__f_empty;
      }
      if ((x$1$4 instanceof $c_Ltyrian_Text)) {
        var t$2 = $as_Ltyrian_Text(x$1$4);
        $m_Lsnabbdom_VNode$();
        var content$1 = $n(t$2).Ltyrian_Text__f_value;
        return new $c_Lsnabbdom_VNode$Text(content$1);
      }
      if ($is_Ltyrian_Html(x$1$4)) {
        var subHtml$1 = $as_Ltyrian_Html(x$1$4);
        return $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode(subHtml$1, onMsg, router);
      }
      throw new $c_s_MatchError(x$1$4);
    });
    if ((this$34 === $m_sci_Nil$())) {
      var childrenElem$2 = $m_sci_Nil$();
    } else {
      var x0$2 = this$34.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
      var t$3 = h$1;
      var rest$1 = $as_sci_List(this$34.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = $n(rest$1).head__O();
        var nx$1 = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
        $n(t$3).sci_$colon$colon__f_next = nx$1;
        t$3 = nx$1;
        rest$1 = $as_sci_List($n(rest$1).tail__O());
      }
      var childrenElem$2 = h$1;
    }
    return $m_Lsnabbdom_h$().apply__T__Lsnabbdom_VNodeData__sci_List__Lsnabbdom_VNode$Element(x96, data$3, childrenElem$2);
  }
  throw new $c_s_MatchError(html);
});
$c_Ltyrian_runtime_Rendering$.prototype.render__O__O__F1__F1__F1__Lsnabbdom_PatchedVNode = (function(oldNode, model, view, onMsg, router) {
  if ($uZ((oldNode instanceof Element))) {
    return $n($p_Ltyrian_runtime_Rendering$__patch__Lsnabbdom_Patch(this)).apply__Lorg_scalajs_dom_Element__Lsnabbdom_VNode__Lsnabbdom_PatchedVNode(oldNode, $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode($as_Ltyrian_Html($n(view).apply__O__O(model)), onMsg, router));
  }
  if ($is_Lsnabbdom_PatchedVNode(oldNode)) {
    var vn = $as_Lsnabbdom_PatchedVNode(oldNode);
    return $n($p_Ltyrian_runtime_Rendering$__patch__Lsnabbdom_Patch(this)).apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Lsnabbdom_PatchedVNode(vn, $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__F1__Lsnabbdom_VNode($as_Ltyrian_Html($n(view).apply__O__O(model)), onMsg, router));
  }
  throw new $c_s_MatchError(oldNode);
});
var $d_Ltyrian_runtime_Rendering$ = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$, "tyrian.runtime.Rendering$", ({
  Ltyrian_runtime_Rendering$: 1
}));
var $n_Ltyrian_runtime_Rendering$;
function $m_Ltyrian_runtime_Rendering$() {
  if ((!$n_Ltyrian_runtime_Rendering$)) {
    $n_Ltyrian_runtime_Rendering$ = new $c_Ltyrian_runtime_Rendering$();
  }
  return $n_Ltyrian_runtime_Rendering$;
}
function $p_Ltyrian_runtime_SubHelper$__rec$1__sci_List__sci_List__sci_List($thiz, remaining, acc) {
  var acc$tailLocal1 = acc;
  var remaining$tailLocal1 = remaining;
  while (true) {
    var x1 = remaining$tailLocal1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x1)) {
      return acc$tailLocal1;
    }
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x19 = $as_sci_$colon$colon(x1);
      var x20 = $as_Ltyrian_Sub($n(x19).sci_$colon$colon__f_head);
      var x21 = $n(x19).sci_$colon$colon__f_next;
      var x$3 = $m_Ltyrian_Sub$None$();
      if ((x$3 === x20)) {
        remaining$tailLocal1 = x21;
        continue;
      }
      if ((x20 instanceof $c_Ltyrian_Sub$Combine)) {
        var x$1 = $as_Ltyrian_Sub$Combine(x20);
        var this$2 = $n(x$1);
        var x17 = this$2.Ltyrian_Sub$Combine__f_sub1;
        var this$3 = $n(x$1);
        var x18 = this$3.Ltyrian_Sub$Combine__f_sub2;
        var this$4 = $n(x21);
        var this$5 = new $c_sci_$colon$colon(x18, this$4);
        remaining$tailLocal1 = new $c_sci_$colon$colon(x17, this$5);
        continue;
      }
      if ((x20 instanceof $c_Ltyrian_Sub$Batch)) {
        var x$1$1 = $as_Ltyrian_Sub$Batch(x20);
        var this$7 = $n(x$1$1);
        var x11 = this$7.Ltyrian_Sub$Batch__f_subs;
        var this$8 = $n(x11);
        remaining$tailLocal1 = this$8.appendedAll__sc_IterableOnce__sci_List(x21);
        continue;
      }
      if ((x20 instanceof $c_Ltyrian_Sub$Observe)) {
        var s = $as_Ltyrian_Sub$Observe(x20);
        var this$9 = $n(acc$tailLocal1);
        var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon(s, this$9);
        remaining$tailLocal1 = x21;
        acc$tailLocal1 = acc$tailLocal1$tmp1;
        continue;
      }
    }
    throw new $c_s_MatchError(x1);
  }
}
/** @constructor */
function $c_Ltyrian_runtime_SubHelper$() {
}
$c_Ltyrian_runtime_SubHelper$.prototype = new $h_O();
$c_Ltyrian_runtime_SubHelper$.prototype.constructor = $c_Ltyrian_runtime_SubHelper$;
/** @constructor */
function $h_Ltyrian_runtime_SubHelper$() {
}
$h_Ltyrian_runtime_SubHelper$.prototype = $c_Ltyrian_runtime_SubHelper$.prototype;
$c_Ltyrian_runtime_SubHelper$.prototype.flatten__Ltyrian_Sub__sci_List = (function(sub) {
  return $p_Ltyrian_runtime_SubHelper$__rec$1__sci_List__sci_List__sci_List(this, new $c_sci_$colon$colon(sub, $m_sci_Nil$()), $m_sci_Nil$());
});
$c_Ltyrian_runtime_SubHelper$.prototype.aliveAndDead__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__T2 = (function(subs, current, evidence$1) {
  matchResult3: {
    var \u03b41$___1;
    var \u03b41$___2;
    var this$1 = $n(current);
    if (this$1.isEmpty__Z()) {
      var x25 = $m_sci_List$().sci_List$__f_scala$collection$immutable$List$$TupleOfNil;
    } else {
      var l = new $c_scm_ListBuffer();
      var r = new $c_scm_ListBuffer();
      var this$4 = $n(this$1.iterator__sc_Iterator());
      while (this$4.hasNext__Z()) {
        var x0 = this$4.next__O();
        var x$1 = $as_T2(x0);
        matchResult2: {
          var $x_1;
          if ((x$1 !== null)) {
            var id = $as_T($n(x$1)._1__O());
            var this$5 = $n(subs);
            var these = this$5;
            while ((!$n(these).isEmpty__Z())) {
              var x0$1 = $n(these).head__O();
              var _$3 = $as_Ltyrian_Sub$Observe(x0$1);
              if (($n(_$3).Ltyrian_Sub$Observe__f_id === id)) {
                var $x_1 = true;
                break matchResult2;
              }
              these = $as_sci_List($n(these).tail__O());
            }
            var $x_1 = false;
            break matchResult2;
          }
          throw new $c_s_MatchError(x$1);
        }
        if ($x_1) {
          var this$6 = l;
        } else {
          var this$6 = r;
        }
        this$6.addOne__O__scm_ListBuffer(x0);
      }
      var x1 = new $c_T2(l.toList__sci_List(), r.toList__sci_List());
      matchEnd7$1: {
        var x25;
        var p2 = $as_sci_List(x1.T2__f__1);
        var x = $m_sci_Nil$();
        if (x.equals__O__Z(p2)) {
          var x25 = new $c_T2($m_sci_Nil$(), this$1);
          break matchEnd7$1;
        }
        var p4 = $as_sci_List(x1.T2__f__2);
        var x$3 = $m_sci_Nil$();
        if (x$3.equals__O__Z(p4)) {
          var x25 = new $c_T2(this$1, $m_sci_Nil$());
          break matchEnd7$1;
        }
        var x25 = x1;
      }
    }
    if ((x25 !== null)) {
      var a = $as_sci_List($n(x25)._1__O());
      var d = $as_sci_List($n(x25)._2__O());
      var \u03b41$___1 = a;
      var \u03b41$___2 = d;
      break matchResult3;
    }
    throw new $c_s_MatchError(x25);
  }
  var a$2 = $as_sci_List(\u03b41$___1);
  var d$2 = $as_sci_List(\u03b41$___2);
  var this$8 = $n(d$2);
  var f = ((_$4) => {
    var _$4$1 = $as_T2(_$4);
    return $n(_$4$1)._2__O();
  });
  if ((this$8 === $m_sci_Nil$())) {
    var _2 = $m_sci_Nil$();
  } else {
    var x0$2 = this$8.head__O();
    var h = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$8.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var x0$3 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var _2 = h;
  }
  return new $c_T2(a$2, _2);
});
$c_Ltyrian_runtime_SubHelper$.prototype.findNewSubs__sci_List__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__sci_List = (function(subs, alive, inProgress, evidence$1) {
  var this$2 = $n(subs);
  var f = ((s) => {
    var s$1 = $as_Ltyrian_Sub$Observe(s);
    var this$1 = $n(alive);
    _return: {
      var these = this$1;
      while ((!$n(these).isEmpty__Z())) {
        var x0 = $n(these).head__O();
        var _$6 = $as_T(x0);
        if ((!(_$6 !== $n(s$1).Ltyrian_Sub$Observe__f_id))) {
          var $x_1 = false;
          break _return;
        }
        these = $as_sci_List($n(these).tail__O());
      }
      var $x_1 = true;
    }
    if ($x_1) {
      return (!$n(inProgress).contains__O__Z($n(s$1).Ltyrian_Sub$Observe__f_id));
    } else {
      return false;
    }
  });
  var l = this$2;
  block: {
    var result;
    while (true) {
      if ($n(l).isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = $n(l).head__O();
        var t = $as_sci_List($n(l).tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if ($n(remaining).isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = $n(remaining).head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List($n(remaining).tail__O());
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List($n(start).tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
              $n(currentLast).sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List($n(toProcess).tail__O());
            }
            var next = $as_sci_List($n(firstMiss).tail__O());
            var nextToCopy = next;
            while ((!$n(next).isEmpty__Z())) {
              var head = $n(next).head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List($n(next).tail__O());
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                }
                nextToCopy = $as_sci_List($n(next).tail__O());
                next = $as_sci_List($n(next).tail__O());
              }
            }
            if ((!$n(nextToCopy).isEmpty__Z())) {
              $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  return result;
});
$c_Ltyrian_runtime_SubHelper$.prototype.runObserve__Ltyrian_Sub$Observe__F1__Lcats_effect_kernel_GenConcurrent__O = (function(sub, callback, F) {
  var this$5 = $m_Lcats_effect_syntax_package$all$();
  var wrapped = $n($m_Lcats_effect_kernel_Resource$().makeFull__F1__F1__Lcats_Functor__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var $x_3 = $n(poll$1);
    var target = $n(sub).Ltyrian_Sub$Observe__f_observable;
    var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((run) => {
      var run$1 = $as_F1(run);
      return $n(run$1).apply__O__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((result) => {
        var result$1 = $as_s_util_Either(result);
        var $x_2 = $n(callback);
        var this$2 = $n(result$1);
        if ((this$2 instanceof $c_s_util_Right)) {
          var x2 = $as_s_util_Right(this$2);
          var b = $n(x2).s_util_Right__f_value;
          var $x_1 = new $c_s_util_Right($as_s_Option($n($n(sub).Ltyrian_Sub$Observe__f_toMsg).apply__O__O(b)));
        } else {
          var $x_1 = this$2;
        }
        $x_2.apply__O__O($x_1);
      })));
    }));
    return $x_3.apply__O__O($n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f));
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$9) => {
    var _$9$1 = $as_s_Option(_$9);
    var this$4 = $n(_$9$1);
    return (this$4.isEmpty__Z() ? $n(F).unit__O() : this$4.get__O());
  })), F)).useForever__Lcats_effect_kernel_GenSpawn__O(F);
  var ev$1 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$5, wrapped, F);
  var target$1 = $n(F).start__O__O(ev$1);
  var this$8 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
    var _$10$1 = $as_Lcats_effect_kernel_Fiber(_$10);
    return $n(_$10$1).cancel__O();
  }));
  var target$2 = $n(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  var this$10 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
  var b$1 = $n(sub).Ltyrian_Sub$Observe__f_id;
  return $f_Lcats_Functor__tupleLeft__O__O__O($n(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance), this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
});
var $d_Ltyrian_runtime_SubHelper$ = new $TypeData().initClass($c_Ltyrian_runtime_SubHelper$, "tyrian.runtime.SubHelper$", ({
  Ltyrian_runtime_SubHelper$: 1
}));
var $n_Ltyrian_runtime_SubHelper$;
function $m_Ltyrian_runtime_SubHelper$() {
  if ((!$n_Ltyrian_runtime_SubHelper$)) {
    $n_Ltyrian_runtime_SubHelper$ = new $c_Ltyrian_runtime_SubHelper$();
  }
  return $n_Ltyrian_runtime_SubHelper$;
}
/** @constructor */
function $c_Ltyrian_runtime_TyrianRuntime$() {
}
$c_Ltyrian_runtime_TyrianRuntime$.prototype = new $h_O();
$c_Ltyrian_runtime_TyrianRuntime$.prototype.constructor = $c_Ltyrian_runtime_TyrianRuntime$;
/** @constructor */
function $h_Ltyrian_runtime_TyrianRuntime$() {
}
$h_Ltyrian_runtime_TyrianRuntime$.prototype = $c_Ltyrian_runtime_TyrianRuntime$.prototype;
$c_Ltyrian_runtime_TyrianRuntime$.prototype.apply__F1__Lorg_scalajs_dom_Element__O__Ltyrian_Cmd__F1__F1__F1__Lcats_effect_kernel_Async__O = (function(router, node, initModel, initCmd, update, view, subscriptions, F) {
  var this$1 = $m_Lcats_effect_std_Dispatcher$();
  return $n($p_Lcats_effect_std_Dispatcher$__impl__Z__Z__Z__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(this$1, false, false, false, F)).use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((dispatcher) => {
    var dispatcher$1 = $as_Lcats_effect_std_Dispatcher(dispatcher);
    var loop = new $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c(((model, currentSubs, msgQueue, renderer) => {
      var model$1 = $as_Lcats_effect_kernel_Ref(model);
      var currentSubs$1 = $as_Lcats_effect_std_AtomicCell(currentSubs);
      var msgQueue$1 = $as_Lcats_effect_std_Queue(msgQueue);
      var renderer$1 = $as_Lcats_effect_kernel_Ref(renderer);
      return $m_Ltyrian_runtime_TyrianRuntime$().mainLoop__Lcats_effect_std_Dispatcher__F1__Ltyrian_Cmd__F1__F1__F1__Lcats_effect_kernel_Ref__Lcats_effect_std_AtomicCell__Lcats_effect_std_Queue__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__O(dispatcher$1, router, initCmd, update, view, subscriptions, model$1, currentSubs$1, msgQueue$1, renderer$1, F, F);
    }));
    var model$2 = $n(F).ref__O__O(initModel);
    var currentSubs$2 = $m_Lcats_effect_std_AtomicCell$ApplyPartiallyApplied$().of$extension__Z__O__Lcats_effect_kernel_GenConcurrent__O(true, $m_sci_Nil$(), F);
    var msgQueue$2 = $m_Lcats_effect_std_Queue$().unbounded__Lcats_effect_kernel_GenConcurrent__O(F);
    var renderer$2 = $m_Ltyrian_runtime_Renderer$().init__Lsnabbdom_PatchedVNode__Lcats_effect_kernel_Async__O($m_Lsnabbdom_toVNode$().apply__Lorg_scalajs_dom_Node__s_Option__Lsnabbdom_PatchedVNode(node, $m_s_None$()), F);
    var t = new $c_T4(model$2, currentSubs$2, msgQueue$2, renderer$2);
    return new $c_Lcats_syntax_Tuple4SemigroupalOps(t).flatMapN__F4__Lcats_FlatMap__O(loop, F);
  })), F);
});
$c_Ltyrian_runtime_TyrianRuntime$.prototype.mainLoop__Lcats_effect_std_Dispatcher__F1__Ltyrian_Cmd__F1__F1__F1__Lcats_effect_kernel_Ref__Lcats_effect_std_AtomicCell__Lcats_effect_std_Queue__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__O = (function(dispatcher, router, initCmd, update, view, subscriptions, model, currentSubs, msgQueue, renderer, F, clock) {
  var runCmd = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cmd) => {
    var cmd$1 = $as_Ltyrian_Cmd(cmd);
    return $m_Ltyrian_runtime_TyrianRuntime$().runCommands__Lcats_effect_std_Queue__Ltyrian_Cmd__Lcats_effect_kernel_Async__O(msgQueue, cmd$1, F);
  }));
  var runSub = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((sub) => {
    var sub$1 = $as_Ltyrian_Sub(sub);
    return $m_Ltyrian_runtime_TyrianRuntime$().runSubscriptions__Lcats_effect_std_AtomicCell__Lcats_effect_std_Queue__Lcats_effect_std_Dispatcher__Ltyrian_Sub__Lcats_effect_kernel_Async__O(currentSubs, msgQueue, dispatcher, sub$1, F);
  }));
  var onMsg = this.postMsg__Lcats_effect_std_Dispatcher__Lcats_effect_std_Queue__F1(dispatcher, msgQueue);
  var target = $n(msgQueue).take__O();
  var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((msg) => {
    var target$1 = $n(model).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oldModel) => {
      matchResult1: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x1 = $as_T2($n($as_F1($n(update).apply__O__O(oldModel))).apply__O__O(msg));
        if ((x1 !== null)) {
          var newModel = $n(x1)._1__O();
          var cmd$2 = $as_Ltyrian_Cmd($n(x1)._2__O());
          var \u03b41$___1 = newModel;
          var \u03b41$___2 = cmd$2;
          break matchResult1;
        }
        throw new $c_s_MatchError(x1);
      }
      var newModel$2 = \u03b41$___1;
      var cmd$2$1 = $as_Ltyrian_Cmd(\u03b41$___2);
      var sub$2 = $as_Ltyrian_Sub($n(subscriptions).apply__O__O(newModel$2));
      var _2 = new $c_T2(cmd$2$1, sub$2);
      return new $c_T2(newModel$2, _2);
    })));
    var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F);
    var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cmdsAndSubs) => {
      var cmdsAndSubs$1 = $as_T2(cmdsAndSubs);
      var fa = runCmd.apply__O__O($n(cmdsAndSubs$1)._1__O());
      var fb = runSub.apply__O__O($n(cmdsAndSubs$1)._2__O());
      var this$8 = $n(F);
      var target$2 = this$8.productR__O__O__O(fa, fb);
      var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F);
      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        $as_jl_Void(x$1);
        var target$3 = $m_Ltyrian_runtime_Renderer$().redraw__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__O(dispatcher, renderer, model, view, onMsg, router, F, clock);
        var this$11 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
        var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
          $as_jl_Void(x$1$2);
        }));
        return $n(this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
      }));
      return $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    }));
    return $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  }));
  var fa$1 = $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  var msgLoop = $f_Lcats_FlatMap__foreverM__O__O($n(F), fa$1);
  var this$17 = $m_Lcats_effect_syntax_package$all$();
  var ev$4 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$17, msgLoop, F);
  var $x_1 = $n($f_Lcats_effect_kernel_GenSpawn__background__O__Lcats_effect_kernel_Resource($n(F), ev$4));
  var fa$2 = runCmd.apply__O__O(initCmd);
  var fb$1 = $n(F).never__O();
  var this$21 = $n(F);
  return $x_1.surround__O__Lcats_effect_kernel_MonadCancel__O(this$21.productR__O__O__O(fa$2, fb$1), F);
});
$c_Ltyrian_runtime_TyrianRuntime$.prototype.runCommands__Lcats_effect_std_Queue__Ltyrian_Cmd__Lcats_effect_kernel_Async__O = (function(msgQueue, cmd, F) {
  var target = $m_Ltyrian_runtime_CmdHelper$().cmdToTaskList__Ltyrian_Cmd__Lcats_Applicative__sci_List(cmd, F);
  $m_Lcats_UnorderedFoldable$();
  var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  var this$15 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
  var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((task) => {
    var this$10 = $m_Lcats_effect_syntax_package$all$();
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
      $as_jl_Throwable(_$4);
      return $m_s_None$();
    }));
    var target$1 = $n(F).handleError__O__F1__O(task, f);
    var this$9 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F);
    var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
      var _$5$1 = $as_s_Option(_$5);
      $m_Lcats_UnorderedFoldable$();
      var tc$1 = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
      var this$8 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(_$5$1, tc$1);
      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => $n(msgQueue).offer__O__O(_$6)));
      return $n(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverseVoid__O__F1__Lcats_Applicative__O(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$1, F);
    }));
    var wrapped = $n(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    var ev$7 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$10, wrapped, F);
    var target$2 = $n(F).start__O__O(ev$7);
    var this$13 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
    return $n(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  }));
  var B = $m_Lcats_kernel_instances_unit_package$().Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit;
  return $f_Lcats_Foldable__foldMapM__O__F1__Lcats_Monad__Lcats_kernel_Monoid__O($n(this$15.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance), this$15.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$3, F, B);
});
$c_Ltyrian_runtime_TyrianRuntime$.prototype.runSubscriptions__Lcats_effect_std_AtomicCell__Lcats_effect_std_Queue__Lcats_effect_std_Dispatcher__Ltyrian_Sub__Lcats_effect_kernel_Async__O = (function(currentSubs, msgQueue, dispatcher, sub, F) {
  return $n(currentSubs).evalUpdate__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oldSubs) => {
    var oldSubs$1 = $as_sci_List(oldSubs);
    var allSubs = $m_Ltyrian_runtime_SubHelper$().flatten__Ltyrian_Sub__sci_List(sub);
    matchResult4: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x6 = $m_Ltyrian_runtime_SubHelper$().aliveAndDead__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__T2(allSubs, oldSubs$1, F);
      if ((x6 !== null)) {
        var stillAlive = $as_sci_List($n(x6)._1__O());
        var discarded = $as_sci_List($n(x6)._2__O());
        var \u03b42$___1 = stillAlive;
        var \u03b42$___2 = discarded;
        break matchResult4;
      }
      throw new $c_s_MatchError(x6);
    }
    var stillAlive$2 = $as_sci_List(\u03b42$___1);
    var discarded$2 = $as_sci_List(\u03b42$___2);
    var $x_2 = $m_Ltyrian_runtime_SubHelper$();
    var this$2 = $n(stillAlive$2);
    var f = ((_$8) => {
      var _$8$1 = $as_T2(_$8);
      return $as_T($n(_$8$1)._1__O());
    });
    if ((this$2 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = this$2.head__O();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(this$2.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = $n(rest).head__O();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      }
      var $x_1 = h;
    }
    var target = $x_2.findNewSubs__sci_List__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__sci_List(allSubs, $x_1, $m_sci_Nil$(), F);
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var this$13 = new $c_Lcats_Traverse$ToTraverseOps$$anon$3(target, tc);
    var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$9) => {
      var _$9$1 = $as_Ltyrian_Sub$Observe(_$9);
      return $m_Ltyrian_runtime_SubHelper$().runObserve__Ltyrian_Sub$Observe__F1__Lcats_effect_kernel_GenConcurrent__O(_$9$1, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((result) => {
        var result$1 = $as_s_util_Either(result);
        var this$12 = $n(dispatcher);
        var $x_3 = $n($n(result$1).toOption__s_Option());
        var this$5 = $m_s_$less$colon$less$();
        var target$1 = $x_3.flatten__s_$less$colon$less__s_Option(this$5.s_$less$colon$less$__f_singleton);
        $m_Lcats_UnorderedFoldable$();
        var tc$1 = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
        var this$11 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$1, tc$1);
        var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
          var target$2 = $n(msgQueue).offer__O__O(_$10);
          var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
          return $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        }));
        var B = $m_Lcats_kernel_instances_unit_package$().Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit;
        var fa = $f_Lcats_Foldable__foldMapM__O__F1__Lcats_Monad__Lcats_kernel_Monoid__O($n(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance), this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$1, F, B);
        $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V(this$12, fa);
      })), F);
    }));
    var newSubs = $n(this$13.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance).traverse__O__F1__Lcats_Applicative__O(this$13.Lcats_Traverse$ToTraverseOps$$anon$3__f_self, f$2, F);
    $m_Lcats_UnorderedFoldable$();
    var tc$2 = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var this$21 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(discarded$2, tc$2);
    var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$11) => {
      var this$16 = $m_Lcats_effect_syntax_package$all$();
      var ev$8 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$16, _$11, F);
      var target$3 = $n(F).start__O__O(ev$8);
      var this$19 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
      return $n(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }));
    var B$1 = $m_Lcats_kernel_instances_unit_package$().Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit;
    var fa$1 = $f_Lcats_Foldable__foldMapM__O__F1__Lcats_Monad__Lcats_kernel_Monoid__O($n(this$21.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance), this$21.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$3, F, B$1);
    var this$25 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(newSubs, F);
    var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$12) => {
      var _$12$1 = $as_sci_List(_$12);
      var this$24 = $n(_$12$1);
      return this$24.appendedAll__sc_IterableOnce__sci_List(stillAlive$2);
    }));
    var fb = $n(this$25.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$25.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$4);
    var this$27 = $n(F);
    return this$27.productR__O__O__O(fa$1, fb);
  })));
});
$c_Ltyrian_runtime_TyrianRuntime$.prototype.postMsg__Lcats_effect_std_Dispatcher__Lcats_effect_std_Queue__F1 = (function(dispatcher, msgQueue) {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((msg) => {
    var this$1 = $n(dispatcher);
    var fa = $n(msgQueue).offer__O__O(msg);
    $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V(this$1, fa);
  }));
});
var $d_Ltyrian_runtime_TyrianRuntime$ = new $TypeData().initClass($c_Ltyrian_runtime_TyrianRuntime$, "tyrian.runtime.TyrianRuntime$", ({
  Ltyrian_runtime_TyrianRuntime$: 1
}));
var $n_Ltyrian_runtime_TyrianRuntime$;
function $m_Ltyrian_runtime_TyrianRuntime$() {
  if ((!$n_Ltyrian_runtime_TyrianRuntime$)) {
    $n_Ltyrian_runtime_TyrianRuntime$ = new $c_Ltyrian_runtime_TyrianRuntime$();
  }
  return $n_Ltyrian_runtime_TyrianRuntime$;
}
/** @constructor */
function $c_Lcats_Bifunctor$() {
}
$c_Lcats_Bifunctor$.prototype = new $h_O();
$c_Lcats_Bifunctor$.prototype.constructor = $c_Lcats_Bifunctor$;
/** @constructor */
function $h_Lcats_Bifunctor$() {
}
$h_Lcats_Bifunctor$.prototype = $c_Lcats_Bifunctor$.prototype;
var $d_Lcats_Bifunctor$ = new $TypeData().initClass($c_Lcats_Bifunctor$, "cats.Bifunctor$", ({
  Lcats_Bifunctor$: 1,
  Lcats_instances_NTupleBifunctorInstances: 1
}));
var $n_Lcats_Bifunctor$;
function $m_Lcats_Bifunctor$() {
  if ((!$n_Lcats_Bifunctor$)) {
    $n_Lcats_Bifunctor$ = new $c_Lcats_Bifunctor$();
  }
  return $n_Lcats_Bifunctor$;
}
/** @constructor */
function $c_Lcats_Eval() {
}
$c_Lcats_Eval.prototype = new $h_O();
$c_Lcats_Eval.prototype.constructor = $c_Lcats_Eval;
/** @constructor */
function $h_Lcats_Eval() {
}
$h_Lcats_Eval.prototype = $c_Lcats_Eval.prototype;
$c_Lcats_Eval.prototype.map__F1__Lcats_Eval = (function(f) {
  return this.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
    var value = $n(f).apply__O__O(a);
    return new $c_Lcats_Now(value);
  })));
});
$c_Lcats_Eval.prototype.flatMap__F1__Lcats_Eval = (function(f) {
  if ((this instanceof $c_Lcats_Eval$FlatMap)) {
    var c = $as_Lcats_Eval$FlatMap(this);
    return new $c_Lcats_Eval$$anon$1(c, f);
  } else if ((this instanceof $c_Lcats_Eval$Defer)) {
    var c$2 = $as_Lcats_Eval$Defer(this);
    return new $c_Lcats_Eval$$anon$3(c$2, f);
  } else {
    return new $c_Lcats_Eval$$anon$4(f, this);
  }
});
function $as_Lcats_Eval(obj) {
  return (((obj instanceof $c_Lcats_Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval"));
}
function $isArrayOf_Lcats_Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval)));
}
function $asArrayOf_Lcats_Eval(obj, depth) {
  return (($isArrayOf_Lcats_Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval;", depth));
}
/** @constructor */
function $c_Lcats_EvalInstances0() {
}
$c_Lcats_EvalInstances0.prototype = new $h_Lcats_EvalInstances1();
$c_Lcats_EvalInstances0.prototype.constructor = $c_Lcats_EvalInstances0;
/** @constructor */
function $h_Lcats_EvalInstances0() {
}
$h_Lcats_EvalInstances0.prototype = $c_Lcats_EvalInstances0.prototype;
/** @constructor */
function $c_Lcats_Foldable$Source$$anon$3() {
}
$c_Lcats_Foldable$Source$$anon$3.prototype = new $h_Lcats_Foldable$Source();
$c_Lcats_Foldable$Source$$anon$3.prototype.constructor = $c_Lcats_Foldable$Source$$anon$3;
/** @constructor */
function $h_Lcats_Foldable$Source$$anon$3() {
}
$h_Lcats_Foldable$Source$$anon$3.prototype = $c_Lcats_Foldable$Source$$anon$3.prototype;
$c_Lcats_Foldable$Source$$anon$3.prototype.uncons__s_Option = (function() {
  return $m_s_None$();
});
var $d_Lcats_Foldable$Source$$anon$3 = new $TypeData().initClass($c_Lcats_Foldable$Source$$anon$3, "cats.Foldable$Source$$anon$3", ({
  Lcats_Foldable$Source$$anon$3: 1,
  Lcats_Foldable$Source: 1
}));
/** @constructor */
function $c_Lcats_Foldable$Source$$anon$4(a$5, src$10) {
  this.Lcats_Foldable$Source$$anon$4__f_a$2 = null;
  this.Lcats_Foldable$Source$$anon$4__f_src$6 = null;
  this.Lcats_Foldable$Source$$anon$4__f_a$2 = a$5;
  this.Lcats_Foldable$Source$$anon$4__f_src$6 = src$10;
}
$c_Lcats_Foldable$Source$$anon$4.prototype = new $h_Lcats_Foldable$Source();
$c_Lcats_Foldable$Source$$anon$4.prototype.constructor = $c_Lcats_Foldable$Source$$anon$4;
/** @constructor */
function $h_Lcats_Foldable$Source$$anon$4() {
}
$h_Lcats_Foldable$Source$$anon$4.prototype = $c_Lcats_Foldable$Source$$anon$4.prototype;
$c_Lcats_Foldable$Source$$anon$4.prototype.uncons__s_Option = (function() {
  var _1 = this.Lcats_Foldable$Source$$anon$4__f_a$2;
  var _2 = this.Lcats_Foldable$Source$$anon$4__f_src$6;
  var value = new $c_T2(_1, _2);
  return new $c_s_Some(value);
});
var $d_Lcats_Foldable$Source$$anon$4 = new $TypeData().initClass($c_Lcats_Foldable$Source$$anon$4, "cats.Foldable$Source$$anon$4", ({
  Lcats_Foldable$Source$$anon$4: 1,
  Lcats_Foldable$Source: 1
}));
/** @constructor */
function $c_Lcats_ParallelArityFunctions2() {
}
$c_Lcats_ParallelArityFunctions2.prototype = new $h_O();
$c_Lcats_ParallelArityFunctions2.prototype.constructor = $c_Lcats_ParallelArityFunctions2;
/** @constructor */
function $h_Lcats_ParallelArityFunctions2() {
}
$h_Lcats_ParallelArityFunctions2.prototype = $c_Lcats_ParallelArityFunctions2.prototype;
function $is_Lcats_SemigroupK(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_SemigroupK)));
}
function $as_Lcats_SemigroupK(obj) {
  return (($is_Lcats_SemigroupK(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.SemigroupK"));
}
function $isArrayOf_Lcats_SemigroupK(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_SemigroupK)));
}
function $asArrayOf_Lcats_SemigroupK(obj, depth) {
  return (($isArrayOf_Lcats_SemigroupK(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.SemigroupK;", depth));
}
function $is_Lcats_arrow_FunctionK(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_arrow_FunctionK)));
}
function $as_Lcats_arrow_FunctionK(obj) {
  return (($is_Lcats_arrow_FunctionK(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.arrow.FunctionK"));
}
function $isArrayOf_Lcats_arrow_FunctionK(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_arrow_FunctionK)));
}
function $asArrayOf_Lcats_arrow_FunctionK(obj, depth) {
  return (($isArrayOf_Lcats_arrow_FunctionK(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.arrow.FunctionK;", depth));
}
function $ct_Lcats_data_AndThenInstances0__($thiz) {
  new $c_Lcats_data_AndThenInstances0$$anon$1();
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_AndThenInstances0() {
}
$c_Lcats_data_AndThenInstances0.prototype = new $h_Lcats_data_AndThenInstances1();
$c_Lcats_data_AndThenInstances0.prototype.constructor = $c_Lcats_data_AndThenInstances0;
/** @constructor */
function $h_Lcats_data_AndThenInstances0() {
}
$h_Lcats_data_AndThenInstances0.prototype = $c_Lcats_data_AndThenInstances0.prototype;
/** @constructor */
function $c_Lcats_data_Chain() {
}
$c_Lcats_data_Chain.prototype = new $h_O();
$c_Lcats_data_Chain.prototype.constructor = $c_Lcats_data_Chain;
/** @constructor */
function $h_Lcats_data_Chain() {
}
$h_Lcats_data_Chain.prototype = $c_Lcats_data_Chain.prototype;
$c_Lcats_data_Chain.prototype.uncons__s_Option = (function() {
  if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var non = $as_Lcats_data_Chain$NonEmpty(this);
    var c = non;
    var rights = null;
    var result = null;
    while ((result === null)) {
      var x3 = c;
      if ((x3 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x$1 = $as_Lcats_data_Chain$Singleton(x3);
        var this$2 = $n(x$1);
        var x13 = this$2.Lcats_data_Chain$Singleton__f_a;
        var next = ((rights === null) ? $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil : rights);
        result = new $c_T2(x13, next);
        continue;
      }
      if ((x3 instanceof $c_Lcats_data_Chain$Append)) {
        var x$1$1 = $as_Lcats_data_Chain$Append(x3);
        var this$5 = $n(x$1$1);
        var x9 = this$5.Lcats_data_Chain$Append__f_leftNE;
        var this$6 = $n(x$1$1);
        var x10 = this$6.Lcats_data_Chain$Append__f_rightNE;
        if ((rights === null)) {
          rights = x10;
        } else {
          var rightNE = rights;
          rights = $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__(new $c_Lcats_data_Chain$Append(), x10, rightNE);
        }
        c = x9;
        continue;
      }
      if ((x3 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x$1$2 = $as_Lcats_data_Chain$Wrap(x3);
        var this$9 = $n(x$1$2);
        var x6 = this$9.Lcats_data_Chain$Wrap__f_seq;
        var this$10 = $m_Lcats_data_Chain$();
        var s = $as_sci_Seq($n(x6).tail__O());
        var tail = $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$10, s);
        if ((rights === null)) {
          var next$2 = tail;
        } else if ((tail instanceof $c_Lcats_data_Chain$NonEmpty)) {
          var non$2 = $as_Lcats_data_Chain$NonEmpty(tail);
          var rightNE$1 = rights;
          var next$2 = $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__(new $c_Lcats_data_Chain$Append(), non$2, rightNE$1);
        } else {
          var next$2 = rights;
        }
        var _1 = $n(x6).head__O();
        result = new $c_T2(_1, next$2);
        continue;
      }
      throw new $c_s_MatchError(x3);
    }
    var value = result;
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_data_Chain.prototype.isEmpty__Z = (function() {
  return (!(this instanceof $c_Lcats_data_Chain$NonEmpty));
});
$c_Lcats_data_Chain.prototype.prepend__O__Lcats_data_Chain = (function(a) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(($m_Lcats_data_Chain$(), new $c_Lcats_data_Chain$Singleton(a)), this);
});
$c_Lcats_data_Chain.prototype.append__O__Lcats_data_Chain = (function(a) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this, ($m_Lcats_data_Chain$(), new $c_Lcats_data_Chain$Singleton(a)));
});
$c_Lcats_data_Chain.prototype.map__F1__Lcats_data_Chain = (function(f) {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var this$2 = $n(x$1);
    var x34 = this$2.Lcats_data_Chain$Wrap__f_seq;
    var seq = $as_sci_Seq($n(x34).map__F1__O(f));
    return new $c_Lcats_data_Chain$Wrap(seq);
  } else {
    var this$6 = $m_Lcats_data_Chain$();
    var this$4 = $n(this.iterator__sc_Iterator());
    var this$5 = new $c_sc_Iterator$$anon$9(this$4, f);
    var s = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$5);
    return $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$6, s);
  }
});
$c_Lcats_data_Chain.prototype.flatMap__F1__Lcats_data_Chain = (function(f) {
  var this$1 = $m_Lcats_data_Chain$();
  var result = this$1.Lcats_data_Chain$__f_nil;
  var iter = this.iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var this$2 = $n(result);
    var c = $as_Lcats_data_Chain($n(f).apply__O__O($n(iter).next__O()));
    result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, c);
  }
  return result;
});
$c_Lcats_data_Chain.prototype.collect__s_PartialFunction__Lcats_data_Chain = (function(pf) {
  var z = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  var result = z;
  var iter = this.iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var x0 = result;
    var x1 = $n(iter).next__O();
    var acc = $as_Lcats_data_Chain(x0);
    var x = $n(pf).applyOrElse__O__F1__O(x1, $m_Lcats_data_Chain$().Lcats_data_Chain$__f_cats$data$Chain$$$sentinel);
    if ((x !== $m_Lcats_data_Chain$().Lcats_data_Chain$__f_cats$data$Chain$$$sentinel)) {
      var this$1 = $n(acc);
      result = this$1.append__O__Lcats_data_Chain(x);
    } else {
      result = acc;
    }
  }
  return $as_Lcats_data_Chain(result);
});
$c_Lcats_data_Chain.prototype.iterator__sc_Iterator = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var this$2 = $n(x$1);
    var x179 = this$2.Lcats_data_Chain$Wrap__f_seq;
    return $n(x179).iterator__sc_Iterator();
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var this$4 = $n(x$1$1);
    var x176 = this$4.Lcats_data_Chain$Singleton__f_a;
    return new $c_sc_Iterator$$anon$20(x176);
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    return new $c_Lcats_data_Chain$ChainIterator(app);
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  }
});
$c_Lcats_data_Chain.prototype.toList__sci_List = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var this$2 = $n(x$1);
    var x237 = this$2.Lcats_data_Chain$Wrap__f_seq;
    return $n(x237).toList__sci_List();
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var this$4 = $n(x$1$1);
    var x234 = this$4.Lcats_data_Chain$Singleton__f_a;
    var this$5 = $m_sci_Nil$();
    return new $c_sci_$colon$colon(x234, this$5);
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    var this$6 = new $c_Lcats_data_Chain$ChainIterator(app);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$6);
  } else {
    return $m_sci_Nil$();
  }
});
$c_Lcats_data_Chain.prototype.toVector__sci_Vector = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var this$2 = $n(x$1);
    var x245 = this$2.Lcats_data_Chain$Wrap__f_seq;
    return $n(x245).toVector__sci_Vector();
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var this$4 = $n(x$1$1);
    var x242 = this$4.Lcats_data_Chain$Singleton__f_a;
    $m_sci_Vector$();
    var this$6 = $m_sci_Vector0$();
    return this$6.appended__O__sci_Vector(x242);
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    var this$7 = new $c_Lcats_data_Chain$ChainIterator(app);
    return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$7);
  } else {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }
});
$c_Lcats_data_Chain.prototype.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z = (function(that, A) {
  if ((this === that)) {
    return true;
  } else {
    var iterX = this.iterator__sc_Iterator();
    var iterY = $n(that).iterator__sc_Iterator();
    while (($n(iterX).hasNext__Z() && $n(iterY).hasNext__Z())) {
      if ((!$n(A).eqv__O__O__Z($n(iterX).next__O(), $n(iterY).next__O()))) {
        return false;
      }
    }
    return ($n(iterX).hasNext__Z() === $n(iterY).hasNext__Z());
  }
});
$c_Lcats_data_Chain.prototype.show__Lcats_Show__T = (function(AA) {
  var builder = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), "Chain(");
  var first = new $c_sr_BooleanRef(true);
  var f = ((a) => {
    if (first.sr_BooleanRef__f_elem) {
      var s = $n(AA).show__O__T(a);
      builder.addAll__T__scm_StringBuilder(s);
      first.sr_BooleanRef__f_elem = false;
    } else {
      var s$1 = (", " + $n(AA).show__O__T(a));
      builder.addAll__T__scm_StringBuilder(s$1);
    }
    return false;
  });
  _return: {
    if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var non = $as_Lcats_data_Chain$NonEmpty(this);
      var c = non;
      var rights = $m_sci_Nil$();
      while ((c !== null)) {
        var x159 = c;
        if ((x159 instanceof $c_Lcats_data_Chain$Singleton)) {
          var x$1 = $as_Lcats_data_Chain$Singleton(x159);
          var this$3 = $n(x$1);
          var x169 = this$3.Lcats_data_Chain$Singleton__f_a;
          var b = $uZ(f(x169));
          if (b) {
            break;
          }
          if ($n(rights).isEmpty__Z()) {
            c = null;
          } else {
            var head = $as_Lcats_data_Chain$NonEmpty($n(rights).head__O());
            rights = $as_sci_List($n(rights).tail__O());
            c = head;
          }
          continue;
        }
        if ((x159 instanceof $c_Lcats_data_Chain$Append)) {
          var x$1$1 = $as_Lcats_data_Chain$Append(x159);
          var this$5 = $n(x$1$1);
          var x165 = this$5.Lcats_data_Chain$Append__f_leftNE;
          var this$6 = $n(x$1$1);
          var x166 = this$6.Lcats_data_Chain$Append__f_rightNE;
          var this$7 = $n(rights);
          rights = new $c_sci_$colon$colon(x166, this$7);
          c = x165;
          continue;
        }
        if ((x159 instanceof $c_Lcats_data_Chain$Wrap)) {
          var x$1$2 = $as_Lcats_data_Chain$Wrap(x159);
          var this$9 = $n(x$1$2);
          var x162 = this$9.Lcats_data_Chain$Wrap__f_seq;
          var iterator = $n(x162).iterator__sc_Iterator();
          while ($n(iterator).hasNext__Z()) {
            var x0 = $n(iterator).next__O();
            var b$2 = $uZ(f(x0));
            if (b$2) {
              break _return;
            }
          }
          if ($n(rights).isEmpty__Z()) {
            c = null;
          } else {
            var head$2 = $as_Lcats_data_Chain$NonEmpty($n(rights).head__O());
            rights = $as_sci_List($n(rights).tail__O());
            c = head$2;
          }
          continue;
        }
        throw new $c_s_MatchError(x159);
      }
    }
  }
  builder.addOne__C__scm_StringBuilder(41);
  return $n(builder.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lcats_data_Chain.prototype.toString__T = (function() {
  return this.show__Lcats_Show__T(new $c_Lcats_Show$$anon$5());
});
$c_Lcats_data_Chain.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_Lcats_data_Chain)) {
    var thatChain = $as_Lcats_data_Chain(o);
    return this.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z(thatChain, ($n($m_Lcats_package$().Lcats_package$__f_Eq), new $c_Lcats_kernel_Eq$$anon$6()));
  } else {
    return false;
  }
});
$c_Lcats_data_Chain.prototype.hashCode__I = (function() {
  $n($m_Lcats_package$().Lcats_package$__f_Hash);
  var hashA = new $c_Lcats_kernel_Hash$$anon$3();
  return $m_Lcats_kernel_instances_StaticMethods$().orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I(this.iterator__sc_Iterator(), hashA);
});
function $as_Lcats_data_Chain(obj) {
  return (((obj instanceof $c_Lcats_data_Chain) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain"));
}
function $isArrayOf_Lcats_data_Chain(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain)));
}
function $asArrayOf_Lcats_data_Chain(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain;", depth));
}
/** @constructor */
function $c_Lcats_data_ChainInstances2() {
}
$c_Lcats_data_ChainInstances2.prototype = new $h_Lcats_data_ChainInstances3();
$c_Lcats_data_ChainInstances2.prototype.constructor = $c_Lcats_data_ChainInstances2;
/** @constructor */
function $h_Lcats_data_ChainInstances2() {
}
$h_Lcats_data_ChainInstances2.prototype = $c_Lcats_data_ChainInstances2.prototype;
/** @constructor */
function $c_Lcats_data_KleisliInstances8() {
}
$c_Lcats_data_KleisliInstances8.prototype = new $h_Lcats_data_KleisliInstances9();
$c_Lcats_data_KleisliInstances8.prototype.constructor = $c_Lcats_data_KleisliInstances8;
/** @constructor */
function $h_Lcats_data_KleisliInstances8() {
}
$h_Lcats_data_KleisliInstances8.prototype = $c_Lcats_data_KleisliInstances8.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances0() {
}
$c_Lcats_data_NonEmptyListInstances0.prototype = new $h_Lcats_data_NonEmptyListInstances1();
$c_Lcats_data_NonEmptyListInstances0.prototype.constructor = $c_Lcats_data_NonEmptyListInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances0() {
}
$h_Lcats_data_NonEmptyListInstances0.prototype = $c_Lcats_data_NonEmptyListInstances0.prototype;
/** @constructor */
function $c_Lcats_data_ValidatedInstances1() {
}
$c_Lcats_data_ValidatedInstances1.prototype = new $h_Lcats_data_ValidatedInstances2();
$c_Lcats_data_ValidatedInstances1.prototype.constructor = $c_Lcats_data_ValidatedInstances1;
/** @constructor */
function $h_Lcats_data_ValidatedInstances1() {
}
$h_Lcats_data_ValidatedInstances1.prototype = $c_Lcats_data_ValidatedInstances1.prototype;
/** @constructor */
function $c_Lcats_effect_IO() {
}
$c_Lcats_effect_IO.prototype = new $h_Lcats_effect_IOPlatform();
$c_Lcats_effect_IO.prototype.constructor = $c_Lcats_effect_IO;
/** @constructor */
function $h_Lcats_effect_IO() {
}
$h_Lcats_effect_IO.prototype = $c_Lcats_effect_IO.prototype;
$c_Lcats_effect_IO.prototype.as__O__Lcats_effect_IO = (function(b) {
  return this.map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => b)));
});
$c_Lcats_effect_IO.prototype.forceR__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return $n(this.handleError__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$9) => {
    $as_jl_Throwable(_$9);
  })))).productR__Lcats_effect_IO__Lcats_effect_IO(that);
});
$c_Lcats_effect_IO.prototype.flatMap__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$FlatMap(this, f, event);
});
$c_Lcats_effect_IO.prototype.flatTap__F1__Lcats_effect_IO = (function(f) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n($as_Lcats_effect_IO($n(f).apply__O__O(a))).as__O__Lcats_effect_IO(a))));
});
$c_Lcats_effect_IO.prototype.guarantee__Lcats_effect_IO__Lcats_effect_IO = (function(finalizer) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var onError = new $c_Lcats_effect_IO$$anon$1(finalizer);
    var this$2 = $n($as_Lcats_effect_IO($n(poll$1).apply__O__O(this)));
    return $n(new $c_Lcats_effect_IO$OnCancel(this$2, finalizer).onError__s_PartialFunction__Lcats_effect_IO(onError)).flatTap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => finalizer)));
  })));
});
$c_Lcats_effect_IO.prototype.guaranteeCase__F1__Lcats_effect_IO = (function(finalizer) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var this$4 = $n($as_Lcats_effect_IO($n(poll$1).apply__O__O(this)));
    var fin = $as_Lcats_effect_IO($n(finalizer).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()));
    var finalized = new $c_Lcats_effect_IO$OnCancel(this$4, fin);
    var onError = new $c_Lcats_effect_IO$$anon$2(finalizer);
    return $n(finalized.onError__s_PartialFunction__Lcats_effect_IO(onError)).flatTap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
      $m_Lcats_effect_IO$();
      var fa = new $c_Lcats_effect_IO$Pure(a);
      return $as_Lcats_effect_IO($n(finalizer).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa)));
    })));
  })));
});
$c_Lcats_effect_IO.prototype.handleError__F1__Lcats_effect_IO = (function(f) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => {
    var t$1 = $as_jl_Throwable(t);
    $m_Lcats_effect_IO$();
    var value = $n(f).apply__O__O(t$1);
    return new $c_Lcats_effect_IO$Pure(value);
  })));
});
$c_Lcats_effect_IO.prototype.handleErrorWith__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$HandleErrorWith(this, f, event);
});
$c_Lcats_effect_IO.prototype.map__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$Map(this, f, event);
});
$c_Lcats_effect_IO.prototype.onError__s_PartialFunction__Lcats_effect_IO = (function(pf) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => {
    var t$1 = $as_jl_Throwable(t);
    var this$3 = $n($as_Lcats_effect_IO($n(pf).applyOrElse__O__F1__O(t$1, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$13) => {
      $as_jl_Throwable(_$13);
      return $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
    })))));
    $m_Lcats_effect_IO$();
    var that = new $c_Lcats_effect_IO$Error(t$1);
    return this$3.productR__Lcats_effect_IO__Lcats_effect_IO(that);
  })));
});
$c_Lcats_effect_IO.prototype.redeemWith__F1__F1__Lcats_effect_IO = (function(recover, bind) {
  return new $c_Lcats_effect_IO$Attempt(this).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$15) => {
    var _$15$1 = $as_s_util_Either(_$15);
    return $as_Lcats_effect_IO($n(_$15$1).fold__F1__F1__O(recover, bind));
  })));
});
$c_Lcats_effect_IO.prototype.productL__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n(that).as__O__Lcats_effect_IO(a))));
});
$c_Lcats_effect_IO.prototype.productR__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$18) => that)));
});
$c_Lcats_effect_IO.prototype.void__Lcats_effect_IO = (function() {
  return this.map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$20) => (void 0))));
});
$c_Lcats_effect_IO.prototype.reportError__s_$less$colon$less__Lcats_effect_IO = (function(ev) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => {
    var t$1 = $as_jl_Throwable(t);
    return ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$()).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ec) => {
      var ec$1 = $as_s_concurrent_ExecutionContext(ec);
      var this$2 = $m_Lcats_effect_IO$();
      var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        $n(ec$1).reportFailure__jl_Throwable__V(t$1);
      }));
      return this$2.delay__F0__Lcats_effect_IO(thunk);
    })));
  })));
});
$c_Lcats_effect_IO.prototype.toString__T = (function() {
  return "IO(...)";
});
$c_Lcats_effect_IO.prototype.unsafeRunAndForget__Lcats_effect_unsafe_IORuntime__V = (function(runtime) {
  this.unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (void 0))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t) => {
    var t$1 = $as_jl_Throwable(t);
    if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(t$1)) {
      if ($n($n(runtime).Lcats_effect_unsafe_IORuntime__f_config).Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors) {
        $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_compute).reportFailure__jl_Throwable__V(t$1);
      }
    } else {
      var this$1 = $n(t$1);
      this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
    }
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$23) => (void 0))), true, runtime);
});
$c_Lcats_effect_IO.prototype.unsafeRunFiber__F0__F1__F1__Z__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber = (function(canceled, failure, success, registerCallback, runtime) {
  var fiber = new $c_Lcats_effect_IOFiber($m_Lcats_effect_package$IOLocalState$().Lcats_effect_package$IOLocalState$__f_empty, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oc) => {
    var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
    if (registerCallback) {
      $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).remove__F1__V(failure);
    }
    var this$1 = $n(oc$1);
    matchResult1: {
      if (((this$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(this$1), true))) {
        $n(canceled).apply__O();
        break matchResult1;
      }
      if ((this$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1 = $as_Lcats_effect_kernel_Outcome$Errored(this$1);
        var this$3 = $n(x$1);
        var x7 = this$3.Lcats_effect_kernel_Outcome$Errored__f_e;
        $n(failure).apply__O__O(x7);
        break matchResult1;
      }
      if ((this$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(this$1);
        var this$5 = $n(x$1$1);
        var x4 = this$5.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        var ioa = $as_Lcats_effect_IO(x4);
        $n(success).apply__O__O($n($as_Lcats_effect_IO$Pure(ioa)).Lcats_effect_IO$Pure__f_value);
        break matchResult1;
      }
      throw new $c_s_MatchError(this$1);
    }
  })), this, $n(runtime).Lcats_effect_unsafe_IORuntime__f_compute, runtime);
  if (registerCallback) {
    $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs).put__F1__V(failure);
  }
  $n($n(runtime).Lcats_effect_unsafe_IORuntime__f_compute).execute__jl_Runnable__V(fiber);
  return fiber;
});
function $as_Lcats_effect_IO(obj) {
  return (((obj instanceof $c_Lcats_effect_IO) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO"));
}
function $isArrayOf_Lcats_effect_IO(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO)));
}
function $asArrayOf_Lcats_effect_IO(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO;", depth));
}
/** @constructor */
function $c_Lcats_effect_IOFiber$$anon$2(cb$12, outer) {
  this.Lcats_effect_IOFiber$$anon$2__f_cb$11 = null;
  this.Lcats_effect_IOFiber$$anon$2__f_cb$11 = cb$12;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_IOFiber$$anon$2.prototype = new $h_O();
$c_Lcats_effect_IOFiber$$anon$2.prototype.constructor = $c_Lcats_effect_IOFiber$$anon$2;
/** @constructor */
function $h_Lcats_effect_IOFiber$$anon$2() {
}
$h_Lcats_effect_IOFiber$$anon$2.prototype = $c_Lcats_effect_IOFiber$$anon$2.prototype;
$c_Lcats_effect_IOFiber$$anon$2.prototype.run__V = (function() {
  var cb$7 = this.Lcats_effect_IOFiber$$anon$2__f_cb$11;
  $n(cb$7).apply__O__O($m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit);
});
var $d_Lcats_effect_IOFiber$$anon$2 = new $TypeData().initClass($c_Lcats_effect_IOFiber$$anon$2, "cats.effect.IOFiber$$anon$2", ({
  Lcats_effect_IOFiber$$anon$2: 1,
  jl_Runnable: 1
}));
function $ps_Lcats_effect_SyncIO__runLoop$1__sjs_js_Array__sr_ObjectRef__Lcats_effect_SyncIO__O(objectState$1, conts$1, cur0) {
  var cur0$tailLocal1 = cur0;
  while (true) {
    var x34 = $n(cur0$tailLocal1).tag__B();
    switch (x34) {
      case 0: {
        var cur = $as_Lcats_effect_SyncIO$Pure(cur0$tailLocal1);
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, $n(cur).Lcats_effect_SyncIO$Pure__f_value, 0);
        break;
      }
      case 1: {
        var cur$2 = $as_Lcats_effect_SyncIO$Suspend(cur0$tailLocal1);
        var error = null;
        try {
          var r = $n($n(cur$2).Lcats_effect_SyncIO$Suspend__f_thunk).apply__O();
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          matchResult2: {
            if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
              error = e$2;
              break matchResult2;
            }
            throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
          }
          var r = (void 0);
        }
        var next = ((error === null) ? $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, r, 0) : $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$1, objectState$1, error, 0));
        cur0$tailLocal1 = next;
        break;
      }
      case 2: {
        var cur$3 = $as_Lcats_effect_SyncIO$Error(cur0$tailLocal1);
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$1, objectState$1, $n(cur$3).Lcats_effect_SyncIO$Error__f_t, 0);
        break;
      }
      case 3: {
        var cur$4 = $as_Lcats_effect_SyncIO$Map(cur0$tailLocal1);
        var a = $n(cur$4).f__F1();
        objectState$1.push(a);
        var $x_1 = $n(conts$1);
        var stack = $n(conts$1).sr_ObjectRef__f_elem;
        var c = $uI(stack[0]);
        var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
        var s = ((1 + (c >> 3)) | 0);
        var shift = ((7 & c) << 2);
        use[s] = ($uI(use[s]) & (~((-1) << shift)));
        use[0] = ((1 + $uI(use[0])) | 0);
        $x_1.sr_ObjectRef__f_elem = use;
        cur0$tailLocal1 = $n(cur$4).ioe__Lcats_effect_SyncIO();
        break;
      }
      case 4: {
        var cur$5 = $as_Lcats_effect_SyncIO$FlatMap(cur0$tailLocal1);
        var a$1 = $n(cur$5).Lcats_effect_SyncIO$FlatMap__f_f;
        objectState$1.push(a$1);
        var $x_2 = $n(conts$1);
        var stack$1 = $n(conts$1).sr_ObjectRef__f_elem;
        var c$1 = $uI(stack$1[0]);
        var use$1 = ((((1 + (((1 + c$1) | 0) >> 3)) | 0) < $uI(stack$1.length)) ? stack$1 : (stack$1.push(0), stack$1));
        var s$1 = ((1 + (c$1 >> 3)) | 0);
        var shift$1 = ((7 & c$1) << 2);
        use$1[s$1] = (($uI(use$1[s$1]) & (~((-1) << shift$1))) | (1 << shift$1));
        use$1[0] = ((1 + $uI(use$1[0])) | 0);
        $x_2.sr_ObjectRef__f_elem = use$1;
        cur0$tailLocal1 = $n(cur$5).Lcats_effect_SyncIO$FlatMap__f_ioe;
        break;
      }
      case 5: {
        var cur$6 = $as_Lcats_effect_SyncIO$HandleErrorWith(cur0$tailLocal1);
        var a$2 = $n(cur$6).Lcats_effect_SyncIO$HandleErrorWith__f_f;
        objectState$1.push(a$2);
        var $x_3 = $n(conts$1);
        var stack$2 = $n(conts$1).sr_ObjectRef__f_elem;
        var c$2 = $uI(stack$2[0]);
        var use$2 = ((((1 + (((1 + c$2) | 0) >> 3)) | 0) < $uI(stack$2.length)) ? stack$2 : (stack$2.push(0), stack$2));
        var s$2 = ((1 + (c$2 >> 3)) | 0);
        var shift$2 = ((7 & c$2) << 2);
        use$2[s$2] = (($uI(use$2[s$2]) & (~((-1) << shift$2))) | (2 << shift$2));
        use$2[0] = ((1 + $uI(use$2[0])) | 0);
        $x_3.sr_ObjectRef__f_elem = use$2;
        cur0$tailLocal1 = $n(cur$6).Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
        break;
      }
      case 6: {
        var cur$7 = $as_Lcats_effect_SyncIO$Success(cur0$tailLocal1);
        return $n(cur$7).Lcats_effect_SyncIO$Success__f_value;
        break;
      }
      case 7: {
        var cur$8 = $as_Lcats_effect_SyncIO$Failure(cur0$tailLocal1);
        var $x_4 = $n($n(cur$8).Lcats_effect_SyncIO$Failure__f_t);
        throw (($x_4 instanceof $c_sjs_js_JavaScriptException) ? $x_4.sjs_js_JavaScriptException__f_exception : $x_4);
        break;
      }
      case 8: {
        var cur$9 = $as_Lcats_effect_SyncIO$Attempt(cur0$tailLocal1);
        var $x_5 = $n(conts$1);
        var stack$3 = $n(conts$1).sr_ObjectRef__f_elem;
        var c$3 = $uI(stack$3[0]);
        var use$3 = ((((1 + (((1 + c$3) | 0) >> 3)) | 0) < $uI(stack$3.length)) ? stack$3 : (stack$3.push(0), stack$3));
        var s$3 = ((1 + (c$3 >> 3)) | 0);
        var shift$3 = ((7 & c$3) << 2);
        use$3[s$3] = (($uI(use$3[s$3]) & (~((-1) << shift$3))) | (4 << shift$3));
        use$3[0] = ((1 + $uI(use$3[0])) | 0);
        $x_5.sr_ObjectRef__f_elem = use$3;
        cur0$tailLocal1 = $n(cur$9).Lcats_effect_SyncIO$Attempt__f_ioa;
        break;
      }
      case 9: {
        var value = $uD(Date.now());
        var $x_6 = $m_RTLong$().fromDouble__D__J(value);
        var n_$_lo = $x_6.l;
        var n_$_hi = $x_6.h;
        var this$10 = new $c_s_concurrent_duration_package$DurationLong(n_$_lo, n_$_hi);
        var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
        var this$_$_lo = this$10.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
        var this$_$_hi = this$10.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
        $m_s_concurrent_duration_Duration$();
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, new $c_s_concurrent_duration_FiniteDuration(this$_$_lo, this$_$_hi, unit), 0);
        break;
      }
      case 10: {
        var value$1 = (1000000.0 * $uD($m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
        var $x_7 = $m_RTLong$().fromDouble__D__J(value$1);
        var n$1_$_lo = $x_7.l;
        var n$1_$_hi = $x_7.h;
        var this$15 = new $c_s_concurrent_duration_package$DurationLong(n$1_$_lo, n$1_$_hi);
        var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
        var this$$1_$_lo = this$15.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
        var this$$1_$_hi = this$15.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
        $m_s_concurrent_duration_Duration$();
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, new $c_s_concurrent_duration_FiniteDuration(this$$1_$_lo, this$$1_$_hi, unit$1), 0);
        break;
      }
      default: {
        throw new $c_s_MatchError(x34);
      }
    }
  }
}
function $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$2, objectState$2, result, depth) {
  var depth$tailLocal1 = depth;
  var result$tailLocal1 = result;
  while (true) {
    var stack = $n(conts$2).sr_ObjectRef__f_elem;
    var c = (($uI(stack[0]) - 1) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (($uI(stack[((1 + (c >> 3)) | 0)]) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (($uI(stack[0]) - 1) | 0);
    switch (op) {
      case 0: {
        return $ps_Lcats_effect_SyncIO__mapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO(objectState$2, conts$2, result$tailLocal1, depth$tailLocal1);
        break;
      }
      case 1: {
        return $ps_Lcats_effect_SyncIO__flatMapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO(objectState$2, conts$2, result$tailLocal1, depth$tailLocal1);
        break;
      }
      case 2: {
        objectState$2.pop();
        break;
      }
      case 3: {
        var value = result$tailLocal1;
        return new $c_Lcats_effect_SyncIO$Success(value);
        break;
      }
      case 4: {
        var value$1 = result$tailLocal1;
        var result$tailLocal1$tmp1 = new $c_s_util_Right(value$1);
        var depth$tailLocal1$tmp1 = ((1 + depth$tailLocal1) | 0);
        result$tailLocal1 = result$tailLocal1$tmp1;
        depth$tailLocal1 = depth$tailLocal1$tmp1;
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
function $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$3, objectState$3, error, depth) {
  while (true) {
    var stack = $n(conts$3).sr_ObjectRef__f_elem;
    var c = (($uI(stack[0]) - 1) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (($uI(stack[((1 + (c >> 3)) | 0)]) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (($uI(stack[0]) - 1) | 0);
    switch (op) {
      case 0:
      case 1: {
        objectState$3.pop();
        break;
      }
      case 2: {
        return $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sjs_js_Array__sr_ObjectRef__jl_Throwable__I__Lcats_effect_SyncIO(objectState$3, conts$3, error, depth);
        break;
      }
      case 3: {
        return new $c_Lcats_effect_SyncIO$Failure(error);
        break;
      }
      case 4: {
        return $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$3, objectState$3, new $c_s_util_Left(error), ((1 + depth) | 0));
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
function $ps_Lcats_effect_SyncIO__mapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO(objectState$4, conts$4, result, depth) {
  var f = $as_F1(objectState$4.pop());
  var error = null;
  try {
    var transformed = $n(f).apply__O__O(result);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult6: {
      if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
        error = e$2;
        break matchResult6;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
    var transformed = (void 0);
  }
  if ((depth > 512)) {
    if ((error === null)) {
      var $x_1 = new $c_Lcats_effect_SyncIO$Pure(transformed);
    } else {
      var t = error;
      var $x_1 = new $c_Lcats_effect_SyncIO$Error(t);
    }
    return $as_Lcats_effect_SyncIO($x_1);
  } else {
    return ((error === null) ? $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$4, objectState$4, transformed, ((1 + depth) | 0)) : $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$4, objectState$4, error, ((1 + depth) | 0)));
  }
}
function $ps_Lcats_effect_SyncIO__flatMapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO(objectState$5, conts$5, result, depth) {
  var f = $as_F1(objectState$5.pop());
  try {
    return $as_Lcats_effect_SyncIO($n(f).apply__O__O(result));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
      return $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$5, objectState$5, e$2, ((1 + depth) | 0));
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
function $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sjs_js_Array__sr_ObjectRef__jl_Throwable__I__Lcats_effect_SyncIO(objectState$6, conts$6, t, depth) {
  var f = $as_F1(objectState$6.pop());
  try {
    return $as_Lcats_effect_SyncIO($n(f).apply__O__O(t));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
      return $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$6, objectState$6, e$2, ((1 + depth) | 0));
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
/** @constructor */
function $c_Lcats_effect_SyncIO() {
}
$c_Lcats_effect_SyncIO.prototype = new $h_O();
$c_Lcats_effect_SyncIO.prototype.constructor = $c_Lcats_effect_SyncIO;
/** @constructor */
function $h_Lcats_effect_SyncIO() {
}
$h_Lcats_effect_SyncIO.prototype = $c_Lcats_effect_SyncIO.prototype;
$c_Lcats_effect_SyncIO.prototype.productR__Lcats_effect_SyncIO__Lcats_effect_SyncIO = (function(that) {
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => that));
  return new $c_Lcats_effect_SyncIO$FlatMap(this, f);
});
$c_Lcats_effect_SyncIO.prototype.toString__T = (function() {
  return "SyncIO(...)";
});
$c_Lcats_effect_SyncIO.prototype.unsafeRunSync__O = (function() {
  var elem = [0];
  var conts = new $c_sr_ObjectRef(elem);
  var objectState = [];
  var stack = conts.sr_ObjectRef__f_elem;
  var c = $uI(stack[0]);
  var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
  var s = ((1 + (c >> 3)) | 0);
  var shift = ((7 & c) << 2);
  use[s] = (($uI(use[s]) & (~((-1) << shift))) | (3 << shift));
  use[0] = ((1 + $uI(use[0])) | 0);
  conts.sr_ObjectRef__f_elem = use;
  return $ps_Lcats_effect_SyncIO__runLoop$1__sjs_js_Array__sr_ObjectRef__Lcats_effect_SyncIO__O(objectState, conts, this);
});
function $as_Lcats_effect_SyncIO(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO"));
}
function $isArrayOf_Lcats_effect_SyncIO(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO)));
}
function $asArrayOf_Lcats_effect_SyncIO(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO;", depth));
}
/** @constructor */
function $c_Lcats_effect_instances_package$spawn$() {
}
$c_Lcats_effect_instances_package$spawn$.prototype = new $h_O();
$c_Lcats_effect_instances_package$spawn$.prototype.constructor = $c_Lcats_effect_instances_package$spawn$;
/** @constructor */
function $h_Lcats_effect_instances_package$spawn$() {
}
$h_Lcats_effect_instances_package$spawn$.prototype = $c_Lcats_effect_instances_package$spawn$.prototype;
var $d_Lcats_effect_instances_package$spawn$ = new $TypeData().initClass($c_Lcats_effect_instances_package$spawn$, "cats.effect.instances.package$spawn$", ({
  Lcats_effect_instances_package$spawn$: 1,
  Lcats_effect_kernel_instances_GenSpawnInstances: 1
}));
var $n_Lcats_effect_instances_package$spawn$;
function $m_Lcats_effect_instances_package$spawn$() {
  if ((!$n_Lcats_effect_instances_package$spawn$)) {
    $n_Lcats_effect_instances_package$spawn$ = new $c_Lcats_effect_instances_package$spawn$();
  }
  return $n_Lcats_effect_instances_package$spawn$;
}
function $f_Lcats_effect_kernel_Fiber__joinWith__O__Lcats_effect_kernel_MonadCancel__O($thiz, onCancel, F) {
  var target = $thiz.join__O();
  var this$2 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    var _$2$1 = $as_Lcats_effect_kernel_Outcome(_$2);
    return $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O($n(_$2$1), onCancel, F);
  }));
  return $n(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
}
function $f_Lcats_effect_kernel_Fiber__joinWithUnit__Lcats_effect_kernel_MonadCancel__s_$less$colon$less__O($thiz, F, ev) {
  return $f_Lcats_effect_kernel_Fiber__joinWith__O__Lcats_effect_kernel_MonadCancel__O($thiz, $n(F).unit__O(), F);
}
function $is_Lcats_effect_kernel_Fiber(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Fiber)));
}
function $as_Lcats_effect_kernel_Fiber(obj) {
  return (($is_Lcats_effect_kernel_Fiber(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Fiber"));
}
function $isArrayOf_Lcats_effect_kernel_Fiber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Fiber)));
}
function $asArrayOf_Lcats_effect_kernel_Fiber(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Fiber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Fiber;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Par$ParallelFImpl() {
}
$c_Lcats_effect_kernel_Par$ParallelFImpl.prototype = new $h_O();
$c_Lcats_effect_kernel_Par$ParallelFImpl.prototype.constructor = $c_Lcats_effect_kernel_Par$ParallelFImpl;
/** @constructor */
function $h_Lcats_effect_kernel_Par$ParallelFImpl() {
}
$h_Lcats_effect_kernel_Par$ParallelFImpl.prototype = $c_Lcats_effect_kernel_Par$ParallelFImpl.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1(F$7) {
  this.Lcats_effect_kernel_Ref$MakeInstances$$anon$1__f_F$5 = null;
  this.Lcats_effect_kernel_Ref$MakeInstances$$anon$1__f_F$5 = F$7;
}
$c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$MakeInstances$$anon$1() {
}
$h_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype = $c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype;
$c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1.prototype.refOf__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Ref$MakeInstances$$anon$1__f_F$5).ref__O__O(a);
});
var $d_Lcats_effect_kernel_Ref$MakeInstances$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Ref$MakeInstances$$anon$1, "cats.effect.kernel.Ref$MakeInstances$$anon$1", ({
  Lcats_effect_kernel_Ref$MakeInstances$$anon$1: 1,
  Lcats_effect_kernel_Ref$Make: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2(F$8) {
  this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6 = null;
  this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6 = F$8;
}
$c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2() {
}
$h_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype = $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype;
$c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2.prototype.refOf__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var F = this.Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2__f_F$6;
    return new $c_Lcats_effect_kernel_SyncRef(a, F);
  })));
});
var $d_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2 = new $TypeData().initClass($c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2, "cats.effect.kernel.Ref$MakeLowPriorityInstances$$anon$2", ({
  Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2: 1,
  Lcats_effect_kernel_Ref$Make: 1
}));
function $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$1) {
  if ((Nil$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$Nil$2$(($n(Nil$lzy1$1).sr_LazyRef__f__initialized ? $n(Nil$lzy1$1).sr_LazyRef__f__value : $n(Nil$lzy1$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$Nil$2$())));
}
function $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$2) {
  return $as_Lcats_effect_kernel_Resource$Nil$2$(($n(Nil$lzy1$2).sr_LazyRef__f__initialized ? $n(Nil$lzy1$2).sr_LazyRef__f__value : $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$2)));
}
function $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$1) {
  if ((Frame$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$Frame$3$(($n(Frame$lzy1$1).sr_LazyRef__f__initialized ? $n(Frame$lzy1$1).sr_LazyRef__f__value : $n(Frame$lzy1$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$Frame$3$($thiz))));
}
function $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$2) {
  return $as_Lcats_effect_kernel_Resource$Frame$3$(($n(Frame$lzy1$2).sr_LazyRef__f__initialized ? $n(Frame$lzy1$2).sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$2)));
}
function $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3, current, stack) {
  var stack$tailLocal1 = stack;
  var current$tailLocal1 = current;
  while (true) {
    var x25 = current$tailLocal1;
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
      var x$1 = $as_Lcats_effect_kernel_Resource$Allocate(x25);
      var this$2 = $n(x$1);
      var x38 = this$2.Lcats_effect_kernel_Resource$Allocate__f_resource;
      var $x_1 = $n(F$1);
      var stack$tailLocal1$2$1 = stack$tailLocal1;
      return $x_1.bracketFull__F1__F1__F2__O(x38, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((stack$tailLocal1$2, onOutput$1, Nil$lzy1$3, Frame$lzy1$3, F$1, onRelease$1) => ((x$1$1) => {
        var x$1$2 = $as_T2(x$1$1);
        if ((x$1$2 !== null)) {
          var a = $n(x$1$2)._1__O();
          var x = $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$3);
          if ((x === null)) {
            var $x_2 = (stack$tailLocal1$2 === null);
          } else {
            var this$4 = $n(x);
            var $x_2 = (this$4 === stack$tailLocal1$2);
          }
          if ($x_2) {
            return $n(onOutput$1).apply__O__O(a);
          }
          if ((stack$tailLocal1$2 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
            $n($p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$3));
            var x$1$3 = $as_Lcats_effect_kernel_Resource$Frame$1(stack$tailLocal1$2);
            var this$6 = $n(x$1$3);
            var x10 = this$6.Lcats_effect_kernel_Resource$Frame$1__f_head;
            var this$7 = $n(x$1$3);
            var x11 = this$7.Lcats_effect_kernel_Resource$Frame$1__f_tail;
            var current$1 = $as_Lcats_effect_kernel_Resource($n(x10).apply__O__O(a));
            return $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3, current$1, x11);
          }
          throw new $c_s_MatchError(stack$tailLocal1$2);
        }
        throw new $c_s_MatchError(x$1$2);
      }))(stack$tailLocal1$2$1, onOutput$1, Nil$lzy1$3, Frame$lzy1$3, F$1, onRelease$1)), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((onRelease$1) => ((x$1$2$1, x$2) => {
        var x$1$4 = $as_T2(x$1$2$1);
        var x$2$1 = $as_Lcats_effect_kernel_Outcome(x$2);
        var x15 = new $c_T2(x$1$4, x$2$1);
        var x16 = $as_T2(x15.T2__f__1);
        if ((x16 !== null)) {
          var release = $as_F1($n(x16)._2__O());
          var outcome = $as_Lcats_effect_kernel_Outcome(x15.T2__f__2);
          return $n(onRelease$1).apply__O__O__O(release, $m_Lcats_effect_kernel_Resource$ExitCase$().fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase(outcome));
        }
        throw new $c_s_MatchError(x15);
      }))(onRelease$1)));
    }
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
      var x$1$5 = $as_Lcats_effect_kernel_Resource$Bind(x25);
      var this$10 = $n(x$1$5);
      var x34 = this$10.Lcats_effect_kernel_Resource$Bind__f_source;
      var this$11 = $n(x$1$5);
      var x35 = this$11.Lcats_effect_kernel_Resource$Bind__f_fs;
      var stack$tailLocal1$tmp1 = $n($p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$3)).apply__F1__Lcats_effect_kernel_Resource$Stack$1__Lcats_effect_kernel_Resource$Frame$1(x35, stack$tailLocal1);
      current$tailLocal1 = x34;
      stack$tailLocal1 = stack$tailLocal1$tmp1;
      continue;
    }
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
      var x$1$6 = $as_Lcats_effect_kernel_Resource$Pure(x25);
      var this$13 = $n(x$1$6);
      var x31 = this$13.Lcats_effect_kernel_Resource$Pure__f_a;
      var x20 = stack$tailLocal1;
      var x$3 = $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1$3);
      if ((x$3 === null)) {
        var $x_3 = (x20 === null);
      } else {
        var this$14 = $n(x$3);
        var $x_3 = (this$14 === x20);
      }
      if ($x_3) {
        return $n(onOutput$1).apply__O__O(x31);
      }
      if ((x20 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
        $n($p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$3$($thiz, Frame$lzy1$3));
        var x$1$7 = $as_Lcats_effect_kernel_Resource$Frame$1(x20);
        var this$16 = $n(x$1$7);
        var x23 = this$16.Lcats_effect_kernel_Resource$Frame$1__f_head;
        var this$17 = $n(x$1$7);
        var x24 = this$17.Lcats_effect_kernel_Resource$Frame$1__f_tail;
        var current$tailLocal1$tmp2 = $as_Lcats_effect_kernel_Resource($n(x23).apply__O__O(x31));
        current$tailLocal1 = current$tailLocal1$tmp2;
        stack$tailLocal1 = x24;
        continue;
      }
      throw new $c_s_MatchError(x20);
    }
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
      var x$1$8 = $as_Lcats_effect_kernel_Resource$Eval(x25);
      var this$19 = $n(x$1$8);
      var x28 = this$19.Lcats_effect_kernel_Resource$Eval__f_fa;
      var this$23 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x28, F$1);
      var stack$tailLocal1$3$1 = stack$tailLocal1;
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((stack$tailLocal1$3, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3) => ((a$1) => {
        var current$2 = new $c_Lcats_effect_kernel_Resource$Pure(a$1);
        return $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3, current$2, stack$tailLocal1$3);
      }))(stack$tailLocal1$3$1, F$1, onOutput$1, onRelease$1, Nil$lzy1$3, Frame$lzy1$3));
      return $n(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    }
    throw new $c_s_MatchError(x25);
  }
}
function $ps_Lcats_effect_kernel_Resource__allocate$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource__F1__O(F$7, r, storeFinalizer) {
  return $n(r).fold__F1__F2__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => $n(F$7).pure__O__O(_$8))), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((release, _$9) => {
    var release$1 = $as_F1(release);
    $as_Lcats_effect_kernel_Resource$ExitCase(_$9);
    return $n(storeFinalizer).apply__O__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fin) => {
      var fin$1 = $as_F1(fin);
      return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ec) => {
        var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
        var fa = $n(F$7).unit__O();
        return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
          var wrapped = $n(fin$1).apply__O__O(ec$1);
          var fin$2 = $n(release$1).apply__O__O(ec$1);
          return $n(F$7).guarantee__O__O__O(wrapped, fin$2);
        })), F$7);
      }));
    })));
  })), F$7);
}
function $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$1) {
  if ((Nil$lzy2$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$Nil$4$(($n(Nil$lzy2$1).sr_LazyRef__f__initialized ? $n(Nil$lzy2$1).sr_LazyRef__f__value : $n(Nil$lzy2$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$Nil$4$())));
}
function $ps_Lcats_effect_kernel_Resource__Nil$3__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$2) {
  return $as_Lcats_effect_kernel_Resource$Nil$4$(($n(Nil$lzy2$2).sr_LazyRef__f__initialized ? $n(Nil$lzy2$2).sr_LazyRef__f__value : $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$2)));
}
function $p_Lcats_effect_kernel_Resource__Frame$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$1) {
  if ((Frame$lzy2$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$Frame$6$(($n(Frame$lzy2$1).sr_LazyRef__f__initialized ? $n(Frame$lzy2$1).sr_LazyRef__f__value : $n(Frame$lzy2$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$Frame$6$($thiz))));
}
function $p_Lcats_effect_kernel_Resource__Frame$5__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$2) {
  return $as_Lcats_effect_kernel_Resource$Frame$6$(($n(Frame$lzy2$2).sr_LazyRef__f__initialized ? $n(Frame$lzy2$2).sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__Frame$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$2)));
}
function $p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O($thiz, F$37, Nil$lzy2$3, Frame$lzy2$3, current, stack, release) {
  var stack$tailLocal2 = stack;
  var current$tailLocal2 = current;
  while (true) {
    var x133 = current$tailLocal2;
    if ((x133 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
      var x$1 = $as_Lcats_effect_kernel_Resource$Allocate(x133);
      var this$2 = $n(x$1);
      var x146 = this$2.Lcats_effect_kernel_Resource$Allocate__f_resource;
      var $x_1 = $n(F$37);
      var stack$tailLocal2$2$1 = stack$tailLocal2;
      return $x_1.uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x146, F$37, release, stack$tailLocal2$2, Nil$lzy2$3, Frame$lzy2$3) => ((poll) => {
        var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
        var target = $n(x146).apply__O__O(poll$1);
        var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$37);
        var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$1) => {
          var x$1$2 = $as_T2(x$1$1);
          if ((x$1$2 !== null)) {
            var b = $n(x$1$2)._1__O();
            var rel = $as_F1($n(x$1$2)._2__O());
            var rel2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ec) => {
              var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
              var wrapped = $n(rel).apply__O__O(ec$1);
              var fa = $n(F$37).unit__O();
              var fin = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(release).apply__O__O(ec$1))), F$37);
              return $n(F$37).guarantee__O__O__O(wrapped, fin);
            }));
            var x = $ps_Lcats_effect_kernel_Resource__Nil$3__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$3);
            if ((x === null)) {
              var $x_2 = (stack$tailLocal2$2 === null);
            } else {
              var this$8 = $n(x);
              var $x_2 = (this$8 === stack$tailLocal2$2);
            }
            if ($x_2) {
              return $n(F$37).pure__O__O(new $c_T2(b, rel2));
            }
            if ((stack$tailLocal2$2 instanceof $c_Lcats_effect_kernel_Resource$Frame$4)) {
              $n($p_Lcats_effect_kernel_Resource__Frame$5__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$3));
              var x$1$3 = $as_Lcats_effect_kernel_Resource$Frame$4(stack$tailLocal2$2);
              var this$11 = $n(x$1$3);
              var x123 = this$11.Lcats_effect_kernel_Resource$Frame$4__f_head;
              var this$12 = $n(x$1$3);
              var x124 = this$12.Lcats_effect_kernel_Resource$Frame$4__f_tail;
              var $x_3 = $n(poll$1);
              var current$1 = $as_Lcats_effect_kernel_Resource($n(x123).apply__O__O(b));
              var wrapped$1 = $x_3.apply__O__O($p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O($thiz, F$37, Nil$lzy2$3, Frame$lzy2$3, current$1, x124, rel2));
              var fin$1 = $n(rel).apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
              var fa$1 = $n(F$37).onCancel__O__O__O(wrapped$1, fin$1);
              var pf = new $c_Lcats_effect_kernel_Resource$$anon$2(rel, F$37);
              return $n(F$37).onError__O__s_PartialFunction__O(fa$1, pf);
            }
            throw new $c_s_MatchError(stack$tailLocal2$2);
          }
          throw new $c_s_MatchError(x$1$2);
        }));
        return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
      }))(x146, F$37, release, stack$tailLocal2$2$1, Nil$lzy2$3, Frame$lzy2$3)));
    }
    if ((x133 instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
      var x$1$4 = $as_Lcats_effect_kernel_Resource$Bind(x133);
      var this$19 = $n(x$1$4);
      var x142 = this$19.Lcats_effect_kernel_Resource$Bind__f_source;
      var this$20 = $n(x$1$4);
      var x143 = this$20.Lcats_effect_kernel_Resource$Bind__f_fs;
      var stack$tailLocal2$tmp1 = $n($p_Lcats_effect_kernel_Resource__Frame$5__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$3)).apply__F1__Lcats_effect_kernel_Resource$Stack$2__Lcats_effect_kernel_Resource$Frame$4(x143, stack$tailLocal2);
      current$tailLocal2 = x142;
      stack$tailLocal2 = stack$tailLocal2$tmp1;
      continue;
    }
    if ((x133 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
      var x$1$5 = $as_Lcats_effect_kernel_Resource$Pure(x133);
      var this$22 = $n(x$1$5);
      var x139 = this$22.Lcats_effect_kernel_Resource$Pure__f_a;
      var x128 = stack$tailLocal2;
      var x$2 = $ps_Lcats_effect_kernel_Resource__Nil$3__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2$3);
      if ((x$2 === null)) {
        var $x_4 = (x128 === null);
      } else {
        var this$23 = $n(x$2);
        var $x_4 = (this$23 === x128);
      }
      if ($x_4) {
        var a = new $c_T2(x139, release);
        return $n(F$37).pure__O__O(a);
      }
      if ((x128 instanceof $c_Lcats_effect_kernel_Resource$Frame$4)) {
        $n($p_Lcats_effect_kernel_Resource__Frame$5__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$6$($thiz, Frame$lzy2$3));
        var x$1$6 = $as_Lcats_effect_kernel_Resource$Frame$4(x128);
        var this$28 = $n(x$1$6);
        var x131 = this$28.Lcats_effect_kernel_Resource$Frame$4__f_head;
        var this$29 = $n(x$1$6);
        var x132 = this$29.Lcats_effect_kernel_Resource$Frame$4__f_tail;
        var current$tailLocal2$tmp2 = $as_Lcats_effect_kernel_Resource($n(x131).apply__O__O(x139));
        current$tailLocal2 = current$tailLocal2$tmp2;
        stack$tailLocal2 = x132;
        continue;
      }
      throw new $c_s_MatchError(x128);
    }
    if ((x133 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
      var x$1$7 = $as_Lcats_effect_kernel_Resource$Eval(x133);
      var this$31 = $n(x$1$7);
      var x136 = this$31.Lcats_effect_kernel_Resource$Eval__f_fa;
      var this$35 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x136, F$37);
      var stack$tailLocal2$3$1 = stack$tailLocal2;
      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((stack$tailLocal2$3, release, F$37, Nil$lzy2$3, Frame$lzy2$3) => ((a$1) => {
        var current$2 = new $c_Lcats_effect_kernel_Resource$Pure(a$1);
        return $p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O($thiz, F$37, Nil$lzy2$3, Frame$lzy2$3, current$2, stack$tailLocal2$3, release);
      }))(stack$tailLocal2$3$1, release, F$37, Nil$lzy2$3, Frame$lzy2$3));
      return $n(this$35.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$35.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    }
    throw new $c_s_MatchError(x133);
  }
}
function $p_Lcats_effect_kernel_Resource__State$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource$State$3$($thiz, State$lzy1$1, F$52) {
  if ((State$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_kernel_Resource$State$3$(($n(State$lzy1$1).sr_LazyRef__f__initialized ? $n(State$lzy1$1).sr_LazyRef__f__value : $n(State$lzy1$1).initialize__O__O(new $c_Lcats_effect_kernel_Resource$State$3$(F$52, $thiz))));
}
function $p_Lcats_effect_kernel_Resource__State$2__sr_LazyRef__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource$State$3$($thiz, State$lzy1$2, F$53) {
  return $as_Lcats_effect_kernel_Resource$State$3$(($n(State$lzy1$2).sr_LazyRef__f__initialized ? $n(State$lzy1$2).sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__State$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource$State$3$($thiz, State$lzy1$2, F$53)));
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource() {
}
$c_Lcats_effect_kernel_Resource.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource.prototype.constructor = $c_Lcats_effect_kernel_Resource;
/** @constructor */
function $h_Lcats_effect_kernel_Resource() {
}
$h_Lcats_effect_kernel_Resource.prototype = $c_Lcats_effect_kernel_Resource.prototype;
$c_Lcats_effect_kernel_Resource.prototype.fold__F1__F2__Lcats_effect_kernel_MonadCancel__O = (function(onOutput, onRelease, F) {
  var Nil$lzy1 = new $c_sr_LazyRef();
  var Frame$lzy1 = new $c_sr_LazyRef();
  return $p_Lcats_effect_kernel_Resource__loop$1__Lcats_effect_kernel_MonadCancel__F1__F2__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O(this, F, onOutput, onRelease, Nil$lzy1, Frame$lzy1, this, $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy1));
});
$c_Lcats_effect_kernel_Resource.prototype.use__F1__Lcats_effect_kernel_MonadCancel__O = (function(f, F) {
  return this.fold__F1__F2__Lcats_effect_kernel_MonadCancel__O(f, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$2, _$3) => {
    var _$2$1 = $as_F1(_$2);
    var _$3$1 = $as_Lcats_effect_kernel_Resource$ExitCase(_$3);
    return $n(_$2$1).apply__O__O(_$3$1);
  })), F);
});
$c_Lcats_effect_kernel_Resource.prototype.useForever__Lcats_effect_kernel_GenSpawn__O = (function(F) {
  return this.use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => $n(F).never__O())), F);
});
$c_Lcats_effect_kernel_Resource.prototype.use___Lcats_effect_kernel_MonadCancel__O = (function(F) {
  return this.use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => $n(F).unit__O())), F);
});
$c_Lcats_effect_kernel_Resource.prototype.both__Lcats_effect_kernel_Resource__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(that, F) {
  var noop = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
    $as_Lcats_effect_kernel_Resource$ExitCase(_$10);
    return $n(F).unit__O();
  }));
  var bothFinalizers = $n(F).ref__O__O(new $c_T2(noop, noop));
  return $n($m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource(bothFinalizers, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((finalizers, ec) => {
    var finalizers$1 = $as_Lcats_effect_kernel_Ref(finalizers);
    var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
    var target = $n(finalizers$1).get__O();
    var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var thisFin = $as_F1($n(x$1$1)._1__O());
        var thatFin = $as_F1($n(x$1$1)._2__O());
        return $n(F).void__O__O($n(F).both__O__O__O($n(thisFin).apply__O__O(ec$1), $n(thatFin).apply__O__O(ec$1)));
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })), F)).evalMap__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((store) => {
    var store$1 = $as_Lcats_effect_kernel_Ref(store);
    var thisStore = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((f$1) => {
      var f$2 = $as_F1(f$1);
      return $n(store$1).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$11) => {
        var _$11$1 = $as_T2(_$11);
        var this$5 = $m_Lcats_Bifunctor$();
        var tc = $f_Lcats_instances_NTupleBifunctorInstances__catsStdBifunctorForTuple2__Lcats_Bifunctor(this$5);
        var this$8 = new $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5(_$11$1, tc);
        var g = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => {
          var x$2 = $as_F1(x);
          return x$2;
        }));
        return $as_T2($n(this$8.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_typeClassInstance).bimap__O__F1__F1__O(this$8.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_self, f$2, g));
      })));
    }));
    var thatStore = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((f$2$1) => {
      var f$3 = $as_F1(f$2$1);
      return $n(store$1).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$12) => {
        var _$12$1 = $as_T2(_$12);
        var this$9 = $m_Lcats_Bifunctor$();
        var tc$1 = $f_Lcats_instances_NTupleBifunctorInstances__catsStdBifunctorForTuple2__Lcats_Bifunctor(this$9);
        var this$12 = new $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5(_$12$1, tc$1);
        var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$3) => {
          var x$4 = $as_F1(x$3);
          return x$4;
        }));
        return $as_T2($n(this$12.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_typeClassInstance).bimap__O__F1__F1__O(this$12.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_self, f$4, f$3));
      })));
    }));
    return $n(F).both__O__O__O($ps_Lcats_effect_kernel_Resource__allocate$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource__F1__O(F, this, thisStore), $ps_Lcats_effect_kernel_Resource__allocate$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource__F1__O(F, that, thatStore));
  })));
});
$c_Lcats_effect_kernel_Resource.prototype.map__F1__Lcats_effect_kernel_Resource = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
    var a$1 = $n(f).apply__O__O(a);
    return new $c_Lcats_effect_kernel_Resource$Pure(a$1);
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this, f$1);
});
$c_Lcats_effect_kernel_Resource.prototype.onFinalize__O__Lcats_Applicative__Lcats_effect_kernel_Resource = (function(finalizer, F) {
  return this.onFinalizeCase__F1__Lcats_Applicative__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$23) => {
    $as_Lcats_effect_kernel_Resource$ExitCase(_$23);
    return finalizer;
  })), F);
});
$c_Lcats_effect_kernel_Resource.prototype.onFinalizeCase__F1__Lcats_Applicative__Lcats_effect_kernel_Resource = (function(f, F) {
  var this$2 = $n($m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource($n(F).unit__O(), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$24, ec) => {
    $as_jl_Void(_$24);
    var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
    return $n(f).apply__O__O(ec$1);
  })), F));
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$25) => {
    $as_jl_Void(_$25);
    return this;
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$2, f$1);
});
$c_Lcats_effect_kernel_Resource.prototype.allocatedCase__Lcats_effect_kernel_MonadCancel__O = (function(F) {
  var Nil$lzy2 = new $c_sr_LazyRef();
  var Frame$lzy2 = new $c_sr_LazyRef();
  return $p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O(this, F, Nil$lzy2, Frame$lzy2, this, $ps_Lcats_effect_kernel_Resource__Nil$3__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$4$(Nil$lzy2), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$27) => {
    $as_Lcats_effect_kernel_Resource$ExitCase(_$27);
    return $n(F).unit__O();
  })));
});
$c_Lcats_effect_kernel_Resource.prototype.allocated__Lcats_effect_kernel_MonadCancel__O = (function(F) {
  return $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(poll$1).apply__O__O(this.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F));
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var b = $n(x$1$1)._1__O();
        var fin = $as_F1($n(x$1$1)._2__O());
        var _2 = $n(fin).apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
        return new $c_T2(b, _2);
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  })));
});
$c_Lcats_effect_kernel_Resource.prototype.evalMap__F1__Lcats_effect_kernel_Resource = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
    var fa = $n(f).apply__O__O(a);
    return new $c_Lcats_effect_kernel_Resource$Eval(fa);
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this, f$1);
});
$c_Lcats_effect_kernel_Resource.prototype.surround__O__Lcats_effect_kernel_MonadCancel__O = (function(gb, F) {
  return this.use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$29) => gb)), F);
});
$c_Lcats_effect_kernel_Resource.prototype.forceR__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(that, F) {
  var resource = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var $x_1 = $n(poll$1);
    var wrapped = this.use___Lcats_effect_kernel_MonadCancel__O(F);
    var fb = $n(that).allocatedCase__Lcats_effect_kernel_MonadCancel__O(F);
    return $x_1.apply__O__O($n(F).forceR__O__O__O(wrapped, fb));
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource.prototype.onCancel__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(fin, F) {
  var resource = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var wrapped = $n(poll$1).apply__O__O(this.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F));
    var fin$1 = $n(fin).use___Lcats_effect_kernel_MonadCancel__O(F);
    return $n(F).onCancel__O__O__O(wrapped, fin$1);
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource.prototype.guaranteeCase__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(fin, F) {
  var resource = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var this$2 = $m_Lcats_effect_kernel_implicits$();
    var wrapped = $n(poll$1).apply__O__O(this.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F));
    var ev$30 = $f_Lcats_effect_kernel_syntax_MonadCancelSyntax__monadCancelOps__O__Lcats_effect_kernel_MonadCancel__O(this$2, wrapped, F);
    var fin$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
      if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
        var this$4 = $n(x$1$2);
        var x157 = this$4.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(x157, F);
        var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$31) => {
          var _$31$1 = $as_T2(_$31);
          return $n(_$31$1)._1__O();
        }));
        var fa = $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
        var fa$1 = new $c_Lcats_effect_kernel_Resource$Eval(fa);
        var fa$2 = $n($as_Lcats_effect_kernel_Resource($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1)))).use___Lcats_effect_kernel_MonadCancel__O(F);
        var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => {
          var e$1 = $as_jl_Throwable(e);
          var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x157, F);
          var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$32) => {
            var _$32$1 = $as_T2(_$32);
            return $n($as_F1($n(_$32$1)._2__O())).apply__O__O(new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e$1));
          }));
          var fa$3 = $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$33) => {
            $as_jl_Throwable(_$33);
          }));
          var fa$4 = $n(F).handleError__O__F1__O(fa$3, f$2);
          return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$4, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(F).raiseError__O__O(e$1))), F);
        }));
        return $n(F).handleErrorWith__O__F1__O(fa$2, f$3);
      }
      if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
        var this$19 = $n(x$1$3);
        var x154 = $as_jl_Throwable(this$19.Lcats_effect_kernel_Outcome$Errored__f_e);
        var fa$5 = $n($as_Lcats_effect_kernel_Resource($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x154)))).use___Lcats_effect_kernel_MonadCancel__O(F);
        var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$34) => {
          $as_jl_Throwable(_$34);
        }));
        return $n(F).handleError__O__F1__O(fa$5, f$4);
      }
      if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
        return $n($as_Lcats_effect_kernel_Resource($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()))).use___Lcats_effect_kernel_MonadCancel__O(F);
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(F).guaranteeCase__O__F1__O(ev$30, fin$1);
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource.prototype.start__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(F) {
  var State$lzy1 = new $c_sr_LazyRef();
  var $x_7 = $m_Lcats_effect_kernel_Resource$();
  var target = $n(F).ref__O__O($n($p_Lcats_effect_kernel_Resource__State$2__sr_LazyRef__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource$State$3$(this, State$lzy1, F)).apply__O__Z__Z__Lcats_effect_kernel_Resource$State$1($n($p_Lcats_effect_kernel_Resource__State$2__sr_LazyRef__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource$State$3$(this, State$lzy1, F)).$lessinit$greater$default$1__O(), ($n($p_Lcats_effect_kernel_Resource__State$2__sr_LazyRef__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource$State$3$(this, State$lzy1, F)), false), ($n($p_Lcats_effect_kernel_Resource__State$2__sr_LazyRef__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource$State$3$(this, State$lzy1, F)), false)));
  var this$27 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    var finalized = $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var wrapped = $n(poll$1).apply__O__O(this.allocated__Lcats_effect_kernel_MonadCancel__O(F));
      var fin = $n(state$1).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => {
        var s$1 = $as_Lcats_effect_kernel_Resource$State$1(s);
        if ($n(s$1).Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete) {
          var $x_2 = $n(s$1);
          var this$4 = $n(s$1);
          var $x_1 = this$4.Lcats_effect_kernel_Resource$State$1__f_fin;
          var this$5 = $n(s$1);
          return $x_2.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1($x_1, this$5.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete, true);
        } else {
          return s$1;
        }
      })));
      var target$1 = $n(F).guarantee__O__O__O(wrapped, fin);
      var this$18 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F);
      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var a = $n(x$1$1)._1__O();
          var rel = $n(x$1$1)._2__O();
          var action = $n(state$1).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s$2) => {
            var s$3 = $as_Lcats_effect_kernel_Resource$State$1(s$2);
            if ($n(s$3).Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete) {
              var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$36) => {
                $as_jl_Throwable(_$36);
              }));
              var _2 = $n(F).handleError__O__F1__O(rel, f);
              return new $c_T2(s$3, _2);
            } else {
              var $x_4 = $n(s$3);
              var this$11 = $n(s$3);
              var $x_3 = this$11.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete;
              var this$12 = $n(s$3);
              var _1 = $x_4.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1(rel, $x_3, this$12.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete);
              var _2$1 = $n(F).unit__O();
              return new $c_T2(_1, _2$1);
            }
          })));
          var target$2 = $f_Lcats_FlatMap__flatten__O__O($n(F), action);
          var this$17 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
          return $n(this$17.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$17.Lcats_Functor$ToFunctorOps$$anon$5__f_self, a);
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
    })));
    var target$3 = $n(F).start__O__O(finalized);
    var this$26 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
    var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((outer) => {
      var outer$1 = $as_Lcats_effect_kernel_Fiber(outer);
      var fiber = new $c_Lcats_effect_kernel_Resource$$anon$4(F, outer$1, state$1);
      var ffa = $n(state$1).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s$4) => {
        var s$5 = $as_Lcats_effect_kernel_Resource$State$1(s$4);
        var $x_6 = $n(s$5);
        var this$20 = $n(s$5);
        var $x_5 = this$20.Lcats_effect_kernel_Resource$State$1__f_fin;
        var this$21 = $n(s$5);
        var _1$1 = $x_6.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1($x_5, true, this$21.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete);
        var _2$2 = $n(s$5).Lcats_effect_kernel_Resource$State$1__f_fin;
        return new $c_T2(_1$1, _2$2);
      })));
      var finalizeOuter = $f_Lcats_FlatMap__flatten__O__O($n(F), ffa);
      return new $c_T2(fiber, finalizeOuter);
    }));
    return $n(this$26.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$26.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$2);
  }));
  return $x_7.apply__O__Lcats_Functor__Lcats_effect_kernel_Resource($n(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3), F);
});
$c_Lcats_effect_kernel_Resource.prototype.attempt__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(F) {
  var resource = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var fa = $n(poll$1).apply__O__O(this.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F));
    var target = $n(F).attempt__O__O(fa);
    var this$10 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_s_util_Either(x$1);
      if ((x$1$1 instanceof $c_s_util_Right)) {
        var x206 = $as_T2($n($as_s_util_Right(x$1$1)).s_util_Right__f_value);
        if ((x206 !== null)) {
          var a = $n(x206)._1__O();
          var r = $as_F1($n(x206)._2__O());
          var _1 = new $c_s_util_Right(a);
          return new $c_T2(_1, r);
        }
      }
      var _2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$46) => {
        $as_Lcats_effect_kernel_Resource$ExitCase(_$46);
        return $n(F).unit__O();
      }));
      return new $c_T2(x$1$1, _2);
    }));
    return $n(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource.prototype.handleErrorWith__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(f, F) {
  var this$3 = $n(this.attempt__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(F));
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    if ((x$1$1 instanceof $c_s_util_Right)) {
      var a = $n($as_s_util_Right(x$1$1)).s_util_Right__f_value;
      return new $c_Lcats_effect_kernel_Resource$Pure(a);
    }
    if ((x$1$1 instanceof $c_s_util_Left)) {
      var e = $as_jl_Throwable($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
      return $as_Lcats_effect_kernel_Resource($n(f).apply__O__O(e));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$3, f$1);
});
function $as_Lcats_effect_kernel_Resource(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource"));
}
function $isArrayOf_Lcats_effect_kernel_Resource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource)));
}
function $asArrayOf_Lcats_effect_kernel_Resource(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceFOInstances0() {
}
$c_Lcats_effect_kernel_ResourceFOInstances0.prototype = new $h_Lcats_effect_kernel_ResourceFOInstances1();
$c_Lcats_effect_kernel_ResourceFOInstances0.prototype.constructor = $c_Lcats_effect_kernel_ResourceFOInstances0;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceFOInstances0() {
}
$h_Lcats_effect_kernel_ResourceFOInstances0.prototype = $c_Lcats_effect_kernel_ResourceFOInstances0.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_Unique$Token() {
}
$c_Lcats_effect_kernel_Unique$Token.prototype = new $h_O();
$c_Lcats_effect_kernel_Unique$Token.prototype.constructor = $c_Lcats_effect_kernel_Unique$Token;
/** @constructor */
function $h_Lcats_effect_kernel_Unique$Token() {
}
$h_Lcats_effect_kernel_Unique$Token.prototype = $c_Lcats_effect_kernel_Unique$Token.prototype;
function $as_Lcats_effect_kernel_Unique$Token(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Unique$Token) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Unique$Token"));
}
function $isArrayOf_Lcats_effect_kernel_Unique$Token(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Unique$Token)));
}
function $asArrayOf_Lcats_effect_kernel_Unique$Token(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Unique$Token(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Unique$Token;", depth));
}
var $d_Lcats_effect_kernel_Unique$Token = new $TypeData().initClass($c_Lcats_effect_kernel_Unique$Token, "cats.effect.kernel.Unique$Token", ({
  Lcats_effect_kernel_Unique$Token: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_AtomicCell$AsyncImpl(init, mutex, F) {
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_mutex = null;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F = null;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_cell = null;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_mutex = mutex;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F = F;
  this.Lcats_effect_std_AtomicCell$AsyncImpl__f_cell = init;
}
$c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype = new $h_Lcats_effect_std_AtomicCell();
$c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype.constructor = $c_Lcats_effect_std_AtomicCell$AsyncImpl;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell$AsyncImpl() {
}
$h_Lcats_effect_std_AtomicCell$AsyncImpl.prototype = $c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype;
$c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype.evalModify__F1__O = (function(f) {
  var $x_1 = $n($n(this.Lcats_effect_std_AtomicCell$AsyncImpl__f_mutex).Lcats_effect_std_Mutex$ConcurrentImpl__f_lock);
  var target = $n(this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.Lcats_effect_std_AtomicCell$AsyncImpl__f_cell)));
  var tc = this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F;
  var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var target$1 = $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  var tc$1 = this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F;
  var this$5 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1)._1__O();
      var b = $n(x$1$1)._2__O();
      return $n(this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        this.Lcats_effect_std_AtomicCell$AsyncImpl__f_cell = a;
        return b;
      })));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $x_1.surround__O__Lcats_effect_kernel_MonadCancel__O($n(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$5.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1), this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F);
});
$c_Lcats_effect_std_AtomicCell$AsyncImpl.prototype.evalUpdate__F1__O = (function(f) {
  return this.evalModify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
    var target = $n(f).apply__O__O(a);
    var tc = this.Lcats_effect_std_AtomicCell$AsyncImpl__f_F;
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((aa) => new $c_T2(aa, (void 0))));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  })));
});
var $d_Lcats_effect_std_AtomicCell$AsyncImpl = new $TypeData().initClass($c_Lcats_effect_std_AtomicCell$AsyncImpl, "cats.effect.std.AtomicCell$AsyncImpl", ({
  Lcats_effect_std_AtomicCell$AsyncImpl: 1,
  Lcats_effect_std_AtomicCell: 1
}));
/** @constructor */
function $c_Lcats_effect_std_AtomicCell$ConcurrentImpl(ref, mutex, F) {
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_ref = null;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_mutex = null;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F = null;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_ref = ref;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_mutex = mutex;
  this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F = F;
}
$c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype = new $h_Lcats_effect_std_AtomicCell();
$c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype.constructor = $c_Lcats_effect_std_AtomicCell$ConcurrentImpl;
/** @constructor */
function $h_Lcats_effect_std_AtomicCell$ConcurrentImpl() {
}
$h_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype = $c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype;
$c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype.evalModify__F1__O = (function(f) {
  var $x_1 = $n($n(this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_mutex).Lcats_effect_std_Mutex$ConcurrentImpl__f_lock);
  var target = $n(this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_ref).get__O();
  var tc = this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F;
  var this$2 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var target$1 = $n(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  var tc$1 = this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F;
  var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1)._1__O();
      var b = $n(x$1$1)._2__O();
      var target$2 = $n(this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_ref).set__O__O(a);
      var tc$2 = this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F;
      var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
      return $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $x_1.surround__O__Lcats_effect_kernel_MonadCancel__O($n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1), this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F);
});
$c_Lcats_effect_std_AtomicCell$ConcurrentImpl.prototype.evalUpdate__F1__O = (function(f) {
  return this.evalModify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
    var target = $n(f).apply__O__O(a);
    var tc = this.Lcats_effect_std_AtomicCell$ConcurrentImpl__f_F;
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((aa) => new $c_T2(aa, (void 0))));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  })));
});
var $d_Lcats_effect_std_AtomicCell$ConcurrentImpl = new $TypeData().initClass($c_Lcats_effect_std_AtomicCell$ConcurrentImpl, "cats.effect.std.AtomicCell$ConcurrentImpl", ({
  Lcats_effect_std_AtomicCell$ConcurrentImpl: 1,
  Lcats_effect_std_AtomicCell: 1
}));
function $is_Lcats_effect_std_Console(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Console)));
}
function $as_Lcats_effect_std_Console(obj) {
  return (($is_Lcats_effect_std_Console(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Console"));
}
function $isArrayOf_Lcats_effect_std_Console(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Console)));
}
function $asArrayOf_Lcats_effect_std_Console(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Console(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Console;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Console$() {
}
$c_Lcats_effect_std_Console$.prototype = new $h_Lcats_effect_std_ConsoleCompanionCrossPlatform();
$c_Lcats_effect_std_Console$.prototype.constructor = $c_Lcats_effect_std_Console$;
/** @constructor */
function $h_Lcats_effect_std_Console$() {
}
$h_Lcats_effect_std_Console$.prototype = $c_Lcats_effect_std_Console$.prototype;
$c_Lcats_effect_std_Console$.prototype.make__Lcats_effect_kernel_Async__Lcats_effect_std_Console = (function(F) {
  try {
    var r1 = process.stdout;
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  var this$2 = $n($x_1.toOption__s_Option());
  if (this$2.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var x0 = this$2.get__O();
    var $x_2 = $m_s_Option$().apply__O__s_Option(x0);
  }
  var this$3 = $n($x_2);
  if (this$3.isEmpty__Z()) {
    var $x_3 = true;
  } else {
    var x0$1 = this$3.get__O();
    var $x_3 = (!(x0$1 === (void 0)));
  }
  if ($x_3) {
    var stdout = this$3;
  } else {
    var stdout = $m_s_None$();
  }
  try {
    var r1$1 = process.stderr;
    var $x_4 = new $c_s_util_Success(r1$1);
  } catch (e$1) {
    var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
    matchEnd8$1: {
      var $x_4;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2$1)) {
        var $x_4 = new $c_s_util_Failure(e$2$1);
        break matchEnd8$1;
      }
      throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : e$2$1);
    }
  }
  var this$6 = $n($x_4.toOption__s_Option());
  if (this$6.isEmpty__Z()) {
    var $x_5 = $m_s_None$();
  } else {
    var x0$2 = this$6.get__O();
    var $x_5 = $m_s_Option$().apply__O__s_Option(x0$2);
  }
  var this$7 = $n($x_5);
  if (this$7.isEmpty__Z()) {
    var $x_6 = true;
  } else {
    var x0$3 = this$7.get__O();
    var $x_6 = (!(x0$3 === (void 0)));
  }
  if ($x_6) {
    var stderr = this$7;
  } else {
    var stderr = $m_s_None$();
  }
  var f = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$8, _$9) => new $c_Lcats_effect_std_Console$NodeJSConsole(_$8, _$9, F)));
  var F$1 = $as_Lcats_Alternative($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
  var this$12 = $n($as_s_Option($n(F$1).map2__O__O__F2__O(stdout, stderr, f)));
  return $as_Lcats_effect_std_Console((this$12.isEmpty__Z() ? new $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole(this, F) : this$12.get__O()));
});
var $d_Lcats_effect_std_Console$ = new $TypeData().initClass($c_Lcats_effect_std_Console$, "cats.effect.std.Console$", ({
  Lcats_effect_std_Console$: 1,
  Lcats_effect_std_ConsoleCompanionCrossPlatform: 1
}));
var $n_Lcats_effect_std_Console$;
function $m_Lcats_effect_std_Console$() {
  if ((!$n_Lcats_effect_std_Console$)) {
    $n_Lcats_effect_std_Console$ = new $c_Lcats_effect_std_Console$();
  }
  return $n_Lcats_effect_std_Console$;
}
function $f_Lcats_effect_std_Dispatcher__unsafeToFuture__O__s_concurrent_Future($thiz, fa) {
  return $as_s_concurrent_Future($n($thiz.unsafeToFutureCancelable__O__T2(fa))._1__O());
}
function $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V($thiz, fa) {
  $n($f_Lcats_effect_std_Dispatcher__unsafeToFuture__O__s_concurrent_Future($thiz, fa)).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_util_Try(x$1);
    if ((x$1$1 instanceof $c_s_util_Failure)) {
      var ex = $n($as_s_util_Failure(x$1$1)).s_util_Failure__f_exception;
      $thiz.reportFailure__jl_Throwable__V(ex);
    }
  })), $m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$parasiticEC);
}
function $is_Lcats_effect_std_Dispatcher(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Dispatcher)));
}
function $as_Lcats_effect_std_Dispatcher(obj) {
  return (($is_Lcats_effect_std_Dispatcher(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$$anon$1() {
}
$c_Lcats_effect_std_Dispatcher$$anon$1.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$$anon$1.prototype.constructor = $c_Lcats_effect_std_Dispatcher$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$$anon$1() {
}
$h_Lcats_effect_std_Dispatcher$$anon$1.prototype = $c_Lcats_effect_std_Dispatcher$$anon$1.prototype;
$c_Lcats_effect_std_Dispatcher$$anon$1.prototype.execute__jl_Runnable__V = (function(runnable) {
  $n(runnable).run__V();
});
$c_Lcats_effect_std_Dispatcher$$anon$1.prototype.reportFailure__jl_Throwable__V = (function(t) {
  var this$1 = $n(t);
  this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
});
var $d_Lcats_effect_std_Dispatcher$$anon$1 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$$anon$1, "cats.effect.std.Dispatcher$$anon$1", ({
  Lcats_effect_std_Dispatcher$$anon$1: 1,
  s_concurrent_ExecutionContext: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$$anon$3(evidence$1$33) {
  this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$1$12 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$1$12 = evidence$1$33;
}
$c_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype = new $h_Lcats_effect_std_Dispatcher$Executor();
$c_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$$anon$3;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$$anon$3() {
}
$h_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype = $c_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$$anon$3.prototype.apply__O__F1__O = (function(task, registerCancel) {
  var F = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$1$12;
  var target = $n(F).deferred__O();
  var tc = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$1$12;
  var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((d$1) => {
    var d$2 = $as_Lcats_effect_kernel_Deferred(d$1);
    var fa = $n(registerCancel).apply__O__O($n(d$2).get__O());
    var F$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$1$12;
    var this$6 = $n(F$1);
    var wrapped = this$6.productR__O__O__O(fa, task);
    var target$1 = $n(d$2).complete__O__O((void 0));
    var tc$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$1$12;
    var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
    var fin = $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    var F$2 = this.Lcats_effect_std_Dispatcher$Executor$$anon$3__f_evidence$1$12;
    return $n(F$2).guarantee__O__O__O(wrapped, fin);
  }));
  return $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
var $d_Lcats_effect_std_Dispatcher$Executor$$anon$3 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$$anon$3, "cats.effect.std.Dispatcher$Executor$$anon$3", ({
  Lcats_effect_std_Dispatcher$Executor$$anon$3: 1,
  Lcats_effect_std_Dispatcher$Executor: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$$anon$4(evidence$1$35, shutoff$4, tasks$7, fiberR$2, spawnExecutor$4, TaskState$lzy1$13) {
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_fiberR$1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_spawnExecutor$3 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26 = evidence$1$35;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3 = shutoff$4;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6 = tasks$7;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_fiberR$1 = fiberR$2;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_spawnExecutor$3 = spawnExecutor$4;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11 = TaskState$lzy1$13;
}
$c_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype = new $h_Lcats_effect_std_Dispatcher$Executor();
$c_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$$anon$4;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$$anon$4() {
}
$h_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype = $c_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$$anon$4.prototype.apply__O__F1__O = (function(task, registerCancel) {
  var F = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
  var target = $n(F).ref__O__O($n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1).apply__O__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(task));
  var tc = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
  var this$55 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$16 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((taskR) => {
    var taskR$1 = $as_Lcats_effect_kernel_Ref(taskR);
    var F$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
    var target$1 = $n(F$1).deferred__O();
    var tc$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
    var this$49 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
    var f$14 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cancelLatch) => {
      var cancelLatch$1 = $as_Lcats_effect_kernel_Deferred(cancelLatch);
      return $n(taskR$1).flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$1(x$1);
        matchAlts5: {
          matchAlts6: {
            if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$1$1)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer === $m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)))) {
              $n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1);
              var x$1$2 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$1$1);
              $n(x$1$2);
              break matchAlts6;
            }
            var x = $n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$();
            if ((x === null)) {
              var $x_1 = (x$1$1 === null);
            } else {
              var this$8 = $n(x);
              var $x_1 = (this$8 === x$1$1);
            }
            if ($x_1) {
              break matchAlts6;
            }
            break matchAlts5;
          }
          var _1 = $n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$();
          var instance = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
          var _2 = $n(instance).unit__O();
          return new $c_T2(_1, _2);
        }
        if (((x$1$1 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$1)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer === $m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)))) {
          $n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1);
          var x$1$3 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$1$1);
          var this$12 = $n(x$1$3);
          var x101 = this$12.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
          var _1$1 = $n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1).apply__Lcats_effect_kernel_Deferred__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x101);
          var _2$1 = $n(x101).get__O();
          return new $c_T2(_1$1, _2$1);
        }
        var x$3 = $n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Executing__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$();
        if ((x$3 === null)) {
          var $x_2 = (x$1$1 === null);
        } else {
          var this$14 = $n(x$3);
          var $x_2 = (this$14 === x$1$1);
        }
        if ($x_2) {
          var F$2 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
          var target$2 = $n(F$2).deferred__O();
          var tc$2 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
          var this$47 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
          var f$13 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((latch) => {
            var latch$1 = $as_Lcats_effect_kernel_Deferred(latch);
            var target$3 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3).set__O__O(new $c_s_Some(latch$1));
            var tc$3 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
            var this$46 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$3);
            var f$12 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$4) => {
              $as_jl_Void(x$1$4);
              var this$19 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6);
              var maxN = $m_s_None$();
              var F$3 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
              var target$4 = $m_Lcats_effect_std_QueueSource$().tryTakeN__s_Option__O__Lcats_Monad__O(maxN, this$19.tryTake__O(), F$3);
              var tc$4 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
              var this$45 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$4, tc$4);
              var f$11 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((scratch) => {
                var scratch$1 = $as_sci_List(scratch);
                var target$5 = $n(cancelLatch$1).tryGet__O();
                var tc$5 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                var this$40 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$5, tc$5);
                var f$8 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$6) => {
                  var x$1$7 = $as_s_Option(x$1$6);
                  if ((x$1$7 instanceof $c_s_Some)) {
                    var instance$1 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                    return $n(instance$1).unit__O();
                  }
                  var x$2 = $m_s_None$();
                  if ((x$2 === x$1$7)) {
                    var target$6 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_fiberR$1).get__O();
                    var tc$6 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                    var this$24 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$6, tc$6);
                    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$25) => {
                      var _$25$1 = $as_Lcats_effect_kernel_Fiber(_$25);
                      return $n(_$25$1).cancel__O();
                    }));
                    var target$7 = $n(this$24.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$24.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
                    var tc$7 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                    var this$39 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$7, tc$7);
                    var f$7 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$1) => {
                      $as_jl_Void(x$1$2$1);
                      $m_Lcats_UnorderedFoldable$();
                      var tc$8 = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
                      var this$28 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(scratch$1, tc$8);
                      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$26) => {
                        var _$26$1 = $as_Lcats_effect_kernel_Ref(_$26);
                        return $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6).offer__O__O(_$26$1);
                      }));
                      var G = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                      var target$8 = $n(this$28.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverseVoid__O__F1__Lcats_Applicative__O(this$28.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$1, G);
                      var tc$9 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                      var this$38 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$8, tc$9);
                      var f$6 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$2) => {
                        $as_jl_Void(x$1$2$2);
                        var target$9 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_spawnExecutor$3;
                        var tc$10 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                        var this$31 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$9, tc$10);
                        var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$27) => {
                          var _$27$1 = $as_Lcats_effect_kernel_Fiber(_$27);
                          return $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_fiberR$1).set__O__O(_$27$1);
                        }));
                        var target$10 = $n(this$31.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$31.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
                        var tc$11 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                        var this$37 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$10, tc$11);
                        var f$5 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$3) => {
                          $as_jl_Void(x$1$2$3);
                          var target$11 = $n(latch$1).complete__O__O((void 0));
                          var tc$12 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                          var this$36 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$11, tc$12);
                          var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$4) => {
                            $uZ(x$1$2$4);
                            var target$12 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3).set__O__O($m_s_None$());
                            var tc$13 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                            var this$35 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$12, tc$13);
                            var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$5) => {
                              $as_jl_Void(x$1$2$5);
                            }));
                            return $n(this$35.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$35.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$3);
                          }));
                          return $n(this$36.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$36.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
                        }));
                        return $n(this$37.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$37.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$5);
                      }));
                      return $n(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$6);
                    }));
                    return $n(this$39.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$39.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$7);
                  }
                  throw new $c_s_MatchError(x$1$7);
                }));
                var target$13 = $n(this$40.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$40.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$8);
                var tc$14 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                var this$44 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$13, tc$14);
                var f$10 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$6) => {
                  $as_jl_Void(x$1$2$6);
                  var target$14 = $n(cancelLatch$1).complete__O__O((void 0));
                  var tc$15 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
                  var this$43 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$14, tc$15);
                  var f$9 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((v1) => {
                    $uZ(v1);
                  }));
                  return $n(this$43.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$43.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$9);
                }));
                return $n(this$44.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$44.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$10);
              }));
              return $n(this$45.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$45.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$11);
            }));
            return $n(this$46.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$46.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$12);
          }));
          var eff = $n(this$47.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$47.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$13);
          var _1$2 = $n($n($m_Lcats_effect_std_Dispatcher$Executor$().cats$effect$std$Dispatcher$Executor$$$_$TaskState$2__sr_LazyRef__Lcats_effect_std_Dispatcher$Executor$TaskState$3$(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_TaskState$lzy1$11)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1).apply__Lcats_effect_kernel_Deferred__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(cancelLatch$1);
          return new $c_T2(_1$2, eff);
        }
        throw new $c_s_MatchError(x$1$1);
      })), this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26);
    }));
    var cancelF = $n(this$49.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$49.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$14);
    var target$15 = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_shutoff$3).get__O();
    var tc$16 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
    var this$52 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$15, tc$16);
    var f$15 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$15) => {
      var x$1$16 = $as_s_Option(x$1$15);
      if ((x$1$16 instanceof $c_s_Some)) {
        var latch$2 = $as_Lcats_effect_kernel_Deferred($n($as_s_Some(x$1$16)).s_Some__f_value);
        return $n(latch$2).get__O();
      }
      var x$4 = $m_s_None$();
      if ((x$4 === x$1$16)) {
        var instance$2 = this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26;
        return $n(instance$2).unit__O();
      }
      throw new $c_s_MatchError(x$1$16);
    }));
    var optBlock = $n(this$52.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$52.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$15);
    var fa = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(optBlock, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_tasks$6).offer__O__O(taskR$1))), this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26);
    return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(registerCancel).apply__O__O(cancelF))), this.Lcats_effect_std_Dispatcher$Executor$$anon$4__f_evidence$1$26);
  }));
  return $n(this$55.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$55.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$16);
});
var $d_Lcats_effect_std_Dispatcher$Executor$$anon$4 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$$anon$4, "cats.effect.std.Dispatcher$Executor$$anon$4", ({
  Lcats_effect_std_Dispatcher$Executor$$anon$4: 1,
  Lcats_effect_std_Dispatcher$Executor: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$$anon$5(supervisor$12, evidence$1$36) {
  this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_supervisor$10 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_evidence$1$27 = null;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_supervisor$10 = supervisor$12;
  this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_evidence$1$27 = evidence$1$36;
}
$c_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype = new $h_Lcats_effect_std_Dispatcher$Executor();
$c_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$$anon$5;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$$anon$5() {
}
$h_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype = $c_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$$anon$5.prototype.apply__O__F1__O = (function(task, registerCancel) {
  var target = $n(this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_supervisor$10).supervise__O__O(task);
  var tc = this.Lcats_effect_std_Dispatcher$Executor$$anon$5__f_evidence$1$27;
  var this$2 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fiber) => {
    var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
    return $n(registerCancel).apply__O__O($n(fiber$1).cancel__O());
  }));
  return $n(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
var $d_Lcats_effect_std_Dispatcher$Executor$$anon$5 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$$anon$5, "cats.effect.std.Dispatcher$Executor$$anon$5", ({
  Lcats_effect_std_Dispatcher$Executor$$anon$5: 1,
  Lcats_effect_std_Dispatcher$Executor: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration$Primary(stateR) {
  this.Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR = null;
  this.Lcats_effect_std_Dispatcher$Registration$Primary__f_stateR = stateR;
}
$c_Lcats_effect_std_Dispatcher$Registration$Primary.prototype = new $h_Lcats_effect_std_Dispatcher$Registration();
$c_Lcats_effect_std_Dispatcher$Registration$Primary.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration$Primary;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration$Primary() {
}
$h_Lcats_effect_std_Dispatcher$Registration$Primary.prototype = $c_Lcats_effect_std_Dispatcher$Registration$Primary.prototype;
function $as_Lcats_effect_std_Dispatcher$Registration$Primary(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration$Primary) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration$Primary"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration$Primary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration$Primary)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration$Primary(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration$Primary(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration$Primary;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Registration$Primary = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Registration$Primary, "cats.effect.std.Dispatcher$Registration$Primary", ({
  Lcats_effect_std_Dispatcher$Registration$Primary: 1,
  Lcats_effect_std_Dispatcher$Registration: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Env$() {
}
$c_Lcats_effect_std_Env$.prototype = new $h_Lcats_effect_std_EnvCompanionPlatform();
$c_Lcats_effect_std_Env$.prototype.constructor = $c_Lcats_effect_std_Env$;
/** @constructor */
function $h_Lcats_effect_std_Env$() {
}
$h_Lcats_effect_std_Env$.prototype = $c_Lcats_effect_std_Env$.prototype;
var $d_Lcats_effect_std_Env$ = new $TypeData().initClass($c_Lcats_effect_std_Env$, "cats.effect.std.Env$", ({
  Lcats_effect_std_Env$: 1,
  Lcats_effect_std_EnvCompanionPlatform: 1
}));
var $n_Lcats_effect_std_Env$;
function $m_Lcats_effect_std_Env$() {
  if ((!$n_Lcats_effect_std_Env$)) {
    $n_Lcats_effect_std_Env$ = new $c_Lcats_effect_std_Env$();
  }
  return $n_Lcats_effect_std_Env$;
}
function $p_Lcats_effect_std_EnvCompanionPlatform$SyncEnv__processEnv__sjs_js_Dictionary($thiz) {
  try {
    var r1 = process.env;
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  return $x_1.getOrElse__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (({})))));
}
/** @constructor */
function $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv(outer, F) {
  this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F = null;
  this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F = F;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype = new $h_O();
$c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype.constructor = $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv;
/** @constructor */
function $h_Lcats_effect_std_EnvCompanionPlatform$SyncEnv() {
}
$h_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype = $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype;
$c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv.prototype.get__T__O = (function(name) {
  var value = $n(this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var dict = $p_Lcats_effect_std_EnvCompanionPlatform$SyncEnv__processEnv__sjs_js_Dictionary(this);
    return ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, name)) ? new $c_s_Some(dict[name]) : $m_s_None$());
  })));
  return $n(new $c_Lcats_data_OptionT(value).collect__s_PartialFunction__Lcats_Functor__Lcats_data_OptionT(new $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1(), this.Lcats_effect_std_EnvCompanionPlatform$SyncEnv__f_F)).Lcats_data_OptionT__f_value;
});
var $d_Lcats_effect_std_EnvCompanionPlatform$SyncEnv = new $TypeData().initClass($c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv, "cats.effect.std.EnvCompanionPlatform$SyncEnv", ({
  Lcats_effect_std_EnvCompanionPlatform$SyncEnv: 1,
  Lcats_effect_std_Env: 1
}));
function $p_Lcats_effect_std_Mutex$ConcurrentImpl__awakeCell__Lcats_effect_kernel_Deferred__O__O($thiz, ourCell, nextCell) {
  var target = $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_state).access__O();
  var tc = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
  var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var lastCell = $n(x$1$1)._1__O();
      var setter = $as_F1($n(x$1$1)._2__O());
      return ((lastCell === ourCell) ? $n(setter).apply__O__O(nextCell) : $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F).pure__O__O(false));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var target$1 = $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  var tc$1 = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
  var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $uZ(x$1$2);
    if ((x$1$3 === false)) {
      var target$2 = $n(ourCell).complete__O__O(nextCell);
      var tc$2 = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
      var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
      return $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }
    if ((x$1$3 === true)) {
      return $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F).unit__O();
    }
    throw new $c_s_MatchError(x$1$3);
  }));
  return $n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
}
function $p_Lcats_effect_std_Mutex$ConcurrentImpl__acquire__Lcats_effect_kernel_Poll__O($thiz, poll) {
  var F = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
  var target = $n(F).deferred__O();
  var tc = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
  var this$7 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ourCell) => {
    var ourCell$1 = $as_Lcats_effect_kernel_Deferred(ourCell);
    var target$1 = $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_state).getAndSet__O__O(ourCell$1);
    var tc$1 = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
    var this$6 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((lastCell) => $p_Lcats_effect_std_Mutex$ConcurrentImpl__loop$1__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Poll__O__O($thiz, ourCell$1, poll, lastCell)));
    return $n(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$6.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }));
  return $n(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$7.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
}
function $p_Lcats_effect_std_Mutex$ConcurrentImpl__loop$1__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Poll__O__O($thiz, ourCell$4, poll$2, nextCell) {
  if ((nextCell === null)) {
    return $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F).pure__O__O(ourCell$4);
  } else {
    var target = $n($thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F).onCancel__O__O__O($n(poll$2).apply__O__O($n($as_Lcats_effect_kernel_Deferred(nextCell)).get__O()), $p_Lcats_effect_std_Mutex$ConcurrentImpl__awakeCell__Lcats_effect_kernel_Deferred__O__O($thiz, ourCell$4, nextCell));
    var tc = $thiz.Lcats_effect_std_Mutex$ConcurrentImpl__f_F;
    var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextCell$2) => $p_Lcats_effect_std_Mutex$ConcurrentImpl__loop$1__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Poll__O__O($thiz, ourCell$4, poll$2, nextCell$2)));
    return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
}
/** @constructor */
function $c_Lcats_effect_std_Mutex$ConcurrentImpl(state, F) {
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_state = null;
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_F = null;
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_lock = null;
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_state = state;
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_F = F;
  var target = $m_Lcats_effect_kernel_Resource$().makeFull__F1__F1__Lcats_Functor__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return $p_Lcats_effect_std_Mutex$ConcurrentImpl__acquire__Lcats_effect_kernel_Poll__O(this, poll$1);
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ourCell) => {
    var ourCell$1 = $as_Lcats_effect_kernel_Deferred(ourCell);
    return $p_Lcats_effect_std_Mutex$ConcurrentImpl__awakeCell__Lcats_effect_kernel_Deferred__O__O(this, ourCell$1, null);
  })), F);
  var tc = new $c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13(F);
  var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  this.Lcats_effect_std_Mutex$ConcurrentImpl__f_lock = $as_Lcats_effect_kernel_Resource($n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self));
}
$c_Lcats_effect_std_Mutex$ConcurrentImpl.prototype = new $h_Lcats_effect_std_Mutex();
$c_Lcats_effect_std_Mutex$ConcurrentImpl.prototype.constructor = $c_Lcats_effect_std_Mutex$ConcurrentImpl;
/** @constructor */
function $h_Lcats_effect_std_Mutex$ConcurrentImpl() {
}
$h_Lcats_effect_std_Mutex$ConcurrentImpl.prototype = $c_Lcats_effect_std_Mutex$ConcurrentImpl.prototype;
var $d_Lcats_effect_std_Mutex$ConcurrentImpl = new $TypeData().initClass($c_Lcats_effect_std_Mutex$ConcurrentImpl, "cats.effect.std.Mutex$ConcurrentImpl", ({
  Lcats_effect_std_Mutex$ConcurrentImpl: 1,
  Lcats_effect_std_Mutex: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$$anon$1(state$2, outer) {
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1 = null;
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer = null;
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1 = state$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer = outer;
}
$c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype = new $h_Lcats_effect_std_Semaphore();
$c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$$anon$1() {
}
$h_Lcats_effect_std_Semaphore$impl$$anon$1.prototype = $c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype;
$c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype.acquireN__J__O = (function(n_$_lo, n_$_hi) {
  $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).requireNonNegative__J__V(n_$_lo, n_$_hi);
  return (((n_$_lo | n_$_hi) === 0) ? $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F).unit__O() : $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).newRequest__O();
    var tc = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
    var this$51 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((req) => {
      var req$1 = $as_Lcats_effect_std_Semaphore$impl$Request(req);
      var ffa$1 = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Semaphore$impl$State(x$1);
        if ((x$1$1 !== null)) {
          $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_State$lzy1);
          var this$5 = $n(x$1$1);
          var x23_$_lo = this$5.Lcats_effect_std_Semaphore$impl$State__f_permits_$lo;
          var x23_$_hi = this$5.Lcats_effect_std_Semaphore$impl$State__f_permits_$hi;
          var this$6 = $n(x$1$1);
          var x24 = this$6.Lcats_effect_std_Semaphore$impl$State__f_waiting;
          var this$7 = $n(x24);
          if ((!this$7.isEmpty__Z())) {
            var self = $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_State$lzy1).apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(0, 0, $n(x24).enqueue__O__sci_Queue($n(req$1).of__J__Lcats_effect_std_Semaphore$impl$Request(n_$_lo, n_$_hi)));
            var y = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Wait__Lcats_effect_std_Semaphore$impl$Wait$();
            var x13___1 = self;
            var x13___2 = y;
          } else {
            var lo = ((x23_$_lo - n_$_lo) | 0);
            var hi = ((((x23_$_hi - n_$_hi) | 0) + ((((~x23_$_lo) & n_$_lo) | ((~(x23_$_lo ^ n_$_lo)) & lo)) >> 31)) | 0);
            if ((hi >= 0)) {
              var $x_2 = $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_State$lzy1);
              var xs = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
              var $x_1 = $m_sci_Nil$();
              var this$13 = $n(xs);
              var self$1 = $x_2.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(lo, hi, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $x_1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$13)));
              var y$1 = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Done__Lcats_effect_std_Semaphore$impl$Done$();
              var x13___1 = self$1;
              var x13___2 = y$1;
            } else {
              var $x_4 = $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_State$lzy1);
              var $x_3 = $n(req$1);
              var sign = (hi >> 31);
              var xlo = (lo ^ sign);
              var rlo = ((xlo - sign) | 0);
              var rhi = (((hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
              var a = $x_3.of__J__Lcats_effect_std_Semaphore$impl$Request(rlo, rhi);
              var F = $m_Lcats_instances_package$queue$().Lcats_instances_package$queue$__f_catsStdInstancesForQueue;
              var self$2 = $x_4.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(0, 0, $as_sci_Queue($n(F).pure__O__O(a)));
              var y$2 = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Wait__Lcats_effect_std_Semaphore$impl$Wait$();
              var x13___1 = self$2;
              var x13___2 = y$2;
            }
          }
          var newState = $as_Lcats_effect_std_Semaphore$impl$State(x13___1);
          var decision = $as_Lcats_effect_std_Semaphore$impl$Action(x13___2);
          var \u03b41$___1 = newState;
          var \u03b41$___2 = decision;
          var newState$2 = $as_Lcats_effect_std_Semaphore$impl$State(\u03b41$___1);
          var decision$2 = $as_Lcats_effect_std_Semaphore$impl$Action(\u03b41$___2);
          var ffa = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
            var x$1$3 = $as_Lcats_effect_std_Semaphore$impl$State(x$1$2);
            if ((x$1$3 !== null)) {
              $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_State$lzy1);
              var this$28 = $n(x$1$3);
              var x18_$_lo = this$28.Lcats_effect_std_Semaphore$impl$State__f_permits_$lo;
              var x18_$_hi = this$28.Lcats_effect_std_Semaphore$impl$State__f_permits_$hi;
              var this$29 = $n(x$1$3);
              var x19 = this$29.Lcats_effect_std_Semaphore$impl$State__f_waiting;
              var this$30 = $n(x19);
              _return: {
                var these = this$30;
                while ((!$n(these).isEmpty__Z())) {
                  var x0 = $n(these).head__O();
                  var _$8 = $as_Lcats_effect_std_Semaphore$impl$Request(x0);
                  if ($n(_$8).sameAs__Lcats_effect_std_Semaphore$impl$Request__Z(req$1)) {
                    var target$1 = new $c_s_Some($n(these).head__O());
                    break _return;
                  }
                  these = $as_sc_LinearSeq($n(these).tail__O());
                }
                var target$1 = $m_s_None$();
              }
              $m_Lcats_UnorderedFoldable$();
              var tc$1 = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
              var this$34 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$1, tc$1);
              var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$9) => {
                var _$9$1 = $as_Lcats_effect_std_Semaphore$impl$Request(_$9);
                return $bL($n(_$9$1).Lcats_effect_std_Semaphore$impl$Request__f_n_$lo, $n(_$9$1).Lcats_effect_std_Semaphore$impl$Request__f_n_$hi);
              }));
              var B = $m_Lcats_kernel_instances_long_package$().Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong;
              var $x_5 = $uJ($n(this$34.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).foldMap__O__F1__Lcats_kernel_Monoid__O(this$34.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, B));
              var x_$_lo = $x_5.l;
              var x_$_hi = $x_5.h;
              var lo$1 = ((n_$_lo - x_$_lo) | 0);
              var hi$1 = ((((n_$_hi - x_$_hi) | 0) + ((((~n_$_lo) & x_$_lo) | ((~(n_$_lo ^ x_$_lo)) & lo$1)) >> 31)) | 0);
              var this$36 = $n(x19);
              var b = $m_sci_Queue$().newBuilder__scm_Builder();
              var it = this$36.iterator__sc_Iterator();
              while ($n(it).hasNext__Z()) {
                var elem = $n(it).next__O();
                var _$10 = $as_Lcats_effect_std_Semaphore$impl$Request(elem);
                if (($n(_$10).sameAs__Lcats_effect_std_Semaphore$impl$Request__Z(req$1) !== true)) {
                  var this$37 = $n(b);
                  this$37.addOne__O__scm_Growable(elem);
                }
              }
              var waitingNow = $as_sci_Queue($n(b).result__O());
              var self$3 = $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_State$lzy1).apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(x18_$_lo, x18_$_hi, waitingNow);
              var y$3 = this.releaseN__J__O(lo$1, hi$1);
              return new $c_T2(self$3, y$3);
            }
            throw new $c_s_MatchError(x$1$3);
          })));
          $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer);
          var F$1 = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
          var cleanup = $f_Lcats_FlatMap__flatten__O__O($n(F$1), ffa);
          matchResult13: {
            var action;
            var x$2 = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Done__Lcats_effect_std_Semaphore$impl$Done$();
            if ((x$2 === null)) {
              var $x_6 = (decision$2 === null);
            } else {
              var this$42 = $n(x$2);
              var $x_6 = (this$42 === decision$2);
            }
            if ($x_6) {
              var action = $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F).unit__O();
              break matchResult13;
            }
            var x$3 = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Wait__Lcats_effect_std_Semaphore$impl$Wait$();
            if ((x$3 === null)) {
              var $x_7 = (decision$2 === null);
            } else {
              var this$43 = $n(x$3);
              var $x_7 = (this$43 === decision$2);
            }
            if ($x_7) {
              var $x_8 = $n(poll$1);
              var this$44 = $n(req$1);
              var wrapped = $x_8.apply__O__O($n(this$44.Lcats_effect_std_Semaphore$impl$Request__f_gate).get__O());
              var F$2 = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
              var action = $n(F$2).onCancel__O__O__O(wrapped, cleanup);
              break matchResult13;
            }
            throw new $c_s_MatchError(decision$2);
          }
          return new $c_T2(newState$2, action);
        }
        throw new $c_s_MatchError(x$1$1);
      })));
      $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer);
      var F$3 = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
      return $f_Lcats_FlatMap__flatten__O__O($n(F$3), ffa$1);
    }));
    return $n(this$51.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$51.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  }))));
});
$c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype.releaseN__J__O = (function(n_$_lo, n_$_hi) {
  $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).requireNonNegative__J__V(n_$_lo, n_$_hi);
  return (((n_$_lo | n_$_hi) === 0) ? $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F).unit__O() : $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_state$1).flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lcats_effect_std_Semaphore$impl$State(x$1);
    if ((x$1$1 !== null)) {
      $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_State$lzy1);
      var this$4 = $n(x$1$1);
      var x34_$_lo = this$4.Lcats_effect_std_Semaphore$impl$State__f_permits_$lo;
      var x34_$_hi = this$4.Lcats_effect_std_Semaphore$impl$State__f_permits_$hi;
      var this$5 = $n(x$1$1);
      var x35 = this$5.Lcats_effect_std_Semaphore$impl$State__f_waiting;
      if ($n(x35).isEmpty__Z()) {
        var $x_1 = $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_State$lzy1);
        var lo = ((x34_$_lo + n_$_lo) | 0);
        var hi = ((((x34_$_hi + n_$_hi) | 0) + ((((x34_$_lo & n_$_lo) | ((x34_$_lo | n_$_lo) & (~lo))) >>> 31) | 0)) | 0);
        var self = $x_1.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(lo, hi, x35);
        var y = $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F).unit__O();
        return new $c_T2(self, y);
      } else {
        matchResult16: {
          var \u03b43$___1;
          var \u03b43$___2;
          var \u03b43$___3;
          var xs = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
          var $x_2 = $m_sci_Nil$();
          var this$10 = $n(xs);
          var x28 = $s_Lcats_effect_std_Semaphore$__cats$effect$std$Semaphore$impl$$anon$1$$_$fulfil$1__J__sci_Queue__sci_Queue__T3(n_$_lo, n_$_hi, x35, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $x_2, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$10)));
          if ((x28 !== null)) {
            var $x_3 = $uJ($n(x28).T3__f__1);
            var newN_$_lo = $x_3.l;
            var newN_$_hi = $x_3.h;
            var waitingNow = $as_sci_Queue($n(x28).T3__f__2);
            var wakeup = $as_sci_Queue($n(x28).T3__f__3);
            var \u03b43$___1 = $bL(newN_$_lo, newN_$_hi);
            var \u03b43$___2 = waitingNow;
            var \u03b43$___3 = wakeup;
            break matchResult16;
          }
          throw new $c_s_MatchError(x28);
        }
        var $x_4 = $uJ(\u03b43$___1);
        var newN$2_$_lo = $x_4.l;
        var newN$2_$_hi = $x_4.h;
        var waitingNow$2 = $as_sci_Queue(\u03b43$___2);
        var wakeup$2 = $as_sci_Queue(\u03b43$___3);
        var self$1 = $n($n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_State$lzy1).apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(newN$2_$_lo, newN$2_$_hi, waitingNow$2);
        $m_Lcats_UnorderedFoldable$();
        var tc = $as_Lcats_Traverse($m_Lcats_instances_package$queue$().Lcats_instances_package$queue$__f_catsStdInstancesForQueue);
        var this$17 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(wakeup$2, tc);
        var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$11) => {
          var _$11$1 = $as_Lcats_effect_std_Semaphore$impl$Request(_$11);
          var this$16 = $n(_$11$1);
          return $n(this$16.Lcats_effect_std_Semaphore$impl$Request__f_gate).complete__O__O((void 0));
        }));
        var G = $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
        var y$1 = $n(this$17.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverseVoid__O__F1__Lcats_Applicative__O(this$17.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, G);
        return new $c_T2(self$1, y$1);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  })), $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F));
});
$c_Lcats_effect_std_Semaphore$impl$$anon$1.prototype.permit__Lcats_effect_kernel_Resource = (function() {
  return $m_Lcats_effect_kernel_Resource$().makeFull__F1__F1__Lcats_Functor__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return $n(poll$1).apply__O__O(this.acquireN__J__O(1, 0));
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$14) => {
    $as_jl_Void(_$14);
    return this.releaseN__J__O(1, 0);
  })), $n(this.Lcats_effect_std_Semaphore$impl$$anon$1__f_$outer).Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F);
});
var $d_Lcats_effect_std_Semaphore$impl$$anon$1 = new $TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$$anon$1, "cats.effect.std.Semaphore$impl$$anon$1", ({
  Lcats_effect_std_Semaphore$impl$$anon$1: 1,
  Lcats_effect_std_Semaphore: 1
}));
function $p_Lcats_effect_std_Supervisor$$anon$1__action$1__O__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__O__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Deferred__O($thiz, fa$5, currentR$1, canceledR$3, restart$5, fin$5, resultR$4, current) {
  return $n($thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => {
    $as_Lcats_effect_kernel_Poll(_$8);
    var $x_1 = $n($thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4);
    var this$2 = $m_Lcats_effect_kernel_implicits$();
    var F = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
    var ev$6 = $f_Lcats_effect_kernel_syntax_MonadCancelSyntax__monadCancelOps__O__Lcats_effect_kernel_MonadCancel__O(this$2, fa$5, F);
    var fin$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oc) => {
      var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
      var target = $n($thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4).deferred__O();
      var tc = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
      var this$18 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
      var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((newCurrent) => {
        var newCurrent$1 = $as_Lcats_effect_kernel_Deferred(newCurrent);
        var fa = $n(currentR$1).set__O__O(newCurrent$1);
        var target$1 = $n(canceledR$3).get__O();
        var tc$1 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
        var this$15 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
        var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((canceled) => {
          var canceled$1 = $uZ(canceled);
          var target$2 = $n($thiz.Lcats_effect_std_Supervisor$$anon$1__f_doneR$3).get__O();
          var tc$2 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
          var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
          var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((done) => {
            var done$1 = $uZ(done);
            if ((((!canceled$1) && (!done$1)) && $uZ($n(restart$5).apply__O__O(oc$1)))) {
              return $p_Lcats_effect_std_Supervisor$$anon$1__action$1__O__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__O__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Deferred__O($thiz, fa$5, currentR$1, canceledR$3, restart$5, fin$5, resultR$4, newCurrent$1);
            } else {
              var fa$1 = $n(newCurrent$1).complete__O__O(null);
              var target$3 = $n(resultR$4).complete__O__O(oc$1);
              var tc$3 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$10 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$3);
              var fin = $n(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
              var F$1 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var fb = $n(F$1).guarantee__O__O__O(fin$5, fin);
              var F$2 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$13 = $n(F$2);
              return this$13.productR__O__O__O(fa$1, fb);
            }
          }));
          return $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
        }));
        var fb$1 = $n(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        var F$3 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
        var this$17 = $n(F$3);
        return this$17.productR__O__O__O(fa, fb$1);
      }));
      return $n(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    }));
    var F$4 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
    var started = $x_1.start__O__O($n(F$4).guaranteeCase__O__F1__O(ev$6, fin$1));
    var tc$4 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
    var this$23 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(started, tc$4);
    var f$5 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((f$3) => {
      var f$4 = $as_Lcats_effect_kernel_Fiber(f$3);
      var target$4 = $n(current).complete__O__O(f$4);
      var tc$5 = $thiz.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
      var this$22 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$5);
      return $n(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }));
    return $n(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$5);
  })));
}
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$1(F$22, checkRestart$4, doneR$7, state$5) {
  this.Lcats_effect_std_Supervisor$$anon$1__f_F$4 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_checkRestart$3 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_doneR$3 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_state$1 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_F$4 = F$22;
  this.Lcats_effect_std_Supervisor$$anon$1__f_checkRestart$3 = checkRestart$4;
  this.Lcats_effect_std_Supervisor$$anon$1__f_doneR$3 = doneR$7;
  this.Lcats_effect_std_Supervisor$$anon$1__f_state$1 = state$5;
}
$c_Lcats_effect_std_Supervisor$$anon$1.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$$anon$1.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$1() {
}
$h_Lcats_effect_std_Supervisor$$anon$1.prototype = $c_Lcats_effect_std_Supervisor$$anon$1.prototype;
$c_Lcats_effect_std_Supervisor$$anon$1.prototype.supervise__O__O = (function(fa) {
  return $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$7) => {
    $as_Lcats_effect_kernel_Poll(_$7);
    matchResult6$1: {
      var monitor;
      var x12 = this.Lcats_effect_std_Supervisor$$anon$1__f_checkRestart$3;
      if ((x12 instanceof $c_s_Some)) {
        var restart = $as_F1($n($as_s_Some(x12)).s_Some__f_value);
        var monitor = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((fa$1, fin) => {
          var target = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).deferred__O();
          var tc = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
          var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
          var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((resultR) => {
            var resultR$1 = $as_Lcats_effect_kernel_Deferred(resultR);
            var target$1 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).ref__O__O(false);
            var tc$1 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
            var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
            var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((canceledR) => {
              var canceledR$1 = $as_Lcats_effect_kernel_Ref(canceledR);
              var target$2 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).deferred__O();
              var tc$2 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$9 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
              var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((firstCurrent) => {
                var firstCurrent$1 = $as_Lcats_effect_kernel_Deferred(firstCurrent);
                var target$3 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).ref__O__O(firstCurrent$1);
                var tc$3 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                var this$8 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, tc$3);
                var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((currentR) => {
                  var currentR$1 = $as_Lcats_effect_kernel_Ref(currentR);
                  var target$4 = $p_Lcats_effect_std_Supervisor$$anon$1__action$1__O__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__O__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Deferred__O(this, fa$1, currentR$1, canceledR$1, restart, fin, resultR$1, firstCurrent$1);
                  var tc$4 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                  var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, tc$4);
                  var b = new $c_Lcats_effect_std_Supervisor$$anon$2(currentR$1, this.Lcats_effect_std_Supervisor$$anon$1__f_F$4, canceledR$1, resultR$1, fin, this);
                  return $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
                }));
                return $n(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
              }));
              return $n(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
            }));
            return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
          }));
          return $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
        }));
        break matchResult6$1;
      }
      var x = $m_s_None$();
      if ((x === x12)) {
        var monitor = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((fa$2, fin$2) => {
          var $x_1 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4);
          var F = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
          return $x_1.start__O__O($n(F).guarantee__O__O__O(fa$2, fin$2));
        }));
        break matchResult6$1;
      }
      throw new $c_s_MatchError(x12);
    }
    var target$5 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).ref__O__O(false);
    var tc$5 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
    var this$42 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$5, tc$5);
    var f$12 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((done) => {
      var done$1 = $as_Lcats_effect_kernel_Ref(done);
      var target$6 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).deferred__O();
      var tc$6 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
      var this$41 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$6, tc$6);
      var f$11 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((insertResult) => {
        var insertResult$1 = $as_Lcats_effect_kernel_Deferred(insertResult);
        var target$7 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).unique__O();
        var tc$7 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
        var this$18 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$7, tc$7);
        var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((token) => {
          var token$1 = $as_Lcats_effect_kernel_Unique$Token(token);
          var cleanup = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_state$1).remove__Lcats_effect_kernel_Unique$Token__O(token$1);
          return new $c_T2(token$1, cleanup);
        }));
        var target$8 = $n(this$18.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$18.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$4);
        var tc$8 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
        var this$40 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$8, tc$8);
        var f$10 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
          var x$1$1 = $as_T2(x$1);
          if ((x$1$1 !== null)) {
            var token$2 = $as_Lcats_effect_kernel_Unique$Token($n(x$1$1)._1__O());
            var cleanup$1 = $n(x$1$1)._2__O();
            var fa$3 = $n(insertResult$1).get__O();
            var ifTrue = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => fa));
            var ifFalse = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
              var fa$4 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).canceled__O();
              var fb = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).raiseError__O__O(new $c_jl_AssertionError("supervised fiber couldn't cancel (this is a bug in Supervisor)"));
              var F$1 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$23 = $n(F$1);
              return this$23.productR__O__O__O(fa$4, fb);
            }));
            var F$2 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
            var $x_2 = $f_Lcats_FlatMap__ifM__O__F0__F0__O($n(F$2), fa$3, ifTrue, ifFalse);
            var fa$5 = $n(done$1).set__O__O(true);
            var F$3 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
            var this$27 = $n(F$3);
            var target$9 = monitor.apply__O__O__O($x_2, this$27.productR__O__O__O(fa$5, cleanup$1));
            var tc$9 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
            var this$39 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$9, tc$9);
            var f$9 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fiber) => {
              var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
              var target$10 = $n(this.Lcats_effect_std_Supervisor$$anon$1__f_state$1).add__Lcats_effect_kernel_Unique$Token__Lcats_effect_kernel_Fiber__O(token$2, fiber$1);
              var tc$10 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
              var this$38 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$10, tc$10);
              var f$8 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((insertOk) => {
                var insertOk$1 = $uZ(insertOk);
                var target$11 = $n(insertResult$1).complete__O__O(insertOk$1);
                var tc$11 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                var this$37 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$11, tc$11);
                var f$7 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
                  $uZ(x$1$2);
                  var fa$6 = $n(done$1).get__O();
                  var ifTrue$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => cleanup$1));
                  var ifFalse$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).unit__O()));
                  var F$4 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                  var target$12 = $f_Lcats_FlatMap__ifM__O__F0__F0__O($n(F$4), fa$6, ifTrue$1, ifFalse$1);
                  var tc$12 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                  var this$36 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$12, tc$12);
                  var f$6 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$1) => {
                    $as_jl_Void(x$1$2$1);
                    var target$13 = ((!insertOk$1) ? $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).raiseError__O__O($ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "supervisor already shutdown")) : $n(this.Lcats_effect_std_Supervisor$$anon$1__f_F$4).unit__O());
                    var tc$13 = this.Lcats_effect_std_Supervisor$$anon$1__f_F$4;
                    var this$35 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$13, tc$13);
                    var f$5 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$2) => {
                      $as_jl_Void(x$1$2$2);
                      return fiber$1;
                    }));
                    return $n(this$35.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$35.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$5);
                  }));
                  return $n(this$36.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$36.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$6);
                }));
                return $n(this$37.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$37.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$7);
              }));
              return $n(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$8);
            }));
            return $n(this$39.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$39.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$9);
          }
          throw new $c_s_MatchError(x$1$1);
        }));
        return $n(this$40.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$40.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$10);
      }));
      return $n(this$41.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$41.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$11);
    }));
    return $n(this$42.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$42.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$12);
  })));
});
var $d_Lcats_effect_std_Supervisor$$anon$1 = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$$anon$1, "cats.effect.std.Supervisor$$anon$1", ({
  Lcats_effect_std_Supervisor$$anon$1: 1,
  Lcats_effect_std_Supervisor: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$3(stateRef$1, F$10) {
  this.Lcats_effect_std_Supervisor$$anon$3__f_stateRef$2 = null;
  this.Lcats_effect_std_Supervisor$$anon$3__f_joinAll = null;
  this.Lcats_effect_std_Supervisor$$anon$3__f_cancelAll = null;
  this.Lcats_effect_std_Supervisor$$anon$3__f_stateRef$2 = stateRef$1;
  var target = $n(stateRef$1).getAndSet__O__O(null);
  var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F$10);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$12) => {
    var _$12$1 = $as_sci_Map(_$12);
    var this$2 = $n(_$12$1);
    var this$3 = new $c_sc_MapOps$$anon$1(this$2);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$3);
  }));
  var allFibers = $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(allFibers, F$10);
  var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$13) => {
    var _$13$1 = $as_sci_List(_$13);
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var this$11 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(_$13$1, tc);
    var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$14) => {
      var _$14$1 = $as_Lcats_effect_kernel_Fiber(_$14);
      var target$1 = $n(_$14$1).join__O();
      var this$10 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F$10);
      return $n(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$10.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }));
    return $n(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverseVoid__O__F1__Lcats_Applicative__O(this$11.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f$1, F$10);
  }));
  this.Lcats_effect_std_Supervisor$$anon$3__f_joinAll = $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  var this$21 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(allFibers, F$10);
  var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$15) => {
    var _$15$1 = $as_sci_List(_$15);
    var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$16) => {
      var _$16$1 = $as_Lcats_effect_kernel_Fiber(_$16);
      return $n(_$16$1).cancel__O();
    }));
    var this$15 = $m_Lcats_effect_kernel_implicits$();
    var P = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(F$10, this$15);
    var F = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4(F$10);
    $m_Lcats_UnorderedFoldable$();
    var Tutraverse = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var target$2 = $m_Lcats_Parallel$().parUnorderedTraverse__O__F1__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O(_$15$1, f$3, Tutraverse, F, P);
    var this$20 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F$10);
    return $n(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  }));
  this.Lcats_effect_std_Supervisor$$anon$3__f_cancelAll = $n(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
}
$c_Lcats_effect_std_Supervisor$$anon$3.prototype = new $h_Lcats_effect_std_Supervisor$State();
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$3;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$3() {
}
$h_Lcats_effect_std_Supervisor$$anon$3.prototype = $c_Lcats_effect_std_Supervisor$$anon$3.prototype;
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.remove__Lcats_effect_kernel_Unique$Token__O = (function(token) {
  return $n(this.Lcats_effect_std_Supervisor$$anon$3__f_stateRef$2).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_sci_Map(x$1);
    if ((x$1$1 === null)) {
      return null;
    } else {
      var this$1 = $n(x$1$1);
      return $as_sci_Map(this$1.removed__O__sci_MapOps(token));
    }
  })));
});
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.add__Lcats_effect_kernel_Unique$Token__Lcats_effect_kernel_Fiber__O = (function(token, fiber) {
  return $n(this.Lcats_effect_std_Supervisor$$anon$3__f_stateRef$2).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_sci_Map(x$1);
    if ((x$1$1 === null)) {
      return new $c_T2(null, false);
    } else {
      var _1 = $n(x$1$1).updated__O__O__sci_MapOps(token, fiber);
      return new $c_T2(_1, true);
    }
  })));
});
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.joinAll__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$3__f_joinAll;
});
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.cancelAll__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$3__f_cancelAll;
});
var $d_Lcats_effect_std_Supervisor$$anon$3 = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$$anon$3, "cats.effect.std.Supervisor$$anon$3", ({
  Lcats_effect_std_Supervisor$$anon$3: 1,
  Lcats_effect_std_Supervisor$State: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$4(F$17, state$2, doneR$5) {
  this.Lcats_effect_std_Supervisor$$anon$4__f_F$21 = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_state$4 = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_doneR$6 = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_joinAll = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_cancelAll = null;
  this.Lcats_effect_std_Supervisor$$anon$4__f_F$21 = F$17;
  this.Lcats_effect_std_Supervisor$$anon$4__f_state$4 = state$2;
  this.Lcats_effect_std_Supervisor$$anon$4__f_doneR$6 = doneR$5;
  var allFibers = $n(F$17).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var fibers = new $c_scm_ListBuffer();
    $n(state$2).size__I();
    var values = $n($n(state$2).values__ju_Collection()).iterator__ju_Iterator();
    while ($n(values).hasNext__Z()) {
      var elem = $n(values).next__O();
      fibers.addOne__O__scm_ListBuffer(elem);
    }
    return fibers.toList__sci_List();
  })));
  var this$8 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(allFibers, F$17);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$20) => {
    var _$20$1 = $as_sci_List(_$20);
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var this$7 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(_$20$1, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$21) => {
      var _$21$1 = $as_Lcats_effect_kernel_Fiber(_$21);
      var target = $n(_$21$1).join__O();
      var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F$17);
      return $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
    }));
    return $n(this$7.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverseVoid__O__F1__Lcats_Applicative__O(this$7.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, F$17);
  }));
  this.Lcats_effect_std_Supervisor$$anon$4__f_joinAll = $n(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$8.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(allFibers, F$17);
  var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$22) => {
    var _$22$1 = $as_sci_List(_$22);
    var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$23) => {
      var _$23$1 = $as_Lcats_effect_kernel_Fiber(_$23);
      return $n(_$23$1).cancel__O();
    }));
    var this$11 = $m_Lcats_effect_kernel_implicits$();
    var P = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(F$17, this$11);
    var F = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4(F$17);
    $m_Lcats_UnorderedFoldable$();
    var Tutraverse = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var target$1 = $m_Lcats_Parallel$().parUnorderedTraverse__O__F1__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O(_$22$1, f$2, Tutraverse, F, P);
    var this$16 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F$17);
    return $n(this$16.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$16.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  }));
  this.Lcats_effect_std_Supervisor$$anon$4__f_cancelAll = $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
}
$c_Lcats_effect_std_Supervisor$$anon$4.prototype = new $h_Lcats_effect_std_Supervisor$State();
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$4;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$4() {
}
$h_Lcats_effect_std_Supervisor$$anon$4.prototype = $c_Lcats_effect_std_Supervisor$$anon$4.prototype;
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.remove__Lcats_effect_kernel_Unique$Token__O = (function(token) {
  var target = $n(this.Lcats_effect_std_Supervisor$$anon$4__f_F$21).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $as_Lcats_effect_kernel_Fiber($n(this.Lcats_effect_std_Supervisor$$anon$4__f_state$4).remove__O__O(token)))));
  var tc = this.Lcats_effect_std_Supervisor$$anon$4__f_F$21;
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  return $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
});
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.add__Lcats_effect_kernel_Unique$Token__Lcats_effect_kernel_Fiber__O = (function(token, fiber) {
  var fa = $n(this.Lcats_effect_std_Supervisor$$anon$4__f_F$21).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $as_Lcats_effect_kernel_Fiber($n(this.Lcats_effect_std_Supervisor$$anon$4__f_state$4).put__O__O__O(token, fiber)))));
  var target = $n(this.Lcats_effect_std_Supervisor$$anon$4__f_doneR$6).get__O();
  var tc = this.Lcats_effect_std_Supervisor$$anon$4__f_F$21;
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$19) => {
    var _$19$1 = $uZ(_$19);
    return (!_$19$1);
  }));
  var fb = $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  var F = this.Lcats_effect_std_Supervisor$$anon$4__f_F$21;
  var this$6 = $n(F);
  return this$6.productR__O__O__O(fa, fb);
});
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.joinAll__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$4__f_joinAll;
});
$c_Lcats_effect_std_Supervisor$$anon$4.prototype.cancelAll__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$4__f_cancelAll;
});
var $d_Lcats_effect_std_Supervisor$$anon$4 = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$$anon$4, "cats.effect.std.Supervisor$$anon$4", ({
  Lcats_effect_std_Supervisor$$anon$4: 1,
  Lcats_effect_std_Supervisor$State: 1
}));
function $p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z($thiz, ste) {
  var name = $n(ste).jl_StackTraceElement__f_declaringClass;
  var i = 0;
  var len = $n($thiz.Lcats_effect_tracing_Tracing$__f_runLoopFilter).u.length;
  while ((i < len)) {
    var this$1 = $n(name);
    var prefix = $n($thiz.Lcats_effect_tracing_Tracing$__f_runLoopFilter).get(i);
    if ($uZ(this$1.startsWith($n(prefix)))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
}
function $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement($thiz, frames) {
  $m_scm_ArrayBuffer$();
  var buffer = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var i = 0;
  var len = $n(frames).u.length;
  while ((i < len)) {
    var frame = $n(frames).get(i);
    if ((!$p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z($thiz, frame))) {
      buffer.addOne__O__scm_ArrayBuffer(frame);
    } else if ((buffer.scm_ArrayBuffer__f_size0 >= 0)) {
      var len$1 = buffer.scm_ArrayBuffer__f_size0;
      var destination = new ($d_jl_StackTraceElement.getArrayOf().constr)(len$1);
      buffer.copyToArray__O__I__I__I(destination, 0, 2147483647);
      return destination;
    } else {
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var it = $n(buffer.view__scm_ArrayBufferView()).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var elem = $n(it).next__O();
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem);
      }
      return new ($d_jl_StackTraceElement.getArrayOf().constr)(jsElems);
    }
    i = ((1 + i) | 0);
  }
  if ((buffer.scm_ArrayBuffer__f_size0 >= 0)) {
    var len$2 = buffer.scm_ArrayBuffer__f_size0;
    var destination$1 = new ($d_jl_StackTraceElement.getArrayOf().constr)(len$2);
    buffer.copyToArray__O__I__I__I(destination$1, 0, 2147483647);
    return destination$1;
  } else {
    var capacity$1 = 0;
    var size$1 = 0;
    var jsElems$1 = null;
    capacity$1 = 0;
    size$1 = 0;
    jsElems$1 = [];
    var it$1 = $n(buffer.view__scm_ArrayBufferView()).iterator__sc_Iterator();
    while ($n(it$1).hasNext__Z()) {
      var elem$1 = $n(it$1).next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems$1.push(unboxedElem$1);
    }
    return new ($d_jl_StackTraceElement.getArrayOf().constr)(jsElems$1);
  }
}
/** @constructor */
function $c_Lcats_effect_tracing_Tracing$() {
  this.Lcats_effect_tracing_TracingPlatform__f_cache = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function0Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function1Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = null;
  this.Lcats_effect_tracing_Tracing$__f_runLoopFilter = null;
  this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter = null;
  $ct_Lcats_effect_tracing_TracingPlatform__(this);
  $n_Lcats_effect_tracing_Tracing$ = this;
  this.Lcats_effect_tracing_Tracing$__f_runLoopFilter = new ($d_T.getArrayOf().constr)(["cats.effect.", "scala.runtime.", "scala.scalajs.runtime.", "scala.scalanative.runtime."]);
  this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter = new ($d_T.getArrayOf().constr)(["cats.", "sbt.", "java.", "jdk.", "sun.", "scala.", "org.scalajs."]);
}
$c_Lcats_effect_tracing_Tracing$.prototype = new $h_Lcats_effect_tracing_TracingPlatform();
$c_Lcats_effect_tracing_Tracing$.prototype.constructor = $c_Lcats_effect_tracing_Tracing$;
/** @constructor */
function $h_Lcats_effect_tracing_Tracing$() {
}
$h_Lcats_effect_tracing_Tracing$.prototype = $c_Lcats_effect_tracing_Tracing$.prototype;
$c_Lcats_effect_tracing_Tracing$.prototype.combineOpAndCallSite__jl_StackTraceElement__jl_StackTraceElement__jl_StackTraceElement = (function(methodSite, callSite) {
  var methodSiteMethodName = $n(methodSite).jl_StackTraceElement__f_methodName;
  var op = this.decodeMethodName__T__T(methodSiteMethodName);
  return $ct_jl_StackTraceElement__T__T__T__I__(new $c_jl_StackTraceElement(), ((op + " @ ") + $n(callSite).jl_StackTraceElement__f_declaringClass), $n(callSite).jl_StackTraceElement__f_methodName, $n(callSite).jl_StackTraceElement__f_fileName, $n(callSite).jl_StackTraceElement__f_lineNumber);
});
$c_Lcats_effect_tracing_Tracing$.prototype.isInternalClass__T__Z = (function(className) {
  var i = 0;
  var len = $n(this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter).u.length;
  while ((i < len)) {
    var this$1 = $n(className);
    var prefix = $n(this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter).get(i);
    if ($uZ(this$1.startsWith($n(prefix)))) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
});
$c_Lcats_effect_tracing_Tracing$.prototype.cats$effect$tracing$Tracing$$$getOpAndCallSite__Ajl_StackTraceElement__jl_StackTraceElement = (function(stackTrace) {
  var len = $n(stackTrace).u.length;
  var idx = 1;
  while ((idx < len)) {
    var methodSite = $n(stackTrace).get(((idx - 1) | 0));
    var callSite = $n(stackTrace).get(idx);
    var callSiteClassName = $n(callSite).jl_StackTraceElement__f_declaringClass;
    var callSiteMethodName = $n(callSite).jl_StackTraceElement__f_methodName;
    var callSiteFileName = $n(callSite).jl_StackTraceElement__f_fileName;
    if (((callSiteClassName === "cats.effect.IOFiber") && (callSiteMethodName === "run"))) {
      return null;
    }
    if ((!this.applyStackTraceFilter__T__T__T__Z(callSiteClassName, callSiteMethodName, callSiteFileName))) {
      return this.combineOpAndCallSite__jl_StackTraceElement__jl_StackTraceElement__jl_StackTraceElement(methodSite, callSite);
    }
    idx = ((1 + idx) | 0);
  }
  return null;
});
$c_Lcats_effect_tracing_Tracing$.prototype.augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V = (function(enhancedExceptions, t, events) {
  if (($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing && enhancedExceptions)) {
    var stackTrace = $n(t).getStackTrace__Ajl_StackTraceElement();
    if (($n(stackTrace).u.length !== 0)) {
      var augmented = ($f_T__indexOf__I__I($n($n($as_jl_StackTraceElement($m_sc_ArrayOps$().last$extension__O__O(stackTrace))).jl_StackTraceElement__f_declaringClass), 64) !== (-1));
      if ((!augmented)) {
        var prefix = $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement(this, stackTrace);
        var this$5 = $n(this.getFrames__Lcats_effect_tracing_RingBuffer__sci_List(events));
        if ((this$5.knownSize__I() >= 0)) {
          var len = this$5.knownSize__I();
          var destination = new ($d_jl_StackTraceElement.getArrayOf().constr)(len);
          $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$5, destination, 0, 2147483647);
          var suffix = destination;
        } else {
          var capacity = 0;
          var size = 0;
          var jsElems = null;
          capacity = 0;
          size = 0;
          jsElems = [];
          var it = this$5.iterator__sc_Iterator();
          while ($n(it).hasNext__Z()) {
            var elem = $n(it).next__O();
            var unboxedElem = ((elem === null) ? null : elem);
            jsElems.push(unboxedElem);
          }
          var suffix = new ($d_jl_StackTraceElement.getArrayOf().constr)(jsElems);
        }
        var $x_1 = $n(t);
        var newLength = (($n(prefix).u.length + suffix.u.length) | 0);
        var this$14 = $n(prefix);
        var this$15 = $objectGetClass(this$14);
        var that = this$15.data.getComponentType();
        if ($d_jl_StackTraceElement.isAssignableFrom($n(that).data)) {
          var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(prefix, newLength, $d_jl_StackTraceElement.getArrayOf().getClassOf());
        } else {
          var dest = new ($d_jl_StackTraceElement.getArrayOf().constr)(newLength);
          $m_s_Array$().copy__O__I__O__I__I__V(prefix, 0, dest, 0, $n(prefix).u.length);
          var dest$1 = dest;
        }
        $m_s_Array$().copy__O__I__O__I__I__V(suffix, 0, dest$1, $n(prefix).u.length, suffix.u.length);
        $x_1.setStackTrace__Ajl_StackTraceElement__V($asArrayOf_jl_StackTraceElement(dest$1, 1));
      }
    }
  }
});
$c_Lcats_effect_tracing_Tracing$.prototype.getFrames__Lcats_effect_tracing_RingBuffer__sci_List = (function(events) {
  var this$1 = $n($n($n(events).toList__sci_List()).collect__s_PartialFunction__sci_List(new $c_Lcats_effect_tracing_Tracing$$anon$1()));
  var f = ((_$1) => {
    var _$1$1 = $as_jl_StackTraceElement(_$1);
    return (_$1$1 !== null);
  });
  var l = this$1;
  block: {
    var result;
    while (true) {
      if ($n(l).isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = $n(l).head__O();
        var t = $as_sci_List($n(l).tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if ($n(remaining).isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x = $n(remaining).head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List($n(remaining).tail__O());
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon($n(start).head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List($n(start).tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
              $n(currentLast).sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List($n(toProcess).tail__O());
            }
            var next = $as_sci_List($n(firstMiss).tail__O());
            var nextToCopy = next;
            while ((!$n(next).isEmpty__Z())) {
              var head = $n(next).head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List($n(next).tail__O());
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
                  $n(currentLast).sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
                }
                nextToCopy = $as_sci_List($n(next).tail__O());
                next = $as_sci_List($n(next).tail__O());
              }
            }
            if ((!$n(nextToCopy).isEmpty__Z())) {
              $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  return result;
});
function $as_Lcats_effect_tracing_Tracing$(obj) {
  return (((obj instanceof $c_Lcats_effect_tracing_Tracing$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.Tracing$"));
}
function $isArrayOf_Lcats_effect_tracing_Tracing$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_Tracing$)));
}
function $asArrayOf_Lcats_effect_tracing_Tracing$(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_Tracing$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.Tracing$;", depth));
}
var $d_Lcats_effect_tracing_Tracing$ = new $TypeData().initClass($c_Lcats_effect_tracing_Tracing$, "cats.effect.tracing.Tracing$", ({
  Lcats_effect_tracing_Tracing$: 1,
  Lcats_effect_tracing_TracingPlatform: 1
}));
var $n_Lcats_effect_tracing_Tracing$;
function $m_Lcats_effect_tracing_Tracing$() {
  if ((!$n_Lcats_effect_tracing_Tracing$)) {
    $n_Lcats_effect_tracing_Tracing$ = new $c_Lcats_effect_tracing_Tracing$();
  }
  return $n_Lcats_effect_tracing_Tracing$;
}
function $is_Lcats_effect_tracing_TracingEvent(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_tracing_TracingEvent)));
}
function $as_Lcats_effect_tracing_TracingEvent(obj) {
  return (($is_Lcats_effect_tracing_TracingEvent(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.TracingEvent"));
}
function $isArrayOf_Lcats_effect_tracing_TracingEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_TracingEvent)));
}
function $asArrayOf_Lcats_effect_tracing_TracingEvent(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_TracingEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.TracingEvent;", depth));
}
var $d_Lcats_effect_tracing_TracingEvent = new $TypeData().initClass(1, "cats.effect.tracing.TracingEvent", ({
  Lcats_effect_tracing_TracingEvent: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1(outer) {
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer = outer;
}
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1() {
}
$h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype;
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1.prototype.run__V = (function() {
  var i = 0;
  while (((i < $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$batchSize) && (!$n($n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers).Lcats_effect_unsafe_JSArrayQueue__f_empty))) {
    var this$1 = $n($n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers);
    var a = this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex];
    this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex] = null;
    this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = ((1 + this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex) | 0);
    if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex === this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_empty = true;
    }
    if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex >= $uI(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length))) {
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex = 0;
    }
    var fiber = $as_Lcats_effect_IOFiber(a);
    try {
      $n(fiber).run__V();
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchResult1: {
        if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
          $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).reportFailure__jl_Throwable__V(e$2);
          break matchResult1;
        }
        $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
      }
    }
    i = ((1 + i) | 0);
  }
  if ((!$n($n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers).Lcats_effect_unsafe_JSArrayQueue__f_empty)) {
    $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$().execute__jl_Runnable__V(this);
  } else {
    $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1__f_$outer).Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = true;
  }
});
var $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1 = new $TypeData().initClass($c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1, "cats.effect.unsafe.BatchingMacrotaskExecutor$$anon$1", ({
  Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2(r$3, outer) {
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_r$2 = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_$outer = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_r$2 = r$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_$outer = outer;
}
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype = new $h_O();
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype.constructor = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2;
/** @constructor */
function $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2() {
}
$h_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype;
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2.prototype.run__V = (function() {
  var this$1 = $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_$outer);
  var r$1 = this.Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2__f_r$2;
  var this$2 = $n(this$1.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag);
  this$2.subtractOne__O__scm_Shrinkable(r$1);
  $n(r$1).run__V();
});
var $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2 = new $TypeData().initClass($c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2, "cats.effect.unsafe.BatchingMacrotaskExecutor$$anon$2", ({
  Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitor() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
}
$c_Lcats_effect_unsafe_FiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitorShared();
$c_Lcats_effect_unsafe_FiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitor() {
}
$h_Lcats_effect_unsafe_FiberMonitor.prototype = $c_Lcats_effect_unsafe_FiberMonitor.prototype;
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitor$() {
  $ct_Lcats_effect_unsafe_FiberMonitorPlatform__(this);
}
$c_Lcats_effect_unsafe_FiberMonitor$.prototype = new $h_Lcats_effect_unsafe_FiberMonitorPlatform();
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitor$;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitor$() {
}
$h_Lcats_effect_unsafe_FiberMonitor$.prototype = $c_Lcats_effect_unsafe_FiberMonitor$.prototype;
var $d_Lcats_effect_unsafe_FiberMonitor$ = new $TypeData().initClass($c_Lcats_effect_unsafe_FiberMonitor$, "cats.effect.unsafe.FiberMonitor$", ({
  Lcats_effect_unsafe_FiberMonitor$: 1,
  Lcats_effect_unsafe_FiberMonitorPlatform: 1
}));
var $n_Lcats_effect_unsafe_FiberMonitor$;
function $m_Lcats_effect_unsafe_FiberMonitor$() {
  if ((!$n_Lcats_effect_unsafe_FiberMonitor$)) {
    $n_Lcats_effect_unsafe_FiberMonitor$ = new $c_Lcats_effect_unsafe_FiberMonitor$();
  }
  return $n_Lcats_effect_unsafe_FiberMonitor$;
}
function $p_Lcats_effect_unsafe_IORuntime$__unregisterAndShutdown$1__F0__F0__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0($thiz, unregister$1, shutdown$1, runtime$lzy1$1, compute$1, blocking$1, scheduler$1, pollers$1, fiberMonitor$1, config$1, metrics$1) {
  return new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    $n(unregister$1).apply__O();
    $n(shutdown$1).apply__O();
    var $x_2 = $n($thiz.Lcats_effect_unsafe_IORuntime$__f_allRuntimes);
    var $x_1 = $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$1, compute$1, blocking$1, scheduler$1, pollers$1, fiberMonitor$1, config$1, metrics$1, unregister$1, shutdown$1);
    var this$2 = $n($p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$1, compute$1, blocking$1, scheduler$1, pollers$1, fiberMonitor$1, config$1, metrics$1, unregister$1, shutdown$1));
    $x_2.remove__O__I__V($x_1, $systemIdentityHashCode(this$2));
  }));
}
function $p_Lcats_effect_unsafe_IORuntime$__runtime$lzyINIT1$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$3, compute$3, blocking$3, scheduler$3, pollers$3, fiberMonitor$3, config$3, metrics$3, unregister$3, shutdown$3) {
  if ((runtime$lzy1$3 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lcats_effect_unsafe_IORuntime(($n(runtime$lzy1$3).sr_LazyRef__f__initialized ? $n(runtime$lzy1$3).sr_LazyRef__f__value : $n(runtime$lzy1$3).initialize__O__O(new $c_Lcats_effect_unsafe_IORuntime(compute$3, blocking$3, scheduler$3, pollers$3, fiberMonitor$3, $p_Lcats_effect_unsafe_IORuntime$__unregisterAndShutdown$1__F0__F0__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0($thiz, unregister$3, shutdown$3, runtime$lzy1$3, compute$3, blocking$3, scheduler$3, pollers$3, fiberMonitor$3, config$3, metrics$3), config$3, metrics$3))));
}
function $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$4, compute$4, blocking$4, scheduler$4, pollers$4, fiberMonitor$4, config$4, metrics$4, unregister$4, shutdown$4) {
  return $as_Lcats_effect_unsafe_IORuntime(($n(runtime$lzy1$4).sr_LazyRef__f__initialized ? $n(runtime$lzy1$4).sr_LazyRef__f__value : $p_Lcats_effect_unsafe_IORuntime$__runtime$lzyINIT1$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime($thiz, runtime$lzy1$4, compute$4, blocking$4, scheduler$4, pollers$4, fiberMonitor$4, config$4, metrics$4, unregister$4, shutdown$4)));
}
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntime$() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
  this.Lcats_effect_unsafe_IORuntime$__f_allRuntimes = null;
  this.Lcats_effect_unsafe_IORuntime$__f_globalFatalFailureHandled = null;
  $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__(this);
  $n_Lcats_effect_unsafe_IORuntime$ = this;
  this.Lcats_effect_unsafe_IORuntime$__f_allRuntimes = new $c_Lcats_effect_unsafe_ThreadSafeHashtable(4);
  this.Lcats_effect_unsafe_IORuntime$__f_globalFatalFailureHandled = $ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $c_ju_concurrent_atomic_AtomicBoolean(), false);
}
$c_Lcats_effect_unsafe_IORuntime$.prototype = new $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform();
$c_Lcats_effect_unsafe_IORuntime$.prototype.constructor = $c_Lcats_effect_unsafe_IORuntime$;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntime$() {
}
$h_Lcats_effect_unsafe_IORuntime$.prototype = $c_Lcats_effect_unsafe_IORuntime$.prototype;
$c_Lcats_effect_unsafe_IORuntime$.prototype.apply__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__F0__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_IORuntime = (function(compute, blocking, scheduler, pollers, shutdown, config) {
  var runtime$lzy1 = new $c_sr_LazyRef();
  var fiberMonitor = $m_Lcats_effect_unsafe_FiberMonitor$().apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_FiberMonitor(compute);
  var unregister = this.registerFiberMonitorMBean__Lcats_effect_unsafe_FiberMonitor__F0(fiberMonitor);
  var metrics = $m_Lcats_effect_unsafe_metrics_IORuntimeMetrics$().apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_metrics_IORuntimeMetrics(compute);
  var $x_2 = $n(this.Lcats_effect_unsafe_IORuntime$__f_allRuntimes);
  var $x_1 = $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime(this, runtime$lzy1, compute, blocking, scheduler, pollers, fiberMonitor, config, metrics, unregister, shutdown);
  var this$1 = $n($p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime(this, runtime$lzy1, compute, blocking, scheduler, pollers, fiberMonitor, config, metrics, unregister, shutdown));
  $x_2.put__O__I__V($x_1, $systemIdentityHashCode(this$1));
  return $p_Lcats_effect_unsafe_IORuntime$__runtime$1__sr_LazyRef__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__sci_List__Lcats_effect_unsafe_FiberMonitor__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_metrics_IORuntimeMetrics__F0__F0__Lcats_effect_unsafe_IORuntime(this, runtime$lzy1, compute, blocking, scheduler, pollers, fiberMonitor, config, metrics, unregister, shutdown);
});
var $d_Lcats_effect_unsafe_IORuntime$ = new $TypeData().initClass($c_Lcats_effect_unsafe_IORuntime$, "cats.effect.unsafe.IORuntime$", ({
  Lcats_effect_unsafe_IORuntime$: 1,
  Lcats_effect_unsafe_IORuntimeCompanionPlatform: 1
}));
var $n_Lcats_effect_unsafe_IORuntime$;
function $m_Lcats_effect_unsafe_IORuntime$() {
  if ((!$n_Lcats_effect_unsafe_IORuntime$)) {
    $n_Lcats_effect_unsafe_IORuntime$ = new $c_Lcats_effect_unsafe_IORuntime$();
  }
  return $n_Lcats_effect_unsafe_IORuntime$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1() {
}
$h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype = $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype;
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype.deregister__V = (function() {
});
var $d_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 = new $TypeData().initClass($c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1, "cats.effect.unsafe.NoOpFiberMonitor$$anon$1", ({
  Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_Scheduler$() {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl = null;
  $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__(this);
}
$c_Lcats_effect_unsafe_Scheduler$.prototype = new $h_Lcats_effect_unsafe_SchedulerCompanionPlatform();
$c_Lcats_effect_unsafe_Scheduler$.prototype.constructor = $c_Lcats_effect_unsafe_Scheduler$;
/** @constructor */
function $h_Lcats_effect_unsafe_Scheduler$() {
}
$h_Lcats_effect_unsafe_Scheduler$.prototype = $c_Lcats_effect_unsafe_Scheduler$.prototype;
var $d_Lcats_effect_unsafe_Scheduler$ = new $TypeData().initClass($c_Lcats_effect_unsafe_Scheduler$, "cats.effect.unsafe.Scheduler$", ({
  Lcats_effect_unsafe_Scheduler$: 1,
  Lcats_effect_unsafe_SchedulerCompanionPlatform: 1
}));
var $n_Lcats_effect_unsafe_Scheduler$;
function $m_Lcats_effect_unsafe_Scheduler$() {
  if ((!$n_Lcats_effect_unsafe_Scheduler$)) {
    $n_Lcats_effect_unsafe_Scheduler$ = new $c_Lcats_effect_unsafe_Scheduler$();
  }
  return $n_Lcats_effect_unsafe_Scheduler$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1(handle$3, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_handle$2 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_handle$2 = handle$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype.run__V = (function() {
  var handle$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_handle$2;
  $m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(handle$1);
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$1", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype.run__V = (function() {
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$2", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3(outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer = outer;
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable = (function(delay, task) {
  var this$1 = $n(delay);
  var that = $n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout;
  if ($f_s_math_Ordered__$less$eq__O__Z(this$1, that)) {
    var handle = $m_sjs_js_timers_package$().setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle(delay, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      $n(task).run__V();
    })));
    return $as_jl_Runnable((0, $n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$mkCancelRunnable)(handle));
  } else {
    var elem = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4(this);
    var cancel = new $c_sr_ObjectRef(elem);
    cancel.sr_ObjectRef__f_elem = this.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable($n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout, new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5(cancel, delay, task, this));
    return new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6(cancel, this);
  }
});
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.nowMicros__J = (function() {
  return $uJ((0, $n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$nowMicrosImpl)());
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$3", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3: 1,
  Lcats_effect_unsafe_Scheduler: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype.run__V = (function() {
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$4", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5(cancel$5, delay$3, task$5, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$3 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_delay$2 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_task$4 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_$outer = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$3 = cancel$5;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_delay$2 = delay$3;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_task$4 = task$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_$outer = outer;
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype.run__V = (function() {
  var this$1 = $n(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_$outer);
  var cancel$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$3;
  var delay$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_delay$2;
  var task$2 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_task$4;
  $n(cancel$1).sr_ObjectRef__f_elem = this$1.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable($n(delay$1).$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration($n(this$1.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3__f_$outer).Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout), task$2);
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$5", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6(cancel$6, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6__f_cancel$4 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6__f_cancel$4 = cancel$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6() {
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6.prototype.run__V = (function() {
  var cancel$2 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6__f_cancel$4;
  $n($as_jl_Runnable($n(cancel$2).sr_ObjectRef__f_elem)).run__V();
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6 = new $TypeData().initClass($c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$6", ({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$6: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_WeakBag$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_WeakBag$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_WeakBag$$anon$1() {
}
$h_Lcats_effect_unsafe_WeakBag$$anon$1.prototype = $c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype;
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype.deregister__V = (function() {
});
var $d_Lcats_effect_unsafe_WeakBag$$anon$1 = new $TypeData().initClass($c_Lcats_effect_unsafe_WeakBag$$anon$1, "cats.effect.unsafe.WeakBag$$anon$1", ({
  Lcats_effect_unsafe_WeakBag$$anon$1: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
}));
function $as_Lcats_effect_unsafe_WorkStealingThreadPool(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.WorkStealingThreadPool"));
}
function $isArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WorkStealingThreadPool)));
}
function $asArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.WorkStealingThreadPool;", depth));
}
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$() {
}
$c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$.prototype = new $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform();
$c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$.prototype.constructor = $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_IORuntimeMetrics$() {
}
$h_Lcats_effect_unsafe_metrics_IORuntimeMetrics$.prototype = $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$.prototype;
var $d_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ = new $TypeData().initClass($c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$, "cats.effect.unsafe.metrics.IORuntimeMetrics$", ({
  Lcats_effect_unsafe_metrics_IORuntimeMetrics$: 1,
  Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform: 1
}));
var $n_Lcats_effect_unsafe_metrics_IORuntimeMetrics$;
function $m_Lcats_effect_unsafe_metrics_IORuntimeMetrics$() {
  if ((!$n_Lcats_effect_unsafe_metrics_IORuntimeMetrics$)) {
    $n_Lcats_effect_unsafe_metrics_IORuntimeMetrics$ = new $c_Lcats_effect_unsafe_metrics_IORuntimeMetrics$();
  }
  return $n_Lcats_effect_unsafe_metrics_IORuntimeMetrics$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_ref_WeakReference() {
  this.Lcats_effect_unsafe_ref_Reference__f_queue = null;
  this.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
}
$c_Lcats_effect_unsafe_ref_WeakReference.prototype = new $h_Lcats_effect_unsafe_ref_Reference();
$c_Lcats_effect_unsafe_ref_WeakReference.prototype.constructor = $c_Lcats_effect_unsafe_ref_WeakReference;
/** @constructor */
function $h_Lcats_effect_unsafe_ref_WeakReference() {
}
$h_Lcats_effect_unsafe_ref_WeakReference.prototype = $c_Lcats_effect_unsafe_ref_WeakReference.prototype;
function $f_Lcats_instances_Function1Instances__$init$__V($thiz) {
  $thiz.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V(new $c_Lcats_instances_Function1Instances$$anon$6());
  $thiz.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V(new $c_Lcats_instances_Function1Instances$$anon$7($thiz));
}
/** @constructor */
function $c_Lcats_instances_package$equiv$() {
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = null;
  $n_Lcats_instances_package$equiv$ = this;
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = new $c_Lcats_instances_EquivInstances$$anon$1();
}
$c_Lcats_instances_package$equiv$.prototype = new $h_O();
$c_Lcats_instances_package$equiv$.prototype.constructor = $c_Lcats_instances_package$equiv$;
/** @constructor */
function $h_Lcats_instances_package$equiv$() {
}
$h_Lcats_instances_package$equiv$.prototype = $c_Lcats_instances_package$equiv$.prototype;
var $d_Lcats_instances_package$equiv$ = new $TypeData().initClass($c_Lcats_instances_package$equiv$, "cats.instances.package$equiv$", ({
  Lcats_instances_package$equiv$: 1,
  Lcats_instances_EquivInstances: 1
}));
var $n_Lcats_instances_package$equiv$;
function $m_Lcats_instances_package$equiv$() {
  if ((!$n_Lcats_instances_package$equiv$)) {
    $n_Lcats_instances_package$equiv$ = new $c_Lcats_instances_package$equiv$();
  }
  return $n_Lcats_instances_package$equiv$;
}
/** @constructor */
function $c_Lcats_instances_package$ordering$() {
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = null;
  $n_Lcats_instances_package$ordering$ = this;
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = new $c_Lcats_instances_OrderingInstances$$anon$1();
}
$c_Lcats_instances_package$ordering$.prototype = new $h_O();
$c_Lcats_instances_package$ordering$.prototype.constructor = $c_Lcats_instances_package$ordering$;
/** @constructor */
function $h_Lcats_instances_package$ordering$() {
}
$h_Lcats_instances_package$ordering$.prototype = $c_Lcats_instances_package$ordering$.prototype;
var $d_Lcats_instances_package$ordering$ = new $TypeData().initClass($c_Lcats_instances_package$ordering$, "cats.instances.package$ordering$", ({
  Lcats_instances_package$ordering$: 1,
  Lcats_instances_OrderingInstances: 1
}));
var $n_Lcats_instances_package$ordering$;
function $m_Lcats_instances_package$ordering$() {
  if ((!$n_Lcats_instances_package$ordering$)) {
    $n_Lcats_instances_package$ordering$ = new $c_Lcats_instances_package$ordering$();
  }
  return $n_Lcats_instances_package$ordering$;
}
/** @constructor */
function $c_Lcats_instances_package$partialOrdering$() {
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = null;
  $n_Lcats_instances_package$partialOrdering$ = this;
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = new $c_Lcats_instances_PartialOrderingInstances$$anon$1();
}
$c_Lcats_instances_package$partialOrdering$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrdering$.prototype.constructor = $c_Lcats_instances_package$partialOrdering$;
/** @constructor */
function $h_Lcats_instances_package$partialOrdering$() {
}
$h_Lcats_instances_package$partialOrdering$.prototype = $c_Lcats_instances_package$partialOrdering$.prototype;
var $d_Lcats_instances_package$partialOrdering$ = new $TypeData().initClass($c_Lcats_instances_package$partialOrdering$, "cats.instances.package$partialOrdering$", ({
  Lcats_instances_package$partialOrdering$: 1,
  Lcats_instances_PartialOrderingInstances: 1
}));
var $n_Lcats_instances_package$partialOrdering$;
function $m_Lcats_instances_package$partialOrdering$() {
  if ((!$n_Lcats_instances_package$partialOrdering$)) {
    $n_Lcats_instances_package$partialOrdering$ = new $c_Lcats_instances_package$partialOrdering$();
  }
  return $n_Lcats_instances_package$partialOrdering$;
}
function $f_Lcats_kernel_Eq__neqv__O__O__Z($thiz, x, y) {
  return (!$thiz.eqv__O__O__Z(x, y));
}
function $is_Lcats_kernel_Eq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Eq)));
}
function $as_Lcats_kernel_Eq(obj) {
  return (($is_Lcats_kernel_Eq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Eq"));
}
function $isArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Eq)));
}
function $asArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Eq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Eq;", depth));
}
/** @constructor */
function $c_Lcats_kernel_HashFunctions() {
}
$c_Lcats_kernel_HashFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_HashFunctions.prototype.constructor = $c_Lcats_kernel_HashFunctions;
/** @constructor */
function $h_Lcats_kernel_HashFunctions() {
}
$h_Lcats_kernel_HashFunctions.prototype = $c_Lcats_kernel_HashFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_PartialOrderFunctions() {
}
$c_Lcats_kernel_PartialOrderFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_PartialOrderFunctions.prototype.constructor = $c_Lcats_kernel_PartialOrderFunctions;
/** @constructor */
function $h_Lcats_kernel_PartialOrderFunctions() {
}
$h_Lcats_kernel_PartialOrderFunctions.prototype = $c_Lcats_kernel_PartialOrderFunctions.prototype;
function $is_Lcats_kernel_Semigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Semigroup)));
}
function $as_Lcats_kernel_Semigroup(obj) {
  return (($is_Lcats_kernel_Semigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Semigroup"));
}
function $isArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Semigroup)));
}
function $asArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Semigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Semigroup;", depth));
}
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$() {
}
$c_Lcats_kernel_instances_StaticMethods$.prototype = new $h_Lcats_kernel_compat_HashCompat();
$c_Lcats_kernel_instances_StaticMethods$.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$() {
}
$h_Lcats_kernel_instances_StaticMethods$.prototype = $c_Lcats_kernel_instances_StaticMethods$.prototype;
$c_Lcats_kernel_instances_StaticMethods$.prototype.combineAllIterable__scm_Builder__sc_IterableOnce__O = (function(b, xs) {
  var this$1 = $n($n(xs).iterator__sc_Iterator());
  while (this$1.hasNext__Z()) {
    var x0 = this$1.next__O();
    var _$1 = $as_sc_Iterable(x0);
    var this$2 = $n(b);
    $as_scm_Builder(this$2.addAll__sc_IterableOnce__scm_Growable(_$1));
  }
  return $n(b).result__O();
});
var $d_Lcats_kernel_instances_StaticMethods$ = new $TypeData().initClass($c_Lcats_kernel_instances_StaticMethods$, "cats.kernel.instances.StaticMethods$", ({
  Lcats_kernel_instances_StaticMethods$: 1,
  Lcats_kernel_compat_HashCompat: 1
}));
var $n_Lcats_kernel_instances_StaticMethods$;
function $m_Lcats_kernel_instances_StaticMethods$() {
  if ((!$n_Lcats_kernel_instances_StaticMethods$)) {
    $n_Lcats_kernel_instances_StaticMethods$ = new $c_Lcats_kernel_instances_StaticMethods$();
  }
  return $n_Lcats_kernel_instances_StaticMethods$;
}
/** @constructor */
function $c_Lcats_kernel_instances_long_package$() {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdOrderForLong = null;
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong = null;
  $n_Lcats_kernel_instances_long_package$ = this;
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this);
}
$c_Lcats_kernel_instances_long_package$.prototype = new $h_O();
$c_Lcats_kernel_instances_long_package$.prototype.constructor = $c_Lcats_kernel_instances_long_package$;
/** @constructor */
function $h_Lcats_kernel_instances_long_package$() {
}
$h_Lcats_kernel_instances_long_package$.prototype = $c_Lcats_kernel_instances_long_package$.prototype;
$c_Lcats_kernel_instances_long_package$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdOrderForLong = x$0;
});
$c_Lcats_kernel_instances_long_package$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong = x$0;
});
var $d_Lcats_kernel_instances_long_package$ = new $TypeData().initClass($c_Lcats_kernel_instances_long_package$, "cats.kernel.instances.long.package$", ({
  Lcats_kernel_instances_long_package$: 1,
  Lcats_kernel_instances_LongInstances: 1
}));
var $n_Lcats_kernel_instances_long_package$;
function $m_Lcats_kernel_instances_long_package$() {
  if ((!$n_Lcats_kernel_instances_long_package$)) {
    $n_Lcats_kernel_instances_long_package$ = new $c_Lcats_kernel_instances_long_package$();
  }
  return $n_Lcats_kernel_instances_long_package$;
}
/** @constructor */
function $c_Lcats_kernel_instances_unit_package$() {
  this.Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit = null;
  $n_Lcats_kernel_instances_unit_package$ = this;
  $f_Lcats_kernel_instances_UnitInstances__$init$__V(this);
}
$c_Lcats_kernel_instances_unit_package$.prototype = new $h_O();
$c_Lcats_kernel_instances_unit_package$.prototype.constructor = $c_Lcats_kernel_instances_unit_package$;
/** @constructor */
function $h_Lcats_kernel_instances_unit_package$() {
}
$h_Lcats_kernel_instances_unit_package$.prototype = $c_Lcats_kernel_instances_unit_package$.prototype;
$c_Lcats_kernel_instances_unit_package$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_kernel_instances_unit_package$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
  this.Lcats_kernel_instances_unit_package$__f_catsKernelStdAlgebraForUnit = x$0;
});
var $d_Lcats_kernel_instances_unit_package$ = new $TypeData().initClass($c_Lcats_kernel_instances_unit_package$, "cats.kernel.instances.unit.package$", ({
  Lcats_kernel_instances_unit_package$: 1,
  Lcats_kernel_instances_UnitInstances: 1
}));
var $n_Lcats_kernel_instances_unit_package$;
function $m_Lcats_kernel_instances_unit_package$() {
  if ((!$n_Lcats_kernel_instances_unit_package$)) {
    $n_Lcats_kernel_instances_unit_package$ = new $c_Lcats_kernel_instances_unit_package$();
  }
  return $n_Lcats_kernel_instances_unit_package$;
}
/** @constructor */
function $c_Lcats_syntax_Tuple2SemigroupalOps(t) {
  this.Lcats_syntax_Tuple2SemigroupalOps__f_t = null;
  this.Lcats_syntax_Tuple2SemigroupalOps__f_t = t;
}
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple2SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple2SemigroupalOps() {
}
$h_Lcats_syntax_Tuple2SemigroupalOps.prototype = $c_Lcats_syntax_Tuple2SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.mapN__F2__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t)._1__O();
  var f1 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t)._2__O();
  return $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f, semigroupal, functor);
});
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.flatMapN__F2__Lcats_FlatMap__O = (function(f, flatMap) {
  return $f_Lcats_FlatMapArityFunctions__flatMap2__O__O__F2__O($n(flatMap), $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t)._1__O(), $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t)._2__O(), f);
});
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.tupled__Lcats_Invariant__Lcats_Semigroupal__O = (function(invariant, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t)._1__O();
  var f1 = $n(this.Lcats_syntax_Tuple2SemigroupalOps__f_t)._2__O();
  return $f_Lcats_SemigroupalArityFunctions__tuple2__O__O__Lcats_Semigroupal__Lcats_Invariant__O(this$1, f0, f1, semigroupal, invariant);
});
var $d_Lcats_syntax_Tuple2SemigroupalOps = new $TypeData().initClass($c_Lcats_syntax_Tuple2SemigroupalOps, "cats.syntax.Tuple2SemigroupalOps", ({
  Lcats_syntax_Tuple2SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_syntax_Tuple3SemigroupalOps(t) {
  this.Lcats_syntax_Tuple3SemigroupalOps__f_t = null;
  this.Lcats_syntax_Tuple3SemigroupalOps__f_t = t;
}
$c_Lcats_syntax_Tuple3SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple3SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple3SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple3SemigroupalOps() {
}
$h_Lcats_syntax_Tuple3SemigroupalOps.prototype = $c_Lcats_syntax_Tuple3SemigroupalOps.prototype;
var $d_Lcats_syntax_Tuple3SemigroupalOps = new $TypeData().initClass($c_Lcats_syntax_Tuple3SemigroupalOps, "cats.syntax.Tuple3SemigroupalOps", ({
  Lcats_syntax_Tuple3SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_syntax_Tuple4SemigroupalOps(t) {
  this.Lcats_syntax_Tuple4SemigroupalOps__f_t = null;
  this.Lcats_syntax_Tuple4SemigroupalOps__f_t = t;
}
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple4SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple4SemigroupalOps() {
}
$h_Lcats_syntax_Tuple4SemigroupalOps.prototype = $c_Lcats_syntax_Tuple4SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype.flatMapN__F4__Lcats_FlatMap__O = (function(f, flatMap) {
  return $f_Lcats_FlatMapArityFunctions__flatMap4__O__O__O__O__F4__O($n(flatMap), $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t).T4__f__1, $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t).T4__f__2, $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t).T4__f__3, $n(this.Lcats_syntax_Tuple4SemigroupalOps__f_t).T4__f__4, f);
});
var $d_Lcats_syntax_Tuple4SemigroupalOps = new $TypeData().initClass($c_Lcats_syntax_Tuple4SemigroupalOps, "cats.syntax.Tuple4SemigroupalOps", ({
  Lcats_syntax_Tuple4SemigroupalOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Compiler$$anon$5() {
  $m_Lcats_package$();
}
$c_Lfs2_Compiler$$anon$5.prototype = new $h_O();
$c_Lfs2_Compiler$$anon$5.prototype.constructor = $c_Lfs2_Compiler$$anon$5;
/** @constructor */
function $h_Lfs2_Compiler$$anon$5() {
}
$h_Lfs2_Compiler$$anon$5.prototype = $c_Lfs2_Compiler$$anon$5.prototype;
$c_Lfs2_Compiler$$anon$5.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var this$1 = $m_Lfs2_Compiler$Target$();
  var F = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F$1 = $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target(this$1, F);
  return $n($as_Lcats_effect_SyncIO(new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1).apply__Lfs2_Pull__O__F2__O(stream, init, foldChunk))).unsafeRunSync__O();
});
var $d_Lfs2_Compiler$$anon$5 = new $TypeData().initClass($c_Lfs2_Compiler$$anon$5, "fs2.Compiler$$anon$5", ({
  Lfs2_Compiler$$anon$5: 1,
  Lfs2_Compiler: 1
}));
/** @constructor */
function $c_Lfs2_Compiler$Target$() {
}
$c_Lfs2_Compiler$Target$.prototype = new $h_O();
$c_Lfs2_Compiler$Target$.prototype.constructor = $c_Lfs2_Compiler$Target$;
/** @constructor */
function $h_Lfs2_Compiler$Target$() {
}
$h_Lfs2_Compiler$Target$.prototype = $c_Lfs2_Compiler$Target$.prototype;
var $d_Lfs2_Compiler$Target$ = new $TypeData().initClass($c_Lfs2_Compiler$Target$, "fs2.Compiler$Target$", ({
  Lfs2_Compiler$Target$: 1,
  Lfs2_Compiler$TargetLowPriority: 1
}));
var $n_Lfs2_Compiler$Target$;
function $m_Lfs2_Compiler$Target$() {
  if ((!$n_Lfs2_Compiler$Target$)) {
    $n_Lfs2_Compiler$Target$ = new $c_Lfs2_Compiler$Target$();
  }
  return $n_Lfs2_Compiler$Target$;
}
/** @constructor */
function $c_Lfs2_CompilerLowPriority$$anon$4() {
  $m_Lcats_instances_package$either$();
}
$c_Lfs2_CompilerLowPriority$$anon$4.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.constructor = $c_Lfs2_CompilerLowPriority$$anon$4;
/** @constructor */
function $h_Lfs2_CompilerLowPriority$$anon$4() {
}
$h_Lfs2_CompilerLowPriority$$anon$4.prototype = $c_Lfs2_CompilerLowPriority$$anon$4.prototype;
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.apply__Lfs2_Pull__O__F2__s_util_Either = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var this$1 = $m_Lfs2_Compiler$Target$();
  var F = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F$1 = $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target(this$1, F);
  var this$3 = $n($as_Lcats_effect_SyncIO(new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1).apply__Lfs2_Pull__O__F2__O(stream, init, foldChunk)));
  return $as_s_util_Either(new $c_Lcats_effect_SyncIO$Attempt(this$3).unsafeRunSync__O());
});
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, fold) {
  return this.apply__Lfs2_Pull__O__F2__s_util_Either(stream, init, fold);
});
var $d_Lfs2_CompilerLowPriority$$anon$4 = new $TypeData().initClass($c_Lfs2_CompilerLowPriority$$anon$4, "fs2.CompilerLowPriority$$anon$4", ({
  Lfs2_CompilerLowPriority$$anon$4: 1,
  Lfs2_Compiler: 1
}));
/** @constructor */
function $c_Lfs2_CompilerLowPriority0$$anon$3() {
  $m_Lcats_package$();
}
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype.constructor = $c_Lfs2_CompilerLowPriority0$$anon$3;
/** @constructor */
function $h_Lfs2_CompilerLowPriority0$$anon$3() {
}
$h_Lfs2_CompilerLowPriority0$$anon$3.prototype = $c_Lfs2_CompilerLowPriority0$$anon$3.prototype;
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var this$1 = $m_Lfs2_Compiler$Target$();
  var F = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F$1 = $f_Lfs2_Compiler$TargetLowPriority__forSync__Lcats_effect_kernel_Sync__Lfs2_Compiler$Target(this$1, F);
  return $n($as_Lcats_effect_SyncIO(new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1).apply__Lfs2_Pull__O__F2__O(($m_Lfs2_Pull$(), $m_Lfs2_Pull$IdOps$().covaryId$extension__Lfs2_Pull__Lcats_Applicative__Lfs2_Pull(stream, $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO)), init, foldChunk))).unsafeRunSync__O();
});
var $d_Lfs2_CompilerLowPriority0$$anon$3 = new $TypeData().initClass($c_Lfs2_CompilerLowPriority0$$anon$3, "fs2.CompilerLowPriority0$$anon$3", ({
  Lfs2_CompilerLowPriority0$$anon$3: 1,
  Lfs2_Compiler: 1
}));
/** @constructor */
function $c_Lfs2_CompilerLowPriority1$$anon$2(F$1) {
  this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2 = null;
  this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2 = F$1;
}
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype.constructor = $c_Lfs2_CompilerLowPriority1$$anon$2;
/** @constructor */
function $h_Lfs2_CompilerLowPriority1$$anon$2() {
}
$h_Lfs2_CompilerLowPriority1$$anon$2.prototype = $c_Lfs2_CompilerLowPriority1$$anon$2.prototype;
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  return $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O($n(this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2), stream, init, foldChunk);
});
var $d_Lfs2_CompilerLowPriority1$$anon$2 = new $TypeData().initClass($c_Lfs2_CompilerLowPriority1$$anon$2, "fs2.CompilerLowPriority1$$anon$2", ({
  Lfs2_CompilerLowPriority1$$anon$2: 1,
  Lfs2_Compiler: 1
}));
function $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$($thiz, TheBuildR$lzy1$1, F$7) {
  if ((TheBuildR$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $as_Lfs2_Pull$TheBuildR$2$(($n(TheBuildR$lzy1$1).sr_LazyRef__f__initialized ? $n(TheBuildR$lzy1$1).sr_LazyRef__f__value : $n(TheBuildR$lzy1$1).initialize__O__O(new $c_Lfs2_Pull$TheBuildR$2$(F$7))));
}
function $p_Lfs2_Pull$__TheBuildR$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$($thiz, TheBuildR$lzy1$2, F$8) {
  return $as_Lfs2_Pull$TheBuildR$2$(($n(TheBuildR$lzy1$2).sr_LazyRef__f__initialized ? $n(TheBuildR$lzy1$2).sr_LazyRef__f__value : $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$($thiz, TheBuildR$lzy1$2, F$8)));
}
function $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O(head$2, scope$7, acc, pred) {
  var pred$tailLocal1 = pred;
  var acc$tailLocal1 = acc;
  while (true) {
    var x187 = pred$tailLocal1;
    if ((x187 instanceof $c_Lfs2_Pull$ViewRunner$1)) {
      var vrun = $as_Lfs2_Pull$ViewRunner$1(x187);
      var acc$tailLocal1$tmp1 = $m_Lfs2_Pull$().fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull(acc$tailLocal1, $n(vrun).Lfs2_Pull$ViewRunner$1__f_view);
      var pred$tailLocal1$tmp1 = $n(vrun).Lfs2_Pull$ViewRunner$1__f_prevRunner;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
      pred$tailLocal1 = pred$tailLocal1$tmp1;
      continue;
    }
    return $n(pred$tailLocal1).out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head$2, scope$7, acc$tailLocal1);
  }
}
function $p_Lfs2_Pull$__goEval$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Eval__F1__O($thiz, scope$14, translation$tailLocal1$11, F$21, extendedTopLevelScope$11, runner$tailLocal1$11, extendLastTopLevelScope$12, contP$14, TheBuildR$lzy1$14, eval$1, view) {
  var target = $n(scope$14).interruptibleEval__O__O($n(translation$tailLocal1$11).apply__O__O($n(eval$1).Lfs2_Pull$Eval__f_value));
  var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$21);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((eitherOutcome) => {
    var eitherOutcome$1 = $as_s_util_Either(eitherOutcome);
    matchResult81: {
      var $x_1;
      if ((eitherOutcome$1 instanceof $c_s_util_Right)) {
        var r = $n($as_s_util_Right(eitherOutcome$1)).s_util_Right__f_value;
        var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
        break matchResult81;
      }
      if ((eitherOutcome$1 instanceof $c_s_util_Left)) {
        var x222 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Left(eitherOutcome$1)).s_util_Left__f_value);
        if ((x222 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
          var x$1 = $as_Lcats_effect_kernel_Outcome$Errored(x222);
          var this$5 = $n(x$1);
          var x225 = $as_jl_Throwable(this$5.Lcats_effect_kernel_Outcome$Errored__f_e);
          var $x_1 = new $c_Lfs2_Pull$Fail(x225);
          break matchResult81;
        }
        if (((x222 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x222), true))) {
          var context = $n(scope$14).Lfs2_internal_Scope__f_id;
          var deferredError = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(context, deferredError);
          break matchResult81;
        }
        if ((x222 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(x222);
          var this$9 = $n(x$1$1);
          var x217 = $as_Lcats_effect_kernel_Unique$Token(this$9.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
          var deferredError$1 = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(x217, deferredError$1);
          break matchResult81;
        }
      }
      throw new $c_s_MatchError(eitherOutcome$1);
    }
    var result = $as_Lfs2_Pull$Terminal($x_1);
    return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$21, extendLastTopLevelScope$12, contP$14, TheBuildR$lzy1$14, scope$14, extendedTopLevelScope$11, translation$tailLocal1$11, runner$tailLocal1$11, $as_Lfs2_Pull($n(view).apply__O__O(result)));
  }));
  return $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
}
function $p_Lfs2_Pull$__goAcquire$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Acquire__F1__O($thiz, scope$16, translation$tailLocal1$13, F$23, extendedTopLevelScope$13, runner$tailLocal1$13, extendLastTopLevelScope$14, contP$16, TheBuildR$lzy1$16, acquire, view) {
  var onScope = $n(scope$16).acquireResource__F1__F2__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return ($n(acquire).cancelable__Z() ? $n(poll$1).apply__O__O($n(translation$tailLocal1$13).apply__O__O($n(acquire).resource__O())) : $n(translation$tailLocal1$13).apply__O__O($n(acquire).resource__O()));
  })), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((resource, exit) => {
    var exit$1 = $as_Lcats_effect_kernel_Resource$ExitCase(exit);
    return $n(translation$tailLocal1$13).apply__O__O($n($n(acquire).release__F2()).apply__O__O__O(resource, exit$1));
  })));
  var this$11 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(onScope, F$23);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((outcome) => {
    var outcome$1 = $as_Lcats_effect_kernel_Outcome(outcome);
    matchResult82: {
      var $x_1;
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome$1);
        var this$4 = $n(x$1);
        var x240 = $as_s_util_Either(this$4.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        if ((x240 instanceof $c_s_util_Right)) {
          var r = $n($as_s_util_Right(x240)).s_util_Right__f_value;
          var $x_1 = new $c_Lfs2_Pull$Succeeded(r);
          break matchResult82;
        }
        if ((x240 instanceof $c_s_util_Left)) {
          var scopeId = $as_Lcats_effect_kernel_Unique$Token($n($as_s_util_Left(x240)).s_util_Left__f_value);
          var deferredError = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(scopeId, deferredError);
          break matchResult82;
        }
      }
      if (((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome$1), true))) {
        var context = $n(scope$16).Lfs2_internal_Scope__f_id;
        var deferredError$1 = $m_s_None$();
        var $x_1 = new $c_Lfs2_Pull$Interrupted(context, deferredError$1);
        break matchResult82;
      }
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome$Errored(outcome$1);
        var this$9 = $n(x$1$1);
        var x231 = $as_jl_Throwable(this$9.Lcats_effect_kernel_Outcome$Errored__f_e);
        var $x_1 = new $c_Lfs2_Pull$Fail(x231);
        break matchResult82;
      }
      throw new $c_s_MatchError(outcome$1);
    }
    var result = $as_Lfs2_Pull$Terminal($x_1);
    return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$23, extendLastTopLevelScope$14, contP$16, TheBuildR$lzy1$16, scope$16, extendedTopLevelScope$13, translation$tailLocal1$13, runner$tailLocal1$13, $as_Lfs2_Pull($n(view).apply__O__O(result)));
  }));
  var cont = $n(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$11.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(F$23, extendedTopLevelScope$13, translation$tailLocal1$13, runner$tailLocal1$13, extendLastTopLevelScope$14, contP$16, TheBuildR$lzy1$16, scope$16, view, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => cont)));
}
function $p_Lfs2_Pull$__goInterruptWhen$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__O__F1__O($thiz, scope$18, F$25, extendedTopLevelScope$15, translation$tailLocal1$17, runner$tailLocal1$15, extendLastTopLevelScope$16, contP$18, TheBuildR$lzy1$18, haltOnSignal, view) {
  var onScope = $n(scope$18).acquireResource__F1__F2__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$68) => {
    $as_Lcats_effect_kernel_Poll(_$68);
    return $n(scope$18).interruptWhen__O__O(haltOnSignal);
  })), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((f, _$69) => {
    var f$1 = $as_Lcats_effect_kernel_Fiber(f);
    $as_Lcats_effect_kernel_Resource$ExitCase(_$69);
    return $n(f$1).cancel__O();
  })));
  var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(onScope, F$25);
  var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((outcome) => {
    var outcome$1 = $as_Lcats_effect_kernel_Outcome(outcome);
    matchResult83: {
      var result;
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome$1);
        var this$4 = $n(x$1);
        var x255 = $as_s_util_Either(this$4.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        if ((x255 instanceof $c_s_util_Right)) {
          var result = $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit;
          break matchResult83;
        }
        if ((x255 instanceof $c_s_util_Left)) {
          var scopeId = $as_Lcats_effect_kernel_Unique$Token($n($as_s_util_Left(x255)).s_util_Left__f_value);
          var deferredError = $m_s_None$();
          var result = new $c_Lfs2_Pull$Interrupted(scopeId, deferredError);
          break matchResult83;
        }
      }
      if (((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome$1), true))) {
        var context = $n(scope$18).Lfs2_internal_Scope__f_id;
        var deferredError$1 = $m_s_None$();
        var result = new $c_Lfs2_Pull$Interrupted(context, deferredError$1);
        break matchResult83;
      }
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome$Errored(outcome$1);
        var this$8 = $n(x$1$1);
        var x246 = $as_jl_Throwable(this$8.Lcats_effect_kernel_Outcome$Errored__f_e);
        var result = new $c_Lfs2_Pull$Fail(x246);
        break matchResult83;
      }
      throw new $c_s_MatchError(outcome$1);
    }
    return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$25, extendLastTopLevelScope$16, contP$18, TheBuildR$lzy1$18, scope$18, extendedTopLevelScope$15, translation$tailLocal1$17, runner$tailLocal1$15, $as_Lfs2_Pull($n(view).apply__O__O(result)));
  }));
  var cont = $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(F$25, extendedTopLevelScope$15, translation$tailLocal1$17, runner$tailLocal1$15, extendLastTopLevelScope$16, contP$18, TheBuildR$lzy1$18, scope$18, view, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => cont)));
}
function $p_Lfs2_Pull$__goInScope$1__Lfs2_internal_Scope__s_Option__Lcats_MonadError__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull__Z__F1__O($thiz, scope$21, extendedTopLevelScope$17, F$27, translation$tailLocal1$19, runner$tailLocal1$17, extendLastTopLevelScope$18, contP$20, TheBuildR$lzy1$20, stream, useInterruption, view) {
  var this$1 = $n(scope$21);
  if ($n(this$1.Lfs2_internal_Scope__f_parent).isEmpty__Z()) {
    var this$2 = $n(extendedTopLevelScope$17);
    var $x_1 = (!this$2.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
    var this$6 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(extendedTopLevelScope$17, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$70) => {
      var _$70$1 = $as_Lfs2_internal_Scope(_$70);
      var fea = $n(_$70$1).close__Lcats_effect_kernel_Resource$ExitCase__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
      return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, F$27);
    }));
    var target = $n(this$6.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverseVoid__O__F1__Lcats_Applicative__O(this$6.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, F$27);
    var this$8 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F$27);
    var b = $m_s_None$();
    var maybeCloseExtendedScope = $n(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
  } else {
    var maybeCloseExtendedScope = $n(F$27).pure__O__O(extendedTopLevelScope$17);
  }
  var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(maybeCloseExtendedScope, F$27);
  var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((newExtendedScope) => {
    var newExtendedScope$1 = $as_s_Option(newExtendedScope);
    var fea$1 = $n(scope$21).open__Z__O(useInterruption);
    var target$1 = $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea$1, F$27);
    var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$27);
    var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((childScope) => {
      var childScope$1 = $as_Lfs2_internal_Scope(childScope);
      var bb = new $c_Lfs2_Pull$$anon$8(stream, childScope$1);
      return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$27, extendLastTopLevelScope$18, contP$20, TheBuildR$lzy1$20, childScope$1, newExtendedScope$1, translation$tailLocal1$19, new $c_Lfs2_Pull$ViewRunner$1(runner$tailLocal1$17, extendedTopLevelScope$17, translation$tailLocal1$19, scope$21, F$27, extendLastTopLevelScope$18, contP$20, TheBuildR$lzy1$20, view), bb);
    }));
    return $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  }));
  var tail = $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(F$27, extendedTopLevelScope$17, translation$tailLocal1$19, runner$tailLocal1$17, extendLastTopLevelScope$18, contP$20, TheBuildR$lzy1$20, scope$21, view, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => tail)));
}
function $p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal($thiz, err, res) {
  if ((res instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$1 = $as_Lfs2_Pull$Succeeded(res);
    var this$2 = $n(x$1);
    $as_jl_Void(this$2.Lfs2_Pull$Succeeded__f_r);
    return new $c_Lfs2_Pull$Fail(err);
  }
  if ((res instanceof $c_Lfs2_Pull$Fail)) {
    var x$1$1 = $as_Lfs2_Pull$Fail(res);
    var this$5 = $n(x$1$1);
    var x276 = this$5.Lfs2_Pull$Fail__f_error;
    var error = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(err, x276, $m_sci_Nil$());
    return new $c_Lfs2_Pull$Fail(error);
  }
  if ((res instanceof $c_Lfs2_Pull$Interrupted)) {
    var x$1$2 = $as_Lfs2_Pull$Interrupted(res);
    $n(x$1$2);
    $n(x$1$2);
    $m_s_sys_package$().error__T__E("Impossible, cannot interrupt here");
  }
  throw new $c_s_MatchError(res);
}
function $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close$1, view$9, res) {
  var x280 = $n(close$1).exitCase__Lcats_effect_kernel_Resource$ExitCase();
  if ((x280 instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored)) {
    var x$1 = $as_Lcats_effect_kernel_Resource$ExitCase$Errored(x280);
    var this$2 = $n(x$1);
    var x283 = this$2.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    return $as_Lfs2_Pull($n(view$9).apply__O__O($p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal($thiz, x283, res)));
  }
  return $as_Lfs2_Pull($n(view$9).apply__O__O(res));
}
function $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r$1, err$1) {
  var $x_1 = $m_Lfs2_CompositeFailure$();
  var this$1 = $n($n($n($n(r$1).swap__s_util_Either()).toOption__s_Option()).toList__sci_List());
  var suffix = $n(err$1).toList__sci_List();
  return $x_1.fromList__sci_List__s_Option(this$1.appendedAll__sc_IterableOnce__sci_List(suffix));
}
function $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal($thiz, close$2, r, ancestor) {
  var x287 = $n(close$2).interruption__s_Option();
  var x = $m_s_None$();
  if ((x === x287)) {
    var this$1 = $n(r);
    if ((this$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$1);
      var b = $n(x2).s_util_Right__f_value;
      var _$72 = $as_jl_Void(b);
      var $x_1 = new $c_Lfs2_Pull$Succeeded(_$72);
    } else {
      if ((!(this$1 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(this$1);
      }
      var x3 = $as_s_util_Left(this$1);
      var a = $n(x3).s_util_Left__f_value;
      var _$71 = $as_jl_Throwable(a);
      var $x_1 = new $c_Lfs2_Pull$Fail(_$71);
    }
    return $as_Lfs2_Pull$Terminal($x_1);
  }
  if ((x287 instanceof $c_s_Some)) {
    var x289 = $as_Lfs2_Pull$Interrupted($n($as_s_Some(x287)).s_Some__f_value);
    if ((x289 !== null)) {
      var this$5 = $n(x289);
      var x291 = this$5.Lfs2_Pull$Interrupted__f_context;
      var this$6 = $n(x289);
      var x292 = this$6.Lfs2_Pull$Interrupted__f_deferredError;
      if ($n(ancestor).descendsFrom__Lcats_effect_kernel_Unique$Token__Z(x291)) {
        var deferredError = $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r, x292);
        return new $c_Lfs2_Pull$Interrupted(x291, deferredError);
      } else {
        var x284 = $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r, x292);
        var x$3 = $m_s_None$();
        if ((x$3 === x284)) {
          return $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit;
        }
        if ((x284 instanceof $c_s_Some)) {
          var e2 = $as_jl_Throwable($n($as_s_Some(x284)).s_Some__f_value);
          return new $c_Lfs2_Pull$Fail(e2);
        }
        throw new $c_s_MatchError(x284);
      }
    }
  }
  throw new $c_s_MatchError(x287);
}
function $p_Lfs2_Pull$__goCloseScope$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$CloseScope__F1__O($thiz, scope$24, F$31, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, close, view) {
  var target = $n(scope$24).findInLineage__Lcats_effect_kernel_Unique$Token__O($n(close).scopeId__Lcats_effect_kernel_Unique$Token());
  var this$20 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$31);
  var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var x299 = $as_Lfs2_internal_Scope($n($as_s_Some(x$1$1)).s_Some__f_value);
      var this$3 = $n(x299);
      if ($n(this$3.Lfs2_internal_Scope__f_parent).isEmpty__Z()) {
        return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$31, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, scope$24, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit));
      }
      if (extendLastTopLevelScope$21) {
        var this$4 = $n(x299);
        var $x_1 = ($ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I(this$4, 0) === 1);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        $m_Lcats_UnorderedFoldable$();
        var tc = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
        var this$8 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(extendedTopLevelScope$20, tc);
        var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$73) => {
          var _$73$1 = $as_Lfs2_internal_Scope(_$73);
          var fea = $n(_$73$1).close__Lcats_effect_kernel_Resource$ExitCase__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
          return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, F$31);
        }));
        var fa = $n(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance).traverseVoid__O__F1__Lcats_Applicative__O(this$8.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, f, F$31);
        var target$1 = $n(x299).openAncestor__O();
        var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$31);
        var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ancestor) => {
          var ancestor$1 = $as_Lfs2_internal_Scope(ancestor);
          return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$31, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, ancestor$1, new $c_s_Some(x299), translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit));
        }));
        var fb = $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        var this$14 = $n(F$31);
        return this$14.productR__O__O__O(fa, fb);
      }
      var target$2 = $n(x299).close__Lcats_effect_kernel_Resource$ExitCase__O($n(close).exitCase__Lcats_effect_kernel_Resource$ExitCase());
      var this$18 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F$31);
      var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => {
        var r$1 = $as_s_util_Either(r);
        var target$3 = $n(x299).openAncestor__O();
        var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, F$31);
        var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ancestor$2) => {
          var ancestor$3 = $as_Lfs2_internal_Scope(ancestor$2);
          var res = $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal($thiz, close, r$1, ancestor$3);
          return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$31, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, ancestor$3, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, res));
        }));
        return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }));
      return $n(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
    }
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var this$19 = $n($n(close).interruption__s_Option());
      var result = $as_Lfs2_Pull$Terminal((this$19.isEmpty__Z() ? $m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit : this$19.get__O()));
      return $thiz.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$31, extendLastTopLevelScope$21, contP$23, TheBuildR$lzy1$23, scope$24, extendedTopLevelScope$20, translation$tailLocal1$22, runner$tailLocal1$20, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close, view, result));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
}
/** @constructor */
function $c_Lfs2_Pull$() {
  this.Lfs2_Pull$__f_fs2$Pull$$$unit = null;
  this.Lfs2_Pull$__f_outUnit = null;
  this.Lfs2_Pull$__f_done = null;
  $n_Lfs2_Pull$ = this;
  this.Lfs2_Pull$__f_fs2$Pull$$$unit = new $c_Lfs2_Pull$Succeeded((void 0));
  var values = $m_Lfs2_Chunk$().Lfs2_Chunk$__f_unit;
  this.Lfs2_Pull$__f_outUnit = new $c_Lfs2_Pull$Output(values);
  this.Lfs2_Pull$__f_done = this.Lfs2_Pull$__f_fs2$Pull$$$unit;
}
$c_Lfs2_Pull$.prototype = new $h_O();
$c_Lfs2_Pull$.prototype.constructor = $c_Lfs2_Pull$;
/** @constructor */
function $h_Lfs2_Pull$() {
}
$h_Lfs2_Pull$.prototype = $c_Lfs2_Pull$.prototype;
$c_Lfs2_Pull$.prototype.output1__O__Lfs2_Pull = (function(o) {
  $m_Lfs2_Chunk$();
  var values = new $c_Lfs2_Chunk$Singleton(o);
  return new $c_Lfs2_Pull$Output(values);
});
$c_Lfs2_Pull$.prototype.output__Lfs2_Chunk__Lfs2_Pull = (function(os) {
  return ($n(os).isEmpty__Z() ? $m_Lfs2_Pull$().Lfs2_Pull$__f_done : new $c_Lfs2_Pull$Output(os));
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull = (function(fmoc, view) {
  var x = $m_Lfs2_Pull$IdContP$();
  if ((x === view)) {
    return fmoc;
  } else if ((view instanceof $c_Lfs2_Pull$Bind)) {
    var bv = $as_Lfs2_Pull$Bind(view);
    if ((fmoc instanceof $c_Lfs2_Pull$Terminal)) {
      var r = $as_Lfs2_Pull$Terminal(fmoc);
      try {
        var this$1 = $n(bv);
        return this$1.cont__Lfs2_Pull$Terminal__Lfs2_Pull(r);
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        var x95 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!$n(x95).isEmpty__Z())) {
          var x96 = $as_jl_Throwable($n(x95).get__O());
          return new $c_Lfs2_Pull$Fail(x96);
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    } else {
      return new $c_Lfs2_Pull$DelegateBind(fmoc, $n(bv).delegate__Lfs2_Pull$Bind());
    }
  } else {
    return new $c_Lfs2_Pull$$anon$7(fmoc, view);
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$bindBindAux__Lfs2_Pull__Lfs2_Pull$Bind__Lfs2_Pull = (function(py, del) {
  var del$tailLocal1 = del;
  var py$tailLocal1 = py;
  while (true) {
    var x108 = py$tailLocal1;
    if ((x108 instanceof $c_Lfs2_Pull$Terminal)) {
      var ty = $as_Lfs2_Pull$Terminal(x108);
      var x106 = del$tailLocal1;
      if ((x106 instanceof $c_Lfs2_Pull$BindBind)) {
        var cici = $as_Lfs2_Pull$BindBind(x106);
        var py$tailLocal1$tmp1 = $n($n(cici).Lfs2_Pull$BindBind__f_bb).cont__Lfs2_Pull$Terminal__Lfs2_Pull(ty);
        var del$tailLocal1$tmp1 = $n(cici).Lfs2_Pull$BindBind__f_del;
        py$tailLocal1 = py$tailLocal1$tmp1;
        del$tailLocal1 = del$tailLocal1$tmp1;
        continue;
      }
      return $n(del$tailLocal1).cont__Lfs2_Pull$Terminal__Lfs2_Pull(ty);
    }
    return new $c_Lfs2_Pull$DelegateBind(x108, del$tailLocal1);
  }
});
$c_Lfs2_Pull$.prototype.compile__Lfs2_Pull__Lfs2_internal_Scope__Z__O__F2__Lcats_MonadError__O = (function(stream, initScope, extendLastTopLevelScope, init, foldChunk, F) {
  var TheBuildR$lzy1 = new $c_sr_LazyRef();
  var contP = new $c_sr_ObjectRef(null);
  var initFk = new $c_Lcats_arrow_FunctionK$$anon$4();
  return this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F, extendLastTopLevelScope, contP, TheBuildR$lzy1, initScope, $m_s_None$(), initFk, new $c_Lfs2_Pull$OuterRun$1(F, foldChunk, initFk, extendLastTopLevelScope, contP, TheBuildR$lzy1, init), stream);
});
$c_Lfs2_Pull$.prototype.translate__Lfs2_Pull__Lcats_arrow_FunctionK__Lfs2_Pull = (function(stream, fK) {
  var fK$tailLocal1 = fK;
  var stream$tailLocal2 = stream;
  while (true) {
    var x331 = stream$tailLocal2;
    if ((x331 instanceof $c_Lfs2_Pull$Translate)) {
      var t = $as_Lfs2_Pull$Translate(x331);
      var stream$tailLocal2$tmp1 = $n(t).Lfs2_Pull$Translate__f_stream;
      var this$1 = $n($n(t).Lfs2_Pull$Translate__f_fk);
      var f = fK$tailLocal1;
      var this$2 = $n(f);
      var fK$tailLocal1$tmp1 = new $c_Lcats_arrow_FunctionK$$anon$1(this$1, this$2);
      stream$tailLocal2 = stream$tailLocal2$tmp1;
      fK$tailLocal1 = fK$tailLocal1$tmp1;
      continue;
    }
    if ((x331 instanceof $c_Lfs2_Pull$Output)) {
      var o = $as_Lfs2_Pull$Output(x331);
      return o;
    }
    if ((x331 instanceof $c_Lfs2_Pull$Terminal)) {
      var r = $as_Lfs2_Pull$Terminal(x331);
      return r;
    }
    var stream$1 = stream$tailLocal2;
    var fk = fK$tailLocal1;
    return new $c_Lfs2_Pull$Translate(stream$1, fk);
  }
});
$c_Lfs2_Pull$.prototype.mapOutput__Lfs2_Stream__F1__Lfs2_Pull = (function(s, f) {
  var s$1 = this.mapOutputNoScope__Lfs2_Stream__F1__Lfs2_Pull(s, f);
  return new $c_Lfs2_Pull$InScope(s$1, true);
});
$c_Lfs2_Pull$.prototype.mapOutputNoScope__Lfs2_Stream__F1__Lfs2_Pull = (function(s, f) {
  var ev$16 = ($m_Lfs2_Stream$(), new $c_Lfs2_Stream$ToPull(s)).Lfs2_Stream$ToPull__f_self;
  var self = $n(ev$16).Lfs2_Stream__f_underlying;
  return $m_Lfs2_Pull$StreamPullOps$().unconsFlatMap$extension__Lfs2_Pull__F1__Lfs2_Pull(self, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((hd) => {
    var hd$1 = $as_Lfs2_Chunk(hd);
    return $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull($n(hd$1).map__F1__Lfs2_Chunk(f));
  })));
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull = (function(p, f) {
  if ((p instanceof $c_Lfs2_Pull$Terminal)) {
    var r = $as_Lfs2_Pull$Terminal(p);
    try {
      return $as_Lfs2_Pull($n(f).apply__O__O(r));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x336 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(x336).isEmpty__Z())) {
        var x337 = $as_jl_Throwable($n(x336).get__O());
        return new $c_Lfs2_Pull$Fail(x337);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  } else {
    return new $c_Lfs2_Pull$$anon$9(p, f);
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL = (function(contP$2, free) {
  var free$tailLocal1 = free;
  while (true) {
    var x166 = free$tailLocal1;
    if ((x166 instanceof $c_Lfs2_Pull$Action)) {
      var e = $as_Lfs2_Pull$Action(x166);
      $n(contP$2).sr_ObjectRef__f_elem = $m_Lfs2_Pull$IdContP$();
      return e;
    }
    if ((x166 instanceof $c_Lfs2_Pull$Bind)) {
      var b = $as_Lfs2_Pull$Bind(x166);
      var x162 = $n(b).Lfs2_Pull$Bind__f_step;
      if ((x162 instanceof $c_Lfs2_Pull$Bind)) {
        var c = $as_Lfs2_Pull$Bind(x162);
        free$tailLocal1 = new $c_Lfs2_Pull$BindBind($n(c).Lfs2_Pull$Bind__f_step, $n(c).delegate__Lfs2_Pull$Bind(), $n(b).delegate__Lfs2_Pull$Bind());
        continue;
      }
      if ((x162 instanceof $c_Lfs2_Pull$Action)) {
        var e$2 = $as_Lfs2_Pull$Action(x162);
        $n(contP$2).sr_ObjectRef__f_elem = $n(b).delegate__Lfs2_Pull$Bind();
        return e$2;
      }
      if ((x162 instanceof $c_Lfs2_Pull$Terminal)) {
        var r = $as_Lfs2_Pull$Terminal(x162);
        free$tailLocal1 = $n(b).cont__Lfs2_Pull$Terminal__Lfs2_Pull(r);
        continue;
      }
      throw new $c_s_MatchError(x162);
    }
    if ((x166 instanceof $c_Lfs2_Pull$Terminal)) {
      var r$2 = $as_Lfs2_Pull$Terminal(x166);
      return r$2;
    }
    throw new $c_s_MatchError(x166);
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$interruptBoundary$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$Interrupted__Lfs2_Pull = (function(contP$38, stream, interruption) {
  var x170 = this.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(contP$38, stream);
  if ((x170 instanceof $c_Lfs2_Pull$CloseScope)) {
    var cs = $as_Lfs2_Pull$CloseScope(x170);
    var scopeId = $n(cs).scopeId__Lcats_effect_kernel_Unique$Token();
    var cl = new $c_Lfs2_Pull$CanceledScope(scopeId, interruption);
    return this.fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull(cl, $as_Lfs2_Pull$ContP($n(contP$38).sr_ObjectRef__f_elem));
  }
  if ((x170 instanceof $c_Lfs2_Pull$Action)) {
    var this$2 = $n($as_Lfs2_Pull$ContP($n(contP$38).sr_ObjectRef__f_elem));
    return this$2.cont__Lfs2_Pull$Terminal__Lfs2_Pull(interruption);
  }
  if ((x170 instanceof $c_Lfs2_Pull$Interrupted)) {
    var interrupted = $as_Lfs2_Pull$Interrupted(x170);
    return interrupted;
  }
  if ((x170 instanceof $c_Lfs2_Pull$Succeeded)) {
    return interruption;
  }
  if ((x170 instanceof $c_Lfs2_Pull$Fail)) {
    var failed = $as_Lfs2_Pull$Fail(x170);
    var this$3 = $n($n($n(interruption).Lfs2_Pull$Interrupted__f_deferredError).toList__sci_List());
    var elem = $n(failed).Lfs2_Pull$Fail__f_error;
    var errs = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$3, elem));
    var this$4 = $n($m_Lfs2_CompositeFailure$().fromList__sci_List__s_Option(errs));
    var error = $as_jl_Throwable((this$4.isEmpty__Z() ? $n(failed).Lfs2_Pull$Fail__f_error : this$4.get__O()));
    return new $c_Lfs2_Pull$Fail(error);
  }
  throw new $c_s_MatchError(x170);
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O = (function(F$11, extendedTopLevelScope$1, translation$tailLocal1$1, runner$tailLocal1$1, extendLastTopLevelScope$2, contP$4, TheBuildR$lzy1$4, scope, view, next) {
  var target = $n(scope).isInterrupted__O();
  var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$11);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return $n(next).apply__O();
    }
    if ((x$1$1 instanceof $c_s_Some)) {
      var outcome = $as_Lcats_effect_kernel_Outcome($n($as_s_Some(x$1$1)).s_Some__f_value);
      matchResult74: {
        var $x_1;
        if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
          var x$1$2 = $as_Lcats_effect_kernel_Outcome$Errored(outcome);
          var this$4 = $n(x$1$2);
          var x183 = $as_jl_Throwable(this$4.Lcats_effect_kernel_Outcome$Errored__f_e);
          var $x_1 = new $c_Lfs2_Pull$Fail(x183);
          break matchResult74;
        }
        if (((outcome instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome), true))) {
          var context = $n(scope).Lfs2_internal_Scope__f_id;
          var deferredError = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(context, deferredError);
          break matchResult74;
        }
        if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x$1$3 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome);
          var this$8 = $n(x$1$3);
          var x179 = $as_Lcats_effect_kernel_Unique$Token(this$8.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
          var deferredError$1 = $m_s_None$();
          var $x_1 = new $c_Lfs2_Pull$Interrupted(x179, deferredError$1);
          break matchResult74;
        }
        throw new $c_s_MatchError(outcome);
      }
      var result = $as_Lfs2_Pull$Terminal($x_1);
      return this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$11, extendLastTopLevelScope$2, contP$4, TheBuildR$lzy1$4, scope, extendedTopLevelScope$1, translation$tailLocal1$1, runner$tailLocal1$1, $as_Lfs2_Pull($n(view).apply__O__O(result)));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O = (function(scope$4, extendedTopLevelScope$3, translation$tailLocal1$3, runner$tailLocal1$3, F$13, extendLastTopLevelScope$4, contP$6, TheBuildR$lzy1$6, err, view) {
  return this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$13, extendLastTopLevelScope$4, contP$6, TheBuildR$lzy1$6, scope$4, extendedTopLevelScope$3, translation$tailLocal1$3, runner$tailLocal1$3, $as_Lfs2_Pull($n(view).apply__O__O(new $c_Lfs2_Pull$Fail(err))));
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$endScope$1__Lcats_effect_kernel_Unique$Token__Lfs2_Pull$Terminal__Lfs2_Pull = (function(scopeId, result) {
  matchResult84: {
    var $x_1;
    if ((result instanceof $c_Lfs2_Pull$Succeeded)) {
      var x$1 = $as_Lfs2_Pull$Succeeded(result);
      var this$2 = $n(x$1);
      $as_jl_Void(this$2.Lfs2_Pull$Succeeded__f_r);
      var $x_1 = new $c_Lfs2_Pull$SucceedScope(scopeId);
      break matchResult84;
    }
    if ((result instanceof $c_Lfs2_Pull$Interrupted)) {
      var x$1$1 = $as_Lfs2_Pull$Interrupted(result);
      $n(x$1$1);
      $n(x$1$1);
      var inter = $as_Lfs2_Pull$Interrupted(result);
      var $x_1 = new $c_Lfs2_Pull$CanceledScope(scopeId, inter);
      break matchResult84;
    }
    if ((result instanceof $c_Lfs2_Pull$Fail)) {
      var x$1$2 = $as_Lfs2_Pull$Fail(result);
      var this$9 = $n(x$1$2);
      var x261 = this$9.Lfs2_Pull$Fail__f_error;
      var $x_1 = new $c_Lfs2_Pull$FailedScope(scopeId, x261);
      break matchResult84;
    }
    throw new $c_s_MatchError(result);
  }
  return $as_Lfs2_Pull($x_1);
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O = (function(F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation, runner, stream) {
  var stream$tailLocal1 = stream;
  var runner$tailLocal1 = runner;
  var translation$tailLocal1 = translation;
  while (true) {
    var x300 = this.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(contP$3, stream$tailLocal1);
    if ((x300 instanceof $c_Lfs2_Pull$Translate)) {
      var tst = $as_Lfs2_Pull$Translate(x300);
      var translateRunner = new $c_Lfs2_Pull$TranslateRunner$1(extendedTopLevelScope, translation$tailLocal1, runner$tailLocal1, scope, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, $n(tst).Lfs2_Pull$Translate__f_fk, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
      var this$1 = $n(translation$tailLocal1);
      var f = $n(tst).Lfs2_Pull$Translate__f_fk;
      var composed = new $c_Lcats_arrow_FunctionK$$anon$1(f, this$1);
      var stream$tailLocal1$tmp1 = $n(tst).Lfs2_Pull$Translate__f_stream;
      translation$tailLocal1 = composed;
      runner$tailLocal1 = translateRunner;
      stream$tailLocal1 = stream$tailLocal1$tmp1;
      continue;
    }
    if ((x300 instanceof $c_Lfs2_Pull$Output)) {
      var output = $as_Lfs2_Pull$Output(x300);
      var view = $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem);
      var $x_2 = translation$tailLocal1;
      var $x_1 = runner$tailLocal1;
      var runner$tailLocal1$2$1 = runner$tailLocal1;
      return this.fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(F$10, extendedTopLevelScope, $x_2, $x_1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, scope, view, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((runner$tailLocal1$2, output, scope, view) => (() => {
        var $x_4 = $n(runner$tailLocal1$2);
        var $x_3 = $n(output).Lfs2_Pull$Output__f_values;
        var this$2 = $n(view);
        var x0 = $m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit;
        return $x_4.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O($x_3, scope, this$2.cont__Lfs2_Pull$Terminal__Lfs2_Pull(x0));
      }))(runner$tailLocal1$2$1, output, scope, view)));
    }
    if ((x300 instanceof $c_Lfs2_Pull$FlatMapOutput)) {
      var fmout = $as_Lfs2_Pull$FlatMapOutput(x300);
      var fmrunr = new $c_Lfs2_Pull$FlatMapR$1(extendedTopLevelScope, translation$tailLocal1, runner$tailLocal1, scope, contP$3, F$10, extendLastTopLevelScope$1, TheBuildR$lzy1$3, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem), $n(fmout).Lfs2_Pull$FlatMapOutput__f_fun);
      var fa = $n(F$10).unit__O();
      var $x_5 = $m_Lcats_syntax_FlatMapOps$();
      var translation$tailLocal1$2$1 = translation$tailLocal1;
      return $x_5.$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((scope, extendedTopLevelScope, translation$tailLocal1$2, fmrunr, fmout, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3) => (() => this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation$tailLocal1$2, fmrunr, $n(fmout).Lfs2_Pull$FlatMapOutput__f_stream)))(scope, extendedTopLevelScope, translation$tailLocal1$2$1, fmrunr, fmout, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3)), F$10);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Uncons)) {
      var u = $as_Lfs2_Pull$Uncons(x300);
      var v = $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem);
      var runr = $p_Lfs2_Pull$__TheBuildR$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$(this, TheBuildR$lzy1$3, F$10);
      var fa$1 = $n(F$10).unit__O();
      var $x_6 = $m_Lcats_syntax_FlatMapOps$();
      var translation$tailLocal1$3$1 = translation$tailLocal1;
      var runner$tailLocal1$3$1 = runner$tailLocal1;
      return $x_6.$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((scope, extendedTopLevelScope, translation$tailLocal1$3, runr, u, F$10, v, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, runner$tailLocal1$3) => (() => {
        var fa$2 = this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation$tailLocal1$3, runr, $n(u).Lfs2_Pull$Uncons__f_stream);
        var target = $n(F$10).attempt__O__O(fa$2);
        var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$10);
        var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$74) => {
          var _$74$1 = $as_s_util_Either(_$74);
          var this$9 = $n(_$74$1);
          if ((this$9 instanceof $c_s_util_Right)) {
            var x2 = $as_s_util_Right(this$9);
            var b = $n(x2).s_util_Right__f_value;
            var _$76 = $as_F1(b);
            return $n(_$76).apply__O__O(new $c_Lfs2_Pull$UnconsRunR$1(extendedTopLevelScope, translation$tailLocal1$3, runner$tailLocal1$3, scope, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, this, v));
          } else if ((this$9 instanceof $c_s_util_Left)) {
            var x3 = $as_s_util_Left(this$9);
            var a = $n(x3).s_util_Left__f_value;
            var _$75 = $as_jl_Throwable(a);
            return this.fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(scope, extendedTopLevelScope, translation$tailLocal1$3, runner$tailLocal1$3, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, _$75, v);
          } else {
            throw new $c_s_MatchError(this$9);
          }
        }));
        return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
      }))(scope, extendedTopLevelScope, translation$tailLocal1$3$1, runr, u, F$10, v, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, runner$tailLocal1$3$1)), F$10);
    }
    if (false) {
      var s = $as_Lfs2_Pull$StepLeg(x300);
      var v$3 = $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem);
      var runr$3 = $p_Lfs2_Pull$__TheBuildR$1__sr_LazyRef__Lcats_MonadError__Lfs2_Pull$TheBuildR$2$(this, TheBuildR$lzy1$3, F$10);
      var target$1 = $n(scope).shiftScope__Lcats_effect_kernel_Unique$Token__F0__O($n(s).scope__Lcats_effect_kernel_Unique$Token(), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((s) => (() => $n(s).toString__T()))(s)));
      var this$14 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$10);
      var translation$tailLocal1$4$1 = translation$tailLocal1;
      var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((extendedTopLevelScope, translation$tailLocal1$4, runr$3, s, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3) => ((_$77) => {
        var _$77$1 = $as_Lfs2_internal_Scope(_$77);
        var fa$3 = this.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, _$77$1, extendedTopLevelScope, translation$tailLocal1$4, runr$3, $n(s).stream__Lfs2_Pull());
        return $n(F$10).attempt__O__O(fa$3);
      }))(extendedTopLevelScope, translation$tailLocal1$4$1, runr$3, s, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3));
      var target$2 = $n(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$14.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F$10);
      var translation$tailLocal1$5$1 = translation$tailLocal1;
      var runner$tailLocal1$4$1 = runner$tailLocal1;
      var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((v$3, scope, extendedTopLevelScope, translation$tailLocal1$5, runner$tailLocal1$4, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3) => ((_$78) => {
        var _$78$1 = $as_s_util_Either(_$78);
        var this$16 = $n(_$78$1);
        if ((this$16 instanceof $c_s_util_Right)) {
          var x2$1 = $as_s_util_Right(this$16);
          var b$1 = $n(x2$1).s_util_Right__f_value;
          var _$80 = $as_F1(b$1);
          return $n(_$80).apply__O__O(new $c_Lfs2_Pull$StepLegRunR$1(scope, extendedTopLevelScope, translation$tailLocal1$5, runner$tailLocal1$4, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, this, v$3));
        } else if ((this$16 instanceof $c_s_util_Left)) {
          var x3$1 = $as_s_util_Left(this$16);
          var a$1 = $n(x3$1).s_util_Left__f_value;
          var _$79 = $as_jl_Throwable(a$1);
          return this.fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(scope, extendedTopLevelScope, translation$tailLocal1$5, runner$tailLocal1$4, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, _$79, v$3);
        } else {
          throw new $c_s_MatchError(this$16);
        }
      }))(v$3, scope, extendedTopLevelScope, translation$tailLocal1$5$1, runner$tailLocal1$4$1, F$10, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3));
      return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
    }
    if (false) {
      var this$19 = $n($as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
      var x0$1 = new $c_Lfs2_Pull$Succeeded(scope);
      stream$tailLocal1 = this$19.cont__Lfs2_Pull$Terminal__Lfs2_Pull(x0$1);
      continue;
    }
    if ((x300 instanceof $c_Lfs2_Pull$Eval)) {
      var eval$1 = $as_Lfs2_Pull$Eval(x300);
      return $p_Lfs2_Pull$__goEval$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Eval__F1__O(this, scope, translation$tailLocal1, F$10, extendedTopLevelScope, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, eval$1, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if (false) {
      var acquire = $as_Lfs2_Pull$Acquire(x300);
      return $p_Lfs2_Pull$__goAcquire$1__Lfs2_internal_Scope__Lcats_arrow_FunctionK__Lcats_MonadError__s_Option__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$Acquire__F1__O(this, scope, translation$tailLocal1, F$10, extendedTopLevelScope, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, acquire, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if ((x300 instanceof $c_Lfs2_Pull$InScope)) {
      var inScope = $as_Lfs2_Pull$InScope(x300);
      return $p_Lfs2_Pull$__goInScope$1__Lfs2_internal_Scope__s_Option__Lcats_MonadError__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull__Z__F1__O(this, scope, extendedTopLevelScope, F$10, translation$tailLocal1, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, $n(inScope).Lfs2_Pull$InScope__f_stream, $n(inScope).Lfs2_Pull$InScope__f_useInterruption, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if (false) {
      var int = $as_Lfs2_Pull$InterruptWhen(x300);
      return $p_Lfs2_Pull$__goInterruptWhen$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__O__F1__O(this, scope, F$10, extendedTopLevelScope, translation$tailLocal1, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, $n(translation$tailLocal1).apply__O__O($n(int).haltOnSignal__O()), $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if ((x300 instanceof $c_Lfs2_Pull$CloseScope)) {
      var close = $as_Lfs2_Pull$CloseScope(x300);
      return $p_Lfs2_Pull$__goCloseScope$1__Lfs2_internal_Scope__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_Pull$CloseScope__F1__O(this, scope, F$10, extendedTopLevelScope, translation$tailLocal1, runner$tailLocal1, extendLastTopLevelScope$1, contP$3, TheBuildR$lzy1$3, close, $as_Lfs2_Pull$ContP($n(contP$3).sr_ObjectRef__f_elem));
    }
    if ((x300 instanceof $c_Lfs2_Pull$Succeeded)) {
      return $n(runner$tailLocal1).done__Lfs2_internal_Scope__O(scope);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Fail)) {
      var failed = $as_Lfs2_Pull$Fail(x300);
      return $n(runner$tailLocal1).fail__jl_Throwable__O($n(failed).Lfs2_Pull$Fail__f_error);
    }
    if ((x300 instanceof $c_Lfs2_Pull$Interrupted)) {
      var int$2 = $as_Lfs2_Pull$Interrupted(x300);
      return $n(runner$tailLocal1).interrupted__Lfs2_Pull$Interrupted__O(int$2);
    }
    throw new $c_s_MatchError(x300);
  }
});
var $d_Lfs2_Pull$ = new $TypeData().initClass($c_Lfs2_Pull$, "fs2.Pull$", ({
  Lfs2_Pull$: 1,
  Lfs2_PullLowPriority: 1
}));
var $n_Lfs2_Pull$;
function $m_Lfs2_Pull$() {
  if ((!$n_Lfs2_Pull$)) {
    $n_Lfs2_Pull$ = new $c_Lfs2_Pull$();
  }
  return $n_Lfs2_Pull$;
}
function $is_Lfs2_Pull$ContP(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_Pull$ContP)));
}
function $as_Lfs2_Pull$ContP(obj) {
  return (($is_Lfs2_Pull$ContP(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$ContP"));
}
function $isArrayOf_Lfs2_Pull$ContP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$ContP)));
}
function $asArrayOf_Lfs2_Pull$ContP(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$ContP(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$ContP;", depth));
}
function $p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull($thiz, chunk, tail) {
  if ((($n(chunk).size__I() === 1) && (tail instanceof $c_Lfs2_Pull$Succeeded))) {
    try {
      return $as_Lfs2_Pull($n($thiz.Lfs2_Pull$FlatMapR$1__f_fun).apply__O__O($n(chunk).apply__I__O(0)));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x190 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(x190).isEmpty__Z())) {
        var x191 = $as_jl_Throwable($n(x190).get__O());
        return new $c_Lfs2_Pull$Fail(x191);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  } else {
    return $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk, tail, 0);
  }
}
function $p_Lfs2_Pull$FlatMapR$1__loop$1__Lfs2_Chunk__sr_IntRef__Lfs2_Pull($thiz, chunk$2, j$1) {
  while (true) {
    var x193 = $as_Lfs2_Pull($n($thiz.Lfs2_Pull$FlatMapR$1__f_fun).apply__O__O($n(chunk$2).apply__I__O($n(j$1).sr_IntRef__f_elem)));
    if ((x193 instanceof $c_Lfs2_Pull$Succeeded)) {
      var x$1 = $as_Lfs2_Pull$Succeeded(x193);
      var this$2 = $n(x$1);
      $as_jl_Void(this$2.Lfs2_Pull$Succeeded__f_r);
      if (($n(j$1).sr_IntRef__f_elem < (($n(chunk$2).size__I() - 1) | 0))) {
        $n(j$1).sr_IntRef__f_elem = ((1 + $n(j$1).sr_IntRef__f_elem) | 0);
        continue;
      }
    }
    return x193;
  }
}
function $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk$1, tail$4, idx) {
  if ((idx === $n(chunk$1).size__I())) {
    $m_Lfs2_Pull$();
    return $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(tail$4, $thiz.Lfs2_Pull$FlatMapR$1__f_fun);
  } else {
    try {
      var j = new $c_sr_IntRef(idx);
      var next = $p_Lfs2_Pull$FlatMapR$1__loop$1__Lfs2_Chunk__sr_IntRef__Lfs2_Pull($thiz, chunk$1, j);
      return $m_Lfs2_Pull$().fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull(next, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_Lfs2_Pull$Terminal(x$1);
        if ((x$1$1 instanceof $c_Lfs2_Pull$Succeeded)) {
          var x$1$2 = $as_Lfs2_Pull$Succeeded(x$1$1);
          var this$5 = $n(x$1$2);
          $as_jl_Void(this$5.Lfs2_Pull$Succeeded__f_r);
          return $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk$1, tail$4, ((1 + j.sr_IntRef__f_elem) | 0));
        }
        if ((x$1$1 instanceof $c_Lfs2_Pull$Fail)) {
          var x$1$3 = $as_Lfs2_Pull$Fail(x$1$1);
          var this$7 = $n(x$1$3);
          var x204 = this$7.Lfs2_Pull$Fail__f_error;
          return new $c_Lfs2_Pull$Fail(x204);
        }
        if ((x$1$1 instanceof $c_Lfs2_Pull$Interrupted)) {
          var x$1$4 = $as_Lfs2_Pull$Interrupted(x$1$1);
          $n(x$1$4);
          $n(x$1$4);
          var interruption = $as_Lfs2_Pull$Interrupted(x$1$1);
          $m_Lfs2_Pull$();
          var self = $m_Lfs2_Pull$().fs2$Pull$$$_$interruptBoundary$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$Interrupted__Lfs2_Pull($thiz.Lfs2_Pull$FlatMapR$1__f_contP$13, tail$4, interruption);
          return $m_Lfs2_Pull$StreamPullOps$().flatMapOutput$extension__Lfs2_Pull__F1__Lfs2_Pull(self, $thiz.Lfs2_Pull$FlatMapR$1__f_fun);
        }
        throw new $c_s_MatchError(x$1$1);
      })));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x209 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(x209).isEmpty__Z())) {
        var x210 = $as_jl_Throwable($n(x209).get__O());
        return new $c_Lfs2_Pull$Fail(x210);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
}
/** @constructor */
function $c_Lfs2_Pull$FlatMapR$1(extendedTopLevelScope$37, translation$tailLocal1$40, runner$tailLocal1$37, scope$39, contP$43, F$53, extendLastTopLevelScope$40, TheBuildR$lzy1$43, view, fun) {
  this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_scope$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_contP$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_F$20 = null;
  this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11 = false;
  this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_view = null;
  this.Lfs2_Pull$FlatMapR$1__f_fun = null;
  this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10 = extendedTopLevelScope$37;
  this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10 = translation$tailLocal1$40;
  this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10 = runner$tailLocal1$37;
  this.Lfs2_Pull$FlatMapR$1__f_scope$13 = scope$39;
  this.Lfs2_Pull$FlatMapR$1__f_contP$13 = contP$43;
  this.Lfs2_Pull$FlatMapR$1__f_F$20 = F$53;
  this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11 = extendLastTopLevelScope$40;
  this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13 = TheBuildR$lzy1$43;
  this.Lfs2_Pull$FlatMapR$1__f_view = view;
  this.Lfs2_Pull$FlatMapR$1__f_fun = fun;
}
$c_Lfs2_Pull$FlatMapR$1.prototype = new $h_O();
$c_Lfs2_Pull$FlatMapR$1.prototype.constructor = $c_Lfs2_Pull$FlatMapR$1;
/** @constructor */
function $h_Lfs2_Pull$FlatMapR$1() {
}
$h_Lfs2_Pull$FlatMapR$1.prototype = $c_Lfs2_Pull$FlatMapR$1.prototype;
$c_Lfs2_Pull$FlatMapR$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, scope, this.Lfs2_Pull$FlatMapR$1__f_view, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, scope, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, $as_Lfs2_Pull($n(this.Lfs2_Pull$FlatMapR$1__f_view).apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit))))));
});
$c_Lfs2_Pull$FlatMapR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  var next = $m_Lfs2_Pull$().fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull($p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull(this, head, tail), this.Lfs2_Pull$FlatMapR$1__f_view);
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, outScope, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, next);
});
$c_Lfs2_Pull$FlatMapR$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, this.Lfs2_Pull$FlatMapR$1__f_scope$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, $as_Lfs2_Pull($n(this.Lfs2_Pull$FlatMapR$1__f_view).apply__O__O(inter)));
});
$c_Lfs2_Pull$FlatMapR$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(this.Lfs2_Pull$FlatMapR$1__f_scope$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_F$20, this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, e, this.Lfs2_Pull$FlatMapR$1__f_view);
});
var $d_Lfs2_Pull$FlatMapR$1 = new $TypeData().initClass($c_Lfs2_Pull$FlatMapR$1, "fs2.Pull$FlatMapR$1", ({
  Lfs2_Pull$FlatMapR$1: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_Pull$OuterRun$1(F$54, foldChunk$2, initFk$2, extendLastTopLevelScope$41, contP$44, TheBuildR$lzy1$44, initB) {
  this.Lfs2_Pull$OuterRun$1__f_F$46 = null;
  this.Lfs2_Pull$OuterRun$1__f_foldChunk$1 = null;
  this.Lfs2_Pull$OuterRun$1__f_initFk$1 = null;
  this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35 = false;
  this.Lfs2_Pull$OuterRun$1__f_contP$37 = null;
  this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37 = null;
  this.Lfs2_Pull$OuterRun$1__f_accB = null;
  this.Lfs2_Pull$OuterRun$1__f_F$46 = F$54;
  this.Lfs2_Pull$OuterRun$1__f_foldChunk$1 = foldChunk$2;
  this.Lfs2_Pull$OuterRun$1__f_initFk$1 = initFk$2;
  this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35 = extendLastTopLevelScope$41;
  this.Lfs2_Pull$OuterRun$1__f_contP$37 = contP$44;
  this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37 = TheBuildR$lzy1$44;
  this.Lfs2_Pull$OuterRun$1__f_accB = initB;
}
$c_Lfs2_Pull$OuterRun$1.prototype = new $h_O();
$c_Lfs2_Pull$OuterRun$1.prototype.constructor = $c_Lfs2_Pull$OuterRun$1;
/** @constructor */
function $h_Lfs2_Pull$OuterRun$1() {
}
$h_Lfs2_Pull$OuterRun$1.prototype = $c_Lfs2_Pull$OuterRun$1.prototype;
$c_Lfs2_Pull$OuterRun$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).pure__O__O(this.Lfs2_Pull$OuterRun$1__f_accB);
});
$c_Lfs2_Pull$OuterRun$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).raiseError__O__O(e);
});
$c_Lfs2_Pull$OuterRun$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  var this$1 = $n($n(inter).Lfs2_Pull$Interrupted__f_deferredError);
  if (this$1.isEmpty__Z()) {
    return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).pure__O__O(this.Lfs2_Pull$OuterRun$1__f_accB);
  } else {
    var x0 = this$1.get__O();
    var e = $as_jl_Throwable(x0);
    return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).raiseError__O__O(e);
  }
});
$c_Lfs2_Pull$OuterRun$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  try {
    this.Lfs2_Pull$OuterRun$1__f_accB = $n(this.Lfs2_Pull$OuterRun$1__f_foldChunk$1).apply__O__O__O(this.Lfs2_Pull$OuterRun$1__f_accB, head);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$OuterRun$1__f_F$46, this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35, this.Lfs2_Pull$OuterRun$1__f_contP$37, this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37, scope, $m_s_None$(), this.Lfs2_Pull$OuterRun$1__f_initFk$1, this, tail);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x328 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(x328).isEmpty__Z())) {
      var x329 = $as_jl_Throwable($n(x328).get__O());
      var x315 = $m_Lfs2_Pull$().fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(this.Lfs2_Pull$OuterRun$1__f_contP$37, tail);
      if ((x315 instanceof $c_Lfs2_Pull$Action)) {
        var $x_7 = $m_Lfs2_Pull$();
        var $x_6 = this.Lfs2_Pull$OuterRun$1__f_F$46;
        var $x_5 = this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35;
        var $x_4 = this.Lfs2_Pull$OuterRun$1__f_contP$37;
        var $x_3 = this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37;
        var $x_2 = $m_s_None$();
        var $x_1 = this.Lfs2_Pull$OuterRun$1__f_initFk$1;
        $m_Lfs2_Pull$();
        var contP$1 = this.Lfs2_Pull$OuterRun$1__f_contP$37;
        var this$3 = $n($as_Lfs2_Pull$ContP($n(contP$1).sr_ObjectRef__f_elem));
        var x0 = new $c_Lfs2_Pull$Fail(x329);
        return $x_7.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O($x_6, $x_5, $x_4, $x_3, scope, $x_2, $x_1, this, this$3.cont__Lfs2_Pull$Terminal__Lfs2_Pull(x0));
      }
      if ((x315 instanceof $c_Lfs2_Pull$Succeeded)) {
        var x$1 = $as_Lfs2_Pull$Succeeded(x315);
        $n(x$1);
        return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).raiseError__O__O(x329);
      }
      if ((x315 instanceof $c_Lfs2_Pull$Fail)) {
        var x$1$1 = $as_Lfs2_Pull$Fail(x315);
        var this$7 = $n(x$1$1);
        var x322 = this$7.Lfs2_Pull$Fail__f_error;
        return $n(this.Lfs2_Pull$OuterRun$1__f_F$46).raiseError__O__O($m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x322, x329, $m_sci_Nil$()));
      }
      if ((x315 instanceof $c_Lfs2_Pull$Interrupted)) {
        var x$1$2 = $as_Lfs2_Pull$Interrupted(x315);
        $n(x$1$2);
        var this$12 = $n(x$1$2);
        var x319 = this$12.Lfs2_Pull$Interrupted__f_deferredError;
        var $x_9 = $n(this.Lfs2_Pull$OuterRun$1__f_F$46);
        var this$13 = $n(x319);
        if (this$13.isEmpty__Z()) {
          var $x_8 = x329;
        } else {
          var x0$1 = this$13.get__O();
          var t = $as_jl_Throwable(x0$1);
          var $x_8 = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x329, t, $m_sci_Nil$());
        }
        return $x_9.raiseError__O__O($x_8);
      }
      throw new $c_s_MatchError(x315);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
var $d_Lfs2_Pull$OuterRun$1 = new $TypeData().initClass($c_Lfs2_Pull$OuterRun$1, "fs2.Pull$OuterRun$1", ({
  Lfs2_Pull$OuterRun$1: 1,
  Lfs2_Pull$Run$1: 1
}));
function $ct_Lfs2_Pull$StepRunR$1__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__F1__($thiz, extendedTopLevelScope$34, translation$tailLocal1$37, runner$tailLocal1$34, scope$36, F$50, extendLastTopLevelScope$37, contP$40, TheBuildR$lzy1$40, view) {
  $thiz.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = extendedTopLevelScope$34;
  $thiz.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = translation$tailLocal1$37;
  $thiz.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = runner$tailLocal1$34;
  $thiz.Lfs2_Pull$StepRunR$1__f_scope$10 = scope$36;
  $thiz.Lfs2_Pull$StepRunR$1__f_F$17 = F$50;
  $thiz.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = extendLastTopLevelScope$37;
  $thiz.Lfs2_Pull$StepRunR$1__f_contP$10 = contP$40;
  $thiz.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = TheBuildR$lzy1$40;
  $thiz.Lfs2_Pull$StepRunR$1__f_view = view;
  return $thiz;
}
/** @constructor */
function $c_Lfs2_Pull$StepRunR$1() {
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_F$17 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
}
$c_Lfs2_Pull$StepRunR$1.prototype = new $h_O();
$c_Lfs2_Pull$StepRunR$1.prototype.constructor = $c_Lfs2_Pull$StepRunR$1;
/** @constructor */
function $h_Lfs2_Pull$StepRunR$1() {
}
$h_Lfs2_Pull$StepRunR$1.prototype = $c_Lfs2_Pull$StepRunR$1.prototype;
$c_Lfs2_Pull$StepRunR$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$StepRunR$1__f_F$17, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, scope, this.Lfs2_Pull$StepRunR$1__f_view, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var $x_9 = $m_Lfs2_Pull$();
    var $x_8 = this.Lfs2_Pull$StepRunR$1__f_F$17;
    var $x_7 = this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8;
    var $x_6 = this.Lfs2_Pull$StepRunR$1__f_contP$10;
    var $x_5 = this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10;
    var $x_4 = this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7;
    var $x_3 = this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7;
    var $x_2 = this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7;
    var $x_1 = this.Lfs2_Pull$StepRunR$1__f_view;
    var r = $m_s_None$();
    return $x_9.fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O($x_8, $x_7, $x_6, $x_5, scope, $x_4, $x_3, $x_2, $as_Lfs2_Pull($n($x_1).apply__O__O(new $c_Lfs2_Pull$Succeeded(r))));
  })));
});
$c_Lfs2_Pull$StepRunR$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$StepRunR$1__f_F$17, this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, this.Lfs2_Pull$StepRunR$1__f_scope$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, $as_Lfs2_Pull($n(this.Lfs2_Pull$StepRunR$1__f_view).apply__O__O(inter)));
});
$c_Lfs2_Pull$StepRunR$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(this.Lfs2_Pull$StepRunR$1__f_scope$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_F$17, this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, e, this.Lfs2_Pull$StepRunR$1__f_view);
});
/** @constructor */
function $c_Lfs2_Pull$TheBuildR$2$(F$47) {
  this.Lfs2_Pull$TheBuildR$2$__f_F$9 = null;
  this.Lfs2_Pull$TheBuildR$2$__f_F$9 = F$47;
}
$c_Lfs2_Pull$TheBuildR$2$.prototype = new $h_O();
$c_Lfs2_Pull$TheBuildR$2$.prototype.constructor = $c_Lfs2_Pull$TheBuildR$2$;
/** @constructor */
function $h_Lfs2_Pull$TheBuildR$2$() {
}
$h_Lfs2_Pull$TheBuildR$2$.prototype = $c_Lfs2_Pull$TheBuildR$2$.prototype;
$c_Lfs2_Pull$TheBuildR$2$.prototype.fail__jl_Throwable__O = (function(e) {
  return $n(this.Lfs2_Pull$TheBuildR$2$__f_F$9).raiseError__O__O(e);
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $n(this.Lfs2_Pull$TheBuildR$2$__f_F$9).pure__O__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$62) => {
    var _$62$1 = $as_Lfs2_Pull$Run$1(_$62);
    return $n(_$62$1).done__Lfs2_internal_Scope__O(scope);
  })));
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  return $n(this.Lfs2_Pull$TheBuildR$2$__f_F$9).pure__O__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$63) => {
    var _$63$1 = $as_Lfs2_Pull$Run$1(_$63);
    return $n(_$63$1).out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head, scope, tail);
  })));
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(i) {
  return $n(this.Lfs2_Pull$TheBuildR$2$__f_F$9).pure__O__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$64) => {
    var _$64$1 = $as_Lfs2_Pull$Run$1(_$64);
    return $n(_$64$1).interrupted__Lfs2_Pull$Interrupted__O(i);
  })));
});
function $as_Lfs2_Pull$TheBuildR$2$(obj) {
  return (((obj instanceof $c_Lfs2_Pull$TheBuildR$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$TheBuildR$2$"));
}
function $isArrayOf_Lfs2_Pull$TheBuildR$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$TheBuildR$2$)));
}
function $asArrayOf_Lfs2_Pull$TheBuildR$2$(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$TheBuildR$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$TheBuildR$2$;", depth));
}
var $d_Lfs2_Pull$TheBuildR$2$ = new $TypeData().initClass($c_Lfs2_Pull$TheBuildR$2$, "fs2.Pull$TheBuildR$2$", ({
  Lfs2_Pull$TheBuildR$2$: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_Pull$TranslateRunner$1(extendedTopLevelScope$33, translation$tailLocal1$36, runner$tailLocal1$33, scope$35, F$49, extendLastTopLevelScope$36, contP$39, TheBuildR$lzy1$39, fk, view) {
  this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_scope$8 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_F$16 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7 = false;
  this.Lfs2_Pull$TranslateRunner$1__f_contP$9 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_fk = null;
  this.Lfs2_Pull$TranslateRunner$1__f_view = null;
  this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6 = extendedTopLevelScope$33;
  this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6 = translation$tailLocal1$36;
  this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6 = runner$tailLocal1$33;
  this.Lfs2_Pull$TranslateRunner$1__f_scope$8 = scope$35;
  this.Lfs2_Pull$TranslateRunner$1__f_F$16 = F$49;
  this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7 = extendLastTopLevelScope$36;
  this.Lfs2_Pull$TranslateRunner$1__f_contP$9 = contP$39;
  this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9 = TheBuildR$lzy1$39;
  this.Lfs2_Pull$TranslateRunner$1__f_fk = fk;
  this.Lfs2_Pull$TranslateRunner$1__f_view = view;
}
$c_Lfs2_Pull$TranslateRunner$1.prototype = new $h_O();
$c_Lfs2_Pull$TranslateRunner$1.prototype.constructor = $c_Lfs2_Pull$TranslateRunner$1;
/** @constructor */
function $h_Lfs2_Pull$TranslateRunner$1() {
}
$h_Lfs2_Pull$TranslateRunner$1.prototype = $c_Lfs2_Pull$TranslateRunner$1.prototype;
$c_Lfs2_Pull$TranslateRunner$1.prototype.done__Lfs2_internal_Scope__O = (function(doneScope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$TranslateRunner$1__f_F$16, this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, doneScope, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, $as_Lfs2_Pull($n(this.Lfs2_Pull$TranslateRunner$1__f_view).apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit)));
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  var $x_1 = $m_Lfs2_Pull$();
  var fk = this.Lfs2_Pull$TranslateRunner$1__f_fk;
  var next = $x_1.fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull(new $c_Lfs2_Pull$Translate(tail, fk), this.Lfs2_Pull$TranslateRunner$1__f_view);
  return $n(this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6).out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head, scope, next);
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$TranslateRunner$1__f_F$16, this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, this.Lfs2_Pull$TranslateRunner$1__f_scope$8, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, $as_Lfs2_Pull($n(this.Lfs2_Pull$TranslateRunner$1__f_view).apply__O__O(inter)));
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(this.Lfs2_Pull$TranslateRunner$1__f_scope$8, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_F$16, this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, e, this.Lfs2_Pull$TranslateRunner$1__f_view);
});
var $d_Lfs2_Pull$TranslateRunner$1 = new $TypeData().initClass($c_Lfs2_Pull$TranslateRunner$1, "fs2.Pull$TranslateRunner$1", ({
  Lfs2_Pull$TranslateRunner$1: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_Pull$ViewRunner$1(runner$tailLocal1$4, extendedTopLevelScope$4, translation$tailLocal1$4, scope$5, F$14, extendLastTopLevelScope$5, contP$7, TheBuildR$lzy1$7, view) {
  this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_scope$6 = null;
  this.Lfs2_Pull$ViewRunner$1__f_F$15 = null;
  this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6 = false;
  this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_contP$8 = null;
  this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8 = null;
  this.Lfs2_Pull$ViewRunner$1__f_view = null;
  this.Lfs2_Pull$ViewRunner$1__f_prevRunner = null;
  this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5 = extendedTopLevelScope$4;
  this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5 = translation$tailLocal1$4;
  this.Lfs2_Pull$ViewRunner$1__f_scope$6 = scope$5;
  this.Lfs2_Pull$ViewRunner$1__f_F$15 = F$14;
  this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6 = extendLastTopLevelScope$5;
  this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5 = runner$tailLocal1$4;
  this.Lfs2_Pull$ViewRunner$1__f_contP$8 = contP$7;
  this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8 = TheBuildR$lzy1$7;
  this.Lfs2_Pull$ViewRunner$1__f_view = view;
  this.Lfs2_Pull$ViewRunner$1__f_prevRunner = runner$tailLocal1$4;
}
$c_Lfs2_Pull$ViewRunner$1.prototype = new $h_O();
$c_Lfs2_Pull$ViewRunner$1.prototype.constructor = $c_Lfs2_Pull$ViewRunner$1;
/** @constructor */
function $h_Lfs2_Pull$ViewRunner$1() {
}
$h_Lfs2_Pull$ViewRunner$1.prototype = $c_Lfs2_Pull$ViewRunner$1.prototype;
$c_Lfs2_Pull$ViewRunner$1.prototype.done__Lfs2_internal_Scope__O = (function(doneScope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$ViewRunner$1__f_F$15, this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, doneScope, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_prevRunner, $as_Lfs2_Pull($n(this.Lfs2_Pull$ViewRunner$1__f_view).apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit)));
});
$c_Lfs2_Pull$ViewRunner$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  return $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O(head, scope, tail, this);
});
$c_Lfs2_Pull$ViewRunner$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$ViewRunner$1__f_F$15, this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, this.Lfs2_Pull$ViewRunner$1__f_scope$6, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_prevRunner, $as_Lfs2_Pull($n(this.Lfs2_Pull$ViewRunner$1__f_view).apply__O__O(inter)));
});
$c_Lfs2_Pull$ViewRunner$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__jl_Throwable__F1__O(this.Lfs2_Pull$ViewRunner$1__f_scope$6, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_F$15, this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, e, this.Lfs2_Pull$ViewRunner$1__f_view);
});
function $as_Lfs2_Pull$ViewRunner$1(obj) {
  return (((obj instanceof $c_Lfs2_Pull$ViewRunner$1) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$ViewRunner$1"));
}
function $isArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$ViewRunner$1)));
}
function $asArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$ViewRunner$1;", depth));
}
var $d_Lfs2_Pull$ViewRunner$1 = new $TypeData().initClass($c_Lfs2_Pull$ViewRunner$1, "fs2.Pull$ViewRunner$1", ({
  Lfs2_Pull$ViewRunner$1: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_Stream$() {
  $n_Lfs2_Stream$ = this;
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
}
$c_Lfs2_Stream$.prototype = new $h_O();
$c_Lfs2_Stream$.prototype.constructor = $c_Lfs2_Stream$;
/** @constructor */
function $h_Lfs2_Stream$() {
}
$h_Lfs2_Stream$.prototype = $c_Lfs2_Stream$.prototype;
$c_Lfs2_Stream$.prototype.emit__O__Lfs2_Stream = (function(o) {
  $m_Lfs2_Pull$();
  var self = $m_Lfs2_Pull$().output1__O__Lfs2_Pull(o);
  return new $c_Lfs2_Stream(self);
});
$c_Lfs2_Stream$.prototype.eval__O__Lfs2_Stream = (function(fo) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var this$3 = new $c_Lfs2_Pull$Eval(fo);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((o) => $m_Lfs2_Pull$().output1__O__Lfs2_Pull(o)));
  var self = new $c_Lfs2_Pull$$anon$1(f, this$3);
  return new $c_Lfs2_Stream(self);
});
var $d_Lfs2_Stream$ = new $TypeData().initClass($c_Lfs2_Stream$, "fs2.Stream$", ({
  Lfs2_Stream$: 1,
  Lfs2_StreamLowPriority: 1
}));
var $n_Lfs2_Stream$;
function $m_Lfs2_Stream$() {
  if ((!$n_Lfs2_Stream$)) {
    $n_Lfs2_Stream$ = new $c_Lfs2_Stream$();
  }
  return $n_Lfs2_Stream$;
}
/** @constructor */
function $c_Lfs2_internal_ScopedResource$$anon$1(token$1, F$2, state$1) {
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3 = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4 = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3 = state$1;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4 = F$2;
  $m_Lcats_implicits$();
  var a = new $c_s_util_Right((void 0));
  var this$4 = $n(F$2);
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru = $n(this$4.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
}
$c_Lfs2_internal_ScopedResource$$anon$1.prototype = new $h_Lfs2_internal_ScopedResource();
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.constructor = $c_Lfs2_internal_ScopedResource$$anon$1;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$$anon$1() {
}
$h_Lfs2_internal_ScopedResource$$anon$1.prototype = $c_Lfs2_internal_ScopedResource$$anon$1.prototype;
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.release__Lcats_effect_kernel_Resource$ExitCase__O = (function(ec) {
  $m_Lcats_implicits$();
  var target = $n(this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => {
    var s$1 = $as_Lfs2_internal_ScopedResource$State(s);
    if (($n(s$1).Lfs2_internal_ScopedResource$State__f_leases !== 0)) {
      $n(s$1);
      var this$1 = $n(s$1);
      var finalizer = this$1.Lfs2_internal_ScopedResource$State__f_finalizer;
      var this$2 = $n(s$1);
      var leases = this$2.Lfs2_internal_ScopedResource$State__f_leases;
      var _1 = new $c_Lfs2_internal_ScopedResource$State(false, finalizer, leases);
      var _2 = $m_s_None$();
      return new $c_T2(_1, _2);
    } else {
      $n(s$1);
      var finalizer$1 = $m_s_None$();
      var this$5 = $n(s$1);
      var leases$1 = this$5.Lfs2_internal_ScopedResource$State__f_leases;
      var _1$1 = new $c_Lfs2_internal_ScopedResource$State(false, finalizer$1, leases$1);
      var _2$1 = $n(s$1).Lfs2_internal_ScopedResource$State__f_finalizer;
      return new $c_T2(_1$1, _2$1);
    }
  })));
  var tc = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
  var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((finalizer$2) => {
    var finalizer$3 = $as_s_Option(finalizer$2);
    var this$10 = $n(finalizer$3);
    if (this$10.isEmpty__Z()) {
      var this$11 = $m_s_None$();
    } else {
      var x0 = this$10.get__O();
      var _$4 = $as_F1(x0);
      var this$11 = new $c_s_Some($n(_$4).apply__O__O(ec));
    }
    return (this$11.isEmpty__Z() ? this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru : this$11.get__O());
  }));
  return $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
});
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.acquired__F1__O = (function(finalizer) {
  return $n(this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3).flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => {
    var s$1 = $as_Lfs2_internal_ScopedResource$State(s);
    var this$2 = $n(s$1);
    if (((!this$2.Lfs2_internal_ScopedResource$State__f_open) && (this$2.Lfs2_internal_ScopedResource$State__f_leases === 0))) {
      $m_Lcats_implicits$();
      $m_Lcats_implicits$();
      var target = $n(finalizer).apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
      var tc = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
      var fa = $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, false);
      var F$1 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var y = $f_Lcats_ApplicativeError__attempt__O__O($n(F$1), fa);
      return new $c_T2(s$1, y);
    } else {
      var attemptFinalizer = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ec) => {
        var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
        $m_Lcats_implicits$();
        var fa$1 = $n(finalizer).apply__O__O(ec$1);
        var F$3 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
        return $f_Lcats_ApplicativeError__attempt__O__O($n(F$3), fa$1);
      }));
      var finalizer$1 = new $c_s_Some(attemptFinalizer);
      var this$12 = $n(s$1);
      var open$1 = this$12.Lfs2_internal_ScopedResource$State__f_open;
      var this$13 = $n(s$1);
      var leases$1 = this$13.Lfs2_internal_ScopedResource$State__f_leases;
      $n(s$1);
      var self = new $c_Lfs2_internal_ScopedResource$State(open$1, finalizer$1, leases$1);
      $m_Lcats_implicits$();
      var a = new $c_s_util_Right(true);
      var F$4 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var this$19 = $n(F$4);
      var y$1 = $n(this$19.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
      return new $c_T2(self, y$1);
    }
  })), this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4);
});
var $d_Lfs2_internal_ScopedResource$$anon$1 = new $TypeData().initClass($c_Lfs2_internal_ScopedResource$$anon$1, "fs2.internal.ScopedResource$$anon$1", ({
  Lfs2_internal_ScopedResource$$anon$1: 1,
  Lfs2_internal_ScopedResource: 1
}));
function $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__($thiz, lastCursor, lastOp) {
  $thiz.Lio_circe_ACursor__f_lastCursor = lastCursor;
  $thiz.Lio_circe_ACursor__f_lastOp = lastOp;
  return $thiz;
}
function $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor) {
  var x1 = $n(cursor).Lio_circe_ACursor__f_lastCursor;
  if ((x1 instanceof $c_Lio_circe_cursor_ArrayCursor)) {
    var lastCursor = $as_Lio_circe_cursor_ArrayCursor(x1);
    return $n(lastCursor).Lio_circe_cursor_ArrayCursor__f_parent;
  }
  return x1;
}
function $ps_Lio_circe_ACursor__loop$1__Lio_circe_ACursor__sci_Vector__sci_Vector(cursor, acc) {
  var acc$tailLocal1 = acc;
  var cursor$tailLocal1 = cursor;
  while (true) {
    if ((cursor$tailLocal1 === null)) {
      return acc$tailLocal1;
    } else {
      var this$1 = $n(cursor$tailLocal1);
      if ((!this$1.succeeded__Z())) {
        var x5 = $n(cursor$tailLocal1).Lio_circe_ACursor__f_lastOp;
        if (false) {
          var x$1 = $as_Lio_circe_CursorOp$Field(x5);
          var x14 = $n(x$1)._1__T();
          var cursor$tailLocal1$tmp1 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var elem$1 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(x14);
          var this$4 = $m_Lio_circe_PathToRoot$();
          var this$ = acc$tailLocal1;
          var acc$tailLocal1$tmp1 = this$4.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$, elem$1);
          cursor$tailLocal1 = cursor$tailLocal1$tmp1;
          acc$tailLocal1 = acc$tailLocal1$tmp1;
          continue;
        }
        if ((x5 instanceof $c_Lio_circe_CursorOp$DownField)) {
          var x$1$1 = $as_Lio_circe_CursorOp$DownField(x5);
          var this$6 = $n(x$1$1);
          var x11 = this$6.Lio_circe_CursorOp$DownField__f_k;
          var cursor$tailLocal1$tmp2 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var elem$2 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(x11);
          var this$8 = $m_Lio_circe_PathToRoot$();
          var this$$1 = acc$tailLocal1;
          var acc$tailLocal1$tmp2 = this$8.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$1, elem$2);
          cursor$tailLocal1 = cursor$tailLocal1$tmp2;
          acc$tailLocal1 = acc$tailLocal1$tmp2;
          continue;
        }
        var x = $m_Lio_circe_CursorOp$DownArray$();
        if ((x === x5)) {
          var cursor$tailLocal1$tmp3 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var elem$3 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(0, 0);
          var this$11 = $m_Lio_circe_PathToRoot$();
          var this$$2 = acc$tailLocal1;
          var acc$tailLocal1$tmp3 = this$11.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$2, elem$3);
          cursor$tailLocal1 = cursor$tailLocal1$tmp3;
          acc$tailLocal1 = acc$tailLocal1$tmp3;
          continue;
        }
        if (false) {
          var x$1$2 = $as_Lio_circe_CursorOp$DownN(x5);
          var x8 = $n(x$1$2)._1__I();
          var cursor$tailLocal1$tmp4 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var hi = (x8 >> 31);
          var elem$4 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(x8, hi);
          var this$16 = $m_Lio_circe_PathToRoot$();
          var this$$3 = acc$tailLocal1;
          var acc$tailLocal1$tmp4 = this$16.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$3, elem$4);
          cursor$tailLocal1 = cursor$tailLocal1$tmp4;
          acc$tailLocal1 = acc$tailLocal1$tmp4;
          continue;
        }
        var x$3 = $m_Lio_circe_CursorOp$MoveLeft$();
        if ((x$3 === x5)) {
          var cursor$tailLocal1$tmp5 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var elem$5 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex((-1), (-1));
          var this$19 = $m_Lio_circe_PathToRoot$();
          var this$$4 = acc$tailLocal1;
          var acc$tailLocal1$tmp5 = this$19.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$4, elem$5);
          cursor$tailLocal1 = cursor$tailLocal1$tmp5;
          acc$tailLocal1 = acc$tailLocal1$tmp5;
          continue;
        }
        var x$5 = $m_Lio_circe_CursorOp$MoveRight$();
        if ((x$5 === x5)) {
          var x3 = $n(cursor$tailLocal1).Lio_circe_ACursor__f_lastCursor;
          if ((x3 instanceof $c_Lio_circe_cursor_ArrayCursor)) {
            var lastCursor = $as_Lio_circe_cursor_ArrayCursor(x3);
            var cursor$tailLocal1$tmp6 = $n(lastCursor).Lio_circe_cursor_ArrayCursor__f_parent;
            var value = $n(lastCursor).Lio_circe_cursor_ArrayCursor__f_indexValue;
            var hi$1 = (value >> 31);
            var lo = ((1 + value) | 0);
            var hi$2 = ((hi$1 + (((value & (~lo)) >>> 31) | 0)) | 0);
            var elem$6 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(lo, hi$2);
            var this$23 = $m_Lio_circe_PathToRoot$();
            var this$$5 = acc$tailLocal1;
            var acc$tailLocal1$tmp6 = this$23.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$5, elem$6);
            cursor$tailLocal1 = cursor$tailLocal1$tmp6;
            acc$tailLocal1 = acc$tailLocal1$tmp6;
            continue;
          }
          cursor$tailLocal1 = $n(cursor$tailLocal1).Lio_circe_ACursor__f_lastCursor;
          continue;
        }
        cursor$tailLocal1 = $n(cursor$tailLocal1).Lio_circe_ACursor__f_lastCursor;
      } else {
        var x15 = cursor$tailLocal1;
        if ((x15 instanceof $c_Lio_circe_cursor_ArrayCursor)) {
          var cursor$2 = $as_Lio_circe_cursor_ArrayCursor(x15);
          var cursor$tailLocal1$tmp7 = $n(cursor$2).Lio_circe_cursor_ArrayCursor__f_parent;
          var value$1 = $n(cursor$2).Lio_circe_cursor_ArrayCursor__f_indexValue;
          var hi$3 = (value$1 >> 31);
          var elem$7 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(value$1, hi$3);
          var this$27 = $m_Lio_circe_PathToRoot$();
          var this$$6 = acc$tailLocal1;
          var acc$tailLocal1$tmp7 = this$27.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$6, elem$7);
          cursor$tailLocal1 = cursor$tailLocal1$tmp7;
          acc$tailLocal1 = acc$tailLocal1$tmp7;
          continue;
        }
        if ((x15 instanceof $c_Lio_circe_cursor_ObjectCursor)) {
          var cursor$3 = $as_Lio_circe_cursor_ObjectCursor(x15);
          var cursor$tailLocal1$tmp8 = $n(cursor$3).Lio_circe_cursor_ObjectCursor__f_parent;
          var keyName = $n(cursor$3).Lio_circe_cursor_ObjectCursor__f_keyValue;
          var elem$8 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(keyName);
          var this$29 = $m_Lio_circe_PathToRoot$();
          var this$$7 = acc$tailLocal1;
          var acc$tailLocal1$tmp8 = this$29.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$7, elem$8);
          cursor$tailLocal1 = cursor$tailLocal1$tmp8;
          acc$tailLocal1 = acc$tailLocal1$tmp8;
          continue;
        }
        if ((x15 instanceof $c_Lio_circe_cursor_TopCursor)) {
          $as_Lio_circe_cursor_TopCursor(x15);
          return acc$tailLocal1;
        }
        cursor$tailLocal1 = $n(cursor$tailLocal1).Lio_circe_ACursor__f_lastCursor;
      }
    }
  }
}
/** @constructor */
function $c_Lio_circe_ACursor() {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
}
$c_Lio_circe_ACursor.prototype = new $h_O();
$c_Lio_circe_ACursor.prototype.constructor = $c_Lio_circe_ACursor;
/** @constructor */
function $h_Lio_circe_ACursor() {
}
$h_Lio_circe_ACursor.prototype = $c_Lio_circe_ACursor.prototype;
$c_Lio_circe_ACursor.prototype.history__sci_List = (function() {
  var next = this;
  var builder = new $c_scm_ListBuffer();
  while ((next !== null)) {
    if (($n(next).Lio_circe_ACursor__f_lastOp !== null)) {
      var elem = $n(next).Lio_circe_ACursor__f_lastOp;
      builder.addOne__O__scm_ListBuffer(elem);
    }
    next = $n(next).Lio_circe_ACursor__f_lastCursor;
  }
  return builder.toList__sci_List();
});
$c_Lio_circe_ACursor.prototype.get__T__Lio_circe_Decoder__s_util_Either = (function(k, d) {
  var this$1 = $n(this.downField__T__Lio_circe_ACursor(k));
  return $n(d).tryDecode__Lio_circe_ACursor__s_util_Either(this$1);
});
function $p_Lio_circe_Decoder__cursorToDecodingFailure__Lio_circe_ACursor__Lio_circe_DecodingFailure($thiz, cursor) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    matchResult2: {
      var $x_1;
      if ((cursor instanceof $c_Lio_circe_FailedCursor)) {
        var cursor$1 = $as_Lio_circe_FailedCursor(cursor);
        if ($n(cursor$1).missingField__Z()) {
          var $x_1 = $m_Lio_circe_DecodingFailure$Reason$MissingField$();
          break matchResult2;
        }
      }
      var this$1 = $n(cursor);
      var field = $f_T__replaceFirst__T__T__T($n($m_Lio_circe_PathToRoot$().toPathString__sci_Vector__T($ps_Lio_circe_ACursor__loop$1__Lio_circe_ACursor__sci_Vector__sci_Vector(this$1, $m_Lio_circe_PathToRoot$().Lio_circe_PathToRoot$__f_empty))), "^\\.", "");
      var message = ("Couldn't decode " + field);
      var $x_1 = new $c_Lio_circe_DecodingFailure$Reason$CustomReason(message);
    }
    return $as_Lio_circe_DecodingFailure$Reason($x_1);
  }));
  var reason = new $c_Lcats_Later(a);
  $m_Lio_circe_DecodingFailure$();
  var this$4 = $n(cursor);
  var value = new $c_Lio_circe_PathToRoot($ps_Lio_circe_ACursor__loop$1__Lio_circe_ACursor__sci_Vector__sci_Vector(this$4, $m_Lio_circe_PathToRoot$().Lio_circe_PathToRoot$__f_empty));
  var pathToRoot = new $c_s_Some(value);
  $m_Lcats_Eval$();
  var a$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(cursor).history__sci_List()));
  var ops = new $c_Lcats_Later(a$1);
  return new $c_Lio_circe_DecodingFailure$DecodingFailureImpl(reason, pathToRoot, ops);
}
function $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either($thiz, c) {
  if ((c instanceof $c_Lio_circe_HCursor)) {
    var hc = $as_Lio_circe_HCursor(c);
    return $thiz.apply__Lio_circe_HCursor__s_util_Either(hc);
  } else {
    var value = $p_Lio_circe_Decoder__cursorToDecodingFailure__Lio_circe_ACursor__Lio_circe_DecodingFailure($thiz, c);
    return new $c_s_util_Left(value);
  }
}
function $f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either($thiz, j) {
  return $thiz.apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(j, null, null));
}
/** @constructor */
function $c_Lio_circe_JsonNumber() {
}
$c_Lio_circe_JsonNumber.prototype = new $h_O();
$c_Lio_circe_JsonNumber.prototype.constructor = $c_Lio_circe_JsonNumber;
/** @constructor */
function $h_Lio_circe_JsonNumber() {
}
$h_Lio_circe_JsonNumber.prototype = $c_Lio_circe_JsonNumber.prototype;
$c_Lio_circe_JsonNumber.prototype.toInt__s_Option = (function() {
  var x7 = this.toLong__s_Option();
  if ((x7 instanceof $c_s_Some)) {
    var $x_1 = $uJ($n($as_s_Some(x7)).s_Some__f_value);
    var n_$_lo = $x_1.l;
    var n_$_hi = $x_1.h;
    var hi = (n_$_lo >> 31);
    if ((((n_$_lo ^ n_$_lo) | (n_$_hi ^ hi)) === 0)) {
      return new $c_s_Some(n_$_lo);
    } else {
      return $m_s_None$();
    }
  }
  var x = $m_s_None$();
  if ((x === x7)) {
    return $m_s_None$();
  }
  throw new $c_s_MatchError(x7);
});
$c_Lio_circe_JsonNumber.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_JsonNumber)) {
    var that$2 = $as_Lio_circe_JsonNumber(that);
    return $n($m_Lio_circe_JsonNumber$().Lio_circe_JsonNumber$__f_eqJsonNumber).eqv__O__O__Z(this, that$2);
  } else {
    return false;
  }
});
$c_Lio_circe_JsonNumber.prototype.hashCode__I = (function() {
  return $n(this.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal()).hashCode__I();
});
function $as_Lio_circe_JsonNumber(obj) {
  return (((obj instanceof $c_Lio_circe_JsonNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonNumber"));
}
function $isArrayOf_Lio_circe_JsonNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonNumber)));
}
function $asArrayOf_Lio_circe_JsonNumber(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonNumber;", depth));
}
/** @constructor */
function $c_Lio_circe_JsonObject() {
}
$c_Lio_circe_JsonObject.prototype = new $h_O();
$c_Lio_circe_JsonObject.prototype.constructor = $c_Lio_circe_JsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject() {
}
$h_Lio_circe_JsonObject.prototype = $c_Lio_circe_JsonObject.prototype;
$c_Lio_circe_JsonObject.prototype.toString__T = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($n($as_sc_IterableOnceOps($n(this.toIterable__sc_Iterable()).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var k = $as_T($n(x$1$1)._1__O());
      var v = $as_Lio_circe_Json($n(x$1$1)._2__O());
      return ((k + " -> ") + $n($m_Lio_circe_Json$().Lio_circe_Json$__f_showJson).show__O__T(v));
    }
    throw new $c_s_MatchError(x$1$1);
  }))))), "object[", ",", "]");
});
$c_Lio_circe_JsonObject.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_JsonObject)) {
    var that$2 = $as_Lio_circe_JsonObject(that);
    if ((that$2 instanceof $c_Lio_circe_JsonObject$LinkedHashMapJsonObject)) {
      var that$3 = $as_Lio_circe_JsonObject$LinkedHashMapJsonObject(that$2);
      return $n(that$3).equalsJsonObject__Lio_circe_JsonObject__Z(this);
    }
    if ((that$2 instanceof $c_Lio_circe_JsonObject$MapAndVectorJsonObject)) {
      var that$4 = $as_Lio_circe_JsonObject$MapAndVectorJsonObject(that$2);
      return $n(that$4).equalsJsonObject__Lio_circe_JsonObject__Z(this);
    }
    throw new $c_s_MatchError(that$2);
  } else {
    return false;
  }
});
$c_Lio_circe_JsonObject.prototype.hashCode__I = (function() {
  if ((this instanceof $c_Lio_circe_JsonObject$LinkedHashMapJsonObject)) {
    var thiz = $as_Lio_circe_JsonObject$LinkedHashMapJsonObject(this);
    var this$1 = $n(thiz);
    return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this$1), $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
  }
  if ((this instanceof $c_Lio_circe_JsonObject$MapAndVectorJsonObject)) {
    var thiz$2 = $as_Lio_circe_JsonObject$MapAndVectorJsonObject(this);
    return $n(thiz$2).internalHashCode__I();
  }
  throw new $c_s_MatchError(this);
});
function $as_Lio_circe_JsonObject(obj) {
  return (((obj instanceof $c_Lio_circe_JsonObject) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonObject"));
}
function $isArrayOf_Lio_circe_JsonObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonObject)));
}
function $asArrayOf_Lio_circe_JsonObject(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonObject;", depth));
}
function $f_Lio_circe_Parser__finishDecode__s_util_Either__Lio_circe_Decoder__s_util_Either($thiz, input, decoder) {
  if ((input instanceof $c_s_util_Right)) {
    var json = $as_Lio_circe_Json($n($as_s_util_Right(input)).s_util_Right__f_value);
    return $f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either($n(decoder), json);
  }
  if ((input instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(input);
    return l;
  }
  throw new $c_s_MatchError(input);
}
function $f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either($thiz, input, evidence$1) {
  var input$1 = $thiz.parse__T__s_util_Either(input);
  return $f_Lio_circe_Parser__finishDecode__s_util_Either__Lio_circe_Decoder__s_util_Either($thiz, input$1, evidence$1);
}
/** @constructor */
function $c_Lio_circe_Printer$$anon$2() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  $ct_jl_ThreadLocal__(this);
}
$c_Lio_circe_Printer$$anon$2.prototype = new $h_jl_ThreadLocal();
$c_Lio_circe_Printer$$anon$2.prototype.constructor = $c_Lio_circe_Printer$$anon$2;
/** @constructor */
function $h_Lio_circe_Printer$$anon$2() {
}
$h_Lio_circe_Printer$$anon$2.prototype = $c_Lio_circe_Printer$$anon$2.prototype;
$c_Lio_circe_Printer$$anon$2.prototype.initialValue__O = (function() {
  return $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
});
var $d_Lio_circe_Printer$$anon$2 = new $TypeData().initClass($c_Lio_circe_Printer$$anon$2, "io.circe.Printer$$anon$2", ({
  Lio_circe_Printer$$anon$2: 1,
  jl_ThreadLocal: 1
}));
/** @constructor */
function $c_Lio_circe_Printer$PiecesAtDepth() {
}
$c_Lio_circe_Printer$PiecesAtDepth.prototype = new $h_O();
$c_Lio_circe_Printer$PiecesAtDepth.prototype.constructor = $c_Lio_circe_Printer$PiecesAtDepth;
/** @constructor */
function $h_Lio_circe_Printer$PiecesAtDepth() {
}
$h_Lio_circe_Printer$PiecesAtDepth.prototype = $c_Lio_circe_Printer$PiecesAtDepth.prototype;
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal() {
}
$c_Lio_circe_numbers_BiggerDecimal.prototype = new $h_O();
$c_Lio_circe_numbers_BiggerDecimal.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal() {
}
$h_Lio_circe_numbers_BiggerDecimal.prototype = $c_Lio_circe_numbers_BiggerDecimal.prototype;
function $p_jl_Character$__getTypeGE256__I__I($thiz, codePoint) {
  return $n($p_jl_Character$__charTypes__AI($thiz)).get($p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, $p_jl_Character$__charTypeIndices__AI($thiz), codePoint, false));
}
function $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) {
  if (((((1 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    var deltas = new $ac_I(new Int32Array([257, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 3, 2, 1, 1, 1, 2, 1, 3, 2, 4, 1, 2, 1, 3, 3, 2, 1, 2, 1, 1, 1, 1, 1, 2, 1, 1, 2, 1, 1, 2, 1, 3, 1, 1, 1, 2, 2, 1, 1, 3, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 2, 1, 2, 2, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 69, 1, 27, 18, 4, 12, 14, 5, 7, 1, 1, 1, 17, 112, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 3, 1, 1, 4, 2, 1, 1, 3, 1, 1, 1, 2, 1, 17, 1, 9, 35, 1, 2, 3, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 2, 2, 51, 48, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 38, 2, 1, 6, 41, 1, 1, 2, 2, 1, 1, 45, 1, 1, 1, 2, 1, 2, 1, 1, 8, 27, 4, 4, 2, 11, 6, 3, 2, 1, 2, 2, 11, 1, 1, 3, 32, 1, 10, 21, 10, 4, 2, 1, 99, 1, 1, 7, 1, 1, 6, 2, 2, 1, 4, 2, 10, 3, 2, 1, 14, 1, 1, 1, 1, 30, 27, 2, 89, 11, 1, 14, 10, 33, 9, 2, 1, 3, 1, 2, 1, 2, 22, 4, 1, 9, 1, 3, 1, 5, 2, 15, 1, 25, 3, 2, 1, 1, 11, 5, 24, 1, 6, 1, 2, 6, 8, 41, 1, 24, 1, 32, 1, 54, 1, 1, 1, 1, 3, 8, 4, 1, 2, 1, 7, 10, 2, 2, 10, 1, 1, 15, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 1, 3, 4, 2, 1, 1, 3, 4, 2, 2, 2, 2, 1, 1, 8, 1, 4, 2, 1, 3, 2, 2, 10, 2, 2, 6, 1, 1, 1, 1, 1, 2, 2, 1, 1, 6, 4, 2, 2, 22, 1, 7, 1, 2, 1, 2, 1, 2, 2, 1, 1, 3, 2, 4, 2, 2, 3, 3, 1, 7, 4, 1, 1, 7, 10, 2, 3, 1, 1, 10, 2, 1, 1, 9, 1, 3, 1, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 3, 5, 1, 2, 1, 1, 2, 1, 2, 1, 15, 2, 2, 2, 10, 1, 1, 7, 1, 6, 1, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 1, 1, 1, 4, 2, 2, 2, 2, 1, 7, 2, 1, 4, 2, 1, 3, 2, 2, 10, 1, 1, 6, 10, 1, 1, 1, 6, 3, 3, 1, 4, 3, 2, 1, 1, 1, 2, 3, 2, 3, 3, 3, 12, 4, 2, 1, 2, 3, 3, 1, 3, 1, 2, 1, 6, 1, 14, 10, 3, 6, 1, 1, 5, 1, 3, 1, 8, 1, 3, 1, 23, 1, 16, 2, 1, 1, 3, 4, 1, 3, 1, 4, 7, 2, 1, 3, 2, 1, 2, 2, 2, 2, 10, 7, 1, 7, 1, 1, 1, 2, 1, 8, 1, 3, 1, 23, 1, 10, 1, 5, 2, 1, 1, 1, 1, 5, 1, 1, 2, 1, 2, 2, 7, 2, 6, 2, 1, 2, 2, 2, 10, 1, 2, 1, 12, 2, 2, 9, 1, 3, 1, 41, 2, 1, 3, 4, 1, 3, 1, 3, 1, 1, 1, 4, 3, 1, 7, 3, 2, 2, 10, 9, 1, 6, 1, 1, 2, 1, 18, 3, 24, 1, 9, 1, 1, 2, 7, 3, 1, 4, 3, 3, 1, 1, 1, 8, 6, 10, 2, 2, 1, 12, 48, 1, 2, 7, 4, 1, 6, 1, 8, 1, 10, 2, 37, 2, 1, 1, 1, 5, 1, 24, 1, 1, 1, 10, 1, 2, 9, 1, 2, 5, 1, 1, 1, 7, 1, 10, 2, 4, 32, 1, 3, 15, 1, 1, 3, 2, 6, 10, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 8, 1, 36, 4, 14, 1, 5, 1, 2, 5, 11, 1, 36, 1, 8, 1, 6, 1, 2, 5, 4, 2, 37, 43, 2, 4, 1, 6, 1, 2, 2, 2, 1, 10, 6, 6, 2, 2, 4, 3, 1, 3, 2, 7, 3, 4, 13, 1, 2, 2, 6, 1, 1, 1, 10, 3, 1, 2, 38, 1, 1, 5, 1, 2, 43, 1, 1, 3, 329, 1, 4, 2, 7, 1, 1, 1, 4, 2, 41, 1, 4, 2, 33, 1, 4, 2, 7, 1, 1, 1, 4, 2, 15, 1, 57, 1, 4, 2, 67, 2, 3, 9, 20, 3, 16, 10, 6, 86, 2, 6, 2, 1, 620, 1, 1, 17, 1, 26, 1, 1, 3, 75, 3, 3, 8, 7, 18, 3, 1, 9, 19, 2, 1, 2, 9, 18, 2, 12, 13, 1, 3, 1, 2, 12, 52, 2, 1, 7, 8, 1, 2, 11, 3, 1, 3, 1, 1, 1, 2, 10, 6, 10, 6, 6, 1, 4, 3, 1, 1, 10, 6, 35, 1, 53, 7, 5, 2, 34, 1, 1, 5, 70, 10, 31, 1, 3, 4, 2, 3, 4, 2, 1, 6, 3, 4, 1, 3, 2, 10, 30, 2, 5, 11, 44, 4, 26, 6, 10, 1, 3, 34, 23, 2, 2, 1, 2, 2, 53, 1, 1, 1, 7, 1, 1, 1, 1, 2, 8, 6, 10, 2, 1, 10, 6, 10, 6, 7, 1, 6, 2, 14, 1, 16, 49, 4, 1, 47, 1, 1, 5, 1, 1, 5, 1, 2, 8, 3, 10, 7, 10, 9, 9, 2, 1, 2, 1, 30, 1, 4, 2, 2, 1, 3, 2, 10, 44, 1, 1, 2, 3, 1, 1, 3, 2, 8, 4, 36, 8, 8, 2, 2, 3, 5, 10, 3, 3, 10, 30, 6, 2, 9, 7, 43, 2, 3, 8, 8, 3, 1, 13, 1, 7, 4, 1, 6, 1, 2, 1, 2, 1, 5, 44, 63, 13, 1, 34, 37, 64, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 8, 6, 2, 6, 2, 8, 8, 8, 8, 6, 2, 6, 2, 8, 1, 1, 1, 1, 1, 1, 1, 1, 8, 8, 14, 2, 8, 8, 8, 8, 8, 8, 5, 1, 2, 4, 1, 1, 1, 3, 3, 1, 2, 4, 1, 3, 4, 2, 2, 4, 1, 3, 8, 5, 3, 2, 3, 1, 2, 4, 1, 2, 1, 11, 5, 6, 2, 1, 1, 1, 2, 1, 1, 1, 8, 1, 1, 5, 1, 9, 1, 1, 4, 2, 3, 1, 1, 1, 11, 1, 1, 1, 10, 1, 5, 1, 10, 1, 1, 2, 6, 3, 1, 1, 1, 10, 3, 1, 1, 1, 13, 3, 33, 15, 13, 4, 1, 3, 12, 15, 2, 1, 4, 1, 2, 1, 3, 2, 3, 1, 1, 1, 2, 1, 5, 6, 1, 1, 1, 1, 1, 1, 4, 1, 1, 4, 1, 4, 1, 2, 2, 2, 5, 1, 4, 1, 1, 2, 1, 1, 16, 35, 1, 1, 4, 1, 2, 4, 5, 5, 2, 4, 1, 2, 1, 2, 1, 7, 1, 31, 2, 2, 1, 1, 1, 31, 268, 8, 1, 1, 1, 1, 20, 2, 7, 1, 1, 81, 1, 30, 25, 40, 6, 69, 25, 11, 21, 60, 78, 22, 183, 1, 9, 1, 54, 8, 111, 1, 248, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 30, 44, 5, 1, 1, 31, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 16, 256, 131, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 63, 1, 1, 1, 1, 32, 1, 1, 258, 48, 21, 2, 6, 39, 2, 32, 1, 105, 48, 48, 1, 1, 3, 2, 1, 1, 1, 1, 1, 1, 4, 1, 1, 2, 1, 6, 2, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 6, 1, 1, 1, 1, 3, 1, 1, 5, 4, 1, 2, 38, 1, 1, 5, 1, 2, 56, 7, 1, 1, 14, 1, 23, 9, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 32, 2, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 9, 1, 2, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 10, 2, 4, 1, 1, 1, 13, 2, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 34, 26, 1, 89, 12, 214, 26, 12, 4, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 9, 4, 2, 1, 5, 2, 3, 1, 1, 1, 2, 1, 86, 2, 2, 2, 2, 1, 1, 90, 1, 3, 1, 5, 43, 1, 94, 1, 2, 4, 10, 32, 36, 12, 16, 31, 1, 10, 30, 8, 1, 15, 32, 10, 39, 15, 320, 6592, 64, 21013, 1, 1143, 3, 55, 9, 40, 6, 2, 268, 1, 3, 16, 10, 2, 20, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 70, 10, 2, 6, 8, 23, 9, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 5, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 5, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 24, 3, 1, 1, 1, 2, 1, 7, 1, 3, 1, 4, 1, 23, 2, 2, 1, 4, 1, 3, 6, 2, 1, 1, 6, 52, 4, 8, 2, 50, 16, 2, 8, 2, 10, 6, 18, 6, 3, 1, 1, 2, 1, 10, 28, 8, 2, 23, 11, 2, 11, 1, 29, 3, 3, 1, 47, 1, 2, 4, 2, 2, 3, 13, 1, 1, 10, 4, 2, 5, 1, 1, 9, 10, 5, 1, 41, 6, 2, 2, 2, 2, 9, 3, 1, 8, 1, 1, 2, 10, 2, 4, 16, 1, 6, 3, 1, 1, 1, 1, 50, 1, 1, 3, 2, 2, 5, 2, 1, 1, 1, 24, 2, 1, 2, 11, 1, 2, 2, 2, 1, 2, 1, 1, 10, 6, 2, 6, 2, 6, 9, 7, 1, 7, 1, 43, 1, 4, 9, 1, 2, 4, 80, 35, 2, 1, 2, 1, 2, 1, 1, 1, 2, 10, 6, 11172, 12, 23, 4, 49, 4, 2048, 6400, 366, 2, 106, 38, 7, 12, 5, 5, 1, 1, 10, 1, 13, 1, 5, 1, 1, 1, 2, 1, 2, 1, 108, 17, 16, 363, 1, 1, 16, 64, 2, 54, 7, 1, 32, 12, 1, 3, 16, 7, 1, 1, 1, 6, 16, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 4, 3, 3, 1, 4, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 3, 1, 1, 1, 2, 4, 5, 1, 135, 2, 1, 1, 3, 1, 3, 1, 1, 1, 1, 1, 1, 2, 10, 2, 3, 2, 26, 1, 1, 1, 1, 1, 1, 26, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 10, 1, 45, 2, 31, 3, 6, 2, 6, 2, 6, 2, 3, 3, 2, 1, 1, 1, 2, 1, 1, 4, 2, 10, 3, 2, 2, 12, 1, 26, 1, 19, 1, 2, 1, 15, 2, 14, 34, 123, 5, 3, 4, 45, 3, 9, 53, 4, 17, 2, 3, 1, 13, 3, 1, 47, 45, 1, 130, 29, 3, 49, 15, 1, 27, 4, 32, 4, 9, 20, 1, 8, 1, 5, 38, 5, 5, 30, 1, 1, 36, 4, 8, 1, 5, 42, 40, 40, 78, 2, 10, 6, 36, 4, 36, 4, 40, 8, 52, 11, 1, 11, 1, 15, 1, 7, 1, 2, 1, 11, 1, 15, 1, 7, 1, 2, 67, 311, 9, 22, 10, 8, 24, 6, 1, 42, 1, 9, 69, 6, 2, 1, 1, 44, 1, 2, 3, 1, 2, 23, 1, 1, 8, 23, 2, 7, 31, 8, 9, 48, 19, 1, 2, 5, 5, 22, 6, 3, 1, 26, 5, 1, 64, 56, 4, 2, 2, 16, 2, 46, 1, 3, 1, 2, 5, 4, 4, 1, 3, 1, 29, 2, 3, 4, 1, 9, 7, 9, 7, 29, 2, 1, 29, 3, 32, 8, 1, 28, 2, 4, 5, 7, 9, 54, 3, 7, 22, 2, 8, 19, 5, 8, 18, 7, 4, 12, 7, 80, 73, 55, 51, 13, 51, 7, 6, 36, 4, 8, 10, 294, 31, 1, 42, 1, 2, 1, 2, 2, 75, 3, 29, 10, 1, 8, 22, 11, 4, 5, 22, 18, 4, 4, 38, 21, 7, 20, 23, 9, 1, 1, 1, 53, 15, 7, 4, 20, 10, 1, 2, 2, 1, 9, 3, 1, 45, 3, 4, 2, 2, 2, 1, 4, 1, 10, 1, 2, 25, 7, 10, 6, 3, 36, 5, 1, 8, 1, 10, 4, 1, 2, 1, 8, 35, 1, 2, 1, 9, 2, 1, 48, 3, 9, 2, 4, 4, 4, 1, 1, 1, 10, 1, 1, 1, 3, 1, 20, 11, 18, 1, 25, 3, 3, 2, 1, 1, 2, 6, 1, 2, 1, 62, 7, 1, 1, 1, 4, 1, 15, 1, 10, 1, 6, 47, 1, 3, 8, 5, 10, 6, 2, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 2, 1, 5, 1, 2, 1, 2, 1, 4, 2, 2, 2, 3, 2, 1, 6, 1, 5, 5, 2, 2, 7, 3, 5, 139, 53, 3, 8, 2, 3, 1, 1, 4, 5, 10, 2, 1, 1, 1, 3, 30, 48, 3, 6, 1, 1, 4, 2, 1, 2, 2, 1, 1, 8, 10, 166, 47, 3, 4, 2, 4, 2, 1, 2, 23, 4, 2, 34, 48, 3, 8, 2, 1, 1, 2, 3, 1, 11, 10, 6, 13, 19, 43, 1, 1, 1, 2, 6, 1, 1, 1, 1, 6, 10, 54, 27, 2, 3, 2, 4, 1, 5, 4, 10, 2, 3, 1, 7, 185, 44, 3, 9, 1, 2, 1, 100, 32, 32, 10, 9, 12, 8, 2, 1, 2, 8, 1, 2, 1, 24, 6, 1, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 3, 9, 10, 70, 8, 2, 39, 3, 4, 2, 2, 4, 1, 1, 1, 1, 1, 27, 1, 10, 40, 6, 1, 1, 4, 8, 1, 8, 1, 6, 2, 3, 46, 13, 1, 2, 3, 1, 5, 13, 73, 7, 10, 246, 9, 1, 37, 1, 7, 1, 6, 1, 1, 1, 5, 10, 10, 19, 3, 2, 30, 2, 22, 1, 1, 7, 1, 2, 1, 2, 73, 7, 1, 2, 1, 38, 6, 3, 1, 1, 2, 1, 7, 1, 1, 8, 10, 6, 6, 1, 2, 1, 32, 5, 1, 2, 1, 2, 1, 1, 1, 1, 7, 10, 310, 19, 2, 2, 2, 7, 2, 1, 1, 13, 1, 34, 2, 5, 3, 2, 1, 1, 1, 13, 10, 86, 1, 15, 21, 8, 4, 17, 13, 1, 922, 102, 111, 1, 5, 11, 196, 2636, 97, 2, 13, 1072, 16, 1, 6, 15, 4010, 583, 8633, 569, 7, 31, 1, 10, 4, 2, 79, 1, 10, 6, 30, 2, 5, 1, 10, 48, 7, 5, 4, 4, 1, 1, 10, 10, 1, 7, 1, 21, 5, 19, 688, 32, 32, 23, 4, 101, 75, 4, 1, 1, 55, 7, 4, 13, 64, 2, 1, 1, 1, 11, 2, 14, 6136, 8, 1238, 42, 9, 8935, 4, 1, 7, 1, 2, 1, 291, 15, 1, 29, 3, 2, 1, 14, 4, 8, 396, 2308, 107, 5, 13, 3, 9, 7, 10, 2, 1, 2, 1, 4, 4700, 46, 2, 23, 9, 116, 60, 246, 10, 39, 2, 60, 2, 3, 3, 6, 8, 8, 2, 7, 30, 4, 61, 21, 66, 3, 1, 122, 20, 12, 20, 12, 87, 9, 25, 135, 26, 26, 26, 7, 1, 18, 26, 26, 1, 1, 2, 2, 1, 2, 2, 2, 4, 1, 8, 4, 1, 1, 1, 7, 1, 11, 26, 26, 2, 1, 4, 2, 8, 1, 7, 1, 26, 2, 1, 4, 1, 5, 1, 1, 3, 7, 1, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 28, 2, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 1, 1, 2, 50, 512, 55, 4, 50, 8, 1, 14, 1, 2, 5, 15, 5, 1, 15, 1104, 10, 1, 20, 6, 6, 213, 7, 1, 17, 2, 7, 1, 2, 1, 5, 5, 62, 33, 1, 112, 45, 3, 7, 7, 2, 10, 4, 1, 1, 320, 30, 1, 17, 44, 4, 10, 5, 1, 464, 27, 1, 4, 10, 742, 7, 1, 4, 1, 2, 1, 15, 1, 197, 2, 9, 7, 41, 34, 34, 7, 1, 4, 10, 4, 2, 785, 59, 1, 3, 1, 4, 76, 45, 1, 15, 194, 4, 1, 27, 1, 2, 1, 1, 2, 1, 1, 10, 1, 4, 1, 1, 1, 1, 6, 1, 4, 1, 1, 1, 1, 1, 1, 3, 1, 2, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 2, 4, 1, 7, 1, 4, 1, 4, 1, 1, 1, 10, 1, 17, 5, 3, 1, 5, 1, 17, 52, 2, 270, 44, 4, 100, 12, 15, 2, 15, 1, 15, 1, 37, 10, 13, 161, 56, 29, 13, 44, 4, 9, 7, 2, 14, 6, 154, 251, 5, 728, 4, 17, 3, 13, 3, 119, 4, 95, 6, 12, 4, 1, 15, 12, 4, 56, 8, 10, 6, 40, 8, 30, 2, 2, 78, 340, 12, 14, 2, 13, 3, 9, 7, 46, 1, 7, 8, 14, 4, 9, 7, 9, 7, 147, 1, 55, 37, 10, 1030, 42720, 32, 4154, 6, 222, 2, 5762, 14, 7473, 3103, 542, 1506, 4939, 5, 4192, 711761, 1, 30, 96, 128, 240, 65040, 65534, 2, 65534]));
    $thiz.jl_Character$__f_charTypeIndices = $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas);
    $thiz.jl_Character$__f_bitmap$0 = (((1 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_charTypeIndices;
}
function $p_jl_Character$__charTypeIndices__AI($thiz) {
  return (((((1 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypeIndices);
}
function $p_jl_Character$__charTypes$lzycompute__AI($thiz) {
  if (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_charTypes = new $ac_I(new Int32Array([1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 1, 2, 5, 1, 3, 2, 1, 3, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 2, 4, 27, 4, 27, 4, 27, 4, 27, 4, 27, 6, 1, 2, 1, 2, 4, 27, 1, 2, 0, 4, 2, 24, 1, 0, 27, 1, 24, 1, 0, 1, 0, 1, 2, 1, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 25, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 6, 7, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 4, 24, 2, 24, 20, 0, 28, 26, 0, 6, 20, 6, 24, 6, 24, 6, 24, 6, 0, 5, 0, 5, 24, 0, 16, 25, 24, 26, 24, 28, 6, 24, 16, 24, 5, 4, 5, 6, 9, 24, 5, 6, 5, 24, 5, 6, 16, 28, 6, 4, 6, 28, 6, 5, 9, 5, 28, 5, 24, 0, 16, 5, 6, 5, 6, 0, 5, 6, 5, 0, 9, 5, 6, 4, 28, 24, 4, 0, 6, 26, 5, 6, 4, 6, 4, 6, 4, 6, 0, 24, 0, 5, 6, 0, 24, 0, 5, 0, 5, 27, 5, 0, 16, 0, 6, 5, 4, 6, 16, 6, 8, 5, 6, 8, 6, 5, 8, 6, 8, 6, 8, 5, 6, 5, 6, 24, 9, 24, 4, 5, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 8, 0, 8, 6, 5, 0, 8, 0, 5, 0, 5, 6, 0, 9, 5, 26, 11, 28, 26, 5, 24, 6, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 0, 9, 6, 5, 6, 24, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 6, 8, 0, 8, 6, 0, 5, 0, 5, 6, 0, 9, 24, 26, 0, 5, 6, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 6, 0, 8, 0, 8, 6, 0, 6, 8, 0, 5, 0, 5, 6, 0, 9, 28, 5, 11, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 8, 6, 8, 0, 8, 0, 8, 6, 0, 5, 0, 8, 0, 9, 11, 28, 26, 28, 0, 6, 8, 6, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 6, 8, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 0, 5, 6, 0, 9, 0, 24, 11, 28, 5, 6, 8, 24, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 0, 6, 8, 0, 8, 6, 0, 8, 0, 5, 0, 5, 6, 0, 9, 0, 5, 8, 0, 6, 8, 5, 0, 5, 0, 5, 6, 5, 8, 6, 0, 8, 0, 8, 6, 5, 28, 0, 5, 8, 11, 5, 6, 0, 9, 11, 28, 5, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 8, 0, 9, 0, 8, 24, 0, 5, 6, 5, 6, 0, 26, 5, 4, 6, 24, 9, 24, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 6, 5, 6, 5, 0, 5, 0, 4, 0, 6, 0, 9, 0, 5, 0, 5, 28, 24, 28, 24, 28, 6, 28, 9, 11, 28, 6, 28, 6, 28, 6, 21, 22, 21, 22, 8, 5, 0, 5, 0, 6, 8, 6, 24, 6, 5, 6, 0, 6, 0, 28, 6, 28, 0, 28, 24, 28, 24, 0, 5, 8, 6, 8, 6, 8, 6, 8, 6, 5, 9, 24, 5, 8, 6, 5, 6, 5, 8, 5, 8, 5, 6, 5, 6, 8, 6, 8, 6, 5, 8, 9, 8, 6, 28, 1, 0, 1, 0, 1, 0, 2, 24, 4, 2, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 11, 0, 5, 28, 0, 1, 0, 2, 0, 20, 5, 28, 24, 5, 12, 5, 21, 22, 0, 5, 24, 10, 5, 0, 5, 6, 8, 0, 5, 6, 8, 24, 0, 5, 6, 0, 5, 0, 5, 0, 6, 0, 5, 6, 8, 6, 8, 6, 8, 6, 24, 4, 24, 26, 5, 6, 0, 9, 0, 11, 0, 24, 20, 24, 6, 16, 6, 9, 0, 5, 4, 5, 0, 5, 6, 5, 6, 5, 0, 5, 0, 5, 0, 6, 8, 6, 8, 0, 8, 6, 8, 6, 0, 28, 0, 24, 9, 5, 0, 5, 0, 5, 0, 5, 0, 9, 11, 0, 28, 5, 6, 8, 6, 0, 24, 5, 8, 6, 8, 6, 0, 6, 8, 6, 8, 6, 8, 6, 0, 6, 9, 0, 9, 0, 24, 4, 24, 0, 6, 7, 6, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 6, 8, 5, 0, 9, 24, 28, 6, 28, 24, 0, 6, 8, 5, 8, 6, 8, 6, 8, 6, 5, 9, 5, 6, 8, 6, 8, 6, 8, 6, 8, 0, 24, 5, 8, 6, 8, 6, 0, 24, 9, 0, 5, 9, 5, 4, 24, 2, 0, 1, 0, 1, 24, 0, 6, 24, 6, 8, 6, 5, 6, 5, 6, 5, 8, 6, 5, 0, 2, 4, 2, 4, 2, 4, 6, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 2, 1, 2, 1, 2, 0, 1, 0, 2, 0, 1, 0, 1, 0, 1, 0, 1, 2, 1, 2, 0, 2, 3, 2, 3, 2, 3, 2, 0, 2, 1, 3, 27, 2, 27, 2, 0, 2, 1, 3, 27, 2, 0, 2, 1, 0, 27, 2, 1, 27, 0, 2, 0, 2, 1, 3, 27, 0, 12, 16, 20, 24, 29, 30, 21, 29, 30, 21, 29, 24, 13, 14, 16, 12, 24, 29, 30, 24, 23, 24, 25, 21, 22, 24, 25, 24, 23, 24, 12, 16, 0, 16, 11, 4, 0, 11, 25, 21, 22, 4, 11, 25, 21, 22, 0, 4, 0, 26, 0, 6, 7, 6, 7, 6, 0, 28, 1, 28, 1, 28, 2, 1, 2, 1, 2, 28, 1, 28, 25, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 2, 1, 2, 5, 2, 28, 2, 1, 25, 1, 2, 28, 25, 28, 2, 28, 11, 10, 1, 2, 10, 11, 28, 0, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 21, 22, 21, 22, 28, 25, 28, 21, 22, 28, 25, 28, 25, 28, 25, 28, 0, 28, 0, 11, 28, 11, 28, 25, 28, 25, 28, 25, 28, 25, 28, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 11, 28, 25, 21, 22, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 28, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 21, 22, 21, 22, 25, 21, 22, 25, 28, 25, 28, 25, 28, 0, 28, 0, 28, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 1, 2, 1, 2, 6, 1, 2, 0, 24, 11, 24, 2, 0, 2, 0, 2, 0, 5, 0, 4, 24, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 29, 30, 29, 30, 24, 29, 30, 24, 29, 30, 24, 20, 24, 20, 24, 29, 30, 24, 29, 30, 21, 22, 21, 22, 21, 22, 21, 22, 24, 4, 24, 20, 24, 20, 24, 21, 24, 28, 24, 21, 22, 21, 22, 21, 22, 21, 22, 20, 0, 28, 0, 28, 0, 28, 0, 28, 0, 12, 24, 28, 4, 5, 10, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 28, 21, 22, 21, 22, 21, 22, 21, 22, 20, 21, 22, 28, 10, 6, 8, 20, 4, 28, 10, 4, 5, 24, 28, 0, 5, 0, 6, 27, 4, 5, 20, 5, 24, 4, 5, 0, 5, 0, 5, 0, 28, 11, 28, 5, 28, 0, 5, 28, 0, 11, 28, 11, 28, 11, 28, 11, 28, 11, 28, 5, 28, 5, 4, 5, 0, 28, 0, 5, 4, 24, 5, 4, 24, 5, 9, 5, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 6, 7, 24, 6, 24, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 6, 5, 10, 6, 24, 0, 27, 4, 27, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 27, 1, 2, 1, 2, 5, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 2, 0, 2, 0, 2, 1, 2, 1, 2, 0, 4, 1, 2, 5, 4, 2, 5, 6, 5, 6, 5, 6, 5, 8, 6, 8, 28, 6, 0, 11, 28, 26, 28, 0, 5, 24, 0, 8, 5, 8, 6, 0, 24, 9, 0, 6, 5, 24, 5, 24, 5, 6, 9, 5, 6, 24, 5, 6, 8, 0, 24, 5, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 24, 0, 4, 9, 0, 24, 5, 6, 4, 5, 9, 5, 0, 5, 6, 8, 6, 8, 6, 0, 5, 6, 5, 6, 8, 0, 9, 0, 24, 5, 4, 5, 28, 5, 8, 6, 8, 5, 6, 5, 6, 5, 6, 5, 6, 5, 6, 5, 0, 5, 4, 24, 5, 8, 6, 8, 24, 5, 4, 8, 6, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 2, 27, 4, 2, 4, 27, 0, 2, 5, 8, 6, 8, 6, 8, 24, 8, 6, 0, 9, 0, 5, 0, 5, 0, 5, 0, 19, 18, 5, 0, 5, 0, 2, 0, 2, 0, 5, 6, 5, 25, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 27, 0, 5, 22, 21, 28, 5, 0, 5, 0, 28, 0, 5, 26, 28, 6, 24, 21, 22, 24, 0, 6, 24, 20, 23, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 24, 21, 22, 24, 23, 24, 0, 24, 20, 21, 22, 21, 22, 21, 22, 24, 25, 20, 25, 0, 24, 26, 24, 0, 5, 0, 5, 0, 16, 0, 24, 26, 24, 21, 22, 24, 25, 24, 20, 24, 9, 24, 25, 24, 1, 21, 24, 22, 27, 23, 27, 2, 21, 25, 22, 25, 21, 22, 24, 21, 22, 24, 5, 4, 5, 4, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 26, 25, 27, 28, 26, 0, 28, 25, 28, 0, 16, 28, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 0, 11, 0, 28, 10, 11, 28, 11, 28, 0, 28, 0, 28, 0, 28, 6, 0, 5, 0, 5, 0, 6, 11, 0, 5, 11, 0, 5, 10, 5, 10, 0, 5, 6, 0, 5, 0, 24, 5, 0, 5, 24, 10, 0, 1, 2, 5, 0, 9, 0, 1, 0, 2, 0, 5, 0, 5, 0, 24, 1, 0, 1, 0, 1, 0, 1, 0, 2, 0, 2, 0, 2, 0, 2, 0, 5, 0, 5, 0, 5, 0, 4, 0, 4, 0, 4, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 11, 5, 28, 11, 5, 0, 11, 0, 5, 0, 5, 0, 11, 5, 11, 0, 24, 5, 0, 24, 0, 5, 0, 11, 5, 11, 0, 11, 5, 6, 0, 6, 0, 6, 5, 0, 5, 0, 5, 0, 6, 0, 6, 11, 0, 24, 0, 5, 11, 24, 5, 11, 0, 5, 28, 5, 6, 0, 11, 24, 0, 5, 0, 24, 5, 0, 11, 5, 0, 11, 5, 0, 24, 0, 11, 0, 5, 0, 1, 0, 2, 0, 11, 5, 6, 0, 9, 0, 11, 0, 5, 0, 6, 20, 0, 5, 0, 6, 5, 11, 5, 0, 5, 6, 11, 24, 0, 5, 6, 24, 0, 5, 11, 0, 5, 0, 8, 6, 8, 5, 6, 24, 0, 11, 9, 6, 5, 6, 5, 0, 6, 8, 5, 8, 6, 8, 6, 24, 16, 24, 6, 0, 16, 0, 5, 0, 9, 0, 6, 5, 6, 8, 6, 0, 9, 24, 5, 8, 5, 0, 5, 6, 24, 5, 0, 6, 8, 5, 8, 6, 8, 5, 24, 6, 24, 8, 6, 9, 5, 24, 5, 24, 0, 11, 0, 5, 0, 5, 8, 6, 8, 6, 8, 6, 24, 6, 5, 6, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 24, 0, 5, 6, 8, 6, 0, 9, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 0, 8, 0, 8, 0, 5, 0, 8, 0, 5, 8, 0, 6, 0, 6, 0, 5, 8, 6, 8, 6, 8, 6, 5, 24, 9, 24, 0, 24, 6, 5, 0, 5, 8, 6, 8, 6, 8, 6, 8, 6, 5, 24, 5, 0, 9, 0, 5, 8, 6, 0, 8, 6, 8, 6, 24, 5, 6, 0, 5, 8, 6, 8, 6, 8, 6, 24, 5, 0, 9, 0, 24, 0, 5, 6, 8, 6, 8, 6, 8, 6, 5, 24, 0, 9, 0, 5, 0, 6, 8, 6, 8, 6, 0, 9, 11, 24, 28, 5, 0, 5, 8, 6, 8, 6, 24, 0, 1, 2, 9, 11, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 8, 0, 8, 0, 6, 8, 6, 5, 8, 5, 8, 6, 24, 0, 9, 0, 5, 0, 5, 8, 6, 0, 6, 8, 6, 5, 24, 5, 8, 0, 5, 6, 5, 6, 8, 5, 6, 24, 6, 0, 5, 6, 8, 6, 5, 6, 8, 6, 24, 5, 24, 0, 5, 0, 24, 0, 5, 0, 5, 8, 6, 0, 6, 8, 6, 5, 24, 0, 9, 11, 0, 24, 5, 0, 6, 0, 8, 6, 8, 6, 8, 6, 0, 5, 0, 5, 0, 5, 6, 0, 6, 0, 6, 0, 6, 5, 6, 0, 9, 0, 5, 0, 5, 0, 5, 8, 0, 6, 0, 8, 6, 8, 6, 5, 0, 9, 0, 5, 6, 8, 24, 0, 6, 5, 8, 5, 0, 5, 8, 6, 0, 8, 6, 8, 6, 24, 9, 0, 5, 0, 11, 28, 26, 28, 0, 24, 5, 0, 10, 0, 24, 0, 5, 0, 5, 24, 0, 5, 16, 6, 5, 6, 0, 5, 0, 5, 0, 5, 0, 9, 0, 24, 5, 0, 9, 0, 5, 0, 6, 24, 0, 5, 6, 24, 28, 4, 24, 28, 0, 9, 0, 11, 0, 5, 0, 5, 0, 1, 2, 11, 24, 0, 5, 0, 6, 5, 8, 0, 6, 4, 0, 4, 24, 4, 6, 0, 8, 0, 5, 0, 5, 0, 5, 0, 4, 0, 4, 0, 4, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 28, 6, 24, 16, 0, 6, 0, 6, 0, 28, 0, 28, 0, 28, 0, 28, 8, 6, 28, 8, 16, 6, 28, 6, 28, 6, 28, 0, 28, 6, 28, 0, 11, 0, 11, 0, 28, 0, 11, 0, 1, 2, 1, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 2, 0, 2, 0, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 2, 0, 9, 28, 6, 28, 6, 28, 6, 28, 6, 28, 24, 0, 6, 0, 6, 0, 2, 5, 2, 0, 2, 0, 6, 0, 6, 0, 6, 0, 6, 0, 6, 0, 4, 0, 6, 0, 5, 0, 6, 4, 0, 9, 0, 5, 28, 0, 5, 6, 0, 5, 6, 9, 0, 26, 0, 5, 4, 6, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 11, 6, 0, 1, 2, 6, 4, 0, 9, 0, 24, 0, 11, 28, 11, 26, 11, 0, 11, 28, 11, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 25, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 11, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 27, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 16, 0, 16, 0, 6, 0, 18, 0, 18, 0]));
    $thiz.jl_Character$__f_bitmap$0 = (((2 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_charTypes;
}
function $p_jl_Character$__charTypes__AI($thiz) {
  return (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypes$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypes);
}
function $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas) {
  var acc = $n(deltas).get(0);
  var i = 1;
  var len = $n(deltas).u.length;
  while ((i !== len)) {
    acc = ((acc + $n(deltas).get(i)) | 0);
    $n(deltas).set(i, acc);
    i = ((1 + i) | 0);
  }
  return deltas;
}
function $p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, startOfRangesArray, value, hasEmptyRanges) {
  var i = $m_ju_Arrays$().binarySearch__AI__I__I(startOfRangesArray, value);
  if ((i >= 0)) {
    if (hasEmptyRanges) {
      var j = ((1 + i) | 0);
      while (((j < $n(startOfRangesArray).u.length) && ($n(startOfRangesArray).get(j) === value))) {
        j = ((1 + j) | 0);
      }
      return j;
    } else {
      return ((1 + i) | 0);
    }
  } else {
    return (~i);
  }
}
function $p_jl_Character$__isSeparator$1__I__Z($thiz, tpe) {
  return (((((tpe - 12) | 0) >>> 0) <= 1) || (tpe === 14));
}
/** @constructor */
function $c_jl_Character$() {
  this.jl_Character$__f_charTypeIndices = null;
  this.jl_Character$__f_charTypes = null;
  this.jl_Character$__f_java$lang$Character$$charTypesFirst256 = null;
  this.jl_Character$__f_nonASCIIZeroDigitCodePoints = null;
  this.jl_Character$__f_bitmap$0 = 0;
  $n_jl_Character$ = this;
  this.jl_Character$__f_java$lang$Character$$charTypesFirst256 = new $ac_I(new Int32Array([15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 24, 24, 26, 24, 24, 24, 21, 22, 24, 25, 24, 20, 24, 24, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 24, 24, 25, 25, 25, 24, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 21, 24, 22, 27, 23, 27, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 21, 25, 22, 25, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 26, 26, 26, 26, 28, 24, 27, 28, 5, 29, 25, 16, 28, 27, 28, 25, 11, 11, 27, 2, 24, 24, 27, 11, 5, 30, 11, 11, 11, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 25, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 25, 2, 2, 2, 2, 2, 2, 2, 2]));
  this.jl_Character$__f_nonASCIIZeroDigitCodePoints = new $ac_I(new Int32Array([1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3558, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43504, 43600, 44016, 65296, 66720, 68912, 69734, 69872, 69942, 70096, 70384, 70736, 70864, 71248, 71360, 71472, 71904, 72016, 72784, 73040, 73120, 73552, 92768, 92864, 93008, 120782, 120792, 120802, 120812, 120822, 123200, 123632, 124144, 125264, 130032]));
}
$c_jl_Character$.prototype = new $h_O();
$c_jl_Character$.prototype.constructor = $c_jl_Character$;
/** @constructor */
function $h_jl_Character$() {
}
$h_jl_Character$.prototype = $c_jl_Character$.prototype;
$c_jl_Character$.prototype.toString__I__T = (function(codePoint) {
  if (((codePoint >>> 0) > 1114111)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  return $as_T(String.fromCodePoint(codePoint));
});
$c_jl_Character$.prototype.getType__I__I = (function(codePoint) {
  return ((codePoint < 0) ? 0 : ((codePoint < 256) ? $n(this.jl_Character$__f_java$lang$Character$$charTypesFirst256).get(codePoint) : $p_jl_Character$__getTypeGE256__I__I(this, codePoint)));
});
$c_jl_Character$.prototype.digitWithValidRadix__I__I__I = (function(codePoint, radix) {
  if ((codePoint < 256)) {
    var value = (((((codePoint - 48) | 0) >>> 0) <= 9) ? ((codePoint - 48) | 0) : (((((codePoint - 65) | 0) >>> 0) <= 25) ? ((codePoint - 55) | 0) : (((((codePoint - 97) | 0) >>> 0) <= 25) ? ((codePoint - 87) | 0) : (-1))));
  } else if (((((codePoint - 65313) | 0) >>> 0) <= 25)) {
    var value = ((codePoint - 65303) | 0);
  } else if (((((codePoint - 65345) | 0) >>> 0) <= 25)) {
    var value = ((codePoint - 65335) | 0);
  } else {
    var p = $m_ju_Arrays$().binarySearch__AI__I__I(this.jl_Character$__f_nonASCIIZeroDigitCodePoints, codePoint);
    var zeroCodePointIndex = ((p < 0) ? (((-2) - p) | 0) : p);
    if ((zeroCodePointIndex < 0)) {
      var value = (-1);
    } else {
      var v = ((codePoint - $n(this.jl_Character$__f_nonASCIIZeroDigitCodePoints).get(zeroCodePointIndex)) | 0);
      var value = ((v > 9) ? (-1) : v);
    }
  }
  return ((value < radix) ? value : (-1));
});
$c_jl_Character$.prototype.isZeroDigit__C__Z = (function(ch) {
  return ((ch < 256) ? (ch === 48) : ($m_ju_Arrays$().binarySearch__AI__I__I(this.jl_Character$__f_nonASCIIZeroDigitCodePoints, ch) >= 0));
});
$c_jl_Character$.prototype.forDigit__I__I__C = (function(digit, radix) {
  if ((((((radix - 2) | 0) >>> 0) > 34) || ((digit >>> 0) >= (radix >>> 0)))) {
    return 0;
  } else {
    var overBaseTen = ((digit - 10) | 0);
    var result = ((overBaseTen < 0) ? ((48 + digit) | 0) : ((97 + overBaseTen) | 0));
    return (65535 & result);
  }
});
$c_jl_Character$.prototype.isISOControl__I__Z = (function(codePoint) {
  return (((codePoint >>> 0) <= 31) || ((((codePoint - 127) | 0) >>> 0) <= 32));
});
$c_jl_Character$.prototype.isWhitespace__I__Z = (function(codePoint) {
  return ((codePoint < 256) ? (((((((((codePoint - 9) | 0) >>> 0) <= 1) || (codePoint === 11)) || (codePoint === 12)) || (codePoint === 13)) || ((((codePoint - 28) | 0) >>> 0) <= 3)) || ((codePoint !== 160) && $p_jl_Character$__isSeparator$1__I__Z(this, $n(this.jl_Character$__f_java$lang$Character$$charTypesFirst256).get(codePoint)))) : (((codePoint !== 8199) && (codePoint !== 8239)) && $p_jl_Character$__isSeparator$1__I__Z(this, $p_jl_Character$__getTypeGE256__I__I(this, codePoint))));
});
$c_jl_Character$.prototype.isDigit__I__Z = (function(cp) {
  if ((cp < 256)) {
    return ((((cp - 48) | 0) >>> 0) <= 9);
  } else {
    var tpe = $p_jl_Character$__getTypeGE256__I__I(this, cp);
    return (tpe === 9);
  }
});
$c_jl_Character$.prototype.isLetter__I__Z = (function(cp) {
  var tpe = this.getType__I__I(cp);
  return (((((((tpe - 1) | 0) >>> 0) <= 1) || (tpe === 3)) || (tpe === 4)) || (tpe === 5));
});
$c_jl_Character$.prototype.toUpperCase__C__C = (function(ch) {
  return (65535 & this.toUpperCase__I__I(ch));
});
$c_jl_Character$.prototype.toUpperCase__I__I = (function(codePoint) {
  switch (codePoint) {
    case 8115:
    case 8131:
    case 8179: {
      return ((9 + codePoint) | 0);
      break;
    }
    default: {
      if (((((codePoint - 8064) | 0) >>> 0) <= 47)) {
        return (8 | codePoint);
      } else {
        var this$1 = $n(this.toString__I__T(codePoint));
        var upperChars = $as_T(this$1.toUpperCase());
        var this$2 = $n(upperChars);
        var x1$2 = this$2.length;
        switch (x1$2) {
          case 1: {
            var this$3 = $n(upperChars);
            return $charAt(this$3, 0);
            break;
          }
          case 2: {
            var this$4 = $n(upperChars);
            var high = $charAt(this$4, 0);
            var this$5 = $n(upperChars);
            var low = $charAt(this$5, 1);
            return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
            break;
          }
          default: {
            return codePoint;
          }
        }
      }
    }
  }
});
$c_jl_Character$.prototype.toLowerCase__I__I = (function(codePoint) {
  if ((codePoint === 304)) {
    return 105;
  } else {
    var this$1 = $n(this.toString__I__T(codePoint));
    var lowerChars = $as_T(this$1.toLowerCase());
    var this$2 = $n(lowerChars);
    var x1$2 = this$2.length;
    switch (x1$2) {
      case 1: {
        var this$3 = $n(lowerChars);
        return $charAt(this$3, 0);
        break;
      }
      case 2: {
        var this$4 = $n(lowerChars);
        var high = $charAt(this$4, 0);
        var this$5 = $n(lowerChars);
        var low = $charAt(this$5, 1);
        return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
        break;
      }
      default: {
        return codePoint;
      }
    }
  }
});
var $d_jl_Character$ = new $TypeData().initClass($c_jl_Character$, "java.lang.Character$", ({
  jl_Character$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Character$;
function $m_jl_Character$() {
  if ((!$n_jl_Character$)) {
    $n_jl_Character$ = new $c_jl_Character$();
  }
  return $n_jl_Character$;
}
function $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrPat = new RegExp("^[\\x00-\\x20]*([+-]?(?:NaN|Infinity|(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((1 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Double$__f_doubleStrPat;
}
function $p_jl_Double$__doubleStrPat__O($thiz) {
  return (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrPat);
}
function $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrHexPat = new RegExp("^[\\x00-\\x20]*([+-]?)0[xX]([0-9A-Fa-f]*)\\.?([0-9A-Fa-f]*)[pP]([+-]?\\d+)[fFdD]?[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((2 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Double$__f_doubleStrHexPat;
}
function $p_jl_Double$__doubleStrHexPat__O($thiz) {
  return (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrHexPat);
}
function $p_jl_Double$__parseDoubleSlowPath__T__D($thiz, s) {
  var groups = $p_jl_Double$__doubleStrHexPat__O($thiz).exec(s);
  if ((groups === null)) {
    $ps_jl_Double$__fail$1__T__E(s);
  }
  var x = groups[1];
  var signStr = $as_T(x);
  var x$1 = groups[2];
  var integralPartStr = $as_T(x$1);
  var x$2 = groups[3];
  var fractionalPartStr = $as_T(x$2);
  var x$3 = groups[4];
  var binaryExpStr = $as_T(x$3);
  if (((integralPartStr === "") && (fractionalPartStr === ""))) {
    $ps_jl_Double$__fail$1__T__E(s);
  }
  var absResult = $thiz.parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 15);
  return ((signStr === "-") ? (-absResult) : absResult);
}
function $ps_jl_Double$__fail$1__T__E(s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""));
}
/** @constructor */
function $c_jl_Double$() {
  this.jl_Double$__f_doubleStrPat = null;
  this.jl_Double$__f_doubleStrHexPat = null;
  this.jl_Double$__f_bitmap$0 = 0;
}
$c_jl_Double$.prototype = new $h_O();
$c_jl_Double$.prototype.constructor = $c_jl_Double$;
/** @constructor */
function $h_jl_Double$() {
}
$h_jl_Double$.prototype = $c_jl_Double$.prototype;
$c_jl_Double$.prototype.parseDouble__T__D = (function(s) {
  var groups = $p_jl_Double$__doubleStrPat__O(this).exec(s);
  if ((groups !== null)) {
    var $x_2 = parseFloat;
    var x = groups[1];
    var $x_1 = $x_2($as_T(x));
    return $uD($x_1);
  } else {
    return $p_jl_Double$__parseDoubleSlowPath__T__D(this, s);
  }
});
$c_jl_Double$.prototype.parseHexDoubleImpl__T__T__T__I__D = (function(integralPartStr, fractionalPartStr, binaryExpStr, maxPrecisionChars) {
  var mantissaStr0 = (("" + integralPartStr) + fractionalPartStr);
  var this$1 = $n(fractionalPartStr);
  var correction1 = ((-(this$1.length << 2)) | 0);
  var limit = ((mantissaStr0.length - 1) | 0);
  var i = 0;
  while (true) {
    if ((i !== limit)) {
      var index = i;
      var $x_1 = ($charAt(mantissaStr0, index) === 48);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      i = ((1 + i) | 0);
    } else {
      break;
    }
  }
  var beginIndex = i;
  if (((beginIndex < 0) || (beginIndex > mantissaStr0.length))) {
    $charAt(mantissaStr0, beginIndex);
  }
  var mantissaStr = $as_T(mantissaStr0.substring(beginIndex));
  var this$2 = $n(mantissaStr);
  var mantissaStrLen = this$2.length;
  var needsCorrection2 = (mantissaStrLen > maxPrecisionChars);
  if (needsCorrection2) {
    var hasNonZeroChar = false;
    var j = maxPrecisionChars;
    while (((!hasNonZeroChar) && (j !== mantissaStrLen))) {
      var this$3 = $n(mantissaStr);
      var index$1 = j;
      if (($charAt(this$3, index$1) !== 48)) {
        hasNonZeroChar = true;
      }
      j = ((1 + j) | 0);
    }
    var compressedTail = (hasNonZeroChar ? "1" : "0");
    var this$4 = $n(mantissaStr);
    if ((maxPrecisionChars > this$4.length)) {
      $charAt(this$4, maxPrecisionChars);
    }
    if ((maxPrecisionChars < 0)) {
      $charAt(this$4, (-1));
    }
    var truncatedMantissaStr = ($as_T(this$4.substring(0, maxPrecisionChars)) + compressedTail);
  } else {
    var truncatedMantissaStr = mantissaStr;
  }
  if (needsCorrection2) {
    var this$5 = $n(mantissaStr);
    var correction2 = (((this$5.length - ((1 + maxPrecisionChars) | 0)) | 0) << 2);
  } else {
    var correction2 = 0;
  }
  var fullCorrection = ((correction1 + correction2) | 0);
  var mantissa = $uD(parseInt(truncatedMantissaStr, 16));
  var binaryExpDouble = $uD(parseInt(binaryExpStr, 10));
  var binaryExp = $doubleToInt(binaryExpDouble);
  return $m_jl_Math$().scalb__D__I__D(mantissa, ((binaryExp + fullCorrection) | 0));
});
$c_jl_Double$.prototype.compare__D__D__I = (function(a, b) {
  if ((a !== a)) {
    return ((b !== b) ? 0 : 1);
  } else if ((b !== b)) {
    return (-1);
  } else if ((a === b)) {
    if ((a === 0.0)) {
      var ainf = (1.0 / a);
      return ((ainf === (1.0 / b)) ? 0 : ((ainf < 0.0) ? (-1) : 1));
    } else {
      return 0;
    }
  } else {
    return ((a < b) ? (-1) : 1);
  }
});
var $d_jl_Double$ = new $TypeData().initClass($c_jl_Double$, "java.lang.Double$", ({
  jl_Double$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Double$;
function $m_jl_Double$() {
  if ((!$n_jl_Double$)) {
    $n_jl_Double$ = new $c_jl_Double$();
  }
  return $n_jl_Double$;
}
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.jl_Float$__f_bitmap$0)) {
    $thiz.jl_Float$__f_parseFloatRegExp = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Float$__f_bitmap$0 = true;
  }
  return $thiz.jl_Float$__f_parseFloatRegExp;
}
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.jl_Float$__f_bitmap$0) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.jl_Float$__f_parseFloatRegExp);
}
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = $uD(parseFloat(fullNumberStr));
  var z = Math.fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z;
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z);
  } else if ((zDouble < z0)) {
    var zUp = $m_jl_Math$().nextUp__F__F(z);
    var mid$2 = (0.5 * (zDouble + zUp));
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z);
  } else {
    var zDown = $m_jl_Math$().nextDown__F__F(z);
    var mid$3 = (0.5 * (zDouble + zDown));
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z);
  }
}
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var str = (("" + integralPartStr) + fractionalPartStr);
  var f = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), str);
  var this$1 = $m_jl_Integer$();
  var $x_1 = this$1.java$lang$Integer$$parseIntImpl__T__I__I__I(exponentStr, 10, 214748364);
  var this$2 = $n(fractionalPartStr);
  var e = (($x_1 - this$2.length) | 0);
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setFloat64(0, mid, true);
  var lo = $uI(fpBitsDataView.getInt32(0, true));
  var hi = $uI(fpBitsDataView.getInt32(4, true));
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw new $c_jl_AssertionError(("parseFloatCorrection was given a subnormal mid: " + mid));
  }
  var hi$2 = (1048575 & hi);
  var hi$3 = (1048576 | hi$2);
  var m = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(lo, hi$3);
  var k = ((lo$1 - 1075) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e));
      var y = $n(m).shiftLeft__I__Ljava_math_BigInteger(k);
      var cmp = $n(x).compareTo__Ljava_math_BigInteger__I(y);
    } else {
      var v = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e));
      var e$1 = ((-k) | 0);
      var x$1 = $n(v).shiftLeft__I__Ljava_math_BigInteger(e$1);
      var cmp = $n(x$1).compareTo__Ljava_math_BigInteger__I(m);
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var v$1 = $n(m).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e$2));
    var y$1 = $n(v$1).shiftLeft__I__Ljava_math_BigInteger(k);
    var cmp = f.compareTo__Ljava_math_BigInteger__I(y$1);
  } else {
    var e$3 = ((-k) | 0);
    var x$2 = f.shiftLeft__I__Ljava_math_BigInteger(e$3);
    var e$4 = ((-e) | 0);
    var y$2 = $n(m).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN).pow__I__Ljava_math_BigInteger(e$4));
    var cmp = $n(x$2).compareTo__Ljava_math_BigInteger__I(y$2);
  }
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $floatToBits(zDown)) === 0) ? zDown : zUp)));
}
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  var doubleValue = $m_jl_Double$().parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 7);
  return Math.fround(doubleValue);
}
/** @constructor */
function $c_jl_Float$() {
  this.jl_Float$__f_parseFloatRegExp = null;
  this.jl_Float$__f_bitmap$0 = false;
}
$c_jl_Float$.prototype = new $h_O();
$c_jl_Float$.prototype.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
}
$h_jl_Float$.prototype = $c_jl_Float$.prototype;
$c_jl_Float$.prototype.parseFloat__T__F = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
  }
  var x = groups[2];
  if ((x !== (void 0))) {
    var absResult = (NaN);
  } else {
    var x$1 = groups[3];
    if ((x$1 !== (void 0))) {
      var absResult = Infinity;
    } else {
      var x$2 = groups[4];
      if ((x$2 !== (void 0))) {
        var x$3 = groups[4];
        var fullNumberStr = $as_T(x$3);
        var x$4 = groups[5];
        var integralPartStr = $as_T(((x$4 !== (void 0)) ? x$4 : ""));
        var x$5 = groups[6];
        var $x_1 = $as_T(((x$5 !== (void 0)) ? x$5 : ""));
        var x$6 = groups[7];
        var fractionalPartStr = (("" + $x_1) + ((x$6 !== (void 0)) ? x$6 : ""));
        var x$7 = groups[8];
        var exponentStr = $as_T(((x$7 !== (void 0)) ? x$7 : "0"));
        var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr);
      } else {
        var x$8 = groups[10];
        var integralPartStr$2 = $as_T(((x$8 !== (void 0)) ? x$8 : ""));
        var x$9 = groups[11];
        var $x_2 = $as_T(((x$9 !== (void 0)) ? x$9 : ""));
        var x$10 = groups[12];
        var fractionalPartStr$2 = (("" + $x_2) + ((x$10 !== (void 0)) ? x$10 : ""));
        var x$11 = groups[13];
        var binaryExpStr = $as_T(x$11);
        var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, integralPartStr$2, fractionalPartStr$2, binaryExpStr);
      }
    }
  }
  var x$12 = groups[1];
  var signStr = $as_T(x$12);
  return ((signStr === "-") ? Math.fround((-absResult)) : absResult);
});
var $d_jl_Float$ = new $TypeData().initClass($c_jl_Float$, "java.lang.Float$", ({
  jl_Float$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$();
  }
  return $n_jl_Float$;
}
/** @constructor */
function $c_jl_Integer$() {
}
$c_jl_Integer$.prototype = new $h_O();
$c_jl_Integer$.prototype.constructor = $c_jl_Integer$;
/** @constructor */
function $h_jl_Integer$() {
}
$h_jl_Integer$.prototype = $c_jl_Integer$.prototype;
$c_jl_Integer$.prototype.parseIntFail__T__E = (function(s) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
});
$c_jl_Integer$.prototype.java$lang$Integer$$parseIntImpl__T__I__I__I = (function(s, radix, overflowBarrier) {
  if ((s === null)) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var this$3 = $n(s);
  var len = this$3.length;
  if ((len === 0)) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var character = $m_jl_Character$();
  var this$5 = $n(s);
  var firstChar = $charAt(this$5, 0);
  var negative = (firstChar === 45);
  var sign = (negative ? (-1) : 0);
  var i = ((negative || (firstChar === 43)) ? 1 : 0);
  if ((i >= len)) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var java$lang$IntFloatBits$Int32Box$$value = 0;
  java$lang$IntFloatBits$Int32Box$$value = 0;
  while ((i !== len)) {
    var this$7 = $n(s);
    var index = i;
    var x = character.digitWithValidRadix__I__I__I($charAt(this$7, index), radix);
    if ((x < 0)) {
      var $x_1 = true;
    } else {
      var x$1 = java$lang$IntFloatBits$Int32Box$$value;
      var $x_1 = ((x$1 >>> 0) > (overflowBarrier >>> 0));
    }
    if ($x_1) {
      $m_jl_Integer$().parseIntFail__T__E(s);
    }
    var x$2 = java$lang$IntFloatBits$Int32Box$$value;
    var x$3 = Math.imul(x$2, radix);
    var v = ((x$3 + x) | 0);
    java$lang$IntFloatBits$Int32Box$$value = v;
    i = ((1 + i) | 0);
  }
  var x$4 = java$lang$IntFloatBits$Int32Box$$value;
  var y = ((2147483647 - sign) | 0);
  if (((x$4 >>> 0) > (y >>> 0))) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var x$5 = java$lang$IntFloatBits$Int32Box$$value;
  var x$6 = (x$5 ^ sign);
  return ((x$6 - sign) | 0);
});
$c_jl_Integer$.prototype.bitCount__I__I = (function(i) {
  var t1 = ((i - (1431655765 & (i >> 1))) | 0);
  var t2 = (((858993459 & t1) + (858993459 & (t1 >> 2))) | 0);
  return (Math.imul(16843009, (252645135 & ((t2 + (t2 >> 4)) | 0))) >> 24);
});
var $d_jl_Integer$ = new $TypeData().initClass($c_jl_Integer$, "java.lang.Integer$", ({
  jl_Integer$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Integer$;
function $m_jl_Integer$() {
  if ((!$n_jl_Integer$)) {
    $n_jl_Integer$ = new $c_jl_Integer$();
  }
  return $n_jl_Integer$;
}
function $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O($thiz) {
  if ((!$thiz.jl_Long$__f_bitmap$0)) {
    var r = [];
    var i = 0;
    while ((i < 2)) {
      r.push(null);
      i = ((1 + i) | 0);
    }
    var i$1 = 2;
    while ((i$1 <= 36)) {
      var value$1 = i$1;
      var barrier = ((1073741824 / ($checkIntDivisor(value$1) >>> 0)) | 0);
      var radixPowLength = value$1;
      var chunkLength = 1;
      var paddingZeros = "0";
      while ((radixPowLength <= barrier)) {
        radixPowLength = Math.imul(radixPowLength, value$1);
        chunkLength = ((1 + chunkLength) | 0);
        paddingZeros = (paddingZeros + "0");
      }
      var x = radixPowLength;
      var this$9 = $m_RTLong$();
      var $x_1 = this$9.divideUnsignedImpl__I__I__I__I__J((-1), (-1), x, 0);
      var overflowBarrier_$_lo = $x_1.l;
      var overflowBarrier_$_hi = $x_1.h;
      r.push(new $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, (1.0 / radixPowLength), paddingZeros, overflowBarrier_$_lo, overflowBarrier_$_hi));
      i$1 = ((1 + i$1) | 0);
    }
    $thiz.jl_Long$__f_java$lang$Long$$StringRadixInfos = r;
    $thiz.jl_Long$__f_bitmap$0 = true;
  }
  return $thiz.jl_Long$__f_java$lang$Long$$StringRadixInfos;
}
function $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I($thiz, chunkStart, chunkEnd, s$1, radix$1) {
  var result = 0;
  var i = chunkStart;
  while ((i !== chunkEnd)) {
    var $x_1 = $m_jl_Character$();
    var this$1 = $n(s$1);
    var index = i;
    var digit = $x_1.digitWithValidRadix__I__I__I($charAt(this$1, index), radix$1);
    if ((digit === (-1))) {
      $m_jl_Integer$().parseIntFail__T__E(s$1);
    }
    result = ((Math.imul(result, radix$1) + digit) | 0);
    i = ((1 + i) | 0);
  }
  return result;
}
/** @constructor */
function $c_jl_Long$() {
  this.jl_Long$__f_java$lang$Long$$StringRadixInfos = null;
  this.jl_Long$__f_bitmap$0 = false;
}
$c_jl_Long$.prototype = new $h_O();
$c_jl_Long$.prototype.constructor = $c_jl_Long$;
/** @constructor */
function $h_jl_Long$() {
}
$h_jl_Long$.prototype = $c_jl_Long$.prototype;
$c_jl_Long$.prototype.java$lang$Long$$StringRadixInfos__O = (function() {
  return ((!this.jl_Long$__f_bitmap$0) ? $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O(this) : this.jl_Long$__f_java$lang$Long$$StringRadixInfos);
});
$c_jl_Long$.prototype.java$lang$Long$$toStringImplJS__J__I__T = (function(i_$_lo, i_$_hi, radix) {
  if (((i_$_lo >> 31) === i_$_hi)) {
    return $as_T(i_$_lo.toString(radix));
  } else if ((((-2097152) & (i_$_hi ^ (i_$_hi >> 10))) === 0)) {
    return $as_T(((4.294967296E9 * i_$_hi) + (i_$_lo >>> 0.0)).toString(radix));
  } else {
    var sign = (i_$_hi >> 31);
    var xlo = (i_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((i_$_hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var radixInfo = $as_jl_Long$StringRadixInfo(this.java$lang$Long$$StringRadixInfos__O()[radix]);
    var divisor = $n(radixInfo).jl_Long$StringRadixInfo__f_radixPowLength;
    var divisorInv = $n(radixInfo).jl_Long$StringRadixInfo__f_radixPowLengthInverse;
    var paddingZeros = $n(radixInfo).jl_Long$StringRadixInfo__f_paddingZeros;
    var approxNum = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var a = (approxNum * divisorInv);
    var approxQuot = $uD(Math.floor(a));
    var n = approxQuot;
    var approxRem = ((rlo - Math.imul(divisor, (n | 0.0))) | 0);
    if ((approxRem < 0)) {
      approxQuot = (approxQuot - 1.0);
      approxRem = ((approxRem + divisor) | 0);
    } else if ((approxRem >= divisor)) {
      approxQuot = (approxQuot + 1.0);
      approxRem = ((approxRem - divisor) | 0);
    }
    var remStr = $as_T(approxRem.toString(radix));
    var $x_2 = $as_T(approxQuot.toString(radix));
    var this$16 = $n(remStr);
    var $x_1 = paddingZeros.substring(this$16.length);
    var s = ((("" + $x_2) + $as_T($x_1)) + remStr);
    return ((i_$_hi < 0) ? ("-" + s) : s);
  }
});
$c_jl_Long$.prototype.parseLongImplJS__T__I__J = (function(s, radix) {
  if ((s === "")) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var start = 0;
  var neg = false;
  var this$1 = $n(s);
  var x1 = $charAt(this$1, 0);
  switch (x1) {
    case 43: {
      start = 1;
      break;
    }
    case 45: {
      start = 1;
      neg = true;
      break;
    }
  }
  var $x_1 = this.parseUnsignedLongJSInternal__T__I__I__J(s, radix, start);
  var unsignedResult_$_lo = $x_1.l;
  var unsignedResult_$_hi = $x_1.h;
  if (neg) {
    var lo = ((-unsignedResult_$_lo) | 0);
    var hi = ((((-unsignedResult_$_hi) | 0) + ((unsignedResult_$_lo | lo) >> 31)) | 0);
    if (((hi === 0) ? (lo !== 0) : (hi > 0))) {
      $m_jl_Integer$().parseIntFail__T__E(s);
    }
    return $bL(lo, hi);
  } else {
    if ((unsignedResult_$_hi < 0)) {
      $m_jl_Integer$().parseIntFail__T__E(s);
    }
    return $bL(unsignedResult_$_lo, unsignedResult_$_hi);
  }
});
$c_jl_Long$.prototype.parseUnsignedLongJSInternal__T__I__I__J = (function(s, radix, start) {
  var this$1 = $n(s);
  var length = this$1.length;
  if ((start >= length)) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  } else {
    var radixInfo = $as_jl_Long$StringRadixInfo(this.java$lang$Long$$StringRadixInfos__O()[radix]);
    var chunkLen = $n(radixInfo).jl_Long$StringRadixInfo__f_chunkLength;
    var firstChunkStart = start;
    while (true) {
      if ((firstChunkStart < length)) {
        var $x_2 = $m_jl_Character$();
        var this$2 = $n(s);
        var index = firstChunkStart;
        var $x_1 = $x_2.isZeroDigit__C__Z($charAt(this$2, index));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        firstChunkStart = ((1 + firstChunkStart) | 0);
      } else {
        break;
      }
    }
    if ((((length - firstChunkStart) | 0) > Math.imul(3, chunkLen))) {
      $m_jl_Integer$().parseIntFail__T__E(s);
    }
    var firstChunkLength = ((1 + ((((((length - firstChunkStart) | 0) - 1) | 0) % $checkIntDivisor(chunkLen)) | 0)) | 0);
    var firstChunkEnd = ((firstChunkStart + firstChunkLength) | 0);
    var chunkStart = firstChunkStart;
    var x = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, chunkStart, firstChunkEnd, s, radix);
    if ((firstChunkEnd === length)) {
      return $bL(x, 0);
    } else {
      var x$1 = $n(radixInfo).jl_Long$StringRadixInfo__f_radixPowLength;
      var secondChunkEnd = ((firstChunkEnd + chunkLen) | 0);
      var a0 = (65535 & x);
      var a1 = ((x >>> 16) | 0);
      var b0 = (65535 & x$1);
      var b1 = ((x$1 >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var x$2 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, firstChunkEnd, secondChunkEnd, s, radix);
      var lo$1 = ((lo + x$2) | 0);
      var hi$1 = ((hi + ((((lo & x$2) | ((lo | x$2) & (~lo$1))) >>> 31) | 0)) | 0);
      if ((secondChunkEnd === length)) {
        return $bL(lo$1, hi$1);
      } else {
        var overflowBarrier_$_lo = $n(radixInfo).jl_Long$StringRadixInfo__f_overflowBarrier_$lo;
        var overflowBarrier_$_hi = $n(radixInfo).jl_Long$StringRadixInfo__f_overflowBarrier_$hi;
        var x$3 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, secondChunkEnd, length, s, radix);
        if (((hi$1 === overflowBarrier_$_hi) ? ((lo$1 >>> 0) > (overflowBarrier_$_lo >>> 0)) : (hi$1 > overflowBarrier_$_hi))) {
          $m_jl_Integer$().parseIntFail__T__E(s);
        }
        var a0$1 = (65535 & lo$1);
        var a1$1 = ((lo$1 >>> 16) | 0);
        var b0$1 = (65535 & x$1);
        var b1$1 = ((x$1 >>> 16) | 0);
        var a0b0$1 = Math.imul(a0$1, b0$1);
        var a1b0$1 = Math.imul(a1$1, b0$1);
        var a0b1$1 = Math.imul(a0$1, b1$1);
        var lo$2 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$2 = ((((((Math.imul(hi$1, x$1) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$3 = ((lo$2 + x$3) | 0);
        var hi$3 = ((hi$2 + ((((lo$2 & x$3) | ((lo$2 | x$3) & (~lo$3))) >>> 31) | 0)) | 0);
        if (((hi$3 === 0) && ((lo$3 >>> 0) < (x$3 >>> 0)))) {
          $m_jl_Integer$().parseIntFail__T__E(s);
        }
        return $bL(lo$3, hi$3);
      }
    }
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toHexString__I__I__T = (function(lo, hi) {
  if ((hi !== 0)) {
    var $x_1 = $as_T((hi >>> 0.0).toString(16));
    var s = $as_T((lo >>> 0.0).toString(16));
    var this$7 = $n(s);
    var beginIndex = this$7.length;
    if (((beginIndex >>> 0) > 8)) {
      $charAt("00000000", beginIndex);
    }
    return ($x_1 + (("" + $as_T("00000000".substring(beginIndex))) + s));
  } else {
    return $as_T((lo >>> 0.0).toString(16));
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toOctalString__I__I__T = (function(lo, hi) {
  var lp = (1073741823 & lo);
  var mp = (1073741823 & ((((lo >>> 30) | 0) + (hi << 2)) | 0));
  var hp = ((hi >>> 28) | 0);
  if ((hp !== 0)) {
    var $x_2 = $as_T((hp >>> 0.0).toString(8));
    var s = $as_T((mp >>> 0.0).toString(8));
    var this$7 = $n(s);
    var beginIndex = this$7.length;
    if (((beginIndex >>> 0) > 10)) {
      $charAt("0000000000", beginIndex);
    }
    var $x_1 = $as_T("0000000000".substring(beginIndex));
    var s$1 = $as_T((lp >>> 0.0).toString(8));
    var this$11 = $n(s$1);
    var beginIndex$1 = this$11.length;
    if (((beginIndex$1 >>> 0) > 10)) {
      $charAt("0000000000", beginIndex$1);
    }
    return (($x_2 + (("" + $x_1) + s)) + (("" + $as_T("0000000000".substring(beginIndex$1))) + s$1));
  } else if ((mp !== 0)) {
    var $x_3 = $as_T((mp >>> 0.0).toString(8));
    var s$2 = $as_T((lp >>> 0.0).toString(8));
    var this$18 = $n(s$2);
    var beginIndex$2 = this$18.length;
    if (((beginIndex$2 >>> 0) > 10)) {
      $charAt("0000000000", beginIndex$2);
    }
    return ($x_3 + (("" + $as_T("0000000000".substring(beginIndex$2))) + s$2));
  } else {
    return $as_T((lp >>> 0.0).toString(8));
  }
});
var $d_jl_Long$ = new $TypeData().initClass($c_jl_Long$, "java.lang.Long$", ({
  jl_Long$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_Long$;
function $m_jl_Long$() {
  if ((!$n_jl_Long$)) {
    $n_jl_Long$ = new $c_jl_Long$();
  }
  return $n_jl_Long$;
}
/** @constructor */
function $c_jl_Number() {
}
$c_jl_Number.prototype = new $h_O();
$c_jl_Number.prototype.constructor = $c_jl_Number;
/** @constructor */
function $h_jl_Number() {
}
$h_jl_Number.prototype = $c_jl_Number.prototype;
function $is_jl_Number(obj) {
  return (((obj instanceof $c_jl_Number) || ((typeof obj) === "number")) || (obj instanceof $Long));
}
function $as_jl_Number(obj) {
  return (($is_jl_Number(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Number"));
}
function $isArrayOf_jl_Number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Number)));
}
function $asArrayOf_jl_Number(obj, depth) {
  return (($isArrayOf_jl_Number(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Number;", depth));
}
function $ct_jl_StackTraceElement__T__T__T__I__I__($thiz, declaringClass, methodName, fileName, lineNumber, columnNumber) {
  $thiz.jl_StackTraceElement__f_declaringClass = declaringClass;
  $thiz.jl_StackTraceElement__f_methodName = methodName;
  $thiz.jl_StackTraceElement__f_fileName = fileName;
  $thiz.jl_StackTraceElement__f_lineNumber = lineNumber;
  $thiz.jl_StackTraceElement__f_columnNumber = columnNumber;
  return $thiz;
}
function $ct_jl_StackTraceElement__T__T__T__I__($thiz, declaringClass, methodName, fileName, lineNumber) {
  $ct_jl_StackTraceElement__T__T__T__I__I__($thiz, declaringClass, methodName, fileName, lineNumber, (-1));
  return $thiz;
}
/** @constructor */
function $c_jl_StackTraceElement() {
  this.jl_StackTraceElement__f_declaringClass = null;
  this.jl_StackTraceElement__f_methodName = null;
  this.jl_StackTraceElement__f_fileName = null;
  this.jl_StackTraceElement__f_lineNumber = 0;
  this.jl_StackTraceElement__f_columnNumber = 0;
}
$c_jl_StackTraceElement.prototype = new $h_O();
$c_jl_StackTraceElement.prototype.constructor = $c_jl_StackTraceElement;
/** @constructor */
function $h_jl_StackTraceElement() {
}
$h_jl_StackTraceElement.prototype = $c_jl_StackTraceElement.prototype;
$c_jl_StackTraceElement.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_jl_StackTraceElement)) {
    var x2 = $as_jl_StackTraceElement(that);
    return (((((this.jl_StackTraceElement__f_fileName === $n(x2).jl_StackTraceElement__f_fileName) && (this.jl_StackTraceElement__f_lineNumber === $n(x2).jl_StackTraceElement__f_lineNumber)) && (this.jl_StackTraceElement__f_columnNumber === $n(x2).jl_StackTraceElement__f_columnNumber)) && (this.jl_StackTraceElement__f_declaringClass === $n(x2).jl_StackTraceElement__f_declaringClass)) && (this.jl_StackTraceElement__f_methodName === $n(x2).jl_StackTraceElement__f_methodName));
  } else {
    return false;
  }
});
$c_jl_StackTraceElement.prototype.toString__T = (function() {
  var result = "";
  if ((this.jl_StackTraceElement__f_declaringClass !== "<jscode>")) {
    result = ((("" + result) + this.jl_StackTraceElement__f_declaringClass) + ".");
  }
  result = (("" + result) + this.jl_StackTraceElement__f_methodName);
  if ((this.jl_StackTraceElement__f_fileName === null)) {
    result = (result + "(Unknown Source)");
  } else {
    result = ((result + "(") + this.jl_StackTraceElement__f_fileName);
    if ((this.jl_StackTraceElement__f_lineNumber >= 0)) {
      result = ((result + ":") + this.jl_StackTraceElement__f_lineNumber);
      if ((this.jl_StackTraceElement__f_columnNumber >= 0)) {
        result = ((result + ":") + this.jl_StackTraceElement__f_columnNumber);
      }
    }
    result = (result + ")");
  }
  return result;
});
$c_jl_StackTraceElement.prototype.hashCode__I = (function() {
  return (((($f_T__hashCode__I($n(this.jl_StackTraceElement__f_declaringClass)) ^ $f_T__hashCode__I($n(this.jl_StackTraceElement__f_methodName))) ^ $f_T__hashCode__I($n(this.jl_StackTraceElement__f_fileName))) ^ this.jl_StackTraceElement__f_lineNumber) ^ this.jl_StackTraceElement__f_columnNumber);
});
function $as_jl_StackTraceElement(obj) {
  return (((obj instanceof $c_jl_StackTraceElement) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.StackTraceElement"));
}
function $isArrayOf_jl_StackTraceElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StackTraceElement)));
}
function $asArrayOf_jl_StackTraceElement(obj, depth) {
  return (($isArrayOf_jl_StackTraceElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.StackTraceElement;", depth));
}
var $d_jl_StackTraceElement = new $TypeData().initClass($c_jl_StackTraceElement, "java.lang.StackTraceElement", ({
  jl_StackTraceElement: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_jl_String$() {
}
$c_jl_String$.prototype = new $h_O();
$c_jl_String$.prototype.constructor = $c_jl_String$;
/** @constructor */
function $h_jl_String$() {
}
$h_jl_String$.prototype = $c_jl_String$.prototype;
$c_jl_String$.prototype.new__AC__I__I__T = (function(value, offset, count) {
  var arrayLength = $n(value).u.length;
  if ((((offset < 0) || (count < 0)) || (offset > ((arrayLength - count) | 0)))) {
    if (((offset < 0) || (offset >= arrayLength))) {
      $charAt("", offset);
    }
    if ((count < 0)) {
      $charAt("", count);
    }
    var index = ((((offset + count) | 0) - 1) | 0);
    $charAt("", index);
  }
  var end = ((offset + count) | 0);
  var result = "";
  var i = offset;
  while ((i !== end)) {
    var $x_1 = result;
    var this$1 = $n(value).get(i);
    result = ($x_1 + ("" + $cToS(this$1)));
    i = ((1 + i) | 0);
  }
  return result;
});
$c_jl_String$.prototype.format__T__AO__T = (function(format, args) {
  return $n($ct_ju_Formatter__(new $c_ju_Formatter()).format__T__AO__ju_Formatter(format, args)).toString__T();
});
var $d_jl_String$ = new $TypeData().initClass($c_jl_String$, "java.lang.String$", ({
  jl_String$: 1,
  Ljava_io_Serializable: 1
}));
var $n_jl_String$;
function $m_jl_String$() {
  if ((!$n_jl_String$)) {
    $n_jl_String$ = new $c_jl_String$();
  }
  return $n_jl_String$;
}
/** @constructor */
function $c_jl_Thread(dummy) {
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
}
$c_jl_Thread.prototype = new $h_O();
$c_jl_Thread.prototype.constructor = $c_jl_Thread;
/** @constructor */
function $h_jl_Thread() {
}
$h_jl_Thread.prototype = $c_jl_Thread.prototype;
$c_jl_Thread.prototype.run__V = (function() {
});
var $d_jl_Thread = new $TypeData().initClass($c_jl_Thread, "java.lang.Thread", ({
  jl_Thread: 1,
  jl_Runnable: 1
}));
function $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, enableSuppression, writableStackTrace) {
  $thiz.jl_Throwable__f_s = s;
  $thiz.jl_Throwable__f_e = e;
  $thiz.jl_Throwable__f_writableStackTrace = writableStackTrace;
  if (writableStackTrace) {
    $thiz.fillInStackTrace__jl_Throwable();
  }
  return $thiz;
}
class $c_jl_Throwable extends Error {
  constructor() {
    super();
    this.jl_Throwable__f_s = null;
    this.jl_Throwable__f_e = null;
    this.jl_Throwable__f_writableStackTrace = false;
    this.jl_Throwable__f_jsErrorForStackTrace = null;
    this.jl_Throwable__f_stackTrace = null;
  }
  getMessage__T() {
    return this.jl_Throwable__f_s;
  }
  getCause__jl_Throwable() {
    return this.jl_Throwable__f_e;
  }
  fillInStackTrace__jl_Throwable() {
    var reference = ((this instanceof $c_sjs_js_JavaScriptException) ? this.sjs_js_JavaScriptException__f_exception : this);
    var identifyingString = Object.prototype.toString.call(reference);
    this.jl_Throwable__f_jsErrorForStackTrace = ((identifyingString === "[object Error]") ? reference : (((Error.captureStackTrace === (void 0)) || $uZ(Object.isSealed(this))) ? new Error() : (Error.captureStackTrace(this), this)));
    return this;
  }
  getStackTrace__Ajl_StackTraceElement() {
    if ((this.jl_Throwable__f_stackTrace === null)) {
      if (this.jl_Throwable__f_writableStackTrace) {
        this.jl_Throwable__f_stackTrace = $m_jl_StackTrace$().extract__O__Ajl_StackTraceElement(this.jl_Throwable__f_jsErrorForStackTrace);
      } else {
        this.jl_Throwable__f_stackTrace = new ($d_jl_StackTraceElement.getArrayOf().constr)(0);
      }
    }
    return this.jl_Throwable__f_stackTrace;
  }
  setStackTrace__Ajl_StackTraceElement__V(stackTrace) {
    if (this.jl_Throwable__f_writableStackTrace) {
      var i = 0;
      while ((i < $n(stackTrace).u.length)) {
        $n($n(stackTrace).get(i));
        i = ((1 + i) | 0);
      }
      var this$1 = $n(stackTrace);
      this.jl_Throwable__f_stackTrace = this$1.clone__O();
    }
  }
  printStackTrace__Ljava_io_PrintStream__V(s) {
    this.getStackTrace__Ajl_StackTraceElement();
    var t = this.toString__T();
    $n(s).println__T__V(t);
    if (($n(this.jl_Throwable__f_stackTrace).u.length !== 0)) {
      var i = 0;
      while ((i < $n(this.jl_Throwable__f_stackTrace).u.length)) {
        var t$1 = ("  at " + $n(this.jl_Throwable__f_stackTrace).get(i));
        $n(s).println__T__V(t$1);
        i = ((1 + i) | 0);
      }
    } else {
      $n(s).println__T__V("  <no stack trace available>");
    }
    var wCause = this;
    while (((wCause !== $n(wCause).getCause__jl_Throwable()) && ($n(wCause).getCause__jl_Throwable() !== null))) {
      var parentTrace = $n(wCause).getStackTrace__Ajl_StackTraceElement();
      wCause = $n(wCause).getCause__jl_Throwable();
      var thisTrace = $n(wCause).getStackTrace__Ajl_StackTraceElement();
      var thisLength = $n(thisTrace).u.length;
      var parentLength = $n(parentTrace).u.length;
      var t$2 = ("Caused by: " + wCause);
      $n(s).println__T__V(t$2);
      if ((thisLength !== 0)) {
        var sameFrameCount = 0;
        while (true) {
          if (((sameFrameCount < thisLength) && (sameFrameCount < parentLength))) {
            var x = $n(thisTrace).get(((((thisLength - sameFrameCount) | 0) - 1) | 0));
            var x$2 = $n(parentTrace).get(((((parentLength - sameFrameCount) | 0) - 1) | 0));
            var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            sameFrameCount = ((1 + sameFrameCount) | 0);
          } else {
            break;
          }
        }
        if ((sameFrameCount > 0)) {
          sameFrameCount = ((sameFrameCount - 1) | 0);
        }
        var lengthToPrint = ((thisLength - sameFrameCount) | 0);
        var i$2 = 0;
        while ((i$2 < lengthToPrint)) {
          var t$3 = ("  at " + $n(thisTrace).get(i$2));
          $n(s).println__T__V(t$3);
          i$2 = ((1 + i$2) | 0);
        }
        if ((sameFrameCount > 0)) {
          var t$4 = (("  ... " + sameFrameCount) + " more");
          $n(s).println__T__V(t$4);
        }
      } else {
        $n(s).println__T__V("  <no stack trace available>");
      }
    }
  }
  toString__T() {
    var className = $objectClassName(this);
    var message = this.getMessage__T();
    return ((message === null) ? className : ((className + ": ") + message));
  }
  hashCode__I() {
    return $c_O.prototype.hashCode__I.call(this);
  }
  equals__O__Z(that) {
    return $c_O.prototype.equals__O__Z.call(this, that);
  }
  get "message"() {
    var m = this.getMessage__T();
    return ((m === null) ? "" : m);
  }
  get "name"() {
    return $objectClassName(this);
  }
  "toString"() {
    return this.toString__T();
  }
}
function $as_jl_Throwable(obj) {
  return (((obj instanceof $c_jl_Throwable) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Throwable"));
}
function $isArrayOf_jl_Throwable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Throwable)));
}
function $asArrayOf_jl_Throwable(obj, depth) {
  return (($isArrayOf_jl_Throwable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Throwable;", depth));
}
function $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1) {
  return $n($thiz.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength).get(diffScale$1);
}
function $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1) {
  return (($n(augend$1).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1)) | 0);
}
function $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I($thiz, thisValue$1, augend$1, diffScale$1) {
  var a = $n(thisValue$1).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var b = $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1);
  return ((1 + ((a > b) ? a : b)) | 0);
}
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.Ljava_math_BigDecimal$__f_ZERO = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = null;
  this.Ljava_math_BigDecimal$__f_LongTenPows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = null;
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = null;
  $n_Ljava_math_BigDecimal$ = this;
  this.Ljava_math_BigDecimal$__f_ZERO = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = this.newArrayOfPows__I__I__AJ(28, 5);
  var len = (($n(this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows).u.length >>> 1) | 0);
  var result = new $ac_I(len);
  var i = 0;
  while ((i < len)) {
    var value = i;
    var $x_4 = $m_Ljava_math_BigDecimal$();
    var $x_2 = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows).u;
    var $x_3 = $aJCheckGet($x_2, value);
    var $x_1_$_lo = $x_2[$x_3];
    var $x_1_$_hi = $x_2[(($x_3 + 1) | 0)];
    result.set(value, $x_4.bitLength__J__I($x_1_$_lo, $x_1_$_hi));
    i = ((1 + i) | 0);
  }
  this.Ljava_math_BigDecimal$__f_LongTenPows = this.newArrayOfPows__I__I__AJ(19, 10);
  var len$2 = (($n(this.Ljava_math_BigDecimal$__f_LongTenPows).u.length >>> 1) | 0);
  var result$2 = new $ac_I(len$2);
  var i$1 = 0;
  while ((i$1 < len$2)) {
    var value$1 = i$1;
    var $x_8 = $m_Ljava_math_BigDecimal$();
    var $x_6 = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).u;
    var $x_7 = $aJCheckGet($x_6, value$1);
    var $x_5_$_lo = $x_6[$x_7];
    var $x_5_$_hi = $x_6[(($x_7 + 1) | 0)];
    result$2.set(value$1, $x_8.bitLength__J__I($x_5_$_lo, $x_5_$_hi));
    i$1 = ((1 + i$1) | 0);
  }
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = result$2;
  var result$3 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$2 = 0;
  while ((i$2 < 11)) {
    var value$2 = i$2;
    result$3.set(value$2, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), value$2, 0));
    i$2 = ((1 + i$2) | 0);
  }
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = result$3;
  var result$4 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var value$3 = i$3;
    result$4.set(value$3, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, value$3));
    i$3 = ((1 + i$3) | 0);
  }
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = result$4;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
}
$c_Ljava_math_BigDecimal$.prototype = new $h_O();
$c_Ljava_math_BigDecimal$.prototype.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
}
$h_Ljava_math_BigDecimal$.prototype = $c_Ljava_math_BigDecimal$.prototype;
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__I__Ljava_math_BigDecimal = (function(unscaledVal_$_lo, unscaledVal_$_hi, scale) {
  return ((scale === 0) ? this.valueOf__J__Ljava_math_BigDecimal(unscaledVal_$_lo, unscaledVal_$_hi) : (((((unscaledVal_$_lo | unscaledVal_$_hi) === 0) && (scale >= 0)) && (scale < $n(this.Ljava_math_BigDecimal$__f_ZeroScaledBy).u.length)) ? $n(this.Ljava_math_BigDecimal$__f_ZeroScaledBy).get(scale) : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal_$_lo, unscaledVal_$_hi, scale)));
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__Ljava_math_BigDecimal = (function(unscaledVal_$_lo, unscaledVal_$_hi) {
  return (((unscaledVal_$_hi >= 0) && ((unscaledVal_$_hi === 0) ? ((unscaledVal_$_lo >>> 0) < 11) : (unscaledVal_$_hi < 0))) ? $n(this.Ljava_math_BigDecimal$__f_BigIntScaledByZero).get(unscaledVal_$_lo) : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal_$_lo, unscaledVal_$_hi, 0));
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__D__Ljava_math_BigDecimal = (function(d) {
  if ((((d === Infinity) || (d === (-Infinity))) || (d !== d))) {
    throw new $c_jl_NumberFormatException(("Infinity or NaN: " + d));
  }
  return $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), ("" + d));
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal = (function(thisValue, augend, diffScale) {
  if (((diffScale < (($n(this.Ljava_math_BigDecimal$__f_LongTenPows).u.length >>> 1) | 0)) && ($p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I(this, thisValue, augend, diffScale) < 64))) {
    var x_$_lo = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
    var x_$_hi = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
    var $x_1 = $n(this.Ljava_math_BigDecimal$__f_LongTenPows).u;
    var $x_2 = $aJCheckGet($x_1, diffScale);
    var x$1_$_lo = $x_1[$x_2];
    var x$1_$_hi = $x_1[(($x_2 + 1) | 0)];
    var a0 = (65535 & x_$_lo);
    var a1 = ((x_$_lo >>> 16) | 0);
    var b0 = (65535 & x$1_$_lo);
    var b1 = ((x$1_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((((((((Math.imul(x_$_lo, x$1_$_hi) + Math.imul(x_$_hi, x$1_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var x$2_$_lo = $n(thisValue).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
    var x$2_$_hi = $n(thisValue).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
    var lo$1 = ((x$2_$_lo + lo) | 0);
    var hi$1 = ((((x$2_$_hi + hi) | 0) + ((((x$2_$_lo & lo) | ((x$2_$_lo | lo) & (~lo$1))) >>> 31) | 0)) | 0);
    return this.valueOf__J__I__Ljava_math_BigDecimal(lo$1, hi$1, $n(thisValue).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  } else {
    var $x_4 = $m_Ljava_math_Multiplication$();
    var $x_3 = $n(augend).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var hi$2 = (diffScale >> 31);
    var bi = $x_4.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($x_3, diffScale, hi$2);
    var this$4 = $n($n(thisValue).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_5 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi);
    var this$5 = $n(thisValue);
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_5, this$5.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$longCompareTo__J__J__I = (function(value1_$_lo, value1_$_hi, value2_$_lo, value2_$_hi) {
  return (((value1_$_hi === value2_$_hi) ? ((value1_$_lo >>> 0) > (value2_$_lo >>> 0)) : (value1_$_hi > value2_$_hi)) ? 1 : (((value1_$_hi === value2_$_hi) ? ((value1_$_lo >>> 0) < (value2_$_lo >>> 0)) : (value1_$_hi < value2_$_hi)) ? (-1) : 0));
});
$c_Ljava_math_BigDecimal$.prototype.newArrayOfPows__I__I__AJ = (function(len, pow) {
  var result = new $ac_J(len);
  result.set(0, 1, 0);
  var i = 1;
  while ((i < len)) {
    var value = i;
    var $x_1 = result.u;
    var $x_2 = $aJCheckGet($x_1, ((value - 1) | 0));
    var x_$_lo = $x_1[$x_2];
    var x_$_hi = $x_1[(($x_2 + 1) | 0)];
    var hi = (pow >> 31);
    var a0 = (65535 & x_$_lo);
    var a1 = ((x_$_lo >>> 16) | 0);
    var b0 = (65535 & pow);
    var b1 = ((pow >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(x_$_lo, hi) + Math.imul(x_$_hi, pow)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    result.set(value, lo, hi$1);
    i = ((1 + i) | 0);
  }
  return result;
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I = (function(parityBit, fraction, roundingMode) {
  var sign = (fraction >> 31);
  var absFraction = (((fraction ^ sign) - sign) | 0);
  var sigFraction = ((fraction >> 31) | ((((-fraction) | 0) >>> 31) | 0));
  var x = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UP;
  if ((x === null)) {
    var $x_1 = (roundingMode === null);
  } else {
    var this$3 = $n(x);
    var $x_1 = (this$3 === roundingMode);
  }
  if ($x_1) {
    return sigFraction;
  } else {
    var x$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_DOWN;
    if ((x$3 === null)) {
      var $x_2 = (roundingMode === null);
    } else {
      var this$4 = $n(x$3);
      var $x_2 = (this$4 === roundingMode);
    }
    if ($x_2) {
      return 0;
    } else {
      var x$5 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_CEILING;
      if ((x$5 === null)) {
        var $x_3 = (roundingMode === null);
      } else {
        var this$5 = $n(x$5);
        var $x_3 = (this$5 === roundingMode);
      }
      if ($x_3) {
        return ((sigFraction > 0) ? sigFraction : 0);
      } else {
        var x$7 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR;
        if ((x$7 === null)) {
          var $x_4 = (roundingMode === null);
        } else {
          var this$7 = $n(x$7);
          var $x_4 = (this$7 === roundingMode);
        }
        if ($x_4) {
          return ((sigFraction < 0) ? sigFraction : 0);
        } else {
          var x$9 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
          if ((x$9 === null)) {
            var $x_5 = (roundingMode === null);
          } else {
            var this$9 = $n(x$9);
            var $x_5 = (this$9 === roundingMode);
          }
          if ($x_5) {
            return ((absFraction >= 5) ? sigFraction : 0);
          } else {
            var x$11 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_DOWN;
            if ((x$11 === null)) {
              var $x_6 = (roundingMode === null);
            } else {
              var this$10 = $n(x$11);
              var $x_6 = (this$10 === roundingMode);
            }
            if ($x_6) {
              return ((absFraction > 5) ? sigFraction : 0);
            } else {
              var x$13 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
              if ((x$13 === null)) {
                var $x_7 = (roundingMode === null);
              } else {
                var this$11 = $n(x$13);
                var $x_7 = (this$11 === roundingMode);
              }
              if ($x_7) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0);
              } else {
                var x$15 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UNNECESSARY;
                if ((x$15 === null)) {
                  var $x_8 = (roundingMode === null);
                } else {
                  var this$12 = $n(x$15);
                  var $x_8 = (this$12 === roundingMode);
                }
                if ($x_8) {
                  if ((fraction === 0)) {
                    return 0;
                  } else {
                    throw new $c_jl_ArithmeticException("Rounding necessary");
                  }
                } else {
                  throw new $c_jl_AssertionError(roundingMode);
                }
              }
            }
          }
        }
      }
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$safeLongToInt__J__I = (function(longValue_$_lo, longValue_$_hi) {
  if ((((longValue_$_hi === (-1)) ? ((longValue_$_lo >>> 0) < 2147483648) : (longValue_$_hi < (-1))) || ((longValue_$_hi === 0) ? ((longValue_$_lo >>> 0) > 2147483647) : (longValue_$_hi > 0)))) {
    throw new $c_jl_ArithmeticException(("Out of int range: " + $s_RTLong__toString__I__I__T(longValue_$_lo, longValue_$_hi)));
  }
  return longValue_$_lo;
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal = (function(longScale_$_lo, longScale_$_hi) {
  var hi = (longScale_$_lo >> 31);
  if ((((longScale_$_lo ^ longScale_$_lo) | (longScale_$_hi ^ hi)) === 0)) {
    return this.valueOf__J__I__Ljava_math_BigDecimal(0, 0, longScale_$_lo);
  } else {
    return ((longScale_$_hi >= 0) ? $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647) : $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648)));
  }
});
$c_Ljava_math_BigDecimal$.prototype.bitLength__J__I = (function(sValue_$_lo, sValue_$_hi) {
  if ((sValue_$_hi < 0)) {
    var lo = (~sValue_$_lo);
    var hi = (~sValue_$_hi);
    var smallValue_$_lo = lo;
    var smallValue_$_hi = hi;
  } else {
    var smallValue_$_lo = sValue_$_lo;
    var smallValue_$_hi = sValue_$_hi;
  }
  return ((64 - ((smallValue_$_hi !== 0) ? Math.clz32(smallValue_$_hi) : ((32 + Math.clz32(smallValue_$_lo)) | 0))) | 0);
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$bitLength__I__I = (function(sValue) {
  var smallValue = ((sValue < 0) ? (~sValue) : sValue);
  return ((32 - Math.clz32(smallValue)) | 0);
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$charNotEqualTo__C__AC__Z = (function(c, cs) {
  return (!this.java$math$BigDecimal$$charEqualTo__C__AC__Z(c, cs));
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$charEqualTo__C__AC__Z = (function(c, cs) {
  var len = $n(cs).u.length;
  var i = 0;
  while ((i !== len)) {
    if (($n(cs).get(i) === c)) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
});
var $d_Ljava_math_BigDecimal$ = new $TypeData().initClass($c_Ljava_math_BigDecimal$, "java.math.BigDecimal$", ({
  Ljava_math_BigDecimal$: 1,
  Ljava_io_Serializable: 1
}));
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$();
  }
  return $n_Ljava_math_BigDecimal$;
}
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.Ljava_math_BigInteger$__f_ONE = null;
  this.Ljava_math_BigInteger$__f_TEN = null;
  this.Ljava_math_BigInteger$__f_ZERO = null;
  this.Ljava_math_BigInteger$__f_MINUS_ONE = null;
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = null;
  this.Ljava_math_BigInteger$__f_TWO_POWS = null;
  $n_Ljava_math_BigInteger$ = this;
  this.Ljava_math_BigInteger$__f_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.Ljava_math_BigInteger$__f_TEN = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.Ljava_math_BigInteger$__f_ZERO = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.Ljava_math_BigInteger$__f_MINUS_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$__f_ZERO, this.Ljava_math_BigInteger$__f_ONE, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.Ljava_math_BigInteger$__f_TEN]);
  var result = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  var i = 0;
  while ((i < 32)) {
    var value = i;
    var $x_1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & value) === 0) ? (1 << value) : 0);
    var hi = (((32 & value) === 0) ? 0 : (1 << value));
    result.set(value, $x_1.valueOf__J__Ljava_math_BigInteger(lo, hi));
    i = ((1 + i) | 0);
  }
  this.Ljava_math_BigInteger$__f_TWO_POWS = result;
}
$c_Ljava_math_BigInteger$.prototype = new $h_O();
$c_Ljava_math_BigInteger$.prototype.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
}
$h_Ljava_math_BigInteger$.prototype = $c_Ljava_math_BigInteger$.prototype;
$c_Ljava_math_BigInteger$.prototype.valueOf__J__Ljava_math_BigInteger = (function(lVal_$_lo, lVal_$_hi) {
  if ((lVal_$_hi < 0)) {
    if ((((~lVal_$_lo) | (~lVal_$_hi)) !== 0)) {
      var lo = ((-lVal_$_lo) | 0);
      var hi = ((((-lVal_$_hi) | 0) + ((lVal_$_lo | lo) >> 31)) | 0);
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), lo, hi);
    } else {
      return this.Ljava_math_BigInteger$__f_MINUS_ONE;
    }
  } else {
    return (((lVal_$_hi === 0) ? ((lVal_$_lo >>> 0) <= 10) : (lVal_$_hi < 0)) ? $n(this.Ljava_math_BigInteger$__f_SMALL_VALUES).get(lVal_$_lo) : $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal_$_lo, lVal_$_hi));
  }
});
$c_Ljava_math_BigInteger$.prototype.getPowerOfTwo__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < $n(this.Ljava_math_BigInteger$__f_TWO_POWS).u.length)) {
    return $n(this.Ljava_math_BigInteger$__f_TWO_POWS).get(exp);
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $ac_I(((1 + intCount) | 0));
    resDigits.set(intCount, (1 << bitN));
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits);
  }
});
$c_Ljava_math_BigInteger$.prototype.checkRangeBasedOnIntArrayLength__I__V = (function(byteLength) {
  if (((byteLength >>> 0) > 67108863)) {
    throw new $c_jl_ArithmeticException("BigInteger would overflow supported range");
  }
});
var $d_Ljava_math_BigInteger$ = new $TypeData().initClass($c_Ljava_math_BigInteger$, "java.math.BigInteger$", ({
  Ljava_math_BigInteger$: 1,
  Ljava_io_Serializable: 1
}));
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$();
  }
  return $n_Ljava_math_BigInteger$;
}
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.Ljava_math_RoundingMode$__f_UP = null;
  this.Ljava_math_RoundingMode$__f_DOWN = null;
  this.Ljava_math_RoundingMode$__f_CEILING = null;
  this.Ljava_math_RoundingMode$__f_FLOOR = null;
  this.Ljava_math_RoundingMode$__f_HALF_UP = null;
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = null;
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = null;
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.Ljava_math_RoundingMode$__f_UP = new $c_Ljava_math_RoundingMode("UP", 0);
  this.Ljava_math_RoundingMode$__f_DOWN = new $c_Ljava_math_RoundingMode("DOWN", 1);
  this.Ljava_math_RoundingMode$__f_CEILING = new $c_Ljava_math_RoundingMode("CEILING", 2);
  this.Ljava_math_RoundingMode$__f_FLOOR = new $c_Ljava_math_RoundingMode("FLOOR", 3);
  this.Ljava_math_RoundingMode$__f_HALF_UP = new $c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = new $c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = new $c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = new $c_Ljava_math_RoundingMode("UNNECESSARY", 7);
}
$c_Ljava_math_RoundingMode$.prototype = new $h_O();
$c_Ljava_math_RoundingMode$.prototype.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
}
$h_Ljava_math_RoundingMode$.prototype = $c_Ljava_math_RoundingMode$.prototype;
var $d_Ljava_math_RoundingMode$ = new $TypeData().initClass($c_Ljava_math_RoundingMode$, "java.math.RoundingMode$", ({
  Ljava_math_RoundingMode$: 1,
  Ljava_io_Serializable: 1
}));
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$();
  }
  return $n_Ljava_math_RoundingMode$;
}
function $ct_Ljava_time_ZoneId__($thiz) {
  if ((($objectGetClass($thiz) !== $d_Ljava_time_ZoneOffset.getClassOf()) && ($objectGetClass($thiz) !== $d_Ljava_time_ZoneRegion.getClassOf()))) {
    throw new $c_jl_AssertionError("Invalid subclass");
  }
  return $thiz;
}
/** @constructor */
function $c_Ljava_time_ZoneId() {
}
$c_Ljava_time_ZoneId.prototype = new $h_O();
$c_Ljava_time_ZoneId.prototype.constructor = $c_Ljava_time_ZoneId;
/** @constructor */
function $h_Ljava_time_ZoneId() {
}
$h_Ljava_time_ZoneId.prototype = $c_Ljava_time_ZoneId.prototype;
$c_Ljava_time_ZoneId.prototype.normalized__Ljava_time_ZoneId = (function() {
  try {
    var rules = $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this);
    if (($n(rules), true)) {
      var this$1 = $n(rules);
      $m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant();
      return this$1.Ljava_time_zone_ZoneRules$Fixed__f_offset;
    }
  } catch (e) {
    if ((!false)) {
      throw e;
    }
  }
  return this;
});
function $as_Ljava_time_ZoneId(obj) {
  return (((obj instanceof $c_Ljava_time_ZoneId) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.ZoneId"));
}
function $isArrayOf_Ljava_time_ZoneId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZoneId)));
}
function $asArrayOf_Ljava_time_ZoneId(obj, depth) {
  return (($isArrayOf_Ljava_time_ZoneId(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.ZoneId;", depth));
}
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__($thiz, printerParsers, optional) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers = printerParsers;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional = optional;
  return $thiz;
}
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__($thiz, printerParsers, optional) {
  var dimensions = new $ac_I(new Int32Array([$n(printerParsers).size__I()]));
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__($thiz, $asArrayOf_Ljava_time_format_internal_DateTimePrinterParser($n(printerParsers).toArray__AO__AO($asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_format_internal_DateTimePrinterParser.getClassOf(), dimensions), 1)), 1), optional);
  return $thiz;
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional = false;
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var nonLocalReturnKey1 = $ct_O__(new $c_O());
  try {
    var length = $n(buf).length__I();
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
      $n(context).startOptional__V();
    }
    try {
      var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f = ((pp) => {
        var pp$1 = $as_Ljava_time_format_internal_DateTimePrinterParser(pp);
        if ((!$n(pp$1).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf))) {
          $n(buf).setLength__I__V(length);
          throw new $c_sr_NonLocalReturnControl(nonLocalReturnKey1, true);
        }
      });
      var len = $n(xs).u.length;
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var x0 = $n(xs).get(i);
          f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        var x3 = $asArrayOf_I(xs, 1);
        while ((i < len)) {
          var x0$1 = $n(x3).get(i);
          f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        var x4 = $asArrayOf_D(xs, 1);
        while ((i < len)) {
          var x0$2 = $n(x4).get(i);
          f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        var x5 = $asArrayOf_J(xs, 1);
        while ((i < len)) {
          var $x_1 = $n(x5).u;
          var $x_2 = $aJCheckGet($x_1, i);
          var x0$3_$_lo = $x_1[$x_2];
          var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
          f($bL(x0$3_$_lo, x0$3_$_hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        var x6 = $asArrayOf_F(xs, 1);
        while ((i < len)) {
          var x0$4 = $n(x6).get(i);
          f(x0$4);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        var x7 = $asArrayOf_C(xs, 1);
        while ((i < len)) {
          var x0$5 = $n(x7).get(i);
          f($bC(x0$5));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        var x8 = $asArrayOf_B(xs, 1);
        while ((i < len)) {
          var x0$6 = $n(x8).get(i);
          f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        var x9 = $asArrayOf_S(xs, 1);
        while ((i < len)) {
          var x0$7 = $n(x9).get(i);
          f(x0$7);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(xs, 1);
        while ((i < len)) {
          var x0$8 = $n(x10).get(i);
          f(x0$8);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    } finally {
      if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
        $n(context).endOptional__V();
      }
    }
    return true;
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = $as_sr_NonLocalReturnControl(e);
      if (($n(ex).sr_NonLocalReturnControl__f_key === nonLocalReturnKey1)) {
        return $uZ($n(ex).sr_NonLocalReturnControl__f_value);
      } else {
        throw $n(ex);
      }
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.toString__T = (function() {
  var buf = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers !== null)) {
    var str = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional ? "[" : "(");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
    var f = ((pp) => {
      var pp$1 = $as_Ljava_time_format_internal_DateTimePrinterParser(pp);
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + pp$1);
      return buf;
    });
    var len = $n(xs).u.length;
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var x0 = $n(xs).get(i);
        f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var x0$1 = $n(x3).get(i);
        f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var x0$2 = $n(x4).get(i);
        f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var $x_1 = $n(x5).u;
        var $x_2 = $aJCheckGet($x_1, i);
        var x0$3_$_lo = $x_1[$x_2];
        var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
        f($bL(x0$3_$_lo, x0$3_$_hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var x0$4 = $n(x6).get(i);
        f(x0$4);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var x0$5 = $n(x7).get(i);
        f($bC(x0$5));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var x0$6 = $n(x8).get(i);
        f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var x0$7 = $n(x9).get(i);
        f(x0$7);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var x0$8 = $n(x10).get(i);
        f(x0$8);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
    var str$1 = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional ? "]" : ")");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
  }
  return buf.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$CompositePrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser(fractionalDigits) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits = fractionalDigits;
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var inSecs = $n(context).getValue__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
  var inNanos = $bL(0, 0);
  var this$2 = $n(context);
  if ($n(this$2.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal).isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var this$3 = $n(context);
    var $x_1 = $n(this$3.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    inNanos = $bL(x_$_lo, x_$_hi);
  }
  if ((inSecs === null)) {
    return false;
  }
  var this$6 = $n($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  var x$1 = inNanos;
  var $x_2 = $uJ(x$1);
  var value_$_lo = $x_2.l;
  var value_$_hi = $x_2.h;
  var inNano = $n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(value_$_lo, value_$_hi, this$6);
  var $x_3 = $uJ(inSecs);
  var x$4_$_lo = $x_3.l;
  var x$4_$_hi = $x_3.h;
  var x$2 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
  var $x_4 = $uJ(x$2);
  var x$3_$_lo = $x_4.l;
  var x$3_$_hi = $x_4.h;
  var lo = ((-x$3_$_lo) | 0);
  var hi = ((((-x$3_$_hi) | 0) + ((x$3_$_lo | lo) >> 31)) | 0);
  if (((x$4_$_hi === hi) ? ((x$4_$_lo >>> 0) >= (lo >>> 0)) : (x$4_$_hi > hi))) {
    var $x_5 = $uJ(inSecs);
    var x$6_$_lo = $x_5.l;
    var x$6_$_hi = $x_5.h;
    var x$5 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var $x_6 = $uJ(x$5);
    var x$7_$_lo = $x_6.l;
    var x$7_$_hi = $x_6.h;
    var lo$1 = ((x$6_$_lo - x$7_$_lo) | 0);
    var hi$1 = ((((x$6_$_hi - x$7_$_hi) | 0) + ((((~x$6_$_lo) & x$7_$_lo) | ((~(x$6_$_lo ^ x$7_$_lo)) & lo$1)) >> 31)) | 0);
    var x$8 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var $x_7 = $uJ(x$8);
    var x$9_$_lo = $x_7.l;
    var x$9_$_hi = $x_7.h;
    var lo$2 = ((lo$1 + x$9_$_lo) | 0);
    var hi$2 = ((((hi$1 + x$9_$_hi) | 0) + ((((lo$1 & x$9_$_lo) | ((lo$1 | x$9_$_lo) & (~lo$2))) >>> 31) | 0)) | 0);
    var x$10 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var $x_8 = $uJ(x$10);
    var b_$_lo = $x_8.l;
    var b_$_hi = $x_8.h;
    var $x_9 = $m_RTLong$().divide__I__I__I__I__J(lo$2, hi$2, b_$_lo, b_$_hi);
    var quot_$_lo = $x_9.l;
    var quot_$_hi = $x_9.h;
    var hi$3 = (hi$2 ^ b_$_hi);
    if ((hi$3 >= 0)) {
      var $x_10 = true;
    } else {
      var a0 = (65535 & quot_$_lo);
      var a1 = ((quot_$_lo >>> 16) | 0);
      var b0 = (65535 & b_$_lo);
      var b1 = ((b_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((((Math.imul(quot_$_lo, b_$_hi) + Math.imul(quot_$_hi, b_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var $x_10 = (((lo$4 ^ lo$2) | (hi$4 ^ hi$2)) === 0);
    }
    if ($x_10) {
      var x$11_$_lo = quot_$_lo;
      var x$11_$_hi = quot_$_hi;
    } else {
      var lo$5 = ((quot_$_lo - 1) | 0);
      var hi$5 = ((((quot_$_hi - 1) | 0) + (((quot_$_lo | (~lo$5)) >>> 31) | 0)) | 0);
      var x$11_$_lo = lo$5;
      var x$11_$_hi = hi$5;
    }
    var lo$6 = ((1 + x$11_$_lo) | 0);
    var hi$6 = ((x$11_$_hi + (((x$11_$_lo & (~lo$6)) >>> 31) | 0)) | 0);
    var x$12 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var $x_11 = $uJ(x$12);
    var b$1_$_lo = $x_11.l;
    var b$1_$_hi = $x_11.h;
    var $x_12 = $m_RTLong$().remainder__I__I__I__I__J(lo$2, hi$2, b$1_$_lo, b$1_$_hi);
    var rem_$_lo = $x_12.l;
    var rem_$_hi = $x_12.h;
    var hi$7 = (hi$2 ^ b$1_$_hi);
    if (((hi$7 >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
      var x$13_$_lo = rem_$_lo;
      var x$13_$_hi = rem_$_hi;
    } else {
      var lo$8 = ((rem_$_lo + b$1_$_lo) | 0);
      var hi$8 = ((((rem_$_hi + b$1_$_hi) | 0) + ((((rem_$_lo & b$1_$_lo) | ((rem_$_lo | b$1_$_lo) & (~lo$8))) >>> 31) | 0)) | 0);
      var x$13_$_lo = lo$8;
      var x$13_$_hi = hi$8;
    }
    var $x_14 = $m_Ljava_time_LocalDateTime$();
    var x$14 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var $x_13 = $uJ(x$14);
    var x$15_$_lo = $x_13.l;
    var x$15_$_hi = $x_13.h;
    var lo$9 = ((x$13_$_lo - x$15_$_lo) | 0);
    var hi$9 = ((((x$13_$_hi - x$15_$_hi) | 0) + ((((~x$13_$_lo) & x$15_$_lo) | ((~(x$13_$_lo ^ x$15_$_lo)) & lo$9)) >> 31)) | 0);
    var ldt = $x_14.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(lo$9, hi$9, 0, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    if (((hi$6 === 0) ? (lo$6 !== 0) : (hi$6 > 0))) {
      var this$40 = $n(buf);
      this$40.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$40.jl_StringBuilder__f_java$lang$StringBuilder$$content + "+");
      this$40.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$40.jl_StringBuilder__f_java$lang$StringBuilder$$content + $s_RTLong__toString__I__I__T(lo$6, hi$6));
    }
    var this$42 = $n(buf);
    this$42.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$42.jl_StringBuilder__f_java$lang$StringBuilder$$content) + ldt);
    var this$43 = $n(ldt);
    var this$44 = $n(this$43.Ljava_time_LocalDateTime__f_time);
    if ((this$44.Ljava_time_LocalTime__f_second === 0)) {
      var this$45 = $n(buf);
      this$45.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$45.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":00");
    }
  } else {
    var $x_15 = $uJ(inSecs);
    var x$17_$_lo = $x_15.l;
    var x$17_$_hi = $x_15.h;
    var x$16 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var $x_16 = $uJ(x$16);
    var x$18_$_lo = $x_16.l;
    var x$18_$_hi = $x_16.h;
    var lo$10 = ((x$17_$_lo + x$18_$_lo) | 0);
    var hi$10 = ((((x$17_$_hi + x$18_$_hi) | 0) + ((((x$17_$_lo & x$18_$_lo) | ((x$17_$_lo | x$18_$_lo) & (~lo$10))) >>> 31) | 0)) | 0);
    var x$19 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var $x_17 = $uJ(x$19);
    var x$20_$_lo = $x_17.l;
    var x$20_$_hi = $x_17.h;
    var $x_18 = $m_RTLong$().divide__I__I__I__I__J(lo$10, hi$10, x$20_$_lo, x$20_$_hi);
    var x$21_$_lo = $x_18.l;
    var x$21_$_hi = $x_18.h;
    var x$22 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var $x_19 = $uJ(x$22);
    var x$23_$_lo = $x_19.l;
    var x$23_$_hi = $x_19.h;
    var $x_20 = $m_RTLong$().remainder__I__I__I__I__J(lo$10, hi$10, x$23_$_lo, x$23_$_hi);
    var x$24_$_lo = $x_20.l;
    var x$24_$_hi = $x_20.h;
    var $x_22 = $m_Ljava_time_LocalDateTime$();
    var x$25 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var $x_21 = $uJ(x$25);
    var x$26_$_lo = $x_21.l;
    var x$26_$_hi = $x_21.h;
    var lo$11 = ((x$24_$_lo - x$26_$_lo) | 0);
    var hi$11 = ((((x$24_$_hi - x$26_$_hi) | 0) + ((((~x$24_$_lo) & x$26_$_lo) | ((~(x$24_$_lo ^ x$26_$_lo)) & lo$11)) >> 31)) | 0);
    var ldt$2 = $x_22.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(lo$11, hi$11, 0, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var pos = $n(buf).length__I();
    var this$59 = $n(buf);
    this$59.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$59.jl_StringBuilder__f_java$lang$StringBuilder$$content) + ldt$2);
    var this$60 = $n(ldt$2);
    var this$61 = $n(this$60.Ljava_time_LocalDateTime__f_time);
    if ((this$61.Ljava_time_LocalTime__f_second === 0)) {
      var this$62 = $n(buf);
      this$62.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$62.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":00");
    }
    if ((x$21_$_hi < 0)) {
      var this$65 = $n(ldt$2);
      var this$66 = $n(this$65.Ljava_time_LocalDateTime__f_date);
      if ((this$66.Ljava_time_LocalDate__f_year === (-10000))) {
        var $x_23 = $n(buf);
        var lo$12 = ((x$21_$_lo - 1) | 0);
        var hi$12 = ((((x$21_$_hi - 1) | 0) + (((x$21_$_lo | (~lo$12)) >>> 31) | 0)) | 0);
        $x_23.replace__I__I__T__jl_StringBuilder(pos, ((2 + pos) | 0), $m_RTLong$().toString__I__I__T(lo$12, hi$12));
      } else if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z($bL(x$24_$_lo, x$24_$_hi), 0)) {
        var this$69 = $n(buf);
        this$69.insert__I__T__jl_StringBuilder(pos, ("" + $s_RTLong__toString__I__I__T(x$21_$_lo, x$21_$_hi)));
      } else {
        var this$73 = $n(buf);
        var offset = ((1 + pos) | 0);
        var sign = (x$21_$_hi >> 31);
        var xlo = (x$21_$_lo ^ sign);
        var rlo = ((xlo - sign) | 0);
        var rhi = (((x$21_$_hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
        this$73.insert__I__T__jl_StringBuilder(offset, $m_RTLong$().toString__I__I__T(rlo, rhi));
      }
    }
  }
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-2))) {
    if ((inNano !== 0)) {
      var this$74 = $n(buf);
      this$74.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$74.jl_StringBuilder__f_java$lang$StringBuilder$$content + ".");
      if ((((inNano % 1000000) | 0) === 0)) {
        var this$78 = $n(buf);
        var i = ((1000 + ((inNano / 1000000) | 0)) | 0);
        var this$77 = ("" + i);
        if ((this$77.length < 1)) {
          $charAt(this$77, 1);
        }
        var str = $as_T(this$77.substring(1));
        this$78.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$78.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      } else if ((((inNano % 1000) | 0) === 0)) {
        var this$81 = $n(buf);
        var i$1 = ((1000000 + ((inNano / 1000) | 0)) | 0);
        var this$80 = ("" + i$1);
        if ((this$80.length < 1)) {
          $charAt(this$80, 1);
        }
        var str$1 = $as_T(this$80.substring(1));
        this$81.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$81.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
      } else {
        var this$84 = $n(buf);
        var i$2 = ((1000000000 + inNano) | 0);
        var this$83 = ("" + i$2);
        if ((this$83.length < 1)) {
          $charAt(this$83, 1);
        }
        var str$2 = $as_T(this$83.substring(1));
        this$84.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$84.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
      }
    }
  } else if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits > 0) || ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-1)) && (inNano > 0)))) {
    var this$85 = $n(buf);
    this$85.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$85.jl_StringBuilder__f_java$lang$StringBuilder$$content + ".");
    var div = 100000000;
    var i$3 = 0;
    while ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-1)) && (inNano > 0)) || (i$3 < this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits))) {
      var digit = ((inNano / $checkIntDivisor(div)) | 0);
      var this$87 = $n(buf);
      var c = (65535 & ((48 + digit) | 0));
      var str$3 = ("" + $cToS(c));
      this$87.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$87.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$3);
      inNano = ((inNano - Math.imul(digit, div)) | 0);
      div = ((div / 10) | 0);
      i$3 = ((1 + i$3) | 0);
    }
  }
  var this$89 = $n(buf);
  this$89.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$89.jl_StringBuilder__f_java$lang$StringBuilder$$content + "Z");
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.toString__T = (function() {
  return "Instant()";
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(printerParser, padWidth, padChar) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser = printerParser;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth = padWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar = padChar;
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var preLen = $n(buf).length__I();
  if ((!$n(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf))) {
    return false;
  }
  var len = (($n(buf).length__I() - preLen) | 0);
  if ((len > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Cannot print as output of " + len) + " characters exceeds pad width of ") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth));
  }
  var i = 0;
  while ((i < ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth - len) | 0))) {
    $n(buf).insert__I__C__jl_StringBuilder(preLen, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar);
    i = ((1 + i) | 0);
  }
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.toString__T = (function() {
  return (((("Pad(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth) + ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar === 32) ? ")" : ((",'" + $cToS(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar)) + "')")));
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator, "java.time.format.internal.TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1(temporal$4, effectiveChrono$2, effectiveZone$2, effectiveDate$2) {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2 = temporal$4;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 = effectiveChrono$2;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 = effectiveZone$2;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 = effectiveDate$2;
}
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1() {
}
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && $n(field).isDateBased__Z())) {
    var this$1 = $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1);
    return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$1, field);
  } else {
    return $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2).isSupported__Ljava_time_temporal_TemporalField__Z(field);
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && $n(field).isDateBased__Z()) ? $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field) : $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field));
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && $n(field).isDateBased__Z())) {
    return $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1).getLong__Ljava_time_temporal_TemporalField__J(field);
  } else {
    return $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2).getLong__Ljava_time_temporal_TemporalField__J(field);
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 : ((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $n(this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2).query__Ljava_time_temporal_TemporalQuery__O(query) : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this))));
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1, "java.time.format.internal.TTBPDateTimePrintContext$$anon$1", ({
  Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1: 1,
  Ljava_time_temporal_TemporalAccessor: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$1() {
}
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$1() {
}
$h_Ljava_time_temporal_TemporalQueries$$anon$1.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O(this));
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$1 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$1, "java.time.temporal.TemporalQueries$$anon$1", ({
  Ljava_time_temporal_TemporalQueries$$anon$1: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$2() {
}
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$2() {
}
$h_Ljava_time_temporal_TemporalQueries$$anon$2.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $as_Ljava_time_chrono_Chronology($n(temporal).query__Ljava_time_temporal_TemporalQuery__O(this));
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$2 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$2, "java.time.temporal.TemporalQueries$$anon$2", ({
  Ljava_time_temporal_TemporalQueries$$anon$2: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$3() {
}
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$3() {
}
$h_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $as_Ljava_time_temporal_TemporalUnit($n(temporal).query__Ljava_time_temporal_TemporalQuery__O(this));
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$3 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$3, "java.time.temporal.TemporalQueries$$anon$3", ({
  Ljava_time_temporal_TemporalQueries$$anon$3: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$4() {
}
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$4() {
}
$h_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset = (function(temporal) {
  return ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset($n(temporal).get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) : null);
});
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$4 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$4, "java.time.temporal.TemporalQueries$$anon$4", ({
  Ljava_time_temporal_TemporalQueries$$anon$4: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$5() {
}
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$5() {
}
$h_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId = (function(temporal) {
  var zone = $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()));
  return ((zone !== null) ? zone : $as_Ljava_time_ZoneId($n(temporal).query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())));
});
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$5 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$5, "java.time.temporal.TemporalQueries$$anon$5", ({
  Ljava_time_temporal_TemporalQueries$$anon$5: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$6() {
}
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$6() {
}
$h_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate = (function(temporal) {
  if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_2 = $m_Ljava_time_LocalDate$();
    var $x_1 = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField());
    return $x_2.ofEpochDay__J__Ljava_time_LocalDate($x_1.l, $x_1.h);
  } else {
    return null;
  }
});
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$6 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$6, "java.time.temporal.TemporalQueries$$anon$6", ({
  Ljava_time_temporal_TemporalQueries$$anon$6: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$7() {
}
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$7() {
}
$h_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime = (function(temporal) {
  if ($n(temporal).isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_2 = $m_Ljava_time_LocalTime$();
    var $x_1 = $n(temporal).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField());
    return $x_2.ofNanoOfDay__J__Ljava_time_LocalTime($x_1.l, $x_1.h);
  } else {
    return null;
  }
});
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$7 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$7, "java.time.temporal.TemporalQueries$$anon$7", ({
  Ljava_time_temporal_TemporalQueries$$anon$7: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ValueRange(minSmallest_$_lo, minSmallest_$_hi, minLargest_$_lo, minLargest_$_hi, maxSmallest_$_lo, maxSmallest_$_hi, maxLargest_$_lo, maxLargest_$_hi) {
  this.Ljava_time_temporal_ValueRange__f_minSmallest_$lo = 0;
  this.Ljava_time_temporal_ValueRange__f_minSmallest_$hi = 0;
  this.Ljava_time_temporal_ValueRange__f_minLargest_$lo = 0;
  this.Ljava_time_temporal_ValueRange__f_minLargest_$hi = 0;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest_$lo = 0;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest_$hi = 0;
  this.Ljava_time_temporal_ValueRange__f_maxLargest_$lo = 0;
  this.Ljava_time_temporal_ValueRange__f_maxLargest_$hi = 0;
  this.Ljava_time_temporal_ValueRange__f_minSmallest_$lo = minSmallest_$_lo;
  this.Ljava_time_temporal_ValueRange__f_minSmallest_$hi = minSmallest_$_hi;
  this.Ljava_time_temporal_ValueRange__f_minLargest_$lo = minLargest_$_lo;
  this.Ljava_time_temporal_ValueRange__f_minLargest_$hi = minLargest_$_hi;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest_$lo = maxSmallest_$_lo;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest_$hi = maxSmallest_$_hi;
  this.Ljava_time_temporal_ValueRange__f_maxLargest_$lo = maxLargest_$_lo;
  this.Ljava_time_temporal_ValueRange__f_maxLargest_$hi = maxLargest_$_hi;
}
$c_Ljava_time_temporal_ValueRange.prototype = new $h_O();
$c_Ljava_time_temporal_ValueRange.prototype.constructor = $c_Ljava_time_temporal_ValueRange;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange() {
}
$h_Ljava_time_temporal_ValueRange.prototype = $c_Ljava_time_temporal_ValueRange.prototype;
$c_Ljava_time_temporal_ValueRange.prototype.isIntValue__Z = (function() {
  var x_$_lo = this.Ljava_time_temporal_ValueRange__f_minSmallest_$lo;
  var x_$_hi = this.Ljava_time_temporal_ValueRange__f_minSmallest_$hi;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 2147483648) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.Ljava_time_temporal_ValueRange__f_maxLargest_$lo;
    var x$1_$_hi = this.Ljava_time_temporal_ValueRange__f_maxLargest_$hi;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 2147483647) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isValidValue__J__Z = (function(value_$_lo, value_$_hi) {
  var x_$_lo = this.Ljava_time_temporal_ValueRange__f_minSmallest_$lo;
  var x_$_hi = this.Ljava_time_temporal_ValueRange__f_minSmallest_$hi;
  if (((value_$_hi === x_$_hi) ? ((value_$_lo >>> 0) >= (x_$_lo >>> 0)) : (value_$_hi > x_$_hi))) {
    var x$1_$_lo = this.Ljava_time_temporal_ValueRange__f_maxLargest_$lo;
    var x$1_$_hi = this.Ljava_time_temporal_ValueRange__f_maxLargest_$hi;
    return ((value_$_hi === x$1_$_hi) ? ((value_$_lo >>> 0) <= (x$1_$_lo >>> 0)) : (value_$_hi < x$1_$_hi));
  } else {
    return false;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isValidIntValue__J__Z = (function(value_$_lo, value_$_hi) {
  return (this.isIntValue__Z() && this.isValidValue__J__Z(value_$_lo, value_$_hi));
});
$c_Ljava_time_temporal_ValueRange.prototype.checkValidValue__J__Ljava_time_temporal_TemporalField__J = (function(value_$_lo, value_$_hi, field) {
  if ((!this.isValidValue__J__Z(value_$_lo, value_$_hi))) {
    if ((field !== null)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Invalid value for " + field) + " (valid values ") + this) + "): ") + $s_RTLong__toString__I__I__T(value_$_lo, value_$_hi)));
    } else {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid value (valid values " + this) + "): ") + $s_RTLong__toString__I__I__T(value_$_lo, value_$_hi)));
    }
  } else {
    return $bL(value_$_lo, value_$_hi);
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I = (function(value_$_lo, value_$_hi, field) {
  if ((!this.isValidIntValue__J__Z(value_$_lo, value_$_hi))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid int value for " + field) + ": ") + $s_RTLong__toString__I__I__T(value_$_lo, value_$_hi)));
  } else {
    return value_$_lo;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_temporal_ValueRange)) {
    var other = $as_Ljava_time_temporal_ValueRange(obj);
    if ((this === other)) {
      return true;
    } else {
      var x_$_lo = this.Ljava_time_temporal_ValueRange__f_minSmallest_$lo;
      var x_$_hi = this.Ljava_time_temporal_ValueRange__f_minSmallest_$hi;
      var x$1_$_lo = $n(other).Ljava_time_temporal_ValueRange__f_minSmallest_$lo;
      var x$1_$_hi = $n(other).Ljava_time_temporal_ValueRange__f_minSmallest_$hi;
      if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
        var x$2_$_lo = this.Ljava_time_temporal_ValueRange__f_minLargest_$lo;
        var x$2_$_hi = this.Ljava_time_temporal_ValueRange__f_minLargest_$hi;
        var x$3_$_lo = $n(other).Ljava_time_temporal_ValueRange__f_minLargest_$lo;
        var x$3_$_hi = $n(other).Ljava_time_temporal_ValueRange__f_minLargest_$hi;
        var $x_2 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        var x$4_$_lo = this.Ljava_time_temporal_ValueRange__f_maxSmallest_$lo;
        var x$4_$_hi = this.Ljava_time_temporal_ValueRange__f_maxSmallest_$hi;
        var x$5_$_lo = $n(other).Ljava_time_temporal_ValueRange__f_maxSmallest_$lo;
        var x$5_$_hi = $n(other).Ljava_time_temporal_ValueRange__f_maxSmallest_$hi;
        var $x_1 = (((x$4_$_lo ^ x$5_$_lo) | (x$4_$_hi ^ x$5_$_hi)) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var x$6_$_lo = this.Ljava_time_temporal_ValueRange__f_maxLargest_$lo;
        var x$6_$_hi = this.Ljava_time_temporal_ValueRange__f_maxLargest_$hi;
        var x$7_$_lo = $n(other).Ljava_time_temporal_ValueRange__f_maxLargest_$lo;
        var x$7_$_hi = $n(other).Ljava_time_temporal_ValueRange__f_maxLargest_$hi;
        return (((x$6_$_lo ^ x$7_$_lo) | (x$6_$_hi ^ x$7_$_hi)) === 0);
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.hashCode__I = (function() {
  var x_$_lo = this.Ljava_time_temporal_ValueRange__f_minSmallest_$lo;
  var x_$_hi = this.Ljava_time_temporal_ValueRange__f_minSmallest_$hi;
  var x$1_$_lo = this.Ljava_time_temporal_ValueRange__f_minLargest_$lo;
  var x$1_$_hi = this.Ljava_time_temporal_ValueRange__f_minLargest_$hi;
  var lo = ((x_$_lo + x$1_$_lo) | 0);
  var hi = ((((x_$_hi + x$1_$_hi) | 0) + ((((x_$_lo & x$1_$_lo) | ((x_$_lo | x$1_$_lo) & (~lo))) >>> 31) | 0)) | 0);
  var x$2_$_lo = this.Ljava_time_temporal_ValueRange__f_minLargest_$lo;
  var x$2_$_hi = this.Ljava_time_temporal_ValueRange__f_minLargest_$hi;
  var lo$1 = ((16 + x$2_$_lo) | 0);
  var lo$2 = (((32 & lo$1) === 0) ? (lo << lo$1) : 0);
  var hi$2 = (((32 & lo$1) === 0) ? (((((lo >>> 1) | 0) >>> (~lo$1)) | 0) | (hi << lo$1)) : (lo << lo$1));
  var x$3_$_lo = this.Ljava_time_temporal_ValueRange__f_maxSmallest_$lo;
  var x$3_$_hi = this.Ljava_time_temporal_ValueRange__f_maxSmallest_$hi;
  var lo$3 = ((48 + x$3_$_lo) | 0);
  var lo$4 = (((32 & lo$3) === 0) ? (((lo$2 >>> lo$3) | 0) | ((hi$2 << 1) << (~lo$3))) : (hi$2 >> lo$3));
  var hi$4 = (((32 & lo$3) === 0) ? (hi$2 >> lo$3) : (hi$2 >> 31));
  var x$4_$_lo = this.Ljava_time_temporal_ValueRange__f_maxSmallest_$lo;
  var x$4_$_hi = this.Ljava_time_temporal_ValueRange__f_maxSmallest_$hi;
  var lo$5 = ((32 + x$4_$_lo) | 0);
  var lo$6 = (((32 & lo$5) === 0) ? (lo$4 << lo$5) : 0);
  var hi$6 = (((32 & lo$5) === 0) ? (((((lo$4 >>> 1) | 0) >>> (~lo$5)) | 0) | (hi$4 << lo$5)) : (lo$4 << lo$5));
  var x$5_$_lo = this.Ljava_time_temporal_ValueRange__f_maxLargest_$lo;
  var x$5_$_hi = this.Ljava_time_temporal_ValueRange__f_maxLargest_$hi;
  var lo$7 = ((32 + x$5_$_lo) | 0);
  var lo$8 = (((32 & lo$7) === 0) ? (((lo$6 >>> lo$7) | 0) | ((hi$6 << 1) << (~lo$7))) : (hi$6 >> lo$7));
  var hi$8 = (((32 & lo$7) === 0) ? (hi$6 >> lo$7) : (hi$6 >> 31));
  var x$6_$_lo = this.Ljava_time_temporal_ValueRange__f_maxLargest_$lo;
  var x$6_$_hi = this.Ljava_time_temporal_ValueRange__f_maxLargest_$hi;
  var lo$9 = ((48 + x$6_$_lo) | 0);
  var lo$10 = (((32 & lo$9) === 0) ? (lo$8 << lo$9) : 0);
  var hi$10 = (((32 & lo$9) === 0) ? (((((lo$8 >>> 1) | 0) >>> (~lo$9)) | 0) | (hi$8 << lo$9)) : (lo$8 << lo$9));
  var lo$11 = (((lo$10 >>> 16) | 0) | (hi$10 << 16));
  var hi$11 = (hi$10 >> 16);
  var lo$12 = (lo$11 ^ hi$11);
  return lo$12;
});
$c_Ljava_time_temporal_ValueRange.prototype.toString__T = (function() {
  var x_$_lo = this.Ljava_time_temporal_ValueRange__f_minSmallest_$lo;
  var x_$_hi = this.Ljava_time_temporal_ValueRange__f_minSmallest_$hi;
  var x$1_$_lo = this.Ljava_time_temporal_ValueRange__f_minLargest_$lo;
  var x$1_$_hi = this.Ljava_time_temporal_ValueRange__f_minLargest_$hi;
  if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) !== 0)) {
    var ss = ("/" + $s_RTLong__toString__I__I__T(this.Ljava_time_temporal_ValueRange__f_minLargest_$lo, this.Ljava_time_temporal_ValueRange__f_minLargest_$hi));
  } else {
    var ss = "";
  }
  var x$2_$_lo = this.Ljava_time_temporal_ValueRange__f_maxSmallest_$lo;
  var x$2_$_hi = this.Ljava_time_temporal_ValueRange__f_maxSmallest_$hi;
  var x$3_$_lo = this.Ljava_time_temporal_ValueRange__f_maxLargest_$lo;
  var x$3_$_hi = this.Ljava_time_temporal_ValueRange__f_maxLargest_$hi;
  if ((((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) !== 0)) {
    var sl = ("/" + $s_RTLong__toString__I__I__T(this.Ljava_time_temporal_ValueRange__f_maxLargest_$lo, this.Ljava_time_temporal_ValueRange__f_maxLargest_$hi));
  } else {
    var sl = "";
  }
  return (((($s_RTLong__toString__I__I__T(this.Ljava_time_temporal_ValueRange__f_minSmallest_$lo, this.Ljava_time_temporal_ValueRange__f_minSmallest_$hi) + ss) + " - ") + $s_RTLong__toString__I__I__T(this.Ljava_time_temporal_ValueRange__f_maxSmallest_$lo, this.Ljava_time_temporal_ValueRange__f_maxSmallest_$hi)) + sl);
});
function $as_Ljava_time_temporal_ValueRange(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_ValueRange) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.ValueRange"));
}
function $isArrayOf_Ljava_time_temporal_ValueRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ValueRange)));
}
function $asArrayOf_Ljava_time_temporal_ValueRange(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_ValueRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.ValueRange;", depth));
}
var $d_Ljava_time_temporal_ValueRange = new $TypeData().initClass($c_Ljava_time_temporal_ValueRange, "java.time.temporal.ValueRange", ({
  Ljava_time_temporal_ValueRange: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_AbstractMap() {
}
$c_ju_AbstractMap.prototype = new $h_O();
$c_ju_AbstractMap.prototype.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
}
$h_ju_AbstractMap.prototype = $c_ju_AbstractMap.prototype;
$c_ju_AbstractMap.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($is_ju_Map(o)) {
    var x2 = $as_ju_Map(o);
    if ((this.size__I() === $n(x2).size__I())) {
      var _\uff3fself = this.entrySet__ju_Set();
      var _\uff3fself$1 = $n(_\uff3fself).iterator__ju_Iterator();
      _return: {
        while ($n(_\uff3fself$1).hasNext__Z()) {
          var t = $n(_\uff3fself$1).next__O();
          var t$1 = $as_ju_Map$Entry(t);
          var $x_2 = $n(x2);
          var this$8 = $n(t$1);
          var a = $x_2.get__O__O(this$8.ju_HashMap$Node__f_key);
          var this$9 = $n(t$1);
          var b = this$9.ju_HashMap$Node__f_value;
          if ((!((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b)))) {
            var $x_1 = true;
            break _return;
          }
        }
        var $x_1 = false;
      }
      return (!$x_1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_AbstractMap.prototype.hashCode__I = (function() {
  var _\uff3fself = this.entrySet__ju_Set();
  var _\uff3fself$1 = $n(_\uff3fself).iterator__ju_Iterator();
  var result = 0;
  while ($n(_\uff3fself$1).hasNext__Z()) {
    var t = result;
    var u = $n(_\uff3fself$1).next__O();
    var t$1 = $uI(t);
    var u$1 = $as_ju_Map$Entry(u);
    result = (($n(u$1).hashCode__I() + t$1) | 0);
  }
  return $uI(result);
});
$c_ju_AbstractMap.prototype.toString__T = (function() {
  var result = "{";
  var first = true;
  var iter = $n(this.entrySet__ju_Set()).iterator__ju_Iterator();
  while ($n(iter).hasNext__Z()) {
    var entry = $as_ju_Map$Entry($n(iter).next__O());
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    var $x_2 = result;
    var this$1 = $n(entry);
    var $x_1 = this$1.ju_HashMap$Node__f_key;
    var this$2 = $n(entry);
    result = (((("" + $x_2) + $x_1) + "=") + this$2.ju_HashMap$Node__f_value);
  }
  return (result + "}");
});
/** @constructor */
function $c_ju_Arrays$NaturalComparator$() {
}
$c_ju_Arrays$NaturalComparator$.prototype = new $h_O();
$c_ju_Arrays$NaturalComparator$.prototype.constructor = $c_ju_Arrays$NaturalComparator$;
/** @constructor */
function $h_ju_Arrays$NaturalComparator$() {
}
$h_ju_Arrays$NaturalComparator$.prototype = $c_ju_Arrays$NaturalComparator$.prototype;
$c_ju_Arrays$NaturalComparator$.prototype.compare__O__O__I = (function(o1, o2) {
  return $dp_compareTo__O__I($n($as_jl_Comparable(o1)), o2);
});
var $d_ju_Arrays$NaturalComparator$ = new $TypeData().initClass($c_ju_Arrays$NaturalComparator$, "java.util.Arrays$NaturalComparator$", ({
  ju_Arrays$NaturalComparator$: 1,
  ju_Comparator: 1
}));
var $n_ju_Arrays$NaturalComparator$;
function $m_ju_Arrays$NaturalComparator$() {
  if ((!$n_ju_Arrays$NaturalComparator$)) {
    $n_ju_Arrays$NaturalComparator$ = new $c_ju_Arrays$NaturalComparator$();
  }
  return $n_ju_Arrays$NaturalComparator$;
}
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Collection)));
}
function $as_ju_Collection(obj) {
  return (($is_ju_Collection(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Collection"));
}
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Collection)));
}
function $asArrayOf_ju_Collection(obj, depth) {
  return (($isArrayOf_ju_Collection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Collection;", depth));
}
/** @constructor */
function $c_ju_Formatter$RootLocaleInfo$() {
}
$c_ju_Formatter$RootLocaleInfo$.prototype = new $h_ju_Formatter$LocaleInfo();
$c_ju_Formatter$RootLocaleInfo$.prototype.constructor = $c_ju_Formatter$RootLocaleInfo$;
/** @constructor */
function $h_ju_Formatter$RootLocaleInfo$() {
}
$h_ju_Formatter$RootLocaleInfo$.prototype = $c_ju_Formatter$RootLocaleInfo$.prototype;
var $d_ju_Formatter$RootLocaleInfo$ = new $TypeData().initClass($c_ju_Formatter$RootLocaleInfo$, "java.util.Formatter$RootLocaleInfo$", ({
  ju_Formatter$RootLocaleInfo$: 1,
  ju_Formatter$LocaleInfo: 1
}));
var $n_ju_Formatter$RootLocaleInfo$;
function $m_ju_Formatter$RootLocaleInfo$() {
  if ((!$n_ju_Formatter$RootLocaleInfo$)) {
    $n_ju_Formatter$RootLocaleInfo$ = new $c_ju_Formatter$RootLocaleInfo$();
  }
  return $n_ju_Formatter$RootLocaleInfo$;
}
function $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__($thiz, outer) {
  $n(outer);
  $thiz.ju_HashMap$AbstractHashMapIterator__f_$outer = outer;
  $thiz.ju_HashMap$AbstractHashMapIterator__f_len = $n($n(outer).ju_HashMap__f_java$util$HashMap$$table).u.length;
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap$AbstractHashMapIterator() {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
}
$c_ju_HashMap$AbstractHashMapIterator.prototype = new $h_O();
$c_ju_HashMap$AbstractHashMapIterator.prototype.constructor = $c_ju_HashMap$AbstractHashMapIterator;
/** @constructor */
function $h_ju_HashMap$AbstractHashMapIterator() {
}
$h_ju_HashMap$AbstractHashMapIterator.prototype = $c_ju_HashMap$AbstractHashMapIterator.prototype;
$c_ju_HashMap$AbstractHashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.ju_HashMap$AbstractHashMapIterator__f_nextNode !== null)) {
    return true;
  } else {
    while ((this.ju_HashMap$AbstractHashMapIterator__f_nextIdx < this.ju_HashMap$AbstractHashMapIterator__f_len)) {
      var node = $n($n(this.ju_HashMap$AbstractHashMapIterator__f_$outer).ju_HashMap__f_java$util$HashMap$$table).get(this.ju_HashMap$AbstractHashMapIterator__f_nextIdx);
      this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = ((1 + this.ju_HashMap$AbstractHashMapIterator__f_nextIdx) | 0);
      if ((node !== null)) {
        this.ju_HashMap$AbstractHashMapIterator__f_nextNode = node;
        return true;
      }
    }
    return false;
  }
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
  }
  var node = this.ju_HashMap$AbstractHashMapIterator__f_nextNode;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = node;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = $n(node).ju_HashMap$Node__f_next;
  return this.extract__ju_HashMap$Node__O(node);
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.remove__V = (function() {
  var last = this.ju_HashMap$AbstractHashMapIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove");
  }
  $n(this.ju_HashMap$AbstractHashMapIterator__f_$outer).removeNode__ju_HashMap$Node__V(last);
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
});
function $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__($thiz, key, hash, value, previous, next) {
  $thiz.ju_HashMap$Node__f_key = key;
  $thiz.ju_HashMap$Node__f_hash = hash;
  $thiz.ju_HashMap$Node__f_value = value;
  $thiz.ju_HashMap$Node__f_previous = previous;
  $thiz.ju_HashMap$Node__f_next = next;
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap$Node() {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
}
$c_ju_HashMap$Node.prototype = new $h_O();
$c_ju_HashMap$Node.prototype.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
}
$h_ju_HashMap$Node.prototype = $c_ju_HashMap$Node.prototype;
$c_ju_HashMap$Node.prototype.equals__O__Z = (function(that) {
  if ($is_ju_Map$Entry(that)) {
    var x2 = $as_ju_Map$Entry(that);
    var a = this.ju_HashMap$Node__f_key;
    var this$1 = $n(x2);
    var b = this$1.ju_HashMap$Node__f_key;
    if (((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b))) {
      var a$1 = this.ju_HashMap$Node__f_value;
      var this$3 = $n(x2);
      var b$1 = this$3.ju_HashMap$Node__f_value;
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z($n(a$1), b$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_HashMap$Node.prototype.hashCode__I = (function() {
  var improvedHash = this.ju_HashMap$Node__f_hash;
  var o = this.ju_HashMap$Node__f_value;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $dp_hashCode__I($n(o))));
});
$c_ju_HashMap$Node.prototype.toString__T = (function() {
  return ((this.ju_HashMap$Node__f_key + "=") + this.ju_HashMap$Node__f_value);
});
function $as_ju_HashMap$Node(obj) {
  return (((obj instanceof $c_ju_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.HashMap$Node"));
}
function $isArrayOf_ju_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_HashMap$Node)));
}
function $asArrayOf_ju_HashMap$Node(obj, depth) {
  return (($isArrayOf_ju_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.HashMap$Node;", depth));
}
var $d_ju_HashMap$Node = new $TypeData().initClass($c_ju_HashMap$Node, "java.util.HashMap$Node", ({
  ju_HashMap$Node: 1,
  ju_Map$Entry: 1
}));
function $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__($thiz, outer) {
  $n(outer);
  $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = outer;
  $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = $n(outer).ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest;
  return $thiz;
}
/** @constructor */
function $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
}
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = new $h_O();
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.constructor = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator;
/** @constructor */
function $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
}
$h_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype;
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.hasNext__Z = (function() {
  return (this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode !== null);
});
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
  }
  var node = this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = node;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = $n(node).ju_LinkedHashMap$Node__f_younger;
  return this.extract__ju_LinkedHashMap$Node__O(node);
});
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.remove__V = (function() {
  var last = this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove");
  }
  $n(this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer).removeNode__ju_HashMap$Node__V(last);
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
});
function $p_ju_Random$__randomInt__I($thiz) {
  var a = (4.294967296E9 * $uD(Math.random()));
  return $doubleToInt(($uD(Math.floor(a)) - 2.147483648E9));
}
/** @constructor */
function $c_ju_Random$() {
}
$c_ju_Random$.prototype = new $h_O();
$c_ju_Random$.prototype.constructor = $c_ju_Random$;
/** @constructor */
function $h_ju_Random$() {
}
$h_ju_Random$.prototype = $c_ju_Random$.prototype;
$c_ju_Random$.prototype.java$util$Random$$randomSeed__J = (function() {
  var value = $p_ju_Random$__randomInt__I(this);
  var value$1 = $p_ju_Random$__randomInt__I(this);
  return $bL(value$1, value);
});
var $d_ju_Random$ = new $TypeData().initClass($c_ju_Random$, "java.util.Random$", ({
  ju_Random$: 1,
  Ljava_io_Serializable: 1
}));
var $n_ju_Random$;
function $m_ju_Random$() {
  if ((!$n_ju_Random$)) {
    $n_ju_Random$ = new $c_ju_Random$();
  }
  return $n_ju_Random$;
}
function $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__($thiz, outer) {
  $n(outer);
  $thiz.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = outer;
  var this$1 = $n($n(outer).java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList());
  $thiz.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = this$1.listIterator__I__ju_ListIterator(0);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = new $h_O();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.hasNext__Z = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter).hasNext__Z();
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.next__O = (function() {
  var node = $as_ju_HashMap$Node($n(this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter).next__O());
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = node;
  return this.extract__ju_HashMap$Node__O(node);
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.remove__V = (function() {
  var last = this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove");
  }
  $n(this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer).removeNode__ju_HashMap$Node__V(last);
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
});
/** @constructor */
function $c_ju_concurrent_ThreadLocalRandom$() {
  this.ju_concurrent_ThreadLocalRandom$__f__current = null;
  $n_ju_concurrent_ThreadLocalRandom$ = this;
  this.ju_concurrent_ThreadLocalRandom$__f__current = new $c_ju_concurrent_ThreadLocalRandom();
}
$c_ju_concurrent_ThreadLocalRandom$.prototype = new $h_O();
$c_ju_concurrent_ThreadLocalRandom$.prototype.constructor = $c_ju_concurrent_ThreadLocalRandom$;
/** @constructor */
function $h_ju_concurrent_ThreadLocalRandom$() {
}
$h_ju_concurrent_ThreadLocalRandom$.prototype = $c_ju_concurrent_ThreadLocalRandom$.prototype;
var $d_ju_concurrent_ThreadLocalRandom$ = new $TypeData().initClass($c_ju_concurrent_ThreadLocalRandom$, "java.util.concurrent.ThreadLocalRandom$", ({
  ju_concurrent_ThreadLocalRandom$: 1,
  Ljava_io_Serializable: 1
}));
var $n_ju_concurrent_ThreadLocalRandom$;
function $m_ju_concurrent_ThreadLocalRandom$() {
  if ((!$n_ju_concurrent_ThreadLocalRandom$)) {
    $n_ju_concurrent_ThreadLocalRandom$ = new $c_ju_concurrent_ThreadLocalRandom$();
  }
  return $n_ju_concurrent_ThreadLocalRandom$;
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$() {
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = null;
  this.ju_concurrent_TimeUnit$__f_SECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MINUTES = null;
  this.ju_concurrent_TimeUnit$__f_HOURS = null;
  this.ju_concurrent_TimeUnit$__f_DAYS = null;
  $n_ju_concurrent_TimeUnit$ = this;
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = new $c_ju_concurrent_TimeUnit$$anon$1();
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = new $c_ju_concurrent_TimeUnit$$anon$2();
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = new $c_ju_concurrent_TimeUnit$$anon$3();
  this.ju_concurrent_TimeUnit$__f_SECONDS = new $c_ju_concurrent_TimeUnit$$anon$4();
  this.ju_concurrent_TimeUnit$__f_MINUTES = new $c_ju_concurrent_TimeUnit$$anon$5();
  this.ju_concurrent_TimeUnit$__f_HOURS = new $c_ju_concurrent_TimeUnit$$anon$6();
  this.ju_concurrent_TimeUnit$__f_DAYS = new $c_ju_concurrent_TimeUnit$$anon$7();
}
$c_ju_concurrent_TimeUnit$.prototype = new $h_O();
$c_ju_concurrent_TimeUnit$.prototype.constructor = $c_ju_concurrent_TimeUnit$;
/** @constructor */
function $h_ju_concurrent_TimeUnit$() {
}
$h_ju_concurrent_TimeUnit$.prototype = $c_ju_concurrent_TimeUnit$.prototype;
$c_ju_concurrent_TimeUnit$.prototype.java$util$concurrent$TimeUnit$$x__J__J__J__J = (function(a_$_lo, a_$_hi, b_$_lo, b_$_hi, max_$_lo, max_$_hi) {
  if (((a_$_hi === max_$_hi) ? ((a_$_lo >>> 0) > (max_$_lo >>> 0)) : (a_$_hi > max_$_hi))) {
    return $bL((-1), 2147483647);
  } else {
    var lo = ((-max_$_lo) | 0);
    var hi = ((((-max_$_hi) | 0) + ((max_$_lo | lo) >> 31)) | 0);
    if (((a_$_hi === hi) ? ((a_$_lo >>> 0) < (lo >>> 0)) : (a_$_hi < hi))) {
      return $bL(1, (-2147483648));
    } else {
      var a0 = (65535 & a_$_lo);
      var a1 = ((a_$_lo >>> 16) | 0);
      var b0 = (65535 & b_$_lo);
      var b1 = ((b_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((((((((Math.imul(a_$_lo, b_$_hi) + Math.imul(a_$_hi, b_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $bL(lo$1, hi$1);
    }
  }
});
var $d_ju_concurrent_TimeUnit$ = new $TypeData().initClass($c_ju_concurrent_TimeUnit$, "java.util.concurrent.TimeUnit$", ({
  ju_concurrent_TimeUnit$: 1,
  Ljava_io_Serializable: 1
}));
var $n_ju_concurrent_TimeUnit$;
function $m_ju_concurrent_TimeUnit$() {
  if ((!$n_ju_concurrent_TimeUnit$)) {
    $n_ju_concurrent_TimeUnit$ = new $c_ju_concurrent_TimeUnit$();
  }
  return $n_ju_concurrent_TimeUnit$;
}
function $ct_ju_concurrent_atomic_AtomicBoolean__Z__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = value;
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicBoolean() {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
}
$c_ju_concurrent_atomic_AtomicBoolean.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicBoolean.prototype.constructor = $c_ju_concurrent_atomic_AtomicBoolean;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicBoolean() {
}
$h_ju_concurrent_atomic_AtomicBoolean.prototype = $c_ju_concurrent_atomic_AtomicBoolean.prototype;
$c_ju_concurrent_atomic_AtomicBoolean.prototype.compareAndSet__Z__Z__Z = (function(expect, update) {
  if ((expect === this.ju_concurrent_atomic_AtomicBoolean__f_value)) {
    this.ju_concurrent_atomic_AtomicBoolean__f_value = update;
    return true;
  } else {
    return false;
  }
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.getAndSet__Z__Z = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  this.ju_concurrent_atomic_AtomicBoolean__f_value = newValue;
  return old;
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  return ("" + this$1);
});
function $as_ju_concurrent_atomic_AtomicBoolean(obj) {
  return (((obj instanceof $c_ju_concurrent_atomic_AtomicBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.atomic.AtomicBoolean"));
}
function $isArrayOf_ju_concurrent_atomic_AtomicBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_atomic_AtomicBoolean)));
}
function $asArrayOf_ju_concurrent_atomic_AtomicBoolean(obj, depth) {
  return (($isArrayOf_ju_concurrent_atomic_AtomicBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.atomic.AtomicBoolean;", depth));
}
var $d_ju_concurrent_atomic_AtomicBoolean = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicBoolean, "java.util.concurrent.atomic.AtomicBoolean", ({
  ju_concurrent_atomic_AtomicBoolean: 1,
  Ljava_io_Serializable: 1
}));
function $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicReference__f_value = value;
  return $thiz;
}
function $ct_ju_concurrent_atomic_AtomicReference__($thiz) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, null);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicReference() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
}
$c_ju_concurrent_atomic_AtomicReference.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicReference.prototype.constructor = $c_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicReference() {
}
$h_ju_concurrent_atomic_AtomicReference.prototype = $c_ju_concurrent_atomic_AtomicReference.prototype;
$c_ju_concurrent_atomic_AtomicReference.prototype.compareAndSet__O__O__Z = (function(expect, update) {
  if (Object.is(expect, this.ju_concurrent_atomic_AtomicReference__f_value)) {
    this.ju_concurrent_atomic_AtomicReference__f_value = update;
    return true;
  } else {
    return false;
  }
});
$c_ju_concurrent_atomic_AtomicReference.prototype.getAndSet__O__O = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicReference__f_value;
  this.ju_concurrent_atomic_AtomicReference__f_value = newValue;
  return old;
});
$c_ju_concurrent_atomic_AtomicReference.prototype.toString__T = (function() {
  var obj = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ("" + obj);
});
var $d_ju_concurrent_atomic_AtomicReference = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicReference, "java.util.concurrent.atomic.AtomicReference", ({
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_O(a, 1);
  $n(a$1).set(i, v);
});
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_O(a, 1);
  return $n(a$1).get(i);
});
var $d_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$, "java.util.internal.GenericArrayOps$ReusableAnyRefArrayOps$", ({
  ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1
}));
var $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
function $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
}
function $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher($thiz) {
  $thiz.ju_regex_Matcher__f_position = 0;
  $thiz.ju_regex_Matcher__f_lastMatch = null;
  $thiz.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = 0;
  return $thiz;
}
function $p_ju_regex_Matcher__ensureLastMatch__O($thiz) {
  if (($thiz.ju_regex_Matcher__f_lastMatch === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "No match available");
  }
  return $thiz.ju_regex_Matcher__f_lastMatch;
}
/** @constructor */
function $c_ju_regex_Matcher(pattern0, input0) {
  this.ju_regex_Matcher__f_pattern0 = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = null;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr = null;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = 0;
  this.ju_regex_Matcher__f_pattern0 = pattern0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = input0;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0);
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = 0;
}
$c_ju_regex_Matcher.prototype = new $h_O();
$c_ju_regex_Matcher.prototype.constructor = $c_ju_regex_Matcher;
/** @constructor */
function $h_ju_regex_Matcher() {
}
$h_ju_regex_Matcher.prototype = $c_ju_regex_Matcher.prototype;
$c_ju_regex_Matcher.prototype.matches__Z = (function() {
  $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  this.ju_regex_Matcher__f_lastMatch = $n(this.ju_regex_Matcher__f_pattern0).execMatches__T__O(this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr);
  return (this.ju_regex_Matcher__f_lastMatch !== null);
});
$c_ju_regex_Matcher.prototype.find__Z = (function() {
  var this$1 = $n(this.ju_regex_Matcher__f_pattern0);
  var input = this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr;
  var start = this.ju_regex_Matcher__f_position;
  var mtch = this$1.java$util$regex$Pattern$$execFindInternal__T__I__O(input, start);
  var end = $uI(this$1.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind.lastIndex);
  if ((mtch !== null)) {
    var $x_1 = ((end === $uI(mtch.index)) ? ((1 + end) | 0) : end);
  } else {
    var this$2 = $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr);
    var $x_1 = ((1 + this$2.length) | 0);
  }
  this.ju_regex_Matcher__f_position = $x_1;
  this.ju_regex_Matcher__f_lastMatch = mtch;
  return (mtch !== null);
});
$c_ju_regex_Matcher.prototype.appendReplacement__jl_StringBuilder__T__ju_regex_Matcher = (function(sb, replacement) {
  var this$2 = $n(sb);
  var this$1 = $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr);
  var beginIndex = this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos;
  var endIndex = this.start__I();
  if ((beginIndex < 0)) {
    $charAt(this$1, beginIndex);
  }
  if ((endIndex > this$1.length)) {
    $charAt(this$1, endIndex);
  }
  if ((endIndex < beginIndex)) {
    $charAt(this$1, (-1));
  }
  var csq = $as_T(this$1.substring(beginIndex, endIndex));
  this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + csq);
  var this$3 = $n(replacement);
  var len = this$3.length;
  var i = 0;
  while ((i < len)) {
    var this$4 = $n(replacement);
    var index = i;
    var x1 = $charAt(this$4, index);
    switch (x1) {
      case 36: {
        i = ((1 + i) | 0);
        var j = i;
        while (true) {
          if ((i < len)) {
            var this$5 = $n(replacement);
            var index$1 = i;
            var c = $charAt(this$5, index$1);
            var $x_1 = ((((c - 48) | 0) >>> 0) <= 9);
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            i = ((1 + i) | 0);
          } else {
            break;
          }
        }
        var this$7 = $m_jl_Integer$();
        var this$6 = $n(replacement);
        var endIndex$1 = i;
        if ((j < 0)) {
          $charAt(this$6, j);
        }
        if ((endIndex$1 > this$6.length)) {
          $charAt(this$6, endIndex$1);
        }
        if ((endIndex$1 < j)) {
          $charAt(this$6, (-1));
        }
        var s = $as_T(this$6.substring(j, endIndex$1));
        var group = this$7.java$lang$Integer$$parseIntImpl__T__I__I__I(s, 10, 214748364);
        var replaced = this.group__I__T(group);
        if ((replaced !== null)) {
          var this$8 = $n(sb);
          this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + replaced);
        }
        break;
      }
      case 92: {
        i = ((1 + i) | 0);
        if ((i < len)) {
          var this$10 = $n(sb);
          var this$9 = $n(replacement);
          var index$2 = i;
          var c$1 = $charAt(this$9, index$2);
          var str = ("" + $cToS(c$1));
          this$10.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$10.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
        }
        i = ((1 + i) | 0);
        break;
      }
      default: {
        var this$12 = $n(sb);
        var str$1 = ("" + $cToS(x1));
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
        i = ((1 + i) | 0);
      }
    }
  }
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = this.end__I();
  return this;
});
$c_ju_regex_Matcher.prototype.appendTail__jl_StringBuilder__jl_StringBuilder = (function(sb) {
  var this$2 = $n(sb);
  var this$1 = $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr);
  var beginIndex = this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos;
  if (((beginIndex < 0) || (beginIndex > this$1.length))) {
    $charAt(this$1, beginIndex);
  }
  var str = $as_T(this$1.substring(beginIndex));
  this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  var this$3 = $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr);
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = this$3.length;
  return sb;
});
$c_ju_regex_Matcher.prototype.replaceFirst__T__T = (function(replacement) {
  this.reset__ju_regex_Matcher();
  if (this.find__Z()) {
    var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
    this.appendReplacement__jl_StringBuilder__T__ju_regex_Matcher(sb, replacement);
    this.appendTail__jl_StringBuilder__jl_StringBuilder(sb);
    return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  } else {
    return this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr;
  }
});
$c_ju_regex_Matcher.prototype.replaceAll__T__T = (function(replacement) {
  this.reset__ju_regex_Matcher();
  var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  while (this.find__Z()) {
    this.appendReplacement__jl_StringBuilder__T__ju_regex_Matcher(sb, replacement);
  }
  this.appendTail__jl_StringBuilder__jl_StringBuilder(sb);
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_ju_regex_Matcher.prototype.reset__ju_regex_Matcher = (function() {
  this.ju_regex_Matcher__f_regionStart0 = 0;
  $n(this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0);
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  return $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
});
$c_ju_regex_Matcher.prototype.start__I = (function() {
  return (($uI($p_ju_regex_Matcher__ensureLastMatch__O(this).index) + this.ju_regex_Matcher__f_regionStart0) | 0);
});
$c_ju_regex_Matcher.prototype.end__I = (function() {
  var $x_1 = this.start__I();
  var this$1 = $n(this.group__T());
  return (($x_1 + this$1.length) | 0);
});
$c_ju_regex_Matcher.prototype.group__T = (function() {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[0];
  return $as_T(x);
});
$c_ju_regex_Matcher.prototype.group__I__T = (function(group) {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[$n(this.ju_regex_Matcher__f_pattern0).numberedGroup__I__I(group)];
  return $as_T(((x !== (void 0)) ? x : null));
});
var $d_ju_regex_Matcher = new $TypeData().initClass($c_ju_regex_Matcher, "java.util.regex.Matcher", ({
  ju_regex_Matcher: 1,
  ju_regex_MatchResult: 1
}));
/** @constructor */
function $c_ju_regex_Pattern(_pattern, _flags, jsPattern, jsFlags, sticky, groupCount, groupNumberMap, namedGroups) {
  this.ju_regex_Pattern__f__pattern = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = false;
  this.ju_regex_Pattern__f_groupCount = 0;
  this.ju_regex_Pattern__f_groupNumberMap = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = null;
  this.ju_regex_Pattern__f_jsRegExpForMatches = null;
  this.ju_regex_Pattern__f__pattern = _pattern;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = jsFlags;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = sticky;
  this.ju_regex_Pattern__f_groupCount = groupCount;
  this.ju_regex_Pattern__f_groupNumberMap = groupNumberMap;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = new RegExp(jsPattern, (this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags + (this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky ? "gy" : "g")));
  this.ju_regex_Pattern__f_jsRegExpForMatches = new RegExp((("^(?:" + jsPattern) + ")$"), jsFlags);
}
$c_ju_regex_Pattern.prototype = new $h_O();
$c_ju_regex_Pattern.prototype.constructor = $c_ju_regex_Pattern;
/** @constructor */
function $h_ju_regex_Pattern() {
}
$h_ju_regex_Pattern.prototype = $c_ju_regex_Pattern.prototype;
$c_ju_regex_Pattern.prototype.execMatches__T__O = (function(input) {
  return this.ju_regex_Pattern__f_jsRegExpForMatches.exec(input);
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$execFindInternal__T__I__O = (function(input, start) {
  var regexp = this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind;
  regexp.lastIndex = start;
  return regexp.exec(input);
});
$c_ju_regex_Pattern.prototype.numberedGroup__I__I = (function(group) {
  if (((group < 0) || (group > this.ju_regex_Pattern__f_groupCount))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + group));
  }
  return $uI(this.ju_regex_Pattern__f_groupNumberMap[group]);
});
$c_ju_regex_Pattern.prototype.toString__T = (function() {
  return this.ju_regex_Pattern__f__pattern;
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$split__T__I__AT = (function(inputStr, limit) {
  if ((inputStr === "")) {
    return new ($d_T.getArrayOf().constr)([""]);
  } else {
    var lim = ((limit > 0) ? limit : 2147483647);
    var this$1 = $n(inputStr);
    var matcher = new $c_ju_regex_Matcher(this, this$1);
    var result = [];
    var prevEnd = 0;
    while ((($uI(result.length) < ((lim - 1) | 0)) && matcher.find__Z())) {
      if ((matcher.end__I() !== 0)) {
        var this$2 = $n(inputStr);
        var beginIndex = prevEnd;
        var endIndex = matcher.start__I();
        if ((beginIndex < 0)) {
          $charAt(this$2, beginIndex);
        }
        if ((endIndex > this$2.length)) {
          $charAt(this$2, endIndex);
        }
        if ((endIndex < beginIndex)) {
          $charAt(this$2, (-1));
        }
        var $x_1 = result.push($as_T(this$2.substring(beginIndex, endIndex)));
        $uI($x_1);
      }
      prevEnd = matcher.end__I();
    }
    var this$3 = $n(inputStr);
    var beginIndex$1 = prevEnd;
    if (((beginIndex$1 < 0) || (beginIndex$1 > this$3.length))) {
      $charAt(this$3, beginIndex$1);
    }
    result.push($as_T(this$3.substring(beginIndex$1)));
    var actualLength = $uI(result.length);
    if ((limit === 0)) {
      while (true) {
        if ((actualLength !== 0)) {
          var x = result[((actualLength - 1) | 0)];
          var $x_2 = ((x !== null) && $dp_equals__O__Z($n(x), ""));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          actualLength = ((actualLength - 1) | 0);
        } else {
          break;
        }
      }
    }
    var r = new ($d_T.getArrayOf().constr)(actualLength);
    var end = actualLength;
    var i = 0;
    while ((i < end)) {
      var value = i;
      r.set(value, $as_T(result[value]));
      i = ((1 + i) | 0);
    }
    return r;
  }
});
var $d_ju_regex_Pattern = new $TypeData().initClass($c_ju_regex_Pattern, "java.util.regex.Pattern", ({
  ju_regex_Pattern: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llocales_cldr_fallback_LocalesProvider$() {
}
$c_Llocales_cldr_fallback_LocalesProvider$.prototype = new $h_O();
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.constructor = $c_Llocales_cldr_fallback_LocalesProvider$;
/** @constructor */
function $h_Llocales_cldr_fallback_LocalesProvider$() {
}
$h_Llocales_cldr_fallback_LocalesProvider$.prototype = $c_Llocales_cldr_fallback_LocalesProvider$.prototype;
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.ldmls__sci_Map = (function() {
  var $x_12 = $m_s_Predef$();
  var xs = $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$().all__ALlocales_cldr_LDML();
  var f = ((x$1) => {
    var x$1$1 = $as_Llocales_cldr_LDML(x$1);
    var this$3 = $n(x$1$1);
    var _1 = $n(this$3.toLocale__ju_Locale()).toLanguageTag__T();
    return new $c_T2(_1, x$1$1);
  });
  var len = $n(xs).u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = $n(xs).get(i);
        ys.set($x_1, $as_T2(f(x0)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = $n(x3).get(i);
        ys.set($x_2, $as_T2(f(x0$1)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = $n(x4).get(i);
        ys.set($x_3, $as_T2(f(x0$2)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i < len)) {
        var $x_6 = i;
        var $x_4 = $n(x5).u;
        var $x_5 = $aJCheckGet($x_4, i);
        var x0$3_$_lo = $x_4[$x_5];
        var x0$3_$_hi = $x_4[(($x_5 + 1) | 0)];
        ys.set($x_6, $as_T2(f($bL(x0$3_$_lo, x0$3_$_hi))));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i < len)) {
        var $x_7 = i;
        var x0$4 = $n(x6).get(i);
        ys.set($x_7, $as_T2(f(x0$4)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i < len)) {
        var $x_8 = i;
        var x0$5 = $n(x7).get(i);
        ys.set($x_8, $as_T2(f($bC(x0$5))));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i < len)) {
        var $x_9 = i;
        var x0$6 = $n(x8).get(i);
        ys.set($x_9, $as_T2(f(x0$6)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i < len)) {
        var $x_10 = i;
        var x0$7 = $n(x9).get(i);
        ys.set($x_10, $as_T2(f(x0$7)));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i < len)) {
        var $x_11 = i;
        var x0$8 = $n(x10).get(i);
        ys.set($x_11, $as_T2(f(x0$8)));
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
  }
  var this$9 = $n($x_12.wrapRefArray__AO__scm_ArraySeq$ofRef(ys));
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$9);
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.currencyData__Llocales_cldr_CurrencyData = (function() {
  return new $c_Llocales_cldr_CurrencyData($as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()), $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()), $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()), $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()));
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.metadata__Llocales_cldr_CLDRMetadata = (function() {
  return new $c_Llocales_cldr_CLDRMetadata(new ($d_T.getArrayOf().constr)(0), $m_sci_Map$EmptyMap$(), new ($d_T.getArrayOf().constr)(0), $m_sci_Map$EmptyMap$(), new ($d_T.getArrayOf().constr)(0));
});
var $d_Llocales_cldr_fallback_LocalesProvider$ = new $TypeData().initClass($c_Llocales_cldr_fallback_LocalesProvider$, "locales.cldr.fallback.LocalesProvider$", ({
  Llocales_cldr_fallback_LocalesProvider$: 1,
  Llocales_cldr_LocalesProvider: 1
}));
var $n_Llocales_cldr_fallback_LocalesProvider$;
function $m_Llocales_cldr_fallback_LocalesProvider$() {
  if ((!$n_Llocales_cldr_fallback_LocalesProvider$)) {
    $n_Llocales_cldr_fallback_LocalesProvider$ = new $c_Llocales_cldr_fallback_LocalesProvider$();
  }
  return $n_Llocales_cldr_fallback_LocalesProvider$;
}
function $is_Lnet_andimiller_hedgehogs_DataGraph(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lnet_andimiller_hedgehogs_DataGraph)));
}
function $as_Lnet_andimiller_hedgehogs_DataGraph(obj) {
  return (($is_Lnet_andimiller_hedgehogs_DataGraph(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.DataGraph"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_DataGraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_DataGraph)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_DataGraph(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_DataGraph(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.DataGraph;", depth));
}
function $f_Lnet_andimiller_hedgehogs_dag_visitor_SimpleSuspendableDagVisitor__run__O__O__Lnet_andimiller_hedgehogs_DataGraph__sci_Map__O($thiz, id, node, graph, inputs) {
  var inputs$1 = $as_sci_Map($n(inputs).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x65 = $as_T2($n(x$1$1)._1__O());
      if ((x65 !== null)) {
        var k = $n(x65)._1__O();
        var v = $n(x$1$1)._2__O();
        return new $c_T2(k, v);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
  return $thiz.run__T__Lnet_andimiller_hedgehogs_dag_visitor_Node__sci_Map__Lcats_effect_IO($as_T(id), $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(node), inputs$1);
}
function $f_Lnet_andimiller_hedgehogs_dag_visitor_SimpleSuspendableDagVisitor__resume__O__O__O__O__Lnet_andimiller_hedgehogs_DataGraph__sci_Map__O($thiz, id, node, handle, payload, graph, inputs) {
  var inputs$1 = $as_sci_Map($n(inputs).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x70 = $as_T2($n(x$1$1)._1__O());
      if ((x70 !== null)) {
        var k = $n(x70)._1__O();
        var v = $n(x$1$1)._2__O();
        return new $c_T2(k, v);
      }
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
  return $thiz.resume__T__Lnet_andimiller_hedgehogs_dag_visitor_Node__T__T__sci_Map__Lcats_effect_IO($as_T(id), $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(node), $as_T(handle), $as_T(payload), inputs$1);
}
/** @constructor */
function $c_s_$less$colon$less$() {
  this.s_$less$colon$less$__f_singleton = null;
  $n_s_$less$colon$less$ = this;
  this.s_$less$colon$less$__f_singleton = new $c_s_$less$colon$less$$anon$1();
}
$c_s_$less$colon$less$.prototype = new $h_O();
$c_s_$less$colon$less$.prototype.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
}
$h_s_$less$colon$less$.prototype = $c_s_$less$colon$less$.prototype;
var $d_s_$less$colon$less$ = new $TypeData().initClass($c_s_$less$colon$less$, "scala.$less$colon$less$", ({
  s_$less$colon$less$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$();
  }
  return $n_s_$less$colon$less$;
}
function $p_s_Array$__slowcopy__O__I__O__I__I__V($thiz, src, srcPos, dest, destPos, length) {
  var i = srcPos;
  var j = destPos;
  var srcUntil = ((srcPos + length) | 0);
  while ((i < srcUntil)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(src, i));
    i = ((1 + i) | 0);
    j = ((1 + j) | 0);
  }
}
function $p_s_Array$__newUnitArray__I__Ajl_Void($thiz, len) {
  var result = new ($d_jl_Void.getArrayOf().constr)(len);
  $m_ju_Arrays$().fill__AO__O__V(result, (void 0));
  return result;
}
/** @constructor */
function $c_s_Array$() {
}
$c_s_Array$.prototype = new $h_O();
$c_s_Array$.prototype.constructor = $c_s_Array$;
/** @constructor */
function $h_s_Array$() {
}
$h_s_Array$.prototype = $c_s_Array$.prototype;
$c_s_Array$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__O = (function(it, evidence$3) {
  var n = $n(it).knownSize__I();
  if ((n > (-1))) {
    var elements = $n(evidence$3).newArray__I__O(n);
    var iterator = $n(it).iterator__sc_Iterator();
    var i = 0;
    while ((i < n)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(elements, i, $n(iterator).next__O());
      i = ((1 + i) | 0);
    }
    return elements;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = $n(evidence$3).runtimeClass__jl_Class();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var iterator$2 = $n(it).iterator__sc_Iterator();
    while ($n(iterator$2).hasNext__Z()) {
      var elem = $n(iterator$2).next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(elementClass).data.zero : elem));
      jsElems.push(unboxedElem);
    }
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return $n(elemRuntimeClass).data.getArrayOf().wrapArray(jsElems);
  }
});
$c_s_Array$.prototype.copy__O__I__O__I__I__V = (function(src, srcPos, dest, destPos, length) {
  var this$1 = $n(src);
  var srcClass = $objectGetClass(this$1);
  var this$2 = $n(srcClass);
  if (this$2.data.isArrayClass) {
    var this$3 = $n(dest);
    var this$4 = $n($objectGetClass(this$3));
    var $x_1 = this$4.data.isAssignableFrom($n(srcClass).data);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $systemArraycopyFull($n(src), srcPos, $n(dest), destPos, length);
  } else {
    $p_s_Array$__slowcopy__O__I__O__I__I__V(this, src, srcPos, dest, destPos, length);
  }
});
$c_s_Array$.prototype.copyOf__O__I__O = (function(original, newLength) {
  if ($isArrayOf_jl_Void(original, 1)) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  } else if ((original instanceof $ac_O)) {
    var x3 = $asArrayOf_O(original, 1);
    return $m_ju_Arrays$().copyOf__AO__I__AO(x3, newLength);
  } else if ((original instanceof $ac_I)) {
    var x4 = $asArrayOf_I(original, 1);
    return $m_ju_Arrays$().copyOf__AI__I__AI(x4, newLength);
  } else if ((original instanceof $ac_D)) {
    var x5 = $asArrayOf_D(original, 1);
    return $m_ju_Arrays$().copyOf__AD__I__AD(x5, newLength);
  } else if ((original instanceof $ac_J)) {
    var x6 = $asArrayOf_J(original, 1);
    return $m_ju_Arrays$().copyOf__AJ__I__AJ(x6, newLength);
  } else if ((original instanceof $ac_F)) {
    var x7 = $asArrayOf_F(original, 1);
    return $m_ju_Arrays$().copyOf__AF__I__AF(x7, newLength);
  } else if ((original instanceof $ac_C)) {
    var x8 = $asArrayOf_C(original, 1);
    return $m_ju_Arrays$().copyOf__AC__I__AC(x8, newLength);
  } else if ((original instanceof $ac_B)) {
    var x9 = $asArrayOf_B(original, 1);
    return $m_ju_Arrays$().copyOf__AB__I__AB(x9, newLength);
  } else if ((original instanceof $ac_S)) {
    var x10 = $asArrayOf_S(original, 1);
    return $m_ju_Arrays$().copyOf__AS__I__AS(x10, newLength);
  } else if ((original instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(original, 1);
    return $m_ju_Arrays$().copyOf__AZ__I__AZ(x11, newLength);
  } else {
    throw new $c_s_MatchError(original);
  }
});
$c_s_Array$.prototype.copyAs__O__I__s_reflect_ClassTag__O = (function(original, newLength, ct) {
  var runtimeClass = $n(ct).runtimeClass__jl_Class();
  if ((runtimeClass !== null)) {
    var this$1 = $n(runtimeClass);
    var $x_1 = (this$1 === $d_V.getClassOf());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  } else {
    var this$4 = $n(runtimeClass);
    var this$2 = $n(original);
    var this$3 = $n($objectGetClass(this$2));
    var that = this$3.data.getComponentType();
    if (this$4.data.isAssignableFrom($n(that).data)) {
      var this$5 = $n(runtimeClass);
      if (this$5.data.isPrimitive) {
        return this.copyOf__O__I__O(original, newLength);
      } else {
        var this$7 = $n(runtimeClass).data.newArray(0);
        var destArrayClass = $objectGetClass(this$7);
        var original$1 = $asArrayOf_O(original, 1);
        return $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, destArrayClass);
      }
    } else {
      var dest = $n(ct).newArray__I__O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(original));
      return dest;
    }
  }
});
$c_s_Array$.prototype.equals__AO__AO__Z = (function(xs, ys) {
  if ((xs === ys)) {
    return true;
  }
  if (($n(xs).u.length !== $n(ys).u.length)) {
    return false;
  }
  var len = $n(xs).u.length;
  var i = 0;
  while ((i < len)) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($n(xs).get(i), $n(ys).get(i)))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
var $d_s_Array$ = new $TypeData().initClass($c_s_Array$, "scala.Array$", ({
  s_Array$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_Array$;
function $m_s_Array$() {
  if ((!$n_s_Array$)) {
    $n_s_Array$ = new $c_s_Array$();
  }
  return $n_s_Array$;
}
/** @constructor */
function $c_s_LowPriorityImplicits() {
}
$c_s_LowPriorityImplicits.prototype = new $h_s_LowPriorityImplicits2();
$c_s_LowPriorityImplicits.prototype.constructor = $c_s_LowPriorityImplicits;
/** @constructor */
function $h_s_LowPriorityImplicits() {
}
$h_s_LowPriorityImplicits.prototype = $c_s_LowPriorityImplicits.prototype;
$c_s_LowPriorityImplicits.prototype.wrapRefArray__AO__scm_ArraySeq$ofRef = (function(xs) {
  if ((xs === null)) {
    return null;
  } else if (($n(xs).u.length === 0)) {
    var this$1 = $m_scm_ArraySeq$();
    return this$1.scm_ArraySeq$__f_EmptyArraySeq;
  } else {
    return new $c_scm_ArraySeq$ofRef(xs);
  }
});
/** @constructor */
function $c_s_Option$() {
}
$c_s_Option$.prototype = new $h_O();
$c_s_Option$.prototype.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
}
$h_s_Option$.prototype = $c_s_Option$.prototype;
$c_s_Option$.prototype.apply__O__s_Option = (function(x) {
  return ((x === null) ? $m_s_None$() : new $c_s_Some(x));
});
var $d_s_Option$ = new $TypeData().initClass($c_s_Option$, "scala.Option$", ({
  s_Option$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$();
  }
  return $n_s_Option$;
}
function $f_s_PartialFunction__andThen__F1__s_PartialFunction($thiz, k) {
  if ($is_s_PartialFunction(k)) {
    var x2 = $as_s_PartialFunction(k);
    return new $c_s_PartialFunction$Combined($thiz, x2);
  } else {
    return new $c_s_PartialFunction$AndThen($thiz, k);
  }
}
function $f_s_PartialFunction__applyOrElse__O__F1__O($thiz, x, default$1) {
  return ($thiz.isDefinedAt__O__Z(x) ? $thiz.apply__O__O(x) : $n(default$1).apply__O__O(x));
}
function $f_s_PartialFunction__runWith__F1__F1($thiz, action) {
  return new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => {
    var z = $thiz.applyOrElse__O__F1__O(x$2$2, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
    return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) && ($n(action).apply__O__O(z), true));
  }));
}
function $is_s_PartialFunction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_PartialFunction)));
}
function $as_s_PartialFunction(obj) {
  return (($is_s_PartialFunction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.PartialFunction"));
}
function $isArrayOf_s_PartialFunction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_PartialFunction)));
}
function $asArrayOf_s_PartialFunction(obj, depth) {
  return (($isArrayOf_s_PartialFunction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.PartialFunction;", depth));
}
function $is_s_Product(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_Product)));
}
function $as_s_Product(obj) {
  return (($is_s_Product(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Product"));
}
function $isArrayOf_s_Product(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Product)));
}
function $asArrayOf_s_Product(obj, depth) {
  return (($isArrayOf_s_Product(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Product;", depth));
}
/** @constructor */
function $c_sc_BuildFromLowPriority2$$anon$11(outer) {
}
$c_sc_BuildFromLowPriority2$$anon$11.prototype = new $h_O();
$c_sc_BuildFromLowPriority2$$anon$11.prototype.constructor = $c_sc_BuildFromLowPriority2$$anon$11;
/** @constructor */
function $h_sc_BuildFromLowPriority2$$anon$11() {
}
$h_sc_BuildFromLowPriority2$$anon$11.prototype = $c_sc_BuildFromLowPriority2$$anon$11.prototype;
$c_sc_BuildFromLowPriority2$$anon$11.prototype.newBuilder__O__scm_Builder = (function(from) {
  var from$1 = $as_sc_Iterable(from);
  return $n($n(from$1).iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
});
var $d_sc_BuildFromLowPriority2$$anon$11 = new $TypeData().initClass($c_sc_BuildFromLowPriority2$$anon$11, "scala.collection.BuildFromLowPriority2$$anon$11", ({
  sc_BuildFromLowPriority2$$anon$11: 1,
  sc_BuildFrom: 1
}));
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1(outer) {
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer = null;
  $n(outer);
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer = outer;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui = $n($n(outer).sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying).iterator__sc_Iterator();
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = $m_s_None$();
}
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1() {
}
$h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype;
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.hasNext__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui).hasNext__Z();
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.next__O = (function() {
  var e = $n(this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui).next__O();
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = new $c_s_Some(e);
  return e;
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.remove__V = (function() {
  var x1 = this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev;
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var e = $n(x2).s_Some__f_value;
    var x1$2 = $n(this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer).sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying;
    if ($is_scm_Set(x1$2)) {
      var x2$2 = $as_scm_Set(x1$2);
      $n(x2$2).remove__O__Z(e);
      this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = $m_s_None$();
    } else {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "remove");
    }
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove");
  }
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 = new $TypeData().initClass($c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1, "scala.collection.convert.JavaCollectionWrappers$SetWrapper$$anon$1", ({
  sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1: 1,
  ju_Iterator: 1
}));
/** @constructor */
function $c_sci_LazyList$Uninitialized$() {
}
$c_sci_LazyList$Uninitialized$.prototype = new $h_O();
$c_sci_LazyList$Uninitialized$.prototype.constructor = $c_sci_LazyList$Uninitialized$;
/** @constructor */
function $h_sci_LazyList$Uninitialized$() {
}
$h_sci_LazyList$Uninitialized$.prototype = $c_sci_LazyList$Uninitialized$.prototype;
var $d_sci_LazyList$Uninitialized$ = new $TypeData().initClass($c_sci_LazyList$Uninitialized$, "scala.collection.immutable.LazyList$Uninitialized$", ({
  sci_LazyList$Uninitialized$: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_LazyList$Uninitialized$;
function $m_sci_LazyList$Uninitialized$() {
  if ((!$n_sci_LazyList$Uninitialized$)) {
    $n_sci_LazyList$Uninitialized$ = new $c_sci_LazyList$Uninitialized$();
  }
  return $n_sci_LazyList$Uninitialized$;
}
/** @constructor */
function $c_sci_List$$anon$1() {
}
$c_sci_List$$anon$1.prototype = new $h_O();
$c_sci_List$$anon$1.prototype.constructor = $c_sci_List$$anon$1;
/** @constructor */
function $h_sci_List$$anon$1() {
}
$h_sci_List$$anon$1.prototype = $c_sci_List$$anon$1.prototype;
$c_sci_List$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this);
});
$c_sci_List$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sci_List$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sci_List$$anon$1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sci_List$$anon$1.prototype.apply__O__O = (function(x) {
  return this;
});
var $d_sci_List$$anon$1 = new $TypeData().initClass($c_sci_List$$anon$1, "scala.collection.immutable.List$$anon$1", ({
  sci_List$$anon$1: 1,
  F1: 1
}));
/** @constructor */
function $c_sci_MapNode() {
}
$c_sci_MapNode.prototype = new $h_sci_Node();
$c_sci_MapNode.prototype.constructor = $c_sci_MapNode;
/** @constructor */
function $h_sci_MapNode() {
}
$h_sci_MapNode.prototype = $c_sci_MapNode.prototype;
function $as_sci_MapNode(obj) {
  return (((obj instanceof $c_sci_MapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapNode"));
}
function $isArrayOf_sci_MapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapNode)));
}
function $asArrayOf_sci_MapNode(obj, depth) {
  return (($isArrayOf_sci_MapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapNode;", depth));
}
function $p_sci_NumericRange$__bigDecimalCheckUnderflow__O__O__O__s_math_Integral__V($thiz, start, end, step, num) {
  if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($n(num).minus__O__O__O($n(num).plus__O__O__O(start, step), start), step))) {
    $ps_sci_NumericRange$__FAIL$1__O__O__V(start, step);
  }
  if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($n(num).minus__O__O__O(end, $n(num).minus__O__O__O(end, step)), step))) {
    $ps_sci_NumericRange$__FAIL$1__O__O__V(end, step);
  }
}
function $ps_sci_NumericRange$__FAIL$1__O__O__V(boundary, step) {
  if ((boundary instanceof $c_s_math_BigDecimal)) {
    var x2 = $as_s_math_BigDecimal(boundary);
    var this$1 = $n($n(x2).s_math_BigDecimal__f_mc);
    var msg = ("Precision " + this$1.Ljava_math_MathContext__f_precision);
  } else {
    var msg = "Precision";
  }
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((msg + " inadequate to represent steps of size ") + step) + " near ") + boundary));
}
function $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O(t, num$1, limit$1) {
  if ($f_s_math_Ordering__gt__O__O__Z($n(num$1), t, limit$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "More than Int.MaxValue elements.");
  } else {
    return t;
  }
}
/** @constructor */
function $c_sci_NumericRange$() {
  $n_sci_NumericRange$ = this;
  var this$14 = $m_sci_Map$();
  var self = $m_s_math_Numeric$IntIsIntegral$();
  var y = $m_s_math_Ordering$Int$();
  var x0 = new $c_T2(self, y);
  var self$1 = $m_s_math_Numeric$ShortIsIntegral$();
  var y$1 = $m_s_math_Ordering$Short$();
  var x1 = new $c_T2(self$1, y$1);
  var self$2 = $m_s_math_Numeric$ByteIsIntegral$();
  var y$2 = $m_s_math_Ordering$Byte$();
  var x2 = new $c_T2(self$2, y$2);
  var self$3 = $m_s_math_Numeric$CharIsIntegral$();
  var y$3 = $m_s_math_Ordering$Char$();
  var x3 = new $c_T2(self$3, y$3);
  var self$4 = $m_s_math_Numeric$LongIsIntegral$();
  var y$4 = $m_s_math_Ordering$Long$();
  var x4 = new $c_T2(self$4, y$4);
  var array = [x0, x1, x2, x3, x4];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this$14.from__sc_IterableOnce__sci_Map(elems);
}
$c_sci_NumericRange$.prototype = new $h_O();
$c_sci_NumericRange$.prototype.constructor = $c_sci_NumericRange$;
/** @constructor */
function $h_sci_NumericRange$() {
}
$h_sci_NumericRange$.prototype = $c_sci_NumericRange$.prototype;
$c_sci_NumericRange$.prototype.count__O__O__O__Z__s_math_Integral__I = (function(start, end, step, isInclusive, num) {
  var this$1 = $n(num);
  var zero = this$1.fromInt__I__O(0);
  var upward = $f_s_math_Ordering__lt__O__O__Z($n(num), start, end);
  var posStep = $f_s_math_Ordering__gt__O__O__Z($n(num), step, zero);
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(step, zero)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(start, end)) {
    return (isInclusive ? 1 : 0);
  } else if ((upward !== posStep)) {
    return 0;
  } else {
    var startint = $n(num).toInt__O__I(start);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(start, $n(num).fromInt__I__O(startint))) {
      var endint = $n(num).toInt__O__I(end);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(end, $n(num).fromInt__I__O(endint))) {
        var stepint = $n(num).toInt__O__I(step);
        if ($m_sr_BoxesRunTime$().equals__O__O__Z(step, $n(num).fromInt__I__O(stepint))) {
          if (isInclusive) {
            var isEmpty = ((stepint >= 0) ? (startint > endint) : (startint < endint));
            if ((stepint === 0)) {
              throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
            }
            var stepSign = (stepint >> 31);
            var gap = (((((endint - startint) | 0) ^ stepSign) - stepSign) | 0);
            var absStep = (((stepint ^ stepSign) - stepSign) | 0);
            var div = (((gap >>> 0) / ($checkIntDivisor(absStep) >>> 0)) | 0);
            var scala$collection$immutable$Range$$numRangeElements = ((1 + div) | 0);
            return (isEmpty ? 0 : ((scala$collection$immutable$Range$$numRangeElements > 0) ? scala$collection$immutable$Range$$numRangeElements : $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(startint, endint, stepint, true)));
          } else {
            var isEmpty$1 = ((stepint >= 0) ? (startint >= endint) : (startint <= endint));
            if ((stepint === 0)) {
              throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
            }
            var stepSign$1 = (stepint >> 31);
            var gap$1 = (((((endint - startint) | 0) ^ stepSign$1) - stepSign$1) | 0);
            var absStep$1 = (((stepint ^ stepSign$1) - stepSign$1) | 0);
            var div$1 = (((gap$1 >>> 0) / ($checkIntDivisor(absStep$1) >>> 0)) | 0);
            var scala$collection$immutable$Range$$numRangeElements$1 = ((Math.imul(absStep$1, div$1) !== gap$1) ? ((1 + div$1) | 0) : div$1);
            return (isEmpty$1 ? 0 : ((scala$collection$immutable$Range$$numRangeElements$1 > 0) ? scala$collection$immutable$Range$$numRangeElements$1 : $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(startint, endint, stepint, false)));
          }
        }
      }
    }
    if ($is_s_math_Numeric$BigDecimalAsIfIntegral(num)) {
      $p_sci_NumericRange$__bigDecimalCheckUnderflow__O__O__O__s_math_Integral__V(this, start, end, step, num);
    }
    var this$6 = $n(num);
    var one = this$6.fromInt__I__O(1);
    var limit = $n(num).fromInt__I__O(2147483647);
    var startside = $n(num).sign__O__O(start);
    var endside = $n(num).sign__O__O(end);
    var $x_3 = $n(num);
    if ($f_s_math_Ordering__gteq__O__O__Z($n(num), $n(num).times__O__O__O(startside, endside), zero)) {
      var diff = $n(num).minus__O__O__O(end, start);
      var quotient = $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O($n(num).quot__O__O__O(diff, step), num, limit);
      var remainder = $n(num).minus__O__O__O(diff, $n(num).times__O__O__O(quotient, step));
      var $x_1 = (((!isInclusive) && $m_sr_BoxesRunTime$().equals__O__O__Z(zero, remainder)) ? quotient : $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O($n(num).plus__O__O__O(quotient, one), num, limit));
    } else {
      var negone = $n(num).fromInt__I__O((-1));
      var startlim = (posStep ? negone : one);
      var startdiff = (((posStep && $f_s_math_Ordering__lt__O__O__Z($n(num), startlim, start)) || ((!posStep) && $f_s_math_Ordering__gt__O__O__Z($n(num), startlim, start))) ? start : $n(num).minus__O__O__O(startlim, start));
      var startq = $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O($n(num).quot__O__O__O(startdiff, step), num, limit);
      var waypointA = ($m_sr_BoxesRunTime$().equals__O__O__Z(startq, zero) ? start : $n(num).plus__O__O__O(start, $n(num).times__O__O__O(startq, step)));
      var waypointB = $n(num).plus__O__O__O(waypointA, step);
      if (($f_s_math_Ordering__lt__O__O__Z($n(num), waypointB, end) !== upward)) {
        var $x_2 = ((isInclusive && $m_sr_BoxesRunTime$().equals__O__O__Z(waypointB, end)) ? $n(num).plus__O__O__O(startq, $n(num).fromInt__I__O(2)) : $n(num).plus__O__O__O(startq, one));
      } else {
        var enddiff = $n(num).minus__O__O__O(end, waypointB);
        var endq = $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O($n(num).quot__O__O__O(enddiff, step), num, limit);
        var last = ($m_sr_BoxesRunTime$().equals__O__O__Z(endq, zero) ? waypointB : $n(num).plus__O__O__O(waypointB, $n(num).times__O__O__O(endq, step)));
        var $x_2 = $n(num).plus__O__O__O(startq, $n(num).plus__O__O__O(endq, (((!isInclusive) && $m_sr_BoxesRunTime$().equals__O__O__Z(last, end)) ? one : $n(num).fromInt__I__O(2))));
      }
      var $x_1 = $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O($x_2, num, limit);
    }
    return $x_3.toInt__O__I($x_1);
  }
});
var $d_sci_NumericRange$ = new $TypeData().initClass($c_sci_NumericRange$, "scala.collection.immutable.NumericRange$", ({
  sci_NumericRange$: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_NumericRange$;
function $m_sci_NumericRange$() {
  if ((!$n_sci_NumericRange$)) {
    $n_sci_NumericRange$ = new $c_sci_NumericRange$();
  }
  return $n_sci_NumericRange$;
}
function $p_sci_Range$__description__I__I__I__Z__T($thiz, start, end, step, isInclusive) {
  return ((((start + (isInclusive ? " to " : " until ")) + end) + " by ") + step);
}
/** @constructor */
function $c_sci_Range$() {
}
$c_sci_Range$.prototype = new $h_O();
$c_sci_Range$.prototype.constructor = $c_sci_Range$;
/** @constructor */
function $h_sci_Range$() {
}
$h_sci_Range$.prototype = $c_sci_Range$.prototype;
$c_sci_Range$.prototype.scala$collection$immutable$Range$$fail__I__I__I__Z__E = (function(start, end, step, isInclusive) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ($p_sci_Range$__description__I__I__I__Z__T(this, start, end, step, isInclusive) + ": seqs cannot contain more than Int.MaxValue elements."));
});
var $d_sci_Range$ = new $TypeData().initClass($c_sci_Range$, "scala.collection.immutable.Range$", ({
  sci_Range$: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Range$;
function $m_sci_Range$() {
  if ((!$n_sci_Range$)) {
    $n_sci_Range$ = new $c_sci_Range$();
  }
  return $n_sci_Range$;
}
/** @constructor */
function $c_sci_SetNode() {
}
$c_sci_SetNode.prototype = new $h_sci_Node();
$c_sci_SetNode.prototype.constructor = $c_sci_SetNode;
/** @constructor */
function $h_sci_SetNode() {
}
$h_sci_SetNode.prototype = $c_sci_SetNode.prototype;
function $as_sci_SetNode(obj) {
  return (((obj instanceof $c_sci_SetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetNode"));
}
function $isArrayOf_sci_SetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetNode)));
}
function $asArrayOf_sci_SetNode(obj, depth) {
  return (($isArrayOf_sci_SetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetNode;", depth));
}
function $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($thiz, elems) {
  if ((elems === $thiz)) {
    $thiz.addAll__sc_IterableOnce__scm_Growable($m_scm_Buffer$().from__sc_IterableOnce__sc_SeqOps(elems));
  } else {
    var it = $n(elems).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      $thiz.addOne__O__scm_Growable($n(it).next__O());
    }
  }
  return $thiz;
}
function $is_scm_Growable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Growable)));
}
function $as_scm_Growable(obj) {
  return (($is_scm_Growable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Growable"));
}
function $isArrayOf_scm_Growable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Growable)));
}
function $asArrayOf_scm_Growable(obj, depth) {
  return (($isArrayOf_scm_Growable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Growable;", depth));
}
function $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V($thiz, runnable) {
  $n(runnable);
  var tl = $thiz.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal;
  var b = $n(tl).get__O();
  if ((b instanceof $c_s_concurrent_BatchingExecutor$SyncBatch)) {
    $n($as_s_concurrent_BatchingExecutor$SyncBatch(b)).push__jl_Runnable__V(runnable);
  } else {
    if ((b !== null)) {
      var this$1 = $n($as_jl_Integer(b));
      var i = this$1;
    } else {
      var i = 0;
    }
    if ((i < 16)) {
      var $x_1 = $n(tl);
      var i$1 = ((1 + i) | 0);
      $x_1.set__O__V(i$1);
      try {
        $n(runnable).run__V();
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        if (false) {
          var x2 = $as_jl_InterruptedException(e$2);
          $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(x2);
        } else if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(e$2);
        } else {
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
        }
      } finally {
        $n(tl).set__O__V(b);
      }
    } else {
      var batch = new $c_s_concurrent_BatchingExecutor$SyncBatch($thiz, runnable);
      $n(tl).set__O__V(batch);
      batch.run__V();
      $n(tl).set__O__V(b);
    }
  }
}
function $is_s_concurrent_Future(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_Future)));
}
function $as_s_concurrent_Future(obj) {
  return (($is_s_concurrent_Future(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.Future"));
}
function $isArrayOf_s_concurrent_Future(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_Future)));
}
function $asArrayOf_s_concurrent_Future(obj, depth) {
  return (($isArrayOf_s_concurrent_Future(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.Future;", depth));
}
function $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, s) {
  var $x_1 = $m_s_Predef$();
  var this$1 = $n($f_T__trim__T($n(s)));
  var this$2 = $n($x_1.wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$1, "\\s+", 0)));
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2);
}
function $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($thiz, labels) {
  var x1 = $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, labels);
  if ((!(x1 instanceof $c_sci_$colon$colon))) {
    throw new $c_s_MatchError(x1);
  }
  var x2 = $as_sci_$colon$colon(x1);
  var hd = $as_T($n(x2).sci_$colon$colon__f_head);
  var rest = $n(x2).sci_$colon$colon__f_next;
  var this$1 = $n(rest);
  var rest$1 = this$1;
  var h = null;
  var t = null;
  while ((rest$1 !== $m_sci_Nil$())) {
    var x0 = $n(rest$1).head__O();
    var s$2 = $as_T(x0);
    var x1$1 = (s$2 + "s");
    var array = [s$2, x1$1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var it = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        $n(t).sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest$1 = $as_sci_List($n(rest$1).tail__O());
  }
  var this$6 = $n(((h === null) ? $m_sci_Nil$() : h));
  return new $c_sci_$colon$colon(hd, this$6);
}
/** @constructor */
function $c_s_concurrent_duration_Duration$() {
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = null;
  this.s_concurrent_duration_Duration$__f_timeUnitName = null;
  this.s_concurrent_duration_Duration$__f_timeUnit = null;
  this.s_concurrent_duration_Duration$__f_Zero = null;
  this.s_concurrent_duration_Duration$__f_Undefined = null;
  this.s_concurrent_duration_Duration$__f_Inf = null;
  this.s_concurrent_duration_Duration$__f_MinusInf = null;
  $n_s_concurrent_duration_Duration$ = this;
  var self = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
  var x0 = new $c_T2(self, "d day");
  var self$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  var x1 = new $c_T2(self$1, "h hr hour");
  var self$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  var x2 = new $c_T2(self$2, "m min minute");
  var self$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var x3 = new $c_T2(self$3, "s sec second");
  var self$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var x4 = new $c_T2(self$4, "ms milli millisecond");
  var self$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
  var x5 = new $c_T2(self$5, "\u00b5s micro microsecond");
  var self$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  var x6 = new $c_T2(self$6, "ns nano nanosecond");
  var array = [x0, x1, x2, x3, x4, x5, x6];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$20 = $n(this.s_concurrent_duration_Duration$__f_timeUnitLabels);
  var this$21 = $n($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$20));
  var this$22 = new $c_sc_MapView$Id(this$21);
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((s$2$2) => {
    var s$2 = $as_T(s$2$2);
    return $as_T($n($p_s_concurrent_duration_Duration$__words__T__sci_List($m_s_concurrent_duration_Duration$(), s$2)).last__O());
  }));
  var this$24 = new $c_sc_MapView$MapValues(this$22, f);
  this.s_concurrent_duration_Duration$__f_timeUnitName = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$24);
  var this$25 = $n(this.s_concurrent_duration_Duration$__f_timeUnitLabels);
  var rest = this$25;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0$1 = $n(rest).head__O();
    var x0$1$2 = $as_T2(x0$1);
    if ((x0$1$2 === null)) {
      throw new $c_s_MatchError(x0$1$2);
    }
    var unit = $as_ju_concurrent_TimeUnit($n(x0$1$2)._1__O());
    var names = $as_T($n(x0$1$2)._2__O());
    var this$28 = $n($p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($m_s_concurrent_duration_Duration$(), names));
    var f$1 = ((unit) => ((x$5$2$2) => {
      var x$5$2 = $as_T(x$5$2$2);
      return new $c_T2(x$5$2, unit);
    }))(unit);
    if ((this$28 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0$2 = this$28.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(this$28.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = $n(rest$1).head__O();
        var nx = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
        $n(t$1).sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest$1 = $as_sci_List($n(rest$1).tail__O());
      }
      var $x_1 = h$1;
    }
    var it = $x_1.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1;
      } else {
        $n(t).sci_$colon$colon__f_next = nx$1;
      }
      t = nx$1;
    }
    rest = $as_sci_List($n(rest).tail__O());
  }
  var this$30 = $n(((h === null) ? $m_sci_Nil$() : h));
  this.s_concurrent_duration_Duration$__f_timeUnit = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$30);
  this.s_concurrent_duration_Duration$__f_Zero = new $c_s_concurrent_duration_FiniteDuration(0, 0, $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS);
  this.s_concurrent_duration_Duration$__f_Undefined = new $c_s_concurrent_duration_Duration$$anon$1();
  this.s_concurrent_duration_Duration$__f_Inf = new $c_s_concurrent_duration_Duration$$anon$2();
  this.s_concurrent_duration_Duration$__f_MinusInf = new $c_s_concurrent_duration_Duration$$anon$3();
}
$c_s_concurrent_duration_Duration$.prototype = new $h_O();
$c_s_concurrent_duration_Duration$.prototype.constructor = $c_s_concurrent_duration_Duration$;
/** @constructor */
function $h_s_concurrent_duration_Duration$() {
}
$h_s_concurrent_duration_Duration$.prototype = $c_s_concurrent_duration_Duration$.prototype;
$c_s_concurrent_duration_Duration$.prototype.apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration = (function(length, unit) {
  var $x_1 = $n(unit).toNanos__J__J(1, 0);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  return this.fromNanos__D__s_concurrent_duration_Duration((((4.294967296E9 * x_$_hi) + (x_$_lo >>> 0.0)) * length));
});
$c_s_concurrent_duration_Duration$.prototype.apply__T__s_concurrent_duration_Duration = (function(s) {
  var this$4 = $n(s);
  var len = this$4.length;
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
  var i = 0;
  while ((i < len)) {
    var this$5 = $n(s);
    var index = i;
    var x = $charAt(this$5, index);
    var this$8 = $m_jl_Character$();
    if ((!this$8.isWhitespace__I__Z(x))) {
      var str = ("" + $cToS(x));
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    }
    i = ((1 + i) | 0);
  }
  var s1 = ((len === sb.length__I()) ? s : sb.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  switch (s1) {
    case "Inf":
    case "PlusInf":
    case "+Inf":
    case "Duration.Inf": {
      return this.s_concurrent_duration_Duration$__f_Inf;
      break;
    }
    case "MinusInf":
    case "-Inf":
    case "Duration.MinusInf": {
      return this.s_concurrent_duration_Duration$__f_MinusInf;
      break;
    }
    case "Duration.Undefined": {
      return this.s_concurrent_duration_Duration$__f_Undefined;
      break;
    }
    default: {
      var $x_1 = $m_sc_StringOps$();
      var x$1 = $m_sc_StringOps$().reverse$extension__T__T(s1);
      _return: {
        var this$14 = $n(x$1);
        var len$1 = this$14.length;
        var i$1 = 0;
        while ((i$1 < len$1)) {
          var this$15 = $n(x$1);
          var index$1 = i$1;
          var x0 = $charAt(this$15, index$1);
          var this$18 = $m_jl_Character$();
          if ((!this$18.isLetter__I__Z(x0))) {
            var x1 = i$1;
            break _return;
          }
          i$1 = ((1 + i$1) | 0);
        }
        var x1 = (-1);
      }
      if ((x1 === (-1))) {
        var x$2 = x$1;
      } else {
        var this$19 = $n(x$1);
        if ((x1 > this$19.length)) {
          $charAt(this$19, x1);
        }
        if ((x1 < 0)) {
          $charAt(this$19, (-1));
        }
        var x$2 = $as_T(this$19.substring(0, x1));
      }
      var unitName = $x_1.reverse$extension__T__T(x$2);
      var x1$2 = $n(this.s_concurrent_duration_Duration$__f_timeUnit).get__O__s_Option(unitName);
      if ((x1$2 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x1$2);
        var unit = $as_ju_concurrent_TimeUnit($n(x2).s_Some__f_value);
        var $x_2 = $m_sc_StringOps$();
        var this$22 = $n(unitName);
        var valueStr = $x_2.dropRight$extension__T__I__T(s1, this$22.length);
        var this$23 = $n($m_sc_StringParsers$().parseLong__T__s_Option(valueStr));
        if (this$23.isEmpty__Z()) {
          var this$25 = $m_s_None$();
        } else {
          var x0$1 = this$23.get__O();
          var $x_3 = $uJ(x0$1);
          var x$3$2_$_lo = $x_3.l;
          var x$3$2_$_hi = $x_3.h;
          $m_s_concurrent_duration_Duration$();
          var this$25 = new $c_s_Some(new $c_s_concurrent_duration_FiniteDuration(x$3$2_$_lo, x$3$2_$_hi, unit));
        }
        return $as_s_concurrent_duration_Duration((this$25.isEmpty__Z() ? $m_s_concurrent_duration_Duration$().apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration($m_jl_Double$().parseDouble__T__D(valueStr), unit) : this$25.get__O()));
      } else {
        throw new $c_jl_NumberFormatException(("format error " + s));
      }
    }
  }
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__D__s_concurrent_duration_Duration = (function(nanos) {
  if (((nanos === Infinity) || (nanos === (-Infinity)))) {
    return ((nanos > 0.0) ? this.s_concurrent_duration_Duration$__f_Inf : this.s_concurrent_duration_Duration$__f_MinusInf);
  } else if ((nanos !== nanos)) {
    return this.s_concurrent_duration_Duration$__f_Undefined;
  } else if (((nanos > 9.223372036854776E18) || (nanos < (-9.223372036854776E18)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("trying to construct too large duration with " + nanos) + "ns"));
  } else {
    var value = $uD(Math.round(nanos));
    var $x_1 = $m_RTLong$().fromDouble__D__J(value);
    return this.fromNanos__J__s_concurrent_duration_FiniteDuration($x_1.l, $x_1.h);
  }
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__J__s_concurrent_duration_FiniteDuration = (function(nanos_$_lo, nanos_$_hi) {
  var hi = (nanos_$_hi >> 31);
  var b0 = (65535 & nanos_$_lo);
  var b1 = ((nanos_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(65391, b0);
  var a1b0 = Math.imul(26687, b0);
  var a0b1 = Math.imul(65391, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(26687, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & nanos_$_lo);
  var b1$1 = ((nanos_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(18659, b0$1);
  var a1b0$1 = Math.imul(18681, b0$1);
  var a0b1$1 = Math.imul(18659, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(18681, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & nanos_$_hi);
  var b1$2 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(65391, b0$2);
  var a1b0$2 = Math.imul(26687, b0$2);
  var a0b1$2 = Math.imul(65391, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(1749024623, hi) + Math.imul(26687, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & nanos_$_hi);
  var b1$3 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(18659, b0$3);
  var a1b0$3 = Math.imul(18681, b0$3);
  var a0b1$3 = Math.imul(18659, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(1224296675, hi) + Math.imul(18681, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (hi$10 >> 13);
  var hi$11 = (hi$10 >> 31);
  var lo$9 = ((nanos_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  var b0$4 = (65535 & lo$10);
  var b1$4 = ((lo$10 >>> 16) | 0);
  var a1b0$4 = Math.imul(37199, b0$4);
  var lo$11 = (a1b0$4 << 16);
  var hi$13 = ((((((Math.imul((-1857093632), hi$12) + Math.imul(20116, lo$10)) | 0) + Math.imul(37199, b1$4)) | 0) + ((a1b0$4 >>> 16) | 0)) | 0);
  var lo$12 = ((nanos_$_lo - lo$11) | 0);
  var hi$14 = ((((nanos_$_hi - hi$13) | 0) + ((((~nanos_$_lo) & lo$11) | ((~(nanos_$_lo ^ lo$11)) & lo$12)) >> 31)) | 0);
  if (((lo$12 | hi$14) === 0)) {
    $m_s_concurrent_duration_Duration$();
    var hi$15 = (nanos_$_hi >> 31);
    var b0$5 = (65535 & nanos_$_lo);
    var b1$5 = ((nanos_$_lo >>> 16) | 0);
    var a0b0$4 = Math.imul(65391, b0$5);
    var a1b0$5 = Math.imul(26687, b0$5);
    var a0b1$4 = Math.imul(65391, b1$5);
    var lo$13 = ((a0b0$4 + (((a1b0$5 + a0b1$4) | 0) << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$16 = ((((Math.imul(26687, b1$5) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$5) | 0) >>> 16) | 0)) | 0);
    var b0$6 = (65535 & nanos_$_lo);
    var b1$6 = ((nanos_$_lo >>> 16) | 0);
    var a0b0$5 = Math.imul(18659, b0$6);
    var a1b0$6 = Math.imul(18681, b0$6);
    var a0b1$5 = Math.imul(18659, b1$6);
    var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
    var hi$17 = ((((Math.imul(18681, b1$6) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$6) | 0) >>> 16) | 0)) | 0);
    var lo$15 = ((lo$13 + hi$17) | 0);
    var hi$18 = ((hi$16 + ((((lo$13 & hi$17) | ((lo$13 | hi$17) & (~lo$15))) >>> 31) | 0)) | 0);
    var b0$7 = (65535 & nanos_$_hi);
    var b1$7 = ((nanos_$_hi >>> 16) | 0);
    var a0b0$6 = Math.imul(65391, b0$7);
    var a1b0$7 = Math.imul(26687, b0$7);
    var a0b1$6 = Math.imul(65391, b1$7);
    var lo$16 = ((a0b0$6 + (((a1b0$7 + a0b1$6) | 0) << 16)) | 0);
    var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
    var hi$19 = ((((((Math.imul(1749024623, hi$15) + Math.imul(26687, b1$7)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$7) | 0) >>> 16) | 0)) | 0);
    var hi$20 = (hi$18 >> 31);
    var lo$17 = ((lo$16 + hi$18) | 0);
    var hi$21 = ((((hi$19 + hi$20) | 0) + ((((lo$16 & hi$18) | ((lo$16 | hi$18) & (~lo$17))) >>> 31) | 0)) | 0);
    var b0$8 = (65535 & nanos_$_hi);
    var b1$8 = ((nanos_$_hi >>> 16) | 0);
    var a0b0$7 = Math.imul(18659, b0$8);
    var a1b0$8 = Math.imul(18681, b0$8);
    var a0b1$7 = Math.imul(18659, b1$8);
    var lo$18 = ((a0b0$7 + (((a1b0$8 + a0b1$7) | 0) << 16)) | 0);
    var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
    var hi$22 = ((((((Math.imul(1224296675, hi$15) + Math.imul(18681, b1$8)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$8) | 0) >>> 16) | 0)) | 0);
    var lo$19 = ((lo$15 + lo$18) | 0);
    var hi$23 = ((hi$22 + ((((lo$15 & lo$18) | ((lo$15 | lo$18) & (~lo$19))) >>> 31) | 0)) | 0);
    var hi$24 = (hi$23 >> 31);
    var lo$20 = ((lo$17 + hi$23) | 0);
    var hi$25 = ((((hi$21 + hi$24) | 0) + ((((lo$17 & hi$23) | ((lo$17 | hi$23) & (~lo$20))) >>> 31) | 0)) | 0);
    var lo$21 = (hi$25 >> 13);
    var hi$26 = (hi$25 >> 31);
    var lo$22 = ((nanos_$_hi >>> 31) | 0);
    var lo$23 = ((lo$21 + lo$22) | 0);
    var hi$27 = ((hi$26 + ((((lo$21 & lo$22) | ((lo$21 | lo$22) & (~lo$23))) >>> 31) | 0)) | 0);
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
    return new $c_s_concurrent_duration_FiniteDuration(lo$23, hi$27, unit);
  } else {
    var hi$28 = (nanos_$_hi >> 31);
    var b0$9 = (65535 & nanos_$_lo);
    var b1$9 = ((nanos_$_lo >>> 16) | 0);
    var a0b0$8 = Math.imul(65318, b0$9);
    var a1b0$9 = Math.imul(40031, b0$9);
    var a0b1$8 = Math.imul(65318, b1$9);
    var lo$24 = ((a0b0$8 + (((a1b0$9 + a0b1$8) | 0) << 16)) | 0);
    var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
    var hi$29 = ((((((((-nanos_$_lo) | 0) + Math.imul(40031, b1$9)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$9) | 0) >>> 16) | 0)) | 0);
    var b0$10 = (65535 & nanos_$_lo);
    var b1$10 = ((nanos_$_lo >>> 16) | 0);
    var a0b0$9 = Math.imul(60757, b0$10);
    var a1b0$10 = Math.imul(60789, b0$10);
    var a0b1$9 = Math.imul(60757, b1$10);
    var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
    var hi$30 = ((((Math.imul(60789, b1$10) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$10) | 0) >>> 16) | 0)) | 0);
    var lo$26 = ((lo$24 + hi$30) | 0);
    var hi$31 = ((hi$29 + ((((lo$24 & hi$30) | ((lo$24 | hi$30) & (~lo$26))) >>> 31) | 0)) | 0);
    var b0$11 = (65535 & nanos_$_hi);
    var b1$11 = ((nanos_$_hi >>> 16) | 0);
    var a0b0$10 = Math.imul(65318, b0$11);
    var a1b0$11 = Math.imul(40031, b0$11);
    var a0b1$10 = Math.imul(65318, b1$11);
    var lo$27 = ((a0b0$10 + (((a1b0$11 + a0b1$10) | 0) << 16)) | 0);
    var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
    var hi$32 = ((((((((Math.imul((-1671430362), hi$28) + ((-nanos_$_hi) | 0)) | 0) + Math.imul(40031, b1$11)) | 0) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$11) | 0) >>> 16) | 0)) | 0);
    var hi$33 = (hi$31 >> 31);
    var lo$28 = ((lo$27 + hi$31) | 0);
    var hi$34 = ((((hi$32 + hi$33) | 0) + ((((lo$27 & hi$31) | ((lo$27 | hi$31) & (~lo$28))) >>> 31) | 0)) | 0);
    var b0$12 = (65535 & nanos_$_hi);
    var b1$12 = ((nanos_$_hi >>> 16) | 0);
    var a0b0$11 = Math.imul(60757, b0$12);
    var a1b0$12 = Math.imul(60789, b0$12);
    var a0b1$11 = Math.imul(60757, b1$12);
    var lo$29 = ((a0b0$11 + (((a1b0$12 + a0b1$11) | 0) << 16)) | 0);
    var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
    var hi$35 = ((((((Math.imul((-311038635), hi$28) + Math.imul(60789, b1$12)) | 0) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$12) | 0) >>> 16) | 0)) | 0);
    var lo$30 = ((lo$26 + lo$29) | 0);
    var hi$36 = ((hi$35 + ((((lo$26 & lo$29) | ((lo$26 | lo$29) & (~lo$30))) >>> 31) | 0)) | 0);
    var hi$37 = (hi$36 >> 31);
    var lo$31 = ((lo$28 + hi$36) | 0);
    var hi$38 = ((((hi$34 + hi$37) | 0) + ((((lo$28 & hi$36) | ((lo$28 | hi$36) & (~lo$31))) >>> 31) | 0)) | 0);
    var lo$32 = ((lo$31 + nanos_$_lo) | 0);
    var hi$39 = ((((hi$38 + nanos_$_hi) | 0) + ((((lo$31 & nanos_$_lo) | ((lo$31 | nanos_$_lo) & (~lo$32))) >>> 31) | 0)) | 0);
    var lo$33 = (hi$39 >> 9);
    var hi$40 = (hi$39 >> 31);
    var lo$34 = ((nanos_$_hi >>> 31) | 0);
    var lo$35 = ((lo$33 + lo$34) | 0);
    var hi$41 = ((hi$40 + ((((lo$33 & lo$34) | ((lo$33 | lo$34) & (~lo$35))) >>> 31) | 0)) | 0);
    var b0$13 = (65535 & lo$35);
    var b1$13 = ((lo$35 >>> 16) | 0);
    var a0b0$12 = Math.imul(40960, b0$13);
    var a1b0$13 = Math.imul(12472, b0$13);
    var a0b1$12 = Math.imul(40960, b1$13);
    var lo$36 = ((a0b0$12 + (((a1b0$13 + a0b1$12) | 0) << 16)) | 0);
    var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
    var hi$42 = ((((((((Math.imul(817405952, hi$41) + Math.imul(838, lo$35)) | 0) + Math.imul(12472, b1$13)) | 0) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$13) | 0) >>> 16) | 0)) | 0);
    var lo$37 = ((nanos_$_lo - lo$36) | 0);
    var hi$43 = ((((nanos_$_hi - hi$42) | 0) + ((((~nanos_$_lo) & lo$36) | ((~(nanos_$_lo ^ lo$36)) & lo$37)) >> 31)) | 0);
    if (((lo$37 | hi$43) === 0)) {
      $m_s_concurrent_duration_Duration$();
      var hi$44 = (nanos_$_hi >> 31);
      var b0$14 = (65535 & nanos_$_lo);
      var b1$14 = ((nanos_$_lo >>> 16) | 0);
      var a0b0$13 = Math.imul(65318, b0$14);
      var a1b0$14 = Math.imul(40031, b0$14);
      var a0b1$13 = Math.imul(65318, b1$14);
      var lo$38 = ((a0b0$13 + (((a1b0$14 + a0b1$13) | 0) << 16)) | 0);
      var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
      var hi$45 = ((((((((-nanos_$_lo) | 0) + Math.imul(40031, b1$14)) | 0) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$14) | 0) >>> 16) | 0)) | 0);
      var b0$15 = (65535 & nanos_$_lo);
      var b1$15 = ((nanos_$_lo >>> 16) | 0);
      var a0b0$14 = Math.imul(60757, b0$15);
      var a1b0$15 = Math.imul(60789, b0$15);
      var a0b1$14 = Math.imul(60757, b1$15);
      var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
      var hi$46 = ((((Math.imul(60789, b1$15) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$15) | 0) >>> 16) | 0)) | 0);
      var lo$40 = ((lo$38 + hi$46) | 0);
      var hi$47 = ((hi$45 + ((((lo$38 & hi$46) | ((lo$38 | hi$46) & (~lo$40))) >>> 31) | 0)) | 0);
      var b0$16 = (65535 & nanos_$_hi);
      var b1$16 = ((nanos_$_hi >>> 16) | 0);
      var a0b0$15 = Math.imul(65318, b0$16);
      var a1b0$16 = Math.imul(40031, b0$16);
      var a0b1$15 = Math.imul(65318, b1$16);
      var lo$41 = ((a0b0$15 + (((a1b0$16 + a0b1$15) | 0) << 16)) | 0);
      var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
      var hi$48 = ((((((((Math.imul((-1671430362), hi$44) + ((-nanos_$_hi) | 0)) | 0) + Math.imul(40031, b1$16)) | 0) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$16) | 0) >>> 16) | 0)) | 0);
      var hi$49 = (hi$47 >> 31);
      var lo$42 = ((lo$41 + hi$47) | 0);
      var hi$50 = ((((hi$48 + hi$49) | 0) + ((((lo$41 & hi$47) | ((lo$41 | hi$47) & (~lo$42))) >>> 31) | 0)) | 0);
      var b0$17 = (65535 & nanos_$_hi);
      var b1$17 = ((nanos_$_hi >>> 16) | 0);
      var a0b0$16 = Math.imul(60757, b0$17);
      var a1b0$17 = Math.imul(60789, b0$17);
      var a0b1$16 = Math.imul(60757, b1$17);
      var lo$43 = ((a0b0$16 + (((a1b0$17 + a0b1$16) | 0) << 16)) | 0);
      var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
      var hi$51 = ((((((Math.imul((-311038635), hi$44) + Math.imul(60789, b1$17)) | 0) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$17) | 0) >>> 16) | 0)) | 0);
      var lo$44 = ((lo$40 + lo$43) | 0);
      var hi$52 = ((hi$51 + ((((lo$40 & lo$43) | ((lo$40 | lo$43) & (~lo$44))) >>> 31) | 0)) | 0);
      var hi$53 = (hi$52 >> 31);
      var lo$45 = ((lo$42 + hi$52) | 0);
      var hi$54 = ((((hi$50 + hi$53) | 0) + ((((lo$42 & hi$52) | ((lo$42 | hi$52) & (~lo$45))) >>> 31) | 0)) | 0);
      var lo$46 = ((lo$45 + nanos_$_lo) | 0);
      var hi$55 = ((((hi$54 + nanos_$_hi) | 0) + ((((lo$45 & nanos_$_lo) | ((lo$45 | nanos_$_lo) & (~lo$46))) >>> 31) | 0)) | 0);
      var lo$47 = (hi$55 >> 9);
      var hi$56 = (hi$55 >> 31);
      var lo$48 = ((nanos_$_hi >>> 31) | 0);
      var lo$49 = ((lo$47 + lo$48) | 0);
      var hi$57 = ((hi$56 + ((((lo$47 & lo$48) | ((lo$47 | lo$48) & (~lo$49))) >>> 31) | 0)) | 0);
      var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
      return new $c_s_concurrent_duration_FiniteDuration(lo$49, hi$57, unit$1);
    } else {
      var hi$58 = (nanos_$_hi >> 31);
      var b0$18 = (65535 & nanos_$_lo);
      var b1$18 = ((nanos_$_lo >>> 16) | 0);
      var a0b0$17 = Math.imul(13310, b0$18);
      var a1b0$18 = Math.imul(293, b0$18);
      var a0b1$17 = Math.imul(13310, b1$18);
      var lo$50 = ((a0b0$17 + (((a1b0$18 + a0b1$17) | 0) << 16)) | 0);
      var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
      var hi$59 = ((((Math.imul(293, b1$18) + ((c1part$17 >>> 16) | 0)) | 0) + (((((65535 & c1part$17) + a1b0$18) | 0) >>> 16) | 0)) | 0);
      var b0$19 = (65535 & nanos_$_lo);
      var b1$19 = ((nanos_$_lo >>> 16) | 0);
      var a0b0$18 = Math.imul(15645, b0$19);
      var a1b0$19 = Math.imul(26877, b0$19);
      var a0b1$18 = Math.imul(15645, b1$19);
      var c1part$18 = ((((a0b0$18 >>> 16) | 0) + a0b1$18) | 0);
      var hi$60 = ((((Math.imul(26877, b1$19) + ((c1part$18 >>> 16) | 0)) | 0) + (((((65535 & c1part$18) + a1b0$19) | 0) >>> 16) | 0)) | 0);
      var lo$52 = ((lo$50 + hi$60) | 0);
      var hi$61 = ((hi$59 + ((((lo$50 & hi$60) | ((lo$50 | hi$60) & (~lo$52))) >>> 31) | 0)) | 0);
      var b0$20 = (65535 & nanos_$_hi);
      var b1$20 = ((nanos_$_hi >>> 16) | 0);
      var a0b0$19 = Math.imul(13310, b0$20);
      var a1b0$20 = Math.imul(293, b0$20);
      var a0b1$19 = Math.imul(13310, b1$20);
      var lo$53 = ((a0b0$19 + (((a1b0$20 + a0b1$19) | 0) << 16)) | 0);
      var c1part$19 = ((((a0b0$19 >>> 16) | 0) + a0b1$19) | 0);
      var hi$62 = ((((((Math.imul(19215358, hi$58) + Math.imul(293, b1$20)) | 0) + ((c1part$19 >>> 16) | 0)) | 0) + (((((65535 & c1part$19) + a1b0$20) | 0) >>> 16) | 0)) | 0);
      var hi$63 = (hi$61 >> 31);
      var lo$54 = ((lo$53 + hi$61) | 0);
      var hi$64 = ((((hi$62 + hi$63) | 0) + ((((lo$53 & hi$61) | ((lo$53 | hi$61) & (~lo$54))) >>> 31) | 0)) | 0);
      var b0$21 = (65535 & nanos_$_hi);
      var b1$21 = ((nanos_$_hi >>> 16) | 0);
      var a0b0$20 = Math.imul(15645, b0$21);
      var a1b0$21 = Math.imul(26877, b0$21);
      var a0b1$20 = Math.imul(15645, b1$21);
      var lo$55 = ((a0b0$20 + (((a1b0$21 + a0b1$20) | 0) << 16)) | 0);
      var c1part$20 = ((((a0b0$20 >>> 16) | 0) + a0b1$20) | 0);
      var hi$65 = ((((((Math.imul(1761426717, hi$58) + Math.imul(26877, b1$21)) | 0) + ((c1part$20 >>> 16) | 0)) | 0) + (((((65535 & c1part$20) + a1b0$21) | 0) >>> 16) | 0)) | 0);
      var lo$56 = ((lo$52 + lo$55) | 0);
      var hi$66 = ((hi$65 + ((((lo$52 & lo$55) | ((lo$52 | lo$55) & (~lo$56))) >>> 31) | 0)) | 0);
      var hi$67 = (hi$66 >> 31);
      var lo$57 = ((lo$54 + hi$66) | 0);
      var hi$68 = ((((hi$64 + hi$67) | 0) + ((((lo$54 & hi$66) | ((lo$54 | hi$66) & (~lo$57))) >>> 31) | 0)) | 0);
      var lo$58 = (((lo$57 >>> 28) | 0) | (hi$68 << 4));
      var hi$69 = (hi$68 >> 28);
      var lo$59 = ((nanos_$_hi >>> 31) | 0);
      var lo$60 = ((lo$58 + lo$59) | 0);
      var hi$70 = ((hi$69 + ((((lo$58 & lo$59) | ((lo$58 | lo$59) & (~lo$60))) >>> 31) | 0)) | 0);
      var b0$22 = (65535 & lo$60);
      var b1$22 = ((lo$60 >>> 16) | 0);
      var a0b0$21 = Math.imul(22528, b0$22);
      var a1b0$22 = Math.imul(63559, b0$22);
      var a0b1$21 = Math.imul(22528, b1$22);
      var lo$61 = ((a0b0$21 + (((a1b0$22 + a0b1$21) | 0) << 16)) | 0);
      var c1part$21 = ((((a0b0$21 >>> 16) | 0) + a0b1$21) | 0);
      var hi$71 = ((((((((Math.imul((-129542144), hi$70) + Math.imul(13, lo$60)) | 0) + Math.imul(63559, b1$22)) | 0) + ((c1part$21 >>> 16) | 0)) | 0) + (((((65535 & c1part$21) + a1b0$22) | 0) >>> 16) | 0)) | 0);
      var lo$62 = ((nanos_$_lo - lo$61) | 0);
      var hi$72 = ((((nanos_$_hi - hi$71) | 0) + ((((~nanos_$_lo) & lo$61) | ((~(nanos_$_lo ^ lo$61)) & lo$62)) >> 31)) | 0);
      if (((lo$62 | hi$72) === 0)) {
        $m_s_concurrent_duration_Duration$();
        var hi$73 = (nanos_$_hi >> 31);
        var b0$23 = (65535 & nanos_$_lo);
        var b1$23 = ((nanos_$_lo >>> 16) | 0);
        var a0b0$22 = Math.imul(13310, b0$23);
        var a1b0$23 = Math.imul(293, b0$23);
        var a0b1$22 = Math.imul(13310, b1$23);
        var lo$63 = ((a0b0$22 + (((a1b0$23 + a0b1$22) | 0) << 16)) | 0);
        var c1part$22 = ((((a0b0$22 >>> 16) | 0) + a0b1$22) | 0);
        var hi$74 = ((((Math.imul(293, b1$23) + ((c1part$22 >>> 16) | 0)) | 0) + (((((65535 & c1part$22) + a1b0$23) | 0) >>> 16) | 0)) | 0);
        var b0$24 = (65535 & nanos_$_lo);
        var b1$24 = ((nanos_$_lo >>> 16) | 0);
        var a0b0$23 = Math.imul(15645, b0$24);
        var a1b0$24 = Math.imul(26877, b0$24);
        var a0b1$23 = Math.imul(15645, b1$24);
        var c1part$23 = ((((a0b0$23 >>> 16) | 0) + a0b1$23) | 0);
        var hi$75 = ((((Math.imul(26877, b1$24) + ((c1part$23 >>> 16) | 0)) | 0) + (((((65535 & c1part$23) + a1b0$24) | 0) >>> 16) | 0)) | 0);
        var lo$65 = ((lo$63 + hi$75) | 0);
        var hi$76 = ((hi$74 + ((((lo$63 & hi$75) | ((lo$63 | hi$75) & (~lo$65))) >>> 31) | 0)) | 0);
        var b0$25 = (65535 & nanos_$_hi);
        var b1$25 = ((nanos_$_hi >>> 16) | 0);
        var a0b0$24 = Math.imul(13310, b0$25);
        var a1b0$25 = Math.imul(293, b0$25);
        var a0b1$24 = Math.imul(13310, b1$25);
        var lo$66 = ((a0b0$24 + (((a1b0$25 + a0b1$24) | 0) << 16)) | 0);
        var c1part$24 = ((((a0b0$24 >>> 16) | 0) + a0b1$24) | 0);
        var hi$77 = ((((((Math.imul(19215358, hi$73) + Math.imul(293, b1$25)) | 0) + ((c1part$24 >>> 16) | 0)) | 0) + (((((65535 & c1part$24) + a1b0$25) | 0) >>> 16) | 0)) | 0);
        var hi$78 = (hi$76 >> 31);
        var lo$67 = ((lo$66 + hi$76) | 0);
        var hi$79 = ((((hi$77 + hi$78) | 0) + ((((lo$66 & hi$76) | ((lo$66 | hi$76) & (~lo$67))) >>> 31) | 0)) | 0);
        var b0$26 = (65535 & nanos_$_hi);
        var b1$26 = ((nanos_$_hi >>> 16) | 0);
        var a0b0$25 = Math.imul(15645, b0$26);
        var a1b0$26 = Math.imul(26877, b0$26);
        var a0b1$25 = Math.imul(15645, b1$26);
        var lo$68 = ((a0b0$25 + (((a1b0$26 + a0b1$25) | 0) << 16)) | 0);
        var c1part$25 = ((((a0b0$25 >>> 16) | 0) + a0b1$25) | 0);
        var hi$80 = ((((((Math.imul(1761426717, hi$73) + Math.imul(26877, b1$26)) | 0) + ((c1part$25 >>> 16) | 0)) | 0) + (((((65535 & c1part$25) + a1b0$26) | 0) >>> 16) | 0)) | 0);
        var lo$69 = ((lo$65 + lo$68) | 0);
        var hi$81 = ((hi$80 + ((((lo$65 & lo$68) | ((lo$65 | lo$68) & (~lo$69))) >>> 31) | 0)) | 0);
        var hi$82 = (hi$81 >> 31);
        var lo$70 = ((lo$67 + hi$81) | 0);
        var hi$83 = ((((hi$79 + hi$82) | 0) + ((((lo$67 & hi$81) | ((lo$67 | hi$81) & (~lo$70))) >>> 31) | 0)) | 0);
        var lo$71 = (((lo$70 >>> 28) | 0) | (hi$83 << 4));
        var hi$84 = (hi$83 >> 28);
        var lo$72 = ((nanos_$_hi >>> 31) | 0);
        var lo$73 = ((lo$71 + lo$72) | 0);
        var hi$85 = ((hi$84 + ((((lo$71 & lo$72) | ((lo$71 | lo$72) & (~lo$73))) >>> 31) | 0)) | 0);
        var unit$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
        return new $c_s_concurrent_duration_FiniteDuration(lo$73, hi$85, unit$2);
      } else {
        var hi$86 = (nanos_$_hi >> 31);
        var b0$27 = (65535 & nanos_$_lo);
        var b1$27 = ((nanos_$_lo >>> 16) | 0);
        var a0b0$26 = Math.imul(3048, b0$27);
        var a1b0$27 = Math.imul(4398, b0$27);
        var a0b1$26 = Math.imul(3048, b1$27);
        var lo$74 = ((a0b0$26 + (((a1b0$27 + a0b1$26) | 0) << 16)) | 0);
        var c1part$26 = ((((a0b0$26 >>> 16) | 0) + a0b1$26) | 0);
        var hi$87 = ((((Math.imul(4398, b1$27) + ((c1part$26 >>> 16) | 0)) | 0) + (((((65535 & c1part$26) + a1b0$27) | 0) >>> 16) | 0)) | 0);
        var b0$28 = (65535 & nanos_$_lo);
        var b1$28 = ((nanos_$_lo >>> 16) | 0);
        var a0b0$27 = Math.imul(38067, b0$28);
        var a1b0$28 = Math.imul(9942, b0$28);
        var a0b1$27 = Math.imul(38067, b1$28);
        var c1part$27 = ((((a0b0$27 >>> 16) | 0) + a0b1$27) | 0);
        var hi$88 = ((((Math.imul(9942, b1$28) + ((c1part$27 >>> 16) | 0)) | 0) + (((((65535 & c1part$27) + a1b0$28) | 0) >>> 16) | 0)) | 0);
        var lo$76 = ((lo$74 + hi$88) | 0);
        var hi$89 = ((hi$87 + ((((lo$74 & hi$88) | ((lo$74 | hi$88) & (~lo$76))) >>> 31) | 0)) | 0);
        var b0$29 = (65535 & nanos_$_hi);
        var b1$29 = ((nanos_$_hi >>> 16) | 0);
        var a0b0$28 = Math.imul(3048, b0$29);
        var a1b0$29 = Math.imul(4398, b0$29);
        var a0b1$28 = Math.imul(3048, b1$29);
        var lo$77 = ((a0b0$28 + (((a1b0$29 + a0b1$28) | 0) << 16)) | 0);
        var c1part$28 = ((((a0b0$28 >>> 16) | 0) + a0b1$28) | 0);
        var hi$90 = ((((((Math.imul(288230376, hi$86) + Math.imul(4398, b1$29)) | 0) + ((c1part$28 >>> 16) | 0)) | 0) + (((((65535 & c1part$28) + a1b0$29) | 0) >>> 16) | 0)) | 0);
        var hi$91 = (hi$89 >> 31);
        var lo$78 = ((lo$77 + hi$89) | 0);
        var hi$92 = ((((hi$90 + hi$91) | 0) + ((((lo$77 & hi$89) | ((lo$77 | hi$89) & (~lo$78))) >>> 31) | 0)) | 0);
        var b0$30 = (65535 & nanos_$_hi);
        var b1$30 = ((nanos_$_hi >>> 16) | 0);
        var a0b0$29 = Math.imul(38067, b0$30);
        var a1b0$30 = Math.imul(9942, b0$30);
        var a0b1$29 = Math.imul(38067, b1$30);
        var lo$79 = ((a0b0$29 + (((a1b0$30 + a0b1$29) | 0) << 16)) | 0);
        var c1part$29 = ((((a0b0$29 >>> 16) | 0) + a0b1$29) | 0);
        var hi$93 = ((((((Math.imul(651596979, hi$86) + Math.imul(9942, b1$30)) | 0) + ((c1part$29 >>> 16) | 0)) | 0) + (((((65535 & c1part$29) + a1b0$30) | 0) >>> 16) | 0)) | 0);
        var lo$80 = ((lo$76 + lo$79) | 0);
        var hi$94 = ((hi$93 + ((((lo$76 & lo$79) | ((lo$76 | lo$79) & (~lo$80))) >>> 31) | 0)) | 0);
        var hi$95 = (hi$94 >> 31);
        var lo$81 = ((lo$78 + hi$94) | 0);
        var hi$96 = ((((hi$92 + hi$95) | 0) + ((((lo$78 & hi$94) | ((lo$78 | hi$94) & (~lo$81))) >>> 31) | 0)) | 0);
        var lo$82 = (((lo$81 >>> 26) | 0) | (hi$96 << 6));
        var hi$97 = (hi$96 >> 26);
        var lo$83 = ((nanos_$_hi >>> 31) | 0);
        var lo$84 = ((lo$82 + lo$83) | 0);
        var hi$98 = ((hi$97 + ((((lo$82 & lo$83) | ((lo$82 | lo$83) & (~lo$84))) >>> 31) | 0)) | 0);
        var b0$31 = (65535 & lo$84);
        var b1$31 = ((lo$84 >>> 16) | 0);
        var a0b0$30 = Math.imul(51712, b0$31);
        var a1b0$31 = Math.imul(15258, b0$31);
        var a0b1$30 = Math.imul(51712, b1$31);
        var lo$85 = ((a0b0$30 + (((a1b0$31 + a0b1$30) | 0) << 16)) | 0);
        var c1part$30 = ((((a0b0$30 >>> 16) | 0) + a0b1$30) | 0);
        var hi$99 = ((((((Math.imul(1000000000, hi$98) + Math.imul(15258, b1$31)) | 0) + ((c1part$30 >>> 16) | 0)) | 0) + (((((65535 & c1part$30) + a1b0$31) | 0) >>> 16) | 0)) | 0);
        var lo$86 = ((nanos_$_lo - lo$85) | 0);
        var hi$100 = ((((nanos_$_hi - hi$99) | 0) + ((((~nanos_$_lo) & lo$85) | ((~(nanos_$_lo ^ lo$85)) & lo$86)) >> 31)) | 0);
        if (((lo$86 | hi$100) === 0)) {
          $m_s_concurrent_duration_Duration$();
          var hi$101 = (nanos_$_hi >> 31);
          var b0$32 = (65535 & nanos_$_lo);
          var b1$32 = ((nanos_$_lo >>> 16) | 0);
          var a0b0$31 = Math.imul(3048, b0$32);
          var a1b0$32 = Math.imul(4398, b0$32);
          var a0b1$31 = Math.imul(3048, b1$32);
          var lo$87 = ((a0b0$31 + (((a1b0$32 + a0b1$31) | 0) << 16)) | 0);
          var c1part$31 = ((((a0b0$31 >>> 16) | 0) + a0b1$31) | 0);
          var hi$102 = ((((Math.imul(4398, b1$32) + ((c1part$31 >>> 16) | 0)) | 0) + (((((65535 & c1part$31) + a1b0$32) | 0) >>> 16) | 0)) | 0);
          var b0$33 = (65535 & nanos_$_lo);
          var b1$33 = ((nanos_$_lo >>> 16) | 0);
          var a0b0$32 = Math.imul(38067, b0$33);
          var a1b0$33 = Math.imul(9942, b0$33);
          var a0b1$32 = Math.imul(38067, b1$33);
          var c1part$32 = ((((a0b0$32 >>> 16) | 0) + a0b1$32) | 0);
          var hi$103 = ((((Math.imul(9942, b1$33) + ((c1part$32 >>> 16) | 0)) | 0) + (((((65535 & c1part$32) + a1b0$33) | 0) >>> 16) | 0)) | 0);
          var lo$89 = ((lo$87 + hi$103) | 0);
          var hi$104 = ((hi$102 + ((((lo$87 & hi$103) | ((lo$87 | hi$103) & (~lo$89))) >>> 31) | 0)) | 0);
          var b0$34 = (65535 & nanos_$_hi);
          var b1$34 = ((nanos_$_hi >>> 16) | 0);
          var a0b0$33 = Math.imul(3048, b0$34);
          var a1b0$34 = Math.imul(4398, b0$34);
          var a0b1$33 = Math.imul(3048, b1$34);
          var lo$90 = ((a0b0$33 + (((a1b0$34 + a0b1$33) | 0) << 16)) | 0);
          var c1part$33 = ((((a0b0$33 >>> 16) | 0) + a0b1$33) | 0);
          var hi$105 = ((((((Math.imul(288230376, hi$101) + Math.imul(4398, b1$34)) | 0) + ((c1part$33 >>> 16) | 0)) | 0) + (((((65535 & c1part$33) + a1b0$34) | 0) >>> 16) | 0)) | 0);
          var hi$106 = (hi$104 >> 31);
          var lo$91 = ((lo$90 + hi$104) | 0);
          var hi$107 = ((((hi$105 + hi$106) | 0) + ((((lo$90 & hi$104) | ((lo$90 | hi$104) & (~lo$91))) >>> 31) | 0)) | 0);
          var b0$35 = (65535 & nanos_$_hi);
          var b1$35 = ((nanos_$_hi >>> 16) | 0);
          var a0b0$34 = Math.imul(38067, b0$35);
          var a1b0$35 = Math.imul(9942, b0$35);
          var a0b1$34 = Math.imul(38067, b1$35);
          var lo$92 = ((a0b0$34 + (((a1b0$35 + a0b1$34) | 0) << 16)) | 0);
          var c1part$34 = ((((a0b0$34 >>> 16) | 0) + a0b1$34) | 0);
          var hi$108 = ((((((Math.imul(651596979, hi$101) + Math.imul(9942, b1$35)) | 0) + ((c1part$34 >>> 16) | 0)) | 0) + (((((65535 & c1part$34) + a1b0$35) | 0) >>> 16) | 0)) | 0);
          var lo$93 = ((lo$89 + lo$92) | 0);
          var hi$109 = ((hi$108 + ((((lo$89 & lo$92) | ((lo$89 | lo$92) & (~lo$93))) >>> 31) | 0)) | 0);
          var hi$110 = (hi$109 >> 31);
          var lo$94 = ((lo$91 + hi$109) | 0);
          var hi$111 = ((((hi$107 + hi$110) | 0) + ((((lo$91 & hi$109) | ((lo$91 | hi$109) & (~lo$94))) >>> 31) | 0)) | 0);
          var lo$95 = (((lo$94 >>> 26) | 0) | (hi$111 << 6));
          var hi$112 = (hi$111 >> 26);
          var lo$96 = ((nanos_$_hi >>> 31) | 0);
          var lo$97 = ((lo$95 + lo$96) | 0);
          var hi$113 = ((hi$112 + ((((lo$95 & lo$96) | ((lo$95 | lo$96) & (~lo$97))) >>> 31) | 0)) | 0);
          var unit$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
          return new $c_s_concurrent_duration_FiniteDuration(lo$97, hi$113, unit$3);
        } else {
          var hi$114 = (nanos_$_hi >> 31);
          var b0$36 = (65535 & nanos_$_lo);
          var b1$36 = ((nanos_$_lo >>> 16) | 0);
          var a0b0$35 = Math.imul(56962, b0$36);
          var a1b0$36 = Math.imul(17179, b0$36);
          var a0b1$35 = Math.imul(56962, b1$36);
          var lo$98 = ((a0b0$35 + (((a1b0$36 + a0b1$35) | 0) << 16)) | 0);
          var c1part$35 = ((((a0b0$35 >>> 16) | 0) + a0b1$35) | 0);
          var hi$115 = ((((Math.imul(17179, b1$36) + ((c1part$35 >>> 16) | 0)) | 0) + (((((65535 & c1part$35) + a1b0$36) | 0) >>> 16) | 0)) | 0);
          var b0$37 = (65535 & nanos_$_lo);
          var b1$37 = ((nanos_$_lo >>> 16) | 0);
          var a0b0$36 = Math.imul(13531, b0$37);
          var a1b0$37 = Math.imul(55222, b0$37);
          var a0b1$36 = Math.imul(13531, b1$37);
          var c1part$36 = ((((a0b0$36 >>> 16) | 0) + a0b1$36) | 0);
          var hi$116 = ((((Math.imul(55222, b1$37) + ((c1part$36 >>> 16) | 0)) | 0) + (((((65535 & c1part$36) + a1b0$37) | 0) >>> 16) | 0)) | 0);
          var lo$100 = ((lo$98 + hi$116) | 0);
          var hi$117 = ((hi$115 + ((((lo$98 & hi$116) | ((lo$98 | hi$116) & (~lo$100))) >>> 31) | 0)) | 0);
          var b0$38 = (65535 & nanos_$_hi);
          var b1$38 = ((nanos_$_hi >>> 16) | 0);
          var a0b0$37 = Math.imul(56962, b0$38);
          var a1b0$38 = Math.imul(17179, b0$38);
          var a0b1$37 = Math.imul(56962, b1$38);
          var lo$101 = ((a0b0$37 + (((a1b0$38 + a0b1$37) | 0) << 16)) | 0);
          var c1part$37 = ((((a0b0$37 >>> 16) | 0) + a0b1$37) | 0);
          var hi$118 = ((((((Math.imul(1125899906, hi$114) + Math.imul(17179, b1$38)) | 0) + ((c1part$37 >>> 16) | 0)) | 0) + (((((65535 & c1part$37) + a1b0$38) | 0) >>> 16) | 0)) | 0);
          var hi$119 = (hi$117 >> 31);
          var lo$102 = ((lo$101 + hi$117) | 0);
          var hi$120 = ((((hi$118 + hi$119) | 0) + ((((lo$101 & hi$117) | ((lo$101 | hi$117) & (~lo$102))) >>> 31) | 0)) | 0);
          var b0$39 = (65535 & nanos_$_hi);
          var b1$39 = ((nanos_$_hi >>> 16) | 0);
          var a0b0$38 = Math.imul(13531, b0$39);
          var a1b0$39 = Math.imul(55222, b0$39);
          var a0b1$38 = Math.imul(13531, b1$39);
          var lo$103 = ((a0b0$38 + (((a1b0$39 + a0b1$38) | 0) << 16)) | 0);
          var c1part$38 = ((((a0b0$38 >>> 16) | 0) + a0b1$38) | 0);
          var hi$121 = ((((((Math.imul((-675924773), hi$114) + Math.imul(55222, b1$39)) | 0) + ((c1part$38 >>> 16) | 0)) | 0) + (((((65535 & c1part$38) + a1b0$39) | 0) >>> 16) | 0)) | 0);
          var lo$104 = ((lo$100 + lo$103) | 0);
          var hi$122 = ((hi$121 + ((((lo$100 & lo$103) | ((lo$100 | lo$103) & (~lo$104))) >>> 31) | 0)) | 0);
          var hi$123 = (hi$122 >> 31);
          var lo$105 = ((lo$102 + hi$122) | 0);
          var hi$124 = ((((hi$120 + hi$123) | 0) + ((((lo$102 & hi$122) | ((lo$102 | hi$122) & (~lo$105))) >>> 31) | 0)) | 0);
          var lo$106 = (((lo$105 >>> 18) | 0) | (hi$124 << 14));
          var hi$125 = (hi$124 >> 18);
          var lo$107 = ((nanos_$_hi >>> 31) | 0);
          var lo$108 = ((lo$106 + lo$107) | 0);
          var hi$126 = ((hi$125 + ((((lo$106 & lo$107) | ((lo$106 | lo$107) & (~lo$108))) >>> 31) | 0)) | 0);
          var b0$40 = (65535 & lo$108);
          var b1$40 = ((lo$108 >>> 16) | 0);
          var a0b0$39 = Math.imul(16960, b0$40);
          var a1b0$40 = Math.imul(15, b0$40);
          var a0b1$39 = Math.imul(16960, b1$40);
          var lo$109 = ((a0b0$39 + (((a1b0$40 + a0b1$39) | 0) << 16)) | 0);
          var c1part$39 = ((((a0b0$39 >>> 16) | 0) + a0b1$39) | 0);
          var hi$127 = ((((((Math.imul(1000000, hi$126) + Math.imul(15, b1$40)) | 0) + ((c1part$39 >>> 16) | 0)) | 0) + (((((65535 & c1part$39) + a1b0$40) | 0) >>> 16) | 0)) | 0);
          var lo$110 = ((nanos_$_lo - lo$109) | 0);
          var hi$128 = ((((nanos_$_hi - hi$127) | 0) + ((((~nanos_$_lo) & lo$109) | ((~(nanos_$_lo ^ lo$109)) & lo$110)) >> 31)) | 0);
          if (((lo$110 | hi$128) === 0)) {
            $m_s_concurrent_duration_Duration$();
            var hi$129 = (nanos_$_hi >> 31);
            var b0$41 = (65535 & nanos_$_lo);
            var b1$41 = ((nanos_$_lo >>> 16) | 0);
            var a0b0$40 = Math.imul(56962, b0$41);
            var a1b0$41 = Math.imul(17179, b0$41);
            var a0b1$40 = Math.imul(56962, b1$41);
            var lo$111 = ((a0b0$40 + (((a1b0$41 + a0b1$40) | 0) << 16)) | 0);
            var c1part$40 = ((((a0b0$40 >>> 16) | 0) + a0b1$40) | 0);
            var hi$130 = ((((Math.imul(17179, b1$41) + ((c1part$40 >>> 16) | 0)) | 0) + (((((65535 & c1part$40) + a1b0$41) | 0) >>> 16) | 0)) | 0);
            var b0$42 = (65535 & nanos_$_lo);
            var b1$42 = ((nanos_$_lo >>> 16) | 0);
            var a0b0$41 = Math.imul(13531, b0$42);
            var a1b0$42 = Math.imul(55222, b0$42);
            var a0b1$41 = Math.imul(13531, b1$42);
            var c1part$41 = ((((a0b0$41 >>> 16) | 0) + a0b1$41) | 0);
            var hi$131 = ((((Math.imul(55222, b1$42) + ((c1part$41 >>> 16) | 0)) | 0) + (((((65535 & c1part$41) + a1b0$42) | 0) >>> 16) | 0)) | 0);
            var lo$113 = ((lo$111 + hi$131) | 0);
            var hi$132 = ((hi$130 + ((((lo$111 & hi$131) | ((lo$111 | hi$131) & (~lo$113))) >>> 31) | 0)) | 0);
            var b0$43 = (65535 & nanos_$_hi);
            var b1$43 = ((nanos_$_hi >>> 16) | 0);
            var a0b0$42 = Math.imul(56962, b0$43);
            var a1b0$43 = Math.imul(17179, b0$43);
            var a0b1$42 = Math.imul(56962, b1$43);
            var lo$114 = ((a0b0$42 + (((a1b0$43 + a0b1$42) | 0) << 16)) | 0);
            var c1part$42 = ((((a0b0$42 >>> 16) | 0) + a0b1$42) | 0);
            var hi$133 = ((((((Math.imul(1125899906, hi$129) + Math.imul(17179, b1$43)) | 0) + ((c1part$42 >>> 16) | 0)) | 0) + (((((65535 & c1part$42) + a1b0$43) | 0) >>> 16) | 0)) | 0);
            var hi$134 = (hi$132 >> 31);
            var lo$115 = ((lo$114 + hi$132) | 0);
            var hi$135 = ((((hi$133 + hi$134) | 0) + ((((lo$114 & hi$132) | ((lo$114 | hi$132) & (~lo$115))) >>> 31) | 0)) | 0);
            var b0$44 = (65535 & nanos_$_hi);
            var b1$44 = ((nanos_$_hi >>> 16) | 0);
            var a0b0$43 = Math.imul(13531, b0$44);
            var a1b0$44 = Math.imul(55222, b0$44);
            var a0b1$43 = Math.imul(13531, b1$44);
            var lo$116 = ((a0b0$43 + (((a1b0$44 + a0b1$43) | 0) << 16)) | 0);
            var c1part$43 = ((((a0b0$43 >>> 16) | 0) + a0b1$43) | 0);
            var hi$136 = ((((((Math.imul((-675924773), hi$129) + Math.imul(55222, b1$44)) | 0) + ((c1part$43 >>> 16) | 0)) | 0) + (((((65535 & c1part$43) + a1b0$44) | 0) >>> 16) | 0)) | 0);
            var lo$117 = ((lo$113 + lo$116) | 0);
            var hi$137 = ((hi$136 + ((((lo$113 & lo$116) | ((lo$113 | lo$116) & (~lo$117))) >>> 31) | 0)) | 0);
            var hi$138 = (hi$137 >> 31);
            var lo$118 = ((lo$115 + hi$137) | 0);
            var hi$139 = ((((hi$135 + hi$138) | 0) + ((((lo$115 & hi$137) | ((lo$115 | hi$137) & (~lo$118))) >>> 31) | 0)) | 0);
            var lo$119 = (((lo$118 >>> 18) | 0) | (hi$139 << 14));
            var hi$140 = (hi$139 >> 18);
            var lo$120 = ((nanos_$_hi >>> 31) | 0);
            var lo$121 = ((lo$119 + lo$120) | 0);
            var hi$141 = ((hi$140 + ((((lo$119 & lo$120) | ((lo$119 | lo$120) & (~lo$121))) >>> 31) | 0)) | 0);
            var unit$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
            return new $c_s_concurrent_duration_FiniteDuration(lo$121, hi$141, unit$4);
          } else {
            var hi$142 = (nanos_$_hi >> 31);
            var b0$45 = (65535 & nanos_$_lo);
            var b1$45 = ((nanos_$_lo >>> 16) | 0);
            var a0b0$44 = Math.imul(39845, b0$45);
            var a1b0$45 = Math.imul(8388, b0$45);
            var a0b1$44 = Math.imul(39845, b1$45);
            var lo$122 = ((a0b0$44 + (((a1b0$45 + a0b1$44) | 0) << 16)) | 0);
            var c1part$44 = ((((a0b0$44 >>> 16) | 0) + a0b1$44) | 0);
            var hi$143 = ((((Math.imul(8388, b1$45) + ((c1part$44 >>> 16) | 0)) | 0) + (((((65535 & c1part$44) + a1b0$45) | 0) >>> 16) | 0)) | 0);
            var b0$46 = (65535 & nanos_$_lo);
            var b1$46 = ((nanos_$_lo >>> 16) | 0);
            var a0b0$45 = Math.imul(63439, b0$46);
            var a1b0$46 = Math.imul(58195, b0$46);
            var a0b1$45 = Math.imul(63439, b1$46);
            var c1part$45 = ((((a0b0$45 >>> 16) | 0) + a0b1$45) | 0);
            var hi$144 = ((((Math.imul(58195, b1$46) + ((c1part$45 >>> 16) | 0)) | 0) + (((((65535 & c1part$45) + a1b0$46) | 0) >>> 16) | 0)) | 0);
            var lo$124 = ((lo$122 + hi$144) | 0);
            var hi$145 = ((hi$143 + ((((lo$122 & hi$144) | ((lo$122 | hi$144) & (~lo$124))) >>> 31) | 0)) | 0);
            var b0$47 = (65535 & nanos_$_hi);
            var b1$47 = ((nanos_$_hi >>> 16) | 0);
            var a0b0$46 = Math.imul(39845, b0$47);
            var a1b0$47 = Math.imul(8388, b0$47);
            var a0b1$46 = Math.imul(39845, b1$47);
            var lo$125 = ((a0b0$46 + (((a1b0$47 + a0b1$46) | 0) << 16)) | 0);
            var c1part$46 = ((((a0b0$46 >>> 16) | 0) + a0b1$46) | 0);
            var hi$146 = ((((((Math.imul(549755813, hi$142) + Math.imul(8388, b1$47)) | 0) + ((c1part$46 >>> 16) | 0)) | 0) + (((((65535 & c1part$46) + a1b0$47) | 0) >>> 16) | 0)) | 0);
            var hi$147 = (hi$145 >> 31);
            var lo$126 = ((lo$125 + hi$145) | 0);
            var hi$148 = ((((hi$146 + hi$147) | 0) + ((((lo$125 & hi$145) | ((lo$125 | hi$145) & (~lo$126))) >>> 31) | 0)) | 0);
            var b0$48 = (65535 & nanos_$_hi);
            var b1$48 = ((nanos_$_hi >>> 16) | 0);
            var a0b0$47 = Math.imul(63439, b0$48);
            var a1b0$48 = Math.imul(58195, b0$48);
            var a0b1$47 = Math.imul(63439, b1$48);
            var lo$127 = ((a0b0$47 + (((a1b0$48 + a0b1$47) | 0) << 16)) | 0);
            var c1part$47 = ((((a0b0$47 >>> 16) | 0) + a0b1$47) | 0);
            var hi$149 = ((((((Math.imul((-481036337), hi$142) + Math.imul(58195, b1$48)) | 0) + ((c1part$47 >>> 16) | 0)) | 0) + (((((65535 & c1part$47) + a1b0$48) | 0) >>> 16) | 0)) | 0);
            var lo$128 = ((lo$124 + lo$127) | 0);
            var hi$150 = ((hi$149 + ((((lo$124 & lo$127) | ((lo$124 | lo$127) & (~lo$128))) >>> 31) | 0)) | 0);
            var hi$151 = (hi$150 >> 31);
            var lo$129 = ((lo$126 + hi$150) | 0);
            var hi$152 = ((((hi$148 + hi$151) | 0) + ((((lo$126 & hi$150) | ((lo$126 | hi$150) & (~lo$129))) >>> 31) | 0)) | 0);
            var lo$130 = (((lo$129 >>> 7) | 0) | (hi$152 << 25));
            var hi$153 = (hi$152 >> 7);
            var lo$131 = ((nanos_$_hi >>> 31) | 0);
            var lo$132 = ((lo$130 + lo$131) | 0);
            var hi$154 = ((hi$153 + ((((lo$130 & lo$131) | ((lo$130 | lo$131) & (~lo$132))) >>> 31) | 0)) | 0);
            var b0$49 = (65535 & lo$132);
            var b1$49 = ((lo$132 >>> 16) | 0);
            var a0b0$48 = Math.imul(1000, b0$49);
            var a0b1$48 = Math.imul(1000, b1$49);
            var lo$133 = ((a0b0$48 + (a0b1$48 << 16)) | 0);
            var c1part$48 = ((((a0b0$48 >>> 16) | 0) + a0b1$48) | 0);
            var hi$155 = ((Math.imul(1000, hi$154) + ((c1part$48 >>> 16) | 0)) | 0);
            var lo$134 = ((nanos_$_lo - lo$133) | 0);
            var hi$156 = ((((nanos_$_hi - hi$155) | 0) + ((((~nanos_$_lo) & lo$133) | ((~(nanos_$_lo ^ lo$133)) & lo$134)) >> 31)) | 0);
            if (((lo$134 | hi$156) === 0)) {
              $m_s_concurrent_duration_Duration$();
              var hi$157 = (nanos_$_hi >> 31);
              var b0$50 = (65535 & nanos_$_lo);
              var b1$50 = ((nanos_$_lo >>> 16) | 0);
              var a0b0$49 = Math.imul(39845, b0$50);
              var a1b0$49 = Math.imul(8388, b0$50);
              var a0b1$49 = Math.imul(39845, b1$50);
              var lo$135 = ((a0b0$49 + (((a1b0$49 + a0b1$49) | 0) << 16)) | 0);
              var c1part$49 = ((((a0b0$49 >>> 16) | 0) + a0b1$49) | 0);
              var hi$158 = ((((Math.imul(8388, b1$50) + ((c1part$49 >>> 16) | 0)) | 0) + (((((65535 & c1part$49) + a1b0$49) | 0) >>> 16) | 0)) | 0);
              var b0$51 = (65535 & nanos_$_lo);
              var b1$51 = ((nanos_$_lo >>> 16) | 0);
              var a0b0$50 = Math.imul(63439, b0$51);
              var a1b0$50 = Math.imul(58195, b0$51);
              var a0b1$50 = Math.imul(63439, b1$51);
              var c1part$50 = ((((a0b0$50 >>> 16) | 0) + a0b1$50) | 0);
              var hi$159 = ((((Math.imul(58195, b1$51) + ((c1part$50 >>> 16) | 0)) | 0) + (((((65535 & c1part$50) + a1b0$50) | 0) >>> 16) | 0)) | 0);
              var lo$137 = ((lo$135 + hi$159) | 0);
              var hi$160 = ((hi$158 + ((((lo$135 & hi$159) | ((lo$135 | hi$159) & (~lo$137))) >>> 31) | 0)) | 0);
              var b0$52 = (65535 & nanos_$_hi);
              var b1$52 = ((nanos_$_hi >>> 16) | 0);
              var a0b0$51 = Math.imul(39845, b0$52);
              var a1b0$51 = Math.imul(8388, b0$52);
              var a0b1$51 = Math.imul(39845, b1$52);
              var lo$138 = ((a0b0$51 + (((a1b0$51 + a0b1$51) | 0) << 16)) | 0);
              var c1part$51 = ((((a0b0$51 >>> 16) | 0) + a0b1$51) | 0);
              var hi$161 = ((((((Math.imul(549755813, hi$157) + Math.imul(8388, b1$52)) | 0) + ((c1part$51 >>> 16) | 0)) | 0) + (((((65535 & c1part$51) + a1b0$51) | 0) >>> 16) | 0)) | 0);
              var hi$162 = (hi$160 >> 31);
              var lo$139 = ((lo$138 + hi$160) | 0);
              var hi$163 = ((((hi$161 + hi$162) | 0) + ((((lo$138 & hi$160) | ((lo$138 | hi$160) & (~lo$139))) >>> 31) | 0)) | 0);
              var b0$53 = (65535 & nanos_$_hi);
              var b1$53 = ((nanos_$_hi >>> 16) | 0);
              var a0b0$52 = Math.imul(63439, b0$53);
              var a1b0$52 = Math.imul(58195, b0$53);
              var a0b1$52 = Math.imul(63439, b1$53);
              var lo$140 = ((a0b0$52 + (((a1b0$52 + a0b1$52) | 0) << 16)) | 0);
              var c1part$52 = ((((a0b0$52 >>> 16) | 0) + a0b1$52) | 0);
              var hi$164 = ((((((Math.imul((-481036337), hi$157) + Math.imul(58195, b1$53)) | 0) + ((c1part$52 >>> 16) | 0)) | 0) + (((((65535 & c1part$52) + a1b0$52) | 0) >>> 16) | 0)) | 0);
              var lo$141 = ((lo$137 + lo$140) | 0);
              var hi$165 = ((hi$164 + ((((lo$137 & lo$140) | ((lo$137 | lo$140) & (~lo$141))) >>> 31) | 0)) | 0);
              var hi$166 = (hi$165 >> 31);
              var lo$142 = ((lo$139 + hi$165) | 0);
              var hi$167 = ((((hi$163 + hi$166) | 0) + ((((lo$139 & hi$165) | ((lo$139 | hi$165) & (~lo$142))) >>> 31) | 0)) | 0);
              var lo$143 = (((lo$142 >>> 7) | 0) | (hi$167 << 25));
              var hi$168 = (hi$167 >> 7);
              var lo$144 = ((nanos_$_hi >>> 31) | 0);
              var lo$145 = ((lo$143 + lo$144) | 0);
              var hi$169 = ((hi$168 + ((((lo$143 & lo$144) | ((lo$143 | lo$144) & (~lo$145))) >>> 31) | 0)) | 0);
              var unit$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(lo$145, hi$169, unit$5);
            } else {
              $m_s_concurrent_duration_Duration$();
              var unit$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(nanos_$_lo, nanos_$_hi, unit$6);
            }
          }
        }
      }
    }
  }
});
var $d_s_concurrent_duration_Duration$ = new $TypeData().initClass($c_s_concurrent_duration_Duration$, "scala.concurrent.duration.Duration$", ({
  s_concurrent_duration_Duration$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_concurrent_duration_Duration$;
function $m_s_concurrent_duration_Duration$() {
  if ((!$n_s_concurrent_duration_Duration$)) {
    $n_s_concurrent_duration_Duration$ = new $c_s_concurrent_duration_Duration$();
  }
  return $n_s_concurrent_duration_Duration$;
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt(n) {
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = 0;
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = n;
}
$c_s_concurrent_duration_package$DurationInt.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt.prototype.constructor = $c_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt() {
}
$h_s_concurrent_duration_package$DurationInt.prototype = $c_s_concurrent_duration_package$DurationInt.prototype;
$c_s_concurrent_duration_package$DurationInt.prototype.hashCode__I = (function() {
  var this$ = this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  return this$;
});
$c_s_concurrent_duration_package$DurationInt.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationInt$().equals$extension__I__O__Z(this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n, x$1);
});
function $as_s_concurrent_duration_package$DurationInt(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationInt"));
}
function $isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationInt)));
}
function $asArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationInt;", depth));
}
var $d_s_concurrent_duration_package$DurationInt = new $TypeData().initClass($c_s_concurrent_duration_package$DurationInt, "scala.concurrent.duration.package$DurationInt", ({
  s_concurrent_duration_package$DurationInt: 1,
  s_concurrent_duration_DurationConversions: 1
}));
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong(n_$_lo, n_$_hi) {
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo = 0;
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi = 0;
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo = n_$_lo;
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi = n_$_hi;
}
$c_s_concurrent_duration_package$DurationLong.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong.prototype.constructor = $c_s_concurrent_duration_package$DurationLong;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong() {
}
$h_s_concurrent_duration_package$DurationLong.prototype = $c_s_concurrent_duration_package$DurationLong.prototype;
$c_s_concurrent_duration_package$DurationLong.prototype.hashCode__I = (function() {
  var this$_$_lo = this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
  var this$_$_hi = this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
  return (this$_$_lo ^ this$_$_hi);
});
$c_s_concurrent_duration_package$DurationLong.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationLong$().equals$extension__J__O__Z(this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo, this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi, x$1);
});
function $as_s_concurrent_duration_package$DurationLong(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationLong"));
}
function $isArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationLong)));
}
function $asArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationLong;", depth));
}
var $d_s_concurrent_duration_package$DurationLong = new $TypeData().initClass($c_s_concurrent_duration_package$DurationLong, "scala.concurrent.duration.package$DurationLong", ({
  s_concurrent_duration_package$DurationLong: 1,
  s_concurrent_duration_DurationConversions: 1
}));
/** @constructor */
function $c_s_concurrent_impl_Promise$ManyCallbacks(first, rest) {
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = first;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = rest;
}
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype = new $h_O();
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.constructor = $c_s_concurrent_impl_Promise$ManyCallbacks;
/** @constructor */
function $h_s_concurrent_impl_Promise$ManyCallbacks() {
}
$h_s_concurrent_impl_Promise$ManyCallbacks.prototype = $c_s_concurrent_impl_Promise$ManyCallbacks.prototype;
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.toString__T = (function() {
  return "ManyCallbacks";
});
function $as_s_concurrent_impl_Promise$ManyCallbacks(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$ManyCallbacks) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$ManyCallbacks"));
}
function $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$ManyCallbacks)));
}
function $asArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$ManyCallbacks;", depth));
}
var $d_s_concurrent_impl_Promise$ManyCallbacks = new $TypeData().initClass($c_s_concurrent_impl_Promise$ManyCallbacks, "scala.concurrent.impl.Promise$ManyCallbacks", ({
  s_concurrent_impl_Promise$ManyCallbacks: 1,
  s_concurrent_impl_Promise$Callbacks: 1
}));
function $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) {
  if ((!$thiz.s_math_BigDecimal$__f_bitmap$0)) {
    $thiz.s_math_BigDecimal$__f_cache = new ($d_s_math_BigDecimal.getArrayOf().constr)(((1 + (($thiz.s_math_BigDecimal$__f_maxCached - $thiz.s_math_BigDecimal$__f_minCached) | 0)) | 0));
    $thiz.s_math_BigDecimal$__f_bitmap$0 = true;
  }
  return $thiz.s_math_BigDecimal$__f_cache;
}
function $p_s_math_BigDecimal$__cache__As_math_BigDecimal($thiz) {
  return ((!$thiz.s_math_BigDecimal$__f_bitmap$0) ? $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) : $thiz.s_math_BigDecimal$__f_cache);
}
/** @constructor */
function $c_s_math_BigDecimal$() {
  this.s_math_BigDecimal$__f_cache = null;
  this.s_math_BigDecimal$__f_minCached = 0;
  this.s_math_BigDecimal$__f_maxCached = 0;
  this.s_math_BigDecimal$__f_defaultMathContext = null;
  this.s_math_BigDecimal$__f_bitmap$0 = false;
  $n_s_math_BigDecimal$ = this;
  this.s_math_BigDecimal$__f_minCached = (-512);
  this.s_math_BigDecimal$__f_maxCached = 512;
  this.s_math_BigDecimal$__f_defaultMathContext = $m_Ljava_math_MathContext$().Ljava_math_MathContext$__f_DECIMAL128;
}
$c_s_math_BigDecimal$.prototype = new $h_O();
$c_s_math_BigDecimal$.prototype.constructor = $c_s_math_BigDecimal$;
/** @constructor */
function $h_s_math_BigDecimal$() {
}
$h_s_math_BigDecimal$.prototype = $c_s_math_BigDecimal$.prototype;
$c_s_math_BigDecimal$.prototype.decimal__D__Ljava_math_MathContext__s_math_BigDecimal = (function(d, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), ("" + d), mc), mc);
});
$c_s_math_BigDecimal$.prototype.apply__I__Ljava_math_MathContext__s_math_BigDecimal = (function(i, mc) {
  var x$2 = this.s_math_BigDecimal$__f_defaultMathContext;
  if (((((mc === null) ? (x$2 === null) : $n(mc).equals__O__Z(x$2)) && (this.s_math_BigDecimal$__f_minCached <= i)) && (i <= this.s_math_BigDecimal$__f_maxCached))) {
    var offset = ((i - this.s_math_BigDecimal$__f_minCached) | 0);
    var n = $n($p_s_math_BigDecimal$__cache__As_math_BigDecimal(this)).get(offset);
    if ((n === null)) {
      var hi = (i >> 31);
      n = new $c_s_math_BigDecimal($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(i, hi), mc);
      $n($p_s_math_BigDecimal$__cache__As_math_BigDecimal(this)).set(offset, n);
    }
    return n;
  } else {
    var hi$1 = (i >> 31);
    return this.apply__J__Ljava_math_MathContext__s_math_BigDecimal(i, hi$1, mc);
  }
});
$c_s_math_BigDecimal$.prototype.apply__J__Ljava_math_MathContext__s_math_BigDecimal = (function(l_$_lo, l_$_hi, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), l_$_lo, l_$_hi, mc), mc);
});
var $d_s_math_BigDecimal$ = new $TypeData().initClass($c_s_math_BigDecimal$, "scala.math.BigDecimal$", ({
  s_math_BigDecimal$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_BigDecimal$;
function $m_s_math_BigDecimal$() {
  if ((!$n_s_math_BigDecimal$)) {
    $n_s_math_BigDecimal$ = new $c_s_math_BigDecimal$();
  }
  return $n_s_math_BigDecimal$;
}
function $p_s_math_BigInt$__getCached__I__s_math_BigInt($thiz, i) {
  var offset = ((i - $thiz.s_math_BigInt$__f_minCached) | 0);
  var n = $n($thiz.s_math_BigInt$__f_cache).get(offset);
  if ((n === null)) {
    var hi = (i >> 31);
    n = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, i, hi);
    $n($thiz.s_math_BigInt$__f_cache).set(offset, n);
  }
  return n;
}
/** @constructor */
function $c_s_math_BigInt$() {
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = null;
  this.s_math_BigInt$__f_longMinValue = null;
  this.s_math_BigInt$__f_minCached = 0;
  this.s_math_BigInt$__f_maxCached = 0;
  this.s_math_BigInt$__f_cache = null;
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = null;
  $n_s_math_BigInt$ = this;
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(0, (-2147483648));
  this.s_math_BigInt$__f_longMinValue = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger, 0, (-2147483648));
  this.s_math_BigInt$__f_minCached = (-1024);
  this.s_math_BigInt$__f_maxCached = 1024;
  this.s_math_BigInt$__f_cache = new ($d_s_math_BigInt.getArrayOf().constr)(((1 + ((this.s_math_BigInt$__f_maxCached - this.s_math_BigInt$__f_minCached) | 0)) | 0));
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger((-1), (-1));
}
$c_s_math_BigInt$.prototype = new $h_O();
$c_s_math_BigInt$.prototype.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
}
$h_s_math_BigInt$.prototype = $c_s_math_BigInt$.prototype;
$c_s_math_BigInt$.prototype.apply__I__s_math_BigInt = (function(i) {
  if (((this.s_math_BigInt$__f_minCached <= i) && (i <= this.s_math_BigInt$__f_maxCached))) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, i);
  } else {
    var hi = (i >> 31);
    return this.apply__J__s_math_BigInt(i, hi);
  }
});
$c_s_math_BigInt$.prototype.apply__J__s_math_BigInt = (function(l_$_lo, l_$_hi) {
  var value = this.s_math_BigInt$__f_minCached;
  var hi = (value >> 31);
  if (((hi === l_$_hi) ? ((value >>> 0) <= (l_$_lo >>> 0)) : (hi < l_$_hi))) {
    var value$1 = this.s_math_BigInt$__f_maxCached;
    var hi$1 = (value$1 >> 31);
    var $x_1 = ((l_$_hi === hi$1) ? ((l_$_lo >>> 0) <= (value$1 >>> 0)) : (l_$_hi < hi$1));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l_$_lo);
  } else {
    return (((l_$_lo | ((-2147483648) ^ l_$_hi)) === 0) ? this.s_math_BigInt$__f_longMinValue : $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, l_$_lo, l_$_hi));
  }
});
$c_s_math_BigInt$.prototype.apply__Ljava_math_BigInteger__s_math_BigInt = (function(x) {
  var this$1 = $n(x);
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1) <= 63)) {
    var $x_1 = $n(x).longValue__J();
    var l_$_lo = $x_1.l;
    var l_$_hi = $x_1.h;
    var value = this.s_math_BigInt$__f_minCached;
    var hi = (value >> 31);
    if (((hi === l_$_hi) ? ((value >>> 0) <= (l_$_lo >>> 0)) : (hi < l_$_hi))) {
      var value$1 = this.s_math_BigInt$__f_maxCached;
      var hi$1 = (value$1 >> 31);
      var $x_2 = ((l_$_hi === hi$1) ? ((l_$_lo >>> 0) <= (value$1 >>> 0)) : (l_$_hi < hi$1));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l_$_lo);
    } else {
      return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, l_$_lo, l_$_hi);
    }
  } else {
    return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, 0, (-2147483648));
  }
});
var $d_s_math_BigInt$ = new $TypeData().initClass($c_s_math_BigInt$, "scala.math.BigInt$", ({
  s_math_BigInt$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$();
  }
  return $n_s_math_BigInt$;
}
function $is_s_math_Equiv(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Equiv)));
}
function $as_s_math_Equiv(obj) {
  return (($is_s_math_Equiv(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Equiv"));
}
function $isArrayOf_s_math_Equiv(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Equiv)));
}
function $asArrayOf_s_math_Equiv(obj, depth) {
  return (($isArrayOf_s_math_Equiv(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Equiv;", depth));
}
/** @constructor */
function $c_s_math_Integral$IntegralOps(outer, lhs) {
  this.s_math_Numeric$NumericOps__f_lhs = null;
  this.s_math_Numeric$NumericOps__f_$outer = null;
  this.s_math_Integral$IntegralOps__f_lhs = null;
  this.s_math_Integral$IntegralOps__f_lhs = lhs;
  $ct_s_math_Numeric$NumericOps__s_math_Numeric__O__(this, outer, lhs);
}
$c_s_math_Integral$IntegralOps.prototype = new $h_s_math_Numeric$NumericOps();
$c_s_math_Integral$IntegralOps.prototype.constructor = $c_s_math_Integral$IntegralOps;
/** @constructor */
function $h_s_math_Integral$IntegralOps() {
}
$h_s_math_Integral$IntegralOps.prototype = $c_s_math_Integral$IntegralOps.prototype;
$c_s_math_Integral$IntegralOps.prototype.$div__O__O = (function(rhs) {
  return $n($as_s_math_Integral(this.s_math_Numeric$NumericOps__f_$outer)).quot__O__O__O(this.s_math_Integral$IntegralOps__f_lhs, rhs);
});
var $d_s_math_Integral$IntegralOps = new $TypeData().initClass($c_s_math_Integral$IntegralOps, "scala.math.Integral$IntegralOps", ({
  s_math_Integral$IntegralOps: 1,
  s_math_Numeric$NumericOps: 1
}));
function $f_s_math_Ordered__$less__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) < 0);
}
function $f_s_math_Ordered__$less$eq__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) <= 0);
}
/** @constructor */
function $c_s_reflect_ClassTag$() {
  this.s_reflect_ClassTag$__f_Byte = null;
  this.s_reflect_ClassTag$__f_Short = null;
  this.s_reflect_ClassTag$__f_Char = null;
  this.s_reflect_ClassTag$__f_Int = null;
  this.s_reflect_ClassTag$__f_Long = null;
  this.s_reflect_ClassTag$__f_Float = null;
  this.s_reflect_ClassTag$__f_Double = null;
  this.s_reflect_ClassTag$__f_Boolean = null;
  this.s_reflect_ClassTag$__f_Unit = null;
  this.s_reflect_ClassTag$__f_Any = null;
  this.s_reflect_ClassTag$__f_Object = null;
  this.s_reflect_ClassTag$__f_AnyRef = null;
  this.s_reflect_ClassTag$__f_Nothing = null;
  this.s_reflect_ClassTag$__f_Null = null;
  $n_s_reflect_ClassTag$ = this;
  this.s_reflect_ClassTag$__f_Byte = $m_s_reflect_ManifestFactory$ByteManifest$();
  this.s_reflect_ClassTag$__f_Short = $m_s_reflect_ManifestFactory$ShortManifest$();
  this.s_reflect_ClassTag$__f_Char = $m_s_reflect_ManifestFactory$CharManifest$();
  this.s_reflect_ClassTag$__f_Int = $m_s_reflect_ManifestFactory$IntManifest$();
  this.s_reflect_ClassTag$__f_Long = $m_s_reflect_ManifestFactory$LongManifest$();
  this.s_reflect_ClassTag$__f_Float = $m_s_reflect_ManifestFactory$FloatManifest$();
  this.s_reflect_ClassTag$__f_Double = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.s_reflect_ClassTag$__f_Boolean = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.s_reflect_ClassTag$__f_Unit = $m_s_reflect_ManifestFactory$UnitManifest$();
  this.s_reflect_ClassTag$__f_Any = $m_s_reflect_ManifestFactory$AnyManifest$();
  this.s_reflect_ClassTag$__f_Object = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.s_reflect_ClassTag$__f_AnyRef = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.s_reflect_ClassTag$__f_Nothing = $m_s_reflect_ManifestFactory$NothingManifest$();
  this.s_reflect_ClassTag$__f_Null = $m_s_reflect_ManifestFactory$NullManifest$();
}
$c_s_reflect_ClassTag$.prototype = new $h_O();
$c_s_reflect_ClassTag$.prototype.constructor = $c_s_reflect_ClassTag$;
/** @constructor */
function $h_s_reflect_ClassTag$() {
}
$h_s_reflect_ClassTag$.prototype = $c_s_reflect_ClassTag$.prototype;
$c_s_reflect_ClassTag$.prototype.apply__jl_Class__s_reflect_ClassTag = (function(runtimeClass1) {
  return ((runtimeClass1 === $d_B.getClassOf()) ? $m_s_reflect_ManifestFactory$ByteManifest$() : ((runtimeClass1 === $d_S.getClassOf()) ? $m_s_reflect_ManifestFactory$ShortManifest$() : ((runtimeClass1 === $d_C.getClassOf()) ? $m_s_reflect_ManifestFactory$CharManifest$() : ((runtimeClass1 === $d_I.getClassOf()) ? $m_s_reflect_ManifestFactory$IntManifest$() : ((runtimeClass1 === $d_J.getClassOf()) ? $m_s_reflect_ManifestFactory$LongManifest$() : ((runtimeClass1 === $d_F.getClassOf()) ? $m_s_reflect_ManifestFactory$FloatManifest$() : ((runtimeClass1 === $d_D.getClassOf()) ? $m_s_reflect_ManifestFactory$DoubleManifest$() : ((runtimeClass1 === $d_Z.getClassOf()) ? $m_s_reflect_ManifestFactory$BooleanManifest$() : ((runtimeClass1 === $d_V.getClassOf()) ? $m_s_reflect_ManifestFactory$UnitManifest$() : ((runtimeClass1 === $d_O.getClassOf()) ? $m_s_reflect_ManifestFactory$ObjectManifest$() : ((runtimeClass1 === $d_sr_Nothing$.getClassOf()) ? $m_s_reflect_ManifestFactory$NothingManifest$() : ((runtimeClass1 === $d_sr_Null$.getClassOf()) ? $m_s_reflect_ManifestFactory$NullManifest$() : new $c_s_reflect_ClassTag$GenericClassTag(runtimeClass1)))))))))))));
});
var $d_s_reflect_ClassTag$ = new $TypeData().initClass($c_s_reflect_ClassTag$, "scala.reflect.ClassTag$", ({
  s_reflect_ClassTag$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_reflect_ClassTag$;
function $m_s_reflect_ClassTag$() {
  if ((!$n_s_reflect_ClassTag$)) {
    $n_s_reflect_ClassTag$ = new $c_s_reflect_ClassTag$();
  }
  return $n_s_reflect_ClassTag$;
}
/** @constructor */
function $c_sr_AbstractFunction0() {
}
$c_sr_AbstractFunction0.prototype = new $h_O();
$c_sr_AbstractFunction0.prototype.constructor = $c_sr_AbstractFunction0;
/** @constructor */
function $h_sr_AbstractFunction0() {
}
$h_sr_AbstractFunction0.prototype = $c_sr_AbstractFunction0.prototype;
$c_sr_AbstractFunction0.prototype.toString__T = (function() {
  return "<function0>";
});
/** @constructor */
function $c_sr_AbstractFunction1() {
}
$c_sr_AbstractFunction1.prototype = new $h_O();
$c_sr_AbstractFunction1.prototype.constructor = $c_sr_AbstractFunction1;
/** @constructor */
function $h_sr_AbstractFunction1() {
}
$h_sr_AbstractFunction1.prototype = $c_sr_AbstractFunction1.prototype;
$c_sr_AbstractFunction1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_sr_AbstractFunction1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sr_AbstractFunction1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sr_AbstractFunction1.prototype.toString__T = (function() {
  return "<function1>";
});
/** @constructor */
function $c_sr_AbstractFunction2() {
}
$c_sr_AbstractFunction2.prototype = new $h_O();
$c_sr_AbstractFunction2.prototype.constructor = $c_sr_AbstractFunction2;
/** @constructor */
function $h_sr_AbstractFunction2() {
}
$h_sr_AbstractFunction2.prototype = $c_sr_AbstractFunction2.prototype;
$c_sr_AbstractFunction2.prototype.toString__T = (function() {
  return "<function2>";
});
/** @constructor */
function $c_sr_AbstractFunction3() {
}
$c_sr_AbstractFunction3.prototype = new $h_O();
$c_sr_AbstractFunction3.prototype.constructor = $c_sr_AbstractFunction3;
/** @constructor */
function $h_sr_AbstractFunction3() {
}
$h_sr_AbstractFunction3.prototype = $c_sr_AbstractFunction3.prototype;
$c_sr_AbstractFunction3.prototype.toString__T = (function() {
  return "<function3>";
});
/** @constructor */
function $c_sr_AbstractFunction4() {
}
$c_sr_AbstractFunction4.prototype = new $h_O();
$c_sr_AbstractFunction4.prototype.constructor = $c_sr_AbstractFunction4;
/** @constructor */
function $h_sr_AbstractFunction4() {
}
$h_sr_AbstractFunction4.prototype = $c_sr_AbstractFunction4.prototype;
$c_sr_AbstractFunction4.prototype.toString__T = (function() {
  return "<function4>";
});
/** @constructor */
function $c_sr_BooleanRef(elem) {
  this.sr_BooleanRef__f_elem = false;
  this.sr_BooleanRef__f_elem = elem;
}
$c_sr_BooleanRef.prototype = new $h_O();
$c_sr_BooleanRef.prototype.constructor = $c_sr_BooleanRef;
/** @constructor */
function $h_sr_BooleanRef() {
}
$h_sr_BooleanRef.prototype = $c_sr_BooleanRef.prototype;
$c_sr_BooleanRef.prototype.toString__T = (function() {
  var b = this.sr_BooleanRef__f_elem;
  return ("" + b);
});
var $d_sr_BooleanRef = new $TypeData().initClass($c_sr_BooleanRef, "scala.runtime.BooleanRef", ({
  sr_BooleanRef: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sr_IntRef(elem) {
  this.sr_IntRef__f_elem = 0;
  this.sr_IntRef__f_elem = elem;
}
$c_sr_IntRef.prototype = new $h_O();
$c_sr_IntRef.prototype.constructor = $c_sr_IntRef;
/** @constructor */
function $h_sr_IntRef() {
}
$h_sr_IntRef.prototype = $c_sr_IntRef.prototype;
$c_sr_IntRef.prototype.toString__T = (function() {
  var i = this.sr_IntRef__f_elem;
  return ("" + i);
});
var $d_sr_IntRef = new $TypeData().initClass($c_sr_IntRef, "scala.runtime.IntRef", ({
  sr_IntRef: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sr_LazyRef() {
  this.sr_LazyRef__f__initialized = false;
  this.sr_LazyRef__f__value = null;
}
$c_sr_LazyRef.prototype = new $h_O();
$c_sr_LazyRef.prototype.constructor = $c_sr_LazyRef;
/** @constructor */
function $h_sr_LazyRef() {
}
$h_sr_LazyRef.prototype = $c_sr_LazyRef.prototype;
$c_sr_LazyRef.prototype.initialize__O__O = (function(value) {
  this.sr_LazyRef__f__value = value;
  this.sr_LazyRef__f__initialized = true;
  return value;
});
$c_sr_LazyRef.prototype.toString__T = (function() {
  return ("LazyRef " + (this.sr_LazyRef__f__initialized ? ("of: " + this.sr_LazyRef__f__value) : "thunk"));
});
var $d_sr_LazyRef = new $TypeData().initClass($c_sr_LazyRef, "scala.runtime.LazyRef", ({
  sr_LazyRef: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sr_ObjectRef(elem) {
  this.sr_ObjectRef__f_elem = null;
  this.sr_ObjectRef__f_elem = elem;
}
$c_sr_ObjectRef.prototype = new $h_O();
$c_sr_ObjectRef.prototype.constructor = $c_sr_ObjectRef;
/** @constructor */
function $h_sr_ObjectRef() {
}
$h_sr_ObjectRef.prototype = $c_sr_ObjectRef.prototype;
$c_sr_ObjectRef.prototype.toString__T = (function() {
  var obj = this.sr_ObjectRef__f_elem;
  return ("" + obj);
});
var $d_sr_ObjectRef = new $TypeData().initClass($c_sr_ObjectRef, "scala.runtime.ObjectRef", ({
  sr_ObjectRef: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Either$() {
}
$c_s_util_Either$.prototype = new $h_O();
$c_s_util_Either$.prototype.constructor = $c_s_util_Either$;
/** @constructor */
function $h_s_util_Either$() {
}
$h_s_util_Either$.prototype = $c_s_util_Either$.prototype;
var $d_s_util_Either$ = new $TypeData().initClass($c_s_util_Either$, "scala.util.Either$", ({
  s_util_Either$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_Either$;
function $m_s_util_Either$() {
  if ((!$n_s_util_Either$)) {
    $n_s_util_Either$ = new $c_s_util_Either$();
  }
  return $n_s_util_Either$;
}
/** @constructor */
function $c_s_util_Left$() {
}
$c_s_util_Left$.prototype = new $h_O();
$c_s_util_Left$.prototype.constructor = $c_s_util_Left$;
/** @constructor */
function $h_s_util_Left$() {
}
$h_s_util_Left$.prototype = $c_s_util_Left$.prototype;
$c_s_util_Left$.prototype.toString__T = (function() {
  return "Left";
});
var $d_s_util_Left$ = new $TypeData().initClass($c_s_util_Left$, "scala.util.Left$", ({
  s_util_Left$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_Left$;
function $m_s_util_Left$() {
  if ((!$n_s_util_Left$)) {
    $n_s_util_Left$ = new $c_s_util_Left$();
  }
  return $n_s_util_Left$;
}
function $p_s_util_Random__loop$1__I__I__I($thiz, minInclusive$1, maxExclusive$1) {
  while (true) {
    var this$1 = $n($thiz.s_util_Random__f_self);
    var n = this$1.next__I__I(32);
    if (((n >= minInclusive$1) && (n < maxExclusive$1))) {
      return n;
    }
  }
}
function $ps_s_util_Random__swap$1__I__I__scm_ArrayBuffer__V(i1, i2, buf$1) {
  var tmp = $n(buf$1).apply__I__O(i1);
  $n(buf$1).update__I__O__V(i1, $n(buf$1).apply__I__O(i2));
  $n(buf$1).update__I__O__V(i2, tmp);
}
function $ct_s_util_Random__ju_Random__($thiz, self) {
  $thiz.s_util_Random__f_self = self;
  return $thiz;
}
/** @constructor */
function $c_s_util_Random() {
  this.s_util_Random__f_self = null;
}
$c_s_util_Random.prototype = new $h_O();
$c_s_util_Random.prototype.constructor = $c_s_util_Random;
/** @constructor */
function $h_s_util_Random() {
}
$h_s_util_Random.prototype = $c_s_util_Random.prototype;
$c_s_util_Random.prototype.between__I__I__I = (function(minInclusive, maxExclusive) {
  var requirement = (minInclusive < maxExclusive);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Invalid bounds");
  }
  var difference = ((maxExclusive - minInclusive) | 0);
  return ((difference >= 0) ? (($n(this.s_util_Random__f_self).nextInt__I__I(difference) + minInclusive) | 0) : $p_s_util_Random__loop$1__I__I__I(this, minInclusive, maxExclusive));
});
$c_s_util_Random.prototype.shuffle__sc_IterableOnce__sc_BuildFrom__O = (function(xs, bf) {
  var this$1 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var buf = this$1.addAll__sc_IterableOnce__scm_ArrayBuffer(xs);
  var this$2 = $n(buf);
  var x = this$2.scm_ArrayBuffer__f_size0;
  var isEmpty$1 = (x < 2);
  if ((!isEmpty$1)) {
    var i = x;
    while (true) {
      var v1 = i;
      var k = $n(this.s_util_Random__f_self).nextInt__I__I(v1);
      $ps_s_util_Random__swap$1__I__I__scm_ArrayBuffer__V(((v1 - 1) | 0), k, buf);
      if ((i === 2)) {
        break;
      }
      i = ((i - 1) | 0);
    }
  }
  var this$8 = $n($n(bf).newBuilder__O__scm_Builder(xs));
  return $n($as_scm_Builder(this$8.addAll__sc_IterableOnce__scm_Growable(buf))).result__O();
});
/** @constructor */
function $c_s_util_Right$() {
}
$c_s_util_Right$.prototype = new $h_O();
$c_s_util_Right$.prototype.constructor = $c_s_util_Right$;
/** @constructor */
function $h_s_util_Right$() {
}
$h_s_util_Right$.prototype = $c_s_util_Right$.prototype;
$c_s_util_Right$.prototype.toString__T = (function() {
  return "Right";
});
var $d_s_util_Right$ = new $TypeData().initClass($c_s_util_Right$, "scala.util.Right$", ({
  s_util_Right$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_Right$;
function $m_s_util_Right$() {
  if ((!$n_s_util_Right$)) {
    $n_s_util_Right$ = new $c_s_util_Right$();
  }
  return $n_s_util_Right$;
}
/** @constructor */
function $c_s_util_control_NoStackTrace$() {
  this.s_util_control_NoStackTrace$__f__noSuppression = false;
  this.s_util_control_NoStackTrace$__f__noSuppression = false;
}
$c_s_util_control_NoStackTrace$.prototype = new $h_O();
$c_s_util_control_NoStackTrace$.prototype.constructor = $c_s_util_control_NoStackTrace$;
/** @constructor */
function $h_s_util_control_NoStackTrace$() {
}
$h_s_util_control_NoStackTrace$.prototype = $c_s_util_control_NoStackTrace$.prototype;
var $d_s_util_control_NoStackTrace$ = new $TypeData().initClass($c_s_util_control_NoStackTrace$, "scala.util.control.NoStackTrace$", ({
  s_util_control_NoStackTrace$: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_control_NoStackTrace$;
function $m_s_util_control_NoStackTrace$() {
  if ((!$n_s_util_control_NoStackTrace$)) {
    $n_s_util_control_NoStackTrace$ = new $c_s_util_control_NoStackTrace$();
  }
  return $n_s_util_control_NoStackTrace$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$() {
  this.s_util_hashing_MurmurHash3$__f_seqSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_mapSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_setSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = 0;
  $n_s_util_hashing_MurmurHash3$ = this;
  this.s_util_hashing_MurmurHash3$__f_seqSeed = $f_T__hashCode__I("Seq");
  this.s_util_hashing_MurmurHash3$__f_mapSeed = $f_T__hashCode__I("Map");
  this.s_util_hashing_MurmurHash3$__f_setSeed = $f_T__hashCode__I("Set");
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = this.unorderedHash__sc_IterableOnce__I__I($m_sci_Nil$(), this.s_util_hashing_MurmurHash3$__f_mapSeed);
}
$c_s_util_hashing_MurmurHash3$.prototype = new $h_s_util_hashing_MurmurHash3();
$c_s_util_hashing_MurmurHash3$.prototype.constructor = $c_s_util_hashing_MurmurHash3$;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$() {
}
$h_s_util_hashing_MurmurHash3$.prototype = $c_s_util_hashing_MurmurHash3$.prototype;
$c_s_util_hashing_MurmurHash3$.prototype.tuple2Hash__O__O__I = (function(x, y) {
  return this.tuple2Hash__I__I__I__I($m_sr_Statics$().anyHash__O__I(x), $m_sr_Statics$().anyHash__O__I(y), (-889275714));
});
$c_s_util_hashing_MurmurHash3$.prototype.seqHash__sc_Seq__I = (function(xs) {
  if ($is_sc_IndexedSeq(xs)) {
    var x2 = $as_sc_IndexedSeq(xs);
    return this.indexedSeqHash__sc_IndexedSeq__I__I(x2, this.s_util_hashing_MurmurHash3$__f_seqSeed);
  } else if ((xs instanceof $c_sci_List)) {
    var x3 = $as_sci_List(xs);
    return this.listHash__sci_List__I__I(x3, this.s_util_hashing_MurmurHash3$__f_seqSeed);
  } else {
    return this.orderedHash__sc_IterableOnce__I__I(xs, this.s_util_hashing_MurmurHash3$__f_seqSeed);
  }
});
$c_s_util_hashing_MurmurHash3$.prototype.mapHash__sc_Map__I = (function(xs) {
  if ($n(xs).isEmpty__Z()) {
    return this.s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var accum = new $c_s_util_hashing_MurmurHash3$accum$1();
    var h = this.s_util_hashing_MurmurHash3$__f_mapSeed;
    $n(xs).foreachEntry__F2__V(accum);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_a);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_b);
    h = this.mixLast__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_c);
    return this.finalizeHash__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_n);
  }
});
var $d_s_util_hashing_MurmurHash3$ = new $TypeData().initClass($c_s_util_hashing_MurmurHash3$, "scala.util.hashing.MurmurHash3$", ({
  s_util_hashing_MurmurHash3$: 1,
  s_util_hashing_MurmurHash3: 1
}));
var $n_s_util_hashing_MurmurHash3$;
function $m_s_util_hashing_MurmurHash3$() {
  if ((!$n_s_util_hashing_MurmurHash3$)) {
    $n_s_util_hashing_MurmurHash3$ = new $c_s_util_hashing_MurmurHash3$();
  }
  return $n_s_util_hashing_MurmurHash3$;
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$accum$1() {
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 1;
}
$c_s_util_hashing_MurmurHash3$accum$1.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3$accum$1.prototype.constructor = $c_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$accum$1() {
}
$h_s_util_hashing_MurmurHash3$accum$1.prototype = $c_s_util_hashing_MurmurHash3$accum$1.prototype;
$c_s_util_hashing_MurmurHash3$accum$1.prototype.toString__T = (function() {
  return "<function2>";
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__V = (function(k, v) {
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(k, v);
  this.s_util_hashing_MurmurHash3$accum$1__f_a = ((this.s_util_hashing_MurmurHash3$accum$1__f_a + h) | 0);
  this.s_util_hashing_MurmurHash3$accum$1__f_b = (this.s_util_hashing_MurmurHash3$accum$1__f_b ^ h);
  this.s_util_hashing_MurmurHash3$accum$1__f_c = Math.imul(this.s_util_hashing_MurmurHash3$accum$1__f_c, (1 | h));
  this.s_util_hashing_MurmurHash3$accum$1__f_n = ((1 + this.s_util_hashing_MurmurHash3$accum$1__f_n) | 0);
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2);
});
var $d_s_util_hashing_MurmurHash3$accum$1 = new $TypeData().initClass($c_s_util_hashing_MurmurHash3$accum$1, "scala.util.hashing.MurmurHash3$accum$1", ({
  s_util_hashing_MurmurHash3$accum$1: 1,
  F2: 1
}));
function $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, pattern, groupNames) {
  $thiz.s_util_matching_Regex__f_pattern = pattern;
  return $thiz;
}
function $ct_s_util_matching_Regex__T__sci_Seq__($thiz, regex, groupNames) {
  $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0), groupNames);
  return $thiz;
}
/** @constructor */
function $c_s_util_matching_Regex() {
  this.s_util_matching_Regex__f_pattern = null;
}
$c_s_util_matching_Regex.prototype = new $h_O();
$c_s_util_matching_Regex.prototype.constructor = $c_s_util_matching_Regex;
/** @constructor */
function $h_s_util_matching_Regex() {
}
$h_s_util_matching_Regex.prototype = $c_s_util_matching_Regex.prototype;
$c_s_util_matching_Regex.prototype.unapplySeq__jl_CharSequence__s_Option = (function(s) {
  var this$1 = $n(this.s_util_matching_Regex__f_pattern);
  var m = new $c_ju_regex_Matcher(this$1, $dp_toString__T($n(s)));
  if (m.matches__Z()) {
    var n = $n(m.ju_regex_Matcher__f_pattern0).ju_regex_Pattern__f_groupCount;
    var b = new $c_scm_ListBuffer();
    var i = 0;
    while ((i < n)) {
      var x0 = i;
      var elem = m.group__I__T(((1 + x0) | 0));
      b.addOne__O__scm_ListBuffer(elem);
      i = ((1 + i) | 0);
    }
    return new $c_s_Some(b.toList__sci_List());
  } else {
    return $m_s_None$();
  }
});
$c_s_util_matching_Regex.prototype.toString__T = (function() {
  return $n(this.s_util_matching_Regex__f_pattern).ju_regex_Pattern__f__pattern;
});
var $d_s_util_matching_Regex = new $TypeData().initClass($c_s_util_matching_Regex, "scala.util.matching.Regex", ({
  s_util_matching_Regex: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_DomApi$$anon$1() {
}
$c_Lsnabbdom_DomApi$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_DomApi$$anon$1.prototype.constructor = $c_Lsnabbdom_DomApi$$anon$1;
/** @constructor */
function $h_Lsnabbdom_DomApi$$anon$1() {
}
$h_Lsnabbdom_DomApi$$anon$1.prototype = $c_Lsnabbdom_DomApi$$anon$1.prototype;
var $d_Lsnabbdom_DomApi$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_DomApi$$anon$1, "snabbdom.DomApi$$anon$1", ({
  Lsnabbdom_DomApi$$anon$1: 1,
  Lsnabbdom_DomApi: 1
}));
/** @constructor */
function $c_Lsnabbdom_init$$anon$1(api$22, cbs$16) {
  this.Lsnabbdom_init$$anon$1__f_api$21 = null;
  this.Lsnabbdom_init$$anon$1__f_cbs$15 = null;
  this.Lsnabbdom_init$$anon$1__f_api$21 = api$22;
  this.Lsnabbdom_init$$anon$1__f_cbs$15 = cbs$16;
}
$c_Lsnabbdom_init$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_init$$anon$1.prototype.constructor = $c_Lsnabbdom_init$$anon$1;
/** @constructor */
function $h_Lsnabbdom_init$$anon$1() {
}
$h_Lsnabbdom_init$$anon$1.prototype = $c_Lsnabbdom_init$$anon$1.prototype;
$c_Lsnabbdom_init$$anon$1.prototype.apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Lsnabbdom_PatchedVNode = (function(oldVnode, vnode) {
  return $m_Lsnabbdom_init$().snabbdom$init$$$_$patch$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Lsnabbdom_PatchedVNode(this.Lsnabbdom_init$$anon$1__f_api$21, this.Lsnabbdom_init$$anon$1__f_cbs$15, oldVnode, vnode);
});
$c_Lsnabbdom_init$$anon$1.prototype.apply__Lorg_scalajs_dom_Element__Lsnabbdom_VNode__Lsnabbdom_PatchedVNode = (function(elm, vnode) {
  return $m_Lsnabbdom_init$().snabbdom$init$$$_$patch$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__Lsnabbdom_PatchedVNode(this.Lsnabbdom_init$$anon$1__f_api$21, this.Lsnabbdom_init$$anon$1__f_cbs$15, $m_Lsnabbdom_init$().snabbdom$init$$$_$emptyNodeAt$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Element__Lsnabbdom_PatchedVNode(this.Lsnabbdom_init$$anon$1__f_api$21, elm), vnode);
});
var $d_Lsnabbdom_init$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_init$$anon$1, "snabbdom.init$$anon$1", ({
  Lsnabbdom_init$$anon$1: 1,
  Lsnabbdom_Patch: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Attributes$$anon$1() {
}
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Attributes$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Attributes$$anon$1() {
}
$h_Lsnabbdom_modules_Attributes$$anon$1.prototype = $c_Lsnabbdom_modules_Attributes$$anon$1.prototype;
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype.apply__Lsnabbdom_PatchedVNode__V = (function(vNode) {
  if ((vNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var elm = $as_Lsnabbdom_PatchedVNode$Element(vNode);
    var this$1 = $n($n($n(elm).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_attrs);
    if ((!this$1.isEmpty__Z())) {
      $m_Lsnabbdom_modules_Attributes$().snabbdom$modules$Attributes$$$setAttrs__Lsnabbdom_PatchedVNode$Element__V(elm);
    }
  }
});
var $d_Lsnabbdom_modules_Attributes$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Attributes$$anon$1, "snabbdom.modules.Attributes$$anon$1", ({
  Lsnabbdom_modules_Attributes$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Attributes$$anon$2() {
}
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Attributes$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Attributes$$anon$2() {
}
$h_Lsnabbdom_modules_Attributes$$anon$2.prototype = $c_Lsnabbdom_modules_Attributes$$anon$2.prototype;
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype.apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__V = (function(oldVNode, vNode) {
  if ((oldVNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var a = $as_Lsnabbdom_PatchedVNode$Element(oldVNode);
    if ((vNode instanceof $c_Lsnabbdom_VNode$Element)) {
      var b = $as_Lsnabbdom_VNode$Element(vNode);
      var x = $n($n(a).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_attrs;
      var x$2 = $n($n(b).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_attrs;
      if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
        $m_Lsnabbdom_modules_Attributes$().snabbdom$modules$Attributes$$$updateAttrs__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V(a, b);
        return (void 0);
      } else {
        return (void 0);
      }
    }
  }
});
var $d_Lsnabbdom_modules_Attributes$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Attributes$$anon$2, "snabbdom.modules.Attributes$$anon$2", ({
  Lsnabbdom_modules_Attributes$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Classes$$anon$1() {
}
$c_Lsnabbdom_modules_Classes$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Classes$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Classes$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Classes$$anon$1() {
}
$h_Lsnabbdom_modules_Classes$$anon$1.prototype = $c_Lsnabbdom_modules_Classes$$anon$1.prototype;
$c_Lsnabbdom_modules_Classes$$anon$1.prototype.apply__Lsnabbdom_PatchedVNode__V = (function(vNode) {
  var this$1 = $m_Lsnabbdom_modules_Classes$();
  if ((vNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var elm = $as_Lsnabbdom_PatchedVNode$Element(vNode);
    var this$2 = $n($n($n(elm).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_classes);
    if ((!this$2.isEmpty__Z())) {
      $p_Lsnabbdom_modules_Classes$__setClasses__Lsnabbdom_PatchedVNode$Element__V(this$1, elm);
    }
  }
});
var $d_Lsnabbdom_modules_Classes$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Classes$$anon$1, "snabbdom.modules.Classes$$anon$1", ({
  Lsnabbdom_modules_Classes$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Classes$$anon$2() {
}
$c_Lsnabbdom_modules_Classes$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Classes$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Classes$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Classes$$anon$2() {
}
$h_Lsnabbdom_modules_Classes$$anon$2.prototype = $c_Lsnabbdom_modules_Classes$$anon$2.prototype;
$c_Lsnabbdom_modules_Classes$$anon$2.prototype.apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__V = (function(oldVNode, vNode) {
  var this$1 = $m_Lsnabbdom_modules_Classes$();
  matchResult2: {
    if ((oldVNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
      var a = $as_Lsnabbdom_PatchedVNode$Element(oldVNode);
      if ((vNode instanceof $c_Lsnabbdom_VNode$Element)) {
        var b = $as_Lsnabbdom_VNode$Element(vNode);
        var x = $n($n(a).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_classes;
        var x$2 = $n($n(b).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_classes;
        if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
          $p_Lsnabbdom_modules_Classes$__updateClasses__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V(this$1, a, b);
          break matchResult2;
        } else {
          break matchResult2;
        }
      }
    }
  }
});
var $d_Lsnabbdom_modules_Classes$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Classes$$anon$2, "snabbdom.modules.Classes$$anon$2", ({
  Lsnabbdom_modules_Classes$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Dataset$$anon$1() {
}
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Dataset$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Dataset$$anon$1() {
}
$h_Lsnabbdom_modules_Dataset$$anon$1.prototype = $c_Lsnabbdom_modules_Dataset$$anon$1.prototype;
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype.apply__Lsnabbdom_PatchedVNode__V = (function(vNode) {
  var this$1 = $m_Lsnabbdom_modules_Dataset$();
  if ((vNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var elm = $as_Lsnabbdom_PatchedVNode$Element(vNode);
    var this$2 = $n($n($n(elm).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_dataset);
    if ((!this$2.isEmpty__Z())) {
      $p_Lsnabbdom_modules_Dataset$__setDataset__Lsnabbdom_PatchedVNode$Element__V(this$1, elm);
    }
  }
});
var $d_Lsnabbdom_modules_Dataset$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Dataset$$anon$1, "snabbdom.modules.Dataset$$anon$1", ({
  Lsnabbdom_modules_Dataset$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Dataset$$anon$2() {
}
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Dataset$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Dataset$$anon$2() {
}
$h_Lsnabbdom_modules_Dataset$$anon$2.prototype = $c_Lsnabbdom_modules_Dataset$$anon$2.prototype;
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype.apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__V = (function(oldVNode, vNode) {
  var this$1 = $m_Lsnabbdom_modules_Dataset$();
  matchResult2: {
    if ((oldVNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
      var a = $as_Lsnabbdom_PatchedVNode$Element(oldVNode);
      if ((vNode instanceof $c_Lsnabbdom_VNode$Element)) {
        var b = $as_Lsnabbdom_VNode$Element(vNode);
        var x = $n($n(a).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_dataset;
        var x$2 = $n($n(b).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_dataset;
        if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
          $p_Lsnabbdom_modules_Dataset$__updateDataset__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V(this$1, a, b);
          break matchResult2;
        } else {
          break matchResult2;
        }
      }
    }
  }
});
var $d_Lsnabbdom_modules_Dataset$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Dataset$$anon$2, "snabbdom.modules.Dataset$$anon$2", ({
  Lsnabbdom_modules_Dataset$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$$anon$1() {
}
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$$anon$1() {
}
$h_Lsnabbdom_modules_EventListeners$$anon$1.prototype = $c_Lsnabbdom_modules_EventListeners$$anon$1.prototype;
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype.apply__Lsnabbdom_PatchedVNode__V = (function(vNode) {
  $m_Lsnabbdom_modules_EventListeners$();
  if ((vNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var elm = $as_Lsnabbdom_PatchedVNode$Element(vNode);
    var this$2 = $n($n($n(elm).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_on);
    if ((!this$2.isEmpty__Z())) {
      $n($n($n(elm).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_on).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_T2(x$1);
        matchResult1: {
          if ((x$1$1 !== null)) {
            var name = $as_T($n(x$1$1)._1__O());
            $n(elm).Lsnabbdom_PatchedVNode$Element__f_node.addEventListener(name, $n(elm).listener__sjs_js_Function1(), false);
            break matchResult1;
          }
          throw new $c_s_MatchError(x$1$1);
        }
      })));
    }
  }
});
var $d_Lsnabbdom_modules_EventListeners$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_EventListeners$$anon$1, "snabbdom.modules.EventListeners$$anon$1", ({
  Lsnabbdom_modules_EventListeners$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$$anon$2() {
}
$c_Lsnabbdom_modules_EventListeners$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$$anon$2() {
}
$h_Lsnabbdom_modules_EventListeners$$anon$2.prototype = $c_Lsnabbdom_modules_EventListeners$$anon$2.prototype;
var $d_Lsnabbdom_modules_EventListeners$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_EventListeners$$anon$2, "snabbdom.modules.EventListeners$$anon$2", ({
  Lsnabbdom_modules_EventListeners$$anon$2: 1,
  Lsnabbdom_PostPatchHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$$anon$3() {
}
$c_Lsnabbdom_modules_EventListeners$$anon$3.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$$anon$3.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$$anon$3;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$$anon$3() {
}
$h_Lsnabbdom_modules_EventListeners$$anon$3.prototype = $c_Lsnabbdom_modules_EventListeners$$anon$3.prototype;
var $d_Lsnabbdom_modules_EventListeners$$anon$3 = new $TypeData().initClass($c_Lsnabbdom_modules_EventListeners$$anon$3, "snabbdom.modules.EventListeners$$anon$3", ({
  Lsnabbdom_modules_EventListeners$$anon$3: 1,
  Lsnabbdom_DestroyHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Props$$anon$1() {
}
$c_Lsnabbdom_modules_Props$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Props$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Props$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Props$$anon$1() {
}
$h_Lsnabbdom_modules_Props$$anon$1.prototype = $c_Lsnabbdom_modules_Props$$anon$1.prototype;
$c_Lsnabbdom_modules_Props$$anon$1.prototype.apply__Lsnabbdom_PatchedVNode__V = (function(vNode) {
  var this$1 = $m_Lsnabbdom_modules_Props$();
  if ((vNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var elm = $as_Lsnabbdom_PatchedVNode$Element(vNode);
    $p_Lsnabbdom_modules_Props$__setProps__Lsnabbdom_PatchedVNode$Element__V(this$1, elm);
  }
});
var $d_Lsnabbdom_modules_Props$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Props$$anon$1, "snabbdom.modules.Props$$anon$1", ({
  Lsnabbdom_modules_Props$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Props$$anon$2() {
}
$c_Lsnabbdom_modules_Props$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Props$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Props$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Props$$anon$2() {
}
$h_Lsnabbdom_modules_Props$$anon$2.prototype = $c_Lsnabbdom_modules_Props$$anon$2.prototype;
$c_Lsnabbdom_modules_Props$$anon$2.prototype.apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__V = (function(oldVNode, vNode) {
  var this$1 = $m_Lsnabbdom_modules_Props$();
  matchResult2: {
    if ((oldVNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
      var a = $as_Lsnabbdom_PatchedVNode$Element(oldVNode);
      if ((vNode instanceof $c_Lsnabbdom_VNode$Element)) {
        var b = $as_Lsnabbdom_VNode$Element(vNode);
        var x = $n($n(a).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_props;
        var x$2 = $n($n(b).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_props;
        if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
          $p_Lsnabbdom_modules_Props$__updateProps__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V(this$1, a, b);
          break matchResult2;
        } else {
          break matchResult2;
        }
      }
    }
  }
});
var $d_Lsnabbdom_modules_Props$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Props$$anon$2, "snabbdom.modules.Props$$anon$2", ({
  Lsnabbdom_modules_Props$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Styles$$anon$1() {
}
$c_Lsnabbdom_modules_Styles$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Styles$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Styles$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Styles$$anon$1() {
}
$h_Lsnabbdom_modules_Styles$$anon$1.prototype = $c_Lsnabbdom_modules_Styles$$anon$1.prototype;
$c_Lsnabbdom_modules_Styles$$anon$1.prototype.apply__Lsnabbdom_PatchedVNode__V = (function(vNode) {
  var this$1 = $m_Lsnabbdom_modules_Styles$();
  if ((vNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var elm = $as_Lsnabbdom_PatchedVNode$Element(vNode);
    $p_Lsnabbdom_modules_Styles$__setStyle__Lsnabbdom_PatchedVNode$Element__V(this$1, elm);
  }
});
var $d_Lsnabbdom_modules_Styles$$anon$1 = new $TypeData().initClass($c_Lsnabbdom_modules_Styles$$anon$1, "snabbdom.modules.Styles$$anon$1", ({
  Lsnabbdom_modules_Styles$$anon$1: 1,
  Lsnabbdom_CreateHook: 1
}));
/** @constructor */
function $c_Lsnabbdom_modules_Styles$$anon$2() {
}
$c_Lsnabbdom_modules_Styles$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Styles$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Styles$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Styles$$anon$2() {
}
$h_Lsnabbdom_modules_Styles$$anon$2.prototype = $c_Lsnabbdom_modules_Styles$$anon$2.prototype;
$c_Lsnabbdom_modules_Styles$$anon$2.prototype.apply__Lsnabbdom_PatchedVNode__Lsnabbdom_VNode__V = (function(oldVNode, vNode) {
  var this$1 = $m_Lsnabbdom_modules_Styles$();
  matchResult2: {
    if ((oldVNode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
      var a = $as_Lsnabbdom_PatchedVNode$Element(oldVNode);
      if ((vNode instanceof $c_Lsnabbdom_VNode$Element)) {
        var b = $as_Lsnabbdom_VNode$Element(vNode);
        var x = $n($n(a).Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_style;
        var x$2 = $n($n(b).Lsnabbdom_VNode$Element__f_data).Lsnabbdom_VNodeData__f_style;
        if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
          $p_Lsnabbdom_modules_Styles$__updateStyle__Lsnabbdom_PatchedVNode$Element__Lsnabbdom_VNode$Element__V(this$1, a, b);
          break matchResult2;
        } else {
          break matchResult2;
        }
      }
    }
  }
});
var $d_Lsnabbdom_modules_Styles$$anon$2 = new $TypeData().initClass($c_Lsnabbdom_modules_Styles$$anon$2, "snabbdom.modules.Styles$$anon$2", ({
  Lsnabbdom_modules_Styles$$anon$2: 1,
  Lsnabbdom_UpdateHook: 1
}));
function $is_Ltyrian_Html(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Html)));
}
function $as_Ltyrian_Html(obj) {
  return (($is_Ltyrian_Html(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Html"));
}
function $isArrayOf_Ltyrian_Html(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Html)));
}
function $asArrayOf_Ltyrian_Html(obj, depth) {
  return (($isArrayOf_Ltyrian_Html(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Html;", depth));
}
function $is_Ltyrian_Property(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Property)));
}
function $as_Ltyrian_Property(obj) {
  return (($is_Ltyrian_Property(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Property"));
}
function $isArrayOf_Ltyrian_Property(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Property)));
}
function $asArrayOf_Ltyrian_Property(obj, depth) {
  return (($isArrayOf_Ltyrian_Property(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Property;", depth));
}
function $f_Ltyrian_TyrianIOApp__$init$__V($thiz) {
  $thiz.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    var _$1$1 = $as_Lcats_effect_IO(_$1);
    $n(_$1$1).unsafeRunAndForget__Lcats_effect_unsafe_IORuntime__V($m_Lcats_effect_unsafe_IORuntime$().global__Lcats_effect_unsafe_IORuntime());
  }));
}
/** @constructor */
function $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5(target$2, tc$2) {
  this.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_self = null;
  this.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_typeClassInstance = null;
  this.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_self = target$2;
  this.Lcats_Bifunctor$ToBifunctorOps$$anon$5__f_typeClassInstance = tc$2;
}
$c_Lcats_Bifunctor$ToBifunctorOps$$anon$5.prototype = new $h_O();
$c_Lcats_Bifunctor$ToBifunctorOps$$anon$5.prototype.constructor = $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5;
/** @constructor */
function $h_Lcats_Bifunctor$ToBifunctorOps$$anon$5() {
}
$h_Lcats_Bifunctor$ToBifunctorOps$$anon$5.prototype = $c_Lcats_Bifunctor$ToBifunctorOps$$anon$5.prototype;
var $d_Lcats_Bifunctor$ToBifunctorOps$$anon$5 = new $TypeData().initClass($c_Lcats_Bifunctor$ToBifunctorOps$$anon$5, "cats.Bifunctor$ToBifunctorOps$$anon$5", ({
  Lcats_Bifunctor$ToBifunctorOps$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifunctor$Ops: 1
}));
function $f_Lcats_ComposedInvariant__imap__O__F1__F1__O($thiz, fga, f, g) {
  return $n($thiz.Lcats_Functor$$anon$1__f_F).imap__O__F1__F1__O(fga, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ga) => $n($thiz.Lcats_Functor$$anon$1__f_G).imap__O__F1__F1__O(ga, f, g))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((gb) => $n($thiz.Lcats_Functor$$anon$1__f_G).imap__O__F1__F1__O(gb, g, f))));
}
function $ct_Lcats_Eval$Defer__F0__($thiz, thunk) {
  $thiz.Lcats_Eval$Defer__f_thunk = thunk;
  return $thiz;
}
/** @constructor */
function $c_Lcats_Eval$Defer() {
  this.Lcats_Eval$Defer__f_thunk = null;
}
$c_Lcats_Eval$Defer.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Defer.prototype.constructor = $c_Lcats_Eval$Defer;
/** @constructor */
function $h_Lcats_Eval$Defer() {
}
$h_Lcats_Eval$Defer.prototype = $c_Lcats_Eval$Defer.prototype;
$c_Lcats_Eval$Defer.prototype.memoize__Lcats_Eval = (function() {
  return new $c_Lcats_Eval$Memoize(this);
});
$c_Lcats_Eval$Defer.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this);
});
function $as_Lcats_Eval$Defer(obj) {
  return (((obj instanceof $c_Lcats_Eval$Defer) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Defer"));
}
function $isArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Defer)));
}
function $asArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Defer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Defer;", depth));
}
/** @constructor */
function $c_Lcats_Eval$FlatMap() {
}
$c_Lcats_Eval$FlatMap.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$FlatMap.prototype.constructor = $c_Lcats_Eval$FlatMap;
/** @constructor */
function $h_Lcats_Eval$FlatMap() {
}
$h_Lcats_Eval$FlatMap.prototype = $c_Lcats_Eval$FlatMap.prototype;
$c_Lcats_Eval$FlatMap.prototype.memoize__Lcats_Eval = (function() {
  return new $c_Lcats_Eval$Memoize(this);
});
$c_Lcats_Eval$FlatMap.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this);
});
function $as_Lcats_Eval$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_Eval$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$FlatMap"));
}
function $isArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$FlatMap)));
}
function $asArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_Eval$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$FlatMap;", depth));
}
/** @constructor */
function $c_Lcats_Eval$Leaf() {
}
$c_Lcats_Eval$Leaf.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Leaf.prototype.constructor = $c_Lcats_Eval$Leaf;
/** @constructor */
function $h_Lcats_Eval$Leaf() {
}
$h_Lcats_Eval$Leaf.prototype = $c_Lcats_Eval$Leaf.prototype;
function $as_Lcats_Eval$Leaf(obj) {
  return (((obj instanceof $c_Lcats_Eval$Leaf) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Leaf"));
}
function $isArrayOf_Lcats_Eval$Leaf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Leaf)));
}
function $asArrayOf_Lcats_Eval$Leaf(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Leaf(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Leaf;", depth));
}
function $ct_Lcats_EvalInstances__($thiz) {
  $thiz.Lcats_EvalInstances__f_catsBimonadForEval = new $c_Lcats_EvalInstances$$anon$6();
  new $c_Lcats_EvalInstances$$anon$9($thiz);
  return $thiz;
}
/** @constructor */
function $c_Lcats_EvalInstances() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
}
$c_Lcats_EvalInstances.prototype = new $h_Lcats_EvalInstances0();
$c_Lcats_EvalInstances.prototype.constructor = $c_Lcats_EvalInstances;
/** @constructor */
function $h_Lcats_EvalInstances() {
}
$h_Lcats_EvalInstances.prototype = $c_Lcats_EvalInstances.prototype;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$9(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $n(outer);
}
$c_Lcats_EvalInstances$$anon$9.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$9.prototype.constructor = $c_Lcats_EvalInstances$$anon$9;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$9() {
}
$h_Lcats_EvalInstances$$anon$9.prototype = $c_Lcats_EvalInstances$$anon$9.prototype;
var $d_Lcats_EvalInstances$$anon$9 = new $TypeData().initClass($c_Lcats_EvalInstances$$anon$9, "cats.EvalInstances$$anon$9", ({
  Lcats_EvalInstances$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
}));
/** @constructor */
function $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2) {
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self = null;
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance = null;
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self = target$2;
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance = tc$2;
}
$c_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype = new $h_O();
$c_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype.constructor = $c_Lcats_FlatMap$ToFlatMapOps$$anon$2;
/** @constructor */
function $h_Lcats_FlatMap$ToFlatMapOps$$anon$2() {
}
$h_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype = $c_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype;
var $d_Lcats_FlatMap$ToFlatMapOps$$anon$2 = new $TypeData().initClass($c_Lcats_FlatMap$ToFlatMapOps$$anon$2, "cats.FlatMap$ToFlatMapOps$$anon$2", ({
  Lcats_FlatMap$ToFlatMapOps$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_FlatMap$Ops: 1
}));
/** @constructor */
function $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$2, tc$2) {
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_self = null;
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance = null;
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_self = target$2;
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance = tc$2;
}
$c_Lcats_Foldable$ToFoldableOps$$anon$6.prototype = new $h_O();
$c_Lcats_Foldable$ToFoldableOps$$anon$6.prototype.constructor = $c_Lcats_Foldable$ToFoldableOps$$anon$6;
/** @constructor */
function $h_Lcats_Foldable$ToFoldableOps$$anon$6() {
}
$h_Lcats_Foldable$ToFoldableOps$$anon$6.prototype = $c_Lcats_Foldable$ToFoldableOps$$anon$6.prototype;
var $d_Lcats_Foldable$ToFoldableOps$$anon$6 = new $TypeData().initClass($c_Lcats_Foldable$ToFoldableOps$$anon$6, "cats.Foldable$ToFoldableOps$$anon$6", ({
  Lcats_Foldable$ToFoldableOps$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable$Ops: 1
}));
function $f_Lcats_Functor__as__O__O__O($thiz, fa, b) {
  return $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => b)));
}
function $f_Lcats_Functor__tupleLeft__O__O__O($thiz, fa, b) {
  return $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => new $c_T2(b, a))));
}
/** @constructor */
function $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2) {
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_self = null;
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance = null;
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_self = target$2;
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance = tc$2;
}
$c_Lcats_Functor$ToFunctorOps$$anon$5.prototype = new $h_O();
$c_Lcats_Functor$ToFunctorOps$$anon$5.prototype.constructor = $c_Lcats_Functor$ToFunctorOps$$anon$5;
/** @constructor */
function $h_Lcats_Functor$ToFunctorOps$$anon$5() {
}
$h_Lcats_Functor$ToFunctorOps$$anon$5.prototype = $c_Lcats_Functor$ToFunctorOps$$anon$5.prototype;
var $d_Lcats_Functor$ToFunctorOps$$anon$5 = new $TypeData().initClass($c_Lcats_Functor$ToFunctorOps$$anon$5, "cats.Functor$ToFunctorOps$$anon$5", ({
  Lcats_Functor$ToFunctorOps$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_Functor$Ops: 1
}));
/** @constructor */
function $c_Lcats_Parallel$() {
}
$c_Lcats_Parallel$.prototype = new $h_Lcats_ParallelArityFunctions2();
$c_Lcats_Parallel$.prototype.constructor = $c_Lcats_Parallel$;
/** @constructor */
function $h_Lcats_Parallel$() {
}
$h_Lcats_Parallel$.prototype = $c_Lcats_Parallel$.prototype;
$c_Lcats_Parallel$.prototype.parUnorderedTraverse__O__F1__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O = (function(ta, f, evidence$1, evidence$2, P) {
  return $n($n(P).sequential__Lcats_arrow_FunctionK()).apply__O__O($n(evidence$1).unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O(ta, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n($n(P).parallel__Lcats_arrow_FunctionK()).apply__O__O($n(f).apply__O__O(a)))), evidence$2));
});
var $d_Lcats_Parallel$ = new $TypeData().initClass($c_Lcats_Parallel$, "cats.Parallel$", ({
  Lcats_Parallel$: 1,
  Lcats_ParallelArityFunctions2: 1,
  Lcats_ParallelArityFunctions: 1
}));
var $n_Lcats_Parallel$;
function $m_Lcats_Parallel$() {
  if ((!$n_Lcats_Parallel$)) {
    $n_Lcats_Parallel$ = new $c_Lcats_Parallel$();
  }
  return $n_Lcats_Parallel$;
}
/** @constructor */
function $c_Lcats_SemigroupK$$anon$1(outer) {
  this.Lcats_SemigroupK$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_SemigroupK$$anon$1__f_$outer = outer;
}
$c_Lcats_SemigroupK$$anon$1.prototype = new $h_O();
$c_Lcats_SemigroupK$$anon$1.prototype.constructor = $c_Lcats_SemigroupK$$anon$1;
/** @constructor */
function $h_Lcats_SemigroupK$$anon$1() {
}
$h_Lcats_SemigroupK$$anon$1.prototype = $c_Lcats_SemigroupK$$anon$1.prototype;
var $d_Lcats_SemigroupK$$anon$1 = new $TypeData().initClass($c_Lcats_SemigroupK$$anon$1, "cats.SemigroupK$$anon$1", ({
  Lcats_SemigroupK$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
}));
/** @constructor */
function $c_Lcats_Semigroupal$() {
  $n_Lcats_Semigroupal$ = this;
  $m_Lcats_instances_package$order$();
  $m_Lcats_instances_package$partialOrder$();
  $m_Lcats_instances_package$ordering$();
  $m_Lcats_instances_package$partialOrdering$();
  $m_Lcats_instances_package$eq$();
  $m_Lcats_instances_package$equiv$();
  $m_Lcats_instances_package$invariant$();
  $m_Lcats_instances_package$invariant$();
  $m_Lcats_instances_package$invariant$();
}
$c_Lcats_Semigroupal$.prototype = new $h_O();
$c_Lcats_Semigroupal$.prototype.constructor = $c_Lcats_Semigroupal$;
/** @constructor */
function $h_Lcats_Semigroupal$() {
}
$h_Lcats_Semigroupal$.prototype = $c_Lcats_Semigroupal$.prototype;
var $d_Lcats_Semigroupal$ = new $TypeData().initClass($c_Lcats_Semigroupal$, "cats.Semigroupal$", ({
  Lcats_Semigroupal$: 1,
  Lcats_ScalaVersionSpecificSemigroupalInstances: 1,
  Lcats_SemigroupalArityFunctions: 1
}));
var $n_Lcats_Semigroupal$;
function $m_Lcats_Semigroupal$() {
  if ((!$n_Lcats_Semigroupal$)) {
    $n_Lcats_Semigroupal$ = new $c_Lcats_Semigroupal$();
  }
  return $n_Lcats_Semigroupal$;
}
/** @constructor */
function $c_Lcats_Traverse$ToTraverseOps$$anon$3(target$2, tc$2) {
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_self = null;
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance = null;
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_self = target$2;
  this.Lcats_Traverse$ToTraverseOps$$anon$3__f_typeClassInstance = tc$2;
}
$c_Lcats_Traverse$ToTraverseOps$$anon$3.prototype = new $h_O();
$c_Lcats_Traverse$ToTraverseOps$$anon$3.prototype.constructor = $c_Lcats_Traverse$ToTraverseOps$$anon$3;
/** @constructor */
function $h_Lcats_Traverse$ToTraverseOps$$anon$3() {
}
$h_Lcats_Traverse$ToTraverseOps$$anon$3.prototype = $c_Lcats_Traverse$ToTraverseOps$$anon$3.prototype;
var $d_Lcats_Traverse$ToTraverseOps$$anon$3 = new $TypeData().initClass($c_Lcats_Traverse$ToTraverseOps$$anon$3, "cats.Traverse$ToTraverseOps$$anon$3", ({
  Lcats_Traverse$ToTraverseOps$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Traverse$Ops: 1
}));
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$1(f$2, outer) {
  this.Lcats_arrow_FunctionK$$anon$1__f_f$1 = null;
  this.Lcats_arrow_FunctionK$$anon$1__f_$outer = null;
  this.Lcats_arrow_FunctionK$$anon$1__f_f$1 = f$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_arrow_FunctionK$$anon$1__f_$outer = outer;
}
$c_Lcats_arrow_FunctionK$$anon$1.prototype = new $h_O();
$c_Lcats_arrow_FunctionK$$anon$1.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$1;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$1() {
}
$h_Lcats_arrow_FunctionK$$anon$1.prototype = $c_Lcats_arrow_FunctionK$$anon$1.prototype;
$c_Lcats_arrow_FunctionK$$anon$1.prototype.apply__O__O = (function(fa) {
  return $n(this.Lcats_arrow_FunctionK$$anon$1__f_$outer).apply__O__O($n(this.Lcats_arrow_FunctionK$$anon$1__f_f$1).apply__O__O(fa));
});
var $d_Lcats_arrow_FunctionK$$anon$1 = new $TypeData().initClass($c_Lcats_arrow_FunctionK$$anon$1, "cats.arrow.FunctionK$$anon$1", ({
  Lcats_arrow_FunctionK$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$4() {
}
$c_Lcats_arrow_FunctionK$$anon$4.prototype = new $h_O();
$c_Lcats_arrow_FunctionK$$anon$4.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$4;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$4() {
}
$h_Lcats_arrow_FunctionK$$anon$4.prototype = $c_Lcats_arrow_FunctionK$$anon$4.prototype;
$c_Lcats_arrow_FunctionK$$anon$4.prototype.apply__O__O = (function(fa) {
  return fa;
});
var $d_Lcats_arrow_FunctionK$$anon$4 = new $TypeData().initClass($c_Lcats_arrow_FunctionK$$anon$4, "cats.arrow.FunctionK$$anon$4", ({
  Lcats_arrow_FunctionK$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_data_Chain$$anon$2() {
}
$c_Lcats_data_Chain$$anon$2.prototype = new $h_sr_AbstractFunction1();
$c_Lcats_data_Chain$$anon$2.prototype.constructor = $c_Lcats_data_Chain$$anon$2;
/** @constructor */
function $h_Lcats_data_Chain$$anon$2() {
}
$h_Lcats_data_Chain$$anon$2.prototype = $c_Lcats_data_Chain$$anon$2.prototype;
$c_Lcats_data_Chain$$anon$2.prototype.apply__O__O = (function(a) {
  return this;
});
var $d_Lcats_data_Chain$$anon$2 = new $TypeData().initClass($c_Lcats_data_Chain$$anon$2, "cats.data.Chain$$anon$2", ({
  Lcats_data_Chain$$anon$2: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
/** @constructor */
function $c_Lcats_data_Chain$NonEmpty() {
}
$c_Lcats_data_Chain$NonEmpty.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$NonEmpty.prototype.constructor = $c_Lcats_data_Chain$NonEmpty;
/** @constructor */
function $h_Lcats_data_Chain$NonEmpty() {
}
$h_Lcats_data_Chain$NonEmpty.prototype = $c_Lcats_data_Chain$NonEmpty.prototype;
function $as_Lcats_data_Chain$NonEmpty(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$NonEmpty) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$NonEmpty"));
}
function $isArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$NonEmpty)));
}
function $asArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$NonEmpty;", depth));
}
/** @constructor */
function $c_Lcats_data_ChainInstances1() {
}
$c_Lcats_data_ChainInstances1.prototype = new $h_Lcats_data_ChainInstances2();
$c_Lcats_data_ChainInstances1.prototype.constructor = $c_Lcats_data_ChainInstances1;
/** @constructor */
function $h_Lcats_data_ChainInstances1() {
}
$h_Lcats_data_ChainInstances1.prototype = $c_Lcats_data_ChainInstances1.prototype;
/** @constructor */
function $c_Lcats_data_KleisliFunctions$$anon$3() {
}
$c_Lcats_data_KleisliFunctions$$anon$3.prototype = new $h_O();
$c_Lcats_data_KleisliFunctions$$anon$3.prototype.constructor = $c_Lcats_data_KleisliFunctions$$anon$3;
/** @constructor */
function $h_Lcats_data_KleisliFunctions$$anon$3() {
}
$h_Lcats_data_KleisliFunctions$$anon$3.prototype = $c_Lcats_data_KleisliFunctions$$anon$3.prototype;
$c_Lcats_data_KleisliFunctions$$anon$3.prototype.apply__O__O = (function(fa) {
  var this$1 = $m_Lcats_data_Kleisli$();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, fa);
});
var $d_Lcats_data_KleisliFunctions$$anon$3 = new $TypeData().initClass($c_Lcats_data_KleisliFunctions$$anon$3, "cats.data.KleisliFunctions$$anon$3", ({
  Lcats_data_KleisliFunctions$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_data_KleisliInstances7() {
}
$c_Lcats_data_KleisliInstances7.prototype = new $h_Lcats_data_KleisliInstances8();
$c_Lcats_data_KleisliInstances7.prototype.constructor = $c_Lcats_data_KleisliInstances7;
/** @constructor */
function $h_Lcats_data_KleisliInstances7() {
}
$h_Lcats_data_KleisliInstances7.prototype = $c_Lcats_data_KleisliInstances7.prototype;
function $ct_Lcats_data_NonEmptyListInstances__($thiz) {
  $thiz.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyListBinCompat1 = new $c_Lcats_data_NonEmptyListInstances$$anon$2();
  return $thiz;
}
function $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$2$$_$go$2__scm_ListBuffer__F1__Lcats_data_NonEmptyList__V(buf$3, f$10, v) {
  var v$tailLocal1 = v;
  while (true) {
    var x64 = $as_s_util_Either($n(v$tailLocal1).Lcats_data_NonEmptyList__f_head);
    if ((x64 instanceof $c_s_util_Right)) {
      var b = $n($as_s_util_Right(x64)).s_util_Right__f_value;
      var this$1 = $n(buf$3);
      this$1.addOne__O__scm_ListBuffer(b);
      var x61 = $m_Lcats_data_NonEmptyList$().fromList__sci_List__s_Option($n(v$tailLocal1).Lcats_data_NonEmptyList__f_tail);
      if ((x61 instanceof $c_s_Some)) {
        var t = $as_Lcats_data_NonEmptyList($n($as_s_Some(x61)).s_Some__f_value);
        v$tailLocal1 = t;
        continue;
      }
      var x = $m_s_None$();
      if ((x === x61)) {
        return (void 0);
      }
      throw new $c_s_MatchError(x61);
    }
    if ((x64 instanceof $c_s_util_Left)) {
      var a = $n($as_s_util_Left(x64)).s_util_Left__f_value;
      var this$2 = $n($as_Lcats_data_NonEmptyList($n(f$10).apply__O__O(a)));
      var l = $n(v$tailLocal1).Lcats_data_NonEmptyList__f_tail;
      v$tailLocal1 = this$2.concat__sci_List__Lcats_data_NonEmptyList(l);
      continue;
    }
    throw new $c_s_MatchError(x64);
  }
}
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyListBinCompat1 = null;
}
$c_Lcats_data_NonEmptyListInstances.prototype = new $h_Lcats_data_NonEmptyListInstances0();
$c_Lcats_data_NonEmptyListInstances.prototype.constructor = $c_Lcats_data_NonEmptyListInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances() {
}
$h_Lcats_data_NonEmptyListInstances.prototype = $c_Lcats_data_NonEmptyListInstances.prototype;
$c_Lcats_data_NonEmptyListInstances.prototype.catsDataSemigroupForNonEmptyList__Lcats_kernel_Semigroup = (function() {
  var instance = $as_Lcats_SemigroupK(this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyListBinCompat1);
  return $n(instance).algebra__Lcats_kernel_Semigroup();
});
function $ct_Lcats_data_ValidatedInstances__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_ValidatedInstances() {
}
$c_Lcats_data_ValidatedInstances.prototype = new $h_Lcats_data_ValidatedInstances1();
$c_Lcats_data_ValidatedInstances.prototype.constructor = $c_Lcats_data_ValidatedInstances;
/** @constructor */
function $h_Lcats_data_ValidatedInstances() {
}
$h_Lcats_data_ValidatedInstances.prototype = $c_Lcats_data_ValidatedInstances.prototype;
/** @constructor */
function $c_Lcats_effect_ContState(wasFinalizing) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.Lcats_effect_ContState__f_wasFinalizing = false;
  this.Lcats_effect_ContState__f_waiting = null;
  this.Lcats_effect_ContState__f_handle = null;
  this.Lcats_effect_ContState__f_wasFinalizing = wasFinalizing;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, null);
  this.Lcats_effect_ContState__f_waiting = $m_Lcats_effect_ContState$().Lcats_effect_ContState$__f_cats$effect$ContState$$$waitingSentinel;
}
$c_Lcats_effect_ContState.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_Lcats_effect_ContState.prototype.constructor = $c_Lcats_effect_ContState;
/** @constructor */
function $h_Lcats_effect_ContState() {
}
$h_Lcats_effect_ContState.prototype = $c_Lcats_effect_ContState.prototype;
var $d_Lcats_effect_ContState = new $TypeData().initClass($c_Lcats_effect_ContState, "cats.effect.ContState", ({
  Lcats_effect_ContState: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$$anon$4(k$4) {
  this.Lcats_effect_IO$$anon$4__f_k$1 = null;
  this.Lcats_effect_IO$$anon$4__f_k$1 = k$4;
}
$c_Lcats_effect_IO$$anon$4.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$4.prototype.constructor = $c_Lcats_effect_IO$$anon$4;
/** @constructor */
function $h_Lcats_effect_IO$$anon$4() {
}
$h_Lcats_effect_IO$$anon$4.prototype = $c_Lcats_effect_IO$$anon$4.prototype;
$c_Lcats_effect_IO$$anon$4.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return $n(G).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var target = $n(lift$1).apply__O__O($n(this.Lcats_effect_IO$$anon$4__f_k$1).apply__O__O(resume$1));
      var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_s_util_Either(x$1);
        if ((x$1$1 instanceof $c_s_util_Right)) {
          var a = $n($as_s_util_Right(x$1$1)).s_util_Right__f_value;
          return $n(G).pure__O__O(a);
        }
        if ((x$1$1 instanceof $c_s_util_Left)) {
          var x38 = $as_s_Option($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
          if ((x38 instanceof $c_s_Some)) {
            var fin = $as_Lcats_effect_IO($n($as_s_Some(x38)).s_Some__f_value);
            return $n(G).onCancel__O__O__O($n(poll$1).apply__O__O(get), $n(lift$1).apply__O__O(fin));
          }
          var x = $m_s_None$();
          if ((x === x38)) {
            return get;
          }
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    })));
  }));
});
var $d_Lcats_effect_IO$$anon$4 = new $TypeData().initClass($c_Lcats_effect_IO$$anon$4, "cats.effect.IO$$anon$4", ({
  Lcats_effect_IO$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$$anon$5(k$5) {
  this.Lcats_effect_IO$$anon$5__f_k$2 = null;
  this.Lcats_effect_IO$$anon$5__f_k$2 = k$5;
}
$c_Lcats_effect_IO$$anon$5.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$5.prototype.constructor = $c_Lcats_effect_IO$$anon$5;
/** @constructor */
function $h_Lcats_effect_IO$$anon$5() {
}
$h_Lcats_effect_IO$$anon$5.prototype = $c_Lcats_effect_IO$$anon$5.prototype;
$c_Lcats_effect_IO$$anon$5.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return $n(G).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var target = $n(lift$1).apply__O__O($n(this.Lcats_effect_IO$$anon$5__f_k$2).apply__O__O(resume$1));
      var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_s_Option(x$1);
        if ((x$1$1 instanceof $c_s_Some)) {
          var fin = $as_Lcats_effect_IO($n($as_s_Some(x$1$1)).s_Some__f_value);
          return $n(G).onCancel__O__O__O($n(poll$1).apply__O__O(get), $n(lift$1).apply__O__O(fin));
        }
        var x = $m_s_None$();
        if ((x === x$1$1)) {
          return get;
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    })));
  }));
});
var $d_Lcats_effect_IO$$anon$5 = new $TypeData().initClass($c_Lcats_effect_IO$$anon$5, "cats.effect.IO$$anon$5", ({
  Lcats_effect_IO$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$$anon$6(k$6) {
  this.Lcats_effect_IO$$anon$6__f_k$3 = null;
  this.Lcats_effect_IO$$anon$6__f_k$3 = k$6;
}
$c_Lcats_effect_IO$$anon$6.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$6.prototype.constructor = $c_Lcats_effect_IO$$anon$6;
/** @constructor */
function $h_Lcats_effect_IO$$anon$6() {
}
$h_Lcats_effect_IO$$anon$6.prototype = $c_Lcats_effect_IO$$anon$6.prototype;
$c_Lcats_effect_IO$$anon$6.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return $n(G).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$40) => {
      $as_Lcats_effect_kernel_Poll(_$40);
      var target = $n(lift$1).apply__O__O($m_Lcats_effect_IO$().delay__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        $n(this.Lcats_effect_IO$$anon$6__f_k$3).apply__O__O(resume$1);
      }))));
      var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$41) => {
        $as_jl_Void(_$41);
        return get;
      }));
      return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    })));
  }));
});
var $d_Lcats_effect_IO$$anon$6 = new $TypeData().initClass($c_Lcats_effect_IO$$anon$6, "cats.effect.IO$$anon$6", ({
  Lcats_effect_IO$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_IOFiberPlatform() {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
}
$c_Lcats_effect_IOFiberPlatform.prototype = new $h_ju_concurrent_atomic_AtomicBoolean();
$c_Lcats_effect_IOFiberPlatform.prototype.constructor = $c_Lcats_effect_IOFiberPlatform;
/** @constructor */
function $h_Lcats_effect_IOFiberPlatform() {
}
$h_Lcats_effect_IOFiberPlatform.prototype = $c_Lcats_effect_IOFiberPlatform.prototype;
$c_Lcats_effect_IOFiberPlatform.prototype.interruptibleImpl__Lcats_effect_IO$Blocking__Lcats_effect_IO = (function(cur) {
  var this$1 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n($n(cur).thunk__F0()).apply__O()));
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
/** @constructor */
function $c_Lcats_effect_kernel_Async$$anon$1(k$5) {
  this.Lcats_effect_kernel_Async$$anon$1__f_k$1 = null;
  this.Lcats_effect_kernel_Async$$anon$1__f_k$1 = k$5;
}
$c_Lcats_effect_kernel_Async$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Async$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Async$$anon$1() {
}
$h_Lcats_effect_kernel_Async$$anon$1.prototype = $c_Lcats_effect_kernel_Async$$anon$1.prototype;
$c_Lcats_effect_kernel_Async$$anon$1.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return $n(G).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      $m_Lcats_implicits$();
      var target = $n(lift$1).apply__O__O($n(this.Lcats_effect_kernel_Async$$anon$1__f_k$1).apply__O__O(resume$1));
      var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, G);
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_s_util_Either(x$1);
        if ((x$1$1 instanceof $c_s_util_Right)) {
          var a = $n($as_s_util_Right(x$1$1)).s_util_Right__f_value;
          return $n(G).pure__O__O(a);
        }
        if ((x$1$1 instanceof $c_s_util_Left)) {
          var x5 = $as_s_Option($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
          if ((x5 instanceof $c_s_Some)) {
            var fin = $n($as_s_Some(x5)).s_Some__f_value;
            return $n(G).onCancel__O__O__O($n(poll$1).apply__O__O(get), $n(lift$1).apply__O__O(fin));
          }
          var x = $m_s_None$();
          if ((x === x5)) {
            return get;
          }
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
    })));
  }));
});
var $d_Lcats_effect_kernel_Async$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Async$$anon$1, "cats.effect.kernel.Async$$anon$1", ({
  Lcats_effect_kernel_Async$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Async$$anon$19(nat$10) {
  this.Lcats_effect_kernel_Async$$anon$19__f_nat$5 = null;
  this.Lcats_effect_kernel_Async$$anon$19__f_nat$5 = nat$10;
}
$c_Lcats_effect_kernel_Async$$anon$19.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$$anon$19.prototype.constructor = $c_Lcats_effect_kernel_Async$$anon$19;
/** @constructor */
function $h_Lcats_effect_kernel_Async$$anon$19() {
}
$h_Lcats_effect_kernel_Async$$anon$19.prototype = $c_Lcats_effect_kernel_Async$$anon$19.prototype;
$c_Lcats_effect_kernel_Async$$anon$19.prototype.apply__Lcats_data_Kleisli__Lcats_data_Kleisli = (function(fa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n(this.Lcats_effect_kernel_Async$$anon$19__f_nat$5).apply__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
});
$c_Lcats_effect_kernel_Async$$anon$19.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_data_Kleisli__Lcats_data_Kleisli($as_Lcats_data_Kleisli(fa));
});
var $d_Lcats_effect_kernel_Async$$anon$19 = new $TypeData().initClass($c_Lcats_effect_kernel_Async$$anon$19, "cats.effect.kernel.Async$$anon$19", ({
  Lcats_effect_kernel_Async$$anon$19: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Async$KleisliAsync$$anon$18(body$12, r$2) {
  this.Lcats_effect_kernel_Async$KleisliAsync$$anon$18__f_body$7 = null;
  this.Lcats_effect_kernel_Async$KleisliAsync$$anon$18__f_r$1 = null;
  this.Lcats_effect_kernel_Async$KleisliAsync$$anon$18__f_body$7 = body$12;
  this.Lcats_effect_kernel_Async$KleisliAsync$$anon$18__f_r$1 = r$2;
}
$c_Lcats_effect_kernel_Async$KleisliAsync$$anon$18.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$KleisliAsync$$anon$18.prototype.constructor = $c_Lcats_effect_kernel_Async$KleisliAsync$$anon$18;
/** @constructor */
function $h_Lcats_effect_kernel_Async$KleisliAsync$$anon$18() {
}
$h_Lcats_effect_kernel_Async$KleisliAsync$$anon$18.prototype = $c_Lcats_effect_kernel_Async$KleisliAsync$$anon$18.prototype;
$c_Lcats_effect_kernel_Async$KleisliAsync$$anon$18.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((cb, ga, nat) => {
    var cb$1 = $as_F1(cb);
    var nat$1 = $as_Lcats_arrow_FunctionK(nat);
    var natT = new $c_Lcats_effect_kernel_Async$$anon$19(nat$1);
    var $x_1 = $n(this.Lcats_effect_kernel_Async$KleisliAsync$$anon$18__f_body$7).apply__Lcats_effect_kernel_MonadCancel__F3($m_Lcats_effect_kernel_MonadCancel$().monadCancelForKleisli__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_MonadCancel(G));
    var this$2 = $m_Lcats_data_Kleisli$();
    return $n($n($as_Lcats_data_Kleisli($n($x_1).apply__O__O__O__O(cb$1, $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$2, ga), natT))).Lcats_data_Kleisli__f_run).apply__O__O(this.Lcats_effect_kernel_Async$KleisliAsync$$anon$18__f_r$1);
  }));
});
var $d_Lcats_effect_kernel_Async$KleisliAsync$$anon$18 = new $TypeData().initClass($c_Lcats_effect_kernel_Async$KleisliAsync$$anon$18, "cats.effect.kernel.Async$KleisliAsync$$anon$18", ({
  Lcats_effect_kernel_Async$KleisliAsync$$anon$18: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10(fib$9, outer) {
  this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_fib$4 = null;
  this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_$outer = null;
  this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_fib$4 = fib$9;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_$outer = outer;
}
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype = new $h_O();
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.constructor = $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10;
/** @constructor */
function $h_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10() {
}
$h_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype = $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype;
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.cancel__Lcats_data_Kleisli = (function() {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n(this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_fib$4).cancel__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
});
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.join__Lcats_data_Kleisli = (function() {
  var this$4 = $m_Lcats_data_Kleisli$();
  var target = $n(this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_fib$4).join__O();
  var tc = $n(this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_$outer).F__Lcats_effect_kernel_GenSpawn();
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oc) => {
    var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
    return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($n(this.Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10__f_$outer), oc$1);
  }));
  var x = $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$4, x);
});
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.cancel__O = (function() {
  return this.cancel__Lcats_data_Kleisli();
});
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10.prototype.join__O = (function() {
  return this.join__Lcats_data_Kleisli();
});
var $d_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10 = new $TypeData().initClass($c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10, "cats.effect.kernel.GenSpawn$KleisliGenSpawn$$anon$10", ({
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9() {
}
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype = new $h_O();
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype.constructor = $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9;
/** @constructor */
function $h_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9() {
}
$h_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype = $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype;
$c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9.prototype.apply__O__O = (function(fa) {
  var this$1 = $m_Lcats_data_Kleisli$();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, fa);
});
var $d_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9 = new $TypeData().initClass($c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9, "cats.effect.kernel.GenSpawn$KleisliGenSpawn$$anon$9", ({
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Par$$anon$1() {
}
$c_Lcats_effect_kernel_Par$$anon$1.prototype = new $h_Lcats_effect_kernel_Par$ParallelFImpl();
$c_Lcats_effect_kernel_Par$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Par$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Par$$anon$1() {
}
$h_Lcats_effect_kernel_Par$$anon$1.prototype = $c_Lcats_effect_kernel_Par$$anon$1.prototype;
var $d_Lcats_effect_kernel_Par$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Par$$anon$1, "cats.effect.kernel.Par$$anon$1", ({
  Lcats_effect_kernel_Par$$anon$1: 1,
  Lcats_effect_kernel_Par$ParallelFImpl: 1,
  Ljava_io_Serializable: 1
}));
function $is_Lcats_effect_kernel_Poll(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Poll)));
}
function $as_Lcats_effect_kernel_Poll(obj) {
  return (($is_Lcats_effect_kernel_Poll(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Poll"));
}
function $isArrayOf_Lcats_effect_kernel_Poll(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Poll)));
}
function $asArrayOf_Lcats_effect_kernel_Poll(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Poll(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Poll;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$4(F$105, outer$2, state$5) {
  this.Lcats_effect_kernel_Resource$$anon$4__f_F$60 = null;
  this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$4__f_state$4 = null;
  this.Lcats_effect_kernel_Resource$$anon$4__f_F$60 = F$105;
  this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1 = outer$2;
  this.Lcats_effect_kernel_Resource$$anon$4__f_state$4 = state$5;
}
$c_Lcats_effect_kernel_Resource$$anon$4.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$4() {
}
$h_Lcats_effect_kernel_Resource$$anon$4.prototype = $c_Lcats_effect_kernel_Resource$$anon$4.prototype;
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.cancel__Lcats_effect_kernel_Resource = (function() {
  var fa$1 = $n(this.Lcats_effect_kernel_Resource$$anon$4__f_F$60).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var fa = $n(poll$1).apply__O__O($n(this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1).cancel__O());
    var fb = $n(this.Lcats_effect_kernel_Resource$$anon$4__f_state$4).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$38) => {
      var _$38$1 = $as_Lcats_effect_kernel_Resource$State$1(_$38);
      var $x_2 = $n(_$38$1);
      var this$3 = $n(_$38$1);
      var $x_1 = this$3.Lcats_effect_kernel_Resource$State$1__f_fin;
      var this$4 = $n(_$38$1);
      return $x_2.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1($x_1, true, this$4.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete);
    })));
    var F = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
    var this$6 = $n(F);
    return this$6.productR__O__O__O(fa, fb);
  })));
  return new $c_Lcats_effect_kernel_Resource$Eval(fa$1);
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.join__Lcats_effect_kernel_Resource = (function() {
  var target = $n(this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1).join__O();
  var tc = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
  var this$23 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
    if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
      var a = new $c_Lcats_effect_kernel_Outcome$Canceled();
      var F = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
      return $n(F).pure__O__O(a);
    }
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
      var x$1$2 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
      var this$8 = $n(x$1$2);
      var x171 = $as_jl_Throwable(this$8.Lcats_effect_kernel_Outcome$Errored__f_e);
      var a$1 = new $c_Lcats_effect_kernel_Outcome$Errored(x171);
      var F$1 = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
      return $n(F$1).pure__O__O(a$1);
    }
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
      var x$1$3 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
      var this$14 = $n(x$1$3);
      var x168 = this$14.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
      var target$1 = $n(this.Lcats_effect_kernel_Resource$$anon$4__f_state$4).get__O();
      var tc$1 = this.Lcats_effect_kernel_Resource$$anon$4__f_F$60;
      var this$22 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => {
        var s$1 = $as_Lcats_effect_kernel_Resource$State$1(s);
        if ($n(s$1).Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete) {
          return new $c_Lcats_effect_kernel_Outcome$Canceled();
        } else {
          var fa = new $c_Lcats_effect_kernel_Resource$Eval(x168);
          return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa);
        }
      }));
      return $n(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var fa$1 = $n(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$23.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa$1);
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.cancel__O = (function() {
  return this.cancel__Lcats_effect_kernel_Resource();
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.join__O = (function() {
  return this.join__Lcats_effect_kernel_Resource();
});
var $d_Lcats_effect_kernel_Resource$$anon$4 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$4, "cats.effect.kernel.Resource$$anon$4", ({
  Lcats_effect_kernel_Resource$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$5() {
}
$c_Lcats_effect_kernel_Resource$$anon$5.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$5.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$5;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$5() {
}
$h_Lcats_effect_kernel_Resource$$anon$5.prototype = $c_Lcats_effect_kernel_Resource$$anon$5.prototype;
$c_Lcats_effect_kernel_Resource$$anon$5.prototype.apply__O__O = (function(fa) {
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
var $d_Lcats_effect_kernel_Resource$$anon$5 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$5, "cats.effect.kernel.Resource$$anon$5", ({
  Lcats_effect_kernel_Resource$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$7(F$107, body$4) {
  this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$94 = null;
  this.Lcats_effect_kernel_Resource$$anon$7__f_body$3 = null;
  this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$94 = F$107;
  this.Lcats_effect_kernel_Resource$$anon$7__f_body$3 = body$4;
}
$c_Lcats_effect_kernel_Resource$$anon$7.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$7.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$7;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$7() {
}
$h_Lcats_effect_kernel_Resource$$anon$7.prototype = $c_Lcats_effect_kernel_Resource$$anon$7.prototype;
$c_Lcats_effect_kernel_Resource$$anon$7.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((cb, ga, nt) => {
    var cb$1 = $as_F1(cb);
    var nt$1 = $as_Lcats_arrow_FunctionK(nt);
    var nt2 = new $c_Lcats_effect_kernel_Resource$$anon$7$$anon$8(G, nt$1, this);
    var $x_1 = $n(nt$1);
    var target = $n(this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$94).ref__O__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$100) => {
      $as_Lcats_effect_kernel_Resource$ExitCase(_$100);
      return $n(this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$94).unit__O();
    })));
    var tc = this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$94;
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$101) => {
      var _$101$1 = $as_Lcats_effect_kernel_Ref(_$101);
      var this$3 = $n(_$101$1);
      return new $c_Lcats_effect_kernel_Ref$TransformedRef2(this$3, nt$1, G);
    }));
    var target$1 = $x_1.apply__O__O($n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f));
    var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, G);
    var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => {
      var r$1 = $as_Lcats_effect_kernel_Ref(r);
      var $x_3 = $n(G);
      var $x_2 = $n(this.Lcats_effect_kernel_Resource$$anon$7__f_body$3).apply__Lcats_effect_kernel_MonadCancel__F3($m_Lcats_effect_kernel_MonadCancel$().monadCancelForKleisli__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_MonadCancel(G));
      var this$6 = $m_Lcats_data_Kleisli$();
      var _1 = $n($n($as_Lcats_data_Kleisli($n($x_2).apply__O__O__O__O(cb$1, $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$6, ga), nt2))).Lcats_data_Kleisli__f_run).apply__O__O(r$1);
      var _2 = $n(r$1).get__O();
      var t = new $c_T2(_1, _2);
      return $x_3.guaranteeCase__O__F1__O(new $c_Lcats_syntax_Tuple2SemigroupalOps(t).tupled__Lcats_Invariant__Lcats_Semigroupal__O(G, G), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
        if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
          $n(x$1$2);
          return $n(G).unit__O();
        } else {
          var target$2 = $n(r$1).get__O();
          var this$12 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, G);
          var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fin) => {
            var fin$1 = $as_F1(fin);
            return $n(nt$1).apply__O__O($n(fin$1).apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$().fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase(x$1$1)));
          }));
          return $n(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$12.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        }
      })));
    }));
    return $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  }));
});
var $d_Lcats_effect_kernel_Resource$$anon$7 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$7, "cats.effect.kernel.Resource$$anon$7", ({
  Lcats_effect_kernel_Resource$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$7$$anon$8(G$9, nt$6, outer) {
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5 = null;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_nt$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_$outer = null;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5 = G$9;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_nt$1 = nt$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$7$$anon$8;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$7$$anon$8() {
}
$h_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype = $c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype;
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype.apply__Lcats_effect_kernel_Resource__Lcats_data_Kleisli = (function(rfa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => {
    var r$1 = $as_Lcats_effect_kernel_Ref(r);
    return $n(this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var target = $n(poll$1).apply__O__O($n(this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_nt$1).apply__O__O($n(rfa).allocatedCase__Lcats_effect_kernel_MonadCancel__O($n(this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_$outer).Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$94)));
      var tc = this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5;
      var this$9 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
      var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var a = $n(x$1$1)._1__O();
          var fin = $as_F1($n(x$1$1)._2__O());
          var $x_1 = $n(r$1);
          var x$2 = this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_$outer;
          var target$1 = $x_1.update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => ((f) => {
            var this$3 = $n(x);
            var f$1 = $as_F1(f);
            return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ec) => {
              var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
              var wrapped = $n(f$1).apply__O__O(ec$1);
              var fa = $n(this$3.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$94).unit__O();
              var fb = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(fin).apply__O__O(ec$1))), this$3.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$94);
              var F = this$3.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$94;
              return $n(F).forceR__O__O__O(wrapped, fb);
            }));
          }))(x$2)));
          var tc$1 = this.Lcats_effect_kernel_Resource$$anon$7$$anon$8__f_G$5;
          var this$8 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
          return $n(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_self, a);
        }
        throw new $c_s_MatchError(x$1$1);
      }));
      return $n(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    })));
  }));
  return new $c_Lcats_data_Kleisli(run);
});
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$8.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_kernel_Resource__Lcats_data_Kleisli($as_Lcats_effect_kernel_Resource(fa));
});
var $d_Lcats_effect_kernel_Resource$$anon$7$$anon$8 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$7$$anon$8, "cats.effect.kernel.Resource$$anon$7$$anon$8", ({
  Lcats_effect_kernel_Resource$$anon$7$$anon$8: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$() {
}
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$() {
}
$h_Lcats_effect_kernel_Resource$ExitCase$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase = (function(outcome) {
  if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome);
    $n(x$1);
    return $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
  }
  if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome$Errored(outcome);
    var this$4 = $n(x$1$1);
    var x260 = $as_jl_Throwable(this$4.Lcats_effect_kernel_Outcome$Errored__f_e);
    return new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(x260);
  }
  if (((outcome instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome), true))) {
    return $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$();
  }
  throw new $c_s_MatchError(outcome);
});
var $d_Lcats_effect_kernel_Resource$ExitCase$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$, "cats.effect.kernel.Resource$ExitCase$", ({
  Lcats_effect_kernel_Resource$ExitCase$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_effect_kernel_Resource$ExitCase$;
function $m_Lcats_effect_kernel_Resource$ExitCase$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$ = new $c_Lcats_effect_kernel_Resource$ExitCase$();
  }
  return $n_Lcats_effect_kernel_Resource$ExitCase$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$3$(outer) {
  this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$3$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$3$() {
}
$h_Lcats_effect_kernel_Resource$Frame$3$.prototype = $c_Lcats_effect_kernel_Resource$Frame$3$.prototype;
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.apply__F1__Lcats_effect_kernel_Resource$Stack$1__Lcats_effect_kernel_Resource$Frame$1 = (function(head, tail) {
  return new $c_Lcats_effect_kernel_Resource$Frame$1(this.Lcats_effect_kernel_Resource$Frame$3$__f_$outer, head, tail);
});
$c_Lcats_effect_kernel_Resource$Frame$3$.prototype.toString__T = (function() {
  return "Frame";
});
function $as_Lcats_effect_kernel_Resource$Frame$3$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$3$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$3$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$3$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$3$;", depth));
}
var $d_Lcats_effect_kernel_Resource$Frame$3$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$3$, "cats.effect.kernel.Resource$Frame$3$", ({
  Lcats_effect_kernel_Resource$Frame$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$6$(outer) {
  this.Lcats_effect_kernel_Resource$Frame$6$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$Frame$6$__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$Frame$6$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$6$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$6$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$6$() {
}
$h_Lcats_effect_kernel_Resource$Frame$6$.prototype = $c_Lcats_effect_kernel_Resource$Frame$6$.prototype;
$c_Lcats_effect_kernel_Resource$Frame$6$.prototype.apply__F1__Lcats_effect_kernel_Resource$Stack$2__Lcats_effect_kernel_Resource$Frame$4 = (function(head, tail) {
  return new $c_Lcats_effect_kernel_Resource$Frame$4(this.Lcats_effect_kernel_Resource$Frame$6$__f_$outer, head, tail);
});
$c_Lcats_effect_kernel_Resource$Frame$6$.prototype.toString__T = (function() {
  return "Frame";
});
function $as_Lcats_effect_kernel_Resource$Frame$6$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$6$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$6$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$6$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$6$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$6$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$6$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$6$;", depth));
}
var $d_Lcats_effect_kernel_Resource$Frame$6$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$6$, "cats.effect.kernel.Resource$Frame$6$", ({
  Lcats_effect_kernel_Resource$Frame$6$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$State$3$(F$104, outer) {
  this.Lcats_effect_kernel_Resource$State$3$__f_F$54 = null;
  this.Lcats_effect_kernel_Resource$State$3$__f_$outer = null;
  this.Lcats_effect_kernel_Resource$State$3$__f_F$54 = F$104;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$State$3$__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$State$3$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$State$3$.prototype.constructor = $c_Lcats_effect_kernel_Resource$State$3$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$State$3$() {
}
$h_Lcats_effect_kernel_Resource$State$3$.prototype = $c_Lcats_effect_kernel_Resource$State$3$.prototype;
$c_Lcats_effect_kernel_Resource$State$3$.prototype.apply__O__Z__Z__Lcats_effect_kernel_Resource$State$1 = (function(fin, finalizeOnComplete, confirmedFinalizeOnComplete) {
  return new $c_Lcats_effect_kernel_Resource$State$1(this.Lcats_effect_kernel_Resource$State$3$__f_$outer, fin, finalizeOnComplete, confirmedFinalizeOnComplete);
});
$c_Lcats_effect_kernel_Resource$State$3$.prototype.toString__T = (function() {
  return "State";
});
$c_Lcats_effect_kernel_Resource$State$3$.prototype.$lessinit$greater$default$1__O = (function() {
  return $n(this.Lcats_effect_kernel_Resource$State$3$__f_F$54).unit__O();
});
function $as_Lcats_effect_kernel_Resource$State$3$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$State$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$State$3$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$State$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$State$3$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$State$3$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$State$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$State$3$;", depth));
}
var $d_Lcats_effect_kernel_Resource$State$3$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$State$3$, "cats.effect.kernel.Resource$State$3$", ({
  Lcats_effect_kernel_Resource$State$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2() {
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2() {
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.apply__O__O = (function(fa) {
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa;
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 = new $TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2, "cats.effect.kernel.instances.GenSpawnInstances$$anon$2", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3() {
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3() {
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3.prototype.apply__O__O = (function(ma) {
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return ma;
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3 = new $TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3, "cats.effect.kernel.instances.GenSpawnInstances$$anon$3", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Console$NodeJSConsole(stdout, stderr, F) {
}
$c_Lcats_effect_std_Console$NodeJSConsole.prototype = new $h_O();
$c_Lcats_effect_std_Console$NodeJSConsole.prototype.constructor = $c_Lcats_effect_std_Console$NodeJSConsole;
/** @constructor */
function $h_Lcats_effect_std_Console$NodeJSConsole() {
}
$h_Lcats_effect_std_Console$NodeJSConsole.prototype = $c_Lcats_effect_std_Console$NodeJSConsole.prototype;
var $d_Lcats_effect_std_Console$NodeJSConsole = new $TypeData().initClass($c_Lcats_effect_std_Console$NodeJSConsole, "cats.effect.std.Console$NodeJSConsole", ({
  Lcats_effect_std_Console$NodeJSConsole: 1,
  Lcats_effect_std_ConsoleCrossPlatform: 1,
  Lcats_effect_std_Console: 1
}));
/** @constructor */
function $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole(outer, F) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype = new $h_O();
$c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype.constructor = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole;
/** @constructor */
function $h_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole() {
}
$h_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype = $c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole.prototype;
var $d_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole = new $TypeData().initClass($c_Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole, "cats.effect.std.ConsoleCompanionCrossPlatform$SyncConsole", ({
  Lcats_effect_std_ConsoleCompanionCrossPlatform$SyncConsole: 1,
  Lcats_effect_std_ConsoleCrossPlatform: 1,
  Lcats_effect_std_Console: 1
}));
function $p_Lcats_effect_std_Dispatcher$$anon$2__cancel$1__ju_concurrent_atomic_AtomicReference__s_concurrent_Future($thiz, stateR$3) {
  while (true) {
    var x7 = $as_Lcats_effect_std_Dispatcher$RegState($n(stateR$3).ju_concurrent_atomic_AtomicReference__f_value);
    if ((x7 instanceof $c_Lcats_effect_std_Dispatcher$RegState$Unstarted)) {
      var u = $as_Lcats_effect_std_Dispatcher$RegState$Unstarted(x7);
      var latch = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
      if ($n(stateR$3).compareAndSet__O__O__Z(u, new $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested(latch))) {
        return latch;
      } else {
        continue;
      }
    }
    if ((x7 instanceof $c_Lcats_effect_std_Dispatcher$RegState$Running)) {
      var r = $as_Lcats_effect_std_Dispatcher$RegState$Running(x7);
      var cancel = $n(r).Lcats_effect_std_Dispatcher$RegState$Running__f_cancel;
      var latch$2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
      $p_Lcats_effect_std_Dispatcher$$anon$2__inner$1__O__s_concurrent_Promise__Z__F0($thiz, cancel, latch$2, true);
      return latch$2;
    }
    if ((x7 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
      var r$2 = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x7);
      return $n($n(r$2).Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch);
    }
    var x = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
    if ((x === x7)) {
      return $m_s_concurrent_Future$().successful__O__s_concurrent_Future((void 0));
    }
    throw new $c_s_MatchError(x7);
  }
}
function $p_Lcats_effect_std_Dispatcher$$anon$2__inner$1__O__s_concurrent_Promise__Z__F0($thiz, fe, result, finalizer) {
  if ($n($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_doneR$5).ju_concurrent_atomic_AtomicBoolean__f_value) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Dispatcher already closed");
  }
  var stateR = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
  var F = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$1$8;
  var promisory = $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var F$1 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$1$8;
    var completeState = $n(F$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      matchResult2: {
        var x4 = $as_Lcats_effect_std_Dispatcher$RegState(stateR.getAndSet__O__O($m_Lcats_effect_std_Dispatcher$RegState$Completed$()));
        if ((x4 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
          var st = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x4);
          var this$4 = $n($n(st).Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch);
          $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$4, (void 0));
          break matchResult2;
        }
        var x = $m_Lcats_effect_std_Dispatcher$RegState$Completed$();
        if ((x === x4)) {
          throw new $c_jl_AssertionError("unexpected Completed state");
        }
      }
    })));
    var $x_1 = $n(poll$1);
    var F$2 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$1$8;
    var fa = $x_1.apply__O__O($n(F$2).guarantee__O__O__O(fe, completeState));
    var recover = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => {
      var e$1 = $as_jl_Throwable(e);
      var F$4 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$1$8;
      return $n(F$4).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        var this$9 = $n(result);
        return $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(this$9, e$1);
      })));
    }));
    var bind = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
      var F$5 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$1$8;
      return $n(F$5).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        var this$11 = $n(result);
        return $f_s_concurrent_Promise__success__O__s_concurrent_Promise(this$11, a);
      })));
    }));
    var F$6 = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$1$8;
    var target = $n(F$6).redeemWith__O__F1__F1__O(fa, recover, bind);
    var tc = $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$1$8;
    var this$14 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    return $n(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$14.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  })));
  stateR.ju_concurrent_atomic_AtomicReference__f_value = new $c_Lcats_effect_std_Dispatcher$RegState$Unstarted(promisory);
  if ($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_parallel$6) {
    var $x_2 = $n($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_workers$3);
    var this$16 = $m_ju_concurrent_ThreadLocalRandom$();
    var worker = $x_2.get($n(this$16.ju_concurrent_ThreadLocalRandom$__f__current).nextInt__I__I($m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus));
  } else {
    var worker = $n($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_workers$3).get(0);
  }
  if (finalizer) {
    $n($n(worker).Lcats_effect_std_Dispatcher$Worker__f_queue).unsafeOffer__O__V(new $c_Lcats_effect_std_Dispatcher$Registration$Finalizer(promisory));
    return new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future($ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException()))));
  } else {
    var reg = new $c_Lcats_effect_std_Dispatcher$Registration$Primary(stateR);
    $n($n(worker).Lcats_effect_std_Dispatcher$Worker__f_queue).unsafeOffer__O__V(reg);
    return new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $p_Lcats_effect_std_Dispatcher$$anon$2__cancel$1__ju_concurrent_atomic_AtomicReference__s_concurrent_Future($thiz, stateR)));
  }
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$$anon$2(doneR$11, evidence$1$32, parallel$7, workers$5, ec$2) {
  this.Lcats_effect_std_Dispatcher$$anon$2__f_doneR$5 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$1$8 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_parallel$6 = false;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_workers$3 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_ec$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_doneR$5 = doneR$11;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_evidence$1$8 = evidence$1$32;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_parallel$6 = parallel$7;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_workers$3 = workers$5;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_ec$1 = ec$2;
}
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype.constructor = $c_Lcats_effect_std_Dispatcher$$anon$2;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$$anon$2() {
}
$h_Lcats_effect_std_Dispatcher$$anon$2.prototype = $c_Lcats_effect_std_Dispatcher$$anon$2.prototype;
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype.unsafeToFutureCancelable__O__T2 = (function(fa) {
  var result = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var _2 = $p_Lcats_effect_std_Dispatcher$$anon$2__inner$1__O__s_concurrent_Promise__Z__F0(this, fa, result, false);
  return new $c_T2(result, _2);
});
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $n(this.Lcats_effect_std_Dispatcher$$anon$2__f_ec$1).reportFailure__jl_Throwable__V(t);
});
var $d_Lcats_effect_std_Dispatcher$$anon$2 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$$anon$2, "cats.effect.std.Dispatcher$$anon$2", ({
  Lcats_effect_std_Dispatcher$$anon$2: 1,
  Lcats_effect_std_DispatcherPlatform: 1,
  Lcats_effect_std_Dispatcher: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(TaskState$lzy1$14) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executing$lzy1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executingbitmap$1 = false;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Dead$lzy1 = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Deadbitmap$1 = false;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Ready$lzy1 = new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$(this);
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Canceling$lzy1 = new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$(this);
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype.Executing__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$ = (function() {
  if ((!this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executingbitmap$1)) {
    this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executing$lzy1 = new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$();
    this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executingbitmap$1 = true;
  }
  return this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Executing$lzy1;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$.prototype.Dead__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$ = (function() {
  if ((!this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Deadbitmap$1)) {
    this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Dead$lzy1 = new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$();
    this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Deadbitmap$1 = true;
  }
  return this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$__f_Dead$lzy1;
});
function $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor$TaskState$3$"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$3$)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor$TaskState$3$;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$, "cats.effect.std.Dispatcher$Executor$TaskState$3$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$(outer) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype.apply__Lcats_effect_kernel_Deferred__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling = (function(latch) {
  return new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$__f_$outer, latch);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$.prototype.toString__T = (function() {
  return "Canceling";
});
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$, "cats.effect.std.Dispatcher$Executor$TaskState$3$Canceling$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$(outer) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype.apply__O__Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready = (function(task) {
  return new $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$__f_$outer, task);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$.prototype.toString__T = (function() {
  return "Ready";
});
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$, "cats.effect.std.Dispatcher$Executor$TaskState$3$Ready$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue(evidence$1) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$1 = null;
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$buffer = null;
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$1 = evidence$1;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, null);
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$buffer = new $c_Lcats_effect_std_UnsafeUnbounded();
}
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype.constructor = $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue() {
}
$h_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype = $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype;
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype.unsafeOffer__O__V = (function(a) {
  $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$buffer).put__O__F0(a);
  var back = $as_F1(this.ju_concurrent_atomic_AtomicReference__f_value);
  if ((back !== null)) {
    $n(back).apply__O__O($m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$RightUnit);
  }
});
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue.prototype.take__O = (function() {
  var F = this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$1;
  return $n(F).cont__Lcats_effect_kernel_Cont__O(new $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6(this));
});
var $d_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue, "cats.effect.std.Dispatcher$UnsafeAsyncQueue", ({
  Lcats_effect_std_Dispatcher$UnsafeAsyncQueue: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6(outer) {
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype.constructor = $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6() {
}
$h_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype = $c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype;
$c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(evidence$1) {
  return new $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((k, get, lift) => {
    var k$1 = $as_F1(k);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    var $x_1 = $n(lift$1);
    var F = $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$1;
    var takeG = $x_1.apply__O__O($n(F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n($n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$buffer).take__O()))));
    var $x_2 = $n(lift$1);
    var F$1 = $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$1;
    var setLatchG = $x_2.apply__O__O($n(F$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).ju_concurrent_atomic_AtomicReference__f_value = k$1;
    }))));
    var $x_3 = $n(lift$1);
    var F$2 = $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).Lcats_effect_std_Dispatcher$UnsafeAsyncQueue__f_cats$effect$std$Dispatcher$UnsafeAsyncQueue$$evidence$1;
    var unsetLatchG = $x_3.apply__O__O($n(F$2).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      var this$5 = $n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer);
      this$5.ju_concurrent_atomic_AtomicReference__f_value = null;
    }))));
    var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$31) => {
      $as_jl_Throwable(_$31);
      var this$10 = $n(evidence$1);
      var fa = this$10.productL__O__O__O(takeG, unsetLatchG);
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$32) => {
        $as_jl_Throwable(_$32);
        var this$14 = $n(evidence$1);
        var fa$1 = this$14.productR__O__O__O(get, unsetLatchG);
        var fb = $n(lift$1).apply__O__O($n(this.Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6__f_$outer).take__O());
        var this$17 = $n(evidence$1);
        return this$17.productR__O__O__O(fa$1, fb);
      }));
      var fb$1 = $n(evidence$1).handleErrorWith__O__F1__O(fa, f);
      var this$20 = $n(evidence$1);
      return this$20.productR__O__O__O(setLatchG, fb$1);
    }));
    return $n(evidence$1).handleErrorWith__O__F1__O(takeG, f$1);
  }));
});
var $d_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6 = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6, "cats.effect.std.Dispatcher$UnsafeAsyncQueue$$anon$6", ({
  Lcats_effect_std_Dispatcher$UnsafeAsyncQueue$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Cont: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Queue() {
}
$c_Lcats_effect_std_Queue.prototype = new $h_O();
$c_Lcats_effect_std_Queue.prototype.constructor = $c_Lcats_effect_std_Queue;
/** @constructor */
function $h_Lcats_effect_std_Queue() {
}
$h_Lcats_effect_std_Queue.prototype = $c_Lcats_effect_std_Queue.prototype;
function $as_Lcats_effect_std_Queue(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Queue"));
}
function $isArrayOf_Lcats_effect_std_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Queue)));
}
function $asArrayOf_Lcats_effect_std_Queue(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Queue;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Request$(outer) {
  this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer = outer;
}
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Request$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Request$() {
}
$h_Lcats_effect_std_Semaphore$impl$Request$.prototype = $c_Lcats_effect_std_Semaphore$impl$Request$.prototype;
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.apply__J__Lcats_effect_kernel_Deferred__Lcats_effect_std_Semaphore$impl$Request = (function(n_$_lo, n_$_hi, gate) {
  return new $c_Lcats_effect_std_Semaphore$impl$Request(this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer, n_$_lo, n_$_hi, gate);
});
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.toString__T = (function() {
  return "Request";
});
var $d_Lcats_effect_std_Semaphore$impl$Request$ = new $TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$Request$, "cats.effect.std.Semaphore$impl$Request$", ({
  Lcats_effect_std_Semaphore$impl$Request$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$State$(outer) {
  this.Lcats_effect_std_Semaphore$impl$State$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$State$__f_$outer = outer;
}
$c_Lcats_effect_std_Semaphore$impl$State$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$State$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$State$() {
}
$h_Lcats_effect_std_Semaphore$impl$State$.prototype = $c_Lcats_effect_std_Semaphore$impl$State$.prototype;
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State = (function(permits_$_lo, permits_$_hi, waiting) {
  return new $c_Lcats_effect_std_Semaphore$impl$State(this.Lcats_effect_std_Semaphore$impl$State$__f_$outer, permits_$_lo, permits_$_hi, waiting);
});
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.toString__T = (function() {
  return "State";
});
var $d_Lcats_effect_std_Semaphore$impl$State$ = new $TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$State$, "cats.effect.std.Semaphore$impl$State$", ({
  Lcats_effect_std_Semaphore$impl$State$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$2(currentR$7, F$5, canceledR$9, resultR$10, fin$11, outer) {
  this.Lcats_effect_std_Supervisor$$anon$2__f_resultR$15 = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_delegateF = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_cancel = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_$outer = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_resultR$15 = resultR$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Supervisor$$anon$2__f_$outer = outer;
  var target = $n(currentR$7).get__O();
  var this$2 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F$5);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$9) => {
    var _$9$1 = $as_Lcats_effect_kernel_Deferred(_$9);
    return $n(_$9$1).get__O();
  }));
  this.Lcats_effect_std_Supervisor$$anon$2__f_delegateF = $n(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$2.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  this.Lcats_effect_std_Supervisor$$anon$2__f_cancel = $n(F$5).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
    $as_Lcats_effect_kernel_Poll(_$10);
    var fa = $n(canceledR$9).set__O__O(true);
    var fb = this.Lcats_effect_std_Supervisor$$anon$2__f_delegateF;
    var this$6 = $n(F$5);
    var target$1 = this$6.productR__O__O__O(fa, fb);
    var this$30 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$5);
    var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_Lcats_effect_kernel_Fiber(x$1);
      if ((x$1$1 === null)) {
        var target$2 = $n(resultR$10).get__O();
        var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F$5);
        return $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
      } else {
        var fa$1 = $n(x$1$1).cancel__O();
        var fb$1 = $n(x$1$1).join__O();
        var this$12 = $n(F$5);
        var target$3 = this$12.productR__O__O__O(fa$1, fb$1);
        var this$29 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$3, F$5);
        var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
          var x$1$3 = $as_Lcats_effect_kernel_Outcome(x$1$2);
          if (((x$1$3 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$3), true))) {
            var target$4 = this.Lcats_effect_std_Supervisor$$anon$2__f_delegateF;
            var this$26 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$4, F$5);
            var x$2 = this.Lcats_effect_std_Supervisor$$anon$2__f_$outer;
            var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => ((x$1$2$1) => {
              $n(x);
              var x$1$4 = $as_Lcats_effect_kernel_Fiber(x$1$2$1);
              if ((x$1$4 === null)) {
                var target$5 = $n(resultR$10).get__O();
                var this$17 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, F$5);
                return $n(this$17.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$17.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
              } else {
                var target$6 = $n(resultR$10).complete__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled());
                var this$21 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$6, F$5);
                var fin = $n(this$21.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$21.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
                var cleanup = $n(F$5).guarantee__O__O__O(fin$11, fin);
                if ((x$1$4 === x$1$1)) {
                  return cleanup;
                } else {
                  var fb$2 = $n(F$5).raiseError__O__O(new $c_jl_AssertionError("unexpected fiber (this is a bug in Supervisor)"));
                  var this$25 = $n(F$5);
                  return this$25.productR__O__O__O(cleanup, fb$2);
                }
              }
            }))(x$2));
            return $n(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          } else {
            var target$7 = $n(resultR$10).get__O();
            var this$28 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$7, F$5);
            return $n(this$28.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$28.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
          }
        }));
        return $n(this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$29.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
      }
    }));
    return $n(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$30.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  })));
}
$c_Lcats_effect_std_Supervisor$$anon$2.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$2;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$2() {
}
$h_Lcats_effect_std_Supervisor$$anon$2.prototype = $c_Lcats_effect_std_Supervisor$$anon$2.prototype;
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.cancel__O = (function() {
  return this.Lcats_effect_std_Supervisor$$anon$2__f_cancel;
});
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.join__O = (function() {
  return $n(this.Lcats_effect_std_Supervisor$$anon$2__f_resultR$15).get__O();
});
var $d_Lcats_effect_std_Supervisor$$anon$2 = new $TypeData().initClass($c_Lcats_effect_std_Supervisor$$anon$2, "cats.effect.std.Supervisor$$anon$2", ({
  Lcats_effect_std_Supervisor$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitorImpl(compute) {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  this.Lcats_effect_unsafe_FiberMonitorImpl__f_bag = null;
  $ct_Lcats_effect_unsafe_FiberMonitorShared__(this);
  this.Lcats_effect_unsafe_FiberMonitorImpl__f_bag = new $c_Lcats_effect_unsafe_WeakBag();
}
$c_Lcats_effect_unsafe_FiberMonitorImpl.prototype = new $h_Lcats_effect_unsafe_FiberMonitor();
$c_Lcats_effect_unsafe_FiberMonitorImpl.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitorImpl;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitorImpl() {
}
$h_Lcats_effect_unsafe_FiberMonitorImpl.prototype = $c_Lcats_effect_unsafe_FiberMonitorImpl.prototype;
$c_Lcats_effect_unsafe_FiberMonitorImpl.prototype.monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle = (function(fiber) {
  return $n(this.Lcats_effect_unsafe_FiberMonitorImpl__f_bag).insert__O__Lcats_effect_unsafe_WeakBag$Handle(fiber);
});
var $d_Lcats_effect_unsafe_FiberMonitorImpl = new $TypeData().initClass($c_Lcats_effect_unsafe_FiberMonitorImpl, "cats.effect.unsafe.FiberMonitorImpl", ({
  Lcats_effect_unsafe_FiberMonitorImpl: 1,
  Lcats_effect_unsafe_FiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitorShared: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_NoOpFiberMonitor() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  $ct_Lcats_effect_unsafe_FiberMonitorShared__(this);
}
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitor();
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_NoOpFiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_NoOpFiberMonitor() {
}
$h_Lcats_effect_unsafe_NoOpFiberMonitor.prototype = $c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype;
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle = (function(fiber) {
  return new $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1(this);
});
var $d_Lcats_effect_unsafe_NoOpFiberMonitor = new $TypeData().initClass($c_Lcats_effect_unsafe_NoOpFiberMonitor, "cats.effect.unsafe.NoOpFiberMonitor", ({
  Lcats_effect_unsafe_NoOpFiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitorShared: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1() {
  this.Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1__f_cpuStarvationSampler = null;
  this.Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1__f_cpuStarvationSampler = $m_Lcats_effect_unsafe_metrics_CpuStarvationSampler$().apply__Lcats_effect_unsafe_metrics_CpuStarvationSampler();
}
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1() {
}
$h_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1.prototype = $c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1.prototype;
var $d_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1 = new $TypeData().initClass($c_Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1, "cats.effect.unsafe.metrics.IORuntimeMetricsCompanionPlatform$$anon$1", ({
  Lcats_effect_unsafe_metrics_IORuntimeMetricsCompanionPlatform$$anon$1: 1,
  Lcats_effect_unsafe_metrics_IORuntimeMetricsPlatform: 1,
  Lcats_effect_unsafe_metrics_IORuntimeMetrics: 1
}));
/** @constructor */
function $c_Lcats_instances_EqInstances$$anon$2(fa$6, fb$3, outer) {
  this.Lcats_instances_EqInstances$$anon$2__f_fa$4 = null;
  this.Lcats_instances_EqInstances$$anon$2__f_fb$2 = null;
  this.Lcats_instances_EqInstances$$anon$2__f_fa$4 = fa$6;
  this.Lcats_instances_EqInstances$$anon$2__f_fb$2 = fb$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_EqInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_EqInstances$$anon$2.prototype.constructor = $c_Lcats_instances_EqInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_EqInstances$$anon$2() {
}
$h_Lcats_instances_EqInstances$$anon$2.prototype = $c_Lcats_instances_EqInstances$$anon$2.prototype;
$c_Lcats_instances_EqInstances$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_EqInstances$$anon$2.prototype.eqv__T2__T2__Z = (function(left, right) {
  var fa$1 = this.Lcats_instances_EqInstances$$anon$2__f_fa$4;
  var fb$1 = this.Lcats_instances_EqInstances$$anon$2__f_fb$2;
  return ($n(fa$1).eqv__O__O__Z($n(left)._1__O(), $n(right)._1__O()) && $n(fb$1).eqv__O__O__Z($n(left)._2__O(), $n(right)._2__O()));
});
$c_Lcats_instances_EqInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__T2__T2__Z($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_EqInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_EqInstances$$anon$2, "cats.instances.EqInstances$$anon$2", ({
  Lcats_instances_EqInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$3(fa$5, f$2) {
}
$c_Lcats_instances_EquivInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$3.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$3() {
}
$h_Lcats_instances_EquivInstances$$anon$3.prototype = $c_Lcats_instances_EquivInstances$$anon$3.prototype;
var $d_Lcats_instances_EquivInstances$$anon$3 = new $TypeData().initClass($c_Lcats_instances_EquivInstances$$anon$3, "cats.instances.EquivInstances$$anon$3", ({
  Lcats_instances_EquivInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1
}));
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$4(fa$6, fb$2) {
}
$c_Lcats_instances_EquivInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$4.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$4() {
}
$h_Lcats_instances_EquivInstances$$anon$4.prototype = $c_Lcats_instances_EquivInstances$$anon$4.prototype;
var $d_Lcats_instances_EquivInstances$$anon$4 = new $TypeData().initClass($c_Lcats_instances_EquivInstances$$anon$4, "cats.instances.EquivInstances$$anon$4", ({
  Lcats_instances_EquivInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1
}));
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(this);
}
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
}
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 = new $TypeData().initClass($c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1, "cats.instances.FunctionInstancesBinCompat0$$anon$1", ({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Defer: 1
}));
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = new $h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$() {
}
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype;
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.toString__T = (function() {
  return "Deferred";
});
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ = new $TypeData().initClass($c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$, "cats.instances.FunctionInstancesBinCompat0$$anon$1$Deferred$", ({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$10() {
}
$c_Lcats_instances_InvariantInstances$$anon$10.prototype = new $h_O();
$c_Lcats_instances_InvariantInstances$$anon$10.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$10;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$10() {
}
$h_Lcats_instances_InvariantInstances$$anon$10.prototype = $c_Lcats_instances_InvariantInstances$$anon$10.prototype;
$c_Lcats_instances_InvariantInstances$$anon$10.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_math_Numeric(fa);
  return new $c_Lcats_instances_InvariantInstances$$anon$11(fa$1, f, g);
});
var $d_Lcats_instances_InvariantInstances$$anon$10 = new $TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$10, "cats.instances.InvariantInstances$$anon$10", ({
  Lcats_instances_InvariantInstances$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$12() {
}
$c_Lcats_instances_InvariantInstances$$anon$12.prototype = new $h_O();
$c_Lcats_instances_InvariantInstances$$anon$12.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$12;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$12() {
}
$h_Lcats_instances_InvariantInstances$$anon$12.prototype = $c_Lcats_instances_InvariantInstances$$anon$12.prototype;
$c_Lcats_instances_InvariantInstances$$anon$12.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_math_Integral(fa);
  return new $c_Lcats_instances_InvariantInstances$$anon$13(fa$1, f, g);
});
var $d_Lcats_instances_InvariantInstances$$anon$12 = new $TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$12, "cats.instances.InvariantInstances$$anon$12", ({
  Lcats_instances_InvariantInstances$$anon$12: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$2(fa$18, fb$7, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fa$13 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fb$5 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fa$13 = fa$18;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$2__f_fb$5 = fb$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$2() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype;
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$2, "cats.instances.InvariantMonoidalInstances$$anon$2", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$3(f$12, fa$19, g$12, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_f$9 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_fa$14 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_g$9 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_f$9 = f$12;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_fa$14 = fa$19;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$3__f_g$9 = g$12;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$3() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype;
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$3 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$3, "cats.instances.InvariantMonoidalInstances$$anon$3", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
}));
/** @constructor */
function $c_Lcats_instances_NTupleBifunctorInstances$$anon$1(bim$2) {
  this.Lcats_instances_NTupleBifunctorInstances$$anon$1__f_bim$1 = null;
  this.Lcats_instances_NTupleBifunctorInstances$$anon$1__f_bim$1 = bim$2;
}
$c_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype.constructor = $c_Lcats_instances_NTupleBifunctorInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_NTupleBifunctorInstances$$anon$1() {
}
$h_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype = $c_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype;
$c_Lcats_instances_NTupleBifunctorInstances$$anon$1.prototype.bimap__O__F1__F1__O = (function(fab, f, g) {
  return $n(this.Lcats_instances_NTupleBifunctorInstances$$anon$1__f_bim$1).apply__O__O__O__O(fab, f, g);
});
var $d_Lcats_instances_NTupleBifunctorInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_NTupleBifunctorInstances$$anon$1, "cats.instances.NTupleBifunctorInstances$$anon$1", ({
  Lcats_instances_NTupleBifunctorInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifunctor: 1
}));
function $is_Lcats_kernel_CommutativeSemigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_CommutativeSemigroup)));
}
function $as_Lcats_kernel_CommutativeSemigroup(obj) {
  return (($is_Lcats_kernel_CommutativeSemigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.CommutativeSemigroup"));
}
function $isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_CommutativeSemigroup)));
}
function $asArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.CommutativeSemigroup;", depth));
}
/** @constructor */
function $c_Lcats_kernel_Comparison$() {
}
$c_Lcats_kernel_Comparison$.prototype = new $h_O();
$c_Lcats_kernel_Comparison$.prototype.constructor = $c_Lcats_kernel_Comparison$;
/** @constructor */
function $h_Lcats_kernel_Comparison$() {
}
$h_Lcats_kernel_Comparison$.prototype = $c_Lcats_kernel_Comparison$.prototype;
var $d_Lcats_kernel_Comparison$ = new $TypeData().initClass($c_Lcats_kernel_Comparison$, "cats.kernel.Comparison$", ({
  Lcats_kernel_Comparison$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_kernel_Comparison$;
function $m_Lcats_kernel_Comparison$() {
  if ((!$n_Lcats_kernel_Comparison$)) {
    $n_Lcats_kernel_Comparison$ = new $c_Lcats_kernel_Comparison$();
  }
  return $n_Lcats_kernel_Comparison$;
}
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$2(ev$6, f$5) {
  this.Lcats_kernel_Eq$$anon$2__f_ev$4 = null;
  this.Lcats_kernel_Eq$$anon$2__f_f$3 = null;
  this.Lcats_kernel_Eq$$anon$2__f_ev$4 = ev$6;
  this.Lcats_kernel_Eq$$anon$2__f_f$3 = f$5;
}
$c_Lcats_kernel_Eq$$anon$2.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$2.prototype.constructor = $c_Lcats_kernel_Eq$$anon$2;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$2() {
}
$h_Lcats_kernel_Eq$$anon$2.prototype = $c_Lcats_kernel_Eq$$anon$2.prototype;
$c_Lcats_kernel_Eq$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Eq$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  var ev$2 = this.Lcats_kernel_Eq$$anon$2__f_ev$4;
  var f$1 = this.Lcats_kernel_Eq$$anon$2__f_f$3;
  return $n(ev$2).eqv__O__O__Z($n(f$1).apply__O__O(x), $n(f$1).apply__O__O(y));
});
var $d_Lcats_kernel_Eq$$anon$2 = new $TypeData().initClass($c_Lcats_kernel_Eq$$anon$2, "cats.kernel.Eq$$anon$2", ({
  Lcats_kernel_Eq$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$5(f$6) {
  this.Lcats_kernel_Eq$$anon$5__f_f$4 = null;
  this.Lcats_kernel_Eq$$anon$5__f_f$4 = f$6;
}
$c_Lcats_kernel_Eq$$anon$5.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$5.prototype.constructor = $c_Lcats_kernel_Eq$$anon$5;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$5() {
}
$h_Lcats_kernel_Eq$$anon$5.prototype = $c_Lcats_kernel_Eq$$anon$5.prototype;
$c_Lcats_kernel_Eq$$anon$5.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Eq$$anon$5.prototype.eqv__O__O__Z = (function(_$3, _$4) {
  var f$2 = this.Lcats_kernel_Eq$$anon$5__f_f$4;
  return $uZ($n(f$2).apply__O__O__O(_$3, _$4));
});
var $d_Lcats_kernel_Eq$$anon$5 = new $TypeData().initClass($c_Lcats_kernel_Eq$$anon$5, "cats.kernel.Eq$$anon$5", ({
  Lcats_kernel_Eq$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$6() {
}
$c_Lcats_kernel_Eq$$anon$6.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$6.prototype.constructor = $c_Lcats_kernel_Eq$$anon$6;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$6() {
}
$h_Lcats_kernel_Eq$$anon$6.prototype = $c_Lcats_kernel_Eq$$anon$6.prototype;
$c_Lcats_kernel_Eq$$anon$6.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Eq$$anon$6.prototype.eqv__O__O__Z = (function(_$5, _$6) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(_$5, _$6);
});
var $d_Lcats_kernel_Eq$$anon$6 = new $TypeData().initClass($c_Lcats_kernel_Eq$$anon$6, "cats.kernel.Eq$$anon$6", ({
  Lcats_kernel_Eq$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
function $is_Lcats_kernel_Hash(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Hash)));
}
function $as_Lcats_kernel_Hash(obj) {
  return (($is_Lcats_kernel_Hash(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Hash"));
}
function $isArrayOf_Lcats_kernel_Hash(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Hash)));
}
function $asArrayOf_Lcats_kernel_Hash(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Hash(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Hash;", depth));
}
/** @constructor */
function $c_Lcats_kernel_Hash$() {
}
$c_Lcats_kernel_Hash$.prototype = new $h_Lcats_kernel_HashFunctions();
$c_Lcats_kernel_Hash$.prototype.constructor = $c_Lcats_kernel_Hash$;
/** @constructor */
function $h_Lcats_kernel_Hash$() {
}
$h_Lcats_kernel_Hash$.prototype = $c_Lcats_kernel_Hash$.prototype;
var $d_Lcats_kernel_Hash$ = new $TypeData().initClass($c_Lcats_kernel_Hash$, "cats.kernel.Hash$", ({
  Lcats_kernel_Hash$: 1,
  Lcats_kernel_HashFunctions: 1,
  Lcats_kernel_EqFunctions: 1
}));
var $n_Lcats_kernel_Hash$;
function $m_Lcats_kernel_Hash$() {
  if ((!$n_Lcats_kernel_Hash$)) {
    $n_Lcats_kernel_Hash$ = new $c_Lcats_kernel_Hash$();
  }
  return $n_Lcats_kernel_Hash$;
}
function $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O($thiz, as) {
  var this$2 = $n($n(as).iterator__sc_Iterator());
  var z = $thiz.empty__O();
  var f = ((x, y) => $thiz.combine__O__O__O(x, y));
  if ($is_sc_IndexedSeq(this$2)) {
    var x2 = $as_sc_IndexedSeq(this$2);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = z;
    while (true) {
      if ((at === end)) {
        return acc;
      } else {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = $n(x2).apply__I__O(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
      }
    }
  } else {
    var result = z;
    while (this$2.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = this$2.next__O();
      result = f(x0$1, x1$1);
    }
    return result;
  }
}
/** @constructor */
function $c_Lcats_kernel_OrderFunctions() {
}
$c_Lcats_kernel_OrderFunctions.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_OrderFunctions.prototype.constructor = $c_Lcats_kernel_OrderFunctions;
/** @constructor */
function $h_Lcats_kernel_OrderFunctions() {
}
$h_Lcats_kernel_OrderFunctions.prototype = $c_Lcats_kernel_OrderFunctions.prototype;
function $f_Lcats_kernel_PartialOrder__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.partialCompare__O__O__D(x, y) === 0.0);
}
function $is_Lcats_kernel_PartialOrder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_PartialOrder)));
}
function $as_Lcats_kernel_PartialOrder(obj) {
  return (($is_Lcats_kernel_PartialOrder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.PartialOrder"));
}
function $isArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_PartialOrder)));
}
function $asArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (($isArrayOf_Lcats_kernel_PartialOrder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.PartialOrder;", depth));
}
function $p_Lcats_kernel_instances_ListEq__loop$3__sci_List__sci_List__Z($thiz, xs, ys) {
  var ys$tailLocal3 = ys;
  var xs$tailLocal3 = xs;
  while (true) {
    var x21 = xs$tailLocal3;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x21)) {
      return $n(ys$tailLocal3).isEmpty__Z();
    }
    if ((x21 instanceof $c_sci_$colon$colon)) {
      var x22 = $as_sci_$colon$colon(x21);
      var x24 = $n(x22).sci_$colon$colon__f_next;
      var x$3 = $n(x22).sci_$colon$colon__f_head;
      var x17 = ys$tailLocal3;
      if ((x17 instanceof $c_sci_$colon$colon)) {
        var x18 = $as_sci_$colon$colon(x17);
        var x20 = $n(x18).sci_$colon$colon__f_next;
        var y = $n(x18).sci_$colon$colon__f_head;
        if ($n($thiz.Lcats_kernel_instances_ListEq__f_ev).eqv__O__O__Z(x$3, y)) {
          xs$tailLocal3 = x24;
          ys$tailLocal3 = x20;
          continue;
        } else {
          return false;
        }
      }
      var x$4 = $m_sci_Nil$();
      if (x$4.equals__O__Z(x17)) {
        return false;
      }
      throw new $c_s_MatchError(x17);
    }
    throw new $c_s_MatchError(x21);
  }
}
/** @constructor */
function $c_Lcats_kernel_instances_ListEq(ev) {
  this.Lcats_kernel_instances_ListEq__f_ev = null;
  this.Lcats_kernel_instances_ListEq__f_ev = ev;
}
$c_Lcats_kernel_instances_ListEq.prototype = new $h_O();
$c_Lcats_kernel_instances_ListEq.prototype.constructor = $c_Lcats_kernel_instances_ListEq;
/** @constructor */
function $h_Lcats_kernel_instances_ListEq() {
}
$h_Lcats_kernel_instances_ListEq.prototype = $c_Lcats_kernel_instances_ListEq.prototype;
$c_Lcats_kernel_instances_ListEq.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_ListEq.prototype.eqv__sci_List__sci_List__Z = (function(xs, ys) {
  return ((xs === ys) || $p_Lcats_kernel_instances_ListEq__loop$3__sci_List__sci_List__Z(this, xs, ys));
});
$c_Lcats_kernel_instances_ListEq.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_List__sci_List__Z($as_sci_List(x), $as_sci_List(y));
});
var $d_Lcats_kernel_instances_ListEq = new $TypeData().initClass($c_Lcats_kernel_instances_ListEq, "cats.kernel.instances.ListEq", ({
  Lcats_kernel_instances_ListEq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
/** @constructor */
function $c_Lcats_package$$anon$2() {
  $m_Lcats_package$();
}
$c_Lcats_package$$anon$2.prototype = new $h_O();
$c_Lcats_package$$anon$2.prototype.constructor = $c_Lcats_package$$anon$2;
/** @constructor */
function $h_Lcats_package$$anon$2() {
}
$h_Lcats_package$$anon$2.prototype = $c_Lcats_package$$anon$2.prototype;
var $d_Lcats_package$$anon$2 = new $TypeData().initClass($c_Lcats_package$$anon$2, "cats.package$$anon$2", ({
  Lcats_package$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
}));
/** @constructor */
function $c_Lcats_package$$anon$3() {
  $m_Lcats_package$();
}
$c_Lcats_package$$anon$3.prototype = new $h_O();
$c_Lcats_package$$anon$3.prototype.constructor = $c_Lcats_package$$anon$3;
/** @constructor */
function $h_Lcats_package$$anon$3() {
}
$h_Lcats_package$$anon$3.prototype = $c_Lcats_package$$anon$3.prototype;
var $d_Lcats_package$$anon$3 = new $TypeData().initClass($c_Lcats_package$$anon$3, "cats.package$$anon$3", ({
  Lcats_package$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align: 1
}));
function $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList($thiz, throwable) {
  if ((throwable instanceof $c_Lfs2_CompositeFailure)) {
    var cf = $as_Lfs2_CompositeFailure(throwable);
    var this$1 = $n(cf);
    var this$2 = $n(this$1.Lfs2_CompositeFailure__f_tail);
    var a = this$1.Lfs2_CompositeFailure__f_head;
    return this$2.prepend__O__Lcats_data_NonEmptyList(a);
  } else {
    $m_Lcats_data_NonEmptyList$();
    $m_Lcats_data_NonEmptyList$();
    var tail = $m_sci_Nil$();
    return new $c_Lcats_data_NonEmptyList(throwable, tail);
  }
}
/** @constructor */
function $c_Lfs2_CompositeFailure$() {
}
$c_Lfs2_CompositeFailure$.prototype = new $h_O();
$c_Lfs2_CompositeFailure$.prototype.constructor = $c_Lfs2_CompositeFailure$;
/** @constructor */
function $h_Lfs2_CompositeFailure$() {
}
$h_Lfs2_CompositeFailure$.prototype = $c_Lfs2_CompositeFailure$.prototype;
$c_Lfs2_CompositeFailure$.prototype.apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure = (function(first, second, rest) {
  return this.apply__jl_Throwable__Lcats_data_NonEmptyList__Lfs2_CompositeFailure(first, ($m_Lcats_data_NonEmptyList$(), new $c_Lcats_data_NonEmptyList(second, rest)));
});
$c_Lfs2_CompositeFailure$.prototype.apply__jl_Throwable__Lcats_data_NonEmptyList__Lfs2_CompositeFailure = (function(first, rest) {
  if ((first instanceof $c_Lfs2_CompositeFailure)) {
    var cf = $as_Lfs2_CompositeFailure(first);
    var this$2 = $n(rest);
    var f = ((throwable) => {
      var throwable$1 = $as_jl_Throwable(throwable);
      return $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList(this, throwable$1);
    });
    var x0 = this$2.Lcats_data_NonEmptyList__f_head;
    var this$7 = $n($as_Lcats_data_NonEmptyList(f(x0)));
    var this$3 = $n(this$2.Lcats_data_NonEmptyList__f_tail);
    var rest$1 = this$3;
    var h = null;
    var t = null;
    while ((rest$1 !== $m_sci_Nil$())) {
      var x0$1 = $n(rest$1).head__O();
      var this$4 = $n($as_Lcats_data_NonEmptyList(f(x0$1)));
      var this$5 = $n(this$4.Lcats_data_NonEmptyList__f_tail);
      var elem = this$4.Lcats_data_NonEmptyList__f_head;
      var this$6 = new $c_sci_$colon$colon(elem, this$5);
      var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$6);
      while (it.hasNext__Z()) {
        var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx;
        } else {
          $n(t).sci_$colon$colon__f_next = nx;
        }
        t = nx;
      }
      rest$1 = $as_sci_List($n(rest$1).tail__O());
    }
    var l = ((h === null) ? $m_sci_Nil$() : h);
    var this$8 = $n(this$7.concat__sci_List__Lcats_data_NonEmptyList(l));
    var other = $n(cf).Lfs2_CompositeFailure__f_tail;
    var tail = $n(other).concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList(this$8);
    return new $c_Lfs2_CompositeFailure($n(cf).Lfs2_CompositeFailure__f_head, tail);
  } else {
    var this$9 = $n(rest);
    var f$1 = ((throwable$2) => {
      var throwable$3 = $as_jl_Throwable(throwable$2);
      return $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList(this, throwable$3);
    });
    var x0$2 = this$9.Lcats_data_NonEmptyList__f_head;
    var this$14 = $n($as_Lcats_data_NonEmptyList(f$1(x0$2)));
    var this$10 = $n(this$9.Lcats_data_NonEmptyList__f_tail);
    var rest$2 = this$10;
    var h$1 = null;
    var t$1 = null;
    while ((rest$2 !== $m_sci_Nil$())) {
      var x0$3 = $n(rest$2).head__O();
      var this$11 = $n($as_Lcats_data_NonEmptyList(f$1(x0$3)));
      var this$12 = $n(this$11.Lcats_data_NonEmptyList__f_tail);
      var elem$1 = this$11.Lcats_data_NonEmptyList__f_head;
      var this$13 = new $c_sci_$colon$colon(elem$1, this$12);
      var it$1 = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$13);
      while (it$1.hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon(it$1.next__O(), $m_sci_Nil$());
        if ((t$1 === null)) {
          h$1 = nx$1;
        } else {
          $n(t$1).sci_$colon$colon__f_next = nx$1;
        }
        t$1 = nx$1;
      }
      rest$2 = $as_sci_List($n(rest$2).tail__O());
    }
    var l$1 = ((h$1 === null) ? $m_sci_Nil$() : h$1);
    return new $c_Lfs2_CompositeFailure(first, this$14.concat__sci_List__Lcats_data_NonEmptyList(l$1));
  }
});
$c_Lfs2_CompositeFailure$.prototype.fromList__sci_List__s_Option = (function(errors) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(errors)) {
    return $m_s_None$();
  }
  if ((errors instanceof $c_sci_$colon$colon)) {
    var x26 = $as_sci_$colon$colon(errors);
    var x27 = $as_jl_Throwable($n(x26).sci_$colon$colon__f_head);
    var x28 = $n(x26).sci_$colon$colon__f_next;
    var x$3 = $m_sci_Nil$();
    if (x$3.equals__O__Z(x28)) {
      return new $c_s_Some(x27);
    }
    if ((x28 instanceof $c_sci_$colon$colon)) {
      var x23 = $as_sci_$colon$colon(x28);
      var x25 = $n(x23).sci_$colon$colon__f_next;
      var second = $as_jl_Throwable($n(x23).sci_$colon$colon__f_head);
      var value = this.apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x27, second, x25);
      return new $c_s_Some(value);
    }
  }
  throw new $c_s_MatchError(errors);
});
$c_Lfs2_CompositeFailure$.prototype.fromResults__s_util_Either__s_util_Either__s_util_Either = (function(first, second) {
  if ((first instanceof $c_s_util_Right)) {
    return second;
  }
  if ((first instanceof $c_s_util_Left)) {
    var err = $as_jl_Throwable($n($as_s_util_Left(first)).s_util_Left__f_value);
    var this$1 = $n(second);
    if ((this$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$1);
      var b = $n(x2).s_util_Right__f_value;
      $as_jl_Void(b);
      var value = err;
    } else {
      if ((!(this$1 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(this$1);
      }
      var x3 = $as_s_util_Left(this$1);
      var a = $n(x3).s_util_Left__f_value;
      var err1 = $as_jl_Throwable(a);
      var value = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(err, err1, $m_sci_Nil$());
    }
    return new $c_s_util_Left(value);
  }
  throw new $c_s_MatchError(first);
});
var $d_Lfs2_CompositeFailure$ = new $TypeData().initClass($c_Lfs2_CompositeFailure$, "fs2.CompositeFailure$", ({
  Lfs2_CompositeFailure$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lfs2_CompositeFailure$;
function $m_Lfs2_CompositeFailure$() {
  if ((!$n_Lfs2_CompositeFailure$)) {
    $n_Lfs2_CompositeFailure$ = new $c_Lfs2_CompositeFailure$();
  }
  return $n_Lfs2_CompositeFailure$;
}
/** @constructor */
function $c_Lfs2_Pull$Action() {
}
$c_Lfs2_Pull$Action.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Action.prototype.constructor = $c_Lfs2_Pull$Action;
/** @constructor */
function $h_Lfs2_Pull$Action() {
}
$h_Lfs2_Pull$Action.prototype = $c_Lfs2_Pull$Action.prototype;
function $as_Lfs2_Pull$Action(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Action) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Action"));
}
function $isArrayOf_Lfs2_Pull$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Action)));
}
function $asArrayOf_Lfs2_Pull$Action(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Action;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$IdContP$() {
}
$c_Lfs2_Pull$IdContP$.prototype = new $h_O();
$c_Lfs2_Pull$IdContP$.prototype.constructor = $c_Lfs2_Pull$IdContP$;
/** @constructor */
function $h_Lfs2_Pull$IdContP$() {
}
$h_Lfs2_Pull$IdContP$.prototype = $c_Lfs2_Pull$IdContP$.prototype;
$c_Lfs2_Pull$IdContP$.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lfs2_Pull$IdContP$.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Lfs2_Pull$IdContP$.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lfs2_Pull$IdContP$.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return r;
});
$c_Lfs2_Pull$IdContP$.prototype.apply__O__O = (function(v1) {
  var r = $as_Lfs2_Pull$Terminal(v1);
  return r;
});
$c_Lfs2_Pull$IdContP$.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  $as_Lfs2_Pull$Terminal(v1);
});
var $d_Lfs2_Pull$IdContP$ = new $TypeData().initClass($c_Lfs2_Pull$IdContP$, "fs2.Pull$IdContP$", ({
  Lfs2_Pull$IdContP$: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
var $n_Lfs2_Pull$IdContP$;
function $m_Lfs2_Pull$IdContP$() {
  if ((!$n_Lfs2_Pull$IdContP$)) {
    $n_Lfs2_Pull$IdContP$ = new $c_Lfs2_Pull$IdContP$();
  }
  return $n_Lfs2_Pull$IdContP$;
}
/** @constructor */
function $c_Lfs2_Pull$IdOps$$anon$10(evidence$1$2) {
  this.Lfs2_Pull$IdOps$$anon$10__f_evidence$1$1 = null;
  this.Lfs2_Pull$IdOps$$anon$10__f_evidence$1$1 = evidence$1$2;
}
$c_Lfs2_Pull$IdOps$$anon$10.prototype = new $h_O();
$c_Lfs2_Pull$IdOps$$anon$10.prototype.constructor = $c_Lfs2_Pull$IdOps$$anon$10;
/** @constructor */
function $h_Lfs2_Pull$IdOps$$anon$10() {
}
$h_Lfs2_Pull$IdOps$$anon$10.prototype = $c_Lfs2_Pull$IdOps$$anon$10.prototype;
$c_Lfs2_Pull$IdOps$$anon$10.prototype.apply__O__O = (function(a) {
  var F = this.Lfs2_Pull$IdOps$$anon$10__f_evidence$1$1;
  return $n(F).pure__O__O(a);
});
var $d_Lfs2_Pull$IdOps$$anon$10 = new $TypeData().initClass($c_Lfs2_Pull$IdOps$$anon$10, "fs2.Pull$IdOps$$anon$10", ({
  Lfs2_Pull$IdOps$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
/** @constructor */
function $c_Lfs2_Pull$StepLegRunR$1(scope$38, extendedTopLevelScope$36, translation$tailLocal1$39, runner$tailLocal1$36, F$52, extendLastTopLevelScope$39, contP$42, TheBuildR$lzy1$42, outer, view) {
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_F$17 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
  this.Lfs2_Pull$StepLegRunR$1__f_scope$11 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_F$19 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10 = false;
  this.Lfs2_Pull$StepLegRunR$1__f_contP$12 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_view = null;
  this.Lfs2_Pull$StepLegRunR$1__f_scope$11 = scope$38;
  this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9 = extendedTopLevelScope$36;
  this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9 = translation$tailLocal1$39;
  this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9 = runner$tailLocal1$36;
  this.Lfs2_Pull$StepLegRunR$1__f_F$19 = F$52;
  this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10 = extendLastTopLevelScope$39;
  this.Lfs2_Pull$StepLegRunR$1__f_contP$12 = contP$42;
  this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12 = TheBuildR$lzy1$42;
  this.Lfs2_Pull$StepLegRunR$1__f_view = view;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$StepRunR$1__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__F1__(this, extendedTopLevelScope$36, translation$tailLocal1$39, runner$tailLocal1$36, scope$38, F$52, extendLastTopLevelScope$39, contP$42, TheBuildR$lzy1$42, view);
}
$c_Lfs2_Pull$StepLegRunR$1.prototype = new $h_Lfs2_Pull$StepRunR$1();
$c_Lfs2_Pull$StepLegRunR$1.prototype.constructor = $c_Lfs2_Pull$StepLegRunR$1;
/** @constructor */
function $h_Lfs2_Pull$StepLegRunR$1() {
}
$h_Lfs2_Pull$StepLegRunR$1.prototype = $c_Lfs2_Pull$StepLegRunR$1.prototype;
$c_Lfs2_Pull$StepLegRunR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$StepLegRunR$1__f_F$19, this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9, this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10, this.Lfs2_Pull$StepLegRunR$1__f_contP$12, this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12, this.Lfs2_Pull$StepLegRunR$1__f_scope$11, this.Lfs2_Pull$StepLegRunR$1__f_view, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var value = new $c_Lfs2_Stream$StepLeg(head, $n(outScope).Lfs2_internal_Scope__f_id, tail);
    var r = new $c_s_Some(value);
    var result = new $c_Lfs2_Pull$Succeeded(r);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$StepLegRunR$1__f_F$19, this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10, this.Lfs2_Pull$StepLegRunR$1__f_contP$12, this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12, this.Lfs2_Pull$StepLegRunR$1__f_scope$11, this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9, this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9, $as_Lfs2_Pull($n(this.Lfs2_Pull$StepLegRunR$1__f_view).apply__O__O(result)));
  })));
});
var $d_Lfs2_Pull$StepLegRunR$1 = new $TypeData().initClass($c_Lfs2_Pull$StepLegRunR$1, "fs2.Pull$StepLegRunR$1", ({
  Lfs2_Pull$StepLegRunR$1: 1,
  Lfs2_Pull$StepRunR$1: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Terminal() {
}
$c_Lfs2_Pull$Terminal.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Terminal.prototype.constructor = $c_Lfs2_Pull$Terminal;
/** @constructor */
function $h_Lfs2_Pull$Terminal() {
}
$h_Lfs2_Pull$Terminal.prototype = $c_Lfs2_Pull$Terminal.prototype;
function $as_Lfs2_Pull$Terminal(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Terminal) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Terminal"));
}
function $isArrayOf_Lfs2_Pull$Terminal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Terminal)));
}
function $asArrayOf_Lfs2_Pull$Terminal(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Terminal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Terminal;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$UnconsRunR$1(extendedTopLevelScope$35, translation$tailLocal1$38, runner$tailLocal1$35, scope$37, F$51, extendLastTopLevelScope$38, contP$41, TheBuildR$lzy1$41, outer, view) {
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_F$17 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_F$18 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9 = false;
  this.Lfs2_Pull$UnconsRunR$1__f_contP$11 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_view = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8 = extendedTopLevelScope$35;
  this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8 = translation$tailLocal1$38;
  this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8 = runner$tailLocal1$35;
  this.Lfs2_Pull$UnconsRunR$1__f_F$18 = F$51;
  this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9 = extendLastTopLevelScope$38;
  this.Lfs2_Pull$UnconsRunR$1__f_contP$11 = contP$41;
  this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11 = TheBuildR$lzy1$41;
  this.Lfs2_Pull$UnconsRunR$1__f_view = view;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$StepRunR$1__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__F1__(this, extendedTopLevelScope$35, translation$tailLocal1$38, runner$tailLocal1$35, scope$37, F$51, extendLastTopLevelScope$38, contP$41, TheBuildR$lzy1$41, view);
}
$c_Lfs2_Pull$UnconsRunR$1.prototype = new $h_Lfs2_Pull$StepRunR$1();
$c_Lfs2_Pull$UnconsRunR$1.prototype.constructor = $c_Lfs2_Pull$UnconsRunR$1;
/** @constructor */
function $h_Lfs2_Pull$UnconsRunR$1() {
}
$h_Lfs2_Pull$UnconsRunR$1.prototype = $c_Lfs2_Pull$UnconsRunR$1.prototype;
$c_Lfs2_Pull$UnconsRunR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Lcats_MonadError__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$UnconsRunR$1__f_F$18, this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8, this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9, this.Lfs2_Pull$UnconsRunR$1__f_contP$11, this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11, outScope, this.Lfs2_Pull$UnconsRunR$1__f_view, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var value = new $c_T2(head, tail);
    var r = new $c_s_Some(value);
    var result = new $c_Lfs2_Pull$Succeeded(r);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Lcats_MonadError__Z__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$UnconsRunR$1__f_F$18, this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9, this.Lfs2_Pull$UnconsRunR$1__f_contP$11, this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11, outScope, this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8, this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8, $as_Lfs2_Pull($n(this.Lfs2_Pull$UnconsRunR$1__f_view).apply__O__O(result)));
  })));
});
var $d_Lfs2_Pull$UnconsRunR$1 = new $TypeData().initClass($c_Lfs2_Pull$UnconsRunR$1, "fs2.Pull$UnconsRunR$1", ({
  Lfs2_Pull$UnconsRunR$1: 1,
  Lfs2_Pull$StepRunR$1: 1,
  Lfs2_Pull$Run$1: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$$anon$2(outer) {
  this.Lfs2_internal_Scope$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lfs2_internal_Scope$$anon$2__f_$outer = outer;
}
$c_Lfs2_internal_Scope$$anon$2.prototype = new $h_O();
$c_Lfs2_internal_Scope$$anon$2.prototype.constructor = $c_Lfs2_internal_Scope$$anon$2;
/** @constructor */
function $h_Lfs2_internal_Scope$$anon$2() {
}
$h_Lfs2_internal_Scope$$anon$2.prototype = $c_Lfs2_internal_Scope$$anon$2.prototype;
$c_Lfs2_internal_Scope$$anon$2.prototype.cancel__O = (function() {
  var this$1 = $n($n(this.Lfs2_internal_Scope$$anon$2__f_$outer).Lfs2_internal_Scope__f_F);
  return $n(this$1.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
});
$c_Lfs2_internal_Scope$$anon$2.prototype.join__O = (function() {
  var this$3 = $n($n(this.Lfs2_internal_Scope$$anon$2__f_$outer).Lfs2_internal_Scope__f_F);
  var this$1 = $n($n(this.Lfs2_internal_Scope$$anon$2__f_$outer).Lfs2_internal_Scope__f_F);
  var fa = $n(this$1.F__Lcats_effect_kernel_MonadCancel()).pure__O__O((void 0));
  var a = new $c_Lcats_effect_kernel_Outcome$Succeeded(fa);
  return $n(this$3.F__Lcats_effect_kernel_MonadCancel()).pure__O__O(a);
});
var $d_Lfs2_internal_Scope$$anon$2 = new $TypeData().initClass($c_Lfs2_internal_Scope$$anon$2, "fs2.internal.Scope$$anon$2", ({
  Lfs2_internal_Scope$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$State$() {
  this.Lfs2_internal_Scope$State$__f_initial_ = null;
  this.Lfs2_internal_Scope$State$__f_closed_ = null;
  $n_Lfs2_internal_Scope$State$ = this;
  var this$1 = $m_Lcats_data_Chain$();
  var resources = this$1.Lcats_data_Chain$__f_nil;
  var this$2 = $m_Lcats_data_Chain$();
  var children = this$2.Lcats_data_Chain$__f_nil;
  this.Lfs2_internal_Scope$State$__f_initial_ = new $c_Lfs2_internal_Scope$State$Open(resources, children);
  this.Lfs2_internal_Scope$State$__f_closed_ = new $c_Lfs2_internal_Scope$State$Closed();
}
$c_Lfs2_internal_Scope$State$.prototype = new $h_O();
$c_Lfs2_internal_Scope$State$.prototype.constructor = $c_Lfs2_internal_Scope$State$;
/** @constructor */
function $h_Lfs2_internal_Scope$State$() {
}
$h_Lfs2_internal_Scope$State$.prototype = $c_Lfs2_internal_Scope$State$.prototype;
var $d_Lfs2_internal_Scope$State$ = new $TypeData().initClass($c_Lfs2_internal_Scope$State$, "fs2.internal.Scope$State$", ({
  Lfs2_internal_Scope$State$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lfs2_internal_Scope$State$;
function $m_Lfs2_internal_Scope$State$() {
  if ((!$n_Lfs2_internal_Scope$State$)) {
    $n_Lfs2_internal_Scope$State$ = new $c_Lfs2_internal_Scope$State$();
  }
  return $n_Lfs2_internal_Scope$State$;
}
function $ct_Lio_circe_BiggerDecimalJsonNumber__T__($thiz, input) {
  $thiz.Lio_circe_BiggerDecimalJsonNumber__f_input = input;
  return $thiz;
}
/** @constructor */
function $c_Lio_circe_BiggerDecimalJsonNumber() {
  this.Lio_circe_BiggerDecimalJsonNumber__f_input = null;
}
$c_Lio_circe_BiggerDecimalJsonNumber.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.constructor = $c_Lio_circe_BiggerDecimalJsonNumber;
/** @constructor */
function $h_Lio_circe_BiggerDecimalJsonNumber() {
}
$h_Lio_circe_BiggerDecimalJsonNumber.prototype = $c_Lio_circe_BiggerDecimalJsonNumber.prototype;
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toLong__s_Option = (function() {
  return $n(this.Lio_circe_JsonBiggerDecimal__f_value).toLong__s_Option();
});
$c_Lio_circe_BiggerDecimalJsonNumber.prototype.toString__T = (function() {
  return this.Lio_circe_BiggerDecimalJsonNumber__f_input;
});
/** @constructor */
function $c_Lio_circe_CursorOp$() {
  this.Lio_circe_CursorOp$__f_eqCursorOp = null;
  this.Lio_circe_CursorOp$__f_eqCursorOpList = null;
  $n_Lio_circe_CursorOp$ = this;
  this.Lio_circe_CursorOp$__f_eqCursorOp = ($n($m_Lcats_package$().Lcats_package$__f_Eq), new $c_Lcats_kernel_Eq$$anon$6());
  $m_Lcats_instances_package$list$();
  var evidence$1 = this.Lio_circe_CursorOp$__f_eqCursorOp;
  this.Lio_circe_CursorOp$__f_eqCursorOpList = new $c_Lcats_kernel_instances_ListEq(evidence$1);
}
$c_Lio_circe_CursorOp$.prototype = new $h_O();
$c_Lio_circe_CursorOp$.prototype.constructor = $c_Lio_circe_CursorOp$;
/** @constructor */
function $h_Lio_circe_CursorOp$() {
}
$h_Lio_circe_CursorOp$.prototype = $c_Lio_circe_CursorOp$.prototype;
var $d_Lio_circe_CursorOp$ = new $TypeData().initClass($c_Lio_circe_CursorOp$, "io.circe.CursorOp$", ({
  Lio_circe_CursorOp$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lio_circe_CursorOp$;
function $m_Lio_circe_CursorOp$() {
  if ((!$n_Lio_circe_CursorOp$)) {
    $n_Lio_circe_CursorOp$ = new $c_Lio_circe_CursorOp$();
  }
  return $n_Lio_circe_CursorOp$;
}
/** @constructor */
function $c_Lio_circe_Decoder$$anon$13(f$18, outer) {
  this.Lio_circe_Decoder$$anon$13__f_f$5 = null;
  this.Lio_circe_Decoder$$anon$13__f_$outer = null;
  this.Lio_circe_Decoder$$anon$13__f_f$5 = f$18;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_Decoder$$anon$13__f_$outer = outer;
}
$c_Lio_circe_Decoder$$anon$13.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$13.prototype.constructor = $c_Lio_circe_Decoder$$anon$13;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$13() {
}
$h_Lio_circe_Decoder$$anon$13.prototype = $c_Lio_circe_Decoder$$anon$13.prototype;
$c_Lio_circe_Decoder$$anon$13.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c);
});
$c_Lio_circe_Decoder$$anon$13.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x109 = $n(this.Lio_circe_Decoder$$anon$13__f_$outer).tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x109 instanceof $c_s_util_Right)) {
    var a = $n($as_s_util_Right(x109)).s_util_Right__f_value;
    var x104 = $as_s_util_Either($n(this.Lio_circe_Decoder$$anon$13__f_f$5).apply__O__O(a));
    if ((x104 instanceof $c_s_util_Right)) {
      var r = $as_s_util_Right(x104);
      return r;
    }
    if ((x104 instanceof $c_s_util_Left)) {
      var message = $as_T($n($as_s_util_Left(x104)).s_util_Left__f_value);
      var value = $m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure(message, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(c).history__sci_List())));
      return new $c_s_util_Left(value);
    }
    throw new $c_s_MatchError(x104);
  }
  if ((x109 instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(x109);
    return l;
  }
  throw new $c_s_MatchError(x109);
});
var $d_Lio_circe_Decoder$$anon$13 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$13, "io.circe.Decoder$$anon$13", ({
  Lio_circe_Decoder$$anon$13: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
/** @constructor */
function $c_Lio_circe_Decoder$$anon$19() {
}
$c_Lio_circe_Decoder$$anon$19.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$19.prototype.constructor = $c_Lio_circe_Decoder$$anon$19;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$19() {
}
$h_Lio_circe_Decoder$$anon$19.prototype = $c_Lio_circe_Decoder$$anon$19.prototype;
$c_Lio_circe_Decoder$$anon$19.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_Decoder$$anon$19.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x164 = $n(c).value__Lio_circe_Json();
  if ((x164 instanceof $c_Lio_circe_Json$JString)) {
    var x$1 = $as_Lio_circe_Json$JString(x164);
    var this$2 = $n(x$1);
    var x167 = this$2.Lio_circe_Json$JString__f_value;
    return new $c_s_util_Right(x167);
  }
  var value = $m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("string", x164), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(c).history__sci_List())));
  return new $c_s_util_Left(value);
});
var $d_Lio_circe_Decoder$$anon$19 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$19, "io.circe.Decoder$$anon$19", ({
  Lio_circe_Decoder$$anon$19: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
/** @constructor */
function $c_Lio_circe_Decoder$$anon$20() {
}
$c_Lio_circe_Decoder$$anon$20.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$20.prototype.constructor = $c_Lio_circe_Decoder$$anon$20;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$20() {
}
$h_Lio_circe_Decoder$$anon$20.prototype = $c_Lio_circe_Decoder$$anon$20.prototype;
$c_Lio_circe_Decoder$$anon$20.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_Decoder$$anon$20.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x168 = $n(c).value__Lio_circe_Json();
  if ((x168 instanceof $c_Lio_circe_Json$JObject)) {
    var x$1 = $as_Lio_circe_Json$JObject(x168);
    var this$2 = $n(x$1);
    var x174 = this$2.Lio_circe_Json$JObject__f_value;
    if ($n(x174).isEmpty__Z()) {
      return new $c_s_util_Right((void 0));
    }
  }
  if ((x168 instanceof $c_Lio_circe_Json$JArray)) {
    var x$1$1 = $as_Lio_circe_Json$JArray(x168);
    var this$5 = $n(x$1$1);
    var x171 = this$5.Lio_circe_Json$JArray__f_value;
    var this$6 = $n(x171);
    if ($f_sc_SeqOps__isEmpty__Z(this$6)) {
      return new $c_s_util_Right((void 0));
    }
  }
  if ($n(x168).isNull__Z()) {
    return new $c_s_util_Right((void 0));
  }
  var value = $m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("'null' or '[]' or '{}'", x168), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(c).history__sci_List())));
  return new $c_s_util_Left(value);
});
var $d_Lio_circe_Decoder$$anon$20 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$20, "io.circe.Decoder$$anon$20", ({
  Lio_circe_Decoder$$anon$20: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
/** @constructor */
function $c_Lio_circe_Decoder$$anon$36(f$21) {
  this.Lio_circe_Decoder$$anon$36__f_f$10 = null;
  this.Lio_circe_Decoder$$anon$36__f_f$10 = f$21;
}
$c_Lio_circe_Decoder$$anon$36.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$36.prototype.constructor = $c_Lio_circe_Decoder$$anon$36;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$36() {
}
$h_Lio_circe_Decoder$$anon$36.prototype = $c_Lio_circe_Decoder$$anon$36.prototype;
$c_Lio_circe_Decoder$$anon$36.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_Decoder$$anon$36.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return $as_s_util_Either($n(this.Lio_circe_Decoder$$anon$36__f_f$10).apply__O__O(c));
});
var $d_Lio_circe_Decoder$$anon$36 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$36, "io.circe.Decoder$$anon$36", ({
  Lio_circe_Decoder$$anon$36: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
function $ct_Lio_circe_Decoder$DecoderWithFailure__T__($thiz, name) {
  $thiz.Lio_circe_Decoder$DecoderWithFailure__f_name = name;
  return $thiz;
}
/** @constructor */
function $c_Lio_circe_Decoder$DecoderWithFailure() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
}
$c_Lio_circe_Decoder$DecoderWithFailure.prototype = new $h_O();
$c_Lio_circe_Decoder$DecoderWithFailure.prototype.constructor = $c_Lio_circe_Decoder$DecoderWithFailure;
/** @constructor */
function $h_Lio_circe_Decoder$DecoderWithFailure() {
}
$h_Lio_circe_Decoder$DecoderWithFailure.prototype = $c_Lio_circe_Decoder$DecoderWithFailure.prototype;
$c_Lio_circe_Decoder$DecoderWithFailure.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_Decoder$DecoderWithFailure.prototype.fail__Lio_circe_HCursor__s_util_Either = (function(c) {
  var value = $m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure(this.Lio_circe_Decoder$DecoderWithFailure__f_name, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(c).history__sci_List())));
  return new $c_s_util_Left(value);
});
/** @constructor */
function $c_Lio_circe_Encoder$$anon$1(f$10, outer) {
  this.Lio_circe_Encoder$$anon$1__f_f$1 = null;
  this.Lio_circe_Encoder$$anon$1__f_$outer = null;
  this.Lio_circe_Encoder$$anon$1__f_f$1 = f$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_Encoder$$anon$1__f_$outer = outer;
}
$c_Lio_circe_Encoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$1.prototype.constructor = $c_Lio_circe_Encoder$$anon$1;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$1() {
}
$h_Lio_circe_Encoder$$anon$1.prototype = $c_Lio_circe_Encoder$$anon$1.prototype;
$c_Lio_circe_Encoder$$anon$1.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $n(this.Lio_circe_Encoder$$anon$1__f_$outer).apply__O__Lio_circe_Json($n(this.Lio_circe_Encoder$$anon$1__f_f$1).apply__O__O(a));
});
var $d_Lio_circe_Encoder$$anon$1 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$1, "io.circe.Encoder$$anon$1", ({
  Lio_circe_Encoder$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
/** @constructor */
function $c_Lio_circe_Encoder$$anon$14() {
}
$c_Lio_circe_Encoder$$anon$14.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$14.prototype.constructor = $c_Lio_circe_Encoder$$anon$14;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$14() {
}
$h_Lio_circe_Encoder$$anon$14.prototype = $c_Lio_circe_Encoder$$anon$14.prototype;
$c_Lio_circe_Encoder$$anon$14.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $uI(a);
  $m_Lio_circe_Json$();
  var $x_1 = $m_Lio_circe_JsonNumber$();
  var hi = (a$1 >> 31);
  return $x_1.fromLong__J__Lio_circe_Json$JNumber(a$1, hi);
});
var $d_Lio_circe_Encoder$$anon$14 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$14, "io.circe.Encoder$$anon$14", ({
  Lio_circe_Encoder$$anon$14: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
/** @constructor */
function $c_Lio_circe_Encoder$$anon$15() {
}
$c_Lio_circe_Encoder$$anon$15.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$15.prototype.constructor = $c_Lio_circe_Encoder$$anon$15;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$15() {
}
$h_Lio_circe_Encoder$$anon$15.prototype = $c_Lio_circe_Encoder$$anon$15.prototype;
$c_Lio_circe_Encoder$$anon$15.prototype.apply__O__Lio_circe_Json = (function(a) {
  var $x_1 = $uJ(a);
  var a$1_$_lo = $x_1.l;
  var a$1_$_hi = $x_1.h;
  $m_Lio_circe_Json$();
  return $m_Lio_circe_JsonNumber$().fromLong__J__Lio_circe_Json$JNumber(a$1_$_lo, a$1_$_hi);
});
var $d_Lio_circe_Encoder$$anon$15 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$15, "io.circe.Encoder$$anon$15", ({
  Lio_circe_Encoder$$anon$15: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
/** @constructor */
function $c_Lio_circe_Encoder$$anon$21(f$12) {
  this.Lio_circe_Encoder$$anon$21__f_f$3 = null;
  this.Lio_circe_Encoder$$anon$21__f_f$3 = f$12;
}
$c_Lio_circe_Encoder$$anon$21.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$21.prototype.constructor = $c_Lio_circe_Encoder$$anon$21;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$21() {
}
$h_Lio_circe_Encoder$$anon$21.prototype = $c_Lio_circe_Encoder$$anon$21.prototype;
$c_Lio_circe_Encoder$$anon$21.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $as_Lio_circe_Json($n(this.Lio_circe_Encoder$$anon$21__f_f$3).apply__O__O(a));
});
var $d_Lio_circe_Encoder$$anon$21 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$21, "io.circe.Encoder$$anon$21", ({
  Lio_circe_Encoder$$anon$21: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
/** @constructor */
function $c_Lio_circe_Encoder$$anon$3() {
}
$c_Lio_circe_Encoder$$anon$3.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$3.prototype.constructor = $c_Lio_circe_Encoder$$anon$3;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$3() {
}
$h_Lio_circe_Encoder$$anon$3.prototype = $c_Lio_circe_Encoder$$anon$3.prototype;
$c_Lio_circe_Encoder$$anon$3.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_Lio_circe_Json(a);
  return a$1;
});
var $d_Lio_circe_Encoder$$anon$3 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$3, "io.circe.Encoder$$anon$3", ({
  Lio_circe_Encoder$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
/** @constructor */
function $c_Lio_circe_Encoder$$anon$6() {
}
$c_Lio_circe_Encoder$$anon$6.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$6.prototype.constructor = $c_Lio_circe_Encoder$$anon$6;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$6() {
}
$h_Lio_circe_Encoder$$anon$6.prototype = $c_Lio_circe_Encoder$$anon$6.prototype;
$c_Lio_circe_Encoder$$anon$6.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = $as_T(a);
  return $m_Lio_circe_Json$().fromString__T__Lio_circe_Json(a$1);
});
var $d_Lio_circe_Encoder$$anon$6 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$6, "io.circe.Encoder$$anon$6", ({
  Lio_circe_Encoder$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
/** @constructor */
function $c_Lio_circe_FailedCursor(lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_FailedCursor__f_lastCursor = null;
  this.Lio_circe_FailedCursor__f_lastOp = null;
  this.Lio_circe_FailedCursor__f_lastCursor = lastCursor;
  this.Lio_circe_FailedCursor__f_lastOp = lastOp;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp);
}
$c_Lio_circe_FailedCursor.prototype = new $h_Lio_circe_ACursor();
$c_Lio_circe_FailedCursor.prototype.constructor = $c_Lio_circe_FailedCursor;
/** @constructor */
function $h_Lio_circe_FailedCursor() {
}
$h_Lio_circe_FailedCursor.prototype = $c_Lio_circe_FailedCursor.prototype;
$c_Lio_circe_FailedCursor.prototype.missingField__Z = (function() {
  var x1 = this.Lio_circe_FailedCursor__f_lastOp;
  matchAlts1: {
    matchAlts2: {
      if (false) {
        break matchAlts2;
      }
      if ((x1 instanceof $c_Lio_circe_CursorOp$DownField)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return true;
  }
  return false;
});
$c_Lio_circe_FailedCursor.prototype.succeeded__Z = (function() {
  return false;
});
$c_Lio_circe_FailedCursor.prototype.downField__T__Lio_circe_ACursor = (function(k) {
  return this;
});
$c_Lio_circe_FailedCursor.prototype.right__Lio_circe_ACursor = (function() {
  return this;
});
function $as_Lio_circe_FailedCursor(obj) {
  return (((obj instanceof $c_Lio_circe_FailedCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.FailedCursor"));
}
function $isArrayOf_Lio_circe_FailedCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_FailedCursor)));
}
function $asArrayOf_Lio_circe_FailedCursor(obj, depth) {
  return (($isArrayOf_Lio_circe_FailedCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.FailedCursor;", depth));
}
var $d_Lio_circe_FailedCursor = new $TypeData().initClass($c_Lio_circe_FailedCursor, "io.circe.FailedCursor", ({
  Lio_circe_FailedCursor: 1,
  Lio_circe_ACursor: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_HCursor() {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
}
$c_Lio_circe_HCursor.prototype = new $h_Lio_circe_ACursor();
$c_Lio_circe_HCursor.prototype.constructor = $c_Lio_circe_HCursor;
/** @constructor */
function $h_Lio_circe_HCursor() {
}
$h_Lio_circe_HCursor.prototype = $c_Lio_circe_HCursor.prototype;
$c_Lio_circe_HCursor.prototype.succeeded__Z = (function() {
  return true;
});
$c_Lio_circe_HCursor.prototype.downField__T__Lio_circe_ACursor = (function(k) {
  var x15 = this.value__Lio_circe_Json();
  if ((x15 instanceof $c_Lio_circe_Json$JObject)) {
    var x$1 = $as_Lio_circe_Json$JObject(x15);
    var this$2 = $n(x$1);
    var x18 = this$2.Lio_circe_Json$JObject__f_value;
    if ((!$n(x18).contains__T__Z(k))) {
      var op = new $c_Lio_circe_CursorOp$DownField(k);
      return new $c_Lio_circe_FailedCursor(this, op);
    } else {
      return new $c_Lio_circe_cursor_ObjectCursor(x18, k, this, false, this, new $c_Lio_circe_CursorOp$DownField(k));
    }
  }
  var op$1 = new $c_Lio_circe_CursorOp$DownField(k);
  return new $c_Lio_circe_FailedCursor(this, op$1);
});
function $as_Lio_circe_HCursor(obj) {
  return (((obj instanceof $c_Lio_circe_HCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.HCursor"));
}
function $isArrayOf_Lio_circe_HCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_HCursor)));
}
function $asArrayOf_Lio_circe_HCursor(obj, depth) {
  return (($isArrayOf_Lio_circe_HCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.HCursor;", depth));
}
function $p_Lio_circe_Json$__arrayEq__sci_Vector__sci_Vector__Z($thiz, x, y) {
  if (($n(x).length__I() !== $n(y).length__I())) {
    return false;
  }
  var it0 = $n(x).iterator__sc_Iterator();
  var it1 = $n(y).iterator__sc_Iterator();
  while ($n(it0).hasNext__Z()) {
    if ($n($m_Lio_circe_Json$().Lio_circe_Json$__f_eqJson).neqv__O__O__Z($n(it0).next__O(), $n(it1).next__O())) {
      return false;
    }
  }
  return true;
}
/** @constructor */
function $c_Lio_circe_Json$() {
  this.Lio_circe_Json$__f_Null = null;
  this.Lio_circe_Json$__f_True = null;
  this.Lio_circe_Json$__f_False = null;
  this.Lio_circe_Json$__f_EmptyArray = null;
  this.Lio_circe_Json$__f_EmptyString = null;
  this.Lio_circe_Json$__f_eqJson = null;
  this.Lio_circe_Json$__f_showJson = null;
  $n_Lio_circe_Json$ = this;
  this.Lio_circe_Json$__f_Null = $m_Lio_circe_Json$JNull$();
  this.Lio_circe_Json$__f_True = new $c_Lio_circe_Json$JBoolean(true);
  this.Lio_circe_Json$__f_False = new $c_Lio_circe_Json$JBoolean(false);
  $m_sci_Vector$();
  var value = $m_sci_Vector0$();
  this.Lio_circe_Json$__f_EmptyArray = new $c_Lio_circe_Json$JArray(value);
  this.Lio_circe_Json$__f_EmptyString = new $c_Lio_circe_Json$JString("");
  $n($m_Lcats_package$().Lcats_package$__f_Eq);
  var f = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
    var x$1$1 = $as_Lio_circe_Json(x$1);
    var x$2$1 = $as_Lio_circe_Json(x$2);
    if ((x$1$1 instanceof $c_Lio_circe_Json$JObject)) {
      var x$1$2 = $as_Lio_circe_Json$JObject(x$1$1);
      var this$9 = $n(x$1$2);
      var x146 = this$9.Lio_circe_Json$JObject__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JObject)) {
        var x$1$3 = $as_Lio_circe_Json$JObject(x$2$1);
        var this$11 = $n(x$1$3);
        var x143 = this$11.Lio_circe_Json$JObject__f_value;
        return $n($m_Lio_circe_JsonObject$().Lio_circe_JsonObject$__f_eqJsonObject).eqv__O__O__Z(x146, x143);
      }
    }
    if ((x$1$1 instanceof $c_Lio_circe_Json$JString)) {
      var x$1$4 = $as_Lio_circe_Json$JString(x$1$1);
      var this$13 = $n(x$1$4);
      var x138 = this$13.Lio_circe_Json$JString__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JString)) {
        var x$1$5 = $as_Lio_circe_Json$JString(x$2$1);
        var this$15 = $n(x$1$5);
        var x135 = this$15.Lio_circe_Json$JString__f_value;
        return (x138 === x135);
      }
    }
    if ((x$1$1 instanceof $c_Lio_circe_Json$JNumber)) {
      var x$1$6 = $as_Lio_circe_Json$JNumber(x$1$1);
      var this$17 = $n(x$1$6);
      var x130 = this$17.Lio_circe_Json$JNumber__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JNumber)) {
        var x$1$7 = $as_Lio_circe_Json$JNumber(x$2$1);
        var this$19 = $n(x$1$7);
        var x127 = this$19.Lio_circe_Json$JNumber__f_value;
        return $n($m_Lio_circe_JsonNumber$().Lio_circe_JsonNumber$__f_eqJsonNumber).eqv__O__O__Z(x130, x127);
      }
    }
    if ((x$1$1 instanceof $c_Lio_circe_Json$JBoolean)) {
      var x$1$8 = $as_Lio_circe_Json$JBoolean(x$1$1);
      var this$21 = $n(x$1$8);
      var x122 = this$21.Lio_circe_Json$JBoolean__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JBoolean)) {
        var x$1$9 = $as_Lio_circe_Json$JBoolean(x$2$1);
        var this$23 = $n(x$1$9);
        var x119 = this$23.Lio_circe_Json$JBoolean__f_value;
        return (x122 === x119);
      }
    }
    if ((x$1$1 instanceof $c_Lio_circe_Json$JArray)) {
      var x$1$10 = $as_Lio_circe_Json$JArray(x$1$1);
      var this$25 = $n(x$1$10);
      var x114 = this$25.Lio_circe_Json$JArray__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_Json$JArray)) {
        var x$1$11 = $as_Lio_circe_Json$JArray(x$2$1);
        var this$27 = $n(x$1$11);
        var x111 = this$27.Lio_circe_Json$JArray__f_value;
        return $p_Lio_circe_Json$__arrayEq__sci_Vector__sci_Vector__Z(this, x114, x111);
      }
    }
    return ($n(x$1$1).isNull__Z() && $n(x$2$1).isNull__Z());
  }));
  this.Lio_circe_Json$__f_eqJson = new $c_Lcats_kernel_Eq$$anon$5(f);
  this.Lio_circe_Json$__f_showJson = new $c_Lcats_Show$$anon$5();
}
$c_Lio_circe_Json$.prototype = new $h_O();
$c_Lio_circe_Json$.prototype.constructor = $c_Lio_circe_Json$;
/** @constructor */
function $h_Lio_circe_Json$() {
}
$h_Lio_circe_Json$.prototype = $c_Lio_circe_Json$.prototype;
$c_Lio_circe_Json$.prototype.fromFields__sc_Iterable__Lio_circe_Json = (function(fields) {
  var value = $m_Lio_circe_JsonObject$().fromIterable__sc_Iterable__Lio_circe_JsonObject(fields);
  return new $c_Lio_circe_Json$JObject(value);
});
$c_Lio_circe_Json$.prototype.fromValues__sc_Iterable__Lio_circe_Json = (function(values) {
  if ($n(values).isEmpty__Z()) {
    return this.Lio_circe_Json$__f_EmptyArray;
  } else {
    var value = $n(values).toVector__sci_Vector();
    return new $c_Lio_circe_Json$JArray(value);
  }
});
$c_Lio_circe_Json$.prototype.fromString__T__Lio_circe_Json = (function(value) {
  var this$1 = $n(value);
  if ((this$1 === "")) {
    return this.Lio_circe_Json$__f_EmptyString;
  } else {
    return new $c_Lio_circe_Json$JString(value);
  }
});
$c_Lio_circe_Json$.prototype.fromDoubleOrNull__D__Lio_circe_Json = (function(value) {
  if (((value === value) && (!((value === Infinity) || (value === (-Infinity)))))) {
    var value$1 = new $c_Lio_circe_JsonDouble(value);
    return new $c_Lio_circe_Json$JNumber(value$1);
  } else {
    return this.Lio_circe_Json$__f_Null;
  }
});
var $d_Lio_circe_Json$ = new $TypeData().initClass($c_Lio_circe_Json$, "io.circe.Json$", ({
  Lio_circe_Json$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lio_circe_Json$;
function $m_Lio_circe_Json$() {
  if ((!$n_Lio_circe_Json$)) {
    $n_Lio_circe_Json$ = new $c_Lio_circe_Json$();
  }
  return $n_Lio_circe_Json$;
}
/** @constructor */
function $c_Lio_circe_JsonNumber$() {
  this.Lio_circe_JsonNumber$__f_jsonLongConstantPool = null;
  this.Lio_circe_JsonNumber$__f_bigDecimalMinLong = null;
  this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong = null;
  this.Lio_circe_JsonNumber$__f_eqJsonNumber = null;
  $n_Lio_circe_JsonNumber$ = this;
  var array = new ($d_Lio_circe_Json$JNumber.getArrayOf().constr)(256);
  var i = 0;
  while ((i < 256)) {
    var $x_1 = i;
    var x0 = i;
    var value = ((x0 - 128) | 0);
    var hi = (value >> 31);
    var value$1 = new $c_Lio_circe_JsonLong(value, hi);
    array.set($x_1, new $c_Lio_circe_Json$JNumber(value$1));
    i = ((1 + i) | 0);
  }
  this.Lio_circe_JsonNumber$__f_jsonLongConstantPool = array;
  this.Lio_circe_JsonNumber$__f_bigDecimalMinLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648));
  this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), (-1), 2147483647);
  var f = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
    var x$1$1 = $as_Lio_circe_JsonNumber(x$1);
    var x$2$1 = $as_Lio_circe_JsonNumber(x$2);
    if ((x$1$1 instanceof $c_Lio_circe_JsonLong)) {
      var x$1$2 = $as_Lio_circe_JsonLong(x$1$1);
      var this$9 = $n(x$1$2);
      var x58_$_lo = this$9.Lio_circe_JsonLong__f_value_$lo;
      var x58_$_hi = this$9.Lio_circe_JsonLong__f_value_$hi;
      if ((x$2$1 instanceof $c_Lio_circe_JsonLong)) {
        var x$1$3 = $as_Lio_circe_JsonLong(x$2$1);
        var this$11 = $n(x$1$3);
        var x55_$_lo = this$11.Lio_circe_JsonLong__f_value_$lo;
        var x55_$_hi = this$11.Lio_circe_JsonLong__f_value_$hi;
        return (((x58_$_lo ^ x55_$_lo) | (x58_$_hi ^ x55_$_hi)) === 0);
      }
    }
    if ((x$1$1 instanceof $c_Lio_circe_JsonDouble)) {
      var x$1$4 = $as_Lio_circe_JsonDouble(x$1$1);
      var this$14 = $n(x$1$4);
      var x50 = this$14.Lio_circe_JsonDouble__f_value;
      if ((x$2$1 instanceof $c_Lio_circe_JsonDouble)) {
        var x$1$5 = $as_Lio_circe_JsonDouble(x$2$1);
        var this$16 = $n(x$1$5);
        var x47 = this$16.Lio_circe_JsonDouble__f_value;
        return ($m_jl_Double$().compare__D__D__I(x50, x47) === 0);
      }
    }
    if (false) {
      var x$1$6 = $as_Lio_circe_JsonFloat(x$1$1);
      var this$18 = $n(x$1$6);
      var x42 = this$18.Lio_circe_JsonFloat__f_value;
      if (false) {
        var x$1$7 = $as_Lio_circe_JsonFloat(x$2$1);
        var this$20 = $n(x$1$7);
        var x39 = this$20.Lio_circe_JsonFloat__f_value;
        return ($m_jl_Double$().compare__D__D__I(x42, x39) === 0);
      }
    }
    if (false) {
      var x$1$8 = $as_Lio_circe_JsonBigDecimal(x$1$1);
      var this$23 = $n(x$1$8);
      var x34 = this$23.Lio_circe_JsonBigDecimal__f_value;
      if (false) {
        var x$1$9 = $as_Lio_circe_JsonBigDecimal(x$2$1);
        var this$25 = $n(x$1$9);
        var x31 = this$25.Lio_circe_JsonBigDecimal__f_value;
        return ($n(x34).compareTo__Ljava_math_BigDecimal__I(x31) === 0);
      }
    }
    var x$6 = $n(x$1$1).toBiggerDecimal__Lio_circe_numbers_BiggerDecimal();
    var x$7 = $n(x$2$1).toBiggerDecimal__Lio_circe_numbers_BiggerDecimal();
    return ((x$6 === null) ? (x$7 === null) : $n(x$6).equals__O__Z(x$7));
  }));
  this.Lio_circe_JsonNumber$__f_eqJsonNumber = new $c_Lcats_kernel_Eq$$anon$5(f);
}
$c_Lio_circe_JsonNumber$.prototype = new $h_O();
$c_Lio_circe_JsonNumber$.prototype.constructor = $c_Lio_circe_JsonNumber$;
/** @constructor */
function $h_Lio_circe_JsonNumber$() {
}
$h_Lio_circe_JsonNumber$.prototype = $c_Lio_circe_JsonNumber$.prototype;
$c_Lio_circe_JsonNumber$.prototype.fromLong__J__Lio_circe_Json$JNumber = (function(value_$_lo, value_$_hi) {
  var lo = ((128 + value_$_lo) | 0);
  var hi = ((value_$_hi + (((value_$_lo & (~lo)) >>> 31) | 0)) | 0);
  if ((hi >= 0)) {
    var value$1 = $n(this.Lio_circe_JsonNumber$__f_jsonLongConstantPool).u.length;
    var hi$1 = (value$1 >> 31);
    var $x_1 = ((hi === hi$1) ? ((lo >>> 0) < (value$1 >>> 0)) : (hi < hi$1));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $n(this.Lio_circe_JsonNumber$__f_jsonLongConstantPool).get(lo);
  } else {
    var value$2 = new $c_Lio_circe_JsonLong(value_$_lo, value_$_hi);
    return new $c_Lio_circe_Json$JNumber(value$2);
  }
});
$c_Lio_circe_JsonNumber$.prototype.fromString__T__s_Option = (function(value) {
  var result = $m_Lio_circe_numbers_BiggerDecimal$().parseBiggerDecimalUnsafe__T__Lio_circe_numbers_BiggerDecimal(value);
  if ((result === null)) {
    return $m_s_None$();
  } else {
    var value$1 = new $c_Lio_circe_JsonBiggerDecimal(result, value);
    return new $c_s_Some(value$1);
  }
});
$c_Lio_circe_JsonNumber$.prototype.bigDecimalIsWhole__Ljava_math_BigDecimal__Z = (function(value) {
  if (($n(value).signum__I() === 0)) {
    var $x_1 = true;
  } else {
    var this$1 = $n(value);
    var $x_1 = (this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0);
  }
  if ($x_1) {
    return true;
  } else {
    var this$2 = $n($n(value).stripTrailingZeros__Ljava_math_BigDecimal());
    return (this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0);
  }
});
$c_Lio_circe_JsonNumber$.prototype.bigDecimalIsValidLong__Ljava_math_BigDecimal__Z = (function(value) {
  return ((this.bigDecimalIsWhole__Ljava_math_BigDecimal__Z(value) && ($n(value).compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsonNumber$__f_bigDecimalMinLong) >= 0)) && ($n(value).compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong) <= 0));
});
var $d_Lio_circe_JsonNumber$ = new $TypeData().initClass($c_Lio_circe_JsonNumber$, "io.circe.JsonNumber$", ({
  Lio_circe_JsonNumber$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lio_circe_JsonNumber$;
function $m_Lio_circe_JsonNumber$() {
  if ((!$n_Lio_circe_JsonNumber$)) {
    $n_Lio_circe_JsonNumber$ = new $c_Lio_circe_JsonNumber$();
  }
  return $n_Lio_circe_JsonNumber$;
}
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject(fields) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields = null;
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields = fields;
}
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype = new $h_Lio_circe_JsonObject();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject() {
}
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.applyUnsafe__T__Lio_circe_Json = (function(key) {
  var this$1 = $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields);
  return $as_Lio_circe_Json($p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, key, null));
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.size__I = (function() {
  return $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields).ju_HashMap__f_contentSize;
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.contains__T__Z = (function(k) {
  return $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields).containsKey__O__Z(k);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.isEmpty__Z = (function() {
  return $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields).isEmpty__Z();
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.toIterable__sc_Iterable = (function() {
  return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.appendToFolder__Lio_circe_Printer$PrintingFolder__V = (function(folder) {
  var originalDepth = $n(folder).Lio_circe_Printer$PrintingFolder__f_depth;
  var p = $n($n(folder).Lio_circe_Printer$PrintingFolder__f_pieces).apply__I__Lio_circe_Printer$Pieces($n(folder).Lio_circe_Printer$PrintingFolder__f_depth);
  var first = true;
  if ($n(folder).Lio_circe_Printer$PrintingFolder__f_sortKeys) {
    var this$1 = new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this);
    var this$2 = $n($m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$1));
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
      var _$4$1 = $as_T2(_$4);
      return $as_T($n(_$4$1)._1__O());
    }));
    var ord = $m_s_math_Ordering$String$();
    var iterable = $as_sc_Iterable($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$2, f, ord));
  } else {
    var iterable = new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this);
  }
  var iterator = $n(iterable).iterator__sc_Iterator();
  $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_lBraces);
  while ($n(iterator).hasNext__Z()) {
    var next = $as_T2($n(iterator).next__O());
    var key = $as_T($n(next)._1__O());
    var value = $as_Lio_circe_Json($n(next)._2__O());
    if (((!$n(folder).Lio_circe_Printer$PrintingFolder__f_dropNullValues) || (!$n(value).isNull__Z()))) {
      if ((!first)) {
        $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_objectCommas);
      }
      $n(folder).onString__T__V(key);
      $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_colons);
      $n(folder).Lio_circe_Printer$PrintingFolder__f_depth = ((1 + $n(folder).Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      $n(value).foldWith__Lio_circe_Json$Folder__O(folder);
      $n(folder).Lio_circe_Printer$PrintingFolder__f_depth = originalDepth;
      first = false;
    }
  }
  $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_rBraces);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.equalsJsonObject__Lio_circe_JsonObject__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_JsonObject$LinkedHashMapJsonObject)) {
    var that$2 = $as_Lio_circe_JsonObject$LinkedHashMapJsonObject(that);
    if ((this.size__I() !== $n(that$2).size__I())) {
      return false;
    }
    var this$1 = $n(this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields);
    var iterator = new $c_ju_HashMap$EntrySet(this$1).iterator__ju_Iterator();
    while ($n(iterator).hasNext__Z()) {
      var entry = $as_ju_Map$Entry($n(iterator).next__O());
      var $x_1 = $n(that$2);
      var this$2 = $n(entry);
      var x = $x_1.applyUnsafe__T__Lio_circe_Json($as_T(this$2.ju_HashMap$Node__f_key));
      var this$3 = $n(entry);
      var x$2 = this$3.ju_HashMap$Node__f_value;
      if ((!((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)))) {
        return false;
      }
    }
    return true;
  }
  if ((that instanceof $c_Lio_circe_JsonObject$MapAndVectorJsonObject)) {
    var that$3 = $as_Lio_circe_JsonObject$MapAndVectorJsonObject(that);
    return ((this.size__I() === $n(that$3).size__I()) && $n($n(that$3).Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var k = $as_T($n(x$1$1)._1__O());
        var v = $as_Lio_circe_Json($n(x$1$1)._2__O());
        var x$2$1 = this.applyUnsafe__T__Lio_circe_Json(k);
        return ((v === null) ? (x$2$1 === null) : $n(v).equals__O__Z(x$2$1));
      }
      throw new $c_s_MatchError(x$1$1);
    }))));
  }
  throw new $c_s_MatchError(that);
});
function $as_Lio_circe_JsonObject$LinkedHashMapJsonObject(obj) {
  return (((obj instanceof $c_Lio_circe_JsonObject$LinkedHashMapJsonObject) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonObject$LinkedHashMapJsonObject"));
}
function $isArrayOf_Lio_circe_JsonObject$LinkedHashMapJsonObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonObject$LinkedHashMapJsonObject)));
}
function $asArrayOf_Lio_circe_JsonObject$LinkedHashMapJsonObject(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonObject$LinkedHashMapJsonObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonObject$LinkedHashMapJsonObject;", depth));
}
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject = new $TypeData().initClass($c_Lio_circe_JsonObject$LinkedHashMapJsonObject, "io.circe.JsonObject$LinkedHashMapJsonObject", ({
  Lio_circe_JsonObject$LinkedHashMapJsonObject: 1,
  Lio_circe_JsonObject: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_JsonObject$MapAndVectorJsonObject(fields, orderedKeys) {
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields = null;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys = null;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields = fields;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys = orderedKeys;
}
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype = new $h_Lio_circe_JsonObject();
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.constructor = $c_Lio_circe_JsonObject$MapAndVectorJsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject$MapAndVectorJsonObject() {
}
$h_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype = $c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype;
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.applyUnsafe__T__Lio_circe_Json = (function(key) {
  return $as_Lio_circe_Json($n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).apply__O__O(key));
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.size__I = (function() {
  return $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).size__I();
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.contains__T__Z = (function(key) {
  return $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).contains__O__Z(key);
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.isEmpty__Z = (function() {
  return $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).isEmpty__Z();
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.toIterable__sc_Iterable = (function() {
  return $as_sc_Iterable($n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((key) => {
    var key$1 = $as_T(key);
    var _2 = $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).apply__O__O(key$1);
    return new $c_T2(key$1, _2);
  }))));
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.appendToFolder__Lio_circe_Printer$PrintingFolder__V = (function(folder) {
  var originalDepth = $n(folder).Lio_circe_Printer$PrintingFolder__f_depth;
  var p = $n($n(folder).Lio_circe_Printer$PrintingFolder__f_pieces).apply__I__Lio_circe_Printer$Pieces($n(folder).Lio_circe_Printer$PrintingFolder__f_depth);
  var first = true;
  if ($n(folder).Lio_circe_Printer$PrintingFolder__f_sortKeys) {
    var this$1 = $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys);
    var ord = $m_s_math_Ordering$String$();
    var keyIterator = $n($as_sci_Vector($f_sc_SeqOps__sorted__s_math_Ordering__O(this$1, ord))).iterator__sc_Iterator();
  } else {
    var keyIterator = $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys).iterator__sc_Iterator();
  }
  $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_lBraces);
  while ($n(keyIterator).hasNext__Z()) {
    var key = $as_T($n(keyIterator).next__O());
    var value = $as_Lio_circe_Json($n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).apply__O__O(key));
    if (((!$n(folder).Lio_circe_Printer$PrintingFolder__f_dropNullValues) || (!$n(value).isNull__Z()))) {
      if ((!first)) {
        $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_objectCommas);
      }
      $n(folder).onString__T__V(key);
      $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_colons);
      $n(folder).Lio_circe_Printer$PrintingFolder__f_depth = ((1 + $n(folder).Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      $n(value).foldWith__Lio_circe_Json$Folder__O(folder);
      $n(folder).Lio_circe_Printer$PrintingFolder__f_depth = originalDepth;
      first = false;
    }
  }
  $n($n(folder).Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_rBraces);
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.equalsJsonObject__Lio_circe_JsonObject__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_JsonObject$MapAndVectorJsonObject)) {
    var that$2 = $as_Lio_circe_JsonObject$MapAndVectorJsonObject(that);
    if ((this.size__I() === $n(that$2).size__I())) {
      var x = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields;
      var x$2 = $n(that$2).Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  }
  if ((that instanceof $c_Lio_circe_JsonObject$LinkedHashMapJsonObject)) {
    var that$3 = $as_Lio_circe_JsonObject$LinkedHashMapJsonObject(that);
    return ((this.size__I() === $n(that$3).size__I()) && $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var k = $as_T($n(x$1$1)._1__O());
        var v = $as_Lio_circe_Json($n(x$1$1)._2__O());
        var x$2$1 = $n(that$3).applyUnsafe__T__Lio_circe_Json(k);
        return ((v === null) ? (x$2$1 === null) : $n(v).equals__O__Z(x$2$1));
      }
      throw new $c_s_MatchError(x$1$1);
    }))));
  }
  throw new $c_s_MatchError(that);
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.internalHashCode__I = (function() {
  return $n(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields).hashCode__I();
});
function $as_Lio_circe_JsonObject$MapAndVectorJsonObject(obj) {
  return (((obj instanceof $c_Lio_circe_JsonObject$MapAndVectorJsonObject) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonObject$MapAndVectorJsonObject"));
}
function $isArrayOf_Lio_circe_JsonObject$MapAndVectorJsonObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonObject$MapAndVectorJsonObject)));
}
function $asArrayOf_Lio_circe_JsonObject$MapAndVectorJsonObject(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonObject$MapAndVectorJsonObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonObject$MapAndVectorJsonObject;", depth));
}
var $d_Lio_circe_JsonObject$MapAndVectorJsonObject = new $TypeData().initClass($c_Lio_circe_JsonObject$MapAndVectorJsonObject, "io.circe.JsonObject$MapAndVectorJsonObject", ({
  Lio_circe_JsonObject$MapAndVectorJsonObject: 1,
  Lio_circe_JsonObject: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_KeyEncoder$$anon$2() {
}
$c_Lio_circe_KeyEncoder$$anon$2.prototype = new $h_O();
$c_Lio_circe_KeyEncoder$$anon$2.prototype.constructor = $c_Lio_circe_KeyEncoder$$anon$2;
/** @constructor */
function $h_Lio_circe_KeyEncoder$$anon$2() {
}
$h_Lio_circe_KeyEncoder$$anon$2.prototype = $c_Lio_circe_KeyEncoder$$anon$2.prototype;
$c_Lio_circe_KeyEncoder$$anon$2.prototype.apply__O__T = (function(key) {
  var key$1 = $as_T(key);
  return key$1;
});
var $d_Lio_circe_KeyEncoder$$anon$2 = new $TypeData().initClass($c_Lio_circe_KeyEncoder$$anon$2, "io.circe.KeyEncoder$$anon$2", ({
  Lio_circe_KeyEncoder$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyEncoder: 1
}));
/** @constructor */
function $c_Lio_circe_ParsingFailure$() {
  $n_Lio_circe_ParsingFailure$ = this;
  $n($m_Lcats_package$().Lcats_package$__f_Eq);
}
$c_Lio_circe_ParsingFailure$.prototype = new $h_O();
$c_Lio_circe_ParsingFailure$.prototype.constructor = $c_Lio_circe_ParsingFailure$;
/** @constructor */
function $h_Lio_circe_ParsingFailure$() {
}
$h_Lio_circe_ParsingFailure$.prototype = $c_Lio_circe_ParsingFailure$.prototype;
var $d_Lio_circe_ParsingFailure$ = new $TypeData().initClass($c_Lio_circe_ParsingFailure$, "io.circe.ParsingFailure$", ({
  Lio_circe_ParsingFailure$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lio_circe_ParsingFailure$;
function $m_Lio_circe_ParsingFailure$() {
  if ((!$n_Lio_circe_ParsingFailure$)) {
    $n_Lio_circe_ParsingFailure$ = new $c_Lio_circe_ParsingFailure$();
  }
  return $n_Lio_circe_ParsingFailure$;
}
function $p_Lio_circe_Printer$__toHex__I__C($thiz, nibble) {
  return (65535 & ((nibble + ((nibble >= 10) ? 87 : 48)) | 0));
}
/** @constructor */
function $c_Lio_circe_Printer$() {
  this.Lio_circe_Printer$__f_noSpaces = null;
  this.Lio_circe_Printer$__f_spaces2 = null;
  $n_Lio_circe_Printer$ = this;
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft = "";
  $m_Lio_circe_Printer$();
  var lbraceRight = "";
  $m_Lio_circe_Printer$();
  var rbraceLeft = "";
  $m_Lio_circe_Printer$();
  var rbraceRight = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft = "";
  $m_Lio_circe_Printer$();
  var lbracketRight = "";
  $m_Lio_circe_Printer$();
  var rbracketLeft = "";
  $m_Lio_circe_Printer$();
  var rbracketRight = "";
  $m_Lio_circe_Printer$();
  var lrbracketsEmpty = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft = "";
  $m_Lio_circe_Printer$();
  var arrayCommaRight = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft = "";
  $m_Lio_circe_Printer$();
  var objectCommaRight = "";
  $m_Lio_circe_Printer$();
  var colonLeft = "";
  $m_Lio_circe_Printer$();
  var colonRight = "";
  $m_Lio_circe_Printer$();
  var reuseWriters = false;
  $m_Lio_circe_Printer$();
  var predictSize = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii = false;
  $m_Lio_circe_Printer$();
  var sortKeys = false;
  this.Lio_circe_Printer$__f_noSpaces = new $c_Lio_circe_Printer(false, "", lbraceLeft, lbraceRight, rbraceLeft, rbraceRight, lbracketLeft, lbracketRight, rbracketLeft, rbracketRight, lrbracketsEmpty, arrayCommaLeft, arrayCommaRight, objectCommaLeft, objectCommaRight, colonLeft, colonRight, reuseWriters, predictSize, escapeNonAscii, sortKeys);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$1 = "";
  $m_Lio_circe_Printer$();
  var lbraceRight$1 = "";
  $m_Lio_circe_Printer$();
  var rbraceLeft$1 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$1 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$1 = "";
  $m_Lio_circe_Printer$();
  var lbracketRight$1 = "";
  $m_Lio_circe_Printer$();
  var rbracketLeft$1 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$1 = "";
  $m_Lio_circe_Printer$();
  var lrbracketsEmpty$1 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$1 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaRight$1 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$1 = "";
  $m_Lio_circe_Printer$();
  var objectCommaRight$1 = "";
  $m_Lio_circe_Printer$();
  var colonLeft$1 = "";
  $m_Lio_circe_Printer$();
  var colonRight$1 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$1 = false;
  $m_Lio_circe_Printer$();
  var predictSize$1 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$1 = false;
  new $c_Lio_circe_Printer(false, "", lbraceLeft$1, lbraceRight$1, rbraceLeft$1, rbraceRight$1, lbracketLeft$1, lbracketRight$1, rbracketLeft$1, rbracketRight$1, lrbracketsEmpty$1, arrayCommaLeft$1, arrayCommaRight$1, objectCommaLeft$1, objectCommaRight$1, colonLeft$1, colonRight$1, reuseWriters$1, predictSize$1, escapeNonAscii$1, true);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$2 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$2 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$2 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$2 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$2 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$2 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$2 = false;
  $m_Lio_circe_Printer$();
  var predictSize$2 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$2 = false;
  this.Lio_circe_Printer$__f_spaces2 = new $c_Lio_circe_Printer(false, "  ", lbraceLeft$2, "\n", "\n", rbraceRight$2, lbracketLeft$2, "\n", "\n", rbracketRight$2, "\n", arrayCommaLeft$2, "\n", objectCommaLeft$2, "\n", " ", " ", reuseWriters$2, predictSize$2, escapeNonAscii$2, false);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$3 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$3 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$3 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$3 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$3 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$3 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$3 = false;
  $m_Lio_circe_Printer$();
  var predictSize$3 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$3 = false;
  new $c_Lio_circe_Printer(false, "  ", lbraceLeft$3, "\n", "\n", rbraceRight$3, lbracketLeft$3, "\n", "\n", rbracketRight$3, "\n", arrayCommaLeft$3, "\n", objectCommaLeft$3, "\n", " ", " ", reuseWriters$3, predictSize$3, escapeNonAscii$3, true);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$4 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$4 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$4 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$4 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$4 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$4 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$4 = false;
  $m_Lio_circe_Printer$();
  var predictSize$4 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$4 = false;
  new $c_Lio_circe_Printer(false, "    ", lbraceLeft$4, "\n", "\n", rbraceRight$4, lbracketLeft$4, "\n", "\n", rbracketRight$4, "\n", arrayCommaLeft$4, "\n", objectCommaLeft$4, "\n", " ", " ", reuseWriters$4, predictSize$4, escapeNonAscii$4, false);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$5 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$5 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$5 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$5 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$5 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$5 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$5 = false;
  $m_Lio_circe_Printer$();
  var predictSize$5 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$5 = false;
  new $c_Lio_circe_Printer(false, "    ", lbraceLeft$5, "\n", "\n", rbraceRight$5, lbracketLeft$5, "\n", "\n", rbracketRight$5, "\n", arrayCommaLeft$5, "\n", objectCommaLeft$5, "\n", " ", " ", reuseWriters$5, predictSize$5, escapeNonAscii$5, true);
}
$c_Lio_circe_Printer$.prototype = new $h_O();
$c_Lio_circe_Printer$.prototype.constructor = $c_Lio_circe_Printer$;
/** @constructor */
function $h_Lio_circe_Printer$() {
}
$h_Lio_circe_Printer$.prototype = $c_Lio_circe_Printer$.prototype;
$c_Lio_circe_Printer$.prototype.io$circe$Printer$$$writeEscapedChar__jl_Appendable__C__V = (function(writer, c) {
  $n($n($n($n($n(writer).append__C__jl_Appendable(117)).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 12))))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 8))))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 4))))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & c)));
});
var $d_Lio_circe_Printer$ = new $TypeData().initClass($c_Lio_circe_Printer$, "io.circe.Printer$", ({
  Lio_circe_Printer$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lio_circe_Printer$;
function $m_Lio_circe_Printer$() {
  if ((!$n_Lio_circe_Printer$)) {
    $n_Lio_circe_Printer$ = new $c_Lio_circe_Printer$();
  }
  return $n_Lio_circe_Printer$;
}
/** @constructor */
function $c_Lio_circe_Printer$ConstantPieces(pieces) {
  this.Lio_circe_Printer$ConstantPieces__f_pieces = null;
  this.Lio_circe_Printer$ConstantPieces__f_pieces = pieces;
}
$c_Lio_circe_Printer$ConstantPieces.prototype = new $h_Lio_circe_Printer$PiecesAtDepth();
$c_Lio_circe_Printer$ConstantPieces.prototype.constructor = $c_Lio_circe_Printer$ConstantPieces;
/** @constructor */
function $h_Lio_circe_Printer$ConstantPieces() {
}
$h_Lio_circe_Printer$ConstantPieces.prototype = $c_Lio_circe_Printer$ConstantPieces.prototype;
$c_Lio_circe_Printer$ConstantPieces.prototype.apply__I__Lio_circe_Printer$Pieces = (function(i) {
  return this.Lio_circe_Printer$ConstantPieces__f_pieces;
});
var $d_Lio_circe_Printer$ConstantPieces = new $TypeData().initClass($c_Lio_circe_Printer$ConstantPieces, "io.circe.Printer$ConstantPieces", ({
  Lio_circe_Printer$ConstantPieces: 1,
  Lio_circe_Printer$PiecesAtDepth: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Lio_circe_Printer$MemoizedPieces__T__($thiz, indent) {
  $thiz.Lio_circe_Printer$MemoizedPieces__f_indent = indent;
  $thiz.Lio_circe_Printer$MemoizedPieces__f_known = $ct_ju_concurrent_CopyOnWriteArrayList__AO__(new $c_ju_concurrent_CopyOnWriteArrayList(), new ($d_Lio_circe_Printer$Pieces.getArrayOf().constr)(128));
  return $thiz;
}
/** @constructor */
function $c_Lio_circe_Printer$MemoizedPieces() {
  this.Lio_circe_Printer$MemoizedPieces__f_indent = null;
  this.Lio_circe_Printer$MemoizedPieces__f_known = null;
}
$c_Lio_circe_Printer$MemoizedPieces.prototype = new $h_Lio_circe_Printer$PiecesAtDepth();
$c_Lio_circe_Printer$MemoizedPieces.prototype.constructor = $c_Lio_circe_Printer$MemoizedPieces;
/** @constructor */
function $h_Lio_circe_Printer$MemoizedPieces() {
}
$h_Lio_circe_Printer$MemoizedPieces.prototype = $c_Lio_circe_Printer$MemoizedPieces.prototype;
$c_Lio_circe_Printer$MemoizedPieces.prototype.addIndentation__jl_StringBuilder__T__I__V = (function(builder, s, depth) {
  var lastNewLineIndex = $f_T__lastIndexOf__I__I($n(s), 10);
  if ((lastNewLineIndex === (-1))) {
    var this$1 = $n(builder);
    this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  } else {
    $n(builder).append__jl_CharSequence__I__I__jl_StringBuilder(s, 0, ((1 + lastNewLineIndex) | 0));
    var i = 0;
    while ((i < depth)) {
      var this$2 = $n(builder);
      var str = this.Lio_circe_Printer$MemoizedPieces__f_indent;
      this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      i = ((1 + i) | 0);
    }
    var $x_1 = $n(builder);
    var this$3 = $n(s);
    $x_1.append__jl_CharSequence__I__I__jl_StringBuilder(s, ((1 + lastNewLineIndex) | 0), this$3.length);
  }
});
$c_Lio_circe_Printer$MemoizedPieces.prototype.apply__I__Lio_circe_Printer$Pieces = (function(i) {
  if ((i >= 128)) {
    return this.compute__I__Lio_circe_Printer$Pieces(i);
  } else {
    var res = $as_Lio_circe_Printer$Pieces($n(this.Lio_circe_Printer$MemoizedPieces__f_known).get__I__O(i));
    if ((res !== null)) {
      return res;
    } else {
      var tmp = this.compute__I__Lio_circe_Printer$Pieces(i);
      $n(this.Lio_circe_Printer$MemoizedPieces__f_known).set__I__O__O(i, tmp);
      return tmp;
    }
  }
});
function $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__($thiz, writer, pieces, dropNullValues, escapeNonAscii, sortKeys) {
  $thiz.Lio_circe_Printer$PrintingFolder__f_writer = writer;
  $thiz.Lio_circe_Printer$PrintingFolder__f_pieces = pieces;
  $thiz.Lio_circe_Printer$PrintingFolder__f_dropNullValues = dropNullValues;
  $thiz.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = escapeNonAscii;
  $thiz.Lio_circe_Printer$PrintingFolder__f_sortKeys = sortKeys;
  $thiz.Lio_circe_Printer$PrintingFolder__f_depth = 0;
  return $thiz;
}
/** @constructor */
function $c_Lio_circe_Printer$PrintingFolder() {
  this.Lio_circe_Printer$PrintingFolder__f_writer = null;
  this.Lio_circe_Printer$PrintingFolder__f_pieces = null;
  this.Lio_circe_Printer$PrintingFolder__f_dropNullValues = false;
  this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = false;
  this.Lio_circe_Printer$PrintingFolder__f_sortKeys = false;
  this.Lio_circe_Printer$PrintingFolder__f_depth = 0;
}
$c_Lio_circe_Printer$PrintingFolder.prototype = new $h_O();
$c_Lio_circe_Printer$PrintingFolder.prototype.constructor = $c_Lio_circe_Printer$PrintingFolder;
/** @constructor */
function $h_Lio_circe_Printer$PrintingFolder() {
}
$h_Lio_circe_Printer$PrintingFolder.prototype = $c_Lio_circe_Printer$PrintingFolder.prototype;
$c_Lio_circe_Printer$PrintingFolder.prototype.onString__T__V = (function(value) {
  $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__C__jl_Appendable(34);
  var i = 0;
  var offset = 0;
  while (true) {
    var $x_2 = i;
    var this$1 = $n(value);
    if (($x_2 < this$1.length)) {
      var this$2 = $n(value);
      var index = i;
      var c = $charAt(this$2, index);
      var esc;
      switch (c) {
        case 34: {
          var esc = 34;
          break;
        }
        case 92: {
          var esc = 92;
          break;
        }
        case 8: {
          var esc = 98;
          break;
        }
        case 12: {
          var esc = 102;
          break;
        }
        case 10: {
          var esc = 110;
          break;
        }
        case 13: {
          var esc = 114;
          break;
        }
        case 9: {
          var esc = 116;
          break;
        }
        default: {
          if ((this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii && (c > 127))) {
            var $x_1 = true;
          } else {
            var this$3 = $m_jl_Character$();
            var $x_1 = this$3.isISOControl__I__Z(c);
          }
          var esc = (65535 & ($x_1 ? 1 : 0));
        }
      }
      if ((esc !== 0)) {
        $n($n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__I__I__jl_Appendable(value, offset, i)).append__C__jl_Appendable(92);
        if ((esc !== 1)) {
          $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__C__jl_Appendable(esc);
        } else {
          $m_Lio_circe_Printer$().io$circe$Printer$$$writeEscapedChar__jl_Appendable__C__V(this.Lio_circe_Printer$PrintingFolder__f_writer, c);
        }
        offset = ((1 + i) | 0);
      }
      i = ((1 + i) | 0);
    } else {
      break;
    }
  }
  if ((offset < i)) {
    $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__I__I__jl_Appendable(value, offset, i);
  }
  $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__C__jl_Appendable(34);
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onArray__sci_Vector__V = (function(value) {
  var orig = this.Lio_circe_Printer$PrintingFolder__f_depth;
  var p = $n(this.Lio_circe_Printer$PrintingFolder__f_pieces).apply__I__Lio_circe_Printer$Pieces(this.Lio_circe_Printer$PrintingFolder__f_depth);
  var this$1 = $n(value);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_lrEmptyBrackets);
  } else {
    var iterator = $n(value).iterator__sc_Iterator();
    $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_lBrackets);
    this.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + this.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
    $n($as_Lio_circe_Json($n(iterator).next__O())).foldWith__Lio_circe_Json$Folder__O(this);
    this.Lio_circe_Printer$PrintingFolder__f_depth = orig;
    while ($n(iterator).hasNext__Z()) {
      $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_arrayCommas);
      this.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + this.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      $n($as_Lio_circe_Json($n(iterator).next__O())).foldWith__Lio_circe_Json$Folder__O(this);
      this.Lio_circe_Printer$PrintingFolder__f_depth = orig;
    }
    $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(p).Lio_circe_Printer$Pieces__f_rBrackets);
  }
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onNull__O = (function() {
  $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable("null");
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onString__T__O = (function(value) {
  this.onString__T__V(value);
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onArray__sci_Vector__O = (function(value) {
  this.onArray__sci_Vector__V(value);
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onObject__Lio_circe_JsonObject__O = (function(value) {
  $n(value).appendToFolder__Lio_circe_Printer$PrintingFolder__V(this);
});
function $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__($thiz, decodeA) {
  $thiz.Lio_circe_SeqDecoder__f_decodeA = decodeA;
  return $thiz;
}
/** @constructor */
function $c_Lio_circe_SeqDecoder() {
  this.Lio_circe_SeqDecoder__f_decodeA = null;
}
$c_Lio_circe_SeqDecoder.prototype = new $h_O();
$c_Lio_circe_SeqDecoder.prototype.constructor = $c_Lio_circe_SeqDecoder;
/** @constructor */
function $h_Lio_circe_SeqDecoder() {
}
$h_Lio_circe_SeqDecoder.prototype = $c_Lio_circe_SeqDecoder.prototype;
$c_Lio_circe_SeqDecoder.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_SeqDecoder.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var values = $n($n(c).value__Lio_circe_Json()).asArray__s_Option();
  var this$1 = $n(values);
  if ((!this$1.isEmpty__Z())) {
    var jsonValues = $as_sci_Vector($n(values).get__O());
    var builder = new $c_scm_ListBuffer();
    var this$3 = $n(jsonValues);
    this$3.length__I();
    var failed = null;
    var index = 0;
    var cursor = new $c_Lio_circe_cursor_ArrayCursor(jsonValues, index, c, false, c, $m_Lio_circe_CursorOp$DownArray$());
    while (true) {
      if ((failed === null)) {
        var $x_3 = index;
        var this$4 = $n(jsonValues);
        var $x_2 = ($x_3 < this$4.length__I());
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        matchResult1: {
          var this$5 = $n(cursor);
          var d = this.Lio_circe_SeqDecoder__f_decodeA;
          var x1 = $n(d).tryDecode__Lio_circe_ACursor__s_util_Either(this$5);
          if ((x1 instanceof $c_s_util_Left)) {
            var e = $as_Lio_circe_DecodingFailure($n($as_s_util_Left(x1)).s_util_Left__f_value);
            var this$6 = $n(e);
            var message$1 = this$6.message__T();
            var $x_1 = $n($n(e).copy__T__F0__Lio_circe_DecodingFailure(message$1, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((e) => (() => $n(e).history__sci_List()))(e))));
            var this$7 = $n(e);
            failed = $x_1.withReason__Lio_circe_DecodingFailure$Reason__Lio_circe_DecodingFailure($as_Lio_circe_DecodingFailure$Reason($n(this$7.Lio_circe_DecodingFailure__f_lazyReason).value__O()));
            break matchResult1;
          }
          if ((x1 instanceof $c_s_util_Right)) {
            var a = $n($as_s_util_Right(x1)).s_util_Right__f_value;
            builder.addOne__O__scm_ListBuffer(a);
            cursor = $n(cursor).right__Lio_circe_ACursor();
            break matchResult1;
          }
          throw new $c_s_MatchError(x1);
        }
        index = ((1 + index) | 0);
      } else {
        break;
      }
    }
    if ((failed === null)) {
      var value = builder.toList__sci_List();
      return new $c_s_util_Right(value);
    } else {
      var value$1 = failed;
      return new $c_s_util_Left(value$1);
    }
  } else if ($n($n(c).value__Lio_circe_Json()).isArray__Z()) {
    var this$11 = new $c_scm_ListBuffer();
    var value$2 = this$11.toList__sci_List();
    return new $c_s_util_Right(value$2);
  } else {
    var $x_4 = $m_Lio_circe_DecodingFailure$();
    var jsonValue = $n(c).value__Lio_circe_Json();
    var value$3 = $x_4.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("array", jsonValue), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(c).history__sci_List())));
    return new $c_s_util_Left(value$3);
  }
});
function $ct_Lio_circe_numbers_BiggerDecimal$Zero__($thiz) {
  var value = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
  $thiz.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = new $c_s_Some(value);
  $thiz.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = new $c_s_Some($bL(0, 0));
  return $thiz;
}
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$Zero() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
}
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype = new $h_Lio_circe_numbers_BiggerDecimal();
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$Zero;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$Zero() {
}
$h_Lio_circe_numbers_BiggerDecimal$Zero.prototype = $c_Lio_circe_numbers_BiggerDecimal$Zero.prototype;
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.toLong__s_Option = (function() {
  return this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong;
});
function $as_Lio_circe_numbers_BiggerDecimal$Zero(obj) {
  return (((obj instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.numbers.BiggerDecimal$Zero"));
}
function $isArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_numbers_BiggerDecimal$Zero)));
}
function $asArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) {
  return (($isArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.numbers.BiggerDecimal$Zero;", depth));
}
/** @constructor */
function $c_Lio_circe_numbers_SigAndExp(unscaled, scale) {
  this.Lio_circe_numbers_SigAndExp__f_unscaled = null;
  this.Lio_circe_numbers_SigAndExp__f_scale = null;
  this.Lio_circe_numbers_SigAndExp__f_unscaled = unscaled;
  this.Lio_circe_numbers_SigAndExp__f_scale = scale;
}
$c_Lio_circe_numbers_SigAndExp.prototype = new $h_Lio_circe_numbers_BiggerDecimal();
$c_Lio_circe_numbers_SigAndExp.prototype.constructor = $c_Lio_circe_numbers_SigAndExp;
/** @constructor */
function $h_Lio_circe_numbers_SigAndExp() {
}
$h_Lio_circe_numbers_SigAndExp.prototype = $c_Lio_circe_numbers_SigAndExp.prototype;
$c_Lio_circe_numbers_SigAndExp.prototype.isWhole__Z = (function() {
  var this$1 = $n(this.Lio_circe_numbers_SigAndExp__f_scale);
  return (this$1.Ljava_math_BigInteger__f_sign < 1);
});
$c_Lio_circe_numbers_SigAndExp.prototype.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option = (function(maxDigits) {
  if ((!this.isWhole__Z())) {
    return $m_s_None$();
  } else {
    var this$1 = $n($n(this.Lio_circe_numbers_SigAndExp__f_unscaled).abs__Ljava_math_BigInteger());
    var this$2 = $n($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1));
    var value = this$2.length;
    var hi = (value >> 31);
    var this$4 = $n($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(value, hi));
    var bi = this.Lio_circe_numbers_SigAndExp__f_scale;
    var digits = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi);
    if (($n(digits).compareTo__Ljava_math_BigInteger__I(maxDigits) > 0)) {
      return $m_s_None$();
    } else {
      var value$1 = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.Lio_circe_numbers_SigAndExp__f_unscaled, $n(this.Lio_circe_numbers_SigAndExp__f_scale).intValue__I()).toBigInteger__Ljava_math_BigInteger();
      return new $c_s_Some(value$1);
    }
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.toLong__s_Option = (function() {
  if ((!this.isWhole__Z())) {
    return $m_s_None$();
  } else {
    var x1 = this.toBigIntegerWithMaxDigits__Ljava_math_BigInteger__s_Option($m_Lio_circe_numbers_BiggerDecimal$().Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits);
    if ((x1 instanceof $c_s_Some)) {
      var i = $as_Ljava_math_BigInteger($n($as_s_Some(x1)).s_Some__f_value);
      var $x_1 = $n(i).longValue__J();
      var asLong_$_lo = $x_1.l;
      var asLong_$_hi = $x_1.h;
      var xn = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(asLong_$_lo, asLong_$_hi);
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, i)) {
        return new $c_s_Some($bL(asLong_$_lo, asLong_$_hi));
      } else {
        return $m_s_None$();
      }
    }
    var x = $m_s_None$();
    if ((x === x1)) {
      return $m_s_None$();
    }
    throw new $c_s_MatchError(x1);
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_SigAndExp)) {
    var other = $as_Lio_circe_numbers_SigAndExp(that);
    var xn = this.Lio_circe_numbers_SigAndExp__f_unscaled;
    var yn = $n(other).Lio_circe_numbers_SigAndExp__f_unscaled;
    if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)) {
      var xn$1 = this.Lio_circe_numbers_SigAndExp__f_scale;
      var yn$1 = $n(other).Lio_circe_numbers_SigAndExp__f_scale;
      return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn$1, yn$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.hashCode__I = (function() {
  return (($n(this.Lio_circe_numbers_SigAndExp__f_scale).hashCode__I() + $n(this.Lio_circe_numbers_SigAndExp__f_unscaled).hashCode__I()) | 0);
});
$c_Lio_circe_numbers_SigAndExp.prototype.toString__T = (function() {
  var xn = this.Lio_circe_numbers_SigAndExp__f_scale;
  var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)) {
    var this$1 = $n(this.Lio_circe_numbers_SigAndExp__f_unscaled);
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  } else {
    return ((this.Lio_circe_numbers_SigAndExp__f_unscaled + "e") + $n(this.Lio_circe_numbers_SigAndExp__f_scale).negate__Ljava_math_BigInteger());
  }
});
function $as_Lio_circe_numbers_SigAndExp(obj) {
  return (((obj instanceof $c_Lio_circe_numbers_SigAndExp) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.numbers.SigAndExp"));
}
function $isArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_numbers_SigAndExp)));
}
function $asArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) {
  return (($isArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.numbers.SigAndExp;", depth));
}
var $d_Lio_circe_numbers_SigAndExp = new $TypeData().initClass($c_Lio_circe_numbers_SigAndExp, "io.circe.numbers.SigAndExp", ({
  Lio_circe_numbers_SigAndExp: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_parser_package$() {
}
$c_Lio_circe_parser_package$.prototype = new $h_O();
$c_Lio_circe_parser_package$.prototype.constructor = $c_Lio_circe_parser_package$;
/** @constructor */
function $h_Lio_circe_parser_package$() {
}
$h_Lio_circe_parser_package$.prototype = $c_Lio_circe_parser_package$.prototype;
$c_Lio_circe_parser_package$.prototype.parse__T__s_util_Either = (function(input) {
  try {
    var x5 = $m_Lio_circe_scalajs_package$().convertJsToJson__sjs_js_Any__s_util_Either(JSON.parse(input));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var x5;
      var x2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(x2).isEmpty__Z())) {
        var x3 = $as_jl_Throwable($n(x2).get__O());
        $m_Lio_circe_ParsingFailure$();
        var message = $n(x3).getMessage__T();
        var value = new $c_Lio_circe_ParsingFailure(message, x3);
        var x5 = new $c_s_util_Left(value);
        break matchResult1;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  if ((x5 instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(x5);
    return r;
  }
  if ((x5 instanceof $c_s_util_Left)) {
    var exception$2 = $as_jl_Throwable($n($as_s_util_Left(x5)).s_util_Left__f_value);
    $m_Lio_circe_ParsingFailure$();
    var message$1 = $n(exception$2).getMessage__T();
    var value$1 = new $c_Lio_circe_ParsingFailure(message$1, exception$2);
    return new $c_s_util_Left(value$1);
  }
  throw new $c_s_MatchError(x5);
});
var $d_Lio_circe_parser_package$ = new $TypeData().initClass($c_Lio_circe_parser_package$, "io.circe.parser.package$", ({
  Lio_circe_parser_package$: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Parser: 1
}));
var $n_Lio_circe_parser_package$;
function $m_Lio_circe_parser_package$() {
  if ((!$n_Lio_circe_parser_package$)) {
    $n_Lio_circe_parser_package$ = new $c_Lio_circe_parser_package$();
  }
  return $n_Lio_circe_parser_package$;
}
/** @constructor */
function $c_jl_Class($data) {
  this.data = $data;
}
$c_jl_Class.prototype = new $h_O();
$c_jl_Class.prototype.constructor = $c_jl_Class;
/** @constructor */
function $h_jl_Class() {
}
$h_jl_Class.prototype = $c_jl_Class.prototype;
$c_jl_Class.prototype.toString__T = (function() {
  return ((this.data.isInterface ? "interface " : (this.data.isPrimitive ? "" : "class ")) + this.data.name);
});
var $d_jl_Class = new $TypeData().initClass($c_jl_Class, "java.lang.Class", ({
  jl_Class: 1,
  Ljava_io_Serializable: 1,
  jl_constant_Constable: 1
}));
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.jl_Enum__f__name = _name;
  $thiz.jl_Enum__f__ordinal = _ordinal;
  return $thiz;
}
/** @constructor */
function $c_jl_Enum() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
$c_jl_Enum.prototype = new $h_O();
$c_jl_Enum.prototype.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
}
$h_jl_Enum.prototype = $c_jl_Enum.prototype;
$c_jl_Enum.prototype.toString__T = (function() {
  return this.jl_Enum__f__name;
});
$c_jl_Enum.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_jl_Enum.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_jl_Enum.prototype.compareTo__jl_Enum__I = (function(o) {
  var x = this.jl_Enum__f__ordinal;
  var y = $n(o).jl_Enum__f__ordinal;
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$c_jl_Enum.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__jl_Enum__I($as_jl_Enum(o));
});
function $as_jl_Enum(obj) {
  return (((obj instanceof $c_jl_Enum) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Enum"));
}
function $isArrayOf_jl_Enum(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Enum)));
}
function $asArrayOf_jl_Enum(obj, depth) {
  return (($isArrayOf_jl_Enum(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Enum;", depth));
}
class $c_jl_Error extends $c_jl_Throwable {
}
function $as_jl_Error(obj) {
  return (((obj instanceof $c_jl_Error) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Error"));
}
function $isArrayOf_jl_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Error)));
}
function $asArrayOf_jl_Error(obj, depth) {
  return (($isArrayOf_jl_Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Error;", depth));
}
function $ct_jl_Exception__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_Exception extends $c_jl_Throwable {
}
var $d_jl_Exception = new $TypeData().initClass($c_jl_Exception, "java.lang.Exception", ({
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ljava_time_Clock$SystemClock(zone) {
  this.Ljava_time_Clock$SystemClock__f_zone = null;
  this.Ljava_time_Clock$SystemClock__f_zone = zone;
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "'zone' can not be null");
  }
}
$c_Ljava_time_Clock$SystemClock.prototype = new $h_Ljava_time_Clock();
$c_Ljava_time_Clock$SystemClock.prototype.constructor = $c_Ljava_time_Clock$SystemClock;
/** @constructor */
function $h_Ljava_time_Clock$SystemClock() {
}
$h_Ljava_time_Clock$SystemClock.prototype = $c_Ljava_time_Clock$SystemClock.prototype;
$c_Ljava_time_Clock$SystemClock.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_Clock$SystemClock)) {
    var clock = $as_Ljava_time_Clock$SystemClock(obj);
    var x = this.Ljava_time_Clock$SystemClock__f_zone;
    var x$2 = $n(clock).Ljava_time_Clock$SystemClock__f_zone;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Ljava_time_Clock$SystemClock.prototype.hashCode__I = (function() {
  return ((1 + $n(this.Ljava_time_Clock$SystemClock__f_zone).hashCode__I()) | 0);
});
$c_Ljava_time_Clock$SystemClock.prototype.toString__T = (function() {
  return (("SystemClock[" + this.Ljava_time_Clock$SystemClock__f_zone) + "]");
});
function $as_Ljava_time_Clock$SystemClock(obj) {
  return (((obj instanceof $c_Ljava_time_Clock$SystemClock) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Clock$SystemClock"));
}
function $isArrayOf_Ljava_time_Clock$SystemClock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Clock$SystemClock)));
}
function $asArrayOf_Ljava_time_Clock$SystemClock(obj, depth) {
  return (($isArrayOf_Ljava_time_Clock$SystemClock(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Clock$SystemClock;", depth));
}
var $d_Ljava_time_Clock$SystemClock = new $TypeData().initClass($c_Ljava_time_Clock$SystemClock, "java.time.Clock$SystemClock", ({
  Ljava_time_Clock$SystemClock: 1,
  Ljava_time_Clock: 1,
  Ljava_io_Serializable: 1
}));
function $s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__MONDAY;
}
function $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__TUESDAY;
}
function $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__WEDNESDAY;
}
function $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__THURSDAY;
}
function $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__FRIDAY;
}
function $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__SATURDAY;
}
function $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__SUNDAY;
}
/** @constructor */
function $c_Ljava_time_DayOfWeek$() {
  this.Ljava_time_DayOfWeek$__f_$values = null;
  this.Ljava_time_DayOfWeek$__f_ENUMS$lzy1 = null;
  this.Ljava_time_DayOfWeek$__f_ENUMSbitmap$1 = false;
  $n_Ljava_time_DayOfWeek$ = this;
  $t_Ljava_time_DayOfWeek$__MONDAY = new $c_Ljava_time_DayOfWeek$$anon$1();
  $t_Ljava_time_DayOfWeek$__TUESDAY = new $c_Ljava_time_DayOfWeek$$anon$2();
  $t_Ljava_time_DayOfWeek$__WEDNESDAY = new $c_Ljava_time_DayOfWeek$$anon$3();
  $t_Ljava_time_DayOfWeek$__THURSDAY = new $c_Ljava_time_DayOfWeek$$anon$4();
  $t_Ljava_time_DayOfWeek$__FRIDAY = new $c_Ljava_time_DayOfWeek$$anon$5();
  $t_Ljava_time_DayOfWeek$__SATURDAY = new $c_Ljava_time_DayOfWeek$$anon$6();
  $t_Ljava_time_DayOfWeek$__SUNDAY = new $c_Ljava_time_DayOfWeek$$anon$7();
  this.Ljava_time_DayOfWeek$__f_$values = new ($d_Ljava_time_DayOfWeek.getArrayOf().constr)([$s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek()]);
}
$c_Ljava_time_DayOfWeek$.prototype = new $h_O();
$c_Ljava_time_DayOfWeek$.prototype.constructor = $c_Ljava_time_DayOfWeek$;
/** @constructor */
function $h_Ljava_time_DayOfWeek$() {
}
$h_Ljava_time_DayOfWeek$.prototype = $c_Ljava_time_DayOfWeek$.prototype;
$c_Ljava_time_DayOfWeek$.prototype.values__ALjava_time_DayOfWeek = (function() {
  var this$1 = $n(this.Ljava_time_DayOfWeek$__f_$values);
  return this$1.clone__O();
});
$c_Ljava_time_DayOfWeek$.prototype.java$time$DayOfWeek$$$ENUMS__ALjava_time_DayOfWeek = (function() {
  if ((!this.Ljava_time_DayOfWeek$__f_ENUMSbitmap$1)) {
    this.Ljava_time_DayOfWeek$__f_ENUMS$lzy1 = $m_Ljava_time_DayOfWeek$().values__ALjava_time_DayOfWeek();
    this.Ljava_time_DayOfWeek$__f_ENUMSbitmap$1 = true;
  }
  return this.Ljava_time_DayOfWeek$__f_ENUMS$lzy1;
});
$c_Ljava_time_DayOfWeek$.prototype.of__I__Ljava_time_DayOfWeek = (function(dayOfWeek) {
  if (((((dayOfWeek - 1) | 0) >>> 0) > 6)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for DayOfWeek: " + dayOfWeek));
  } else {
    return $n(this.java$time$DayOfWeek$$$ENUMS__ALjava_time_DayOfWeek()).get(((dayOfWeek - 1) | 0));
  }
});
var $d_Ljava_time_DayOfWeek$ = new $TypeData().initClass($c_Ljava_time_DayOfWeek$, "java.time.DayOfWeek$", ({
  Ljava_time_DayOfWeek$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ljava_time_DayOfWeek$;
function $m_Ljava_time_DayOfWeek$() {
  if ((!$n_Ljava_time_DayOfWeek$)) {
    $n_Ljava_time_DayOfWeek$ = new $c_Ljava_time_DayOfWeek$();
  }
  return $n_Ljava_time_DayOfWeek$;
}
function $s_Ljava_time_Month$__JANUARY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JANUARY;
}
function $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__FEBRUARY;
}
function $s_Ljava_time_Month$__MARCH__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__MARCH;
}
function $s_Ljava_time_Month$__APRIL__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__APRIL;
}
function $s_Ljava_time_Month$__MAY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__MAY;
}
function $s_Ljava_time_Month$__JUNE__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JUNE;
}
function $s_Ljava_time_Month$__JULY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JULY;
}
function $s_Ljava_time_Month$__AUGUST__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__AUGUST;
}
function $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__SEPTEMBER;
}
function $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__OCTOBER;
}
function $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__NOVEMBER;
}
function $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__DECEMBER;
}
/** @constructor */
function $c_Ljava_time_Month$() {
  this.Ljava_time_Month$__f_$values = null;
  this.Ljava_time_Month$__f_ENUMS$lzy1 = null;
  this.Ljava_time_Month$__f_ENUMSbitmap$1 = false;
  $n_Ljava_time_Month$ = this;
  $t_Ljava_time_Month$__JANUARY = new $c_Ljava_time_Month$$anon$1();
  $t_Ljava_time_Month$__FEBRUARY = new $c_Ljava_time_Month$$anon$2();
  $t_Ljava_time_Month$__MARCH = new $c_Ljava_time_Month$$anon$3();
  $t_Ljava_time_Month$__APRIL = new $c_Ljava_time_Month$$anon$4();
  $t_Ljava_time_Month$__MAY = new $c_Ljava_time_Month$$anon$5();
  $t_Ljava_time_Month$__JUNE = new $c_Ljava_time_Month$$anon$6();
  $t_Ljava_time_Month$__JULY = new $c_Ljava_time_Month$$anon$7();
  $t_Ljava_time_Month$__AUGUST = new $c_Ljava_time_Month$$anon$8();
  $t_Ljava_time_Month$__SEPTEMBER = new $c_Ljava_time_Month$$anon$9();
  $t_Ljava_time_Month$__OCTOBER = new $c_Ljava_time_Month$$anon$10();
  $t_Ljava_time_Month$__NOVEMBER = new $c_Ljava_time_Month$$anon$11();
  $t_Ljava_time_Month$__DECEMBER = new $c_Ljava_time_Month$$anon$12();
  this.Ljava_time_Month$__f_$values = new ($d_Ljava_time_Month.getArrayOf().constr)([$s_Ljava_time_Month$__JANUARY__Ljava_time_Month(), $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month(), $s_Ljava_time_Month$__MARCH__Ljava_time_Month(), $s_Ljava_time_Month$__APRIL__Ljava_time_Month(), $s_Ljava_time_Month$__MAY__Ljava_time_Month(), $s_Ljava_time_Month$__JUNE__Ljava_time_Month(), $s_Ljava_time_Month$__JULY__Ljava_time_Month(), $s_Ljava_time_Month$__AUGUST__Ljava_time_Month(), $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month(), $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month(), $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month(), $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month()]);
}
$c_Ljava_time_Month$.prototype = new $h_O();
$c_Ljava_time_Month$.prototype.constructor = $c_Ljava_time_Month$;
/** @constructor */
function $h_Ljava_time_Month$() {
}
$h_Ljava_time_Month$.prototype = $c_Ljava_time_Month$.prototype;
$c_Ljava_time_Month$.prototype.values__ALjava_time_Month = (function() {
  var this$1 = $n(this.Ljava_time_Month$__f_$values);
  return this$1.clone__O();
});
$c_Ljava_time_Month$.prototype.java$time$Month$$$ENUMS__ALjava_time_Month = (function() {
  if ((!this.Ljava_time_Month$__f_ENUMSbitmap$1)) {
    this.Ljava_time_Month$__f_ENUMS$lzy1 = $m_Ljava_time_Month$().values__ALjava_time_Month();
    this.Ljava_time_Month$__f_ENUMSbitmap$1 = true;
  }
  return this.Ljava_time_Month$__f_ENUMS$lzy1;
});
$c_Ljava_time_Month$.prototype.of__I__Ljava_time_Month = (function(month) {
  if (((((month - 1) | 0) >>> 0) > 11)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for MonthOfYear: " + month));
  } else {
    return $n(this.java$time$Month$$$ENUMS__ALjava_time_Month()).get(((month - 1) | 0));
  }
});
var $d_Ljava_time_Month$ = new $TypeData().initClass($c_Ljava_time_Month$, "java.time.Month$", ({
  Ljava_time_Month$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ljava_time_Month$;
function $m_Ljava_time_Month$() {
  if ((!$n_Ljava_time_Month$)) {
    $n_Ljava_time_Month$ = new $c_Ljava_time_Month$();
  }
  return $n_Ljava_time_Month$;
}
var $d_Ljava_time_ZoneRegion = new $TypeData().initClass(0, "java.time.ZoneRegion", ({
  Ljava_time_ZoneRegion: 1,
  Ljava_time_ZoneId: 1,
  Ljava_io_Serializable: 1
}));
function $f_Ljava_time_chrono_Chronology__equals__O__Z($thiz, obj) {
  if ($is_Ljava_time_chrono_Chronology(obj)) {
    var other = $as_Ljava_time_chrono_Chronology(obj);
    return (($thiz === other) || ($f_T__compareTo__T__I("ISO", ($n(other), "ISO")) === 0));
  } else {
    return false;
  }
}
function $f_Ljava_time_chrono_Chronology__hashCode__I($thiz) {
  var this$1 = $objectGetClass($thiz);
  return ($systemIdentityHashCode(this$1) ^ $f_T__hashCode__I("ISO"));
}
function $is_Ljava_time_chrono_Chronology(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_Chronology)));
}
function $as_Ljava_time_chrono_Chronology(obj) {
  return (($is_Ljava_time_chrono_Chronology(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.Chronology"));
}
function $isArrayOf_Ljava_time_chrono_Chronology(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_Chronology)));
}
function $asArrayOf_Ljava_time_chrono_Chronology(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_Chronology(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.Chronology;", depth));
}
function $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__STRICT;
}
function $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__SMART;
}
function $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__LENIENT;
}
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$() {
  $n_Ljava_time_format_ResolverStyle$ = this;
  $t_Ljava_time_format_ResolverStyle$__STRICT = new $c_Ljava_time_format_ResolverStyle$$anon$1();
  $t_Ljava_time_format_ResolverStyle$__SMART = new $c_Ljava_time_format_ResolverStyle$$anon$2();
  $t_Ljava_time_format_ResolverStyle$__LENIENT = new $c_Ljava_time_format_ResolverStyle$$anon$3();
  $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
  $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle();
  $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle();
}
$c_Ljava_time_format_ResolverStyle$.prototype = new $h_O();
$c_Ljava_time_format_ResolverStyle$.prototype.constructor = $c_Ljava_time_format_ResolverStyle$;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$() {
}
$h_Ljava_time_format_ResolverStyle$.prototype = $c_Ljava_time_format_ResolverStyle$.prototype;
var $d_Ljava_time_format_ResolverStyle$ = new $TypeData().initClass($c_Ljava_time_format_ResolverStyle$, "java.time.format.ResolverStyle$", ({
  Ljava_time_format_ResolverStyle$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ljava_time_format_ResolverStyle$;
function $m_Ljava_time_format_ResolverStyle$() {
  if ((!$n_Ljava_time_format_ResolverStyle$)) {
    $n_Ljava_time_format_ResolverStyle$ = new $c_Ljava_time_format_ResolverStyle$();
  }
  return $n_Ljava_time_format_ResolverStyle$;
}
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE;
}
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE;
}
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT;
}
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT;
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = this;
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1();
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2();
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3();
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4();
  $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
  $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
  $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
  $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
}
function $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND;
}
function $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY;
}
function $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND;
}
function $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY;
}
function $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND;
}
function $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY;
}
function $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE;
}
function $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY;
}
function $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR;
}
function $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY;
}
function $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM;
}
function $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM;
}
function $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY;
}
function $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY;
}
function $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY;
}
function $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK;
}
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH;
}
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR;
}
function $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH;
}
function $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR;
}
function $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY;
}
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH;
}
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR;
}
function $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR;
}
function $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH;
}
function $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA;
}
function $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__YEAR;
}
function $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ERA;
}
function $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS;
}
function $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS;
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$() {
  this.Ljava_time_temporal_ChronoField$__f_$values = null;
  $n_Ljava_time_temporal_ChronoField$ = this;
  $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND = new $c_Ljava_time_temporal_ChronoField$$anon$1();
  $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$2();
  $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND = new $c_Ljava_time_temporal_ChronoField$$anon$3();
  $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$4();
  $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND = new $c_Ljava_time_temporal_ChronoField$$anon$5();
  $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$6();
  $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE = new $c_Ljava_time_temporal_ChronoField$$anon$7();
  $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$8();
  $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR = new $c_Ljava_time_temporal_ChronoField$$anon$9();
  $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$10();
  $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM = new $c_Ljava_time_temporal_ChronoField$$anon$11();
  $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM = new $c_Ljava_time_temporal_ChronoField$$anon$12();
  $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$13();
  $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$14();
  $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$15();
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK = new $c_Ljava_time_temporal_ChronoField$$anon$16();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$17();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$18();
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$19();
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$20();
  $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$21();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$22();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$23();
  $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$24();
  $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$25();
  $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA = new $c_Ljava_time_temporal_ChronoField$$anon$26();
  $t_Ljava_time_temporal_ChronoField$__YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$27();
  $t_Ljava_time_temporal_ChronoField$__ERA = new $c_Ljava_time_temporal_ChronoField$$anon$28();
  $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS = new $c_Ljava_time_temporal_ChronoField$$anon$29();
  $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS = new $c_Ljava_time_temporal_ChronoField$$anon$30();
  this.Ljava_time_temporal_ChronoField$__f_$values = new ($d_Ljava_time_temporal_ChronoField.getArrayOf().constr)([$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()]);
}
$c_Ljava_time_temporal_ChronoField$.prototype = new $h_O();
$c_Ljava_time_temporal_ChronoField$.prototype.constructor = $c_Ljava_time_temporal_ChronoField$;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$() {
}
$h_Ljava_time_temporal_ChronoField$.prototype = $c_Ljava_time_temporal_ChronoField$.prototype;
$c_Ljava_time_temporal_ChronoField$.prototype.values__ALjava_time_temporal_ChronoField = (function() {
  var this$1 = $n(this.Ljava_time_temporal_ChronoField$__f_$values);
  return this$1.clone__O();
});
var $d_Ljava_time_temporal_ChronoField$ = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$, "java.time.temporal.ChronoField$", ({
  Ljava_time_temporal_ChronoField$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ljava_time_temporal_ChronoField$;
function $m_Ljava_time_temporal_ChronoField$() {
  if ((!$n_Ljava_time_temporal_ChronoField$)) {
    $n_Ljava_time_temporal_ChronoField$ = new $c_Ljava_time_temporal_ChronoField$();
  }
  return $n_Ljava_time_temporal_ChronoField$;
}
function $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__NANOS;
}
function $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MICROS;
}
function $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MILLIS;
}
function $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__SECONDS;
}
function $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MINUTES;
}
function $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__HOURS;
}
function $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS;
}
function $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__DAYS;
}
function $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__WEEKS;
}
function $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MONTHS;
}
function $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__YEARS;
}
function $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__DECADES;
}
function $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__CENTURIES;
}
function $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA;
}
function $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__ERAS;
}
function $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__FOREVER;
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$() {
  $n_Ljava_time_temporal_ChronoUnit$ = this;
  $t_Ljava_time_temporal_ChronoUnit$__NANOS = new $c_Ljava_time_temporal_ChronoUnit$$anon$1();
  $t_Ljava_time_temporal_ChronoUnit$__MICROS = new $c_Ljava_time_temporal_ChronoUnit$$anon$2();
  $t_Ljava_time_temporal_ChronoUnit$__MILLIS = new $c_Ljava_time_temporal_ChronoUnit$$anon$3();
  $t_Ljava_time_temporal_ChronoUnit$__SECONDS = new $c_Ljava_time_temporal_ChronoUnit$$anon$4();
  $t_Ljava_time_temporal_ChronoUnit$__MINUTES = new $c_Ljava_time_temporal_ChronoUnit$$anon$5();
  $t_Ljava_time_temporal_ChronoUnit$__HOURS = new $c_Ljava_time_temporal_ChronoUnit$$anon$6();
  $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = new $c_Ljava_time_temporal_ChronoUnit$$anon$7();
  $t_Ljava_time_temporal_ChronoUnit$__DAYS = new $c_Ljava_time_temporal_ChronoUnit$$anon$8();
  $t_Ljava_time_temporal_ChronoUnit$__WEEKS = new $c_Ljava_time_temporal_ChronoUnit$$anon$9();
  $t_Ljava_time_temporal_ChronoUnit$__MONTHS = new $c_Ljava_time_temporal_ChronoUnit$$anon$10();
  $t_Ljava_time_temporal_ChronoUnit$__YEARS = new $c_Ljava_time_temporal_ChronoUnit$$anon$11();
  $t_Ljava_time_temporal_ChronoUnit$__DECADES = new $c_Ljava_time_temporal_ChronoUnit$$anon$12();
  $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = new $c_Ljava_time_temporal_ChronoUnit$$anon$13();
  $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = new $c_Ljava_time_temporal_ChronoUnit$$anon$14();
  $t_Ljava_time_temporal_ChronoUnit$__ERAS = new $c_Ljava_time_temporal_ChronoUnit$$anon$15();
  $t_Ljava_time_temporal_ChronoUnit$__FOREVER = new $c_Ljava_time_temporal_ChronoUnit$$anon$16();
  $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
}
$c_Ljava_time_temporal_ChronoUnit$.prototype = new $h_O();
$c_Ljava_time_temporal_ChronoUnit$.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$() {
}
$h_Ljava_time_temporal_ChronoUnit$.prototype = $c_Ljava_time_temporal_ChronoUnit$.prototype;
var $d_Ljava_time_temporal_ChronoUnit$ = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$, "java.time.temporal.ChronoUnit$", ({
  Ljava_time_temporal_ChronoUnit$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ljava_time_temporal_ChronoUnit$;
function $m_Ljava_time_temporal_ChronoUnit$() {
  if ((!$n_Ljava_time_temporal_ChronoUnit$)) {
    $n_Ljava_time_temporal_ChronoUnit$ = new $c_Ljava_time_temporal_ChronoUnit$();
  }
  return $n_Ljava_time_temporal_ChronoUnit$;
}
function $as_Ljava_time_zone_StandardZoneRules(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.StandardZoneRules"));
}
function $isArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_StandardZoneRules)));
}
function $asArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.StandardZoneRules;", depth));
}
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$Fixed(offset) {
  this.Ljava_time_zone_ZoneRules$Fixed__f_offset = null;
  this.Ljava_time_zone_ZoneRules$Fixed__f_offset = offset;
}
$c_Ljava_time_zone_ZoneRules$Fixed.prototype = new $h_Ljava_time_zone_ZoneRules();
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.constructor = $c_Ljava_time_zone_ZoneRules$Fixed;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$Fixed() {
}
$h_Ljava_time_zone_ZoneRules$Fixed.prototype = $c_Ljava_time_zone_ZoneRules$Fixed.prototype;
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z = (function(dateTime, offset) {
  var x = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return ((x === null) ? (offset === null) : $n(x).equals__O__Z(offset));
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed)) {
    var fixed = $as_Ljava_time_zone_ZoneRules$Fixed(obj);
    if ((this === fixed)) {
      return true;
    } else {
      var x = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      var x$2 = $n(fixed).Ljava_time_zone_ZoneRules$Fixed__f_offset;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    }
  } else if (false) {
    var rules = $as_Ljava_time_zone_StandardZoneRules(obj);
    if ($n(rules).isFixedOffset__Z()) {
      var x$3 = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      var x$4 = $n(rules).getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant());
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.hashCode__I = (function() {
  var this$1 = $n(this.Ljava_time_zone_ZoneRules$Fixed__f_offset);
  var $x_1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $n(this.Ljava_time_zone_ZoneRules$Fixed__f_offset);
  return (1 ^ (((31 + $x_1) | 0) ^ ((31 + this$2.Ljava_time_ZoneOffset__f_totalSeconds) | 0)));
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.toString__T = (function() {
  return ("FixedRules:" + this.Ljava_time_zone_ZoneRules$Fixed__f_offset);
});
function $as_Ljava_time_zone_ZoneRules$Fixed(obj) {
  return (((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRules$Fixed"));
}
function $isArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRules$Fixed)));
}
function $asArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRules$Fixed;", depth));
}
var $d_Ljava_time_zone_ZoneRules$Fixed = new $TypeData().initClass($c_Ljava_time_zone_ZoneRules$Fixed, "java.time.zone.ZoneRules$Fixed", ({
  Ljava_time_zone_ZoneRules$Fixed: 1,
  Ljava_time_zone_ZoneRules: 1,
  Ljava_io_Serializable: 1
}));
function $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z($thiz, iter, o$2) {
  while (true) {
    if ($n(iter).hasNext__Z()) {
      var a = $n(iter).next__O();
      if ((!((a === null) ? (o$2 === null) : $dp_equals__O__Z($n(a), o$2)))) {
        continue;
      }
      $n(iter).remove__V();
      return true;
    } else {
      return false;
    }
  }
}
/** @constructor */
function $c_ju_AbstractCollection() {
}
$c_ju_AbstractCollection.prototype = new $h_O();
$c_ju_AbstractCollection.prototype.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
}
$h_ju_AbstractCollection.prototype = $c_ju_AbstractCollection.prototype;
$c_ju_AbstractCollection.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0);
});
$c_ju_AbstractCollection.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.iterator__ju_Iterator();
  while ($n(_\uff3fself).hasNext__Z()) {
    var t = $n(_\uff3fself).next__O();
    if (((o === null) ? (t === null) : $dp_equals__O__Z($n(o), t))) {
      return true;
    }
  }
  return false;
});
$c_ju_AbstractCollection.prototype.toArray__AO__AO = (function(a) {
  if (($n(a).u.length >= this.size__I())) {
    var toFill = a;
  } else {
    var this$1 = $n(a);
    var this$2 = $objectGetClass(this$1);
    var componentType = this$2.data.getComponentType();
    var length = this.size__I();
    var toFill = $asArrayOf_O($n(componentType).data.newArray(length), 1);
  }
  var iter = this.iterator__ju_Iterator();
  var end = this.size__I();
  var i = 0;
  while ((i < end)) {
    var value = i;
    $n(toFill).set(value, $n(iter).next__O());
    i = ((1 + i) | 0);
  }
  if (($n(toFill).u.length > this.size__I())) {
    $n(toFill).set(this.size__I(), null);
  }
  return toFill;
});
$c_ju_AbstractCollection.prototype.remove__O__Z = (function(o) {
  return $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z(this, this.iterator__ju_Iterator(), o);
});
$c_ju_AbstractCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = $n(c).iterator__ju_Iterator();
  _return: {
    while ($n(_\uff3fself).hasNext__Z()) {
      var t = $n(_\uff3fself).next__O();
      if ((!this.contains__O__Z(t))) {
        var $x_1 = true;
        break _return;
      }
    }
    var $x_1 = false;
  }
  return (!$x_1);
});
$c_ju_AbstractCollection.prototype.toString__T = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = "[";
  var first = true;
  while ($n(_\uff3fself).hasNext__Z()) {
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (("" + result) + $n(_\uff3fself).next__O());
  }
  return (result + "]");
});
function $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__($thiz, inner) {
  $thiz.ju_Collections$UnmodifiableIterator__f_inner = inner;
  return $thiz;
}
/** @constructor */
function $c_ju_Collections$UnmodifiableIterator() {
  this.ju_Collections$UnmodifiableIterator__f_inner = null;
}
$c_ju_Collections$UnmodifiableIterator.prototype = new $h_O();
$c_ju_Collections$UnmodifiableIterator.prototype.constructor = $c_ju_Collections$UnmodifiableIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableIterator() {
}
$h_ju_Collections$UnmodifiableIterator.prototype = $c_ju_Collections$UnmodifiableIterator.prototype;
$c_ju_Collections$UnmodifiableIterator.prototype.hasNext__Z = (function() {
  return $n(this.ju_Collections$UnmodifiableIterator__f_inner).hasNext__Z();
});
$c_ju_Collections$UnmodifiableIterator.prototype.next__O = (function() {
  return $n(this.ju_Collections$UnmodifiableIterator__f_inner).next__O();
});
$c_ju_Collections$UnmodifiableIterator.prototype.remove__V = (function() {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
var $d_ju_Collections$UnmodifiableIterator = new $TypeData().initClass($c_ju_Collections$UnmodifiableIterator, "java.util.Collections$UnmodifiableIterator", ({
  ju_Collections$UnmodifiableIterator: 1,
  ju_Collections$WrappedIterator: 1,
  ju_Iterator: 1
}));
/** @constructor */
function $c_ju_HashMap$NodeIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer);
}
$c_ju_HashMap$NodeIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$NodeIterator.prototype.constructor = $c_ju_HashMap$NodeIterator;
/** @constructor */
function $h_ju_HashMap$NodeIterator() {
}
$h_ju_HashMap$NodeIterator.prototype = $c_ju_HashMap$NodeIterator.prototype;
$c_ju_HashMap$NodeIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node;
});
var $d_ju_HashMap$NodeIterator = new $TypeData().initClass($c_ju_HashMap$NodeIterator, "java.util.HashMap$NodeIterator", ({
  ju_HashMap$NodeIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  ju_Iterator: 1
}));
/** @constructor */
function $c_ju_HashMap$ValueIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer);
}
$c_ju_HashMap$ValueIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$ValueIterator.prototype.constructor = $c_ju_HashMap$ValueIterator;
/** @constructor */
function $h_ju_HashMap$ValueIterator() {
}
$h_ju_HashMap$ValueIterator.prototype = $c_ju_HashMap$ValueIterator.prototype;
$c_ju_HashMap$ValueIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return $n(node).ju_HashMap$Node__f_value;
});
var $d_ju_HashMap$ValueIterator = new $TypeData().initClass($c_ju_HashMap$ValueIterator, "java.util.HashMap$ValueIterator", ({
  ju_HashMap$ValueIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  ju_Iterator: 1
}));
/** @constructor */
function $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, older, younger) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  this.ju_LinkedHashMap$Node__f_older = null;
  this.ju_LinkedHashMap$Node__f_younger = null;
  this.ju_LinkedHashMap$Node__f_older = older;
  this.ju_LinkedHashMap$Node__f_younger = younger;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next);
}
$c_ju_LinkedHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_LinkedHashMap$Node.prototype.constructor = $c_ju_LinkedHashMap$Node;
/** @constructor */
function $h_ju_LinkedHashMap$Node() {
}
$h_ju_LinkedHashMap$Node.prototype = $c_ju_LinkedHashMap$Node.prototype;
function $as_ju_LinkedHashMap$Node(obj) {
  return (((obj instanceof $c_ju_LinkedHashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.LinkedHashMap$Node"));
}
function $isArrayOf_ju_LinkedHashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_LinkedHashMap$Node)));
}
function $asArrayOf_ju_LinkedHashMap$Node(obj, depth) {
  return (($isArrayOf_ju_LinkedHashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.LinkedHashMap$Node;", depth));
}
var $d_ju_LinkedHashMap$Node = new $TypeData().initClass($c_ju_LinkedHashMap$Node, "java.util.LinkedHashMap$Node", ({
  ju_LinkedHashMap$Node: 1,
  ju_HashMap$Node: 1,
  ju_Map$Entry: 1
}));
/** @constructor */
function $c_ju_LinkedHashMap$NodeIterator(outer) {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer);
}
$c_ju_LinkedHashMap$NodeIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$c_ju_LinkedHashMap$NodeIterator.prototype.constructor = $c_ju_LinkedHashMap$NodeIterator;
/** @constructor */
function $h_ju_LinkedHashMap$NodeIterator() {
}
$h_ju_LinkedHashMap$NodeIterator.prototype = $c_ju_LinkedHashMap$NodeIterator.prototype;
$c_ju_LinkedHashMap$NodeIterator.prototype.extract__ju_LinkedHashMap$Node__O = (function(node) {
  return node;
});
var $d_ju_LinkedHashMap$NodeIterator = new $TypeData().initClass($c_ju_LinkedHashMap$NodeIterator, "java.util.LinkedHashMap$NodeIterator", ({
  ju_LinkedHashMap$NodeIterator: 1,
  ju_LinkedHashMap$AbstractLinkedHashMapIterator: 1,
  ju_Iterator: 1
}));
/** @constructor */
function $c_ju_LinkedHashMap$ValueIterator(outer) {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer);
}
$c_ju_LinkedHashMap$ValueIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$c_ju_LinkedHashMap$ValueIterator.prototype.constructor = $c_ju_LinkedHashMap$ValueIterator;
/** @constructor */
function $h_ju_LinkedHashMap$ValueIterator() {
}
$h_ju_LinkedHashMap$ValueIterator.prototype = $c_ju_LinkedHashMap$ValueIterator.prototype;
$c_ju_LinkedHashMap$ValueIterator.prototype.extract__ju_LinkedHashMap$Node__O = (function(node) {
  return $n(node).ju_HashMap$Node__f_value;
});
var $d_ju_LinkedHashMap$ValueIterator = new $TypeData().initClass($c_ju_LinkedHashMap$ValueIterator, "java.util.LinkedHashMap$ValueIterator", ({
  ju_LinkedHashMap$ValueIterator: 1,
  ju_LinkedHashMap$AbstractLinkedHashMapIterator: 1,
  ju_Iterator: 1
}));
function $s_ju_Locale$Category$__DISPLAY__ju_Locale$Category() {
  $m_ju_Locale$Category$();
  return $t_ju_Locale$Category$__DISPLAY;
}
function $s_ju_Locale$Category$__FORMAT__ju_Locale$Category() {
  $m_ju_Locale$Category$();
  return $t_ju_Locale$Category$__FORMAT;
}
/** @constructor */
function $c_ju_Locale$Category$() {
  this.ju_Locale$Category$__f_$values = null;
  $n_ju_Locale$Category$ = this;
  $t_ju_Locale$Category$__DISPLAY = new $c_ju_Locale$Category$$anon$2();
  $t_ju_Locale$Category$__FORMAT = new $c_ju_Locale$Category$$anon$3();
  this.ju_Locale$Category$__f_$values = new ($d_ju_Locale$Category.getArrayOf().constr)([$s_ju_Locale$Category$__DISPLAY__ju_Locale$Category(), $s_ju_Locale$Category$__FORMAT__ju_Locale$Category()]);
}
$c_ju_Locale$Category$.prototype = new $h_O();
$c_ju_Locale$Category$.prototype.constructor = $c_ju_Locale$Category$;
/** @constructor */
function $h_ju_Locale$Category$() {
}
$h_ju_Locale$Category$.prototype = $c_ju_Locale$Category$.prototype;
$c_ju_Locale$Category$.prototype.values__Aju_Locale$Category = (function() {
  var this$1 = $n(this.ju_Locale$Category$__f_$values);
  return this$1.clone__O();
});
var $d_ju_Locale$Category$ = new $TypeData().initClass($c_ju_Locale$Category$, "java.util.Locale$Category$", ({
  ju_Locale$Category$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_ju_Locale$Category$;
function $m_ju_Locale$Category$() {
  if ((!$n_ju_Locale$Category$)) {
    $n_ju_Locale$Category$ = new $c_ju_Locale$Category$();
  }
  return $n_ju_Locale$Category$;
}
/** @constructor */
function $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next);
}
$c_ju_NullRejectingHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_NullRejectingHashMap$Node.prototype.constructor = $c_ju_NullRejectingHashMap$Node;
/** @constructor */
function $h_ju_NullRejectingHashMap$Node() {
}
$h_ju_NullRejectingHashMap$Node.prototype = $c_ju_NullRejectingHashMap$Node.prototype;
var $d_ju_NullRejectingHashMap$Node = new $TypeData().initClass($c_ju_NullRejectingHashMap$Node, "java.util.NullRejectingHashMap$Node", ({
  ju_NullRejectingHashMap$Node: 1,
  ju_HashMap$Node: 1,
  ju_Map$Entry: 1
}));
function $p_ju_Random__loop$1__I__I($thiz, n$1) {
  while (true) {
    var bits = $thiz.next__I__I(31);
    var value = ((bits % $checkIntDivisor(n$1)) | 0);
    if ((((((bits - value) | 0) + ((n$1 - 1) | 0)) | 0) < 0)) {
    } else {
      return value;
    }
  }
}
function $ct_ju_Random__J__($thiz, seed_in_$_lo, seed_in_$_hi) {
  $thiz.setSeed__J__V(seed_in_$_lo, seed_in_$_hi);
  return $thiz;
}
function $ct_ju_Random__($thiz) {
  var $x_1 = $m_ju_Random$().java$util$Random$$randomSeed__J();
  $ct_ju_Random__J__($thiz, $x_1.l, $x_1.h);
  return $thiz;
}
/** @constructor */
function $c_ju_Random() {
  this.ju_Random__f_java$util$Random$$seed_$lo = 0;
  this.ju_Random__f_java$util$Random$$seed_$hi = 0;
}
$c_ju_Random.prototype = new $h_O();
$c_ju_Random.prototype.constructor = $c_ju_Random;
/** @constructor */
function $h_ju_Random() {
}
$h_ju_Random.prototype = $c_ju_Random.prototype;
$c_ju_Random.prototype.setSeed__J__V = (function(seed_in_$_lo, seed_in_$_hi) {
  var lo = ((-554899859) ^ seed_in_$_lo);
  var hi = (5 ^ seed_in_$_hi);
  var hi$1 = (65535 & hi);
  this.ju_Random__f_java$util$Random$$seed_$lo = lo;
  this.ju_Random__f_java$util$Random$$seed_$hi = hi$1;
});
$c_ju_Random.prototype.next__I__I = (function(bits) {
  var x_$_lo = this.ju_Random__f_java$util$Random$$seed_$lo;
  var x_$_hi = this.ju_Random__f_java$util$Random$$seed_$hi;
  var b0 = (65535 & x_$_lo);
  var b1 = ((x_$_lo >>> 16) | 0);
  var a1b0 = Math.imul(58989, b0);
  var lo = (a1b0 << 16);
  var hi = ((((((Math.imul((-429064192), x_$_hi) + Math.imul(384748, x_$_lo)) | 0) + Math.imul(58989, b1)) | 0) + ((a1b0 >>> 16) | 0)) | 0);
  var lo$1 = ((720896 + lo) | 0);
  var hi$1 = ((hi + (((lo & (~lo$1)) >>> 31) | 0)) | 0);
  var lo$2 = (((lo$1 >>> 16) | 0) | (hi$1 << 16));
  var hi$2 = ((hi$1 >>> 16) | 0);
  this.ju_Random__f_java$util$Random$$seed_$lo = lo$2;
  this.ju_Random__f_java$util$Random$$seed_$hi = hi$2;
  return ((hi$1 >>> ((-bits) | 0)) | 0);
});
$c_ju_Random.prototype.nextInt__I__I = (function(n) {
  if ((n <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "n must be positive");
  } else {
    return (((n & ((-n) | 0)) === n) ? (this.next__I__I(31) >> Math.clz32(n)) : $p_ju_Random__loop$1__I__I(this, n));
  }
});
var $d_ju_Random = new $TypeData().initClass($c_ju_Random, "java.util.Random", ({
  ju_Random: 1,
  ju_random_RandomGenerator: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer);
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator() {
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node;
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$NodeIterator", ({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  ju_Iterator: 1
}));
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer);
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator() {
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return $n(node).ju_HashMap$Node__f_value;
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$ValueIterator", ({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  ju_Iterator: 1
}));
function $ct_ju_concurrent_atomic_AtomicInteger__I__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = value;
  return $thiz;
}
function $ct_ju_concurrent_atomic_AtomicInteger__($thiz) {
  $ct_ju_concurrent_atomic_AtomicInteger__I__($thiz, 0);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicInteger() {
  this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = 0;
}
$c_ju_concurrent_atomic_AtomicInteger.prototype = new $h_jl_Number();
$c_ju_concurrent_atomic_AtomicInteger.prototype.constructor = $c_ju_concurrent_atomic_AtomicInteger;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicInteger() {
}
$h_ju_concurrent_atomic_AtomicInteger.prototype = $c_ju_concurrent_atomic_AtomicInteger.prototype;
$c_ju_concurrent_atomic_AtomicInteger.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value;
  return ("" + this$1);
});
var $d_ju_concurrent_atomic_AtomicInteger = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicInteger, "java.util.concurrent.atomic.AtomicInteger", ({
  ju_concurrent_atomic_AtomicInteger: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_atomic_AtomicLong(value_$_lo, value_$_hi) {
  this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value_$lo = 0;
  this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value_$hi = 0;
  this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value_$lo = value_$_lo;
  this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value_$hi = value_$_hi;
}
$c_ju_concurrent_atomic_AtomicLong.prototype = new $h_jl_Number();
$c_ju_concurrent_atomic_AtomicLong.prototype.constructor = $c_ju_concurrent_atomic_AtomicLong;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicLong() {
}
$h_ju_concurrent_atomic_AtomicLong.prototype = $c_ju_concurrent_atomic_AtomicLong.prototype;
$c_ju_concurrent_atomic_AtomicLong.prototype.toString__T = (function() {
  var this$1_$_lo = this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value_$lo;
  var this$1_$_hi = this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value_$hi;
  return $m_RTLong$().toString__I__I__T(this$1_$_lo, this$1_$_hi);
});
var $d_ju_concurrent_atomic_AtomicLong = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicLong, "java.util.concurrent.atomic.AtomicLong", ({
  ju_concurrent_atomic_AtomicLong: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llocales_cldr_CalendarPatterns$() {
  $n_Llocales_cldr_CalendarPatterns$ = this;
  $m_Llocales_cldr_CalendarPatterns$();
}
$c_Llocales_cldr_CalendarPatterns$.prototype = new $h_O();
$c_Llocales_cldr_CalendarPatterns$.prototype.constructor = $c_Llocales_cldr_CalendarPatterns$;
/** @constructor */
function $h_Llocales_cldr_CalendarPatterns$() {
}
$h_Llocales_cldr_CalendarPatterns$.prototype = $c_Llocales_cldr_CalendarPatterns$.prototype;
$c_Llocales_cldr_CalendarPatterns$.prototype.toString__T = (function() {
  return "CalendarPatterns";
});
var $d_Llocales_cldr_CalendarPatterns$ = new $TypeData().initClass($c_Llocales_cldr_CalendarPatterns$, "locales.cldr.CalendarPatterns$", ({
  Llocales_cldr_CalendarPatterns$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Llocales_cldr_CalendarPatterns$;
function $m_Llocales_cldr_CalendarPatterns$() {
  if ((!$n_Llocales_cldr_CalendarPatterns$)) {
    $n_Llocales_cldr_CalendarPatterns$ = new $c_Llocales_cldr_CalendarPatterns$();
  }
  return $n_Llocales_cldr_CalendarPatterns$;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$() {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_tyrian$TyrianApp$$evidence$1 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_run = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_nodeNames = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_storageKey = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_visitor = null;
  $n_Lnet_andimiller_hedgehogs_dag_visitor_Demo$ = this;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_tyrian$TyrianApp$$evidence$1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
  $f_Ltyrian_TyrianIOApp__$init$__V(this);
  var this$2 = new $c_sr_RichChar(65);
  var this$5 = $n($f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$2, $bC(90)));
  var this$4 = new $c_sr_RichChar(97);
  var suffix = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$4, $bC(122));
  this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_nodeNames = $as_sci_Seq($n($as_sc_IndexedSeqOps($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this$5, suffix))).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    var _$1$1 = $uC(_$1);
    return ("" + $cToS(_$1$1));
  }))));
  this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_storageKey = "hedgehogs-dag-snapshot";
  this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_visitor = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4();
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Demo$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.makeProgram__I__I__I__Lnet_andimiller_hedgehogs_DataGraph = (function(nodes, edges, approvals) {
  var nodeGraph = $as_Lnet_andimiller_hedgehogs_DataGraph($n($as_sc_IterableOnceOps($n(this.Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_nodeNames).take__I__O(nodes))).foldLeft__O__F2__O($m_Lnet_andimiller_hedgehogs_DataGraph$().empty__Lnet_andimiller_hedgehogs_DataGraph(), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((x$1, x$2) => {
    var x$1$1 = $as_Lnet_andimiller_hedgehogs_DataGraph(x$1);
    var x$2$1 = $as_T(x$2);
    var $x_1 = $n(x$1$1);
    var this$2 = $n(x$2$1);
    var this$4 = new $c_s_concurrent_duration_package$DurationInt(1);
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
    var this$ = this$4.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    $m_s_concurrent_duration_Duration$();
    var hi = (this$ >> 31);
    var n = new $c_s_concurrent_duration_FiniteDuration(this$, hi, unit);
    return $x_1.addNode__O__O__Lnet_andimiller_hedgehogs_DataGraph(this$2, new $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(n));
  }))));
  var this$9 = $n(nodeGraph);
  var this$10 = $n($n(this$9.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).keySet__sci_Set());
  var nodesVector = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$10);
  var isEmpty = (edges < 0);
  var scala$collection$immutable$Range$$numRangeElements = ((1 + edges) | 0);
  var at = 0;
  if (isEmpty) {
    var end = 0;
  } else {
    if ((scala$collection$immutable$Range$$numRangeElements <= 0)) {
      $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, edges, 1, true);
    }
    var end = scala$collection$immutable$Range$$numRangeElements;
  }
  var acc = nodeGraph;
  var $x_2;
  while (true) {
    if ((at !== end)) {
      var temp$at = ((1 + at) | 0);
      var x0 = acc;
      var i = at;
      if ((((i < 0) || (i >= scala$collection$immutable$Range$$numRangeElements)) || isEmpty)) {
        if (((scala$collection$immutable$Range$$numRangeElements <= 0) && (!isEmpty))) {
          $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, edges, 1, true);
        }
        var max = (isEmpty ? (-1) : ((scala$collection$immutable$Range$$numRangeElements - 1) | 0));
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((i + " is out of bounds (min 0, max ") + max) + ")"));
      }
      var x$1$2 = $as_Lnet_andimiller_hedgehogs_DataGraph(x0);
      var $x_3 = $m_s_util_Random$();
      var this$16 = $n(x$1$2);
      var from = $as_T($n(nodesVector).apply__I__O($x_3.between__I__I__I(0, $n($n(this$16.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).keySet__sci_Set()).size__I())));
      var $x_4 = $m_s_util_Random$();
      var this$17 = $n(x$1$2);
      var to = $as_T($n(nodesVector).apply__I__O($x_4.between__I__I__I(0, $n($n(this$17.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).keySet__sci_Set()).size__I())));
      if ((from !== to)) {
        var nextGraph = $n(x$1$2).addEdge__O__O__O__Lnet_andimiller_hedgehogs_DataGraph(from, to, (void 0));
        var temp$acc = ($uZ($n($m_Lnet_andimiller_hedgehogs_Dag$().isDag__Lnet_andimiller_hedgehogs_SimpleGraph__Lcats_Eval(nextGraph)).value__O()) ? nextGraph : x$1$2);
      } else {
        var temp$acc = x$1$2;
      }
      at = temp$at;
      acc = temp$acc;
      continue;
    }
    var $x_2 = acc;
    break;
  }
  var withEdges = $as_Lnet_andimiller_hedgehogs_DataGraph($x_2);
  var $x_5 = $m_s_util_Random$();
  var this$18 = $m_sc_BuildFrom$();
  var this$20 = $n($as_sci_Vector($x_5.shuffle__sc_IterableOnce__sc_BuildFrom__O(nodesVector, new $c_sc_BuildFromLowPriority2$$anon$11(this$18))));
  $m_Lcats_implicits$();
  var evidence$1 = $as_Lcats_kernel_Order($m_Lcats_implicits$().Lcats_implicits$__f_catsKernelStdOrderForInt);
  var n$1 = $uI(new $c_Lcats_syntax_OrderOps(approvals, evidence$1).min__O__O(nodes));
  var this$21 = $n(this$20.slice__I__I__sci_Vector(0, n$1));
  var at$1 = 0;
  var end$1 = this$21.length__I();
  var acc$1 = withEdges;
  var $x_6;
  while (true) {
    if ((at$1 !== end$1)) {
      var temp$at$1 = ((1 + at$1) | 0);
      var x0$1 = acc$1;
      var x1 = this$21.apply__I__O(at$1);
      var x$1$3 = $as_Lnet_andimiller_hedgehogs_DataGraph(x0$1);
      var x$2$2 = $as_T(x1);
      var temp$acc$1;
      var temp$acc$1 = $n(x$1$3).addNode__O__O__Lnet_andimiller_hedgehogs_DataGraph(x$2$2, $s_Lnet_andimiller_hedgehogs_dag_visitor_Node$__Approval__Lnet_andimiller_hedgehogs_dag_visitor_Node());
      at$1 = temp$at$1;
      acc$1 = temp$acc$1;
      continue;
    }
    var $x_6 = acc$1;
    break;
  }
  return $as_Lnet_andimiller_hedgehogs_DataGraph($x_6);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.events__Lcats_effect_std_Queue__F1 = (function(queue) {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent(x$1);
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted)) {
      var x$1$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted(x$1$1);
      var this$2 = $n(x$1$2);
      var x48 = $as_T(this$2.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted__f_id);
      var state = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Running__Lnet_andimiller_hedgehogs_dag_visitor_State();
      return $as_Lcats_effect_IO($n(queue).offer__O__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(x48, state)));
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended)) {
      var x$1$3 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended(x$1$1);
      var this$5 = $n(x$1$3);
      var x44 = $as_T(this$5.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_id);
      var this$6 = $n(x$1$3);
      $as_T(this$6.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_handle);
      var state$1 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Suspended__Lnet_andimiller_hedgehogs_dag_visitor_State();
      return $as_Lcats_effect_IO($n(queue).offer__O__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(x44, state$1)));
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed)) {
      var x$1$4 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed(x$1$1);
      var this$9 = $n(x$1$4);
      var x40 = $as_T(this$9.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_id);
      var this$10 = $n(x$1$4);
      $as_T(this$10.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_handle);
      var state$2 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Running__Lnet_andimiller_hedgehogs_dag_visitor_State();
      return $as_Lcats_effect_IO($n(queue).offer__O__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(x40, state$2)));
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted)) {
      var x$1$5 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted(x$1$1);
      var this$13 = $n(x$1$5);
      var x37 = $as_T(this$13.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted__f_id);
      var state$3 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done__Lnet_andimiller_hedgehogs_dag_visitor_State();
      return $as_Lcats_effect_IO($n(queue).offer__O__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(x37, state$3)));
    }
    throw new $c_s_MatchError(x$1$1);
  }));
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.foldRun__Lcats_effect_std_Queue__Lcats_effect_IO__Lcats_effect_IO = (function(queue, run) {
  var this$1 = $n(run);
  return $n($n(new $c_Lcats_effect_IO$Attempt(this$1).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    var _$2$1 = $as_s_util_Either(_$2);
    var this$3 = $n(_$2$1);
    if ((this$3 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(this$3);
      var b = $n(x2).s_util_Right__f_value;
      var result = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunResult(b);
      var $x_1 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted(result);
    } else {
      if ((!(this$3 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(this$3);
      }
      var x3 = $as_s_util_Left(this$3);
      var a = $n(x3).s_util_Left__f_value;
      var e = $as_jl_Throwable(a);
      var message = $n(e).getMessage__T();
      var $x_1 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed(message);
    }
    return $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg($x_1);
  })))).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a$1) => {
    var a$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg(a$1);
    return $as_Lcats_effect_IO($n(queue).offer__O__O(a$2));
  })))).as__O__Lcats_effect_IO($s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__NoOp__Lnet_andimiller_hedgehogs_dag_visitor_Msg());
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.waitingIds__Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__sci_List = (function(snap) {
  var this$3 = $n($n($as_sc_IterableOnceOps($n($n($n(snap).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).collect__s_PartialFunction__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5()))).toList__sci_List());
  $m_Lcats_implicits$();
  var ev = $as_Lcats_kernel_Order($m_Lcats_implicits$().Lcats_implicits$__f_catsKernelStdOrderForString);
  var this$2 = $n(ev);
  var ord = new $c_Lcats_kernel_Order$$anon$1(this$2);
  return $as_sci_List($f_sc_SeqOps__sorted__s_math_Ordering__O(this$3, ord));
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.init__sci_Map__T2 = (function(flags) {
  new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
  var $x_2 = $m_Ljava_time_Instant$();
  var value = $uD(Date.now());
  var $x_1 = $m_RTLong$().fromDouble__D__J(value);
  var startTime = $x_2.ofEpochMilli__J__Ljava_time_Instant($x_1.l, $x_1.h);
  var graph = $n(this.makeProgram__I__I__I__Lnet_andimiller_hedgehogs_DataGraph(5, 5, 0)).mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((n) => {
    var n$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(n);
    var _2 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending__Lnet_andimiller_hedgehogs_dag_visitor_State();
    return new $c_T2(n$1, _2);
  })));
  var this$6 = $m_sci_Vector$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var messages = this$6.from__sc_IterableOnce__sci_Vector(elems);
  var queue = $m_s_None$();
  var snapshot = $m_s_None$();
  var graphviz = $m_s_None$();
  var _1 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime, graph, messages, queue, 5, 5, 0, false, snapshot, "", graphviz);
  var $x_5 = $m_sr_ScalaRunTime$();
  var $x_4 = $m_Ltyrian_Cmd$Run$().apply__O__Lcats_Applicative__Ltyrian_Cmd$Run($n($as_Lcats_effect_IO($m_Lcats_effect_std_Queue$().unbounded__Lcats_effect_kernel_GenConcurrent__O($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO))).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((queue$1) => {
    var queue$2 = $as_Lcats_effect_std_Queue(queue$1);
    return new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated(queue$2);
  }))), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
  var msg = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
  var $x_3 = new $c_Ltyrian_Cmd$Emit(msg);
  var msg$1 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadGraphviz__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
  var cmds = $x_5.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$x_4, $x_3, new $c_Ltyrian_Cmd$Emit(msg$1)]));
  var this$14 = $n(cmds);
  var cmds$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$14);
  var _2$1 = new $c_Ltyrian_Cmd$Batch(cmds$1);
  return new $c_T2(_1, _2$1);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.update__Lnet_andimiller_hedgehogs_dag_visitor_Model__F1 = (function(model) {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg(x$1);
    var x = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__NoOp__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
    if (((x === null) ? (x$1$1 === null) : $n(x).equals__O__Z(x$1$1))) {
      var _2 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(model, _2);
    }
    var x$3 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Start__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
    if (((x$3 === null) ? (x$1$1 === null) : $n(x$3).equals__O__Z(x$1$1))) {
      if ($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running) {
        var _2$1 = $m_Ltyrian_Cmd$None$();
        return new $c_T2(model, _2$1);
      }
      new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
      var $x_2 = $m_Ljava_time_Instant$();
      var value = $uD(Date.now());
      var $x_1 = $m_RTLong$().fromDouble__D__J(value);
      var startTime$1 = $x_2.ofEpochMilli__J__Ljava_time_Instant($x_1.l, $x_1.h);
      var graph$1 = $n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph).mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
        var x$1$3 = $as_T2(x$1$2);
        if ((x$1$3 !== null)) {
          var n = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node($n(x$1$3)._1__O());
          var y = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending__Lnet_andimiller_hedgehogs_dag_visitor_State();
          return new $c_T2(n, y);
        }
        throw new $c_s_MatchError(x$1$3);
      })));
      var snapshot$1 = $m_s_None$();
      var this$9 = $n(model);
      var messages$1 = this$9.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$10 = $n(model);
      var queue$1 = this$10.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$11 = $n(model);
      var nodes$1 = this$11.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$12 = $n(model);
      var edges$1 = this$12.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$13 = $n(model);
      var approvals$1 = this$13.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$14 = $n(model);
      var graphviz$1 = this$14.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      $n(model);
      var _1 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$1, graph$1, messages$1, queue$1, nodes$1, edges$1, approvals$1, true, snapshot$1, "", graphviz$1);
      var $x_7 = $m_sr_ScalaRunTime$();
      var msg = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ClearLog__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
      var $x_6 = new $c_Ltyrian_Cmd$Emit(msg);
      var msg$1 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SyncNodeColours__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
      var $x_5 = new $c_Ltyrian_Cmd$Emit(msg$1);
      var $x_4 = $m_Ltyrian_Cmd$Run$();
      matchResult21: {
        var $x_3;
        var x66 = $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
        if ((x66 instanceof $c_s_Some)) {
          var q = $as_Lcats_effect_std_Queue($n($as_s_Some(x66)).s_Some__f_value);
          var $x_3 = $m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().foldRun__Lcats_effect_std_Queue__Lcats_effect_IO__Lcats_effect_IO(q, $as_Lcats_effect_IO($m_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$().start__Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor__Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode__F1__Lnet_andimiller_hedgehogs_DataGraph__Lcats_effect_kernel_GenConcurrent__O($m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_visitor, $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$(), $m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().events__Lcats_effect_std_Queue__F1(q), $n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph).mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
            var _$3$1 = $as_T2(_$3);
            return $as_Lnet_andimiller_hedgehogs_dag_visitor_Node($n(_$3$1)._1__O());
          }))), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO)));
          break matchResult21;
        }
        var x$5 = $m_s_None$();
        if ((x$5 === x66)) {
          $m_Lcats_effect_IO$();
          var value$1 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed("event queue not ready yet");
          var $x_3 = new $c_Lcats_effect_IO$Pure(value$1);
          break matchResult21;
        }
        throw new $c_s_MatchError(x66);
      }
      var cmds = $x_7.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$x_6, $x_5, $x_4.apply__O__Lcats_Applicative__Ltyrian_Cmd$Run($x_3, $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO)]));
      var this$22 = $n(cmds);
      var cmds$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$22);
      var _2$2 = new $c_Ltyrian_Cmd$Batch(cmds$1);
      return new $c_T2(_1, _2$2);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve)) {
      var x$1$4 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve(x$1$1);
      var this$27 = $n(x$1$4);
      var x138 = this$27.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve__f_id;
      var x72 = $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      if ((x72 instanceof $c_s_Some)) {
        var snap = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot($n($as_s_Some(x72)).s_Some__f_value);
        if ((!$n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running)) {
          var snapshot$2 = $m_s_None$();
          var this$28 = $n(model);
          var startTime$2 = this$28.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
          var this$29 = $n(model);
          var graph$2 = this$29.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
          var this$30 = $n(model);
          var messages$2 = this$30.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
          var this$31 = $n(model);
          var queue$2 = this$31.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
          var this$32 = $n(model);
          var nodes$2 = this$32.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
          var this$33 = $n(model);
          var edges$2 = this$33.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
          var this$34 = $n(model);
          var approvals$2 = this$34.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
          var this$35 = $n(model);
          var graphviz$2 = this$35.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
          $n(model);
          var _1$1 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$2, graph$2, messages$2, queue$2, nodes$2, edges$2, approvals$2, true, snapshot$2, "", graphviz$2);
          var $x_17 = $m_sr_ScalaRunTime$();
          $m_Ltyrian_Html$();
          var $x_15 = $m_sr_ScalaRunTime$();
          $m_Ltyrian_Html$();
          var plainText = (x138 + " was ");
          var $x_14 = new $c_Ltyrian_Text(plainText);
          var this$39 = $m_Ltyrian_Html$();
          var attributes = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("color:limegreen;")]));
          var children = $x_15.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_14, $f_Ltyrian_HtmlTags__span$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$39, attributes, "approved")]));
          var attributes$1 = $m_sci_Nil$();
          var this$41 = $n(children);
          var children$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$41);
          var key = $m_s_None$();
          var msg$2 = new $c_Ltyrian_Tag("span", attributes$1, children$1, key);
          var msg$3 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$2);
          var $x_16 = new $c_Ltyrian_Cmd$Emit(msg$3);
          var $x_13 = $m_Ltyrian_Cmd$Run$();
          matchResult22: {
            var $x_8;
            var x69 = $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
            if ((x69 instanceof $c_s_Some)) {
              var q$2 = $as_Lcats_effect_std_Queue($n($as_s_Some(x69)).s_Some__f_value);
              var $x_12 = $m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$();
              var $x_11 = $m_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$();
              var $x_10 = $m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_visitor;
              var $x_9 = $m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().events__Lcats_effect_std_Queue__F1(q$2);
              var this$49 = $m_sci_Map$();
              var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2(x138, "approved")]));
              var $x_8 = $x_12.foldRun__Lcats_effect_std_Queue__Lcats_effect_IO__Lcats_effect_IO(q$2, $as_Lcats_effect_IO($x_11.resume__Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor__F1__Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__sci_Map__Lcats_effect_kernel_GenConcurrent__O($x_10, $x_9, snap, this$49.from__sc_IterableOnce__sci_Map(elems), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO)));
              break matchResult22;
            }
            var x$7 = $m_s_None$();
            if ((x$7 === x69)) {
              $m_Lcats_effect_IO$();
              var value$2 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed("event queue not ready yet");
              var $x_8 = new $c_Lcats_effect_IO$Pure(value$2);
              break matchResult22;
            }
            throw new $c_s_MatchError(x69);
          }
          var cmds$2 = $x_17.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$x_16, $x_13.apply__O__Lcats_Applicative__Ltyrian_Cmd$Run($x_8, $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO)]));
          var this$54 = $n(cmds$2);
          var cmds$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$54);
          var _2$3 = new $c_Ltyrian_Cmd$Batch(cmds$3);
          return new $c_T2(_1$1, _2$3);
        }
      }
      var _2$4 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(model, _2$4);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted)) {
      var x$1$5 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted(x$1$1);
      var this$60 = $n(x$1$5);
      var x135 = this$60.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted__f_result;
      if ((x135 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished)) {
        var x$1$6 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished(x135);
        $n(x$1$6);
        var snapshot$3 = $m_s_None$();
        var this$63 = $n(model);
        var startTime$3 = this$63.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
        var this$64 = $n(model);
        var graph$3 = this$64.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
        var this$65 = $n(model);
        var messages$3 = this$65.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
        var this$66 = $n(model);
        var queue$3 = this$66.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
        var this$67 = $n(model);
        var nodes$3 = this$67.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
        var this$68 = $n(model);
        var edges$3 = this$68.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
        var this$69 = $n(model);
        var approvals$3 = this$69.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
        var this$70 = $n(model);
        var graphviz$3 = this$70.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
        $n(model);
        var _1$2 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$3, graph$3, messages$3, queue$3, nodes$3, edges$3, approvals$3, false, snapshot$3, "", graphviz$3);
        $m_Ltyrian_Html$();
        var children$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("Run finished, every node is ")), $n($s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done__Lnet_andimiller_hedgehogs_dag_visitor_State()).toHtml__Ltyrian_Html()]));
        var attributes$2 = $m_sci_Nil$();
        var this$75 = $n(children$2);
        var children$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$75);
        var key$1 = $m_s_None$();
        var msg$4 = new $c_Ltyrian_Tag("span", attributes$2, children$3, key$1);
        var msg$5 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$4);
        var _2$5 = new $c_Ltyrian_Cmd$Emit(msg$5);
        return new $c_T2(_1$2, _2$5);
      }
      if ((x135 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended)) {
        var x$1$7 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended(x135);
        var this$83 = $n(x$1$7);
        var x78 = this$83.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended__f_snapshot;
        var snapshot$4 = new $c_s_Some(x78);
        var encoder = $m_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$().dagSnapshotEncoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder__Lio_circe_Encoder($m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString, $m_Lnet_andimiller_hedgehogs_dag_visitor_Node$().given_Encoder_Node__Lio_circe_Encoder(), $m_Lnet_andimiller_hedgehogs_dag_visitor_Node$().given_Encoder_Node__Lio_circe_Encoder(), $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString, $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeUnit);
        var this$87 = $n($n(encoder).apply__O__Lio_circe_Json(x78));
        var snapshotText$1 = $n($m_Lio_circe_Printer$().Lio_circe_Printer$__f_spaces2).print__Lio_circe_Json__T(this$87);
        var this$88 = $n(model);
        var startTime$4 = this$88.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
        var this$89 = $n(model);
        var graph$4 = this$89.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
        var this$90 = $n(model);
        var messages$4 = this$90.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
        var this$91 = $n(model);
        var queue$4 = this$91.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
        var this$92 = $n(model);
        var nodes$4 = this$92.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
        var this$93 = $n(model);
        var edges$4 = this$93.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
        var this$94 = $n(model);
        var approvals$4 = this$94.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
        var this$95 = $n(model);
        var graphviz$4 = this$95.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
        $n(model);
        var _1$3 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$4, graph$4, messages$4, queue$4, nodes$4, edges$4, approvals$4, false, snapshot$4, snapshotText$1, graphviz$4);
        $m_Ltyrian_Html$();
        var $x_18 = $m_sr_ScalaRunTime$();
        $m_Ltyrian_Html$();
        var this$97 = $n($m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().waitingIds__Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__sci_List(x78));
        var plainText$1 = ("Run suspended, waiting for approval of: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$97, "", ", ", ""));
        var children$4 = $x_18.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Text(plainText$1)]));
        var attributes$3 = $m_sci_Nil$();
        var this$101 = $n(children$4);
        var children$5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$101);
        var key$2 = $m_s_None$();
        var msg$6 = new $c_Ltyrian_Tag("span", attributes$3, children$5, key$2);
        var msg$7 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$6);
        var _2$6 = new $c_Ltyrian_Cmd$Emit(msg$7);
        return new $c_T2(_1$3, _2$6);
      }
      throw new $c_s_MatchError(x135);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed)) {
      var x$1$8 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed(x$1$1);
      var this$109 = $n(x$1$8);
      var x132 = this$109.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed__f_message;
      $n(model);
      var this$110 = $n(model);
      var startTime = this$110.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$111 = $n(model);
      var graph = this$111.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var this$112 = $n(model);
      var messages = this$112.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$113 = $n(model);
      var queue = this$113.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$114 = $n(model);
      var nodes = this$114.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$115 = $n(model);
      var edges = this$115.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$116 = $n(model);
      var approvals = this$116.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$117 = $n(model);
      var snapshot = this$117.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$118 = $n(model);
      var snapshotText = this$118.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      var this$119 = $n(model);
      var graphviz = this$119.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      var _1$4 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime, graph, messages, queue, nodes, edges, approvals, false, snapshot, snapshotText, graphviz);
      var this$121 = $m_Ltyrian_Html$();
      var attributes$4 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("color:indianred;")]));
      var plainText$2 = ("Run failed: " + x132);
      var msg$8 = $f_Ltyrian_HtmlTags__span$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$121, attributes$4, plainText$2);
      var msg$9 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$8);
      var _2$7 = new $c_Ltyrian_Cmd$Emit(msg$9);
      return new $c_T2(_1$4, _2$7);
    }
    var x$9 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ApplySnapshot__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
    if (((x$9 === null) ? (x$1$1 === null) : $n(x$9).equals__O__Z(x$1$1))) {
      if ($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running) {
        var _2$8 = $m_Ltyrian_Cmd$None$();
        return new $c_T2(model, _2$8);
      }
      var this$126 = $m_Lio_circe_parser_package$();
      var input = $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      var evidence$1 = $m_Lnet_andimiller_hedgehogs_dag_visitor_circe_DagSnapshotCodecs$().dagSnapshotDecoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder__Lio_circe_Decoder($m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString, $m_Lnet_andimiller_hedgehogs_dag_visitor_Node$().given_Decoder_Node__Lio_circe_Decoder(), $m_Lnet_andimiller_hedgehogs_dag_visitor_Node$().given_Decoder_Node__Lio_circe_Decoder(), $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString, $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeUnit);
      var x93 = $f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either(this$126, input, evidence$1);
      if ((x93 instanceof $c_s_util_Left)) {
        var err = $as_Lio_circe_Error($n($as_s_util_Left(x93)).s_util_Left__f_value);
        var this$127 = $m_Ltyrian_Html$();
        var attributes$5 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("color:indianred;")]));
        var plainText$3 = ("Could not parse snapshot: " + $n(err).getMessage__T());
        var msg$10 = $f_Ltyrian_HtmlTags__span$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$127, attributes$5, plainText$3);
        var msg$11 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$10);
        var _2$9 = new $c_Ltyrian_Cmd$Emit(msg$11);
        return new $c_T2(model, _2$9);
      }
      if ((x93 instanceof $c_s_util_Right)) {
        var snap$3 = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot($n($as_s_util_Right(x93)).s_util_Right__f_value);
        var newGraph = $n($n(snap$3).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph).mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$3$1) => {
          var x$1$9 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState(x$1$3$1);
          if ((x$1$9 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)) {
            var x$1$10 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(x$1$9);
            var this$132 = $n(x$1$10);
            var x92 = this$132.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending__f_input;
            var n$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(x92);
            var y$1 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending__Lnet_andimiller_hedgehogs_dag_visitor_State();
            return new $c_T2(n$1, y$1);
          }
          if ((x$1$9 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
            var x$1$11 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(x$1$9);
            var this$136 = $n(x$1$11);
            var x88 = this$136.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_input;
            var this$137 = $n(x$1$11);
            $as_T(this$137.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle);
            var n$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(x88);
            var y$2 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Suspended__Lnet_andimiller_hedgehogs_dag_visitor_State();
            return new $c_T2(n$2, y$2);
          }
          if ((x$1$9 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
            var x$1$12 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x$1$9);
            var this$141 = $n(x$1$12);
            var x85 = this$141.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output;
            var n$3 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(x85);
            var y$3 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done__Lnet_andimiller_hedgehogs_dag_visitor_State();
            return new $c_T2(n$3, y$3);
          }
          throw new $c_s_MatchError(x$1$9);
        })));
        var snapshot$5 = new $c_s_Some(snap$3);
        var this$145 = $n(model);
        var startTime$5 = this$145.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
        var this$146 = $n(model);
        var messages$5 = this$146.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
        var this$147 = $n(model);
        var queue$5 = this$147.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
        var this$148 = $n(model);
        var nodes$5 = this$148.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
        var this$149 = $n(model);
        var edges$5 = this$149.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
        var this$150 = $n(model);
        var approvals$5 = this$150.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
        var this$151 = $n(model);
        var running$1 = this$151.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
        var this$152 = $n(model);
        var snapshotText$2 = this$152.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
        var this$153 = $n(model);
        var graphviz$5 = this$153.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
        $n(model);
        var _1$5 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$5, newGraph, messages$5, queue$5, nodes$5, edges$5, approvals$5, running$1, snapshot$5, snapshotText$2, graphviz$5);
        var $x_21 = $m_sr_ScalaRunTime$();
        $m_Ltyrian_Html$();
        var $x_19 = $m_sr_ScalaRunTime$();
        $m_Ltyrian_Html$();
        var this$155 = $n($m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().waitingIds__Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__sci_List(snap$3));
        var plainText$4 = ("Snapshot applied, waiting for approval of: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$155, "", ", ", ""));
        var children$6 = $x_19.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Text(plainText$4)]));
        var attributes$6 = $m_sci_Nil$();
        var this$159 = $n(children$6);
        var children$7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$159);
        var key$3 = $m_s_None$();
        var msg$12 = new $c_Ltyrian_Tag("span", attributes$6, children$7, key$3);
        var msg$13 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$12);
        var $x_20 = new $c_Ltyrian_Cmd$Emit(msg$13);
        var msg$14 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SyncNodeColours__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
        var cmds$4 = $x_21.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$x_20, new $c_Ltyrian_Cmd$Emit(msg$14)]));
        var this$167 = $n(cmds$4);
        var cmds$5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$167);
        var _2$10 = new $c_Ltyrian_Cmd$Batch(cmds$5);
        return new $c_T2(_1$5, _2$10);
      }
      throw new $c_s_MatchError(x93);
    }
    var x$11 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SaveSnapshot__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
    if (((x$11 === null) ? (x$1$1 === null) : $n(x$11).equals__O__Z(x$1$1))) {
      var this$171 = $n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText);
      if ((this$171 === "")) {
        $m_Ltyrian_Html$();
        var children$8 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("No snapshot to save"))]));
        var attributes$7 = $m_sci_Nil$();
        var this$175 = $n(children$8);
        var children$9 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$175);
        var key$4 = $m_s_None$();
        var msg$15 = new $c_Ltyrian_Tag("span", attributes$7, children$9, key$4);
        var msg$16 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$15);
        var _2$11 = new $c_Ltyrian_Cmd$Emit(msg$16);
        return new $c_T2(model, _2$11);
      } else {
        var $x_23 = $m_sr_ScalaRunTime$();
        var $x_22 = $m_Ltyrian_Cmd$SideEffect$().apply__F0__Lcats_effect_kernel_Sync__Ltyrian_Cmd$SideEffect(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
          window.localStorage.setItem($m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_storageKey, $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText);
        })), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
        $m_Ltyrian_Html$();
        var children$10 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("Snapshot saved to localStorage"))]));
        var attributes$8 = $m_sci_Nil$();
        var this$185 = $n(children$10);
        var children$11 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$185);
        var key$5 = $m_s_None$();
        var msg$17 = new $c_Ltyrian_Tag("span", attributes$8, children$11, key$5);
        var msg$18 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$17);
        var cmds$6 = $x_23.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$x_22, new $c_Ltyrian_Cmd$Emit(msg$18)]));
        var this$192 = $n(cmds$6);
        var cmds$7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$192);
        var _2$12 = new $c_Ltyrian_Cmd$Batch(cmds$7);
        return new $c_T2(model, _2$12);
      }
    }
    var x$13 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadSnapshot__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
    if (((x$13 === null) ? (x$1$1 === null) : $n(x$13).equals__O__Z(x$1$1))) {
      if ($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running) {
        var _2$13 = $m_Ltyrian_Cmd$None$();
        return new $c_T2(model, _2$13);
      }
      var $x_24 = $m_Ltyrian_Cmd$Run$();
      var this$197 = $m_Lcats_effect_IO$();
      var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_s_Option$().apply__O__s_Option($as_T(window.localStorage.getItem($m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().Lnet_andimiller_hedgehogs_dag_visitor_Demo$__f_storageKey)))));
      var _2$14 = $x_24.apply__O__Lcats_Applicative__Ltyrian_Cmd$Run($n(this$197.delay__F0__Lcats_effect_IO(thunk)).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$4$1) => {
        var x$1$13 = $as_s_Option(x$1$4$1);
        if ((x$1$13 instanceof $c_s_Some)) {
          var saved = $as_T($n($as_s_Some(x$1$13)).s_Some__f_value);
          return new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded(saved);
        }
        var x$2 = $m_s_None$();
        if ((x$2 === x$1$13)) {
          $m_Ltyrian_Html$();
          var children$12 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("No snapshot found in localStorage"))]));
          var attributes$9 = $m_sci_Nil$();
          var this$202 = $n(children$12);
          var children$13 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$202);
          var key$6 = $m_s_None$();
          var msg$19 = new $c_Ltyrian_Tag("span", attributes$9, children$13, key$6);
          return new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$19);
        }
        throw new $c_s_MatchError(x$1$13);
      }))), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
      return new $c_T2(model, _2$14);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded)) {
      var x$1$14 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded(x$1$1);
      var this$209 = $n(x$1$14);
      var x129 = this$209.Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded__f_text;
      $n(model);
      var this$210 = $n(model);
      var startTime$6 = this$210.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$211 = $n(model);
      var graph$5 = this$211.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var this$212 = $n(model);
      var messages$6 = this$212.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$213 = $n(model);
      var queue$6 = this$213.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$214 = $n(model);
      var nodes$6 = this$214.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$215 = $n(model);
      var edges$6 = this$215.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$216 = $n(model);
      var approvals$6 = this$216.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$217 = $n(model);
      var running = this$217.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$218 = $n(model);
      var snapshot$6 = this$218.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$219 = $n(model);
      var graphviz$6 = this$219.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      var _1$6 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$6, graph$5, messages$6, queue$6, nodes$6, edges$6, approvals$6, running, snapshot$6, x129, graphviz$6);
      var msg$20 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ApplySnapshot__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
      var _2$15 = new $c_Ltyrian_Cmd$Emit(msg$20);
      return new $c_T2(_1$6, _2$15);
    }
    var x$15 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
    if (((x$15 === null) ? (x$1$1 === null) : $n(x$15).equals__O__Z(x$1$1))) {
      if ($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running) {
        var _2$16 = $m_Ltyrian_Cmd$None$();
        return new $c_T2(model, _2$16);
      }
      var newGraph$2 = $n($m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$().makeProgram__I__I__I__Lnet_andimiller_hedgehogs_DataGraph($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes, $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges, $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals)).mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((n$4) => {
        var n$5 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(n$4);
        var _2$17 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending__Lnet_andimiller_hedgehogs_dag_visitor_State();
        return new $c_T2(n$5, _2$17);
      })));
      new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
      var $x_26 = $m_Ljava_time_Instant$();
      var value$3 = $uD(Date.now());
      var $x_25 = $m_RTLong$().fromDouble__D__J(value$3);
      var startTime$6$1 = $x_26.ofEpochMilli__J__Ljava_time_Instant($x_25.l, $x_25.h);
      var snapshot$6$1 = $m_s_None$();
      var this$229 = $n(model);
      var messages$6$1 = this$229.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$230 = $n(model);
      var queue$6$1 = this$230.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$231 = $n(model);
      var nodes$6$1 = this$231.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$232 = $n(model);
      var edges$6$1 = this$232.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$233 = $n(model);
      var approvals$6$1 = this$233.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$234 = $n(model);
      var running$2 = this$234.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$235 = $n(model);
      var graphviz$6$1 = this$235.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      $n(model);
      var _1$7 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$6$1, newGraph$2, messages$6$1, queue$6$1, nodes$6$1, edges$6$1, approvals$6$1, running$2, snapshot$6$1, "", graphviz$6$1);
      var $x_31 = $m_sr_ScalaRunTime$();
      var msg$21 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ClearLog__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
      var $x_30 = new $c_Ltyrian_Cmd$Emit(msg$21);
      $m_Ltyrian_Html$();
      var $x_28 = $m_sr_ScalaRunTime$();
      $m_Ltyrian_Html$();
      var this$238 = $n(newGraph$2);
      var $x_27 = $n($n(this$238.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).keySet__sci_Set()).size__I();
      var this$239 = $n(newGraph$2);
      var plainText$5 = (((("Graph has been regenerated with " + $x_27) + " nodes and ") + $n($n(this$239.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap).keySet__sci_Set()).size__I()) + " edges, all nodes reset to ");
      var children$14 = $x_28.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Text(plainText$5), $n($s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending__Lnet_andimiller_hedgehogs_dag_visitor_State()).toHtml__Ltyrian_Html()]));
      var attributes$10 = $m_sci_Nil$();
      var this$243 = $n(children$14);
      var children$15 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$243);
      var key$7 = $m_s_None$();
      var msg$22 = new $c_Ltyrian_Tag("span", attributes$10, children$15, key$7);
      var msg$23 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$22);
      var $x_29 = new $c_Ltyrian_Cmd$Emit(msg$23);
      var msg$24 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SyncNodeColours__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
      var cmds$8 = $x_31.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$x_30, $x_29, new $c_Ltyrian_Cmd$Emit(msg$24)]));
      var this$251 = $n(cmds$8);
      var cmds$9 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$251);
      var _2$18 = new $c_Ltyrian_Cmd$Batch(cmds$9);
      return new $c_T2(_1$7, _2$18);
    }
    var x$17 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadGraphviz__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
    if (((x$17 === null) ? (x$1$1 === null) : $n(x$17).equals__O__Z(x$1$1))) {
      var $x_33 = $m_Ltyrian_Cmd$Run$();
      var $x_32 = $m_Lcats_effect_IO$();
      var this$255 = $m_Lcats_effect_IO$();
      var thunk$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $i_$0040hpcc$002djs$002fwasm$002dgraphviz.Graphviz.load()));
      var _2$19 = $x_33.apply__O__Lcats_Applicative__Ltyrian_Cmd$Run($n($x_32.fromPromise__Lcats_effect_IO__Lcats_effect_IO(this$255.delay__F0__Lcats_effect_IO(thunk$1))).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((g) => new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded(g)))), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
      return new $c_T2(model, _2$19);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded)) {
      var x$1$15 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded(x$1$1);
      var this$259 = $n(x$1$15);
      var x126 = this$259.Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded__f_g;
      var graphviz$7 = new $c_s_Some(x126);
      var this$261 = $n(model);
      var startTime$7 = this$261.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$262 = $n(model);
      var graph$5$1 = this$262.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var this$263 = $n(model);
      var messages$7 = this$263.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$264 = $n(model);
      var queue$7 = this$264.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$265 = $n(model);
      var nodes$7 = this$265.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$266 = $n(model);
      var edges$7 = this$266.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$267 = $n(model);
      var approvals$7 = this$267.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$268 = $n(model);
      var running$3 = this$268.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$269 = $n(model);
      var snapshot$7 = this$269.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$270 = $n(model);
      var snapshotText$3 = this$270.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      $n(model);
      var _1$8 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$7, graph$5$1, messages$7, queue$7, nodes$7, edges$7, approvals$7, running$3, snapshot$7, snapshotText$3, graphviz$7);
      $m_Ltyrian_Html$();
      var children$16 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("Graphviz loaded"))]));
      var attributes$11 = $m_sci_Nil$();
      var this$275 = $n(children$16);
      var children$17 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$275);
      var key$8 = $m_s_None$();
      var msg$25 = new $c_Ltyrian_Tag("span", attributes$11, children$17, key$8);
      var msg$26 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$25);
      var _2$20 = new $c_Ltyrian_Cmd$Emit(msg$26);
      return new $c_T2(_1$8, _2$20);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount)) {
      var x$1$16 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount(x$1$1);
      var this$283 = $n(x$1$16);
      var x123 = this$283.Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount__f_n;
      $n(model);
      var this$284 = $n(model);
      var startTime$8 = this$284.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$285 = $n(model);
      var graph$6 = this$285.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var this$286 = $n(model);
      var messages$8 = this$286.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$287 = $n(model);
      var queue$8 = this$287.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$288 = $n(model);
      var edges$8 = this$288.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$289 = $n(model);
      var approvals$8 = this$289.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$290 = $n(model);
      var running$4 = this$290.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$291 = $n(model);
      var snapshot$8 = this$291.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$292 = $n(model);
      var snapshotText$4 = this$292.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      var this$293 = $n(model);
      var graphviz$8 = this$293.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      var _1$9 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$8, graph$6, messages$8, queue$8, x123, edges$8, approvals$8, running$4, snapshot$8, snapshotText$4, graphviz$8);
      var msg$27 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
      var _2$21 = new $c_Ltyrian_Cmd$Emit(msg$27);
      return new $c_T2(_1$9, _2$21);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount)) {
      var x$1$17 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount(x$1$1);
      var this$298 = $n(x$1$17);
      var x120 = this$298.Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount__f_e;
      $n(model);
      var this$299 = $n(model);
      var startTime$9 = this$299.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$300 = $n(model);
      var graph$7 = this$300.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var this$301 = $n(model);
      var messages$9 = this$301.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$302 = $n(model);
      var queue$9 = this$302.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$303 = $n(model);
      var nodes$8 = this$303.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$304 = $n(model);
      var approvals$9 = this$304.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$305 = $n(model);
      var running$5 = this$305.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$306 = $n(model);
      var snapshot$9 = this$306.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$307 = $n(model);
      var snapshotText$5 = this$307.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      var this$308 = $n(model);
      var graphviz$9 = this$308.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      var _1$10 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$9, graph$7, messages$9, queue$9, nodes$8, x120, approvals$9, running$5, snapshot$9, snapshotText$5, graphviz$9);
      var msg$28 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
      var _2$22 = new $c_Ltyrian_Cmd$Emit(msg$28);
      return new $c_T2(_1$10, _2$22);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount)) {
      var x$1$18 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount(x$1$1);
      var this$313 = $n(x$1$18);
      var x117 = this$313.Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount__f_n;
      $n(model);
      var this$314 = $n(model);
      var startTime$10 = this$314.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$315 = $n(model);
      var graph$8 = this$315.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var this$316 = $n(model);
      var messages$10 = this$316.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$317 = $n(model);
      var queue$10 = this$317.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$318 = $n(model);
      var nodes$9 = this$318.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$319 = $n(model);
      var edges$9 = this$319.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$320 = $n(model);
      var running$6 = this$320.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$321 = $n(model);
      var snapshot$10 = this$321.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$322 = $n(model);
      var snapshotText$6 = this$322.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      var this$323 = $n(model);
      var graphviz$10 = this$323.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      var _1$11 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$10, graph$8, messages$10, queue$10, nodes$9, edges$9, x117, running$6, snapshot$10, snapshotText$6, graphviz$10);
      var msg$29 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
      var _2$23 = new $c_Ltyrian_Cmd$Emit(msg$29);
      return new $c_T2(_1$11, _2$23);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated)) {
      var x$1$19 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated(x$1$1);
      var this$328 = $n(x$1$19);
      var x114 = this$328.Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated__f_queue;
      var queue$8$1 = new $c_s_Some(x114);
      var this$330 = $n(model);
      var startTime$8$1 = this$330.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$331 = $n(model);
      var graph$6$1 = this$331.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var this$332 = $n(model);
      var messages$8$1 = this$332.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$333 = $n(model);
      var nodes$8$1 = this$333.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$334 = $n(model);
      var edges$8$1 = this$334.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$335 = $n(model);
      var approvals$8$1 = this$335.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$336 = $n(model);
      var running$4$1 = this$336.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$337 = $n(model);
      var snapshot$8$1 = this$337.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$338 = $n(model);
      var snapshotText$4$1 = this$338.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      var this$339 = $n(model);
      var graphviz$8$1 = this$339.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      $n(model);
      var _1$12 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$8$1, graph$6$1, messages$8$1, queue$8$1, nodes$8$1, edges$8$1, approvals$8$1, running$4$1, snapshot$8$1, snapshotText$4$1, graphviz$8$1);
      var _2$24 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(_1$12, _2$24);
    }
    var x$19 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SyncNodeColours__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
    if (((x$19 === null) ? (x$1$1 === null) : $n(x$19).equals__O__Z(x$1$1))) {
      var this$342 = $n($n($n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph).mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
        var _$4$1 = $as_T2(_$4);
        return $as_Lnet_andimiller_hedgehogs_dag_visitor_State($n(_$4$1)._2__O());
      })))).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap);
      var this$344 = $n($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$342));
      var f = ((x$1$5$1) => {
        var x$1$20 = $as_T2(x$1$5$1);
        if ((x$1$20 !== null)) {
          var id = $as_T($n(x$1$20)._1__O());
          var state = $as_Lnet_andimiller_hedgehogs_dag_visitor_State($n(x$1$20)._2__O());
          return $m_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$().set__T__T__Lcats_effect_kernel_Sync__Ltyrian_Cmd((("--" + id) + "-fill"), $n(state).toColour__T(), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
        }
        throw new $c_s_MatchError(x$1$20);
      });
      if ((this$344 === $m_sci_Nil$())) {
        var cmds$10 = $m_sci_Nil$();
      } else {
        var x0 = this$344.head__O();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$344.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        var cmds$10 = h;
      }
      var _2$25 = new $c_Ltyrian_Cmd$Batch(cmds$10);
      return new $c_T2(model, _2$25);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState)) {
      var x$1$21 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(x$1$1);
      var this$348 = $n(x$1$21);
      var x110 = this$348.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_node;
      var this$349 = $n(x$1$21);
      var x111 = this$349.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_state;
      var $x_34 = $n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph);
      var self = $n($as_T2($n($n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).apply__O__O(x110)))._1__O();
      var ev$10 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(self);
      var nextGraph = $x_34.addNode__O__O__Lnet_andimiller_hedgehogs_DataGraph(x110, new $c_T2(ev$10, x111));
      var stateUpdate = $m_Lnet_andimiller_hedgehogs_dag_visitor_CssVariables$().set__T__T__Lcats_effect_kernel_Sync__Ltyrian_Cmd((("--" + x110) + "-fill"), $n(x111).toColour__T(), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
      $n(model);
      var this$352 = $n(model);
      var startTime$11 = this$352.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$353 = $n(model);
      var messages$11 = this$353.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var this$354 = $n(model);
      var queue$11 = this$354.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$355 = $n(model);
      var nodes$10 = this$355.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$356 = $n(model);
      var edges$10 = this$356.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$357 = $n(model);
      var approvals$10 = this$357.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$358 = $n(model);
      var running$7 = this$358.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$359 = $n(model);
      var snapshot$11 = this$359.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$360 = $n(model);
      var snapshotText$7 = this$360.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      var this$361 = $n(model);
      var graphviz$11 = this$361.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      var _1$13 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$11, nextGraph, messages$11, queue$11, nodes$10, edges$10, approvals$10, running$7, snapshot$11, snapshotText$7, graphviz$11);
      $m_Lcats_implicits$();
      $m_Ltyrian_Html$();
      var $x_36 = $m_sr_ScalaRunTime$();
      $m_Ltyrian_Html$();
      var plainText$6 = (x110 + " changed state to ");
      var children$18 = $x_36.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Text(plainText$6), $n(x111).toHtml__Ltyrian_Html()]));
      var attributes$12 = $m_sci_Nil$();
      var this$366 = $n(children$18);
      var children$19 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$366);
      var key$9 = $m_s_None$();
      var msg$30 = new $c_Ltyrian_Tag("span", attributes$12, children$19, key$9);
      var a = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$30);
      var $x_37 = new $c_s_Some(a);
      var this$374 = $n($n(nextGraph).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap);
      var this$375 = new $c_sc_MapOps$$anon$1(this$374);
      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
        var _$5$1 = $as_T2(_$5);
        return $as_Lnet_andimiller_hedgehogs_dag_visitor_State($n(_$5$1)._2__O());
      }));
      var cond = $n($as_sc_IterableOnceOps($f_sc_IterableOps__map__F1__O(this$375, f$1))).forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => {
        var _$6$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_State(_$6);
        var x$2$1 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done__Lnet_andimiller_hedgehogs_dag_visitor_State();
        if ((_$6$1 === null)) {
          return (x$2$1 === null);
        } else {
          var this$376 = $n(_$6$1);
          return (this$376 === x$2$1);
        }
      })));
      if (cond) {
        $m_Ltyrian_Html$();
        var children$20 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("Graph is all ")), $n($s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done__Lnet_andimiller_hedgehogs_dag_visitor_State()).toHtml__Ltyrian_Html()]));
        var attributes$13 = $m_sci_Nil$();
        var this$381 = $n(children$20);
        var children$21 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$381);
        var key$10 = $m_s_None$();
        var msg$31 = new $c_Ltyrian_Tag("span", attributes$13, children$21, key$10);
        var $x_35 = new $c_s_Some(new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg$31));
      } else {
        var $x_35 = $m_s_None$();
      }
      var this$388 = new $c_sci_$colon$colon($x_37, new $c_sci_$colon$colon($x_35, $m_sci_Nil$()));
      var this$387 = $m_s_$less$colon$less$();
      var toIterableOnce = this$387.s_$less$colon$less$__f_singleton;
      var this$390 = $n($as_sci_List($f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$388, toIterableOnce)));
      var f$2 = ((msg$32) => {
        var msg$33 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg(msg$32);
        return new $c_Ltyrian_Cmd$Emit(msg$33);
      });
      if ((this$390 === $m_sci_Nil$())) {
        var this$391 = $m_sci_Nil$();
      } else {
        var x0$2 = this$390.head__O();
        var h$1 = new $c_sci_$colon$colon(f$2(x0$2), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(this$390.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var x0$3 = $n(rest$1).head__O();
          var nx$1 = new $c_sci_$colon$colon(f$2(x0$3), $m_sci_Nil$());
          $n(t$1).sci_$colon$colon__f_next = nx$1;
          t$1 = nx$1;
          rest$1 = $as_sci_List($n(rest$1).tail__O());
        }
        var this$391 = h$1;
      }
      var cmds$11 = $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$391, stateUpdate));
      var _2$26 = new $c_Ltyrian_Cmd$Batch(cmds$11);
      return new $c_T2(_1$13, _2$26);
    }
    if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log)) {
      var x$1$22 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(x$1$1);
      var this$395 = $n(x$1$22);
      var x107 = this$395.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log__f_msg;
      new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
      var $x_39 = $m_Ljava_time_Instant$();
      var value$4 = $uD(Date.now());
      var $x_38 = $m_RTLong$().fromDouble__D__J(value$4);
      var now = $x_39.ofEpochMilli__J__Ljava_time_Instant($x_38.l, $x_38.h);
      var startInclusive = $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$400 = $n($m_Ljava_time_Duration$().between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__Ljava_time_Duration(startInclusive, now));
      var ts_$_lo = this$400.Ljava_time_Duration__f_seconds_$lo;
      var ts_$_hi = this$400.Ljava_time_Duration__f_seconds_$hi;
      var $x_41 = $n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages);
      $m_Ltyrian_Html$();
      var $x_40 = $m_sr_ScalaRunTime$();
      $m_Ltyrian_Html$();
      var plainText$7 = ($s_RTLong__toString__I__I__T(ts_$_lo, ts_$_hi) + "s ");
      var children$22 = $x_40.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Text(plainText$7), x107]));
      var attributes$14 = $m_sci_Nil$();
      var this$404 = $n(children$22);
      var children$23 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$404);
      var key$11 = $m_s_None$();
      var messages$9$1 = $x_41.appended__O__sci_Vector(new $c_Ltyrian_Tag("span", attributes$14, children$23, key$11));
      var this$408 = $n(model);
      var startTime$9$1 = this$408.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$409 = $n(model);
      var graph$7$1 = this$409.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var this$410 = $n(model);
      var queue$9$1 = this$410.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$411 = $n(model);
      var nodes$9$1 = this$411.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$412 = $n(model);
      var edges$9$1 = this$412.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$413 = $n(model);
      var approvals$9$1 = this$413.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$414 = $n(model);
      var running$5$1 = this$414.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$415 = $n(model);
      var snapshot$9$1 = this$415.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$416 = $n(model);
      var snapshotText$5$1 = this$416.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      var this$417 = $n(model);
      var graphviz$9$1 = this$417.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      $n(model);
      var _1$14 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$9$1, graph$7$1, messages$9$1, queue$9$1, nodes$9$1, edges$9$1, approvals$9$1, running$5$1, snapshot$9$1, snapshotText$5$1, graphviz$9$1);
      var _2$27 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(_1$14, _2$27);
    }
    var x$21 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ClearLog__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
    if (((x$21 === null) ? (x$1$1 === null) : $n(x$21).equals__O__Z(x$1$1))) {
      var this$420 = $m_sci_Vector$();
      var elems$1 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
      var messages$10$1 = this$420.from__sc_IterableOnce__sci_Vector(elems$1);
      var this$421 = $n(model);
      var startTime$10$1 = this$421.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var this$422 = $n(model);
      var graph$8$1 = this$422.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var this$423 = $n(model);
      var queue$10$1 = this$423.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var this$424 = $n(model);
      var nodes$10$1 = this$424.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      var this$425 = $n(model);
      var edges$10$1 = this$425.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      var this$426 = $n(model);
      var approvals$10$1 = this$426.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      var this$427 = $n(model);
      var running$6$1 = this$427.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      var this$428 = $n(model);
      var snapshot$10$1 = this$428.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var this$429 = $n(model);
      var snapshotText$6$1 = this$429.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      var this$430 = $n(model);
      var graphviz$10$1 = this$430.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      $n(model);
      var _1$15 = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime$10$1, graph$8$1, messages$10$1, queue$10$1, nodes$10$1, edges$10$1, approvals$10$1, running$6$1, snapshot$10$1, snapshotText$6$1, graphviz$10$1);
      var _2$28 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(_1$15, _2$28);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.slider__T__T__I__I__I__I__F1__Ltyrian_Html = (function(name, htmlId, min, max, initial, current, onChanged) {
  $m_Ltyrian_Html$();
  var attributes$4 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_AttributeName("for")).$colon$eq__O__Ltyrian_Attribute(htmlId), $n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("display: flex; align-items: center; gap: 8px; width: 100%;")]));
  var $x_3 = $m_sr_ScalaRunTime$();
  var this$2 = $m_Ltyrian_Html$();
  var attributes = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("flex: 0 0 80px;")]));
  var $x_2 = $f_Ltyrian_HtmlTags__span$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$2, attributes, name);
  $m_Ltyrian_Html$();
  var attributes$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString).$colon$eq__T__Ltyrian_Attribute(htmlId), ($m_Ltyrian_Html$(), new $c_Ltyrian_AttributeName("type")).$colon$eq__O__Ltyrian_Attribute("range"), ($m_Ltyrian_Html$(), new $c_Ltyrian_AttributeName("min")).$colon$eq__O__Ltyrian_Attribute(("" + min)), $n($m_Ltyrian_Html$().Ltyrian_Html$__f_value$minusString).$colon$eq__T__Ltyrian_PropertyString(("" + initial)), ($m_Ltyrian_Html$(), new $c_Ltyrian_AttributeName("max")).$colon$eq__O__Ltyrian_Attribute(("" + max)), $n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("flex: 1 1 auto; margin: 0;"), $m_Ltyrian_Html$().onChange__F1__Ltyrian_Attr(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((value) => {
    var value$1 = $as_T(value);
    var this$11 = $m_jl_Integer$();
    return $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg($n(onChanged).apply__O__O(this$11.java$lang$Integer$$parseIntImpl__T__I__I__I(value$1, 10, 214748364)));
  })))]));
  var this$13 = $n(attributes$1);
  var attributes$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$13);
  var children = $m_sci_Nil$();
  var key = $m_s_None$();
  var $x_1 = new $c_Ltyrian_Tag("input", attributes$2, children, key);
  var this$18 = $m_Ltyrian_Html$();
  var attributes$3 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("flex: 0 0 32px; text-align: right;")]));
  var plainText = ("" + current);
  var children$1 = $x_3.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_2, $x_1, $f_Ltyrian_HtmlTags__span$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$18, attributes$3, plainText)]));
  var this$20 = $n(attributes$4);
  var attributes$5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$20);
  var this$22 = $n(children$1);
  var children$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$22);
  var key$1 = $m_s_None$();
  return new $c_Ltyrian_Tag("label", attributes$5, children$2, key$1);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.view__Lnet_andimiller_hedgehogs_dag_visitor_Model__Ltyrian_Html = (function(model) {
  $m_Ltyrian_Html$();
  var attributes$31 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("display: flex; gap: 24px; align-items: flex-start;")]));
  var $x_33 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var attributes$13 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("flex: 0 0 400px;")]));
  $m_Ltyrian_Html$();
  var $x_23 = $m_sr_ScalaRunTime$();
  var this$1 = $m_Ltyrian_Html$();
  var $x_22 = $f_Ltyrian_HtmlTags__h2$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$1, "Controls");
  var $x_21 = this.slider__T__T__I__I__I__I__F1__Ltyrian_Html("Nodes", "nodes", 2, 50, 5, $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((n) => {
    var n$1 = $uI(n);
    return new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount(n$1);
  })));
  $m_Ltyrian_Html$();
  var attributes = $m_sci_Nil$();
  var children = $m_sci_Nil$();
  var key = $m_s_None$();
  var $x_20 = new $c_Ltyrian_Tag("hr", attributes, children, key);
  var $x_19 = this.slider__T__T__I__I__I__I__F1__Ltyrian_Html("Edges", "edges", 2, 100, 10, $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => {
    var e$1 = $uI(e);
    return new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount(e$1);
  })));
  $m_Ltyrian_Html$();
  var attributes$1 = $m_sci_Nil$();
  var children$1 = $m_sci_Nil$();
  var key$1 = $m_s_None$();
  var $x_18 = new $c_Ltyrian_Tag("hr", attributes$1, children$1, key$1);
  var $x_17 = this.slider__T__T__I__I__I__I__F1__Ltyrian_Html("Approvals", "approvals", 0, $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes, 0, $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((n$2) => {
    var n$3 = $uI(n$2);
    return new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount(n$3);
  })));
  $m_Ltyrian_Html$();
  var attributes$2 = $m_sci_Nil$();
  var children$2 = $m_sci_Nil$();
  var key$2 = $m_s_None$();
  var $x_16 = new $c_Ltyrian_Tag("hr", attributes$2, children$2, key$2);
  var this$15 = $m_Ltyrian_Html$();
  var $x_14 = $m_sr_ScalaRunTime$();
  var this$14 = $m_Ltyrian_Html$();
  var msg = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
  var attributes$3 = $x_14.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Event(this$14, msg)]));
  var $x_15 = $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$15, attributes$3, "Reroll");
  var this$17 = $m_Ltyrian_Html$();
  var $x_13 = $m_sr_ScalaRunTime$();
  var this$16 = $m_Ltyrian_Html$();
  var msg$1 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Start__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
  var attributes$4 = $x_13.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Event(this$16, msg$1)]));
  var children$3 = $x_23.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_22, $x_21, $x_20, $x_19, $x_18, $x_17, $x_16, $x_15, $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$17, attributes$4, "Start")]));
  var attributes$5 = $m_sci_Nil$();
  var this$19 = $n(children$3);
  var children$4 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$19);
  var key$3 = $m_s_None$();
  var this$23 = new $c_sci_$colon$colon(new $c_Ltyrian_Tag("div", attributes$5, children$4, key$3), $m_sci_Nil$());
  var suffix = this.approvalSection__Lnet_andimiller_hedgehogs_dag_visitor_Model__sci_List(model);
  var this$55 = $n(this$23.appendedAll__sc_IterableOnce__sci_List(suffix));
  $m_Ltyrian_Html$();
  var $x_31 = $m_sr_ScalaRunTime$();
  var this$24 = $m_Ltyrian_Html$();
  var $x_30 = $f_Ltyrian_HtmlTags__h2$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$24, "Snapshot");
  $m_Ltyrian_Html$();
  var children$5 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("When the run suspends, its entire state is serialised here as JSON via the circe codecs. You can Save it, reload the page, Load it back, and approve the waiting nodes to finish the run."))]));
  var attributes$6 = $m_sci_Nil$();
  var this$28 = $n(children$5);
  var children$6 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$28);
  var key$4 = $m_s_None$();
  var $x_29 = new $c_Ltyrian_Tag("p", attributes$6, children$6, key$4);
  $m_Ltyrian_Html$();
  var attributes$7 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_AttributeName("rows")).$colon$eq__O__Ltyrian_Attribute("12"), ($m_Ltyrian_Html$(), new $c_Ltyrian_AttributeName("readonly")).$colon$eq__O__Ltyrian_Attribute("readonly"), $n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("width: 100%; font-family: monospace; box-sizing: border-box;"), $n($m_Ltyrian_Html$().Ltyrian_Html$__f_value$minusString).$colon$eq__T__Ltyrian_PropertyString($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText)]));
  var children$7 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([]));
  var this$35 = $n(attributes$7);
  var attributes$8 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$35);
  var this$37 = $n(children$7);
  var children$8 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$37);
  var key$5 = $m_s_None$();
  var $x_28 = new $c_Ltyrian_Tag("textarea", attributes$8, children$8, key$5);
  $m_Ltyrian_Html$();
  var $x_27 = $m_sr_ScalaRunTime$();
  var this$42 = $m_Ltyrian_Html$();
  var $x_25 = $m_sr_ScalaRunTime$();
  var this$41 = $m_Ltyrian_Html$();
  var msg$2 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SaveSnapshot__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
  var attributes$9 = $x_25.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Event(this$41, msg$2)]));
  var $x_26 = $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$42, attributes$9, "Save to localStorage");
  var this$44 = $m_Ltyrian_Html$();
  var $x_24 = $m_sr_ScalaRunTime$();
  var this$43 = $m_Ltyrian_Html$();
  var msg$3 = $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadSnapshot__Lnet_andimiller_hedgehogs_dag_visitor_Msg();
  var attributes$10 = $x_24.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Event(this$43, msg$3)]));
  var children$9 = $x_27.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_26, $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$44, attributes$10, "Load from localStorage")]));
  var attributes$11 = $m_sci_Nil$();
  var this$46 = $n(children$9);
  var children$10 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$46);
  var key$6 = $m_s_None$();
  var children$11 = $x_31.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_30, $x_29, $x_28, new $c_Ltyrian_Tag("div", attributes$11, children$10, key$6)]));
  var attributes$12 = $m_sci_Nil$();
  var this$51 = $n(children$11);
  var children$12 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$51);
  var key$7 = $m_s_None$();
  var suffix$1 = new $c_sci_$colon$colon(new $c_Ltyrian_Tag("div", attributes$12, children$12, key$7), $m_sci_Nil$());
  var children$13 = this$55.appendedAll__sc_IterableOnce__sci_List(suffix$1);
  var this$57 = $n(attributes$13);
  var attributes$14 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$57);
  var children$14 = $n(children$13);
  var key$8 = $m_s_None$();
  var $x_32 = new $c_Ltyrian_Tag("div", attributes$14, children$14, key$8);
  $m_Ltyrian_Html$();
  var attributes$25 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("flex: 1 1 auto; min-width: 300px;")]));
  var $x_11 = $m_sr_ScalaRunTime$();
  var this$61 = $m_Ltyrian_Html$();
  var $x_10 = $f_Ltyrian_HtmlTags__h1$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$61, "Hedgehogs Suspendable Visitor Demo");
  $m_Ltyrian_Html$();
  var children$15 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("This demonstrates concurrently running a graph of dependencies with the suspendable visitor. Each round node is an operation that takes 1 second to run, and each hexagonal node needs an approval: when the run reaches it, the whole run suspends into a snapshot until you approve it. An arrow represents dependency flow, the target needs the source to run before it can start."))]));
  var attributes$15 = $m_sci_Nil$();
  var this$65 = $n(children$15);
  var children$16 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$65);
  var key$9 = $m_s_None$();
  var $x_9 = new $c_Ltyrian_Tag("p", attributes$15, children$16, key$9);
  $m_Ltyrian_Html$();
  var $x_7 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var children$17 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("Each node is coloured according to state, it may be ")), $n($s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending__Lnet_andimiller_hedgehogs_dag_visitor_State()).toHtml__Ltyrian_Html(), ($m_Ltyrian_Html$(), new $c_Ltyrian_Text(", ")), $n($s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Running__Lnet_andimiller_hedgehogs_dag_visitor_State()).toHtml__Ltyrian_Html(), ($m_Ltyrian_Html$(), new $c_Ltyrian_Text(", ")), $n($s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Suspended__Lnet_andimiller_hedgehogs_dag_visitor_State()).toHtml__Ltyrian_Html(), ($m_Ltyrian_Html$(), new $c_Ltyrian_Text(" or ")), $n($s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done__Lnet_andimiller_hedgehogs_dag_visitor_State()).toHtml__Ltyrian_Html(), ($m_Ltyrian_Html$(), new $c_Ltyrian_Text("; the log shows transitions as they happen, with a clock that keeps running across suspensions."))]));
  var attributes$16 = $m_sci_Nil$();
  var this$80 = $n(children$17);
  var children$18 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$80);
  var key$10 = $m_s_None$();
  var children$19 = $x_7.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Tag("span", attributes$16, children$18, key$10)]));
  var attributes$17 = $m_sci_Nil$();
  var this$85 = $n(children$19);
  var children$20 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$85);
  var key$11 = $m_s_None$();
  var $x_8 = new $c_Ltyrian_Tag("p", attributes$17, children$20, key$11);
  $m_Ltyrian_Html$();
  var attributes$23 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("min-height: 400px;")]));
  var $x_6 = $m_sr_ScalaRunTime$();
  var this$89 = $m_Ltyrian_Html$();
  var $x_5 = $f_Ltyrian_HtmlTags__h2$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$89, "Graph");
  $m_Ltyrian_Html$();
  var attributes$21 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("display: flex; justify-content: center;")]));
  var $x_4 = $m_sr_ScalaRunTime$();
  var this$90 = $n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz);
  if (this$90.isEmpty__Z()) {
    var this$99 = $m_s_None$();
  } else {
    var x0 = this$90.get__O();
    var renderGraph = $n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph).mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$7) => {
      var _$7$1 = $as_T2(_$7);
      return $as_Lnet_andimiller_hedgehogs_dag_visitor_Node($n(_$7$1)._1__O());
    })));
    $m_Ltyrian_Html$();
    var html = $as_T(x0.dot($m_Lnet_andimiller_hedgehogs_dag_visitor_Digraph$().apply__Lnet_andimiller_hedgehogs_DataGraph__T(renderGraph), "svg_inline"));
    var attributes$18 = $m_sci_Nil$();
    var key$12 = $m_s_None$();
    var this$98 = new $c_Ltyrian_RawTag("div", attributes$18, html, key$12);
    var this$94 = $n(renderGraph);
    var this$95 = $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this$94, 1378194421, true);
    var value = ("" + this$95);
    var value$1 = new $c_s_Some(value);
    var name = this$98.Ltyrian_RawTag__f_name;
    var attributes$19 = this$98.Ltyrian_RawTag__f_attributes;
    var innerHTML = this$98.Ltyrian_RawTag__f_innerHTML;
    var this$99 = new $c_s_Some(new $c_Ltyrian_RawTag(name, attributes$19, innerHTML, value$1));
  }
  if (this$99.isEmpty__Z()) {
    $m_Ltyrian_Html$();
    var children$21 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text("Waiting for graphviz wasm to load"))]));
    var attributes$20 = $m_sci_Nil$();
    var this$103 = $n(children$21);
    var children$22 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$103);
    var key$13 = $m_s_None$();
    var $x_3 = new $c_Ltyrian_Tag("div", attributes$20, children$22, key$13);
  } else {
    var $x_3 = this$99.get__O();
  }
  var children$23 = $x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$as_Ltyrian_Elem($x_3)]));
  var this$108 = $n(attributes$21);
  var attributes$22 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$108);
  var this$110 = $n(children$23);
  var children$24 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$110);
  var key$14 = $m_s_None$();
  var children$25 = $x_6.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_5, new $c_Ltyrian_Tag("div", attributes$22, children$24, key$14)]));
  var this$115 = $n(attributes$23);
  var attributes$24 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$115);
  var this$117 = $n(children$25);
  var children$26 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$117);
  var key$15 = $m_s_None$();
  var children$27 = $x_11.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_10, $x_9, $x_8, new $c_Ltyrian_Tag("div", attributes$24, children$26, key$15)]));
  var this$122 = $n(attributes$25);
  var attributes$26 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$122);
  var this$124 = $n(children$27);
  var children$28 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$124);
  var key$16 = $m_s_None$();
  var $x_12 = new $c_Ltyrian_Tag("div", attributes$26, children$28, key$16);
  $m_Ltyrian_Html$();
  var attributes$29 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("flex: 0 0 350px;")]));
  var $x_2 = $m_sr_ScalaRunTime$();
  var this$128 = $m_Ltyrian_Html$();
  var $x_1 = $f_Ltyrian_HtmlTags__h2$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$128, "Logs");
  $m_Ltyrian_Html$();
  var attributes$27 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute("height: 85vh; overflow: auto; display: flex; flex-direction: column-reverse;")]));
  var this$129 = $n($n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages);
  var children$29 = $as_sci_Seq($f_sc_IndexedSeqOps__reverse__O(this$129));
  var this$131 = $n(attributes$27);
  var attributes$28 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$131);
  var children$30 = $n(children$29).toList__sci_List();
  var key$17 = $m_s_None$();
  var children$31 = $x_2.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_1, new $c_Ltyrian_Tag("div", attributes$28, children$30, key$17)]));
  var this$136 = $n(attributes$29);
  var attributes$30 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$136);
  var this$138 = $n(children$31);
  var children$32 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$138);
  var key$18 = $m_s_None$();
  var children$33 = $x_33.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_32, $x_12, new $c_Ltyrian_Tag("div", attributes$30, children$32, key$18)]));
  var this$143 = $n(attributes$31);
  var attributes$32 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$143);
  var this$145 = $n(children$33);
  var children$34 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$145);
  var key$19 = $m_s_None$();
  return new $c_Ltyrian_Tag("div", attributes$32, children$34, key$19);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.approvalSection__Lnet_andimiller_hedgehogs_dag_visitor_Model__sci_List = (function(model) {
  var x139 = $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
  if ((x139 instanceof $c_s_Some)) {
    var snap = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot($n($as_s_Some(x139)).s_Some__f_value);
    if ((!$n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running)) {
      $m_Ltyrian_Html$();
      var $x_3 = $m_sr_ScalaRunTime$();
      var this$1 = $m_Ltyrian_Html$();
      var $x_2 = $f_Ltyrian_HtmlTags__h2$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$1, "Waiting for approval");
      $m_Ltyrian_Html$();
      var this$5 = $n(this.waitingIds__Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__sci_List(snap));
      var f = ((id) => {
        var id$1 = $as_T(id);
        var this$4 = $m_Ltyrian_Html$();
        var $x_1 = $m_sr_ScalaRunTime$();
        var this$3 = $m_Ltyrian_Html$();
        var msg = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve(id$1);
        var attributes = $x_1.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Event(this$3, msg)]));
        var plainText = ("Approve " + id$1);
        return $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$4, attributes, plainText);
      });
      if ((this$5 === $m_sci_Nil$())) {
        var children = $m_sci_Nil$();
      } else {
        var x0 = this$5.head__O();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$5.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = $n(rest).head__O();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          $n(t).sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List($n(rest).tail__O());
        }
        var children = h;
      }
      var attributes$1 = $m_sci_Nil$();
      var key = $m_s_None$();
      var children$1 = $x_3.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$x_2, new $c_Ltyrian_Tag("div", attributes$1, children, key)]));
      var attributes$2 = $m_sci_Nil$();
      var this$10 = $n(children$1);
      var children$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$10);
      var key$1 = $m_s_None$();
      return new $c_sci_$colon$colon(new $c_Ltyrian_Tag("div", attributes$2, children$2, key$1), $m_sci_Nil$());
    }
  }
  return $m_sci_Nil$();
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.subscriptions__Lnet_andimiller_hedgehogs_dag_visitor_Model__Ltyrian_Sub = (function(model) {
  var x142 = $n(model).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
  var x = $m_s_None$();
  if ((x === x142)) {
    return $m_Ltyrian_Sub$None$();
  }
  if ((x142 instanceof $c_s_Some)) {
    var queue = $as_Lcats_effect_std_Queue($n($as_s_Some(x142)).s_Some__f_value);
    return $m_Ltyrian_Sub$().make__T__Lfs2_Stream__Lcats_effect_kernel_Async__Ltyrian_Sub("events", $n($m_Lfs2_Stream$().eval__O__Lfs2_Stream($n(queue).take__O())).repeat__Lfs2_Stream(), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
  }
  throw new $c_s_MatchError(x142);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$.prototype.launch = (function(arg, ...rest) {
  switch ($uI(rest.length)) {
    case 0: {
      if (((typeof arg) === "string")) {
        var prep0$2 = $as_T(arg);
        $f_Ltyrian_TyrianApp__launch__T__V(this, prep0$2);
        return (void 0);
      } else {
        $f_Ltyrian_TyrianApp__launch__Lorg_scalajs_dom_Element__V(this, arg);
        return (void 0);
      }
      break;
    }
    case 1: {
      if (((typeof arg) === "string")) {
        var prep0$4 = $as_T(arg);
        var prep1$2 = rest[0];
        $f_Ltyrian_TyrianApp__launch__T__sjs_js_Dictionary__V(this, prep0$4, prep1$2);
        return (void 0);
      } else {
        var prep1 = rest[0];
        $f_Ltyrian_TyrianApp__launch__Lorg_scalajs_dom_Element__sjs_js_Dictionary__V(this, arg, prep1);
        return (void 0);
      }
      break;
    }
    default: {
      throw new TypeError("No matching overload");
    }
  }
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Demo$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$, "net.andimiller.hedgehogs.dag.visitor.Demo$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Demo$: 1,
  Ltyrian_TyrianApp: 1,
  Ltyrian_TyrianIOApp: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_Demo$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_Demo$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_Demo$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_Demo$;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4.prototype.run__T__Lnet_andimiller_hedgehogs_dag_visitor_Node__sci_Map__Lcats_effect_IO = (function(id, node, inputs) {
  if ((node instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds)) {
    var x$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(node);
    var this$2 = $n(x$1);
    var x33 = this$2.Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds__f_n;
    var this$3 = $m_Lcats_effect_IO$();
    return $n(this$3.sleep__s_concurrent_duration_Duration__Lcats_effect_IO(x33)).as__O__Lcats_effect_IO(new $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(node));
  }
  var x = $s_Lnet_andimiller_hedgehogs_dag_visitor_Node$__Approval__Lnet_andimiller_hedgehogs_dag_visitor_Node();
  if (((x === null) ? (node === null) : $n(x).equals__O__Z(node))) {
    var this$10 = $m_Lcats_effect_IO$();
    var this$6 = new $c_s_concurrent_duration_package$DurationInt(500);
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
    var this$ = this$6.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    $m_s_concurrent_duration_Duration$();
    var hi = (this$ >> 31);
    var finiteDelay = new $c_s_concurrent_duration_FiniteDuration(this$, hi, unit);
    var $x_1 = $n(this$10.sleep__s_concurrent_duration_Duration__Lcats_effect_IO(finiteDelay));
    var handle = ("approval-" + id);
    return $x_1.as__O__Lcats_effect_IO(new $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(handle));
  }
  throw new $c_s_MatchError(node);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4.prototype.resume__T__Lnet_andimiller_hedgehogs_dag_visitor_Node__T__T__sci_Map__Lcats_effect_IO = (function(id, node, handle, payload, inputs) {
  var this$6 = $m_Lcats_effect_IO$();
  var this$2 = new $c_s_concurrent_duration_package$DurationInt(500);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  var finiteDelay = new $c_s_concurrent_duration_FiniteDuration(this$, hi, unit);
  return $n(this$6.sleep__s_concurrent_duration_Duration__Lcats_effect_IO(finiteDelay)).as__O__Lcats_effect_IO(new $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(node));
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4 = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4, "net.andimiller.hedgehogs.dag.visitor.Demo$$anon$4", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$4: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_SimpleSuspendableDagVisitor: 1
}));
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadGraphviz__Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadGraphviz;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll__Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Start__Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Start;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ApplySnapshot__Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ApplySnapshot;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SaveSnapshot__Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SaveSnapshot;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadSnapshot__Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadSnapshot;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SyncNodeColours__Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SyncNodeColours;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ClearLog__Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ClearLog;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__NoOp__Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__NoOp;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$() {
  $n_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ = this;
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadGraphviz = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6("LoadGraphviz", 1);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6("Reroll", 3);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Start = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6("Start", 4);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ApplySnapshot = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6("ApplySnapshot", 9);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SaveSnapshot = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6("SaveSnapshot", 10);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadSnapshot = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6("LoadSnapshot", 11);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SyncNodeColours = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6("SyncNodeColours", 17);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ClearLog = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6("ClearLog", 18);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__NoOp = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6("NoOp", 19);
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$.prototype;
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$, "net.andimiller.hedgehogs.dag.visitor.Msg$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_Msg$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_Msg$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_Msg$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_Msg$;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_Node$__Approval__Lnet_andimiller_hedgehogs_dag_visitor_Node() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_Node$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_Node$__Approval;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$() {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Encoder_Node$lzy1 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Encoder_Nodebitmap$1 = false;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Decoder_Node$lzy1 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Decoder_Nodebitmap$1 = false;
  $n_Lnet_andimiller_hedgehogs_dag_visitor_Node$ = this;
  $t_Lnet_andimiller_hedgehogs_dag_visitor_Node$__Approval = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1("Approval", 1);
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Node$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Node$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$.prototype.given_Encoder_Node__Lio_circe_Encoder = (function() {
  if ((!this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Encoder_Nodebitmap$1)) {
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(x$1);
      if ((x$1$1 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds)) {
        var x$1$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(x$1$1);
        var this$2 = $n(x$1$2);
        var x13 = this$2.Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds__f_n;
        var this$6 = $m_Lio_circe_Json$();
        var $x_4 = $m_sr_ScalaRunTime$();
        var $x_3 = $m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("type", "waitSeconds", $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString);
        var $x_2 = $m_Lio_circe_syntax_package$KeyOps$();
        var this$5 = $n(x13);
        var $x_1 = $n(this$5.s_concurrent_duration_FiniteDuration__f_unit).toSeconds__J__J(this$5.s_concurrent_duration_FiniteDuration__f_length_$lo, this$5.s_concurrent_duration_FiniteDuration__f_length_$hi);
        var fields = $x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_3, $x_2.$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("seconds", $x_1, $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeLong, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString)]));
        return this$6.fromFields__sc_Iterable__Lio_circe_Json(fields);
      }
      var x = $s_Lnet_andimiller_hedgehogs_dag_visitor_Node$__Approval__Lnet_andimiller_hedgehogs_dag_visitor_Node();
      if (((x === null) ? (x$1$1 === null) : $n(x).equals__O__Z(x$1$1))) {
        var this$8 = $m_Lio_circe_Json$();
        var fields$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$m_Lio_circe_syntax_package$KeyOps$().$colon$eq$extension__O__O__Lio_circe_Encoder__Lio_circe_KeyEncoder__T2("type", "approval", $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString, $m_Lio_circe_KeyEncoder$().Lio_circe_KeyEncoder$__f_encodeKeyString)]));
        return this$8.fromFields__sc_Iterable__Lio_circe_Json(fields$1);
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Encoder_Node$lzy1 = new $c_Lio_circe_Encoder$$anon$21(f);
    this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Encoder_Nodebitmap$1 = true;
  }
  return this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Encoder_Node$lzy1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$.prototype.given_Decoder_Node__Lio_circe_Decoder = (function() {
  if ((!this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Decoder_Nodebitmap$1)) {
    $m_Lio_circe_Decoder$();
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((c) => {
      var c$1 = $as_Lio_circe_HCursor(c);
      var this$1 = $n($n(c$1).get__T__Lio_circe_Decoder__s_util_Either("type", $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString));
      if ((this$1 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$1);
        var b = $n(x2).s_util_Right__f_value;
        var x$1 = $as_T(b);
        if ((x$1 === "waitSeconds")) {
          var this$2 = $n($n(c$1).get__T__Lio_circe_Decoder__s_util_Either("seconds", $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeLong));
          if ((this$2 instanceof $c_s_util_Right)) {
            var x2$1 = $as_s_util_Right(this$2);
            var b$1 = $n(x2$1).s_util_Right__f_value;
            var $x_1 = $uJ(b$1);
            var s_$_lo = $x_1.l;
            var s_$_hi = $x_1.h;
            var this$4 = new $c_s_concurrent_duration_package$DurationLong(s_$_lo, s_$_hi);
            var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
            var this$_$_lo = this$4.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
            var this$_$_hi = this$4.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
            $m_s_concurrent_duration_Duration$();
            var n = new $c_s_concurrent_duration_FiniteDuration(this$_$_lo, this$_$_hi, unit);
            return new $c_s_util_Right(new $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(n));
          } else {
            return this$2;
          }
        } else if ((x$1 === "approval")) {
          var value = $s_Lnet_andimiller_hedgehogs_dag_visitor_Node$__Approval__Lnet_andimiller_hedgehogs_dag_visitor_Node();
          return new $c_s_util_Right(value);
        } else {
          var value$1 = $m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure(("Unknown Node type: " + x$1), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(c$1).history__sci_List())));
          return new $c_s_util_Left(value$1);
        }
      } else {
        return this$1;
      }
    }));
    this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Decoder_Node$lzy1 = new $c_Lio_circe_Decoder$$anon$36(f);
    this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Decoder_Nodebitmap$1 = true;
  }
  return this.Lnet_andimiller_hedgehogs_dag_visitor_Node$__f_given_Decoder_Node$lzy1;
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Node$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Node$, "net.andimiller.hedgehogs.dag.visitor.Node$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Node$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_Node$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_Node$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_Node$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_Node$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_Node$;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending__Lnet_andimiller_hedgehogs_dag_visitor_State() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_State$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Running__Lnet_andimiller_hedgehogs_dag_visitor_State() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_State$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Running;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Suspended__Lnet_andimiller_hedgehogs_dag_visitor_State() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_State$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Suspended;
}
function $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done__Lnet_andimiller_hedgehogs_dag_visitor_State() {
  $m_Lnet_andimiller_hedgehogs_dag_visitor_State$();
  return $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_State$() {
  $n_Lnet_andimiller_hedgehogs_dag_visitor_State$ = this;
  $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending = new $c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3("Pending", 0);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Running = new $c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3("Running", 1);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Suspended = new $c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3("Suspended", 2);
  $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done = new $c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3("Done", 3);
  $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending__Lnet_andimiller_hedgehogs_dag_visitor_State();
  $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Running__Lnet_andimiller_hedgehogs_dag_visitor_State();
  $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Suspended__Lnet_andimiller_hedgehogs_dag_visitor_State();
  $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done__Lnet_andimiller_hedgehogs_dag_visitor_State();
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_State$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_State$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_State$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_State$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_State$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_State$.prototype;
var $d_Lnet_andimiller_hedgehogs_dag_visitor_State$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_State$, "net.andimiller.hedgehogs.dag.visitor.State$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_State$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_State$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_State$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_State$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_State$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_State$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_State$;
}
/** @constructor */
function $c_s_$less$colon$less() {
}
$c_s_$less$colon$less.prototype = new $h_O();
$c_s_$less$colon$less.prototype.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
}
$h_s_$less$colon$less.prototype = $c_s_$less$colon$less.prototype;
$c_s_$less$colon$less.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  $uZ(v1);
});
/** @constructor */
function $c_s_Predef$() {
  this.s_Predef$__f_Map = null;
  this.s_Predef$__f_Set = null;
  $n_s_Predef$ = this;
  this.s_Predef$__f_Map = $m_sci_Map$();
  this.s_Predef$__f_Set = $m_sci_Set$();
}
$c_s_Predef$.prototype = new $h_s_LowPriorityImplicits();
$c_s_Predef$.prototype.constructor = $c_s_Predef$;
/** @constructor */
function $h_s_Predef$() {
}
$h_s_Predef$.prototype = $c_s_Predef$.prototype;
$c_s_Predef$.prototype.assert__Z__V = (function(assertion) {
  if ((!assertion)) {
    throw new $c_jl_AssertionError("assertion failed");
  }
});
$c_s_Predef$.prototype.require__Z__V = (function(requirement) {
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed");
  }
});
var $d_s_Predef$ = new $TypeData().initClass($c_s_Predef$, "scala.Predef$", ({
  s_Predef$: 1,
  s_LowPriorityImplicits: 1,
  s_LowPriorityImplicits2: 1
}));
var $n_s_Predef$;
function $m_s_Predef$() {
  if ((!$n_s_Predef$)) {
    $n_s_Predef$ = new $c_s_Predef$();
  }
  return $n_s_Predef$;
}
function $f_s_Product2__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz._1__O();
      break;
    }
    case 1: {
      return $thiz._2__O();
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"));
    }
  }
}
function $f_s_Product3__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T3__f__1;
      break;
    }
    case 1: {
      return $thiz.T3__f__2;
      break;
    }
    case 2: {
      return $thiz.T3__f__3;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"));
    }
  }
}
function $f_s_Product4__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T4__f__1;
      break;
    }
    case 1: {
      return $thiz.T4__f__2;
      break;
    }
    case 2: {
      return $thiz.T4__f__3;
      break;
    }
    case 3: {
      return $thiz.T4__f__4;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"));
    }
  }
}
/** @constructor */
function $c_sc_BuildFrom$() {
}
$c_sc_BuildFrom$.prototype = new $h_O();
$c_sc_BuildFrom$.prototype.constructor = $c_sc_BuildFrom$;
/** @constructor */
function $h_sc_BuildFrom$() {
}
$h_sc_BuildFrom$.prototype = $c_sc_BuildFrom$.prototype;
var $d_sc_BuildFrom$ = new $TypeData().initClass($c_sc_BuildFrom$, "scala.collection.BuildFrom$", ({
  sc_BuildFrom$: 1,
  sc_BuildFromLowPriority1: 1,
  sc_BuildFromLowPriority2: 1
}));
var $n_sc_BuildFrom$;
function $m_sc_BuildFrom$() {
  if ((!$n_sc_BuildFrom$)) {
    $n_sc_BuildFrom$ = new $c_sc_BuildFrom$();
  }
  return $n_sc_BuildFrom$;
}
function $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__($thiz, delegate) {
  $thiz.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
}
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = new $h_O();
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.constructor = $c_sc_ClassTagIterableFactory$AnyIterableDelegate;
/** @constructor */
function $h_sc_ClassTagIterableFactory$AnyIterableDelegate() {
}
$h_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = $c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype;
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.empty__O = (function() {
  return $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate).empty__O__O($m_s_reflect_ManifestFactory$AnyManifest$());
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate).from__sc_IterableOnce__O__O(it, $m_s_reflect_ManifestFactory$AnyManifest$());
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.newBuilder__scm_Builder = (function() {
  var this$1 = $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate);
  var x0 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$1.newBuilder__s_reflect_ClassTag__scm_Builder(x0);
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.apply__sci_Seq__O = (function(elems) {
  var this$1 = $n(this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate);
  var evidence$7 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$1.from__sc_IterableOnce__O__O(elems, evidence$7);
});
function $ct_sc_IterableFactory$Delegate__sc_IterableFactory__($thiz, delegate) {
  $thiz.sc_IterableFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_IterableFactory$Delegate() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
}
$c_sc_IterableFactory$Delegate.prototype = new $h_O();
$c_sc_IterableFactory$Delegate.prototype.constructor = $c_sc_IterableFactory$Delegate;
/** @constructor */
function $h_sc_IterableFactory$Delegate() {
}
$h_sc_IterableFactory$Delegate.prototype = $c_sc_IterableFactory$Delegate.prototype;
$c_sc_IterableFactory$Delegate.prototype.empty__O = (function() {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).empty__O();
});
$c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).from__sc_IterableOnce__O(it);
});
$c_sc_IterableFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_IterableFactory$Delegate__f_delegate).newBuilder__scm_Builder();
});
/** @constructor */
function $c_sc_IterableFactory$ToFactory(factory) {
  this.sc_IterableFactory$ToFactory__f_factory = null;
  this.sc_IterableFactory$ToFactory__f_factory = factory;
}
$c_sc_IterableFactory$ToFactory.prototype = new $h_O();
$c_sc_IterableFactory$ToFactory.prototype.constructor = $c_sc_IterableFactory$ToFactory;
/** @constructor */
function $h_sc_IterableFactory$ToFactory() {
}
$h_sc_IterableFactory$ToFactory.prototype = $c_sc_IterableFactory$ToFactory.prototype;
$c_sc_IterableFactory$ToFactory.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_IterableFactory$ToFactory__f_factory).from__sc_IterableOnce__O(it);
});
var $d_sc_IterableFactory$ToFactory = new $TypeData().initClass($c_sc_IterableFactory$ToFactory, "scala.collection.IterableFactory$ToFactory", ({
  sc_IterableFactory$ToFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
}));
function $f_sc_IterableOps__last__O($thiz) {
  var it = $thiz.iterator__sc_Iterator();
  var lst = $n(it).next__O();
  while ($n(it).hasNext__Z()) {
    lst = $n(it).next__O();
  }
  return lst;
}
function $f_sc_IterableOps__sizeCompare__I__I($thiz, otherSize) {
  if ((otherSize < 0)) {
    return 1;
  } else {
    var known = $thiz.knownSize__I();
    if ((known >= 0)) {
      return ((known === otherSize) ? 0 : ((known < otherSize) ? (-1) : 1));
    } else {
      var i = 0;
      var it = $thiz.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        if ((i === otherSize)) {
          return 1;
        }
        $n(it).next__O();
        i = ((1 + i) | 0);
      }
      return ((i - otherSize) | 0);
    }
  }
}
function $f_sc_IterableOps__filter__F1__O($thiz, pred) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$Filter($thiz, pred, false));
}
function $f_sc_IterableOps__filterNot__F1__O($thiz, pred) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$Filter($thiz, pred, true));
}
function $f_sc_IterableOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Take__sc_IterableOps__I__(new $c_sc_View$Take(), $thiz, n));
}
function $f_sc_IterableOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $thiz, n));
}
function $f_sc_IterableOps__dropRight__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$DropRight__sc_IterableOps__I__(new $c_sc_View$DropRight(), $thiz, n));
}
function $f_sc_IterableOps__tail__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.drop__I__O(1);
}
function $f_sc_IterableOps__init__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.dropRight__I__O(1);
}
function $f_sc_IterableOps__map__F1__O($thiz, f) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f));
}
function $f_sc_IterableOps__flatMap__F1__O($thiz, f) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$FlatMap($thiz, f));
}
function $f_sc_IterableOps__collect__s_PartialFunction__O($thiz, pf) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(new $c_sc_View$Collect($thiz, pf));
}
function $f_sc_IterableOps__concat__sc_IterableOnce__O($thiz, suffix) {
  var $x_2 = $n($thiz.iterableFactory__sc_IterableFactory());
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $x_1 = new $c_sc_View$Concat($thiz, x2);
  } else {
    var this$1 = $n($thiz.iterator__sc_Iterator());
    var xs = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n(suffix).iterator__sc_Iterator()));
    var $x_1 = this$1.concat__F0__sc_Iterator(xs);
  }
  return $x_2.from__sc_IterableOnce__O($x_1);
}
function $is_sc_IterableOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOps)));
}
function $as_sc_IterableOps(obj) {
  return (($is_sc_IterableOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOps"));
}
function $isArrayOf_sc_IterableOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOps)));
}
function $asArrayOf_sc_IterableOps(obj, depth) {
  return (($isArrayOf_sc_IterableOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOps;", depth));
}
function $f_sc_Iterator__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var dropped = $thiz.drop__I__sc_Iterator(from);
  while ($n(dropped).hasNext__Z()) {
    if ($uZ($n(p).apply__O__O($n(dropped).next__O()))) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
}
function $f_sc_Iterator__concat__F0__sc_Iterator($thiz, xs) {
  return new $c_sc_Iterator$ConcatIterator($thiz).concat__F0__sc_Iterator(xs);
}
function $f_sc_Iterator__take__I__sc_Iterator($thiz, n) {
  return $thiz.sliceIterator__I__I__sc_Iterator(0, ((n > 0) ? n : 0));
}
function $f_sc_Iterator__sliceIterator__I__I__sc_Iterator($thiz, from, until) {
  var lo = ((from > 0) ? from : 0);
  var rest = ((until < 0) ? (-1) : ((until <= lo) ? 0 : ((until - lo) | 0)));
  return ((rest === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_Iterator$SliceIterator($thiz, lo, rest));
}
function $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz, that) {
  var those = $n(that).iterator__sc_Iterator();
  while ($thiz.hasNext__Z()) {
    if ((!$n(those).hasNext__Z())) {
      return false;
    }
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($thiz.next__O(), $n(those).next__O()))) {
      return false;
    }
  }
  return (!$n(those).hasNext__Z());
}
function $is_sc_Iterator(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterator)));
}
function $as_sc_Iterator(obj) {
  return (($is_sc_Iterator(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator"));
}
function $isArrayOf_sc_Iterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator)));
}
function $asArrayOf_sc_Iterator(obj, depth) {
  return (($isArrayOf_sc_Iterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator;", depth));
}
/** @constructor */
function $c_sc_Iterator$() {
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = null;
  $n_sc_Iterator$ = this;
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = new $c_sc_Iterator$$anon$19();
}
$c_sc_Iterator$.prototype = new $h_O();
$c_sc_Iterator$.prototype.constructor = $c_sc_Iterator$;
/** @constructor */
function $h_sc_Iterator$() {
}
$h_sc_Iterator$.prototype = $c_sc_Iterator$.prototype;
$c_sc_Iterator$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sc_Iterator$$anon$21();
});
$c_sc_Iterator$.prototype.empty__O = (function() {
  return this.sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sc_Iterator$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $n(source).iterator__sc_Iterator();
});
var $d_sc_Iterator$ = new $TypeData().initClass($c_sc_Iterator$, "scala.collection.Iterator$", ({
  sc_Iterator$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Iterator$;
function $m_sc_Iterator$() {
  if ((!$n_sc_Iterator$)) {
    $n_sc_Iterator$ = new $c_sc_Iterator$();
  }
  return $n_sc_Iterator$;
}
function $ct_sc_MapFactory$Delegate__sc_MapFactory__($thiz, delegate) {
  $thiz.sc_MapFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_MapFactory$Delegate() {
  this.sc_MapFactory$Delegate__f_delegate = null;
}
$c_sc_MapFactory$Delegate.prototype = new $h_O();
$c_sc_MapFactory$Delegate.prototype.constructor = $c_sc_MapFactory$Delegate;
/** @constructor */
function $h_sc_MapFactory$Delegate() {
}
$h_sc_MapFactory$Delegate.prototype = $c_sc_MapFactory$Delegate.prototype;
$c_sc_MapFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return $n(this.sc_MapFactory$Delegate__f_delegate).apply__sci_Seq__O(elems);
});
$c_sc_MapFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return $n(this.sc_MapFactory$Delegate__f_delegate).from__sc_IterableOnce__O(it);
});
$c_sc_MapFactory$Delegate.prototype.empty__O = (function() {
  return $n(this.sc_MapFactory$Delegate__f_delegate).empty__O();
});
$c_sc_MapFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_MapFactory$Delegate__f_delegate).newBuilder__scm_Builder();
});
/** @constructor */
function $c_sc_View$() {
}
$c_sc_View$.prototype = new $h_O();
$c_sc_View$.prototype.constructor = $c_sc_View$;
/** @constructor */
function $h_sc_View$() {
}
$h_sc_View$.prototype = $c_sc_View$.prototype;
$c_sc_View$.prototype.from__sc_IterableOnce__sc_View = (function(it) {
  if ($is_sc_View(it)) {
    var x2 = $as_sc_View(it);
    return x2;
  } else if ($is_sc_Iterable(it)) {
    var x3 = $as_sc_Iterable(it);
    var it$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n(x3).iterator__sc_Iterator()));
    return new $c_sc_View$$anon$1(it$1);
  } else {
    var this$2 = $n($m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(it));
    return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this$2);
  }
});
$c_sc_View$.prototype.newBuilder__scm_Builder = (function() {
  $m_scm_ArrayBuffer$();
  var this$2 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((it$2$2) => {
    var it$2 = $as_sc_IterableOnce(it$2$2);
    return $m_sc_View$().from__sc_IterableOnce__sc_View(it$2);
  }));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_sc_View$.prototype.dropRightIterator__sc_Iterator__I__sc_Iterator = (function(it, n) {
  if ((n <= 0)) {
    return it;
  } else {
    var k = $n(it).knownSize__I();
    return ((k >= 0) ? $n(it).take__I__sc_Iterator(((k - n) | 0)) : new $c_sc_View$DropRightIterator(it, n));
  }
});
$c_sc_View$.prototype.empty__O = (function() {
  return $m_sc_View$Empty$();
});
$c_sc_View$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_View(source);
});
var $d_sc_View$ = new $TypeData().initClass($c_sc_View$, "scala.collection.View$", ({
  sc_View$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_View$;
function $m_sc_View$() {
  if ((!$n_sc_View$)) {
    $n_sc_View$ = new $c_sc_View$();
  }
  return $n_sc_View$;
}
/** @constructor */
function $c_sci_BitmapIndexedMapNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedMapNode__f_dataMap = 0;
  this.sci_BitmapIndexedMapNode__f_nodeMap = 0;
  this.sci_BitmapIndexedMapNode__f_content = null;
  this.sci_BitmapIndexedMapNode__f_originalHashes = null;
  this.sci_BitmapIndexedMapNode__f_size = 0;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedMapNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedMapNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedMapNode__f_content = content;
  this.sci_BitmapIndexedMapNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedMapNode__f_size = size;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode;
}
$c_sci_BitmapIndexedMapNode.prototype = new $h_sci_MapNode();
$c_sci_BitmapIndexedMapNode.prototype.constructor = $c_sci_BitmapIndexedMapNode;
/** @constructor */
function $h_sci_BitmapIndexedMapNode() {
}
$h_sci_BitmapIndexedMapNode.prototype = $c_sci_BitmapIndexedMapNode.prototype;
$c_sci_BitmapIndexedMapNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_size;
});
$c_sci_BitmapIndexedMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode;
});
$c_sci_BitmapIndexedMapNode.prototype.getKey__I__O = (function(index) {
  return $n(this.sci_BitmapIndexedMapNode__f_content).get((index << 1));
});
$c_sci_BitmapIndexedMapNode.prototype.getValue__I__O = (function(index) {
  return $n(this.sci_BitmapIndexedMapNode__f_content).get(((1 + (index << 1)) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.getPayload__I__T2 = (function(index) {
  return new $c_T2($n(this.sci_BitmapIndexedMapNode__f_content).get((index << 1)), $n(this.sci_BitmapIndexedMapNode__f_content).get(((1 + (index << 1)) | 0)));
});
$c_sci_BitmapIndexedMapNode.prototype.getHash__I__I = (function(index) {
  return $n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(index);
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  return $as_sci_MapNode($n(this.sci_BitmapIndexedMapNode__f_content).get((((($n(this.sci_BitmapIndexedMapNode__f_content).u.length - 1) | 0) - index) | 0)));
});
$c_sci_BitmapIndexedMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index))) {
      return this.getValue__I__O(index);
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    return $n(this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos))).apply__O__I__I__I__O(key, originalHash, keyHash, ((5 + shift) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_BitmapIndexedMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? new $c_s_Some(this.getValue__I__O(index)) : $m_s_None$());
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return $n(this.getNode__I__sci_MapNode(index$2)).get__O__I__I__I__s_Option(key, originalHash, keyHash, ((5 + shift) | 0));
  } else {
    return $m_s_None$();
  }
});
$c_sci_BitmapIndexedMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, keyHash, shift, f) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? this.getValue__I__O(index) : $n(f).apply__O());
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return $n(this.getNode__I__sci_MapNode(index$2)).getOrElse__O__I__I__I__F0__O(key, originalHash, keyHash, ((5 + shift) | 0), f);
  } else {
    return $n(f).apply__O();
  }
});
$c_sci_BitmapIndexedMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    return (($n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index)));
  } else {
    return (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0) && $n(this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos))).containsKey__O__I__I__I__Z(key, originalHash, keyHash, ((5 + shift) | 0)));
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode = (function(key, value, originalHash, keyHash, shift, replaceValue) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      if (replaceValue) {
        var value0 = this.getValue__I__O(index);
        return ((Object.is(key0, key) && Object.is(value0, value)) ? this : this.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode(bitpos, key, value));
      } else {
        return this;
      }
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      return this.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew$2 = $n(subNode).updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), replaceValue);
    return ((subNodeNew$2 === subNode) ? this : this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew$2));
  } else {
    return this.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode(bitpos, key, originalHash, keyHash, value);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updateWithShallowMutations__O__O__I__I__I__I__I = (function(key, value, originalHash, keyHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      var value0 = this.getValue__I__O(index);
      if ((!(Object.is(key0, key) && Object.is(value0, value)))) {
        var dataIx = this.dataIndex__I__I(bitpos);
        var idx = (dataIx << 1);
        $n(this.sci_BitmapIndexedMapNode__f_content).set(((1 + idx) | 0), value);
      }
      return shallowlyMutableNodeMap;
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos);
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeSize = $n(subNode).size__I();
    var subNodeHashCode = $n(subNode).cachedJavaKeySetHashCode__I();
    var returnMutableNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$2;
      if ((subNode instanceof $c_sci_BitmapIndexedMapNode)) {
        var x2 = $as_sci_BitmapIndexedMapNode(subNode);
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          $n(x2).updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, keyHash, ((5 + shift) | 0), 0);
          var subNodeNew$2 = x2;
          break matchEnd4;
        }
      }
      var result = $n(subNode).updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), true);
      if ((result !== subNode)) {
        returnMutableNodeMap = (returnMutableNodeMap | bitpos);
      }
      var subNodeNew$2 = result;
    }
    $n(this.sci_BitmapIndexedMapNode__f_content).set((((($n(this.sci_BitmapIndexedMapNode__f_content).u.length - 1) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew$2);
    this.sci_BitmapIndexedMapNode__f_size = ((((this.sci_BitmapIndexedMapNode__f_size - subNodeSize) | 0) + $n(subNodeNew$2).size__I()) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - subNodeHashCode) | 0) + $n(subNodeNew$2).cachedJavaKeySetHashCode__I()) | 0);
    return returnMutableNodeMap;
  } else {
    var dataIx$2 = this.dataIndex__I__I(bitpos);
    var idx$2 = (dataIx$2 << 1);
    var src = this.sci_BitmapIndexedMapNode__f_content;
    var dst = new $ac_O(((2 + $n(src).u.length) | 0));
    $systemArraycopyRefs($n(src), 0, dst, 0, idx$2);
    dst.set(idx$2, key);
    dst.set(((1 + idx$2) | 0), value);
    var destPos = ((2 + idx$2) | 0);
    var length = (($n(src).u.length - idx$2) | 0);
    $systemArraycopyRefs($n(src), idx$2, dst, destPos, length);
    this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedMapNode__f_content = dst;
    this.sci_BitmapIndexedMapNode__f_originalHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx$2, originalHash);
    this.sci_BitmapIndexedMapNode__f_size = ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
    return shallowlyMutableNodeMap;
  }
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_BitmapIndexedMapNode = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key0, key)) {
      var i = this.sci_BitmapIndexedMapNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
        var $x_1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(keyHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(1), this.getValue__I__O(1)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(1)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1))) : new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(0), this.getValue__I__O(0)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(0)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0))));
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode(bitpos, keyHash);
      }
    } else {
      return this;
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew = $n(subNode).removed__O__I__I__I__sci_MapNode(key, originalHash, keyHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this;
    }
    var subNodeNewSize = $n(subNodeNew).size__I();
    return ((subNodeNewSize === 1) ? ((this.sci_BitmapIndexedMapNode__f_size === $n(subNode).size__I()) ? $as_sci_BitmapIndexedMapNode(subNodeNew) : this.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew)) : ((subNodeNewSize > 1) ? this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew) : this));
  } else {
    return this;
  }
});
$c_sci_BitmapIndexedMapNode.prototype.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode = (function(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var x0 = new $c_T2(key0, value0);
    var x1 = new $c_T2(key1, value1);
    var array = [x0, x1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionMapNode(originalHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems));
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    var newCachedHash = ((keyHash0 + keyHash1) | 0);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key0, value0, key1, value1]), new $ac_I(new Int32Array([originalHash0, originalHash1])), 2, newCachedHash) : new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key1, value1, key0, value0]), new $ac_I(new Int32Array([originalHash1, originalHash0])), 2, newCachedHash));
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedMapNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, $n(node).size__I(), $n(node).cachedJavaKeySetHashCode__I());
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_nodeMap !== 0);
});
$c_sci_BitmapIndexedMapNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_dataMap !== 0);
});
$c_sci_BitmapIndexedMapNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_dataMap & ((bitpos - 1) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_nodeMap & ((bitpos - 1) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode = (function(bitpos, newKey, newValue) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  var length = $n(src).u.length;
  $systemArraycopyRefs($n(src), 0, dst, 0, length);
  dst.set(((1 + idx) | 0), newValue);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode);
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, newNode) {
  var idx = (((($n(this.sci_BitmapIndexedMapNode__f_content).u.length - 1) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  var length = $n(src).u.length;
  $systemArraycopyRefs($n(src), 0, dst, 0, length);
  dst.set(idx, newNode);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, ((((this.sci_BitmapIndexedMapNode__f_size - $n(oldNode).size__I()) | 0) + $n(newNode).size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(newNode).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode = (function(bitpos, key, originalHash, keyHash, value) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idx);
  dst.set(idx, key);
  dst.set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = (($n(src).u.length - idx) | 0);
  $systemArraycopyRefs($n(src), idx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode = (function(bitpos, keyHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((($n(src).u.length - 2) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idx);
  var srcPos = ((2 + idx) | 0);
  var length = (((($n(src).u.length - idx) | 0) - 2) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, idx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, ((this.sci_BitmapIndexedMapNode__f_size - 1) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((($n(this.sci_BitmapIndexedMapNode__f_content).u.length - 2) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((($n(src).u.length - 1) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, idxOld, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((($n(src).u.length - idxNew) | 0) - 2) | 0);
  $systemArraycopyRefs($n(src), srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedMapNode__f_nodeMap = (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedMapNode__f_content = dst;
  this.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedMapNode__f_size = ((((this.sci_BitmapIndexedMapNode__f_size - 1) | 0) + $n(node).size__I()) | 0);
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0);
  return this;
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((($n(this.sci_BitmapIndexedMapNode__f_content).u.length - 2) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((($n(src).u.length - 1) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, idxOld, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((($n(src).u.length - idxNew) | 0) - 2) | 0);
  $systemArraycopyRefs($n(src), srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos), dst, dstHashes, ((((this.sci_BitmapIndexedMapNode__f_size - 1) | 0) + $n(node).size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, node) {
  var idxOld = (((($n(this.sci_BitmapIndexedMapNode__f_content).u.length - 1) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var idxNew = (dataIxNew << 1);
  var key = $n(node).getKey__I__O(0);
  var value = $n(node).getValue__I__O(0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((1 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idxNew);
  dst.set(idxNew, key);
  dst.set(((1 + idxNew) | 0), value);
  var destPos = ((2 + idxNew) | 0);
  var length = ((idxOld - idxNew) | 0);
  $systemArraycopyRefs($n(src), idxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((2 + idxOld) | 0);
  var length$1 = (((($n(src).u.length - idxOld) | 0) - 1) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, destPos$1, length$1);
  var hash = $n(node).getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedMapNode__f_size - $n(oldNode).size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    $n(f).apply__O__O(this.getPayload__I__T2(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_MapNode(j)).foreach__F1__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachEntry__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    $n(f).apply__O__O__O(this.getKey__I__O(i$1), this.getValue__I__O(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_MapNode(j)).foreachEntry__F2__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var i = 0;
  var i$1 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i$1);
  while ((i < iN)) {
    $n(f).apply__O__O__O__O(this.getKey__I__O(i), this.getValue__I__O(i), this.getHash__I__I(i));
    i = ((1 + i) | 0);
  }
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_MapNode(j)).foreachWithHash__F3__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this === x2)) {
      return true;
    } else {
      if (((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode === $n(x2).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedMapNode__f_nodeMap === $n(x2).sci_BitmapIndexedMapNode__f_nodeMap)) && (this.sci_BitmapIndexedMapNode__f_dataMap === $n(x2).sci_BitmapIndexedMapNode__f_dataMap)) && (this.sci_BitmapIndexedMapNode__f_size === $n(x2).sci_BitmapIndexedMapNode__f_size))) {
        var a = this.sci_BitmapIndexedMapNode__f_originalHashes;
        var b = $n(x2).sci_BitmapIndexedMapNode__f_originalHashes;
        var $x_1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var a1 = this.sci_BitmapIndexedMapNode__f_content;
        var a2 = $n(x2).sci_BitmapIndexedMapNode__f_content;
        var length = $n(this.sci_BitmapIndexedMapNode__f_content).u.length;
        if ((a1 === a2)) {
          return true;
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z($n(a1).get(i), $n(a2).get(i));
            i = ((1 + i) | 0);
          }
          return isEqual;
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_BitmapIndexedMapNode.prototype.toString__T = (function() {
  var i = $systemIdentityHashCode(this);
  return (($objectClassName(this) + "@") + $as_T((i >>> 0.0).toString(16)));
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_BitmapIndexedMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
      return x2;
    } else if ((($n(x2).sci_BitmapIndexedMapNode__f_size === 0) || (x2 === this))) {
      return this;
    } else if (($n(x2).sci_BitmapIndexedMapNode__f_size === 1)) {
      var originalHash = $n(x2).getHash__I__I(0);
      return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode($n(x2).getKey__I__O(0), $n(x2).getValue__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift, true);
    }
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedMapNode__f_dataMap | $n(x2).sci_BitmapIndexedMapNode__f_dataMap) | this.sci_BitmapIndexedMapNode__f_nodeMap) | $n(x2).sci_BitmapIndexedMapNode__f_nodeMap);
    var $x_1 = $m_sci_Node$();
    var i = ((~allMap) & ((allMap - 1) | 0));
    var minimumBitPos = $x_1.bitposFrom__I__I(((32 - Math.clz32(i)) | 0));
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - Math.clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataRightOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          var leftOriginalHash = this.getHash__I__I(leftIdx);
          if (((leftOriginalHash === $n(x2).getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getKey__I__O(leftIdx), $n(x2).getKey__I__O(rightIdx)))) {
            leftDataRightDataRightOverwrites = (leftDataRightDataRightOverwrites | bitpos);
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(leftOriginalHash), shift)));
          }
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos);
        } else {
          leftDataOnly = (leftDataOnly | bitpos);
        }
        leftIdx = ((1 + leftIdx) | 0);
      } else if (((bitpos & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos);
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos);
        }
      } else if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0);
      } else if (((bitpos & $n(x2).sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos);
      }
      if ((bitpos === maximumBitPos)) {
        finished = true;
      } else {
        bitpos = (bitpos << 1);
      }
    }
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataRightOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (rightDataOnly | leftDataRightDataRightOverwrites)) && (newNodeMap === rightNodeOnly))) {
      return x2;
    }
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var rightNode = $n(x2).getNode__I__sci_MapNode(rightNodeIdx);
        var newNode = $n(this.getNode__I__sci_MapNode(leftNodeIdx)).concat__sci_MapNode__I__sci_MapNode(rightNode, nextShift);
        if ((rightNode !== newNode)) {
          anyChangesMadeSoFar = true;
        }
        newContent.set(((((newContentSize - compressedNodeIdx) | 0) - 1) | 0), newNode);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + $n(newNode).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        var n = $n(x2).getNode__I__sci_MapNode(rightNodeIdx);
        var leftKey = this.getKey__I__O(leftDataIdx);
        var leftValue = this.getValue__I__O(leftDataIdx);
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash$2);
        var updated = $n(n).updated__O__O__I__I__I__Z__sci_MapNode(leftKey, leftValue, leftOriginalHash$2, leftImproved, nextShift, false);
        if ((updated !== n)) {
          anyChangesMadeSoFar = true;
        }
        newContent.set(((((newContentSize - compressedNodeIdx) | 0) - 1) | 0), updated);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + $n(updated).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(updated).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        anyChangesMadeSoFar = true;
        var rightOriginalHash = $n(x2).getHash__I__I(rightDataIdx);
        var newNode$3 = $n(this.getNode__I__sci_MapNode(leftNodeIdx)).updated__O__O__I__I__I__Z__sci_MapNode($n(x2).getKey__I__O(rightDataIdx), $n(x2).getValue__I__O(rightDataIdx), $n(x2).getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift, true);
        newContent.set(((((newContentSize - compressedNodeIdx) | 0) - 1) | 0), newNode$3);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + $n(newNode$3).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$3).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$2 = $n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(leftDataIdx);
        newContent.set((compressedDataIdx << 1), this.getKey__I__O(leftDataIdx));
        newContent.set(((1 + (compressedDataIdx << 1)) | 0), this.getValue__I__O(leftDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$2);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0);
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        var originalHash$3 = $n($n(x2).sci_BitmapIndexedMapNode__f_originalHashes).get(rightDataIdx);
        newContent.set((compressedDataIdx << 1), $n(x2).getKey__I__O(rightDataIdx));
        newContent.set(((1 + (compressedDataIdx << 1)) | 0), $n(x2).getValue__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$3);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0);
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$4 = this.getNode__I__sci_MapNode(leftNodeIdx);
        newContent.set(((((newContentSize - compressedNodeIdx) | 0) - 1) | 0), newNode$4);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + $n(newNode$4).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$4).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        var newNode$5 = $n(x2).getNode__I__sci_MapNode(rightNodeIdx);
        newContent.set(((((newContentSize - compressedNodeIdx) | 0) - 1) | 0), newNode$5);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + $n(newNode$5).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$5).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$3 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = $n(x2).getHash__I__I(rightDataIdx);
        var newNode$6 = $n(x2).mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(this.getKey__I__O(leftDataIdx), this.getValue__I__O(leftDataIdx), leftOriginalHash$3, $m_sc_Hashing$().improve__I__I(leftOriginalHash$3), $n(x2).getKey__I__O(rightDataIdx), $n(x2).getValue__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        newContent.set(((((newContentSize - compressedNodeIdx) | 0) - 1) | 0), newNode$6);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + $n(newNode$6).size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + $n(newNode$6).cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataRightOverwrites) !== 0)) {
        var originalHash$4 = $n($n(x2).sci_BitmapIndexedMapNode__f_originalHashes).get(rightDataIdx);
        newContent.set((compressedDataIdx << 1), $n(x2).getKey__I__O(rightDataIdx));
        newContent.set(((1 + (compressedDataIdx << 1)) | 0), $n(x2).getValue__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$4);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
      }
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true;
      } else {
        bitpos$2 = (bitpos$2 << 1);
      }
    }
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedMapNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : x2);
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode");
  }
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_BitmapIndexedMapNode = (function() {
  var this$1 = $n(this.sci_BitmapIndexedMapNode__f_content);
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var i$1 = ($m_jl_Integer$().bitCount__I__I(i) << 1);
  while ((i$1 < contentLength)) {
    contentClone.set(i$1, $n($as_sci_MapNode(contentClone.get(i$1))).copy__sci_MapNode());
    i$1 = ((1 + i$1) | 0);
  }
  var $x_2 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var $x_1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var this$2 = $n(this.sci_BitmapIndexedMapNode__f_originalHashes);
  return new $c_sci_BitmapIndexedMapNode($x_2, $x_1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode);
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_BitmapIndexedMapNode = (function(pred, flipped) {
  if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
    return this;
  } else if ((this.sci_BitmapIndexedMapNode__f_size === 1)) {
    if (($uZ($n(pred).apply__O__O(this.getPayload__I__T2(0))) !== flipped)) {
      return this;
    } else {
      var this$1 = $m_sci_MapNode$();
      return this$1.sci_MapNode$__f_EmptyMapNode;
    }
  } else if ((this.sci_BitmapIndexedMapNode__f_nodeMap === 0)) {
    var i = this.sci_BitmapIndexedMapNode__f_dataMap;
    var i$1 = ((~i) & ((i - 1) | 0));
    var minimumIndex = ((32 - Math.clz32(i$1)) | 0);
    var i$2 = this.sci_BitmapIndexedMapNode__f_dataMap;
    var maximumIndex = ((32 - Math.clz32(i$2)) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i$3);
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload = this.getPayload__I__T2(dataIndex);
        var passed = ($uZ($n(pred).apply__O__O(payload)) !== flipped);
        if (passed) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      var this$4 = $m_sci_MapNode$();
      return this$4.sci_MapNode$__f_EmptyMapNode;
    } else if ((newDataMap === this.sci_BitmapIndexedMapNode__f_dataMap)) {
      return this;
    } else {
      var i$4 = newDataMap;
      var newSize = $m_jl_Integer$().bitCount__I__I(i$4);
      var newContent = new $ac_O((newSize << 1));
      var newOriginalHashCodes = new $ac_I(newSize);
      var i$5 = newDataMap;
      var newMaximumIndex = ((32 - Math.clz32(i$5)) | 0);
      var i$6 = newDataMap;
      var i$7 = ((~i$6) & ((i$6 - 1) | 0));
      var j = ((32 - Math.clz32(i$7)) | 0);
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().bitposFrom__I__I(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, bitpos$2);
          newContent.set((newDataIndex << 1), $n(this.sci_BitmapIndexedMapNode__f_content).get((oldIndex << 1)));
          newContent.set(((1 + (newDataIndex << 1)) | 0), $n(this.sci_BitmapIndexedMapNode__f_content).get(((1 + (oldIndex << 1)) | 0)));
          newOriginalHashCodes.set(newDataIndex, $n(this.sci_BitmapIndexedMapNode__f_originalHashes).get(oldIndex));
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.sci_BitmapIndexedMapNode__f_dataMap | this.sci_BitmapIndexedMapNode__f_nodeMap);
    var i$8 = ((~allMap) & ((allMap - 1) | 0));
    var minimumIndex$2 = ((32 - Math.clz32(i$8)) | 0);
    var maximumIndex$2 = ((32 - Math.clz32(allMap)) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().bitposFrom__I__I(i$2$1);
      if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload$2 = this.getPayload__I__T2(dataIndex$2);
        var passed$2 = ($uZ($n(pred).apply__O__O(payload$2)) !== flipped);
        if (passed$2) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        var oldSubNode = this.getNode__I__sci_MapNode(nodeIndex);
        var newSubNode = $n(oldSubNode).filterImpl__F1__Z__sci_MapNode(pred, flipped);
        newSize$2 = ((newSize$2 + $n(newSubNode).size__I()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + $n(newSubNode).cachedJavaKeySetHashCode__I()) | 0);
        if (($n(newSubNode).size__I() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = new $c_scm_Queue(16);
            }
            var this$10 = $n(newNodes);
            this$10.addOne__O__scm_ArrayDeque(newSubNode);
          }
        } else if (($n(newSubNode).size__I() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            var elems = $m_sci_Nil$();
            var this$12 = new $c_scm_Queue(16);
            nodesToMigrateToData = $as_scm_Queue(this$12.addAll__sc_IterableOnce__scm_ArrayDeque(elems));
          }
          var this$13 = $n(nodesToMigrateToData);
          this$13.addOne__O__scm_ArrayDeque(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    if ((newSize$2 === 0)) {
      var this$14 = $m_sci_MapNode$();
      return this$14.sci_MapNode$__f_EmptyMapNode;
    } else if ((newSize$2 === this.sci_BitmapIndexedMapNode__f_size)) {
      return this;
    } else {
      var i$9 = newDataMap$2;
      var newDataSize = $m_jl_Integer$().bitCount__I__I(i$9);
      var i$10 = newNodeMap;
      var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(i$10)) | 0);
      var newContent$2 = new $ac_O(newContentSize);
      var newOriginalHashes = new $ac_I(newDataSize);
      var newAllMap = (newDataMap$2 | newNodeMap);
      var maxIndex = ((32 - Math.clz32(newAllMap)) | 0);
      var i$3$1 = minimumIndex$2;
      var oldDataIndex = 0;
      var oldNodeIndex = 0;
      var newDataIndex$2 = 0;
      var newNodeIndex = 0;
      while ((i$3$1 < maxIndex)) {
        var bitpos$4 = $m_sci_Node$().bitposFrom__I__I(i$3$1);
        if (((bitpos$4 & oldDataPassThrough) !== 0)) {
          newContent$2.set((newDataIndex$2 << 1), this.getKey__I__O(oldDataIndex));
          newContent$2.set(((1 + (newDataIndex$2 << 1)) | 0), this.getValue__I__O(oldDataIndex));
          newOriginalHashes.set(newDataIndex$2, this.getHash__I__I(oldDataIndex));
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & nodesToPassThroughMap) !== 0)) {
          newContent$2.set(((((newContentSize - newNodeIndex) | 0) - 1) | 0), this.getNode__I__sci_MapNode(oldNodeIndex));
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & nodeMigrateToDataTargetMap) !== 0)) {
          var this$16 = $n(nodesToMigrateToData);
          var node = $as_sci_MapNode(this$16.removeHead__Z__O(false));
          newContent$2.set((newDataIndex$2 << 1), $n(node).getKey__I__O(0));
          newContent$2.set(((1 + (newDataIndex$2 << 1)) | 0), $n(node).getValue__I__O(0));
          newOriginalHashes.set(newDataIndex$2, $n(node).getHash__I__I(0));
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & mapOfNewNodes) !== 0)) {
          var $x_1 = newNodeIndex;
          var this$17 = $n(newNodes);
          newContent$2.set(((((newContentSize - $x_1) | 0) - 1) | 0), this$17.removeHead__Z__O(false));
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        }
        i$3$1 = ((1 + i$3$1) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap$2, newNodeMap, newContent$2, newOriginalHashes, newSize$2, newCachedHashCode$2);
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, isFlipped) {
  return this.filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped);
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_MapNode = (function() {
  return this.copy__sci_BitmapIndexedMapNode();
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(that, shift);
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, originalHash, hash, shift);
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, hash, shift, replaceValue);
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index);
});
function $as_sci_BitmapIndexedMapNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedMapNode"));
}
function $isArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedMapNode)));
}
function $asArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedMapNode;", depth));
}
var $d_sci_BitmapIndexedMapNode = new $TypeData().initClass($c_sci_BitmapIndexedMapNode, "scala.collection.immutable.BitmapIndexedMapNode", ({
  sci_BitmapIndexedMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1
}));
function $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode($thiz, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode) {
  if ((newSize === 0)) {
    var this$1 = $m_sci_SetNode$();
    return this$1.sci_SetNode$__f_EmptySetNode;
  } else if ((newSize === $thiz.sci_BitmapIndexedSetNode__f_size)) {
    return $thiz;
  } else {
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newAllMap = (newDataMap | newNodeMap);
    var maxIndex = ((32 - Math.clz32(newAllMap)) | 0);
    var i = minimumIndex;
    var oldDataIndex = 0;
    var oldNodeIndex = 0;
    var newDataIndex = 0;
    var newNodeIndex = 0;
    while ((i < maxIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i);
      if (((bitpos & oldDataPassThrough) !== 0)) {
        newContent.set(newDataIndex, $thiz.getPayload__I__O(oldDataIndex));
        newOriginalHashes.set(newDataIndex, $thiz.getHash__I__I(oldDataIndex));
        newDataIndex = ((1 + newDataIndex) | 0);
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & nodesToPassThroughMap) !== 0)) {
        newContent.set(((((newContentSize - newNodeIndex) | 0) - 1) | 0), $thiz.getNode__I__sci_SetNode(oldNodeIndex));
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & nodeMigrateToDataTargetMap) !== 0)) {
        var this$3 = $n(nodesToMigrateToData);
        var node = $as_sci_SetNode(this$3.removeHead__Z__O(false));
        newContent.set(newDataIndex, $n(node).getPayload__I__O(0));
        newOriginalHashes.set(newDataIndex, $n(node).getHash__I__I(0));
        newDataIndex = ((1 + newDataIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & mapOfNewNodes) !== 0)) {
        var $x_1 = newNodeIndex;
        var this$4 = $n(newNodes);
        newContent.set(((((newContentSize - $x_1) | 0) - 1) | 0), this$4.removeHead__Z__O(false));
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & $thiz.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & $thiz.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      }
      i = ((1 + i) | 0);
    }
    return new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode);
  }
}
/** @constructor */
function $c_sci_BitmapIndexedSetNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedSetNode__f_dataMap = 0;
  this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
  this.sci_BitmapIndexedSetNode__f_content = null;
  this.sci_BitmapIndexedSetNode__f_originalHashes = null;
  this.sci_BitmapIndexedSetNode__f_size = 0;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedSetNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedSetNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedSetNode__f_content = content;
  this.sci_BitmapIndexedSetNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedSetNode__f_size = size;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode;
}
$c_sci_BitmapIndexedSetNode.prototype = new $h_sci_SetNode();
$c_sci_BitmapIndexedSetNode.prototype.constructor = $c_sci_BitmapIndexedSetNode;
/** @constructor */
function $h_sci_BitmapIndexedSetNode() {
}
$h_sci_BitmapIndexedSetNode.prototype = $c_sci_BitmapIndexedSetNode.prototype;
$c_sci_BitmapIndexedSetNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_size;
});
$c_sci_BitmapIndexedSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode;
});
$c_sci_BitmapIndexedSetNode.prototype.getPayload__I__O = (function(index) {
  return $n(this.sci_BitmapIndexedSetNode__f_content).get(index);
});
$c_sci_BitmapIndexedSetNode.prototype.getHash__I__I = (function(index) {
  return $n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(index);
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  return $as_sci_SetNode($n(this.sci_BitmapIndexedSetNode__f_content).get((((($n(this.sci_BitmapIndexedSetNode__f_content).u.length - 1) | 0) - index) | 0)));
});
$c_sci_BitmapIndexedSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    return (($n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element, this.getPayload__I__O(index)));
  }
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    return $n(this.getNode__I__sci_SetNode(index$2)).contains__O__I__I__I__Z(element, originalHash, elementHash, ((5 + shift) | 0));
  }
  return false;
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if (Object.is(element0, element)) {
      return this;
    } else {
      var element0UnimprovedHash = this.getHash__I__I(index);
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      if (((originalHash === element0UnimprovedHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        return this;
      } else {
        var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        return this.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      }
    }
  }
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew$2 = $n(subNode).updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNode === subNodeNew$2)) {
      return this;
    } else {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew$2);
    }
  }
  return this.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode(bitpos, element, originalHash, elementHash);
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $x_1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(elementHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(1)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(1)])), ((this.sci_BitmapIndexedSetNode__f_size - 1) | 0), $m_sc_Hashing$().improve__I__I($n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(1))) : new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(0)]), new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(0)])), ((this.sci_BitmapIndexedSetNode__f_size - 1) | 0), $m_sc_Hashing$().improve__I__I($n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(0))));
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode(bitpos, elementHash);
      }
    } else {
      return this;
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = $n(subNode).removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this;
    } else {
      var x1 = $n(subNodeNew).size__I();
      return ((x1 === 1) ? ((this.sci_BitmapIndexedSetNode__f_size === $n(subNode).size__I()) ? $as_sci_BitmapIndexedSetNode(subNodeNew) : this.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, elementHash, subNode, subNodeNew)) : ((x1 > 1) ? this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew) : this));
    }
  } else {
    return this;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.removeWithShallowMutations__O__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, 0);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $x_1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var newDataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
        if ((index === 0)) {
          var newContent = new $ac_O([this.getPayload__I__O(1)]);
          var newOriginalHashes = new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(1)]));
          var newCachedJavaKeySetHashCode = $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1));
          this.sci_BitmapIndexedSetNode__f_content = newContent;
          this.sci_BitmapIndexedSetNode__f_originalHashes = newOriginalHashes;
          this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = newCachedJavaKeySetHashCode;
        } else {
          var newContent$2 = new $ac_O([this.getPayload__I__O(0)]);
          var newOriginalHashes$2 = new $ac_I(new Int32Array([$n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(0)]));
          var newCachedJavaKeySetHashCode$2 = $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0));
          this.sci_BitmapIndexedSetNode__f_content = newContent$2;
          this.sci_BitmapIndexedSetNode__f_originalHashes = newOriginalHashes$2;
          this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = newCachedJavaKeySetHashCode$2;
        }
        this.sci_BitmapIndexedSetNode__f_dataMap = newDataMap;
        this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
        this.sci_BitmapIndexedSetNode__f_size = 1;
        return this;
      } else {
        var dataIx = this.dataIndex__I__I(bitpos);
        var src = this.sci_BitmapIndexedSetNode__f_content;
        var dst = new $ac_O((($n(src).u.length - 1) | 0));
        $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
        var srcPos = ((1 + dataIx) | 0);
        var length = (((($n(src).u.length - dataIx) | 0) - 1) | 0);
        $systemArraycopyRefs($n(src), srcPos, dst, dataIx, length);
        var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
        this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
        this.sci_BitmapIndexedSetNode__f_content = dst;
        this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
        this.sci_BitmapIndexedSetNode__f_size = ((this.sci_BitmapIndexedSetNode__f_size - 1) | 0);
        this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0);
        return this;
      }
    } else {
      return this;
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = $as_sci_BitmapIndexedSetNode($n(subNode).removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, 5));
    if ((subNodeNew === subNode)) {
      return this;
    }
    if (($n(subNodeNew).sci_BitmapIndexedSetNode__f_size === 1)) {
      var i$2 = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i$2) === 0)) {
        var i$3 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $x_2 = ($m_jl_Integer$().bitCount__I__I(i$3) === 1);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        this.sci_BitmapIndexedSetNode__f_dataMap = $n(subNodeNew).sci_BitmapIndexedSetNode__f_dataMap;
        this.sci_BitmapIndexedSetNode__f_nodeMap = $n(subNodeNew).sci_BitmapIndexedSetNode__f_nodeMap;
        this.sci_BitmapIndexedSetNode__f_content = $n(subNodeNew).sci_BitmapIndexedSetNode__f_content;
        this.sci_BitmapIndexedSetNode__f_originalHashes = $n(subNodeNew).sci_BitmapIndexedSetNode__f_originalHashes;
        this.sci_BitmapIndexedSetNode__f_size = $n(subNodeNew).sci_BitmapIndexedSetNode__f_size;
        this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = $n(subNodeNew).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode;
        return this;
      } else {
        this.migrateFromNodeToInlineInPlace__I__I__I__sci_SetNode__sci_SetNode__V(bitpos, originalHash, elementHash, subNode, subNodeNew);
        return this;
      }
    } else {
      $n(this.sci_BitmapIndexedSetNode__f_content).set((((($n(this.sci_BitmapIndexedSetNode__f_content).u.length - 1) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew);
      this.sci_BitmapIndexedSetNode__f_size = ((this.sci_BitmapIndexedSetNode__f_size - 1) | 0);
      this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(subNode).cachedJavaKeySetHashCode__I()) | 0) + $n(subNodeNew).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) | 0);
      return this;
    }
  } else {
    return this;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode = (function(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [key0, key1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionSetNode(originalKeyHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems));
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      var newCachedHashCode = ((keyHash0 + keyHash1) | 0);
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key0, key1]), new $ac_I(new Int32Array([originalKeyHash0, originalKeyHash1])), 2, newCachedHashCode) : new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key1, key0]), new $ac_I(new Int32Array([originalKeyHash1, originalKeyHash0])), 2, newCachedHashCode));
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedSetNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, $n(node).size__I(), $n(node).cachedJavaKeySetHashCode__I());
    }
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_dataMap !== 0);
});
$c_sci_BitmapIndexedSetNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_nodeMap !== 0);
});
$c_sci_BitmapIndexedSetNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_dataMap & ((bitpos - 1) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_nodeMap & ((bitpos - 1) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, oldNode, newNode) {
  var idx = (((($n(this.sci_BitmapIndexedSetNode__f_content).u.length - 1) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  var length = $n(src).u.length;
  $systemArraycopyRefs($n(src), 0, dst, 0, length);
  dst.set(idx, newNode);
  return new $c_sci_BitmapIndexedSetNode(this.sci_BitmapIndexedSetNode__f_dataMap, this.sci_BitmapIndexedSetNode__f_nodeMap, dst, this.sci_BitmapIndexedSetNode__f_originalHashes, ((((this.sci_BitmapIndexedSetNode__f_size - $n(oldNode).size__I()) | 0) + $n(newNode).size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(newNode).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode = (function(bitpos, key, originalHash, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  dst.set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = (($n(src).u.length - dataIx) | 0);
  $systemArraycopyRefs($n(src), dataIx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode = (function(bitpos, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O((($n(src).u.length - 1) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = (((($n(src).u.length - dataIx) | 0) - 1) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, dataIx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, ((this.sci_BitmapIndexedSetNode__f_size - 1) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((($n(this.sci_BitmapIndexedSetNode__f_content).u.length - 1) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((idxNew - dataIx) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, dataIx, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((1 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((($n(src).u.length - idxNew) | 0) - 1) | 0);
  $systemArraycopyRefs($n(src), srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos), dst, dstHashes, ((((this.sci_BitmapIndexedSetNode__f_size - 1) | 0) + $n(node).size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((($n(this.sci_BitmapIndexedSetNode__f_content).u.length - 1) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var srcPos = ((1 + dataIx) | 0);
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var length = ((idxNew - dataIx) | 0);
  $systemArraycopyRefs($n(src), srcPos, $n(dest), dataIx, length);
  $n(this.sci_BitmapIndexedSetNode__f_content).set(idxNew, node);
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedSetNode__f_size = ((((this.sci_BitmapIndexedSetNode__f_size - 1) | 0) + $n(node).size__I()) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0);
  return this;
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, oldNode, node) {
  var idxOld = (((($n(this.sci_BitmapIndexedSetNode__f_content).u.length - 1) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O($n(src).u.length);
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIxNew);
  dst.set(dataIxNew, $n(node).getPayload__I__O(0));
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  $systemArraycopyRefs($n(src), dataIxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((1 + idxOld) | 0);
  var length$1 = (((($n(src).u.length - idxOld) | 0) - 1) | 0);
  $systemArraycopyRefs($n(src), srcPos, dst, destPos$1, length$1);
  var hash = $n(node).getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedSetNode__f_size - $n(oldNode).size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromNodeToInlineInPlace__I__I__I__sci_SetNode__sci_SetNode__V = (function(bitpos, originalHash, elementHash, oldNode, node) {
  var idxOld = (((($n(this.sci_BitmapIndexedSetNode__f_content).u.length - 1) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var element = $n(node).getPayload__I__O(0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  $systemArraycopyRefs($n(src), dataIxNew, $n(dest), destPos, length);
  $n(this.sci_BitmapIndexedSetNode__f_content).set(dataIxNew, element);
  var hash = $n(node).getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedSetNode__f_size = ((1 + ((this.sci_BitmapIndexedSetNode__f_size - $n(oldNode).size__I()) | 0)) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - $n(oldNode).cachedJavaKeySetHashCode__I()) | 0) + $n(node).cachedJavaKeySetHashCode__I()) | 0);
});
$c_sci_BitmapIndexedSetNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var thisPayloadArity = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < thisPayloadArity)) {
    $n(f).apply__O__O(this.getPayload__I__O(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var thisNodeArity = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < thisNodeArity)) {
    $n(this.getNode__I__sci_SetNode(j)).foreach__F1__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.subsetOf__sci_SetNode__I__Z = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else if ((!(that instanceof $c_sci_HashCollisionSetNode))) {
    if ((!(that instanceof $c_sci_BitmapIndexedSetNode))) {
      throw new $c_s_MatchError(that);
    }
    var x3 = $as_sci_BitmapIndexedSetNode(that);
    var thisBitmap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
    var nodeBitmap = ($n(x3).sci_BitmapIndexedSetNode__f_dataMap | $n(x3).sci_BitmapIndexedSetNode__f_nodeMap);
    if (((thisBitmap | nodeBitmap) !== nodeBitmap)) {
      return false;
    }
    var bitmap = (thisBitmap & nodeBitmap);
    var i = bitmap;
    var i$1 = ((~i) & ((i - 1) | 0));
    var bitsToSkip = ((32 - Math.clz32(i$1)) | 0);
    var isValidSubset = true;
    while ((isValidSubset && (bitsToSkip < 32))) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(bitsToSkip);
      if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
        if ((($n(x3).sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
          var payload0 = this.getPayload__I__O($m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos));
          var payload1 = $n(x3).getPayload__I__O($m_sci_Node$().indexFrom__I__I__I($n(x3).sci_BitmapIndexedSetNode__f_dataMap, bitpos));
          isValidSubset = $m_sr_BoxesRunTime$().equals__O__O__Z(payload0, payload1);
        } else {
          var thisDataIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos);
          var payload = this.getPayload__I__O(thisDataIndex);
          var subNode = $n(that).getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I($n(x3).sci_BitmapIndexedSetNode__f_nodeMap, bitpos));
          var elementUnimprovedHash = this.getHash__I__I(thisDataIndex);
          var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
          isValidSubset = $n(subNode).contains__O__I__I__I__Z(payload, elementUnimprovedHash, elementHash, ((5 + shift) | 0));
        }
      } else if ((($n(x3).sci_BitmapIndexedSetNode__f_dataMap & bitpos) === 0)) {
        var subNode0 = this.getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, bitpos));
        var subNode1 = $n(x3).getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I($n(x3).sci_BitmapIndexedSetNode__f_nodeMap, bitpos));
        isValidSubset = $n(subNode0).subsetOf__sci_SetNode__I__Z(subNode1, ((5 + shift) | 0));
      } else {
        isValidSubset = false;
      }
      var newBitmap = (bitmap ^ bitpos);
      bitmap = newBitmap;
      var i$2 = ((~newBitmap) & ((newBitmap - 1) | 0));
      bitsToSkip = ((32 - Math.clz32(i$2)) | 0);
    }
    return isValidSubset;
  } else {
    return false;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.filterImpl__F1__Z__sci_BitmapIndexedSetNode = (function(pred, flipped) {
  if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
    return this;
  } else if ((this.sci_BitmapIndexedSetNode__f_size === 1)) {
    if (($uZ($n(pred).apply__O__O(this.getPayload__I__O(0))) !== flipped)) {
      return this;
    } else {
      var this$1 = $m_sci_SetNode$();
      return this$1.sci_SetNode$__f_EmptySetNode;
    }
  } else if ((this.sci_BitmapIndexedSetNode__f_nodeMap === 0)) {
    var i = this.sci_BitmapIndexedSetNode__f_dataMap;
    var i$1 = ((~i) & ((i - 1) | 0));
    var minimumIndex = ((32 - Math.clz32(i$1)) | 0);
    var i$2 = this.sci_BitmapIndexedSetNode__f_dataMap;
    var maximumIndex = ((32 - Math.clz32(i$2)) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i$3);
      if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        var payload = this.getPayload__I__O(dataIndex);
        var passed = ($uZ($n(pred).apply__O__O(payload)) !== flipped);
        if (passed) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      var this$4 = $m_sci_SetNode$();
      return this$4.sci_SetNode$__f_EmptySetNode;
    } else if ((newDataMap === this.sci_BitmapIndexedSetNode__f_dataMap)) {
      return this;
    } else {
      var i$4 = newDataMap;
      var newSize = $m_jl_Integer$().bitCount__I__I(i$4);
      var newContent = new $ac_O(newSize);
      var newOriginalHashCodes = new $ac_I(newSize);
      var i$5 = newDataMap;
      var newMaximumIndex = ((32 - Math.clz32(i$5)) | 0);
      var i$6 = newDataMap;
      var i$7 = ((~i$6) & ((i$6 - 1) | 0));
      var j = ((32 - Math.clz32(i$7)) | 0);
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().bitposFrom__I__I(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos$2);
          newContent.set(newDataIndex, $n(this.sci_BitmapIndexedSetNode__f_content).get(oldIndex));
          newOriginalHashCodes.set(newDataIndex, $n(this.sci_BitmapIndexedSetNode__f_originalHashes).get(oldIndex));
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
    var i$8 = ((~allMap) & ((allMap - 1) | 0));
    var minimumIndex$2 = ((32 - Math.clz32(i$8)) | 0);
    var maximumIndex$2 = ((32 - Math.clz32(allMap)) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().bitposFrom__I__I(i$2$1);
      if (((bitpos$3 & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        var payload$2 = this.getPayload__I__O(dataIndex$2);
        var passed$2 = ($uZ($n(pred).apply__O__O(payload$2)) !== flipped);
        if (passed$2) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        var oldSubNode = this.getNode__I__sci_SetNode(nodeIndex);
        var newSubNode = $n(oldSubNode).filterImpl__F1__Z__sci_SetNode(pred, flipped);
        newSize$2 = ((newSize$2 + $n(newSubNode).size__I()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + $n(newSubNode).cachedJavaKeySetHashCode__I()) | 0);
        if (($n(newSubNode).size__I() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = new $c_scm_Queue(16);
            }
            var this$10 = $n(newNodes);
            this$10.addOne__O__scm_ArrayDeque(newSubNode);
          }
        } else if (($n(newSubNode).size__I() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            nodesToMigrateToData = new $c_scm_Queue(16);
          }
          var this$12 = $n(nodesToMigrateToData);
          this$12.addOne__O__scm_ArrayDeque(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize$2, newDataMap$2, newNodeMap, minimumIndex$2, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode$2);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.diff__sci_SetNode__I__sci_BitmapIndexedSetNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
      return this;
    } else if ((this.sci_BitmapIndexedSetNode__f_size === 1)) {
      var h = this.getHash__I__I(0);
      if ($n(that).contains__O__I__I__I__Z(this.getPayload__I__O(0), h, $m_sc_Hashing$().improve__I__I(h), shift)) {
        var this$1 = $m_sci_SetNode$();
        return this$1.sci_SetNode$__f_EmptySetNode;
      } else {
        return this;
      }
    } else {
      var allMap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
      var i = ((~allMap) & ((allMap - 1) | 0));
      var minimumIndex = ((32 - Math.clz32(i)) | 0);
      var maximumIndex = ((32 - Math.clz32(allMap)) | 0);
      var oldDataPassThrough = 0;
      var nodeMigrateToDataTargetMap = 0;
      var nodesToMigrateToData = null;
      var nodesToPassThroughMap = 0;
      var mapOfNewNodes = 0;
      var newNodes = null;
      var newDataMap = 0;
      var newNodeMap = 0;
      var newSize = 0;
      var newCachedHashCode = 0;
      var dataIndex = 0;
      var nodeIndex = 0;
      var i$1 = minimumIndex;
      while ((i$1 < maximumIndex)) {
        var bitpos = $m_sci_Node$().bitposFrom__I__I(i$1);
        if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          var payload = this.getPayload__I__O(dataIndex);
          var originalHash = this.getHash__I__I(dataIndex);
          var hash = $m_sc_Hashing$().improve__I__I(originalHash);
          if ((!$n(x2).contains__O__I__I__I__Z(payload, originalHash, hash, shift))) {
            newDataMap = (newDataMap | bitpos);
            oldDataPassThrough = (oldDataPassThrough | bitpos);
            newSize = ((1 + newSize) | 0);
            newCachedHashCode = ((newCachedHashCode + hash) | 0);
          }
          dataIndex = ((1 + dataIndex) | 0);
        } else if (((bitpos & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          var oldSubNode = this.getNode__I__sci_SetNode(nodeIndex);
          if (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
            var thatDataIndex = $m_sci_Node$().indexFrom__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_dataMap, bitpos);
            var thatPayload = $n(x2).getPayload__I__O(thatDataIndex);
            var thatOriginalHash = $n(x2).getHash__I__I(thatDataIndex);
            var thatHash = $m_sc_Hashing$().improve__I__I(thatOriginalHash);
            var newSubNode = $n(oldSubNode).removed__O__I__I__I__sci_SetNode(thatPayload, thatOriginalHash, thatHash, ((5 + shift) | 0));
          } else {
            var newSubNode = (((bitpos & $n(x2).sci_BitmapIndexedSetNode__f_nodeMap) !== 0) ? $n(oldSubNode).diff__sci_SetNode__I__sci_SetNode($n(x2).getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_nodeMap, bitpos)), ((5 + shift) | 0)) : oldSubNode);
          }
          newSize = ((newSize + $n(newSubNode).size__I()) | 0);
          newCachedHashCode = ((newCachedHashCode + $n(newSubNode).cachedJavaKeySetHashCode__I()) | 0);
          if (($n(newSubNode).size__I() > 1)) {
            newNodeMap = (newNodeMap | bitpos);
            if ((oldSubNode === newSubNode)) {
              nodesToPassThroughMap = (nodesToPassThroughMap | bitpos);
            } else {
              mapOfNewNodes = (mapOfNewNodes | bitpos);
              if ((newNodes === null)) {
                newNodes = new $c_scm_Queue(16);
              }
              var this$5 = $n(newNodes);
              this$5.addOne__O__scm_ArrayDeque(newSubNode);
            }
          } else if (($n(newSubNode).size__I() === 1)) {
            newDataMap = (newDataMap | bitpos);
            nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos);
            if ((nodesToMigrateToData === null)) {
              nodesToMigrateToData = new $c_scm_Queue(16);
            }
            var this$7 = $n(nodesToMigrateToData);
            this$7.addOne__O__scm_ArrayDeque(newSubNode);
          }
          nodeIndex = ((1 + nodeIndex) | 0);
        }
        i$1 = ((1 + i$1) | 0);
      }
      return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode);
    }
  } else if ((that instanceof $c_sci_HashCollisionSetNode)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "BitmapIndexedSetNode diff HashCollisionSetNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this === x2)) {
      return true;
    } else {
      if (((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode === $n(x2).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedSetNode__f_nodeMap === $n(x2).sci_BitmapIndexedSetNode__f_nodeMap)) && (this.sci_BitmapIndexedSetNode__f_dataMap === $n(x2).sci_BitmapIndexedSetNode__f_dataMap)) && (this.sci_BitmapIndexedSetNode__f_size === $n(x2).sci_BitmapIndexedSetNode__f_size))) {
        var a = this.sci_BitmapIndexedSetNode__f_originalHashes;
        var b = $n(x2).sci_BitmapIndexedSetNode__f_originalHashes;
        var $x_1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var a1 = this.sci_BitmapIndexedSetNode__f_content;
        var a2 = $n(x2).sci_BitmapIndexedSetNode__f_content;
        var length = $n(this.sci_BitmapIndexedSetNode__f_content).u.length;
        if ((a1 === a2)) {
          return true;
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z($n(a1).get(i), $n(a2).get(i));
            i = ((1 + i) | 0);
          }
          return isEqual;
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_BitmapIndexedSetNode.prototype.toString__T = (function() {
  var $x_1 = $m_sc_StringOps$();
  var x0 = this.sci_BitmapIndexedSetNode__f_size;
  var x1 = this.sci_BitmapIndexedSetNode__f_dataMap;
  var x2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var array = [x0, x1, x2];
  return $x_1.format$extension__T__sci_Seq__T("BitmapIndexedSetNode(size=%s, dataMap=%x, nodeMap=%x)", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_BitmapIndexedSetNode = (function() {
  var this$1 = $n(this.sci_BitmapIndexedSetNode__f_content);
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var i$1 = $m_jl_Integer$().bitCount__I__I(i);
  while ((i$1 < contentLength)) {
    contentClone.set(i$1, $n($as_sci_SetNode(contentClone.get(i$1))).copy__sci_SetNode());
    i$1 = ((1 + i$1) | 0);
  }
  var $x_2 = this.sci_BitmapIndexedSetNode__f_dataMap;
  var $x_1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var this$2 = $n(this.sci_BitmapIndexedSetNode__f_originalHashes);
  return new $c_sci_BitmapIndexedSetNode($x_2, $x_1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedSetNode__f_size, this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode);
});
$c_sci_BitmapIndexedSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    $n(f).apply__O__O__O(this.getPayload__I__O(i$1), this.getHash__I__I(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    $n(this.getNode__I__sci_SetNode(j)).foreachWithHash__F2__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_SetNode = (function() {
  return this.copy__sci_BitmapIndexedSetNode();
});
$c_sci_BitmapIndexedSetNode.prototype.diff__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.diff__sci_SetNode__I__sci_BitmapIndexedSetNode(that, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.filterImpl__F1__Z__sci_SetNode = (function(pred, flipped) {
  return this.filterImpl__F1__Z__sci_BitmapIndexedSetNode(pred, flipped);
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index);
});
function $as_sci_BitmapIndexedSetNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedSetNode"));
}
function $isArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedSetNode)));
}
function $asArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedSetNode;", depth));
}
var $d_sci_BitmapIndexedSetNode = new $TypeData().initClass($c_sci_BitmapIndexedSetNode, "scala.collection.immutable.BitmapIndexedSetNode", ({
  sci_BitmapIndexedSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1
}));
/** @constructor */
function $c_sci_HashCollisionMapNode(originalHash, hash, content) {
  this.sci_HashCollisionMapNode__f_originalHash = 0;
  this.sci_HashCollisionMapNode__f_hash = 0;
  this.sci_HashCollisionMapNode__f_content = null;
  this.sci_HashCollisionMapNode__f_originalHash = originalHash;
  this.sci_HashCollisionMapNode__f_hash = hash;
  this.sci_HashCollisionMapNode__f_content = content;
  $m_s_Predef$().require__Z__V(($n(this.sci_HashCollisionMapNode__f_content).length__I() >= 2));
}
$c_sci_HashCollisionMapNode.prototype = new $h_sci_MapNode();
$c_sci_HashCollisionMapNode.prototype.constructor = $c_sci_HashCollisionMapNode;
/** @constructor */
function $h_sci_HashCollisionMapNode() {
}
$h_sci_HashCollisionMapNode.prototype = $c_sci_HashCollisionMapNode.prototype;
$c_sci_HashCollisionMapNode.prototype.indexOf__O__I = (function(key) {
  var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
  var i = 0;
  while ($n(iter).hasNext__Z()) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n($as_T2($n(iter).next__O()))._1__O(), key)) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
});
$c_sci_HashCollisionMapNode.prototype.size__I = (function() {
  return $n(this.sci_HashCollisionMapNode__f_content).length__I();
});
$c_sci_HashCollisionMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, hash, shift) {
  var this$1 = $n(this.get__O__I__I__I__s_Option(key, originalHash, hash, shift));
  if (this$1.isEmpty__Z()) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
    throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException());
  } else {
    return this$1.get__O();
  }
});
$c_sci_HashCollisionMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, hash, shift) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var index = this.indexOf__O__I(key);
    return ((index >= 0) ? new $c_s_Some($n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O()) : $m_s_None$());
  } else {
    return $m_s_None$();
  }
});
$c_sci_HashCollisionMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, hash, shift, f) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var x1 = this.indexOf__O__I(key);
    return ((x1 === (-1)) ? $n(f).apply__O() : $n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(x1)))._2__O());
  } else {
    return $n(f).apply__O();
  }
});
$c_sci_HashCollisionMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, hash, shift) {
  return ((this.sci_HashCollisionMapNode__f_hash === hash) && (this.indexOf__O__I(key) >= 0));
});
$c_sci_HashCollisionMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  var index = this.indexOf__O__I(key);
  return ((index >= 0) ? (replaceValue ? (Object.is($n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O(), value) ? this : new $c_sci_HashCollisionMapNode(originalHash, hash, $n(this.sci_HashCollisionMapNode__f_content).updated__I__O__sci_Vector(index, new $c_T2(key, value)))) : this) : new $c_sci_HashCollisionMapNode(originalHash, hash, $n(this.sci_HashCollisionMapNode__f_content).appended__O__sci_Vector(new $c_T2(key, value))));
});
$c_sci_HashCollisionMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  if ((!this.containsKey__O__I__I__I__Z(key, originalHash, hash, shift))) {
    return this;
  } else {
    var this$1 = $n(this.sci_HashCollisionMapNode__f_content);
    var pred = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((keyValuePair$2$2) => {
      var keyValuePair$2 = $as_T2(keyValuePair$2$2);
      return $m_sr_BoxesRunTime$().equals__O__O__Z($n(keyValuePair$2)._1__O(), key);
    }));
    var updatedContent = this$1.filterImpl__F1__Z__sci_Vector(pred, true);
    var this$2 = $n(updatedContent);
    var x1 = this$2.length__I();
    if ((x1 === 1)) {
      var x1$2 = $as_T2($n(updatedContent).apply__I__O(0));
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2);
      }
      var k = $n(x1$2)._1__O();
      var v = $n(x1$2)._2__O();
      return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([originalHash])), 1, hash);
    } else {
      return new $c_sci_HashCollisionMapNode(originalHash, hash, updatedContent);
    }
  }
});
$c_sci_HashCollisionMapNode.prototype.hasNodes__Z = (function() {
  return false;
});
$c_sci_HashCollisionMapNode.prototype.nodeArity__I = (function() {
  return 0;
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$c_sci_HashCollisionMapNode.prototype.hasPayload__Z = (function() {
  return true;
});
$c_sci_HashCollisionMapNode.prototype.payloadArity__I = (function() {
  return $n(this.sci_HashCollisionMapNode__f_content).length__I();
});
$c_sci_HashCollisionMapNode.prototype.getKey__I__O = (function(index) {
  return $n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._1__O();
});
$c_sci_HashCollisionMapNode.prototype.getValue__I__O = (function(index) {
  return $n($as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O();
});
$c_sci_HashCollisionMapNode.prototype.getPayload__I__T2 = (function(index) {
  return $as_T2($n(this.sci_HashCollisionMapNode__f_content).apply__I__O(index));
});
$c_sci_HashCollisionMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionMapNode__f_originalHash;
});
$c_sci_HashCollisionMapNode.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_HashCollisionMapNode__f_content).foreach__F1__V(f);
});
$c_sci_HashCollisionMapNode.prototype.foreachEntry__F2__V = (function(f) {
  $n(this.sci_HashCollisionMapNode__f_content).foreach__F1__V(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
    var x0$1$2 = $as_T2(x0$1$2$2);
    if ((x0$1$2 !== null)) {
      var k = $n(x0$1$2)._1__O();
      var v = $n(x0$1$2)._2__O();
      return $n(f).apply__O__O__O(k, v);
    } else {
      throw new $c_s_MatchError(x0$1$2);
    }
  })));
});
$c_sci_HashCollisionMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var next = $as_T2($n(iter).next__O());
    $n(f).apply__O__O__O__O($n(next)._1__O(), $n(next)._2__O(), this.sci_HashCollisionMapNode__f_originalHash);
  }
});
$c_sci_HashCollisionMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((this === x2)) {
      return true;
    } else if (((this.sci_HashCollisionMapNode__f_hash === $n(x2).sci_HashCollisionMapNode__f_hash) && ($n(this.sci_HashCollisionMapNode__f_content).length__I() === $n($n(x2).sci_HashCollisionMapNode__f_content).length__I()))) {
      var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        var x1$2 = $as_T2($n(iter).next__O());
        if ((x1$2 === null)) {
          throw new $c_s_MatchError(x1$2);
        }
        var key = $n(x1$2)._1__O();
        var value = $n(x1$2)._2__O();
        var index = $n(x2).indexOf__O__I(key);
        if (((index < 0) || (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, $n($as_T2($n($n(x2).sci_HashCollisionMapNode__f_content).apply__I__O(index)))._2__O())))) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_HashCollisionMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((x2 === this)) {
      return this;
    } else {
      var newContent = null;
      var iter = $n(this.sci_HashCollisionMapNode__f_content).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        var nextPayload = $as_T2($n(iter).next__O());
        if (($n(x2).indexOf__O__I($n(nextPayload)._1__O()) < 0)) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            $n(newContent).addAll__sc_IterableOnce__sci_VectorBuilder($n(x2).sci_HashCollisionMapNode__f_content);
          }
          $n(newContent).addOne__O__sci_VectorBuilder(nextPayload);
        }
      }
      return ((newContent === null) ? x2 : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, $n(newContent).result__sci_Vector()));
    }
  } else if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$c_sci_HashCollisionMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, flipped) {
  var newContent = $n(this.sci_HashCollisionMapNode__f_content).filterImpl__F1__Z__sci_Vector(pred, flipped);
  var newContentLength = $n(newContent).length__I();
  if ((newContentLength === 0)) {
    var this$1 = $m_sci_MapNode$();
    return this$1.sci_MapNode$__f_EmptyMapNode;
  } else if ((newContentLength === 1)) {
    var x1 = $as_T2($n(newContent).head__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $n(x1)._2__O();
    return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(this.sci_HashCollisionMapNode__f_hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([this.sci_HashCollisionMapNode__f_originalHash])), 1, this.sci_HashCollisionMapNode__f_hash);
  } else {
    return ((newContentLength === $n(this.sci_HashCollisionMapNode__f_content).length__I()) ? this : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, newContent));
  }
});
$c_sci_HashCollisionMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_HashCollisionMapNode.prototype.toString__T = (function() {
  var i = $systemIdentityHashCode(this);
  return (($objectClassName(this) + "@") + $as_T((i >>> 0.0).toString(16)));
});
$c_sci_HashCollisionMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul($n(this.sci_HashCollisionMapNode__f_content).length__I(), this.sci_HashCollisionMapNode__f_hash);
});
$c_sci_HashCollisionMapNode.prototype.copy__sci_MapNode = (function() {
  return new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, this.sci_HashCollisionMapNode__f_content);
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_HashCollisionMapNode(that, shift);
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index);
});
function $as_sci_HashCollisionMapNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionMapNode"));
}
function $isArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionMapNode)));
}
function $asArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionMapNode;", depth));
}
var $d_sci_HashCollisionMapNode = new $TypeData().initClass($c_sci_HashCollisionMapNode, "scala.collection.immutable.HashCollisionMapNode", ({
  sci_HashCollisionMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1
}));
/** @constructor */
function $c_sci_HashCollisionSetNode(originalHash, hash, content) {
  this.sci_HashCollisionSetNode__f_originalHash = 0;
  this.sci_HashCollisionSetNode__f_hash = 0;
  this.sci_HashCollisionSetNode__f_content = null;
  this.sci_HashCollisionSetNode__f_originalHash = originalHash;
  this.sci_HashCollisionSetNode__f_hash = hash;
  this.sci_HashCollisionSetNode__f_content = content;
  $m_s_Predef$().require__Z__V(($n(this.sci_HashCollisionSetNode__f_content).length__I() >= 2));
}
$c_sci_HashCollisionSetNode.prototype = new $h_sci_SetNode();
$c_sci_HashCollisionSetNode.prototype.constructor = $c_sci_HashCollisionSetNode;
/** @constructor */
function $h_sci_HashCollisionSetNode() {
}
$h_sci_HashCollisionSetNode.prototype = $c_sci_HashCollisionSetNode.prototype;
$c_sci_HashCollisionSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, hash, shift) {
  if ((this.sci_HashCollisionSetNode__f_hash === hash)) {
    var this$1 = $n(this.sci_HashCollisionSetNode__f_content);
    return $f_sc_SeqOps__contains__O__Z(this$1, element);
  } else {
    return false;
  }
});
$c_sci_HashCollisionSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return (this.contains__O__I__I__I__Z(element, originalHash, hash, shift) ? this : new $c_sci_HashCollisionSetNode(originalHash, hash, $n(this.sci_HashCollisionSetNode__f_content).appended__O__sci_Vector(element)));
});
$c_sci_HashCollisionSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  if ((!this.contains__O__I__I__I__Z(element, originalHash, hash, shift))) {
    return this;
  } else {
    var this$1 = $n(this.sci_HashCollisionSetNode__f_content);
    var pred = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((element0$2$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(element0$2$2, element)));
    var updatedContent = this$1.filterImpl__F1__Z__sci_Vector(pred, true);
    var this$2 = $n(updatedContent);
    var x1 = this$2.length__I();
    return ((x1 === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([$n(updatedContent).apply__I__O(0)]), new $ac_I(new Int32Array([originalHash])), 1, hash) : new $c_sci_HashCollisionSetNode(originalHash, hash, updatedContent));
  }
});
$c_sci_HashCollisionSetNode.prototype.hasNodes__Z = (function() {
  return false;
});
$c_sci_HashCollisionSetNode.prototype.nodeArity__I = (function() {
  return 0;
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$c_sci_HashCollisionSetNode.prototype.hasPayload__Z = (function() {
  return true;
});
$c_sci_HashCollisionSetNode.prototype.payloadArity__I = (function() {
  return $n(this.sci_HashCollisionSetNode__f_content).length__I();
});
$c_sci_HashCollisionSetNode.prototype.getPayload__I__O = (function(index) {
  return $n(this.sci_HashCollisionSetNode__f_content).apply__I__O(index);
});
$c_sci_HashCollisionSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionSetNode__f_originalHash;
});
$c_sci_HashCollisionSetNode.prototype.size__I = (function() {
  return $n(this.sci_HashCollisionSetNode__f_content).length__I();
});
$c_sci_HashCollisionSetNode.prototype.foreach__F1__V = (function(f) {
  var iter = $n(this.sci_HashCollisionSetNode__f_content).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    $n(f).apply__O__O($n(iter).next__O());
  }
});
$c_sci_HashCollisionSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul($n(this.sci_HashCollisionSetNode__f_content).length__I(), this.sci_HashCollisionSetNode__f_hash);
});
$c_sci_HashCollisionSetNode.prototype.subsetOf__sci_SetNode__I__Z = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    var $x_1 = $n(this.sci_HashCollisionSetNode__f_content).length__I();
    var this$1 = $n(x2);
    if (($x_1 <= $n(this$1.sci_HashCollisionSetNode__f_content).length__I())) {
      var this$2 = $n(this.sci_HashCollisionSetNode__f_content);
      var eta$0$1 = $n(x2).sci_HashCollisionSetNode__f_content;
      var res = true;
      var it = this$2.iterator__sc_Iterator();
      while ((res && $n(it).hasNext__Z())) {
        var x0 = $n(it).next__O();
        var this$3 = $n(eta$0$1);
        res = $f_sc_SeqOps__contains__O__Z(this$3, x0);
      }
      return res;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_sci_HashCollisionSetNode.prototype.filterImpl__F1__Z__sci_SetNode = (function(pred, flipped) {
  var newContent = $n(this.sci_HashCollisionSetNode__f_content).filterImpl__F1__Z__sci_Vector(pred, flipped);
  var newContentLength = $n(newContent).length__I();
  if ((newContentLength === 0)) {
    var this$1 = $m_sci_SetNode$();
    return this$1.sci_SetNode$__f_EmptySetNode;
  } else {
    return ((newContentLength === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(this.sci_HashCollisionSetNode__f_hash, 0)), 0, new $ac_O([$n(newContent).head__O()]), new $ac_I(new Int32Array([this.sci_HashCollisionSetNode__f_originalHash])), 1, this.sci_HashCollisionSetNode__f_hash) : (($n(newContent).length__I() === $n(this.sci_HashCollisionSetNode__f_content).length__I()) ? this : new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, newContent)));
  }
});
$c_sci_HashCollisionSetNode.prototype.diff__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.filterImpl__F1__Z__sci_SetNode(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $n(that).contains__O__I__I__I__Z(x$1$2$2, this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, shift))), true);
});
$c_sci_HashCollisionSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((this === x2)) {
      return true;
    } else {
      if ((this.sci_HashCollisionSetNode__f_hash === $n(x2).sci_HashCollisionSetNode__f_hash)) {
        var this$1 = $n(this.sci_HashCollisionSetNode__f_content);
        var $x_2 = this$1.length__I();
        var this$2 = $n($n(x2).sci_HashCollisionSetNode__f_content);
        var $x_1 = ($x_2 === this$2.length__I());
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var this$3 = $n(this.sci_HashCollisionSetNode__f_content);
        var eta$0$1 = $n(x2).sci_HashCollisionSetNode__f_content;
        var res = true;
        var it = this$3.iterator__sc_Iterator();
        while ((res && $n(it).hasNext__Z())) {
          var x0 = $n(it).next__O();
          var this$4 = $n(eta$0$1);
          res = $f_sc_SeqOps__contains__O__Z(this$4, x0);
        }
        return res;
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_sci_HashCollisionSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_HashCollisionSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var iter = $n(this.sci_HashCollisionSetNode__f_content).iterator__sc_Iterator();
  while ($n(iter).hasNext__Z()) {
    var next = $n(iter).next__O();
    $n(f).apply__O__O__O(next, this.sci_HashCollisionSetNode__f_originalHash);
  }
});
$c_sci_HashCollisionSetNode.prototype.copy__sci_SetNode = (function() {
  return new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, this.sci_HashCollisionSetNode__f_content);
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index);
});
function $as_sci_HashCollisionSetNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionSetNode"));
}
function $isArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionSetNode)));
}
function $asArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionSetNode;", depth));
}
var $d_sci_HashCollisionSetNode = new $TypeData().initClass($c_sci_HashCollisionSetNode, "scala.collection.immutable.HashCollisionSetNode", ({
  sci_HashCollisionSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1
}));
/** @constructor */
function $c_sci_HashMap$() {
  this.sci_HashMap$__f_EmptyMap = null;
  $n_sci_HashMap$ = this;
  var this$1 = $m_sci_MapNode$();
  this.sci_HashMap$__f_EmptyMap = new $c_sci_HashMap(this$1.sci_MapNode$__f_EmptyMapNode);
}
$c_sci_HashMap$.prototype = new $h_O();
$c_sci_HashMap$.prototype.constructor = $c_sci_HashMap$;
/** @constructor */
function $h_sci_HashMap$() {
}
$h_sci_HashMap$.prototype = $c_sci_HashMap$.prototype;
$c_sci_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_HashMap(elems);
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__sci_HashMap = (function(source) {
  if ((source instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(source);
    return x2;
  } else {
    var this$1 = new $c_sci_HashMapBuilder();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_HashMapBuilder(source));
    return this$2.result__sci_HashMap();
  }
});
$c_sci_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashMapBuilder();
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_HashMap(it);
});
$c_sci_HashMap$.prototype.empty__O = (function() {
  return this.sci_HashMap$__f_EmptyMap;
});
var $d_sci_HashMap$ = new $TypeData().initClass($c_sci_HashMap$, "scala.collection.immutable.HashMap$", ({
  sci_HashMap$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_HashMap$;
function $m_sci_HashMap$() {
  if ((!$n_sci_HashMap$)) {
    $n_sci_HashMap$ = new $c_sci_HashMap$();
  }
  return $n_sci_HashMap$;
}
/** @constructor */
function $c_sci_HashSet$() {
  this.sci_HashSet$__f_EmptySet = null;
  $n_sci_HashSet$ = this;
  var this$1 = $m_sci_SetNode$();
  this.sci_HashSet$__f_EmptySet = new $c_sci_HashSet(this$1.sci_SetNode$__f_EmptySetNode);
}
$c_sci_HashSet$.prototype = new $h_O();
$c_sci_HashSet$.prototype.constructor = $c_sci_HashSet$;
/** @constructor */
function $h_sci_HashSet$() {
}
$h_sci_HashSet$.prototype = $c_sci_HashSet$.prototype;
$c_sci_HashSet$.prototype.from__sc_IterableOnce__sci_HashSet = (function(source) {
  if ((source instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(source);
    return x2;
  } else if (($n(source).knownSize__I() === 0)) {
    return this.sci_HashSet$__f_EmptySet;
  } else {
    var this$1 = new $c_sci_HashSetBuilder();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_HashSetBuilder(source));
    return this$2.result__sci_HashSet();
  }
});
$c_sci_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashSetBuilder();
});
$c_sci_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_HashSet(source);
});
$c_sci_HashSet$.prototype.empty__O = (function() {
  return this.sci_HashSet$__f_EmptySet;
});
var $d_sci_HashSet$ = new $TypeData().initClass($c_sci_HashSet$, "scala.collection.immutable.HashSet$", ({
  sci_HashSet$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_HashSet$;
function $m_sci_HashSet$() {
  if ((!$n_sci_HashSet$)) {
    $n_sci_HashSet$ = new $c_sci_HashSet$();
  }
  return $n_sci_HashSet$;
}
/** @constructor */
function $c_sci_Map$() {
}
$c_sci_Map$.prototype = new $h_O();
$c_sci_Map$.prototype.constructor = $c_sci_Map$;
/** @constructor */
function $h_sci_Map$() {
}
$h_sci_Map$.prototype = $c_sci_Map$.prototype;
$c_sci_Map$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Map(elems);
});
$c_sci_Map$.prototype.from__sc_IterableOnce__sci_Map = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    if ($n(x2).isEmpty__Z()) {
      return $m_sci_Map$EmptyMap$();
    }
  }
  if ((it instanceof $c_sci_HashMap)) {
    var x3 = $as_sci_HashMap(it);
    return x3;
  }
  if ((it instanceof $c_sci_Map$Map1)) {
    var x4 = $as_sci_Map$Map1(it);
    return x4;
  }
  if ((it instanceof $c_sci_Map$Map2)) {
    var x5 = $as_sci_Map$Map2(it);
    return x5;
  }
  if ((it instanceof $c_sci_Map$Map3)) {
    var x6 = $as_sci_Map$Map3(it);
    return x6;
  }
  if ((it instanceof $c_sci_Map$Map4)) {
    var x7 = $as_sci_Map$Map4(it);
    return x7;
  }
  if (false) {
    var x8 = $as_sci_ListMap(it);
    return x8;
  }
  if (false) {
    var x9 = $as_sci_TreeSeqMap(it);
    return x9;
  }
  if (false) {
    var x10 = $as_sci_VectorMap(it);
    return x10;
  }
  if (false) {
    var x11 = $as_sci_SeqMap$SeqMap1(it);
    return x11;
  }
  if (false) {
    var x12 = $as_sci_SeqMap$SeqMap2(it);
    return x12;
  }
  if (false) {
    var x13 = $as_sci_SeqMap$SeqMap3(it);
    return x13;
  }
  if (false) {
    var x14 = $as_sci_SeqMap$SeqMap4(it);
    return x14;
  }
  var this$1 = new $c_sci_MapBuilderImpl();
  var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_MapBuilderImpl(it));
  return this$2.result__sci_Map();
});
$c_sci_Map$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_MapBuilderImpl();
});
$c_sci_Map$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Map(it);
});
$c_sci_Map$.prototype.empty__O = (function() {
  return $m_sci_Map$EmptyMap$();
});
var $d_sci_Map$ = new $TypeData().initClass($c_sci_Map$, "scala.collection.immutable.Map$", ({
  sci_Map$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Map$;
function $m_sci_Map$() {
  if ((!$n_sci_Map$)) {
    $n_sci_Map$ = new $c_sci_Map$();
  }
  return $n_sci_Map$;
}
/** @constructor */
function $c_sci_Set$() {
}
$c_sci_Set$.prototype = new $h_O();
$c_sci_Set$.prototype.constructor = $c_sci_Set$;
/** @constructor */
function $h_sci_Set$() {
}
$h_sci_Set$.prototype = $c_sci_Set$.prototype;
$c_sci_Set$.prototype.from__sc_IterableOnce__sci_Set = (function(it) {
  if (($n(it).knownSize__I() === 0)) {
    return $m_sci_Set$EmptySet$();
  } else if ((it instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(it);
    return x2;
  } else if (false) {
    var x3 = $as_sci_ListSet(it);
    return x3;
  } else if ((it instanceof $c_sci_Set$Set1)) {
    var x4 = $as_sci_Set$Set1(it);
    return x4;
  } else if ((it instanceof $c_sci_Set$Set2)) {
    var x5 = $as_sci_Set$Set2(it);
    return x5;
  } else if ((it instanceof $c_sci_Set$Set3)) {
    var x6 = $as_sci_Set$Set3(it);
    return x6;
  } else if ((it instanceof $c_sci_Set$Set4)) {
    var x7 = $as_sci_Set$Set4(it);
    return x7;
  } else if ((it instanceof $c_sci_HashMap$HashKeySet)) {
    var x8 = $as_sci_HashMap$HashKeySet(it);
    return x8;
  } else if ((it instanceof $c_sci_MapOps$ImmutableKeySet)) {
    var x9 = $as_sci_MapOps$ImmutableKeySet(it);
    return x9;
  } else {
    var this$1 = new $c_sci_SetBuilderImpl();
    var this$2 = $n(this$1.addAll__sc_IterableOnce__sci_SetBuilderImpl(it));
    return this$2.result__sci_Set();
  }
});
$c_sci_Set$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_SetBuilderImpl();
});
$c_sci_Set$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Set(source);
});
$c_sci_Set$.prototype.empty__O = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_sci_Set$ = new $TypeData().initClass($c_sci_Set$, "scala.collection.immutable.Set$", ({
  sci_Set$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Set$;
function $m_sci_Set$() {
  if ((!$n_sci_Set$)) {
    $n_sci_Set$ = new $c_sci_Set$();
  }
  return $n_sci_Set$;
}
function $f_scm_Builder__sizeHint__sc_IterableOnce__I__V($thiz, coll, delta) {
  var x1 = $n(coll).knownSize__I();
  if ((x1 !== (-1))) {
    var that = ((x1 + delta) | 0);
    $thiz.sizeHint__I__V(((that < 0) ? 0 : that));
  }
}
function $is_scm_Builder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Builder)));
}
function $as_scm_Builder(obj) {
  return (($is_scm_Builder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Builder"));
}
function $isArrayOf_scm_Builder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Builder)));
}
function $asArrayOf_scm_Builder(obj, depth) {
  return (($isArrayOf_scm_Builder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Builder;", depth));
}
/** @constructor */
function $c_scm_HashMap$() {
}
$c_scm_HashMap$.prototype = new $h_O();
$c_scm_HashMap$.prototype.constructor = $c_scm_HashMap$;
/** @constructor */
function $h_scm_HashMap$() {
}
$h_scm_HashMap$.prototype = $c_scm_HashMap$.prototype;
$c_scm_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_HashMap(elems);
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__scm_HashMap = (function(it) {
  var k = $n(it).knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  return $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), cap, 0.75).addAll__sc_IterableOnce__scm_HashMap(it);
});
$c_scm_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashMap$$anon$6(16, 0.75);
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__scm_HashMap(it);
});
$c_scm_HashMap$.prototype.empty__O = (function() {
  return $ct_scm_HashMap__(new $c_scm_HashMap());
});
var $d_scm_HashMap$ = new $TypeData().initClass($c_scm_HashMap$, "scala.collection.mutable.HashMap$", ({
  scm_HashMap$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_HashMap$;
function $m_scm_HashMap$() {
  if ((!$n_scm_HashMap$)) {
    $n_scm_HashMap$ = new $c_scm_HashMap$();
  }
  return $n_scm_HashMap$;
}
/** @constructor */
function $c_scm_HashSet$() {
}
$c_scm_HashSet$.prototype = new $h_O();
$c_scm_HashSet$.prototype.constructor = $c_scm_HashSet$;
/** @constructor */
function $h_scm_HashSet$() {
}
$h_scm_HashSet$.prototype = $c_scm_HashSet$.prototype;
$c_scm_HashSet$.prototype.from__sc_IterableOnce__scm_HashSet = (function(it) {
  var k = $n(it).knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  var this$1 = $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), cap, 0.75);
  return this$1.addAll__sc_IterableOnce__scm_HashSet(it);
});
$c_scm_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashSet$$anon$4(16, 0.75);
});
$c_scm_HashSet$.prototype.empty__O = (function() {
  return $ct_scm_HashSet__(new $c_scm_HashSet());
});
$c_scm_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_HashSet(source);
});
var $d_scm_HashSet$ = new $TypeData().initClass($c_scm_HashSet$, "scala.collection.mutable.HashSet$", ({
  scm_HashSet$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_HashSet$;
function $m_scm_HashSet$() {
  if ((!$n_scm_HashSet$)) {
    $n_scm_HashSet$ = new $c_scm_HashSet$();
  }
  return $n_scm_HashSet$;
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$SyncBatch(outer, runnable) {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null;
  $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__(this, outer, runnable, $m_s_concurrent_BatchingExecutorStatics$().s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray, 1);
}
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype = new $h_s_concurrent_BatchingExecutor$AbstractBatch();
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$SyncBatch() {
}
$h_s_concurrent_BatchingExecutor$SyncBatch.prototype = $c_s_concurrent_BatchingExecutor$SyncBatch.prototype;
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.run__V = (function() {
  while (true) {
    try {
      this.runN__I__V(1024);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if (false) {
        var x2 = $as_jl_InterruptedException(e$2);
        $n(this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer);
        $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(x2);
      } else if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        $n(this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer);
        $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(e$2);
      } else {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    if ((this.s_concurrent_BatchingExecutor$AbstractBatch__f_size > 0)) {
      continue;
    }
    return (void 0);
  }
});
function $as_s_concurrent_BatchingExecutor$SyncBatch(obj) {
  return (((obj instanceof $c_s_concurrent_BatchingExecutor$SyncBatch) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.BatchingExecutor$SyncBatch"));
}
function $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BatchingExecutor$SyncBatch)));
}
function $asArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (($isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.BatchingExecutor$SyncBatch;", depth));
}
var $d_s_concurrent_BatchingExecutor$SyncBatch = new $TypeData().initClass($c_s_concurrent_BatchingExecutor$SyncBatch, "scala.concurrent.BatchingExecutor$SyncBatch", ({
  s_concurrent_BatchingExecutor$SyncBatch: 1,
  s_concurrent_BatchingExecutor$AbstractBatch: 1,
  jl_Runnable: 1
}));
/** @constructor */
function $c_s_concurrent_impl_Promise$Link(to) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, to);
}
$c_s_concurrent_impl_Promise$Link.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$Link.prototype.constructor = $c_s_concurrent_impl_Promise$Link;
/** @constructor */
function $h_s_concurrent_impl_Promise$Link() {
}
$h_s_concurrent_impl_Promise$Link.prototype = $c_s_concurrent_impl_Promise$Link.prototype;
$c_s_concurrent_impl_Promise$Link.prototype.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise = (function(owner) {
  var c = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value);
  var current = c;
  var target = c;
  while (true) {
    var value = $n(target).ju_concurrent_atomic_AtomicReference__f_value;
    if ($is_s_concurrent_impl_Promise$Callbacks(value)) {
      if (this.compareAndSet__O__O__Z(current, target)) {
        return target;
      } else {
        current = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value);
      }
    } else if ((value instanceof $c_s_concurrent_impl_Promise$Link)) {
      target = $as_s_concurrent_impl_Promise$DefaultPromise($n($as_s_concurrent_impl_Promise$Link(value)).ju_concurrent_atomic_AtomicReference__f_value);
    } else {
      $n(owner).unlink__s_util_Try__V($as_s_util_Try(value));
      return owner;
    }
  }
});
function $as_s_concurrent_impl_Promise$Link(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Link) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Link"));
}
function $isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Link)));
}
function $asArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Link;", depth));
}
var $d_s_concurrent_impl_Promise$Link = new $TypeData().initClass($c_s_concurrent_impl_Promise$Link, "scala.concurrent.impl.Promise$Link", ({
  s_concurrent_impl_Promise$Link: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_jdk_CollectionConverters$() {
}
$c_s_jdk_CollectionConverters$.prototype = new $h_O();
$c_s_jdk_CollectionConverters$.prototype.constructor = $c_s_jdk_CollectionConverters$;
/** @constructor */
function $h_s_jdk_CollectionConverters$() {
}
$h_s_jdk_CollectionConverters$.prototype = $c_s_jdk_CollectionConverters$.prototype;
var $d_s_jdk_CollectionConverters$ = new $TypeData().initClass($c_s_jdk_CollectionConverters$, "scala.jdk.CollectionConverters$", ({
  s_jdk_CollectionConverters$: 1,
  sc_convert_AsJavaExtensions: 1,
  sc_convert_AsScalaExtensions: 1
}));
var $n_s_jdk_CollectionConverters$;
function $m_s_jdk_CollectionConverters$() {
  if ((!$n_s_jdk_CollectionConverters$)) {
    $n_s_jdk_CollectionConverters$ = new $c_s_jdk_CollectionConverters$();
  }
  return $n_s_jdk_CollectionConverters$;
}
/** @constructor */
function $c_s_jdk_javaapi_CollectionConverters$() {
}
$c_s_jdk_javaapi_CollectionConverters$.prototype = new $h_O();
$c_s_jdk_javaapi_CollectionConverters$.prototype.constructor = $c_s_jdk_javaapi_CollectionConverters$;
/** @constructor */
function $h_s_jdk_javaapi_CollectionConverters$() {
}
$h_s_jdk_javaapi_CollectionConverters$.prototype = $c_s_jdk_javaapi_CollectionConverters$.prototype;
var $d_s_jdk_javaapi_CollectionConverters$ = new $TypeData().initClass($c_s_jdk_javaapi_CollectionConverters$, "scala.jdk.javaapi.CollectionConverters$", ({
  s_jdk_javaapi_CollectionConverters$: 1,
  sc_convert_AsJavaConverters: 1,
  sc_convert_AsScalaConverters: 1
}));
var $n_s_jdk_javaapi_CollectionConverters$;
function $m_s_jdk_javaapi_CollectionConverters$() {
  if ((!$n_s_jdk_javaapi_CollectionConverters$)) {
    $n_s_jdk_javaapi_CollectionConverters$ = new $c_s_jdk_javaapi_CollectionConverters$();
  }
  return $n_s_jdk_javaapi_CollectionConverters$;
}
/** @constructor */
function $c_s_math_Ordering$() {
}
$c_s_math_Ordering$.prototype = new $h_O();
$c_s_math_Ordering$.prototype.constructor = $c_s_math_Ordering$;
/** @constructor */
function $h_s_math_Ordering$() {
}
$h_s_math_Ordering$.prototype = $c_s_math_Ordering$.prototype;
var $d_s_math_Ordering$ = new $TypeData().initClass($c_s_math_Ordering$, "scala.math.Ordering$", ({
  s_math_Ordering$: 1,
  s_math_LowPriorityOrderingImplicits: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$;
function $m_s_math_Ordering$() {
  if ((!$n_s_math_Ordering$)) {
    $n_s_math_Ordering$ = new $c_s_math_Ordering$();
  }
  return $n_s_math_Ordering$;
}
function $is_s_math_PartialOrdering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_PartialOrdering)));
}
function $as_s_math_PartialOrdering(obj) {
  return (($is_s_math_PartialOrdering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.PartialOrdering"));
}
function $isArrayOf_s_math_PartialOrdering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_PartialOrdering)));
}
function $asArrayOf_s_math_PartialOrdering(obj, depth) {
  return (($isArrayOf_s_math_PartialOrdering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.PartialOrdering;", depth));
}
/** @constructor */
function $c_s_math_ScalaNumber() {
}
$c_s_math_ScalaNumber.prototype = new $h_jl_Number();
$c_s_math_ScalaNumber.prototype.constructor = $c_s_math_ScalaNumber;
/** @constructor */
function $h_s_math_ScalaNumber() {
}
$h_s_math_ScalaNumber.prototype = $c_s_math_ScalaNumber.prototype;
function $as_s_math_ScalaNumber(obj) {
  return (((obj instanceof $c_s_math_ScalaNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.ScalaNumber"));
}
function $isArrayOf_s_math_ScalaNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_ScalaNumber)));
}
function $asArrayOf_s_math_ScalaNumber(obj, depth) {
  return (($isArrayOf_s_math_ScalaNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.ScalaNumber;", depth));
}
/** @constructor */
function $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(f) {
  this.sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c__f_f = null;
  this.sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c__f_f = f;
}
$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c.prototype = new $h_sr_AbstractFunction0();
$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c.prototype.constructor = $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c;
/** @constructor */
function $h_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c() {
}
$h_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c.prototype = $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c.prototype;
$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c.prototype.apply__O = (function() {
  return $n(this.sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c__f_f)();
});
var $d_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c = new $TypeData().initClass($c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c, "scala.runtime.AbstractFunction0.$$Lambda$07eded5776954a9c145e92c329afd52873ad179c", ({
  sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c: 1,
  sr_AbstractFunction0: 1,
  F0: 1
}));
/** @constructor */
function $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(f) {
  this.sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919__f_f = null;
  this.sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919__f_f = f;
}
$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919.prototype = new $h_sr_AbstractFunction1();
$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919.prototype.constructor = $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919;
/** @constructor */
function $h_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919() {
}
$h_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919.prototype = $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919.prototype;
$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919.prototype.apply__O__O = (function(x0) {
  return $n(this.sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919__f_f)(x0);
});
var $d_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919 = new $TypeData().initClass($c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919, "scala.runtime.AbstractFunction1.$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919", ({
  sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
/** @constructor */
function $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(f) {
  this.sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8__f_f = null;
  this.sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8__f_f = f;
}
$c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8.prototype = new $h_sr_AbstractFunction2();
$c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8.prototype.constructor = $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8;
/** @constructor */
function $h_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8() {
}
$h_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8.prototype = $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8.prototype;
$c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8.prototype.apply__O__O__O = (function(x0, x1) {
  return $n(this.sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8__f_f)(x0, x1);
});
var $d_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8 = new $TypeData().initClass($c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8, "scala.runtime.AbstractFunction2.$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8", ({
  sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8: 1,
  sr_AbstractFunction2: 1,
  F2: 1
}));
/** @constructor */
function $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(f) {
  this.sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825__f_f = null;
  this.sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825__f_f = f;
}
$c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825.prototype = new $h_sr_AbstractFunction3();
$c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825.prototype.constructor = $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825;
/** @constructor */
function $h_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825() {
}
$h_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825.prototype = $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825.prototype;
$c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825.prototype.apply__O__O__O__O = (function(x0, x1, x2) {
  return $n(this.sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825__f_f)(x0, x1, x2);
});
var $d_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825 = new $TypeData().initClass($c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825, "scala.runtime.AbstractFunction3.$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825", ({
  sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825: 1,
  sr_AbstractFunction3: 1,
  F3: 1
}));
/** @constructor */
function $c_sr_AbstractPartialFunction() {
}
$c_sr_AbstractPartialFunction.prototype = new $h_O();
$c_sr_AbstractPartialFunction.prototype.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
}
$h_sr_AbstractPartialFunction.prototype = $c_sr_AbstractPartialFunction.prototype;
$c_sr_AbstractPartialFunction.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sr_AbstractPartialFunction.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sr_AbstractPartialFunction.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sr_AbstractPartialFunction.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sr_AbstractPartialFunction.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sr_AbstractPartialFunction.prototype.apply__O__O = (function(x) {
  return this.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf);
});
$c_sr_AbstractPartialFunction.prototype.apply$mcZI$sp__I__Z = (function(x) {
  return $uZ(this.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf));
});
$c_sr_AbstractPartialFunction.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
var $d_sr_Nothing$ = new $TypeData().initClass(0, "scala.runtime.Nothing$", ({
  sr_Nothing$: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sjs_js_Any$() {
}
$c_sjs_js_Any$.prototype = new $h_O();
$c_sjs_js_Any$.prototype.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
}
$h_sjs_js_Any$.prototype = $c_sjs_js_Any$.prototype;
$c_sjs_js_Any$.prototype.fromFunction0__F0__sjs_js_Function0 = (function(f) {
  return (() => $n(f).apply__O());
});
$c_sjs_js_Any$.prototype.fromFunction1__F1__sjs_js_Function1 = (function(f) {
  return ((arg1$2) => $n(f).apply__O__O(arg1$2));
});
$c_sjs_js_Any$.prototype.fromFunction2__F2__sjs_js_Function2 = (function(f) {
  return ((arg1$2, arg2$2) => $n(f).apply__O__O__O(arg1$2, arg2$2));
});
var $d_sjs_js_Any$ = new $TypeData().initClass($c_sjs_js_Any$, "scala.scalajs.js.Any$", ({
  sjs_js_Any$: 1,
  sjs_js_LowPrioAnyImplicits: 1,
  sjs_js_LowestPrioAnyImplicits: 1
}));
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$();
  }
  return $n_sjs_js_Any$;
}
/** @constructor */
function $c_sjsr_AnonFunction0() {
}
$c_sjsr_AnonFunction0.prototype = new $h_sr_AbstractFunction0();
$c_sjsr_AnonFunction0.prototype.constructor = $c_sjsr_AnonFunction0;
/** @constructor */
function $h_sjsr_AnonFunction0() {
}
$h_sjsr_AnonFunction0.prototype = $c_sjsr_AnonFunction0.prototype;
/** @constructor */
function $c_sjsr_AnonFunction1() {
}
$c_sjsr_AnonFunction1.prototype = new $h_sr_AbstractFunction1();
$c_sjsr_AnonFunction1.prototype.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
}
$h_sjsr_AnonFunction1.prototype = $c_sjsr_AnonFunction1.prototype;
/** @constructor */
function $c_sjsr_AnonFunction2() {
}
$c_sjsr_AnonFunction2.prototype = new $h_sr_AbstractFunction2();
$c_sjsr_AnonFunction2.prototype.constructor = $c_sjsr_AnonFunction2;
/** @constructor */
function $h_sjsr_AnonFunction2() {
}
$h_sjsr_AnonFunction2.prototype = $c_sjsr_AnonFunction2.prototype;
/** @constructor */
function $c_sjsr_AnonFunction3() {
}
$c_sjsr_AnonFunction3.prototype = new $h_sr_AbstractFunction3();
$c_sjsr_AnonFunction3.prototype.constructor = $c_sjsr_AnonFunction3;
/** @constructor */
function $h_sjsr_AnonFunction3() {
}
$h_sjsr_AnonFunction3.prototype = $c_sjsr_AnonFunction3.prototype;
/** @constructor */
function $c_sjsr_AnonFunction4() {
}
$c_sjsr_AnonFunction4.prototype = new $h_sr_AbstractFunction4();
$c_sjsr_AnonFunction4.prototype.constructor = $c_sjsr_AnonFunction4;
/** @constructor */
function $h_sjsr_AnonFunction4() {
}
$h_sjsr_AnonFunction4.prototype = $c_sjsr_AnonFunction4.prototype;
/** @constructor */
function $c_s_util_Random$() {
  this.s_util_Random__f_self = null;
  $ct_s_util_Random__ju_Random__(this, $ct_ju_Random__(new $c_ju_Random()));
}
$c_s_util_Random$.prototype = new $h_s_util_Random();
$c_s_util_Random$.prototype.constructor = $c_s_util_Random$;
/** @constructor */
function $h_s_util_Random$() {
}
$h_s_util_Random$.prototype = $c_s_util_Random$.prototype;
var $d_s_util_Random$ = new $TypeData().initClass($c_s_util_Random$, "scala.util.Random$", ({
  s_util_Random$: 1,
  s_util_Random: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_util_Random$;
function $m_s_util_Random$() {
  if ((!$n_s_util_Random$)) {
    $n_s_util_Random$ = new $c_s_util_Random$();
  }
  return $n_s_util_Random$;
}
class $c_s_util_control_ControlThrowable extends $c_jl_Throwable {
}
function $as_s_util_control_ControlThrowable(obj) {
  return (((obj instanceof $c_s_util_control_ControlThrowable) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.control.ControlThrowable"));
}
function $isArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_control_ControlThrowable)));
}
function $asArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (($isArrayOf_s_util_control_ControlThrowable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.control.ControlThrowable;", depth));
}
/** @constructor */
function $c_Lsnabbdom_PatchedVNode$() {
}
$c_Lsnabbdom_PatchedVNode$.prototype = new $h_O();
$c_Lsnabbdom_PatchedVNode$.prototype.constructor = $c_Lsnabbdom_PatchedVNode$;
/** @constructor */
function $h_Lsnabbdom_PatchedVNode$() {
}
$h_Lsnabbdom_PatchedVNode$.prototype = $c_Lsnabbdom_PatchedVNode$.prototype;
$c_Lsnabbdom_PatchedVNode$.prototype.key__Lsnabbdom_PatchedVNode__s_Option = (function(vnode) {
  if ((vnode instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var x$1 = $as_Lsnabbdom_PatchedVNode$Element(vnode);
    $n(x$1);
    var this$3 = $n(x$1);
    var x5 = this$3.Lsnabbdom_PatchedVNode$Element__f_data;
    $n(x$1);
    $n(x$1);
    return $n(x5).Lsnabbdom_VNodeData__f_key;
  } else {
    return $m_s_None$();
  }
});
var $d_Lsnabbdom_PatchedVNode$ = new $TypeData().initClass($c_Lsnabbdom_PatchedVNode$, "snabbdom.PatchedVNode$", ({
  Lsnabbdom_PatchedVNode$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lsnabbdom_PatchedVNode$;
function $m_Lsnabbdom_PatchedVNode$() {
  if ((!$n_Lsnabbdom_PatchedVNode$)) {
    $n_Lsnabbdom_PatchedVNode$ = new $c_Lsnabbdom_PatchedVNode$();
  }
  return $n_Lsnabbdom_PatchedVNode$;
}
/** @constructor */
function $c_Lsnabbdom_VNode$() {
  this.Lsnabbdom_VNode$__f_empty = null;
  $n_Lsnabbdom_VNode$ = this;
  this.Lsnabbdom_VNode$__f_empty = new $c_Lsnabbdom_VNode$Text("");
}
$c_Lsnabbdom_VNode$.prototype = new $h_O();
$c_Lsnabbdom_VNode$.prototype.constructor = $c_Lsnabbdom_VNode$;
/** @constructor */
function $h_Lsnabbdom_VNode$() {
}
$h_Lsnabbdom_VNode$.prototype = $c_Lsnabbdom_VNode$.prototype;
$c_Lsnabbdom_VNode$.prototype.snabbdom$VNode$$$key__Lsnabbdom_VNode__s_Option = (function(vnode) {
  if ((vnode instanceof $c_Lsnabbdom_VNode$Text)) {
    var x$1 = $as_Lsnabbdom_VNode$Text(vnode);
    $n(x$1);
    return $m_s_None$();
  }
  if ((vnode instanceof $c_Lsnabbdom_VNode$Element)) {
    var x$1$1 = $as_Lsnabbdom_VNode$Element(vnode);
    $n(x$1$1);
    var this$5 = $n(x$1$1);
    var x22 = this$5.Lsnabbdom_VNode$Element__f_data;
    $n(x$1$1);
    return $n(x22).Lsnabbdom_VNodeData__f_key;
  }
  if ((vnode instanceof $c_Lsnabbdom_VNode$Comment)) {
    var x$1$2 = $as_Lsnabbdom_VNode$Comment(vnode);
    $n(x$1$2);
    return $m_s_None$();
  }
  throw new $c_s_MatchError(vnode);
});
$c_Lsnabbdom_VNode$.prototype.applyInitHook__Lsnabbdom_VNode__Lsnabbdom_VNode = (function(vnode) {
  if ((vnode instanceof $c_Lsnabbdom_VNode$Text)) {
    var x$1 = $as_Lsnabbdom_VNode$Text(vnode);
    $n(x$1);
    return vnode;
  }
  if ((vnode instanceof $c_Lsnabbdom_VNode$Element)) {
    var x$1$1 = $as_Lsnabbdom_VNode$Element(vnode);
    $n(x$1$1);
    var this$5 = $n(x$1$1);
    var x46 = this$5.Lsnabbdom_VNode$Element__f_data;
    $n(x$1$1);
    var this$7 = $n($n(x46).Lsnabbdom_VNodeData__f_hook);
    if (this$7.isEmpty__Z()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = this$7.get__O();
      var _$2 = $as_Lsnabbdom_Hooks(x0);
      var $x_1 = $n(_$2).init__s_Option();
    }
    var this$8 = $n($x_1);
    if (this$8.isEmpty__Z()) {
      return vnode;
    } else {
      var x0$1 = this$8.get__O();
      var _$3 = $as_Lsnabbdom_InitHook(x0$1);
      return $n(_$3).apply__Lsnabbdom_VNode__Lsnabbdom_VNode(vnode);
    }
  }
  if ((vnode instanceof $c_Lsnabbdom_VNode$Comment)) {
    var x$1$2 = $as_Lsnabbdom_VNode$Comment(vnode);
    $n(x$1$2);
    return vnode;
  }
  throw new $c_s_MatchError(vnode);
});
var $d_Lsnabbdom_VNode$ = new $TypeData().initClass($c_Lsnabbdom_VNode$, "snabbdom.VNode$", ({
  Lsnabbdom_VNode$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lsnabbdom_VNode$;
function $m_Lsnabbdom_VNode$() {
  if ((!$n_Lsnabbdom_VNode$)) {
    $n_Lsnabbdom_VNode$ = new $c_Lsnabbdom_VNode$();
  }
  return $n_Lsnabbdom_VNode$;
}
/** @constructor */
function $c_Lsnabbdom_VNodeData$() {
  this.Lsnabbdom_VNodeData$__f_empty = null;
  $n_Lsnabbdom_VNodeData$ = this;
  $m_Lsnabbdom_VNodeData$();
  $m_Lsnabbdom_VNodeData$();
  var props = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var attrs = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var classes = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var style = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var dataset = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var on = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var hook = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var key = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var ns = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var fn = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var args = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var is = $m_s_None$();
  this.Lsnabbdom_VNodeData$__f_empty = new $c_Lsnabbdom_VNodeData(props, attrs, classes, style, dataset, on, hook, key, ns, fn, args, is);
}
$c_Lsnabbdom_VNodeData$.prototype = new $h_O();
$c_Lsnabbdom_VNodeData$.prototype.constructor = $c_Lsnabbdom_VNodeData$;
/** @constructor */
function $h_Lsnabbdom_VNodeData$() {
}
$h_Lsnabbdom_VNodeData$.prototype = $c_Lsnabbdom_VNodeData$.prototype;
$c_Lsnabbdom_VNodeData$.prototype.toString__T = (function() {
  return "VNodeData";
});
var $d_Lsnabbdom_VNodeData$ = new $TypeData().initClass($c_Lsnabbdom_VNodeData$, "snabbdom.VNodeData$", ({
  Lsnabbdom_VNodeData$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lsnabbdom_VNodeData$;
function $m_Lsnabbdom_VNodeData$() {
  if ((!$n_Lsnabbdom_VNodeData$)) {
    $n_Lsnabbdom_VNodeData$ = new $c_Lsnabbdom_VNodeData$();
  }
  return $n_Lsnabbdom_VNodeData$;
}
/** @constructor */
function $c_Ltyrian_Attribute$() {
  $n_Ltyrian_Attribute$ = this;
  $m_Ltyrian_Attribute$();
}
$c_Ltyrian_Attribute$.prototype = new $h_O();
$c_Ltyrian_Attribute$.prototype.constructor = $c_Ltyrian_Attribute$;
/** @constructor */
function $h_Ltyrian_Attribute$() {
}
$h_Ltyrian_Attribute$.prototype = $c_Ltyrian_Attribute$.prototype;
var $d_Ltyrian_Attribute$ = new $TypeData().initClass($c_Ltyrian_Attribute$, "tyrian.Attribute$", ({
  Ltyrian_Attribute$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Ltyrian_Attribute$;
function $m_Ltyrian_Attribute$() {
  if ((!$n_Ltyrian_Attribute$)) {
    $n_Ltyrian_Attribute$ = new $c_Ltyrian_Attribute$();
  }
  return $n_Ltyrian_Attribute$;
}
function $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails($thiz, path) {
  if ((path === "")) {
    var search = $m_s_None$();
    var hash = $m_s_None$();
    return new $c_Ltyrian_LocationDetails$LocationPathDetails(path, search, hash);
  }
  if ((path !== null)) {
    var x20 = $n($thiz.Ltyrian_LocationDetails$__f_pathMatchAll).unapplySeq__jl_CharSequence__s_Option(path);
    if ((!$n(x20).isEmpty__Z())) {
      var x21 = $as_sci_List($n(x20).get__O());
      if (($n(x21).lengthCompare__I__I(3) === 0)) {
        var this$2 = $n(x21);
        var x22 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$2, 0));
        var this$3 = $n(x21);
        var x23 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$3, 1));
        var this$4 = $n(x21);
        var x24 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$4, 2));
        var search$1 = $m_s_Option$().apply__O__s_Option(x23);
        var hash$1 = $m_s_Option$().apply__O__s_Option(x24);
        return new $c_Ltyrian_LocationDetails$LocationPathDetails(x22, search$1, hash$1);
      }
    }
    var x16 = $n($thiz.Ltyrian_LocationDetails$__f_pathMatchHash).unapplySeq__jl_CharSequence__s_Option(path);
    if ((!$n(x16).isEmpty__Z())) {
      var x17 = $as_sci_List($n(x16).get__O());
      if (($n(x17).lengthCompare__I__I(2) === 0)) {
        var this$6 = $n(x17);
        var x18 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$6, 0));
        var this$7 = $n(x17);
        var x19 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$7, 1));
        var search$2 = $m_s_None$();
        var hash$2 = $m_s_Option$().apply__O__s_Option(x19);
        return new $c_Ltyrian_LocationDetails$LocationPathDetails(x18, search$2, hash$2);
      }
    }
    var x12 = $n($thiz.Ltyrian_LocationDetails$__f_pathMatchSearch).unapplySeq__jl_CharSequence__s_Option(path);
    if ((!$n(x12).isEmpty__Z())) {
      var x13 = $as_sci_List($n(x12).get__O());
      if (($n(x13).lengthCompare__I__I(2) === 0)) {
        var this$9 = $n(x13);
        var x14 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$9, 0));
        var this$10 = $n(x13);
        var x15 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$10, 1));
        var search$3 = $m_s_Option$().apply__O__s_Option(x15);
        var hash$3 = $m_s_None$();
        return new $c_Ltyrian_LocationDetails$LocationPathDetails(x14, search$3, hash$3);
      }
    }
  }
  var search$4 = $m_s_None$();
  var hash$4 = $m_s_None$();
  return new $c_Ltyrian_LocationDetails$LocationPathDetails(path, search$4, hash$4);
}
/** @constructor */
function $c_Ltyrian_LocationDetails$() {
  this.Ltyrian_LocationDetails$__f_urlFileMatch = null;
  this.Ltyrian_LocationDetails$__f_urlDataMatch = null;
  this.Ltyrian_LocationDetails$__f_urlMatch = null;
  this.Ltyrian_LocationDetails$__f_pathMatchAll = null;
  this.Ltyrian_LocationDetails$__f_pathMatchHash = null;
  this.Ltyrian_LocationDetails$__f_pathMatchSearch = null;
  $n_Ltyrian_LocationDetails$ = this;
  this.Ltyrian_LocationDetails$__f_urlFileMatch = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^(file\\:)\\/\\/(\\/.*)?", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_urlDataMatch = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^(data\\:)(.*)?", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_urlMatch = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "^([a-z]+\\:)(\\/+)?([a-zA-Z0-9-\\.\\@]+)(:)?([0-9]+)?(.*)?", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_pathMatchAll = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(.*)(\\?.*)(#.*)", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_pathMatchHash = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(.*)(#.*)", $m_sci_Nil$());
  this.Ltyrian_LocationDetails$__f_pathMatchSearch = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "(.*)(\\?.*)", $m_sci_Nil$());
}
$c_Ltyrian_LocationDetails$.prototype = new $h_O();
$c_Ltyrian_LocationDetails$.prototype.constructor = $c_Ltyrian_LocationDetails$;
/** @constructor */
function $h_Ltyrian_LocationDetails$() {
}
$h_Ltyrian_LocationDetails$.prototype = $c_Ltyrian_LocationDetails$.prototype;
$c_Ltyrian_LocationDetails$.prototype.fromUrl__T__Ltyrian_LocationDetails = (function(url) {
  if ((url !== null)) {
    var x38 = $n(this.Ltyrian_LocationDetails$__f_urlFileMatch).unapplySeq__jl_CharSequence__s_Option(url);
    if ((!$n(x38).isEmpty__Z())) {
      var x39 = $as_sci_List($n(x38).get__O());
      if (($n(x39).lengthCompare__I__I(2) === 0)) {
        var this$1 = $n(x39);
        var x40 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$1, 0));
        var this$2 = $n(x39);
        var x41 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$2, 1));
        var this$3 = $n($m_s_Option$().apply__O__s_Option(x41));
        var p = $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails(this, $as_T((this$3.isEmpty__Z() ? "" : this$3.get__O())));
        $m_Ltyrian_LocationDetails$();
        var hash = $n(p).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
        var hostName = $m_s_None$();
        var pathName = $n(p).Ltyrian_LocationDetails$LocationPathDetails__f_path;
        var port = $m_s_None$();
        var protocol = $m_s_Option$().apply__O__s_Option(x40);
        var search = $n(p).Ltyrian_LocationDetails$LocationPathDetails__f_search;
        return new $c_Ltyrian_LocationDetails(hash, hostName, pathName, port, protocol, search, url);
      }
    }
    var x34 = $n(this.Ltyrian_LocationDetails$__f_urlDataMatch).unapplySeq__jl_CharSequence__s_Option(url);
    if ((!$n(x34).isEmpty__Z())) {
      var x35 = $as_sci_List($n(x34).get__O());
      if (($n(x35).lengthCompare__I__I(2) === 0)) {
        var this$5 = $n(x35);
        var x36 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$5, 0));
        var this$6 = $n(x35);
        var x37 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$6, 1));
        var this$7 = $n($m_s_Option$().apply__O__s_Option(x37));
        var p$2 = $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails(this, $as_T((this$7.isEmpty__Z() ? "" : this$7.get__O())));
        $m_Ltyrian_LocationDetails$();
        var hash$1 = $n(p$2).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
        var hostName$1 = $m_s_None$();
        var pathName$1 = $n(p$2).Ltyrian_LocationDetails$LocationPathDetails__f_path;
        var port$1 = $m_s_None$();
        var protocol$1 = $m_s_Option$().apply__O__s_Option(x36);
        var search$1 = $n(p$2).Ltyrian_LocationDetails$LocationPathDetails__f_search;
        return new $c_Ltyrian_LocationDetails(hash$1, hostName$1, pathName$1, port$1, protocol$1, search$1, url);
      }
    }
    var x26 = $n(this.Ltyrian_LocationDetails$__f_urlMatch).unapplySeq__jl_CharSequence__s_Option(url);
    if ((!$n(x26).isEmpty__Z())) {
      var x27 = $as_sci_List($n(x26).get__O());
      if (($n(x27).lengthCompare__I__I(6) === 0)) {
        var this$9 = $n(x27);
        var x28 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$9, 0));
        var this$10 = $n(x27);
        $as_T($f_sc_LinearSeqOps__apply__I__O(this$10, 1));
        var this$11 = $n(x27);
        var x30 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$11, 2));
        var this$12 = $n(x27);
        $as_T($f_sc_LinearSeqOps__apply__I__O(this$12, 3));
        var this$13 = $n(x27);
        var x32 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$13, 4));
        var this$14 = $n(x27);
        var x33 = $as_T($f_sc_LinearSeqOps__apply__I__O(this$14, 5));
        var this$15 = $n($m_s_Option$().apply__O__s_Option(x33));
        var p$3 = $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails(this, $as_T((this$15.isEmpty__Z() ? "" : this$15.get__O())));
        $m_Ltyrian_LocationDetails$();
        var hash$2 = $n(p$3).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
        var hostName$2 = $m_s_Option$().apply__O__s_Option(x30);
        var pathName$2 = $n(p$3).Ltyrian_LocationDetails$LocationPathDetails__f_path;
        var port$2 = $m_s_Option$().apply__O__s_Option(x32);
        var protocol$2 = $m_s_Option$().apply__O__s_Option(x28);
        var search$2 = $n(p$3).Ltyrian_LocationDetails$LocationPathDetails__f_search;
        return new $c_Ltyrian_LocationDetails(hash$2, hostName$2, pathName$2, port$2, protocol$2, search$2, url);
      }
    }
  }
  var this$17 = $n($m_s_Option$().apply__O__s_Option(url));
  var p$4 = $p_Ltyrian_LocationDetails$__parsePath__T__Ltyrian_LocationDetails$LocationPathDetails(this, $as_T((this$17.isEmpty__Z() ? "" : this$17.get__O())));
  $m_Ltyrian_LocationDetails$();
  var hash$3 = $n(p$4).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
  var hostName$3 = $m_s_None$();
  var pathName$3 = $n(p$4).Ltyrian_LocationDetails$LocationPathDetails__f_path;
  var port$3 = $m_s_None$();
  var protocol$3 = $m_s_None$();
  var search$3 = $n(p$4).Ltyrian_LocationDetails$LocationPathDetails__f_search;
  return new $c_Ltyrian_LocationDetails(hash$3, hostName$3, pathName$3, port$3, protocol$3, search$3, url);
});
var $d_Ltyrian_LocationDetails$ = new $TypeData().initClass($c_Ltyrian_LocationDetails$, "tyrian.LocationDetails$", ({
  Ltyrian_LocationDetails$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Ltyrian_LocationDetails$;
function $m_Ltyrian_LocationDetails$() {
  if ((!$n_Ltyrian_LocationDetails$)) {
    $n_Ltyrian_LocationDetails$ = new $c_Ltyrian_LocationDetails$();
  }
  return $n_Ltyrian_LocationDetails$;
}
function $p_Ltyrian_Sub$__cancel$2__F1__O__s_Option($thiz, release$5, res) {
  return $m_s_Option$().apply__O__s_Option($n(release$5).apply__O__O(res));
}
/** @constructor */
function $c_Ltyrian_Sub$() {
}
$c_Ltyrian_Sub$.prototype = new $h_O();
$c_Ltyrian_Sub$.prototype.constructor = $c_Ltyrian_Sub$;
/** @constructor */
function $h_Ltyrian_Sub$() {
}
$h_Ltyrian_Sub$.prototype = $c_Ltyrian_Sub$.prototype;
$c_Ltyrian_Sub$.prototype.merge__Ltyrian_Sub__Ltyrian_Sub__Ltyrian_Sub = (function(a, b) {
  var x = $m_Ltyrian_Sub$None$();
  if ((x === a)) {
    var x$3 = $m_Ltyrian_Sub$None$();
    if ((x$3 === b)) {
      return $m_Ltyrian_Sub$None$();
    }
    return b;
  }
  var x$5 = $m_Ltyrian_Sub$None$();
  if ((x$5 === b)) {
    return a;
  }
  return new $c_Ltyrian_Sub$Combine(a, b);
});
$c_Ltyrian_Sub$.prototype.make__T__F1__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub = (function(id, acquire, release, toMsg, evidence$1) {
  var task = $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cb) => {
    var cb$1 = $as_F1(cb);
    var target = $n(acquire).apply__O__O(cb$1);
    var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, evidence$1);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((res) => $p_Ltyrian_Sub$__cancel$2__F1__O__s_Option(this, release, res)));
    return $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  })))));
  return new $c_Ltyrian_Sub$Observe(id, task, toMsg);
});
$c_Ltyrian_Sub$.prototype.make__T__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub = (function(id, acquire, release, evidence$1) {
  return this.make__T__F1__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub(id, acquire, release, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => $m_s_Option$().apply__O__s_Option(x))), evidence$1);
});
$c_Ltyrian_Sub$.prototype.make__T__Lfs2_Stream__Lcats_effect_kernel_Async__Ltyrian_Sub = (function(id, stream, evidence$1) {
  return this.make__T__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub(id, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cb) => {
    var cb$1 = $as_F1(cb);
    var $x_1 = $n(evidence$1);
    var this$5 = $n($n($n(stream).attempt__Lfs2_Stream()).foreach__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((result) => {
      var result$1 = $as_s_util_Either(result);
      return $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        $n(cb$1).apply__O__O(result$1);
      })));
    }))));
    $m_Lfs2_Compiler$();
    var F = new $c_Lfs2_Compiler$Target$ConcurrentTarget(evidence$1);
    var compiler = new $c_Lfs2_CompilerLowPriority1$$anon$2(F);
    return $x_1.start__O__O(new $c_Lfs2_Stream$CompileOps(this$5.Lfs2_Stream__f_underlying, compiler).drain__O());
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
    var _$10$1 = $as_Lcats_effect_kernel_Fiber(_$10);
    return $n(_$10$1).cancel__O();
  })), evidence$1);
});
$c_Ltyrian_Sub$.prototype.fromEvent__T__Lorg_scalajs_dom_EventTarget__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub = (function(name, target, extract, evidence$1) {
  return $m_Ltyrian_Sub$().make__T__F1__F1__F1__Lcats_effect_kernel_Sync__Ltyrian_Sub((("" + name) + $dp_hashCode__I($n(target))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((callback) => {
    var callback$1 = $as_F1(callback);
    return $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
        $n(callback$1).apply__O__O(new $c_s_util_Right(a));
      }));
      var listener = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(f);
      target.addEventListener(name, listener);
      return listener;
    })));
  })), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((listener$1) => $n(evidence$1).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    target.removeEventListener(name, listener$1);
  }))))), extract, evidence$1);
});
var $d_Ltyrian_Sub$ = new $TypeData().initClass($c_Ltyrian_Sub$, "tyrian.Sub$", ({
  Ltyrian_Sub$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ltyrian_Sub$;
function $m_Ltyrian_Sub$() {
  if ((!$n_Ltyrian_Sub$)) {
    $n_Ltyrian_Sub$ = new $c_Ltyrian_Sub$();
  }
  return $n_Ltyrian_Sub$;
}
function $p_Ltyrian_runtime_Renderer$__render__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__Lcats_effect_kernel_Clock__J__Lcats_effect_kernel_Async__V($thiz, dispatcher, renderer, model, view, onMsg, router, clock, t_$_lo, t_$_hi, F) {
  var this$28 = $n(dispatcher);
  var target = $n(clock).realTime__O();
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
    var _$5$1 = $as_s_concurrent_duration_FiniteDuration(_$5);
    var this$2 = $n(_$5$1);
    return $n(this$2.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$2.s_concurrent_duration_FiniteDuration__f_length_$lo, this$2.s_concurrent_duration_FiniteDuration__f_length_$hi);
  }));
  var target$1 = $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  var this$27 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F);
  var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((time) => {
    var $x_1 = $uJ(time);
    var time$1_$_lo = $x_1.l;
    var time$1_$_hi = $x_1.h;
    var target$2 = $n(model).get__O();
    var this$26 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, F);
    var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((m) => {
      var ffa = $n(renderer).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => {
        var r$1 = $as_Ltyrian_runtime_Renderer(r);
        var x9 = $n(r$1).Ltyrian_runtime_Renderer__f_state;
        var x = $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState();
        if (((x === null) ? (x9 === null) : $n(x).equals__O__Z(x9))) {
          var y = $n(F).unit__O();
          return new $c_T2(r$1, y);
        }
        if ((x9 instanceof $c_Ltyrian_runtime_RendererState$Running)) {
          var x$1 = $as_Ltyrian_runtime_RendererState$Running(x9);
          var this$9 = $n(x$1);
          var x12_$_lo = this$9.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$lo;
          var x12_$_hi = this$9.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$hi;
          var lo = ((t_$_lo - x12_$_lo) | 0);
          var hi = ((((t_$_hi - x12_$_hi) | 0) + ((((~t_$_lo) & x12_$_lo) | ((~(t_$_lo ^ x12_$_lo)) & lo)) >> 31)) | 0);
          if (((hi === 0) ? ((lo >>> 0) >= 1000) : (hi > 0))) {
            var state$2 = $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState();
            var this$12 = $n(r$1);
            var vnode$2 = this$12.Ltyrian_runtime_Renderer__f_vnode;
            $n(r$1);
            var self = new $c_Ltyrian_runtime_Renderer(vnode$2, state$2);
            var y$1 = $n(F).unit__O();
            return new $c_T2(self, y$1);
          } else {
            $n(r$1);
            var vnode = $m_Ltyrian_runtime_Rendering$().render__O__O__F1__F1__F1__Lsnabbdom_PatchedVNode($n(r$1).Ltyrian_runtime_Renderer__f_vnode, m, view, onMsg, router);
            var this$16 = $n(r$1);
            var state = this$16.Ltyrian_runtime_Renderer__f_state;
            var self$1 = new $c_Ltyrian_runtime_Renderer(vnode, state);
            var target$3 = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $uI(window.requestAnimationFrame(((_$6) => {
              $uD(_$6);
              $p_Ltyrian_runtime_Renderer$__render__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__Lcats_effect_kernel_Clock__J__Lcats_effect_kernel_Async__V($m_Ltyrian_runtime_Renderer$(), dispatcher, renderer, model, view, onMsg, router, clock, time$1_$_lo, time$1_$_hi, F);
            }))))));
            var this$20 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
            var y$2 = $n(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$20.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
            return new $c_T2(self$1, y$2);
          }
        }
        throw new $c_s_MatchError(x9);
      })));
      var target$4 = $f_Lcats_FlatMap__flatten__O__O($n(F), ffa);
      var this$25 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, F);
      var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((res) => {
        $as_jl_Void(res);
      }));
      return $n(this$25.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$25.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
    }));
    return $n(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
  }));
  var fa = $n(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  $f_Lcats_effect_std_Dispatcher__unsafeRunAndForget__O__V(this$28, fa);
}
/** @constructor */
function $c_Ltyrian_runtime_Renderer$() {
  this.Ltyrian_runtime_Renderer$__f_timeout_$lo = 0;
  this.Ltyrian_runtime_Renderer$__f_timeout_$hi = 0;
  this.Ltyrian_runtime_Renderer$__f_timeout_$lo = 1000;
  this.Ltyrian_runtime_Renderer$__f_timeout_$hi = 0;
}
$c_Ltyrian_runtime_Renderer$.prototype = new $h_O();
$c_Ltyrian_runtime_Renderer$.prototype.constructor = $c_Ltyrian_runtime_Renderer$;
/** @constructor */
function $h_Ltyrian_runtime_Renderer$() {
}
$h_Ltyrian_runtime_Renderer$.prototype = $c_Ltyrian_runtime_Renderer$.prototype;
$c_Ltyrian_runtime_Renderer$.prototype.init__Lsnabbdom_PatchedVNode__Lcats_effect_kernel_Async__O = (function(vnode, F) {
  var $x_1 = $n(F);
  var state = $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState();
  return $x_1.ref__O__O(new $c_Ltyrian_runtime_Renderer(vnode, state));
});
$c_Ltyrian_runtime_Renderer$.prototype.redraw__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__Lcats_effect_kernel_Async__Lcats_effect_kernel_Clock__O = (function(dispatcher, renderer, model, view, onMsg, router, F, clock) {
  var target = $n(clock).realTime__O();
  var this$13 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((time) => {
    var time$1 = $as_s_concurrent_duration_FiniteDuration(time);
    return $n(renderer).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => {
      var r$1 = $as_Ltyrian_runtime_Renderer(r);
      var x5 = $n(r$1).Ltyrian_runtime_Renderer__f_state;
      var x = $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState();
      if (((x === null) ? (x5 === null) : $n(x).equals__O__Z(x5))) {
        var $x_2 = $n(r$1);
        var this$2 = $n(time$1);
        var $x_1 = $n(this$2.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$2.s_concurrent_duration_FiniteDuration__f_length_$lo, this$2.s_concurrent_duration_FiniteDuration__f_length_$hi);
        var self = $x_2.runningAt__J__Ltyrian_runtime_Renderer($x_1.l, $x_1.h);
        var target$1 = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $uI(window.requestAnimationFrame(((_$3) => {
          $uD(_$3);
          var $x_4 = $m_Ltyrian_runtime_Renderer$();
          var this$4 = $n(time$1);
          var $x_3 = $n(this$4.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$4.s_concurrent_duration_FiniteDuration__f_length_$lo, this$4.s_concurrent_duration_FiniteDuration__f_length_$hi);
          $p_Ltyrian_runtime_Renderer$__render__Lcats_effect_std_Dispatcher__Lcats_effect_kernel_Ref__Lcats_effect_kernel_Ref__F1__F1__F1__Lcats_effect_kernel_Clock__J__Lcats_effect_kernel_Async__V($x_4, dispatcher, renderer, model, view, onMsg, router, clock, $x_3.l, $x_3.h, F);
        }))))));
        var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
        var y = $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        return new $c_T2(self, y);
      }
      if ((x5 instanceof $c_Ltyrian_runtime_RendererState$Running)) {
        var x$1 = $as_Ltyrian_runtime_RendererState$Running(x5);
        $n(x$1);
        var $x_6 = $n(r$1);
        var this$10 = $n(time$1);
        var $x_5 = $n(this$10.s_concurrent_duration_FiniteDuration__f_unit).toMillis__J__J(this$10.s_concurrent_duration_FiniteDuration__f_length_$lo, this$10.s_concurrent_duration_FiniteDuration__f_length_$hi);
        var self$1 = $x_6.runningAt__J__Ltyrian_runtime_Renderer($x_5.l, $x_5.h);
        var y$1 = $n(F).unit__O();
        return new $c_T2(self$1, y$1);
      }
      throw new $c_s_MatchError(x5);
    })));
  }));
  var ffa = $n(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$13.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  return $f_Lcats_FlatMap__flatten__O__O($n(F), ffa);
});
var $d_Ltyrian_runtime_Renderer$ = new $TypeData().initClass($c_Ltyrian_runtime_Renderer$, "tyrian.runtime.Renderer$", ({
  Ltyrian_runtime_Renderer$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Ltyrian_runtime_Renderer$;
function $m_Ltyrian_runtime_Renderer$() {
  if ((!$n_Ltyrian_runtime_Renderer$)) {
    $n_Ltyrian_runtime_Renderer$ = new $c_Ltyrian_runtime_Renderer$();
  }
  return $n_Ltyrian_runtime_Renderer$;
}
function $s_Ltyrian_runtime_RendererState$__Idle__Ltyrian_runtime_RendererState() {
  $m_Ltyrian_runtime_RendererState$();
  return $t_Ltyrian_runtime_RendererState$__Idle;
}
/** @constructor */
function $c_Ltyrian_runtime_RendererState$() {
  $n_Ltyrian_runtime_RendererState$ = this;
  $t_Ltyrian_runtime_RendererState$__Idle = new $c_Ltyrian_runtime_RendererState$$anon$1("Idle", 0);
}
$c_Ltyrian_runtime_RendererState$.prototype = new $h_O();
$c_Ltyrian_runtime_RendererState$.prototype.constructor = $c_Ltyrian_runtime_RendererState$;
/** @constructor */
function $h_Ltyrian_runtime_RendererState$() {
}
$h_Ltyrian_runtime_RendererState$.prototype = $c_Ltyrian_runtime_RendererState$.prototype;
var $d_Ltyrian_runtime_RendererState$ = new $TypeData().initClass($c_Ltyrian_runtime_RendererState$, "tyrian.runtime.RendererState$", ({
  Ltyrian_runtime_RendererState$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ltyrian_runtime_RendererState$;
function $m_Ltyrian_runtime_RendererState$() {
  if ((!$n_Ltyrian_runtime_RendererState$)) {
    $n_Ltyrian_runtime_RendererState$ = new $c_Ltyrian_runtime_RendererState$();
  }
  return $n_Ltyrian_runtime_RendererState$;
}
/** @constructor */
function $c_Lcats_Always(f) {
  this.Lcats_Always__f_f = null;
  this.Lcats_Always__f_f = f;
}
$c_Lcats_Always.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Always.prototype.constructor = $c_Lcats_Always;
/** @constructor */
function $h_Lcats_Always() {
}
$h_Lcats_Always.prototype = $c_Lcats_Always.prototype;
$c_Lcats_Always.prototype.value__O = (function() {
  return $n(this.Lcats_Always__f_f).apply__O();
});
$c_Lcats_Always.prototype.memoize__Lcats_Eval = (function() {
  return new $c_Lcats_Later(this.Lcats_Always__f_f);
});
var $d_Lcats_Always = new $TypeData().initClass($c_Lcats_Always, "cats.Always", ({
  Lcats_Always: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
function $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1($thiz, m) {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
    $n(m).Lcats_Eval$Memoize__f_result = new $c_s_Some(a);
    return new $c_Lcats_Now(a);
  }));
}
function $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O($thiz, curr, fs) {
  var fs$tailLocal1 = fs;
  var curr$tailLocal1 = curr;
  while (true) {
    var x52 = curr$tailLocal1;
    if ((x52 instanceof $c_Lcats_Eval$FlatMap)) {
      var c = $as_Lcats_Eval$FlatMap(x52);
      var x26 = $as_Lcats_Eval($n($n(c).start__F0()).apply__O());
      if ((x26 instanceof $c_Lcats_Eval$FlatMap)) {
        var cc = $as_Lcats_Eval$FlatMap(x26);
        var first = $n(c).run__F1();
        var rest = fs$tailLocal1;
        var nextFs = new $c_Lcats_Eval$Many(first, rest);
        var curr$tailLocal1$tmp1 = $as_Lcats_Eval($n($n(cc).start__F0()).apply__O());
        var first$1 = $n(cc).run__F1();
        var fs$tailLocal1$tmp1 = new $c_Lcats_Eval$Many(first$1, nextFs);
        curr$tailLocal1 = curr$tailLocal1$tmp1;
        fs$tailLocal1 = fs$tailLocal1$tmp1;
        continue;
      }
      if ((x26 instanceof $c_Lcats_Eval$Defer)) {
        var call = $as_Lcats_Eval$Defer(x26);
        var curr$tailLocal1$tmp2 = $as_Lcats_Eval($n($n(call).Lcats_Eval$Defer__f_thunk).apply__O());
        var first$2 = $n(c).run__F1();
        var rest$1 = fs$tailLocal1;
        var fs$tailLocal1$tmp2 = new $c_Lcats_Eval$Many(first$2, rest$1);
        curr$tailLocal1 = curr$tailLocal1$tmp2;
        fs$tailLocal1 = fs$tailLocal1$tmp2;
        continue;
      }
      if ((x26 instanceof $c_Lcats_Eval$Memoize)) {
        var x28 = $as_Lcats_Eval$Memoize(x26);
        var this$5 = $n(x28);
        var x30 = this$5.Lcats_Eval$Memoize__f_eval;
        var x23 = $n(x28).Lcats_Eval$Memoize__f_result;
        if ((x23 instanceof $c_s_Some)) {
          var a = $n($as_s_Some(x23)).s_Some__f_value;
          curr$tailLocal1 = $as_Lcats_Eval($n($n(c).run__F1()).apply__O__O(a));
          continue;
        }
        var x = $m_s_None$();
        if ((x === x23)) {
          var first$3 = $n(c).run__F1();
          var rest$2 = fs$tailLocal1;
          var nextFs$2 = new $c_Lcats_Eval$Many(first$3, rest$2);
          var first$4 = $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1($thiz, x28);
          var fs$tailLocal1$tmp3 = new $c_Lcats_Eval$Many(first$4, nextFs$2);
          curr$tailLocal1 = x30;
          fs$tailLocal1 = fs$tailLocal1$tmp3;
          continue;
        }
        throw new $c_s_MatchError(x23);
      }
      if ((x26 instanceof $c_Lcats_Eval$Leaf)) {
        var xx = $as_Lcats_Eval$Leaf(x26);
        curr$tailLocal1 = $as_Lcats_Eval($n($n(c).run__F1()).apply__O__O($n(xx).value__O()));
        continue;
      }
      throw new $c_s_MatchError(x26);
    }
    if ((x52 instanceof $c_Lcats_Eval$Defer)) {
      var call$2 = $as_Lcats_Eval$Defer(x52);
      curr$tailLocal1 = $as_Lcats_Eval($n($n(call$2).Lcats_Eval$Defer__f_thunk).apply__O());
      continue;
    }
    if ((x52 instanceof $c_Lcats_Eval$Memoize)) {
      var m = $as_Lcats_Eval$Memoize(x52);
      var x41 = $n(m).Lcats_Eval$Memoize__f_result;
      if ((x41 instanceof $c_s_Some)) {
        var a$2 = $n($as_s_Some(x41)).s_Some__f_value;
        var x33 = fs$tailLocal1;
        if ((x33 instanceof $c_Lcats_Eval$Many)) {
          var x$1 = $as_Lcats_Eval$Many(x33);
          var this$9 = $n(x$1);
          var x39 = this$9.Lcats_Eval$Many__f_first;
          var this$10 = $n(x$1);
          var x40 = this$10.Lcats_Eval$Many__f_rest;
          var curr$tailLocal1$tmp4 = $as_Lcats_Eval($n(x39).apply__O__O(a$2));
          curr$tailLocal1 = curr$tailLocal1$tmp4;
          fs$tailLocal1 = x40;
          continue;
        }
        if ((x33 instanceof $c_Lcats_Eval$Ident)) {
          var x$1$1 = $as_Lcats_Eval$Ident(x33);
          var this$12 = $n(x$1$1);
          var x36 = this$12.Lcats_Eval$Ident__f_ev;
          $n(x36);
          return a$2;
        }
        throw new $c_s_MatchError(x33);
      }
      var x$3 = $m_s_None$();
      if ((x$3 === x41)) {
        var curr$tailLocal1$tmp5 = $n(m).Lcats_Eval$Memoize__f_eval;
        var first$5 = $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1($thiz, m);
        var rest$3 = fs$tailLocal1;
        var fs$tailLocal1$tmp5 = new $c_Lcats_Eval$Many(first$5, rest$3);
        curr$tailLocal1 = curr$tailLocal1$tmp5;
        fs$tailLocal1 = fs$tailLocal1$tmp5;
        continue;
      }
      throw new $c_s_MatchError(x41);
    }
    if ((x52 instanceof $c_Lcats_Eval$Leaf)) {
      var x$5 = $as_Lcats_Eval$Leaf(x52);
      var a1 = $n(x$5).value__O();
      var x44 = fs$tailLocal1;
      if ((x44 instanceof $c_Lcats_Eval$Many)) {
        var x$1$2 = $as_Lcats_Eval$Many(x44);
        var this$16 = $n(x$1$2);
        var x50 = this$16.Lcats_Eval$Many__f_first;
        var this$17 = $n(x$1$2);
        var x51 = this$17.Lcats_Eval$Many__f_rest;
        var curr$tailLocal1$tmp6 = $as_Lcats_Eval($n(x50).apply__O__O(a1));
        curr$tailLocal1 = curr$tailLocal1$tmp6;
        fs$tailLocal1 = x51;
        continue;
      }
      if ((x44 instanceof $c_Lcats_Eval$Ident)) {
        var x$1$3 = $as_Lcats_Eval$Ident(x44);
        var this$19 = $n(x$1$3);
        var x47 = this$19.Lcats_Eval$Ident__f_ev;
        $n(x47);
        return a1;
      }
      throw new $c_s_MatchError(x44);
    }
    throw new $c_s_MatchError(x52);
  }
}
/** @constructor */
function $c_Lcats_Eval$() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
  this.Lcats_Eval$__f_Unit = null;
  this.Lcats_Eval$__f_True = null;
  this.Lcats_Eval$__f_False = null;
  $ct_Lcats_EvalInstances__(this);
  $n_Lcats_Eval$ = this;
  this.Lcats_Eval$__f_Unit = new $c_Lcats_Now((void 0));
  this.Lcats_Eval$__f_True = new $c_Lcats_Now(true);
  this.Lcats_Eval$__f_False = new $c_Lcats_Now(false);
}
$c_Lcats_Eval$.prototype = new $h_Lcats_EvalInstances();
$c_Lcats_Eval$.prototype.constructor = $c_Lcats_Eval$;
/** @constructor */
function $h_Lcats_Eval$() {
}
$h_Lcats_Eval$.prototype = $c_Lcats_Eval$.prototype;
$c_Lcats_Eval$.prototype.cats$Eval$$$evaluate__Lcats_Eval__O = (function(e) {
  var this$1 = $m_s_$less$colon$less$();
  var e$1 = this$1.s_$less$colon$less$__f_singleton;
  return $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O(this, e, new $c_Lcats_Eval$Ident(e$1));
});
var $d_Lcats_Eval$ = new $TypeData().initClass($c_Lcats_Eval$, "cats.Eval$", ({
  Lcats_Eval$: 1,
  Lcats_EvalInstances: 1,
  Lcats_EvalInstances0: 1,
  Lcats_EvalInstances1: 1
}));
var $n_Lcats_Eval$;
function $m_Lcats_Eval$() {
  if ((!$n_Lcats_Eval$)) {
    $n_Lcats_Eval$ = new $c_Lcats_Eval$();
  }
  return $n_Lcats_Eval$;
}
/** @constructor */
function $c_Lcats_Eval$$anon$1(c$1, f$2) {
  this.Lcats_Eval$$anon$1__f_start = null;
  this.Lcats_Eval$$anon$1__f_run = null;
  this.Lcats_Eval$$anon$1__f_start = $n(c$1).start__F0();
  this.Lcats_Eval$$anon$1__f_run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => new $c_Lcats_Eval$$anon$2(c$1, s, f$2, this)));
}
$c_Lcats_Eval$$anon$1.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$1.prototype.constructor = $c_Lcats_Eval$$anon$1;
/** @constructor */
function $h_Lcats_Eval$$anon$1() {
}
$h_Lcats_Eval$$anon$1.prototype = $c_Lcats_Eval$$anon$1.prototype;
$c_Lcats_Eval$$anon$1.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$1__f_start;
});
$c_Lcats_Eval$$anon$1.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$1__f_run;
});
var $d_Lcats_Eval$$anon$1 = new $TypeData().initClass($c_Lcats_Eval$$anon$1, "cats.Eval$$anon$1", ({
  Lcats_Eval$$anon$1: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$$anon$2(c$3, s$1, f$4, outer) {
  this.Lcats_Eval$$anon$2__f_start = null;
  this.Lcats_Eval$$anon$2__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Eval$$anon$2__f_start = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $as_Lcats_Eval($n($n(c$3).run__F1()).apply__O__O(s$1))));
  this.Lcats_Eval$$anon$2__f_run = f$4;
}
$c_Lcats_Eval$$anon$2.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$2.prototype.constructor = $c_Lcats_Eval$$anon$2;
/** @constructor */
function $h_Lcats_Eval$$anon$2() {
}
$h_Lcats_Eval$$anon$2.prototype = $c_Lcats_Eval$$anon$2.prototype;
$c_Lcats_Eval$$anon$2.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$2__f_start;
});
$c_Lcats_Eval$$anon$2.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$2__f_run;
});
var $d_Lcats_Eval$$anon$2 = new $TypeData().initClass($c_Lcats_Eval$$anon$2, "cats.Eval$$anon$2", ({
  Lcats_Eval$$anon$2: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$$anon$3(c$5, f$5) {
  this.Lcats_Eval$$anon$3__f_start = null;
  this.Lcats_Eval$$anon$3__f_run = null;
  this.Lcats_Eval$$anon$3__f_start = $n(c$5).Lcats_Eval$Defer__f_thunk;
  this.Lcats_Eval$$anon$3__f_run = f$5;
}
$c_Lcats_Eval$$anon$3.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$3.prototype.constructor = $c_Lcats_Eval$$anon$3;
/** @constructor */
function $h_Lcats_Eval$$anon$3() {
}
$h_Lcats_Eval$$anon$3.prototype = $c_Lcats_Eval$$anon$3.prototype;
$c_Lcats_Eval$$anon$3.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$3__f_start;
});
$c_Lcats_Eval$$anon$3.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$3__f_run;
});
var $d_Lcats_Eval$$anon$3 = new $TypeData().initClass($c_Lcats_Eval$$anon$3, "cats.Eval$$anon$3", ({
  Lcats_Eval$$anon$3: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$$anon$4(f$6, outer) {
  this.Lcats_Eval$$anon$4__f_start = null;
  this.Lcats_Eval$$anon$4__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Eval$$anon$4__f_start = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => outer));
  this.Lcats_Eval$$anon$4__f_run = f$6;
}
$c_Lcats_Eval$$anon$4.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$4.prototype.constructor = $c_Lcats_Eval$$anon$4;
/** @constructor */
function $h_Lcats_Eval$$anon$4() {
}
$h_Lcats_Eval$$anon$4.prototype = $c_Lcats_Eval$$anon$4.prototype;
$c_Lcats_Eval$$anon$4.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$4__f_start;
});
$c_Lcats_Eval$$anon$4.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$4__f_run;
});
var $d_Lcats_Eval$$anon$4 = new $TypeData().initClass($c_Lcats_Eval$$anon$4, "cats.Eval$$anon$4", ({
  Lcats_Eval$$anon$4: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$$anon$5(a$2) {
  this.Lcats_Eval$Defer__f_thunk = null;
  $ct_Lcats_Eval$Defer__F0__(this, ($m_Lcats_Eval$(), a$2));
}
$c_Lcats_Eval$$anon$5.prototype = new $h_Lcats_Eval$Defer();
$c_Lcats_Eval$$anon$5.prototype.constructor = $c_Lcats_Eval$$anon$5;
/** @constructor */
function $h_Lcats_Eval$$anon$5() {
}
$h_Lcats_Eval$$anon$5.prototype = $c_Lcats_Eval$$anon$5.prototype;
var $d_Lcats_Eval$$anon$5 = new $TypeData().initClass($c_Lcats_Eval$$anon$5, "cats.Eval$$anon$5", ({
  Lcats_Eval$$anon$5: 1,
  Lcats_Eval$Defer: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
function $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O($thiz, fa, z, f, G) {
  var src = $m_Lcats_Foldable$Source$().fromFoldable__O__Lcats_Foldable__Lcats_Foldable$Source(fa, $thiz);
  return $n(G).tailRecM__O__F1__O(new $c_T2(z, src), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var b = $n(x$1$1)._1__O();
      var src$1 = $as_Lcats_Foldable$Source($n(x$1$1)._2__O());
      var x63 = $n(src$1).uncons__s_Option();
      if ((x63 instanceof $c_s_Some)) {
        var x65 = $as_T2($n($as_s_Some(x63)).s_Some__f_value);
        if ((x65 !== null)) {
          var a = $n(x65)._1__O();
          var src$2 = $as_Lcats_Eval($n(x65)._2__O());
          return $n(G).map__O__F1__O($n(f).apply__O__O__O(b, a), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b$2) => {
            var _2 = $n(src$2).value__O();
            var value = new $c_T2(b$2, _2);
            return new $c_s_util_Left(value);
          })));
        }
      }
      var x = $m_s_None$();
      if ((x === x63)) {
        return $n(G).pure__O__O(new $c_s_util_Right(b));
      }
      throw new $c_s_MatchError(x63);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $f_Lcats_Foldable__foldMapM__O__F1__Lcats_Monad__Lcats_kernel_Monoid__O($thiz, fa, f, G, B) {
  return $thiz.foldM__O__O__F2__Lcats_Monad__O(fa, $n(B).empty__O(), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((b, a) => $n(G).map__O__F1__O($n(f).apply__O__O(a), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$14) => $n(B).combine__O__O__O(b, _$14)))))), G);
}
function $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O($thiz, fa, f, G) {
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(G).unit__O()));
  return $n($thiz.foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a$1, acc) => {
    var acc$1 = $as_Lcats_Eval(acc);
    return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), acc$1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$17, _$18) => {
      $as_jl_Void(_$18);
    })));
  })))).value__O();
}
function $is_Lcats_Foldable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Foldable)));
}
function $as_Lcats_Foldable(obj) {
  return (($is_Lcats_Foldable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Foldable"));
}
function $isArrayOf_Lcats_Foldable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Foldable)));
}
function $asArrayOf_Lcats_Foldable(obj, depth) {
  return (($isArrayOf_Lcats_Foldable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Foldable;", depth));
}
/** @constructor */
function $c_Lcats_Later(f) {
  this.Lcats_Later__f_thunk = null;
  this.Lcats_Later__f_value$lzy1 = null;
  this.Lcats_Later__f_valuebitmap$1 = false;
  this.Lcats_Later__f_thunk = f;
}
$c_Lcats_Later.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Later.prototype.constructor = $c_Lcats_Later;
/** @constructor */
function $h_Lcats_Later() {
}
$h_Lcats_Later.prototype = $c_Lcats_Later.prototype;
$c_Lcats_Later.prototype.value__O = (function() {
  if ((!this.Lcats_Later__f_valuebitmap$1)) {
    var result = $n(this.Lcats_Later__f_thunk).apply__O();
    this.Lcats_Later__f_thunk = null;
    this.Lcats_Later__f_value$lzy1 = result;
    this.Lcats_Later__f_valuebitmap$1 = true;
  }
  return this.Lcats_Later__f_value$lzy1;
});
$c_Lcats_Later.prototype.memoize__Lcats_Eval = (function() {
  return this;
});
var $d_Lcats_Later = new $TypeData().initClass($c_Lcats_Later, "cats.Later", ({
  Lcats_Later: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_MonoidK$$anon$1(outer) {
  this.Lcats_MonoidK$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_MonoidK$$anon$1__f_$outer = outer;
}
$c_Lcats_MonoidK$$anon$1.prototype = new $h_O();
$c_Lcats_MonoidK$$anon$1.prototype.constructor = $c_Lcats_MonoidK$$anon$1;
/** @constructor */
function $h_Lcats_MonoidK$$anon$1() {
}
$h_Lcats_MonoidK$$anon$1.prototype = $c_Lcats_MonoidK$$anon$1.prototype;
$c_Lcats_MonoidK$$anon$1.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_MonoidK$$anon$1.prototype.empty__O = (function() {
  return $n(this.Lcats_MonoidK$$anon$1__f_$outer).empty__O();
});
$c_Lcats_MonoidK$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return $n(this.Lcats_MonoidK$$anon$1__f_$outer).combineK__O__O__O(x, y);
});
var $d_Lcats_MonoidK$$anon$1 = new $TypeData().initClass($c_Lcats_MonoidK$$anon$1, "cats.MonoidK$$anon$1", ({
  Lcats_MonoidK$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_Parallel$$anon$2(evidence$1$1) {
  this.Lcats_Parallel$$anon$2__f_sequential = null;
  this.Lcats_Parallel$$anon$2__f_parallel = null;
  this.Lcats_Parallel$$anon$2__f_sequential = new $c_Lcats_arrow_FunctionK$$anon$4();
  this.Lcats_Parallel$$anon$2__f_parallel = new $c_Lcats_arrow_FunctionK$$anon$4();
}
$c_Lcats_Parallel$$anon$2.prototype = new $h_O();
$c_Lcats_Parallel$$anon$2.prototype.constructor = $c_Lcats_Parallel$$anon$2;
/** @constructor */
function $h_Lcats_Parallel$$anon$2() {
}
$h_Lcats_Parallel$$anon$2.prototype = $c_Lcats_Parallel$$anon$2.prototype;
$c_Lcats_Parallel$$anon$2.prototype.sequential__Lcats_arrow_FunctionK = (function() {
  return this.Lcats_Parallel$$anon$2__f_sequential;
});
$c_Lcats_Parallel$$anon$2.prototype.parallel__Lcats_arrow_FunctionK = (function() {
  return this.Lcats_Parallel$$anon$2__f_parallel;
});
var $d_Lcats_Parallel$$anon$2 = new $TypeData().initClass($c_Lcats_Parallel$$anon$2, "cats.Parallel$$anon$2", ({
  Lcats_Parallel$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
}));
/** @constructor */
function $c_Lcats_Show$$anon$5() {
}
$c_Lcats_Show$$anon$5.prototype = new $h_O();
$c_Lcats_Show$$anon$5.prototype.constructor = $c_Lcats_Show$$anon$5;
/** @constructor */
function $h_Lcats_Show$$anon$5() {
}
$h_Lcats_Show$$anon$5.prototype = $c_Lcats_Show$$anon$5.prototype;
$c_Lcats_Show$$anon$5.prototype.show__O__T = (function(_$2) {
  return $dp_toString__T($n(_$2));
});
var $d_Lcats_Show$$anon$5 = new $TypeData().initClass($c_Lcats_Show$$anon$5, "cats.Show$$anon$5", ({
  Lcats_Show$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
/** @constructor */
function $c_Lcats_UnorderedFoldable$() {
  $n_Lcats_UnorderedFoldable$ = this;
  new $c_Lcats_UnorderedFoldable$$anon$1();
  new $c_Lcats_UnorderedFoldable$$anon$2();
}
$c_Lcats_UnorderedFoldable$.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$.prototype.constructor = $c_Lcats_UnorderedFoldable$;
/** @constructor */
function $h_Lcats_UnorderedFoldable$() {
}
$h_Lcats_UnorderedFoldable$.prototype = $c_Lcats_UnorderedFoldable$.prototype;
var $d_Lcats_UnorderedFoldable$ = new $TypeData().initClass($c_Lcats_UnorderedFoldable$, "cats.UnorderedFoldable$", ({
  Lcats_UnorderedFoldable$: 1,
  Lcats_ScalaVersionSpecificTraverseInstances: 1,
  Lcats_instances_NTupleUnorderedFoldableInstances: 1,
  Lcats_UnorderedFoldableLowPriority: 1
}));
var $n_Lcats_UnorderedFoldable$;
function $m_Lcats_UnorderedFoldable$() {
  if ((!$n_Lcats_UnorderedFoldable$)) {
    $n_Lcats_UnorderedFoldable$ = new $c_Lcats_UnorderedFoldable$();
  }
  return $n_Lcats_UnorderedFoldable$;
}
function $p_Lcats_data_Chain$ChainIterator__go$7__O($thiz) {
  while (true) {
    if ((($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && $n($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator).hasNext__Z())) {
      return $n($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator).next__O();
    } else {
      $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
      var x278 = $thiz.Lcats_data_Chain$ChainIterator__f_c;
      if ((x278 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x$1 = $as_Lcats_data_Chain$Singleton(x278);
        var this$2 = $n(x$1);
        var x288 = this$2.Lcats_data_Chain$Singleton__f_a;
        if ($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).isEmpty__Z()) {
          var $x_1 = null;
        } else {
          var head = $as_Lcats_data_Chain$NonEmpty($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).head__O());
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $as_sci_List($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).tail__O());
          var $x_1 = head;
        }
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $x_1;
        return x288;
      }
      if ((x278 instanceof $c_Lcats_data_Chain$Append)) {
        var x$1$1 = $as_Lcats_data_Chain$Append(x278);
        var this$4 = $n(x$1$1);
        var x284 = this$4.Lcats_data_Chain$Append__f_leftNE;
        var this$5 = $n(x$1$1);
        var x285 = this$5.Lcats_data_Chain$Append__f_rightNE;
        $thiz.Lcats_data_Chain$ChainIterator__f_c = x284;
        var this$6 = $n($thiz.Lcats_data_Chain$ChainIterator__f_rights);
        $thiz.Lcats_data_Chain$ChainIterator__f_rights = new $c_sci_$colon$colon(x285, this$6);
        continue;
      }
      if ((x278 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x$1$2 = $as_Lcats_data_Chain$Wrap(x278);
        var this$8 = $n(x$1$2);
        var x281 = this$8.Lcats_data_Chain$Wrap__f_seq;
        if ($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).isEmpty__Z()) {
          var $x_2 = null;
        } else {
          var head$2 = $as_Lcats_data_Chain$NonEmpty($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).head__O());
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $as_sci_List($n($thiz.Lcats_data_Chain$ChainIterator__f_rights).tail__O());
          var $x_2 = head$2;
        }
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $x_2;
        $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = $n(x281).iterator__sc_Iterator();
        return $n($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator).next__O();
      }
      if ((x278 === null)) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next called on empty iterator");
      }
      throw new $c_s_MatchError(x278);
    }
  }
}
/** @constructor */
function $c_Lcats_data_Chain$ChainIterator(self) {
  this.Lcats_data_Chain$ChainIterator__f_c = null;
  this.Lcats_data_Chain$ChainIterator__f_rights = null;
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
  this.Lcats_data_Chain$ChainIterator__f_c = self;
  this.Lcats_data_Chain$ChainIterator__f_rights = $m_sci_Nil$();
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
}
$c_Lcats_data_Chain$ChainIterator.prototype = new $h_O();
$c_Lcats_data_Chain$ChainIterator.prototype.constructor = $c_Lcats_data_Chain$ChainIterator;
/** @constructor */
function $h_Lcats_data_Chain$ChainIterator() {
}
$h_Lcats_data_Chain$ChainIterator.prototype = $c_Lcats_data_Chain$ChainIterator.prototype;
$c_Lcats_data_Chain$ChainIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lcats_data_Chain$ChainIterator.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lcats_data_Chain$ChainIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lcats_data_Chain$ChainIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lcats_data_Chain$ChainIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lcats_data_Chain$ChainIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lcats_data_Chain$ChainIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lcats_data_Chain$ChainIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lcats_data_Chain$ChainIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lcats_data_Chain$ChainIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lcats_data_Chain$ChainIterator.prototype.hasNext__Z = (function() {
  return ((this.Lcats_data_Chain$ChainIterator__f_c !== null) || ((this.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && $n(this.Lcats_data_Chain$ChainIterator__f_currentIterator).hasNext__Z()));
});
$c_Lcats_data_Chain$ChainIterator.prototype.next__O = (function() {
  return $p_Lcats_data_Chain$ChainIterator__go$7__O(this);
});
var $d_Lcats_data_Chain$ChainIterator = new $TypeData().initClass($c_Lcats_data_Chain$ChainIterator, "cats.data.Chain$ChainIterator", ({
  Lcats_data_Chain$ChainIterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
function $ct_Lcats_data_ChainInstances__($thiz) {
  $thiz.Lcats_data_ChainInstances__f_catsDataInstancesForChain = new $c_Lcats_data_ChainInstances$$anon$3();
  return $thiz;
}
function $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval(f$18, lb$1, as) {
  var x305 = $n(as).uncons__s_Option();
  if ((x305 instanceof $c_s_Some)) {
    var x307 = $as_T2($n($as_s_Some(x305)).s_Some__f_value);
    if ((x307 !== null)) {
      var h = $n(x307)._1__O();
      var t = $as_Lcats_data_Chain($n(x307)._2__O());
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval(f$18, lb$1, t)));
      return $as_Lcats_Eval($n(f$18).apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a)));
    }
  }
  var x = $m_s_None$();
  if ((x === x305)) {
    return lb$1;
  }
  throw new $c_s_MatchError(x305);
}
function $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$10__F1__Lcats_Applicative__Lcats_data_Chain$NonEmpty__Lcats_data_Chain__O__O(f$22, G$13, fa, rhs, acc) {
  var acc$tailLocal4 = acc;
  var rhs$tailLocal4 = rhs;
  var fa$tailLocal1 = fa;
  while (true) {
    var x321 = fa$tailLocal1;
    if ((x321 instanceof $c_Lcats_data_Chain$Append)) {
      var x$1 = $as_Lcats_data_Chain$Append(x321);
      var this$2 = $n(x$1);
      var x330 = this$2.Lcats_data_Chain$Append__f_leftNE;
      var this$3 = $n(x$1);
      var x331 = this$3.Lcats_data_Chain$Append__f_rightNE;
      if ($n(rhs$tailLocal4).isEmpty__Z()) {
        var rhs$tailLocal4$tmp1 = x331;
      } else {
        var right = rhs$tailLocal4;
        var rhs$tailLocal4$tmp1 = $ct_Lcats_data_Chain$Append__Lcats_data_Chain__Lcats_data_Chain__(new $c_Lcats_data_Chain$Append(), x331, right);
      }
      fa$tailLocal1 = x330;
      rhs$tailLocal4 = rhs$tailLocal4$tmp1;
      continue;
    }
    if ((x321 instanceof $c_Lcats_data_Chain$Wrap)) {
      var x$1$1 = $as_Lcats_data_Chain$Wrap(x321);
      var this$6 = $n(x$1$1);
      var x327 = this$6.Lcats_data_Chain$Wrap__f_seq;
      $m_Lcats_UnorderedFoldable$();
      var instance = $as_Lcats_Traverse($m_Lcats_instances_package$seq$().Lcats_instances_package$seq$__f_catsStdInstancesForSeq);
      var va = $n(instance).traverseVoid__O__F1__Lcats_Applicative__O(x327, f$22, G$13);
      var acc1 = $n(G$13).productL__O__O__O(acc$tailLocal4, va);
      var x317 = rhs$tailLocal4;
      var x = $m_Lcats_data_Chain$Empty$();
      if (x.equals__O__Z(x317)) {
        return acc1;
      }
      if ((x317 instanceof $c_Lcats_data_Chain$NonEmpty)) {
        var ne = $as_Lcats_data_Chain$NonEmpty(x317);
        var rhs$tailLocal4$tmp2 = $m_Lcats_data_Chain$Empty$();
        fa$tailLocal1 = ne;
        rhs$tailLocal4 = rhs$tailLocal4$tmp2;
        acc$tailLocal4 = acc1;
        continue;
      }
      throw new $c_s_MatchError(x317);
    }
    if ((x321 instanceof $c_Lcats_data_Chain$Singleton)) {
      var x$1$2 = $as_Lcats_data_Chain$Singleton(x321);
      var this$10 = $n(x$1$2);
      var x324 = this$10.Lcats_data_Chain$Singleton__f_a;
      var acc1$2 = $n(G$13).productL__O__O__O(acc$tailLocal4, $n(f$22).apply__O__O(x324));
      var x319 = rhs$tailLocal4;
      var x$3 = $m_Lcats_data_Chain$Empty$();
      if (x$3.equals__O__Z(x319)) {
        return acc1$2;
      }
      if ((x319 instanceof $c_Lcats_data_Chain$NonEmpty)) {
        var ne$2 = $as_Lcats_data_Chain$NonEmpty(x319);
        var rhs$tailLocal4$tmp3 = $m_Lcats_data_Chain$Empty$();
        fa$tailLocal1 = ne$2;
        rhs$tailLocal4 = rhs$tailLocal4$tmp3;
        acc$tailLocal4 = acc1$2;
        continue;
      }
      throw new $c_s_MatchError(x319);
    }
    throw new $c_s_MatchError(x321);
  }
}
function $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$11__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f$23, rest, acc) {
  var acc$tailLocal5 = acc;
  var rest$tailLocal1 = rest;
  while (true) {
    var x346 = rest$tailLocal1;
    if ((x346 instanceof $c_sci_$colon$colon)) {
      var x347 = $as_sci_$colon$colon(x346);
      var x349 = $n(x347).sci_$colon$colon__f_next;
      var hd = $as_Lcats_data_Chain($n(x347).sci_$colon$colon__f_head);
      var x341 = $n(hd).uncons__s_Option();
      if ((x341 instanceof $c_s_Some)) {
        var x343 = $as_T2($n($as_s_Some(x341)).s_Some__f_value);
        if ((x343 !== null)) {
          var hdh = $as_s_util_Either($n(x343)._1__O());
          var hdt = $as_Lcats_data_Chain($n(x343)._2__O());
          if ((hdh instanceof $c_s_util_Right)) {
            var b = $n($as_s_util_Right(hdh)).s_util_Right__f_value;
            var this$1 = $n(x349);
            var rest$tailLocal1$tmp1 = new $c_sci_$colon$colon(hdt, this$1);
            var this$2 = $n(acc$tailLocal5);
            var acc$tailLocal5$tmp1 = this$2.append__O__Lcats_data_Chain(b);
            rest$tailLocal1 = rest$tailLocal1$tmp1;
            acc$tailLocal5 = acc$tailLocal5$tmp1;
            continue;
          }
          if ((hdh instanceof $c_s_util_Left)) {
            var a = $n($as_s_util_Left(hdh)).s_util_Left__f_value;
            var elem$3 = $as_Lcats_data_Chain($n(f$23).apply__O__O(a));
            var this$3 = $n(x349);
            var this$4 = new $c_sci_$colon$colon(hdt, this$3);
            rest$tailLocal1 = new $c_sci_$colon$colon(elem$3, this$4);
            continue;
          }
          throw new $c_s_MatchError(hdh);
        }
      }
      var x = $m_s_None$();
      if ((x === x341)) {
        rest$tailLocal1 = x349;
        continue;
      }
      throw new $c_s_MatchError(x341);
    }
    return acc$tailLocal5;
  }
}
/** @constructor */
function $c_Lcats_data_ChainInstances() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
}
$c_Lcats_data_ChainInstances.prototype = new $h_Lcats_data_ChainInstances1();
$c_Lcats_data_ChainInstances.prototype.constructor = $c_Lcats_data_ChainInstances;
/** @constructor */
function $h_Lcats_data_ChainInstances() {
}
$h_Lcats_data_ChainInstances.prototype = $c_Lcats_data_ChainInstances.prototype;
/** @constructor */
function $c_Lcats_data_Kleisli(run) {
  this.Lcats_data_Kleisli__f_run = null;
  this.Lcats_data_Kleisli__f_run = run;
}
$c_Lcats_data_Kleisli.prototype = new $h_O();
$c_Lcats_data_Kleisli.prototype.constructor = $c_Lcats_data_Kleisli;
/** @constructor */
function $h_Lcats_data_Kleisli() {
}
$h_Lcats_data_Kleisli.prototype = $c_Lcats_data_Kleisli.prototype;
$c_Lcats_data_Kleisli.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Kleisli.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_Kleisli.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_Kleisli)) {
    var x$0$2 = $as_Lcats_data_Kleisli(x$0);
    var x = this.Lcats_data_Kleisli__f_run;
    var x$2 = $n(x$0$2).Lcats_data_Kleisli__f_run;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_data_Kleisli.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_Kleisli.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Kleisli.prototype.productPrefix__T = (function() {
  return "Kleisli";
});
$c_Lcats_data_Kleisli.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Kleisli__f_run;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Kleisli.prototype.map__F1__Lcats_Functor__Lcats_data_Kleisli = (function(f, F) {
  return this.mapF__F1__Lcats_data_Kleisli(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => $n(F).map__O__F1__O(_$3, f))));
});
$c_Lcats_data_Kleisli.prototype.mapF__F1__Lcats_data_Kleisli = (function(f) {
  $m_Lcats_data_Kleisli$();
  var run = $n(this.Lcats_data_Kleisli__f_run).andThen__F1__F1(f);
  return new $c_Lcats_data_Kleisli(run);
});
$c_Lcats_data_Kleisli.prototype.flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli = (function(f, F) {
  var x5 = this.Lcats_data_Kleisli__f_run;
  if ((x5 instanceof $c_Lcats_data_StrictConstFunction1)) {
    var x$1 = $as_Lcats_data_StrictConstFunction1(x5);
    var this$2 = $n(x$1);
    var x8 = this$2.Lcats_data_StrictConstFunction1__f_a;
    $m_Lcats_data_Kleisli$();
    var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n(F).flatMap__O__F1__O(x8, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$7) => $n($n($as_Lcats_data_Kleisli($n(f).apply__O__O(_$7))).Lcats_data_Kleisli__f_run).apply__O__O(a))))));
    return new $c_Lcats_data_Kleisli(run);
  }
  return $m_Lcats_data_Kleisli$().shift__F1__Lcats_FlatMap__Lcats_data_Kleisli(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a$2) => $n(F).flatMap__O__F1__O($n(this.Lcats_data_Kleisli__f_run).apply__O__O(a$2), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => $n($n($as_Lcats_data_Kleisli($n(f).apply__O__O(_$8))).Lcats_data_Kleisli__f_run).apply__O__O(a$2)))))), F);
});
function $as_Lcats_data_Kleisli(obj) {
  return (((obj instanceof $c_Lcats_data_Kleisli) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Kleisli"));
}
function $isArrayOf_Lcats_data_Kleisli(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Kleisli)));
}
function $asArrayOf_Lcats_data_Kleisli(obj, depth) {
  return (($isArrayOf_Lcats_data_Kleisli(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Kleisli;", depth));
}
var $d_Lcats_data_Kleisli = new $TypeData().initClass($c_Lcats_data_Kleisli, "cats.data.Kleisli", ({
  Lcats_data_Kleisli: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $f_Lcats_data_KleisliFunctor__void__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa) {
  $m_Lcats_data_Kleisli$();
  var $x_1 = $n($n(fa).Lcats_data_Kleisli__f_run);
  var \u03b41$ = $thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  var run = $x_1.andThen__F1__F1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fa$2) => $n(\u03b41$).void__O__O(fa$2))));
  return new $c_Lcats_data_Kleisli(run);
}
/** @constructor */
function $c_Lcats_data_KleisliInstances6() {
}
$c_Lcats_data_KleisliInstances6.prototype = new $h_Lcats_data_KleisliInstances7();
$c_Lcats_data_KleisliInstances6.prototype.constructor = $c_Lcats_data_KleisliInstances6;
/** @constructor */
function $h_Lcats_data_KleisliInstances6() {
}
$h_Lcats_data_KleisliInstances6.prototype = $c_Lcats_data_KleisliInstances6.prototype;
/** @constructor */
function $c_Lcats_data_OptionT(value) {
  this.Lcats_data_OptionT__f_value = null;
  this.Lcats_data_OptionT__f_value = value;
}
$c_Lcats_data_OptionT.prototype = new $h_O();
$c_Lcats_data_OptionT.prototype.constructor = $c_Lcats_data_OptionT;
/** @constructor */
function $h_Lcats_data_OptionT() {
}
$h_Lcats_data_OptionT.prototype = $c_Lcats_data_OptionT.prototype;
$c_Lcats_data_OptionT.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_OptionT.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_OptionT.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_OptionT)) {
    var x$0$2 = $as_Lcats_data_OptionT(x$0);
    var x = this.Lcats_data_OptionT__f_value;
    var y = $n(x$0$2).Lcats_data_OptionT__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_OptionT.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_OptionT.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_OptionT.prototype.productPrefix__T = (function() {
  return "OptionT";
});
$c_Lcats_data_OptionT.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_OptionT__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_OptionT.prototype.collect__s_PartialFunction__Lcats_Functor__Lcats_data_OptionT = (function(f, F) {
  var value = $n(F).map__O__F1__O(this.Lcats_data_OptionT__f_value, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$15) => {
    var _$15$1 = $as_s_Option(_$15);
    var this$1 = $n(_$15$1);
    return ((!this$1.isEmpty__Z()) ? $as_s_Option($n($n(f).lift__F1()).apply__O__O(this$1.get__O())) : $m_s_None$());
  })));
  return new $c_Lcats_data_OptionT(value);
});
$c_Lcats_data_OptionT.prototype.orElseF__F0__Lcats_Monad__Lcats_data_OptionT = (function(default$1, F) {
  var value = $n(F).flatMap__O__F1__O(this.Lcats_data_OptionT__f_value, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var s = $as_s_Some(x$1$1);
      return $n(F).pure__O__O(s);
    }
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return $n(default$1).apply__O();
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  return new $c_Lcats_data_OptionT(value);
});
function $as_Lcats_data_OptionT(obj) {
  return (((obj instanceof $c_Lcats_data_OptionT) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.OptionT"));
}
function $isArrayOf_Lcats_data_OptionT(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_OptionT)));
}
function $asArrayOf_Lcats_data_OptionT(obj, depth) {
  return (($isArrayOf_Lcats_data_OptionT(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.OptionT;", depth));
}
var $d_Lcats_data_OptionT = new $TypeData().initClass($c_Lcats_data_OptionT, "cats.data.OptionT", ({
  Lcats_data_OptionT: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_Validated() {
}
$c_Lcats_data_Validated.prototype = new $h_O();
$c_Lcats_data_Validated.prototype.constructor = $c_Lcats_data_Validated;
/** @constructor */
function $h_Lcats_data_Validated() {
}
$h_Lcats_data_Validated.prototype = $c_Lcats_data_Validated.prototype;
$c_Lcats_data_Validated.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lcats_effect_IOFiber$$anon$1(id$2, outer) {
  this.Lcats_effect_IOFiber$$anon$1__f_id$1 = 0;
  this.Lcats_effect_IOFiber$$anon$1__f_$outer = null;
  this.Lcats_effect_IOFiber$$anon$1__f_id$1 = id$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_IOFiber$$anon$1__f_$outer = outer;
}
$c_Lcats_effect_IOFiber$$anon$1.prototype = new $h_O();
$c_Lcats_effect_IOFiber$$anon$1.prototype.constructor = $c_Lcats_effect_IOFiber$$anon$1;
/** @constructor */
function $h_Lcats_effect_IOFiber$$anon$1() {
}
$h_Lcats_effect_IOFiber$$anon$1.prototype = $c_Lcats_effect_IOFiber$$anon$1.prototype;
$c_Lcats_effect_IOFiber$$anon$1.prototype.apply__Lcats_effect_IO__Lcats_effect_IO = (function(ioa) {
  var id = this.Lcats_effect_IOFiber$$anon$1__f_id$1;
  var self = this.Lcats_effect_IOFiber$$anon$1__f_$outer;
  return new $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(ioa, id, self);
});
$c_Lcats_effect_IOFiber$$anon$1.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_IO__Lcats_effect_IO($as_Lcats_effect_IO(fa));
});
var $d_Lcats_effect_IOFiber$$anon$1 = new $TypeData().initClass($c_Lcats_effect_IOFiber$$anon$1, "cats.effect.IOFiber$$anon$1", ({
  Lcats_effect_IOFiber$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
function $f_Lcats_effect_kernel_Clock$KleisliClock__realTime__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.C__Lcats_effect_kernel_Clock()).realTime__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
/** @constructor */
function $c_Lcats_effect_kernel_Deferred() {
}
$c_Lcats_effect_kernel_Deferred.prototype = new $h_O();
$c_Lcats_effect_kernel_Deferred.prototype.constructor = $c_Lcats_effect_kernel_Deferred;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred() {
}
$h_Lcats_effect_kernel_Deferred.prototype = $c_Lcats_effect_kernel_Deferred.prototype;
function $as_Lcats_effect_kernel_Deferred(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Deferred) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Deferred"));
}
function $isArrayOf_Lcats_effect_kernel_Deferred(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Deferred)));
}
function $asArrayOf_Lcats_effect_kernel_Deferred(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Deferred(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Deferred;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13(nat$9) {
  this.Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13__f_nat$4 = null;
  this.Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13__f_nat$4 = nat$9;
}
$c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13() {
}
$h_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype = $c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype;
$c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype.apply__Lcats_data_Kleisli__Lcats_data_Kleisli = (function(stfa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n(this.Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13__f_nat$4).apply__O__O($n($n(stfa).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
});
$c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_data_Kleisli__Lcats_data_Kleisli($as_Lcats_data_Kleisli(fa));
});
var $d_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13, "cats.effect.kernel.MonadCancel$KleisliMonadCancel$$anon$13", ({
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9() {
}
$c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9() {
}
$h_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype = $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype;
$c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype.apply__O__O = (function(fa) {
  return fa;
});
var $d_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9, "cats.effect.kernel.MonadCancel$Uncancelable$$anon$9", ({
  Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
function $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O($thiz, onCancel, F) {
  if ((($thiz instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled($thiz), true))) {
    return onCancel;
  }
  if (($thiz instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$1 = $as_Lcats_effect_kernel_Outcome$Errored($thiz);
    var this$2 = $n(x$1);
    var x7 = this$2.Lcats_effect_kernel_Outcome$Errored__f_e;
    return $n(F).raiseError__O__O(x7);
  }
  if (($thiz instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded($thiz);
    var this$4 = $n(x$1$1);
    var x4 = this$4.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    return x4;
  }
  throw new $c_s_MatchError($thiz);
}
function $f_Lcats_effect_kernel_Outcome__mapK__Lcats_arrow_FunctionK__Lcats_effect_kernel_Outcome($thiz, f) {
  if ((($thiz instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled($thiz), true))) {
    return new $c_Lcats_effect_kernel_Outcome$Canceled();
  }
  if (($thiz instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$1 = $as_Lcats_effect_kernel_Outcome$Errored($thiz);
    var this$3 = $n(x$1);
    var x15 = this$3.Lcats_effect_kernel_Outcome$Errored__f_e;
    return new $c_Lcats_effect_kernel_Outcome$Errored(x15);
  }
  if (($thiz instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded($thiz);
    var this$6 = $n(x$1$1);
    var x12 = this$6.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    var fa = $n(f).apply__O__O(x12);
    return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa);
  }
  throw new $c_s_MatchError($thiz);
}
function $is_Lcats_effect_kernel_Outcome(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Outcome)));
}
function $as_Lcats_effect_kernel_Outcome(obj) {
  return (($is_Lcats_effect_kernel_Outcome(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome"));
}
function $isArrayOf_Lcats_effect_kernel_Outcome(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome)));
}
function $asArrayOf_Lcats_effect_kernel_Outcome(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Ref() {
}
$c_Lcats_effect_kernel_Ref.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref.prototype.constructor = $c_Lcats_effect_kernel_Ref;
/** @constructor */
function $h_Lcats_effect_kernel_Ref() {
}
$h_Lcats_effect_kernel_Ref.prototype = $c_Lcats_effect_kernel_Ref.prototype;
$c_Lcats_effect_kernel_Ref.prototype.flatModify__F1__Lcats_effect_kernel_MonadCancel__O = (function(f, F) {
  return $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
    $as_Lcats_effect_kernel_Poll(_$3);
    return $f_Lcats_FlatMap__flatten__O__O($n(F), this.modify__F1__O(f));
  })));
});
function $as_Lcats_effect_kernel_Ref(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Ref) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Ref"));
}
function $isArrayOf_Lcats_effect_kernel_Ref(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Ref)));
}
function $asArrayOf_Lcats_effect_kernel_Ref(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Ref(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Ref;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$6(poll$6, F$106) {
  this.Lcats_effect_kernel_Resource$$anon$6__f_poll$5 = null;
  this.Lcats_effect_kernel_Resource$$anon$6__f_F$91 = null;
  this.Lcats_effect_kernel_Resource$$anon$6__f_poll$5 = poll$6;
  this.Lcats_effect_kernel_Resource$$anon$6__f_F$91 = F$106;
}
$c_Lcats_effect_kernel_Resource$$anon$6.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$6;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$6() {
}
$h_Lcats_effect_kernel_Resource$$anon$6.prototype = $c_Lcats_effect_kernel_Resource$$anon$6.prototype;
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.apply__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource = (function(rfb) {
  var resource = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((innerPoll) => {
    var innerPoll$1 = $as_Lcats_effect_kernel_Poll(innerPoll);
    return $n(innerPoll$1).apply__O__O($n(this.Lcats_effect_kernel_Resource$$anon$6__f_poll$5).apply__O__O($n(rfb).allocatedCase__Lcats_effect_kernel_MonadCancel__O(this.Lcats_effect_kernel_Resource$$anon$6__f_F$91)));
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource($as_Lcats_effect_kernel_Resource(fa));
});
var $d_Lcats_effect_kernel_Resource$$anon$6 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$6, "cats.effect.kernel.Resource$$anon$6", ({
  Lcats_effect_kernel_Resource$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
function $is_Lcats_effect_kernel_Resource$ExitCase(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Resource$ExitCase)));
}
function $as_Lcats_effect_kernel_Resource$ExitCase(obj) {
  return (($is_Lcats_effect_kernel_Resource$ExitCase(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$ExitCase"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$ExitCase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$ExitCase)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$ExitCase(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$ExitCase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$ExitCase;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$State$1(outer, fin, finalizeOnComplete, confirmedFinalizeOnComplete) {
  this.Lcats_effect_kernel_Resource$State$1__f_fin = null;
  this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete = false;
  this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete = false;
  this.Lcats_effect_kernel_Resource$State$1__f_$outer = null;
  this.Lcats_effect_kernel_Resource$State$1__f_fin = fin;
  this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete = finalizeOnComplete;
  this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete = confirmedFinalizeOnComplete;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_Resource$State$1__f_$outer = outer;
}
$c_Lcats_effect_kernel_Resource$State$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$State$1.prototype.constructor = $c_Lcats_effect_kernel_Resource$State$1;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$State$1() {
}
$h_Lcats_effect_kernel_Resource$State$1.prototype = $c_Lcats_effect_kernel_Resource$State$1.prototype;
$c_Lcats_effect_kernel_Resource$State$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_kernel_Resource$State$1__f_fin;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$State$1)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$State$1(x$0);
    if (((this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete === $n(x$0$2).Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete) && (this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete === $n(x$0$2).Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete))) {
      var x = this.Lcats_effect_kernel_Resource$State$1__f_fin;
      var y = $n(x$0$2).Lcats_effect_kernel_Resource$State$1__f_fin;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_kernel_Resource$State$1__f_fin;
      break;
    }
    case 1: {
      return this.Lcats_effect_kernel_Resource$State$1__f_finalizeOnComplete;
      break;
    }
    case 2: {
      return this.Lcats_effect_kernel_Resource$State$1__f_confirmedFinalizeOnComplete;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_kernel_Resource$State$1.prototype.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$1 = (function(fin, finalizeOnComplete, confirmedFinalizeOnComplete) {
  return new $c_Lcats_effect_kernel_Resource$State$1(this.Lcats_effect_kernel_Resource$State$1__f_$outer, fin, finalizeOnComplete, confirmedFinalizeOnComplete);
});
function $as_Lcats_effect_kernel_Resource$State$1(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$State$1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$State$1"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$State$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$State$1)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$State$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$State$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$State$1;", depth));
}
var $d_Lcats_effect_kernel_Resource$State$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$State$1, "cats.effect.kernel.Resource$State$1", ({
  Lcats_effect_kernel_Resource$State$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M$2, outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1() {
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.sequential__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2();
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.parallel__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$3();
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1, "cats.effect.kernel.instances.GenSpawnInstances$$anon$1", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
}));
function $is_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$1)));
}
function $as_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj) {
  return (($is_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor$TaskState$1"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$1)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor$TaskState$1;", depth));
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState() {
}
$c_Lcats_effect_std_Dispatcher$RegState.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$RegState.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState() {
}
$h_Lcats_effect_std_Dispatcher$RegState.prototype = $c_Lcats_effect_std_Dispatcher$RegState.prototype;
$c_Lcats_effect_std_Dispatcher$RegState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $as_Lcats_effect_std_Dispatcher$RegState(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$RegState) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$RegState"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$RegState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$RegState)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$RegState(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$RegState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$RegState;", depth));
}
function $ct_Lcats_effect_std_Queue$AbstractQueue__I__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__($thiz, capacity, state, F) {
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_capacity = capacity;
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_state = state;
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_F = F;
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_take = $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(F).deferred__O();
    var this$63 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, F);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((taker) => {
      var taker$1 = $as_Lcats_effect_kernel_Deferred(taker);
      var modificationF = $n(state).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Queue$State(x$1);
        if ((x$1$1 !== null)) {
          var this$4 = $n(x$1$1);
          var x124 = this$4.Lcats_effect_std_Queue$State__f_queue;
          var this$5 = $n(x$1$1);
          var x125 = this$5.Lcats_effect_std_Queue$State__f_size;
          var this$6 = $n(x$1$1);
          var x126 = this$6.Lcats_effect_std_Queue$State__f_takers;
          var this$7 = $n(x$1$1);
          var x127 = this$7.Lcats_effect_std_Queue$State__f_offerers;
          var this$8 = $n(x124);
          if (((!this$8.isEmpty__Z()) && $n(x127).isEmpty__Z())) {
            matchResult25: {
              var \u03b49$___1;
              var \u03b49$___2;
              var x97 = $n(x124).dequeue__T2();
              if ((x97 !== null)) {
                var a = $n(x97)._1__O();
                var rest = $as_sci_Queue($n(x97)._2__O());
                var \u03b49$___1 = a;
                var \u03b49$___2 = rest;
                break matchResult25;
              }
              throw new $c_s_MatchError(x97);
            }
            var a$2 = \u03b49$___1;
            var rest$2 = $as_sci_Queue(\u03b49$___2);
            var size = ((x125 - 1) | 0);
            var self = new $c_Lcats_effect_std_Queue$State(rest$2, size, x126, x127);
            var y = $n(F).pure__O__O(a$2);
            return new $c_T2(self, y);
          }
          var this$13 = $n(x124);
          if ((!this$13.isEmpty__Z())) {
            matchResult26: {
              var \u03b410$___1;
              var \u03b410$___2;
              var x100 = $n(x124).dequeue__T2();
              if ((x100 !== null)) {
                var a$3 = $n(x100)._1__O();
                var rest$3 = $as_sci_Queue($n(x100)._2__O());
                var \u03b410$___1 = a$3;
                var \u03b410$___2 = rest$3;
                break matchResult26;
              }
              throw new $c_s_MatchError(x100);
            }
            var a$4 = \u03b410$___1;
            var rest$4 = $as_sci_Queue(\u03b410$___2);
            if ((((x125 - 1) | 0) < capacity)) {
              matchResult27: {
                var \u03b411$___1;
                var \u03b411$___2;
                var x103 = $n(x127).dequeue__T2();
                if ((x103 !== null)) {
                  var release = $as_Lcats_effect_kernel_Deferred($n(x103)._1__O());
                  var tail = $as_sci_Queue($n(x103)._2__O());
                  var \u03b411$___1 = release;
                  var \u03b411$___2 = tail;
                  break matchResult27;
                }
                throw new $c_s_MatchError(x103);
              }
              var release$2 = $as_Lcats_effect_kernel_Deferred(\u03b411$___1);
              var tail$2 = $as_sci_Queue(\u03b411$___2);
              var size$1 = ((x125 - 1) | 0);
              var self$1 = new $c_Lcats_effect_std_Queue$State(rest$4, size$1, x126, tail$2);
              var target$1 = $n(release$2).complete__O__O((void 0));
              var this$19 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, F);
              var y$1 = $n(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_self, a$4);
              return new $c_T2(self$1, y$1);
            } else {
              var size$2 = ((x125 - 1) | 0);
              var self$2 = new $c_Lcats_effect_std_Queue$State(rest$4, size$2, x126, x127);
              var y$2 = $n(F).pure__O__O(a$4);
              return new $c_T2(self$2, y$2);
            }
          }
          var cleanup = $n(state).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => {
            var s$1 = $as_Lcats_effect_std_Queue$State(s);
            var this$24 = $n($n(s$1).Lcats_effect_std_Queue$State__f_takers);
            var b = $m_sci_Queue$().newBuilder__scm_Builder();
            var it = this$24.iterator__sc_Iterator();
            while ($n(it).hasNext__Z()) {
              var elem = $n(it).next__O();
              var _$26 = $as_Lcats_effect_kernel_Deferred(elem);
              if (((_$26 !== taker$1) !== false)) {
                var this$25 = $n(b);
                this$25.addOne__O__scm_Growable(elem);
              }
            }
            var takers2 = $as_sci_Queue($n(b).result__O());
            if ($n(takers2).isEmpty__Z()) {
              $n(s$1);
              var this$26 = $n(s$1);
              var queue = this$26.Lcats_effect_std_Queue$State__f_queue;
              var this$27 = $n(s$1);
              var size$3 = this$27.Lcats_effect_std_Queue$State__f_size;
              var this$28 = $n(s$1);
              var offerers = this$28.Lcats_effect_std_Queue$State__f_offerers;
              var self$3 = new $c_Lcats_effect_std_Queue$State(queue, size$3, takers2, offerers);
              var y$3 = $n(F).unit__O();
              return new $c_T2(self$3, y$3);
            } else {
              matchResult28: {
                var \u03b413$___1;
                var \u03b413$___2;
                var x106 = $n(takers2).dequeue__T2();
                if ((x106 !== null)) {
                  var taker$2 = $as_Lcats_effect_kernel_Deferred($n(x106)._1__O());
                  var rest$1 = $as_sci_Queue($n(x106)._2__O());
                  var \u03b413$___1 = taker$2;
                  var \u03b413$___2 = rest$1;
                  break matchResult28;
                }
                throw new $c_s_MatchError(x106);
              }
              var taker$2$1 = $as_Lcats_effect_kernel_Deferred(\u03b413$___1);
              var rest$2$1 = $as_sci_Queue(\u03b413$___2);
              $n(s$1);
              var this$33 = $n(s$1);
              var queue$1 = this$33.Lcats_effect_std_Queue$State__f_queue;
              var this$34 = $n(s$1);
              var size$4 = this$34.Lcats_effect_std_Queue$State__f_size;
              var this$35 = $n(s$1);
              var offerers$1 = this$35.Lcats_effect_std_Queue$State__f_offerers;
              var self$4 = new $c_Lcats_effect_std_Queue$State(queue$1, size$4, rest$2$1, offerers$1);
              var target$2 = $n(taker$2$1).complete__O__O((void 0));
              var this$39 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, F);
              var y$4 = $n(this$39.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$39.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
              return new $c_T2(self$4, y$4);
            }
          })));
          var wrapped = $n(poll$1).apply__O__O($n(taker$1).get__O());
          var fin = $f_Lcats_FlatMap__flatten__O__O($n(F), cleanup);
          var fa = $n(F).onCancel__O__O__O(wrapped, fin);
          var wrapped$1 = $n(poll$1).apply__O__O($thiz.Lcats_effect_std_Queue$AbstractQueue__f_take);
          var ffa = $thiz.Lcats_effect_std_Queue$AbstractQueue__f_notifyNextTaker;
          var fin$1 = $f_Lcats_FlatMap__flatten__O__O($n(F), ffa);
          var fb = $n(F).onCancel__O__O__O(wrapped$1, fin$1);
          var this$51 = $n(F);
          var await$1 = this$51.productR__O__O__O(fa, fb);
          if ($n(x127).isEmpty__Z()) {
            var \u03b412$___1 = await$1;
            var \u03b412$___2 = x127;
          } else {
            matchResult29: {
              var \u03b415$___1;
              var \u03b415$___2;
              var x109 = $n(x127).dequeue__T2();
              if ((x109 !== null)) {
                var release$3 = $as_Lcats_effect_kernel_Deferred($n(x109)._1__O());
                var rest$5 = $as_sci_Queue($n(x109)._2__O());
                var \u03b415$___1 = release$3;
                var \u03b415$___2 = rest$5;
                break matchResult29;
              }
              throw new $c_s_MatchError(x109);
            }
            var release$4 = $as_Lcats_effect_kernel_Deferred(\u03b415$___1);
            var rest$6 = $as_sci_Queue(\u03b415$___2);
            var fa$1 = $n(release$4).complete__O__O((void 0));
            var this$56 = $n(F);
            var _1 = this$56.productR__O__O__O(fa$1, await$1);
            var \u03b412$___1 = _1;
            var \u03b412$___2 = rest$6;
          }
          var fulfill = \u03b412$___1;
          var offerers2 = $as_sci_Queue(\u03b412$___2);
          var takers = $n(x126).enqueue__O__sci_Queue(taker$1);
          var self$5 = new $c_Lcats_effect_std_Queue$State(x124, x125, takers, offerers2);
          return new $c_T2(self$5, fulfill);
        }
        throw new $c_s_MatchError(x$1$1);
      })));
      return $f_Lcats_FlatMap__flatten__O__O($n(F), modificationF);
    }));
    return $n(this$63.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$63.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })));
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_tryTake = $n(state).flatModify__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
    var x$1$3 = $as_Lcats_effect_std_Queue$State(x$1$2);
    if ((x$1$3 !== null)) {
      var this$65 = $n(x$1$3);
      var x144 = this$65.Lcats_effect_std_Queue$State__f_queue;
      var this$66 = $n(x$1$3);
      var x145 = this$66.Lcats_effect_std_Queue$State__f_size;
      var this$67 = $n(x$1$3);
      var x146 = this$67.Lcats_effect_std_Queue$State__f_takers;
      var this$68 = $n(x$1$3);
      var x147 = this$68.Lcats_effect_std_Queue$State__f_offerers;
      var this$69 = $n(x144);
      if (((!this$69.isEmpty__Z()) && $n(x147).isEmpty__Z())) {
        matchResult31: {
          var \u03b416$___1;
          var \u03b416$___2;
          var x128 = $n(x144).dequeue__T2();
          if ((x128 !== null)) {
            var a$1 = $n(x128)._1__O();
            var rest$7 = $as_sci_Queue($n(x128)._2__O());
            var \u03b416$___1 = a$1;
            var \u03b416$___2 = rest$7;
            break matchResult31;
          }
          throw new $c_s_MatchError(x128);
        }
        var a$2$1 = \u03b416$___1;
        var rest$2$2 = $as_sci_Queue(\u03b416$___2);
        var size$5 = ((x145 - 1) | 0);
        var self$6 = new $c_Lcats_effect_std_Queue$State(rest$2$2, size$5, x146, x147);
        var y$5 = $n(F).pure__O__O(new $c_s_Some(a$2$1));
        return new $c_T2(self$6, y$5);
      }
      var this$77 = $n(x144);
      if ((!this$77.isEmpty__Z())) {
        matchResult32: {
          var \u03b417$___1;
          var \u03b417$___2;
          var x131 = $n(x144).dequeue__T2();
          if ((x131 !== null)) {
            var a$3$1 = $n(x131)._1__O();
            var rest$3$1 = $as_sci_Queue($n(x131)._2__O());
            var \u03b417$___1 = a$3$1;
            var \u03b417$___2 = rest$3$1;
            break matchResult32;
          }
          throw new $c_s_MatchError(x131);
        }
        var a$4$1 = \u03b417$___1;
        var rest$4$1 = $as_sci_Queue(\u03b417$___2);
        matchResult33: {
          var \u03b418$___1;
          var \u03b418$___2;
          var x134 = $n(x147).dequeue__T2();
          if ((x134 !== null)) {
            var release$1 = $as_Lcats_effect_kernel_Deferred($n(x134)._1__O());
            var tail$1 = $as_sci_Queue($n(x134)._2__O());
            var \u03b418$___1 = release$1;
            var \u03b418$___2 = tail$1;
            break matchResult33;
          }
          throw new $c_s_MatchError(x134);
        }
        var release$2$1 = $as_Lcats_effect_kernel_Deferred(\u03b418$___1);
        var tail$2$1 = $as_sci_Queue(\u03b418$___2);
        var size$6 = ((x145 - 1) | 0);
        var self$7 = new $c_Lcats_effect_std_Queue$State(rest$4$1, size$6, x146, tail$2$1);
        var target$3 = $n(release$2$1).complete__O__O((void 0));
        var this$86 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, F);
        var b$1 = new $c_s_Some(a$4$1);
        var y$6 = $n(this$86.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$86.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
        return new $c_T2(self$7, y$6);
      }
    }
    var y$7 = $n(F).pure__O__O($m_s_None$());
    return new $c_T2(x$1$3, y$7);
  })), F);
  var target$4 = $n(state).get__O();
  var this$93 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$4, F);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$27) => {
    var _$27$1 = $as_Lcats_effect_std_Queue$State(_$27);
    return $n(_$27$1).Lcats_effect_std_Queue$State__f_size;
  }));
  $n(this$93.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$93.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_notifyNextTaker = $n(state).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s$2) => {
    var s$3 = $as_Lcats_effect_std_Queue$State(s$2);
    if ($n($n(s$3).Lcats_effect_std_Queue$State__f_takers).isEmpty__Z()) {
      var y$8 = $n(F).unit__O();
      return new $c_T2(s$3, y$8);
    } else {
      matchResult35: {
        var \u03b414$___1;
        var \u03b414$___2;
        var x148 = $n($n(s$3).Lcats_effect_std_Queue$State__f_takers).dequeue__T2();
        if ((x148 !== null)) {
          var taker$3 = $as_Lcats_effect_kernel_Deferred($n(x148)._1__O());
          var rest$8 = $as_sci_Queue($n(x148)._2__O());
          var \u03b414$___1 = taker$3;
          var \u03b414$___2 = rest$8;
          break matchResult35;
        }
        throw new $c_s_MatchError(x148);
      }
      var taker$2$2 = $as_Lcats_effect_kernel_Deferred(\u03b414$___1);
      var rest$2$3 = $as_sci_Queue(\u03b414$___2);
      $n(s$3);
      var this$97 = $n(s$3);
      var queue$2 = this$97.Lcats_effect_std_Queue$State__f_queue;
      var this$98 = $n(s$3);
      var size$7 = this$98.Lcats_effect_std_Queue$State__f_size;
      var this$99 = $n(s$3);
      var offerers$2 = this$99.Lcats_effect_std_Queue$State__f_offerers;
      var self$8 = new $c_Lcats_effect_std_Queue$State(queue$2, size$7, rest$2$3, offerers$2);
      var target$5 = $n(taker$2$2).complete__O__O((void 0));
      var this$103 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$5, F);
      var y$9 = $n(this$103.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$103.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
      return new $c_T2(self$8, y$9);
    }
  })));
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_std_Queue$AbstractQueue() {
  this.Lcats_effect_std_Queue$AbstractQueue__f_capacity = 0;
  this.Lcats_effect_std_Queue$AbstractQueue__f_state = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_F = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_take = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_tryTake = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_notifyNextTaker = null;
}
$c_Lcats_effect_std_Queue$AbstractQueue.prototype = new $h_Lcats_effect_std_Queue();
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.constructor = $c_Lcats_effect_std_Queue$AbstractQueue;
/** @constructor */
function $h_Lcats_effect_std_Queue$AbstractQueue() {
}
$h_Lcats_effect_std_Queue$AbstractQueue.prototype = $c_Lcats_effect_std_Queue$AbstractQueue.prototype;
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.offer__O__O = (function(a) {
  return $n(this.Lcats_effect_std_Queue$AbstractQueue__f_F).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(this.Lcats_effect_std_Queue$AbstractQueue__f_F).deferred__O();
    var tc = this.Lcats_effect_std_Queue$AbstractQueue__f_F;
    var this$54 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((offerer) => {
      var offerer$1 = $as_Lcats_effect_kernel_Deferred(offerer);
      var modificationF = $n(this.Lcats_effect_std_Queue$AbstractQueue__f_state).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Queue$State(x$1);
        if ((x$1$1 !== null)) {
          var this$4 = $n(x$1$1);
          var x79 = this$4.Lcats_effect_std_Queue$State__f_queue;
          var this$5 = $n(x$1$1);
          var x80 = this$5.Lcats_effect_std_Queue$State__f_size;
          var this$6 = $n(x$1$1);
          var x81 = this$6.Lcats_effect_std_Queue$State__f_takers;
          var this$7 = $n(x$1$1);
          var x82 = this$7.Lcats_effect_std_Queue$State__f_offerers;
          var this$8 = $n(x81);
          if ((!this$8.isEmpty__Z())) {
            matchResult21: {
              var \u03b47$___1;
              var \u03b47$___2;
              var x69 = $n(x81).dequeue__T2();
              if ((x69 !== null)) {
                var taker = $as_Lcats_effect_kernel_Deferred($n(x69)._1__O());
                var rest = $as_sci_Queue($n(x69)._2__O());
                var \u03b47$___1 = taker;
                var \u03b47$___2 = rest;
                break matchResult21;
              }
              throw new $c_s_MatchError(x69);
            }
            var taker$2 = $as_Lcats_effect_kernel_Deferred(\u03b47$___1);
            var rest$2 = $as_sci_Queue(\u03b47$___2);
            var queue = $n(x79).enqueue__O__sci_Queue(a);
            var size = ((1 + x80) | 0);
            var self = new $c_Lcats_effect_std_Queue$State(queue, size, rest$2, x82);
            var target$1 = $n(taker$2).complete__O__O((void 0));
            var tc$1 = this.Lcats_effect_std_Queue$AbstractQueue__f_F;
            var this$13 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, tc$1);
            var y = $n(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$13.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
            return new $c_T2(self, y);
          }
          if ((x80 < this.Lcats_effect_std_Queue$AbstractQueue__f_capacity)) {
            var queue$1 = $n(x79).enqueue__O__sci_Queue(a);
            var size$1 = ((1 + x80) | 0);
            var self$1 = new $c_Lcats_effect_std_Queue$State(queue$1, size$1, x81, x82);
            var y$1 = $n(this.Lcats_effect_std_Queue$AbstractQueue__f_F).unit__O();
            return new $c_T2(self$1, y$1);
          }
        }
        matchResult36: {
          var \u03b419$___1;
          var \u03b419$___2;
          var \u03b419$___3;
          var \u03b419$___4;
          if ((x$1$1 !== null)) {
            var this$19 = $n(x$1$1);
            var x153 = this$19.Lcats_effect_std_Queue$State__f_queue;
            var this$20 = $n(x$1$1);
            var x154 = this$20.Lcats_effect_std_Queue$State__f_size;
            var this$21 = $n(x$1$1);
            var x155 = this$21.Lcats_effect_std_Queue$State__f_takers;
            var this$22 = $n(x$1$1);
            var x156 = this$22.Lcats_effect_std_Queue$State__f_offerers;
            var \u03b419$___1 = x153;
            var \u03b419$___2 = x154;
            var \u03b419$___3 = x155;
            var \u03b419$___4 = x156;
            break matchResult36;
          }
          throw new $c_s_MatchError(x$1$1);
        }
        var queue$2 = $as_sci_Queue(\u03b419$___1);
        var size$2 = $uI(\u03b419$___2);
        var takers$2 = $as_sci_Queue(\u03b419$___3);
        var offerers$2 = $as_sci_Queue(\u03b419$___4);
        var cleanup = $n(this.Lcats_effect_std_Queue$BoundedQueue__f_state).modify__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((this$24) => ((s$2) => {
          var s = $as_Lcats_effect_std_Queue$State(s$2);
          var this$25 = $n($n(s).Lcats_effect_std_Queue$State__f_offerers);
          var b = $m_sci_Queue$().newBuilder__scm_Builder();
          var it = this$25.iterator__sc_Iterator();
          while ($n(it).hasNext__Z()) {
            var elem = $n(it).next__O();
            var _$29 = $as_Lcats_effect_kernel_Deferred(elem);
            if (((_$29 !== offerer$1) !== false)) {
              var this$26 = $n(b);
              this$26.addOne__O__scm_Growable(elem);
            }
          }
          var offerers2 = $as_sci_Queue($n(b).result__O());
          if ($n(offerers2).isEmpty__Z()) {
            $n(s);
            var this$27 = $n(s);
            var queue$3 = this$27.Lcats_effect_std_Queue$State__f_queue;
            var this$28 = $n(s);
            var size$3 = this$28.Lcats_effect_std_Queue$State__f_size;
            var this$29 = $n(s);
            var takers = this$29.Lcats_effect_std_Queue$State__f_takers;
            var self$2 = new $c_Lcats_effect_std_Queue$State(queue$3, size$3, takers, offerers2);
            var y$2 = $n(this$24.Lcats_effect_std_Queue$BoundedQueue__f_F).unit__O();
            return new $c_T2(self$2, y$2);
          } else {
            matchResult37: {
              var \u03b420$___1;
              var \u03b420$___2;
              var x157 = $n(offerers2).dequeue__T2();
              if ((x157 !== null)) {
                var offerer$2 = $as_Lcats_effect_kernel_Deferred($n(x157)._1__O());
                var rest$1 = $as_sci_Queue($n(x157)._2__O());
                var \u03b420$___1 = offerer$2;
                var \u03b420$___2 = rest$1;
                break matchResult37;
              }
              throw new $c_s_MatchError(x157);
            }
            var offerer$3 = $as_Lcats_effect_kernel_Deferred(\u03b420$___1);
            var rest$2$1 = $as_sci_Queue(\u03b420$___2);
            $n(s);
            var this$34 = $n(s);
            var queue$4 = this$34.Lcats_effect_std_Queue$State__f_queue;
            var this$35 = $n(s);
            var size$4 = this$35.Lcats_effect_std_Queue$State__f_size;
            var this$36 = $n(s);
            var takers$1 = this$36.Lcats_effect_std_Queue$State__f_takers;
            var self$3 = new $c_Lcats_effect_std_Queue$State(queue$4, size$4, takers$1, rest$2$1);
            var target$2 = $n(offerer$3).complete__O__O((void 0));
            var tc$2 = this$24.Lcats_effect_std_Queue$BoundedQueue__f_F;
            var this$40 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
            var y$3 = $n(this$40.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$40.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
            return new $c_T2(self$3, y$3);
          }
        }))(this)));
        var offerers = $n(offerers$2).enqueue__O__sci_Queue(offerer$1);
        var self$4 = new $c_Lcats_effect_std_Queue$State(queue$2, size$2, takers$2, offerers);
        var fa = $n(poll$1).apply__O__O($n(offerer$1).get__O());
        var fb = $n(poll$1).apply__O__O(this.offer__O__O(a));
        var F = this.Lcats_effect_std_Queue$BoundedQueue__f_F;
        var this$46 = $n(F);
        var wrapped = this$46.productR__O__O__O(fa, fb);
        var F$1 = this.Lcats_effect_std_Queue$BoundedQueue__f_F;
        var fin = $f_Lcats_FlatMap__flatten__O__O($n(F$1), cleanup);
        var F$2 = this.Lcats_effect_std_Queue$BoundedQueue__f_F;
        var y$4 = $n(F$2).onCancel__O__O__O(wrapped, fin);
        return new $c_T2(self$4, y$4);
      })));
      var F$3 = this.Lcats_effect_std_Queue$AbstractQueue__f_F;
      return $f_Lcats_FlatMap__flatten__O__O($n(F$3), modificationF);
    }));
    return $n(this$54.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$54.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })));
});
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.take__O = (function() {
  return this.Lcats_effect_std_Queue$AbstractQueue__f_take;
});
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.tryTake__O = (function() {
  return this.Lcats_effect_std_Queue$AbstractQueue__f_tryTake;
});
/** @constructor */
function $c_Lcats_effect_std_Queue$State(queue, size, takers, offerers) {
  this.Lcats_effect_std_Queue$State__f_queue = null;
  this.Lcats_effect_std_Queue$State__f_size = 0;
  this.Lcats_effect_std_Queue$State__f_takers = null;
  this.Lcats_effect_std_Queue$State__f_offerers = null;
  this.Lcats_effect_std_Queue$State__f_queue = queue;
  this.Lcats_effect_std_Queue$State__f_size = size;
  this.Lcats_effect_std_Queue$State__f_takers = takers;
  this.Lcats_effect_std_Queue$State__f_offerers = offerers;
}
$c_Lcats_effect_std_Queue$State.prototype = new $h_O();
$c_Lcats_effect_std_Queue$State.prototype.constructor = $c_Lcats_effect_std_Queue$State;
/** @constructor */
function $h_Lcats_effect_std_Queue$State() {
}
$h_Lcats_effect_std_Queue$State.prototype = $c_Lcats_effect_std_Queue$State.prototype;
$c_Lcats_effect_std_Queue$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Queue$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_std_Queue$State__f_queue;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_std_Queue$State__f_size;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lcats_effect_std_Queue$State__f_takers;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lcats_effect_std_Queue$State__f_offerers;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Lcats_effect_std_Queue$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_std_Queue$State)) {
    var x$0$2 = $as_Lcats_effect_std_Queue$State(x$0);
    if ((this.Lcats_effect_std_Queue$State__f_size === $n(x$0$2).Lcats_effect_std_Queue$State__f_size)) {
      var x = this.Lcats_effect_std_Queue$State__f_queue;
      var x$2 = $n(x$0$2).Lcats_effect_std_Queue$State__f_queue;
      if ((x === null)) {
        var $x_2 = (x$2 === null);
      } else {
        var this$1 = $n(x);
        var $x_2 = $f_sc_Seq__equals__O__Z(this$1, x$2);
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lcats_effect_std_Queue$State__f_takers;
      var x$4 = $n(x$0$2).Lcats_effect_std_Queue$State__f_takers;
      if ((x$3 === null)) {
        var $x_1 = (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        var $x_1 = $f_sc_Seq__equals__O__Z(this$2, x$4);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_std_Queue$State__f_offerers;
      var x$6 = $n(x$0$2).Lcats_effect_std_Queue$State__f_offerers;
      if ((x$5 === null)) {
        return (x$6 === null);
      } else {
        var this$3 = $n(x$5);
        return $f_sc_Seq__equals__O__Z(this$3, x$6);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Queue$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Queue$State.prototype.productArity__I = (function() {
  return 4;
});
$c_Lcats_effect_std_Queue$State.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lcats_effect_std_Queue$State.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_std_Queue$State__f_queue;
      break;
    }
    case 1: {
      return this.Lcats_effect_std_Queue$State__f_size;
      break;
    }
    case 2: {
      return this.Lcats_effect_std_Queue$State__f_takers;
      break;
    }
    case 3: {
      return this.Lcats_effect_std_Queue$State__f_offerers;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lcats_effect_std_Queue$State(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Queue$State) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Queue$State"));
}
function $isArrayOf_Lcats_effect_std_Queue$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Queue$State)));
}
function $asArrayOf_Lcats_effect_std_Queue$State(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Queue$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Queue$State;", depth));
}
var $d_Lcats_effect_std_Queue$State = new $TypeData().initClass($c_Lcats_effect_std_Queue$State, "cats.effect.std.Queue$State", ({
  Lcats_effect_std_Queue$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Request(outer, n_$_lo, n_$_hi, gate) {
  this.Lcats_effect_std_Semaphore$impl$Request__f_n_$lo = 0;
  this.Lcats_effect_std_Semaphore$impl$Request__f_n_$hi = 0;
  this.Lcats_effect_std_Semaphore$impl$Request__f_gate = null;
  this.Lcats_effect_std_Semaphore$impl$Request__f_$outer = null;
  this.Lcats_effect_std_Semaphore$impl$Request__f_n_$lo = n_$_lo;
  this.Lcats_effect_std_Semaphore$impl$Request__f_n_$hi = n_$_hi;
  this.Lcats_effect_std_Semaphore$impl$Request__f_gate = gate;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$Request__f_$outer = outer;
}
$c_Lcats_effect_std_Semaphore$impl$Request.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Request;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Request() {
}
$h_Lcats_effect_std_Semaphore$impl$Request.prototype = $c_Lcats_effect_std_Semaphore$impl$Request.prototype;
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Request");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var lv_$_lo = this.Lcats_effect_std_Semaphore$impl$Request__f_n_$lo;
  var lv_$_hi = this.Lcats_effect_std_Semaphore$impl$Request__f_n_$hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(lv_$_lo, lv_$_hi);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lcats_effect_std_Semaphore$impl$Request__f_gate;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lcats_effect_std_Semaphore$impl$Request) && ($n($as_Lcats_effect_std_Semaphore$impl$Request(x$0)).Lcats_effect_std_Semaphore$impl$Request__f_$outer === this.Lcats_effect_std_Semaphore$impl$Request__f_$outer))) {
    var x$0$2 = $as_Lcats_effect_std_Semaphore$impl$Request(x$0);
    var x_$_lo = this.Lcats_effect_std_Semaphore$impl$Request__f_n_$lo;
    var x_$_hi = this.Lcats_effect_std_Semaphore$impl$Request__f_n_$hi;
    var x$1_$_lo = $n(x$0$2).Lcats_effect_std_Semaphore$impl$Request__f_n_$lo;
    var x$1_$_hi = $n(x$0$2).Lcats_effect_std_Semaphore$impl$Request__f_n_$hi;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2 = this.Lcats_effect_std_Semaphore$impl$Request__f_gate;
      var x$2$1 = $n(x$0$2).Lcats_effect_std_Semaphore$impl$Request__f_gate;
      if ((x$2 === null)) {
        var $x_1 = (x$2$1 === null);
      } else {
        var this$2 = $n(x$2);
        var $x_1 = (this$2 === x$2$1);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productPrefix__T = (function() {
  return "Request";
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return $bL(this.Lcats_effect_std_Semaphore$impl$Request__f_n_$lo, this.Lcats_effect_std_Semaphore$impl$Request__f_n_$hi);
  }
  if ((n === 1)) {
    return this.Lcats_effect_std_Semaphore$impl$Request__f_gate;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.sameAs__Lcats_effect_std_Semaphore$impl$Request__Z = (function(r) {
  return ($n(r).Lcats_effect_std_Semaphore$impl$Request__f_gate === this.Lcats_effect_std_Semaphore$impl$Request__f_gate);
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.of__J__Lcats_effect_std_Semaphore$impl$Request = (function(newN_$_lo, newN_$_hi) {
  return $n($n(this.Lcats_effect_std_Semaphore$impl$Request__f_$outer).Lcats_effect_std_Semaphore$impl__f_Request$lzy1).apply__J__Lcats_effect_kernel_Deferred__Lcats_effect_std_Semaphore$impl$Request(newN_$_lo, newN_$_hi, this.Lcats_effect_std_Semaphore$impl$Request__f_gate);
});
function $as_Lcats_effect_std_Semaphore$impl$Request(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Semaphore$impl$Request) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Semaphore$impl$Request"));
}
function $isArrayOf_Lcats_effect_std_Semaphore$impl$Request(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore$impl$Request)));
}
function $asArrayOf_Lcats_effect_std_Semaphore$impl$Request(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Semaphore$impl$Request(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Semaphore$impl$Request;", depth));
}
var $d_Lcats_effect_std_Semaphore$impl$Request = new $TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$Request, "cats.effect.std.Semaphore$impl$Request", ({
  Lcats_effect_std_Semaphore$impl$Request: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$State(outer, permits_$_lo, permits_$_hi, waiting) {
  this.Lcats_effect_std_Semaphore$impl$State__f_permits_$lo = 0;
  this.Lcats_effect_std_Semaphore$impl$State__f_permits_$hi = 0;
  this.Lcats_effect_std_Semaphore$impl$State__f_waiting = null;
  this.Lcats_effect_std_Semaphore$impl$State__f_$outer = null;
  this.Lcats_effect_std_Semaphore$impl$State__f_permits_$lo = permits_$_lo;
  this.Lcats_effect_std_Semaphore$impl$State__f_permits_$hi = permits_$_hi;
  this.Lcats_effect_std_Semaphore$impl$State__f_waiting = waiting;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Semaphore$impl$State__f_$outer = outer;
}
$c_Lcats_effect_std_Semaphore$impl$State.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$State.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$State;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$State() {
}
$h_Lcats_effect_std_Semaphore$impl$State.prototype = $c_Lcats_effect_std_Semaphore$impl$State.prototype;
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var lv_$_lo = this.Lcats_effect_std_Semaphore$impl$State__f_permits_$lo;
  var lv_$_hi = this.Lcats_effect_std_Semaphore$impl$State__f_permits_$hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(lv_$_lo, lv_$_hi);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lcats_effect_std_Semaphore$impl$State__f_waiting;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lcats_effect_std_Semaphore$impl$State) && ($n($as_Lcats_effect_std_Semaphore$impl$State(x$0)).Lcats_effect_std_Semaphore$impl$State__f_$outer === this.Lcats_effect_std_Semaphore$impl$State__f_$outer))) {
    var x$0$2 = $as_Lcats_effect_std_Semaphore$impl$State(x$0);
    var x_$_lo = this.Lcats_effect_std_Semaphore$impl$State__f_permits_$lo;
    var x_$_hi = this.Lcats_effect_std_Semaphore$impl$State__f_permits_$hi;
    var x$1_$_lo = $n(x$0$2).Lcats_effect_std_Semaphore$impl$State__f_permits_$lo;
    var x$1_$_hi = $n(x$0$2).Lcats_effect_std_Semaphore$impl$State__f_permits_$hi;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2 = this.Lcats_effect_std_Semaphore$impl$State__f_waiting;
      var x$2$1 = $n(x$0$2).Lcats_effect_std_Semaphore$impl$State__f_waiting;
      if ((x$2 === null)) {
        var $x_1 = (x$2$1 === null);
      } else {
        var this$2 = $n(x$2);
        var $x_1 = $f_sc_Seq__equals__O__Z(this$2, x$2$1);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return $bL(this.Lcats_effect_std_Semaphore$impl$State__f_permits_$lo, this.Lcats_effect_std_Semaphore$impl$State__f_permits_$hi);
  }
  if ((n === 1)) {
    return this.Lcats_effect_std_Semaphore$impl$State__f_waiting;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Semaphore$impl$State(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Semaphore$impl$State) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Semaphore$impl$State"));
}
function $isArrayOf_Lcats_effect_std_Semaphore$impl$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore$impl$State)));
}
function $asArrayOf_Lcats_effect_std_Semaphore$impl$State(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Semaphore$impl$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Semaphore$impl$State;", depth));
}
var $d_Lcats_effect_std_Semaphore$impl$State = new $TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$State, "cats.effect.std.Semaphore$impl$State", ({
  Lcats_effect_std_Semaphore$impl$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_UnsafeUnbounded$Cell(_data) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.Lcats_effect_std_UnsafeUnbounded$Cell__f__data = null;
  this.Lcats_effect_std_UnsafeUnbounded$Cell__f__data = _data;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, null);
}
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype.constructor = $c_Lcats_effect_std_UnsafeUnbounded$Cell;
/** @constructor */
function $h_Lcats_effect_std_UnsafeUnbounded$Cell() {
}
$h_Lcats_effect_std_UnsafeUnbounded$Cell.prototype = $c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype;
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype.apply__V = (function() {
  this.Lcats_effect_std_UnsafeUnbounded$Cell__f__data = null;
});
$c_Lcats_effect_std_UnsafeUnbounded$Cell.prototype.apply__O = (function() {
  this.apply__V();
});
function $as_Lcats_effect_std_UnsafeUnbounded$Cell(obj) {
  return (((obj instanceof $c_Lcats_effect_std_UnsafeUnbounded$Cell) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.UnsafeUnbounded$Cell"));
}
function $isArrayOf_Lcats_effect_std_UnsafeUnbounded$Cell(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_UnsafeUnbounded$Cell)));
}
function $asArrayOf_Lcats_effect_std_UnsafeUnbounded$Cell(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_UnsafeUnbounded$Cell(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.UnsafeUnbounded$Cell;", depth));
}
var $d_Lcats_effect_std_UnsafeUnbounded$Cell = new $TypeData().initClass($c_Lcats_effect_std_UnsafeUnbounded$Cell, "cats.effect.std.UnsafeUnbounded$Cell", ({
  Lcats_effect_std_UnsafeUnbounded$Cell: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1,
  F0: 1
}));
class $c_Lcats_effect_tracing_TracingEvent$StackTrace extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
function $as_Lcats_effect_tracing_TracingEvent$StackTrace(obj) {
  return (((obj instanceof $c_Lcats_effect_tracing_TracingEvent$StackTrace) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.TracingEvent$StackTrace"));
}
function $isArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_TracingEvent$StackTrace)));
}
function $asArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.TracingEvent$StackTrace;", depth));
}
var $d_Lcats_effect_tracing_TracingEvent$StackTrace = new $TypeData().initClass($c_Lcats_effect_tracing_TracingEvent$StackTrace, "cats.effect.tracing.TracingEvent$StackTrace", ({
  Lcats_effect_tracing_TracingEvent$StackTrace: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_tracing_TracingEvent: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold) {
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions = false;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors = false;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold = 0.0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold = cancelationCheckThreshold;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold = autoYieldThreshold;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions = enhancedExceptions;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize = traceBufferSize;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout = shutdownHookTimeout;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors = reportUnhandledFiberErrors;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval = cpuStarvationCheckInterval;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay = cpuStarvationCheckInitialDelay;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold = cpuStarvationCheckThreshold;
  var requirement = (autoYieldThreshold > 1);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + ("Auto yield threshold " + autoYieldThreshold)) + " must be > 1"));
  }
  var requirement$1 = (cancelationCheckThreshold > 0);
  if ((!requirement$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + ("Cancelation check threshold " + cancelationCheckThreshold)) + " must be > 0"));
  }
  var requirement$2 = (((autoYieldThreshold % $checkIntDivisor(cancelationCheckThreshold)) | 0) === 0);
  if ((!requirement$2)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + (("Auto yield threshold " + autoYieldThreshold) + " must be a multiple of cancelation check threshold ")) + cancelationCheckThreshold));
  }
  var requirement$3 = (cpuStarvationCheckThreshold > 0.0);
  if ((!requirement$3)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + ("CPU starvation check threshold " + cpuStarvationCheckThreshold)) + " must be > 0"));
  }
  var a = traceBufferSize;
  var a$1 = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
  var value = $uD(Math.round(a$1));
  var $x_1 = $m_RTLong$().fromDouble__D__J(value);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize = x_$_lo;
}
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfig;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfig() {
}
$h_Lcats_effect_unsafe_IORuntimeConfig.prototype = $c_Lcats_effect_unsafe_IORuntimeConfig.prototype;
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("IORuntimeConfig");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize;
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x = this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = (this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$1 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$2 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var dv = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold;
  var data$9 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$10, 9);
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_unsafe_IORuntimeConfig)) {
    var x$0$2 = $as_Lcats_effect_unsafe_IORuntimeConfig(x$0);
    if (((((((this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold === $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold))) {
      var x = this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      var x$2 = $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
      var x$4 = $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
      var x$6 = $n(x$0$2).Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productArity__I = (function() {
  return 9;
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productPrefix__T = (function() {
  return "IORuntimeConfig";
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
      break;
    }
    case 1: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
      break;
    }
    case 2: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions;
      break;
    }
    case 3: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize;
      break;
    }
    case 4: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      break;
    }
    case 5: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors;
      break;
    }
    case 6: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInterval;
      break;
    }
    case 7: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckInitialDelay;
      break;
    }
    case 8: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cpuStarvationCheckThreshold;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lcats_effect_unsafe_IORuntimeConfig(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_IORuntimeConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.IORuntimeConfig"));
}
function $isArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntimeConfig)));
}
function $asArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.IORuntimeConfig;", depth));
}
var $d_Lcats_effect_unsafe_IORuntimeConfig = new $TypeData().initClass($c_Lcats_effect_unsafe_IORuntimeConfig, "cats.effect.unsafe.IORuntimeConfig", ({
  Lcats_effect_unsafe_IORuntimeConfig: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfig$() {
  this.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = null;
  $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__(this);
}
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype = new $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform();
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfig$;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfig$() {
}
$h_Lcats_effect_unsafe_IORuntimeConfig$.prototype = $c_Lcats_effect_unsafe_IORuntimeConfig$.prototype;
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.DefaultCpuStarvationCheckInterval__s_concurrent_duration_FiniteDuration = (function() {
  var this$2 = new $c_s_concurrent_duration_package$DurationInt(1);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  return new $c_s_concurrent_duration_FiniteDuration(this$, hi, unit);
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.DefaultCpuStarvationCheckInitialDelay__s_concurrent_duration_FiniteDuration = (function() {
  var this$2 = new $c_s_concurrent_duration_package$DurationInt(10);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  return new $c_s_concurrent_duration_FiniteDuration(this$, hi, unit);
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.apply__I__I__Z__I__s_concurrent_duration_Duration__Z__s_concurrent_duration_FiniteDuration__s_concurrent_duration_Duration__D__Lcats_effect_unsafe_IORuntimeConfig = (function(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold) {
  var a = traceBufferSize;
  var a$1 = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
  var value = $uD(Math.round(a$1));
  var $x_1 = $m_RTLong$().fromDouble__D__J(value);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  return new $c_Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, (1 << x_$_lo), shutdownHookTimeout, reportUnhandledFiberErrors, cpuStarvationCheckInterval, cpuStarvationCheckInitialDelay, cpuStarvationCheckThreshold);
});
function $as_Lcats_effect_unsafe_IORuntimeConfig$(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_IORuntimeConfig$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.IORuntimeConfig$"));
}
function $isArrayOf_Lcats_effect_unsafe_IORuntimeConfig$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntimeConfig$)));
}
function $asArrayOf_Lcats_effect_unsafe_IORuntimeConfig$(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_IORuntimeConfig$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.IORuntimeConfig$;", depth));
}
var $d_Lcats_effect_unsafe_IORuntimeConfig$ = new $TypeData().initClass($c_Lcats_effect_unsafe_IORuntimeConfig$, "cats.effect.unsafe.IORuntimeConfig$", ({
  Lcats_effect_unsafe_IORuntimeConfig$: 1,
  Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lcats_effect_unsafe_IORuntimeConfig$;
function $m_Lcats_effect_unsafe_IORuntimeConfig$() {
  if ((!$n_Lcats_effect_unsafe_IORuntimeConfig$)) {
    $n_Lcats_effect_unsafe_IORuntimeConfig$ = new $c_Lcats_effect_unsafe_IORuntimeConfig$();
  }
  return $n_Lcats_effect_unsafe_IORuntimeConfig$;
}
/** @constructor */
function $c_Lcats_effect_unsafe_WeakBag$Entry(a, index, rq) {
  this.Lcats_effect_unsafe_ref_Reference__f_queue = null;
  this.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
  this.Lcats_effect_unsafe_WeakBag$Entry__f_index = 0;
  this.Lcats_effect_unsafe_WeakBag$Entry__f_index = index;
  $ct_Lcats_effect_unsafe_ref_Reference__O__Lcats_effect_unsafe_ref_ReferenceQueue__(this, a, rq);
}
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype = new $h_Lcats_effect_unsafe_ref_WeakReference();
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype.constructor = $c_Lcats_effect_unsafe_WeakBag$Entry;
/** @constructor */
function $h_Lcats_effect_unsafe_WeakBag$Entry() {
}
$h_Lcats_effect_unsafe_WeakBag$Entry.prototype = $c_Lcats_effect_unsafe_WeakBag$Entry.prototype;
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype.deregister__V = (function() {
  this.enqueue__Z();
});
function $as_Lcats_effect_unsafe_WeakBag$Entry(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_WeakBag$Entry) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.WeakBag$Entry"));
}
function $isArrayOf_Lcats_effect_unsafe_WeakBag$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WeakBag$Entry)));
}
function $asArrayOf_Lcats_effect_unsafe_WeakBag$Entry(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_WeakBag$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.WeakBag$Entry;", depth));
}
var $d_Lcats_effect_unsafe_WeakBag$Entry = new $TypeData().initClass($c_Lcats_effect_unsafe_WeakBag$Entry, "cats.effect.unsafe.WeakBag$Entry", ({
  Lcats_effect_unsafe_WeakBag$Entry: 1,
  Lcats_effect_unsafe_ref_WeakReference: 1,
  Lcats_effect_unsafe_ref_Reference: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
}));
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$7(outer) {
  this.Lcats_instances_Function1Instances$$anon$7__f_category = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var instance = $n(outer).catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice();
  this.Lcats_instances_Function1Instances$$anon$7__f_category = instance;
}
$c_Lcats_instances_Function1Instances$$anon$7.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$7.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$7;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$7() {
}
$h_Lcats_instances_Function1Instances$$anon$7.prototype = $c_Lcats_instances_Function1Instances$$anon$7.prototype;
$c_Lcats_instances_Function1Instances$$anon$7.prototype.combineK__F1__F1__F1 = (function(x, y) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen($as_F1($n(this.Lcats_instances_Function1Instances$$anon$7__f_category).compose__O__O__O(x, y)));
});
$c_Lcats_instances_Function1Instances$$anon$7.prototype.empty__O = (function() {
  return $as_F1($n(this.Lcats_instances_Function1Instances$$anon$7__f_category).id__O());
});
$c_Lcats_instances_Function1Instances$$anon$7.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__F1__F1__F1($as_F1(x), $as_F1(y));
});
$c_Lcats_instances_Function1Instances$$anon$7.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this);
});
var $d_Lcats_instances_Function1Instances$$anon$7 = new $TypeData().initClass($c_Lcats_instances_Function1Instances$$anon$7, "cats.instances.Function1Instances$$anon$7", ({
  Lcats_instances_Function1Instances$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1,
  Lcats_MonoidK: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$5(fa$20, fb$8, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fa$15 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fb$6 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fa$15 = fa$20;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$5__f_fb$6 = fb$8;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$5;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$5() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$5.prototype;
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$5 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$5, "cats.instances.InvariantMonoidalInstances$$anon$5", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_CommutativeSemigroup: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(f$13, fa$21, g$13, outer) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_f$10 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$16 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_g$10 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_f$10 = f$13;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$16 = fa$21;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_g$10 = g$13;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$6() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype;
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$6 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$6, "cats.instances.InvariantMonoidalInstances$$anon$6", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_CommutativeSemigroup: 1
}));
function $f_Lcats_instances_LazyListInstances__$init$__V($thiz) {
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V(new $c_Lcats_instances_LazyListInstances$$anon$1());
  $thiz.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_LazyListInstances$$anon$3($thiz));
}
function $ps_Lcats_instances_LazyListInstances__step$1__Lcats_Monad__F2__T2__O(G$3, f$8, in$1) {
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ((in$1 !== null)) {
      var s = $as_sci_LazyList($n(in$1)._1__O());
      var b = $n(in$1)._2__O();
      var \u03b41$___1 = s;
      var \u03b41$___2 = b;
      break matchResult5;
    }
    throw new $c_s_MatchError(in$1);
  }
  var s$2 = $as_sci_LazyList(\u03b41$___1);
  var b$2 = \u03b41$___2;
  var this$2 = $n(s$2);
  if ((this$2.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    return $n(G$3).pure__O__O(new $c_s_util_Right(b$2));
  } else {
    return $n(G$3).map__O__F1__O($n(f$8).apply__O__O__O(b$2, $n(s$2).head__O()), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((bnext) => {
      var _1 = $n(s$2).tail__sci_LazyList();
      var value = new $c_T2(_1, bnext);
      return new $c_s_util_Left(value);
    })));
  }
}
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $as_Lcats_Traverse($n(outer).catsStdInstancesForLazyList__Lcats_Align());
}
$c_Lcats_instances_LazyListInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$3.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$3() {
}
$h_Lcats_instances_LazyListInstances$$anon$3.prototype = $c_Lcats_instances_LazyListInstances$$anon$3.prototype;
var $d_Lcats_instances_LazyListInstances$$anon$3 = new $TypeData().initClass($c_Lcats_instances_LazyListInstances$$anon$3, "cats.instances.LazyListInstances$$anon$3", ({
  Lcats_instances_LazyListInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__V(buf$1, f$4, lists) {
  var lists$tailLocal1 = lists;
  while (true) {
    var x6 = lists$tailLocal1;
    if ((x6 instanceof $c_sci_$colon$colon)) {
      var x10 = $as_sci_$colon$colon(x6);
      var x11 = $as_sci_List($n(x10).sci_$colon$colon__f_head);
      var x12 = $n(x10).sci_$colon$colon__f_next;
      if ((x11 instanceof $c_sci_$colon$colon)) {
        var x13 = $as_sci_$colon$colon(x11);
        var x15 = $n(x13).sci_$colon$colon__f_next;
        var ab = $as_s_util_Either($n(x13).sci_$colon$colon__f_head);
        if ((ab instanceof $c_s_util_Right)) {
          var b = $n($as_s_util_Right(ab)).s_util_Right__f_value;
          var this$1 = $n(buf$1);
          this$1.addOne__O__scm_Growable(b);
          var this$2 = $n(x12);
          lists$tailLocal1 = new $c_sci_$colon$colon(x15, this$2);
          continue;
        }
        if ((ab instanceof $c_s_util_Left)) {
          var a = $n($as_s_util_Left(ab)).s_util_Left__f_value;
          var elem$1 = $as_sci_List($n(f$4).apply__O__O(a));
          var this$3 = $n(x12);
          var this$4 = new $c_sci_$colon$colon(x15, this$3);
          lists$tailLocal1 = new $c_sci_$colon$colon(elem$1, this$4);
          continue;
        }
        throw new $c_s_MatchError(ab);
      }
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(x11)) {
        lists$tailLocal1 = x12;
        continue;
      }
    }
    var x$3 = $m_sci_Nil$();
    if (x$3.equals__O__Z(x6)) {
      return (void 0);
    }
    throw new $c_s_MatchError(x6);
  }
}
function $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1, f$6, as) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(as)) {
    return lb$1;
  }
  if ((as instanceof $c_sci_$colon$colon)) {
    var x21 = $as_sci_$colon$colon(as);
    var x23 = $n(x21).sci_$colon$colon__f_next;
    var h = $n(x21).sci_$colon$colon__f_head;
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1, f$6, x23)));
    return $as_Lcats_Eval($n(f$6).apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a)));
  }
  throw new $c_s_MatchError(as);
}
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G$4, f$12, size, fa) {
  if ((size > 1)) {
    var leftSize = (((size + ((size >>> 31) | 0)) | 0) >> 1);
    var rightSize = ((size - leftSize) | 0);
    matchResult7: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x30 = $n(fa).splitAt__I__T2(leftSize);
      if ((x30 !== null)) {
        var leftL = $as_sci_List($n(x30)._1__O());
        var rightL = $as_sci_List($n(x30)._2__O());
        var \u03b41$___1 = leftL;
        var \u03b41$___2 = rightL;
        break matchResult7;
      }
      throw new $c_s_MatchError(x30);
    }
    var leftL$2 = $as_sci_List(\u03b41$___1);
    var rightL$2 = $as_sci_List(\u03b41$___2);
    return $n($s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G$4, f$12, leftSize, leftL$2)).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((left) => {
      var right = $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G$4, f$12, rightSize, rightL$2);
      return $n(G$4).map2Eval__O__Lcats_Eval__F2__Lcats_Eval(left, right, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$6, _$7) => {
        $as_jl_Void(_$6);
        $as_jl_Void(_$7);
      })));
    })));
  } else {
    var a = $n(fa).head__O();
    $m_Lcats_Eval$();
    var a$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      var gb = $n(f$12).apply__O__O(a);
      return $n(G$4).void__O__O(gb);
    }));
    return new $c_Lcats_Always(a$1);
  }
}
function $ps_Lcats_instances_ListInstances__step$1__Lcats_Monad__F2__T2__O(G$6, f$18, in$1) {
  if ((in$1 !== null)) {
    var x65 = $as_sci_List($n(in$1)._1__O());
    var x66 = $n(in$1)._2__O();
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x65)) {
      return $n(G$6).pure__O__O(new $c_s_util_Right(x66));
    }
    if ((x65 instanceof $c_sci_$colon$colon)) {
      var x62 = $as_sci_$colon$colon(x65);
      var x64 = $n(x62).sci_$colon$colon__f_next;
      var a = $n(x62).sci_$colon$colon__f_head;
      return $n(G$6).map__O__F1__O($n(f$18).apply__O__O__O(x66, a), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((bnext) => {
        var value = new $c_T2(x64, bnext);
        return new $c_s_util_Left(value);
      })));
    }
  }
  throw new $c_s_MatchError(in$1);
}
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List(fa, acc) {
  var acc$tailLocal1 = acc;
  var fa$tailLocal2 = fa;
  while (true) {
    if ($n(fa$tailLocal2).isEmpty__Z()) {
      return acc$tailLocal1;
    } else {
      var fa$tailLocal2$tmp1 = $as_sci_List($n(fa$tailLocal2).tail__O());
      var this$1 = $n(acc$tailLocal1);
      var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon((void 0), this$1);
      fa$tailLocal2 = fa$tailLocal2$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
    }
  }
}
/** @constructor */
function $c_Lcats_instances_ListInstancesBinCompat0$$anon$6() {
  $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
}
$c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype = new $h_O();
$c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype.constructor = $c_Lcats_instances_ListInstancesBinCompat0$$anon$6;
/** @constructor */
function $h_Lcats_instances_ListInstancesBinCompat0$$anon$6() {
}
$h_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype = $c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype;
var $d_Lcats_instances_ListInstancesBinCompat0$$anon$6 = new $TypeData().initClass($c_Lcats_instances_ListInstancesBinCompat0$$anon$6, "cats.instances.ListInstancesBinCompat0$$anon$6", ({
  Lcats_instances_ListInstancesBinCompat0$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
/** @constructor */
function $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3() {
  $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
}
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype = new $h_O();
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype.constructor = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3;
/** @constructor */
function $h_Lcats_instances_OptionInstancesBinCompat0$$anon$3() {
}
$h_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3.prototype;
var $d_Lcats_instances_OptionInstancesBinCompat0$$anon$3 = new $TypeData().initClass($c_Lcats_instances_OptionInstancesBinCompat0$$anon$3, "cats.instances.OptionInstancesBinCompat0$$anon$3", ({
  Lcats_instances_OptionInstancesBinCompat0$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$2(fa$6, fb$3, outer) {
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$4 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$2 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$4 = fa$6;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$2 = fb$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$2() {
}
$h_Lcats_instances_PartialOrderInstances$$anon$2.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$2.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__T2__T2__D = (function(x, y) {
  var fa$1 = this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$4;
  var fb$1 = this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$2;
  var z = $n(fa$1).partialCompare__O__O__D($n(x)._1__O(), $n(y)._1__O());
  return ((z === 0.0) ? $n(fb$1).partialCompare__O__O__D($n(x)._2__O(), $n(y)._2__O()) : z);
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__T2__T2__D($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_PartialOrderInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_PartialOrderInstances$$anon$2, "cats.instances.PartialOrderInstances$$anon$2", ({
  Lcats_instances_PartialOrderInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$2(fa$5, f$2) {
}
$c_Lcats_instances_PartialOrderingInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$2() {
}
$h_Lcats_instances_PartialOrderingInstances$$anon$2.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$2.prototype;
var $d_Lcats_instances_PartialOrderingInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_PartialOrderingInstances$$anon$2, "cats.instances.PartialOrderingInstances$$anon$2", ({
  Lcats_instances_PartialOrderingInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa$6, fb$2) {
}
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$3() {
}
$h_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype;
var $d_Lcats_instances_PartialOrderingInstances$$anon$3 = new $TypeData().initClass($c_Lcats_instances_PartialOrderingInstances$$anon$3, "cats.instances.PartialOrderingInstances$$anon$3", ({
  Lcats_instances_PartialOrderingInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1
}));
function $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__sci_Queue(bldr$1, f$4, lists) {
  var lists$tailLocal1 = lists;
  while (true) {
    var x9 = lists$tailLocal1;
    if ((x9 instanceof $c_sci_$colon$colon)) {
      var x10 = $as_sci_$colon$colon(x9);
      var x12 = $n(x10).sci_$colon$colon__f_next;
      var q = $as_sci_Queue($n(x10).sci_$colon$colon__f_head);
      if ($n(q).isEmpty__Z()) {
        lists$tailLocal1 = x12;
        continue;
      } else {
        matchResult1: {
          var \u03b41$___1;
          var \u03b41$___2;
          var x1 = $n(q).dequeue__T2();
          if ((x1 !== null)) {
            var e = $as_s_util_Either($n(x1)._1__O());
            var es = $as_sci_Queue($n(x1)._2__O());
            var \u03b41$___1 = e;
            var \u03b41$___2 = es;
            break matchResult1;
          }
          throw new $c_s_MatchError(x1);
        }
        var e$2 = $as_s_util_Either(\u03b41$___1);
        var es$2 = $as_sci_Queue(\u03b41$___2);
        if ((e$2 instanceof $c_s_util_Right)) {
          var b = $n($as_s_util_Right(e$2)).s_util_Right__f_value;
          var this$2 = $n(bldr$1);
          this$2.addOne__O__scm_Growable(b);
          var this$3 = $n(x12);
          lists$tailLocal1 = new $c_sci_$colon$colon(es$2, this$3);
          continue;
        }
        if ((e$2 instanceof $c_s_util_Left)) {
          var a = $n($as_s_util_Left(e$2)).s_util_Left__f_value;
          var elem$1 = $as_sci_Queue($n(f$4).apply__O__O(a));
          var this$4 = $n(x12);
          var this$5 = new $c_sci_$colon$colon(es$2, this$4);
          lists$tailLocal1 = new $c_sci_$colon$colon(elem$1, this$5);
          continue;
        }
        throw new $c_s_MatchError(e$2);
      }
    }
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x9)) {
      return $as_sci_Queue($n(bldr$1).result__O());
    }
    throw new $c_s_MatchError(x9);
  }
}
function $ps_Lcats_instances_QueueInstances__loop$2__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$1, f$6, as) {
  if ($n(as).isEmpty__Z()) {
    return lb$1;
  } else {
    matchResult5: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x16 = $n(as).dequeue__T2();
      if ((x16 !== null)) {
        var h = $n(x16)._1__O();
        var t = $as_sci_Queue($n(x16)._2__O());
        var \u03b42$___1 = h;
        var \u03b42$___2 = t;
        break matchResult5;
      }
      throw new $c_s_MatchError(x16);
    }
    var h$2 = \u03b42$___1;
    var t$2 = $as_sci_Queue(\u03b42$___2);
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lcats_instances_QueueInstances__loop$2__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$1, f$6, t$2)));
    return $as_Lcats_Eval($n(f$6).apply__O__O__O(h$2, new $c_Lcats_Eval$$anon$5(a)));
  }
}
function $ps_Lcats_instances_QueueInstances__step$1__Lcats_Monad__F2__T2__O(G$2, f$10, in$1) {
  matchResult8: {
    var \u03b43$___1;
    var \u03b43$___2;
    if ((in$1 !== null)) {
      var xs = $as_sci_Queue($n(in$1)._1__O());
      var b = $n(in$1)._2__O();
      var \u03b43$___1 = xs;
      var \u03b43$___2 = b;
      break matchResult8;
    }
    throw new $c_s_MatchError(in$1);
  }
  var xs$2 = $as_sci_Queue(\u03b43$___1);
  var b$2 = \u03b43$___2;
  if ($n(xs$2).isEmpty__Z()) {
    return $n(G$2).pure__O__O(new $c_s_util_Right(b$2));
  } else {
    matchResult9: {
      var \u03b44$___1;
      var \u03b44$___2;
      var x26 = $n(xs$2).dequeue__T2();
      if ((x26 !== null)) {
        var a = $n(x26)._1__O();
        var tail = $as_sci_Queue($n(x26)._2__O());
        var \u03b44$___1 = a;
        var \u03b44$___2 = tail;
        break matchResult9;
      }
      throw new $c_s_MatchError(x26);
    }
    var a$2 = \u03b44$___1;
    var tail$2 = $as_sci_Queue(\u03b44$___2);
    return $n(G$2).map__O__F1__O($n(f$10).apply__O__O__O(b$2, a$2), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((bnext) => {
      var value = new $c_T2(tail$2, bnext);
      return new $c_s_util_Left(value);
    })));
  }
}
function $f_Lcats_instances_SeqInstances__$init$__V($thiz) {
  $thiz.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V(new $c_Lcats_instances_SeqInstances$$anon$1());
  $thiz.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_SeqInstances$$anon$2());
}
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$2() {
  $as_Lcats_Traverse($m_Lcats_instances_package$seq$().Lcats_instances_package$seq$__f_catsStdInstancesForSeq);
}
$c_Lcats_instances_SeqInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$2.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$2() {
}
$h_Lcats_instances_SeqInstances$$anon$2.prototype = $c_Lcats_instances_SeqInstances$$anon$2.prototype;
var $d_Lcats_instances_SeqInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_SeqInstances$$anon$2, "cats.instances.SeqInstances$$anon$2", ({
  Lcats_instances_SeqInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
function $ps_Lcats_instances_StreamInstances__step$1__Lcats_Monad__F2__T2__O(G$3, f$8, in$1) {
  matchResult5: {
    var \u03b41$___1;
    var \u03b41$___2;
    if ((in$1 !== null)) {
      var s = $as_sci_Stream($n(in$1)._1__O());
      var b = $n(in$1)._2__O();
      var \u03b41$___1 = s;
      var \u03b41$___2 = b;
      break matchResult5;
    }
    throw new $c_s_MatchError(in$1);
  }
  var s$2 = $as_sci_Stream(\u03b41$___1);
  var b$2 = \u03b41$___2;
  return ($n(s$2).isEmpty__Z() ? $n(G$3).pure__O__O(new $c_s_util_Right(b$2)) : $n(G$3).map__O__F1__O($n(f$8).apply__O__O__O(b$2, $n(s$2).head__O()), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((bnext) => {
    var _1 = $n(s$2).tail__sci_Stream();
    var value = new $c_T2(_1, bnext);
    return new $c_s_util_Left(value);
  }))));
}
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$2(fn$1, a$2) {
  this.Lcats_instances_StreamInstances$$anon$2__f_fn$2 = null;
  this.Lcats_instances_StreamInstances$$anon$2__f_stack = null;
  this.Lcats_instances_StreamInstances$$anon$2__f_state = null;
  this.Lcats_instances_StreamInstances$$anon$2__f_fn$2 = fn$1;
  this.Lcats_instances_StreamInstances$$anon$2__f_stack = $as_sci_Stream($n(fn$1).apply__O__O(a$2));
  this.Lcats_instances_StreamInstances$$anon$2__f_state = new $c_s_util_Left((void 0));
}
$c_Lcats_instances_StreamInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_StreamInstances$$anon$2.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$2() {
}
$h_Lcats_instances_StreamInstances$$anon$2.prototype = $c_Lcats_instances_StreamInstances$$anon$2.prototype;
$c_Lcats_instances_StreamInstances$$anon$2.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.advance__V = (function() {
  while (true) {
    var x1 = this.Lcats_instances_StreamInstances$$anon$2__f_stack;
    if ((x1 !== null)) {
      var x8 = $m_s_package$$hash$colon$colon$().unapply__sci_Stream__s_Option(x1);
      if ((!$n(x8).isEmpty__Z())) {
        var x9 = $as_T2($n(x8).get__O());
        var x10 = $as_s_util_Either($n(x9)._1__O());
        var x11 = $as_sci_Stream($n(x9)._2__O());
        if ((x10 instanceof $c_s_util_Right)) {
          var b = $n($as_s_util_Right(x10)).s_util_Right__f_value;
          this.Lcats_instances_StreamInstances$$anon$2__f_stack = x11;
          var value = new $c_s_Some(b);
          this.Lcats_instances_StreamInstances$$anon$2__f_state = new $c_s_util_Right(value);
          return (void 0);
        }
        if ((x10 instanceof $c_s_util_Left)) {
          var a = $n($as_s_util_Left(x10)).s_util_Left__f_value;
          var prefix$1 = $as_sci_Stream($n(this.Lcats_instances_StreamInstances$$anon$2__f_fn$2).apply__O__O(a));
          var l = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((x11) => (() => x11))(x11));
          this.Lcats_instances_StreamInstances$$anon$2__f_stack = $n(prefix$1).lazyAppendedAll__F0__sci_Stream(l);
          continue;
        }
      }
    }
    var value$1 = $m_s_None$();
    this.Lcats_instances_StreamInstances$$anon$2__f_state = new $c_s_util_Right(value$1);
    return (void 0);
  }
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.hasNext__Z = (function() {
  while (true) {
    var x14 = this.Lcats_instances_StreamInstances$$anon$2__f_state;
    if ((x14 instanceof $c_s_util_Left)) {
      var x$2 = $n($as_s_util_Left(x14)).s_util_Left__f_value;
      var $x_1 = (x$2 === (void 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.advance__V();
      continue;
    }
    if ((x14 instanceof $c_s_util_Right)) {
      var o = $as_s_Option($n($as_s_util_Right(x14)).s_util_Right__f_value);
      var this$1 = $n(o);
      return (!this$1.isEmpty__Z());
    }
    throw new $c_s_MatchError(x14);
  }
});
$c_Lcats_instances_StreamInstances$$anon$2.prototype.next__O = (function() {
  while (true) {
    var x19 = this.Lcats_instances_StreamInstances$$anon$2__f_state;
    if ((x19 instanceof $c_s_util_Left)) {
      var x$2 = $n($as_s_util_Left(x19)).s_util_Left__f_value;
      var $x_1 = (x$2 === (void 0));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.advance__V();
      continue;
    }
    if ((x19 instanceof $c_s_util_Right)) {
      var o = $as_s_Option($n($as_s_util_Right(x19)).s_util_Right__f_value);
      var b = $n(o).get__O();
      this.advance__V();
      return b;
    }
    throw new $c_s_MatchError(x19);
  }
});
var $d_Lcats_instances_StreamInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_StreamInstances$$anon$2, "cats.instances.StreamInstances$$anon$2", ({
  Lcats_instances_StreamInstances$$anon$2: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
/** @constructor */
function $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7() {
  $as_Lcats_Traverse($m_Lcats_instances_package$stream$().Lcats_instances_package$stream$__f_catsStdInstancesForStream);
}
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype = new $h_O();
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype.constructor = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7;
/** @constructor */
function $h_Lcats_instances_StreamInstancesBinCompat0$$anon$7() {
}
$h_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7.prototype;
var $d_Lcats_instances_StreamInstancesBinCompat0$$anon$7 = new $TypeData().initClass($c_Lcats_instances_StreamInstancesBinCompat0$$anon$7, "cats.instances.StreamInstancesBinCompat0$$anon$7", ({
  Lcats_instances_StreamInstancesBinCompat0$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
function $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval(fa$2, f$5, lb$1, i) {
  if ((i < $n(fa$2).length__I())) {
    var $x_1 = $n(fa$2).apply__I__O(i);
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval(fa$2, f$5, lb$1, ((1 + i) | 0))));
    return $as_Lcats_Eval($n(f$5).apply__O__O__O($x_1, new $c_Lcats_Eval$$anon$5(a)));
  } else {
    return lb$1;
  }
}
function $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G$4, fa$7, f$10, size, idx) {
  if ((size > 1)) {
    var leftSize = (((size + ((size >>> 31) | 0)) | 0) >> 1);
    var rightSize = ((size - leftSize) | 0);
    return $n($s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G$4, fa$7, f$10, leftSize, idx)).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((left) => {
      var right = $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G$4, fa$7, f$10, rightSize, ((idx + leftSize) | 0));
      return $n(G$4).map2Eval__O__Lcats_Eval__F2__Lcats_Eval(left, right, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$6, _$7) => {
        $as_jl_Void(_$6);
        $as_jl_Void(_$7);
      })));
    })));
  } else {
    var a = $n(fa$7).apply__I__O(idx);
    $m_Lcats_Eval$();
    var a$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      var gb = $n(f$10).apply__O__O(a);
      return $n(G$4).void__O__O(gb);
    }));
    return new $c_Lcats_Always(a$1);
  }
}
/** @constructor */
function $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6() {
  $as_Lcats_Traverse($m_Lcats_instances_package$vector$().Lcats_instances_package$vector$__f_catsStdInstancesForVector);
}
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype = new $h_O();
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype.constructor = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6;
/** @constructor */
function $h_Lcats_instances_VectorInstancesBinCompat0$$anon$6() {
}
$h_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype;
var $d_Lcats_instances_VectorInstancesBinCompat0$$anon$6 = new $TypeData().initClass($c_Lcats_instances_VectorInstancesBinCompat0$$anon$6, "cats.instances.VectorInstancesBinCompat0$$anon$6", ({
  Lcats_instances_VectorInstancesBinCompat0$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
/** @constructor */
function $c_Lcats_instances_package$eq$() {
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = null;
  $n_Lcats_instances_package$eq$ = this;
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = new $c_Lcats_instances_EqInstances$$anon$1();
}
$c_Lcats_instances_package$eq$.prototype = new $h_O();
$c_Lcats_instances_package$eq$.prototype.constructor = $c_Lcats_instances_package$eq$;
/** @constructor */
function $h_Lcats_instances_package$eq$() {
}
$h_Lcats_instances_package$eq$.prototype = $c_Lcats_instances_package$eq$.prototype;
var $d_Lcats_instances_package$eq$ = new $TypeData().initClass($c_Lcats_instances_package$eq$, "cats.instances.package$eq$", ({
  Lcats_instances_package$eq$: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1
}));
var $n_Lcats_instances_package$eq$;
function $m_Lcats_instances_package$eq$() {
  if ((!$n_Lcats_instances_package$eq$)) {
    $n_Lcats_instances_package$eq$ = new $c_Lcats_instances_package$eq$();
  }
  return $n_Lcats_instances_package$eq$;
}
/** @constructor */
function $c_Lcats_instances_package$invariant$() {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = null;
  $n_Lcats_instances_package$invariant$ = this;
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_InvariantInstances__$init$__V(this);
}
$c_Lcats_instances_package$invariant$.prototype = new $h_O();
$c_Lcats_instances_package$invariant$.prototype.constructor = $c_Lcats_instances_package$invariant$;
/** @constructor */
function $h_Lcats_instances_package$invariant$() {
}
$h_Lcats_instances_package$invariant$.prototype = $c_Lcats_instances_package$invariant$.prototype;
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = x$0;
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = x$0;
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V = (function(x$0) {
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V = (function(x$0) {
});
var $d_Lcats_instances_package$invariant$ = new $TypeData().initClass($c_Lcats_instances_package$invariant$, "cats.instances.package$invariant$", ({
  Lcats_instances_package$invariant$: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_instances_InvariantInstances: 1,
  Lcats_instances_InvariantInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$invariant$;
function $m_Lcats_instances_package$invariant$() {
  if ((!$n_Lcats_instances_package$invariant$)) {
    $n_Lcats_instances_package$invariant$ = new $c_Lcats_instances_package$invariant$();
  }
  return $n_Lcats_instances_package$invariant$;
}
/** @constructor */
function $c_Lcats_instances_package$order$() {
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = null;
  $n_Lcats_instances_package$order$ = this;
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = new $c_Lcats_instances_OrderInstances$$anon$1();
}
$c_Lcats_instances_package$order$.prototype = new $h_O();
$c_Lcats_instances_package$order$.prototype.constructor = $c_Lcats_instances_package$order$;
/** @constructor */
function $h_Lcats_instances_package$order$() {
}
$h_Lcats_instances_package$order$.prototype = $c_Lcats_instances_package$order$.prototype;
var $d_Lcats_instances_package$order$ = new $TypeData().initClass($c_Lcats_instances_package$order$, "cats.instances.package$order$", ({
  Lcats_instances_package$order$: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1
}));
var $n_Lcats_instances_package$order$;
function $m_Lcats_instances_package$order$() {
  if ((!$n_Lcats_instances_package$order$)) {
    $n_Lcats_instances_package$order$ = new $c_Lcats_instances_package$order$();
  }
  return $n_Lcats_instances_package$order$;
}
/** @constructor */
function $c_Lcats_instances_package$partialOrder$() {
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = null;
  $n_Lcats_instances_package$partialOrder$ = this;
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = new $c_Lcats_instances_PartialOrderInstances$$anon$1();
}
$c_Lcats_instances_package$partialOrder$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrder$.prototype.constructor = $c_Lcats_instances_package$partialOrder$;
/** @constructor */
function $h_Lcats_instances_package$partialOrder$() {
}
$h_Lcats_instances_package$partialOrder$.prototype = $c_Lcats_instances_package$partialOrder$.prototype;
var $d_Lcats_instances_package$partialOrder$ = new $TypeData().initClass($c_Lcats_instances_package$partialOrder$, "cats.instances.package$partialOrder$", ({
  Lcats_instances_package$partialOrder$: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1
}));
var $n_Lcats_instances_package$partialOrder$;
function $m_Lcats_instances_package$partialOrder$() {
  if ((!$n_Lcats_instances_package$partialOrder$)) {
    $n_Lcats_instances_package$partialOrder$ = new $c_Lcats_instances_package$partialOrder$();
  }
  return $n_Lcats_instances_package$partialOrder$;
}
/** @constructor */
function $c_Lcats_kernel_Hash$$anon$3() {
}
$c_Lcats_kernel_Hash$$anon$3.prototype = new $h_O();
$c_Lcats_kernel_Hash$$anon$3.prototype.constructor = $c_Lcats_kernel_Hash$$anon$3;
/** @constructor */
function $h_Lcats_kernel_Hash$$anon$3() {
}
$h_Lcats_kernel_Hash$$anon$3.prototype = $c_Lcats_kernel_Hash$$anon$3.prototype;
$c_Lcats_kernel_Hash$$anon$3.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Hash$$anon$3.prototype.hash__O__I = (function(x) {
  return $dp_hashCode__I($n(x));
});
$c_Lcats_kernel_Hash$$anon$3.prototype.eqv__O__O__Z = (function(x, y) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
});
var $d_Lcats_kernel_Hash$$anon$3 = new $TypeData().initClass($c_Lcats_kernel_Hash$$anon$3, "cats.kernel.Hash$$anon$3", ({
  Lcats_kernel_Hash$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_Hash: 1
}));
function $f_Lcats_kernel_Order__partialCompare__O__O__D($thiz, x, y) {
  return $thiz.compare__O__O__I(x, y);
}
function $f_Lcats_kernel_Order__min__O__O__O($thiz, x, y) {
  return ($thiz.lt__O__O__Z(x, y) ? x : y);
}
function $f_Lcats_kernel_Order__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0);
}
function $f_Lcats_kernel_Order__neqv__O__O__Z($thiz, x, y) {
  return (!$thiz.eqv__O__O__Z(x, y));
}
function $f_Lcats_kernel_Order__lt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) < 0);
}
function $is_Lcats_kernel_Order(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Order)));
}
function $as_Lcats_kernel_Order(obj) {
  return (($is_Lcats_kernel_Order(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Order"));
}
function $isArrayOf_Lcats_kernel_Order(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Order)));
}
function $asArrayOf_Lcats_kernel_Order(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Order(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Order;", depth));
}
/** @constructor */
function $c_Lcats_kernel_PartialOrder$() {
}
$c_Lcats_kernel_PartialOrder$.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_PartialOrder$.prototype.constructor = $c_Lcats_kernel_PartialOrder$;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$() {
}
$h_Lcats_kernel_PartialOrder$.prototype = $c_Lcats_kernel_PartialOrder$.prototype;
var $d_Lcats_kernel_PartialOrder$ = new $TypeData().initClass($c_Lcats_kernel_PartialOrder$, "cats.kernel.PartialOrder$", ({
  Lcats_kernel_PartialOrder$: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1
}));
var $n_Lcats_kernel_PartialOrder$;
function $m_Lcats_kernel_PartialOrder$() {
  if ((!$n_Lcats_kernel_PartialOrder$)) {
    $n_Lcats_kernel_PartialOrder$ = new $c_Lcats_kernel_PartialOrder$();
  }
  return $n_Lcats_kernel_PartialOrder$;
}
/** @constructor */
function $c_Lcats_kernel_PartialOrder$$anon$1(ev$7, f$5) {
  this.Lcats_kernel_PartialOrder$$anon$1__f_ev$4 = null;
  this.Lcats_kernel_PartialOrder$$anon$1__f_f$3 = null;
  this.Lcats_kernel_PartialOrder$$anon$1__f_ev$4 = ev$7;
  this.Lcats_kernel_PartialOrder$$anon$1__f_f$3 = f$5;
}
$c_Lcats_kernel_PartialOrder$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.constructor = $c_Lcats_kernel_PartialOrder$$anon$1;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$$anon$1() {
}
$h_Lcats_kernel_PartialOrder$$anon$1.prototype = $c_Lcats_kernel_PartialOrder$$anon$1.prototype;
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_PartialOrder$$anon$1.prototype.partialCompare__O__O__D = (function(x, y) {
  var ev$1 = this.Lcats_kernel_PartialOrder$$anon$1__f_ev$4;
  var f$1 = this.Lcats_kernel_PartialOrder$$anon$1__f_f$3;
  return $n(ev$1).partialCompare__O__O__D($n(f$1).apply__O__O(x), $n(f$1).apply__O__O(y));
});
var $d_Lcats_kernel_PartialOrder$$anon$1 = new $TypeData().initClass($c_Lcats_kernel_PartialOrder$$anon$1, "cats.kernel.PartialOrder$$anon$1", ({
  Lcats_kernel_PartialOrder$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_LazyListMonoid() {
}
$c_Lcats_kernel_instances_LazyListMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_LazyListMonoid.prototype.constructor = $c_Lcats_kernel_instances_LazyListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_LazyListMonoid() {
}
$h_Lcats_kernel_instances_LazyListMonoid.prototype = $c_Lcats_kernel_instances_LazyListMonoid.prototype;
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combineAll__sc_IterableOnce__sci_LazyList = (function(xs) {
  return $as_sci_LazyList($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O(($m_sci_LazyList$(), new $c_sci_LazyList$LazyBuilder()), xs));
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.empty__O = (function() {
  var this$1 = $m_sci_LazyList$();
  return this$1.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_LazyList(x);
  var y$1 = $as_sci_LazyList(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_LazyList(y$1);
});
$c_Lcats_kernel_instances_LazyListMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_LazyList(as);
});
var $d_Lcats_kernel_instances_LazyListMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_LazyListMonoid, "cats.kernel.instances.LazyListMonoid", ({
  Lcats_kernel_instances_LazyListMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_ListMonoid() {
}
$c_Lcats_kernel_instances_ListMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_ListMonoid.prototype.constructor = $c_Lcats_kernel_instances_ListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_ListMonoid() {
}
$h_Lcats_kernel_instances_ListMonoid.prototype = $c_Lcats_kernel_instances_ListMonoid.prototype;
$c_Lcats_kernel_instances_ListMonoid.prototype.combineAll__sc_IterableOnce__sci_List = (function(xs) {
  return $as_sci_List($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O(new $c_scm_ListBuffer(), xs));
});
$c_Lcats_kernel_instances_ListMonoid.prototype.empty__O = (function() {
  return $m_sci_Nil$();
});
$c_Lcats_kernel_instances_ListMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_List(x);
  var y$1 = $as_sci_List(y);
  return $n(y$1).$colon$colon$colon__sci_List__sci_List(x$1);
});
$c_Lcats_kernel_instances_ListMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_List(as);
});
var $d_Lcats_kernel_instances_ListMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_ListMonoid, "cats.kernel.instances.ListMonoid", ({
  Lcats_kernel_instances_ListMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_QueueMonoid() {
}
$c_Lcats_kernel_instances_QueueMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_QueueMonoid.prototype.constructor = $c_Lcats_kernel_instances_QueueMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_QueueMonoid() {
}
$h_Lcats_kernel_instances_QueueMonoid.prototype = $c_Lcats_kernel_instances_QueueMonoid.prototype;
$c_Lcats_kernel_instances_QueueMonoid.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$();
});
$c_Lcats_kernel_instances_QueueMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Queue(x);
  var y$1 = $as_sci_Queue(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Queue(y$1);
});
$c_Lcats_kernel_instances_QueueMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $as_sci_Queue($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O($m_sci_Queue$().newBuilder__scm_Builder(), as));
});
var $d_Lcats_kernel_instances_QueueMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_QueueMonoid, "cats.kernel.instances.QueueMonoid", ({
  Lcats_kernel_instances_QueueMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_SeqMonoid() {
}
$c_Lcats_kernel_instances_SeqMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_SeqMonoid.prototype.constructor = $c_Lcats_kernel_instances_SeqMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_SeqMonoid() {
}
$h_Lcats_kernel_instances_SeqMonoid.prototype = $c_Lcats_kernel_instances_SeqMonoid.prototype;
$c_Lcats_kernel_instances_SeqMonoid.prototype.empty__O = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Seq(x);
  var y$1 = $as_sci_Seq(y);
  var this$1 = $n(x$1);
  return $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(y$1));
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $as_sci_Seq($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O($m_sci_Seq$().newBuilder__scm_Builder(), as));
});
function $as_Lcats_kernel_instances_SeqMonoid(obj) {
  return (((obj instanceof $c_Lcats_kernel_instances_SeqMonoid) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.instances.SeqMonoid"));
}
function $isArrayOf_Lcats_kernel_instances_SeqMonoid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_instances_SeqMonoid)));
}
function $asArrayOf_Lcats_kernel_instances_SeqMonoid(obj, depth) {
  return (($isArrayOf_Lcats_kernel_instances_SeqMonoid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.instances.SeqMonoid;", depth));
}
var $d_Lcats_kernel_instances_SeqMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_SeqMonoid, "cats.kernel.instances.SeqMonoid", ({
  Lcats_kernel_instances_SeqMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_StreamMonoid() {
}
$c_Lcats_kernel_instances_StreamMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StreamMonoid.prototype.constructor = $c_Lcats_kernel_instances_StreamMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StreamMonoid() {
}
$h_Lcats_kernel_instances_StreamMonoid.prototype = $c_Lcats_kernel_instances_StreamMonoid.prototype;
$c_Lcats_kernel_instances_StreamMonoid.prototype.combineAll__sc_IterableOnce__sci_Stream = (function(xs) {
  return $as_sci_Stream($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O($m_sci_Stream$().newBuilder__scm_Builder(), xs));
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$();
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Stream(x);
  var y$1 = $as_sci_Stream(y);
  var this$1 = $n(x$1);
  return $as_sci_Stream($f_sc_IterableOps__concat__sc_IterableOnce__O(this$1, y$1));
});
$c_Lcats_kernel_instances_StreamMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_Stream(as);
});
var $d_Lcats_kernel_instances_StreamMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_StreamMonoid, "cats.kernel.instances.StreamMonoid", ({
  Lcats_kernel_instances_StreamMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_StringMonoid() {
}
$c_Lcats_kernel_instances_StringMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StringMonoid.prototype.constructor = $c_Lcats_kernel_instances_StringMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StringMonoid() {
}
$h_Lcats_kernel_instances_StringMonoid.prototype = $c_Lcats_kernel_instances_StringMonoid.prototype;
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__T__T__T = (function(x, y) {
  return (("" + x) + y);
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combineAll__sc_IterableOnce__T = (function(xs) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var this$1 = $n($n(xs).iterator__sc_Iterator());
  while (this$1.hasNext__Z()) {
    var x0 = this$1.next__O();
    var s = $as_T(x0);
    sb.append__T__scm_StringBuilder(s);
  }
  return $n(sb.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lcats_kernel_instances_StringMonoid.prototype.empty__O = (function() {
  return "";
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T__T__T($as_T(x), $as_T(y));
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__T(as);
});
var $d_Lcats_kernel_instances_StringMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_StringMonoid, "cats.kernel.instances.StringMonoid", ({
  Lcats_kernel_instances_StringMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_VectorMonoid() {
}
$c_Lcats_kernel_instances_VectorMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_VectorMonoid.prototype.constructor = $c_Lcats_kernel_instances_VectorMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_VectorMonoid() {
}
$h_Lcats_kernel_instances_VectorMonoid.prototype = $c_Lcats_kernel_instances_VectorMonoid.prototype;
$c_Lcats_kernel_instances_VectorMonoid.prototype.combineAll__sc_IterableOnce__sci_Vector = (function(xs) {
  return $as_sci_Vector($m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O(($m_sci_Vector$(), new $c_sci_VectorBuilder()), xs));
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.empty__O = (function() {
  $m_sci_Vector$();
  return $m_sci_Vector0$();
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Vector(x);
  var y$1 = $as_sci_Vector(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Vector(y$1);
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_Vector(as);
});
var $d_Lcats_kernel_instances_VectorMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_VectorMonoid, "cats.kernel.instances.VectorMonoid", ({
  Lcats_kernel_instances_VectorMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
/** @constructor */
function $c_Lfs2_Chunk$$anon$1(outer) {
  this.Lfs2_Chunk$$anon$1__f_i = 0;
  this.Lfs2_Chunk$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lfs2_Chunk$$anon$1__f_$outer = outer;
  this.Lfs2_Chunk$$anon$1__f_i = 0;
}
$c_Lfs2_Chunk$$anon$1.prototype = new $h_O();
$c_Lfs2_Chunk$$anon$1.prototype.constructor = $c_Lfs2_Chunk$$anon$1;
/** @constructor */
function $h_Lfs2_Chunk$$anon$1() {
}
$h_Lfs2_Chunk$$anon$1.prototype = $c_Lfs2_Chunk$$anon$1.prototype;
$c_Lfs2_Chunk$$anon$1.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lfs2_Chunk$$anon$1.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lfs2_Chunk$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lfs2_Chunk$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lfs2_Chunk$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lfs2_Chunk$$anon$1.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lfs2_Chunk$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lfs2_Chunk$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lfs2_Chunk$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lfs2_Chunk$$anon$1.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lfs2_Chunk$$anon$1.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lfs2_Chunk$$anon$1.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lfs2_Chunk$$anon$1.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lfs2_Chunk$$anon$1.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lfs2_Chunk$$anon$1.prototype.hasNext__Z = (function() {
  return (this.Lfs2_Chunk$$anon$1__f_i < $n(this.Lfs2_Chunk$$anon$1__f_$outer).size__I());
});
$c_Lfs2_Chunk$$anon$1.prototype.next__O = (function() {
  var result = $n(this.Lfs2_Chunk$$anon$1__f_$outer).apply__I__O(this.Lfs2_Chunk$$anon$1__f_i);
  this.Lfs2_Chunk$$anon$1__f_i = ((1 + this.Lfs2_Chunk$$anon$1__f_i) | 0);
  return result;
});
var $d_Lfs2_Chunk$$anon$1 = new $TypeData().initClass($c_Lfs2_Chunk$$anon$1, "fs2.Chunk$$anon$1", ({
  Lfs2_Chunk$$anon$1: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
/** @constructor */
function $c_Lfs2_Pull$AlgEffect() {
}
$c_Lfs2_Pull$AlgEffect.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$AlgEffect.prototype.constructor = $c_Lfs2_Pull$AlgEffect;
/** @constructor */
function $h_Lfs2_Pull$AlgEffect() {
}
$h_Lfs2_Pull$AlgEffect.prototype = $c_Lfs2_Pull$AlgEffect.prototype;
function $as_Lfs2_Pull$AlgEffect(obj) {
  return (((obj instanceof $c_Lfs2_Pull$AlgEffect) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$AlgEffect"));
}
function $isArrayOf_Lfs2_Pull$AlgEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$AlgEffect)));
}
function $asArrayOf_Lfs2_Pull$AlgEffect(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$AlgEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$AlgEffect;", depth));
}
function $ct_Lfs2_Pull$Bind__Lfs2_Pull__($thiz, step) {
  $thiz.Lfs2_Pull$Bind__f_step = step;
  return $thiz;
}
/** @constructor */
function $c_Lfs2_Pull$Bind() {
  this.Lfs2_Pull$Bind__f_step = null;
}
$c_Lfs2_Pull$Bind.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Bind.prototype.constructor = $c_Lfs2_Pull$Bind;
/** @constructor */
function $h_Lfs2_Pull$Bind() {
}
$h_Lfs2_Pull$Bind.prototype = $c_Lfs2_Pull$Bind.prototype;
$c_Lfs2_Pull$Bind.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lfs2_Pull$Bind.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Lfs2_Pull$Bind.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lfs2_Pull$Bind.prototype.delegate__Lfs2_Pull$Bind = (function() {
  return this;
});
$c_Lfs2_Pull$Bind.prototype.apply__O__O = (function(v1) {
  var r = $as_Lfs2_Pull$Terminal(v1);
  return this.cont__Lfs2_Pull$Terminal__Lfs2_Pull(r);
});
$c_Lfs2_Pull$Bind.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  $as_Lfs2_Pull$Terminal(v1);
});
function $as_Lfs2_Pull$Bind(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Bind) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Bind"));
}
function $isArrayOf_Lfs2_Pull$Bind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Bind)));
}
function $asArrayOf_Lfs2_Pull$Bind(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Bind(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Bind;", depth));
}
function $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($thiz, outcome) {
  var wrapped = $n($thiz.Lfs2_internal_InterruptContext__f_ref).update__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    var _$2$1 = $as_s_Option(_$2);
    var this$1 = $n(_$2$1);
    return (this$1.isEmpty__Z() ? new $c_s_Some(outcome) : this$1);
  })));
  var target = $n($thiz.Lfs2_internal_InterruptContext__f_deferred).complete__O__O(outcome);
  var tc = $thiz.Lfs2_internal_InterruptContext__f_F;
  var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var fin = $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
  var F = $thiz.Lfs2_internal_InterruptContext__f_F;
  return $n(F).guarantee__O__O__O(wrapped, fin);
}
/** @constructor */
function $c_Lfs2_internal_InterruptContext(deferred, ref, interruptRoot, cancelParent, F) {
  this.Lfs2_internal_InterruptContext__f_deferred = null;
  this.Lfs2_internal_InterruptContext__f_ref = null;
  this.Lfs2_internal_InterruptContext__f_interruptRoot = null;
  this.Lfs2_internal_InterruptContext__f_cancelParent = null;
  this.Lfs2_internal_InterruptContext__f_F = null;
  this.Lfs2_internal_InterruptContext__f_deferred = deferred;
  this.Lfs2_internal_InterruptContext__f_ref = ref;
  this.Lfs2_internal_InterruptContext__f_interruptRoot = interruptRoot;
  this.Lfs2_internal_InterruptContext__f_cancelParent = cancelParent;
  this.Lfs2_internal_InterruptContext__f_F = F;
}
$c_Lfs2_internal_InterruptContext.prototype = new $h_O();
$c_Lfs2_internal_InterruptContext.prototype.constructor = $c_Lfs2_internal_InterruptContext;
/** @constructor */
function $h_Lfs2_internal_InterruptContext() {
}
$h_Lfs2_internal_InterruptContext.prototype = $c_Lfs2_internal_InterruptContext.prototype;
$c_Lfs2_internal_InterruptContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_InterruptContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_internal_InterruptContext.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_InterruptContext)) {
    var x$0$2 = $as_Lfs2_internal_InterruptContext(x$0);
    var x = this.Lfs2_internal_InterruptContext__f_deferred;
    var x$2 = $n(x$0$2).Lfs2_internal_InterruptContext__f_deferred;
    if ((x === null)) {
      var $x_3 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_3 = (this$1 === x$2);
    }
    if ($x_3) {
      var x$3 = this.Lfs2_internal_InterruptContext__f_ref;
      var x$4 = $n(x$0$2).Lfs2_internal_InterruptContext__f_ref;
      if ((x$3 === null)) {
        var $x_2 = (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        var $x_2 = (this$2 === x$4);
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Lfs2_internal_InterruptContext__f_interruptRoot;
      var x$6 = $n(x$0$2).Lfs2_internal_InterruptContext__f_interruptRoot;
      if ((x$5 === null)) {
        var $x_1 = (x$6 === null);
      } else {
        var this$3 = $n(x$5);
        var $x_1 = (this$3 === x$6);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$1 = this.Lfs2_internal_InterruptContext__f_cancelParent;
      var y = $n(x$0$2).Lfs2_internal_InterruptContext__f_cancelParent;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_internal_InterruptContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_InterruptContext.prototype.productArity__I = (function() {
  return 4;
});
$c_Lfs2_internal_InterruptContext.prototype.productPrefix__T = (function() {
  return "InterruptContext";
});
$c_Lfs2_internal_InterruptContext.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_internal_InterruptContext__f_deferred;
      break;
    }
    case 1: {
      return this.Lfs2_internal_InterruptContext__f_ref;
      break;
    }
    case 2: {
      return this.Lfs2_internal_InterruptContext__f_interruptRoot;
      break;
    }
    case 3: {
      return this.Lfs2_internal_InterruptContext__f_cancelParent;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lfs2_internal_InterruptContext.prototype.completeWhen__O__O = (function(outcome) {
  var $x_1 = $n(this.Lfs2_internal_InterruptContext__f_F);
  var tc = this.Lfs2_internal_InterruptContext__f_F;
  var this$3 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(outcome, tc);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((outcome$2) => {
    var outcome$1 = $as_Lcats_effect_kernel_Outcome(outcome$2);
    return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(this, outcome$1);
  }));
  return $x_1.start__O__O($n(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$3.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f));
});
$c_Lfs2_internal_InterruptContext.prototype.childContext__Z__Lcats_effect_kernel_Unique$Token__O = (function(interruptible, newScopeId) {
  if (interruptible) {
    var this$1 = $m_Lcats_effect_kernel_implicits$();
    var wrapped = $n(this.Lfs2_internal_InterruptContext__f_deferred).get__O();
    var F = this.Lfs2_internal_InterruptContext__f_F;
    var ev$2 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$1, wrapped, F);
    var F$1 = this.Lfs2_internal_InterruptContext__f_F;
    var target = $n(F$1).start__O__O(ev$2);
    var tc = this.Lfs2_internal_InterruptContext__f_F;
    var this$21 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
    var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fiber) => {
      var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
      var target$1 = $m_Lfs2_internal_InterruptContext$().apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O(newScopeId, $n(fiber$1).cancel__O(), this.Lfs2_internal_InterruptContext__f_F);
      var tc$1 = this.Lfs2_internal_InterruptContext__f_F;
      var this$20 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
      var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((context) => {
        var context$1 = $as_Lfs2_internal_InterruptContext(context);
        var this$16 = $m_Lcats_effect_kernel_implicits$();
        var target$2 = $n(fiber$1).join__O();
        var tc$2 = this.Lfs2_internal_InterruptContext__f_F;
        var this$15 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2);
        var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
          var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
          if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
            var this$8 = $n(x$1$2);
            var x12 = this$8.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var tc$3 = this.Lfs2_internal_InterruptContext__f_F;
            var this$10 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(x12, tc$3);
            var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((i) => {
              var i$1 = $as_Lcats_effect_kernel_Outcome(i);
              return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($n(context$1), i$1);
            }));
            return $n(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$10.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
          }
          if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
            var this$12 = $n(x$1$3);
            var x9 = $as_jl_Throwable(this$12.Lcats_effect_kernel_Outcome$Errored__f_e);
            return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($n(context$1), new $c_Lcats_effect_kernel_Outcome$Errored(x9));
          }
          if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
            return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($n(context$1), new $c_Lcats_effect_kernel_Outcome$Canceled());
          }
          throw new $c_s_MatchError(x$1$1);
        }));
        var wrapped$1 = $n(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$15.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
        var F$2 = this.Lfs2_internal_InterruptContext__f_F;
        var ev$3 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$16, wrapped$1, F$2);
        var F$3 = this.Lfs2_internal_InterruptContext__f_F;
        var target$3 = $n(F$3).start__O__O(ev$3);
        var tc$4 = this.Lfs2_internal_InterruptContext__f_F;
        var this$19 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$4);
        return $n(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$19.Lcats_Functor$ToFunctorOps$$anon$5__f_self, context$1);
      }));
      return $n(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$20.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    }));
    return $n(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$21.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
  } else {
    var instance = this.Lfs2_internal_InterruptContext__f_F;
    var cancelParent$1 = $n(instance).unit__O();
    var deferred$1 = this.Lfs2_internal_InterruptContext__f_deferred;
    var ref$1 = this.Lfs2_internal_InterruptContext__f_ref;
    var interruptRoot$1 = this.Lfs2_internal_InterruptContext__f_interruptRoot;
    var F$4 = this.Lfs2_internal_InterruptContext__f_F;
    var a = new $c_Lfs2_internal_InterruptContext(deferred$1, ref$1, interruptRoot$1, cancelParent$1, F$4);
    var F$5 = this.Lfs2_internal_InterruptContext__f_F;
    return $n(F$5).pure__O__O(a);
  }
});
$c_Lfs2_internal_InterruptContext.prototype.eval__O__O = (function(fa) {
  var target = $n(this.Lfs2_internal_InterruptContext__f_ref).get__O();
  var tc = this.Lfs2_internal_InterruptContext__f_F;
  var this$28 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, tc);
  var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var outcome = $as_Lcats_effect_kernel_Outcome($n($as_s_Some(x$1$1)).s_Some__f_value);
      return $n(this.Lfs2_internal_InterruptContext__f_F).pure__O__O(new $c_s_util_Left(outcome));
    }
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var $x_2 = $n(this.Lfs2_internal_InterruptContext__f_F);
      var $x_1 = $n(this.Lfs2_internal_InterruptContext__f_deferred).get__O();
      var F$1 = this.Lfs2_internal_InterruptContext__f_F;
      var target$1 = $x_2.raceOutcome__O__O__O($x_1, $n(F$1).attempt__O__O(fa));
      var tc$1 = this.Lfs2_internal_InterruptContext__f_F;
      var this$27 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, tc$1);
      var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
        var x$1$3 = $as_s_util_Either(x$1$2);
        if ((x$1$3 instanceof $c_s_util_Right)) {
          var oc = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Right(x$1$3)).s_util_Right__f_value);
          var this$7 = $n(oc);
          if (((this$7 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(this$7), true))) {
            var target$2 = $n(this.Lfs2_internal_InterruptContext__f_F).canceled__O();
            var tc$2 = this.Lfs2_internal_InterruptContext__f_F;
            var this$11 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2);
            var value = new $c_Lcats_effect_kernel_Outcome$Canceled();
            var b = new $c_s_util_Left(value);
            return $n(this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$11.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
          }
          if ((this$7 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$4 = $as_Lcats_effect_kernel_Outcome$Errored(this$7);
            var this$13 = $n(x$1$4);
            var x7 = this$13.Lcats_effect_kernel_Outcome$Errored__f_e;
            var e = $as_jl_Throwable(x7);
            return $n(this.Lfs2_internal_InterruptContext__f_F).raiseError__O__O(e);
          }
          if ((this$7 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$5 = $as_Lcats_effect_kernel_Outcome$Succeeded(this$7);
            var this$15 = $n(x$1$5);
            var x4 = this$15.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var tc$3 = this.Lfs2_internal_InterruptContext__f_F;
            var this$22 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(x4, tc$3);
            var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
              var _$3$1 = $as_s_util_Either(_$3);
              if ((_$3$1 instanceof $c_s_util_Left)) {
                var a = $n($as_s_util_Left(_$3$1)).s_util_Left__f_value;
                var _$4 = $as_jl_Throwable(a);
                var value$1 = new $c_Lcats_effect_kernel_Outcome$Errored(_$4);
                return new $c_s_util_Left(value$1);
              }
              if ((_$3$1 instanceof $c_s_util_Right)) {
                var r = $as_s_util_Right(_$3$1);
                $m_Lcats_syntax_EitherUtil$();
                return r;
              }
              throw new $c_s_MatchError(_$3$1);
            }));
            return $n(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$22.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
          }
          throw new $c_s_MatchError(this$7);
        }
        if ((x$1$3 instanceof $c_s_util_Left)) {
          var oc$2 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Left(x$1$3)).s_util_Left__f_value);
          var this$23 = $n(oc$2);
          var F$2 = this.Lfs2_internal_InterruptContext__f_F;
          var target$3 = $f_Lcats_effect_kernel_Outcome__embed__O__Lcats_effect_kernel_MonadCancel__O(this$23, $n(F$2).never__O(), F$2);
          var tc$4 = this.Lfs2_internal_InterruptContext__f_F;
          var this$26 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, tc$4);
          var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
            var _$5$1 = $as_Lcats_effect_kernel_Outcome(_$5);
            return new $c_s_util_Left(_$5$1);
          }));
          return $n(this$26.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$26.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
        }
        throw new $c_s_MatchError(x$1$3);
      }));
      return $n(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return $n(this$28.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$28.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
});
function $as_Lfs2_internal_InterruptContext(obj) {
  return (((obj instanceof $c_Lfs2_internal_InterruptContext) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.InterruptContext"));
}
function $isArrayOf_Lfs2_internal_InterruptContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_InterruptContext)));
}
function $asArrayOf_Lfs2_internal_InterruptContext(obj, depth) {
  return (($isArrayOf_Lfs2_internal_InterruptContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.InterruptContext;", depth));
}
var $d_Lfs2_internal_InterruptContext = new $TypeData().initClass($c_Lfs2_internal_InterruptContext, "fs2.internal.InterruptContext", ({
  Lfs2_internal_InterruptContext: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_internal_ScopedResource$State(open, finalizer, leases) {
  this.Lfs2_internal_ScopedResource$State__f_open = false;
  this.Lfs2_internal_ScopedResource$State__f_finalizer = null;
  this.Lfs2_internal_ScopedResource$State__f_leases = 0;
  this.Lfs2_internal_ScopedResource$State__f_open = open;
  this.Lfs2_internal_ScopedResource$State__f_finalizer = finalizer;
  this.Lfs2_internal_ScopedResource$State__f_leases = leases;
}
$c_Lfs2_internal_ScopedResource$State.prototype = new $h_O();
$c_Lfs2_internal_ScopedResource$State.prototype.constructor = $c_Lfs2_internal_ScopedResource$State;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$State() {
}
$h_Lfs2_internal_ScopedResource$State.prototype = $c_Lfs2_internal_ScopedResource$State.prototype;
$c_Lfs2_internal_ScopedResource$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_ScopedResource$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lfs2_internal_ScopedResource$State__f_open ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lfs2_internal_ScopedResource$State__f_finalizer;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lfs2_internal_ScopedResource$State__f_leases;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lfs2_internal_ScopedResource$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_ScopedResource$State)) {
    var x$0$2 = $as_Lfs2_internal_ScopedResource$State(x$0);
    if (((this.Lfs2_internal_ScopedResource$State__f_open === $n(x$0$2).Lfs2_internal_ScopedResource$State__f_open) && (this.Lfs2_internal_ScopedResource$State__f_leases === $n(x$0$2).Lfs2_internal_ScopedResource$State__f_leases))) {
      var x = this.Lfs2_internal_ScopedResource$State__f_finalizer;
      var x$2 = $n(x$0$2).Lfs2_internal_ScopedResource$State__f_finalizer;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_internal_ScopedResource$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_ScopedResource$State.prototype.productArity__I = (function() {
  return 3;
});
$c_Lfs2_internal_ScopedResource$State.prototype.productPrefix__T = (function() {
  return "State";
});
$c_Lfs2_internal_ScopedResource$State.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_internal_ScopedResource$State__f_open;
      break;
    }
    case 1: {
      return this.Lfs2_internal_ScopedResource$State__f_finalizer;
      break;
    }
    case 2: {
      return this.Lfs2_internal_ScopedResource$State__f_leases;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lfs2_internal_ScopedResource$State(obj) {
  return (((obj instanceof $c_Lfs2_internal_ScopedResource$State) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.ScopedResource$State"));
}
function $isArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_ScopedResource$State)));
}
function $asArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) {
  return (($isArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.ScopedResource$State;", depth));
}
var $d_Lfs2_internal_ScopedResource$State = new $TypeData().initClass($c_Lfs2_internal_ScopedResource$State, "fs2.internal.ScopedResource$State", ({
  Lfs2_internal_ScopedResource$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_CursorOp() {
}
$c_Lio_circe_CursorOp.prototype = new $h_O();
$c_Lio_circe_CursorOp.prototype.constructor = $c_Lio_circe_CursorOp;
/** @constructor */
function $h_Lio_circe_CursorOp() {
}
$h_Lio_circe_CursorOp.prototype = $c_Lio_circe_CursorOp.prototype;
$c_Lio_circe_CursorOp.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $as_Lio_circe_CursorOp(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp"));
}
function $isArrayOf_Lio_circe_CursorOp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp)));
}
function $asArrayOf_Lio_circe_CursorOp(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp;", depth));
}
/** @constructor */
function $c_Lio_circe_Decoder$$anon$27() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Int");
}
$c_Lio_circe_Decoder$$anon$27.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$27.prototype.constructor = $c_Lio_circe_Decoder$$anon$27;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$27() {
}
$h_Lio_circe_Decoder$$anon$27.prototype = $c_Lio_circe_Decoder$$anon$27.prototype;
$c_Lio_circe_Decoder$$anon$27.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x235 = $n(c).value__Lio_circe_Json();
  if ((x235 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x235);
    var this$2 = $n(x$1);
    var x241 = this$2.Lio_circe_Json$JNumber__f_value;
    var x229 = $n(x241).toInt__s_Option();
    if ((x229 instanceof $c_s_Some)) {
      var v = $uI($n($as_s_Some(x229)).s_Some__f_value);
      return new $c_s_util_Right(v);
    }
    var x = $m_s_None$();
    if ((x === x229)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c);
    }
    throw new $c_s_MatchError(x229);
  }
  if ((x235 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x235);
    var this$5 = $n(x$1$1);
    var x238 = this$5.Lio_circe_Json$JString__f_value;
    var this$6 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(x238));
    if (this$6.isEmpty__Z()) {
      var x232 = $m_s_None$();
    } else {
      var x0 = this$6.get__O();
      var _$14 = $as_Lio_circe_JsonNumber(x0);
      var x232 = $n(_$14).toInt__s_Option();
    }
    if ((x232 instanceof $c_s_Some)) {
      var value = $uI($n($as_s_Some(x232)).s_Some__f_value);
      return new $c_s_util_Right(value);
    }
    var x$3 = $m_s_None$();
    if ((x$3 === x232)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c);
    }
    throw new $c_s_MatchError(x232);
  }
  return this.fail__Lio_circe_HCursor__s_util_Either(c);
});
var $d_Lio_circe_Decoder$$anon$27 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$27, "io.circe.Decoder$$anon$27", ({
  Lio_circe_Decoder$$anon$27: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
/** @constructor */
function $c_Lio_circe_Decoder$$anon$28() {
  this.Lio_circe_Decoder$DecoderWithFailure__f_name = null;
  $ct_Lio_circe_Decoder$DecoderWithFailure__T__(this, "Long");
}
$c_Lio_circe_Decoder$$anon$28.prototype = new $h_Lio_circe_Decoder$DecoderWithFailure();
$c_Lio_circe_Decoder$$anon$28.prototype.constructor = $c_Lio_circe_Decoder$$anon$28;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$28() {
}
$h_Lio_circe_Decoder$$anon$28.prototype = $c_Lio_circe_Decoder$$anon$28.prototype;
$c_Lio_circe_Decoder$$anon$28.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x248 = $n(c).value__Lio_circe_Json();
  if ((x248 instanceof $c_Lio_circe_Json$JNumber)) {
    var x$1 = $as_Lio_circe_Json$JNumber(x248);
    var this$2 = $n(x$1);
    var x254 = this$2.Lio_circe_Json$JNumber__f_value;
    var x242 = $n(x254).toLong__s_Option();
    if ((x242 instanceof $c_s_Some)) {
      var $x_1 = $uJ($n($as_s_Some(x242)).s_Some__f_value);
      var v_$_lo = $x_1.l;
      var v_$_hi = $x_1.h;
      return new $c_s_util_Right($bL(v_$_lo, v_$_hi));
    }
    var x = $m_s_None$();
    if ((x === x242)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c);
    }
    throw new $c_s_MatchError(x242);
  }
  if ((x248 instanceof $c_Lio_circe_Json$JString)) {
    var x$1$1 = $as_Lio_circe_Json$JString(x248);
    var this$5 = $n(x$1$1);
    var x251 = this$5.Lio_circe_Json$JString__f_value;
    var this$6 = $n($m_Lio_circe_JsonNumber$().fromString__T__s_Option(x251));
    if (this$6.isEmpty__Z()) {
      var x245 = $m_s_None$();
    } else {
      var x0 = this$6.get__O();
      var _$15 = $as_Lio_circe_JsonNumber(x0);
      var x245 = $n(_$15).toLong__s_Option();
    }
    if ((x245 instanceof $c_s_Some)) {
      var $x_2 = $uJ($n($as_s_Some(x245)).s_Some__f_value);
      var value_$_lo = $x_2.l;
      var value_$_hi = $x_2.h;
      return new $c_s_util_Right($bL(value_$_lo, value_$_hi));
    }
    var x$3 = $m_s_None$();
    if ((x$3 === x245)) {
      return this.fail__Lio_circe_HCursor__s_util_Either(c);
    }
    throw new $c_s_MatchError(x245);
  }
  return this.fail__Lio_circe_HCursor__s_util_Either(c);
});
var $d_Lio_circe_Decoder$$anon$28 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$28, "io.circe.Decoder$$anon$28", ({
  Lio_circe_Decoder$$anon$28: 1,
  Lio_circe_Decoder$DecoderWithFailure: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
/** @constructor */
function $c_Lio_circe_Decoder$$anon$48(decodeA$3) {
  this.Lio_circe_SeqDecoder__f_decodeA = null;
  $ct_Lio_circe_SeqDecoder__Lio_circe_Decoder__(this, decodeA$3);
}
$c_Lio_circe_Decoder$$anon$48.prototype = new $h_Lio_circe_SeqDecoder();
$c_Lio_circe_Decoder$$anon$48.prototype.constructor = $c_Lio_circe_Decoder$$anon$48;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$48() {
}
$h_Lio_circe_Decoder$$anon$48.prototype = $c_Lio_circe_Decoder$$anon$48.prototype;
var $d_Lio_circe_Decoder$$anon$48 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$48, "io.circe.Decoder$$anon$48", ({
  Lio_circe_Decoder$$anon$48: 1,
  Lio_circe_SeqDecoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
function $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json($thiz, a) {
  return $m_Lio_circe_Json$().fromValues__sc_Iterable__Lio_circe_Json($thiz.encodeArray__O__sci_Vector(a));
}
function $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json($thiz, a) {
  $m_Lio_circe_Json$();
  var value = $thiz.encodeObject__O__Lio_circe_JsonObject(a);
  return new $c_Lio_circe_Json$JObject(value);
}
class $c_Lio_circe_Error extends $c_jl_Exception {
  fillInStackTrace__jl_Throwable() {
    return this;
  }
}
function $as_Lio_circe_Error(obj) {
  return (((obj instanceof $c_Lio_circe_Error) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Error"));
}
function $isArrayOf_Lio_circe_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Error)));
}
function $asArrayOf_Lio_circe_Error(obj, depth) {
  return (($isArrayOf_Lio_circe_Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Error;", depth));
}
/** @constructor */
function $c_Lio_circe_Json() {
}
$c_Lio_circe_Json.prototype = new $h_O();
$c_Lio_circe_Json.prototype.constructor = $c_Lio_circe_Json;
/** @constructor */
function $h_Lio_circe_Json() {
}
$h_Lio_circe_Json.prototype = $c_Lio_circe_Json.prototype;
$c_Lio_circe_Json.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_Json.prototype.toString__T = (function() {
  return $n($m_Lio_circe_Printer$().Lio_circe_Printer$__f_spaces2).print__Lio_circe_Json__T(this);
});
$c_Lio_circe_Json.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_Json)) {
    var that$2 = $as_Lio_circe_Json(that);
    return $n($m_Lio_circe_Json$().Lio_circe_Json$__f_eqJson).eqv__O__O__Z(this, that$2);
  } else {
    return false;
  }
});
function $as_Lio_circe_Json(obj) {
  return (((obj instanceof $c_Lio_circe_Json) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json"));
}
function $isArrayOf_Lio_circe_Json(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json)));
}
function $asArrayOf_Lio_circe_Json(obj, depth) {
  return (($isArrayOf_Lio_circe_Json(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json;", depth));
}
/** @constructor */
function $c_Lio_circe_JsonObject$$anon$6(outer) {
  this.Lio_circe_JsonObject$$anon$6__f_underlying = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var this$1 = $n($n($n(outer).Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5__f_$outer).Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields);
  this.Lio_circe_JsonObject$$anon$6__f_underlying = new $c_ju_HashMap$EntrySet(this$1).iterator__ju_Iterator();
}
$c_Lio_circe_JsonObject$$anon$6.prototype = new $h_O();
$c_Lio_circe_JsonObject$$anon$6.prototype.constructor = $c_Lio_circe_JsonObject$$anon$6;
/** @constructor */
function $h_Lio_circe_JsonObject$$anon$6() {
}
$h_Lio_circe_JsonObject$$anon$6.prototype = $c_Lio_circe_JsonObject$$anon$6.prototype;
$c_Lio_circe_JsonObject$$anon$6.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lio_circe_JsonObject$$anon$6.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lio_circe_JsonObject$$anon$6.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lio_circe_JsonObject$$anon$6.prototype.hasNext__Z = (function() {
  return $n(this.Lio_circe_JsonObject$$anon$6__f_underlying).hasNext__Z();
});
$c_Lio_circe_JsonObject$$anon$6.prototype.next__T2 = (function() {
  var field = $as_ju_Map$Entry($n(this.Lio_circe_JsonObject$$anon$6__f_underlying).next__O());
  var this$1 = $n(field);
  var _1 = this$1.ju_HashMap$Node__f_key;
  var this$2 = $n(field);
  var _2 = this$2.ju_HashMap$Node__f_value;
  return new $c_T2(_1, _2);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_Lio_circe_JsonObject$$anon$6 = new $TypeData().initClass($c_Lio_circe_JsonObject$$anon$6, "io.circe.JsonObject$$anon$6", ({
  Lio_circe_JsonObject$$anon$6: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
/** @constructor */
function $c_Lio_circe_PathToRoot(value) {
  this.Lio_circe_PathToRoot__f_value = null;
  this.Lio_circe_PathToRoot__f_value = value;
}
$c_Lio_circe_PathToRoot.prototype = new $h_O();
$c_Lio_circe_PathToRoot.prototype.constructor = $c_Lio_circe_PathToRoot;
/** @constructor */
function $h_Lio_circe_PathToRoot() {
}
$h_Lio_circe_PathToRoot.prototype = $c_Lio_circe_PathToRoot.prototype;
$c_Lio_circe_PathToRoot.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_PathToRoot.prototype.hashCode__I = (function() {
  $m_Lio_circe_PathToRoot$();
  var this$ = this.Lio_circe_PathToRoot__f_value;
  var this$2 = $n(this$);
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this$2);
});
$c_Lio_circe_PathToRoot.prototype.equals__O__Z = (function(x$0) {
  return $m_Lio_circe_PathToRoot$().equals$extension__sci_Vector__O__Z(this.Lio_circe_PathToRoot__f_value, x$0);
});
$c_Lio_circe_PathToRoot.prototype.toString__T = (function() {
  return $m_Lio_circe_PathToRoot$().toString$extension__sci_Vector__T(this.Lio_circe_PathToRoot__f_value);
});
$c_Lio_circe_PathToRoot.prototype.productArity__I = (function() {
  $m_Lio_circe_PathToRoot$();
  return 1;
});
$c_Lio_circe_PathToRoot.prototype.productPrefix__T = (function() {
  $m_Lio_circe_PathToRoot$();
  return "PathToRoot";
});
$c_Lio_circe_PathToRoot.prototype.productElement__I__O = (function(n) {
  return $m_Lio_circe_PathToRoot$().productElement$extension__sci_Vector__I__O(this.Lio_circe_PathToRoot__f_value, n);
});
function $as_Lio_circe_PathToRoot(obj) {
  return (((obj instanceof $c_Lio_circe_PathToRoot) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.PathToRoot"));
}
function $isArrayOf_Lio_circe_PathToRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_PathToRoot)));
}
function $asArrayOf_Lio_circe_PathToRoot(obj, depth) {
  return (($isArrayOf_Lio_circe_PathToRoot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.PathToRoot;", depth));
}
var $d_Lio_circe_PathToRoot = new $TypeData().initClass($c_Lio_circe_PathToRoot, "io.circe.PathToRoot", ({
  Lio_circe_PathToRoot: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_PathToRoot$PathElem() {
}
$c_Lio_circe_PathToRoot$PathElem.prototype = new $h_O();
$c_Lio_circe_PathToRoot$PathElem.prototype.constructor = $c_Lio_circe_PathToRoot$PathElem;
/** @constructor */
function $h_Lio_circe_PathToRoot$PathElem() {
}
$h_Lio_circe_PathToRoot$PathElem.prototype = $c_Lio_circe_PathToRoot$PathElem.prototype;
$c_Lio_circe_PathToRoot$PathElem.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $as_Lio_circe_PathToRoot$PathElem(obj) {
  return (((obj instanceof $c_Lio_circe_PathToRoot$PathElem) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.PathToRoot$PathElem"));
}
function $isArrayOf_Lio_circe_PathToRoot$PathElem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_PathToRoot$PathElem)));
}
function $asArrayOf_Lio_circe_PathToRoot$PathElem(obj, depth) {
  return (($isArrayOf_Lio_circe_PathToRoot$PathElem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.PathToRoot$PathElem;", depth));
}
function $p_Lio_circe_Printer__concat__T__T__T__T($thiz, left, text, right) {
  var builder = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + left);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + text);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + right);
  return builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
}
/** @constructor */
function $c_Lio_circe_Printer(dropNullValues, indent, lbraceLeft, lbraceRight, rbraceLeft, rbraceRight, lbracketLeft, lbracketRight, rbracketLeft, rbracketRight, lrbracketsEmpty, arrayCommaLeft, arrayCommaRight, objectCommaLeft, objectCommaRight, colonLeft, colonRight, reuseWriters, predictSize, escapeNonAscii, sortKeys) {
  this.Lio_circe_Printer__f_dropNullValues = false;
  this.Lio_circe_Printer__f_indent = null;
  this.Lio_circe_Printer__f_lbraceLeft = null;
  this.Lio_circe_Printer__f_lbraceRight = null;
  this.Lio_circe_Printer__f_rbraceLeft = null;
  this.Lio_circe_Printer__f_rbraceRight = null;
  this.Lio_circe_Printer__f_lbracketLeft = null;
  this.Lio_circe_Printer__f_lbracketRight = null;
  this.Lio_circe_Printer__f_rbracketLeft = null;
  this.Lio_circe_Printer__f_rbracketRight = null;
  this.Lio_circe_Printer__f_lrbracketsEmpty = null;
  this.Lio_circe_Printer__f_arrayCommaLeft = null;
  this.Lio_circe_Printer__f_arrayCommaRight = null;
  this.Lio_circe_Printer__f_objectCommaLeft = null;
  this.Lio_circe_Printer__f_objectCommaRight = null;
  this.Lio_circe_Printer__f_colonLeft = null;
  this.Lio_circe_Printer__f_colonRight = null;
  this.Lio_circe_Printer__f_reuseWriters = false;
  this.Lio_circe_Printer__f_predictSize = false;
  this.Lio_circe_Printer__f_escapeNonAscii = false;
  this.Lio_circe_Printer__f_sortKeys = false;
  this.Lio_circe_Printer__f_io$circe$Printer$$pieces = null;
  this.Lio_circe_Printer__f_stringWriter = null;
  this.Lio_circe_Printer__f_dropNullValues = dropNullValues;
  this.Lio_circe_Printer__f_indent = indent;
  this.Lio_circe_Printer__f_lbraceLeft = lbraceLeft;
  this.Lio_circe_Printer__f_lbraceRight = lbraceRight;
  this.Lio_circe_Printer__f_rbraceLeft = rbraceLeft;
  this.Lio_circe_Printer__f_rbraceRight = rbraceRight;
  this.Lio_circe_Printer__f_lbracketLeft = lbracketLeft;
  this.Lio_circe_Printer__f_lbracketRight = lbracketRight;
  this.Lio_circe_Printer__f_rbracketLeft = rbracketLeft;
  this.Lio_circe_Printer__f_rbracketRight = rbracketRight;
  this.Lio_circe_Printer__f_lrbracketsEmpty = lrbracketsEmpty;
  this.Lio_circe_Printer__f_arrayCommaLeft = arrayCommaLeft;
  this.Lio_circe_Printer__f_arrayCommaRight = arrayCommaRight;
  this.Lio_circe_Printer__f_objectCommaLeft = objectCommaLeft;
  this.Lio_circe_Printer__f_objectCommaRight = objectCommaRight;
  this.Lio_circe_Printer__f_colonLeft = colonLeft;
  this.Lio_circe_Printer__f_colonRight = colonRight;
  this.Lio_circe_Printer__f_reuseWriters = reuseWriters;
  this.Lio_circe_Printer__f_predictSize = predictSize;
  this.Lio_circe_Printer__f_escapeNonAscii = escapeNonAscii;
  this.Lio_circe_Printer__f_sortKeys = sortKeys;
  var this$1 = $n(indent);
  if ((this$1 === "")) {
    var lBraces = $p_Lio_circe_Printer__concat__T__T__T__T(this, lbraceLeft, "{", lbraceRight);
    var rBraces = $p_Lio_circe_Printer__concat__T__T__T__T(this, rbraceRight, "}", rbraceLeft);
    var lBrackets = $p_Lio_circe_Printer__concat__T__T__T__T(this, lbracketLeft, "[", lbracketRight);
    var rBrackets = $p_Lio_circe_Printer__concat__T__T__T__T(this, rbracketLeft, "]", rbracketRight);
    var lrEmptyBrackets = $p_Lio_circe_Printer__concat__T__T__T__T(this, "[", lrbracketsEmpty, "]");
    var arrayCommas = $p_Lio_circe_Printer__concat__T__T__T__T(this, arrayCommaLeft, ",", arrayCommaRight);
    var objectCommas = $p_Lio_circe_Printer__concat__T__T__T__T(this, objectCommaLeft, ",", objectCommaRight);
    var colons = $p_Lio_circe_Printer__concat__T__T__T__T(this, colonLeft, ":", colonRight);
    var $x_1 = new $c_Lio_circe_Printer$ConstantPieces(new $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons));
  } else {
    var $x_1 = new $c_Lio_circe_Printer$$anon$1(this);
  }
  this.Lio_circe_Printer__f_io$circe$Printer$$pieces = $x_1;
  this.Lio_circe_Printer__f_stringWriter = new $c_Lio_circe_Printer$$anon$2();
}
$c_Lio_circe_Printer.prototype = new $h_O();
$c_Lio_circe_Printer.prototype.constructor = $c_Lio_circe_Printer;
/** @constructor */
function $h_Lio_circe_Printer() {
}
$h_Lio_circe_Printer.prototype = $c_Lio_circe_Printer.prototype;
$c_Lio_circe_Printer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_Printer.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash, 1349935098);
  var hash$1 = acc;
  var data = (this.Lio_circe_Printer__f_dropNullValues ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x = this.Lio_circe_Printer__f_indent;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var x$1 = this.Lio_circe_Printer__f_lbraceLeft;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  var x$2 = this.Lio_circe_Printer__f_lbraceRight;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$3);
  var hash$5 = acc;
  var x$3 = this.Lio_circe_Printer__f_rbraceLeft;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$4);
  var hash$6 = acc;
  var x$4 = this.Lio_circe_Printer__f_rbraceRight;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$5);
  var hash$7 = acc;
  var x$5 = this.Lio_circe_Printer__f_lbracketLeft;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$6);
  var hash$8 = acc;
  var x$6 = this.Lio_circe_Printer__f_lbracketRight;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$7);
  var hash$9 = acc;
  var x$7 = this.Lio_circe_Printer__f_rbracketLeft;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$8);
  var hash$10 = acc;
  var x$8 = this.Lio_circe_Printer__f_rbracketRight;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$8);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$9);
  var hash$11 = acc;
  var x$9 = this.Lio_circe_Printer__f_lrbracketsEmpty;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$9);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$10);
  var hash$12 = acc;
  var x$10 = this.Lio_circe_Printer__f_arrayCommaLeft;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$10);
  acc = $m_sr_Statics$().mix__I__I__I(hash$12, data$11);
  var hash$13 = acc;
  var x$11 = this.Lio_circe_Printer__f_arrayCommaRight;
  var data$12 = $m_sr_Statics$().anyHash__O__I(x$11);
  acc = $m_sr_Statics$().mix__I__I__I(hash$13, data$12);
  var hash$14 = acc;
  var x$12 = this.Lio_circe_Printer__f_objectCommaLeft;
  var data$13 = $m_sr_Statics$().anyHash__O__I(x$12);
  acc = $m_sr_Statics$().mix__I__I__I(hash$14, data$13);
  var hash$15 = acc;
  var x$13 = this.Lio_circe_Printer__f_objectCommaRight;
  var data$14 = $m_sr_Statics$().anyHash__O__I(x$13);
  acc = $m_sr_Statics$().mix__I__I__I(hash$15, data$14);
  var hash$16 = acc;
  var x$14 = this.Lio_circe_Printer__f_colonLeft;
  var data$15 = $m_sr_Statics$().anyHash__O__I(x$14);
  acc = $m_sr_Statics$().mix__I__I__I(hash$16, data$15);
  var hash$17 = acc;
  var x$15 = this.Lio_circe_Printer__f_colonRight;
  var data$16 = $m_sr_Statics$().anyHash__O__I(x$15);
  acc = $m_sr_Statics$().mix__I__I__I(hash$17, data$16);
  var hash$18 = acc;
  var data$17 = (this.Lio_circe_Printer__f_reuseWriters ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$18, data$17);
  var hash$19 = acc;
  var data$18 = (this.Lio_circe_Printer__f_predictSize ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$19, data$18);
  var hash$20 = acc;
  var data$19 = (this.Lio_circe_Printer__f_escapeNonAscii ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$20, data$19);
  var hash$21 = acc;
  var data$20 = (this.Lio_circe_Printer__f_sortKeys ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$21, data$20);
  var hash$22 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$22, 21);
});
$c_Lio_circe_Printer.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_Printer)) {
    var x$0$2 = $as_Lio_circe_Printer(x$0);
    return (((((((((((((((((((((this.Lio_circe_Printer__f_dropNullValues === $n(x$0$2).Lio_circe_Printer__f_dropNullValues) && (this.Lio_circe_Printer__f_reuseWriters === $n(x$0$2).Lio_circe_Printer__f_reuseWriters)) && (this.Lio_circe_Printer__f_predictSize === $n(x$0$2).Lio_circe_Printer__f_predictSize)) && (this.Lio_circe_Printer__f_escapeNonAscii === $n(x$0$2).Lio_circe_Printer__f_escapeNonAscii)) && (this.Lio_circe_Printer__f_sortKeys === $n(x$0$2).Lio_circe_Printer__f_sortKeys)) && (this.Lio_circe_Printer__f_indent === $n(x$0$2).Lio_circe_Printer__f_indent)) && (this.Lio_circe_Printer__f_lbraceLeft === $n(x$0$2).Lio_circe_Printer__f_lbraceLeft)) && (this.Lio_circe_Printer__f_lbraceRight === $n(x$0$2).Lio_circe_Printer__f_lbraceRight)) && (this.Lio_circe_Printer__f_rbraceLeft === $n(x$0$2).Lio_circe_Printer__f_rbraceLeft)) && (this.Lio_circe_Printer__f_rbraceRight === $n(x$0$2).Lio_circe_Printer__f_rbraceRight)) && (this.Lio_circe_Printer__f_lbracketLeft === $n(x$0$2).Lio_circe_Printer__f_lbracketLeft)) && (this.Lio_circe_Printer__f_lbracketRight === $n(x$0$2).Lio_circe_Printer__f_lbracketRight)) && (this.Lio_circe_Printer__f_rbracketLeft === $n(x$0$2).Lio_circe_Printer__f_rbracketLeft)) && (this.Lio_circe_Printer__f_rbracketRight === $n(x$0$2).Lio_circe_Printer__f_rbracketRight)) && (this.Lio_circe_Printer__f_lrbracketsEmpty === $n(x$0$2).Lio_circe_Printer__f_lrbracketsEmpty)) && (this.Lio_circe_Printer__f_arrayCommaLeft === $n(x$0$2).Lio_circe_Printer__f_arrayCommaLeft)) && (this.Lio_circe_Printer__f_arrayCommaRight === $n(x$0$2).Lio_circe_Printer__f_arrayCommaRight)) && (this.Lio_circe_Printer__f_objectCommaLeft === $n(x$0$2).Lio_circe_Printer__f_objectCommaLeft)) && (this.Lio_circe_Printer__f_objectCommaRight === $n(x$0$2).Lio_circe_Printer__f_objectCommaRight)) && (this.Lio_circe_Printer__f_colonLeft === $n(x$0$2).Lio_circe_Printer__f_colonLeft)) && (this.Lio_circe_Printer__f_colonRight === $n(x$0$2).Lio_circe_Printer__f_colonRight));
  } else {
    return false;
  }
});
$c_Lio_circe_Printer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_Printer.prototype.productArity__I = (function() {
  return 21;
});
$c_Lio_circe_Printer.prototype.productPrefix__T = (function() {
  return "Printer";
});
$c_Lio_circe_Printer.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lio_circe_Printer__f_dropNullValues;
      break;
    }
    case 1: {
      return this.Lio_circe_Printer__f_indent;
      break;
    }
    case 2: {
      return this.Lio_circe_Printer__f_lbraceLeft;
      break;
    }
    case 3: {
      return this.Lio_circe_Printer__f_lbraceRight;
      break;
    }
    case 4: {
      return this.Lio_circe_Printer__f_rbraceLeft;
      break;
    }
    case 5: {
      return this.Lio_circe_Printer__f_rbraceRight;
      break;
    }
    case 6: {
      return this.Lio_circe_Printer__f_lbracketLeft;
      break;
    }
    case 7: {
      return this.Lio_circe_Printer__f_lbracketRight;
      break;
    }
    case 8: {
      return this.Lio_circe_Printer__f_rbracketLeft;
      break;
    }
    case 9: {
      return this.Lio_circe_Printer__f_rbracketRight;
      break;
    }
    case 10: {
      return this.Lio_circe_Printer__f_lrbracketsEmpty;
      break;
    }
    case 11: {
      return this.Lio_circe_Printer__f_arrayCommaLeft;
      break;
    }
    case 12: {
      return this.Lio_circe_Printer__f_arrayCommaRight;
      break;
    }
    case 13: {
      return this.Lio_circe_Printer__f_objectCommaLeft;
      break;
    }
    case 14: {
      return this.Lio_circe_Printer__f_objectCommaRight;
      break;
    }
    case 15: {
      return this.Lio_circe_Printer__f_colonLeft;
      break;
    }
    case 16: {
      return this.Lio_circe_Printer__f_colonRight;
      break;
    }
    case 17: {
      return this.Lio_circe_Printer__f_reuseWriters;
      break;
    }
    case 18: {
      return this.Lio_circe_Printer__f_predictSize;
      break;
    }
    case 19: {
      return this.Lio_circe_Printer__f_escapeNonAscii;
      break;
    }
    case 20: {
      return this.Lio_circe_Printer__f_sortKeys;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lio_circe_Printer.prototype.print__Lio_circe_Json__T = (function(json) {
  if ((this.Lio_circe_Printer__f_reuseWriters && (this.Lio_circe_Printer__f_stringWriter !== null))) {
    var w = $as_jl_StringBuilder($n(this.Lio_circe_Printer__f_stringWriter).get__O());
    $n(w).setLength__I__V(0);
    var writer = w;
  } else {
    var writer = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  }
  this.unsafePrintToAppendable__Lio_circe_Json__jl_Appendable__V(json, writer);
  return $n(writer).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lio_circe_Printer.prototype.unsafePrintToAppendable__Lio_circe_Json__jl_Appendable__V = (function(json, out) {
  var folder = new $c_Lio_circe_Printer$AppendableFolder(this, out);
  $n(json).foldWith__Lio_circe_Json$Folder__O(folder);
});
function $as_Lio_circe_Printer(obj) {
  return (((obj instanceof $c_Lio_circe_Printer) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Printer"));
}
function $isArrayOf_Lio_circe_Printer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Printer)));
}
function $asArrayOf_Lio_circe_Printer(obj, depth) {
  return (($isArrayOf_Lio_circe_Printer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Printer;", depth));
}
var $d_Lio_circe_Printer = new $TypeData().initClass($c_Lio_circe_Printer, "io.circe.Printer", ({
  Lio_circe_Printer: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_Printer$$anon$1(outer) {
  this.Lio_circe_Printer$MemoizedPieces__f_indent = null;
  this.Lio_circe_Printer$MemoizedPieces__f_known = null;
  this.Lio_circe_Printer$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_Printer$$anon$1__f_$outer = outer;
  $ct_Lio_circe_Printer$MemoizedPieces__T__(this, $n(outer).Lio_circe_Printer__f_indent);
}
$c_Lio_circe_Printer$$anon$1.prototype = new $h_Lio_circe_Printer$MemoizedPieces();
$c_Lio_circe_Printer$$anon$1.prototype.constructor = $c_Lio_circe_Printer$$anon$1;
/** @constructor */
function $h_Lio_circe_Printer$$anon$1() {
}
$h_Lio_circe_Printer$$anon$1.prototype = $c_Lio_circe_Printer$$anon$1.prototype;
$c_Lio_circe_Printer$$anon$1.prototype.compute__I__Lio_circe_Printer$Pieces = (function(i) {
  var builder = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lbraceLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "{");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lbraceRight, ((1 + i) | 0));
  var lBraces = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_rbraceLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "}");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_rbraceRight, ((1 + i) | 0));
  var rBraces = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lbracketLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "[");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lbracketRight, ((1 + i) | 0));
  var lBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_rbracketLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "]");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_rbracketRight, ((1 + i) | 0));
  var rBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "[");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_lrbracketsEmpty, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "]");
  var lrEmptyBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_arrayCommaLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_arrayCommaRight, ((1 + i) | 0));
  var arrayCommas = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_objectCommaLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_objectCommaRight, ((1 + i) | 0));
  var objectCommas = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_colonLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, $n(this.Lio_circe_Printer$$anon$1__f_$outer).Lio_circe_Printer__f_colonRight, ((1 + i) | 0));
  var colons = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return new $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons);
});
var $d_Lio_circe_Printer$$anon$1 = new $TypeData().initClass($c_Lio_circe_Printer$$anon$1, "io.circe.Printer$$anon$1", ({
  Lio_circe_Printer$$anon$1: 1,
  Lio_circe_Printer$MemoizedPieces: 1,
  Lio_circe_Printer$PiecesAtDepth: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_Printer$AppendableFolder(outer, writer) {
  this.Lio_circe_Printer$PrintingFolder__f_writer = null;
  this.Lio_circe_Printer$PrintingFolder__f_pieces = null;
  this.Lio_circe_Printer$PrintingFolder__f_dropNullValues = false;
  this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = false;
  this.Lio_circe_Printer$PrintingFolder__f_sortKeys = false;
  this.Lio_circe_Printer$PrintingFolder__f_depth = 0;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__(this, writer, $n(outer).Lio_circe_Printer__f_io$circe$Printer$$pieces, $n(outer).Lio_circe_Printer__f_dropNullValues, $n(outer).Lio_circe_Printer__f_escapeNonAscii, $n(outer).Lio_circe_Printer__f_sortKeys);
}
$c_Lio_circe_Printer$AppendableFolder.prototype = new $h_Lio_circe_Printer$PrintingFolder();
$c_Lio_circe_Printer$AppendableFolder.prototype.constructor = $c_Lio_circe_Printer$AppendableFolder;
/** @constructor */
function $h_Lio_circe_Printer$AppendableFolder() {
}
$h_Lio_circe_Printer$AppendableFolder.prototype = $c_Lio_circe_Printer$AppendableFolder.prototype;
$c_Lio_circe_Printer$AppendableFolder.prototype.onBoolean__Z__V = (function(value) {
  $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable(("" + value));
});
$c_Lio_circe_Printer$AppendableFolder.prototype.onBoolean__Z__O = (function(value) {
  this.onBoolean__Z__V(value);
});
$c_Lio_circe_Printer$AppendableFolder.prototype.onNumber__Lio_circe_JsonNumber__O = (function(value) {
  $n(this.Lio_circe_Printer$PrintingFolder__f_writer).append__jl_CharSequence__jl_Appendable($n(value).toString__T());
});
var $d_Lio_circe_Printer$AppendableFolder = new $TypeData().initClass($c_Lio_circe_Printer$AppendableFolder, "io.circe.Printer$AppendableFolder", ({
  Lio_circe_Printer$AppendableFolder: 1,
  Lio_circe_Printer$PrintingFolder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Json$Folder: 1
}));
/** @constructor */
function $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons) {
  this.Lio_circe_Printer$Pieces__f_lBraces = null;
  this.Lio_circe_Printer$Pieces__f_rBraces = null;
  this.Lio_circe_Printer$Pieces__f_lBrackets = null;
  this.Lio_circe_Printer$Pieces__f_rBrackets = null;
  this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets = null;
  this.Lio_circe_Printer$Pieces__f_arrayCommas = null;
  this.Lio_circe_Printer$Pieces__f_objectCommas = null;
  this.Lio_circe_Printer$Pieces__f_colons = null;
  this.Lio_circe_Printer$Pieces__f_lBraces = lBraces;
  this.Lio_circe_Printer$Pieces__f_rBraces = rBraces;
  this.Lio_circe_Printer$Pieces__f_lBrackets = lBrackets;
  this.Lio_circe_Printer$Pieces__f_rBrackets = rBrackets;
  this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets = lrEmptyBrackets;
  this.Lio_circe_Printer$Pieces__f_arrayCommas = arrayCommas;
  this.Lio_circe_Printer$Pieces__f_objectCommas = objectCommas;
  this.Lio_circe_Printer$Pieces__f_colons = colons;
}
$c_Lio_circe_Printer$Pieces.prototype = new $h_O();
$c_Lio_circe_Printer$Pieces.prototype.constructor = $c_Lio_circe_Printer$Pieces;
/** @constructor */
function $h_Lio_circe_Printer$Pieces() {
}
$h_Lio_circe_Printer$Pieces.prototype = $c_Lio_circe_Printer$Pieces.prototype;
$c_Lio_circe_Printer$Pieces.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_Printer$Pieces.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1372040413), true);
});
$c_Lio_circe_Printer$Pieces.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_Printer$Pieces)) {
    var x$0$2 = $as_Lio_circe_Printer$Pieces(x$0);
    return ((((((((this.Lio_circe_Printer$Pieces__f_lBraces === $n(x$0$2).Lio_circe_Printer$Pieces__f_lBraces) && (this.Lio_circe_Printer$Pieces__f_rBraces === $n(x$0$2).Lio_circe_Printer$Pieces__f_rBraces)) && (this.Lio_circe_Printer$Pieces__f_lBrackets === $n(x$0$2).Lio_circe_Printer$Pieces__f_lBrackets)) && (this.Lio_circe_Printer$Pieces__f_rBrackets === $n(x$0$2).Lio_circe_Printer$Pieces__f_rBrackets)) && (this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets === $n(x$0$2).Lio_circe_Printer$Pieces__f_lrEmptyBrackets)) && (this.Lio_circe_Printer$Pieces__f_arrayCommas === $n(x$0$2).Lio_circe_Printer$Pieces__f_arrayCommas)) && (this.Lio_circe_Printer$Pieces__f_objectCommas === $n(x$0$2).Lio_circe_Printer$Pieces__f_objectCommas)) && (this.Lio_circe_Printer$Pieces__f_colons === $n(x$0$2).Lio_circe_Printer$Pieces__f_colons));
  } else {
    return false;
  }
});
$c_Lio_circe_Printer$Pieces.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_Printer$Pieces.prototype.productArity__I = (function() {
  return 8;
});
$c_Lio_circe_Printer$Pieces.prototype.productPrefix__T = (function() {
  return "Pieces";
});
$c_Lio_circe_Printer$Pieces.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lio_circe_Printer$Pieces__f_lBraces;
      break;
    }
    case 1: {
      return this.Lio_circe_Printer$Pieces__f_rBraces;
      break;
    }
    case 2: {
      return this.Lio_circe_Printer$Pieces__f_lBrackets;
      break;
    }
    case 3: {
      return this.Lio_circe_Printer$Pieces__f_rBrackets;
      break;
    }
    case 4: {
      return this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets;
      break;
    }
    case 5: {
      return this.Lio_circe_Printer$Pieces__f_arrayCommas;
      break;
    }
    case 6: {
      return this.Lio_circe_Printer$Pieces__f_objectCommas;
      break;
    }
    case 7: {
      return this.Lio_circe_Printer$Pieces__f_colons;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lio_circe_Printer$Pieces(obj) {
  return (((obj instanceof $c_Lio_circe_Printer$Pieces) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Printer$Pieces"));
}
function $isArrayOf_Lio_circe_Printer$Pieces(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Printer$Pieces)));
}
function $asArrayOf_Lio_circe_Printer$Pieces(obj, depth) {
  return (($isArrayOf_Lio_circe_Printer$Pieces(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Printer$Pieces;", depth));
}
var $d_Lio_circe_Printer$Pieces = new $TypeData().initClass($c_Lio_circe_Printer$Pieces, "io.circe.Printer$Pieces", ({
  Lio_circe_Printer$Pieces: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lio_circe_cursor_ArrayCursor(values, indexValue, parent, changed, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_ArrayCursor__f_values = null;
  this.Lio_circe_cursor_ArrayCursor__f_indexValue = 0;
  this.Lio_circe_cursor_ArrayCursor__f_parent = null;
  this.Lio_circe_cursor_ArrayCursor__f_changed = false;
  this.Lio_circe_cursor_ArrayCursor__f_values = values;
  this.Lio_circe_cursor_ArrayCursor__f_indexValue = indexValue;
  this.Lio_circe_cursor_ArrayCursor__f_parent = parent;
  this.Lio_circe_cursor_ArrayCursor__f_changed = changed;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp);
}
$c_Lio_circe_cursor_ArrayCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_ArrayCursor.prototype.constructor = $c_Lio_circe_cursor_ArrayCursor;
/** @constructor */
function $h_Lio_circe_cursor_ArrayCursor() {
}
$h_Lio_circe_cursor_ArrayCursor.prototype = $c_Lio_circe_cursor_ArrayCursor.prototype;
$c_Lio_circe_cursor_ArrayCursor.prototype.value__Lio_circe_Json = (function() {
  return $as_Lio_circe_Json($n(this.Lio_circe_cursor_ArrayCursor__f_values).apply__I__O(this.Lio_circe_cursor_ArrayCursor__f_indexValue));
});
$c_Lio_circe_cursor_ArrayCursor.prototype.right__Lio_circe_ACursor = (function() {
  var $x_1 = this.Lio_circe_cursor_ArrayCursor__f_indexValue;
  var this$1 = $n(this.Lio_circe_cursor_ArrayCursor__f_values);
  if (($x_1 === ((this$1.length__I() - 1) | 0))) {
    var op = $m_Lio_circe_CursorOp$MoveRight$();
    return new $c_Lio_circe_FailedCursor(this, op);
  } else {
    return new $c_Lio_circe_cursor_ArrayCursor(this.Lio_circe_cursor_ArrayCursor__f_values, ((1 + this.Lio_circe_cursor_ArrayCursor__f_indexValue) | 0), this.Lio_circe_cursor_ArrayCursor__f_parent, this.Lio_circe_cursor_ArrayCursor__f_changed, this, $m_Lio_circe_CursorOp$MoveRight$());
  }
});
function $as_Lio_circe_cursor_ArrayCursor(obj) {
  return (((obj instanceof $c_Lio_circe_cursor_ArrayCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.cursor.ArrayCursor"));
}
function $isArrayOf_Lio_circe_cursor_ArrayCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_cursor_ArrayCursor)));
}
function $asArrayOf_Lio_circe_cursor_ArrayCursor(obj, depth) {
  return (($isArrayOf_Lio_circe_cursor_ArrayCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.cursor.ArrayCursor;", depth));
}
var $d_Lio_circe_cursor_ArrayCursor = new $TypeData().initClass($c_Lio_circe_cursor_ArrayCursor, "io.circe.cursor.ArrayCursor", ({
  Lio_circe_cursor_ArrayCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_cursor_ObjectCursor(obj, keyValue, parent, changed, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_ObjectCursor__f_obj = null;
  this.Lio_circe_cursor_ObjectCursor__f_keyValue = null;
  this.Lio_circe_cursor_ObjectCursor__f_parent = null;
  this.Lio_circe_cursor_ObjectCursor__f_obj = obj;
  this.Lio_circe_cursor_ObjectCursor__f_keyValue = keyValue;
  this.Lio_circe_cursor_ObjectCursor__f_parent = parent;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp);
}
$c_Lio_circe_cursor_ObjectCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_ObjectCursor.prototype.constructor = $c_Lio_circe_cursor_ObjectCursor;
/** @constructor */
function $h_Lio_circe_cursor_ObjectCursor() {
}
$h_Lio_circe_cursor_ObjectCursor.prototype = $c_Lio_circe_cursor_ObjectCursor.prototype;
$c_Lio_circe_cursor_ObjectCursor.prototype.value__Lio_circe_Json = (function() {
  return $n(this.Lio_circe_cursor_ObjectCursor__f_obj).applyUnsafe__T__Lio_circe_Json(this.Lio_circe_cursor_ObjectCursor__f_keyValue);
});
$c_Lio_circe_cursor_ObjectCursor.prototype.right__Lio_circe_ACursor = (function() {
  var op = $m_Lio_circe_CursorOp$MoveRight$();
  return new $c_Lio_circe_FailedCursor(this, op);
});
function $as_Lio_circe_cursor_ObjectCursor(obj) {
  return (((obj instanceof $c_Lio_circe_cursor_ObjectCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.cursor.ObjectCursor"));
}
function $isArrayOf_Lio_circe_cursor_ObjectCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_cursor_ObjectCursor)));
}
function $asArrayOf_Lio_circe_cursor_ObjectCursor(obj, depth) {
  return (($isArrayOf_Lio_circe_cursor_ObjectCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.cursor.ObjectCursor;", depth));
}
var $d_Lio_circe_cursor_ObjectCursor = new $TypeData().initClass($c_Lio_circe_cursor_ObjectCursor, "io.circe.cursor.ObjectCursor", ({
  Lio_circe_cursor_ObjectCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_cursor_TopCursor(value, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_TopCursor__f_value = null;
  this.Lio_circe_cursor_TopCursor__f_value = value;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp);
}
$c_Lio_circe_cursor_TopCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_TopCursor.prototype.constructor = $c_Lio_circe_cursor_TopCursor;
/** @constructor */
function $h_Lio_circe_cursor_TopCursor() {
}
$h_Lio_circe_cursor_TopCursor.prototype = $c_Lio_circe_cursor_TopCursor.prototype;
$c_Lio_circe_cursor_TopCursor.prototype.value__Lio_circe_Json = (function() {
  return this.Lio_circe_cursor_TopCursor__f_value;
});
$c_Lio_circe_cursor_TopCursor.prototype.right__Lio_circe_ACursor = (function() {
  var op = $m_Lio_circe_CursorOp$MoveRight$();
  return new $c_Lio_circe_FailedCursor(this, op);
});
function $as_Lio_circe_cursor_TopCursor(obj) {
  return (((obj instanceof $c_Lio_circe_cursor_TopCursor) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.cursor.TopCursor"));
}
function $isArrayOf_Lio_circe_cursor_TopCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_cursor_TopCursor)));
}
function $asArrayOf_Lio_circe_cursor_TopCursor(obj, depth) {
  return (($isArrayOf_Lio_circe_cursor_TopCursor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.cursor.TopCursor;", depth));
}
var $d_Lio_circe_cursor_TopCursor = new $TypeData().initClass($c_Lio_circe_cursor_TopCursor, "io.circe.cursor.TopCursor", ({
  Lio_circe_cursor_TopCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$$anon$1() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
  $ct_Lio_circe_numbers_BiggerDecimal$Zero__(this);
}
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype = new $h_Lio_circe_numbers_BiggerDecimal$Zero();
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$$anon$1;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$$anon$1() {
}
$h_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype = $c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype;
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.isNegativeZero__Z = (function() {
  return false;
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero)) {
    var other = $as_Lio_circe_numbers_BiggerDecimal$Zero(that);
    return (!$n(other).isNegativeZero__Z());
  } else {
    return false;
  }
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.hashCode__I = (function() {
  var valueInt = (0.0 | 0);
  return ((valueInt === 0.0) ? valueInt : 0);
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.toString__T = (function() {
  return "0";
});
var $d_Lio_circe_numbers_BiggerDecimal$$anon$1 = new $TypeData().initClass($c_Lio_circe_numbers_BiggerDecimal$$anon$1, "io.circe.numbers.BiggerDecimal$$anon$1", ({
  Lio_circe_numbers_BiggerDecimal$$anon$1: 1,
  Lio_circe_numbers_BiggerDecimal$Zero: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$$anon$2() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
  $ct_Lio_circe_numbers_BiggerDecimal$Zero__(this);
}
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype = new $h_Lio_circe_numbers_BiggerDecimal$Zero();
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$$anon$2;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$$anon$2() {
}
$h_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype = $c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype;
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.isNegativeZero__Z = (function() {
  return true;
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero)) {
    var other = $as_Lio_circe_numbers_BiggerDecimal$Zero(that);
    return $n(other).isNegativeZero__Z();
  } else {
    return false;
  }
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.hashCode__I = (function() {
  ((-0) | 0);
  return (-2147483648);
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.toString__T = (function() {
  return "-0";
});
var $d_Lio_circe_numbers_BiggerDecimal$$anon$2 = new $TypeData().initClass($c_Lio_circe_numbers_BiggerDecimal$$anon$2, "io.circe.numbers.BiggerDecimal$$anon$2", ({
  Lio_circe_numbers_BiggerDecimal$$anon$2: 1,
  Lio_circe_numbers_BiggerDecimal$Zero: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  Ljava_io_Serializable: 1
}));
function $as_Ljava_io_IOException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.IOException"));
}
function $isArrayOf_Ljava_io_IOException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_IOException)));
}
function $asArrayOf_Ljava_io_IOException(obj, depth) {
  return (($isArrayOf_Ljava_io_IOException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.IOException;", depth));
}
/** @constructor */
function $c_Ljava_io_OutputStream() {
}
$c_Ljava_io_OutputStream.prototype = new $h_O();
$c_Ljava_io_OutputStream.prototype.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
}
$h_Ljava_io_OutputStream.prototype = $c_Ljava_io_OutputStream.prototype;
class $c_jl_AssertionError extends $c_jl_Error {
  constructor(detailMessage) {
    super();
    var message = ("" + detailMessage);
    if ((detailMessage instanceof $c_jl_Throwable)) {
      var x2 = $as_jl_Throwable(detailMessage);
      var cause = x2;
    } else {
      var cause = null;
    }
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
  }
}
var $d_jl_AssertionError = new $TypeData().initClass($c_jl_AssertionError, "java.lang.AssertionError", ({
  jl_AssertionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $f_jl_Boolean__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_jl_Boolean__hashCode__I($thiz) {
  return ($thiz ? 1231 : 1237);
}
function $f_jl_Boolean__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Boolean__compareTo__O__I($thiz, o) {
  var that = $as_jl_Boolean(o);
  var this$1 = $n(that);
  return (($thiz === this$1) ? 0 : ($thiz ? 1 : (-1)));
}
function $as_jl_Boolean(obj) {
  return ((((typeof obj) === "boolean") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Boolean"));
}
function $isArrayOf_jl_Boolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Boolean)));
}
function $asArrayOf_jl_Boolean(obj, depth) {
  return (($isArrayOf_jl_Boolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Boolean;", depth));
}
var $d_jl_Boolean = new $TypeData().initClass(0, "java.lang.Boolean", ({
  jl_Boolean: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => ((typeof x) === "boolean")));
function $f_jl_Character__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Character__equals__O__Z($thiz, that) {
  if ((that instanceof $Char)) {
    var this$1 = $n($as_jl_Character(that)).c;
    return ($thiz === this$1);
  } else {
    return false;
  }
}
function $f_jl_Character__toString__T($thiz) {
  return ("" + $cToS($thiz));
}
function $f_jl_Character__compareTo__O__I($thiz, o) {
  var that = $as_jl_Character(o);
  var this$1 = $n(that).c;
  return (($thiz - this$1) | 0);
}
function $as_jl_Character(obj) {
  return (((obj instanceof $Char) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Character"));
}
function $isArrayOf_jl_Character(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Character)));
}
function $asArrayOf_jl_Character(obj, depth) {
  return (($isArrayOf_jl_Character(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Character;", depth));
}
var $d_jl_Character = new $TypeData().initClass(0, "java.lang.Character", ({
  jl_Character: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => (x instanceof $Char)));
function $as_jl_InterruptedException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.InterruptedException"));
}
function $isArrayOf_jl_InterruptedException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_InterruptedException)));
}
function $asArrayOf_jl_InterruptedException(obj, depth) {
  return (($isArrayOf_jl_InterruptedException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.InterruptedException;", depth));
}
function $as_jl_LinkageError(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.LinkageError"));
}
function $isArrayOf_jl_LinkageError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_LinkageError)));
}
function $asArrayOf_jl_LinkageError(obj, depth) {
  return (($isArrayOf_jl_LinkageError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.LinkageError;", depth));
}
function $ct_jl_RuntimeException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_RuntimeException extends $c_jl_Exception {
}
var $d_jl_RuntimeException = new $TypeData().initClass($c_jl_RuntimeException, "java.lang.RuntimeException", ({
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_StringBuilder__($thiz) {
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = "";
  return $thiz;
}
function $ct_jl_StringBuilder__T__($thiz, str) {
  $ct_jl_StringBuilder__($thiz);
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = $n(str);
  return $thiz;
}
function $ct_jl_StringBuilder__I__($thiz, initialCapacity) {
  $ct_jl_StringBuilder__($thiz);
  if ((initialCapacity < 0)) {
    $throwNegativeArraySizeException();
  }
  return $thiz;
}
/** @constructor */
function $c_jl_StringBuilder() {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = null;
}
$c_jl_StringBuilder.prototype = new $h_O();
$c_jl_StringBuilder.prototype.constructor = $c_jl_StringBuilder;
/** @constructor */
function $h_jl_StringBuilder() {
}
$h_jl_StringBuilder.prototype = $c_jl_StringBuilder.prototype;
$c_jl_StringBuilder.prototype.append__jl_CharSequence__I__I__jl_StringBuilder = (function(s, start, end) {
  var s2 = ((s === null) ? "null" : s);
  var length = $dp_length__I($n(s2));
  if ((((start < 0) || (start > end)) || (end > length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var str = $dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n(s2), start, end)));
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this;
});
$c_jl_StringBuilder.prototype.append__AC__jl_StringBuilder = (function(str) {
  var this$1 = $m_jl_String$();
  var count = $n(str).u.length;
  var str$1 = this$1.new__AC__I__I__T(str, 0, count);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
  return this;
});
$c_jl_StringBuilder.prototype.deleteCharAt__I__jl_StringBuilder = (function(index) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var this$1 = $n(oldContent);
  if ((index > this$1.length)) {
    $charAt(this$1, index);
  }
  if ((index < 0)) {
    $charAt(this$1, (-1));
  }
  var $x_1 = $as_T(this$1.substring(0, index));
  var this$2 = $n(oldContent);
  var beginIndex = ((1 + index) | 0);
  if (((beginIndex < 0) || (beginIndex > this$2.length))) {
    $charAt(this$2, beginIndex);
  }
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + $x_1) + $as_T(this$2.substring(beginIndex)));
  return this;
});
$c_jl_StringBuilder.prototype.replace__I__I__T__jl_StringBuilder = (function(start, end, str) {
  var strNonNull = $n(str);
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var this$1 = $n(oldContent);
  var length = this$1.length;
  var this$2 = $n(oldContent);
  if ((start > this$2.length)) {
    $charAt(this$2, start);
  }
  if ((start < 0)) {
    $charAt(this$2, (-1));
  }
  var firstPart = (("" + $as_T(this$2.substring(0, start))) + strNonNull);
  if ((end < start)) {
    var this$3 = $n(oldContent);
    $charAt(this$3, (-1));
  }
  if ((end >= length)) {
    var $x_1 = firstPart;
  } else {
    var this$4 = $n(oldContent);
    if (((end < 0) || (end > this$4.length))) {
      $charAt(this$4, end);
    }
    var $x_1 = (firstPart + $as_T(this$4.substring(end)));
  }
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = $x_1;
  return this;
});
$c_jl_StringBuilder.prototype.insert__I__T__jl_StringBuilder = (function(offset, str) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var this$1 = $n(oldContent);
  if ((offset > this$1.length)) {
    $charAt(this$1, offset);
  }
  if ((offset < 0)) {
    $charAt(this$1, (-1));
  }
  var $x_1 = $as_T(this$1.substring(0, offset));
  var this$2 = $n(oldContent);
  if (((offset < 0) || (offset > this$2.length))) {
    $charAt(this$2, offset);
  }
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = ((("" + $x_1) + str) + $as_T(this$2.substring(offset)));
  return this;
});
$c_jl_StringBuilder.prototype.insert__I__C__jl_StringBuilder = (function(offset, c) {
  if ((offset < 0)) {
    var $x_1 = true;
  } else {
    var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
    var $x_1 = (offset > this$1.length);
  }
  if ($x_1) {
    throw $ct_jl_IndexOutOfBoundsException__I__(new $c_jl_IndexOutOfBoundsException(), offset);
  }
  return this.insert__I__T__jl_StringBuilder(offset, ("" + $cToS(c)));
});
$c_jl_StringBuilder.prototype.reverse__jl_StringBuilder = (function() {
  var original = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var result = "";
  var this$1 = $n(original);
  var i = ((this$1.length - 1) | 0);
  while ((i > 0)) {
    var this$2 = $n(original);
    var index = i;
    var c = $charAt(this$2, index);
    if (((64512 & c) === 56320)) {
      var this$4 = $n(original);
      var index$1 = ((i - 1) | 0);
      var c2 = $charAt(this$4, index$1);
      if (((64512 & c2) === 55296)) {
        result = ((((result + "") + $cToS(c2)) + "") + $cToS(c));
        i = ((i - 2) | 0);
      } else {
        result = ((result + "") + $cToS(c));
        i = ((i - 1) | 0);
      }
    } else {
      result = ((result + "") + $cToS(c));
      i = ((i - 1) | 0);
    }
  }
  if ((i === 0)) {
    var $x_1 = result;
    var this$10 = $n(original);
    var this$11 = $charAt(this$10, 0);
    result = ($x_1 + ("" + $cToS(this$11)));
  }
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = result;
  return this;
});
$c_jl_StringBuilder.prototype.toString__T = (function() {
  return this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_jl_StringBuilder.prototype.length__I = (function() {
  var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  return this$1.length;
});
$c_jl_StringBuilder.prototype.setLength__I__V = (function(newLength) {
  var newContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var this$1 = $n(newContent);
  var currentLength = this$1.length;
  if ((newLength >= currentLength)) {
    while ((currentLength !== newLength)) {
      newContent = (newContent + "\u0000");
      currentLength = ((1 + currentLength) | 0);
    }
    this.jl_StringBuilder__f_java$lang$StringBuilder$$content = newContent;
  } else {
    var this$2 = $n(newContent);
    if ((newLength > this$2.length)) {
      $charAt(this$2, newLength);
    }
    if ((newLength < 0)) {
      $charAt(this$2, (-1));
    }
    this.jl_StringBuilder__f_java$lang$StringBuilder$$content = $as_T(this$2.substring(0, newLength));
  }
});
$c_jl_StringBuilder.prototype.charAt__I__C = (function(index) {
  var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  return $charAt(this$1, index);
});
$c_jl_StringBuilder.prototype.getChars__I__I__AC__I__V = (function(srcBegin, srcEnd, dst, dstBegin) {
  $f_T__getChars__I__I__AC__I__V($n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content), srcBegin, srcEnd, dst, dstBegin);
});
$c_jl_StringBuilder.prototype.setCharAt__I__C__V = (function(index, ch) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var this$1 = $n(oldContent);
  if ((index > this$1.length)) {
    $charAt(this$1, index);
  }
  if ((index < 0)) {
    $charAt(this$1, (-1));
  }
  var $x_1 = $as_T(this$1.substring(0, index));
  var this$2 = $n(oldContent);
  var beginIndex = ((1 + index) | 0);
  if (((beginIndex < 0) || (beginIndex > this$2.length))) {
    $charAt(this$2, beginIndex);
  }
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (($x_1 + $cToS(ch)) + $as_T(this$2.substring(beginIndex)));
});
$c_jl_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.substring__I__I__T(start, end);
});
$c_jl_StringBuilder.prototype.substring__I__I__T = (function(start, end) {
  var this$1 = $n(this.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  if ((start < 0)) {
    $charAt(this$1, start);
  }
  if ((end > this$1.length)) {
    $charAt(this$1, end);
  }
  if ((end < start)) {
    $charAt(this$1, (-1));
  }
  return $as_T(this$1.substring(start, end));
});
$c_jl_StringBuilder.prototype.append__C__jl_Appendable = (function(c) {
  var str = ("" + $cToS(c));
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__jl_StringBuilder(csq, start, end);
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + csq);
  return this;
});
function $as_jl_StringBuilder(obj) {
  return (((obj instanceof $c_jl_StringBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.StringBuilder"));
}
function $isArrayOf_jl_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StringBuilder)));
}
function $asArrayOf_jl_StringBuilder(obj, depth) {
  return (($isArrayOf_jl_StringBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.StringBuilder;", depth));
}
var $d_jl_StringBuilder = new $TypeData().initClass($c_jl_StringBuilder, "java.lang.StringBuilder", ({
  jl_StringBuilder: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
}));
function $as_jl_ThreadDeath(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ThreadDeath"));
}
function $isArrayOf_jl_ThreadDeath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ThreadDeath)));
}
function $asArrayOf_jl_ThreadDeath(obj, depth) {
  return (($isArrayOf_jl_ThreadDeath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ThreadDeath;", depth));
}
class $c_jl_VirtualMachineError extends $c_jl_Error {
}
function $as_jl_VirtualMachineError(obj) {
  return (((obj instanceof $c_jl_VirtualMachineError) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.VirtualMachineError"));
}
function $isArrayOf_jl_VirtualMachineError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_VirtualMachineError)));
}
function $asArrayOf_jl_VirtualMachineError(obj, depth) {
  return (($isArrayOf_jl_VirtualMachineError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.VirtualMachineError;", depth));
}
function $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I($thiz, value_$_lo, value_$_hi) {
  if (((value_$_lo | ((-2147483648) ^ value_$_hi)) === 0)) {
    return 19;
  } else {
    var $x_2 = $m_ju_Arrays$();
    var $x_1 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows;
    var sign = (value_$_hi >> 31);
    var xlo = (value_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((value_$_hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var index = $x_2.binarySearch__AJ__J__I($x_1, rlo, rhi);
    return ((index < 0) ? (~index) : ((1 + index) | 0));
  }
}
function $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc) {
  var mcPrecision = $n(mc).Ljava_math_MathContext__f_precision;
  var discardedPrecision = (($thiz.precision__I() - mcPrecision) | 0);
  var mcPrecGood = (($p_Ljava_math_BigDecimal__approxPrecision__I($thiz) < mcPrecision) || (mcPrecision === 0));
  if ((!(mcPrecGood || (discardedPrecision <= 0)))) {
    if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision);
    } else {
      var $x_1 = $m_Ljava_math_Multiplication$();
      var hi = (discardedPrecision >> 31);
      var sizeOfFraction = $x_1.powerOf10__J__Ljava_math_BigInteger(discardedPrecision, hi);
      var integerAndFraction = $n($thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()).divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger(sizeOfFraction);
      var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value >> 31);
      var hi$2 = (discardedPrecision >> 31);
      var lo = ((value - discardedPrecision) | 0);
      var hi$3 = ((((hi$1 - hi$2) | 0) + ((((~value) & discardedPrecision) | ((~(value ^ discardedPrecision)) & lo)) >> 31)) | 0);
      var this$5 = $n($n(integerAndFraction).get(1));
      if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
        var absBi = $n($n(integerAndFraction).get(1)).abs__Ljava_math_BigInteger();
        var compRem = $n($n(absBi).shiftLeftOneBit__Ljava_math_BigInteger()).compareTo__Ljava_math_BigInteger__I(sizeOfFraction);
        var parityBit = ($n($n(integerAndFraction).get(0)).testBit__I__Z(0) ? 1 : 0);
        var this$6 = $n($n(integerAndFraction).get(1));
        var frac = Math.imul(this$6.Ljava_math_BigInteger__f_sign, ((5 + compRem) | 0));
        var carry = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, frac, $n(mc).Ljava_math_MathContext__f_roundingMode);
        if ((carry !== 0)) {
          var $x_2 = $m_Ljava_math_BigInteger$();
          var hi$4 = (carry >> 31);
          var bi = $x_2.valueOf__J__Ljava_math_BigInteger(carry, hi$4);
          var $x_3 = $n(integerAndFraction);
          var this$8 = $n($n(integerAndFraction).get(0));
          $x_3.set(0, $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, bi));
        }
        var tempBD = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__(new $c_Ljava_math_BigDecimal(), $n(integerAndFraction).get(0));
        if ((tempBD.precision__I() > mcPrecision)) {
          $n(integerAndFraction).set(0, $n($n(integerAndFraction).get(0)).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN));
          var lo$1 = ((lo - 1) | 0);
          var hi$5 = ((((hi$3 - 1) | 0) + (((lo | (~lo$1)) >>> 31) | 0)) | 0);
          var newScale_$_lo = lo$1;
          var newScale_$_hi = hi$5;
        } else {
          var newScale_$_lo = lo;
          var newScale_$_hi = hi$3;
        }
      } else {
        var newScale_$_lo = lo;
        var newScale_$_hi = hi$3;
      }
      $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(newScale_$_lo, newScale_$_hi);
      $thiz.Ljava_math_BigDecimal__f__precision = mcPrecision;
      $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $n(integerAndFraction).get(0));
    }
  }
}
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
    var x_$_lo = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
    var x_$_hi = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
    return (((~x_$_lo) | (~x_$_hi)) !== 0);
  } else {
    return false;
  }
}
function $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision) {
  var $x_1 = $n($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows).u;
  var $x_2 = $aJCheckGet($x_1, discardedPrecision);
  var sizeOfFraction_$_lo = $x_1[$x_2];
  var sizeOfFraction_$_hi = $x_1[(($x_2 + 1) | 0)];
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (discardedPrecision >> 31);
  var lo = ((value - discardedPrecision) | 0);
  var hi$2 = ((((hi - hi$1) | 0) + ((((~value) & discardedPrecision) | ((~(value ^ discardedPrecision)) & lo)) >> 31)) | 0);
  var unscaledVal_$_lo = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
  var unscaledVal_$_hi = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
  var $x_3 = $m_RTLong$().divide__I__I__I__I__J(unscaledVal_$_lo, unscaledVal_$_hi, sizeOfFraction_$_lo, sizeOfFraction_$_hi);
  var intPart0_$_lo = $x_3.l;
  var intPart0_$_hi = $x_3.h;
  var a0 = (65535 & sizeOfFraction_$_lo);
  var a1 = ((sizeOfFraction_$_lo >>> 16) | 0);
  var b0 = (65535 & intPart0_$_lo);
  var b1 = ((intPart0_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$3 = ((((((((Math.imul(sizeOfFraction_$_lo, intPart0_$_hi) + Math.imul(sizeOfFraction_$_hi, intPart0_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((unscaledVal_$_lo - lo$1) | 0);
  var hi$4 = ((((unscaledVal_$_hi - hi$3) | 0) + ((((~unscaledVal_$_lo) & lo$1) | ((~(unscaledVal_$_lo ^ lo$1)) & lo$2)) >> 31)) | 0);
  if (((lo$2 | hi$4) !== 0)) {
    var $x_4 = $m_Ljava_math_BigDecimal$();
    var sign = (hi$4 >> 31);
    var xlo = (lo$2 ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi$4 ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var lo$3 = (rlo << 1);
    var hi$5 = (((rlo >>> 31) | 0) | (rhi << 1));
    var compRem = $x_4.java$math$BigDecimal$$longCompareTo__J__J__I(lo$3, hi$5, sizeOfFraction_$_lo, sizeOfFraction_$_hi);
    var lo$4 = (hi$4 >> 31);
    var lo$5 = ((-lo$2) | 0);
    var hi$7 = ((((-hi$4) | 0) + ((lo$2 | lo$5) >> 31)) | 0);
    var lo$6 = ((hi$7 >>> 31) | 0);
    var lo$7 = (lo$4 | lo$6);
    var frac = Math.imul(lo$7, ((5 + compRem) | 0));
    var value$1 = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & intPart0_$_lo), frac, $n(mc).Ljava_math_MathContext__f_roundingMode);
    var hi$8 = (value$1 >> 31);
    var lo$8 = ((intPart0_$_lo + value$1) | 0);
    var hi$9 = ((((intPart0_$_hi + hi$8) | 0) + ((((intPart0_$_lo & value$1) | ((intPart0_$_lo | value$1) & (~lo$8))) >>> 31) | 0)) | 0);
    var sign$1 = (hi$9 >> 31);
    var xlo$1 = (lo$8 ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((hi$9 ^ sign$1) + (((xlo$1 & (~rlo$1)) >>> 31) | 0)) | 0);
    var a = ((4.294967296E9 * rhi$1) + (rlo$1 >>> 0.0));
    if (($uD(Math.log10(a)) >= $n(mc).Ljava_math_MathContext__f_precision)) {
      var lo$9 = ((lo - 1) | 0);
      var hi$10 = ((((hi$2 - 1) | 0) + (((lo | (~lo$9)) >>> 31) | 0)) | 0);
      var hi$11 = (hi$9 >> 31);
      var b0$1 = (65535 & lo$8);
      var b1$1 = ((lo$8 >>> 16) | 0);
      var a0b0$1 = Math.imul(26214, b0$1);
      var a1b0$1 = Math.imul(26214, b0$1);
      var a0b1$1 = Math.imul(26214, b1$1);
      var lo$10 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$12 = ((((Math.imul(26214, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var b0$2 = (65535 & lo$8);
      var b1$2 = ((lo$8 >>> 16) | 0);
      var a0b0$2 = Math.imul(26215, b0$2);
      var a1b0$2 = Math.imul(26214, b0$2);
      var a0b1$2 = Math.imul(26215, b1$2);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$13 = ((((Math.imul(26214, b1$2) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
      var lo$12 = ((lo$10 + hi$13) | 0);
      var hi$14 = ((hi$12 + ((((lo$10 & hi$13) | ((lo$10 | hi$13) & (~lo$12))) >>> 31) | 0)) | 0);
      var b0$3 = (65535 & hi$9);
      var b1$3 = ((hi$9 >>> 16) | 0);
      var a0b0$3 = Math.imul(26214, b0$3);
      var a1b0$3 = Math.imul(26214, b0$3);
      var a0b1$3 = Math.imul(26214, b1$3);
      var lo$13 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$15 = ((((((Math.imul(1717986918, hi$11) + Math.imul(26214, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
      var hi$16 = (hi$14 >> 31);
      var lo$14 = ((lo$13 + hi$14) | 0);
      var hi$17 = ((((hi$15 + hi$16) | 0) + ((((lo$13 & hi$14) | ((lo$13 | hi$14) & (~lo$14))) >>> 31) | 0)) | 0);
      var b0$4 = (65535 & hi$9);
      var b1$4 = ((hi$9 >>> 16) | 0);
      var a0b0$4 = Math.imul(26215, b0$4);
      var a1b0$4 = Math.imul(26214, b0$4);
      var a0b1$4 = Math.imul(26215, b1$4);
      var lo$15 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$18 = ((((((Math.imul(1717986919, hi$11) + Math.imul(26214, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
      var lo$16 = ((lo$12 + lo$15) | 0);
      var hi$19 = ((hi$18 + ((((lo$12 & lo$15) | ((lo$12 | lo$15) & (~lo$16))) >>> 31) | 0)) | 0);
      var hi$20 = (hi$19 >> 31);
      var lo$17 = ((lo$14 + hi$19) | 0);
      var hi$21 = ((((hi$17 + hi$20) | 0) + ((((lo$14 & hi$19) | ((lo$14 | hi$19) & (~lo$17))) >>> 31) | 0)) | 0);
      var lo$18 = (((lo$17 >>> 2) | 0) | (hi$21 << 30));
      var hi$22 = (hi$21 >> 2);
      var lo$19 = ((hi$9 >>> 31) | 0);
      var lo$20 = ((lo$18 + lo$19) | 0);
      var hi$23 = ((hi$22 + ((((lo$18 & lo$19) | ((lo$18 | lo$19) & (~lo$20))) >>> 31) | 0)) | 0);
      var x1___1 = $bL(lo$9, hi$10);
      var x1___2 = $bL(lo$20, hi$23);
    } else {
      var x1___1 = $bL(lo, hi$2);
      var x1___2 = $bL(lo$8, hi$9);
    }
  } else {
    var x1___1 = $bL(lo, hi$2);
    var x1___2 = $bL(intPart0_$_lo, intPart0_$_hi);
  }
  var $x_5 = $uJ(x1___1);
  var newScale_$_lo = $x_5.l;
  var newScale_$_hi = $x_5.h;
  var $x_6 = $uJ(x1___2);
  var intPart_$_lo = $x_6.l;
  var intPart_$_hi = $x_6.h;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(newScale_$_lo, newScale_$_hi);
  $thiz.Ljava_math_BigDecimal__f__precision = $n(mc).Ljava_math_MathContext__f_precision;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo = intPart_$_lo;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi = intPart_$_hi;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(intPart_$_lo, intPart_$_hi);
  $thiz.Ljava_math_BigDecimal__f__intVal = null;
}
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo & value$1) | ((lo | value$1) & (~lo$1))) >>> 31) | 0)) | 0);
  if (((hi$3 === 0) ? ((lo$1 >>> 0) > 19) : (hi$3 > 0))) {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
  var bigInteger = $thiz.toBigIntegerExact__Ljava_math_BigInteger();
  var this$6 = $n(bigInteger);
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$6) < bitLengthOfType)) {
    return $n(bigInteger).longValue__J();
  } else {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
}
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.Ljava_math_BigDecimal__f__precision > 0) ? $thiz.Ljava_math_BigDecimal__f__precision : ((1 + $doubleToInt((0.3010299956639812 * (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength - 1) | 0)))) | 0));
}
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.Ljava_math_BigDecimal__f__intVal = unscaledVal;
  var this$1 = $n(unscaledVal);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1);
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var $x_1 = $n(unscaledVal).longValue__J();
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo = $x_1.l;
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi = $x_1.h;
  }
}
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.Ljava_math_BigDecimal__f__toStringImage = null;
  $thiz.Ljava_math_BigDecimal__f__hashCode = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  $thiz.Ljava_math_BigDecimal__f__precision = 0;
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue_$_lo, smallValue_$_hi, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo = smallValue_$_lo;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi = smallValue_$_hi;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(smallValue_$_lo, smallValue_$_hi);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo = smallValue;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi = hi;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$bitLength__I__I(smallValue);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, in$1, offset, len) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var last = ((((offset + len) | 0) - 1) | 0);
  if (((((last >= $n(in$1).u.length) || (offset < 0)) || (len <= 0)) || (last < 0))) {
    throw new $c_jl_NumberFormatException(((((("Bad offset/length: offset=" + offset) + " len=") + len) + " in.length=") + $n(in$1).u.length));
  }
  var index = offset;
  if (((offset <= last) && ($n(in$1).get(offset) === 43))) {
    index = ((1 + index) | 0);
    if (((index < last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([43, 45]))))) {
      throw new $c_jl_NumberFormatException(("For input string: " + $n(in$1).toString__T()));
    }
  } else {
    var isMinus = ((index <= last) && ($n(in$1).get(index) === 45));
    var nextIsSign = ((((1 + index) | 0) < last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z($n(in$1).get(((1 + index) | 0)), new $ac_C(new Uint16Array([43, 45]))));
    if ((isMinus && nextIsSign)) {
      throw new $c_jl_NumberFormatException(("For input string: " + $n(in$1).toString__T()));
    }
  }
  var begin = index;
  var counter = 0;
  var wasNonZero = false;
  while (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charNotEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([46, 101, 69]))))) {
    if ((!wasNonZero)) {
      if (($n(in$1).get(index) === 48)) {
        counter = ((1 + counter) | 0);
      } else {
        wasNonZero = true;
      }
    }
    index = ((1 + index) | 0);
  }
  var count = ((index - begin) | 0);
  var this$1 = $m_jl_String$();
  var u = this$1.new__AC__I__I__T(in$1, begin, count);
  var b = ((index - begin) | 0);
  if (((index <= last) && ($n(in$1).get(index) === 46))) {
    index = ((1 + index) | 0);
    var begin$2 = index;
    while (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charNotEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([101, 69]))))) {
      if ((!wasNonZero)) {
        if (($n(in$1).get(index) === 48)) {
          counter = ((1 + counter) | 0);
        } else {
          wasNonZero = true;
        }
      }
      index = ((1 + index) | 0);
    }
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = ((index - begin$2) | 0);
    var count$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var this$2 = $m_jl_String$();
    var _1 = (("" + u) + this$2.new__AC__I__I__T(in$1, begin$2, count$1));
    var _2 = ((b + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    var x1___1 = _1;
    var x1___2 = _2;
  } else {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
    var x1___1 = u;
    var x1___2 = b;
  }
  var unscaled = $as_T(x1___1);
  var bufLength = $uI(x1___2);
  if (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z($n(in$1).get(index), new $ac_C(new Uint16Array([101, 69]))))) {
    index = ((1 + index) | 0);
    var indexIsPlus = ((index <= last) && ($n(in$1).get(index) === 43));
    var nextIsNotMinus = ((((1 + index) | 0) <= last) && ($n(in$1).get(((1 + index) | 0)) !== 45));
    var begin$3 = ((indexIsPlus && nextIsNotMinus) ? ((1 + index) | 0) : index);
    var count$2 = ((((1 + last) | 0) - begin$3) | 0);
    var this$3 = $m_jl_String$();
    var scaleString = this$3.new__AC__I__I__T(in$1, begin$3, count$2);
    var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var this$5 = $m_jl_Integer$();
    var value$1 = this$5.java$lang$Integer$$parseIntImpl__T__I__I__I(scaleString, 10, 214748364);
    var hi$1 = (value$1 >> 31);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((hi - hi$1) | 0) + ((((~value) & value$1) | ((~(value ^ value$1)) & lo)) >> 31)) | 0);
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = lo;
    var value$2 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$3 = (value$2 >> 31);
    if ((((lo ^ value$2) | (hi$2 ^ hi$3)) !== 0)) {
      throw new $c_jl_NumberFormatException("Scale out of range");
    }
  }
  if ((bufLength < 19)) {
    var this$11 = $m_jl_Long$();
    var $x_1 = this$11.parseLongImplJS__T__I__J(unscaled, 10);
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo = $x_1.l;
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi = $x_1.h;
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo, $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi);
  } else {
    $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), unscaled));
  }
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__T__($thiz, sVal) {
  var $x_1 = $f_T__toCharArray__AC($n(sVal));
  var this$1 = $n(sVal);
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $x_1, 0, this$1.length);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__($thiz, sVal, mc) {
  var $x_1 = $f_T__toCharArray__AC($n(sVal));
  var this$1 = $n(sVal);
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $x_1, 0, this$1.length);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $n(unscaledVal));
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__($thiz, bi) {
  $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, bi, 0);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__J__($thiz, lVal_$_lo, lVal_$_hi) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal_$_lo, lVal_$_hi, 0);
  return $thiz;
}
function $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__($thiz, lVal_$_lo, lVal_$_hi, mc) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal_$_lo, lVal_$_hi, 0);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz;
}
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.Ljava_math_BigDecimal__f__toStringImage = null;
  this.Ljava_math_BigDecimal__f__hashCode = 0;
  this.Ljava_math_BigDecimal__f__intVal = null;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo = 0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi = 0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  this.Ljava_math_BigDecimal__f__precision = 0;
}
$c_Ljava_math_BigDecimal.prototype = new $h_jl_Number();
$c_Ljava_math_BigDecimal.prototype.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
}
$h_Ljava_math_BigDecimal.prototype = $c_Ljava_math_BigDecimal.prototype;
$c_Ljava_math_BigDecimal.prototype.add__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(augend) {
  var diffScale = ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale - $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return augend;
  } else if (($p_Ljava_math_BigDecimal__isZero__Z($n(augend)) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this;
  } else if ((diffScale === 0)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    var b = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $x_1 = $m_Ljava_math_BigDecimal$();
      var x_$_lo = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
      var x_$_hi = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
      var x$1_$_lo = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
      var x$1_$_hi = $n(augend).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
      var lo = ((x_$_lo + x$1_$_lo) | 0);
      var hi = ((((x_$_hi + x$1_$_hi) | 0) + ((((x_$_lo & x$1_$_lo) | ((x_$_lo | x$1_$_lo) & (~lo))) >>> 31) | 0)) | 0);
      return $x_1.valueOf__J__I__Ljava_math_BigDecimal(lo, hi, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    } else {
      var this$3 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
      var bi = $n(augend).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, bi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    }
  } else {
    return ((diffScale > 0) ? $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(this, augend, diffScale) : $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(augend, this, ((-diffScale) | 0)));
  }
});
$c_Ljava_math_BigDecimal.prototype.signum__I = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var x_$_lo = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
    var x_$_hi = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
    if ((x_$_hi < 0)) {
      return (-1);
    } else {
      var x$1_$_lo = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
      var x$1_$_hi = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
      if (((x$1_$_hi === 0) ? (x$1_$_lo !== 0) : (x$1_$_hi > 0))) {
        return 1;
      } else {
        return 0;
      }
    }
  } else {
    var this$3 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    return this$3.Ljava_math_BigInteger__f_sign;
  }
});
$c_Ljava_math_BigDecimal.prototype.precision__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__precision === 0)) {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
      var $x_1 = 1;
    } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var $x_1 = $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I(this, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi);
    } else {
      var decimalDigits = ((1 + $doubleToInt((0.3010299956639812 * ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength - 1) | 0)))) | 0);
      var $x_3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var $x_2 = $m_Ljava_math_Multiplication$();
      var hi = (decimalDigits >> 31);
      var this$2 = $n($n($x_3).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($x_2.powerOf10__J__Ljava_math_BigInteger(decimalDigits, hi)));
      if ((this$2.Ljava_math_BigInteger__f_sign !== 0)) {
        var $x_1 = ((1 + decimalDigits) | 0);
      } else {
        var $x_1 = decimalDigits;
      }
    }
    this.Ljava_math_BigDecimal__f__precision = $x_1;
  }
  return this.Ljava_math_BigDecimal__f__precision;
});
$c_Ljava_math_BigDecimal.prototype.scaleByPowerOfTen__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((hi - hi$1) | 0) + ((((~value) & n) | ((~(value ^ n)) & lo)) >> 31)) | 0);
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var x_$_lo = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
    var x_$_hi = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
    if (((x_$_lo | x_$_hi) === 0)) {
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(lo, hi$2);
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(lo, hi$2));
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(lo, hi$2));
  }
});
$c_Ljava_math_BigDecimal.prototype.stripTrailingZeros__Ljava_math_BigDecimal = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
  } else {
    var lastPow = (($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).u.length - 1) | 0);
    var i = 1;
    var strippedBI = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var scale_$_lo = value;
    var scale_$_hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!$n(strippedBI).testBit__I__Z(0))) {
        var qr = $n(strippedBI).divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem($n($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows).get(i));
        var this$2 = $n($n(qr).Ljava_math_BigInteger$QuotAndRem__f_rem);
        if ((this$2.Ljava_math_BigInteger__f_sign === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = $n(qr).Ljava_math_BigInteger$QuotAndRem__f_quot;
          var x_$_lo = scale_$_lo;
          var x_$_hi = scale_$_hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var lo = ((x_$_lo - value$1) | 0);
          var hi$2 = ((((x_$_hi - hi$1) | 0) + ((((~x_$_lo) & value$1) | ((~(x_$_lo ^ value$1)) & lo)) >> 31)) | 0);
          i = temp$i;
          strippedBI = temp$strippedBI;
          scale_$_lo = lo;
          scale_$_hi = hi$2;
          continue;
        }
        if ((i !== 1)) {
          i = 1;
          continue;
        }
        var _1 = strippedBI;
        var _2_$_lo = scale_$_lo;
        var _2_$_hi = scale_$_hi;
        var x1___1 = _1;
        var x1___2 = $bL(_2_$_lo, _2_$_hi);
        break;
      } else {
        var _1$1 = strippedBI;
        var _2$1_$_lo = scale_$_lo;
        var _2$1_$_hi = scale_$_hi;
        var x1___1 = _1$1;
        var x1___2 = $bL(_2$1_$_lo, _2$1_$_hi);
        break;
      }
    }
    var strippedBI$1 = $as_Ljava_math_BigInteger(x1___1);
    var $x_1 = $uJ(x1___2);
    var newScale_$_lo = $x_1.l;
    var newScale_$_hi = $x_1.h;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(newScale_$_lo, newScale_$_hi));
  }
});
$c_Ljava_math_BigDecimal.prototype.compareTo__Ljava_math_BigDecimal__I = (function(bi) {
  var thisSign = this.signum__I();
  var valueSign = $n(bi).signum__I();
  if ((thisSign === valueSign)) {
    if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) && ($n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
      var x_$_lo = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
      var x_$_hi = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
      var x$1_$_lo = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
      var x$1_$_hi = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
      if (((x_$_hi === x$1_$_hi) ? ((x_$_lo >>> 0) < (x$1_$_lo >>> 0)) : (x_$_hi < x$1_$_hi))) {
        return (-1);
      } else {
        var x$2_$_lo = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
        var x$2_$_hi = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
        var x$3_$_lo = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
        var x$3_$_hi = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
        if (((x$2_$_hi === x$3_$_hi) ? ((x$2_$_lo >>> 0) > (x$3_$_lo >>> 0)) : (x$2_$_hi > x$3_$_hi))) {
          return 1;
        } else {
          return 0;
        }
      }
    } else {
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var value$1 = $n(bi).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((hi - hi$1) | 0) + ((((~value) & value$1) | ((~(value ^ value$1)) & lo)) >> 31)) | 0);
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I($n(bi))) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((hi$2 + (((lo & (~lo$1)) >>> 31) | 0)) | 0);
      if (((hi$3 === hi$4) ? ((diffPrecision >>> 0) > (lo$1 >>> 0)) : (hi$3 > hi$4))) {
        return thisSign;
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = ((lo - 1) | 0);
        var hi$6 = ((((hi$2 - 1) | 0) + (((lo | (~lo$2)) >>> 31) | 0)) | 0);
        if (((hi$5 === hi$6) ? ((diffPrecision >>> 0) < (lo$2 >>> 0)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0);
        } else {
          var t = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          var v = $n(bi).java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          if ((hi$2 < 0)) {
            var $x_2 = $n(t);
            var $x_1 = $m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((((-hi$2) | 0) + ((lo | lo$3) >> 31)) | 0);
            var _1 = $x_2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($x_1.powerOf10__J__Ljava_math_BigInteger(lo$3, hi$7));
            var x1___1 = _1;
            var x1___2 = v;
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var _2 = $n(v).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().powerOf10__J__Ljava_math_BigInteger(lo, hi$2));
            var x1___1 = t;
            var x1___2 = _2;
          } else {
            var x1___1 = t;
            var x1___2 = v;
          }
          var thisUnscaled = $as_Ljava_math_BigInteger(x1___1);
          var valUnscaled = $as_Ljava_math_BigInteger(x1___2);
          return $n(thisUnscaled).compareTo__Ljava_math_BigInteger__I(valUnscaled);
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1);
  }
});
$c_Ljava_math_BigDecimal.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    var x2 = $as_Ljava_math_BigDecimal(x);
    if (($n(x2).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)) {
      if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
        var x$1_$_lo = $n(x2).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
        var x$1_$_hi = $n(x2).Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
        var x$2_$_lo = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
        var x$2_$_hi = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
        return (((x$1_$_lo ^ x$2_$_lo) | (x$1_$_hi ^ x$2_$_hi)) === 0);
      } else {
        return $n(this.Ljava_math_BigDecimal__f__intVal).equals__O__Z($n(x2).Ljava_math_BigDecimal__f__intVal);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ljava_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__hashCode !== 0)) {
    return this.Ljava_math_BigDecimal__f__hashCode;
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var x_$_lo = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
    var x_$_hi = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
    this.Ljava_math_BigDecimal__f__hashCode = x_$_lo;
    var $x_1 = this.Ljava_math_BigDecimal__f__hashCode;
    var x$1_$_lo = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo;
    var x$1_$_hi = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi;
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(33, $x_1) + x$1_$_hi) | 0);
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, this.Ljava_math_BigDecimal__f__hashCode) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode;
  } else {
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, $n(this.Ljava_math_BigDecimal__f__intVal).hashCode__I()) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode;
  }
});
$c_Ljava_math_BigDecimal.prototype.toString__T = (function() {
  if ((this.Ljava_math_BigDecimal__f__toStringImage !== null)) {
    return this.Ljava_math_BigDecimal__f__toStringImage;
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 32)) {
    this.Ljava_math_BigDecimal__f__toStringImage = $m_Ljava_math_Conversion$().toDecimalScaledString__J__I__T(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    return this.Ljava_math_BigDecimal__f__toStringImage;
  } else {
    var this$1 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var intString = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
      return intString;
    } else {
      var this$2 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
      if ((this$2.Ljava_math_BigInteger__f_sign < 0)) {
        var begin = 2;
      } else {
        var begin = 1;
      }
      var this$3 = $n(intString);
      var end = this$3.length;
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo & end) | ((lo | end) & (~lo$1))) >>> 31) | 0)) | 0);
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((hi$3 - hi$4) | 0) + ((((~lo$1) & begin) | ((~(lo$1 ^ begin)) & lo$2)) >> 31)) | 0);
      if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0) && ((hi$5 === (-1)) ? ((lo$2 >>> 0) >= 4294967290) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
          $m_Ljava_math_BigDecimal$();
          var this$15 = $n(intString);
          if ((pos > this$15.length)) {
            $charAt(this$15, pos);
          }
          if ((pos < 0)) {
            $charAt(this$15, (-1));
          }
          var $x_1 = $as_T(this$15.substring(0, pos));
          var this$16 = $n(intString);
          if (((pos < 0) || (pos > this$16.length))) {
            $charAt(this$16, pos);
          }
          var result = (($x_1 + ".") + $as_T(this$16.substring(pos)));
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = ((begin - 1) | 0);
          $m_Ljava_math_BigDecimal$();
          var this$20 = $n(intString);
          if ((pos$1 > this$20.length)) {
            $charAt(this$20, pos$1);
          }
          if ((pos$1 < 0)) {
            $charAt(this$20, (-1));
          }
          var $x_2 = $as_T(this$20.substring(0, pos$1));
          var this$21 = $n(intString);
          if (((pos$1 < 0) || (pos$1 > this$21.length))) {
            $charAt(this$21, pos$1);
          }
          var s = (($x_2 + "0.") + $as_T(this$21.substring(pos$1)));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
          var s2Len = (~lo$2);
          $m_Ljava_math_BigDecimal$();
          var this$26 = $n(s2);
          if ((s2Len > this$26.length)) {
            $charAt(this$26, s2Len);
          }
          if ((s2Len < 0)) {
            $charAt(this$26, (-1));
          }
          var s2$1 = $as_T(this$26.substring(0, s2Len));
          if ((pos$2 > s.length)) {
            $charAt(s, pos$2);
          }
          if ((pos$2 < 0)) {
            $charAt(s, (-1));
          }
          var $x_3 = $as_T(s.substring(0, pos$2));
          if (((pos$2 < 0) || (pos$2 > s.length))) {
            $charAt(s, pos$2);
          }
          var result = ((("" + $x_3) + s2$1) + $as_T(s.substring(pos$2)));
        }
      } else {
        if ((((end - begin) | 0) >= 1)) {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var this$30 = $n(intString);
          if ((begin > this$30.length)) {
            $charAt(this$30, begin);
          }
          if ((begin < 0)) {
            $charAt(this$30, (-1));
          }
          var $x_4 = $as_T(this$30.substring(0, begin));
          var this$31 = $n(intString);
          if (((begin < 0) || (begin > this$31.length))) {
            $charAt(this$31, begin);
          }
          var r0 = (($x_4 + ".") + $as_T(this$31.substring(begin)));
        } else {
          var r0 = intString;
        }
        var r1 = (r0 + "E");
        var r2 = (((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1);
        var result = (r2 + $m_RTLong$().toString__I__I__T(lo$2, hi$5));
      }
      this.Ljava_math_BigDecimal__f__toStringImage = result;
      return this.Ljava_math_BigDecimal__f__toStringImage;
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigInteger__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $x_2 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
    return $x_2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($x_1.powerOf10__J__Ljava_math_BigInteger(lo, hi$1));
  } else {
    var $x_4 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    return $x_4.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($x_3.powerOf10__J__Ljava_math_BigInteger(value$1, hi$2));
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigIntegerExact__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $x_2 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
    return $x_2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($x_1.powerOf10__J__Ljava_math_BigInteger(lo, hi$1));
  } else {
    if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()).getLowestSetBit__I()))) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    var $x_4 = $n(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $x_4.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($x_3.powerOf10__J__Ljava_math_BigInteger(value$1, hi$2));
    var this$4 = $n($n(integerAndFraction).get(1));
    if ((this$4.Ljava_math_BigInteger__f_sign !== 0)) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    return $n(integerAndFraction).get(0);
  }
});
$c_Ljava_math_BigDecimal.prototype.longValue__J = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-64)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this)))) {
    return $bL(0, 0);
  } else {
    return $n(this.toBigInteger__Ljava_math_BigInteger()).longValue__J();
  }
});
$c_Ljava_math_BigDecimal.prototype.intValue__I = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-32)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? 0 : $n(this.toBigInteger__Ljava_math_BigInteger()).intValue__I());
});
$c_Ljava_math_BigDecimal.prototype.intValueExact__I = (function() {
  var $x_1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 32);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  return x_$_lo;
});
$c_Ljava_math_BigDecimal.prototype.shortValueExact__S = (function() {
  var $x_1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 16);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  return ((x_$_lo << 16) >> 16);
});
$c_Ljava_math_BigDecimal.prototype.byteValueExact__B = (function() {
  var $x_1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 8);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  return ((x_$_lo << 24) >> 24);
});
$c_Ljava_math_BigDecimal.prototype.floatValue__F = (function() {
  return $m_jl_Float$().parseFloat__T__F(((this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger() + "e") + ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)));
});
$c_Ljava_math_BigDecimal.prototype.doubleValue__D = (function() {
  return $m_jl_Double$().parseDouble__T__D(((this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger() + "e") + ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)));
});
$c_Ljava_math_BigDecimal.prototype.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger = (function() {
  if ((this.Ljava_math_BigDecimal__f__intVal === null)) {
    this.Ljava_math_BigDecimal__f__intVal = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$lo, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue_$hi);
  }
  return this.Ljava_math_BigDecimal__f__intVal;
});
$c_Ljava_math_BigDecimal.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_math_BigDecimal__I($as_Ljava_math_BigDecimal(o));
});
function $as_Ljava_math_BigDecimal(obj) {
  return (((obj instanceof $c_Ljava_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigDecimal"));
}
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigDecimal)));
}
function $asArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (($isArrayOf_Ljava_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigDecimal;", depth));
}
var $d_Ljava_math_BigDecimal = new $TypeData().initClass($c_Ljava_math_BigDecimal, "java.math.BigDecimal", ({
  Ljava_math_BigDecimal: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}));
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  var this$1 = $n(s);
  var stringLength0 = this$1.length;
  var this$2 = $n(s);
  if (($charAt(this$2, 0) === 45)) {
    var _3 = ((stringLength0 - 1) | 0);
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = _3;
  } else {
    var this$3 = $n(s);
    if (($charAt(this$3, 0) === 43)) {
      var _3$1 = ((stringLength0 - 1) | 0);
      var x1___1 = 1;
      var x1___2 = 1;
      var x1___3 = _3$1;
    } else {
      var x1___1 = 1;
      var x1___2 = 0;
      var x1___3 = stringLength0;
    }
  }
  var _sign = $uI(x1___1);
  var startChar = $uI(x1___2);
  var stringLength = $uI(x1___3);
  var i = startChar;
  while ((i < stringLength0)) {
    var value = i;
    var this$6 = $n(s);
    var c = $charAt(this$6, value);
    if (((c === 43) || (c === 45))) {
      throw new $c_jl_NumberFormatException("Illegal embedded sign character");
    }
    i = ((1 + i) | 0);
  }
  var charsPerInt = $n($m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_DigitFitInInt).get(radix);
  var bigRadixDigitsLength = ((stringLength / $checkIntDivisor(charsPerInt)) | 0);
  var topChars = ((stringLength % $checkIntDivisor(charsPerInt)) | 0);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0);
  }
  var _digits = new $ac_I(bigRadixDigitsLength);
  var bigRadix = $n($m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_BigRadices).get(((radix - 2) | 0));
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var this$8 = $m_jl_Integer$();
    var this$7 = $n(s);
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    if ((beginIndex < 0)) {
      $charAt(this$7, beginIndex);
    }
    if ((endIndex > this$7.length)) {
      $charAt(this$7, endIndex);
    }
    if ((endIndex < beginIndex)) {
      $charAt(this$7, (-1));
    }
    var s$1 = $as_T(this$7.substring(beginIndex, endIndex));
    if (((((radix - 2) | 0) >>> 0) > 34)) {
      this$8.parseIntFail__T__E(s$1);
    }
    var bigRadixDigit = this$8.java$lang$Integer$$parseIntImpl__T__I__I__I(s$1, radix, ((2147483648 / ($checkIntDivisor(radix) >>> 0)) | 0));
    var this$10 = $m_Ljava_math_Multiplication$();
    var aSize = digitIndex;
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this$10, _digits, _digits, aSize, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().inplaceAdd__AI__I__I__I(_digits, digitIndex, bigRadixDigit)) | 0);
    _digits.set(digitIndex, newDigit);
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0);
  }
  $thiz.Ljava_math_BigInteger__f_sign = _sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = digitIndex;
  $thiz.Ljava_math_BigInteger__f_digits = _digits;
  $thiz.cutOffLeadingZeroes__V();
}
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = (-2);
  $thiz.Ljava_math_BigInteger__f__hashCode = 0;
  return $thiz;
}
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  $n(s);
  if (((((radix - 2) | 0) >>> 0) > 34)) {
    throw new $c_jl_NumberFormatException("Radix out of range");
  }
  var this$2 = $n(s);
  if ((this$2 === "")) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz;
}
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = 1;
  $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([value]));
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if (($n(digits).u.length === 0)) {
    $thiz.Ljava_math_BigInteger__f_sign = 0;
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([0]));
  } else {
    $thiz.Ljava_math_BigInteger__f_sign = signum;
    $thiz.Ljava_math_BigInteger__f_numberLength = $n(digits).u.length;
    $thiz.Ljava_math_BigInteger__f_digits = digits;
    $thiz.cutOffLeadingZeroes__V();
  }
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = numberLength;
  $thiz.Ljava_math_BigInteger__f_digits = digits;
  return $thiz;
}
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal_$_lo, lVal_$_hi) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  if ((lVal_$_hi === 0)) {
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal_$_lo]));
  } else {
    $thiz.Ljava_math_BigInteger__f_numberLength = 2;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal_$_lo, lVal_$_hi]));
  }
  return $thiz;
}
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.Ljava_math_BigInteger__f_digits = null;
  this.Ljava_math_BigInteger__f_numberLength = 0;
  this.Ljava_math_BigInteger__f_sign = 0;
  this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = 0;
  this.Ljava_math_BigInteger__f__hashCode = 0;
}
$c_Ljava_math_BigInteger.prototype = new $h_jl_Number();
$c_Ljava_math_BigInteger.prototype.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
}
$h_Ljava_math_BigInteger.prototype = $c_Ljava_math_BigInteger.prototype;
$c_Ljava_math_BigInteger.prototype.abs__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits) : this);
});
$c_Ljava_math_BigInteger.prototype.compareTo__Ljava_math_BigInteger__I = (function(bi) {
  return ((this.Ljava_math_BigInteger__f_sign > $n(bi).Ljava_math_BigInteger__f_sign) ? 1 : ((this.Ljava_math_BigInteger__f_sign < $n(bi).Ljava_math_BigInteger__f_sign) ? (-1) : ((this.Ljava_math_BigInteger__f_numberLength > $n(bi).Ljava_math_BigInteger__f_numberLength) ? this.Ljava_math_BigInteger__f_sign : ((this.Ljava_math_BigInteger__f_numberLength < $n(bi).Ljava_math_BigInteger__f_numberLength) ? ((-$n(bi).Ljava_math_BigInteger__f_sign) | 0) : Math.imul(this.Ljava_math_BigInteger__f_sign, $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, $n(bi).Ljava_math_BigInteger__f_digits, this.Ljava_math_BigInteger__f_numberLength))))));
});
$c_Ljava_math_BigInteger.prototype.divide__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(divisor) {
  if (($n(divisor).Ljava_math_BigInteger__f_sign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorSign = $n(divisor).Ljava_math_BigInteger__f_sign;
  if ($n(divisor).isOne__Z()) {
    return (($n(divisor).Ljava_math_BigInteger__f_sign > 0) ? this : this.negate__Ljava_math_BigInteger());
  } else {
    var thisSign = this.Ljava_math_BigInteger__f_sign;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var divisorLen = $n(divisor).Ljava_math_BigInteger__f_numberLength;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var dividend = $n(this.Ljava_math_BigInteger__f_digits).get(0);
      var divisor$1 = $n($n(divisor).Ljava_math_BigInteger__f_digits).get(0);
      var x = (((dividend >>> 0) / ($checkIntDivisor(divisor$1) >>> 0)) | 0);
      if ((thisSign !== divisorSign)) {
        var lo = ((-x) | 0);
        var hi = ((x | lo) >> 31);
        var bi_$_lo = lo;
        var bi_$_hi = hi;
      } else {
        var bi_$_lo = x;
        var bi_$_hi = 0;
      }
      return $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(bi_$_lo, bi_$_hi);
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, $n(divisor).Ljava_math_BigInteger__f_digits, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE);
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(resDigits, this.Ljava_math_BigInteger__f_digits, thisLen, $n($n(divisor).Ljava_math_BigInteger__f_digits).get(0));
        } else {
          $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(resDigits, resLength, this.Ljava_math_BigInteger__f_digits, thisLen, $n(divisor).Ljava_math_BigInteger__f_digits, divisorLen);
        }
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.cutOffLeadingZeroes__V();
        return result;
      }
    }
  }
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger = (function(divisor) {
  return $n(this.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(divisor)).toArray__ALjava_math_BigInteger();
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem = (function(divisor) {
  var divisorSign = $n(divisor).Ljava_math_BigInteger__f_sign;
  if ((divisorSign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorLen = $n(divisor).Ljava_math_BigInteger__f_numberLength;
  var divisorDigits = $n(divisor).Ljava_math_BigInteger__f_digits;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem(this, $n(divisorDigits).get(0), divisorSign);
  } else {
    var thisDigits = this.Ljava_math_BigInteger__f_digits;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(thisDigits, divisorDigits, thisLen));
    if ((cmp < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO, this);
    } else {
      var thisSign = this.Ljava_math_BigInteger__f_sign;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.cutOffLeadingZeroes__V();
      result1.cutOffLeadingZeroes__V();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
    }
  }
});
$c_Ljava_math_BigInteger.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigInteger)) {
    var x2 = $as_Ljava_math_BigInteger(x);
    return (((this.Ljava_math_BigInteger__f_sign === $n(x2).Ljava_math_BigInteger__f_sign) && (this.Ljava_math_BigInteger__f_numberLength === $n(x2).Ljava_math_BigInteger__f_numberLength)) && this.equalsArrays__AI__Z($n(x2).Ljava_math_BigInteger__f_digits));
  } else {
    return false;
  }
});
$c_Ljava_math_BigInteger.prototype.getLowestSetBit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_sign === 0)) {
    return (-1);
  } else {
    var i = this.getFirstNonzeroDigit__I();
    var i$1 = $n(this.Ljava_math_BigInteger__f_digits).get(i);
    var i$2 = ((~i$1) & ((i$1 - 1) | 0));
    return (((i << 5) + ((32 - Math.clz32(i$2)) | 0)) | 0);
  }
});
$c_Ljava_math_BigInteger.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigInteger__f__hashCode !== 0)) {
    return this.Ljava_math_BigInteger__f__hashCode;
  } else {
    var end = this.Ljava_math_BigInteger__f_numberLength;
    var i = 0;
    while ((i < end)) {
      var value = i;
      this.Ljava_math_BigInteger__f__hashCode = ((Math.imul(33, this.Ljava_math_BigInteger__f__hashCode) + $n(this.Ljava_math_BigInteger__f_digits).get(value)) | 0);
      i = ((1 + i) | 0);
    }
    this.Ljava_math_BigInteger__f__hashCode = Math.imul(this.Ljava_math_BigInteger__f__hashCode, this.Ljava_math_BigInteger__f_sign);
    return this.Ljava_math_BigInteger__f__hashCode;
  }
});
$c_Ljava_math_BigInteger.prototype.intValue__I = (function() {
  return Math.imul(this.Ljava_math_BigInteger__f_sign, $n(this.Ljava_math_BigInteger__f_digits).get(0));
});
$c_Ljava_math_BigInteger.prototype.longValue__J = (function() {
  if ((this.Ljava_math_BigInteger__f_numberLength > 1)) {
    var value = $n(this.Ljava_math_BigInteger__f_digits).get(1);
    var value$1 = $n(this.Ljava_math_BigInteger__f_digits).get(0);
    var value$3_$_lo = value$1;
    var value$3_$_hi = value;
  } else {
    var value$2 = $n(this.Ljava_math_BigInteger__f_digits).get(0);
    var value$3_$_lo = value$2;
    var value$3_$_hi = 0;
  }
  var value$4 = this.Ljava_math_BigInteger__f_sign;
  var hi$3 = (value$4 >> 31);
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & value$3_$_lo);
  var b1 = ((value$3_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(value$4, value$3_$_hi) + Math.imul(hi$3, value$3_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $bL(lo, hi$4);
});
$c_Ljava_math_BigInteger.prototype.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(bi) {
  if ((($n(bi).Ljava_math_BigInteger__f_sign === 0) || (this.Ljava_math_BigInteger__f_sign === 0))) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  } else {
    var this$1 = $m_Ljava_math_Multiplication$();
    return this$1.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this, bi);
  }
});
$c_Ljava_math_BigInteger.prototype.negate__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.Ljava_math_BigInteger__f_sign) | 0), this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits));
});
$c_Ljava_math_BigInteger.prototype.pow__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < 0)) {
    throw new $c_jl_ArithmeticException("Negative exponent");
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  } else if ((((exp === 1) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE)) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO))) {
    return this;
  } else if ((!this.testBit__I__Z(0))) {
    var x = 1;
    while ((!this.testBit__I__Z(x))) {
      x = ((1 + x) | 0);
    }
    return $n($m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger(Math.imul(x, exp))).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($n(this.shiftRight__I__Ljava_math_BigInteger(x)).pow__I__Ljava_math_BigInteger(exp));
  } else {
    return $m_Ljava_math_Multiplication$().pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, exp);
  }
});
$c_Ljava_math_BigInteger.prototype.shiftLeft__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))));
});
$c_Ljava_math_BigInteger.prototype.shiftRight__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))));
});
$c_Ljava_math_BigInteger.prototype.testBit__I__Z = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & $n(this.Ljava_math_BigInteger__f_digits).get(0)) !== 0);
  } else {
    if ((n < 0)) {
      throw new $c_jl_ArithmeticException("Negative bit address");
    }
    if ((intCount >= this.Ljava_math_BigInteger__f_numberLength)) {
      return (this.Ljava_math_BigInteger__f_sign < 0);
    } else if ((!((this.Ljava_math_BigInteger__f_sign < 0) && (intCount < this.getFirstNonzeroDigit__I())))) {
      var digit = $n(this.Ljava_math_BigInteger__f_digits).get(intCount);
      if ((this.Ljava_math_BigInteger__f_sign < 0)) {
        digit = ((this.getFirstNonzeroDigit__I() === intCount) ? ((-digit) | 0) : (~digit));
      }
      var i = (1 << n);
      return ((digit & i) !== 0);
    } else {
      return false;
    }
  }
});
$c_Ljava_math_BigInteger.prototype.toString__T = (function() {
  return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this);
});
$c_Ljava_math_BigInteger.prototype.cutOffLeadingZeroes__V = (function() {
  while (true) {
    if ((this.Ljava_math_BigInteger__f_numberLength > 0)) {
      this.Ljava_math_BigInteger__f_numberLength = ((this.Ljava_math_BigInteger__f_numberLength - 1) | 0);
      if (($n(this.Ljava_math_BigInteger__f_digits).get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
        continue;
      }
    }
    break;
  }
  if (($n(this.Ljava_math_BigInteger__f_digits).get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
    this.Ljava_math_BigInteger__f_sign = 0;
  }
  this.Ljava_math_BigInteger__f_numberLength = ((1 + this.Ljava_math_BigInteger__f_numberLength) | 0);
});
$c_Ljava_math_BigInteger.prototype.equalsArrays__AI__Z = (function(b) {
  var i = 0;
  while ((i !== this.Ljava_math_BigInteger__f_numberLength)) {
    if (($n(this.Ljava_math_BigInteger__f_digits).get(i) !== $n(b).get(i))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_Ljava_math_BigInteger.prototype.getFirstNonzeroDigit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit === (-2))) {
    if ((this.Ljava_math_BigInteger__f_sign === 0)) {
      var $x_1 = (-1);
    } else {
      var i = 0;
      while (($n(this.Ljava_math_BigInteger__f_digits).get(i) === 0)) {
        i = ((1 + i) | 0);
      }
      var $x_1 = i;
    }
    this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = $x_1;
  }
  return this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit;
});
$c_Ljava_math_BigInteger.prototype.isOne__Z = (function() {
  return ((this.Ljava_math_BigInteger__f_numberLength === 1) && ($n(this.Ljava_math_BigInteger__f_digits).get(0) === 1));
});
$c_Ljava_math_BigInteger.prototype.shiftLeftOneBit__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $m_Ljava_math_BitLevel$().shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger(this));
});
$c_Ljava_math_BigInteger.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_math_BigInteger__I($as_Ljava_math_BigInteger(o));
});
function $as_Ljava_math_BigInteger(obj) {
  return (((obj instanceof $c_Ljava_math_BigInteger) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigInteger"));
}
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigInteger)));
}
function $asArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (($isArrayOf_Ljava_math_BigInteger(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigInteger;", depth));
}
var $d_Ljava_math_BigInteger = new $TypeData().initClass($c_Ljava_math_BigInteger, "java.math.BigInteger", ({
  Ljava_math_BigInteger: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}));
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal);
}
$c_Ljava_math_RoundingMode.prototype = new $h_jl_Enum();
$c_Ljava_math_RoundingMode.prototype.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
}
$h_Ljava_math_RoundingMode.prototype = $c_Ljava_math_RoundingMode.prototype;
var $d_Ljava_math_RoundingMode = new $TypeData().initClass($c_Ljava_math_RoundingMode, "java.math.RoundingMode", ({
  Ljava_math_RoundingMode: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
function $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V($thiz) {
  if (($thiz.ju_AbstractRandomAccessListIterator__f_last === (-1))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
  }
}
function $ct_ju_AbstractRandomAccessListIterator__I__I__I__($thiz, i, start, end) {
  $thiz.ju_AbstractRandomAccessListIterator__f_i = i;
  $thiz.ju_AbstractRandomAccessListIterator__f_end = end;
  $thiz.ju_AbstractRandomAccessListIterator__f_last = (-1);
  return $thiz;
}
/** @constructor */
function $c_ju_AbstractRandomAccessListIterator() {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
}
$c_ju_AbstractRandomAccessListIterator.prototype = new $h_O();
$c_ju_AbstractRandomAccessListIterator.prototype.constructor = $c_ju_AbstractRandomAccessListIterator;
/** @constructor */
function $h_ju_AbstractRandomAccessListIterator() {
}
$h_ju_AbstractRandomAccessListIterator.prototype = $c_ju_AbstractRandomAccessListIterator.prototype;
$c_ju_AbstractRandomAccessListIterator.prototype.hasNext__Z = (function() {
  return (this.ju_AbstractRandomAccessListIterator__f_i < this.ju_AbstractRandomAccessListIterator__f_end);
});
$c_ju_AbstractRandomAccessListIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException());
  }
  this.ju_AbstractRandomAccessListIterator__f_last = this.ju_AbstractRandomAccessListIterator__f_i;
  this.ju_AbstractRandomAccessListIterator__f_i = ((1 + this.ju_AbstractRandomAccessListIterator__f_i) | 0);
  return this.get__I__O(this.ju_AbstractRandomAccessListIterator__f_last);
});
$c_ju_AbstractRandomAccessListIterator.prototype.remove__V = (function() {
  $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V(this);
  this.remove__I__V(this.ju_AbstractRandomAccessListIterator__f_last);
  if ((this.ju_AbstractRandomAccessListIterator__f_last < this.ju_AbstractRandomAccessListIterator__f_i)) {
    this.ju_AbstractRandomAccessListIterator__f_i = ((this.ju_AbstractRandomAccessListIterator__f_i - 1) | 0);
  }
  this.ju_AbstractRandomAccessListIterator__f_last = (-1);
  this.ju_AbstractRandomAccessListIterator__f_end = ((this.ju_AbstractRandomAccessListIterator__f_end - 1) | 0);
});
function $p_ju_Formatter__sendToDest__T__V($thiz, s) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (("" + $thiz.ju_Formatter__f_stringOutput) + s);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s]);
  }
}
function $p_ju_Formatter__sendToDest__T__T__V($thiz, s1, s2) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = ((("" + $thiz.ju_Formatter__f_stringOutput) + s1) + s2);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2]);
  }
}
function $p_ju_Formatter__sendToDest__T__T__T__V($thiz, s1, s2, s3) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (($thiz.ju_Formatter__f_stringOutput + (("" + s1) + s2)) + s3);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2, s3]);
  }
}
function $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, ss) {
  try {
    var len = $uI(ss.length);
    var i = 0;
    while ((i !== len)) {
      var t = ss[i];
      var t$1 = $as_T(t);
      $n($thiz.ju_Formatter__f_dest).append__jl_CharSequence__jl_Appendable(t$1);
      i = ((1 + i) | 0);
    }
  } catch (e) {
    if (false) {
      $as_Ljava_io_IOException(e);
    } else {
      throw e;
    }
  }
}
function $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter($thiz, localeInfo, format, args) {
  if ($thiz.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException();
  }
  var lastImplicitArgIndex = 0;
  var lastArgIndex = 0;
  var this$1 = $n(format);
  var fmtLength = this$1.length;
  var fmtIndex = 0;
  while ((fmtIndex !== fmtLength)) {
    var this$2 = $n(format);
    var fromIndex = fmtIndex;
    var nextPercentIndex = $uI(this$2.indexOf("%", fromIndex));
    if ((nextPercentIndex < 0)) {
      var this$3 = $n(format);
      var beginIndex = fmtIndex;
      if (((beginIndex < 0) || (beginIndex > this$3.length))) {
        $charAt(this$3, beginIndex);
      }
      $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(this$3.substring(beginIndex)));
      return $thiz;
    }
    var this$4 = $n(format);
    var beginIndex$1 = fmtIndex;
    if ((beginIndex$1 < 0)) {
      $charAt(this$4, beginIndex$1);
    }
    if ((nextPercentIndex > this$4.length)) {
      $charAt(this$4, nextPercentIndex);
    }
    if ((nextPercentIndex < beginIndex$1)) {
      $charAt(this$4, (-1));
    }
    $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(this$4.substring(beginIndex$1, nextPercentIndex)));
    var formatSpecifierIndex = ((1 + nextPercentIndex) | 0);
    var re = $m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$FormatSpecifier;
    re.lastIndex = formatSpecifierIndex;
    var execResult = re.exec(format);
    if (((execResult === null) || ($uI(execResult.index) !== formatSpecifierIndex))) {
      if ((formatSpecifierIndex === fmtLength)) {
        var conversion = 37;
      } else {
        var this$5 = $n(format);
        var conversion = $charAt(this$5, formatSpecifierIndex);
      }
      $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion);
    }
    fmtIndex = $uI(re.lastIndex);
    var this$6 = $n(format);
    var index = ((fmtIndex - 1) | 0);
    var conversion$2 = $charAt(this$6, index);
    var flags = $p_ju_Formatter__parseFlags__T__C__I($thiz, $as_T(execResult[2]), conversion$2);
    var width = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[3]);
    var precision = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[4]);
    if ((width === (-2))) {
      $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, (-2147483648));
    }
    if ((precision === (-2))) {
      $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, (-2147483648));
    }
    if ((conversion$2 === 110)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((width !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width);
      }
      if ((flags !== 0)) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags);
      }
      $p_ju_Formatter__sendToDest__T__V($thiz, "\n");
    } else if ((conversion$2 === 37)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags);
      }
      if ((((1 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      if ((((-2) & flags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(37, flags, (-2));
      }
      $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, "%");
    } else {
      var conversionLower = (((256 & flags) !== 0) ? (65535 & ((32 + conversion$2) | 0)) : conversion$2);
      var illegalFlags = $n($m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags).get(((conversionLower - 97) | 0));
      if (((illegalFlags === (-1)) || (((256 & flags) & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion$2);
      }
      if ((((17 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags);
      }
      if (((precision !== (-1)) && ((512 & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if (((flags & illegalFlags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, illegalFlags);
      }
      if (((128 & flags) !== 0)) {
        var argIndex = lastArgIndex;
      } else {
        var i = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[1]);
        if ((i === (-1))) {
          lastImplicitArgIndex = ((1 + lastImplicitArgIndex) | 0);
          var argIndex = lastImplicitArgIndex;
        } else {
          if ((i <= 0)) {
            $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, i);
          }
          var argIndex = i;
        }
      }
      if (((argIndex <= 0) || (argIndex > $n(args).u.length))) {
        $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      lastArgIndex = argIndex;
      var arg = $n(args).get(((argIndex - 1) | 0));
      if ((((arg === null) && (conversionLower !== 98)) && (conversionLower !== 115))) {
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, "null");
      } else {
        $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision);
      }
    }
  }
  return $thiz;
}
function $p_ju_Formatter__parseFlags__T__C__I($thiz, flags, conversion) {
  var bits = (((((conversion - 65) | 0) >>> 0) <= 25) ? 256 : 0);
  var this$1 = $n(flags);
  var len = this$1.length;
  var i = 0;
  while ((i !== len)) {
    var this$2 = $n(flags);
    var index = i;
    var f = $charAt(this$2, index);
    switch (f) {
      case 45: {
        var bit = 1;
        break;
      }
      case 35: {
        var bit = 2;
        break;
      }
      case 43: {
        var bit = 4;
        break;
      }
      case 32: {
        var bit = 8;
        break;
      }
      case 48: {
        var bit = 16;
        break;
      }
      case 44: {
        var bit = 32;
        break;
      }
      case 40: {
        var bit = 64;
        break;
      }
      case 60: {
        var bit = 128;
        break;
      }
      default: {
        var bit;
        throw new $c_jl_AssertionError($bC(f));
      }
    }
    if (((bits & bit) !== 0)) {
      $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, f);
    }
    bits = (bits | bit);
    i = ((1 + i) | 0);
  }
  return bits;
}
function $p_ju_Formatter__parsePositiveInt__O__I($thiz, capture) {
  if ((capture !== (void 0))) {
    var t = $as_T(capture);
    var x = $uD(parseInt(t, 10));
    return ((x <= 2.147483647E9) ? $doubleToInt(x) : (-2));
  } else {
    return (-1);
  }
}
function $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision) {
  switch (conversionLower) {
    case 98: {
      var str = (((arg === false) || (arg === null)) ? "false" : "true");
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str);
      break;
    }
    case 104: {
      var i = $dp_hashCode__I($n(arg));
      var str$2 = $as_T((i >>> 0.0).toString(16));
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str$2);
      break;
    }
    case 115: {
      if ($is_ju_Formattable(arg)) {
        var x2 = $as_ju_Formattable(arg);
        var formattableFlags = (((((1 & flags) !== 0) ? 1 : 0) | (((2 & flags) !== 0) ? 4 : 0)) | (((256 & flags) !== 0) ? 2 : 0));
        $n(x2).formatTo__ju_Formatter__I__I__I__V($thiz, formattableFlags, width, precision);
      } else {
        if (((2 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 2);
        }
        var str$3 = ("" + arg);
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str$3);
      }
      break;
    }
    case 99: {
      if ((arg instanceof $Char)) {
        var x2$2 = $uC(arg);
        var str$4 = ("" + $cToS(x2$2));
      } else {
        if ((!$isInt(arg))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
        }
        var x3 = $uI(arg);
        if (((x3 >>> 0) > 1114111)) {
          $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, x3);
        }
        var str$4 = $m_jl_Character$().toString__I__T(x3);
      }
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, (-1), str$4);
      break;
    }
    case 100: {
      if ($isInt(arg)) {
        var x2$3 = $uI(arg);
        var str$5 = ("" + x2$3);
      } else if ((arg instanceof $Long)) {
        var $x_1 = $uJ(arg);
        var x3$2_$_lo = $x_1.l;
        var x3$2_$_hi = $x_1.h;
        var str$5 = $m_RTLong$().toString__I__I__T(x3$2_$_lo, x3$2_$_hi);
      } else {
        if ((!(arg instanceof $c_Ljava_math_BigInteger))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
        }
        var x4 = $as_Ljava_math_BigInteger(arg);
        var this$12 = $n(x4);
        var str$5 = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$12);
      }
      $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str$5, "");
      break;
    }
    case 111:
    case 120: {
      var isOctal = (conversionLower === 111);
      var prefix = (((2 & flags) === 0) ? "" : (isOctal ? "0" : (((256 & flags) !== 0) ? "0X" : "0x")));
      if ((arg instanceof $c_Ljava_math_BigInteger)) {
        var x2$4 = $as_Ljava_math_BigInteger(arg);
        var radix = (isOctal ? 8 : 16);
        var $x_2 = $m_ju_Formatter$RootLocaleInfo$();
        var this$15 = $n(x2$4);
        $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $x_2, flags, width, $m_Ljava_math_Conversion$().bigInteger2String__Ljava_math_BigInteger__I__T(this$15, radix), prefix);
      } else {
        if ($isInt(arg)) {
          var x2$5 = $uI(arg);
          var str$6 = (isOctal ? $as_T((x2$5 >>> 0.0).toString(8)) : $as_T((x2$5 >>> 0.0).toString(16)));
        } else {
          if ((!(arg instanceof $Long))) {
            $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
          }
          var $x_3 = $uJ(arg);
          var x3$3_$_lo = $x_3.l;
          var x3$3_$_hi = $x_3.h;
          if (isOctal) {
            var this$22 = $m_jl_Long$();
            var str$6 = this$22.java$lang$Long$$toOctalString__I__I__T(x3$3_$_lo, x3$3_$_hi);
          } else {
            var this$26 = $m_jl_Long$();
            var str$6 = this$26.java$lang$Long$$toHexString__I__I__T(x3$3_$_lo, x3$3_$_hi);
          }
        }
        if (((76 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 76);
        }
        $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str$6));
      }
      break;
    }
    case 101:
    case 102:
    case 103: {
      if (((typeof arg) === "number")) {
        var x2$6 = $uD(arg);
        if (((x2$6 !== x2$6) || ((x2$6 === Infinity) || (x2$6 === (-Infinity))))) {
          $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x2$6);
        } else {
          $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal(x2$6), flags, precision, conversionLower, localeInfo, width);
        }
      } else if ((arg instanceof $c_Ljava_math_BigDecimal)) {
        var x3$4 = $as_Ljava_math_BigDecimal(arg);
        $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal(x3$4), flags, precision, conversionLower, localeInfo, width);
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
      }
      break;
    }
    case 97: {
      if (((typeof arg) === "number")) {
        var x2$7 = $uD(arg);
        $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, x2$7);
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
      }
      break;
    }
    default: {
      throw new $c_jl_AssertionError((("Unknown conversion '" + $cToS(conversionLower)) + "' was not rejected earlier"));
    }
  }
}
function $p_ju_Formatter__flagsToString__I__T($thiz, flags) {
  return ((((((((((1 & flags) !== 0) ? "-" : "") + (((2 & flags) !== 0) ? "#" : "")) + (((4 & flags) !== 0) ? "+" : "")) + (((8 & flags) !== 0) ? " " : "")) + (((16 & flags) !== 0) ? "0" : "")) + (((32 & flags) !== 0) ? "," : "")) + (((64 & flags) !== 0) ? "(" : "")) + (((128 & flags) !== 0) ? "<" : ""));
}
function $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, digitsAfterDot, forceDecimalSep) {
  var rounded = $n(x).round__I__ju_Formatter$Decimal(((1 + digitsAfterDot) | 0));
  var signStr = ($n(rounded).ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = $n(rounded).ju_Formatter$Decimal__f_unscaledValue;
  var this$1 = $n(intStr);
  var fractionalDigitCount = ((this$1.length - 1) | 0);
  var missingZeros = ((digitsAfterDot - fractionalDigitCount) | 0);
  var this$2 = $n(intStr);
  if ((this$2.length < 1)) {
    $charAt(this$2, 1);
  }
  var integerPart = $as_T(this$2.substring(0, 1));
  var this$3 = $n(intStr);
  if ((this$3.length < 1)) {
    $charAt(this$3, 1);
  }
  var fractionalPart = (("" + $as_T(this$3.substring(1))) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(missingZeros));
  var significandStr = (((fractionalPart === "") && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + fractionalPart));
  var exponent = ((fractionalDigitCount - $n(rounded).ju_Formatter$Decimal__f_scale) | 0);
  var exponentSign = ((exponent < 0) ? "-" : "+");
  var sign = (exponent >> 31);
  var this$5 = (((exponent ^ sign) - sign) | 0);
  var exponentAbsStr0 = ("" + this$5);
  var exponentAbsStr = ((exponentAbsStr0.length === 1) ? ("0" + exponentAbsStr0) : exponentAbsStr0);
  return ((((signStr + significandStr) + "e") + exponentSign) + exponentAbsStr);
}
function $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, scale, forceDecimalSep) {
  var rounded = $n(x).setScale__I__ju_Formatter$Decimal(scale);
  var signStr = ($n(rounded).ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = $n(rounded).ju_Formatter$Decimal__f_unscaledValue;
  var this$1 = $n(intStr);
  var intStrLen = this$1.length;
  var minDigits = ((1 + scale) | 0);
  var expandedIntStr = ((intStrLen >= minDigits) ? intStr : (("" + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((minDigits - intStrLen) | 0))) + intStr));
  var this$2 = $n(expandedIntStr);
  var dotPos = ((this$2.length - scale) | 0);
  var this$3 = $n(expandedIntStr);
  if ((dotPos > this$3.length)) {
    $charAt(this$3, dotPos);
  }
  if ((dotPos < 0)) {
    $charAt(this$3, (-1));
  }
  var integerPart = (signStr + $as_T(this$3.substring(0, dotPos)));
  if (((scale === 0) && (!forceDecimalSep))) {
    return integerPart;
  } else {
    var this$4 = $n(expandedIntStr);
    if (((dotPos < 0) || (dotPos > this$4.length))) {
      $charAt(this$4, dotPos);
    }
    return ((integerPart + ".") + $as_T(this$4.substring(dotPos)));
  }
}
function $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, precision, forceDecimalSep) {
  var p = ((precision === 0) ? 1 : precision);
  var rounded = $n(x).round__I__ju_Formatter$Decimal(p);
  var this$1 = $n(rounded);
  var this$2 = $n(this$1.ju_Formatter$Decimal__f_unscaledValue);
  var orderOfMagnitude = ((((this$2.length - 1) | 0) - $n(rounded).ju_Formatter$Decimal__f_scale) | 0);
  if (((orderOfMagnitude >= (-4)) && (orderOfMagnitude < p))) {
    var b = ((((p - orderOfMagnitude) | 0) - 1) | 0);
    return $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((b < 0) ? 0 : b), forceDecimalSep);
  } else {
    return $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((p - 1) | 0), forceDecimalSep);
  }
}
function $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, arg) {
  if (((arg !== arg) || ((arg === Infinity) || (arg === (-Infinity))))) {
    $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, arg);
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, arg, true);
    var lo = $uI(fpBitsDataView.getInt32(0, true));
    var hi = $uI(fpBitsDataView.getInt32(4, true));
    var negative = (hi < 0);
    var hi$1 = (1048575 & hi);
    var lo$1 = ((hi >>> 20) | 0);
    var biasedExponent = (2047 & lo$1);
    var actualPrecision = ((precision === 0) ? 1 : ((precision > 12) ? (-1) : precision));
    var signStr = (negative ? "-" : (((4 & flags) !== 0) ? "+" : (((8 & flags) !== 0) ? " " : "")));
    if ((biasedExponent === 0)) {
      if (((lo | hi$1) === 0)) {
        var x1___1 = "0";
        var x1___2 = $bL(0, 0);
        var x1___3 = 0;
      } else if ((actualPrecision === (-1))) {
        var x1___1 = "0";
        var x1___2 = $bL(lo, hi$1);
        var x1___3 = (-1022);
      } else {
        var leadingZeros = ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo)) | 0));
        var shift = ((leadingZeros - 11) | 0);
        var lo$2 = (((32 & shift) === 0) ? (lo << shift) : 0);
        var hi$2 = (((32 & shift) === 0) ? (((((lo >>> 1) | 0) >>> (~shift)) | 0) | (hi$1 << shift)) : (lo << shift));
        var hi$3 = (1048575 & hi$2);
        var normalizedExponent = (((-1022) - shift) | 0);
        var x1___1 = "1";
        var x1___2 = $bL(lo$2, hi$3);
        var x1___3 = normalizedExponent;
      }
    } else {
      var _3 = ((biasedExponent - 1023) | 0);
      var x1___1 = "1";
      var x1___2 = $bL(lo, hi$1);
      var x1___3 = _3;
    }
    var implicitBitStr = $as_T(x1___1);
    var $x_1 = $uJ(x1___2);
    var mantissa_$_lo = $x_1.l;
    var mantissa_$_hi = $x_1.h;
    var exponent = $uI(x1___3);
    if ((actualPrecision === (-1))) {
      var roundedMantissa_$_lo = mantissa_$_lo;
      var roundedMantissa_$_hi = mantissa_$_hi;
    } else {
      var n = ((52 - (actualPrecision << 2)) | 0);
      var lo$3 = (((32 & n) === 0) ? (1 << n) : 0);
      var hi$4 = (((32 & n) === 0) ? 0 : (1 << n));
      var lo$4 = ((lo$3 - 1) | 0);
      var hi$5 = ((((hi$4 - 1) | 0) + (((lo$3 | (~lo$4)) >>> 31) | 0)) | 0);
      var lo$5 = (((lo$3 >>> 1) | 0) | (hi$4 << 31));
      var hi$6 = (hi$4 >> 1);
      var lo$6 = (~lo$4);
      var hi$7 = (~hi$5);
      var lo$7 = (mantissa_$_lo & lo$6);
      var hi$8 = (mantissa_$_hi & hi$7);
      var lo$8 = (mantissa_$_lo & lo$4);
      var hi$9 = (mantissa_$_hi & hi$5);
      if (((hi$9 === hi$6) ? ((lo$8 >>> 0) < (lo$5 >>> 0)) : (hi$9 < hi$6))) {
        var roundedMantissa_$_lo = lo$7;
        var roundedMantissa_$_hi = hi$8;
      } else if (((hi$9 === hi$6) ? ((lo$8 >>> 0) > (lo$5 >>> 0)) : (hi$9 > hi$6))) {
        var lo$9 = ((lo$7 + lo$3) | 0);
        var hi$10 = ((((hi$8 + hi$4) | 0) + ((((lo$7 & lo$3) | ((lo$7 | lo$3) & (~lo$9))) >>> 31) | 0)) | 0);
        var roundedMantissa_$_lo = lo$9;
        var roundedMantissa_$_hi = hi$10;
      } else {
        var lo$10 = (lo$7 & lo$3);
        var hi$11 = (hi$8 & hi$4);
        if (((lo$10 | hi$11) === 0)) {
          var roundedMantissa_$_lo = lo$7;
          var roundedMantissa_$_hi = hi$8;
        } else {
          var lo$11 = ((lo$7 + lo$3) | 0);
          var hi$12 = ((((hi$8 + hi$4) | 0) + ((((lo$7 & lo$3) | ((lo$7 | lo$3) & (~lo$11))) >>> 31) | 0)) | 0);
          var roundedMantissa_$_lo = lo$11;
          var roundedMantissa_$_hi = hi$12;
        }
      }
    }
    var this$30 = $m_jl_Long$();
    var baseStr = this$30.java$lang$Long$$toHexString__I__I__T(roundedMantissa_$_lo, roundedMantissa_$_hi);
    var this$34 = $n(baseStr);
    var beginIndex = this$34.length;
    if (((beginIndex >>> 0) > 13)) {
      $charAt("0000000000000", beginIndex);
    }
    var padded = (("" + $as_T("0000000000000".substring(beginIndex))) + baseStr);
    $m_ju_Formatter$();
    var condition = (padded.length === 13);
    if ((!condition)) {
      throw new $c_jl_AssertionError("padded mantissa does not have the right number of bits");
    }
    var minLength = ((actualPrecision < 1) ? 1 : actualPrecision);
    var len = padded.length;
    while (true) {
      if ((len > minLength)) {
        var index = ((len - 1) | 0);
        var $x_2 = ($charAt(padded, index) === 48);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        len = ((len - 1) | 0);
      } else {
        break;
      }
    }
    var endIndex = len;
    if ((endIndex > padded.length)) {
      $charAt(padded, endIndex);
    }
    if ((endIndex < 0)) {
      $charAt(padded, (-1));
    }
    var mantissaStr = $as_T(padded.substring(0, endIndex));
    var exponentStr = ("" + exponent);
    var prefix = (signStr + (((256 & flags) !== 0) ? "0X" : "0x"));
    var rest = ((((implicitBitStr + ".") + mantissaStr) + "p") + exponentStr);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest));
  }
}
function $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str) {
  if ((precision < 0)) {
    var $x_1 = true;
  } else {
    var this$1 = $n(str);
    var $x_1 = (precision >= this$1.length);
  }
  if ($x_1) {
    var truncatedStr = str;
  } else {
    var this$2 = $n(str);
    if ((precision > this$2.length)) {
      $charAt(this$2, precision);
    }
    if ((precision < 0)) {
      $charAt(this$2, (-1));
    }
    var truncatedStr = $as_T(this$2.substring(0, precision));
  }
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, truncatedStr));
}
function $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x) {
  var str = ((x !== x) ? "NaN" : ((x > 0.0) ? (((4 & flags) !== 0) ? "+Infinity" : (((8 & flags) !== 0) ? " Infinity" : "Infinity")) : (((64 & flags) !== 0) ? "(Infinity)" : "-Infinity")));
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
}
function $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str, basePrefix) {
  var this$1 = $n(str);
  if (((this$1.length >= width) && ((110 & flags) === 0))) {
    $n(localeInfo);
    var str$1 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str);
    $p_ju_Formatter__sendToDest__T__V($thiz, str$1);
  } else if (((126 & flags) === 0)) {
    $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
  } else {
    var this$5 = $n(str);
    if (($charAt(this$5, 0) !== 45)) {
      if (((4 & flags) !== 0)) {
        var x1___1 = "+";
        var x1___2 = str;
      } else if (((8 & flags) !== 0)) {
        var x1___1 = " ";
        var x1___2 = str;
      } else {
        var x1___1 = "";
        var x1___2 = str;
      }
    } else if (((64 & flags) !== 0)) {
      var this$9 = $n(str);
      if ((this$9.length < 1)) {
        $charAt(this$9, 1);
      }
      var _2 = ($as_T(this$9.substring(1)) + ")");
      var x1___1 = "(";
      var x1___2 = _2;
    } else {
      var this$10 = $n(str);
      if ((this$10.length < 1)) {
        $charAt(this$10, 1);
      }
      var _2$1 = $as_T(this$10.substring(1));
      var x1___1 = "-";
      var x1___2 = _2$1;
    }
    var numberPrefix = $as_T(x1___1);
    var rest0 = $as_T(x1___2);
    var prefix = (("" + numberPrefix) + basePrefix);
    var rest = (((32 & flags) !== 0) ? $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, rest0) : rest0);
    $n(localeInfo);
    var str$2 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str$2);
  }
}
function $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, s) {
  $n(localeInfo);
  var groupingSize = 3;
  var this$1 = $n(s);
  var len = this$1.length;
  var index = 0;
  while (true) {
    if ((index !== len)) {
      var this$2 = $n(s);
      var index$1 = index;
      var c = $charAt(this$2, index$1);
      var $x_1 = ((((c - 48) | 0) >>> 0) <= 9);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      index = ((1 + index) | 0);
    } else {
      break;
    }
  }
  index = ((index - groupingSize) | 0);
  if ((index <= 0)) {
    return s;
  } else {
    var this$3 = $n(s);
    var beginIndex = index;
    if (((beginIndex < 0) || (beginIndex > this$3.length))) {
      $charAt(this$3, beginIndex);
    }
    var result = $as_T(this$3.substring(beginIndex));
    while ((index > groupingSize)) {
      var next = ((index - groupingSize) | 0);
      var this$4 = $n(s);
      var endIndex = index;
      if ((next < 0)) {
        $charAt(this$4, next);
      }
      if ((endIndex > this$4.length)) {
        $charAt(this$4, endIndex);
      }
      if ((endIndex < next)) {
        $charAt(this$4, (-1));
      }
      result = (($as_T(this$4.substring(next, endIndex)) + ",") + result);
      index = next;
    }
    var this$5 = $n(s);
    var endIndex$1 = index;
    if ((endIndex$1 > this$5.length)) {
      $charAt(this$5, endIndex$1);
    }
    if ((endIndex$1 < 0)) {
      $charAt(this$5, (-1));
    }
    return (($as_T(this$5.substring(0, endIndex$1)) + ",") + result);
  }
}
function $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str) {
  if (((256 & flags) !== 0)) {
    var this$2 = $n(str);
    return $as_T(this$2.toUpperCase());
  } else {
    return str;
  }
}
function $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, str) {
  if (((256 & flags) !== 0)) {
    $n(localeInfo);
    var this$3 = $n(str);
    return $as_T(this$3.toUpperCase());
  } else {
    return str;
  }
}
function $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, str) {
  var this$1 = $n(str);
  var len = this$1.length;
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__V($thiz, str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), str);
  }
}
function $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str) {
  var this$1 = $n(prefix);
  var this$2 = $n(str);
  var len = ((this$1.length + this$2.length) | 0);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, prefix, str);
  } else if (((16 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, $p_ju_Formatter__strRepeat__T__I__T($thiz, ($n(localeInfo), "0"), ((width - len) | 0)), str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), prefix, str);
  }
}
function $p_ju_Formatter__strRepeat__T__I__T($thiz, s, times) {
  var result = "";
  var i = 0;
  while ((i !== times)) {
    result = (("" + result) + s);
    i = ((1 + i) | 0);
  }
  return result;
}
function $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, flag) {
  throw new $c_ju_DuplicateFormatFlagsException(("" + $cToS(flag)));
}
function $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion) {
  throw new $c_ju_UnknownFormatConversionException(("" + $cToS(conversion)));
}
function $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision) {
  throw new $c_ju_IllegalFormatPrecisionException(precision);
}
function $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width) {
  throw new $c_ju_IllegalFormatWidthException(width);
}
function $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, index) {
  var msg = ((index === 0) ? "Illegal format argument index = 0" : "Format argument index: (not representable as int)");
  throw new $c_ju_IllegalFormatArgumentIndexException(msg);
}
function $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatWidthException(fullFormatSpecifier);
}
function $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatArgumentException(fullFormatSpecifier);
}
function $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, arg) {
  throw new $c_ju_IllegalFormatCodePointException(arg);
}
function $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult$1) {
  return ("%" + execResult$1[0]);
}
function $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, x, flags$1, precision$1, conversionLower$1, localeInfo$1, width$1) {
  var forceDecimalSep = ((2 & flags$1) !== 0);
  var actualPrecision = ((precision$1 >= 0) ? precision$1 : 6);
  switch (conversionLower$1) {
    case 101: {
      var notation = $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    case 102: {
      var notation = $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    default: {
      var notation = $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
    }
  }
  $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo$1, flags$1, width$1, notation, "");
}
function $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, dest, formatterLocaleInfo) {
  $thiz.ju_Formatter__f_dest = dest;
  $thiz.ju_Formatter__f_formatterLocaleInfo = formatterLocaleInfo;
  $thiz.ju_Formatter__f_stringOutput = "";
  $thiz.ju_Formatter__f_java$util$Formatter$$closed = false;
  return $thiz;
}
function $ct_ju_Formatter__($thiz) {
  $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, null, $m_ju_Formatter$RootLocaleInfo$());
  return $thiz;
}
/** @constructor */
function $c_ju_Formatter() {
  this.ju_Formatter__f_dest = null;
  this.ju_Formatter__f_formatterLocaleInfo = null;
  this.ju_Formatter__f_stringOutput = null;
  this.ju_Formatter__f_java$util$Formatter$$closed = false;
}
$c_ju_Formatter.prototype = new $h_O();
$c_ju_Formatter.prototype.constructor = $c_ju_Formatter;
/** @constructor */
function $h_ju_Formatter() {
}
$h_ju_Formatter.prototype = $c_ju_Formatter.prototype;
$c_ju_Formatter.prototype.format__T__AO__ju_Formatter = (function(format, args) {
  return $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter(this, this.ju_Formatter__f_formatterLocaleInfo, format, args);
});
$c_ju_Formatter.prototype.toString__T = (function() {
  if (this.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException();
  }
  return ((this.ju_Formatter__f_dest === null) ? this.ju_Formatter__f_stringOutput : $n(this.ju_Formatter__f_dest).toString__T());
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatFlagsException__I__E = (function(flags) {
  throw new $c_ju_IllegalFormatFlagsException($p_ju_Formatter__flagsToString__I__T(this, flags));
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E = (function(conversionLower, flags, illegalFlags) {
  throw new $c_ju_FormatFlagsConversionMismatchException($p_ju_Formatter__flagsToString__I__T(this, (flags & illegalFlags)), conversionLower);
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E = (function(conversionLower, arg) {
  var this$1 = $n(arg);
  throw new $c_ju_IllegalFormatConversionException(conversionLower, $objectGetClass(this$1));
});
var $d_ju_Formatter = new $TypeData().initClass($c_ju_Formatter, "java.util.Formatter", ({
  ju_Formatter: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
}));
/** @constructor */
function $c_ju_HashMap$Values(outer) {
  this.ju_HashMap$Values__f_$outer = null;
  $n(outer);
  this.ju_HashMap$Values__f_$outer = outer;
}
$c_ju_HashMap$Values.prototype = new $h_ju_AbstractCollection();
$c_ju_HashMap$Values.prototype.constructor = $c_ju_HashMap$Values;
/** @constructor */
function $h_ju_HashMap$Values() {
}
$h_ju_HashMap$Values.prototype = $c_ju_HashMap$Values.prototype;
$c_ju_HashMap$Values.prototype.iterator__ju_Iterator = (function() {
  return $n(this.ju_HashMap$Values__f_$outer).valueIterator__ju_Iterator();
});
$c_ju_HashMap$Values.prototype.size__I = (function() {
  return $n(this.ju_HashMap$Values__f_$outer).ju_HashMap__f_contentSize;
});
$c_ju_HashMap$Values.prototype.contains__O__Z = (function(o) {
  return $n(this.ju_HashMap$Values__f_$outer).containsValue__O__Z(o);
});
var $d_ju_HashMap$Values = new $TypeData().initClass($c_ju_HashMap$Values, "java.util.HashMap$Values", ({
  ju_HashMap$Values: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1
}));
function $is_ju_List(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_List)));
}
function $as_ju_List(obj) {
  return (($is_ju_List(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.List"));
}
function $isArrayOf_ju_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_List)));
}
function $asArrayOf_ju_List(obj, depth) {
  return (($isArrayOf_ju_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.List;", depth));
}
/** @constructor */
function $c_ju_Locale$LocaleBuilder(strict, language, region, variant, script, extensions, unicodeExtensions, unicodeAttributes) {
  this.ju_Locale$LocaleBuilder__f_strict = false;
  this.ju_Locale$LocaleBuilder__f_language = null;
  this.ju_Locale$LocaleBuilder__f_region = null;
  this.ju_Locale$LocaleBuilder__f_variant = null;
  this.ju_Locale$LocaleBuilder__f_script = null;
  this.ju_Locale$LocaleBuilder__f_extensions = null;
  this.ju_Locale$LocaleBuilder__f_unicodeExtensions = null;
  this.ju_Locale$LocaleBuilder__f_unicodeAttributes = null;
  this.ju_Locale$LocaleBuilder__f_strict = strict;
  this.ju_Locale$LocaleBuilder__f_language = language;
  this.ju_Locale$LocaleBuilder__f_region = region;
  this.ju_Locale$LocaleBuilder__f_variant = variant;
  this.ju_Locale$LocaleBuilder__f_script = script;
  this.ju_Locale$LocaleBuilder__f_extensions = extensions;
  this.ju_Locale$LocaleBuilder__f_unicodeExtensions = unicodeExtensions;
  this.ju_Locale$LocaleBuilder__f_unicodeAttributes = unicodeAttributes;
}
$c_ju_Locale$LocaleBuilder.prototype = new $h_O();
$c_ju_Locale$LocaleBuilder.prototype.constructor = $c_ju_Locale$LocaleBuilder;
/** @constructor */
function $h_ju_Locale$LocaleBuilder() {
}
$h_ju_Locale$LocaleBuilder.prototype = $c_ju_Locale$LocaleBuilder.prototype;
$c_ju_Locale$LocaleBuilder.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_ju_Locale$LocaleBuilder.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LocaleBuilder");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.ju_Locale$LocaleBuilder__f_strict ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.ju_Locale$LocaleBuilder__f_language;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.ju_Locale$LocaleBuilder__f_region;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.ju_Locale$LocaleBuilder__f_variant;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.ju_Locale$LocaleBuilder__f_script;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.ju_Locale$LocaleBuilder__f_extensions;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$9, 8);
});
$c_ju_Locale$LocaleBuilder.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_ju_Locale$LocaleBuilder)) {
    var x$0$2 = $as_ju_Locale$LocaleBuilder(x$0);
    if ((this.ju_Locale$LocaleBuilder__f_strict === $n(x$0$2).ju_Locale$LocaleBuilder__f_strict)) {
      var x = this.ju_Locale$LocaleBuilder__f_language;
      var x$2 = $n(x$0$2).ju_Locale$LocaleBuilder__f_language;
      var $x_7 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$3 = this.ju_Locale$LocaleBuilder__f_region;
      var x$4 = $n(x$0$2).ju_Locale$LocaleBuilder__f_region;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.ju_Locale$LocaleBuilder__f_variant;
      var x$6 = $n(x$0$2).ju_Locale$LocaleBuilder__f_variant;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.ju_Locale$LocaleBuilder__f_script;
      var x$8 = $n(x$0$2).ju_Locale$LocaleBuilder__f_script;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.ju_Locale$LocaleBuilder__f_extensions;
      var x$10 = $n(x$0$2).ju_Locale$LocaleBuilder__f_extensions;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      var x$12 = $n(x$0$2).ju_Locale$LocaleBuilder__f_unicodeExtensions;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      var x$14 = $n(x$0$2).ju_Locale$LocaleBuilder__f_unicodeAttributes;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_Locale$LocaleBuilder.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_ju_Locale$LocaleBuilder.prototype.productArity__I = (function() {
  return 8;
});
$c_ju_Locale$LocaleBuilder.prototype.productPrefix__T = (function() {
  return "LocaleBuilder";
});
$c_ju_Locale$LocaleBuilder.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.ju_Locale$LocaleBuilder__f_strict;
      break;
    }
    case 1: {
      return this.ju_Locale$LocaleBuilder__f_language;
      break;
    }
    case 2: {
      return this.ju_Locale$LocaleBuilder__f_region;
      break;
    }
    case 3: {
      return this.ju_Locale$LocaleBuilder__f_variant;
      break;
    }
    case 4: {
      return this.ju_Locale$LocaleBuilder__f_script;
      break;
    }
    case 5: {
      return this.ju_Locale$LocaleBuilder__f_extensions;
      break;
    }
    case 6: {
      return this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      break;
    }
    case 7: {
      return this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_ju_Locale$LocaleBuilder.prototype.language__T__s_Option = (function(language) {
  if ((language === null)) {
    var $x_1 = true;
  } else {
    var this$1 = $n(language);
    var $x_1 = (this$1 === "");
  }
  if ($x_1) {
    var language$3 = $m_s_None$();
    var strict$1 = this.ju_Locale$LocaleBuilder__f_strict;
    var region$1 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$3 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$3 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$1 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$1 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$1 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$1, language$3, region$1, variant$3, script$3, extensions$1, unicodeExtensions$1, unicodeAttributes$1);
    return new $c_s_Some(value);
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkLanguage__T__Z(language))) {
    var this$3 = $n(language);
    var value$1 = $as_T(this$3.toLowerCase());
    var language$4 = new $c_s_Some(value$1);
    var strict$2 = this.ju_Locale$LocaleBuilder__f_strict;
    var region$2 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$4 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$4 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$2 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$2 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$2 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$2, language$4, region$2, variant$4, script$4, extensions$2, unicodeExtensions$2, unicodeAttributes$2);
    return new $c_s_Some(value$2);
  } else {
    return $m_s_None$();
  }
});
$c_ju_Locale$LocaleBuilder.prototype.script__T__s_Option = (function(script) {
  if ((script === null)) {
    var $x_1 = true;
  } else {
    var this$1 = $n(script);
    var $x_1 = (this$1 === "");
  }
  if ($x_1) {
    var script$5 = $m_s_None$();
    var strict$3 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$5 = this.ju_Locale$LocaleBuilder__f_language;
    var region$3 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$5 = this.ju_Locale$LocaleBuilder__f_variant;
    var extensions$3 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$3 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$3 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$3, language$5, region$3, variant$5, script$5, extensions$3, unicodeExtensions$3, unicodeAttributes$3);
    return new $c_s_Some(value);
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkScript__T__Z(script))) {
    var this$3 = $n(script);
    var c = $charAt(this$3, 0);
    var $x_2 = $m_jl_Character$().toUpperCase__C__C(c);
    var this$6 = $n(script);
    if ((this$6.length < 1)) {
      $charAt(this$6, 1);
    }
    var value$1 = ($cToS($x_2) + $as_T(this$6.substring(1)));
    var script$6 = new $c_s_Some(value$1);
    var strict$4 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$6 = this.ju_Locale$LocaleBuilder__f_language;
    var region$4 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$6 = this.ju_Locale$LocaleBuilder__f_variant;
    var extensions$4 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$4 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$4 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$4, language$6, region$4, variant$6, script$6, extensions$4, unicodeExtensions$4, unicodeAttributes$4);
    return new $c_s_Some(value$2);
  } else {
    return $m_s_None$();
  }
});
$c_ju_Locale$LocaleBuilder.prototype.region__T__s_Option = (function(region) {
  if ((region === null)) {
    var $x_1 = true;
  } else {
    var this$1 = $n(region);
    var $x_1 = (this$1 === "");
  }
  if ($x_1) {
    var region$5 = $m_s_None$();
    var strict$5 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$7 = this.ju_Locale$LocaleBuilder__f_language;
    var variant$7 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$7 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$5 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$5 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$5 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$5, language$7, region$5, variant$7, script$7, extensions$5, unicodeExtensions$5, unicodeAttributes$5);
    return new $c_s_Some(value);
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkRegion__T__Z(region))) {
    var this$3 = $n(region);
    var value$1 = $as_T(this$3.toUpperCase());
    var region$6 = new $c_s_Some(value$1);
    var strict$6 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$8 = this.ju_Locale$LocaleBuilder__f_language;
    var variant$8 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$8 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$6 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$6 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$6 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$6, language$8, region$6, variant$8, script$8, extensions$6, unicodeExtensions$6, unicodeAttributes$6);
    return new $c_s_Some(value$2);
  } else {
    return $m_s_None$();
  }
});
$c_ju_Locale$LocaleBuilder.prototype.variant__T__s_Option = (function(variant) {
  if ((variant === null)) {
    var $x_1 = true;
  } else {
    var this$1 = $n(variant);
    var $x_1 = (this$1 === "");
  }
  if ($x_1) {
    var variant$10 = $m_s_None$();
    var strict$8 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$10 = this.ju_Locale$LocaleBuilder__f_language;
    var region$8 = this.ju_Locale$LocaleBuilder__f_region;
    var script$10 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$8 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$8 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$8 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$8, language$10, region$8, variant$10, script$10, extensions$8, unicodeExtensions$8, unicodeAttributes$8);
    return new $c_s_Some(value);
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkVariant__T__Z(variant))) {
    var this$3 = $n(variant);
    var value$1 = $as_T(this$3.split("-").join("_"));
    var variant$11 = new $c_s_Some(value$1);
    var strict$9 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$11 = this.ju_Locale$LocaleBuilder__f_language;
    var region$9 = this.ju_Locale$LocaleBuilder__f_region;
    var script$11 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$9 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$9 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$9 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$9, language$11, region$9, variant$11, script$11, extensions$9, unicodeExtensions$9, unicodeAttributes$9);
    return new $c_s_Some(value$2);
  } else {
    return $m_s_None$();
  }
});
$c_ju_Locale$LocaleBuilder.prototype.build__ju_Locale = (function() {
  var this$1 = $n(this.ju_Locale$LocaleBuilder__f_language);
  var $x_2 = $as_T((this$1.isEmpty__Z() ? "" : this$1.get__O()));
  var this$2 = $n(this.ju_Locale$LocaleBuilder__f_region);
  var $x_1 = $as_T((this$2.isEmpty__Z() ? "" : this$2.get__O()));
  var this$3 = $n(this.ju_Locale$LocaleBuilder__f_variant);
  return new $c_ju_Locale($x_2, $x_1, $as_T((this$3.isEmpty__Z() ? "" : this$3.get__O())), this.ju_Locale$LocaleBuilder__f_script, this.ju_Locale$LocaleBuilder__f_extensions, this.ju_Locale$LocaleBuilder__f_unicodeExtensions, this.ju_Locale$LocaleBuilder__f_unicodeAttributes, ($m_ju_Locale$(), true));
});
function $as_ju_Locale$LocaleBuilder(obj) {
  return (((obj instanceof $c_ju_Locale$LocaleBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Locale$LocaleBuilder"));
}
function $isArrayOf_ju_Locale$LocaleBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale$LocaleBuilder)));
}
function $asArrayOf_ju_Locale$LocaleBuilder(obj, depth) {
  return (($isArrayOf_ju_Locale$LocaleBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Locale$LocaleBuilder;", depth));
}
var $d_ju_Locale$LocaleBuilder = new $TypeData().initClass($c_ju_Locale$LocaleBuilder, "java.util.Locale$LocaleBuilder", ({
  ju_Locale$LocaleBuilder: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_concurrent_ExecutionException extends $c_jl_Exception {
  constructor(message, cause) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
  }
}
var $d_ju_concurrent_ExecutionException = new $TypeData().initClass($c_ju_concurrent_ExecutionException, "java.util.concurrent.ExecutionException", ({
  ju_concurrent_ExecutionException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_ThreadLocalRandom() {
  this.ju_Random__f_java$util$Random$$seed_$lo = 0;
  this.ju_Random__f_java$util$Random$$seed_$hi = 0;
  this.ju_concurrent_ThreadLocalRandom__f_initialized = false;
  var $x_1 = $m_ju_Random$().java$util$Random$$randomSeed__J();
  $ct_ju_Random__J__(this, $x_1.l, $x_1.h);
  this.ju_concurrent_ThreadLocalRandom__f_initialized = true;
}
$c_ju_concurrent_ThreadLocalRandom.prototype = new $h_ju_Random();
$c_ju_concurrent_ThreadLocalRandom.prototype.constructor = $c_ju_concurrent_ThreadLocalRandom;
/** @constructor */
function $h_ju_concurrent_ThreadLocalRandom() {
}
$h_ju_concurrent_ThreadLocalRandom.prototype = $c_ju_concurrent_ThreadLocalRandom.prototype;
$c_ju_concurrent_ThreadLocalRandom.prototype.setSeed__J__V = (function(seed_$_lo, seed_$_hi) {
  if (this.ju_concurrent_ThreadLocalRandom__f_initialized) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  $c_ju_Random.prototype.setSeed__J__V.call(this, seed_$_lo, seed_$_hi);
});
var $d_ju_concurrent_ThreadLocalRandom = new $TypeData().initClass($c_ju_concurrent_ThreadLocalRandom, "java.util.concurrent.ThreadLocalRandom", ({
  ju_concurrent_ThreadLocalRandom: 1,
  ju_Random: 1,
  ju_random_RandomGenerator: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
$c_ju_concurrent_TimeUnit.prototype = new $h_jl_Enum();
$c_ju_concurrent_TimeUnit.prototype.constructor = $c_ju_concurrent_TimeUnit;
/** @constructor */
function $h_ju_concurrent_TimeUnit() {
}
$h_ju_concurrent_TimeUnit.prototype = $c_ju_concurrent_TimeUnit.prototype;
function $as_ju_concurrent_TimeUnit(obj) {
  return (((obj instanceof $c_ju_concurrent_TimeUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.TimeUnit"));
}
function $isArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_TimeUnit)));
}
function $asArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (($isArrayOf_ju_concurrent_TimeUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.TimeUnit;", depth));
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ByteArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uB(o1);
  var y = $uB(o2);
  return ((x - y) | 0);
});
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_B(a, 1);
  var v$1 = $uB(v);
  $n(a$1).set(i, v$1);
});
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_B(a, 1);
  return $n(a$1).get(i);
});
var $d_ju_internal_GenericArrayOps$ByteArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$ByteArrayOps$, "java.util.internal.GenericArrayOps$ByteArrayOps$", ({
  ju_internal_GenericArrayOps$ByteArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$ByteArrayOps$;
function $m_ju_internal_GenericArrayOps$ByteArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ByteArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ByteArrayOps$ = new $c_ju_internal_GenericArrayOps$ByteArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ByteArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$CharArrayOps$() {
}
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$CharArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$CharArrayOps$() {
}
$h_ju_internal_GenericArrayOps$CharArrayOps$.prototype = $c_ju_internal_GenericArrayOps$CharArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uC(o1);
  var y = $uC(o2);
  return ((x - y) | 0);
});
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_C(a, 1);
  var v$1 = $uC(v);
  $n(a$1).set(i, v$1);
});
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_C(a, 1);
  return $bC($n(a$1).get(i));
});
var $d_ju_internal_GenericArrayOps$CharArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$CharArrayOps$, "java.util.internal.GenericArrayOps$CharArrayOps$", ({
  ju_internal_GenericArrayOps$CharArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$CharArrayOps$;
function $m_ju_internal_GenericArrayOps$CharArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$CharArrayOps$)) {
    $n_ju_internal_GenericArrayOps$CharArrayOps$ = new $c_ju_internal_GenericArrayOps$CharArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$CharArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$IntArrayOps$() {
}
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$IntArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$IntArrayOps$() {
}
$h_ju_internal_GenericArrayOps$IntArrayOps$.prototype = $c_ju_internal_GenericArrayOps$IntArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uI(o1);
  var y = $uI(o2);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_I(a, 1);
  var v$1 = $uI(v);
  $n(a$1).set(i, v$1);
});
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_I(a, 1);
  return $n(a$1).get(i);
});
var $d_ju_internal_GenericArrayOps$IntArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$IntArrayOps$, "java.util.internal.GenericArrayOps$IntArrayOps$", ({
  ju_internal_GenericArrayOps$IntArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$IntArrayOps$;
function $m_ju_internal_GenericArrayOps$IntArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$IntArrayOps$)) {
    $n_ju_internal_GenericArrayOps$IntArrayOps$ = new $c_ju_internal_GenericArrayOps$IntArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$IntArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$LongArrayOps$() {
}
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$LongArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$LongArrayOps$() {
}
$h_ju_internal_GenericArrayOps$LongArrayOps$.prototype = $c_ju_internal_GenericArrayOps$LongArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var $x_1 = $uJ(o1);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var $x_2 = $uJ(o2);
  var y_$_lo = $x_2.l;
  var y_$_hi = $x_2.h;
  return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
});
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_J(a, 1);
  var $x_1 = $uJ(v);
  var v$1_$_lo = $x_1.l;
  var v$1_$_hi = $x_1.h;
  $n(a$1).set(i, v$1_$_lo, v$1_$_hi);
});
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_J(a, 1);
  var $x_1 = $n(a$1).u;
  var $x_2 = $aJCheckGet($x_1, i);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
var $d_ju_internal_GenericArrayOps$LongArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$LongArrayOps$, "java.util.internal.GenericArrayOps$LongArrayOps$", ({
  ju_internal_GenericArrayOps$LongArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$LongArrayOps$;
function $m_ju_internal_GenericArrayOps$LongArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$LongArrayOps$)) {
    $n_ju_internal_GenericArrayOps$LongArrayOps$ = new $c_ju_internal_GenericArrayOps$LongArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$LongArrayOps$;
}
/** @constructor */
function $c_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ShortArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
$h_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uS(o1);
  var y = $uS(o2);
  return ((x - y) | 0);
});
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var a$1 = $asArrayOf_S(a, 1);
  var v$1 = $uS(v);
  $n(a$1).set(i, v$1);
});
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.get__O__I__O = (function(a, i) {
  var a$1 = $asArrayOf_S(a, 1);
  return $n(a$1).get(i);
});
var $d_ju_internal_GenericArrayOps$ShortArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$ShortArrayOps$, "java.util.internal.GenericArrayOps$ShortArrayOps$", ({
  ju_internal_GenericArrayOps$ShortArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
var $n_ju_internal_GenericArrayOps$ShortArrayOps$;
function $m_ju_internal_GenericArrayOps$ShortArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ShortArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ShortArrayOps$ = new $c_ju_internal_GenericArrayOps$ShortArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ShortArrayOps$;
}
/** @constructor */
function $c_Llocales_cldr_CLDRMetadata(isoCountries, iso3Countries, isoLanguages, iso3Languages, scripts) {
  this.Llocales_cldr_CLDRMetadata__f_isoCountries = null;
  this.Llocales_cldr_CLDRMetadata__f_iso3Countries = null;
  this.Llocales_cldr_CLDRMetadata__f_isoLanguages = null;
  this.Llocales_cldr_CLDRMetadata__f_iso3Languages = null;
  this.Llocales_cldr_CLDRMetadata__f_scripts = null;
  this.Llocales_cldr_CLDRMetadata__f_isoCountries = isoCountries;
  this.Llocales_cldr_CLDRMetadata__f_iso3Countries = iso3Countries;
  this.Llocales_cldr_CLDRMetadata__f_isoLanguages = isoLanguages;
  this.Llocales_cldr_CLDRMetadata__f_iso3Languages = iso3Languages;
  this.Llocales_cldr_CLDRMetadata__f_scripts = scripts;
}
$c_Llocales_cldr_CLDRMetadata.prototype = new $h_O();
$c_Llocales_cldr_CLDRMetadata.prototype.constructor = $c_Llocales_cldr_CLDRMetadata;
/** @constructor */
function $h_Llocales_cldr_CLDRMetadata() {
}
$h_Llocales_cldr_CLDRMetadata.prototype = $c_Llocales_cldr_CLDRMetadata.prototype;
$c_Llocales_cldr_CLDRMetadata.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_CLDRMetadata.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_CLDRMetadata.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CLDRMetadata)) {
    var x$0$2 = $as_Llocales_cldr_CLDRMetadata(x$0);
    var x = this.Llocales_cldr_CLDRMetadata__f_isoCountries;
    var x$2 = $n(x$0$2).Llocales_cldr_CLDRMetadata__f_isoCountries;
    if ((x === null)) {
      var $x_4 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_4 = (this$1 === x$2);
    }
    if ($x_4) {
      var x$3 = this.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      var x$4 = $n(x$0$2).Llocales_cldr_CLDRMetadata__f_iso3Countries;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llocales_cldr_CLDRMetadata__f_isoLanguages;
      var x$6 = $n(x$0$2).Llocales_cldr_CLDRMetadata__f_isoLanguages;
      if ((x$5 === null)) {
        var $x_2 = (x$6 === null);
      } else {
        var this$2 = $n(x$5);
        var $x_2 = (this$2 === x$6);
      }
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llocales_cldr_CLDRMetadata__f_iso3Languages;
      var x$8 = $n(x$0$2).Llocales_cldr_CLDRMetadata__f_iso3Languages;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.Llocales_cldr_CLDRMetadata__f_scripts;
      var x$10 = $n(x$0$2).Llocales_cldr_CLDRMetadata__f_scripts;
      if ((x$9 === null)) {
        return (x$10 === null);
      } else {
        var this$3 = $n(x$9);
        return (this$3 === x$10);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_CLDRMetadata.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_CLDRMetadata.prototype.productArity__I = (function() {
  return 5;
});
$c_Llocales_cldr_CLDRMetadata.prototype.productPrefix__T = (function() {
  return "CLDRMetadata";
});
$c_Llocales_cldr_CLDRMetadata.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_CLDRMetadata__f_isoCountries;
      break;
    }
    case 1: {
      return this.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      break;
    }
    case 2: {
      return this.Llocales_cldr_CLDRMetadata__f_isoLanguages;
      break;
    }
    case 3: {
      return this.Llocales_cldr_CLDRMetadata__f_iso3Languages;
      break;
    }
    case 4: {
      return this.Llocales_cldr_CLDRMetadata__f_scripts;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llocales_cldr_CLDRMetadata(obj) {
  return (((obj instanceof $c_Llocales_cldr_CLDRMetadata) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CLDRMetadata"));
}
function $isArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CLDRMetadata)));
}
function $asArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CLDRMetadata;", depth));
}
var $d_Llocales_cldr_CLDRMetadata = new $TypeData().initClass($c_Llocales_cldr_CLDRMetadata, "locales.cldr.CLDRMetadata", ({
  Llocales_cldr_CLDRMetadata: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns) {
  this.Llocales_cldr_CalendarPatterns__f_datePatterns = null;
  this.Llocales_cldr_CalendarPatterns__f_timePatterns = null;
  this.Llocales_cldr_CalendarPatterns__f_datePatterns = datePatterns;
  this.Llocales_cldr_CalendarPatterns__f_timePatterns = timePatterns;
}
$c_Llocales_cldr_CalendarPatterns.prototype = new $h_O();
$c_Llocales_cldr_CalendarPatterns.prototype.constructor = $c_Llocales_cldr_CalendarPatterns;
/** @constructor */
function $h_Llocales_cldr_CalendarPatterns() {
}
$h_Llocales_cldr_CalendarPatterns.prototype = $c_Llocales_cldr_CalendarPatterns.prototype;
$c_Llocales_cldr_CalendarPatterns.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_CalendarPatterns.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_CalendarPatterns.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CalendarPatterns)) {
    var x$0$2 = $as_Llocales_cldr_CalendarPatterns(x$0);
    var x = this.Llocales_cldr_CalendarPatterns__f_datePatterns;
    var x$2 = $n(x$0$2).Llocales_cldr_CalendarPatterns__f_datePatterns;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CalendarPatterns__f_timePatterns;
      var x$4 = $n(x$0$2).Llocales_cldr_CalendarPatterns__f_timePatterns;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_CalendarPatterns.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_CalendarPatterns.prototype.productArity__I = (function() {
  return 2;
});
$c_Llocales_cldr_CalendarPatterns.prototype.productPrefix__T = (function() {
  return "CalendarPatterns";
});
$c_Llocales_cldr_CalendarPatterns.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llocales_cldr_CalendarPatterns__f_datePatterns;
  }
  if ((n === 1)) {
    return this.Llocales_cldr_CalendarPatterns__f_timePatterns;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llocales_cldr_CalendarPatterns(obj) {
  return (((obj instanceof $c_Llocales_cldr_CalendarPatterns) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CalendarPatterns"));
}
function $isArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CalendarPatterns)));
}
function $asArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CalendarPatterns;", depth));
}
var $d_Llocales_cldr_CalendarPatterns = new $TypeData().initClass($c_Llocales_cldr_CalendarPatterns, "locales.cldr.CalendarPatterns", ({
  Llocales_cldr_CalendarPatterns: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras) {
  this.Llocales_cldr_CalendarSymbols__f_months = null;
  this.Llocales_cldr_CalendarSymbols__f_shortMonths = null;
  this.Llocales_cldr_CalendarSymbols__f_weekdays = null;
  this.Llocales_cldr_CalendarSymbols__f_shortWeekdays = null;
  this.Llocales_cldr_CalendarSymbols__f_amPm = null;
  this.Llocales_cldr_CalendarSymbols__f_eras = null;
  this.Llocales_cldr_CalendarSymbols__f_months = months;
  this.Llocales_cldr_CalendarSymbols__f_shortMonths = shortMonths;
  this.Llocales_cldr_CalendarSymbols__f_weekdays = weekdays;
  this.Llocales_cldr_CalendarSymbols__f_shortWeekdays = shortWeekdays;
  this.Llocales_cldr_CalendarSymbols__f_amPm = amPm;
  this.Llocales_cldr_CalendarSymbols__f_eras = eras;
}
$c_Llocales_cldr_CalendarSymbols.prototype = new $h_O();
$c_Llocales_cldr_CalendarSymbols.prototype.constructor = $c_Llocales_cldr_CalendarSymbols;
/** @constructor */
function $h_Llocales_cldr_CalendarSymbols() {
}
$h_Llocales_cldr_CalendarSymbols.prototype = $c_Llocales_cldr_CalendarSymbols.prototype;
$c_Llocales_cldr_CalendarSymbols.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_CalendarSymbols.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_CalendarSymbols.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CalendarSymbols)) {
    var x$0$2 = $as_Llocales_cldr_CalendarSymbols(x$0);
    var x = this.Llocales_cldr_CalendarSymbols__f_months;
    var x$2 = $n(x$0$2).Llocales_cldr_CalendarSymbols__f_months;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CalendarSymbols__f_shortMonths;
      var x$4 = $n(x$0$2).Llocales_cldr_CalendarSymbols__f_shortMonths;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.Llocales_cldr_CalendarSymbols__f_weekdays;
      var x$6 = $n(x$0$2).Llocales_cldr_CalendarSymbols__f_weekdays;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      var x$8 = $n(x$0$2).Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.Llocales_cldr_CalendarSymbols__f_amPm;
      var x$10 = $n(x$0$2).Llocales_cldr_CalendarSymbols__f_amPm;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.Llocales_cldr_CalendarSymbols__f_eras;
      var x$12 = $n(x$0$2).Llocales_cldr_CalendarSymbols__f_eras;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_CalendarSymbols.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_CalendarSymbols.prototype.productArity__I = (function() {
  return 6;
});
$c_Llocales_cldr_CalendarSymbols.prototype.productPrefix__T = (function() {
  return "CalendarSymbols";
});
$c_Llocales_cldr_CalendarSymbols.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_CalendarSymbols__f_months;
      break;
    }
    case 1: {
      return this.Llocales_cldr_CalendarSymbols__f_shortMonths;
      break;
    }
    case 2: {
      return this.Llocales_cldr_CalendarSymbols__f_weekdays;
      break;
    }
    case 3: {
      return this.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      break;
    }
    case 4: {
      return this.Llocales_cldr_CalendarSymbols__f_amPm;
      break;
    }
    case 5: {
      return this.Llocales_cldr_CalendarSymbols__f_eras;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llocales_cldr_CalendarSymbols(obj) {
  return (((obj instanceof $c_Llocales_cldr_CalendarSymbols) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CalendarSymbols"));
}
function $isArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CalendarSymbols)));
}
function $asArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CalendarSymbols;", depth));
}
var $d_Llocales_cldr_CalendarSymbols = new $TypeData().initClass($c_Llocales_cldr_CalendarSymbols, "locales.cldr.CalendarSymbols", ({
  Llocales_cldr_CalendarSymbols: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llocales_cldr_CurrencyData(currencyTypes, fractions, regions, numericCodes) {
  this.Llocales_cldr_CurrencyData__f_currencyTypes = null;
  this.Llocales_cldr_CurrencyData__f_fractions = null;
  this.Llocales_cldr_CurrencyData__f_regions = null;
  this.Llocales_cldr_CurrencyData__f_numericCodes = null;
  this.Llocales_cldr_CurrencyData__f_currencyTypes = currencyTypes;
  this.Llocales_cldr_CurrencyData__f_fractions = fractions;
  this.Llocales_cldr_CurrencyData__f_regions = regions;
  this.Llocales_cldr_CurrencyData__f_numericCodes = numericCodes;
}
$c_Llocales_cldr_CurrencyData.prototype = new $h_O();
$c_Llocales_cldr_CurrencyData.prototype.constructor = $c_Llocales_cldr_CurrencyData;
/** @constructor */
function $h_Llocales_cldr_CurrencyData() {
}
$h_Llocales_cldr_CurrencyData.prototype = $c_Llocales_cldr_CurrencyData.prototype;
$c_Llocales_cldr_CurrencyData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_CurrencyData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_CurrencyData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CurrencyData)) {
    var x$0$2 = $as_Llocales_cldr_CurrencyData(x$0);
    var x = this.Llocales_cldr_CurrencyData__f_currencyTypes;
    var x$2 = $n(x$0$2).Llocales_cldr_CurrencyData__f_currencyTypes;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CurrencyData__f_fractions;
      var x$4 = $n(x$0$2).Llocales_cldr_CurrencyData__f_fractions;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llocales_cldr_CurrencyData__f_regions;
      var x$6 = $n(x$0$2).Llocales_cldr_CurrencyData__f_regions;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Llocales_cldr_CurrencyData__f_numericCodes;
      var x$8 = $n(x$0$2).Llocales_cldr_CurrencyData__f_numericCodes;
      return ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_CurrencyData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_CurrencyData.prototype.productArity__I = (function() {
  return 4;
});
$c_Llocales_cldr_CurrencyData.prototype.productPrefix__T = (function() {
  return "CurrencyData";
});
$c_Llocales_cldr_CurrencyData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_CurrencyData__f_currencyTypes;
      break;
    }
    case 1: {
      return this.Llocales_cldr_CurrencyData__f_fractions;
      break;
    }
    case 2: {
      return this.Llocales_cldr_CurrencyData__f_regions;
      break;
    }
    case 3: {
      return this.Llocales_cldr_CurrencyData__f_numericCodes;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llocales_cldr_CurrencyData(obj) {
  return (((obj instanceof $c_Llocales_cldr_CurrencyData) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.CurrencyData"));
}
function $isArrayOf_Llocales_cldr_CurrencyData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyData)));
}
function $asArrayOf_Llocales_cldr_CurrencyData(obj, depth) {
  return (($isArrayOf_Llocales_cldr_CurrencyData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.CurrencyData;", depth));
}
var $d_Llocales_cldr_CurrencyData = new $TypeData().initClass($c_Llocales_cldr_CurrencyData, "locales.cldr.CurrencyData", ({
  Llocales_cldr_CurrencyData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__($thiz, parent, locale, defaultNS, digitSymbols, calendarSymbols, calendarPatterns, currencies, numberPatterns) {
  $thiz.Llocales_cldr_LDML__f_parent = parent;
  $thiz.Llocales_cldr_LDML__f_locale = locale;
  $thiz.Llocales_cldr_LDML__f_defaultNS = defaultNS;
  $thiz.Llocales_cldr_LDML__f_digitSymbols = digitSymbols;
  $thiz.Llocales_cldr_LDML__f_calendarSymbols = calendarSymbols;
  $thiz.Llocales_cldr_LDML__f_calendarPatterns = calendarPatterns;
  $thiz.Llocales_cldr_LDML__f_currencies = currencies;
  $thiz.Llocales_cldr_LDML__f_numberPatterns = numberPatterns;
  var this$1 = $n(currencies);
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var _$1 = $as_Llocales_cldr_NumberCurrency(elem);
    var key = $n(_$1).currencyCode__T();
    var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_scm_ListBuffer()))));
    var this$3 = $n(bldr);
    this$3.addOne__O__scm_Growable(elem);
  }
  var this$4 = $m_sci_HashMap$();
  var result = this$4.sci_HashMap$__f_EmptyMap;
  var mapIt = $n(m).iterator__sc_Iterator();
  while ($n(mapIt).hasNext__Z()) {
    var x1 = $as_T2($n(mapIt).next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = $n(x1)._1__O();
    var v = $as_scm_Builder($n(x1)._2__O());
    result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
  }
  var this$5 = $n(result);
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$5.iterator__sc_Iterator();
  while ($n(it$1).hasNext__Z()) {
    var x0 = $n(it$1).next__O();
    var x$1 = $as_T2(x0);
    matchResult10: {
      var elem$1___1;
      var elem$1___2;
      if ((x$1 !== null)) {
        var code = $as_T($n(x$1)._1__O());
        var list = $as_sci_List($n(x$1)._2__O());
        var this$7 = $n(code);
        var self = $as_T(this$7.toUpperCase());
        var y = $n(list).head__O();
        var elem$1___1 = self;
        var elem$1___2 = y;
        break matchResult10;
      }
      throw new $c_s_MatchError(x$1);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0);
  }
  b.result__sci_HashMap();
  return $thiz;
}
/** @constructor */
function $c_Llocales_cldr_LDML() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
}
$c_Llocales_cldr_LDML.prototype = new $h_O();
$c_Llocales_cldr_LDML.prototype.constructor = $c_Llocales_cldr_LDML;
/** @constructor */
function $h_Llocales_cldr_LDML() {
}
$h_Llocales_cldr_LDML.prototype = $c_Llocales_cldr_LDML.prototype;
$c_Llocales_cldr_LDML.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_LDML.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_LDML.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_LDML)) {
    var x$0$2 = $as_Llocales_cldr_LDML(x$0);
    var x = this.Llocales_cldr_LDML__f_parent;
    var x$2 = $n(x$0$2).Llocales_cldr_LDML__f_parent;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_LDML__f_locale;
      var x$4 = $n(x$0$2).Llocales_cldr_LDML__f_locale;
      var $x_7 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$5 = this.Llocales_cldr_LDML__f_defaultNS;
      var x$6 = $n(x$0$2).Llocales_cldr_LDML__f_defaultNS;
      var $x_6 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$7 = this.Llocales_cldr_LDML__f_digitSymbols;
      var x$8 = $n(x$0$2).Llocales_cldr_LDML__f_digitSymbols;
      var $x_5 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$9 = this.Llocales_cldr_LDML__f_calendarSymbols;
      var x$10 = $n(x$0$2).Llocales_cldr_LDML__f_calendarSymbols;
      var $x_4 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$11 = this.Llocales_cldr_LDML__f_calendarPatterns;
      var x$12 = $n(x$0$2).Llocales_cldr_LDML__f_calendarPatterns;
      var $x_3 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$13 = this.Llocales_cldr_LDML__f_currencies;
      var x$14 = $n(x$0$2).Llocales_cldr_LDML__f_currencies;
      var $x_2 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$15 = this.Llocales_cldr_LDML__f_numberPatterns;
      var x$16 = $n(x$0$2).Llocales_cldr_LDML__f_numberPatterns;
      var $x_1 = ((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_LDML.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_LDML.prototype.productArity__I = (function() {
  return 8;
});
$c_Llocales_cldr_LDML.prototype.productPrefix__T = (function() {
  return "LDML";
});
$c_Llocales_cldr_LDML.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_LDML__f_parent;
      break;
    }
    case 1: {
      return this.Llocales_cldr_LDML__f_locale;
      break;
    }
    case 2: {
      return this.Llocales_cldr_LDML__f_defaultNS;
      break;
    }
    case 3: {
      return this.Llocales_cldr_LDML__f_digitSymbols;
      break;
    }
    case 4: {
      return this.Llocales_cldr_LDML__f_calendarSymbols;
      break;
    }
    case 5: {
      return this.Llocales_cldr_LDML__f_calendarPatterns;
      break;
    }
    case 6: {
      return this.Llocales_cldr_LDML__f_currencies;
      break;
    }
    case 7: {
      return this.Llocales_cldr_LDML__f_numberPatterns;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llocales_cldr_LDML.prototype.toLocale__ju_Locale = (function() {
  if (($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_language === "root")) {
    var $x_3 = new $c_ju_Locale$Builder().setLanguage__T__ju_Locale$Builder("");
    var this$1 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_territory);
    var $x_2 = $n($n($x_3).setRegion__T__ju_Locale$Builder($as_T((this$1.isEmpty__Z() ? "" : this$1.get__O()))));
    var this$2 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_script);
    var $x_1 = $x_2.setScript__T__ju_Locale$Builder($as_T((this$2.isEmpty__Z() ? "" : this$2.get__O())));
    var this$3 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_variant);
    return $n($n($x_1).setVariant__T__ju_Locale$Builder($as_T((this$3.isEmpty__Z() ? "" : this$3.get__O())))).build__ju_Locale();
  } else {
    var $x_6 = new $c_ju_Locale$Builder().setLanguage__T__ju_Locale$Builder($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_language);
    var this$4 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_territory);
    var $x_5 = $n($n($x_6).setRegion__T__ju_Locale$Builder($as_T((this$4.isEmpty__Z() ? "" : this$4.get__O()))));
    var this$5 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_script);
    var $x_4 = $x_5.setScript__T__ju_Locale$Builder($as_T((this$5.isEmpty__Z() ? "" : this$5.get__O())));
    var this$6 = $n($n(this.Llocales_cldr_LDML__f_locale).Llocales_cldr_LDMLLocale__f_variant);
    return $n($n($x_4).setVariant__T__ju_Locale$Builder($as_T((this$6.isEmpty__Z() ? "" : this$6.get__O())))).build__ju_Locale();
  }
});
function $as_Llocales_cldr_LDML(obj) {
  return (((obj instanceof $c_Llocales_cldr_LDML) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.LDML"));
}
function $isArrayOf_Llocales_cldr_LDML(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LDML)));
}
function $asArrayOf_Llocales_cldr_LDML(obj, depth) {
  return (($isArrayOf_Llocales_cldr_LDML(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.LDML;", depth));
}
var $d_Llocales_cldr_LDML = new $TypeData().initClass(0, "locales.cldr.LDML", ({
  Llocales_cldr_LDML: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llocales_cldr_LDMLLocale(language, territory, variant, script) {
  this.Llocales_cldr_LDMLLocale__f_language = null;
  this.Llocales_cldr_LDMLLocale__f_territory = null;
  this.Llocales_cldr_LDMLLocale__f_variant = null;
  this.Llocales_cldr_LDMLLocale__f_script = null;
  this.Llocales_cldr_LDMLLocale__f_language = language;
  this.Llocales_cldr_LDMLLocale__f_territory = territory;
  this.Llocales_cldr_LDMLLocale__f_variant = variant;
  this.Llocales_cldr_LDMLLocale__f_script = script;
}
$c_Llocales_cldr_LDMLLocale.prototype = new $h_O();
$c_Llocales_cldr_LDMLLocale.prototype.constructor = $c_Llocales_cldr_LDMLLocale;
/** @constructor */
function $h_Llocales_cldr_LDMLLocale() {
}
$h_Llocales_cldr_LDMLLocale.prototype = $c_Llocales_cldr_LDMLLocale.prototype;
$c_Llocales_cldr_LDMLLocale.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_LDMLLocale.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_LDMLLocale.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_LDMLLocale)) {
    var x$0$2 = $as_Llocales_cldr_LDMLLocale(x$0);
    if ((this.Llocales_cldr_LDMLLocale__f_language === $n(x$0$2).Llocales_cldr_LDMLLocale__f_language)) {
      var x = this.Llocales_cldr_LDMLLocale__f_territory;
      var x$2 = $n(x$0$2).Llocales_cldr_LDMLLocale__f_territory;
      var $x_3 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.Llocales_cldr_LDMLLocale__f_variant;
      var x$4 = $n(x$0$2).Llocales_cldr_LDMLLocale__f_variant;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llocales_cldr_LDMLLocale__f_script;
      var x$6 = $n(x$0$2).Llocales_cldr_LDMLLocale__f_script;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_LDMLLocale.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_LDMLLocale.prototype.productArity__I = (function() {
  return 4;
});
$c_Llocales_cldr_LDMLLocale.prototype.productPrefix__T = (function() {
  return "LDMLLocale";
});
$c_Llocales_cldr_LDMLLocale.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_LDMLLocale__f_language;
      break;
    }
    case 1: {
      return this.Llocales_cldr_LDMLLocale__f_territory;
      break;
    }
    case 2: {
      return this.Llocales_cldr_LDMLLocale__f_variant;
      break;
    }
    case 3: {
      return this.Llocales_cldr_LDMLLocale__f_script;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llocales_cldr_LDMLLocale(obj) {
  return (((obj instanceof $c_Llocales_cldr_LDMLLocale) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.LDMLLocale"));
}
function $isArrayOf_Llocales_cldr_LDMLLocale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LDMLLocale)));
}
function $asArrayOf_Llocales_cldr_LDMLLocale(obj, depth) {
  return (($isArrayOf_Llocales_cldr_LDMLLocale(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.LDMLLocale;", depth));
}
var $d_Llocales_cldr_LDMLLocale = new $TypeData().initClass($c_Llocales_cldr_LDMLLocale, "locales.cldr.LDMLLocale", ({
  Llocales_cldr_LDMLLocale: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Llocales_cldr_NumberCurrency(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.NumberCurrency"));
}
function $isArrayOf_Llocales_cldr_NumberCurrency(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberCurrency)));
}
function $asArrayOf_Llocales_cldr_NumberCurrency(obj, depth) {
  return (($isArrayOf_Llocales_cldr_NumberCurrency(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.NumberCurrency;", depth));
}
/** @constructor */
function $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat) {
  this.Llocales_cldr_NumberPatterns__f_decimalFormat = null;
  this.Llocales_cldr_NumberPatterns__f_percentFormat = null;
  this.Llocales_cldr_NumberPatterns__f_currencyFormat = null;
  this.Llocales_cldr_NumberPatterns__f_decimalFormat = decimalFormat;
  this.Llocales_cldr_NumberPatterns__f_percentFormat = percentFormat;
  this.Llocales_cldr_NumberPatterns__f_currencyFormat = currencyFormat;
}
$c_Llocales_cldr_NumberPatterns.prototype = new $h_O();
$c_Llocales_cldr_NumberPatterns.prototype.constructor = $c_Llocales_cldr_NumberPatterns;
/** @constructor */
function $h_Llocales_cldr_NumberPatterns() {
}
$h_Llocales_cldr_NumberPatterns.prototype = $c_Llocales_cldr_NumberPatterns.prototype;
$c_Llocales_cldr_NumberPatterns.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_NumberPatterns.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_NumberPatterns.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_NumberPatterns)) {
    var x$0$2 = $as_Llocales_cldr_NumberPatterns(x$0);
    var x = this.Llocales_cldr_NumberPatterns__f_decimalFormat;
    var x$2 = $n(x$0$2).Llocales_cldr_NumberPatterns__f_decimalFormat;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_NumberPatterns__f_percentFormat;
      var x$4 = $n(x$0$2).Llocales_cldr_NumberPatterns__f_percentFormat;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llocales_cldr_NumberPatterns__f_currencyFormat;
      var x$6 = $n(x$0$2).Llocales_cldr_NumberPatterns__f_currencyFormat;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_NumberPatterns.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_NumberPatterns.prototype.productArity__I = (function() {
  return 3;
});
$c_Llocales_cldr_NumberPatterns.prototype.productPrefix__T = (function() {
  return "NumberPatterns";
});
$c_Llocales_cldr_NumberPatterns.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_NumberPatterns__f_decimalFormat;
      break;
    }
    case 1: {
      return this.Llocales_cldr_NumberPatterns__f_percentFormat;
      break;
    }
    case 2: {
      return this.Llocales_cldr_NumberPatterns__f_currencyFormat;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llocales_cldr_NumberPatterns(obj) {
  return (((obj instanceof $c_Llocales_cldr_NumberPatterns) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.NumberPatterns"));
}
function $isArrayOf_Llocales_cldr_NumberPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberPatterns)));
}
function $asArrayOf_Llocales_cldr_NumberPatterns(obj, depth) {
  return (($isArrayOf_Llocales_cldr_NumberPatterns(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.NumberPatterns;", depth));
}
var $d_Llocales_cldr_NumberPatterns = new $TypeData().initClass($c_Llocales_cldr_NumberPatterns, "locales.cldr.NumberPatterns", ({
  Llocales_cldr_NumberPatterns: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llocales_cldr_NumberingSystem(id, digits) {
  this.Llocales_cldr_NumberingSystem__f_id = null;
  this.Llocales_cldr_NumberingSystem__f_digits = null;
  this.Llocales_cldr_NumberingSystem__f_id = id;
  this.Llocales_cldr_NumberingSystem__f_digits = digits;
}
$c_Llocales_cldr_NumberingSystem.prototype = new $h_O();
$c_Llocales_cldr_NumberingSystem.prototype.constructor = $c_Llocales_cldr_NumberingSystem;
/** @constructor */
function $h_Llocales_cldr_NumberingSystem() {
}
$h_Llocales_cldr_NumberingSystem.prototype = $c_Llocales_cldr_NumberingSystem.prototype;
$c_Llocales_cldr_NumberingSystem.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_NumberingSystem.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_NumberingSystem.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_NumberingSystem)) {
    var x$0$2 = $as_Llocales_cldr_NumberingSystem(x$0);
    if ((this.Llocales_cldr_NumberingSystem__f_id === $n(x$0$2).Llocales_cldr_NumberingSystem__f_id)) {
      var x = this.Llocales_cldr_NumberingSystem__f_digits;
      var x$2 = $n(x$0$2).Llocales_cldr_NumberingSystem__f_digits;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_NumberingSystem.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_NumberingSystem.prototype.productArity__I = (function() {
  return 2;
});
$c_Llocales_cldr_NumberingSystem.prototype.productPrefix__T = (function() {
  return "NumberingSystem";
});
$c_Llocales_cldr_NumberingSystem.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llocales_cldr_NumberingSystem__f_id;
  }
  if ((n === 1)) {
    return this.Llocales_cldr_NumberingSystem__f_digits;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Llocales_cldr_NumberingSystem(obj) {
  return (((obj instanceof $c_Llocales_cldr_NumberingSystem) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.NumberingSystem"));
}
function $isArrayOf_Llocales_cldr_NumberingSystem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberingSystem)));
}
function $asArrayOf_Llocales_cldr_NumberingSystem(obj, depth) {
  return (($isArrayOf_Llocales_cldr_NumberingSystem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.NumberingSystem;", depth));
}
var $d_Llocales_cldr_NumberingSystem = new $TypeData().initClass($c_Llocales_cldr_NumberingSystem, "locales.cldr.NumberingSystem", ({
  Llocales_cldr_NumberingSystem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp) {
  this.Llocales_cldr_Symbols__f_ns = null;
  this.Llocales_cldr_Symbols__f_aliasOf = null;
  this.Llocales_cldr_Symbols__f_decimal = null;
  this.Llocales_cldr_Symbols__f_group = null;
  this.Llocales_cldr_Symbols__f_list = null;
  this.Llocales_cldr_Symbols__f_percent = null;
  this.Llocales_cldr_Symbols__f_minus = null;
  this.Llocales_cldr_Symbols__f_perMille = null;
  this.Llocales_cldr_Symbols__f_infinity = null;
  this.Llocales_cldr_Symbols__f_nan = null;
  this.Llocales_cldr_Symbols__f_exp = null;
  this.Llocales_cldr_Symbols__f_ns = ns;
  this.Llocales_cldr_Symbols__f_aliasOf = aliasOf;
  this.Llocales_cldr_Symbols__f_decimal = decimal;
  this.Llocales_cldr_Symbols__f_group = group;
  this.Llocales_cldr_Symbols__f_list = list;
  this.Llocales_cldr_Symbols__f_percent = percent;
  this.Llocales_cldr_Symbols__f_minus = minus;
  this.Llocales_cldr_Symbols__f_perMille = perMille;
  this.Llocales_cldr_Symbols__f_infinity = infinity;
  this.Llocales_cldr_Symbols__f_nan = nan;
  this.Llocales_cldr_Symbols__f_exp = exp;
}
$c_Llocales_cldr_Symbols.prototype = new $h_O();
$c_Llocales_cldr_Symbols.prototype.constructor = $c_Llocales_cldr_Symbols;
/** @constructor */
function $h_Llocales_cldr_Symbols() {
}
$h_Llocales_cldr_Symbols.prototype = $c_Llocales_cldr_Symbols.prototype;
$c_Llocales_cldr_Symbols.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_Symbols.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_Symbols.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_Symbols)) {
    var x$0$2 = $as_Llocales_cldr_Symbols(x$0);
    var x = this.Llocales_cldr_Symbols__f_ns;
    var x$2 = $n(x$0$2).Llocales_cldr_Symbols__f_ns;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_Symbols__f_aliasOf;
      var x$4 = $n(x$0$2).Llocales_cldr_Symbols__f_aliasOf;
      var $x_10 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$5 = this.Llocales_cldr_Symbols__f_decimal;
      var x$6 = $n(x$0$2).Llocales_cldr_Symbols__f_decimal;
      var $x_9 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$7 = this.Llocales_cldr_Symbols__f_group;
      var x$8 = $n(x$0$2).Llocales_cldr_Symbols__f_group;
      var $x_8 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$9 = this.Llocales_cldr_Symbols__f_list;
      var x$10 = $n(x$0$2).Llocales_cldr_Symbols__f_list;
      var $x_7 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$11 = this.Llocales_cldr_Symbols__f_percent;
      var x$12 = $n(x$0$2).Llocales_cldr_Symbols__f_percent;
      var $x_6 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$13 = this.Llocales_cldr_Symbols__f_minus;
      var x$14 = $n(x$0$2).Llocales_cldr_Symbols__f_minus;
      var $x_5 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$15 = this.Llocales_cldr_Symbols__f_perMille;
      var x$16 = $n(x$0$2).Llocales_cldr_Symbols__f_perMille;
      var $x_4 = ((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$17 = this.Llocales_cldr_Symbols__f_infinity;
      var x$18 = $n(x$0$2).Llocales_cldr_Symbols__f_infinity;
      var $x_3 = ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$19 = this.Llocales_cldr_Symbols__f_nan;
      var x$20 = $n(x$0$2).Llocales_cldr_Symbols__f_nan;
      var $x_2 = ((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$21 = this.Llocales_cldr_Symbols__f_exp;
      var x$22 = $n(x$0$2).Llocales_cldr_Symbols__f_exp;
      var $x_1 = ((x$21 === null) ? (x$22 === null) : $n(x$21).equals__O__Z(x$22));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_Symbols.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_Symbols.prototype.productArity__I = (function() {
  return 11;
});
$c_Llocales_cldr_Symbols.prototype.productPrefix__T = (function() {
  return "Symbols";
});
$c_Llocales_cldr_Symbols.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_Symbols__f_ns;
      break;
    }
    case 1: {
      return this.Llocales_cldr_Symbols__f_aliasOf;
      break;
    }
    case 2: {
      return this.Llocales_cldr_Symbols__f_decimal;
      break;
    }
    case 3: {
      return this.Llocales_cldr_Symbols__f_group;
      break;
    }
    case 4: {
      return this.Llocales_cldr_Symbols__f_list;
      break;
    }
    case 5: {
      return this.Llocales_cldr_Symbols__f_percent;
      break;
    }
    case 6: {
      return this.Llocales_cldr_Symbols__f_minus;
      break;
    }
    case 7: {
      return this.Llocales_cldr_Symbols__f_perMille;
      break;
    }
    case 8: {
      return this.Llocales_cldr_Symbols__f_infinity;
      break;
    }
    case 9: {
      return this.Llocales_cldr_Symbols__f_nan;
      break;
    }
    case 10: {
      return this.Llocales_cldr_Symbols__f_exp;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Llocales_cldr_Symbols(obj) {
  return (((obj instanceof $c_Llocales_cldr_Symbols) || (obj === null)) ? obj : $throwClassCastException(obj, "locales.cldr.Symbols"));
}
function $isArrayOf_Llocales_cldr_Symbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_Symbols)));
}
function $asArrayOf_Llocales_cldr_Symbols(obj, depth) {
  return (($isArrayOf_Llocales_cldr_Symbols(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Llocales.cldr.Symbols;", depth));
}
var $d_Llocales_cldr_Symbols = new $TypeData().initClass($c_Llocales_cldr_Symbols, "locales.cldr.Symbols", ({
  Llocales_cldr_Symbols: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot(graph, direction, version) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_direction = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_version = 0;
  this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph = graph;
  this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_direction = direction;
  this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_version = version;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash, (-655279282));
  var hash$1 = acc;
  var x = this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph;
  var data = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x$1 = this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_direction;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var data$2 = this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_version;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot(x$0);
    if ((this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_version === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_version)) {
      var x = this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph;
      var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_direction;
      var x$4 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_direction;
      if ((x$3 === null)) {
        var $x_1 = (x$4 === null);
      } else {
        var this$1 = $n(x$3);
        var $x_1 = (this$1 === x$4);
      }
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype.productArity__I = (function() {
  return 3;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype.productPrefix__T = (function() {
  return "DagSnapshot";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_graph;
      break;
    }
    case 1: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_direction;
      break;
    }
    case 2: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot__f_version;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.DagSnapshot"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.DagSnapshot;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot, "net.andimiller.hedgehogs.dag.visitor.DagSnapshot", ({
  Lnet_andimiller_hedgehogs_dag_visitor_DagSnapshot: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Model(startTime, graph, messages, queue, nodes, edges, approvals, running, snapshot, snapshotText, graphviz) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes = 0;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges = 0;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals = 0;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running = false;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime = startTime;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph = graph;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages = messages;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue = queue;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes = nodes;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges = edges;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals = approvals;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running = running;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot = snapshot;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText = snapshotText;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz = graphviz;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Model;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Model() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Model");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var data$6 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var data$7 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var data$8 = (this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$4 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$5 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var x$6 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$12, 11);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Model)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Model(x$0);
    if (((((this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes) && (this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges)) && (this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals)) && (this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running))) {
      var x = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      var $x_6 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var x$4 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var x$6 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var x$8 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var x$10 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText))) {
      var x$11 = this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      var x$12 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype.productArity__I = (function() {
  return 11;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype.productPrefix__T = (function() {
  return "Model";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Model.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_startTime;
      break;
    }
    case 1: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graph;
      break;
    }
    case 2: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_messages;
      break;
    }
    case 3: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_queue;
      break;
    }
    case 4: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_nodes;
      break;
    }
    case 5: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_edges;
      break;
    }
    case 6: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_approvals;
      break;
    }
    case 7: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_running;
      break;
    }
    case 8: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshot;
      break;
    }
    case 9: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_snapshotText;
      break;
    }
    case 10: {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_Model__f_graphviz;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Model(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Model) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Model"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Model(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Model)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Model(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Model(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Model;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Model = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Model, "net.andimiller.hedgehogs.dag.visitor.Model", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Model: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListIterator(domList) {
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList = null;
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index = 0;
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList = domList;
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index = 0;
}
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = new $h_O();
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListIterator;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListIterator() {
}
$h_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype = $c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype;
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.hasNext__Z = (function() {
  return (this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index < $uI(this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList.length));
});
$c_Lorg_scalajs_dom_DOMList$DOMListIterator.prototype.next__O = (function() {
  var res = this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_domList[this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index];
  this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index = ((1 + this.Lorg_scalajs_dom_DOMList$DOMListIterator__f_index) | 0);
  return res;
});
var $d_Lorg_scalajs_dom_DOMList$DOMListIterator = new $TypeData().initClass($c_Lorg_scalajs_dom_DOMList$DOMListIterator, "org.scalajs.dom.DOMList$DOMListIterator", ({
  Lorg_scalajs_dom_DOMList$DOMListIterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
/** @constructor */
function $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(outer) {
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index = 0;
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_$outer = outer;
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index = 0;
}
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype = new $h_O();
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.constructor = $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1;
/** @constructor */
function $h_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1() {
}
$h_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype = $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype;
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.next__T2 = (function() {
  var n = $n(this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_$outer).Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.item(this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index);
  this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index = ((1 + this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index) | 0);
  var _1 = $as_T(n.name);
  return new $c_T2(_1, n);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.hasNext__Z = (function() {
  return (this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_index < $uI($n(this.Lorg_scalajs_dom_NamedNodeMapMap$$anon$1__f_$outer).Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.length));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1 = new $TypeData().initClass($c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1, "org.scalajs.dom.NamedNodeMapMap$$anon$1", ({
  Lorg_scalajs_dom_NamedNodeMapMap$$anon$1: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z($thiz) {
  if ((($as_T((typeof postMessage)) !== "undefined") && ($as_T((typeof importScripts)) === "undefined"))) {
    var postMessageIsAsynchronous = new $c_sr_BooleanRef(true);
    var oldOnMessage = onmessage;
    try {
      onmessage = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        var ev$4 = false;
        postMessageIsAsynchronous.sr_BooleanRef__f_elem = ev$4;
      })));
      postMessage("", "*");
      onmessage = oldOnMessage;
      return postMessageIsAsynchronous.sr_BooleanRef__f_elem;
    } catch (e) {
      var e$1 = e;
      var e$2 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
      var x2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!$n(x2).isEmpty__Z())) {
        $as_jl_Throwable($n(x2).get__O());
        return false;
      }
      throw e$2;
    }
  } else {
    return false;
  }
}
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$1, currentlyRunningATask$1, handle) {
  if ($n(currentlyRunningATask$1).sr_BooleanRef__f_elem) {
    setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$1, currentlyRunningATask$1, handle);
    }))), 0);
  } else {
    matchResult2: {
      var x5 = $n(tasksByHandle$1).get__O__s_Option(handle);
      if ((x5 instanceof $c_s_Some)) {
        var task = $as_F0($n($as_s_Some(x5)).s_Some__f_value);
        var ev$5 = true;
        $n(currentlyRunningATask$1).sr_BooleanRef__f_elem = ev$5;
        try {
          $n(task).apply__O();
          break matchResult2;
        } finally {
          var this$3 = $n(tasksByHandle$1);
          this$3.subtractOne__O__scm_Shrinkable(handle);
          var ev$6 = false;
          $n(currentlyRunningATask$1).sr_BooleanRef__f_elem = ev$6;
        }
      }
      var x = $m_s_None$();
      if ((x === x5)) {
        break matchResult2;
      }
      throw new $c_s_MatchError(x5);
    }
  }
}
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V($thiz, tasksByHandle$3, currentlyRunningATask$3, messagePrefix$1, event) {
  if ((($as_T((typeof event.data)) === "string") && ($uI(event.data.indexOf(messagePrefix$1)) === 0))) {
    var this$3 = $n($dp_toString__T($n(event.data)));
    var this$2 = $n(messagePrefix$1);
    var beginIndex = this$2.length;
    if (((beginIndex < 0) || (beginIndex > this$3.length))) {
      $charAt(this$3, beginIndex);
    }
    var x = $as_T(this$3.substring(beginIndex));
    var this$6 = $m_jl_Integer$();
    $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$3, currentlyRunningATask$3, this$6.java$lang$Integer$$parseIntImpl__T__I__I__I(x, 10, 214748364));
  }
}
/** @constructor */
function $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = null;
  $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = this;
  if (($as_T((typeof setImmediate)) === "undefined")) {
    var nextHandle = new $c_sr_IntRef(1);
    var tasksByHandle = $as_scm_Map($m_scm_Map$().apply__sci_Seq__O($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]))));
    var currentlyRunningATask = new $c_sr_BooleanRef(false);
    if (($as_T((typeof navigator)) !== "undefined")) {
      var x = navigator.userAgent;
      if ((x !== (void 0))) {
        var _$1 = $as_T(x);
        var this$8 = $n(_$1);
        var $x_5 = ($uI(this$8.indexOf("jsdom")) !== (-1));
      } else {
        var $x_5 = false;
      }
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var setImmediate$1 = Node.constructor("return setImmediate")();
      var $x_4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((k) => {
        var k$1 = $as_F0(k);
        setImmediate$1($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$1));
      }));
    } else if ($p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z(this)) {
      var this$10 = $m_s_util_Random$();
      var this$11 = $n(this$10.s_util_Random__f_self);
      var messagePrefix = (("setImmediate$" + this$11.next__I__I(32)) + "$");
      if (($as_T((typeof addEventListener)) !== "undefined")) {
        addEventListener("message", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((event) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V(this, tasksByHandle, currentlyRunningATask, messagePrefix, event);
        }))), false);
      } else {
        attachEvent("onmessage", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((event$2) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V(this, tasksByHandle, currentlyRunningATask, messagePrefix, event$2);
        }))));
      }
      var $x_4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((k$2) => {
        var k$3 = $as_F0(k$2);
        var handle = nextHandle.sr_IntRef__f_elem;
        var ev$7 = ((1 + nextHandle.sr_IntRef__f_elem) | 0);
        nextHandle.sr_IntRef__f_elem = ev$7;
        var this$17 = $n(tasksByHandle);
        var elem = new $c_T2(handle, k$3);
        this$17.addOne__O__scm_Growable(elem);
        var $x_6 = postMessage;
        var s = (messagePrefix + handle);
        $x_6(s, "*");
      }));
    } else if (($as_T((typeof MessageChannel)) !== "undefined")) {
      var channel = new MessageChannel();
      channel.port1.onmessage = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((event$3) => {
        $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$1__scm_Map__sr_BooleanRef__I__V(this, tasksByHandle, currentlyRunningATask, $uI(event$3.data));
      })));
      var $x_4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((k$3$1) => {
        var k$4 = $as_F0(k$3$1);
        var handle$1 = nextHandle.sr_IntRef__f_elem;
        var ev$8 = ((1 + nextHandle.sr_IntRef__f_elem) | 0);
        nextHandle.sr_IntRef__f_elem = ev$8;
        var this$22 = $n(tasksByHandle);
        var elem$1 = new $c_T2(handle$1, k$4);
        this$22.addOne__O__scm_Growable(elem$1);
        channel.port2.postMessage(handle$1);
      }));
    } else {
      var $x_4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((k$4$1) => {
        var k$5 = $as_F0(k$4$1);
        setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$5), 0);
      }));
    }
  } else {
    var $x_4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((k$5$1) => {
      var k$6 = $as_F0(k$5$1);
      setImmediate($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$6));
    }));
  }
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = $x_4;
}
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = new $h_O();
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.constructor = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
/** @constructor */
function $h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
}
$h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype;
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.execute__jl_Runnable__V = (function(runnable) {
  $n(this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate).apply__O__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    $n(runnable).run__V();
  })));
});
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.reportFailure__jl_Throwable__V = (function(cause) {
  var this$1 = $n(cause);
  this$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err);
});
var $d_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $TypeData().initClass($c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$, "org.scalajs.macrotaskexecutor.MacrotaskExecutor$", ({
  Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_ExecutionContextExecutor: 1
}));
var $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
function $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  if ((!$n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$)) {
    $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$();
  }
  return $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
}
/** @constructor */
function $c_s_$eq$colon$eq() {
}
$c_s_$eq$colon$eq.prototype = new $h_s_$less$colon$less();
$c_s_$eq$colon$eq.prototype.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
}
$h_s_$eq$colon$eq.prototype = $c_s_$eq$colon$eq.prototype;
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.s_PartialFunction$$anon$1__f_lift = null;
  this.s_PartialFunction$$anon$1__f_lift = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => $m_s_None$()));
}
$c_s_PartialFunction$$anon$1.prototype = new $h_O();
$c_s_PartialFunction$$anon$1.prototype.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
}
$h_s_PartialFunction$$anon$1.prototype = $c_s_PartialFunction$$anon$1.prototype;
$c_s_PartialFunction$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_s_PartialFunction$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  this.apply__O__E(v1);
});
$c_s_PartialFunction$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_PartialFunction$$anon$1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_PartialFunction$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__E = (function(x) {
  throw new $c_s_MatchError(x);
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return this;
});
$c_s_PartialFunction$$anon$1.prototype.lift__F1 = (function() {
  return this.s_PartialFunction$$anon$1__f_lift;
});
$c_s_PartialFunction$$anon$1.prototype.runWith__F1__F1 = (function(action) {
  return $m_s_PartialFunction$().s_PartialFunction$__f_scala$PartialFunction$$constFalse;
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return this;
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__O = (function(v1) {
  this.apply__O__E(v1);
});
var $d_s_PartialFunction$$anon$1 = new $TypeData().initClass($c_s_PartialFunction$$anon$1, "scala.PartialFunction$$anon$1", ({
  s_PartialFunction$$anon$1: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_PartialFunction$AndThen(pf, k) {
  this.s_PartialFunction$AndThen__f_pf = null;
  this.s_PartialFunction$AndThen__f_k = null;
  this.s_PartialFunction$AndThen__f_pf = pf;
  this.s_PartialFunction$AndThen__f_k = k;
}
$c_s_PartialFunction$AndThen.prototype = new $h_O();
$c_s_PartialFunction$AndThen.prototype.constructor = $c_s_PartialFunction$AndThen;
/** @constructor */
function $h_s_PartialFunction$AndThen() {
}
$h_s_PartialFunction$AndThen.prototype = $c_s_PartialFunction$AndThen.prototype;
$c_s_PartialFunction$AndThen.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_s_PartialFunction$AndThen.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_s_PartialFunction$AndThen.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_s_PartialFunction$AndThen.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_s_PartialFunction$AndThen.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_PartialFunction$AndThen.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_PartialFunction$AndThen.prototype.isDefinedAt__O__Z = (function(x) {
  return $n(this.s_PartialFunction$AndThen__f_pf).isDefinedAt__O__Z(x);
});
$c_s_PartialFunction$AndThen.prototype.apply__O__O = (function(x) {
  return $n(this.s_PartialFunction$AndThen__f_k).apply__O__O($n(this.s_PartialFunction$AndThen__f_pf).apply__O__O(x));
});
$c_s_PartialFunction$AndThen.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var z = $n(this.s_PartialFunction$AndThen__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? $n(this.s_PartialFunction$AndThen__f_k).apply__O__O(z) : $n(default$1).apply__O__O(x));
});
$c_s_PartialFunction$AndThen.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
var $d_s_PartialFunction$AndThen = new $TypeData().initClass($c_s_PartialFunction$AndThen, "scala.PartialFunction$AndThen", ({
  s_PartialFunction$AndThen: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_PartialFunction$Combined(pf, k) {
  this.s_PartialFunction$Combined__f_pf = null;
  this.s_PartialFunction$Combined__f_k = null;
  this.s_PartialFunction$Combined__f_pf = pf;
  this.s_PartialFunction$Combined__f_k = k;
}
$c_s_PartialFunction$Combined.prototype = new $h_O();
$c_s_PartialFunction$Combined.prototype.constructor = $c_s_PartialFunction$Combined;
/** @constructor */
function $h_s_PartialFunction$Combined() {
}
$h_s_PartialFunction$Combined.prototype = $c_s_PartialFunction$Combined.prototype;
$c_s_PartialFunction$Combined.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_s_PartialFunction$Combined.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_s_PartialFunction$Combined.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_s_PartialFunction$Combined.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_s_PartialFunction$Combined.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_PartialFunction$Combined.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_PartialFunction$Combined.prototype.isDefinedAt__O__Z = (function(x) {
  var b = $n(this.s_PartialFunction$Combined__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(b)) && $n(this.s_PartialFunction$Combined__f_k).isDefinedAt__O__Z(b));
});
$c_s_PartialFunction$Combined.prototype.apply__O__O = (function(x) {
  return $n(this.s_PartialFunction$Combined__f_k).apply__O__O($n(this.s_PartialFunction$Combined__f_pf).apply__O__O(x));
});
$c_s_PartialFunction$Combined.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var pfv = $n(this.s_PartialFunction$Combined__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(pfv)) ? $n(this.s_PartialFunction$Combined__f_k).applyOrElse__O__F1__O(pfv, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $n(default$1).apply__O__O(x)))) : $n(default$1).apply__O__O(x));
});
$c_s_PartialFunction$Combined.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
var $d_s_PartialFunction$Combined = new $TypeData().initClass($c_s_PartialFunction$Combined, "scala.PartialFunction$Combined", ({
  s_PartialFunction$Combined: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_PartialFunction$Lifted(pf) {
  this.s_PartialFunction$Lifted__f_pf = null;
  this.s_PartialFunction$Lifted__f_pf = pf;
}
$c_s_PartialFunction$Lifted.prototype = new $h_sr_AbstractFunction1();
$c_s_PartialFunction$Lifted.prototype.constructor = $c_s_PartialFunction$Lifted;
/** @constructor */
function $h_s_PartialFunction$Lifted() {
}
$h_s_PartialFunction$Lifted.prototype = $c_s_PartialFunction$Lifted.prototype;
$c_s_PartialFunction$Lifted.prototype.apply__O__s_Option = (function(x) {
  var z = $n(this.s_PartialFunction$Lifted__f_pf).applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? new $c_s_Some(z) : $m_s_None$());
});
$c_s_PartialFunction$Lifted.prototype.apply__O__O = (function(v1) {
  return this.apply__O__s_Option(v1);
});
var $d_s_PartialFunction$Lifted = new $TypeData().initClass($c_s_PartialFunction$Lifted, "scala.PartialFunction$Lifted", ({
  s_PartialFunction$Lifted: 1,
  sr_AbstractFunction1: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_AbstractIterator() {
}
$c_sc_AbstractIterator.prototype = new $h_O();
$c_sc_AbstractIterator.prototype.constructor = $c_sc_AbstractIterator;
/** @constructor */
function $h_sc_AbstractIterator() {
}
$h_sc_AbstractIterator.prototype = $c_sc_AbstractIterator.prototype;
$c_sc_AbstractIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_sc_AbstractIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_sc_AbstractIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_sc_AbstractIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return this.sliceIterator__I__I__sc_Iterator(n, (-1));
});
$c_sc_AbstractIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_sc_AbstractIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_sc_AbstractIterator.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sc_AbstractIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_AbstractIterator.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sc_AbstractIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_AbstractIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_AbstractIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_AbstractIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_AbstractIterator.prototype.knownSize__I = (function() {
  return (-1);
});
/** @constructor */
function $c_sc_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Iterable$());
}
$c_sc_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Iterable$.prototype.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
}
$h_sc_Iterable$.prototype = $c_sc_Iterable$.prototype;
var $d_sc_Iterable$ = new $TypeData().initClass($c_sc_Iterable$, "scala.collection.Iterable$", ({
  sc_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$();
  }
  return $n_sc_Iterable$;
}
/** @constructor */
function $c_sc_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  this.sc_Map$__f_DefaultSentinel = null;
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_sci_Map$());
  $n_sc_Map$ = this;
  this.sc_Map$__f_DefaultSentinel = $ct_O__(new $c_O());
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sc_Map$().sc_Map$__f_DefaultSentinel));
}
$c_sc_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_sc_Map$.prototype.constructor = $c_sc_Map$;
/** @constructor */
function $h_sc_Map$() {
}
$h_sc_Map$.prototype = $c_sc_Map$.prototype;
var $d_sc_Map$ = new $TypeData().initClass($c_sc_Map$, "scala.collection.Map$", ({
  sc_Map$: 1,
  sc_MapFactory$Delegate: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Map$;
function $m_sc_Map$() {
  if ((!$n_sc_Map$)) {
    $n_sc_Map$ = new $c_sc_Map$();
  }
  return $n_sc_Map$;
}
/** @constructor */
function $c_sc_MapView$() {
  this.sc_MapView$__f_EmptyMapView = null;
  $n_sc_MapView$ = this;
  this.sc_MapView$__f_EmptyMapView = new $c_sc_MapView$$anon$1();
}
$c_sc_MapView$.prototype = new $h_O();
$c_sc_MapView$.prototype.constructor = $c_sc_MapView$;
/** @constructor */
function $h_sc_MapView$() {
}
$h_sc_MapView$.prototype = $c_sc_MapView$.prototype;
$c_sc_MapView$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = new $c_scm_HashMap$$anon$6(16, 0.75);
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
    var x$1$2 = $as_scm_HashMap(x$1$2$2);
    var this$2 = $n(x$1$2);
    return new $c_sc_MapView$Id(this$2);
  }));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_sc_MapView$.prototype.from__sc_MapOps__sc_MapView = (function(it) {
  if ($is_sc_MapView(it)) {
    var x2 = $as_sc_MapView(it);
    return x2;
  } else {
    return new $c_sc_MapView$Id(it);
  }
});
$c_sc_MapView$.prototype.apply__sci_Seq__sc_MapView = (function(elems) {
  var this$2 = $n(elems);
  return this.from__sc_MapOps__sc_MapView($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$2));
});
$c_sc_MapView$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_MapView(elems);
});
$c_sc_MapView$.prototype.from__sc_IterableOnce__O = (function(it) {
  return $m_sc_View$().from__sc_IterableOnce__sc_View(it);
});
$c_sc_MapView$.prototype.empty__O = (function() {
  return this.sc_MapView$__f_EmptyMapView;
});
var $d_sc_MapView$ = new $TypeData().initClass($c_sc_MapView$, "scala.collection.MapView$", ({
  sc_MapView$: 1,
  sc_MapViewFactory: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_MapView$;
function $m_sc_MapView$() {
  if ((!$n_sc_MapView$)) {
    $n_sc_MapView$ = new $c_sc_MapView$();
  }
  return $n_sc_MapView$;
}
function $ct_sc_SeqFactory$Delegate__sc_SeqFactory__($thiz, delegate) {
  $thiz.sc_SeqFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqFactory$Delegate() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
}
$c_sc_SeqFactory$Delegate.prototype = new $h_O();
$c_sc_SeqFactory$Delegate.prototype.constructor = $c_sc_SeqFactory$Delegate;
/** @constructor */
function $h_sc_SeqFactory$Delegate() {
}
$h_sc_SeqFactory$Delegate.prototype = $c_sc_SeqFactory$Delegate.prototype;
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__sc_SeqOps = (function(elems) {
  return $as_sc_SeqOps($n(this.sc_SeqFactory$Delegate__f_delegate).apply__sci_Seq__O(elems));
});
$c_sc_SeqFactory$Delegate.prototype.empty__sc_SeqOps = (function() {
  return $as_sc_SeqOps($n(this.sc_SeqFactory$Delegate__f_delegate).empty__O());
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return $as_sc_SeqOps($n(this.sc_SeqFactory$Delegate__f_delegate).from__sc_IterableOnce__O(it));
});
$c_sc_SeqFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return $n(this.sc_SeqFactory$Delegate__f_delegate).newBuilder__scm_Builder();
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_SeqOps(source);
});
$c_sc_SeqFactory$Delegate.prototype.empty__O = (function() {
  return this.empty__sc_SeqOps();
});
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_SeqOps(elems);
});
function $f_sc_SeqOps__isDefinedAt__I__Z($thiz, idx) {
  return ((idx >= 0) && ($thiz.lengthCompare__I__I(idx) > 0));
}
function $f_sc_SeqOps__indexOf__O__I__I($thiz, elem, from) {
  return $thiz.indexWhere__F1__I__I(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(elem, x$1$2$2))), from);
}
function $f_sc_SeqOps__contains__O__Z($thiz, elem) {
  return $thiz.exists__F1__Z(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$3$2$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(x$3$2$2, elem))));
}
function $f_sc_SeqOps__sorted__s_math_Ordering__O($thiz, ord) {
  var len = $thiz.length__I();
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((len === 1)) {
    var this$1 = $n(b);
    var elem = $thiz.head__O();
    this$1.addOne__O__scm_Growable(elem);
  } else if ((len > 1)) {
    $n(b).sizeHint__I__V(len);
    var arr = new $ac_O(len);
    $thiz.copyToArray__O__I__I__I(arr, 0, 2147483647);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, ord);
    var i = 0;
    while ((i < len)) {
      var this$2 = $n(b);
      var elem$1 = arr.get(i);
      this$2.addOne__O__scm_Growable(elem$1);
      i = ((1 + i) | 0);
    }
  }
  return $n(b).result__O();
}
function $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($thiz, f, ord) {
  var this$1 = $n(ord);
  return $thiz.sorted__s_math_Ordering__O(new $c_s_math_Ordering$$anon$1(this$1, f));
}
function $f_sc_SeqOps__isEmpty__Z($thiz) {
  return ($thiz.lengthCompare__I__I(0) === 0);
}
function $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  var thisKnownSize = $thiz.knownSize__I();
  if ((thisKnownSize !== (-1))) {
    var thatKnownSize = $n(that).knownSize__I();
    if ((thatKnownSize !== (-1))) {
      if ((thisKnownSize !== thatKnownSize)) {
        return false;
      }
      if ((thisKnownSize === 0)) {
        return true;
      }
    }
  }
  return $f_sc_Iterator__sameElements__sc_IterableOnce__Z($n($thiz.iterator__sc_Iterator()), that);
}
function $is_sc_SeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SeqOps)));
}
function $as_sc_SeqOps(obj) {
  return (($is_sc_SeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SeqOps"));
}
function $isArrayOf_sc_SeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SeqOps)));
}
function $asArrayOf_sc_SeqOps(obj, depth) {
  return (($isArrayOf_sc_SeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SeqOps;", depth));
}
/** @constructor */
function $c_sc_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Set$());
}
$c_sc_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Set$.prototype.constructor = $c_sc_Set$;
/** @constructor */
function $h_sc_Set$() {
}
$h_sc_Set$.prototype = $c_sc_Set$.prototype;
var $d_sc_Set$ = new $TypeData().initClass($c_sc_Set$, "scala.collection.Set$", ({
  sc_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Set$;
function $m_sc_Set$() {
  if ((!$n_sc_Set$)) {
    $n_sc_Set$ = new $c_sc_Set$();
  }
  return $n_sc_Set$;
}
function $f_sc_StrictOptimizedIterableOps__map__F1__O($thiz, f) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $n(f).apply__O__O($n(it).next__O());
    this$1.addOne__O__scm_Growable(elem);
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($thiz, f) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elems = $as_sc_IterableOnce($n(f).apply__O__O($n(it).next__O()));
    this$1.addAll__sc_IterableOnce__scm_Growable(elems);
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($thiz, pf) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var v = $n(pf).applyOrElse__O__F1__O(elem, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((marker) => ((x$2$2) => marker))(marker)));
    if ((marker !== v)) {
      var this$2 = $n(b);
      this$2.addOne__O__scm_Growable(v);
    }
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__flatten__F1__O($thiz, toIterableOnce) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elems = $as_sc_IterableOnce($n(toIterableOnce).apply__O__O($n(it).next__O()));
    this$1.addAll__sc_IterableOnce__scm_Growable(elems);
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__zipWithIndex__O($thiz) {
  var b = $n($thiz.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
  var i = 0;
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = new $c_T2($n(it).next__O(), i);
    this$1.addOne__O__scm_Growable(elem);
    i = ((1 + i) | 0);
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O($thiz, pred, isFlipped) {
  var b = $thiz.newSpecificBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    if (($uZ($n(pred).apply__O__O(elem)) !== isFlipped)) {
      var this$1 = $n(b);
      this$1.addOne__O__scm_Growable(elem);
    }
  }
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedIterableOps__dropRight__I__O($thiz, n) {
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((n >= 0)) {
    $f_scm_Builder__sizeHint__sc_IterableOnce__I__V($n(b), $thiz, ((-n) | 0));
  }
  var lead = $n($thiz.iterator__sc_Iterator()).drop__I__sc_Iterator(n);
  var it = $thiz.iterator__sc_Iterator();
  while ($n(lead).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $n(it).next__O();
    this$1.addOne__O__scm_Growable(elem);
    $n(lead).next__O();
  }
  return $n(b).result__O();
}
function $as_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$IteratorWrapper"));
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$IteratorWrapper)));
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$IteratorWrapper;", depth));
}
/** @constructor */
function $c_sci_BitSet$() {
  this.sci_BitSet$__f_empty = null;
  $n_sci_BitSet$ = this;
  this.sci_BitSet$__f_empty = new $c_sci_BitSet$BitSet1(0, 0);
}
$c_sci_BitSet$.prototype = new $h_O();
$c_sci_BitSet$.prototype.constructor = $c_sci_BitSet$;
/** @constructor */
function $h_sci_BitSet$() {
}
$h_sci_BitSet$.prototype = $c_sci_BitSet$.prototype;
$c_sci_BitSet$.prototype.fromSpecific__sc_IterableOnce__sci_BitSet = (function(it) {
  if ((it instanceof $c_sci_BitSet)) {
    var x2 = $as_sci_BitSet(it);
    return x2;
  } else {
    var this$1 = $n(this.newBuilder__scm_Builder());
    return $as_sci_BitSet($n($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(it))).result__O());
  }
});
$c_sci_BitSet$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((bs$2$2) => {
    var bs$2 = $as_scm_BitSet(bs$2$2);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet($n(bs$2).scm_BitSet__f_elems);
  }));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_sci_BitSet$.prototype.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet = (function(a_$_lo, a_$_hi, b_$_lo, b_$_hi) {
  return (((b_$_lo | b_$_hi) === 0) ? new $c_sci_BitSet$BitSet1(a_$_lo, a_$_hi) : new $c_sci_BitSet$BitSet2(a_$_lo, a_$_hi, b_$_lo, b_$_hi));
});
$c_sci_BitSet$.prototype.fromBitMaskNoCopy__AJ__sci_BitSet = (function(elems) {
  var len = (($n(elems).u.length >>> 1) | 0);
  if ((len === 0)) {
    return this.sci_BitSet$__f_empty;
  } else if ((len === 1)) {
    var $x_2 = $n(elems).u;
    $aJCheckGet($x_2, 0);
    var $x_1_$_lo = $x_2[0];
    var $x_1_$_hi = $x_2[1];
    return new $c_sci_BitSet$BitSet1($x_1_$_lo, $x_1_$_hi);
  } else if ((len === 2)) {
    var $x_6 = $n(elems).u;
    $aJCheckGet($x_6, 0);
    var $x_5_$_lo = $x_6[0];
    var $x_5_$_hi = $x_6[1];
    var $x_4 = $n(elems).u;
    $aJCheckGet($x_4, 1);
    var $x_3_$_lo = $x_4[2];
    var $x_3_$_hi = $x_4[3];
    return this.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet($x_5_$_lo, $x_5_$_hi, $x_3_$_lo, $x_3_$_hi);
  } else {
    return new $c_sci_BitSet$BitSetN(elems);
  }
});
var $d_sci_BitSet$ = new $TypeData().initClass($c_sci_BitSet$, "scala.collection.immutable.BitSet$", ({
  sci_BitSet$: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_BitSet$;
function $m_sci_BitSet$() {
  if ((!$n_sci_BitSet$)) {
    $n_sci_BitSet$ = new $c_sci_BitSet$();
  }
  return $n_sci_BitSet$;
}
/** @constructor */
function $c_sci_HashMap$accum$1(outer) {
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = null;
  this.sci_HashMap$accum$1__f_$outer = null;
  $n(outer);
  this.sci_HashMap$accum$1__f_$outer = outer;
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = $n(outer).sci_HashMap__f_rootNode;
}
$c_sci_HashMap$accum$1.prototype = new $h_sr_AbstractFunction2();
$c_sci_HashMap$accum$1.prototype.constructor = $c_sci_HashMap$accum$1;
/** @constructor */
function $h_sci_HashMap$accum$1() {
}
$h_sci_HashMap$accum$1.prototype = $c_sci_HashMap$accum$1.prototype;
$c_sci_HashMap$accum$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  $as_T2(v1);
});
$c_sci_HashMap$accum$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sci_HashMap$accum$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sci_HashMap$accum$1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__V = (function(key, value) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var improved = $m_sc_Hashing$().improve__I__I(originalHash);
  if ((!this.sci_HashMap$accum$1__f_changed)) {
    this.sci_HashMap$accum$1__f_current = $n(this.sci_HashMap$accum$1__f_current).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, improved, 0, true);
    if ((this.sci_HashMap$accum$1__f_current !== $n(this.sci_HashMap$accum$1__f_$outer).sci_HashMap__f_rootNode)) {
      this.sci_HashMap$accum$1__f_changed = true;
      this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
    }
  } else {
    this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = $n(this.sci_HashMap$accum$1__f_current).updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, improved, 0, this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap);
  }
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2);
});
$c_sci_HashMap$accum$1.prototype.apply__O__O = (function(v1) {
  var kv = $as_T2(v1);
  this.apply__O__O__V($n(kv)._1__O(), $n(kv)._2__O());
});
var $d_sci_HashMap$accum$1 = new $TypeData().initClass($c_sci_HashMap$accum$1, "scala.collection.immutable.HashMap$accum$1", ({
  sci_HashMap$accum$1: 1,
  sr_AbstractFunction2: 1,
  F2: 1,
  F1: 1
}));
/** @constructor */
function $c_sci_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_List$());
}
$c_sci_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sci_Iterable$.prototype.constructor = $c_sci_Iterable$;
/** @constructor */
function $h_sci_Iterable$() {
}
$h_sci_Iterable$.prototype = $c_sci_Iterable$.prototype;
$c_sci_Iterable$.prototype.from__sc_IterableOnce__sci_Iterable = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    return x2;
  } else {
    return $as_sci_Iterable($c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O.call(this, it));
  }
});
$c_sci_Iterable$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Iterable(it);
});
var $d_sci_Iterable$ = new $TypeData().initClass($c_sci_Iterable$, "scala.collection.immutable.Iterable$", ({
  sci_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Iterable$;
function $m_sci_Iterable$() {
  if ((!$n_sci_Iterable$)) {
    $n_sci_Iterable$ = new $c_sci_Iterable$();
  }
  return $n_sci_Iterable$;
}
/** @constructor */
function $c_sci_LazyList$() {
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty = null;
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = null;
  $n_sci_LazyList$ = this;
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty = $ct_sci_LazyList__O__(new $c_sci_LazyList(), $m_sci_LazyList$EmptyMarker$());
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$10$2$2) => $m_sr_Statics$PFMarker$()));
}
$c_sci_LazyList$.prototype = new $h_O();
$c_sci_LazyList$.prototype.constructor = $c_sci_LazyList$;
/** @constructor */
function $h_sci_LazyList$() {
}
$h_sci_LazyList$.prototype = $c_sci_LazyList$.prototype;
$c_sci_LazyList$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_LazyList(elems);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList = (function(ll, p, isFlipped) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var elem = null;
    var found = false;
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    while (true) {
      if ((!found)) {
        var this$2 = $n(rest);
        var $x_1 = (!(this$2.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        elem = $n(rest).head__O();
        found = ($uZ($n(p).apply__O__O(elem)) !== isFlipped);
        rest = $n(rest).tail__sci_LazyList();
        restRef.sr_ObjectRef__f_elem = rest;
      } else {
        break;
      }
    }
    if (found) {
      $m_sci_LazyList$();
      var hd = elem;
      var tl = $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(rest, p, isFlipped);
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
    } else {
      return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$collectImpl__sci_LazyList__s_PartialFunction__sci_LazyList = (function(ll, pf) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var marker = $m_sr_Statics$PFMarker$();
    var toMarker = $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker;
    var res = marker;
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    while (true) {
      if ((res === marker)) {
        var this$3 = $n(rest);
        var $x_1 = (!(this$3.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        res = $n(pf).applyOrElse__O__F1__O($n(rest).head__O(), toMarker);
        rest = $n(rest).tail__sci_LazyList();
        restRef.sr_ObjectRef__f_elem = rest;
      } else {
        break;
      }
    }
    if ((res === marker)) {
      return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    } else {
      $m_sci_LazyList$();
      var hd = res;
      var tl = $m_sci_LazyList$().scala$collection$immutable$LazyList$$collectImpl__sci_LazyList__s_PartialFunction__sci_LazyList(rest, pf);
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList = (function(ll, f) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state$1 = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var it = new $c_sr_ObjectRef(null);
    var itHasNext = false;
    var elem = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    var rest = new $c_sr_ObjectRef(elem);
    while (true) {
      if ((!itHasNext)) {
        var this$4 = $n($as_sci_LazyList(rest.sr_ObjectRef__f_elem));
        var $x_1 = (!(this$4.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        it.sr_ObjectRef__f_elem = $n($as_sc_IterableOnce($n(f).apply__O__O($n($as_sci_LazyList(rest.sr_ObjectRef__f_elem)).head__O()))).iterator__sc_Iterator();
        itHasNext = $n($as_sc_Iterator(it.sr_ObjectRef__f_elem)).hasNext__Z();
        if ((!itHasNext)) {
          rest.sr_ObjectRef__f_elem = $n($as_sci_LazyList(rest.sr_ObjectRef__f_elem)).tail__sci_LazyList();
          restRef.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
        }
      } else {
        break;
      }
    }
    if (itHasNext) {
      var head = $n($as_sc_Iterator(it.sr_ObjectRef__f_elem)).next__O();
      rest.sr_ObjectRef__f_elem = $n($as_sci_LazyList(rest.sr_ObjectRef__f_elem)).tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      $m_sci_LazyList$();
      $m_sci_LazyList$();
      var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadPrependIterator__sc_Iterator__F0__sci_LazyList($as_sc_Iterator(it.sr_ObjectRef__f_elem), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList($as_sci_LazyList(rest.sr_ObjectRef__f_elem), f))))));
      var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), head, tl);
    } else {
      return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state$1);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList = (function(ll, n) {
  var restRef = new $c_sr_ObjectRef(ll);
  var iRef = new $c_sr_IntRef(n);
  var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    var rest = $as_sci_LazyList(restRef.sr_ObjectRef__f_elem);
    var i = iRef.sr_IntRef__f_elem;
    while (true) {
      if ((i > 0)) {
        var this$3 = $n(rest);
        var $x_1 = (!(this$3.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        rest = $n(rest).tail__sci_LazyList();
        restRef.sr_ObjectRef__f_elem = rest;
        i = ((i - 1) | 0);
        iRef.sr_IntRef__f_elem = i;
      } else {
        break;
      }
    }
    return rest;
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__sci_LazyList = (function(coll) {
  if ((coll instanceof $c_sci_LazyList)) {
    var x2 = $as_sci_LazyList(coll);
    return x2;
  } else if (($n(coll).knownSize__I() === 0)) {
    return this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadFromIterator__sc_Iterator__sci_LazyList($n(coll).iterator__sc_Iterator())));
    return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$eagerHeadPrependIterator__sc_Iterator__F0__sci_LazyList = (function(it, suffix) {
  if ($n(it).hasNext__Z()) {
    var hd = $n(it).next__O();
    var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadPrependIterator__sc_Iterator__F0__sci_LazyList(it, suffix)));
    var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
  } else {
    return $as_sci_LazyList($n(suffix).apply__O());
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$eagerHeadFromIterator__sc_Iterator__sci_LazyList = (function(it) {
  if ($n(it).hasNext__Z()) {
    var hd = $n(it).next__O();
    var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadFromIterator__sc_Iterator__sci_LazyList(it)));
    var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
  } else {
    return this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  }
});
$c_sci_LazyList$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_LazyList$LazyBuilder();
});
$c_sci_LazyList$.prototype.empty__O = (function() {
  return this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_LazyList(source);
});
var $d_sci_LazyList$ = new $TypeData().initClass($c_sci_LazyList$, "scala.collection.immutable.LazyList$", ({
  sci_LazyList$: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_LazyList$;
function $m_sci_LazyList$() {
  if ((!$n_sci_LazyList$)) {
    $n_sci_LazyList$ = new $c_sci_LazyList$();
  }
  return $n_sci_LazyList$;
}
/** @constructor */
function $c_sci_Stream$() {
}
$c_sci_Stream$.prototype = new $h_O();
$c_sci_Stream$.prototype.constructor = $c_sci_Stream$;
/** @constructor */
function $h_sci_Stream$() {
}
$h_sci_Stream$.prototype = $c_sci_Stream$.prototype;
$c_sci_Stream$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Stream(elems);
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__sci_Stream = (function(coll) {
  if ((coll instanceof $c_sci_Stream)) {
    var x2 = $as_sci_Stream(coll);
    return x2;
  } else {
    return this.fromIterator__sc_Iterator__sci_Stream($n(coll).iterator__sc_Iterator());
  }
});
$c_sci_Stream$.prototype.fromIterator__sc_Iterator__sci_Stream = (function(it) {
  return ($n(it).hasNext__Z() ? new $c_sci_Stream$Cons($n(it).next__O(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Stream$().fromIterator__sc_Iterator__sci_Stream(it)))) : $m_sci_Stream$Empty$());
});
$c_sci_Stream$.prototype.newBuilder__scm_Builder = (function() {
  $m_scm_ArrayBuffer$();
  var this$2 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((array$2$2) => {
    var array$2 = $as_scm_ArrayBuffer(array$2$2);
    return $m_sci_Stream$().from__sc_IterableOnce__sci_Stream(array$2);
  }));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_sci_Stream$.prototype.filteredTail__sci_Stream__F1__Z__sci_Stream = (function(stream, p, isFlipped) {
  var hd = $n(stream).head__O();
  var tl = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n($as_sci_Stream($n(stream).tail__O())).filterImpl__F1__Z__sci_Stream(p, isFlipped)));
  return new $c_sci_Stream$Cons(hd, tl);
});
$c_sci_Stream$.prototype.collectedTail__O__sci_Stream__s_PartialFunction__sci_Stream = (function(head, stream, pf) {
  var tl = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n($as_sci_Stream($n(stream).tail__O())).collect__s_PartialFunction__sci_Stream(pf)));
  return new $c_sci_Stream$Cons(head, tl);
});
$c_sci_Stream$.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$();
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Stream(source);
});
var $d_sci_Stream$ = new $TypeData().initClass($c_sci_Stream$, "scala.collection.immutable.Stream$", ({
  sci_Stream$: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Stream$;
function $m_sci_Stream$() {
  if ((!$n_sci_Stream$)) {
    $n_sci_Stream$ = new $c_sci_Stream$();
  }
  return $n_sci_Stream$;
}
/** @constructor */
function $c_scm_Builder$$anon$1(outer, f$1) {
  this.scm_Builder$$anon$1__f_$outer = null;
  this.scm_Builder$$anon$1__f_f$1 = null;
  $n(outer);
  this.scm_Builder$$anon$1__f_$outer = outer;
  this.scm_Builder$$anon$1__f_f$1 = f$1;
}
$c_scm_Builder$$anon$1.prototype = new $h_O();
$c_scm_Builder$$anon$1.prototype.constructor = $c_scm_Builder$$anon$1;
/** @constructor */
function $h_scm_Builder$$anon$1() {
}
$h_scm_Builder$$anon$1.prototype = $c_scm_Builder$$anon$1.prototype;
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Builder$$anon$1 = (function(x) {
  var this$1 = $n(this.scm_Builder$$anon$1__f_$outer);
  this$1.addOne__O__scm_Growable(x);
  return this;
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Builder$$anon$1 = (function(xs) {
  var this$1 = $n(this.scm_Builder$$anon$1__f_$outer);
  this$1.addAll__sc_IterableOnce__scm_Growable(xs);
  return this;
});
$c_scm_Builder$$anon$1.prototype.sizeHint__I__V = (function(size) {
  $n(this.scm_Builder$$anon$1__f_$outer).sizeHint__I__V(size);
});
$c_scm_Builder$$anon$1.prototype.result__O = (function() {
  return $n(this.scm_Builder$$anon$1__f_f$1).apply__O__O($n(this.scm_Builder$$anon$1__f_$outer).result__O());
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_Builder$$anon$1(elems);
});
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_Builder$$anon$1(elem);
});
var $d_scm_Builder$$anon$1 = new $TypeData().initClass($c_scm_Builder$$anon$1, "scala.collection.mutable.Builder$$anon$1", ({
  scm_Builder$$anon$1: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $ct_scm_GrowableBuilder__scm_Growable__($thiz, elems) {
  $thiz.scm_GrowableBuilder__f_elems = elems;
  return $thiz;
}
/** @constructor */
function $c_scm_GrowableBuilder() {
  this.scm_GrowableBuilder__f_elems = null;
}
$c_scm_GrowableBuilder.prototype = new $h_O();
$c_scm_GrowableBuilder.prototype.constructor = $c_scm_GrowableBuilder;
/** @constructor */
function $h_scm_GrowableBuilder() {
}
$h_scm_GrowableBuilder.prototype = $c_scm_GrowableBuilder.prototype;
$c_scm_GrowableBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_GrowableBuilder = (function(elem) {
  var this$1 = $n(this.scm_GrowableBuilder__f_elems);
  this$1.addOne__O__scm_Growable(elem);
  return this;
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_GrowableBuilder = (function(xs) {
  $n(this.scm_GrowableBuilder__f_elems).addAll__sc_IterableOnce__scm_Growable(xs);
  return this;
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_GrowableBuilder(elems);
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_GrowableBuilder(elem);
});
$c_scm_GrowableBuilder.prototype.result__O = (function() {
  return this.scm_GrowableBuilder__f_elems;
});
var $d_scm_GrowableBuilder = new $TypeData().initClass($c_scm_GrowableBuilder, "scala.collection.mutable.GrowableBuilder", ({
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_scm_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_ArrayBuffer$());
}
$c_scm_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Iterable$.prototype.constructor = $c_scm_Iterable$;
/** @constructor */
function $h_scm_Iterable$() {
}
$h_scm_Iterable$.prototype = $c_scm_Iterable$.prototype;
var $d_scm_Iterable$ = new $TypeData().initClass($c_scm_Iterable$, "scala.collection.mutable.Iterable$", ({
  scm_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Iterable$;
function $m_scm_Iterable$() {
  if ((!$n_scm_Iterable$)) {
    $n_scm_Iterable$ = new $c_scm_Iterable$();
  }
  return $n_scm_Iterable$;
}
/** @constructor */
function $c_scm_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_scm_HashMap$());
}
$c_scm_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_scm_Map$.prototype.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
}
$h_scm_Map$.prototype = $c_scm_Map$.prototype;
var $d_scm_Map$ = new $TypeData().initClass($c_scm_Map$, "scala.collection.mutable.Map$", ({
  scm_Map$: 1,
  sc_MapFactory$Delegate: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$();
  }
  return $n_scm_Map$;
}
/** @constructor */
function $c_scm_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_HashSet$());
}
$c_scm_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Set$.prototype.constructor = $c_scm_Set$;
/** @constructor */
function $h_scm_Set$() {
}
$h_scm_Set$.prototype = $c_scm_Set$.prototype;
var $d_scm_Set$ = new $TypeData().initClass($c_scm_Set$, "scala.collection.mutable.Set$", ({
  scm_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Set$;
function $m_scm_Set$() {
  if ((!$n_scm_Set$)) {
    $n_scm_Set$ = new $c_scm_Set$();
  }
  return $n_scm_Set$;
}
class $c_s_concurrent_Future$$anon$4 extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$4 = new $TypeData().initClass($c_s_concurrent_Future$$anon$4, "scala.concurrent.Future$$anon$4", ({
  s_concurrent_Future$$anon$4: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration() {
}
$c_s_concurrent_duration_Duration.prototype = new $h_O();
$c_s_concurrent_duration_Duration.prototype.constructor = $c_s_concurrent_duration_Duration;
/** @constructor */
function $h_s_concurrent_duration_Duration() {
}
$h_s_concurrent_duration_Duration.prototype = $c_s_concurrent_duration_Duration.prototype;
$c_s_concurrent_duration_Duration.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
$c_s_concurrent_duration_Duration.prototype.min__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  return ($f_s_math_Ordered__$less__O__Z(this, other) ? this : other);
});
function $as_s_concurrent_duration_Duration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration"));
}
function $isArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration)));
}
function $asArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration;", depth));
}
function $f_sr_EnumValue__productElement__I__O($thiz, n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
}
class $c_sr_NonLocalReturnControl extends $c_s_util_control_ControlThrowable {
  constructor(key, value) {
    super();
    this.sr_NonLocalReturnControl__f_key = null;
    this.sr_NonLocalReturnControl__f_value = null;
    this.sr_NonLocalReturnControl__f_key = key;
    this.sr_NonLocalReturnControl__f_value = value;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, false, false);
  }
  fillInStackTrace__jl_Throwable() {
    return this;
  }
}
function $as_sr_NonLocalReturnControl(obj) {
  return (((obj instanceof $c_sr_NonLocalReturnControl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.NonLocalReturnControl"));
}
function $isArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_NonLocalReturnControl)));
}
function $asArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (($isArrayOf_sr_NonLocalReturnControl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.NonLocalReturnControl;", depth));
}
var $d_sr_NonLocalReturnControl = new $TypeData().initClass($c_sr_NonLocalReturnControl, "scala.runtime.NonLocalReturnControl", ({
  sr_NonLocalReturnControl: 1,
  s_util_control_ControlThrowable: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sjs_js_WrappedDictionary$DictionaryIterator(dict) {
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = dict;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = Object.keys(dict);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
}
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.constructor = $c_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $h_sjs_js_WrappedDictionary$DictionaryIterator() {
}
$h_sjs_js_WrappedDictionary$DictionaryIterator.prototype = $c_sjs_js_WrappedDictionary$DictionaryIterator.prototype;
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.hasNext__Z = (function() {
  return (this.sjs_js_WrappedDictionary$DictionaryIterator__f_index < $uI(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys.length));
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__T2 = (function() {
  var key = $as_T(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys[this.sjs_js_WrappedDictionary$DictionaryIterator__f_index]);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = ((1 + this.sjs_js_WrappedDictionary$DictionaryIterator__f_index) | 0);
  var dict = this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    var $x_1 = dict[key];
  } else {
    var $x_1;
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
  return new $c_T2(key, $x_1);
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sjs_js_WrappedDictionary$DictionaryIterator = new $TypeData().initClass($c_sjs_js_WrappedDictionary$DictionaryIterator, "scala.scalajs.js.WrappedDictionary$DictionaryIterator", ({
  sjs_js_WrappedDictionary$DictionaryIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = null;
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = ({});
}
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.constructor = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder;
/** @constructor */
function $h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
}
$h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype;
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder = (function(elem) {
  var dict = this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict;
  var key = $as_T($n(elem)._1__O());
  var value = $n(elem)._2__O();
  dict[key] = value;
  return this;
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__sjs_js_WrappedDictionary = (function() {
  return new $c_sjs_js_WrappedDictionary(this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict);
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__O = (function() {
  return this.result__sjs_js_WrappedDictionary();
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder($as_T2(elem));
});
var $d_sjs_js_WrappedDictionary$WrappedDictionaryBuilder = new $TypeData().initClass($c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder, "scala.scalajs.js.WrappedDictionary$WrappedDictionaryBuilder", ({
  sjs_js_WrappedDictionary$WrappedDictionaryBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(f) {
  this.sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d__f_f = null;
  this.sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d__f_f = f;
}
$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.prototype = new $h_sjsr_AnonFunction0();
$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.prototype.constructor = $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d;
/** @constructor */
function $h_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d() {
}
$h_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.prototype = $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.prototype;
$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.prototype.apply__O = (function() {
  return $n(this.sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d__f_f)();
});
var $d_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d = new $TypeData().initClass($c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d, "scala.scalajs.runtime.AnonFunction0.$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d", ({
  sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d: 1,
  sjsr_AnonFunction0: 1,
  sr_AbstractFunction0: 1,
  F0: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(f) {
  this.sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1__f_f = null;
  this.sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1__f_f = f;
}
$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.prototype = new $h_sjsr_AnonFunction1();
$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.prototype.constructor = $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1;
/** @constructor */
function $h_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1() {
}
$h_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.prototype = $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.prototype;
$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.prototype.apply__O__O = (function(x0) {
  return $n(this.sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1__f_f)(x0);
});
var $d_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1 = new $TypeData().initClass($c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1, "scala.scalajs.runtime.AnonFunction1.$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1", ({
  sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1: 1,
  sjsr_AnonFunction1: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(f) {
  this.sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7__f_f = null;
  this.sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7__f_f = f;
}
$c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7.prototype = new $h_sjsr_AnonFunction2();
$c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7.prototype.constructor = $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7;
/** @constructor */
function $h_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7() {
}
$h_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7.prototype = $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7.prototype;
$c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7.prototype.apply__O__O__O = (function(x0, x1) {
  return $n(this.sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7__f_f)(x0, x1);
});
var $d_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7 = new $TypeData().initClass($c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7, "scala.scalajs.runtime.AnonFunction2.$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7", ({
  sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7: 1,
  sjsr_AnonFunction2: 1,
  sr_AbstractFunction2: 1,
  F2: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(f) {
  this.sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96__f_f = null;
  this.sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96__f_f = f;
}
$c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96.prototype = new $h_sjsr_AnonFunction3();
$c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96.prototype.constructor = $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96;
/** @constructor */
function $h_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96() {
}
$h_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96.prototype = $c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96.prototype;
$c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96.prototype.apply__O__O__O__O = (function(x0, x1, x2) {
  return $n(this.sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96__f_f)(x0, x1, x2);
});
var $d_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96 = new $TypeData().initClass($c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96, "scala.scalajs.runtime.AnonFunction3.$$Lambda$73f37e31ba038fe839c174212837da323f140c96", ({
  sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96: 1,
  sjsr_AnonFunction3: 1,
  sr_AbstractFunction3: 1,
  F3: 1
}));
/** @constructor */
function $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c(f) {
  this.sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c__f_f = null;
  this.sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c__f_f = f;
}
$c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c.prototype = new $h_sjsr_AnonFunction4();
$c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c.prototype.constructor = $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c;
/** @constructor */
function $h_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c() {
}
$h_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c.prototype = $c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c.prototype;
$c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c.prototype.apply__O__O__O__O__O = (function(x0, x1, x2, x3) {
  return $n(this.sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c__f_f)(x0, x1, x2, x3);
});
var $d_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c = new $TypeData().initClass($c_sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c, "scala.scalajs.runtime.AnonFunction4.$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c", ({
  sjsr_AnonFunction4_$$Lambda$120c664e6fb20e1c3552e9e8baf775b7682c102c: 1,
  sjsr_AnonFunction4: 1,
  sr_AbstractFunction4: 1,
  F4: 1
}));
/** @constructor */
function $c_s_util_Either() {
}
$c_s_util_Either.prototype = new $h_O();
$c_s_util_Either.prototype.constructor = $c_s_util_Either;
/** @constructor */
function $h_s_util_Either() {
}
$h_s_util_Either.prototype = $c_s_util_Either.prototype;
$c_s_util_Either.prototype.fold__F1__F1__O = (function(fa, fb) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return $n(fb).apply__O__O(b);
  } else if ((this instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(this);
    var a = $n(x3).s_util_Left__f_value;
    return $n(fa).apply__O__O(a);
  } else {
    throw new $c_s_MatchError(this);
  }
});
$c_s_util_Either.prototype.swap__s_util_Either = (function() {
  if ((this instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(this);
    var a = $n(x2).s_util_Left__f_value;
    return new $c_s_util_Right(a);
  } else if ((this instanceof $c_s_util_Right)) {
    var x3 = $as_s_util_Right(this);
    var b = $n(x3).s_util_Right__f_value;
    return new $c_s_util_Left(b);
  } else {
    throw new $c_s_MatchError(this);
  }
});
$c_s_util_Either.prototype.flatMap__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return $as_s_util_Either($n(f).apply__O__O(b));
  } else {
    return this;
  }
});
$c_s_util_Either.prototype.map__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return new $c_s_util_Right($n(f).apply__O__O(b));
  } else {
    return this;
  }
});
$c_s_util_Either.prototype.toOption__s_Option = (function() {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = $n(x2).s_util_Right__f_value;
    return new $c_s_Some(b);
  } else {
    return $m_s_None$();
  }
});
function $as_s_util_Either(obj) {
  return (((obj instanceof $c_s_util_Either) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Either"));
}
function $isArrayOf_s_util_Either(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Either)));
}
function $asArrayOf_s_util_Either(obj, depth) {
  return (($isArrayOf_s_util_Either(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Either;", depth));
}
/** @constructor */
function $c_s_util_Try() {
}
$c_s_util_Try.prototype = new $h_O();
$c_s_util_Try.prototype.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
}
$h_s_util_Try.prototype = $c_s_util_Try.prototype;
function $as_s_util_Try(obj) {
  return (((obj instanceof $c_s_util_Try) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Try"));
}
function $isArrayOf_s_util_Try(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Try)));
}
function $asArrayOf_s_util_Try(obj, depth) {
  return (($isArrayOf_s_util_Try(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Try;", depth));
}
function $as_Lsnabbdom_Hooks(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.Hooks"));
}
function $isArrayOf_Lsnabbdom_Hooks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_Hooks)));
}
function $asArrayOf_Lsnabbdom_Hooks(obj, depth) {
  return (($isArrayOf_Lsnabbdom_Hooks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.Hooks;", depth));
}
/** @constructor */
function $c_Lsnabbdom_Module(pre, create, update, postPatch, destroy, remove, post) {
  this.Lsnabbdom_Module__f_pre = null;
  this.Lsnabbdom_Module__f_create = null;
  this.Lsnabbdom_Module__f_update = null;
  this.Lsnabbdom_Module__f_postPatch = null;
  this.Lsnabbdom_Module__f_destroy = null;
  this.Lsnabbdom_Module__f_remove = null;
  this.Lsnabbdom_Module__f_post = null;
  this.Lsnabbdom_Module__f_pre = pre;
  this.Lsnabbdom_Module__f_create = create;
  this.Lsnabbdom_Module__f_update = update;
  this.Lsnabbdom_Module__f_postPatch = postPatch;
  this.Lsnabbdom_Module__f_destroy = destroy;
  this.Lsnabbdom_Module__f_remove = remove;
  this.Lsnabbdom_Module__f_post = post;
}
$c_Lsnabbdom_Module.prototype = new $h_O();
$c_Lsnabbdom_Module.prototype.constructor = $c_Lsnabbdom_Module;
/** @constructor */
function $h_Lsnabbdom_Module() {
}
$h_Lsnabbdom_Module.prototype = $c_Lsnabbdom_Module.prototype;
$c_Lsnabbdom_Module.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_Module.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_Module.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_Module)) {
    var x$0$2 = $as_Lsnabbdom_Module(x$0);
    var x = this.Lsnabbdom_Module__f_pre;
    var x$2 = $n(x$0$2).Lsnabbdom_Module__f_pre;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lsnabbdom_Module__f_create;
      var x$4 = $n(x$0$2).Lsnabbdom_Module__f_create;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.Lsnabbdom_Module__f_update;
      var x$6 = $n(x$0$2).Lsnabbdom_Module__f_update;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.Lsnabbdom_Module__f_postPatch;
      var x$8 = $n(x$0$2).Lsnabbdom_Module__f_postPatch;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.Lsnabbdom_Module__f_destroy;
      var x$10 = $n(x$0$2).Lsnabbdom_Module__f_destroy;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.Lsnabbdom_Module__f_remove;
      var x$12 = $n(x$0$2).Lsnabbdom_Module__f_remove;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.Lsnabbdom_Module__f_post;
      var x$14 = $n(x$0$2).Lsnabbdom_Module__f_post;
      return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_Module.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_Module.prototype.productArity__I = (function() {
  return 7;
});
$c_Lsnabbdom_Module.prototype.productPrefix__T = (function() {
  return "Module";
});
$c_Lsnabbdom_Module.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_Module__f_pre;
      break;
    }
    case 1: {
      return this.Lsnabbdom_Module__f_create;
      break;
    }
    case 2: {
      return this.Lsnabbdom_Module__f_update;
      break;
    }
    case 3: {
      return this.Lsnabbdom_Module__f_postPatch;
      break;
    }
    case 4: {
      return this.Lsnabbdom_Module__f_destroy;
      break;
    }
    case 5: {
      return this.Lsnabbdom_Module__f_remove;
      break;
    }
    case 6: {
      return this.Lsnabbdom_Module__f_post;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lsnabbdom_Module(obj) {
  return (((obj instanceof $c_Lsnabbdom_Module) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.Module"));
}
function $isArrayOf_Lsnabbdom_Module(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_Module)));
}
function $asArrayOf_Lsnabbdom_Module(obj, depth) {
  return (($isArrayOf_Lsnabbdom_Module(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.Module;", depth));
}
var $d_Lsnabbdom_Module = new $TypeData().initClass($c_Lsnabbdom_Module, "snabbdom.Module", ({
  Lsnabbdom_Module: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_ModuleHooks(create, update, postPatch, remove, destroy, pre, post) {
  this.Lsnabbdom_ModuleHooks__f_create = null;
  this.Lsnabbdom_ModuleHooks__f_update = null;
  this.Lsnabbdom_ModuleHooks__f_postPatch = null;
  this.Lsnabbdom_ModuleHooks__f_remove = null;
  this.Lsnabbdom_ModuleHooks__f_destroy = null;
  this.Lsnabbdom_ModuleHooks__f_pre = null;
  this.Lsnabbdom_ModuleHooks__f_post = null;
  this.Lsnabbdom_ModuleHooks__f_create = create;
  this.Lsnabbdom_ModuleHooks__f_update = update;
  this.Lsnabbdom_ModuleHooks__f_postPatch = postPatch;
  this.Lsnabbdom_ModuleHooks__f_remove = remove;
  this.Lsnabbdom_ModuleHooks__f_destroy = destroy;
  this.Lsnabbdom_ModuleHooks__f_pre = pre;
  this.Lsnabbdom_ModuleHooks__f_post = post;
}
$c_Lsnabbdom_ModuleHooks.prototype = new $h_O();
$c_Lsnabbdom_ModuleHooks.prototype.constructor = $c_Lsnabbdom_ModuleHooks;
/** @constructor */
function $h_Lsnabbdom_ModuleHooks() {
}
$h_Lsnabbdom_ModuleHooks.prototype = $c_Lsnabbdom_ModuleHooks.prototype;
$c_Lsnabbdom_ModuleHooks.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_ModuleHooks.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_ModuleHooks.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_ModuleHooks)) {
    var x$0$2 = $as_Lsnabbdom_ModuleHooks(x$0);
    var x = this.Lsnabbdom_ModuleHooks__f_create;
    var x$2 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_create;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lsnabbdom_ModuleHooks__f_update;
      var x$4 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_update;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.Lsnabbdom_ModuleHooks__f_postPatch;
      var x$6 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_postPatch;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.Lsnabbdom_ModuleHooks__f_remove;
      var x$8 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_remove;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.Lsnabbdom_ModuleHooks__f_destroy;
      var x$10 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_destroy;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.Lsnabbdom_ModuleHooks__f_pre;
      var x$12 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_pre;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.Lsnabbdom_ModuleHooks__f_post;
      var x$14 = $n(x$0$2).Lsnabbdom_ModuleHooks__f_post;
      return ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_ModuleHooks.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_ModuleHooks.prototype.productArity__I = (function() {
  return 7;
});
$c_Lsnabbdom_ModuleHooks.prototype.productPrefix__T = (function() {
  return "ModuleHooks";
});
$c_Lsnabbdom_ModuleHooks.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_ModuleHooks__f_create;
      break;
    }
    case 1: {
      return this.Lsnabbdom_ModuleHooks__f_update;
      break;
    }
    case 2: {
      return this.Lsnabbdom_ModuleHooks__f_postPatch;
      break;
    }
    case 3: {
      return this.Lsnabbdom_ModuleHooks__f_remove;
      break;
    }
    case 4: {
      return this.Lsnabbdom_ModuleHooks__f_destroy;
      break;
    }
    case 5: {
      return this.Lsnabbdom_ModuleHooks__f_pre;
      break;
    }
    case 6: {
      return this.Lsnabbdom_ModuleHooks__f_post;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lsnabbdom_ModuleHooks(obj) {
  return (((obj instanceof $c_Lsnabbdom_ModuleHooks) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.ModuleHooks"));
}
function $isArrayOf_Lsnabbdom_ModuleHooks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_ModuleHooks)));
}
function $asArrayOf_Lsnabbdom_ModuleHooks(obj, depth) {
  return (($isArrayOf_Lsnabbdom_ModuleHooks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.ModuleHooks;", depth));
}
var $d_Lsnabbdom_ModuleHooks = new $TypeData().initClass($c_Lsnabbdom_ModuleHooks, "snabbdom.ModuleHooks", ({
  Lsnabbdom_ModuleHooks: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_VNodeData(props, attrs, classes, style, dataset, on, hook, key, ns, fn, args, is) {
  this.Lsnabbdom_VNodeData__f_props = null;
  this.Lsnabbdom_VNodeData__f_attrs = null;
  this.Lsnabbdom_VNodeData__f_classes = null;
  this.Lsnabbdom_VNodeData__f_style = null;
  this.Lsnabbdom_VNodeData__f_dataset = null;
  this.Lsnabbdom_VNodeData__f_on = null;
  this.Lsnabbdom_VNodeData__f_hook = null;
  this.Lsnabbdom_VNodeData__f_key = null;
  this.Lsnabbdom_VNodeData__f_ns = null;
  this.Lsnabbdom_VNodeData__f_fn = null;
  this.Lsnabbdom_VNodeData__f_args = null;
  this.Lsnabbdom_VNodeData__f_is = null;
  this.Lsnabbdom_VNodeData__f_props = props;
  this.Lsnabbdom_VNodeData__f_attrs = attrs;
  this.Lsnabbdom_VNodeData__f_classes = classes;
  this.Lsnabbdom_VNodeData__f_style = style;
  this.Lsnabbdom_VNodeData__f_dataset = dataset;
  this.Lsnabbdom_VNodeData__f_on = on;
  this.Lsnabbdom_VNodeData__f_hook = hook;
  this.Lsnabbdom_VNodeData__f_key = key;
  this.Lsnabbdom_VNodeData__f_ns = ns;
  this.Lsnabbdom_VNodeData__f_fn = fn;
  this.Lsnabbdom_VNodeData__f_args = args;
  this.Lsnabbdom_VNodeData__f_is = is;
}
$c_Lsnabbdom_VNodeData.prototype = new $h_O();
$c_Lsnabbdom_VNodeData.prototype.constructor = $c_Lsnabbdom_VNodeData;
/** @constructor */
function $h_Lsnabbdom_VNodeData() {
}
$h_Lsnabbdom_VNodeData.prototype = $c_Lsnabbdom_VNodeData.prototype;
$c_Lsnabbdom_VNodeData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_VNodeData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_VNodeData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_VNodeData)) {
    var x$0$2 = $as_Lsnabbdom_VNodeData(x$0);
    var x = this.Lsnabbdom_VNodeData__f_props;
    var x$2 = $n(x$0$2).Lsnabbdom_VNodeData__f_props;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lsnabbdom_VNodeData__f_attrs;
      var x$4 = $n(x$0$2).Lsnabbdom_VNodeData__f_attrs;
      var $x_10 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$5 = this.Lsnabbdom_VNodeData__f_classes;
      var x$6 = $n(x$0$2).Lsnabbdom_VNodeData__f_classes;
      var $x_9 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$7 = this.Lsnabbdom_VNodeData__f_style;
      var x$8 = $n(x$0$2).Lsnabbdom_VNodeData__f_style;
      var $x_8 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$9 = this.Lsnabbdom_VNodeData__f_dataset;
      var x$10 = $n(x$0$2).Lsnabbdom_VNodeData__f_dataset;
      var $x_7 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$11 = this.Lsnabbdom_VNodeData__f_on;
      var x$12 = $n(x$0$2).Lsnabbdom_VNodeData__f_on;
      var $x_6 = ((x$11 === null) ? (x$12 === null) : $n(x$11).equals__O__Z(x$12));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$13 = this.Lsnabbdom_VNodeData__f_hook;
      var x$14 = $n(x$0$2).Lsnabbdom_VNodeData__f_hook;
      var $x_5 = ((x$13 === null) ? (x$14 === null) : $n(x$13).equals__O__Z(x$14));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$15 = this.Lsnabbdom_VNodeData__f_key;
      var x$16 = $n(x$0$2).Lsnabbdom_VNodeData__f_key;
      var $x_4 = ((x$15 === null) ? (x$16 === null) : $n(x$15).equals__O__Z(x$16));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$17 = this.Lsnabbdom_VNodeData__f_ns;
      var x$18 = $n(x$0$2).Lsnabbdom_VNodeData__f_ns;
      var $x_3 = ((x$17 === null) ? (x$18 === null) : $n(x$17).equals__O__Z(x$18));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$19 = this.Lsnabbdom_VNodeData__f_fn;
      var x$20 = $n(x$0$2).Lsnabbdom_VNodeData__f_fn;
      var $x_2 = ((x$19 === null) ? (x$20 === null) : $n(x$19).equals__O__Z(x$20));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$21 = this.Lsnabbdom_VNodeData__f_args;
      var x$22 = $n(x$0$2).Lsnabbdom_VNodeData__f_args;
      var $x_1 = ((x$21 === null) ? (x$22 === null) : $n(x$21).equals__O__Z(x$22));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$23 = this.Lsnabbdom_VNodeData__f_is;
      var x$24 = $n(x$0$2).Lsnabbdom_VNodeData__f_is;
      return ((x$23 === null) ? (x$24 === null) : $n(x$23).equals__O__Z(x$24));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_VNodeData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_VNodeData.prototype.productArity__I = (function() {
  return 12;
});
$c_Lsnabbdom_VNodeData.prototype.productPrefix__T = (function() {
  return "VNodeData";
});
$c_Lsnabbdom_VNodeData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_VNodeData__f_props;
      break;
    }
    case 1: {
      return this.Lsnabbdom_VNodeData__f_attrs;
      break;
    }
    case 2: {
      return this.Lsnabbdom_VNodeData__f_classes;
      break;
    }
    case 3: {
      return this.Lsnabbdom_VNodeData__f_style;
      break;
    }
    case 4: {
      return this.Lsnabbdom_VNodeData__f_dataset;
      break;
    }
    case 5: {
      return this.Lsnabbdom_VNodeData__f_on;
      break;
    }
    case 6: {
      return this.Lsnabbdom_VNodeData__f_hook;
      break;
    }
    case 7: {
      return this.Lsnabbdom_VNodeData__f_key;
      break;
    }
    case 8: {
      return this.Lsnabbdom_VNodeData__f_ns;
      break;
    }
    case 9: {
      return this.Lsnabbdom_VNodeData__f_fn;
      break;
    }
    case 10: {
      return this.Lsnabbdom_VNodeData__f_args;
      break;
    }
    case 11: {
      return this.Lsnabbdom_VNodeData__f_is;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lsnabbdom_VNodeData(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNodeData) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNodeData"));
}
function $isArrayOf_Lsnabbdom_VNodeData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNodeData)));
}
function $asArrayOf_Lsnabbdom_VNodeData(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNodeData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNodeData;", depth));
}
var $d_Lsnabbdom_VNodeData = new $TypeData().initClass($c_Lsnabbdom_VNodeData, "snabbdom.VNodeData", ({
  Lsnabbdom_VNodeData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Location$() {
}
$c_Ltyrian_Location$.prototype = new $h_O();
$c_Ltyrian_Location$.prototype.constructor = $c_Ltyrian_Location$;
/** @constructor */
function $h_Ltyrian_Location$() {
}
$h_Ltyrian_Location$.prototype = $c_Ltyrian_Location$.prototype;
$c_Ltyrian_Location$.prototype.fromUrl__T__Ltyrian_Location$Internal__Ltyrian_Location = (function(url, currentLocation) {
  var ld = $m_Ltyrian_LocationDetails$().fromUrl__T__Ltyrian_LocationDetails(url);
  if ($n($n(ld).Ltyrian_LocationDetails__f_protocol).isEmpty__Z()) {
    return new $c_Ltyrian_Location$Internal(ld);
  } else {
    var x = $n(ld).Ltyrian_LocationDetails__f_origin;
    var this$2 = $n(currentLocation);
    var x$2 = $n(this$2.Ltyrian_Location$Internal__f_locationDetails).Ltyrian_LocationDetails__f_origin;
    return $as_Ltyrian_Location((((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2)) ? new $c_Ltyrian_Location$Internal(ld) : new $c_Ltyrian_Location$External(ld)));
  }
});
var $d_Ltyrian_Location$ = new $TypeData().initClass($c_Ltyrian_Location$, "tyrian.Location$", ({
  Ltyrian_Location$: 1,
  Ltyrian_LocationPlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ltyrian_Location$;
function $m_Ltyrian_Location$() {
  if ((!$n_Ltyrian_Location$)) {
    $n_Ltyrian_Location$ = new $c_Ltyrian_Location$();
  }
  return $n_Ltyrian_Location$;
}
function $p_Ltyrian_LocationDetails__whichSeparator__T__T($thiz, protocol) {
  return ($n($thiz.Ltyrian_LocationDetails__f_noSep).contains__O__Z(protocol) ? "" : "//");
}
/** @constructor */
function $c_Ltyrian_LocationDetails(hash, hostName, pathName, port, protocol, search, url) {
  this.Ltyrian_LocationDetails__f_hash = null;
  this.Ltyrian_LocationDetails__f_hostName = null;
  this.Ltyrian_LocationDetails__f_pathName = null;
  this.Ltyrian_LocationDetails__f_port = null;
  this.Ltyrian_LocationDetails__f_protocol = null;
  this.Ltyrian_LocationDetails__f_search = null;
  this.Ltyrian_LocationDetails__f_url = null;
  this.Ltyrian_LocationDetails__f_noSep = null;
  this.Ltyrian_LocationDetails__f_host = null;
  this.Ltyrian_LocationDetails__f_href = null;
  this.Ltyrian_LocationDetails__f_origin = null;
  this.Ltyrian_LocationDetails__f_hash = hash;
  this.Ltyrian_LocationDetails__f_hostName = hostName;
  this.Ltyrian_LocationDetails__f_pathName = pathName;
  this.Ltyrian_LocationDetails__f_port = port;
  this.Ltyrian_LocationDetails__f_protocol = protocol;
  this.Ltyrian_LocationDetails__f_search = search;
  this.Ltyrian_LocationDetails__f_url = url;
  this.Ltyrian_LocationDetails__f_noSep = new $c_sci_$colon$colon("xmpp:", new $c_sci_$colon$colon("data:", new $c_sci_$colon$colon("mailto:", $m_sci_Nil$())));
  matchResult4: {
    var $x_1;
    var x = $m_s_None$();
    if ((x === port)) {
      var $x_1 = hostName;
      break matchResult4;
    }
    if ((port instanceof $c_s_Some)) {
      var p = $as_T($n($as_s_Some(port)).s_Some__f_value);
      var this$1 = $n(hostName);
      if (this$1.isEmpty__Z()) {
        var $x_1 = $m_s_None$();
        break matchResult4;
      } else {
        var x0 = this$1.get__O();
        var h = $as_T(x0);
        var $x_1 = new $c_s_Some(((h + ":") + p));
        break matchResult4;
      }
    }
    throw new $c_s_MatchError(port);
  }
  this.Ltyrian_LocationDetails__f_host = $x_1;
  this.Ltyrian_LocationDetails__f_href = url;
  var this$2 = $n(protocol);
  if (this$2.isEmpty__Z()) {
    var $x_2 = $m_s_None$();
  } else {
    var x0$1 = this$2.get__O();
    var pr = $as_T(x0$1);
    var this$3 = $n(this.Ltyrian_LocationDetails__f_host);
    if (this$3.isEmpty__Z()) {
      var $x_2 = $m_s_None$();
    } else {
      var x0$2 = this$3.get__O();
      var ht = $as_T(x0$2);
      var $x_2 = new $c_s_Some(((("" + pr) + $p_Ltyrian_LocationDetails__whichSeparator__T__T(this, pr)) + ht));
    }
  }
  this.Ltyrian_LocationDetails__f_origin = $x_2;
  matchResult5: {
    var x8 = this.Ltyrian_LocationDetails__f_origin;
    var x$3 = $m_s_None$();
    if ((x$3 === x8)) {
      break matchResult5;
    }
    if ((x8 instanceof $c_s_Some)) {
      var o = $as_T($n($as_s_Some(x8)).s_Some__f_value);
      $f_T__replaceFirst__T__T__T($n(this.Ltyrian_LocationDetails__f_href), o, "");
      break matchResult5;
    }
    throw new $c_s_MatchError(x8);
  }
}
$c_Ltyrian_LocationDetails.prototype = new $h_O();
$c_Ltyrian_LocationDetails.prototype.constructor = $c_Ltyrian_LocationDetails;
/** @constructor */
function $h_Ltyrian_LocationDetails() {
}
$h_Ltyrian_LocationDetails.prototype = $c_Ltyrian_LocationDetails.prototype;
$c_Ltyrian_LocationDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_LocationDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_LocationDetails.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_LocationDetails)) {
    var x$0$2 = $as_Ltyrian_LocationDetails(x$0);
    var x = this.Ltyrian_LocationDetails__f_hash;
    var x$2 = $n(x$0$2).Ltyrian_LocationDetails__f_hash;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_LocationDetails__f_hostName;
      var x$4 = $n(x$0$2).Ltyrian_LocationDetails__f_hostName;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if (($x_4 && (this.Ltyrian_LocationDetails__f_pathName === $n(x$0$2).Ltyrian_LocationDetails__f_pathName))) {
      var x$5 = this.Ltyrian_LocationDetails__f_port;
      var x$6 = $n(x$0$2).Ltyrian_LocationDetails__f_port;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Ltyrian_LocationDetails__f_protocol;
      var x$8 = $n(x$0$2).Ltyrian_LocationDetails__f_protocol;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Ltyrian_LocationDetails__f_search;
      var x$10 = $n(x$0$2).Ltyrian_LocationDetails__f_search;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : $n(x$9).equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.Ltyrian_LocationDetails__f_url === $n(x$0$2).Ltyrian_LocationDetails__f_url);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_LocationDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_LocationDetails.prototype.productArity__I = (function() {
  return 7;
});
$c_Ltyrian_LocationDetails.prototype.productPrefix__T = (function() {
  return "LocationDetails";
});
$c_Ltyrian_LocationDetails.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_LocationDetails__f_hash;
      break;
    }
    case 1: {
      return this.Ltyrian_LocationDetails__f_hostName;
      break;
    }
    case 2: {
      return this.Ltyrian_LocationDetails__f_pathName;
      break;
    }
    case 3: {
      return this.Ltyrian_LocationDetails__f_port;
      break;
    }
    case 4: {
      return this.Ltyrian_LocationDetails__f_protocol;
      break;
    }
    case 5: {
      return this.Ltyrian_LocationDetails__f_search;
      break;
    }
    case 6: {
      return this.Ltyrian_LocationDetails__f_url;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_LocationDetails(obj) {
  return (((obj instanceof $c_Ltyrian_LocationDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.LocationDetails"));
}
function $isArrayOf_Ltyrian_LocationDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_LocationDetails)));
}
function $asArrayOf_Ltyrian_LocationDetails(obj, depth) {
  return (($isArrayOf_Ltyrian_LocationDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.LocationDetails;", depth));
}
var $d_Ltyrian_LocationDetails = new $TypeData().initClass($c_Ltyrian_LocationDetails, "tyrian.LocationDetails", ({
  Ltyrian_LocationDetails: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_LocationDetails$LocationPathDetails(path, search, hash) {
  this.Ltyrian_LocationDetails$LocationPathDetails__f_path = null;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_search = null;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_hash = null;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_path = path;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_search = search;
  this.Ltyrian_LocationDetails$LocationPathDetails__f_hash = hash;
}
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype = new $h_O();
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.constructor = $c_Ltyrian_LocationDetails$LocationPathDetails;
/** @constructor */
function $h_Ltyrian_LocationDetails$LocationPathDetails() {
}
$h_Ltyrian_LocationDetails$LocationPathDetails.prototype = $c_Ltyrian_LocationDetails$LocationPathDetails.prototype;
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_LocationDetails$LocationPathDetails)) {
    var x$0$2 = $as_Ltyrian_LocationDetails$LocationPathDetails(x$0);
    if ((this.Ltyrian_LocationDetails$LocationPathDetails__f_path === $n(x$0$2).Ltyrian_LocationDetails$LocationPathDetails__f_path)) {
      var x = this.Ltyrian_LocationDetails$LocationPathDetails__f_search;
      var x$2 = $n(x$0$2).Ltyrian_LocationDetails$LocationPathDetails__f_search;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Ltyrian_LocationDetails$LocationPathDetails__f_hash;
      var x$4 = $n(x$0$2).Ltyrian_LocationDetails$LocationPathDetails__f_hash;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.productArity__I = (function() {
  return 3;
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.productPrefix__T = (function() {
  return "LocationPathDetails";
});
$c_Ltyrian_LocationDetails$LocationPathDetails.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_LocationDetails$LocationPathDetails__f_path;
      break;
    }
    case 1: {
      return this.Ltyrian_LocationDetails$LocationPathDetails__f_search;
      break;
    }
    case 2: {
      return this.Ltyrian_LocationDetails$LocationPathDetails__f_hash;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_LocationDetails$LocationPathDetails(obj) {
  return (((obj instanceof $c_Ltyrian_LocationDetails$LocationPathDetails) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.LocationDetails$LocationPathDetails"));
}
function $isArrayOf_Ltyrian_LocationDetails$LocationPathDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_LocationDetails$LocationPathDetails)));
}
function $asArrayOf_Ltyrian_LocationDetails$LocationPathDetails(obj, depth) {
  return (($isArrayOf_Ltyrian_LocationDetails$LocationPathDetails(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.LocationDetails$LocationPathDetails;", depth));
}
var $d_Ltyrian_LocationDetails$LocationPathDetails = new $TypeData().initClass($c_Ltyrian_LocationDetails$LocationPathDetails, "tyrian.LocationDetails$LocationPathDetails", ({
  Ltyrian_LocationDetails$LocationPathDetails: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_Renderer(vnode, state) {
  this.Ltyrian_runtime_Renderer__f_vnode = null;
  this.Ltyrian_runtime_Renderer__f_state = null;
  this.Ltyrian_runtime_Renderer__f_vnode = vnode;
  this.Ltyrian_runtime_Renderer__f_state = state;
}
$c_Ltyrian_runtime_Renderer.prototype = new $h_O();
$c_Ltyrian_runtime_Renderer.prototype.constructor = $c_Ltyrian_runtime_Renderer;
/** @constructor */
function $h_Ltyrian_runtime_Renderer() {
}
$h_Ltyrian_runtime_Renderer.prototype = $c_Ltyrian_runtime_Renderer.prototype;
$c_Ltyrian_runtime_Renderer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_runtime_Renderer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_runtime_Renderer.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_runtime_Renderer)) {
    var x$0$2 = $as_Ltyrian_runtime_Renderer(x$0);
    var x = this.Ltyrian_runtime_Renderer__f_vnode;
    var x$2 = $n(x$0$2).Ltyrian_runtime_Renderer__f_vnode;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_runtime_Renderer__f_state;
      var x$4 = $n(x$0$2).Ltyrian_runtime_Renderer__f_state;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_Renderer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_runtime_Renderer.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_runtime_Renderer.prototype.productPrefix__T = (function() {
  return "Renderer";
});
$c_Ltyrian_runtime_Renderer.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_runtime_Renderer__f_vnode;
  }
  if ((n === 1)) {
    return this.Ltyrian_runtime_Renderer__f_state;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_runtime_Renderer.prototype.runningAt__J__Ltyrian_runtime_Renderer = (function(t_$_lo, t_$_hi) {
  var state$1 = new $c_Ltyrian_runtime_RendererState$Running(t_$_lo, t_$_hi);
  var vnode$1 = this.Ltyrian_runtime_Renderer__f_vnode;
  return new $c_Ltyrian_runtime_Renderer(vnode$1, state$1);
});
function $as_Ltyrian_runtime_Renderer(obj) {
  return (((obj instanceof $c_Ltyrian_runtime_Renderer) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.runtime.Renderer"));
}
function $isArrayOf_Ltyrian_runtime_Renderer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_runtime_Renderer)));
}
function $asArrayOf_Ltyrian_runtime_Renderer(obj, depth) {
  return (($isArrayOf_Ltyrian_runtime_Renderer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.runtime.Renderer;", depth));
}
var $d_Ltyrian_runtime_Renderer = new $TypeData().initClass($c_Ltyrian_runtime_Renderer, "tyrian.runtime.Renderer", ({
  Ltyrian_runtime_Renderer: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $f_Lcats_ComposedFunctor__map__O__F1__O($thiz, fga, f) {
  return $n($thiz.Lcats_Functor$$anon$1__f_F).map__O__F1__O(fga, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ga) => $n($thiz.Lcats_Functor$$anon$1__f_G).map__O__F1__O(ga, f))));
}
/** @constructor */
function $c_Lcats_Eval$Ident(ev) {
  this.Lcats_Eval$Ident__f_ev = null;
  this.Lcats_Eval$Ident__f_ev = ev;
}
$c_Lcats_Eval$Ident.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Ident.prototype.constructor = $c_Lcats_Eval$Ident;
/** @constructor */
function $h_Lcats_Eval$Ident() {
}
$h_Lcats_Eval$Ident.prototype = $c_Lcats_Eval$Ident.prototype;
$c_Lcats_Eval$Ident.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Eval$Ident.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_Eval$Ident.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Eval$Ident)) {
    var x$0$2 = $as_Lcats_Eval$Ident(x$0);
    var x = this.Lcats_Eval$Ident__f_ev;
    var x$2 = $n(x$0$2).Lcats_Eval$Ident__f_ev;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lcats_Eval$Ident.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Eval$Ident.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_Eval$Ident.prototype.productPrefix__T = (function() {
  return "Ident";
});
$c_Lcats_Eval$Ident.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Ident__f_ev;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_Eval$Ident(obj) {
  return (((obj instanceof $c_Lcats_Eval$Ident) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Ident"));
}
function $isArrayOf_Lcats_Eval$Ident(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Ident)));
}
function $asArrayOf_Lcats_Eval$Ident(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Ident(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Ident;", depth));
}
var $d_Lcats_Eval$Ident = new $TypeData().initClass($c_Lcats_Eval$Ident, "cats.Eval$Ident", ({
  Lcats_Eval$Ident: 1,
  Lcats_Eval$FnStack: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$Many(first, rest) {
  this.Lcats_Eval$Many__f_first = null;
  this.Lcats_Eval$Many__f_rest = null;
  this.Lcats_Eval$Many__f_first = first;
  this.Lcats_Eval$Many__f_rest = rest;
}
$c_Lcats_Eval$Many.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Many.prototype.constructor = $c_Lcats_Eval$Many;
/** @constructor */
function $h_Lcats_Eval$Many() {
}
$h_Lcats_Eval$Many.prototype = $c_Lcats_Eval$Many.prototype;
$c_Lcats_Eval$Many.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Eval$Many.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_Eval$Many.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Eval$Many)) {
    var x$0$2 = $as_Lcats_Eval$Many(x$0);
    var x = this.Lcats_Eval$Many__f_first;
    var x$2 = $n(x$0$2).Lcats_Eval$Many__f_first;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_Eval$Many__f_rest;
      var x$4 = $n(x$0$2).Lcats_Eval$Many__f_rest;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_Eval$Many.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Eval$Many.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_Eval$Many.prototype.productPrefix__T = (function() {
  return "Many";
});
$c_Lcats_Eval$Many.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Many__f_first;
  }
  if ((n === 1)) {
    return this.Lcats_Eval$Many__f_rest;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_Eval$Many(obj) {
  return (((obj instanceof $c_Lcats_Eval$Many) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Many"));
}
function $isArrayOf_Lcats_Eval$Many(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Many)));
}
function $asArrayOf_Lcats_Eval$Many(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Many(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Many;", depth));
}
var $d_Lcats_Eval$Many = new $TypeData().initClass($c_Lcats_Eval$Many, "cats.Eval$Many", ({
  Lcats_Eval$Many: 1,
  Lcats_Eval$FnStack: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Eval$Memoize(eval$1) {
  this.Lcats_Eval$Memoize__f_eval = null;
  this.Lcats_Eval$Memoize__f_result = null;
  this.Lcats_Eval$Memoize__f_eval = eval$1;
  this.Lcats_Eval$Memoize__f_result = $m_s_None$();
}
$c_Lcats_Eval$Memoize.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Memoize.prototype.constructor = $c_Lcats_Eval$Memoize;
/** @constructor */
function $h_Lcats_Eval$Memoize() {
}
$h_Lcats_Eval$Memoize.prototype = $c_Lcats_Eval$Memoize.prototype;
$c_Lcats_Eval$Memoize.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Eval$Memoize.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_Eval$Memoize.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Eval$Memoize)) {
    var x$0$2 = $as_Lcats_Eval$Memoize(x$0);
    var x = this.Lcats_Eval$Memoize__f_eval;
    var x$2 = $n(x$0$2).Lcats_Eval$Memoize__f_eval;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_Eval$Memoize.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Eval$Memoize.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_Eval$Memoize.prototype.productPrefix__T = (function() {
  return "Memoize";
});
$c_Lcats_Eval$Memoize.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Memoize__f_eval;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_Eval$Memoize.prototype.memoize__Lcats_Eval = (function() {
  return this;
});
$c_Lcats_Eval$Memoize.prototype.value__O = (function() {
  var x12 = this.Lcats_Eval$Memoize__f_result;
  if ((x12 instanceof $c_s_Some)) {
    var a = $n($as_s_Some(x12)).s_Some__f_value;
    return a;
  }
  var x = $m_s_None$();
  if ((x === x12)) {
    var a$2 = $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this);
    this.Lcats_Eval$Memoize__f_result = new $c_s_Some(a$2);
    return a$2;
  }
  throw new $c_s_MatchError(x12);
});
function $as_Lcats_Eval$Memoize(obj) {
  return (((obj instanceof $c_Lcats_Eval$Memoize) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Memoize"));
}
function $isArrayOf_Lcats_Eval$Memoize(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Memoize)));
}
function $asArrayOf_Lcats_Eval$Memoize(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Memoize(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Memoize;", depth));
}
var $d_Lcats_Eval$Memoize = new $TypeData().initClass($c_Lcats_Eval$Memoize, "cats.Eval$Memoize", ({
  Lcats_Eval$Memoize: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
function $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(self, current) {
  var current$tailLocal1 = current;
  var self$tailLocal1 = self;
  while (true) {
    var x31 = self$tailLocal1;
    if ((x31 instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1 = $as_Lcats_data_AndThen$Single(x31);
      var this$2 = $n(x$1);
      var x50 = this$2.Lcats_data_AndThen$Single__f_f;
      $n(x$1);
      return $n(x50).apply__O__O(current$tailLocal1);
    }
    if ((x31 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$1 = $as_Lcats_data_AndThen$Concat(x31);
      var this$5 = $n(x$1$1);
      var x42 = this$5.Lcats_data_AndThen$Concat__f_left;
      var this$6 = $n(x$1$1);
      var x43 = this$6.Lcats_data_AndThen$Concat__f_right;
      if ((x42 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$2 = $as_Lcats_data_AndThen$Single(x42);
        var this$8 = $n(x$1$2);
        var x46 = this$8.Lcats_data_AndThen$Single__f_f;
        $n(x$1$2);
        var current$tailLocal1$tmp1 = $n(x46).apply__O__O(current$tailLocal1);
        self$tailLocal1 = x43;
        current$tailLocal1 = current$tailLocal1$tmp1;
        continue;
      }
    }
    if ((x31 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$3 = $as_Lcats_data_AndThen$Concat(x31);
      var this$11 = $n(x$1$3);
      var x34 = this$11.Lcats_data_AndThen$Concat__f_left;
      var this$12 = $n(x$1$3);
      var x35 = this$12.Lcats_data_AndThen$Concat__f_right;
      if ((x34 instanceof $c_Lcats_data_AndThen$Concat)) {
        var x$1$4 = $as_Lcats_data_AndThen$Concat(x34);
        $n(x$1$4);
        $n(x$1$4);
        var left = $as_Lcats_data_AndThen$Concat(x34);
        var this$16 = $n(left);
        self$tailLocal1 = $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(this$16, x35);
        continue;
      }
    }
    throw new $c_s_MatchError(x31);
  }
}
function $ps_Lcats_data_AndThen__loop$2__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(left, right) {
  var right$tailLocal1 = right;
  var left$tailLocal1 = left;
  while (true) {
    var x52 = left$tailLocal1;
    if ((x52 instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1 = $as_Lcats_data_AndThen$Concat(x52);
      var this$2 = $n(x$1);
      var x55 = this$2.Lcats_data_AndThen$Concat__f_left;
      var this$3 = $n(x$1);
      var x56 = this$3.Lcats_data_AndThen$Concat__f_right;
      var right$1 = right$tailLocal1;
      var right$tailLocal1$tmp1 = new $c_Lcats_data_AndThen$Concat(x56, right$1);
      left$tailLocal1 = x55;
      right$tailLocal1 = right$tailLocal1$tmp1;
      continue;
    }
    var right$2 = right$tailLocal1;
    return new $c_Lcats_data_AndThen$Concat(x52, right$2);
  }
}
/** @constructor */
function $c_Lcats_data_AndThen() {
}
$c_Lcats_data_AndThen.prototype = new $h_O();
$c_Lcats_data_AndThen.prototype.constructor = $c_Lcats_data_AndThen;
/** @constructor */
function $h_Lcats_data_AndThen() {
}
$h_Lcats_data_AndThen.prototype = $c_Lcats_data_AndThen.prototype;
$c_Lcats_data_AndThen.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_AndThen.prototype.apply__O__O = (function(a) {
  return $ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(this, a);
});
$c_Lcats_data_AndThen.prototype.andThen__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    var atg = $as_Lcats_data_AndThen(g);
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(this, atg);
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1 = $as_Lcats_data_AndThen$Single(this);
      var this$2 = $n(x$1);
      var x12 = this$2.Lcats_data_AndThen$Single__f_f;
      var this$3 = $n(x$1);
      var x13 = this$3.Lcats_data_AndThen$Single__f_index;
      if ((x13 < 128)) {
        var f = $n(x12).andThen__F1__F1(g);
        var index = ((1 + x13) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index);
      }
    }
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$1 = $as_Lcats_data_AndThen$Concat(this);
      var this$6 = $n(x$1$1);
      var x4 = this$6.Lcats_data_AndThen$Concat__f_left;
      var this$7 = $n(x$1$1);
      var x5 = this$7.Lcats_data_AndThen$Concat__f_right;
      if ((x5 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$2 = $as_Lcats_data_AndThen$Single(x5);
        var this$9 = $n(x$1$2);
        var x8 = this$9.Lcats_data_AndThen$Single__f_f;
        var this$10 = $n(x$1$2);
        var x9 = this$10.Lcats_data_AndThen$Single__f_index;
        if ((x9 < 128)) {
          var f$1 = $n(x8).andThen__F1__F1(g);
          var index$1 = ((1 + x9) | 0);
          var right = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(x4, right);
        }
      }
    }
    var right$1 = new $c_Lcats_data_AndThen$Single(g, 0);
    return new $c_Lcats_data_AndThen$Concat(this, right$1);
  }
});
$c_Lcats_data_AndThen.prototype.compose__F1__Lcats_data_AndThen = (function(g) {
  if ((g instanceof $c_Lcats_data_AndThen)) {
    var atg = $as_Lcats_data_AndThen(g);
    return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(atg, this);
  } else {
    if ((this instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1 = $as_Lcats_data_AndThen$Single(this);
      var this$2 = $n(x$1);
      var x27 = this$2.Lcats_data_AndThen$Single__f_f;
      var this$3 = $n(x$1);
      var x28 = this$3.Lcats_data_AndThen$Single__f_index;
      if ((x28 < 128)) {
        var f = $n(x27).compose__F1__F1(g);
        var index = ((1 + x28) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index);
      }
    }
    if ((this instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$1 = $as_Lcats_data_AndThen$Concat(this);
      var this$6 = $n(x$1$1);
      var x19 = this$6.Lcats_data_AndThen$Concat__f_left;
      var this$7 = $n(x$1$1);
      var x20 = this$7.Lcats_data_AndThen$Concat__f_right;
      if ((x19 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$2 = $as_Lcats_data_AndThen$Single(x19);
        var this$9 = $n(x$1$2);
        var x23 = this$9.Lcats_data_AndThen$Single__f_f;
        var this$10 = $n(x$1$2);
        var x24 = this$10.Lcats_data_AndThen$Single__f_index;
        if ((x24 < 128)) {
          var f$1 = $n(x23).compose__F1__F1(g);
          var index$1 = ((1 + x24) | 0);
          var left = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(left, x20);
        }
      }
    }
    var left$1 = new $c_Lcats_data_AndThen$Single(g, 0);
    return new $c_Lcats_data_AndThen$Concat(left$1, this);
  }
});
$c_Lcats_data_AndThen.prototype.toString__T = (function() {
  return ("AndThen$" + $systemIdentityHashCode(this));
});
$c_Lcats_data_AndThen.prototype.andThen__F1__F1 = (function(g) {
  return this.andThen__F1__Lcats_data_AndThen(g);
});
$c_Lcats_data_AndThen.prototype.compose__F1__F1 = (function(g) {
  return this.compose__F1__Lcats_data_AndThen(g);
});
$c_Lcats_data_AndThen.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($ps_Lcats_data_AndThen__loop$1__Lcats_data_AndThen__O__O(this, v1));
});
function $as_Lcats_data_AndThen(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen"));
}
function $isArrayOf_Lcats_data_AndThen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen)));
}
function $asArrayOf_Lcats_data_AndThen(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen;", depth));
}
/** @constructor */
function $c_Lcats_data_AndThen$() {
  $ct_Lcats_data_AndThenInstances0__(this);
}
$c_Lcats_data_AndThen$.prototype = new $h_Lcats_data_AndThenInstances0();
$c_Lcats_data_AndThen$.prototype.constructor = $c_Lcats_data_AndThen$;
/** @constructor */
function $h_Lcats_data_AndThen$() {
}
$h_Lcats_data_AndThen$.prototype = $c_Lcats_data_AndThen$.prototype;
$c_Lcats_data_AndThen$.prototype.apply__F1__Lcats_data_AndThen = (function(f) {
  if ((f instanceof $c_Lcats_data_AndThen)) {
    var ref = $as_Lcats_data_AndThen(f);
    return ref;
  } else {
    return new $c_Lcats_data_AndThen$Single(f, 0);
  }
});
$c_Lcats_data_AndThen$.prototype.andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen = (function(ab, bc) {
  if ((ab instanceof $c_Lcats_data_AndThen$Single)) {
    var x$1 = $as_Lcats_data_AndThen$Single(ab);
    var this$2 = $n(x$1);
    var x177 = this$2.Lcats_data_AndThen$Single__f_f;
    var this$3 = $n(x$1);
    var x178 = this$3.Lcats_data_AndThen$Single__f_index;
    if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1$1 = $as_Lcats_data_AndThen$Single(bc);
      var this$5 = $n(x$1$1);
      var x151 = this$5.Lcats_data_AndThen$Single__f_f;
      var this$6 = $n(x$1$1);
      var x152 = this$6.Lcats_data_AndThen$Single__f_index;
      if ((((x178 + x152) | 0) < 128)) {
        var f = $n(x177).andThen__F1__F1(x151);
        var index = ((1 + ((x178 + x152) | 0)) | 0);
        return new $c_Lcats_data_AndThen$Single(f, index);
      } else {
        return new $c_Lcats_data_AndThen$Concat(ab, bc);
      }
    }
    if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
      var x$1$2 = $as_Lcats_data_AndThen$Concat(bc);
      var this$10 = $n(x$1$2);
      var x143 = this$10.Lcats_data_AndThen$Concat__f_left;
      var this$11 = $n(x$1$2);
      var x144 = this$11.Lcats_data_AndThen$Concat__f_right;
      if ((x143 instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$3 = $as_Lcats_data_AndThen$Single(x143);
        var this$13 = $n(x$1$3);
        var x147 = this$13.Lcats_data_AndThen$Single__f_f;
        var this$14 = $n(x$1$3);
        var x148 = this$14.Lcats_data_AndThen$Single__f_index;
        if ((((x178 + x148) | 0) < 128)) {
          var f$1 = $n(x177).andThen__F1__F1(x147);
          var index$1 = ((1 + ((x178 + x148) | 0)) | 0);
          var left = new $c_Lcats_data_AndThen$Single(f$1, index$1);
          return new $c_Lcats_data_AndThen$Concat(left, x144);
        }
      }
    }
    return new $c_Lcats_data_AndThen$Concat(ab, bc);
  }
  if ((ab instanceof $c_Lcats_data_AndThen$Concat)) {
    var x$1$4 = $as_Lcats_data_AndThen$Concat(ab);
    var this$19 = $n(x$1$4);
    var x169 = this$19.Lcats_data_AndThen$Concat__f_left;
    var this$20 = $n(x$1$4);
    var x170 = this$20.Lcats_data_AndThen$Concat__f_right;
    if ((x170 instanceof $c_Lcats_data_AndThen$Single)) {
      var x$1$5 = $as_Lcats_data_AndThen$Single(x170);
      var this$22 = $n(x$1$5);
      var x173 = this$22.Lcats_data_AndThen$Single__f_f;
      var this$23 = $n(x$1$5);
      var x174 = this$23.Lcats_data_AndThen$Single__f_index;
      if ((bc instanceof $c_Lcats_data_AndThen$Single)) {
        var x$1$6 = $as_Lcats_data_AndThen$Single(bc);
        var this$25 = $n(x$1$6);
        var x164 = this$25.Lcats_data_AndThen$Single__f_f;
        var this$26 = $n(x$1$6);
        var x165 = this$26.Lcats_data_AndThen$Single__f_index;
        if ((((x174 + x165) | 0) < 128)) {
          var f$2 = $n(x173).andThen__F1__F1(x164);
          var index$2 = ((1 + ((x174 + x165) | 0)) | 0);
          var right = new $c_Lcats_data_AndThen$Single(f$2, index$2);
          return new $c_Lcats_data_AndThen$Concat(x169, right);
        } else {
          return new $c_Lcats_data_AndThen$Concat(ab, bc);
        }
      }
      if ((bc instanceof $c_Lcats_data_AndThen$Concat)) {
        var x$1$7 = $as_Lcats_data_AndThen$Concat(bc);
        var this$31 = $n(x$1$7);
        var x156 = this$31.Lcats_data_AndThen$Concat__f_left;
        var this$32 = $n(x$1$7);
        var x157 = this$32.Lcats_data_AndThen$Concat__f_right;
        if ((x156 instanceof $c_Lcats_data_AndThen$Single)) {
          var x$1$8 = $as_Lcats_data_AndThen$Single(x156);
          var this$34 = $n(x$1$8);
          var x160 = this$34.Lcats_data_AndThen$Single__f_f;
          var this$35 = $n(x$1$8);
          var x161 = this$35.Lcats_data_AndThen$Single__f_index;
          if ((((x174 + x161) | 0) < 128)) {
            var f$3 = $n(x173).andThen__F1__F1(x160);
            var index$3 = ((1 + ((x174 + x161) | 0)) | 0);
            var left$1 = new $c_Lcats_data_AndThen$Single(f$3, index$3);
            var right$1 = new $c_Lcats_data_AndThen$Concat(left$1, x157);
            return new $c_Lcats_data_AndThen$Concat(x169, right$1);
          }
        }
      }
      return new $c_Lcats_data_AndThen$Concat(ab, bc);
    }
  }
  return new $c_Lcats_data_AndThen$Concat(ab, bc);
});
var $d_Lcats_data_AndThen$ = new $TypeData().initClass($c_Lcats_data_AndThen$, "cats.data.AndThen$", ({
  Lcats_data_AndThen$: 1,
  Lcats_data_AndThenInstances0: 1,
  Lcats_data_AndThenInstances1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_data_AndThen$;
function $m_Lcats_data_AndThen$() {
  if ((!$n_Lcats_data_AndThen$)) {
    $n_Lcats_data_AndThen$ = new $c_Lcats_data_AndThen$();
  }
  return $n_Lcats_data_AndThen$;
}
/** @constructor */
function $c_Lcats_data_KleisliInstances5() {
}
$c_Lcats_data_KleisliInstances5.prototype = new $h_Lcats_data_KleisliInstances6();
$c_Lcats_data_KleisliInstances5.prototype.constructor = $c_Lcats_data_KleisliInstances5;
/** @constructor */
function $h_Lcats_data_KleisliInstances5() {
}
$h_Lcats_data_KleisliInstances5.prototype = $c_Lcats_data_KleisliInstances5.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyList(head, tail) {
  this.Lcats_data_NonEmptyList__f_head = null;
  this.Lcats_data_NonEmptyList__f_tail = null;
  this.Lcats_data_NonEmptyList__f_head = head;
  this.Lcats_data_NonEmptyList__f_tail = tail;
}
$c_Lcats_data_NonEmptyList.prototype = new $h_O();
$c_Lcats_data_NonEmptyList.prototype.constructor = $c_Lcats_data_NonEmptyList;
/** @constructor */
function $h_Lcats_data_NonEmptyList() {
}
$h_Lcats_data_NonEmptyList.prototype = $c_Lcats_data_NonEmptyList.prototype;
$c_Lcats_data_NonEmptyList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_NonEmptyList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_NonEmptyList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_NonEmptyList)) {
    var x$0$2 = $as_Lcats_data_NonEmptyList(x$0);
    var x = this.Lcats_data_NonEmptyList__f_head;
    var y = $n(x$0$2).Lcats_data_NonEmptyList__f_head;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lcats_data_NonEmptyList__f_tail;
      var x$2 = $n(x$0$2).Lcats_data_NonEmptyList__f_tail;
      return ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_data_NonEmptyList.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_NonEmptyList.prototype.productPrefix__T = (function() {
  return "NonEmptyList";
});
$c_Lcats_data_NonEmptyList.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_NonEmptyList__f_head;
  }
  if ((n === 1)) {
    return this.Lcats_data_NonEmptyList__f_tail;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_NonEmptyList.prototype.size__I = (function() {
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  return ((1 + this$1.length__I()) | 0);
});
$c_Lcats_data_NonEmptyList.prototype.map__F1__Lcats_data_NonEmptyList = (function(f) {
  $m_Lcats_data_NonEmptyList$();
  var head = $n(f).apply__O__O(this.Lcats_data_NonEmptyList__f_head);
  var tail = $n(this.Lcats_data_NonEmptyList__f_tail).map__F1__sci_List(f);
  return new $c_Lcats_data_NonEmptyList(head, tail);
});
$c_Lcats_data_NonEmptyList.prototype.concat__sci_List__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var tail = $n(other).$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail);
});
$c_Lcats_data_NonEmptyList.prototype.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var this$1 = $n(other);
  var this$2 = $n(this$1.Lcats_data_NonEmptyList__f_tail);
  var elem = this$1.Lcats_data_NonEmptyList__f_head;
  var tail = new $c_sci_$colon$colon(elem, this$2).$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail);
});
$c_Lcats_data_NonEmptyList.prototype.flatMap__F1__Lcats_data_NonEmptyList = (function(f) {
  var this$5 = $n($as_Lcats_data_NonEmptyList($n(f).apply__O__O(this.Lcats_data_NonEmptyList__f_head)));
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = $n(rest).head__O();
    var this$2 = $n($as_Lcats_data_NonEmptyList($n(f).apply__O__O(x0)));
    var this$3 = $n(this$2.Lcats_data_NonEmptyList__f_tail);
    var elem = this$2.Lcats_data_NonEmptyList__f_head;
    var this$4 = new $c_sci_$colon$colon(elem, this$3);
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        $n(t).sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = $as_sci_List($n(rest).tail__O());
  }
  var l = ((h === null) ? $m_sci_Nil$() : h);
  return this$5.concat__sci_List__Lcats_data_NonEmptyList(l);
});
$c_Lcats_data_NonEmptyList.prototype.prepend__O__Lcats_data_NonEmptyList = (function(a) {
  $m_Lcats_data_NonEmptyList$();
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var elem = this.Lcats_data_NonEmptyList__f_head;
  var tail = new $c_sci_$colon$colon(elem, this$1);
  return new $c_Lcats_data_NonEmptyList(a, tail);
});
$c_Lcats_data_NonEmptyList.prototype.foldRight__Lcats_Eval__F2__Lcats_Eval = (function(lb, f) {
  $m_Lcats_UnorderedFoldable$();
  var instance = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  var $x_1 = $n(instance);
  var this$3 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return $x_1.foldRight__O__Lcats_Eval__F2__Lcats_Eval(new $c_sci_$colon$colon(elem, this$3), lb, f);
});
$c_Lcats_data_NonEmptyList.prototype.traverse__F1__Lcats_Applicative__O = (function(f, G) {
  var $x_1 = $n(f).apply__O__O(this.Lcats_data_NonEmptyList__f_head);
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    $m_Lcats_UnorderedFoldable$();
    var instance = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    return $n(instance).traverse__O__F1__Lcats_Applicative__O(this.Lcats_data_NonEmptyList__f_tail, f, G);
  }));
  return $n($n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($x_1, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$2, _$3) => {
    var _$3$1 = $as_sci_List(_$3);
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(_$2, _$3$1);
  })))).value__O();
});
$c_Lcats_data_NonEmptyList.prototype.toString__T = (function() {
  var this$1 = $n(this.Lcats_data_NonEmptyList__f_tail);
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return ("NonEmpty" + new $c_sci_$colon$colon(elem, this$1));
});
function $as_Lcats_data_NonEmptyList(obj) {
  return (((obj instanceof $c_Lcats_data_NonEmptyList) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.NonEmptyList"));
}
function $isArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_NonEmptyList)));
}
function $asArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (($isArrayOf_Lcats_data_NonEmptyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.NonEmptyList;", depth));
}
var $d_Lcats_data_NonEmptyList = new $TypeData().initClass($c_Lcats_data_NonEmptyList, "cats.data.NonEmptyList", ({
  Lcats_data_NonEmptyList: 1,
  Lcats_data_NonEmptyCollection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_StrictConstFunction1(a) {
  this.Lcats_data_StrictConstFunction1__f_a = null;
  this.Lcats_data_StrictConstFunction1__f_a = a;
}
$c_Lcats_data_StrictConstFunction1.prototype = new $h_O();
$c_Lcats_data_StrictConstFunction1.prototype.constructor = $c_Lcats_data_StrictConstFunction1;
/** @constructor */
function $h_Lcats_data_StrictConstFunction1() {
}
$h_Lcats_data_StrictConstFunction1.prototype = $c_Lcats_data_StrictConstFunction1.prototype;
$c_Lcats_data_StrictConstFunction1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lcats_data_StrictConstFunction1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_StrictConstFunction1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_StrictConstFunction1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_StrictConstFunction1)) {
    var x$0$2 = $as_Lcats_data_StrictConstFunction1(x$0);
    var x = this.Lcats_data_StrictConstFunction1__f_a;
    var y = $n(x$0$2).Lcats_data_StrictConstFunction1__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_StrictConstFunction1.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_StrictConstFunction1.prototype.productPrefix__T = (function() {
  return "StrictConstFunction1";
});
$c_Lcats_data_StrictConstFunction1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_StrictConstFunction1__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_StrictConstFunction1.prototype.apply__O__O = (function(arg) {
  return this.Lcats_data_StrictConstFunction1__f_a;
});
$c_Lcats_data_StrictConstFunction1.prototype.andThen__F1__F1 = (function(g) {
  if ((g instanceof $c_Lcats_data_StrictConstFunction1)) {
    var g$2 = $as_Lcats_data_StrictConstFunction1(g);
    return g$2;
  } else {
    var a = $n(g).apply__O__O(this.Lcats_data_StrictConstFunction1__f_a);
    return new $c_Lcats_data_StrictConstFunction1(a);
  }
});
$c_Lcats_data_StrictConstFunction1.prototype.compose__F1__F1 = (function(g) {
  return this;
});
$c_Lcats_data_StrictConstFunction1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.Lcats_data_StrictConstFunction1__f_a);
});
function $as_Lcats_data_StrictConstFunction1(obj) {
  return (((obj instanceof $c_Lcats_data_StrictConstFunction1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.StrictConstFunction1"));
}
function $isArrayOf_Lcats_data_StrictConstFunction1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_StrictConstFunction1)));
}
function $asArrayOf_Lcats_data_StrictConstFunction1(obj, depth) {
  return (($isArrayOf_Lcats_data_StrictConstFunction1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.StrictConstFunction1;", depth));
}
var $d_Lcats_data_StrictConstFunction1 = new $TypeData().initClass($c_Lcats_data_StrictConstFunction1, "cats.data.StrictConstFunction1", ({
  Lcats_data_StrictConstFunction1: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_Validated$Valid(a) {
  this.Lcats_data_Validated$Valid__f_a = null;
  this.Lcats_data_Validated$Valid__f_a = a;
}
$c_Lcats_data_Validated$Valid.prototype = new $h_Lcats_data_Validated();
$c_Lcats_data_Validated$Valid.prototype.constructor = $c_Lcats_data_Validated$Valid;
/** @constructor */
function $h_Lcats_data_Validated$Valid() {
}
$h_Lcats_data_Validated$Valid.prototype = $c_Lcats_data_Validated$Valid.prototype;
$c_Lcats_data_Validated$Valid.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_Validated$Valid.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_Validated$Valid)) {
    var x$0$2 = $as_Lcats_data_Validated$Valid(x$0);
    var x = this.Lcats_data_Validated$Valid__f_a;
    var y = $n(x$0$2).Lcats_data_Validated$Valid__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_Validated$Valid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_Validated$Valid.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Validated$Valid.prototype.productPrefix__T = (function() {
  return "Valid";
});
$c_Lcats_data_Validated$Valid.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Validated$Valid__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_Validated$Valid(obj) {
  return (((obj instanceof $c_Lcats_data_Validated$Valid) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Validated$Valid"));
}
function $isArrayOf_Lcats_data_Validated$Valid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated$Valid)));
}
function $asArrayOf_Lcats_data_Validated$Valid(obj, depth) {
  return (($isArrayOf_Lcats_data_Validated$Valid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Validated$Valid;", depth));
}
var $d_Lcats_data_Validated$Valid = new $TypeData().initClass($c_Lcats_data_Validated$Valid, "cats.data.Validated$Valid", ({
  Lcats_data_Validated$Valid: 1,
  Lcats_data_Validated: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$$anon$1(finalizer$7) {
  this.Lcats_effect_IO$$anon$1__f_finalizer$2 = null;
  this.Lcats_effect_IO$$anon$1__f_finalizer$2 = finalizer$7;
}
$c_Lcats_effect_IO$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_IO$$anon$1.prototype.constructor = $c_Lcats_effect_IO$$anon$1;
/** @constructor */
function $h_Lcats_effect_IO$$anon$1() {
}
$h_Lcats_effect_IO$$anon$1.prototype = $c_Lcats_effect_IO$$anon$1.prototype;
$c_Lcats_effect_IO$$anon$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lcats_effect_IO$$anon$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  var $x_1 = $n(this.Lcats_effect_IO$$anon$1__f_finalizer$2);
  var this$1 = $m_s_$less$colon$less$();
  return $x_1.reportError__s_$less$colon$less__Lcats_effect_IO(this$1.s_$less$colon$less$__f_singleton);
});
$c_Lcats_effect_IO$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x));
});
$c_Lcats_effect_IO$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1);
});
var $d_Lcats_effect_IO$$anon$1 = new $TypeData().initClass($c_Lcats_effect_IO$$anon$1, "cats.effect.IO$$anon$1", ({
  Lcats_effect_IO$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$$anon$2(finalizer$8) {
  this.Lcats_effect_IO$$anon$2__f_finalizer$5 = null;
  this.Lcats_effect_IO$$anon$2__f_finalizer$5 = finalizer$8;
}
$c_Lcats_effect_IO$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_IO$$anon$2.prototype.constructor = $c_Lcats_effect_IO$$anon$2;
/** @constructor */
function $h_Lcats_effect_IO$$anon$2() {
}
$h_Lcats_effect_IO$$anon$2.prototype = $c_Lcats_effect_IO$$anon$2.prototype;
$c_Lcats_effect_IO$$anon$2.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lcats_effect_IO$$anon$2.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  var $x_1 = $n($as_Lcats_effect_IO($n(this.Lcats_effect_IO$$anon$2__f_finalizer$5).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x))));
  var this$3 = $m_s_$less$colon$less$();
  return $x_1.reportError__s_$less$colon$less__Lcats_effect_IO(this$3.s_$less$colon$less$__f_singleton);
});
$c_Lcats_effect_IO$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x));
});
$c_Lcats_effect_IO$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1);
});
var $d_Lcats_effect_IO$$anon$2 = new $TypeData().initClass($c_Lcats_effect_IO$$anon$2, "cats.effect.IO$$anon$2", ({
  Lcats_effect_IO$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
function $p_Lcats_effect_IODeferred__clear$1__I__V($thiz, handle$1) {
  var stack = $thiz.Lcats_effect_IODeferred__f_callbacks;
  delete stack[handle$1];
  var removed = true;
  if ((!removed)) {
    var this$3 = $n($thiz.Lcats_effect_IODeferred__f_clearCounter);
    var newValue = ((1 + this$3.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value) | 0);
    this$3.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = newValue;
    if (((newValue & ((newValue - 1) | 0)) === 0)) {
      var this$6 = $n($thiz.Lcats_effect_IODeferred__f_clearCounter);
      var delta = ((-((newValue - newValue) | 0)) | 0);
      var newValue$1 = ((this$6.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value + delta) | 0);
      this$6.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = newValue$1;
    }
  }
}
/** @constructor */
function $c_Lcats_effect_IODeferred() {
  this.Lcats_effect_IODeferred__f_initial = null;
  this.Lcats_effect_IODeferred__f_cell = null;
  this.Lcats_effect_IODeferred__f_callbacks = null;
  this.Lcats_effect_IODeferred__f_clearCounter = null;
  var await$1 = $m_Lcats_effect_IO$().asyncCheckAttempt__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cb) => {
    var cb$1 = $as_F1(cb);
    var this$8 = $m_Lcats_effect_IO$();
    var thunk$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      var stack = this.Lcats_effect_IODeferred__f_callbacks;
      stack.push(cb$1);
      var handle = (($uI(stack.length) - 1) | 0);
      var back = $as_Lcats_effect_IO($n(this.Lcats_effect_IODeferred__f_cell).ju_concurrent_atomic_AtomicReference__f_value);
      if ((back === this.Lcats_effect_IODeferred__f_initial)) {
        var this$4 = $m_Lcats_effect_IO$();
        var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
          $p_Lcats_effect_IODeferred__clear$1__I__V(this, handle);
        }));
        var value = this$4.delay__F0__Lcats_effect_IO(thunk);
        var value$1 = new $c_s_Some(value);
        return new $c_s_util_Left(value$1);
      } else {
        $p_Lcats_effect_IODeferred__clear$1__I__V(this, handle);
        var value$2 = $n($as_Lcats_effect_IO$Pure(back)).Lcats_effect_IO$Pure__f_value;
        return new $c_s_util_Right(value$2);
      }
    }));
    return this$8.delay__F0__Lcats_effect_IO(thunk$1);
  })));
  this.Lcats_effect_IODeferred__f_initial = $m_Lcats_effect_IO$().defer__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var back$1 = $as_Lcats_effect_IO($n(this.Lcats_effect_IODeferred__f_cell).ju_concurrent_atomic_AtomicReference__f_value);
    return ((back$1 === this.Lcats_effect_IODeferred__f_initial) ? await$1 : back$1);
  })));
  this.Lcats_effect_IODeferred__f_cell = $ct_ju_concurrent_atomic_AtomicReference__O__(new $c_ju_concurrent_atomic_AtomicReference(), this.Lcats_effect_IODeferred__f_initial);
  this.Lcats_effect_IODeferred__f_callbacks = [null];
  this.Lcats_effect_IODeferred__f_clearCounter = $ct_ju_concurrent_atomic_AtomicInteger__(new $c_ju_concurrent_atomic_AtomicInteger());
}
$c_Lcats_effect_IODeferred.prototype = new $h_Lcats_effect_kernel_Deferred();
$c_Lcats_effect_IODeferred.prototype.constructor = $c_Lcats_effect_IODeferred;
/** @constructor */
function $h_Lcats_effect_IODeferred() {
}
$h_Lcats_effect_IODeferred.prototype = $c_Lcats_effect_IODeferred.prototype;
$c_Lcats_effect_IODeferred.prototype.complete__O__Lcats_effect_IO = (function(a) {
  var this$8 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    if ($n(this.Lcats_effect_IODeferred__f_cell).compareAndSet__O__O__Z(this.Lcats_effect_IODeferred__f_initial, ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Pure(a)))) {
      var stack = this.Lcats_effect_IODeferred__f_callbacks;
      var oc = new $c_s_util_Right(a);
      $uZ(stack.reduceRight($m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((acc, cb) => {
        var acc$1 = $uZ(acc);
        var cb$1 = $as_F1(cb);
        return ((cb$1 !== null) ? ($n(cb$1).apply__O__O(oc), true) : acc$1);
      }))), false));
      return true;
    } else {
      return false;
    }
  }));
  return this$8.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IODeferred.prototype.get__Lcats_effect_IO = (function() {
  return $as_Lcats_effect_IO($n(this.Lcats_effect_IODeferred__f_cell).ju_concurrent_atomic_AtomicReference__f_value);
});
$c_Lcats_effect_IODeferred.prototype.tryGet__Lcats_effect_IO = (function() {
  var this$3 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var back = $as_Lcats_effect_IO($n(this.Lcats_effect_IODeferred__f_cell).ju_concurrent_atomic_AtomicReference__f_value);
    if ((back === this.Lcats_effect_IODeferred__f_initial)) {
      return $m_s_None$();
    } else {
      var value = $n($as_Lcats_effect_IO$Pure(back)).Lcats_effect_IO$Pure__f_value;
      return new $c_s_Some(value);
    }
  }));
  return this$3.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IODeferred.prototype.complete__O__O = (function(a) {
  return this.complete__O__Lcats_effect_IO(a);
});
$c_Lcats_effect_IODeferred.prototype.get__O = (function() {
  return this.get__Lcats_effect_IO();
});
$c_Lcats_effect_IODeferred.prototype.tryGet__O = (function() {
  return this.tryGet__Lcats_effect_IO();
});
var $d_Lcats_effect_IODeferred = new $TypeData().initClass($c_Lcats_effect_IODeferred, "cats.effect.IODeferred", ({
  Lcats_effect_IODeferred: 1,
  Lcats_effect_kernel_Deferred: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_DeferredSource: 1,
  Lcats_effect_kernel_DeferredSink: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$() {
  this.Lcats_effect_SyncIO$__f__syncForSyncIO = null;
  this.Lcats_effect_SyncIO$__f_realTime = null;
  this.Lcats_effect_SyncIO$__f__unit = null;
  $n_Lcats_effect_SyncIO$ = this;
  this.Lcats_effect_SyncIO$__f__syncForSyncIO = new $c_Lcats_effect_SyncIO$SyncIOSync();
  this.Lcats_effect_SyncIO$__f_realTime = $m_Lcats_effect_SyncIO$RealTime$();
  this.Lcats_effect_SyncIO$__f__unit = new $c_Lcats_effect_SyncIO$Pure((void 0));
}
$c_Lcats_effect_SyncIO$.prototype = new $h_O();
$c_Lcats_effect_SyncIO$.prototype.constructor = $c_Lcats_effect_SyncIO$;
/** @constructor */
function $h_Lcats_effect_SyncIO$() {
}
$h_Lcats_effect_SyncIO$.prototype = $c_Lcats_effect_SyncIO$.prototype;
var $d_Lcats_effect_SyncIO$ = new $TypeData().initClass($c_Lcats_effect_SyncIO$, "cats.effect.SyncIO$", ({
  Lcats_effect_SyncIO$: 1,
  Lcats_effect_SyncIOCompanionPlatform: 1,
  Lcats_effect_SyncIOLowPriorityImplicits: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_effect_SyncIO$;
function $m_Lcats_effect_SyncIO$() {
  if ((!$n_Lcats_effect_SyncIO$)) {
    $n_Lcats_effect_SyncIO$ = new $c_Lcats_effect_SyncIO$();
  }
  return $n_Lcats_effect_SyncIO$;
}
/** @constructor */
function $c_Lcats_effect_SyncIO$Attempt(ioa) {
  this.Lcats_effect_SyncIO$Attempt__f_ioa = null;
  this.Lcats_effect_SyncIO$Attempt__f_ioa = ioa;
}
$c_Lcats_effect_SyncIO$Attempt.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Attempt.prototype.constructor = $c_Lcats_effect_SyncIO$Attempt;
/** @constructor */
function $h_Lcats_effect_SyncIO$Attempt() {
}
$h_Lcats_effect_SyncIO$Attempt.prototype = $c_Lcats_effect_SyncIO$Attempt.prototype;
$c_Lcats_effect_SyncIO$Attempt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Attempt.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Attempt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Attempt)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Attempt(x$0);
    var x = this.Lcats_effect_SyncIO$Attempt__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$Attempt__f_ioa;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productPrefix__T = (function() {
  return "Attempt";
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Attempt__f_ioa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Attempt.prototype.tag__B = (function() {
  return 8;
});
function $as_Lcats_effect_SyncIO$Attempt(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Attempt) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Attempt"));
}
function $isArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Attempt)));
}
function $asArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Attempt;", depth));
}
var $d_Lcats_effect_SyncIO$Attempt = new $TypeData().initClass($c_Lcats_effect_SyncIO$Attempt, "cats.effect.SyncIO$Attempt", ({
  Lcats_effect_SyncIO$Attempt: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$Error(t) {
  this.Lcats_effect_SyncIO$Error__f_t = null;
  this.Lcats_effect_SyncIO$Error__f_t = t;
}
$c_Lcats_effect_SyncIO$Error.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Error.prototype.constructor = $c_Lcats_effect_SyncIO$Error;
/** @constructor */
function $h_Lcats_effect_SyncIO$Error() {
}
$h_Lcats_effect_SyncIO$Error.prototype = $c_Lcats_effect_SyncIO$Error.prototype;
$c_Lcats_effect_SyncIO$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Error.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Error)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Error(x$0);
    var x = this.Lcats_effect_SyncIO$Error__f_t;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$Error__f_t;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Error.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Error.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Lcats_effect_SyncIO$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Error__f_t;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Error.prototype.tag__B = (function() {
  return 2;
});
function $as_Lcats_effect_SyncIO$Error(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Error) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Error"));
}
function $isArrayOf_Lcats_effect_SyncIO$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Error)));
}
function $asArrayOf_Lcats_effect_SyncIO$Error(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Error;", depth));
}
var $d_Lcats_effect_SyncIO$Error = new $TypeData().initClass($c_Lcats_effect_SyncIO$Error, "cats.effect.SyncIO$Error", ({
  Lcats_effect_SyncIO$Error: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$Failure(t) {
  this.Lcats_effect_SyncIO$Failure__f_t = null;
  this.Lcats_effect_SyncIO$Failure__f_t = t;
}
$c_Lcats_effect_SyncIO$Failure.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Failure.prototype.constructor = $c_Lcats_effect_SyncIO$Failure;
/** @constructor */
function $h_Lcats_effect_SyncIO$Failure() {
}
$h_Lcats_effect_SyncIO$Failure.prototype = $c_Lcats_effect_SyncIO$Failure.prototype;
$c_Lcats_effect_SyncIO$Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Failure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Failure)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Failure(x$0);
    var x = this.Lcats_effect_SyncIO$Failure__f_t;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$Failure__f_t;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Failure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Failure.prototype.productPrefix__T = (function() {
  return "Failure";
});
$c_Lcats_effect_SyncIO$Failure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Failure__f_t;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Failure.prototype.tag__B = (function() {
  return 7;
});
function $as_Lcats_effect_SyncIO$Failure(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Failure"));
}
function $isArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Failure)));
}
function $asArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Failure;", depth));
}
var $d_Lcats_effect_SyncIO$Failure = new $TypeData().initClass($c_Lcats_effect_SyncIO$Failure, "cats.effect.SyncIO$Failure", ({
  Lcats_effect_SyncIO$Failure: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$FlatMap(ioe, f) {
  this.Lcats_effect_SyncIO$FlatMap__f_ioe = null;
  this.Lcats_effect_SyncIO$FlatMap__f_f = null;
  this.Lcats_effect_SyncIO$FlatMap__f_ioe = ioe;
  this.Lcats_effect_SyncIO$FlatMap__f_f = f;
}
$c_Lcats_effect_SyncIO$FlatMap.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$FlatMap.prototype.constructor = $c_Lcats_effect_SyncIO$FlatMap;
/** @constructor */
function $h_Lcats_effect_SyncIO$FlatMap() {
}
$h_Lcats_effect_SyncIO$FlatMap.prototype = $c_Lcats_effect_SyncIO$FlatMap.prototype;
$c_Lcats_effect_SyncIO$FlatMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$FlatMap)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$FlatMap(x$0);
    var x = this.Lcats_effect_SyncIO$FlatMap__f_ioe;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$FlatMap__f_ioe;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_SyncIO$FlatMap__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_SyncIO$FlatMap__f_f;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productPrefix__T = (function() {
  return "FlatMap";
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$FlatMap__f_ioe;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$FlatMap__f_f;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.tag__B = (function() {
  return 4;
});
function $as_Lcats_effect_SyncIO$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$FlatMap"));
}
function $isArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$FlatMap)));
}
function $asArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$FlatMap;", depth));
}
var $d_Lcats_effect_SyncIO$FlatMap = new $TypeData().initClass($c_Lcats_effect_SyncIO$FlatMap, "cats.effect.SyncIO$FlatMap", ({
  Lcats_effect_SyncIO$FlatMap: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$HandleErrorWith(ioa, f) {
  this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa = null;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_f = null;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa = ioa;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_f = f;
}
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.constructor = $c_Lcats_effect_SyncIO$HandleErrorWith;
/** @constructor */
function $h_Lcats_effect_SyncIO$HandleErrorWith() {
}
$h_Lcats_effect_SyncIO$HandleErrorWith.prototype = $c_Lcats_effect_SyncIO$HandleErrorWith.prototype;
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$HandleErrorWith)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$HandleErrorWith(x$0);
    var x = this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_SyncIO$HandleErrorWith__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_SyncIO$HandleErrorWith__f_f;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productPrefix__T = (function() {
  return "HandleErrorWith";
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$HandleErrorWith__f_f;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.tag__B = (function() {
  return 5;
});
function $as_Lcats_effect_SyncIO$HandleErrorWith(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$HandleErrorWith) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$HandleErrorWith"));
}
function $isArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$HandleErrorWith)));
}
function $asArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$HandleErrorWith;", depth));
}
var $d_Lcats_effect_SyncIO$HandleErrorWith = new $TypeData().initClass($c_Lcats_effect_SyncIO$HandleErrorWith, "cats.effect.SyncIO$HandleErrorWith", ({
  Lcats_effect_SyncIO$HandleErrorWith: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
function $as_Lcats_effect_SyncIO$Map(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Map"));
}
function $isArrayOf_Lcats_effect_SyncIO$Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Map)));
}
function $asArrayOf_Lcats_effect_SyncIO$Map(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Map;", depth));
}
/** @constructor */
function $c_Lcats_effect_SyncIO$Pure(value) {
  this.Lcats_effect_SyncIO$Pure__f_value = null;
  this.Lcats_effect_SyncIO$Pure__f_value = value;
}
$c_Lcats_effect_SyncIO$Pure.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Pure.prototype.constructor = $c_Lcats_effect_SyncIO$Pure;
/** @constructor */
function $h_Lcats_effect_SyncIO$Pure() {
}
$h_Lcats_effect_SyncIO$Pure.prototype = $c_Lcats_effect_SyncIO$Pure.prototype;
$c_Lcats_effect_SyncIO$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Pure)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Pure(x$0);
    var x = this.Lcats_effect_SyncIO$Pure__f_value;
    var y = $n(x$0$2).Lcats_effect_SyncIO$Pure__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Pure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Pure.prototype.productPrefix__T = (function() {
  return "Pure";
});
$c_Lcats_effect_SyncIO$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Pure__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Pure.prototype.tag__B = (function() {
  return 0;
});
$c_Lcats_effect_SyncIO$Pure.prototype.toString__T = (function() {
  return (("SyncIO(" + this.Lcats_effect_SyncIO$Pure__f_value) + ")");
});
function $as_Lcats_effect_SyncIO$Pure(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Pure"));
}
function $isArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Pure)));
}
function $asArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Pure;", depth));
}
var $d_Lcats_effect_SyncIO$Pure = new $TypeData().initClass($c_Lcats_effect_SyncIO$Pure, "cats.effect.SyncIO$Pure", ({
  Lcats_effect_SyncIO$Pure: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$Success(value) {
  this.Lcats_effect_SyncIO$Success__f_value = null;
  this.Lcats_effect_SyncIO$Success__f_value = value;
}
$c_Lcats_effect_SyncIO$Success.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Success.prototype.constructor = $c_Lcats_effect_SyncIO$Success;
/** @constructor */
function $h_Lcats_effect_SyncIO$Success() {
}
$h_Lcats_effect_SyncIO$Success.prototype = $c_Lcats_effect_SyncIO$Success.prototype;
$c_Lcats_effect_SyncIO$Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Success.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Success)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Success(x$0);
    var x = this.Lcats_effect_SyncIO$Success__f_value;
    var y = $n(x$0$2).Lcats_effect_SyncIO$Success__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Success.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Success.prototype.productPrefix__T = (function() {
  return "Success";
});
$c_Lcats_effect_SyncIO$Success.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Success__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Success.prototype.tag__B = (function() {
  return 6;
});
function $as_Lcats_effect_SyncIO$Success(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Success) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Success"));
}
function $isArrayOf_Lcats_effect_SyncIO$Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Success)));
}
function $asArrayOf_Lcats_effect_SyncIO$Success(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Success;", depth));
}
var $d_Lcats_effect_SyncIO$Success = new $TypeData().initClass($c_Lcats_effect_SyncIO$Success, "cats.effect.SyncIO$Success", ({
  Lcats_effect_SyncIO$Success: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$Suspend(hint, thunk) {
  this.Lcats_effect_SyncIO$Suspend__f_hint = null;
  this.Lcats_effect_SyncIO$Suspend__f_thunk = null;
  this.Lcats_effect_SyncIO$Suspend__f_hint = hint;
  this.Lcats_effect_SyncIO$Suspend__f_thunk = thunk;
}
$c_Lcats_effect_SyncIO$Suspend.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Suspend.prototype.constructor = $c_Lcats_effect_SyncIO$Suspend;
/** @constructor */
function $h_Lcats_effect_SyncIO$Suspend() {
}
$h_Lcats_effect_SyncIO$Suspend.prototype = $c_Lcats_effect_SyncIO$Suspend.prototype;
$c_Lcats_effect_SyncIO$Suspend.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Suspend.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Suspend.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Suspend)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Suspend(x$0);
    var x = this.Lcats_effect_SyncIO$Suspend__f_hint;
    var x$2 = $n(x$0$2).Lcats_effect_SyncIO$Suspend__f_hint;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lcats_effect_SyncIO$Suspend__f_thunk;
      var x$4 = $n(x$0$2).Lcats_effect_SyncIO$Suspend__f_thunk;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productPrefix__T = (function() {
  return "Suspend";
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Suspend__f_hint;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$Suspend__f_thunk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Suspend.prototype.tag__B = (function() {
  return 1;
});
function $as_Lcats_effect_SyncIO$Suspend(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Suspend) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Suspend"));
}
function $isArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Suspend)));
}
function $asArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Suspend;", depth));
}
var $d_Lcats_effect_SyncIO$Suspend = new $TypeData().initClass($c_Lcats_effect_SyncIO$Suspend, "cats.effect.SyncIO$Suspend", ({
  Lcats_effect_SyncIO$Suspend: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Deferred$TransformedDeferred(underlying, trans) {
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying = null;
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans = null;
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying = underlying;
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans = trans;
}
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype = new $h_Lcats_effect_kernel_Deferred();
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.constructor = $c_Lcats_effect_kernel_Deferred$TransformedDeferred;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred$TransformedDeferred() {
}
$h_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype = $c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype;
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.get__O = (function() {
  return $n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying).get__O());
});
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.tryGet__O = (function() {
  return $n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying).tryGet__O());
});
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.complete__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying).complete__O__O(a));
});
var $d_Lcats_effect_kernel_Deferred$TransformedDeferred = new $TypeData().initClass($c_Lcats_effect_kernel_Deferred$TransformedDeferred, "cats.effect.kernel.Deferred$TransformedDeferred", ({
  Lcats_effect_kernel_Deferred$TransformedDeferred: 1,
  Lcats_effect_kernel_Deferred: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_DeferredSource: 1,
  Lcats_effect_kernel_DeferredSink: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$$anon$1(fin$18, outer) {
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$3 = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$3 = fin$18;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer = outer;
}
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$$anon$1() {
}
$h_Lcats_effect_kernel_MonadCancel$$anon$1.prototype = $c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype;
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return true;
});
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $n(this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer).handleError__O__F1__O($n(this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$3).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x)), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => (void 0))));
});
var $d_Lcats_effect_kernel_MonadCancel$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$$anon$1, "cats.effect.kernel.MonadCancel$$anon$1", ({
  Lcats_effect_kernel_MonadCancel$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Canceled() {
}
$c_Lcats_effect_kernel_Outcome$Canceled.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Canceled;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Canceled() {
}
$h_Lcats_effect_kernel_Outcome$Canceled.prototype = $c_Lcats_effect_kernel_Outcome$Canceled.prototype;
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$0), true)));
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productPrefix__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Outcome$Canceled(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Outcome$Canceled) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome$Canceled"));
}
function $isArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Canceled)));
}
function $asArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome$Canceled;", depth));
}
var $d_Lcats_effect_kernel_Outcome$Canceled = new $TypeData().initClass($c_Lcats_effect_kernel_Outcome$Canceled, "cats.effect.kernel.Outcome$Canceled", ({
  Lcats_effect_kernel_Outcome$Canceled: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Errored(e) {
  this.Lcats_effect_kernel_Outcome$Errored__f_e = null;
  this.Lcats_effect_kernel_Outcome$Errored__f_e = e;
}
$c_Lcats_effect_kernel_Outcome$Errored.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Errored.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Errored;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Errored() {
}
$h_Lcats_effect_kernel_Outcome$Errored.prototype = $c_Lcats_effect_kernel_Outcome$Errored.prototype;
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$0$2 = $as_Lcats_effect_kernel_Outcome$Errored(x$0);
    var x = this.Lcats_effect_kernel_Outcome$Errored__f_e;
    var y = $n(x$0$2).Lcats_effect_kernel_Outcome$Errored__f_e;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productPrefix__T = (function() {
  return "Errored";
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Outcome$Errored__f_e;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Outcome$Errored(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Outcome$Errored) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome$Errored"));
}
function $isArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Errored)));
}
function $asArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome$Errored;", depth));
}
var $d_Lcats_effect_kernel_Outcome$Errored = new $TypeData().initClass($c_Lcats_effect_kernel_Outcome$Errored, "cats.effect.kernel.Outcome$Errored", ({
  Lcats_effect_kernel_Outcome$Errored: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Succeeded(fa) {
  this.Lcats_effect_kernel_Outcome$Succeeded__f_fa = null;
  this.Lcats_effect_kernel_Outcome$Succeeded__f_fa = fa;
}
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Succeeded;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Succeeded() {
}
$h_Lcats_effect_kernel_Outcome$Succeeded.prototype = $c_Lcats_effect_kernel_Outcome$Succeeded.prototype;
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$0$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$0);
    var x = this.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    var y = $n(x$0$2).Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productPrefix__T = (function() {
  return "Succeeded";
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Outcome$Succeeded(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Outcome$Succeeded) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome$Succeeded"));
}
function $isArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Succeeded)));
}
function $asArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome$Succeeded;", depth));
}
var $d_Lcats_effect_kernel_Outcome$Succeeded = new $TypeData().initClass($c_Lcats_effect_kernel_Outcome$Succeeded, "cats.effect.kernel.Outcome$Succeeded", ({
  Lcats_effect_kernel_Outcome$Succeeded: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Ref$TransformedRef2(underlying, trans, G) {
  this.Lcats_effect_kernel_Ref$TransformedRef2__f_underlying = null;
  this.Lcats_effect_kernel_Ref$TransformedRef2__f_trans = null;
  this.Lcats_effect_kernel_Ref$TransformedRef2__f_G = null;
  this.Lcats_effect_kernel_Ref$TransformedRef2__f_underlying = underlying;
  this.Lcats_effect_kernel_Ref$TransformedRef2__f_trans = trans;
  this.Lcats_effect_kernel_Ref$TransformedRef2__f_G = G;
}
$c_Lcats_effect_kernel_Ref$TransformedRef2.prototype = new $h_Lcats_effect_kernel_Ref();
$c_Lcats_effect_kernel_Ref$TransformedRef2.prototype.constructor = $c_Lcats_effect_kernel_Ref$TransformedRef2;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$TransformedRef2() {
}
$h_Lcats_effect_kernel_Ref$TransformedRef2.prototype = $c_Lcats_effect_kernel_Ref$TransformedRef2.prototype;
$c_Lcats_effect_kernel_Ref$TransformedRef2.prototype.get__O = (function() {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_underlying).get__O());
});
$c_Lcats_effect_kernel_Ref$TransformedRef2.prototype.set__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_underlying).set__O__O(a));
});
$c_Lcats_effect_kernel_Ref$TransformedRef2.prototype.getAndSet__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_underlying).getAndSet__O__O(a));
});
$c_Lcats_effect_kernel_Ref$TransformedRef2.prototype.update__F1__O = (function(f) {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_underlying).update__F1__O(f));
});
$c_Lcats_effect_kernel_Ref$TransformedRef2.prototype.modify__F1__O = (function(f) {
  return $n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_underlying).modify__F1__O(f));
});
$c_Lcats_effect_kernel_Ref$TransformedRef2.prototype.access__O = (function() {
  var this$2 = $n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_G);
  var this$1 = $m_Lcats_Invariant$();
  var evidence$1 = $f_Lcats_instances_NTupleMonadInstances__catsStdInstancesForTuple2__Lcats_Comonad(this$1);
  var this$5 = new $c_Lcats_Functor$$anon$1(evidence$1, this$2);
  $m_Lcats_instances_package$function$();
  var evidence$1$1 = new $c_Lcats_instances_Function1Instances0$$anon$11();
  var this$7 = new $c_Lcats_Functor$$anon$1(evidence$1$1, this$5);
  var fga = $n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_trans).apply__O__O($n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_underlying).access__O());
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$27) => $n(this.Lcats_effect_kernel_Ref$TransformedRef2__f_trans).apply__O__O(_$27)));
  return $f_Lcats_ComposedFunctor__map__O__F1__O(this$7, fga, f);
});
var $d_Lcats_effect_kernel_Ref$TransformedRef2 = new $TypeData().initClass($c_Lcats_effect_kernel_Ref$TransformedRef2, "cats.effect.kernel.Ref$TransformedRef2", ({
  Lcats_effect_kernel_Ref$TransformedRef2: 1,
  Lcats_effect_kernel_Ref: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_RefSource: 1,
  Lcats_effect_kernel_RefSink: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$2(rel$4, F$102) {
  this.Lcats_effect_kernel_Resource$$anon$2__f_rel$2 = null;
  this.Lcats_effect_kernel_Resource$$anon$2__f_F$41 = null;
  this.Lcats_effect_kernel_Resource$$anon$2__f_rel$2 = rel$4;
  this.Lcats_effect_kernel_Resource$$anon$2__f_F$41 = F$102;
}
$c_Lcats_effect_kernel_Resource$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$2() {
}
$h_Lcats_effect_kernel_Resource$$anon$2.prototype = $c_Lcats_effect_kernel_Resource$$anon$2.prototype;
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  var fa = $n(this.Lcats_effect_kernel_Resource$$anon$2__f_rel$2).apply__O__O(new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(x));
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$26) => {
    $as_jl_Throwable(_$26);
  }));
  var F$1 = this.Lcats_effect_kernel_Resource$$anon$2__f_F$41;
  return $n(F$1).handleError__O__F1__O(fa, f);
});
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x));
});
$c_Lcats_effect_kernel_Resource$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1);
});
var $d_Lcats_effect_kernel_Resource$$anon$2 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$$anon$2, "cats.effect.kernel.Resource$$anon$2", ({
  Lcats_effect_kernel_Resource$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Allocate(resource) {
  this.Lcats_effect_kernel_Resource$Allocate__f_resource = null;
  this.Lcats_effect_kernel_Resource$Allocate__f_resource = resource;
}
$c_Lcats_effect_kernel_Resource$Allocate.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Allocate.prototype.constructor = $c_Lcats_effect_kernel_Resource$Allocate;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Allocate() {
}
$h_Lcats_effect_kernel_Resource$Allocate.prototype = $c_Lcats_effect_kernel_Resource$Allocate.prototype;
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Allocate(x$0);
    var x = this.Lcats_effect_kernel_Resource$Allocate__f_resource;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$Allocate__f_resource;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productPrefix__T = (function() {
  return "Allocate";
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Allocate__f_resource;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Allocate(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Allocate) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Allocate"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Allocate)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Allocate;", depth));
}
var $d_Lcats_effect_kernel_Resource$Allocate = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Allocate, "cats.effect.kernel.Resource$Allocate", ({
  Lcats_effect_kernel_Resource$Allocate: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Bind(source, fs) {
  this.Lcats_effect_kernel_Resource$Bind__f_source = null;
  this.Lcats_effect_kernel_Resource$Bind__f_fs = null;
  this.Lcats_effect_kernel_Resource$Bind__f_source = source;
  this.Lcats_effect_kernel_Resource$Bind__f_fs = fs;
}
$c_Lcats_effect_kernel_Resource$Bind.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Bind.prototype.constructor = $c_Lcats_effect_kernel_Resource$Bind;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Bind() {
}
$h_Lcats_effect_kernel_Resource$Bind.prototype = $c_Lcats_effect_kernel_Resource$Bind.prototype;
$c_Lcats_effect_kernel_Resource$Bind.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Bind(x$0);
    var x = this.Lcats_effect_kernel_Resource$Bind__f_source;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$Bind__f_source;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Bind__f_fs;
      var x$4 = $n(x$0$2).Lcats_effect_kernel_Resource$Bind__f_fs;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.productPrefix__T = (function() {
  return "Bind";
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Bind__f_source;
  }
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Bind__f_fs;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Bind(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Bind) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Bind"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Bind)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Bind;", depth));
}
var $d_Lcats_effect_kernel_Resource$Bind = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Bind, "cats.effect.kernel.Resource$Bind", ({
  Lcats_effect_kernel_Resource$Bind: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Eval(fa) {
  this.Lcats_effect_kernel_Resource$Eval__f_fa = null;
  this.Lcats_effect_kernel_Resource$Eval__f_fa = fa;
}
$c_Lcats_effect_kernel_Resource$Eval.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Eval.prototype.constructor = $c_Lcats_effect_kernel_Resource$Eval;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Eval() {
}
$h_Lcats_effect_kernel_Resource$Eval.prototype = $c_Lcats_effect_kernel_Resource$Eval.prototype;
$c_Lcats_effect_kernel_Resource$Eval.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Eval(x$0);
    var x = this.Lcats_effect_kernel_Resource$Eval__f_fa;
    var y = $n(x$0$2).Lcats_effect_kernel_Resource$Eval__f_fa;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productPrefix__T = (function() {
  return "Eval";
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Eval__f_fa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Eval(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Eval"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Eval)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Eval;", depth));
}
var $d_Lcats_effect_kernel_Resource$Eval = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Eval, "cats.effect.kernel.Resource$Eval", ({
  Lcats_effect_kernel_Resource$Eval: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e) {
  this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e = null;
  this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e = e;
}
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Errored;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Errored() {
}
$h_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$ExitCase$Errored(x$0);
    var x = this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productPrefix__T = (function() {
  return "Errored";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$ExitCase$Errored(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$ExitCase$Errored"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$ExitCase$Errored)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$ExitCase$Errored;", depth));
}
var $d_Lcats_effect_kernel_Resource$ExitCase$Errored = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$Errored, "cats.effect.kernel.Resource$ExitCase$Errored", ({
  Lcats_effect_kernel_Resource$ExitCase$Errored: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$1(outer, head, tail) {
  this.Lcats_effect_kernel_Resource$Frame$1__f_head = null;
  this.Lcats_effect_kernel_Resource$Frame$1__f_tail = null;
  this.Lcats_effect_kernel_Resource$Frame$1__f_head = head;
  this.Lcats_effect_kernel_Resource$Frame$1__f_tail = tail;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_kernel_Resource$Frame$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$1;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$1() {
}
$h_Lcats_effect_kernel_Resource$Frame$1.prototype = $c_Lcats_effect_kernel_Resource$Frame$1.prototype;
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Frame$1(x$0);
    var x = this.Lcats_effect_kernel_Resource$Frame$1__f_head;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$Frame$1__f_head;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Frame$1__f_tail;
      var x$4 = $n(x$0$2).Lcats_effect_kernel_Resource$Frame$1__f_tail;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productPrefix__T = (function() {
  return "Frame";
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Frame$1__f_head;
  }
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Frame$1__f_tail;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Frame$1(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$1"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$1)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$1;", depth));
}
var $d_Lcats_effect_kernel_Resource$Frame$1 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$1, "cats.effect.kernel.Resource$Frame$1", ({
  Lcats_effect_kernel_Resource$Frame$1: 1,
  Lcats_effect_kernel_Resource$Stack$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$4(outer, head, tail) {
  this.Lcats_effect_kernel_Resource$Frame$4__f_head = null;
  this.Lcats_effect_kernel_Resource$Frame$4__f_tail = null;
  this.Lcats_effect_kernel_Resource$Frame$4__f_head = head;
  this.Lcats_effect_kernel_Resource$Frame$4__f_tail = tail;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_effect_kernel_Resource$Frame$4.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$4;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$4() {
}
$h_Lcats_effect_kernel_Resource$Frame$4.prototype = $c_Lcats_effect_kernel_Resource$Frame$4.prototype;
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Frame$4)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Frame$4(x$0);
    var x = this.Lcats_effect_kernel_Resource$Frame$4__f_head;
    var x$2 = $n(x$0$2).Lcats_effect_kernel_Resource$Frame$4__f_head;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Frame$4__f_tail;
      var x$4 = $n(x$0$2).Lcats_effect_kernel_Resource$Frame$4__f_tail;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.productPrefix__T = (function() {
  return "Frame";
});
$c_Lcats_effect_kernel_Resource$Frame$4.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Frame$4__f_head;
  }
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Frame$4__f_tail;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Frame$4(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$4) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$4"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$4)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$4(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$4;", depth));
}
var $d_Lcats_effect_kernel_Resource$Frame$4 = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Frame$4, "cats.effect.kernel.Resource$Frame$4", ({
  Lcats_effect_kernel_Resource$Frame$4: 1,
  Lcats_effect_kernel_Resource$Stack$2: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Pure(a) {
  this.Lcats_effect_kernel_Resource$Pure__f_a = null;
  this.Lcats_effect_kernel_Resource$Pure__f_a = a;
}
$c_Lcats_effect_kernel_Resource$Pure.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Pure.prototype.constructor = $c_Lcats_effect_kernel_Resource$Pure;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Pure() {
}
$h_Lcats_effect_kernel_Resource$Pure.prototype = $c_Lcats_effect_kernel_Resource$Pure.prototype;
$c_Lcats_effect_kernel_Resource$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Pure(x$0);
    var x = this.Lcats_effect_kernel_Resource$Pure__f_a;
    var y = $n(x$0$2).Lcats_effect_kernel_Resource$Pure__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productPrefix__T = (function() {
  return "Pure";
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Pure__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Pure(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Pure"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Pure)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Pure;", depth));
}
var $d_Lcats_effect_kernel_Resource$Pure = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Pure, "cats.effect.kernel.Resource$Pure", ({
  Lcats_effect_kernel_Resource$Pure: 1,
  Lcats_effect_kernel_Resource: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
function $p_Lcats_effect_kernel_SyncRef__setter$1__O__F1($thiz, snapshot$1) {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n($thiz.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    if (Object.is($thiz.Lcats_effect_kernel_SyncRef__f_value, snapshot$1)) {
      $thiz.Lcats_effect_kernel_SyncRef__f_value = a;
      return true;
    } else {
      return false;
    }
  })))));
}
/** @constructor */
function $c_Lcats_effect_kernel_SyncRef(value, F) {
  this.Lcats_effect_kernel_SyncRef__f_value = null;
  this.Lcats_effect_kernel_SyncRef__f_F = null;
  this.Lcats_effect_kernel_SyncRef__f_value = value;
  this.Lcats_effect_kernel_SyncRef__f_F = F;
}
$c_Lcats_effect_kernel_SyncRef.prototype = new $h_Lcats_effect_kernel_Ref();
$c_Lcats_effect_kernel_SyncRef.prototype.constructor = $c_Lcats_effect_kernel_SyncRef;
/** @constructor */
function $h_Lcats_effect_kernel_SyncRef() {
}
$h_Lcats_effect_kernel_SyncRef.prototype = $c_Lcats_effect_kernel_SyncRef.prototype;
$c_Lcats_effect_kernel_SyncRef.prototype.get__O = (function() {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.Lcats_effect_kernel_SyncRef__f_value)));
});
$c_Lcats_effect_kernel_SyncRef.prototype.set__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    this.Lcats_effect_kernel_SyncRef__f_value = a;
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.getAndSet__O__O = (function(a) {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var current = this.Lcats_effect_kernel_SyncRef__f_value;
    this.Lcats_effect_kernel_SyncRef__f_value = a;
    return current;
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.access__O = (function() {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var snapshot = this.Lcats_effect_kernel_SyncRef__f_value;
    var _2 = $p_Lcats_effect_kernel_SyncRef__setter$1__O__F1(this, snapshot);
    return new $c_T2(snapshot, _2);
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.update__F1__O = (function(f) {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    this.Lcats_effect_kernel_SyncRef__f_value = $n(f).apply__O__O(this.Lcats_effect_kernel_SyncRef__f_value);
  })));
});
$c_Lcats_effect_kernel_SyncRef.prototype.modify__F1__O = (function(f) {
  return $n(this.Lcats_effect_kernel_SyncRef__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    matchResult2: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x4 = $as_T2($n(f).apply__O__O(this.Lcats_effect_kernel_SyncRef__f_value));
      if ((x4 !== null)) {
        var u = $n(x4)._1__O();
        var b = $n(x4)._2__O();
        var \u03b42$___1 = u;
        var \u03b42$___2 = b;
        break matchResult2;
      }
      throw new $c_s_MatchError(x4);
    }
    var u$2 = \u03b42$___1;
    var b$2 = \u03b42$___2;
    this.Lcats_effect_kernel_SyncRef__f_value = u$2;
    return b$2;
  })));
});
var $d_Lcats_effect_kernel_SyncRef = new $TypeData().initClass($c_Lcats_effect_kernel_SyncRef, "cats.effect.kernel.SyncRef", ({
  Lcats_effect_kernel_SyncRef: 1,
  Lcats_effect_kernel_Ref: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_RefSource: 1,
  Lcats_effect_kernel_RefSink: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(outer, latch) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch = latch;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$0)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer === this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_$outer))) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(x$0);
    var x = this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
    var x$2 = $n(x$0$2).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.productPrefix__T = (function() {
  return "Canceling";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling__f_latch;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor$TaskState$3$Canceling"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor$TaskState$3$Canceling;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling, "cats.effect.std.Dispatcher$Executor$TaskState$3$Canceling", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Canceling: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_std_Dispatcher$Executor$TaskState$1: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(outer, task) {
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer = null;
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task = task;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer = outer;
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready) && ($n($as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$0)).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer === this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_$outer))) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(x$0);
    var x = this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task;
    var y = $n(x$0$2).Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.productPrefix__T = (function() {
  return "Ready";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready__f_task;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Executor$TaskState$3$Ready"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Executor$TaskState$3$Ready;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready, "cats.effect.std.Dispatcher$Executor$TaskState$3$Ready", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Ready: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_std_Dispatcher$Executor$TaskState$1: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested(latch) {
  this.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch = null;
  this.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch = latch;
}
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype = new $h_Lcats_effect_std_Dispatcher$RegState();
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState$CancelRequested() {
}
$h_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype = $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype;
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(x$0);
    var x = this.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
    var x$2 = $n(x$0$2).Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.productPrefix__T = (function() {
  return "CancelRequested";
});
$c_Lcats_effect_std_Dispatcher$RegState$CancelRequested.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$RegState$CancelRequested__f_latch;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$RegState$CancelRequested(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$RegState$CancelRequested) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$RegState$CancelRequested"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$RegState$CancelRequested(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$RegState$CancelRequested)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$RegState$CancelRequested(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$RegState$CancelRequested(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$RegState$CancelRequested;", depth));
}
var $d_Lcats_effect_std_Dispatcher$RegState$CancelRequested = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$RegState$CancelRequested, "cats.effect.std.Dispatcher$RegState$CancelRequested", ({
  Lcats_effect_std_Dispatcher$RegState$CancelRequested: 1,
  Lcats_effect_std_Dispatcher$RegState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState$Running(cancel) {
  this.Lcats_effect_std_Dispatcher$RegState$Running__f_cancel = null;
  this.Lcats_effect_std_Dispatcher$RegState$Running__f_cancel = cancel;
}
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype = new $h_Lcats_effect_std_Dispatcher$RegState();
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState$Running;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState$Running() {
}
$h_Lcats_effect_std_Dispatcher$RegState$Running.prototype = $c_Lcats_effect_std_Dispatcher$RegState$Running.prototype;
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$RegState$Running)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$RegState$Running(x$0);
    var x = this.Lcats_effect_std_Dispatcher$RegState$Running__f_cancel;
    var y = $n(x$0$2).Lcats_effect_std_Dispatcher$RegState$Running__f_cancel;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.productPrefix__T = (function() {
  return "Running";
});
$c_Lcats_effect_std_Dispatcher$RegState$Running.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$RegState$Running__f_cancel;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$RegState$Running(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$RegState$Running) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$RegState$Running"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$RegState$Running(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$RegState$Running)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$RegState$Running(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$RegState$Running(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$RegState$Running;", depth));
}
var $d_Lcats_effect_std_Dispatcher$RegState$Running = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$RegState$Running, "cats.effect.std.Dispatcher$RegState$Running", ({
  Lcats_effect_std_Dispatcher$RegState$Running: 1,
  Lcats_effect_std_Dispatcher$RegState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState$Unstarted(action) {
  this.Lcats_effect_std_Dispatcher$RegState$Unstarted__f_action = null;
  this.Lcats_effect_std_Dispatcher$RegState$Unstarted__f_action = action;
}
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype = new $h_Lcats_effect_std_Dispatcher$RegState();
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState$Unstarted;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState$Unstarted() {
}
$h_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype = $c_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype;
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$RegState$Unstarted)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$RegState$Unstarted(x$0);
    var x = this.Lcats_effect_std_Dispatcher$RegState$Unstarted__f_action;
    var y = $n(x$0$2).Lcats_effect_std_Dispatcher$RegState$Unstarted__f_action;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype.productPrefix__T = (function() {
  return "Unstarted";
});
$c_Lcats_effect_std_Dispatcher$RegState$Unstarted.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$RegState$Unstarted__f_action;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$RegState$Unstarted(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$RegState$Unstarted) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$RegState$Unstarted"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$RegState$Unstarted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$RegState$Unstarted)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$RegState$Unstarted(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$RegState$Unstarted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$RegState$Unstarted;", depth));
}
var $d_Lcats_effect_std_Dispatcher$RegState$Unstarted = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$RegState$Unstarted, "cats.effect.std.Dispatcher$RegState$Unstarted", ({
  Lcats_effect_std_Dispatcher$RegState$Unstarted: 1,
  Lcats_effect_std_Dispatcher$RegState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration$Finalizer(action) {
  this.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action = null;
  this.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action = action;
}
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype = new $h_Lcats_effect_std_Dispatcher$Registration();
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration$Finalizer;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration$Finalizer() {
}
$h_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype = $c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype;
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$Registration$Finalizer)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$Registration$Finalizer(x$0);
    var x = this.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action;
    var y = $n(x$0$2).Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.productPrefix__T = (function() {
  return "Finalizer";
});
$c_Lcats_effect_std_Dispatcher$Registration$Finalizer.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$Registration$Finalizer__f_action;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$Registration$Finalizer(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration$Finalizer) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration$Finalizer"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration$Finalizer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration$Finalizer)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration$Finalizer(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration$Finalizer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration$Finalizer;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Registration$Finalizer = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Registration$Finalizer, "cats.effect.std.Dispatcher$Registration$Finalizer", ({
  Lcats_effect_std_Dispatcher$Registration$Finalizer: 1,
  Lcats_effect_std_Dispatcher$Registration: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill() {
}
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype = new $h_Lcats_effect_std_Dispatcher$Registration();
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration$PoisonPill() {
}
$h_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype = $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype;
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill) && ($as_Lcats_effect_std_Dispatcher$Registration$PoisonPill(x$0), true)));
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.productPrefix__T = (function() {
  return "PoisonPill";
});
$c_Lcats_effect_std_Dispatcher$Registration$PoisonPill.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_std_Dispatcher$Registration$PoisonPill(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration$PoisonPill) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration$PoisonPill"));
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration$PoisonPill(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration$PoisonPill)));
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration$PoisonPill(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration$PoisonPill(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration$PoisonPill;", depth));
}
var $d_Lcats_effect_std_Dispatcher$Registration$PoisonPill = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Registration$PoisonPill, "cats.effect.std.Dispatcher$Registration$PoisonPill", ({
  Lcats_effect_std_Dispatcher$Registration$PoisonPill: 1,
  Lcats_effect_std_Dispatcher$Registration: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1() {
}
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype.constructor = $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_EnvCompanionPlatform$$anon$1() {
}
$h_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype = $c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype;
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return (((typeof x) === "string") && ($as_T(x), true));
});
$c_Lcats_effect_std_EnvCompanionPlatform$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  if (((typeof x) === "string")) {
    var value = $as_T(x);
    return value;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
var $d_Lcats_effect_std_EnvCompanionPlatform$$anon$1 = new $TypeData().initClass($c_Lcats_effect_std_EnvCompanionPlatform$$anon$1, "cats.effect.std.EnvCompanionPlatform$$anon$1", ({
  Lcats_effect_std_EnvCompanionPlatform$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Queue$BoundedQueue(capacity, state, F) {
  this.Lcats_effect_std_Queue$AbstractQueue__f_capacity = 0;
  this.Lcats_effect_std_Queue$AbstractQueue__f_state = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_F = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_take = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_tryTake = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_notifyNextTaker = null;
  this.Lcats_effect_std_Queue$BoundedQueue__f_state = null;
  this.Lcats_effect_std_Queue$BoundedQueue__f_F = null;
  this.Lcats_effect_std_Queue$BoundedQueue__f_state = state;
  this.Lcats_effect_std_Queue$BoundedQueue__f_F = F;
  $ct_Lcats_effect_std_Queue$AbstractQueue__I__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__(this, capacity, state, F);
  var requirement = (capacity > 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: capacity must be > 0");
  }
}
$c_Lcats_effect_std_Queue$BoundedQueue.prototype = new $h_Lcats_effect_std_Queue$AbstractQueue();
$c_Lcats_effect_std_Queue$BoundedQueue.prototype.constructor = $c_Lcats_effect_std_Queue$BoundedQueue;
/** @constructor */
function $h_Lcats_effect_std_Queue$BoundedQueue() {
}
$h_Lcats_effect_std_Queue$BoundedQueue.prototype = $c_Lcats_effect_std_Queue$BoundedQueue.prototype;
var $d_Lcats_effect_std_Queue$BoundedQueue = new $TypeData().initClass($c_Lcats_effect_std_Queue$BoundedQueue, "cats.effect.std.Queue$BoundedQueue", ({
  Lcats_effect_std_Queue$BoundedQueue: 1,
  Lcats_effect_std_Queue$AbstractQueue: 1,
  Lcats_effect_std_Queue: 1,
  Lcats_effect_std_QueueSource: 1,
  Lcats_effect_std_QueueSink: 1
}));
/** @constructor */
function $c_Lcats_effect_tracing_Tracing$$anon$1() {
}
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.constructor = $c_Lcats_effect_tracing_Tracing$$anon$1;
/** @constructor */
function $h_Lcats_effect_tracing_Tracing$$anon$1() {
}
$h_Lcats_effect_tracing_Tracing$$anon$1.prototype = $c_Lcats_effect_tracing_Tracing$$anon$1.prototype;
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.isDefinedAt__Lcats_effect_tracing_TracingEvent__Z = (function(x) {
  return ((x instanceof $c_Lcats_effect_tracing_TracingEvent$StackTrace) && ($as_Lcats_effect_tracing_TracingEvent$StackTrace(x), true));
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.applyOrElse__Lcats_effect_tracing_TracingEvent__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Lcats_effect_tracing_TracingEvent$StackTrace)) {
    var ev = $as_Lcats_effect_tracing_TracingEvent$StackTrace(x);
    return $m_Lcats_effect_tracing_Tracing$().cats$effect$tracing$Tracing$$$getOpAndCallSite__Ajl_StackTraceElement__jl_StackTraceElement($n(ev).getStackTrace__Ajl_StackTraceElement());
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lcats_effect_tracing_TracingEvent__Z($as_Lcats_effect_tracing_TracingEvent(x));
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lcats_effect_tracing_TracingEvent__F1__O($as_Lcats_effect_tracing_TracingEvent(x), default$1);
});
var $d_Lcats_effect_tracing_Tracing$$anon$1 = new $TypeData().initClass($c_Lcats_effect_tracing_Tracing$$anon$1, "cats.effect.tracing.Tracing$$anon$1", ({
  Lcats_effect_tracing_Tracing$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor(batchSize, reportFailure0) {
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$batchSize = 0;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_reportFailure0 = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_queueMicrotask = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = false;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskRunnable = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskJSFunction = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag = null;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$batchSize = batchSize;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_reportFailure0 = reportFailure0;
  if (($as_T((typeof queueMicrotask)) === "function")) {
    var $x_1 = queueMicrotask;
  } else {
    var resolved = Promise.resolve((void 0));
    var $x_1 = ((task) => resolved.then(task));
  }
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_queueMicrotask = $x_1;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = true;
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers = new $c_Lcats_effect_unsafe_JSArrayQueue();
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskRunnable = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$1(this);
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskJSFunction = (() => {
    $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskRunnable).run__V();
  });
  this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag = (($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing && $m_Lcats_effect_unsafe_FiberMonitor$().weakRefsAvailable__Z()) ? $as_scm_Set($m_scm_Set$().empty__O()) : null);
}
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype = new $h_O();
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.constructor = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor;
/** @constructor */
function $h_Lcats_effect_unsafe_BatchingMacrotaskExecutor() {
}
$h_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype = $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype;
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.execute__jl_Runnable__V = (function(runnable) {
  var $x_2 = $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$();
  if ((this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag !== null)) {
    if ((runnable instanceof $c_Lcats_effect_IOFiber)) {
      var r = $as_Lcats_effect_IOFiber(runnable);
      var this$2 = $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_fiberBag);
      this$2.addOne__O__scm_Growable(r);
      var $x_1 = new $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor$$anon$2(r, this);
    } else {
      var $x_1 = runnable;
    }
  } else {
    var $x_1 = runnable;
  }
  $x_2.execute__jl_Runnable__V($x_1);
});
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.schedule__Lcats_effect_IOFiber__V = (function(fiber) {
  var this$1 = $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$fibers);
  if ((!this$1.Lcats_effect_unsafe_JSArrayQueue__f_empty)) {
    if (((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex === 0) && (this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex === $uI(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length)))) {
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.push(null);
    } else if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_startIndex === this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
      var i = 0;
      while ((i < this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex)) {
        this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.push(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[i]);
        this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[i] = null;
        i = ((1 + i) | 0);
      }
      this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = $uI(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length);
    }
  }
  this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = ((1 + this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex) | 0);
  if ((this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex > $uI(this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer.length))) {
    this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex = 1;
  }
  this$1.Lcats_effect_unsafe_JSArrayQueue__f_buffer[((this$1.Lcats_effect_unsafe_JSArrayQueue__f_endIndex - 1) | 0)] = fiber;
  this$1.Lcats_effect_unsafe_JSArrayQueue__f_empty = false;
  if (this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule) {
    this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_cats$effect$unsafe$BatchingMacrotaskExecutor$$needsReschedule = false;
    (0, this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_queueMicrotask)(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_executeBatchTaskJSFunction);
  }
});
$c_Lcats_effect_unsafe_BatchingMacrotaskExecutor.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $n(this.Lcats_effect_unsafe_BatchingMacrotaskExecutor__f_reportFailure0).apply__O__O(t);
});
function $as_Lcats_effect_unsafe_BatchingMacrotaskExecutor(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.BatchingMacrotaskExecutor"));
}
function $isArrayOf_Lcats_effect_unsafe_BatchingMacrotaskExecutor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_BatchingMacrotaskExecutor)));
}
function $asArrayOf_Lcats_effect_unsafe_BatchingMacrotaskExecutor(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_BatchingMacrotaskExecutor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.BatchingMacrotaskExecutor;", depth));
}
var $d_Lcats_effect_unsafe_BatchingMacrotaskExecutor = new $TypeData().initClass($c_Lcats_effect_unsafe_BatchingMacrotaskExecutor, "cats.effect.unsafe.BatchingMacrotaskExecutor", ({
  Lcats_effect_unsafe_BatchingMacrotaskExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  Lcats_effect_unsafe_FiberExecutor: 1
}));
/** @constructor */
function $c_Lcats_instances_Function1Instances0$$anon$11() {
}
$c_Lcats_instances_Function1Instances0$$anon$11.prototype = new $h_O();
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.constructor = $c_Lcats_instances_Function1Instances0$$anon$11;
/** @constructor */
function $h_Lcats_instances_Function1Instances0$$anon$11() {
}
$h_Lcats_instances_Function1Instances0$$anon$11.prototype = $c_Lcats_instances_Function1Instances0$$anon$11.prototype;
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__F1__F1__F1($as_F1(fa), f);
});
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.map__F1__F1__F1 = (function(fa, f) {
  return new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((t1) => $n(f).apply__O__O($n(fa).apply__O__O(t1))));
});
$c_Lcats_instances_Function1Instances0$$anon$11.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__F1__F1__F1($as_F1(fa), f);
});
var $d_Lcats_instances_Function1Instances0$$anon$11 = new $TypeData().initClass($c_Lcats_instances_Function1Instances0$$anon$11, "cats.instances.Function1Instances0$$anon$11", ({
  Lcats_instances_Function1Instances0$$anon$11: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Distributive: 1
}));
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$2() {
}
$c_Lcats_instances_LazyListInstances$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$2() {
}
$h_Lcats_instances_LazyListInstances$$anon$2.prototype = $c_Lcats_instances_LazyListInstances$$anon$2.prototype;
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.isDefinedAt__s_Option__Z = (function(x) {
  return ((x instanceof $c_s_Some) && ($n($as_s_Some(x)), true));
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.applyOrElse__s_Option__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_Some)) {
    var v = $n($as_s_Some(x)).s_Some__f_value;
    return v;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z($as_s_Option(x));
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O($as_s_Option(x), default$1);
});
var $d_Lcats_instances_LazyListInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_LazyListInstances$$anon$2, "cats.instances.LazyListInstances$$anon$2", ({
  Lcats_instances_LazyListInstances$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$2(fa$6, fb$3, outer) {
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$4 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$2 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$4 = fa$6;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$2 = fb$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
$c_Lcats_instances_OrderInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$2() {
}
$h_Lcats_instances_OrderInstances$$anon$2.prototype = $c_Lcats_instances_OrderInstances$$anon$2.prototype;
$c_Lcats_instances_OrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.min__O__O__O = (function(x, y) {
  return $f_Lcats_kernel_Order__min__O__O__O(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.lt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__lt__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var fa$1 = this.Lcats_instances_OrderInstances$$anon$2__f_fa$4;
  var fb$1 = this.Lcats_instances_OrderInstances$$anon$2__f_fb$2;
  var z = $n(fa$1).compare__O__O__I($n(x)._1__O(), $n(y)._1__O());
  return ((z === 0) ? $n(fb$1).compare__O__O__I($n(x)._2__O(), $n(y)._2__O()) : z);
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_OrderInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_OrderInstances$$anon$2, "cats.instances.OrderInstances$$anon$2", ({
  Lcats_instances_OrderInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
}));
/** @constructor */
function $c_Lcats_instances_package$either$() {
}
$c_Lcats_instances_package$either$.prototype = new $h_O();
$c_Lcats_instances_package$either$.prototype.constructor = $c_Lcats_instances_package$either$;
/** @constructor */
function $h_Lcats_instances_package$either$() {
}
$h_Lcats_instances_package$either$.prototype = $c_Lcats_instances_package$either$.prototype;
var $d_Lcats_instances_package$either$ = new $TypeData().initClass($c_Lcats_instances_package$either$, "cats.instances.package$either$", ({
  Lcats_instances_package$either$: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1
}));
var $n_Lcats_instances_package$either$;
function $m_Lcats_instances_package$either$() {
  if ((!$n_Lcats_instances_package$either$)) {
    $n_Lcats_instances_package$either$ = new $c_Lcats_instances_package$either$();
  }
  return $n_Lcats_instances_package$either$;
}
/** @constructor */
function $c_Lcats_instances_package$queue$() {
  this.Lcats_instances_package$queue$__f_catsStdInstancesForQueue = null;
  $n_Lcats_instances_package$queue$ = this;
  this.Lcats_instances_package$queue$__f_catsStdInstancesForQueue = new $c_Lcats_instances_QueueInstances$$anon$1();
}
$c_Lcats_instances_package$queue$.prototype = new $h_O();
$c_Lcats_instances_package$queue$.prototype.constructor = $c_Lcats_instances_package$queue$;
/** @constructor */
function $h_Lcats_instances_package$queue$() {
}
$h_Lcats_instances_package$queue$.prototype = $c_Lcats_instances_package$queue$.prototype;
var $d_Lcats_instances_package$queue$ = new $TypeData().initClass($c_Lcats_instances_package$queue$, "cats.instances.package$queue$", ({
  Lcats_instances_package$queue$: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1
}));
var $n_Lcats_instances_package$queue$;
function $m_Lcats_instances_package$queue$() {
  if ((!$n_Lcats_instances_package$queue$)) {
    $n_Lcats_instances_package$queue$ = new $c_Lcats_instances_package$queue$();
  }
  return $n_Lcats_instances_package$queue$;
}
/** @constructor */
function $c_Lcats_instances_package$seq$() {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = null;
  $n_Lcats_instances_package$seq$ = this;
  $f_Lcats_instances_SeqInstances__$init$__V(this);
}
$c_Lcats_instances_package$seq$.prototype = new $h_O();
$c_Lcats_instances_package$seq$.prototype.constructor = $c_Lcats_instances_package$seq$;
/** @constructor */
function $h_Lcats_instances_package$seq$() {
}
$h_Lcats_instances_package$seq$.prototype = $c_Lcats_instances_package$seq$.prototype;
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = x$0;
});
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
var $d_Lcats_instances_package$seq$ = new $TypeData().initClass($c_Lcats_instances_package$seq$, "cats.instances.package$seq$", ({
  Lcats_instances_package$seq$: 1,
  Lcats_kernel_instances_SeqInstances2: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_instances_SeqInstances: 1
}));
var $n_Lcats_instances_package$seq$;
function $m_Lcats_instances_package$seq$() {
  if ((!$n_Lcats_instances_package$seq$)) {
    $n_Lcats_instances_package$seq$ = new $c_Lcats_instances_package$seq$();
  }
  return $n_Lcats_instances_package$seq$;
}
/** @constructor */
function $c_Lcats_kernel_Order$() {
}
$c_Lcats_kernel_Order$.prototype = new $h_Lcats_kernel_OrderFunctions();
$c_Lcats_kernel_Order$.prototype.constructor = $c_Lcats_kernel_Order$;
/** @constructor */
function $h_Lcats_kernel_Order$() {
}
$h_Lcats_kernel_Order$.prototype = $c_Lcats_kernel_Order$.prototype;
var $d_Lcats_kernel_Order$ = new $TypeData().initClass($c_Lcats_kernel_Order$, "cats.kernel.Order$", ({
  Lcats_kernel_Order$: 1,
  Lcats_kernel_OrderFunctions: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  Lcats_kernel_OrderToOrderingConversion: 1
}));
var $n_Lcats_kernel_Order$;
function $m_Lcats_kernel_Order$() {
  if ((!$n_Lcats_kernel_Order$)) {
    $n_Lcats_kernel_Order$ = new $c_Lcats_kernel_Order$();
  }
  return $n_Lcats_kernel_Order$;
}
/** @constructor */
function $c_Lcats_kernel_Order$$anon$2(ev$5, f$7) {
  this.Lcats_kernel_Order$$anon$2__f_ev$3 = null;
  this.Lcats_kernel_Order$$anon$2__f_f$4 = null;
  this.Lcats_kernel_Order$$anon$2__f_ev$3 = ev$5;
  this.Lcats_kernel_Order$$anon$2__f_f$4 = f$7;
}
$c_Lcats_kernel_Order$$anon$2.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$2.prototype.constructor = $c_Lcats_kernel_Order$$anon$2;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$2() {
}
$h_Lcats_kernel_Order$$anon$2.prototype = $c_Lcats_kernel_Order$$anon$2.prototype;
$c_Lcats_kernel_Order$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.min__O__O__O = (function(x, y) {
  return $f_Lcats_kernel_Order__min__O__O__O(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.lt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__lt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  var ev$1 = this.Lcats_kernel_Order$$anon$2__f_ev$3;
  var f$1 = this.Lcats_kernel_Order$$anon$2__f_f$4;
  return $n(ev$1).compare__O__O__I($n(f$1).apply__O__O(x), $n(f$1).apply__O__O(y));
});
var $d_Lcats_kernel_Order$$anon$2 = new $TypeData().initClass($c_Lcats_kernel_Order$$anon$2, "cats.kernel.Order$$anon$2", ({
  Lcats_kernel_Order$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BitSetPartialOrder() {
}
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.constructor = $c_Lcats_kernel_instances_BitSetPartialOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetPartialOrder() {
}
$h_Lcats_kernel_instances_BitSetPartialOrder.prototype = $c_Lcats_kernel_instances_BitSetPartialOrder.prototype;
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__sci_BitSet__sci_BitSet__D = (function(x, y) {
  if ((x === y)) {
    return 0.0;
  } else {
    var this$1 = $n(x);
    var $x_1 = $f_sc_BitSetOps__size__I(this$1);
    var this$2 = $n(y);
    if (($x_1 < $f_sc_BitSetOps__size__I(this$2))) {
      var this$3 = $n(x);
      if ($f_sc_IterableOnceOps__forall__F1__Z(this$3, y)) {
        return (-1.0);
      } else {
        return (NaN);
      }
    } else {
      var this$4 = $n(y);
      var $x_2 = $f_sc_BitSetOps__size__I(this$4);
      var this$5 = $n(x);
      if (($x_2 < $f_sc_BitSetOps__size__I(this$5))) {
        var this$6 = $n(y);
        if ($f_sc_IterableOnceOps__forall__F1__Z(this$6, x)) {
          return 1.0;
        } else {
          return (NaN);
        }
      } else {
        if ((x === null)) {
          var $x_3 = (y === null);
        } else {
          var this$7 = $n(x);
          var $x_3 = $f_sc_SortedSet__equals__O__Z(this$7, y);
        }
        if ($x_3) {
          return 0.0;
        } else {
          return (NaN);
        }
      }
    }
  }
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__sci_BitSet__sci_BitSet__Z = (function(x, y) {
  if ((x === null)) {
    return (y === null);
  } else {
    var this$1 = $n(x);
    return $f_sc_SortedSet__equals__O__Z(this$1, y);
  }
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_sci_BitSet(x);
  var this$1 = $n(x$1);
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.unorderedHash__sc_IterableOnce__I__I(this$1, this$2.s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__sci_BitSet__sci_BitSet__D($as_sci_BitSet(x), $as_sci_BitSet(y));
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_BitSet__sci_BitSet__Z($as_sci_BitSet(x), $as_sci_BitSet(y));
});
var $d_Lcats_kernel_instances_BitSetPartialOrder = new $TypeData().initClass($c_Lcats_kernel_instances_BitSetPartialOrder, "cats.kernel.instances.BitSetPartialOrder", ({
  Lcats_kernel_instances_BitSetPartialOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Hash: 1
}));
/** @constructor */
function $c_Lfs2_Chunk() {
}
$c_Lfs2_Chunk.prototype = new $h_O();
$c_Lfs2_Chunk.prototype.constructor = $c_Lfs2_Chunk;
/** @constructor */
function $h_Lfs2_Chunk() {
}
$h_Lfs2_Chunk.prototype = $c_Lfs2_Chunk.prototype;
$c_Lfs2_Chunk.prototype.foreach__F1__V = (function(f) {
  var i = 0;
  while ((i < this.size__I())) {
    $n(f).apply__O__O(this.apply__I__O(i));
    i = ((1 + i) | 0);
  }
});
$c_Lfs2_Chunk.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0);
});
$c_Lfs2_Chunk.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lfs2_Chunk$$anon$1(this);
});
$c_Lfs2_Chunk.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var elem = this$1.stringHash__T__I__I("Chunk", (-137723950));
  var h = new $c_sr_IntRef(elem);
  this.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((o) => {
    h.sr_IntRef__f_elem = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h.sr_IntRef__f_elem, $m_sr_Statics$().anyHash__O__I(o));
  })));
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h.sr_IntRef__f_elem, this.size__I());
});
$c_Lfs2_Chunk.prototype.equals__O__Z = (function(a) {
  if ((a instanceof $c_Lfs2_Chunk)) {
    var c = $as_Lfs2_Chunk(a);
    return ((this.size__I() === $n(c).size__I()) && $f_sc_Iterator__sameElements__sc_IterableOnce__Z($n(this.iterator__sc_Iterator()), $n(c).iterator__sc_Iterator()));
  } else {
    return false;
  }
});
$c_Lfs2_Chunk.prototype.toString__T = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($n(this.iterator__sc_Iterator()), "Chunk(", ", ", ")");
});
function $as_Lfs2_Chunk(obj) {
  return (((obj instanceof $c_Lfs2_Chunk) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Chunk"));
}
function $isArrayOf_Lfs2_Chunk(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Chunk)));
}
function $asArrayOf_Lfs2_Chunk(obj, depth) {
  return (($isArrayOf_Lfs2_Chunk(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Chunk;", depth));
}
/** @constructor */
function $c_Lfs2_Chunk$() {
  this.Lfs2_Chunk$__f_fs2$Chunk$$$NotApplied = null;
  this.Lfs2_Chunk$__f_empty_ = null;
  this.Lfs2_Chunk$__f_unit = null;
  $n_Lfs2_Chunk$ = this;
  this.Lfs2_Chunk$__f_fs2$Chunk$$$NotApplied = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$15) => $m_Lfs2_Chunk$().Lfs2_Chunk$__f_fs2$Chunk$$$NotApplied));
  this.Lfs2_Chunk$__f_empty_ = new $c_Lfs2_Chunk$EmptyChunk();
  this.Lfs2_Chunk$__f_unit = new $c_Lfs2_Chunk$Singleton((void 0));
}
$c_Lfs2_Chunk$.prototype = new $h_O();
$c_Lfs2_Chunk$.prototype.constructor = $c_Lfs2_Chunk$;
/** @constructor */
function $h_Lfs2_Chunk$() {
}
$h_Lfs2_Chunk$.prototype = $c_Lfs2_Chunk$.prototype;
var $d_Lfs2_Chunk$ = new $TypeData().initClass($c_Lfs2_Chunk$, "fs2.Chunk$", ({
  Lfs2_Chunk$: 1,
  Lfs2_CollectorK: 1,
  Lfs2_ChunkCompanion213And3Compat: 1,
  Lfs2_ChunkCompanionPlatform: 1,
  Lfs2_ChunkCompanionRuntimePlatform: 1
}));
var $n_Lfs2_Chunk$;
function $m_Lfs2_Chunk$() {
  if ((!$n_Lfs2_Chunk$)) {
    $n_Lfs2_Chunk$ = new $c_Lfs2_Chunk$();
  }
  return $n_Lfs2_Chunk$;
}
/** @constructor */
function $c_Lfs2_Compiler$() {
  $n_Lfs2_Compiler$ = this;
  new $c_Lfs2_CompilerLowPriority0$$anon$3();
  new $c_Lfs2_CompilerLowPriority$$anon$4();
  new $c_Lfs2_Compiler$$anon$5();
}
$c_Lfs2_Compiler$.prototype = new $h_O();
$c_Lfs2_Compiler$.prototype.constructor = $c_Lfs2_Compiler$;
/** @constructor */
function $h_Lfs2_Compiler$() {
}
$h_Lfs2_Compiler$.prototype = $c_Lfs2_Compiler$.prototype;
var $d_Lfs2_Compiler$ = new $TypeData().initClass($c_Lfs2_Compiler$, "fs2.Compiler$", ({
  Lfs2_Compiler$: 1,
  Lfs2_CompilerLowPriority2: 1,
  Lfs2_CompilerLowPriority1: 1,
  Lfs2_CompilerLowPriority0: 1,
  Lfs2_CompilerLowPriority: 1
}));
var $n_Lfs2_Compiler$;
function $m_Lfs2_Compiler$() {
  if ((!$n_Lfs2_Compiler$)) {
    $n_Lfs2_Compiler$ = new $c_Lfs2_Compiler$();
  }
  return $n_Lfs2_Compiler$;
}
class $c_Lfs2_CompositeFailure extends $c_jl_Throwable {
  constructor(head, tail) {
    super();
    this.Lfs2_CompositeFailure__f_head = null;
    this.Lfs2_CompositeFailure__f_tail = null;
    this.Lfs2_CompositeFailure__f_head = head;
    this.Lfs2_CompositeFailure__f_tail = tail;
    var $x_1 = $n(tail).size__I();
    var this$1 = $n(head);
    var this$2 = $objectGetClass(this$1);
    var message = ((((("Multiple exceptions were thrown (" + ((1 + $x_1) | 0)) + "), first ") + this$2.data.name) + ": ") + $n(head).getMessage__T());
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, head, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lfs2_CompositeFailure)) {
      var x$0$2 = $as_Lfs2_CompositeFailure(x$0);
      var x = this.Lfs2_CompositeFailure__f_head;
      var x$2 = $n(x$0$2).Lfs2_CompositeFailure__f_head;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Lfs2_CompositeFailure__f_tail;
        var x$4 = $n(x$0$2).Lfs2_CompositeFailure__f_tail;
        var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        $n(x$0$2);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "CompositeFailure";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lfs2_CompositeFailure__f_head;
    }
    if ((n === 1)) {
      return this.Lfs2_CompositeFailure__f_tail;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
function $as_Lfs2_CompositeFailure(obj) {
  return (((obj instanceof $c_Lfs2_CompositeFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.CompositeFailure"));
}
function $isArrayOf_Lfs2_CompositeFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_CompositeFailure)));
}
function $asArrayOf_Lfs2_CompositeFailure(obj, depth) {
  return (($isArrayOf_Lfs2_CompositeFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.CompositeFailure;", depth));
}
var $d_Lfs2_CompositeFailure = new $TypeData().initClass($c_Lfs2_CompositeFailure, "fs2.CompositeFailure", ({
  Lfs2_CompositeFailure: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$1(f$14, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$1__f_f$1 = null;
  this.Lfs2_Pull$$anon$1__f_f$1 = f$14;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
$c_Lfs2_Pull$$anon$1.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$1.prototype.constructor = $c_Lfs2_Pull$$anon$1;
/** @constructor */
function $h_Lfs2_Pull$$anon$1() {
}
$h_Lfs2_Pull$$anon$1.prototype = $c_Lfs2_Pull$$anon$1.prototype;
$c_Lfs2_Pull$$anon$1.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(e) {
  if ((e instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$1 = $as_Lfs2_Pull$Succeeded(e);
    var this$2 = $n(x$1);
    var x15 = this$2.Lfs2_Pull$Succeeded__f_r;
    try {
      return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$1__f_f$1).apply__O__O(x15));
    } catch (e$2) {
      var e$3 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
      var x2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$3);
      if ((!$n(x2).isEmpty__Z())) {
        var x3 = $as_jl_Throwable($n(x2).get__O());
        return new $c_Lfs2_Pull$Fail(x3);
      }
      throw ((e$3 instanceof $c_sjs_js_JavaScriptException) ? e$3.sjs_js_JavaScriptException__f_exception : e$3);
    }
  }
  if ((e instanceof $c_Lfs2_Pull$Interrupted)) {
    var x$1$1 = $as_Lfs2_Pull$Interrupted(e);
    $n(x$1$1);
    $n(x$1$1);
    var res = $as_Lfs2_Pull$Interrupted(e);
    return res;
  }
  if ((e instanceof $c_Lfs2_Pull$Fail)) {
    var x$1$2 = $as_Lfs2_Pull$Fail(e);
    $n(x$1$2);
    var res$2 = $as_Lfs2_Pull$Fail(e);
    return res$2;
  }
  throw new $c_s_MatchError(e);
});
var $d_Lfs2_Pull$$anon$1 = new $TypeData().initClass($c_Lfs2_Pull$$anon$1, "fs2.Pull$$anon$1", ({
  Lfs2_Pull$$anon$1: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$2(post$3, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$2__f_post$1 = null;
  this.Lfs2_Pull$$anon$2__f_post$1 = post$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
$c_Lfs2_Pull$$anon$2.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$2.prototype.constructor = $c_Lfs2_Pull$$anon$2;
/** @constructor */
function $h_Lfs2_Pull$$anon$2() {
}
$h_Lfs2_Pull$$anon$2.prototype = $c_Lfs2_Pull$$anon$2.prototype;
$c_Lfs2_Pull$$anon$2.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  if ((r instanceof $c_Lfs2_Pull$Succeeded)) {
    return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$2__f_post$1).apply__O());
  }
  if ((r instanceof $c_Lfs2_Pull$Interrupted)) {
    var r$2 = $as_Lfs2_Pull$Interrupted(r);
    return r$2;
  }
  if ((r instanceof $c_Lfs2_Pull$Fail)) {
    var r$3 = $as_Lfs2_Pull$Fail(r);
    return r$3;
  }
  throw new $c_s_MatchError(r);
});
var $d_Lfs2_Pull$$anon$2 = new $TypeData().initClass($c_Lfs2_Pull$$anon$2, "fs2.Pull$$anon$2", ({
  Lfs2_Pull$$anon$2: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$3(handler$2, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$3__f_handler$1 = null;
  this.Lfs2_Pull$$anon$3__f_handler$1 = handler$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer);
}
$c_Lfs2_Pull$$anon$3.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$3.prototype.constructor = $c_Lfs2_Pull$$anon$3;
/** @constructor */
function $h_Lfs2_Pull$$anon$3() {
}
$h_Lfs2_Pull$$anon$3.prototype = $c_Lfs2_Pull$$anon$3.prototype;
$c_Lfs2_Pull$$anon$3.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(term) {
  if ((term instanceof $c_Lfs2_Pull$Fail)) {
    var x$1 = $as_Lfs2_Pull$Fail(term);
    var this$2 = $n(x$1);
    var x27 = this$2.Lfs2_Pull$Fail__f_error;
    try {
      return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$3__f_handler$1).apply__O__O(x27));
    } catch (e$2) {
      var e$3 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
      var x21 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$3);
      if ((!$n(x21).isEmpty__Z())) {
        var x22 = $as_jl_Throwable($n(x21).get__O());
        return new $c_Lfs2_Pull$Fail(x22);
      }
      throw ((e$3 instanceof $c_sjs_js_JavaScriptException) ? e$3.sjs_js_JavaScriptException__f_exception : e$3);
    }
  } else {
    return term;
  }
});
var $d_Lfs2_Pull$$anon$3 = new $TypeData().initClass($c_Lfs2_Pull$$anon$3, "fs2.Pull$$anon$3", ({
  Lfs2_Pull$$anon$3: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$7(fmoc$1, view$1) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$7__f_view$2 = null;
  this.Lfs2_Pull$$anon$7__f_view$2 = view$1;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, fmoc$1);
}
$c_Lfs2_Pull$$anon$7.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$7.prototype.constructor = $c_Lfs2_Pull$$anon$7;
/** @constructor */
function $h_Lfs2_Pull$$anon$7() {
}
$h_Lfs2_Pull$$anon$7.prototype = $c_Lfs2_Pull$$anon$7.prototype;
$c_Lfs2_Pull$$anon$7.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$7__f_view$2).apply__O__O(r));
});
var $d_Lfs2_Pull$$anon$7 = new $TypeData().initClass($c_Lfs2_Pull$$anon$7, "fs2.Pull$$anon$7", ({
  Lfs2_Pull$$anon$7: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$8(stream$3, childScope$1) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$8__f_childScope$2 = null;
  this.Lfs2_Pull$$anon$8__f_childScope$2 = childScope$1;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, stream$3);
}
$c_Lfs2_Pull$$anon$8.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$8.prototype.constructor = $c_Lfs2_Pull$$anon$8;
/** @constructor */
function $h_Lfs2_Pull$$anon$8() {
}
$h_Lfs2_Pull$$anon$8.prototype = $c_Lfs2_Pull$$anon$8.prototype;
$c_Lfs2_Pull$$anon$8.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$endScope$1__Lcats_effect_kernel_Unique$Token__Lfs2_Pull$Terminal__Lfs2_Pull($n(this.Lfs2_Pull$$anon$8__f_childScope$2).Lfs2_internal_Scope__f_id, r);
});
var $d_Lfs2_Pull$$anon$8 = new $TypeData().initClass($c_Lfs2_Pull$$anon$8, "fs2.Pull$$anon$8", ({
  Lfs2_Pull$$anon$8: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$$anon$9(p$2, f$11) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$9__f_f$12 = null;
  this.Lfs2_Pull$$anon$9__f_f$12 = f$11;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, p$2);
}
$c_Lfs2_Pull$$anon$9.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$9.prototype.constructor = $c_Lfs2_Pull$$anon$9;
/** @constructor */
function $h_Lfs2_Pull$$anon$9() {
}
$h_Lfs2_Pull$$anon$9.prototype = $c_Lfs2_Pull$$anon$9.prototype;
$c_Lfs2_Pull$$anon$9.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  try {
    return $as_Lfs2_Pull($n(this.Lfs2_Pull$$anon$9__f_f$12).apply__O__O(r));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x340 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(x340).isEmpty__Z())) {
      var x341 = $as_jl_Throwable($n(x340).get__O());
      return new $c_Lfs2_Pull$Fail(x341);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
var $d_Lfs2_Pull$$anon$9 = new $TypeData().initClass($c_Lfs2_Pull$$anon$9, "fs2.Pull$$anon$9", ({
  Lfs2_Pull$$anon$9: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$BindBind(step, bb, del) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$BindBind__f_bb = null;
  this.Lfs2_Pull$BindBind__f_del = null;
  this.Lfs2_Pull$BindBind__f_bb = bb;
  this.Lfs2_Pull$BindBind__f_del = del;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, step);
}
$c_Lfs2_Pull$BindBind.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$BindBind.prototype.constructor = $c_Lfs2_Pull$BindBind;
/** @constructor */
function $h_Lfs2_Pull$BindBind() {
}
$h_Lfs2_Pull$BindBind.prototype = $c_Lfs2_Pull$BindBind.prototype;
$c_Lfs2_Pull$BindBind.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(tx) {
  try {
    return $m_Lfs2_Pull$().fs2$Pull$$$bindBindAux__Lfs2_Pull__Lfs2_Pull$Bind__Lfs2_Pull($n(this.Lfs2_Pull$BindBind__f_bb).cont__Lfs2_Pull$Terminal__Lfs2_Pull(tx), this.Lfs2_Pull$BindBind__f_del);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x103 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!$n(x103).isEmpty__Z())) {
      var x104 = $as_jl_Throwable($n(x103).get__O());
      return new $c_Lfs2_Pull$Fail(x104);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
function $as_Lfs2_Pull$BindBind(obj) {
  return (((obj instanceof $c_Lfs2_Pull$BindBind) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$BindBind"));
}
function $isArrayOf_Lfs2_Pull$BindBind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$BindBind)));
}
function $asArrayOf_Lfs2_Pull$BindBind(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$BindBind(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$BindBind;", depth));
}
var $d_Lfs2_Pull$BindBind = new $TypeData().initClass($c_Lfs2_Pull$BindBind, "fs2.Pull$BindBind", ({
  Lfs2_Pull$BindBind: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_Pull$CloseScope() {
}
$c_Lfs2_Pull$CloseScope.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$CloseScope.prototype.constructor = $c_Lfs2_Pull$CloseScope;
/** @constructor */
function $h_Lfs2_Pull$CloseScope() {
}
$h_Lfs2_Pull$CloseScope.prototype = $c_Lfs2_Pull$CloseScope.prototype;
function $as_Lfs2_Pull$CloseScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$CloseScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$CloseScope"));
}
function $isArrayOf_Lfs2_Pull$CloseScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$CloseScope)));
}
function $asArrayOf_Lfs2_Pull$CloseScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$CloseScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$CloseScope;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$DelegateBind(step, delegate) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$DelegateBind__f_delegate = null;
  this.Lfs2_Pull$DelegateBind__f_delegate = delegate;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, step);
}
$c_Lfs2_Pull$DelegateBind.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$DelegateBind.prototype.constructor = $c_Lfs2_Pull$DelegateBind;
/** @constructor */
function $h_Lfs2_Pull$DelegateBind() {
}
$h_Lfs2_Pull$DelegateBind.prototype = $c_Lfs2_Pull$DelegateBind.prototype;
$c_Lfs2_Pull$DelegateBind.prototype.delegate__Lfs2_Pull$Bind = (function() {
  return this.Lfs2_Pull$DelegateBind__f_delegate;
});
$c_Lfs2_Pull$DelegateBind.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(yr) {
  return $n(this.Lfs2_Pull$DelegateBind__f_delegate).cont__Lfs2_Pull$Terminal__Lfs2_Pull(yr);
});
var $d_Lfs2_Pull$DelegateBind = new $TypeData().initClass($c_Lfs2_Pull$DelegateBind, "fs2.Pull$DelegateBind", ({
  Lfs2_Pull$DelegateBind: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$$anon$1() {
}
$c_Lfs2_internal_Scope$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lfs2_internal_Scope$$anon$1.prototype.constructor = $c_Lfs2_internal_Scope$$anon$1;
/** @constructor */
function $h_Lfs2_internal_Scope$$anon$1() {
}
$h_Lfs2_internal_Scope$$anon$1.prototype = $c_Lfs2_internal_Scope$$anon$1.prototype;
$c_Lfs2_internal_Scope$$anon$1.prototype.isDefinedAt__s_util_Either__Z = (function(x) {
  return ((x instanceof $c_s_util_Left) && ($as_jl_Throwable($n($as_s_util_Left(x)).s_util_Left__f_value), true));
});
$c_Lfs2_internal_Scope$$anon$1.prototype.applyOrElse__s_util_Either__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_util_Left)) {
    var err = $as_jl_Throwable($n($as_s_util_Left(x)).s_util_Left__f_value);
    return err;
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Lfs2_internal_Scope$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Either__Z($as_s_util_Either(x));
});
$c_Lfs2_internal_Scope$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Either__F1__O($as_s_util_Either(x), default$1);
});
var $d_Lfs2_internal_Scope$$anon$1 = new $TypeData().initClass($c_Lfs2_internal_Scope$$anon$1, "fs2.internal.Scope$$anon$1", ({
  Lfs2_internal_Scope$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$State$Closed() {
}
$c_Lfs2_internal_Scope$State$Closed.prototype = new $h_O();
$c_Lfs2_internal_Scope$State$Closed.prototype.constructor = $c_Lfs2_internal_Scope$State$Closed;
/** @constructor */
function $h_Lfs2_internal_Scope$State$Closed() {
}
$h_Lfs2_internal_Scope$State$Closed.prototype = $c_Lfs2_internal_Scope$State$Closed.prototype;
$c_Lfs2_internal_Scope$State$Closed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_Scope$State$Closed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_internal_Scope$State$Closed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
    var x$0$2 = $as_Lfs2_internal_Scope$State$Closed(x$0);
    $n(x$0$2);
    return true;
  } else {
    return false;
  }
});
$c_Lfs2_internal_Scope$State$Closed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productArity__I = (function() {
  return 0;
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productPrefix__T = (function() {
  return "Closed";
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_internal_Scope$State$Closed(obj) {
  return (((obj instanceof $c_Lfs2_internal_Scope$State$Closed) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope$State$Closed"));
}
function $isArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State$Closed)));
}
function $asArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope$State$Closed;", depth));
}
var $d_Lfs2_internal_Scope$State$Closed = new $TypeData().initClass($c_Lfs2_internal_Scope$State$Closed, "fs2.internal.Scope$State$Closed", ({
  Lfs2_internal_Scope$State$Closed: 1,
  Lfs2_internal_Scope$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_internal_Scope$State$Open(resources, children) {
  this.Lfs2_internal_Scope$State$Open__f_resources = null;
  this.Lfs2_internal_Scope$State$Open__f_children = null;
  this.Lfs2_internal_Scope$State$Open__f_resources = resources;
  this.Lfs2_internal_Scope$State$Open__f_children = children;
}
$c_Lfs2_internal_Scope$State$Open.prototype = new $h_O();
$c_Lfs2_internal_Scope$State$Open.prototype.constructor = $c_Lfs2_internal_Scope$State$Open;
/** @constructor */
function $h_Lfs2_internal_Scope$State$Open() {
}
$h_Lfs2_internal_Scope$State$Open.prototype = $c_Lfs2_internal_Scope$State$Open.prototype;
$c_Lfs2_internal_Scope$State$Open.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_internal_Scope$State$Open.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_internal_Scope$State$Open.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_internal_Scope$State$Open)) {
    var x$0$2 = $as_Lfs2_internal_Scope$State$Open(x$0);
    var x = this.Lfs2_internal_Scope$State$Open__f_resources;
    var x$2 = $n(x$0$2).Lfs2_internal_Scope$State$Open__f_resources;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_internal_Scope$State$Open__f_children;
      var x$4 = $n(x$0$2).Lfs2_internal_Scope$State$Open__f_children;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_internal_Scope$State$Open.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_internal_Scope$State$Open.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_internal_Scope$State$Open.prototype.productPrefix__T = (function() {
  return "Open";
});
$c_Lfs2_internal_Scope$State$Open.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_internal_Scope$State$Open__f_resources;
  }
  if ((n === 1)) {
    return this.Lfs2_internal_Scope$State$Open__f_children;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_internal_Scope$State$Open.prototype.unregisterChild__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope$State = (function(id) {
  var this$1 = $n(this.Lfs2_internal_Scope$State$Open__f_children);
  var acc = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  var x116;
  var acc$tailLocal2 = acc;
  var rem$tailLocal2 = this$1;
  while (true) {
    var x154 = $n(rem$tailLocal2).uncons__s_Option();
    if ((x154 instanceof $c_s_Some)) {
      var x156 = $as_T2($n($as_s_Some(x154)).s_Some__f_value);
      if ((x156 !== null)) {
        var a = $n(x156)._1__O();
        var tail = $as_Lcats_data_Chain($n(x156)._2__O());
        var _$21 = $as_Lfs2_internal_Scope(a);
        var x = $n(_$21).Lfs2_internal_Scope__f_id;
        if ((x === null)) {
          var $x_1 = (id === null);
        } else {
          var this$2 = $n(x);
          var $x_1 = (this$2 === id);
        }
        if ((!$x_1)) {
          var this$3 = $n(acc$tailLocal2);
          var acc$tailLocal2$tmp1 = this$3.append__O__Lcats_data_Chain(a);
          rem$tailLocal2 = tail;
          acc$tailLocal2 = acc$tailLocal2$tmp1;
          continue;
        }
        var this$4 = $n(acc$tailLocal2);
        var _2 = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$4, tail);
        var value = new $c_T2(a, _2);
        var x116 = new $c_s_Some(value);
        break;
      }
    }
    var x$1 = $m_s_None$();
    if ((x$1 === x154)) {
      var x116 = $m_s_None$();
      break;
    }
    throw new $c_s_MatchError(x154);
  }
  if ((x116 instanceof $c_s_Some)) {
    var x118 = $as_T2($n($as_s_Some(x116)).s_Some__f_value);
    if ((x118 !== null)) {
      var newChildren = $as_Lcats_data_Chain($n(x118)._2__O());
      var resources = this.Lfs2_internal_Scope$State$Open__f_resources;
      return new $c_Lfs2_internal_Scope$State$Open(resources, newChildren);
    }
  }
  var x$2 = $m_s_None$();
  if ((x$2 === x116)) {
    return this;
  }
  throw new $c_s_MatchError(x116);
});
function $as_Lfs2_internal_Scope$State$Open(obj) {
  return (((obj instanceof $c_Lfs2_internal_Scope$State$Open) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope$State$Open"));
}
function $isArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State$Open)));
}
function $asArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope$State$Open;", depth));
}
var $d_Lfs2_internal_Scope$State$Open = new $TypeData().initClass($c_Lfs2_internal_Scope$State$Open, "fs2.internal.Scope$State$Open", ({
  Lfs2_internal_Scope$State$Open: 1,
  Lfs2_internal_Scope$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_CursorOp$ArrayOp() {
}
$c_Lio_circe_CursorOp$ArrayOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$ArrayOp.prototype.constructor = $c_Lio_circe_CursorOp$ArrayOp;
/** @constructor */
function $h_Lio_circe_CursorOp$ArrayOp() {
}
$h_Lio_circe_CursorOp$ArrayOp.prototype = $c_Lio_circe_CursorOp$ArrayOp.prototype;
/** @constructor */
function $c_Lio_circe_CursorOp$ObjectOp() {
}
$c_Lio_circe_CursorOp$ObjectOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$ObjectOp.prototype.constructor = $c_Lio_circe_CursorOp$ObjectOp;
/** @constructor */
function $h_Lio_circe_CursorOp$ObjectOp() {
}
$h_Lio_circe_CursorOp$ObjectOp.prototype = $c_Lio_circe_CursorOp$ObjectOp.prototype;
/** @constructor */
function $c_Lio_circe_CursorOp$UnconstrainedOp() {
}
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.constructor = $c_Lio_circe_CursorOp$UnconstrainedOp;
/** @constructor */
function $h_Lio_circe_CursorOp$UnconstrainedOp() {
}
$h_Lio_circe_CursorOp$UnconstrainedOp.prototype = $c_Lio_circe_CursorOp$UnconstrainedOp.prototype;
function $ct_Lio_circe_DecodingFailure__Lcats_Eval__($thiz, lazyReason) {
  $thiz.Lio_circe_DecodingFailure__f_lazyReason = lazyReason;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_Lio_circe_DecodingFailure extends $c_Lio_circe_Error {
  constructor() {
    super();
    this.Lio_circe_DecodingFailure__f_lazyReason = null;
  }
  message__T() {
    var x18 = $as_Lio_circe_DecodingFailure$Reason($n(this.Lio_circe_DecodingFailure__f_lazyReason).value__O());
    if ((x18 instanceof $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation)) {
      var x$1 = $as_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation(x18);
      var this$2 = $n(x$1);
      var x24 = this$2.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType;
      var this$3 = $n(x$1);
      var x25 = this$3.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue;
      var this$4 = $n(x25);
      return ((("Got value '" + $n($m_Lio_circe_Printer$().Lio_circe_Printer$__f_noSpaces).print__Lio_circe_Json__T(this$4)) + "' with wrong type, expecting ") + x24);
    }
    var x = $m_Lio_circe_DecodingFailure$Reason$MissingField$();
    if ((x === x18)) {
      return "Missing required field";
    }
    if ((x18 instanceof $c_Lio_circe_DecodingFailure$Reason$CustomReason)) {
      var x$1$1 = $as_Lio_circe_DecodingFailure$Reason$CustomReason(x18);
      var this$6 = $n(x$1$1);
      var x21 = this$6.Lio_circe_DecodingFailure$Reason$CustomReason__f_message;
      return x21;
    }
    throw new $c_s_MatchError(x18);
  }
  getMessage__T() {
    return $n($m_Lio_circe_DecodingFailure$().Lio_circe_DecodingFailure$__f_showDecodingFailure).show__O__T(this);
  }
  copy__T__F0__Lio_circe_DecodingFailure(message, history) {
    return $m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$CustomReason(message), history);
  }
  toString__T() {
    var this$1 = $n(this.pathToRootString__s_Option());
    if (this$1.isEmpty__Z()) {
      return (((("DecodingFailure(" + this.message__T()) + ", ") + this.history__sci_List()) + ")");
    } else {
      var x0 = this$1.get__O();
      var pathToRootString = $as_T(x0);
      return ((("DecodingFailure at " + pathToRootString) + ": ") + this.message__T());
    }
  }
  equals__O__Z(that) {
    if ((that instanceof $c_Lio_circe_DecodingFailure)) {
      var other = $as_Lio_circe_DecodingFailure(that);
      return $n($m_Lio_circe_DecodingFailure$().Lio_circe_DecodingFailure$__f_eqDecodingFailure).eqv__O__O__Z(this, other);
    } else {
      return false;
    }
  }
  hashCode__I() {
    return $f_T__hashCode__I($n(this.message__T()));
  }
}
function $as_Lio_circe_DecodingFailure(obj) {
  return (((obj instanceof $c_Lio_circe_DecodingFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.DecodingFailure"));
}
function $isArrayOf_Lio_circe_DecodingFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_DecodingFailure)));
}
function $asArrayOf_Lio_circe_DecodingFailure(obj, depth) {
  return (($isArrayOf_Lio_circe_DecodingFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.DecodingFailure;", depth));
}
/** @constructor */
function $c_Lio_circe_DecodingFailure$Reason$CustomReason(message) {
  this.Lio_circe_DecodingFailure$Reason$CustomReason__f_message = null;
  this.Lio_circe_DecodingFailure$Reason$CustomReason__f_message = message;
}
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype = new $h_Lio_circe_DecodingFailure$Reason();
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.constructor = $c_Lio_circe_DecodingFailure$Reason$CustomReason;
/** @constructor */
function $h_Lio_circe_DecodingFailure$Reason$CustomReason() {
}
$h_Lio_circe_DecodingFailure$Reason$CustomReason.prototype = $c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype;
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2016764043, true);
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_DecodingFailure$Reason$CustomReason)) {
    var x$0$2 = $as_Lio_circe_DecodingFailure$Reason$CustomReason(x$0);
    return ((this.Lio_circe_DecodingFailure$Reason$CustomReason__f_message === $n(x$0$2).Lio_circe_DecodingFailure$Reason$CustomReason__f_message) && ($n(x$0$2), true));
  } else {
    return false;
  }
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.productPrefix__T = (function() {
  return "CustomReason";
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_DecodingFailure$Reason$CustomReason__f_message;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lio_circe_DecodingFailure$Reason$CustomReason(obj) {
  return (((obj instanceof $c_Lio_circe_DecodingFailure$Reason$CustomReason) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.DecodingFailure$Reason$CustomReason"));
}
function $isArrayOf_Lio_circe_DecodingFailure$Reason$CustomReason(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_DecodingFailure$Reason$CustomReason)));
}
function $asArrayOf_Lio_circe_DecodingFailure$Reason$CustomReason(obj, depth) {
  return (($isArrayOf_Lio_circe_DecodingFailure$Reason$CustomReason(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.DecodingFailure$Reason$CustomReason;", depth));
}
var $d_Lio_circe_DecodingFailure$Reason$CustomReason = new $TypeData().initClass($c_Lio_circe_DecodingFailure$Reason$CustomReason, "io.circe.DecodingFailure$Reason$CustomReason", ({
  Lio_circe_DecodingFailure$Reason$CustomReason: 1,
  Lio_circe_DecodingFailure$Reason: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation(expectedJsonFieldType, jsonValue) {
  this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType = null;
  this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue = null;
  this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType = expectedJsonFieldType;
  this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue = jsonValue;
}
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype = new $h_Lio_circe_DecodingFailure$Reason();
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.constructor = $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation;
/** @constructor */
function $h_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation() {
}
$h_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype = $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype;
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-653731207), true);
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation)) {
    var x$0$2 = $as_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation(x$0);
    if ((this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType === $n(x$0$2).Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType)) {
      var x = this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue;
      var x$2 = $n(x$0$2).Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.productArity__I = (function() {
  return 2;
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.productPrefix__T = (function() {
  return "WrongTypeExpectation";
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType;
  }
  if ((n === 1)) {
    return this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation(obj) {
  return (((obj instanceof $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.DecodingFailure$Reason$WrongTypeExpectation"));
}
function $isArrayOf_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation)));
}
function $asArrayOf_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation(obj, depth) {
  return (($isArrayOf_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.DecodingFailure$Reason$WrongTypeExpectation;", depth));
}
var $d_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation = new $TypeData().initClass($c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation, "io.circe.DecodingFailure$Reason$WrongTypeExpectation", ({
  Lio_circe_DecodingFailure$Reason$WrongTypeExpectation: 1,
  Lio_circe_DecodingFailure$Reason: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_Encoder$$anon$7() {
}
$c_Lio_circe_Encoder$$anon$7.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$7.prototype.constructor = $c_Lio_circe_Encoder$$anon$7;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$7() {
}
$h_Lio_circe_Encoder$$anon$7.prototype = $c_Lio_circe_Encoder$$anon$7.prototype;
$c_Lio_circe_Encoder$$anon$7.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$c_Lio_circe_Encoder$$anon$7.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  $as_jl_Void(a);
  return $m_Lio_circe_JsonObject$().Lio_circe_JsonObject$__f_empty;
});
var $d_Lio_circe_Encoder$$anon$7 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$7, "io.circe.Encoder$$anon$7", ({
  Lio_circe_Encoder$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
}));
/** @constructor */
function $c_Lio_circe_Json$JArray(value) {
  this.Lio_circe_Json$JArray__f_value = null;
  this.Lio_circe_Json$JArray__f_value = value;
}
$c_Lio_circe_Json$JArray.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JArray.prototype.constructor = $c_Lio_circe_Json$JArray;
/** @constructor */
function $h_Lio_circe_Json$JArray() {
}
$h_Lio_circe_Json$JArray.prototype = $c_Lio_circe_Json$JArray.prototype;
$c_Lio_circe_Json$JArray.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1627390131), true);
});
$c_Lio_circe_Json$JArray.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JArray.prototype.productPrefix__T = (function() {
  return "JArray";
});
$c_Lio_circe_Json$JArray.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JArray__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JArray.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onArray__sci_Vector__O(this.Lio_circe_Json$JArray__f_value);
});
$c_Lio_circe_Json$JArray.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JArray.prototype.isArray__Z = (function() {
  return true;
});
$c_Lio_circe_Json$JArray.prototype.asArray__s_Option = (function() {
  var value = this.Lio_circe_Json$JArray__f_value;
  return new $c_s_Some(value);
});
function $as_Lio_circe_Json$JArray(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JArray) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JArray"));
}
function $isArrayOf_Lio_circe_Json$JArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JArray)));
}
function $asArrayOf_Lio_circe_Json$JArray(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JArray;", depth));
}
var $d_Lio_circe_Json$JArray = new $TypeData().initClass($c_Lio_circe_Json$JArray, "io.circe.Json$JArray", ({
  Lio_circe_Json$JArray: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_Json$JBoolean(value) {
  this.Lio_circe_Json$JBoolean__f_value = false;
  this.Lio_circe_Json$JBoolean__f_value = value;
}
$c_Lio_circe_Json$JBoolean.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JBoolean.prototype.constructor = $c_Lio_circe_Json$JBoolean;
/** @constructor */
function $h_Lio_circe_Json$JBoolean() {
}
$h_Lio_circe_Json$JBoolean.prototype = $c_Lio_circe_Json$JBoolean.prototype;
$c_Lio_circe_Json$JBoolean.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash, 1848310910);
  var hash$1 = acc;
  var data = (this.Lio_circe_Json$JBoolean__f_value ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lio_circe_Json$JBoolean.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JBoolean.prototype.productPrefix__T = (function() {
  return "JBoolean";
});
$c_Lio_circe_Json$JBoolean.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JBoolean__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JBoolean.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onBoolean__Z__O(this.Lio_circe_Json$JBoolean__f_value);
});
$c_Lio_circe_Json$JBoolean.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JBoolean.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JBoolean.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
function $as_Lio_circe_Json$JBoolean(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JBoolean"));
}
function $isArrayOf_Lio_circe_Json$JBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JBoolean)));
}
function $asArrayOf_Lio_circe_Json$JBoolean(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JBoolean;", depth));
}
var $d_Lio_circe_Json$JBoolean = new $TypeData().initClass($c_Lio_circe_Json$JBoolean, "io.circe.Json$JBoolean", ({
  Lio_circe_Json$JBoolean: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_Json$JNumber(value) {
  this.Lio_circe_Json$JNumber__f_value = null;
  this.Lio_circe_Json$JNumber__f_value = value;
}
$c_Lio_circe_Json$JNumber.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JNumber.prototype.constructor = $c_Lio_circe_Json$JNumber;
/** @constructor */
function $h_Lio_circe_Json$JNumber() {
}
$h_Lio_circe_Json$JNumber.prototype = $c_Lio_circe_Json$JNumber.prototype;
$c_Lio_circe_Json$JNumber.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-124218111), true);
});
$c_Lio_circe_Json$JNumber.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JNumber.prototype.productPrefix__T = (function() {
  return "JNumber";
});
$c_Lio_circe_Json$JNumber.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JNumber__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JNumber.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onNumber__Lio_circe_JsonNumber__O(this.Lio_circe_Json$JNumber__f_value);
});
$c_Lio_circe_Json$JNumber.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JNumber.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JNumber.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
function $as_Lio_circe_Json$JNumber(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JNumber"));
}
function $isArrayOf_Lio_circe_Json$JNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JNumber)));
}
function $asArrayOf_Lio_circe_Json$JNumber(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JNumber;", depth));
}
var $d_Lio_circe_Json$JNumber = new $TypeData().initClass($c_Lio_circe_Json$JNumber, "io.circe.Json$JNumber", ({
  Lio_circe_Json$JNumber: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_Json$JObject(value) {
  this.Lio_circe_Json$JObject__f_value = null;
  this.Lio_circe_Json$JObject__f_value = value;
}
$c_Lio_circe_Json$JObject.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JObject.prototype.constructor = $c_Lio_circe_Json$JObject;
/** @constructor */
function $h_Lio_circe_Json$JObject() {
}
$h_Lio_circe_Json$JObject.prototype = $c_Lio_circe_Json$JObject.prototype;
$c_Lio_circe_Json$JObject.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 330919449, true);
});
$c_Lio_circe_Json$JObject.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JObject.prototype.productPrefix__T = (function() {
  return "JObject";
});
$c_Lio_circe_Json$JObject.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JObject__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JObject.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onObject__Lio_circe_JsonObject__O(this.Lio_circe_Json$JObject__f_value);
});
$c_Lio_circe_Json$JObject.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JObject.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JObject.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
function $as_Lio_circe_Json$JObject(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JObject) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JObject"));
}
function $isArrayOf_Lio_circe_Json$JObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JObject)));
}
function $asArrayOf_Lio_circe_Json$JObject(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JObject;", depth));
}
var $d_Lio_circe_Json$JObject = new $TypeData().initClass($c_Lio_circe_Json$JObject, "io.circe.Json$JObject", ({
  Lio_circe_Json$JObject: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_Json$JString(value) {
  this.Lio_circe_Json$JString__f_value = null;
  this.Lio_circe_Json$JString__f_value = value;
}
$c_Lio_circe_Json$JString.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JString.prototype.constructor = $c_Lio_circe_Json$JString;
/** @constructor */
function $h_Lio_circe_Json$JString() {
}
$h_Lio_circe_Json$JString.prototype = $c_Lio_circe_Json$JString.prototype;
$c_Lio_circe_Json$JString.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1660707310), true);
});
$c_Lio_circe_Json$JString.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JString.prototype.productPrefix__T = (function() {
  return "JString";
});
$c_Lio_circe_Json$JString.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JString__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JString.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onString__T__O(this.Lio_circe_Json$JString__f_value);
});
$c_Lio_circe_Json$JString.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JString.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JString.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
function $as_Lio_circe_Json$JString(obj) {
  return (((obj instanceof $c_Lio_circe_Json$JString) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.Json$JString"));
}
function $isArrayOf_Lio_circe_Json$JString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JString)));
}
function $asArrayOf_Lio_circe_Json$JString(obj, depth) {
  return (($isArrayOf_Lio_circe_Json$JString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.Json$JString;", depth));
}
var $d_Lio_circe_Json$JString = new $TypeData().initClass($c_Lio_circe_Json$JString, "io.circe.Json$JString", ({
  Lio_circe_Json$JString: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lio_circe_JsonBigDecimal(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonBigDecimal"));
}
function $isArrayOf_Lio_circe_JsonBigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonBigDecimal)));
}
function $asArrayOf_Lio_circe_JsonBigDecimal(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonBigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonBigDecimal;", depth));
}
/** @constructor */
function $c_Lio_circe_JsonDouble(value) {
  this.Lio_circe_JsonDouble__f_value = 0.0;
  this.Lio_circe_JsonDouble__f_value = value;
}
$c_Lio_circe_JsonDouble.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonDouble.prototype.constructor = $c_Lio_circe_JsonDouble;
/** @constructor */
function $h_Lio_circe_JsonDouble() {
}
$h_Lio_circe_JsonDouble.prototype = $c_Lio_circe_JsonDouble.prototype;
$c_Lio_circe_JsonDouble.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_JsonDouble.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_JsonDouble.prototype.productPrefix__T = (function() {
  return "JsonDouble";
});
$c_Lio_circe_JsonDouble.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_JsonDouble__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_JsonDouble.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromDoubleUnsafe__D__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonDouble__f_value);
});
$c_Lio_circe_JsonDouble.prototype.toLong__s_Option = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  var asBigDecimal = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
  if ($m_Lio_circe_JsonNumber$().bigDecimalIsValidLong__Ljava_math_BigDecimal__Z(asBigDecimal)) {
    var $x_1 = $n(asBigDecimal).longValue__J();
    var value_$_lo = $x_1.l;
    var value_$_hi = $x_1.h;
    return new $c_s_Some($bL(value_$_lo, value_$_hi));
  } else {
    return $m_s_None$();
  }
});
$c_Lio_circe_JsonDouble.prototype.toString__T = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  return ("" + d);
});
function $as_Lio_circe_JsonDouble(obj) {
  return (((obj instanceof $c_Lio_circe_JsonDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonDouble"));
}
function $isArrayOf_Lio_circe_JsonDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonDouble)));
}
function $asArrayOf_Lio_circe_JsonDouble(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonDouble;", depth));
}
var $d_Lio_circe_JsonDouble = new $TypeData().initClass($c_Lio_circe_JsonDouble, "io.circe.JsonDouble", ({
  Lio_circe_JsonDouble: 1,
  Lio_circe_JsonNumber: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
function $as_Lio_circe_JsonFloat(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonFloat"));
}
function $isArrayOf_Lio_circe_JsonFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonFloat)));
}
function $asArrayOf_Lio_circe_JsonFloat(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonFloat;", depth));
}
/** @constructor */
function $c_Lio_circe_JsonLong(value_$_lo, value_$_hi) {
  this.Lio_circe_JsonLong__f_value_$lo = 0;
  this.Lio_circe_JsonLong__f_value_$hi = 0;
  this.Lio_circe_JsonLong__f_value_$lo = value_$_lo;
  this.Lio_circe_JsonLong__f_value_$hi = value_$_hi;
}
$c_Lio_circe_JsonLong.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonLong.prototype.constructor = $c_Lio_circe_JsonLong;
/** @constructor */
function $h_Lio_circe_JsonLong() {
}
$h_Lio_circe_JsonLong.prototype = $c_Lio_circe_JsonLong.prototype;
$c_Lio_circe_JsonLong.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_JsonLong.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_JsonLong.prototype.productPrefix__T = (function() {
  return "JsonLong";
});
$c_Lio_circe_JsonLong.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return $bL(this.Lio_circe_JsonLong__f_value_$lo, this.Lio_circe_JsonLong__f_value_$hi);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_JsonLong.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromLong__J__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonLong__f_value_$lo, this.Lio_circe_JsonLong__f_value_$hi);
});
$c_Lio_circe_JsonLong.prototype.toLong__s_Option = (function() {
  var value_$_lo = this.Lio_circe_JsonLong__f_value_$lo;
  var value_$_hi = this.Lio_circe_JsonLong__f_value_$hi;
  return new $c_s_Some($bL(value_$_lo, value_$_hi));
});
$c_Lio_circe_JsonLong.prototype.toString__T = (function() {
  var i_$_lo = this.Lio_circe_JsonLong__f_value_$lo;
  var i_$_hi = this.Lio_circe_JsonLong__f_value_$hi;
  return $m_RTLong$().toString__I__I__T(i_$_lo, i_$_hi);
});
function $as_Lio_circe_JsonLong(obj) {
  return (((obj instanceof $c_Lio_circe_JsonLong) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.JsonLong"));
}
function $isArrayOf_Lio_circe_JsonLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonLong)));
}
function $asArrayOf_Lio_circe_JsonLong(obj, depth) {
  return (($isArrayOf_Lio_circe_JsonLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.JsonLong;", depth));
}
var $d_Lio_circe_JsonLong = new $TypeData().initClass($c_Lio_circe_JsonLong, "io.circe.JsonLong", ({
  Lio_circe_JsonLong: 1,
  Lio_circe_JsonNumber: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
function $ct_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__Lio_circe_MidPriorityEncoders__Lio_circe_Encoder__($thiz, outer, encodeA) {
  $thiz.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = encodeA;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $thiz;
}
/** @constructor */
function $c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder() {
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = null;
}
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype = new $h_O();
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype.constructor = $c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder;
/** @constructor */
function $h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder() {
}
$h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype = $c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype;
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsArray__apply__O__Lio_circe_Json(this, a);
});
$c_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder.prototype.encodeArray__O__sci_Vector = (function(a) {
  $m_sci_Vector$();
  var builder = new $c_sci_VectorBuilder();
  var a$1 = $as_sci_List(a);
  var iterator = $n(a$1).iterator__sc_Iterator();
  while ($n(iterator).hasNext__Z()) {
    var elem = $n(this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA).apply__O__Lio_circe_Json($n(iterator).next__O());
    builder.addOne__O__sci_VectorBuilder(elem);
  }
  return builder.result__sci_Vector();
});
/** @constructor */
function $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(index_$_lo, index_$_hi) {
  this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$lo = 0;
  this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$hi = 0;
  this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$lo = index_$_lo;
  this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$hi = index_$_hi;
}
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype = new $h_Lio_circe_PathToRoot$PathElem();
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.constructor = $c_Lio_circe_PathToRoot$PathElem$ArrayIndex;
/** @constructor */
function $h_Lio_circe_PathToRoot$PathElem$ArrayIndex() {
}
$h_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype = $c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype;
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash, 760492569);
  var hash$1 = acc;
  var lv_$_lo = this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$lo;
  var lv_$_hi = this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$hi;
  var data = $m_sr_Statics$().longHash__J__I(lv_$_lo, lv_$_hi);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_PathToRoot$PathElem$ArrayIndex)) {
    var x$0$2 = $as_Lio_circe_PathToRoot$PathElem$ArrayIndex(x$0);
    var x_$_lo = this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$lo;
    var x_$_hi = this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$hi;
    var x$1_$_lo = $n(x$0$2).Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$lo;
    var x$1_$_hi = $n(x$0$2).Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$hi;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return false;
  }
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.productPrefix__T = (function() {
  return "ArrayIndex";
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return $bL(this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$lo, this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index_$hi);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lio_circe_PathToRoot$PathElem$ArrayIndex(obj) {
  return (((obj instanceof $c_Lio_circe_PathToRoot$PathElem$ArrayIndex) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.PathToRoot$PathElem$ArrayIndex"));
}
function $isArrayOf_Lio_circe_PathToRoot$PathElem$ArrayIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_PathToRoot$PathElem$ArrayIndex)));
}
function $asArrayOf_Lio_circe_PathToRoot$PathElem$ArrayIndex(obj, depth) {
  return (($isArrayOf_Lio_circe_PathToRoot$PathElem$ArrayIndex(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.PathToRoot$PathElem$ArrayIndex;", depth));
}
var $d_Lio_circe_PathToRoot$PathElem$ArrayIndex = new $TypeData().initClass($c_Lio_circe_PathToRoot$PathElem$ArrayIndex, "io.circe.PathToRoot$PathElem$ArrayIndex", ({
  Lio_circe_PathToRoot$PathElem$ArrayIndex: 1,
  Lio_circe_PathToRoot$PathElem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_PathToRoot$PathElem$ObjectKey(keyName) {
  this.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName = null;
  this.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName = keyName;
}
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype = new $h_Lio_circe_PathToRoot$PathElem();
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.constructor = $c_Lio_circe_PathToRoot$PathElem$ObjectKey;
/** @constructor */
function $h_Lio_circe_PathToRoot$PathElem$ObjectKey() {
}
$h_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype = $c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype;
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1657275149), true);
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_PathToRoot$PathElem$ObjectKey)) {
    var x$0$2 = $as_Lio_circe_PathToRoot$PathElem$ObjectKey(x$0);
    return (this.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName === $n(x$0$2).Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName);
  } else {
    return false;
  }
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.productPrefix__T = (function() {
  return "ObjectKey";
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lio_circe_PathToRoot$PathElem$ObjectKey(obj) {
  return (((obj instanceof $c_Lio_circe_PathToRoot$PathElem$ObjectKey) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.PathToRoot$PathElem$ObjectKey"));
}
function $isArrayOf_Lio_circe_PathToRoot$PathElem$ObjectKey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_PathToRoot$PathElem$ObjectKey)));
}
function $asArrayOf_Lio_circe_PathToRoot$PathElem$ObjectKey(obj, depth) {
  return (($isArrayOf_Lio_circe_PathToRoot$PathElem$ObjectKey(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.PathToRoot$PathElem$ObjectKey;", depth));
}
var $d_Lio_circe_PathToRoot$PathElem$ObjectKey = new $TypeData().initClass($c_Lio_circe_PathToRoot$PathElem$ObjectKey, "io.circe.PathToRoot$PathElem$ObjectKey", ({
  Lio_circe_PathToRoot$PathElem$ObjectKey: 1,
  Lio_circe_PathToRoot$PathElem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
}
$c_Ljava_io_FilterOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_Ljava_io_FilterOutputStream.prototype.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
}
$h_Ljava_io_FilterOutputStream.prototype = $c_Ljava_io_FilterOutputStream.prototype;
class $c_jl_ArithmeticException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
function $as_jl_ArithmeticException(obj) {
  return (((obj instanceof $c_jl_ArithmeticException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ArithmeticException"));
}
function $isArrayOf_jl_ArithmeticException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArithmeticException)));
}
function $asArrayOf_jl_ArithmeticException(obj, depth) {
  return (($isArrayOf_jl_ArithmeticException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ArithmeticException;", depth));
}
var $d_jl_ArithmeticException = new $TypeData().initClass($c_jl_ArithmeticException, "java.lang.ArithmeticException", ({
  jl_ArithmeticException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_jl_ArrayStoreException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_jl_ArrayStoreException = new $TypeData().initClass($c_jl_ArrayStoreException, "java.lang.ArrayStoreException", ({
  jl_ArrayStoreException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $f_jl_Byte__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Byte__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Byte__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Byte__compareTo__O__I($thiz, o) {
  var that = $as_jl_Byte(o);
  var this$1 = $n(that);
  return (($thiz - this$1) | 0);
}
function $as_jl_Byte(obj) {
  return (($isByte(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Byte"));
}
function $isArrayOf_jl_Byte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Byte)));
}
function $asArrayOf_jl_Byte(obj, depth) {
  return (($isArrayOf_jl_Byte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Byte;", depth));
}
var $d_jl_Byte = new $TypeData().initClass(0, "java.lang.Byte", ({
  jl_Byte: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => $isByte(x)));
function $ct_jl_ClassCastException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_ClassCastException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_ClassCastException extends $c_jl_RuntimeException {
}
function $as_jl_ClassCastException(obj) {
  return (((obj instanceof $c_jl_ClassCastException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ClassCastException"));
}
function $isArrayOf_jl_ClassCastException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ClassCastException)));
}
function $asArrayOf_jl_ClassCastException(obj, depth) {
  return (($isArrayOf_jl_ClassCastException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ClassCastException;", depth));
}
var $d_jl_ClassCastException = new $TypeData().initClass($c_jl_ClassCastException, "java.lang.ClassCastException", ({
  jl_ClassCastException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_IllegalArgumentException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IllegalArgumentException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IllegalArgumentException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalArgumentException = new $TypeData().initClass($c_jl_IllegalArgumentException, "java.lang.IllegalArgumentException", ({
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_IllegalStateException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IllegalStateException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IllegalStateException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalStateException = new $TypeData().initClass($c_jl_IllegalStateException, "java.lang.IllegalStateException", ({
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_IndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IndexOutOfBoundsException__I__($thiz, index) {
  var s = ("Index out of range: " + index);
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_IndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_IndexOutOfBoundsException extends $c_jl_RuntimeException {
}
var $d_jl_IndexOutOfBoundsException = new $TypeData().initClass($c_jl_IndexOutOfBoundsException, "java.lang.IndexOutOfBoundsException", ({
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype;
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $TypeData().initClass($c_jl_JSConsoleBasedPrintStream$DummyOutputStream, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", ({
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 1,
  Ljava_io_OutputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
}));
class $c_jl_NegativeArraySizeException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
var $d_jl_NegativeArraySizeException = new $TypeData().initClass($c_jl_NegativeArraySizeException, "java.lang.NegativeArraySizeException", ({
  jl_NegativeArraySizeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_NullPointerException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_NullPointerException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_NullPointerException extends $c_jl_RuntimeException {
}
var $d_jl_NullPointerException = new $TypeData().initClass($c_jl_NullPointerException, "java.lang.NullPointerException", ({
  jl_NullPointerException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $as_jl_SecurityException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.SecurityException"));
}
function $isArrayOf_jl_SecurityException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_SecurityException)));
}
function $asArrayOf_jl_SecurityException(obj, depth) {
  return (($isArrayOf_jl_SecurityException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.SecurityException;", depth));
}
function $f_jl_Short__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Short__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Short__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Short__compareTo__O__I($thiz, o) {
  var that = $as_jl_Short(o);
  var this$1 = $n(that);
  return (($thiz - this$1) | 0);
}
function $as_jl_Short(obj) {
  return (($isShort(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Short"));
}
function $isArrayOf_jl_Short(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Short)));
}
function $asArrayOf_jl_Short(obj, depth) {
  return (($isArrayOf_jl_Short(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Short;", depth));
}
var $d_jl_Short = new $TypeData().initClass(0, "java.lang.Short", ({
  jl_Short: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => $isShort(x)));
class $c_jl_StackOverflowError extends $c_jl_VirtualMachineError {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_jl_StackOverflowError = new $TypeData().initClass($c_jl_StackOverflowError, "java.lang.StackOverflowError", ({
  jl_StackOverflowError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_jl_UnsupportedOperationException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
function $ct_jl_UnsupportedOperationException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
class $c_jl_UnsupportedOperationException extends $c_jl_RuntimeException {
}
var $d_jl_UnsupportedOperationException = new $TypeData().initClass($c_jl_UnsupportedOperationException, "java.lang.UnsupportedOperationException", ({
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Ljava_time_DateTimeException__T__jl_Throwable__($thiz, message, cause) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz;
}
function $ct_Ljava_time_DateTimeException__T__($thiz, message) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, null, true, true);
  return $thiz;
}
class $c_Ljava_time_DateTimeException extends $c_jl_RuntimeException {
}
function $as_Ljava_time_DateTimeException(obj) {
  return (((obj instanceof $c_Ljava_time_DateTimeException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.DateTimeException"));
}
function $isArrayOf_Ljava_time_DateTimeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_DateTimeException)));
}
function $asArrayOf_Ljava_time_DateTimeException(obj, depth) {
  return (($isArrayOf_Ljava_time_DateTimeException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.DateTimeException;", depth));
}
var $d_Ljava_time_DateTimeException = new $TypeData().initClass($c_Ljava_time_DateTimeException, "java.time.DateTimeException", ({
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ljava_time_Duration(seconds_$_lo, seconds_$_hi, nanos) {
  this.Ljava_time_Duration__f_seconds_$lo = 0;
  this.Ljava_time_Duration__f_seconds_$hi = 0;
  this.Ljava_time_Duration__f_nanos = 0;
  this.Ljava_time_Duration__f_seconds_$lo = seconds_$_lo;
  this.Ljava_time_Duration__f_seconds_$hi = seconds_$_hi;
  this.Ljava_time_Duration__f_nanos = nanos;
}
$c_Ljava_time_Duration.prototype = new $h_O();
$c_Ljava_time_Duration.prototype.constructor = $c_Ljava_time_Duration;
/** @constructor */
function $h_Ljava_time_Duration() {
}
$h_Ljava_time_Duration.prototype = $c_Ljava_time_Duration.prototype;
$c_Ljava_time_Duration.prototype.compare__Ljava_time_Duration__I = (function(otherDuration) {
  var x_$_lo = this.Ljava_time_Duration__f_seconds_$lo;
  var x_$_hi = this.Ljava_time_Duration__f_seconds_$hi;
  var y_$_lo = $n(otherDuration).Ljava_time_Duration__f_seconds_$lo;
  var y_$_hi = $n(otherDuration).Ljava_time_Duration__f_seconds_$hi;
  var cmp = ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
  return ((cmp !== 0) ? cmp : ((this.Ljava_time_Duration__f_nanos - $n(otherDuration).Ljava_time_Duration__f_nanos) | 0));
});
$c_Ljava_time_Duration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_Duration)) {
    var otherDuration = $as_Ljava_time_Duration(other);
    if ((this === otherDuration)) {
      return true;
    } else {
      var x_$_lo = this.Ljava_time_Duration__f_seconds_$lo;
      var x_$_hi = this.Ljava_time_Duration__f_seconds_$hi;
      var x$1_$_lo = $n(otherDuration).Ljava_time_Duration__f_seconds_$lo;
      var x$1_$_hi = $n(otherDuration).Ljava_time_Duration__f_seconds_$hi;
      if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
        return (this.Ljava_time_Duration__f_nanos === $n(otherDuration).Ljava_time_Duration__f_nanos);
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_Duration.prototype.hashCode__I = (function() {
  var x$1_$_lo = this.Ljava_time_Duration__f_seconds_$lo;
  var x$1_$_hi = this.Ljava_time_Duration__f_seconds_$hi;
  var x_$_lo = this.Ljava_time_Duration__f_seconds_$lo;
  var x_$_hi = this.Ljava_time_Duration__f_seconds_$hi;
  var lo = (x$1_$_lo ^ x_$_hi);
  return ((lo + Math.imul(51, this.Ljava_time_Duration__f_nanos)) | 0);
});
$c_Ljava_time_Duration.prototype.toString__T = (function() {
  if ((this === $m_Ljava_time_Duration$().ZERO__Ljava_time_Duration())) {
    return "PT0S";
  }
  var num_$_lo = this.Ljava_time_Duration__f_seconds_$lo;
  var num_$_hi = this.Ljava_time_Duration__f_seconds_$hi;
  var hi = (num_$_hi >> 31);
  var b0 = (65535 & num_$_lo);
  var b1 = ((num_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(23010, b0);
  var a1b0 = Math.imul(18641, b0);
  var a0b1 = Math.imul(23010, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(18641, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & num_$_lo);
  var b1$1 = ((num_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(31749, b0$1);
  var a1b0$1 = Math.imul(27379, b0$1);
  var a0b1$1 = Math.imul(31749, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(27379, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & num_$_hi);
  var b1$2 = ((num_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(23010, b0$2);
  var a1b0$2 = Math.imul(18641, b0$2);
  var a0b1$2 = Math.imul(23010, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(1221679586, hi) + Math.imul(18641, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & num_$_hi);
  var b1$3 = ((num_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(31749, b0$3);
  var a1b0$3 = Math.imul(27379, b0$3);
  var a0b1$3 = Math.imul(31749, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(1794341893, hi) + Math.imul(27379, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 10) | 0) | (hi$10 << 22));
  var hi$11 = (hi$10 >> 10);
  var lo$9 = ((num_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  var num$1_$_lo = this.Ljava_time_Duration__f_seconds_$lo;
  var num$1_$_hi = this.Ljava_time_Duration__f_seconds_$hi;
  var hi$13 = (num$1_$_hi >> 31);
  var b0$4 = (65535 & num$1_$_lo);
  var b1$4 = ((num$1_$_lo >>> 16) | 0);
  var a0b0$4 = Math.imul(23010, b0$4);
  var a1b0$4 = Math.imul(18641, b0$4);
  var a0b1$4 = Math.imul(23010, b1$4);
  var lo$11 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$14 = ((((Math.imul(18641, b1$4) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var b0$5 = (65535 & num$1_$_lo);
  var b1$5 = ((num$1_$_lo >>> 16) | 0);
  var a0b0$5 = Math.imul(31749, b0$5);
  var a1b0$5 = Math.imul(27379, b0$5);
  var a0b1$5 = Math.imul(31749, b1$5);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$15 = ((((Math.imul(27379, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var lo$13 = ((lo$11 + hi$15) | 0);
  var hi$16 = ((hi$14 + ((((lo$11 & hi$15) | ((lo$11 | hi$15) & (~lo$13))) >>> 31) | 0)) | 0);
  var b0$6 = (65535 & num$1_$_hi);
  var b1$6 = ((num$1_$_hi >>> 16) | 0);
  var a0b0$6 = Math.imul(23010, b0$6);
  var a1b0$6 = Math.imul(18641, b0$6);
  var a0b1$6 = Math.imul(23010, b1$6);
  var lo$14 = ((a0b0$6 + (((a1b0$6 + a0b1$6) | 0) << 16)) | 0);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$17 = ((((((Math.imul(1221679586, hi$13) + Math.imul(18641, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var hi$18 = (hi$16 >> 31);
  var lo$15 = ((lo$14 + hi$16) | 0);
  var hi$19 = ((((hi$17 + hi$18) | 0) + ((((lo$14 & hi$16) | ((lo$14 | hi$16) & (~lo$15))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & num$1_$_hi);
  var b1$7 = ((num$1_$_hi >>> 16) | 0);
  var a0b0$7 = Math.imul(31749, b0$7);
  var a1b0$7 = Math.imul(27379, b0$7);
  var a0b1$7 = Math.imul(31749, b1$7);
  var lo$16 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$20 = ((((((Math.imul(1794341893, hi$13) + Math.imul(27379, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var lo$17 = ((lo$13 + lo$16) | 0);
  var hi$21 = ((hi$20 + ((((lo$13 & lo$16) | ((lo$13 | lo$16) & (~lo$17))) >>> 31) | 0)) | 0);
  var hi$22 = (hi$21 >> 31);
  var lo$18 = ((lo$15 + hi$21) | 0);
  var hi$23 = ((((hi$19 + hi$22) | 0) + ((((lo$15 & hi$21) | ((lo$15 | hi$21) & (~lo$18))) >>> 31) | 0)) | 0);
  var lo$19 = (((lo$18 >>> 10) | 0) | (hi$23 << 22));
  var hi$24 = (hi$23 >> 10);
  var lo$20 = ((num$1_$_hi >>> 31) | 0);
  var lo$21 = ((lo$19 + lo$20) | 0);
  var hi$25 = ((hi$24 + ((((lo$19 & lo$20) | ((lo$19 | lo$20) & (~lo$21))) >>> 31) | 0)) | 0);
  var b0$8 = (65535 & lo$21);
  var b1$8 = ((lo$21 >>> 16) | 0);
  var a0b0$8 = Math.imul(3600, b0$8);
  var a0b1$8 = Math.imul(3600, b1$8);
  var lo$22 = ((a0b0$8 + (a0b1$8 << 16)) | 0);
  var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
  var hi$26 = ((Math.imul(3600, hi$25) + ((c1part$8 >>> 16) | 0)) | 0);
  var lo$23 = ((num$1_$_lo - lo$22) | 0);
  var hi$27 = ((((num$1_$_hi - hi$26) | 0) + ((((~num$1_$_lo) & lo$22) | ((~(num$1_$_lo ^ lo$22)) & lo$23)) >> 31)) | 0);
  var hi$28 = (hi$27 >> 31);
  var b0$9 = (65535 & lo$23);
  var b1$9 = ((lo$23 >>> 16) | 0);
  var a0b0$9 = Math.imul(34952, b0$9);
  var a1b0$8 = Math.imul(34952, b0$9);
  var a0b1$9 = Math.imul(34952, b1$9);
  var lo$24 = ((a0b0$9 + (((a1b0$8 + a0b1$9) | 0) << 16)) | 0);
  var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
  var hi$29 = ((((((((-lo$23) | 0) + Math.imul(34952, b1$9)) | 0) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$8) | 0) >>> 16) | 0)) | 0);
  var b0$10 = (65535 & lo$23);
  var b1$10 = ((lo$23 >>> 16) | 0);
  var a0b0$10 = Math.imul(34953, b0$10);
  var a1b0$9 = Math.imul(34952, b0$10);
  var a0b1$10 = Math.imul(34953, b1$10);
  var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
  var hi$30 = ((((Math.imul(34952, b1$10) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$9) | 0) >>> 16) | 0)) | 0);
  var lo$26 = ((lo$24 + hi$30) | 0);
  var hi$31 = ((hi$29 + ((((lo$24 & hi$30) | ((lo$24 | hi$30) & (~lo$26))) >>> 31) | 0)) | 0);
  var b0$11 = (65535 & hi$27);
  var b1$11 = ((hi$27 >>> 16) | 0);
  var a0b0$11 = Math.imul(34952, b0$11);
  var a1b0$10 = Math.imul(34952, b0$11);
  var a0b1$11 = Math.imul(34952, b1$11);
  var lo$27 = ((a0b0$11 + (((a1b0$10 + a0b1$11) | 0) << 16)) | 0);
  var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
  var hi$32 = ((((((((Math.imul((-2004318072), hi$28) + ((-hi$27) | 0)) | 0) + Math.imul(34952, b1$11)) | 0) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$10) | 0) >>> 16) | 0)) | 0);
  var hi$33 = (hi$31 >> 31);
  var lo$28 = ((lo$27 + hi$31) | 0);
  var hi$34 = ((((hi$32 + hi$33) | 0) + ((((lo$27 & hi$31) | ((lo$27 | hi$31) & (~lo$28))) >>> 31) | 0)) | 0);
  var b0$12 = (65535 & hi$27);
  var b1$12 = ((hi$27 >>> 16) | 0);
  var a0b0$12 = Math.imul(34953, b0$12);
  var a1b0$11 = Math.imul(34952, b0$12);
  var a0b1$12 = Math.imul(34953, b1$12);
  var lo$29 = ((a0b0$12 + (((a1b0$11 + a0b1$12) | 0) << 16)) | 0);
  var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
  var hi$35 = ((((((Math.imul((-2004318071), hi$28) + Math.imul(34952, b1$12)) | 0) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$11) | 0) >>> 16) | 0)) | 0);
  var lo$30 = ((lo$26 + lo$29) | 0);
  var hi$36 = ((hi$35 + ((((lo$26 & lo$29) | ((lo$26 | lo$29) & (~lo$30))) >>> 31) | 0)) | 0);
  var hi$37 = (hi$36 >> 31);
  var lo$31 = ((lo$28 + hi$36) | 0);
  var hi$38 = ((((hi$34 + hi$37) | 0) + ((((lo$28 & hi$36) | ((lo$28 | hi$36) & (~lo$31))) >>> 31) | 0)) | 0);
  var lo$32 = ((lo$31 + lo$23) | 0);
  var hi$39 = ((((hi$38 + hi$27) | 0) + ((((lo$31 & lo$23) | ((lo$31 | lo$23) & (~lo$32))) >>> 31) | 0)) | 0);
  var lo$33 = (((lo$32 >>> 5) | 0) | (hi$39 << 27));
  var lo$34 = ((hi$27 >>> 31) | 0);
  var lo$35 = ((lo$33 + lo$34) | 0);
  var num$2_$_lo = this.Ljava_time_Duration__f_seconds_$lo;
  var num$2_$_hi = this.Ljava_time_Duration__f_seconds_$hi;
  var hi$42 = (num$2_$_hi >> 31);
  var b0$13 = (65535 & num$2_$_lo);
  var b1$13 = ((num$2_$_lo >>> 16) | 0);
  var a0b0$13 = Math.imul(34952, b0$13);
  var a1b0$12 = Math.imul(34952, b0$13);
  var a0b1$13 = Math.imul(34952, b1$13);
  var lo$36 = ((a0b0$13 + (((a1b0$12 + a0b1$13) | 0) << 16)) | 0);
  var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
  var hi$43 = ((((((((-num$2_$_lo) | 0) + Math.imul(34952, b1$13)) | 0) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$12) | 0) >>> 16) | 0)) | 0);
  var b0$14 = (65535 & num$2_$_lo);
  var b1$14 = ((num$2_$_lo >>> 16) | 0);
  var a0b0$14 = Math.imul(34953, b0$14);
  var a1b0$13 = Math.imul(34952, b0$14);
  var a0b1$14 = Math.imul(34953, b1$14);
  var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
  var hi$44 = ((((Math.imul(34952, b1$14) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$13) | 0) >>> 16) | 0)) | 0);
  var lo$38 = ((lo$36 + hi$44) | 0);
  var hi$45 = ((hi$43 + ((((lo$36 & hi$44) | ((lo$36 | hi$44) & (~lo$38))) >>> 31) | 0)) | 0);
  var b0$15 = (65535 & num$2_$_hi);
  var b1$15 = ((num$2_$_hi >>> 16) | 0);
  var a0b0$15 = Math.imul(34952, b0$15);
  var a1b0$14 = Math.imul(34952, b0$15);
  var a0b1$15 = Math.imul(34952, b1$15);
  var lo$39 = ((a0b0$15 + (((a1b0$14 + a0b1$15) | 0) << 16)) | 0);
  var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
  var hi$46 = ((((((((Math.imul((-2004318072), hi$42) + ((-num$2_$_hi) | 0)) | 0) + Math.imul(34952, b1$15)) | 0) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$14) | 0) >>> 16) | 0)) | 0);
  var hi$47 = (hi$45 >> 31);
  var lo$40 = ((lo$39 + hi$45) | 0);
  var hi$48 = ((((hi$46 + hi$47) | 0) + ((((lo$39 & hi$45) | ((lo$39 | hi$45) & (~lo$40))) >>> 31) | 0)) | 0);
  var b0$16 = (65535 & num$2_$_hi);
  var b1$16 = ((num$2_$_hi >>> 16) | 0);
  var a0b0$16 = Math.imul(34953, b0$16);
  var a1b0$15 = Math.imul(34952, b0$16);
  var a0b1$16 = Math.imul(34953, b1$16);
  var lo$41 = ((a0b0$16 + (((a1b0$15 + a0b1$16) | 0) << 16)) | 0);
  var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
  var hi$49 = ((((((Math.imul((-2004318071), hi$42) + Math.imul(34952, b1$16)) | 0) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$15) | 0) >>> 16) | 0)) | 0);
  var lo$42 = ((lo$38 + lo$41) | 0);
  var hi$50 = ((hi$49 + ((((lo$38 & lo$41) | ((lo$38 | lo$41) & (~lo$42))) >>> 31) | 0)) | 0);
  var hi$51 = (hi$50 >> 31);
  var lo$43 = ((lo$40 + hi$50) | 0);
  var hi$52 = ((((hi$48 + hi$51) | 0) + ((((lo$40 & hi$50) | ((lo$40 | hi$50) & (~lo$43))) >>> 31) | 0)) | 0);
  var lo$44 = ((lo$43 + num$2_$_lo) | 0);
  var hi$53 = ((((hi$52 + num$2_$_hi) | 0) + ((((lo$43 & num$2_$_lo) | ((lo$43 | num$2_$_lo) & (~lo$44))) >>> 31) | 0)) | 0);
  var lo$45 = (((lo$44 >>> 5) | 0) | (hi$53 << 27));
  var lo$46 = ((num$2_$_hi >>> 31) | 0);
  var lo$47 = ((lo$45 + lo$46) | 0);
  var b0$17 = (65535 & lo$47);
  var b1$17 = ((lo$47 >>> 16) | 0);
  var a0b0$17 = Math.imul(60, b0$17);
  var a0b1$17 = Math.imul(60, b1$17);
  var lo$48 = ((a0b0$17 + (a0b1$17 << 16)) | 0);
  var lo$49 = ((num$2_$_lo - lo$48) | 0);
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 24);
  buf.append__T__scm_StringBuilder("PT");
  if (((lo$10 | hi$12) !== 0)) {
    $n(buf.append__J__scm_StringBuilder(lo$10, hi$12)).append__C__scm_StringBuilder(72);
  }
  if ((lo$35 !== 0)) {
    $n(buf.append__I__scm_StringBuilder(lo$35)).append__C__scm_StringBuilder(77);
  }
  if ((((lo$49 === 0) && (this.Ljava_time_Duration__f_nanos === 0)) && ($n(buf.scm_StringBuilder__f_underlying).length__I() > 2))) {
    return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
  if (((lo$49 < 0) && (this.Ljava_time_Duration__f_nanos > 0))) {
    if ((lo$49 === (-1))) {
      buf.append__T__scm_StringBuilder("-0");
    } else {
      buf.append__I__scm_StringBuilder(((1 + lo$49) | 0));
    }
  } else {
    buf.append__I__scm_StringBuilder(lo$49);
  }
  if ((this.Ljava_time_Duration__f_nanos > 0)) {
    var pos = $n(buf.scm_StringBuilder__f_underlying).length__I();
    if ((lo$49 < 0)) {
      buf.append__I__scm_StringBuilder(((2000000000 - this.Ljava_time_Duration__f_nanos) | 0));
    } else {
      buf.append__I__scm_StringBuilder(((1000000000 + this.Ljava_time_Duration__f_nanos) | 0));
    }
    while (true) {
      var index = (($n(buf.scm_StringBuilder__f_underlying).length__I() - 1) | 0);
      if (($n(buf.scm_StringBuilder__f_underlying).charAt__I__C(index) === 48)) {
        var len = (($n(buf.scm_StringBuilder__f_underlying).length__I() - 1) | 0);
        $n(buf.scm_StringBuilder__f_underlying).setLength__I__V(len);
      } else {
        break;
      }
    }
    buf.setCharAt__I__C__scm_StringBuilder(pos, 46);
  }
  buf.append__C__scm_StringBuilder(83);
  return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljava_time_Duration.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_Duration__I($as_Ljava_time_Duration(that));
});
$c_Ljava_time_Duration.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_Duration(that);
  return this.compare__Ljava_time_Duration__I(other);
});
function $as_Ljava_time_Duration(obj) {
  return (((obj instanceof $c_Ljava_time_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Duration"));
}
function $isArrayOf_Ljava_time_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Duration)));
}
function $asArrayOf_Ljava_time_Duration(obj, depth) {
  return (($isArrayOf_Ljava_time_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Duration;", depth));
}
var $d_Ljava_time_Duration = new $TypeData().initClass($c_Ljava_time_Duration, "java.time.Duration", ({
  Ljava_time_Duration: 1,
  Ljava_time_temporal_TemporalAmount: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
function $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
  if ((x === null)) {
    var $x_1 = (field === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === field);
  }
  if ($x_1) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Field too large for an int: " + field));
  }
  var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  if ((x$3 === null)) {
    var $x_2 = (field === null);
  } else {
    var this$2 = $n(x$3);
    var $x_2 = (this$2 === field);
  }
  if ($x_2) {
    var this$3 = $n($thiz.Ljava_time_ZonedDateTime__f_offset);
    return this$3.Ljava_time_ZoneOffset__f_totalSeconds;
  }
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return $n($thiz.Ljava_time_ZonedDateTime__f_dateTime).get__Ljava_time_temporal_TemporalField__I(field);
  }
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field);
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  matchAlts3: {
    matchAlts4: {
      var x = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x === null)) {
        var $x_1 = (query === null);
      } else {
        var this$1 = $n(x);
        var $x_1 = (this$1 === query);
      }
      if ($x_1) {
        break matchAlts4;
      }
      var x$3 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$3 === null)) {
        var $x_2 = (query === null);
      } else {
        var this$2 = $n(x$3);
        var $x_2 = (this$2 === query);
      }
      if ($x_2) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return $thiz.Ljava_time_ZonedDateTime__f_zone;
  }
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x$5 === null)) {
    var $x_3 = (query === null);
  } else {
    var this$3 = $n(x$5);
    var $x_3 = (this$3 === query);
  }
  if ($x_3) {
    var this$4 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
    $n(this$4.Ljava_time_LocalDateTime__f_date);
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  }
  var x$7 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$7 === null)) {
    var $x_4 = (query === null);
  } else {
    var this$6 = $n(x$7);
    var $x_4 = (this$6 === query);
  }
  if ($x_4) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  var x$9 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
  if ((x$9 === null)) {
    var $x_5 = (query === null);
  } else {
    var this$7 = $n(x$9);
    var $x_5 = (this$7 === query);
  }
  if ($x_5) {
    return $thiz.Ljava_time_ZonedDateTime__f_offset;
  }
  var x$11 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$11 === null)) {
    var $x_6 = (query === null);
  } else {
    var this$8 = $n(x$11);
    var $x_6 = (this$8 === query);
  }
  if ($x_6) {
    var $x_8 = $m_Ljava_time_LocalDate$();
    var this$9 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
    var $x_7 = $n(this$9.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
    return $x_8.ofEpochDay__J__Ljava_time_LocalDate($x_7.l, $x_7.h);
  }
  var x$13 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$13 === null)) {
    var $x_9 = (query === null);
  } else {
    var this$10 = $n(x$13);
    var $x_9 = (this$10 === query);
  }
  if ($x_9) {
    var this$11 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
    return this$11.Ljava_time_LocalDateTime__f_time;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query);
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz) {
  var this$1 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
  var $x_1 = $n(this$1.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
  var epochDay_$_lo = $x_1.l;
  var epochDay_$_hi = $x_1.h;
  var b0 = (65535 & epochDay_$_lo);
  var b1 = ((epochDay_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((Math.imul(86400, epochDay_$_hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var this$3 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
  var value = $n(this$3.Ljava_time_LocalDateTime__f_time).toSecondOfDay__I();
  var hi$1 = (value >> 31);
  var lo$1 = ((lo + value) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + ((((lo & value) | ((lo | value) & (~lo$1))) >>> 31) | 0)) | 0);
  var secs_$_lo = lo$1;
  var secs_$_hi = hi$2;
  var x_$_lo = secs_$_lo;
  var x_$_hi = secs_$_hi;
  var this$6 = $n($thiz.Ljava_time_ZonedDateTime__f_offset);
  var value$1 = this$6.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$3 = (value$1 >> 31);
  var lo$2 = ((x_$_lo - value$1) | 0);
  var hi$4 = ((((x_$_hi - hi$3) | 0) + ((((~x_$_lo) & value$1) | ((~(x_$_lo ^ value$1)) & lo$2)) >> 31)) | 0);
  secs_$_lo = lo$2;
  secs_$_hi = hi$4;
  return $bL(secs_$_lo, secs_$_hi);
}
function $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I($thiz, other) {
  var $x_1 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var this$1 = $n(other);
  var $x_2 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(this$1);
  var y_$_lo = $x_2.l;
  var y_$_hi = $x_2.h;
  var cmp = ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
  if ((cmp === 0)) {
    var this$3 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
    var this$4 = $n(this$3.Ljava_time_LocalDateTime__f_time);
    var $x_3 = this$4.Ljava_time_LocalTime__f_nano;
    var this$5 = $n(other);
    var this$6 = $n(this$5.Ljava_time_ZonedDateTime__f_dateTime);
    var this$7 = $n(this$6.Ljava_time_LocalDateTime__f_time);
    cmp = (($x_3 - this$7.Ljava_time_LocalTime__f_nano) | 0);
    if ((cmp === 0)) {
      var this$9 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
      var this$8 = $n(other);
      var that = this$8.Ljava_time_ZonedDateTime__f_dateTime;
      cmp = this$9.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(that);
      if ((cmp === 0)) {
        var $x_4 = $n($n($thiz.Ljava_time_ZonedDateTime__f_zone).Ljava_time_ZoneOffset__f_id);
        var this$10 = $n(other);
        cmp = $f_T__compareTo__T__I($x_4, $n(this$10.Ljava_time_ZonedDateTime__f_zone).Ljava_time_ZoneOffset__f_id);
        if ((cmp === 0)) {
          var this$11 = $n($thiz.Ljava_time_ZonedDateTime__f_dateTime);
          $n(this$11.Ljava_time_LocalDateTime__f_date);
          $n($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
          var this$13 = $n(other);
          var this$14 = $n(this$13.Ljava_time_ZonedDateTime__f_dateTime);
          $n(this$14.Ljava_time_LocalDateTime__f_date);
          var that$1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
          cmp = $f_T__compareTo__T__I("ISO", ($n(that$1), "ISO"));
        }
      }
    }
  }
  return cmp;
}
function $is_Ljava_time_chrono_ChronoZonedDateTime(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_ChronoZonedDateTime)));
}
function $as_Ljava_time_chrono_ChronoZonedDateTime(obj) {
  return (($is_Ljava_time_chrono_ChronoZonedDateTime(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.ChronoZonedDateTime"));
}
function $isArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoZonedDateTime)));
}
function $asArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.ChronoZonedDateTime;", depth));
}
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology() {
}
$c_Ljava_time_chrono_IsoChronology.prototype = new $h_O();
$c_Ljava_time_chrono_IsoChronology.prototype.constructor = $c_Ljava_time_chrono_IsoChronology;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology() {
}
$h_Ljava_time_chrono_IsoChronology.prototype = $c_Ljava_time_chrono_IsoChronology.prototype;
$c_Ljava_time_chrono_IsoChronology.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_chrono_Chronology(that);
  return $f_T__compareTo__T__I("ISO", ($n(other), "ISO"));
});
$c_Ljava_time_chrono_IsoChronology.prototype.equals__O__Z = (function(obj) {
  return $f_Ljava_time_chrono_Chronology__equals__O__Z(this, obj);
});
$c_Ljava_time_chrono_IsoChronology.prototype.hashCode__I = (function() {
  return $f_Ljava_time_chrono_Chronology__hashCode__I(this);
});
$c_Ljava_time_chrono_IsoChronology.prototype.toString__T = (function() {
  return "ISO";
});
$c_Ljava_time_chrono_IsoChronology.prototype.isLeapYear__J__Z = (function(prolepticYear_$_lo, prolepticYear_$_hi) {
  var lo = (3 & prolepticYear_$_lo);
  if ((lo === 0)) {
    var hi = (prolepticYear_$_hi >> 31);
    var b0 = (65535 & prolepticYear_$_lo);
    var b1 = ((prolepticYear_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(2621, b0);
    var a1b0 = Math.imul(41943, b0);
    var a0b1 = Math.imul(2621, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((-prolepticYear_$_lo) | 0) + Math.imul(41943, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var b0$1 = (65535 & prolepticYear_$_lo);
    var b1$1 = ((prolepticYear_$_lo >>> 16) | 0);
    var a0b0$1 = Math.imul(55051, b0$1);
    var a1b0$1 = Math.imul(28835, b0$1);
    var a0b1$1 = Math.imul(55051, b1$1);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$2 = ((((Math.imul(28835, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$3 = ((lo$1 + hi$2) | 0);
    var hi$3 = ((hi$1 + ((((lo$1 & hi$2) | ((lo$1 | hi$2) & (~lo$3))) >>> 31) | 0)) | 0);
    var b0$2 = (65535 & prolepticYear_$_hi);
    var b1$2 = ((prolepticYear_$_hi >>> 16) | 0);
    var a0b0$2 = Math.imul(2621, b0$2);
    var a1b0$2 = Math.imul(41943, b0$2);
    var a0b1$2 = Math.imul(2621, b1$2);
    var lo$4 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$4 = ((((((((Math.imul((-1546188227), hi) + ((-prolepticYear_$_hi) | 0)) | 0) + Math.imul(41943, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
    var hi$5 = (hi$3 >> 31);
    var lo$5 = ((lo$4 + hi$3) | 0);
    var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$4 & hi$3) | ((lo$4 | hi$3) & (~lo$5))) >>> 31) | 0)) | 0);
    var b0$3 = (65535 & prolepticYear_$_hi);
    var b1$3 = ((prolepticYear_$_hi >>> 16) | 0);
    var a0b0$3 = Math.imul(55051, b0$3);
    var a1b0$3 = Math.imul(28835, b0$3);
    var a0b1$3 = Math.imul(55051, b1$3);
    var lo$6 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$7 = ((((((Math.imul(1889785611, hi) + Math.imul(28835, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
    var lo$7 = ((lo$3 + lo$6) | 0);
    var hi$8 = ((hi$7 + ((((lo$3 & lo$6) | ((lo$3 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
    var hi$9 = (hi$8 >> 31);
    var lo$8 = ((lo$5 + hi$8) | 0);
    var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$5 & hi$8) | ((lo$5 | hi$8) & (~lo$8))) >>> 31) | 0)) | 0);
    var lo$9 = ((lo$8 + prolepticYear_$_lo) | 0);
    var hi$11 = ((((hi$10 + prolepticYear_$_hi) | 0) + ((((lo$8 & prolepticYear_$_lo) | ((lo$8 | prolepticYear_$_lo) & (~lo$9))) >>> 31) | 0)) | 0);
    var lo$10 = (((lo$9 >>> 6) | 0) | (hi$11 << 26));
    var hi$12 = (hi$11 >> 6);
    var lo$11 = ((prolepticYear_$_hi >>> 31) | 0);
    var lo$12 = ((lo$10 + lo$11) | 0);
    var hi$13 = ((hi$12 + ((((lo$10 & lo$11) | ((lo$10 | lo$11) & (~lo$12))) >>> 31) | 0)) | 0);
    var b0$4 = (65535 & lo$12);
    var b1$4 = ((lo$12 >>> 16) | 0);
    var a0b0$4 = Math.imul(100, b0$4);
    var a0b1$4 = Math.imul(100, b1$4);
    var lo$13 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$14 = ((Math.imul(100, hi$13) + ((c1part$4 >>> 16) | 0)) | 0);
    var lo$14 = ((prolepticYear_$_lo - lo$13) | 0);
    var hi$15 = ((((prolepticYear_$_hi - hi$14) | 0) + ((((~prolepticYear_$_lo) & lo$13) | ((~(prolepticYear_$_lo ^ lo$13)) & lo$14)) >> 31)) | 0);
    if (((lo$14 | hi$15) !== 0)) {
      return true;
    } else {
      var hi$16 = (prolepticYear_$_hi >> 31);
      var b0$5 = (65535 & prolepticYear_$_lo);
      var b1$5 = ((prolepticYear_$_lo >>> 16) | 0);
      var a0b0$5 = Math.imul(2621, b0$5);
      var a1b0$4 = Math.imul(41943, b0$5);
      var a0b1$5 = Math.imul(2621, b1$5);
      var lo$15 = ((a0b0$5 + (((a1b0$4 + a0b1$5) | 0) << 16)) | 0);
      var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
      var hi$17 = ((((((((-prolepticYear_$_lo) | 0) + Math.imul(41943, b1$5)) | 0) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$4) | 0) >>> 16) | 0)) | 0);
      var b0$6 = (65535 & prolepticYear_$_lo);
      var b1$6 = ((prolepticYear_$_lo >>> 16) | 0);
      var a0b0$6 = Math.imul(55051, b0$6);
      var a1b0$5 = Math.imul(28835, b0$6);
      var a0b1$6 = Math.imul(55051, b1$6);
      var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
      var hi$18 = ((((Math.imul(28835, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$5) | 0) >>> 16) | 0)) | 0);
      var lo$17 = ((lo$15 + hi$18) | 0);
      var hi$19 = ((hi$17 + ((((lo$15 & hi$18) | ((lo$15 | hi$18) & (~lo$17))) >>> 31) | 0)) | 0);
      var b0$7 = (65535 & prolepticYear_$_hi);
      var b1$7 = ((prolepticYear_$_hi >>> 16) | 0);
      var a0b0$7 = Math.imul(2621, b0$7);
      var a1b0$6 = Math.imul(41943, b0$7);
      var a0b1$7 = Math.imul(2621, b1$7);
      var lo$18 = ((a0b0$7 + (((a1b0$6 + a0b1$7) | 0) << 16)) | 0);
      var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
      var hi$20 = ((((((((Math.imul((-1546188227), hi$16) + ((-prolepticYear_$_hi) | 0)) | 0) + Math.imul(41943, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$6) | 0) >>> 16) | 0)) | 0);
      var hi$21 = (hi$19 >> 31);
      var lo$19 = ((lo$18 + hi$19) | 0);
      var hi$22 = ((((hi$20 + hi$21) | 0) + ((((lo$18 & hi$19) | ((lo$18 | hi$19) & (~lo$19))) >>> 31) | 0)) | 0);
      var b0$8 = (65535 & prolepticYear_$_hi);
      var b1$8 = ((prolepticYear_$_hi >>> 16) | 0);
      var a0b0$8 = Math.imul(55051, b0$8);
      var a1b0$7 = Math.imul(28835, b0$8);
      var a0b1$8 = Math.imul(55051, b1$8);
      var lo$20 = ((a0b0$8 + (((a1b0$7 + a0b1$8) | 0) << 16)) | 0);
      var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
      var hi$23 = ((((((Math.imul(1889785611, hi$16) + Math.imul(28835, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$7) | 0) >>> 16) | 0)) | 0);
      var lo$21 = ((lo$17 + lo$20) | 0);
      var hi$24 = ((hi$23 + ((((lo$17 & lo$20) | ((lo$17 | lo$20) & (~lo$21))) >>> 31) | 0)) | 0);
      var hi$25 = (hi$24 >> 31);
      var lo$22 = ((lo$19 + hi$24) | 0);
      var hi$26 = ((((hi$22 + hi$25) | 0) + ((((lo$19 & hi$24) | ((lo$19 | hi$24) & (~lo$22))) >>> 31) | 0)) | 0);
      var lo$23 = ((lo$22 + prolepticYear_$_lo) | 0);
      var hi$27 = ((((hi$26 + prolepticYear_$_hi) | 0) + ((((lo$22 & prolepticYear_$_lo) | ((lo$22 | prolepticYear_$_lo) & (~lo$23))) >>> 31) | 0)) | 0);
      var lo$24 = (((lo$23 >>> 8) | 0) | (hi$27 << 24));
      var hi$28 = (hi$27 >> 8);
      var lo$25 = ((prolepticYear_$_hi >>> 31) | 0);
      var lo$26 = ((lo$24 + lo$25) | 0);
      var hi$29 = ((hi$28 + ((((lo$24 & lo$25) | ((lo$24 | lo$25) & (~lo$26))) >>> 31) | 0)) | 0);
      var b0$9 = (65535 & lo$26);
      var b1$9 = ((lo$26 >>> 16) | 0);
      var a0b0$9 = Math.imul(400, b0$9);
      var a0b1$9 = Math.imul(400, b1$9);
      var lo$27 = ((a0b0$9 + (a0b1$9 << 16)) | 0);
      var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
      var hi$30 = ((Math.imul(400, hi$29) + ((c1part$9 >>> 16) | 0)) | 0);
      var lo$28 = ((prolepticYear_$_lo - lo$27) | 0);
      var hi$31 = ((((prolepticYear_$_hi - hi$30) | 0) + ((((~prolepticYear_$_lo) & lo$27) | ((~(prolepticYear_$_lo ^ lo$27)) & lo$28)) >> 31)) | 0);
      return ((lo$28 | hi$31) === 0);
    }
  } else {
    return false;
  }
});
$c_Ljava_time_chrono_IsoChronology.prototype.compare__O__I = (function(that) {
  var other = $as_Ljava_time_chrono_Chronology(that);
  return $f_T__compareTo__T__I("ISO", ($n(other), "ISO"));
});
var $d_Ljava_time_chrono_IsoChronology = new $TypeData().initClass($c_Ljava_time_chrono_IsoChronology, "java.time.chrono.IsoChronology", ({
  Ljava_time_chrono_IsoChronology: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_time_chrono_Chronology: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_AbstractSet() {
}
$c_ju_AbstractSet.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractSet.prototype.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
}
$h_ju_AbstractSet.prototype = $c_ju_AbstractSet.prototype;
$c_ju_AbstractSet.prototype.equals__O__Z = (function(that) {
  if ((that === this)) {
    return true;
  } else if ($is_ju_Collection(that)) {
    var x2 = $as_ju_Collection(that);
    return (($n(x2).size__I() === this.size__I()) && this.containsAll__ju_Collection__Z(x2));
  } else {
    return false;
  }
});
$c_ju_AbstractSet.prototype.hashCode__I = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = 0;
  while ($n(_\uff3fself).hasNext__Z()) {
    var t = result;
    var u = $n(_\uff3fself).next__O();
    var t$1 = $uI(t);
    result = (($dp_hashCode__I($n(u)) + t$1) | 0);
  }
  return $uI(result);
});
function $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner) {
  $thiz.ju_Collections$UnmodifiableCollection__f_inner = inner;
  return $thiz;
}
/** @constructor */
function $c_ju_Collections$UnmodifiableCollection() {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
}
$c_ju_Collections$UnmodifiableCollection.prototype = new $h_O();
$c_ju_Collections$UnmodifiableCollection.prototype.constructor = $c_ju_Collections$UnmodifiableCollection;
/** @constructor */
function $h_ju_Collections$UnmodifiableCollection() {
}
$h_ju_Collections$UnmodifiableCollection.prototype = $c_ju_Collections$UnmodifiableCollection.prototype;
$c_ju_Collections$UnmodifiableCollection.prototype.size__I = (function() {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).size__I();
});
$c_ju_Collections$UnmodifiableCollection.prototype.contains__O__Z = (function(o) {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).contains__O__Z(o);
});
$c_ju_Collections$UnmodifiableCollection.prototype.toArray__AO__AO = (function(a) {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).toArray__AO__AO(a);
});
$c_ju_Collections$UnmodifiableCollection.prototype.toString__T = (function() {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).toString__T();
});
$c_ju_Collections$UnmodifiableCollection.prototype.iterator__ju_Iterator = (function() {
  return $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(new $c_ju_Collections$UnmodifiableIterator(), $n(this.ju_Collections$UnmodifiableCollection__f_inner).iterator__ju_Iterator());
});
$c_ju_Collections$UnmodifiableCollection.prototype.add__O__Z = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
class $c_ju_ConcurrentModificationException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_ju_ConcurrentModificationException = new $TypeData().initClass($c_ju_ConcurrentModificationException, "java.util.ConcurrentModificationException", ({
  ju_ConcurrentModificationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var node = $thiz.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (($n($thiz.ju_HashMap__f_java$util$HashMap$$table).u.length - 1) | 0)));
  return ((node === null) ? defaultValue : ($thiz.nodeWasAccessed__ju_HashMap$Node__V(node), $n(node).ju_HashMap$Node__f_value));
}
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.ju_HashMap__f_java$util$HashMap$$table;
  var oldlen = $n(oldTable).u.length;
  var newlen = (oldlen << 1);
  var newTable = new ($d_ju_HashMap$Node.getArrayOf().constr)(newlen);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = newTable;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((newlen * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = $n(oldTable).get(i);
    while ((node !== null)) {
      if ((($n(node).ju_HashMap$Node__f_hash & oldlen) === 0)) {
        $n(node).ju_HashMap$Node__f_previous = lastLow;
        if ((lastLow === null)) {
          newTable.set(i, node);
        } else {
          $n(lastLow).ju_HashMap$Node__f_next = node;
        }
        lastLow = node;
      } else {
        $n(node).ju_HashMap$Node__f_previous = lastHigh;
        if ((lastHigh === null)) {
          newTable.set(((oldlen + i) | 0), node);
        } else {
          $n(lastHigh).ju_HashMap$Node__f_next = node;
        }
        lastHigh = node;
      }
      node = $n(node).ju_HashMap$Node__f_next;
    }
    if ((lastLow !== null)) {
      $n(lastLow).ju_HashMap$Node__f_next = null;
    }
    if ((lastHigh !== null)) {
      $n(lastHigh).ju_HashMap$Node__f_next = null;
    }
    i = ((1 + i) | 0);
  }
}
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor = loadFactor;
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "initialCapacity < 0");
  }
  if ((loadFactor <= 0.0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "loadFactor <= 0.0");
  }
  var a = ((initialCapacity - 1) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = new ($d_ju_HashMap$Node.getArrayOf().constr)(((a$1 < 1073741824) ? a$1 : 1073741824));
  var size = $n($thiz.ju_HashMap__f_java$util$HashMap$$table).u.length;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((size * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  $thiz.ju_HashMap__f_contentSize = 0;
  return $thiz;
}
function $ct_ju_HashMap__($thiz) {
  $ct_ju_HashMap__I__F__($thiz, 16, 0.75);
  return $thiz;
}
/** @constructor */
function $c_ju_HashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
}
$c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$c_ju_HashMap.prototype.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
}
$h_ju_HashMap.prototype = $c_ju_HashMap.prototype;
$c_ju_HashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(new $c_ju_HashMap$Node(), key, hash, value, previous, next);
});
$c_ju_HashMap.prototype.nodeWasAccessed__ju_HashMap$Node__V = (function(node) {
});
$c_ju_HashMap.prototype.nodeWasAdded__ju_HashMap$Node__V = (function(node) {
});
$c_ju_HashMap.prototype.nodeWasRemoved__ju_HashMap$Node__V = (function(node) {
});
$c_ju_HashMap.prototype.size__I = (function() {
  return this.ju_HashMap__f_contentSize;
});
$c_ju_HashMap.prototype.isEmpty__Z = (function() {
  return (this.ju_HashMap__f_contentSize === 0);
});
$c_ju_HashMap.prototype.get__O__O = (function(key) {
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this, key, null);
});
$c_ju_HashMap.prototype.containsKey__O__Z = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return (this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (($n(this.ju_HashMap__f_java$util$HashMap$$table).u.length - 1) | 0))) !== null);
});
$c_ju_HashMap.prototype.put__O__O__O = (function(key, value) {
  if ((key === null)) {
    var $x_1 = 0;
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $x_1, false);
});
$c_ju_HashMap.prototype.remove__O__O = (function(key) {
  var node = this.java$util$HashMap$$remove0__O__ju_HashMap$Node(key);
  return ((node === null) ? null : $n(node).ju_HashMap$Node__f_value);
});
$c_ju_HashMap.prototype.containsValue__O__Z = (function(value) {
  var _\uff3fself = this.valueIterator__ju_Iterator();
  while ($n(_\uff3fself).hasNext__Z()) {
    var t = $n(_\uff3fself).next__O();
    if (((value === null) ? (t === null) : $dp_equals__O__Z($n(value), t))) {
      return true;
    }
  }
  return false;
});
$c_ju_HashMap.prototype.entrySet__ju_Set = (function() {
  return new $c_ju_HashMap$EntrySet(this);
});
$c_ju_HashMap.prototype.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node = (function(key, hash, idx) {
  var node = $n(this.ju_HashMap__f_java$util$HashMap$$table).get(idx);
  while (true) {
    if ((node === null)) {
      return null;
    } else {
      if ((hash === $n(node).ju_HashMap$Node__f_hash)) {
        var b = $n(node).ju_HashMap$Node__f_key;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z($n(key), b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return node;
      } else if ((hash < $n(node).ju_HashMap$Node__f_hash)) {
        return null;
      } else {
        node = $n(node).ju_HashMap$Node__f_next;
      }
    }
  }
});
$c_ju_HashMap.prototype.java$util$HashMap$$put0__O__O__I__Z__O = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.ju_HashMap__f_contentSize) | 0);
  if ((newContentSize >= this.ju_HashMap__f_threshold)) {
    $p_ju_HashMap__growTable__V(this);
  }
  var idx = (hash & (($n(this.ju_HashMap__f_java$util$HashMap$$table).u.length - 1) | 0));
  var x1 = $n(this.ju_HashMap__f_java$util$HashMap$$table).get(idx);
  if ((x1 === null)) {
    var newNode = this.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, null, null);
    $n(this.ju_HashMap__f_java$util$HashMap$$table).set(idx, newNode);
    var newNode$3 = newNode;
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && ($n(n).ju_HashMap$Node__f_hash <= hash))) {
      if (($n(n).ju_HashMap$Node__f_hash === hash)) {
        var b = $n(n).ju_HashMap$Node__f_key;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z($n(key), b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        this.nodeWasAccessed__ju_HashMap$Node__V(n);
        var old = $n(n).ju_HashMap$Node__f_value;
        if (((!ifAbsent) || (old === null))) {
          $n(n).ju_HashMap$Node__f_value = value;
        }
        return old;
      }
      prev = n;
      n = $n(n).ju_HashMap$Node__f_next;
    }
    var newNode$2 = this.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, prev, n);
    if ((prev === null)) {
      $n(this.ju_HashMap__f_java$util$HashMap$$table).set(idx, newNode$2);
    } else {
      $n(prev).ju_HashMap$Node__f_next = newNode$2;
    }
    if ((n !== null)) {
      $n(n).ju_HashMap$Node__f_previous = newNode$2;
    }
    var newNode$3 = newNode$2;
  }
  this.ju_HashMap__f_contentSize = newContentSize;
  this.nodeWasAdded__ju_HashMap$Node__V(newNode$3);
  return null;
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__O__ju_HashMap$Node = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I($n(key));
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var idx = (hash & (($n(this.ju_HashMap__f_java$util$HashMap$$table).u.length - 1) | 0));
  var node = this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
  if ((node !== null)) {
    this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx);
  }
  return node;
});
$c_ju_HashMap.prototype.removeNode__ju_HashMap$Node__V = (function(node) {
  var hash = $n(node).ju_HashMap$Node__f_hash;
  this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, (hash & (($n(this.ju_HashMap__f_java$util$HashMap$$table).u.length - 1) | 0)));
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__ju_HashMap$Node__I__V = (function(node, idx) {
  var previous = $n(node).ju_HashMap$Node__f_previous;
  var next = $n(node).ju_HashMap$Node__f_next;
  if ((previous === null)) {
    $n(this.ju_HashMap__f_java$util$HashMap$$table).set(idx, next);
  } else {
    $n(previous).ju_HashMap$Node__f_next = next;
  }
  if ((next !== null)) {
    $n(next).ju_HashMap$Node__f_previous = previous;
  }
  this.ju_HashMap__f_contentSize = ((this.ju_HashMap__f_contentSize - 1) | 0);
  this.nodeWasRemoved__ju_HashMap$Node__V(node);
});
$c_ju_HashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_HashMap$NodeIterator(this);
});
$c_ju_HashMap.prototype.valueIterator__ju_Iterator = (function() {
  return new $c_ju_HashMap$ValueIterator(this);
});
var $d_ju_HashMap = new $TypeData().initClass($c_ju_HashMap, "java.util.HashMap", ({
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
}));
function $ct_ju_IllformedLocaleException__T__I__($thiz, s, errorIndex) {
  var s$1 = (s + ((errorIndex < 0) ? "" : ((" [at index " + errorIndex) + "]")));
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s$1, null, true, true);
  return $thiz;
}
function $ct_ju_IllformedLocaleException__T__($thiz, s) {
  $ct_ju_IllformedLocaleException__T__I__($thiz, s, (-1));
  return $thiz;
}
class $c_ju_IllformedLocaleException extends $c_jl_RuntimeException {
}
var $d_ju_IllformedLocaleException = new $TypeData().initClass($c_ju_IllformedLocaleException, "java.util.IllformedLocaleException", ({
  ju_IllformedLocaleException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_Locale$$anon$1() {
}
$c_ju_Locale$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_ju_Locale$$anon$1.prototype.constructor = $c_ju_Locale$$anon$1;
/** @constructor */
function $h_ju_Locale$$anon$1() {
}
$h_ju_Locale$$anon$1.prototype = $c_ju_Locale$$anon$1.prototype;
$c_ju_Locale$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    $as_T($n(x)._1__O());
    var x7 = $as_T($n(x)._2__O());
    var this$1 = $n(x7);
    if ((this$1 === "")) {
      return true;
    }
    return true;
  }
  return false;
});
$c_ju_Locale$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x11 = $as_T($n(x)._1__O());
    var x12 = $as_T($n(x)._2__O());
    var this$1 = $n(x12);
    if ((this$1 === "")) {
      return x11;
    }
    return ((x11 + "-") + x12);
  }
  return $n(default$1).apply__O__O(x);
});
$c_ju_Locale$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x));
});
$c_ju_Locale$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1);
});
var $d_ju_Locale$$anon$1 = new $TypeData().initClass($c_ju_Locale$$anon$1, "java.util.Locale$$anon$1", ({
  ju_Locale$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
function $ct_ju_NoSuchElementException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_ju_NoSuchElementException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_ju_NoSuchElementException extends $c_jl_RuntimeException {
}
var $d_ju_NoSuchElementException = new $TypeData().initClass($c_ju_NoSuchElementException, "java.util.NoSuchElementException", ({
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_RandomAccessListIterator(list, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_RandomAccessListIterator__f_list = null;
  this.ju_RandomAccessListIterator__f_list = list;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end);
}
$c_ju_RandomAccessListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_RandomAccessListIterator.prototype.constructor = $c_ju_RandomAccessListIterator;
/** @constructor */
function $h_ju_RandomAccessListIterator() {
}
$h_ju_RandomAccessListIterator.prototype = $c_ju_RandomAccessListIterator.prototype;
$c_ju_RandomAccessListIterator.prototype.get__I__O = (function(index) {
  return $n(this.ju_RandomAccessListIterator__f_list).get__I__O(index);
});
$c_ju_RandomAccessListIterator.prototype.remove__I__V = (function(index) {
  $n(this.ju_RandomAccessListIterator__f_list).remove__I__O(index);
});
var $d_ju_RandomAccessListIterator = new $TypeData().initClass($c_ju_RandomAccessListIterator, "java.util.RandomAccessListIterator", ({
  ju_RandomAccessListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
}));
function $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_concurrent_ConcurrentHashMap__f_inner = new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor);
  return $thiz;
}
function $ct_ju_concurrent_ConcurrentHashMap__($thiz) {
  $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, 16, 0.75);
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap() {
  this.ju_concurrent_ConcurrentHashMap__f_inner = null;
}
$c_ju_concurrent_ConcurrentHashMap.prototype = new $h_ju_AbstractMap();
$c_ju_concurrent_ConcurrentHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap() {
}
$h_ju_concurrent_ConcurrentHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap.prototype.size__I = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).ju_HashMap__f_contentSize;
});
$c_ju_concurrent_ConcurrentHashMap.prototype.get__O__O = (function(key) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).get__O__O(key);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.put__O__O__O = (function(key, value) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).put__O__O__O(key, value);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.remove__O__O = (function(key) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).remove__O__O(key);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.values__ju_Collection = (function() {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap__f_inner);
  return new $c_ju_HashMap$Values(this$1);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.entrySet__ju_Set = (function() {
  var this$1 = $n(this.ju_concurrent_ConcurrentHashMap__f_inner);
  return new $c_ju_HashMap$EntrySet(this$1);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.hashCode__I = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).hashCode__I();
});
$c_ju_concurrent_ConcurrentHashMap.prototype.toString__T = (function() {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).toString__T();
});
$c_ju_concurrent_ConcurrentHashMap.prototype.equals__O__Z = (function(o) {
  return $n(this.ju_concurrent_ConcurrentHashMap__f_inner).equals__O__Z(o);
});
var $d_ju_concurrent_ConcurrentHashMap = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap, "java.util.concurrent.ConcurrentHashMap", ({
  ju_concurrent_ConcurrentHashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  ju_concurrent_ConcurrentMap: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_CopyOnWriteArrayListIterator(arraySnapshot, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot = null;
  this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot = arraySnapshot;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end);
}
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.constructor = $c_ju_concurrent_CopyOnWriteArrayListIterator;
/** @constructor */
function $h_ju_concurrent_CopyOnWriteArrayListIterator() {
}
$h_ju_concurrent_CopyOnWriteArrayListIterator.prototype = $c_ju_concurrent_CopyOnWriteArrayListIterator.prototype;
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.remove__V = (function() {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.get__I__O = (function(index) {
  var v = this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot;
  return v[index];
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.remove__I__V = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
var $d_ju_concurrent_CopyOnWriteArrayListIterator = new $TypeData().initClass($c_ju_concurrent_CopyOnWriteArrayListIterator, "java.util.concurrent.CopyOnWriteArrayListIterator", ({
  ju_concurrent_CopyOnWriteArrayListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
}));
function $as_ju_concurrent_RejectedExecutionException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.RejectedExecutionException"));
}
function $isArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_RejectedExecutionException)));
}
function $asArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) {
  return (($isArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.RejectedExecutionException;", depth));
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "NANOSECONDS", 0);
}
$c_ju_concurrent_TimeUnit$$anon$1.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$1.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$1() {
}
$h_ju_concurrent_TimeUnit$$anon$1.prototype = $c_ju_concurrent_TimeUnit$$anon$1.prototype;
$c_ju_concurrent_TimeUnit$$anon$1.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a_$_lo, a_$_hi, u) {
  return $n(u).toNanos__J__J(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toNanos__J__J = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMicros__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(39845, b0);
  var a1b0 = Math.imul(8388, b0);
  var a0b1 = Math.imul(39845, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(8388, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(63439, b0$1);
  var a1b0$1 = Math.imul(58195, b0$1);
  var a0b1$1 = Math.imul(63439, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(58195, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(39845, b0$2);
  var a1b0$2 = Math.imul(8388, b0$2);
  var a0b1$2 = Math.imul(39845, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(549755813, hi) + Math.imul(8388, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(63439, b0$3);
  var a1b0$3 = Math.imul(58195, b0$3);
  var a0b1$3 = Math.imul(63439, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-481036337), hi) + Math.imul(58195, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 7) | 0) | (hi$10 << 25));
  var hi$11 = (hi$10 >> 7);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMillis__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(56962, b0);
  var a1b0 = Math.imul(17179, b0);
  var a0b1 = Math.imul(56962, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(17179, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(13531, b0$1);
  var a1b0$1 = Math.imul(55222, b0$1);
  var a0b1$1 = Math.imul(13531, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(55222, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(56962, b0$2);
  var a1b0$2 = Math.imul(17179, b0$2);
  var a0b1$2 = Math.imul(56962, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(1125899906, hi) + Math.imul(17179, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(13531, b0$3);
  var a1b0$3 = Math.imul(55222, b0$3);
  var a0b1$3 = Math.imul(13531, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-675924773), hi) + Math.imul(55222, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 18) | 0) | (hi$10 << 14));
  var hi$11 = (hi$10 >> 18);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toSeconds__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(3048, b0);
  var a1b0 = Math.imul(4398, b0);
  var a0b1 = Math.imul(3048, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(4398, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(38067, b0$1);
  var a1b0$1 = Math.imul(9942, b0$1);
  var a0b1$1 = Math.imul(38067, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(9942, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(3048, b0$2);
  var a1b0$2 = Math.imul(4398, b0$2);
  var a0b1$2 = Math.imul(3048, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(288230376, hi) + Math.imul(4398, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(38067, b0$3);
  var a1b0$3 = Math.imul(9942, b0$3);
  var a0b1$3 = Math.imul(38067, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(651596979, hi) + Math.imul(9942, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 26) | 0) | (hi$10 << 6));
  var hi$11 = (hi$10 >> 26);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMinutes__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(13310, b0);
  var a1b0 = Math.imul(293, b0);
  var a0b1 = Math.imul(13310, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(293, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(15645, b0$1);
  var a1b0$1 = Math.imul(26877, b0$1);
  var a0b1$1 = Math.imul(15645, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(26877, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(13310, b0$2);
  var a1b0$2 = Math.imul(293, b0$2);
  var a0b1$2 = Math.imul(13310, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(19215358, hi) + Math.imul(293, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(15645, b0$3);
  var a1b0$3 = Math.imul(26877, b0$3);
  var a0b1$3 = Math.imul(15645, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(1761426717, hi) + Math.imul(26877, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 28) | 0) | (hi$10 << 4));
  var hi$11 = (hi$10 >> 28);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toHours__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(65318, b0);
  var a1b0 = Math.imul(40031, b0);
  var a0b1 = Math.imul(65318, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((-a_$_lo) | 0) + Math.imul(40031, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(60757, b0$1);
  var a1b0$1 = Math.imul(60789, b0$1);
  var a0b1$1 = Math.imul(60757, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(60789, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(65318, b0$2);
  var a1b0$2 = Math.imul(40031, b0$2);
  var a0b1$2 = Math.imul(65318, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((((Math.imul((-1671430362), hi) + ((-a_$_hi) | 0)) | 0) + Math.imul(40031, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(60757, b0$3);
  var a1b0$3 = Math.imul(60789, b0$3);
  var a0b1$3 = Math.imul(60757, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-311038635), hi) + Math.imul(60789, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = ((lo$7 + a_$_lo) | 0);
  var hi$11 = ((((hi$10 + a_$_hi) | 0) + ((((lo$7 & a_$_lo) | ((lo$7 | a_$_lo) & (~lo$8))) >>> 31) | 0)) | 0);
  var lo$9 = (hi$11 >> 9);
  var hi$12 = (hi$11 >> 31);
  var lo$10 = ((a_$_hi >>> 31) | 0);
  var lo$11 = ((lo$9 + lo$10) | 0);
  var hi$13 = ((hi$12 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
  return $bL(lo$11, hi$13);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toDays__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(65391, b0);
  var a1b0 = Math.imul(26687, b0);
  var a0b1 = Math.imul(65391, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(26687, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(18659, b0$1);
  var a1b0$1 = Math.imul(18681, b0$1);
  var a0b1$1 = Math.imul(18659, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(18681, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(65391, b0$2);
  var a1b0$2 = Math.imul(26687, b0$2);
  var a0b1$2 = Math.imul(65391, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(1749024623, hi) + Math.imul(26687, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(18659, b0$3);
  var a1b0$3 = Math.imul(18681, b0$3);
  var a0b1$3 = Math.imul(18659, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(1224296675, hi) + Math.imul(18681, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (hi$10 >> 13);
  var hi$11 = (hi$10 >> 31);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
var $d_ju_concurrent_TimeUnit$$anon$1 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$1, "java.util.concurrent.TimeUnit$$anon$1", ({
  ju_concurrent_TimeUnit$$anon$1: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MICROSECONDS", 1);
}
$c_ju_concurrent_TimeUnit$$anon$2.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$2.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$2() {
}
$h_ju_concurrent_TimeUnit$$anon$2.prototype = $c_ju_concurrent_TimeUnit$$anon$2.prototype;
$c_ju_concurrent_TimeUnit$$anon$2.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a_$_lo, a_$_hi, u) {
  return $n(u).toMicros__J__J(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toNanos__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 1000, 0, (-1511828489), 2147483);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMicros__J__J = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMillis__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(39845, b0);
  var a1b0 = Math.imul(8388, b0);
  var a0b1 = Math.imul(39845, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(8388, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(63439, b0$1);
  var a1b0$1 = Math.imul(58195, b0$1);
  var a0b1$1 = Math.imul(63439, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(58195, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(39845, b0$2);
  var a1b0$2 = Math.imul(8388, b0$2);
  var a0b1$2 = Math.imul(39845, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(549755813, hi) + Math.imul(8388, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(63439, b0$3);
  var a1b0$3 = Math.imul(58195, b0$3);
  var a0b1$3 = Math.imul(63439, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-481036337), hi) + Math.imul(58195, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 7) | 0) | (hi$10 << 25));
  var hi$11 = (hi$10 >> 7);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toSeconds__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(56962, b0);
  var a1b0 = Math.imul(17179, b0);
  var a0b1 = Math.imul(56962, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(17179, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(13531, b0$1);
  var a1b0$1 = Math.imul(55222, b0$1);
  var a0b1$1 = Math.imul(13531, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(55222, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(56962, b0$2);
  var a1b0$2 = Math.imul(17179, b0$2);
  var a0b1$2 = Math.imul(56962, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(1125899906, hi) + Math.imul(17179, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(13531, b0$3);
  var a1b0$3 = Math.imul(55222, b0$3);
  var a0b1$3 = Math.imul(13531, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-675924773), hi) + Math.imul(55222, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 18) | 0) | (hi$10 << 14));
  var hi$11 = (hi$10 >> 18);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMinutes__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(25401, b0);
  var a1b0 = Math.imul(36650, b0);
  var a0b1 = Math.imul(25401, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((-a_$_lo) | 0) + Math.imul(36650, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(55081, b0$1);
  var a1b0$1 = Math.imul(17318, b0$1);
  var a0b1$1 = Math.imul(55081, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(17318, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(25401, b0$2);
  var a1b0$2 = Math.imul(36650, b0$2);
  var a0b1$2 = Math.imul(25401, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((((Math.imul((-1893047495), hi) + ((-a_$_hi) | 0)) | 0) + Math.imul(36650, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(55081, b0$3);
  var a1b0$3 = Math.imul(17318, b0$3);
  var a0b1$3 = Math.imul(55081, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(1135007529, hi) + Math.imul(17318, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = ((lo$7 + a_$_lo) | 0);
  var hi$11 = ((((hi$10 + a_$_hi) | 0) + ((((lo$7 & a_$_lo) | ((lo$7 | a_$_lo) & (~lo$8))) >>> 31) | 0)) | 0);
  var lo$9 = (((lo$8 >>> 25) | 0) | (hi$11 << 7));
  var hi$12 = (hi$11 >> 25);
  var lo$10 = ((a_$_hi >>> 31) | 0);
  var lo$11 = ((lo$9 + lo$10) | 0);
  var hi$13 = ((hi$12 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
  return $bL(lo$11, hi$13);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toHours__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(48940, b0);
  var a1b0 = Math.imul(39093, b0);
  var a0b1 = Math.imul(48940, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((-a_$_lo) | 0) + Math.imul(39093, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(10693, b0$1);
  var a1b0$1 = Math.imul(997, b0$1);
  var a0b1$1 = Math.imul(10693, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(997, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(48940, b0$2);
  var a1b0$2 = Math.imul(39093, b0$2);
  var a0b1$2 = Math.imul(48940, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((((Math.imul((-1732919508), hi) + ((-a_$_hi) | 0)) | 0) + Math.imul(39093, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(10693, b0$3);
  var a1b0$3 = Math.imul(997, b0$3);
  var a0b1$3 = Math.imul(10693, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(65350085, hi) + Math.imul(997, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = ((lo$7 + a_$_lo) | 0);
  var hi$11 = ((((hi$10 + a_$_hi) | 0) + ((((lo$7 & a_$_lo) | ((lo$7 | a_$_lo) & (~lo$8))) >>> 31) | 0)) | 0);
  var lo$9 = (((lo$8 >>> 31) | 0) | (hi$11 << 1));
  var hi$12 = (hi$11 >> 31);
  var lo$10 = ((a_$_hi >>> 31) | 0);
  var lo$11 = ((lo$9 + lo$10) | 0);
  var hi$13 = ((hi$12 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
  return $bL(lo$11, hi$13);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toDays__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(16313, b0);
  var a1b0 = Math.imul(13031, b0);
  var a0b1 = Math.imul(16313, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(13031, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(47255, b0$1);
  var a1b0$1 = Math.imul(22177, b0$1);
  var a0b1$1 = Math.imul(47255, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(22177, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(16313, b0$2);
  var a1b0$2 = Math.imul(13031, b0$2);
  var a0b1$2 = Math.imul(16313, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(854015929, hi) + Math.imul(13031, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(47255, b0$3);
  var a1b0$3 = Math.imul(22177, b0$3);
  var a0b1$3 = Math.imul(47255, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(1453439127, hi) + Math.imul(22177, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (hi$10 >> 2);
  var hi$11 = (hi$10 >> 31);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
var $d_ju_concurrent_TimeUnit$$anon$2 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$2, "java.util.concurrent.TimeUnit$$anon$2", ({
  ju_concurrent_TimeUnit$$anon$2: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MILLISECONDS", 2);
}
$c_ju_concurrent_TimeUnit$$anon$3.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$3.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$3() {
}
$h_ju_concurrent_TimeUnit$$anon$3.prototype = $c_ju_concurrent_TimeUnit$$anon$3.prototype;
$c_ju_concurrent_TimeUnit$$anon$3.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a_$_lo, a_$_hi, u) {
  return $n(u).toMillis__J__J(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toNanos__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 1000000, 0, 2077252342, 2147);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMicros__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 1000, 0, (-1511828489), 2147483);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMillis__J__J = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toSeconds__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(39845, b0);
  var a1b0 = Math.imul(8388, b0);
  var a0b1 = Math.imul(39845, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(8388, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(63439, b0$1);
  var a1b0$1 = Math.imul(58195, b0$1);
  var a0b1$1 = Math.imul(63439, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(58195, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(39845, b0$2);
  var a1b0$2 = Math.imul(8388, b0$2);
  var a0b1$2 = Math.imul(39845, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(549755813, hi) + Math.imul(8388, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(63439, b0$3);
  var a1b0$3 = Math.imul(58195, b0$3);
  var a0b1$3 = Math.imul(63439, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-481036337), hi) + Math.imul(58195, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 7) | 0) | (hi$10 << 25));
  var hi$11 = (hi$10 >> 7);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMinutes__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(45682, b0);
  var a1b0 = Math.imul(17895, b0);
  var a0b1 = Math.imul(45682, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(17895, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(30479, b0$1);
  var a1b0$1 = Math.imul(62984, b0$1);
  var a0b1$1 = Math.imul(30479, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(62984, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(45682, b0$2);
  var a1b0$2 = Math.imul(17895, b0$2);
  var a0b1$2 = Math.imul(45682, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(1172812402, hi) + Math.imul(17895, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(30479, b0$3);
  var a1b0$3 = Math.imul(62984, b0$3);
  var a0b1$3 = Math.imul(30479, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-167217393), hi) + Math.imul(62984, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 14) | 0) | (hi$10 << 18));
  var hi$11 = (hi$10 >> 14);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toHours__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(48728, b0);
  var a1b0 = Math.imul(19088, b0);
  var a0b1 = Math.imul(48728, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(19088, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(58725, b0$1);
  var a1b0$1 = Math.imul(32230, b0$1);
  var a0b1$1 = Math.imul(58725, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(32230, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(48728, b0$2);
  var a1b0$2 = Math.imul(19088, b0$2);
  var a0b1$2 = Math.imul(48728, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(1250999896, hi) + Math.imul(19088, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(58725, b0$3);
  var a1b0$3 = Math.imul(32230, b0$3);
  var a0b1$3 = Math.imul(58725, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(2112284005, hi) + Math.imul(32230, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 20) | 0) | (hi$10 << 12));
  var hi$11 = (hi$10 >> 20);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toDays__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(43125, b0);
  var a1b0 = Math.imul(25451, b0);
  var a0b1 = Math.imul(43125, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(25451, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(56455, b0$1);
  var a1b0$1 = Math.imul(64819, b0$1);
  var a0b1$1 = Math.imul(56455, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(64819, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(43125, b0$2);
  var a1b0$2 = Math.imul(25451, b0$2);
  var a0b1$2 = Math.imul(43125, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(1667999861, hi) + Math.imul(25451, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(56455, b0$3);
  var a1b0$3 = Math.imul(64819, b0$3);
  var a0b1$3 = Math.imul(56455, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-46932857), hi) + Math.imul(64819, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 25) | 0) | (hi$10 << 7));
  var hi$11 = (hi$10 >> 25);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
var $d_ju_concurrent_TimeUnit$$anon$3 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$3, "java.util.concurrent.TimeUnit$$anon$3", ({
  ju_concurrent_TimeUnit$$anon$3: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SECONDS", 3);
}
$c_ju_concurrent_TimeUnit$$anon$4.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$4.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$4() {
}
$h_ju_concurrent_TimeUnit$$anon$4.prototype = $c_ju_concurrent_TimeUnit$$anon$4.prototype;
$c_ju_concurrent_TimeUnit$$anon$4.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a_$_lo, a_$_hi, u) {
  return $n(u).toSeconds__J__J(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toNanos__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 1000000000, 0, 633437444, 2);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMicros__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 1000000, 0, 2077252342, 2147);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMillis__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 1000, 0, (-1511828489), 2147483);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toSeconds__J__J = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMinutes__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(34952, b0);
  var a1b0 = Math.imul(34952, b0);
  var a0b1 = Math.imul(34952, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((-a_$_lo) | 0) + Math.imul(34952, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(34953, b0$1);
  var a1b0$1 = Math.imul(34952, b0$1);
  var a0b1$1 = Math.imul(34953, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(34952, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(34952, b0$2);
  var a1b0$2 = Math.imul(34952, b0$2);
  var a0b1$2 = Math.imul(34952, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((((Math.imul((-2004318072), hi) + ((-a_$_hi) | 0)) | 0) + Math.imul(34952, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(34953, b0$3);
  var a1b0$3 = Math.imul(34952, b0$3);
  var a0b1$3 = Math.imul(34953, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-2004318071), hi) + Math.imul(34952, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = ((lo$7 + a_$_lo) | 0);
  var hi$11 = ((((hi$10 + a_$_hi) | 0) + ((((lo$7 & a_$_lo) | ((lo$7 | a_$_lo) & (~lo$8))) >>> 31) | 0)) | 0);
  var lo$9 = (((lo$8 >>> 5) | 0) | (hi$11 << 27));
  var hi$12 = (hi$11 >> 5);
  var lo$10 = ((a_$_hi >>> 31) | 0);
  var lo$11 = ((lo$9 + lo$10) | 0);
  var hi$13 = ((hi$12 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
  return $bL(lo$11, hi$13);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toHours__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(23010, b0);
  var a1b0 = Math.imul(18641, b0);
  var a0b1 = Math.imul(23010, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(18641, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(31749, b0$1);
  var a1b0$1 = Math.imul(27379, b0$1);
  var a0b1$1 = Math.imul(31749, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(27379, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(23010, b0$2);
  var a1b0$2 = Math.imul(18641, b0$2);
  var a0b1$2 = Math.imul(23010, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(1221679586, hi) + Math.imul(18641, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(31749, b0$3);
  var a1b0$3 = Math.imul(27379, b0$3);
  var a0b1$3 = Math.imul(31749, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul(1794341893, hi) + Math.imul(27379, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 10) | 0) | (hi$10 << 22));
  var hi$11 = (hi$10 >> 10);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toDays__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(51360, b0);
  var a1b0 = Math.imul(6213, b0);
  var a0b1 = Math.imul(51360, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(6213, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(10583, b0$1);
  var a1b0$1 = Math.imul(52817, b0$1);
  var a0b1$1 = Math.imul(10583, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(52817, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(51360, b0$2);
  var a1b0$2 = Math.imul(6213, b0$2);
  var a0b1$2 = Math.imul(51360, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(407226528, hi) + Math.imul(6213, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(10583, b0$3);
  var a1b0$3 = Math.imul(52817, b0$3);
  var a0b1$3 = Math.imul(10583, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-833541801), hi) + Math.imul(52817, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 13) | 0) | (hi$10 << 19));
  var hi$11 = (hi$10 >> 13);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
var $d_ju_concurrent_TimeUnit$$anon$4 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$4, "java.util.concurrent.TimeUnit$$anon$4", ({
  ju_concurrent_TimeUnit$$anon$4: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MINUTES", 4);
}
$c_ju_concurrent_TimeUnit$$anon$5.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$5.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$5() {
}
$h_ju_concurrent_TimeUnit$$anon$5.prototype = $c_ju_concurrent_TimeUnit$$anon$5.prototype;
$c_ju_concurrent_TimeUnit$$anon$5.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a_$_lo, a_$_hi, u) {
  return $n(u).toMinutes__J__J(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toNanos__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, (-129542144), 13, 153722867, 0);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMicros__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 60000000, 0, (-895955376), 35);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMillis__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 60000, 0, 1692789776, 35791);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toSeconds__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 60, 0, 572662306, 35791394);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMinutes__J__J = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toHours__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(34952, b0);
  var a1b0 = Math.imul(34952, b0);
  var a0b1 = Math.imul(34952, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((-a_$_lo) | 0) + Math.imul(34952, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(34953, b0$1);
  var a1b0$1 = Math.imul(34952, b0$1);
  var a0b1$1 = Math.imul(34953, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(34952, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(34952, b0$2);
  var a1b0$2 = Math.imul(34952, b0$2);
  var a0b1$2 = Math.imul(34952, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((((Math.imul((-2004318072), hi) + ((-a_$_hi) | 0)) | 0) + Math.imul(34952, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(34953, b0$3);
  var a1b0$3 = Math.imul(34952, b0$3);
  var a0b1$3 = Math.imul(34953, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-2004318071), hi) + Math.imul(34952, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = ((lo$7 + a_$_lo) | 0);
  var hi$11 = ((((hi$10 + a_$_hi) | 0) + ((((lo$7 & a_$_lo) | ((lo$7 | a_$_lo) & (~lo$8))) >>> 31) | 0)) | 0);
  var lo$9 = (((lo$8 >>> 5) | 0) | (hi$11 << 27));
  var hi$12 = (hi$11 >> 5);
  var lo$10 = ((a_$_hi >>> 31) | 0);
  var lo$11 = ((lo$9 + lo$10) | 0);
  var hi$13 = ((hi$12 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
  return $bL(lo$11, hi$13);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toDays__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(55341, b0);
  var a1b0 = Math.imul(11650, b0);
  var a0b1 = Math.imul(55341, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(11650, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(11651, b0$1);
  var a1b0$1 = Math.imul(33496, b0$1);
  var a0b1$1 = Math.imul(11651, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(33496, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(55341, b0$2);
  var a1b0$2 = Math.imul(11650, b0$2);
  var a0b1$2 = Math.imul(55341, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(763549741, hi) + Math.imul(11650, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(11651, b0$3);
  var a1b0$3 = Math.imul(33496, b0$3);
  var a0b1$3 = Math.imul(11651, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-2099761789), hi) + Math.imul(33496, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 8) | 0) | (hi$10 << 24));
  var hi$11 = (hi$10 >> 8);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
var $d_ju_concurrent_TimeUnit$$anon$5 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$5, "java.util.concurrent.TimeUnit$$anon$5", ({
  ju_concurrent_TimeUnit$$anon$5: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "HOURS", 5);
}
$c_ju_concurrent_TimeUnit$$anon$6.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$6.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$6() {
}
$h_ju_concurrent_TimeUnit$$anon$6.prototype = $c_ju_concurrent_TimeUnit$$anon$6.prototype;
$c_ju_concurrent_TimeUnit$$anon$6.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a_$_lo, a_$_hi, u) {
  return $n(u).toHours__J__J(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toNanos__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 817405952, 838, 2562047, 0);
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMicros__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, (-694967296), 0, (-1732919508), 0);
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMillis__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 3600000, 0, (-2047687697), 596);
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toSeconds__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 3600, 0, 1011703407, 596523);
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMinutes__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 60, 0, 572662306, 35791394);
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toHours__J__J = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toDays__J__J = (function(a_$_lo, a_$_hi) {
  var hi = (a_$_hi >> 31);
  var b0 = (65535 & a_$_lo);
  var b1 = ((a_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(43690, b0);
  var a1b0 = Math.imul(10922, b0);
  var a0b1 = Math.imul(43690, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(10922, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & a_$_lo);
  var b1$1 = ((a_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(43691, b0$1);
  var a1b0$1 = Math.imul(43690, b0$1);
  var a0b1$1 = Math.imul(43691, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(43690, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & a_$_hi);
  var b1$2 = ((a_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(43690, b0$2);
  var a1b0$2 = Math.imul(10922, b0$2);
  var a0b1$2 = Math.imul(43690, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(715827882, hi) + Math.imul(10922, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & a_$_hi);
  var b1$3 = ((a_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(43691, b0$3);
  var a1b0$3 = Math.imul(43690, b0$3);
  var a0b1$3 = Math.imul(43691, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-1431655765), hi) + Math.imul(43690, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 2) | 0) | (hi$10 << 30));
  var hi$11 = (hi$10 >> 2);
  var lo$9 = ((a_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
  return $bL(lo$10, hi$12);
});
var $d_ju_concurrent_TimeUnit$$anon$6 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$6, "java.util.concurrent.TimeUnit$$anon$6", ({
  ju_concurrent_TimeUnit$$anon$6: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DAYS", 6);
}
$c_ju_concurrent_TimeUnit$$anon$7.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$7.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$7() {
}
$h_ju_concurrent_TimeUnit$$anon$7.prototype = $c_ju_concurrent_TimeUnit$$anon$7.prototype;
$c_ju_concurrent_TimeUnit$$anon$7.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a_$_lo, a_$_hi, u) {
  return $n(u).toDays__J__J(a_$_lo, a_$_hi);
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toNanos__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, (-1857093632), 20116, 106751, 0);
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMicros__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 500654080, 20, 106751991, 0);
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMillis__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 86400000, 0, (-622191233), 24);
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toSeconds__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 86400, 0, 579025220, 24855);
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMinutes__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 1440, 0, 381774870, 1491308);
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toHours__J__J = (function(a_$_lo, a_$_hi) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a_$_lo, a_$_hi, 24, 0, 1431655765, 89478485);
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toDays__J__J = (function(a_$_lo, a_$_hi) {
  return $bL(a_$_lo, a_$_hi);
});
var $d_ju_concurrent_TimeUnit$$anon$7 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$7, "java.util.concurrent.TimeUnit$$anon$7", ({
  ju_concurrent_TimeUnit$$anon$7: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fen$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  var value = $m_Llocales_cldr_fallback_data_\uff3froot$();
  var $x_8 = new $c_s_Some(value);
  var territory = $m_s_None$();
  var variant = $m_s_None$();
  var script = $m_s_None$();
  var $x_7 = new $c_Llocales_cldr_LDMLLocale("en", territory, variant, script);
  var $x_6 = $m_s_None$();
  var $x_4 = $m_sr_ScalaRunTime$();
  var ns = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  var aliasOf = $m_s_None$();
  var decimal = new $c_s_Some($bC(46));
  var group = new $c_s_Some($bC(44));
  var list = new $c_s_Some($bC(59));
  var percent = new $c_s_Some($bC(37));
  var minus = new $c_s_Some($bC(45));
  var perMille = new $c_s_Some($bC(8240));
  var infinity = new $c_s_Some("\u221e");
  var nan = new $c_s_Some("NaN");
  var exp = new $c_s_Some("E");
  var elems = $x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_Llocales_cldr_Symbols.getArrayOf().constr)([new $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp)]));
  var $x_5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]));
  var months = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  var elems$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
  var shortMonths = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  var elems$3 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]));
  var weekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  var elems$4 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]));
  var shortWeekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  var elems$5 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["AM", "PM"]));
  var amPm = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5);
  var elems$6 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["BC", "AD"]));
  var eras = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$6);
  var value$1 = new $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras);
  var $x_3 = new $c_s_Some(value$1);
  $m_Llocales_cldr_CalendarPatterns$();
  var this$26 = $m_sci_Map$();
  var elems$7 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2(0, "EEEE, MMMM d, y"), new $c_T2(1, "MMMM d, y"), new $c_T2(2, "MMM d, y"), new $c_T2(3, "M/d/yy")]));
  var datePatterns = this$26.from__sc_IterableOnce__sci_Map(elems$7);
  var this$31 = $m_sci_Map$();
  var elems$8 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2(0, "h:mm:ss a zzzz"), new $c_T2(1, "h:mm:ss a z"), new $c_T2(2, "h:mm:ss a"), new $c_T2(3, "h:mm a")]));
  var timePatterns = this$31.from__sc_IterableOnce__sci_Map(elems$8);
  var value$2 = new $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns);
  var $x_2 = new $c_s_Some(value$2);
  var elems$9 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var $x_1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$9);
  var decimalFormat = new $c_s_Some("#,##0.###");
  var percentFormat = new $c_s_Some("#,##0%");
  var currencyFormat = new $c_s_Some("\u00a4#,##0.00;(\u00a4#,##0.00)");
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $x_8, $x_7, $x_6, $x_5, $x_3, $x_2, $x_1, new $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat));
}
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3fen$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fen$() {
}
$h_Llocales_cldr_fallback_data_\uff3fen$.prototype = $c_Llocales_cldr_fallback_data_\uff3fen$.prototype;
var $d_Llocales_cldr_fallback_data_\uff3fen$ = new $TypeData().initClass($c_Llocales_cldr_fallback_data_\uff3fen$, "locales.cldr.fallback.data._en$", ({
  Llocales_cldr_fallback_data_\uff3fen$: 1,
  Llocales_cldr_LDML: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
var $n_Llocales_cldr_fallback_data_\uff3fen$;
function $m_Llocales_cldr_fallback_data_\uff3fen$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fen$)) {
    $n_Llocales_cldr_fallback_data_\uff3fen$ = new $c_Llocales_cldr_fallback_data_\uff3fen$();
  }
  return $n_Llocales_cldr_fallback_data_\uff3fen$;
}
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3froot$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  var $x_8 = $m_s_None$();
  var territory = $m_s_None$();
  var variant = $m_s_None$();
  var script = $m_s_None$();
  var $x_7 = new $c_Llocales_cldr_LDMLLocale("root", territory, variant, script);
  var value = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  var $x_6 = new $c_s_Some(value);
  var $x_4 = $m_sr_ScalaRunTime$();
  var ns = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  var aliasOf = $m_s_None$();
  var decimal = new $c_s_Some($bC(46));
  var group = new $c_s_Some($bC(44));
  var list = new $c_s_Some($bC(59));
  var percent = new $c_s_Some($bC(37));
  var minus = new $c_s_Some($bC(45));
  var perMille = new $c_s_Some($bC(8240));
  var infinity = new $c_s_Some("\u221e");
  var nan = new $c_s_Some("NaN");
  var exp = new $c_s_Some("E");
  var elems = $x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_Llocales_cldr_Symbols.getArrayOf().constr)([new $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp)]));
  var $x_5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["M01", "M02", "M03", "M04", "M05", "M06", "M07", "M08", "M09", "M10", "M11", "M12"]));
  var months = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  var elems$2 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var shortMonths = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  var elems$3 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]));
  var weekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  var elems$4 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var shortWeekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  var elems$5 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var amPm = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5);
  var elems$6 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["BCE", "CE"]));
  var eras = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$6);
  var value$1 = new $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras);
  var $x_3 = new $c_s_Some(value$1);
  $m_Llocales_cldr_CalendarPatterns$();
  var this$26 = $m_sci_Map$();
  var elems$7 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2(0, "y MMMM d, EEEE"), new $c_T2(1, "y MMMM d"), new $c_T2(2, "y MMM d"), new $c_T2(3, "y-MM-dd")]));
  var datePatterns = this$26.from__sc_IterableOnce__sci_Map(elems$7);
  var this$31 = $m_sci_Map$();
  var elems$8 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([new $c_T2(0, "HH:mm:ss zzzz"), new $c_T2(1, "HH:mm:ss z"), new $c_T2(2, "HH:mm:ss"), new $c_T2(3, "HH:mm")]));
  var timePatterns = this$31.from__sc_IterableOnce__sci_Map(elems$8);
  var value$2 = new $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns);
  var $x_2 = new $c_s_Some(value$2);
  var elems$9 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var $x_1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$9);
  var decimalFormat = new $c_s_Some("#,##0.###");
  var percentFormat = new $c_s_Some("#,##0%");
  var currencyFormat = new $c_s_Some("\u00a4\u00a0#,##0.00");
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $x_8, $x_7, $x_6, $x_5, $x_3, $x_2, $x_1, new $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat));
}
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3froot$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3froot$() {
}
$h_Llocales_cldr_fallback_data_\uff3froot$.prototype = $c_Llocales_cldr_fallback_data_\uff3froot$.prototype;
var $d_Llocales_cldr_fallback_data_\uff3froot$ = new $TypeData().initClass($c_Llocales_cldr_fallback_data_\uff3froot$, "locales.cldr.fallback.data._root$", ({
  Llocales_cldr_fallback_data_\uff3froot$: 1,
  Llocales_cldr_LDML: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
var $n_Llocales_cldr_fallback_data_\uff3froot$;
function $m_Llocales_cldr_fallback_data_\uff3froot$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3froot$)) {
    $n_Llocales_cldr_fallback_data_\uff3froot$ = new $c_Llocales_cldr_fallback_data_\uff3froot$();
  }
  return $n_Llocales_cldr_fallback_data_\uff3froot$;
}
class $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed extends $c_jl_Throwable {
  constructor(nodeId, t) {
    super();
    this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_nodeId = null;
    this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_t = null;
    this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_nodeId = nodeId;
    this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_t = t;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1988812465, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed)) {
      var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed(x$0);
      if ((this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_nodeId === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_nodeId)) {
        var x = this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_t;
        var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_t;
        var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        $n(x$0$2);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "SubtaskFailed";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_nodeId;
    }
    if ((n === 1)) {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_t;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  getMessage__T() {
    return ((("Node " + this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_nodeId) + " failed to run: ") + $n(this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_t).getMessage__T());
  }
  getCause__jl_Throwable() {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed__f_t;
  }
}
function $as_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.DagVisitor$SubtaskFailed"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.DagVisitor$SubtaskFailed;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed, "net.andimiller.hedgehogs.dag.visitor.DagVisitor$SubtaskFailed", ({
  Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    $as_T($n(x)._1__O());
    if (($n(x)._2__O() instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
      var x$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting($n(x)._2__O());
      $n(x$1);
      var this$3 = $n(x$1);
      $as_T(this$3.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle);
      return true;
    }
  }
  return false;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var id = $as_T($n(x)._1__O());
    if (($n(x)._2__O() instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
      var x$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting($n(x)._2__O());
      $n(x$1);
      var this$3 = $n(x$1);
      $as_T(this$3.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle);
      return id;
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x));
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1);
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5 = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5, "net.andimiller.hedgehogs.dag.visitor.Demo$$anon$5", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Demo$$anon$5: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg;", depth));
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Node() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Node;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Node() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Node.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Node.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Node(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Node) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Node"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Node)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Node(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Node;", depth));
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(output) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output = output;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1188062430), true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype.productPrefix__T = (function() {
  return "Done";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.NodeState$Done"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.NodeState$Done;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done, "net.andimiller.hedgehogs.dag.visitor.NodeState$Done", ({
  Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_NodeState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(input) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending__f_input = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending__f_input = input;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 222573613, true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending__f_input;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending__f_input;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype.productPrefix__T = (function() {
  return "Pending";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending__f_input;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.NodeState$Pending"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.NodeState$Pending;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending, "net.andimiller.hedgehogs.dag.visitor.NodeState$Pending", ({
  Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_NodeState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(input, handle) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_input = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_input = input;
  this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle = handle;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-608640766), true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_input;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_input;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle;
      var y$1 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle;
      var $x_1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype.productArity__I = (function() {
  return 2;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype.productPrefix__T = (function() {
  return "Waiting";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_input;
  }
  if ((n === 1)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting__f_handle;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.NodeState$Waiting"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.NodeState$Waiting;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting, "net.andimiller.hedgehogs.dag.visitor.NodeState$Waiting", ({
  Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Waiting: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_NodeState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted(id) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted__f_id = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted__f_id = id;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-171741574), true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted__f_id;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted__f_id;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype.productPrefix__T = (function() {
  return "NodeCompleted";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted__f_id;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.RunEvent$NodeCompleted"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.RunEvent$NodeCompleted;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted, "net.andimiller.hedgehogs.dag.visitor.RunEvent$NodeCompleted", ({
  Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeCompleted: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_RunEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed(id, handle) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_id = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_handle = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_id = id;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_handle = handle;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 729962585, true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_id;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_id;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_handle;
      var y$1 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_handle;
      var $x_1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype.productArity__I = (function() {
  return 2;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype.productPrefix__T = (function() {
  return "NodeResumed";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_id;
  }
  if ((n === 1)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed__f_handle;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.RunEvent$NodeResumed"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.RunEvent$NodeResumed;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed, "net.andimiller.hedgehogs.dag.visitor.RunEvent$NodeResumed", ({
  Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeResumed: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_RunEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted(id) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted__f_id = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted__f_id = id;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-478635828), true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted__f_id;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted__f_id;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype.productPrefix__T = (function() {
  return "NodeStarted";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted__f_id;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.RunEvent$NodeStarted"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.RunEvent$NodeStarted;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted, "net.andimiller.hedgehogs.dag.visitor.RunEvent$NodeStarted", ({
  Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeStarted: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_RunEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended(id, handle) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_id = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_handle = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_id = id;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_handle = handle;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1209822284, true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_id;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_id;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_handle;
      var y$1 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_handle;
      var $x_1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype.productArity__I = (function() {
  return 2;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype.productPrefix__T = (function() {
  return "NodeSuspended";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_id;
  }
  if ((n === 1)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended__f_handle;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.RunEvent$NodeSuspended"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.RunEvent$NodeSuspended;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended, "net.andimiller.hedgehogs.dag.visitor.RunEvent$NodeSuspended", ({
  Lnet_andimiller_hedgehogs_dag_visitor_RunEvent$NodeSuspended: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_RunEvent: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished(graph) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished__f_graph = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished__f_graph = graph;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1261382652, true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished__f_graph;
    var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished__f_graph;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype.productPrefix__T = (function() {
  return "Finished";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished__f_graph;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.RunResult$Finished"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.RunResult$Finished;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished, "net.andimiller.hedgehogs.dag.visitor.RunResult$Finished", ({
  Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Finished: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_RunResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended(snapshot) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended__f_snapshot = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended__f_snapshot = snapshot;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 663183787, true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended__f_snapshot;
    var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended__f_snapshot;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype.productPrefix__T = (function() {
  return "Suspended";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended__f_snapshot;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.RunResult$Suspended"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.RunResult$Suspended;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended, "net.andimiller.hedgehogs.dag.visitor.RunResult$Suspended", ({
  Lnet_andimiller_hedgehogs_dag_visitor_RunResult$Suspended: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_RunResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_State() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_State.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_State.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_State;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_State() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_State.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_State.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_State.prototype.toColour__T = (function() {
  var x = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending__Lnet_andimiller_hedgehogs_dag_visitor_State();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $x_1 = (this$1 === this);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return "indianred";
  }
  var x$3 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Running__Lnet_andimiller_hedgehogs_dag_visitor_State();
  if ((x$3 !== null)) {
    var this$2 = $n(x$3);
    var $x_2 = (this$2 === this);
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    return "coral";
  }
  var x$5 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Suspended__Lnet_andimiller_hedgehogs_dag_visitor_State();
  if ((x$5 !== null)) {
    var this$3 = $n(x$5);
    var $x_3 = (this$3 === this);
  } else {
    var $x_3 = false;
  }
  if ($x_3) {
    return "dodgerblue";
  }
  var x$7 = $s_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done__Lnet_andimiller_hedgehogs_dag_visitor_State();
  if ((x$7 !== null)) {
    var this$4 = $n(x$7);
    var $x_4 = (this$4 === this);
  } else {
    var $x_4 = false;
  }
  if ($x_4) {
    return "limegreen";
  }
  throw new $c_s_MatchError(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_State.prototype.toHtml__Ltyrian_Html = (function() {
  var this$1 = $m_Ltyrian_Html$();
  var attributes = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$n($m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString).$colon$eq__T__Ltyrian_Attribute((("color:" + this.toColour__T()) + ";"))]));
  var plainText = this.toString__T();
  return $f_Ltyrian_HtmlTags__span$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$1, attributes, plainText);
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_State(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_State) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.State"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_State)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_State(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.State;", depth));
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(output) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete__f_output = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete__f_output = output;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1130793353, true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete__f_output;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete__f_output;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype.productPrefix__T = (function() {
  return "Complete";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete__f_output;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.StepResult$Complete"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.StepResult$Complete;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete, "net.andimiller.hedgehogs.dag.visitor.StepResult$Complete", ({
  Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Complete: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_StepResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(handle) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend__f_handle = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend__f_handle = handle;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 238702293, true);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend__f_handle;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend__f_handle;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype.productPrefix__T = (function() {
  return "Suspend";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend__f_handle;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.StepResult$Suspend"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.StepResult$Suspend;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend, "net.andimiller.hedgehogs.dag.visitor.StepResult$Suspend", ({
  Lnet_andimiller_hedgehogs_dag_visitor_StepResult$Suspend: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_StepResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1(direction$18, graph$11, id$9) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_direction$14 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_graph$10 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_id$1 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_direction$14 = direction$18;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_graph$10 = graph$11;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_id$1 = id$9;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    var x121 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState($n(x)._2__O());
    $n(x)._1__O();
    if ((x121 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
      var x$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x121);
      $n(x$1);
      return true;
    }
  }
  return false;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x128 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState($n(x)._2__O());
    var from = $n(x)._1__O();
    if ((x128 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done)) {
      var x$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done(x128);
      var this$2 = $n(x$1);
      var x131 = this$2.Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Done__f_output;
      var x125 = this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_direction$14;
      var x$2 = $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$();
      if ((x$2 === x125)) {
        var $x_1 = $n($n(this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_graph$10).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap);
        var _2 = this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_id$1;
        var _2$1 = $x_1.apply__O__O(new $c_T2(from, _2));
        var self = new $c_T2(from, _2$1);
        return new $c_T2(self, x131);
      }
      var x$4 = $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$();
      if ((x$4 === x125)) {
        var $x_2 = $n($n(this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_graph$10).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap);
        var _1 = this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1__f_id$1;
        var _2$2 = $x_2.apply__O__O(new $c_T2(_1, from));
        var self$1 = new $c_T2(from, _2$2);
        return new $c_T2(self$1, x131);
      }
      throw new $c_s_MatchError(x125);
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x));
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1);
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1 = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$$anon$1", ({
  Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2(errored$13, id$10, completed$19, evidence$1$27) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_errored$10 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_id$5 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_completed$14 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_evidence$1$16 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_errored$10 = errored$13;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_id$5 = id$10;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_completed$14 = completed$19;
  this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_evidence$1$16 = evidence$1$27;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  $m_Lcats_implicits$();
  var $x_1 = $n(this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_errored$10);
  var nodeId = $dp_toString__T($n(this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_id$5));
  var fa = $x_1.complete__O__O(new $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$SubtaskFailed(nodeId, x));
  var fb = $n(this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_completed$14).offer__O__O(this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_id$5);
  var F = this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2__f_evidence$1$16;
  var this$4 = $n(F);
  return this$4.productR__O__O__O(fa, fb);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x));
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1);
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2 = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$$anon$2", ({
  Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    $n(x)._1__O();
    if (($n(x)._2__O() instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)) {
      var x$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending($n(x)._2__O());
      $n(x$1);
      return true;
    }
  }
  return false;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var id = $n(x)._1__O();
    if (($n(x)._2__O() instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending)) {
      var x$1 = $as_Lnet_andimiller_hedgehogs_dag_visitor_NodeState$Pending($n(x)._2__O());
      $n(x$1);
      return id;
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z($as_T2(x));
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O($as_T2(x), default$1);
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3 = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$$anon$3", ({
  Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
class $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions extends $c_jl_Throwable {
  constructor(message) {
    super();
    this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions__f_message = null;
    this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions__f_message = message;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 630868343, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions)) {
      var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions(x$0);
      return ((this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions__f_message === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions__f_message) && ($n(x$0$2), true));
    } else {
      return false;
    }
  }
  productArity__I() {
    return 1;
  }
  productPrefix__T() {
    return "InvalidCompletions";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions__f_message;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  getMessage__T() {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions__f_message;
  }
}
function $as_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$InvalidCompletions"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$InvalidCompletions;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$InvalidCompletions", ({
  Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidCompletions: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
class $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag extends $c_jl_Throwable {
  constructor(message) {
    super();
    this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag__f_message = null;
    this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag__f_message = message;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 350885948, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag)) {
      var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag(x$0);
      return ((this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag__f_message === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag__f_message) && ($n(x$0$2), true));
    } else {
      return false;
    }
  }
  productArity__I() {
    return 1;
  }
  productPrefix__T() {
    return "InvalidDag";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag__f_message;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  getMessage__T() {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag__f_message;
  }
}
function $as_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$InvalidDag"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$InvalidDag;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$InvalidDag", ({
  Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$InvalidDag: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
class $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag extends $c_jl_Throwable {
  constructor(message) {
    super();
    this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag__f_message = null;
    this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag__f_message = message;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-383688712), true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag)) {
      var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag(x$0);
      return ((this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag__f_message === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag__f_message) && ($n(x$0$2), true));
    } else {
      return false;
    }
  }
  productArity__I() {
    return 1;
  }
  productPrefix__T() {
    return "StuckDag";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag__f_message;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  getMessage__T() {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag__f_message;
  }
}
function $as_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$StuckDag"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$StuckDag;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag, "net.andimiller.hedgehogs.dag.visitor.SuspendableDagVisitor$StuckDag", ({
  Lnet_andimiller_hedgehogs_dag_visitor_SuspendableDagVisitor$StuckDag: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
class $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError extends $c_jl_VirtualMachineError {
  constructor(cause) {
    super();
    var message = ((cause === null) ? null : $n(cause).toString__T());
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true);
  }
}
var $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError = new $TypeData().initClass($c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError, "org.scalajs.linker.runtime.UndefinedBehaviorError", ({
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
}
$c_s_$less$colon$less$$anon$1.prototype = new $h_s_$eq$colon$eq();
$c_s_$less$colon$less$$anon$1.prototype.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
}
$h_s_$less$colon$less$$anon$1.prototype = $c_s_$less$colon$less$$anon$1.prototype;
$c_s_$less$colon$less$$anon$1.prototype.apply__O__O = (function(x) {
  return x;
});
$c_s_$less$colon$less$$anon$1.prototype.compose__F1__F1 = (function(r) {
  return r;
});
$c_s_$less$colon$less$$anon$1.prototype.andThen__F1__F1 = (function(r) {
  return r;
});
$c_s_$less$colon$less$$anon$1.prototype.toString__T = (function() {
  return "generalized constraint";
});
var $d_s_$less$colon$less$$anon$1 = new $TypeData().initClass($c_s_$less$colon$less$$anon$1, "scala.$less$colon$less$$anon$1", ({
  s_$less$colon$less$$anon$1: 1,
  s_$eq$colon$eq: 1,
  s_$less$colon$less: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
function $p_s_MatchError__objString$lzycompute__T($thiz) {
  if ((!$thiz.s_MatchError__f_bitmap$0)) {
    if (($thiz.s_MatchError__f_obj === null)) {
      var $x_1 = "null";
    } else {
      var this$1 = $n($thiz.s_MatchError__f_obj);
      var cls = $objectGetClass(this$1);
      if ((cls === null)) {
        var ofClass = "of a JS class";
      } else {
        var this$2 = $n(cls);
        var ofClass = ("of class " + this$2.data.name);
      }
      var $x_1 = $p_s_MatchError__liftedTree1$1__T__T($thiz, ofClass);
    }
    $thiz.s_MatchError__f_objString = $x_1;
    $thiz.s_MatchError__f_bitmap$0 = true;
  }
  return $thiz.s_MatchError__f_objString;
}
function $p_s_MatchError__objString__T($thiz) {
  return ((!$thiz.s_MatchError__f_bitmap$0) ? $p_s_MatchError__objString$lzycompute__T($thiz) : $thiz.s_MatchError__f_objString);
}
function $p_s_MatchError__liftedTree1$1__T__T($thiz, ofClass$1) {
  try {
    return ((($thiz.s_MatchError__f_obj + " (") + ofClass$1) + ")");
  } catch (e) {
    return ("an instance " + ofClass$1);
  }
}
class $c_s_MatchError extends $c_jl_RuntimeException {
  constructor(obj) {
    super();
    this.s_MatchError__f_objString = null;
    this.s_MatchError__f_obj = null;
    this.s_MatchError__f_bitmap$0 = false;
    this.s_MatchError__f_obj = obj;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return $p_s_MatchError__objString__T(this);
  }
}
var $d_s_MatchError = new $TypeData().initClass($c_s_MatchError, "scala.MatchError", ({
  s_MatchError: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_Option() {
}
$c_s_Option.prototype = new $h_O();
$c_s_Option.prototype.constructor = $c_s_Option;
/** @constructor */
function $h_s_Option() {
}
$h_s_Option.prototype = $c_s_Option.prototype;
$c_s_Option.prototype.isEmpty__Z = (function() {
  return (this === $m_s_None$());
});
$c_s_Option.prototype.knownSize__I = (function() {
  return (this.isEmpty__Z() ? 0 : 1);
});
$c_s_Option.prototype.flatten__s_$less$colon$less__s_Option = (function(ev) {
  if (this.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    $n(ev);
    var x = this.get__O();
    return $as_s_Option(x);
  }
});
$c_s_Option.prototype.iterator__sc_Iterator = (function() {
  if (this.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  } else {
    var a = this.get__O();
    return new $c_sc_Iterator$$anon$20(a);
  }
});
$c_s_Option.prototype.toList__sci_List = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$() : new $c_sci_$colon$colon(this.get__O(), $m_sci_Nil$()));
});
function $as_s_Option(obj) {
  return (((obj instanceof $c_s_Option) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Option"));
}
function $isArrayOf_s_Option(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Option)));
}
function $asArrayOf_s_Option(obj, depth) {
  return (($isArrayOf_s_Option(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Option;", depth));
}
/** @constructor */
function $c_s_Product$$anon$1(outer) {
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = 0;
  this.s_Product$$anon$1__f_$outer = null;
  $n(outer);
  this.s_Product$$anon$1__f_$outer = outer;
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = $n(outer).productArity__I();
}
$c_s_Product$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_s_Product$$anon$1.prototype.constructor = $c_s_Product$$anon$1;
/** @constructor */
function $h_s_Product$$anon$1() {
}
$h_s_Product$$anon$1.prototype = $c_s_Product$$anon$1.prototype;
$c_s_Product$$anon$1.prototype.hasNext__Z = (function() {
  return (this.s_Product$$anon$1__f_c < this.s_Product$$anon$1__f_cmax);
});
$c_s_Product$$anon$1.prototype.next__O = (function() {
  var result = $n(this.s_Product$$anon$1__f_$outer).productElement__I__O(this.s_Product$$anon$1__f_c);
  this.s_Product$$anon$1__f_c = ((1 + this.s_Product$$anon$1__f_c) | 0);
  return result;
});
var $d_s_Product$$anon$1 = new $TypeData().initClass($c_s_Product$$anon$1, "scala.Product$$anon$1", ({
  s_Product$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_T2(_1, _2) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2__f__1 = _1;
  this.T2__f__2 = _2;
}
$c_T2.prototype = new $h_O();
$c_T2.prototype.constructor = $c_T2;
/** @constructor */
function $h_T2() {
}
$h_T2.prototype = $c_T2.prototype;
$c_T2.prototype.productArity__I = (function() {
  return 2;
});
$c_T2.prototype.productElement__I__O = (function(n) {
  return $f_s_Product2__productElement__I__O(this, n);
});
$c_T2.prototype._1__O = (function() {
  return this.T2__f__1;
});
$c_T2.prototype._2__O = (function() {
  return this.T2__f__2;
});
$c_T2.prototype.toString__T = (function() {
  return (((("(" + this._1__O()) + ",") + this._2__O()) + ")");
});
$c_T2.prototype.copy$default$1__O = (function() {
  return this._1__O();
});
$c_T2.prototype.productPrefix__T = (function() {
  return "Tuple2";
});
$c_T2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T2.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-116390334), true);
});
$c_T2.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_T2)) {
    var Tuple2$1 = $as_T2(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this._1__O(), $n(Tuple2$1)._1__O()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this._2__O(), $n(Tuple2$1)._2__O()));
  } else {
    return false;
  }
});
function $as_T2(obj) {
  return (((obj instanceof $c_T2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple2"));
}
function $isArrayOf_T2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T2)));
}
function $asArrayOf_T2(obj, depth) {
  return (($isArrayOf_T2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple2;", depth));
}
var $d_T2 = new $TypeData().initClass($c_T2, "scala.Tuple2", ({
  T2: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.T3__f__1 = null;
  this.T3__f__2 = null;
  this.T3__f__3 = null;
  this.T3__f__1 = _1;
  this.T3__f__2 = _2;
  this.T3__f__3 = _3;
}
$c_T3.prototype = new $h_O();
$c_T3.prototype.constructor = $c_T3;
/** @constructor */
function $h_T3() {
}
$h_T3.prototype = $c_T3.prototype;
$c_T3.prototype.productArity__I = (function() {
  return 3;
});
$c_T3.prototype.productElement__I__O = (function(n) {
  return $f_s_Product3__productElement__I__O(this, n);
});
$c_T3.prototype.toString__T = (function() {
  return (((((("(" + this.T3__f__1) + ",") + this.T3__f__2) + ",") + this.T3__f__3) + ")");
});
$c_T3.prototype.productPrefix__T = (function() {
  return "Tuple3";
});
$c_T3.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T3.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-192629203), true);
});
$c_T3.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_T3)) {
    var Tuple3$1 = $as_T3(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__1, $n(Tuple3$1).T3__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__2, $n(Tuple3$1).T3__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__3, $n(Tuple3$1).T3__f__3)));
  } else {
    return false;
  }
});
function $as_T3(obj) {
  return (((obj instanceof $c_T3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple3"));
}
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T3)));
}
function $asArrayOf_T3(obj, depth) {
  return (($isArrayOf_T3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple3;", depth));
}
var $d_T3 = new $TypeData().initClass($c_T3, "scala.Tuple3", ({
  T3: 1,
  s_Product3: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_T4(_1, _2, _3, _4) {
  this.T4__f__1 = null;
  this.T4__f__2 = null;
  this.T4__f__3 = null;
  this.T4__f__4 = null;
  this.T4__f__1 = _1;
  this.T4__f__2 = _2;
  this.T4__f__3 = _3;
  this.T4__f__4 = _4;
}
$c_T4.prototype = new $h_O();
$c_T4.prototype.constructor = $c_T4;
/** @constructor */
function $h_T4() {
}
$h_T4.prototype = $c_T4.prototype;
$c_T4.prototype.productArity__I = (function() {
  return 4;
});
$c_T4.prototype.productElement__I__O = (function(n) {
  return $f_s_Product4__productElement__I__O(this, n);
});
$c_T4.prototype.toString__T = (function() {
  return (((((((("(" + this.T4__f__1) + ",") + this.T4__f__2) + ",") + this.T4__f__3) + ",") + this.T4__f__4) + ")");
});
$c_T4.prototype.productPrefix__T = (function() {
  return "Tuple4";
});
$c_T4.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T4.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1542739752), true);
});
$c_T4.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_T4)) {
    var Tuple4$1 = $as_T4(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__1, $n(Tuple4$1).T4__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__2, $n(Tuple4$1).T4__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__3, $n(Tuple4$1).T4__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__4, $n(Tuple4$1).T4__f__4)));
  } else {
    return false;
  }
});
function $as_T4(obj) {
  return (((obj instanceof $c_T4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple4"));
}
function $isArrayOf_T4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T4)));
}
function $asArrayOf_T4(obj, depth) {
  return (($isArrayOf_T4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple4;", depth));
}
var $d_T4 = new $TypeData().initClass($c_T4, "scala.Tuple4", ({
  T4: 1,
  s_Product4: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_BitSetOps$$anon$1(outer, start$1) {
  this.sc_BitSetOps$$anon$1__f_currentPos = 0;
  this.sc_BitSetOps$$anon$1__f_currentWord_$lo = 0;
  this.sc_BitSetOps$$anon$1__f_currentWord_$hi = 0;
  this.sc_BitSetOps$$anon$1__f_$outer = null;
  $n(outer);
  this.sc_BitSetOps$$anon$1__f_$outer = outer;
  this.sc_BitSetOps$$anon$1__f_currentPos = ((start$1 > 0) ? (start$1 >> 6) : 0);
  if ((start$1 > 0)) {
    var $x_2 = $n(outer).word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos);
    var x_$_lo = $x_2.l;
    var x_$_hi = $x_2.h;
    var n = (63 & start$1);
    var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
    var hi = (((32 & n) === 0) ? (((2147483647 >>> (~n)) | 0) | ((-1) << n)) : ((-1) << n));
    var lo$1 = (x_$_lo & lo);
    var hi$1 = (x_$_hi & hi);
    var $x_1_$_lo = lo$1;
    var $x_1_$_hi = hi$1;
  } else {
    var $x_3 = $n(outer).word__I__J(0);
    var $x_1_$_lo = $x_3.l;
    var $x_1_$_hi = $x_3.h;
  }
  this.sc_BitSetOps$$anon$1__f_currentWord_$lo = $x_1_$_lo;
  this.sc_BitSetOps$$anon$1__f_currentWord_$hi = $x_1_$_hi;
}
$c_sc_BitSetOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_BitSetOps$$anon$1.prototype.constructor = $c_sc_BitSetOps$$anon$1;
/** @constructor */
function $h_sc_BitSetOps$$anon$1() {
}
$h_sc_BitSetOps$$anon$1.prototype = $c_sc_BitSetOps$$anon$1.prototype;
$c_sc_BitSetOps$$anon$1.prototype.hasNext__Z = (function() {
  while (true) {
    var x_$_lo = this.sc_BitSetOps$$anon$1__f_currentWord_$lo;
    var x_$_hi = this.sc_BitSetOps$$anon$1__f_currentWord_$hi;
    if (((x_$_lo | x_$_hi) === 0)) {
      if ((((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0) >= $n(this.sc_BitSetOps$$anon$1__f_$outer).nwords__I())) {
        return false;
      }
      this.sc_BitSetOps$$anon$1__f_currentPos = ((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0);
      var $x_1 = $n(this.sc_BitSetOps$$anon$1__f_$outer).word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos);
      this.sc_BitSetOps$$anon$1__f_currentWord_$lo = $x_1.l;
      this.sc_BitSetOps$$anon$1__f_currentWord_$hi = $x_1.h;
    } else {
      break;
    }
  }
  return true;
});
$c_sc_BitSetOps$$anon$1.prototype.next__I = (function() {
  if (this.hasNext__Z()) {
    var l_$_lo = this.sc_BitSetOps$$anon$1__f_currentWord_$lo;
    var l_$_hi = this.sc_BitSetOps$$anon$1__f_currentWord_$hi;
    if ((l_$_lo !== 0)) {
      var i = ((~l_$_lo) & ((l_$_lo - 1) | 0));
      var bitPos = ((32 - Math.clz32(i)) | 0);
    } else {
      var i$1 = ((~l_$_hi) & ((l_$_hi - 1) | 0));
      var bitPos = ((64 - Math.clz32(i$1)) | 0);
    }
    var x$1_$_lo = this.sc_BitSetOps$$anon$1__f_currentWord_$lo;
    var x$1_$_hi = this.sc_BitSetOps$$anon$1__f_currentWord_$hi;
    var x_$_lo = this.sc_BitSetOps$$anon$1__f_currentWord_$lo;
    var x_$_hi = this.sc_BitSetOps$$anon$1__f_currentWord_$hi;
    var lo = ((x_$_lo - 1) | 0);
    var hi = ((((x_$_hi - 1) | 0) + (((x_$_lo | (~lo)) >>> 31) | 0)) | 0);
    var lo$1 = (x$1_$_lo & lo);
    var hi$1 = (x$1_$_hi & hi);
    this.sc_BitSetOps$$anon$1__f_currentWord_$lo = lo$1;
    this.sc_BitSetOps$$anon$1__f_currentWord_$hi = hi$1;
    return (((this.sc_BitSetOps$$anon$1__f_currentPos << 6) + bitPos) | 0);
  } else {
    return $uI($n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O());
  }
});
$c_sc_BitSetOps$$anon$1.prototype.next__O = (function() {
  return this.next__I();
});
var $d_sc_BitSetOps$$anon$1 = new $TypeData().initClass($c_sc_BitSetOps$$anon$1, "scala.collection.BitSetOps$$anon$1", ({
  sc_BitSetOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_ClassTagSeqFactory$AnySeqDelegate(delegate) {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
  $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__(this, delegate);
}
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = new $h_sc_ClassTagIterableFactory$AnyIterableDelegate();
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.constructor = $c_sc_ClassTagSeqFactory$AnySeqDelegate;
/** @constructor */
function $h_sc_ClassTagSeqFactory$AnySeqDelegate() {
}
$h_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = $c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype;
var $d_sc_ClassTagSeqFactory$AnySeqDelegate = new $TypeData().initClass($c_sc_ClassTagSeqFactory$AnySeqDelegate, "scala.collection.ClassTagSeqFactory$AnySeqDelegate", ({
  sc_ClassTagSeqFactory$AnySeqDelegate: 1,
  sc_ClassTagIterableFactory$AnyIterableDelegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SeqFactory: 1
}));
function $f_sc_IndexedSeqOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_IndexedSeqView$Take($thiz, n));
}
function $f_sc_IndexedSeqOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), $thiz, n));
}
function $f_sc_IndexedSeqOps__dropRight__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), $thiz, n));
}
function $f_sc_IndexedSeqOps__map__F1__O($thiz, f) {
  return $n($thiz.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O($ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), $thiz, f));
}
function $f_sc_IndexedSeqOps__reverse__O($thiz) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_IndexedSeqView$Reverse($thiz));
}
function $f_sc_IndexedSeqOps__head__O($thiz) {
  if ((!$thiz.isEmpty__Z())) {
    return $thiz.apply__I__O(0);
  } else {
    if ($is_sc_IndexedSeq($thiz)) {
      var x2 = $as_sc_IndexedSeq($thiz);
      var this$1 = $n(x2);
      var $x_1 = this$1.className__T();
    } else {
      var $x_1 = $thiz.toString__T();
    }
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("head of empty " + $x_1));
  }
}
function $f_sc_IndexedSeqOps__last__O($thiz) {
  if ((!$thiz.isEmpty__Z())) {
    return $thiz.apply__I__O((($thiz.length__I() - 1) | 0));
  } else {
    if ($is_sc_IndexedSeq($thiz)) {
      var x2 = $as_sc_IndexedSeq($thiz);
      var this$1 = $n(x2);
      var $x_1 = this$1.className__T();
    } else {
      var $x_1 = $thiz.toString__T();
    }
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("last of empty " + $x_1));
  }
}
function $is_sc_IndexedSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeqOps)));
}
function $as_sc_IndexedSeqOps(obj) {
  return (($is_sc_IndexedSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IndexedSeqOps"));
}
function $isArrayOf_sc_IndexedSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeqOps)));
}
function $asArrayOf_sc_IndexedSeqOps(obj, depth) {
  return (($isArrayOf_sc_IndexedSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IndexedSeqOps;", depth));
}
function $f_sc_Iterable__toString__T($thiz) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, ($thiz.className__T() + "("), ", ", ")");
}
function $is_sc_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterable)));
}
function $as_sc_Iterable(obj) {
  return (($is_sc_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterable"));
}
function $isArrayOf_sc_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterable)));
}
function $asArrayOf_sc_Iterable(obj, depth) {
  return (($isArrayOf_sc_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterable;", depth));
}
function $p_sc_Iterator$$anon$10__nextCur__V($thiz) {
  $thiz.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  $thiz.sc_Iterator$$anon$10__f_cur = $n($as_sc_IterableOnce($n($thiz.sc_Iterator$$anon$10__f_f$3).apply__O__O($n($thiz.sc_Iterator$$anon$10__f_$outer).next__O()))).iterator__sc_Iterator();
  $thiz.sc_Iterator$$anon$10__f__hasNext = (-1);
}
/** @constructor */
function $c_sc_Iterator$$anon$10(outer, f$3) {
  this.sc_Iterator$$anon$10__f_cur = null;
  this.sc_Iterator$$anon$10__f__hasNext = 0;
  this.sc_Iterator$$anon$10__f_$outer = null;
  this.sc_Iterator$$anon$10__f_f$3 = null;
  $n(outer);
  this.sc_Iterator$$anon$10__f_$outer = outer;
  this.sc_Iterator$$anon$10__f_f$3 = f$3;
  this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  this.sc_Iterator$$anon$10__f__hasNext = (-1);
}
$c_sc_Iterator$$anon$10.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$10.prototype.constructor = $c_sc_Iterator$$anon$10;
/** @constructor */
function $h_sc_Iterator$$anon$10() {
}
$h_sc_Iterator$$anon$10.prototype = $c_sc_Iterator$$anon$10.prototype;
$c_sc_Iterator$$anon$10.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$10__f__hasNext === (-1))) {
    while ((!$n(this.sc_Iterator$$anon$10__f_cur).hasNext__Z())) {
      if ((!$n(this.sc_Iterator$$anon$10__f_$outer).hasNext__Z())) {
        this.sc_Iterator$$anon$10__f__hasNext = 0;
        this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
        return false;
      }
      $p_sc_Iterator$$anon$10__nextCur__V(this);
    }
    this.sc_Iterator$$anon$10__f__hasNext = 1;
    return true;
  } else {
    return (this.sc_Iterator$$anon$10__f__hasNext === 1);
  }
});
$c_sc_Iterator$$anon$10.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$10__f__hasNext = (-1);
  }
  return $n(this.sc_Iterator$$anon$10__f_cur).next__O();
});
var $d_sc_Iterator$$anon$10 = new $TypeData().initClass($c_sc_Iterator$$anon$10, "scala.collection.Iterator$$anon$10", ({
  sc_Iterator$$anon$10: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$19() {
}
$c_sc_Iterator$$anon$19.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$19.prototype.constructor = $c_sc_Iterator$$anon$19;
/** @constructor */
function $h_sc_Iterator$$anon$19() {
}
$h_sc_Iterator$$anon$19.prototype = $c_sc_Iterator$$anon$19.prototype;
$c_sc_Iterator$$anon$19.prototype.hasNext__Z = (function() {
  return false;
});
$c_sc_Iterator$$anon$19.prototype.next__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
});
$c_sc_Iterator$$anon$19.prototype.knownSize__I = (function() {
  return 0;
});
$c_sc_Iterator$$anon$19.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return this;
});
$c_sc_Iterator$$anon$19.prototype.next__O = (function() {
  this.next__E();
});
var $d_sc_Iterator$$anon$19 = new $TypeData().initClass($c_sc_Iterator$$anon$19, "scala.collection.Iterator$$anon$19", ({
  sc_Iterator$$anon$19: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$20(a$1) {
  this.sc_Iterator$$anon$20__f_consumed = false;
  this.sc_Iterator$$anon$20__f_a$1 = null;
  this.sc_Iterator$$anon$20__f_a$1 = a$1;
  this.sc_Iterator$$anon$20__f_consumed = false;
}
$c_sc_Iterator$$anon$20.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$20.prototype.constructor = $c_sc_Iterator$$anon$20;
/** @constructor */
function $h_sc_Iterator$$anon$20() {
}
$h_sc_Iterator$$anon$20.prototype = $c_sc_Iterator$$anon$20.prototype;
$c_sc_Iterator$$anon$20.prototype.hasNext__Z = (function() {
  return (!this.sc_Iterator$$anon$20__f_consumed);
});
$c_sc_Iterator$$anon$20.prototype.next__O = (function() {
  if (this.sc_Iterator$$anon$20__f_consumed) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    this.sc_Iterator$$anon$20__f_consumed = true;
    return this.sc_Iterator$$anon$20__f_a$1;
  }
});
$c_sc_Iterator$$anon$20.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return (((this.sc_Iterator$$anon$20__f_consumed || (from > 0)) || (until === 0)) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : this);
});
var $d_sc_Iterator$$anon$20 = new $TypeData().initClass($c_sc_Iterator$$anon$20, "scala.collection.Iterator$$anon$20", ({
  sc_Iterator$$anon$20: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$6(outer, p$1, isFlipped$1) {
  this.sc_Iterator$$anon$6__f_hd = null;
  this.sc_Iterator$$anon$6__f_hdDefined = false;
  this.sc_Iterator$$anon$6__f_$outer = null;
  this.sc_Iterator$$anon$6__f_p$1 = null;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = false;
  $n(outer);
  this.sc_Iterator$$anon$6__f_$outer = outer;
  this.sc_Iterator$$anon$6__f_p$1 = p$1;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = isFlipped$1;
  this.sc_Iterator$$anon$6__f_hdDefined = false;
}
$c_sc_Iterator$$anon$6.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$6.prototype.constructor = $c_sc_Iterator$$anon$6;
/** @constructor */
function $h_sc_Iterator$$anon$6() {
}
$h_sc_Iterator$$anon$6.prototype = $c_sc_Iterator$$anon$6.prototype;
$c_sc_Iterator$$anon$6.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$$anon$6__f_hdDefined) {
    return true;
  } else {
    if ((!$n(this.sc_Iterator$$anon$6__f_$outer).hasNext__Z())) {
      return false;
    }
    this.sc_Iterator$$anon$6__f_hd = $n(this.sc_Iterator$$anon$6__f_$outer).next__O();
    while (($uZ($n(this.sc_Iterator$$anon$6__f_p$1).apply__O__O(this.sc_Iterator$$anon$6__f_hd)) === this.sc_Iterator$$anon$6__f_isFlipped$1)) {
      if ((!$n(this.sc_Iterator$$anon$6__f_$outer).hasNext__Z())) {
        return false;
      }
      this.sc_Iterator$$anon$6__f_hd = $n(this.sc_Iterator$$anon$6__f_$outer).next__O();
    }
    this.sc_Iterator$$anon$6__f_hdDefined = true;
    return true;
  }
});
$c_sc_Iterator$$anon$6.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$6__f_hdDefined = false;
    return this.sc_Iterator$$anon$6__f_hd;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
var $d_sc_Iterator$$anon$6 = new $TypeData().initClass($c_sc_Iterator$$anon$6, "scala.collection.Iterator$$anon$6", ({
  sc_Iterator$$anon$6: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$9(outer, f$2) {
  this.sc_Iterator$$anon$9__f_$outer = null;
  this.sc_Iterator$$anon$9__f_f$2 = null;
  $n(outer);
  this.sc_Iterator$$anon$9__f_$outer = outer;
  this.sc_Iterator$$anon$9__f_f$2 = f$2;
}
$c_sc_Iterator$$anon$9.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$9.prototype.constructor = $c_sc_Iterator$$anon$9;
/** @constructor */
function $h_sc_Iterator$$anon$9() {
}
$h_sc_Iterator$$anon$9.prototype = $c_sc_Iterator$$anon$9.prototype;
$c_sc_Iterator$$anon$9.prototype.knownSize__I = (function() {
  return $n(this.sc_Iterator$$anon$9__f_$outer).knownSize__I();
});
$c_sc_Iterator$$anon$9.prototype.hasNext__Z = (function() {
  return $n(this.sc_Iterator$$anon$9__f_$outer).hasNext__Z();
});
$c_sc_Iterator$$anon$9.prototype.next__O = (function() {
  return $n(this.sc_Iterator$$anon$9__f_f$2).apply__O__O($n(this.sc_Iterator$$anon$9__f_$outer).next__O());
});
var $d_sc_Iterator$$anon$9 = new $TypeData().initClass($c_sc_Iterator$$anon$9, "scala.collection.Iterator$$anon$9", ({
  sc_Iterator$$anon$9: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sc_Iterator$ConcatIterator__merge$1__V($thiz) {
  while (true) {
    if (($thiz.sc_Iterator$ConcatIterator__f_current instanceof $c_sc_Iterator$ConcatIterator)) {
      var c = $as_sc_Iterator$ConcatIterator($thiz.sc_Iterator$ConcatIterator__f_current);
      $thiz.sc_Iterator$ConcatIterator__f_current = $n(c).sc_Iterator$ConcatIterator__f_current;
      $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = $n(c).sc_Iterator$ConcatIterator__f_currentHasNextChecked;
      if (($n(c).sc_Iterator$ConcatIterator__f_tail !== null)) {
        if (($thiz.sc_Iterator$ConcatIterator__f_last === null)) {
          $thiz.sc_Iterator$ConcatIterator__f_last = $n(c).sc_Iterator$ConcatIterator__f_last;
        }
        $n($n(c).sc_Iterator$ConcatIterator__f_last).sc_Iterator$ConcatIteratorCell__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail;
        $thiz.sc_Iterator$ConcatIterator__f_tail = $n(c).sc_Iterator$ConcatIterator__f_tail;
      }
      continue;
    }
    return (void 0);
  }
}
function $p_sc_Iterator$ConcatIterator__advance$1__Z($thiz) {
  while (true) {
    if (($thiz.sc_Iterator$ConcatIterator__f_tail === null)) {
      $thiz.sc_Iterator$ConcatIterator__f_current = null;
      $thiz.sc_Iterator$ConcatIterator__f_last = null;
      return false;
    } else {
      $thiz.sc_Iterator$ConcatIterator__f_current = $n($thiz.sc_Iterator$ConcatIterator__f_tail).headIterator__sc_Iterator();
      if (($thiz.sc_Iterator$ConcatIterator__f_last === $thiz.sc_Iterator$ConcatIterator__f_tail)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = $n($thiz.sc_Iterator$ConcatIterator__f_last).sc_Iterator$ConcatIteratorCell__f_tail;
      }
      $thiz.sc_Iterator$ConcatIterator__f_tail = $n($thiz.sc_Iterator$ConcatIterator__f_tail).sc_Iterator$ConcatIteratorCell__f_tail;
      $p_sc_Iterator$ConcatIterator__merge$1__V($thiz);
      if ($thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
        return true;
      } else {
        if ((!(($thiz.sc_Iterator$ConcatIterator__f_current !== null) && $n($thiz.sc_Iterator$ConcatIterator__f_current).hasNext__Z()))) {
          continue;
        }
        $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
        return true;
      }
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIterator(current) {
  this.sc_Iterator$ConcatIterator__f_current = null;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
  this.sc_Iterator$ConcatIterator__f_current = current;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
}
$c_sc_Iterator$ConcatIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$ConcatIterator.prototype.constructor = $c_sc_Iterator$ConcatIterator;
/** @constructor */
function $h_sc_Iterator$ConcatIterator() {
}
$h_sc_Iterator$ConcatIterator.prototype = $c_sc_Iterator$ConcatIterator.prototype;
$c_sc_Iterator$ConcatIterator.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
    return true;
  } else if ((this.sc_Iterator$ConcatIterator__f_current !== null)) {
    if ($n(this.sc_Iterator$ConcatIterator__f_current).hasNext__Z()) {
      this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
      return true;
    } else {
      return $p_sc_Iterator$ConcatIterator__advance$1__Z(this);
    }
  } else {
    return false;
  }
});
$c_sc_Iterator$ConcatIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
    return $n(this.sc_Iterator$ConcatIterator__f_current).next__O();
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
$c_sc_Iterator$ConcatIterator.prototype.concat__F0__sc_Iterator = (function(that) {
  var c = new $c_sc_Iterator$ConcatIteratorCell(that, null);
  if ((this.sc_Iterator$ConcatIterator__f_tail === null)) {
    this.sc_Iterator$ConcatIterator__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c;
  } else {
    $n(this.sc_Iterator$ConcatIterator__f_last).sc_Iterator$ConcatIteratorCell__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c;
  }
  if ((this.sc_Iterator$ConcatIterator__f_current === null)) {
    this.sc_Iterator$ConcatIterator__f_current = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  }
  return this;
});
function $as_sc_Iterator$ConcatIterator(obj) {
  return (((obj instanceof $c_sc_Iterator$ConcatIterator) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator$ConcatIterator"));
}
function $isArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator$ConcatIterator)));
}
function $asArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (($isArrayOf_sc_Iterator$ConcatIterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator$ConcatIterator;", depth));
}
var $d_sc_Iterator$ConcatIterator = new $TypeData().initClass($c_sc_Iterator$ConcatIterator, "scala.collection.Iterator$ConcatIterator", ({
  sc_Iterator$ConcatIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sc_Iterator$SliceIterator__skip__V($thiz) {
  while (($thiz.sc_Iterator$SliceIterator__f_dropping > 0)) {
    if ($n($thiz.sc_Iterator$SliceIterator__f_underlying).hasNext__Z()) {
      $n($thiz.sc_Iterator$SliceIterator__f_underlying).next__O();
      $thiz.sc_Iterator$SliceIterator__f_dropping = (($thiz.sc_Iterator$SliceIterator__f_dropping - 1) | 0);
    } else {
      $thiz.sc_Iterator$SliceIterator__f_dropping = 0;
    }
  }
}
function $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I($thiz, lo$1) {
  if (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    return (-1);
  } else {
    var that = (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining - lo$1) | 0);
    return ((that < 0) ? 0 : that);
  }
}
/** @constructor */
function $c_sc_Iterator$SliceIterator(underlying, start, limit) {
  this.sc_Iterator$SliceIterator__f_underlying = null;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = 0;
  this.sc_Iterator$SliceIterator__f_dropping = 0;
  this.sc_Iterator$SliceIterator__f_underlying = underlying;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = limit;
  this.sc_Iterator$SliceIterator__f_dropping = start;
}
$c_sc_Iterator$SliceIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$SliceIterator.prototype.constructor = $c_sc_Iterator$SliceIterator;
/** @constructor */
function $h_sc_Iterator$SliceIterator() {
}
$h_sc_Iterator$SliceIterator.prototype = $c_sc_Iterator$SliceIterator.prototype;
$c_sc_Iterator$SliceIterator.prototype.knownSize__I = (function() {
  var size = $n(this.sc_Iterator$SliceIterator__f_underlying).knownSize__I();
  if ((size < 0)) {
    return (-1);
  } else {
    var that = ((size - this.sc_Iterator$SliceIterator__f_dropping) | 0);
    var dropSize = ((that < 0) ? 0 : that);
    if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
      return dropSize;
    } else {
      var x = this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining;
      return ((x < dropSize) ? x : dropSize);
    }
  }
});
$c_sc_Iterator$SliceIterator.prototype.hasNext__Z = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining !== 0) && $n(this.sc_Iterator$SliceIterator__f_underlying).hasNext__Z());
});
$c_sc_Iterator$SliceIterator.prototype.next__O = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining > 0)) {
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining - 1) | 0);
    return $n(this.sc_Iterator$SliceIterator__f_underlying).next__O();
  } else {
    return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0) ? $n(this.sc_Iterator$SliceIterator__f_underlying).next__O() : $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O());
  }
});
$c_sc_Iterator$SliceIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  if ((until < 0)) {
    var rest = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
  } else if ((until <= lo)) {
    var rest = 0;
  } else if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    var rest = ((until - lo) | 0);
  } else {
    var x = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
    var that = ((until - lo) | 0);
    var rest = ((x < that) ? x : that);
  }
  var sum = ((this.sc_Iterator$SliceIterator__f_dropping + lo) | 0);
  if ((rest === 0)) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  } else if ((sum < 0)) {
    this.sc_Iterator$SliceIterator__f_dropping = 2147483647;
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = 0;
    var xs = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_sc_Iterator$SliceIterator(this.sc_Iterator$SliceIterator__f_underlying, ((sum - 2147483647) | 0), rest)));
    return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
  } else {
    this.sc_Iterator$SliceIterator__f_dropping = sum;
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = rest;
    return this;
  }
});
var $d_sc_Iterator$SliceIterator = new $TypeData().initClass($c_sc_Iterator$SliceIterator, "scala.collection.Iterator$SliceIterator", ({
  sc_Iterator$SliceIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Iterator$UnfoldIterator(init, f) {
  this.sc_Iterator$UnfoldIterator__f_f = null;
  this.sc_Iterator$UnfoldIterator__f_state = null;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null;
  this.sc_Iterator$UnfoldIterator__f_f = f;
  this.sc_Iterator$UnfoldIterator__f_state = init;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null;
}
$c_sc_Iterator$UnfoldIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$UnfoldIterator.prototype.constructor = $c_sc_Iterator$UnfoldIterator;
/** @constructor */
function $h_sc_Iterator$UnfoldIterator() {
}
$h_sc_Iterator$UnfoldIterator.prototype = $c_sc_Iterator$UnfoldIterator.prototype;
$c_sc_Iterator$UnfoldIterator.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$UnfoldIterator__f_nextResult === null)) {
    var res = $as_s_Option($n(this.sc_Iterator$UnfoldIterator__f_f).apply__O__O(this.sc_Iterator$UnfoldIterator__f_state));
    if ((res === null)) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "null during unfold");
    }
    this.sc_Iterator$UnfoldIterator__f_nextResult = res;
    this.sc_Iterator$UnfoldIterator__f_state = null;
  }
  var this$1 = $n(this.sc_Iterator$UnfoldIterator__f_nextResult);
  return (!this$1.isEmpty__Z());
});
$c_sc_Iterator$UnfoldIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var x1 = $as_T2($n(this.sc_Iterator$UnfoldIterator__f_nextResult).get__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var value = $n(x1)._1__O();
    var newState = $n(x1)._2__O();
    this.sc_Iterator$UnfoldIterator__f_state = newState;
    this.sc_Iterator$UnfoldIterator__f_nextResult = null;
    return value;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
var $d_sc_Iterator$UnfoldIterator = new $TypeData().initClass($c_sc_Iterator$UnfoldIterator, "scala.collection.Iterator$UnfoldIterator", ({
  sc_Iterator$UnfoldIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_LinearSeqIterator(coll) {
  this.sc_LinearSeqIterator__f_these = null;
  this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => coll)));
}
$c_sc_LinearSeqIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_LinearSeqIterator.prototype.constructor = $c_sc_LinearSeqIterator;
/** @constructor */
function $h_sc_LinearSeqIterator() {
}
$h_sc_LinearSeqIterator.prototype = $c_sc_LinearSeqIterator.prototype;
$c_sc_LinearSeqIterator.prototype.hasNext__Z = (function() {
  var this$1 = $n($n(this.sc_LinearSeqIterator__f_these).v__sc_LinearSeqOps());
  return (!this$1.isEmpty__Z());
});
$c_sc_LinearSeqIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var cur = $n(this.sc_LinearSeqIterator__f_these).v__sc_LinearSeqOps();
    var result = $n(cur).head__O();
    this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $as_sc_LinearSeq($n(cur).tail__O()))));
    return result;
  }
});
var $d_sc_LinearSeqIterator = new $TypeData().initClass($c_sc_LinearSeqIterator, "scala.collection.LinearSeqIterator", ({
  sc_LinearSeqIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $f_sc_LinearSeqOps__iterator__sc_Iterator($thiz) {
  return (($thiz.knownSize__I() === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_LinearSeqIterator($thiz));
}
function $f_sc_LinearSeqOps__length__I($thiz) {
  var these = $as_sc_LinearSeq($thiz);
  var len = 0;
  while (true) {
    var this$1 = $n(these);
    if ((!this$1.isEmpty__Z())) {
      len = ((1 + len) | 0);
      these = $as_sc_LinearSeq($n(these).tail__O());
    } else {
      break;
    }
  }
  return len;
}
function $f_sc_LinearSeqOps__last__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "LinearSeq.last");
  } else {
    var these = $as_sc_LinearSeq($thiz);
    var scout = $as_sc_LinearSeq($thiz.tail__O());
    while (true) {
      var this$1 = $n(scout);
      if ((!this$1.isEmpty__Z())) {
        these = scout;
        scout = $as_sc_LinearSeq($n(scout).tail__O());
      } else {
        break;
      }
    }
    return $n(these).head__O();
  }
}
function $f_sc_LinearSeqOps__lengthCompare__I__I($thiz, len) {
  return ((len < 0) ? 1 : $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, 0, $as_sc_LinearSeq($thiz), len));
}
function $f_sc_LinearSeqOps__isDefinedAt__I__Z($thiz, x) {
  return ((x >= 0) && ($thiz.lengthCompare__I__I(x) > 0));
}
function $f_sc_LinearSeqOps__apply__I__O($thiz, n) {
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  var skipped = $as_sc_LinearSeq($thiz.drop__I__O(n));
  if ($n(skipped).isEmpty__Z()) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return $n(skipped).head__O();
}
function $f_sc_LinearSeqOps__foreach__F1__V($thiz, f) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    $n(f).apply__O__O($n(these).head__O());
    these = $as_sc_LinearSeq($n(these).tail__O());
  }
}
function $f_sc_LinearSeqOps__forall__F1__Z($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    if ((!$uZ($n(p).apply__O__O($n(these).head__O())))) {
      return false;
    }
    these = $as_sc_LinearSeq($n(these).tail__O());
  }
  return true;
}
function $f_sc_LinearSeqOps__exists__F1__Z($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return true;
    }
    these = $as_sc_LinearSeq($n(these).tail__O());
  }
  return false;
}
function $f_sc_LinearSeqOps__foldLeft__O__F2__O($thiz, z, op) {
  var acc = z;
  var these = $as_sc_LinearSeq($thiz);
  while ((!$n(these).isEmpty__Z())) {
    acc = $n(op).apply__O__O__O(acc, $n(these).head__O());
    these = $as_sc_LinearSeq($n(these).tail__O());
  }
  return acc;
}
function $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  if ($is_sc_LinearSeq(that)) {
    var x2 = $as_sc_LinearSeq(that);
    return $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, $as_sc_LinearSeq($thiz), x2);
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that);
  }
}
function $f_sc_LinearSeqOps__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var these = $as_sc_LinearSeq($thiz.drop__I__O(from));
  while (true) {
    var this$3 = $n(these);
    if ((!this$3.isEmpty__Z())) {
      if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
        return i;
      }
      i = ((1 + i) | 0);
      these = $as_sc_LinearSeq($n(these).tail__O());
    } else {
      break;
    }
  }
  return (-1);
}
function $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return ($n(xs).isEmpty__Z() ? 0 : 1);
    } else if ($n(xs).isEmpty__Z()) {
      return (-1);
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sc_LinearSeq($n(xs).tail__O());
      i = temp$i;
      xs = temp$xs;
    }
  }
}
function $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true;
    } else {
      var this$1 = $n(a);
      if ((!this$1.isEmpty__Z())) {
        var this$2 = $n(b);
        var $x_1 = (!this$2.isEmpty__Z());
      } else {
        var $x_1 = false;
      }
      if (($x_1 && $m_sr_BoxesRunTime$().equals__O__O__Z($n(a).head__O(), $n(b).head__O()))) {
        var temp$a = $as_sc_LinearSeq($n(a).tail__O());
        var temp$b = $as_sc_LinearSeq($n(b).tail__O());
        a = temp$a;
        b = temp$b;
        continue;
      }
      return ($n(a).isEmpty__Z() && $n(b).isEmpty__Z());
    }
  }
}
function $is_sc_LinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeqOps)));
}
function $as_sc_LinearSeqOps(obj) {
  return (($is_sc_LinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeqOps"));
}
function $isArrayOf_sc_LinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeqOps)));
}
function $asArrayOf_sc_LinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_LinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeqOps;", depth));
}
/** @constructor */
function $c_sc_MapOps$$anon$3(outer) {
  this.sc_MapOps$$anon$3__f_iter = null;
  this.sc_MapOps$$anon$3__f_iter = $n(outer).iterator__sc_Iterator();
}
$c_sc_MapOps$$anon$3.prototype = new $h_sc_AbstractIterator();
$c_sc_MapOps$$anon$3.prototype.constructor = $c_sc_MapOps$$anon$3;
/** @constructor */
function $h_sc_MapOps$$anon$3() {
}
$h_sc_MapOps$$anon$3.prototype = $c_sc_MapOps$$anon$3.prototype;
$c_sc_MapOps$$anon$3.prototype.hasNext__Z = (function() {
  return $n(this.sc_MapOps$$anon$3__f_iter).hasNext__Z();
});
$c_sc_MapOps$$anon$3.prototype.next__O = (function() {
  return $n($as_T2($n(this.sc_MapOps$$anon$3__f_iter).next__O()))._2__O();
});
var $d_sc_MapOps$$anon$3 = new $TypeData().initClass($c_sc_MapOps$$anon$3, "scala.collection.MapOps$$anon$3", ({
  sc_MapOps$$anon$3: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Seq$());
}
$c_sc_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sc_Seq$.prototype.constructor = $c_sc_Seq$;
/** @constructor */
function $h_sc_Seq$() {
}
$h_sc_Seq$.prototype = $c_sc_Seq$.prototype;
var $d_sc_Seq$ = new $TypeData().initClass($c_sc_Seq$, "scala.collection.Seq$", ({
  sc_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sc_Seq$;
function $m_sc_Seq$() {
  if ((!$n_sc_Seq$)) {
    $n_sc_Seq$ = new $c_sc_Seq$();
  }
  return $n_sc_Seq$;
}
function $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($thiz, that) {
  if ((($thiz instanceof $c_sci_Set$Set1) || (($thiz instanceof $c_sci_Set$Set2) || (($thiz instanceof $c_sci_Set$Set3) || ($thiz instanceof $c_sci_Set$Set4))))) {
    var result = $as_sci_SetOps($thiz);
    var it = $n(that).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var this$1 = $n(result);
      var elem = $n(it).next__O();
      result = this$1.incl__O__sci_SetOps(elem);
    }
    return result;
  } else {
    if ($is_sc_Iterable(that)) {
      var x2 = $as_sc_Iterable(that);
      var $x_1 = new $c_sc_View$Concat($thiz, x2);
    } else {
      var $x_1 = $n($thiz.iterator__sc_Iterator()).concat__F0__sc_Iterator(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n(that).iterator__sc_Iterator())));
    }
    return $as_sc_SetOps($thiz.fromSpecific__sc_IterableOnce__O($x_1));
  }
}
function $is_sc_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SetOps)));
}
function $as_sc_SetOps(obj) {
  return (($is_sc_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SetOps"));
}
function $isArrayOf_sc_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SetOps)));
}
function $asArrayOf_sc_SetOps(obj, depth) {
  return (($isArrayOf_sc_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SetOps;", depth));
}
/** @constructor */
function $c_sc_StrictOptimizedLinearSeqOps$$anon$1(outer) {
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = null;
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = outer;
}
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.constructor = $c_sc_StrictOptimizedLinearSeqOps$$anon$1;
/** @constructor */
function $h_sc_StrictOptimizedLinearSeqOps$$anon$1() {
}
$h_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = $c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype;
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.hasNext__Z = (function() {
  return (!$n(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current).isEmpty__Z());
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.next__O = (function() {
  var r = $n(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current).head__O();
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = $as_sc_StrictOptimizedLinearSeqOps($n(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current).tail__O());
  return r;
});
var $d_sc_StrictOptimizedLinearSeqOps$$anon$1 = new $TypeData().initClass($c_sc_StrictOptimizedLinearSeqOps$$anon$1, "scala.collection.StrictOptimizedLinearSeqOps$$anon$1", ({
  sc_StrictOptimizedLinearSeqOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sc_StringOps$$anon$1__advance__T($thiz) {
  var start = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  while (true) {
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$ = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var this$2 = $n(this$);
      var c = $charAt(this$2, i);
      var $x_1 = (!((c === 10) || (c === 13)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    } else {
      break;
    }
  }
  var end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var this$$2 = $thiz.sc_StringOps$$anon$1__f_$this$2;
    var i$1 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
    var this$5 = $n(this$$2);
    var c$1 = $charAt(this$5, i$1);
    $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$$3 = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i$2 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var this$7 = $n(this$$3);
      var c$2 = $charAt(this$7, i$2);
      var $x_2 = (((13 ^ c$1) | (10 ^ c$2)) === 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    }
    if ((!$thiz.sc_StringOps$$anon$1__f_stripped$1)) {
      end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
    }
  }
  var this$9 = $n($thiz.sc_StringOps$$anon$1__f_$this$2);
  var endIndex = end;
  if ((start < 0)) {
    $charAt(this$9, start);
  }
  if ((endIndex > this$9.length)) {
    $charAt(this$9, endIndex);
  }
  if ((endIndex < start)) {
    $charAt(this$9, (-1));
  }
  return $as_T(this$9.substring(start, endIndex));
}
/** @constructor */
function $c_sc_StringOps$$anon$1(\u03b4this$2, stripped$1) {
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = 0;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0;
  this.sc_StringOps$$anon$1__f_$this$2 = null;
  this.sc_StringOps$$anon$1__f_stripped$1 = false;
  this.sc_StringOps$$anon$1__f_$this$2 = \u03b4this$2;
  this.sc_StringOps$$anon$1__f_stripped$1 = stripped$1;
  var this$1 = $n(\u03b4this$2);
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = this$1.length;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0;
}
$c_sc_StringOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StringOps$$anon$1.prototype.constructor = $c_sc_StringOps$$anon$1;
/** @constructor */
function $h_sc_StringOps$$anon$1() {
}
$h_sc_StringOps$$anon$1.prototype = $c_sc_StringOps$$anon$1.prototype;
$c_sc_StringOps$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len);
});
$c_sc_StringOps$$anon$1.prototype.next__T = (function() {
  return ((this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index >= this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len) ? $as_T($n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O()) : $p_sc_StringOps$$anon$1__advance__T(this));
});
$c_sc_StringOps$$anon$1.prototype.next__O = (function() {
  return this.next__T();
});
var $d_sc_StringOps$$anon$1 = new $TypeData().initClass($c_sc_StringOps$$anon$1, "scala.collection.StringOps$$anon$1", ({
  sc_StringOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sc_View$DropRightIterator(underlying, maxlen) {
  this.sc_View$DropRightIterator__f_underlying = null;
  this.sc_View$DropRightIterator__f_maxlen = 0;
  this.sc_View$DropRightIterator__f_len = 0;
  this.sc_View$DropRightIterator__f_pos = 0;
  this.sc_View$DropRightIterator__f_buf = null;
  this.sc_View$DropRightIterator__f_underlying = underlying;
  this.sc_View$DropRightIterator__f_maxlen = maxlen;
  this.sc_View$DropRightIterator__f_len = (-1);
  this.sc_View$DropRightIterator__f_pos = 0;
}
$c_sc_View$DropRightIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_View$DropRightIterator.prototype.constructor = $c_sc_View$DropRightIterator;
/** @constructor */
function $h_sc_View$DropRightIterator() {
}
$h_sc_View$DropRightIterator.prototype = $c_sc_View$DropRightIterator.prototype;
$c_sc_View$DropRightIterator.prototype.init__V = (function() {
  if ((this.sc_View$DropRightIterator__f_buf === null)) {
    var x = this.sc_View$DropRightIterator__f_maxlen;
    this.sc_View$DropRightIterator__f_buf = $ct_scm_ArrayBuffer__I__(new $c_scm_ArrayBuffer(), ((x < 256) ? x : 256));
    while (((this.sc_View$DropRightIterator__f_pos < this.sc_View$DropRightIterator__f_maxlen) && $n(this.sc_View$DropRightIterator__f_underlying).hasNext__Z())) {
      $n(this.sc_View$DropRightIterator__f_buf).addOne__O__scm_ArrayBuffer($n(this.sc_View$DropRightIterator__f_underlying).next__O());
      this.sc_View$DropRightIterator__f_pos = ((1 + this.sc_View$DropRightIterator__f_pos) | 0);
    }
    if ((!$n(this.sc_View$DropRightIterator__f_underlying).hasNext__Z())) {
      this.sc_View$DropRightIterator__f_len = 0;
    }
    this.sc_View$DropRightIterator__f_pos = 0;
  }
});
$c_sc_View$DropRightIterator.prototype.knownSize__I = (function() {
  return this.sc_View$DropRightIterator__f_len;
});
$c_sc_View$DropRightIterator.prototype.hasNext__Z = (function() {
  this.init__V();
  return (this.sc_View$DropRightIterator__f_len !== 0);
});
$c_sc_View$DropRightIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var x = $n(this.sc_View$DropRightIterator__f_buf).apply__I__O(this.sc_View$DropRightIterator__f_pos);
    if ((this.sc_View$DropRightIterator__f_len === (-1))) {
      $n(this.sc_View$DropRightIterator__f_buf).update__I__O__V(this.sc_View$DropRightIterator__f_pos, $n(this.sc_View$DropRightIterator__f_underlying).next__O());
      if ((!$n(this.sc_View$DropRightIterator__f_underlying).hasNext__Z())) {
        this.sc_View$DropRightIterator__f_len = 0;
      }
    } else {
      this.sc_View$DropRightIterator__f_len = ((this.sc_View$DropRightIterator__f_len - 1) | 0);
    }
    this.sc_View$DropRightIterator__f_pos = ((1 + this.sc_View$DropRightIterator__f_pos) | 0);
    if ((this.sc_View$DropRightIterator__f_pos === this.sc_View$DropRightIterator__f_maxlen)) {
      this.sc_View$DropRightIterator__f_pos = 0;
    }
    return x;
  }
});
var $d_sc_View$DropRightIterator = new $TypeData().initClass($c_sc_View$DropRightIterator, "scala.collection.View$DropRightIterator", ({
  sc_View$DropRightIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sci_ChampBaseIterator__initNodes__V($thiz) {
  if (($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths === null)) {
    $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths = new $ac_I(($m_sci_Node$().sci_Node$__f_MaxDepth << 1));
    $thiz.sci_ChampBaseIterator__f_nodes = new ($d_sci_Node.getArrayOf().constr)($m_sci_Node$().sci_Node$__f_MaxDepth);
  }
}
function $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = $n(node).payloadArity__I();
}
function $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, node) {
  $p_sci_ChampBaseIterator__initNodes__V($thiz);
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0);
  var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
  var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
  $n($thiz.sci_ChampBaseIterator__f_nodes).set($thiz.sci_ChampBaseIterator__f_currentStackLevel, node);
  $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).set(cursorIndex, 0);
  $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).set(lengthIndex, $n(node).nodeArity__I());
}
function $p_sci_ChampBaseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (($thiz.sci_ChampBaseIterator__f_currentStackLevel - 1) | 0);
}
function $p_sci_ChampBaseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseIterator__f_currentStackLevel >= 0)) {
    var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
    var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
    var nodeCursor = $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).get(cursorIndex);
    var nodeLength = $n($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths).get(lengthIndex);
    if ((nodeCursor < nodeLength)) {
      var ev$1 = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths;
      $n(ev$1).set(cursorIndex, ((1 + $n(ev$1).get(cursorIndex)) | 0));
      var nextNode = $n($n($thiz.sci_ChampBaseIterator__f_nodes).get($thiz.sci_ChampBaseIterator__f_currentStackLevel)).getNode__I__sci_Node(nodeCursor);
      if ($n(nextNode).hasNodes__Z()) {
        $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, nextNode);
      }
      if ($n(nextNode).hasPayload__Z()) {
        $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, nextNode);
        return true;
      }
    } else {
      $p_sci_ChampBaseIterator__popNode__V($thiz);
    }
  }
  return false;
}
function $ct_sci_ChampBaseIterator__($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = 0;
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (-1);
  return $thiz;
}
function $ct_sci_ChampBaseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseIterator__($thiz);
  if ($n(rootNode).hasNodes__Z()) {
    $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, rootNode);
  }
  if ($n(rootNode).hasPayload__Z()) {
    $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, rootNode);
  }
  return $thiz;
}
/** @constructor */
function $c_sci_ChampBaseIterator() {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
}
$c_sci_ChampBaseIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_ChampBaseIterator.prototype.constructor = $c_sci_ChampBaseIterator;
/** @constructor */
function $h_sci_ChampBaseIterator() {
}
$h_sci_ChampBaseIterator.prototype = $c_sci_ChampBaseIterator.prototype;
$c_sci_ChampBaseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseIterator__f_currentValueCursor < this.sci_ChampBaseIterator__f_currentValueLength) || $p_sci_ChampBaseIterator__searchNextValueNode__Z(this));
});
function $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (($n(node).payloadArity__I() - 1) | 0);
}
function $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0);
  $n($thiz.sci_ChampBaseReverseIterator__f_nodeStack).set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, node);
  $n($thiz.sci_ChampBaseReverseIterator__f_nodeIndex).set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (($n(node).nodeArity__I() - 1) | 0));
}
function $p_sci_ChampBaseReverseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel - 1) | 0);
}
function $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel >= 0)) {
    var nodeCursor = $n($thiz.sci_ChampBaseReverseIterator__f_nodeIndex).get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
    $n($thiz.sci_ChampBaseReverseIterator__f_nodeIndex).set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, ((nodeCursor - 1) | 0));
    if ((nodeCursor >= 0)) {
      var nextNode = $n($n($thiz.sci_ChampBaseReverseIterator__f_nodeStack).get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel)).getNode__I__sci_Node(nodeCursor);
      $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, nextNode);
    } else {
      var currNode = $n($thiz.sci_ChampBaseReverseIterator__f_nodeStack).get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
      $p_sci_ChampBaseReverseIterator__popNode__V($thiz);
      if ($n(currNode).hasPayload__Z()) {
        $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, currNode);
        return true;
      }
    }
  }
  return false;
}
function $ct_sci_ChampBaseReverseIterator__($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex = new $ac_I(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack = new ($d_sci_Node.getArrayOf().constr)(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  return $thiz;
}
function $ct_sci_ChampBaseReverseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseReverseIterator__($thiz);
  $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, rootNode);
  $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz);
  return $thiz;
}
/** @constructor */
function $c_sci_ChampBaseReverseIterator() {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
}
$c_sci_ChampBaseReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_ChampBaseReverseIterator.prototype.constructor = $c_sci_ChampBaseReverseIterator;
/** @constructor */
function $h_sci_ChampBaseReverseIterator() {
}
$h_sci_ChampBaseReverseIterator.prototype = $c_sci_ChampBaseReverseIterator.prototype;
$c_sci_ChampBaseReverseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseReverseIterator__f_currentValueCursor >= 0) || $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z(this));
});
function $p_sci_HashMapBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashMapBuilder__f_aliased !== null);
}
function $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > $n(as).u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = (($n(as).u.length - ix) | 0);
  $systemArraycopy($n(as), ix, result, destPos, length);
  return result;
}
function $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V($thiz, bm, bitpos, key, originalHash, keyHash, value) {
  var dataIx = $n(bm).dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = $n(bm).sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, idx);
  dst.set(idx, key);
  dst.set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = (($n(src).u.length - idx) | 0);
  $systemArraycopyRefs($n(src), idx, dst, destPos, length);
  var dstHashes = $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, $n(bm).sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  $n(bm).sci_BitmapIndexedMapNode__f_dataMap = ($n(bm).sci_BitmapIndexedMapNode__f_dataMap | bitpos);
  $n(bm).sci_BitmapIndexedMapNode__f_content = dst;
  $n(bm).sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  $n(bm).sci_BitmapIndexedMapNode__f_size = ((1 + $n(bm).sci_BitmapIndexedMapNode__f_size) | 0);
  $n(bm).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = (($n(bm).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
}
function $p_sci_HashMapBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashMapBuilder__isAliased__Z($thiz)) {
    $p_sci_HashMapBuilder__copyElems__V($thiz);
  }
  $thiz.sci_HashMapBuilder__f_aliased = null;
}
function $p_sci_HashMapBuilder__copyElems__V($thiz) {
  $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = $n($thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode).copy__sci_BitmapIndexedMapNode();
}
/** @constructor */
function $c_sci_HashMapBuilder() {
  this.sci_HashMapBuilder__f_aliased = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = new $c_sci_BitmapIndexedMapNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0);
}
$c_sci_HashMapBuilder.prototype = new $h_O();
$c_sci_HashMapBuilder.prototype.constructor = $c_sci_HashMapBuilder;
/** @constructor */
function $h_sci_HashMapBuilder() {
}
$h_sci_HashMapBuilder.prototype = $c_sci_HashMapBuilder.prototype;
$c_sci_HashMapBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_HashMapBuilder.prototype.update__sci_MapNode__O__O__I__I__I__V = (function(mapNode, key, value, originalHash, keyHash, shift) {
  if ((mapNode instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(mapNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if ((($n(x2).sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
      var key0 = $n(x2).getKey__I__O(index);
      var key0UnimprovedHash = $n(x2).getHash__I__I(index);
      if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
        $n($n(x2).sci_BitmapIndexedMapNode__f_content).set(((1 + (index << 1)) | 0), value);
      } else {
        var value0 = $n(x2).getValue__I__O(index);
        var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
        var subNodeNew = $n(x2).mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
        $n(x2).migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
      }
    } else if ((($n(x2).sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
      var subNode = $n(x2).getNode__I__sci_MapNode(index$2);
      var beforeSize = $n(subNode).size__I();
      var beforeHash = $n(subNode).cachedJavaKeySetHashCode__I();
      this.update__sci_MapNode__O__O__I__I__I__V(subNode, key, value, originalHash, keyHash, ((5 + shift) | 0));
      $n(x2).sci_BitmapIndexedMapNode__f_size = (($n(x2).sci_BitmapIndexedMapNode__f_size + (($n(subNode).size__I() - beforeSize) | 0)) | 0);
      $n(x2).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = (($n(x2).sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + (($n(subNode).cachedJavaKeySetHashCode__I() - beforeHash) | 0)) | 0);
    } else {
      $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V(this, x2, bitpos, key, originalHash, keyHash, value);
    }
  } else if ((mapNode instanceof $c_sci_HashCollisionMapNode)) {
    var x3 = $as_sci_HashCollisionMapNode(mapNode);
    var index$3 = $n(x3).indexOf__O__I(key);
    if ((index$3 < 0)) {
      $n(x3).sci_HashCollisionMapNode__f_content = $n($n(x3).sci_HashCollisionMapNode__f_content).appended__O__sci_Vector(new $c_T2(key, value));
    } else {
      $n(x3).sci_HashCollisionMapNode__f_content = $n($n(x3).sci_HashCollisionMapNode__f_content).updated__I__O__sci_Vector(index$3, new $c_T2(key, value));
    }
  } else {
    throw new $c_s_MatchError(mapNode);
  }
});
$c_sci_HashMapBuilder.prototype.result__sci_HashMap = (function() {
  if (($n(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode).sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap;
  } else if ((this.sci_HashMapBuilder__f_aliased !== null)) {
    return this.sci_HashMapBuilder__f_aliased;
  } else {
    this.sci_HashMapBuilder__f_aliased = new $c_sci_HashMap(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode);
    return this.sci_HashMapBuilder__f_aliased;
  }
});
$c_sci_HashMapBuilder.prototype.addOne__T2__sci_HashMapBuilder = (function(elem) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var x = $n(elem)._1__O();
  var h = $m_sr_Statics$().anyHash__O__I(x);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n(elem)._1__O(), $n(elem)._2__O(), h, im, 0);
  return this;
});
$c_sci_HashMapBuilder.prototype.addOne__O__O__sci_HashMapBuilder = (function(key, value) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, key, value, originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
  return this;
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__sci_HashMapBuilder = (function(xs) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    new $c_sci_HashMapBuilder$$anon$1(this, x2);
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = $n(x3).nodeIterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var next = $as_scm_HashMap$Node($n(iter).next__O());
      $n(x3);
      var improvedHash = $n(next).scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var hash = $m_sc_Hashing$().improve__I__I(originalHash);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n(next).scm_HashMap$Node__f__key, $n(next).scm_HashMap$Node__f__value, originalHash, hash, 0);
    }
  } else if (false) {
    var x4 = $as_scm_LinkedHashMap(xs);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    while ($n(iter$2).hasNext__Z()) {
      var next$2 = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
      var originalHash$2 = $n(x4).unimproveHash__I__I($n(next$2).hash__I());
      var hash$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n(next$2).key__O(), $n(next$2).value__O(), originalHash$2, hash$2, 0);
    }
  } else if ($is_sci_Map(xs)) {
    var x5 = $as_sci_Map(xs);
    $n(x5).foreachEntry__F2__V(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((key$2$2, value$2$2) => this.addOne__O__O__sci_HashMapBuilder(key$2$2, value$2$2))));
  } else {
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      this.addOne__T2__sci_HashMapBuilder($as_T2($n(it).next__O()));
    }
  }
  return this;
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_HashMapBuilder(elems);
});
$c_sci_HashMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_HashMapBuilder($as_T2(elem));
});
$c_sci_HashMapBuilder.prototype.result__O = (function() {
  return this.result__sci_HashMap();
});
var $d_sci_HashMapBuilder = new $TypeData().initClass($c_sci_HashMapBuilder, "scala.collection.immutable.HashMapBuilder", ({
  sci_HashMapBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $p_sci_HashSetBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashSetBuilder__f_aliased !== null);
}
function $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > $n(as).u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + $n(as).u.length) | 0));
  $systemArraycopy($n(as), 0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = (($n(as).u.length - ix) | 0);
  $systemArraycopy($n(as), ix, result, destPos, length);
  return result;
}
function $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V($thiz, bm, bitpos, key, originalHash, keyHash) {
  var dataIx = $n(bm).dataIndex__I__I(bitpos);
  var src = $n(bm).sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + $n(src).u.length) | 0));
  $systemArraycopyRefs($n(src), 0, dst, 0, dataIx);
  dst.set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = (($n(src).u.length - dataIx) | 0);
  $systemArraycopyRefs($n(src), dataIx, dst, destPos, length);
  var dstHashes = $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, $n(bm).sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  $n(bm).sci_BitmapIndexedSetNode__f_dataMap = ($n(bm).sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  $n(bm).sci_BitmapIndexedSetNode__f_content = dst;
  $n(bm).sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  $n(bm).sci_BitmapIndexedSetNode__f_size = ((1 + $n(bm).sci_BitmapIndexedSetNode__f_size) | 0);
  $n(bm).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = (($n(bm).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
}
function $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V($thiz, bm, bitpos, elem) {
  var dataIx = $n(bm).dataIndex__I__I(bitpos);
  $n($n(bm).sci_BitmapIndexedSetNode__f_content).set(dataIx, elem);
}
function $p_sci_HashSetBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashSetBuilder__isAliased__Z($thiz)) {
    $p_sci_HashSetBuilder__copyElems__V($thiz);
  }
  $thiz.sci_HashSetBuilder__f_aliased = null;
}
function $p_sci_HashSetBuilder__copyElems__V($thiz) {
  $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = $n($thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode).copy__sci_BitmapIndexedSetNode();
}
/** @constructor */
function $c_sci_HashSetBuilder() {
  this.sci_HashSetBuilder__f_aliased = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = new $c_sci_BitmapIndexedSetNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0);
}
$c_sci_HashSetBuilder.prototype = new $h_O();
$c_sci_HashSetBuilder.prototype.constructor = $c_sci_HashSetBuilder;
/** @constructor */
function $h_sci_HashSetBuilder() {
}
$h_sci_HashSetBuilder.prototype = $c_sci_HashSetBuilder.prototype;
$c_sci_HashSetBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_HashSetBuilder.prototype.update__sci_SetNode__O__I__I__I__V = (function(setNode, element, originalHash, elementHash, shift) {
  if ((setNode instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(setNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if ((($n(x2).sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
      var element0 = $n(x2).getPayload__I__O(index);
      var element0UnimprovedHash = $n(x2).getHash__I__I(index);
      if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V(this, x2, bitpos, element0);
      } else {
        var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
        var subNodeNew = $n(x2).mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        $n(x2).migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      }
    } else if ((($n(x2).sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I($n(x2).sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
      var subNode = $n(x2).getNode__I__sci_SetNode(index$2);
      var beforeSize = $n(subNode).size__I();
      var beforeHashCode = $n(subNode).cachedJavaKeySetHashCode__I();
      this.update__sci_SetNode__O__I__I__I__V(subNode, element, originalHash, elementHash, ((5 + shift) | 0));
      $n(x2).sci_BitmapIndexedSetNode__f_size = (($n(x2).sci_BitmapIndexedSetNode__f_size + (($n(subNode).size__I() - beforeSize) | 0)) | 0);
      $n(x2).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = (($n(x2).sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + (($n(subNode).cachedJavaKeySetHashCode__I() - beforeHashCode) | 0)) | 0);
    } else {
      $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V(this, x2, bitpos, element, originalHash, elementHash);
    }
  } else if ((setNode instanceof $c_sci_HashCollisionSetNode)) {
    var x3 = $as_sci_HashCollisionSetNode(setNode);
    var this$1 = $n($n(x3).sci_HashCollisionSetNode__f_content);
    var index$3 = $f_sc_SeqOps__indexOf__O__I__I(this$1, element, 0);
    if ((index$3 < 0)) {
      $n(x3).sci_HashCollisionSetNode__f_content = $n($n(x3).sci_HashCollisionSetNode__f_content).appended__O__sci_Vector(element);
    } else {
      $n(x3).sci_HashCollisionSetNode__f_content = $n($n(x3).sci_HashCollisionSetNode__f_content).updated__I__O__sci_Vector(index$3, element);
    }
  } else {
    throw new $c_s_MatchError(setNode);
  }
});
$c_sci_HashSetBuilder.prototype.result__sci_HashSet = (function() {
  if (($n(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode).sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet;
  } else if ((this.sci_HashSetBuilder__f_aliased !== null)) {
    return this.sci_HashSetBuilder__f_aliased;
  } else {
    this.sci_HashSetBuilder__f_aliased = new $c_sci_HashSet(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode);
    return this.sci_HashSetBuilder__f_aliased;
  }
});
$c_sci_HashSetBuilder.prototype.addOne__O__sci_HashSetBuilder = (function(elem) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().anyHash__O__I(elem);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_SetNode__O__I__I__I__V(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, elem, h, im, 0);
  return this;
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__sci_HashSetBuilder = (function(xs) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    new $c_sci_HashSetBuilder$$anon$1(this, x2);
  } else {
    var it = $n(xs).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      this.addOne__O__sci_HashSetBuilder($n(it).next__O());
    }
  }
  return this;
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_HashSetBuilder(elems);
});
$c_sci_HashSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_HashSetBuilder(elem);
});
$c_sci_HashSetBuilder.prototype.result__O = (function() {
  return this.result__sci_HashSet();
});
var $d_sci_HashSetBuilder = new $TypeData().initClass($c_sci_HashSetBuilder, "scala.collection.immutable.HashSetBuilder", ({
  sci_HashSetBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Vector$());
}
$c_sci_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_IndexedSeq$.prototype.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
}
$h_sci_IndexedSeq$.prototype = $c_sci_IndexedSeq$.prototype;
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sci_IndexedSeq = (function(it) {
  if ($is_sci_IndexedSeq(it)) {
    var x2 = $as_sci_IndexedSeq(it);
    return x2;
  } else {
    return $as_sci_IndexedSeq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it));
  }
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(source);
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(it);
});
var $d_sci_IndexedSeq$ = new $TypeData().initClass($c_sci_IndexedSeq$, "scala.collection.immutable.IndexedSeq$", ({
  sci_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$();
  }
  return $n_sci_IndexedSeq$;
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder() {
  this.sci_LazyList$LazyBuilder__f_next = null;
  this.sci_LazyList$LazyBuilder__f_list = null;
  this.clear__V();
}
$c_sci_LazyList$LazyBuilder.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder.prototype.constructor = $c_sci_LazyList$LazyBuilder;
/** @constructor */
function $h_sci_LazyList$LazyBuilder() {
}
$h_sci_LazyList$LazyBuilder.prototype = $c_sci_LazyList$LazyBuilder.prototype;
$c_sci_LazyList$LazyBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_LazyList$LazyBuilder.prototype.clear__V = (function() {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $m_sci_LazyList$();
  var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => deferred.eval__sci_LazyList()));
  this.sci_LazyList$LazyBuilder__f_list = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
  this.sci_LazyList$LazyBuilder__f_next = deferred;
});
$c_sci_LazyList$LazyBuilder.prototype.result__sci_LazyList = (function() {
  $n(this.sci_LazyList$LazyBuilder__f_next).init__F0__V(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)));
  return this.sci_LazyList$LazyBuilder__f_list;
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__sci_LazyList$LazyBuilder = (function(elem) {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $n(this.sci_LazyList$LazyBuilder__f_next).init__F0__V(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    $m_sci_LazyList$();
    $m_sci_LazyList$();
    var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => deferred.eval__sci_LazyList()));
    var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, tl);
  })));
  this.sci_LazyList$LazyBuilder__f_next = deferred;
  return this;
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder = (function(xs) {
  if (($n(xs).knownSize__I() !== 0)) {
    var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
    $n(this.sci_LazyList$LazyBuilder__f_next).init__F0__V(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadPrependIterator__sc_Iterator__F0__sci_LazyList($n(xs).iterator__sc_Iterator(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => deferred.eval__sci_LazyList()))))));
    this.sci_LazyList$LazyBuilder__f_next = deferred;
  }
  return this;
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder(elems);
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_LazyList$LazyBuilder(elem);
});
$c_sci_LazyList$LazyBuilder.prototype.result__O = (function() {
  return this.result__sci_LazyList();
});
var $d_sci_LazyList$LazyBuilder = new $TypeData().initClass($c_sci_LazyList$LazyBuilder, "scala.collection.immutable.LazyList$LazyBuilder", ({
  sci_LazyList$LazyBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sci_LazyList$LazyIterator(lazyList) {
  this.sci_LazyList$LazyIterator__f_lazyList = null;
  this.sci_LazyList$LazyIterator__f_lazyList = lazyList;
}
$c_sci_LazyList$LazyIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_LazyList$LazyIterator.prototype.constructor = $c_sci_LazyList$LazyIterator;
/** @constructor */
function $h_sci_LazyList$LazyIterator() {
}
$h_sci_LazyList$LazyIterator.prototype = $c_sci_LazyList$LazyIterator.prototype;
$c_sci_LazyList$LazyIterator.prototype.hasNext__Z = (function() {
  var this$1 = $n(this.sci_LazyList$LazyIterator__f_lazyList);
  return (!(this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
});
$c_sci_LazyList$LazyIterator.prototype.next__O = (function() {
  var this$1 = $n(this.sci_LazyList$LazyIterator__f_lazyList);
  if ((this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var res = $n(this.sci_LazyList$LazyIterator__f_lazyList).head__O();
    this.sci_LazyList$LazyIterator__f_lazyList = $n(this.sci_LazyList$LazyIterator__f_lazyList).tail__sci_LazyList();
    return res;
  }
});
var $d_sci_LazyList$LazyIterator = new $TypeData().initClass($c_sci_LazyList$LazyIterator, "scala.collection.immutable.LazyList$LazyIterator", ({
  sci_LazyList$LazyIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_List$() {
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = null;
  this.sci_List$__f_partialNotApplied = null;
  $n_sci_List$ = this;
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = new $c_T2($m_sci_Nil$(), $m_sci_Nil$());
  this.sci_List$__f_partialNotApplied = new $c_sci_List$$anon$1();
}
$c_sci_List$.prototype = new $h_O();
$c_sci_List$.prototype.constructor = $c_sci_List$;
/** @constructor */
function $h_sci_List$() {
}
$h_sci_List$.prototype = $c_sci_List$.prototype;
$c_sci_List$.prototype.apply__sci_Seq__O = (function(elems) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
});
$c_sci_List$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ListBuffer();
});
$c_sci_List$.prototype.empty__O = (function() {
  return $m_sci_Nil$();
});
$c_sci_List$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source);
});
var $d_sci_List$ = new $TypeData().initClass($c_sci_List$, "scala.collection.immutable.List$", ({
  sci_List$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_List$;
function $m_sci_List$() {
  if ((!$n_sci_List$)) {
    $n_sci_List$ = new $c_sci_List$();
  }
  return $n_sci_List$;
}
function $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__($thiz, outer) {
  $n(outer);
  $thiz.sci_Map$Map2$Map2Iterator__f_$outer = outer;
  $thiz.sci_Map$Map2$Map2Iterator__f_i = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map2$Map2Iterator() {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
}
$c_sci_Map$Map2$Map2Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map2$Map2Iterator.prototype.constructor = $c_sci_Map$Map2$Map2Iterator;
/** @constructor */
function $h_sci_Map$Map2$Map2Iterator() {
}
$h_sci_Map$Map2$Map2Iterator.prototype = $c_sci_Map$Map2$Map2Iterator.prototype;
$c_sci_Map$Map2$Map2Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map2$Map2Iterator__f_i < 2);
});
$c_sci_Map$Map2$Map2Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map2$Map2Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, $n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
      break;
    }
    case 1: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, $n(this.sci_Map$Map2$Map2Iterator__f_$outer).sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
      break;
    }
    default: {
      var result = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
    }
  }
  this.sci_Map$Map2$Map2Iterator__f_i = ((1 + this.sci_Map$Map2$Map2Iterator__f_i) | 0);
  return result;
});
$c_sci_Map$Map2$Map2Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map2$Map2Iterator__f_i = ((this.sci_Map$Map2$Map2Iterator__f_i + n) | 0);
  return this;
});
function $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__($thiz, outer) {
  $n(outer);
  $thiz.sci_Map$Map3$Map3Iterator__f_$outer = outer;
  $thiz.sci_Map$Map3$Map3Iterator__f_i = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map3$Map3Iterator() {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
}
$c_sci_Map$Map3$Map3Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map3$Map3Iterator.prototype.constructor = $c_sci_Map$Map3$Map3Iterator;
/** @constructor */
function $h_sci_Map$Map3$Map3Iterator() {
}
$h_sci_Map$Map3$Map3Iterator.prototype = $c_sci_Map$Map3$Map3Iterator.prototype;
$c_sci_Map$Map3$Map3Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map3$Map3Iterator__f_i < 3);
});
$c_sci_Map$Map3$Map3Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map3$Map3Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, $n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
      break;
    }
    case 1: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, $n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
      break;
    }
    case 2: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, $n(this.sci_Map$Map3$Map3Iterator__f_$outer).sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
      break;
    }
    default: {
      var result = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
    }
  }
  this.sci_Map$Map3$Map3Iterator__f_i = ((1 + this.sci_Map$Map3$Map3Iterator__f_i) | 0);
  return result;
});
$c_sci_Map$Map3$Map3Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map3$Map3Iterator__f_i = ((this.sci_Map$Map3$Map3Iterator__f_i + n) | 0);
  return this;
});
function $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__($thiz, outer) {
  $n(outer);
  $thiz.sci_Map$Map4$Map4Iterator__f_$outer = outer;
  $thiz.sci_Map$Map4$Map4Iterator__f_i = 0;
  return $thiz;
}
/** @constructor */
function $c_sci_Map$Map4$Map4Iterator() {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
}
$c_sci_Map$Map4$Map4Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map4$Map4Iterator.prototype.constructor = $c_sci_Map$Map4$Map4Iterator;
/** @constructor */
function $h_sci_Map$Map4$Map4Iterator() {
}
$h_sci_Map$Map4$Map4Iterator.prototype = $c_sci_Map$Map4$Map4Iterator.prototype;
$c_sci_Map$Map4$Map4Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map4$Map4Iterator__f_i < 4);
});
$c_sci_Map$Map4$Map4Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map4$Map4Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
      break;
    }
    case 1: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
      break;
    }
    case 2: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
      break;
    }
    case 3: {
      var result = this.nextResult__O__O__O($n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, $n(this.sci_Map$Map4$Map4Iterator__f_$outer).sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
      break;
    }
    default: {
      var result = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
    }
  }
  this.sci_Map$Map4$Map4Iterator__f_i = ((1 + this.sci_Map$Map4$Map4Iterator__f_i) | 0);
  return result;
});
$c_sci_Map$Map4$Map4Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map4$Map4Iterator__f_i = ((this.sci_Map$Map4$Map4Iterator__f_i + n) | 0);
  return this;
});
/** @constructor */
function $c_sci_MapBuilderImpl() {
  this.sci_MapBuilderImpl__f_elems = null;
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
  this.sci_MapBuilderImpl__f_hashMapBuilder = null;
  this.sci_MapBuilderImpl__f_elems = $m_sci_Map$EmptyMap$();
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
}
$c_sci_MapBuilderImpl.prototype = new $h_O();
$c_sci_MapBuilderImpl.prototype.constructor = $c_sci_MapBuilderImpl;
/** @constructor */
function $h_sci_MapBuilderImpl() {
}
$h_sci_MapBuilderImpl.prototype = $c_sci_MapBuilderImpl.prototype;
$c_sci_MapBuilderImpl.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_MapBuilderImpl.prototype.result__sci_Map = (function() {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? $n(this.sci_MapBuilderImpl__f_hashMapBuilder).result__sci_HashMap() : this.sci_MapBuilderImpl__f_elems);
});
$c_sci_MapBuilderImpl.prototype.addOne__O__O__sci_MapBuilderImpl = (function(key, value) {
  if (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder) {
    $n(this.sci_MapBuilderImpl__f_hashMapBuilder).addOne__O__O__sci_HashMapBuilder(key, value);
  } else if (($n(this.sci_MapBuilderImpl__f_elems).size__I() < 4)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map($n(this.sci_MapBuilderImpl__f_elems).updated__O__O__sci_MapOps(key, value));
  } else if ($n(this.sci_MapBuilderImpl__f_elems).contains__O__Z(key)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map($n(this.sci_MapBuilderImpl__f_elems).updated__O__O__sci_MapOps(key, value));
  } else {
    this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = true;
    if ((this.sci_MapBuilderImpl__f_hashMapBuilder === null)) {
      this.sci_MapBuilderImpl__f_hashMapBuilder = new $c_sci_HashMapBuilder();
    }
    $n($as_sci_Map$Map4(this.sci_MapBuilderImpl__f_elems)).buildTo__sci_HashMapBuilder__sci_HashMapBuilder(this.sci_MapBuilderImpl__f_hashMapBuilder);
    $n(this.sci_MapBuilderImpl__f_hashMapBuilder).addOne__O__O__sci_HashMapBuilder(key, value);
  }
  return this;
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__sci_MapBuilderImpl = (function(xs) {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? ($n(this.sci_MapBuilderImpl__f_hashMapBuilder).addAll__sc_IterableOnce__sci_HashMapBuilder(xs), this) : $as_sci_MapBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)));
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_MapBuilderImpl(elems);
});
$c_sci_MapBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  var elem$1 = $as_T2(elem);
  return this.addOne__O__O__sci_MapBuilderImpl($n(elem$1)._1__O(), $n(elem$1)._2__O());
});
$c_sci_MapBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Map();
});
function $as_sci_MapBuilderImpl(obj) {
  return (((obj instanceof $c_sci_MapBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapBuilderImpl"));
}
function $isArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapBuilderImpl)));
}
function $asArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_MapBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapBuilderImpl;", depth));
}
var $d_sci_MapBuilderImpl = new $TypeData().initClass($c_sci_MapBuilderImpl, "scala.collection.immutable.MapBuilderImpl", ({
  sci_MapBuilderImpl: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sci_Queue$() {
}
$c_sci_Queue$.prototype = new $h_O();
$c_sci_Queue$.prototype.constructor = $c_sci_Queue$;
/** @constructor */
function $h_sci_Queue$() {
}
$h_sci_Queue$.prototype = $c_sci_Queue$.prototype;
$c_sci_Queue$.prototype.newBuilder__scm_Builder = (function() {
  var this$1 = new $c_scm_ListBuffer();
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => {
    var x$2 = $as_sci_List(x$2$2);
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), x$2);
  }));
  return new $c_scm_Builder$$anon$1(this$1, f);
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__sci_Queue = (function(source) {
  if ((source instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(source);
    return x2;
  } else {
    var list = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source);
    return ($n(list).isEmpty__Z() ? $m_sci_Queue$EmptyQueue$() : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), list));
  }
});
$c_sci_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $n(elems).toList__sci_List());
});
$c_sci_Queue$.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$();
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Queue(source);
});
var $d_sci_Queue$ = new $TypeData().initClass($c_sci_Queue$, "scala.collection.immutable.Queue$", ({
  sci_Queue$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Queue$;
function $m_sci_Queue$() {
  if ((!$n_sci_Queue$)) {
    $n_sci_Queue$ = new $c_sci_Queue$();
  }
  return $n_sci_Queue$;
}
/** @constructor */
function $c_sci_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_List$());
}
$c_sci_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_Seq$.prototype.constructor = $c_sci_Seq$;
/** @constructor */
function $h_sci_Seq$() {
}
$h_sci_Seq$.prototype = $c_sci_Seq$.prototype;
$c_sci_Seq$.prototype.from__sc_IterableOnce__sci_Seq = (function(it) {
  if ($is_sci_Seq(it)) {
    var x2 = $as_sci_Seq(it);
    return x2;
  } else {
    return $as_sci_Seq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it));
  }
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Seq(source);
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_Seq(it);
});
var $d_sci_Seq$ = new $TypeData().initClass($c_sci_Seq$, "scala.collection.immutable.Seq$", ({
  sci_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Seq$;
function $m_sci_Seq$() {
  if ((!$n_sci_Seq$)) {
    $n_sci_Seq$ = new $c_sci_Seq$();
  }
  return $n_sci_Seq$;
}
/** @constructor */
function $c_sci_SetBuilderImpl() {
  this.sci_SetBuilderImpl__f_elems = null;
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
  this.sci_SetBuilderImpl__f_hashSetBuilder = null;
  this.sci_SetBuilderImpl__f_elems = $m_sci_Set$EmptySet$();
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
}
$c_sci_SetBuilderImpl.prototype = new $h_O();
$c_sci_SetBuilderImpl.prototype.constructor = $c_sci_SetBuilderImpl;
/** @constructor */
function $h_sci_SetBuilderImpl() {
}
$h_sci_SetBuilderImpl.prototype = $c_sci_SetBuilderImpl.prototype;
$c_sci_SetBuilderImpl.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_SetBuilderImpl.prototype.result__sci_Set = (function() {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? $n(this.sci_SetBuilderImpl__f_hashSetBuilder).result__sci_HashSet() : this.sci_SetBuilderImpl__f_elems);
});
$c_sci_SetBuilderImpl.prototype.addOne__O__sci_SetBuilderImpl = (function(elem) {
  if (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder) {
    $n(this.sci_SetBuilderImpl__f_hashSetBuilder).addOne__O__sci_HashSetBuilder(elem);
  } else if (($n(this.sci_SetBuilderImpl__f_elems).size__I() < 4)) {
    var this$1 = $n(this.sci_SetBuilderImpl__f_elems);
    this.sci_SetBuilderImpl__f_elems = $as_sci_Set(this$1.incl__O__sci_SetOps(elem));
  } else if ((!$n(this.sci_SetBuilderImpl__f_elems).contains__O__Z(elem))) {
    this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = true;
    if ((this.sci_SetBuilderImpl__f_hashSetBuilder === null)) {
      this.sci_SetBuilderImpl__f_hashSetBuilder = new $c_sci_HashSetBuilder();
    }
    $n($as_sci_Set$Set4(this.sci_SetBuilderImpl__f_elems)).buildTo__scm_Builder__scm_Builder(this.sci_SetBuilderImpl__f_hashSetBuilder);
    $n(this.sci_SetBuilderImpl__f_hashSetBuilder).addOne__O__sci_HashSetBuilder(elem);
  }
  return this;
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__sci_SetBuilderImpl = (function(xs) {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? ($n(this.sci_SetBuilderImpl__f_hashSetBuilder).addAll__sc_IterableOnce__sci_HashSetBuilder(xs), this) : $as_sci_SetBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)));
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_SetBuilderImpl(elems);
});
$c_sci_SetBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_SetBuilderImpl(elem);
});
$c_sci_SetBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Set();
});
function $as_sci_SetBuilderImpl(obj) {
  return (((obj instanceof $c_sci_SetBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetBuilderImpl"));
}
function $isArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetBuilderImpl)));
}
function $asArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_SetBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetBuilderImpl;", depth));
}
var $d_sci_SetBuilderImpl = new $TypeData().initClass($c_sci_SetBuilderImpl, "scala.collection.immutable.SetBuilderImpl", ({
  sci_SetBuilderImpl: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $ps_sci_Vector$__liftedTree1$1__I() {
  try {
    var this$ = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.Vector.defaultApplyPreferredMaxLength", "250");
    var this$3 = $m_jl_Integer$();
    return this$3.java$lang$Integer$$parseIntImpl__T__I__I__I(this$, 10, 214748364);
  } catch (e) {
    if (false) {
      return 250;
    } else {
      throw e;
    }
  }
}
/** @constructor */
function $c_sci_Vector$() {
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = 0;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = null;
  $n_sci_Vector$ = this;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = $ps_sci_Vector$__liftedTree1$1__I();
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = new $c_sci_NewVectorIterator($m_sci_Vector0$(), 0, 0);
}
$c_sci_Vector$.prototype = new $h_O();
$c_sci_Vector$.prototype.constructor = $c_sci_Vector$;
/** @constructor */
function $h_sci_Vector$() {
}
$h_sci_Vector$.prototype = $c_sci_Vector$.prototype;
$c_sci_Vector$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Vector(elems);
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__sci_Vector = (function(it) {
  if ((it instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(it);
    return x2;
  } else {
    var knownSize = $n(it).knownSize__I();
    if ((knownSize === 0)) {
      return $m_sci_Vector0$();
    } else if (((((knownSize - 1) | 0) >>> 0) <= 31)) {
      matchEnd5: {
        var a1$3;
        if ((it instanceof $c_sci_ArraySeq$ofRef)) {
          var x2$2 = $as_sci_ArraySeq$ofRef(it);
          var x = $n($n(x2$2).elemTag__s_reflect_ClassTag()).runtimeClass__jl_Class();
          if ((x !== null)) {
            var this$1 = $n(x);
            var $x_1 = (this$1 === $d_O.getClassOf());
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            var a1$3 = $n(x2$2).sci_ArraySeq$ofRef__f_unsafeArray;
            break matchEnd5;
          }
        }
        if ($is_sci_Iterable(it)) {
          var x3 = $as_sci_Iterable(it);
          var a1 = new $ac_O(knownSize);
          var this$2 = $n(x3);
          this$2.copyToArray__O__I__I__I(a1, 0, 2147483647);
          var a1$3 = a1;
          break matchEnd5;
        }
        var a1$2 = new $ac_O(knownSize);
        var this$3 = $n($n(it).iterator__sc_Iterator());
        this$3.copyToArray__O__I__I__I(a1$2, 0, 2147483647);
        var a1$3 = a1$2;
      }
      return new $c_sci_Vector1(a1$3);
    } else {
      var this$4 = new $c_sci_VectorBuilder();
      var this$5 = $n(this$4.addAll__sc_IterableOnce__sci_VectorBuilder(it));
      return this$5.result__sci_Vector();
    }
  }
});
$c_sci_Vector$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_VectorBuilder();
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Vector(source);
});
$c_sci_Vector$.prototype.empty__O = (function() {
  return $m_sci_Vector0$();
});
var $d_sci_Vector$ = new $TypeData().initClass($c_sci_Vector$, "scala.collection.immutable.Vector$", ({
  sci_Vector$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Vector$;
function $m_sci_Vector$() {
  if ((!$n_sci_Vector$)) {
    $n_sci_Vector$ = new $c_sci_Vector$();
  }
  return $n_sci_Vector$;
}
function $p_sci_VectorBuilder__leftAlignPrefix__V($thiz) {
  var a = null;
  var aParent = null;
  if (($thiz.sci_VectorBuilder__f_depth >= 6)) {
    a = $thiz.sci_VectorBuilder__f_a6;
    var i = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 25) | 0);
    if ((i > 0)) {
      var src = a;
      var dest = a;
      var length = ((64 - i) | 0);
      $systemArraycopyRefs($n(src), i, $n(dest), 0, length);
    }
    var num = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset;
    var t = (((num >> 24) >>> 7) | 0);
    var newOffset = (((33554431 & ((num + t) | 0)) - t) | 0);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset) | 0)) | 0);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset;
    if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 25) | 0) === 0)) {
      $thiz.sci_VectorBuilder__f_depth = 5;
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 5)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a5;
    }
    var i$2 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 20) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 5)) {
      if ((i$2 > 0)) {
        var src$1 = a;
        var dest$1 = a;
        var length$1 = ((32 - i$2) | 0);
        $systemArraycopyRefs($n(src$1), i$2, $n(dest$1), 0, length$1);
      }
      $thiz.sci_VectorBuilder__f_a5 = $asArrayOf_O(a, 5);
      var num$1 = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset;
      var t$1 = (((num$1 >> 19) >>> 12) | 0);
      var newOffset$1 = (((1048575 & ((num$1 + t$1) | 0)) - t$1) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$1) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$1;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 20) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 4;
      }
    } else {
      if ((i$2 > 0)) {
        var original = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, i$2, 32);
      }
      $n(aParent).set(0, a);
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 4)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a4;
    }
    var i$3 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 15) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 4)) {
      if ((i$3 > 0)) {
        var src$2 = a;
        var dest$2 = a;
        var length$2 = ((32 - i$3) | 0);
        $systemArraycopyRefs($n(src$2), i$3, $n(dest$2), 0, length$2);
      }
      $thiz.sci_VectorBuilder__f_a4 = $asArrayOf_O(a, 4);
      var num$2 = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset;
      var t$2 = (((num$2 >> 14) >>> 17) | 0);
      var newOffset$2 = (((32767 & ((num$2 + t$2) | 0)) - t$2) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$2) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$2;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 15) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 3;
      }
    } else {
      if ((i$3 > 0)) {
        var original$1 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, i$3, 32);
      }
      $n(aParent).set(0, a);
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 3)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a3;
    }
    var i$4 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 10) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 3)) {
      if ((i$4 > 0)) {
        var src$3 = a;
        var dest$3 = a;
        var length$3 = ((32 - i$4) | 0);
        $systemArraycopyRefs($n(src$3), i$4, $n(dest$3), 0, length$3);
      }
      $thiz.sci_VectorBuilder__f_a3 = $asArrayOf_O(a, 3);
      var num$3 = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset;
      var t$3 = (((num$3 >> 9) >>> 22) | 0);
      var newOffset$3 = (((1023 & ((num$3 + t$3) | 0)) - t$3) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$3) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$3;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 10) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 2;
      }
    } else {
      if ((i$4 > 0)) {
        var original$2 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$2, i$4, 32);
      }
      $n(aParent).set(0, a);
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 2)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a2;
    }
    var i$5 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 5) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 2)) {
      if ((i$5 > 0)) {
        var src$4 = a;
        var dest$4 = a;
        var length$4 = ((32 - i$5) | 0);
        $systemArraycopyRefs($n(src$4), i$5, $n(dest$4), 0, length$4);
      }
      $thiz.sci_VectorBuilder__f_a2 = $asArrayOf_O(a, 2);
      var num$4 = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset;
      var t$4 = (((num$4 >> 4) >>> 27) | 0);
      var newOffset$4 = (((31 & ((num$4 + t$4) | 0)) - t$4) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$4) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$4;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 5) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 1;
      }
    } else {
      if ((i$5 > 0)) {
        var original$3 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$3, i$5, 32);
      }
      $n(aParent).set(0, a);
    }
    aParent = a;
    a = $asArrayOf_O($n(a).get(0), 1);
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 1)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a1;
    }
    var i$6 = (31 & $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset);
    if (($thiz.sci_VectorBuilder__f_depth === 1)) {
      if ((i$6 > 0)) {
        var src$5 = a;
        var dest$5 = a;
        var length$5 = ((32 - i$6) | 0);
        $systemArraycopyRefs($n(src$5), i$6, $n(dest$5), 0, length$5);
      }
      $thiz.sci_VectorBuilder__f_a1 = a;
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
    } else {
      if ((i$6 > 0)) {
        var original$4 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$4, i$6, 32);
      }
      $n(aParent).set(0, a);
    }
  }
  $thiz.sci_VectorBuilder__f_prefixIsRightAligned = false;
}
function $p_sci_VectorBuilder__addArr1__AO__V($thiz, data) {
  var dl = $n(data).u.length;
  if ((dl > 0)) {
    if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
      $p_sci_VectorBuilder__advance__V($thiz);
    }
    var a = ((32 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
    var copy1 = ((a < dl) ? a : dl);
    var copy2 = ((dl - copy1) | 0);
    var dest = $thiz.sci_VectorBuilder__f_a1;
    var destPos = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1;
    $systemArraycopyRefs($n(data), 0, $n(dest), destPos, copy1);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy1) | 0);
    if ((copy2 > 0)) {
      $p_sci_VectorBuilder__advance__V($thiz);
      var dest$1 = $thiz.sci_VectorBuilder__f_a1;
      $systemArraycopyRefs($n(data), copy1, $n(dest$1), 0, copy2);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy2) | 0);
    }
  }
}
function $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, dim) {
  if (($n(slice).u.length === 0)) {
    return (void 0);
  }
  if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V($thiz);
  }
  var sl = $n(slice).u.length;
  switch (dim) {
    case 2: {
      var a = (31 & ((((1024 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 5) | 0));
      var copy1 = ((a < sl) ? a : sl);
      var copy2 = ((sl - copy1) | 0);
      var destPos = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 5) | 0));
      var dest = $thiz.sci_VectorBuilder__f_a2;
      $systemArraycopyRefs($n(slice), 0, $n(dest), destPos, copy1);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1 << 5));
      if ((copy2 > 0)) {
        var dest$1 = $thiz.sci_VectorBuilder__f_a2;
        $systemArraycopyRefs($n(slice), copy1, $n(dest$1), 0, copy2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2 << 5));
      }
      break;
    }
    case 3: {
      var num = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest;
      var t = (((num >> 9) >>> 22) | 0);
      if (((((1023 & ((num + t) | 0)) - t) | 0) !== 0)) {
        var f = ((e$2$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$2$2, 1), 2);
        });
        var len = $n(slice).u.length;
        var i = 0;
        if ((slice !== null)) {
          while ((i < len)) {
            var x0 = $n(slice).get(i);
            f(x0);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          var x3 = $asArrayOf_I(slice, 1);
          while ((i < len)) {
            var x0$1 = $n(x3).get(i);
            f(x0$1);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          var x4 = $asArrayOf_D(slice, 1);
          while ((i < len)) {
            var x0$2 = $n(x4).get(i);
            f(x0$2);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          var x5 = $asArrayOf_J(slice, 1);
          while ((i < len)) {
            var $x_1 = $n(x5).u;
            var $x_2 = $aJCheckGet($x_1, i);
            var x0$3_$_lo = $x_1[$x_2];
            var x0$3_$_hi = $x_1[(($x_2 + 1) | 0)];
            f($bL(x0$3_$_lo, x0$3_$_hi));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          var x6 = $asArrayOf_F(slice, 1);
          while ((i < len)) {
            var x0$4 = $n(x6).get(i);
            f(x0$4);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          var x7 = $asArrayOf_C(slice, 1);
          while ((i < len)) {
            var x0$5 = $n(x7).get(i);
            f($bC(x0$5));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          var x8 = $asArrayOf_B(slice, 1);
          while ((i < len)) {
            var x0$6 = $n(x8).get(i);
            f(x0$6);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          var x9 = $asArrayOf_S(slice, 1);
          while ((i < len)) {
            var x0$7 = $n(x9).get(i);
            f(x0$7);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10 = $asArrayOf_Z(slice, 1);
          while ((i < len)) {
            var x0$8 = $n(x10).get(i);
            f(x0$8);
            i = ((1 + i) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$1 = (31 & ((((32768 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 10) | 0));
      var copy1$2 = ((a$1 < sl) ? a$1 : sl);
      var copy2$2 = ((sl - copy1$2) | 0);
      var destPos$2 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 10) | 0));
      var dest$2 = $thiz.sci_VectorBuilder__f_a3;
      $systemArraycopyRefs($n(slice), 0, $n(dest$2), destPos$2, copy1$2);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$2 << 10));
      if ((copy2$2 > 0)) {
        var dest$3 = $thiz.sci_VectorBuilder__f_a3;
        $systemArraycopyRefs($n(slice), copy1$2, $n(dest$3), 0, copy2$2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$2 << 10));
      }
      break;
    }
    case 4: {
      var num$1 = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest;
      var t$1 = (((num$1 >> 14) >>> 17) | 0);
      if (((((32767 & ((num$1 + t$1) | 0)) - t$1) | 0) !== 0)) {
        var f$1 = ((e$2$2$1) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$2$2$1, 1), 3);
        });
        var len$1 = $n(slice).u.length;
        var i$1 = 0;
        if ((slice !== null)) {
          while ((i$1 < len$1)) {
            var x0$9 = $n(slice).get(i$1);
            f$1(x0$9);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          var x3$1 = $asArrayOf_I(slice, 1);
          while ((i$1 < len$1)) {
            var x0$10 = $n(x3$1).get(i$1);
            f$1(x0$10);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          var x4$1 = $asArrayOf_D(slice, 1);
          while ((i$1 < len$1)) {
            var x0$11 = $n(x4$1).get(i$1);
            f$1(x0$11);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          var x5$1 = $asArrayOf_J(slice, 1);
          while ((i$1 < len$1)) {
            var $x_3 = $n(x5$1).u;
            var $x_4 = $aJCheckGet($x_3, i$1);
            var x0$12_$_lo = $x_3[$x_4];
            var x0$12_$_hi = $x_3[(($x_4 + 1) | 0)];
            f$1($bL(x0$12_$_lo, x0$12_$_hi));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          var x6$1 = $asArrayOf_F(slice, 1);
          while ((i$1 < len$1)) {
            var x0$13 = $n(x6$1).get(i$1);
            f$1(x0$13);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          var x7$1 = $asArrayOf_C(slice, 1);
          while ((i$1 < len$1)) {
            var x0$14 = $n(x7$1).get(i$1);
            f$1($bC(x0$14));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          var x8$1 = $asArrayOf_B(slice, 1);
          while ((i$1 < len$1)) {
            var x0$15 = $n(x8$1).get(i$1);
            f$1(x0$15);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          var x9$1 = $asArrayOf_S(slice, 1);
          while ((i$1 < len$1)) {
            var x0$16 = $n(x9$1).get(i$1);
            f$1(x0$16);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10$1 = $asArrayOf_Z(slice, 1);
          while ((i$1 < len$1)) {
            var x0$17 = $n(x10$1).get(i$1);
            f$1(x0$17);
            i$1 = ((1 + i$1) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$2 = (31 & ((((1048576 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 15) | 0));
      var copy1$3 = ((a$2 < sl) ? a$2 : sl);
      var copy2$3 = ((sl - copy1$3) | 0);
      var destPos$3 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 15) | 0));
      var dest$4 = $thiz.sci_VectorBuilder__f_a4;
      $systemArraycopyRefs($n(slice), 0, $n(dest$4), destPos$3, copy1$3);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$3 << 15));
      if ((copy2$3 > 0)) {
        var dest$5 = $thiz.sci_VectorBuilder__f_a4;
        $systemArraycopyRefs($n(slice), copy1$3, $n(dest$5), 0, copy2$3);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$3 << 15));
      }
      break;
    }
    case 5: {
      var num$2 = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest;
      var t$2 = (((num$2 >> 19) >>> 12) | 0);
      if (((((1048575 & ((num$2 + t$2) | 0)) - t$2) | 0) !== 0)) {
        var f$2 = ((e$2$2$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$2$2$2, 1), 4);
        });
        var len$2 = $n(slice).u.length;
        var i$2 = 0;
        if ((slice !== null)) {
          while ((i$2 < len$2)) {
            var x0$18 = $n(slice).get(i$2);
            f$2(x0$18);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          var x3$2 = $asArrayOf_I(slice, 1);
          while ((i$2 < len$2)) {
            var x0$19 = $n(x3$2).get(i$2);
            f$2(x0$19);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          var x4$2 = $asArrayOf_D(slice, 1);
          while ((i$2 < len$2)) {
            var x0$20 = $n(x4$2).get(i$2);
            f$2(x0$20);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          var x5$2 = $asArrayOf_J(slice, 1);
          while ((i$2 < len$2)) {
            var $x_5 = $n(x5$2).u;
            var $x_6 = $aJCheckGet($x_5, i$2);
            var x0$21_$_lo = $x_5[$x_6];
            var x0$21_$_hi = $x_5[(($x_6 + 1) | 0)];
            f$2($bL(x0$21_$_lo, x0$21_$_hi));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          var x6$2 = $asArrayOf_F(slice, 1);
          while ((i$2 < len$2)) {
            var x0$22 = $n(x6$2).get(i$2);
            f$2(x0$22);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          var x7$2 = $asArrayOf_C(slice, 1);
          while ((i$2 < len$2)) {
            var x0$23 = $n(x7$2).get(i$2);
            f$2($bC(x0$23));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          var x8$2 = $asArrayOf_B(slice, 1);
          while ((i$2 < len$2)) {
            var x0$24 = $n(x8$2).get(i$2);
            f$2(x0$24);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          var x9$2 = $asArrayOf_S(slice, 1);
          while ((i$2 < len$2)) {
            var x0$25 = $n(x9$2).get(i$2);
            f$2(x0$25);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10$2 = $asArrayOf_Z(slice, 1);
          while ((i$2 < len$2)) {
            var x0$26 = $n(x10$2).get(i$2);
            f$2(x0$26);
            i$2 = ((1 + i$2) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$3 = (31 & ((((33554432 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 20) | 0));
      var copy1$4 = ((a$3 < sl) ? a$3 : sl);
      var copy2$4 = ((sl - copy1$4) | 0);
      var destPos$4 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 20) | 0));
      var dest$6 = $thiz.sci_VectorBuilder__f_a5;
      $systemArraycopyRefs($n(slice), 0, $n(dest$6), destPos$4, copy1$4);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$4 << 20));
      if ((copy2$4 > 0)) {
        var dest$7 = $thiz.sci_VectorBuilder__f_a5;
        $systemArraycopyRefs($n(slice), copy1$4, $n(dest$7), 0, copy2$4);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$4 << 20));
      }
      break;
    }
    case 6: {
      var num$3 = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest;
      var t$3 = (((num$3 >> 24) >>> 7) | 0);
      if (((((33554431 & ((num$3 + t$3) | 0)) - t$3) | 0) !== 0)) {
        var f$3 = ((e$2$2$3) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, $asArrayOf_O(e$2$2$3, 1), 5);
        });
        var len$3 = $n(slice).u.length;
        var i$3 = 0;
        if ((slice !== null)) {
          while ((i$3 < len$3)) {
            var x0$27 = $n(slice).get(i$3);
            f$3(x0$27);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          var x3$3 = $asArrayOf_I(slice, 1);
          while ((i$3 < len$3)) {
            var x0$28 = $n(x3$3).get(i$3);
            f$3(x0$28);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          var x4$3 = $asArrayOf_D(slice, 1);
          while ((i$3 < len$3)) {
            var x0$29 = $n(x4$3).get(i$3);
            f$3(x0$29);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          var x5$3 = $asArrayOf_J(slice, 1);
          while ((i$3 < len$3)) {
            var $x_7 = $n(x5$3).u;
            var $x_8 = $aJCheckGet($x_7, i$3);
            var x0$30_$_lo = $x_7[$x_8];
            var x0$30_$_hi = $x_7[(($x_8 + 1) | 0)];
            f$3($bL(x0$30_$_lo, x0$30_$_hi));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          var x6$3 = $asArrayOf_F(slice, 1);
          while ((i$3 < len$3)) {
            var x0$31 = $n(x6$3).get(i$3);
            f$3(x0$31);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          var x7$3 = $asArrayOf_C(slice, 1);
          while ((i$3 < len$3)) {
            var x0$32 = $n(x7$3).get(i$3);
            f$3($bC(x0$32));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          var x8$3 = $asArrayOf_B(slice, 1);
          while ((i$3 < len$3)) {
            var x0$33 = $n(x8$3).get(i$3);
            f$3(x0$33);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          var x9$3 = $asArrayOf_S(slice, 1);
          while ((i$3 < len$3)) {
            var x0$34 = $n(x9$3).get(i$3);
            f$3(x0$34);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          var x10$3 = $asArrayOf_Z(slice, 1);
          while ((i$3 < len$3)) {
            var x0$35 = $n(x10$3).get(i$3);
            f$3(x0$35);
            i$3 = ((1 + i$3) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var destPos$5 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 25) | 0);
      if ((((destPos$5 + sl) | 0) > 64)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "exceeding 2^31 elements");
      }
      var dest$8 = $thiz.sci_VectorBuilder__f_a6;
      $systemArraycopyRefs($n(slice), 0, $n(dest$8), destPos$5, sl);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (sl << 25));
      break;
    }
    default: {
      throw new $c_s_MatchError(dim);
    }
  }
}
function $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder($thiz, xs) {
  var sliceCount = $n(xs).vectorSliceCount__I();
  var sliceIdx = 0;
  while ((sliceIdx < sliceCount)) {
    var slice = $n(xs).vectorSlice__I__AO(sliceIdx);
    var idx = sliceIdx;
    var c = (((sliceCount + ((sliceCount >>> 31) | 0)) | 0) >> 1);
    var a = ((idx - c) | 0);
    var sign = (a >> 31);
    var x1 = ((((1 + c) | 0) - (((a ^ sign) - sign) | 0)) | 0);
    if ((x1 === 1)) {
      $p_sci_VectorBuilder__addArr1__AO__V($thiz, slice);
    } else if ((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32) || ($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0))) {
      $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, x1);
    } else {
      $m_sci_VectorStatics$().foreachRec__I__AO__F1__V(((x1 - 2) | 0), slice, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((data$2$2) => {
        var data$2 = $asArrayOf_O(data$2$2, 1);
        $p_sci_VectorBuilder__addArr1__AO__V($thiz, data$2);
      })));
    }
    sliceIdx = ((1 + sliceIdx) | 0);
  }
  return $thiz;
}
function $p_sci_VectorBuilder__advance__V($thiz) {
  var idx = ((32 + $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
}
function $p_sci_VectorBuilder__advanceN__I__V($thiz, n) {
  if ((n > 0)) {
    var idx = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest + n) | 0);
    var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
    $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
  }
}
function $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor) {
  if ((xor <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((((((((((((((("advance1(" + idx) + ", ") + xor) + "): a1=") + $thiz.sci_VectorBuilder__f_a1) + ", a2=") + $thiz.sci_VectorBuilder__f_a2) + ", a3=") + $thiz.sci_VectorBuilder__f_a3) + ", a4=") + $thiz.sci_VectorBuilder__f_a4) + ", a5=") + $thiz.sci_VectorBuilder__f_a5) + ", a6=") + $thiz.sci_VectorBuilder__f_a6) + ", depth=") + $thiz.sci_VectorBuilder__f_depth));
  } else if ((xor < 1024)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 1)) {
      $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a2).set(0, $thiz.sci_VectorBuilder__f_a1);
      $thiz.sci_VectorBuilder__f_depth = 2;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
  } else if ((xor < 32768)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 2)) {
      $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a3).set(0, $thiz.sci_VectorBuilder__f_a2);
      $thiz.sci_VectorBuilder__f_depth = 3;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
  } else if ((xor < 1048576)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 3)) {
      $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a4).set(0, $thiz.sci_VectorBuilder__f_a3);
      $thiz.sci_VectorBuilder__f_depth = 4;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $n($thiz.sci_VectorBuilder__f_a4).set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
  } else if ((xor < 33554432)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 4)) {
      $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n($thiz.sci_VectorBuilder__f_a5).set(0, $thiz.sci_VectorBuilder__f_a4);
      $thiz.sci_VectorBuilder__f_depth = 5;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $n($thiz.sci_VectorBuilder__f_a4).set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $n($thiz.sci_VectorBuilder__f_a5).set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4);
  } else {
    if (($thiz.sci_VectorBuilder__f_depth <= 5)) {
      $thiz.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $n($thiz.sci_VectorBuilder__f_a6).set(0, $thiz.sci_VectorBuilder__f_a5);
      $thiz.sci_VectorBuilder__f_depth = 6;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $n($thiz.sci_VectorBuilder__f_a2).set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $n($thiz.sci_VectorBuilder__f_a3).set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $n($thiz.sci_VectorBuilder__f_a4).set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $n($thiz.sci_VectorBuilder__f_a5).set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4);
    $n($thiz.sci_VectorBuilder__f_a6).set(((idx >>> 25) | 0), $thiz.sci_VectorBuilder__f_a5);
  }
}
/** @constructor */
function $c_sci_VectorBuilder() {
  this.sci_VectorBuilder__f_a6 = null;
  this.sci_VectorBuilder__f_a5 = null;
  this.sci_VectorBuilder__f_a4 = null;
  this.sci_VectorBuilder__f_a3 = null;
  this.sci_VectorBuilder__f_a2 = null;
  this.sci_VectorBuilder__f_a1 = null;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
  this.sci_VectorBuilder__f_prefixIsRightAligned = false;
  this.sci_VectorBuilder__f_depth = 0;
  this.sci_VectorBuilder__f_a1 = new $ac_O(32);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
  this.sci_VectorBuilder__f_prefixIsRightAligned = false;
  this.sci_VectorBuilder__f_depth = 1;
}
$c_sci_VectorBuilder.prototype = new $h_O();
$c_sci_VectorBuilder.prototype.constructor = $c_sci_VectorBuilder;
/** @constructor */
function $h_sci_VectorBuilder() {
}
$h_sci_VectorBuilder.prototype = $c_sci_VectorBuilder.prototype;
$c_sci_VectorBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_VectorBuilder.prototype.initFrom__AO__V = (function(prefix1) {
  this.sci_VectorBuilder__f_depth = 1;
  var i = $n(prefix1).u.length;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  this.sci_VectorBuilder__f_a1 = (($n(prefix1).u.length === 32) ? prefix1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(prefix1, 0, 32));
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - 32) | 0);
  }
});
$c_sci_VectorBuilder.prototype.initFrom__sci_Vector__sci_VectorBuilder = (function(v) {
  var x1 = $n(v).vectorSliceCount__I();
  switch (x1) {
    case 0: {
      break;
    }
    case 1: {
      var v1 = $as_sci_Vector1(v);
      this.sci_VectorBuilder__f_depth = 1;
      var i = $n($n(v1).sci_Vector__f_prefix1).u.length;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      var a = $n(v1).sci_Vector__f_prefix1;
      this.sci_VectorBuilder__f_a1 = (($n(a).u.length === 32) ? a : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, 32));
      break;
    }
    case 3: {
      var v2 = $as_sci_Vector2(v);
      var d2 = $n(v2).sci_Vector2__f_data2;
      var a$1 = $n(v2).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$1).u.length === 32) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 0, 32));
      this.sci_VectorBuilder__f_depth = 2;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((32 - $n(v2).sci_Vector2__f_len1) | 0);
      var i$1 = (($n(v2).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$1);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$1 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a2).set(0, $n(v2).sci_Vector__f_prefix1);
      var dest = this.sci_VectorBuilder__f_a2;
      var length = $n(d2).u.length;
      $systemArraycopyRefs($n(d2), 0, $n(dest), 1, length);
      $n(this.sci_VectorBuilder__f_a2).set(((1 + $n(d2).u.length) | 0), this.sci_VectorBuilder__f_a1);
      break;
    }
    case 5: {
      var v3 = $as_sci_Vector3(v);
      var d3 = $n(v3).sci_Vector3__f_data3;
      var s2 = $n(v3).sci_Vector3__f_suffix2;
      var a$2 = $n(v3).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$2).u.length === 32) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 0, 32));
      this.sci_VectorBuilder__f_depth = 3;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((1024 - $n(v3).sci_Vector3__f_len12) | 0);
      var i$2 = (($n(v3).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$2);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$2 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a3).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v3).sci_Vector__f_prefix1, $n(v3).sci_Vector3__f_prefix2), 2));
      var dest$1 = this.sci_VectorBuilder__f_a3;
      var length$1 = $n(d3).u.length;
      $systemArraycopyRefs($n(d3), 0, $n(dest$1), 1, length$1);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2, 32), 2);
      $n(this.sci_VectorBuilder__f_a3).set(((1 + $n(d3).u.length) | 0), this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2).u.length, this.sci_VectorBuilder__f_a1);
      break;
    }
    case 7: {
      var v4 = $as_sci_Vector4(v);
      var d4 = $n(v4).sci_Vector4__f_data4;
      var s3 = $n(v4).sci_Vector4__f_suffix3;
      var s2$2 = $n(v4).sci_Vector4__f_suffix2;
      var a$3 = $n(v4).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$3).u.length === 32) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 0, 32));
      this.sci_VectorBuilder__f_depth = 4;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((32768 - $n(v4).sci_Vector4__f_len123) | 0);
      var i$3 = (($n(v4).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$3);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$3 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a4).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v4).sci_Vector__f_prefix1, $n(v4).sci_Vector4__f_prefix2), $n(v4).sci_Vector4__f_prefix3), 3));
      var dest$2 = this.sci_VectorBuilder__f_a4;
      var length$2 = $n(d4).u.length;
      $systemArraycopyRefs($n(d4), 0, $n(dest$2), 1, length$2);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$2, 32), 2);
      $n(this.sci_VectorBuilder__f_a4).set(((1 + $n(d4).u.length) | 0), this.sci_VectorBuilder__f_a3);
      $n(this.sci_VectorBuilder__f_a3).set($n(s3).u.length, this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2$2).u.length, this.sci_VectorBuilder__f_a1);
      break;
    }
    case 9: {
      var v5 = $as_sci_Vector5(v);
      var d5 = $n(v5).sci_Vector5__f_data5;
      var s4 = $n(v5).sci_Vector5__f_suffix4;
      var s3$2 = $n(v5).sci_Vector5__f_suffix3;
      var s2$3 = $n(v5).sci_Vector5__f_suffix2;
      var a$4 = $n(v5).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$4).u.length === 32) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 0, 32));
      this.sci_VectorBuilder__f_depth = 5;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((1048576 - $n(v5).sci_Vector5__f_len1234) | 0);
      var i$4 = (($n(v5).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$4);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$4 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $n(this.sci_VectorBuilder__f_a5).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v5).sci_Vector__f_prefix1, $n(v5).sci_Vector5__f_prefix2), $n(v5).sci_Vector5__f_prefix3), $n(v5).sci_Vector5__f_prefix4), 4));
      var dest$3 = this.sci_VectorBuilder__f_a5;
      var length$3 = $n(d5).u.length;
      $systemArraycopyRefs($n(d5), 0, $n(dest$3), 1, length$3);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$2, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$3, 32), 2);
      $n(this.sci_VectorBuilder__f_a5).set(((1 + $n(d5).u.length) | 0), this.sci_VectorBuilder__f_a4);
      $n(this.sci_VectorBuilder__f_a4).set($n(s4).u.length, this.sci_VectorBuilder__f_a3);
      $n(this.sci_VectorBuilder__f_a3).set($n(s3$2).u.length, this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2$3).u.length, this.sci_VectorBuilder__f_a1);
      break;
    }
    case 11: {
      var v6 = $as_sci_Vector6(v);
      var d6 = $n(v6).sci_Vector6__f_data6;
      var s5 = $n(v6).sci_Vector6__f_suffix5;
      var s4$2 = $n(v6).sci_Vector6__f_suffix4;
      var s3$3 = $n(v6).sci_Vector6__f_suffix3;
      var s2$4 = $n(v6).sci_Vector6__f_suffix2;
      var a$5 = $n(v6).sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = (($n(a$5).u.length === 32) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 0, 32));
      this.sci_VectorBuilder__f_depth = 6;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((33554432 - $n(v6).sci_Vector6__f_len12345) | 0);
      var i$5 = (($n(v6).sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$5);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$5 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $n(this.sci_VectorBuilder__f_a6).set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($n(v6).sci_Vector__f_prefix1, $n(v6).sci_Vector6__f_prefix2), $n(v6).sci_Vector6__f_prefix3), $n(v6).sci_Vector6__f_prefix4), $n(v6).sci_Vector6__f_prefix5), 5));
      var dest$4 = this.sci_VectorBuilder__f_a6;
      var length$4 = $n(d6).u.length;
      $systemArraycopyRefs($n(d6), 0, $n(dest$4), 1, length$4);
      this.sci_VectorBuilder__f_a5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s5, 32), 5);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4$2, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$4, 32), 2);
      $n(this.sci_VectorBuilder__f_a6).set(((1 + $n(d6).u.length) | 0), this.sci_VectorBuilder__f_a5);
      $n(this.sci_VectorBuilder__f_a5).set($n(s5).u.length, this.sci_VectorBuilder__f_a4);
      $n(this.sci_VectorBuilder__f_a4).set($n(s4$2).u.length, this.sci_VectorBuilder__f_a3);
      $n(this.sci_VectorBuilder__f_a3).set($n(s3$3).u.length, this.sci_VectorBuilder__f_a2);
      $n(this.sci_VectorBuilder__f_a2).set($n(s2$4).u.length, this.sci_VectorBuilder__f_a1);
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - 32) | 0);
  }
  return this;
});
$c_sci_VectorBuilder.prototype.alignTo__I__sci_Vector__sci_VectorBuilder = (function(before, bigVector) {
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 !== 0) || (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest !== 0))) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "A non-empty VectorBuilder cannot be aligned retrospectively. Please call .reset() or use a new VectorBuilder.");
  }
  var x = $m_sci_Vector0$();
  if (x.equals__O__Z(bigVector)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1;
  } else if ((bigVector instanceof $c_sci_Vector1)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1;
  } else if ((bigVector instanceof $c_sci_Vector2)) {
    var x4 = $as_sci_Vector2(bigVector);
    var _1$mcI$sp = $n(x4).sci_Vector2__f_len1;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp;
    var x1$2___2$mcI$sp = 32;
  } else if ((bigVector instanceof $c_sci_Vector3)) {
    var x5 = $as_sci_Vector3(bigVector);
    var _1$mcI$sp$1 = $n(x5).sci_Vector3__f_len12;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$1;
    var x1$2___2$mcI$sp = 1024;
  } else if ((bigVector instanceof $c_sci_Vector4)) {
    var x6 = $as_sci_Vector4(bigVector);
    var _1$mcI$sp$2 = $n(x6).sci_Vector4__f_len123;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$2;
    var x1$2___2$mcI$sp = 32768;
  } else if ((bigVector instanceof $c_sci_Vector5)) {
    var x7 = $as_sci_Vector5(bigVector);
    var _1$mcI$sp$3 = $n(x7).sci_Vector5__f_len1234;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$3;
    var x1$2___2$mcI$sp = 1048576;
  } else {
    if ((!(bigVector instanceof $c_sci_Vector6))) {
      throw new $c_s_MatchError(bigVector);
    }
    var x8 = $as_sci_Vector6(bigVector);
    var _1$mcI$sp$4 = $n(x8).sci_Vector6__f_len12345;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$4;
    var x1$2___2$mcI$sp = 33554432;
  }
  var prefixLength = x1$2___1$mcI$sp;
  var maxPrefixLength = x1$2___2$mcI$sp;
  if ((maxPrefixLength === 1)) {
    return this;
  }
  var overallPrefixLength = ((((before + prefixLength) | 0) % $checkIntDivisor(maxPrefixLength)) | 0);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((((maxPrefixLength - overallPrefixLength) | 0) % $checkIntDivisor(maxPrefixLength)) | 0);
  $p_sci_VectorBuilder__advanceN__I__V(this, ((-32) & this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset));
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset);
  this.sci_VectorBuilder__f_prefixIsRightAligned = true;
  return this;
});
$c_sci_VectorBuilder.prototype.addOne__O__sci_VectorBuilder = (function(elem) {
  if ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V(this);
  }
  $n(this.sci_VectorBuilder__f_a1).set(this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1, elem);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = ((1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  return this;
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__sci_VectorBuilder = (function(xs) {
  if ((xs instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(xs);
    return ((((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest === 0)) && (!this.sci_VectorBuilder__f_prefixIsRightAligned)) ? this.initFrom__sci_Vector__sci_VectorBuilder(x2) : $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder(this, x2));
  } else {
    return $as_sci_VectorBuilder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$c_sci_VectorBuilder.prototype.result__sci_Vector = (function() {
  if (this.sci_VectorBuilder__f_prefixIsRightAligned) {
    $p_sci_VectorBuilder__leftAlignPrefix__V(this);
  }
  var len = ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var realLen = ((len - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
  if ((realLen === 0)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  } else if ((len < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("Vector cannot have negative size " + len));
  } else if ((len <= 32)) {
    var a = this.sci_VectorBuilder__f_a1;
    return new $c_sci_Vector1((($n(a).u.length === realLen) ? a : $m_ju_Arrays$().copyOf__AO__I__AO(a, realLen)));
  } else if ((len <= 1024)) {
    var i1 = (31 & ((len - 1) | 0));
    var i2 = ((((len - 1) | 0) >>> 5) | 0);
    var original = this.sci_VectorBuilder__f_a2;
    var data = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, 1, i2), 2);
    var prefix1 = $n(this.sci_VectorBuilder__f_a2).get(0);
    var a$1 = $n(this.sci_VectorBuilder__f_a2).get(i2);
    var len$1 = ((1 + i1) | 0);
    var suffix1 = (($n(a$1).u.length === len$1) ? a$1 : $m_ju_Arrays$().copyOf__AO__I__AO(a$1, len$1));
    return new $c_sci_Vector2(prefix1, ((32 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0), data, suffix1, realLen);
  } else if ((len <= 32768)) {
    var i1$2 = (31 & ((len - 1) | 0));
    var i2$2 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3 = ((((len - 1) | 0) >>> 10) | 0);
    var original$1 = this.sci_VectorBuilder__f_a3;
    var data$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, 1, i3), 3);
    var a$2 = $n(this.sci_VectorBuilder__f_a3).get(0);
    var to = $n(a$2).u.length;
    var prefix2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 1, to), 2);
    var prefix1$2 = $n($n(this.sci_VectorBuilder__f_a3).get(0)).get(0);
    var original$2 = $n(this.sci_VectorBuilder__f_a3).get(i3);
    var suffix2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$2, i2$2), 2);
    var a$3 = $n($n(this.sci_VectorBuilder__f_a3).get(i3)).get(i2$2);
    var len$2 = ((1 + i1$2) | 0);
    var suffix1$2 = (($n(a$3).u.length === len$2) ? a$3 : $m_ju_Arrays$().copyOf__AO__I__AO(a$3, len$2));
    var len1 = $n(prefix1$2).u.length;
    var len12 = ((len1 + ($n(prefix2).u.length << 5)) | 0);
    return new $c_sci_Vector3(prefix1$2, len1, prefix2, len12, data$2, suffix2, suffix1$2, realLen);
  } else if ((len <= 1048576)) {
    var i1$3 = (31 & ((len - 1) | 0));
    var i2$3 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3$2 = (31 & ((((len - 1) | 0) >>> 10) | 0));
    var i4 = ((((len - 1) | 0) >>> 15) | 0);
    var original$3 = this.sci_VectorBuilder__f_a4;
    var data$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$3, 1, i4), 4);
    var a$4 = $n(this.sci_VectorBuilder__f_a4).get(0);
    var to$1 = $n(a$4).u.length;
    var prefix3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 1, to$1), 3);
    var a$5 = $n($n(this.sci_VectorBuilder__f_a4).get(0)).get(0);
    var to$2 = $n(a$5).u.length;
    var prefix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 1, to$2), 2);
    var prefix1$3 = $n($n($n(this.sci_VectorBuilder__f_a4).get(0)).get(0)).get(0);
    var original$4 = $n(this.sci_VectorBuilder__f_a4).get(i4);
    var suffix3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$4, i3$2), 3);
    var original$5 = $n($n(this.sci_VectorBuilder__f_a4).get(i4)).get(i3$2);
    var suffix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$5, i2$3), 2);
    var a$6 = $n($n($n(this.sci_VectorBuilder__f_a4).get(i4)).get(i3$2)).get(i2$3);
    var len$3 = ((1 + i1$3) | 0);
    var suffix1$3 = (($n(a$6).u.length === len$3) ? a$6 : $m_ju_Arrays$().copyOf__AO__I__AO(a$6, len$3));
    var len1$2 = $n(prefix1$3).u.length;
    var len12$2 = ((len1$2 + ($n(prefix2$2).u.length << 5)) | 0);
    var len123 = ((len12$2 + ($n(prefix3).u.length << 10)) | 0);
    return new $c_sci_Vector4(prefix1$3, len1$2, prefix2$2, len12$2, prefix3, len123, data$3, suffix3, suffix2$2, suffix1$3, realLen);
  } else if ((len <= 33554432)) {
    var i1$4 = (31 & ((len - 1) | 0));
    var i2$4 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3$3 = (31 & ((((len - 1) | 0) >>> 10) | 0));
    var i4$2 = (31 & ((((len - 1) | 0) >>> 15) | 0));
    var i5 = ((((len - 1) | 0) >>> 20) | 0);
    var original$6 = this.sci_VectorBuilder__f_a5;
    var data$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$6, 1, i5), 5);
    var a$7 = $n(this.sci_VectorBuilder__f_a5).get(0);
    var to$3 = $n(a$7).u.length;
    var prefix4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$7, 1, to$3), 4);
    var a$8 = $n($n(this.sci_VectorBuilder__f_a5).get(0)).get(0);
    var to$4 = $n(a$8).u.length;
    var prefix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$8, 1, to$4), 3);
    var a$9 = $n($n($n(this.sci_VectorBuilder__f_a5).get(0)).get(0)).get(0);
    var to$5 = $n(a$9).u.length;
    var prefix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$9, 1, to$5), 2);
    var prefix1$4 = $n($n($n($n(this.sci_VectorBuilder__f_a5).get(0)).get(0)).get(0)).get(0);
    var original$7 = $n(this.sci_VectorBuilder__f_a5).get(i5);
    var suffix4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$7, i4$2), 4);
    var original$8 = $n($n(this.sci_VectorBuilder__f_a5).get(i5)).get(i4$2);
    var suffix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$8, i3$3), 3);
    var original$9 = $n($n($n(this.sci_VectorBuilder__f_a5).get(i5)).get(i4$2)).get(i3$3);
    var suffix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$9, i2$4), 2);
    var a$10 = $n($n($n($n(this.sci_VectorBuilder__f_a5).get(i5)).get(i4$2)).get(i3$3)).get(i2$4);
    var len$4 = ((1 + i1$4) | 0);
    var suffix1$4 = (($n(a$10).u.length === len$4) ? a$10 : $m_ju_Arrays$().copyOf__AO__I__AO(a$10, len$4));
    var len1$3 = $n(prefix1$4).u.length;
    var len12$3 = ((len1$3 + ($n(prefix2$3).u.length << 5)) | 0);
    var len123$2 = ((len12$3 + ($n(prefix3$2).u.length << 10)) | 0);
    var len1234 = ((len123$2 + ($n(prefix4).u.length << 15)) | 0);
    return new $c_sci_Vector5(prefix1$4, len1$3, prefix2$3, len12$3, prefix3$2, len123$2, prefix4, len1234, data$4, suffix4, suffix3$2, suffix2$3, suffix1$4, realLen);
  } else {
    var i1$5 = (31 & ((len - 1) | 0));
    var i2$5 = (31 & ((((len - 1) | 0) >>> 5) | 0));
    var i3$4 = (31 & ((((len - 1) | 0) >>> 10) | 0));
    var i4$3 = (31 & ((((len - 1) | 0) >>> 15) | 0));
    var i5$2 = (31 & ((((len - 1) | 0) >>> 20) | 0));
    var i6 = ((((len - 1) | 0) >>> 25) | 0);
    var original$10 = this.sci_VectorBuilder__f_a6;
    var data$5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$10, 1, i6), 6);
    var a$11 = $n(this.sci_VectorBuilder__f_a6).get(0);
    var to$6 = $n(a$11).u.length;
    var prefix5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$11, 1, to$6), 5);
    var a$12 = $n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0);
    var to$7 = $n(a$12).u.length;
    var prefix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$12, 1, to$7), 4);
    var a$13 = $n($n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0)).get(0);
    var to$8 = $n(a$13).u.length;
    var prefix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$13, 1, to$8), 3);
    var a$14 = $n($n($n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0)).get(0)).get(0);
    var to$9 = $n(a$14).u.length;
    var prefix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$14, 1, to$9), 2);
    var prefix1$5 = $n($n($n($n($n(this.sci_VectorBuilder__f_a6).get(0)).get(0)).get(0)).get(0)).get(0);
    var original$11 = $n(this.sci_VectorBuilder__f_a6).get(i6);
    var suffix5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$11, i5$2), 5);
    var original$12 = $n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2);
    var suffix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$12, i4$3), 4);
    var original$13 = $n($n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2)).get(i4$3);
    var suffix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$13, i3$4), 3);
    var original$14 = $n($n($n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2)).get(i4$3)).get(i3$4);
    var suffix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$14, i2$5), 2);
    var a$15 = $n($n($n($n($n(this.sci_VectorBuilder__f_a6).get(i6)).get(i5$2)).get(i4$3)).get(i3$4)).get(i2$5);
    var len$5 = ((1 + i1$5) | 0);
    var suffix1$5 = (($n(a$15).u.length === len$5) ? a$15 : $m_ju_Arrays$().copyOf__AO__I__AO(a$15, len$5));
    var len1$4 = $n(prefix1$5).u.length;
    var len12$4 = ((len1$4 + ($n(prefix2$4).u.length << 5)) | 0);
    var len123$3 = ((len12$4 + ($n(prefix3$3).u.length << 10)) | 0);
    var len1234$2 = ((len123$3 + ($n(prefix4$2).u.length << 15)) | 0);
    var len12345 = ((len1234$2 + ($n(prefix5).u.length << 20)) | 0);
    return new $c_sci_Vector6(prefix1$5, len1$4, prefix2$4, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data$5, suffix5, suffix4$2, suffix3$3, suffix2$4, suffix1$5, realLen);
  }
});
$c_sci_VectorBuilder.prototype.toString__T = (function() {
  return (((((((("VectorBuilder(len1=" + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) + ", lenRest=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) + ", offset=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) + ", depth=") + this.sci_VectorBuilder__f_depth) + ")");
});
$c_sci_VectorBuilder.prototype.result__O = (function() {
  return this.result__sci_Vector();
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
});
$c_sci_VectorBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_VectorBuilder(elem);
});
function $as_sci_VectorBuilder(obj) {
  return (((obj instanceof $c_sci_VectorBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.VectorBuilder"));
}
function $isArrayOf_sci_VectorBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorBuilder)));
}
function $asArrayOf_sci_VectorBuilder(obj, depth) {
  return (($isArrayOf_sci_VectorBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.VectorBuilder;", depth));
}
var $d_sci_VectorBuilder = new $TypeData().initClass($c_sci_VectorBuilder, "scala.collection.immutable.VectorBuilder", ({
  sci_VectorBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_scm_ArrayBuffer$() {
  this.scm_ArrayBuffer$__f_emptyArray = null;
  $n_scm_ArrayBuffer$ = this;
  this.scm_ArrayBuffer$__f_emptyArray = new $ac_O(0);
}
$c_scm_ArrayBuffer$.prototype = new $h_O();
$c_scm_ArrayBuffer$.prototype.constructor = $c_scm_ArrayBuffer$;
/** @constructor */
function $h_scm_ArrayBuffer$() {
}
$h_scm_ArrayBuffer$.prototype = $c_scm_ArrayBuffer$.prototype;
$c_scm_ArrayBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(elems);
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__scm_ArrayBuffer = (function(coll) {
  var k = $n(coll).knownSize__I();
  if ((k >= 0)) {
    var array = this.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO(this.scm_ArrayBuffer$__f_emptyArray, 0, k);
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      var actual = $n(x2).copyToArray__O__I__I__I(array, 0, 2147483647);
    } else {
      var actual = $n($n(coll).iterator__sc_Iterator()).copyToArray__O__I__I__I(array, 0, 2147483647);
    }
    if ((actual !== k)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + k));
    }
    return $ct_scm_ArrayBuffer__AO__I__(new $c_scm_ArrayBuffer(), array, k);
  } else {
    var this$2 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    return this$2.addAll__sc_IterableOnce__scm_ArrayBuffer(coll);
  }
});
$c_scm_ArrayBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayBuffer$$anon$1();
});
$c_scm_ArrayBuffer$.prototype.resizeUp__I__I__I = (function(arrayLen, targetLen) {
  if ((targetLen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ((((("Overflow while resizing array of array-backed collection. Requested length: " + targetLen) + "; current length: ") + arrayLen) + "; increase: ") + ((targetLen - arrayLen) | 0)));
  } else if ((targetLen <= arrayLen)) {
    return (-1);
  } else if ((targetLen > 2147483639)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ((("Array of array-backed collection exceeds VM length limit of 2147483639. Requested length: " + targetLen) + "; current length: ") + arrayLen));
  } else if ((arrayLen > 1073741819)) {
    return 2147483639;
  } else {
    var x = (arrayLen << 1);
    var y = ((x > 16) ? x : 16);
    return ((targetLen > y) ? targetLen : y);
  }
});
$c_scm_ArrayBuffer$.prototype.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO = (function(array, curSize, targetSize) {
  var newLen = this.resizeUp__I__I__I($n(array).u.length, targetSize);
  if ((newLen < 0)) {
    return array;
  } else {
    var res = new $ac_O(newLen);
    $systemArraycopyRefs($n(array), 0, res, 0, curSize);
    return res;
  }
});
$c_scm_ArrayBuffer$.prototype.empty__O = (function() {
  return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(source);
});
var $d_scm_ArrayBuffer$ = new $TypeData().initClass($c_scm_ArrayBuffer$, "scala.collection.mutable.ArrayBuffer$", ({
  scm_ArrayBuffer$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_ArrayBuffer$;
function $m_scm_ArrayBuffer$() {
  if ((!$n_scm_ArrayBuffer$)) {
    $n_scm_ArrayBuffer$ = new $c_scm_ArrayBuffer$();
  }
  return $n_scm_ArrayBuffer$;
}
/** @constructor */
function $c_scm_ArrayBuffer$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())));
}
$c_scm_ArrayBuffer$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayBuffer$$anon$1.prototype.constructor = $c_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $h_scm_ArrayBuffer$$anon$1() {
}
$h_scm_ArrayBuffer$$anon$1.prototype = $c_scm_ArrayBuffer$$anon$1.prototype;
$c_scm_ArrayBuffer$$anon$1.prototype.sizeHint__I__V = (function(size) {
  $n($as_scm_ArrayBuffer(this.scm_GrowableBuilder__f_elems)).sizeHint__I__V(size);
});
var $d_scm_ArrayBuffer$$anon$1 = new $TypeData().initClass($c_scm_ArrayBuffer$$anon$1, "scala.collection.mutable.ArrayBuffer$$anon$1", ({
  scm_ArrayBuffer$$anon$1: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_scm_ArrayDeque$() {
}
$c_scm_ArrayDeque$.prototype = new $h_O();
$c_scm_ArrayDeque$.prototype.constructor = $c_scm_ArrayDeque$;
/** @constructor */
function $h_scm_ArrayDeque$() {
}
$h_scm_ArrayDeque$.prototype = $c_scm_ArrayDeque$.prototype;
$c_scm_ArrayDeque$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(elems);
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__scm_ArrayDeque = (function(coll) {
  var s = $n(coll).knownSize__I();
  if ((s >= 0)) {
    var array = this.alloc__I__AO(s);
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      var actual = $n(x2).copyToArray__O__I__I__I(array, 0, 2147483647);
    } else {
      var actual = $n($n(coll).iterator__sc_Iterator()).copyToArray__O__I__I__I(array, 0, 2147483647);
    }
    if ((actual !== s)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + s));
    }
    return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, s);
  } else {
    var this$2 = $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
    return this$2.addAll__sc_IterableOnce__scm_ArrayDeque(coll);
  }
});
$c_scm_ArrayDeque$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayDeque$$anon$1();
});
$c_scm_ArrayDeque$.prototype.alloc__I__AO = (function(len) {
  var requirement = (len >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Non-negative array size required");
  }
  var size = ((((-2147483648) >>> Math.clz32(len)) | 0) << 1);
  var requirement$1 = (size >= 0);
  if ((!requirement$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "ArrayDeque too big - cannot allocate ArrayDeque of length ") + len));
  }
  return new $ac_O(((size > 16) ? size : 16));
});
$c_scm_ArrayDeque$.prototype.empty__O = (function() {
  return $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(source);
});
var $d_scm_ArrayDeque$ = new $TypeData().initClass($c_scm_ArrayDeque$, "scala.collection.mutable.ArrayDeque$", ({
  scm_ArrayDeque$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_ArrayDeque$;
function $m_scm_ArrayDeque$() {
  if ((!$n_scm_ArrayDeque$)) {
    $n_scm_ArrayDeque$ = new $c_scm_ArrayDeque$();
  }
  return $n_scm_ArrayDeque$;
}
/** @constructor */
function $c_scm_ArrayDeque$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16));
}
$c_scm_ArrayDeque$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayDeque$$anon$1.prototype.constructor = $c_scm_ArrayDeque$$anon$1;
/** @constructor */
function $h_scm_ArrayDeque$$anon$1() {
}
$h_scm_ArrayDeque$$anon$1.prototype = $c_scm_ArrayDeque$$anon$1.prototype;
$c_scm_ArrayDeque$$anon$1.prototype.sizeHint__I__V = (function(size) {
  var this$1 = $n($as_scm_ArrayDeque(this.scm_GrowableBuilder__f_elems));
  var idx = this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((size > (((this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this$1.scm_ArrayDeque__f_array).u.length - 1) | 0))) && (size >= $n(this$1.scm_ArrayDeque__f_array).u.length))) {
    this$1.scala$collection$mutable$ArrayDeque$$resize__I__V(size);
  }
});
var $d_scm_ArrayDeque$$anon$1 = new $TypeData().initClass($c_scm_ArrayDeque$$anon$1, "scala.collection.mutable.ArrayDeque$$anon$1", ({
  scm_ArrayDeque$$anon$1: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_scm_Buffer$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sjs_js_WrappedArray$());
}
$c_scm_Buffer$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_Buffer$.prototype.constructor = $c_scm_Buffer$;
/** @constructor */
function $h_scm_Buffer$() {
}
$h_scm_Buffer$.prototype = $c_scm_Buffer$.prototype;
var $d_scm_Buffer$ = new $TypeData().initClass($c_scm_Buffer$, "scala.collection.mutable.Buffer$", ({
  scm_Buffer$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Buffer$;
function $m_scm_Buffer$() {
  if ((!$n_scm_Buffer$)) {
    $n_scm_Buffer$ = new $c_scm_Buffer$();
  }
  return $n_scm_Buffer$;
}
/** @constructor */
function $c_scm_HashMap$$anon$6(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), initialCapacity$1, loadFactor$1));
}
$c_scm_HashMap$$anon$6.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashMap$$anon$6.prototype.constructor = $c_scm_HashMap$$anon$6;
/** @constructor */
function $h_scm_HashMap$$anon$6() {
}
$h_scm_HashMap$$anon$6.prototype = $c_scm_HashMap$$anon$6.prototype;
$c_scm_HashMap$$anon$6.prototype.sizeHint__I__V = (function(size) {
  $n($as_scm_HashMap(this.scm_GrowableBuilder__f_elems)).sizeHint__I__V(size);
});
var $d_scm_HashMap$$anon$6 = new $TypeData().initClass($c_scm_HashMap$$anon$6, "scala.collection.mutable.HashMap$$anon$6", ({
  scm_HashMap$$anon$6: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $ct_scm_HashMap$HashMapIterator__scm_HashMap__($thiz, outer) {
  $n(outer);
  $thiz.scm_HashMap$HashMapIterator__f_$outer = outer;
  $thiz.scm_HashMap$HashMapIterator__f_i = 0;
  $thiz.scm_HashMap$HashMapIterator__f_node = null;
  $thiz.scm_HashMap$HashMapIterator__f_len = $n($n(outer).scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  return $thiz;
}
/** @constructor */
function $c_scm_HashMap$HashMapIterator() {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
}
$c_scm_HashMap$HashMapIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashMap$HashMapIterator.prototype.constructor = $c_scm_HashMap$HashMapIterator;
/** @constructor */
function $h_scm_HashMap$HashMapIterator() {
}
$h_scm_HashMap$HashMapIterator.prototype = $c_scm_HashMap$HashMapIterator.prototype;
$c_scm_HashMap$HashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashMap$HashMapIterator__f_node !== null)) {
    return true;
  } else {
    while ((this.scm_HashMap$HashMapIterator__f_i < this.scm_HashMap$HashMapIterator__f_len)) {
      var n = $n($n(this.scm_HashMap$HashMapIterator__f_$outer).scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(this.scm_HashMap$HashMapIterator__f_i);
      this.scm_HashMap$HashMapIterator__f_i = ((1 + this.scm_HashMap$HashMapIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashMap$HashMapIterator__f_node = n;
        return true;
      }
    }
    return false;
  }
});
$c_scm_HashMap$HashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var r = this.extract__scm_HashMap$Node__O(this.scm_HashMap$HashMapIterator__f_node);
    this.scm_HashMap$HashMapIterator__f_node = $n(this.scm_HashMap$HashMapIterator__f_node).scm_HashMap$Node__f__next;
    return r;
  }
});
/** @constructor */
function $c_scm_HashSet$$anon$4(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), initialCapacity$1, loadFactor$1));
}
$c_scm_HashSet$$anon$4.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashSet$$anon$4.prototype.constructor = $c_scm_HashSet$$anon$4;
/** @constructor */
function $h_scm_HashSet$$anon$4() {
}
$h_scm_HashSet$$anon$4.prototype = $c_scm_HashSet$$anon$4.prototype;
$c_scm_HashSet$$anon$4.prototype.sizeHint__I__V = (function(size) {
  $n($as_scm_HashSet(this.scm_GrowableBuilder__f_elems)).sizeHint__I__V(size);
});
var $d_scm_HashSet$$anon$4 = new $TypeData().initClass($c_scm_HashSet$$anon$4, "scala.collection.mutable.HashSet$$anon$4", ({
  scm_HashSet$$anon$4: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
function $ct_scm_HashSet$HashSetIterator__scm_HashSet__($thiz, outer) {
  $n(outer);
  $thiz.scm_HashSet$HashSetIterator__f_$outer = outer;
  $thiz.scm_HashSet$HashSetIterator__f_i = 0;
  $thiz.scm_HashSet$HashSetIterator__f_node = null;
  $thiz.scm_HashSet$HashSetIterator__f_len = $n($n(outer).scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length;
  return $thiz;
}
/** @constructor */
function $c_scm_HashSet$HashSetIterator() {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
}
$c_scm_HashSet$HashSetIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashSet$HashSetIterator.prototype.constructor = $c_scm_HashSet$HashSetIterator;
/** @constructor */
function $h_scm_HashSet$HashSetIterator() {
}
$h_scm_HashSet$HashSetIterator.prototype = $c_scm_HashSet$HashSetIterator.prototype;
$c_scm_HashSet$HashSetIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashSet$HashSetIterator__f_node !== null)) {
    return true;
  } else {
    while ((this.scm_HashSet$HashSetIterator__f_i < this.scm_HashSet$HashSetIterator__f_len)) {
      var n = $n($n(this.scm_HashSet$HashSetIterator__f_$outer).scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(this.scm_HashSet$HashSetIterator__f_i);
      this.scm_HashSet$HashSetIterator__f_i = ((1 + this.scm_HashSet$HashSetIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashSet$HashSetIterator__f_node = n;
        return true;
      }
    }
    return false;
  }
});
$c_scm_HashSet$HashSetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  } else {
    var r = this.extract__scm_HashSet$Node__O(this.scm_HashSet$HashSetIterator__f_node);
    this.scm_HashSet$HashSetIterator__f_node = $n(this.scm_HashSet$HashSetIterator__f_node).scm_HashSet$Node__f__next;
    return r;
  }
});
function $ct_scm_ImmutableBuilder__sc_IterableOnce__($thiz, empty) {
  $thiz.scm_ImmutableBuilder__f_elems = empty;
  return $thiz;
}
/** @constructor */
function $c_scm_ImmutableBuilder() {
  this.scm_ImmutableBuilder__f_elems = null;
}
$c_scm_ImmutableBuilder.prototype = new $h_O();
$c_scm_ImmutableBuilder.prototype.constructor = $c_scm_ImmutableBuilder;
/** @constructor */
function $h_scm_ImmutableBuilder() {
}
$h_scm_ImmutableBuilder.prototype = $c_scm_ImmutableBuilder.prototype;
$c_scm_ImmutableBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_ImmutableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_ImmutableBuilder.prototype.result__O = (function() {
  return this.scm_ImmutableBuilder__f_elems;
});
/** @constructor */
function $c_scm_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_scm_ArrayBuffer$());
}
$c_scm_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_IndexedSeq$.prototype.constructor = $c_scm_IndexedSeq$;
/** @constructor */
function $h_scm_IndexedSeq$() {
}
$h_scm_IndexedSeq$.prototype = $c_scm_IndexedSeq$.prototype;
var $d_scm_IndexedSeq$ = new $TypeData().initClass($c_scm_IndexedSeq$, "scala.collection.mutable.IndexedSeq$", ({
  scm_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_IndexedSeq$;
function $m_scm_IndexedSeq$() {
  if ((!$n_scm_IndexedSeq$)) {
    $n_scm_IndexedSeq$ = new $c_scm_IndexedSeq$();
  }
  return $n_scm_IndexedSeq$;
}
/** @constructor */
function $c_scm_ListBuffer$() {
}
$c_scm_ListBuffer$.prototype = new $h_O();
$c_scm_ListBuffer$.prototype.constructor = $c_scm_ListBuffer$;
/** @constructor */
function $h_scm_ListBuffer$() {
}
$h_scm_ListBuffer$.prototype = $c_scm_ListBuffer$.prototype;
$c_scm_ListBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(elems);
});
$c_scm_ListBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer());
});
$c_scm_ListBuffer$.prototype.empty__O = (function() {
  return new $c_scm_ListBuffer();
});
$c_scm_ListBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(source);
});
var $d_scm_ListBuffer$ = new $TypeData().initClass($c_scm_ListBuffer$, "scala.collection.mutable.ListBuffer$", ({
  scm_ListBuffer$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_ListBuffer$;
function $m_scm_ListBuffer$() {
  if ((!$n_scm_ListBuffer$)) {
    $n_scm_ListBuffer$ = new $c_scm_ListBuffer$();
  }
  return $n_scm_ListBuffer$;
}
/** @constructor */
function $c_scm_MutationTracker$CheckedIterator(underlying, mutationCount) {
  this.scm_MutationTracker$CheckedIterator__f_underlying = null;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = null;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = 0;
  this.scm_MutationTracker$CheckedIterator__f_underlying = underlying;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = mutationCount;
  var this$1 = $n(mutationCount);
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = $uI(this$1.apply__O());
}
$c_scm_MutationTracker$CheckedIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_MutationTracker$CheckedIterator.prototype.constructor = $c_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $h_scm_MutationTracker$CheckedIterator() {
}
$h_scm_MutationTracker$CheckedIterator.prototype = $c_scm_MutationTracker$CheckedIterator.prototype;
$c_scm_MutationTracker$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_MutationTracker$CheckedIterator__f_expectedCount;
  var this$1 = $n(this.scm_MutationTracker$CheckedIterator__f_mutationCount);
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return $n(this.scm_MutationTracker$CheckedIterator__f_underlying).hasNext__Z();
});
$c_scm_MutationTracker$CheckedIterator.prototype.next__O = (function() {
  return $n(this.scm_MutationTracker$CheckedIterator__f_underlying).next__O();
});
var $d_scm_MutationTracker$CheckedIterator = new $TypeData().initClass($c_scm_MutationTracker$CheckedIterator, "scala.collection.mutable.MutationTracker$CheckedIterator", ({
  scm_MutationTracker$CheckedIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_Queue$() {
}
$c_scm_Queue$.prototype = new $h_O();
$c_scm_Queue$.prototype.constructor = $c_scm_Queue$;
/** @constructor */
function $h_scm_Queue$() {
}
$h_scm_Queue$.prototype = $c_scm_Queue$.prototype;
$c_scm_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  var this$1 = new $c_scm_Queue(16);
  return $as_scm_Queue(this$1.addAll__sc_IterableOnce__scm_ArrayDeque(elems));
});
$c_scm_Queue$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_Queue(16));
});
$c_scm_Queue$.prototype.empty__O = (function() {
  return new $c_scm_Queue(16);
});
$c_scm_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  var this$1 = new $c_scm_Queue(16);
  return $as_scm_Queue(this$1.addAll__sc_IterableOnce__scm_ArrayDeque(source));
});
var $d_scm_Queue$ = new $TypeData().initClass($c_scm_Queue$, "scala.collection.mutable.Queue$", ({
  scm_Queue$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_Queue$;
function $m_scm_Queue$() {
  if ((!$n_scm_Queue$)) {
    $n_scm_Queue$ = new $c_scm_Queue$();
  }
  return $n_scm_Queue$;
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$parasitic$() {
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = null;
  $n_s_concurrent_ExecutionContext$parasitic$ = this;
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = $ct_jl_ThreadLocal__(new $c_jl_ThreadLocal());
}
$c_s_concurrent_ExecutionContext$parasitic$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$parasitic$.prototype.constructor = $c_s_concurrent_ExecutionContext$parasitic$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$parasitic$() {
}
$h_s_concurrent_ExecutionContext$parasitic$.prototype = $c_s_concurrent_ExecutionContext$parasitic$.prototype;
$c_s_concurrent_ExecutionContext$parasitic$.prototype.execute__jl_Runnable__V = (function(runnable) {
  $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V(this, runnable);
});
$c_s_concurrent_ExecutionContext$parasitic$.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $n($m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter).apply__O__O(t);
});
var $d_s_concurrent_ExecutionContext$parasitic$ = new $TypeData().initClass($c_s_concurrent_ExecutionContext$parasitic$, "scala.concurrent.ExecutionContext$parasitic$", ({
  s_concurrent_ExecutionContext$parasitic$: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_BatchingExecutor: 1
}));
var $n_s_concurrent_ExecutionContext$parasitic$;
function $m_s_concurrent_ExecutionContext$parasitic$() {
  if ((!$n_s_concurrent_ExecutionContext$parasitic$)) {
    $n_s_concurrent_ExecutionContext$parasitic$ = new $c_s_concurrent_ExecutionContext$parasitic$();
  }
  return $n_s_concurrent_ExecutionContext$parasitic$;
}
/** @constructor */
function $c_s_concurrent_duration_Duration$Infinite() {
}
$c_s_concurrent_duration_Duration$Infinite.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_Duration$Infinite.prototype.constructor = $c_s_concurrent_duration_Duration$Infinite;
/** @constructor */
function $h_s_concurrent_duration_Duration$Infinite() {
}
$h_s_concurrent_duration_Duration$Infinite.prototype = $c_s_concurrent_duration_Duration$Infinite.prototype;
$c_s_concurrent_duration_Duration$Infinite.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined)) {
    return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined;
  }
  if ((other instanceof $c_s_concurrent_duration_Duration$Infinite)) {
    var x2 = $as_s_concurrent_duration_Duration$Infinite(other);
    if ((x2 !== this)) {
      return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined;
    }
  }
  return this;
});
function $as_s_concurrent_duration_Duration$Infinite(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration$Infinite) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration$Infinite"));
}
function $isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration$Infinite)));
}
function $asArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration$Infinite;", depth));
}
function $p_s_concurrent_duration_FiniteDuration__bounded__J__Z($thiz, max_$_lo, max_$_hi) {
  var lo = ((-max_$_lo) | 0);
  var hi = ((((-max_$_hi) | 0) + ((max_$_lo | lo) >> 31)) | 0);
  var x_$_lo = $thiz.s_concurrent_duration_FiniteDuration__f_length_$lo;
  var x_$_hi = $thiz.s_concurrent_duration_FiniteDuration__f_length_$hi;
  if (((hi === x_$_hi) ? ((lo >>> 0) <= (x_$_lo >>> 0)) : (hi < x_$_hi))) {
    var x$1_$_lo = $thiz.s_concurrent_duration_FiniteDuration__f_length_$lo;
    var x$1_$_hi = $thiz.s_concurrent_duration_FiniteDuration__f_length_$hi;
    return ((x$1_$_hi === max_$_hi) ? ((x$1_$_lo >>> 0) <= (max_$_lo >>> 0)) : (x$1_$_hi < max_$_hi));
  } else {
    return false;
  }
}
function $p_s_concurrent_duration_FiniteDuration__unitString__T($thiz) {
  var $x_1 = $as_T($n($m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_timeUnitName).apply__O__O($thiz.s_concurrent_duration_FiniteDuration__f_unit));
  var x_$_lo = $thiz.s_concurrent_duration_FiniteDuration__f_length_$lo;
  var x_$_hi = $thiz.s_concurrent_duration_FiniteDuration__f_length_$hi;
  return ($x_1 + ((((1 ^ x_$_lo) | x_$_hi) === 0) ? "" : "s"));
}
function $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, a_$_lo, a_$_hi, b_$_lo, b_$_hi) {
  if (((b_$_hi === 0) ? (b_$_lo !== 0) : (b_$_hi > 0))) {
    var lo = (~b_$_lo);
    var hi = ((((2147483647 - b_$_hi) | 0) + ((b_$_lo & lo) >> 31)) | 0);
    var $x_2 = ((a_$_hi === hi) ? ((a_$_lo >>> 0) > (lo >>> 0)) : (a_$_hi > hi));
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    var $x_1 = true;
  } else if ((b_$_hi < 0)) {
    var lo$1 = ((-b_$_lo) | 0);
    var hi$1 = (((((-2147483648) - b_$_hi) | 0) + ((b_$_lo | lo$1) >> 31)) | 0);
    var $x_1 = ((a_$_hi === hi$1) ? ((a_$_lo >>> 0) < (lo$1 >>> 0)) : (a_$_hi < hi$1));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "integer overflow");
  }
  var lo$2 = ((a_$_lo + b_$_lo) | 0);
  var hi$2 = ((((a_$_hi + b_$_hi) | 0) + ((((a_$_lo & b_$_lo) | ((a_$_lo | b_$_lo) & (~lo$2))) >>> 31) | 0)) | 0);
  return $bL(lo$2, hi$2);
}
function $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration($thiz, otherLength_$_lo, otherLength_$_hi, otherUnit) {
  var $x_1 = $n(otherUnit).convert__J__ju_concurrent_TimeUnit__J(1, 0, $thiz.s_concurrent_duration_FiniteDuration__f_unit);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  if (((x_$_lo | x_$_hi) === 0)) {
    var commonUnit = $thiz.s_concurrent_duration_FiniteDuration__f_unit;
  } else {
    var commonUnit = otherUnit;
  }
  var $x_4 = $n(commonUnit).convert__J__ju_concurrent_TimeUnit__J($thiz.s_concurrent_duration_FiniteDuration__f_length_$lo, $thiz.s_concurrent_duration_FiniteDuration__f_length_$hi, $thiz.s_concurrent_duration_FiniteDuration__f_unit);
  var $x_3 = $n(commonUnit).convert__J__ju_concurrent_TimeUnit__J(otherLength_$_lo, otherLength_$_hi, otherUnit);
  var $x_2 = $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, $x_4.l, $x_4.h, $x_3.l, $x_3.h);
  var totalLength_$_lo = $x_2.l;
  var totalLength_$_hi = $x_2.h;
  return new $c_s_concurrent_duration_FiniteDuration(totalLength_$_lo, totalLength_$_hi, commonUnit);
}
/** @constructor */
function $c_s_concurrent_duration_FiniteDuration(length_$_lo, length_$_hi, unit) {
  this.s_concurrent_duration_FiniteDuration__f_length_$lo = 0;
  this.s_concurrent_duration_FiniteDuration__f_length_$hi = 0;
  this.s_concurrent_duration_FiniteDuration__f_unit = null;
  this.s_concurrent_duration_FiniteDuration__f_length_$lo = length_$_lo;
  this.s_concurrent_duration_FiniteDuration__f_length_$hi = length_$_hi;
  this.s_concurrent_duration_FiniteDuration__f_unit = unit;
  var x = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  if ((x === null)) {
    var $x_1 = (unit === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === unit);
  }
  if ($x_1) {
    var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, (-1), 2147483647);
  } else {
    var x$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$3 === null)) {
      var $x_2 = (unit === null);
    } else {
      var this$2 = $n(x$3);
      var $x_2 = (this$2 === unit);
    }
    if ($x_2) {
      var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, (-1511828489), 2147483);
    } else {
      var x$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$5 === null)) {
        var $x_3 = (unit === null);
      } else {
        var this$3 = $n(x$5);
        var $x_3 = (this$3 === unit);
      }
      if ($x_3) {
        var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 2077252342, 2147);
      } else {
        var x$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
        if ((x$7 === null)) {
          var $x_4 = (unit === null);
        } else {
          var this$4 = $n(x$7);
          var $x_4 = (this$4 === unit);
        }
        if ($x_4) {
          var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 633437444, 2);
        } else {
          var x$9 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
          if ((x$9 === null)) {
            var $x_5 = (unit === null);
          } else {
            var this$5 = $n(x$9);
            var $x_5 = (this$5 === unit);
          }
          if ($x_5) {
            var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 153722867, 0);
          } else {
            var x$11 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
            if ((x$11 === null)) {
              var $x_6 = (unit === null);
            } else {
              var this$6 = $n(x$11);
              var $x_6 = (this$6 === unit);
            }
            if ($x_6) {
              var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 2562047, 0);
            } else {
              var x$13 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
              if ((x$13 === null)) {
                var $x_7 = (unit === null);
              } else {
                var this$7 = $n(x$13);
                var $x_7 = (this$7 === unit);
              }
              if ($x_7) {
                var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, 106751, 0);
              } else {
                var $x_8 = $n($m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS).convert__J__ju_concurrent_TimeUnit__J(length_$_lo, length_$_hi, unit);
                var v_$_lo = $x_8.l;
                var v_$_hi = $x_8.h;
                var requirement = (((v_$_hi === (-1)) ? ((v_$_lo >>> 0) >= 4294860545) : (v_$_hi > (-1))) && ((v_$_hi === 0) ? ((v_$_lo >>> 0) <= 106751) : (v_$_hi < 0)));
              }
            }
          }
        }
      }
    }
  }
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Duration is limited to +-(2^63-1)ns (ca. 292 years)");
  }
}
$c_s_concurrent_duration_FiniteDuration.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_FiniteDuration.prototype.constructor = $c_s_concurrent_duration_FiniteDuration;
/** @constructor */
function $h_s_concurrent_duration_FiniteDuration() {
}
$h_s_concurrent_duration_FiniteDuration.prototype = $c_s_concurrent_duration_FiniteDuration.prototype;
$c_s_concurrent_duration_FiniteDuration.prototype.toString__T = (function() {
  return (($s_RTLong__toString__I__I__T(this.s_concurrent_duration_FiniteDuration__f_length_$lo, this.s_concurrent_duration_FiniteDuration__f_length_$hi) + " ") + $p_s_concurrent_duration_FiniteDuration__unitString__T(this));
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var $x_1 = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length_$lo, this.s_concurrent_duration_FiniteDuration__f_length_$hi);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var this$3 = new $c_sr_RichLong(x_$_lo, x_$_hi);
    var this$2 = $n(x2);
    var $x_2 = $n(this$2.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this$2.s_concurrent_duration_FiniteDuration__f_length_$lo, this$2.s_concurrent_duration_FiniteDuration__f_length_$hi);
    var y_$_lo = $x_2.l;
    var y_$_hi = $x_2.h;
    var x$1_$_lo = this$3.sr_RichLong__f_self_$lo;
    var x$1_$_hi = this$3.sr_RichLong__f_self_$hi;
    return ((x$1_$_hi === y_$_hi) ? ((x$1_$_lo === y_$_lo) ? 0 : (((x$1_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x$1_$_hi < y_$_hi) ? (-1) : 1));
  } else {
    var this$7 = $n(other);
    return ((-this$7.compare__s_concurrent_duration_Duration__I(this)) | 0);
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, $n(x2).s_concurrent_duration_FiniteDuration__f_length_$lo, $n(x2).s_concurrent_duration_FiniteDuration__f_length_$hi, $n(x2).s_concurrent_duration_FiniteDuration__f_unit);
  } else {
    return other;
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration = (function(other) {
  var x_$_lo = $n(other).s_concurrent_duration_FiniteDuration__f_length_$lo;
  var x_$_hi = $n(other).s_concurrent_duration_FiniteDuration__f_length_$hi;
  var lo = ((-x_$_lo) | 0);
  var hi = ((((-x_$_hi) | 0) + ((x_$_lo | lo) >> 31)) | 0);
  return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, lo, hi, $n(other).s_concurrent_duration_FiniteDuration__f_unit);
});
$c_s_concurrent_duration_FiniteDuration.prototype.min__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration = (function(other) {
  return ($f_s_math_Ordered__$less__O__Z(this, other) ? this : other);
});
$c_s_concurrent_duration_FiniteDuration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var $x_1 = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length_$lo, this.s_concurrent_duration_FiniteDuration__f_length_$hi);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var this$1 = $n(x2);
    var $x_2 = $n(this$1.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length_$lo, this$1.s_concurrent_duration_FiniteDuration__f_length_$hi);
    var x$1_$_lo = $x_2.l;
    var x$1_$_hi = $x_2.h;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return (this === other);
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.hashCode__I = (function() {
  var $x_1 = $n(this.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length_$lo, this.s_concurrent_duration_FiniteDuration__f_length_$hi);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  return x_$_lo;
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
function $as_s_concurrent_duration_FiniteDuration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_FiniteDuration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.FiniteDuration"));
}
function $isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_FiniteDuration)));
}
function $asArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.FiniteDuration;", depth));
}
var $d_s_concurrent_duration_FiniteDuration = new $TypeData().initClass($c_s_concurrent_duration_FiniteDuration, "scala.concurrent.duration.FiniteDuration", ({
  s_concurrent_duration_FiniteDuration: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
function $f_s_math_Ordering__gteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) >= 0);
}
function $f_s_math_Ordering__lt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) < 0);
}
function $f_s_math_Ordering__gt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) > 0);
}
function $f_s_math_Ordering__equiv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0);
}
function $f_s_math_Ordering__max__O__O__O($thiz, x, y) {
  return ($thiz.gteq__O__O__Z(x, y) ? x : y);
}
function $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z($thiz, other) {
  if ((other instanceof $c_s_math_Ordering$Reverse)) {
    var x2 = $as_s_math_Ordering$Reverse(other);
    var x = $n(x2).s_math_Ordering$Reverse__f_outer;
    return ((x !== null) && $n(x).equals__O__Z($thiz));
  } else {
    return false;
  }
}
function $is_s_math_Ordering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Ordering)));
}
function $as_s_math_Ordering(obj) {
  return (($is_s_math_Ordering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering"));
}
function $isArrayOf_s_math_Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering)));
}
function $asArrayOf_s_math_Ordering(obj, depth) {
  return (($isArrayOf_s_math_Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering;", depth));
}
function $f_s_reflect_ClassTag__equals__O__Z($thiz, x) {
  if ($is_s_reflect_ClassTag(x)) {
    var x$2 = $thiz.runtimeClass__jl_Class();
    var x$3 = $n($as_s_reflect_ClassTag(x)).runtimeClass__jl_Class();
    if ((x$2 === null)) {
      return (x$3 === null);
    } else {
      var this$1 = $n(x$2);
      return (this$1 === x$3);
    }
  } else {
    return false;
  }
}
function $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T(clazz) {
  var this$1 = $n(clazz);
  if (this$1.data.isArrayClass) {
    var this$2 = $n(clazz);
    return (("Array[" + $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this$2.data.getComponentType())) + "]");
  } else {
    var this$3 = $n(clazz);
    return this$3.data.name;
  }
}
function $is_s_reflect_ClassTag(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_reflect_ClassTag)));
}
function $as_s_reflect_ClassTag(obj) {
  return (($is_s_reflect_ClassTag(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.reflect.ClassTag"));
}
function $isArrayOf_s_reflect_ClassTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_reflect_ClassTag)));
}
function $asArrayOf_s_reflect_ClassTag(obj, depth) {
  return (($isArrayOf_s_reflect_ClassTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.reflect.ClassTag;", depth));
}
/** @constructor */
function $c_sr_ScalaRunTime$$anon$1(x$2) {
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = 0;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = null;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = x$2;
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = $n(x$2).productArity__I();
}
$c_sr_ScalaRunTime$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sr_ScalaRunTime$$anon$1.prototype.constructor = $c_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $h_sr_ScalaRunTime$$anon$1() {
}
$h_sr_ScalaRunTime$$anon$1.prototype = $c_sr_ScalaRunTime$$anon$1.prototype;
$c_sr_ScalaRunTime$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sr_ScalaRunTime$$anon$1__f_c < this.sr_ScalaRunTime$$anon$1__f_cmax);
});
$c_sr_ScalaRunTime$$anon$1.prototype.next__O = (function() {
  var result = $n(this.sr_ScalaRunTime$$anon$1__f_x$2).productElement__I__O(this.sr_ScalaRunTime$$anon$1__f_c);
  this.sr_ScalaRunTime$$anon$1__f_c = ((1 + this.sr_ScalaRunTime$$anon$1__f_c) | 0);
  return result;
});
var $d_sr_ScalaRunTime$$anon$1 = new $TypeData().initClass($c_sr_ScalaRunTime$$anon$1, "scala.runtime.ScalaRunTime$$anon$1", ({
  sr_ScalaRunTime$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sjs_js_WrappedArray$() {
}
$c_sjs_js_WrappedArray$.prototype = new $h_O();
$c_sjs_js_WrappedArray$.prototype.constructor = $c_sjs_js_WrappedArray$;
/** @constructor */
function $h_sjs_js_WrappedArray$() {
}
$h_sjs_js_WrappedArray$.prototype = $c_sjs_js_WrappedArray$.prototype;
$c_sjs_js_WrappedArray$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(elems);
});
$c_sjs_js_WrappedArray$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__sjs_js_WrappedArray = (function(source) {
  var this$1 = $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
  return $as_sjs_js_WrappedArray($n($as_scm_Builder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this$1, source))).result__O());
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(source);
});
$c_sjs_js_WrappedArray$.prototype.empty__O = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
var $d_sjs_js_WrappedArray$ = new $TypeData().initClass($c_sjs_js_WrappedArray$, "scala.scalajs.js.WrappedArray$", ({
  sjs_js_WrappedArray$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sjs_js_WrappedArray$;
function $m_sjs_js_WrappedArray$() {
  if ((!$n_sjs_js_WrappedArray$)) {
    $n_sjs_js_WrappedArray$ = new $c_sjs_js_WrappedArray$();
  }
  return $n_sjs_js_WrappedArray$;
}
/** @constructor */
function $c_sjsr_WrappedVarArgs$() {
}
$c_sjsr_WrappedVarArgs$.prototype = new $h_O();
$c_sjsr_WrappedVarArgs$.prototype.constructor = $c_sjsr_WrappedVarArgs$;
/** @constructor */
function $h_sjsr_WrappedVarArgs$() {
}
$h_sjsr_WrappedVarArgs$.prototype = $c_sjsr_WrappedVarArgs$.prototype;
$c_sjsr_WrappedVarArgs$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(elems);
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__sjsr_WrappedVarArgs = (function(source) {
  var this$1 = $n(this.newBuilder__scm_Builder());
  return $as_sjsr_WrappedVarArgs($n($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(source))).result__O());
});
$c_sjsr_WrappedVarArgs$.prototype.newBuilder__scm_Builder = (function() {
  var array = [];
  var this$3 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
    var x$1$2 = $as_sjs_js_WrappedArray(x$1$2$2);
    return $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), $n(x$1$2).sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array);
  }));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(source);
});
$c_sjsr_WrappedVarArgs$.prototype.empty__O = (function() {
  return $ct_sjsr_WrappedVarArgs__(new $c_sjsr_WrappedVarArgs());
});
var $d_sjsr_WrappedVarArgs$ = new $TypeData().initClass($c_sjsr_WrappedVarArgs$, "scala.scalajs.runtime.WrappedVarArgs$", ({
  sjsr_WrappedVarArgs$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sjsr_WrappedVarArgs$;
function $m_sjsr_WrappedVarArgs$() {
  if ((!$n_sjsr_WrappedVarArgs$)) {
    $n_sjsr_WrappedVarArgs$ = new $c_sjsr_WrappedVarArgs$();
  }
  return $n_sjsr_WrappedVarArgs$;
}
/** @constructor */
function $c_s_util_Failure(exception) {
  this.s_util_Failure__f_exception = null;
  this.s_util_Failure__f_exception = exception;
}
$c_s_util_Failure.prototype = new $h_s_util_Try();
$c_s_util_Failure.prototype.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
}
$h_s_util_Failure.prototype = $c_s_util_Failure.prototype;
$c_s_util_Failure.prototype.get__O = (function() {
  var $x_1 = $n(this.s_util_Failure__f_exception);
  throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
});
$c_s_util_Failure.prototype.getOrElse__F0__O = (function(default$1) {
  return $n(default$1).apply__O();
});
$c_s_util_Failure.prototype.foreach__F1__V = (function(f) {
});
$c_s_util_Failure.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = $n(pf).applyOrElse__O__F1__O(this.s_util_Failure__f_exception, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => {
      $as_jl_Throwable(x$2$2);
      return marker;
    })));
    return ((marker !== v) ? new $c_s_util_Success(v) : this);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
$c_s_util_Failure.prototype.toOption__s_Option = (function() {
  return $m_s_None$();
});
$c_s_util_Failure.prototype.productPrefix__T = (function() {
  return "Failure";
});
$c_s_util_Failure.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Failure.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Failure__f_exception : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Failure.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1408943127), true);
});
$c_s_util_Failure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Failure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Failure)) {
    var Failure$1 = $as_s_util_Failure(x$1);
    var x = this.s_util_Failure__f_exception;
    var x$2 = $n(Failure$1).s_util_Failure__f_exception;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
function $as_s_util_Failure(obj) {
  return (((obj instanceof $c_s_util_Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Failure"));
}
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Failure)));
}
function $asArrayOf_s_util_Failure(obj, depth) {
  return (($isArrayOf_s_util_Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Failure;", depth));
}
var $d_s_util_Failure = new $TypeData().initClass($c_s_util_Failure, "scala.util.Failure", ({
  s_util_Failure: 1,
  s_util_Try: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Left(value) {
  this.s_util_Left__f_value = null;
  this.s_util_Left__f_value = value;
}
$c_s_util_Left.prototype = new $h_s_util_Either();
$c_s_util_Left.prototype.constructor = $c_s_util_Left;
/** @constructor */
function $h_s_util_Left() {
}
$h_s_util_Left.prototype = $c_s_util_Left.prototype;
$c_s_util_Left.prototype.isRight__Z = (function() {
  return false;
});
$c_s_util_Left.prototype.productPrefix__T = (function() {
  return "Left";
});
$c_s_util_Left.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Left.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Left__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Left.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Left.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 877209692, true);
});
$c_s_util_Left.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Left.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Left)) {
    var Left$1 = $as_s_util_Left(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Left__f_value, $n(Left$1).s_util_Left__f_value);
  } else {
    return false;
  }
});
function $as_s_util_Left(obj) {
  return (((obj instanceof $c_s_util_Left) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Left"));
}
function $isArrayOf_s_util_Left(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Left)));
}
function $asArrayOf_s_util_Left(obj, depth) {
  return (($isArrayOf_s_util_Left(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Left;", depth));
}
var $d_s_util_Left = new $TypeData().initClass($c_s_util_Left, "scala.util.Left", ({
  s_util_Left: 1,
  s_util_Either: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Right(value) {
  this.s_util_Right__f_value = null;
  this.s_util_Right__f_value = value;
}
$c_s_util_Right.prototype = new $h_s_util_Either();
$c_s_util_Right.prototype.constructor = $c_s_util_Right;
/** @constructor */
function $h_s_util_Right() {
}
$h_s_util_Right.prototype = $c_s_util_Right.prototype;
$c_s_util_Right.prototype.isRight__Z = (function() {
  return true;
});
$c_s_util_Right.prototype.productPrefix__T = (function() {
  return "Right";
});
$c_s_util_Right.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Right.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Right__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Right.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Right.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 252890491, true);
});
$c_s_util_Right.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Right.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Right)) {
    var Right$1 = $as_s_util_Right(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Right__f_value, $n(Right$1).s_util_Right__f_value);
  } else {
    return false;
  }
});
function $as_s_util_Right(obj) {
  return (((obj instanceof $c_s_util_Right) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Right"));
}
function $isArrayOf_s_util_Right(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Right)));
}
function $asArrayOf_s_util_Right(obj, depth) {
  return (($isArrayOf_s_util_Right(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Right;", depth));
}
var $d_s_util_Right = new $TypeData().initClass($c_s_util_Right, "scala.util.Right", ({
  s_util_Right: 1,
  s_util_Either: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_util_Success(value) {
  this.s_util_Success__f_value = null;
  this.s_util_Success__f_value = value;
}
$c_s_util_Success.prototype = new $h_s_util_Try();
$c_s_util_Success.prototype.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
}
$h_s_util_Success.prototype = $c_s_util_Success.prototype;
$c_s_util_Success.prototype.get__O = (function() {
  return this.s_util_Success__f_value;
});
$c_s_util_Success.prototype.getOrElse__F0__O = (function(default$1) {
  return this.s_util_Success__f_value;
});
$c_s_util_Success.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.s_util_Success__f_value);
});
$c_s_util_Success.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  return this;
});
$c_s_util_Success.prototype.toOption__s_Option = (function() {
  return new $c_s_Some(this.s_util_Success__f_value);
});
$c_s_util_Success.prototype.productPrefix__T = (function() {
  return "Success";
});
$c_s_util_Success.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Success.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Success__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Success.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1750213842), true);
});
$c_s_util_Success.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Success.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Success)) {
    var Success$1 = $as_s_util_Success(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Success__f_value, $n(Success$1).s_util_Success__f_value);
  } else {
    return false;
  }
});
function $as_s_util_Success(obj) {
  return (((obj instanceof $c_s_util_Success) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Success"));
}
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Success)));
}
function $asArrayOf_s_util_Success(obj, depth) {
  return (($isArrayOf_s_util_Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Success;", depth));
}
var $d_s_util_Success = new $TypeData().initClass($c_s_util_Success, "scala.util.Success", ({
  s_util_Success: 1,
  s_util_Try: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lsnabbdom_AttrValue$BooleanAttrValue(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.AttrValue$BooleanAttrValue"));
}
function $isArrayOf_Lsnabbdom_AttrValue$BooleanAttrValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_AttrValue$BooleanAttrValue)));
}
function $asArrayOf_Lsnabbdom_AttrValue$BooleanAttrValue(obj, depth) {
  return (($isArrayOf_Lsnabbdom_AttrValue$BooleanAttrValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.AttrValue$BooleanAttrValue;", depth));
}
/** @constructor */
function $c_Lsnabbdom_AttrValue$StringAttrValue(value) {
  this.Lsnabbdom_AttrValue$StringAttrValue__f_value = null;
  this.Lsnabbdom_AttrValue$StringAttrValue__f_value = value;
}
$c_Lsnabbdom_AttrValue$StringAttrValue.prototype = new $h_O();
$c_Lsnabbdom_AttrValue$StringAttrValue.prototype.constructor = $c_Lsnabbdom_AttrValue$StringAttrValue;
/** @constructor */
function $h_Lsnabbdom_AttrValue$StringAttrValue() {
}
$h_Lsnabbdom_AttrValue$StringAttrValue.prototype = $c_Lsnabbdom_AttrValue$StringAttrValue.prototype;
$c_Lsnabbdom_AttrValue$StringAttrValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_AttrValue$StringAttrValue.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_AttrValue$StringAttrValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_AttrValue$StringAttrValue)) {
    var x$0$2 = $as_Lsnabbdom_AttrValue$StringAttrValue(x$0);
    return (this.Lsnabbdom_AttrValue$StringAttrValue__f_value === $n(x$0$2).Lsnabbdom_AttrValue$StringAttrValue__f_value);
  } else {
    return false;
  }
});
$c_Lsnabbdom_AttrValue$StringAttrValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_AttrValue$StringAttrValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsnabbdom_AttrValue$StringAttrValue.prototype.productPrefix__T = (function() {
  return "StringAttrValue";
});
$c_Lsnabbdom_AttrValue$StringAttrValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsnabbdom_AttrValue$StringAttrValue__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lsnabbdom_AttrValue$StringAttrValue(obj) {
  return (((obj instanceof $c_Lsnabbdom_AttrValue$StringAttrValue) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.AttrValue$StringAttrValue"));
}
function $isArrayOf_Lsnabbdom_AttrValue$StringAttrValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_AttrValue$StringAttrValue)));
}
function $asArrayOf_Lsnabbdom_AttrValue$StringAttrValue(obj, depth) {
  return (($isArrayOf_Lsnabbdom_AttrValue$StringAttrValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.AttrValue$StringAttrValue;", depth));
}
var $d_Lsnabbdom_AttrValue$StringAttrValue = new $TypeData().initClass($c_Lsnabbdom_AttrValue$StringAttrValue, "snabbdom.AttrValue$StringAttrValue", ({
  Lsnabbdom_AttrValue$StringAttrValue: 1,
  Lsnabbdom_AttrValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_PatchedVNode$Comment(content, node) {
  this.Lsnabbdom_PatchedVNode$Comment__f_content = null;
  this.Lsnabbdom_PatchedVNode$Comment__f_node = null;
  this.Lsnabbdom_PatchedVNode$Comment__f_content = content;
  this.Lsnabbdom_PatchedVNode$Comment__f_node = node;
}
$c_Lsnabbdom_PatchedVNode$Comment.prototype = new $h_O();
$c_Lsnabbdom_PatchedVNode$Comment.prototype.constructor = $c_Lsnabbdom_PatchedVNode$Comment;
/** @constructor */
function $h_Lsnabbdom_PatchedVNode$Comment() {
}
$h_Lsnabbdom_PatchedVNode$Comment.prototype = $c_Lsnabbdom_PatchedVNode$Comment.prototype;
$c_Lsnabbdom_PatchedVNode$Comment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_PatchedVNode$Comment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_PatchedVNode$Comment.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_PatchedVNode$Comment)) {
    var x$0$2 = $as_Lsnabbdom_PatchedVNode$Comment(x$0);
    if ((this.Lsnabbdom_PatchedVNode$Comment__f_content === $n(x$0$2).Lsnabbdom_PatchedVNode$Comment__f_content)) {
      var x = this.Lsnabbdom_PatchedVNode$Comment__f_node;
      var y = $n(x$0$2).Lsnabbdom_PatchedVNode$Comment__f_node;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_PatchedVNode$Comment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_PatchedVNode$Comment.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsnabbdom_PatchedVNode$Comment.prototype.productPrefix__T = (function() {
  return "Comment";
});
$c_Lsnabbdom_PatchedVNode$Comment.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsnabbdom_PatchedVNode$Comment__f_content;
  }
  if ((n === 1)) {
    return this.Lsnabbdom_PatchedVNode$Comment__f_node;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsnabbdom_PatchedVNode$Comment.prototype.toVNode__Lsnabbdom_VNode = (function() {
  $m_Lsnabbdom_VNode$();
  var content = this.Lsnabbdom_PatchedVNode$Comment__f_content;
  return new $c_Lsnabbdom_VNode$Comment(content);
});
$c_Lsnabbdom_PatchedVNode$Comment.prototype.node__Lorg_scalajs_dom_Node = (function() {
  return this.Lsnabbdom_PatchedVNode$Comment__f_node;
});
function $as_Lsnabbdom_PatchedVNode$Comment(obj) {
  return (((obj instanceof $c_Lsnabbdom_PatchedVNode$Comment) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PatchedVNode$Comment"));
}
function $isArrayOf_Lsnabbdom_PatchedVNode$Comment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PatchedVNode$Comment)));
}
function $asArrayOf_Lsnabbdom_PatchedVNode$Comment(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PatchedVNode$Comment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PatchedVNode$Comment;", depth));
}
var $d_Lsnabbdom_PatchedVNode$Comment = new $TypeData().initClass($c_Lsnabbdom_PatchedVNode$Comment, "snabbdom.PatchedVNode$Comment", ({
  Lsnabbdom_PatchedVNode$Comment: 1,
  Lsnabbdom_PatchedVNode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $p_Lsnabbdom_PatchedVNode$Element__handleEvent__Lorg_scalajs_dom_Event__V($thiz, event) {
  var name = $as_T(event.type);
  var this$1 = $n($n($n($thiz.Lsnabbdom_PatchedVNode$Element__f_data).Lsnabbdom_VNodeData__f_on).get__O__s_Option(name));
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    var handler = $as_Lsnabbdom_EventHandler(x0);
    $n($n(handler).Lsnabbdom_EventHandler__f_cbs).foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
      var _$1$1 = $as_F2(_$1);
      $n(_$1$1).apply__O__O__O(event, $thiz.toVNode__Lsnabbdom_VNode());
    })));
  }
}
/** @constructor */
function $c_Lsnabbdom_PatchedVNode$Element(sel, data, children, node) {
  this.Lsnabbdom_PatchedVNode$Element__f_sel = null;
  this.Lsnabbdom_PatchedVNode$Element__f_data = null;
  this.Lsnabbdom_PatchedVNode$Element__f_children = null;
  this.Lsnabbdom_PatchedVNode$Element__f_node = null;
  this.Lsnabbdom_PatchedVNode$Element__f_listener$lzy1 = null;
  this.Lsnabbdom_PatchedVNode$Element__f_listenerbitmap$1 = false;
  this.Lsnabbdom_PatchedVNode$Element__f_sel = sel;
  this.Lsnabbdom_PatchedVNode$Element__f_data = data;
  this.Lsnabbdom_PatchedVNode$Element__f_children = children;
  this.Lsnabbdom_PatchedVNode$Element__f_node = node;
}
$c_Lsnabbdom_PatchedVNode$Element.prototype = new $h_O();
$c_Lsnabbdom_PatchedVNode$Element.prototype.constructor = $c_Lsnabbdom_PatchedVNode$Element;
/** @constructor */
function $h_Lsnabbdom_PatchedVNode$Element() {
}
$h_Lsnabbdom_PatchedVNode$Element.prototype = $c_Lsnabbdom_PatchedVNode$Element.prototype;
$c_Lsnabbdom_PatchedVNode$Element.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_PatchedVNode$Element.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_PatchedVNode$Element.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_PatchedVNode$Element)) {
    var x$0$2 = $as_Lsnabbdom_PatchedVNode$Element(x$0);
    if ((this.Lsnabbdom_PatchedVNode$Element__f_sel === $n(x$0$2).Lsnabbdom_PatchedVNode$Element__f_sel)) {
      var x = this.Lsnabbdom_PatchedVNode$Element__f_data;
      var x$2 = $n(x$0$2).Lsnabbdom_PatchedVNode$Element__f_data;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lsnabbdom_PatchedVNode$Element__f_children;
      var x$4 = $n(x$0$2).Lsnabbdom_PatchedVNode$Element__f_children;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$1 = this.Lsnabbdom_PatchedVNode$Element__f_node;
      var y = $n(x$0$2).Lsnabbdom_PatchedVNode$Element__f_node;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_PatchedVNode$Element.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_PatchedVNode$Element.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsnabbdom_PatchedVNode$Element.prototype.productPrefix__T = (function() {
  return "Element";
});
$c_Lsnabbdom_PatchedVNode$Element.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_PatchedVNode$Element__f_sel;
      break;
    }
    case 1: {
      return this.Lsnabbdom_PatchedVNode$Element__f_data;
      break;
    }
    case 2: {
      return this.Lsnabbdom_PatchedVNode$Element__f_children;
      break;
    }
    case 3: {
      return this.Lsnabbdom_PatchedVNode$Element__f_node;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsnabbdom_PatchedVNode$Element.prototype.listener__sjs_js_Function1 = (function() {
  if ((!this.Lsnabbdom_PatchedVNode$Element__f_listenerbitmap$1)) {
    this.Lsnabbdom_PatchedVNode$Element__f_listener$lzy1 = ((event) => {
      $p_Lsnabbdom_PatchedVNode$Element__handleEvent__Lorg_scalajs_dom_Event__V(this, event);
    });
    this.Lsnabbdom_PatchedVNode$Element__f_listenerbitmap$1 = true;
  }
  return this.Lsnabbdom_PatchedVNode$Element__f_listener$lzy1;
});
$c_Lsnabbdom_PatchedVNode$Element.prototype.toVNode__Lsnabbdom_VNode = (function() {
  var sel = this.Lsnabbdom_PatchedVNode$Element__f_sel;
  var data = this.Lsnabbdom_PatchedVNode$Element__f_data;
  var this$2 = $n(this.Lsnabbdom_PatchedVNode$Element__f_children);
  var f = ((_$2) => {
    var _$2$1 = $as_Lsnabbdom_PatchedVNode(_$2);
    return $n(_$2$1).toVNode__Lsnabbdom_VNode();
  });
  if ((this$2 === $m_sci_Nil$())) {
    var children = $m_sci_Nil$();
  } else {
    var x0 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = $n(rest).head__O();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    var children = h;
  }
  return new $c_Lsnabbdom_VNode$Element(sel, data, children);
});
$c_Lsnabbdom_PatchedVNode$Element.prototype.node__Lorg_scalajs_dom_Node = (function() {
  return this.Lsnabbdom_PatchedVNode$Element__f_node;
});
function $as_Lsnabbdom_PatchedVNode$Element(obj) {
  return (((obj instanceof $c_Lsnabbdom_PatchedVNode$Element) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PatchedVNode$Element"));
}
function $isArrayOf_Lsnabbdom_PatchedVNode$Element(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PatchedVNode$Element)));
}
function $asArrayOf_Lsnabbdom_PatchedVNode$Element(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PatchedVNode$Element(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PatchedVNode$Element;", depth));
}
var $d_Lsnabbdom_PatchedVNode$Element = new $TypeData().initClass($c_Lsnabbdom_PatchedVNode$Element, "snabbdom.PatchedVNode$Element", ({
  Lsnabbdom_PatchedVNode$Element: 1,
  Lsnabbdom_PatchedVNode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_PatchedVNode$Text(content, node) {
  this.Lsnabbdom_PatchedVNode$Text__f_content = null;
  this.Lsnabbdom_PatchedVNode$Text__f_node = null;
  this.Lsnabbdom_PatchedVNode$Text__f_content = content;
  this.Lsnabbdom_PatchedVNode$Text__f_node = node;
}
$c_Lsnabbdom_PatchedVNode$Text.prototype = new $h_O();
$c_Lsnabbdom_PatchedVNode$Text.prototype.constructor = $c_Lsnabbdom_PatchedVNode$Text;
/** @constructor */
function $h_Lsnabbdom_PatchedVNode$Text() {
}
$h_Lsnabbdom_PatchedVNode$Text.prototype = $c_Lsnabbdom_PatchedVNode$Text.prototype;
$c_Lsnabbdom_PatchedVNode$Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_PatchedVNode$Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_PatchedVNode$Text.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_PatchedVNode$Text)) {
    var x$0$2 = $as_Lsnabbdom_PatchedVNode$Text(x$0);
    if ((this.Lsnabbdom_PatchedVNode$Text__f_content === $n(x$0$2).Lsnabbdom_PatchedVNode$Text__f_content)) {
      var x = this.Lsnabbdom_PatchedVNode$Text__f_node;
      var y = $n(x$0$2).Lsnabbdom_PatchedVNode$Text__f_node;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_PatchedVNode$Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_PatchedVNode$Text.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsnabbdom_PatchedVNode$Text.prototype.productPrefix__T = (function() {
  return "Text";
});
$c_Lsnabbdom_PatchedVNode$Text.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsnabbdom_PatchedVNode$Text__f_content;
  }
  if ((n === 1)) {
    return this.Lsnabbdom_PatchedVNode$Text__f_node;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsnabbdom_PatchedVNode$Text.prototype.toVNode__Lsnabbdom_VNode = (function() {
  var content = this.Lsnabbdom_PatchedVNode$Text__f_content;
  return new $c_Lsnabbdom_VNode$Text(content);
});
$c_Lsnabbdom_PatchedVNode$Text.prototype.node__Lorg_scalajs_dom_Node = (function() {
  return this.Lsnabbdom_PatchedVNode$Text__f_node;
});
function $as_Lsnabbdom_PatchedVNode$Text(obj) {
  return (((obj instanceof $c_Lsnabbdom_PatchedVNode$Text) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PatchedVNode$Text"));
}
function $isArrayOf_Lsnabbdom_PatchedVNode$Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PatchedVNode$Text)));
}
function $asArrayOf_Lsnabbdom_PatchedVNode$Text(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PatchedVNode$Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PatchedVNode$Text;", depth));
}
var $d_Lsnabbdom_PatchedVNode$Text = new $TypeData().initClass($c_Lsnabbdom_PatchedVNode$Text, "snabbdom.PatchedVNode$Text", ({
  Lsnabbdom_PatchedVNode$Text: 1,
  Lsnabbdom_PatchedVNode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_VNode$Comment(content) {
  this.Lsnabbdom_VNode$Comment__f_content = null;
  this.Lsnabbdom_VNode$Comment__f_content = content;
}
$c_Lsnabbdom_VNode$Comment.prototype = new $h_O();
$c_Lsnabbdom_VNode$Comment.prototype.constructor = $c_Lsnabbdom_VNode$Comment;
/** @constructor */
function $h_Lsnabbdom_VNode$Comment() {
}
$h_Lsnabbdom_VNode$Comment.prototype = $c_Lsnabbdom_VNode$Comment.prototype;
$c_Lsnabbdom_VNode$Comment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_VNode$Comment.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_VNode$Comment.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_VNode$Comment)) {
    var x$0$2 = $as_Lsnabbdom_VNode$Comment(x$0);
    return (this.Lsnabbdom_VNode$Comment__f_content === $n(x$0$2).Lsnabbdom_VNode$Comment__f_content);
  } else {
    return false;
  }
});
$c_Lsnabbdom_VNode$Comment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_VNode$Comment.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsnabbdom_VNode$Comment.prototype.productPrefix__T = (function() {
  return "Comment";
});
$c_Lsnabbdom_VNode$Comment.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsnabbdom_VNode$Comment__f_content;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lsnabbdom_VNode$Comment(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNode$Comment) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNode$Comment"));
}
function $isArrayOf_Lsnabbdom_VNode$Comment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNode$Comment)));
}
function $asArrayOf_Lsnabbdom_VNode$Comment(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNode$Comment(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNode$Comment;", depth));
}
var $d_Lsnabbdom_VNode$Comment = new $TypeData().initClass($c_Lsnabbdom_VNode$Comment, "snabbdom.VNode$Comment", ({
  Lsnabbdom_VNode$Comment: 1,
  Lsnabbdom_VNode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_VNode$Element(sel, data, children) {
  this.Lsnabbdom_VNode$Element__f_sel = null;
  this.Lsnabbdom_VNode$Element__f_data = null;
  this.Lsnabbdom_VNode$Element__f_children = null;
  this.Lsnabbdom_VNode$Element__f_sel = sel;
  this.Lsnabbdom_VNode$Element__f_data = data;
  this.Lsnabbdom_VNode$Element__f_children = children;
}
$c_Lsnabbdom_VNode$Element.prototype = new $h_O();
$c_Lsnabbdom_VNode$Element.prototype.constructor = $c_Lsnabbdom_VNode$Element;
/** @constructor */
function $h_Lsnabbdom_VNode$Element() {
}
$h_Lsnabbdom_VNode$Element.prototype = $c_Lsnabbdom_VNode$Element.prototype;
$c_Lsnabbdom_VNode$Element.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_VNode$Element.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_VNode$Element.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_VNode$Element)) {
    var x$0$2 = $as_Lsnabbdom_VNode$Element(x$0);
    if ((this.Lsnabbdom_VNode$Element__f_sel === $n(x$0$2).Lsnabbdom_VNode$Element__f_sel)) {
      var x = this.Lsnabbdom_VNode$Element__f_data;
      var x$2 = $n(x$0$2).Lsnabbdom_VNode$Element__f_data;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsnabbdom_VNode$Element__f_children;
      var x$4 = $n(x$0$2).Lsnabbdom_VNode$Element__f_children;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsnabbdom_VNode$Element.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_VNode$Element.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsnabbdom_VNode$Element.prototype.productPrefix__T = (function() {
  return "Element";
});
$c_Lsnabbdom_VNode$Element.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_VNode$Element__f_sel;
      break;
    }
    case 1: {
      return this.Lsnabbdom_VNode$Element__f_data;
      break;
    }
    case 2: {
      return this.Lsnabbdom_VNode$Element__f_children;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Lsnabbdom_VNode$Element(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNode$Element) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNode$Element"));
}
function $isArrayOf_Lsnabbdom_VNode$Element(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNode$Element)));
}
function $asArrayOf_Lsnabbdom_VNode$Element(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNode$Element(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNode$Element;", depth));
}
var $d_Lsnabbdom_VNode$Element = new $TypeData().initClass($c_Lsnabbdom_VNode$Element, "snabbdom.VNode$Element", ({
  Lsnabbdom_VNode$Element: 1,
  Lsnabbdom_VNode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lsnabbdom_VNode$Text(content) {
  this.Lsnabbdom_VNode$Text__f_content = null;
  this.Lsnabbdom_VNode$Text__f_content = content;
}
$c_Lsnabbdom_VNode$Text.prototype = new $h_O();
$c_Lsnabbdom_VNode$Text.prototype.constructor = $c_Lsnabbdom_VNode$Text;
/** @constructor */
function $h_Lsnabbdom_VNode$Text() {
}
$h_Lsnabbdom_VNode$Text.prototype = $c_Lsnabbdom_VNode$Text.prototype;
$c_Lsnabbdom_VNode$Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsnabbdom_VNode$Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lsnabbdom_VNode$Text.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsnabbdom_VNode$Text)) {
    var x$0$2 = $as_Lsnabbdom_VNode$Text(x$0);
    return (this.Lsnabbdom_VNode$Text__f_content === $n(x$0$2).Lsnabbdom_VNode$Text__f_content);
  } else {
    return false;
  }
});
$c_Lsnabbdom_VNode$Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsnabbdom_VNode$Text.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsnabbdom_VNode$Text.prototype.productPrefix__T = (function() {
  return "Text";
});
$c_Lsnabbdom_VNode$Text.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsnabbdom_VNode$Text__f_content;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lsnabbdom_VNode$Text(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNode$Text) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNode$Text"));
}
function $isArrayOf_Lsnabbdom_VNode$Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNode$Text)));
}
function $asArrayOf_Lsnabbdom_VNode$Text(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNode$Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNode$Text;", depth));
}
var $d_Lsnabbdom_VNode$Text = new $TypeData().initClass($c_Lsnabbdom_VNode$Text, "snabbdom.VNode$Text", ({
  Lsnabbdom_VNode$Text: 1,
  Lsnabbdom_VNode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Attribute(name, value) {
  this.Ltyrian_Attribute__f_name = null;
  this.Ltyrian_Attribute__f_value = null;
  this.Ltyrian_Attribute__f_name = name;
  this.Ltyrian_Attribute__f_value = value;
}
$c_Ltyrian_Attribute.prototype = new $h_O();
$c_Ltyrian_Attribute.prototype.constructor = $c_Ltyrian_Attribute;
/** @constructor */
function $h_Ltyrian_Attribute() {
}
$h_Ltyrian_Attribute.prototype = $c_Ltyrian_Attribute.prototype;
$c_Ltyrian_Attribute.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(this);
});
$c_Ltyrian_Attribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Attribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Attribute.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Attribute)) {
    var x$0$2 = $as_Ltyrian_Attribute(x$0);
    return ((this.Ltyrian_Attribute__f_name === $n(x$0$2).Ltyrian_Attribute__f_name) && (this.Ltyrian_Attribute__f_value === $n(x$0$2).Ltyrian_Attribute__f_value));
  } else {
    return false;
  }
});
$c_Ltyrian_Attribute.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_Attribute.prototype.productPrefix__T = (function() {
  return "Attribute";
});
$c_Ltyrian_Attribute.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Attribute__f_name;
  }
  if ((n === 1)) {
    return this.Ltyrian_Attribute__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_Attribute(obj) {
  return (((obj instanceof $c_Ltyrian_Attribute) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Attribute"));
}
function $isArrayOf_Ltyrian_Attribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Attribute)));
}
function $asArrayOf_Ltyrian_Attribute(obj, depth) {
  return (($isArrayOf_Ltyrian_Attribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Attribute;", depth));
}
var $d_Ltyrian_Attribute = new $TypeData().initClass($c_Ltyrian_Attribute, "tyrian.Attribute", ({
  Ltyrian_Attribute: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Cmd$Batch(cmds) {
  this.Ltyrian_Cmd$Batch__f_cmds = null;
  this.Ltyrian_Cmd$Batch__f_cmds = cmds;
}
$c_Ltyrian_Cmd$Batch.prototype = new $h_O();
$c_Ltyrian_Cmd$Batch.prototype.constructor = $c_Ltyrian_Cmd$Batch;
/** @constructor */
function $h_Ltyrian_Cmd$Batch() {
}
$h_Ltyrian_Cmd$Batch.prototype = $c_Ltyrian_Cmd$Batch.prototype;
$c_Ltyrian_Cmd$Batch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Cmd$Batch.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Cmd$Batch.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Batch)) {
    var x$0$2 = $as_Ltyrian_Cmd$Batch(x$0);
    var x = this.Ltyrian_Cmd$Batch__f_cmds;
    var x$2 = $n(x$0$2).Ltyrian_Cmd$Batch__f_cmds;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Cmd$Batch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Cmd$Batch.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Cmd$Batch.prototype.productPrefix__T = (function() {
  return "Batch";
});
$c_Ltyrian_Cmd$Batch.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Batch__f_cmds;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_Cmd$Batch(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Batch) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Batch"));
}
function $isArrayOf_Ltyrian_Cmd$Batch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Batch)));
}
function $asArrayOf_Ltyrian_Cmd$Batch(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Batch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Batch;", depth));
}
var $d_Ltyrian_Cmd$Batch = new $TypeData().initClass($c_Ltyrian_Cmd$Batch, "tyrian.Cmd$Batch", ({
  Ltyrian_Cmd$Batch: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Cmd$Combine(cmd1, cmd2) {
  this.Ltyrian_Cmd$Combine__f_cmd1 = null;
  this.Ltyrian_Cmd$Combine__f_cmd2 = null;
  this.Ltyrian_Cmd$Combine__f_cmd1 = cmd1;
  this.Ltyrian_Cmd$Combine__f_cmd2 = cmd2;
}
$c_Ltyrian_Cmd$Combine.prototype = new $h_O();
$c_Ltyrian_Cmd$Combine.prototype.constructor = $c_Ltyrian_Cmd$Combine;
/** @constructor */
function $h_Ltyrian_Cmd$Combine() {
}
$h_Ltyrian_Cmd$Combine.prototype = $c_Ltyrian_Cmd$Combine.prototype;
$c_Ltyrian_Cmd$Combine.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Cmd$Combine.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Cmd$Combine.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Combine)) {
    var x$0$2 = $as_Ltyrian_Cmd$Combine(x$0);
    var x = this.Ltyrian_Cmd$Combine__f_cmd1;
    var x$2 = $n(x$0$2).Ltyrian_Cmd$Combine__f_cmd1;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_Cmd$Combine__f_cmd2;
      var x$4 = $n(x$0$2).Ltyrian_Cmd$Combine__f_cmd2;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Cmd$Combine.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Cmd$Combine.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_Cmd$Combine.prototype.productPrefix__T = (function() {
  return "Combine";
});
$c_Ltyrian_Cmd$Combine.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Combine__f_cmd1;
  }
  if ((n === 1)) {
    return this.Ltyrian_Cmd$Combine__f_cmd2;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_Cmd$Combine(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Combine) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Combine"));
}
function $isArrayOf_Ltyrian_Cmd$Combine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Combine)));
}
function $asArrayOf_Ltyrian_Cmd$Combine(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Combine(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Combine;", depth));
}
var $d_Ltyrian_Cmd$Combine = new $TypeData().initClass($c_Ltyrian_Cmd$Combine, "tyrian.Cmd$Combine", ({
  Ltyrian_Cmd$Combine: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Cmd$Emit(msg) {
  this.Ltyrian_Cmd$Emit__f_msg = null;
  this.Ltyrian_Cmd$Emit__f_msg = msg;
}
$c_Ltyrian_Cmd$Emit.prototype = new $h_O();
$c_Ltyrian_Cmd$Emit.prototype.constructor = $c_Ltyrian_Cmd$Emit;
/** @constructor */
function $h_Ltyrian_Cmd$Emit() {
}
$h_Ltyrian_Cmd$Emit.prototype = $c_Ltyrian_Cmd$Emit.prototype;
$c_Ltyrian_Cmd$Emit.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Cmd$Emit.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Cmd$Emit.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Emit)) {
    var x$0$2 = $as_Ltyrian_Cmd$Emit(x$0);
    var x = this.Ltyrian_Cmd$Emit__f_msg;
    var y = $n(x$0$2).Ltyrian_Cmd$Emit__f_msg;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Ltyrian_Cmd$Emit.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Cmd$Emit.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Cmd$Emit.prototype.productPrefix__T = (function() {
  return "Emit";
});
$c_Ltyrian_Cmd$Emit.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Emit__f_msg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Cmd$Emit.prototype.toTask__Lcats_Applicative__O = (function(evidence$1) {
  return $n(evidence$1).pure__O__O(this.Ltyrian_Cmd$Emit__f_msg);
});
function $as_Ltyrian_Cmd$Emit(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Emit) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Emit"));
}
function $isArrayOf_Ltyrian_Cmd$Emit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Emit)));
}
function $asArrayOf_Ltyrian_Cmd$Emit(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Emit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Emit;", depth));
}
var $d_Ltyrian_Cmd$Emit = new $TypeData().initClass($c_Ltyrian_Cmd$Emit, "tyrian.Cmd$Emit", ({
  Ltyrian_Cmd$Emit: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Cmd$Run(task, toMsg, evidence$1) {
  this.Ltyrian_Cmd$Run__f_task = null;
  this.Ltyrian_Cmd$Run__f_toMsg = null;
  this.Ltyrian_Cmd$Run__f_evidence$1 = null;
  this.Ltyrian_Cmd$Run__f_task = task;
  this.Ltyrian_Cmd$Run__f_toMsg = toMsg;
  this.Ltyrian_Cmd$Run__f_evidence$1 = evidence$1;
}
$c_Ltyrian_Cmd$Run.prototype = new $h_O();
$c_Ltyrian_Cmd$Run.prototype.constructor = $c_Ltyrian_Cmd$Run;
/** @constructor */
function $h_Ltyrian_Cmd$Run() {
}
$h_Ltyrian_Cmd$Run.prototype = $c_Ltyrian_Cmd$Run.prototype;
$c_Ltyrian_Cmd$Run.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Cmd$Run.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Cmd$Run.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Run)) {
    var x$0$2 = $as_Ltyrian_Cmd$Run(x$0);
    var x = this.Ltyrian_Cmd$Run__f_task;
    var y = $n(x$0$2).Ltyrian_Cmd$Run__f_task;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Ltyrian_Cmd$Run__f_toMsg;
      var x$2 = $n(x$0$2).Ltyrian_Cmd$Run__f_toMsg;
      return ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Cmd$Run.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Cmd$Run.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_Cmd$Run.prototype.productPrefix__T = (function() {
  return "Run";
});
$c_Ltyrian_Cmd$Run.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Run__f_task;
  }
  if ((n === 1)) {
    return this.Ltyrian_Cmd$Run__f_toMsg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Cmd$Run.prototype.toTask__O = (function() {
  var instance = this.Ltyrian_Cmd$Run__f_evidence$1;
  return $n(instance).map__O__F1__O(this.Ltyrian_Cmd$Run__f_task, this.Ltyrian_Cmd$Run__f_toMsg);
});
function $as_Ltyrian_Cmd$Run(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Run) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Run"));
}
function $isArrayOf_Ltyrian_Cmd$Run(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Run)));
}
function $asArrayOf_Ltyrian_Cmd$Run(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Run(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Run;", depth));
}
var $d_Ltyrian_Cmd$Run = new $TypeData().initClass($c_Ltyrian_Cmd$Run, "tyrian.Cmd$Run", ({
  Ltyrian_Cmd$Run: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Cmd$SideEffect(task, evidence$1) {
  this.Ltyrian_Cmd$SideEffect__f_task = null;
  this.Ltyrian_Cmd$SideEffect__f_evidence$1 = null;
  this.Ltyrian_Cmd$SideEffect__f_task = task;
  this.Ltyrian_Cmd$SideEffect__f_evidence$1 = evidence$1;
}
$c_Ltyrian_Cmd$SideEffect.prototype = new $h_O();
$c_Ltyrian_Cmd$SideEffect.prototype.constructor = $c_Ltyrian_Cmd$SideEffect;
/** @constructor */
function $h_Ltyrian_Cmd$SideEffect() {
}
$h_Ltyrian_Cmd$SideEffect.prototype = $c_Ltyrian_Cmd$SideEffect.prototype;
$c_Ltyrian_Cmd$SideEffect.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Cmd$SideEffect.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Cmd$SideEffect.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$SideEffect)) {
    var x$0$2 = $as_Ltyrian_Cmd$SideEffect(x$0);
    var x = this.Ltyrian_Cmd$SideEffect__f_task;
    var y = $n(x$0$2).Ltyrian_Cmd$SideEffect__f_task;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Ltyrian_Cmd$SideEffect.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Cmd$SideEffect.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Cmd$SideEffect.prototype.productPrefix__T = (function() {
  return "SideEffect";
});
$c_Ltyrian_Cmd$SideEffect.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$SideEffect__f_task;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Cmd$SideEffect.prototype.toTask__O = (function() {
  var F = this.Ltyrian_Cmd$SideEffect__f_evidence$1;
  var this$3 = $n(F);
  var fa = this.Ltyrian_Cmd$SideEffect__f_task;
  var F$1 = this.Ltyrian_Cmd$SideEffect__f_evidence$1;
  var fb = $n(F$1).unit__O();
  return this$3.productR__O__O__O(fa, fb);
});
function $as_Ltyrian_Cmd$SideEffect(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$SideEffect) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$SideEffect"));
}
function $isArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$SideEffect)));
}
function $asArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$SideEffect;", depth));
}
var $d_Ltyrian_Cmd$SideEffect = new $TypeData().initClass($c_Ltyrian_Cmd$SideEffect, "tyrian.Cmd$SideEffect", ({
  Ltyrian_Cmd$SideEffect: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Event(name, msg, preventDefault, stopPropagation, stopImmediatePropagation) {
  this.Ltyrian_Event__f_name = null;
  this.Ltyrian_Event__f_msg = null;
  this.Ltyrian_Event__f_preventDefault = false;
  this.Ltyrian_Event__f_stopPropagation = false;
  this.Ltyrian_Event__f_stopImmediatePropagation = false;
  this.Ltyrian_Event__f_name = name;
  this.Ltyrian_Event__f_msg = msg;
  this.Ltyrian_Event__f_preventDefault = preventDefault;
  this.Ltyrian_Event__f_stopPropagation = stopPropagation;
  this.Ltyrian_Event__f_stopImmediatePropagation = stopImmediatePropagation;
}
$c_Ltyrian_Event.prototype = new $h_O();
$c_Ltyrian_Event.prototype.constructor = $c_Ltyrian_Event;
/** @constructor */
function $h_Ltyrian_Event() {
}
$h_Ltyrian_Event.prototype = $c_Ltyrian_Event.prototype;
$c_Ltyrian_Event.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(this);
});
$c_Ltyrian_Event.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Event.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Event");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Ltyrian_Event__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Ltyrian_Event__f_msg;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Ltyrian_Event__f_preventDefault ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Ltyrian_Event__f_stopPropagation ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Ltyrian_Event__f_stopImmediatePropagation ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5);
});
$c_Ltyrian_Event.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Event)) {
    var x$0$2 = $as_Ltyrian_Event(x$0);
    if (((((this.Ltyrian_Event__f_preventDefault === $n(x$0$2).Ltyrian_Event__f_preventDefault) && (this.Ltyrian_Event__f_stopPropagation === $n(x$0$2).Ltyrian_Event__f_stopPropagation)) && (this.Ltyrian_Event__f_stopImmediatePropagation === $n(x$0$2).Ltyrian_Event__f_stopImmediatePropagation)) && (this.Ltyrian_Event__f_name === $n(x$0$2).Ltyrian_Event__f_name))) {
      var x = this.Ltyrian_Event__f_msg;
      var x$2 = $n(x$0$2).Ltyrian_Event__f_msg;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Event.prototype.productArity__I = (function() {
  return 5;
});
$c_Ltyrian_Event.prototype.productPrefix__T = (function() {
  return "Event";
});
$c_Ltyrian_Event.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_Event__f_name;
      break;
    }
    case 1: {
      return this.Ltyrian_Event__f_msg;
      break;
    }
    case 2: {
      return this.Ltyrian_Event__f_preventDefault;
      break;
    }
    case 3: {
      return this.Ltyrian_Event__f_stopPropagation;
      break;
    }
    case 4: {
      return this.Ltyrian_Event__f_stopImmediatePropagation;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_Event(obj) {
  return (((obj instanceof $c_Ltyrian_Event) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Event"));
}
function $isArrayOf_Ltyrian_Event(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Event)));
}
function $asArrayOf_Ltyrian_Event(obj, depth) {
  return (($isArrayOf_Ltyrian_Event(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Event;", depth));
}
var $d_Ltyrian_Event = new $TypeData().initClass($c_Ltyrian_Event, "tyrian.Event", ({
  Ltyrian_Event: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Location$External(locationDetails) {
  this.Ltyrian_Location$External__f_locationDetails = null;
  this.Ltyrian_Location$External__f_isInternal = false;
  this.Ltyrian_Location$External__f_locationDetails = locationDetails;
  this.Ltyrian_Location$External__f_isInternal = false;
}
$c_Ltyrian_Location$External.prototype = new $h_O();
$c_Ltyrian_Location$External.prototype.constructor = $c_Ltyrian_Location$External;
/** @constructor */
function $h_Ltyrian_Location$External() {
}
$h_Ltyrian_Location$External.prototype = $c_Ltyrian_Location$External.prototype;
$c_Ltyrian_Location$External.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Location$External.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Location$External.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Location$External)) {
    var x$0$2 = $as_Ltyrian_Location$External(x$0);
    var x = this.Ltyrian_Location$External__f_locationDetails;
    var x$2 = $n(x$0$2).Ltyrian_Location$External__f_locationDetails;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Ltyrian_Location$External.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Location$External.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Location$External.prototype.productPrefix__T = (function() {
  return "External";
});
$c_Ltyrian_Location$External.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Location$External__f_locationDetails;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Location$External.prototype.isInternal__Z = (function() {
  return this.Ltyrian_Location$External__f_isInternal;
});
function $as_Ltyrian_Location$External(obj) {
  return (((obj instanceof $c_Ltyrian_Location$External) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Location$External"));
}
function $isArrayOf_Ltyrian_Location$External(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Location$External)));
}
function $asArrayOf_Ltyrian_Location$External(obj, depth) {
  return (($isArrayOf_Ltyrian_Location$External(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Location$External;", depth));
}
var $d_Ltyrian_Location$External = new $TypeData().initClass($c_Ltyrian_Location$External, "tyrian.Location$External", ({
  Ltyrian_Location$External: 1,
  Ltyrian_Location: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Location$Internal(locationDetails) {
  this.Ltyrian_Location$Internal__f_locationDetails = null;
  this.Ltyrian_Location$Internal__f_isInternal = false;
  this.Ltyrian_Location$Internal__f_locationDetails = locationDetails;
  this.Ltyrian_Location$Internal__f_isInternal = true;
}
$c_Ltyrian_Location$Internal.prototype = new $h_O();
$c_Ltyrian_Location$Internal.prototype.constructor = $c_Ltyrian_Location$Internal;
/** @constructor */
function $h_Ltyrian_Location$Internal() {
}
$h_Ltyrian_Location$Internal.prototype = $c_Ltyrian_Location$Internal.prototype;
$c_Ltyrian_Location$Internal.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Location$Internal.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Location$Internal.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Location$Internal)) {
    var x$0$2 = $as_Ltyrian_Location$Internal(x$0);
    var x = this.Ltyrian_Location$Internal__f_locationDetails;
    var x$2 = $n(x$0$2).Ltyrian_Location$Internal__f_locationDetails;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Ltyrian_Location$Internal.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Location$Internal.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Location$Internal.prototype.productPrefix__T = (function() {
  return "Internal";
});
$c_Ltyrian_Location$Internal.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Location$Internal__f_locationDetails;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Location$Internal.prototype.isInternal__Z = (function() {
  return this.Ltyrian_Location$Internal__f_isInternal;
});
function $as_Ltyrian_Location$Internal(obj) {
  return (((obj instanceof $c_Ltyrian_Location$Internal) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Location$Internal"));
}
function $isArrayOf_Ltyrian_Location$Internal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Location$Internal)));
}
function $asArrayOf_Ltyrian_Location$Internal(obj, depth) {
  return (($isArrayOf_Ltyrian_Location$Internal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Location$Internal;", depth));
}
var $d_Ltyrian_Location$Internal = new $TypeData().initClass($c_Ltyrian_Location$Internal, "tyrian.Location$Internal", ({
  Ltyrian_Location$Internal: 1,
  Ltyrian_Location: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Ltyrian_NamedAttribute(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.NamedAttribute"));
}
function $isArrayOf_Ltyrian_NamedAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_NamedAttribute)));
}
function $asArrayOf_Ltyrian_NamedAttribute(obj, depth) {
  return (($isArrayOf_Ltyrian_NamedAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.NamedAttribute;", depth));
}
/** @constructor */
function $c_Ltyrian_Sub$Batch(subs) {
  this.Ltyrian_Sub$Batch__f_subs = null;
  this.Ltyrian_Sub$Batch__f_subs = subs;
}
$c_Ltyrian_Sub$Batch.prototype = new $h_O();
$c_Ltyrian_Sub$Batch.prototype.constructor = $c_Ltyrian_Sub$Batch;
/** @constructor */
function $h_Ltyrian_Sub$Batch() {
}
$h_Ltyrian_Sub$Batch.prototype = $c_Ltyrian_Sub$Batch.prototype;
$c_Ltyrian_Sub$Batch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Sub$Batch.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Sub$Batch.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Sub$Batch)) {
    var x$0$2 = $as_Ltyrian_Sub$Batch(x$0);
    var x = this.Ltyrian_Sub$Batch__f_subs;
    var x$2 = $n(x$0$2).Ltyrian_Sub$Batch__f_subs;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Ltyrian_Sub$Batch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Sub$Batch.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Sub$Batch.prototype.productPrefix__T = (function() {
  return "Batch";
});
$c_Ltyrian_Sub$Batch.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Sub$Batch__f_subs;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_Sub$Batch(obj) {
  return (((obj instanceof $c_Ltyrian_Sub$Batch) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Batch"));
}
function $isArrayOf_Ltyrian_Sub$Batch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Batch)));
}
function $asArrayOf_Ltyrian_Sub$Batch(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Batch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Batch;", depth));
}
var $d_Ltyrian_Sub$Batch = new $TypeData().initClass($c_Ltyrian_Sub$Batch, "tyrian.Sub$Batch", ({
  Ltyrian_Sub$Batch: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Sub$Combine(sub1, sub2) {
  this.Ltyrian_Sub$Combine__f_sub1 = null;
  this.Ltyrian_Sub$Combine__f_sub2 = null;
  this.Ltyrian_Sub$Combine__f_sub1 = sub1;
  this.Ltyrian_Sub$Combine__f_sub2 = sub2;
}
$c_Ltyrian_Sub$Combine.prototype = new $h_O();
$c_Ltyrian_Sub$Combine.prototype.constructor = $c_Ltyrian_Sub$Combine;
/** @constructor */
function $h_Ltyrian_Sub$Combine() {
}
$h_Ltyrian_Sub$Combine.prototype = $c_Ltyrian_Sub$Combine.prototype;
$c_Ltyrian_Sub$Combine.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Sub$Combine.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Sub$Combine.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Sub$Combine)) {
    var x$0$2 = $as_Ltyrian_Sub$Combine(x$0);
    var x = this.Ltyrian_Sub$Combine__f_sub1;
    var x$2 = $n(x$0$2).Ltyrian_Sub$Combine__f_sub1;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_Sub$Combine__f_sub2;
      var x$4 = $n(x$0$2).Ltyrian_Sub$Combine__f_sub2;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Sub$Combine.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Sub$Combine.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_Sub$Combine.prototype.productPrefix__T = (function() {
  return "Combine";
});
$c_Ltyrian_Sub$Combine.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Sub$Combine__f_sub1;
  }
  if ((n === 1)) {
    return this.Ltyrian_Sub$Combine__f_sub2;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_Sub$Combine(obj) {
  return (((obj instanceof $c_Ltyrian_Sub$Combine) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Combine"));
}
function $isArrayOf_Ltyrian_Sub$Combine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Combine)));
}
function $asArrayOf_Ltyrian_Sub$Combine(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Combine(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Combine;", depth));
}
var $d_Ltyrian_Sub$Combine = new $TypeData().initClass($c_Ltyrian_Sub$Combine, "tyrian.Sub$Combine", ({
  Ltyrian_Sub$Combine: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Sub$Observe(id, observable, toMsg) {
  this.Ltyrian_Sub$Observe__f_id = null;
  this.Ltyrian_Sub$Observe__f_observable = null;
  this.Ltyrian_Sub$Observe__f_toMsg = null;
  this.Ltyrian_Sub$Observe__f_id = id;
  this.Ltyrian_Sub$Observe__f_observable = observable;
  this.Ltyrian_Sub$Observe__f_toMsg = toMsg;
}
$c_Ltyrian_Sub$Observe.prototype = new $h_O();
$c_Ltyrian_Sub$Observe.prototype.constructor = $c_Ltyrian_Sub$Observe;
/** @constructor */
function $h_Ltyrian_Sub$Observe() {
}
$h_Ltyrian_Sub$Observe.prototype = $c_Ltyrian_Sub$Observe.prototype;
$c_Ltyrian_Sub$Observe.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Sub$Observe.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Sub$Observe.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Sub$Observe)) {
    var x$0$2 = $as_Ltyrian_Sub$Observe(x$0);
    if ((this.Ltyrian_Sub$Observe__f_id === $n(x$0$2).Ltyrian_Sub$Observe__f_id)) {
      var x = this.Ltyrian_Sub$Observe__f_observable;
      var y = $n(x$0$2).Ltyrian_Sub$Observe__f_observable;
      var $x_1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$1 = this.Ltyrian_Sub$Observe__f_toMsg;
      var x$2 = $n(x$0$2).Ltyrian_Sub$Observe__f_toMsg;
      return ((x$1 === null) ? (x$2 === null) : $n(x$1).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Sub$Observe.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_Sub$Observe.prototype.productArity__I = (function() {
  return 3;
});
$c_Ltyrian_Sub$Observe.prototype.productPrefix__T = (function() {
  return "Observe";
});
$c_Ltyrian_Sub$Observe.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_Sub$Observe__f_id;
      break;
    }
    case 1: {
      return this.Ltyrian_Sub$Observe__f_observable;
      break;
    }
    case 2: {
      return this.Ltyrian_Sub$Observe__f_toMsg;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_Sub$Observe(obj) {
  return (((obj instanceof $c_Ltyrian_Sub$Observe) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Observe"));
}
function $isArrayOf_Ltyrian_Sub$Observe(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Observe)));
}
function $asArrayOf_Ltyrian_Sub$Observe(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Observe(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Observe;", depth));
}
var $d_Ltyrian_Sub$Observe = new $TypeData().initClass($c_Ltyrian_Sub$Observe, "tyrian.Sub$Observe", ({
  Ltyrian_Sub$Observe: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Text(value) {
  this.Ltyrian_Text__f_value = null;
  this.Ltyrian_Text__f_value = value;
}
$c_Ltyrian_Text.prototype = new $h_O();
$c_Ltyrian_Text.prototype.constructor = $c_Ltyrian_Text;
/** @constructor */
function $h_Ltyrian_Text() {
}
$h_Ltyrian_Text.prototype = $c_Ltyrian_Text.prototype;
$c_Ltyrian_Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Text.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Text)) {
    var x$0$2 = $as_Ltyrian_Text(x$0);
    return (this.Ltyrian_Text__f_value === $n(x$0$2).Ltyrian_Text__f_value);
  } else {
    return false;
  }
});
$c_Ltyrian_Text.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_Text.prototype.productPrefix__T = (function() {
  return "Text";
});
$c_Ltyrian_Text.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Text__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Text.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Elem__T(this);
});
function $as_Ltyrian_Text(obj) {
  return (((obj instanceof $c_Ltyrian_Text) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Text"));
}
function $isArrayOf_Ltyrian_Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Text)));
}
function $asArrayOf_Ltyrian_Text(obj, depth) {
  return (($isArrayOf_Ltyrian_Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Text;", depth));
}
var $d_Ltyrian_Text = new $TypeData().initClass($c_Ltyrian_Text, "tyrian.Text", ({
  Ltyrian_Text: 1,
  Ltyrian_Elem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_RendererState() {
}
$c_Ltyrian_runtime_RendererState.prototype = new $h_O();
$c_Ltyrian_runtime_RendererState.prototype.constructor = $c_Ltyrian_runtime_RendererState;
/** @constructor */
function $h_Ltyrian_runtime_RendererState() {
}
$h_Ltyrian_runtime_RendererState.prototype = $c_Ltyrian_runtime_RendererState.prototype;
$c_Ltyrian_runtime_RendererState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$1() {
}
$c_Ltyrian_runtime_Rendering$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$1;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$1() {
}
$h_Ltyrian_runtime_Rendering$$anon$1.prototype = $c_Ltyrian_runtime_Rendering$$anon$1.prototype;
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    $n(x$1);
    $n(x$1);
    return true;
  } else if (false) {
    var x$1$1 = $as_Ltyrian_NamedAttribute(x);
    $n(x$1$1)._1__T();
    return true;
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    var this$2 = $n(x$1);
    var x15 = this$2.Ltyrian_Attribute__f_name;
    var this$3 = $n(x$1);
    var x16 = this$3.Ltyrian_Attribute__f_value;
    var _2 = new $c_Lsnabbdom_AttrValue$StringAttrValue(x16);
    return new $c_T2(x15, _2);
  } else if (false) {
    var x$1$1 = $as_Ltyrian_NamedAttribute(x);
    var x12 = $n(x$1$1)._1__T();
    var _2$1 = new $c_Lsnabbdom_AttrValue$StringAttrValue("");
    return new $c_T2(x12, _2$1);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x));
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1);
});
var $d_Ltyrian_runtime_Rendering$$anon$1 = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$$anon$1, "tyrian.runtime.Rendering$$anon$1", ({
  Ltyrian_runtime_Rendering$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$2() {
}
$c_Ltyrian_runtime_Rendering$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$2;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$2() {
}
$h_Ltyrian_runtime_Rendering$$anon$2.prototype = $c_Ltyrian_runtime_Rendering$$anon$2.prototype;
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_PropertyString)) {
    var x$1 = $as_Ltyrian_PropertyString(x);
    $n(x$1);
    $n(x$1);
    return true;
  } else if (false) {
    var x$1$1 = $as_Ltyrian_PropertyBoolean(x);
    $n(x$1$1)._1__T();
    $n(x$1$1)._2__Z();
    return true;
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_PropertyString)) {
    var x$1 = $as_Ltyrian_PropertyString(x);
    var this$2 = $n(x$1);
    var x33 = this$2.Ltyrian_PropertyString__f_name;
    var this$3 = $n(x$1);
    var x34 = this$3.Ltyrian_PropertyString__f_value;
    return new $c_T2(x33, x34);
  } else if (false) {
    var x$1$1 = $as_Ltyrian_PropertyBoolean(x);
    var x29 = $n(x$1$1)._1__T();
    var x30 = $n(x$1$1)._2__Z();
    return new $c_T2(x29, x30);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x));
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1);
});
var $d_Ltyrian_runtime_Rendering$$anon$2 = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$$anon$2, "tyrian.runtime.Rendering$$anon$2", ({
  Ltyrian_runtime_Rendering$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$3(onMsg$5) {
  this.Ltyrian_runtime_Rendering$$anon$3__f_onMsg$1 = null;
  this.Ltyrian_runtime_Rendering$$anon$3__f_onMsg$1 = onMsg$5;
}
$c_Ltyrian_runtime_Rendering$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$3;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$3() {
}
$h_Ltyrian_runtime_Rendering$$anon$3.prototype = $c_Ltyrian_runtime_Rendering$$anon$3.prototype;
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Event)) {
    var x$1 = $as_Ltyrian_Event(x);
    $n(x$1);
    $n(x$1);
    $n(x$1);
    $n(x$1);
    $n(x$1);
    return true;
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Event)) {
    var x$1 = $as_Ltyrian_Event(x);
    var this$2 = $n(x$1);
    var x46 = this$2.Ltyrian_Event__f_name;
    var this$3 = $n(x$1);
    var x47 = this$3.Ltyrian_Event__f_msg;
    var this$4 = $n(x$1);
    var x48 = this$4.Ltyrian_Event__f_preventDefault;
    var this$5 = $n(x$1);
    var x49 = this$5.Ltyrian_Event__f_stopPropagation;
    var this$6 = $n(x$1);
    var x50 = this$6.Ltyrian_Event__f_stopImmediatePropagation;
    var callback = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => {
      if (x48) {
        e.preventDefault();
      }
      if (x49) {
        e.stopPropagation();
      }
      if (x50) {
        e.stopImmediatePropagation();
      }
      $n(this.Ltyrian_runtime_Rendering$$anon$3__f_onMsg$1).apply__O__O($n(x47).apply__O__O(e));
    }));
    var _2 = $m_Lsnabbdom_EventHandler$().apply__sci_Seq__Lsnabbdom_EventHandler($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([callback])));
    return new $c_T2(x46, _2);
  } else {
    return $n(default$1).apply__O__O(x);
  }
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x));
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1);
});
var $d_Ltyrian_runtime_Rendering$$anon$3 = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$$anon$3, "tyrian.runtime.Rendering$$anon$3", ({
  Ltyrian_runtime_Rendering$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$4() {
}
$c_Ltyrian_runtime_Rendering$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$4;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$4() {
}
$h_Ltyrian_runtime_Rendering$$anon$4.prototype = $c_Ltyrian_runtime_Rendering$$anon$4.prototype;
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    var this$2 = $n(x$1);
    var x67 = this$2.Ltyrian_Attribute__f_name;
    $n(x$1);
    if ((x67 === "href")) {
      return true;
    }
  }
  return false;
});
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    var this$2 = $n(x$1);
    var x72 = this$2.Ltyrian_Attribute__f_name;
    var this$3 = $n(x$1);
    var x73 = this$3.Ltyrian_Attribute__f_value;
    if ((x72 === "href")) {
      return x73;
    }
  }
  return $n(default$1).apply__O__O(x);
});
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x));
});
$c_Ltyrian_runtime_Rendering$$anon$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1);
});
var $d_Ltyrian_runtime_Rendering$$anon$4 = new $TypeData().initClass($c_Ltyrian_runtime_Rendering$$anon$4, "tyrian.runtime.Rendering$$anon$4", ({
  Ltyrian_runtime_Rendering$$anon$4: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_Functor$$anon$1(evidence$1$1, outer) {
  this.Lcats_Functor$$anon$1__f_F = null;
  this.Lcats_Functor$$anon$1__f_G = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Functor$$anon$1__f_F = outer;
  this.Lcats_Functor$$anon$1__f_G = evidence$1$1;
}
$c_Lcats_Functor$$anon$1.prototype = new $h_O();
$c_Lcats_Functor$$anon$1.prototype.constructor = $c_Lcats_Functor$$anon$1;
/** @constructor */
function $h_Lcats_Functor$$anon$1() {
}
$h_Lcats_Functor$$anon$1.prototype = $c_Lcats_Functor$$anon$1.prototype;
$c_Lcats_Functor$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_Functor$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_Functor$$anon$1.prototype.imap__O__F1__F1__O = (function(fga, f, g) {
  return $f_Lcats_ComposedInvariant__imap__O__F1__F1__O(this, fga, f, g);
});
$c_Lcats_Functor$$anon$1.prototype.map__O__F1__O = (function(fga, f) {
  return $f_Lcats_ComposedFunctor__map__O__F1__O(this, fga, f);
});
var $d_Lcats_Functor$$anon$1 = new $TypeData().initClass($c_Lcats_Functor$$anon$1, "cats.Functor$$anon$1", ({
  Lcats_Functor$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_ComposedInvariant: 1,
  Lcats_ComposedFunctor: 1
}));
function $ct_Lcats_NonEmptyReducible__Lcats_Foldable__($thiz, G) {
  $thiz.Lcats_NonEmptyReducible__f_G = G;
  return $thiz;
}
/** @constructor */
function $c_Lcats_NonEmptyReducible() {
  this.Lcats_NonEmptyReducible__f_G = null;
}
$c_Lcats_NonEmptyReducible.prototype = new $h_O();
$c_Lcats_NonEmptyReducible.prototype.constructor = $c_Lcats_NonEmptyReducible;
/** @constructor */
function $h_Lcats_NonEmptyReducible() {
}
$h_Lcats_NonEmptyReducible.prototype = $c_Lcats_NonEmptyReducible.prototype;
$c_Lcats_NonEmptyReducible.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_NonEmptyReducible.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, H) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  var _1 = $n(fa$1).Lcats_data_NonEmptyList__f_head;
  var _2 = $n(fa$1).Lcats_data_NonEmptyList__f_tail;
  var \u03b44$___1 = _1;
  var \u03b44$___2 = _2;
  var a$2 = \u03b44$___1;
  var ga$2 = \u03b44$___2;
  return $n(H).flatMap__O__F1__O($n(f).apply__O__O__O(z, a$2), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => $n(this.Lcats_NonEmptyReducible__f_G).foldM__O__O__F2__Lcats_Monad__O(ga$2, _$4, f, H))));
});
/** @constructor */
function $c_Lcats_Now(value) {
  this.Lcats_Now__f_value = null;
  this.Lcats_Now__f_value = value;
}
$c_Lcats_Now.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Now.prototype.constructor = $c_Lcats_Now;
/** @constructor */
function $h_Lcats_Now() {
}
$h_Lcats_Now.prototype = $c_Lcats_Now.prototype;
$c_Lcats_Now.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Now.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_Now.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Now)) {
    var x$0$2 = $as_Lcats_Now(x$0);
    var x = this.Lcats_Now__f_value;
    var y = $n(x$0$2).Lcats_Now__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_Now.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Now.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_Now.prototype.productPrefix__T = (function() {
  return "Now";
});
$c_Lcats_Now.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Now__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_Now.prototype.value__O = (function() {
  return this.Lcats_Now__f_value;
});
$c_Lcats_Now.prototype.memoize__Lcats_Eval = (function() {
  return this;
});
function $as_Lcats_Now(obj) {
  return (((obj instanceof $c_Lcats_Now) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Now"));
}
function $isArrayOf_Lcats_Now(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Now)));
}
function $asArrayOf_Lcats_Now(obj, depth) {
  return (($isArrayOf_Lcats_Now(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Now;", depth));
}
var $d_Lcats_Now = new $TypeData().initClass($c_Lcats_Now, "cats.Now", ({
  Lcats_Now: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$1() {
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_False;
}
$c_Lcats_UnorderedFoldable$$anon$1.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$1.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$1;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$1() {
}
$h_Lcats_UnorderedFoldable$$anon$1.prototype = $c_Lcats_UnorderedFoldable$$anon$1.prototype;
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return $n(lx).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $uZ(x$1);
    if ((x$1$1 === true)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_True;
    }
    if ((x$1$1 === false)) {
      return ly;
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$1__f_empty;
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y));
});
var $d_Lcats_UnorderedFoldable$$anon$1 = new $TypeData().initClass($c_Lcats_UnorderedFoldable$$anon$1, "cats.UnorderedFoldable$$anon$1", ({
  Lcats_UnorderedFoldable$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
}));
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$2() {
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_True;
}
$c_Lcats_UnorderedFoldable$$anon$2.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$2.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$2;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$2() {
}
$h_Lcats_UnorderedFoldable$$anon$2.prototype = $c_Lcats_UnorderedFoldable$$anon$2.prototype;
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return $n(lx).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $uZ(x$1);
    if ((x$1$1 === true)) {
      return ly;
    }
    if ((x$1$1 === false)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_False;
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$2__f_empty;
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y));
});
var $d_Lcats_UnorderedFoldable$$anon$2 = new $TypeData().initClass($c_Lcats_UnorderedFoldable$$anon$2, "cats.UnorderedFoldable$$anon$2", ({
  Lcats_UnorderedFoldable$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
}));
function $f_Lcats_arrow_Arrow__id__O($thiz) {
  return $thiz.lift__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => x)));
}
/** @constructor */
function $c_Lcats_data_AndThen$Concat(left, right) {
  this.Lcats_data_AndThen$Concat__f_left = null;
  this.Lcats_data_AndThen$Concat__f_right = null;
  this.Lcats_data_AndThen$Concat__f_left = left;
  this.Lcats_data_AndThen$Concat__f_right = right;
}
$c_Lcats_data_AndThen$Concat.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Concat.prototype.constructor = $c_Lcats_data_AndThen$Concat;
/** @constructor */
function $h_Lcats_data_AndThen$Concat() {
}
$h_Lcats_data_AndThen$Concat.prototype = $c_Lcats_data_AndThen$Concat.prototype;
$c_Lcats_data_AndThen$Concat.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_AndThen$Concat.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_AndThen$Concat)) {
    var x$0$2 = $as_Lcats_data_AndThen$Concat(x$0);
    var x = this.Lcats_data_AndThen$Concat__f_left;
    var x$2 = $n(x$0$2).Lcats_data_AndThen$Concat__f_left;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_data_AndThen$Concat__f_right;
      var x$4 = $n(x$0$2).Lcats_data_AndThen$Concat__f_right;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_data_AndThen$Concat.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_AndThen$Concat.prototype.productPrefix__T = (function() {
  return "Concat";
});
$c_Lcats_data_AndThen$Concat.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_AndThen$Concat__f_left;
  }
  if ((n === 1)) {
    return this.Lcats_data_AndThen$Concat__f_right;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_AndThen$Concat(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen$Concat) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen$Concat"));
}
function $isArrayOf_Lcats_data_AndThen$Concat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Concat)));
}
function $asArrayOf_Lcats_data_AndThen$Concat(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen$Concat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen$Concat;", depth));
}
var $d_Lcats_data_AndThen$Concat = new $TypeData().initClass($c_Lcats_data_AndThen$Concat, "cats.data.AndThen$Concat", ({
  Lcats_data_AndThen$Concat: 1,
  Lcats_data_AndThen: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_AndThen$Single(f, index) {
  this.Lcats_data_AndThen$Single__f_f = null;
  this.Lcats_data_AndThen$Single__f_index = 0;
  this.Lcats_data_AndThen$Single__f_f = f;
  this.Lcats_data_AndThen$Single__f_index = index;
}
$c_Lcats_data_AndThen$Single.prototype = new $h_Lcats_data_AndThen();
$c_Lcats_data_AndThen$Single.prototype.constructor = $c_Lcats_data_AndThen$Single;
/** @constructor */
function $h_Lcats_data_AndThen$Single() {
}
$h_Lcats_data_AndThen$Single.prototype = $c_Lcats_data_AndThen$Single.prototype;
$c_Lcats_data_AndThen$Single.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Single");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_data_AndThen$Single__f_f;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_data_AndThen$Single__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lcats_data_AndThen$Single.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_AndThen$Single)) {
    var x$0$2 = $as_Lcats_data_AndThen$Single(x$0);
    if ((this.Lcats_data_AndThen$Single__f_index === $n(x$0$2).Lcats_data_AndThen$Single__f_index)) {
      var x = this.Lcats_data_AndThen$Single__f_f;
      var x$2 = $n(x$0$2).Lcats_data_AndThen$Single__f_f;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_data_AndThen$Single.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_AndThen$Single.prototype.productPrefix__T = (function() {
  return "Single";
});
$c_Lcats_data_AndThen$Single.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_AndThen$Single__f_f;
  }
  if ((n === 1)) {
    return this.Lcats_data_AndThen$Single__f_index;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_AndThen$Single(obj) {
  return (((obj instanceof $c_Lcats_data_AndThen$Single) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.AndThen$Single"));
}
function $isArrayOf_Lcats_data_AndThen$Single(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_AndThen$Single)));
}
function $asArrayOf_Lcats_data_AndThen$Single(obj, depth) {
  return (($isArrayOf_Lcats_data_AndThen$Single(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.AndThen$Single;", depth));
}
var $d_Lcats_data_AndThen$Single = new $TypeData().initClass($c_Lcats_data_AndThen$Single, "cats.data.AndThen$Single", ({
  Lcats_data_AndThen$Single: 1,
  Lcats_data_AndThen: 1,
  F1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_KleisliInstances4() {
}
$c_Lcats_data_KleisliInstances4.prototype = new $h_Lcats_data_KleisliInstances5();
$c_Lcats_data_KleisliInstances4.prototype.constructor = $c_Lcats_data_KleisliInstances4;
/** @constructor */
function $h_Lcats_data_KleisliInstances4() {
}
$h_Lcats_data_KleisliInstances4.prototype = $c_Lcats_data_KleisliInstances4.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyList$() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyListBinCompat1 = null;
  $ct_Lcats_data_NonEmptyListInstances__(this);
}
$c_Lcats_data_NonEmptyList$.prototype = new $h_Lcats_data_NonEmptyListInstances();
$c_Lcats_data_NonEmptyList$.prototype.constructor = $c_Lcats_data_NonEmptyList$;
/** @constructor */
function $h_Lcats_data_NonEmptyList$() {
}
$h_Lcats_data_NonEmptyList$.prototype = $c_Lcats_data_NonEmptyList$.prototype;
$c_Lcats_data_NonEmptyList$.prototype.fromList__sci_List__s_Option = (function(l) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(l)) {
    return $m_s_None$();
  }
  if ((l instanceof $c_sci_$colon$colon)) {
    var x45 = $as_sci_$colon$colon(l);
    var x47 = $n(x45).sci_$colon$colon__f_next;
    var h = $n(x45).sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    var value = new $c_Lcats_data_NonEmptyList(h, x47);
    return new $c_s_Some(value);
  }
  throw new $c_s_MatchError(l);
});
$c_Lcats_data_NonEmptyList$.prototype.fromListUnsafe__sci_List__Lcats_data_NonEmptyList = (function(l) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(l)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Cannot create NonEmptyList from empty list");
  }
  if ((l instanceof $c_sci_$colon$colon)) {
    var x49 = $as_sci_$colon$colon(l);
    var x51 = $n(x49).sci_$colon$colon__f_next;
    var h = $n(x49).sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(h, x51);
  }
  throw new $c_s_MatchError(l);
});
var $d_Lcats_data_NonEmptyList$ = new $TypeData().initClass($c_Lcats_data_NonEmptyList$, "cats.data.NonEmptyList$", ({
  Lcats_data_NonEmptyList$: 1,
  Lcats_data_NonEmptyListInstances: 1,
  Lcats_data_NonEmptyListInstances0: 1,
  Lcats_data_NonEmptyListInstances1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lcats_data_NonEmptyList$;
function $m_Lcats_data_NonEmptyList$() {
  if ((!$n_Lcats_data_NonEmptyList$)) {
    $n_Lcats_data_NonEmptyList$ = new $c_Lcats_data_NonEmptyList$();
  }
  return $n_Lcats_data_NonEmptyList$;
}
/** @constructor */
function $c_Lcats_effect_IO$() {
  this.Lcats_effect_IO$__f__asyncForIO = null;
  this.Lcats_effect_IO$__f__unit = null;
  this.Lcats_effect_IO$__f__never = null;
  $n_Lcats_effect_IO$ = this;
  this.Lcats_effect_IO$__f__asyncForIO = new $c_Lcats_effect_IO$IOAsync();
  this.Lcats_effect_IO$__f__unit = new $c_Lcats_effect_IO$Pure((void 0));
  var this$2 = $m_Lcats_effect_instances_package$spawn$();
  var M = this.Lcats_effect_IO$__f__asyncForIO;
  new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M, this$2);
  $m_Lcats_effect_std_Console$().make__Lcats_effect_kernel_Async__Lcats_effect_std_Console(this.Lcats_effect_IO$__f__asyncForIO);
  var this$3 = $m_Lcats_effect_std_Env$();
  var F = this.Lcats_effect_IO$__f__asyncForIO;
  new $c_Lcats_effect_std_EnvCompanionPlatform$SyncEnv(this$3, F);
  this.Lcats_effect_IO$__f__never = $as_Lcats_effect_IO($n(this.Lcats_effect_IO$__f__asyncForIO).never__O());
}
$c_Lcats_effect_IO$.prototype = new $h_Lcats_effect_IOCompanionPlatform();
$c_Lcats_effect_IO$.prototype.constructor = $c_Lcats_effect_IO$;
/** @constructor */
function $h_Lcats_effect_IO$() {
}
$h_Lcats_effect_IO$.prototype = $c_Lcats_effect_IO$.prototype;
$c_Lcats_effect_IO$.prototype.delay__F0__Lcats_effect_IO = (function(thunk) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F0__Lcats_effect_tracing_TracingEvent(thunk);
  return new $c_Lcats_effect_IO$Delay(thunk, event);
});
$c_Lcats_effect_IO$.prototype.defer__F0__Lcats_effect_IO = (function(thunk) {
  var this$2 = $n(this.delay__F0__Lcats_effect_IO(thunk));
  var this$1 = $m_s_$less$colon$less$();
  var ev = this$1.s_$less$colon$less$__f_singleton;
  return this$2.flatMap__F1__Lcats_effect_IO(ev);
});
$c_Lcats_effect_IO$.prototype.asyncCheckAttempt__F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$4(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.async__F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$5(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.async___F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$6(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.cont__Lcats_effect_kernel_Cont__Lcats_effect_IO = (function(body) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__Lcats_effect_kernel_Cont__Lcats_effect_tracing_TracingEvent(body);
  return new $c_Lcats_effect_IO$IOCont(body, event);
});
$c_Lcats_effect_IO$.prototype.sleep__s_concurrent_duration_Duration__Lcats_effect_IO = (function(delay) {
  matchResult13: {
    var $x_1;
    if ((delay instanceof $c_s_concurrent_duration_FiniteDuration)) {
      var fd = $as_s_concurrent_duration_FiniteDuration(delay);
      var $x_1 = new $c_Lcats_effect_IO$Sleep(fd);
      break matchResult13;
    }
    var x = $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf;
    if (((x === null) ? (delay === null) : $n(x).equals__O__Z(delay))) {
      var $x_1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__never;
      break matchResult13;
    }
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Duration must be either a `FiniteDuration` or `Duration.Inf`, but got: " + delay));
  }
  return $as_Lcats_effect_IO($x_1);
});
$c_Lcats_effect_IO$.prototype.uncancelable__F1__Lcats_effect_IO = (function(body) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(body);
  return new $c_Lcats_effect_IO$Uncancelable(body, event);
});
$c_Lcats_effect_IO$.prototype.ref__O__Lcats_effect_IO = (function(a) {
  var this$2 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var F = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
    return new $c_Lcats_effect_kernel_SyncRef(a, F);
  }));
  return this$2.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$.prototype.deferred__Lcats_effect_IO = (function() {
  var this$1 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => new $c_Lcats_effect_IODeferred()));
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$.prototype.bracketFull__F1__F1__F2__Lcats_effect_IO = (function(acquire, use, release) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return $n($as_Lcats_effect_IO($n(acquire).apply__O__O(poll$1))).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n($m_Lcats_effect_IO$().defer__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $as_Lcats_effect_IO($n(poll$1).apply__O__O($n(use).apply__O__O(a))))))).guaranteeCase__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$54) => {
      var _$54$1 = $as_Lcats_effect_kernel_Outcome(_$54);
      return $as_Lcats_effect_IO($n(release).apply__O__O__O(a, _$54$1));
    }))))));
  })));
});
function $as_Lcats_effect_IO$(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$"));
}
function $isArrayOf_Lcats_effect_IO$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$)));
}
function $asArrayOf_Lcats_effect_IO$(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$;", depth));
}
var $d_Lcats_effect_IO$ = new $TypeData().initClass($c_Lcats_effect_IO$, "cats.effect.IO$", ({
  Lcats_effect_IO$: 1,
  Lcats_effect_IOCompanionPlatform: 1,
  Lcats_effect_IOLowPriorityImplicits: 1,
  Lcats_syntax_TupleParallelSyntax: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_effect_IO$;
function $m_Lcats_effect_IO$() {
  if ((!$n_Lcats_effect_IO$)) {
    $n_Lcats_effect_IO$ = new $c_Lcats_effect_IO$();
  }
  return $n_Lcats_effect_IO$;
}
/** @constructor */
function $c_Lcats_effect_IO$Attempt(ioa) {
  this.Lcats_effect_IO$Attempt__f_ioa = null;
  this.Lcats_effect_IO$Attempt__f_ioa = ioa;
}
$c_Lcats_effect_IO$Attempt.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Attempt.prototype.constructor = $c_Lcats_effect_IO$Attempt;
/** @constructor */
function $h_Lcats_effect_IO$Attempt() {
}
$h_Lcats_effect_IO$Attempt.prototype = $c_Lcats_effect_IO$Attempt.prototype;
$c_Lcats_effect_IO$Attempt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Attempt.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Attempt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Attempt)) {
    var x$0$2 = $as_Lcats_effect_IO$Attempt(x$0);
    var x = this.Lcats_effect_IO$Attempt__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Attempt__f_ioa;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Attempt.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Attempt.prototype.productPrefix__T = (function() {
  return "Attempt";
});
$c_Lcats_effect_IO$Attempt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Attempt__f_ioa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Attempt.prototype.tag__B = (function() {
  return 8;
});
function $as_Lcats_effect_IO$Attempt(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Attempt) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Attempt"));
}
function $isArrayOf_Lcats_effect_IO$Attempt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Attempt)));
}
function $asArrayOf_Lcats_effect_IO$Attempt(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Attempt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Attempt;", depth));
}
var $d_Lcats_effect_IO$Attempt = new $TypeData().initClass($c_Lcats_effect_IO$Attempt, "cats.effect.IO$Attempt", ({
  Lcats_effect_IO$Attempt: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lcats_effect_IO$Blocking(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Blocking"));
}
function $isArrayOf_Lcats_effect_IO$Blocking(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Blocking)));
}
function $asArrayOf_Lcats_effect_IO$Blocking(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Blocking(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Blocking;", depth));
}
/** @constructor */
function $c_Lcats_effect_IO$Delay(thunk, event) {
  this.Lcats_effect_IO$Delay__f_thunk = null;
  this.Lcats_effect_IO$Delay__f_event = null;
  this.Lcats_effect_IO$Delay__f_thunk = thunk;
  this.Lcats_effect_IO$Delay__f_event = event;
}
$c_Lcats_effect_IO$Delay.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Delay.prototype.constructor = $c_Lcats_effect_IO$Delay;
/** @constructor */
function $h_Lcats_effect_IO$Delay() {
}
$h_Lcats_effect_IO$Delay.prototype = $c_Lcats_effect_IO$Delay.prototype;
$c_Lcats_effect_IO$Delay.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Delay.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Delay.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Delay)) {
    var x$0$2 = $as_Lcats_effect_IO$Delay(x$0);
    var x = this.Lcats_effect_IO$Delay__f_thunk;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Delay__f_thunk;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lcats_effect_IO$Delay__f_event;
      var x$4 = $n(x$0$2).Lcats_effect_IO$Delay__f_event;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Delay.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$Delay.prototype.productPrefix__T = (function() {
  return "Delay";
});
$c_Lcats_effect_IO$Delay.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Delay__f_thunk;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$Delay__f_event;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Delay.prototype.tag__B = (function() {
  return 2;
});
function $as_Lcats_effect_IO$Delay(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Delay) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Delay"));
}
function $isArrayOf_Lcats_effect_IO$Delay(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Delay)));
}
function $asArrayOf_Lcats_effect_IO$Delay(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Delay(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Delay;", depth));
}
var $d_Lcats_effect_IO$Delay = new $TypeData().initClass($c_Lcats_effect_IO$Delay, "cats.effect.IO$Delay", ({
  Lcats_effect_IO$Delay: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Error(t) {
  this.Lcats_effect_IO$Error__f_t = null;
  this.Lcats_effect_IO$Error__f_t = t;
}
$c_Lcats_effect_IO$Error.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Error.prototype.constructor = $c_Lcats_effect_IO$Error;
/** @constructor */
function $h_Lcats_effect_IO$Error() {
}
$h_Lcats_effect_IO$Error.prototype = $c_Lcats_effect_IO$Error.prototype;
$c_Lcats_effect_IO$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Error.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Error)) {
    var x$0$2 = $as_Lcats_effect_IO$Error(x$0);
    var x = this.Lcats_effect_IO$Error__f_t;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Error__f_t;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Error.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Error.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Lcats_effect_IO$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Error__f_t;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Error.prototype.tag__B = (function() {
  return 1;
});
function $as_Lcats_effect_IO$Error(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Error) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Error"));
}
function $isArrayOf_Lcats_effect_IO$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Error)));
}
function $asArrayOf_Lcats_effect_IO$Error(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Error;", depth));
}
var $d_Lcats_effect_IO$Error = new $TypeData().initClass($c_Lcats_effect_IO$Error, "cats.effect.IO$Error", ({
  Lcats_effect_IO$Error: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$EvalOn(ioa, ec) {
  this.Lcats_effect_IO$EvalOn__f_ioa = null;
  this.Lcats_effect_IO$EvalOn__f_ec = null;
  this.Lcats_effect_IO$EvalOn__f_ioa = ioa;
  this.Lcats_effect_IO$EvalOn__f_ec = ec;
}
$c_Lcats_effect_IO$EvalOn.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$EvalOn.prototype.constructor = $c_Lcats_effect_IO$EvalOn;
/** @constructor */
function $h_Lcats_effect_IO$EvalOn() {
}
$h_Lcats_effect_IO$EvalOn.prototype = $c_Lcats_effect_IO$EvalOn.prototype;
$c_Lcats_effect_IO$EvalOn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$EvalOn.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$EvalOn.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$EvalOn)) {
    var x$0$2 = $as_Lcats_effect_IO$EvalOn(x$0);
    var x = this.Lcats_effect_IO$EvalOn__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$EvalOn__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$EvalOn__f_ec;
      var x$4 = $n(x$0$2).Lcats_effect_IO$EvalOn__f_ec;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$EvalOn.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$EvalOn.prototype.productPrefix__T = (function() {
  return "EvalOn";
});
$c_Lcats_effect_IO$EvalOn.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$EvalOn__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$EvalOn__f_ec;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$EvalOn.prototype.tag__B = (function() {
  return 20;
});
function $as_Lcats_effect_IO$EvalOn(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$EvalOn) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$EvalOn"));
}
function $isArrayOf_Lcats_effect_IO$EvalOn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$EvalOn)));
}
function $asArrayOf_Lcats_effect_IO$EvalOn(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$EvalOn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$EvalOn;", depth));
}
var $d_Lcats_effect_IO$EvalOn = new $TypeData().initClass($c_Lcats_effect_IO$EvalOn, "cats.effect.IO$EvalOn", ({
  Lcats_effect_IO$EvalOn: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$FlatMap(ioe, f, event) {
  this.Lcats_effect_IO$FlatMap__f_ioe = null;
  this.Lcats_effect_IO$FlatMap__f_f = null;
  this.Lcats_effect_IO$FlatMap__f_event = null;
  this.Lcats_effect_IO$FlatMap__f_ioe = ioe;
  this.Lcats_effect_IO$FlatMap__f_f = f;
  this.Lcats_effect_IO$FlatMap__f_event = event;
}
$c_Lcats_effect_IO$FlatMap.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$FlatMap.prototype.constructor = $c_Lcats_effect_IO$FlatMap;
/** @constructor */
function $h_Lcats_effect_IO$FlatMap() {
}
$h_Lcats_effect_IO$FlatMap.prototype = $c_Lcats_effect_IO$FlatMap.prototype;
$c_Lcats_effect_IO$FlatMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$FlatMap.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$FlatMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$FlatMap)) {
    var x$0$2 = $as_Lcats_effect_IO$FlatMap(x$0);
    var x = this.Lcats_effect_IO$FlatMap__f_ioe;
    var x$2 = $n(x$0$2).Lcats_effect_IO$FlatMap__f_ioe;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$FlatMap__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_IO$FlatMap__f_f;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_IO$FlatMap__f_event;
      var x$6 = $n(x$0$2).Lcats_effect_IO$FlatMap__f_event;
      if ((x$5 === null)) {
        return (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        return (this$1 === x$6);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$FlatMap.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$FlatMap.prototype.productPrefix__T = (function() {
  return "FlatMap";
});
$c_Lcats_effect_IO$FlatMap.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$FlatMap__f_ioe;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$FlatMap__f_f;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$FlatMap__f_event;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$FlatMap.prototype.tag__B = (function() {
  return 7;
});
function $as_Lcats_effect_IO$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$FlatMap"));
}
function $isArrayOf_Lcats_effect_IO$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$FlatMap)));
}
function $asArrayOf_Lcats_effect_IO$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$FlatMap;", depth));
}
var $d_Lcats_effect_IO$FlatMap = new $TypeData().initClass($c_Lcats_effect_IO$FlatMap, "cats.effect.IO$FlatMap", ({
  Lcats_effect_IO$FlatMap: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$HandleErrorWith(ioa, f, event) {
  this.Lcats_effect_IO$HandleErrorWith__f_ioa = null;
  this.Lcats_effect_IO$HandleErrorWith__f_f = null;
  this.Lcats_effect_IO$HandleErrorWith__f_event = null;
  this.Lcats_effect_IO$HandleErrorWith__f_ioa = ioa;
  this.Lcats_effect_IO$HandleErrorWith__f_f = f;
  this.Lcats_effect_IO$HandleErrorWith__f_event = event;
}
$c_Lcats_effect_IO$HandleErrorWith.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$HandleErrorWith.prototype.constructor = $c_Lcats_effect_IO$HandleErrorWith;
/** @constructor */
function $h_Lcats_effect_IO$HandleErrorWith() {
}
$h_Lcats_effect_IO$HandleErrorWith.prototype = $c_Lcats_effect_IO$HandleErrorWith.prototype;
$c_Lcats_effect_IO$HandleErrorWith.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$HandleErrorWith)) {
    var x$0$2 = $as_Lcats_effect_IO$HandleErrorWith(x$0);
    var x = this.Lcats_effect_IO$HandleErrorWith__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$HandleErrorWith__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$HandleErrorWith__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_IO$HandleErrorWith__f_f;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_IO$HandleErrorWith__f_event;
      var x$6 = $n(x$0$2).Lcats_effect_IO$HandleErrorWith__f_event;
      if ((x$5 === null)) {
        return (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        return (this$1 === x$6);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productPrefix__T = (function() {
  return "HandleErrorWith";
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$HandleErrorWith__f_ioa;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$HandleErrorWith__f_f;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$HandleErrorWith__f_event;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.tag__B = (function() {
  return 9;
});
function $as_Lcats_effect_IO$HandleErrorWith(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$HandleErrorWith) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$HandleErrorWith"));
}
function $isArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$HandleErrorWith)));
}
function $asArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$HandleErrorWith;", depth));
}
var $d_Lcats_effect_IO$HandleErrorWith = new $TypeData().initClass($c_Lcats_effect_IO$HandleErrorWith, "cats.effect.IO$HandleErrorWith", ({
  Lcats_effect_IO$HandleErrorWith: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$IOCont(body, event) {
  this.Lcats_effect_IO$IOCont__f_body = null;
  this.Lcats_effect_IO$IOCont__f_event = null;
  this.Lcats_effect_IO$IOCont__f_body = body;
  this.Lcats_effect_IO$IOCont__f_event = event;
}
$c_Lcats_effect_IO$IOCont.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$IOCont.prototype.constructor = $c_Lcats_effect_IO$IOCont;
/** @constructor */
function $h_Lcats_effect_IO$IOCont() {
}
$h_Lcats_effect_IO$IOCont.prototype = $c_Lcats_effect_IO$IOCont.prototype;
$c_Lcats_effect_IO$IOCont.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$IOCont.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$IOCont.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$IOCont)) {
    var x$0$2 = $as_Lcats_effect_IO$IOCont(x$0);
    var x = this.Lcats_effect_IO$IOCont__f_body;
    var x$2 = $n(x$0$2).Lcats_effect_IO$IOCont__f_body;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lcats_effect_IO$IOCont__f_event;
      var x$4 = $n(x$0$2).Lcats_effect_IO$IOCont__f_event;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$2 = $n(x$3);
        return (this$2 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$IOCont.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$IOCont.prototype.productPrefix__T = (function() {
  return "IOCont";
});
$c_Lcats_effect_IO$IOCont.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$IOCont__f_body;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$IOCont__f_event;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOCont.prototype.tag__B = (function() {
  return 14;
});
function $as_Lcats_effect_IO$IOCont(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$IOCont) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$IOCont"));
}
function $isArrayOf_Lcats_effect_IO$IOCont(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$IOCont)));
}
function $asArrayOf_Lcats_effect_IO$IOCont(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$IOCont(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$IOCont;", depth));
}
var $d_Lcats_effect_IO$IOCont = new $TypeData().initClass($c_Lcats_effect_IO$IOCont, "cats.effect.IO$IOCont", ({
  Lcats_effect_IO$IOCont: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$IOCont$Get(state) {
  this.Lcats_effect_IO$IOCont$Get__f_state = null;
  this.Lcats_effect_IO$IOCont$Get__f_state = state;
}
$c_Lcats_effect_IO$IOCont$Get.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$IOCont$Get.prototype.constructor = $c_Lcats_effect_IO$IOCont$Get;
/** @constructor */
function $h_Lcats_effect_IO$IOCont$Get() {
}
$h_Lcats_effect_IO$IOCont$Get.prototype = $c_Lcats_effect_IO$IOCont$Get.prototype;
$c_Lcats_effect_IO$IOCont$Get.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$IOCont$Get.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$IOCont$Get.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$IOCont$Get)) {
    var x$0$2 = $as_Lcats_effect_IO$IOCont$Get(x$0);
    var x = this.Lcats_effect_IO$IOCont$Get__f_state;
    var x$2 = $n(x$0$2).Lcats_effect_IO$IOCont$Get__f_state;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productPrefix__T = (function() {
  return "Get";
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$IOCont$Get__f_state;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$IOCont$Get.prototype.tag__B = (function() {
  return 15;
});
function $as_Lcats_effect_IO$IOCont$Get(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$IOCont$Get) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$IOCont$Get"));
}
function $isArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$IOCont$Get)));
}
function $asArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$IOCont$Get;", depth));
}
var $d_Lcats_effect_IO$IOCont$Get = new $TypeData().initClass($c_Lcats_effect_IO$IOCont$Get, "cats.effect.IO$IOCont$Get", ({
  Lcats_effect_IO$IOCont$Get: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lcats_effect_IO$Local(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Local"));
}
function $isArrayOf_Lcats_effect_IO$Local(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Local)));
}
function $asArrayOf_Lcats_effect_IO$Local(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Local(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Local;", depth));
}
/** @constructor */
function $c_Lcats_effect_IO$Map(ioe, f, event) {
  this.Lcats_effect_IO$Map__f_ioe = null;
  this.Lcats_effect_IO$Map__f_f = null;
  this.Lcats_effect_IO$Map__f_event = null;
  this.Lcats_effect_IO$Map__f_ioe = ioe;
  this.Lcats_effect_IO$Map__f_f = f;
  this.Lcats_effect_IO$Map__f_event = event;
}
$c_Lcats_effect_IO$Map.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Map.prototype.constructor = $c_Lcats_effect_IO$Map;
/** @constructor */
function $h_Lcats_effect_IO$Map() {
}
$h_Lcats_effect_IO$Map.prototype = $c_Lcats_effect_IO$Map.prototype;
$c_Lcats_effect_IO$Map.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Map.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Map.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Map)) {
    var x$0$2 = $as_Lcats_effect_IO$Map(x$0);
    var x = this.Lcats_effect_IO$Map__f_ioe;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Map__f_ioe;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$Map__f_f;
      var x$4 = $n(x$0$2).Lcats_effect_IO$Map__f_f;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lcats_effect_IO$Map__f_event;
      var x$6 = $n(x$0$2).Lcats_effect_IO$Map__f_event;
      if ((x$5 === null)) {
        return (x$6 === null);
      } else {
        var this$1 = $n(x$5);
        return (this$1 === x$6);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Map.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$Map.prototype.productPrefix__T = (function() {
  return "Map";
});
$c_Lcats_effect_IO$Map.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$Map__f_ioe;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$Map__f_f;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$Map__f_event;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$Map.prototype.tag__B = (function() {
  return 6;
});
function $as_Lcats_effect_IO$Map(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Map) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Map"));
}
function $isArrayOf_Lcats_effect_IO$Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Map)));
}
function $asArrayOf_Lcats_effect_IO$Map(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Map;", depth));
}
var $d_Lcats_effect_IO$Map = new $TypeData().initClass($c_Lcats_effect_IO$Map, "cats.effect.IO$Map", ({
  Lcats_effect_IO$Map: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$OnCancel(ioa, fin) {
  this.Lcats_effect_IO$OnCancel__f_ioa = null;
  this.Lcats_effect_IO$OnCancel__f_fin = null;
  this.Lcats_effect_IO$OnCancel__f_ioa = ioa;
  this.Lcats_effect_IO$OnCancel__f_fin = fin;
}
$c_Lcats_effect_IO$OnCancel.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$OnCancel.prototype.constructor = $c_Lcats_effect_IO$OnCancel;
/** @constructor */
function $h_Lcats_effect_IO$OnCancel() {
}
$h_Lcats_effect_IO$OnCancel.prototype = $c_Lcats_effect_IO$OnCancel.prototype;
$c_Lcats_effect_IO$OnCancel.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$OnCancel.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$OnCancel.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$OnCancel)) {
    var x$0$2 = $as_Lcats_effect_IO$OnCancel(x$0);
    var x = this.Lcats_effect_IO$OnCancel__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$OnCancel__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$OnCancel__f_fin;
      var x$4 = $n(x$0$2).Lcats_effect_IO$OnCancel__f_fin;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$OnCancel.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$OnCancel.prototype.productPrefix__T = (function() {
  return "OnCancel";
});
$c_Lcats_effect_IO$OnCancel.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$OnCancel__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$OnCancel__f_fin;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$OnCancel.prototype.tag__B = (function() {
  return 11;
});
function $as_Lcats_effect_IO$OnCancel(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$OnCancel) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$OnCancel"));
}
function $isArrayOf_Lcats_effect_IO$OnCancel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$OnCancel)));
}
function $asArrayOf_Lcats_effect_IO$OnCancel(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$OnCancel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$OnCancel;", depth));
}
var $d_Lcats_effect_IO$OnCancel = new $TypeData().initClass($c_Lcats_effect_IO$OnCancel, "cats.effect.IO$OnCancel", ({
  Lcats_effect_IO$OnCancel: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Pure(value) {
  this.Lcats_effect_IO$Pure__f_value = null;
  this.Lcats_effect_IO$Pure__f_value = value;
}
$c_Lcats_effect_IO$Pure.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Pure.prototype.constructor = $c_Lcats_effect_IO$Pure;
/** @constructor */
function $h_Lcats_effect_IO$Pure() {
}
$h_Lcats_effect_IO$Pure.prototype = $c_Lcats_effect_IO$Pure.prototype;
$c_Lcats_effect_IO$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Pure)) {
    var x$0$2 = $as_Lcats_effect_IO$Pure(x$0);
    var x = this.Lcats_effect_IO$Pure__f_value;
    var y = $n(x$0$2).Lcats_effect_IO$Pure__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Pure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Pure.prototype.productPrefix__T = (function() {
  return "Pure";
});
$c_Lcats_effect_IO$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Pure__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Pure.prototype.tag__B = (function() {
  return 0;
});
$c_Lcats_effect_IO$Pure.prototype.toString__T = (function() {
  return (("IO(" + this.Lcats_effect_IO$Pure__f_value) + ")");
});
function $as_Lcats_effect_IO$Pure(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Pure"));
}
function $isArrayOf_Lcats_effect_IO$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Pure)));
}
function $asArrayOf_Lcats_effect_IO$Pure(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Pure;", depth));
}
var $d_Lcats_effect_IO$Pure = new $TypeData().initClass($c_Lcats_effect_IO$Pure, "cats.effect.IO$Pure", ({
  Lcats_effect_IO$Pure: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$RacePair(ioa, iob) {
  this.Lcats_effect_IO$RacePair__f_ioa = null;
  this.Lcats_effect_IO$RacePair__f_iob = null;
  this.Lcats_effect_IO$RacePair__f_ioa = ioa;
  this.Lcats_effect_IO$RacePair__f_iob = iob;
}
$c_Lcats_effect_IO$RacePair.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$RacePair.prototype.constructor = $c_Lcats_effect_IO$RacePair;
/** @constructor */
function $h_Lcats_effect_IO$RacePair() {
}
$h_Lcats_effect_IO$RacePair.prototype = $c_Lcats_effect_IO$RacePair.prototype;
$c_Lcats_effect_IO$RacePair.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$RacePair.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$RacePair.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$RacePair)) {
    var x$0$2 = $as_Lcats_effect_IO$RacePair(x$0);
    var x = this.Lcats_effect_IO$RacePair__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$RacePair__f_ioa;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$RacePair__f_iob;
      var x$4 = $n(x$0$2).Lcats_effect_IO$RacePair__f_iob;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$RacePair.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$RacePair.prototype.productPrefix__T = (function() {
  return "RacePair";
});
$c_Lcats_effect_IO$RacePair.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$RacePair__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$RacePair__f_iob;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$RacePair.prototype.tag__B = (function() {
  return 18;
});
function $as_Lcats_effect_IO$RacePair(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$RacePair) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$RacePair"));
}
function $isArrayOf_Lcats_effect_IO$RacePair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$RacePair)));
}
function $asArrayOf_Lcats_effect_IO$RacePair(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$RacePair(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$RacePair;", depth));
}
var $d_Lcats_effect_IO$RacePair = new $TypeData().initClass($c_Lcats_effect_IO$RacePair, "cats.effect.IO$RacePair", ({
  Lcats_effect_IO$RacePair: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Sleep(delay) {
  this.Lcats_effect_IO$Sleep__f_delay = null;
  this.Lcats_effect_IO$Sleep__f_delay = delay;
}
$c_Lcats_effect_IO$Sleep.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Sleep.prototype.constructor = $c_Lcats_effect_IO$Sleep;
/** @constructor */
function $h_Lcats_effect_IO$Sleep() {
}
$h_Lcats_effect_IO$Sleep.prototype = $c_Lcats_effect_IO$Sleep.prototype;
$c_Lcats_effect_IO$Sleep.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Sleep.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Sleep.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Sleep)) {
    var x$0$2 = $as_Lcats_effect_IO$Sleep(x$0);
    var x = this.Lcats_effect_IO$Sleep__f_delay;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Sleep__f_delay;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Sleep.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Sleep.prototype.productPrefix__T = (function() {
  return "Sleep";
});
$c_Lcats_effect_IO$Sleep.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Sleep__f_delay;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Sleep.prototype.tag__B = (function() {
  return 19;
});
function $as_Lcats_effect_IO$Sleep(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Sleep) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Sleep"));
}
function $isArrayOf_Lcats_effect_IO$Sleep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Sleep)));
}
function $asArrayOf_Lcats_effect_IO$Sleep(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Sleep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Sleep;", depth));
}
var $d_Lcats_effect_IO$Sleep = new $TypeData().initClass($c_Lcats_effect_IO$Sleep, "cats.effect.IO$Sleep", ({
  Lcats_effect_IO$Sleep: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Start(ioa) {
  this.Lcats_effect_IO$Start__f_ioa = null;
  this.Lcats_effect_IO$Start__f_ioa = ioa;
}
$c_Lcats_effect_IO$Start.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Start.prototype.constructor = $c_Lcats_effect_IO$Start;
/** @constructor */
function $h_Lcats_effect_IO$Start() {
}
$h_Lcats_effect_IO$Start.prototype = $c_Lcats_effect_IO$Start.prototype;
$c_Lcats_effect_IO$Start.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Start.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Start.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Start)) {
    var x$0$2 = $as_Lcats_effect_IO$Start(x$0);
    var x = this.Lcats_effect_IO$Start__f_ioa;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Start__f_ioa;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Start.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_IO$Start.prototype.productPrefix__T = (function() {
  return "Start";
});
$c_Lcats_effect_IO$Start.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Start__f_ioa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Start.prototype.tag__B = (function() {
  return 17;
});
function $as_Lcats_effect_IO$Start(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Start) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Start"));
}
function $isArrayOf_Lcats_effect_IO$Start(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Start)));
}
function $asArrayOf_Lcats_effect_IO$Start(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Start(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Start;", depth));
}
var $d_Lcats_effect_IO$Start = new $TypeData().initClass($c_Lcats_effect_IO$Start, "cats.effect.IO$Start", ({
  Lcats_effect_IO$Start: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Uncancelable(body, event) {
  this.Lcats_effect_IO$Uncancelable__f_body = null;
  this.Lcats_effect_IO$Uncancelable__f_event = null;
  this.Lcats_effect_IO$Uncancelable__f_body = body;
  this.Lcats_effect_IO$Uncancelable__f_event = event;
}
$c_Lcats_effect_IO$Uncancelable.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Uncancelable.prototype.constructor = $c_Lcats_effect_IO$Uncancelable;
/** @constructor */
function $h_Lcats_effect_IO$Uncancelable() {
}
$h_Lcats_effect_IO$Uncancelable.prototype = $c_Lcats_effect_IO$Uncancelable.prototype;
$c_Lcats_effect_IO$Uncancelable.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Uncancelable.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_IO$Uncancelable.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable)) {
    var x$0$2 = $as_Lcats_effect_IO$Uncancelable(x$0);
    var x = this.Lcats_effect_IO$Uncancelable__f_body;
    var x$2 = $n(x$0$2).Lcats_effect_IO$Uncancelable__f_body;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$Uncancelable__f_event;
      var x$4 = $n(x$0$2).Lcats_effect_IO$Uncancelable__f_event;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Uncancelable.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_IO$Uncancelable.prototype.productPrefix__T = (function() {
  return "Uncancelable";
});
$c_Lcats_effect_IO$Uncancelable.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Uncancelable__f_body;
  }
  if ((n === 1)) {
    return this.Lcats_effect_IO$Uncancelable__f_event;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Uncancelable.prototype.tag__B = (function() {
  return 12;
});
function $as_Lcats_effect_IO$Uncancelable(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Uncancelable) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Uncancelable"));
}
function $isArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Uncancelable)));
}
function $asArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Uncancelable;", depth));
}
var $d_Lcats_effect_IO$Uncancelable = new $TypeData().initClass($c_Lcats_effect_IO$Uncancelable, "cats.effect.IO$Uncancelable", ({
  Lcats_effect_IO$Uncancelable: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(ioa, id, self) {
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa = null;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id = 0;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self = null;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa = ioa;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id = id;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self = self;
}
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.constructor = $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop;
/** @constructor */
function $h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop() {
}
$h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype = $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype;
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("UnmaskRunLoop");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop)) {
    var x$0$2 = $as_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(x$0);
    if ((this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id === $n(x$0$2).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id)) {
      var x = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      var x$2 = $n(x$0$2).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      var x$4 = $n(x$0$2).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productArity__I = (function() {
  return 3;
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productPrefix__T = (function() {
  return "UnmaskRunLoop";
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      break;
    }
    case 1: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id;
      break;
    }
    case 2: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.tag__B = (function() {
  return 13;
});
function $as_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Uncancelable$UnmaskRunLoop"));
}
function $isArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Uncancelable$UnmaskRunLoop)));
}
function $asArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Uncancelable$UnmaskRunLoop;", depth));
}
var $d_Lcats_effect_IO$Uncancelable$UnmaskRunLoop = new $TypeData().initClass($c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop, "cats.effect.IO$Uncancelable$UnmaskRunLoop", ({
  Lcats_effect_IO$Uncancelable$UnmaskRunLoop: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, _cur0, cancelationIterations, autoCedeIterations) {
  var autoCedeIterations$tailLocal1 = autoCedeIterations;
  var cancelationIterations$tailLocal1 = cancelationIterations;
  var _cur0$tailLocal1 = _cur0;
  while (true) {
    if ((_cur0$tailLocal1 === $m_Lcats_effect_IO$EndFiber$())) {
      return (void 0);
    }
    var nextCancelation = ((cancelationIterations$tailLocal1 - 1) | 0);
    var nextAutoCede = autoCedeIterations$tailLocal1;
    if ((nextCancelation <= 0)) {
      nextCancelation = $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold;
      nextAutoCede = ((nextAutoCede - nextCancelation) | 0);
      if ((nextAutoCede <= 0)) {
        $thiz.Lcats_effect_IOFiber__f_resumeTag = 7;
        $thiz.Lcats_effect_IOFiber__f_resumeIO = _cur0$tailLocal1;
        var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
        $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
        return (void 0);
      }
    }
    if ($p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz)) {
      var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
      var cancelationIterations$tailLocal1$tmp1 = nextCancelation;
      var autoCedeIterations$tailLocal1$tmp1 = nextAutoCede;
      _cur0$tailLocal1 = fin;
      cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp1;
      autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp1;
    } else {
      if ((_cur0$tailLocal1 === null)) {
        var t = $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
        var cur0 = new $c_Lcats_effect_IO$Error(t);
      } else {
        var cur0 = _cur0$tailLocal1;
      }
      var x40 = $n(cur0).tag__B();
      switch (x40) {
        case 0: {
          var cur = $as_Lcats_effect_IO$Pure(cur0);
          var _cur0$tailLocal1$tmp2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $n(cur).Lcats_effect_IO$Pure__f_value, 0);
          var cancelationIterations$tailLocal1$tmp2 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp2 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp2;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp2;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp2;
          break;
        }
        case 1: {
          var cur$2 = $as_Lcats_effect_IO$Error(cur0);
          var ex = $n(cur$2).Lcats_effect_IO$Error__f_t;
          if ((!$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(ex))) {
            $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(ex);
          }
          var _cur0$tailLocal1$tmp3 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, ex, 0);
          var cancelationIterations$tailLocal1$tmp3 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp3 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp3;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp3;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp3;
          break;
        }
        case 2: {
          var cur$3 = $as_Lcats_effect_IO$Delay(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$3).Lcats_effect_IO$Delay__f_event);
          }
          var error = null;
          try {
            var r = $n($n(cur$3).Lcats_effect_IO$Delay__f_thunk).apply__O();
          } catch (e) {
            var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
            matchResult2: {
              if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
                error = e$2;
                break matchResult2;
              }
              $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
            }
            var r = (void 0);
          }
          var next = ((error === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, r, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, 0));
          var cancelationIterations$tailLocal1$tmp4 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp4 = nextAutoCede;
          _cur0$tailLocal1 = next;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp4;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp4;
          break;
        }
        case 3: {
          var $x_1 = $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler).nowMicros__J();
          var n_$_lo = $x_1.l;
          var n_$_hi = $x_1.h;
          var this$3 = new $c_s_concurrent_duration_package$DurationLong(n_$_lo, n_$_hi);
          var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
          var this$_$_lo = this$3.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
          var this$_$_hi = this$3.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
          $m_s_concurrent_duration_Duration$();
          var _cur0$tailLocal1$tmp5 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_concurrent_duration_FiniteDuration(this$_$_lo, this$_$_hi, unit), 0);
          var cancelationIterations$tailLocal1$tmp5 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp5 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp5;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp5;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp5;
          break;
        }
        case 4: {
          $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler);
          var value = (1000000.0 * $uD($m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
          var $x_2 = $m_RTLong$().fromDouble__D__J(value);
          var n$1_$_lo = $x_2.l;
          var n$1_$_hi = $x_2.h;
          var this$9 = new $c_s_concurrent_duration_package$DurationLong(n$1_$_lo, n$1_$_hi);
          var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
          var this$$1_$_lo = this$9.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
          var this$$1_$_hi = this$9.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
          $m_s_concurrent_duration_Duration$();
          var _cur0$tailLocal1$tmp6 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_concurrent_duration_FiniteDuration(this$$1_$_lo, this$$1_$_hi, unit$1), 0);
          var cancelationIterations$tailLocal1$tmp6 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp6 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp6;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp6;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp6;
          break;
        }
        case 5: {
          var _cur0$tailLocal1$tmp7 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $thiz.Lcats_effect_IOFiber__f_currentCtx, 0);
          var cancelationIterations$tailLocal1$tmp7 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp7 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp7;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp7;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp7;
          break;
        }
        case 6: {
          var cur$4 = $as_Lcats_effect_IO$Map(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$4).Lcats_effect_IO$Map__f_event);
          }
          var ioe = $n(cur$4).Lcats_effect_IO$Map__f_ioe;
          var f = $n(cur$4).Lcats_effect_IO$Map__f_f;
          var x8 = $n(ioe).tag__B();
          switch (x8) {
            case 0: {
              var pure = $as_Lcats_effect_IO$Pure(ioe);
              var _cur0$tailLocal1$tmp8 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, $n(pure).Lcats_effect_IO$Pure__f_value);
              var cancelationIterations$tailLocal1$tmp8 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp8 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp8;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp8;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp8;
              break;
            }
            case 1: {
              var error$2 = $as_Lcats_effect_IO$Error(ioe);
              var ex$2 = $n(error$2).Lcats_effect_IO$Error__f_t;
              if ((!$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(ex$2))) {
                $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(ex$2);
              }
              var _cur0$tailLocal1$tmp9 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, ex$2, 0);
              var cancelationIterations$tailLocal1$tmp9 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp9 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp9;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp9;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp9;
              break;
            }
            case 2: {
              var delay = $as_Lcats_effect_IO$Delay(ioe);
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(delay).Lcats_effect_IO$Delay__f_event);
              }
              var error$3 = null;
              try {
                var result = $n(f).apply__O__O($n($n(delay).Lcats_effect_IO$Delay__f_thunk).apply__O());
              } catch (e$3) {
                var e$4 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
                matchResult4: {
                  if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$4)) {
                    error$3 = e$4;
                    break matchResult4;
                  }
                  $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$4);
                }
                var result = (void 0);
              }
              var nextIO = ((error$3 === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error$3, 0));
              var cancelationIterations$tailLocal1$tmp10 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp10 = nextAutoCede;
              _cur0$tailLocal1 = nextIO;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp10;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp10;
              break;
            }
            case 3: {
              var $x_3 = $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler).nowMicros__J();
              var n$2_$_lo = $x_3.l;
              var n$2_$_hi = $x_3.h;
              var this$13 = new $c_s_concurrent_duration_package$DurationLong(n$2_$_lo, n$2_$_hi);
              var unit$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              var this$$2_$_lo = this$13.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
              var this$$2_$_hi = this$13.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
              $m_s_concurrent_duration_Duration$();
              var realTime = new $c_s_concurrent_duration_FiniteDuration(this$$2_$_lo, this$$2_$_hi, unit$2);
              var _cur0$tailLocal1$tmp11 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, realTime);
              var cancelationIterations$tailLocal1$tmp11 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp11 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp11;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp11;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp11;
              break;
            }
            case 4: {
              $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler);
              var value$1 = (1000000.0 * $uD($m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
              var $x_4 = $m_RTLong$().fromDouble__D__J(value$1);
              var n$3_$_lo = $x_4.l;
              var n$3_$_hi = $x_4.h;
              var this$19 = new $c_s_concurrent_duration_package$DurationLong(n$3_$_lo, n$3_$_hi);
              var unit$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var this$$3_$_lo = this$19.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
              var this$$3_$_hi = this$19.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
              $m_s_concurrent_duration_Duration$();
              var monotonic = new $c_s_concurrent_duration_FiniteDuration(this$$3_$_lo, this$$3_$_hi, unit$3);
              var _cur0$tailLocal1$tmp12 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, monotonic);
              var cancelationIterations$tailLocal1$tmp12 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp12 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp12;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp12;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp12;
              break;
            }
            case 5: {
              var ec$2 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var _cur0$tailLocal1$tmp13 = $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f, ec$2);
              var cancelationIterations$tailLocal1$tmp13 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp13 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp13;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp13;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp13;
              break;
            }
            default: {
              var this$$4 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$4.push(f);
              var stack = $thiz.Lcats_effect_IOFiber__f_conts;
              var c = $uI(stack[0]);
              var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
              var s = ((1 + (c >> 3)) | 0);
              var shift = ((7 & c) << 2);
              use[s] = ($uI(use[s]) & (~((-1) << shift)));
              use[0] = ((1 + $uI(use[0])) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use;
              var cancelationIterations$tailLocal1$tmp14 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp14 = nextAutoCede;
              _cur0$tailLocal1 = ioe;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp14;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp14;
            }
          }
          break;
        }
        case 7: {
          var cur$5 = $as_Lcats_effect_IO$FlatMap(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$5).Lcats_effect_IO$FlatMap__f_event);
          }
          var ioe$2 = $n(cur$5).Lcats_effect_IO$FlatMap__f_ioe;
          var f$2 = $n(cur$5).Lcats_effect_IO$FlatMap__f_f;
          var x13 = $n(ioe$2).tag__B();
          switch (x13) {
            case 0: {
              var pure$2 = $as_Lcats_effect_IO$Pure(ioe$2);
              var _cur0$tailLocal1$tmp15 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, $n(pure$2).Lcats_effect_IO$Pure__f_value);
              var cancelationIterations$tailLocal1$tmp15 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp15 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp15;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp15;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp15;
              break;
            }
            case 1: {
              var error$4 = $as_Lcats_effect_IO$Error(ioe$2);
              var ex$3 = $n(error$4).Lcats_effect_IO$Error__f_t;
              if ((!$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(ex$3))) {
                $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(ex$3);
              }
              var _cur0$tailLocal1$tmp16 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, ex$3, 0);
              var cancelationIterations$tailLocal1$tmp16 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp16 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp16;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp16;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp16;
              break;
            }
            case 2: {
              var delay$2 = $as_Lcats_effect_IO$Delay(ioe$2);
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(delay$2).Lcats_effect_IO$Delay__f_event);
              }
              try {
                var result$2 = $as_Lcats_effect_IO($n(f$2).apply__O__O($n($n(delay$2).Lcats_effect_IO$Delay__f_thunk).apply__O()));
              } catch (e$5) {
                var e$6 = ((e$5 instanceof $c_jl_Throwable) ? e$5 : new $c_sjs_js_JavaScriptException(e$5));
                matchResult7: {
                  var result$2;
                  if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$6)) {
                    var result$2 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, e$6, 0);
                    break matchResult7;
                  }
                  $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$6);
                }
              }
              var cancelationIterations$tailLocal1$tmp17 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp17 = nextAutoCede;
              _cur0$tailLocal1 = result$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp17;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp17;
              break;
            }
            case 3: {
              var $x_5 = $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler).nowMicros__J();
              var n$4_$_lo = $x_5.l;
              var n$4_$_hi = $x_5.h;
              var this$25 = new $c_s_concurrent_duration_package$DurationLong(n$4_$_lo, n$4_$_hi);
              var unit$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              var this$$5_$_lo = this$25.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
              var this$$5_$_hi = this$25.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
              $m_s_concurrent_duration_Duration$();
              var realTime$2 = new $c_s_concurrent_duration_FiniteDuration(this$$5_$_lo, this$$5_$_hi, unit$4);
              var _cur0$tailLocal1$tmp18 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, realTime$2);
              var cancelationIterations$tailLocal1$tmp18 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp18 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp18;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp18;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp18;
              break;
            }
            case 4: {
              $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler);
              var value$2 = (1000000.0 * $uD($m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
              var $x_6 = $m_RTLong$().fromDouble__D__J(value$2);
              var n$5_$_lo = $x_6.l;
              var n$5_$_hi = $x_6.h;
              var this$31 = new $c_s_concurrent_duration_package$DurationLong(n$5_$_lo, n$5_$_hi);
              var unit$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var this$$6_$_lo = this$31.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
              var this$$6_$_hi = this$31.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
              $m_s_concurrent_duration_Duration$();
              var monotonic$2 = new $c_s_concurrent_duration_FiniteDuration(this$$6_$_lo, this$$6_$_hi, unit$5);
              var _cur0$tailLocal1$tmp19 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, monotonic$2);
              var cancelationIterations$tailLocal1$tmp19 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp19 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp19;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp19;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp19;
              break;
            }
            case 5: {
              var ec$3 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var _cur0$tailLocal1$tmp20 = $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, ec$3);
              var cancelationIterations$tailLocal1$tmp20 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp20 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp20;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp20;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp20;
              break;
            }
            default: {
              var this$$7 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$7.push(f$2);
              var stack$1 = $thiz.Lcats_effect_IOFiber__f_conts;
              var c$1 = $uI(stack$1[0]);
              var use$1 = ((((1 + (((1 + c$1) | 0) >> 3)) | 0) < $uI(stack$1.length)) ? stack$1 : (stack$1.push(0), stack$1));
              var s$1 = ((1 + (c$1 >> 3)) | 0);
              var shift$1 = ((7 & c$1) << 2);
              use$1[s$1] = (($uI(use$1[s$1]) & (~((-1) << shift$1))) | (1 << shift$1));
              use$1[0] = ((1 + $uI(use$1[0])) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use$1;
              var cancelationIterations$tailLocal1$tmp21 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp21 = nextAutoCede;
              _cur0$tailLocal1 = ioe$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp21;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp21;
            }
          }
          break;
        }
        case 8: {
          var cur$6 = $as_Lcats_effect_IO$Attempt(cur0);
          var ioa = $n(cur$6).Lcats_effect_IO$Attempt__f_ioa;
          var x16 = $n(ioa).tag__B();
          switch (x16) {
            case 0: {
              var pure$3 = $as_Lcats_effect_IO$Pure(ioa);
              var value$3 = $n(pure$3).Lcats_effect_IO$Pure__f_value;
              var _cur0$tailLocal1$tmp22 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(value$3), 0);
              var cancelationIterations$tailLocal1$tmp22 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp22 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp22;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp22;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp22;
              break;
            }
            case 1: {
              var error$5 = $as_Lcats_effect_IO$Error(ioa);
              var t$7 = $n(error$5).Lcats_effect_IO$Error__f_t;
              if ((!$m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(t$7))) {
                $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(t$7);
              }
              $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, t$7, $thiz.Lcats_effect_IOFiber__f_tracingEvents);
              var _cur0$tailLocal1$tmp23 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Left(t$7), 0);
              var cancelationIterations$tailLocal1$tmp23 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp23 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp23;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp23;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp23;
              break;
            }
            case 2: {
              var delay$3 = $as_Lcats_effect_IO$Delay(ioa);
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(delay$3).Lcats_effect_IO$Delay__f_event);
              }
              var error$6 = null;
              try {
                var result$3 = $n($n(delay$3).Lcats_effect_IO$Delay__f_thunk).apply__O();
              } catch (e$7) {
                var e$8 = ((e$7 instanceof $c_jl_Throwable) ? e$7 : new $c_sjs_js_JavaScriptException(e$7));
                matchResult9: {
                  if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$8)) {
                    $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, e$8, $thiz.Lcats_effect_IOFiber__f_tracingEvents);
                    error$6 = e$8;
                    break matchResult9;
                  }
                  $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$8);
                }
                var result$3 = (void 0);
              }
              if ((error$6 === null)) {
                var next$2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(result$3), 0);
              } else {
                var value$4 = error$6;
                var next$2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Left(value$4), 0);
              }
              var cancelationIterations$tailLocal1$tmp24 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp24 = nextAutoCede;
              _cur0$tailLocal1 = next$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp24;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp24;
              break;
            }
            case 3: {
              var $x_7 = $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler).nowMicros__J();
              var n$6_$_lo = $x_7.l;
              var n$6_$_hi = $x_7.h;
              var this$41 = new $c_s_concurrent_duration_package$DurationLong(n$6_$_lo, n$6_$_hi);
              var unit$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              var this$$8_$_lo = this$41.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
              var this$$8_$_hi = this$41.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
              $m_s_concurrent_duration_Duration$();
              var realTime$3 = new $c_s_concurrent_duration_FiniteDuration(this$$8_$_lo, this$$8_$_hi, unit$6);
              var _cur0$tailLocal1$tmp25 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(realTime$3), 0);
              var cancelationIterations$tailLocal1$tmp25 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp25 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp25;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp25;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp25;
              break;
            }
            case 4: {
              $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler);
              var value$5 = (1000000.0 * $uD($m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
              var $x_8 = $m_RTLong$().fromDouble__D__J(value$5);
              var n$7_$_lo = $x_8.l;
              var n$7_$_hi = $x_8.h;
              var this$48 = new $c_s_concurrent_duration_package$DurationLong(n$7_$_lo, n$7_$_hi);
              var unit$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var this$$9_$_lo = this$48.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$lo;
              var this$$9_$_hi = this$48.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n_$hi;
              $m_s_concurrent_duration_Duration$();
              var monotonic$3 = new $c_s_concurrent_duration_FiniteDuration(this$$9_$_lo, this$$9_$_hi, unit$7);
              var _cur0$tailLocal1$tmp26 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(monotonic$3), 0);
              var cancelationIterations$tailLocal1$tmp26 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp26 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp26;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp26;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp26;
              break;
            }
            case 5: {
              var ec$4 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var _cur0$tailLocal1$tmp27 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Right(ec$4), 0);
              var cancelationIterations$tailLocal1$tmp27 = ((nextCancelation - 1) | 0);
              var autoCedeIterations$tailLocal1$tmp27 = nextAutoCede;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp27;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp27;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp27;
              break;
            }
            default: {
              var stack$2 = $thiz.Lcats_effect_IOFiber__f_conts;
              var c$2 = $uI(stack$2[0]);
              var use$2 = ((((1 + (((1 + c$2) | 0) >> 3)) | 0) < $uI(stack$2.length)) ? stack$2 : (stack$2.push(0), stack$2));
              var s$2 = ((1 + (c$2 >> 3)) | 0);
              var shift$2 = ((7 & c$2) << 2);
              use$2[s$2] = (($uI(use$2[s$2]) & (~((-1) << shift$2))) | (9 << shift$2));
              use$2[0] = ((1 + $uI(use$2[0])) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use$2;
              var cancelationIterations$tailLocal1$tmp28 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp28 = nextAutoCede;
              _cur0$tailLocal1 = ioa;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp28;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp28;
            }
          }
          break;
        }
        case 9: {
          var cur$7 = $as_Lcats_effect_IO$HandleErrorWith(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$7).Lcats_effect_IO$HandleErrorWith__f_event);
          }
          var this$$10 = $thiz.Lcats_effect_IOFiber__f_objectState;
          var a = $n(cur$7).Lcats_effect_IO$HandleErrorWith__f_f;
          this$$10.push(a);
          var stack$3 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$3 = $uI(stack$3[0]);
          var use$3 = ((((1 + (((1 + c$3) | 0) >> 3)) | 0) < $uI(stack$3.length)) ? stack$3 : (stack$3.push(0), stack$3));
          var s$3 = ((1 + (c$3 >> 3)) | 0);
          var shift$3 = ((7 & c$3) << 2);
          use$3[s$3] = (($uI(use$3[s$3]) & (~((-1) << shift$3))) | (5 << shift$3));
          use$3[0] = ((1 + $uI(use$3[0])) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$3;
          var _cur0$tailLocal1$tmp29 = $n(cur$7).Lcats_effect_IO$HandleErrorWith__f_ioa;
          var cancelationIterations$tailLocal1$tmp29 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp29 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp29;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp29;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp29;
          break;
        }
        case 10: {
          $thiz.Lcats_effect_IOFiber__f_canceled = true;
          if ($p_Lcats_effect_IOFiber__isUnmasked__Z($thiz)) {
            var fin$2 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
            var cancelationIterations$tailLocal1$tmp30 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp30 = nextAutoCede;
            _cur0$tailLocal1 = fin$2;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp30;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp30;
          } else {
            var _cur0$tailLocal1$tmp31 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, (void 0), 0);
            var cancelationIterations$tailLocal1$tmp31 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp31 = nextAutoCede;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp31;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp31;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp31;
          }
          break;
        }
        case 11: {
          var cur$8 = $as_Lcats_effect_IO$OnCancel(cur0);
          var this$$11 = $thiz.Lcats_effect_IOFiber__f_finalizers;
          var ioa$1 = $n(cur$8).Lcats_effect_IO$OnCancel__f_fin;
          var ec$1 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
          var a$1 = new $c_Lcats_effect_IO$EvalOn(ioa$1, ec$1);
          this$$11.push(a$1);
          var stack$4 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$4 = $uI(stack$4[0]);
          var use$4 = ((((1 + (((1 + c$4) | 0) >> 3)) | 0) < $uI(stack$4.length)) ? stack$4 : (stack$4.push(0), stack$4));
          var s$4 = ((1 + (c$4 >> 3)) | 0);
          var shift$4 = ((7 & c$4) << 2);
          use$4[s$4] = (($uI(use$4[s$4]) & (~((-1) << shift$4))) | (6 << shift$4));
          use$4[0] = ((1 + $uI(use$4[0])) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$4;
          var _cur0$tailLocal1$tmp32 = $n(cur$8).Lcats_effect_IO$OnCancel__f_ioa;
          var cancelationIterations$tailLocal1$tmp32 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp32 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp32;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp32;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp32;
          break;
        }
        case 12: {
          var cur$9 = $as_Lcats_effect_IO$Uncancelable(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$9).Lcats_effect_IO$Uncancelable__f_event);
          }
          $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
          var id = $thiz.Lcats_effect_IOFiber__f_masks;
          var poll = new $c_Lcats_effect_IOFiber$$anon$1(id, $thiz);
          try {
            var next$3 = $as_Lcats_effect_IO($n($n(cur$9).Lcats_effect_IO$Uncancelable__f_body).apply__O__O(poll));
          } catch (e$9) {
            var e$10 = ((e$9 instanceof $c_jl_Throwable) ? e$9 : new $c_sjs_js_JavaScriptException(e$9));
            matchResult11: {
              var next$3;
              if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$10)) {
                $m_Lcats_effect_IO$();
                var next$3 = new $c_Lcats_effect_IO$Error(e$10);
                break matchResult11;
              }
              $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$10);
            }
          }
          var stack$5 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$5 = $uI(stack$5[0]);
          var use$5 = ((((1 + (((1 + c$5) | 0) >> 3)) | 0) < $uI(stack$5.length)) ? stack$5 : (stack$5.push(0), stack$5));
          var s$5 = ((1 + (c$5 >> 3)) | 0);
          var shift$5 = ((7 & c$5) << 2);
          use$5[s$5] = (($uI(use$5[s$5]) & (~((-1) << shift$5))) | (7 << shift$5));
          use$5[0] = ((1 + $uI(use$5[0])) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$5;
          var cancelationIterations$tailLocal1$tmp33 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp33 = nextAutoCede;
          _cur0$tailLocal1 = next$3;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp33;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp33;
          break;
        }
        case 13: {
          var cur$10 = $as_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(cur0);
          if ((($thiz.Lcats_effect_IOFiber__f_masks === $n(cur$10).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id) && ($thiz === $n(cur$10).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self))) {
            $thiz.Lcats_effect_IOFiber__f_masks = (($thiz.Lcats_effect_IOFiber__f_masks - 1) | 0);
            var stack$6 = $thiz.Lcats_effect_IOFiber__f_conts;
            var c$6 = $uI(stack$6[0]);
            var use$6 = ((((1 + (((1 + c$6) | 0) >> 3)) | 0) < $uI(stack$6.length)) ? stack$6 : (stack$6.push(0), stack$6));
            var s$6 = ((1 + (c$6 >> 3)) | 0);
            var shift$6 = ((7 & c$6) << 2);
            use$6[s$6] = (($uI(use$6[s$6]) & (~((-1) << shift$6))) | (8 << shift$6));
            use$6[0] = ((1 + $uI(use$6[0])) | 0);
            $thiz.Lcats_effect_IOFiber__f_conts = use$6;
          }
          var _cur0$tailLocal1$tmp34 = $n(cur$10).Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
          var cancelationIterations$tailLocal1$tmp34 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp34 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp34;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp34;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp34;
          break;
        }
        case 14: {
          var cur$11 = $as_Lcats_effect_IO$IOCont(cur0);
          var body = $n(cur$11).Lcats_effect_IO$IOCont__f_body;
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$11).Lcats_effect_IO$IOCont__f_event);
          }
          var state = new $c_Lcats_effect_ContState($thiz.Lcats_effect_IOFiber__f_finalizing);
          var cb = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((state) => ((e$11) => {
            var e$1 = $as_s_util_Either(e$11);
            if ((e$1 === null)) {
              var value$6 = $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
              var result$1 = new $c_s_util_Left(value$6);
            } else {
              var result$1 = e$1;
            }
            var waiting = state.Lcats_effect_ContState__f_waiting;
            $p_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__s_util_Either__V($thiz, state, waiting, result$1);
          }))(state));
          var get = new $c_Lcats_effect_IO$IOCont$Get(state);
          try {
            var next$4 = $as_Lcats_effect_IO($n($n(body).apply__Lcats_effect_kernel_MonadCancel__F3($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO)).apply__O__O__O__O(cb, get, new $c_Lcats_arrow_FunctionK$$anon$4()));
          } catch (e$12) {
            var e$13 = ((e$12 instanceof $c_jl_Throwable) ? e$12 : new $c_sjs_js_JavaScriptException(e$12));
            matchResult13: {
              var next$4;
              if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$13)) {
                $m_Lcats_effect_IO$();
                var next$4 = new $c_Lcats_effect_IO$Error(e$13);
                break matchResult13;
              }
              $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$13);
            }
          }
          var cancelationIterations$tailLocal1$tmp35 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp35 = nextAutoCede;
          _cur0$tailLocal1 = next$4;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp35;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp35;
          break;
        }
        case 15: {
          var cur$12 = $as_Lcats_effect_IO$IOCont$Get(cur0);
          var state$3 = $n(cur$12).Lcats_effect_IO$IOCont$Get__f_state;
          var this$69 = $m_Lcats_effect_IO$();
          var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((state$3) => (() => {
            $n(state$3).compareAndSet__O__O__Z($n(state$3).Lcats_effect_ContState__f_waiting, null);
          }))(state$3));
          var fin$3 = this$69.delay__F0__Lcats_effect_IO(thunk);
          var this$$12 = $thiz.Lcats_effect_IOFiber__f_finalizers;
          this$$12.push(fin$3);
          var stack$7 = $thiz.Lcats_effect_IOFiber__f_conts;
          var c$7 = $uI(stack$7[0]);
          var use$7 = ((((1 + (((1 + c$7) | 0) >> 3)) | 0) < $uI(stack$7.length)) ? stack$7 : (stack$7.push(0), stack$7));
          var s$7 = ((1 + (c$7 >> 3)) | 0);
          var shift$7 = ((7 & c$7) << 2);
          use$7[s$7] = (($uI(use$7[s$7]) & (~((-1) << shift$7))) | (6 << shift$7));
          use$7[0] = ((1 + $uI(use$7[0])) | 0);
          $thiz.Lcats_effect_IOFiber__f_conts = use$7;
          if ($n(state$3).compareAndSet__O__O__Z(null, $n(state$3).Lcats_effect_ContState__f_waiting)) {
            $n(state$3).Lcats_effect_ContState__f_wasFinalizing = $thiz.Lcats_effect_IOFiber__f_finalizing;
            if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
              $n(state$3).Lcats_effect_ContState__f_handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
              var this$$13 = $thiz.Lcats_effect_IOFiber__f_finalizers;
              var this$72 = $m_Lcats_effect_IO$();
              var thunk$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((state$3) => (() => {
                $n($n(state$3).Lcats_effect_ContState__f_handle).deregister__V();
              }))(state$3));
              var a$2 = this$72.delay__F0__Lcats_effect_IO(thunk$1);
              this$$13.push(a$2);
              var stack$8 = $thiz.Lcats_effect_IOFiber__f_conts;
              var c$8 = $uI(stack$8[0]);
              var use$8 = ((((1 + (((1 + c$8) | 0) >> 3)) | 0) < $uI(stack$8.length)) ? stack$8 : (stack$8.push(0), stack$8));
              var s$8 = ((1 + (c$8 >> 3)) | 0);
              var shift$8 = ((7 & c$8) << 2);
              use$8[s$8] = (($uI(use$8[s$8]) & (~((-1) << shift$8))) | (6 << shift$8));
              use$8[0] = ((1 + $uI(use$8[0])) | 0);
              $thiz.Lcats_effect_IOFiber__f_conts = use$8;
            }
            $thiz.getAndSet__Z__Z(true);
            if ($p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz)) {
              if ($thiz.getAndSet__Z__Z(false)) {
                if ($p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz)) {
                  var fin$4 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
                  var cancelationIterations$tailLocal1$tmp36 = nextCancelation;
                  var autoCedeIterations$tailLocal1$tmp36 = nextAutoCede;
                  _cur0$tailLocal1 = fin$4;
                  cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp36;
                  autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp36;
                } else {
                  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = true;
                  return (void 0);
                }
              } else {
                return (void 0);
              }
            } else {
              return (void 0);
            }
          } else {
            var result$4 = $as_s_util_Either($n(state$3).ju_concurrent_atomic_AtomicReference__f_value);
            if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
              matchResult14: {
                var next$5;
                if ((result$4 instanceof $c_s_util_Left)) {
                  var t$14 = $as_jl_Throwable($n($as_s_util_Left(result$4)).s_util_Left__f_value);
                  var next$5 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, t$14, 0);
                  break matchResult14;
                }
                if ((result$4 instanceof $c_s_util_Right)) {
                  var a$3 = $n($as_s_util_Right(result$4)).s_util_Right__f_value;
                  var next$5 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, a$3, 0);
                  break matchResult14;
                }
                throw new $c_s_MatchError(result$4);
              }
              var cancelationIterations$tailLocal1$tmp37 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp37 = nextAutoCede;
              _cur0$tailLocal1 = next$5;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp37;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp37;
            } else if (($thiz.Lcats_effect_IOFiber__f_outcome === null)) {
              var fin$5 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
              var cancelationIterations$tailLocal1$tmp38 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp38 = nextAutoCede;
              _cur0$tailLocal1 = fin$5;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp38;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp38;
            } else {
              return (void 0);
            }
          }
          break;
        }
        case 16: {
          $thiz.Lcats_effect_IOFiber__f_resumeTag = 6;
          var ec$5 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
          $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$5, $thiz);
          return (void 0);
          break;
        }
        case 17: {
          var cur$13 = $as_Lcats_effect_IO$Start(cur0);
          var ec$5$1 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
          var fiber = new $c_Lcats_effect_IOFiber($thiz.Lcats_effect_IOFiber__f_localState, null, $n(cur$13).Lcats_effect_IO$Start__f_ioa, ec$5$1, $thiz.Lcats_effect_IOFiber__f_runtime);
          $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$5$1, fiber);
          var _cur0$tailLocal1$tmp39 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, fiber, 0);
          var cancelationIterations$tailLocal1$tmp39 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp39 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp39;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp39;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp39;
          break;
        }
        case 18: {
          var cur$14 = $as_Lcats_effect_IO$RacePair(cur0);
          var next$6 = $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cur$14) => ((cb$2) => {
            var cb$1 = $as_F1(cb$2);
            var this$86 = $m_Lcats_effect_IO$();
            var thunk$2 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
              var ec$6 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
              var rt = $thiz.Lcats_effect_IOFiber__f_runtime;
              var fiberA = new $c_Lcats_effect_IOFiber($thiz.Lcats_effect_IOFiber__f_localState, null, $n(cur$14).Lcats_effect_IO$RacePair__f_ioa, ec$6, rt);
              var fiberB = new $c_Lcats_effect_IOFiber($thiz.Lcats_effect_IOFiber__f_localState, null, $n(cur$14).Lcats_effect_IO$RacePair__f_iob, ec$6, rt);
              $p_Lcats_effect_IOFiber__setCallback__F1__V(fiberA, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oc) => {
                var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
                var $x_9 = $n(cb$1);
                var value$7 = new $c_T2(oc$1, fiberB);
                var value$8 = new $c_s_util_Left(value$7);
                $x_9.apply__O__O(new $c_s_util_Right(value$8));
              })));
              $p_Lcats_effect_IOFiber__setCallback__F1__V(fiberB, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oc$2) => {
                var oc$3 = $as_Lcats_effect_kernel_Outcome(oc$2);
                var $x_10 = $n(cb$1);
                var value$9 = new $c_T2(fiberA, oc$3);
                var value$10 = new $c_s_util_Right(value$9);
                $x_10.apply__O__O(new $c_s_util_Right(value$10));
              })));
              $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$6, fiberA);
              $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$6, fiberB);
              var this$81 = $n(fiberA.cancel__Lcats_effect_IO());
              var cancel = new $c_Lcats_effect_IO$Start(this$81).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cancelA) => {
                var cancelA$1 = $as_Lcats_effect_kernel_Fiber(cancelA);
                var this$83 = $n(fiberB.cancel__Lcats_effect_IO());
                return new $c_Lcats_effect_IO$Start(this$83).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cancelB) => {
                  var cancelB$1 = $as_Lcats_effect_kernel_Fiber(cancelB);
                  return $n($as_Lcats_effect_IO($n(cancelA$1).join__O())).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
                    $as_Lcats_effect_kernel_Outcome(x$1);
                    return $n($as_Lcats_effect_IO($n(cancelB$1).join__O())).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
                      $as_Lcats_effect_kernel_Outcome(x$1$2);
                    })));
                  })));
                })));
              })));
              return new $c_s_Some(cancel);
            }));
            return this$86.delay__F0__Lcats_effect_IO(thunk$2);
          }))(cur$14)));
          var cancelationIterations$tailLocal1$tmp40 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp40 = nextAutoCede;
          _cur0$tailLocal1 = next$6;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp40;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp40;
          break;
        }
        case 19: {
          var cur$16 = $as_Lcats_effect_IO$Sleep(cur0);
          var delay$4 = $n(cur$16).Lcats_effect_IO$Sleep__f_delay;
          var x_$_lo = $n(delay$4).s_concurrent_duration_FiniteDuration__f_length_$lo;
          var x_$_hi = $n(delay$4).s_concurrent_duration_FiniteDuration__f_length_$hi;
          if (((x_$_hi === 0) ? (x_$_lo !== 0) : (x_$_hi > 0))) {
            var next$7 = $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((delay$4) => ((cb$3) => {
              var cb$4 = $as_F1(cb$3);
              var this$91 = $m_Lcats_effect_IO$();
              var thunk$5 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
                var scheduler = $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_scheduler;
                if (false) {
                  var cancel$1 = $n($as_Lcats_effect_unsafe_WorkStealingThreadPool(scheduler)).sleepInternal__s_concurrent_duration_FiniteDuration__F1__jl_Runnable(delay$4, cb$4);
                  var thunk$3 = $as_F0(cancel$1);
                  var cancelIO = new $c_Lcats_effect_IO$Delay(thunk$3, null);
                } else {
                  var cancel$2 = $n(scheduler).sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable(delay$4, new $c_Lcats_effect_IOFiber$$anon$2(cb$4, $thiz));
                  var this$89 = $m_Lcats_effect_IO$();
                  var thunk$4 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
                    $n(cancel$2).run__V();
                  }));
                  var cancelIO = this$89.delay__F0__Lcats_effect_IO(thunk$4);
                }
                return new $c_s_Some(cancelIO);
              }));
              return this$91.delay__F0__Lcats_effect_IO(thunk$5);
            }))(delay$4)));
          } else {
            $m_Lcats_effect_IO$();
            var next$7 = $m_Lcats_effect_IO$Cede$();
          }
          var cancelationIterations$tailLocal1$tmp41 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp41 = nextAutoCede;
          _cur0$tailLocal1 = next$7;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp41;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp41;
          break;
        }
        case 20: {
          var cur$17 = $as_Lcats_effect_IO$EvalOn(cur0);
          if (($n(cur$17).Lcats_effect_IO$EvalOn__f_ec === $thiz.Lcats_effect_IOFiber__f_currentCtx)) {
            var _cur0$tailLocal1$tmp42 = $n(cur$17).Lcats_effect_IO$EvalOn__f_ioa;
            var cancelationIterations$tailLocal1$tmp42 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp42 = nextAutoCede;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp42;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp42;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp42;
          } else {
            var ec$6$1 = $n(cur$17).Lcats_effect_IO$EvalOn__f_ec;
            var this$$14 = $thiz.Lcats_effect_IOFiber__f_objectState;
            var a$4 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
            this$$14.push(a$4);
            $thiz.Lcats_effect_IOFiber__f_currentCtx = ec$6$1;
            var stack$9 = $thiz.Lcats_effect_IOFiber__f_conts;
            var c$9 = $uI(stack$9[0]);
            var use$9 = ((((1 + (((1 + c$9) | 0) >> 3)) | 0) < $uI(stack$9.length)) ? stack$9 : (stack$9.push(0), stack$9));
            var s$9 = ((1 + (c$9 >> 3)) | 0);
            var shift$9 = ((7 & c$9) << 2);
            use$9[s$9] = (($uI(use$9[s$9]) & (~((-1) << shift$9))) | (4 << shift$9));
            use$9[0] = ((1 + $uI(use$9[0])) | 0);
            $thiz.Lcats_effect_IOFiber__f_conts = use$9;
            $thiz.Lcats_effect_IOFiber__f_resumeTag = 7;
            $thiz.Lcats_effect_IOFiber__f_resumeIO = $n(cur$17).Lcats_effect_IO$EvalOn__f_ioa;
            if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
              var handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
              var this$$15 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$15.push(handle);
            }
            $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec$6$1, $thiz);
            return (void 0);
          }
          break;
        }
        case 21: {
          var cur$18 = $as_Lcats_effect_IO$Blocking(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, $n(cur$18).event__Lcats_effect_tracing_TracingEvent());
          }
          if (($n(cur$18).hint__Lcats_effect_kernel_Sync$Type() === $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_TypeBlocking)) {
            var ec$7 = $thiz.Lcats_effect_IOFiber__f_currentCtx;
            if (false) {
              var wstp = $as_Lcats_effect_unsafe_WorkStealingThreadPool(ec$7);
              if ($n(wstp).canExecuteBlockingCode__Z()) {
                $n(wstp).prepareForBlocking__V();
                var error$7 = null;
                try {
                  var r$2 = $n($n(cur$18).thunk__F0()).apply__O();
                } catch (e$14) {
                  var e$15 = ((e$14 instanceof $c_jl_Throwable) ? e$14 : new $c_sjs_js_JavaScriptException(e$14));
                  matchResult17: {
                    if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$15)) {
                      error$7 = e$15;
                      break matchResult17;
                    }
                    $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$15);
                  }
                  var r$2 = (void 0);
                }
                var next$8 = ((error$7 === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, r$2, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error$7, 0));
                var cancelationIterations$tailLocal1$tmp43 = nextCancelation;
                var autoCedeIterations$tailLocal1$tmp43 = $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold;
                _cur0$tailLocal1 = next$8;
                cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp43;
                autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp43;
              } else {
                $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur$18);
                return (void 0);
              }
            } else {
              $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur$18);
              return (void 0);
            }
          } else {
            var _cur0$tailLocal1$tmp45 = $thiz.interruptibleImpl__Lcats_effect_IO$Blocking__Lcats_effect_IO(cur$18);
            var cancelationIterations$tailLocal1$tmp45 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp45 = nextAutoCede;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp45;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp45;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp45;
          }
          break;
        }
        case 22: {
          var cur$19 = $as_Lcats_effect_IO$Local(cur0);
          matchResult19: {
            var \u03b41$___1;
            var \u03b41$___2;
            var x37 = $as_T2($n($n(cur$19).f__F1()).apply__O__O($thiz.Lcats_effect_IOFiber__f_localState));
            if ((x37 !== null)) {
              var nextLocalState = $as_sci_Map($n(x37)._1__O());
              var value$11 = $n(x37)._2__O();
              var \u03b41$___1 = nextLocalState;
              var \u03b41$___2 = value$11;
              break matchResult19;
            }
            throw new $c_s_MatchError(x37);
          }
          var nextLocalState$2 = $as_sci_Map(\u03b41$___1);
          var value$2$1 = \u03b41$___2;
          $thiz.Lcats_effect_IOFiber__f_localState = nextLocalState$2;
          var _cur0$tailLocal1$tmp46 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, value$2$1, 0);
          var cancelationIterations$tailLocal1$tmp46 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp46 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp46;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp46;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp46;
          break;
        }
        case 23: {
          var _cur0$tailLocal1$tmp47 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $m_Lcats_effect_Trace$().apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace($thiz.Lcats_effect_IOFiber__f_tracingEvents), 0);
          var cancelationIterations$tailLocal1$tmp47 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp47 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp47;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp47;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp47;
          break;
        }
        case 24: {
          var _cur0$tailLocal1$tmp48 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, $thiz.Lcats_effect_IOFiber__f_runtime, 0);
          var cancelationIterations$tailLocal1$tmp48 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp48 = nextAutoCede;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp48;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp48;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp48;
          break;
        }
        default: {
          throw new $c_s_MatchError(x40);
        }
      }
    }
  }
}
function $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur) {
  $thiz.Lcats_effect_IOFiber__f_resumeTag = 5;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = cur;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$.push(handle);
  }
  var ec = $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_blocking;
  $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
}
function $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, oc) {
  $thiz.Lcats_effect_IOFiber__f__join = ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Pure(oc));
  $thiz.Lcats_effect_IOFiber__f__cancel = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
  $thiz.Lcats_effect_IOFiber__f_outcome = oc;
  var stack = $thiz.Lcats_effect_IOFiber__f_callbacks;
  if (((!$uZ(stack.reduceRight($m_sjs_js_Any$().fromFunction2__F2__sjs_js_Function2(new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((acc, cb) => {
    var acc$1 = $uZ(acc);
    var cb$1 = $as_F1(cb);
    return ((cb$1 !== null) ? ($n(cb$1).apply__O__O(oc), true) : acc$1);
  }))), false))) && $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_config).Lcats_effect_unsafe_IORuntimeConfig__f_reportUnhandledFiberErrors)) {
    if ((oc instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
      var x$1 = $as_Lcats_effect_kernel_Outcome$Errored(oc);
      var this$7 = $n(x$1);
      var x44 = $as_jl_Throwable(this$7.Lcats_effect_kernel_Outcome$Errored__f_e);
      $n($thiz.Lcats_effect_IOFiber__f_currentCtx).reportFailure__jl_Throwable__V(x44);
    }
  }
  $thiz.Lcats_effect_IOFiber__f_masks = 0;
  $thiz.Lcats_effect_IOFiber__f_resumeTag = 8;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  $thiz.Lcats_effect_IOFiber__f_conts = null;
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  this$.length = 0;
  var this$$1 = $thiz.Lcats_effect_IOFiber__f_finalizers;
  this$$1.length = 0;
  $thiz.Lcats_effect_IOFiber__f_currentCtx = null;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    $n($thiz.Lcats_effect_IOFiber__f_tracingEvents).invalidate__V();
  }
}
function $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, cb) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_finalizers;
  if ((!($uI(this$.length) === 0))) {
    if ((!$thiz.Lcats_effect_IOFiber__f_finalizing)) {
      $thiz.Lcats_effect_IOFiber__f_finalizing = true;
      $thiz.Lcats_effect_IOFiber__f_conts = [0];
      var stack = $thiz.Lcats_effect_IOFiber__f_conts;
      var c = $uI(stack[0]);
      var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
      var s = ((1 + (c >> 3)) | 0);
      var shift = ((7 & c) << 2);
      use[s] = (($uI(use[s]) & (~((-1) << shift))) | (2 << shift));
      use[0] = ((1 + $uI(use[0])) | 0);
      $thiz.Lcats_effect_IOFiber__f_conts = use;
      var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
      this$$2.push(cb);
      $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
    }
    var this$$3 = $thiz.Lcats_effect_IOFiber__f_finalizers;
    return $as_Lcats_effect_IO(this$$3.pop());
  } else {
    if ((cb !== null)) {
      $n(cb).apply__O__O($m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit);
    }
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
    return $m_Lcats_effect_IO$EndFiber$();
  }
}
function $p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz) {
  return ($thiz.Lcats_effect_IOFiber__f_canceled && $p_Lcats_effect_IOFiber__isUnmasked__Z($thiz));
}
function $p_Lcats_effect_IOFiber__isUnmasked__Z($thiz) {
  return ($thiz.Lcats_effect_IOFiber__f_masks === 0);
}
function $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz) {
  return $n($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_fiberMonitor).monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle($thiz);
}
function $p_Lcats_effect_IOFiber__setCallback__F1__V($thiz, cb) {
  var stack = $thiz.Lcats_effect_IOFiber__f_callbacks;
  stack[(($uI(stack.length) - 1) | 0)] = cb;
}
function $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, depth) {
  var depth$tailLocal1 = depth;
  var result$tailLocal1 = result;
  while (true) {
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = (($uI(stack[0]) - 1) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (($uI(stack[((1 + (c >> 3)) | 0)]) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (($uI(stack[0]) - 1) | 0);
    switch (op) {
      case 0: {
        var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
        var f = $as_F1(this$.pop());
        var error = null;
        try {
          var transformed = $n(f).apply__O__O(result$tailLocal1);
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          matchResult22: {
            if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
              error = e$2;
              break matchResult22;
            }
            $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
          }
          var transformed = (void 0);
        }
        if ((depth$tailLocal1 > 512)) {
          if ((error === null)) {
            var $x_1 = new $c_Lcats_effect_IO$Pure(transformed);
          } else {
            var t = error;
            var $x_1 = new $c_Lcats_effect_IO$Error(t);
          }
          return $as_Lcats_effect_IO($x_1);
        } else if ((error === null)) {
          var depth$tailLocal1$tmp1 = ((1 + depth$tailLocal1) | 0);
          result$tailLocal1 = transformed;
          depth$tailLocal1 = depth$tailLocal1$tmp1;
        } else {
          return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, ((1 + depth$tailLocal1) | 0));
        }
        break;
      }
      case 1: {
        var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
        var f$2 = $as_F1(this$$1.pop());
        try {
          return $as_Lcats_effect_IO($n(f$2).apply__O__O(result$tailLocal1));
        } catch (e$3) {
          var e$4 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
          if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$4)) {
            return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, e$4, ((1 + depth$tailLocal1) | 0));
          }
          $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$4);
        }
        break;
      }
      case 2: {
        return $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz);
        break;
      }
      case 3: {
        return $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO($thiz, result$tailLocal1);
        break;
      }
      case 4: {
        return $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO($thiz, result$tailLocal1);
        break;
      }
      case 5: {
        var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
        this$$2.pop();
        break;
      }
      case 6: {
        var this$$3 = $thiz.Lcats_effect_IOFiber__f_finalizers;
        this$$3.pop();
        depth$tailLocal1 = ((1 + depth$tailLocal1) | 0);
        break;
      }
      case 7: {
        $thiz.Lcats_effect_IOFiber__f_masks = (($thiz.Lcats_effect_IOFiber__f_masks - 1) | 0);
        depth$tailLocal1 = ((1 + depth$tailLocal1) | 0);
        break;
      }
      case 8: {
        $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal1 = ((1 + depth$tailLocal1) | 0);
        break;
      }
      case 9: {
        var value = result$tailLocal1;
        result$tailLocal1 = new $c_s_util_Right(value);
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
function $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, depth) {
  var depth$tailLocal2 = depth;
  var error$tailLocal1 = error;
  while (true) {
    $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V($n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, error$tailLocal1, $thiz.Lcats_effect_IOFiber__f_tracingEvents);
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = (($uI(stack[0]) - 1) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (($uI(stack[((1 + (c >> 3)) | 0)]) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (($uI(stack[0]) - 1) | 0);
    switch (op) {
      case 0:
      case 1: {
        var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
        this$.pop();
        break;
      }
      case 2: {
        return $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO($thiz, error$tailLocal1);
        break;
      }
      case 3: {
        return $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO($thiz, error$tailLocal1);
        break;
      }
      case 4: {
        return $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO($thiz, error$tailLocal1);
        break;
      }
      case 5: {
        var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
        var f = $as_F1(this$$1.pop());
        try {
          return $as_Lcats_effect_IO($n(f).apply__O__O(error$tailLocal1));
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
            var depth$tailLocal2$tmp1 = ((1 + depth$tailLocal2) | 0);
            error$tailLocal1 = e$2;
            depth$tailLocal2 = depth$tailLocal2$tmp1;
            break;
          }
          $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
        }
        break;
      }
      case 6: {
        var this$$2 = $thiz.Lcats_effect_IOFiber__f_finalizers;
        this$$2.pop();
        depth$tailLocal2 = ((1 + depth$tailLocal2) | 0);
        break;
      }
      case 7: {
        $thiz.Lcats_effect_IOFiber__f_masks = (($thiz.Lcats_effect_IOFiber__f_masks - 1) | 0);
        depth$tailLocal2 = ((1 + depth$tailLocal2) | 0);
        break;
      }
      case 8: {
        $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0);
        depth$tailLocal2 = ((1 + depth$tailLocal2) | 0);
        break;
      }
      case 9: {
        var value = error$tailLocal1;
        return $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, new $c_s_util_Left(value), depth$tailLocal2);
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
function $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber) {
  if ((ec instanceof $c_Lcats_effect_unsafe_BatchingMacrotaskExecutor)) {
    var bmte = $as_Lcats_effect_unsafe_BatchingMacrotaskExecutor(ec);
    $n(bmte).schedule__Lcats_effect_IOFiber__V(fiber);
  } else {
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber);
  }
}
function $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber) {
  try {
    $n(ec).execute__jl_Runnable__V(fiber);
  } catch (e) {
    if ((!false)) {
      throw e;
    }
  }
}
function $p_Lcats_effect_IOFiber__execR__V($thiz) {
  if ($thiz.Lcats_effect_IOFiber__f_canceled) {
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
  } else {
    $thiz.Lcats_effect_IOFiber__f_conts = [0];
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = $uI(stack[0]);
    var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
    var s = ((1 + (c >> 3)) | 0);
    var shift = ((7 & c) << 2);
    use[s] = (($uI(use[s]) & (~((-1) << shift))) | (3 << shift));
    use[0] = ((1 + $uI(use[0])) | 0);
    $thiz.Lcats_effect_IOFiber__f_conts = use;
    var io = $thiz.Lcats_effect_IOFiber__f_resumeIO;
    $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
    $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, io, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
  }
}
function $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  var a = this$.pop();
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, a, 0), $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__asyncContinueFailedR__V($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  var t = $as_jl_Throwable(this$.pop());
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, t, 0), $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V($thiz) {
  var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, fin, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
  var cb = $as_F1(this$.pop());
  var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, cb);
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, fin, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__blockingR__V($thiz) {
  var error = null;
  var cur = $as_Lcats_effect_IO$Blocking($thiz.Lcats_effect_IOFiber__f_resumeIO);
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  try {
    var r = $n($n(cur).thunk__F0()).apply__O();
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult27: {
      if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
        error = e$2;
        break matchResult27;
      }
      $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
    }
    var r = (void 0);
  }
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    $n($as_Lcats_effect_unsafe_WeakBag$Handle(this$.pop())).deregister__V();
  }
  if ((error === null)) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
    var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$$1.push(r);
  } else {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    var a = error;
    this$$2.push(a);
  }
  var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
  $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
}
function $p_Lcats_effect_IOFiber__cedeR__V($thiz) {
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, (void 0), 0), $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__autoCedeR__V($thiz) {
  var io = $thiz.Lcats_effect_IOFiber__f_resumeIO;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, io, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $n($thiz.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold);
}
function $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz) {
  var this$ = $thiz.Lcats_effect_IOFiber__f_finalizers;
  if ((!($uI(this$.length) === 0))) {
    var stack = $thiz.Lcats_effect_IOFiber__f_conts;
    var c = $uI(stack[0]);
    var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < $uI(stack.length)) ? stack : (stack.push(0), stack));
    var s = ((1 + (c >> 3)) | 0);
    var shift = ((7 & c) << 2);
    use[s] = (($uI(use[s]) & (~((-1) << shift))) | (2 << shift));
    use[0] = ((1 + $uI(use[0])) | 0);
    $thiz.Lcats_effect_IOFiber__f_conts = use;
    var this$$1 = $thiz.Lcats_effect_IOFiber__f_finalizers;
    return $as_Lcats_effect_IO(this$$1.pop());
  } else {
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    var cb = this$$2.pop();
    if ((cb !== null)) {
      $n($as_F1(cb)).apply__O__O($m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit);
    }
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
    return $m_Lcats_effect_IO$EndFiber$();
  }
}
function $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  $n($thiz.Lcats_effect_IOFiber__f_currentCtx).reportFailure__jl_Throwable__V(t);
  return $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz);
}
function $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO($thiz, result) {
  $m_Lcats_effect_IO$();
  var fa = new $c_Lcats_effect_IO$Pure(result);
  $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, new $c_Lcats_effect_kernel_Outcome$Succeeded(fa));
  return $m_Lcats_effect_IO$EndFiber$();
}
function $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, new $c_Lcats_effect_kernel_Outcome$Errored(t));
  return $m_Lcats_effect_IO$EndFiber$();
}
function $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO($thiz, result) {
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    $n($as_Lcats_effect_unsafe_WeakBag$Handle(this$.pop())).deregister__V();
  }
  var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
  var ec = $as_s_concurrent_ExecutionContext(this$$1.pop());
  $thiz.Lcats_effect_IOFiber__f_currentCtx = ec;
  if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$$2.push(result);
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
    return $m_Lcats_effect_IO$EndFiber$();
  } else {
    return $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  }
}
function $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
    $n($as_Lcats_effect_unsafe_WeakBag$Handle(this$.pop())).deregister__V();
  }
  var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
  var ec = $as_s_concurrent_ExecutionContext(this$$1.pop());
  $thiz.Lcats_effect_IOFiber__f_currentCtx = ec;
  if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
    var this$$2 = $thiz.Lcats_effect_IOFiber__f_objectState;
    this$$2.push(t);
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
    return $m_Lcats_effect_IO$EndFiber$();
  } else {
    return $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  }
}
function $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, te) {
  if ((te !== null)) {
    $n($thiz.Lcats_effect_IOFiber__f_tracingEvents).push__Lcats_effect_tracing_TracingEvent__V(te);
  }
}
function $p_Lcats_effect_IOFiber__next$1__F1__O__Lcats_effect_IO($thiz, f$1, v) {
  var error = null;
  try {
    var result = $n(f$1).apply__O__O(v);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult3: {
      if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
        error = e$2;
        break matchResult3;
      }
      $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
    }
    var result = (void 0);
  }
  return ((error === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, 0));
}
function $p_Lcats_effect_IOFiber__next$2__F1__O__Lcats_effect_IO($thiz, f$2, v) {
  try {
    return $as_Lcats_effect_IO($n(f$2).apply__O__O(v));
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
      return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, e$2, 0);
    }
    $m_Lcats_effect_IOFiber$().onFatalFailure__jl_Throwable__E(e$2);
  }
}
function $p_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__V($thiz, state$2, result$1) {
  while (true) {
    if ($thiz.getAndSet__Z__Z(false)) {
      if (($thiz.Lcats_effect_IOFiber__f_finalizing === $n(state$2).Lcats_effect_ContState__f_wasFinalizing)) {
        if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
          $n($n(state$2).Lcats_effect_ContState__f_handle).deregister__V();
        }
        var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
        if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
          matchResult12: {
            if ((result$1 instanceof $c_s_util_Left)) {
              var t = $as_jl_Throwable($n($as_s_util_Left(result$1)).s_util_Left__f_value);
              $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
              var this$ = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$.push(t);
              break matchResult12;
            }
            if ((result$1 instanceof $c_s_util_Right)) {
              var a = $n($as_s_util_Right(result$1)).s_util_Right__f_value;
              $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
              var this$$1 = $thiz.Lcats_effect_IOFiber__f_objectState;
              this$$1.push(a);
              break matchResult12;
            }
            throw new $c_s_MatchError(result$1);
          }
        } else {
          $thiz.Lcats_effect_IOFiber__f_resumeTag = 3;
        }
        $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
        return (void 0);
      } else {
        $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = true;
        return (void 0);
      }
    } else if (((($thiz.Lcats_effect_IOFiber__f_finalizing === $n(state$2).Lcats_effect_ContState__f_wasFinalizing) && (!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) && ($thiz.Lcats_effect_IOFiber__f_outcome === null))) {
    } else {
      return (void 0);
    }
  }
}
function $p_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__s_util_Either__V($thiz, state$3, waiting$1, result$2) {
  while (true) {
    var tag = $as_s_util_Either($n(state$3).ju_concurrent_atomic_AtomicReference__f_value);
    if (((tag === null) || (tag === waiting$1))) {
      if ((!$n(state$3).compareAndSet__O__O__Z(tag, result$2))) {
      } else if ((tag === waiting$1)) {
        $p_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__V($thiz, state$3, result$2);
        return (void 0);
      } else {
        return (void 0);
      }
    } else {
      return (void 0);
    }
  }
}
/** @constructor */
function $c_Lcats_effect_IOFiber(initState, cb, startIO, startEC, rt) {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  this.Lcats_effect_IOFiber__f_localState = null;
  this.Lcats_effect_IOFiber__f_currentCtx = null;
  this.Lcats_effect_IOFiber__f_objectState = null;
  this.Lcats_effect_IOFiber__f_finalizers = null;
  this.Lcats_effect_IOFiber__f_callbacks = null;
  this.Lcats_effect_IOFiber__f_resumeTag = 0;
  this.Lcats_effect_IOFiber__f_resumeIO = null;
  this.Lcats_effect_IOFiber__f_runtime = null;
  this.Lcats_effect_IOFiber__f_tracingEvents = null;
  this.Lcats_effect_IOFiber__f_conts = null;
  this.Lcats_effect_IOFiber__f_canceled = false;
  this.Lcats_effect_IOFiber__f_masks = 0;
  this.Lcats_effect_IOFiber__f_finalizing = false;
  this.Lcats_effect_IOFiber__f_outcome = null;
  this.Lcats_effect_IOFiber__f__cancel = null;
  this.Lcats_effect_IOFiber__f__join = null;
  $ct_ju_concurrent_atomic_AtomicBoolean__Z__(this, false);
  this.Lcats_effect_IOFiber__f_localState = initState;
  this.Lcats_effect_IOFiber__f_currentCtx = startEC;
  this.Lcats_effect_IOFiber__f_objectState = [];
  this.Lcats_effect_IOFiber__f_finalizers = [];
  this.Lcats_effect_IOFiber__f_callbacks = [cb];
  this.Lcats_effect_IOFiber__f_resumeTag = 0;
  this.Lcats_effect_IOFiber__f_resumeIO = startIO;
  this.Lcats_effect_IOFiber__f_runtime = rt;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var logSize = $n(this.Lcats_effect_IOFiber__f_runtime).Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize;
    var $x_1 = new $c_Lcats_effect_tracing_RingBuffer(logSize);
  } else {
    var $x_1 = null;
  }
  this.Lcats_effect_IOFiber__f_tracingEvents = $x_1;
  this.Lcats_effect_IOFiber__f_canceled = false;
  this.Lcats_effect_IOFiber__f_masks = 0;
  this.Lcats_effect_IOFiber__f_finalizing = false;
  this.Lcats_effect_IOFiber__f__cancel = $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
    $as_Lcats_effect_kernel_Poll(_$3);
    this.Lcats_effect_IOFiber__f_canceled = true;
    if (this.getAndSet__Z__Z(false)) {
      if ($p_Lcats_effect_IOFiber__isUnmasked__Z(this)) {
        return $m_Lcats_effect_IO$().async___F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fin) => {
          var fin$1 = $as_F1(fin);
          var ec = this.Lcats_effect_IOFiber__f_currentCtx;
          this.Lcats_effect_IOFiber__f_resumeTag = 4;
          var this$ = this.Lcats_effect_IOFiber__f_objectState;
          this$.push(fin$1);
          $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(this, ec, this);
        })));
      } else {
        this.ju_concurrent_atomic_AtomicBoolean__f_value = true;
        return $n(this.join__Lcats_effect_IO()).void__Lcats_effect_IO();
      }
    } else {
      return $n(this.join__Lcats_effect_IO()).void__Lcats_effect_IO();
    }
  })));
  this.Lcats_effect_IOFiber__f__join = $m_Lcats_effect_IO$().asyncCheckAttempt__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cb$2) => {
    var cb$1 = $as_F1(cb$2);
    var this$19 = $m_Lcats_effect_IO$();
    var thunk$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      if ((this.Lcats_effect_IOFiber__f_outcome === null)) {
        var stack = this.Lcats_effect_IOFiber__f_callbacks;
        var next = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oc) => {
          var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
          $n(cb$1).apply__O__O(new $c_s_util_Right(oc$1));
        }));
        stack.push(next);
        var handle = (($uI(stack.length) - 1) | 0);
        if ((this.Lcats_effect_IOFiber__f_outcome !== null)) {
          var stack$1 = this.Lcats_effect_IOFiber__f_callbacks;
          delete stack$1[handle];
          var value = this.Lcats_effect_IOFiber__f_outcome;
          return new $c_s_util_Right(value);
        } else {
          var this$15 = $m_Lcats_effect_IO$();
          var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
            var stack$2 = this.Lcats_effect_IOFiber__f_callbacks;
            delete stack$2[handle];
          }));
          var value$1 = this$15.delay__F0__Lcats_effect_IO(thunk);
          var value$2 = new $c_s_Some(value$1);
          return new $c_s_util_Left(value$2);
        }
      } else {
        var value$3 = this.Lcats_effect_IOFiber__f_outcome;
        return new $c_s_util_Right(value$3);
      }
    }));
    return this$19.delay__F0__Lcats_effect_IO(thunk$1);
  })));
}
$c_Lcats_effect_IOFiber.prototype = new $h_Lcats_effect_IOFiberPlatform();
$c_Lcats_effect_IOFiber.prototype.constructor = $c_Lcats_effect_IOFiber;
/** @constructor */
function $h_Lcats_effect_IOFiber() {
}
$h_Lcats_effect_IOFiber.prototype = $c_Lcats_effect_IOFiber.prototype;
$c_Lcats_effect_IOFiber.prototype.run__V = (function() {
  var x1 = this.Lcats_effect_IOFiber__f_resumeTag;
  switch (x1) {
    case 0: {
      $p_Lcats_effect_IOFiber__execR__V(this);
      return (void 0);
      break;
    }
    case 1: {
      $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V(this);
      return (void 0);
      break;
    }
    case 2: {
      $p_Lcats_effect_IOFiber__asyncContinueFailedR__V(this);
      return (void 0);
      break;
    }
    case 3: {
      $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V(this);
      return (void 0);
      break;
    }
    case 4: {
      $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V(this);
      return (void 0);
      break;
    }
    case 5: {
      $p_Lcats_effect_IOFiber__blockingR__V(this);
      return (void 0);
      break;
    }
    case 6: {
      $p_Lcats_effect_IOFiber__cedeR__V(this);
      return (void 0);
      break;
    }
    case 7: {
      $p_Lcats_effect_IOFiber__autoCedeR__V(this);
      return (void 0);
      break;
    }
    case 8: {
      return (void 0);
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_Lcats_effect_IOFiber.prototype.cancel__Lcats_effect_IO = (function() {
  return this.Lcats_effect_IOFiber__f__cancel;
});
$c_Lcats_effect_IOFiber.prototype.join__Lcats_effect_IO = (function() {
  return this.Lcats_effect_IOFiber__f__join;
});
$c_Lcats_effect_IOFiber.prototype.toString__T = (function() {
  var state = (this.ju_concurrent_atomic_AtomicBoolean__f_value ? "SUSPENDED" : (this.isDone__Z() ? "COMPLETED" : "RUNNING"));
  var tracingEvents = this.Lcats_effect_IOFiber__f_tracingEvents;
  var this$1 = $n($m_s_Option$().apply__O__s_Option(tracingEvents));
  if (this$1.isEmpty__Z()) {
    var this$3 = $m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var tracingEvents$1 = $as_Lcats_effect_tracing_RingBuffer(x0);
    var this$2 = $n($n($m_Lcats_effect_tracing_Tracing$().getFrames__Lcats_effect_tracing_RingBuffer__sci_List(tracingEvents$1)).headOption__s_Option());
    if (this$2.isEmpty__Z()) {
      var this$3 = $m_s_None$();
    } else {
      var x0$1 = this$2.get__O();
      var frame = $as_jl_StackTraceElement(x0$1);
      var this$3 = new $c_s_Some((": " + frame));
    }
  }
  var opAndCallSite = $as_T((this$3.isEmpty__Z() ? "" : this$3.get__O()));
  var x = $systemIdentityHashCode(this);
  return (((("cats.effect.IOFiber@" + $as_T((x >>> 0.0).toString(16))) + " ") + state) + opAndCallSite);
});
$c_Lcats_effect_IOFiber.prototype.isDone__Z = (function() {
  return (this.Lcats_effect_IOFiber__f_outcome !== null);
});
$c_Lcats_effect_IOFiber.prototype.cancel__O = (function() {
  return this.cancel__Lcats_effect_IO();
});
$c_Lcats_effect_IOFiber.prototype.join__O = (function() {
  return this.join__Lcats_effect_IO();
});
function $as_Lcats_effect_IOFiber(obj) {
  return (((obj instanceof $c_Lcats_effect_IOFiber) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IOFiber"));
}
function $isArrayOf_Lcats_effect_IOFiber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IOFiber)));
}
function $asArrayOf_Lcats_effect_IOFiber(obj, depth) {
  return (($isArrayOf_Lcats_effect_IOFiber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IOFiber;", depth));
}
var $d_Lcats_effect_IOFiber = new $TypeData().initClass($c_Lcats_effect_IOFiber, "cats.effect.IOFiber", ({
  Lcats_effect_IOFiber: 1,
  Lcats_effect_IOFiberPlatform: 1,
  ju_concurrent_atomic_AtomicBoolean: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1,
  jl_Runnable: 1
}));
class $c_Lcats_effect_std_FailureSignal$ extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_Lcats_effect_std_FailureSignal$ = new $TypeData().initClass($c_Lcats_effect_std_FailureSignal$, "cats.effect.std.FailureSignal$", ({
  Lcats_effect_std_FailureSignal$: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
var $n_Lcats_effect_std_FailureSignal$;
function $m_Lcats_effect_std_FailureSignal$() {
  if ((!$n_Lcats_effect_std_FailureSignal$)) {
    $n_Lcats_effect_std_FailureSignal$ = new $c_Lcats_effect_std_FailureSignal$();
  }
  return $n_Lcats_effect_std_FailureSignal$;
}
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Semigroup(fa);
  var fb$1 = $as_Lcats_kernel_Semigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$2(fa$1, fb$1, this);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_kernel_Semigroup(fa);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$3(f, fa$1, g, this);
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$1, "cats.instances.InvariantMonoidalInstances$$anon$1", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$4() {
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$4() {
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_CommutativeSemigroup(fa);
  var fb$1 = $as_Lcats_kernel_CommutativeSemigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$5(fa$1, fb$1, this);
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_kernel_CommutativeSemigroup(fa);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(f, fa$1, g, this);
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$4 = new $TypeData().initClass($c_Lcats_instances_InvariantMonoidalInstances$$anon$4, "cats.instances.InvariantMonoidalInstances$$anon$4", ({
  Lcats_instances_InvariantMonoidalInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
}));
function $f_Lcats_instances_NTupleMonadInstances__catsStdInstancesForTuple2__Lcats_Comonad($thiz) {
  var cofMap = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((fa, f) => {
    var fa$1 = $as_T2(fa);
    var f$1 = $as_F1(f);
    var _2$1 = $n(f$1).apply__O__O(fa$1);
    var _1$1 = $n(fa$1).copy$default$1__O();
    $n(fa$1);
    return new $c_T2(_1$1, _2$1);
  }));
  return new $c_Lcats_instances_NTupleMonadInstances$$anon$1(cofMap);
}
/** @constructor */
function $c_Lcats_instances_NTupleMonadInstances$$anon$1(cofMap$2) {
  this.Lcats_instances_NTupleMonadInstances$$anon$1__f_cofMap$1 = null;
  this.Lcats_instances_NTupleMonadInstances$$anon$1__f_cofMap$1 = cofMap$2;
}
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.constructor = $c_Lcats_instances_NTupleMonadInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_NTupleMonadInstances$$anon$1() {
}
$h_Lcats_instances_NTupleMonadInstances$$anon$1.prototype = $c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype;
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__s_Product__F1__s_Product($as_s_Product(fa), f);
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.coflatMap__s_Product__F1__s_Product = (function(fa, f) {
  return $as_s_Product($n(this.Lcats_instances_NTupleMonadInstances$$anon$1__f_cofMap$1).apply__O__O__O(fa, f));
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.extract__s_Product__O = (function(fa) {
  return $n(fa).productElement__I__O((($n(fa).productArity__I() - 1) | 0));
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.map__s_Product__F1__s_Product = (function(fa, f) {
  return this.coflatMap__s_Product__F1__s_Product(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fa$2) => {
    var fa$1 = $as_s_Product(fa$2);
    return $n(f).apply__O__O(this.extract__s_Product__O(fa$1));
  })));
});
$c_Lcats_instances_NTupleMonadInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__s_Product__F1__s_Product($as_s_Product(fa), f);
});
var $d_Lcats_instances_NTupleMonadInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_NTupleMonadInstances$$anon$1, "cats.instances.NTupleMonadInstances$$anon$1", ({
  Lcats_instances_NTupleMonadInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1
}));
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$2(fa$4, fb$2) {
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = fa$4;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = fb$2;
}
$c_Lcats_instances_OrderingInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$2() {
}
$h_Lcats_instances_OrderingInstances$$anon$2.prototype = $c_Lcats_instances_OrderingInstances$$anon$2.prototype;
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var z = $n(this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1).compare__O__O__I($n(x)._1__O(), $n(y)._1__O());
  return ((z === 0) ? $n(this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1).compare__O__O__I($n(x)._2__O(), $n(y)._2__O()) : z);
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y));
});
var $d_Lcats_instances_OrderingInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_OrderingInstances$$anon$2, "cats.instances.OrderingInstances$$anon$2", ({
  Lcats_instances_OrderingInstances$$anon$2: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
}));
/** @constructor */
function $c_Lcats_instances_package$list$() {
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = null;
  $n_Lcats_instances_package$list$ = this;
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = new $c_Lcats_instances_ListInstances$$anon$1();
  new $c_Lcats_instances_ListInstancesBinCompat0$$anon$6();
}
$c_Lcats_instances_package$list$.prototype = new $h_O();
$c_Lcats_instances_package$list$.prototype.constructor = $c_Lcats_instances_package$list$;
/** @constructor */
function $h_Lcats_instances_package$list$() {
}
$h_Lcats_instances_package$list$.prototype = $c_Lcats_instances_package$list$.prototype;
var $d_Lcats_instances_package$list$ = new $TypeData().initClass($c_Lcats_instances_package$list$, "cats.instances.package$list$", ({
  Lcats_instances_package$list$: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_instances_ListInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$list$;
function $m_Lcats_instances_package$list$() {
  if ((!$n_Lcats_instances_package$list$)) {
    $n_Lcats_instances_package$list$ = new $c_Lcats_instances_package$list$();
  }
  return $n_Lcats_instances_package$list$;
}
/** @constructor */
function $c_Lcats_instances_package$stream$() {
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = null;
  $n_Lcats_instances_package$stream$ = this;
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = new $c_Lcats_instances_StreamInstances$$anon$1();
  new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7();
}
$c_Lcats_instances_package$stream$.prototype = new $h_O();
$c_Lcats_instances_package$stream$.prototype.constructor = $c_Lcats_instances_package$stream$;
/** @constructor */
function $h_Lcats_instances_package$stream$() {
}
$h_Lcats_instances_package$stream$.prototype = $c_Lcats_instances_package$stream$.prototype;
var $d_Lcats_instances_package$stream$ = new $TypeData().initClass($c_Lcats_instances_package$stream$, "cats.instances.package$stream$", ({
  Lcats_instances_package$stream$: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$stream$;
function $m_Lcats_instances_package$stream$() {
  if ((!$n_Lcats_instances_package$stream$)) {
    $n_Lcats_instances_package$stream$ = new $c_Lcats_instances_package$stream$();
  }
  return $n_Lcats_instances_package$stream$;
}
/** @constructor */
function $c_Lcats_instances_package$vector$() {
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = null;
  $n_Lcats_instances_package$vector$ = this;
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = new $c_Lcats_instances_VectorInstances$$anon$1();
  new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6();
}
$c_Lcats_instances_package$vector$.prototype = new $h_O();
$c_Lcats_instances_package$vector$.prototype.constructor = $c_Lcats_instances_package$vector$;
/** @constructor */
function $h_Lcats_instances_package$vector$() {
}
$h_Lcats_instances_package$vector$.prototype = $c_Lcats_instances_package$vector$.prototype;
var $d_Lcats_instances_package$vector$ = new $TypeData().initClass($c_Lcats_instances_package$vector$, "cats.instances.package$vector$", ({
  Lcats_instances_package$vector$: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$vector$;
function $m_Lcats_instances_package$vector$() {
  if ((!$n_Lcats_instances_package$vector$)) {
    $n_Lcats_instances_package$vector$ = new $c_Lcats_instances_package$vector$();
  }
  return $n_Lcats_instances_package$vector$;
}
/** @constructor */
function $c_Lcats_kernel_Order$$anon$1(outer) {
  this.Lcats_kernel_Order$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_kernel_Order$$anon$1__f_$outer = outer;
}
$c_Lcats_kernel_Order$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$1.prototype.constructor = $c_Lcats_kernel_Order$$anon$1;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$1() {
}
$h_Lcats_kernel_Order$$anon$1.prototype = $c_Lcats_kernel_Order$$anon$1.prototype;
$c_Lcats_kernel_Order$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Lcats_kernel_Order$$anon$1.prototype.compare__O__O__I = (function(_$1, _$2) {
  var this$1 = $n(this.Lcats_kernel_Order$$anon$1__f_$outer);
  return this$1.compare__O__O__I(_$1, _$2);
});
var $d_Lcats_kernel_Order$$anon$1 = new $TypeData().initClass($c_Lcats_kernel_Order$$anon$1, "cats.kernel.Order$$anon$1", ({
  Lcats_kernel_Order$$anon$1: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalOrder() {
}
$c_Lcats_kernel_instances_BigDecimalOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalOrder() {
}
$h_Lcats_kernel_instances_BigDecimalOrder.prototype = $c_Lcats_kernel_instances_BigDecimalOrder.prototype;
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.neqv__s_math_BigDecimal__s_math_BigDecimal__Z = (function(x, y) {
  return (!$m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x, y));
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_math_BigDecimal(x);
  return $n(x$1).hashCode__I();
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  var this$1 = $n(x$1);
  return $n(this$1.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(y$1).s_math_BigDecimal__f_bigDecimal);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x$1, y$1);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_math_BigDecimal__s_math_BigDecimal__Z($as_s_math_BigDecimal(x), $as_s_math_BigDecimal(y));
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.lt__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  var this$1 = $n(x$1);
  return $f_s_math_Ordered__$less__O__Z(this$1, y$1);
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.min__O__O__O = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  return $n(x$1).min__s_math_BigDecimal__s_math_BigDecimal(y$1);
});
var $d_Lcats_kernel_instances_BigDecimalOrder = new $TypeData().initClass($c_Lcats_kernel_instances_BigDecimalOrder, "cats.kernel.instances.BigDecimalOrder", ({
  Lcats_kernel_instances_BigDecimalOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_DoubleOrder() {
}
$c_Lcats_kernel_instances_DoubleOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleOrder.prototype.constructor = $c_Lcats_kernel_instances_DoubleOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleOrder() {
}
$h_Lcats_kernel_instances_DoubleOrder.prototype = $c_Lcats_kernel_instances_DoubleOrder.prototype;
$c_Lcats_kernel_instances_DoubleOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__D__D__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.neqv__D__D__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.lt__D__D__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uD(x);
  var valueInt = (x$1 | 0);
  if (((valueInt === x$1) && ((1.0 / x$1) !== (-Infinity)))) {
    return valueInt;
  } else if ((x$1 !== x$1)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, x$1, true);
    var lo = $uI(fpBitsDataView.getInt32(0, true));
    var hi = $uI(fpBitsDataView.getInt32(4, true));
    return (lo ^ hi);
  }
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1);
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__D__D__Z($uD(x), $uD(y));
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__D__D__Z($uD(x), $uD(y));
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__D__D__Z($uD(x), $uD(y));
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.min__O__O__O = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $uD(Math.min(x$1, y$1));
});
var $d_Lcats_kernel_instances_DoubleOrder = new $TypeData().initClass($c_Lcats_kernel_instances_DoubleOrder, "cats.kernel.instances.DoubleOrder", ({
  Lcats_kernel_instances_DoubleOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_FloatOrder() {
}
$c_Lcats_kernel_instances_FloatOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatOrder.prototype.constructor = $c_Lcats_kernel_instances_FloatOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FloatOrder() {
}
$h_Lcats_kernel_instances_FloatOrder.prototype = $c_Lcats_kernel_instances_FloatOrder.prototype;
$c_Lcats_kernel_instances_FloatOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__F__F__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.neqv__F__F__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.lt__F__F__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uF(x);
  var value = x$1;
  var valueInt = (value | 0);
  if (((valueInt === value) && ((1.0 / value) !== (-Infinity)))) {
    return valueInt;
  } else if ((value !== value)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, value, true);
    var lo = $uI(fpBitsDataView.getInt32(0, true));
    var hi = $uI(fpBitsDataView.getInt32(4, true));
    return (lo ^ hi);
  }
});
$c_Lcats_kernel_instances_FloatOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1);
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__F__F__Z($uF(x), $uF(y));
});
$c_Lcats_kernel_instances_FloatOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__F__F__Z($uF(x), $uF(y));
});
$c_Lcats_kernel_instances_FloatOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__F__F__Z($uF(x), $uF(y));
});
$c_Lcats_kernel_instances_FloatOrder.prototype.min__O__O__O = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return Math.fround($uD(Math.min(x$1, y$1)));
});
var $d_Lcats_kernel_instances_FloatOrder = new $TypeData().initClass($c_Lcats_kernel_instances_FloatOrder, "cats.kernel.instances.FloatOrder", ({
  Lcats_kernel_instances_FloatOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
}));
/** @constructor */
function $c_Lfs2_Chunk$EmptyChunk() {
}
$c_Lfs2_Chunk$EmptyChunk.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$EmptyChunk.prototype.constructor = $c_Lfs2_Chunk$EmptyChunk;
/** @constructor */
function $h_Lfs2_Chunk$EmptyChunk() {
}
$h_Lfs2_Chunk$EmptyChunk.prototype = $c_Lfs2_Chunk$EmptyChunk.prototype;
$c_Lfs2_Chunk$EmptyChunk.prototype.size__I = (function() {
  return 0;
});
$c_Lfs2_Chunk$EmptyChunk.prototype.apply__I__E = (function(i) {
  $m_s_sys_package$().error__T__E((("Chunk.empty.apply(" + i) + ")"));
});
$c_Lfs2_Chunk$EmptyChunk.prototype.map__F1__Lfs2_Chunk = (function(f) {
  return this;
});
$c_Lfs2_Chunk$EmptyChunk.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i);
});
var $d_Lfs2_Chunk$EmptyChunk = new $TypeData().initClass($c_Lfs2_Chunk$EmptyChunk, "fs2.Chunk$EmptyChunk", ({
  Lfs2_Chunk$EmptyChunk: 1,
  Lfs2_Chunk: 1,
  Ljava_io_Serializable: 1,
  Lfs2_Chunk213And3Compat: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
}));
/** @constructor */
function $c_Lfs2_Chunk$Singleton(value) {
  this.Lfs2_Chunk$Singleton__f_value = null;
  this.Lfs2_Chunk$Singleton__f_value = value;
}
$c_Lfs2_Chunk$Singleton.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$Singleton.prototype.constructor = $c_Lfs2_Chunk$Singleton;
/** @constructor */
function $h_Lfs2_Chunk$Singleton() {
}
$h_Lfs2_Chunk$Singleton.prototype = $c_Lfs2_Chunk$Singleton.prototype;
$c_Lfs2_Chunk$Singleton.prototype.size__I = (function() {
  return 1;
});
$c_Lfs2_Chunk$Singleton.prototype.apply__I__O = (function(i) {
  if ((i === 0)) {
    return this.Lfs2_Chunk$Singleton__f_value;
  } else {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
});
$c_Lfs2_Chunk$Singleton.prototype.map__F1__Lfs2_Chunk = (function(f) {
  $m_Lfs2_Chunk$();
  var o = $n(f).apply__O__O(this.Lfs2_Chunk$Singleton__f_value);
  return new $c_Lfs2_Chunk$Singleton(o);
});
var $d_Lfs2_Chunk$Singleton = new $TypeData().initClass($c_Lfs2_Chunk$Singleton, "fs2.Chunk$Singleton", ({
  Lfs2_Chunk$Singleton: 1,
  Lfs2_Chunk: 1,
  Ljava_io_Serializable: 1,
  Lfs2_Chunk213And3Compat: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
}));
/** @constructor */
function $c_Lio_circe_CursorOp$DownField(k) {
  this.Lio_circe_CursorOp$DownField__f_k = null;
  this.Lio_circe_CursorOp$DownField__f_k = k;
}
$c_Lio_circe_CursorOp$DownField.prototype = new $h_Lio_circe_CursorOp$ObjectOp();
$c_Lio_circe_CursorOp$DownField.prototype.constructor = $c_Lio_circe_CursorOp$DownField;
/** @constructor */
function $h_Lio_circe_CursorOp$DownField() {
}
$h_Lio_circe_CursorOp$DownField.prototype = $c_Lio_circe_CursorOp$DownField.prototype;
$c_Lio_circe_CursorOp$DownField.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1384263395), true);
});
$c_Lio_circe_CursorOp$DownField.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_CursorOp$DownField)) {
    var x$0$2 = $as_Lio_circe_CursorOp$DownField(x$0);
    return (this.Lio_circe_CursorOp$DownField__f_k === $n(x$0$2).Lio_circe_CursorOp$DownField__f_k);
  } else {
    return false;
  }
});
$c_Lio_circe_CursorOp$DownField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_CursorOp$DownField.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_CursorOp$DownField.prototype.productPrefix__T = (function() {
  return "DownField";
});
$c_Lio_circe_CursorOp$DownField.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$DownField__f_k;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lio_circe_CursorOp$DownField(obj) {
  return (((obj instanceof $c_Lio_circe_CursorOp$DownField) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$DownField"));
}
function $isArrayOf_Lio_circe_CursorOp$DownField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$DownField)));
}
function $asArrayOf_Lio_circe_CursorOp$DownField(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$DownField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$DownField;", depth));
}
var $d_Lio_circe_CursorOp$DownField = new $TypeData().initClass($c_Lio_circe_CursorOp$DownField, "io.circe.CursorOp$DownField", ({
  Lio_circe_CursorOp$DownField: 1,
  Lio_circe_CursorOp$ObjectOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lio_circe_CursorOp$DownN(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$DownN"));
}
function $isArrayOf_Lio_circe_CursorOp$DownN(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$DownN)));
}
function $asArrayOf_Lio_circe_CursorOp$DownN(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$DownN(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$DownN;", depth));
}
function $as_Lio_circe_CursorOp$Field(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.CursorOp$Field"));
}
function $isArrayOf_Lio_circe_CursorOp$Field(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$Field)));
}
function $asArrayOf_Lio_circe_CursorOp$Field(obj, depth) {
  return (($isArrayOf_Lio_circe_CursorOp$Field(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.CursorOp$Field;", depth));
}
class $c_Lio_circe_DecodingFailure$DecodingFailureImpl extends $c_Lio_circe_DecodingFailure {
  constructor(lazyReason, pathToRoot, ops) {
    super();
    this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot = null;
    this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops = null;
    this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot = pathToRoot;
    this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops = ops;
    $ct_Lio_circe_DecodingFailure__Lcats_Eval__(this, lazyReason);
  }
  pathToRootString__s_Option() {
    var x = this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot;
    var value = new $c_Lio_circe_PathToRoot($m_Lio_circe_PathToRoot$().Lio_circe_PathToRoot$__f_empty);
    var x$2 = new $c_s_Some(value);
    if (((x !== null) && $n(x).equals__O__Z(x$2))) {
      return new $c_s_Some("");
    } else {
      var this$3 = $n(this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot);
      var this$4 = $n((this$3.isEmpty__Z() ? $n($m_Lio_circe_PathToRoot$().fromHistory__sci_List__s_util_Either($as_sci_List($n(this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops).value__O()))).toOption__s_Option() : this$3));
      if (this$4.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var x0 = this$4.get__O();
        var _$1 = ((x0 === null) ? null : $n($as_Lio_circe_PathToRoot(x0)).Lio_circe_PathToRoot__f_value);
        $m_Lio_circe_PathToRoot$();
        return new $c_s_Some($m_Lio_circe_PathToRoot$().toPathString__sci_Vector__T(_$1));
      }
    }
  }
  history__sci_List() {
    return $as_sci_List($n(this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops).value__O());
  }
  withReason__Lio_circe_DecodingFailure$Reason__Lio_circe_DecodingFailure(reason) {
    $m_Lcats_Eval$();
    var reason$1 = new $c_Lcats_Now(reason);
    var pathToRoot = this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot;
    var ops = this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops;
    return new $c_Lio_circe_DecodingFailure$DecodingFailureImpl(reason$1, pathToRoot, ops);
  }
}
var $d_Lio_circe_DecodingFailure$DecodingFailureImpl = new $TypeData().initClass($c_Lio_circe_DecodingFailure$DecodingFailureImpl, "io.circe.DecodingFailure$DecodingFailureImpl", ({
  Lio_circe_DecodingFailure$DecodingFailureImpl: 1,
  Lio_circe_DecodingFailure: 1,
  Lio_circe_Error: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_Encoder$$anon$28(encodeA$3, outer) {
  this.Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__f_encodeA = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder__Lio_circe_MidPriorityEncoders__Lio_circe_Encoder__(this, $m_Lio_circe_Encoder$(), encodeA$3);
}
$c_Lio_circe_Encoder$$anon$28.prototype = new $h_Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder();
$c_Lio_circe_Encoder$$anon$28.prototype.constructor = $c_Lio_circe_Encoder$$anon$28;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$28() {
}
$h_Lio_circe_Encoder$$anon$28.prototype = $c_Lio_circe_Encoder$$anon$28.prototype;
var $d_Lio_circe_Encoder$$anon$28 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$28, "io.circe.Encoder$$anon$28", ({
  Lio_circe_Encoder$$anon$28: 1,
  Lio_circe_MidPriorityEncoders$IterableAsArrayEncoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsArray: 1
}));
/** @constructor */
function $c_Lio_circe_JsonBiggerDecimal(value, input) {
  this.Lio_circe_BiggerDecimalJsonNumber__f_input = null;
  this.Lio_circe_JsonBiggerDecimal__f_value = null;
  this.Lio_circe_JsonBiggerDecimal__f_input = null;
  this.Lio_circe_JsonBiggerDecimal__f_value = value;
  this.Lio_circe_JsonBiggerDecimal__f_input = input;
  $ct_Lio_circe_BiggerDecimalJsonNumber__T__(this, input);
}
$c_Lio_circe_JsonBiggerDecimal.prototype = new $h_Lio_circe_BiggerDecimalJsonNumber();
$c_Lio_circe_JsonBiggerDecimal.prototype.constructor = $c_Lio_circe_JsonBiggerDecimal;
/** @constructor */
function $h_Lio_circe_JsonBiggerDecimal() {
}
$h_Lio_circe_JsonBiggerDecimal.prototype = $c_Lio_circe_JsonBiggerDecimal.prototype;
$c_Lio_circe_JsonBiggerDecimal.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productArity__I = (function() {
  return 2;
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productPrefix__T = (function() {
  return "JsonBiggerDecimal";
});
$c_Lio_circe_JsonBiggerDecimal.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_JsonBiggerDecimal__f_value;
  }
  if ((n === 1)) {
    return this.Lio_circe_JsonBiggerDecimal__f_input;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_JsonBiggerDecimal.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return this.Lio_circe_JsonBiggerDecimal__f_value;
});
var $d_Lio_circe_JsonBiggerDecimal = new $TypeData().initClass($c_Lio_circe_JsonBiggerDecimal, "io.circe.JsonBiggerDecimal", ({
  Lio_circe_JsonBiggerDecimal: 1,
  Lio_circe_BiggerDecimalJsonNumber: 1,
  Lio_circe_JsonNumber: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(outer) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5__f_$outer = outer;
}
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype = new $h_O();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5() {
}
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.head__O = (function() {
  var this$1 = new $c_Lio_circe_JsonObject$$anon$6(this);
  return this$1.next__T2();
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$();
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.className__T = (function() {
  return "Iterable";
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lio_circe_JsonObject$$anon$6(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $as_sc_IterableOps($m_sc_Iterable$().from__sc_IterableOnce__O(coll));
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5 = new $TypeData().initClass($c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5, "io.circe.JsonObject$LinkedHashMapJsonObject$$anon$5", ({
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1
}));
function $ct_jl_ArrayIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
function $ct_jl_ArrayIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
class $c_jl_ArrayIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
var $d_jl_ArrayIndexOutOfBoundsException = new $TypeData().initClass($c_jl_ArrayIndexOutOfBoundsException, "java.lang.ArrayIndexOutOfBoundsException", ({
  jl_ArrayIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $f_jl_Double__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Double__hashCode__I($thiz) {
  var valueInt = ($thiz | 0);
  if (((valueInt === $thiz) && ((1.0 / $thiz) !== (-Infinity)))) {
    return valueInt;
  } else if (($thiz !== $thiz)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, $thiz, true);
    var lo = $uI(fpBitsDataView.getInt32(0, true));
    var hi = $uI(fpBitsDataView.getInt32(4, true));
    return (lo ^ hi);
  }
}
function $f_jl_Double__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Double__compareTo__O__I($thiz, o) {
  var that = $as_jl_Double(o);
  var $x_1 = $m_jl_Double$();
  var this$1 = $n(that);
  return $x_1.compare__D__D__I($thiz, this$1);
}
function $as_jl_Double(obj) {
  return ((((typeof obj) === "number") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Double"));
}
function $isArrayOf_jl_Double(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Double)));
}
function $asArrayOf_jl_Double(obj, depth) {
  return (($isArrayOf_jl_Double(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Double;", depth));
}
var $d_jl_Double = new $TypeData().initClass(0, "java.lang.Double", ({
  jl_Double: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => ((typeof x) === "number")));
function $f_jl_Float__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Float__hashCode__I($thiz) {
  var value = $thiz;
  var valueInt = (value | 0);
  if (((valueInt === value) && ((1.0 / value) !== (-Infinity)))) {
    return valueInt;
  } else if ((value !== value)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, value, true);
    var lo = $uI(fpBitsDataView.getInt32(0, true));
    var hi = $uI(fpBitsDataView.getInt32(4, true));
    return (lo ^ hi);
  }
}
function $f_jl_Float__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Float__compareTo__O__I($thiz, o) {
  var that = $as_jl_Float(o);
  var this$1 = $n(that);
  return $m_jl_Double$().compare__D__D__I($thiz, this$1);
}
function $as_jl_Float(obj) {
  return (($isFloat(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Float"));
}
function $isArrayOf_jl_Float(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Float)));
}
function $asArrayOf_jl_Float(obj, depth) {
  return (($isArrayOf_jl_Float(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Float;", depth));
}
var $d_jl_Float = new $TypeData().initClass(0, "java.lang.Float", ({
  jl_Float: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => $isFloat(x)));
function $f_jl_Integer__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
function $f_jl_Integer__hashCode__I($thiz) {
  return $thiz;
}
function $f_jl_Integer__toString__T($thiz) {
  return ("" + $thiz);
}
function $f_jl_Integer__compareTo__O__I($thiz, o) {
  var that = $as_jl_Integer(o);
  var this$1 = $n(that);
  return (($thiz === this$1) ? 0 : (($thiz < this$1) ? (-1) : 1));
}
function $as_jl_Integer(obj) {
  return (($isInt(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Integer"));
}
function $isArrayOf_jl_Integer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Integer)));
}
function $asArrayOf_jl_Integer(obj, depth) {
  return (($isArrayOf_jl_Integer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Integer;", depth));
}
var $d_jl_Integer = new $TypeData().initClass(0, "java.lang.Integer", ({
  jl_Integer: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => $isInt(x)));
function $f_jl_Long__equals__O__Z($thiz, $thizhi, that) {
  if ((that instanceof $Long)) {
    var x2 = $as_jl_Long(that);
    var $x_1 = $n(x2);
    var this$1_$_lo = $x_1.l;
    var this$1_$_hi = $x_1.h;
    return ((($thiz ^ this$1_$_lo) | ($thizhi ^ this$1_$_hi)) === 0);
  } else {
    return false;
  }
}
function $f_jl_Long__hashCode__I($thiz, $thizhi) {
  return ($thiz ^ $thizhi);
}
function $f_jl_Long__toString__T($thiz, $thizhi) {
  return $m_RTLong$().toString__I__I__T($thiz, $thizhi);
}
function $f_jl_Long__compareTo__O__I($thiz, $thizhi, o) {
  var that = $as_jl_Long(o);
  var $x_1 = $n(that);
  var this$1_$_lo = $x_1.l;
  var this$1_$_hi = $x_1.h;
  return (($thizhi === this$1_$_hi) ? (($thiz === this$1_$_lo) ? 0 : ((($thiz >>> 0) < (this$1_$_lo >>> 0)) ? (-1) : 1)) : (($thizhi < this$1_$_hi) ? (-1) : 1));
}
function $as_jl_Long(obj) {
  return (((obj instanceof $Long) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long"));
}
function $isArrayOf_jl_Long(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long)));
}
function $asArrayOf_jl_Long(obj, depth) {
  return (($isArrayOf_jl_Long(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long;", depth));
}
var $d_jl_Long = new $TypeData().initClass(0, "java.lang.Long", ({
  jl_Long: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => (x instanceof $Long)));
class $c_jl_NumberFormatException extends $c_jl_IllegalArgumentException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
function $as_jl_NumberFormatException(obj) {
  return (((obj instanceof $c_jl_NumberFormatException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.NumberFormatException"));
}
function $isArrayOf_jl_NumberFormatException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_NumberFormatException)));
}
function $asArrayOf_jl_NumberFormatException(obj, depth) {
  return (($isArrayOf_jl_NumberFormatException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.NumberFormatException;", depth));
}
var $d_jl_NumberFormatException = new $TypeData().initClass($c_jl_NumberFormatException, "java.lang.NumberFormatException", ({
  jl_NumberFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $f_T__length__I($thiz) {
  return $thiz.length;
}
function $f_T__codePointAt__I__I($thiz, index) {
  $charAt($thiz, index);
  return $uI($thiz.codePointAt(index));
}
function $f_T__hashCode__I($thiz) {
  var n = $thiz.length;
  var h = 0;
  var i = 0;
  while ((i !== n)) {
    var $x_2 = h;
    var $x_1 = h;
    var index = i;
    h = ((((($x_2 << 5) - $x_1) | 0) + $charAt($thiz, index)) | 0);
    i = ((1 + i) | 0);
  }
  return h;
}
function $f_T__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
function $f_T__compareTo__T__I($thiz, anotherString) {
  var thisLength = $thiz.length;
  var this$1 = $n(anotherString);
  var strLength = this$1.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var index = i;
    var this$3 = $n(anotherString);
    var index$1 = i;
    var cmp = (($charAt($thiz, index) - $charAt(this$3, index$1)) | 0);
    if ((cmp !== 0)) {
      return cmp;
    }
    i = ((1 + i) | 0);
  }
  return ((thisLength - strLength) | 0);
}
function $f_T__getChars__I__I__AC__I__V($thiz, srcBegin, srcEnd, dst, dstBegin) {
  var dstLength = $n(dst).u.length;
  if (((((srcEnd > $thiz.length) || (srcBegin < 0)) || (srcEnd < 0)) || (srcBegin > srcEnd))) {
    if ((srcBegin < 0)) {
      $charAt($thiz, srcBegin);
    }
    if ((srcEnd > $thiz.length)) {
      $charAt($thiz, srcEnd);
    }
    $charAt($thiz, (-1));
  }
  if ((dstBegin < 0)) {
    $charAt("", dstBegin);
  }
  if ((dstBegin > ((dstLength - ((srcEnd - srcBegin) | 0)) | 0))) {
    var index = ((dstBegin + ((srcEnd - srcBegin) | 0)) | 0);
    $charAt("", index);
  }
  var offset = ((dstBegin - srcBegin) | 0);
  var i = srcBegin;
  while ((i < srcEnd)) {
    var $x_2 = $n(dst);
    var $x_1 = i;
    var index$1 = i;
    $x_2.set((($x_1 + offset) | 0), $charAt($thiz, index$1));
    i = ((1 + i) | 0);
  }
}
function $f_T__indexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.indexOf(str));
}
function $f_T__lastIndexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.lastIndexOf(str));
}
function $f_T__repeat__I__T($thiz, count) {
  if ((count < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  } else {
    return $as_T($thiz.repeat(count));
  }
}
function $f_T__replaceAll__T__T__T($thiz, regex, replacement) {
  var this$2 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  return new $c_ju_regex_Matcher(this$2, $thiz).replaceAll__T__T(replacement);
}
function $f_T__replaceFirst__T__T__T($thiz, regex, replacement) {
  var this$2 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  return new $c_ju_regex_Matcher(this$2, $thiz).replaceFirst__T__T(replacement);
}
function $f_T__split__T__I__AT($thiz, regex, limit) {
  var this$2 = $n($m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0));
  return this$2.java$util$regex$Pattern$$split__T__I__AT($thiz, limit);
}
function $f_T__subSequence__I__I__jl_CharSequence($thiz, beginIndex, endIndex) {
  if ((beginIndex < 0)) {
    $charAt($thiz, beginIndex);
  }
  if ((endIndex > $thiz.length)) {
    $charAt($thiz, endIndex);
  }
  if ((endIndex < beginIndex)) {
    $charAt($thiz, (-1));
  }
  return $as_T($thiz.substring(beginIndex, endIndex));
}
function $f_T__toCharArray__AC($thiz) {
  var len = $thiz.length;
  var result = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $x_1 = i;
    var index = i;
    result.set($x_1, $charAt($thiz, index));
    i = ((1 + i) | 0);
  }
  return result;
}
function $f_T__trim__T($thiz) {
  var len = $thiz.length;
  var start = 0;
  while (true) {
    if ((start !== len)) {
      var index = start;
      var $x_1 = ($charAt($thiz, index) <= 32);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      start = ((1 + start) | 0);
    } else {
      break;
    }
  }
  if ((start === len)) {
    return "";
  } else {
    var end = len;
    while (true) {
      var index$1 = ((end - 1) | 0);
      if (($charAt($thiz, index$1) <= 32)) {
        end = ((end - 1) | 0);
      } else {
        break;
      }
    }
    if (((start | (end ^ len)) === 0)) {
      return $thiz;
    } else {
      var beginIndex = start;
      var endIndex = end;
      if ((beginIndex < 0)) {
        $charAt($thiz, beginIndex);
      }
      if ((endIndex > $thiz.length)) {
        $charAt($thiz, endIndex);
      }
      if ((endIndex < beginIndex)) {
        $charAt($thiz, (-1));
      }
      return $as_T($thiz.substring(beginIndex, endIndex));
    }
  }
}
function $f_T__toString__T($thiz) {
  return $thiz;
}
function $f_T__compareTo__O__I($thiz, o) {
  return $f_T__compareTo__T__I($thiz, $as_T(o));
}
function $as_T(obj) {
  return ((((typeof obj) === "string") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.String"));
}
function $isArrayOf_T(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T)));
}
function $asArrayOf_T(obj, depth) {
  return (($isArrayOf_T(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.String;", depth));
}
var $d_T = new $TypeData().initClass(0, "java.lang.String", ({
  T: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => ((typeof x) === "string")));
class $c_jl_StringIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
  constructor(index) {
    super();
    var s = ("String index out of range: " + index);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
var $d_jl_StringIndexOutOfBoundsException = new $TypeData().initClass($c_jl_StringIndexOutOfBoundsException, "java.lang.StringIndexOutOfBoundsException", ({
  jl_StringIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z($thiz, field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return $n(field).isDateBased__Z();
  } else if ((field !== null)) {
    var this$1 = $n(field);
    return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z($thiz, this$1);
  } else {
    return false;
  }
}
function $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $x_1 = (query === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === query);
  }
  if ($x_1) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === null)) {
    var $x_2 = (query === null);
  } else {
    var this$2 = $n(x$3);
    var $x_2 = (this$2 === query);
  }
  if ($x_2) {
    return $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  }
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$5 === null)) {
    var $x_3 = (query === null);
  } else {
    var this$3 = $n(x$5);
    var $x_3 = (this$3 === query);
  }
  if ($x_3) {
    var $x_5 = $m_Ljava_time_LocalDate$();
    var $x_4 = $thiz.toEpochDay__J();
    return $x_5.ofEpochDay__J__Ljava_time_LocalDate($x_4.l, $x_4.h);
  }
  matchAlts1: {
    matchAlts2: {
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === null)) {
        var $x_6 = (query === null);
      } else {
        var this$4 = $n(x$7);
        var $x_6 = (this$4 === query);
      }
      if ($x_6) {
        break matchAlts2;
      }
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$9 === null)) {
        var $x_7 = (query === null);
      } else {
        var this$5 = $n(x$9);
        var $x_7 = (this$5 === query);
      }
      if ($x_7) {
        break matchAlts2;
      }
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x$11 === null)) {
        var $x_8 = (query === null);
      } else {
        var this$6 = $n(x$11);
        var $x_8 = (this$6 === query);
      }
      if ($x_8) {
        break matchAlts2;
      }
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$13 === null)) {
        var $x_9 = (query === null);
      } else {
        var this$7 = $n(x$13);
        var $x_9 = (this$7 === query);
      }
      if ($x_9) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query);
}
function $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I($thiz, other) {
  var $x_1 = $thiz.toEpochDay__J();
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var $x_2 = $n(other).toEpochDay__J();
  var y_$_lo = $x_2.l;
  var y_$_hi = $x_2.h;
  var cmp = ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
  if ((cmp === 0)) {
    $n($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    $n(other);
    var that = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    cmp = $f_T__compareTo__T__I("ISO", ($n(that), "ISO"));
  }
  return cmp;
}
function $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z($thiz, other) {
  var $x_1 = $thiz.toEpochDay__J();
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var $x_2 = $n(other).toEpochDay__J();
  var x$1_$_lo = $x_2.l;
  var x$1_$_hi = $x_2.h;
  return ((x_$_hi === x$1_$_hi) ? ((x_$_lo >>> 0) > (x$1_$_lo >>> 0)) : (x_$_hi > x$1_$_hi));
}
function $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z($thiz, other) {
  var $x_1 = $thiz.toEpochDay__J();
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var $x_2 = $n(other).toEpochDay__J();
  var x$1_$_lo = $x_2.l;
  var x$1_$_hi = $x_2.h;
  return ((x_$_hi === x$1_$_hi) ? ((x_$_lo >>> 0) < (x$1_$_lo >>> 0)) : (x_$_hi < x$1_$_hi));
}
function $is_Ljava_time_chrono_ChronoLocalDate(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_ChronoLocalDate)));
}
function $as_Ljava_time_chrono_ChronoLocalDate(obj) {
  return (($is_Ljava_time_chrono_ChronoLocalDate(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.ChronoLocalDate"));
}
function $isArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoLocalDate)));
}
function $asArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.ChronoLocalDate;", depth));
}
/** @constructor */
function $c_Ljava_time_chrono_ChronoLocalDateTime() {
}
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype = new $h_O();
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.constructor = $c_Ljava_time_chrono_ChronoLocalDateTime;
/** @constructor */
function $h_Ljava_time_chrono_ChronoLocalDateTime() {
}
$h_Ljava_time_chrono_ChronoLocalDateTime.prototype = $c_Ljava_time_chrono_ChronoLocalDateTime.prototype;
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $x_1 = (query === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === query);
  }
  if ($x_1) {
    $n(this.Ljava_time_LocalDateTime__f_date);
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === null)) {
    var $x_2 = (query === null);
  } else {
    var this$3 = $n(x$3);
    var $x_2 = (this$3 === query);
  }
  if ($x_2) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$5 === null)) {
    var $x_3 = (query === null);
  } else {
    var this$4 = $n(x$5);
    var $x_3 = (this$4 === query);
  }
  if ($x_3) {
    var $x_5 = $m_Ljava_time_LocalDate$();
    var $x_4 = $n(this.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
    return $x_5.ofEpochDay__J__Ljava_time_LocalDate($x_4.l, $x_4.h);
  }
  var x$7 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$7 === null)) {
    var $x_6 = (query === null);
  } else {
    var this$5 = $n(x$7);
    var $x_6 = (this$5 === query);
  }
  if ($x_6) {
    return this.Ljava_time_LocalDateTime__f_time;
  }
  matchAlts1: {
    matchAlts2: {
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$9 === null)) {
        var $x_7 = (query === null);
      } else {
        var this$6 = $n(x$9);
        var $x_7 = (this$6 === query);
      }
      if ($x_7) {
        break matchAlts2;
      }
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x$11 === null)) {
        var $x_8 = (query === null);
      } else {
        var this$7 = $n(x$11);
        var $x_8 = (this$7 === query);
      }
      if ($x_8) {
        break matchAlts2;
      }
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$13 === null)) {
        var $x_9 = (query === null);
      } else {
        var this$8 = $n(x$13);
        var $x_9 = (this$8 === query);
      }
      if ($x_9) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query);
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.toEpochSecond__Ljava_time_ZoneOffset__J = (function(offset) {
  $n(offset);
  var $x_1 = $n(this.Ljava_time_LocalDateTime__f_date).toEpochDay__J();
  var epochDay_$_lo = $x_1.l;
  var epochDay_$_hi = $x_1.h;
  var b0 = (65535 & epochDay_$_lo);
  var b1 = ((epochDay_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((Math.imul(86400, epochDay_$_hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var value = $n(this.Ljava_time_LocalDateTime__f_time).toSecondOfDay__I();
  var hi$1 = (value >> 31);
  var lo$1 = ((lo + value) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + ((((lo & value) | ((lo | value) & (~lo$1))) >>> 31) | 0)) | 0);
  var secs_$_lo = lo$1;
  var secs_$_hi = hi$2;
  var x_$_lo = secs_$_lo;
  var x_$_hi = secs_$_hi;
  var this$4 = $n(offset);
  var value$1 = this$4.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$3 = (value$1 >> 31);
  var lo$2 = ((x_$_lo - value$1) | 0);
  var hi$4 = ((((x_$_hi - hi$3) | 0) + ((((~x_$_lo) & value$1) | ((~(x_$_lo ^ value$1)) & lo$2)) >> 31)) | 0);
  secs_$_lo = lo$2;
  secs_$_hi = hi$4;
  return $bL(secs_$_lo, secs_$_hi);
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.compare__Ljava_time_chrono_ChronoLocalDateTime__I = (function(other) {
  var this$2 = $n(this.Ljava_time_LocalDateTime__f_date);
  var this$1 = $n(other);
  var that = this$1.Ljava_time_LocalDateTime__f_date;
  var cmp = this$2.compareTo__Ljava_time_chrono_ChronoLocalDate__I(that);
  if ((cmp === 0)) {
    var this$4 = $n(this.Ljava_time_LocalDateTime__f_time);
    var this$3 = $n(other);
    var other$1 = this$3.Ljava_time_LocalDateTime__f_time;
    cmp = this$4.compare__Ljava_time_LocalTime__I(other$1);
    if ((cmp === 0)) {
      $n(($n(this.Ljava_time_LocalDateTime__f_date), $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()));
      var this$6 = $n(other);
      $n(this$6.Ljava_time_LocalDateTime__f_date);
      var that$1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      cmp = $f_T__compareTo__T__I("ISO", ($n(that$1), "ISO"));
    }
  }
  return cmp;
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_chrono_ChronoLocalDateTime__I($as_Ljava_time_chrono_ChronoLocalDateTime(that));
});
function $as_Ljava_time_chrono_ChronoLocalDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_chrono_ChronoLocalDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.chrono.ChronoLocalDateTime"));
}
function $isArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoLocalDateTime)));
}
function $asArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.chrono.ChronoLocalDateTime;", depth));
}
class $c_Ljava_time_temporal_UnsupportedTemporalTypeException extends $c_Ljava_time_DateTimeException {
  constructor(message) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
}
var $d_Ljava_time_temporal_UnsupportedTemporalTypeException = new $TypeData().initClass($c_Ljava_time_temporal_UnsupportedTemporalTypeException, "java.time.temporal.UnsupportedTemporalTypeException", ({
  Ljava_time_temporal_UnsupportedTemporalTypeException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $as_Ljava_time_zone_ZoneRulesException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.zone.ZoneRulesException"));
}
function $isArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRulesException)));
}
function $asArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) {
  return (($isArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.zone.ZoneRulesException;", depth));
}
/** @constructor */
function $c_ju_AbstractList() {
}
$c_ju_AbstractList.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractList.prototype.constructor = $c_ju_AbstractList;
/** @constructor */
function $h_ju_AbstractList() {
}
$h_ju_AbstractList.prototype = $c_ju_AbstractList.prototype;
$c_ju_AbstractList.prototype.add__O__Z = (function(element) {
  this.add__I__O__V(this.size__I(), element);
  return true;
});
$c_ju_AbstractList.prototype.add__I__O__V = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_AbstractList.prototype.remove__I__O = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_AbstractList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0);
});
$c_ju_AbstractList.prototype.listIterator__ju_ListIterator = (function() {
  return this.listIterator__I__ju_ListIterator(0);
});
$c_ju_AbstractList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  return new $c_ju_RandomAccessListIterator(this, index, 0, this.size__I());
});
$c_ju_AbstractList.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($is_ju_List(o)) {
    var x2 = $as_ju_List(o);
    var oIter = $n(x2).listIterator__ju_ListIterator();
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while ($n(_\uff3fself).hasNext__Z()) {
        var t = $n(_\uff3fself).next__O();
        if ($n(oIter).hasNext__Z()) {
          var b = $n(oIter).next__O();
          var $x_2 = ((t === null) ? (b === null) : $dp_equals__O__Z($n(t), b));
        } else {
          var $x_2 = false;
        }
        if ((!$x_2)) {
          var $x_1 = true;
          break _return;
        }
      }
      var $x_1 = false;
    }
    if ((!$x_1)) {
      return (!$n(oIter).hasNext__Z());
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_AbstractList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while ($n(_\uff3fself).hasNext__Z()) {
    var t = result;
    var u = $n(_\uff3fself).next__O();
    var t$1 = $uI(t);
    result = ((Math.imul(31, t$1) + ((u === null) ? 0 : $dp_hashCode__I($n(u)))) | 0);
  }
  return $uI(result);
});
$c_ju_AbstractList.prototype.checkIndexInBounds__I__V = (function(index) {
  if (((index < 0) || (index >= this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
$c_ju_AbstractList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if (((index < 0) || (index > this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
/** @constructor */
function $c_ju_Collections$UnmodifiableListIterator(innerIterator) {
  this.ju_Collections$UnmodifiableIterator__f_inner = null;
  $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(this, innerIterator);
}
$c_ju_Collections$UnmodifiableListIterator.prototype = new $h_ju_Collections$UnmodifiableIterator();
$c_ju_Collections$UnmodifiableListIterator.prototype.constructor = $c_ju_Collections$UnmodifiableListIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableListIterator() {
}
$h_ju_Collections$UnmodifiableListIterator.prototype = $c_ju_Collections$UnmodifiableListIterator.prototype;
var $d_ju_Collections$UnmodifiableListIterator = new $TypeData().initClass($c_ju_Collections$UnmodifiableListIterator, "java.util.Collections$UnmodifiableListIterator", ({
  ju_Collections$UnmodifiableListIterator: 1,
  ju_Collections$UnmodifiableIterator: 1,
  ju_Collections$WrappedIterator: 1,
  ju_Iterator: 1,
  ju_Collections$WrappedListIterator: 1,
  ju_ListIterator: 1
}));
class $c_ju_FormatterClosedException extends $c_jl_IllegalStateException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
var $d_ju_FormatterClosedException = new $TypeData().initClass($c_ju_FormatterClosedException, "java.util.FormatterClosedException", ({
  ju_FormatterClosedException: 1,
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.ju_HashMap$EntrySet__f_$outer = null;
  $n(outer);
  this.ju_HashMap$EntrySet__f_$outer = outer;
}
$c_ju_HashMap$EntrySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$EntrySet.prototype.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
}
$h_ju_HashMap$EntrySet.prototype = $c_ju_HashMap$EntrySet.prototype;
$c_ju_HashMap$EntrySet.prototype.iterator__ju_Iterator = (function() {
  var this$1 = $n(this.ju_HashMap$EntrySet__f_$outer);
  return this$1.nodeIterator__ju_Iterator();
});
$c_ju_HashMap$EntrySet.prototype.size__I = (function() {
  return $n(this.ju_HashMap$EntrySet__f_$outer).ju_HashMap__f_contentSize;
});
$c_ju_HashMap$EntrySet.prototype.contains__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var x2 = $as_ju_Map$Entry(o);
    var this$2 = $n(this.ju_HashMap$EntrySet__f_$outer);
    var this$1 = $n(x2);
    var key = this$1.ju_HashMap$Node__f_key;
    if ((key === null)) {
      var hash = 0;
    } else {
      var originalHash = $dp_hashCode__I($n(key));
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    var node = this$2.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (($n(this$2.ju_HashMap__f_java$util$HashMap$$table).u.length - 1) | 0)));
    if ((node !== null)) {
      var this$4 = $n(node);
      var a = this$4.ju_HashMap$Node__f_value;
      var this$5 = $n(x2);
      var b = this$5.ju_HashMap$Node__f_value;
      return ((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_HashMap$EntrySet.prototype.remove__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var x2 = $as_ju_Map$Entry(o);
    var this$1 = $n(x2);
    var key = this$1.ju_HashMap$Node__f_key;
    var this$2 = $n(this.ju_HashMap$EntrySet__f_$outer);
    if ((key === null)) {
      var hash = 0;
    } else {
      var originalHash = $dp_hashCode__I($n(key));
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    var idx = (hash & (($n(this$2.ju_HashMap__f_java$util$HashMap$$table).u.length - 1) | 0));
    var node = this$2.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
    if ((node !== null)) {
      var this$4 = $n(node);
      var a = this$4.ju_HashMap$Node__f_value;
      var this$5 = $n(x2);
      var b = this$5.ju_HashMap$Node__f_value;
      var $x_1 = ((a === null) ? (b === null) : $dp_equals__O__Z($n(a), b));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(this.ju_HashMap$EntrySet__f_$outer).java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
var $d_ju_HashMap$EntrySet = new $TypeData().initClass($c_ju_HashMap$EntrySet, "java.util.HashMap$EntrySet", ({
  ju_HashMap$EntrySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
}));
class $c_ju_IllegalFormatException extends $c_jl_IllegalArgumentException {
}
/** @constructor */
function $c_ju_NullRejectingHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
}
$c_ju_NullRejectingHashMap.prototype = new $h_ju_HashMap();
$c_ju_NullRejectingHashMap.prototype.constructor = $c_ju_NullRejectingHashMap;
/** @constructor */
function $h_ju_NullRejectingHashMap() {
}
$h_ju_NullRejectingHashMap.prototype = $c_ju_NullRejectingHashMap.prototype;
$c_ju_NullRejectingHashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return new $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next);
});
$c_ju_NullRejectingHashMap.prototype.get__O__O = (function(key) {
  var key$1 = $n(key);
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this, key$1, null);
});
$c_ju_NullRejectingHashMap.prototype.put__O__O__O = (function(key, value) {
  var key$1 = $n(key);
  var value$1 = $n(value);
  var originalHash = $dp_hashCode__I(key$1);
  return this.java$util$HashMap$$put0__O__O__I__Z__O(key$1, value$1, (originalHash ^ ((originalHash >>> 16) | 0)), false);
});
$c_ju_NullRejectingHashMap.prototype.remove__O__O = (function(key) {
  return $c_ju_HashMap.prototype.remove__O__O.call(this, $n(key));
});
$c_ju_NullRejectingHashMap.prototype.containsValue__O__Z = (function(value) {
  return $c_ju_HashMap.prototype.containsValue__O__Z.call(this, $n(value));
});
class $c_ju_regex_PatternSyntaxException extends $c_jl_IllegalArgumentException {
  constructor(desc, regex, index) {
    super();
    this.ju_regex_PatternSyntaxException__f_desc = null;
    this.ju_regex_PatternSyntaxException__f_regex = null;
    this.ju_regex_PatternSyntaxException__f_index = 0;
    this.ju_regex_PatternSyntaxException__f_desc = desc;
    this.ju_regex_PatternSyntaxException__f_regex = regex;
    this.ju_regex_PatternSyntaxException__f_index = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var idx = this.ju_regex_PatternSyntaxException__f_index;
    var re = this.ju_regex_PatternSyntaxException__f_regex;
    var indexHint = ((idx < 0) ? "" : (" near index " + idx));
    var base = (((this.ju_regex_PatternSyntaxException__f_desc + indexHint) + "\n") + re);
    if (((idx >= 0) && (re !== null))) {
      var this$1 = $n(re);
      var $x_1 = (idx < this$1.length);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (((base + "\n") + $f_T__repeat__I__T(" ", idx)) + "^");
    } else {
      return base;
    }
  }
}
var $d_ju_regex_PatternSyntaxException = new $TypeData().initClass($c_ju_regex_PatternSyntaxException, "java.util.regex.PatternSyntaxException", ({
  ju_regex_PatternSyntaxException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $p_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__outboundEdgeIndex__sci_Map($thiz) {
  if ((!$thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundEdgeIndexbitmap$1)) {
    var this$1 = $n($thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap);
    var m = $as_scm_Map($m_scm_Map$().empty__O());
    var it = this$1.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var x$1 = $as_T2(elem);
      matchResult4: {
        var key;
        if ((x$1 !== null)) {
          var x6 = $as_T2($n(x$1)._1__O());
          if ((x6 !== null)) {
            var from = $n(x6)._1__O();
            var key = from;
            break matchResult4;
          }
        }
        throw new $c_s_MatchError(x$1);
      }
      var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(this$1))));
      var this$2 = $n(bldr);
      this$2.addOne__O__scm_Growable(elem);
    }
    var this$3 = $m_sci_HashMap$();
    var result = this$3.sci_HashMap$__f_EmptyMap;
    var mapIt = $n(m).iterator__sc_Iterator();
    while ($n(mapIt).hasNext__Z()) {
      var x1 = $as_T2($n(mapIt).next__O());
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1);
      }
      var k = $n(x1)._1__O();
      var v = $as_scm_Builder($n(x1)._2__O());
      result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
    }
    var this$4 = $n(result);
    var this$7 = new $c_sc_MapView$Id(this$4);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
      var _$3$1 = $as_sci_Map(_$3);
      return $as_sci_Map($n(_$3$1).map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$1) => {
        var x$1$2 = $as_T2(x$1$1);
        if ((x$1$2 !== null)) {
          var x11 = $as_T2($n(x$1$2)._1__O());
          if ((x11 !== null)) {
            var to = $n(x11)._2__O();
            var data = $n(x$1$2)._2__O();
            return new $c_T2(to, data);
          }
        }
        throw new $c_s_MatchError(x$1$2);
      }))));
    }));
    var this$9 = new $c_sc_MapView$MapValues(this$7, f);
    $thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundEdgeIndex$lzy1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$9);
    $thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundEdgeIndexbitmap$1 = true;
  }
  return $thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundEdgeIndex$lzy1;
}
function $p_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__outboundIndex__sci_Map($thiz) {
  if ((!$thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundIndexbitmap$1)) {
    var this$1 = $n($p_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__outboundEdgeIndex__sci_Map($thiz));
    var this$2 = new $c_sc_MapView$Id(this$1);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
      var _$4$1 = $as_sci_Map(_$4);
      return $n(_$4$1).keySet__sci_Set();
    }));
    var this$4 = new $c_sc_MapView$MapValues(this$2, f);
    $thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundIndex$lzy1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$4);
    $thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundIndexbitmap$1 = true;
  }
  return $thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundIndex$lzy1;
}
function $p_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__inboundIndex__sci_Map($thiz) {
  if ((!$thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_inboundIndexbitmap$1)) {
    var this$1 = $n($thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap);
    var m = $as_scm_Map($m_scm_Map$().empty__O());
    var it = this$1.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem = $n(it).next__O();
      var x$1 = $as_T2(elem);
      matchResult6: {
        var key;
        if ((x$1 !== null)) {
          var x16 = $as_T2($n(x$1)._1__O());
          if ((x16 !== null)) {
            var to = $n(x16)._2__O();
            var key = to;
            break matchResult6;
          }
        }
        throw new $c_s_MatchError(x$1);
      }
      var bldr = $as_scm_Builder($n(m).getOrElseUpdate__O__F0__O(key, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(this$1))));
      var this$2 = $n(bldr);
      this$2.addOne__O__scm_Growable(elem);
    }
    var this$3 = $m_sci_HashMap$();
    var result = this$3.sci_HashMap$__f_EmptyMap;
    var mapIt = $n(m).iterator__sc_Iterator();
    while ($n(mapIt).hasNext__Z()) {
      var x1 = $as_T2($n(mapIt).next__O());
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1);
      }
      var k = $n(x1)._1__O();
      var v = $as_scm_Builder($n(x1)._2__O());
      result = $n(result).updated__O__O__sci_HashMap(k, $n(v).result__O());
    }
    var this$4 = $n(result);
    var this$5 = new $c_sc_MapView$Id(this$4);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
      var _$5$1 = $as_sci_Map(_$5);
      return $as_sci_Set($n($n(_$5$1).keySet__sci_Set()).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => {
        var _$6$1 = $as_T2(_$6);
        return $n(_$6$1)._1__O();
      }))));
    }));
    var this$7 = new $c_sc_MapView$MapValues(this$5, f);
    $thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_inboundIndex$lzy1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$7);
    $thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_inboundIndexbitmap$1 = true;
  }
  return $thiz.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_inboundIndex$lzy1;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(nodeMap, edgeMap, emptyNode, emptyEdge) {
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap = null;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap = null;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyNode = null;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyEdge = null;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundEdgeIndex$lzy1 = null;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundEdgeIndexbitmap$1 = false;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundIndex$lzy1 = null;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_outboundIndexbitmap$1 = false;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_inboundIndex$lzy1 = null;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_inboundIndexbitmap$1 = false;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap = nodeMap;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap = edgeMap;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyNode = emptyNode;
  this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyEdge = emptyEdge;
}
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.constructor = $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph() {
}
$h_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype = $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype;
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1378194421, true);
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(x$0);
    var x = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap;
    var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap;
      var x$4 = $n(x$0$2).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyNode;
      var x$6 = $n(x$0$2).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyNode;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyEdge;
      var x$8 = $n(x$0$2).Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyEdge;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : $n(x$7).equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $n(x$0$2);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.productArity__I = (function() {
  return 4;
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.productPrefix__T = (function() {
  return "AdjacencyListDataGraph";
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap;
      break;
    }
    case 1: {
      return this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap;
      break;
    }
    case 2: {
      return this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyNode;
      break;
    }
    case 3: {
      return this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyEdge;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.addNode__O__O__Lnet_andimiller_hedgehogs_DataGraph = (function(id, data) {
  var nodeMap = $as_sci_Map($n(this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).updated__O__O__sci_MapOps(id, data));
  var edgeMap = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap;
  var emptyNode = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyNode;
  var emptyEdge = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyEdge;
  return new $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(nodeMap, edgeMap, emptyNode, emptyEdge);
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.removeNode__O__Lnet_andimiller_hedgehogs_DataGraph = (function(id) {
  var nodeMap = $as_sci_Map($n(this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap).removed__O__sci_MapOps(id));
  var edgeMap = $as_sci_Map($n(this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap).filterNot__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x21 = $as_T2($n(x$1$1)._1__O());
      if ((x21 !== null)) {
        var from = $n(x21)._1__O();
        var to = $n(x21)._2__O();
        return ($m_sr_BoxesRunTime$().equals__O__O__Z(from, id) || $m_sr_BoxesRunTime$().equals__O__O__Z(to, id));
      }
    }
    throw new $c_s_MatchError(x$1$1);
  }))));
  var emptyNode = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyNode;
  var emptyEdge = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyEdge;
  return new $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(nodeMap, edgeMap, emptyNode, emptyEdge);
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.addEdge__O__O__O__Lnet_andimiller_hedgehogs_DataGraph = (function(from, to, data) {
  var edgeMap$2 = $as_sci_Map($n(this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap).updated__O__O__sci_MapOps(new $c_T2(from, to), data));
  var nodeMap$2 = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap;
  var emptyNode$2 = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyNode;
  var emptyEdge$2 = this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_emptyEdge;
  return new $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(nodeMap$2, edgeMap$2, emptyNode$2, emptyEdge$2);
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.outgoing__O__sci_Set = (function(id) {
  return $as_sci_Set($n($p_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__outboundIndex__sci_Map(this)).getOrElse__O__F0__O(id, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sci_Set$EmptySet$()))));
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.inbound__O__sci_Set = (function(id) {
  return $as_sci_Set($n($p_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__inboundIndex__sci_Map(this)).getOrElse__O__F0__O(id, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $m_sci_Set$EmptySet$()))));
});
$c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph.prototype.mapNode__F1__Lnet_andimiller_hedgehogs_DataGraph = (function(f) {
  var this$1 = $n(this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_nodeMap);
  var this$2 = new $c_sc_MapView$Id(this$1);
  var this$4 = new $c_sc_MapView$MapValues(this$2, f);
  return new $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$4), this.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph__f_edgeMap, $m_s_None$(), $m_s_None$());
});
function $as_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.AdjacencyListDataGraph"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_AdjacencyListDataGraph)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.AdjacencyListDataGraph;", depth));
}
var $d_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_AdjacencyListDataGraph, "net.andimiller.hedgehogs.AdjacencyListDataGraph", ({
  Lnet_andimiller_hedgehogs_AdjacencyListDataGraph: 1,
  Lnet_andimiller_hedgehogs_SimpleGraph: 1,
  Lnet_andimiller_hedgehogs_DataGraph: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount(n) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount__f_n = 0;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount__f_n = n;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ApprovalCount");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount__f_n;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount(x$0);
    return (this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount__f_n === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount__f_n);
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype.productPrefix__T = (function() {
  return "ApprovalCount";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount__f_n;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$ApprovalCount"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$ApprovalCount;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount, "net.andimiller.hedgehogs.dag.visitor.Msg$ApprovalCount", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$ApprovalCount: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve(id) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve__f_id = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve__f_id = id;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve(x$0);
    return (this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve__f_id === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve__f_id);
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype.productPrefix__T = (function() {
  return "Approve";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve__f_id;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$Approve"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$Approve;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve, "net.andimiller.hedgehogs.dag.visitor.Msg$Approve", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$Approve: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount(e) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount__f_e = 0;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount__f_e = e;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("EdgeCount");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount__f_e;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount(x$0);
    return (this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount__f_e === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount__f_e);
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype.productPrefix__T = (function() {
  return "EdgeCount";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount__f_e;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$EdgeCount"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$EdgeCount;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount, "net.andimiller.hedgehogs.dag.visitor.Msg$EdgeCount", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$EdgeCount: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded(g) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded__f_g = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded__f_g = g;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded__f_g;
    var y = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded__f_g;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype.productPrefix__T = (function() {
  return "GraphvizLoaded";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded__f_g;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$GraphvizLoaded"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$GraphvizLoaded;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded, "net.andimiller.hedgehogs.dag.visitor.Msg$GraphvizLoaded", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$GraphvizLoaded: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(msg) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log__f_msg = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log__f_msg = msg;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log__f_msg;
    var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log__f_msg;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype.productPrefix__T = (function() {
  return "Log";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log__f_msg;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$Log"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$Log;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log, "net.andimiller.hedgehogs.dag.visitor.Msg$Log", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$Log: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount(n) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount__f_n = 0;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount__f_n = n;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("NodeCount");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount__f_n;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount(x$0);
    return (this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount__f_n === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount__f_n);
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype.productPrefix__T = (function() {
  return "NodeCount";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount__f_n;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$NodeCount"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$NodeCount;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount, "net.andimiller.hedgehogs.dag.visitor.Msg$NodeCount", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$NodeCount: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated(queue) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated__f_queue = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated__f_queue = queue;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated__f_queue;
    var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated__f_queue;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype.productPrefix__T = (function() {
  return "QueueCreated";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated__f_queue;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$QueueCreated"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$QueueCreated;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated, "net.andimiller.hedgehogs.dag.visitor.Msg$QueueCreated", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$QueueCreated: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted(result) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted__f_result = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted__f_result = result;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted__f_result;
    var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted__f_result;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype.productPrefix__T = (function() {
  return "RunCompleted";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted__f_result;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$RunCompleted"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$RunCompleted;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted, "net.andimiller.hedgehogs.dag.visitor.Msg$RunCompleted", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunCompleted: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed(message) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed__f_message = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed__f_message = message;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed(x$0);
    return (this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed__f_message === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed__f_message);
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype.productPrefix__T = (function() {
  return "RunFailed";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed__f_message;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$RunFailed"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$RunFailed;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed, "net.andimiller.hedgehogs.dag.visitor.Msg$RunFailed", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$RunFailed: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded(text) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded__f_text = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded__f_text = text;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded(x$0);
    return (this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded__f_text === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded__f_text);
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype.productPrefix__T = (function() {
  return "SnapshotLoaded";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded__f_text;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$SnapshotLoaded"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$SnapshotLoaded;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded, "net.andimiller.hedgehogs.dag.visitor.Msg$SnapshotLoaded", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$SnapshotLoaded: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(node, state) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_node = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_state = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_node = node;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_state = state;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(x$0);
    if ((this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_node === $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_node)) {
      var x = this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_state;
      var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_state;
      if ((x === null)) {
        return (x$2 === null);
      } else {
        var this$1 = $n(x);
        return (this$1 === x$2);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype.productArity__I = (function() {
  return 2;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype.productPrefix__T = (function() {
  return "UpdateNodeState";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_node;
  }
  if ((n === 1)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState__f_state;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Msg$UpdateNodeState"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Msg$UpdateNodeState;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState, "net.andimiller.hedgehogs.dag.visitor.Msg$UpdateNodeState", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$UpdateNodeState: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(n) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds__f_n = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds__f_n = n;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Node();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds)) {
    var x$0$2 = $as_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(x$0);
    var x = this.Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds__f_n;
    var x$2 = $n(x$0$2).Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds__f_n;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype.productArity__I = (function() {
  return 1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype.productPrefix__T = (function() {
  return "WaitSeconds";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds__f_n;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(obj) {
  return (((obj instanceof $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.hedgehogs.dag.visitor.Node$WaitSeconds"));
}
function $isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds)));
}
function $asArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.hedgehogs.dag.visitor.Node$WaitSeconds;", depth));
}
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds, "net.andimiller.hedgehogs.dag.visitor.Node$WaitSeconds", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Node$WaitSeconds: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Node: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_s_None$() {
}
$c_s_None$.prototype = new $h_s_Option();
$c_s_None$.prototype.constructor = $c_s_None$;
/** @constructor */
function $h_s_None$() {
}
$h_s_None$.prototype = $c_s_None$.prototype;
$c_s_None$.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "None.get");
});
$c_s_None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_s_None$.prototype.productArity__I = (function() {
  return 0;
});
$c_s_None$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_s_None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_s_None$.prototype.toString__T = (function() {
  return "None";
});
$c_s_None$.prototype.get__O = (function() {
  this.get__E();
});
var $d_s_None$ = new $TypeData().initClass($c_s_None$, "scala.None$", ({
  s_None$: 1,
  s_Option: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_None$;
function $m_s_None$() {
  if ((!$n_s_None$)) {
    $n_s_None$ = new $c_s_None$();
  }
  return $n_s_None$;
}
/** @constructor */
function $c_s_Some(value) {
  this.s_Some__f_value = null;
  this.s_Some__f_value = value;
}
$c_s_Some.prototype = new $h_s_Option();
$c_s_Some.prototype.constructor = $c_s_Some;
/** @constructor */
function $h_s_Some() {
}
$h_s_Some.prototype = $c_s_Some.prototype;
$c_s_Some.prototype.get__O = (function() {
  return this.s_Some__f_value;
});
$c_s_Some.prototype.productPrefix__T = (function() {
  return "Some";
});
$c_s_Some.prototype.productArity__I = (function() {
  return 1;
});
$c_s_Some.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_Some__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_Some.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_Some.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1323286827, true);
});
$c_s_Some.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_Some.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_Some)) {
    var Some$1 = $as_s_Some(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_Some__f_value, $n(Some$1).s_Some__f_value);
  } else {
    return false;
  }
});
function $as_s_Some(obj) {
  return (((obj instanceof $c_s_Some) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Some"));
}
function $isArrayOf_s_Some(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Some)));
}
function $asArrayOf_s_Some(obj, depth) {
  return (($isArrayOf_s_Some(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Some;", depth));
}
var $d_s_Some = new $TypeData().initClass($c_s_Some, "scala.Some", ({
  s_Some: 1,
  s_Option: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_AbstractIterable() {
}
$c_sc_AbstractIterable.prototype = new $h_O();
$c_sc_AbstractIterable.prototype.constructor = $c_sc_AbstractIterable;
/** @constructor */
function $h_sc_AbstractIterable() {
}
$h_sc_AbstractIterable.prototype = $c_sc_AbstractIterable.prototype;
$c_sc_AbstractIterable.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$();
});
$c_sc_AbstractIterable.prototype.className__T = (function() {
  return this.stringPrefix__T();
});
$c_sc_AbstractIterable.prototype.stringPrefix__T = (function() {
  return "Iterable";
});
$c_sc_AbstractIterable.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps($n(this.iterableFactory__sc_IterableFactory()).from__sc_IterableOnce__O(coll));
});
$c_sc_AbstractIterable.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $n(this.iterableFactory__sc_IterableFactory()).newBuilder__scm_Builder();
});
$c_sc_AbstractIterable.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_sc_AbstractIterable.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_sc_AbstractIterable.prototype.sizeCompare__I__I = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$c_sc_AbstractIterable.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_sc_AbstractIterable.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$c_sc_AbstractIterable.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n);
});
$c_sc_AbstractIterable.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_sc_AbstractIterable.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_sc_AbstractIterable.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sc_AbstractIterable.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sc_AbstractIterable.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_sc_AbstractIterable.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sc_AbstractIterable.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sc_AbstractIterable.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sc_AbstractIterable.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sc_AbstractIterable.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_AbstractIterable.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$c_sc_AbstractIterable.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$c_sc_AbstractIterable.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sc_AbstractIterable.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_AbstractIterable.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_AbstractIterable.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_AbstractIterable.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_AbstractIterable.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq(this);
});
$c_sc_AbstractIterable.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_AbstractIterable.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_sc_AbstractIterable.prototype.knownSize__I = (function() {
  return (-1);
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll);
});
function $ct_sc_ArrayOps$ArrayIterator__O__($thiz, xs) {
  $thiz.sc_ArrayOps$ArrayIterator__f_xs = xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  var xs$1 = $thiz.sc_ArrayOps$ArrayIterator__f_xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_len = $m_jl_reflect_Array$().getLength__O__I(xs$1);
  return $thiz;
}
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator() {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
}
$c_sc_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_ArrayOps$ArrayIterator.prototype.constructor = $c_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator() {
}
$h_sc_ArrayOps$ArrayIterator.prototype = $c_sc_ArrayOps$ArrayIterator.prototype;
$c_sc_ArrayOps$ArrayIterator.prototype.knownSize__I = (function() {
  return ((this.sc_ArrayOps$ArrayIterator__f_len - this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
});
$c_sc_ArrayOps$ArrayIterator.prototype.hasNext__Z = (function() {
  return (this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos < this.sc_ArrayOps$ArrayIterator__f_len);
});
$c_sc_ArrayOps$ArrayIterator.prototype.next__O = (function() {
  var $x_1 = this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos;
  var xs = this.sc_ArrayOps$ArrayIterator__f_xs;
  if (($x_1 >= $m_jl_reflect_Array$().getLength__O__I(xs))) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.sc_ArrayOps$ArrayIterator__f_xs, this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var newPos = ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos + n) | 0);
    if ((newPos < 0)) {
      var $x_1 = this.sc_ArrayOps$ArrayIterator__f_len;
    } else {
      var a = this.sc_ArrayOps$ArrayIterator__f_len;
      var $x_1 = ((a < newPos) ? a : newPos);
    }
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = $x_1;
  }
  return this;
});
var $d_sc_ArrayOps$ArrayIterator = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator, "scala.collection.ArrayOps$ArrayIterator", ({
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
function $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I($thiz, value) {
  return ((value < 0) ? 0 : ((value > $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) ? $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder : value));
}
function $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = $n(self).length__I();
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0;
}
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewIterator() {
}
$h_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.knownSize__I = (function() {
  return this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder;
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0);
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)) {
    var r = $n(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self).apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((1 + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder - 1) | 0);
    return r;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + n) | 0);
    var b = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder - n) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b);
  }
  return this;
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var formatFrom = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, from);
  var formatUntil = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, until);
  var b = ((formatUntil - formatFrom) | 0);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + formatFrom) | 0);
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewIterator = new $TypeData().initClass($c_sc_IndexedSeqView$IndexedSeqViewIterator, "scala.collection.IndexedSeqView$IndexedSeqViewIterator", ({
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = $n(self).length__I();
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (($thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder - 1) | 0);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0;
}
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
}
$h_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0);
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    var r = $n(this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self).apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos - 1) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder - 1) | 0);
    return r;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder <= from)) {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
    } else if ((from <= 0)) {
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = until;
      }
    } else {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos - from) | 0);
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        if ((until <= from)) {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
        } else {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((until - from) | 0);
        }
      } else {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder - from) | 0);
      }
    }
  }
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator = new $TypeData().initClass($c_sc_IndexedSeqView$IndexedSeqViewReverseIterator, "scala.collection.IndexedSeqView$IndexedSeqViewReverseIterator", ({
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$21() {
  this.scm_ImmutableBuilder__f_elems = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
}
$c_sc_Iterator$$anon$21.prototype = new $h_scm_ImmutableBuilder();
$c_sc_Iterator$$anon$21.prototype.constructor = $c_sc_Iterator$$anon$21;
/** @constructor */
function $h_sc_Iterator$$anon$21() {
}
$h_sc_Iterator$$anon$21.prototype = $c_sc_Iterator$$anon$21.prototype;
$c_sc_Iterator$$anon$21.prototype.addOne__O__sc_Iterator$$anon$21 = (function(elem) {
  var this$2 = $n($as_sc_Iterator(this.scm_ImmutableBuilder__f_elems));
  var xs = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $c_sc_Iterator$$anon$20(elem)));
  this.scm_ImmutableBuilder__f_elems = this$2.concat__F0__sc_Iterator(xs);
  return this;
});
$c_sc_Iterator$$anon$21.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_Iterator$$anon$21(elem);
});
var $d_sc_Iterator$$anon$21 = new $TypeData().initClass($c_sc_Iterator$$anon$21, "scala.collection.Iterator$$anon$21", ({
  sc_Iterator$$anon$21: 1,
  scm_ImmutableBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
/** @constructor */
function $c_sc_Iterator$$anon$7(outer, pf$1) {
  this.sc_Iterator$$anon$7__f_hd = null;
  this.sc_Iterator$$anon$7__f_status = 0;
  this.sc_Iterator$$anon$7__f_$outer = null;
  this.sc_Iterator$$anon$7__f_pf$1 = null;
  $n(outer);
  this.sc_Iterator$$anon$7__f_$outer = outer;
  this.sc_Iterator$$anon$7__f_pf$1 = pf$1;
  this.sc_Iterator$$anon$7__f_status = 0;
}
$c_sc_Iterator$$anon$7.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$7.prototype.constructor = $c_sc_Iterator$$anon$7;
/** @constructor */
function $h_sc_Iterator$$anon$7() {
}
$h_sc_Iterator$$anon$7.prototype = $c_sc_Iterator$$anon$7.prototype;
$c_sc_Iterator$$anon$7.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  $uZ($m_sr_Statics$PFMarker$());
});
$c_sc_Iterator$$anon$7.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_Iterator$$anon$7.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sc_Iterator$$anon$7.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sc_Iterator$$anon$7.prototype.apply__O__O = (function(value) {
  return $m_sr_Statics$PFMarker$();
});
$c_sc_Iterator$$anon$7.prototype.hasNext__Z = (function() {
  var marker = $m_sr_Statics$PFMarker$();
  while ((this.sc_Iterator$$anon$7__f_status === 0)) {
    if ($n(this.sc_Iterator$$anon$7__f_$outer).hasNext__Z()) {
      var x = $n(this.sc_Iterator$$anon$7__f_$outer).next__O();
      var v = $n(this.sc_Iterator$$anon$7__f_pf$1).applyOrElse__O__F1__O(x, this);
      if ((marker !== v)) {
        this.sc_Iterator$$anon$7__f_hd = v;
        this.sc_Iterator$$anon$7__f_status = 1;
      }
    } else {
      this.sc_Iterator$$anon$7__f_status = (-1);
    }
  }
  return (this.sc_Iterator$$anon$7__f_status === 1);
});
$c_sc_Iterator$$anon$7.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$7__f_status = 0;
    return this.sc_Iterator$$anon$7__f_hd;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
var $d_sc_Iterator$$anon$7 = new $TypeData().initClass($c_sc_Iterator$$anon$7, "scala.collection.Iterator$$anon$7", ({
  sc_Iterator$$anon$7: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  F1: 1
}));
function $f_sc_MapOps__getOrElse__O__F0__O($thiz, key, default$1) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $n(x2).s_Some__f_value;
    return v;
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return $n(default$1).apply__O();
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
}
function $f_sc_MapOps__apply__O__O($thiz, key) {
  var x1 = $thiz.get__O__s_Option(key);
  var x = $m_s_None$();
  if ((x === x1)) {
    return $thiz.default__O__O(key);
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var value = $n(x3).s_Some__f_value;
    return value;
  } else {
    throw new $c_s_MatchError(x1);
  }
}
function $f_sc_MapOps__applyOrElse__O__F1__O($thiz, x, default$1) {
  return $thiz.getOrElse__O__F0__O(x, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n(default$1).apply__O__O(x))));
}
function $f_sc_MapOps__foreachEntry__F2__V($thiz, f) {
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var next = $as_T2($n(it).next__O());
    $n(f).apply__O__O__O($n(next)._1__O(), $n(next)._2__O());
  }
}
function $f_sc_MapOps__default__O__O($thiz, key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
}
function $f_sc_MapOps__contains__O__Z($thiz, key) {
  var this$1 = $n($thiz.get__O__s_Option(key));
  return (!this$1.isEmpty__Z());
}
function $f_sc_MapOps__map__F1__sc_IterableOps($thiz, f) {
  return $as_sc_IterableOps($n($thiz.mapFactory__sc_MapFactory()).from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f)));
}
function $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var $x_2 = $thiz.mapFactory__sc_MapFactory();
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $x_1 = new $c_sc_View$Concat($thiz, x2);
  } else {
    var $x_1 = $n($thiz.iterator__sc_Iterator()).concat__F0__sc_Iterator(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n(suffix).iterator__sc_Iterator())));
  }
  return $as_sc_IterableOps($n($x_2).from__sc_IterableOnce__O($x_1));
}
function $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, sb, start, sep, end) {
  var this$1 = $n($thiz.iterator__sc_Iterator());
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
    var x0$1$2 = $as_T2(x0$1$2$2);
    if ((x0$1$2 !== null)) {
      var k = $n(x0$1$2)._1__O();
      var v = $n(x0$1$2)._2__O();
      return ((k + " -> ") + v);
    } else {
      throw new $c_s_MatchError(x0$1$2);
    }
  }));
  var this$2 = new $c_sc_Iterator$$anon$9(this$1, f);
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this$2, sb, start, sep, end);
}
function $f_sc_StrictOptimizedSeqOps__appended__O__O($thiz, elem) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V($n(b), $thiz, 1);
  var this$1 = $n(b);
  this$1.addAll__sc_IterableOnce__scm_Growable($thiz);
  var this$2 = $n(b);
  this$2.addOne__O__scm_Growable(elem);
  return $n(b).result__O();
}
function $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O($thiz, suffix) {
  var b = $n($thiz.iterableFactory__sc_SeqFactory()).newBuilder__scm_Builder();
  var this$1 = $n(b);
  this$1.addAll__sc_IterableOnce__scm_Growable($thiz);
  var this$2 = $n(b);
  this$2.addAll__sc_IterableOnce__scm_Growable(suffix);
  return $n(b).result__O();
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying = underlying;
}
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = new $h_sc_AbstractIterator();
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JIteratorWrapper() {
}
$h_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.hasNext__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying).hasNext__Z();
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.next__O = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying).next__O();
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper)) {
    var x2 = $as_sc_convert_JavaCollectionWrappers$JIteratorWrapper(other);
    var x = this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying;
    var x$2 = $n(x2).sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.hashCode__I = (function() {
  var this$1 = $n(this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying);
  return $systemIdentityHashCode(this$1);
});
function $as_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj) {
  return (((obj instanceof $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$JIteratorWrapper"));
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$JIteratorWrapper)));
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$JIteratorWrapper;", depth));
}
var $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper = new $TypeData().initClass($c_sc_convert_JavaCollectionWrappers$JIteratorWrapper, "scala.collection.convert.JavaCollectionWrappers$JIteratorWrapper", ({
  sc_convert_JavaCollectionWrappers$JIteratorWrapper: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
function $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) {
  if ((!$thiz.sci_ArraySeq$__f_bitmap$0)) {
    $thiz.sci_ArraySeq$__f_emptyImpl = new $c_sci_ArraySeq$ofRef(new $ac_O(0));
    $thiz.sci_ArraySeq$__f_bitmap$0 = true;
  }
  return $thiz.sci_ArraySeq$__f_emptyImpl;
}
function $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef($thiz) {
  return ((!$thiz.sci_ArraySeq$__f_bitmap$0) ? $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) : $thiz.sci_ArraySeq$__f_emptyImpl);
}
/** @constructor */
function $c_sci_ArraySeq$() {
  this.sci_ArraySeq$__f_emptyImpl = null;
  this.sci_ArraySeq$__f_untagged = null;
  this.sci_ArraySeq$__f_bitmap$0 = false;
  $n_sci_ArraySeq$ = this;
  this.sci_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
}
$c_sci_ArraySeq$.prototype = new $h_O();
$c_sci_ArraySeq$.prototype.constructor = $c_sci_ArraySeq$;
/** @constructor */
function $h_sci_ArraySeq$() {
}
$h_sci_ArraySeq$.prototype = $c_sci_ArraySeq$.prototype;
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq = (function(it, tag) {
  if ((it instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(it);
    return x2;
  } else {
    return this.unsafeWrapArray__O__sci_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, tag));
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$2) {
  $m_scm_ArrayBuffer$();
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((b$2$2) => {
    var b$2 = $as_scm_ArrayBuffer(b$2$2);
    var $x_1 = $m_sci_ArraySeq$();
    var this$2 = $n(b$2);
    return $x_1.unsafeWrapArray__O__sci_ArraySeq($f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this$2, evidence$2));
  }));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_sci_ArraySeq$.prototype.unsafeWrapArray__O__sci_ArraySeq = (function(x) {
  if ((x === null)) {
    return null;
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_sci_ArraySeq$ofRef(x3);
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_sci_ArraySeq$ofInt(x4);
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_sci_ArraySeq$ofDouble(x5);
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_sci_ArraySeq$ofLong(x6);
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_sci_ArraySeq$ofFloat(x7);
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_sci_ArraySeq$ofChar(x8);
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_sci_ArraySeq$ofByte(x9);
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_sci_ArraySeq$ofShort(x10);
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_sci_ArraySeq$ofBoolean(x11);
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_sci_ArraySeq$ofUnit(x12);
  } else {
    throw new $c_s_MatchError(x);
  }
});
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5));
});
$c_sci_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this);
});
var $d_sci_ArraySeq$ = new $TypeData().initClass($c_sci_ArraySeq$, "scala.collection.immutable.ArraySeq$", ({
  sci_ArraySeq$: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_ArraySeq$;
function $m_sci_ArraySeq$() {
  if ((!$n_sci_ArraySeq$)) {
    $n_sci_ArraySeq$ = new $c_sci_ArraySeq$();
  }
  return $n_sci_ArraySeq$;
}
/** @constructor */
function $c_sci_HashMapBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, $n(x2$1).sci_HashMap__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    $n(outer).update__sci_MapNode__O__O__I__I__I__V($n(outer).sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  }
}
$c_sci_HashMapBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashMapBuilder$$anon$1.prototype.constructor = $c_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $h_sci_HashMapBuilder$$anon$1() {
}
$h_sci_HashMapBuilder$$anon$1.prototype = $c_sci_HashMapBuilder$$anon$1.prototype;
$c_sci_HashMapBuilder$$anon$1.prototype.next__E = (function() {
  $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException());
});
$c_sci_HashMapBuilder$$anon$1.prototype.next__O = (function() {
  this.next__E();
});
var $d_sci_HashMapBuilder$$anon$1 = new $TypeData().initClass($c_sci_HashMapBuilder$$anon$1, "scala.collection.immutable.HashMapBuilder$$anon$1", ({
  sci_HashMapBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_HashSetBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, $n(x2$1).sci_HashSet__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    $n(outer).update__sci_SetNode__O__I__I__I__V($n(outer).sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, $n($as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  }
}
$c_sci_HashSetBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashSetBuilder$$anon$1.prototype.constructor = $c_sci_HashSetBuilder$$anon$1;
/** @constructor */
function $h_sci_HashSetBuilder$$anon$1() {
}
$h_sci_HashSetBuilder$$anon$1.prototype = $c_sci_HashSetBuilder$$anon$1.prototype;
$c_sci_HashSetBuilder$$anon$1.prototype.next__E = (function() {
  $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  throw $ct_jl_ClassCastException__(new $c_jl_ClassCastException());
});
$c_sci_HashSetBuilder$$anon$1.prototype.next__O = (function() {
  this.next__E();
});
var $d_sci_HashSetBuilder$$anon$1 = new $TypeData().initClass($c_sci_HashSetBuilder$$anon$1, "scala.collection.immutable.HashSetBuilder$$anon$1", ({
  sci_HashSetBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $is_sci_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Iterable)));
}
function $as_sci_Iterable(obj) {
  return (($is_sci_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Iterable"));
}
function $isArrayOf_sci_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Iterable)));
}
function $asArrayOf_sci_Iterable(obj, depth) {
  return (($isArrayOf_sci_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Iterable;", depth));
}
/** @constructor */
function $c_sci_Map$Map2$$anon$1(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$c_sci_Map$Map2$$anon$1.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$1.prototype.constructor = $c_sci_Map$Map2$$anon$1;
/** @constructor */
function $h_sci_Map$Map2$$anon$1() {
}
$h_sci_Map$Map2$$anon$1.prototype = $c_sci_Map$Map2$$anon$1.prototype;
$c_sci_Map$Map2$$anon$1.prototype.nextResult__O__O__O = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map2$$anon$1 = new $TypeData().initClass($c_sci_Map$Map2$$anon$1, "scala.collection.immutable.Map$Map2$$anon$1", ({
  sci_Map$Map2$$anon$1: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map2$$anon$2(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$c_sci_Map$Map2$$anon$2.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$2.prototype.constructor = $c_sci_Map$Map2$$anon$2;
/** @constructor */
function $h_sci_Map$Map2$$anon$2() {
}
$h_sci_Map$Map2$$anon$2.prototype = $c_sci_Map$Map2$$anon$2.prototype;
$c_sci_Map$Map2$$anon$2.prototype.nextResult__O__O__O = (function(k, v) {
  return k;
});
var $d_sci_Map$Map2$$anon$2 = new $TypeData().initClass($c_sci_Map$Map2$$anon$2, "scala.collection.immutable.Map$Map2$$anon$2", ({
  sci_Map$Map2$$anon$2: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map2$$anon$3(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
$c_sci_Map$Map2$$anon$3.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$3.prototype.constructor = $c_sci_Map$Map2$$anon$3;
/** @constructor */
function $h_sci_Map$Map2$$anon$3() {
}
$h_sci_Map$Map2$$anon$3.prototype = $c_sci_Map$Map2$$anon$3.prototype;
$c_sci_Map$Map2$$anon$3.prototype.nextResult__O__O__O = (function(k, v) {
  return v;
});
var $d_sci_Map$Map2$$anon$3 = new $TypeData().initClass($c_sci_Map$Map2$$anon$3, "scala.collection.immutable.Map$Map2$$anon$3", ({
  sci_Map$Map2$$anon$3: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$4(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$c_sci_Map$Map3$$anon$4.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$4.prototype.constructor = $c_sci_Map$Map3$$anon$4;
/** @constructor */
function $h_sci_Map$Map3$$anon$4() {
}
$h_sci_Map$Map3$$anon$4.prototype = $c_sci_Map$Map3$$anon$4.prototype;
$c_sci_Map$Map3$$anon$4.prototype.nextResult__O__O__O = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map3$$anon$4 = new $TypeData().initClass($c_sci_Map$Map3$$anon$4, "scala.collection.immutable.Map$Map3$$anon$4", ({
  sci_Map$Map3$$anon$4: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$5(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$c_sci_Map$Map3$$anon$5.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$5.prototype.constructor = $c_sci_Map$Map3$$anon$5;
/** @constructor */
function $h_sci_Map$Map3$$anon$5() {
}
$h_sci_Map$Map3$$anon$5.prototype = $c_sci_Map$Map3$$anon$5.prototype;
$c_sci_Map$Map3$$anon$5.prototype.nextResult__O__O__O = (function(k, v) {
  return k;
});
var $d_sci_Map$Map3$$anon$5 = new $TypeData().initClass($c_sci_Map$Map3$$anon$5, "scala.collection.immutable.Map$Map3$$anon$5", ({
  sci_Map$Map3$$anon$5: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map3$$anon$6(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
$c_sci_Map$Map3$$anon$6.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$6.prototype.constructor = $c_sci_Map$Map3$$anon$6;
/** @constructor */
function $h_sci_Map$Map3$$anon$6() {
}
$h_sci_Map$Map3$$anon$6.prototype = $c_sci_Map$Map3$$anon$6.prototype;
$c_sci_Map$Map3$$anon$6.prototype.nextResult__O__O__O = (function(k, v) {
  return v;
});
var $d_sci_Map$Map3$$anon$6 = new $TypeData().initClass($c_sci_Map$Map3$$anon$6, "scala.collection.immutable.Map$Map3$$anon$6", ({
  sci_Map$Map3$$anon$6: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$7(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$c_sci_Map$Map4$$anon$7.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$7.prototype.constructor = $c_sci_Map$Map4$$anon$7;
/** @constructor */
function $h_sci_Map$Map4$$anon$7() {
}
$h_sci_Map$Map4$$anon$7.prototype = $c_sci_Map$Map4$$anon$7.prototype;
$c_sci_Map$Map4$$anon$7.prototype.nextResult__O__O__O = (function(k, v) {
  return new $c_T2(k, v);
});
var $d_sci_Map$Map4$$anon$7 = new $TypeData().initClass($c_sci_Map$Map4$$anon$7, "scala.collection.immutable.Map$Map4$$anon$7", ({
  sci_Map$Map4$$anon$7: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$8(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$c_sci_Map$Map4$$anon$8.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$8.prototype.constructor = $c_sci_Map$Map4$$anon$8;
/** @constructor */
function $h_sci_Map$Map4$$anon$8() {
}
$h_sci_Map$Map4$$anon$8.prototype = $c_sci_Map$Map4$$anon$8.prototype;
$c_sci_Map$Map4$$anon$8.prototype.nextResult__O__O__O = (function(k, v) {
  return k;
});
var $d_sci_Map$Map4$$anon$8 = new $TypeData().initClass($c_sci_Map$Map4$$anon$8, "scala.collection.immutable.Map$Map4$$anon$8", ({
  sci_Map$Map4$$anon$8: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_Map$Map4$$anon$9(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
$c_sci_Map$Map4$$anon$9.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$9.prototype.constructor = $c_sci_Map$Map4$$anon$9;
/** @constructor */
function $h_sci_Map$Map4$$anon$9() {
}
$h_sci_Map$Map4$$anon$9.prototype = $c_sci_Map$Map4$$anon$9.prototype;
$c_sci_Map$Map4$$anon$9.prototype.nextResult__O__O__O = (function(k, v) {
  return v;
});
var $d_sci_Map$Map4$$anon$9 = new $TypeData().initClass($c_sci_Map$Map4$$anon$9, "scala.collection.immutable.Map$Map4$$anon$9", ({
  sci_Map$Map4$$anon$9: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapKeyIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$c_sci_MapKeyIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyIterator.prototype.constructor = $c_sci_MapKeyIterator;
/** @constructor */
function $h_sci_MapKeyIterator() {
}
$h_sci_MapKeyIterator.prototype = $c_sci_MapKeyIterator.prototype;
$c_sci_MapKeyIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var key = $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return key;
});
var $d_sci_MapKeyIterator = new $TypeData().initClass($c_sci_MapKeyIterator, "scala.collection.immutable.MapKeyIterator", ({
  sci_MapKeyIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleHashIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
  this.sci_MapKeyValueTupleHashIterator__f_value = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
}
$c_sci_MapKeyValueTupleHashIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_MapKeyValueTupleHashIterator.prototype.constructor = $c_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleHashIterator() {
}
$h_sci_MapKeyValueTupleHashIterator.prototype = $c_sci_MapKeyValueTupleHashIterator.prototype;
$c_sci_MapKeyValueTupleHashIterator.prototype.hashCode__I = (function() {
  var $x_2 = $m_s_util_hashing_MurmurHash3$();
  var $x_1 = this.sci_MapKeyValueTupleHashIterator__f_hash;
  var x = this.sci_MapKeyValueTupleHashIterator__f_value;
  return $x_2.tuple2Hash__I__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x), (-889275714));
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__sci_MapKeyValueTupleHashIterator = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  this.sci_MapKeyValueTupleHashIterator__f_hash = $n(this.sci_ChampBaseReverseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_MapKeyValueTupleHashIterator__f_value = $n($as_sci_MapNode(this.sci_ChampBaseReverseIterator__f_currentValueNode)).getValue__I__O(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = ((this.sci_ChampBaseReverseIterator__f_currentValueCursor - 1) | 0);
  return this;
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__O = (function() {
  return this.next__sci_MapKeyValueTupleHashIterator();
});
var $d_sci_MapKeyValueTupleHashIterator = new $TypeData().initClass($c_sci_MapKeyValueTupleHashIterator, "scala.collection.immutable.MapKeyValueTupleHashIterator", ({
  sci_MapKeyValueTupleHashIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapKeyValueTupleIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$c_sci_MapKeyValueTupleIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyValueTupleIterator.prototype.constructor = $c_sci_MapKeyValueTupleIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleIterator() {
}
$h_sci_MapKeyValueTupleIterator.prototype = $c_sci_MapKeyValueTupleIterator.prototype;
$c_sci_MapKeyValueTupleIterator.prototype.next__T2 = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var payload = $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__T2(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload;
});
$c_sci_MapKeyValueTupleIterator.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sci_MapKeyValueTupleIterator = new $TypeData().initClass($c_sci_MapKeyValueTupleIterator, "scala.collection.immutable.MapKeyValueTupleIterator", ({
  sci_MapKeyValueTupleIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_MapValueIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$c_sci_MapValueIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapValueIterator.prototype.constructor = $c_sci_MapValueIterator;
/** @constructor */
function $h_sci_MapValueIterator() {
}
$h_sci_MapValueIterator.prototype = $c_sci_MapValueIterator.prototype;
$c_sci_MapValueIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var value = $n($as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode)).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return value;
});
var $d_sci_MapValueIterator = new $TypeData().initClass($c_sci_MapValueIterator, "scala.collection.immutable.MapValueIterator", ({
  sci_MapValueIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $p_sci_NewVectorIterator__advanceSlice__V($thiz) {
  if (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
  var slice = $n($thiz.sci_NewVectorIterator__f_v).vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  while (($n(slice).u.length === 0)) {
    $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
    slice = $n($thiz.sci_NewVectorIterator__f_v).vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  }
  $thiz.sci_NewVectorIterator__f_sliceStart = $thiz.sci_NewVectorIterator__f_sliceEnd;
  var count = $thiz.sci_NewVectorIterator__f_sliceCount;
  var idx = $thiz.sci_NewVectorIterator__f_sliceIdx;
  var c = (((count + ((count >>> 31) | 0)) | 0) >> 1);
  var a = ((idx - c) | 0);
  var sign = (a >> 31);
  $thiz.sci_NewVectorIterator__f_sliceDim = ((((1 + c) | 0) - (((a ^ sign) - sign) | 0)) | 0);
  var x1 = $thiz.sci_NewVectorIterator__f_sliceDim;
  switch (x1) {
    case 1: {
      $thiz.sci_NewVectorIterator__f_a1 = slice;
      break;
    }
    case 2: {
      $thiz.sci_NewVectorIterator__f_a2 = $asArrayOf_O(slice, 2);
      break;
    }
    case 3: {
      $thiz.sci_NewVectorIterator__f_a3 = $asArrayOf_O(slice, 3);
      break;
    }
    case 4: {
      $thiz.sci_NewVectorIterator__f_a4 = $asArrayOf_O(slice, 4);
      break;
    }
    case 5: {
      $thiz.sci_NewVectorIterator__f_a5 = $asArrayOf_O(slice, 5);
      break;
    }
    case 6: {
      $thiz.sci_NewVectorIterator__f_a6 = $asArrayOf_O(slice, 6);
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  $thiz.sci_NewVectorIterator__f_sliceEnd = (($thiz.sci_NewVectorIterator__f_sliceStart + Math.imul($n(slice).u.length, (1 << Math.imul(5, (($thiz.sci_NewVectorIterator__f_sliceDim - 1) | 0))))) | 0);
  if (($thiz.sci_NewVectorIterator__f_sliceEnd > $thiz.sci_NewVectorIterator__f_totalLength)) {
    $thiz.sci_NewVectorIterator__f_sliceEnd = $thiz.sci_NewVectorIterator__f_totalLength;
  }
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    $thiz.sci_NewVectorIterator__f_oldPos = (((1 << Math.imul(5, $thiz.sci_NewVectorIterator__f_sliceDim)) - 1) | 0);
  }
}
function $p_sci_NewVectorIterator__advance__V($thiz) {
  var pos = (((($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + $thiz.sci_NewVectorIterator__f_totalLength) | 0);
  if ((pos === $thiz.sci_NewVectorIterator__f_sliceEnd)) {
    $p_sci_NewVectorIterator__advanceSlice__V($thiz);
  }
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    var io = ((pos - $thiz.sci_NewVectorIterator__f_sliceStart) | 0);
    var xor = ($thiz.sci_NewVectorIterator__f_oldPos ^ io);
    $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor);
    $thiz.sci_NewVectorIterator__f_oldPos = io;
  }
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var a = $n($thiz.sci_NewVectorIterator__f_a1).u.length;
  var b = $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
  $thiz.sci_NewVectorIterator__f_a1len = ((a < b) ? a : b);
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
}
function $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0);
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0);
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0);
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $n($thiz.sci_NewVectorIterator__f_a6).get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get(0);
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get(0);
  }
}
function $p_sci_NewVectorIterator__setA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $n($thiz.sci_NewVectorIterator__f_a6).get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $n($thiz.sci_NewVectorIterator__f_a5).get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $n($thiz.sci_NewVectorIterator__f_a4).get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $n($thiz.sci_NewVectorIterator__f_a3).get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $n($thiz.sci_NewVectorIterator__f_a2).get((31 & ((io >>> 5) | 0)));
  }
}
/** @constructor */
function $c_sci_NewVectorIterator(v, totalLength, sliceCount) {
  this.sci_NewVectorIterator__f_v = null;
  this.sci_NewVectorIterator__f_totalLength = 0;
  this.sci_NewVectorIterator__f_sliceCount = 0;
  this.sci_NewVectorIterator__f_a1 = null;
  this.sci_NewVectorIterator__f_a2 = null;
  this.sci_NewVectorIterator__f_a3 = null;
  this.sci_NewVectorIterator__f_a4 = null;
  this.sci_NewVectorIterator__f_a5 = null;
  this.sci_NewVectorIterator__f_a6 = null;
  this.sci_NewVectorIterator__f_a1len = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 0;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = 0;
  this.sci_NewVectorIterator__f_v = v;
  this.sci_NewVectorIterator__f_totalLength = totalLength;
  this.sci_NewVectorIterator__f_sliceCount = sliceCount;
  this.sci_NewVectorIterator__f_a1 = $n(v).sci_Vector__f_prefix1;
  this.sci_NewVectorIterator__f_a1len = $n(this.sci_NewVectorIterator__f_a1).u.length;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = this.sci_NewVectorIterator__f_totalLength;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 1;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_a1len;
}
$c_sci_NewVectorIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_NewVectorIterator.prototype.constructor = $c_sci_NewVectorIterator;
/** @constructor */
function $h_sci_NewVectorIterator() {
}
$h_sci_NewVectorIterator.prototype = $c_sci_NewVectorIterator.prototype;
$c_sci_NewVectorIterator.prototype.knownSize__I = (function() {
  return ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
});
$c_sci_NewVectorIterator.prototype.hasNext__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1);
});
$c_sci_NewVectorIterator.prototype.next__O = (function() {
  if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
    $p_sci_NewVectorIterator__advance__V(this);
  }
  var r = $n(this.sci_NewVectorIterator__f_a1).get(this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1);
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((1 + this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  return r;
});
$c_sci_NewVectorIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var oldpos = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + this.sci_NewVectorIterator__f_totalLength) | 0);
    var a = ((oldpos + n) | 0);
    var b = this.sci_NewVectorIterator__f_totalLength;
    var newpos = ((a < b) ? a : b);
    if ((newpos === this.sci_NewVectorIterator__f_totalLength)) {
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
      this.sci_NewVectorIterator__f_a1len = 0;
    } else {
      while ((newpos >= this.sci_NewVectorIterator__f_sliceEnd)) {
        $p_sci_NewVectorIterator__advanceSlice__V(this);
      }
      var io = ((newpos - this.sci_NewVectorIterator__f_sliceStart) | 0);
      if ((this.sci_NewVectorIterator__f_sliceDim > 1)) {
        var xor = (this.sci_NewVectorIterator__f_oldPos ^ io);
        $p_sci_NewVectorIterator__setA__I__I__V(this, io, xor);
        this.sci_NewVectorIterator__f_oldPos = io;
      }
      this.sci_NewVectorIterator__f_a1len = $n(this.sci_NewVectorIterator__f_a1).u.length;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = (31 & io);
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + ((this.sci_NewVectorIterator__f_totalLength - newpos) | 0)) | 0);
      if ((this.sci_NewVectorIterator__f_a1len > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1)) {
        this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
      }
    }
  }
  return this;
});
$c_sci_NewVectorIterator.prototype.take__I__sc_Iterator = (function(n) {
  if ((n < ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0))) {
    var trunc = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0) - ((n < 0) ? 0 : n)) | 0);
    this.sci_NewVectorIterator__f_totalLength = ((this.sci_NewVectorIterator__f_totalLength - trunc) | 0);
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - trunc) | 0);
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 < this.sci_NewVectorIterator__f_a1len)) {
      this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
    }
    if ((this.sci_NewVectorIterator__f_totalLength < this.sci_NewVectorIterator__f_sliceEnd)) {
      this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_totalLength;
    }
  }
  return this;
});
$c_sci_NewVectorIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var xsLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var srcLen = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? xsLen : ((xsLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var total$1 = ((total < 0) ? 0 : total);
  var copied = 0;
  var isBoxed = (xs instanceof $ac_O);
  while ((copied < total$1)) {
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
      $p_sci_NewVectorIterator__advance__V(this);
    }
    var a = ((total$1 - copied) | 0);
    var b = (($n(this.sci_NewVectorIterator__f_a1).u.length - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
    var count = ((a < b) ? a : b);
    if (isBoxed) {
      var src = this.sci_NewVectorIterator__f_a1;
      var srcPos = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1;
      var destPos = ((start + copied) | 0);
      $systemArraycopyFull($n(src), srcPos, $n(xs), destPos, count);
    } else {
      $m_s_Array$().copy__O__I__O__I__I__V(this.sci_NewVectorIterator__f_a1, this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1, xs, ((start + copied) | 0), count);
    }
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + count) | 0);
    copied = ((copied + count) | 0);
  }
  return total$1;
});
var $d_sci_NewVectorIterator = new $TypeData().initClass($c_sci_NewVectorIterator, "scala.collection.immutable.NewVectorIterator", ({
  sci_NewVectorIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  jl_Cloneable: 1
}));
/** @constructor */
function $c_sci_NumericRange$NumericRangeIterator(self, num) {
  this.sci_NumericRange$NumericRangeIterator__f_self = null;
  this.sci_NumericRange$NumericRangeIterator__f_num = null;
  this.sci_NumericRange$NumericRangeIterator__f__hasNext = false;
  this.sci_NumericRange$NumericRangeIterator__f__next = null;
  this.sci_NumericRange$NumericRangeIterator__f_lastElement = null;
  this.sci_NumericRange$NumericRangeIterator__f_self = self;
  this.sci_NumericRange$NumericRangeIterator__f_num = num;
  this.sci_NumericRange$NumericRangeIterator__f__hasNext = (!$n(self).isEmpty__Z());
  this.sci_NumericRange$NumericRangeIterator__f__next = $n(self).sci_NumericRange__f_start;
  this.sci_NumericRange$NumericRangeIterator__f_lastElement = (this.sci_NumericRange$NumericRangeIterator__f__hasNext ? $n(self).last__O() : $n(self).sci_NumericRange__f_start);
}
$c_sci_NumericRange$NumericRangeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_NumericRange$NumericRangeIterator.prototype.constructor = $c_sci_NumericRange$NumericRangeIterator;
/** @constructor */
function $h_sci_NumericRange$NumericRangeIterator() {
}
$h_sci_NumericRange$NumericRangeIterator.prototype = $c_sci_NumericRange$NumericRangeIterator.prototype;
$c_sci_NumericRange$NumericRangeIterator.prototype.knownSize__I = (function() {
  if (this.sci_NumericRange$NumericRangeIterator__f__hasNext) {
    var $x_1 = this.sci_NumericRange$NumericRangeIterator__f_num;
    var this$2 = $n(this.sci_NumericRange$NumericRangeIterator__f_num);
    var this$1 = $n(this.sci_NumericRange$NumericRangeIterator__f_num);
    var lhs = this.sci_NumericRange$NumericRangeIterator__f_lastElement;
    var lhs$1 = new $c_s_math_Integral$IntegralOps(this$1, lhs).$minus__O__O(this.sci_NumericRange$NumericRangeIterator__f__next);
    return ((1 + $n($x_1).toInt__O__I(new $c_s_math_Integral$IntegralOps(this$2, lhs$1).$div__O__O($n(this.sci_NumericRange$NumericRangeIterator__f_self).sci_NumericRange__f_step))) | 0);
  } else {
    return 0;
  }
});
$c_sci_NumericRange$NumericRangeIterator.prototype.hasNext__Z = (function() {
  return this.sci_NumericRange$NumericRangeIterator__f__hasNext;
});
$c_sci_NumericRange$NumericRangeIterator.prototype.next__O = (function() {
  if ((!this.sci_NumericRange$NumericRangeIterator__f__hasNext)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var value = this.sci_NumericRange$NumericRangeIterator__f__next;
  this.sci_NumericRange$NumericRangeIterator__f__hasNext = (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, this.sci_NumericRange$NumericRangeIterator__f_lastElement));
  this.sci_NumericRange$NumericRangeIterator__f__next = $n(this.sci_NumericRange$NumericRangeIterator__f_num).plus__O__O__O(value, $n(this.sci_NumericRange$NumericRangeIterator__f_self).sci_NumericRange__f_step);
  return value;
});
var $d_sci_NumericRange$NumericRangeIterator = new $TypeData().initClass($c_sci_NumericRange$NumericRangeIterator, "scala.collection.immutable.NumericRange$NumericRangeIterator", ({
  sci_NumericRange$NumericRangeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_RangeIterator(start, step, lastElement, initiallyEmpty) {
  this.sci_RangeIterator__f_step = 0;
  this.sci_RangeIterator__f_lastElement = 0;
  this.sci_RangeIterator__f__hasNext = false;
  this.sci_RangeIterator__f__next = 0;
  this.sci_RangeIterator__f_step = step;
  this.sci_RangeIterator__f_lastElement = lastElement;
  this.sci_RangeIterator__f__hasNext = (!initiallyEmpty);
  this.sci_RangeIterator__f__next = start;
}
$c_sci_RangeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RangeIterator.prototype.constructor = $c_sci_RangeIterator;
/** @constructor */
function $h_sci_RangeIterator() {
}
$h_sci_RangeIterator.prototype = $c_sci_RangeIterator.prototype;
$c_sci_RangeIterator.prototype.knownSize__I = (function() {
  return (this.sci_RangeIterator__f__hasNext ? ((1 + ((((this.sci_RangeIterator__f_lastElement - this.sci_RangeIterator__f__next) | 0) / $checkIntDivisor(this.sci_RangeIterator__f_step)) | 0)) | 0) : 0);
});
$c_sci_RangeIterator.prototype.hasNext__Z = (function() {
  return this.sci_RangeIterator__f__hasNext;
});
$c_sci_RangeIterator.prototype.next__I = (function() {
  if ((!this.sci_RangeIterator__f__hasNext)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var value = this.sci_RangeIterator__f__next;
  this.sci_RangeIterator__f__hasNext = (value !== this.sci_RangeIterator__f_lastElement);
  this.sci_RangeIterator__f__next = ((value + this.sci_RangeIterator__f_step) | 0);
  return value;
});
$c_sci_RangeIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var value = this.sci_RangeIterator__f__next;
    var hi = (value >> 31);
    var value$1 = Math.imul(this.sci_RangeIterator__f_step, n);
    var hi$1 = (value$1 >> 31);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((hi + hi$1) | 0) + ((((value & value$1) | ((value | value$1) & (~lo))) >>> 31) | 0)) | 0);
    if ((this.sci_RangeIterator__f_step > 0)) {
      var value$2 = this.sci_RangeIterator__f_lastElement;
      var hi$3 = (value$2 >> 31);
      if (((hi$3 === hi$2) ? ((value$2 >>> 0) < (lo >>> 0)) : (hi$3 < hi$2))) {
        var x_$_lo = value$2;
        var x_$_hi = hi$3;
      } else {
        var x_$_lo = lo;
        var x_$_hi = hi$2;
      }
      this.sci_RangeIterator__f__next = x_$_lo;
      var value$3 = this.sci_RangeIterator__f_lastElement;
      var hi$4 = (value$3 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$4) ? ((lo >>> 0) <= (value$3 >>> 0)) : (hi$2 < hi$4));
    } else if ((this.sci_RangeIterator__f_step < 0)) {
      var value$4 = this.sci_RangeIterator__f_lastElement;
      var hi$5 = (value$4 >> 31);
      if (((hi$5 === hi$2) ? ((value$4 >>> 0) > (lo >>> 0)) : (hi$5 > hi$2))) {
        var x$1_$_lo = value$4;
        var x$1_$_hi = hi$5;
      } else {
        var x$1_$_lo = lo;
        var x$1_$_hi = hi$2;
      }
      this.sci_RangeIterator__f__next = x$1_$_lo;
      var value$5 = this.sci_RangeIterator__f_lastElement;
      var hi$6 = (value$5 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$6) ? ((lo >>> 0) >= (value$5 >>> 0)) : (hi$2 > hi$6));
    }
  }
  return this;
});
$c_sci_RangeIterator.prototype.next__O = (function() {
  return this.next__I();
});
var $d_sci_RangeIterator = new $TypeData().initClass($c_sci_RangeIterator, "scala.collection.immutable.RangeIterator", ({
  sci_RangeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sci_Set$SetNIterator__I__($thiz, n) {
  $thiz.sci_Set$SetNIterator__f_current = 0;
  $thiz.sci_Set$SetNIterator__f_remainder = n;
  return $thiz;
}
/** @constructor */
function $c_sci_Set$SetNIterator() {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
}
$c_sci_Set$SetNIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Set$SetNIterator.prototype.constructor = $c_sci_Set$SetNIterator;
/** @constructor */
function $h_sci_Set$SetNIterator() {
}
$h_sci_Set$SetNIterator.prototype = $c_sci_Set$SetNIterator.prototype;
$c_sci_Set$SetNIterator.prototype.knownSize__I = (function() {
  return this.sci_Set$SetNIterator__f_remainder;
});
$c_sci_Set$SetNIterator.prototype.hasNext__Z = (function() {
  return (this.sci_Set$SetNIterator__f_remainder > 0);
});
$c_sci_Set$SetNIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.apply__I__O(this.sci_Set$SetNIterator__f_current);
    this.sci_Set$SetNIterator__f_current = ((1 + this.sci_Set$SetNIterator__f_current) | 0);
    this.sci_Set$SetNIterator__f_remainder = ((this.sci_Set$SetNIterator__f_remainder - 1) | 0);
    return r;
  } else {
    return $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
});
$c_sci_Set$SetNIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sci_Set$SetNIterator__f_current = ((this.sci_Set$SetNIterator__f_current + n) | 0);
    var b = ((this.sci_Set$SetNIterator__f_remainder - n) | 0);
    this.sci_Set$SetNIterator__f_remainder = ((b < 0) ? 0 : b);
  }
  return this;
});
/** @constructor */
function $c_sci_SetHashIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  this.sci_SetHashIterator__f_hash = 0;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
  this.sci_SetHashIterator__f_hash = 0;
}
$c_sci_SetHashIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetHashIterator.prototype.constructor = $c_sci_SetHashIterator;
/** @constructor */
function $h_sci_SetHashIterator() {
}
$h_sci_SetHashIterator.prototype = $c_sci_SetHashIterator.prototype;
$c_sci_SetHashIterator.prototype.hashCode__I = (function() {
  return this.sci_SetHashIterator__f_hash;
});
$c_sci_SetHashIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  this.sci_SetHashIterator__f_hash = $n(this.sci_ChampBaseIterator__f_currentValueNode).getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return this;
});
var $d_sci_SetHashIterator = new $TypeData().initClass($c_sci_SetHashIterator, "scala.collection.immutable.SetHashIterator", ({
  sci_SetHashIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_sci_SetIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
$c_sci_SetIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetIterator.prototype.constructor = $c_sci_SetIterator;
/** @constructor */
function $h_sci_SetIterator() {
}
$h_sci_SetIterator.prototype = $c_sci_SetIterator.prototype;
$c_sci_SetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var payload = $n($as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode)).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload;
});
var $d_sci_SetIterator = new $TypeData().initClass($c_sci_SetIterator, "scala.collection.immutable.SetIterator", ({
  sci_SetIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
function $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps($thiz, that) {
  var this$2 = $n($n(that).iterator__sc_Iterator());
  var f = ((x$1$2$2, x$2$2$2) => {
    var x$1$2 = $as_sci_SetOps(x$1$2$2);
    var this$1 = $n(x$1$2);
    return this$1.excl__O__sci_SetOps(x$2$2$2);
  });
  if ($is_sc_IndexedSeq(this$2)) {
    var x2 = $as_sc_IndexedSeq(this$2);
    var at = 0;
    var end = $n(x2).length__I();
    var acc = $thiz;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = $n(x2).apply__I__O(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = $thiz;
    while (this$2.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = this$2.next__O();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $as_sci_SetOps($x_1);
}
function $is_sci_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SetOps)));
}
function $as_sci_SetOps(obj) {
  return (($is_sci_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetOps"));
}
function $isArrayOf_sci_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetOps)));
}
function $asArrayOf_sci_SetOps(obj, depth) {
  return (($isArrayOf_sci_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetOps;", depth));
}
function $ct_scm_ArrayBuilder__($thiz) {
  $thiz.scm_ArrayBuilder__f_capacity = 0;
  $thiz.scm_ArrayBuilder__f_size = 0;
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayBuilder() {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0;
}
$c_scm_ArrayBuilder.prototype = new $h_O();
$c_scm_ArrayBuilder.prototype.constructor = $c_scm_ArrayBuilder;
/** @constructor */
function $h_scm_ArrayBuilder() {
}
$h_scm_ArrayBuilder.prototype = $c_scm_ArrayBuilder.prototype;
$c_scm_ArrayBuilder.prototype.sizeHint__I__V = (function(size) {
  if ((this.scm_ArrayBuilder__f_capacity < size)) {
    this.resize__I__V(size);
  }
});
/** @constructor */
function $c_scm_ArraySeq$() {
  this.scm_ArraySeq$__f_untagged = null;
  this.scm_ArraySeq$__f_EmptyArraySeq = null;
  $n_scm_ArraySeq$ = this;
  this.scm_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
  this.scm_ArraySeq$__f_EmptyArraySeq = new $c_scm_ArraySeq$ofRef(new $ac_O(0));
}
$c_scm_ArraySeq$.prototype = new $h_O();
$c_scm_ArraySeq$.prototype.constructor = $c_scm_ArraySeq$;
/** @constructor */
function $h_scm_ArraySeq$() {
}
$h_scm_ArraySeq$.prototype = $c_scm_ArraySeq$.prototype;
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq = (function(it, evidence$2) {
  return this.make__O__scm_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, evidence$2));
});
$c_scm_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$3) {
  var this$3 = new $c_scm_ArrayBuilder$generic($n(evidence$3).runtimeClass__jl_Class());
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => $m_scm_ArraySeq$().make__O__scm_ArraySeq(x$2$2)));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_scm_ArraySeq$.prototype.make__O__scm_ArraySeq = (function(x) {
  if ((x === null)) {
    return null;
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_scm_ArraySeq$ofRef(x3);
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_scm_ArraySeq$ofInt(x4);
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_scm_ArraySeq$ofDouble(x5);
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_scm_ArraySeq$ofLong(x6);
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_scm_ArraySeq$ofFloat(x7);
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_scm_ArraySeq$ofChar(x8);
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_scm_ArraySeq$ofByte(x9);
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_scm_ArraySeq$ofShort(x10);
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_scm_ArraySeq$ofBoolean(x11);
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_scm_ArraySeq$ofUnit(x12);
  } else {
    throw new $c_s_MatchError(x);
  }
});
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5));
});
$c_scm_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return this.scm_ArraySeq$__f_EmptyArraySeq;
});
var $d_scm_ArraySeq$ = new $TypeData().initClass($c_scm_ArraySeq$, "scala.collection.mutable.ArraySeq$", ({
  scm_ArraySeq$: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
}));
var $n_scm_ArraySeq$;
function $m_scm_ArraySeq$() {
  if ((!$n_scm_ArraySeq$)) {
    $n_scm_ArraySeq$ = new $c_scm_ArraySeq$();
  }
  return $n_scm_ArraySeq$;
}
/** @constructor */
function $c_scm_HashMap$$anon$1(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$c_scm_HashMap$$anon$1.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$1.prototype.constructor = $c_scm_HashMap$$anon$1;
/** @constructor */
function $h_scm_HashMap$$anon$1() {
}
$h_scm_HashMap$$anon$1.prototype = $c_scm_HashMap$$anon$1.prototype;
$c_scm_HashMap$$anon$1.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return new $c_T2($n(nd).scm_HashMap$Node__f__key, $n(nd).scm_HashMap$Node__f__value);
});
var $d_scm_HashMap$$anon$1 = new $TypeData().initClass($c_scm_HashMap$$anon$1, "scala.collection.mutable.HashMap$$anon$1", ({
  scm_HashMap$$anon$1: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$3(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$c_scm_HashMap$$anon$3.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$3.prototype.constructor = $c_scm_HashMap$$anon$3;
/** @constructor */
function $h_scm_HashMap$$anon$3() {
}
$h_scm_HashMap$$anon$3.prototype = $c_scm_HashMap$$anon$3.prototype;
$c_scm_HashMap$$anon$3.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return $n(nd).scm_HashMap$Node__f__value;
});
var $d_scm_HashMap$$anon$3 = new $TypeData().initClass($c_scm_HashMap$$anon$3, "scala.collection.mutable.HashMap$$anon$3", ({
  scm_HashMap$$anon$3: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$4(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
$c_scm_HashMap$$anon$4.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$4.prototype.constructor = $c_scm_HashMap$$anon$4;
/** @constructor */
function $h_scm_HashMap$$anon$4() {
}
$h_scm_HashMap$$anon$4.prototype = $c_scm_HashMap$$anon$4.prototype;
$c_scm_HashMap$$anon$4.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd;
});
var $d_scm_HashMap$$anon$4 = new $TypeData().initClass($c_scm_HashMap$$anon$4, "scala.collection.mutable.HashMap$$anon$4", ({
  scm_HashMap$$anon$4: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashMap$$anon$5(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  this.scm_HashMap$$anon$5__f_hash = 0;
  this.scm_HashMap$$anon$5__f_$outer = null;
  $n(outer);
  this.scm_HashMap$$anon$5__f_$outer = outer;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
  this.scm_HashMap$$anon$5__f_hash = 0;
}
$c_scm_HashMap$$anon$5.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$5.prototype.constructor = $c_scm_HashMap$$anon$5;
/** @constructor */
function $h_scm_HashMap$$anon$5() {
}
$h_scm_HashMap$$anon$5.prototype = $c_scm_HashMap$$anon$5.prototype;
$c_scm_HashMap$$anon$5.prototype.hashCode__I = (function() {
  return this.scm_HashMap$$anon$5__f_hash;
});
$c_scm_HashMap$$anon$5.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  var $x_1 = $m_s_util_hashing_MurmurHash3$();
  $n(this.scm_HashMap$$anon$5__f_$outer);
  var improvedHash = $n(nd).scm_HashMap$Node__f__hash;
  var x = $n(nd).scm_HashMap$Node__f__value;
  this.scm_HashMap$$anon$5__f_hash = $x_1.tuple2Hash__O__O__I((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().anyHash__O__I(x));
  return this;
});
var $d_scm_HashMap$$anon$5 = new $TypeData().initClass($c_scm_HashMap$$anon$5, "scala.collection.mutable.HashMap$$anon$5", ({
  scm_HashMap$$anon$5: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$1(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
$c_scm_HashSet$$anon$1.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$1.prototype.constructor = $c_scm_HashSet$$anon$1;
/** @constructor */
function $h_scm_HashSet$$anon$1() {
}
$h_scm_HashSet$$anon$1.prototype = $c_scm_HashSet$$anon$1.prototype;
$c_scm_HashSet$$anon$1.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return $n(nd).scm_HashSet$Node__f__key;
});
var $d_scm_HashSet$$anon$1 = new $TypeData().initClass($c_scm_HashSet$$anon$1, "scala.collection.mutable.HashSet$$anon$1", ({
  scm_HashSet$$anon$1: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$2(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
$c_scm_HashSet$$anon$2.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$2.prototype.constructor = $c_scm_HashSet$$anon$2;
/** @constructor */
function $h_scm_HashSet$$anon$2() {
}
$h_scm_HashSet$$anon$2.prototype = $c_scm_HashSet$$anon$2.prototype;
$c_scm_HashSet$$anon$2.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return nd;
});
var $d_scm_HashSet$$anon$2 = new $TypeData().initClass($c_scm_HashSet$$anon$2, "scala.collection.mutable.HashSet$$anon$2", ({
  scm_HashSet$$anon$2: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_scm_HashSet$$anon$3(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  this.scm_HashSet$$anon$3__f_hash = 0;
  this.scm_HashSet$$anon$3__f_$outer = null;
  $n(outer);
  this.scm_HashSet$$anon$3__f_$outer = outer;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
  this.scm_HashSet$$anon$3__f_hash = 0;
}
$c_scm_HashSet$$anon$3.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$3.prototype.constructor = $c_scm_HashSet$$anon$3;
/** @constructor */
function $h_scm_HashSet$$anon$3() {
}
$h_scm_HashSet$$anon$3.prototype = $c_scm_HashSet$$anon$3.prototype;
$c_scm_HashSet$$anon$3.prototype.hashCode__I = (function() {
  return this.scm_HashSet$$anon$3__f_hash;
});
$c_scm_HashSet$$anon$3.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  var this$1 = $n(this.scm_HashSet$$anon$3__f_$outer);
  var improvedHash = $n(nd).scm_HashSet$Node__f__hash;
  this.scm_HashSet$$anon$3__f_hash = this$1.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
  return this;
});
var $d_scm_HashSet$$anon$3 = new $TypeData().initClass($c_scm_HashSet$$anon$3, "scala.collection.mutable.HashSet$$anon$3", ({
  scm_HashSet$$anon$3: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$1() {
}
$c_s_concurrent_duration_Duration$$anon$1.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$1.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$1() {
}
$h_s_concurrent_duration_Duration$$anon$1.prototype = $c_s_concurrent_duration_Duration$$anon$1.prototype;
$c_s_concurrent_duration_Duration$$anon$1.prototype.toString__T = (function() {
  return "Duration.Undefined";
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.equals__O__Z = (function(other) {
  return false;
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  return this;
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : 1);
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
var $d_s_concurrent_duration_Duration$$anon$1 = new $TypeData().initClass($c_s_concurrent_duration_Duration$$anon$1, "scala.concurrent.duration.Duration$$anon$1", ({
  s_concurrent_duration_Duration$$anon$1: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$2() {
}
$c_s_concurrent_duration_Duration$$anon$2.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$2.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$2() {
}
$h_s_concurrent_duration_Duration$$anon$2.prototype = $c_s_concurrent_duration_Duration$$anon$2.prototype;
$c_s_concurrent_duration_Duration$$anon$2.prototype.toString__T = (function() {
  return "Duration.Inf";
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined) ? (-1) : ((other === this) ? 0 : 1));
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
var $d_s_concurrent_duration_Duration$$anon$2 = new $TypeData().initClass($c_s_concurrent_duration_Duration$$anon$2, "scala.concurrent.duration.Duration$$anon$2", ({
  s_concurrent_duration_Duration$$anon$2: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$3() {
}
$c_s_concurrent_duration_Duration$$anon$3.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$3.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$3() {
}
$h_s_concurrent_duration_Duration$$anon$3.prototype = $c_s_concurrent_duration_Duration$$anon$3.prototype;
$c_s_concurrent_duration_Duration$$anon$3.prototype.toString__T = (function() {
  return "Duration.MinusInf";
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : (-1));
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that));
});
var $d_s_concurrent_duration_Duration$$anon$3 = new $TypeData().initClass($c_s_concurrent_duration_Duration$$anon$3, "scala.concurrent.duration.Duration$$anon$3", ({
  s_concurrent_duration_Duration$$anon$3: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
function $f_s_math_Numeric__sign__O__O($thiz, x) {
  return ($f_s_math_Ordering__lt__O__O__Z($thiz, x, $thiz.fromInt__I__O(0)) ? $thiz.negate__O__O($thiz.fromInt__I__O(1)) : ($f_s_math_Ordering__gt__O__O__Z($thiz, x, $thiz.fromInt__I__O(0)) ? $thiz.fromInt__I__O(1) : $thiz.fromInt__I__O(0)));
}
function $is_s_math_Numeric(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Numeric)));
}
function $as_s_math_Numeric(obj) {
  return (($is_s_math_Numeric(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Numeric"));
}
function $isArrayOf_s_math_Numeric(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Numeric)));
}
function $asArrayOf_s_math_Numeric(obj, depth) {
  return (($isArrayOf_s_math_Numeric(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Numeric;", depth));
}
/** @constructor */
function $c_s_math_Ordering$$anon$1(outer, f$1) {
  this.s_math_Ordering$$anon$1__f_$outer = null;
  this.s_math_Ordering$$anon$1__f_f$1 = null;
  $n(outer);
  this.s_math_Ordering$$anon$1__f_$outer = outer;
  this.s_math_Ordering$$anon$1__f_f$1 = f$1;
}
$c_s_math_Ordering$$anon$1.prototype = new $h_O();
$c_s_math_Ordering$$anon$1.prototype.constructor = $c_s_math_Ordering$$anon$1;
/** @constructor */
function $h_s_math_Ordering$$anon$1() {
}
$h_s_math_Ordering$$anon$1.prototype = $c_s_math_Ordering$$anon$1.prototype;
$c_s_math_Ordering$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.s_math_Ordering$$anon$1__f_$outer).compare__O__O__I($n(this.s_math_Ordering$$anon$1__f_f$1).apply__O__O(x), $n(this.s_math_Ordering$$anon$1__f_f$1).apply__O__O(y));
});
var $d_s_math_Ordering$$anon$1 = new $TypeData().initClass($c_s_math_Ordering$$anon$1, "scala.math.Ordering$$anon$1", ({
  s_math_Ordering$$anon$1: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
function $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($thiz, other) {
  return (other === $thiz.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse);
}
/** @constructor */
function $c_s_math_Ordering$Reverse(outer) {
  this.s_math_Ordering$Reverse__f_outer = null;
  this.s_math_Ordering$Reverse__f_outer = outer;
}
$c_s_math_Ordering$Reverse.prototype = new $h_O();
$c_s_math_Ordering$Reverse.prototype.constructor = $c_s_math_Ordering$Reverse;
/** @constructor */
function $h_s_math_Ordering$Reverse() {
}
$h_s_math_Ordering$Reverse.prototype = $c_s_math_Ordering$Reverse.prototype;
$c_s_math_Ordering$Reverse.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  var x$2 = this.s_math_Ordering$Reverse__f_outer;
  return ((other === null) ? (x$2 === null) : $n(other).equals__O__Z(x$2));
});
$c_s_math_Ordering$Reverse.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).compare__O__O__I(y, x);
});
$c_s_math_Ordering$Reverse.prototype.gteq__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).gteq__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.equiv__O__O__Z = (function(x, y) {
  return $n(this.s_math_Ordering$Reverse__f_outer).equiv__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true;
    }
  }
  if ((obj instanceof $c_s_math_Ordering$Reverse)) {
    var x3 = $as_s_math_Ordering$Reverse(obj);
    var x = this.s_math_Ordering$Reverse__f_outer;
    var x$2 = $n(x3).s_math_Ordering$Reverse__f_outer;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  }
  return false;
});
$c_s_math_Ordering$Reverse.prototype.hashCode__I = (function() {
  return Math.imul(41, $n(this.s_math_Ordering$Reverse__f_outer).hashCode__I());
});
function $as_s_math_Ordering$Reverse(obj) {
  return (((obj instanceof $c_s_math_Ordering$Reverse) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$Reverse"));
}
function $isArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Reverse)));
}
function $asArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (($isArrayOf_s_math_Ordering$Reverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$Reverse;", depth));
}
var $d_s_math_Ordering$Reverse = new $TypeData().initClass($c_s_math_Ordering$Reverse, "scala.math.Ordering$Reverse", ({
  s_math_Ordering$Reverse: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_reflect_ClassTag$GenericClassTag(runtimeClass) {
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = null;
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = runtimeClass;
}
$c_s_reflect_ClassTag$GenericClassTag.prototype = new $h_O();
$c_s_reflect_ClassTag$GenericClassTag.prototype.constructor = $c_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $h_s_reflect_ClassTag$GenericClassTag() {
}
$h_s_reflect_ClassTag$GenericClassTag.prototype = $c_s_reflect_ClassTag$GenericClassTag.prototype;
$c_s_reflect_ClassTag$GenericClassTag.prototype.equals__O__Z = (function(x) {
  return $f_s_reflect_ClassTag__equals__O__Z(this, x);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.hashCode__I = (function() {
  var x = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_sr_Statics$().anyHash__O__I(x);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.toString__T = (function() {
  return $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.runtimeClass__jl_Class = (function() {
  return this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.newArray__I__O = (function(len) {
  var componentType = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $n(componentType).data.newArray(len);
});
var $d_s_reflect_ClassTag$GenericClassTag = new $TypeData().initClass($c_s_reflect_ClassTag$GenericClassTag, "scala.reflect.ClassTag$GenericClassTag", ({
  s_reflect_ClassTag$GenericClassTag: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
/** @constructor */
function $c_Ltyrian_Html$() {
  this.Ltyrian_Html$__f_id$minusString = null;
  this.Ltyrian_Html$__f_style$minusString = null;
  this.Ltyrian_Html$__f_value$minusString = null;
  $n_Ltyrian_Html$ = this;
  $f_Ltyrian_HtmlAttributes__$init$__V(this);
}
$c_Ltyrian_Html$.prototype = new $h_O();
$c_Ltyrian_Html$.prototype.constructor = $c_Ltyrian_Html$;
/** @constructor */
function $h_Ltyrian_Html$() {
}
$h_Ltyrian_Html$.prototype = $c_Ltyrian_Html$.prototype;
$c_Ltyrian_Html$.prototype.onChange__F1__Ltyrian_Attr = (function(msg) {
  var msg$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => $n(msg).apply__O__O($as_T(e.target.value))));
  return new $c_Ltyrian_Event("change", msg$1, true, true, true);
});
var $d_Ltyrian_Html$ = new $TypeData().initClass($c_Ltyrian_Html$, "tyrian.Html$", ({
  Ltyrian_Html$: 1,
  Ltyrian_HtmlTags: 1,
  Ltyrian_HtmlAttributes: 1,
  Ltyrian_AttributeSyntax: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Ltyrian_Html$;
function $m_Ltyrian_Html$() {
  if ((!$n_Ltyrian_Html$)) {
    $n_Ltyrian_Html$ = new $c_Ltyrian_Html$();
  }
  return $n_Ltyrian_Html$;
}
function $as_Ltyrian_PropertyBoolean(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.PropertyBoolean"));
}
function $isArrayOf_Ltyrian_PropertyBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_PropertyBoolean)));
}
function $asArrayOf_Ltyrian_PropertyBoolean(obj, depth) {
  return (($isArrayOf_Ltyrian_PropertyBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.PropertyBoolean;", depth));
}
/** @constructor */
function $c_Ltyrian_PropertyString(name, value) {
  this.Ltyrian_PropertyString__f_name = null;
  this.Ltyrian_PropertyString__f_value = null;
  this.Ltyrian_PropertyString__f_valueOf = null;
  this.Ltyrian_PropertyString__f_name = name;
  this.Ltyrian_PropertyString__f_value = value;
  this.Ltyrian_PropertyString__f_valueOf = value;
}
$c_Ltyrian_PropertyString.prototype = new $h_O();
$c_Ltyrian_PropertyString.prototype.constructor = $c_Ltyrian_PropertyString;
/** @constructor */
function $h_Ltyrian_PropertyString() {
}
$h_Ltyrian_PropertyString.prototype = $c_Ltyrian_PropertyString.prototype;
$c_Ltyrian_PropertyString.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(this);
});
$c_Ltyrian_PropertyString.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_PropertyString.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_PropertyString.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_PropertyString)) {
    var x$0$2 = $as_Ltyrian_PropertyString(x$0);
    return ((this.Ltyrian_PropertyString__f_name === $n(x$0$2).Ltyrian_PropertyString__f_name) && (this.Ltyrian_PropertyString__f_value === $n(x$0$2).Ltyrian_PropertyString__f_value));
  } else {
    return false;
  }
});
$c_Ltyrian_PropertyString.prototype.productArity__I = (function() {
  return 2;
});
$c_Ltyrian_PropertyString.prototype.productPrefix__T = (function() {
  return "PropertyString";
});
$c_Ltyrian_PropertyString.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_PropertyString__f_name;
  }
  if ((n === 1)) {
    return this.Ltyrian_PropertyString__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_PropertyString(obj) {
  return (((obj instanceof $c_Ltyrian_PropertyString) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.PropertyString"));
}
function $isArrayOf_Ltyrian_PropertyString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_PropertyString)));
}
function $asArrayOf_Ltyrian_PropertyString(obj, depth) {
  return (($isArrayOf_Ltyrian_PropertyString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.PropertyString;", depth));
}
var $d_Ltyrian_PropertyString = new $TypeData().initClass($c_Ltyrian_PropertyString, "tyrian.PropertyString", ({
  Ltyrian_PropertyString: 1,
  Ltyrian_Attr: 1,
  Ltyrian_Property: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_RawTag(name, attributes, innerHTML, key) {
  this.Ltyrian_RawTag__f_name = null;
  this.Ltyrian_RawTag__f_attributes = null;
  this.Ltyrian_RawTag__f_innerHTML = null;
  this.Ltyrian_RawTag__f_key = null;
  this.Ltyrian_RawTag__f_name = name;
  this.Ltyrian_RawTag__f_attributes = attributes;
  this.Ltyrian_RawTag__f_innerHTML = innerHTML;
  this.Ltyrian_RawTag__f_key = key;
}
$c_Ltyrian_RawTag.prototype = new $h_O();
$c_Ltyrian_RawTag.prototype.constructor = $c_Ltyrian_RawTag;
/** @constructor */
function $h_Ltyrian_RawTag() {
}
$h_Ltyrian_RawTag.prototype = $c_Ltyrian_RawTag.prototype;
$c_Ltyrian_RawTag.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Html__T(this);
});
$c_Ltyrian_RawTag.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_RawTag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_RawTag.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_RawTag)) {
    var x$0$2 = $as_Ltyrian_RawTag(x$0);
    if ((this.Ltyrian_RawTag__f_name === $n(x$0$2).Ltyrian_RawTag__f_name)) {
      var x = this.Ltyrian_RawTag__f_attributes;
      var x$2 = $n(x$0$2).Ltyrian_RawTag__f_attributes;
      var $x_1 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.Ltyrian_RawTag__f_innerHTML === $n(x$0$2).Ltyrian_RawTag__f_innerHTML))) {
      var x$3 = this.Ltyrian_RawTag__f_key;
      var x$4 = $n(x$0$2).Ltyrian_RawTag__f_key;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_RawTag.prototype.productArity__I = (function() {
  return 4;
});
$c_Ltyrian_RawTag.prototype.productPrefix__T = (function() {
  return "RawTag";
});
$c_Ltyrian_RawTag.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_RawTag__f_name;
      break;
    }
    case 1: {
      return this.Ltyrian_RawTag__f_attributes;
      break;
    }
    case 2: {
      return this.Ltyrian_RawTag__f_innerHTML;
      break;
    }
    case 3: {
      return this.Ltyrian_RawTag__f_key;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_RawTag(obj) {
  return (((obj instanceof $c_Ltyrian_RawTag) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.RawTag"));
}
function $isArrayOf_Ltyrian_RawTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_RawTag)));
}
function $asArrayOf_Ltyrian_RawTag(obj, depth) {
  return (($isArrayOf_Ltyrian_RawTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.RawTag;", depth));
}
var $d_Ltyrian_RawTag = new $TypeData().initClass($c_Ltyrian_RawTag, "tyrian.RawTag", ({
  Ltyrian_RawTag: 1,
  Ltyrian_Elem: 1,
  Ltyrian_Html: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_Tag(name, attributes, children, key) {
  this.Ltyrian_Tag__f_name = null;
  this.Ltyrian_Tag__f_attributes = null;
  this.Ltyrian_Tag__f_children = null;
  this.Ltyrian_Tag__f_key = null;
  this.Ltyrian_Tag__f_name = name;
  this.Ltyrian_Tag__f_attributes = attributes;
  this.Ltyrian_Tag__f_children = children;
  this.Ltyrian_Tag__f_key = key;
}
$c_Ltyrian_Tag.prototype = new $h_O();
$c_Ltyrian_Tag.prototype.constructor = $c_Ltyrian_Tag;
/** @constructor */
function $h_Ltyrian_Tag() {
}
$h_Ltyrian_Tag.prototype = $c_Ltyrian_Tag.prototype;
$c_Ltyrian_Tag.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Html__T(this);
});
$c_Ltyrian_Tag.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Tag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ltyrian_Tag.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_Tag)) {
    var x$0$2 = $as_Ltyrian_Tag(x$0);
    if ((this.Ltyrian_Tag__f_name === $n(x$0$2).Ltyrian_Tag__f_name)) {
      var x = this.Ltyrian_Tag__f_attributes;
      var x$2 = $n(x$0$2).Ltyrian_Tag__f_attributes;
      var $x_2 = ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Ltyrian_Tag__f_children;
      var x$4 = $n(x$0$2).Ltyrian_Tag__f_children;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Ltyrian_Tag__f_key;
      var x$6 = $n(x$0$2).Ltyrian_Tag__f_key;
      return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ltyrian_Tag.prototype.productArity__I = (function() {
  return 4;
});
$c_Ltyrian_Tag.prototype.productPrefix__T = (function() {
  return "Tag";
});
$c_Ltyrian_Tag.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_Tag__f_name;
      break;
    }
    case 1: {
      return this.Ltyrian_Tag__f_attributes;
      break;
    }
    case 2: {
      return this.Ltyrian_Tag__f_children;
      break;
    }
    case 3: {
      return this.Ltyrian_Tag__f_key;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $as_Ltyrian_Tag(obj) {
  return (((obj instanceof $c_Ltyrian_Tag) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Tag"));
}
function $isArrayOf_Ltyrian_Tag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Tag)));
}
function $asArrayOf_Ltyrian_Tag(obj, depth) {
  return (($isArrayOf_Ltyrian_Tag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Tag;", depth));
}
var $d_Ltyrian_Tag = new $TypeData().initClass($c_Ltyrian_Tag, "tyrian.Tag", ({
  Ltyrian_Tag: 1,
  Ltyrian_Elem: 1,
  Ltyrian_Html: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ltyrian_runtime_RendererState$Running(lastTriggered_$_lo, lastTriggered_$_hi) {
  this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$lo = 0;
  this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$hi = 0;
  this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$lo = lastTriggered_$_lo;
  this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$hi = lastTriggered_$_hi;
}
$c_Ltyrian_runtime_RendererState$Running.prototype = new $h_Ltyrian_runtime_RendererState();
$c_Ltyrian_runtime_RendererState$Running.prototype.constructor = $c_Ltyrian_runtime_RendererState$Running;
/** @constructor */
function $h_Ltyrian_runtime_RendererState$Running() {
}
$h_Ltyrian_runtime_RendererState$Running.prototype = $c_Ltyrian_runtime_RendererState$Running.prototype;
$c_Ltyrian_runtime_RendererState$Running.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Running");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var lv_$_lo = this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$lo;
  var lv_$_hi = this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(lv_$_lo, lv_$_hi);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Ltyrian_runtime_RendererState$Running.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ltyrian_runtime_RendererState$Running)) {
    var x$0$2 = $as_Ltyrian_runtime_RendererState$Running(x$0);
    var x_$_lo = this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$lo;
    var x_$_hi = this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$hi;
    var x$1_$_lo = $n(x$0$2).Ltyrian_runtime_RendererState$Running__f_lastTriggered_$lo;
    var x$1_$_hi = $n(x$0$2).Ltyrian_runtime_RendererState$Running__f_lastTriggered_$hi;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return false;
  }
});
$c_Ltyrian_runtime_RendererState$Running.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ltyrian_runtime_RendererState$Running.prototype.productArity__I = (function() {
  return 1;
});
$c_Ltyrian_runtime_RendererState$Running.prototype.productPrefix__T = (function() {
  return "Running";
});
$c_Ltyrian_runtime_RendererState$Running.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return $bL(this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$lo, this.Ltyrian_runtime_RendererState$Running__f_lastTriggered_$hi);
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Ltyrian_runtime_RendererState$Running(obj) {
  return (((obj instanceof $c_Ltyrian_runtime_RendererState$Running) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.runtime.RendererState$Running"));
}
function $isArrayOf_Ltyrian_runtime_RendererState$Running(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_runtime_RendererState$Running)));
}
function $asArrayOf_Ltyrian_runtime_RendererState$Running(obj, depth) {
  return (($isArrayOf_Ltyrian_runtime_RendererState$Running(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.runtime.RendererState$Running;", depth));
}
var $d_Ltyrian_runtime_RendererState$Running = new $TypeData().initClass($c_Ltyrian_runtime_RendererState$Running, "tyrian.runtime.RendererState$Running", ({
  Ltyrian_runtime_RendererState$Running: 1,
  Ltyrian_runtime_RendererState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
function $f_Lcats_Apply__productL__O__O__O($thiz, fa, fb) {
  return $thiz.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a, _$2) => a)));
}
function $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fb$2) => $thiz.map2__O__O__F2__O(fa, fb$2, f))));
}
function $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__($thiz, leftNE, rightNE) {
  $thiz.Lcats_data_Chain$Append__f_leftNE = leftNE;
  $thiz.Lcats_data_Chain$Append__f_rightNE = rightNE;
  return $thiz;
}
function $ct_Lcats_data_Chain$Append__Lcats_data_Chain__Lcats_data_Chain__($thiz, left, right) {
  $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__($thiz, $as_Lcats_data_Chain$NonEmpty(left), $as_Lcats_data_Chain$NonEmpty(right));
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_Chain$Append() {
  this.Lcats_data_Chain$Append__f_leftNE = null;
  this.Lcats_data_Chain$Append__f_rightNE = null;
}
$c_Lcats_data_Chain$Append.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Append.prototype.constructor = $c_Lcats_data_Chain$Append;
/** @constructor */
function $h_Lcats_data_Chain$Append() {
}
$h_Lcats_data_Chain$Append.prototype = $c_Lcats_data_Chain$Append.prototype;
$c_Lcats_data_Chain$Append.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Append.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_Chain$Append.prototype.productPrefix__T = (function() {
  return "Append";
});
$c_Lcats_data_Chain$Append.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Append__f_leftNE;
  }
  if ((n === 1)) {
    return this.Lcats_data_Chain$Append__f_rightNE;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_Chain$Append(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Append) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Append"));
}
function $isArrayOf_Lcats_data_Chain$Append(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Append)));
}
function $asArrayOf_Lcats_data_Chain$Append(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Append(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Append;", depth));
}
var $d_Lcats_data_Chain$Append = new $TypeData().initClass($c_Lcats_data_Chain$Append, "cats.data.Chain$Append", ({
  Lcats_data_Chain$Append: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_Chain$Singleton(a) {
  this.Lcats_data_Chain$Singleton__f_a = null;
  this.Lcats_data_Chain$Singleton__f_a = a;
}
$c_Lcats_data_Chain$Singleton.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Singleton.prototype.constructor = $c_Lcats_data_Chain$Singleton;
/** @constructor */
function $h_Lcats_data_Chain$Singleton() {
}
$h_Lcats_data_Chain$Singleton.prototype = $c_Lcats_data_Chain$Singleton.prototype;
$c_Lcats_data_Chain$Singleton.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Singleton.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Chain$Singleton.prototype.productPrefix__T = (function() {
  return "Singleton";
});
$c_Lcats_data_Chain$Singleton.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Singleton__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_Chain$Singleton(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Singleton) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Singleton"));
}
function $isArrayOf_Lcats_data_Chain$Singleton(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Singleton)));
}
function $asArrayOf_Lcats_data_Chain$Singleton(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Singleton(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Singleton;", depth));
}
var $d_Lcats_data_Chain$Singleton = new $TypeData().initClass($c_Lcats_data_Chain$Singleton, "cats.data.Chain$Singleton", ({
  Lcats_data_Chain$Singleton: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_data_Chain$Wrap(seq) {
  this.Lcats_data_Chain$Wrap__f_seq = null;
  this.Lcats_data_Chain$Wrap__f_seq = seq;
}
$c_Lcats_data_Chain$Wrap.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Wrap.prototype.constructor = $c_Lcats_data_Chain$Wrap;
/** @constructor */
function $h_Lcats_data_Chain$Wrap() {
}
$h_Lcats_data_Chain$Wrap.prototype = $c_Lcats_data_Chain$Wrap.prototype;
$c_Lcats_data_Chain$Wrap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Wrap.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Chain$Wrap.prototype.productPrefix__T = (function() {
  return "Wrap";
});
$c_Lcats_data_Chain$Wrap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Wrap__f_seq;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_data_Chain$Wrap(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Wrap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Wrap"));
}
function $isArrayOf_Lcats_data_Chain$Wrap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Wrap)));
}
function $asArrayOf_Lcats_data_Chain$Wrap(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Wrap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Wrap;", depth));
}
var $d_Lcats_data_Chain$Wrap = new $TypeData().initClass($c_Lcats_data_Chain$Wrap, "cats.data.Chain$Wrap", ({
  Lcats_data_Chain$Wrap: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Lcats_data_KleisliInstances3__($thiz) {
  $m_Lcats_package$();
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_KleisliInstances3() {
}
$c_Lcats_data_KleisliInstances3.prototype = new $h_Lcats_data_KleisliInstances4();
$c_Lcats_data_KleisliInstances3.prototype.constructor = $c_Lcats_data_KleisliInstances3;
/** @constructor */
function $h_Lcats_data_KleisliInstances3() {
}
$h_Lcats_data_KleisliInstances3.prototype = $c_Lcats_data_KleisliInstances3.prototype;
function $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__($thiz, fa, f, g) {
  $thiz.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = fa;
  $thiz.Lcats_instances_ScalaVersionSpecificNumeric__f_f = f;
  $thiz.Lcats_instances_ScalaVersionSpecificNumeric__f_g = g;
  return $thiz;
}
/** @constructor */
function $c_Lcats_instances_ScalaVersionSpecificNumeric() {
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_f = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_g = null;
}
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype = new $h_O();
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.constructor = $c_Lcats_instances_ScalaVersionSpecificNumeric;
/** @constructor */
function $h_Lcats_instances_ScalaVersionSpecificNumeric() {
}
$h_Lcats_instances_ScalaVersionSpecificNumeric.prototype = $c_Lcats_instances_ScalaVersionSpecificNumeric.prototype;
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.sign__O__O = (function(x) {
  return $f_s_math_Numeric__sign__O__O(this, x);
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.compare__O__O__I = (function(x, y) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).compare__O__O__I($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x), $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(y));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.plus__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).plus__O__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x), $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(y)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.minus__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).minus__O__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x), $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(y)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.times__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).times__O__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x), $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(y)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.negate__O__O = (function(x) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).negate__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x)));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.fromInt__I__O = (function(x) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_f).apply__O__O($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).fromInt__I__O(x));
});
$c_Lcats_instances_ScalaVersionSpecificNumeric.prototype.toInt__O__I = (function(x) {
  return $n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa).toInt__O__I($n(this.Lcats_instances_ScalaVersionSpecificNumeric__f_g).apply__O__O(x));
});
/** @constructor */
function $c_Lcats_instances_package$option$() {
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = null;
  $n_Lcats_instances_package$option$ = this;
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = new $c_Lcats_instances_OptionInstances$$anon$1();
  new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3();
}
$c_Lcats_instances_package$option$.prototype = new $h_O();
$c_Lcats_instances_package$option$.prototype.constructor = $c_Lcats_instances_package$option$;
/** @constructor */
function $h_Lcats_instances_package$option$() {
}
$h_Lcats_instances_package$option$.prototype = $c_Lcats_instances_package$option$.prototype;
var $d_Lcats_instances_package$option$ = new $TypeData().initClass($c_Lcats_instances_package$option$, "cats.instances.package$option$", ({
  Lcats_instances_package$option$: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$option$;
function $m_Lcats_instances_package$option$() {
  if ((!$n_Lcats_instances_package$option$)) {
    $n_Lcats_instances_package$option$ = new $c_Lcats_instances_package$option$();
  }
  return $n_Lcats_instances_package$option$;
}
/** @constructor */
function $c_Lfs2_Pull$Fail(error) {
  this.Lfs2_Pull$Fail__f_error = null;
  this.Lfs2_Pull$Fail__f_error = error;
}
$c_Lfs2_Pull$Fail.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Fail.prototype.constructor = $c_Lfs2_Pull$Fail;
/** @constructor */
function $h_Lfs2_Pull$Fail() {
}
$h_Lfs2_Pull$Fail.prototype = $c_Lfs2_Pull$Fail.prototype;
$c_Lfs2_Pull$Fail.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Fail.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$Fail.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Fail)) {
    var x$0$2 = $as_Lfs2_Pull$Fail(x$0);
    var x = this.Lfs2_Pull$Fail__f_error;
    var x$2 = $n(x$0$2).Lfs2_Pull$Fail__f_error;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Fail.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Fail.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Fail.prototype.productPrefix__T = (function() {
  return "Fail";
});
$c_Lfs2_Pull$Fail.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Fail__f_error;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Fail(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Fail) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Fail"));
}
function $isArrayOf_Lfs2_Pull$Fail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Fail)));
}
function $asArrayOf_Lfs2_Pull$Fail(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Fail(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Fail;", depth));
}
var $d_Lfs2_Pull$Fail = new $TypeData().initClass($c_Lfs2_Pull$Fail, "fs2.Pull$Fail", ({
  Lfs2_Pull$Fail: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$FlatMapOutput(stream, fun) {
  this.Lfs2_Pull$FlatMapOutput__f_stream = null;
  this.Lfs2_Pull$FlatMapOutput__f_fun = null;
  this.Lfs2_Pull$FlatMapOutput__f_stream = stream;
  this.Lfs2_Pull$FlatMapOutput__f_fun = fun;
}
$c_Lfs2_Pull$FlatMapOutput.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$FlatMapOutput.prototype.constructor = $c_Lfs2_Pull$FlatMapOutput;
/** @constructor */
function $h_Lfs2_Pull$FlatMapOutput() {
}
$h_Lfs2_Pull$FlatMapOutput.prototype = $c_Lfs2_Pull$FlatMapOutput.prototype;
$c_Lfs2_Pull$FlatMapOutput.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$FlatMapOutput.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$FlatMapOutput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$FlatMapOutput)) {
    var x$0$2 = $as_Lfs2_Pull$FlatMapOutput(x$0);
    var x = this.Lfs2_Pull$FlatMapOutput__f_stream;
    var x$2 = $n(x$0$2).Lfs2_Pull$FlatMapOutput__f_stream;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_Pull$FlatMapOutput__f_fun;
      var x$4 = $n(x$0$2).Lfs2_Pull$FlatMapOutput__f_fun;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$FlatMapOutput.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productPrefix__T = (function() {
  return "FlatMapOutput";
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$FlatMapOutput__f_stream;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$FlatMapOutput__f_fun;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$FlatMapOutput(obj) {
  return (((obj instanceof $c_Lfs2_Pull$FlatMapOutput) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$FlatMapOutput"));
}
function $isArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$FlatMapOutput)));
}
function $asArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$FlatMapOutput;", depth));
}
var $d_Lfs2_Pull$FlatMapOutput = new $TypeData().initClass($c_Lfs2_Pull$FlatMapOutput, "fs2.Pull$FlatMapOutput", ({
  Lfs2_Pull$FlatMapOutput: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$InScope(stream, useInterruption) {
  this.Lfs2_Pull$InScope__f_stream = null;
  this.Lfs2_Pull$InScope__f_useInterruption = false;
  this.Lfs2_Pull$InScope__f_stream = stream;
  this.Lfs2_Pull$InScope__f_useInterruption = useInterruption;
}
$c_Lfs2_Pull$InScope.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$InScope.prototype.constructor = $c_Lfs2_Pull$InScope;
/** @constructor */
function $h_Lfs2_Pull$InScope() {
}
$h_Lfs2_Pull$InScope.prototype = $c_Lfs2_Pull$InScope.prototype;
$c_Lfs2_Pull$InScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$InScope.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("InScope");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lfs2_Pull$InScope__f_stream;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lfs2_Pull$InScope__f_useInterruption ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lfs2_Pull$InScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$InScope)) {
    var x$0$2 = $as_Lfs2_Pull$InScope(x$0);
    if ((this.Lfs2_Pull$InScope__f_useInterruption === $n(x$0$2).Lfs2_Pull$InScope__f_useInterruption)) {
      var x = this.Lfs2_Pull$InScope__f_stream;
      var x$2 = $n(x$0$2).Lfs2_Pull$InScope__f_stream;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$InScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$InScope.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$InScope.prototype.productPrefix__T = (function() {
  return "InScope";
});
$c_Lfs2_Pull$InScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$InScope__f_stream;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$InScope__f_useInterruption;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$InScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$InScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$InScope"));
}
function $isArrayOf_Lfs2_Pull$InScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$InScope)));
}
function $asArrayOf_Lfs2_Pull$InScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$InScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$InScope;", depth));
}
var $d_Lfs2_Pull$InScope = new $TypeData().initClass($c_Lfs2_Pull$InScope, "fs2.Pull$InScope", ({
  Lfs2_Pull$InScope: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Interrupted(context, deferredError) {
  this.Lfs2_Pull$Interrupted__f_context = null;
  this.Lfs2_Pull$Interrupted__f_deferredError = null;
  this.Lfs2_Pull$Interrupted__f_context = context;
  this.Lfs2_Pull$Interrupted__f_deferredError = deferredError;
}
$c_Lfs2_Pull$Interrupted.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Interrupted.prototype.constructor = $c_Lfs2_Pull$Interrupted;
/** @constructor */
function $h_Lfs2_Pull$Interrupted() {
}
$h_Lfs2_Pull$Interrupted.prototype = $c_Lfs2_Pull$Interrupted.prototype;
$c_Lfs2_Pull$Interrupted.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Interrupted.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$Interrupted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Interrupted)) {
    var x$0$2 = $as_Lfs2_Pull$Interrupted(x$0);
    var x = this.Lfs2_Pull$Interrupted__f_context;
    var x$2 = $n(x$0$2).Lfs2_Pull$Interrupted__f_context;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lfs2_Pull$Interrupted__f_deferredError;
      var x$4 = $n(x$0$2).Lfs2_Pull$Interrupted__f_deferredError;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Interrupted.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Interrupted.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$Interrupted.prototype.productPrefix__T = (function() {
  return "Interrupted";
});
$c_Lfs2_Pull$Interrupted.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Interrupted__f_context;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$Interrupted__f_deferredError;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Interrupted(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Interrupted) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Interrupted"));
}
function $isArrayOf_Lfs2_Pull$Interrupted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Interrupted)));
}
function $asArrayOf_Lfs2_Pull$Interrupted(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Interrupted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Interrupted;", depth));
}
var $d_Lfs2_Pull$Interrupted = new $TypeData().initClass($c_Lfs2_Pull$Interrupted, "fs2.Pull$Interrupted", ({
  Lfs2_Pull$Interrupted: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Output(values) {
  this.Lfs2_Pull$Output__f_values = null;
  this.Lfs2_Pull$Output__f_values = values;
}
$c_Lfs2_Pull$Output.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Output.prototype.constructor = $c_Lfs2_Pull$Output;
/** @constructor */
function $h_Lfs2_Pull$Output() {
}
$h_Lfs2_Pull$Output.prototype = $c_Lfs2_Pull$Output.prototype;
$c_Lfs2_Pull$Output.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Output.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$Output.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Output)) {
    var x$0$2 = $as_Lfs2_Pull$Output(x$0);
    var x = this.Lfs2_Pull$Output__f_values;
    var x$2 = $n(x$0$2).Lfs2_Pull$Output__f_values;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Output.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Output.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Output.prototype.productPrefix__T = (function() {
  return "Output";
});
$c_Lfs2_Pull$Output.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Output__f_values;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Output(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Output) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Output"));
}
function $isArrayOf_Lfs2_Pull$Output(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Output)));
}
function $asArrayOf_Lfs2_Pull$Output(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Output(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Output;", depth));
}
var $d_Lfs2_Pull$Output = new $TypeData().initClass($c_Lfs2_Pull$Output, "fs2.Pull$Output", ({
  Lfs2_Pull$Output: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lfs2_Pull$StepLeg(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$StepLeg"));
}
function $isArrayOf_Lfs2_Pull$StepLeg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$StepLeg)));
}
function $asArrayOf_Lfs2_Pull$StepLeg(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$StepLeg(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$StepLeg;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$Succeeded(r) {
  this.Lfs2_Pull$Succeeded__f_r = null;
  this.Lfs2_Pull$Succeeded__f_r = r;
}
$c_Lfs2_Pull$Succeeded.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Succeeded.prototype.constructor = $c_Lfs2_Pull$Succeeded;
/** @constructor */
function $h_Lfs2_Pull$Succeeded() {
}
$h_Lfs2_Pull$Succeeded.prototype = $c_Lfs2_Pull$Succeeded.prototype;
$c_Lfs2_Pull$Succeeded.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Succeeded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$Succeeded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$0$2 = $as_Lfs2_Pull$Succeeded(x$0);
    var x = this.Lfs2_Pull$Succeeded__f_r;
    var y = $n(x$0$2).Lfs2_Pull$Succeeded__f_r;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Succeeded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Succeeded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Succeeded.prototype.productPrefix__T = (function() {
  return "Succeeded";
});
$c_Lfs2_Pull$Succeeded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Succeeded__f_r;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Succeeded(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Succeeded) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Succeeded"));
}
function $isArrayOf_Lfs2_Pull$Succeeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Succeeded)));
}
function $asArrayOf_Lfs2_Pull$Succeeded(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Succeeded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Succeeded;", depth));
}
var $d_Lfs2_Pull$Succeeded = new $TypeData().initClass($c_Lfs2_Pull$Succeeded, "fs2.Pull$Succeeded", ({
  Lfs2_Pull$Succeeded: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Translate(stream, fk) {
  this.Lfs2_Pull$Translate__f_stream = null;
  this.Lfs2_Pull$Translate__f_fk = null;
  this.Lfs2_Pull$Translate__f_stream = stream;
  this.Lfs2_Pull$Translate__f_fk = fk;
}
$c_Lfs2_Pull$Translate.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Translate.prototype.constructor = $c_Lfs2_Pull$Translate;
/** @constructor */
function $h_Lfs2_Pull$Translate() {
}
$h_Lfs2_Pull$Translate.prototype = $c_Lfs2_Pull$Translate.prototype;
$c_Lfs2_Pull$Translate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Translate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$Translate.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Translate)) {
    var x$0$2 = $as_Lfs2_Pull$Translate(x$0);
    var x = this.Lfs2_Pull$Translate__f_stream;
    var x$2 = $n(x$0$2).Lfs2_Pull$Translate__f_stream;
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_Pull$Translate__f_fk;
      var x$4 = $n(x$0$2).Lfs2_Pull$Translate__f_fk;
      if ((x$3 === null)) {
        return (x$4 === null);
      } else {
        var this$1 = $n(x$3);
        return (this$1 === x$4);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Translate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Translate.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$Translate.prototype.productPrefix__T = (function() {
  return "Translate";
});
$c_Lfs2_Pull$Translate.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Translate__f_stream;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$Translate__f_fk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Translate(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Translate) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Translate"));
}
function $isArrayOf_Lfs2_Pull$Translate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Translate)));
}
function $asArrayOf_Lfs2_Pull$Translate(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Translate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Translate;", depth));
}
var $d_Lfs2_Pull$Translate = new $TypeData().initClass($c_Lfs2_Pull$Translate, "fs2.Pull$Translate", ({
  Lfs2_Pull$Translate: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$Uncons(stream) {
  this.Lfs2_Pull$Uncons__f_stream = null;
  this.Lfs2_Pull$Uncons__f_stream = stream;
}
$c_Lfs2_Pull$Uncons.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Uncons.prototype.constructor = $c_Lfs2_Pull$Uncons;
/** @constructor */
function $h_Lfs2_Pull$Uncons() {
}
$h_Lfs2_Pull$Uncons.prototype = $c_Lfs2_Pull$Uncons.prototype;
$c_Lfs2_Pull$Uncons.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Uncons.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$Uncons.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Uncons)) {
    var x$0$2 = $as_Lfs2_Pull$Uncons(x$0);
    var x = this.Lfs2_Pull$Uncons__f_stream;
    var x$2 = $n(x$0$2).Lfs2_Pull$Uncons__f_stream;
    return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Uncons.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Uncons.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Uncons.prototype.productPrefix__T = (function() {
  return "Uncons";
});
$c_Lfs2_Pull$Uncons.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Uncons__f_stream;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Uncons(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Uncons) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Uncons"));
}
function $isArrayOf_Lfs2_Pull$Uncons(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Uncons)));
}
function $asArrayOf_Lfs2_Pull$Uncons(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Uncons(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Uncons;", depth));
}
var $d_Lfs2_Pull$Uncons = new $TypeData().initClass($c_Lfs2_Pull$Uncons, "fs2.Pull$Uncons", ({
  Lfs2_Pull$Uncons: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
class $c_Lio_circe_ParsingFailure extends $c_Lio_circe_Error {
  constructor(message, underlying) {
    super();
    this.Lio_circe_ParsingFailure__f_message = null;
    this.Lio_circe_ParsingFailure__f_underlying = null;
    this.Lio_circe_ParsingFailure__f_message = message;
    this.Lio_circe_ParsingFailure__f_underlying = underlying;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1253560490, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lio_circe_ParsingFailure)) {
      var x$0$2 = $as_Lio_circe_ParsingFailure(x$0);
      if ((this.Lio_circe_ParsingFailure__f_message === $n(x$0$2).Lio_circe_ParsingFailure__f_message)) {
        var x = this.Lio_circe_ParsingFailure__f_underlying;
        var x$2 = $n(x$0$2).Lio_circe_ParsingFailure__f_underlying;
        return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "ParsingFailure";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lio_circe_ParsingFailure__f_message;
    }
    if ((n === 1)) {
      return this.Lio_circe_ParsingFailure__f_underlying;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  getMessage__T() {
    return this.Lio_circe_ParsingFailure__f_message;
  }
  toString__T() {
    return ("ParsingFailure: " + this.Lio_circe_ParsingFailure__f_message);
  }
}
function $as_Lio_circe_ParsingFailure(obj) {
  return (((obj instanceof $c_Lio_circe_ParsingFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "io.circe.ParsingFailure"));
}
function $isArrayOf_Lio_circe_ParsingFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_ParsingFailure)));
}
function $asArrayOf_Lio_circe_ParsingFailure(obj, depth) {
  return (($isArrayOf_Lio_circe_ParsingFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.circe.ParsingFailure;", depth));
}
var $d_Lio_circe_ParsingFailure = new $TypeData().initClass($c_Lio_circe_ParsingFailure, "io.circe.ParsingFailure", ({
  Lio_circe_ParsingFailure: 1,
  Lio_circe_Error: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  return $thiz;
}
/** @constructor */
function $c_Ljava_io_PrintStream() {
}
$c_Ljava_io_PrintStream.prototype = new $h_Ljava_io_FilterOutputStream();
$c_Ljava_io_PrintStream.prototype.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
}
$h_Ljava_io_PrintStream.prototype = $c_Ljava_io_PrintStream.prototype;
$c_Ljava_io_PrintStream.prototype.println__T__V = (function(s) {
  this.print__T__V(s);
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V("\n");
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__Ljava_io_PrintStream = (function(csq) {
  this.print__T__V(((csq === null) ? "null" : $dp_toString__T($n(csq))));
  return this;
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__I__I__Ljava_io_PrintStream = (function(csq, start, end) {
  var csq1 = ((csq === null) ? "null" : csq);
  this.print__T__V($dp_toString__T($n($dp_subSequence__I__I__jl_CharSequence($n(csq1), start, end))));
  return this;
});
$c_Ljava_io_PrintStream.prototype.append__C__Ljava_io_PrintStream = (function(c) {
  this.print__C__V(c);
  return this;
});
$c_Ljava_io_PrintStream.prototype.append__C__jl_Appendable = (function(c) {
  return this.append__C__Ljava_io_PrintStream(c);
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__Ljava_io_PrintStream(csq, start, end);
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  return this.append__jl_CharSequence__Ljava_io_PrintStream(csq);
});
function $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J($thiz, end) {
  var a_$_lo = $n(end).Ljava_time_Instant__f_seconds_$lo;
  var a_$_hi = $n(end).Ljava_time_Instant__f_seconds_$hi;
  var b_$_lo = $thiz.Ljava_time_Instant__f_seconds_$lo;
  var b_$_hi = $thiz.Ljava_time_Instant__f_seconds_$hi;
  var this$1 = $m_jl_Math$();
  var lo = ((a_$_lo - b_$_lo) | 0);
  var hi = ((((a_$_hi - b_$_hi) | 0) + ((((~a_$_lo) & b_$_lo) | ((~(a_$_lo ^ b_$_lo)) & lo)) >> 31)) | 0);
  var hi$1 = (a_$_hi ^ b_$_hi);
  var hi$2 = (hi ^ a_$_hi);
  var hi$3 = (hi$1 & hi$2);
  if ((hi$3 < 0)) {
    this$1.java$lang$Math$$longOverflow__E();
  }
  var this$7 = $m_jl_Math$();
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(51712, b0);
  var a1b0 = Math.imul(15258, b0);
  var a0b1 = Math.imul(51712, b1);
  var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((Math.imul(1000000000, hi) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  if (((lo | hi) !== 0)) {
    var $x_2 = $m_RTLong$().divide__I__I__I__I__J(lo$4, hi$4, lo, hi);
    var x_$_lo = $x_2.l;
    var x_$_hi = $x_2.h;
    var $x_1 = (((1000000000 ^ x_$_lo) | x_$_hi) !== 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    this$7.java$lang$Math$$longOverflow__E();
  }
  var value = $n(end).Ljava_time_Instant__f_nanos;
  var hi$5 = (value >> 31);
  var value$1 = $thiz.Ljava_time_Instant__f_nanos;
  var hi$6 = (value$1 >> 31);
  var lo$5 = ((value - value$1) | 0);
  var hi$7 = ((((hi$5 - hi$6) | 0) + ((((~value) & value$1) | ((~(value ^ value$1)) & lo$5)) >> 31)) | 0);
  var this$15 = $m_jl_Math$();
  var lo$6 = ((lo$4 + lo$5) | 0);
  var hi$8 = ((((hi$4 + hi$7) | 0) + ((((lo$4 & lo$5) | ((lo$4 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 ^ hi$4);
  var hi$10 = (hi$8 ^ hi$7);
  var hi$11 = (hi$9 & hi$10);
  if ((hi$11 < 0)) {
    this$15.java$lang$Math$$longOverflow__E();
  }
  return $bL(lo$6, hi$8);
}
function $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J($thiz, end) {
  var a_$_lo = $n(end).Ljava_time_Instant__f_seconds_$lo;
  var a_$_hi = $n(end).Ljava_time_Instant__f_seconds_$hi;
  var b_$_lo = $thiz.Ljava_time_Instant__f_seconds_$lo;
  var b_$_hi = $thiz.Ljava_time_Instant__f_seconds_$hi;
  var this$1 = $m_jl_Math$();
  var lo = ((a_$_lo - b_$_lo) | 0);
  var hi = ((((a_$_hi - b_$_hi) | 0) + ((((~a_$_lo) & b_$_lo) | ((~(a_$_lo ^ b_$_lo)) & lo)) >> 31)) | 0);
  var hi$1 = (a_$_hi ^ b_$_hi);
  var hi$2 = (hi ^ a_$_hi);
  var hi$3 = (hi$1 & hi$2);
  if ((hi$3 < 0)) {
    this$1.java$lang$Math$$longOverflow__E();
  }
  var value = $n(end).Ljava_time_Instant__f_nanos;
  var hi$4 = (value >> 31);
  var value$1 = $thiz.Ljava_time_Instant__f_nanos;
  var hi$5 = (value$1 >> 31);
  var lo$4 = ((value - value$1) | 0);
  var hi$6 = ((((hi$4 - hi$5) | 0) + ((((~value) & value$1) | ((~(value ^ value$1)) & lo$4)) >> 31)) | 0);
  if ((((hi === 0) ? (lo !== 0) : (hi > 0)) && (hi$6 < 0))) {
    var lo$5 = ((lo - 1) | 0);
    var hi$7 = ((((hi - 1) | 0) + (((lo | (~lo$5)) >>> 31) | 0)) | 0);
    return $bL(lo$5, hi$7);
  } else if (((hi < 0) && ((hi$6 === 0) ? (lo$4 !== 0) : (hi$6 > 0)))) {
    var lo$6 = ((1 + lo) | 0);
    var hi$8 = ((hi + (((lo & (~lo$6)) >>> 31) | 0)) | 0);
    return $bL(lo$6, hi$8);
  } else {
    return $bL(lo, hi);
  }
}
/** @constructor */
function $c_Ljava_time_Instant(seconds_$_lo, seconds_$_hi, nanos) {
  this.Ljava_time_Instant__f_seconds_$lo = 0;
  this.Ljava_time_Instant__f_seconds_$hi = 0;
  this.Ljava_time_Instant__f_nanos = 0;
  this.Ljava_time_Instant__f_seconds_$lo = seconds_$_lo;
  this.Ljava_time_Instant__f_seconds_$hi = seconds_$_hi;
  this.Ljava_time_Instant__f_nanos = nanos;
}
$c_Ljava_time_Instant.prototype = new $h_O();
$c_Ljava_time_Instant.prototype.constructor = $c_Ljava_time_Instant;
/** @constructor */
function $h_Ljava_time_Instant() {
}
$h_Ljava_time_Instant.prototype = $c_Ljava_time_Instant.prototype;
$c_Ljava_time_Instant.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return ((((field === $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()));
  } else if ((field !== null)) {
    var this$1 = $n(field);
    return this.isSupported__Ljava_time_temporal_TemporalField__Z(this$1);
  } else {
    return false;
  }
});
$c_Ljava_time_Instant.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$c_Ljava_time_Instant.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === f);
    }
    if ($x_1) {
      return this.Ljava_time_Instant__f_nanos;
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $x_2 = (f === null);
    } else {
      var this$2 = $n(x$3);
      var $x_2 = (this$2 === f);
    }
    if ($x_2) {
      return ((this.Ljava_time_Instant__f_nanos / 1000) | 0);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x$5 === null)) {
      var $x_3 = (f === null);
    } else {
      var this$3 = $n(x$5);
      var $x_3 = (this$3 === f);
    }
    if ($x_3) {
      return ((this.Ljava_time_Instant__f_nanos / 1000000) | 0);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var $x_5 = $n($f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field));
    var this$4 = $n(field);
    var $x_4 = this.getLong__Ljava_time_temporal_TemporalField__J(this$4);
    return $x_5.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($x_4.l, $x_4.h, field);
  }
});
$c_Ljava_time_Instant.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === f);
    }
    if ($x_1) {
      var value = this.Ljava_time_Instant__f_nanos;
      var hi = (value >> 31);
      return $bL(value, hi);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $x_2 = (f === null);
    } else {
      var this$3 = $n(x$3);
      var $x_2 = (this$3 === f);
    }
    if ($x_2) {
      var value$1 = this.Ljava_time_Instant__f_nanos;
      var hi$1 = (value$1 >> 31);
      var hi$2 = (hi$1 >> 31);
      var b0 = (65535 & value$1);
      var b1 = ((value$1 >>> 16) | 0);
      var a0b0 = Math.imul(39845, b0);
      var a1b0 = Math.imul(8388, b0);
      var a0b1 = Math.imul(39845, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$3 = ((((Math.imul(8388, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var b0$1 = (65535 & value$1);
      var b1$1 = ((value$1 >>> 16) | 0);
      var a0b0$1 = Math.imul(63439, b0$1);
      var a1b0$1 = Math.imul(58195, b0$1);
      var a0b1$1 = Math.imul(63439, b1$1);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$4 = ((((Math.imul(58195, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((lo + hi$4) | 0);
      var hi$5 = ((hi$3 + ((((lo & hi$4) | ((lo | hi$4) & (~lo$2))) >>> 31) | 0)) | 0);
      var b0$2 = (65535 & hi$1);
      var b1$2 = ((hi$1 >>> 16) | 0);
      var a0b0$2 = Math.imul(39845, b0$2);
      var a1b0$2 = Math.imul(8388, b0$2);
      var a0b1$2 = Math.imul(39845, b1$2);
      var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$6 = ((((((Math.imul(549755813, hi$2) + Math.imul(8388, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
      var hi$7 = (hi$5 >> 31);
      var lo$4 = ((lo$3 + hi$5) | 0);
      var hi$8 = ((((hi$6 + hi$7) | 0) + ((((lo$3 & hi$5) | ((lo$3 | hi$5) & (~lo$4))) >>> 31) | 0)) | 0);
      var b0$3 = (65535 & hi$1);
      var b1$3 = ((hi$1 >>> 16) | 0);
      var a0b0$3 = Math.imul(63439, b0$3);
      var a1b0$3 = Math.imul(58195, b0$3);
      var a0b1$3 = Math.imul(63439, b1$3);
      var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$9 = ((((((Math.imul((-481036337), hi$2) + Math.imul(58195, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
      var lo$6 = ((lo$2 + lo$5) | 0);
      var hi$10 = ((hi$9 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
      var hi$11 = (hi$10 >> 31);
      var lo$7 = ((lo$4 + hi$10) | 0);
      var hi$12 = ((((hi$8 + hi$11) | 0) + ((((lo$4 & hi$10) | ((lo$4 | hi$10) & (~lo$7))) >>> 31) | 0)) | 0);
      var lo$8 = (((lo$7 >>> 7) | 0) | (hi$12 << 25));
      var hi$13 = (hi$12 >> 7);
      var lo$9 = ((hi$1 >>> 31) | 0);
      var lo$10 = ((lo$8 + lo$9) | 0);
      var hi$14 = ((hi$13 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
      return $bL(lo$10, hi$14);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x$5 === null)) {
      var $x_3 = (f === null);
    } else {
      var this$22 = $n(x$5);
      var $x_3 = (this$22 === f);
    }
    if ($x_3) {
      var value$2 = this.Ljava_time_Instant__f_nanos;
      var hi$15 = (value$2 >> 31);
      var hi$16 = (hi$15 >> 31);
      var b0$4 = (65535 & value$2);
      var b1$4 = ((value$2 >>> 16) | 0);
      var a0b0$4 = Math.imul(56962, b0$4);
      var a1b0$4 = Math.imul(17179, b0$4);
      var a0b1$4 = Math.imul(56962, b1$4);
      var lo$11 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$17 = ((((Math.imul(17179, b1$4) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
      var b0$5 = (65535 & value$2);
      var b1$5 = ((value$2 >>> 16) | 0);
      var a0b0$5 = Math.imul(13531, b0$5);
      var a1b0$5 = Math.imul(55222, b0$5);
      var a0b1$5 = Math.imul(13531, b1$5);
      var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
      var hi$18 = ((((Math.imul(55222, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
      var lo$13 = ((lo$11 + hi$18) | 0);
      var hi$19 = ((hi$17 + ((((lo$11 & hi$18) | ((lo$11 | hi$18) & (~lo$13))) >>> 31) | 0)) | 0);
      var b0$6 = (65535 & hi$15);
      var b1$6 = ((hi$15 >>> 16) | 0);
      var a0b0$6 = Math.imul(56962, b0$6);
      var a1b0$6 = Math.imul(17179, b0$6);
      var a0b1$6 = Math.imul(56962, b1$6);
      var lo$14 = ((a0b0$6 + (((a1b0$6 + a0b1$6) | 0) << 16)) | 0);
      var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
      var hi$20 = ((((((Math.imul(1125899906, hi$16) + Math.imul(17179, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
      var hi$21 = (hi$19 >> 31);
      var lo$15 = ((lo$14 + hi$19) | 0);
      var hi$22 = ((((hi$20 + hi$21) | 0) + ((((lo$14 & hi$19) | ((lo$14 | hi$19) & (~lo$15))) >>> 31) | 0)) | 0);
      var b0$7 = (65535 & hi$15);
      var b1$7 = ((hi$15 >>> 16) | 0);
      var a0b0$7 = Math.imul(13531, b0$7);
      var a1b0$7 = Math.imul(55222, b0$7);
      var a0b1$7 = Math.imul(13531, b1$7);
      var lo$16 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
      var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
      var hi$23 = ((((((Math.imul((-675924773), hi$16) + Math.imul(55222, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
      var lo$17 = ((lo$13 + lo$16) | 0);
      var hi$24 = ((hi$23 + ((((lo$13 & lo$16) | ((lo$13 | lo$16) & (~lo$17))) >>> 31) | 0)) | 0);
      var hi$25 = (hi$24 >> 31);
      var lo$18 = ((lo$15 + hi$24) | 0);
      var hi$26 = ((((hi$22 + hi$25) | 0) + ((((lo$15 & hi$24) | ((lo$15 | hi$24) & (~lo$18))) >>> 31) | 0)) | 0);
      var lo$19 = (((lo$18 >>> 18) | 0) | (hi$26 << 14));
      var hi$27 = (hi$26 >> 18);
      var lo$20 = ((hi$15 >>> 31) | 0);
      var lo$21 = ((lo$19 + lo$20) | 0);
      var hi$28 = ((hi$27 + ((((lo$19 & lo$20) | ((lo$19 | lo$20) & (~lo$21))) >>> 31) | 0)) | 0);
      return $bL(lo$21, hi$28);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x$7 === null)) {
      var $x_4 = (f === null);
    } else {
      var this$41 = $n(x$7);
      var $x_4 = (this$41 === f);
    }
    if ($x_4) {
      return $bL(this.Ljava_time_Instant__f_seconds_$lo, this.Ljava_time_Instant__f_seconds_$hi);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var this$42 = $n(field);
    return this.getLong__Ljava_time_temporal_TemporalField__J(this$42);
  }
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var this$1 = $n(f);
    $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue_$_lo, newValue_$_hi, this$1);
    var x = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$2 = $n(x);
      var $x_1 = (this$2 === f);
    }
    if ($x_1) {
      var nval = Math.imul(1000000, newValue_$_lo);
      return ((nval !== this.Ljava_time_Instant__f_nanos) ? $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds_$lo, this.Ljava_time_Instant__f_seconds_$hi, nval) : this);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $x_2 = (f === null);
    } else {
      var this$4 = $n(x$3);
      var $x_2 = (this$4 === f);
    }
    if ($x_2) {
      var nval$2 = Math.imul(1000, newValue_$_lo);
      return ((nval$2 !== this.Ljava_time_Instant__f_nanos) ? $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds_$lo, this.Ljava_time_Instant__f_seconds_$hi, nval$2) : this);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x$5 === null)) {
      var $x_3 = (f === null);
    } else {
      var this$6 = $n(x$5);
      var $x_3 = (this$6 === f);
    }
    if ($x_3) {
      var value = this.Ljava_time_Instant__f_nanos;
      var hi = (value >> 31);
      if ((((newValue_$_lo ^ value) | (newValue_$_hi ^ hi)) !== 0)) {
        return $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds_$lo, this.Ljava_time_Instant__f_seconds_$hi, newValue_$_lo);
      } else {
        return this;
      }
    }
    var x$7 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x$7 === null)) {
      var $x_4 = (f === null);
    } else {
      var this$10 = $n(x$7);
      var $x_4 = (this$10 === f);
    }
    if ($x_4) {
      var x$1_$_lo = this.Ljava_time_Instant__f_seconds_$lo;
      var x$1_$_hi = this.Ljava_time_Instant__f_seconds_$hi;
      if ((((newValue_$_lo ^ x$1_$_lo) | (newValue_$_hi ^ x$1_$_hi)) !== 0)) {
        return $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(newValue_$_lo, newValue_$_hi, this.Ljava_time_Instant__f_nanos);
      } else {
        return this;
      }
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  }
  var this$12 = $n(field);
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant(this$12, newValue_$_lo, newValue_$_hi);
});
$c_Ljava_time_Instant.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)));
});
$c_Ljava_time_Instant.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var f = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === f);
    }
    if ($x_1) {
      return $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J(this, end);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
    if ((x$3 === null)) {
      var $x_2 = (f === null);
    } else {
      var this$2 = $n(x$3);
      var $x_2 = (this$2 === f);
    }
    if ($x_2) {
      var $x_3 = $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J(this, end);
      var num_$_lo = $x_3.l;
      var num_$_hi = $x_3.h;
      var hi = (num_$_hi >> 31);
      var b0 = (65535 & num_$_lo);
      var b1 = ((num_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(39845, b0);
      var a1b0 = Math.imul(8388, b0);
      var a0b1 = Math.imul(39845, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((((Math.imul(8388, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var b0$1 = (65535 & num_$_lo);
      var b1$1 = ((num_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(63439, b0$1);
      var a1b0$1 = Math.imul(58195, b0$1);
      var a0b1$1 = Math.imul(63439, b1$1);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$2 = ((((Math.imul(58195, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((lo + hi$2) | 0);
      var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
      var b0$2 = (65535 & num_$_hi);
      var b1$2 = ((num_$_hi >>> 16) | 0);
      var a0b0$2 = Math.imul(39845, b0$2);
      var a1b0$2 = Math.imul(8388, b0$2);
      var a0b1$2 = Math.imul(39845, b1$2);
      var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$4 = ((((((Math.imul(549755813, hi) + Math.imul(8388, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
      var hi$5 = (hi$3 >> 31);
      var lo$4 = ((lo$3 + hi$3) | 0);
      var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
      var b0$3 = (65535 & num_$_hi);
      var b1$3 = ((num_$_hi >>> 16) | 0);
      var a0b0$3 = Math.imul(63439, b0$3);
      var a1b0$3 = Math.imul(58195, b0$3);
      var a0b1$3 = Math.imul(63439, b1$3);
      var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$7 = ((((((Math.imul((-481036337), hi) + Math.imul(58195, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
      var lo$6 = ((lo$2 + lo$5) | 0);
      var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
      var hi$9 = (hi$8 >> 31);
      var lo$7 = ((lo$4 + hi$8) | 0);
      var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
      var lo$8 = (((lo$7 >>> 7) | 0) | (hi$10 << 25));
      var hi$11 = (hi$10 >> 7);
      var lo$9 = ((num_$_hi >>> 31) | 0);
      var lo$10 = ((lo$8 + lo$9) | 0);
      var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
      return $bL(lo$10, hi$12);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
    if ((x$5 === null)) {
      var $x_4 = (f === null);
    } else {
      var this$20 = $n(x$5);
      var $x_4 = (this$20 === f);
    }
    if ($x_4) {
      var $x_5 = $n(end).toEpochMilli__J();
      var a_$_lo = $x_5.l;
      var a_$_hi = $x_5.h;
      var $x_6 = this.toEpochMilli__J();
      var b_$_lo = $x_6.l;
      var b_$_hi = $x_6.h;
      var this$21 = $m_jl_Math$();
      var lo$11 = ((a_$_lo - b_$_lo) | 0);
      var hi$13 = ((((a_$_hi - b_$_hi) | 0) + ((((~a_$_lo) & b_$_lo) | ((~(a_$_lo ^ b_$_lo)) & lo$11)) >> 31)) | 0);
      var hi$14 = (a_$_hi ^ b_$_hi);
      var hi$15 = (hi$13 ^ a_$_hi);
      var hi$16 = (hi$14 & hi$15);
      if ((hi$16 < 0)) {
        this$21.java$lang$Math$$longOverflow__E();
      }
      return $bL(lo$11, hi$13);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
    if ((x$7 === null)) {
      var $x_7 = (f === null);
    } else {
      var this$27 = $n(x$7);
      var $x_7 = (this$27 === f);
    }
    if ($x_7) {
      return $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
    if ((x$9 === null)) {
      var $x_8 = (f === null);
    } else {
      var this$28 = $n(x$9);
      var $x_8 = (this$28 === f);
    }
    if ($x_8) {
      var $x_9 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
      var num$1_$_lo = $x_9.l;
      var num$1_$_hi = $x_9.h;
      var hi$17 = (num$1_$_hi >> 31);
      var b0$4 = (65535 & num$1_$_lo);
      var b1$4 = ((num$1_$_lo >>> 16) | 0);
      var a0b0$4 = Math.imul(34952, b0$4);
      var a1b0$4 = Math.imul(34952, b0$4);
      var a0b1$4 = Math.imul(34952, b1$4);
      var lo$15 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$18 = ((((((((-num$1_$_lo) | 0) + Math.imul(34952, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
      var b0$5 = (65535 & num$1_$_lo);
      var b1$5 = ((num$1_$_lo >>> 16) | 0);
      var a0b0$5 = Math.imul(34953, b0$5);
      var a1b0$5 = Math.imul(34952, b0$5);
      var a0b1$5 = Math.imul(34953, b1$5);
      var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
      var hi$19 = ((((Math.imul(34952, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
      var lo$17 = ((lo$15 + hi$19) | 0);
      var hi$20 = ((hi$18 + ((((lo$15 & hi$19) | ((lo$15 | hi$19) & (~lo$17))) >>> 31) | 0)) | 0);
      var b0$6 = (65535 & num$1_$_hi);
      var b1$6 = ((num$1_$_hi >>> 16) | 0);
      var a0b0$6 = Math.imul(34952, b0$6);
      var a1b0$6 = Math.imul(34952, b0$6);
      var a0b1$6 = Math.imul(34952, b1$6);
      var lo$18 = ((a0b0$6 + (((a1b0$6 + a0b1$6) | 0) << 16)) | 0);
      var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
      var hi$21 = ((((((((Math.imul((-2004318072), hi$17) + ((-num$1_$_hi) | 0)) | 0) + Math.imul(34952, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
      var hi$22 = (hi$20 >> 31);
      var lo$19 = ((lo$18 + hi$20) | 0);
      var hi$23 = ((((hi$21 + hi$22) | 0) + ((((lo$18 & hi$20) | ((lo$18 | hi$20) & (~lo$19))) >>> 31) | 0)) | 0);
      var b0$7 = (65535 & num$1_$_hi);
      var b1$7 = ((num$1_$_hi >>> 16) | 0);
      var a0b0$7 = Math.imul(34953, b0$7);
      var a1b0$7 = Math.imul(34952, b0$7);
      var a0b1$7 = Math.imul(34953, b1$7);
      var lo$20 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
      var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
      var hi$24 = ((((((Math.imul((-2004318071), hi$17) + Math.imul(34952, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
      var lo$21 = ((lo$17 + lo$20) | 0);
      var hi$25 = ((hi$24 + ((((lo$17 & lo$20) | ((lo$17 | lo$20) & (~lo$21))) >>> 31) | 0)) | 0);
      var hi$26 = (hi$25 >> 31);
      var lo$22 = ((lo$19 + hi$25) | 0);
      var hi$27 = ((((hi$23 + hi$26) | 0) + ((((lo$19 & hi$25) | ((lo$19 | hi$25) & (~lo$22))) >>> 31) | 0)) | 0);
      var lo$23 = ((lo$22 + num$1_$_lo) | 0);
      var hi$28 = ((((hi$27 + num$1_$_hi) | 0) + ((((lo$22 & num$1_$_lo) | ((lo$22 | num$1_$_lo) & (~lo$23))) >>> 31) | 0)) | 0);
      var lo$24 = (((lo$23 >>> 5) | 0) | (hi$28 << 27));
      var hi$29 = (hi$28 >> 5);
      var lo$25 = ((num$1_$_hi >>> 31) | 0);
      var lo$26 = ((lo$24 + lo$25) | 0);
      var hi$30 = ((hi$29 + ((((lo$24 & lo$25) | ((lo$24 | lo$25) & (~lo$26))) >>> 31) | 0)) | 0);
      return $bL(lo$26, hi$30);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
    if ((x$11 === null)) {
      var $x_10 = (f === null);
    } else {
      var this$47 = $n(x$11);
      var $x_10 = (this$47 === f);
    }
    if ($x_10) {
      var $x_11 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
      var num$2_$_lo = $x_11.l;
      var num$2_$_hi = $x_11.h;
      var hi$31 = (num$2_$_hi >> 31);
      var b0$8 = (65535 & num$2_$_lo);
      var b1$8 = ((num$2_$_lo >>> 16) | 0);
      var a0b0$8 = Math.imul(23010, b0$8);
      var a1b0$8 = Math.imul(18641, b0$8);
      var a0b1$8 = Math.imul(23010, b1$8);
      var lo$27 = ((a0b0$8 + (((a1b0$8 + a0b1$8) | 0) << 16)) | 0);
      var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
      var hi$32 = ((((Math.imul(18641, b1$8) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$8) | 0) >>> 16) | 0)) | 0);
      var b0$9 = (65535 & num$2_$_lo);
      var b1$9 = ((num$2_$_lo >>> 16) | 0);
      var a0b0$9 = Math.imul(31749, b0$9);
      var a1b0$9 = Math.imul(27379, b0$9);
      var a0b1$9 = Math.imul(31749, b1$9);
      var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
      var hi$33 = ((((Math.imul(27379, b1$9) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$9) | 0) >>> 16) | 0)) | 0);
      var lo$29 = ((lo$27 + hi$33) | 0);
      var hi$34 = ((hi$32 + ((((lo$27 & hi$33) | ((lo$27 | hi$33) & (~lo$29))) >>> 31) | 0)) | 0);
      var b0$10 = (65535 & num$2_$_hi);
      var b1$10 = ((num$2_$_hi >>> 16) | 0);
      var a0b0$10 = Math.imul(23010, b0$10);
      var a1b0$10 = Math.imul(18641, b0$10);
      var a0b1$10 = Math.imul(23010, b1$10);
      var lo$30 = ((a0b0$10 + (((a1b0$10 + a0b1$10) | 0) << 16)) | 0);
      var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
      var hi$35 = ((((((Math.imul(1221679586, hi$31) + Math.imul(18641, b1$10)) | 0) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$10) | 0) >>> 16) | 0)) | 0);
      var hi$36 = (hi$34 >> 31);
      var lo$31 = ((lo$30 + hi$34) | 0);
      var hi$37 = ((((hi$35 + hi$36) | 0) + ((((lo$30 & hi$34) | ((lo$30 | hi$34) & (~lo$31))) >>> 31) | 0)) | 0);
      var b0$11 = (65535 & num$2_$_hi);
      var b1$11 = ((num$2_$_hi >>> 16) | 0);
      var a0b0$11 = Math.imul(31749, b0$11);
      var a1b0$11 = Math.imul(27379, b0$11);
      var a0b1$11 = Math.imul(31749, b1$11);
      var lo$32 = ((a0b0$11 + (((a1b0$11 + a0b1$11) | 0) << 16)) | 0);
      var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
      var hi$38 = ((((((Math.imul(1794341893, hi$31) + Math.imul(27379, b1$11)) | 0) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$11) | 0) >>> 16) | 0)) | 0);
      var lo$33 = ((lo$29 + lo$32) | 0);
      var hi$39 = ((hi$38 + ((((lo$29 & lo$32) | ((lo$29 | lo$32) & (~lo$33))) >>> 31) | 0)) | 0);
      var hi$40 = (hi$39 >> 31);
      var lo$34 = ((lo$31 + hi$39) | 0);
      var hi$41 = ((((hi$37 + hi$40) | 0) + ((((lo$31 & hi$39) | ((lo$31 | hi$39) & (~lo$34))) >>> 31) | 0)) | 0);
      var lo$35 = (((lo$34 >>> 10) | 0) | (hi$41 << 22));
      var hi$42 = (hi$41 >> 10);
      var lo$36 = ((num$2_$_hi >>> 31) | 0);
      var lo$37 = ((lo$35 + lo$36) | 0);
      var hi$43 = ((hi$42 + ((((lo$35 & lo$36) | ((lo$35 | lo$36) & (~lo$37))) >>> 31) | 0)) | 0);
      return $bL(lo$37, hi$43);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
    if ((x$13 === null)) {
      var $x_12 = (f === null);
    } else {
      var this$65 = $n(x$13);
      var $x_12 = (this$65 === f);
    }
    if ($x_12) {
      var $x_13 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
      var num$3_$_lo = $x_13.l;
      var num$3_$_hi = $x_13.h;
      var hi$44 = (num$3_$_hi >> 31);
      var b0$12 = (65535 & num$3_$_lo);
      var b1$12 = ((num$3_$_lo >>> 16) | 0);
      var a0b0$12 = Math.imul(51360, b0$12);
      var a1b0$12 = Math.imul(6213, b0$12);
      var a0b1$12 = Math.imul(51360, b1$12);
      var lo$38 = ((a0b0$12 + (((a1b0$12 + a0b1$12) | 0) << 16)) | 0);
      var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
      var hi$45 = ((((Math.imul(6213, b1$12) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$12) | 0) >>> 16) | 0)) | 0);
      var b0$13 = (65535 & num$3_$_lo);
      var b1$13 = ((num$3_$_lo >>> 16) | 0);
      var a0b0$13 = Math.imul(10583, b0$13);
      var a1b0$13 = Math.imul(52817, b0$13);
      var a0b1$13 = Math.imul(10583, b1$13);
      var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
      var hi$46 = ((((Math.imul(52817, b1$13) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$13) | 0) >>> 16) | 0)) | 0);
      var lo$40 = ((lo$38 + hi$46) | 0);
      var hi$47 = ((hi$45 + ((((lo$38 & hi$46) | ((lo$38 | hi$46) & (~lo$40))) >>> 31) | 0)) | 0);
      var b0$14 = (65535 & num$3_$_hi);
      var b1$14 = ((num$3_$_hi >>> 16) | 0);
      var a0b0$14 = Math.imul(51360, b0$14);
      var a1b0$14 = Math.imul(6213, b0$14);
      var a0b1$14 = Math.imul(51360, b1$14);
      var lo$41 = ((a0b0$14 + (((a1b0$14 + a0b1$14) | 0) << 16)) | 0);
      var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
      var hi$48 = ((((((Math.imul(407226528, hi$44) + Math.imul(6213, b1$14)) | 0) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$14) | 0) >>> 16) | 0)) | 0);
      var hi$49 = (hi$47 >> 31);
      var lo$42 = ((lo$41 + hi$47) | 0);
      var hi$50 = ((((hi$48 + hi$49) | 0) + ((((lo$41 & hi$47) | ((lo$41 | hi$47) & (~lo$42))) >>> 31) | 0)) | 0);
      var b0$15 = (65535 & num$3_$_hi);
      var b1$15 = ((num$3_$_hi >>> 16) | 0);
      var a0b0$15 = Math.imul(10583, b0$15);
      var a1b0$15 = Math.imul(52817, b0$15);
      var a0b1$15 = Math.imul(10583, b1$15);
      var lo$43 = ((a0b0$15 + (((a1b0$15 + a0b1$15) | 0) << 16)) | 0);
      var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
      var hi$51 = ((((((Math.imul((-833541801), hi$44) + Math.imul(52817, b1$15)) | 0) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$15) | 0) >>> 16) | 0)) | 0);
      var lo$44 = ((lo$40 + lo$43) | 0);
      var hi$52 = ((hi$51 + ((((lo$40 & lo$43) | ((lo$40 | lo$43) & (~lo$44))) >>> 31) | 0)) | 0);
      var hi$53 = (hi$52 >> 31);
      var lo$45 = ((lo$42 + hi$52) | 0);
      var hi$54 = ((((hi$50 + hi$53) | 0) + ((((lo$42 & hi$52) | ((lo$42 | hi$52) & (~lo$45))) >>> 31) | 0)) | 0);
      var lo$46 = (((lo$45 >>> 12) | 0) | (hi$54 << 20));
      var hi$55 = (hi$54 >> 12);
      var lo$47 = ((num$3_$_hi >>> 31) | 0);
      var lo$48 = ((lo$46 + lo$47) | 0);
      var hi$56 = ((hi$55 + ((((lo$46 & lo$47) | ((lo$46 | lo$47) & (~lo$48))) >>> 31) | 0)) | 0);
      return $bL(lo$48, hi$56);
    }
    var x$15 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if ((x$15 === null)) {
      var $x_14 = (f === null);
    } else {
      var this$83 = $n(x$15);
      var $x_14 = (this$83 === f);
    }
    if ($x_14) {
      var $x_15 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
      var num$4_$_lo = $x_15.l;
      var num$4_$_hi = $x_15.h;
      var hi$57 = (num$4_$_hi >> 31);
      var b0$16 = (65535 & num$4_$_lo);
      var b1$16 = ((num$4_$_lo >>> 16) | 0);
      var a0b0$16 = Math.imul(51360, b0$16);
      var a1b0$16 = Math.imul(6213, b0$16);
      var a0b1$16 = Math.imul(51360, b1$16);
      var lo$49 = ((a0b0$16 + (((a1b0$16 + a0b1$16) | 0) << 16)) | 0);
      var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
      var hi$58 = ((((Math.imul(6213, b1$16) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$16) | 0) >>> 16) | 0)) | 0);
      var b0$17 = (65535 & num$4_$_lo);
      var b1$17 = ((num$4_$_lo >>> 16) | 0);
      var a0b0$17 = Math.imul(10583, b0$17);
      var a1b0$17 = Math.imul(52817, b0$17);
      var a0b1$17 = Math.imul(10583, b1$17);
      var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
      var hi$59 = ((((Math.imul(52817, b1$17) + ((c1part$17 >>> 16) | 0)) | 0) + (((((65535 & c1part$17) + a1b0$17) | 0) >>> 16) | 0)) | 0);
      var lo$51 = ((lo$49 + hi$59) | 0);
      var hi$60 = ((hi$58 + ((((lo$49 & hi$59) | ((lo$49 | hi$59) & (~lo$51))) >>> 31) | 0)) | 0);
      var b0$18 = (65535 & num$4_$_hi);
      var b1$18 = ((num$4_$_hi >>> 16) | 0);
      var a0b0$18 = Math.imul(51360, b0$18);
      var a1b0$18 = Math.imul(6213, b0$18);
      var a0b1$18 = Math.imul(51360, b1$18);
      var lo$52 = ((a0b0$18 + (((a1b0$18 + a0b1$18) | 0) << 16)) | 0);
      var c1part$18 = ((((a0b0$18 >>> 16) | 0) + a0b1$18) | 0);
      var hi$61 = ((((((Math.imul(407226528, hi$57) + Math.imul(6213, b1$18)) | 0) + ((c1part$18 >>> 16) | 0)) | 0) + (((((65535 & c1part$18) + a1b0$18) | 0) >>> 16) | 0)) | 0);
      var hi$62 = (hi$60 >> 31);
      var lo$53 = ((lo$52 + hi$60) | 0);
      var hi$63 = ((((hi$61 + hi$62) | 0) + ((((lo$52 & hi$60) | ((lo$52 | hi$60) & (~lo$53))) >>> 31) | 0)) | 0);
      var b0$19 = (65535 & num$4_$_hi);
      var b1$19 = ((num$4_$_hi >>> 16) | 0);
      var a0b0$19 = Math.imul(10583, b0$19);
      var a1b0$19 = Math.imul(52817, b0$19);
      var a0b1$19 = Math.imul(10583, b1$19);
      var lo$54 = ((a0b0$19 + (((a1b0$19 + a0b1$19) | 0) << 16)) | 0);
      var c1part$19 = ((((a0b0$19 >>> 16) | 0) + a0b1$19) | 0);
      var hi$64 = ((((((Math.imul((-833541801), hi$57) + Math.imul(52817, b1$19)) | 0) + ((c1part$19 >>> 16) | 0)) | 0) + (((((65535 & c1part$19) + a1b0$19) | 0) >>> 16) | 0)) | 0);
      var lo$55 = ((lo$51 + lo$54) | 0);
      var hi$65 = ((hi$64 + ((((lo$51 & lo$54) | ((lo$51 | lo$54) & (~lo$55))) >>> 31) | 0)) | 0);
      var hi$66 = (hi$65 >> 31);
      var lo$56 = ((lo$53 + hi$65) | 0);
      var hi$67 = ((((hi$63 + hi$66) | 0) + ((((lo$53 & hi$65) | ((lo$53 | hi$65) & (~lo$56))) >>> 31) | 0)) | 0);
      var lo$57 = (((lo$56 >>> 13) | 0) | (hi$67 << 19));
      var hi$68 = (hi$67 >> 13);
      var lo$58 = ((num$4_$_hi >>> 31) | 0);
      var lo$59 = ((lo$57 + lo$58) | 0);
      var hi$69 = ((hi$68 + ((((lo$57 & lo$58) | ((lo$57 | lo$58) & (~lo$59))) >>> 31) | 0)) | 0);
      return $bL(lo$59, hi$69);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  }
  var this$101 = $n(unit);
  return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end, this$101);
});
$c_Ljava_time_Instant.prototype.toEpochMilli__J = (function() {
  var x_$_lo = this.Ljava_time_Instant__f_seconds_$lo;
  var x_$_hi = this.Ljava_time_Instant__f_seconds_$hi;
  if ((x_$_hi >= 0)) {
    var a_$_lo = this.Ljava_time_Instant__f_seconds_$lo;
    var a_$_hi = this.Ljava_time_Instant__f_seconds_$hi;
    var this$2 = $m_jl_Math$();
    var b0 = (65535 & a_$_lo);
    var b1 = ((a_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(1000, b0);
    var a0b1 = Math.imul(1000, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((Math.imul(1000, a_$_hi) + ((c1part >>> 16) | 0)) | 0);
    if (((a_$_lo | a_$_hi) !== 0)) {
      var $x_2 = $m_RTLong$().divide__I__I__I__I__J(lo, hi, a_$_lo, a_$_hi);
      var x$1_$_lo = $x_2.l;
      var x$1_$_hi = $x_2.h;
      var $x_1 = (((1000 ^ x$1_$_lo) | x$1_$_hi) !== 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this$2.java$lang$Math$$longOverflow__E();
    }
    var value = this.Ljava_time_Instant__f_nanos;
    var hi$1 = (value >> 31);
    var hi$2 = (hi$1 >> 31);
    var b0$1 = (65535 & value);
    var b1$1 = ((value >>> 16) | 0);
    var a0b0$1 = Math.imul(56962, b0$1);
    var a1b0 = Math.imul(17179, b0$1);
    var a0b1$1 = Math.imul(56962, b1$1);
    var lo$1 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$3 = ((((Math.imul(17179, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
    var b0$2 = (65535 & value);
    var b1$2 = ((value >>> 16) | 0);
    var a0b0$2 = Math.imul(13531, b0$2);
    var a1b0$1 = Math.imul(55222, b0$2);
    var a0b1$2 = Math.imul(13531, b1$2);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$4 = ((((Math.imul(55222, b1$2) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$3 = ((lo$1 + hi$4) | 0);
    var hi$5 = ((hi$3 + ((((lo$1 & hi$4) | ((lo$1 | hi$4) & (~lo$3))) >>> 31) | 0)) | 0);
    var b0$3 = (65535 & hi$1);
    var b1$3 = ((hi$1 >>> 16) | 0);
    var a0b0$3 = Math.imul(56962, b0$3);
    var a1b0$2 = Math.imul(17179, b0$3);
    var a0b1$3 = Math.imul(56962, b1$3);
    var lo$4 = ((a0b0$3 + (((a1b0$2 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$6 = ((((((Math.imul(1125899906, hi$2) + Math.imul(17179, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$2) | 0) >>> 16) | 0)) | 0);
    var hi$7 = (hi$5 >> 31);
    var lo$5 = ((lo$4 + hi$5) | 0);
    var hi$8 = ((((hi$6 + hi$7) | 0) + ((((lo$4 & hi$5) | ((lo$4 | hi$5) & (~lo$5))) >>> 31) | 0)) | 0);
    var b0$4 = (65535 & hi$1);
    var b1$4 = ((hi$1 >>> 16) | 0);
    var a0b0$4 = Math.imul(13531, b0$4);
    var a1b0$3 = Math.imul(55222, b0$4);
    var a0b1$4 = Math.imul(13531, b1$4);
    var lo$6 = ((a0b0$4 + (((a1b0$3 + a0b1$4) | 0) << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$9 = ((((((Math.imul((-675924773), hi$2) + Math.imul(55222, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$3) | 0) >>> 16) | 0)) | 0);
    var lo$7 = ((lo$3 + lo$6) | 0);
    var hi$10 = ((hi$9 + ((((lo$3 & lo$6) | ((lo$3 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
    var hi$11 = (hi$10 >> 31);
    var lo$8 = ((lo$5 + hi$10) | 0);
    var hi$12 = ((((hi$8 + hi$11) | 0) + ((((lo$5 & hi$10) | ((lo$5 | hi$10) & (~lo$8))) >>> 31) | 0)) | 0);
    var lo$9 = (((lo$8 >>> 18) | 0) | (hi$12 << 14));
    var hi$13 = (hi$12 >> 18);
    var lo$10 = ((hi$1 >>> 31) | 0);
    var lo$11 = ((lo$9 + lo$10) | 0);
    var hi$14 = ((hi$13 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
    var this$25 = $m_jl_Math$();
    var lo$12 = ((lo + lo$11) | 0);
    var hi$15 = ((((hi + hi$14) | 0) + ((((lo & lo$11) | ((lo | lo$11) & (~lo$12))) >>> 31) | 0)) | 0);
    var hi$16 = (hi$15 ^ hi);
    var hi$17 = (hi$15 ^ hi$14);
    var hi$18 = (hi$16 & hi$17);
    if ((hi$18 < 0)) {
      this$25.java$lang$Math$$longOverflow__E();
    }
    return $bL(lo$12, hi$15);
  } else {
    var x$2_$_lo = this.Ljava_time_Instant__f_seconds_$lo;
    var x$2_$_hi = this.Ljava_time_Instant__f_seconds_$hi;
    var lo$16 = ((1 + x$2_$_lo) | 0);
    var hi$19 = ((x$2_$_hi + (((x$2_$_lo & (~lo$16)) >>> 31) | 0)) | 0);
    var this$32 = $m_jl_Math$();
    var b0$5 = (65535 & lo$16);
    var b1$5 = ((lo$16 >>> 16) | 0);
    var a0b0$5 = Math.imul(1000, b0$5);
    var a0b1$5 = Math.imul(1000, b1$5);
    var lo$17 = ((a0b0$5 + (a0b1$5 << 16)) | 0);
    var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
    var hi$20 = ((Math.imul(1000, hi$19) + ((c1part$5 >>> 16) | 0)) | 0);
    if (((lo$16 | hi$19) !== 0)) {
      var $x_4 = $m_RTLong$().divide__I__I__I__I__J(lo$17, hi$20, lo$16, hi$19);
      var x$3_$_lo = $x_4.l;
      var x$3_$_hi = $x_4.h;
      var $x_3 = (((1000 ^ x$3_$_lo) | x$3_$_hi) !== 0);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      this$32.java$lang$Math$$longOverflow__E();
    }
    var value$1 = this.Ljava_time_Instant__f_nanos;
    var hi$21 = (value$1 >> 31);
    var hi$22 = (hi$21 >> 31);
    var b0$6 = (65535 & value$1);
    var b1$6 = ((value$1 >>> 16) | 0);
    var a0b0$6 = Math.imul(56962, b0$6);
    var a1b0$4 = Math.imul(17179, b0$6);
    var a0b1$6 = Math.imul(56962, b1$6);
    var lo$18 = ((a0b0$6 + (((a1b0$4 + a0b1$6) | 0) << 16)) | 0);
    var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
    var hi$23 = ((((Math.imul(17179, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$4) | 0) >>> 16) | 0)) | 0);
    var b0$7 = (65535 & value$1);
    var b1$7 = ((value$1 >>> 16) | 0);
    var a0b0$7 = Math.imul(13531, b0$7);
    var a1b0$5 = Math.imul(55222, b0$7);
    var a0b1$7 = Math.imul(13531, b1$7);
    var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
    var hi$24 = ((((Math.imul(55222, b1$7) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$5) | 0) >>> 16) | 0)) | 0);
    var lo$20 = ((lo$18 + hi$24) | 0);
    var hi$25 = ((hi$23 + ((((lo$18 & hi$24) | ((lo$18 | hi$24) & (~lo$20))) >>> 31) | 0)) | 0);
    var b0$8 = (65535 & hi$21);
    var b1$8 = ((hi$21 >>> 16) | 0);
    var a0b0$8 = Math.imul(56962, b0$8);
    var a1b0$6 = Math.imul(17179, b0$8);
    var a0b1$8 = Math.imul(56962, b1$8);
    var lo$21 = ((a0b0$8 + (((a1b0$6 + a0b1$8) | 0) << 16)) | 0);
    var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
    var hi$26 = ((((((Math.imul(1125899906, hi$22) + Math.imul(17179, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$6) | 0) >>> 16) | 0)) | 0);
    var hi$27 = (hi$25 >> 31);
    var lo$22 = ((lo$21 + hi$25) | 0);
    var hi$28 = ((((hi$26 + hi$27) | 0) + ((((lo$21 & hi$25) | ((lo$21 | hi$25) & (~lo$22))) >>> 31) | 0)) | 0);
    var b0$9 = (65535 & hi$21);
    var b1$9 = ((hi$21 >>> 16) | 0);
    var a0b0$9 = Math.imul(13531, b0$9);
    var a1b0$7 = Math.imul(55222, b0$9);
    var a0b1$9 = Math.imul(13531, b1$9);
    var lo$23 = ((a0b0$9 + (((a1b0$7 + a0b1$9) | 0) << 16)) | 0);
    var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
    var hi$29 = ((((((Math.imul((-675924773), hi$22) + Math.imul(55222, b1$9)) | 0) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$7) | 0) >>> 16) | 0)) | 0);
    var lo$24 = ((lo$20 + lo$23) | 0);
    var hi$30 = ((hi$29 + ((((lo$20 & lo$23) | ((lo$20 | lo$23) & (~lo$24))) >>> 31) | 0)) | 0);
    var hi$31 = (hi$30 >> 31);
    var lo$25 = ((lo$22 + hi$30) | 0);
    var hi$32 = ((((hi$28 + hi$31) | 0) + ((((lo$22 & hi$30) | ((lo$22 | hi$30) & (~lo$25))) >>> 31) | 0)) | 0);
    var lo$26 = (((lo$25 >>> 18) | 0) | (hi$32 << 14));
    var hi$33 = (hi$32 >> 18);
    var lo$27 = ((hi$21 >>> 31) | 0);
    var lo$28 = ((lo$26 + lo$27) | 0);
    var hi$34 = ((hi$33 + ((((lo$26 & lo$27) | ((lo$26 | lo$27) & (~lo$28))) >>> 31) | 0)) | 0);
    var lo$29 = ((1000 - lo$28) | 0);
    var hi$35 = ((((-hi$34) | 0) + ((lo$28 | lo$29) >> 31)) | 0);
    var this$56 = $m_jl_Math$();
    var lo$30 = ((lo$17 - lo$29) | 0);
    var hi$36 = ((((hi$20 - hi$35) | 0) + ((((~lo$17) & lo$29) | ((~(lo$17 ^ lo$29)) & lo$30)) >> 31)) | 0);
    var hi$37 = (hi$20 ^ hi$35);
    var hi$38 = (hi$36 ^ hi$20);
    var hi$39 = (hi$37 & hi$38);
    if ((hi$39 < 0)) {
      this$56.java$lang$Math$$longOverflow__E();
    }
    return $bL(lo$30, hi$36);
  }
});
$c_Ljava_time_Instant.prototype.compare__Ljava_time_Instant__I = (function(otherInstant) {
  var x_$_lo = this.Ljava_time_Instant__f_seconds_$lo;
  var x_$_hi = this.Ljava_time_Instant__f_seconds_$hi;
  var y_$_lo = $n(otherInstant).Ljava_time_Instant__f_seconds_$lo;
  var y_$_hi = $n(otherInstant).Ljava_time_Instant__f_seconds_$hi;
  var cmp = ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
  return ((cmp !== 0) ? cmp : ((this.Ljava_time_Instant__f_nanos - $n(otherInstant).Ljava_time_Instant__f_nanos) | 0));
});
$c_Ljava_time_Instant.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_Instant)) {
    var otherInstant = $as_Ljava_time_Instant(other);
    if ((this === otherInstant)) {
      return true;
    } else {
      var x_$_lo = this.Ljava_time_Instant__f_seconds_$lo;
      var x_$_hi = this.Ljava_time_Instant__f_seconds_$hi;
      var x$1_$_lo = $n(otherInstant).Ljava_time_Instant__f_seconds_$lo;
      var x$1_$_hi = $n(otherInstant).Ljava_time_Instant__f_seconds_$hi;
      if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
        return (this.Ljava_time_Instant__f_nanos === $n(otherInstant).Ljava_time_Instant__f_nanos);
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_Instant.prototype.hashCode__I = (function() {
  var x$1_$_lo = this.Ljava_time_Instant__f_seconds_$lo;
  var x$1_$_hi = this.Ljava_time_Instant__f_seconds_$hi;
  var x_$_lo = this.Ljava_time_Instant__f_seconds_$lo;
  var x_$_hi = this.Ljava_time_Instant__f_seconds_$hi;
  var lo = (x$1_$_lo ^ x_$_hi);
  return ((lo + Math.imul(51, this.Ljava_time_Instant__f_nanos)) | 0);
});
$c_Ljava_time_Instant.prototype.toString__T = (function() {
  return $n($m_Ljava_time_format_DateTimeFormatter$().ISO_INSTANT__Ljava_time_format_DateTimeFormatter()).format__Ljava_time_temporal_TemporalAccessor__T(this);
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant(field, newValue_$_lo, newValue_$_hi);
});
$c_Ljava_time_Instant.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_Instant__I($as_Ljava_time_Instant(that));
});
$c_Ljava_time_Instant.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_Instant(that);
  return this.compare__Ljava_time_Instant__I(other);
});
function $as_Ljava_time_Instant(obj) {
  return (((obj instanceof $c_Ljava_time_Instant) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.Instant"));
}
function $isArrayOf_Ljava_time_Instant(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Instant)));
}
function $asArrayOf_Ljava_time_Instant(obj, depth) {
  return (($isArrayOf_Ljava_time_Instant(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.Instant;", depth));
}
var $d_Ljava_time_Instant = new $TypeData().initClass($c_Ljava_time_Instant, "java.time.Instant", ({
  Ljava_time_Instant: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
function $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x1 = $as_Ljava_time_temporal_ChronoField(field);
  var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  if ((x === null)) {
    var $x_1 = (x1 === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === x1);
  }
  if ($x_1) {
    var value = $thiz.Ljava_time_LocalTime__f_nano;
    var hi = (value >> 31);
    return $bL(value, hi);
  }
  var x$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$3 === null)) {
    var $x_2 = (x1 === null);
  } else {
    var this$3 = $n(x$3);
    var $x_2 = (this$3 === x1);
  }
  if ($x_2) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$5 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
  if ((x$5 === null)) {
    var $x_3 = (x1 === null);
  } else {
    var this$4 = $n(x$5);
    var $x_3 = (this$4 === x1);
  }
  if ($x_3) {
    var value$1 = $thiz.Ljava_time_LocalTime__f_nano;
    var hi$1 = (value$1 >> 31);
    var hi$2 = (hi$1 >> 31);
    var b0 = (65535 & value$1);
    var b1 = ((value$1 >>> 16) | 0);
    var a0b0 = Math.imul(39845, b0);
    var a1b0 = Math.imul(8388, b0);
    var a0b1 = Math.imul(39845, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$3 = ((((Math.imul(8388, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var b0$1 = (65535 & value$1);
    var b1$1 = ((value$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(63439, b0$1);
    var a1b0$1 = Math.imul(58195, b0$1);
    var a0b1$1 = Math.imul(63439, b1$1);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$4 = ((((Math.imul(58195, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((lo + hi$4) | 0);
    var hi$5 = ((hi$3 + ((((lo & hi$4) | ((lo | hi$4) & (~lo$2))) >>> 31) | 0)) | 0);
    var b0$2 = (65535 & hi$1);
    var b1$2 = ((hi$1 >>> 16) | 0);
    var a0b0$2 = Math.imul(39845, b0$2);
    var a1b0$2 = Math.imul(8388, b0$2);
    var a0b1$2 = Math.imul(39845, b1$2);
    var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$6 = ((((((Math.imul(549755813, hi$2) + Math.imul(8388, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
    var hi$7 = (hi$5 >> 31);
    var lo$4 = ((lo$3 + hi$5) | 0);
    var hi$8 = ((((hi$6 + hi$7) | 0) + ((((lo$3 & hi$5) | ((lo$3 | hi$5) & (~lo$4))) >>> 31) | 0)) | 0);
    var b0$3 = (65535 & hi$1);
    var b1$3 = ((hi$1 >>> 16) | 0);
    var a0b0$3 = Math.imul(63439, b0$3);
    var a1b0$3 = Math.imul(58195, b0$3);
    var a0b1$3 = Math.imul(63439, b1$3);
    var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$9 = ((((((Math.imul((-481036337), hi$2) + Math.imul(58195, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
    var lo$6 = ((lo$2 + lo$5) | 0);
    var hi$10 = ((hi$9 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
    var hi$11 = (hi$10 >> 31);
    var lo$7 = ((lo$4 + hi$10) | 0);
    var hi$12 = ((((hi$8 + hi$11) | 0) + ((((lo$4 & hi$10) | ((lo$4 | hi$10) & (~lo$7))) >>> 31) | 0)) | 0);
    var lo$8 = (((lo$7 >>> 7) | 0) | (hi$12 << 25));
    var hi$13 = (hi$12 >> 7);
    var lo$9 = ((hi$1 >>> 31) | 0);
    var lo$10 = ((lo$8 + lo$9) | 0);
    var hi$14 = ((hi$13 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
    return $bL(lo$10, hi$14);
  }
  var x$7 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$7 === null)) {
    var $x_4 = (x1 === null);
  } else {
    var this$23 = $n(x$7);
    var $x_4 = (this$23 === x1);
  }
  if ($x_4) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$9 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
  if ((x$9 === null)) {
    var $x_5 = (x1 === null);
  } else {
    var this$24 = $n(x$9);
    var $x_5 = (this$24 === x1);
  }
  if ($x_5) {
    var value$2 = $thiz.Ljava_time_LocalTime__f_nano;
    var hi$15 = (value$2 >> 31);
    var hi$16 = (hi$15 >> 31);
    var b0$4 = (65535 & value$2);
    var b1$4 = ((value$2 >>> 16) | 0);
    var a0b0$4 = Math.imul(56962, b0$4);
    var a1b0$4 = Math.imul(17179, b0$4);
    var a0b1$4 = Math.imul(56962, b1$4);
    var lo$11 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$17 = ((((Math.imul(17179, b1$4) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
    var b0$5 = (65535 & value$2);
    var b1$5 = ((value$2 >>> 16) | 0);
    var a0b0$5 = Math.imul(13531, b0$5);
    var a1b0$5 = Math.imul(55222, b0$5);
    var a0b1$5 = Math.imul(13531, b1$5);
    var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
    var hi$18 = ((((Math.imul(55222, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
    var lo$13 = ((lo$11 + hi$18) | 0);
    var hi$19 = ((hi$17 + ((((lo$11 & hi$18) | ((lo$11 | hi$18) & (~lo$13))) >>> 31) | 0)) | 0);
    var b0$6 = (65535 & hi$15);
    var b1$6 = ((hi$15 >>> 16) | 0);
    var a0b0$6 = Math.imul(56962, b0$6);
    var a1b0$6 = Math.imul(17179, b0$6);
    var a0b1$6 = Math.imul(56962, b1$6);
    var lo$14 = ((a0b0$6 + (((a1b0$6 + a0b1$6) | 0) << 16)) | 0);
    var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
    var hi$20 = ((((((Math.imul(1125899906, hi$16) + Math.imul(17179, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
    var hi$21 = (hi$19 >> 31);
    var lo$15 = ((lo$14 + hi$19) | 0);
    var hi$22 = ((((hi$20 + hi$21) | 0) + ((((lo$14 & hi$19) | ((lo$14 | hi$19) & (~lo$15))) >>> 31) | 0)) | 0);
    var b0$7 = (65535 & hi$15);
    var b1$7 = ((hi$15 >>> 16) | 0);
    var a0b0$7 = Math.imul(13531, b0$7);
    var a1b0$7 = Math.imul(55222, b0$7);
    var a0b1$7 = Math.imul(13531, b1$7);
    var lo$16 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
    var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
    var hi$23 = ((((((Math.imul((-675924773), hi$16) + Math.imul(55222, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
    var lo$17 = ((lo$13 + lo$16) | 0);
    var hi$24 = ((hi$23 + ((((lo$13 & lo$16) | ((lo$13 | lo$16) & (~lo$17))) >>> 31) | 0)) | 0);
    var hi$25 = (hi$24 >> 31);
    var lo$18 = ((lo$15 + hi$24) | 0);
    var hi$26 = ((((hi$22 + hi$25) | 0) + ((((lo$15 & hi$24) | ((lo$15 | hi$24) & (~lo$18))) >>> 31) | 0)) | 0);
    var lo$19 = (((lo$18 >>> 18) | 0) | (hi$26 << 14));
    var hi$27 = (hi$26 >> 18);
    var lo$20 = ((hi$15 >>> 31) | 0);
    var lo$21 = ((lo$19 + lo$20) | 0);
    var hi$28 = ((hi$27 + ((((lo$19 & lo$20) | ((lo$19 | lo$20) & (~lo$21))) >>> 31) | 0)) | 0);
    return $bL(lo$21, hi$28);
  }
  var x$11 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$11 === null)) {
    var $x_6 = (x1 === null);
  } else {
    var this$43 = $n(x$11);
    var $x_6 = (this$43 === x1);
  }
  if ($x_6) {
    var $x_7 = $thiz.toNanoOfDay__J();
    var num_$_lo = $x_7.l;
    var num_$_hi = $x_7.h;
    var hi$29 = (num_$_hi >> 31);
    var b0$8 = (65535 & num_$_lo);
    var b1$8 = ((num_$_lo >>> 16) | 0);
    var a0b0$8 = Math.imul(56962, b0$8);
    var a1b0$8 = Math.imul(17179, b0$8);
    var a0b1$8 = Math.imul(56962, b1$8);
    var lo$22 = ((a0b0$8 + (((a1b0$8 + a0b1$8) | 0) << 16)) | 0);
    var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
    var hi$30 = ((((Math.imul(17179, b1$8) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$8) | 0) >>> 16) | 0)) | 0);
    var b0$9 = (65535 & num_$_lo);
    var b1$9 = ((num_$_lo >>> 16) | 0);
    var a0b0$9 = Math.imul(13531, b0$9);
    var a1b0$9 = Math.imul(55222, b0$9);
    var a0b1$9 = Math.imul(13531, b1$9);
    var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
    var hi$31 = ((((Math.imul(55222, b1$9) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$9) | 0) >>> 16) | 0)) | 0);
    var lo$24 = ((lo$22 + hi$31) | 0);
    var hi$32 = ((hi$30 + ((((lo$22 & hi$31) | ((lo$22 | hi$31) & (~lo$24))) >>> 31) | 0)) | 0);
    var b0$10 = (65535 & num_$_hi);
    var b1$10 = ((num_$_hi >>> 16) | 0);
    var a0b0$10 = Math.imul(56962, b0$10);
    var a1b0$10 = Math.imul(17179, b0$10);
    var a0b1$10 = Math.imul(56962, b1$10);
    var lo$25 = ((a0b0$10 + (((a1b0$10 + a0b1$10) | 0) << 16)) | 0);
    var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
    var hi$33 = ((((((Math.imul(1125899906, hi$29) + Math.imul(17179, b1$10)) | 0) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$10) | 0) >>> 16) | 0)) | 0);
    var hi$34 = (hi$32 >> 31);
    var lo$26 = ((lo$25 + hi$32) | 0);
    var hi$35 = ((((hi$33 + hi$34) | 0) + ((((lo$25 & hi$32) | ((lo$25 | hi$32) & (~lo$26))) >>> 31) | 0)) | 0);
    var b0$11 = (65535 & num_$_hi);
    var b1$11 = ((num_$_hi >>> 16) | 0);
    var a0b0$11 = Math.imul(13531, b0$11);
    var a1b0$11 = Math.imul(55222, b0$11);
    var a0b1$11 = Math.imul(13531, b1$11);
    var lo$27 = ((a0b0$11 + (((a1b0$11 + a0b1$11) | 0) << 16)) | 0);
    var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
    var hi$36 = ((((((Math.imul((-675924773), hi$29) + Math.imul(55222, b1$11)) | 0) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$11) | 0) >>> 16) | 0)) | 0);
    var lo$28 = ((lo$24 + lo$27) | 0);
    var hi$37 = ((hi$36 + ((((lo$24 & lo$27) | ((lo$24 | lo$27) & (~lo$28))) >>> 31) | 0)) | 0);
    var hi$38 = (hi$37 >> 31);
    var lo$29 = ((lo$26 + hi$37) | 0);
    var hi$39 = ((((hi$35 + hi$38) | 0) + ((((lo$26 & hi$37) | ((lo$26 | hi$37) & (~lo$29))) >>> 31) | 0)) | 0);
    var lo$30 = (((lo$29 >>> 18) | 0) | (hi$39 << 14));
    var hi$40 = (hi$39 >> 18);
    var lo$31 = ((num_$_hi >>> 31) | 0);
    var lo$32 = ((lo$30 + lo$31) | 0);
    var hi$41 = ((hi$40 + ((((lo$30 & lo$31) | ((lo$30 | lo$31) & (~lo$32))) >>> 31) | 0)) | 0);
    return $bL(lo$32, hi$41);
  }
  var x$13 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  if ((x$13 === null)) {
    var $x_8 = (x1 === null);
  } else {
    var this$61 = $n(x$13);
    var $x_8 = (this$61 === x1);
  }
  if ($x_8) {
    var value$3 = $thiz.Ljava_time_LocalTime__f_second;
    var hi$42 = (value$3 >> 31);
    return $bL(value$3, hi$42);
  }
  var x$15 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$15 === null)) {
    var $x_9 = (x1 === null);
  } else {
    var this$63 = $n(x$15);
    var $x_9 = (this$63 === x1);
  }
  if ($x_9) {
    var value$4 = $thiz.toSecondOfDay__I();
    var hi$43 = (value$4 >> 31);
    return $bL(value$4, hi$43);
  }
  var x$17 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  if ((x$17 === null)) {
    var $x_10 = (x1 === null);
  } else {
    var this$65 = $n(x$17);
    var $x_10 = (this$65 === x1);
  }
  if ($x_10) {
    var value$5 = $thiz.Ljava_time_LocalTime__f_minute;
    var hi$44 = (value$5 >> 31);
    return $bL(value$5, hi$44);
  }
  var x$19 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$19 === null)) {
    var $x_11 = (x1 === null);
  } else {
    var this$67 = $n(x$19);
    var $x_11 = (this$67 === x1);
  }
  if ($x_11) {
    var value$6 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$45 = (value$6 >> 31);
    var b0$12 = (65535 & value$6);
    var b1$12 = ((value$6 >>> 16) | 0);
    var a0b0$12 = Math.imul(60, b0$12);
    var a0b1$12 = Math.imul(60, b1$12);
    var lo$33 = ((a0b0$12 + (a0b1$12 << 16)) | 0);
    var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
    var hi$46 = ((Math.imul(60, hi$45) + ((c1part$12 >>> 16) | 0)) | 0);
    var value$7 = $thiz.Ljava_time_LocalTime__f_minute;
    var hi$47 = (value$7 >> 31);
    var lo$34 = ((lo$33 + value$7) | 0);
    var hi$48 = ((((hi$46 + hi$47) | 0) + ((((lo$33 & value$7) | ((lo$33 | value$7) & (~lo$34))) >>> 31) | 0)) | 0);
    return $bL(lo$34, hi$48);
  }
  var x$21 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
  if ((x$21 === null)) {
    var $x_12 = (x1 === null);
  } else {
    var this$72 = $n(x$21);
    var $x_12 = (this$72 === x1);
  }
  if ($x_12) {
    var value$8 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$49 = (value$8 >> 31);
    var hi$50 = (hi$49 >> 31);
    var b0$13 = (65535 & value$8);
    var b1$13 = ((value$8 >>> 16) | 0);
    var a0b0$13 = Math.imul(43690, b0$13);
    var a1b0$12 = Math.imul(10922, b0$13);
    var a0b1$13 = Math.imul(43690, b1$13);
    var lo$35 = ((a0b0$13 + (((a1b0$12 + a0b1$13) | 0) << 16)) | 0);
    var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
    var hi$51 = ((((Math.imul(10922, b1$13) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$12) | 0) >>> 16) | 0)) | 0);
    var b0$14 = (65535 & value$8);
    var b1$14 = ((value$8 >>> 16) | 0);
    var a0b0$14 = Math.imul(43691, b0$14);
    var a1b0$13 = Math.imul(43690, b0$14);
    var a0b1$14 = Math.imul(43691, b1$14);
    var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
    var hi$52 = ((((Math.imul(43690, b1$14) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$13) | 0) >>> 16) | 0)) | 0);
    var lo$37 = ((lo$35 + hi$52) | 0);
    var hi$53 = ((hi$51 + ((((lo$35 & hi$52) | ((lo$35 | hi$52) & (~lo$37))) >>> 31) | 0)) | 0);
    var b0$15 = (65535 & hi$49);
    var b1$15 = ((hi$49 >>> 16) | 0);
    var a0b0$15 = Math.imul(43690, b0$15);
    var a1b0$14 = Math.imul(10922, b0$15);
    var a0b1$15 = Math.imul(43690, b1$15);
    var lo$38 = ((a0b0$15 + (((a1b0$14 + a0b1$15) | 0) << 16)) | 0);
    var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
    var hi$54 = ((((((Math.imul(715827882, hi$50) + Math.imul(10922, b1$15)) | 0) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$14) | 0) >>> 16) | 0)) | 0);
    var hi$55 = (hi$53 >> 31);
    var lo$39 = ((lo$38 + hi$53) | 0);
    var hi$56 = ((((hi$54 + hi$55) | 0) + ((((lo$38 & hi$53) | ((lo$38 | hi$53) & (~lo$39))) >>> 31) | 0)) | 0);
    var b0$16 = (65535 & hi$49);
    var b1$16 = ((hi$49 >>> 16) | 0);
    var a0b0$16 = Math.imul(43691, b0$16);
    var a1b0$15 = Math.imul(43690, b0$16);
    var a0b1$16 = Math.imul(43691, b1$16);
    var lo$40 = ((a0b0$16 + (((a1b0$15 + a0b1$16) | 0) << 16)) | 0);
    var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
    var hi$57 = ((((((Math.imul((-1431655765), hi$50) + Math.imul(43690, b1$16)) | 0) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$15) | 0) >>> 16) | 0)) | 0);
    var lo$41 = ((lo$37 + lo$40) | 0);
    var hi$58 = ((hi$57 + ((((lo$37 & lo$40) | ((lo$37 | lo$40) & (~lo$41))) >>> 31) | 0)) | 0);
    var hi$59 = (hi$58 >> 31);
    var lo$42 = ((lo$39 + hi$58) | 0);
    var hi$60 = ((((hi$56 + hi$59) | 0) + ((((lo$39 & hi$58) | ((lo$39 | hi$58) & (~lo$42))) >>> 31) | 0)) | 0);
    var lo$43 = (((lo$42 >>> 1) | 0) | (hi$60 << 31));
    var hi$61 = (hi$60 >> 1);
    var lo$44 = ((hi$49 >>> 31) | 0);
    var lo$45 = ((lo$43 + lo$44) | 0);
    var hi$62 = ((hi$61 + ((((lo$43 & lo$44) | ((lo$43 | lo$44) & (~lo$45))) >>> 31) | 0)) | 0);
    var b0$17 = (65535 & lo$45);
    var b1$17 = ((lo$45 >>> 16) | 0);
    var a0b0$17 = Math.imul(12, b0$17);
    var a0b1$17 = Math.imul(12, b1$17);
    var lo$46 = ((a0b0$17 + (a0b1$17 << 16)) | 0);
    var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
    var hi$63 = ((Math.imul(12, hi$62) + ((c1part$17 >>> 16) | 0)) | 0);
    var lo$47 = ((value$8 - lo$46) | 0);
    var hi$64 = ((((hi$49 - hi$63) | 0) + ((((~value$8) & lo$46) | ((~(value$8 ^ lo$46)) & lo$47)) >> 31)) | 0);
    return $bL(lo$47, hi$64);
  }
  var x$23 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
  if ((x$23 === null)) {
    var $x_13 = (x1 === null);
  } else {
    var this$93 = $n(x$23);
    var $x_13 = (this$93 === x1);
  }
  if ($x_13) {
    var value$9 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$65 = (value$9 >> 31);
    var hi$66 = (hi$65 >> 31);
    var b0$18 = (65535 & value$9);
    var b1$18 = ((value$9 >>> 16) | 0);
    var a0b0$18 = Math.imul(43690, b0$18);
    var a1b0$16 = Math.imul(10922, b0$18);
    var a0b1$18 = Math.imul(43690, b1$18);
    var lo$48 = ((a0b0$18 + (((a1b0$16 + a0b1$18) | 0) << 16)) | 0);
    var c1part$18 = ((((a0b0$18 >>> 16) | 0) + a0b1$18) | 0);
    var hi$67 = ((((Math.imul(10922, b1$18) + ((c1part$18 >>> 16) | 0)) | 0) + (((((65535 & c1part$18) + a1b0$16) | 0) >>> 16) | 0)) | 0);
    var b0$19 = (65535 & value$9);
    var b1$19 = ((value$9 >>> 16) | 0);
    var a0b0$19 = Math.imul(43691, b0$19);
    var a1b0$17 = Math.imul(43690, b0$19);
    var a0b1$19 = Math.imul(43691, b1$19);
    var c1part$19 = ((((a0b0$19 >>> 16) | 0) + a0b1$19) | 0);
    var hi$68 = ((((Math.imul(43690, b1$19) + ((c1part$19 >>> 16) | 0)) | 0) + (((((65535 & c1part$19) + a1b0$17) | 0) >>> 16) | 0)) | 0);
    var lo$50 = ((lo$48 + hi$68) | 0);
    var hi$69 = ((hi$67 + ((((lo$48 & hi$68) | ((lo$48 | hi$68) & (~lo$50))) >>> 31) | 0)) | 0);
    var b0$20 = (65535 & hi$65);
    var b1$20 = ((hi$65 >>> 16) | 0);
    var a0b0$20 = Math.imul(43690, b0$20);
    var a1b0$18 = Math.imul(10922, b0$20);
    var a0b1$20 = Math.imul(43690, b1$20);
    var lo$51 = ((a0b0$20 + (((a1b0$18 + a0b1$20) | 0) << 16)) | 0);
    var c1part$20 = ((((a0b0$20 >>> 16) | 0) + a0b1$20) | 0);
    var hi$70 = ((((((Math.imul(715827882, hi$66) + Math.imul(10922, b1$20)) | 0) + ((c1part$20 >>> 16) | 0)) | 0) + (((((65535 & c1part$20) + a1b0$18) | 0) >>> 16) | 0)) | 0);
    var hi$71 = (hi$69 >> 31);
    var lo$52 = ((lo$51 + hi$69) | 0);
    var hi$72 = ((((hi$70 + hi$71) | 0) + ((((lo$51 & hi$69) | ((lo$51 | hi$69) & (~lo$52))) >>> 31) | 0)) | 0);
    var b0$21 = (65535 & hi$65);
    var b1$21 = ((hi$65 >>> 16) | 0);
    var a0b0$21 = Math.imul(43691, b0$21);
    var a1b0$19 = Math.imul(43690, b0$21);
    var a0b1$21 = Math.imul(43691, b1$21);
    var lo$53 = ((a0b0$21 + (((a1b0$19 + a0b1$21) | 0) << 16)) | 0);
    var c1part$21 = ((((a0b0$21 >>> 16) | 0) + a0b1$21) | 0);
    var hi$73 = ((((((Math.imul((-1431655765), hi$66) + Math.imul(43690, b1$21)) | 0) + ((c1part$21 >>> 16) | 0)) | 0) + (((((65535 & c1part$21) + a1b0$19) | 0) >>> 16) | 0)) | 0);
    var lo$54 = ((lo$50 + lo$53) | 0);
    var hi$74 = ((hi$73 + ((((lo$50 & lo$53) | ((lo$50 | lo$53) & (~lo$54))) >>> 31) | 0)) | 0);
    var hi$75 = (hi$74 >> 31);
    var lo$55 = ((lo$52 + hi$74) | 0);
    var hi$76 = ((((hi$72 + hi$75) | 0) + ((((lo$52 & hi$74) | ((lo$52 | hi$74) & (~lo$55))) >>> 31) | 0)) | 0);
    var lo$56 = (((lo$55 >>> 1) | 0) | (hi$76 << 31));
    var hi$77 = (hi$76 >> 1);
    var lo$57 = ((hi$65 >>> 31) | 0);
    var lo$58 = ((lo$56 + lo$57) | 0);
    var hi$78 = ((hi$77 + ((((lo$56 & lo$57) | ((lo$56 | lo$57) & (~lo$58))) >>> 31) | 0)) | 0);
    var b0$22 = (65535 & lo$58);
    var b1$22 = ((lo$58 >>> 16) | 0);
    var a0b0$22 = Math.imul(12, b0$22);
    var a0b1$22 = Math.imul(12, b1$22);
    var lo$59 = ((a0b0$22 + (a0b1$22 << 16)) | 0);
    var c1part$22 = ((((a0b0$22 >>> 16) | 0) + a0b1$22) | 0);
    var hi$79 = ((Math.imul(12, hi$78) + ((c1part$22 >>> 16) | 0)) | 0);
    var lo$60 = ((value$9 - lo$59) | 0);
    var hi$80 = ((((hi$65 - hi$79) | 0) + ((((~value$9) & lo$59) | ((~(value$9 ^ lo$59)) & lo$60)) >> 31)) | 0);
    var hi$81 = (hi$80 >> 31);
    var b0$23 = (65535 & lo$60);
    var b1$23 = ((lo$60 >>> 16) | 0);
    var a0b0$23 = Math.imul(43690, b0$23);
    var a1b0$20 = Math.imul(10922, b0$23);
    var a0b1$23 = Math.imul(43690, b1$23);
    var lo$61 = ((a0b0$23 + (((a1b0$20 + a0b1$23) | 0) << 16)) | 0);
    var c1part$23 = ((((a0b0$23 >>> 16) | 0) + a0b1$23) | 0);
    var hi$82 = ((((Math.imul(10922, b1$23) + ((c1part$23 >>> 16) | 0)) | 0) + (((((65535 & c1part$23) + a1b0$20) | 0) >>> 16) | 0)) | 0);
    var b0$24 = (65535 & lo$60);
    var b1$24 = ((lo$60 >>> 16) | 0);
    var a0b0$24 = Math.imul(43691, b0$24);
    var a1b0$21 = Math.imul(43690, b0$24);
    var a0b1$24 = Math.imul(43691, b1$24);
    var c1part$24 = ((((a0b0$24 >>> 16) | 0) + a0b1$24) | 0);
    var hi$83 = ((((Math.imul(43690, b1$24) + ((c1part$24 >>> 16) | 0)) | 0) + (((((65535 & c1part$24) + a1b0$21) | 0) >>> 16) | 0)) | 0);
    var lo$63 = ((lo$61 + hi$83) | 0);
    var hi$84 = ((hi$82 + ((((lo$61 & hi$83) | ((lo$61 | hi$83) & (~lo$63))) >>> 31) | 0)) | 0);
    var b0$25 = (65535 & hi$80);
    var b1$25 = ((hi$80 >>> 16) | 0);
    var a0b0$25 = Math.imul(43690, b0$25);
    var a1b0$22 = Math.imul(10922, b0$25);
    var a0b1$25 = Math.imul(43690, b1$25);
    var lo$64 = ((a0b0$25 + (((a1b0$22 + a0b1$25) | 0) << 16)) | 0);
    var c1part$25 = ((((a0b0$25 >>> 16) | 0) + a0b1$25) | 0);
    var hi$85 = ((((((Math.imul(715827882, hi$81) + Math.imul(10922, b1$25)) | 0) + ((c1part$25 >>> 16) | 0)) | 0) + (((((65535 & c1part$25) + a1b0$22) | 0) >>> 16) | 0)) | 0);
    var hi$86 = (hi$84 >> 31);
    var lo$65 = ((lo$64 + hi$84) | 0);
    var hi$87 = ((((hi$85 + hi$86) | 0) + ((((lo$64 & hi$84) | ((lo$64 | hi$84) & (~lo$65))) >>> 31) | 0)) | 0);
    var b0$26 = (65535 & hi$80);
    var b1$26 = ((hi$80 >>> 16) | 0);
    var a0b0$26 = Math.imul(43691, b0$26);
    var a1b0$23 = Math.imul(43690, b0$26);
    var a0b1$26 = Math.imul(43691, b1$26);
    var lo$66 = ((a0b0$26 + (((a1b0$23 + a0b1$26) | 0) << 16)) | 0);
    var c1part$26 = ((((a0b0$26 >>> 16) | 0) + a0b1$26) | 0);
    var hi$88 = ((((((Math.imul((-1431655765), hi$81) + Math.imul(43690, b1$26)) | 0) + ((c1part$26 >>> 16) | 0)) | 0) + (((((65535 & c1part$26) + a1b0$23) | 0) >>> 16) | 0)) | 0);
    var lo$67 = ((lo$63 + lo$66) | 0);
    var hi$89 = ((hi$88 + ((((lo$63 & lo$66) | ((lo$63 | lo$66) & (~lo$67))) >>> 31) | 0)) | 0);
    var hi$90 = (hi$89 >> 31);
    var lo$68 = ((lo$65 + hi$89) | 0);
    var hi$91 = ((((hi$87 + hi$90) | 0) + ((((lo$65 & hi$89) | ((lo$65 | hi$89) & (~lo$68))) >>> 31) | 0)) | 0);
    var lo$69 = (((lo$68 >>> 1) | 0) | (hi$91 << 31));
    var hi$92 = (hi$91 >> 1);
    var lo$70 = ((hi$80 >>> 31) | 0);
    var lo$71 = ((lo$69 + lo$70) | 0);
    var hi$93 = ((hi$92 + ((((lo$69 & lo$70) | ((lo$69 | lo$70) & (~lo$71))) >>> 31) | 0)) | 0);
    var b0$27 = (65535 & lo$71);
    var b1$27 = ((lo$71 >>> 16) | 0);
    var a0b0$27 = Math.imul(12, b0$27);
    var a0b1$27 = Math.imul(12, b1$27);
    var lo$72 = ((a0b0$27 + (a0b1$27 << 16)) | 0);
    var c1part$27 = ((((a0b0$27 >>> 16) | 0) + a0b1$27) | 0);
    var hi$94 = ((Math.imul(12, hi$93) + ((c1part$27 >>> 16) | 0)) | 0);
    var lo$73 = ((lo$60 - lo$72) | 0);
    var hi$95 = ((((hi$80 - hi$94) | 0) + ((((~lo$60) & lo$72) | ((~(lo$60 ^ lo$72)) & lo$73)) >> 31)) | 0);
    if (((lo$73 | hi$95) === 0)) {
      return $bL(12, 0);
    } else {
      return $bL(lo$60, hi$80);
    }
  }
  var x$25 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$25 === null)) {
    var $x_14 = (x1 === null);
  } else {
    var this$134 = $n(x$25);
    var $x_14 = (this$134 === x1);
  }
  if ($x_14) {
    var value$10 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$96 = (value$10 >> 31);
    return $bL(value$10, hi$96);
  }
  var x$27 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$27 === null)) {
    var $x_15 = (x1 === null);
  } else {
    var this$136 = $n(x$27);
    var $x_15 = (this$136 === x1);
  }
  if ($x_15) {
    if (($thiz.Ljava_time_LocalTime__f_hour === 0)) {
      return $bL(24, 0);
    } else {
      var value$11 = $thiz.Ljava_time_LocalTime__f_hour;
      var hi$97 = (value$11 >> 31);
      return $bL(value$11, hi$97);
    }
  }
  var x$29 = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((x$29 === null)) {
    var $x_16 = (x1 === null);
  } else {
    var this$138 = $n(x$29);
    var $x_16 = (this$138 === x1);
  }
  if ($x_16) {
    var value$12 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$98 = (value$12 >> 31);
    var hi$99 = (hi$98 >> 31);
    var b0$28 = (65535 & value$12);
    var b1$28 = ((value$12 >>> 16) | 0);
    var a0b0$28 = Math.imul(43690, b0$28);
    var a1b0$24 = Math.imul(10922, b0$28);
    var a0b1$28 = Math.imul(43690, b1$28);
    var lo$74 = ((a0b0$28 + (((a1b0$24 + a0b1$28) | 0) << 16)) | 0);
    var c1part$28 = ((((a0b0$28 >>> 16) | 0) + a0b1$28) | 0);
    var hi$100 = ((((Math.imul(10922, b1$28) + ((c1part$28 >>> 16) | 0)) | 0) + (((((65535 & c1part$28) + a1b0$24) | 0) >>> 16) | 0)) | 0);
    var b0$29 = (65535 & value$12);
    var b1$29 = ((value$12 >>> 16) | 0);
    var a0b0$29 = Math.imul(43691, b0$29);
    var a1b0$25 = Math.imul(43690, b0$29);
    var a0b1$29 = Math.imul(43691, b1$29);
    var c1part$29 = ((((a0b0$29 >>> 16) | 0) + a0b1$29) | 0);
    var hi$101 = ((((Math.imul(43690, b1$29) + ((c1part$29 >>> 16) | 0)) | 0) + (((((65535 & c1part$29) + a1b0$25) | 0) >>> 16) | 0)) | 0);
    var lo$76 = ((lo$74 + hi$101) | 0);
    var hi$102 = ((hi$100 + ((((lo$74 & hi$101) | ((lo$74 | hi$101) & (~lo$76))) >>> 31) | 0)) | 0);
    var b0$30 = (65535 & hi$98);
    var b1$30 = ((hi$98 >>> 16) | 0);
    var a0b0$30 = Math.imul(43690, b0$30);
    var a1b0$26 = Math.imul(10922, b0$30);
    var a0b1$30 = Math.imul(43690, b1$30);
    var lo$77 = ((a0b0$30 + (((a1b0$26 + a0b1$30) | 0) << 16)) | 0);
    var c1part$30 = ((((a0b0$30 >>> 16) | 0) + a0b1$30) | 0);
    var hi$103 = ((((((Math.imul(715827882, hi$99) + Math.imul(10922, b1$30)) | 0) + ((c1part$30 >>> 16) | 0)) | 0) + (((((65535 & c1part$30) + a1b0$26) | 0) >>> 16) | 0)) | 0);
    var hi$104 = (hi$102 >> 31);
    var lo$78 = ((lo$77 + hi$102) | 0);
    var hi$105 = ((((hi$103 + hi$104) | 0) + ((((lo$77 & hi$102) | ((lo$77 | hi$102) & (~lo$78))) >>> 31) | 0)) | 0);
    var b0$31 = (65535 & hi$98);
    var b1$31 = ((hi$98 >>> 16) | 0);
    var a0b0$31 = Math.imul(43691, b0$31);
    var a1b0$27 = Math.imul(43690, b0$31);
    var a0b1$31 = Math.imul(43691, b1$31);
    var lo$79 = ((a0b0$31 + (((a1b0$27 + a0b1$31) | 0) << 16)) | 0);
    var c1part$31 = ((((a0b0$31 >>> 16) | 0) + a0b1$31) | 0);
    var hi$106 = ((((((Math.imul((-1431655765), hi$99) + Math.imul(43690, b1$31)) | 0) + ((c1part$31 >>> 16) | 0)) | 0) + (((((65535 & c1part$31) + a1b0$27) | 0) >>> 16) | 0)) | 0);
    var lo$80 = ((lo$76 + lo$79) | 0);
    var hi$107 = ((hi$106 + ((((lo$76 & lo$79) | ((lo$76 | lo$79) & (~lo$80))) >>> 31) | 0)) | 0);
    var hi$108 = (hi$107 >> 31);
    var lo$81 = ((lo$78 + hi$107) | 0);
    var hi$109 = ((((hi$105 + hi$108) | 0) + ((((lo$78 & hi$107) | ((lo$78 | hi$107) & (~lo$81))) >>> 31) | 0)) | 0);
    var lo$82 = (((lo$81 >>> 1) | 0) | (hi$109 << 31));
    var hi$110 = (hi$109 >> 1);
    var lo$83 = ((hi$98 >>> 31) | 0);
    var lo$84 = ((lo$82 + lo$83) | 0);
    var hi$111 = ((hi$110 + ((((lo$82 & lo$83) | ((lo$82 | lo$83) & (~lo$84))) >>> 31) | 0)) | 0);
    return $bL(lo$84, hi$111);
  }
  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
}
/** @constructor */
function $c_Ljava_time_LocalTime(_hour, _minute, _second, nano) {
  this.Ljava_time_LocalTime__f_nano = 0;
  this.Ljava_time_LocalTime__f_hour = 0;
  this.Ljava_time_LocalTime__f_minute = 0;
  this.Ljava_time_LocalTime__f_second = 0;
  this.Ljava_time_LocalTime__f_nano = nano;
  this.Ljava_time_LocalTime__f_hour = ((_hour << 24) >> 24);
  this.Ljava_time_LocalTime__f_minute = ((_minute << 24) >> 24);
  this.Ljava_time_LocalTime__f_second = ((_second << 24) >> 24);
}
$c_Ljava_time_LocalTime.prototype = new $h_O();
$c_Ljava_time_LocalTime.prototype.constructor = $c_Ljava_time_LocalTime;
/** @constructor */
function $h_Ljava_time_LocalTime() {
}
$h_Ljava_time_LocalTime.prototype = $c_Ljava_time_LocalTime.prototype;
$c_Ljava_time_LocalTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return $n(field).isTimeBased__Z();
  } else if ((field !== null)) {
    var this$1 = $n(field);
    return this.isSupported__Ljava_time_temporal_TemporalField__Z(this$1);
  } else {
    return false;
  }
});
$c_Ljava_time_LocalTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$c_Ljava_time_LocalTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var $x_1 = $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    return x_$_lo;
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$c_Ljava_time_LocalTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ((field === $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      return this.toNanoOfDay__J();
    }
    if ((field === $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      var $x_1 = this.toNanoOfDay__J();
      var num_$_lo = $x_1.l;
      var num_$_hi = $x_1.h;
      var hi = (num_$_hi >> 31);
      var b0 = (65535 & num_$_lo);
      var b1 = ((num_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(39845, b0);
      var a1b0 = Math.imul(8388, b0);
      var a0b1 = Math.imul(39845, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((((Math.imul(8388, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var b0$1 = (65535 & num_$_lo);
      var b1$1 = ((num_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(63439, b0$1);
      var a1b0$1 = Math.imul(58195, b0$1);
      var a0b1$1 = Math.imul(63439, b1$1);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$2 = ((((Math.imul(58195, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((lo + hi$2) | 0);
      var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
      var b0$2 = (65535 & num_$_hi);
      var b1$2 = ((num_$_hi >>> 16) | 0);
      var a0b0$2 = Math.imul(39845, b0$2);
      var a1b0$2 = Math.imul(8388, b0$2);
      var a0b1$2 = Math.imul(39845, b1$2);
      var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$4 = ((((((Math.imul(549755813, hi) + Math.imul(8388, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
      var hi$5 = (hi$3 >> 31);
      var lo$4 = ((lo$3 + hi$3) | 0);
      var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
      var b0$3 = (65535 & num_$_hi);
      var b1$3 = ((num_$_hi >>> 16) | 0);
      var a0b0$3 = Math.imul(63439, b0$3);
      var a1b0$3 = Math.imul(58195, b0$3);
      var a0b1$3 = Math.imul(63439, b1$3);
      var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$7 = ((((((Math.imul((-481036337), hi) + Math.imul(58195, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
      var lo$6 = ((lo$2 + lo$5) | 0);
      var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
      var hi$9 = (hi$8 >> 31);
      var lo$7 = ((lo$4 + hi$8) | 0);
      var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
      var lo$8 = (((lo$7 >>> 7) | 0) | (hi$10 << 25));
      var hi$11 = (hi$10 >> 7);
      var lo$9 = ((num_$_hi >>> 31) | 0);
      var lo$10 = ((lo$8 + lo$9) | 0);
      var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
      return $bL(lo$10, hi$12);
    }
    return $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field);
  } else {
    var this$18 = $n(field);
    return this.getLong__Ljava_time_temporal_TemporalField__J(this$18);
  }
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var this$1 = $n(f);
    $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue_$_lo, newValue_$_hi, this$1);
    var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$2 = $n(x);
      var $x_1 = (this$2 === f);
    }
    if ($x_1) {
      return this.withNano__I__Ljava_time_LocalTime(newValue_$_lo);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $x_2 = (f === null);
    } else {
      var this$4 = $n(x$3);
      var $x_2 = (this$4 === f);
    }
    if ($x_2) {
      return $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(newValue_$_lo, newValue_$_hi);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x$5 === null)) {
      var $x_3 = (f === null);
    } else {
      var this$5 = $n(x$5);
      var $x_3 = (this$5 === f);
    }
    if ($x_3) {
      return this.withNano__I__Ljava_time_LocalTime(Math.imul(1000, newValue_$_lo));
    }
    var x$7 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((x$7 === null)) {
      var $x_4 = (f === null);
    } else {
      var this$7 = $n(x$7);
      var $x_4 = (this$7 === f);
    }
    if ($x_4) {
      var $x_5 = $m_Ljava_time_LocalTime$();
      var b0 = (65535 & newValue_$_lo);
      var b1 = ((newValue_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(1000, b0);
      var a0b1 = Math.imul(1000, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((Math.imul(1000, newValue_$_hi) + ((c1part >>> 16) | 0)) | 0);
      return $x_5.ofNanoOfDay__J__Ljava_time_LocalTime(lo, hi);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if ((x$9 === null)) {
      var $x_6 = (f === null);
    } else {
      var this$9 = $n(x$9);
      var $x_6 = (this$9 === f);
    }
    if ($x_6) {
      return this.withNano__I__Ljava_time_LocalTime(Math.imul(1000000, newValue_$_lo));
    }
    var x$11 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((x$11 === null)) {
      var $x_7 = (f === null);
    } else {
      var this$11 = $n(x$11);
      var $x_7 = (this$11 === f);
    }
    if ($x_7) {
      var $x_8 = $m_Ljava_time_LocalTime$();
      var b0$1 = (65535 & newValue_$_lo);
      var b1$1 = ((newValue_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(16960, b0$1);
      var a1b0 = Math.imul(15, b0$1);
      var a0b1$1 = Math.imul(16960, b1$1);
      var lo$1 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$1 = ((((((Math.imul(1000000, newValue_$_hi) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $x_8.ofNanoOfDay__J__Ljava_time_LocalTime(lo$1, hi$1);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    if ((x$13 === null)) {
      var $x_9 = (f === null);
    } else {
      var this$13 = $n(x$13);
      var $x_9 = (this$13 === f);
    }
    if ($x_9) {
      return this.withSecond__I__Ljava_time_LocalTime(newValue_$_lo);
    }
    var x$15 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((x$15 === null)) {
      var $x_10 = (f === null);
    } else {
      var this$15 = $n(x$15);
      var $x_10 = (this$15 === f);
    }
    if ($x_10) {
      var value = this.toSecondOfDay__I();
      var hi$2 = (value >> 31);
      var lo$2 = ((newValue_$_lo - value) | 0);
      var hi$3 = ((((newValue_$_hi - hi$2) | 0) + ((((~newValue_$_lo) & value) | ((~(newValue_$_lo ^ value)) & lo$2)) >> 31)) | 0);
      return this.plusSeconds__J__Ljava_time_LocalTime(lo$2, hi$3);
    }
    var x$17 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    if ((x$17 === null)) {
      var $x_11 = (f === null);
    } else {
      var this$18 = $n(x$17);
      var $x_11 = (this$18 === f);
    }
    if ($x_11) {
      return this.withMinute__I__Ljava_time_LocalTime(newValue_$_lo);
    }
    var x$19 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((x$19 === null)) {
      var $x_12 = (f === null);
    } else {
      var this$20 = $n(x$19);
      var $x_12 = (this$20 === f);
    }
    if ($x_12) {
      var value$1 = ((Math.imul(60, this.Ljava_time_LocalTime__f_hour) + this.Ljava_time_LocalTime__f_minute) | 0);
      var hi$4 = (value$1 >> 31);
      var lo$3 = ((newValue_$_lo - value$1) | 0);
      var hi$5 = ((((newValue_$_hi - hi$4) | 0) + ((((~newValue_$_lo) & value$1) | ((~(newValue_$_lo ^ value$1)) & lo$3)) >> 31)) | 0);
      return this.plusMinutes__J__Ljava_time_LocalTime(lo$3, hi$5);
    }
    var x$21 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    if ((x$21 === null)) {
      var $x_13 = (f === null);
    } else {
      var this$23 = $n(x$21);
      var $x_13 = (this$23 === f);
    }
    if ($x_13) {
      var value$2 = ((this.Ljava_time_LocalTime__f_hour % 12) | 0);
      var hi$6 = (value$2 >> 31);
      var lo$4 = ((newValue_$_lo - value$2) | 0);
      var hi$7 = ((((newValue_$_hi - hi$6) | 0) + ((((~newValue_$_lo) & value$2) | ((~(newValue_$_lo ^ value$2)) & lo$4)) >> 31)) | 0);
      return this.plusHours__J__Ljava_time_LocalTime(lo$4, hi$7);
    }
    var x$23 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    if ((x$23 === null)) {
      var $x_14 = (f === null);
    } else {
      var this$26 = $n(x$23);
      var $x_14 = (this$26 === f);
    }
    if ($x_14) {
      if ((((12 ^ newValue_$_lo) | newValue_$_hi) === 0)) {
        var x$1_$_lo = 0;
        var x$1_$_hi = 0;
      } else {
        var x$1_$_lo = newValue_$_lo;
        var x$1_$_hi = newValue_$_hi;
      }
      var value$3 = ((this.Ljava_time_LocalTime__f_hour % 12) | 0);
      var hi$8 = (value$3 >> 31);
      var lo$5 = ((x$1_$_lo - value$3) | 0);
      var hi$9 = ((((x$1_$_hi - hi$8) | 0) + ((((~x$1_$_lo) & value$3) | ((~(x$1_$_lo ^ value$3)) & lo$5)) >> 31)) | 0);
      return this.plusHours__J__Ljava_time_LocalTime(lo$5, hi$9);
    }
    var x$25 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((x$25 === null)) {
      var $x_15 = (f === null);
    } else {
      var this$30 = $n(x$25);
      var $x_15 = (this$30 === f);
    }
    if ($x_15) {
      return this.withHour__I__Ljava_time_LocalTime(newValue_$_lo);
    }
    var x$27 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((x$27 === null)) {
      var $x_16 = (f === null);
    } else {
      var this$32 = $n(x$27);
      var $x_16 = (this$32 === f);
    }
    if ($x_16) {
      if ((((24 ^ newValue_$_lo) | newValue_$_hi) === 0)) {
        var x$2_$_lo = 0;
        var x$2_$_hi = 0;
      } else {
        var x$2_$_lo = newValue_$_lo;
        var x$2_$_hi = newValue_$_hi;
      }
      return this.withHour__I__Ljava_time_LocalTime(x$2_$_lo);
    }
    var x$29 = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((x$29 === null)) {
      var $x_17 = (f === null);
    } else {
      var this$35 = $n(x$29);
      var $x_17 = (this$35 === f);
    }
    if ($x_17) {
      var value$4 = ((this.Ljava_time_LocalTime__f_hour / 12) | 0);
      var hi$10 = (value$4 >> 31);
      var lo$6 = ((newValue_$_lo - value$4) | 0);
      var hi$11 = ((((newValue_$_hi - hi$10) | 0) + ((((~newValue_$_lo) & value$4) | ((~(newValue_$_lo ^ value$4)) & lo$6)) >> 31)) | 0);
      var b0$2 = (65535 & lo$6);
      var b1$2 = ((lo$6 >>> 16) | 0);
      var a0b0$2 = Math.imul(12, b0$2);
      var a0b1$2 = Math.imul(12, b1$2);
      var lo$7 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$12 = ((Math.imul(12, hi$11) + ((c1part$2 >>> 16) | 0)) | 0);
      return this.plusHours__J__Ljava_time_LocalTime(lo$7, hi$12);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var this$39 = $n(field);
    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(this$39, newValue_$_lo, newValue_$_hi);
  }
});
$c_Ljava_time_LocalTime.prototype.withHour__I__Ljava_time_LocalTime = (function(hour) {
  if ((this.Ljava_time_LocalTime__f_hour === hour)) {
    return this;
  } else {
    var this$2 = $n($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
    var hi = (hour >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(hour, hi, this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(hour, this.Ljava_time_LocalTime__f_minute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano);
  }
});
$c_Ljava_time_LocalTime.prototype.withMinute__I__Ljava_time_LocalTime = (function(minute) {
  if ((this.Ljava_time_LocalTime__f_minute === minute)) {
    return this;
  } else {
    var this$2 = $n($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
    var hi = (minute >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(minute, hi, this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(this.Ljava_time_LocalTime__f_hour, minute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano);
  }
});
$c_Ljava_time_LocalTime.prototype.withSecond__I__Ljava_time_LocalTime = (function(second) {
  if ((this.Ljava_time_LocalTime__f_second === second)) {
    return this;
  } else {
    var this$2 = $n($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
    var hi = (second >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(second, hi, this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(this.Ljava_time_LocalTime__f_hour, this.Ljava_time_LocalTime__f_minute, second, this.Ljava_time_LocalTime__f_nano);
  }
});
$c_Ljava_time_LocalTime.prototype.withNano__I__Ljava_time_LocalTime = (function(nanoOfSecond) {
  if ((this.Ljava_time_LocalTime__f_nano === nanoOfSecond)) {
    return this;
  } else {
    var this$2 = $n($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var hi = (nanoOfSecond >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(nanoOfSecond, hi, this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(this.Ljava_time_LocalTime__f_hour, this.Ljava_time_LocalTime__f_minute, this.Ljava_time_LocalTime__f_second, nanoOfSecond);
  }
});
$c_Ljava_time_LocalTime.prototype.plusHours__J__Ljava_time_LocalTime = (function(hoursToAdd_$_lo, hoursToAdd_$_hi) {
  if (((hoursToAdd_$_lo | hoursToAdd_$_hi) === 0)) {
    return this;
  }
  var hi = (hoursToAdd_$_hi >> 31);
  var b0 = (65535 & hoursToAdd_$_lo);
  var b1 = ((hoursToAdd_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(43690, b0);
  var a1b0 = Math.imul(10922, b0);
  var a0b1 = Math.imul(43690, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(10922, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & hoursToAdd_$_lo);
  var b1$1 = ((hoursToAdd_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(43691, b0$1);
  var a1b0$1 = Math.imul(43690, b0$1);
  var a0b1$1 = Math.imul(43691, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(43690, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & hoursToAdd_$_hi);
  var b1$2 = ((hoursToAdd_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(43690, b0$2);
  var a1b0$2 = Math.imul(10922, b0$2);
  var a0b1$2 = Math.imul(43690, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(715827882, hi) + Math.imul(10922, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & hoursToAdd_$_hi);
  var b1$3 = ((hoursToAdd_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(43691, b0$3);
  var a1b0$3 = Math.imul(43690, b0$3);
  var a0b1$3 = Math.imul(43691, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-1431655765), hi) + Math.imul(43690, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 2) | 0) | (hi$10 << 30));
  var lo$9 = ((hoursToAdd_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var b0$4 = (65535 & lo$10);
  var b1$4 = ((lo$10 >>> 16) | 0);
  var a0b0$4 = Math.imul(24, b0$4);
  var a0b1$4 = Math.imul(24, b1$4);
  var lo$11 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
  var lo$12 = ((hoursToAdd_$_lo - lo$11) | 0);
  var newHour = ((((24 + ((lo$12 + this.Ljava_time_LocalTime__f_hour) | 0)) | 0) % 24) | 0);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(newHour, this.Ljava_time_LocalTime__f_minute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano);
});
$c_Ljava_time_LocalTime.prototype.plusMinutes__J__Ljava_time_LocalTime = (function(minutesToAdd_$_lo, minutesToAdd_$_hi) {
  if (((minutesToAdd_$_lo | minutesToAdd_$_hi) === 0)) {
    return this;
  }
  var mofd = ((Math.imul(60, this.Ljava_time_LocalTime__f_hour) + this.Ljava_time_LocalTime__f_minute) | 0);
  var hi = (minutesToAdd_$_hi >> 31);
  var b0 = (65535 & minutesToAdd_$_lo);
  var b1 = ((minutesToAdd_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(55341, b0);
  var a1b0 = Math.imul(11650, b0);
  var a0b1 = Math.imul(55341, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(11650, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & minutesToAdd_$_lo);
  var b1$1 = ((minutesToAdd_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(11651, b0$1);
  var a1b0$1 = Math.imul(33496, b0$1);
  var a0b1$1 = Math.imul(11651, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(33496, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & minutesToAdd_$_hi);
  var b1$2 = ((minutesToAdd_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(55341, b0$2);
  var a1b0$2 = Math.imul(11650, b0$2);
  var a0b1$2 = Math.imul(55341, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(763549741, hi) + Math.imul(11650, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & minutesToAdd_$_hi);
  var b1$3 = ((minutesToAdd_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(11651, b0$3);
  var a1b0$3 = Math.imul(33496, b0$3);
  var a0b1$3 = Math.imul(11651, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-2099761789), hi) + Math.imul(33496, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 8) | 0) | (hi$10 << 24));
  var lo$9 = ((minutesToAdd_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var b0$4 = (65535 & lo$10);
  var b1$4 = ((lo$10 >>> 16) | 0);
  var a0b0$4 = Math.imul(1440, b0$4);
  var a0b1$4 = Math.imul(1440, b1$4);
  var lo$11 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
  var lo$12 = ((minutesToAdd_$_lo - lo$11) | 0);
  var newMofd = ((((1440 + ((lo$12 + mofd) | 0)) | 0) % 1440) | 0);
  if ((mofd === newMofd)) {
    return this;
  }
  var newHour = ((newMofd / 60) | 0);
  var newMinute = ((newMofd % 60) | 0);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(newHour, newMinute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano);
});
$c_Ljava_time_LocalTime.prototype.plusSeconds__J__Ljava_time_LocalTime = (function(secondstoAdd_$_lo, secondstoAdd_$_hi) {
  if (((secondstoAdd_$_lo | secondstoAdd_$_hi) === 0)) {
    return this;
  }
  var sofd = ((((Math.imul(3600, this.Ljava_time_LocalTime__f_hour) + Math.imul(60, this.Ljava_time_LocalTime__f_minute)) | 0) + this.Ljava_time_LocalTime__f_second) | 0);
  var hi = (secondstoAdd_$_hi >> 31);
  var b0 = (65535 & secondstoAdd_$_lo);
  var b1 = ((secondstoAdd_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(51360, b0);
  var a1b0 = Math.imul(6213, b0);
  var a0b1 = Math.imul(51360, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(6213, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & secondstoAdd_$_lo);
  var b1$1 = ((secondstoAdd_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(10583, b0$1);
  var a1b0$1 = Math.imul(52817, b0$1);
  var a0b1$1 = Math.imul(10583, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(52817, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & secondstoAdd_$_hi);
  var b1$2 = ((secondstoAdd_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(51360, b0$2);
  var a1b0$2 = Math.imul(6213, b0$2);
  var a0b1$2 = Math.imul(51360, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(407226528, hi) + Math.imul(6213, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & secondstoAdd_$_hi);
  var b1$3 = ((secondstoAdd_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(10583, b0$3);
  var a1b0$3 = Math.imul(52817, b0$3);
  var a0b1$3 = Math.imul(10583, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-833541801), hi) + Math.imul(52817, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 13) | 0) | (hi$10 << 19));
  var lo$9 = ((secondstoAdd_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var b0$4 = (65535 & lo$10);
  var b1$4 = ((lo$10 >>> 16) | 0);
  var a0b0$4 = Math.imul(20864, b0$4);
  var a0b1$4 = Math.imul(20864, b1$4);
  var lo$11 = ((a0b0$4 + (((b0$4 + a0b1$4) | 0) << 16)) | 0);
  var lo$12 = ((secondstoAdd_$_lo - lo$11) | 0);
  var newSofd = ((((86400 + ((lo$12 + sofd) | 0)) | 0) % 86400) | 0);
  if ((sofd === newSofd)) {
    return this;
  }
  var newHour = ((newSofd / 3600) | 0);
  var newMinute = ((((newSofd / 60) | 0) % 60) | 0);
  var newSecond = ((newSofd % 60) | 0);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(newHour, newMinute, newSecond, this.Ljava_time_LocalTime__f_nano);
});
$c_Ljava_time_LocalTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $x_1 = (query === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === query);
  }
  if ($x_1) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === null)) {
    var $x_2 = (query === null);
  } else {
    var this$2 = $n(x$3);
    var $x_2 = (this$2 === query);
  }
  if ($x_2) {
    return this;
  }
  matchAlts1: {
    matchAlts2: {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === null)) {
        var $x_3 = (query === null);
      } else {
        var this$3 = $n(x$5);
        var $x_3 = (this$3 === query);
      }
      if ($x_3) {
        break matchAlts2;
      }
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === null)) {
        var $x_4 = (query === null);
      } else {
        var this$4 = $n(x$7);
        var $x_4 = (this$4 === query);
      }
      if ($x_4) {
        break matchAlts2;
      }
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$9 === null)) {
        var $x_5 = (query === null);
      } else {
        var this$5 = $n(x$9);
        var $x_5 = (this$5 === query);
      }
      if ($x_5) {
        break matchAlts2;
      }
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$11 === null)) {
        var $x_6 = (query === null);
      } else {
        var this$6 = $n(x$11);
        var $x_6 = (this$6 === query);
      }
      if ($x_6) {
        break matchAlts2;
      }
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
      if ((x$13 === null)) {
        var $x_7 = (query === null);
      } else {
        var this$7 = $n(x$13);
        var $x_7 = (this$7 === query);
      }
      if ($x_7) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this);
});
$c_Ljava_time_LocalTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var u = $as_Ljava_time_temporal_ChronoUnit(unit);
    var $x_1 = $n(end).toNanoOfDay__J();
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var $x_2 = this.toNanoOfDay__J();
    var x$1_$_lo = $x_2.l;
    var x$1_$_hi = $x_2.h;
    var lo = ((x_$_lo - x$1_$_lo) | 0);
    var hi = ((((x_$_hi - x$1_$_hi) | 0) + ((((~x_$_lo) & x$1_$_lo) | ((~(x_$_lo ^ x$1_$_lo)) & lo)) >> 31)) | 0);
    var x$2 = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if ((x$2 === null)) {
      var $x_3 = (u === null);
    } else {
      var this$2 = $n(x$2);
      var $x_3 = (this$2 === u);
    }
    if ($x_3) {
      return $bL(lo, hi);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
    if ((x$3 === null)) {
      var $x_4 = (u === null);
    } else {
      var this$3 = $n(x$3);
      var $x_4 = (this$3 === u);
    }
    if ($x_4) {
      var hi$1 = (hi >> 31);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(39845, b0);
      var a1b0 = Math.imul(8388, b0);
      var a0b1 = Math.imul(39845, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(8388, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var b0$1 = (65535 & lo);
      var b1$1 = ((lo >>> 16) | 0);
      var a0b0$1 = Math.imul(63439, b0$1);
      var a1b0$1 = Math.imul(58195, b0$1);
      var a0b1$1 = Math.imul(63439, b1$1);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$3 = ((((Math.imul(58195, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var lo$3 = ((lo$1 + hi$3) | 0);
      var hi$4 = ((hi$2 + ((((lo$1 & hi$3) | ((lo$1 | hi$3) & (~lo$3))) >>> 31) | 0)) | 0);
      var b0$2 = (65535 & hi);
      var b1$2 = ((hi >>> 16) | 0);
      var a0b0$2 = Math.imul(39845, b0$2);
      var a1b0$2 = Math.imul(8388, b0$2);
      var a0b1$2 = Math.imul(39845, b1$2);
      var lo$4 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$5 = ((((((Math.imul(549755813, hi$1) + Math.imul(8388, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
      var hi$6 = (hi$4 >> 31);
      var lo$5 = ((lo$4 + hi$4) | 0);
      var hi$7 = ((((hi$5 + hi$6) | 0) + ((((lo$4 & hi$4) | ((lo$4 | hi$4) & (~lo$5))) >>> 31) | 0)) | 0);
      var b0$3 = (65535 & hi);
      var b1$3 = ((hi >>> 16) | 0);
      var a0b0$3 = Math.imul(63439, b0$3);
      var a1b0$3 = Math.imul(58195, b0$3);
      var a0b1$3 = Math.imul(63439, b1$3);
      var lo$6 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$8 = ((((((Math.imul((-481036337), hi$1) + Math.imul(58195, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
      var lo$7 = ((lo$3 + lo$6) | 0);
      var hi$9 = ((hi$8 + ((((lo$3 & lo$6) | ((lo$3 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
      var hi$10 = (hi$9 >> 31);
      var lo$8 = ((lo$5 + hi$9) | 0);
      var hi$11 = ((((hi$7 + hi$10) | 0) + ((((lo$5 & hi$9) | ((lo$5 | hi$9) & (~lo$8))) >>> 31) | 0)) | 0);
      var lo$9 = (((lo$8 >>> 7) | 0) | (hi$11 << 25));
      var hi$12 = (hi$11 >> 7);
      var lo$10 = ((hi >>> 31) | 0);
      var lo$11 = ((lo$9 + lo$10) | 0);
      var hi$13 = ((hi$12 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
      return $bL(lo$11, hi$13);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
    if ((x$5 === null)) {
      var $x_5 = (u === null);
    } else {
      var this$21 = $n(x$5);
      var $x_5 = (this$21 === u);
    }
    if ($x_5) {
      var hi$14 = (hi >> 31);
      var b0$4 = (65535 & lo);
      var b1$4 = ((lo >>> 16) | 0);
      var a0b0$4 = Math.imul(56962, b0$4);
      var a1b0$4 = Math.imul(17179, b0$4);
      var a0b1$4 = Math.imul(56962, b1$4);
      var lo$12 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$15 = ((((Math.imul(17179, b1$4) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
      var b0$5 = (65535 & lo);
      var b1$5 = ((lo >>> 16) | 0);
      var a0b0$5 = Math.imul(13531, b0$5);
      var a1b0$5 = Math.imul(55222, b0$5);
      var a0b1$5 = Math.imul(13531, b1$5);
      var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
      var hi$16 = ((((Math.imul(55222, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
      var lo$14 = ((lo$12 + hi$16) | 0);
      var hi$17 = ((hi$15 + ((((lo$12 & hi$16) | ((lo$12 | hi$16) & (~lo$14))) >>> 31) | 0)) | 0);
      var b0$6 = (65535 & hi);
      var b1$6 = ((hi >>> 16) | 0);
      var a0b0$6 = Math.imul(56962, b0$6);
      var a1b0$6 = Math.imul(17179, b0$6);
      var a0b1$6 = Math.imul(56962, b1$6);
      var lo$15 = ((a0b0$6 + (((a1b0$6 + a0b1$6) | 0) << 16)) | 0);
      var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
      var hi$18 = ((((((Math.imul(1125899906, hi$14) + Math.imul(17179, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
      var hi$19 = (hi$17 >> 31);
      var lo$16 = ((lo$15 + hi$17) | 0);
      var hi$20 = ((((hi$18 + hi$19) | 0) + ((((lo$15 & hi$17) | ((lo$15 | hi$17) & (~lo$16))) >>> 31) | 0)) | 0);
      var b0$7 = (65535 & hi);
      var b1$7 = ((hi >>> 16) | 0);
      var a0b0$7 = Math.imul(13531, b0$7);
      var a1b0$7 = Math.imul(55222, b0$7);
      var a0b1$7 = Math.imul(13531, b1$7);
      var lo$17 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
      var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
      var hi$21 = ((((((Math.imul((-675924773), hi$14) + Math.imul(55222, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
      var lo$18 = ((lo$14 + lo$17) | 0);
      var hi$22 = ((hi$21 + ((((lo$14 & lo$17) | ((lo$14 | lo$17) & (~lo$18))) >>> 31) | 0)) | 0);
      var hi$23 = (hi$22 >> 31);
      var lo$19 = ((lo$16 + hi$22) | 0);
      var hi$24 = ((((hi$20 + hi$23) | 0) + ((((lo$16 & hi$22) | ((lo$16 | hi$22) & (~lo$19))) >>> 31) | 0)) | 0);
      var lo$20 = (((lo$19 >>> 18) | 0) | (hi$24 << 14));
      var hi$25 = (hi$24 >> 18);
      var lo$21 = ((hi >>> 31) | 0);
      var lo$22 = ((lo$20 + lo$21) | 0);
      var hi$26 = ((hi$25 + ((((lo$20 & lo$21) | ((lo$20 | lo$21) & (~lo$22))) >>> 31) | 0)) | 0);
      return $bL(lo$22, hi$26);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
    if ((x$7 === null)) {
      var $x_6 = (u === null);
    } else {
      var this$39 = $n(x$7);
      var $x_6 = (this$39 === u);
    }
    if ($x_6) {
      var hi$27 = (hi >> 31);
      var b0$8 = (65535 & lo);
      var b1$8 = ((lo >>> 16) | 0);
      var a0b0$8 = Math.imul(3048, b0$8);
      var a1b0$8 = Math.imul(4398, b0$8);
      var a0b1$8 = Math.imul(3048, b1$8);
      var lo$23 = ((a0b0$8 + (((a1b0$8 + a0b1$8) | 0) << 16)) | 0);
      var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
      var hi$28 = ((((Math.imul(4398, b1$8) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$8) | 0) >>> 16) | 0)) | 0);
      var b0$9 = (65535 & lo);
      var b1$9 = ((lo >>> 16) | 0);
      var a0b0$9 = Math.imul(38067, b0$9);
      var a1b0$9 = Math.imul(9942, b0$9);
      var a0b1$9 = Math.imul(38067, b1$9);
      var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
      var hi$29 = ((((Math.imul(9942, b1$9) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$9) | 0) >>> 16) | 0)) | 0);
      var lo$25 = ((lo$23 + hi$29) | 0);
      var hi$30 = ((hi$28 + ((((lo$23 & hi$29) | ((lo$23 | hi$29) & (~lo$25))) >>> 31) | 0)) | 0);
      var b0$10 = (65535 & hi);
      var b1$10 = ((hi >>> 16) | 0);
      var a0b0$10 = Math.imul(3048, b0$10);
      var a1b0$10 = Math.imul(4398, b0$10);
      var a0b1$10 = Math.imul(3048, b1$10);
      var lo$26 = ((a0b0$10 + (((a1b0$10 + a0b1$10) | 0) << 16)) | 0);
      var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
      var hi$31 = ((((((Math.imul(288230376, hi$27) + Math.imul(4398, b1$10)) | 0) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$10) | 0) >>> 16) | 0)) | 0);
      var hi$32 = (hi$30 >> 31);
      var lo$27 = ((lo$26 + hi$30) | 0);
      var hi$33 = ((((hi$31 + hi$32) | 0) + ((((lo$26 & hi$30) | ((lo$26 | hi$30) & (~lo$27))) >>> 31) | 0)) | 0);
      var b0$11 = (65535 & hi);
      var b1$11 = ((hi >>> 16) | 0);
      var a0b0$11 = Math.imul(38067, b0$11);
      var a1b0$11 = Math.imul(9942, b0$11);
      var a0b1$11 = Math.imul(38067, b1$11);
      var lo$28 = ((a0b0$11 + (((a1b0$11 + a0b1$11) | 0) << 16)) | 0);
      var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
      var hi$34 = ((((((Math.imul(651596979, hi$27) + Math.imul(9942, b1$11)) | 0) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$11) | 0) >>> 16) | 0)) | 0);
      var lo$29 = ((lo$25 + lo$28) | 0);
      var hi$35 = ((hi$34 + ((((lo$25 & lo$28) | ((lo$25 | lo$28) & (~lo$29))) >>> 31) | 0)) | 0);
      var hi$36 = (hi$35 >> 31);
      var lo$30 = ((lo$27 + hi$35) | 0);
      var hi$37 = ((((hi$33 + hi$36) | 0) + ((((lo$27 & hi$35) | ((lo$27 | hi$35) & (~lo$30))) >>> 31) | 0)) | 0);
      var lo$31 = (((lo$30 >>> 26) | 0) | (hi$37 << 6));
      var hi$38 = (hi$37 >> 26);
      var lo$32 = ((hi >>> 31) | 0);
      var lo$33 = ((lo$31 + lo$32) | 0);
      var hi$39 = ((hi$38 + ((((lo$31 & lo$32) | ((lo$31 | lo$32) & (~lo$33))) >>> 31) | 0)) | 0);
      return $bL(lo$33, hi$39);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
    if ((x$9 === null)) {
      var $x_7 = (u === null);
    } else {
      var this$57 = $n(x$9);
      var $x_7 = (this$57 === u);
    }
    if ($x_7) {
      var hi$40 = (hi >> 31);
      var b0$12 = (65535 & lo);
      var b1$12 = ((lo >>> 16) | 0);
      var a0b0$12 = Math.imul(13310, b0$12);
      var a1b0$12 = Math.imul(293, b0$12);
      var a0b1$12 = Math.imul(13310, b1$12);
      var lo$34 = ((a0b0$12 + (((a1b0$12 + a0b1$12) | 0) << 16)) | 0);
      var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
      var hi$41 = ((((Math.imul(293, b1$12) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$12) | 0) >>> 16) | 0)) | 0);
      var b0$13 = (65535 & lo);
      var b1$13 = ((lo >>> 16) | 0);
      var a0b0$13 = Math.imul(15645, b0$13);
      var a1b0$13 = Math.imul(26877, b0$13);
      var a0b1$13 = Math.imul(15645, b1$13);
      var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
      var hi$42 = ((((Math.imul(26877, b1$13) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$13) | 0) >>> 16) | 0)) | 0);
      var lo$36 = ((lo$34 + hi$42) | 0);
      var hi$43 = ((hi$41 + ((((lo$34 & hi$42) | ((lo$34 | hi$42) & (~lo$36))) >>> 31) | 0)) | 0);
      var b0$14 = (65535 & hi);
      var b1$14 = ((hi >>> 16) | 0);
      var a0b0$14 = Math.imul(13310, b0$14);
      var a1b0$14 = Math.imul(293, b0$14);
      var a0b1$14 = Math.imul(13310, b1$14);
      var lo$37 = ((a0b0$14 + (((a1b0$14 + a0b1$14) | 0) << 16)) | 0);
      var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
      var hi$44 = ((((((Math.imul(19215358, hi$40) + Math.imul(293, b1$14)) | 0) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$14) | 0) >>> 16) | 0)) | 0);
      var hi$45 = (hi$43 >> 31);
      var lo$38 = ((lo$37 + hi$43) | 0);
      var hi$46 = ((((hi$44 + hi$45) | 0) + ((((lo$37 & hi$43) | ((lo$37 | hi$43) & (~lo$38))) >>> 31) | 0)) | 0);
      var b0$15 = (65535 & hi);
      var b1$15 = ((hi >>> 16) | 0);
      var a0b0$15 = Math.imul(15645, b0$15);
      var a1b0$15 = Math.imul(26877, b0$15);
      var a0b1$15 = Math.imul(15645, b1$15);
      var lo$39 = ((a0b0$15 + (((a1b0$15 + a0b1$15) | 0) << 16)) | 0);
      var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
      var hi$47 = ((((((Math.imul(1761426717, hi$40) + Math.imul(26877, b1$15)) | 0) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$15) | 0) >>> 16) | 0)) | 0);
      var lo$40 = ((lo$36 + lo$39) | 0);
      var hi$48 = ((hi$47 + ((((lo$36 & lo$39) | ((lo$36 | lo$39) & (~lo$40))) >>> 31) | 0)) | 0);
      var hi$49 = (hi$48 >> 31);
      var lo$41 = ((lo$38 + hi$48) | 0);
      var hi$50 = ((((hi$46 + hi$49) | 0) + ((((lo$38 & hi$48) | ((lo$38 | hi$48) & (~lo$41))) >>> 31) | 0)) | 0);
      var lo$42 = (((lo$41 >>> 28) | 0) | (hi$50 << 4));
      var hi$51 = (hi$50 >> 28);
      var lo$43 = ((hi >>> 31) | 0);
      var lo$44 = ((lo$42 + lo$43) | 0);
      var hi$52 = ((hi$51 + ((((lo$42 & lo$43) | ((lo$42 | lo$43) & (~lo$44))) >>> 31) | 0)) | 0);
      return $bL(lo$44, hi$52);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
    if ((x$11 === null)) {
      var $x_8 = (u === null);
    } else {
      var this$75 = $n(x$11);
      var $x_8 = (this$75 === u);
    }
    if ($x_8) {
      var hi$53 = (hi >> 31);
      var b0$16 = (65535 & lo);
      var b1$16 = ((lo >>> 16) | 0);
      var a0b0$16 = Math.imul(65318, b0$16);
      var a1b0$16 = Math.imul(40031, b0$16);
      var a0b1$16 = Math.imul(65318, b1$16);
      var lo$45 = ((a0b0$16 + (((a1b0$16 + a0b1$16) | 0) << 16)) | 0);
      var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
      var hi$54 = ((((((((-lo) | 0) + Math.imul(40031, b1$16)) | 0) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$16) | 0) >>> 16) | 0)) | 0);
      var b0$17 = (65535 & lo);
      var b1$17 = ((lo >>> 16) | 0);
      var a0b0$17 = Math.imul(60757, b0$17);
      var a1b0$17 = Math.imul(60789, b0$17);
      var a0b1$17 = Math.imul(60757, b1$17);
      var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
      var hi$55 = ((((Math.imul(60789, b1$17) + ((c1part$17 >>> 16) | 0)) | 0) + (((((65535 & c1part$17) + a1b0$17) | 0) >>> 16) | 0)) | 0);
      var lo$47 = ((lo$45 + hi$55) | 0);
      var hi$56 = ((hi$54 + ((((lo$45 & hi$55) | ((lo$45 | hi$55) & (~lo$47))) >>> 31) | 0)) | 0);
      var b0$18 = (65535 & hi);
      var b1$18 = ((hi >>> 16) | 0);
      var a0b0$18 = Math.imul(65318, b0$18);
      var a1b0$18 = Math.imul(40031, b0$18);
      var a0b1$18 = Math.imul(65318, b1$18);
      var lo$48 = ((a0b0$18 + (((a1b0$18 + a0b1$18) | 0) << 16)) | 0);
      var c1part$18 = ((((a0b0$18 >>> 16) | 0) + a0b1$18) | 0);
      var hi$57 = ((((((((Math.imul((-1671430362), hi$53) + ((-hi) | 0)) | 0) + Math.imul(40031, b1$18)) | 0) + ((c1part$18 >>> 16) | 0)) | 0) + (((((65535 & c1part$18) + a1b0$18) | 0) >>> 16) | 0)) | 0);
      var hi$58 = (hi$56 >> 31);
      var lo$49 = ((lo$48 + hi$56) | 0);
      var hi$59 = ((((hi$57 + hi$58) | 0) + ((((lo$48 & hi$56) | ((lo$48 | hi$56) & (~lo$49))) >>> 31) | 0)) | 0);
      var b0$19 = (65535 & hi);
      var b1$19 = ((hi >>> 16) | 0);
      var a0b0$19 = Math.imul(60757, b0$19);
      var a1b0$19 = Math.imul(60789, b0$19);
      var a0b1$19 = Math.imul(60757, b1$19);
      var lo$50 = ((a0b0$19 + (((a1b0$19 + a0b1$19) | 0) << 16)) | 0);
      var c1part$19 = ((((a0b0$19 >>> 16) | 0) + a0b1$19) | 0);
      var hi$60 = ((((((Math.imul((-311038635), hi$53) + Math.imul(60789, b1$19)) | 0) + ((c1part$19 >>> 16) | 0)) | 0) + (((((65535 & c1part$19) + a1b0$19) | 0) >>> 16) | 0)) | 0);
      var lo$51 = ((lo$47 + lo$50) | 0);
      var hi$61 = ((hi$60 + ((((lo$47 & lo$50) | ((lo$47 | lo$50) & (~lo$51))) >>> 31) | 0)) | 0);
      var hi$62 = (hi$61 >> 31);
      var lo$52 = ((lo$49 + hi$61) | 0);
      var hi$63 = ((((hi$59 + hi$62) | 0) + ((((lo$49 & hi$61) | ((lo$49 | hi$61) & (~lo$52))) >>> 31) | 0)) | 0);
      var lo$53 = ((lo$52 + lo) | 0);
      var hi$64 = ((((hi$63 + hi) | 0) + ((((lo$52 & lo) | ((lo$52 | lo) & (~lo$53))) >>> 31) | 0)) | 0);
      var lo$54 = (hi$64 >> 9);
      var hi$65 = (hi$64 >> 31);
      var lo$55 = ((hi >>> 31) | 0);
      var lo$56 = ((lo$54 + lo$55) | 0);
      var hi$66 = ((hi$65 + ((((lo$54 & lo$55) | ((lo$54 | lo$55) & (~lo$56))) >>> 31) | 0)) | 0);
      return $bL(lo$56, hi$66);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
    if ((x$13 === null)) {
      var $x_9 = (u === null);
    } else {
      var this$94 = $n(x$13);
      var $x_9 = (this$94 === u);
    }
    if ($x_9) {
      var hi$67 = (hi >> 31);
      var b0$20 = (65535 & lo);
      var b1$20 = ((lo >>> 16) | 0);
      var a0b0$20 = Math.imul(65391, b0$20);
      var a1b0$20 = Math.imul(26687, b0$20);
      var a0b1$20 = Math.imul(65391, b1$20);
      var lo$57 = ((a0b0$20 + (((a1b0$20 + a0b1$20) | 0) << 16)) | 0);
      var c1part$20 = ((((a0b0$20 >>> 16) | 0) + a0b1$20) | 0);
      var hi$68 = ((((Math.imul(26687, b1$20) + ((c1part$20 >>> 16) | 0)) | 0) + (((((65535 & c1part$20) + a1b0$20) | 0) >>> 16) | 0)) | 0);
      var b0$21 = (65535 & lo);
      var b1$21 = ((lo >>> 16) | 0);
      var a0b0$21 = Math.imul(18659, b0$21);
      var a1b0$21 = Math.imul(18681, b0$21);
      var a0b1$21 = Math.imul(18659, b1$21);
      var c1part$21 = ((((a0b0$21 >>> 16) | 0) + a0b1$21) | 0);
      var hi$69 = ((((Math.imul(18681, b1$21) + ((c1part$21 >>> 16) | 0)) | 0) + (((((65535 & c1part$21) + a1b0$21) | 0) >>> 16) | 0)) | 0);
      var lo$59 = ((lo$57 + hi$69) | 0);
      var hi$70 = ((hi$68 + ((((lo$57 & hi$69) | ((lo$57 | hi$69) & (~lo$59))) >>> 31) | 0)) | 0);
      var b0$22 = (65535 & hi);
      var b1$22 = ((hi >>> 16) | 0);
      var a0b0$22 = Math.imul(65391, b0$22);
      var a1b0$22 = Math.imul(26687, b0$22);
      var a0b1$22 = Math.imul(65391, b1$22);
      var lo$60 = ((a0b0$22 + (((a1b0$22 + a0b1$22) | 0) << 16)) | 0);
      var c1part$22 = ((((a0b0$22 >>> 16) | 0) + a0b1$22) | 0);
      var hi$71 = ((((((Math.imul(1749024623, hi$67) + Math.imul(26687, b1$22)) | 0) + ((c1part$22 >>> 16) | 0)) | 0) + (((((65535 & c1part$22) + a1b0$22) | 0) >>> 16) | 0)) | 0);
      var hi$72 = (hi$70 >> 31);
      var lo$61 = ((lo$60 + hi$70) | 0);
      var hi$73 = ((((hi$71 + hi$72) | 0) + ((((lo$60 & hi$70) | ((lo$60 | hi$70) & (~lo$61))) >>> 31) | 0)) | 0);
      var b0$23 = (65535 & hi);
      var b1$23 = ((hi >>> 16) | 0);
      var a0b0$23 = Math.imul(18659, b0$23);
      var a1b0$23 = Math.imul(18681, b0$23);
      var a0b1$23 = Math.imul(18659, b1$23);
      var lo$62 = ((a0b0$23 + (((a1b0$23 + a0b1$23) | 0) << 16)) | 0);
      var c1part$23 = ((((a0b0$23 >>> 16) | 0) + a0b1$23) | 0);
      var hi$74 = ((((((Math.imul(1224296675, hi$67) + Math.imul(18681, b1$23)) | 0) + ((c1part$23 >>> 16) | 0)) | 0) + (((((65535 & c1part$23) + a1b0$23) | 0) >>> 16) | 0)) | 0);
      var lo$63 = ((lo$59 + lo$62) | 0);
      var hi$75 = ((hi$74 + ((((lo$59 & lo$62) | ((lo$59 | lo$62) & (~lo$63))) >>> 31) | 0)) | 0);
      var hi$76 = (hi$75 >> 31);
      var lo$64 = ((lo$61 + hi$75) | 0);
      var hi$77 = ((((hi$73 + hi$76) | 0) + ((((lo$61 & hi$75) | ((lo$61 | hi$75) & (~lo$64))) >>> 31) | 0)) | 0);
      var lo$65 = (hi$77 >> 12);
      var hi$78 = (hi$77 >> 31);
      var lo$66 = ((hi >>> 31) | 0);
      var lo$67 = ((lo$65 + lo$66) | 0);
      var hi$79 = ((hi$78 + ((((lo$65 & lo$66) | ((lo$65 | lo$66) & (~lo$67))) >>> 31) | 0)) | 0);
      return $bL(lo$67, hi$79);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  } else {
    var this$112 = $n(unit);
    return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end, this$112);
  }
});
$c_Ljava_time_LocalTime.prototype.toSecondOfDay__I = (function() {
  var total = Math.imul(3600, this.Ljava_time_LocalTime__f_hour);
  total = ((total + Math.imul(60, this.Ljava_time_LocalTime__f_minute)) | 0);
  total = ((total + this.Ljava_time_LocalTime__f_second) | 0);
  return total;
});
$c_Ljava_time_LocalTime.prototype.toNanoOfDay__J = (function() {
  var value = this.Ljava_time_LocalTime__f_hour;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(40960, b0);
  var a1b0 = Math.imul(12472, b0);
  var a0b1 = Math.imul(40960, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(817405952, hi) + Math.imul(838, value)) | 0) + Math.imul(12472, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var total_$_lo = lo;
  var total_$_hi = hi$1;
  var x_$_lo = total_$_lo;
  var x_$_hi = total_$_hi;
  var value$1 = this.Ljava_time_LocalTime__f_minute;
  var hi$2 = (value$1 >> 31);
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(22528, b0$1);
  var a1b0$1 = Math.imul(63559, b0$1);
  var a0b1$1 = Math.imul(22528, b1$1);
  var lo$1 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((((((Math.imul((-129542144), hi$2) + Math.imul(13, value$1)) | 0) + Math.imul(63559, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((x_$_lo + lo$1) | 0);
  var hi$4 = ((((x_$_hi + hi$3) | 0) + ((((x_$_lo & lo$1) | ((x_$_lo | lo$1) & (~lo$2))) >>> 31) | 0)) | 0);
  total_$_lo = lo$2;
  total_$_hi = hi$4;
  var x$1_$_lo = total_$_lo;
  var x$1_$_hi = total_$_hi;
  var value$2 = this.Ljava_time_LocalTime__f_second;
  var hi$5 = (value$2 >> 31);
  var b0$2 = (65535 & value$2);
  var b1$2 = ((value$2 >>> 16) | 0);
  var a0b0$2 = Math.imul(51712, b0$2);
  var a1b0$2 = Math.imul(15258, b0$2);
  var a0b1$2 = Math.imul(51712, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$6 = ((((((Math.imul(1000000000, hi$5) + Math.imul(15258, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var lo$4 = ((x$1_$_lo + lo$3) | 0);
  var hi$7 = ((((x$1_$_hi + hi$6) | 0) + ((((x$1_$_lo & lo$3) | ((x$1_$_lo | lo$3) & (~lo$4))) >>> 31) | 0)) | 0);
  total_$_lo = lo$4;
  total_$_hi = hi$7;
  var x$2_$_lo = total_$_lo;
  var x$2_$_hi = total_$_hi;
  var value$3 = this.Ljava_time_LocalTime__f_nano;
  var hi$8 = (value$3 >> 31);
  var lo$5 = ((x$2_$_lo + value$3) | 0);
  var hi$9 = ((((x$2_$_hi + hi$8) | 0) + ((((x$2_$_lo & value$3) | ((x$2_$_lo | value$3) & (~lo$5))) >>> 31) | 0)) | 0);
  total_$_lo = lo$5;
  total_$_hi = hi$9;
  return $bL(total_$_lo, total_$_hi);
});
$c_Ljava_time_LocalTime.prototype.compare__Ljava_time_LocalTime__I = (function(other) {
  var x = this.Ljava_time_LocalTime__f_hour;
  var y = $n(other).Ljava_time_LocalTime__f_hour;
  var cmp = ((x === y) ? 0 : ((x < y) ? (-1) : 1));
  if ((cmp === 0)) {
    var x$1 = this.Ljava_time_LocalTime__f_minute;
    var y$1 = $n(other).Ljava_time_LocalTime__f_minute;
    cmp = ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
    if ((cmp === 0)) {
      var x$2 = this.Ljava_time_LocalTime__f_second;
      var y$2 = $n(other).Ljava_time_LocalTime__f_second;
      cmp = ((x$2 === y$2) ? 0 : ((x$2 < y$2) ? (-1) : 1));
      if ((cmp === 0)) {
        var x$3 = this.Ljava_time_LocalTime__f_nano;
        var y$3 = $n(other).Ljava_time_LocalTime__f_nano;
        cmp = ((x$3 === y$3) ? 0 : ((x$3 < y$3) ? (-1) : 1));
      }
    }
  }
  return cmp;
});
$c_Ljava_time_LocalTime.prototype.isAfter__Ljava_time_LocalTime__Z = (function(other) {
  return (this.compare__Ljava_time_LocalTime__I(other) > 0);
});
$c_Ljava_time_LocalTime.prototype.isBefore__Ljava_time_LocalTime__Z = (function(other) {
  return (this.compare__Ljava_time_LocalTime__I(other) < 0);
});
$c_Ljava_time_LocalTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalTime)) {
    var other = $as_Ljava_time_LocalTime(obj);
    return ((this === other) || ((((this.Ljava_time_LocalTime__f_hour === $n(other).Ljava_time_LocalTime__f_hour) && (this.Ljava_time_LocalTime__f_minute === $n(other).Ljava_time_LocalTime__f_minute)) && (this.Ljava_time_LocalTime__f_second === $n(other).Ljava_time_LocalTime__f_second)) && (this.Ljava_time_LocalTime__f_nano === $n(other).Ljava_time_LocalTime__f_nano)));
  } else {
    return false;
  }
});
$c_Ljava_time_LocalTime.prototype.hashCode__I = (function() {
  var $x_1 = this.toNanoOfDay__J();
  var nod_$_lo = $x_1.l;
  var nod_$_hi = $x_1.h;
  var lo = (nod_$_lo ^ nod_$_hi);
  return lo;
});
$c_Ljava_time_LocalTime.prototype.toString__T = (function() {
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 18);
  var hourValue = this.Ljava_time_LocalTime__f_hour;
  var minuteValue = this.Ljava_time_LocalTime__f_minute;
  var secondValue = this.Ljava_time_LocalTime__f_second;
  var nanoValue = this.Ljava_time_LocalTime__f_nano;
  $n($n($n(buf.append__T__scm_StringBuilder(((hourValue < 10) ? "0" : ""))).append__I__scm_StringBuilder(hourValue)).append__T__scm_StringBuilder(((minuteValue < 10) ? ":0" : ":"))).append__I__scm_StringBuilder(minuteValue);
  if (((secondValue > 0) || (nanoValue > 0))) {
    $n(buf.append__T__scm_StringBuilder(((secondValue < 10) ? ":0" : ":"))).append__I__scm_StringBuilder(secondValue);
    if ((nanoValue > 0)) {
      buf.append__C__scm_StringBuilder(46);
      if ((((nanoValue % 1000000) | 0) === 0)) {
        var i = ((1000 + ((nanoValue / 1000000) | 0)) | 0);
        var this$2 = ("" + i);
        if ((this$2.length < 1)) {
          $charAt(this$2, 1);
        }
        buf.append__T__scm_StringBuilder($as_T(this$2.substring(1)));
      } else if ((((nanoValue % 1000) | 0) === 0)) {
        var i$1 = ((1000000 + ((nanoValue / 1000) | 0)) | 0);
        var this$4 = ("" + i$1);
        if ((this$4.length < 1)) {
          $charAt(this$4, 1);
        }
        buf.append__T__scm_StringBuilder($as_T(this$4.substring(1)));
      } else {
        var i$2 = ((1000000000 + nanoValue) | 0);
        var this$6 = ("" + i$2);
        if ((this$6.length < 1)) {
          $charAt(this$6, 1);
        }
        buf.append__T__scm_StringBuilder($as_T(this$6.substring(1)));
      }
    }
  }
  return $n(buf.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(field, newValue_$_lo, newValue_$_hi);
});
$c_Ljava_time_LocalTime.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_LocalTime__I($as_Ljava_time_LocalTime(that));
});
$c_Ljava_time_LocalTime.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_LocalTime(that);
  return this.compare__Ljava_time_LocalTime__I(other);
});
function $as_Ljava_time_LocalTime(obj) {
  return (((obj instanceof $c_Ljava_time_LocalTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.LocalTime"));
}
function $isArrayOf_Ljava_time_LocalTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalTime)));
}
function $asArrayOf_Ljava_time_LocalTime(obj, depth) {
  return (($isArrayOf_Ljava_time_LocalTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.LocalTime;", depth));
}
var $d_Ljava_time_LocalTime = new $TypeData().initClass($c_Ljava_time_LocalTime, "java.time.LocalTime", ({
  Ljava_time_LocalTime: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
function $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime($thiz, dateTime, offset) {
  if (($thiz.Ljava_time_OffsetDateTime__f_dateTime === dateTime)) {
    var x = $thiz.Ljava_time_OffsetDateTime__f_offset;
    var $x_1 = ((x === null) ? (offset === null) : $n(x).equals__O__Z(offset));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $thiz;
  } else {
    return new $c_Ljava_time_OffsetDateTime(dateTime, offset);
  }
}
/** @constructor */
function $c_Ljava_time_OffsetDateTime(dateTime, offset) {
  this.Ljava_time_OffsetDateTime__f_dateTime = null;
  this.Ljava_time_OffsetDateTime__f_offset = null;
  this.Ljava_time_OffsetDateTime__f_dateTime = dateTime;
  this.Ljava_time_OffsetDateTime__f_offset = offset;
  $n(dateTime);
  $n(offset);
}
$c_Ljava_time_OffsetDateTime.prototype = new $h_O();
$c_Ljava_time_OffsetDateTime.prototype.constructor = $c_Ljava_time_OffsetDateTime;
/** @constructor */
function $h_Ljava_time_OffsetDateTime() {
}
$h_Ljava_time_OffsetDateTime.prototype = $c_Ljava_time_OffsetDateTime.prototype;
$c_Ljava_time_OffsetDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return true;
  } else if ((field !== null)) {
    var this$1 = $n(field);
    return this.isSupported__Ljava_time_temporal_TemporalField__Z(this$1);
  } else {
    return false;
  }
});
$c_Ljava_time_OffsetDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if (((field === $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()))) {
      var this$1 = $n(field);
      return this$1.Ljava_time_temporal_ChronoField__f__range;
    } else {
      return $n(this.Ljava_time_OffsetDateTime__f_dateTime).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field);
    }
  } else {
    var this$2 = $n(field);
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$2);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === f);
    }
    if ($x_1) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $x_2 = (f === null);
    } else {
      var this$2 = $n(x$3);
      var $x_2 = (this$2 === f);
    }
    if ($x_2) {
      var this$3 = $n(this.Ljava_time_OffsetDateTime__f_offset);
      return this$3.Ljava_time_ZoneOffset__f_totalSeconds;
    }
    return $n(this.Ljava_time_OffsetDateTime__f_dateTime).get__Ljava_time_temporal_TemporalField__I(field);
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === f);
    }
    if ($x_1) {
      return $n(this.Ljava_time_OffsetDateTime__f_dateTime).toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_OffsetDateTime__f_offset);
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $x_2 = (f === null);
      } else {
        var this$2 = $n(x$3);
        var $x_2 = (this$2 === f);
      }
      if ($x_2) {
        var this$3 = $n(this.Ljava_time_OffsetDateTime__f_offset);
        var value = this$3.Ljava_time_ZoneOffset__f_totalSeconds;
        var hi = (value >> 31);
        return $bL(value, hi);
      } else {
        return $n(this.Ljava_time_OffsetDateTime__f_dateTime).getLong__Ljava_time_temporal_TemporalField__J(field);
      }
    }
  } else {
    var this$5 = $n(field);
    return this.getLong__Ljava_time_temporal_TemporalField__J(this$5);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.withOffsetSameInstant__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime = (function(offset) {
  var x$2 = this.Ljava_time_OffsetDateTime__f_offset;
  if (((offset === null) ? (x$2 === null) : $n(offset).equals__O__Z(x$2))) {
    return this;
  }
  var this$1 = $n(offset);
  var $x_1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $n(this.Ljava_time_OffsetDateTime__f_offset);
  var difference = (($x_1 - this$2.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
  var this$4 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
  var hi = (difference >> 31);
  var adjusted = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$4, this$4.Ljava_time_LocalDateTime__f_date, 0, 0, 0, 0, difference, hi, 0, 0, 1);
  return new $c_Ljava_time_OffsetDateTime(adjusted, offset);
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === f);
    }
    if ($x_1) {
      var $x_3 = $m_Ljava_time_OffsetDateTime$();
      var $x_2 = $m_Ljava_time_Instant$();
      var this$2 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
      var this$3 = $n(this$2.Ljava_time_LocalDateTime__f_time);
      var value = this$3.Ljava_time_LocalTime__f_nano;
      var hi = (value >> 31);
      return $x_3.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime($x_2.ofEpochSecond__J__J__Ljava_time_Instant(newValue_$_lo, newValue_$_hi, value, hi), this.Ljava_time_OffsetDateTime__f_offset);
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $x_4 = (f === null);
      } else {
        var this$5 = $n(x$3);
        var $x_4 = (this$5 === f);
      }
      if ($x_4) {
        var $x_6 = this.Ljava_time_OffsetDateTime__f_dateTime;
        var $x_5 = $m_Ljava_time_ZoneOffset$();
        var this$6 = $n(f);
        return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, $x_6, $x_5.ofTotalSeconds__I__Ljava_time_ZoneOffset($n(this$6.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue_$_lo, newValue_$_hi, this$6)));
      } else {
        return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, $n(this.Ljava_time_OffsetDateTime__f_dateTime).with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue_$_lo, newValue_$_hi), this.Ljava_time_OffsetDateTime__f_offset);
      }
    }
  } else {
    var this$7 = $n(field);
    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime(this$7, newValue_$_lo, newValue_$_hi);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === null)) {
    var $x_1 = (query === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === query);
  }
  if ($x_1) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === null)) {
    var $x_2 = (query === null);
  } else {
    var this$2 = $n(x$3);
    var $x_2 = (this$2 === query);
  }
  if ($x_2) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  matchAlts3: {
    matchAlts4: {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === null)) {
        var $x_3 = (query === null);
      } else {
        var this$3 = $n(x$5);
        var $x_3 = (this$3 === query);
      }
      if ($x_3) {
        break matchAlts4;
      }
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === null)) {
        var $x_4 = (query === null);
      } else {
        var this$4 = $n(x$7);
        var $x_4 = (this$4 === query);
      }
      if ($x_4) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return this.Ljava_time_OffsetDateTime__f_offset;
  }
  var x$9 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$9 === null)) {
    var $x_5 = (query === null);
  } else {
    var this$5 = $n(x$9);
    var $x_5 = (this$5 === query);
  }
  if ($x_5) {
    var this$6 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
    return this$6.Ljava_time_LocalDateTime__f_date;
  }
  var x$11 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$11 === null)) {
    var $x_6 = (query === null);
  } else {
    var this$7 = $n(x$11);
    var $x_6 = (this$7 === query);
  }
  if ($x_6) {
    var this$8 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
    return this$8.Ljava_time_LocalDateTime__f_time;
  }
  var x$13 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
  if ((x$13 === null)) {
    var $x_7 = (query === null);
  } else {
    var this$9 = $n(x$13);
    var $x_7 = (this$9 === query);
  }
  if ($x_7) {
    return null;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query);
});
$c_Ljava_time_OffsetDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_OffsetDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_OffsetDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    end = $n(end).withOffsetSameInstant__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this.Ljava_time_OffsetDateTime__f_offset);
    return $n(this.Ljava_time_OffsetDateTime__f_dateTime).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J($n(end).Ljava_time_OffsetDateTime__f_dateTime, unit);
  } else {
    var this$1 = $n(unit);
    var temporal2 = end;
    return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(temporal2, this$1);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.compare__Ljava_time_OffsetDateTime__I = (function(other) {
  var x = this.Ljava_time_OffsetDateTime__f_offset;
  var this$1 = $n(other);
  var x$2 = this$1.Ljava_time_OffsetDateTime__f_offset;
  if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
    var $x_1 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
    var this$2 = $n(other);
    return $x_1.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(this$2.Ljava_time_OffsetDateTime__f_dateTime);
  }
  var $x_2 = $n(this.Ljava_time_OffsetDateTime__f_dateTime).toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_OffsetDateTime__f_offset);
  var x$1_$_lo = $x_2.l;
  var x$1_$_hi = $x_2.h;
  var this$3 = $n(other);
  var $x_3 = $n(this$3.Ljava_time_OffsetDateTime__f_dateTime).toEpochSecond__Ljava_time_ZoneOffset__J(this$3.Ljava_time_OffsetDateTime__f_offset);
  var y_$_lo = $x_3.l;
  var y_$_hi = $x_3.h;
  var cmp = ((x$1_$_hi === y_$_hi) ? ((x$1_$_lo === y_$_lo) ? 0 : (((x$1_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x$1_$_hi < y_$_hi) ? (-1) : 1));
  if ((cmp === 0)) {
    var this$5 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
    var this$6 = $n(this$5.Ljava_time_LocalDateTime__f_time);
    var $x_4 = this$6.Ljava_time_LocalTime__f_nano;
    var this$7 = $n(other);
    var this$8 = $n(this$7.Ljava_time_OffsetDateTime__f_dateTime);
    var this$9 = $n(this$8.Ljava_time_LocalDateTime__f_time);
    cmp = (($x_4 - this$9.Ljava_time_LocalTime__f_nano) | 0);
    if ((cmp === 0)) {
      var $x_5 = $n(this.Ljava_time_OffsetDateTime__f_dateTime);
      var this$10 = $n(other);
      cmp = $x_5.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(this$10.Ljava_time_OffsetDateTime__f_dateTime);
    }
  }
  return cmp;
});
$c_Ljava_time_OffsetDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_OffsetDateTime)) {
    var other = $as_Ljava_time_OffsetDateTime(obj);
    if ((this === other)) {
      return true;
    } else {
      var x = this.Ljava_time_OffsetDateTime__f_dateTime;
      var x$2 = $n(other).Ljava_time_OffsetDateTime__f_dateTime;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_OffsetDateTime__f_offset;
        var x$4 = $n(other).Ljava_time_OffsetDateTime__f_offset;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_OffsetDateTime.prototype.hashCode__I = (function() {
  var $x_1 = $n(this.Ljava_time_OffsetDateTime__f_dateTime).hashCode__I();
  var this$1 = $n(this.Ljava_time_OffsetDateTime__f_offset);
  return ($x_1 ^ this$1.Ljava_time_ZoneOffset__f_totalSeconds);
});
$c_Ljava_time_OffsetDateTime.prototype.toString__T = (function() {
  return (("" + $n(this.Ljava_time_OffsetDateTime__f_dateTime).toString__T()) + $n(this.Ljava_time_OffsetDateTime__f_offset).Ljava_time_ZoneOffset__f_id);
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime(field, newValue_$_lo, newValue_$_hi);
});
$c_Ljava_time_OffsetDateTime.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_OffsetDateTime__I($as_Ljava_time_OffsetDateTime(that));
});
$c_Ljava_time_OffsetDateTime.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_OffsetDateTime(that);
  return this.compare__Ljava_time_OffsetDateTime__I(other);
});
function $as_Ljava_time_OffsetDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_OffsetDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.OffsetDateTime"));
}
function $isArrayOf_Ljava_time_OffsetDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_OffsetDateTime)));
}
function $asArrayOf_Ljava_time_OffsetDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_OffsetDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.OffsetDateTime;", depth));
}
var $d_Ljava_time_OffsetDateTime = new $TypeData().initClass($c_Ljava_time_OffsetDateTime, "java.time.OffsetDateTime", ({
  Ljava_time_OffsetDateTime: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ljava_time_ZoneOffset(totalSeconds) {
  this.Ljava_time_ZoneOffset__f_totalSeconds = 0;
  this.Ljava_time_ZoneOffset__f_id = null;
  this.Ljava_time_ZoneOffset__f_totalSeconds = totalSeconds;
  $ct_Ljava_time_ZoneId__(this);
  this.Ljava_time_ZoneOffset__f_id = $m_Ljava_time_ZoneOffset$().java$time$ZoneOffset$$$buildId__I__T(totalSeconds);
}
$c_Ljava_time_ZoneOffset.prototype = new $h_Ljava_time_ZoneId();
$c_Ljava_time_ZoneOffset.prototype.constructor = $c_Ljava_time_ZoneOffset;
/** @constructor */
function $h_Ljava_time_ZoneOffset() {
}
$h_Ljava_time_ZoneOffset.prototype = $c_Ljava_time_ZoneOffset.prototype;
$c_Ljava_time_ZoneOffset.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return (field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
  } else if ((field !== null)) {
    var this$1 = $n(field);
    return this.isSupported__Ljava_time_temporal_TemporalField__Z(this$1);
  } else {
    return false;
  }
});
$c_Ljava_time_ZoneOffset.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    var this$1 = $n(field);
    return this$1.Ljava_time_temporal_ChronoField__f__range;
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var this$2 = $n(field);
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$2);
  }
});
$c_Ljava_time_ZoneOffset.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    return this.Ljava_time_ZoneOffset__f_totalSeconds;
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var $x_2 = $n(this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field));
    var $x_1 = this.getLong__Ljava_time_temporal_TemporalField__J(field);
    return $x_2.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($x_1.l, $x_1.h, field);
  }
});
$c_Ljava_time_ZoneOffset.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    var value = this.Ljava_time_ZoneOffset__f_totalSeconds;
    var hi = (value >> 31);
    return $bL(value, hi);
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unsupported field: " + field));
  } else {
    var this$2 = $n(field);
    return this.getLong__Ljava_time_temporal_TemporalField__J(this$2);
  }
});
$c_Ljava_time_ZoneOffset.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return (((query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) ? this : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) ? null : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)));
});
$c_Ljava_time_ZoneOffset.prototype.compare__Ljava_time_ZoneOffset__I = (function(other) {
  return (($n(other).Ljava_time_ZoneOffset__f_totalSeconds - this.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
});
$c_Ljava_time_ZoneOffset.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZoneOffset)) {
    var that = $as_Ljava_time_ZoneOffset(obj);
    return ((this === that) || (this.Ljava_time_ZoneOffset__f_totalSeconds === $n(that).Ljava_time_ZoneOffset__f_totalSeconds));
  } else {
    return false;
  }
});
$c_Ljava_time_ZoneOffset.prototype.hashCode__I = (function() {
  return this.Ljava_time_ZoneOffset__f_totalSeconds;
});
$c_Ljava_time_ZoneOffset.prototype.toString__T = (function() {
  return this.Ljava_time_ZoneOffset__f_id;
});
$c_Ljava_time_ZoneOffset.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_ZoneOffset__I($as_Ljava_time_ZoneOffset(that));
});
$c_Ljava_time_ZoneOffset.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_ZoneOffset(that);
  return this.compare__Ljava_time_ZoneOffset__I(other);
});
function $as_Ljava_time_ZoneOffset(obj) {
  return (((obj instanceof $c_Ljava_time_ZoneOffset) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.ZoneOffset"));
}
function $isArrayOf_Ljava_time_ZoneOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZoneOffset)));
}
function $asArrayOf_Ljava_time_ZoneOffset(obj, depth) {
  return (($isArrayOf_Ljava_time_ZoneOffset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.ZoneOffset;", depth));
}
var $d_Ljava_time_ZoneOffset = new $TypeData().initClass($c_Ljava_time_ZoneOffset, "java.time.ZoneOffset", ({
  Ljava_time_ZoneOffset: 1,
  Ljava_time_ZoneId: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1
}));
function $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime($thiz, offset) {
  var x$2 = $thiz.Ljava_time_ZonedDateTime__f_offset;
  if ((!((offset === null) ? (x$2 === null) : $n(offset).equals__O__Z(x$2)))) {
    var this$1 = $n($thiz.Ljava_time_ZonedDateTime__f_zone);
    var $x_1 = $n($m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$1)).isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z($thiz.Ljava_time_ZonedDateTime__f_dateTime, offset);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return new $c_Ljava_time_ZonedDateTime($thiz.Ljava_time_ZonedDateTime__f_dateTime, offset, $thiz.Ljava_time_ZonedDateTime__f_zone);
  } else {
    return $thiz;
  }
}
/** @constructor */
function $c_Ljava_time_ZonedDateTime(dateTime, offset, zone) {
  this.Ljava_time_ZonedDateTime__f_dateTime = null;
  this.Ljava_time_ZonedDateTime__f_offset = null;
  this.Ljava_time_ZonedDateTime__f_zone = null;
  this.Ljava_time_ZonedDateTime__f_dateTime = dateTime;
  this.Ljava_time_ZonedDateTime__f_offset = offset;
  this.Ljava_time_ZonedDateTime__f_zone = zone;
}
$c_Ljava_time_ZonedDateTime.prototype = new $h_O();
$c_Ljava_time_ZonedDateTime.prototype.constructor = $c_Ljava_time_ZonedDateTime;
/** @constructor */
function $h_Ljava_time_ZonedDateTime() {
}
$h_Ljava_time_ZonedDateTime.prototype = $c_Ljava_time_ZonedDateTime.prototype;
$c_Ljava_time_ZonedDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return true;
  } else if ((field !== null)) {
    var this$1 = $n(field);
    return this.isSupported__Ljava_time_temporal_TemporalField__Z(this$1);
  } else {
    return false;
  }
});
$c_Ljava_time_ZonedDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if (((field === $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()))) {
      var this$1 = $n(field);
      return this$1.Ljava_time_temporal_ChronoField__f__range;
    } else {
      return $n(this.Ljava_time_ZonedDateTime__f_dateTime).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field);
    }
  } else {
    var this$2 = $n(field);
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$2);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === f);
    }
    if ($x_1) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $x_2 = (f === null);
    } else {
      var this$2 = $n(x$3);
      var $x_2 = (this$2 === f);
    }
    if ($x_2) {
      var this$3 = $n(this.Ljava_time_ZonedDateTime__f_offset);
      return this$3.Ljava_time_ZoneOffset__f_totalSeconds;
    }
    return $n(this.Ljava_time_ZonedDateTime__f_dateTime).get__Ljava_time_temporal_TemporalField__I(field);
  } else {
    return $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === f);
    }
    if ($x_1) {
      return $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(this);
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $x_2 = (f === null);
      } else {
        var this$2 = $n(x$3);
        var $x_2 = (this$2 === f);
      }
      if ($x_2) {
        var this$3 = $n(this.Ljava_time_ZonedDateTime__f_offset);
        var value = this$3.Ljava_time_ZoneOffset__f_totalSeconds;
        var hi = (value >> 31);
        return $bL(value, hi);
      } else {
        return $n(this.Ljava_time_ZonedDateTime__f_dateTime).getLong__Ljava_time_temporal_TemporalField__J(field);
      }
    }
  } else {
    var this$5 = $n(field);
    return this.getLong__Ljava_time_temporal_TemporalField__J(this$5);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.withZoneSameInstant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(zone) {
  $n(zone);
  var x = this.Ljava_time_ZonedDateTime__f_zone;
  if (((x === null) ? (zone === null) : $n(x).equals__O__Z(zone))) {
    return this;
  } else {
    var $x_2 = $m_Ljava_time_ZonedDateTime$();
    var $x_1 = $n(this.Ljava_time_ZonedDateTime__f_dateTime).toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_ZonedDateTime__f_offset);
    var this$1 = $n(this.Ljava_time_ZonedDateTime__f_dateTime);
    var this$2 = $n(this$1.Ljava_time_LocalDateTime__f_time);
    return $x_2.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($x_1.l, $x_1.h, this$2.Ljava_time_LocalTime__f_nano, zone);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === f);
    }
    if ($x_1) {
      var $x_2 = $m_Ljava_time_ZonedDateTime$();
      var this$2 = $n(this.Ljava_time_ZonedDateTime__f_dateTime);
      var this$3 = $n(this$2.Ljava_time_LocalDateTime__f_time);
      return $x_2.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(newValue_$_lo, newValue_$_hi, this$3.Ljava_time_LocalTime__f_nano, this.Ljava_time_ZonedDateTime__f_zone);
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if ((x$3 === null)) {
        var $x_3 = (f === null);
      } else {
        var this$4 = $n(x$3);
        var $x_3 = (this$4 === f);
      }
      if ($x_3) {
        var $x_4 = $m_Ljava_time_ZoneOffset$();
        var this$5 = $n(f);
        return $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this, $x_4.ofTotalSeconds__I__Ljava_time_ZoneOffset($n(this$5.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue_$_lo, newValue_$_hi, this$5)));
      } else {
        var newDateTime = $n(this.Ljava_time_ZonedDateTime__f_dateTime).with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue_$_lo, newValue_$_hi);
        return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset);
      }
    }
  } else {
    var this$6 = $n(field);
    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime(this$6, newValue_$_lo, newValue_$_hi);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  if ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery())) {
    var this$1 = $n(this.Ljava_time_ZonedDateTime__f_dateTime);
    return this$1.Ljava_time_LocalDateTime__f_date;
  } else {
    return $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O(this, query);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_ZonedDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZonedDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    end = $n(end).withZoneSameInstant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(this.Ljava_time_ZonedDateTime__f_zone);
    if ($n(unit).isDateBased__Z()) {
      return $n(this.Ljava_time_ZonedDateTime__f_dateTime).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J($n(end).Ljava_time_ZonedDateTime__f_dateTime, unit);
    } else {
      var dateTime = this.Ljava_time_ZonedDateTime__f_dateTime;
      var offset = this.Ljava_time_ZonedDateTime__f_offset;
      var $x_1 = new $c_Ljava_time_OffsetDateTime(dateTime, offset);
      var this$2 = $n(end);
      var dateTime$1 = this$2.Ljava_time_ZonedDateTime__f_dateTime;
      var offset$1 = this$2.Ljava_time_ZonedDateTime__f_offset;
      return $x_1.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(new $c_Ljava_time_OffsetDateTime(dateTime$1, offset$1), unit);
    }
  } else {
    var this$4 = $n(unit);
    var temporal2 = end;
    return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(temporal2, this$4);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZonedDateTime)) {
    var other = $as_Ljava_time_ZonedDateTime(obj);
    if ((this === other)) {
      return true;
    } else {
      var x = this.Ljava_time_ZonedDateTime__f_dateTime;
      var x$2 = $n(other).Ljava_time_ZonedDateTime__f_dateTime;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_ZonedDateTime__f_offset;
        var x$4 = $n(other).Ljava_time_ZonedDateTime__f_offset;
        var $x_1 = ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var x$5 = this.Ljava_time_ZonedDateTime__f_zone;
        var x$6 = $n(other).Ljava_time_ZonedDateTime__f_zone;
        return ((x$5 === null) ? (x$6 === null) : $n(x$5).equals__O__Z(x$6));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_ZonedDateTime.prototype.hashCode__I = (function() {
  var $x_2 = $n(this.Ljava_time_ZonedDateTime__f_dateTime).hashCode__I();
  var this$1 = $n(this.Ljava_time_ZonedDateTime__f_offset);
  var $x_1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var i = $n(this.Ljava_time_ZonedDateTime__f_zone).hashCode__I();
  return (($x_2 ^ $x_1) ^ ((i << 3) | ((i >>> 29) | 0)));
});
$c_Ljava_time_ZonedDateTime.prototype.toString__T = (function() {
  var str = (("" + $n(this.Ljava_time_ZonedDateTime__f_dateTime).toString__T()) + $n(this.Ljava_time_ZonedDateTime__f_offset).Ljava_time_ZoneOffset__f_id);
  if ((this.Ljava_time_ZonedDateTime__f_offset !== this.Ljava_time_ZonedDateTime__f_zone)) {
    str = ((str + ("[" + this.Ljava_time_ZonedDateTime__f_zone)) + "]");
  }
  return str;
});
$c_Ljava_time_ZonedDateTime.prototype.compareTo__O__I = (function(that) {
  var other = $as_Ljava_time_chrono_ChronoZonedDateTime(that);
  return $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I(this, other);
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime(field, newValue_$_lo, newValue_$_hi);
});
$c_Ljava_time_ZonedDateTime.prototype.compare__O__I = (function(that) {
  var other = $as_Ljava_time_chrono_ChronoZonedDateTime(that);
  return $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I(this, other);
});
function $as_Ljava_time_ZonedDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_ZonedDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.ZonedDateTime"));
}
function $isArrayOf_Ljava_time_ZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZonedDateTime)));
}
function $asArrayOf_Ljava_time_ZonedDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_ZonedDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.ZonedDateTime;", depth));
}
var $d_Ljava_time_ZonedDateTime = new $TypeData().initClass($c_Ljava_time_ZonedDateTime, "java.time.ZonedDateTime", ({
  Ljava_time_ZonedDateTime: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_time_chrono_ChronoZonedDateTime: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Ljava_time_format_ResolverStyle() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
$c_Ljava_time_format_ResolverStyle.prototype = new $h_jl_Enum();
$c_Ljava_time_format_ResolverStyle.prototype.constructor = $c_Ljava_time_format_ResolverStyle;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle() {
}
$h_Ljava_time_format_ResolverStyle.prototype = $c_Ljava_time_format_ResolverStyle.prototype;
$c_Ljava_time_format_ResolverStyle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
class $c_ju_DuplicateFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_DuplicateFormatFlagsException__f_f = null;
    this.ju_DuplicateFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    $n(f);
  }
  getMessage__T() {
    return (("Flags = '" + this.ju_DuplicateFormatFlagsException__f_f) + "'");
  }
}
var $d_ju_DuplicateFormatFlagsException = new $TypeData().initClass($c_ju_DuplicateFormatFlagsException, "java.util.DuplicateFormatFlagsException", ({
  ju_DuplicateFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_FormatFlagsConversionMismatchException extends $c_ju_IllegalFormatException {
  constructor(f, c) {
    super();
    this.ju_FormatFlagsConversionMismatchException__f_f = null;
    this.ju_FormatFlagsConversionMismatchException__f_c = 0;
    this.ju_FormatFlagsConversionMismatchException__f_f = f;
    this.ju_FormatFlagsConversionMismatchException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    $n(f);
  }
  getMessage__T() {
    return ((("Conversion = " + $cToS(this.ju_FormatFlagsConversionMismatchException__f_c)) + ", Flags = ") + this.ju_FormatFlagsConversionMismatchException__f_f);
  }
}
var $d_ju_FormatFlagsConversionMismatchException = new $TypeData().initClass($c_ju_FormatFlagsConversionMismatchException, "java.util.FormatFlagsConversionMismatchException", ({
  ju_FormatFlagsConversionMismatchException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatArgumentIndexException extends $c_ju_IllegalFormatException {
  constructor(msg) {
    super();
    this.ju_IllegalFormatArgumentIndexException__f_msg = null;
    this.ju_IllegalFormatArgumentIndexException__f_msg = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return this.ju_IllegalFormatArgumentIndexException__f_msg;
  }
}
var $d_ju_IllegalFormatArgumentIndexException = new $TypeData().initClass($c_ju_IllegalFormatArgumentIndexException, "java.util.IllegalFormatArgumentIndexException", ({
  ju_IllegalFormatArgumentIndexException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatCodePointException extends $c_ju_IllegalFormatException {
  constructor(c) {
    super();
    this.ju_IllegalFormatCodePointException__f_c = 0;
    this.ju_IllegalFormatCodePointException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var i = this.ju_IllegalFormatCodePointException__f_c;
    return ("Code point = 0x" + $as_T((i >>> 0.0).toString(16)));
  }
}
var $d_ju_IllegalFormatCodePointException = new $TypeData().initClass($c_ju_IllegalFormatCodePointException, "java.util.IllegalFormatCodePointException", ({
  ju_IllegalFormatCodePointException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(c, arg) {
    super();
    this.ju_IllegalFormatConversionException__f_c = 0;
    this.ju_IllegalFormatConversionException__f_arg = null;
    this.ju_IllegalFormatConversionException__f_c = c;
    this.ju_IllegalFormatConversionException__f_arg = arg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    $n(arg);
  }
  getMessage__T() {
    var this$1 = this.ju_IllegalFormatConversionException__f_c;
    var this$3 = $n(this.ju_IllegalFormatConversionException__f_arg);
    return ((("" + $cToS(this$1)) + " != ") + this$3.data.name);
  }
}
var $d_ju_IllegalFormatConversionException = new $TypeData().initClass($c_ju_IllegalFormatConversionException, "java.util.IllegalFormatConversionException", ({
  ju_IllegalFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_IllegalFormatFlagsException__f_f = null;
    this.ju_IllegalFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    $n(f);
  }
  getMessage__T() {
    return (("Flags = '" + this.ju_IllegalFormatFlagsException__f_f) + "'");
  }
}
var $d_ju_IllegalFormatFlagsException = new $TypeData().initClass($c_ju_IllegalFormatFlagsException, "java.util.IllegalFormatFlagsException", ({
  ju_IllegalFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatPrecisionException extends $c_ju_IllegalFormatException {
  constructor(p) {
    super();
    this.ju_IllegalFormatPrecisionException__f_p = 0;
    this.ju_IllegalFormatPrecisionException__f_p = p;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var i = this.ju_IllegalFormatPrecisionException__f_p;
    return ("" + i);
  }
}
var $d_ju_IllegalFormatPrecisionException = new $TypeData().initClass($c_ju_IllegalFormatPrecisionException, "java.util.IllegalFormatPrecisionException", ({
  ju_IllegalFormatPrecisionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_IllegalFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(w) {
    super();
    this.ju_IllegalFormatWidthException__f_w = 0;
    this.ju_IllegalFormatWidthException__f_w = w;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var i = this.ju_IllegalFormatWidthException__f_w;
    return ("" + i);
  }
}
var $d_ju_IllegalFormatWidthException = new $TypeData().initClass($c_ju_IllegalFormatWidthException, "java.util.IllegalFormatWidthException", ({
  ju_IllegalFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
function $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = $thiz.ju_LinkedHashMap__f_youngest;
  if ((older !== null)) {
    $n(older).ju_LinkedHashMap$Node__f_younger = node;
  } else {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = node;
  }
  $n(node).ju_LinkedHashMap$Node__f_older = older;
  $n(node).ju_LinkedHashMap$Node__f_younger = null;
  $thiz.ju_LinkedHashMap__f_youngest = node;
}
function $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = $n(node).ju_LinkedHashMap$Node__f_older;
  var younger = $n(node).ju_LinkedHashMap$Node__f_younger;
  if ((older === null)) {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = younger;
  } else {
    $n(older).ju_LinkedHashMap$Node__f_younger = younger;
  }
  if ((younger === null)) {
    $thiz.ju_LinkedHashMap__f_youngest = older;
  } else {
    $n(younger).ju_LinkedHashMap$Node__f_older = older;
  }
}
function $ct_ju_LinkedHashMap__I__F__Z__($thiz, initialCapacity, loadFactor, accessOrder) {
  $thiz.ju_LinkedHashMap__f_accessOrder = accessOrder;
  $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor);
  return $thiz;
}
function $ct_ju_LinkedHashMap__($thiz) {
  $ct_ju_LinkedHashMap__I__F__Z__($thiz, 16, 0.75, false);
  return $thiz;
}
/** @constructor */
function $c_ju_LinkedHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  this.ju_LinkedHashMap__f_accessOrder = false;
  this.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = null;
  this.ju_LinkedHashMap__f_youngest = null;
}
$c_ju_LinkedHashMap.prototype = new $h_ju_HashMap();
$c_ju_LinkedHashMap.prototype.constructor = $c_ju_LinkedHashMap;
/** @constructor */
function $h_ju_LinkedHashMap() {
}
$h_ju_LinkedHashMap.prototype = $c_ju_LinkedHashMap.prototype;
$c_ju_LinkedHashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return new $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, null, null);
});
$c_ju_LinkedHashMap.prototype.nodeWasAccessed__ju_HashMap$Node__V = (function(node) {
  if (this.ju_LinkedHashMap__f_accessOrder) {
    var myNode = $as_ju_LinkedHashMap$Node(node);
    if (($n(myNode).ju_LinkedHashMap$Node__f_younger !== null)) {
      $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, myNode);
      $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, myNode);
    }
  }
});
$c_ju_LinkedHashMap.prototype.nodeWasAdded__ju_HashMap$Node__V = (function(node) {
  $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, $as_ju_LinkedHashMap$Node(node));
});
$c_ju_LinkedHashMap.prototype.nodeWasRemoved__ju_HashMap$Node__V = (function(node) {
  $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, $as_ju_LinkedHashMap$Node(node));
});
$c_ju_LinkedHashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_LinkedHashMap$NodeIterator(this);
});
$c_ju_LinkedHashMap.prototype.valueIterator__ju_Iterator = (function() {
  return new $c_ju_LinkedHashMap$ValueIterator(this);
});
var $d_ju_LinkedHashMap = new $TypeData().initClass($c_ju_LinkedHashMap, "java.util.LinkedHashMap", ({
  ju_LinkedHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1,
  ju_SequencedMap: 1
}));
/** @constructor */
function $c_ju_Locale$Category() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
$c_ju_Locale$Category.prototype = new $h_jl_Enum();
$c_ju_Locale$Category.prototype.constructor = $c_ju_Locale$Category;
/** @constructor */
function $h_ju_Locale$Category() {
}
$h_ju_Locale$Category.prototype = $c_ju_Locale$Category.prototype;
$c_ju_Locale$Category.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $as_ju_Locale$Category(obj) {
  return (((obj instanceof $c_ju_Locale$Category) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Locale$Category"));
}
function $isArrayOf_ju_Locale$Category(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale$Category)));
}
function $asArrayOf_ju_Locale$Category(obj, depth) {
  return (($isArrayOf_ju_Locale$Category(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Locale$Category;", depth));
}
var $d_ju_Locale$Category = new $TypeData().initClass(0, "java.util.Locale$Category", ({
  ju_Locale$Category: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
}));
class $c_ju_MissingFormatArgumentException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatArgumentException__f_s = null;
    this.ju_MissingFormatArgumentException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    $n(s);
  }
  getMessage__T() {
    return (("Format specifier '" + this.ju_MissingFormatArgumentException__f_s) + "'");
  }
}
var $d_ju_MissingFormatArgumentException = new $TypeData().initClass($c_ju_MissingFormatArgumentException, "java.util.MissingFormatArgumentException", ({
  ju_MissingFormatArgumentException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_MissingFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatWidthException__f_s = null;
    this.ju_MissingFormatWidthException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    $n(s);
  }
  getMessage__T() {
    return this.ju_MissingFormatWidthException__f_s;
  }
}
var $d_ju_MissingFormatWidthException = new $TypeData().initClass($c_ju_MissingFormatWidthException, "java.util.MissingFormatWidthException", ({
  ju_MissingFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
class $c_ju_UnknownFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_UnknownFormatConversionException__f_s = null;
    this.ju_UnknownFormatConversionException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    $n(s);
  }
  getMessage__T() {
    return (("Conversion = '" + this.ju_UnknownFormatConversionException__f_s) + "'");
  }
}
var $d_ju_UnknownFormatConversionException = new $TypeData().initClass($c_ju_UnknownFormatConversionException, "java.util.UnknownFormatConversionException", ({
  ju_UnknownFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor) {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  $ct_ju_HashMap__I__F__(this, initialCapacity, loadFactor);
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = new $h_ju_NullRejectingHashMap();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap() {
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(this);
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.valueIterator__ju_Iterator = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator(this);
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList = (function() {
  var snapshot = $ct_ju_ArrayList__I__(new $c_ju_ArrayList(), this.ju_HashMap__f_contentSize);
  var iter = new $c_ju_HashMap$NodeIterator(this);
  while (iter.hasNext__Z()) {
    snapshot.add__O__Z(iter.next__O());
  }
  return snapshot;
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$InnerHashMap, "java.util.concurrent.ConcurrentHashMap$InnerHashMap", ({
  ju_concurrent_ConcurrentHashMap$InnerHashMap: 1,
  ju_NullRejectingHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcB$sp(xs$mcB$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = xs$mcB$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcB$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcB$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next$mcB$sp__B = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next__O = (function() {
  return this.next$mcB$sp__B();
});
var $d_sc_ArrayOps$ArrayIterator$mcB$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcB$sp, "scala.collection.ArrayOps$ArrayIterator$mcB$sp", ({
  sc_ArrayOps$ArrayIterator$mcB$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcC$sp(xs$mcC$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = xs$mcC$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcC$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcC$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next$mcC$sp__C = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next__O = (function() {
  return $bC(this.next$mcC$sp__C());
});
var $d_sc_ArrayOps$ArrayIterator$mcC$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcC$sp, "scala.collection.ArrayOps$ArrayIterator$mcC$sp", ({
  sc_ArrayOps$ArrayIterator$mcC$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcD$sp(xs$mcD$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = xs$mcD$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcD$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcD$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next$mcD$sp__D = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next__O = (function() {
  return this.next$mcD$sp__D();
});
var $d_sc_ArrayOps$ArrayIterator$mcD$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcD$sp, "scala.collection.ArrayOps$ArrayIterator$mcD$sp", ({
  sc_ArrayOps$ArrayIterator$mcD$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcF$sp(xs$mcF$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = xs$mcF$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcF$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcF$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next$mcF$sp__F = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next__O = (function() {
  return this.next$mcF$sp__F();
});
var $d_sc_ArrayOps$ArrayIterator$mcF$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcF$sp, "scala.collection.ArrayOps$ArrayIterator$mcF$sp", ({
  sc_ArrayOps$ArrayIterator$mcF$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcI$sp(xs$mcI$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = xs$mcI$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcI$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcI$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next$mcI$sp__I = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next__O = (function() {
  return this.next$mcI$sp__I();
});
var $d_sc_ArrayOps$ArrayIterator$mcI$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcI$sp, "scala.collection.ArrayOps$ArrayIterator$mcI$sp", ({
  sc_ArrayOps$ArrayIterator$mcI$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcJ$sp(xs$mcJ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = xs$mcJ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcJ$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcJ$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next$mcJ$sp__J = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= (($n(this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp).u.length >>> 1) | 0))) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var $x_1 = $n(this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp).u;
  var $x_2 = $aJCheckGet($x_1, this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  var r_$_lo = $x_1[$x_2];
  var r_$_hi = $x_1[(($x_2 + 1) | 0)];
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return $bL(r_$_lo, r_$_hi);
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next__O = (function() {
  return this.next$mcJ$sp__J();
});
var $d_sc_ArrayOps$ArrayIterator$mcJ$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcJ$sp, "scala.collection.ArrayOps$ArrayIterator$mcJ$sp", ({
  sc_ArrayOps$ArrayIterator$mcJ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcS$sp(xs$mcS$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = xs$mcS$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcS$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcS$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next$mcS$sp__S = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next__O = (function() {
  return this.next$mcS$sp__S();
});
var $d_sc_ArrayOps$ArrayIterator$mcS$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcS$sp, "scala.collection.ArrayOps$ArrayIterator$mcS$sp", ({
  sc_ArrayOps$ArrayIterator$mcS$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcV$sp(xs$mcV$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = xs$mcV$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcV$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcV$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next$mcV$sp__V = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  $n(this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next__O = (function() {
  this.next$mcV$sp__V();
});
var $d_sc_ArrayOps$ArrayIterator$mcV$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcV$sp, "scala.collection.ArrayOps$ArrayIterator$mcV$sp", ({
  sc_ArrayOps$ArrayIterator$mcV$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcZ$sp(xs$mcZ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = xs$mcZ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcZ$sp);
}
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcZ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcZ$sp() {
}
$h_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next$mcZ$sp__Z = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= $n(this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp).u.length)) {
    $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty).next__O();
  }
  var r = $n(this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp).get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next__O = (function() {
  return this.next$mcZ$sp__Z();
});
var $d_sc_ArrayOps$ArrayIterator$mcZ$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcZ$sp, "scala.collection.ArrayOps$ArrayIterator$mcZ$sp", ({
  sc_ArrayOps$ArrayIterator$mcZ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
function $f_sc_View__toString__T($thiz) {
  return ($thiz.className__T() + "(<not computed>)");
}
function $is_sc_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_View)));
}
function $as_sc_View(obj) {
  return (($is_sc_View(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.View"));
}
function $isArrayOf_sc_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_View)));
}
function $asArrayOf_sc_View(obj, depth) {
  return (($isArrayOf_sc_View(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.View;", depth));
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying = underlying;
}
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = new $h_ju_AbstractSet();
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper() {
}
$h_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.contains__O__Z = (function(o) {
  try {
    return $n(this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying).contains__O__Z(o);
  } catch (e) {
    if ((e instanceof $c_jl_ClassCastException)) {
      $as_jl_ClassCastException(e);
      return false;
    } else {
      throw e;
    }
  }
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.isEmpty__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying).isEmpty__Z();
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.size__I = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying).size__I();
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.iterator__ju_Iterator = (function() {
  return new $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1(this);
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper = new $TypeData().initClass($c_sc_convert_JavaCollectionWrappers$SetWrapper, "scala.collection.convert.JavaCollectionWrappers$SetWrapper", ({
  sc_convert_JavaCollectionWrappers$SetWrapper: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set2$$anon$1(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set2$$anon$1__f_$outer = null;
  $n(outer);
  this.sci_Set$Set2$$anon$1__f_$outer = outer;
  $ct_sci_Set$SetNIterator__I__(this, ($n(outer), 2));
}
$c_sci_Set$Set2$$anon$1.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set2$$anon$1.prototype.constructor = $c_sci_Set$Set2$$anon$1;
/** @constructor */
function $h_sci_Set$Set2$$anon$1() {
}
$h_sci_Set$Set2$$anon$1.prototype = $c_sci_Set$Set2$$anon$1.prototype;
$c_sci_Set$Set2$$anon$1.prototype.apply__I__O = (function(i) {
  return $n(this.sci_Set$Set2$$anon$1__f_$outer).scala$collection$immutable$Set$Set2$$getElem__I__O(i);
});
var $d_sci_Set$Set2$$anon$1 = new $TypeData().initClass($c_sci_Set$Set2$$anon$1, "scala.collection.immutable.Set$Set2$$anon$1", ({
  sci_Set$Set2$$anon$1: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set3$$anon$2(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set3$$anon$2__f_$outer = null;
  $n(outer);
  this.sci_Set$Set3$$anon$2__f_$outer = outer;
  $ct_sci_Set$SetNIterator__I__(this, ($n(outer), 3));
}
$c_sci_Set$Set3$$anon$2.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set3$$anon$2.prototype.constructor = $c_sci_Set$Set3$$anon$2;
/** @constructor */
function $h_sci_Set$Set3$$anon$2() {
}
$h_sci_Set$Set3$$anon$2.prototype = $c_sci_Set$Set3$$anon$2.prototype;
$c_sci_Set$Set3$$anon$2.prototype.apply__I__O = (function(i) {
  return $n(this.sci_Set$Set3$$anon$2__f_$outer).scala$collection$immutable$Set$Set3$$getElem__I__O(i);
});
var $d_sci_Set$Set3$$anon$2 = new $TypeData().initClass($c_sci_Set$Set3$$anon$2, "scala.collection.immutable.Set$Set3$$anon$2", ({
  sci_Set$Set3$$anon$2: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set4$$anon$3(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set4$$anon$3__f_$outer = null;
  $n(outer);
  this.sci_Set$Set4$$anon$3__f_$outer = outer;
  $ct_sci_Set$SetNIterator__I__(this, ($n(outer), 4));
}
$c_sci_Set$Set4$$anon$3.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set4$$anon$3.prototype.constructor = $c_sci_Set$Set4$$anon$3;
/** @constructor */
function $h_sci_Set$Set4$$anon$3() {
}
$h_sci_Set$Set4$$anon$3.prototype = $c_sci_Set$Set4$$anon$3.prototype;
$c_sci_Set$Set4$$anon$3.prototype.apply__I__O = (function(i) {
  return $n(this.sci_Set$Set4$$anon$3__f_$outer).scala$collection$immutable$Set$Set4$$getElem__I__O(i);
});
var $d_sci_Set$Set4$$anon$3 = new $TypeData().initClass($c_sci_Set$Set4$$anon$3, "scala.collection.immutable.Set$Set4$$anon$3", ({
  sci_Set$Set4$$anon$3: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArrayBuilder$generic(elementClass) {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0;
  this.scm_ArrayBuilder$generic__f_elementClass = null;
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = false;
  this.scm_ArrayBuilder$generic__f_jsElems = null;
  this.scm_ArrayBuilder$generic__f_elementClass = elementClass;
  $ct_scm_ArrayBuilder__(this);
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  this.scm_ArrayBuilder$generic__f_jsElems = [];
}
$c_scm_ArrayBuilder$generic.prototype = new $h_scm_ArrayBuilder();
$c_scm_ArrayBuilder$generic.prototype.constructor = $c_scm_ArrayBuilder$generic;
/** @constructor */
function $h_scm_ArrayBuilder$generic() {
}
$h_scm_ArrayBuilder$generic.prototype = $c_scm_ArrayBuilder$generic.prototype;
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_ArrayBuilder$generic = (function(elem) {
  var unboxedElem = (this.scm_ArrayBuilder$generic__f_isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(this.scm_ArrayBuilder$generic__f_elementClass).data.zero : elem));
  this.scm_ArrayBuilder$generic__f_jsElems.push(unboxedElem);
  return this;
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_ArrayBuilder$generic = (function(xs) {
  var it = $n(xs).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    this.addOne__O__scm_ArrayBuilder$generic(elem);
  }
  return this;
});
$c_scm_ArrayBuilder$generic.prototype.resize__I__V = (function(size) {
});
$c_scm_ArrayBuilder$generic.prototype.result__O = (function() {
  var x$2 = this.scm_ArrayBuilder$generic__f_elementClass;
  if ((x$2 === $d_V.getClassOf())) {
    var elemRuntimeClass = $d_jl_Void.getClassOf();
  } else {
    var x$4 = this.scm_ArrayBuilder$generic__f_elementClass;
    if ((x$4 === $d_sr_Null$.getClassOf())) {
      var $x_1 = true;
    } else {
      var x$6 = this.scm_ArrayBuilder$generic__f_elementClass;
      var $x_1 = (x$6 === $d_sr_Nothing$.getClassOf());
    }
    if ($x_1) {
      var elemRuntimeClass = $d_O.getClassOf();
    } else {
      var elemRuntimeClass = this.scm_ArrayBuilder$generic__f_elementClass;
    }
  }
  return $n(elemRuntimeClass).data.getArrayOf().wrapArray(this.scm_ArrayBuilder$generic__f_jsElems);
});
$c_scm_ArrayBuilder$generic.prototype.toString__T = (function() {
  return "ArrayBuilder.generic";
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuilder$generic(elems);
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuilder$generic(elem);
});
var $d_scm_ArrayBuilder$generic = new $TypeData().initClass($c_scm_ArrayBuilder$generic, "scala.collection.mutable.ArrayBuilder$generic", ({
  scm_ArrayBuilder$generic: 1,
  scm_ArrayBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  Ljava_io_Serializable: 1
}));
function $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O($thiz, srcStart, dest, destStart, maxItems) {
  var until = ((1 + $m_jl_reflect_Array$().getLength__O__I(dest)) | 0);
  if (((destStart < 0) || (destStart >= until))) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(destStart, ((until - 1) | 0)));
  }
  var idx = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var a = ((((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n($thiz.scm_ArrayDeque__f_array).u.length - 1) | 0)) - srcStart) | 0);
  var b = (($m_jl_reflect_Array$().getLength__O__I(dest) - destStart) | 0);
  var b$1 = ((a < b) ? a : b);
  var toCopy = ((maxItems < b$1) ? maxItems : b$1);
  if ((toCopy > 0)) {
    var idx$1 = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var until$1 = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (($n($thiz.scm_ArrayDeque__f_array).u.length - 1) | 0));
    if (((srcStart < 0) || (srcStart >= until$1))) {
      throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(srcStart, ((until$1 - 1) | 0)));
    }
    var startIdx = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + srcStart) | 0) & (($n($thiz.scm_ArrayDeque__f_array).u.length - 1) | 0));
    var b$2 = (($n($thiz.scm_ArrayDeque__f_array).u.length - startIdx) | 0);
    var block1 = ((toCopy < b$2) ? toCopy : b$2);
    $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, startIdx, dest, destStart, block1);
    var block2 = ((toCopy - block1) | 0);
    if ((block2 > 0)) {
      $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, 0, dest, ((destStart + block1) | 0), block2);
    }
  }
  return dest;
}
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(this, self);
  var this$1 = $n(mutationCount);
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = $uI(this$1.apply__O());
}
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewIterator();
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedIterator() {
}
$h_scm_CheckedIndexedSeqView$CheckedIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount;
  var this$1 = $n(this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount);
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedIterator = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$CheckedIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedIterator", ({
  scm_CheckedIndexedSeqView$CheckedIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(this, self);
  var this$1 = $n(mutationCount);
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = $uI(this$1.apply__O());
}
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator();
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedReverseIterator() {
}
$h_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount;
  var this$1 = $n(this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount);
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedReverseIterator = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$CheckedReverseIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedReverseIterator", ({
  scm_CheckedIndexedSeqView$CheckedReverseIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
class $c_s_concurrent_Future$$anon$1 extends $c_ju_NoSuchElementException {
  constructor(t$2) {
    super();
    var s = ("Future.collect partial function is not defined at: " + t$2);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$1 = new $TypeData().initClass($c_s_concurrent_Future$$anon$1, "scala.concurrent.Future$$anon$1", ({
  s_concurrent_Future$$anon$1: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
class $c_s_concurrent_Future$$anon$2 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.filter predicate is not satisfied", null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$2 = new $TypeData().initClass($c_s_concurrent_Future$$anon$2, "scala.concurrent.Future$$anon$2", ({
  s_concurrent_Future$$anon$2: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
class $c_s_concurrent_Future$$anon$3 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.failed not completed with a throwable.", null, true, true);
  }
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this);
  }
}
var $d_s_concurrent_Future$$anon$3 = new $TypeData().initClass($c_s_concurrent_Future$$anon$3, "scala.concurrent.Future$$anon$3", ({
  s_concurrent_Future$$anon$3: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
}));
function $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($thiz) {
  var _$this = $thiz;
  while (true) {
    var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return $as_s_util_Try(state);
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
    } else {
      return null;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, state, callbacks) {
  var _$this = $thiz;
  while (true) {
    if ((state instanceof $c_s_util_Try)) {
      $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($n(_$this), callbacks, $as_s_util_Try(state));
      return callbacks;
    } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if ($n(_$this).compareAndSet__O__O__Z(state, ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop) ? $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($n(_$this), callbacks, $as_s_concurrent_impl_Promise$Callbacks(state)) : callbacks))) {
        return callbacks;
      } else {
        state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
      }
    } else {
      var p = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      var temp$state$2 = $n(p).ju_concurrent_atomic_AtomicReference__f_value;
      _$this = p;
      state = temp$state$2;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, left, right) {
  while (true) {
    if ((left instanceof $c_s_concurrent_impl_Promise$Transformation)) {
      return new $c_s_concurrent_impl_Promise$ManyCallbacks($as_s_concurrent_impl_Promise$Transformation(left), right);
    } else {
      var m = $as_s_concurrent_impl_Promise$ManyCallbacks(left);
      var temp$left = $n(m).s_concurrent_impl_Promise$ManyCallbacks__f_rest;
      var temp$right = new $c_s_concurrent_impl_Promise$ManyCallbacks($n(m).s_concurrent_impl_Promise$ManyCallbacks__f_first, right);
      left = temp$left;
      right = temp$right;
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($thiz, callbacks, resolved) {
  while (true) {
    if ((callbacks instanceof $c_s_concurrent_impl_Promise$ManyCallbacks)) {
      var m = $as_s_concurrent_impl_Promise$ManyCallbacks(callbacks);
      $n($n(m).s_concurrent_impl_Promise$ManyCallbacks__f_first).submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved);
      callbacks = $n(m).s_concurrent_impl_Promise$ManyCallbacks__f_rest;
      continue;
    } else {
      $n($as_s_concurrent_impl_Promise$Transformation(callbacks)).submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved);
    }
    return (void 0);
  }
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, initial) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, initial);
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__($thiz, result) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(result));
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop);
  return $thiz;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$DefaultPromise() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
}
$c_s_concurrent_impl_Promise$DefaultPromise.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.constructor = $c_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $h_s_concurrent_impl_Promise$DefaultPromise() {
}
$h_s_concurrent_impl_Promise$DefaultPromise.prototype = $c_s_concurrent_impl_Promise$DefaultPromise.prototype;
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  $as_s_util_Try(v1);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.onComplete__F1__s_concurrent_ExecutionContext__V = (function(func, executor) {
  $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ju_concurrent_atomic_AtomicReference__f_value, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, func, executor));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.toString__T = (function() {
  var _$this = this;
  while (true) {
    var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return (("Future(" + state) + ")");
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
    } else {
      return "Future(<not completed>)";
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete__s_util_Try__Z = (function(value) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Try)) && this.tryComplete0__O__s_util_Try__Z(state, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(value)));
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete0__O__s_util_Try__Z = (function(state, resolved) {
  var _$this = this;
  while (true) {
    if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if ((!$n(_$this).compareAndSet__O__O__Z(state, resolved))) {
        state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
        continue;
      }
      if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
        $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($n(_$this), $as_s_concurrent_impl_Promise$Callbacks(state), resolved);
      }
      return true;
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var p = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      if ((p !== _$this)) {
        var temp$state$2 = $n(p).ju_concurrent_atomic_AtomicReference__f_value;
        _$this = p;
        state = temp$state$2;
        continue;
      }
      return false;
    } else {
      return false;
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise = (function(other) {
  if ((other !== this)) {
    var state = this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((!(state instanceof $c_s_util_Try))) {
      if ((other instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
        var resolved = $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($n($as_s_concurrent_impl_Promise$DefaultPromise(other)));
      } else {
        var this$1 = $n(other);
        var this$3 = $n($m_s_Option$().apply__O__s_Option($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(this$1)));
        var this$2 = $m_s_$less$colon$less$();
        var ev = this$2.s_$less$colon$less$__f_singleton;
        var resolved = $as_s_util_Try((this$3.isEmpty__Z() ? ($n(ev), null) : this$3.get__O()));
      }
      if ((resolved !== null)) {
        this.tryComplete0__O__s_util_Try__Z(state, resolved);
      } else {
        $n(other).onComplete__F1__s_concurrent_ExecutionContext__V(this, $m_s_concurrent_ExecutionContext$parasitic$());
      }
    }
  }
  return this;
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V = (function(target, link) {
  var _$this = this;
  while (true) {
    if ((_$this !== target)) {
      var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
      if ((state instanceof $c_s_util_Try)) {
        if ((!$n(target).tryComplete0__O__s_util_Try__Z($n(target).ju_concurrent_atomic_AtomicReference__f_value, $as_s_util_Try(state)))) {
          throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot link completed promises together");
        }
      } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
        var l = ((link !== null) ? link : new $c_s_concurrent_impl_Promise$Link(target));
        var p = $n(l).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        if (((_$this !== p) && $n(_$this).compareAndSet__O__O__Z(state, l))) {
          if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
            $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($n(p), $n(p).ju_concurrent_atomic_AtomicReference__f_value, $as_s_concurrent_impl_Promise$Callbacks(state));
          }
        } else {
          target = p;
          link = l;
          continue;
        }
      } else {
        _$this = $n($as_s_concurrent_impl_Promise$Link(state)).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        continue;
      }
    }
    break;
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.unlink__s_util_Try__V = (function(resolved) {
  var _$this = this;
  while (true) {
    var state = $n(_$this).ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var next = ($n(_$this).compareAndSet__O__O__Z(state, resolved) ? $as_s_concurrent_impl_Promise$DefaultPromise($n($as_s_concurrent_impl_Promise$Link(state)).ju_concurrent_atomic_AtomicReference__f_value) : _$this);
      _$this = next;
      continue;
    } else {
      $n(_$this).tryComplete0__O__s_util_Try__Z(state, resolved);
    }
    break;
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply__O__O = (function(v1) {
  var resolved = $as_s_util_Try(v1);
  this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolved);
});
function $as_s_concurrent_impl_Promise$DefaultPromise(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$DefaultPromise) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$DefaultPromise"));
}
function $isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$DefaultPromise)));
}
function $asArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$DefaultPromise;", depth));
}
var $d_s_concurrent_impl_Promise$DefaultPromise = new $TypeData().initClass($c_s_concurrent_impl_Promise$DefaultPromise, "scala.concurrent.impl.Promise$DefaultPromise", ({
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1
}));
function $is_s_math_Integral(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Integral)));
}
function $as_s_math_Integral(obj) {
  return (($is_s_math_Integral(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Integral"));
}
function $isArrayOf_s_math_Integral(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Integral)));
}
function $asArrayOf_s_math_Integral(obj, depth) {
  return (($isArrayOf_s_math_Integral(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Integral;", depth));
}
/** @constructor */
function $c_s_math_Ordering$Boolean$() {
}
$c_s_math_Ordering$Boolean$.prototype = new $h_O();
$c_s_math_Ordering$Boolean$.prototype.constructor = $c_s_math_Ordering$Boolean$;
/** @constructor */
function $h_s_math_Ordering$Boolean$() {
}
$h_s_math_Ordering$Boolean$.prototype = $c_s_math_Ordering$Boolean$.prototype;
$c_s_math_Ordering$Boolean$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Boolean$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uZ(x);
  var y$1 = $uZ(y);
  return ((x$1 === y$1) ? 0 : (x$1 ? 1 : (-1)));
});
var $d_s_math_Ordering$Boolean$ = new $TypeData().initClass($c_s_math_Ordering$Boolean$, "scala.math.Ordering$Boolean$", ({
  s_math_Ordering$Boolean$: 1,
  s_math_Ordering$BooleanOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Boolean$;
function $m_s_math_Ordering$Boolean$() {
  if ((!$n_s_math_Ordering$Boolean$)) {
    $n_s_math_Ordering$Boolean$ = new $c_s_math_Ordering$Boolean$();
  }
  return $n_s_math_Ordering$Boolean$;
}
/** @constructor */
function $c_s_math_Ordering$Byte$() {
}
$c_s_math_Ordering$Byte$.prototype = new $h_O();
$c_s_math_Ordering$Byte$.prototype.constructor = $c_s_math_Ordering$Byte$;
/** @constructor */
function $h_s_math_Ordering$Byte$() {
}
$h_s_math_Ordering$Byte$.prototype = $c_s_math_Ordering$Byte$.prototype;
$c_s_math_Ordering$Byte$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Byte$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Ordering$Byte$ = new $TypeData().initClass($c_s_math_Ordering$Byte$, "scala.math.Ordering$Byte$", ({
  s_math_Ordering$Byte$: 1,
  s_math_Ordering$ByteOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Byte$;
function $m_s_math_Ordering$Byte$() {
  if ((!$n_s_math_Ordering$Byte$)) {
    $n_s_math_Ordering$Byte$ = new $c_s_math_Ordering$Byte$();
  }
  return $n_s_math_Ordering$Byte$;
}
/** @constructor */
function $c_s_math_Ordering$Char$() {
}
$c_s_math_Ordering$Char$.prototype = new $h_O();
$c_s_math_Ordering$Char$.prototype.constructor = $c_s_math_Ordering$Char$;
/** @constructor */
function $h_s_math_Ordering$Char$() {
}
$h_s_math_Ordering$Char$.prototype = $c_s_math_Ordering$Char$.prototype;
$c_s_math_Ordering$Char$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Char$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Ordering$Char$ = new $TypeData().initClass($c_s_math_Ordering$Char$, "scala.math.Ordering$Char$", ({
  s_math_Ordering$Char$: 1,
  s_math_Ordering$CharOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Char$;
function $m_s_math_Ordering$Char$() {
  if ((!$n_s_math_Ordering$Char$)) {
    $n_s_math_Ordering$Char$ = new $c_s_math_Ordering$Char$();
  }
  return $n_s_math_Ordering$Char$;
}
/** @constructor */
function $c_s_math_Ordering$Long$() {
}
$c_s_math_Ordering$Long$.prototype = new $h_O();
$c_s_math_Ordering$Long$.prototype.constructor = $c_s_math_Ordering$Long$;
/** @constructor */
function $h_s_math_Ordering$Long$() {
}
$h_s_math_Ordering$Long$.prototype = $c_s_math_Ordering$Long$.prototype;
$c_s_math_Ordering$Long$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Long$.prototype.compare__O__O__I = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return ((x$1_$_hi === y$1_$_hi) ? ((x$1_$_lo === y$1_$_lo) ? 0 : (((x$1_$_lo >>> 0) < (y$1_$_lo >>> 0)) ? (-1) : 1)) : ((x$1_$_hi < y$1_$_hi) ? (-1) : 1));
});
var $d_s_math_Ordering$Long$ = new $TypeData().initClass($c_s_math_Ordering$Long$, "scala.math.Ordering$Long$", ({
  s_math_Ordering$Long$: 1,
  s_math_Ordering$LongOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Long$;
function $m_s_math_Ordering$Long$() {
  if ((!$n_s_math_Ordering$Long$)) {
    $n_s_math_Ordering$Long$ = new $c_s_math_Ordering$Long$();
  }
  return $n_s_math_Ordering$Long$;
}
/** @constructor */
function $c_s_math_Ordering$Short$() {
}
$c_s_math_Ordering$Short$.prototype = new $h_O();
$c_s_math_Ordering$Short$.prototype.constructor = $c_s_math_Ordering$Short$;
/** @constructor */
function $h_s_math_Ordering$Short$() {
}
$h_s_math_Ordering$Short$.prototype = $c_s_math_Ordering$Short$.prototype;
$c_s_math_Ordering$Short$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Short$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Ordering$Short$ = new $TypeData().initClass($c_s_math_Ordering$Short$, "scala.math.Ordering$Short$", ({
  s_math_Ordering$Short$: 1,
  s_math_Ordering$ShortOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$Short$;
function $m_s_math_Ordering$Short$() {
  if ((!$n_s_math_Ordering$Short$)) {
    $n_s_math_Ordering$Short$ = new $c_s_math_Ordering$Short$();
  }
  return $n_s_math_Ordering$Short$;
}
/** @constructor */
function $c_s_math_Ordering$String$() {
}
$c_s_math_Ordering$String$.prototype = new $h_O();
$c_s_math_Ordering$String$.prototype.constructor = $c_s_math_Ordering$String$;
/** @constructor */
function $h_s_math_Ordering$String$() {
}
$h_s_math_Ordering$String$.prototype = $c_s_math_Ordering$String$.prototype;
$c_s_math_Ordering$String$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$String$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_T(x);
  var y$1 = $as_T(y);
  return $f_T__compareTo__T__I($n(x$1), y$1);
});
var $d_s_math_Ordering$String$ = new $TypeData().initClass($c_s_math_Ordering$String$, "scala.math.Ordering$String$", ({
  s_math_Ordering$String$: 1,
  s_math_Ordering$StringOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
var $n_s_math_Ordering$String$;
function $m_s_math_Ordering$String$() {
  if ((!$n_s_math_Ordering$String$)) {
    $n_s_math_Ordering$String$ = new $c_s_math_Ordering$String$();
  }
  return $n_s_math_Ordering$String$;
}
/** @constructor */
function $c_s_reflect_AnyValManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_AnyValManifest.prototype = new $h_O();
$c_s_reflect_AnyValManifest.prototype.constructor = $c_s_reflect_AnyValManifest;
/** @constructor */
function $h_s_reflect_AnyValManifest() {
}
$h_s_reflect_AnyValManifest.prototype = $c_s_reflect_AnyValManifest.prototype;
$c_s_reflect_AnyValManifest.prototype.toString__T = (function() {
  return this.s_reflect_AnyValManifest__f_toString;
});
$c_s_reflect_AnyValManifest.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_s_reflect_AnyValManifest.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ClassTypeManifest() {
}
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype = new $h_O();
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ClassTypeManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ClassTypeManifest() {
}
$h_s_reflect_ManifestFactory$ClassTypeManifest.prototype = $c_s_reflect_ManifestFactory$ClassTypeManifest.prototype;
class $c_sjs_js_JavaScriptException extends $c_jl_RuntimeException {
  constructor(exception) {
    super();
    this.sjs_js_JavaScriptException__f_exception = null;
    this.sjs_js_JavaScriptException__f_exception = exception;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return $dp_toString__T($n(this.sjs_js_JavaScriptException__f_exception));
  }
  productPrefix__T() {
    return "JavaScriptException";
  }
  productArity__I() {
    return 1;
  }
  productElement__I__O(x$1) {
    return ((x$1 === 0) ? this.sjs_js_JavaScriptException__f_exception : $m_sr_Statics$().ioobe__I__O(x$1));
  }
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1744042595, true);
  }
  equals__O__Z(x$1) {
    if ((this === x$1)) {
      return true;
    } else if ((x$1 instanceof $c_sjs_js_JavaScriptException)) {
      var JavaScriptException$1 = $as_sjs_js_JavaScriptException(x$1);
      var x = this.sjs_js_JavaScriptException__f_exception;
      var y = $n(JavaScriptException$1).sjs_js_JavaScriptException__f_exception;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  }
}
function $as_sjs_js_JavaScriptException(obj) {
  return (((obj instanceof $c_sjs_js_JavaScriptException) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.JavaScriptException"));
}
function $isArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_JavaScriptException)));
}
function $asArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (($isArrayOf_sjs_js_JavaScriptException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.JavaScriptException;", depth));
}
var $d_sjs_js_JavaScriptException = new $TypeData().initClass($c_sjs_js_JavaScriptException, "scala.scalajs.js.JavaScriptException", ({
  sjs_js_JavaScriptException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
}));
function $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O($thiz, fga, evidence$1) {
  return $thiz.traverse__O__F1__Lcats_Applicative__O(fga, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ga) => ga)), evidence$1);
}
function $is_Lcats_Traverse(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Traverse)));
}
function $as_Lcats_Traverse(obj) {
  return (($is_Lcats_Traverse(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Traverse"));
}
function $isArrayOf_Lcats_Traverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Traverse)));
}
function $asArrayOf_Lcats_Traverse(obj, depth) {
  return (($isArrayOf_Lcats_Traverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Traverse;", depth));
}
function $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval($thiz, width$1, G$1, f$10, as$1, start, end) {
  if ((((end - start) | 0) <= width$1)) {
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(G$1).map__O__F1__O($n(f$10).apply__O__O($n(as$1).apply__I__O(((end - 1) | 0))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$5) => {
      var this$1 = $m_sci_Nil$();
      return new $c_sci_$colon$colon(_$5, this$1);
    })))));
    var flist = new $c_Lcats_Later(a);
    var idx = ((end - 2) | 0);
    while ((start <= idx)) {
      var a$1 = $n(as$1).apply__I__O(idx);
      var right = flist;
      $m_Lcats_Eval$();
      var a$2 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((G$1, f$10, a$1, right) => (() => $n(G$1).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f$10).apply__O__O(a$1), right, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$6, _$7) => {
        var _$7$1 = $as_sci_List(_$7);
        var this$3 = $n(_$7$1);
        return new $c_sci_$colon$colon(_$6, this$3);
      })))))(G$1, f$10, a$1, right));
      flist = new $c_Lcats_Eval$$anon$5(a$2);
      idx = ((idx - 1) | 0);
    }
    return $n(flist).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((glist) => $n(G$1).map__O__F1__O(glist, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => {
      var _$8$1 = $as_sci_List(_$8);
      var this$5 = $m_Lcats_data_Chain$();
      return $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$5, _$8$1);
    }))))));
  } else {
    var step = ((((end - start) | 0) / $checkIntDivisor(width$1)) | 0);
    $m_Lcats_Eval$();
    var a$3 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval($thiz, width$1, G$1, f$10, as$1, start, ((start + step) | 0))));
    var fchain = new $c_Lcats_Eval$$anon$5(a$3);
    var start0 = ((start + step) | 0);
    var end0 = ((start0 + step) | 0);
    while ((start0 < end)) {
      var y = end0;
      var end1 = ((end < y) ? end : y);
      var right$3 = $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval($thiz, width$1, G$1, f$10, as$1, start0, end1);
      fchain = $n(fchain).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((G$1, right$3) => ((_$9) => $n(G$1).map2Eval__O__Lcats_Eval__F2__Lcats_Eval(_$9, right$3, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$10, _$11) => {
        var _$10$1 = $as_Lcats_data_Chain(_$10);
        var _$11$1 = $as_Lcats_data_Chain(_$11);
        var this$10 = $n(_$10$1);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$10, _$11$1);
      })))))(G$1, right$3)));
      start0 = ((start0 + step) | 0);
      end0 = ((end0 + step) | 0);
    }
    return fchain;
  }
}
/** @constructor */
function $c_Lcats_data_Chain$() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = null;
  this.Lcats_data_Chain$__f_nil = null;
  $ct_Lcats_data_ChainInstances__(this);
  $n_Lcats_data_Chain$ = this;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = new $c_Lcats_data_Chain$$anon$2();
  this.Lcats_data_Chain$__f_nil = $m_Lcats_data_Chain$Empty$();
}
$c_Lcats_data_Chain$.prototype = new $h_Lcats_data_ChainInstances();
$c_Lcats_data_Chain$.prototype.constructor = $c_Lcats_data_Chain$;
/** @constructor */
function $h_Lcats_data_Chain$() {
}
$h_Lcats_data_Chain$.prototype = $c_Lcats_data_Chain$.prototype;
$c_Lcats_data_Chain$.prototype.concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain = (function(c, c2) {
  if ((c instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var non = $as_Lcats_data_Chain$NonEmpty(c);
    if ((c2 instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var non2 = $as_Lcats_data_Chain$NonEmpty(c2);
      return $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__(new $c_Lcats_data_Chain$Append(), non, non2);
    } else {
      return non;
    }
  } else {
    return c2;
  }
});
$c_Lcats_data_Chain$.prototype.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O = (function(as, f, G) {
  if ($n(as).isEmpty__Z()) {
    return $n(G).pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil);
  } else {
    var this$1 = $n(as);
    return $n($p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval(this, 128, G, f, as, 0, this$1.length__I())).value__O();
  }
});
var $d_Lcats_data_Chain$ = new $TypeData().initClass($c_Lcats_data_Chain$, "cats.data.Chain$", ({
  Lcats_data_Chain$: 1,
  Lcats_data_ChainInstances: 1,
  Lcats_data_ChainInstances1: 1,
  Lcats_data_ChainInstances2: 1,
  Lcats_data_ChainInstances3: 1,
  Lcats_data_ChainCompanionCompat: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_data_Chain$;
function $m_Lcats_data_Chain$() {
  if ((!$n_Lcats_data_Chain$)) {
    $n_Lcats_data_Chain$ = new $c_Lcats_data_Chain$();
  }
  return $n_Lcats_data_Chain$;
}
/** @constructor */
function $c_Lcats_data_KleisliInstances2() {
}
$c_Lcats_data_KleisliInstances2.prototype = new $h_Lcats_data_KleisliInstances3();
$c_Lcats_data_KleisliInstances2.prototype.constructor = $c_Lcats_data_KleisliInstances2;
/** @constructor */
function $h_Lcats_data_KleisliInstances2() {
}
$h_Lcats_data_KleisliInstances2.prototype = $c_Lcats_data_KleisliInstances2.prototype;
/** @constructor */
function $c_Lcats_data_Validated$() {
  this.Lcats_data_Validated$__f_validUnit = null;
  $ct_Lcats_data_ValidatedInstances__(this);
  $n_Lcats_data_Validated$ = this;
  this.Lcats_data_Validated$__f_validUnit = new $c_Lcats_data_Validated$Valid((void 0));
}
$c_Lcats_data_Validated$.prototype = new $h_Lcats_data_ValidatedInstances();
$c_Lcats_data_Validated$.prototype.constructor = $c_Lcats_data_Validated$;
/** @constructor */
function $h_Lcats_data_Validated$() {
}
$h_Lcats_data_Validated$.prototype = $c_Lcats_data_Validated$.prototype;
var $d_Lcats_data_Validated$ = new $TypeData().initClass($c_Lcats_data_Validated$, "cats.data.Validated$", ({
  Lcats_data_Validated$: 1,
  Lcats_data_ValidatedInstances: 1,
  Lcats_data_ValidatedInstances1: 1,
  Lcats_data_ValidatedInstances2: 1,
  Lcats_data_ValidatedFunctions: 1,
  Lcats_data_ValidatedFunctionsBinCompat0: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_data_Validated$;
function $m_Lcats_data_Validated$() {
  if ((!$n_Lcats_data_Validated$)) {
    $n_Lcats_data_Validated$ = new $c_Lcats_data_Validated$();
  }
  return $n_Lcats_data_Validated$;
}
/** @constructor */
function $c_Lcats_effect_SyncIO$RealTime$() {
}
$c_Lcats_effect_SyncIO$RealTime$.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$RealTime$.prototype.constructor = $c_Lcats_effect_SyncIO$RealTime$;
/** @constructor */
function $h_Lcats_effect_SyncIO$RealTime$() {
}
$h_Lcats_effect_SyncIO$RealTime$.prototype = $c_Lcats_effect_SyncIO$RealTime$.prototype;
$c_Lcats_effect_SyncIO$RealTime$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.hashCode__I = (function() {
  return (-795507285);
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productPrefix__T = (function() {
  return "RealTime";
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.tag__B = (function() {
  return 9;
});
var $d_Lcats_effect_SyncIO$RealTime$ = new $TypeData().initClass($c_Lcats_effect_SyncIO$RealTime$, "cats.effect.SyncIO$RealTime$", ({
  Lcats_effect_SyncIO$RealTime$: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_SyncIO$RealTime$;
function $m_Lcats_effect_SyncIO$RealTime$() {
  if ((!$n_Lcats_effect_SyncIO$RealTime$)) {
    $n_Lcats_effect_SyncIO$RealTime$ = new $c_Lcats_effect_SyncIO$RealTime$();
  }
  return $n_Lcats_effect_SyncIO$RealTime$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
}
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
}
$h_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.hashCode__I = (function() {
  return (-58529607);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.toString__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productPrefix__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Resource$ExitCase$Canceled$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$Canceled$, "cats.effect.kernel.Resource$ExitCase$Canceled$", ({
  Lcats_effect_kernel_Resource$ExitCase$Canceled$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
function $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$Canceled$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$ = new $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$();
  }
  return $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
}
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
}
$h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.hashCode__I = (function() {
  return (-1345265087);
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.toString__T = (function() {
  return "Succeeded";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productPrefix__T = (function() {
  return "Succeeded";
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$, "cats.effect.kernel.Resource$ExitCase$Succeeded$", ({
  Lcats_effect_kernel_Resource$ExitCase$Succeeded$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
function $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ = new $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
  }
  return $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Nil$2$() {
}
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Nil$2$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Nil$2$() {
}
$h_Lcats_effect_kernel_Resource$Nil$2$.prototype = $c_Lcats_effect_kernel_Resource$Nil$2$.prototype;
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.hashCode__I = (function() {
  return 78321;
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.toString__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productPrefix__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Nil$2$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Nil$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Nil$2$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Nil$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Nil$2$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Nil$2$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Nil$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Nil$2$;", depth));
}
var $d_Lcats_effect_kernel_Resource$Nil$2$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Nil$2$, "cats.effect.kernel.Resource$Nil$2$", ({
  Lcats_effect_kernel_Resource$Nil$2$: 1,
  Lcats_effect_kernel_Resource$Stack$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Nil$4$() {
}
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Nil$4$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Nil$4$() {
}
$h_Lcats_effect_kernel_Resource$Nil$4$.prototype = $c_Lcats_effect_kernel_Resource$Nil$4$.prototype;
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.hashCode__I = (function() {
  return 78321;
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.toString__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.productPrefix__T = (function() {
  return "Nil";
});
$c_Lcats_effect_kernel_Resource$Nil$4$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lcats_effect_kernel_Resource$Nil$4$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Nil$4$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Nil$4$"));
}
function $isArrayOf_Lcats_effect_kernel_Resource$Nil$4$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Nil$4$)));
}
function $asArrayOf_Lcats_effect_kernel_Resource$Nil$4$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Nil$4$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Nil$4$;", depth));
}
var $d_Lcats_effect_kernel_Resource$Nil$4$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$Nil$4$, "cats.effect.kernel.Resource$Nil$4$", ({
  Lcats_effect_kernel_Resource$Nil$4$: 1,
  Lcats_effect_kernel_Resource$Stack$2: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$Blocking$() {
}
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$Blocking$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$Blocking$() {
}
$h_Lcats_effect_kernel_Sync$Type$Blocking$.prototype = $c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype;
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.hashCode__I = (function() {
  return (-599928747);
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.toString__T = (function() {
  return "Blocking";
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productPrefix__T = (function() {
  return "Blocking";
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Sync$Type$Blocking$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$Blocking$, "cats.effect.kernel.Sync$Type$Blocking$", ({
  Lcats_effect_kernel_Sync$Type$Blocking$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Sync$Type$Blocking$;
function $m_Lcats_effect_kernel_Sync$Type$Blocking$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$Blocking$)) {
    $n_Lcats_effect_kernel_Sync$Type$Blocking$ = new $c_Lcats_effect_kernel_Sync$Type$Blocking$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$Blocking$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$Delay$() {
}
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$Delay$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$Delay$() {
}
$h_Lcats_effect_kernel_Sync$Type$Delay$.prototype = $c_Lcats_effect_kernel_Sync$Type$Delay$.prototype;
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.hashCode__I = (function() {
  return 65915235;
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.toString__T = (function() {
  return "Delay";
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productPrefix__T = (function() {
  return "Delay";
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Sync$Type$Delay$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$Delay$, "cats.effect.kernel.Sync$Type$Delay$", ({
  Lcats_effect_kernel_Sync$Type$Delay$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Sync$Type$Delay$;
function $m_Lcats_effect_kernel_Sync$Type$Delay$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$Delay$)) {
    $n_Lcats_effect_kernel_Sync$Type$Delay$ = new $c_Lcats_effect_kernel_Sync$Type$Delay$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$Delay$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
}
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
}
$h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype = $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype;
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.hashCode__I = (function() {
  return 430282004;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.toString__T = (function() {
  return "InterruptibleMany";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productPrefix__T = (function() {
  return "InterruptibleMany";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$, "cats.effect.kernel.Sync$Type$InterruptibleMany$", ({
  Lcats_effect_kernel_Sync$Type$InterruptibleMany$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
function $m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$)) {
    $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ = new $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
}
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
}
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
}
$h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype = $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype;
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.hashCode__I = (function() {
  return 430353718;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.toString__T = (function() {
  return "InterruptibleOnce";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productPrefix__T = (function() {
  return "InterruptibleOnce";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$, "cats.effect.kernel.Sync$Type$InterruptibleOnce$", ({
  Lcats_effect_kernel_Sync$Type$InterruptibleOnce$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
function $m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$)) {
    $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ = new $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$() {
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.hashCode__I = (function() {
  return 2125956;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.toString__T = (function() {
  return "Dead";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.productPrefix__T = (function() {
  return "Dead";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$, "cats.effect.std.Dispatcher$Executor$TaskState$3$Dead$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Dead$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_std_Dispatcher$Executor$TaskState$1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$() {
}
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$() {
}
$h_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype = $c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype;
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.hashCode__I = (function() {
  return 912992978;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.toString__T = (function() {
  return "Executing";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.productPrefix__T = (function() {
  return "Executing";
});
$c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$, "cats.effect.std.Dispatcher$Executor$TaskState$3$Executing$", ({
  Lcats_effect_std_Dispatcher$Executor$TaskState$3$Executing$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_std_Dispatcher$Executor$TaskState$1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$RegState$Completed$() {
}
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype = new $h_Lcats_effect_std_Dispatcher$RegState();
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$RegState$Completed$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$RegState$Completed$() {
}
$h_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype = $c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype;
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.hashCode__I = (function() {
  return 601036331;
});
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.toString__T = (function() {
  return "Completed";
});
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.productPrefix__T = (function() {
  return "Completed";
});
$c_Lcats_effect_std_Dispatcher$RegState$Completed$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_std_Dispatcher$RegState$Completed$ = new $TypeData().initClass($c_Lcats_effect_std_Dispatcher$RegState$Completed$, "cats.effect.std.Dispatcher$RegState$Completed$", ({
  Lcats_effect_std_Dispatcher$RegState$Completed$: 1,
  Lcats_effect_std_Dispatcher$RegState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_std_Dispatcher$RegState$Completed$;
function $m_Lcats_effect_std_Dispatcher$RegState$Completed$() {
  if ((!$n_Lcats_effect_std_Dispatcher$RegState$Completed$)) {
    $n_Lcats_effect_std_Dispatcher$RegState$Completed$ = new $c_Lcats_effect_std_Dispatcher$RegState$Completed$();
  }
  return $n_Lcats_effect_std_Dispatcher$RegState$Completed$;
}
function $p_Lcats_effect_std_Queue$UnboundedAsyncQueue__notifyOne__V($thiz) {
  while (true) {
    try {
      var f = $as_F1($n($thiz.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_takers).take__O());
      var retry = ((f === null) || ($n(f).apply__O__O($m_Lcats_effect_std_Queue$().Lcats_effect_std_Queue$__f_cats$effect$std$Queue$$$EitherUnit), false));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchResult56: {
        var retry;
        var x = $thiz.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal;
        if ((x !== null)) {
          var this$1 = $n(x);
          var $x_1 = (this$1 === e$2);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          var retry = false;
          break matchResult56;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    if (retry) {
    } else {
      return (void 0);
    }
  }
}
/** @constructor */
function $c_Lcats_effect_std_Queue$UnboundedAsyncQueue(F) {
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_F = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_takers = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_take = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_tryTake = null;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_F = F;
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer = new $c_Lcats_effect_std_UnsafeUnbounded();
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_takers = new $c_Lcats_effect_std_UnsafeUnbounded();
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal = $m_Lcats_effect_std_FailureSignal$();
  $n(F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).size__I())));
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_take = $n(F).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return $f_Lcats_effect_kernel_Sync__defer__F0__O($n(F), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      try {
        return $n(F).pure__O__O($n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).take__O());
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        var x = this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal;
        if ((x !== null)) {
          var this$3 = $n(x);
          var $x_1 = (this$3 === e$2);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          var received = new $c_sr_BooleanRef(false);
          var result = new $c_sr_ObjectRef(null);
          var wait = $n(F).asyncCheckAttempt__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((k) => {
            var k$1 = $as_F1(k);
            return $n(F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
              var clear = $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_takers).put__O__F0(k$1);
              try {
                result.sr_ObjectRef__f_elem = $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).take__O();
                $n(clear).apply__O();
                received.sr_BooleanRef__f_elem = true;
                $p_Lcats_effect_std_Queue$UnboundedAsyncQueue__notifyOne__V(this);
                return $m_Lcats_effect_std_Queue$().Lcats_effect_std_Queue$__f_cats$effect$std$Queue$$$EitherUnit;
              } catch (e$1) {
                var e$2$1 = ((e$1 instanceof $c_jl_Throwable) ? e$1 : new $c_sjs_js_JavaScriptException(e$1));
                var x$1 = this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal;
                if ((x$1 !== null)) {
                  var this$6 = $n(x$1);
                  var $x_2 = (this$6 === e$2$1);
                } else {
                  var $x_2 = false;
                }
                if ($x_2) {
                  var value = $n(F).delay__F0__O(clear);
                  var value$1 = new $c_s_Some(value);
                  return new $c_s_util_Left(value$1);
                }
                throw ((e$2$1 instanceof $c_sjs_js_JavaScriptException) ? e$2$1.sjs_js_JavaScriptException__f_exception : e$2$1);
              }
            })));
          })));
          var notifyAnyway = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
            $p_Lcats_effect_std_Queue$UnboundedAsyncQueue__notifyOne__V(this);
          })));
          var fa = $n(poll$1).apply__O__O(wait);
          var fb = $f_Lcats_effect_kernel_Sync__defer__F0__O($n(F), new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => (received.sr_BooleanRef__f_elem ? $n(F).pure__O__O(result.sr_ObjectRef__f_elem) : $n(poll$1).apply__O__O(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_take)))));
          var this$11 = $n(F);
          var wrapped = this$11.productR__O__O__O(fa, fb);
          return $n(F).onCancel__O__O__O(wrapped, notifyAnyway);
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    })));
  })));
  this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_tryTake = $n(F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    try {
      var value$2 = $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).take__O();
      return new $c_s_Some(value$2);
    } catch (e$3) {
      var e$2$2 = ((e$3 instanceof $c_jl_Throwable) ? e$3 : new $c_sjs_js_JavaScriptException(e$3));
      var x$2 = this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_FailureSignal;
      if ((x$2 !== null)) {
        var this$15 = $n(x$2);
        var $x_3 = (this$15 === e$2$2);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        return $m_s_None$();
      }
      throw ((e$2$2 instanceof $c_sjs_js_JavaScriptException) ? e$2$2.sjs_js_JavaScriptException__f_exception : e$2$2);
    }
  })));
}
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype = new $h_Lcats_effect_std_Queue();
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype.constructor = $c_Lcats_effect_std_Queue$UnboundedAsyncQueue;
/** @constructor */
function $h_Lcats_effect_std_Queue$UnboundedAsyncQueue() {
}
$h_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype = $c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype;
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype.unsafeOffer__O__V = (function(a) {
  $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_buffer).put__O__F0(a);
  $p_Lcats_effect_std_Queue$UnboundedAsyncQueue__notifyOne__V(this);
});
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype.offer__O__O = (function(a) {
  return $n(this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_F).delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    this.unsafeOffer__O__V(a);
  })));
});
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype.take__O = (function() {
  return this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_take;
});
$c_Lcats_effect_std_Queue$UnboundedAsyncQueue.prototype.tryTake__O = (function() {
  return this.Lcats_effect_std_Queue$UnboundedAsyncQueue__f_tryTake;
});
var $d_Lcats_effect_std_Queue$UnboundedAsyncQueue = new $TypeData().initClass($c_Lcats_effect_std_Queue$UnboundedAsyncQueue, "cats.effect.std.Queue$UnboundedAsyncQueue", ({
  Lcats_effect_std_Queue$UnboundedAsyncQueue: 1,
  Lcats_effect_std_Queue: 1,
  Lcats_effect_std_QueueSource: 1,
  Lcats_effect_std_QueueSink: 1,
  Lcats_effect_std_unsafe_BoundedQueueSink: 1,
  Lcats_effect_std_unsafe_BoundedQueue: 1,
  Lcats_effect_std_unsafe_UnboundedQueueSink: 1,
  Lcats_effect_std_unsafe_UnboundedQueue: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Done$() {
}
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Done$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Done$() {
}
$h_Lcats_effect_std_Semaphore$impl$Done$.prototype = $c_Lcats_effect_std_Semaphore$impl$Done$.prototype;
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.hashCode__I = (function() {
  return 2135970;
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.toString__T = (function() {
  return "Done";
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productPrefix__T = (function() {
  return "Done";
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_std_Semaphore$impl$Done$ = new $TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$Done$, "cats.effect.std.Semaphore$impl$Done$", ({
  Lcats_effect_std_Semaphore$impl$Done$: 1,
  Lcats_effect_std_Semaphore$impl$Action: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Wait$() {
}
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Wait$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Wait$() {
}
$h_Lcats_effect_std_Semaphore$impl$Wait$.prototype = $c_Lcats_effect_std_Semaphore$impl$Wait$.prototype;
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.hashCode__I = (function() {
  return 2688405;
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.toString__T = (function() {
  return "Wait";
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productPrefix__T = (function() {
  return "Wait";
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_effect_std_Semaphore$impl$Wait$ = new $TypeData().initClass($c_Lcats_effect_std_Semaphore$impl$Wait$, "cats.effect.std.Semaphore$impl$Wait$", ({
  Lcats_effect_std_Semaphore$impl$Wait$: 1,
  Lcats_effect_std_Semaphore$impl$Action: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$11(fa$8, f$4, g$4) {
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_f = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_g = null;
  $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__(this, fa$8, f$4, g$4);
}
$c_Lcats_instances_InvariantInstances$$anon$11.prototype = new $h_Lcats_instances_ScalaVersionSpecificNumeric();
$c_Lcats_instances_InvariantInstances$$anon$11.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$11;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$11() {
}
$h_Lcats_instances_InvariantInstances$$anon$11.prototype = $c_Lcats_instances_InvariantInstances$$anon$11.prototype;
var $d_Lcats_instances_InvariantInstances$$anon$11 = new $TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$11, "cats.instances.InvariantInstances$$anon$11", ({
  Lcats_instances_InvariantInstances$$anon$11: 1,
  Lcats_instances_ScalaVersionSpecificNumeric: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1,
  s_math_Numeric: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalGroup() {
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = null;
  var this$1 = $n($m_s_package$().BigDecimal__s_math_BigDecimal$());
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = this$1.apply__I__Ljava_math_MathContext__s_math_BigDecimal(0, this$1.s_math_BigDecimal$__f_defaultMathContext);
}
$c_Lcats_kernel_instances_BigDecimalGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalGroup() {
}
$h_Lcats_kernel_instances_BigDecimalGroup.prototype = $c_Lcats_kernel_instances_BigDecimalGroup.prototype;
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal = (function(x, y) {
  return new $c_s_math_BigDecimal($n($n(x).s_math_BigDecimal__f_bigDecimal).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($n(y).s_math_BigDecimal__f_bigDecimal), $n(x).s_math_BigDecimal__f_mc);
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigDecimalGroup__f_empty;
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal($as_s_math_BigDecimal(x), $as_s_math_BigDecimal(y));
});
var $d_Lcats_kernel_instances_BigDecimalGroup = new $TypeData().initClass($c_Lcats_kernel_instances_BigDecimalGroup, "cats.kernel.instances.BigDecimalGroup", ({
  Lcats_kernel_instances_BigDecimalGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BigIntGroup() {
  this.Lcats_kernel_instances_BigIntGroup__f_empty = null;
  this.Lcats_kernel_instances_BigIntGroup__f_empty = $n($m_s_package$().BigInt__s_math_BigInt$()).apply__I__s_math_BigInt(0);
}
$c_Lcats_kernel_instances_BigIntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntGroup.prototype.constructor = $c_Lcats_kernel_instances_BigIntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntGroup() {
}
$h_Lcats_kernel_instances_BigIntGroup.prototype = $c_Lcats_kernel_instances_BigIntGroup.prototype;
$c_Lcats_kernel_instances_BigIntGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigIntGroup__f_empty;
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $n(x$1).$plus__s_math_BigInt__s_math_BigInt(y$1);
});
var $d_Lcats_kernel_instances_BigIntGroup = new $TypeData().initClass($c_Lcats_kernel_instances_BigIntGroup, "cats.kernel.instances.BigIntGroup", ({
  Lcats_kernel_instances_BigIntGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_ByteGroup() {
}
$c_Lcats_kernel_instances_ByteGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteGroup.prototype.constructor = $c_Lcats_kernel_instances_ByteGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ByteGroup() {
}
$h_Lcats_kernel_instances_ByteGroup.prototype = $c_Lcats_kernel_instances_ByteGroup.prototype;
$c_Lcats_kernel_instances_ByteGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__B__B__B = (function(x, y) {
  return ((((x + y) | 0) << 24) >> 24);
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__B__B__B($uB(x), $uB(y));
});
$c_Lcats_kernel_instances_ByteGroup.prototype.empty__O = (function() {
  return 0;
});
var $d_Lcats_kernel_instances_ByteGroup = new $TypeData().initClass($c_Lcats_kernel_instances_ByteGroup, "cats.kernel.instances.ByteGroup", ({
  Lcats_kernel_instances_ByteGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_DoubleGroup() {
}
$c_Lcats_kernel_instances_DoubleGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleGroup.prototype.constructor = $c_Lcats_kernel_instances_DoubleGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleGroup() {
}
$h_Lcats_kernel_instances_DoubleGroup.prototype = $c_Lcats_kernel_instances_DoubleGroup.prototype;
$c_Lcats_kernel_instances_DoubleGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__D__D__D = (function(x, y) {
  return (x + y);
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__D__D__D($uD(x), $uD(y));
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.empty__O = (function() {
  return 0.0;
});
var $d_Lcats_kernel_instances_DoubleGroup = new $TypeData().initClass($c_Lcats_kernel_instances_DoubleGroup, "cats.kernel.instances.DoubleGroup", ({
  Lcats_kernel_instances_DoubleGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_DurationGroup() {
}
$c_Lcats_kernel_instances_DurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationGroup.prototype.constructor = $c_Lcats_kernel_instances_DurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DurationGroup() {
}
$h_Lcats_kernel_instances_DurationGroup.prototype = $c_Lcats_kernel_instances_DurationGroup.prototype;
$c_Lcats_kernel_instances_DurationGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_DurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
});
$c_Lcats_kernel_instances_DurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  return $n(x$1).$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration(y$1);
});
var $d_Lcats_kernel_instances_DurationGroup = new $TypeData().initClass($c_Lcats_kernel_instances_DurationGroup, "cats.kernel.instances.DurationGroup", ({
  Lcats_kernel_instances_DurationGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationGroup() {
}
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationGroup() {
}
$h_Lcats_kernel_instances_FiniteDurationGroup.prototype = $c_Lcats_kernel_instances_FiniteDurationGroup.prototype;
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero;
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  var this$1 = $n(x$1);
  return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this$1, $n(y$1).s_concurrent_duration_FiniteDuration__f_length_$lo, $n(y$1).s_concurrent_duration_FiniteDuration__f_length_$hi, $n(y$1).s_concurrent_duration_FiniteDuration__f_unit);
});
var $d_Lcats_kernel_instances_FiniteDurationGroup = new $TypeData().initClass($c_Lcats_kernel_instances_FiniteDurationGroup, "cats.kernel.instances.FiniteDurationGroup", ({
  Lcats_kernel_instances_FiniteDurationGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_FloatGroup() {
}
$c_Lcats_kernel_instances_FloatGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatGroup.prototype.constructor = $c_Lcats_kernel_instances_FloatGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FloatGroup() {
}
$h_Lcats_kernel_instances_FloatGroup.prototype = $c_Lcats_kernel_instances_FloatGroup.prototype;
$c_Lcats_kernel_instances_FloatGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__F__F__F = (function(x, y) {
  return Math.fround((x + y));
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__F__F__F($uF(x), $uF(y));
});
$c_Lcats_kernel_instances_FloatGroup.prototype.empty__O = (function() {
  return 0.0;
});
var $d_Lcats_kernel_instances_FloatGroup = new $TypeData().initClass($c_Lcats_kernel_instances_FloatGroup, "cats.kernel.instances.FloatGroup", ({
  Lcats_kernel_instances_FloatGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_IntGroup() {
}
$c_Lcats_kernel_instances_IntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_IntGroup.prototype.constructor = $c_Lcats_kernel_instances_IntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_IntGroup() {
}
$h_Lcats_kernel_instances_IntGroup.prototype = $c_Lcats_kernel_instances_IntGroup.prototype;
$c_Lcats_kernel_instances_IntGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__I__I__I = (function(x, y) {
  return ((x + y) | 0);
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__I__I__I($uI(x), $uI(y));
});
$c_Lcats_kernel_instances_IntGroup.prototype.empty__O = (function() {
  return 0;
});
var $d_Lcats_kernel_instances_IntGroup = new $TypeData().initClass($c_Lcats_kernel_instances_IntGroup, "cats.kernel.instances.IntGroup", ({
  Lcats_kernel_instances_IntGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_LongGroup() {
}
$c_Lcats_kernel_instances_LongGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_LongGroup.prototype.constructor = $c_Lcats_kernel_instances_LongGroup;
/** @constructor */
function $h_Lcats_kernel_instances_LongGroup() {
}
$h_Lcats_kernel_instances_LongGroup.prototype = $c_Lcats_kernel_instances_LongGroup.prototype;
$c_Lcats_kernel_instances_LongGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__J__J__J = (function(x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  var lo = ((x_$_lo + y_$_lo) | 0);
  var hi = ((((x_$_hi + y_$_hi) | 0) + ((((x_$_lo & y_$_lo) | ((x_$_lo | y_$_lo) & (~lo))) >>> 31) | 0)) | 0);
  return $bL(lo, hi);
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__O__O__O = (function(x, y) {
  var $x_2 = $uJ(x);
  var $x_1 = $uJ(y);
  return this.combine__J__J__J($x_2.l, $x_2.h, $x_1.l, $x_1.h);
});
$c_Lcats_kernel_instances_LongGroup.prototype.empty__O = (function() {
  return $bL(0, 0);
});
var $d_Lcats_kernel_instances_LongGroup = new $TypeData().initClass($c_Lcats_kernel_instances_LongGroup, "cats.kernel.instances.LongGroup", ({
  Lcats_kernel_instances_LongGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_ShortGroup() {
}
$c_Lcats_kernel_instances_ShortGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortGroup.prototype.constructor = $c_Lcats_kernel_instances_ShortGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ShortGroup() {
}
$h_Lcats_kernel_instances_ShortGroup.prototype = $c_Lcats_kernel_instances_ShortGroup.prototype;
$c_Lcats_kernel_instances_ShortGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__S__S__S = (function(x, y) {
  return ((((x + y) | 0) << 16) >> 16);
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__S__S__S($uS(x), $uS(y));
});
$c_Lcats_kernel_instances_ShortGroup.prototype.empty__O = (function() {
  return 0;
});
var $d_Lcats_kernel_instances_ShortGroup = new $TypeData().initClass($c_Lcats_kernel_instances_ShortGroup, "cats.kernel.instances.ShortGroup", ({
  Lcats_kernel_instances_ShortGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_StringOrder() {
}
$c_Lcats_kernel_instances_StringOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_StringOrder.prototype.constructor = $c_Lcats_kernel_instances_StringOrder;
/** @constructor */
function $h_Lcats_kernel_instances_StringOrder() {
}
$h_Lcats_kernel_instances_StringOrder.prototype = $c_Lcats_kernel_instances_StringOrder.prototype;
$c_Lcats_kernel_instances_StringOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.min__O__O__O = (function(x, y) {
  return $f_Lcats_kernel_Order__min__O__O__O(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.lt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__lt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__T__T__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__T__T__I = (function(x, y) {
  return ((x === y) ? 0 : $f_T__compareTo__T__I($n(x), y));
});
$c_Lcats_kernel_instances_StringOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_T(x);
  return $f_T__hashCode__I($n(x$1));
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__T__T__Z($as_T(x), $as_T(y));
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T__T__I($as_T(x), $as_T(y));
});
var $d_Lcats_kernel_instances_StringOrder = new $TypeData().initClass($c_Lcats_kernel_instances_StringOrder, "cats.kernel.instances.StringOrder", ({
  Lcats_kernel_instances_StringOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_StringLowerBounded: 1
}));
function $as_Lfs2_Pull$Acquire(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Acquire"));
}
function $isArrayOf_Lfs2_Pull$Acquire(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Acquire)));
}
function $asArrayOf_Lfs2_Pull$Acquire(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Acquire(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Acquire;", depth));
}
/** @constructor */
function $c_Lfs2_Pull$Eval(value) {
  this.Lfs2_Pull$Eval__f_value = null;
  this.Lfs2_Pull$Eval__f_value = value;
}
$c_Lfs2_Pull$Eval.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$Eval.prototype.constructor = $c_Lfs2_Pull$Eval;
/** @constructor */
function $h_Lfs2_Pull$Eval() {
}
$h_Lfs2_Pull$Eval.prototype = $c_Lfs2_Pull$Eval.prototype;
$c_Lfs2_Pull$Eval.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$Eval.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$Eval.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$Eval)) {
    var x$0$2 = $as_Lfs2_Pull$Eval(x$0);
    var x = this.Lfs2_Pull$Eval__f_value;
    var y = $n(x$0$2).Lfs2_Pull$Eval__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lfs2_Pull$Eval.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$Eval.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$Eval.prototype.productPrefix__T = (function() {
  return "Eval";
});
$c_Lfs2_Pull$Eval.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Eval__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $as_Lfs2_Pull$Eval(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Eval"));
}
function $isArrayOf_Lfs2_Pull$Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Eval)));
}
function $asArrayOf_Lfs2_Pull$Eval(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Eval;", depth));
}
var $d_Lfs2_Pull$Eval = new $TypeData().initClass($c_Lfs2_Pull$Eval, "fs2.Pull$Eval", ({
  Lfs2_Pull$Eval: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
function $as_Lfs2_Pull$GetScope(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$GetScope"));
}
function $isArrayOf_Lfs2_Pull$GetScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$GetScope)));
}
function $asArrayOf_Lfs2_Pull$GetScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$GetScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$GetScope;", depth));
}
function $as_Lfs2_Pull$InterruptWhen(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$InterruptWhen"));
}
function $isArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$InterruptWhen)));
}
function $asArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$InterruptWhen;", depth));
}
class $c_Lfs2_internal_AcquireAfterScopeClosed$ extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return (-998855110);
  }
  productArity__I() {
    return 0;
  }
  productPrefix__T() {
    return "AcquireAfterScopeClosed";
  }
  productElement__I__O(n) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  fillInStackTrace__jl_Throwable() {
    return this;
  }
}
var $d_Lfs2_internal_AcquireAfterScopeClosed$ = new $TypeData().initClass($c_Lfs2_internal_AcquireAfterScopeClosed$, "fs2.internal.AcquireAfterScopeClosed$", ({
  Lfs2_internal_AcquireAfterScopeClosed$: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lfs2_internal_AcquireAfterScopeClosed$;
function $m_Lfs2_internal_AcquireAfterScopeClosed$() {
  if ((!$n_Lfs2_internal_AcquireAfterScopeClosed$)) {
    $n_Lfs2_internal_AcquireAfterScopeClosed$ = new $c_Lfs2_internal_AcquireAfterScopeClosed$();
  }
  return $n_Lfs2_internal_AcquireAfterScopeClosed$;
}
/** @constructor */
function $c_Lio_circe_DecodingFailure$Reason$MissingField$() {
}
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype = new $h_Lio_circe_DecodingFailure$Reason();
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.constructor = $c_Lio_circe_DecodingFailure$Reason$MissingField$;
/** @constructor */
function $h_Lio_circe_DecodingFailure$Reason$MissingField$() {
}
$h_Lio_circe_DecodingFailure$Reason$MissingField$.prototype = $c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype;
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.hashCode__I = (function() {
  return (-1005620396);
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.toString__T = (function() {
  return "MissingField";
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.productPrefix__T = (function() {
  return "MissingField";
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lio_circe_DecodingFailure$Reason$MissingField$ = new $TypeData().initClass($c_Lio_circe_DecodingFailure$Reason$MissingField$, "io.circe.DecodingFailure$Reason$MissingField$", ({
  Lio_circe_DecodingFailure$Reason$MissingField$: 1,
  Lio_circe_DecodingFailure$Reason: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lio_circe_DecodingFailure$Reason$MissingField$;
function $m_Lio_circe_DecodingFailure$Reason$MissingField$() {
  if ((!$n_Lio_circe_DecodingFailure$Reason$MissingField$)) {
    $n_Lio_circe_DecodingFailure$Reason$MissingField$ = new $c_Lio_circe_DecodingFailure$Reason$MissingField$();
  }
  return $n_Lio_circe_DecodingFailure$Reason$MissingField$;
}
/** @constructor */
function $c_Lio_circe_Json$JNull$() {
}
$c_Lio_circe_Json$JNull$.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JNull$.prototype.constructor = $c_Lio_circe_Json$JNull$;
/** @constructor */
function $h_Lio_circe_Json$JNull$() {
}
$h_Lio_circe_Json$JNull$.prototype = $c_Lio_circe_Json$JNull$.prototype;
$c_Lio_circe_Json$JNull$.prototype.hashCode__I = (function() {
  return 70780145;
});
$c_Lio_circe_Json$JNull$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_Json$JNull$.prototype.productPrefix__T = (function() {
  return "JNull";
});
$c_Lio_circe_Json$JNull$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JNull$.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return $n(folder).onNull__O();
});
$c_Lio_circe_Json$JNull$.prototype.isNull__Z = (function() {
  return true;
});
$c_Lio_circe_Json$JNull$.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JNull$.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
var $d_Lio_circe_Json$JNull$ = new $TypeData().initClass($c_Lio_circe_Json$JNull$, "io.circe.Json$JNull$", ({
  Lio_circe_Json$JNull$: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lio_circe_Json$JNull$;
function $m_Lio_circe_Json$JNull$() {
  if ((!$n_Lio_circe_Json$JNull$)) {
    $n_Lio_circe_Json$JNull$ = new $c_Lio_circe_Json$JNull$();
  }
  return $n_Lio_circe_Json$JNull$;
}
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (($as_T((typeof console)) !== "undefined")) {
    if (($thiz.jl_JSConsoleBasedPrintStream__f_isErr && $uZ((!(!console.error))))) {
      console.error(line);
    } else {
      console.log(line);
    }
  }
}
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.jl_JSConsoleBasedPrintStream__f_isErr = false;
  this.jl_JSConsoleBasedPrintStream__f_buffer = null;
  this.jl_JSConsoleBasedPrintStream__f_isErr = isErr;
  var out = new $c_jl_JSConsoleBasedPrintStream$DummyOutputStream();
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, out, false, null);
  this.jl_JSConsoleBasedPrintStream__f_buffer = "";
}
$c_jl_JSConsoleBasedPrintStream.prototype = new $h_Ljava_io_PrintStream();
$c_jl_JSConsoleBasedPrintStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
}
$h_jl_JSConsoleBasedPrintStream.prototype = $c_jl_JSConsoleBasedPrintStream.prototype;
$c_jl_JSConsoleBasedPrintStream.prototype.print__C__V = (function(c) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(("" + $cToS(c)));
});
$c_jl_JSConsoleBasedPrintStream.prototype.print__T__V = (function(s) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(((s === null) ? "null" : s));
});
$c_jl_JSConsoleBasedPrintStream.prototype.java$lang$JSConsoleBasedPrintStream$$printString__T__V = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = $n(rest);
    var nlPos = $uI(this$1.indexOf("\n"));
    if ((nlPos < 0)) {
      this.jl_JSConsoleBasedPrintStream__f_buffer = (("" + this.jl_JSConsoleBasedPrintStream__f_buffer) + rest);
      rest = "";
    } else {
      var $x_1 = this.jl_JSConsoleBasedPrintStream__f_buffer;
      var this$2 = $n(rest);
      if ((nlPos > this$2.length)) {
        $charAt(this$2, nlPos);
      }
      if ((nlPos < 0)) {
        $charAt(this$2, (-1));
      }
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $x_1) + $as_T(this$2.substring(0, nlPos))));
      this.jl_JSConsoleBasedPrintStream__f_buffer = "";
      var this$3 = $n(rest);
      var beginIndex = ((1 + nlPos) | 0);
      if (((beginIndex < 0) || (beginIndex > this$3.length))) {
        $charAt(this$3, beginIndex);
      }
      rest = $as_T(this$3.substring(beginIndex));
    }
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $TypeData().initClass($c_jl_JSConsoleBasedPrintStream, "java.lang.JSConsoleBasedPrintStream", ({
  jl_JSConsoleBasedPrintStream: 1,
  Ljava_io_PrintStream: 1,
  Ljava_io_FilterOutputStream: 1,
  Ljava_io_OutputStream: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1,
  jl_Appendable: 1
}));
function $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x2 = $as_Ljava_time_temporal_ChronoField(field);
  var x = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  if ((x === null)) {
    var $x_1 = (x2 === null);
  } else {
    var this$1 = $n(x);
    var $x_1 = (this$1 === x2);
  }
  if ($x_1) {
    var value = $n($thiz.getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I();
    var hi = (value >> 31);
    return $bL(value, hi);
  }
  var x$3 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
  if ((x$3 === null)) {
    var $x_2 = (x2 === null);
  } else {
    var this$3 = $n(x$3);
    var $x_2 = (this$3 === x2);
  }
  if ($x_2) {
    var value$1 = $thiz.Ljava_time_LocalDate__f_day;
    var hi$1 = (value$1 >> 31);
    var lo = ((value$1 - 1) | 0);
    var hi$2 = ((((hi$1 - 1) | 0) + (((value$1 | (~lo)) >>> 31) | 0)) | 0);
    var hi$3 = (hi$2 >> 31);
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(37449, b0);
    var a1b0 = Math.imul(18724, b0);
    var a0b1 = Math.imul(37449, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((((Math.imul(18724, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var b0$1 = (65535 & lo);
    var b1$1 = ((lo >>> 16) | 0);
    var a0b0$1 = Math.imul(18725, b0$1);
    var a1b0$1 = Math.imul(9362, b0$1);
    var a0b1$1 = Math.imul(18725, b1$1);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$5 = ((((Math.imul(9362, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$3 = ((lo$1 + hi$5) | 0);
    var hi$6 = ((hi$4 + ((((lo$1 & hi$5) | ((lo$1 | hi$5) & (~lo$3))) >>> 31) | 0)) | 0);
    var b0$2 = (65535 & hi$2);
    var b1$2 = ((hi$2 >>> 16) | 0);
    var a0b0$2 = Math.imul(37449, b0$2);
    var a1b0$2 = Math.imul(18724, b0$2);
    var a0b1$2 = Math.imul(37449, b1$2);
    var lo$4 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$7 = ((((((Math.imul(1227133513, hi$3) + Math.imul(18724, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
    var hi$8 = (hi$6 >> 31);
    var lo$5 = ((lo$4 + hi$6) | 0);
    var hi$9 = ((((hi$7 + hi$8) | 0) + ((((lo$4 & hi$6) | ((lo$4 | hi$6) & (~lo$5))) >>> 31) | 0)) | 0);
    var b0$3 = (65535 & hi$2);
    var b1$3 = ((hi$2 >>> 16) | 0);
    var a0b0$3 = Math.imul(18725, b0$3);
    var a1b0$3 = Math.imul(9362, b0$3);
    var a0b1$3 = Math.imul(18725, b1$3);
    var lo$6 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$10 = ((((((Math.imul(613566757, hi$3) + Math.imul(9362, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
    var lo$7 = ((lo$3 + lo$6) | 0);
    var hi$11 = ((hi$10 + ((((lo$3 & lo$6) | ((lo$3 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
    var hi$12 = (hi$11 >> 31);
    var lo$8 = ((lo$5 + hi$11) | 0);
    var hi$13 = ((((hi$9 + hi$12) | 0) + ((((lo$5 & hi$11) | ((lo$5 | hi$11) & (~lo$8))) >>> 31) | 0)) | 0);
    var lo$9 = (((lo$8 >>> 1) | 0) | (hi$13 << 31));
    var hi$14 = (hi$13 >> 1);
    var lo$10 = ((hi$2 >>> 31) | 0);
    var lo$11 = ((lo$9 + lo$10) | 0);
    var hi$15 = ((hi$14 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
    var b0$4 = (65535 & lo$11);
    var b1$4 = ((lo$11 >>> 16) | 0);
    var a0b0$4 = Math.imul(7, b0$4);
    var a0b1$4 = Math.imul(7, b1$4);
    var lo$12 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$16 = ((Math.imul(7, hi$15) + ((c1part$4 >>> 16) | 0)) | 0);
    var lo$13 = ((lo - lo$12) | 0);
    var hi$17 = ((((hi$2 - hi$16) | 0) + ((((~lo) & lo$12) | ((~(lo ^ lo$12)) & lo$13)) >> 31)) | 0);
    var lo$14 = ((1 + lo$13) | 0);
    var hi$18 = ((hi$17 + (((lo$13 & (~lo$14)) >>> 31) | 0)) | 0);
    return $bL(lo$14, hi$18);
  }
  var x$5 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
  if ((x$5 === null)) {
    var $x_3 = (x2 === null);
  } else {
    var this$26 = $n(x$5);
    var $x_3 = (this$26 === x2);
  }
  if ($x_3) {
    var value$2 = $thiz.getDayOfYear__I();
    var hi$19 = (value$2 >> 31);
    var lo$15 = ((value$2 - 1) | 0);
    var hi$20 = ((((hi$19 - 1) | 0) + (((value$2 | (~lo$15)) >>> 31) | 0)) | 0);
    var hi$21 = (hi$20 >> 31);
    var b0$5 = (65535 & lo$15);
    var b1$5 = ((lo$15 >>> 16) | 0);
    var a0b0$5 = Math.imul(37449, b0$5);
    var a1b0$4 = Math.imul(18724, b0$5);
    var a0b1$5 = Math.imul(37449, b1$5);
    var lo$16 = ((a0b0$5 + (((a1b0$4 + a0b1$5) | 0) << 16)) | 0);
    var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
    var hi$22 = ((((Math.imul(18724, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$4) | 0) >>> 16) | 0)) | 0);
    var b0$6 = (65535 & lo$15);
    var b1$6 = ((lo$15 >>> 16) | 0);
    var a0b0$6 = Math.imul(18725, b0$6);
    var a1b0$5 = Math.imul(9362, b0$6);
    var a0b1$6 = Math.imul(18725, b1$6);
    var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
    var hi$23 = ((((Math.imul(9362, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$5) | 0) >>> 16) | 0)) | 0);
    var lo$18 = ((lo$16 + hi$23) | 0);
    var hi$24 = ((hi$22 + ((((lo$16 & hi$23) | ((lo$16 | hi$23) & (~lo$18))) >>> 31) | 0)) | 0);
    var b0$7 = (65535 & hi$20);
    var b1$7 = ((hi$20 >>> 16) | 0);
    var a0b0$7 = Math.imul(37449, b0$7);
    var a1b0$6 = Math.imul(18724, b0$7);
    var a0b1$7 = Math.imul(37449, b1$7);
    var lo$19 = ((a0b0$7 + (((a1b0$6 + a0b1$7) | 0) << 16)) | 0);
    var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
    var hi$25 = ((((((Math.imul(1227133513, hi$21) + Math.imul(18724, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$6) | 0) >>> 16) | 0)) | 0);
    var hi$26 = (hi$24 >> 31);
    var lo$20 = ((lo$19 + hi$24) | 0);
    var hi$27 = ((((hi$25 + hi$26) | 0) + ((((lo$19 & hi$24) | ((lo$19 | hi$24) & (~lo$20))) >>> 31) | 0)) | 0);
    var b0$8 = (65535 & hi$20);
    var b1$8 = ((hi$20 >>> 16) | 0);
    var a0b0$8 = Math.imul(18725, b0$8);
    var a1b0$7 = Math.imul(9362, b0$8);
    var a0b1$8 = Math.imul(18725, b1$8);
    var lo$21 = ((a0b0$8 + (((a1b0$7 + a0b1$8) | 0) << 16)) | 0);
    var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
    var hi$28 = ((((((Math.imul(613566757, hi$21) + Math.imul(9362, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$7) | 0) >>> 16) | 0)) | 0);
    var lo$22 = ((lo$18 + lo$21) | 0);
    var hi$29 = ((hi$28 + ((((lo$18 & lo$21) | ((lo$18 | lo$21) & (~lo$22))) >>> 31) | 0)) | 0);
    var hi$30 = (hi$29 >> 31);
    var lo$23 = ((lo$20 + hi$29) | 0);
    var hi$31 = ((((hi$27 + hi$30) | 0) + ((((lo$20 & hi$29) | ((lo$20 | hi$29) & (~lo$23))) >>> 31) | 0)) | 0);
    var lo$24 = (((lo$23 >>> 1) | 0) | (hi$31 << 31));
    var hi$32 = (hi$31 >> 1);
    var lo$25 = ((hi$20 >>> 31) | 0);
    var lo$26 = ((lo$24 + lo$25) | 0);
    var hi$33 = ((hi$32 + ((((lo$24 & lo$25) | ((lo$24 | lo$25) & (~lo$26))) >>> 31) | 0)) | 0);
    var b0$9 = (65535 & lo$26);
    var b1$9 = ((lo$26 >>> 16) | 0);
    var a0b0$9 = Math.imul(7, b0$9);
    var a0b1$9 = Math.imul(7, b1$9);
    var lo$27 = ((a0b0$9 + (a0b1$9 << 16)) | 0);
    var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
    var hi$34 = ((Math.imul(7, hi$33) + ((c1part$9 >>> 16) | 0)) | 0);
    var lo$28 = ((lo$15 - lo$27) | 0);
    var hi$35 = ((((hi$20 - hi$34) | 0) + ((((~lo$15) & lo$27) | ((~(lo$15 ^ lo$27)) & lo$28)) >> 31)) | 0);
    var lo$29 = ((1 + lo$28) | 0);
    var hi$36 = ((hi$35 + (((lo$28 & (~lo$29)) >>> 31) | 0)) | 0);
    return $bL(lo$29, hi$36);
  }
  var x$7 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  if ((x$7 === null)) {
    var $x_4 = (x2 === null);
  } else {
    var this$49 = $n(x$7);
    var $x_4 = (this$49 === x2);
  }
  if ($x_4) {
    var value$3 = $thiz.Ljava_time_LocalDate__f_day;
    var hi$37 = (value$3 >> 31);
    return $bL(value$3, hi$37);
  }
  var x$9 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
  if ((x$9 === null)) {
    var $x_5 = (x2 === null);
  } else {
    var this$51 = $n(x$9);
    var $x_5 = (this$51 === x2);
  }
  if ($x_5) {
    var value$4 = $thiz.getDayOfYear__I();
    var hi$38 = (value$4 >> 31);
    return $bL(value$4, hi$38);
  }
  var x$11 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  if ((x$11 === null)) {
    var $x_6 = (x2 === null);
  } else {
    var this$53 = $n(x$11);
    var $x_6 = (this$53 === x2);
  }
  if ($x_6) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$13 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
  if ((x$13 === null)) {
    var $x_7 = (x2 === null);
  } else {
    var this$54 = $n(x$13);
    var $x_7 = (this$54 === x2);
  }
  if ($x_7) {
    var value$5 = $thiz.Ljava_time_LocalDate__f_day;
    var hi$39 = (value$5 >> 31);
    var lo$30 = ((value$5 - 1) | 0);
    var hi$40 = ((((hi$39 - 1) | 0) + (((value$5 | (~lo$30)) >>> 31) | 0)) | 0);
    var hi$41 = (hi$40 >> 31);
    var b0$10 = (65535 & lo$30);
    var b1$10 = ((lo$30 >>> 16) | 0);
    var a0b0$10 = Math.imul(37449, b0$10);
    var a1b0$8 = Math.imul(18724, b0$10);
    var a0b1$10 = Math.imul(37449, b1$10);
    var lo$31 = ((a0b0$10 + (((a1b0$8 + a0b1$10) | 0) << 16)) | 0);
    var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
    var hi$42 = ((((Math.imul(18724, b1$10) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$8) | 0) >>> 16) | 0)) | 0);
    var b0$11 = (65535 & lo$30);
    var b1$11 = ((lo$30 >>> 16) | 0);
    var a0b0$11 = Math.imul(18725, b0$11);
    var a1b0$9 = Math.imul(9362, b0$11);
    var a0b1$11 = Math.imul(18725, b1$11);
    var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
    var hi$43 = ((((Math.imul(9362, b1$11) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$9) | 0) >>> 16) | 0)) | 0);
    var lo$33 = ((lo$31 + hi$43) | 0);
    var hi$44 = ((hi$42 + ((((lo$31 & hi$43) | ((lo$31 | hi$43) & (~lo$33))) >>> 31) | 0)) | 0);
    var b0$12 = (65535 & hi$40);
    var b1$12 = ((hi$40 >>> 16) | 0);
    var a0b0$12 = Math.imul(37449, b0$12);
    var a1b0$10 = Math.imul(18724, b0$12);
    var a0b1$12 = Math.imul(37449, b1$12);
    var lo$34 = ((a0b0$12 + (((a1b0$10 + a0b1$12) | 0) << 16)) | 0);
    var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
    var hi$45 = ((((((Math.imul(1227133513, hi$41) + Math.imul(18724, b1$12)) | 0) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$10) | 0) >>> 16) | 0)) | 0);
    var hi$46 = (hi$44 >> 31);
    var lo$35 = ((lo$34 + hi$44) | 0);
    var hi$47 = ((((hi$45 + hi$46) | 0) + ((((lo$34 & hi$44) | ((lo$34 | hi$44) & (~lo$35))) >>> 31) | 0)) | 0);
    var b0$13 = (65535 & hi$40);
    var b1$13 = ((hi$40 >>> 16) | 0);
    var a0b0$13 = Math.imul(18725, b0$13);
    var a1b0$11 = Math.imul(9362, b0$13);
    var a0b1$13 = Math.imul(18725, b1$13);
    var lo$36 = ((a0b0$13 + (((a1b0$11 + a0b1$13) | 0) << 16)) | 0);
    var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
    var hi$48 = ((((((Math.imul(613566757, hi$41) + Math.imul(9362, b1$13)) | 0) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$11) | 0) >>> 16) | 0)) | 0);
    var lo$37 = ((lo$33 + lo$36) | 0);
    var hi$49 = ((hi$48 + ((((lo$33 & lo$36) | ((lo$33 | lo$36) & (~lo$37))) >>> 31) | 0)) | 0);
    var hi$50 = (hi$49 >> 31);
    var lo$38 = ((lo$35 + hi$49) | 0);
    var hi$51 = ((((hi$47 + hi$50) | 0) + ((((lo$35 & hi$49) | ((lo$35 | hi$49) & (~lo$38))) >>> 31) | 0)) | 0);
    var lo$39 = (((lo$38 >>> 1) | 0) | (hi$51 << 31));
    var hi$52 = (hi$51 >> 1);
    var lo$40 = ((hi$40 >>> 31) | 0);
    var lo$41 = ((lo$39 + lo$40) | 0);
    var hi$53 = ((hi$52 + ((((lo$39 & lo$40) | ((lo$39 | lo$40) & (~lo$41))) >>> 31) | 0)) | 0);
    var lo$42 = ((1 + lo$41) | 0);
    var hi$54 = ((hi$53 + (((lo$41 & (~lo$42)) >>> 31) | 0)) | 0);
    return $bL(lo$42, hi$54);
  }
  var x$15 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
  if ((x$15 === null)) {
    var $x_8 = (x2 === null);
  } else {
    var this$75 = $n(x$15);
    var $x_8 = (this$75 === x2);
  }
  if ($x_8) {
    var value$6 = $thiz.getDayOfYear__I();
    var hi$55 = (value$6 >> 31);
    var lo$43 = ((value$6 - 1) | 0);
    var hi$56 = ((((hi$55 - 1) | 0) + (((value$6 | (~lo$43)) >>> 31) | 0)) | 0);
    var hi$57 = (hi$56 >> 31);
    var b0$14 = (65535 & lo$43);
    var b1$14 = ((lo$43 >>> 16) | 0);
    var a0b0$14 = Math.imul(37449, b0$14);
    var a1b0$12 = Math.imul(18724, b0$14);
    var a0b1$14 = Math.imul(37449, b1$14);
    var lo$44 = ((a0b0$14 + (((a1b0$12 + a0b1$14) | 0) << 16)) | 0);
    var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
    var hi$58 = ((((Math.imul(18724, b1$14) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$12) | 0) >>> 16) | 0)) | 0);
    var b0$15 = (65535 & lo$43);
    var b1$15 = ((lo$43 >>> 16) | 0);
    var a0b0$15 = Math.imul(18725, b0$15);
    var a1b0$13 = Math.imul(9362, b0$15);
    var a0b1$15 = Math.imul(18725, b1$15);
    var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
    var hi$59 = ((((Math.imul(9362, b1$15) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$13) | 0) >>> 16) | 0)) | 0);
    var lo$46 = ((lo$44 + hi$59) | 0);
    var hi$60 = ((hi$58 + ((((lo$44 & hi$59) | ((lo$44 | hi$59) & (~lo$46))) >>> 31) | 0)) | 0);
    var b0$16 = (65535 & hi$56);
    var b1$16 = ((hi$56 >>> 16) | 0);
    var a0b0$16 = Math.imul(37449, b0$16);
    var a1b0$14 = Math.imul(18724, b0$16);
    var a0b1$16 = Math.imul(37449, b1$16);
    var lo$47 = ((a0b0$16 + (((a1b0$14 + a0b1$16) | 0) << 16)) | 0);
    var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
    var hi$61 = ((((((Math.imul(1227133513, hi$57) + Math.imul(18724, b1$16)) | 0) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$14) | 0) >>> 16) | 0)) | 0);
    var hi$62 = (hi$60 >> 31);
    var lo$48 = ((lo$47 + hi$60) | 0);
    var hi$63 = ((((hi$61 + hi$62) | 0) + ((((lo$47 & hi$60) | ((lo$47 | hi$60) & (~lo$48))) >>> 31) | 0)) | 0);
    var b0$17 = (65535 & hi$56);
    var b1$17 = ((hi$56 >>> 16) | 0);
    var a0b0$17 = Math.imul(18725, b0$17);
    var a1b0$15 = Math.imul(9362, b0$17);
    var a0b1$17 = Math.imul(18725, b1$17);
    var lo$49 = ((a0b0$17 + (((a1b0$15 + a0b1$17) | 0) << 16)) | 0);
    var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
    var hi$64 = ((((((Math.imul(613566757, hi$57) + Math.imul(9362, b1$17)) | 0) + ((c1part$17 >>> 16) | 0)) | 0) + (((((65535 & c1part$17) + a1b0$15) | 0) >>> 16) | 0)) | 0);
    var lo$50 = ((lo$46 + lo$49) | 0);
    var hi$65 = ((hi$64 + ((((lo$46 & lo$49) | ((lo$46 | lo$49) & (~lo$50))) >>> 31) | 0)) | 0);
    var hi$66 = (hi$65 >> 31);
    var lo$51 = ((lo$48 + hi$65) | 0);
    var hi$67 = ((((hi$63 + hi$66) | 0) + ((((lo$48 & hi$65) | ((lo$48 | hi$65) & (~lo$51))) >>> 31) | 0)) | 0);
    var lo$52 = (((lo$51 >>> 1) | 0) | (hi$67 << 31));
    var hi$68 = (hi$67 >> 1);
    var lo$53 = ((hi$56 >>> 31) | 0);
    var lo$54 = ((lo$52 + lo$53) | 0);
    var hi$69 = ((hi$68 + ((((lo$52 & lo$53) | ((lo$52 | lo$53) & (~lo$54))) >>> 31) | 0)) | 0);
    var lo$55 = ((1 + lo$54) | 0);
    var hi$70 = ((hi$69 + (((lo$54 & (~lo$55)) >>> 31) | 0)) | 0);
    return $bL(lo$55, hi$70);
  }
  var x$17 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
  if ((x$17 === null)) {
    var $x_9 = (x2 === null);
  } else {
    var this$96 = $n(x$17);
    var $x_9 = (this$96 === x2);
  }
  if ($x_9) {
    var value$7 = $thiz.Ljava_time_LocalDate__f_month;
    var hi$71 = (value$7 >> 31);
    return $bL(value$7, hi$71);
  }
  var x$19 = $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
  if ((x$19 === null)) {
    var $x_10 = (x2 === null);
  } else {
    var this$98 = $n(x$19);
    var $x_10 = (this$98 === x2);
  }
  if ($x_10) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$21 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
  if ((x$21 === null)) {
    var $x_11 = (x2 === null);
  } else {
    var this$99 = $n(x$21);
    var $x_11 = (this$99 === x2);
  }
  if ($x_11) {
    if (($thiz.Ljava_time_LocalDate__f_year >= 1)) {
      var value$8 = $thiz.Ljava_time_LocalDate__f_year;
      var hi$72 = (value$8 >> 31);
      return $bL(value$8, hi$72);
    } else {
      var value$9 = $thiz.Ljava_time_LocalDate__f_year;
      var hi$73 = (value$9 >> 31);
      var lo$56 = ((1 - value$9) | 0);
      var hi$74 = ((((-hi$73) | 0) + ((value$9 | lo$56) >> 31)) | 0);
      return $bL(lo$56, hi$74);
    }
  }
  var x$23 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  if ((x$23 === null)) {
    var $x_12 = (x2 === null);
  } else {
    var this$103 = $n(x$23);
    var $x_12 = (this$103 === x2);
  }
  if ($x_12) {
    var value$10 = $thiz.Ljava_time_LocalDate__f_year;
    var hi$75 = (value$10 >> 31);
    return $bL(value$10, hi$75);
  }
  var x$25 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
  if ((x$25 === null)) {
    var $x_13 = (x2 === null);
  } else {
    var this$105 = $n(x$25);
    var $x_13 = (this$105 === x2);
  }
  if ($x_13) {
    if (($thiz.Ljava_time_LocalDate__f_year >= 1)) {
      return $bL(1, 0);
    } else {
      return $bL(0, 0);
    }
  }
  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
}
function $p_Ljava_time_LocalDate__getProlepticMonth__J($thiz) {
  var value = $thiz.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = (($thiz.Ljava_time_LocalDate__f_month - 1) | 0);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo & value$1) | ((lo | value$1) & (~lo$1))) >>> 31) | 0)) | 0);
  return $bL(lo$1, hi$3);
}
function $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J($thiz, end) {
  var $x_1 = $p_Ljava_time_LocalDate__getProlepticMonth__J($thiz);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var lo = (x_$_lo << 5);
  var hi = (((x_$_lo >>> 27) | 0) | (x_$_hi << 5));
  var value = $thiz.Ljava_time_LocalDate__f_day;
  var hi$1 = (value >> 31);
  var lo$1 = ((lo + value) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + ((((lo & value) | ((lo | value) & (~lo$1))) >>> 31) | 0)) | 0);
  var $x_2 = $p_Ljava_time_LocalDate__getProlepticMonth__J($n(end));
  var x$1_$_lo = $x_2.l;
  var x$1_$_hi = $x_2.h;
  var lo$2 = (x$1_$_lo << 5);
  var hi$3 = (((x$1_$_lo >>> 27) | 0) | (x$1_$_hi << 5));
  var this$5 = $n(end);
  var value$1 = this$5.Ljava_time_LocalDate__f_day;
  var hi$4 = (value$1 >> 31);
  var lo$3 = ((lo$2 + value$1) | 0);
  var hi$5 = ((((hi$3 + hi$4) | 0) + ((((lo$2 & value$1) | ((lo$2 | value$1) & (~lo$3))) >>> 31) | 0)) | 0);
  var lo$4 = ((lo$3 - lo$1) | 0);
  var hi$6 = ((((hi$5 - hi$2) | 0) + ((((~lo$3) & lo$1) | ((~(lo$3 ^ lo$1)) & lo$4)) >> 31)) | 0);
  var hi$7 = (hi$6 >> 4);
  var lo$6 = ((hi$7 >>> 27) | 0);
  var lo$7 = ((lo$4 + lo$6) | 0);
  var hi$8 = ((hi$6 + ((((lo$4 & lo$6) | ((lo$4 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 5) | 0) | (hi$8 << 27));
  var hi$9 = (hi$8 >> 5);
  return $bL(lo$8, hi$9);
}
/** @constructor */
function $c_Ljava_time_LocalDate(year, monthOfYear, dayOfMonth) {
  this.Ljava_time_LocalDate__f_year = 0;
  this.Ljava_time_LocalDate__f_month = 0;
  this.Ljava_time_LocalDate__f_day = 0;
  this.Ljava_time_LocalDate__f_year = year;
  this.Ljava_time_LocalDate__f_month = ((monthOfYear << 16) >> 16);
  this.Ljava_time_LocalDate__f_day = ((dayOfMonth << 16) >> 16);
}
$c_Ljava_time_LocalDate.prototype = new $h_O();
$c_Ljava_time_LocalDate.prototype.constructor = $c_Ljava_time_LocalDate;
/** @constructor */
function $h_Ljava_time_LocalDate() {
}
$h_Ljava_time_LocalDate.prototype = $c_Ljava_time_LocalDate.prototype;
$c_Ljava_time_LocalDate.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this, field);
});
$c_Ljava_time_LocalDate.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    if ($n(f).isDateBased__Z()) {
      var x = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
      if ((x === null)) {
        var $x_1 = (f === null);
      } else {
        var this$1 = $n(x);
        var $x_1 = (this$1 === f);
      }
      if ($x_1) {
        var $x_2 = $m_Ljava_time_temporal_ValueRange$();
        var value = this.lengthOfMonth__I();
        var hi = (value >> 31);
        return $x_2.of__J__J__Ljava_time_temporal_ValueRange(1, 0, value, hi);
      } else {
        var x$3 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
        if ((x$3 === null)) {
          var $x_3 = (f === null);
        } else {
          var this$3 = $n(x$3);
          var $x_3 = (this$3 === f);
        }
        if ($x_3) {
          var $x_4 = $m_Ljava_time_temporal_ValueRange$();
          var value$1 = this.lengthOfYear__I();
          var hi$1 = (value$1 >> 31);
          return $x_4.of__J__J__Ljava_time_temporal_ValueRange(1, 0, value$1, hi$1);
        } else {
          var x$5 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          if ((x$5 === null)) {
            var $x_5 = (f === null);
          } else {
            var this$5 = $n(x$5);
            var $x_5 = (this$5 === f);
          }
          if ($x_5) {
            var $x_9 = $m_Ljava_time_temporal_ValueRange$();
            if (($m_Ljava_time_Month$().of__I__Ljava_time_Month(this.Ljava_time_LocalDate__f_month) === $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month())) {
              var $x_8 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
              var value$2 = this.Ljava_time_LocalDate__f_year;
              var hi$2 = (value$2 >> 31);
              var $x_7 = (!$n($x_8).isLeapYear__J__Z(value$2, hi$2));
            } else {
              var $x_7 = false;
            }
            if ($x_7) {
              var $x_6_$_lo = 4;
              var $x_6_$_hi = 0;
            } else {
              var $x_6_$_lo = 5;
              var $x_6_$_hi = 0;
            }
            return $x_9.of__J__J__Ljava_time_temporal_ValueRange(1, 0, $x_6_$_lo, $x_6_$_hi);
          } else {
            var x$7 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
            if ((x$7 === null)) {
              var $x_10 = (f === null);
            } else {
              var this$7 = $n(x$7);
              var $x_10 = (this$7 === f);
            }
            if ($x_10) {
              if ((this.Ljava_time_LocalDate__f_year <= 0)) {
                var $x_11 = $m_Ljava_time_temporal_ValueRange$();
                var value$3 = $m_Ljava_time_Year$().MAX_VALUE__I();
                var hi$3 = (value$3 >> 31);
                var lo = ((1 + value$3) | 0);
                var hi$4 = ((hi$3 + (((value$3 & (~lo)) >>> 31) | 0)) | 0);
                return $x_11.of__J__J__Ljava_time_temporal_ValueRange(1, 0, lo, hi$4);
              } else {
                var $x_12 = $m_Ljava_time_temporal_ValueRange$();
                var value$4 = $m_Ljava_time_Year$().MAX_VALUE__I();
                var hi$5 = (value$4 >> 31);
                return $x_12.of__J__J__Ljava_time_temporal_ValueRange(1, 0, value$4, hi$5);
              }
            } else {
              var this$11 = $n(field);
              return this$11.Ljava_time_temporal_ChronoField__f__range;
            }
          }
        }
      }
    } else {
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
    }
  } else {
    var this$12 = $n(field);
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$12);
  }
});
$c_Ljava_time_LocalDate.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var $x_1 = $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    return x_$_lo;
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$c_Ljava_time_LocalDate.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ((field === $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
      return this.toEpochDay__J();
    }
    if ((field === $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField())) {
      return $p_Ljava_time_LocalDate__getProlepticMonth__J(this);
    }
    return $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field);
  } else {
    var this$1 = $n(field);
    return this.getLong__Ljava_time_temporal_TemporalField__J(this$1);
  }
});
$c_Ljava_time_LocalDate.prototype.getDayOfYear__I = (function() {
  var $x_2 = $m_Ljava_time_Month$().of__I__Ljava_time_Month(this.Ljava_time_LocalDate__f_month);
  var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  return (((($n($x_2).firstDayOfYear__Z__I($n($x_1).isLeapYear__J__Z(value, hi)) + this.Ljava_time_LocalDate__f_day) | 0) - 1) | 0);
});
$c_Ljava_time_LocalDate.prototype.getDayOfWeek__Ljava_time_DayOfWeek = (function() {
  var $x_1 = this.toEpochDay__J();
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var lo = ((3 + x_$_lo) | 0);
  var hi = ((x_$_hi + (((x_$_lo & (~lo)) >>> 31) | 0)) | 0);
  var hi$1 = (hi >> 31);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(37449, b0);
  var a1b0 = Math.imul(18724, b0);
  var a0b1 = Math.imul(37449, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((((Math.imul(18724, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & lo);
  var b1$1 = ((lo >>> 16) | 0);
  var a0b0$1 = Math.imul(18725, b0$1);
  var a1b0$1 = Math.imul(9362, b0$1);
  var a0b1$1 = Math.imul(18725, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((Math.imul(9362, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$3 = ((lo$1 + hi$3) | 0);
  var hi$4 = ((hi$2 + ((((lo$1 & hi$3) | ((lo$1 | hi$3) & (~lo$3))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & hi);
  var b1$2 = ((hi >>> 16) | 0);
  var a0b0$2 = Math.imul(37449, b0$2);
  var a1b0$2 = Math.imul(18724, b0$2);
  var a0b1$2 = Math.imul(37449, b1$2);
  var lo$4 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$5 = ((((((Math.imul(1227133513, hi$1) + Math.imul(18724, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$6 = (hi$4 >> 31);
  var lo$5 = ((lo$4 + hi$4) | 0);
  var hi$7 = ((((hi$5 + hi$6) | 0) + ((((lo$4 & hi$4) | ((lo$4 | hi$4) & (~lo$5))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & hi);
  var b1$3 = ((hi >>> 16) | 0);
  var a0b0$3 = Math.imul(18725, b0$3);
  var a1b0$3 = Math.imul(9362, b0$3);
  var a0b1$3 = Math.imul(18725, b1$3);
  var lo$6 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$8 = ((((((Math.imul(613566757, hi$1) + Math.imul(9362, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$7 = ((lo$3 + lo$6) | 0);
  var hi$9 = ((hi$8 + ((((lo$3 & lo$6) | ((lo$3 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
  var hi$10 = (hi$9 >> 31);
  var lo$8 = ((lo$5 + hi$9) | 0);
  var hi$11 = ((((hi$7 + hi$10) | 0) + ((((lo$5 & hi$9) | ((lo$5 | hi$9) & (~lo$8))) >>> 31) | 0)) | 0);
  var lo$9 = (((lo$8 >>> 1) | 0) | (hi$11 << 31));
  var hi$12 = (hi$11 >> 1);
  var lo$10 = ((hi >>> 31) | 0);
  var lo$11 = ((lo$9 + lo$10) | 0);
  var hi$13 = ((hi$12 + ((((lo$9 & lo$10) | ((lo$9 | lo$10) & (~lo$11))) >>> 31) | 0)) | 0);
  var b0$4 = (65535 & lo$11);
  var b1$4 = ((lo$11 >>> 16) | 0);
  var a0b0$4 = Math.imul(7, b0$4);
  var a0b1$4 = Math.imul(7, b1$4);
  var lo$12 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$14 = ((Math.imul(7, hi$13) + ((c1part$4 >>> 16) | 0)) | 0);
  var lo$13 = ((lo - lo$12) | 0);
  var hi$15 = ((((hi - hi$14) | 0) + ((((~lo) & lo$12) | ((~(lo ^ lo$12)) & lo$13)) >> 31)) | 0);
  if (((hi >= 0) || ((lo$13 | hi$15) === 0))) {
    var x$1_$_lo = lo$13;
    var x$1_$_hi = hi$15;
  } else {
    var lo$15 = ((7 + lo$13) | 0);
    var hi$16 = ((hi$15 + (((lo$13 & (~lo$15)) >>> 31) | 0)) | 0);
    var x$1_$_lo = lo$15;
    var x$1_$_hi = hi$16;
  }
  return $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(((1 + x$1_$_lo) | 0));
});
$c_Ljava_time_LocalDate.prototype.lengthOfMonth__I = (function() {
  var x3 = this.Ljava_time_LocalDate__f_month;
  switch (x3) {
    case 2: {
      var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      var value = this.Ljava_time_LocalDate__f_year;
      var hi = (value >> 31);
      if ($n($x_1).isLeapYear__J__Z(value, hi)) {
        return 29;
      } else {
        return 28;
      }
      break;
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      return 30;
      break;
    }
    default: {
      return 31;
    }
  }
});
$c_Ljava_time_LocalDate.prototype.lengthOfYear__I = (function() {
  var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  if ($n($x_1).isLeapYear__J__Z(value, hi)) {
    return 366;
  } else {
    return 365;
  }
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var f = $as_Ljava_time_temporal_ChronoField(field);
    var this$1 = $n(f);
    $n(this$1.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue_$_lo, newValue_$_hi, this$1);
    var x = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    if ((x === null)) {
      var $x_1 = (f === null);
    } else {
      var this$2 = $n(x);
      var $x_1 = (this$2 === f);
    }
    if ($x_1) {
      var value = $n(this.getDayOfWeek__Ljava_time_DayOfWeek()).getValue__I();
      var hi = (value >> 31);
      var lo = ((newValue_$_lo - value) | 0);
      var hi$1 = ((((newValue_$_hi - hi) | 0) + ((((~newValue_$_lo) & value) | ((~(newValue_$_lo ^ value)) & lo)) >> 31)) | 0);
      return this.plusDays__J__Ljava_time_LocalDate(lo, hi$1);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
    if ((x$3 === null)) {
      var $x_2 = (f === null);
    } else {
      var this$5 = $n(x$3);
      var $x_2 = (this$5 === f);
    }
    if ($x_2) {
      var $x_3 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField());
      var x$1_$_lo = $x_3.l;
      var x$1_$_hi = $x_3.h;
      var lo$1 = ((newValue_$_lo - x$1_$_lo) | 0);
      var hi$2 = ((((newValue_$_hi - x$1_$_hi) | 0) + ((((~newValue_$_lo) & x$1_$_lo) | ((~(newValue_$_lo ^ x$1_$_lo)) & lo$1)) >> 31)) | 0);
      return this.plusDays__J__Ljava_time_LocalDate(lo$1, hi$2);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
    if ((x$5 === null)) {
      var $x_4 = (f === null);
    } else {
      var this$7 = $n(x$5);
      var $x_4 = (this$7 === f);
    }
    if ($x_4) {
      var $x_5 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField());
      var x$2_$_lo = $x_5.l;
      var x$2_$_hi = $x_5.h;
      var lo$2 = ((newValue_$_lo - x$2_$_lo) | 0);
      var hi$3 = ((((newValue_$_hi - x$2_$_hi) | 0) + ((((~newValue_$_lo) & x$2_$_lo) | ((~(newValue_$_lo ^ x$2_$_lo)) & lo$2)) >> 31)) | 0);
      return this.plusDays__J__Ljava_time_LocalDate(lo$2, hi$3);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
    if ((x$7 === null)) {
      var $x_6 = (f === null);
    } else {
      var this$9 = $n(x$7);
      var $x_6 = (this$9 === f);
    }
    if ($x_6) {
      return this.withDayOfMonth__I__Ljava_time_LocalDate(newValue_$_lo);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
    if ((x$9 === null)) {
      var $x_7 = (f === null);
    } else {
      var this$11 = $n(x$9);
      var $x_7 = (this$11 === f);
    }
    if ($x_7) {
      return this.withDayOfYear__I__Ljava_time_LocalDate(newValue_$_lo);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
    if ((x$11 === null)) {
      var $x_8 = (f === null);
    } else {
      var this$13 = $n(x$11);
      var $x_8 = (this$13 === f);
    }
    if ($x_8) {
      return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(newValue_$_lo, newValue_$_hi);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
    if ((x$13 === null)) {
      var $x_9 = (f === null);
    } else {
      var this$14 = $n(x$13);
      var $x_9 = (this$14 === f);
    }
    if ($x_9) {
      var $x_10 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
      var x$4_$_lo = $x_10.l;
      var x$4_$_hi = $x_10.h;
      var lo$3 = ((newValue_$_lo - x$4_$_lo) | 0);
      var hi$4 = ((((newValue_$_hi - x$4_$_hi) | 0) + ((((~newValue_$_lo) & x$4_$_lo) | ((~(newValue_$_lo ^ x$4_$_lo)) & lo$3)) >> 31)) | 0);
      return this.plusWeeks__J__Ljava_time_LocalDate(lo$3, hi$4);
    }
    var x$15 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
    if ((x$15 === null)) {
      var $x_11 = (f === null);
    } else {
      var this$16 = $n(x$15);
      var $x_11 = (this$16 === f);
    }
    if ($x_11) {
      var $x_12 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
      var x$6_$_lo = $x_12.l;
      var x$6_$_hi = $x_12.h;
      var lo$4 = ((newValue_$_lo - x$6_$_lo) | 0);
      var hi$5 = ((((newValue_$_hi - x$6_$_hi) | 0) + ((((~newValue_$_lo) & x$6_$_lo) | ((~(newValue_$_lo ^ x$6_$_lo)) & lo$4)) >> 31)) | 0);
      return this.plusWeeks__J__Ljava_time_LocalDate(lo$4, hi$5);
    }
    var x$17 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    if ((x$17 === null)) {
      var $x_13 = (f === null);
    } else {
      var this$18 = $n(x$17);
      var $x_13 = (this$18 === f);
    }
    if ($x_13) {
      return this.withMonth__I__Ljava_time_LocalDate(newValue_$_lo);
    }
    var x$19 = $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
    if ((x$19 === null)) {
      var $x_14 = (f === null);
    } else {
      var this$20 = $n(x$19);
      var $x_14 = (this$20 === f);
    }
    if ($x_14) {
      var $x_15 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField());
      var x$8_$_lo = $x_15.l;
      var x$8_$_hi = $x_15.h;
      var lo$5 = ((newValue_$_lo - x$8_$_lo) | 0);
      var hi$6 = ((((newValue_$_hi - x$8_$_hi) | 0) + ((((~newValue_$_lo) & x$8_$_lo) | ((~(newValue_$_lo ^ x$8_$_lo)) & lo$5)) >> 31)) | 0);
      return this.plusMonths__J__Ljava_time_LocalDate(lo$5, hi$6);
    }
    var x$21 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
    if ((x$21 === null)) {
      var $x_16 = (f === null);
    } else {
      var this$22 = $n(x$21);
      var $x_16 = (this$22 === f);
    }
    if ($x_16) {
      if ((this.Ljava_time_LocalDate__f_year >= 1)) {
        var x$10_$_lo = newValue_$_lo;
        var x$10_$_hi = newValue_$_hi;
      } else {
        var lo$6 = ((1 - newValue_$_lo) | 0);
        var hi$7 = ((((-newValue_$_hi) | 0) + ((newValue_$_lo | lo$6) >> 31)) | 0);
        var x$10_$_lo = lo$6;
        var x$10_$_hi = hi$7;
      }
      return this.withYear__I__Ljava_time_LocalDate(x$10_$_lo);
    }
    var x$23 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    if ((x$23 === null)) {
      var $x_17 = (f === null);
    } else {
      var this$25 = $n(x$23);
      var $x_17 = (this$25 === f);
    }
    if ($x_17) {
      return this.withYear__I__Ljava_time_LocalDate(newValue_$_lo);
    }
    var x$25 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
    if ((x$25 === null)) {
      var $x_18 = (f === null);
    } else {
      var this$27 = $n(x$25);
      var $x_18 = (this$27 === f);
    }
    if ($x_18) {
      var $x_19 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var x$12_$_lo = $x_19.l;
      var x$12_$_hi = $x_19.h;
      if ((((x$12_$_lo ^ newValue_$_lo) | (x$12_$_hi ^ newValue_$_hi)) === 0)) {
        return this;
      } else {
        return this.withYear__I__Ljava_time_LocalDate(((1 - this.Ljava_time_LocalDate__f_year) | 0));
      }
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var this$29 = $n(field);
    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(this$29, newValue_$_lo, newValue_$_hi);
  }
});
$c_Ljava_time_LocalDate.prototype.withYear__I__Ljava_time_LocalDate = (function(year) {
  if ((this.Ljava_time_LocalDate__f_year === year)) {
    return this;
  } else {
    var this$2 = $n($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
    var hi = (year >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(year, hi, this$2);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(year, this.Ljava_time_LocalDate__f_month, this.Ljava_time_LocalDate__f_day);
  }
});
$c_Ljava_time_LocalDate.prototype.withMonth__I__Ljava_time_LocalDate = (function(month) {
  if ((this.Ljava_time_LocalDate__f_month === month)) {
    return this;
  } else {
    var this$2 = $n($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
    var hi = (month >> 31);
    $n(this$2.Ljava_time_temporal_ChronoField__f__range).checkValidValue__J__Ljava_time_temporal_TemporalField__J(month, hi, this$2);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, month, this.Ljava_time_LocalDate__f_day);
  }
});
$c_Ljava_time_LocalDate.prototype.withDayOfMonth__I__Ljava_time_LocalDate = (function(dayOfMonth) {
  return ((this.Ljava_time_LocalDate__f_day === dayOfMonth) ? this : $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, this.Ljava_time_LocalDate__f_month, dayOfMonth));
});
$c_Ljava_time_LocalDate.prototype.withDayOfYear__I__Ljava_time_LocalDate = (function(dayOfYear) {
  return ((this.getDayOfYear__I() === dayOfYear) ? this : $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, dayOfYear));
});
$c_Ljava_time_LocalDate.prototype.plusMonths__J__Ljava_time_LocalDate = (function(monthsToAdd_$_lo, monthsToAdd_$_hi) {
  if (((monthsToAdd_$_lo | monthsToAdd_$_hi) === 0)) {
    return this;
  } else {
    var value = this.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    var b0 = (65535 & value);
    var b1 = ((value >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
    var value$1 = ((this.Ljava_time_LocalDate__f_month - 1) | 0);
    var hi$2 = (value$1 >> 31);
    var lo$1 = ((lo + value$1) | 0);
    var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo & value$1) | ((lo | value$1) & (~lo$1))) >>> 31) | 0)) | 0);
    var lo$2 = ((lo$1 + monthsToAdd_$_lo) | 0);
    var hi$4 = ((((hi$3 + monthsToAdd_$_hi) | 0) + ((((lo$1 & monthsToAdd_$_lo) | ((lo$1 | monthsToAdd_$_lo) & (~lo$2))) >>> 31) | 0)) | 0);
    var this$30 = $n($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
    var hi$5 = (hi$4 >> 31);
    var b0$1 = (65535 & lo$2);
    var b1$1 = ((lo$2 >>> 16) | 0);
    var a0b0$1 = Math.imul(43690, b0$1);
    var a1b0 = Math.imul(10922, b0$1);
    var a0b1$1 = Math.imul(43690, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$6 = ((((Math.imul(10922, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
    var b0$2 = (65535 & lo$2);
    var b1$2 = ((lo$2 >>> 16) | 0);
    var a0b0$2 = Math.imul(43691, b0$2);
    var a1b0$1 = Math.imul(43690, b0$2);
    var a0b1$2 = Math.imul(43691, b1$2);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$7 = ((((Math.imul(43690, b1$2) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$5 = ((lo$3 + hi$7) | 0);
    var hi$8 = ((hi$6 + ((((lo$3 & hi$7) | ((lo$3 | hi$7) & (~lo$5))) >>> 31) | 0)) | 0);
    var b0$3 = (65535 & hi$4);
    var b1$3 = ((hi$4 >>> 16) | 0);
    var a0b0$3 = Math.imul(43690, b0$3);
    var a1b0$2 = Math.imul(10922, b0$3);
    var a0b1$3 = Math.imul(43690, b1$3);
    var lo$6 = ((a0b0$3 + (((a1b0$2 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$9 = ((((((Math.imul(715827882, hi$5) + Math.imul(10922, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$2) | 0) >>> 16) | 0)) | 0);
    var hi$10 = (hi$8 >> 31);
    var lo$7 = ((lo$6 + hi$8) | 0);
    var hi$11 = ((((hi$9 + hi$10) | 0) + ((((lo$6 & hi$8) | ((lo$6 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
    var b0$4 = (65535 & hi$4);
    var b1$4 = ((hi$4 >>> 16) | 0);
    var a0b0$4 = Math.imul(43691, b0$4);
    var a1b0$3 = Math.imul(43690, b0$4);
    var a0b1$4 = Math.imul(43691, b1$4);
    var lo$8 = ((a0b0$4 + (((a1b0$3 + a0b1$4) | 0) << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$12 = ((((((Math.imul((-1431655765), hi$5) + Math.imul(43690, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$3) | 0) >>> 16) | 0)) | 0);
    var lo$9 = ((lo$5 + lo$8) | 0);
    var hi$13 = ((hi$12 + ((((lo$5 & lo$8) | ((lo$5 | lo$8) & (~lo$9))) >>> 31) | 0)) | 0);
    var hi$14 = (hi$13 >> 31);
    var lo$10 = ((lo$7 + hi$13) | 0);
    var hi$15 = ((((hi$11 + hi$14) | 0) + ((((lo$7 & hi$13) | ((lo$7 | hi$13) & (~lo$10))) >>> 31) | 0)) | 0);
    var lo$11 = (((lo$10 >>> 1) | 0) | (hi$15 << 31));
    var hi$16 = (hi$15 >> 1);
    var lo$12 = ((hi$4 >>> 31) | 0);
    var lo$13 = ((lo$11 + lo$12) | 0);
    var hi$17 = ((hi$16 + ((((lo$11 & lo$12) | ((lo$11 | lo$12) & (~lo$13))) >>> 31) | 0)) | 0);
    if ((hi$4 >= 0)) {
      var $x_1 = true;
    } else {
      var b0$5 = (65535 & lo$13);
      var b1$5 = ((lo$13 >>> 16) | 0);
      var a0b0$5 = Math.imul(12, b0$5);
      var a0b1$5 = Math.imul(12, b1$5);
      var lo$15 = ((a0b0$5 + (a0b1$5 << 16)) | 0);
      var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
      var hi$18 = ((Math.imul(12, hi$17) + ((c1part$5 >>> 16) | 0)) | 0);
      var $x_1 = (((lo$15 ^ lo$2) | (hi$18 ^ hi$4)) === 0);
    }
    if ($x_1) {
      var value$2_$_lo = lo$13;
      var value$2_$_hi = hi$17;
    } else {
      var lo$16 = ((lo$13 - 1) | 0);
      var hi$19 = ((((hi$17 - 1) | 0) + (((lo$13 | (~lo$16)) >>> 31) | 0)) | 0);
      var value$2_$_lo = lo$16;
      var value$2_$_hi = hi$19;
    }
    var newYear = $n(this$30.Ljava_time_temporal_ChronoField__f__range).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(value$2_$_lo, value$2_$_hi, this$30);
    var hi$20 = (hi$4 >> 31);
    var b0$6 = (65535 & lo$2);
    var b1$6 = ((lo$2 >>> 16) | 0);
    var a0b0$6 = Math.imul(43690, b0$6);
    var a1b0$4 = Math.imul(10922, b0$6);
    var a0b1$6 = Math.imul(43690, b1$6);
    var lo$17 = ((a0b0$6 + (((a1b0$4 + a0b1$6) | 0) << 16)) | 0);
    var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
    var hi$21 = ((((Math.imul(10922, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$4) | 0) >>> 16) | 0)) | 0);
    var b0$7 = (65535 & lo$2);
    var b1$7 = ((lo$2 >>> 16) | 0);
    var a0b0$7 = Math.imul(43691, b0$7);
    var a1b0$5 = Math.imul(43690, b0$7);
    var a0b1$7 = Math.imul(43691, b1$7);
    var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
    var hi$22 = ((((Math.imul(43690, b1$7) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$5) | 0) >>> 16) | 0)) | 0);
    var lo$19 = ((lo$17 + hi$22) | 0);
    var hi$23 = ((hi$21 + ((((lo$17 & hi$22) | ((lo$17 | hi$22) & (~lo$19))) >>> 31) | 0)) | 0);
    var b0$8 = (65535 & hi$4);
    var b1$8 = ((hi$4 >>> 16) | 0);
    var a0b0$8 = Math.imul(43690, b0$8);
    var a1b0$6 = Math.imul(10922, b0$8);
    var a0b1$8 = Math.imul(43690, b1$8);
    var lo$20 = ((a0b0$8 + (((a1b0$6 + a0b1$8) | 0) << 16)) | 0);
    var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
    var hi$24 = ((((((Math.imul(715827882, hi$20) + Math.imul(10922, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$6) | 0) >>> 16) | 0)) | 0);
    var hi$25 = (hi$23 >> 31);
    var lo$21 = ((lo$20 + hi$23) | 0);
    var hi$26 = ((((hi$24 + hi$25) | 0) + ((((lo$20 & hi$23) | ((lo$20 | hi$23) & (~lo$21))) >>> 31) | 0)) | 0);
    var b0$9 = (65535 & hi$4);
    var b1$9 = ((hi$4 >>> 16) | 0);
    var a0b0$9 = Math.imul(43691, b0$9);
    var a1b0$7 = Math.imul(43690, b0$9);
    var a0b1$9 = Math.imul(43691, b1$9);
    var lo$22 = ((a0b0$9 + (((a1b0$7 + a0b1$9) | 0) << 16)) | 0);
    var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
    var hi$27 = ((((((Math.imul((-1431655765), hi$20) + Math.imul(43690, b1$9)) | 0) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$7) | 0) >>> 16) | 0)) | 0);
    var lo$23 = ((lo$19 + lo$22) | 0);
    var hi$28 = ((hi$27 + ((((lo$19 & lo$22) | ((lo$19 | lo$22) & (~lo$23))) >>> 31) | 0)) | 0);
    var hi$29 = (hi$28 >> 31);
    var lo$24 = ((lo$21 + hi$28) | 0);
    var hi$30 = ((((hi$26 + hi$29) | 0) + ((((lo$21 & hi$28) | ((lo$21 | hi$28) & (~lo$24))) >>> 31) | 0)) | 0);
    var lo$25 = (((lo$24 >>> 1) | 0) | (hi$30 << 31));
    var hi$31 = (hi$30 >> 1);
    var lo$26 = ((hi$4 >>> 31) | 0);
    var lo$27 = ((lo$25 + lo$26) | 0);
    var hi$32 = ((hi$31 + ((((lo$25 & lo$26) | ((lo$25 | lo$26) & (~lo$27))) >>> 31) | 0)) | 0);
    var b0$10 = (65535 & lo$27);
    var b1$10 = ((lo$27 >>> 16) | 0);
    var a0b0$10 = Math.imul(12, b0$10);
    var a0b1$10 = Math.imul(12, b1$10);
    var lo$28 = ((a0b0$10 + (a0b1$10 << 16)) | 0);
    var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
    var hi$33 = ((Math.imul(12, hi$32) + ((c1part$10 >>> 16) | 0)) | 0);
    var lo$29 = ((lo$2 - lo$28) | 0);
    var hi$34 = ((((hi$4 - hi$33) | 0) + ((((~lo$2) & lo$28) | ((~(lo$2 ^ lo$28)) & lo$29)) >> 31)) | 0);
    if (((hi$4 >= 0) || ((lo$29 | hi$34) === 0))) {
      var x_$_lo = lo$29;
      var x_$_hi = hi$34;
    } else {
      var lo$31 = ((12 + lo$29) | 0);
      var hi$35 = ((hi$34 + (((lo$29 & (~lo$31)) >>> 31) | 0)) | 0);
      var x_$_lo = lo$31;
      var x_$_hi = hi$35;
    }
    var newMonth = ((1 + x_$_lo) | 0);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(newYear, newMonth, this.Ljava_time_LocalDate__f_day);
  }
});
$c_Ljava_time_LocalDate.prototype.plusWeeks__J__Ljava_time_LocalDate = (function(weeksToAdd_$_lo, weeksToAdd_$_hi) {
  var this$1 = $m_jl_Math$();
  var b0 = (65535 & weeksToAdd_$_lo);
  var b1 = ((weeksToAdd_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(7, b0);
  var a0b1 = Math.imul(7, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((Math.imul(7, weeksToAdd_$_hi) + ((c1part >>> 16) | 0)) | 0);
  if (((weeksToAdd_$_lo | weeksToAdd_$_hi) !== 0)) {
    var $x_2 = $m_RTLong$().divide__I__I__I__I__J(lo, hi, weeksToAdd_$_lo, weeksToAdd_$_hi);
    var x_$_lo = $x_2.l;
    var x_$_hi = $x_2.h;
    var $x_1 = (((7 ^ x_$_lo) | x_$_hi) !== 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    this$1.java$lang$Math$$longOverflow__E();
  }
  return this.plusDays__J__Ljava_time_LocalDate(lo, hi);
});
$c_Ljava_time_LocalDate.prototype.plusDays__J__Ljava_time_LocalDate = (function(daysToAdd_$_lo, daysToAdd_$_hi) {
  if (((daysToAdd_$_lo | daysToAdd_$_hi) === 0)) {
    return this;
  } else {
    var $x_1 = this.toEpochDay__J();
    var a_$_lo = $x_1.l;
    var a_$_hi = $x_1.h;
    var this$2 = $m_jl_Math$();
    var lo = ((a_$_lo + daysToAdd_$_lo) | 0);
    var hi = ((((a_$_hi + daysToAdd_$_hi) | 0) + ((((a_$_lo & daysToAdd_$_lo) | ((a_$_lo | daysToAdd_$_lo) & (~lo))) >>> 31) | 0)) | 0);
    var hi$1 = (hi ^ a_$_hi);
    var hi$2 = (hi ^ daysToAdd_$_hi);
    var hi$3 = (hi$1 & hi$2);
    if ((hi$3 < 0)) {
      this$2.java$lang$Math$$longOverflow__E();
    }
    return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(lo, hi);
  }
});
$c_Ljava_time_LocalDate.prototype.minusDays__J__Ljava_time_LocalDate = (function(daysToSubtract_$_lo, daysToSubtract_$_hi) {
  if (((daysToSubtract_$_lo | ((-2147483648) ^ daysToSubtract_$_hi)) === 0)) {
    return $n(this.plusDays__J__Ljava_time_LocalDate((-1), 2147483647)).plusDays__J__Ljava_time_LocalDate(1, 0);
  } else {
    var lo = ((-daysToSubtract_$_lo) | 0);
    var hi = ((((-daysToSubtract_$_hi) | 0) + ((daysToSubtract_$_lo | lo) >> 31)) | 0);
    return this.plusDays__J__Ljava_time_LocalDate(lo, hi);
  }
});
$c_Ljava_time_LocalDate.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? this : $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O(this, query));
});
$c_Ljava_time_LocalDate.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x6 = $as_Ljava_time_temporal_ChronoUnit(unit);
    var x = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if ((x === null)) {
      var $x_1 = (x6 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x6);
    }
    if ($x_1) {
      return this.daysUntil__Ljava_time_LocalDate__J(end);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
    if ((x$3 === null)) {
      var $x_2 = (x6 === null);
    } else {
      var this$2 = $n(x$3);
      var $x_2 = (this$2 === x6);
    }
    if ($x_2) {
      var $x_3 = this.daysUntil__Ljava_time_LocalDate__J(end);
      var num_$_lo = $x_3.l;
      var num_$_hi = $x_3.h;
      var hi = (num_$_hi >> 31);
      var b0 = (65535 & num_$_lo);
      var b1 = ((num_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(37449, b0);
      var a1b0 = Math.imul(18724, b0);
      var a0b1 = Math.imul(37449, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((((Math.imul(18724, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var b0$1 = (65535 & num_$_lo);
      var b1$1 = ((num_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(18725, b0$1);
      var a1b0$1 = Math.imul(9362, b0$1);
      var a0b1$1 = Math.imul(18725, b1$1);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$2 = ((((Math.imul(9362, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((lo + hi$2) | 0);
      var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
      var b0$2 = (65535 & num_$_hi);
      var b1$2 = ((num_$_hi >>> 16) | 0);
      var a0b0$2 = Math.imul(37449, b0$2);
      var a1b0$2 = Math.imul(18724, b0$2);
      var a0b1$2 = Math.imul(37449, b1$2);
      var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$4 = ((((((Math.imul(1227133513, hi) + Math.imul(18724, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
      var hi$5 = (hi$3 >> 31);
      var lo$4 = ((lo$3 + hi$3) | 0);
      var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
      var b0$3 = (65535 & num_$_hi);
      var b1$3 = ((num_$_hi >>> 16) | 0);
      var a0b0$3 = Math.imul(18725, b0$3);
      var a1b0$3 = Math.imul(9362, b0$3);
      var a0b1$3 = Math.imul(18725, b1$3);
      var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$7 = ((((((Math.imul(613566757, hi) + Math.imul(9362, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
      var lo$6 = ((lo$2 + lo$5) | 0);
      var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
      var hi$9 = (hi$8 >> 31);
      var lo$7 = ((lo$4 + hi$8) | 0);
      var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
      var lo$8 = (((lo$7 >>> 1) | 0) | (hi$10 << 31));
      var hi$11 = (hi$10 >> 1);
      var lo$9 = ((num_$_hi >>> 31) | 0);
      var lo$10 = ((lo$8 + lo$9) | 0);
      var hi$12 = ((hi$11 + ((((lo$8 & lo$9) | ((lo$8 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
      return $bL(lo$10, hi$12);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
    if ((x$5 === null)) {
      var $x_4 = (x6 === null);
    } else {
      var this$20 = $n(x$5);
      var $x_4 = (this$20 === x6);
    }
    if ($x_4) {
      return $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
    if ((x$7 === null)) {
      var $x_5 = (x6 === null);
    } else {
      var this$21 = $n(x$7);
      var $x_5 = (this$21 === x6);
    }
    if ($x_5) {
      var $x_6 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var num$1_$_lo = $x_6.l;
      var num$1_$_hi = $x_6.h;
      var hi$13 = (num$1_$_hi >> 31);
      var b0$4 = (65535 & num$1_$_lo);
      var b1$4 = ((num$1_$_lo >>> 16) | 0);
      var a0b0$4 = Math.imul(43690, b0$4);
      var a1b0$4 = Math.imul(10922, b0$4);
      var a0b1$4 = Math.imul(43690, b1$4);
      var lo$11 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$14 = ((((Math.imul(10922, b1$4) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
      var b0$5 = (65535 & num$1_$_lo);
      var b1$5 = ((num$1_$_lo >>> 16) | 0);
      var a0b0$5 = Math.imul(43691, b0$5);
      var a1b0$5 = Math.imul(43690, b0$5);
      var a0b1$5 = Math.imul(43691, b1$5);
      var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
      var hi$15 = ((((Math.imul(43690, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
      var lo$13 = ((lo$11 + hi$15) | 0);
      var hi$16 = ((hi$14 + ((((lo$11 & hi$15) | ((lo$11 | hi$15) & (~lo$13))) >>> 31) | 0)) | 0);
      var b0$6 = (65535 & num$1_$_hi);
      var b1$6 = ((num$1_$_hi >>> 16) | 0);
      var a0b0$6 = Math.imul(43690, b0$6);
      var a1b0$6 = Math.imul(10922, b0$6);
      var a0b1$6 = Math.imul(43690, b1$6);
      var lo$14 = ((a0b0$6 + (((a1b0$6 + a0b1$6) | 0) << 16)) | 0);
      var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
      var hi$17 = ((((((Math.imul(715827882, hi$13) + Math.imul(10922, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
      var hi$18 = (hi$16 >> 31);
      var lo$15 = ((lo$14 + hi$16) | 0);
      var hi$19 = ((((hi$17 + hi$18) | 0) + ((((lo$14 & hi$16) | ((lo$14 | hi$16) & (~lo$15))) >>> 31) | 0)) | 0);
      var b0$7 = (65535 & num$1_$_hi);
      var b1$7 = ((num$1_$_hi >>> 16) | 0);
      var a0b0$7 = Math.imul(43691, b0$7);
      var a1b0$7 = Math.imul(43690, b0$7);
      var a0b1$7 = Math.imul(43691, b1$7);
      var lo$16 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
      var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
      var hi$20 = ((((((Math.imul((-1431655765), hi$13) + Math.imul(43690, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
      var lo$17 = ((lo$13 + lo$16) | 0);
      var hi$21 = ((hi$20 + ((((lo$13 & lo$16) | ((lo$13 | lo$16) & (~lo$17))) >>> 31) | 0)) | 0);
      var hi$22 = (hi$21 >> 31);
      var lo$18 = ((lo$15 + hi$21) | 0);
      var hi$23 = ((((hi$19 + hi$22) | 0) + ((((lo$15 & hi$21) | ((lo$15 | hi$21) & (~lo$18))) >>> 31) | 0)) | 0);
      var lo$19 = (((lo$18 >>> 1) | 0) | (hi$23 << 31));
      var hi$24 = (hi$23 >> 1);
      var lo$20 = ((num$1_$_hi >>> 31) | 0);
      var lo$21 = ((lo$19 + lo$20) | 0);
      var hi$25 = ((hi$24 + ((((lo$19 & lo$20) | ((lo$19 | lo$20) & (~lo$21))) >>> 31) | 0)) | 0);
      return $bL(lo$21, hi$25);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit();
    if ((x$9 === null)) {
      var $x_7 = (x6 === null);
    } else {
      var this$39 = $n(x$9);
      var $x_7 = (this$39 === x6);
    }
    if ($x_7) {
      var $x_8 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var num$2_$_lo = $x_8.l;
      var num$2_$_hi = $x_8.h;
      var hi$26 = (num$2_$_hi >> 31);
      var b0$8 = (65535 & num$2_$_lo);
      var b1$8 = ((num$2_$_lo >>> 16) | 0);
      var a0b0$8 = Math.imul(34952, b0$8);
      var a1b0$8 = Math.imul(34952, b0$8);
      var a0b1$8 = Math.imul(34952, b1$8);
      var lo$22 = ((a0b0$8 + (((a1b0$8 + a0b1$8) | 0) << 16)) | 0);
      var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
      var hi$27 = ((((((((-num$2_$_lo) | 0) + Math.imul(34952, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$8) | 0) >>> 16) | 0)) | 0);
      var b0$9 = (65535 & num$2_$_lo);
      var b1$9 = ((num$2_$_lo >>> 16) | 0);
      var a0b0$9 = Math.imul(34953, b0$9);
      var a1b0$9 = Math.imul(34952, b0$9);
      var a0b1$9 = Math.imul(34953, b1$9);
      var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
      var hi$28 = ((((Math.imul(34952, b1$9) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$9) | 0) >>> 16) | 0)) | 0);
      var lo$24 = ((lo$22 + hi$28) | 0);
      var hi$29 = ((hi$27 + ((((lo$22 & hi$28) | ((lo$22 | hi$28) & (~lo$24))) >>> 31) | 0)) | 0);
      var b0$10 = (65535 & num$2_$_hi);
      var b1$10 = ((num$2_$_hi >>> 16) | 0);
      var a0b0$10 = Math.imul(34952, b0$10);
      var a1b0$10 = Math.imul(34952, b0$10);
      var a0b1$10 = Math.imul(34952, b1$10);
      var lo$25 = ((a0b0$10 + (((a1b0$10 + a0b1$10) | 0) << 16)) | 0);
      var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
      var hi$30 = ((((((((Math.imul((-2004318072), hi$26) + ((-num$2_$_hi) | 0)) | 0) + Math.imul(34952, b1$10)) | 0) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$10) | 0) >>> 16) | 0)) | 0);
      var hi$31 = (hi$29 >> 31);
      var lo$26 = ((lo$25 + hi$29) | 0);
      var hi$32 = ((((hi$30 + hi$31) | 0) + ((((lo$25 & hi$29) | ((lo$25 | hi$29) & (~lo$26))) >>> 31) | 0)) | 0);
      var b0$11 = (65535 & num$2_$_hi);
      var b1$11 = ((num$2_$_hi >>> 16) | 0);
      var a0b0$11 = Math.imul(34953, b0$11);
      var a1b0$11 = Math.imul(34952, b0$11);
      var a0b1$11 = Math.imul(34953, b1$11);
      var lo$27 = ((a0b0$11 + (((a1b0$11 + a0b1$11) | 0) << 16)) | 0);
      var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
      var hi$33 = ((((((Math.imul((-2004318071), hi$26) + Math.imul(34952, b1$11)) | 0) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$11) | 0) >>> 16) | 0)) | 0);
      var lo$28 = ((lo$24 + lo$27) | 0);
      var hi$34 = ((hi$33 + ((((lo$24 & lo$27) | ((lo$24 | lo$27) & (~lo$28))) >>> 31) | 0)) | 0);
      var hi$35 = (hi$34 >> 31);
      var lo$29 = ((lo$26 + hi$34) | 0);
      var hi$36 = ((((hi$32 + hi$35) | 0) + ((((lo$26 & hi$34) | ((lo$26 | hi$34) & (~lo$29))) >>> 31) | 0)) | 0);
      var lo$30 = ((lo$29 + num$2_$_lo) | 0);
      var hi$37 = ((((hi$36 + num$2_$_hi) | 0) + ((((lo$29 & num$2_$_lo) | ((lo$29 | num$2_$_lo) & (~lo$30))) >>> 31) | 0)) | 0);
      var lo$31 = (((lo$30 >>> 6) | 0) | (hi$37 << 26));
      var hi$38 = (hi$37 >> 6);
      var lo$32 = ((num$2_$_hi >>> 31) | 0);
      var lo$33 = ((lo$31 + lo$32) | 0);
      var hi$39 = ((hi$38 + ((((lo$31 & lo$32) | ((lo$31 | lo$32) & (~lo$33))) >>> 31) | 0)) | 0);
      return $bL(lo$33, hi$39);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit();
    if ((x$11 === null)) {
      var $x_9 = (x6 === null);
    } else {
      var this$58 = $n(x$11);
      var $x_9 = (this$58 === x6);
    }
    if ($x_9) {
      var $x_10 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var num$3_$_lo = $x_10.l;
      var num$3_$_hi = $x_10.h;
      var hi$40 = (num$3_$_hi >> 31);
      var b0$12 = (65535 & num$3_$_lo);
      var b1$12 = ((num$3_$_lo >>> 16) | 0);
      var a0b0$12 = Math.imul(1747, b0$12);
      var a1b0$12 = Math.imul(27962, b0$12);
      var a0b1$12 = Math.imul(1747, b1$12);
      var lo$34 = ((a0b0$12 + (((a1b0$12 + a0b1$12) | 0) << 16)) | 0);
      var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
      var hi$41 = ((((Math.imul(27962, b1$12) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$12) | 0) >>> 16) | 0)) | 0);
      var b0$13 = (65535 & num$3_$_lo);
      var b1$13 = ((num$3_$_lo >>> 16) | 0);
      var a0b0$13 = Math.imul(14855, b0$13);
      var a1b0$13 = Math.imul(41069, b0$13);
      var a0b1$13 = Math.imul(14855, b1$13);
      var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
      var hi$42 = ((((Math.imul(41069, b1$13) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$13) | 0) >>> 16) | 0)) | 0);
      var lo$36 = ((lo$34 + hi$42) | 0);
      var hi$43 = ((hi$41 + ((((lo$34 & hi$42) | ((lo$34 | hi$42) & (~lo$36))) >>> 31) | 0)) | 0);
      var b0$14 = (65535 & num$3_$_hi);
      var b1$14 = ((num$3_$_hi >>> 16) | 0);
      var a0b0$14 = Math.imul(1747, b0$14);
      var a1b0$14 = Math.imul(27962, b0$14);
      var a0b1$14 = Math.imul(1747, b1$14);
      var lo$37 = ((a0b0$14 + (((a1b0$14 + a0b1$14) | 0) << 16)) | 0);
      var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
      var hi$44 = ((((((Math.imul(1832519379, hi$40) + Math.imul(27962, b1$14)) | 0) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$14) | 0) >>> 16) | 0)) | 0);
      var hi$45 = (hi$43 >> 31);
      var lo$38 = ((lo$37 + hi$43) | 0);
      var hi$46 = ((((hi$44 + hi$45) | 0) + ((((lo$37 & hi$43) | ((lo$37 | hi$43) & (~lo$38))) >>> 31) | 0)) | 0);
      var b0$15 = (65535 & num$3_$_hi);
      var b1$15 = ((num$3_$_hi >>> 16) | 0);
      var a0b0$15 = Math.imul(14855, b0$15);
      var a1b0$15 = Math.imul(41069, b0$15);
      var a0b1$15 = Math.imul(14855, b1$15);
      var lo$39 = ((a0b0$15 + (((a1b0$15 + a0b1$15) | 0) << 16)) | 0);
      var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
      var hi$47 = ((((((Math.imul((-1603454457), hi$40) + Math.imul(41069, b1$15)) | 0) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$15) | 0) >>> 16) | 0)) | 0);
      var lo$40 = ((lo$36 + lo$39) | 0);
      var hi$48 = ((hi$47 + ((((lo$36 & lo$39) | ((lo$36 | lo$39) & (~lo$40))) >>> 31) | 0)) | 0);
      var hi$49 = (hi$48 >> 31);
      var lo$41 = ((lo$38 + hi$48) | 0);
      var hi$50 = ((((hi$46 + hi$49) | 0) + ((((lo$38 & hi$48) | ((lo$38 | hi$48) & (~lo$41))) >>> 31) | 0)) | 0);
      var lo$42 = (((lo$41 >>> 9) | 0) | (hi$50 << 23));
      var hi$51 = (hi$50 >> 9);
      var lo$43 = ((num$3_$_hi >>> 31) | 0);
      var lo$44 = ((lo$42 + lo$43) | 0);
      var hi$52 = ((hi$51 + ((((lo$42 & lo$43) | ((lo$42 | lo$43) & (~lo$44))) >>> 31) | 0)) | 0);
      return $bL(lo$44, hi$52);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit();
    if ((x$13 === null)) {
      var $x_11 = (x6 === null);
    } else {
      var this$76 = $n(x$13);
      var $x_11 = (this$76 === x6);
    }
    if ($x_11) {
      var $x_12 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var num$4_$_lo = $x_12.l;
      var num$4_$_hi = $x_12.h;
      var hi$53 = (num$4_$_hi >> 31);
      var b0$16 = (65535 & num$4_$_lo);
      var b1$16 = ((num$4_$_lo >>> 16) | 0);
      var a0b0$16 = Math.imul(15903, b0$16);
      var a1b0$16 = Math.imul(44739, b0$16);
      var a0b1$16 = Math.imul(15903, b1$16);
      var lo$45 = ((a0b0$16 + (((a1b0$16 + a0b1$16) | 0) << 16)) | 0);
      var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
      var hi$54 = ((((((((-num$4_$_lo) | 0) + Math.imul(44739, b1$16)) | 0) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$16) | 0) >>> 16) | 0)) | 0);
      var b0$17 = (65535 & num$4_$_lo);
      var b1$17 = ((num$4_$_lo >>> 16) | 0);
      var a0b0$17 = Math.imul(10661, b0$17);
      var a1b0$17 = Math.imul(26389, b0$17);
      var a0b1$17 = Math.imul(10661, b1$17);
      var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
      var hi$55 = ((((Math.imul(26389, b1$17) + ((c1part$17 >>> 16) | 0)) | 0) + (((((65535 & c1part$17) + a1b0$17) | 0) >>> 16) | 0)) | 0);
      var lo$47 = ((lo$45 + hi$55) | 0);
      var hi$56 = ((hi$54 + ((((lo$45 & hi$55) | ((lo$45 | hi$55) & (~lo$47))) >>> 31) | 0)) | 0);
      var b0$18 = (65535 & num$4_$_hi);
      var b1$18 = ((num$4_$_hi >>> 16) | 0);
      var a0b0$18 = Math.imul(15903, b0$18);
      var a1b0$18 = Math.imul(44739, b0$18);
      var a0b1$18 = Math.imul(15903, b1$18);
      var lo$48 = ((a0b0$18 + (((a1b0$18 + a0b1$18) | 0) << 16)) | 0);
      var c1part$18 = ((((a0b0$18 >>> 16) | 0) + a0b1$18) | 0);
      var hi$57 = ((((((((Math.imul((-1362936289), hi$53) + ((-num$4_$_hi) | 0)) | 0) + Math.imul(44739, b1$18)) | 0) + ((c1part$18 >>> 16) | 0)) | 0) + (((((65535 & c1part$18) + a1b0$18) | 0) >>> 16) | 0)) | 0);
      var hi$58 = (hi$56 >> 31);
      var lo$49 = ((lo$48 + hi$56) | 0);
      var hi$59 = ((((hi$57 + hi$58) | 0) + ((((lo$48 & hi$56) | ((lo$48 | hi$56) & (~lo$49))) >>> 31) | 0)) | 0);
      var b0$19 = (65535 & num$4_$_hi);
      var b1$19 = ((num$4_$_hi >>> 16) | 0);
      var a0b0$19 = Math.imul(10661, b0$19);
      var a1b0$19 = Math.imul(26389, b0$19);
      var a0b1$19 = Math.imul(10661, b1$19);
      var lo$50 = ((a0b0$19 + (((a1b0$19 + a0b1$19) | 0) << 16)) | 0);
      var c1part$19 = ((((a0b0$19 >>> 16) | 0) + a0b1$19) | 0);
      var hi$60 = ((((((Math.imul(1729440165, hi$53) + Math.imul(26389, b1$19)) | 0) + ((c1part$19 >>> 16) | 0)) | 0) + (((((65535 & c1part$19) + a1b0$19) | 0) >>> 16) | 0)) | 0);
      var lo$51 = ((lo$47 + lo$50) | 0);
      var hi$61 = ((hi$60 + ((((lo$47 & lo$50) | ((lo$47 | lo$50) & (~lo$51))) >>> 31) | 0)) | 0);
      var hi$62 = (hi$61 >> 31);
      var lo$52 = ((lo$49 + hi$61) | 0);
      var hi$63 = ((((hi$59 + hi$62) | 0) + ((((lo$49 & hi$61) | ((lo$49 | hi$61) & (~lo$52))) >>> 31) | 0)) | 0);
      var lo$53 = ((lo$52 + num$4_$_lo) | 0);
      var hi$64 = ((((hi$63 + num$4_$_hi) | 0) + ((((lo$52 & num$4_$_lo) | ((lo$52 | num$4_$_lo) & (~lo$53))) >>> 31) | 0)) | 0);
      var lo$54 = (((lo$53 >>> 13) | 0) | (hi$64 << 19));
      var hi$65 = (hi$64 >> 13);
      var lo$55 = ((num$4_$_hi >>> 31) | 0);
      var lo$56 = ((lo$54 + lo$55) | 0);
      var hi$66 = ((hi$65 + ((((lo$54 & lo$55) | ((lo$54 | lo$55) & (~lo$56))) >>> 31) | 0)) | 0);
      return $bL(lo$56, hi$66);
    }
    var x$15 = $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit();
    if ((x$15 === null)) {
      var $x_13 = (x6 === null);
    } else {
      var this$95 = $n(x$15);
      var $x_13 = (this$95 === x6);
    }
    if ($x_13) {
      var $x_14 = $n(end).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var x$1_$_lo = $x_14.l;
      var x$1_$_hi = $x_14.h;
      var $x_15 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var x$2_$_lo = $x_15.l;
      var x$2_$_hi = $x_15.h;
      var lo$57 = ((x$1_$_lo - x$2_$_lo) | 0);
      var hi$67 = ((((x$1_$_hi - x$2_$_hi) | 0) + ((((~x$1_$_lo) & x$2_$_lo) | ((~(x$1_$_lo ^ x$2_$_lo)) & lo$57)) >> 31)) | 0);
      return $bL(lo$57, hi$67);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  } else {
    var this$97 = $n(unit);
    return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end, this$97);
  }
});
$c_Ljava_time_LocalDate.prototype.daysUntil__Ljava_time_LocalDate__J = (function(end) {
  var $x_1 = $n(end).toEpochDay__J();
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var $x_2 = this.toEpochDay__J();
  var x$1_$_lo = $x_2.l;
  var x$1_$_hi = $x_2.h;
  var lo = ((x_$_lo - x$1_$_lo) | 0);
  var hi = ((((x_$_hi - x$1_$_hi) | 0) + ((((~x_$_lo) & x$1_$_lo) | ((~(x_$_lo ^ x$1_$_lo)) & lo)) >> 31)) | 0);
  return $bL(lo, hi);
});
$c_Ljava_time_LocalDate.prototype.toEpochDay__J = (function() {
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  var value$1 = this.Ljava_time_LocalDate__f_month;
  var hi$1 = (value$1 >> 31);
  var total_$_lo = 0;
  var total_$_hi = 0;
  var x_$_lo = total_$_lo;
  var x_$_hi = total_$_hi;
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(365, b0);
  var a0b1 = Math.imul(365, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((Math.imul(365, hi) + ((c1part >>> 16) | 0)) | 0);
  var lo$1 = ((x_$_lo + lo) | 0);
  var hi$3 = ((((x_$_hi + hi$2) | 0) + ((((x_$_lo & lo) | ((x_$_lo | lo) & (~lo$1))) >>> 31) | 0)) | 0);
  total_$_lo = lo$1;
  total_$_hi = hi$3;
  if ((hi >= 0)) {
    var x$1_$_lo = total_$_lo;
    var x$1_$_hi = total_$_hi;
    var lo$2 = ((3 + value) | 0);
    var hi$4 = ((hi + (((value & (~lo$2)) >>> 31) | 0)) | 0);
    var hi$5 = (hi$4 >> 1);
    var lo$4 = ((hi$5 >>> 30) | 0);
    var lo$5 = ((lo$2 + lo$4) | 0);
    var hi$6 = ((hi$4 + ((((lo$2 & lo$4) | ((lo$2 | lo$4) & (~lo$5))) >>> 31) | 0)) | 0);
    var lo$6 = (((lo$5 >>> 2) | 0) | (hi$6 << 30));
    var hi$7 = (hi$6 >> 2);
    var lo$7 = ((99 + value) | 0);
    var hi$8 = ((hi + (((value & (~lo$7)) >>> 31) | 0)) | 0);
    var hi$9 = (hi$8 >> 31);
    var b0$1 = (65535 & lo$7);
    var b1$1 = ((lo$7 >>> 16) | 0);
    var a0b0$1 = Math.imul(2621, b0$1);
    var a1b0 = Math.imul(41943, b0$1);
    var a0b1$1 = Math.imul(2621, b1$1);
    var lo$8 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$10 = ((((((((-lo$7) | 0) + Math.imul(41943, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
    var b0$2 = (65535 & lo$7);
    var b1$2 = ((lo$7 >>> 16) | 0);
    var a0b0$2 = Math.imul(55051, b0$2);
    var a1b0$1 = Math.imul(28835, b0$2);
    var a0b1$2 = Math.imul(55051, b1$2);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$11 = ((((Math.imul(28835, b1$2) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$10 = ((lo$8 + hi$11) | 0);
    var hi$12 = ((hi$10 + ((((lo$8 & hi$11) | ((lo$8 | hi$11) & (~lo$10))) >>> 31) | 0)) | 0);
    var b0$3 = (65535 & hi$8);
    var b1$3 = ((hi$8 >>> 16) | 0);
    var a0b0$3 = Math.imul(2621, b0$3);
    var a1b0$2 = Math.imul(41943, b0$3);
    var a0b1$3 = Math.imul(2621, b1$3);
    var lo$11 = ((a0b0$3 + (((a1b0$2 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$13 = ((((((((Math.imul((-1546188227), hi$9) + ((-hi$8) | 0)) | 0) + Math.imul(41943, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$2) | 0) >>> 16) | 0)) | 0);
    var hi$14 = (hi$12 >> 31);
    var lo$12 = ((lo$11 + hi$12) | 0);
    var hi$15 = ((((hi$13 + hi$14) | 0) + ((((lo$11 & hi$12) | ((lo$11 | hi$12) & (~lo$12))) >>> 31) | 0)) | 0);
    var b0$4 = (65535 & hi$8);
    var b1$4 = ((hi$8 >>> 16) | 0);
    var a0b0$4 = Math.imul(55051, b0$4);
    var a1b0$3 = Math.imul(28835, b0$4);
    var a0b1$4 = Math.imul(55051, b1$4);
    var lo$13 = ((a0b0$4 + (((a1b0$3 + a0b1$4) | 0) << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$16 = ((((((Math.imul(1889785611, hi$9) + Math.imul(28835, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$3) | 0) >>> 16) | 0)) | 0);
    var lo$14 = ((lo$10 + lo$13) | 0);
    var hi$17 = ((hi$16 + ((((lo$10 & lo$13) | ((lo$10 | lo$13) & (~lo$14))) >>> 31) | 0)) | 0);
    var hi$18 = (hi$17 >> 31);
    var lo$15 = ((lo$12 + hi$17) | 0);
    var hi$19 = ((((hi$15 + hi$18) | 0) + ((((lo$12 & hi$17) | ((lo$12 | hi$17) & (~lo$15))) >>> 31) | 0)) | 0);
    var lo$16 = ((lo$15 + lo$7) | 0);
    var hi$20 = ((((hi$19 + hi$8) | 0) + ((((lo$15 & lo$7) | ((lo$15 | lo$7) & (~lo$16))) >>> 31) | 0)) | 0);
    var lo$17 = (((lo$16 >>> 6) | 0) | (hi$20 << 26));
    var hi$21 = (hi$20 >> 6);
    var lo$18 = ((hi$8 >>> 31) | 0);
    var lo$19 = ((lo$17 + lo$18) | 0);
    var hi$22 = ((hi$21 + ((((lo$17 & lo$18) | ((lo$17 | lo$18) & (~lo$19))) >>> 31) | 0)) | 0);
    var lo$20 = ((lo$6 - lo$19) | 0);
    var hi$23 = ((((hi$7 - hi$22) | 0) + ((((~lo$6) & lo$19) | ((~(lo$6 ^ lo$19)) & lo$20)) >> 31)) | 0);
    var lo$21 = ((399 + value) | 0);
    var hi$24 = ((hi + (((value & (~lo$21)) >>> 31) | 0)) | 0);
    var hi$25 = (hi$24 >> 31);
    var b0$5 = (65535 & lo$21);
    var b1$5 = ((lo$21 >>> 16) | 0);
    var a0b0$5 = Math.imul(2621, b0$5);
    var a1b0$4 = Math.imul(41943, b0$5);
    var a0b1$5 = Math.imul(2621, b1$5);
    var lo$22 = ((a0b0$5 + (((a1b0$4 + a0b1$5) | 0) << 16)) | 0);
    var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
    var hi$26 = ((((((((-lo$21) | 0) + Math.imul(41943, b1$5)) | 0) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$4) | 0) >>> 16) | 0)) | 0);
    var b0$6 = (65535 & lo$21);
    var b1$6 = ((lo$21 >>> 16) | 0);
    var a0b0$6 = Math.imul(55051, b0$6);
    var a1b0$5 = Math.imul(28835, b0$6);
    var a0b1$6 = Math.imul(55051, b1$6);
    var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
    var hi$27 = ((((Math.imul(28835, b1$6) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$5) | 0) >>> 16) | 0)) | 0);
    var lo$24 = ((lo$22 + hi$27) | 0);
    var hi$28 = ((hi$26 + ((((lo$22 & hi$27) | ((lo$22 | hi$27) & (~lo$24))) >>> 31) | 0)) | 0);
    var b0$7 = (65535 & hi$24);
    var b1$7 = ((hi$24 >>> 16) | 0);
    var a0b0$7 = Math.imul(2621, b0$7);
    var a1b0$6 = Math.imul(41943, b0$7);
    var a0b1$7 = Math.imul(2621, b1$7);
    var lo$25 = ((a0b0$7 + (((a1b0$6 + a0b1$7) | 0) << 16)) | 0);
    var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
    var hi$29 = ((((((((Math.imul((-1546188227), hi$25) + ((-hi$24) | 0)) | 0) + Math.imul(41943, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$6) | 0) >>> 16) | 0)) | 0);
    var hi$30 = (hi$28 >> 31);
    var lo$26 = ((lo$25 + hi$28) | 0);
    var hi$31 = ((((hi$29 + hi$30) | 0) + ((((lo$25 & hi$28) | ((lo$25 | hi$28) & (~lo$26))) >>> 31) | 0)) | 0);
    var b0$8 = (65535 & hi$24);
    var b1$8 = ((hi$24 >>> 16) | 0);
    var a0b0$8 = Math.imul(55051, b0$8);
    var a1b0$7 = Math.imul(28835, b0$8);
    var a0b1$8 = Math.imul(55051, b1$8);
    var lo$27 = ((a0b0$8 + (((a1b0$7 + a0b1$8) | 0) << 16)) | 0);
    var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
    var hi$32 = ((((((Math.imul(1889785611, hi$25) + Math.imul(28835, b1$8)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$7) | 0) >>> 16) | 0)) | 0);
    var lo$28 = ((lo$24 + lo$27) | 0);
    var hi$33 = ((hi$32 + ((((lo$24 & lo$27) | ((lo$24 | lo$27) & (~lo$28))) >>> 31) | 0)) | 0);
    var hi$34 = (hi$33 >> 31);
    var lo$29 = ((lo$26 + hi$33) | 0);
    var hi$35 = ((((hi$31 + hi$34) | 0) + ((((lo$26 & hi$33) | ((lo$26 | hi$33) & (~lo$29))) >>> 31) | 0)) | 0);
    var lo$30 = ((lo$29 + lo$21) | 0);
    var hi$36 = ((((hi$35 + hi$24) | 0) + ((((lo$29 & lo$21) | ((lo$29 | lo$21) & (~lo$30))) >>> 31) | 0)) | 0);
    var lo$31 = (((lo$30 >>> 8) | 0) | (hi$36 << 24));
    var hi$37 = (hi$36 >> 8);
    var lo$32 = ((hi$24 >>> 31) | 0);
    var lo$33 = ((lo$31 + lo$32) | 0);
    var hi$38 = ((hi$37 + ((((lo$31 & lo$32) | ((lo$31 | lo$32) & (~lo$33))) >>> 31) | 0)) | 0);
    var lo$34 = ((lo$20 + lo$33) | 0);
    var hi$39 = ((((hi$23 + hi$38) | 0) + ((((lo$20 & lo$33) | ((lo$20 | lo$33) & (~lo$34))) >>> 31) | 0)) | 0);
    var lo$35 = ((x$1_$_lo + lo$34) | 0);
    var hi$40 = ((((x$1_$_hi + hi$39) | 0) + ((((x$1_$_lo & lo$34) | ((x$1_$_lo | lo$34) & (~lo$35))) >>> 31) | 0)) | 0);
    total_$_lo = lo$35;
    total_$_hi = hi$40;
  } else {
    var x$2_$_lo = total_$_lo;
    var x$2_$_hi = total_$_hi;
    var hi$41 = (hi >> 1);
    var lo$37 = ((hi$41 >>> 30) | 0);
    var lo$38 = ((value + lo$37) | 0);
    var hi$42 = ((hi + ((((value & lo$37) | ((value | lo$37) & (~lo$38))) >>> 31) | 0)) | 0);
    var lo$39 = (((lo$38 >>> 2) | 0) | (hi$42 << 30));
    var hi$43 = (hi$42 >> 2);
    var lo$40 = ((-lo$39) | 0);
    var hi$44 = ((((-hi$43) | 0) + ((lo$39 | lo$40) >> 31)) | 0);
    var hi$45 = (hi >> 31);
    var b0$9 = (65535 & value);
    var b1$9 = ((value >>> 16) | 0);
    var a0b0$9 = Math.imul(62914, b0$9);
    var a1b0$8 = Math.imul(23592, b0$9);
    var a0b1$9 = Math.imul(62914, b1$9);
    var lo$41 = ((a0b0$9 + (((a1b0$8 + a0b1$9) | 0) << 16)) | 0);
    var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
    var hi$46 = ((((Math.imul(23592, b1$9) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$8) | 0) >>> 16) | 0)) | 0);
    var b0$10 = (65535 & value);
    var b1$10 = ((value >>> 16) | 0);
    var a0b0$10 = Math.imul(10485, b0$10);
    var a1b0$9 = Math.imul(36700, b0$10);
    var a0b1$10 = Math.imul(10485, b1$10);
    var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
    var hi$47 = ((((Math.imul(36700, b1$10) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$9) | 0) >>> 16) | 0)) | 0);
    var lo$43 = ((lo$41 + hi$47) | 0);
    var hi$48 = ((hi$46 + ((((lo$41 & hi$47) | ((lo$41 | hi$47) & (~lo$43))) >>> 31) | 0)) | 0);
    var b0$11 = (65535 & hi);
    var b1$11 = ((hi >>> 16) | 0);
    var a0b0$11 = Math.imul(62914, b0$11);
    var a1b0$10 = Math.imul(23592, b0$11);
    var a0b1$11 = Math.imul(62914, b1$11);
    var lo$44 = ((a0b0$11 + (((a1b0$10 + a0b1$11) | 0) << 16)) | 0);
    var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
    var hi$49 = ((((((Math.imul(1546188226, hi$45) + Math.imul(23592, b1$11)) | 0) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$10) | 0) >>> 16) | 0)) | 0);
    var hi$50 = (hi$48 >> 31);
    var lo$45 = ((lo$44 + hi$48) | 0);
    var hi$51 = ((((hi$49 + hi$50) | 0) + ((((lo$44 & hi$48) | ((lo$44 | hi$48) & (~lo$45))) >>> 31) | 0)) | 0);
    var b0$12 = (65535 & hi);
    var b1$12 = ((hi >>> 16) | 0);
    var a0b0$12 = Math.imul(10485, b0$12);
    var a1b0$11 = Math.imul(36700, b0$12);
    var a0b1$12 = Math.imul(10485, b1$12);
    var lo$46 = ((a0b0$12 + (((a1b0$11 + a0b1$12) | 0) << 16)) | 0);
    var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
    var hi$52 = ((((((Math.imul((-1889785611), hi$45) + Math.imul(36700, b1$12)) | 0) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$11) | 0) >>> 16) | 0)) | 0);
    var lo$47 = ((lo$43 + lo$46) | 0);
    var hi$53 = ((hi$52 + ((((lo$43 & lo$46) | ((lo$43 | lo$46) & (~lo$47))) >>> 31) | 0)) | 0);
    var hi$54 = (hi$53 >> 31);
    var lo$48 = ((lo$45 + hi$53) | 0);
    var hi$55 = ((((hi$51 + hi$54) | 0) + ((((lo$45 & hi$53) | ((lo$45 | hi$53) & (~lo$48))) >>> 31) | 0)) | 0);
    var lo$49 = ((lo$48 - value) | 0);
    var hi$56 = ((((hi$55 - hi) | 0) + ((((~lo$48) & value) | ((~(lo$48 ^ value)) & lo$49)) >> 31)) | 0);
    var lo$50 = (((lo$49 >>> 6) | 0) | (hi$56 << 26));
    var hi$57 = (hi$56 >> 6);
    var lo$51 = ((hi$57 >>> 31) | 0);
    var lo$52 = ((lo$50 + lo$51) | 0);
    var hi$58 = ((hi$57 + ((((lo$50 & lo$51) | ((lo$50 | lo$51) & (~lo$52))) >>> 31) | 0)) | 0);
    var lo$53 = ((lo$40 - lo$52) | 0);
    var hi$59 = ((((hi$44 - hi$58) | 0) + ((((~lo$40) & lo$52) | ((~(lo$40 ^ lo$52)) & lo$53)) >> 31)) | 0);
    var hi$60 = (hi >> 31);
    var b0$13 = (65535 & value);
    var b1$13 = ((value >>> 16) | 0);
    var a0b0$13 = Math.imul(62914, b0$13);
    var a1b0$12 = Math.imul(23592, b0$13);
    var a0b1$13 = Math.imul(62914, b1$13);
    var lo$54 = ((a0b0$13 + (((a1b0$12 + a0b1$13) | 0) << 16)) | 0);
    var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
    var hi$61 = ((((Math.imul(23592, b1$13) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$12) | 0) >>> 16) | 0)) | 0);
    var b0$14 = (65535 & value);
    var b1$14 = ((value >>> 16) | 0);
    var a0b0$14 = Math.imul(10485, b0$14);
    var a1b0$13 = Math.imul(36700, b0$14);
    var a0b1$14 = Math.imul(10485, b1$14);
    var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
    var hi$62 = ((((Math.imul(36700, b1$14) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$13) | 0) >>> 16) | 0)) | 0);
    var lo$56 = ((lo$54 + hi$62) | 0);
    var hi$63 = ((hi$61 + ((((lo$54 & hi$62) | ((lo$54 | hi$62) & (~lo$56))) >>> 31) | 0)) | 0);
    var b0$15 = (65535 & hi);
    var b1$15 = ((hi >>> 16) | 0);
    var a0b0$15 = Math.imul(62914, b0$15);
    var a1b0$14 = Math.imul(23592, b0$15);
    var a0b1$15 = Math.imul(62914, b1$15);
    var lo$57 = ((a0b0$15 + (((a1b0$14 + a0b1$15) | 0) << 16)) | 0);
    var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
    var hi$64 = ((((((Math.imul(1546188226, hi$60) + Math.imul(23592, b1$15)) | 0) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$14) | 0) >>> 16) | 0)) | 0);
    var hi$65 = (hi$63 >> 31);
    var lo$58 = ((lo$57 + hi$63) | 0);
    var hi$66 = ((((hi$64 + hi$65) | 0) + ((((lo$57 & hi$63) | ((lo$57 | hi$63) & (~lo$58))) >>> 31) | 0)) | 0);
    var b0$16 = (65535 & hi);
    var b1$16 = ((hi >>> 16) | 0);
    var a0b0$16 = Math.imul(10485, b0$16);
    var a1b0$15 = Math.imul(36700, b0$16);
    var a0b1$16 = Math.imul(10485, b1$16);
    var lo$59 = ((a0b0$16 + (((a1b0$15 + a0b1$16) | 0) << 16)) | 0);
    var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
    var hi$67 = ((((((Math.imul((-1889785611), hi$60) + Math.imul(36700, b1$16)) | 0) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$15) | 0) >>> 16) | 0)) | 0);
    var lo$60 = ((lo$56 + lo$59) | 0);
    var hi$68 = ((hi$67 + ((((lo$56 & lo$59) | ((lo$56 | lo$59) & (~lo$60))) >>> 31) | 0)) | 0);
    var hi$69 = (hi$68 >> 31);
    var lo$61 = ((lo$58 + hi$68) | 0);
    var hi$70 = ((((hi$66 + hi$69) | 0) + ((((lo$58 & hi$68) | ((lo$58 | hi$68) & (~lo$61))) >>> 31) | 0)) | 0);
    var lo$62 = ((lo$61 - value) | 0);
    var hi$71 = ((((hi$70 - hi) | 0) + ((((~lo$61) & value) | ((~(lo$61 ^ value)) & lo$62)) >> 31)) | 0);
    var lo$63 = (((lo$62 >>> 8) | 0) | (hi$71 << 24));
    var hi$72 = (hi$71 >> 8);
    var lo$64 = ((hi$72 >>> 31) | 0);
    var lo$65 = ((lo$63 + lo$64) | 0);
    var hi$73 = ((hi$72 + ((((lo$63 & lo$64) | ((lo$63 | lo$64) & (~lo$65))) >>> 31) | 0)) | 0);
    var lo$66 = ((lo$53 + lo$65) | 0);
    var hi$74 = ((((hi$59 + hi$73) | 0) + ((((lo$53 & lo$65) | ((lo$53 | lo$65) & (~lo$66))) >>> 31) | 0)) | 0);
    var lo$67 = ((x$2_$_lo - lo$66) | 0);
    var hi$75 = ((((x$2_$_hi - hi$74) | 0) + ((((~x$2_$_lo) & lo$66) | ((~(x$2_$_lo ^ lo$66)) & lo$67)) >> 31)) | 0);
    total_$_lo = lo$67;
    total_$_hi = hi$75;
  }
  var x$3_$_lo = total_$_lo;
  var x$3_$_hi = total_$_hi;
  var b0$17 = (65535 & value$1);
  var b1$17 = ((value$1 >>> 16) | 0);
  var a0b0$17 = Math.imul(367, b0$17);
  var a0b1$17 = Math.imul(367, b1$17);
  var lo$68 = ((a0b0$17 + (a0b1$17 << 16)) | 0);
  var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
  var hi$76 = ((Math.imul(367, hi$1) + ((c1part$17 >>> 16) | 0)) | 0);
  var lo$69 = ((lo$68 - 362) | 0);
  var hi$77 = ((((hi$76 - 1) | 0) + (((lo$68 | (~lo$69)) >>> 31) | 0)) | 0);
  var hi$78 = (hi$77 >> 31);
  var b0$18 = (65535 & lo$69);
  var b1$18 = ((lo$69 >>> 16) | 0);
  var a0b0$18 = Math.imul(43690, b0$18);
  var a1b0$16 = Math.imul(10922, b0$18);
  var a0b1$18 = Math.imul(43690, b1$18);
  var lo$70 = ((a0b0$18 + (((a1b0$16 + a0b1$18) | 0) << 16)) | 0);
  var c1part$18 = ((((a0b0$18 >>> 16) | 0) + a0b1$18) | 0);
  var hi$79 = ((((Math.imul(10922, b1$18) + ((c1part$18 >>> 16) | 0)) | 0) + (((((65535 & c1part$18) + a1b0$16) | 0) >>> 16) | 0)) | 0);
  var b0$19 = (65535 & lo$69);
  var b1$19 = ((lo$69 >>> 16) | 0);
  var a0b0$19 = Math.imul(43691, b0$19);
  var a1b0$17 = Math.imul(43690, b0$19);
  var a0b1$19 = Math.imul(43691, b1$19);
  var c1part$19 = ((((a0b0$19 >>> 16) | 0) + a0b1$19) | 0);
  var hi$80 = ((((Math.imul(43690, b1$19) + ((c1part$19 >>> 16) | 0)) | 0) + (((((65535 & c1part$19) + a1b0$17) | 0) >>> 16) | 0)) | 0);
  var lo$72 = ((lo$70 + hi$80) | 0);
  var hi$81 = ((hi$79 + ((((lo$70 & hi$80) | ((lo$70 | hi$80) & (~lo$72))) >>> 31) | 0)) | 0);
  var b0$20 = (65535 & hi$77);
  var b1$20 = ((hi$77 >>> 16) | 0);
  var a0b0$20 = Math.imul(43690, b0$20);
  var a1b0$18 = Math.imul(10922, b0$20);
  var a0b1$20 = Math.imul(43690, b1$20);
  var lo$73 = ((a0b0$20 + (((a1b0$18 + a0b1$20) | 0) << 16)) | 0);
  var c1part$20 = ((((a0b0$20 >>> 16) | 0) + a0b1$20) | 0);
  var hi$82 = ((((((Math.imul(715827882, hi$78) + Math.imul(10922, b1$20)) | 0) + ((c1part$20 >>> 16) | 0)) | 0) + (((((65535 & c1part$20) + a1b0$18) | 0) >>> 16) | 0)) | 0);
  var hi$83 = (hi$81 >> 31);
  var lo$74 = ((lo$73 + hi$81) | 0);
  var hi$84 = ((((hi$82 + hi$83) | 0) + ((((lo$73 & hi$81) | ((lo$73 | hi$81) & (~lo$74))) >>> 31) | 0)) | 0);
  var b0$21 = (65535 & hi$77);
  var b1$21 = ((hi$77 >>> 16) | 0);
  var a0b0$21 = Math.imul(43691, b0$21);
  var a1b0$19 = Math.imul(43690, b0$21);
  var a0b1$21 = Math.imul(43691, b1$21);
  var lo$75 = ((a0b0$21 + (((a1b0$19 + a0b1$21) | 0) << 16)) | 0);
  var c1part$21 = ((((a0b0$21 >>> 16) | 0) + a0b1$21) | 0);
  var hi$85 = ((((((Math.imul((-1431655765), hi$78) + Math.imul(43690, b1$21)) | 0) + ((c1part$21 >>> 16) | 0)) | 0) + (((((65535 & c1part$21) + a1b0$19) | 0) >>> 16) | 0)) | 0);
  var lo$76 = ((lo$72 + lo$75) | 0);
  var hi$86 = ((hi$85 + ((((lo$72 & lo$75) | ((lo$72 | lo$75) & (~lo$76))) >>> 31) | 0)) | 0);
  var hi$87 = (hi$86 >> 31);
  var lo$77 = ((lo$74 + hi$86) | 0);
  var hi$88 = ((((hi$84 + hi$87) | 0) + ((((lo$74 & hi$86) | ((lo$74 | hi$86) & (~lo$77))) >>> 31) | 0)) | 0);
  var lo$78 = (((lo$77 >>> 1) | 0) | (hi$88 << 31));
  var hi$89 = (hi$88 >> 1);
  var lo$79 = ((hi$77 >>> 31) | 0);
  var lo$80 = ((lo$78 + lo$79) | 0);
  var hi$90 = ((hi$89 + ((((lo$78 & lo$79) | ((lo$78 | lo$79) & (~lo$80))) >>> 31) | 0)) | 0);
  var lo$81 = ((x$3_$_lo + lo$80) | 0);
  var hi$91 = ((((x$3_$_hi + hi$90) | 0) + ((((x$3_$_lo & lo$80) | ((x$3_$_lo | lo$80) & (~lo$81))) >>> 31) | 0)) | 0);
  total_$_lo = lo$81;
  total_$_hi = hi$91;
  var x$4_$_lo = total_$_lo;
  var x$4_$_hi = total_$_hi;
  var value$2 = ((this.Ljava_time_LocalDate__f_day - 1) | 0);
  var hi$92 = (value$2 >> 31);
  var lo$82 = ((x$4_$_lo + value$2) | 0);
  var hi$93 = ((((x$4_$_hi + hi$92) | 0) + ((((x$4_$_lo & value$2) | ((x$4_$_lo | value$2) & (~lo$82))) >>> 31) | 0)) | 0);
  total_$_lo = lo$82;
  total_$_hi = hi$93;
  if (((hi$1 === 0) ? ((value$1 >>> 0) > 2) : (hi$1 > 0))) {
    var x$5_$_lo = total_$_lo;
    var x$5_$_hi = total_$_hi;
    var lo$83 = ((x$5_$_lo - 1) | 0);
    var hi$94 = ((((x$5_$_hi - 1) | 0) + (((x$5_$_lo | (~lo$83)) >>> 31) | 0)) | 0);
    total_$_lo = lo$83;
    total_$_hi = hi$94;
    var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var value$3 = this.Ljava_time_LocalDate__f_year;
    var hi$95 = (value$3 >> 31);
    if ((!$n($x_1).isLeapYear__J__Z(value$3, hi$95))) {
      var x$6_$_lo = total_$_lo;
      var x$6_$_hi = total_$_hi;
      var lo$84 = ((x$6_$_lo - 1) | 0);
      var hi$96 = ((((x$6_$_hi - 1) | 0) + (((x$6_$_lo | (~lo$84)) >>> 31) | 0)) | 0);
      total_$_lo = lo$84;
      total_$_hi = hi$96;
    }
  }
  var x$7_$_lo = total_$_lo;
  var x$7_$_hi = total_$_hi;
  var $x_2 = $m_Ljava_time_LocalDate$();
  var x$8_$_lo = $x_2.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970_$lo;
  var x$8_$_hi = $x_2.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970_$hi;
  var lo$85 = ((x$7_$_lo - x$8_$_lo) | 0);
  var hi$97 = ((((x$7_$_hi - x$8_$_hi) | 0) + ((((~x$7_$_lo) & x$8_$_lo) | ((~(x$7_$_lo ^ x$8_$_lo)) & lo$85)) >> 31)) | 0);
  return $bL(lo$85, hi$97);
});
$c_Ljava_time_LocalDate.prototype.compareTo__Ljava_time_chrono_ChronoLocalDate__I = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? this.compareTo0__Ljava_time_LocalDate__I($as_Ljava_time_LocalDate(other)) : $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I(this, other));
});
$c_Ljava_time_LocalDate.prototype.compareTo0__Ljava_time_LocalDate__I = (function(otherDate) {
  var cmp = ((this.Ljava_time_LocalDate__f_year - $n(otherDate).Ljava_time_LocalDate__f_year) | 0);
  if ((cmp === 0)) {
    cmp = ((this.Ljava_time_LocalDate__f_month - $n(otherDate).Ljava_time_LocalDate__f_month) | 0);
    if ((cmp === 0)) {
      cmp = ((this.Ljava_time_LocalDate__f_day - $n(otherDate).Ljava_time_LocalDate__f_day) | 0);
    }
  }
  return cmp;
});
$c_Ljava_time_LocalDate.prototype.isAfter__Ljava_time_chrono_ChronoLocalDate__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? (this.compareTo0__Ljava_time_LocalDate__I($as_Ljava_time_LocalDate(other)) > 0) : $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z(this, other));
});
$c_Ljava_time_LocalDate.prototype.isBefore__Ljava_time_chrono_ChronoLocalDate__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? (this.compareTo0__Ljava_time_LocalDate__I($as_Ljava_time_LocalDate(other)) < 0) : $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z(this, other));
});
$c_Ljava_time_LocalDate.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalDate)) {
    var otherDate = $as_Ljava_time_LocalDate(obj);
    return ((this === otherDate) || (this.compareTo0__Ljava_time_LocalDate__I(otherDate) === 0));
  } else {
    return false;
  }
});
$c_Ljava_time_LocalDate.prototype.hashCode__I = (function() {
  var yearValue = this.Ljava_time_LocalDate__f_year;
  var monthValue = this.Ljava_time_LocalDate__f_month;
  var dayValue = this.Ljava_time_LocalDate__f_day;
  return (((-2048) & yearValue) ^ (((((yearValue << 11) + (monthValue << 6)) | 0) + dayValue) | 0));
});
$c_Ljava_time_LocalDate.prototype.toString__T = (function() {
  var yearValue = this.Ljava_time_LocalDate__f_year;
  var monthValue = this.Ljava_time_LocalDate__f_month;
  var dayValue = this.Ljava_time_LocalDate__f_day;
  var sign = (yearValue >> 31);
  var absYear = (((yearValue ^ sign) - sign) | 0);
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 10);
  if ((absYear < 1000)) {
    if ((yearValue < 0)) {
      $n(buf.append__I__scm_StringBuilder(((yearValue - 10000) | 0))).deleteCharAt__I__scm_StringBuilder(1);
    } else {
      $n(buf.append__I__scm_StringBuilder(((10000 + yearValue) | 0))).deleteCharAt__I__scm_StringBuilder(0);
    }
  } else {
    if ((yearValue > 9999)) {
      buf.append__C__scm_StringBuilder(43);
    }
    buf.append__I__scm_StringBuilder(yearValue);
  }
  var this$2 = $n($n($n($n(buf.append__T__scm_StringBuilder(((monthValue < 10) ? "-0" : "-"))).append__I__scm_StringBuilder(monthValue)).append__T__scm_StringBuilder(((dayValue < 10) ? "-0" : "-"))).append__I__scm_StringBuilder(dayValue));
  return $n(this$2.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(field, newValue_$_lo, newValue_$_hi);
});
$c_Ljava_time_LocalDate.prototype.compareTo__O__I = (function(that) {
  return this.compareTo__Ljava_time_chrono_ChronoLocalDate__I($as_Ljava_time_chrono_ChronoLocalDate(that));
});
$c_Ljava_time_LocalDate.prototype.compare__O__I = (function(that) {
  var other = $as_Ljava_time_chrono_ChronoLocalDate(that);
  return $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I(this, other);
});
function $as_Ljava_time_LocalDate(obj) {
  return (((obj instanceof $c_Ljava_time_LocalDate) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.LocalDate"));
}
function $isArrayOf_Ljava_time_LocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalDate)));
}
function $asArrayOf_Ljava_time_LocalDate(obj, depth) {
  return (($isArrayOf_Ljava_time_LocalDate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.LocalDate;", depth));
}
var $d_Ljava_time_LocalDate = new $TypeData().initClass($c_Ljava_time_LocalDate, "java.time.LocalDate", ({
  Ljava_time_LocalDate: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_time_chrono_ChronoLocalDate: 1,
  Ljava_io_Serializable: 1
}));
function $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, newTime) {
  return ((($thiz.Ljava_time_LocalDateTime__f_date === newDate) && ($thiz.Ljava_time_LocalDateTime__f_time === newTime)) ? $thiz : new $c_Ljava_time_LocalDateTime(newDate, newTime));
}
function $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime($thiz, newDate, hours_$_lo, hours_$_hi, minutes_$_lo, minutes_$_hi, seconds_$_lo, seconds_$_hi, nanos_$_lo, nanos_$_hi, sign) {
  var lo = (hours_$_lo | minutes_$_lo);
  var hi = (hours_$_hi | minutes_$_hi);
  var lo$1 = (lo | seconds_$_lo);
  var hi$1 = (hi | seconds_$_hi);
  var lo$2 = (lo$1 | nanos_$_lo);
  var hi$2 = (hi$1 | nanos_$_hi);
  if (((lo$2 | hi$2) === 0)) {
    return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, $thiz.Ljava_time_LocalDateTime__f_time);
  }
  var hi$3 = (nanos_$_hi >> 31);
  var b0 = (65535 & nanos_$_lo);
  var b1 = ((nanos_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(65391, b0);
  var a1b0 = Math.imul(26687, b0);
  var a0b1 = Math.imul(65391, b1);
  var lo$3 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((Math.imul(26687, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & nanos_$_lo);
  var b1$1 = ((nanos_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(18659, b0$1);
  var a1b0$1 = Math.imul(18681, b0$1);
  var a0b1$1 = Math.imul(18659, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$5 = ((((Math.imul(18681, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$5 = ((lo$3 + hi$5) | 0);
  var hi$6 = ((hi$4 + ((((lo$3 & hi$5) | ((lo$3 | hi$5) & (~lo$5))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & nanos_$_hi);
  var b1$2 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(65391, b0$2);
  var a1b0$2 = Math.imul(26687, b0$2);
  var a0b1$2 = Math.imul(65391, b1$2);
  var lo$6 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$7 = ((((((Math.imul(1749024623, hi$3) + Math.imul(26687, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$8 = (hi$6 >> 31);
  var lo$7 = ((lo$6 + hi$6) | 0);
  var hi$9 = ((((hi$7 + hi$8) | 0) + ((((lo$6 & hi$6) | ((lo$6 | hi$6) & (~lo$7))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & nanos_$_hi);
  var b1$3 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(18659, b0$3);
  var a1b0$3 = Math.imul(18681, b0$3);
  var a0b1$3 = Math.imul(18659, b1$3);
  var lo$8 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$10 = ((((((Math.imul(1224296675, hi$3) + Math.imul(18681, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$9 = ((lo$5 + lo$8) | 0);
  var hi$11 = ((hi$10 + ((((lo$5 & lo$8) | ((lo$5 | lo$8) & (~lo$9))) >>> 31) | 0)) | 0);
  var hi$12 = (hi$11 >> 31);
  var lo$10 = ((lo$7 + hi$11) | 0);
  var hi$13 = ((((hi$9 + hi$12) | 0) + ((((lo$7 & hi$11) | ((lo$7 | hi$11) & (~lo$10))) >>> 31) | 0)) | 0);
  var lo$11 = (hi$13 >> 13);
  var hi$14 = (hi$13 >> 31);
  var lo$12 = ((nanos_$_hi >>> 31) | 0);
  var lo$13 = ((lo$11 + lo$12) | 0);
  var hi$15 = ((hi$14 + ((((lo$11 & lo$12) | ((lo$11 | lo$12) & (~lo$13))) >>> 31) | 0)) | 0);
  var hi$16 = (seconds_$_hi >> 31);
  var b0$4 = (65535 & seconds_$_lo);
  var b1$4 = ((seconds_$_lo >>> 16) | 0);
  var a0b0$4 = Math.imul(51360, b0$4);
  var a1b0$4 = Math.imul(6213, b0$4);
  var a0b1$4 = Math.imul(51360, b1$4);
  var lo$14 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$17 = ((((Math.imul(6213, b1$4) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var b0$5 = (65535 & seconds_$_lo);
  var b1$5 = ((seconds_$_lo >>> 16) | 0);
  var a0b0$5 = Math.imul(10583, b0$5);
  var a1b0$5 = Math.imul(52817, b0$5);
  var a0b1$5 = Math.imul(10583, b1$5);
  var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
  var hi$18 = ((((Math.imul(52817, b1$5) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var lo$16 = ((lo$14 + hi$18) | 0);
  var hi$19 = ((hi$17 + ((((lo$14 & hi$18) | ((lo$14 | hi$18) & (~lo$16))) >>> 31) | 0)) | 0);
  var b0$6 = (65535 & seconds_$_hi);
  var b1$6 = ((seconds_$_hi >>> 16) | 0);
  var a0b0$6 = Math.imul(51360, b0$6);
  var a1b0$6 = Math.imul(6213, b0$6);
  var a0b1$6 = Math.imul(51360, b1$6);
  var lo$17 = ((a0b0$6 + (((a1b0$6 + a0b1$6) | 0) << 16)) | 0);
  var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
  var hi$20 = ((((((Math.imul(407226528, hi$16) + Math.imul(6213, b1$6)) | 0) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var hi$21 = (hi$19 >> 31);
  var lo$18 = ((lo$17 + hi$19) | 0);
  var hi$22 = ((((hi$20 + hi$21) | 0) + ((((lo$17 & hi$19) | ((lo$17 | hi$19) & (~lo$18))) >>> 31) | 0)) | 0);
  var b0$7 = (65535 & seconds_$_hi);
  var b1$7 = ((seconds_$_hi >>> 16) | 0);
  var a0b0$7 = Math.imul(10583, b0$7);
  var a1b0$7 = Math.imul(52817, b0$7);
  var a0b1$7 = Math.imul(10583, b1$7);
  var lo$19 = ((a0b0$7 + (((a1b0$7 + a0b1$7) | 0) << 16)) | 0);
  var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
  var hi$23 = ((((((Math.imul((-833541801), hi$16) + Math.imul(52817, b1$7)) | 0) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$7) | 0) >>> 16) | 0)) | 0);
  var lo$20 = ((lo$16 + lo$19) | 0);
  var hi$24 = ((hi$23 + ((((lo$16 & lo$19) | ((lo$16 | lo$19) & (~lo$20))) >>> 31) | 0)) | 0);
  var hi$25 = (hi$24 >> 31);
  var lo$21 = ((lo$18 + hi$24) | 0);
  var hi$26 = ((((hi$22 + hi$25) | 0) + ((((lo$18 & hi$24) | ((lo$18 | hi$24) & (~lo$21))) >>> 31) | 0)) | 0);
  var lo$22 = (((lo$21 >>> 13) | 0) | (hi$26 << 19));
  var hi$27 = (hi$26 >> 13);
  var lo$23 = ((seconds_$_hi >>> 31) | 0);
  var lo$24 = ((lo$22 + lo$23) | 0);
  var hi$28 = ((hi$27 + ((((lo$22 & lo$23) | ((lo$22 | lo$23) & (~lo$24))) >>> 31) | 0)) | 0);
  var lo$25 = ((lo$13 + lo$24) | 0);
  var hi$29 = ((((hi$15 + hi$28) | 0) + ((((lo$13 & lo$24) | ((lo$13 | lo$24) & (~lo$25))) >>> 31) | 0)) | 0);
  var hi$30 = (minutes_$_hi >> 31);
  var b0$8 = (65535 & minutes_$_lo);
  var b1$8 = ((minutes_$_lo >>> 16) | 0);
  var a0b0$8 = Math.imul(55341, b0$8);
  var a1b0$8 = Math.imul(11650, b0$8);
  var a0b1$8 = Math.imul(55341, b1$8);
  var lo$26 = ((a0b0$8 + (((a1b0$8 + a0b1$8) | 0) << 16)) | 0);
  var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
  var hi$31 = ((((Math.imul(11650, b1$8) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$8) | 0) >>> 16) | 0)) | 0);
  var b0$9 = (65535 & minutes_$_lo);
  var b1$9 = ((minutes_$_lo >>> 16) | 0);
  var a0b0$9 = Math.imul(11651, b0$9);
  var a1b0$9 = Math.imul(33496, b0$9);
  var a0b1$9 = Math.imul(11651, b1$9);
  var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
  var hi$32 = ((((Math.imul(33496, b1$9) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$9) | 0) >>> 16) | 0)) | 0);
  var lo$28 = ((lo$26 + hi$32) | 0);
  var hi$33 = ((hi$31 + ((((lo$26 & hi$32) | ((lo$26 | hi$32) & (~lo$28))) >>> 31) | 0)) | 0);
  var b0$10 = (65535 & minutes_$_hi);
  var b1$10 = ((minutes_$_hi >>> 16) | 0);
  var a0b0$10 = Math.imul(55341, b0$10);
  var a1b0$10 = Math.imul(11650, b0$10);
  var a0b1$10 = Math.imul(55341, b1$10);
  var lo$29 = ((a0b0$10 + (((a1b0$10 + a0b1$10) | 0) << 16)) | 0);
  var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
  var hi$34 = ((((((Math.imul(763549741, hi$30) + Math.imul(11650, b1$10)) | 0) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + a1b0$10) | 0) >>> 16) | 0)) | 0);
  var hi$35 = (hi$33 >> 31);
  var lo$30 = ((lo$29 + hi$33) | 0);
  var hi$36 = ((((hi$34 + hi$35) | 0) + ((((lo$29 & hi$33) | ((lo$29 | hi$33) & (~lo$30))) >>> 31) | 0)) | 0);
  var b0$11 = (65535 & minutes_$_hi);
  var b1$11 = ((minutes_$_hi >>> 16) | 0);
  var a0b0$11 = Math.imul(11651, b0$11);
  var a1b0$11 = Math.imul(33496, b0$11);
  var a0b1$11 = Math.imul(11651, b1$11);
  var lo$31 = ((a0b0$11 + (((a1b0$11 + a0b1$11) | 0) << 16)) | 0);
  var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
  var hi$37 = ((((((Math.imul((-2099761789), hi$30) + Math.imul(33496, b1$11)) | 0) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$11) | 0) >>> 16) | 0)) | 0);
  var lo$32 = ((lo$28 + lo$31) | 0);
  var hi$38 = ((hi$37 + ((((lo$28 & lo$31) | ((lo$28 | lo$31) & (~lo$32))) >>> 31) | 0)) | 0);
  var hi$39 = (hi$38 >> 31);
  var lo$33 = ((lo$30 + hi$38) | 0);
  var hi$40 = ((((hi$36 + hi$39) | 0) + ((((lo$30 & hi$38) | ((lo$30 | hi$38) & (~lo$33))) >>> 31) | 0)) | 0);
  var lo$34 = (((lo$33 >>> 8) | 0) | (hi$40 << 24));
  var hi$41 = (hi$40 >> 8);
  var lo$35 = ((minutes_$_hi >>> 31) | 0);
  var lo$36 = ((lo$34 + lo$35) | 0);
  var hi$42 = ((hi$41 + ((((lo$34 & lo$35) | ((lo$34 | lo$35) & (~lo$36))) >>> 31) | 0)) | 0);
  var lo$37 = ((lo$25 + lo$36) | 0);
  var hi$43 = ((((hi$29 + hi$42) | 0) + ((((lo$25 & lo$36) | ((lo$25 | lo$36) & (~lo$37))) >>> 31) | 0)) | 0);
  var hi$44 = (hours_$_hi >> 31);
  var b0$12 = (65535 & hours_$_lo);
  var b1$12 = ((hours_$_lo >>> 16) | 0);
  var a0b0$12 = Math.imul(43690, b0$12);
  var a1b0$12 = Math.imul(10922, b0$12);
  var a0b1$12 = Math.imul(43690, b1$12);
  var lo$38 = ((a0b0$12 + (((a1b0$12 + a0b1$12) | 0) << 16)) | 0);
  var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
  var hi$45 = ((((Math.imul(10922, b1$12) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$12) | 0) >>> 16) | 0)) | 0);
  var b0$13 = (65535 & hours_$_lo);
  var b1$13 = ((hours_$_lo >>> 16) | 0);
  var a0b0$13 = Math.imul(43691, b0$13);
  var a1b0$13 = Math.imul(43690, b0$13);
  var a0b1$13 = Math.imul(43691, b1$13);
  var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
  var hi$46 = ((((Math.imul(43690, b1$13) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$13) | 0) >>> 16) | 0)) | 0);
  var lo$40 = ((lo$38 + hi$46) | 0);
  var hi$47 = ((hi$45 + ((((lo$38 & hi$46) | ((lo$38 | hi$46) & (~lo$40))) >>> 31) | 0)) | 0);
  var b0$14 = (65535 & hours_$_hi);
  var b1$14 = ((hours_$_hi >>> 16) | 0);
  var a0b0$14 = Math.imul(43690, b0$14);
  var a1b0$14 = Math.imul(10922, b0$14);
  var a0b1$14 = Math.imul(43690, b1$14);
  var lo$41 = ((a0b0$14 + (((a1b0$14 + a0b1$14) | 0) << 16)) | 0);
  var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
  var hi$48 = ((((((Math.imul(715827882, hi$44) + Math.imul(10922, b1$14)) | 0) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$14) | 0) >>> 16) | 0)) | 0);
  var hi$49 = (hi$47 >> 31);
  var lo$42 = ((lo$41 + hi$47) | 0);
  var hi$50 = ((((hi$48 + hi$49) | 0) + ((((lo$41 & hi$47) | ((lo$41 | hi$47) & (~lo$42))) >>> 31) | 0)) | 0);
  var b0$15 = (65535 & hours_$_hi);
  var b1$15 = ((hours_$_hi >>> 16) | 0);
  var a0b0$15 = Math.imul(43691, b0$15);
  var a1b0$15 = Math.imul(43690, b0$15);
  var a0b1$15 = Math.imul(43691, b1$15);
  var lo$43 = ((a0b0$15 + (((a1b0$15 + a0b1$15) | 0) << 16)) | 0);
  var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
  var hi$51 = ((((((Math.imul((-1431655765), hi$44) + Math.imul(43690, b1$15)) | 0) + ((c1part$15 >>> 16) | 0)) | 0) + (((((65535 & c1part$15) + a1b0$15) | 0) >>> 16) | 0)) | 0);
  var lo$44 = ((lo$40 + lo$43) | 0);
  var hi$52 = ((hi$51 + ((((lo$40 & lo$43) | ((lo$40 | lo$43) & (~lo$44))) >>> 31) | 0)) | 0);
  var hi$53 = (hi$52 >> 31);
  var lo$45 = ((lo$42 + hi$52) | 0);
  var hi$54 = ((((hi$50 + hi$53) | 0) + ((((lo$42 & hi$52) | ((lo$42 | hi$52) & (~lo$45))) >>> 31) | 0)) | 0);
  var lo$46 = (((lo$45 >>> 2) | 0) | (hi$54 << 30));
  var hi$55 = (hi$54 >> 2);
  var lo$47 = ((hours_$_hi >>> 31) | 0);
  var lo$48 = ((lo$46 + lo$47) | 0);
  var hi$56 = ((hi$55 + ((((lo$46 & lo$47) | ((lo$46 | lo$47) & (~lo$48))) >>> 31) | 0)) | 0);
  var lo$49 = ((lo$37 + lo$48) | 0);
  var hi$57 = ((((hi$43 + hi$56) | 0) + ((((lo$37 & lo$48) | ((lo$37 | lo$48) & (~lo$49))) >>> 31) | 0)) | 0);
  var totDays_$_lo = lo$49;
  var totDays_$_hi = hi$57;
  var x_$_lo = totDays_$_lo;
  var x_$_hi = totDays_$_hi;
  var hi$58 = (sign >> 31);
  var a0 = (65535 & x_$_lo);
  var a1 = ((x_$_lo >>> 16) | 0);
  var b0$16 = (65535 & sign);
  var b1$16 = ((sign >>> 16) | 0);
  var a0b0$16 = Math.imul(a0, b0$16);
  var a1b0$16 = Math.imul(a1, b0$16);
  var a0b1$16 = Math.imul(a0, b1$16);
  var lo$50 = ((a0b0$16 + (((a1b0$16 + a0b1$16) | 0) << 16)) | 0);
  var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
  var hi$59 = ((((((((Math.imul(x_$_lo, hi$58) + Math.imul(x_$_hi, sign)) | 0) + Math.imul(a1, b1$16)) | 0) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$16) | 0) >>> 16) | 0)) | 0);
  totDays_$_lo = lo$50;
  totDays_$_hi = hi$59;
  var hi$60 = (nanos_$_hi >> 31);
  var b0$17 = (65535 & nanos_$_lo);
  var b1$17 = ((nanos_$_lo >>> 16) | 0);
  var a0b0$17 = Math.imul(65391, b0$17);
  var a1b0$17 = Math.imul(26687, b0$17);
  var a0b1$17 = Math.imul(65391, b1$17);
  var lo$51 = ((a0b0$17 + (((a1b0$17 + a0b1$17) | 0) << 16)) | 0);
  var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
  var hi$61 = ((((Math.imul(26687, b1$17) + ((c1part$17 >>> 16) | 0)) | 0) + (((((65535 & c1part$17) + a1b0$17) | 0) >>> 16) | 0)) | 0);
  var b0$18 = (65535 & nanos_$_lo);
  var b1$18 = ((nanos_$_lo >>> 16) | 0);
  var a0b0$18 = Math.imul(18659, b0$18);
  var a1b0$18 = Math.imul(18681, b0$18);
  var a0b1$18 = Math.imul(18659, b1$18);
  var c1part$18 = ((((a0b0$18 >>> 16) | 0) + a0b1$18) | 0);
  var hi$62 = ((((Math.imul(18681, b1$18) + ((c1part$18 >>> 16) | 0)) | 0) + (((((65535 & c1part$18) + a1b0$18) | 0) >>> 16) | 0)) | 0);
  var lo$53 = ((lo$51 + hi$62) | 0);
  var hi$63 = ((hi$61 + ((((lo$51 & hi$62) | ((lo$51 | hi$62) & (~lo$53))) >>> 31) | 0)) | 0);
  var b0$19 = (65535 & nanos_$_hi);
  var b1$19 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$19 = Math.imul(65391, b0$19);
  var a1b0$19 = Math.imul(26687, b0$19);
  var a0b1$19 = Math.imul(65391, b1$19);
  var lo$54 = ((a0b0$19 + (((a1b0$19 + a0b1$19) | 0) << 16)) | 0);
  var c1part$19 = ((((a0b0$19 >>> 16) | 0) + a0b1$19) | 0);
  var hi$64 = ((((((Math.imul(1749024623, hi$60) + Math.imul(26687, b1$19)) | 0) + ((c1part$19 >>> 16) | 0)) | 0) + (((((65535 & c1part$19) + a1b0$19) | 0) >>> 16) | 0)) | 0);
  var hi$65 = (hi$63 >> 31);
  var lo$55 = ((lo$54 + hi$63) | 0);
  var hi$66 = ((((hi$64 + hi$65) | 0) + ((((lo$54 & hi$63) | ((lo$54 | hi$63) & (~lo$55))) >>> 31) | 0)) | 0);
  var b0$20 = (65535 & nanos_$_hi);
  var b1$20 = ((nanos_$_hi >>> 16) | 0);
  var a0b0$20 = Math.imul(18659, b0$20);
  var a1b0$20 = Math.imul(18681, b0$20);
  var a0b1$20 = Math.imul(18659, b1$20);
  var lo$56 = ((a0b0$20 + (((a1b0$20 + a0b1$20) | 0) << 16)) | 0);
  var c1part$20 = ((((a0b0$20 >>> 16) | 0) + a0b1$20) | 0);
  var hi$67 = ((((((Math.imul(1224296675, hi$60) + Math.imul(18681, b1$20)) | 0) + ((c1part$20 >>> 16) | 0)) | 0) + (((((65535 & c1part$20) + a1b0$20) | 0) >>> 16) | 0)) | 0);
  var lo$57 = ((lo$53 + lo$56) | 0);
  var hi$68 = ((hi$67 + ((((lo$53 & lo$56) | ((lo$53 | lo$56) & (~lo$57))) >>> 31) | 0)) | 0);
  var hi$69 = (hi$68 >> 31);
  var lo$58 = ((lo$55 + hi$68) | 0);
  var hi$70 = ((((hi$66 + hi$69) | 0) + ((((lo$55 & hi$68) | ((lo$55 | hi$68) & (~lo$58))) >>> 31) | 0)) | 0);
  var lo$59 = (hi$70 >> 13);
  var hi$71 = (hi$70 >> 31);
  var lo$60 = ((nanos_$_hi >>> 31) | 0);
  var lo$61 = ((lo$59 + lo$60) | 0);
  var hi$72 = ((hi$71 + ((((lo$59 & lo$60) | ((lo$59 | lo$60) & (~lo$61))) >>> 31) | 0)) | 0);
  var b0$21 = (65535 & lo$61);
  var b1$21 = ((lo$61 >>> 16) | 0);
  var a1b0$21 = Math.imul(37199, b0$21);
  var lo$62 = (a1b0$21 << 16);
  var hi$73 = ((((((Math.imul((-1857093632), hi$72) + Math.imul(20116, lo$61)) | 0) + Math.imul(37199, b1$21)) | 0) + ((a1b0$21 >>> 16) | 0)) | 0);
  var lo$63 = ((nanos_$_lo - lo$62) | 0);
  var hi$74 = ((((nanos_$_hi - hi$73) | 0) + ((((~nanos_$_lo) & lo$62) | ((~(nanos_$_lo ^ lo$62)) & lo$63)) >> 31)) | 0);
  var hi$75 = (seconds_$_hi >> 31);
  var b0$22 = (65535 & seconds_$_lo);
  var b1$22 = ((seconds_$_lo >>> 16) | 0);
  var a0b0$21 = Math.imul(51360, b0$22);
  var a1b0$22 = Math.imul(6213, b0$22);
  var a0b1$21 = Math.imul(51360, b1$22);
  var lo$64 = ((a0b0$21 + (((a1b0$22 + a0b1$21) | 0) << 16)) | 0);
  var c1part$21 = ((((a0b0$21 >>> 16) | 0) + a0b1$21) | 0);
  var hi$76 = ((((Math.imul(6213, b1$22) + ((c1part$21 >>> 16) | 0)) | 0) + (((((65535 & c1part$21) + a1b0$22) | 0) >>> 16) | 0)) | 0);
  var b0$23 = (65535 & seconds_$_lo);
  var b1$23 = ((seconds_$_lo >>> 16) | 0);
  var a0b0$22 = Math.imul(10583, b0$23);
  var a1b0$23 = Math.imul(52817, b0$23);
  var a0b1$22 = Math.imul(10583, b1$23);
  var c1part$22 = ((((a0b0$22 >>> 16) | 0) + a0b1$22) | 0);
  var hi$77 = ((((Math.imul(52817, b1$23) + ((c1part$22 >>> 16) | 0)) | 0) + (((((65535 & c1part$22) + a1b0$23) | 0) >>> 16) | 0)) | 0);
  var lo$66 = ((lo$64 + hi$77) | 0);
  var hi$78 = ((hi$76 + ((((lo$64 & hi$77) | ((lo$64 | hi$77) & (~lo$66))) >>> 31) | 0)) | 0);
  var b0$24 = (65535 & seconds_$_hi);
  var b1$24 = ((seconds_$_hi >>> 16) | 0);
  var a0b0$23 = Math.imul(51360, b0$24);
  var a1b0$24 = Math.imul(6213, b0$24);
  var a0b1$23 = Math.imul(51360, b1$24);
  var lo$67 = ((a0b0$23 + (((a1b0$24 + a0b1$23) | 0) << 16)) | 0);
  var c1part$23 = ((((a0b0$23 >>> 16) | 0) + a0b1$23) | 0);
  var hi$79 = ((((((Math.imul(407226528, hi$75) + Math.imul(6213, b1$24)) | 0) + ((c1part$23 >>> 16) | 0)) | 0) + (((((65535 & c1part$23) + a1b0$24) | 0) >>> 16) | 0)) | 0);
  var hi$80 = (hi$78 >> 31);
  var lo$68 = ((lo$67 + hi$78) | 0);
  var hi$81 = ((((hi$79 + hi$80) | 0) + ((((lo$67 & hi$78) | ((lo$67 | hi$78) & (~lo$68))) >>> 31) | 0)) | 0);
  var b0$25 = (65535 & seconds_$_hi);
  var b1$25 = ((seconds_$_hi >>> 16) | 0);
  var a0b0$24 = Math.imul(10583, b0$25);
  var a1b0$25 = Math.imul(52817, b0$25);
  var a0b1$24 = Math.imul(10583, b1$25);
  var lo$69 = ((a0b0$24 + (((a1b0$25 + a0b1$24) | 0) << 16)) | 0);
  var c1part$24 = ((((a0b0$24 >>> 16) | 0) + a0b1$24) | 0);
  var hi$82 = ((((((Math.imul((-833541801), hi$75) + Math.imul(52817, b1$25)) | 0) + ((c1part$24 >>> 16) | 0)) | 0) + (((((65535 & c1part$24) + a1b0$25) | 0) >>> 16) | 0)) | 0);
  var lo$70 = ((lo$66 + lo$69) | 0);
  var hi$83 = ((hi$82 + ((((lo$66 & lo$69) | ((lo$66 | lo$69) & (~lo$70))) >>> 31) | 0)) | 0);
  var hi$84 = (hi$83 >> 31);
  var lo$71 = ((lo$68 + hi$83) | 0);
  var hi$85 = ((((hi$81 + hi$84) | 0) + ((((lo$68 & hi$83) | ((lo$68 | hi$83) & (~lo$71))) >>> 31) | 0)) | 0);
  var lo$72 = (((lo$71 >>> 13) | 0) | (hi$85 << 19));
  var hi$86 = (hi$85 >> 13);
  var lo$73 = ((seconds_$_hi >>> 31) | 0);
  var lo$74 = ((lo$72 + lo$73) | 0);
  var hi$87 = ((hi$86 + ((((lo$72 & lo$73) | ((lo$72 | lo$73) & (~lo$74))) >>> 31) | 0)) | 0);
  var b0$26 = (65535 & lo$74);
  var b1$26 = ((lo$74 >>> 16) | 0);
  var a0b0$25 = Math.imul(20864, b0$26);
  var a0b1$25 = Math.imul(20864, b1$26);
  var lo$75 = ((a0b0$25 + (((b0$26 + a0b1$25) | 0) << 16)) | 0);
  var c1part$25 = ((((a0b0$25 >>> 16) | 0) + a0b1$25) | 0);
  var hi$88 = ((((((Math.imul(86400, hi$87) + b1$26) | 0) + ((c1part$25 >>> 16) | 0)) | 0) + (((((65535 & c1part$25) + b0$26) | 0) >>> 16) | 0)) | 0);
  var lo$76 = ((seconds_$_lo - lo$75) | 0);
  var hi$89 = ((((seconds_$_hi - hi$88) | 0) + ((((~seconds_$_lo) & lo$75) | ((~(seconds_$_lo ^ lo$75)) & lo$76)) >> 31)) | 0);
  var b0$27 = (65535 & lo$76);
  var b1$27 = ((lo$76 >>> 16) | 0);
  var a0b0$26 = Math.imul(51712, b0$27);
  var a1b0$26 = Math.imul(15258, b0$27);
  var a0b1$26 = Math.imul(51712, b1$27);
  var lo$77 = ((a0b0$26 + (((a1b0$26 + a0b1$26) | 0) << 16)) | 0);
  var c1part$26 = ((((a0b0$26 >>> 16) | 0) + a0b1$26) | 0);
  var hi$90 = ((((((Math.imul(1000000000, hi$89) + Math.imul(15258, b1$27)) | 0) + ((c1part$26 >>> 16) | 0)) | 0) + (((((65535 & c1part$26) + a1b0$26) | 0) >>> 16) | 0)) | 0);
  var lo$78 = ((lo$63 + lo$77) | 0);
  var hi$91 = ((((hi$74 + hi$90) | 0) + ((((lo$63 & lo$77) | ((lo$63 | lo$77) & (~lo$78))) >>> 31) | 0)) | 0);
  var hi$92 = (minutes_$_hi >> 31);
  var b0$28 = (65535 & minutes_$_lo);
  var b1$28 = ((minutes_$_lo >>> 16) | 0);
  var a0b0$27 = Math.imul(55341, b0$28);
  var a1b0$27 = Math.imul(11650, b0$28);
  var a0b1$27 = Math.imul(55341, b1$28);
  var lo$79 = ((a0b0$27 + (((a1b0$27 + a0b1$27) | 0) << 16)) | 0);
  var c1part$27 = ((((a0b0$27 >>> 16) | 0) + a0b1$27) | 0);
  var hi$93 = ((((Math.imul(11650, b1$28) + ((c1part$27 >>> 16) | 0)) | 0) + (((((65535 & c1part$27) + a1b0$27) | 0) >>> 16) | 0)) | 0);
  var b0$29 = (65535 & minutes_$_lo);
  var b1$29 = ((minutes_$_lo >>> 16) | 0);
  var a0b0$28 = Math.imul(11651, b0$29);
  var a1b0$28 = Math.imul(33496, b0$29);
  var a0b1$28 = Math.imul(11651, b1$29);
  var c1part$28 = ((((a0b0$28 >>> 16) | 0) + a0b1$28) | 0);
  var hi$94 = ((((Math.imul(33496, b1$29) + ((c1part$28 >>> 16) | 0)) | 0) + (((((65535 & c1part$28) + a1b0$28) | 0) >>> 16) | 0)) | 0);
  var lo$81 = ((lo$79 + hi$94) | 0);
  var hi$95 = ((hi$93 + ((((lo$79 & hi$94) | ((lo$79 | hi$94) & (~lo$81))) >>> 31) | 0)) | 0);
  var b0$30 = (65535 & minutes_$_hi);
  var b1$30 = ((minutes_$_hi >>> 16) | 0);
  var a0b0$29 = Math.imul(55341, b0$30);
  var a1b0$29 = Math.imul(11650, b0$30);
  var a0b1$29 = Math.imul(55341, b1$30);
  var lo$82 = ((a0b0$29 + (((a1b0$29 + a0b1$29) | 0) << 16)) | 0);
  var c1part$29 = ((((a0b0$29 >>> 16) | 0) + a0b1$29) | 0);
  var hi$96 = ((((((Math.imul(763549741, hi$92) + Math.imul(11650, b1$30)) | 0) + ((c1part$29 >>> 16) | 0)) | 0) + (((((65535 & c1part$29) + a1b0$29) | 0) >>> 16) | 0)) | 0);
  var hi$97 = (hi$95 >> 31);
  var lo$83 = ((lo$82 + hi$95) | 0);
  var hi$98 = ((((hi$96 + hi$97) | 0) + ((((lo$82 & hi$95) | ((lo$82 | hi$95) & (~lo$83))) >>> 31) | 0)) | 0);
  var b0$31 = (65535 & minutes_$_hi);
  var b1$31 = ((minutes_$_hi >>> 16) | 0);
  var a0b0$30 = Math.imul(11651, b0$31);
  var a1b0$30 = Math.imul(33496, b0$31);
  var a0b1$30 = Math.imul(11651, b1$31);
  var lo$84 = ((a0b0$30 + (((a1b0$30 + a0b1$30) | 0) << 16)) | 0);
  var c1part$30 = ((((a0b0$30 >>> 16) | 0) + a0b1$30) | 0);
  var hi$99 = ((((((Math.imul((-2099761789), hi$92) + Math.imul(33496, b1$31)) | 0) + ((c1part$30 >>> 16) | 0)) | 0) + (((((65535 & c1part$30) + a1b0$30) | 0) >>> 16) | 0)) | 0);
  var lo$85 = ((lo$81 + lo$84) | 0);
  var hi$100 = ((hi$99 + ((((lo$81 & lo$84) | ((lo$81 | lo$84) & (~lo$85))) >>> 31) | 0)) | 0);
  var hi$101 = (hi$100 >> 31);
  var lo$86 = ((lo$83 + hi$100) | 0);
  var hi$102 = ((((hi$98 + hi$101) | 0) + ((((lo$83 & hi$100) | ((lo$83 | hi$100) & (~lo$86))) >>> 31) | 0)) | 0);
  var lo$87 = (((lo$86 >>> 8) | 0) | (hi$102 << 24));
  var hi$103 = (hi$102 >> 8);
  var lo$88 = ((minutes_$_hi >>> 31) | 0);
  var lo$89 = ((lo$87 + lo$88) | 0);
  var hi$104 = ((hi$103 + ((((lo$87 & lo$88) | ((lo$87 | lo$88) & (~lo$89))) >>> 31) | 0)) | 0);
  var b0$32 = (65535 & lo$89);
  var b1$32 = ((lo$89 >>> 16) | 0);
  var a0b0$31 = Math.imul(1440, b0$32);
  var a0b1$31 = Math.imul(1440, b1$32);
  var lo$90 = ((a0b0$31 + (a0b1$31 << 16)) | 0);
  var c1part$31 = ((((a0b0$31 >>> 16) | 0) + a0b1$31) | 0);
  var hi$105 = ((Math.imul(1440, hi$104) + ((c1part$31 >>> 16) | 0)) | 0);
  var lo$91 = ((minutes_$_lo - lo$90) | 0);
  var hi$106 = ((((minutes_$_hi - hi$105) | 0) + ((((~minutes_$_lo) & lo$90) | ((~(minutes_$_lo ^ lo$90)) & lo$91)) >> 31)) | 0);
  var b0$33 = (65535 & lo$91);
  var b1$33 = ((lo$91 >>> 16) | 0);
  var a0b0$32 = Math.imul(22528, b0$33);
  var a1b0$31 = Math.imul(63559, b0$33);
  var a0b1$32 = Math.imul(22528, b1$33);
  var lo$92 = ((a0b0$32 + (((a1b0$31 + a0b1$32) | 0) << 16)) | 0);
  var c1part$32 = ((((a0b0$32 >>> 16) | 0) + a0b1$32) | 0);
  var hi$107 = ((((((((Math.imul((-129542144), hi$106) + Math.imul(13, lo$91)) | 0) + Math.imul(63559, b1$33)) | 0) + ((c1part$32 >>> 16) | 0)) | 0) + (((((65535 & c1part$32) + a1b0$31) | 0) >>> 16) | 0)) | 0);
  var lo$93 = ((lo$78 + lo$92) | 0);
  var hi$108 = ((((hi$91 + hi$107) | 0) + ((((lo$78 & lo$92) | ((lo$78 | lo$92) & (~lo$93))) >>> 31) | 0)) | 0);
  var hi$109 = (hours_$_hi >> 31);
  var b0$34 = (65535 & hours_$_lo);
  var b1$34 = ((hours_$_lo >>> 16) | 0);
  var a0b0$33 = Math.imul(43690, b0$34);
  var a1b0$32 = Math.imul(10922, b0$34);
  var a0b1$33 = Math.imul(43690, b1$34);
  var lo$94 = ((a0b0$33 + (((a1b0$32 + a0b1$33) | 0) << 16)) | 0);
  var c1part$33 = ((((a0b0$33 >>> 16) | 0) + a0b1$33) | 0);
  var hi$110 = ((((Math.imul(10922, b1$34) + ((c1part$33 >>> 16) | 0)) | 0) + (((((65535 & c1part$33) + a1b0$32) | 0) >>> 16) | 0)) | 0);
  var b0$35 = (65535 & hours_$_lo);
  var b1$35 = ((hours_$_lo >>> 16) | 0);
  var a0b0$34 = Math.imul(43691, b0$35);
  var a1b0$33 = Math.imul(43690, b0$35);
  var a0b1$34 = Math.imul(43691, b1$35);
  var c1part$34 = ((((a0b0$34 >>> 16) | 0) + a0b1$34) | 0);
  var hi$111 = ((((Math.imul(43690, b1$35) + ((c1part$34 >>> 16) | 0)) | 0) + (((((65535 & c1part$34) + a1b0$33) | 0) >>> 16) | 0)) | 0);
  var lo$96 = ((lo$94 + hi$111) | 0);
  var hi$112 = ((hi$110 + ((((lo$94 & hi$111) | ((lo$94 | hi$111) & (~lo$96))) >>> 31) | 0)) | 0);
  var b0$36 = (65535 & hours_$_hi);
  var b1$36 = ((hours_$_hi >>> 16) | 0);
  var a0b0$35 = Math.imul(43690, b0$36);
  var a1b0$34 = Math.imul(10922, b0$36);
  var a0b1$35 = Math.imul(43690, b1$36);
  var lo$97 = ((a0b0$35 + (((a1b0$34 + a0b1$35) | 0) << 16)) | 0);
  var c1part$35 = ((((a0b0$35 >>> 16) | 0) + a0b1$35) | 0);
  var hi$113 = ((((((Math.imul(715827882, hi$109) + Math.imul(10922, b1$36)) | 0) + ((c1part$35 >>> 16) | 0)) | 0) + (((((65535 & c1part$35) + a1b0$34) | 0) >>> 16) | 0)) | 0);
  var hi$114 = (hi$112 >> 31);
  var lo$98 = ((lo$97 + hi$112) | 0);
  var hi$115 = ((((hi$113 + hi$114) | 0) + ((((lo$97 & hi$112) | ((lo$97 | hi$112) & (~lo$98))) >>> 31) | 0)) | 0);
  var b0$37 = (65535 & hours_$_hi);
  var b1$37 = ((hours_$_hi >>> 16) | 0);
  var a0b0$36 = Math.imul(43691, b0$37);
  var a1b0$35 = Math.imul(43690, b0$37);
  var a0b1$36 = Math.imul(43691, b1$37);
  var lo$99 = ((a0b0$36 + (((a1b0$35 + a0b1$36) | 0) << 16)) | 0);
  var c1part$36 = ((((a0b0$36 >>> 16) | 0) + a0b1$36) | 0);
  var hi$116 = ((((((Math.imul((-1431655765), hi$109) + Math.imul(43690, b1$37)) | 0) + ((c1part$36 >>> 16) | 0)) | 0) + (((((65535 & c1part$36) + a1b0$35) | 0) >>> 16) | 0)) | 0);
  var lo$100 = ((lo$96 + lo$99) | 0);
  var hi$117 = ((hi$116 + ((((lo$96 & lo$99) | ((lo$96 | lo$99) & (~lo$100))) >>> 31) | 0)) | 0);
  var hi$118 = (hi$117 >> 31);
  var lo$101 = ((lo$98 + hi$117) | 0);
  var hi$119 = ((((hi$115 + hi$118) | 0) + ((((lo$98 & hi$117) | ((lo$98 | hi$117) & (~lo$101))) >>> 31) | 0)) | 0);
  var lo$102 = (((lo$101 >>> 2) | 0) | (hi$119 << 30));
  var hi$120 = (hi$119 >> 2);
  var lo$103 = ((hours_$_hi >>> 31) | 0);
  var lo$104 = ((lo$102 + lo$103) | 0);
  var hi$121 = ((hi$120 + ((((lo$102 & lo$103) | ((lo$102 | lo$103) & (~lo$104))) >>> 31) | 0)) | 0);
  var b0$38 = (65535 & lo$104);
  var b1$38 = ((lo$104 >>> 16) | 0);
  var a0b0$37 = Math.imul(24, b0$38);
  var a0b1$37 = Math.imul(24, b1$38);
  var lo$105 = ((a0b0$37 + (a0b1$37 << 16)) | 0);
  var c1part$37 = ((((a0b0$37 >>> 16) | 0) + a0b1$37) | 0);
  var hi$122 = ((Math.imul(24, hi$121) + ((c1part$37 >>> 16) | 0)) | 0);
  var lo$106 = ((hours_$_lo - lo$105) | 0);
  var hi$123 = ((((hours_$_hi - hi$122) | 0) + ((((~hours_$_lo) & lo$105) | ((~(hours_$_lo ^ lo$105)) & lo$106)) >> 31)) | 0);
  var b0$39 = (65535 & lo$106);
  var b1$39 = ((lo$106 >>> 16) | 0);
  var a0b0$38 = Math.imul(40960, b0$39);
  var a1b0$36 = Math.imul(12472, b0$39);
  var a0b1$38 = Math.imul(40960, b1$39);
  var lo$107 = ((a0b0$38 + (((a1b0$36 + a0b1$38) | 0) << 16)) | 0);
  var c1part$38 = ((((a0b0$38 >>> 16) | 0) + a0b1$38) | 0);
  var hi$124 = ((((((((Math.imul(817405952, hi$123) + Math.imul(838, lo$106)) | 0) + Math.imul(12472, b1$39)) | 0) + ((c1part$38 >>> 16) | 0)) | 0) + (((((65535 & c1part$38) + a1b0$36) | 0) >>> 16) | 0)) | 0);
  var lo$108 = ((lo$93 + lo$107) | 0);
  var hi$125 = ((((hi$108 + hi$124) | 0) + ((((lo$93 & lo$107) | ((lo$93 | lo$107) & (~lo$108))) >>> 31) | 0)) | 0);
  var totNanos_$_lo = lo$108;
  var totNanos_$_hi = hi$125;
  var $x_1 = $n($thiz.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
  var curNoD_$_lo = $x_1.l;
  var curNoD_$_hi = $x_1.h;
  var x$1_$_lo = totNanos_$_lo;
  var x$1_$_hi = totNanos_$_hi;
  var hi$126 = (sign >> 31);
  var a0$1 = (65535 & x$1_$_lo);
  var a1$1 = ((x$1_$_lo >>> 16) | 0);
  var b0$40 = (65535 & sign);
  var b1$40 = ((sign >>> 16) | 0);
  var a0b0$39 = Math.imul(a0$1, b0$40);
  var a1b0$37 = Math.imul(a1$1, b0$40);
  var a0b1$39 = Math.imul(a0$1, b1$40);
  var lo$109 = ((a0b0$39 + (((a1b0$37 + a0b1$39) | 0) << 16)) | 0);
  var c1part$39 = ((((a0b0$39 >>> 16) | 0) + a0b1$39) | 0);
  var hi$127 = ((((((((Math.imul(x$1_$_lo, hi$126) + Math.imul(x$1_$_hi, sign)) | 0) + Math.imul(a1$1, b1$40)) | 0) + ((c1part$39 >>> 16) | 0)) | 0) + (((((65535 & c1part$39) + a1b0$37) | 0) >>> 16) | 0)) | 0);
  var lo$110 = ((lo$109 + curNoD_$_lo) | 0);
  var hi$128 = ((((hi$127 + curNoD_$_hi) | 0) + ((((lo$109 & curNoD_$_lo) | ((lo$109 | curNoD_$_lo) & (~lo$110))) >>> 31) | 0)) | 0);
  totNanos_$_lo = lo$110;
  totNanos_$_hi = hi$128;
  var x$2_$_lo = totDays_$_lo;
  var x$2_$_hi = totDays_$_hi;
  var a_$_lo = totNanos_$_lo;
  var a_$_hi = totNanos_$_hi;
  var hi$129 = (a_$_hi >> 31);
  var b0$41 = (65535 & a_$_lo);
  var b1$41 = ((a_$_lo >>> 16) | 0);
  var a0b0$40 = Math.imul(65391, b0$41);
  var a1b0$38 = Math.imul(26687, b0$41);
  var a0b1$40 = Math.imul(65391, b1$41);
  var lo$111 = ((a0b0$40 + (((a1b0$38 + a0b1$40) | 0) << 16)) | 0);
  var c1part$40 = ((((a0b0$40 >>> 16) | 0) + a0b1$40) | 0);
  var hi$130 = ((((Math.imul(26687, b1$41) + ((c1part$40 >>> 16) | 0)) | 0) + (((((65535 & c1part$40) + a1b0$38) | 0) >>> 16) | 0)) | 0);
  var b0$42 = (65535 & a_$_lo);
  var b1$42 = ((a_$_lo >>> 16) | 0);
  var a0b0$41 = Math.imul(18659, b0$42);
  var a1b0$39 = Math.imul(18681, b0$42);
  var a0b1$41 = Math.imul(18659, b1$42);
  var c1part$41 = ((((a0b0$41 >>> 16) | 0) + a0b1$41) | 0);
  var hi$131 = ((((Math.imul(18681, b1$42) + ((c1part$41 >>> 16) | 0)) | 0) + (((((65535 & c1part$41) + a1b0$39) | 0) >>> 16) | 0)) | 0);
  var lo$113 = ((lo$111 + hi$131) | 0);
  var hi$132 = ((hi$130 + ((((lo$111 & hi$131) | ((lo$111 | hi$131) & (~lo$113))) >>> 31) | 0)) | 0);
  var b0$43 = (65535 & a_$_hi);
  var b1$43 = ((a_$_hi >>> 16) | 0);
  var a0b0$42 = Math.imul(65391, b0$43);
  var a1b0$40 = Math.imul(26687, b0$43);
  var a0b1$42 = Math.imul(65391, b1$43);
  var lo$114 = ((a0b0$42 + (((a1b0$40 + a0b1$42) | 0) << 16)) | 0);
  var c1part$42 = ((((a0b0$42 >>> 16) | 0) + a0b1$42) | 0);
  var hi$133 = ((((((Math.imul(1749024623, hi$129) + Math.imul(26687, b1$43)) | 0) + ((c1part$42 >>> 16) | 0)) | 0) + (((((65535 & c1part$42) + a1b0$40) | 0) >>> 16) | 0)) | 0);
  var hi$134 = (hi$132 >> 31);
  var lo$115 = ((lo$114 + hi$132) | 0);
  var hi$135 = ((((hi$133 + hi$134) | 0) + ((((lo$114 & hi$132) | ((lo$114 | hi$132) & (~lo$115))) >>> 31) | 0)) | 0);
  var b0$44 = (65535 & a_$_hi);
  var b1$44 = ((a_$_hi >>> 16) | 0);
  var a0b0$43 = Math.imul(18659, b0$44);
  var a1b0$41 = Math.imul(18681, b0$44);
  var a0b1$43 = Math.imul(18659, b1$44);
  var lo$116 = ((a0b0$43 + (((a1b0$41 + a0b1$43) | 0) << 16)) | 0);
  var c1part$43 = ((((a0b0$43 >>> 16) | 0) + a0b1$43) | 0);
  var hi$136 = ((((((Math.imul(1224296675, hi$129) + Math.imul(18681, b1$44)) | 0) + ((c1part$43 >>> 16) | 0)) | 0) + (((((65535 & c1part$43) + a1b0$41) | 0) >>> 16) | 0)) | 0);
  var lo$117 = ((lo$113 + lo$116) | 0);
  var hi$137 = ((hi$136 + ((((lo$113 & lo$116) | ((lo$113 | lo$116) & (~lo$117))) >>> 31) | 0)) | 0);
  var hi$138 = (hi$137 >> 31);
  var lo$118 = ((lo$115 + hi$137) | 0);
  var hi$139 = ((((hi$135 + hi$138) | 0) + ((((lo$115 & hi$137) | ((lo$115 | hi$137) & (~lo$118))) >>> 31) | 0)) | 0);
  var lo$119 = (hi$139 >> 13);
  var hi$140 = (hi$139 >> 31);
  var lo$120 = ((a_$_hi >>> 31) | 0);
  var lo$121 = ((lo$119 + lo$120) | 0);
  var hi$141 = ((hi$140 + ((((lo$119 & lo$120) | ((lo$119 | lo$120) & (~lo$121))) >>> 31) | 0)) | 0);
  var hi$142 = (20116 ^ a_$_hi);
  if ((hi$142 >= 0)) {
    var $x_2 = true;
  } else {
    var b0$45 = (65535 & lo$121);
    var b1$45 = ((lo$121 >>> 16) | 0);
    var a1b0$42 = Math.imul(37199, b0$45);
    var lo$123 = (a1b0$42 << 16);
    var hi$143 = ((((((Math.imul((-1857093632), hi$141) + Math.imul(20116, lo$121)) | 0) + Math.imul(37199, b1$45)) | 0) + ((a1b0$42 >>> 16) | 0)) | 0);
    var $x_2 = (((lo$123 ^ a_$_lo) | (hi$143 ^ a_$_hi)) === 0);
  }
  if ($x_2) {
    var x$3_$_lo = lo$121;
    var x$3_$_hi = hi$141;
  } else {
    var lo$124 = ((lo$121 - 1) | 0);
    var hi$144 = ((((hi$141 - 1) | 0) + (((lo$121 | (~lo$124)) >>> 31) | 0)) | 0);
    var x$3_$_lo = lo$124;
    var x$3_$_hi = hi$144;
  }
  var lo$125 = ((x$2_$_lo + x$3_$_lo) | 0);
  var hi$145 = ((((x$2_$_hi + x$3_$_hi) | 0) + ((((x$2_$_lo & x$3_$_lo) | ((x$2_$_lo | x$3_$_lo) & (~lo$125))) >>> 31) | 0)) | 0);
  totDays_$_lo = lo$125;
  totDays_$_hi = hi$145;
  var a$1_$_lo = totNanos_$_lo;
  var a$1_$_hi = totNanos_$_hi;
  var hi$146 = (a$1_$_hi >> 31);
  var b0$46 = (65535 & a$1_$_lo);
  var b1$46 = ((a$1_$_lo >>> 16) | 0);
  var a0b0$44 = Math.imul(65391, b0$46);
  var a1b0$43 = Math.imul(26687, b0$46);
  var a0b1$44 = Math.imul(65391, b1$46);
  var lo$126 = ((a0b0$44 + (((a1b0$43 + a0b1$44) | 0) << 16)) | 0);
  var c1part$44 = ((((a0b0$44 >>> 16) | 0) + a0b1$44) | 0);
  var hi$147 = ((((Math.imul(26687, b1$46) + ((c1part$44 >>> 16) | 0)) | 0) + (((((65535 & c1part$44) + a1b0$43) | 0) >>> 16) | 0)) | 0);
  var b0$47 = (65535 & a$1_$_lo);
  var b1$47 = ((a$1_$_lo >>> 16) | 0);
  var a0b0$45 = Math.imul(18659, b0$47);
  var a1b0$44 = Math.imul(18681, b0$47);
  var a0b1$45 = Math.imul(18659, b1$47);
  var c1part$45 = ((((a0b0$45 >>> 16) | 0) + a0b1$45) | 0);
  var hi$148 = ((((Math.imul(18681, b1$47) + ((c1part$45 >>> 16) | 0)) | 0) + (((((65535 & c1part$45) + a1b0$44) | 0) >>> 16) | 0)) | 0);
  var lo$128 = ((lo$126 + hi$148) | 0);
  var hi$149 = ((hi$147 + ((((lo$126 & hi$148) | ((lo$126 | hi$148) & (~lo$128))) >>> 31) | 0)) | 0);
  var b0$48 = (65535 & a$1_$_hi);
  var b1$48 = ((a$1_$_hi >>> 16) | 0);
  var a0b0$46 = Math.imul(65391, b0$48);
  var a1b0$45 = Math.imul(26687, b0$48);
  var a0b1$46 = Math.imul(65391, b1$48);
  var lo$129 = ((a0b0$46 + (((a1b0$45 + a0b1$46) | 0) << 16)) | 0);
  var c1part$46 = ((((a0b0$46 >>> 16) | 0) + a0b1$46) | 0);
  var hi$150 = ((((((Math.imul(1749024623, hi$146) + Math.imul(26687, b1$48)) | 0) + ((c1part$46 >>> 16) | 0)) | 0) + (((((65535 & c1part$46) + a1b0$45) | 0) >>> 16) | 0)) | 0);
  var hi$151 = (hi$149 >> 31);
  var lo$130 = ((lo$129 + hi$149) | 0);
  var hi$152 = ((((hi$150 + hi$151) | 0) + ((((lo$129 & hi$149) | ((lo$129 | hi$149) & (~lo$130))) >>> 31) | 0)) | 0);
  var b0$49 = (65535 & a$1_$_hi);
  var b1$49 = ((a$1_$_hi >>> 16) | 0);
  var a0b0$47 = Math.imul(18659, b0$49);
  var a1b0$46 = Math.imul(18681, b0$49);
  var a0b1$47 = Math.imul(18659, b1$49);
  var lo$131 = ((a0b0$47 + (((a1b0$46 + a0b1$47) | 0) << 16)) | 0);
  var c1part$47 = ((((a0b0$47 >>> 16) | 0) + a0b1$47) | 0);
  var hi$153 = ((((((Math.imul(1224296675, hi$146) + Math.imul(18681, b1$49)) | 0) + ((c1part$47 >>> 16) | 0)) | 0) + (((((65535 & c1part$47) + a1b0$46) | 0) >>> 16) | 0)) | 0);
  var lo$132 = ((lo$128 + lo$131) | 0);
  var hi$154 = ((hi$153 + ((((lo$128 & lo$131) | ((lo$128 | lo$131) & (~lo$132))) >>> 31) | 0)) | 0);
  var hi$155 = (hi$154 >> 31);
  var lo$133 = ((lo$130 + hi$154) | 0);
  var hi$156 = ((((hi$152 + hi$155) | 0) + ((((lo$130 & hi$154) | ((lo$130 | hi$154) & (~lo$133))) >>> 31) | 0)) | 0);
  var lo$134 = (hi$156 >> 13);
  var hi$157 = (hi$156 >> 31);
  var lo$135 = ((a$1_$_hi >>> 31) | 0);
  var lo$136 = ((lo$134 + lo$135) | 0);
  var hi$158 = ((hi$157 + ((((lo$134 & lo$135) | ((lo$134 | lo$135) & (~lo$136))) >>> 31) | 0)) | 0);
  var b0$50 = (65535 & lo$136);
  var b1$50 = ((lo$136 >>> 16) | 0);
  var a1b0$47 = Math.imul(37199, b0$50);
  var lo$137 = (a1b0$47 << 16);
  var hi$159 = ((((((Math.imul((-1857093632), hi$158) + Math.imul(20116, lo$136)) | 0) + Math.imul(37199, b1$50)) | 0) + ((a1b0$47 >>> 16) | 0)) | 0);
  var lo$138 = ((a$1_$_lo - lo$137) | 0);
  var hi$160 = ((((a$1_$_hi - hi$159) | 0) + ((((~a$1_$_lo) & lo$137) | ((~(a$1_$_lo ^ lo$137)) & lo$138)) >> 31)) | 0);
  var hi$161 = (20116 ^ a$1_$_hi);
  if (((hi$161 >= 0) || ((lo$138 | hi$160) === 0))) {
    var newNoD_$_lo = lo$138;
    var newNoD_$_hi = hi$160;
  } else {
    var lo$140 = ((lo$138 - 1857093632) | 0);
    var hi$162 = ((((20116 + hi$160) | 0) + (((lo$138 | (~lo$140)) >>> 31) | 0)) | 0);
    var newNoD_$_lo = lo$140;
    var newNoD_$_hi = hi$162;
  }
  var newTime = ((((newNoD_$_lo ^ curNoD_$_lo) | (newNoD_$_hi ^ curNoD_$_hi)) === 0) ? $thiz.Ljava_time_LocalDateTime__f_time : $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(newNoD_$_lo, newNoD_$_hi));
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, $n(newDate).plusDays__J__Ljava_time_LocalDate(totDays_$_lo, totDays_$_hi), newTime);
}
function $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I($thiz, other) {
  var $x_1 = $n($thiz.Ljava_time_LocalDateTime__f_date);
  var this$1 = $n(other);
  var cmp = $x_1.compareTo0__Ljava_time_LocalDate__I(this$1.Ljava_time_LocalDateTime__f_date);
  if ((cmp === 0)) {
    var this$3 = $n($thiz.Ljava_time_LocalDateTime__f_time);
    var this$2 = $n(other);
    var other$1 = this$2.Ljava_time_LocalDateTime__f_time;
    cmp = this$3.compare__Ljava_time_LocalTime__I(other$1);
  }
  return cmp;
}
/** @constructor */
function $c_Ljava_time_LocalDateTime(date, time) {
  this.Ljava_time_LocalDateTime__f_date = null;
  this.Ljava_time_LocalDateTime__f_time = null;
  this.Ljava_time_LocalDateTime__f_date = date;
  this.Ljava_time_LocalDateTime__f_time = time;
}
$c_Ljava_time_LocalDateTime.prototype = new $h_Ljava_time_chrono_ChronoLocalDateTime();
$c_Ljava_time_LocalDateTime.prototype.constructor = $c_Ljava_time_LocalDateTime;
/** @constructor */
function $h_Ljava_time_LocalDateTime() {
}
$h_Ljava_time_LocalDateTime.prototype = $c_Ljava_time_LocalDateTime.prototype;
$c_Ljava_time_LocalDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return ($n(field).isDateBased__Z() || $n(field).isTimeBased__Z());
  } else if ((field !== null)) {
    var this$1 = $n(field);
    return this.isSupported__Ljava_time_temporal_TemporalField__Z(this$1);
  } else {
    return false;
  }
});
$c_Ljava_time_LocalDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ($n(field).isTimeBased__Z()) {
      var this$1 = $n(this.Ljava_time_LocalDateTime__f_time);
      return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$1, field);
    } else {
      return $n(this.Ljava_time_LocalDateTime__f_date).range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field);
    }
  } else {
    var this$2 = $n(field);
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$2);
  }
});
$c_Ljava_time_LocalDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? ($n(field).isTimeBased__Z() ? $n(this.Ljava_time_LocalDateTime__f_time).get__Ljava_time_temporal_TemporalField__I(field) : $n(this.Ljava_time_LocalDateTime__f_date).get__Ljava_time_temporal_TemporalField__I(field)) : $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field));
});
$c_Ljava_time_LocalDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ($n(field).isTimeBased__Z()) {
      return $n(this.Ljava_time_LocalDateTime__f_time).getLong__Ljava_time_temporal_TemporalField__J(field);
    } else {
      return $n(this.Ljava_time_LocalDateTime__f_date).getLong__Ljava_time_temporal_TemporalField__J(field);
    }
  } else {
    var this$1 = $n(field);
    return this.getLong__Ljava_time_temporal_TemporalField__J(this$1);
  }
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return ($n(field).isTimeBased__Z() ? $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $n(this.Ljava_time_LocalDateTime__f_time).with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(field, newValue_$_lo, newValue_$_hi)) : $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, $n(this.Ljava_time_LocalDateTime__f_date).with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(field, newValue_$_lo, newValue_$_hi), this.Ljava_time_LocalDateTime__f_time));
  } else {
    var this$1 = $n(field);
    return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(this$1, newValue_$_lo, newValue_$_hi);
  }
});
$c_Ljava_time_LocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_LocalDateTime__f_date : $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O.call(this, query));
});
$c_Ljava_time_LocalDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var f = $as_Ljava_time_temporal_ChronoUnit(unit);
    if ($n(f).isTimeBased__Z()) {
      var $x_1 = $n(this.Ljava_time_LocalDateTime__f_date).daysUntil__Ljava_time_LocalDate__J($n(end).Ljava_time_LocalDateTime__f_date);
      var daysUntil_$_lo = $x_1.l;
      var daysUntil_$_hi = $x_1.h;
      var $x_2 = $n($n(end).Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
      var x_$_lo = $x_2.l;
      var x_$_hi = $x_2.h;
      var $x_3 = $n(this.Ljava_time_LocalDateTime__f_time).toNanoOfDay__J();
      var x$1_$_lo = $x_3.l;
      var x$1_$_hi = $x_3.h;
      var lo = ((x_$_lo - x$1_$_lo) | 0);
      var hi = ((((x_$_hi - x$1_$_hi) | 0) + ((((~x_$_lo) & x$1_$_lo) | ((~(x_$_lo ^ x$1_$_lo)) & lo)) >> 31)) | 0);
      var timeUntil_$_lo = lo;
      var timeUntil_$_hi = hi;
      var x$2_$_lo = daysUntil_$_lo;
      var x$2_$_hi = daysUntil_$_hi;
      if (((x$2_$_hi === 0) ? (x$2_$_lo !== 0) : (x$2_$_hi > 0))) {
        var x$3_$_lo = timeUntil_$_lo;
        var x$3_$_hi = timeUntil_$_hi;
        var $x_4 = (x$3_$_hi < 0);
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        var x$4_$_lo = daysUntil_$_lo;
        var x$4_$_hi = daysUntil_$_hi;
        var lo$1 = ((x$4_$_lo - 1) | 0);
        var hi$1 = ((((x$4_$_hi - 1) | 0) + (((x$4_$_lo | (~lo$1)) >>> 31) | 0)) | 0);
        daysUntil_$_lo = lo$1;
        daysUntil_$_hi = hi$1;
        var x$5_$_lo = timeUntil_$_lo;
        var x$5_$_hi = timeUntil_$_hi;
        var lo$2 = ((x$5_$_lo - 1857093632) | 0);
        var hi$2 = ((((20116 + x$5_$_hi) | 0) + (((x$5_$_lo | (~lo$2)) >>> 31) | 0)) | 0);
        timeUntil_$_lo = lo$2;
        timeUntil_$_hi = hi$2;
      } else {
        var x$6_$_lo = daysUntil_$_lo;
        var x$6_$_hi = daysUntil_$_hi;
        if ((x$6_$_hi < 0)) {
          var x$7_$_lo = timeUntil_$_lo;
          var x$7_$_hi = timeUntil_$_hi;
          var $x_5 = ((x$7_$_hi === 0) ? (x$7_$_lo !== 0) : (x$7_$_hi > 0));
        } else {
          var $x_5 = false;
        }
        if ($x_5) {
          var x$8_$_lo = daysUntil_$_lo;
          var x$8_$_hi = daysUntil_$_hi;
          var lo$3 = ((1 + x$8_$_lo) | 0);
          var hi$3 = ((x$8_$_hi + (((x$8_$_lo & (~lo$3)) >>> 31) | 0)) | 0);
          daysUntil_$_lo = lo$3;
          daysUntil_$_hi = hi$3;
          var x$9_$_lo = timeUntil_$_lo;
          var x$9_$_hi = timeUntil_$_hi;
          var lo$4 = ((1857093632 + x$9_$_lo) | 0);
          var hi$4 = ((((x$9_$_hi - 20117) | 0) + (((x$9_$_lo & (~lo$4)) >>> 31) | 0)) | 0);
          timeUntil_$_lo = lo$4;
          timeUntil_$_hi = hi$4;
        }
      }
      var x$10 = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
      if ((x$10 === null)) {
        var $x_6 = (f === null);
      } else {
        var this$10 = $n(x$10);
        var $x_6 = (this$10 === f);
      }
      if ($x_6) {
        var a_$_lo = daysUntil_$_lo;
        var a_$_hi = daysUntil_$_hi;
        var this$11 = $m_jl_Math$();
        var b0 = (65535 & a_$_lo);
        var b1 = ((a_$_lo >>> 16) | 0);
        var a1b0 = Math.imul(37199, b0);
        var lo$5 = (a1b0 << 16);
        var hi$5 = ((((((Math.imul((-1857093632), a_$_hi) + Math.imul(20116, a_$_lo)) | 0) + Math.imul(37199, b1)) | 0) + ((a1b0 >>> 16) | 0)) | 0);
        if (((a_$_lo | a_$_hi) !== 0)) {
          var $x_8 = $m_RTLong$().divide__I__I__I__I__J(lo$5, hi$5, a_$_lo, a_$_hi);
          var x$11_$_lo = $x_8.l;
          var x$11_$_hi = $x_8.h;
          var $x_7 = ((((-1857093632) ^ x$11_$_lo) | (20116 ^ x$11_$_hi)) !== 0);
        } else {
          var $x_7 = false;
        }
        if ($x_7) {
          this$11.java$lang$Math$$longOverflow__E();
        }
        var b_$_lo = timeUntil_$_lo;
        var b_$_hi = timeUntil_$_hi;
        var this$16 = $m_jl_Math$();
        var lo$6 = ((lo$5 + b_$_lo) | 0);
        var hi$6 = ((((hi$5 + b_$_hi) | 0) + ((((lo$5 & b_$_lo) | ((lo$5 | b_$_lo) & (~lo$6))) >>> 31) | 0)) | 0);
        var hi$7 = (hi$6 ^ hi$5);
        var hi$8 = (hi$6 ^ b_$_hi);
        var hi$9 = (hi$7 & hi$8);
        if ((hi$9 < 0)) {
          this$16.java$lang$Math$$longOverflow__E();
        }
        return $bL(lo$6, hi$6);
      }
      var x$3$1 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
      if ((x$3$1 === null)) {
        var $x_9 = (f === null);
      } else {
        var this$22 = $n(x$3$1);
        var $x_9 = (this$22 === f);
      }
      if ($x_9) {
        var a$1_$_lo = daysUntil_$_lo;
        var a$1_$_hi = daysUntil_$_hi;
        var this$23 = $m_jl_Math$();
        var b0$1 = (65535 & a$1_$_lo);
        var b1$1 = ((a$1_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(24576, b0$1);
        var a1b0$1 = Math.imul(7639, b0$1);
        var a0b1 = Math.imul(24576, b1$1);
        var lo$10 = ((a0b0 + (((a1b0$1 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$10 = ((((((((Math.imul(500654080, a$1_$_hi) + Math.imul(20, a$1_$_lo)) | 0) + Math.imul(7639, b1$1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        if (((a$1_$_lo | a$1_$_hi) !== 0)) {
          var $x_11 = $m_RTLong$().divide__I__I__I__I__J(lo$10, hi$10, a$1_$_lo, a$1_$_hi);
          var x$12_$_lo = $x_11.l;
          var x$12_$_hi = $x_11.h;
          var $x_10 = (((500654080 ^ x$12_$_lo) | (20 ^ x$12_$_hi)) !== 0);
        } else {
          var $x_10 = false;
        }
        if ($x_10) {
          this$23.java$lang$Math$$longOverflow__E();
        }
        var num_$_lo = timeUntil_$_lo;
        var num_$_hi = timeUntil_$_hi;
        var hi$11 = (num_$_hi >> 31);
        var b0$2 = (65535 & num_$_lo);
        var b1$2 = ((num_$_lo >>> 16) | 0);
        var a0b0$1 = Math.imul(39845, b0$2);
        var a1b0$2 = Math.imul(8388, b0$2);
        var a0b1$1 = Math.imul(39845, b1$2);
        var lo$11 = ((a0b0$1 + (((a1b0$2 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$12 = ((((Math.imul(8388, b1$2) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$2) | 0) >>> 16) | 0)) | 0);
        var b0$3 = (65535 & num_$_lo);
        var b1$3 = ((num_$_lo >>> 16) | 0);
        var a0b0$2 = Math.imul(63439, b0$3);
        var a1b0$3 = Math.imul(58195, b0$3);
        var a0b1$2 = Math.imul(63439, b1$3);
        var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
        var hi$13 = ((((Math.imul(58195, b1$3) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$3) | 0) >>> 16) | 0)) | 0);
        var lo$13 = ((lo$11 + hi$13) | 0);
        var hi$14 = ((hi$12 + ((((lo$11 & hi$13) | ((lo$11 | hi$13) & (~lo$13))) >>> 31) | 0)) | 0);
        var b0$4 = (65535 & num_$_hi);
        var b1$4 = ((num_$_hi >>> 16) | 0);
        var a0b0$3 = Math.imul(39845, b0$4);
        var a1b0$4 = Math.imul(8388, b0$4);
        var a0b1$3 = Math.imul(39845, b1$4);
        var lo$14 = ((a0b0$3 + (((a1b0$4 + a0b1$3) | 0) << 16)) | 0);
        var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
        var hi$15 = ((((((Math.imul(549755813, hi$11) + Math.imul(8388, b1$4)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$4) | 0) >>> 16) | 0)) | 0);
        var hi$16 = (hi$14 >> 31);
        var lo$15 = ((lo$14 + hi$14) | 0);
        var hi$17 = ((((hi$15 + hi$16) | 0) + ((((lo$14 & hi$14) | ((lo$14 | hi$14) & (~lo$15))) >>> 31) | 0)) | 0);
        var b0$5 = (65535 & num_$_hi);
        var b1$5 = ((num_$_hi >>> 16) | 0);
        var a0b0$4 = Math.imul(63439, b0$5);
        var a1b0$5 = Math.imul(58195, b0$5);
        var a0b1$4 = Math.imul(63439, b1$5);
        var lo$16 = ((a0b0$4 + (((a1b0$5 + a0b1$4) | 0) << 16)) | 0);
        var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
        var hi$18 = ((((((Math.imul((-481036337), hi$11) + Math.imul(58195, b1$5)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$5) | 0) >>> 16) | 0)) | 0);
        var lo$17 = ((lo$13 + lo$16) | 0);
        var hi$19 = ((hi$18 + ((((lo$13 & lo$16) | ((lo$13 | lo$16) & (~lo$17))) >>> 31) | 0)) | 0);
        var hi$20 = (hi$19 >> 31);
        var lo$18 = ((lo$15 + hi$19) | 0);
        var hi$21 = ((((hi$17 + hi$20) | 0) + ((((lo$15 & hi$19) | ((lo$15 | hi$19) & (~lo$18))) >>> 31) | 0)) | 0);
        var lo$19 = (((lo$18 >>> 7) | 0) | (hi$21 << 25));
        var hi$22 = (hi$21 >> 7);
        var lo$20 = ((num_$_hi >>> 31) | 0);
        var lo$21 = ((lo$19 + lo$20) | 0);
        var hi$23 = ((hi$22 + ((((lo$19 & lo$20) | ((lo$19 | lo$20) & (~lo$21))) >>> 31) | 0)) | 0);
        var this$45 = $m_jl_Math$();
        var lo$22 = ((lo$10 + lo$21) | 0);
        var hi$24 = ((((hi$10 + hi$23) | 0) + ((((lo$10 & lo$21) | ((lo$10 | lo$21) & (~lo$22))) >>> 31) | 0)) | 0);
        var hi$25 = (hi$24 ^ hi$10);
        var hi$26 = (hi$24 ^ hi$23);
        var hi$27 = (hi$25 & hi$26);
        if ((hi$27 < 0)) {
          this$45.java$lang$Math$$longOverflow__E();
        }
        return $bL(lo$22, hi$24);
      }
      var x$5$1 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
      if ((x$5$1 === null)) {
        var $x_12 = (f === null);
      } else {
        var this$51 = $n(x$5$1);
        var $x_12 = (this$51 === f);
      }
      if ($x_12) {
        var a$2_$_lo = daysUntil_$_lo;
        var a$2_$_hi = daysUntil_$_hi;
        var this$52 = $m_jl_Math$();
        var b0$6 = (65535 & a$2_$_lo);
        var b1$6 = ((a$2_$_lo >>> 16) | 0);
        var a0b0$5 = Math.imul(23552, b0$6);
        var a1b0$6 = Math.imul(1318, b0$6);
        var a0b1$5 = Math.imul(23552, b1$6);
        var lo$26 = ((a0b0$5 + (((a1b0$6 + a0b1$5) | 0) << 16)) | 0);
        var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
        var hi$28 = ((((((Math.imul(86400000, a$2_$_hi) + Math.imul(1318, b1$6)) | 0) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + a1b0$6) | 0) >>> 16) | 0)) | 0);
        if (((a$2_$_lo | a$2_$_hi) !== 0)) {
          var $x_14 = $m_RTLong$().divide__I__I__I__I__J(lo$26, hi$28, a$2_$_lo, a$2_$_hi);
          var x$13_$_lo = $x_14.l;
          var x$13_$_hi = $x_14.h;
          var $x_13 = (((86400000 ^ x$13_$_lo) | x$13_$_hi) !== 0);
        } else {
          var $x_13 = false;
        }
        if ($x_13) {
          this$52.java$lang$Math$$longOverflow__E();
        }
        var num$1_$_lo = timeUntil_$_lo;
        var num$1_$_hi = timeUntil_$_hi;
        var hi$29 = (num$1_$_hi >> 31);
        var b0$7 = (65535 & num$1_$_lo);
        var b1$7 = ((num$1_$_lo >>> 16) | 0);
        var a0b0$6 = Math.imul(56962, b0$7);
        var a1b0$7 = Math.imul(17179, b0$7);
        var a0b1$6 = Math.imul(56962, b1$7);
        var lo$27 = ((a0b0$6 + (((a1b0$7 + a0b1$6) | 0) << 16)) | 0);
        var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
        var hi$30 = ((((Math.imul(17179, b1$7) + ((c1part$6 >>> 16) | 0)) | 0) + (((((65535 & c1part$6) + a1b0$7) | 0) >>> 16) | 0)) | 0);
        var b0$8 = (65535 & num$1_$_lo);
        var b1$8 = ((num$1_$_lo >>> 16) | 0);
        var a0b0$7 = Math.imul(13531, b0$8);
        var a1b0$8 = Math.imul(55222, b0$8);
        var a0b1$7 = Math.imul(13531, b1$8);
        var c1part$7 = ((((a0b0$7 >>> 16) | 0) + a0b1$7) | 0);
        var hi$31 = ((((Math.imul(55222, b1$8) + ((c1part$7 >>> 16) | 0)) | 0) + (((((65535 & c1part$7) + a1b0$8) | 0) >>> 16) | 0)) | 0);
        var lo$29 = ((lo$27 + hi$31) | 0);
        var hi$32 = ((hi$30 + ((((lo$27 & hi$31) | ((lo$27 | hi$31) & (~lo$29))) >>> 31) | 0)) | 0);
        var b0$9 = (65535 & num$1_$_hi);
        var b1$9 = ((num$1_$_hi >>> 16) | 0);
        var a0b0$8 = Math.imul(56962, b0$9);
        var a1b0$9 = Math.imul(17179, b0$9);
        var a0b1$8 = Math.imul(56962, b1$9);
        var lo$30 = ((a0b0$8 + (((a1b0$9 + a0b1$8) | 0) << 16)) | 0);
        var c1part$8 = ((((a0b0$8 >>> 16) | 0) + a0b1$8) | 0);
        var hi$33 = ((((((Math.imul(1125899906, hi$29) + Math.imul(17179, b1$9)) | 0) + ((c1part$8 >>> 16) | 0)) | 0) + (((((65535 & c1part$8) + a1b0$9) | 0) >>> 16) | 0)) | 0);
        var hi$34 = (hi$32 >> 31);
        var lo$31 = ((lo$30 + hi$32) | 0);
        var hi$35 = ((((hi$33 + hi$34) | 0) + ((((lo$30 & hi$32) | ((lo$30 | hi$32) & (~lo$31))) >>> 31) | 0)) | 0);
        var b0$10 = (65535 & num$1_$_hi);
        var b1$10 = ((num$1_$_hi >>> 16) | 0);
        var a0b0$9 = Math.imul(13531, b0$10);
        var a1b0$10 = Math.imul(55222, b0$10);
        var a0b1$9 = Math.imul(13531, b1$10);
        var lo$32 = ((a0b0$9 + (((a1b0$10 + a0b1$9) | 0) << 16)) | 0);
        var c1part$9 = ((((a0b0$9 >>> 16) | 0) + a0b1$9) | 0);
        var hi$36 = ((((((Math.imul((-675924773), hi$29) + Math.imul(55222, b1$10)) | 0) + ((c1part$9 >>> 16) | 0)) | 0) + (((((65535 & c1part$9) + a1b0$10) | 0) >>> 16) | 0)) | 0);
        var lo$33 = ((lo$29 + lo$32) | 0);
        var hi$37 = ((hi$36 + ((((lo$29 & lo$32) | ((lo$29 | lo$32) & (~lo$33))) >>> 31) | 0)) | 0);
        var hi$38 = (hi$37 >> 31);
        var lo$34 = ((lo$31 + hi$37) | 0);
        var hi$39 = ((((hi$35 + hi$38) | 0) + ((((lo$31 & hi$37) | ((lo$31 | hi$37) & (~lo$34))) >>> 31) | 0)) | 0);
        var lo$35 = (((lo$34 >>> 18) | 0) | (hi$39 << 14));
        var hi$40 = (hi$39 >> 18);
        var lo$36 = ((num$1_$_hi >>> 31) | 0);
        var lo$37 = ((lo$35 + lo$36) | 0);
        var hi$41 = ((hi$40 + ((((lo$35 & lo$36) | ((lo$35 | lo$36) & (~lo$37))) >>> 31) | 0)) | 0);
        var this$74 = $m_jl_Math$();
        var lo$38 = ((lo$26 + lo$37) | 0);
        var hi$42 = ((((hi$28 + hi$41) | 0) + ((((lo$26 & lo$37) | ((lo$26 | lo$37) & (~lo$38))) >>> 31) | 0)) | 0);
        var hi$43 = (hi$42 ^ hi$28);
        var hi$44 = (hi$42 ^ hi$41);
        var hi$45 = (hi$43 & hi$44);
        if ((hi$45 < 0)) {
          this$74.java$lang$Math$$longOverflow__E();
        }
        return $bL(lo$38, hi$42);
      }
      var x$7$1 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
      if ((x$7$1 === null)) {
        var $x_15 = (f === null);
      } else {
        var this$80 = $n(x$7$1);
        var $x_15 = (this$80 === f);
      }
      if ($x_15) {
        var a$3_$_lo = daysUntil_$_lo;
        var a$3_$_hi = daysUntil_$_hi;
        var this$81 = $m_jl_Math$();
        var b0$11 = (65535 & a$3_$_lo);
        var b1$11 = ((a$3_$_lo >>> 16) | 0);
        var a0b0$10 = Math.imul(20864, b0$11);
        var a0b1$10 = Math.imul(20864, b1$11);
        var lo$42 = ((a0b0$10 + (((b0$11 + a0b1$10) | 0) << 16)) | 0);
        var c1part$10 = ((((a0b0$10 >>> 16) | 0) + a0b1$10) | 0);
        var hi$46 = ((((((Math.imul(86400, a$3_$_hi) + b1$11) | 0) + ((c1part$10 >>> 16) | 0)) | 0) + (((((65535 & c1part$10) + b0$11) | 0) >>> 16) | 0)) | 0);
        if (((a$3_$_lo | a$3_$_hi) !== 0)) {
          var $x_17 = $m_RTLong$().divide__I__I__I__I__J(lo$42, hi$46, a$3_$_lo, a$3_$_hi);
          var x$14_$_lo = $x_17.l;
          var x$14_$_hi = $x_17.h;
          var $x_16 = (((86400 ^ x$14_$_lo) | x$14_$_hi) !== 0);
        } else {
          var $x_16 = false;
        }
        if ($x_16) {
          this$81.java$lang$Math$$longOverflow__E();
        }
        var num$2_$_lo = timeUntil_$_lo;
        var num$2_$_hi = timeUntil_$_hi;
        var hi$47 = (num$2_$_hi >> 31);
        var b0$12 = (65535 & num$2_$_lo);
        var b1$12 = ((num$2_$_lo >>> 16) | 0);
        var a0b0$11 = Math.imul(3048, b0$12);
        var a1b0$11 = Math.imul(4398, b0$12);
        var a0b1$11 = Math.imul(3048, b1$12);
        var lo$43 = ((a0b0$11 + (((a1b0$11 + a0b1$11) | 0) << 16)) | 0);
        var c1part$11 = ((((a0b0$11 >>> 16) | 0) + a0b1$11) | 0);
        var hi$48 = ((((Math.imul(4398, b1$12) + ((c1part$11 >>> 16) | 0)) | 0) + (((((65535 & c1part$11) + a1b0$11) | 0) >>> 16) | 0)) | 0);
        var b0$13 = (65535 & num$2_$_lo);
        var b1$13 = ((num$2_$_lo >>> 16) | 0);
        var a0b0$12 = Math.imul(38067, b0$13);
        var a1b0$12 = Math.imul(9942, b0$13);
        var a0b1$12 = Math.imul(38067, b1$13);
        var c1part$12 = ((((a0b0$12 >>> 16) | 0) + a0b1$12) | 0);
        var hi$49 = ((((Math.imul(9942, b1$13) + ((c1part$12 >>> 16) | 0)) | 0) + (((((65535 & c1part$12) + a1b0$12) | 0) >>> 16) | 0)) | 0);
        var lo$45 = ((lo$43 + hi$49) | 0);
        var hi$50 = ((hi$48 + ((((lo$43 & hi$49) | ((lo$43 | hi$49) & (~lo$45))) >>> 31) | 0)) | 0);
        var b0$14 = (65535 & num$2_$_hi);
        var b1$14 = ((num$2_$_hi >>> 16) | 0);
        var a0b0$13 = Math.imul(3048, b0$14);
        var a1b0$13 = Math.imul(4398, b0$14);
        var a0b1$13 = Math.imul(3048, b1$14);
        var lo$46 = ((a0b0$13 + (((a1b0$13 + a0b1$13) | 0) << 16)) | 0);
        var c1part$13 = ((((a0b0$13 >>> 16) | 0) + a0b1$13) | 0);
        var hi$51 = ((((((Math.imul(288230376, hi$47) + Math.imul(4398, b1$14)) | 0) + ((c1part$13 >>> 16) | 0)) | 0) + (((((65535 & c1part$13) + a1b0$13) | 0) >>> 16) | 0)) | 0);
        var hi$52 = (hi$50 >> 31);
        var lo$47 = ((lo$46 + hi$50) | 0);
        var hi$53 = ((((hi$51 + hi$52) | 0) + ((((lo$46 & hi$50) | ((lo$46 | hi$50) & (~lo$47))) >>> 31) | 0)) | 0);
        var b0$15 = (65535 & num$2_$_hi);
        var b1$15 = ((num$2_$_hi >>> 16) | 0);
        var a0b0$14 = Math.imul(38067, b0$15);
        var a1b0$14 = Math.imul(9942, b0$15);
        var a0b1$14 = Math.imul(38067, b1$15);
        var lo$48 = ((a0b0$14 + (((a1b0$14 + a0b1$14) | 0) << 16)) | 0);
        var c1part$14 = ((((a0b0$14 >>> 16) | 0) + a0b1$14) | 0);
        var hi$54 = ((((((Math.imul(651596979, hi$47) + Math.imul(9942, b1$15)) | 0) + ((c1part$14 >>> 16) | 0)) | 0) + (((((65535 & c1part$14) + a1b0$14) | 0) >>> 16) | 0)) | 0);
        var lo$49 = ((lo$45 + lo$48) | 0);
        var hi$55 = ((hi$54 + ((((lo$45 & lo$48) | ((lo$45 | lo$48) & (~lo$49))) >>> 31) | 0)) | 0);
        var hi$56 = (hi$55 >> 31);
        var lo$50 = ((lo$47 + hi$55) | 0);
        var hi$57 = ((((hi$53 + hi$56) | 0) + ((((lo$47 & hi$55) | ((lo$47 | hi$55) & (~lo$50))) >>> 31) | 0)) | 0);
        var lo$51 = (((lo$50 >>> 26) | 0) | (hi$57 << 6));
        var hi$58 = (hi$57 >> 26);
        var lo$52 = ((num$2_$_hi >>> 31) | 0);
        var lo$53 = ((lo$51 + lo$52) | 0);
        var hi$59 = ((hi$58 + ((((lo$51 & lo$52) | ((lo$51 | lo$52) & (~lo$53))) >>> 31) | 0)) | 0);
        var this$103 = $m_jl_Math$();
        var lo$54 = ((lo$42 + lo$53) | 0);
        var hi$60 = ((((hi$46 + hi$59) | 0) + ((((lo$42 & lo$53) | ((lo$42 | lo$53) & (~lo$54))) >>> 31) | 0)) | 0);
        var hi$61 = (hi$60 ^ hi$46);
        var hi$62 = (hi$60 ^ hi$59);
        var hi$63 = (hi$61 & hi$62);
        if ((hi$63 < 0)) {
          this$103.java$lang$Math$$longOverflow__E();
        }
        return $bL(lo$54, hi$60);
      }
      var x$9$1 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
      if ((x$9$1 === null)) {
        var $x_18 = (f === null);
      } else {
        var this$109 = $n(x$9$1);
        var $x_18 = (this$109 === f);
      }
      if ($x_18) {
        var a$4_$_lo = daysUntil_$_lo;
        var a$4_$_hi = daysUntil_$_hi;
        var this$110 = $m_jl_Math$();
        var b0$16 = (65535 & a$4_$_lo);
        var b1$16 = ((a$4_$_lo >>> 16) | 0);
        var a0b0$15 = Math.imul(1440, b0$16);
        var a0b1$15 = Math.imul(1440, b1$16);
        var lo$58 = ((a0b0$15 + (a0b1$15 << 16)) | 0);
        var c1part$15 = ((((a0b0$15 >>> 16) | 0) + a0b1$15) | 0);
        var hi$64 = ((Math.imul(1440, a$4_$_hi) + ((c1part$15 >>> 16) | 0)) | 0);
        if (((a$4_$_lo | a$4_$_hi) !== 0)) {
          var $x_20 = $m_RTLong$().divide__I__I__I__I__J(lo$58, hi$64, a$4_$_lo, a$4_$_hi);
          var x$15_$_lo = $x_20.l;
          var x$15_$_hi = $x_20.h;
          var $x_19 = (((1440 ^ x$15_$_lo) | x$15_$_hi) !== 0);
        } else {
          var $x_19 = false;
        }
        if ($x_19) {
          this$110.java$lang$Math$$longOverflow__E();
        }
        var num$3_$_lo = timeUntil_$_lo;
        var num$3_$_hi = timeUntil_$_hi;
        var hi$65 = (num$3_$_hi >> 31);
        var b0$17 = (65535 & num$3_$_lo);
        var b1$17 = ((num$3_$_lo >>> 16) | 0);
        var a0b0$16 = Math.imul(13310, b0$17);
        var a1b0$15 = Math.imul(293, b0$17);
        var a0b1$16 = Math.imul(13310, b1$17);
        var lo$59 = ((a0b0$16 + (((a1b0$15 + a0b1$16) | 0) << 16)) | 0);
        var c1part$16 = ((((a0b0$16 >>> 16) | 0) + a0b1$16) | 0);
        var hi$66 = ((((Math.imul(293, b1$17) + ((c1part$16 >>> 16) | 0)) | 0) + (((((65535 & c1part$16) + a1b0$15) | 0) >>> 16) | 0)) | 0);
        var b0$18 = (65535 & num$3_$_lo);
        var b1$18 = ((num$3_$_lo >>> 16) | 0);
        var a0b0$17 = Math.imul(15645, b0$18);
        var a1b0$16 = Math.imul(26877, b0$18);
        var a0b1$17 = Math.imul(15645, b1$18);
        var c1part$17 = ((((a0b0$17 >>> 16) | 0) + a0b1$17) | 0);
        var hi$67 = ((((Math.imul(26877, b1$18) + ((c1part$17 >>> 16) | 0)) | 0) + (((((65535 & c1part$17) + a1b0$16) | 0) >>> 16) | 0)) | 0);
        var lo$61 = ((lo$59 + hi$67) | 0);
        var hi$68 = ((hi$66 + ((((lo$59 & hi$67) | ((lo$59 | hi$67) & (~lo$61))) >>> 31) | 0)) | 0);
        var b0$19 = (65535 & num$3_$_hi);
        var b1$19 = ((num$3_$_hi >>> 16) | 0);
        var a0b0$18 = Math.imul(13310, b0$19);
        var a1b0$17 = Math.imul(293, b0$19);
        var a0b1$18 = Math.imul(13310, b1$19);
        var lo$62 = ((a0b0$18 + (((a1b0$17 + a0b1$18) | 0) << 16)) | 0);
        var c1part$18 = ((((a0b0$18 >>> 16) | 0) + a0b1$18) | 0);
        var hi$69 = ((((((Math.imul(19215358, hi$65) + Math.imul(293, b1$19)) | 0) + ((c1part$18 >>> 16) | 0)) | 0) + (((((65535 & c1part$18) + a1b0$17) | 0) >>> 16) | 0)) | 0);
        var hi$70 = (hi$68 >> 31);
        var lo$63 = ((lo$62 + hi$68) | 0);
        var hi$71 = ((((hi$69 + hi$70) | 0) + ((((lo$62 & hi$68) | ((lo$62 | hi$68) & (~lo$63))) >>> 31) | 0)) | 0);
        var b0$20 = (65535 & num$3_$_hi);
        var b1$20 = ((num$3_$_hi >>> 16) | 0);
        var a0b0$19 = Math.imul(15645, b0$20);
        var a1b0$18 = Math.imul(26877, b0$20);
        var a0b1$19 = Math.imul(15645, b1$20);
        var lo$64 = ((a0b0$19 + (((a1b0$18 + a0b1$19) | 0) << 16)) | 0);
        var c1part$19 = ((((a0b0$19 >>> 16) | 0) + a0b1$19) | 0);
        var hi$72 = ((((((Math.imul(1761426717, hi$65) + Math.imul(26877, b1$20)) | 0) + ((c1part$19 >>> 16) | 0)) | 0) + (((((65535 & c1part$19) + a1b0$18) | 0) >>> 16) | 0)) | 0);
        var lo$65 = ((lo$61 + lo$64) | 0);
        var hi$73 = ((hi$72 + ((((lo$61 & lo$64) | ((lo$61 | lo$64) & (~lo$65))) >>> 31) | 0)) | 0);
        var hi$74 = (hi$73 >> 31);
        var lo$66 = ((lo$63 + hi$73) | 0);
        var hi$75 = ((((hi$71 + hi$74) | 0) + ((((lo$63 & hi$73) | ((lo$63 | hi$73) & (~lo$66))) >>> 31) | 0)) | 0);
        var lo$67 = (((lo$66 >>> 28) | 0) | (hi$75 << 4));
        var hi$76 = (hi$75 >> 28);
        var lo$68 = ((num$3_$_hi >>> 31) | 0);
        var lo$69 = ((lo$67 + lo$68) | 0);
        var hi$77 = ((hi$76 + ((((lo$67 & lo$68) | ((lo$67 | lo$68) & (~lo$69))) >>> 31) | 0)) | 0);
        var this$132 = $m_jl_Math$();
        var lo$70 = ((lo$58 + lo$69) | 0);
        var hi$78 = ((((hi$64 + hi$77) | 0) + ((((lo$58 & lo$69) | ((lo$58 | lo$69) & (~lo$70))) >>> 31) | 0)) | 0);
        var hi$79 = (hi$78 ^ hi$64);
        var hi$80 = (hi$78 ^ hi$77);
        var hi$81 = (hi$79 & hi$80);
        if ((hi$81 < 0)) {
          this$132.java$lang$Math$$longOverflow__E();
        }
        return $bL(lo$70, hi$78);
      }
      var x$11$1 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
      if ((x$11$1 === null)) {
        var $x_21 = (f === null);
      } else {
        var this$138 = $n(x$11$1);
        var $x_21 = (this$138 === f);
      }
      if ($x_21) {
        var a$5_$_lo = daysUntil_$_lo;
        var a$5_$_hi = daysUntil_$_hi;
        var this$139 = $m_jl_Math$();
        var b0$21 = (65535 & a$5_$_lo);
        var b1$21 = ((a$5_$_lo >>> 16) | 0);
        var a0b0$20 = Math.imul(24, b0$21);
        var a0b1$20 = Math.imul(24, b1$21);
        var lo$74 = ((a0b0$20 + (a0b1$20 << 16)) | 0);
        var c1part$20 = ((((a0b0$20 >>> 16) | 0) + a0b1$20) | 0);
        var hi$82 = ((Math.imul(24, a$5_$_hi) + ((c1part$20 >>> 16) | 0)) | 0);
        if (((a$5_$_lo | a$5_$_hi) !== 0)) {
          var $x_23 = $m_RTLong$().divide__I__I__I__I__J(lo$74, hi$82, a$5_$_lo, a$5_$_hi);
          var x$16_$_lo = $x_23.l;
          var x$16_$_hi = $x_23.h;
          var $x_22 = (((24 ^ x$16_$_lo) | x$16_$_hi) !== 0);
        } else {
          var $x_22 = false;
        }
        if ($x_22) {
          this$139.java$lang$Math$$longOverflow__E();
        }
        var num$4_$_lo = timeUntil_$_lo;
        var num$4_$_hi = timeUntil_$_hi;
        var hi$83 = (num$4_$_hi >> 31);
        var b0$22 = (65535 & num$4_$_lo);
        var b1$22 = ((num$4_$_lo >>> 16) | 0);
        var a0b0$21 = Math.imul(65318, b0$22);
        var a1b0$19 = Math.imul(40031, b0$22);
        var a0b1$21 = Math.imul(65318, b1$22);
        var lo$75 = ((a0b0$21 + (((a1b0$19 + a0b1$21) | 0) << 16)) | 0);
        var c1part$21 = ((((a0b0$21 >>> 16) | 0) + a0b1$21) | 0);
        var hi$84 = ((((((((-num$4_$_lo) | 0) + Math.imul(40031, b1$22)) | 0) + ((c1part$21 >>> 16) | 0)) | 0) + (((((65535 & c1part$21) + a1b0$19) | 0) >>> 16) | 0)) | 0);
        var b0$23 = (65535 & num$4_$_lo);
        var b1$23 = ((num$4_$_lo >>> 16) | 0);
        var a0b0$22 = Math.imul(60757, b0$23);
        var a1b0$20 = Math.imul(60789, b0$23);
        var a0b1$22 = Math.imul(60757, b1$23);
        var c1part$22 = ((((a0b0$22 >>> 16) | 0) + a0b1$22) | 0);
        var hi$85 = ((((Math.imul(60789, b1$23) + ((c1part$22 >>> 16) | 0)) | 0) + (((((65535 & c1part$22) + a1b0$20) | 0) >>> 16) | 0)) | 0);
        var lo$77 = ((lo$75 + hi$85) | 0);
        var hi$86 = ((hi$84 + ((((lo$75 & hi$85) | ((lo$75 | hi$85) & (~lo$77))) >>> 31) | 0)) | 0);
        var b0$24 = (65535 & num$4_$_hi);
        var b1$24 = ((num$4_$_hi >>> 16) | 0);
        var a0b0$23 = Math.imul(65318, b0$24);
        var a1b0$21 = Math.imul(40031, b0$24);
        var a0b1$23 = Math.imul(65318, b1$24);
        var lo$78 = ((a0b0$23 + (((a1b0$21 + a0b1$23) | 0) << 16)) | 0);
        var c1part$23 = ((((a0b0$23 >>> 16) | 0) + a0b1$23) | 0);
        var hi$87 = ((((((((Math.imul((-1671430362), hi$83) + ((-num$4_$_hi) | 0)) | 0) + Math.imul(40031, b1$24)) | 0) + ((c1part$23 >>> 16) | 0)) | 0) + (((((65535 & c1part$23) + a1b0$21) | 0) >>> 16) | 0)) | 0);
        var hi$88 = (hi$86 >> 31);
        var lo$79 = ((lo$78 + hi$86) | 0);
        var hi$89 = ((((hi$87 + hi$88) | 0) + ((((lo$78 & hi$86) | ((lo$78 | hi$86) & (~lo$79))) >>> 31) | 0)) | 0);
        var b0$25 = (65535 & num$4_$_hi);
        var b1$25 = ((num$4_$_hi >>> 16) | 0);
        var a0b0$24 = Math.imul(60757, b0$25);
        var a1b0$22 = Math.imul(60789, b0$25);
        var a0b1$24 = Math.imul(60757, b1$25);
        var lo$80 = ((a0b0$24 + (((a1b0$22 + a0b1$24) | 0) << 16)) | 0);
        var c1part$24 = ((((a0b0$24 >>> 16) | 0) + a0b1$24) | 0);
        var hi$90 = ((((((Math.imul((-311038635), hi$83) + Math.imul(60789, b1$25)) | 0) + ((c1part$24 >>> 16) | 0)) | 0) + (((((65535 & c1part$24) + a1b0$22) | 0) >>> 16) | 0)) | 0);
        var lo$81 = ((lo$77 + lo$80) | 0);
        var hi$91 = ((hi$90 + ((((lo$77 & lo$80) | ((lo$77 | lo$80) & (~lo$81))) >>> 31) | 0)) | 0);
        var hi$92 = (hi$91 >> 31);
        var lo$82 = ((lo$79 + hi$91) | 0);
        var hi$93 = ((((hi$89 + hi$92) | 0) + ((((lo$79 & hi$91) | ((lo$79 | hi$91) & (~lo$82))) >>> 31) | 0)) | 0);
        var lo$83 = ((lo$82 + num$4_$_lo) | 0);
        var hi$94 = ((((hi$93 + num$4_$_hi) | 0) + ((((lo$82 & num$4_$_lo) | ((lo$82 | num$4_$_lo) & (~lo$83))) >>> 31) | 0)) | 0);
        var lo$84 = (hi$94 >> 9);
        var hi$95 = (hi$94 >> 31);
        var lo$85 = ((num$4_$_hi >>> 31) | 0);
        var lo$86 = ((lo$84 + lo$85) | 0);
        var hi$96 = ((hi$95 + ((((lo$84 & lo$85) | ((lo$84 | lo$85) & (~lo$86))) >>> 31) | 0)) | 0);
        var this$162 = $m_jl_Math$();
        var lo$87 = ((lo$74 + lo$86) | 0);
        var hi$97 = ((((hi$82 + hi$96) | 0) + ((((lo$74 & lo$86) | ((lo$74 | lo$86) & (~lo$87))) >>> 31) | 0)) | 0);
        var hi$98 = (hi$97 ^ hi$82);
        var hi$99 = (hi$97 ^ hi$96);
        var hi$100 = (hi$98 & hi$99);
        if ((hi$100 < 0)) {
          this$162.java$lang$Math$$longOverflow__E();
        }
        return $bL(lo$87, hi$97);
      }
      var x$13$1 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
      if ((x$13$1 === null)) {
        var $x_24 = (f === null);
      } else {
        var this$168 = $n(x$13$1);
        var $x_24 = (this$168 === f);
      }
      if ($x_24) {
        var a$6_$_lo = daysUntil_$_lo;
        var a$6_$_hi = daysUntil_$_hi;
        var this$169 = $m_jl_Math$();
        var lo$91 = (a$6_$_lo << 1);
        var hi$101 = (((a$6_$_lo >>> 31) | 0) | (a$6_$_hi << 1));
        if (((a$6_$_lo | a$6_$_hi) !== 0)) {
          var $x_26 = $m_RTLong$().divide__I__I__I__I__J(lo$91, hi$101, a$6_$_lo, a$6_$_hi);
          var x$17_$_lo = $x_26.l;
          var x$17_$_hi = $x_26.h;
          var $x_25 = (((2 ^ x$17_$_lo) | x$17_$_hi) !== 0);
        } else {
          var $x_25 = false;
        }
        if ($x_25) {
          this$169.java$lang$Math$$longOverflow__E();
        }
        var num$5_$_lo = timeUntil_$_lo;
        var num$5_$_hi = timeUntil_$_hi;
        var hi$102 = (num$5_$_hi >> 31);
        var b0$26 = (65535 & num$5_$_lo);
        var b1$26 = ((num$5_$_lo >>> 16) | 0);
        var a0b0$25 = Math.imul(65391, b0$26);
        var a1b0$23 = Math.imul(26687, b0$26);
        var a0b1$25 = Math.imul(65391, b1$26);
        var lo$92 = ((a0b0$25 + (((a1b0$23 + a0b1$25) | 0) << 16)) | 0);
        var c1part$25 = ((((a0b0$25 >>> 16) | 0) + a0b1$25) | 0);
        var hi$103 = ((((Math.imul(26687, b1$26) + ((c1part$25 >>> 16) | 0)) | 0) + (((((65535 & c1part$25) + a1b0$23) | 0) >>> 16) | 0)) | 0);
        var b0$27 = (65535 & num$5_$_lo);
        var b1$27 = ((num$5_$_lo >>> 16) | 0);
        var a0b0$26 = Math.imul(18659, b0$27);
        var a1b0$24 = Math.imul(18681, b0$27);
        var a0b1$26 = Math.imul(18659, b1$27);
        var c1part$26 = ((((a0b0$26 >>> 16) | 0) + a0b1$26) | 0);
        var hi$104 = ((((Math.imul(18681, b1$27) + ((c1part$26 >>> 16) | 0)) | 0) + (((((65535 & c1part$26) + a1b0$24) | 0) >>> 16) | 0)) | 0);
        var lo$94 = ((lo$92 + hi$104) | 0);
        var hi$105 = ((hi$103 + ((((lo$92 & hi$104) | ((lo$92 | hi$104) & (~lo$94))) >>> 31) | 0)) | 0);
        var b0$28 = (65535 & num$5_$_hi);
        var b1$28 = ((num$5_$_hi >>> 16) | 0);
        var a0b0$27 = Math.imul(65391, b0$28);
        var a1b0$25 = Math.imul(26687, b0$28);
        var a0b1$27 = Math.imul(65391, b1$28);
        var lo$95 = ((a0b0$27 + (((a1b0$25 + a0b1$27) | 0) << 16)) | 0);
        var c1part$27 = ((((a0b0$27 >>> 16) | 0) + a0b1$27) | 0);
        var hi$106 = ((((((Math.imul(1749024623, hi$102) + Math.imul(26687, b1$28)) | 0) + ((c1part$27 >>> 16) | 0)) | 0) + (((((65535 & c1part$27) + a1b0$25) | 0) >>> 16) | 0)) | 0);
        var hi$107 = (hi$105 >> 31);
        var lo$96 = ((lo$95 + hi$105) | 0);
        var hi$108 = ((((hi$106 + hi$107) | 0) + ((((lo$95 & hi$105) | ((lo$95 | hi$105) & (~lo$96))) >>> 31) | 0)) | 0);
        var b0$29 = (65535 & num$5_$_hi);
        var b1$29 = ((num$5_$_hi >>> 16) | 0);
        var a0b0$28 = Math.imul(18659, b0$29);
        var a1b0$26 = Math.imul(18681, b0$29);
        var a0b1$28 = Math.imul(18659, b1$29);
        var lo$97 = ((a0b0$28 + (((a1b0$26 + a0b1$28) | 0) << 16)) | 0);
        var c1part$28 = ((((a0b0$28 >>> 16) | 0) + a0b1$28) | 0);
        var hi$109 = ((((((Math.imul(1224296675, hi$102) + Math.imul(18681, b1$29)) | 0) + ((c1part$28 >>> 16) | 0)) | 0) + (((((65535 & c1part$28) + a1b0$26) | 0) >>> 16) | 0)) | 0);
        var lo$98 = ((lo$94 + lo$97) | 0);
        var hi$110 = ((hi$109 + ((((lo$94 & lo$97) | ((lo$94 | lo$97) & (~lo$98))) >>> 31) | 0)) | 0);
        var hi$111 = (hi$110 >> 31);
        var lo$99 = ((lo$96 + hi$110) | 0);
        var hi$112 = ((((hi$108 + hi$111) | 0) + ((((lo$96 & hi$110) | ((lo$96 | hi$110) & (~lo$99))) >>> 31) | 0)) | 0);
        var lo$100 = (hi$112 >> 12);
        var hi$113 = (hi$112 >> 31);
        var lo$101 = ((num$5_$_hi >>> 31) | 0);
        var lo$102 = ((lo$100 + lo$101) | 0);
        var hi$114 = ((hi$113 + ((((lo$100 & lo$101) | ((lo$100 | lo$101) & (~lo$102))) >>> 31) | 0)) | 0);
        var this$191 = $m_jl_Math$();
        var lo$103 = ((lo$91 + lo$102) | 0);
        var hi$115 = ((((hi$101 + hi$114) | 0) + ((((lo$91 & lo$102) | ((lo$91 | lo$102) & (~lo$103))) >>> 31) | 0)) | 0);
        var hi$116 = (hi$115 ^ hi$101);
        var hi$117 = (hi$115 ^ hi$114);
        var hi$118 = (hi$116 & hi$117);
        if ((hi$118 < 0)) {
          this$191.java$lang$Math$$longOverflow__E();
        }
        return $bL(lo$103, hi$115);
      }
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
    }
    var endDate = (($n($n(end).Ljava_time_LocalDateTime__f_date).isAfter__Ljava_time_chrono_ChronoLocalDate__Z(this.Ljava_time_LocalDateTime__f_date) && $n($n(end).Ljava_time_LocalDateTime__f_time).isBefore__Ljava_time_LocalTime__Z(this.Ljava_time_LocalDateTime__f_time)) ? $n($n(end).Ljava_time_LocalDateTime__f_date).minusDays__J__Ljava_time_LocalDate(1, 0) : (($n($n(end).Ljava_time_LocalDateTime__f_date).isBefore__Ljava_time_chrono_ChronoLocalDate__Z(this.Ljava_time_LocalDateTime__f_date) && $n($n(end).Ljava_time_LocalDateTime__f_time).isAfter__Ljava_time_LocalTime__Z(this.Ljava_time_LocalDateTime__f_time)) ? $n($n(end).Ljava_time_LocalDateTime__f_date).plusDays__J__Ljava_time_LocalDate(1, 0) : $n(end).Ljava_time_LocalDateTime__f_date));
    return $n(this.Ljava_time_LocalDateTime__f_date).until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(endDate, unit);
  } else {
    var this$197 = $n(unit);
    return this.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end, this$197);
  }
});
$c_Ljava_time_LocalDateTime.prototype.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I = (function(other) {
  if ((other instanceof $c_Ljava_time_LocalDateTime)) {
    var l = $as_Ljava_time_LocalDateTime(other);
    return $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, l);
  } else {
    return this.compare__Ljava_time_chrono_ChronoLocalDateTime__I(other);
  }
});
$c_Ljava_time_LocalDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalDateTime)) {
    var other = $as_Ljava_time_LocalDateTime(obj);
    if ((this === other)) {
      return true;
    } else {
      var x = this.Ljava_time_LocalDateTime__f_date;
      var x$2 = $n(other).Ljava_time_LocalDateTime__f_date;
      if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_LocalDateTime__f_time;
        var x$4 = $n(other).Ljava_time_LocalDateTime__f_time;
        return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_LocalDateTime.prototype.hashCode__I = (function() {
  return ($n(this.Ljava_time_LocalDateTime__f_date).hashCode__I() ^ $n(this.Ljava_time_LocalDateTime__f_time).hashCode__I());
});
$c_Ljava_time_LocalDateTime.prototype.toString__T = (function() {
  return (($n(this.Ljava_time_LocalDateTime__f_date).toString__T() + "T") + $n(this.Ljava_time_LocalDateTime__f_time).toString__T());
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue_$_lo, newValue_$_hi);
});
$c_Ljava_time_LocalDateTime.prototype.compareTo__O__I = (function(that) {
  return this.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I($as_Ljava_time_chrono_ChronoLocalDateTime(that));
});
function $as_Ljava_time_LocalDateTime(obj) {
  return (((obj instanceof $c_Ljava_time_LocalDateTime) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.LocalDateTime"));
}
function $isArrayOf_Ljava_time_LocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalDateTime)));
}
function $asArrayOf_Ljava_time_LocalDateTime(obj, depth) {
  return (($isArrayOf_Ljava_time_LocalDateTime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.LocalDateTime;", depth));
}
var $d_Ljava_time_LocalDateTime = new $TypeData().initClass($c_Ljava_time_LocalDateTime, "java.time.LocalDateTime", ({
  Ljava_time_LocalDateTime: 1,
  Ljava_time_chrono_ChronoLocalDateTime: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = new $h_jl_Enum();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.toString__T = (function() {
  var x7 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal;
  switch (x7) {
    case 0: {
      return "ParseCaseSensitive(true)";
      break;
    }
    case 1: {
      return "ParseCaseSensitive(false)";
      break;
    }
    case 2: {
      return "ParseStrict(true)";
      break;
    }
    case 3: {
      return "ParseStrict(false)";
      break;
    }
    default: {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Unreachable");
    }
  }
});
function $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__($thiz, name, ordinal, baseUnit, rangeUnit, _range, _$name, _$ordinal) {
  $thiz.Ljava_time_temporal_ChronoField__f_name = name;
  $thiz.Ljava_time_temporal_ChronoField__f_ordinal = ordinal;
  $thiz.Ljava_time_temporal_ChronoField__f__range = _range;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoField() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
}
$c_Ljava_time_temporal_ChronoField.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_ChronoField.prototype.constructor = $c_Ljava_time_temporal_ChronoField;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField() {
}
$h_Ljava_time_temporal_ChronoField.prototype = $c_Ljava_time_temporal_ChronoField.prototype;
$c_Ljava_time_temporal_ChronoField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_temporal_ChronoField.prototype.isDateBased__Z = (function() {
  return ((this.Ljava_time_temporal_ChronoField__f_ordinal >= $n($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()).jl_Enum__f__ordinal) && (this.Ljava_time_temporal_ChronoField__f_ordinal <= $n($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField()).jl_Enum__f__ordinal));
});
$c_Ljava_time_temporal_ChronoField.prototype.isTimeBased__Z = (function() {
  return (this.Ljava_time_temporal_ChronoField__f_ordinal < $n($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()).jl_Enum__f__ordinal);
});
$c_Ljava_time_temporal_ChronoField.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_ChronoField__f_name;
});
function $as_Ljava_time_temporal_ChronoField(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_ChronoField) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.ChronoField"));
}
function $isArrayOf_Ljava_time_temporal_ChronoField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ChronoField)));
}
function $asArrayOf_Ljava_time_temporal_ChronoField(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_ChronoField(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.ChronoField;", depth));
}
var $d_Ljava_time_temporal_ChronoField = new $TypeData().initClass(0, "java.time.temporal.ChronoField", ({
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
}));
function $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__($thiz, name, ordinal, duration, _$name, _$ordinal) {
  $thiz.Ljava_time_temporal_ChronoUnit__f_name = name;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
}
$c_Ljava_time_temporal_ChronoUnit.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_ChronoUnit.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit() {
}
$h_Ljava_time_temporal_ChronoUnit.prototype = $c_Ljava_time_temporal_ChronoUnit.prototype;
$c_Ljava_time_temporal_ChronoUnit.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_temporal_ChronoUnit.prototype.isDateBased__Z = (function() {
  return ((this.compareTo__jl_Enum__I($s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit()) >= 0) && (this !== $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit()));
});
$c_Ljava_time_temporal_ChronoUnit.prototype.isTimeBased__Z = (function() {
  return (this.compareTo__jl_Enum__I($s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit()) < 0);
});
$c_Ljava_time_temporal_ChronoUnit.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_ChronoUnit__f_name;
});
function $as_Ljava_time_temporal_ChronoUnit(obj) {
  return (((obj instanceof $c_Ljava_time_temporal_ChronoUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "java.time.temporal.ChronoUnit"));
}
function $isArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ChronoUnit)));
}
function $asArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) {
  return (($isArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.time.temporal.ChronoUnit;", depth));
}
/** @constructor */
function $c_ju_Collections$$anon$15(o$2) {
  this.ju_Collections$$anon$15__f_o$2 = null;
  this.ju_Collections$$anon$15__f_o$2 = o$2;
}
$c_ju_Collections$$anon$15.prototype = new $h_ju_AbstractList();
$c_ju_Collections$$anon$15.prototype.constructor = $c_ju_Collections$$anon$15;
/** @constructor */
function $h_ju_Collections$$anon$15() {
}
$h_ju_Collections$$anon$15.prototype = $c_ju_Collections$$anon$15.prototype;
$c_ju_Collections$$anon$15.prototype.size__I = (function() {
  return 1;
});
$c_ju_Collections$$anon$15.prototype.get__I__O = (function(index) {
  if ((index === 0)) {
    return this.ju_Collections$$anon$15__f_o$2;
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
var $d_ju_Collections$$anon$15 = new $TypeData().initClass($c_ju_Collections$$anon$15, "java.util.Collections$$anon$15", ({
  ju_Collections$$anon$15: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_SequencedCollection: 1,
  Ljava_io_Serializable: 1
}));
function $ct_ju_concurrent_CopyOnWriteArrayList__I__($thiz, initialCapacity) {
  $thiz.ju_concurrent_CopyOnWriteArrayList__f_inner = [];
  $thiz.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false;
  return $thiz;
}
function $ct_ju_concurrent_CopyOnWriteArrayList__AO__($thiz, toCopyIn) {
  $ct_ju_concurrent_CopyOnWriteArrayList__I__($thiz, $n(toCopyIn).u.length);
  var end = $n(toCopyIn).u.length;
  var i = 0;
  while ((i < end)) {
    var value = i;
    $thiz.add__O__Z($n(toCopyIn).get(value));
    i = ((1 + i) | 0);
  }
  return $thiz;
}
/** @constructor */
function $c_ju_concurrent_CopyOnWriteArrayList() {
  this.ju_concurrent_CopyOnWriteArrayList__f_inner = null;
  this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false;
}
$c_ju_concurrent_CopyOnWriteArrayList.prototype = new $h_O();
$c_ju_concurrent_CopyOnWriteArrayList.prototype.constructor = $c_ju_concurrent_CopyOnWriteArrayList;
/** @constructor */
function $h_ju_concurrent_CopyOnWriteArrayList() {
}
$h_ju_concurrent_CopyOnWriteArrayList.prototype = $c_ju_concurrent_CopyOnWriteArrayList.prototype;
$c_ju_concurrent_CopyOnWriteArrayList.prototype.size__I = (function() {
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return $uI(v.length);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  while ($n(_\uff3fself).hasNext__Z()) {
    var t = $n(_\uff3fself).next__O();
    if (((o === null) ? (t === null) : $dp_equals__O__Z($n(o), t))) {
      return true;
    }
  }
  return false;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toArray__AO__AO = (function(a) {
  var this$1 = $n(a);
  var this$2 = $objectGetClass(this$1);
  var componentType = this$2.data.getComponentType();
  var $x_1 = $n(a);
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  if (($x_1.u.length >= $uI(v.length))) {
    var toFill = a;
  } else {
    var v$1 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    var length = $uI(v$1.length);
    var toFill = $asArrayOf_O($n(componentType).data.newArray(length), 1);
  }
  var iter = this.listIterator__I__ju_ListIterator(0);
  var v$2 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  var end = $uI(v$2.length);
  var i = 0;
  while ((i < end)) {
    var value = i;
    $n(toFill).set(value, $n(iter).next__O());
    i = ((1 + i) | 0);
  }
  var $x_2 = $n(toFill);
  var v$3 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  if (($x_2.u.length > $uI(v$3.length))) {
    var $x_3 = $n(toFill);
    var v$4 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    $x_3.set($uI(v$4.length), null);
  }
  return toFill;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return v[index];
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.set__I__O__O = (function(index, element) {
  this.checkIndexInBounds__I__V(index);
  this.copyIfNeeded__V();
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  var oldValue = v[index];
  var v$1 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  v$1[index] = element;
  return oldValue;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.add__O__Z = (function(e) {
  this.copyIfNeeded__V();
  this.innerPush__O__V(e);
  return true;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.remove__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  this.copyIfNeeded__V();
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return v.splice(index, 1)[0];
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toString__T = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = "[";
  var first = true;
  while ($n(_\uff3fself).hasNext__Z()) {
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (("" + result) + $n(_\uff3fself).next__O());
  }
  return (result + "]");
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.equals__O__Z = (function(obj) {
  if ((obj === this)) {
    return true;
  } else if ($is_ju_List(obj)) {
    var x2 = $as_ju_List(obj);
    var oIter = $n(x2).listIterator__ju_ListIterator();
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while ($n(_\uff3fself).hasNext__Z()) {
        var t = $n(_\uff3fself).next__O();
        if ($n(oIter).hasNext__Z()) {
          var b = $n(oIter).next__O();
          var $x_2 = ((t === null) ? (b === null) : $dp_equals__O__Z($n(t), b));
        } else {
          var $x_2 = false;
        }
        if ((!$x_2)) {
          var $x_1 = true;
          break _return;
        }
      }
      var $x_1 = false;
    }
    if ((!$x_1)) {
      return (!$n(oIter).hasNext__Z());
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while ($n(_\uff3fself).hasNext__Z()) {
    var t = result;
    var u = $n(_\uff3fself).next__O();
    var t$1 = $uI(t);
    result = ((Math.imul(31, t$1) + ((u === null) ? 0 : $dp_hashCode__I($n(u)))) | 0);
  }
  return $uI(result);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.listIterator__ju_ListIterator = (function() {
  return this.listIterator__I__ju_ListIterator(0);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  var $x_1 = this.innerSnapshot__O();
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return new $c_ju_concurrent_CopyOnWriteArrayListIterator($x_1, index, 0, $uI(v.length));
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerPush__O__V = (function(elem) {
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  v.push(elem);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.copyIfNeeded__V = (function() {
  if (this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite) {
    var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    this.ju_concurrent_CopyOnWriteArrayList__f_inner = v.slice(0);
    this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false;
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerSnapshot__O = (function() {
  this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = true;
  return this.ju_concurrent_CopyOnWriteArrayList__f_inner;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.checkIndexInBounds__I__V = (function(index) {
  if ((index < 0)) {
    var $x_1 = true;
  } else {
    var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    var $x_1 = (index >= $uI(v.length));
  }
  if ($x_1) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if ((index < 0)) {
    var $x_1 = true;
  } else {
    var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    var $x_1 = (index > $uI(v.length));
  }
  if ($x_1) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
var $d_ju_concurrent_CopyOnWriteArrayList = new $TypeData().initClass($c_ju_concurrent_CopyOnWriteArrayList, "java.util.concurrent.CopyOnWriteArrayList", ({
  ju_concurrent_CopyOnWriteArrayList: 1,
  ju_List: 1,
  ju_SequencedCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype.hashCode__I = (function() {
  return 1967173483;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype.toString__T = (function() {
  return "Dependency";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype.productPrefix__T = (function() {
  return "Dependency";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$, "net.andimiller.hedgehogs.dag.visitor.DagVisitor$RunMode$Dependency$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Dependency$;
}
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$() {
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype = new $h_O();
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype.hashCode__I = (function() {
  return 2192718;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype.toString__T = (function() {
  return "Flow";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype.productPrefix__T = (function() {
  return "Flow";
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$ = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$, "net.andimiller.hedgehogs.dag.visitor.DagVisitor$RunMode$Flow$", ({
  Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$;
function $m_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$() {
  if ((!$n_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$)) {
    $n_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$ = new $c_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$();
  }
  return $n_Lnet_andimiller_hedgehogs_dag_visitor_DagVisitor$RunMode$Flow$;
}
function $f_sc_BitSetOps__contains__I__Z($thiz, elem) {
  if ((elem >= 0)) {
    var $x_1 = $thiz.word__I__J((elem >> 6));
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (x_$_lo & lo);
    var hi$1 = (x_$_hi & hi);
    return ((lo$1 | hi$1) !== 0);
  } else {
    return false;
  }
}
function $f_sc_BitSetOps__size__I($thiz) {
  var s = 0;
  var i = $thiz.nwords__I();
  while ((i > 0)) {
    i = ((i - 1) | 0);
    var $x_2 = s;
    var $x_1 = $thiz.word__I__J(i);
    var i$1_$_lo = $x_1.l;
    var i$1_$_hi = $x_1.h;
    s = (($x_2 + (($m_jl_Integer$().bitCount__I__I(i$1_$_lo) + $m_jl_Integer$().bitCount__I__I(i$1_$_hi)) | 0)) | 0);
  }
  return s;
}
function $f_sc_BitSetOps__isEmpty__Z($thiz) {
  var end = $thiz.nwords__I();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = ((end - 1) | 0);
  var res = true;
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while ((res && it.sci_RangeIterator__f__hasNext)) {
    var x0 = it.next__I();
    var $x_1 = $thiz.word__I__J(x0);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    res = ((x_$_lo | x_$_hi) === 0);
  }
  return res;
}
function $f_sc_BitSetOps__foreach__F1__V($thiz, f) {
  var i = 0;
  while ((i < $thiz.nwords__I())) {
    var $x_1 = $thiz.word__I__J(i);
    var w_$_lo = $x_1.l;
    var w_$_hi = $x_1.h;
    var j = (i << 6);
    while (true) {
      var x_$_lo = w_$_lo;
      var x_$_hi = w_$_hi;
      if (((x_$_lo | x_$_hi) !== 0)) {
        var x$1_$_lo = w_$_lo;
        var x$1_$_hi = w_$_hi;
        var lo = (1 & x$1_$_lo);
        if ((lo === 1)) {
          $n(f).apply__O__O(j);
        }
        var x$2_$_lo = w_$_lo;
        var x$2_$_hi = w_$_hi;
        var lo$1 = (((x$2_$_lo >>> 1) | 0) | (x$2_$_hi << 31));
        var hi = ((x$2_$_hi >>> 1) | 0);
        w_$_lo = lo$1;
        w_$_hi = hi;
        j = ((1 + j) | 0);
      } else {
        break;
      }
    }
    i = ((1 + i) | 0);
  }
}
function $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet($thiz, other) {
  if ($is_sc_BitSet(other)) {
    var x2 = $as_sc_BitSet(other);
    var x = $n($as_sc_BitSetOps($thiz)).nwords__I();
    var that = $n(x2).nwords__I();
    var len = ((x > that) ? x : that);
    var words = new $ac_J(len);
    var isEmpty = (len <= 0);
    var scala$collection$immutable$Range$$lastElement = ((len - 1) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var v1 = i;
        var $x_1 = $thiz.word__I__J(v1);
        var x$1_$_lo = $x_1.l;
        var x$1_$_hi = $x_1.h;
        var $x_2 = $n(x2).word__I__J(v1);
        var x$2_$_lo = $x_2.l;
        var x$2_$_hi = $x_2.h;
        var lo = (x$1_$_lo | x$2_$_lo);
        var hi = (x$1_$_hi | x$2_$_hi);
        words.set(v1, lo, hi);
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break;
        }
        i = ((1 + i) | 0);
      }
    }
    return $thiz.fromBitMaskNoCopy__AJ__sc_BitSet(words);
  } else {
    return $thiz.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet(other);
  }
}
function $is_sc_BitSetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSetOps)));
}
function $as_sc_BitSetOps(obj) {
  return (($is_sc_BitSetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSetOps"));
}
function $isArrayOf_sc_BitSetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSetOps)));
}
function $asArrayOf_sc_BitSetOps(obj, depth) {
  return (($isArrayOf_sc_BitSetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSetOps;", depth));
}
function $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq($thiz, n, s) {
  while (true) {
    if (((n <= 0) || $n(s).isEmpty__Z())) {
      return s;
    } else {
      var temp$n = ((n - 1) | 0);
      var temp$s = $as_sc_LinearSeq($n(s).tail__O());
      n = temp$n;
      s = temp$s;
    }
  }
}
function $is_sc_StrictOptimizedLinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_StrictOptimizedLinearSeqOps)));
}
function $as_sc_StrictOptimizedLinearSeqOps(obj) {
  return (($is_sc_StrictOptimizedLinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StrictOptimizedLinearSeqOps"));
}
function $isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StrictOptimizedLinearSeqOps)));
}
function $asArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StrictOptimizedLinearSeqOps;", depth));
}
function $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps($thiz, f) {
  var b = $n($thiz.mapFactory__sc_MapFactory()).newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(b);
    var elem = $n(f).apply__O__O($n(it).next__O());
    this$1.addOne__O__scm_Growable(elem);
  }
  return $as_sc_IterableOps($n(b).result__O());
}
function $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var b = $n($thiz.mapFactory__sc_MapFactory()).newBuilder__scm_Builder();
  var this$1 = $n(b);
  this$1.addAll__sc_IterableOnce__scm_Growable($thiz);
  var this$2 = $n(b);
  this$2.addAll__sc_IterableOnce__scm_Growable(suffix);
  return $as_sc_IterableOps($n(b).result__O());
}
function $as_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$MutableSetWrapper"));
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$MutableSetWrapper)));
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$MutableSetWrapper;", depth));
}
function $p_s_math_BigDecimal__computeHashCode__V($thiz) {
  if ($thiz.isWhole__Z()) {
    var $x_3 = $n($thiz.s_math_BigDecimal__f_bigDecimal).precision__I();
    var this$1 = $n($thiz.s_math_BigDecimal__f_bigDecimal);
    var $x_2 = ((($x_3 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0) < 4934);
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    var $x_1 = $n($thiz.toBigInt__s_math_BigInt()).hashCode__I();
  } else if ($thiz.isDecimalDouble__Z()) {
    var dv = $n($thiz.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
    var $x_1 = $m_sr_Statics$().doubleHash__D__I(dv);
  } else {
    var temp = $n($thiz.s_math_BigDecimal__f_bigDecimal).stripTrailingZeros__Ljava_math_BigDecimal();
    var $x_5 = $m_s_util_hashing_MurmurHash3$();
    var this$2 = $n(temp);
    var $x_4 = $n($n($n(temp).scaleByPowerOfTen__I__Ljava_math_BigDecimal(this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)).toBigInteger__Ljava_math_BigInteger()).hashCode__I();
    var this$3 = $n(temp);
    var $x_1 = $x_5.mixLast__I__I__I($x_4, this$3.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  }
  $thiz.s_math_BigDecimal__f_computedHashCode = $x_1;
}
/** @constructor */
function $c_s_math_BigDecimal(bigDecimal, mc) {
  this.s_math_BigDecimal__f_bigDecimal = null;
  this.s_math_BigDecimal__f_mc = null;
  this.s_math_BigDecimal__f_computedHashCode = 0;
  this.s_math_BigDecimal__f_bigDecimal = bigDecimal;
  this.s_math_BigDecimal__f_mc = mc;
  if ((bigDecimal === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null value for BigDecimal");
  }
  if ((mc === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null MathContext for BigDecimal");
  }
  this.s_math_BigDecimal__f_computedHashCode = 1565550863;
}
$c_s_math_BigDecimal.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigDecimal.prototype.constructor = $c_s_math_BigDecimal;
/** @constructor */
function $h_s_math_BigDecimal() {
}
$h_s_math_BigDecimal.prototype = $c_s_math_BigDecimal.prototype;
$c_s_math_BigDecimal.prototype.compareTo__O__I = (function(that) {
  var that$1 = $as_s_math_BigDecimal(that);
  return $n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that$1).s_math_BigDecimal__f_bigDecimal);
});
$c_s_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.s_math_BigDecimal__f_computedHashCode === 1565550863)) {
    $p_s_math_BigDecimal__computeHashCode__V(this);
  }
  return this.s_math_BigDecimal__f_computedHashCode;
});
$c_s_math_BigDecimal.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigDecimal)) {
    var x2 = $as_s_math_BigDecimal(that);
    return this.equals__s_math_BigDecimal__Z(x2);
  } else if ((that instanceof $c_s_math_BigInt)) {
    var x3 = $as_s_math_BigInt(that);
    var $x_2 = $n(x3).bitLength__I();
    var $x_1 = $n(this.s_math_BigDecimal__f_bigDecimal).precision__I();
    var this$1 = $n(this.s_math_BigDecimal__f_bigDecimal);
    if (($x_2 > (3.3219280948873626 * (((($x_1 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0) - 2) | 0)))) {
      var this$2 = $n(this.toBigIntExact__s_Option());
      if ((!this$2.isEmpty__Z())) {
        var x0 = this$2.get__O();
        var x$1$2 = $as_s_math_BigInt(x0);
        return $n(x3).equals__s_math_BigInt__Z(x$1$2);
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    if ((!((x4 === Infinity) || (x4 === (-Infinity))))) {
      var d = $n(this.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
      if (((!((d === Infinity) || (d === (-Infinity)))) && (d === x4))) {
        var this$9 = $m_s_math_BigDecimal$();
        return this.equals__s_math_BigDecimal__Z(this$9.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$9.s_math_BigDecimal$__f_defaultMathContext));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if ((!((x5 === Infinity) || (x5 === (-Infinity))))) {
      var f = $n(this.s_math_BigDecimal__f_bigDecimal).floatValue__F();
      if (((!((f === Infinity) || (f === (-Infinity)))) && (f === x5))) {
        var this$16 = $m_s_math_BigDecimal$();
        var d$1 = f;
        return this.equals__s_math_BigDecimal__Z(this$16.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d$1, this$16.s_math_BigDecimal$__f_defaultMathContext));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$c_s_math_BigDecimal.prototype.isValidByte__Z = (function() {
  try {
    $n(this.s_math_BigDecimal__f_bigDecimal).byteValueExact__B();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidShort__Z = (function() {
  try {
    $n(this.s_math_BigDecimal__f_bigDecimal).shortValueExact__S();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidChar__Z = (function() {
  return ((this.isValidInt__Z() && ($n(this.s_math_BigDecimal__f_bigDecimal).intValueExact__I() >= 0)) && ($n(this.s_math_BigDecimal__f_bigDecimal).intValueExact__I() <= 65535));
});
$c_s_math_BigDecimal.prototype.isValidInt__Z = (function() {
  try {
    $n(this.s_math_BigDecimal__f_bigDecimal).intValueExact__I();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidLong__Z = (function() {
  try {
    var this$1 = $n(this.s_math_BigDecimal__f_bigDecimal);
    $p_Ljava_math_BigDecimal__valueExact__I__J(this$1, 64);
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isDecimalDouble__Z = (function() {
  var d = $n(this.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
  if ((!((d === Infinity) || (d === (-Infinity))))) {
    var this$4 = $m_s_math_BigDecimal$();
    return this.equals__s_math_BigDecimal__Z(this$4.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$4.s_math_BigDecimal$__f_defaultMathContext));
  } else {
    return false;
  }
});
$c_s_math_BigDecimal.prototype.isWhole__Z = (function() {
  var this$1 = $n(this.s_math_BigDecimal__f_bigDecimal);
  if ((this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
    return true;
  } else {
    var this$2 = $n($n(this.s_math_BigDecimal__f_bigDecimal).stripTrailingZeros__Ljava_math_BigDecimal());
    return (this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0);
  }
});
$c_s_math_BigDecimal.prototype.equals__s_math_BigDecimal__Z = (function(that) {
  return ($n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that).s_math_BigDecimal__f_bigDecimal) === 0);
});
$c_s_math_BigDecimal.prototype.min__s_math_BigDecimal__s_math_BigDecimal = (function(that) {
  var x1 = $n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that).s_math_BigDecimal__f_bigDecimal);
  return ((x1 <= 0) ? this : that);
});
$c_s_math_BigDecimal.prototype.byteValue__B = (function() {
  return (($n(this.s_math_BigDecimal__f_bigDecimal).intValue__I() << 24) >> 24);
});
$c_s_math_BigDecimal.prototype.shortValue__S = (function() {
  return (($n(this.s_math_BigDecimal__f_bigDecimal).intValue__I() << 16) >> 16);
});
$c_s_math_BigDecimal.prototype.intValue__I = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).intValue__I();
});
$c_s_math_BigDecimal.prototype.longValue__J = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).longValue__J();
});
$c_s_math_BigDecimal.prototype.floatValue__F = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).floatValue__F();
});
$c_s_math_BigDecimal.prototype.doubleValue__D = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).doubleValue__D();
});
$c_s_math_BigDecimal.prototype.toBigInt__s_math_BigInt = (function() {
  return $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), $n(this.s_math_BigDecimal__f_bigDecimal).toBigInteger__Ljava_math_BigInteger());
});
$c_s_math_BigDecimal.prototype.toBigIntExact__s_Option = (function() {
  if (this.isWhole__Z()) {
    try {
      return new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), $n(this.s_math_BigDecimal__f_bigDecimal).toBigIntegerExact__Ljava_math_BigInteger()));
    } catch (e) {
      if ((e instanceof $c_jl_ArithmeticException)) {
        return $m_s_None$();
      } else {
        throw e;
      }
    }
  } else {
    return $m_s_None$();
  }
});
$c_s_math_BigDecimal.prototype.toString__T = (function() {
  return $n(this.s_math_BigDecimal__f_bigDecimal).toString__T();
});
$c_s_math_BigDecimal.prototype.compare__O__I = (function(that) {
  var that$1 = $as_s_math_BigDecimal(that);
  return $n(this.s_math_BigDecimal__f_bigDecimal).compareTo__Ljava_math_BigDecimal__I($n(that$1).s_math_BigDecimal__f_bigDecimal);
});
$c_s_math_BigDecimal.prototype.underlying__O = (function() {
  return this.s_math_BigDecimal__f_bigDecimal;
});
function $as_s_math_BigDecimal(obj) {
  return (((obj instanceof $c_s_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigDecimal"));
}
function $isArrayOf_s_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigDecimal)));
}
function $asArrayOf_s_math_BigDecimal(obj, depth) {
  return (($isArrayOf_s_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigDecimal;", depth));
}
var $d_s_math_BigDecimal = new $TypeData().initClass($c_s_math_BigDecimal, "scala.math.BigDecimal", ({
  s_math_BigDecimal: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
function $p_s_math_BigInt__longEncoding__Z($thiz) {
  var x_$_lo = $thiz.s_math_BigInt__f__long_$lo;
  var x_$_hi = $thiz.s_math_BigInt__f__long_$hi;
  return ((x_$_lo | ((-2147483648) ^ x_$_hi)) !== 0);
}
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $n($thiz.bigInteger__Ljava_math_BigInteger()).shiftRight__I__Ljava_math_BigInteger(2147483647);
  var this$1 = $n(shifted);
  if ((this$1.Ljava_math_BigInteger__f_sign !== 0)) {
    return (!$n(shifted).equals__O__Z($m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$minusOne));
  } else {
    return false;
  }
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, _bigInteger, _long_$_lo, _long_$_hi) {
  $thiz.s_math_BigInt__f__bigInteger = _bigInteger;
  $thiz.s_math_BigInt__f__long_$lo = _long_$_lo;
  $thiz.s_math_BigInt__f__long_$hi = _long_$_hi;
  return $thiz;
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__($thiz, bigInteger) {
  var this$1 = $n(bigInteger);
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1) <= 63)) {
    var $x_2 = $n(bigInteger).longValue__J();
    var $x_1_$_lo = $x_2.l;
    var $x_1_$_hi = $x_2.h;
  } else {
    var $x_1_$_lo = 0;
    var $x_1_$_hi = (-2147483648);
  }
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, bigInteger, $x_1_$_lo, $x_1_$_hi);
  return $thiz;
}
/** @constructor */
function $c_s_math_BigInt() {
  this.s_math_BigInt__f__bigInteger = null;
  this.s_math_BigInt__f__long_$lo = 0;
  this.s_math_BigInt__f__long_$hi = 0;
}
$c_s_math_BigInt.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigInt.prototype.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
}
$h_s_math_BigInt.prototype = $c_s_math_BigInt.prototype;
$c_s_math_BigInt.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_math_BigInt__I($as_s_math_BigInt(that));
});
$c_s_math_BigInt.prototype.bigInteger__Ljava_math_BigInteger = (function() {
  var read = this.s_math_BigInt__f__bigInteger;
  if ((read !== null)) {
    return read;
  } else {
    var lVal_$_lo = this.s_math_BigInt__f__long_$lo;
    var lVal_$_hi = this.s_math_BigInt__f__long_$hi;
    var write = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(lVal_$_lo, lVal_$_hi);
    this.s_math_BigInt__f__bigInteger = write;
    return write;
  }
});
$c_s_math_BigInt.prototype.hashCode__I = (function() {
  if (this.isValidLong__Z()) {
    return $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this);
  } else {
    var x = this.bigInteger__Ljava_math_BigInteger();
    return $m_sr_Statics$().anyHash__O__I(x);
  }
});
$c_s_math_BigInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    var x2 = $as_s_math_BigInt(that);
    return this.equals__s_math_BigInt__Z(x2);
  } else if ((that instanceof $c_s_math_BigDecimal)) {
    var x3 = $as_s_math_BigDecimal(that);
    return $n(x3).equals__O__Z(this);
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    return (this.isValidDouble__Z() && (this.doubleValue__D() === x4));
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if (this.isValidFloat__Z()) {
      var this$1 = $n(this.bigInteger__Ljava_math_BigInteger());
      return ($m_jl_Float$().parseFloat__T__F($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1)) === x5);
    } else {
      return false;
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$c_s_math_BigInt.prototype.isValidByte__Z = (function() {
  var x_$_lo = this.s_math_BigInt__f__long_$lo;
  var x_$_hi = this.s_math_BigInt__f__long_$hi;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 4294967168) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.s_math_BigInt__f__long_$lo;
    var x$1_$_hi = this.s_math_BigInt__f__long_$hi;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 127) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidShort__Z = (function() {
  var x_$_lo = this.s_math_BigInt__f__long_$lo;
  var x_$_hi = this.s_math_BigInt__f__long_$hi;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 4294934528) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.s_math_BigInt__f__long_$lo;
    var x$1_$_hi = this.s_math_BigInt__f__long_$hi;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 32767) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidChar__Z = (function() {
  var x_$_lo = this.s_math_BigInt__f__long_$lo;
  var x_$_hi = this.s_math_BigInt__f__long_$hi;
  if ((x_$_hi >= 0)) {
    var x$1_$_lo = this.s_math_BigInt__f__long_$lo;
    var x$1_$_hi = this.s_math_BigInt__f__long_$hi;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 65535) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidInt__Z = (function() {
  var x_$_lo = this.s_math_BigInt__f__long_$lo;
  var x_$_hi = this.s_math_BigInt__f__long_$hi;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 2147483648) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.s_math_BigInt__f__long_$lo;
    var x$1_$_hi = this.s_math_BigInt__f__long_$hi;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 2147483647) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidLong__Z = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) || $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, $m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger));
});
$c_s_math_BigInt.prototype.isValidFloat__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 24)) {
    var $x_1 = true;
  } else {
    var lowest = this.lowestSetBit__I();
    var $x_1 = (((bitLen <= 128) && (lowest >= ((bitLen - 24) | 0))) && (lowest < 128));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidDouble__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 53)) {
    var $x_1 = true;
  } else {
    var lowest = this.lowestSetBit__I();
    var $x_1 = (((bitLen <= 1024) && (lowest >= ((bitLen - 53) | 0))) && (lowest < 1024));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isWhole__Z = (function() {
  return true;
});
$c_s_math_BigInt.prototype.equals__s_math_BigInt__Z = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z($n(that))) {
      var x_$_lo = this.s_math_BigInt__f__long_$lo;
      var x_$_hi = this.s_math_BigInt__f__long_$hi;
      var x$1_$_lo = $n(that).s_math_BigInt__f__long_$lo;
      var x$1_$_hi = $n(that).s_math_BigInt__f__long_$hi;
      return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return ((!$p_s_math_BigInt__longEncoding__Z($n(that))) && $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, $n(that).s_math_BigInt__f__bigInteger));
  }
});
$c_s_math_BigInt.prototype.compare__s_math_BigInt__I = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z($n(that))) {
      var x_$_lo = this.s_math_BigInt__f__long_$lo;
      var x_$_hi = this.s_math_BigInt__f__long_$hi;
      var y_$_lo = $n(that).s_math_BigInt__f__long_$lo;
      var y_$_hi = $n(that).s_math_BigInt__f__long_$hi;
      return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
    } else {
      var this$2 = $n($n(that).s_math_BigInt__f__bigInteger);
      return ((-this$2.Ljava_math_BigInteger__f_sign) | 0);
    }
  } else if ($p_s_math_BigInt__longEncoding__Z($n(that))) {
    var this$3 = $n(this.s_math_BigInt__f__bigInteger);
    return this$3.Ljava_math_BigInteger__f_sign;
  } else {
    return $n(this.s_math_BigInt__f__bigInteger).compareTo__Ljava_math_BigInteger__I($n(that).s_math_BigInt__f__bigInteger);
  }
});
$c_s_math_BigInt.prototype.$plus__s_math_BigInt__s_math_BigInt = (function(that) {
  if (($p_s_math_BigInt__longEncoding__Z(this) && $p_s_math_BigInt__longEncoding__Z($n(that)))) {
    var x_$_lo = this.s_math_BigInt__f__long_$lo;
    var x_$_hi = this.s_math_BigInt__f__long_$hi;
    var y_$_lo = $n(that).s_math_BigInt__f__long_$lo;
    var y_$_hi = $n(that).s_math_BigInt__f__long_$hi;
    var lo = ((x_$_lo + y_$_lo) | 0);
    var hi = ((((x_$_hi + y_$_hi) | 0) + ((((x_$_lo & y_$_lo) | ((x_$_lo | y_$_lo) & (~lo))) >>> 31) | 0)) | 0);
    var hi$1 = (x_$_hi ^ y_$_hi);
    var hi$2 = (~hi$1);
    var hi$3 = (x_$_hi ^ hi);
    var hi$4 = (hi$2 & hi$3);
    if ((hi$4 >= 0)) {
      return $m_s_math_BigInt$().apply__J__s_math_BigInt(lo, hi);
    }
  }
  var $x_1 = $m_s_math_BigInt$();
  var this$7 = $n(this.bigInteger__Ljava_math_BigInteger());
  var bi = $n(that).bigInteger__Ljava_math_BigInteger();
  return $x_1.apply__Ljava_math_BigInteger__s_math_BigInt($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$7, bi));
});
$c_s_math_BigInt.prototype.min__s_math_BigInt__s_math_BigInt = (function(that) {
  return ($f_s_math_Ordered__$less$eq__O__Z(this, that) ? this : that);
});
$c_s_math_BigInt.prototype.lowestSetBit__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var x_$_lo = this.s_math_BigInt__f__long_$lo;
    var x_$_hi = this.s_math_BigInt__f__long_$hi;
    if (((x_$_lo | x_$_hi) === 0)) {
      return (-1);
    } else {
      var l_$_lo = this.s_math_BigInt__f__long_$lo;
      var l_$_hi = this.s_math_BigInt__f__long_$hi;
      if ((l_$_lo !== 0)) {
        var i = ((~l_$_lo) & ((l_$_lo - 1) | 0));
        return ((32 - Math.clz32(i)) | 0);
      } else {
        var i$1 = ((~l_$_hi) & ((l_$_hi - 1) | 0));
        return ((64 - Math.clz32(i$1)) | 0);
      }
    }
  } else {
    return $n(this.bigInteger__Ljava_math_BigInteger()).getLowestSetBit__I();
  }
});
$c_s_math_BigInt.prototype.bitLength__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var x_$_lo = this.s_math_BigInt__f__long_$lo;
    var x_$_hi = this.s_math_BigInt__f__long_$hi;
    if ((x_$_hi < 0)) {
      var x$1_$_lo = this.s_math_BigInt__f__long_$lo;
      var x$1_$_hi = this.s_math_BigInt__f__long_$hi;
      var lo = ((1 + x$1_$_lo) | 0);
      var hi = ((x$1_$_hi + (((x$1_$_lo & (~lo)) >>> 31) | 0)) | 0);
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((((-hi) | 0) + ((lo | lo$1) >> 31)) | 0);
      return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0);
    } else {
      var l_$_lo = this.s_math_BigInt__f__long_$lo;
      var l_$_hi = this.s_math_BigInt__f__long_$hi;
      return ((64 - ((l_$_hi !== 0) ? Math.clz32(l_$_hi) : ((32 + Math.clz32(l_$_lo)) | 0))) | 0);
    }
  } else {
    var this$12 = $n(this.s_math_BigInt__f__bigInteger);
    return $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$12);
  }
});
$c_s_math_BigInt.prototype.byteValue__B = (function() {
  return ((this.intValue__I() << 24) >> 24);
});
$c_s_math_BigInt.prototype.shortValue__S = (function() {
  return ((this.intValue__I() << 16) >> 16);
});
$c_s_math_BigInt.prototype.intValue__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var x_$_lo = this.s_math_BigInt__f__long_$lo;
    var x_$_hi = this.s_math_BigInt__f__long_$hi;
    return x_$_lo;
  } else {
    return $n(this.bigInteger__Ljava_math_BigInteger()).intValue__I();
  }
});
$c_s_math_BigInt.prototype.longValue__J = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    return $bL(this.s_math_BigInt__f__long_$lo, this.s_math_BigInt__f__long_$hi);
  } else {
    return $n(this.s_math_BigInt__f__bigInteger).longValue__J();
  }
});
$c_s_math_BigInt.prototype.floatValue__F = (function() {
  var this$1 = $n(this.bigInteger__Ljava_math_BigInteger());
  return $m_jl_Float$().parseFloat__T__F($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1));
});
$c_s_math_BigInt.prototype.doubleValue__D = (function() {
  if (this.isValidLong__Z()) {
    var x_$_lo = this.s_math_BigInt__f__long_$lo;
    var x_$_hi = this.s_math_BigInt__f__long_$hi;
    if ((x_$_hi >= (-2097152))) {
      var x$1_$_lo = this.s_math_BigInt__f__long_$lo;
      var x$1_$_hi = this.s_math_BigInt__f__long_$hi;
      var $x_1 = ((x$1_$_hi === 2097152) ? (x$1_$_lo === 0) : (x$1_$_hi < 2097152));
    } else {
      var $x_1 = false;
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var x$2_$_lo = this.s_math_BigInt__f__long_$lo;
    var x$2_$_hi = this.s_math_BigInt__f__long_$hi;
    return ((4.294967296E9 * x$2_$_hi) + (x$2_$_lo >>> 0.0));
  } else {
    var this$4 = $n(this.bigInteger__Ljava_math_BigInteger());
    return $m_jl_Double$().parseDouble__T__D($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$4));
  }
});
$c_s_math_BigInt.prototype.toString__T = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1_$_lo = this.s_math_BigInt__f__long_$lo;
    var this$1_$_hi = this.s_math_BigInt__f__long_$hi;
    return $m_RTLong$().toString__I__I__T(this$1_$_lo, this$1_$_hi);
  } else {
    var this$2 = $n(this.s_math_BigInt__f__bigInteger);
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$2);
  }
});
$c_s_math_BigInt.prototype.compare__O__I = (function(that) {
  return this.compare__s_math_BigInt__I($as_s_math_BigInt(that));
});
$c_s_math_BigInt.prototype.underlying__O = (function() {
  return this.bigInteger__Ljava_math_BigInteger();
});
function $as_s_math_BigInt(obj) {
  return (((obj instanceof $c_s_math_BigInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigInt"));
}
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigInt)));
}
function $asArrayOf_s_math_BigInt(obj, depth) {
  return (($isArrayOf_s_math_BigInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigInt;", depth));
}
var $d_s_math_BigInt = new $TypeData().initClass($c_s_math_BigInt, "scala.math.BigInt", ({
  s_math_BigInt: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
function $f_s_math_Numeric$ByteIsIntegral__plus__B__B__B($thiz, x, y) {
  return ((((x + y) | 0) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__minus__B__B__B($thiz, x, y) {
  return ((((x - y) | 0) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__times__B__B__B($thiz, x, y) {
  return ((Math.imul(x, y) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__quot__B__B__B($thiz, x, y) {
  return ((((x / $checkIntDivisor(y)) | 0) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__rem__B__B__B($thiz, x, y) {
  return ((((x % $checkIntDivisor(y)) | 0) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__negate__B__B($thiz, x) {
  return ((((-x) | 0) << 24) >> 24);
}
function $f_s_math_Numeric$ByteIsIntegral__sign__B__B($thiz, x) {
  var x$1 = x;
  return ((((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)) << 24) >> 24);
}
function $f_s_math_Numeric$CharIsIntegral__plus__C__C__C($thiz, x, y) {
  return (65535 & ((x + y) | 0));
}
function $f_s_math_Numeric$CharIsIntegral__minus__C__C__C($thiz, x, y) {
  return (65535 & ((x - y) | 0));
}
function $f_s_math_Numeric$CharIsIntegral__times__C__C__C($thiz, x, y) {
  return (65535 & Math.imul(x, y));
}
function $f_s_math_Numeric$CharIsIntegral__quot__C__C__C($thiz, x, y) {
  return (65535 & ((x / $checkIntDivisor(y)) | 0));
}
function $f_s_math_Numeric$CharIsIntegral__rem__C__C__C($thiz, x, y) {
  return (65535 & ((x % $checkIntDivisor(y)) | 0));
}
function $f_s_math_Numeric$CharIsIntegral__negate__C__C($thiz, x) {
  return (65535 & ((-x) | 0));
}
function $f_s_math_Numeric$CharIsIntegral__sign__C__C($thiz, x) {
  var x$1 = x;
  return (65535 & ((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)));
}
function $f_s_math_Numeric$IntIsIntegral__plus__I__I__I($thiz, x, y) {
  return ((x + y) | 0);
}
function $f_s_math_Numeric$IntIsIntegral__minus__I__I__I($thiz, x, y) {
  return ((x - y) | 0);
}
function $f_s_math_Numeric$IntIsIntegral__times__I__I__I($thiz, x, y) {
  return Math.imul(x, y);
}
function $f_s_math_Numeric$IntIsIntegral__quot__I__I__I($thiz, x, y) {
  return ((x / $checkIntDivisor(y)) | 0);
}
function $f_s_math_Numeric$IntIsIntegral__rem__I__I__I($thiz, x, y) {
  return ((x % $checkIntDivisor(y)) | 0);
}
function $f_s_math_Numeric$IntIsIntegral__negate__I__I($thiz, x) {
  return ((-x) | 0);
}
function $f_s_math_Numeric$LongIsIntegral__plus__J__J__J($thiz, x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  var lo = ((x_$_lo + y_$_lo) | 0);
  var hi = ((((x_$_hi + y_$_hi) | 0) + ((((x_$_lo & y_$_lo) | ((x_$_lo | y_$_lo) & (~lo))) >>> 31) | 0)) | 0);
  return $bL(lo, hi);
}
function $f_s_math_Numeric$LongIsIntegral__minus__J__J__J($thiz, x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  var lo = ((x_$_lo - y_$_lo) | 0);
  var hi = ((((x_$_hi - y_$_hi) | 0) + ((((~x_$_lo) & y_$_lo) | ((~(x_$_lo ^ y_$_lo)) & lo)) >> 31)) | 0);
  return $bL(lo, hi);
}
function $f_s_math_Numeric$LongIsIntegral__times__J__J__J($thiz, x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  var a0 = (65535 & x_$_lo);
  var a1 = ((x_$_lo >>> 16) | 0);
  var b0 = (65535 & y_$_lo);
  var b1 = ((y_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(x_$_lo, y_$_hi) + Math.imul(x_$_hi, y_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $bL(lo, hi);
}
function $f_s_math_Numeric$LongIsIntegral__quot__J__J__J($thiz, x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  return $m_RTLong$().divide__I__I__I__I__J(x_$_lo, x_$_hi, y_$_lo, y_$_hi);
}
function $f_s_math_Numeric$LongIsIntegral__rem__J__J__J($thiz, x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  return $m_RTLong$().remainder__I__I__I__I__J(x_$_lo, x_$_hi, y_$_lo, y_$_hi);
}
function $f_s_math_Numeric$LongIsIntegral__negate__J__J($thiz, x_$_lo, x_$_hi) {
  var lo = ((-x_$_lo) | 0);
  var hi = ((((-x_$_hi) | 0) + ((x_$_lo | lo) >> 31)) | 0);
  return $bL(lo, hi);
}
function $f_s_math_Numeric$ShortIsIntegral__plus__S__S__S($thiz, x, y) {
  return ((((x + y) | 0) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__minus__S__S__S($thiz, x, y) {
  return ((((x - y) | 0) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__times__S__S__S($thiz, x, y) {
  return ((Math.imul(x, y) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__quot__S__S__S($thiz, x, y) {
  return ((((x / $checkIntDivisor(y)) | 0) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__rem__S__S__S($thiz, x, y) {
  return ((((x % $checkIntDivisor(y)) | 0) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__negate__S__S($thiz, x) {
  return ((((-x) | 0) << 16) >> 16);
}
function $f_s_math_Numeric$ShortIsIntegral__sign__S__S($thiz, x) {
  var x$1 = x;
  return ((((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)) << 16) >> 16);
}
/** @constructor */
function $c_s_math_Ordering$Int$() {
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = null;
  $n_s_math_Ordering$Int$ = this;
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = new $c_s_math_Ordering$Reverse(this);
}
$c_s_math_Ordering$Int$.prototype = new $h_O();
$c_s_math_Ordering$Int$.prototype.constructor = $c_s_math_Ordering$Int$;
/** @constructor */
function $h_s_math_Ordering$Int$() {
}
$h_s_math_Ordering$Int$.prototype = $c_s_math_Ordering$Int$.prototype;
$c_s_math_Ordering$Int$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Int$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
var $d_s_math_Ordering$Int$ = new $TypeData().initClass($c_s_math_Ordering$Int$, "scala.math.Ordering$Int$", ({
  s_math_Ordering$Int$: 1,
  s_math_Ordering$IntOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$CachedReverse: 1
}));
var $n_s_math_Ordering$Int$;
function $m_s_math_Ordering$Int$() {
  if ((!$n_s_math_Ordering$Int$)) {
    $n_s_math_Ordering$Int$ = new $c_s_math_Ordering$Int$();
  }
  return $n_s_math_Ordering$Int$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$BooleanManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest() {
}
$h_s_reflect_ManifestFactory$BooleanManifest.prototype = $c_s_reflect_ManifestFactory$BooleanManifest.prototype;
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_Z.getClassOf();
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_Z(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$ByteManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ByteManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest() {
}
$h_s_reflect_ManifestFactory$ByteManifest.prototype = $c_s_reflect_ManifestFactory$ByteManifest.prototype;
$c_s_reflect_ManifestFactory$ByteManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_B.getClassOf();
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_B(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$CharManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$CharManifest.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest() {
}
$h_s_reflect_ManifestFactory$CharManifest.prototype = $c_s_reflect_ManifestFactory$CharManifest.prototype;
$c_s_reflect_ManifestFactory$CharManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_C.getClassOf();
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_C(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$DoubleManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest() {
}
$h_s_reflect_ManifestFactory$DoubleManifest.prototype = $c_s_reflect_ManifestFactory$DoubleManifest.prototype;
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_D.getClassOf();
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_D(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$FloatManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$FloatManifest.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest() {
}
$h_s_reflect_ManifestFactory$FloatManifest.prototype = $c_s_reflect_ManifestFactory$FloatManifest.prototype;
$c_s_reflect_ManifestFactory$FloatManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_F.getClassOf();
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_F(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$IntManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$IntManifest.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest() {
}
$h_s_reflect_ManifestFactory$IntManifest.prototype = $c_s_reflect_ManifestFactory$IntManifest.prototype;
$c_s_reflect_ManifestFactory$IntManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_I.getClassOf();
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_I(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$LongManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$LongManifest.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest() {
}
$h_s_reflect_ManifestFactory$LongManifest.prototype = $c_s_reflect_ManifestFactory$LongManifest.prototype;
$c_s_reflect_ManifestFactory$LongManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_J.getClassOf();
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_J(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$PhantomManifest() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$PhantomManifest.prototype = new $h_s_reflect_ManifestFactory$ClassTypeManifest();
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.constructor = $c_s_reflect_ManifestFactory$PhantomManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$PhantomManifest() {
}
$h_s_reflect_ManifestFactory$PhantomManifest.prototype = $c_s_reflect_ManifestFactory$PhantomManifest.prototype;
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.toString__T = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_toString;
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$ShortManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ShortManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest() {
}
$h_s_reflect_ManifestFactory$ShortManifest.prototype = $c_s_reflect_ManifestFactory$ShortManifest.prototype;
$c_s_reflect_ManifestFactory$ShortManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_S.getClassOf();
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_S(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
$c_s_reflect_ManifestFactory$UnitManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$UnitManifest.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest() {
}
$h_s_reflect_ManifestFactory$UnitManifest.prototype = $c_s_reflect_ManifestFactory$UnitManifest.prototype;
$c_s_reflect_ManifestFactory$UnitManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_V.getClassOf();
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.newArray__I__O = (function(len) {
  return new ($d_jl_Void.getArrayOf().constr)(len);
});
/** @constructor */
function $c_Ltyrian_Cmd$None$() {
}
$c_Ltyrian_Cmd$None$.prototype = new $h_O();
$c_Ltyrian_Cmd$None$.prototype.constructor = $c_Ltyrian_Cmd$None$;
/** @constructor */
function $h_Ltyrian_Cmd$None$() {
}
$h_Ltyrian_Cmd$None$.prototype = $c_Ltyrian_Cmd$None$.prototype;
$c_Ltyrian_Cmd$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Cmd$None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_Ltyrian_Cmd$None$.prototype.toString__T = (function() {
  return "None";
});
$c_Ltyrian_Cmd$None$.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_Cmd$None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_Ltyrian_Cmd$None$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Ltyrian_Cmd$None$ = new $TypeData().initClass($c_Ltyrian_Cmd$None$, "tyrian.Cmd$None$", ({
  Ltyrian_Cmd$None$: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Ltyrian_Cmd$None$;
function $m_Ltyrian_Cmd$None$() {
  if ((!$n_Ltyrian_Cmd$None$)) {
    $n_Ltyrian_Cmd$None$ = new $c_Ltyrian_Cmd$None$();
  }
  return $n_Ltyrian_Cmd$None$;
}
/** @constructor */
function $c_Ltyrian_Empty$() {
}
$c_Ltyrian_Empty$.prototype = new $h_O();
$c_Ltyrian_Empty$.prototype.constructor = $c_Ltyrian_Empty$;
/** @constructor */
function $h_Ltyrian_Empty$() {
}
$h_Ltyrian_Empty$.prototype = $c_Ltyrian_Empty$.prototype;
$c_Ltyrian_Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Empty$.prototype.hashCode__I = (function() {
  return 67081517;
});
$c_Ltyrian_Empty$.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_Empty$.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_Ltyrian_Empty$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ltyrian_Empty$.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Elem__T(this);
});
var $d_Ltyrian_Empty$ = new $TypeData().initClass($c_Ltyrian_Empty$, "tyrian.Empty$", ({
  Ltyrian_Empty$: 1,
  Ltyrian_Elem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Ltyrian_Empty$;
function $m_Ltyrian_Empty$() {
  if ((!$n_Ltyrian_Empty$)) {
    $n_Ltyrian_Empty$ = new $c_Ltyrian_Empty$();
  }
  return $n_Ltyrian_Empty$;
}
/** @constructor */
function $c_Ltyrian_EmptyAttribute$() {
}
$c_Ltyrian_EmptyAttribute$.prototype = new $h_O();
$c_Ltyrian_EmptyAttribute$.prototype.constructor = $c_Ltyrian_EmptyAttribute$;
/** @constructor */
function $h_Ltyrian_EmptyAttribute$() {
}
$h_Ltyrian_EmptyAttribute$.prototype = $c_Ltyrian_EmptyAttribute$.prototype;
$c_Ltyrian_EmptyAttribute$.prototype.toString__T = (function() {
  return $m_Ltyrian_HTMLRendering$package$().render__Ltyrian_Attr__T(this);
});
$c_Ltyrian_EmptyAttribute$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_EmptyAttribute$.prototype.hashCode__I = (function() {
  return 853194735;
});
$c_Ltyrian_EmptyAttribute$.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_EmptyAttribute$.prototype.productPrefix__T = (function() {
  return "EmptyAttribute";
});
$c_Ltyrian_EmptyAttribute$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Ltyrian_EmptyAttribute$ = new $TypeData().initClass($c_Ltyrian_EmptyAttribute$, "tyrian.EmptyAttribute$", ({
  Ltyrian_EmptyAttribute$: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Ltyrian_EmptyAttribute$;
function $m_Ltyrian_EmptyAttribute$() {
  if ((!$n_Ltyrian_EmptyAttribute$)) {
    $n_Ltyrian_EmptyAttribute$ = new $c_Ltyrian_EmptyAttribute$();
  }
  return $n_Ltyrian_EmptyAttribute$;
}
/** @constructor */
function $c_Ltyrian_Sub$None$() {
}
$c_Ltyrian_Sub$None$.prototype = new $h_O();
$c_Ltyrian_Sub$None$.prototype.constructor = $c_Ltyrian_Sub$None$;
/** @constructor */
function $h_Ltyrian_Sub$None$() {
}
$h_Ltyrian_Sub$None$.prototype = $c_Ltyrian_Sub$None$.prototype;
$c_Ltyrian_Sub$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ltyrian_Sub$None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_Ltyrian_Sub$None$.prototype.toString__T = (function() {
  return "None";
});
$c_Ltyrian_Sub$None$.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_Sub$None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_Ltyrian_Sub$None$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Ltyrian_Sub$None$ = new $TypeData().initClass($c_Ltyrian_Sub$None$, "tyrian.Sub$None$", ({
  Ltyrian_Sub$None$: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Ltyrian_Sub$None$;
function $m_Ltyrian_Sub$None$() {
  if ((!$n_Ltyrian_Sub$None$)) {
    $n_Ltyrian_Sub$None$ = new $c_Ltyrian_Sub$None$();
  }
  return $n_Ltyrian_Sub$None$;
}
function $f_Lcats_Applicative__replicateA__I__O__O($thiz, n, fa) {
  if ((n <= 0)) {
    return $thiz.pure__O__O($m_sci_Nil$());
  } else if ((n === 1)) {
    return $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
      var this$1 = $m_sci_Nil$();
      return new $c_sci_$colon$colon(_$2, this$1);
    })));
  } else {
    var one = $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
      $m_Lcats_data_Chain$();
      return new $c_Lcats_data_Chain$Singleton(_$3);
    })));
    return $thiz.map__O__F1__O($p_Lcats_Applicative__loop$1__O__I__O__O($thiz, one, ((n - 1) | 0), one), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
      var _$10$1 = $as_Lcats_data_Chain(_$10);
      return $n(_$10$1).toList__sci_List();
    })));
  }
}
function $p_Lcats_Applicative__loop$1__O__I__O__O($thiz, fa, n, acc) {
  var acc$tailLocal1 = acc;
  var n$tailLocal1 = n;
  var fa$tailLocal1 = fa;
  while (true) {
    if ((n$tailLocal1 === 1)) {
      return $thiz.map2__O__O__F2__O(fa$tailLocal1, acc$tailLocal1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$4, _$5) => {
        var _$4$1 = $as_Lcats_data_Chain(_$4);
        var _$5$1 = $as_Lcats_data_Chain(_$5);
        var this$1 = $n(_$4$1);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$1, _$5$1);
      })));
    } else {
      var fa$tailLocal1$tmp1 = $thiz.map2__O__O__F2__O(fa$tailLocal1, fa$tailLocal1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$6, _$7) => {
        var _$6$1 = $as_Lcats_data_Chain(_$6);
        var _$7$1 = $as_Lcats_data_Chain(_$7);
        var this$2 = $n(_$6$1);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, _$7$1);
      })));
      var n$tailLocal1$tmp1 = (n$tailLocal1 >> 1);
      var acc$tailLocal1$tmp1 = (((1 & n$tailLocal1) === 1) ? $thiz.map2__O__O__F2__O(acc$tailLocal1, fa$tailLocal1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$8, _$9) => {
        var _$8$1 = $as_Lcats_data_Chain(_$8);
        var _$9$1 = $as_Lcats_data_Chain(_$9);
        var this$3 = $n(_$8$1);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$3, _$9$1);
      }))) : acc$tailLocal1);
      fa$tailLocal1 = fa$tailLocal1$tmp1;
      n$tailLocal1 = n$tailLocal1$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
    }
  }
}
function $is_Lcats_Applicative(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Applicative)));
}
function $as_Lcats_Applicative(obj) {
  return (($is_Lcats_Applicative(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Applicative"));
}
function $isArrayOf_Lcats_Applicative(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Applicative)));
}
function $asArrayOf_Lcats_Applicative(obj, depth) {
  return (($isArrayOf_Lcats_Applicative(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Applicative;", depth));
}
function $f_Lcats_FlatMap__flatten__O__O($thiz, ffa) {
  return $thiz.flatMap__O__F1__O(ffa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fa) => fa)));
}
function $f_Lcats_FlatMap__product__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $thiz.map__O__F1__O(fb, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b) => new $c_T2(a, b)))))));
}
function $f_Lcats_FlatMap__map2__O__O__F2__O($thiz, fa, fb, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $thiz.map__O__F1__O(fb, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b) => $n(f).apply__O__O__O(a, b)))))));
}
function $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  $m_Lcats_Eval$();
  var a$1 = $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $thiz.map__O__F1__O($n(fb).value__O(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b) => $n(f).apply__O__O__O(a, b)))))));
  return new $c_Lcats_Now(a$1);
}
function $f_Lcats_FlatMap__productR__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => fb)));
}
function $f_Lcats_FlatMap__productL__O__O__O($thiz, fa, fb) {
  return $thiz.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a, _$5) => a)));
}
function $f_Lcats_FlatMap__ifM__O__F0__F0__O($thiz, fa, ifTrue, ifFalse) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$7) => {
    var _$7$1 = $uZ(_$7);
    return (_$7$1 ? $n(ifTrue).apply__O() : $n(ifFalse).apply__O());
  })));
}
function $f_Lcats_FlatMap__flatTap__O__F1__O($thiz, fa, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $thiz.as__O__O__O($n(f).apply__O__O(a), a))));
}
function $f_Lcats_FlatMap__foreverM__O__O($thiz, fa) {
  var leftUnit = new $c_s_util_Left((void 0));
  var stepResult = $thiz.as__O__O__O(fa, leftUnit);
  return $thiz.tailRecM__O__F1__O((void 0), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => {
    $as_jl_Void(_$8);
    return stepResult;
  })));
}
function $is_Lcats_FlatMap(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_FlatMap)));
}
function $as_Lcats_FlatMap(obj) {
  return (($is_Lcats_FlatMap(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.FlatMap"));
}
function $isArrayOf_Lcats_FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_FlatMap)));
}
function $asArrayOf_Lcats_FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.FlatMap;", depth));
}
/** @constructor */
function $c_Lcats_data_Chain$Empty$() {
}
$c_Lcats_data_Chain$Empty$.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$Empty$.prototype.constructor = $c_Lcats_data_Chain$Empty$;
/** @constructor */
function $h_Lcats_data_Chain$Empty$() {
}
$h_Lcats_data_Chain$Empty$.prototype = $c_Lcats_data_Chain$Empty$.prototype;
$c_Lcats_data_Chain$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Empty$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_data_Chain$Empty$.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_Lcats_data_Chain$Empty$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_data_Chain$Empty$ = new $TypeData().initClass($c_Lcats_data_Chain$Empty$, "cats.data.Chain$Empty$", ({
  Lcats_data_Chain$Empty$: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_data_Chain$Empty$;
function $m_Lcats_data_Chain$Empty$() {
  if ((!$n_Lcats_data_Chain$Empty$)) {
    $n_Lcats_data_Chain$Empty$ = new $c_Lcats_data_Chain$Empty$();
  }
  return $n_Lcats_data_Chain$Empty$;
}
function $f_Lcats_data_KleisliApply__map2Eval__Lcats_data_Kleisli__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  var memoFb = $n(fb).memoize__Lcats_Eval();
  $m_Lcats_Eval$();
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
    var fb$1 = $n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(a);
    var efc = $n(memoFb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$176) => {
      var _$176$1 = $as_Lcats_data_Kleisli(_$176);
      return $n($n(_$176$1).Lcats_data_Kleisli__f_run).apply__O__O(a);
    })));
    var efz = $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).map2Eval__O__Lcats_Eval__F2__Lcats_Eval(fb$1, efc, f);
    return $n(efz).value__O();
  }));
  var a$1 = new $c_Lcats_data_Kleisli(run);
  return new $c_Lcats_Now(a$1);
}
function $f_Lcats_data_KleisliApply__product__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fb, fc) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).product__O__O__O($n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(a), $n($n(fc).Lcats_data_Kleisli__f_run).apply__O__O(a))));
  return new $c_Lcats_data_Kleisli(run);
}
/** @constructor */
function $c_Lcats_data_KleisliInstances1() {
}
$c_Lcats_data_KleisliInstances1.prototype = new $h_Lcats_data_KleisliInstances2();
$c_Lcats_data_KleisliInstances1.prototype.constructor = $c_Lcats_data_KleisliInstances1;
/** @constructor */
function $h_Lcats_data_KleisliInstances1() {
}
$h_Lcats_data_KleisliInstances1.prototype = $c_Lcats_data_KleisliInstances1.prototype;
/** @constructor */
function $c_Lcats_effect_IO$Canceled$() {
}
$c_Lcats_effect_IO$Canceled$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Canceled$.prototype.constructor = $c_Lcats_effect_IO$Canceled$;
/** @constructor */
function $h_Lcats_effect_IO$Canceled$() {
}
$h_Lcats_effect_IO$Canceled$.prototype = $c_Lcats_effect_IO$Canceled$.prototype;
$c_Lcats_effect_IO$Canceled$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Canceled$.prototype.hashCode__I = (function() {
  return (-58529607);
});
$c_Lcats_effect_IO$Canceled$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$Canceled$.prototype.productPrefix__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_IO$Canceled$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Canceled$.prototype.tag__B = (function() {
  return 10;
});
var $d_Lcats_effect_IO$Canceled$ = new $TypeData().initClass($c_Lcats_effect_IO$Canceled$, "cats.effect.IO$Canceled$", ({
  Lcats_effect_IO$Canceled$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$Canceled$;
function $m_Lcats_effect_IO$Canceled$() {
  if ((!$n_Lcats_effect_IO$Canceled$)) {
    $n_Lcats_effect_IO$Canceled$ = new $c_Lcats_effect_IO$Canceled$();
  }
  return $n_Lcats_effect_IO$Canceled$;
}
/** @constructor */
function $c_Lcats_effect_IO$Cede$() {
}
$c_Lcats_effect_IO$Cede$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Cede$.prototype.constructor = $c_Lcats_effect_IO$Cede$;
/** @constructor */
function $h_Lcats_effect_IO$Cede$() {
}
$h_Lcats_effect_IO$Cede$.prototype = $c_Lcats_effect_IO$Cede$.prototype;
$c_Lcats_effect_IO$Cede$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$Cede$.prototype.hashCode__I = (function() {
  return 2096259;
});
$c_Lcats_effect_IO$Cede$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$Cede$.prototype.productPrefix__T = (function() {
  return "Cede";
});
$c_Lcats_effect_IO$Cede$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$Cede$.prototype.tag__B = (function() {
  return 16;
});
var $d_Lcats_effect_IO$Cede$ = new $TypeData().initClass($c_Lcats_effect_IO$Cede$, "cats.effect.IO$Cede$", ({
  Lcats_effect_IO$Cede$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$Cede$;
function $m_Lcats_effect_IO$Cede$() {
  if ((!$n_Lcats_effect_IO$Cede$)) {
    $n_Lcats_effect_IO$Cede$ = new $c_Lcats_effect_IO$Cede$();
  }
  return $n_Lcats_effect_IO$Cede$;
}
/** @constructor */
function $c_Lcats_effect_IO$EndFiber$() {
}
$c_Lcats_effect_IO$EndFiber$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$EndFiber$.prototype.constructor = $c_Lcats_effect_IO$EndFiber$;
/** @constructor */
function $h_Lcats_effect_IO$EndFiber$() {
}
$h_Lcats_effect_IO$EndFiber$.prototype = $c_Lcats_effect_IO$EndFiber$.prototype;
$c_Lcats_effect_IO$EndFiber$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$EndFiber$.prototype.hashCode__I = (function() {
  return 1766772977;
});
$c_Lcats_effect_IO$EndFiber$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$EndFiber$.prototype.productPrefix__T = (function() {
  return "EndFiber";
});
$c_Lcats_effect_IO$EndFiber$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$EndFiber$.prototype.tag__B = (function() {
  return (-1);
});
var $d_Lcats_effect_IO$EndFiber$ = new $TypeData().initClass($c_Lcats_effect_IO$EndFiber$, "cats.effect.IO$EndFiber$", ({
  Lcats_effect_IO$EndFiber$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$EndFiber$;
function $m_Lcats_effect_IO$EndFiber$() {
  if ((!$n_Lcats_effect_IO$EndFiber$)) {
    $n_Lcats_effect_IO$EndFiber$ = new $c_Lcats_effect_IO$EndFiber$();
  }
  return $n_Lcats_effect_IO$EndFiber$;
}
/** @constructor */
function $c_Lcats_effect_IO$ReadEC$() {
}
$c_Lcats_effect_IO$ReadEC$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$ReadEC$.prototype.constructor = $c_Lcats_effect_IO$ReadEC$;
/** @constructor */
function $h_Lcats_effect_IO$ReadEC$() {
}
$h_Lcats_effect_IO$ReadEC$.prototype = $c_Lcats_effect_IO$ReadEC$.prototype;
$c_Lcats_effect_IO$ReadEC$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$ReadEC$.prototype.hashCode__I = (function() {
  return (-1851113260);
});
$c_Lcats_effect_IO$ReadEC$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$ReadEC$.prototype.productPrefix__T = (function() {
  return "ReadEC";
});
$c_Lcats_effect_IO$ReadEC$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$ReadEC$.prototype.tag__B = (function() {
  return 5;
});
var $d_Lcats_effect_IO$ReadEC$ = new $TypeData().initClass($c_Lcats_effect_IO$ReadEC$, "cats.effect.IO$ReadEC$", ({
  Lcats_effect_IO$ReadEC$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$ReadEC$;
function $m_Lcats_effect_IO$ReadEC$() {
  if ((!$n_Lcats_effect_IO$ReadEC$)) {
    $n_Lcats_effect_IO$ReadEC$ = new $c_Lcats_effect_IO$ReadEC$();
  }
  return $n_Lcats_effect_IO$ReadEC$;
}
/** @constructor */
function $c_Lcats_effect_IO$RealTime$() {
}
$c_Lcats_effect_IO$RealTime$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$RealTime$.prototype.constructor = $c_Lcats_effect_IO$RealTime$;
/** @constructor */
function $h_Lcats_effect_IO$RealTime$() {
}
$h_Lcats_effect_IO$RealTime$.prototype = $c_Lcats_effect_IO$RealTime$.prototype;
$c_Lcats_effect_IO$RealTime$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_IO$RealTime$.prototype.hashCode__I = (function() {
  return (-795507285);
});
$c_Lcats_effect_IO$RealTime$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_IO$RealTime$.prototype.productPrefix__T = (function() {
  return "RealTime";
});
$c_Lcats_effect_IO$RealTime$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_IO$RealTime$.prototype.tag__B = (function() {
  return 3;
});
var $d_Lcats_effect_IO$RealTime$ = new $TypeData().initClass($c_Lcats_effect_IO$RealTime$, "cats.effect.IO$RealTime$", ({
  Lcats_effect_IO$RealTime$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lcats_effect_IO$RealTime$;
function $m_Lcats_effect_IO$RealTime$() {
  if ((!$n_Lcats_effect_IO$RealTime$)) {
    $n_Lcats_effect_IO$RealTime$ = new $c_Lcats_effect_IO$RealTime$();
  }
  return $n_Lcats_effect_IO$RealTime$;
}
/** @constructor */
function $c_Lcats_instances_EqInstances$$anon$1() {
}
$c_Lcats_instances_EqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EqInstances$$anon$1() {
}
$h_Lcats_instances_EqInstances$$anon$1.prototype = $c_Lcats_instances_EqInstances$$anon$1.prototype;
$c_Lcats_instances_EqInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_Lcats_kernel_Eq(fa);
  $n($m_Lcats_package$().Lcats_package$__f_Eq);
  return new $c_Lcats_kernel_Eq$$anon$2(fa$1, fi);
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Eq(fa);
  var fb$1 = $as_Lcats_kernel_Eq(fb);
  return new $c_Lcats_instances_EqInstances$$anon$2(fa$1, fb$1, this);
});
var $d_Lcats_instances_EqInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_EqInstances$$anon$1, "cats.instances.EqInstances$$anon$1", ({
  Lcats_instances_EqInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$1() {
}
$c_Lcats_instances_EquivInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$1() {
}
$h_Lcats_instances_EquivInstances$$anon$1.prototype = $c_Lcats_instances_EquivInstances$$anon$1.prototype;
$c_Lcats_instances_EquivInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_s_math_Equiv(fa);
  return new $c_Lcats_instances_EquivInstances$$anon$3(fa$1, fi);
});
$c_Lcats_instances_EquivInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Equiv(fa);
  var fb$1 = $as_s_math_Equiv(fb);
  return new $c_Lcats_instances_EquivInstances$$anon$4(fa$1, fb$1);
});
var $d_Lcats_instances_EquivInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_EquivInstances$$anon$1, "cats.instances.EquivInstances$$anon$1", ({
  Lcats_instances_EquivInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$13(fa$9, f$5, g$5) {
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_fa = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_f = null;
  this.Lcats_instances_ScalaVersionSpecificNumeric__f_g = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_f$6 = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10 = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_g$6 = null;
  this.Lcats_instances_InvariantInstances$$anon$13__f_f$6 = f$5;
  this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10 = fa$9;
  this.Lcats_instances_InvariantInstances$$anon$13__f_g$6 = g$5;
  $ct_Lcats_instances_ScalaVersionSpecificNumeric__s_math_Numeric__F1__F1__(this, fa$9, f$5, g$5);
}
$c_Lcats_instances_InvariantInstances$$anon$13.prototype = new $h_Lcats_instances_ScalaVersionSpecificNumeric();
$c_Lcats_instances_InvariantInstances$$anon$13.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$13;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$13() {
}
$h_Lcats_instances_InvariantInstances$$anon$13.prototype = $c_Lcats_instances_InvariantInstances$$anon$13.prototype;
$c_Lcats_instances_InvariantInstances$$anon$13.prototype.quot__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_InvariantInstances$$anon$13__f_f$6).apply__O__O($n(this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10).quot__O__O__O($n(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6).apply__O__O(x), $n(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6).apply__O__O(y)));
});
$c_Lcats_instances_InvariantInstances$$anon$13.prototype.rem__O__O__O = (function(x, y) {
  return $n(this.Lcats_instances_InvariantInstances$$anon$13__f_f$6).apply__O__O($n(this.Lcats_instances_InvariantInstances$$anon$13__f_fa$10).rem__O__O__O($n(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6).apply__O__O(x), $n(this.Lcats_instances_InvariantInstances$$anon$13__f_g$6).apply__O__O(y)));
});
var $d_Lcats_instances_InvariantInstances$$anon$13 = new $TypeData().initClass($c_Lcats_instances_InvariantInstances$$anon$13, "cats.instances.InvariantInstances$$anon$13", ({
  Lcats_instances_InvariantInstances$$anon$13: 1,
  Lcats_instances_ScalaVersionSpecificNumeric: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1,
  s_math_Numeric: 1,
  s_math_Integral: 1
}));
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$1() {
}
$c_Lcats_instances_OrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$1() {
}
$h_Lcats_instances_OrderInstances$$anon$1.prototype = $c_Lcats_instances_OrderInstances$$anon$1.prototype;
$c_Lcats_instances_OrderInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_Lcats_kernel_Order(fa);
  $n($m_Lcats_package$().Lcats_package$__f_Order);
  return new $c_Lcats_kernel_Order$$anon$2(fa$1, fi);
});
$c_Lcats_instances_OrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Order(fa);
  var fb$1 = $as_Lcats_kernel_Order(fb);
  return new $c_Lcats_instances_OrderInstances$$anon$2(fa$1, fb$1, this);
});
var $d_Lcats_instances_OrderInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_OrderInstances$$anon$1, "cats.instances.OrderInstances$$anon$1", ({
  Lcats_instances_OrderInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$1() {
}
$c_Lcats_instances_OrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$1() {
}
$h_Lcats_instances_OrderingInstances$$anon$1.prototype = $c_Lcats_instances_OrderingInstances$$anon$1.prototype;
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_s_math_Ordering(fa);
  var this$1 = $n(fa$1);
  return new $c_s_math_Ordering$$anon$1(this$1, fi);
});
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Ordering(fa);
  var fb$1 = $as_s_math_Ordering(fb);
  return new $c_Lcats_instances_OrderingInstances$$anon$2(fa$1, fb$1);
});
var $d_Lcats_instances_OrderingInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_OrderingInstances$$anon$1, "cats.instances.OrderingInstances$$anon$1", ({
  Lcats_instances_OrderingInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$1() {
}
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$1() {
}
$h_Lcats_instances_PartialOrderInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_Lcats_kernel_PartialOrder(fa);
  $n($m_Lcats_package$().Lcats_package$__f_PartialOrder);
  return new $c_Lcats_kernel_PartialOrder$$anon$1(fa$1, fi);
});
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_PartialOrder(fa);
  var fb$1 = $as_Lcats_kernel_PartialOrder(fb);
  return new $c_Lcats_instances_PartialOrderInstances$$anon$2(fa$1, fb$1, this);
});
var $d_Lcats_instances_PartialOrderInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_PartialOrderInstances$$anon$1, "cats.instances.PartialOrderInstances$$anon$1", ({
  Lcats_instances_PartialOrderInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$1() {
}
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$1() {
}
$h_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  var fa$1 = $as_s_math_PartialOrdering(fa);
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$2(fa$1, fi);
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_PartialOrdering(fa);
  var fb$1 = $as_s_math_PartialOrdering(fb);
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa$1, fb$1);
});
var $d_Lcats_instances_PartialOrderingInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_PartialOrderingInstances$$anon$1, "cats.instances.PartialOrderingInstances$$anon$1", ({
  Lcats_instances_PartialOrderingInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BitSetSemilattice() {
}
$c_Lcats_kernel_instances_BitSetSemilattice.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.constructor = $c_Lcats_kernel_instances_BitSetSemilattice;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetSemilattice() {
}
$h_Lcats_kernel_instances_BitSetSemilattice.prototype = $c_Lcats_kernel_instances_BitSetSemilattice.prototype;
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.empty__O = (function() {
  return $m_sci_BitSet$().sci_BitSet$__f_empty;
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_BitSet(x);
  var y$1 = $as_sci_BitSet(y);
  var this$1 = $n(x$1);
  return $as_sci_BitSet($f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this$1, y$1));
});
var $d_Lcats_kernel_instances_BitSetSemilattice = new $TypeData().initClass($c_Lcats_kernel_instances_BitSetSemilattice, "cats.kernel.instances.BitSetSemilattice", ({
  Lcats_kernel_instances_BitSetSemilattice: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_DurationOrder() {
}
$c_Lcats_kernel_instances_DurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationOrder.prototype.constructor = $c_Lcats_kernel_instances_DurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DurationOrder() {
}
$h_Lcats_kernel_instances_DurationOrder.prototype = $c_Lcats_kernel_instances_DurationOrder.prototype;
$c_Lcats_kernel_instances_DurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $n(x).equals__O__Z(y));
});
$c_Lcats_kernel_instances_DurationOrder.prototype.neqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : $n(x).equals__O__Z(y)));
});
$c_Lcats_kernel_instances_DurationOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  return $n(x$1).hashCode__I();
});
$c_Lcats_kernel_instances_DurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  var this$1 = $n(x$1);
  return this$1.compare__s_concurrent_duration_Duration__I(y$1);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z($as_s_concurrent_duration_Duration(x), $as_s_concurrent_duration_Duration(y));
});
$c_Lcats_kernel_instances_DurationOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z($as_s_concurrent_duration_Duration(x), $as_s_concurrent_duration_Duration(y));
});
$c_Lcats_kernel_instances_DurationOrder.prototype.lt__O__O__Z = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  var this$1 = $n(x$1);
  return $f_s_math_Ordered__$less__O__Z(this$1, y$1);
});
$c_Lcats_kernel_instances_DurationOrder.prototype.min__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  return $n(x$1).min__s_concurrent_duration_Duration__s_concurrent_duration_Duration(y$1);
});
var $d_Lcats_kernel_instances_DurationOrder = new $TypeData().initClass($c_Lcats_kernel_instances_DurationOrder, "cats.kernel.instances.DurationOrder", ({
  Lcats_kernel_instances_DurationOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_DurationBounded: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationOrder() {
}
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationOrder() {
}
$h_Lcats_kernel_instances_FiniteDurationOrder.prototype = $c_Lcats_kernel_instances_FiniteDurationOrder.prototype;
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $n(x).equals__O__Z(y));
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.neqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return (!((x === null) ? (y === null) : $n(x).equals__O__Z(y)));
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var this$1 = $n(x$1);
  var $x_1 = $n(this$1.s_concurrent_duration_FiniteDuration__f_unit).toNanos__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length_$lo, this$1.s_concurrent_duration_FiniteDuration__f_length_$hi);
  var x$2_$_lo = $x_1.l;
  var x$2_$_hi = $x_1.h;
  return x$2_$_lo;
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  return $n(x$1).compare__s_concurrent_duration_Duration__I(y$1);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z($as_s_concurrent_duration_FiniteDuration(x), $as_s_concurrent_duration_FiniteDuration(y));
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z($as_s_concurrent_duration_FiniteDuration(x), $as_s_concurrent_duration_FiniteDuration(y));
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.lt__O__O__Z = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  var this$1 = $n(x$1);
  return $f_s_math_Ordered__$less__O__Z(this$1, y$1);
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.min__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  return $n(x$1).min__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration(y$1);
});
var $d_Lcats_kernel_instances_FiniteDurationOrder = new $TypeData().initClass($c_Lcats_kernel_instances_FiniteDurationOrder, "cats.kernel.instances.FiniteDurationOrder", ({
  Lcats_kernel_instances_FiniteDurationOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_FiniteDurationBounded: 1
}));
/** @constructor */
function $c_Lfs2_Pull$CanceledScope(scopeId, inter) {
  this.Lfs2_Pull$CanceledScope__f_scopeId = null;
  this.Lfs2_Pull$CanceledScope__f_inter = null;
  this.Lfs2_Pull$CanceledScope__f_scopeId = scopeId;
  this.Lfs2_Pull$CanceledScope__f_inter = inter;
}
$c_Lfs2_Pull$CanceledScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$CanceledScope.prototype.constructor = $c_Lfs2_Pull$CanceledScope;
/** @constructor */
function $h_Lfs2_Pull$CanceledScope() {
}
$h_Lfs2_Pull$CanceledScope.prototype = $c_Lfs2_Pull$CanceledScope.prototype;
$c_Lfs2_Pull$CanceledScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$CanceledScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$CanceledScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$CanceledScope)) {
    var x$0$2 = $as_Lfs2_Pull$CanceledScope(x$0);
    var x = this.Lfs2_Pull$CanceledScope__f_scopeId;
    var x$2 = $n(x$0$2).Lfs2_Pull$CanceledScope__f_scopeId;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lfs2_Pull$CanceledScope__f_inter;
      var x$4 = $n(x$0$2).Lfs2_Pull$CanceledScope__f_inter;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$CanceledScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$CanceledScope.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$CanceledScope.prototype.productPrefix__T = (function() {
  return "CanceledScope";
});
$c_Lfs2_Pull$CanceledScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$CanceledScope__f_scopeId;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$CanceledScope__f_inter;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$CanceledScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$CanceledScope__f_scopeId;
});
$c_Lfs2_Pull$CanceledScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  return $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$();
});
$c_Lfs2_Pull$CanceledScope.prototype.interruption__s_Option = (function() {
  var value = this.Lfs2_Pull$CanceledScope__f_inter;
  return new $c_s_Some(value);
});
function $as_Lfs2_Pull$CanceledScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$CanceledScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$CanceledScope"));
}
function $isArrayOf_Lfs2_Pull$CanceledScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$CanceledScope)));
}
function $asArrayOf_Lfs2_Pull$CanceledScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$CanceledScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$CanceledScope;", depth));
}
var $d_Lfs2_Pull$CanceledScope = new $TypeData().initClass($c_Lfs2_Pull$CanceledScope, "fs2.Pull$CanceledScope", ({
  Lfs2_Pull$CanceledScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$FailedScope(scopeId, err) {
  this.Lfs2_Pull$FailedScope__f_scopeId = null;
  this.Lfs2_Pull$FailedScope__f_err = null;
  this.Lfs2_Pull$FailedScope__f_scopeId = scopeId;
  this.Lfs2_Pull$FailedScope__f_err = err;
}
$c_Lfs2_Pull$FailedScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$FailedScope.prototype.constructor = $c_Lfs2_Pull$FailedScope;
/** @constructor */
function $h_Lfs2_Pull$FailedScope() {
}
$h_Lfs2_Pull$FailedScope.prototype = $c_Lfs2_Pull$FailedScope.prototype;
$c_Lfs2_Pull$FailedScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$FailedScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$FailedScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$FailedScope)) {
    var x$0$2 = $as_Lfs2_Pull$FailedScope(x$0);
    var x = this.Lfs2_Pull$FailedScope__f_scopeId;
    var x$2 = $n(x$0$2).Lfs2_Pull$FailedScope__f_scopeId;
    if ((x === null)) {
      var $x_1 = (x$2 === null);
    } else {
      var this$1 = $n(x);
      var $x_1 = (this$1 === x$2);
    }
    if ($x_1) {
      var x$3 = this.Lfs2_Pull$FailedScope__f_err;
      var x$4 = $n(x$0$2).Lfs2_Pull$FailedScope__f_err;
      return ((x$3 === null) ? (x$4 === null) : $n(x$3).equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$FailedScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$FailedScope.prototype.productArity__I = (function() {
  return 2;
});
$c_Lfs2_Pull$FailedScope.prototype.productPrefix__T = (function() {
  return "FailedScope";
});
$c_Lfs2_Pull$FailedScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$FailedScope__f_scopeId;
  }
  if ((n === 1)) {
    return this.Lfs2_Pull$FailedScope__f_err;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$FailedScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$FailedScope__f_scopeId;
});
$c_Lfs2_Pull$FailedScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  var e = this.Lfs2_Pull$FailedScope__f_err;
  return new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e);
});
$c_Lfs2_Pull$FailedScope.prototype.interruption__s_Option = (function() {
  return $m_s_None$();
});
function $as_Lfs2_Pull$FailedScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$FailedScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$FailedScope"));
}
function $isArrayOf_Lfs2_Pull$FailedScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$FailedScope)));
}
function $asArrayOf_Lfs2_Pull$FailedScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$FailedScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$FailedScope;", depth));
}
var $d_Lfs2_Pull$FailedScope = new $TypeData().initClass($c_Lfs2_Pull$FailedScope, "fs2.Pull$FailedScope", ({
  Lfs2_Pull$FailedScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lfs2_Pull$SucceedScope(scopeId) {
  this.Lfs2_Pull$SucceedScope__f_scopeId = null;
  this.Lfs2_Pull$SucceedScope__f_scopeId = scopeId;
}
$c_Lfs2_Pull$SucceedScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$SucceedScope.prototype.constructor = $c_Lfs2_Pull$SucceedScope;
/** @constructor */
function $h_Lfs2_Pull$SucceedScope() {
}
$h_Lfs2_Pull$SucceedScope.prototype = $c_Lfs2_Pull$SucceedScope.prototype;
$c_Lfs2_Pull$SucceedScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lfs2_Pull$SucceedScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lfs2_Pull$SucceedScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lfs2_Pull$SucceedScope)) {
    var x$0$2 = $as_Lfs2_Pull$SucceedScope(x$0);
    var x = this.Lfs2_Pull$SucceedScope__f_scopeId;
    var x$2 = $n(x$0$2).Lfs2_Pull$SucceedScope__f_scopeId;
    if ((x === null)) {
      return (x$2 === null);
    } else {
      var this$1 = $n(x);
      return (this$1 === x$2);
    }
  } else {
    return false;
  }
});
$c_Lfs2_Pull$SucceedScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lfs2_Pull$SucceedScope.prototype.productArity__I = (function() {
  return 1;
});
$c_Lfs2_Pull$SucceedScope.prototype.productPrefix__T = (function() {
  return "SucceedScope";
});
$c_Lfs2_Pull$SucceedScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$SucceedScope__f_scopeId;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lfs2_Pull$SucceedScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$SucceedScope__f_scopeId;
});
$c_Lfs2_Pull$SucceedScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  return $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
});
$c_Lfs2_Pull$SucceedScope.prototype.interruption__s_Option = (function() {
  return $m_s_None$();
});
function $as_Lfs2_Pull$SucceedScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$SucceedScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$SucceedScope"));
}
function $isArrayOf_Lfs2_Pull$SucceedScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$SucceedScope)));
}
function $asArrayOf_Lfs2_Pull$SucceedScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$SucceedScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$SucceedScope;", depth));
}
var $d_Lfs2_Pull$SucceedScope = new $TypeData().initClass($c_Lfs2_Pull$SucceedScope, "fs2.Pull$SucceedScope", ({
  Lfs2_Pull$SucceedScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lio_circe_CursorOp$DeleteGoParent$() {
}
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.constructor = $c_Lio_circe_CursorOp$DeleteGoParent$;
/** @constructor */
function $h_Lio_circe_CursorOp$DeleteGoParent$() {
}
$h_Lio_circe_CursorOp$DeleteGoParent$.prototype = $c_Lio_circe_CursorOp$DeleteGoParent$.prototype;
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.hashCode__I = (function() {
  return (-1822060899);
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.toString__T = (function() {
  return "DeleteGoParent";
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productPrefix__T = (function() {
  return "DeleteGoParent";
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lio_circe_CursorOp$DeleteGoParent$ = new $TypeData().initClass($c_Lio_circe_CursorOp$DeleteGoParent$, "io.circe.CursorOp$DeleteGoParent$", ({
  Lio_circe_CursorOp$DeleteGoParent$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lio_circe_CursorOp$DeleteGoParent$;
function $m_Lio_circe_CursorOp$DeleteGoParent$() {
  if ((!$n_Lio_circe_CursorOp$DeleteGoParent$)) {
    $n_Lio_circe_CursorOp$DeleteGoParent$ = new $c_Lio_circe_CursorOp$DeleteGoParent$();
  }
  return $n_Lio_circe_CursorOp$DeleteGoParent$;
}
/** @constructor */
function $c_Lio_circe_CursorOp$DownArray$() {
}
$c_Lio_circe_CursorOp$DownArray$.prototype = new $h_Lio_circe_CursorOp$ArrayOp();
$c_Lio_circe_CursorOp$DownArray$.prototype.constructor = $c_Lio_circe_CursorOp$DownArray$;
/** @constructor */
function $h_Lio_circe_CursorOp$DownArray$() {
}
$h_Lio_circe_CursorOp$DownArray$.prototype = $c_Lio_circe_CursorOp$DownArray$.prototype;
$c_Lio_circe_CursorOp$DownArray$.prototype.hashCode__I = (function() {
  return (-1017900361);
});
$c_Lio_circe_CursorOp$DownArray$.prototype.toString__T = (function() {
  return "DownArray";
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productPrefix__T = (function() {
  return "DownArray";
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lio_circe_CursorOp$DownArray$ = new $TypeData().initClass($c_Lio_circe_CursorOp$DownArray$, "io.circe.CursorOp$DownArray$", ({
  Lio_circe_CursorOp$DownArray$: 1,
  Lio_circe_CursorOp$ArrayOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lio_circe_CursorOp$DownArray$;
function $m_Lio_circe_CursorOp$DownArray$() {
  if ((!$n_Lio_circe_CursorOp$DownArray$)) {
    $n_Lio_circe_CursorOp$DownArray$ = new $c_Lio_circe_CursorOp$DownArray$();
  }
  return $n_Lio_circe_CursorOp$DownArray$;
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveLeft$() {
}
$c_Lio_circe_CursorOp$MoveLeft$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveLeft$.prototype.constructor = $c_Lio_circe_CursorOp$MoveLeft$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveLeft$() {
}
$h_Lio_circe_CursorOp$MoveLeft$.prototype = $c_Lio_circe_CursorOp$MoveLeft$.prototype;
$c_Lio_circe_CursorOp$MoveLeft$.prototype.hashCode__I = (function() {
  return (-40017000);
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.toString__T = (function() {
  return "MoveLeft";
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productPrefix__T = (function() {
  return "MoveLeft";
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lio_circe_CursorOp$MoveLeft$ = new $TypeData().initClass($c_Lio_circe_CursorOp$MoveLeft$, "io.circe.CursorOp$MoveLeft$", ({
  Lio_circe_CursorOp$MoveLeft$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lio_circe_CursorOp$MoveLeft$;
function $m_Lio_circe_CursorOp$MoveLeft$() {
  if ((!$n_Lio_circe_CursorOp$MoveLeft$)) {
    $n_Lio_circe_CursorOp$MoveLeft$ = new $c_Lio_circe_CursorOp$MoveLeft$();
  }
  return $n_Lio_circe_CursorOp$MoveLeft$;
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveRight$() {
}
$c_Lio_circe_CursorOp$MoveRight$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveRight$.prototype.constructor = $c_Lio_circe_CursorOp$MoveRight$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveRight$() {
}
$h_Lio_circe_CursorOp$MoveRight$.prototype = $c_Lio_circe_CursorOp$MoveRight$.prototype;
$c_Lio_circe_CursorOp$MoveRight$.prototype.hashCode__I = (function() {
  return (-1234866005);
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.toString__T = (function() {
  return "MoveRight";
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productPrefix__T = (function() {
  return "MoveRight";
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lio_circe_CursorOp$MoveRight$ = new $TypeData().initClass($c_Lio_circe_CursorOp$MoveRight$, "io.circe.CursorOp$MoveRight$", ({
  Lio_circe_CursorOp$MoveRight$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lio_circe_CursorOp$MoveRight$;
function $m_Lio_circe_CursorOp$MoveRight$() {
  if ((!$n_Lio_circe_CursorOp$MoveRight$)) {
    $n_Lio_circe_CursorOp$MoveRight$ = new $c_Lio_circe_CursorOp$MoveRight$();
  }
  return $n_Lio_circe_CursorOp$MoveRight$;
}
/** @constructor */
function $c_Lio_circe_CursorOp$MoveUp$() {
}
$c_Lio_circe_CursorOp$MoveUp$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveUp$.prototype.constructor = $c_Lio_circe_CursorOp$MoveUp$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveUp$() {
}
$h_Lio_circe_CursorOp$MoveUp$.prototype = $c_Lio_circe_CursorOp$MoveUp$.prototype;
$c_Lio_circe_CursorOp$MoveUp$.prototype.hashCode__I = (function() {
  return (-1984396692);
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.toString__T = (function() {
  return "MoveUp";
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productPrefix__T = (function() {
  return "MoveUp";
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lio_circe_CursorOp$MoveUp$ = new $TypeData().initClass($c_Lio_circe_CursorOp$MoveUp$, "io.circe.CursorOp$MoveUp$", ({
  Lio_circe_CursorOp$MoveUp$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
var $n_Lio_circe_CursorOp$MoveUp$;
function $m_Lio_circe_CursorOp$MoveUp$() {
  if ((!$n_Lio_circe_CursorOp$MoveUp$)) {
    $n_Lio_circe_CursorOp$MoveUp$ = new $c_Lio_circe_CursorOp$MoveUp$();
  }
  return $n_Lio_circe_CursorOp$MoveUp$;
}
/** @constructor */
function $c_Lio_circe_Decoder$() {
  this.Lio_circe_Decoder$__f_resultInstance = null;
  this.Lio_circe_Decoder$__f_decodeString = null;
  this.Lio_circe_Decoder$__f_decodeUnit = null;
  this.Lio_circe_Decoder$__f_decodeInt = null;
  this.Lio_circe_Decoder$__f_decodeLong = null;
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$rightNone = null;
  this.Lio_circe_Decoder$__f_keyMissingNone = null;
  $n_Lio_circe_Decoder$ = this;
  this.Lio_circe_Decoder$__f_resultInstance = ($m_Lcats_instances_package$either$(), new $c_Lcats_instances_EitherInstances$$anon$2());
  $m_Lcats_data_Validated$();
  $m_Lcats_data_NonEmptyList$().catsDataSemigroupForNonEmptyList__Lcats_kernel_Semigroup();
  $m_Lcats_instances_package$either$();
  this.Lio_circe_Decoder$__f_decodeString = new $c_Lio_circe_Decoder$$anon$19();
  this.Lio_circe_Decoder$__f_decodeUnit = new $c_Lio_circe_Decoder$$anon$20();
  this.Lio_circe_Decoder$__f_decodeInt = new $c_Lio_circe_Decoder$$anon$27();
  this.Lio_circe_Decoder$__f_decodeLong = new $c_Lio_circe_Decoder$$anon$28();
  var value = $m_s_None$();
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$rightNone = new $c_s_util_Right(value);
  $m_Lcats_data_Validated$();
  var value$1 = $m_s_None$();
  this.Lio_circe_Decoder$__f_keyMissingNone = new $c_s_util_Right(value$1);
  $m_Lcats_data_Validated$();
}
$c_Lio_circe_Decoder$.prototype = new $h_O();
$c_Lio_circe_Decoder$.prototype.constructor = $c_Lio_circe_Decoder$;
/** @constructor */
function $h_Lio_circe_Decoder$() {
}
$h_Lio_circe_Decoder$.prototype = $c_Lio_circe_Decoder$.prototype;
var $d_Lio_circe_Decoder$ = new $TypeData().initClass($c_Lio_circe_Decoder$, "io.circe.Decoder$", ({
  Lio_circe_Decoder$: 1,
  Lio_circe_DecoderDerivation: 1,
  Lio_circe_LowPriorityCollectionDecoders: 1,
  Lio_circe_CollectionDecoders: 1,
  Lio_circe_TupleDecoders: 1,
  Lio_circe_ProductDecoders: 1,
  Lio_circe_LiteralDecoders: 1,
  Lio_circe_EnumerationDecoders: 1,
  Lio_circe_LowPriorityDecoders: 1
}));
var $n_Lio_circe_Decoder$;
function $m_Lio_circe_Decoder$() {
  if ((!$n_Lio_circe_Decoder$)) {
    $n_Lio_circe_Decoder$ = new $c_Lio_circe_Decoder$();
  }
  return $n_Lio_circe_Decoder$;
}
/** @constructor */
function $c_Lio_circe_Encoder$() {
  this.Lio_circe_Encoder$__f_encodeJson = null;
  this.Lio_circe_Encoder$__f_encodeString = null;
  this.Lio_circe_Encoder$__f_encodeUnit = null;
  this.Lio_circe_Encoder$__f_encodeInt = null;
  this.Lio_circe_Encoder$__f_encodeLong = null;
  $n_Lio_circe_Encoder$ = this;
  this.Lio_circe_Encoder$__f_encodeJson = new $c_Lio_circe_Encoder$$anon$3();
  this.Lio_circe_Encoder$__f_encodeString = new $c_Lio_circe_Encoder$$anon$6();
  this.Lio_circe_Encoder$__f_encodeUnit = new $c_Lio_circe_Encoder$$anon$7();
  this.Lio_circe_Encoder$__f_encodeInt = new $c_Lio_circe_Encoder$$anon$14();
  this.Lio_circe_Encoder$__f_encodeLong = new $c_Lio_circe_Encoder$$anon$15();
}
$c_Lio_circe_Encoder$.prototype = new $h_O();
$c_Lio_circe_Encoder$.prototype.constructor = $c_Lio_circe_Encoder$;
/** @constructor */
function $h_Lio_circe_Encoder$() {
}
$h_Lio_circe_Encoder$.prototype = $c_Lio_circe_Encoder$.prototype;
var $d_Lio_circe_Encoder$ = new $TypeData().initClass($c_Lio_circe_Encoder$, "io.circe.Encoder$", ({
  Lio_circe_Encoder$: 1,
  Lio_circe_TupleEncoders: 1,
  Lio_circe_ProductEncoders: 1,
  Lio_circe_ProductTypedEncoders: 1,
  Lio_circe_LiteralEncoders: 1,
  Lio_circe_EnumerationEncoders: 1,
  Lio_circe_LowPriorityEncoders: 1,
  Lio_circe_MidPriorityEncoders: 1,
  Lio_circe_EncoderDerivationRelaxed: 1
}));
var $n_Lio_circe_Encoder$;
function $m_Lio_circe_Encoder$() {
  if ((!$n_Lio_circe_Encoder$)) {
    $n_Lio_circe_Encoder$ = new $c_Lio_circe_Encoder$();
  }
  return $n_Lio_circe_Encoder$;
}
function $ct_Ljava_time_DayOfWeek__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_DayOfWeek__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
/** @constructor */
function $c_Ljava_time_DayOfWeek() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
}
$c_Ljava_time_DayOfWeek.prototype = new $h_jl_Enum();
$c_Ljava_time_DayOfWeek.prototype.constructor = $c_Ljava_time_DayOfWeek;
/** @constructor */
function $h_Ljava_time_DayOfWeek() {
}
$h_Ljava_time_DayOfWeek.prototype = $c_Ljava_time_DayOfWeek.prototype;
$c_Ljava_time_DayOfWeek.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_DayOfWeek.prototype.getValue__I = (function() {
  return ((1 + this.Ljava_time_DayOfWeek__f_ordinal) | 0);
});
$c_Ljava_time_DayOfWeek.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return (field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  } else if ((field !== null)) {
    var this$1 = $n(field);
    return this.isSupported__Ljava_time_temporal_TemporalField__Z(this$1);
  } else {
    return false;
  }
});
$c_Ljava_time_DayOfWeek.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    var this$1 = $n(field);
    return this$1.Ljava_time_temporal_ChronoField__f__range;
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var this$2 = $n(field);
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$2);
  }
});
$c_Ljava_time_DayOfWeek.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    return this.getValue__I();
  } else {
    var $x_2 = $n(this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field));
    var $x_1 = this.getLong__Ljava_time_temporal_TemporalField__J(field);
    return $x_2.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($x_1.l, $x_1.h, field);
  }
});
$c_Ljava_time_DayOfWeek.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    var value = this.getValue__I();
    var hi = (value >> 31);
    return $bL(value, hi);
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var this$2 = $n(field);
    return this.getLong__Ljava_time_temporal_TemporalField__J(this$2);
  }
});
$c_Ljava_time_DayOfWeek.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)));
});
var $d_Ljava_time_DayOfWeek = new $TypeData().initClass(0, "java.time.DayOfWeek", ({
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
}));
function $ct_Ljava_time_Month__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_Month__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
/** @constructor */
function $c_Ljava_time_Month() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
}
$c_Ljava_time_Month.prototype = new $h_jl_Enum();
$c_Ljava_time_Month.prototype.constructor = $c_Ljava_time_Month;
/** @constructor */
function $h_Ljava_time_Month() {
}
$h_Ljava_time_Month.prototype = $c_Ljava_time_Month.prototype;
$c_Ljava_time_Month.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_Month.prototype.getValue__I = (function() {
  return ((1 + this.Ljava_time_Month__f_ordinal) | 0);
});
$c_Ljava_time_Month.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return (field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
  } else if ((field !== null)) {
    var this$1 = $n(field);
    return this.isSupported__Ljava_time_temporal_TemporalField__Z(this$1);
  } else {
    return false;
  }
});
$c_Ljava_time_Month.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    var this$1 = $n(field);
    return this$1.Ljava_time_temporal_ChronoField__f__range;
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var this$2 = $n(field);
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$2);
  }
});
$c_Ljava_time_Month.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    return this.getValue__I();
  } else {
    var $x_2 = $n(this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field));
    var $x_1 = this.getLong__Ljava_time_temporal_TemporalField__J(field);
    return $x_2.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($x_1.l, $x_1.h, field);
  }
});
$c_Ljava_time_Month.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    var value = this.getValue__I();
    var hi = (value >> 31);
    return $bL(value, hi);
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var this$2 = $n(field);
    return this.getLong__Ljava_time_temporal_TemporalField__J(this$2);
  }
});
$c_Ljava_time_Month.prototype.plus__J__Ljava_time_Month = (function(months_$_lo, months_$_hi) {
  var hi = (months_$_hi >> 31);
  var b0 = (65535 & months_$_lo);
  var b1 = ((months_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(43690, b0);
  var a1b0 = Math.imul(10922, b0);
  var a0b1 = Math.imul(43690, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((Math.imul(10922, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var b0$1 = (65535 & months_$_lo);
  var b1$1 = ((months_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(43691, b0$1);
  var a1b0$1 = Math.imul(43690, b0$1);
  var a0b1$1 = Math.imul(43691, b1$1);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$2 = ((((Math.imul(43690, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((lo + hi$2) | 0);
  var hi$3 = ((hi$1 + ((((lo & hi$2) | ((lo | hi$2) & (~lo$2))) >>> 31) | 0)) | 0);
  var b0$2 = (65535 & months_$_hi);
  var b1$2 = ((months_$_hi >>> 16) | 0);
  var a0b0$2 = Math.imul(43690, b0$2);
  var a1b0$2 = Math.imul(10922, b0$2);
  var a0b1$2 = Math.imul(43690, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$4 = ((((((Math.imul(715827882, hi) + Math.imul(10922, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var hi$5 = (hi$3 >> 31);
  var lo$4 = ((lo$3 + hi$3) | 0);
  var hi$6 = ((((hi$4 + hi$5) | 0) + ((((lo$3 & hi$3) | ((lo$3 | hi$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var b0$3 = (65535 & months_$_hi);
  var b1$3 = ((months_$_hi >>> 16) | 0);
  var a0b0$3 = Math.imul(43691, b0$3);
  var a1b0$3 = Math.imul(43690, b0$3);
  var a0b1$3 = Math.imul(43691, b1$3);
  var lo$5 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$7 = ((((((Math.imul((-1431655765), hi) + Math.imul(43690, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((lo$2 + lo$5) | 0);
  var hi$8 = ((hi$7 + ((((lo$2 & lo$5) | ((lo$2 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 >> 31);
  var lo$7 = ((lo$4 + hi$8) | 0);
  var hi$10 = ((((hi$6 + hi$9) | 0) + ((((lo$4 & hi$8) | ((lo$4 | hi$8) & (~lo$7))) >>> 31) | 0)) | 0);
  var lo$8 = (((lo$7 >>> 1) | 0) | (hi$10 << 31));
  var lo$9 = ((months_$_hi >>> 31) | 0);
  var lo$10 = ((lo$8 + lo$9) | 0);
  var b0$4 = (65535 & lo$10);
  var b1$4 = ((lo$10 >>> 16) | 0);
  var a0b0$4 = Math.imul(12, b0$4);
  var a0b1$4 = Math.imul(12, b1$4);
  var lo$11 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
  var lo$12 = ((months_$_lo - lo$11) | 0);
  return $n($m_Ljava_time_Month$().java$time$Month$$$ENUMS__ALjava_time_Month()).get(((((this.Ljava_time_Month__f_ordinal + ((12 + lo$12) | 0)) | 0) % 12) | 0));
});
$c_Ljava_time_Month.prototype.length__Z__I = (function(leapYear) {
  var x = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $x_1 = (this$1 === this);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return (leapYear ? 29 : 28);
  }
  matchAlts1: {
    matchAlts2: {
      var x$3 = $s_Ljava_time_Month$__APRIL__Ljava_time_Month();
      if ((x$3 !== null)) {
        var this$2 = $n(x$3);
        var $x_2 = (this$2 === this);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        break matchAlts2;
      }
      var x$5 = $s_Ljava_time_Month$__JUNE__Ljava_time_Month();
      if ((x$5 !== null)) {
        var this$3 = $n(x$5);
        var $x_3 = (this$3 === this);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        break matchAlts2;
      }
      var x$7 = $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month();
      if ((x$7 !== null)) {
        var this$4 = $n(x$7);
        var $x_4 = (this$4 === this);
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        break matchAlts2;
      }
      var x$9 = $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month();
      if ((x$9 !== null)) {
        var this$5 = $n(x$9);
        var $x_5 = (this$5 === this);
      } else {
        var $x_5 = false;
      }
      if ($x_5) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return 30;
  }
  return 31;
});
$c_Ljava_time_Month.prototype.firstDayOfYear__Z__I = (function(leapYear) {
  var leap = (leapYear ? 1 : 0);
  var x = $s_Ljava_time_Month$__JANUARY__Ljava_time_Month();
  if ((x !== null)) {
    var this$1 = $n(x);
    var $x_1 = (this$1 === this);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return 1;
  }
  var x$3 = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
  if ((x$3 !== null)) {
    var this$2 = $n(x$3);
    var $x_2 = (this$2 === this);
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    return 32;
  }
  var x$5 = $s_Ljava_time_Month$__MARCH__Ljava_time_Month();
  if ((x$5 !== null)) {
    var this$3 = $n(x$5);
    var $x_3 = (this$3 === this);
  } else {
    var $x_3 = false;
  }
  if ($x_3) {
    return ((60 + leap) | 0);
  }
  var x$7 = $s_Ljava_time_Month$__APRIL__Ljava_time_Month();
  if ((x$7 !== null)) {
    var this$4 = $n(x$7);
    var $x_4 = (this$4 === this);
  } else {
    var $x_4 = false;
  }
  if ($x_4) {
    return ((91 + leap) | 0);
  }
  var x$9 = $s_Ljava_time_Month$__MAY__Ljava_time_Month();
  if ((x$9 !== null)) {
    var this$5 = $n(x$9);
    var $x_5 = (this$5 === this);
  } else {
    var $x_5 = false;
  }
  if ($x_5) {
    return ((121 + leap) | 0);
  }
  var x$11 = $s_Ljava_time_Month$__JUNE__Ljava_time_Month();
  if ((x$11 !== null)) {
    var this$6 = $n(x$11);
    var $x_6 = (this$6 === this);
  } else {
    var $x_6 = false;
  }
  if ($x_6) {
    return ((152 + leap) | 0);
  }
  var x$13 = $s_Ljava_time_Month$__JULY__Ljava_time_Month();
  if ((x$13 !== null)) {
    var this$7 = $n(x$13);
    var $x_7 = (this$7 === this);
  } else {
    var $x_7 = false;
  }
  if ($x_7) {
    return ((182 + leap) | 0);
  }
  var x$15 = $s_Ljava_time_Month$__AUGUST__Ljava_time_Month();
  if ((x$15 !== null)) {
    var this$8 = $n(x$15);
    var $x_8 = (this$8 === this);
  } else {
    var $x_8 = false;
  }
  if ($x_8) {
    return ((213 + leap) | 0);
  }
  var x$17 = $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month();
  if ((x$17 !== null)) {
    var this$9 = $n(x$17);
    var $x_9 = (this$9 === this);
  } else {
    var $x_9 = false;
  }
  if ($x_9) {
    return ((244 + leap) | 0);
  }
  var x$19 = $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month();
  if ((x$19 !== null)) {
    var this$10 = $n(x$19);
    var $x_10 = (this$10 === this);
  } else {
    var $x_10 = false;
  }
  if ($x_10) {
    return ((274 + leap) | 0);
  }
  var x$21 = $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month();
  if ((x$21 !== null)) {
    var this$11 = $n(x$21);
    var $x_11 = (this$11 === this);
  } else {
    var $x_11 = false;
  }
  if ($x_11) {
    return ((305 + leap) | 0);
  }
  var x$23 = $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month();
  if ((x$23 !== null)) {
    var this$12 = $n(x$23);
    var $x_12 = (this$12 === this);
  } else {
    var $x_12 = false;
  }
  if ($x_12) {
    return ((335 + leap) | 0);
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_Month.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology() : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit() : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : $n(query).queryFrom__Ljava_time_temporal_TemporalAccessor__O(this))));
});
var $d_Ljava_time_Month = new $TypeData().initClass(0, "java.time.Month", ({
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
}));
/** @constructor */
function $c_sc_AbstractView() {
}
$c_sc_AbstractView.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractView.prototype.constructor = $c_sc_AbstractView;
/** @constructor */
function $h_sc_AbstractView() {
}
$h_sc_AbstractView.prototype = $c_sc_AbstractView.prototype;
$c_sc_AbstractView.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$();
});
$c_sc_AbstractView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_AbstractView.prototype.stringPrefix__T = (function() {
  return "View";
});
/** @constructor */
function $c_sc_MapOps$$anon$1(outer) {
  this.sc_MapOps$$anon$1__f_$outer = null;
  $n(outer);
  this.sc_MapOps$$anon$1__f_$outer = outer;
}
$c_sc_MapOps$$anon$1.prototype = new $h_sc_AbstractIterable();
$c_sc_MapOps$$anon$1.prototype.constructor = $c_sc_MapOps$$anon$1;
/** @constructor */
function $h_sc_MapOps$$anon$1() {
}
$h_sc_MapOps$$anon$1.prototype = $c_sc_MapOps$$anon$1.prototype;
$c_sc_MapOps$$anon$1.prototype.knownSize__I = (function() {
  return $n(this.sc_MapOps$$anon$1__f_$outer).knownSize__I();
});
$c_sc_MapOps$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_MapOps$$anon$1__f_$outer).valuesIterator__sc_Iterator();
});
var $d_sc_MapOps$$anon$1 = new $TypeData().initClass($c_sc_MapOps$$anon$1, "scala.collection.MapOps$$anon$1", ({
  sc_MapOps$$anon$1: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $f_sc_Set__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  } else {
    if ($is_sc_Set(that)) {
      var x2 = $as_sc_Set(that);
      if (($n(x2), true)) {
        if (($thiz.size__I() === $n(x2).size__I())) {
          try {
            return $thiz.subsetOf__sc_Set__Z(x2);
          } catch (e) {
            if ((e instanceof $c_jl_ClassCastException)) {
              return false;
            } else {
              throw e;
            }
          }
        } else {
          return false;
        }
      }
    }
    return false;
  }
}
function $is_sc_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Set)));
}
function $as_sc_Set(obj) {
  return (($is_sc_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Set"));
}
function $isArrayOf_sc_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Set)));
}
function $asArrayOf_sc_Set(obj, depth) {
  return (($isArrayOf_sc_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Set;", depth));
}
function $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps($thiz, that) {
  var result = $as_sci_SetOps($thiz);
  var it = $n(that).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var this$1 = $n(result);
    var elem = $n(it).next__O();
    result = this$1.incl__O__sci_SetOps(elem);
  }
  return result;
}
function $is_s_math_Numeric$BigDecimalAsIfIntegral(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Numeric$BigDecimalAsIfIntegral)));
}
function $as_s_math_Numeric$BigDecimalAsIfIntegral(obj) {
  return (($is_s_math_Numeric$BigDecimalAsIfIntegral(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Numeric$BigDecimalAsIfIntegral"));
}
function $isArrayOf_s_math_Numeric$BigDecimalAsIfIntegral(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Numeric$BigDecimalAsIfIntegral)));
}
function $asArrayOf_s_math_Numeric$BigDecimalAsIfIntegral(obj, depth) {
  return (($isArrayOf_s_math_Numeric$BigDecimalAsIfIntegral(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Numeric$BigDecimalAsIfIntegral;", depth));
}
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Any";
}
$c_s_reflect_ManifestFactory$AnyManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$AnyManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyManifest$() {
}
$h_s_reflect_ManifestFactory$AnyManifest$.prototype = $c_s_reflect_ManifestFactory$AnyManifest$.prototype;
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf();
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$AnyManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$AnyManifest$, "scala.reflect.ManifestFactory$AnyManifest$", ({
  s_reflect_ManifestFactory$AnyManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$AnyManifest$;
function $m_s_reflect_ManifestFactory$AnyManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyManifest$)) {
    $n_s_reflect_ManifestFactory$AnyManifest$ = new $c_s_reflect_ManifestFactory$AnyManifest$();
  }
  return $n_s_reflect_ManifestFactory$AnyManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Boolean";
}
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype = new $h_s_reflect_ManifestFactory$BooleanManifest();
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest$() {
}
$h_s_reflect_ManifestFactory$BooleanManifest$.prototype = $c_s_reflect_ManifestFactory$BooleanManifest$.prototype;
var $d_s_reflect_ManifestFactory$BooleanManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$BooleanManifest$, "scala.reflect.ManifestFactory$BooleanManifest$", ({
  s_reflect_ManifestFactory$BooleanManifest$: 1,
  s_reflect_ManifestFactory$BooleanManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$BooleanManifest$;
function $m_s_reflect_ManifestFactory$BooleanManifest$() {
  if ((!$n_s_reflect_ManifestFactory$BooleanManifest$)) {
    $n_s_reflect_ManifestFactory$BooleanManifest$ = new $c_s_reflect_ManifestFactory$BooleanManifest$();
  }
  return $n_s_reflect_ManifestFactory$BooleanManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Byte";
}
$c_s_reflect_ManifestFactory$ByteManifest$.prototype = new $h_s_reflect_ManifestFactory$ByteManifest();
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest$() {
}
$h_s_reflect_ManifestFactory$ByteManifest$.prototype = $c_s_reflect_ManifestFactory$ByteManifest$.prototype;
var $d_s_reflect_ManifestFactory$ByteManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$ByteManifest$, "scala.reflect.ManifestFactory$ByteManifest$", ({
  s_reflect_ManifestFactory$ByteManifest$: 1,
  s_reflect_ManifestFactory$ByteManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$ByteManifest$;
function $m_s_reflect_ManifestFactory$ByteManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ByteManifest$)) {
    $n_s_reflect_ManifestFactory$ByteManifest$ = new $c_s_reflect_ManifestFactory$ByteManifest$();
  }
  return $n_s_reflect_ManifestFactory$ByteManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Char";
}
$c_s_reflect_ManifestFactory$CharManifest$.prototype = new $h_s_reflect_ManifestFactory$CharManifest();
$c_s_reflect_ManifestFactory$CharManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest$() {
}
$h_s_reflect_ManifestFactory$CharManifest$.prototype = $c_s_reflect_ManifestFactory$CharManifest$.prototype;
var $d_s_reflect_ManifestFactory$CharManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$CharManifest$, "scala.reflect.ManifestFactory$CharManifest$", ({
  s_reflect_ManifestFactory$CharManifest$: 1,
  s_reflect_ManifestFactory$CharManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$CharManifest$;
function $m_s_reflect_ManifestFactory$CharManifest$() {
  if ((!$n_s_reflect_ManifestFactory$CharManifest$)) {
    $n_s_reflect_ManifestFactory$CharManifest$ = new $c_s_reflect_ManifestFactory$CharManifest$();
  }
  return $n_s_reflect_ManifestFactory$CharManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Double";
}
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype = new $h_s_reflect_ManifestFactory$DoubleManifest();
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest$() {
}
$h_s_reflect_ManifestFactory$DoubleManifest$.prototype = $c_s_reflect_ManifestFactory$DoubleManifest$.prototype;
var $d_s_reflect_ManifestFactory$DoubleManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$DoubleManifest$, "scala.reflect.ManifestFactory$DoubleManifest$", ({
  s_reflect_ManifestFactory$DoubleManifest$: 1,
  s_reflect_ManifestFactory$DoubleManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$DoubleManifest$;
function $m_s_reflect_ManifestFactory$DoubleManifest$() {
  if ((!$n_s_reflect_ManifestFactory$DoubleManifest$)) {
    $n_s_reflect_ManifestFactory$DoubleManifest$ = new $c_s_reflect_ManifestFactory$DoubleManifest$();
  }
  return $n_s_reflect_ManifestFactory$DoubleManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Float";
}
$c_s_reflect_ManifestFactory$FloatManifest$.prototype = new $h_s_reflect_ManifestFactory$FloatManifest();
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest$() {
}
$h_s_reflect_ManifestFactory$FloatManifest$.prototype = $c_s_reflect_ManifestFactory$FloatManifest$.prototype;
var $d_s_reflect_ManifestFactory$FloatManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$FloatManifest$, "scala.reflect.ManifestFactory$FloatManifest$", ({
  s_reflect_ManifestFactory$FloatManifest$: 1,
  s_reflect_ManifestFactory$FloatManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$FloatManifest$;
function $m_s_reflect_ManifestFactory$FloatManifest$() {
  if ((!$n_s_reflect_ManifestFactory$FloatManifest$)) {
    $n_s_reflect_ManifestFactory$FloatManifest$ = new $c_s_reflect_ManifestFactory$FloatManifest$();
  }
  return $n_s_reflect_ManifestFactory$FloatManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Int";
}
$c_s_reflect_ManifestFactory$IntManifest$.prototype = new $h_s_reflect_ManifestFactory$IntManifest();
$c_s_reflect_ManifestFactory$IntManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest$() {
}
$h_s_reflect_ManifestFactory$IntManifest$.prototype = $c_s_reflect_ManifestFactory$IntManifest$.prototype;
var $d_s_reflect_ManifestFactory$IntManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$IntManifest$, "scala.reflect.ManifestFactory$IntManifest$", ({
  s_reflect_ManifestFactory$IntManifest$: 1,
  s_reflect_ManifestFactory$IntManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$IntManifest$;
function $m_s_reflect_ManifestFactory$IntManifest$() {
  if ((!$n_s_reflect_ManifestFactory$IntManifest$)) {
    $n_s_reflect_ManifestFactory$IntManifest$ = new $c_s_reflect_ManifestFactory$IntManifest$();
  }
  return $n_s_reflect_ManifestFactory$IntManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Long";
}
$c_s_reflect_ManifestFactory$LongManifest$.prototype = new $h_s_reflect_ManifestFactory$LongManifest();
$c_s_reflect_ManifestFactory$LongManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest$() {
}
$h_s_reflect_ManifestFactory$LongManifest$.prototype = $c_s_reflect_ManifestFactory$LongManifest$.prototype;
var $d_s_reflect_ManifestFactory$LongManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$LongManifest$, "scala.reflect.ManifestFactory$LongManifest$", ({
  s_reflect_ManifestFactory$LongManifest$: 1,
  s_reflect_ManifestFactory$LongManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$LongManifest$;
function $m_s_reflect_ManifestFactory$LongManifest$() {
  if ((!$n_s_reflect_ManifestFactory$LongManifest$)) {
    $n_s_reflect_ManifestFactory$LongManifest$ = new $c_s_reflect_ManifestFactory$LongManifest$();
  }
  return $n_s_reflect_ManifestFactory$LongManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NothingManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Nothing";
}
$c_s_reflect_ManifestFactory$NothingManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NothingManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NothingManifest$() {
}
$h_s_reflect_ManifestFactory$NothingManifest$.prototype = $c_s_reflect_ManifestFactory$NothingManifest$.prototype;
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Nothing$.getClassOf();
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$NothingManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$NothingManifest$, "scala.reflect.ManifestFactory$NothingManifest$", ({
  s_reflect_ManifestFactory$NothingManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$NothingManifest$;
function $m_s_reflect_ManifestFactory$NothingManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NothingManifest$)) {
    $n_s_reflect_ManifestFactory$NothingManifest$ = new $c_s_reflect_ManifestFactory$NothingManifest$();
  }
  return $n_s_reflect_ManifestFactory$NothingManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NullManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Null";
}
$c_s_reflect_ManifestFactory$NullManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NullManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NullManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NullManifest$() {
}
$h_s_reflect_ManifestFactory$NullManifest$.prototype = $c_s_reflect_ManifestFactory$NullManifest$.prototype;
$c_s_reflect_ManifestFactory$NullManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Null$.getClassOf();
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$NullManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$NullManifest$, "scala.reflect.ManifestFactory$NullManifest$", ({
  s_reflect_ManifestFactory$NullManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$NullManifest$;
function $m_s_reflect_ManifestFactory$NullManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NullManifest$)) {
    $n_s_reflect_ManifestFactory$NullManifest$ = new $c_s_reflect_ManifestFactory$NullManifest$();
  }
  return $n_s_reflect_ManifestFactory$NullManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ObjectManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Object";
}
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ObjectManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ObjectManifest$() {
}
$h_s_reflect_ManifestFactory$ObjectManifest$.prototype = $c_s_reflect_ManifestFactory$ObjectManifest$.prototype;
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf();
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$ObjectManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$ObjectManifest$, "scala.reflect.ManifestFactory$ObjectManifest$", ({
  s_reflect_ManifestFactory$ObjectManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$ObjectManifest$;
function $m_s_reflect_ManifestFactory$ObjectManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ObjectManifest$)) {
    $n_s_reflect_ManifestFactory$ObjectManifest$ = new $c_s_reflect_ManifestFactory$ObjectManifest$();
  }
  return $n_s_reflect_ManifestFactory$ObjectManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Short";
}
$c_s_reflect_ManifestFactory$ShortManifest$.prototype = new $h_s_reflect_ManifestFactory$ShortManifest();
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest$() {
}
$h_s_reflect_ManifestFactory$ShortManifest$.prototype = $c_s_reflect_ManifestFactory$ShortManifest$.prototype;
var $d_s_reflect_ManifestFactory$ShortManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$ShortManifest$, "scala.reflect.ManifestFactory$ShortManifest$", ({
  s_reflect_ManifestFactory$ShortManifest$: 1,
  s_reflect_ManifestFactory$ShortManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$ShortManifest$;
function $m_s_reflect_ManifestFactory$ShortManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ShortManifest$)) {
    $n_s_reflect_ManifestFactory$ShortManifest$ = new $c_s_reflect_ManifestFactory$ShortManifest$();
  }
  return $n_s_reflect_ManifestFactory$ShortManifest$;
}
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Unit";
}
$c_s_reflect_ManifestFactory$UnitManifest$.prototype = new $h_s_reflect_ManifestFactory$UnitManifest();
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest$() {
}
$h_s_reflect_ManifestFactory$UnitManifest$.prototype = $c_s_reflect_ManifestFactory$UnitManifest$.prototype;
var $d_s_reflect_ManifestFactory$UnitManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$UnitManifest$, "scala.reflect.ManifestFactory$UnitManifest$", ({
  s_reflect_ManifestFactory$UnitManifest$: 1,
  s_reflect_ManifestFactory$UnitManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
var $n_s_reflect_ManifestFactory$UnitManifest$;
function $m_s_reflect_ManifestFactory$UnitManifest$() {
  if ((!$n_s_reflect_ManifestFactory$UnitManifest$)) {
    $n_s_reflect_ManifestFactory$UnitManifest$ = new $c_s_reflect_ManifestFactory$UnitManifest$();
  }
  return $n_s_reflect_ManifestFactory$UnitManifest$;
}
function $f_Lcats_ApplicativeError__handleError__O__F1__O($thiz, fa, f) {
  return $thiz.handleErrorWith__O__F1__O(fa, $n(f).andThen__F1__F1(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => $thiz.pure__O__O(x)))));
}
function $f_Lcats_ApplicativeError__voidError__O__O($thiz, fu) {
  return $thiz.handleError__O__F1__O(fu, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((y) => (void 0))));
}
function $f_Lcats_ApplicativeError__attempt__O__O($thiz, fa) {
  return $thiz.handleErrorWith__O__F1__O($thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => new $c_s_util_Right(_$2)))), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => $thiz.pure__O__O(new $c_s_util_Left(e)))));
}
function $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O($thiz, fa, pf) {
  return $thiz.handleErrorWith__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => $n($n(pf).andThen__F1__s_PartialFunction(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => $thiz.map2__O__O__F2__O(_$6, $thiz.raiseError__O__O(e), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$7, b) => {
    $as_jl_Void(_$7);
    return b;
  }))))))).applyOrElse__O__F1__O(e, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e$3) => $thiz.raiseError__O__O(e$3)))))));
}
/** @constructor */
function $c_Lcats_data_AndThenInstances0$$anon$1() {
  $m_Lcats_instances_package$all$();
}
$c_Lcats_data_AndThenInstances0$$anon$1.prototype = new $h_O();
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.constructor = $c_Lcats_data_AndThenInstances0$$anon$1;
/** @constructor */
function $h_Lcats_data_AndThenInstances0$$anon$1() {
}
$h_Lcats_data_AndThenInstances0$$anon$1.prototype = $c_Lcats_data_AndThenInstances0$$anon$1.prototype;
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.id__O = (function() {
  return $f_Lcats_arrow_Arrow__id__O(this);
});
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.lift__F1__O = (function(f) {
  return $m_Lcats_data_AndThen$().apply__F1__Lcats_data_AndThen(f);
});
$c_Lcats_data_AndThenInstances0$$anon$1.prototype.compose__O__O__O = (function(f, g) {
  var f$1 = $as_Lcats_data_AndThen(f);
  var g$1 = $as_Lcats_data_AndThen(g);
  return $m_Lcats_data_AndThen$().andThen__Lcats_data_AndThen__Lcats_data_AndThen__Lcats_data_AndThen(g$1, f$1);
});
var $d_Lcats_data_AndThenInstances0$$anon$1 = new $TypeData().initClass($c_Lcats_data_AndThenInstances0$$anon$1, "cats.data.AndThenInstances0$$anon$1", ({
  Lcats_data_AndThenInstances0$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_CommutativeArrow: 1
}));
/** @constructor */
function $c_Lcats_data_KleisliInstances0\uff3f5() {
}
$c_Lcats_data_KleisliInstances0\uff3f5.prototype = new $h_Lcats_data_KleisliInstances1();
$c_Lcats_data_KleisliInstances0\uff3f5.prototype.constructor = $c_Lcats_data_KleisliInstances0\uff3f5;
/** @constructor */
function $h_Lcats_data_KleisliInstances0\uff3f5() {
}
$h_Lcats_data_KleisliInstances0\uff3f5.prototype = $c_Lcats_data_KleisliInstances0\uff3f5.prototype;
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$6() {
}
$c_Lcats_instances_Function1Instances$$anon$6.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$6.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$6;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$6() {
}
$h_Lcats_instances_Function1Instances$$anon$6.prototype = $c_Lcats_instances_Function1Instances$$anon$6.prototype;
$c_Lcats_instances_Function1Instances$$anon$6.prototype.id__O = (function() {
  return $f_Lcats_arrow_Arrow__id__O(this);
});
$c_Lcats_instances_Function1Instances$$anon$6.prototype.lift__F1__O = (function(f) {
  return f;
});
$c_Lcats_instances_Function1Instances$$anon$6.prototype.compose__O__O__O = (function(f, g) {
  var f$1 = $as_F1(f);
  var g$1 = $as_F1(g);
  return $n(f$1).compose__F1__F1(g$1);
});
var $d_Lcats_instances_Function1Instances$$anon$6 = new $TypeData().initClass($c_Lcats_instances_Function1Instances$$anon$6, "cats.instances.Function1Instances$$anon$6", ({
  Lcats_instances_Function1Instances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_CommutativeArrow: 1
}));
function $ct_ju_ArrayList__O__I__($thiz, innerInit, _size) {
  $thiz.ju_ArrayList__f__size = _size;
  $thiz.ju_ArrayList__f_innerJS = innerInit;
  $thiz.ju_ArrayList__f_innerWasm = null;
  return $thiz;
}
function $ct_ju_ArrayList__I__($thiz, initialCapacity) {
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  $ct_ju_ArrayList__O__I__($thiz, [], 0);
  return $thiz;
}
function $ct_ju_ArrayList__($thiz) {
  $ct_ju_ArrayList__I__($thiz, 16);
  return $thiz;
}
/** @constructor */
function $c_ju_ArrayList() {
  this.ju_ArrayList__f__size = 0;
  this.ju_ArrayList__f_innerJS = null;
  this.ju_ArrayList__f_innerWasm = null;
}
$c_ju_ArrayList.prototype = new $h_ju_AbstractList();
$c_ju_ArrayList.prototype.constructor = $c_ju_ArrayList;
/** @constructor */
function $h_ju_ArrayList() {
}
$h_ju_ArrayList.prototype = $c_ju_ArrayList.prototype;
$c_ju_ArrayList.prototype.size__I = (function() {
  return $uI(this.ju_ArrayList__f_innerJS.length);
});
$c_ju_ArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  return this.ju_ArrayList__f_innerJS[index];
});
$c_ju_ArrayList.prototype.add__O__Z = (function(e) {
  $uI(this.ju_ArrayList__f_innerJS.push(e));
  return true;
});
$c_ju_ArrayList.prototype.add__I__O__V = (function(index, element) {
  this.checkIndexOnBounds__I__V(index);
  this.ju_ArrayList__f_innerJS.splice(index, 0, element);
});
$c_ju_ArrayList.prototype.remove__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  var array = this.ju_ArrayList__f_innerJS;
  return array.splice(index, 1)[0];
});
var $d_ju_ArrayList = new $TypeData().initClass($c_ju_ArrayList, "java.util.ArrayList", ({
  ju_ArrayList: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_SequencedCollection: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_ju_Collections$UnmodifiableList__ju_List__($thiz, inner) {
  $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner);
  return $thiz;
}
/** @constructor */
function $c_ju_Collections$UnmodifiableList() {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
}
$c_ju_Collections$UnmodifiableList.prototype = new $h_ju_Collections$UnmodifiableCollection();
$c_ju_Collections$UnmodifiableList.prototype.constructor = $c_ju_Collections$UnmodifiableList;
/** @constructor */
function $h_ju_Collections$UnmodifiableList() {
}
$h_ju_Collections$UnmodifiableList.prototype = $c_ju_Collections$UnmodifiableList.prototype;
$c_ju_Collections$UnmodifiableList.prototype.get__I__O = (function(index) {
  return $n($as_ju_List(this.ju_Collections$UnmodifiableCollection__f_inner)).get__I__O(index);
});
$c_ju_Collections$UnmodifiableList.prototype.equals__O__Z = (function(obj) {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).equals__O__Z(obj);
});
$c_ju_Collections$UnmodifiableList.prototype.hashCode__I = (function() {
  return $n(this.ju_Collections$UnmodifiableCollection__f_inner).hashCode__I();
});
$c_ju_Collections$UnmodifiableList.prototype.remove__I__O = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_Collections$UnmodifiableList.prototype.listIterator__ju_ListIterator = (function() {
  return new $c_ju_Collections$UnmodifiableListIterator($n($as_ju_List(this.ju_Collections$UnmodifiableCollection__f_inner)).listIterator__ju_ListIterator());
});
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6(\u03b4name$6, _$ordinal$6) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6__f_$name$3 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6__f_$name$3 = \u03b4name$6;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6.prototype.productPrefix__T = (function() {
  return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6__f_$name$3;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6.prototype.toString__T = (function() {
  return this.Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6__f_$name$3;
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6 = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6, "net.andimiller.hedgehogs.dag.visitor.Msg$$anon$6", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Msg$$anon$6: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Msg: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1(\u03b4name$4, _$ordinal$4) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1__f_$name$1 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1__f_$name$1 = \u03b4name$4;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_Node();
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1__f_$name$1;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1.prototype.toString__T = (function() {
  return this.Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1__f_$name$1;
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1 = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1, "net.andimiller.hedgehogs.dag.visitor.Node$$anon$1", ({
  Lnet_andimiller_hedgehogs_dag_visitor_Node$$anon$1: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_Node: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3(\u03b4name$5, _$ordinal$5) {
  this.Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3__f_$name$2 = null;
  this.Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3__f_$name$2 = \u03b4name$5;
}
$c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3.prototype = new $h_Lnet_andimiller_hedgehogs_dag_visitor_State();
$c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3.prototype.constructor = $c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3;
/** @constructor */
function $h_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3() {
}
$h_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3.prototype = $c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3.prototype;
$c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3.prototype.productPrefix__T = (function() {
  return this.Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3__f_$name$2;
});
$c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3.prototype.toString__T = (function() {
  return this.Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3__f_$name$2;
});
var $d_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3 = new $TypeData().initClass($c_Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3, "net.andimiller.hedgehogs.dag.visitor.State$$anon$3", ({
  Lnet_andimiller_hedgehogs_dag_visitor_State$$anon$3: 1,
  Lnet_andimiller_hedgehogs_dag_visitor_State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
function $f_sc_Seq__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else {
    if ($is_sc_Seq(o)) {
      var x2 = $as_sc_Seq(o);
      if ($n(x2).canEqual__O__Z($thiz)) {
        return $thiz.sameElements__sc_IterableOnce__Z(x2);
      }
    }
    return false;
  }
}
function $is_sc_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Seq)));
}
function $as_sc_Seq(obj) {
  return (($is_sc_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Seq"));
}
function $isArrayOf_sc_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Seq)));
}
function $asArrayOf_sc_Seq(obj, depth) {
  return (($isArrayOf_sc_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Seq;", depth));
}
function $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq($thiz) {
  if ((!$thiz.sc_SeqView$Sorted__f_bitmap$0)) {
    var len = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
    if ((len === 0)) {
      var res = $m_sci_Nil$();
    } else if ((len === 1)) {
      var x0 = $n($thiz.sc_SeqView$Sorted__f_underlying).head__O();
      var array = [x0];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var res = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    } else {
      var arr = new $ac_O(len);
      var this$5 = $n($thiz.sc_SeqView$Sorted__f_underlying);
      this$5.copyToArray__O__I__I__I(arr, 0, 2147483647);
      var comparator = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
      $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, comparator);
      var res = $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(arr);
    }
    $thiz.sc_SeqView$Sorted__f_evaluated = true;
    $thiz.sc_SeqView$Sorted__f_underlying = null;
    $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = res;
    $thiz.sc_SeqView$Sorted__f_bitmap$0 = true;
  }
  return $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted;
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, len, ord) {
  $thiz.sc_SeqView$Sorted__f_underlying = underlying;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = len;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = ord;
  $thiz.sc_SeqView$Sorted__f_evaluated = false;
  return $thiz;
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__($thiz, underlying, ord) {
  $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, $n(underlying).length__I(), ord);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Sorted() {
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = null;
  this.sc_SeqView$Sorted__f_underlying = null;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = 0;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = null;
  this.sc_SeqView$Sorted__f_evaluated = false;
  this.sc_SeqView$Sorted__f_bitmap$0 = false;
}
$c_sc_SeqView$Sorted.prototype = new $h_O();
$c_sc_SeqView$Sorted.prototype.constructor = $c_sc_SeqView$Sorted;
/** @constructor */
function $h_sc_SeqView$Sorted() {
}
$h_sc_SeqView$Sorted.prototype = $c_sc_SeqView$Sorted.prototype;
$c_sc_SeqView$Sorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$();
});
$c_sc_SeqView$Sorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_SeqView$Sorted.prototype.className__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Sorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder();
});
$c_sc_SeqView$Sorted.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this).iterator__sc_Iterator();
});
$c_sc_SeqView$Sorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_sc_SeqView$Sorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Sorted.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_sc_SeqView$Sorted.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_sc_SeqView$Sorted.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_sc_SeqView$Sorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sc_SeqView$Sorted.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sc_SeqView$Sorted.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sc_SeqView$Sorted.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sc_SeqView$Sorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sc_SeqView$Sorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_SeqView$Sorted.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sc_SeqView$Sorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_SeqView$Sorted.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_SeqView$Sorted.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_SeqView$Sorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_SeqView$Sorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$_sorted__sc_Seq = (function() {
  return ((!this.sc_SeqView$Sorted__f_bitmap$0) ? $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq(this) : this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted);
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$elems__sc_SeqOps = (function() {
  var orig = this.sc_SeqView$Sorted__f_underlying;
  return (this.sc_SeqView$Sorted__f_evaluated ? this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq() : orig);
});
$c_sc_SeqView$Sorted.prototype.apply__I__O = (function(i) {
  return $n(this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq()).apply__I__O(i);
});
$c_sc_SeqView$Sorted.prototype.length__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
  var xs = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n(this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq()).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs);
});
$c_sc_SeqView$Sorted.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted.prototype.isEmpty__Z = (function() {
  return (this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0);
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : $n(ord1).equals__O__Z(x$2))) {
    return this;
  } else {
    return ($n(ord1).isReverseOf__s_math_Ordering__Z(this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? new $c_sc_SeqView$Sorted$ReverseSorted(this) : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1));
  }
});
$c_sc_SeqView$Sorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll);
});
$c_sc_SeqView$Sorted.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Sorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Sorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord);
});
var $d_sc_SeqView$Sorted = new $TypeData().initClass($c_sc_SeqView$Sorted, "scala.collection.SeqView$Sorted", ({
  sc_SeqView$Sorted: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
function $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) {
  if ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0)) {
    $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed = $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), $n($thiz.sc_SeqView$Sorted$ReverseSorted__f_$outer).scala$collection$SeqView$Sorted$$_sorted__sc_Seq());
    $thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = true;
  }
  return $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed;
}
function $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse($thiz) {
  return ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0) ? $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) : $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed);
}
/** @constructor */
function $c_sc_SeqView$Sorted$ReverseSorted(outer) {
  this.sc_SeqView$Sorted$ReverseSorted__f__reversed = null;
  this.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = false;
  this.sc_SeqView$Sorted$ReverseSorted__f_$outer = null;
  $n(outer);
  this.sc_SeqView$Sorted$ReverseSorted__f_$outer = outer;
}
$c_sc_SeqView$Sorted$ReverseSorted.prototype = new $h_O();
$c_sc_SeqView$Sorted$ReverseSorted.prototype.constructor = $c_sc_SeqView$Sorted$ReverseSorted;
/** @constructor */
function $h_sc_SeqView$Sorted$ReverseSorted() {
}
$h_sc_SeqView$Sorted$ReverseSorted.prototype = $c_sc_SeqView$Sorted$ReverseSorted.prototype;
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.className__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).iterator__sc_Iterator();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.apply__I__O = (function(i) {
  return $n($p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this)).apply__I__O(i);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.length__I = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
  var xs = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n($p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this)).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.knownSize__I = (function() {
  return $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.isEmpty__Z = (function() {
  return ($n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : $n(ord1).equals__O__Z(x$2))) {
    return this.sc_SeqView$Sorted$ReverseSorted__f_$outer;
  } else {
    return ($n(ord1).isReverseOf__s_math_Ordering__Z($n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? this : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), $n(this.sc_SeqView$Sorted$ReverseSorted__f_$outer).sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1));
  }
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord);
});
var $d_sc_SeqView$Sorted$ReverseSorted = new $TypeData().initClass($c_sc_SeqView$Sorted$ReverseSorted, "scala.collection.SeqView$Sorted$ReverseSorted", ({
  sc_SeqView$Sorted$ReverseSorted: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$$anon$1(it$1) {
  this.sc_View$$anon$1__f_it$1 = null;
  this.sc_View$$anon$1__f_it$1 = it$1;
}
$c_sc_View$$anon$1.prototype = new $h_sc_AbstractView();
$c_sc_View$$anon$1.prototype.constructor = $c_sc_View$$anon$1;
/** @constructor */
function $h_sc_View$$anon$1() {
}
$h_sc_View$$anon$1.prototype = $c_sc_View$$anon$1.prototype;
$c_sc_View$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $as_sc_Iterator($n(this.sc_View$$anon$1__f_it$1).apply__O());
});
var $d_sc_View$$anon$1 = new $TypeData().initClass($c_sc_View$$anon$1, "scala.collection.View$$anon$1", ({
  sc_View$$anon$1: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$Collect(underlying, pf) {
  this.sc_View$Collect__f_underlying = null;
  this.sc_View$Collect__f_pf = null;
  this.sc_View$Collect__f_underlying = underlying;
  this.sc_View$Collect__f_pf = pf;
}
$c_sc_View$Collect.prototype = new $h_sc_AbstractView();
$c_sc_View$Collect.prototype.constructor = $c_sc_View$Collect;
/** @constructor */
function $h_sc_View$Collect() {
}
$h_sc_View$Collect.prototype = $c_sc_View$Collect.prototype;
$c_sc_View$Collect.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Collect__f_underlying).iterator__sc_Iterator());
  var pf = this.sc_View$Collect__f_pf;
  return new $c_sc_Iterator$$anon$7(this$1, pf);
});
var $d_sc_View$Collect = new $TypeData().initClass($c_sc_View$Collect, "scala.collection.View$Collect", ({
  sc_View$Collect: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$Concat(prefix, suffix) {
  this.sc_View$Concat__f_prefix = null;
  this.sc_View$Concat__f_suffix = null;
  this.sc_View$Concat__f_prefix = prefix;
  this.sc_View$Concat__f_suffix = suffix;
}
$c_sc_View$Concat.prototype = new $h_sc_AbstractView();
$c_sc_View$Concat.prototype.constructor = $c_sc_View$Concat;
/** @constructor */
function $h_sc_View$Concat() {
}
$h_sc_View$Concat.prototype = $c_sc_View$Concat.prototype;
$c_sc_View$Concat.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($n(this.sc_View$Concat__f_prefix).iterator__sc_Iterator());
  var xs = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n(this.sc_View$Concat__f_suffix).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs);
});
$c_sc_View$Concat.prototype.knownSize__I = (function() {
  var prefixSize = $n(this.sc_View$Concat__f_prefix).knownSize__I();
  if ((prefixSize >= 0)) {
    var suffixSize = $n(this.sc_View$Concat__f_suffix).knownSize__I();
    return ((suffixSize >= 0) ? ((prefixSize + suffixSize) | 0) : (-1));
  } else {
    return (-1);
  }
});
$c_sc_View$Concat.prototype.isEmpty__Z = (function() {
  return ($n(this.sc_View$Concat__f_prefix).isEmpty__Z() && $n(this.sc_View$Concat__f_suffix).isEmpty__Z());
});
var $d_sc_View$Concat = new $TypeData().initClass($c_sc_View$Concat, "scala.collection.View$Concat", ({
  sc_View$Concat: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Drop__f_underlying = underlying;
  $thiz.sc_View$Drop__f_n = n;
  $thiz.sc_View$Drop__f_normN = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
}
$c_sc_View$Drop.prototype = new $h_sc_AbstractView();
$c_sc_View$Drop.prototype.constructor = $c_sc_View$Drop;
/** @constructor */
function $h_sc_View$Drop() {
}
$h_sc_View$Drop.prototype = $c_sc_View$Drop.prototype;
$c_sc_View$Drop.prototype.iterator__sc_Iterator = (function() {
  return $n($n(this.sc_View$Drop__f_underlying).iterator__sc_Iterator()).drop__I__sc_Iterator(this.sc_View$Drop__f_n);
});
$c_sc_View$Drop.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Drop__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$Drop__f_normN) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$c_sc_View$Drop.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Drop = new $TypeData().initClass($c_sc_View$Drop, "scala.collection.View$Drop", ({
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$DropRight__f_underlying = underlying;
  $thiz.sc_View$DropRight__f_n = n;
  $thiz.sc_View$DropRight__f_normN = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
}
$c_sc_View$DropRight.prototype = new $h_sc_AbstractView();
$c_sc_View$DropRight.prototype.constructor = $c_sc_View$DropRight;
/** @constructor */
function $h_sc_View$DropRight() {
}
$h_sc_View$DropRight.prototype = $c_sc_View$DropRight.prototype;
$c_sc_View$DropRight.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_View$().dropRightIterator__sc_Iterator__I__sc_Iterator($n(this.sc_View$DropRight__f_underlying).iterator__sc_Iterator(), this.sc_View$DropRight__f_n);
});
$c_sc_View$DropRight.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$DropRight__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$DropRight__f_normN) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$c_sc_View$DropRight.prototype.isEmpty__Z = (function() {
  if ((this.knownSize__I() >= 0)) {
    return (this.knownSize__I() === 0);
  } else {
    var this$1 = $n(this.iterator__sc_Iterator());
    return (!this$1.hasNext__Z());
  }
});
var $d_sc_View$DropRight = new $TypeData().initClass($c_sc_View$DropRight, "scala.collection.View$DropRight", ({
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$Filter(underlying, p, isFlipped) {
  this.sc_View$Filter__f_underlying = null;
  this.sc_View$Filter__f_p = null;
  this.sc_View$Filter__f_isFlipped = false;
  this.sc_View$Filter__f_underlying = underlying;
  this.sc_View$Filter__f_p = p;
  this.sc_View$Filter__f_isFlipped = isFlipped;
}
$c_sc_View$Filter.prototype = new $h_sc_AbstractView();
$c_sc_View$Filter.prototype.constructor = $c_sc_View$Filter;
/** @constructor */
function $h_sc_View$Filter() {
}
$h_sc_View$Filter.prototype = $c_sc_View$Filter.prototype;
$c_sc_View$Filter.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Filter__f_underlying).iterator__sc_Iterator());
  var p = this.sc_View$Filter__f_p;
  var isFlipped = this.sc_View$Filter__f_isFlipped;
  return new $c_sc_Iterator$$anon$6(this$1, p, isFlipped);
});
$c_sc_View$Filter.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$Filter__f_underlying).knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$Filter.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Filter = new $TypeData().initClass($c_sc_View$Filter, "scala.collection.View$Filter", ({
  sc_View$Filter: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sc_View$FlatMap(underlying, f) {
  this.sc_View$FlatMap__f_underlying = null;
  this.sc_View$FlatMap__f_f = null;
  this.sc_View$FlatMap__f_underlying = underlying;
  this.sc_View$FlatMap__f_f = f;
}
$c_sc_View$FlatMap.prototype = new $h_sc_AbstractView();
$c_sc_View$FlatMap.prototype.constructor = $c_sc_View$FlatMap;
/** @constructor */
function $h_sc_View$FlatMap() {
}
$h_sc_View$FlatMap.prototype = $c_sc_View$FlatMap.prototype;
$c_sc_View$FlatMap.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$FlatMap__f_underlying).iterator__sc_Iterator());
  var f = this.sc_View$FlatMap__f_f;
  return new $c_sc_Iterator$$anon$10(this$1, f);
});
$c_sc_View$FlatMap.prototype.knownSize__I = (function() {
  return (($n(this.sc_View$FlatMap__f_underlying).knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$FlatMap.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$FlatMap = new $TypeData().initClass($c_sc_View$FlatMap, "scala.collection.View$FlatMap", ({
  sc_View$FlatMap: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f) {
  $thiz.sc_View$Map__f_underlying = underlying;
  $thiz.sc_View$Map__f_f = f;
  return $thiz;
}
/** @constructor */
function $c_sc_View$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
}
$c_sc_View$Map.prototype = new $h_sc_AbstractView();
$c_sc_View$Map.prototype.constructor = $c_sc_View$Map;
/** @constructor */
function $h_sc_View$Map() {
}
$h_sc_View$Map.prototype = $c_sc_View$Map.prototype;
$c_sc_View$Map.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_View$Map__f_underlying).iterator__sc_Iterator());
  var f = this.sc_View$Map__f_f;
  return new $c_sc_Iterator$$anon$9(this$1, f);
});
$c_sc_View$Map.prototype.knownSize__I = (function() {
  return $n(this.sc_View$Map__f_underlying).knownSize__I();
});
$c_sc_View$Map.prototype.isEmpty__Z = (function() {
  return $n(this.sc_View$Map__f_underlying).isEmpty__Z();
});
var $d_sc_View$Map = new $TypeData().initClass($c_sc_View$Map, "scala.collection.View$Map", ({
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Take__f_underlying = underlying;
  $thiz.sc_View$Take__f_n = n;
  $thiz.sc_View$Take__f_normN = ((n > 0) ? n : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_View$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
}
$c_sc_View$Take.prototype = new $h_sc_AbstractView();
$c_sc_View$Take.prototype.constructor = $c_sc_View$Take;
/** @constructor */
function $h_sc_View$Take() {
}
$h_sc_View$Take.prototype = $c_sc_View$Take.prototype;
$c_sc_View$Take.prototype.iterator__sc_Iterator = (function() {
  return $n($n(this.sc_View$Take__f_underlying).iterator__sc_Iterator()).take__I__sc_Iterator(this.sc_View$Take__f_n);
});
$c_sc_View$Take.prototype.knownSize__I = (function() {
  var size = $n(this.sc_View$Take__f_underlying).knownSize__I();
  if ((size >= 0)) {
    var that = this.sc_View$Take__f_normN;
    return ((size < that) ? size : that);
  } else {
    return (-1);
  }
});
$c_sc_View$Take.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Take = new $TypeData().initClass($c_sc_View$Take, "scala.collection.View$Take", ({
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_s_math_Numeric$ByteIsIntegral$() {
}
$c_s_math_Numeric$ByteIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$ByteIsIntegral$.prototype.constructor = $c_s_math_Numeric$ByteIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$ByteIsIntegral$() {
}
$h_s_math_Numeric$ByteIsIntegral$.prototype = $c_s_math_Numeric$ByteIsIntegral$.prototype;
$c_s_math_Numeric$ByteIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = $uB(x);
  return $f_s_math_Numeric$ByteIsIntegral__sign__B__B(this, x$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = $uB(x);
  return x$1;
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return ((x << 24) >> 24);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uB(x);
  return $f_s_math_Numeric$ByteIsIntegral__negate__B__B(this, x$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__rem__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__quot__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__times__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__minus__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return $f_s_math_Numeric$ByteIsIntegral__plus__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Numeric$ByteIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$ByteIsIntegral$, "scala.math.Numeric$ByteIsIntegral$", ({
  s_math_Numeric$ByteIsIntegral$: 1,
  s_math_Numeric$ByteIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$ByteOrdering: 1
}));
var $n_s_math_Numeric$ByteIsIntegral$;
function $m_s_math_Numeric$ByteIsIntegral$() {
  if ((!$n_s_math_Numeric$ByteIsIntegral$)) {
    $n_s_math_Numeric$ByteIsIntegral$ = new $c_s_math_Numeric$ByteIsIntegral$();
  }
  return $n_s_math_Numeric$ByteIsIntegral$;
}
/** @constructor */
function $c_s_math_Numeric$CharIsIntegral$() {
}
$c_s_math_Numeric$CharIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$CharIsIntegral$.prototype.constructor = $c_s_math_Numeric$CharIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$CharIsIntegral$() {
}
$h_s_math_Numeric$CharIsIntegral$.prototype = $c_s_math_Numeric$CharIsIntegral$.prototype;
$c_s_math_Numeric$CharIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = $uC(x);
  return $bC($f_s_math_Numeric$CharIsIntegral__sign__C__C(this, x$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = $uC(x);
  return x$1;
});
$c_s_math_Numeric$CharIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return $bC((65535 & x));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uC(x);
  return $bC($f_s_math_Numeric$CharIsIntegral__negate__C__C(this, x$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__rem__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__quot__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__times__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__minus__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__plus__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Numeric$CharIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$CharIsIntegral$, "scala.math.Numeric$CharIsIntegral$", ({
  s_math_Numeric$CharIsIntegral$: 1,
  s_math_Numeric$CharIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$CharOrdering: 1
}));
var $n_s_math_Numeric$CharIsIntegral$;
function $m_s_math_Numeric$CharIsIntegral$() {
  if ((!$n_s_math_Numeric$CharIsIntegral$)) {
    $n_s_math_Numeric$CharIsIntegral$ = new $c_s_math_Numeric$CharIsIntegral$();
  }
  return $n_s_math_Numeric$CharIsIntegral$;
}
/** @constructor */
function $c_s_math_Numeric$IntIsIntegral$() {
}
$c_s_math_Numeric$IntIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$IntIsIntegral$.prototype.constructor = $c_s_math_Numeric$IntIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$IntIsIntegral$() {
}
$h_s_math_Numeric$IntIsIntegral$.prototype = $c_s_math_Numeric$IntIsIntegral$.prototype;
$c_s_math_Numeric$IntIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = $uI(x);
  return ((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0));
});
$c_s_math_Numeric$IntIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = $uI(x);
  return x$1;
});
$c_s_math_Numeric$IntIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return x;
});
$c_s_math_Numeric$IntIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uI(x);
  return $f_s_math_Numeric$IntIsIntegral__negate__I__I(this, x$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__rem__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__quot__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__times__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__minus__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return $f_s_math_Numeric$IntIsIntegral__plus__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
var $d_s_math_Numeric$IntIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$IntIsIntegral$, "scala.math.Numeric$IntIsIntegral$", ({
  s_math_Numeric$IntIsIntegral$: 1,
  s_math_Numeric$IntIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$IntOrdering: 1
}));
var $n_s_math_Numeric$IntIsIntegral$;
function $m_s_math_Numeric$IntIsIntegral$() {
  if ((!$n_s_math_Numeric$IntIsIntegral$)) {
    $n_s_math_Numeric$IntIsIntegral$ = new $c_s_math_Numeric$IntIsIntegral$();
  }
  return $n_s_math_Numeric$IntIsIntegral$;
}
/** @constructor */
function $c_s_math_Numeric$LongIsIntegral$() {
}
$c_s_math_Numeric$LongIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$LongIsIntegral$.prototype.constructor = $c_s_math_Numeric$LongIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$LongIsIntegral$() {
}
$h_s_math_Numeric$LongIsIntegral$.prototype = $c_s_math_Numeric$LongIsIntegral$.prototype;
$c_s_math_Numeric$LongIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.sign__O__O = (function(x) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  return $m_s_math_package$().signum__J__J(x$1_$_lo, x$1_$_hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.toInt__O__I = (function(x) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  return x$1_$_lo;
});
$c_s_math_Numeric$LongIsIntegral$.prototype.fromInt__I__O = (function(x) {
  var hi = (x >> 31);
  return $bL(x, hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.negate__O__O = (function(x) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  return $f_s_math_Numeric$LongIsIntegral__negate__J__J(this, x$1_$_lo, x$1_$_hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return $f_s_math_Numeric$LongIsIntegral__rem__J__J__J(this, x$1_$_lo, x$1_$_hi, y$1_$_lo, y$1_$_hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return $f_s_math_Numeric$LongIsIntegral__quot__J__J__J(this, x$1_$_lo, x$1_$_hi, y$1_$_lo, y$1_$_hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return $f_s_math_Numeric$LongIsIntegral__times__J__J__J(this, x$1_$_lo, x$1_$_hi, y$1_$_lo, y$1_$_hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return $f_s_math_Numeric$LongIsIntegral__minus__J__J__J(this, x$1_$_lo, x$1_$_hi, y$1_$_lo, y$1_$_hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return $f_s_math_Numeric$LongIsIntegral__plus__J__J__J(this, x$1_$_lo, x$1_$_hi, y$1_$_lo, y$1_$_hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  return ((x$1_$_hi === y$1_$_hi) ? ((x$1_$_lo === y$1_$_lo) ? 0 : (((x$1_$_lo >>> 0) < (y$1_$_lo >>> 0)) ? (-1) : 1)) : ((x$1_$_hi < y$1_$_hi) ? (-1) : 1));
});
var $d_s_math_Numeric$LongIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$LongIsIntegral$, "scala.math.Numeric$LongIsIntegral$", ({
  s_math_Numeric$LongIsIntegral$: 1,
  s_math_Numeric$LongIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$LongOrdering: 1
}));
var $n_s_math_Numeric$LongIsIntegral$;
function $m_s_math_Numeric$LongIsIntegral$() {
  if ((!$n_s_math_Numeric$LongIsIntegral$)) {
    $n_s_math_Numeric$LongIsIntegral$ = new $c_s_math_Numeric$LongIsIntegral$();
  }
  return $n_s_math_Numeric$LongIsIntegral$;
}
/** @constructor */
function $c_s_math_Numeric$ShortIsIntegral$() {
}
$c_s_math_Numeric$ShortIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$ShortIsIntegral$.prototype.constructor = $c_s_math_Numeric$ShortIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$ShortIsIntegral$() {
}
$h_s_math_Numeric$ShortIsIntegral$.prototype = $c_s_math_Numeric$ShortIsIntegral$.prototype;
$c_s_math_Numeric$ShortIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = $uS(x);
  return $f_s_math_Numeric$ShortIsIntegral__sign__S__S(this, x$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = $uS(x);
  return x$1;
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return ((x << 16) >> 16);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uS(x);
  return $f_s_math_Numeric$ShortIsIntegral__negate__S__S(this, x$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__rem__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__quot__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__times__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__minus__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return $f_s_math_Numeric$ShortIsIntegral__plus__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Numeric$ShortIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$ShortIsIntegral$, "scala.math.Numeric$ShortIsIntegral$", ({
  s_math_Numeric$ShortIsIntegral$: 1,
  s_math_Numeric$ShortIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$ShortOrdering: 1
}));
var $n_s_math_Numeric$ShortIsIntegral$;
function $m_s_math_Numeric$ShortIsIntegral$() {
  if ((!$n_s_math_Numeric$ShortIsIntegral$)) {
    $n_s_math_Numeric$ShortIsIntegral$ = new $c_s_math_Numeric$ShortIsIntegral$();
  }
  return $n_s_math_Numeric$ShortIsIntegral$;
}
function $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive($thiz, end) {
  $m_sci_NumericRange$();
  var start = $thiz.self__O();
  var this$1 = $n($thiz.num__s_math_Integral());
  var step = this$1.fromInt__I__O(1);
  var num = $thiz.num__s_math_Integral();
  return new $c_sci_NumericRange$Inclusive(start, end, step, num);
}
/** @constructor */
function $c_Ltyrian_runtime_RendererState$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Ltyrian_runtime_RendererState$$anon$1__f_$name$1 = null;
  this.Ltyrian_runtime_RendererState$$anon$1__f_$name$1 = \u03b4name$2;
}
$c_Ltyrian_runtime_RendererState$$anon$1.prototype = new $h_Ltyrian_runtime_RendererState();
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.constructor = $c_Ltyrian_runtime_RendererState$$anon$1;
/** @constructor */
function $h_Ltyrian_runtime_RendererState$$anon$1() {
}
$h_Ltyrian_runtime_RendererState$$anon$1.prototype = $c_Ltyrian_runtime_RendererState$$anon$1.prototype;
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.productPrefix__T = (function() {
  return this.Ltyrian_runtime_RendererState$$anon$1__f_$name$1;
});
$c_Ltyrian_runtime_RendererState$$anon$1.prototype.toString__T = (function() {
  return this.Ltyrian_runtime_RendererState$$anon$1__f_$name$1;
});
var $d_Ltyrian_runtime_RendererState$$anon$1 = new $TypeData().initClass($c_Ltyrian_runtime_RendererState$$anon$1, "tyrian.runtime.RendererState$$anon$1", ({
  Ltyrian_runtime_RendererState$$anon$1: 1,
  Ltyrian_runtime_RendererState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Lcats_data_KleisliInstances0() {
}
$c_Lcats_data_KleisliInstances0.prototype = new $h_Lcats_data_KleisliInstances0\uff3f5();
$c_Lcats_data_KleisliInstances0.prototype.constructor = $c_Lcats_data_KleisliInstances0;
/** @constructor */
function $h_Lcats_data_KleisliInstances0() {
}
$h_Lcats_data_KleisliInstances0.prototype = $c_Lcats_data_KleisliInstances0.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_implicits$() {
}
$c_Lcats_effect_kernel_implicits$.prototype = new $h_O();
$c_Lcats_effect_kernel_implicits$.prototype.constructor = $c_Lcats_effect_kernel_implicits$;
/** @constructor */
function $h_Lcats_effect_kernel_implicits$() {
}
$h_Lcats_effect_kernel_implicits$.prototype = $c_Lcats_effect_kernel_implicits$.prototype;
var $d_Lcats_effect_kernel_implicits$ = new $TypeData().initClass($c_Lcats_effect_kernel_implicits$, "cats.effect.kernel.implicits$", ({
  Lcats_effect_kernel_implicits$: 1,
  Lcats_effect_kernel_syntax_MonadCancelSyntax: 1,
  Lcats_effect_kernel_syntax_GenSpawnSyntax: 1,
  Lcats_effect_kernel_syntax_GenTemporalSyntax: 1,
  Lcats_effect_kernel_syntax_GenConcurrentSyntax: 1,
  Lcats_effect_kernel_syntax_AsyncSyntax: 1,
  Lcats_effect_kernel_syntax_ResourceSyntax: 1,
  Lcats_effect_kernel_syntax_ClockSyntax: 1,
  Lcats_effect_kernel_syntax_AllSyntax: 1,
  Lcats_effect_kernel_instances_GenSpawnInstances: 1,
  Lcats_effect_kernel_instances_AllInstances: 1
}));
var $n_Lcats_effect_kernel_implicits$;
function $m_Lcats_effect_kernel_implicits$() {
  if ((!$n_Lcats_effect_kernel_implicits$)) {
    $n_Lcats_effect_kernel_implicits$ = new $c_Lcats_effect_kernel_implicits$();
  }
  return $n_Lcats_effect_kernel_implicits$;
}
/** @constructor */
function $c_Lcats_kernel_instances_UnitAlgebra() {
}
$c_Lcats_kernel_instances_UnitAlgebra.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitAlgebra.prototype.constructor = $c_Lcats_kernel_instances_UnitAlgebra;
/** @constructor */
function $h_Lcats_kernel_instances_UnitAlgebra() {
}
$h_Lcats_kernel_instances_UnitAlgebra.prototype = $c_Lcats_kernel_instances_UnitAlgebra.prototype;
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.empty__O = (function() {
  return (void 0);
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combine__O__O__O = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
});
var $d_Lcats_kernel_instances_UnitAlgebra = new $TypeData().initClass($c_Lcats_kernel_instances_UnitAlgebra, "cats.kernel.instances.UnitAlgebra", ({
  Lcats_kernel_instances_UnitAlgebra: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
/** @constructor */
function $c_ju_Collections$ImmutableList(inner) {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  $ct_ju_Collections$UnmodifiableList__ju_List__(this, inner);
}
$c_ju_Collections$ImmutableList.prototype = new $h_ju_Collections$UnmodifiableList();
$c_ju_Collections$ImmutableList.prototype.constructor = $c_ju_Collections$ImmutableList;
/** @constructor */
function $h_ju_Collections$ImmutableList() {
}
$h_ju_Collections$ImmutableList.prototype = $c_ju_Collections$ImmutableList.prototype;
var $d_ju_Collections$ImmutableList = new $TypeData().initClass($c_ju_Collections$ImmutableList, "java.util.Collections$ImmutableList", ({
  ju_Collections$ImmutableList: 1,
  ju_Collections$UnmodifiableList: 1,
  ju_Collections$UnmodifiableCollection: 1,
  ju_Collections$WrappedCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  Ljava_io_Serializable: 1,
  ju_Collections$WrappedList: 1,
  ju_Collections$WrappedEquals: 1,
  ju_List: 1,
  ju_SequencedCollection: 1
}));
/** @constructor */
function $c_Lorg_scalajs_dom_DOMList$DOMListSeq(domList) {
  this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList = null;
  this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList = domList;
}
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = new $h_O();
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.constructor = $c_Lorg_scalajs_dom_DOMList$DOMListSeq;
/** @constructor */
function $h_Lorg_scalajs_dom_DOMList$DOMListSeq() {
}
$h_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype = $c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype;
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_Seq$().newBuilder__scm_Builder();
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.className__T = (function() {
  return "Seq";
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.reverseIterator__sc_Iterator = (function() {
  return $n($f_sc_IterableOnceOps__reversed__sc_Iterable(this)).iterator__sc_Iterator();
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.canEqual__O__Z = (function(that) {
  return true;
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.length__I = (function() {
  return $uI(this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList.length);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.apply__I__O = (function(x) {
  return this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList[x];
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lorg_scalajs_dom_DOMList$DOMListIterator(this.Lorg_scalajs_dom_DOMList$DOMListSeq__f_domList);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Seq$();
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_Seq$();
  return this$1.from__sc_IterableOnce__sc_SeqOps(coll);
});
$c_Lorg_scalajs_dom_DOMList$DOMListSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__I__O(v1));
});
var $d_Lorg_scalajs_dom_DOMList$DOMListSeq = new $TypeData().initClass($c_Lorg_scalajs_dom_DOMList$DOMListSeq, "org.scalajs.dom.DOMList$DOMListSeq", ({
  Lorg_scalajs_dom_DOMList$DOMListSeq: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  F1: 1,
  s_PartialFunction: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sc_Seq: 1
}));
/** @constructor */
function $c_sc_AbstractSet() {
}
$c_sc_AbstractSet.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSet.prototype.constructor = $c_sc_AbstractSet;
/** @constructor */
function $h_sc_AbstractSet() {
}
$h_sc_AbstractSet.prototype = $c_sc_AbstractSet.prototype;
$c_sc_AbstractSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_Set__equals__O__Z(this, that);
});
$c_sc_AbstractSet.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(this, this$1.s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_sc_AbstractSet.prototype.stringPrefix__T = (function() {
  return "Set";
});
$c_sc_AbstractSet.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  return this.forall__F1__Z(that);
});
$c_sc_AbstractSet.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.contains__O__Z(v1);
});
$c_sc_AbstractSet.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractSet.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sc_AbstractSet.prototype.apply__O__O = (function(v1) {
  return this.contains__O__Z(v1);
});
function $f_sc_Map__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else {
    if ($is_sc_Map(o)) {
      var x2 = $as_sc_Map(o);
      if (($n(x2), true)) {
        if (($thiz.size__I() === $n(x2).size__I())) {
          try {
            return $thiz.forall__F1__Z(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2$2) => {
              var kv$2 = $as_T2(kv$2$2);
              return $m_sr_BoxesRunTime$().equals__O__O__Z($n(x2).getOrElse__O__F0__O($n(kv$2)._1__O(), $m_sc_Map$().sc_Map$__f_scala$collection$Map$$DefaultSentinelFn), $n(kv$2)._2__O());
            })));
          } catch (e) {
            if ((e instanceof $c_jl_ClassCastException)) {
              return false;
            } else {
              throw e;
            }
          }
        } else {
          return false;
        }
      }
    }
    return false;
  }
}
function $is_sc_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Map)));
}
function $as_sc_Map(obj) {
  return (($is_sc_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Map"));
}
function $isArrayOf_sc_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Map)));
}
function $asArrayOf_sc_Map(obj, depth) {
  return (($isArrayOf_sc_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Map;", depth));
}
function $is_sc_MapView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_MapView)));
}
function $as_sc_MapView(obj) {
  return (($is_sc_MapView(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.MapView"));
}
function $isArrayOf_sc_MapView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_MapView)));
}
function $asArrayOf_sc_MapView(obj, depth) {
  return (($isArrayOf_sc_MapView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.MapView;", depth));
}
function $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V($thiz, t, e) {
  var wasInterrupted = false;
  if ((wasInterrupted || $m_s_util_control_NonFatal$().apply__jl_Throwable__Z(t))) {
    var completed = $thiz.tryComplete0__O__s_util_Try__Z($thiz.ju_concurrent_atomic_AtomicReference__f_value, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(new $c_s_util_Failure(t)));
    if ((completed && wasInterrupted)) {
      var this$1 = $n($m_jl_Thread$().jl_Thread$__f_SingleThread);
      this$1.jl_Thread__f_java$lang$Thread$$interruptedState = true;
    }
    if (((($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 5) || ($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 6)) || (!completed))) {
      $n(e).reportFailure__jl_Throwable__V(t);
    }
  } else {
    var $x_1 = $n(t);
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
  }
}
function $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, _fun, _ec, _arg, _xform) {
  $thiz.s_concurrent_impl_Promise$Transformation__f__fun = _fun;
  $thiz.s_concurrent_impl_Promise$Transformation__f__ec = _ec;
  $thiz.s_concurrent_impl_Promise$Transformation__f__arg = _arg;
  $thiz.s_concurrent_impl_Promise$Transformation__f__xform = _xform;
  $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz);
  return $thiz;
}
function $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__($thiz, xform, f, ec) {
  $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, f, $n(ec), null, xform);
  return $thiz;
}
/** @constructor */
function $c_s_concurrent_impl_Promise$Transformation() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__xform = 0;
}
$c_s_concurrent_impl_Promise$Transformation.prototype = new $h_s_concurrent_impl_Promise$DefaultPromise();
$c_s_concurrent_impl_Promise$Transformation.prototype.constructor = $c_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $h_s_concurrent_impl_Promise$Transformation() {
}
$h_s_concurrent_impl_Promise$Transformation.prototype = $c_s_concurrent_impl_Promise$Transformation.prototype;
$c_s_concurrent_impl_Promise$Transformation.prototype.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation = (function(resolved) {
  this.s_concurrent_impl_Promise$Transformation__f__arg = resolved;
  var e = this.s_concurrent_impl_Promise$Transformation__f__ec;
  try {
    $n(e).execute__jl_Runnable__V(this);
  } catch (e$2) {
    var e$3 = ((e$2 instanceof $c_jl_Throwable) ? e$2 : new $c_sjs_js_JavaScriptException(e$2));
    this.s_concurrent_impl_Promise$Transformation__f__fun = null;
    this.s_concurrent_impl_Promise$Transformation__f__arg = null;
    this.s_concurrent_impl_Promise$Transformation__f__ec = null;
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$3, e);
  }
  return this;
});
$c_s_concurrent_impl_Promise$Transformation.prototype.run__V = (function() {
  var v = this.s_concurrent_impl_Promise$Transformation__f__arg;
  var fun = this.s_concurrent_impl_Promise$Transformation__f__fun;
  var ec = this.s_concurrent_impl_Promise$Transformation__f__ec;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  try {
    var x1 = this.s_concurrent_impl_Promise$Transformation__f__xform;
    switch (x1) {
      case 0: {
        var resolvedResult = null;
        break;
      }
      case 1: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success($n(fun).apply__O__O($n(v).get__O())) : v);
        break;
      }
      case 2: {
        if ((v instanceof $c_s_util_Success)) {
          var f = $n(fun).apply__O__O($n(v).get__O());
          if ((f instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
            $n($as_s_concurrent_impl_Promise$DefaultPromise(f)).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null);
          } else {
            this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f));
          }
          var resolvedResult = null;
        } else {
          var resolvedResult = v;
        }
        break;
      }
      case 3: {
        var resolvedResult = $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try($as_s_util_Try($n(fun).apply__O__O(v)));
        break;
      }
      case 4: {
        var f$2 = $n(fun).apply__O__O(v);
        if ((f$2 instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
          $n($as_s_concurrent_impl_Promise$DefaultPromise(f$2)).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null);
        } else {
          this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f$2));
        }
        var resolvedResult = null;
        break;
      }
      case 5: {
        $n(v).foreach__F1__V(fun);
        var resolvedResult = null;
        break;
      }
      case 6: {
        $n(fun).apply__O__O(v);
        var resolvedResult = null;
        break;
      }
      case 7: {
        var resolvedResult = ((v instanceof $c_s_util_Failure) ? $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try($n(v).recover__s_PartialFunction__s_util_Try($as_s_PartialFunction(fun))) : v);
        break;
      }
      case 8: {
        if ((v instanceof $c_s_util_Failure)) {
          var f$3 = $as_s_concurrent_Future($n($as_s_PartialFunction(fun)).applyOrElse__O__F1__O($n($as_s_util_Failure(v)).s_util_Failure__f_exception, $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailed));
          var resolvedResult = ((f$3 !== $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker) ? (((f$3 instanceof $c_s_concurrent_impl_Promise$DefaultPromise) ? $n($as_s_concurrent_impl_Promise$DefaultPromise(f$3)).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null) : this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise(f$3)), null) : v);
        } else {
          var resolvedResult = v;
        }
        break;
      }
      case 9: {
        var resolvedResult = (((v instanceof $c_s_util_Failure) || $uZ($n(fun).apply__O__O($n(v).get__O()))) ? v : $m_s_concurrent_Future$().s_concurrent_Future$__f_filterFailure);
        break;
      }
      case 10: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success($n($as_s_PartialFunction(fun)).applyOrElse__O__F1__O($n(v).get__O(), $m_s_concurrent_Future$().s_concurrent_Future$__f_collectFailed)) : v);
        break;
      }
      default: {
        var resolvedResult = new $c_s_util_Failure($ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("BUG: encountered transformation promise with illegal type: " + this.s_concurrent_impl_Promise$Transformation__f__xform)));
      }
    }
    if ((resolvedResult !== null)) {
      this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolvedResult);
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$2, ec);
  }
});
function $as_s_concurrent_impl_Promise$Transformation(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Transformation) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Transformation"));
}
function $isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Transformation)));
}
function $asArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Transformation;", depth));
}
var $d_s_concurrent_impl_Promise$Transformation = new $TypeData().initClass($c_s_concurrent_impl_Promise$Transformation, "scala.concurrent.impl.Promise$Transformation", ({
  s_concurrent_impl_Promise$Transformation: 1,
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1,
  s_concurrent_impl_Promise$Callbacks: 1,
  jl_Runnable: 1,
  s_concurrent_Batchable: 1
}));
/** @constructor */
function $c_sr_RichChar(self) {
  this.sr_RichChar__f_self = 0;
  this.sr_RichChar__f_self = self;
}
$c_sr_RichChar.prototype = new $h_O();
$c_sr_RichChar.prototype.constructor = $c_sr_RichChar;
/** @constructor */
function $h_sr_RichChar() {
}
$h_sr_RichChar.prototype = $c_sr_RichChar.prototype;
$c_sr_RichChar.prototype.isWhole__Z = (function() {
  return true;
});
$c_sr_RichChar.prototype.compare__O__I = (function(y) {
  var x = this.sr_RichChar__f_self;
  var y$1 = $uC(y);
  return ((x - y$1) | 0);
});
$c_sr_RichChar.prototype.compareTo__O__I = (function(that) {
  var x = this.sr_RichChar__f_self;
  var y = $uC(that);
  return ((x - y) | 0);
});
$c_sr_RichChar.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this);
});
$c_sr_RichChar.prototype.isValidByte__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidByte__Z(this);
});
$c_sr_RichChar.prototype.isValidShort__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidShort__Z(this);
});
$c_sr_RichChar.prototype.isValidInt__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidInt__Z(this);
});
$c_sr_RichChar.prototype.doubleValue__D = (function() {
  var this$ = this.sr_RichChar__f_self;
  return this$;
});
$c_sr_RichChar.prototype.floatValue__F = (function() {
  var this$ = this.sr_RichChar__f_self;
  return Math.fround(this$);
});
$c_sr_RichChar.prototype.longValue__J = (function() {
  var this$ = this.sr_RichChar__f_self;
  var value = this$;
  var hi = (value >> 31);
  return $bL(value, hi);
});
$c_sr_RichChar.prototype.intValue__I = (function() {
  var this$ = this.sr_RichChar__f_self;
  return this$;
});
$c_sr_RichChar.prototype.byteValue__B = (function() {
  var this$ = this.sr_RichChar__f_self;
  return ((this$ << 24) >> 24);
});
$c_sr_RichChar.prototype.shortValue__S = (function() {
  var this$ = this.sr_RichChar__f_self;
  return ((this$ << 16) >> 16);
});
$c_sr_RichChar.prototype.isValidChar__Z = (function() {
  return true;
});
$c_sr_RichChar.prototype.hashCode__I = (function() {
  var this$ = this.sr_RichChar__f_self;
  return this$;
});
$c_sr_RichChar.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichChar$().equals$extension__C__O__Z(this.sr_RichChar__f_self, x$1);
});
$c_sr_RichChar.prototype.num__s_math_Integral = (function() {
  return $m_s_math_Numeric$CharIsIntegral$();
});
$c_sr_RichChar.prototype.self__O = (function() {
  return $bC(this.sr_RichChar__f_self);
});
function $as_sr_RichChar(obj) {
  return (((obj instanceof $c_sr_RichChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichChar"));
}
function $isArrayOf_sr_RichChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichChar)));
}
function $asArrayOf_sr_RichChar(obj, depth) {
  return (($isArrayOf_sr_RichChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichChar;", depth));
}
var $d_sr_RichChar = new $TypeData().initClass($c_sr_RichChar, "scala.runtime.RichChar", ({
  sr_RichChar: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
}));
/** @constructor */
function $c_sr_RichLong(self_$_lo, self_$_hi) {
  this.sr_RichLong__f_self_$lo = 0;
  this.sr_RichLong__f_self_$hi = 0;
  this.sr_RichLong__f_self_$lo = self_$_lo;
  this.sr_RichLong__f_self_$hi = self_$_hi;
}
$c_sr_RichLong.prototype = new $h_O();
$c_sr_RichLong.prototype.constructor = $c_sr_RichLong;
/** @constructor */
function $h_sr_RichLong() {
}
$h_sr_RichLong.prototype = $c_sr_RichLong.prototype;
$c_sr_RichLong.prototype.isWhole__Z = (function() {
  return true;
});
$c_sr_RichLong.prototype.compare__O__I = (function(y) {
  var x_$_lo = this.sr_RichLong__f_self_$lo;
  var x_$_hi = this.sr_RichLong__f_self_$hi;
  var $x_1 = $uJ(y);
  var y$1_$_lo = $x_1.l;
  var y$1_$_hi = $x_1.h;
  return ((x_$_hi === y$1_$_hi) ? ((x_$_lo === y$1_$_lo) ? 0 : (((x_$_lo >>> 0) < (y$1_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y$1_$_hi) ? (-1) : 1));
});
$c_sr_RichLong.prototype.compareTo__O__I = (function(that) {
  var x_$_lo = this.sr_RichLong__f_self_$lo;
  var x_$_hi = this.sr_RichLong__f_self_$hi;
  var $x_1 = $uJ(that);
  var y_$_lo = $x_1.l;
  var y_$_hi = $x_1.h;
  return ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
});
$c_sr_RichLong.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this);
});
$c_sr_RichLong.prototype.doubleValue__D = (function() {
  var this$_$_lo = this.sr_RichLong__f_self_$lo;
  var this$_$_hi = this.sr_RichLong__f_self_$hi;
  return ((4.294967296E9 * this$_$_hi) + (this$_$_lo >>> 0.0));
});
$c_sr_RichLong.prototype.floatValue__F = (function() {
  var this$_$_lo = this.sr_RichLong__f_self_$lo;
  var this$_$_hi = this.sr_RichLong__f_self_$hi;
  var compressedLo = (((((-2097152) & (this$_$_hi ^ (this$_$_hi >> 10))) === 0) || ((65535 & this$_$_lo) === 0)) ? this$_$_lo : (32768 | ((-32768) & this$_$_lo)));
  return Math.fround(((4.294967296E9 * this$_$_hi) + (compressedLo >>> 0.0)));
});
$c_sr_RichLong.prototype.longValue__J = (function() {
  var this$_$_lo = this.sr_RichLong__f_self_$lo;
  var this$_$_hi = this.sr_RichLong__f_self_$hi;
  return $bL(this$_$_lo, this$_$_hi);
});
$c_sr_RichLong.prototype.intValue__I = (function() {
  var this$_$_lo = this.sr_RichLong__f_self_$lo;
  var this$_$_hi = this.sr_RichLong__f_self_$hi;
  return this$_$_lo;
});
$c_sr_RichLong.prototype.byteValue__B = (function() {
  var this$_$_lo = this.sr_RichLong__f_self_$lo;
  var this$_$_hi = this.sr_RichLong__f_self_$hi;
  return ((this$_$_lo << 24) >> 24);
});
$c_sr_RichLong.prototype.shortValue__S = (function() {
  var this$_$_lo = this.sr_RichLong__f_self_$lo;
  var this$_$_hi = this.sr_RichLong__f_self_$hi;
  return ((this$_$_lo << 16) >> 16);
});
$c_sr_RichLong.prototype.isValidByte__Z = (function() {
  return $m_sr_RichLong$().isValidByte$extension__J__Z(this.sr_RichLong__f_self_$lo, this.sr_RichLong__f_self_$hi);
});
$c_sr_RichLong.prototype.isValidShort__Z = (function() {
  return $m_sr_RichLong$().isValidShort$extension__J__Z(this.sr_RichLong__f_self_$lo, this.sr_RichLong__f_self_$hi);
});
$c_sr_RichLong.prototype.isValidChar__Z = (function() {
  return $m_sr_RichLong$().isValidChar$extension__J__Z(this.sr_RichLong__f_self_$lo, this.sr_RichLong__f_self_$hi);
});
$c_sr_RichLong.prototype.isValidInt__Z = (function() {
  return $m_sr_RichLong$().isValidInt$extension__J__Z(this.sr_RichLong__f_self_$lo, this.sr_RichLong__f_self_$hi);
});
$c_sr_RichLong.prototype.hashCode__I = (function() {
  var this$_$_lo = this.sr_RichLong__f_self_$lo;
  var this$_$_hi = this.sr_RichLong__f_self_$hi;
  return (this$_$_lo ^ this$_$_hi);
});
$c_sr_RichLong.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichLong$().equals$extension__J__O__Z(this.sr_RichLong__f_self_$lo, this.sr_RichLong__f_self_$hi, x$1);
});
$c_sr_RichLong.prototype.num__s_math_Integral = (function() {
  return $m_s_math_Numeric$LongIsIntegral$();
});
$c_sr_RichLong.prototype.self__O = (function() {
  return $bL(this.sr_RichLong__f_self_$lo, this.sr_RichLong__f_self_$hi);
});
function $as_sr_RichLong(obj) {
  return (((obj instanceof $c_sr_RichLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichLong"));
}
function $isArrayOf_sr_RichLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichLong)));
}
function $asArrayOf_sr_RichLong(obj, depth) {
  return (($isArrayOf_sr_RichLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichLong;", depth));
}
var $d_sr_RichLong = new $TypeData().initClass($c_sr_RichLong, "scala.runtime.RichLong", ({
  sr_RichLong: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
}));
function $f_Lcats_Monad__map__O__F1__O($thiz, fa, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $thiz.pure__O__O($n(f).apply__O__O(a)))));
}
function $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli($thiz, b, f) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).tailRecM__O__F1__O(b, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$171) => $n($n($as_Lcats_data_Kleisli($n(f).apply__O__O(_$171))).Lcats_data_Kleisli__f_run).apply__O__O(a))))));
  return new $c_Lcats_data_Kleisli(run);
}
function $ct_Lcats_data_KleisliInstances__($thiz) {
  $ct_Lcats_data_KleisliInstances3__($thiz);
  $as_Lcats_CommutativeMonad($m_Lcats_package$().Lcats_package$__f_catsInstancesForId);
  return $thiz;
}
/** @constructor */
function $c_Lcats_data_KleisliInstances() {
}
$c_Lcats_data_KleisliInstances.prototype = new $h_Lcats_data_KleisliInstances0();
$c_Lcats_data_KleisliInstances.prototype.constructor = $c_Lcats_data_KleisliInstances;
/** @constructor */
function $h_Lcats_data_KleisliInstances() {
}
$h_Lcats_data_KleisliInstances.prototype = $c_Lcats_data_KleisliInstances.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$() {
}
$c_Lcats_effect_kernel_Resource$.prototype = new $h_Lcats_effect_kernel_ResourceFOInstances0();
$c_Lcats_effect_kernel_Resource$.prototype.constructor = $c_Lcats_effect_kernel_Resource$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$() {
}
$h_Lcats_effect_kernel_Resource$.prototype = $c_Lcats_effect_kernel_Resource$.prototype;
$c_Lcats_effect_kernel_Resource$.prototype.apply__O__Lcats_Functor__Lcats_effect_kernel_Resource = (function(resource, F) {
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(resource, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1)._1__O();
      var release = $n(x$1$1)._2__O();
      var _2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$57) => {
        $as_Lcats_effect_kernel_Resource$ExitCase(_$57);
        return release;
      }));
      return new $c_T2(a, _2);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  return this.applyCase__O__Lcats_effect_kernel_Resource($n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f));
});
$c_Lcats_effect_kernel_Resource$.prototype.applyCase__O__Lcats_effect_kernel_Resource = (function(resource) {
  var resource$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$59) => {
    $as_Lcats_effect_kernel_Poll(_$59);
    return resource;
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource$1);
});
$c_Lcats_effect_kernel_Resource$.prototype.make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource = (function(acquire, release, F) {
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(acquire, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
    var y = $n(release).apply__O__O(a);
    return new $c_T2(a, y);
  }));
  return this.apply__O__Lcats_Functor__Lcats_effect_kernel_Resource($n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f), F);
});
$c_Lcats_effect_kernel_Resource$.prototype.makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource = (function(acquire, release, F) {
  var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(acquire, F);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
    var _2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => {
      var e$1 = $as_Lcats_effect_kernel_Resource$ExitCase(e);
      return $n(release).apply__O__O__O(a, e$1);
    }));
    return new $c_T2(a, _2);
  }));
  return this.applyCase__O__Lcats_effect_kernel_Resource($n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f));
});
$c_Lcats_effect_kernel_Resource$.prototype.makeFull__F1__F1__Lcats_Functor__Lcats_effect_kernel_Resource = (function(acquire, release, F) {
  var resource = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(acquire).apply__O__O(poll$1);
    var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
      var _2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$65) => {
        $as_Lcats_effect_kernel_Resource$ExitCase(_$65);
        return $n(release).apply__O__O(a);
      }));
      return new $c_T2(a, _2);
    }));
    return $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource$.prototype.uncancelable__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(body, F) {
  var resource = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var inner = new $c_Lcats_effect_kernel_Resource$$anon$6(poll$1, F);
    return $n($as_Lcats_effect_kernel_Resource($n(body).apply__O__O(inner))).allocatedCase__Lcats_effect_kernel_MonadCancel__O(F);
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource$.prototype.deferred__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(F) {
  var fa = $n(F).deferred__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$87) => {
    var _$87$1 = $as_Lcats_effect_kernel_Deferred(_$87);
    var this$4 = $n(_$87$1);
    var f = new $c_Lcats_effect_kernel_Resource$$anon$5();
    return new $c_Lcats_effect_kernel_Deferred$TransformedDeferred(this$4, f);
  })));
});
$c_Lcats_effect_kernel_Resource$.prototype.ref__O__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(a, F) {
  var fa = $n(F).ref__O__O(a);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$90) => {
    var _$90$1 = $as_Lcats_effect_kernel_Ref(_$90);
    var this$5 = $n(_$90$1);
    var f = new $c_Lcats_effect_kernel_Resource$$anon$5();
    var G = $ct_Lcats_effect_kernel_ResourceMonad__(new $c_Lcats_effect_kernel_ResourceMonad());
    return new $c_Lcats_effect_kernel_Ref$TransformedRef2(this$5, f, G);
  })));
});
$c_Lcats_effect_kernel_Resource$.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource = (function(hint, thunk, F) {
  var fa = $n(F).suspend__Lcats_effect_kernel_Sync$Type__F0__O(hint, thunk);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_Resource$.prototype.cont__Lcats_effect_kernel_Cont__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource = (function(body, F) {
  var resource = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return $n(poll$1).apply__O__O($n(F).cont__Lcats_effect_kernel_Cont__O(new $c_Lcats_effect_kernel_Resource$$anon$7(F, body)));
  }));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource);
});
$c_Lcats_effect_kernel_Resource$.prototype.raiseError__O__Lcats_ApplicativeError__Lcats_effect_kernel_Resource = (function(e, F) {
  var fa = $n(F).raiseError__O__O(e);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
var $d_Lcats_effect_kernel_Resource$ = new $TypeData().initClass($c_Lcats_effect_kernel_Resource$, "cats.effect.kernel.Resource$", ({
  Lcats_effect_kernel_Resource$: 1,
  Lcats_effect_kernel_ResourceFOInstances0: 1,
  Lcats_effect_kernel_ResourceFOInstances1: 1,
  Lcats_effect_kernel_ResourceHOInstances5: 1,
  Lcats_effect_kernel_ResourceHOInstances4: 1,
  Lcats_effect_kernel_ResourceHOInstances3: 1,
  Lcats_effect_kernel_ResourceHOInstances2: 1,
  Lcats_effect_kernel_ResourceHOInstances1: 1,
  Lcats_effect_kernel_ResourceHOInstances0: 1,
  Lcats_effect_kernel_ResourcePlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
var $n_Lcats_effect_kernel_Resource$;
function $m_Lcats_effect_kernel_Resource$() {
  if ((!$n_Lcats_effect_kernel_Resource$)) {
    $n_Lcats_effect_kernel_Resource$ = new $c_Lcats_effect_kernel_Resource$();
  }
  return $n_Lcats_effect_kernel_Resource$;
}
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4(F$3) {
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1 = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1 = F$3;
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4() {
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__O__F1__O(fa, f);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.pure__O__O = (function(a) {
  var fa = $n(this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1).pure__O__O(a);
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  $m_Lcats_implicits$();
  var target = $n(this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1).both__O__O__O(($n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance), fa), ($n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance), fb));
  var tc = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1;
  var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = $n(x$1$1)._1__O();
      var b = $n(x$1$1)._2__O();
      return $n(f).apply__O__O__O(a, b);
    }
    throw new $c_s_MatchError(x$1$1);
  }));
  var fa$1 = $n(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$1);
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa$1;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  return this.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$8, _$9) => new $c_T2(_$8, _$9))));
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.map__O__F1__O = (function(fa, f) {
  $m_Lcats_implicits$();
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  var tc = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1;
  var this$4 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(fa, tc);
  var fa$1 = $n(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$4.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa$1;
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.unit__O = (function() {
  var fa = $n(this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4__f_F$1).unit__O();
  $n($m_Lcats_effect_kernel_Par$().Lcats_effect_kernel_Par$__f_instance);
  return fa;
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 = new $TypeData().initClass($c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4, "cats.effect.kernel.instances.GenSpawnInstances$$anon$4", ({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_BigIntOrder() {
}
$c_Lcats_kernel_instances_BigIntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntOrder.prototype.constructor = $c_Lcats_kernel_instances_BigIntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntOrder() {
}
$h_Lcats_kernel_instances_BigIntOrder.prototype = $c_Lcats_kernel_instances_BigIntOrder.prototype;
$c_Lcats_kernel_instances_BigIntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.neqv__s_math_BigInt__s_math_BigInt__Z = (function(x, y) {
  return (!$m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x, y));
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_math_BigInt(x);
  return $n(x$1).hashCode__I();
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $n(x$1).compare__s_math_BigInt__I(y$1);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x$1, y$1);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__s_math_BigInt__s_math_BigInt__Z($as_s_math_BigInt(x), $as_s_math_BigInt(y));
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.lt__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  var this$1 = $n(x$1);
  return $f_s_math_Ordered__$less__O__Z(this$1, y$1);
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.min__O__O__O = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $n(x$1).min__s_math_BigInt__s_math_BigInt(y$1);
});
var $d_Lcats_kernel_instances_BigIntOrder = new $TypeData().initClass($c_Lcats_kernel_instances_BigIntOrder, "cats.kernel.instances.BigIntOrder", ({
  Lcats_kernel_instances_BigIntOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_Next: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_Previous: 1,
  Lcats_kernel_UnboundedEnumerable: 1,
  Lcats_kernel_instances_BigIntUnboundedEnum: 1
}));
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "STRICT", 0);
}
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype = new $h_Ljava_time_format_ResolverStyle();
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.constructor = $c_Ljava_time_format_ResolverStyle$$anon$1;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$$anon$1() {
}
$h_Ljava_time_format_ResolverStyle$$anon$1.prototype = $c_Ljava_time_format_ResolverStyle$$anon$1.prototype;
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_format_ResolverStyle$$anon$1 = new $TypeData().initClass($c_Ljava_time_format_ResolverStyle$$anon$1, "java.time.format.ResolverStyle$$anon$1", ({
  Ljava_time_format_ResolverStyle$$anon$1: 1,
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SMART", 1);
}
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype = new $h_Ljava_time_format_ResolverStyle();
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.constructor = $c_Ljava_time_format_ResolverStyle$$anon$2;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$$anon$2() {
}
$h_Ljava_time_format_ResolverStyle$$anon$2.prototype = $c_Ljava_time_format_ResolverStyle$$anon$2.prototype;
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_format_ResolverStyle$$anon$2 = new $TypeData().initClass($c_Ljava_time_format_ResolverStyle$$anon$2, "java.time.format.ResolverStyle$$anon$2", ({
  Ljava_time_format_ResolverStyle$$anon$2: 1,
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "LENIENT", 2);
}
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype = new $h_Ljava_time_format_ResolverStyle();
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.constructor = $c_Ljava_time_format_ResolverStyle$$anon$3;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$$anon$3() {
}
$h_Ljava_time_format_ResolverStyle$$anon$3.prototype = $c_Ljava_time_format_ResolverStyle$$anon$3.prototype;
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_format_ResolverStyle$$anon$3 = new $TypeData().initClass($c_Ljava_time_format_ResolverStyle$$anon$3, "java.time.format.ResolverStyle$$anon$3", ({
  Ljava_time_format_ResolverStyle$$anon$3: 1,
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_ju_Locale$Category$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DISPLAY", 0);
}
$c_ju_Locale$Category$$anon$2.prototype = new $h_ju_Locale$Category();
$c_ju_Locale$Category$$anon$2.prototype.constructor = $c_ju_Locale$Category$$anon$2;
/** @constructor */
function $h_ju_Locale$Category$$anon$2() {
}
$h_ju_Locale$Category$$anon$2.prototype = $c_ju_Locale$Category$$anon$2.prototype;
$c_ju_Locale$Category$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_ju_Locale$Category$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_ju_Locale$Category$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_ju_Locale$Category$$anon$2 = new $TypeData().initClass($c_ju_Locale$Category$$anon$2, "java.util.Locale$Category$$anon$2", ({
  ju_Locale$Category$$anon$2: 1,
  ju_Locale$Category: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_ju_Locale$Category$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "FORMAT", 1);
}
$c_ju_Locale$Category$$anon$3.prototype = new $h_ju_Locale$Category();
$c_ju_Locale$Category$$anon$3.prototype.constructor = $c_ju_Locale$Category$$anon$3;
/** @constructor */
function $h_ju_Locale$Category$$anon$3() {
}
$h_ju_Locale$Category$$anon$3.prototype = $c_ju_Locale$Category$$anon$3.prototype;
$c_ju_Locale$Category$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_ju_Locale$Category$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_ju_Locale$Category$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_ju_Locale$Category$$anon$3 = new $TypeData().initClass($c_ju_Locale$Category$$anon$3, "java.util.Locale$Category$$anon$3", ({
  ju_Locale$Category$$anon$3: 1,
  ju_Locale$Category: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_sc_AbstractSeq() {
}
$c_sc_AbstractSeq.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSeq.prototype.constructor = $c_sc_AbstractSeq;
/** @constructor */
function $h_sc_AbstractSeq() {
}
$h_sc_AbstractSeq.prototype = $c_sc_AbstractSeq.prototype;
$c_sc_AbstractSeq.prototype.canEqual__O__Z = (function(that) {
  return true;
});
$c_sc_AbstractSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_sc_AbstractSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_sc_AbstractSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_AbstractSeq.prototype.size__I = (function() {
  return this.length__I();
});
$c_sc_AbstractSeq.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_AbstractSeq.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_AbstractSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_sc_AbstractSeq.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$c_sc_AbstractSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sc_AbstractSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_AbstractSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_AbstractSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_AbstractSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sc_AbstractSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sc_AbstractSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sc_AbstractSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sc_AbstractSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sc_AbstractSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_sc_AbstractSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sc_AbstractSeq.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x));
});
/** @constructor */
function $c_sc_AbstractSeqView() {
}
$c_sc_AbstractSeqView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractSeqView.prototype.constructor = $c_sc_AbstractSeqView;
/** @constructor */
function $h_sc_AbstractSeqView() {
}
$h_sc_AbstractSeqView.prototype = $c_sc_AbstractSeqView.prototype;
$c_sc_AbstractSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_AbstractSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_AbstractSeqView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_AbstractSeqView.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_AbstractSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_AbstractSeqView.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_sc_AbstractSeqView.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_AbstractSeqView.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_AbstractSeqView.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_AbstractSeqView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_AbstractSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_AbstractSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
function $is_sc_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeq)));
}
function $as_sc_IndexedSeq(obj) {
  return (($is_sc_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IndexedSeq"));
}
function $isArrayOf_sc_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeq)));
}
function $asArrayOf_sc_IndexedSeq(obj, depth) {
  return (($isArrayOf_sc_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IndexedSeq;", depth));
}
function $is_sc_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeq)));
}
function $as_sc_LinearSeq(obj) {
  return (($is_sc_LinearSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeq"));
}
function $isArrayOf_sc_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeq)));
}
function $asArrayOf_sc_LinearSeq(obj, depth) {
  return (($isArrayOf_sc_LinearSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeq;", depth));
}
/** @constructor */
function $c_sc_View$Empty$() {
}
$c_sc_View$Empty$.prototype = new $h_sc_AbstractView();
$c_sc_View$Empty$.prototype.constructor = $c_sc_View$Empty$;
/** @constructor */
function $h_sc_View$Empty$() {
}
$h_sc_View$Empty$.prototype = $c_sc_View$Empty$.prototype;
$c_sc_View$Empty$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sc_View$Empty$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sc_View$Empty$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sc_View$Empty$.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_sc_View$Empty$.prototype.productArity__I = (function() {
  return 0;
});
$c_sc_View$Empty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sc_View$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sc_View$Empty$.prototype.hashCode__I = (function() {
  return 67081517;
});
var $d_sc_View$Empty$ = new $TypeData().initClass($c_sc_View$Empty$, "scala.collection.View$Empty$", ({
  sc_View$Empty$: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
}));
var $n_sc_View$Empty$;
function $m_sc_View$Empty$() {
  if ((!$n_sc_View$Empty$)) {
    $n_sc_View$Empty$ = new $c_sc_View$Empty$();
  }
  return $n_sc_View$Empty$;
}
function $is_sci_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Set)));
}
function $as_sci_Set(obj) {
  return (($is_sci_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set"));
}
function $isArrayOf_sci_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set)));
}
function $asArrayOf_sci_Set(obj, depth) {
  return (($isArrayOf_sci_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set;", depth));
}
function $f_scm_SetOps__remove__O__Z($thiz, elem) {
  var res = $thiz.contains__O__Z(elem);
  var this$1 = $n($as_scm_Shrinkable($thiz));
  this$1.subtractOne__O__scm_Shrinkable(elem);
  return res;
}
function $is_Lcats_Alternative(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Alternative)));
}
function $as_Lcats_Alternative(obj) {
  return (($is_Lcats_Alternative(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Alternative"));
}
function $isArrayOf_Lcats_Alternative(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Alternative)));
}
function $asArrayOf_Lcats_Alternative(obj, depth) {
  return (($isArrayOf_Lcats_Alternative(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Alternative;", depth));
}
function $f_Lcats_StackSafeMonad__tailRecM__O__F1__O($thiz, a, f) {
  return $thiz.flatMap__O__F1__O($n(f).apply__O__O(a), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    if ((x$1$1 instanceof $c_s_util_Left)) {
      var a$1 = $n($as_s_util_Left(x$1$1)).s_util_Left__f_value;
      return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O($thiz, a$1, f);
    }
    if ((x$1$1 instanceof $c_s_util_Right)) {
      var b = $n($as_s_util_Right(x$1$1)).s_util_Right__f_value;
      return $thiz.pure__O__O(b);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
}
function $is_Lcats_StackSafeMonad(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_StackSafeMonad)));
}
function $as_Lcats_StackSafeMonad(obj) {
  return (($is_Lcats_StackSafeMonad(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.StackSafeMonad"));
}
function $isArrayOf_Lcats_StackSafeMonad(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_StackSafeMonad)));
}
function $asArrayOf_Lcats_StackSafeMonad(obj, depth) {
  return (($isArrayOf_Lcats_StackSafeMonad(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.StackSafeMonad;", depth));
}
/** @constructor */
function $c_Lcats_instances_package$function$() {
  this.Lcats_instances_package$function$__f_catsStdInstancesForFunction1 = null;
  $n_Lcats_instances_package$function$ = this;
  $f_Lcats_instances_Function1Instances__$init$__V(this);
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
}
$c_Lcats_instances_package$function$.prototype = new $h_O();
$c_Lcats_instances_package$function$.prototype.constructor = $c_Lcats_instances_package$function$;
/** @constructor */
function $h_Lcats_instances_package$function$() {
}
$h_Lcats_instances_package$function$.prototype = $c_Lcats_instances_package$function$.prototype;
$c_Lcats_instances_package$function$.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_instances_package$function$__f_catsStdInstancesForFunction1;
});
$c_Lcats_instances_package$function$.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_instances_package$function$__f_catsStdInstancesForFunction1 = x$0;
});
$c_Lcats_instances_package$function$.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
});
var $d_Lcats_instances_package$function$ = new $TypeData().initClass($c_Lcats_instances_package$function$, "cats.instances.package$function$", ({
  Lcats_instances_package$function$: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1
}));
var $n_Lcats_instances_package$function$;
function $m_Lcats_instances_package$function$() {
  if ((!$n_Lcats_instances_package$function$)) {
    $n_Lcats_instances_package$function$ = new $c_Lcats_instances_package$function$();
  }
  return $n_Lcats_instances_package$function$;
}
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "SENSITIVE", 0, "SENSITIVE", 0);
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "INSENSITIVE", 1, "INSENSITIVE", 1);
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "STRICT", 2, "STRICT", 2);
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "LENIENT", 3, "LENIENT", 3);
}
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4() {
}
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "NanoOfSecond", 0, $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 999999999, 0), "NANO_OF_SECOND", 0);
}
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$1() {
}
$h_Ljava_time_temporal_ChronoField$$anon$1.prototype = $c_Ljava_time_temporal_ChronoField$$anon$1.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$1 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$1, "java.time.temporal.ChronoField$$anon$1", ({
  Ljava_time_temporal_ChronoField$$anon$1: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$10() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MinuteOfDay", 9, $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 1439, 0), "MINUTE_OF_DAY", 9);
}
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$10;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$10() {
}
$h_Ljava_time_temporal_ChronoField$$anon$10.prototype = $c_Ljava_time_temporal_ChronoField$$anon$10.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$10 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$10, "java.time.temporal.ChronoField$$anon$10", ({
  Ljava_time_temporal_ChronoField$$anon$10: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$11() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "HourOfAmPm", 10, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 11, 0), "HOUR_OF_AMPM", 10);
}
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$11;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$11() {
}
$h_Ljava_time_temporal_ChronoField$$anon$11.prototype = $c_Ljava_time_temporal_ChronoField$$anon$11.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$11 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$11, "java.time.temporal.ChronoField$$anon$11", ({
  Ljava_time_temporal_ChronoField$$anon$11: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$12() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "ClockHourOfAmPm", 11, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(1, 0, 12, 0), "CLOCK_HOUR_OF_AMPM", 11);
}
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$12;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$12() {
}
$h_Ljava_time_temporal_ChronoField$$anon$12.prototype = $c_Ljava_time_temporal_ChronoField$$anon$12.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$12 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$12, "java.time.temporal.ChronoField$$anon$12", ({
  Ljava_time_temporal_ChronoField$$anon$12: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$13() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "HourOfDay", 12, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 23, 0), "HOUR_OF_DAY", 12);
}
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$13;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$13() {
}
$h_Ljava_time_temporal_ChronoField$$anon$13.prototype = $c_Ljava_time_temporal_ChronoField$$anon$13.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$13 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$13, "java.time.temporal.ChronoField$$anon$13", ({
  Ljava_time_temporal_ChronoField$$anon$13: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$14() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "ClockHourOfDay", 13, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(1, 0, 24, 0), "CLOCK_HOUR_OF_DAY", 13);
}
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$14;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$14() {
}
$h_Ljava_time_temporal_ChronoField$$anon$14.prototype = $c_Ljava_time_temporal_ChronoField$$anon$14.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$14 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$14, "java.time.temporal.ChronoField$$anon$14", ({
  Ljava_time_temporal_ChronoField$$anon$14: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$15() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AmPmOfDay", 14, $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 1, 0), "AMPM_OF_DAY", 14);
}
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$15;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$15() {
}
$h_Ljava_time_temporal_ChronoField$$anon$15.prototype = $c_Ljava_time_temporal_ChronoField$$anon$15.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$15 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$15, "java.time.temporal.ChronoField$$anon$15", ({
  Ljava_time_temporal_ChronoField$$anon$15: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$16() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "DayOfWeek", 15, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(1, 0, 7, 0), "DAY_OF_WEEK", 15);
}
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$16;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$16() {
}
$h_Ljava_time_temporal_ChronoField$$anon$16.prototype = $c_Ljava_time_temporal_ChronoField$$anon$16.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$16 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$16, "java.time.temporal.ChronoField$$anon$16", ({
  Ljava_time_temporal_ChronoField$$anon$16: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$17() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedDayOfWeekInMonth", 16, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(1, 0, 7, 0), "ALIGNED_DAY_OF_WEEK_IN_MONTH", 16);
}
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$17;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$17() {
}
$h_Ljava_time_temporal_ChronoField$$anon$17.prototype = $c_Ljava_time_temporal_ChronoField$$anon$17.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$17 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$17, "java.time.temporal.ChronoField$$anon$17", ({
  Ljava_time_temporal_ChronoField$$anon$17: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$18() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedDayOfWeekInYear", 17, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(1, 0, 7, 0), "ALIGNED_DAY_OF_WEEK_IN_YEAR", 17);
}
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$18;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$18() {
}
$h_Ljava_time_temporal_ChronoField$$anon$18.prototype = $c_Ljava_time_temporal_ChronoField$$anon$18.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$18 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$18, "java.time.temporal.ChronoField$$anon$18", ({
  Ljava_time_temporal_ChronoField$$anon$18: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$19() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  var this$1 = $m_Ljava_time_temporal_ValueRange$();
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "DayOfMonth", 18, $x_2, $x_1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(1, 0, 1, 0, 28, 0, 31, 0), "DAY_OF_MONTH", 18);
}
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$19;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$19() {
}
$h_Ljava_time_temporal_ChronoField$$anon$19.prototype = $c_Ljava_time_temporal_ChronoField$$anon$19.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$19 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$19, "java.time.temporal.ChronoField$$anon$19", ({
  Ljava_time_temporal_ChronoField$$anon$19: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "NanoOfDay", 1, $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, (-1857093633), 20116), "NANO_OF_DAY", 1);
}
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$2() {
}
$h_Ljava_time_temporal_ChronoField$$anon$2.prototype = $c_Ljava_time_temporal_ChronoField$$anon$2.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$2 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$2, "java.time.temporal.ChronoField$$anon$2", ({
  Ljava_time_temporal_ChronoField$$anon$2: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$20() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  var this$1 = $m_Ljava_time_temporal_ValueRange$();
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "DayOfYear", 19, $x_2, $x_1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(1, 0, 1, 0, 365, 0, 366, 0), "DAY_OF_YEAR", 19);
}
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$20;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$20() {
}
$h_Ljava_time_temporal_ChronoField$$anon$20.prototype = $c_Ljava_time_temporal_ChronoField$$anon$20.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$20 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$20, "java.time.temporal.ChronoField$$anon$20", ({
  Ljava_time_temporal_ChronoField$$anon$20: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$21() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "EpochDay", 20, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange((-170999002), (-86), 169560311, 85), "EPOCH_DAY", 20);
}
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$21;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$21() {
}
$h_Ljava_time_temporal_ChronoField$$anon$21.prototype = $c_Ljava_time_temporal_ChronoField$$anon$21.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$21 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$21, "java.time.temporal.ChronoField$$anon$21", ({
  Ljava_time_temporal_ChronoField$$anon$21: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$22() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  var this$1 = $m_Ljava_time_temporal_ValueRange$();
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedWeekOfMonth", 21, $x_2, $x_1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(1, 0, 1, 0, 4, 0, 5, 0), "ALIGNED_WEEK_OF_MONTH", 21);
}
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$22;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$22() {
}
$h_Ljava_time_temporal_ChronoField$$anon$22.prototype = $c_Ljava_time_temporal_ChronoField$$anon$22.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$22 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$22, "java.time.temporal.ChronoField$$anon$22", ({
  Ljava_time_temporal_ChronoField$$anon$22: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$23() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedWeekOfYear", 22, $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(1, 0, 53, 0), "ALIGNED_WEEK_OF_YEAR", 22);
}
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$23;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$23() {
}
$h_Ljava_time_temporal_ChronoField$$anon$23.prototype = $c_Ljava_time_temporal_ChronoField$$anon$23.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$23 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$23, "java.time.temporal.ChronoField$$anon$23", ({
  Ljava_time_temporal_ChronoField$$anon$23: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$24() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MonthOfYear", 23, $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(1, 0, 12, 0), "MONTH_OF_YEAR", 23);
}
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$24;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$24() {
}
$h_Ljava_time_temporal_ChronoField$$anon$24.prototype = $c_Ljava_time_temporal_ChronoField$$anon$24.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$24 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$24, "java.time.temporal.ChronoField$$anon$24", ({
  Ljava_time_temporal_ChronoField$$anon$24: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$25() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_3 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $m_Ljava_time_temporal_ValueRange$();
  var value = $m_Ljava_time_Year$().MIN_VALUE__I();
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi$2 = (value$1 >> 31);
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(12, b0$1);
  var a0b1$1 = Math.imul(12, b1$1);
  var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((Math.imul(12, hi$2) + ((c1part$1 >>> 16) | 0)) | 0);
  var lo$2 = ((11 + lo$1) | 0);
  var hi$4 = ((hi$3 + (((lo$1 & (~lo$2)) >>> 31) | 0)) | 0);
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "ProlepticMonth", 24, $x_3, $x_2, $x_1.of__J__J__Ljava_time_temporal_ValueRange(lo, hi$1, lo$2, hi$4), "PROLEPTIC_MONTH", 24);
}
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$25;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$25() {
}
$h_Ljava_time_temporal_ChronoField$$anon$25.prototype = $c_Ljava_time_temporal_ChronoField$$anon$25.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$25 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$25, "java.time.temporal.ChronoField$$anon$25", ({
  Ljava_time_temporal_ChronoField$$anon$25: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$26() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var this$4 = $m_Ljava_time_temporal_ValueRange$();
  var value = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi = (value >> 31);
  var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi$1 = (value$1 >> 31);
  var lo = ((1 + value$1) | 0);
  var hi$2 = ((hi$1 + (((value$1 & (~lo)) >>> 31) | 0)) | 0);
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "YearOfEra", 25, $x_2, $x_1, this$4.of__J__J__J__J__Ljava_time_temporal_ValueRange(1, 0, 1, 0, value, hi, lo, hi$2), "YEAR_OF_ERA", 25);
}
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$26;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$26() {
}
$h_Ljava_time_temporal_ChronoField$$anon$26.prototype = $c_Ljava_time_temporal_ChronoField$$anon$26.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$26 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$26, "java.time.temporal.ChronoField$$anon$26", ({
  Ljava_time_temporal_ChronoField$$anon$26: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$27() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_3 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $m_Ljava_time_temporal_ValueRange$();
  var value = $m_Ljava_time_Year$().MIN_VALUE__I();
  var hi = (value >> 31);
  var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi$1 = (value$1 >> 31);
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "Year", 26, $x_3, $x_2, $x_1.of__J__J__Ljava_time_temporal_ValueRange(value, hi, value$1, hi$1), "YEAR", 26);
}
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$27;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$27() {
}
$h_Ljava_time_temporal_ChronoField$$anon$27.prototype = $c_Ljava_time_temporal_ChronoField$$anon$27.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$27 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$27, "java.time.temporal.ChronoField$$anon$27", ({
  Ljava_time_temporal_ChronoField$$anon$27: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$28() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "Era", 27, $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 1, 0), "ERA", 27);
}
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$28;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$28() {
}
$h_Ljava_time_temporal_ChronoField$$anon$28.prototype = $c_Ljava_time_temporal_ChronoField$$anon$28.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$28 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$28, "java.time.temporal.ChronoField$$anon$28", ({
  Ljava_time_temporal_ChronoField$$anon$28: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$29() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "InstantSeconds", 28, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, (-2147483648), (-1), 2147483647), "INSTANT_SECONDS", 28);
}
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$29;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$29() {
}
$h_Ljava_time_temporal_ChronoField$$anon$29.prototype = $c_Ljava_time_temporal_ChronoField$$anon$29.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$29 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$29, "java.time.temporal.ChronoField$$anon$29", ({
  Ljava_time_temporal_ChronoField$$anon$29: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MicroOfSecond", 2, $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 999999, 0), "MICRO_OF_SECOND", 2);
}
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$3() {
}
$h_Ljava_time_temporal_ChronoField$$anon$3.prototype = $c_Ljava_time_temporal_ChronoField$$anon$3.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$3 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$3, "java.time.temporal.ChronoField$$anon$3", ({
  Ljava_time_temporal_ChronoField$$anon$3: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$30() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "OffsetSeconds", 29, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange((-64800), (-1), 64800, 0), "OFFSET_SECONDS", 29);
}
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$30;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$30() {
}
$h_Ljava_time_temporal_ChronoField$$anon$30.prototype = $c_Ljava_time_temporal_ChronoField$$anon$30.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$30 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$30, "java.time.temporal.ChronoField$$anon$30", ({
  Ljava_time_temporal_ChronoField$$anon$30: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MicroOfDay", 3, $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 500654079, 20), "MICRO_OF_DAY", 3);
}
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$4() {
}
$h_Ljava_time_temporal_ChronoField$$anon$4.prototype = $c_Ljava_time_temporal_ChronoField$$anon$4.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$4 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$4, "java.time.temporal.ChronoField$$anon$4", ({
  Ljava_time_temporal_ChronoField$$anon$4: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MilliOfSecond", 4, $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 999, 0), "MILLI_OF_SECOND", 4);
}
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$5() {
}
$h_Ljava_time_temporal_ChronoField$$anon$5.prototype = $c_Ljava_time_temporal_ChronoField$$anon$5.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$5 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$5, "java.time.temporal.ChronoField$$anon$5", ({
  Ljava_time_temporal_ChronoField$$anon$5: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MilliOfDay", 5, $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 86399999, 0), "MILLI_OF_DAY", 5);
}
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$6() {
}
$h_Ljava_time_temporal_ChronoField$$anon$6.prototype = $c_Ljava_time_temporal_ChronoField$$anon$6.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$6 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$6, "java.time.temporal.ChronoField$$anon$6", ({
  Ljava_time_temporal_ChronoField$$anon$6: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "SecondOfMinute", 6, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 59, 0), "SECOND_OF_MINUTE", 6);
}
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$7() {
}
$h_Ljava_time_temporal_ChronoField$$anon$7.prototype = $c_Ljava_time_temporal_ChronoField$$anon$7.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$7 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$7, "java.time.temporal.ChronoField$$anon$7", ({
  Ljava_time_temporal_ChronoField$$anon$7: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$8() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "SecondOfDay", 7, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 86399, 0), "SECOND_OF_DAY", 7);
}
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$8;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$8() {
}
$h_Ljava_time_temporal_ChronoField$$anon$8.prototype = $c_Ljava_time_temporal_ChronoField$$anon$8.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$8 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$8, "java.time.temporal.ChronoField$$anon$8", ({
  Ljava_time_temporal_ChronoField$$anon$8: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$9() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MinuteOfHour", 8, $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(0, 0, 59, 0), "MINUTE_OF_HOUR", 8);
}
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$9;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$9() {
}
$h_Ljava_time_temporal_ChronoField$$anon$9.prototype = $c_Ljava_time_temporal_ChronoField$$anon$9.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoField$$anon$9 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$9, "java.time.temporal.ChronoField$$anon$9", ({
  Ljava_time_temporal_ChronoField$$anon$9: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Nanos", 0, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(1, 0), "NANOS", 0);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$1() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$1.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$1 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$1, "java.time.temporal.ChronoUnit$$anon$1", ({
  Ljava_time_temporal_ChronoUnit$$anon$1: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$10() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Months", 9, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(2629746, 0, 0), "MONTHS", 9);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$10;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$10() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$10.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$10 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$10, "java.time.temporal.ChronoUnit$$anon$10", ({
  Ljava_time_temporal_ChronoUnit$$anon$10: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$11() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Years", 10, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(31556952, 0, 0), "YEARS", 10);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$11;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$11() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$11.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$11 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$11, "java.time.temporal.ChronoUnit$$anon$11", ({
  Ljava_time_temporal_ChronoUnit$$anon$11: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$12() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Decades", 11, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(315569520, 0, 0), "DECADES", 11);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$12;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$12() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$12.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$12 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$12, "java.time.temporal.ChronoUnit$$anon$12", ({
  Ljava_time_temporal_ChronoUnit$$anon$12: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$13() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Centuries", 12, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration((-1139272096), 0, 0), "CENTURIES", 12);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$13;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$13() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$13.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$13 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$13, "java.time.temporal.ChronoUnit$$anon$13", ({
  Ljava_time_temporal_ChronoUnit$$anon$13: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$14() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Millenia", 13, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(1492180928, 7, 0), "MILLENNIA", 13);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$14;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$14() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$14.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$14 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$14, "java.time.temporal.ChronoUnit$$anon$14", ({
  Ljava_time_temporal_ChronoUnit$$anon$14: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$15() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Eras", 14, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(1915187200, 7347425, 0), "ERAS", 14);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$15;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$15() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$15.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$15 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$15, "java.time.temporal.ChronoUnit$$anon$15", ({
  Ljava_time_temporal_ChronoUnit$$anon$15: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$16() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Forever", 15, $m_Ljava_time_Duration$().ofSeconds__J__J__Ljava_time_Duration((-1), 2147483647, 999999999, 0), "FOREVER", 15);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$16;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$16() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$16.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$16 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$16, "java.time.temporal.ChronoUnit$$anon$16", ({
  Ljava_time_temporal_ChronoUnit$$anon$16: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Micros", 1, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(1000, 0), "MICROS", 1);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$2() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$2.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$2 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$2, "java.time.temporal.ChronoUnit$$anon$2", ({
  Ljava_time_temporal_ChronoUnit$$anon$2: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Millis", 2, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(1000000, 0), "MILLIS", 2);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$3() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$3.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$3 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$3, "java.time.temporal.ChronoUnit$$anon$3", ({
  Ljava_time_temporal_ChronoUnit$$anon$3: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Seconds", 3, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(1, 0, 0), "SECONDS", 3);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$4() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$4.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$4 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$4, "java.time.temporal.ChronoUnit$$anon$4", ({
  Ljava_time_temporal_ChronoUnit$$anon$4: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Minutes", 4, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(60, 0, 0), "MINUTES", 4);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$5() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$5.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$5 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$5, "java.time.temporal.ChronoUnit$$anon$5", ({
  Ljava_time_temporal_ChronoUnit$$anon$5: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Hours", 5, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(3600, 0, 0), "HOURS", 5);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$6() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$6.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$6 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$6, "java.time.temporal.ChronoUnit$$anon$6", ({
  Ljava_time_temporal_ChronoUnit$$anon$6: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "HalfDays", 6, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(43200, 0, 0), "HALF_DAYS", 6);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$7() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$7.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$7 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$7, "java.time.temporal.ChronoUnit$$anon$7", ({
  Ljava_time_temporal_ChronoUnit$$anon$7: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$8() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Days", 7, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(86400, 0, 0), "DAYS", 7);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$8;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$8() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$8.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$8 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$8, "java.time.temporal.ChronoUnit$$anon$8", ({
  Ljava_time_temporal_ChronoUnit$$anon$8: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$9() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Weeks", 8, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(604800, 0, 0), "WEEKS", 8);
}
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$9;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$9() {
}
$h_Ljava_time_temporal_ChronoUnit$$anon$9.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$9 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$9, "java.time.temporal.ChronoUnit$$anon$9", ({
  Ljava_time_temporal_ChronoUnit$$anon$9: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_sc_AbstractMap() {
}
$c_sc_AbstractMap.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractMap.prototype.constructor = $c_sc_AbstractMap;
/** @constructor */
function $h_sc_AbstractMap() {
}
$h_sc_AbstractMap.prototype = $c_sc_AbstractMap.prototype;
$c_sc_AbstractMap.prototype.equals__O__Z = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$c_sc_AbstractMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(this);
});
$c_sc_AbstractMap.prototype.stringPrefix__T = (function() {
  return "Map";
});
$c_sc_AbstractMap.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps($n(this.mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(coll));
});
$c_sc_AbstractMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $n(this.mapFactory__sc_MapFactory()).newBuilder__scm_Builder();
});
$c_sc_AbstractMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$c_sc_AbstractMap.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$c_sc_AbstractMap.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sc_AbstractMap.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$c_sc_AbstractMap.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$c_sc_AbstractMap.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$c_sc_AbstractMap.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_sc_AbstractMap.prototype.isDefinedAt__O__Z = (function(key) {
  return this.contains__O__Z(key);
});
$c_sc_AbstractMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f);
});
$c_sc_AbstractMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$c_sc_AbstractMap.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$c_sc_AbstractMap.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sc_AbstractMap.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sc_AbstractMap.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sc_AbstractMap.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__O__O(v1));
});
$c_sc_AbstractMap.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractMap.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll);
});
function $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Drop__f_underlying = underlying;
  $thiz.sc_SeqView$Drop__f_n = n;
  $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
}
$c_sc_SeqView$Drop.prototype = new $h_sc_View$Drop();
$c_sc_SeqView$Drop.prototype.constructor = $c_sc_SeqView$Drop;
/** @constructor */
function $h_sc_SeqView$Drop() {
}
$h_sc_SeqView$Drop.prototype = $c_sc_SeqView$Drop.prototype;
$c_sc_SeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Drop.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_SeqView$Drop.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_sc_SeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Drop.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Drop.prototype.length__I = (function() {
  var this$1 = $n(this.sc_SeqView$Drop__f_underlying);
  var x = ((this$1.length__I() - this.sc_View$Drop__f_normN) | 0);
  return ((x > 0) ? x : 0);
});
$c_sc_SeqView$Drop.prototype.apply__I__O = (function(i) {
  return $n(this.sc_SeqView$Drop__f_underlying).apply__I__O(((i + this.sc_View$Drop__f_normN) | 0));
});
$c_sc_SeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this.sc_SeqView$Drop__f_underlying, ((this.sc_SeqView$Drop__f_n + n) | 0));
});
$c_sc_SeqView$Drop.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
$c_sc_SeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
var $d_sc_SeqView$Drop = new $TypeData().initClass($c_sc_SeqView$Drop, "scala.collection.SeqView$Drop", ({
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$DropRight__f_underlying = underlying;
  $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n);
  var this$1 = $n(underlying);
  var x = ((this$1.length__I() - ((n > 0) ? n : 0)) | 0);
  $thiz.sc_SeqView$DropRight__f_len = ((x > 0) ? x : 0);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
}
$c_sc_SeqView$DropRight.prototype = new $h_sc_View$DropRight();
$c_sc_SeqView$DropRight.prototype.constructor = $c_sc_SeqView$DropRight;
/** @constructor */
function $h_sc_SeqView$DropRight() {
}
$h_sc_SeqView$DropRight.prototype = $c_sc_SeqView$DropRight.prototype;
$c_sc_SeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$DropRight.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_SeqView$DropRight.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_sc_SeqView$DropRight.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$DropRight.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$DropRight.prototype.length__I = (function() {
  return this.sc_SeqView$DropRight__f_len;
});
$c_sc_SeqView$DropRight.prototype.apply__I__O = (function(i) {
  return $n(this.sc_SeqView$DropRight__f_underlying).apply__I__O(i);
});
$c_sc_SeqView$DropRight.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$DropRight.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$DropRight.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$DropRight = new $TypeData().initClass($c_sc_SeqView$DropRight, "scala.collection.SeqView$DropRight", ({
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Id__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Id__f_underlying = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Id() {
  this.sc_SeqView$Id__f_underlying = null;
}
$c_sc_SeqView$Id.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Id.prototype.constructor = $c_sc_SeqView$Id;
/** @constructor */
function $h_sc_SeqView$Id() {
}
$h_sc_SeqView$Id.prototype = $c_sc_SeqView$Id.prototype;
$c_sc_SeqView$Id.prototype.apply__I__O = (function(idx) {
  return $n(this.sc_SeqView$Id__f_underlying).apply__I__O(idx);
});
$c_sc_SeqView$Id.prototype.length__I = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).length__I();
});
$c_sc_SeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).iterator__sc_Iterator();
});
$c_sc_SeqView$Id.prototype.knownSize__I = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).knownSize__I();
});
$c_sc_SeqView$Id.prototype.isEmpty__Z = (function() {
  return $n(this.sc_SeqView$Id__f_underlying).isEmpty__Z();
});
var $d_sc_SeqView$Id = new $TypeData().initClass($c_sc_SeqView$Id, "scala.collection.SeqView$Id", ({
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f) {
  $thiz.sc_SeqView$Map__f_underlying = underlying;
  $thiz.sc_SeqView$Map__f_f = f;
  $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
}
$c_sc_SeqView$Map.prototype = new $h_sc_View$Map();
$c_sc_SeqView$Map.prototype.constructor = $c_sc_SeqView$Map;
/** @constructor */
function $h_sc_SeqView$Map() {
}
$h_sc_SeqView$Map.prototype = $c_sc_SeqView$Map.prototype;
$c_sc_SeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Map.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.reversed__sc_Iterable()).iterator__sc_Iterator();
});
$c_sc_SeqView$Map.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_sc_SeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Map.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Map.prototype.apply__I__O = (function(idx) {
  return $n(this.sc_SeqView$Map__f_f).apply__O__O($n(this.sc_SeqView$Map__f_underlying).apply__I__O(idx));
});
$c_sc_SeqView$Map.prototype.length__I = (function() {
  return $n(this.sc_SeqView$Map__f_underlying).length__I();
});
$c_sc_SeqView$Map.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Map.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$Map = new $TypeData().initClass($c_sc_SeqView$Map, "scala.collection.SeqView$Map", ({
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Reverse__f_underlying = underlying;
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Reverse() {
  this.sc_SeqView$Reverse__f_underlying = null;
}
$c_sc_SeqView$Reverse.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Reverse.prototype.constructor = $c_sc_SeqView$Reverse;
/** @constructor */
function $h_sc_SeqView$Reverse() {
}
$h_sc_SeqView$Reverse.prototype = $c_sc_SeqView$Reverse.prototype;
$c_sc_SeqView$Reverse.prototype.apply__I__O = (function(i) {
  return $n(this.sc_SeqView$Reverse__f_underlying).apply__I__O(((((this.length__I() - 1) | 0) - i) | 0));
});
$c_sc_SeqView$Reverse.prototype.length__I = (function() {
  var this$1 = $n(this.sc_SeqView$Reverse__f_underlying);
  return this$1.length__I();
});
$c_sc_SeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_SeqView$Reverse__f_underlying).reverseIterator__sc_Iterator();
});
$c_sc_SeqView$Reverse.prototype.knownSize__I = (function() {
  return $n(this.sc_SeqView$Reverse__f_underlying).knownSize__I();
});
$c_sc_SeqView$Reverse.prototype.isEmpty__Z = (function() {
  return $n(this.sc_SeqView$Reverse__f_underlying).isEmpty__Z();
});
var $d_sc_SeqView$Reverse = new $TypeData().initClass($c_sc_SeqView$Reverse, "scala.collection.SeqView$Reverse", ({
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
function $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Take__f_underlying = underlying;
  $thiz.sc_SeqView$Take__f_n = n;
  $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_SeqView$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
}
$c_sc_SeqView$Take.prototype = new $h_sc_View$Take();
$c_sc_SeqView$Take.prototype.constructor = $c_sc_SeqView$Take;
/** @constructor */
function $h_sc_SeqView$Take() {
}
$h_sc_SeqView$Take.prototype = $c_sc_SeqView$Take.prototype;
$c_sc_SeqView$Take.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_sc_SeqView$Take.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Take.prototype.apply__I__O = (function(idx) {
  if ((idx < this.sc_SeqView$Take__f_n)) {
    return $n(this.sc_SeqView$Take__f_underlying).apply__I__O(idx);
  } else {
    throw $n((($n(this.sc_SeqView$Take__f_underlying).knownSize__I() >= 0) ? $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, ((this.knownSize__I() - 1) | 0)) : $m_scg_CommonErrors$().indexOutOfBounds__I__jl_IndexOutOfBoundsException(idx)));
  }
});
$c_sc_SeqView$Take.prototype.length__I = (function() {
  var x = $n(this.sc_SeqView$Take__f_underlying).length__I();
  var that = this.sc_View$Take__f_normN;
  return ((x < that) ? x : that);
});
$c_sc_SeqView$Take.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
function $f_sc_SortedSet__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  }
  if ($is_sc_SortedSet(that)) {
    var x2 = $as_sc_SortedSet(that);
    var x = $n(x2).ordering__s_math_Ordering();
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
      if ((($n(x2), true) && ($thiz.size__I() === $n(x2).size__I()))) {
        var i1 = $thiz.iterator__sc_Iterator();
        var i2 = $n(x2).iterator__sc_Iterator();
        var allEqual = true;
        while ((allEqual && $n(i1).hasNext__Z())) {
          allEqual = $n($thiz.ordering__s_math_Ordering()).equiv__O__O__Z($n(i1).next__O(), $n(i2).next__O());
        }
        return allEqual;
      } else {
        return false;
      }
    }
  }
  return $f_sc_Set__equals__O__Z($thiz, that);
}
function $is_sc_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SortedSet)));
}
function $as_sc_SortedSet(obj) {
  return (($is_sc_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SortedSet"));
}
function $isArrayOf_sc_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SortedSet)));
}
function $asArrayOf_sc_SortedSet(obj, depth) {
  return (($isArrayOf_sc_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SortedSet;", depth));
}
function $is_sci_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Seq)));
}
function $as_sci_Seq(obj) {
  return (($is_sci_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Seq"));
}
function $isArrayOf_sci_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Seq)));
}
function $asArrayOf_sci_Seq(obj, depth) {
  return (($isArrayOf_sci_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Seq;", depth));
}
function $f_scm_MapOps__update__O__O__V($thiz, key, value) {
  var this$1 = $n($as_scm_Growable($thiz));
  var elem = new $c_T2(key, value);
  this$1.addOne__O__scm_Growable(elem);
}
function $f_scm_MapOps__getOrElseUpdate__O__F0__O($thiz, key, defaultValue) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $n(x2).s_Some__f_value;
    return v;
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var d = $n(defaultValue).apply__O();
      $thiz.update__O__O__V(key, d);
      return d;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
}
/** @constructor */
function $c_Lcats_Invariant$() {
}
$c_Lcats_Invariant$.prototype = new $h_O();
$c_Lcats_Invariant$.prototype.constructor = $c_Lcats_Invariant$;
/** @constructor */
function $h_Lcats_Invariant$() {
}
$h_Lcats_Invariant$.prototype = $c_Lcats_Invariant$.prototype;
var $d_Lcats_Invariant$ = new $TypeData().initClass($c_Lcats_Invariant$, "cats.Invariant$", ({
  Lcats_Invariant$: 1,
  Lcats_ScalaVersionSpecificInvariantInstances: 1,
  Lcats_instances_NTupleMonadInstances5: 1,
  Lcats_instances_NTupleMonadInstances4: 1,
  Lcats_instances_NTupleMonadInstances3: 1,
  Lcats_instances_NTupleMonadInstances2: 1,
  Lcats_instances_NTupleMonadInstances1: 1,
  Lcats_instances_NTupleMonadInstances: 1,
  Lcats_TupleInstances2: 1,
  Lcats_TupleInstances1: 1,
  Lcats_TupleInstances0: 1,
  Lcats_InvariantInstances2: 1,
  Lcats_InvariantInstances1: 1,
  Lcats_InvariantInstances0: 1
}));
var $n_Lcats_Invariant$;
function $m_Lcats_Invariant$() {
  if ((!$n_Lcats_Invariant$)) {
    $n_Lcats_Invariant$ = new $c_Lcats_Invariant$();
  }
  return $n_Lcats_Invariant$;
}
function $f_Lcats_MonadError__redeemWith__O__F1__F1__O($thiz, fa, recover, bind) {
  return $thiz.flatMap__O__F1__O($thiz.attempt__O__O(fa), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
    var _$3$1 = $as_s_util_Either(_$3);
    return $n(_$3$1).fold__F1__F1__O(recover, bind);
  })));
}
function $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli($thiz, e) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$166) => $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).raiseError__O__O(e)));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli($thiz, kb, f) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n($thiz.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1).handleErrorWith__O__F1__O($n($n(kb).Lcats_data_Kleisli__f_run).apply__O__O(a), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((e) => $n($n($as_Lcats_data_Kleisli($n(f).apply__O__O(e))).Lcats_data_Kleisli__f_run).apply__O__O(a))))));
  return new $c_Lcats_data_Kleisli(run);
}
function $ct_Lcats_effect_kernel_ResourceMonad__($thiz) {
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceMonad() {
}
$c_Lcats_effect_kernel_ResourceMonad.prototype = new $h_O();
$c_Lcats_effect_kernel_ResourceMonad.prototype.constructor = $c_Lcats_effect_kernel_ResourceMonad;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceMonad() {
}
$h_Lcats_effect_kernel_ResourceMonad.prototype = $c_Lcats_effect_kernel_ResourceMonad.prototype;
$c_Lcats_effect_kernel_ResourceMonad.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.unit__O = (function() {
  return new $c_Lcats_effect_kernel_Resource$Pure((void 0));
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.pure__O__O = (function(x) {
  return new $c_Lcats_effect_kernel_Resource$Pure(x);
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_kernel_Resource$Bind(this$1, f);
});
var $d_Lcats_effect_kernel_ResourceMonad = new $TypeData().initClass($c_Lcats_effect_kernel_ResourceMonad, "cats.effect.kernel.ResourceMonad", ({
  Lcats_effect_kernel_ResourceMonad: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_StackSafeMonad: 1
}));
/** @constructor */
function $c_Lcats_effect_syntax_package$all$() {
}
$c_Lcats_effect_syntax_package$all$.prototype = new $h_O();
$c_Lcats_effect_syntax_package$all$.prototype.constructor = $c_Lcats_effect_syntax_package$all$;
/** @constructor */
function $h_Lcats_effect_syntax_package$all$() {
}
$h_Lcats_effect_syntax_package$all$.prototype = $c_Lcats_effect_syntax_package$all$.prototype;
var $d_Lcats_effect_syntax_package$all$ = new $TypeData().initClass($c_Lcats_effect_syntax_package$all$, "cats.effect.syntax.package$all$", ({
  Lcats_effect_syntax_package$all$: 1,
  Lcats_effect_kernel_syntax_MonadCancelSyntax: 1,
  Lcats_effect_kernel_syntax_GenSpawnSyntax: 1,
  Lcats_effect_kernel_syntax_GenTemporalSyntax: 1,
  Lcats_effect_kernel_syntax_GenConcurrentSyntax: 1,
  Lcats_effect_kernel_syntax_AsyncSyntax: 1,
  Lcats_effect_kernel_syntax_ResourceSyntax: 1,
  Lcats_effect_kernel_syntax_ClockSyntax: 1,
  Lcats_effect_kernel_syntax_AllSyntax: 1,
  Lcats_effect_std_syntax_BackpressureSyntax: 1,
  Lcats_effect_std_syntax_SupervisorSyntax: 1,
  Lcats_effect_std_syntax_AllSyntax: 1,
  Lcats_effect_syntax_DispatcherSyntax: 1,
  Lcats_effect_syntax_AllSyntax: 1
}));
var $n_Lcats_effect_syntax_package$all$;
function $m_Lcats_effect_syntax_package$all$() {
  if ((!$n_Lcats_effect_syntax_package$all$)) {
    $n_Lcats_effect_syntax_package$all$ = new $c_Lcats_effect_syntax_package$all$();
  }
  return $n_Lcats_effect_syntax_package$all$;
}
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "MONDAY", 0, "MONDAY", 0);
}
$c_Ljava_time_DayOfWeek$$anon$1.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$1.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$1;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$1() {
}
$h_Ljava_time_DayOfWeek$$anon$1.prototype = $c_Ljava_time_DayOfWeek$$anon$1.prototype;
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_DayOfWeek$$anon$1 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$1, "java.time.DayOfWeek$$anon$1", ({
  Ljava_time_DayOfWeek$$anon$1: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "TUESDAY", 1, "TUESDAY", 1);
}
$c_Ljava_time_DayOfWeek$$anon$2.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$2.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$2;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$2() {
}
$h_Ljava_time_DayOfWeek$$anon$2.prototype = $c_Ljava_time_DayOfWeek$$anon$2.prototype;
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_DayOfWeek$$anon$2 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$2, "java.time.DayOfWeek$$anon$2", ({
  Ljava_time_DayOfWeek$$anon$2: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "WEDNESDAY", 2, "WEDNESDAY", 2);
}
$c_Ljava_time_DayOfWeek$$anon$3.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$3.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$3;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$3() {
}
$h_Ljava_time_DayOfWeek$$anon$3.prototype = $c_Ljava_time_DayOfWeek$$anon$3.prototype;
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_DayOfWeek$$anon$3 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$3, "java.time.DayOfWeek$$anon$3", ({
  Ljava_time_DayOfWeek$$anon$3: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "THURSDAY", 3, "THURSDAY", 3);
}
$c_Ljava_time_DayOfWeek$$anon$4.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$4.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$4;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$4() {
}
$h_Ljava_time_DayOfWeek$$anon$4.prototype = $c_Ljava_time_DayOfWeek$$anon$4.prototype;
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_DayOfWeek$$anon$4 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$4, "java.time.DayOfWeek$$anon$4", ({
  Ljava_time_DayOfWeek$$anon$4: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "FRIDAY", 4, "FRIDAY", 4);
}
$c_Ljava_time_DayOfWeek$$anon$5.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$5.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$5;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$5() {
}
$h_Ljava_time_DayOfWeek$$anon$5.prototype = $c_Ljava_time_DayOfWeek$$anon$5.prototype;
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_DayOfWeek$$anon$5 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$5, "java.time.DayOfWeek$$anon$5", ({
  Ljava_time_DayOfWeek$$anon$5: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "SATURDAY", 5, "SATURDAY", 5);
}
$c_Ljava_time_DayOfWeek$$anon$6.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$6.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$6;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$6() {
}
$h_Ljava_time_DayOfWeek$$anon$6.prototype = $c_Ljava_time_DayOfWeek$$anon$6.prototype;
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_DayOfWeek$$anon$6 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$6, "java.time.DayOfWeek$$anon$6", ({
  Ljava_time_DayOfWeek$$anon$6: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "SUNDAY", 6, "SUNDAY", 6);
}
$c_Ljava_time_DayOfWeek$$anon$7.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$7.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$7;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$7() {
}
$h_Ljava_time_DayOfWeek$$anon$7.prototype = $c_Ljava_time_DayOfWeek$$anon$7.prototype;
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_DayOfWeek$$anon$7 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$7, "java.time.DayOfWeek$$anon$7", ({
  Ljava_time_DayOfWeek$$anon$7: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JANUARY", 0, "JANUARY", 0);
}
$c_Ljava_time_Month$$anon$1.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$1.prototype.constructor = $c_Ljava_time_Month$$anon$1;
/** @constructor */
function $h_Ljava_time_Month$$anon$1() {
}
$h_Ljava_time_Month$$anon$1.prototype = $c_Ljava_time_Month$$anon$1.prototype;
$c_Ljava_time_Month$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$1 = new $TypeData().initClass($c_Ljava_time_Month$$anon$1, "java.time.Month$$anon$1", ({
  Ljava_time_Month$$anon$1: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$10() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "OCTOBER", 9, "OCTOBER", 9);
}
$c_Ljava_time_Month$$anon$10.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$10.prototype.constructor = $c_Ljava_time_Month$$anon$10;
/** @constructor */
function $h_Ljava_time_Month$$anon$10() {
}
$h_Ljava_time_Month$$anon$10.prototype = $c_Ljava_time_Month$$anon$10.prototype;
$c_Ljava_time_Month$$anon$10.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$10.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$10.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$10 = new $TypeData().initClass($c_Ljava_time_Month$$anon$10, "java.time.Month$$anon$10", ({
  Ljava_time_Month$$anon$10: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$11() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "NOVEMBER", 10, "NOVEMBER", 10);
}
$c_Ljava_time_Month$$anon$11.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$11.prototype.constructor = $c_Ljava_time_Month$$anon$11;
/** @constructor */
function $h_Ljava_time_Month$$anon$11() {
}
$h_Ljava_time_Month$$anon$11.prototype = $c_Ljava_time_Month$$anon$11.prototype;
$c_Ljava_time_Month$$anon$11.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$11.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$11.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$11 = new $TypeData().initClass($c_Ljava_time_Month$$anon$11, "java.time.Month$$anon$11", ({
  Ljava_time_Month$$anon$11: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$12() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "DECEMBER", 11, "DECEMBER", 11);
}
$c_Ljava_time_Month$$anon$12.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$12.prototype.constructor = $c_Ljava_time_Month$$anon$12;
/** @constructor */
function $h_Ljava_time_Month$$anon$12() {
}
$h_Ljava_time_Month$$anon$12.prototype = $c_Ljava_time_Month$$anon$12.prototype;
$c_Ljava_time_Month$$anon$12.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$12.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$12.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$12 = new $TypeData().initClass($c_Ljava_time_Month$$anon$12, "java.time.Month$$anon$12", ({
  Ljava_time_Month$$anon$12: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "FEBRUARY", 1, "FEBRUARY", 1);
}
$c_Ljava_time_Month$$anon$2.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$2.prototype.constructor = $c_Ljava_time_Month$$anon$2;
/** @constructor */
function $h_Ljava_time_Month$$anon$2() {
}
$h_Ljava_time_Month$$anon$2.prototype = $c_Ljava_time_Month$$anon$2.prototype;
$c_Ljava_time_Month$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$2 = new $TypeData().initClass($c_Ljava_time_Month$$anon$2, "java.time.Month$$anon$2", ({
  Ljava_time_Month$$anon$2: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "MARCH", 2, "MARCH", 2);
}
$c_Ljava_time_Month$$anon$3.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$3.prototype.constructor = $c_Ljava_time_Month$$anon$3;
/** @constructor */
function $h_Ljava_time_Month$$anon$3() {
}
$h_Ljava_time_Month$$anon$3.prototype = $c_Ljava_time_Month$$anon$3.prototype;
$c_Ljava_time_Month$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$3 = new $TypeData().initClass($c_Ljava_time_Month$$anon$3, "java.time.Month$$anon$3", ({
  Ljava_time_Month$$anon$3: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "APRIL", 3, "APRIL", 3);
}
$c_Ljava_time_Month$$anon$4.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$4.prototype.constructor = $c_Ljava_time_Month$$anon$4;
/** @constructor */
function $h_Ljava_time_Month$$anon$4() {
}
$h_Ljava_time_Month$$anon$4.prototype = $c_Ljava_time_Month$$anon$4.prototype;
$c_Ljava_time_Month$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$4 = new $TypeData().initClass($c_Ljava_time_Month$$anon$4, "java.time.Month$$anon$4", ({
  Ljava_time_Month$$anon$4: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "MAY", 4, "MAY", 4);
}
$c_Ljava_time_Month$$anon$5.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$5.prototype.constructor = $c_Ljava_time_Month$$anon$5;
/** @constructor */
function $h_Ljava_time_Month$$anon$5() {
}
$h_Ljava_time_Month$$anon$5.prototype = $c_Ljava_time_Month$$anon$5.prototype;
$c_Ljava_time_Month$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$5 = new $TypeData().initClass($c_Ljava_time_Month$$anon$5, "java.time.Month$$anon$5", ({
  Ljava_time_Month$$anon$5: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JUNE", 5, "JUNE", 5);
}
$c_Ljava_time_Month$$anon$6.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$6.prototype.constructor = $c_Ljava_time_Month$$anon$6;
/** @constructor */
function $h_Ljava_time_Month$$anon$6() {
}
$h_Ljava_time_Month$$anon$6.prototype = $c_Ljava_time_Month$$anon$6.prototype;
$c_Ljava_time_Month$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$6 = new $TypeData().initClass($c_Ljava_time_Month$$anon$6, "java.time.Month$$anon$6", ({
  Ljava_time_Month$$anon$6: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JULY", 6, "JULY", 6);
}
$c_Ljava_time_Month$$anon$7.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$7.prototype.constructor = $c_Ljava_time_Month$$anon$7;
/** @constructor */
function $h_Ljava_time_Month$$anon$7() {
}
$h_Ljava_time_Month$$anon$7.prototype = $c_Ljava_time_Month$$anon$7.prototype;
$c_Ljava_time_Month$$anon$7.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$7 = new $TypeData().initClass($c_Ljava_time_Month$$anon$7, "java.time.Month$$anon$7", ({
  Ljava_time_Month$$anon$7: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$8() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "AUGUST", 7, "AUGUST", 7);
}
$c_Ljava_time_Month$$anon$8.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$8.prototype.constructor = $c_Ljava_time_Month$$anon$8;
/** @constructor */
function $h_Ljava_time_Month$$anon$8() {
}
$h_Ljava_time_Month$$anon$8.prototype = $c_Ljava_time_Month$$anon$8.prototype;
$c_Ljava_time_Month$$anon$8.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$8.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$8.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$8 = new $TypeData().initClass($c_Ljava_time_Month$$anon$8, "java.time.Month$$anon$8", ({
  Ljava_time_Month$$anon$8: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_Ljava_time_Month$$anon$9() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "SEPTEMBER", 8, "SEPTEMBER", 8);
}
$c_Ljava_time_Month$$anon$9.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$9.prototype.constructor = $c_Ljava_time_Month$$anon$9;
/** @constructor */
function $h_Ljava_time_Month$$anon$9() {
}
$h_Ljava_time_Month$$anon$9.prototype = $c_Ljava_time_Month$$anon$9.prototype;
$c_Ljava_time_Month$$anon$9.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$9.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$9.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
var $d_Ljava_time_Month$$anon$9 = new $TypeData().initClass($c_Ljava_time_Month$$anon$9, "java.time.Month$$anon$9", ({
  Ljava_time_Month$$anon$9: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
/** @constructor */
function $c_sc_AbstractMapView() {
}
$c_sc_AbstractMapView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractMapView.prototype.constructor = $c_sc_AbstractMapView;
/** @constructor */
function $h_sc_AbstractMapView() {
}
$h_sc_AbstractMapView.prototype = $c_sc_AbstractMapView.prototype;
$c_sc_AbstractMapView.prototype.filter__F1__sc_MapView = (function(pred) {
  return new $c_sc_MapView$Filter(this, false, pred);
});
$c_sc_AbstractMapView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_AbstractMapView.prototype.stringPrefix__T = (function() {
  return "MapView";
});
$c_sc_AbstractMapView.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$c_sc_AbstractMapView.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$c_sc_AbstractMapView.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sc_AbstractMapView.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$c_sc_AbstractMapView.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$c_sc_AbstractMapView.prototype.isDefinedAt__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_sc_AbstractMapView.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$c_sc_AbstractMapView.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sc_AbstractMapView.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sc_AbstractMapView.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sc_AbstractMapView.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($f_sc_MapOps__apply__O__O(this, v1));
});
$c_sc_AbstractMapView.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractMapView.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sc_AbstractMapView.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sc_MapView$();
});
$c_sc_AbstractMapView.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sc_MapView(pred);
});
function $is_sci_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Map)));
}
function $as_sci_Map(obj) {
  return (($is_sci_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map"));
}
function $isArrayOf_sci_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map)));
}
function $asArrayOf_sci_Map(obj, depth) {
  return (($isArrayOf_sci_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map;", depth));
}
function $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O($thiz, fa, fin) {
  return $thiz.guaranteeCase__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    $as_Lcats_effect_kernel_Outcome(_$2);
    return fin;
  })));
}
function $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O($thiz, fa, fin) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var finalized = $thiz.onCancel__O__O__O($n(poll$1).apply__O__O(fa), $n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()));
    var handled = $thiz.onError__O__s_PartialFunction__O(finalized, new $c_Lcats_effect_kernel_MonadCancel$$anon$1(fin, $thiz));
    return $f_Lcats_FlatMap__flatTap__O__F1__O($thiz, handled, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
      var $x_1 = $n(fin);
      var fa$1 = $thiz.pure__O__O(a);
      return $x_1.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1));
    })));
  })));
}
function $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O($thiz, acquire, use, release) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(acquire).apply__O__O(poll$1);
    var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => {
      var fa = $thiz.unit__O();
      return $thiz.guaranteeCase__O__F1__O($n(poll$1).apply__O__O($m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(use).apply__O__O(a))), $thiz)), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$6) => {
        var _$6$1 = $as_Lcats_effect_kernel_Outcome(_$6);
        return $n(release).apply__O__O__O(a, _$6$1);
      })));
    }));
    return $n(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })));
}
/** @constructor */
function $c_Lcats_kernel_instances_ByteOrder() {
}
$c_Lcats_kernel_instances_ByteOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteOrder.prototype.constructor = $c_Lcats_kernel_instances_ByteOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ByteOrder() {
}
$h_Lcats_kernel_instances_ByteOrder.prototype = $c_Lcats_kernel_instances_ByteOrder.prototype;
$c_Lcats_kernel_instances_ByteOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__B__B__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__B__B__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.neqv__B__B__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.lt__B__B__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.min__B__B__B = (function(x, y) {
  var a = x;
  var b = y;
  return ((((a < b) ? a : b) << 24) >> 24);
});
$c_Lcats_kernel_instances_ByteOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uB(x);
  return x$1;
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__B__B__I($uB(x), $uB(y));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__B__B__Z($uB(x), $uB(y));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__B__B__Z($uB(x), $uB(y));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__B__B__Z($uB(x), $uB(y));
});
$c_Lcats_kernel_instances_ByteOrder.prototype.min__O__O__O = (function(x, y) {
  return this.min__B__B__B($uB(x), $uB(y));
});
var $d_Lcats_kernel_instances_ByteOrder = new $TypeData().initClass($c_Lcats_kernel_instances_ByteOrder, "cats.kernel.instances.ByteOrder", ({
  Lcats_kernel_instances_ByteOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ByteBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ByteEnumerable: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_IntOrder() {
}
$c_Lcats_kernel_instances_IntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_IntOrder.prototype.constructor = $c_Lcats_kernel_instances_IntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_IntOrder() {
}
$h_Lcats_kernel_instances_IntOrder.prototype = $c_Lcats_kernel_instances_IntOrder.prototype;
$c_Lcats_kernel_instances_IntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__I__I__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__I__I__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.neqv__I__I__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.lt__I__I__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uI(x);
  return x$1;
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__I__I__I($uI(x), $uI(y));
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__I__I__Z($uI(x), $uI(y));
});
$c_Lcats_kernel_instances_IntOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__I__I__Z($uI(x), $uI(y));
});
$c_Lcats_kernel_instances_IntOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__I__I__Z($uI(x), $uI(y));
});
$c_Lcats_kernel_instances_IntOrder.prototype.min__O__O__O = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 < y$1) ? x$1 : y$1);
});
var $d_Lcats_kernel_instances_IntOrder = new $TypeData().initClass($c_Lcats_kernel_instances_IntOrder, "cats.kernel.instances.IntOrder", ({
  Lcats_kernel_instances_IntOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_IntBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_IntEnumerable: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_LongOrder() {
}
$c_Lcats_kernel_instances_LongOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_LongOrder.prototype.constructor = $c_Lcats_kernel_instances_LongOrder;
/** @constructor */
function $h_Lcats_kernel_instances_LongOrder() {
}
$h_Lcats_kernel_instances_LongOrder.prototype = $c_Lcats_kernel_instances_LongOrder.prototype;
$c_Lcats_kernel_instances_LongOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__J__J__I = (function(x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  return (((x_$_hi === y_$_hi) ? ((x_$_lo >>> 0) < (y_$_lo >>> 0)) : (x_$_hi < y_$_hi)) ? (-1) : (((x_$_hi === y_$_hi) ? ((x_$_lo >>> 0) > (y_$_lo >>> 0)) : (x_$_hi > y_$_hi)) ? 1 : 0));
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__J__J__Z = (function(x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  return (((x_$_lo ^ y_$_lo) | (x_$_hi ^ y_$_hi)) === 0);
});
$c_Lcats_kernel_instances_LongOrder.prototype.neqv__J__J__Z = (function(x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  return (((x_$_lo ^ y_$_lo) | (x_$_hi ^ y_$_hi)) !== 0);
});
$c_Lcats_kernel_instances_LongOrder.prototype.lt__J__J__Z = (function(x_$_lo, x_$_hi, y_$_lo, y_$_hi) {
  return ((x_$_hi === y_$_hi) ? ((x_$_lo >>> 0) < (y_$_lo >>> 0)) : (x_$_hi < y_$_hi));
});
$c_Lcats_kernel_instances_LongOrder.prototype.hash__O__I = (function(x) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  return (x$1_$_lo ^ x$1_$_hi);
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__O__O__I = (function(x, y) {
  var $x_2 = $uJ(x);
  var $x_1 = $uJ(y);
  return this.compare__J__J__I($x_2.l, $x_2.h, $x_1.l, $x_1.h);
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var $x_2 = $uJ(x);
  var $x_1 = $uJ(y);
  return this.eqv__J__J__Z($x_2.l, $x_2.h, $x_1.l, $x_1.h);
});
$c_Lcats_kernel_instances_LongOrder.prototype.neqv__O__O__Z = (function(x, y) {
  var $x_2 = $uJ(x);
  var $x_1 = $uJ(y);
  return this.neqv__J__J__Z($x_2.l, $x_2.h, $x_1.l, $x_1.h);
});
$c_Lcats_kernel_instances_LongOrder.prototype.lt__O__O__Z = (function(x, y) {
  var $x_2 = $uJ(x);
  var $x_1 = $uJ(y);
  return this.lt__J__J__Z($x_2.l, $x_2.h, $x_1.l, $x_1.h);
});
$c_Lcats_kernel_instances_LongOrder.prototype.min__O__O__O = (function(x, y) {
  var $x_1 = $uJ(x);
  var x$1_$_lo = $x_1.l;
  var x$1_$_hi = $x_1.h;
  var $x_2 = $uJ(y);
  var y$1_$_lo = $x_2.l;
  var y$1_$_hi = $x_2.h;
  if (((x$1_$_hi === y$1_$_hi) ? ((x$1_$_lo >>> 0) < (y$1_$_lo >>> 0)) : (x$1_$_hi < y$1_$_hi))) {
    return $bL(x$1_$_lo, x$1_$_hi);
  } else {
    return $bL(y$1_$_lo, y$1_$_hi);
  }
});
var $d_Lcats_kernel_instances_LongOrder = new $TypeData().initClass($c_Lcats_kernel_instances_LongOrder, "cats.kernel.instances.LongOrder", ({
  Lcats_kernel_instances_LongOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_LongBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_LongEnumerable: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_ShortOrder() {
}
$c_Lcats_kernel_instances_ShortOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortOrder.prototype.constructor = $c_Lcats_kernel_instances_ShortOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ShortOrder() {
}
$h_Lcats_kernel_instances_ShortOrder.prototype = $c_Lcats_kernel_instances_ShortOrder.prototype;
$c_Lcats_kernel_instances_ShortOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__S__S__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__S__S__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.neqv__S__S__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.lt__S__S__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.min__S__S__S = (function(x, y) {
  var a = x;
  var b = y;
  return ((((a < b) ? a : b) << 16) >> 16);
});
$c_Lcats_kernel_instances_ShortOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uS(x);
  return x$1;
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__S__S__I($uS(x), $uS(y));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__S__S__Z($uS(x), $uS(y));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__S__S__Z($uS(x), $uS(y));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__S__S__Z($uS(x), $uS(y));
});
$c_Lcats_kernel_instances_ShortOrder.prototype.min__O__O__O = (function(x, y) {
  return this.min__S__S__S($uS(x), $uS(y));
});
var $d_Lcats_kernel_instances_ShortOrder = new $TypeData().initClass($c_Lcats_kernel_instances_ShortOrder, "cats.kernel.instances.ShortOrder", ({
  Lcats_kernel_instances_ShortOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ShortBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ShortEnumerable: 1
}));
/** @constructor */
function $c_Lcats_kernel_instances_UnitOrder() {
}
$c_Lcats_kernel_instances_UnitOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitOrder.prototype.constructor = $c_Lcats_kernel_instances_UnitOrder;
/** @constructor */
function $h_Lcats_kernel_instances_UnitOrder() {
}
$h_Lcats_kernel_instances_UnitOrder.prototype = $c_Lcats_kernel_instances_UnitOrder.prototype;
$c_Lcats_kernel_instances_UnitOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_UnitOrder.prototype.compare__O__O__I = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return 0;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.hash__O__I = (function(x) {
  $as_jl_Void(x);
  return 0;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.eqv__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return true;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.neqv__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return false;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.lt__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return false;
});
$c_Lcats_kernel_instances_UnitOrder.prototype.min__O__O__O = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
});
var $d_Lcats_kernel_instances_UnitOrder = new $TypeData().initClass($c_Lcats_kernel_instances_UnitOrder, "cats.kernel.instances.UnitOrder", ({
  Lcats_kernel_instances_UnitOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_UnitBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_UnitEnumerable: 1
}));
/** @constructor */
function $c_sc_AbstractIndexedSeqView() {
}
$c_sc_AbstractIndexedSeqView.prototype = new $h_sc_AbstractSeqView();
$c_sc_AbstractIndexedSeqView.prototype.constructor = $c_sc_AbstractIndexedSeqView;
/** @constructor */
function $h_sc_AbstractIndexedSeqView() {
}
$h_sc_AbstractIndexedSeqView.prototype = $c_sc_AbstractIndexedSeqView.prototype;
$c_sc_AbstractIndexedSeqView.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_AbstractIndexedSeqView.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sc_AbstractIndexedSeqView.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_AbstractIndexedSeqView.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_AbstractIndexedSeqView.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_AbstractIndexedSeqView.prototype.knownSize__I = (function() {
  return this.length__I();
});
function $is_sc_BitSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSet)));
}
function $as_sc_BitSet(obj) {
  return (($is_sc_BitSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSet"));
}
function $isArrayOf_sc_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSet)));
}
function $asArrayOf_sc_BitSet(obj, depth) {
  return (($isArrayOf_sc_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSet;", depth));
}
/** @constructor */
function $c_sc_MapView$$anon$1() {
}
$c_sc_MapView$$anon$1.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$$anon$1.prototype.constructor = $c_sc_MapView$$anon$1;
/** @constructor */
function $h_sc_MapView$$anon$1() {
}
$h_sc_MapView$$anon$1.prototype = $c_sc_MapView$$anon$1.prototype;
$c_sc_MapView$$anon$1.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$();
});
$c_sc_MapView$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sc_MapView$$anon$1.prototype.knownSize__I = (function() {
  return 0;
});
$c_sc_MapView$$anon$1.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sc_MapView$$anon$1.prototype.filter__F1__sc_MapView = (function(pred) {
  return this;
});
$c_sc_MapView$$anon$1.prototype.filter__F1__O = (function(pred) {
  return this;
});
var $d_sc_MapView$$anon$1 = new $TypeData().initClass($c_sc_MapView$$anon$1, "scala.collection.MapView$$anon$1", ({
  sc_MapView$$anon$1: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
/** @constructor */
function $c_sc_MapView$Filter(underlying, isFlipped, p) {
  this.sc_MapView$Filter__f_underlying = null;
  this.sc_MapView$Filter__f_isFlipped = false;
  this.sc_MapView$Filter__f_p = null;
  this.sc_MapView$Filter__f_underlying = underlying;
  this.sc_MapView$Filter__f_isFlipped = isFlipped;
  this.sc_MapView$Filter__f_p = p;
}
$c_sc_MapView$Filter.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Filter.prototype.constructor = $c_sc_MapView$Filter;
/** @constructor */
function $h_sc_MapView$Filter() {
}
$h_sc_MapView$Filter.prototype = $c_sc_MapView$Filter.prototype;
$c_sc_MapView$Filter.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $n($n(this.sc_MapView$Filter__f_underlying).iterator__sc_Iterator());
  var p = this.sc_MapView$Filter__f_p;
  var isFlipped = this.sc_MapView$Filter__f_isFlipped;
  return new $c_sc_Iterator$$anon$6(this$1, p, isFlipped);
});
$c_sc_MapView$Filter.prototype.get__O__s_Option = (function(key) {
  var x1 = $n(this.sc_MapView$Filter__f_underlying).get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = $n(x2).s_Some__f_value;
    if (($uZ($n(this.sc_MapView$Filter__f_p).apply__O__O(new $c_T2(key, v))) !== this.sc_MapView$Filter__f_isFlipped)) {
      return x2;
    }
  }
  return $m_s_None$();
});
$c_sc_MapView$Filter.prototype.knownSize__I = (function() {
  return (($n(this.sc_MapView$Filter__f_underlying).knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_MapView$Filter.prototype.isEmpty__Z = (function() {
  var this$1 = $n(this.iterator__sc_Iterator());
  return (!this$1.hasNext__Z());
});
var $d_sc_MapView$Filter = new $TypeData().initClass($c_sc_MapView$Filter, "scala.collection.MapView$Filter", ({
  sc_MapView$Filter: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
/** @constructor */
function $c_sc_MapView$Id(underlying) {
  this.sc_MapView$Id__f_underlying = null;
  this.sc_MapView$Id__f_underlying = underlying;
}
$c_sc_MapView$Id.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Id.prototype.constructor = $c_sc_MapView$Id;
/** @constructor */
function $h_sc_MapView$Id() {
}
$h_sc_MapView$Id.prototype = $c_sc_MapView$Id.prototype;
$c_sc_MapView$Id.prototype.get__O__s_Option = (function(key) {
  return $n(this.sc_MapView$Id__f_underlying).get__O__s_Option(key);
});
$c_sc_MapView$Id.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sc_MapView$Id__f_underlying).iterator__sc_Iterator();
});
$c_sc_MapView$Id.prototype.knownSize__I = (function() {
  return $n(this.sc_MapView$Id__f_underlying).knownSize__I();
});
$c_sc_MapView$Id.prototype.isEmpty__Z = (function() {
  return $n(this.sc_MapView$Id__f_underlying).isEmpty__Z();
});
var $d_sc_MapView$Id = new $TypeData().initClass($c_sc_MapView$Id, "scala.collection.MapView$Id", ({
  sc_MapView$Id: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
/** @constructor */
function $c_sc_MapView$MapValues(underlying, f) {
  this.sc_MapView$MapValues__f_underlying = null;
  this.sc_MapView$MapValues__f_f = null;
  this.sc_MapView$MapValues__f_underlying = underlying;
  this.sc_MapView$MapValues__f_f = f;
}
$c_sc_MapView$MapValues.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$MapValues.prototype.constructor = $c_sc_MapView$MapValues;
/** @constructor */
function $h_sc_MapView$MapValues() {
}
$h_sc_MapView$MapValues.prototype = $c_sc_MapView$MapValues.prototype;
$c_sc_MapView$MapValues.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $n($n(this.sc_MapView$MapValues__f_underlying).iterator__sc_Iterator());
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2$2) => {
    var kv$2 = $as_T2(kv$2$2);
    return new $c_T2($n(kv$2)._1__O(), $n(this.sc_MapView$MapValues__f_f).apply__O__O($n(kv$2)._2__O()));
  }));
  return new $c_sc_Iterator$$anon$9(this$2, f);
});
$c_sc_MapView$MapValues.prototype.get__O__s_Option = (function(key) {
  var this$1 = $n($n(this.sc_MapView$MapValues__f_underlying).get__O__s_Option(key));
  var f = this.sc_MapView$MapValues__f_f;
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())));
});
$c_sc_MapView$MapValues.prototype.knownSize__I = (function() {
  return $n(this.sc_MapView$MapValues__f_underlying).knownSize__I();
});
$c_sc_MapView$MapValues.prototype.isEmpty__Z = (function() {
  return $n(this.sc_MapView$MapValues__f_underlying).isEmpty__Z();
});
var $d_sc_MapView$MapValues = new $TypeData().initClass($c_sc_MapView$MapValues, "scala.collection.MapView$MapValues", ({
  sc_MapView$MapValues: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
/** @constructor */
function $c_sci_AbstractSet() {
}
$c_sci_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_sci_AbstractSet.prototype.constructor = $c_sci_AbstractSet;
/** @constructor */
function $h_sci_AbstractSet() {
}
$h_sci_AbstractSet.prototype = $c_sci_AbstractSet.prototype;
$c_sci_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Set$();
});
$c_sci_AbstractSet.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps(this, that);
});
function $is_Lcats_CommutativeMonad(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_CommutativeMonad)));
}
function $as_Lcats_CommutativeMonad(obj) {
  return (($is_Lcats_CommutativeMonad(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.CommutativeMonad"));
}
function $isArrayOf_Lcats_CommutativeMonad(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_CommutativeMonad)));
}
function $asArrayOf_Lcats_CommutativeMonad(obj, depth) {
  return (($isArrayOf_Lcats_CommutativeMonad(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.CommutativeMonad;", depth));
}
/** @constructor */
function $c_Lcats_effect_implicits$() {
}
$c_Lcats_effect_implicits$.prototype = new $h_O();
$c_Lcats_effect_implicits$.prototype.constructor = $c_Lcats_effect_implicits$;
/** @constructor */
function $h_Lcats_effect_implicits$() {
}
$h_Lcats_effect_implicits$.prototype = $c_Lcats_effect_implicits$.prototype;
var $d_Lcats_effect_implicits$ = new $TypeData().initClass($c_Lcats_effect_implicits$, "cats.effect.implicits$", ({
  Lcats_effect_implicits$: 1,
  Lcats_effect_kernel_syntax_MonadCancelSyntax: 1,
  Lcats_effect_kernel_syntax_GenSpawnSyntax: 1,
  Lcats_effect_kernel_syntax_GenTemporalSyntax: 1,
  Lcats_effect_kernel_syntax_GenConcurrentSyntax: 1,
  Lcats_effect_kernel_syntax_AsyncSyntax: 1,
  Lcats_effect_kernel_syntax_ResourceSyntax: 1,
  Lcats_effect_kernel_syntax_ClockSyntax: 1,
  Lcats_effect_kernel_syntax_AllSyntax: 1,
  Lcats_effect_std_syntax_BackpressureSyntax: 1,
  Lcats_effect_std_syntax_SupervisorSyntax: 1,
  Lcats_effect_std_syntax_AllSyntax: 1,
  Lcats_effect_syntax_DispatcherSyntax: 1,
  Lcats_effect_syntax_AllSyntax: 1,
  Lcats_effect_kernel_instances_GenSpawnInstances: 1,
  Lcats_effect_instances_AllInstances: 1
}));
var $n_Lcats_effect_implicits$;
function $m_Lcats_effect_implicits$() {
  if ((!$n_Lcats_effect_implicits$)) {
    $n_Lcats_effect_implicits$ = new $c_Lcats_effect_implicits$();
  }
  return $n_Lcats_effect_implicits$;
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli($thiz, body) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n($thiz.F__Lcats_effect_kernel_MonadCancel()).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nat) => {
    var nat$1 = $as_Lcats_effect_kernel_Poll(nat);
    var natT = new $c_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel$$anon$13(nat$1);
    return $n($n($as_Lcats_data_Kleisli($n(body).apply__O__O(natT))).Lcats_data_Kleisli__f_run).apply__O__O(r);
  })))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_MonadCancel()).canceled__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fin) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n($thiz.F__Lcats_effect_kernel_MonadCancel()).onCancel__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fin).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fb) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n($thiz.F__Lcats_effect_kernel_MonadCancel()).forceR__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli($thiz, fa, fin) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n($thiz.F__Lcats_effect_kernel_MonadCancel()).guaranteeCase__O__F1__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
      var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
      var this$3 = $n(x$1$2);
      var x69 = this$3.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
      var this$4 = $m_Lcats_data_Kleisli$();
      var fa$1 = $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$4, x69);
      return $n($n($as_Lcats_data_Kleisli($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1)))).Lcats_data_Kleisli__f_run).apply__O__O(r);
    }
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
      var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
      var this$8 = $n(x$1$3);
      var x66 = this$8.Lcats_effect_kernel_Outcome$Errored__f_e;
      var fa$2 = $n($n($as_Lcats_data_Kleisli($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x66)))).Lcats_data_Kleisli__f_run).apply__O__O(r);
      $thiz.F__Lcats_effect_kernel_MonadCancel();
      var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$51) => (void 0)));
      var F$1 = $thiz.F__Lcats_effect_kernel_MonadCancel();
      return $n(F$1).handleError__O__F1__O(fa$2, f);
    }
    if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
      return $n($n($as_Lcats_data_Kleisli($n(fin).apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()))).Lcats_data_Kleisli__f_run).apply__O__O(r);
    }
    throw new $c_s_MatchError(x$1$1);
  })))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O($thiz, p, init, foldChunk) {
  return $n($m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource($m_Lfs2_internal_Scope$().newRoot__Lfs2_Compiler$Target__O($thiz), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((scope, ec) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
    var fea = $n(scope$1).close__Lcats_effect_kernel_Resource$ExitCase__O(ec$1);
    $thiz.F__Lcats_effect_kernel_MonadCancel();
    return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, $thiz.F__Lcats_effect_kernel_MonadCancel());
  })), $thiz.F__Lcats_effect_kernel_MonadCancel())).use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((scope$2) => {
    var scope$3 = $as_Lfs2_internal_Scope(scope$2);
    return $m_Lfs2_Pull$().compile__Lfs2_Pull__Lfs2_internal_Scope__Z__O__F2__Lcats_MonadError__O(p, scope$3, false, init, foldChunk, $thiz.F__Lcats_effect_kernel_MonadCancel());
  })), $thiz.F__Lcats_effect_kernel_MonadCancel());
}
function $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
}
$c_sc_IndexedSeqView$Drop.prototype = new $h_sc_SeqView$Drop();
$c_sc_IndexedSeqView$Drop.prototype.constructor = $c_sc_IndexedSeqView$Drop;
/** @constructor */
function $h_sc_IndexedSeqView$Drop() {
}
$h_sc_IndexedSeqView$Drop.prototype = $c_sc_IndexedSeqView$Drop.prototype;
$c_sc_IndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Drop.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Drop.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sc_IndexedSeqView$Drop.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Drop.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Drop.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
var $d_sc_IndexedSeqView$Drop = new $TypeData().initClass($c_sc_IndexedSeqView$Drop, "scala.collection.IndexedSeqView$Drop", ({
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
}
$c_sc_IndexedSeqView$DropRight.prototype = new $h_sc_SeqView$DropRight();
$c_sc_IndexedSeqView$DropRight.prototype.constructor = $c_sc_IndexedSeqView$DropRight;
/** @constructor */
function $h_sc_IndexedSeqView$DropRight() {
}
$h_sc_IndexedSeqView$DropRight.prototype = $c_sc_IndexedSeqView$DropRight.prototype;
$c_sc_IndexedSeqView$DropRight.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$DropRight.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$DropRight.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sc_IndexedSeqView$DropRight.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$DropRight.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$DropRight.prototype.lengthCompare__I__I = (function(len) {
  var x = this.sc_SeqView$DropRight__f_len;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$DropRight.prototype.knownSize__I = (function() {
  return this.sc_SeqView$DropRight__f_len;
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
var $d_sc_IndexedSeqView$DropRight = new $TypeData().initClass($c_sc_IndexedSeqView$DropRight, "scala.collection.IndexedSeqView$DropRight", ({
  sc_IndexedSeqView$DropRight: 1,
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Id(underlying) {
  this.sc_SeqView$Id__f_underlying = null;
  $ct_sc_SeqView$Id__sc_SeqOps__(this, underlying);
}
$c_sc_IndexedSeqView$Id.prototype = new $h_sc_SeqView$Id();
$c_sc_IndexedSeqView$Id.prototype.constructor = $c_sc_IndexedSeqView$Id;
/** @constructor */
function $h_sc_IndexedSeqView$Id() {
}
$h_sc_IndexedSeqView$Id.prototype = $c_sc_IndexedSeqView$Id.prototype;
$c_sc_IndexedSeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Id.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Id.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Id.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sc_IndexedSeqView$Id.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Id.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Id.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Id.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__O = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Id.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
var $d_sc_IndexedSeqView$Id = new $TypeData().initClass($c_sc_IndexedSeqView$Id, "scala.collection.IndexedSeqView$Id", ({
  sc_IndexedSeqView$Id: 1,
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__($thiz, underlying, f) {
  $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f);
  return $thiz;
}
/** @constructor */
function $c_sc_IndexedSeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
}
$c_sc_IndexedSeqView$Map.prototype = new $h_sc_SeqView$Map();
$c_sc_IndexedSeqView$Map.prototype.constructor = $c_sc_IndexedSeqView$Map;
/** @constructor */
function $h_sc_IndexedSeqView$Map() {
}
$h_sc_IndexedSeqView$Map.prototype = $c_sc_IndexedSeqView$Map.prototype;
$c_sc_IndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Map.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Map.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sc_IndexedSeqView$Map.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Map.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Map.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
var $d_sc_IndexedSeqView$Map = new $TypeData().initClass($c_sc_IndexedSeqView$Map, "scala.collection.IndexedSeqView$Map", ({
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Reverse(underlying) {
  this.sc_SeqView$Reverse__f_underlying = null;
  $ct_sc_SeqView$Reverse__sc_SeqOps__(this, underlying);
}
$c_sc_IndexedSeqView$Reverse.prototype = new $h_sc_SeqView$Reverse();
$c_sc_IndexedSeqView$Reverse.prototype.constructor = $c_sc_IndexedSeqView$Reverse;
/** @constructor */
function $h_sc_IndexedSeqView$Reverse() {
}
$h_sc_IndexedSeqView$Reverse.prototype = $c_sc_IndexedSeqView$Reverse.prototype;
$c_sc_IndexedSeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Reverse.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Reverse.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Reverse.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sc_IndexedSeqView$Reverse.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Reverse.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Reverse.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Reverse.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__O = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
var $d_sc_IndexedSeqView$Reverse = new $TypeData().initClass($c_sc_IndexedSeqView$Reverse, "scala.collection.IndexedSeqView$Reverse", ({
  sc_IndexedSeqView$Reverse: 1,
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
/** @constructor */
function $c_sc_IndexedSeqView$Take(underlying, n) {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
  $ct_sc_SeqView$Take__sc_SeqOps__I__(this, underlying, n);
}
$c_sc_IndexedSeqView$Take.prototype = new $h_sc_SeqView$Take();
$c_sc_IndexedSeqView$Take.prototype.constructor = $c_sc_IndexedSeqView$Take;
/** @constructor */
function $h_sc_IndexedSeqView$Take() {
}
$h_sc_IndexedSeqView$Take.prototype = $c_sc_IndexedSeqView$Take.prototype;
$c_sc_IndexedSeqView$Take.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Take.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Take.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Take.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Take.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Take.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__O = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
var $d_sc_IndexedSeqView$Take = new $TypeData().initClass($c_sc_IndexedSeqView$Take, "scala.collection.IndexedSeqView$Take", ({
  sc_IndexedSeqView$Take: 1,
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
/** @constructor */
function $c_sci_AbstractSeq() {
}
$c_sci_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_sci_AbstractSeq.prototype.constructor = $c_sci_AbstractSeq;
/** @constructor */
function $h_sci_AbstractSeq() {
}
$h_sci_AbstractSeq.prototype = $c_sci_AbstractSeq.prototype;
/** @constructor */
function $c_scm_ArrayBufferView(underlying, mutationCount) {
  this.scm_ArrayBufferView__f_underlying = null;
  this.scm_ArrayBufferView__f_mutationCount = null;
  this.scm_ArrayBufferView__f_underlying = underlying;
  this.scm_ArrayBufferView__f_mutationCount = mutationCount;
}
$c_scm_ArrayBufferView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_scm_ArrayBufferView.prototype.constructor = $c_scm_ArrayBufferView;
/** @constructor */
function $h_scm_ArrayBufferView() {
}
$h_scm_ArrayBufferView.prototype = $c_scm_ArrayBufferView.prototype;
$c_scm_ArrayBufferView.prototype.apply__I__O = (function(n) {
  return $n(this.scm_ArrayBufferView__f_underlying).apply__I__O(n);
});
$c_scm_ArrayBufferView.prototype.length__I = (function() {
  var this$1 = $n(this.scm_ArrayBufferView__f_underlying);
  return this$1.scm_ArrayBuffer__f_size0;
});
$c_scm_ArrayBufferView.prototype.className__T = (function() {
  return "ArrayBufferView";
});
$c_scm_ArrayBufferView.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_scm_ArrayBufferView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_scm_ArrayBufferView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
var $d_scm_ArrayBufferView = new $TypeData().initClass($c_scm_ArrayBufferView, "scala.collection.mutable.ArrayBufferView", ({
  scm_ArrayBufferView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
function $f_Lcats_effect_kernel_GenSpawn__background__O__Lcats_effect_kernel_Resource($thiz, fa) {
  return $n($m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource($thiz.start__O__O(fa), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    var _$2$1 = $as_Lcats_effect_kernel_Fiber(_$2);
    return $n(_$2$1).cancel__O();
  })), $thiz)).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
    var _$3$1 = $as_Lcats_effect_kernel_Fiber(_$3);
    return $n(_$3$1).join__O();
  })));
}
function $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O($thiz, fa, fb) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(poll$1).apply__O__O($thiz.racePair__O__O__O(fa, fb));
    var this$9 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_s_util_Either(x$1);
      if ((x$1$1 instanceof $c_s_util_Left)) {
        var x7 = $as_T2($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
        if ((x7 !== null)) {
          var oc = $as_Lcats_effect_kernel_Outcome($n(x7)._1__O());
          var f = $as_Lcats_effect_kernel_Fiber($n(x7)._2__O());
          var target$1 = $n(f).cancel__O();
          var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, $thiz);
          var b = new $c_s_util_Left(oc);
          return $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b);
        }
      }
      if ((x$1$1 instanceof $c_s_util_Right)) {
        var x3 = $as_T2($n($as_s_util_Right(x$1$1)).s_util_Right__f_value);
        if ((x3 !== null)) {
          var f$2 = $as_Lcats_effect_kernel_Fiber($n(x3)._1__O());
          var oc$2 = $as_Lcats_effect_kernel_Outcome($n(x3)._2__O());
          var target$2 = $n(f$2).cancel__O();
          var this$8 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, $thiz);
          var b$1 = new $c_s_util_Right(oc$2);
          return $n(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).as__O__O__O(this$8.Lcats_Functor$ToFunctorOps$$anon$5__f_self, b$1);
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
  })));
}
function $f_Lcats_effect_kernel_GenSpawn__both__O__O__O($thiz, fa, fb) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $n(poll$1).apply__O__O($thiz.racePair__O__O__O(fa, fb));
    var this$47 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_s_util_Either(x$1);
      if ((x$1$1 instanceof $c_s_util_Left)) {
        var x98 = $as_T2($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
        if ((x98 !== null)) {
          var oc = $as_Lcats_effect_kernel_Outcome($n(x98)._1__O());
          var f = $as_Lcats_effect_kernel_Fiber($n(x98)._2__O());
          if ((oc instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(oc);
            var this$4 = $n(x$1$2);
            var x75 = this$4.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var wrapped = $n(poll$1).apply__O__O($n(f).join__O());
            var fin = $n(f).cancel__O();
            var target$1 = $thiz.onCancel__O__O__O(wrapped, fin);
            var this$16 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, $thiz);
            var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2$1) => {
              var x$1$3 = $as_Lcats_effect_kernel_Outcome(x$1$2$1);
              if ((x$1$3 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x$1$4 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$3);
                var this$9 = $n(x$1$4);
                var x67 = this$9.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                return $f_Lcats_FlatMap__product__O__O__O($thiz, x75, x67);
              }
              if ((x$1$3 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                var x$1$5 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$3);
                var this$13 = $n(x$1$5);
                var x64 = this$13.Lcats_effect_kernel_Outcome$Errored__f_e;
                return $thiz.raiseError__O__O(x64);
              }
              if (((x$1$3 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$3), true))) {
                var fa$1 = $n(poll$1).apply__O__O($thiz.canceled__O());
                var fb$1 = $thiz.never__O();
                return $thiz.productR__O__O__O(fa$1, fb$1);
              }
              throw new $c_s_MatchError(x$1$3);
            }));
            return $n(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
          }
          if ((oc instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$6 = $as_Lcats_effect_kernel_Outcome$Errored(oc);
            var this$18 = $n(x$1$6);
            var x72 = this$18.Lcats_effect_kernel_Outcome$Errored__f_e;
            var fa$2 = $n(f).cancel__O();
            var fb$2 = $thiz.raiseError__O__O(x72);
            return $thiz.productR__O__O__O(fa$2, fb$2);
          }
          if (((oc instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(oc), true))) {
            var fa$3 = $n(f).cancel__O();
            var fb$3 = $n(poll$1).apply__O__O($thiz.canceled__O());
            var fa$4 = $thiz.productR__O__O__O(fa$3, fb$3);
            var fb$4 = $thiz.never__O();
            return $thiz.productR__O__O__O(fa$4, fb$4);
          }
          throw new $c_s_MatchError(oc);
        }
      }
      if ((x$1$1 instanceof $c_s_util_Right)) {
        var x94 = $as_T2($n($as_s_util_Right(x$1$1)).s_util_Right__f_value);
        if ((x94 !== null)) {
          var f$2 = $as_Lcats_effect_kernel_Fiber($n(x94)._1__O());
          var oc$2 = $as_Lcats_effect_kernel_Outcome($n(x94)._2__O());
          if ((oc$2 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$7 = $as_Lcats_effect_kernel_Outcome$Succeeded(oc$2);
            var this$26 = $n(x$1$7);
            var x91 = this$26.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var wrapped$1 = $n(poll$1).apply__O__O($n(f$2).join__O());
            var fin$1 = $n(f$2).cancel__O();
            var target$2 = $thiz.onCancel__O__O__O(wrapped$1, fin$1);
            var this$38 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, $thiz);
            var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$3$1) => {
              var x$1$8 = $as_Lcats_effect_kernel_Outcome(x$1$3$1);
              if ((x$1$8 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x$1$9 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$8);
                var this$31 = $n(x$1$9);
                var x83 = this$31.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                return $f_Lcats_FlatMap__product__O__O__O($thiz, x83, x91);
              }
              if ((x$1$8 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                var x$1$10 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$8);
                var this$35 = $n(x$1$10);
                var x80 = this$35.Lcats_effect_kernel_Outcome$Errored__f_e;
                return $thiz.raiseError__O__O(x80);
              }
              if (((x$1$8 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$8), true))) {
                var fa$5 = $n(poll$1).apply__O__O($thiz.canceled__O());
                var fb$5 = $thiz.never__O();
                return $thiz.productR__O__O__O(fa$5, fb$5);
              }
              throw new $c_s_MatchError(x$1$8);
            }));
            return $n(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$38.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3);
          }
          if ((oc$2 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$11 = $as_Lcats_effect_kernel_Outcome$Errored(oc$2);
            var this$40 = $n(x$1$11);
            var x88 = this$40.Lcats_effect_kernel_Outcome$Errored__f_e;
            var fa$6 = $n(f$2).cancel__O();
            var fb$6 = $thiz.raiseError__O__O(x88);
            return $thiz.productR__O__O__O(fa$6, fb$6);
          }
          if (((oc$2 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(oc$2), true))) {
            var fa$7 = $n(f$2).cancel__O();
            var fb$7 = $n(poll$1).apply__O__O($thiz.canceled__O());
            var fa$8 = $thiz.productR__O__O__O(fa$7, fb$7);
            var fb$8 = $thiz.never__O();
            return $thiz.productR__O__O__O(fa$8, fb$8);
          }
          throw new $c_s_MatchError(oc$2);
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $n(this$47.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$47.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$4);
  })));
}
function $is_Lcats_effect_kernel_GenSpawn(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_GenSpawn)));
}
function $as_Lcats_effect_kernel_GenSpawn(obj) {
  return (($is_Lcats_effect_kernel_GenSpawn(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.GenSpawn"));
}
function $isArrayOf_Lcats_effect_kernel_GenSpawn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_GenSpawn)));
}
function $asArrayOf_Lcats_effect_kernel_GenSpawn(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_GenSpawn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.GenSpawn;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$$anon$4(F0$10, cancel$10) {
  this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3 = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3 = cancel$10;
}
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$$anon$4() {
}
$h_Lcats_effect_kernel_MonadCancel$$anon$4.prototype = $c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype;
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_cancel$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_MonadCancel$$anon$4 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$$anon$4, "cats.effect.kernel.MonadCancel$$anon$4", ({
  Lcats_effect_kernel_MonadCancel$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1
}));
/** @constructor */
function $c_Lfs2_Compiler$Target$ConcurrentTarget(F0) {
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0 = null;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F = null;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0 = F0;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F = F0;
}
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype = new $h_O();
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.constructor = $c_Lfs2_Compiler$Target$ConcurrentTarget;
/** @constructor */
function $h_Lfs2_Compiler$Target$ConcurrentTarget() {
}
$h_Lfs2_Compiler$Target$ConcurrentTarget.prototype = $c_Lfs2_Compiler$Target$ConcurrentTarget.prototype;
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.unit__O = (function() {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).pure__O__O((void 0));
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.pure__O__O = (function(a) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).pure__O__O(a);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).handleErrorWith__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.flatMap__O__F1__O = (function(fa, f) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).flatMap__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).tailRecM__O__F1__O(a, f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.uncancelable__F1__O = (function(f) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).uncancelable__F1__O(f);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.canceled__O = (function() {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).canceled__O();
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.forceR__O__O__O = (function(fa, fb) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).forceR__O__O__O(fa, fb);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.onCancel__O__O__O = (function(fa, fin) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).onCancel__O__O__O(fa, fin);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F;
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.unique__O = (function() {
  var F = this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0;
  return $n(F).unique__O();
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.ref__O__O = (function(a) {
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0).ref__O__O(a);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option = (function(root) {
  var value = $m_Lfs2_internal_InterruptContext$().apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O(root, $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).unit__O(), this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0);
  return new $c_s_Some(value);
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  return $n(this.Lfs2_Compiler$Target$ConcurrentTarget__f_F).raiseError__O__O(e$1);
});
var $d_Lfs2_Compiler$Target$ConcurrentTarget = new $TypeData().initClass($c_Lfs2_Compiler$Target$ConcurrentTarget, "fs2.Compiler$Target$ConcurrentTarget", ({
  Lfs2_Compiler$Target$ConcurrentTarget: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lfs2_Compiler$Target: 1
}));
/** @constructor */
function $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(F0) {
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0 = null;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F = null;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0 = F0;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F = F0;
}
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype = new $h_O();
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.constructor = $c_Lfs2_Compiler$TargetLowPriority$SyncTarget;
/** @constructor */
function $h_Lfs2_Compiler$TargetLowPriority$SyncTarget() {
}
$h_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype = $c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype;
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.unit__O = (function() {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).pure__O__O((void 0));
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.pure__O__O = (function(a) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).pure__O__O(a);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).handleErrorWith__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.flatMap__O__F1__O = (function(fa, f) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).flatMap__O__F1__O(fa, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).tailRecM__O__F1__O(a, f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.uncancelable__F1__O = (function(f) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).uncancelable__F1__O(f);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.canceled__O = (function() {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).canceled__O();
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.forceR__O__O__O = (function(fa, fb) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).forceR__O__O__O(fa, fb);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.onCancel__O__O__O = (function(fa, fin) {
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).onCancel__O__O__O(fa, fin);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F;
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.unique__O = (function() {
  var F = this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0;
  return $n(F).unique__O();
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.ref__O__O = (function(a) {
  var F = this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0;
  var mk = new $c_Lcats_effect_kernel_Ref$MakeLowPriorityInstances$$anon$2(F);
  return mk.refOf__O__O(a);
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option = (function(root) {
  return $m_s_None$();
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  return $n(this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F).raiseError__O__O(e$1);
});
var $d_Lfs2_Compiler$TargetLowPriority$SyncTarget = new $TypeData().initClass($c_Lfs2_Compiler$TargetLowPriority$SyncTarget, "fs2.Compiler$TargetLowPriority$SyncTarget", ({
  Lfs2_Compiler$TargetLowPriority$SyncTarget: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lfs2_Compiler$Target: 1
}));
/** @constructor */
function $c_sci_AbstractMap() {
}
$c_sci_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_sci_AbstractMap.prototype.constructor = $c_sci_AbstractMap;
/** @constructor */
function $h_sci_AbstractMap() {
}
$h_sci_AbstractMap.prototype = $c_sci_AbstractMap.prototype;
$c_sci_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_Map$();
});
$c_sci_AbstractMap.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sci_AbstractMap.prototype.keySet__sci_Set = (function() {
  return $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$ImmutableKeySet(), this);
});
$c_sci_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Iterable$();
});
function $f_sci_IndexedSeq__canEqual__O__Z($thiz, that) {
  if ((!$is_sci_IndexedSeq(that))) {
    return true;
  } else {
    var x2 = $as_sci_IndexedSeq(that);
    return ($thiz.length__I() === $n(x2).length__I());
  }
}
function $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z($thiz, o) {
  if ($is_sci_IndexedSeq(o)) {
    var x2 = $as_sci_IndexedSeq(o);
    if (($thiz === x2)) {
      return true;
    } else {
      var length = $thiz.length__I();
      var equal = (length === $n(x2).length__I());
      if (equal) {
        var index = 0;
        var a = $thiz.applyPreferredMaxLength__I();
        var b = $n(x2).applyPreferredMaxLength__I();
        var preferredLength = ((a < b) ? a : b);
        var hi = (length >> 31);
        var hi$1 = (preferredLength >> 31);
        var lo = (preferredLength << 1);
        var hi$2 = (((preferredLength >>> 31) | 0) | (hi$1 << 1));
        if (((hi === hi$2) ? ((length >>> 0) > (lo >>> 0)) : (hi > hi$2))) {
          var maxApplyCompare = preferredLength;
        } else {
          var maxApplyCompare = length;
        }
        while (((index < maxApplyCompare) && equal)) {
          equal = $m_sr_BoxesRunTime$().equals__O__O__Z($thiz.apply__I__O(index), $n(x2).apply__I__O(index));
          index = ((1 + index) | 0);
        }
        if (((index < length) && equal)) {
          var thisIt = $n($thiz.iterator__sc_Iterator()).drop__I__sc_Iterator(index);
          var thatIt = $n($n(x2).iterator__sc_Iterator()).drop__I__sc_Iterator(index);
          while ((equal && $n(thisIt).hasNext__Z())) {
            equal = $m_sr_BoxesRunTime$().equals__O__O__Z($n(thisIt).next__O(), $n(thatIt).next__O());
          }
        }
      }
      return equal;
    }
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, o);
  }
}
function $is_sci_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_IndexedSeq)));
}
function $as_sci_IndexedSeq(obj) {
  return (($is_sci_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.IndexedSeq"));
}
function $isArrayOf_sci_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_IndexedSeq)));
}
function $asArrayOf_sci_IndexedSeq(obj, depth) {
  return (($isArrayOf_sci_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.IndexedSeq;", depth));
}
/** @constructor */
function $c_sci_Set$EmptySet$() {
}
$c_sci_Set$EmptySet$.prototype = new $h_sci_AbstractSet();
$c_sci_Set$EmptySet$.prototype.constructor = $c_sci_Set$EmptySet$;
/** @constructor */
function $h_sci_Set$EmptySet$() {
}
$h_sci_Set$EmptySet$.prototype = $c_sci_Set$EmptySet$.prototype;
$c_sci_Set$EmptySet$.prototype.size__I = (function() {
  return 0;
});
$c_sci_Set$EmptySet$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_Set$EmptySet$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Set$EmptySet$.prototype.subsetOf__sc_Set__Z = (function(that) {
  return true;
});
$c_sci_Set$EmptySet$.prototype.contains__O__Z = (function(elem) {
  return false;
});
$c_sci_Set$EmptySet$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Set$EmptySet$.prototype.foreach__F1__V = (function(f) {
});
$c_sci_Set$EmptySet$.prototype.excl__O__sci_SetOps = (function(elem) {
  return this;
});
$c_sci_Set$EmptySet$.prototype.incl__O__sci_SetOps = (function(elem) {
  return new $c_sci_Set$Set1(elem);
});
$c_sci_Set$EmptySet$.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return this;
});
$c_sci_Set$EmptySet$.prototype.filterNot__F1__O = (function(pred) {
  return this;
});
$c_sci_Set$EmptySet$.prototype.filter__F1__O = (function(pred) {
  return this;
});
var $d_sci_Set$EmptySet$ = new $TypeData().initClass($c_sci_Set$EmptySet$, "scala.collection.immutable.Set$EmptySet$", ({
  sci_Set$EmptySet$: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Set$EmptySet$;
function $m_sci_Set$EmptySet$() {
  if ((!$n_sci_Set$EmptySet$)) {
    $n_sci_Set$EmptySet$ = new $c_sci_Set$EmptySet$();
  }
  return $n_sci_Set$EmptySet$;
}
/** @constructor */
function $c_Lcats_data_Kleisli$() {
  $ct_Lcats_data_KleisliInstances__(this);
}
$c_Lcats_data_Kleisli$.prototype = new $h_Lcats_data_KleisliInstances();
$c_Lcats_data_Kleisli$.prototype.constructor = $c_Lcats_data_Kleisli$;
/** @constructor */
function $h_Lcats_data_Kleisli$() {
}
$h_Lcats_data_Kleisli$.prototype = $c_Lcats_data_Kleisli$.prototype;
$c_Lcats_data_Kleisli$.prototype.shift__F1__Lcats_FlatMap__Lcats_data_Kleisli = (function(run, F) {
  if ($is_Lcats_Applicative(F)) {
    var ap = $as_Lcats_Applicative(F);
    $m_Lcats_data_Kleisli$();
    var run$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n(F).flatMap__O__F1__O($n(ap).pure__O__O(r), run)));
    return new $c_Lcats_data_Kleisli(run$1);
  } else {
    $m_Lcats_data_Kleisli$();
    return new $c_Lcats_data_Kleisli(run);
  }
});
var $d_Lcats_data_Kleisli$ = new $TypeData().initClass($c_Lcats_data_Kleisli$, "cats.data.Kleisli$", ({
  Lcats_data_Kleisli$: 1,
  Lcats_data_KleisliInstances: 1,
  Lcats_data_KleisliInstances0: 1,
  Lcats_data_KleisliInstances0\uff3f5: 1,
  Lcats_data_KleisliInstances1: 1,
  Lcats_data_KleisliInstances2: 1,
  Lcats_data_KleisliInstances3: 1,
  Lcats_data_KleisliInstances4: 1,
  Lcats_data_KleisliInstances5: 1,
  Lcats_data_KleisliInstances6: 1,
  Lcats_data_KleisliInstances7: 1,
  Lcats_data_KleisliInstances8: 1,
  Lcats_data_KleisliInstances9: 1,
  Lcats_data_KleisliFunctions: 1,
  Lcats_data_KleisliFunctionsBinCompat: 1,
  Lcats_data_KleisliExplicitInstances: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
var $n_Lcats_data_Kleisli$;
function $m_Lcats_data_Kleisli$() {
  if ((!$n_Lcats_data_Kleisli$)) {
    $n_Lcats_data_Kleisli$ = new $c_Lcats_data_Kleisli$();
  }
  return $n_Lcats_data_Kleisli$;
}
function $f_Lcats_effect_kernel_GenConcurrent__racePair__O__O__O($thiz, fa, fb) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = $thiz.deferred__O();
    var this$27 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f$7 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((result) => {
      var result$1 = $as_Lcats_effect_kernel_Deferred(result);
      var target$2 = $thiz.start__O__O($thiz.guaranteeCase__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oc) => {
        var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
        var target$1 = $n(result$1).complete__O__O(new $c_s_util_Left(oc$1));
        var this$5 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$1, $thiz);
        return $n(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$5.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
      }))));
      var this$26 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, $thiz);
      var f$6 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fibA) => {
        var fibA$1 = $as_Lcats_effect_kernel_Fiber(fibA);
        var target$4 = $thiz.start__O__O($thiz.guaranteeCase__O__F1__O(fb, new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((oc$2) => {
          var oc$3 = $as_Lcats_effect_kernel_Outcome(oc$2);
          var target$3 = $n(result$1).complete__O__O(new $c_s_util_Right(oc$3));
          var this$9 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$3, $thiz);
          return $n(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).void__O__O(this$9.Lcats_Functor$ToFunctorOps$$anon$5__f_self);
        }))));
        var this$25 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$4, $thiz);
        var f$5 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fibB) => {
          var fibB$1 = $as_Lcats_effect_kernel_Fiber(fibB);
          var $x_1 = $n(poll$1).apply__O__O($n(result$1).get__O());
          var target$5 = $thiz.start__O__O($n(fibA$1).cancel__O());
          var this$18 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$5, $thiz);
          var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((canA) => {
            var canA$1 = $as_Lcats_effect_kernel_Fiber(canA);
            var target$6 = $thiz.start__O__O($n(fibB$1).cancel__O());
            var this$17 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$6, $thiz);
            var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((canB) => {
              var canB$1 = $as_Lcats_effect_kernel_Fiber(canB);
              var target$7 = $n(canA$1).join__O();
              var this$16 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$7, $thiz);
              var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
                $as_Lcats_effect_kernel_Outcome(x$1);
                var target$8 = $n(canB$1).join__O();
                var this$15 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$8, $thiz);
                var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1$2) => {
                  $as_Lcats_effect_kernel_Outcome(x$1$2);
                }));
                return $n(this$15.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$15.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
              }));
              return $n(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$16.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$1);
            }));
            return $n(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$17.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$2);
          }));
          var target$9 = $thiz.onCancel__O__O__O($x_1, $n(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$18.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$3));
          var this$24 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target$9, $thiz);
          var f$4 = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((back) => {
            var back$1 = $as_s_util_Either(back);
            if ((back$1 instanceof $c_s_util_Left)) {
              var oc$4 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Left(back$1)).s_util_Left__f_value);
              var value = new $c_T2(oc$4, fibB$1);
              return new $c_s_util_Left(value);
            }
            if ((back$1 instanceof $c_s_util_Right)) {
              var oc$2$1 = $as_Lcats_effect_kernel_Outcome($n($as_s_util_Right(back$1)).s_util_Right__f_value);
              var value$1 = new $c_T2(fibA$1, oc$2$1);
              return new $c_s_util_Right(value$1);
            }
            throw new $c_s_MatchError(back$1);
          }));
          return $n(this$24.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$24.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f$4);
        }));
        return $n(this$25.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$25.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$5);
      }));
      return $n(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$26.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$6);
    }));
    return $n(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance).flatMap__O__F1__O(this$27.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f$7);
  })));
}
function $is_Lcats_effect_kernel_GenConcurrent(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_GenConcurrent)));
}
function $as_Lcats_effect_kernel_GenConcurrent(obj) {
  return (($is_Lcats_effect_kernel_GenConcurrent(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.GenConcurrent"));
}
function $isArrayOf_Lcats_effect_kernel_GenConcurrent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_GenConcurrent)));
}
function $asArrayOf_Lcats_effect_kernel_GenConcurrent(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_GenConcurrent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.GenConcurrent;", depth));
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceMonadCancel() {
}
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype = new $h_Lcats_effect_kernel_ResourceMonad();
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.constructor = $c_Lcats_effect_kernel_ResourceMonadCancel;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceMonadCancel() {
}
$h_Lcats_effect_kernel_ResourceMonadCancel.prototype = $c_Lcats_effect_kernel_ResourceMonadCancel.prototype;
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.redeemWith__O__F1__F1__O = (function(fa, recover, bind) {
  return $f_Lcats_MonadError__redeemWith__O__F1__F1__O(this, fa, recover, bind);
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.attempt__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return $n(fa$1).attempt__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(this.F__Lcats_effect_kernel_MonadCancel());
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return $n(fa$1).handleErrorWith__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(f, this.F__Lcats_effect_kernel_MonadCancel());
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  return $m_Lcats_effect_kernel_Resource$().raiseError__O__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(e$1, this.F__Lcats_effect_kernel_MonadCancel());
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.canceled__O = (function() {
  var F = this.F__Lcats_effect_kernel_MonadCancel();
  var fa = $n(F).canceled__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var fb$1 = $as_Lcats_effect_kernel_Resource(fb);
  return $n(fa$1).forceR__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(fb$1, this.F__Lcats_effect_kernel_MonadCancel());
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var fin$1 = $as_Lcats_effect_kernel_Resource(fin);
  return $n(fa$1).onCancel__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(fin$1, this.F__Lcats_effect_kernel_MonadCancel());
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.uncancelable__F1__O = (function(body) {
  return $m_Lcats_effect_kernel_Resource$().uncancelable__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(body, this.F__Lcats_effect_kernel_MonadCancel());
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var rfa = $as_Lcats_effect_kernel_Resource(fa);
  return $n(rfa).guaranteeCase__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(fin, this.F__Lcats_effect_kernel_MonadCancel());
});
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(m) {
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = null;
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = m;
}
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = new $h_O();
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq() {
}
$h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype;
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_IndexedSeq$().newBuilder__scm_Builder();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.className__T = (function() {
  return "IndexedSeq";
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.size__I = (function() {
  return this.length__I();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I($n(this.iterator__sc_Iterator()), p, from);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength;
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.length__I = (function() {
  return $n(this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m).length__I();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__I__O = (function(i) {
  return $n(this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m).apply__I__O(i);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterator__sc_Iterator = (function() {
  return $n(this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m).iterator__sc_Iterator();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_IndexedSeq$();
  return this$1.from__sc_IterableOnce__sci_IndexedSeq(coll);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__I__O(v1));
});
var $d_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq = new $TypeData().initClass($c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq, "cats.kernel.instances.StaticMethods$WrappedIndexedSeq", ({
  Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  sci_Iterable: 1,
  F1: 1,
  s_PartialFunction: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sc_Seq: 1,
  sci_SeqOps: 1,
  sci_Seq: 1,
  sc_IndexedSeqOps: 1,
  sc_IndexedSeq: 1,
  sci_IndexedSeqOps: 1,
  sci_IndexedSeq: 1
}));
function $as_sci_SeqMap$SeqMap1(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap1"));
}
function $isArrayOf_sci_SeqMap$SeqMap1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap1)));
}
function $asArrayOf_sci_SeqMap$SeqMap1(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap1;", depth));
}
function $as_sci_SeqMap$SeqMap2(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap2"));
}
function $isArrayOf_sci_SeqMap$SeqMap2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap2)));
}
function $asArrayOf_sci_SeqMap$SeqMap2(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap2;", depth));
}
function $as_sci_SeqMap$SeqMap3(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap3"));
}
function $isArrayOf_sci_SeqMap$SeqMap3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap3)));
}
function $asArrayOf_sci_SeqMap$SeqMap3(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap3;", depth));
}
function $as_sci_SeqMap$SeqMap4(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SeqMap$SeqMap4"));
}
function $isArrayOf_sci_SeqMap$SeqMap4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap4)));
}
function $asArrayOf_sci_SeqMap$SeqMap4(obj, depth) {
  return (($isArrayOf_sci_SeqMap$SeqMap4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SeqMap$SeqMap4;", depth));
}
/** @constructor */
function $c_sci_Set$Set1(elem1) {
  this.sci_Set$Set1__f_elem1 = null;
  this.sci_Set$Set1__f_elem1 = elem1;
}
$c_sci_Set$Set1.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set1.prototype.constructor = $c_sci_Set$Set1;
/** @constructor */
function $h_sci_Set$Set1() {
}
$h_sci_Set$Set1.prototype = $c_sci_Set$Set1.prototype;
$c_sci_Set$Set1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set1.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Set$Set1.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set1.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true);
});
$c_sci_Set$Set1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set1.prototype.size__I = (function() {
  return 1;
});
$c_sci_Set$Set1.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set1.prototype.knownSize__I = (function() {
  return 1;
});
$c_sci_Set$Set1.prototype.contains__O__Z = (function(elem) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1);
});
$c_sci_Set$Set1.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set2(this.sci_Set$Set1__f_elem1, elem));
});
$c_sci_Set$Set1.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1) ? $m_sci_Set$EmptySet$() : this);
});
$c_sci_Set$Set1.prototype.iterator__sc_Iterator = (function() {
  var a = this.sci_Set$Set1__f_elem1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Set$Set1.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set1__f_elem1);
});
$c_sci_Set$Set1.prototype.forall__F1__Z = (function(p) {
  return $uZ($n(p).apply__O__O(this.sci_Set$Set1__f_elem1));
});
$c_sci_Set$Set1.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  return (($uZ($n(pred).apply__O__O(this.sci_Set$Set1__f_elem1)) !== isFlipped) ? this : $m_sci_Set$EmptySet$());
});
$c_sci_Set$Set1.prototype.head__O = (function() {
  return this.sci_Set$Set1__f_elem1;
});
$c_sci_Set$Set1.prototype.tail__O = (function() {
  return $m_sci_Set$EmptySet$();
});
$c_sci_Set$Set1.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set1.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_Set$Set1(obj) {
  return (((obj instanceof $c_sci_Set$Set1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set1"));
}
function $isArrayOf_sci_Set$Set1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set1)));
}
function $asArrayOf_sci_Set$Set1(obj, depth) {
  return (($isArrayOf_sci_Set$Set1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set1;", depth));
}
var $d_sci_Set$Set1 = new $TypeData().initClass($c_sci_Set$Set1, "scala.collection.immutable.Set$Set1", ({
  sci_Set$Set1: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set2(elem1, elem2) {
  this.sci_Set$Set2__f_elem1 = null;
  this.sci_Set$Set2__f_elem2 = null;
  this.sci_Set$Set2__f_elem1 = elem1;
  this.sci_Set$Set2__f_elem2 = elem2;
}
$c_sci_Set$Set2.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set2.prototype.constructor = $c_sci_Set$Set2;
/** @constructor */
function $h_sci_Set$Set2() {
}
$h_sci_Set$Set2.prototype = $c_sci_Set$Set2.prototype;
$c_sci_Set$Set2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set2.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Set$Set2.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set2.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true);
});
$c_sci_Set$Set2.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set2.prototype.size__I = (function() {
  return 2;
});
$c_sci_Set$Set2.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set2.prototype.knownSize__I = (function() {
  return 2;
});
$c_sci_Set$Set2.prototype.contains__O__Z = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2));
});
$c_sci_Set$Set2.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set3(this.sci_Set$Set2__f_elem1, this.sci_Set$Set2__f_elem2, elem));
});
$c_sci_Set$Set2.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem1) : this));
});
$c_sci_Set$Set2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set2$$anon$1(this);
});
$c_sci_Set$Set2.prototype.scala$collection$immutable$Set$Set2$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set2__f_elem1;
      break;
    }
    case 1: {
      return this.sci_Set$Set2__f_elem2;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$c_sci_Set$Set2.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set2__f_elem1);
  $n(f).apply__O__O(this.sci_Set$Set2__f_elem2);
});
$c_sci_Set$Set2.prototype.forall__F1__Z = (function(p) {
  return ($uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem1)) && $uZ($n(p).apply__O__O(this.sci_Set$Set2__f_elem2)));
});
$c_sci_Set$Set2.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set2__f_elem1)) !== isFlipped)) {
    r1 = this.sci_Set$Set2__f_elem1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set2__f_elem2)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set2__f_elem2;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Set$Set2.prototype.head__O = (function() {
  return this.sci_Set$Set2__f_elem1;
});
$c_sci_Set$Set2.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2);
});
$c_sci_Set$Set2.prototype.tail__O = (function() {
  return this.tail__sci_Set();
});
$c_sci_Set$Set2.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set2.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_Set$Set2(obj) {
  return (((obj instanceof $c_sci_Set$Set2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set2"));
}
function $isArrayOf_sci_Set$Set2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set2)));
}
function $asArrayOf_sci_Set$Set2(obj, depth) {
  return (($isArrayOf_sci_Set$Set2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set2;", depth));
}
var $d_sci_Set$Set2 = new $TypeData().initClass($c_sci_Set$Set2, "scala.collection.immutable.Set$Set2", ({
  sci_Set$Set2: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set3(elem1, elem2, elem3) {
  this.sci_Set$Set3__f_elem1 = null;
  this.sci_Set$Set3__f_elem2 = null;
  this.sci_Set$Set3__f_elem3 = null;
  this.sci_Set$Set3__f_elem1 = elem1;
  this.sci_Set$Set3__f_elem2 = elem2;
  this.sci_Set$Set3__f_elem3 = elem3;
}
$c_sci_Set$Set3.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set3.prototype.constructor = $c_sci_Set$Set3;
/** @constructor */
function $h_sci_Set$Set3() {
}
$h_sci_Set$Set3.prototype = $c_sci_Set$Set3.prototype;
$c_sci_Set$Set3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set3.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Set$Set3.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set3.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true);
});
$c_sci_Set$Set3.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set3.prototype.size__I = (function() {
  return 3;
});
$c_sci_Set$Set3.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set3.prototype.knownSize__I = (function() {
  return 3;
});
$c_sci_Set$Set3.prototype.contains__O__Z = (function(elem) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3));
});
$c_sci_Set$Set3.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set4(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3, elem));
});
$c_sci_Set$Set3.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2) : this)));
});
$c_sci_Set$Set3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set3$$anon$2(this);
});
$c_sci_Set$Set3.prototype.scala$collection$immutable$Set$Set3$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set3__f_elem1;
      break;
    }
    case 1: {
      return this.sci_Set$Set3__f_elem2;
      break;
    }
    case 2: {
      return this.sci_Set$Set3__f_elem3;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$c_sci_Set$Set3.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set3__f_elem1);
  $n(f).apply__O__O(this.sci_Set$Set3__f_elem2);
  $n(f).apply__O__O(this.sci_Set$Set3__f_elem3);
});
$c_sci_Set$Set3.prototype.forall__F1__Z = (function(p) {
  return (($uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem1)) && $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem2))) && $uZ($n(p).apply__O__O(this.sci_Set$Set3__f_elem3)));
});
$c_sci_Set$Set3.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set3__f_elem1)) !== isFlipped)) {
    r1 = this.sci_Set$Set3__f_elem1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set3__f_elem2)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set3__f_elem2;
    } else {
      r2 = this.sci_Set$Set3__f_elem2;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set3__f_elem3)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set3__f_elem3;
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set3__f_elem3;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Set$Set3.prototype.head__O = (function() {
  return this.sci_Set$Set3__f_elem1;
});
$c_sci_Set$Set3.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3);
});
$c_sci_Set$Set3.prototype.tail__O = (function() {
  return this.tail__sci_Set();
});
$c_sci_Set$Set3.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set3.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_Set$Set3(obj) {
  return (((obj instanceof $c_sci_Set$Set3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set3"));
}
function $isArrayOf_sci_Set$Set3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set3)));
}
function $asArrayOf_sci_Set$Set3(obj, depth) {
  return (($isArrayOf_sci_Set$Set3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set3;", depth));
}
var $d_sci_Set$Set3 = new $TypeData().initClass($c_sci_Set$Set3, "scala.collection.immutable.Set$Set3", ({
  sci_Set$Set3: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Set$Set4(elem1, elem2, elem3, elem4) {
  this.sci_Set$Set4__f_elem1 = null;
  this.sci_Set$Set4__f_elem2 = null;
  this.sci_Set$Set4__f_elem3 = null;
  this.sci_Set$Set4__f_elem4 = null;
  this.sci_Set$Set4__f_elem1 = elem1;
  this.sci_Set$Set4__f_elem2 = elem2;
  this.sci_Set$Set4__f_elem3 = elem3;
  this.sci_Set$Set4__f_elem4 = elem4;
}
$c_sci_Set$Set4.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set4.prototype.constructor = $c_sci_Set$Set4;
/** @constructor */
function $h_sci_Set$Set4() {
}
$h_sci_Set$Set4.prototype = $c_sci_Set$Set4.prototype;
$c_sci_Set$Set4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set4.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Set$Set4.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set4.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, true);
});
$c_sci_Set$Set4.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set4.prototype.size__I = (function() {
  return 4;
});
$c_sci_Set$Set4.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set4.prototype.knownSize__I = (function() {
  return 4;
});
$c_sci_Set$Set4.prototype.contains__O__Z = (function(elem) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4));
});
$c_sci_Set$Set4.prototype.incl__O__sci_Set = (function(elem) {
  if (this.contains__O__Z(elem)) {
    return this;
  } else {
    var this$1 = $m_sci_HashSet$();
    var this$2 = $n(this$1.sci_HashSet$__f_EmptySet);
    var elem$1 = this.sci_Set$Set4__f_elem1;
    var this$3 = $n(this$2.incl__O__sci_HashSet(elem$1));
    var elem$2 = this.sci_Set$Set4__f_elem2;
    var this$4 = $n(this$3.incl__O__sci_HashSet(elem$2));
    var elem$3 = this.sci_Set$Set4__f_elem3;
    var this$5 = $n(this$4.incl__O__sci_HashSet(elem$3));
    var elem$4 = this.sci_Set$Set4__f_elem4;
    var this$6 = $n(this$5.incl__O__sci_HashSet(elem$4));
    return this$6.incl__O__sci_HashSet(elem);
  }
});
$c_sci_Set$Set4.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3) : this))));
});
$c_sci_Set$Set4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set4$$anon$3(this);
});
$c_sci_Set$Set4.prototype.scala$collection$immutable$Set$Set4$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set4__f_elem1;
      break;
    }
    case 1: {
      return this.sci_Set$Set4__f_elem2;
      break;
    }
    case 2: {
      return this.sci_Set$Set4__f_elem3;
      break;
    }
    case 3: {
      return this.sci_Set$Set4__f_elem4;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$c_sci_Set$Set4.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem1);
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem2);
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem3);
  $n(f).apply__O__O(this.sci_Set$Set4__f_elem4);
});
$c_sci_Set$Set4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem1)) && $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem2))) && $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem3))) && $uZ($n(p).apply__O__O(this.sci_Set$Set4__f_elem4)));
});
$c_sci_Set$Set4.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var r3 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem1)) !== isFlipped)) {
    r1 = this.sci_Set$Set4__f_elem1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem2)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem2;
    } else {
      r2 = this.sci_Set$Set4__f_elem2;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem3)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem3;
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set4__f_elem3;
    } else {
      r3 = this.sci_Set$Set4__f_elem3;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(this.sci_Set$Set4__f_elem4)) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem4;
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set4__f_elem4;
    } else if ((n === 2)) {
      r3 = this.sci_Set$Set4__f_elem4;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return new $c_sci_Set$Set3(r1, r2, r3);
      break;
    }
    case 4: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Set$Set4.prototype.head__O = (function() {
  return this.sci_Set$Set4__f_elem1;
});
$c_sci_Set$Set4.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4);
});
$c_sci_Set$Set4.prototype.buildTo__scm_Builder__scm_Builder = (function(builder) {
  return $as_scm_Builder($n($n($n($n(builder).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem1)).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem2)).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem3)).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem4));
});
$c_sci_Set$Set4.prototype.tail__O = (function() {
  return this.tail__sci_Set();
});
$c_sci_Set$Set4.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set4.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_Set$Set4(obj) {
  return (((obj instanceof $c_sci_Set$Set4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set4"));
}
function $isArrayOf_sci_Set$Set4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set4)));
}
function $asArrayOf_sci_Set$Set4(obj, depth) {
  return (($isArrayOf_sci_Set$Set4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set4;", depth));
}
var $d_sci_Set$Set4 = new $TypeData().initClass($c_sci_Set$Set4, "scala.collection.immutable.Set$Set4", ({
  sci_Set$Set4: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_AbstractSeq() {
}
$c_scm_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_scm_AbstractSeq.prototype.constructor = $c_scm_AbstractSeq;
/** @constructor */
function $h_scm_AbstractSeq() {
}
$h_scm_AbstractSeq.prototype = $c_scm_AbstractSeq.prototype;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Drop(underlying, n, mutationCount) {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(this, underlying, n);
}
$c_scm_CheckedIndexedSeqView$Drop.prototype = new $h_sc_IndexedSeqView$Drop();
$c_scm_CheckedIndexedSeqView$Drop.prototype.constructor = $c_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Drop() {
}
$h_scm_CheckedIndexedSeqView$Drop.prototype = $c_scm_CheckedIndexedSeqView$Drop.prototype;
$c_scm_CheckedIndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Drop = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Drop, "scala.collection.mutable.CheckedIndexedSeqView$Drop", ({
  scm_CheckedIndexedSeqView$Drop: 1,
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$DropRight(underlying, n, mutationCount) {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
  this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(this, underlying, n);
}
$c_scm_CheckedIndexedSeqView$DropRight.prototype = new $h_sc_IndexedSeqView$DropRight();
$c_scm_CheckedIndexedSeqView$DropRight.prototype.constructor = $c_scm_CheckedIndexedSeqView$DropRight;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$DropRight() {
}
$h_scm_CheckedIndexedSeqView$DropRight.prototype = $c_scm_CheckedIndexedSeqView$DropRight.prototype;
$c_scm_CheckedIndexedSeqView$DropRight.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$DropRight = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$DropRight, "scala.collection.mutable.CheckedIndexedSeqView$DropRight", ({
  scm_CheckedIndexedSeqView$DropRight: 1,
  sc_IndexedSeqView$DropRight: 1,
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Map(underlying, f, mutationCount) {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(this, underlying, f);
}
$c_scm_CheckedIndexedSeqView$Map.prototype = new $h_sc_IndexedSeqView$Map();
$c_scm_CheckedIndexedSeqView$Map.prototype.constructor = $c_scm_CheckedIndexedSeqView$Map;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Map() {
}
$h_scm_CheckedIndexedSeqView$Map.prototype = $c_scm_CheckedIndexedSeqView$Map.prototype;
$c_scm_CheckedIndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Map = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Map, "scala.collection.mutable.CheckedIndexedSeqView$Map", ({
  scm_CheckedIndexedSeqView$Map: 1,
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
function $is_scm_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Set)));
}
function $as_scm_Set(obj) {
  return (($is_scm_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Set"));
}
function $isArrayOf_scm_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Set)));
}
function $asArrayOf_scm_Set(obj, depth) {
  return (($isArrayOf_scm_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Set;", depth));
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__unique__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).unique__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => {
    var target = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).start__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r));
    var tc = $thiz.F__Lcats_effect_kernel_GenSpawn();
    var this$3 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fib) => {
      var fib$1 = $as_Lcats_effect_kernel_Fiber(fib);
      return new $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10(fib$1, $thiz);
    }));
    return $n(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$3.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__never__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).never__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).cede__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fb) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n($thiz.F__Lcats_effect_kernel_GenSpawn()).uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var $x_1 = $n(poll$1);
    var target = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).racePair__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(r));
    var tc = $thiz.F__Lcats_effect_kernel_GenSpawn();
    var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_s_util_Either(x$1);
      if ((x$1$1 instanceof $c_s_util_Left)) {
        var x178 = $as_T2($n($as_s_util_Left(x$1$1)).s_util_Left__f_value);
        if ((x178 !== null)) {
          var oc = $as_Lcats_effect_kernel_Outcome($n(x178)._1__O());
          var fib = $as_Lcats_effect_kernel_Fiber($n(x178)._2__O());
          var _1 = $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, oc);
          var _2 = new $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10(fib, $thiz);
          var value = new $c_T2(_1, _2);
          return new $c_s_util_Left(value);
        }
      }
      if ((x$1$1 instanceof $c_s_util_Right)) {
        var x174 = $as_T2($n($as_s_util_Right(x$1$1)).s_util_Right__f_value);
        if ((x174 !== null)) {
          var fib$2 = $as_Lcats_effect_kernel_Fiber($n(x174)._1__O());
          var oc$2 = $as_Lcats_effect_kernel_Outcome($n(x174)._2__O());
          var _1$1 = new $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$10(fib$2, $thiz);
          var _2$1 = $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, oc$2);
          var value$1 = new $c_T2(_1$1, _2$1);
          return new $c_s_util_Right(value$1);
        }
      }
      throw new $c_s_MatchError(x$1$1);
    }));
    return $x_1.apply__O__O($n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f));
  })))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fb) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n($thiz.F__Lcats_effect_kernel_GenSpawn()).both__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(r))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fb) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => {
    var target = $n($thiz.F__Lcats_effect_kernel_GenSpawn()).raceOutcome__O__O__O($n($n(fa).Lcats_data_Kleisli__f_run).apply__O__O(r), $n($n(fb).Lcats_data_Kleisli__f_run).apply__O__O(r));
    var tc = $thiz.F__Lcats_effect_kernel_GenSpawn();
    var this$7 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, tc);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$104) => {
      var _$104$1 = $as_s_util_Either(_$104);
      if ((_$104$1 instanceof $c_s_util_Left)) {
        var a = $n($as_s_util_Left(_$104$1)).s_util_Left__f_value;
        var _$105 = $as_Lcats_effect_kernel_Outcome(a);
        var value = $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, _$105);
        return new $c_s_util_Left(value);
      }
      if ((_$104$1 instanceof $c_s_util_Right)) {
        var b = $n($as_s_util_Right(_$104$1)).s_util_Right__f_value;
        var _$106 = $as_Lcats_effect_kernel_Outcome(b);
        var value$1 = $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, _$106);
        return new $c_s_util_Right(value$1);
      }
      throw new $c_s_MatchError(_$104$1);
    }));
    return $n(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance).map__O__F1__O(this$7.Lcats_Functor$ToFunctorOps$$anon$5__f_self, f);
  }));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cats$effect$kernel$GenSpawn$KleisliGenSpawn$$liftOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Outcome($thiz, oc) {
  var nat = new $c_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn$$anon$9();
  return $f_Lcats_effect_kernel_Outcome__mapK__Lcats_arrow_FunctionK__Lcats_effect_kernel_Outcome($n(oc), nat);
}
/** @constructor */
function $c_sci_Map$EmptyMap$() {
}
$c_sci_Map$EmptyMap$.prototype = new $h_sci_AbstractMap();
$c_sci_Map$EmptyMap$.prototype.constructor = $c_sci_Map$EmptyMap$;
/** @constructor */
function $h_sci_Map$EmptyMap$() {
}
$h_sci_Map$EmptyMap$.prototype = $c_sci_Map$EmptyMap$.prototype;
$c_sci_Map$EmptyMap$.prototype.size__I = (function() {
  return 0;
});
$c_sci_Map$EmptyMap$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Map$EmptyMap$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_Map$EmptyMap$.prototype.apply__O__E = (function(key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
});
$c_sci_Map$EmptyMap$.prototype.contains__O__Z = (function(key) {
  return false;
});
$c_sci_Map$EmptyMap$.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$();
});
$c_sci_Map$EmptyMap$.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $n(default$1).apply__O();
});
$c_sci_Map$EmptyMap$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Map$EmptyMap$.prototype.keysIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Map$EmptyMap$.prototype.valuesIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sci_Map = (function(suffix) {
  if ($is_sci_Map(suffix)) {
    var x2 = $as_sci_Map(suffix);
    return x2;
  } else {
    return $as_sci_Map($f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix));
  }
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_Map(suffix);
});
$c_sci_Map$EmptyMap$.prototype.removed__O__sci_MapOps = (function(key) {
  return this;
});
$c_sci_Map$EmptyMap$.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return new $c_sci_Map$Map1(key, value);
});
$c_sci_Map$EmptyMap$.prototype.apply__O__O = (function(key) {
  this.apply__O__E(key);
});
var $d_sci_Map$EmptyMap$ = new $TypeData().initClass($c_sci_Map$EmptyMap$, "scala.collection.immutable.Map$EmptyMap$", ({
  sci_Map$EmptyMap$: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Map$EmptyMap$;
function $m_sci_Map$EmptyMap$() {
  if ((!$n_sci_Map$EmptyMap$)) {
    $n_sci_Map$EmptyMap$ = new $c_sci_Map$EmptyMap$();
  }
  return $n_sci_Map$EmptyMap$;
}
function $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__($thiz, outer) {
  $n(outer);
  $thiz.sci_MapOps$ImmutableKeySet__f_$outer = outer;
  return $thiz;
}
/** @constructor */
function $c_sci_MapOps$ImmutableKeySet() {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null;
}
$c_sci_MapOps$ImmutableKeySet.prototype = new $h_sci_AbstractSet();
$c_sci_MapOps$ImmutableKeySet.prototype.constructor = $c_sci_MapOps$ImmutableKeySet;
/** @constructor */
function $h_sci_MapOps$ImmutableKeySet() {
}
$h_sci_MapOps$ImmutableKeySet.prototype = $c_sci_MapOps$ImmutableKeySet.prototype;
$c_sci_MapOps$ImmutableKeySet.prototype.iterator__sc_Iterator = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).keysIterator__sc_Iterator();
});
$c_sci_MapOps$ImmutableKeySet.prototype.contains__O__Z = (function(key) {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).contains__O__Z(key);
});
$c_sci_MapOps$ImmutableKeySet.prototype.size__I = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).size__I();
});
$c_sci_MapOps$ImmutableKeySet.prototype.knownSize__I = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).knownSize__I();
});
$c_sci_MapOps$ImmutableKeySet.prototype.isEmpty__Z = (function() {
  return $n(this.sci_MapOps$ImmutableKeySet__f_$outer).isEmpty__Z();
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_Set = (function(elem) {
  if ($n(this.sci_MapOps$ImmutableKeySet__f_$outer).contains__O__Z(elem)) {
    return this;
  } else {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $n($as_sci_SetOps($f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this)));
    return $as_sci_Set(this$3.incl__O__sci_SetOps(elem));
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_Set = (function(elem) {
  if ($n(this.sci_MapOps$ImmutableKeySet__f_$outer).contains__O__Z(elem)) {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $n($as_sci_SetOps($f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this)));
    return $as_sci_Set(this$3.excl__O__sci_SetOps(elem));
  } else {
    return this;
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_MapOps$ImmutableKeySet(obj) {
  return (((obj instanceof $c_sci_MapOps$ImmutableKeySet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapOps$ImmutableKeySet"));
}
function $isArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapOps$ImmutableKeySet)));
}
function $asArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) {
  return (($isArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapOps$ImmutableKeySet;", depth));
}
var $d_sci_MapOps$ImmutableKeySet = new $TypeData().initClass($c_sci_MapOps$ImmutableKeySet, "scala.collection.immutable.MapOps$ImmutableKeySet", ({
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $f_scm_Buffer__subtractOne__O__scm_Buffer($thiz, x) {
  var i = $thiz.indexOf__O__I__I(x, 0);
  if ((i !== (-1))) {
    $thiz.remove__I__O(i);
  }
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_kernel_GenSpawn$$anon$3(F0$8) {
  this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3 = null;
  this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3 = F0$8;
}
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype = new $h_O();
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_GenSpawn$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_GenSpawn$$anon$3() {
}
$h_Lcats_effect_kernel_GenSpawn$$anon$3.prototype = $c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype;
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.F__Lcats_effect_kernel_GenSpawn = (function() {
  return this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__unique__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__never__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.cede__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.racePair__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_GenSpawn$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenSpawn$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_GenSpawn$$anon$3 = new $TypeData().initClass($c_Lcats_effect_kernel_GenSpawn$$anon$3, "cats.effect.kernel.GenSpawn$$anon$3", ({
  Lcats_effect_kernel_GenSpawn$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn: 1
}));
function $f_Lcats_effect_kernel_Sync__$init$__V($thiz) {
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V($m_Lcats_effect_kernel_Sync$Type$Delay$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V($m_Lcats_effect_kernel_Sync$Type$Blocking$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V($m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V($m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$());
}
function $f_Lcats_effect_kernel_Sync__unique__O($thiz) {
  return $thiz.delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => new $c_Lcats_effect_kernel_Unique$Token())));
}
function $f_Lcats_effect_kernel_Sync__defer__F0__O($thiz, thunk) {
  return $thiz.flatMap__O__F1__O($thiz.delay__F0__O(thunk), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x) => x)));
}
function $is_Lcats_effect_kernel_Sync(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Sync)));
}
function $as_Lcats_effect_kernel_Sync(obj) {
  return (($is_Lcats_effect_kernel_Sync(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Sync"));
}
function $isArrayOf_Lcats_effect_kernel_Sync(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Sync)));
}
function $asArrayOf_Lcats_effect_kernel_Sync(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Sync(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Sync;", depth));
}
/** @constructor */
function $c_Lcats_kernel_Eq$() {
}
$c_Lcats_kernel_Eq$.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_Eq$.prototype.constructor = $c_Lcats_kernel_Eq$;
/** @constructor */
function $h_Lcats_kernel_Eq$() {
}
$h_Lcats_kernel_Eq$.prototype = $c_Lcats_kernel_Eq$.prototype;
var $d_Lcats_kernel_Eq$ = new $TypeData().initClass($c_Lcats_kernel_Eq$, "cats.kernel.Eq$", ({
  Lcats_kernel_Eq$: 1,
  Lcats_kernel_EqFunctions: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_ScalaVersionSpecificEqInstances: 1,
  Lcats_kernel_ScalaVersionSpecificHashInstances: 1,
  Lcats_kernel_ScalaVersionSpecificPartialOrderInstances: 1,
  Lcats_kernel_ScalaVersionSpecificOrderInstances: 1,
  Lcats_kernel_instances_TupleEqInstances: 1,
  Lcats_kernel_instances_TupleHashInstances: 1,
  Lcats_kernel_instances_TuplePartialOrderInstances: 1,
  Lcats_kernel_instances_TupleOrderInstances: 1,
  Lcats_kernel_EqInstances0: 1,
  Lcats_kernel_EqInstances: 1,
  Lcats_kernel_HashInstances0: 1,
  Lcats_kernel_HashInstances: 1,
  Lcats_kernel_PartialOrderInstances0: 1,
  Lcats_kernel_PartialOrderInstances1: 1,
  Lcats_kernel_PartialOrderInstances: 1,
  Lcats_kernel_OrderInstances0: 1,
  Lcats_kernel_OrderInstances1: 1
}));
var $n_Lcats_kernel_Eq$;
function $m_Lcats_kernel_Eq$() {
  if ((!$n_Lcats_kernel_Eq$)) {
    $n_Lcats_kernel_Eq$ = new $c_Lcats_kernel_Eq$();
  }
  return $n_Lcats_kernel_Eq$;
}
/** @constructor */
function $c_Lcats_kernel_Semigroup$() {
}
$c_Lcats_kernel_Semigroup$.prototype = new $h_Lcats_kernel_SemigroupFunctions();
$c_Lcats_kernel_Semigroup$.prototype.constructor = $c_Lcats_kernel_Semigroup$;
/** @constructor */
function $h_Lcats_kernel_Semigroup$() {
}
$h_Lcats_kernel_Semigroup$.prototype = $c_Lcats_kernel_Semigroup$.prototype;
var $d_Lcats_kernel_Semigroup$ = new $TypeData().initClass($c_Lcats_kernel_Semigroup$, "cats.kernel.Semigroup$", ({
  Lcats_kernel_Semigroup$: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  Lcats_kernel_ScalaVersionSpecificMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemigroupInstances: 1,
  Lcats_kernel_instances_TupleBandInstances: 1,
  Lcats_kernel_instances_TupleCommutativeSemigroupInstances: 1,
  Lcats_kernel_instances_TupleMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeMonoidInstances: 1,
  Lcats_kernel_instances_TupleGroupInstances: 1,
  Lcats_kernel_instances_TupleBoundedSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeGroupInstances: 1,
  Lcats_kernel_SemigroupInstances: 1,
  Lcats_kernel_CommutativeSemigroupInstances: 1,
  Lcats_kernel_BandInstances: 1,
  Lcats_kernel_MonoidInstances: 1,
  Lcats_kernel_CommutativeMonoidInstances: 1,
  Lcats_kernel_SemilatticeInstances: 1,
  Lcats_kernel_BoundedSemilatticeInstances: 1,
  Lcats_kernel_GroupInstances: 1
}));
var $n_Lcats_kernel_Semigroup$;
function $m_Lcats_kernel_Semigroup$() {
  if ((!$n_Lcats_kernel_Semigroup$)) {
    $n_Lcats_kernel_Semigroup$ = new $c_Lcats_kernel_Semigroup$();
  }
  return $n_Lcats_kernel_Semigroup$;
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set($thiz, newHashMap) {
  return ((newHashMap === $as_sci_HashMap($thiz.sci_MapOps$ImmutableKeySet__f_$outer)) ? $thiz : $n(newHashMap).keySet__sci_Set());
}
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set($thiz, newRootNode) {
  return ((newRootNode === $n($as_sci_HashMap($thiz.sci_MapOps$ImmutableKeySet__f_$outer)).sci_HashMap__f_rootNode) ? $thiz : new $c_sci_HashMap(newRootNode).keySet__sci_Set());
}
/** @constructor */
function $c_sci_HashMap$HashKeySet(outer) {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null;
  $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(this, outer);
}
$c_sci_HashMap$HashKeySet.prototype = new $h_sci_MapOps$ImmutableKeySet();
$c_sci_HashMap$HashKeySet.prototype.constructor = $c_sci_HashMap$HashKeySet;
/** @constructor */
function $h_sci_HashMap$HashKeySet() {
}
$h_sci_HashMap$HashKeySet.prototype = $c_sci_HashMap$HashKeySet.prototype;
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_Set = (function(elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  var improvedHash = $m_sc_Hashing$().improve__I__I(originalHash);
  var newNode = $n($n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer)).sci_HashMap__f_rootNode).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(elem, null, originalHash, improvedHash, 0, false);
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set(this, newNode);
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_Set = (function(elem) {
  var this$1 = $n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$1.removed__O__sci_HashMap(elem));
});
$c_sci_HashMap$HashKeySet.prototype.filter__F1__sci_Set = (function(pred) {
  var this$1 = $n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer));
  var pred$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2$2) => {
    var kv$2 = $as_T2(kv$2$2);
    return $uZ($n(pred).apply__O__O($n(kv$2)._1__O()));
  }));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$1.filterImpl__F1__Z__sci_HashMap(pred$1, false));
});
$c_sci_HashMap$HashKeySet.prototype.filterNot__F1__sci_Set = (function(pred) {
  var this$1 = $n($as_sci_HashMap(this.sci_MapOps$ImmutableKeySet__f_$outer));
  var pred$1 = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((kv$2$2) => {
    var kv$2 = $as_T2(kv$2$2);
    return $uZ($n(pred).apply__O__O($n(kv$2)._1__O()));
  }));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$1.filterImpl__F1__Z__sci_HashMap(pred$1, true));
});
$c_sci_HashMap$HashKeySet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterNot__F1__sci_Set(pred);
});
$c_sci_HashMap$HashKeySet.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_Set(pred);
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $as_sci_HashMap$HashKeySet(obj) {
  return (((obj instanceof $c_sci_HashMap$HashKeySet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashMap$HashKeySet"));
}
function $isArrayOf_sci_HashMap$HashKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap$HashKeySet)));
}
function $asArrayOf_sci_HashMap$HashKeySet(obj, depth) {
  return (($isArrayOf_sci_HashMap$HashKeySet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashMap$HashKeySet;", depth));
}
var $d_sci_HashMap$HashKeySet = new $TypeData().initClass($c_sci_HashMap$HashKeySet, "scala.collection.immutable.HashMap$HashKeySet", ({
  sci_HashMap$HashKeySet: 1,
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Map$Map1(key1, value1) {
  this.sci_Map$Map1__f_key1 = null;
  this.sci_Map$Map1__f_value1 = null;
  this.sci_Map$Map1__f_key1 = key1;
  this.sci_Map$Map1__f_value1 = value1;
}
$c_sci_Map$Map1.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map1.prototype.constructor = $c_sci_Map$Map1;
/** @constructor */
function $h_sci_Map$Map1() {
}
$h_sci_Map$Map1.prototype = $c_sci_Map$Map1.prototype;
$c_sci_Map$Map1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map1.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Map$Map1.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map1.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true);
});
$c_sci_Map$Map1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map1.prototype.size__I = (function() {
  return 1;
});
$c_sci_Map$Map1.prototype.knownSize__I = (function() {
  return 1;
});
$c_sci_Map$Map1.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map1.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)) {
    return this.sci_Map$Map1__f_value1;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map1.prototype.contains__O__Z = (function(key) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1);
});
$c_sci_Map$Map1.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_s_Some(this.sci_Map$Map1__f_value1) : $m_s_None$());
});
$c_sci_Map$Map1.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? this.sci_Map$Map1__f_value1 : $n(default$1).apply__O());
});
$c_sci_Map$Map1.prototype.iterator__sc_Iterator = (function() {
  var a = new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Map$Map1.prototype.keysIterator__sc_Iterator = (function() {
  var a = this.sci_Map$Map1__f_key1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Map$Map1.prototype.valuesIterator__sc_Iterator = (function() {
  var a = this.sci_Map$Map1__f_value1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_sci_Map$Map1(this.sci_Map$Map1__f_key1, value) : new $c_sci_Map$Map2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1, key, value));
});
$c_sci_Map$Map1.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? $m_sci_Map$EmptyMap$() : this);
});
$c_sci_Map$Map1.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1));
});
$c_sci_Map$Map1.prototype.forall__F1__Z = (function(p) {
  return $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1)));
});
$c_sci_Map$Map1.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  return (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))) !== isFlipped) ? this : $m_sci_Map$EmptyMap$());
});
$c_sci_Map$Map1.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 1);
});
$c_sci_Map$Map1.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $as_sci_Map$Map1(obj) {
  return (((obj instanceof $c_sci_Map$Map1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map1"));
}
function $isArrayOf_sci_Map$Map1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map1)));
}
function $asArrayOf_sci_Map$Map1(obj, depth) {
  return (($isArrayOf_sci_Map$Map1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map1;", depth));
}
var $d_sci_Map$Map1 = new $TypeData().initClass($c_sci_Map$Map1, "scala.collection.immutable.Map$Map1", ({
  sci_Map$Map1: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Map$Map2(key1, value1, key2, value2) {
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = key1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = value1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = key2;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = value2;
}
$c_sci_Map$Map2.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map2.prototype.constructor = $c_sci_Map$Map2;
/** @constructor */
function $h_sci_Map$Map2() {
}
$h_sci_Map$Map2.prototype = $c_sci_Map$Map2.prototype;
$c_sci_Map$Map2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map2.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Map$Map2.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map2.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true);
});
$c_sci_Map$Map2.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map2.prototype.size__I = (function() {
  return 2;
});
$c_sci_Map$Map2.prototype.knownSize__I = (function() {
  return 2;
});
$c_sci_Map$Map2.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map2.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map2.prototype.contains__O__Z = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2));
});
$c_sci_Map$Map2.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : $m_s_None$()));
});
$c_sci_Map$Map2.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 : $n(default$1).apply__O()));
});
$c_sci_Map$Map2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$1(this);
});
$c_sci_Map$Map2.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$2(this);
});
$c_sci_Map$Map2.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$3(this);
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, value, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, value) : new $c_sci_Map$Map3(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2, key, value)));
});
$c_sci_Map$Map2.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : this));
});
$c_sci_Map$Map2.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2));
});
$c_sci_Map$Map2.prototype.forall__F1__Z = (function(p) {
  return ($uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))));
});
$c_sci_Map$Map2.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var v1 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1;
    v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2;
      v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Map$Map2.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 2);
});
$c_sci_Map$Map2.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $as_sci_Map$Map2(obj) {
  return (((obj instanceof $c_sci_Map$Map2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map2"));
}
function $isArrayOf_sci_Map$Map2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map2)));
}
function $asArrayOf_sci_Map$Map2(obj, depth) {
  return (($isArrayOf_sci_Map$Map2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map2;", depth));
}
var $d_sci_Map$Map2 = new $TypeData().initClass($c_sci_Map$Map2, "scala.collection.immutable.Map$Map2", ({
  sci_Map$Map2: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Map$Map3(key1, value1, key2, value2, key3, value3) {
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = key1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = value1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = key2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = value2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = key3;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = value3;
}
$c_sci_Map$Map3.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map3.prototype.constructor = $c_sci_Map$Map3;
/** @constructor */
function $h_sci_Map$Map3() {
}
$h_sci_Map$Map3.prototype = $c_sci_Map$Map3.prototype;
$c_sci_Map$Map3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map3.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Map$Map3.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map3.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true);
});
$c_sci_Map$Map3.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map3.prototype.size__I = (function() {
  return 3;
});
$c_sci_Map$Map3.prototype.knownSize__I = (function() {
  return 3;
});
$c_sci_Map$Map3.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map3.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map3.prototype.contains__O__Z = (function(key) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3));
});
$c_sci_Map$Map3.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : $m_s_None$())));
});
$c_sci_Map$Map3.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 : $n(default$1).apply__O())));
});
$c_sci_Map$Map3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$4(this);
});
$c_sci_Map$Map3.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$5(this);
});
$c_sci_Map$Map3.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$6(this);
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, value) : new $c_sci_Map$Map4(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3, key, value))));
});
$c_sci_Map$Map3.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : this)));
});
$c_sci_Map$Map3.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3));
});
$c_sci_Map$Map3.prototype.forall__F1__Z = (function(p) {
  return (($uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2)))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))));
});
$c_sci_Map$Map3.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var v1 = null;
  var v2 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1;
    v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
    } else {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Map$Map3.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 3);
});
$c_sci_Map$Map3.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $as_sci_Map$Map3(obj) {
  return (((obj instanceof $c_sci_Map$Map3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map3"));
}
function $isArrayOf_sci_Map$Map3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map3)));
}
function $asArrayOf_sci_Map$Map3(obj, depth) {
  return (($isArrayOf_sci_Map$Map3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map3;", depth));
}
var $d_sci_Map$Map3 = new $TypeData().initClass($c_sci_Map$Map3, "scala.collection.immutable.Map$Map3", ({
  sci_Map$Map3: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Map$Map4(key1, value1, key2, value2, key3, value3, key4, value4) {
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = key1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = value1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = key2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = value2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = key3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = value3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = key4;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = value4;
}
$c_sci_Map$Map4.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map4.prototype.constructor = $c_sci_Map$Map4;
/** @constructor */
function $h_sci_Map$Map4() {
}
$h_sci_Map$Map4.prototype = $c_sci_Map$Map4.prototype;
$c_sci_Map$Map4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map4.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Map$Map4.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map4.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, true);
});
$c_sci_Map$Map4.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map4.prototype.size__I = (function() {
  return 4;
});
$c_sci_Map$Map4.prototype.knownSize__I = (function() {
  return 4;
});
$c_sci_Map$Map4.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map4.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map4.prototype.contains__O__Z = (function(key) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4));
});
$c_sci_Map$Map4.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : $m_s_None$()))));
});
$c_sci_Map$Map4.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 : $n(default$1).apply__O()))));
});
$c_sci_Map$Map4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$7(this);
});
$c_sci_Map$Map4.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$8(this);
});
$c_sci_Map$Map4.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$9(this);
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_Map = (function(key, value) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, value);
  } else {
    var this$1 = $m_sci_HashMap$();
    return $n($n($n($n($n(this$1.sci_HashMap$__f_EmptyMap).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1)).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)).updated__O__O__sci_HashMap(key, value);
  }
});
$c_sci_Map$Map4.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : this))));
});
$c_sci_Map$Map4.prototype.foreach__F1__V = (function(f) {
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3));
  $n(f).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4));
});
$c_sci_Map$Map4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)))) && $uZ($n(p).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))));
});
$c_sci_Map$Map4.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var k3 = null;
  var v1 = null;
  var v2 = null;
  var v3 = null;
  var n = 0;
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1;
    v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1;
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
    } else {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
    } else {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
    }
    n = ((1 + n) | 0);
  }
  if (($uZ($n(pred).apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
    } else if ((n === 2)) {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      return new $c_sci_Map$Map3(k1, v1, k2, v2, k3, v3);
      break;
    }
    case 4: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Map$Map4.prototype.buildTo__sci_HashMapBuilder__sci_HashMapBuilder = (function(builder) {
  return $n($n($n($n(builder).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1)).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
});
$c_sci_Map$Map4.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 4);
});
$c_sci_Map$Map4.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $as_sci_Map$Map4(obj) {
  return (((obj instanceof $c_sci_Map$Map4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map4"));
}
function $isArrayOf_sci_Map$Map4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map4)));
}
function $asArrayOf_sci_Map$Map4(obj, depth) {
  return (($isArrayOf_sci_Map$Map4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map4;", depth));
}
var $d_sci_Map$Map4 = new $TypeData().initClass($c_sci_Map$Map4, "scala.collection.immutable.Map$Map4", ({
  sci_Map$Map4: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $f_scm_Map__withDefaultValue__O__scm_Map($thiz, d) {
  return new $c_scm_Map$WithDefault($thiz, new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => d)));
}
function $is_scm_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Map)));
}
function $as_scm_Map(obj) {
  return (($is_scm_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Map"));
}
function $isArrayOf_scm_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Map)));
}
function $asArrayOf_scm_Map(obj, depth) {
  return (($isArrayOf_scm_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Map;", depth));
}
/** @constructor */
function $c_Lcats_EvalInstances$$anon$6() {
}
$c_Lcats_EvalInstances$$anon$6.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$6.prototype.constructor = $c_Lcats_EvalInstances$$anon$6;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$6() {
}
$h_Lcats_EvalInstances$$anon$6.prototype = $c_Lcats_EvalInstances$$anon$6.prototype;
$c_Lcats_EvalInstances$$anon$6.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_Eval(fa);
  return $n(fa$1).map__F1__Lcats_Eval(f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_EvalInstances$$anon$6.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_EvalInstances$$anon$6.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_EvalInstances$$anon$6.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_EvalInstances$$anon$6.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_EvalInstances$$anon$6.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return $n(fa$1).map__F1__Lcats_Eval(f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.pure__O__O = (function(x) {
  return new $c_Lcats_Now(x);
});
$c_Lcats_EvalInstances$$anon$6.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return $n(fa$1).flatMap__F1__Lcats_Eval(f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.unit__O = (function() {
  return $m_Lcats_Eval$().Lcats_Eval$__f_Unit;
});
$c_Lcats_EvalInstances$$anon$6.prototype.void__O__O = (function(fa) {
  $as_Lcats_Eval(fa);
  return $m_Lcats_Eval$().Lcats_Eval$__f_Unit;
});
var $d_Lcats_EvalInstances$$anon$6 = new $TypeData().initClass($c_Lcats_EvalInstances$$anon$6, "cats.EvalInstances$$anon$6", ({
  Lcats_EvalInstances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1
}));
function $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__ref__O__Lcats_data_Kleisli($thiz, a) {
  var this$4 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenConcurrent()).map__O__F1__O($n($thiz.F__Lcats_effect_kernel_GenConcurrent()).ref__O__O(a), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$56) => {
    var _$56$1 = $as_Lcats_effect_kernel_Ref(_$56);
    var this$3 = $n(_$56$1);
    $m_Lcats_data_Kleisli$();
    var f = new $c_Lcats_data_KleisliFunctions$$anon$3();
    var G = $m_Lcats_effect_kernel_GenConcurrent$().genConcurrentForKleisli__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_GenConcurrent($thiz.F__Lcats_effect_kernel_GenConcurrent());
    return new $c_Lcats_effect_kernel_Ref$TransformedRef2(this$3, f, G);
  })));
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$4, x);
}
function $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__deferred__Lcats_data_Kleisli($thiz) {
  var this$3 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_GenConcurrent()).map__O__F1__O($n($thiz.F__Lcats_effect_kernel_GenConcurrent()).deferred__O(), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$58) => {
    var _$58$1 = $as_Lcats_effect_kernel_Deferred(_$58);
    var this$2 = $n(_$58$1);
    $m_Lcats_data_Kleisli$();
    var f = new $c_Lcats_data_KleisliFunctions$$anon$3();
    return new $c_Lcats_effect_kernel_Deferred$TransformedDeferred(this$2, f);
  })));
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$3, x);
}
function $is_Lcats_effect_kernel_GenTemporal(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_GenTemporal)));
}
function $as_Lcats_effect_kernel_GenTemporal(obj) {
  return (($is_Lcats_effect_kernel_GenTemporal(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.GenTemporal"));
}
function $isArrayOf_Lcats_effect_kernel_GenTemporal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_GenTemporal)));
}
function $asArrayOf_Lcats_effect_kernel_GenTemporal(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_GenTemporal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.GenTemporal;", depth));
}
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$2() {
}
$c_Lcats_instances_EitherInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$2.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$2() {
}
$h_Lcats_instances_EitherInstances$$anon$2.prototype = $c_Lcats_instances_EitherInstances$$anon$2.prototype;
$c_Lcats_instances_EitherInstances$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_util_Either(fa);
  return $n(fa$1).map__F1__s_util_Either(f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__s_util_Either__F1__Lcats_Applicative__O($as_s_util_Either(sa), f, evidence$1);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unit__s_util_Either = (function() {
  return $m_Lcats_syntax_EitherUtil$().Lcats_syntax_EitherUtil$__f_unit;
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__s_util_Either__F1__s_util_Either = (function(fea, f) {
  if ((fea instanceof $c_s_util_Left)) {
    var e = $n($as_s_util_Left(fea)).s_util_Left__f_value;
    return $as_s_util_Either($n(f).apply__O__O(e));
  }
  if ((fea instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(fea);
    return r;
  }
  throw new $c_s_MatchError(fea);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__s_util_Either = (function(b, f) {
  var b$tailLocal1 = b;
  while (true) {
    var x26 = $as_s_util_Either($n(f).apply__O__O(b$tailLocal1));
    if ((x26 instanceof $c_s_util_Left)) {
      var left = $as_s_util_Left(x26);
      return left;
    }
    if ((x26 instanceof $c_s_util_Right)) {
      var e = $as_s_util_Either($n($as_s_util_Right(x26)).s_util_Right__f_value);
      if ((e instanceof $c_s_util_Left)) {
        var b1 = $n($as_s_util_Left(e)).s_util_Left__f_value;
        b$tailLocal1 = b1;
        continue;
      }
      if ((e instanceof $c_s_util_Right)) {
        var right = $as_s_util_Right(e);
        return right;
      }
      throw new $c_s_MatchError(e);
    }
    throw new $c_s_MatchError(x26);
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fb, fc, f) {
  if ((fb instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(fb);
    $m_Lcats_syntax_EitherUtil$();
    return new $c_Lcats_Now(l);
  }
  if ((fb instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(fb)).s_util_Right__f_value;
    return $n(fc).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
      var _$10$1 = $as_s_util_Either(_$10);
      var this$3 = $n(_$10$1);
      if ((this$3 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(this$3);
        var b$1 = $n(x2).s_util_Right__f_value;
        return new $c_s_util_Right($n(f).apply__O__O__O(b, b$1));
      } else {
        return this$3;
      }
    })));
  }
  throw new $c_s_MatchError(fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__s_util_Either__F1__Lcats_Applicative__O = (function(fa, f, F) {
  if ((fa instanceof $c_s_util_Left)) {
    var left = $as_s_util_Left(fa);
    return $n(F).pure__O__O(left);
  }
  if ((fa instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(fa)).s_util_Right__f_value;
    return $n(F).map__O__F1__O($n(f).apply__O__O(b), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$13) => new $c_s_util_Right(_$13))));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fa, lc, f) {
  if ((fa instanceof $c_s_util_Left)) {
    return lc;
  }
  if ((fa instanceof $c_s_util_Right)) {
    var b = $n($as_s_util_Right(fa)).s_util_Right__f_value;
    return $as_Lcats_Eval($n(f).apply__O__O__O(b, lc));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O = (function(fab, f, C) {
  var this$1 = $n(fab);
  if ((this$1 instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this$1);
    var b = $n(x2).s_util_Right__f_value;
    return $n(f).apply__O__O(b);
  } else if ((this$1 instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(this$1);
    $n(x3);
    return $n(C).empty__O();
  } else {
    throw new $c_s_MatchError(this$1);
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.void__s_util_Either__s_util_Either = (function(e) {
  return ($n(e).isRight__Z() ? $m_Lcats_syntax_EitherUtil$().Lcats_syntax_EitherUtil$__f_unit : e);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unit__O = (function() {
  return this.unit__s_util_Either();
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.pure__O__O = (function(x) {
  return new $c_s_util_Right(x);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return $n(fa$1).flatMap__F1__s_util_Either(f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_util_Either__F1__s_util_Either($as_s_util_Either(fa), f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.raiseError__O__O = (function(e) {
  return new $c_s_util_Left(e);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return $n(fa$1).map__F1__s_util_Either(f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_util_Either(a, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval($as_s_util_Either(fa), fb, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_util_Either__F1__Lcats_Applicative__O($as_s_util_Either(fa), f, evidence$1);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval($as_s_util_Either(fa), lb, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.attempt__O__O = (function(fa) {
  var fab = $as_s_util_Either(fa);
  return new $c_s_util_Right(fab);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O($as_s_util_Either(fa), f, B);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.void__O__O = (function(fa) {
  return this.void__s_util_Either__s_util_Either($as_s_util_Either(fa));
});
var $d_Lcats_instances_EitherInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_EitherInstances$$anon$2, "cats.instances.EitherInstances$$anon$2", ({
  Lcats_instances_EitherInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lorg_scalajs_dom_NamedNodeMapMap(namedNodeMap) {
  this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap = null;
  this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap = namedNodeMap;
}
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype = new $h_O();
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.constructor = $c_Lorg_scalajs_dom_NamedNodeMapMap;
/** @constructor */
function $h_Lorg_scalajs_dom_NamedNodeMapMap() {
}
$h_Lorg_scalajs_dom_NamedNodeMapMap.prototype = $c_Lorg_scalajs_dom_NamedNodeMapMap.prototype;
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.head__O = (function() {
  var this$1 = new $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(this);
  return this$1.next__T2();
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.className__T = (function() {
  return "Map";
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Iterable$();
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.isDefinedAt__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.equals__O__Z = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.sizeHint__I__V = (function(size) {
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.update__O__O__V = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.getOrElseUpdate__O__F0__O = (function(key, op) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, op);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_Map$();
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lorg_scalajs_dom_NamedNodeMapMap$$anon$1(this);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.get__T__s_Option = (function(key) {
  var x1 = this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.getNamedItem(key);
  if ((x1 === null)) {
    return $m_s_None$();
  }
  return new $c_s_Some(x1);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.addOne__T2__Lorg_scalajs_dom_NamedNodeMapMap = (function(kv) {
  this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.setNamedItem($n(kv)._2__O());
  return this;
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.subtractOne__T__Lorg_scalajs_dom_NamedNodeMapMap = (function(key) {
  this.Lorg_scalajs_dom_NamedNodeMapMap__f_org$scalajs$dom$NamedNodeMapMap$$namedNodeMap.removeNamedItem(key);
  return this;
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.get__O__s_Option = (function(key) {
  return this.get__T__s_Option($as_T(key));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__Lorg_scalajs_dom_NamedNodeMapMap($as_T2(elem));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__T__Lorg_scalajs_dom_NamedNodeMapMap($as_T(elem));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.result__O = (function() {
  return this;
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $as_sc_IterableOps($m_scm_Map$().from__sc_IterableOnce__O(coll));
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_Lorg_scalajs_dom_NamedNodeMapMap.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ($f_sc_MapOps__apply__O__O(this, v1));
});
var $d_Lorg_scalajs_dom_NamedNodeMapMap = new $TypeData().initClass($c_Lorg_scalajs_dom_NamedNodeMapMap, "org.scalajs.dom.NamedNodeMapMap", ({
  Lorg_scalajs_dom_NamedNodeMapMap: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  scm_Iterable: 1,
  F1: 1,
  s_PartialFunction: 1,
  sc_MapOps: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sc_Map: 1,
  jl_Cloneable: 1,
  scm_Cloneable: 1,
  scm_Clearable: 1,
  scm_Growable: 1,
  scm_Builder: 1,
  scm_Shrinkable: 1,
  scm_MapOps: 1,
  scm_Map: 1
}));
function $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet($thiz, newRootNode) {
  return (($thiz.sci_HashSet__f_rootNode === newRootNode) ? $thiz : new $c_sci_HashSet(newRootNode));
}
function $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet($thiz, that) {
  var iter = $n(that).iterator__sc_Iterator();
  var curr = $thiz.sci_HashSet__f_rootNode;
  while ($n(iter).hasNext__Z()) {
    var next = $n(iter).next__O();
    var originalHash = $m_sr_Statics$().anyHash__O__I(next);
    var improved = $m_sc_Hashing$().improve__I__I(originalHash);
    curr = $n(curr).removed__O__I__I__I__sci_BitmapIndexedSetNode(next, originalHash, improved, 0);
    if ((curr !== $thiz.sci_HashSet__f_rootNode)) {
      if (($n(curr).sci_BitmapIndexedSetNode__f_size === 0)) {
        var this$1 = $m_sci_HashSet$();
        return this$1.sci_HashSet$__f_EmptySet;
      }
      while ($n(iter).hasNext__Z()) {
        var next$2 = $n(iter).next__O();
        var originalHash$2 = $m_sr_Statics$().anyHash__O__I(next$2);
        var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
        $n(curr).removeWithShallowMutations__O__I__I__sci_BitmapIndexedSetNode(next$2, originalHash$2, improved$2);
        if (($n(curr).sci_BitmapIndexedSetNode__f_size === 0)) {
          var this$2 = $m_sci_HashSet$();
          return this$2.sci_HashSet$__f_EmptySet;
        }
      }
      return new $c_sci_HashSet(curr);
    }
  }
  return $thiz;
}
/** @constructor */
function $c_sci_HashSet(rootNode) {
  this.sci_HashSet__f_rootNode = null;
  this.sci_HashSet__f_rootNode = rootNode;
}
$c_sci_HashSet.prototype = new $h_sci_AbstractSet();
$c_sci_HashSet.prototype.constructor = $c_sci_HashSet;
/** @constructor */
function $h_sci_HashSet() {
}
$h_sci_HashSet.prototype = $c_sci_HashSet.prototype;
$c_sci_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_HashSet.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_HashSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashSet(pred, false);
});
$c_sci_HashSet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashSet(pred, true);
});
$c_sci_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_HashSet$();
});
$c_sci_HashSet.prototype.knownSize__I = (function() {
  return $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size;
});
$c_sci_HashSet.prototype.size__I = (function() {
  return $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size;
});
$c_sci_HashSet.prototype.isEmpty__Z = (function() {
  return ($n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size === 0);
});
$c_sci_HashSet.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_SetIterator(this.sci_HashSet__f_rootNode));
});
$c_sci_HashSet.prototype.contains__O__Z = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  return $n(this.sci_HashSet__f_rootNode).contains__O__I__I__I__Z(element, elementUnimprovedHash, elementHash, 0);
});
$c_sci_HashSet.prototype.incl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = $n(this.sci_HashSet__f_rootNode).updated__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode);
});
$c_sci_HashSet.prototype.excl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = $n(this.sci_HashSet__f_rootNode).removed__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode);
});
$c_sci_HashSet.prototype.head__O = (function() {
  return $n(this.iterator__sc_Iterator()).next__O();
});
$c_sci_HashSet.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_HashSet__f_rootNode).foreach__F1__V(f);
});
$c_sci_HashSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  if (this.isEmpty__Z()) {
    return true;
  } else if ((!$n(that).isEmpty__Z())) {
    if ((that instanceof $c_sci_HashSet)) {
      var x2 = $as_sci_HashSet(that);
      return $n(this.sci_HashSet__f_rootNode).subsetOf__sci_SetNode__I__Z($n(x2).sci_HashSet__f_rootNode, 0);
    } else {
      return $f_sc_IterableOnceOps__forall__F1__Z(this, that);
    }
  } else {
    return false;
  }
});
$c_sci_HashSet.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if ((this === x2)) {
      return true;
    } else {
      var x = this.sci_HashSet__f_rootNode;
      var x$2 = $n(x2).sci_HashSet__f_rootNode;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    }
  } else {
    return $f_sc_Set__equals__O__Z(this, that);
  }
});
$c_sci_HashSet.prototype.className__T = (function() {
  return "HashSet";
});
$c_sci_HashSet.prototype.hashCode__I = (function() {
  var it = new $c_sci_SetHashIterator(this.sci_HashSet__f_rootNode);
  var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(it, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
  return hash;
});
$c_sci_HashSet.prototype.diff__sc_Set__sci_HashSet = (function(that) {
  if (this.isEmpty__Z()) {
    return this;
  } else if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if ($n(x2).isEmpty__Z()) {
      return this;
    } else {
      var newRootNode = $n(this.sci_HashSet__f_rootNode).diff__sci_SetNode__I__sci_BitmapIndexedSetNode($n(x2).sci_HashSet__f_rootNode, 0);
      if (($n(newRootNode).sci_BitmapIndexedSetNode__f_size === 0)) {
        var this$1 = $m_sci_HashSet$();
        return this$1.sci_HashSet$__f_EmptySet;
      } else {
        return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, $n(this.sci_HashSet__f_rootNode).diff__sci_SetNode__I__sci_BitmapIndexedSetNode($n(x2).sci_HashSet__f_rootNode, 0));
      }
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(that);
    var this$2 = $n(x3);
    var iter = new $c_scm_HashSet$$anon$2(this$2);
    var curr = this.sci_HashSet__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      var this$3 = $n(x3);
      var improvedHash = $n(next).scm_HashSet$Node__f__hash;
      var originalHash = this$3.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      curr = $n(curr).removed__O__I__I__I__sci_BitmapIndexedSetNode($n(next).scm_HashSet$Node__f__key, originalHash, improved, 0);
      if ((curr !== this.sci_HashSet__f_rootNode)) {
        if (($n(curr).sci_BitmapIndexedSetNode__f_size === 0)) {
          var this$4 = $m_sci_HashSet$();
          return this$4.sci_HashSet$__f_EmptySet;
        }
        while (iter.hasNext__Z()) {
          var next$2 = $as_scm_HashSet$Node(iter.next__O());
          var this$5 = $n(x3);
          var improvedHash$1 = $n(next$2).scm_HashSet$Node__f__hash;
          var originalHash$2 = this$5.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash$1);
          var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
          $n(curr).removeWithShallowMutations__O__I__I__sci_BitmapIndexedSetNode($n(next$2).scm_HashSet$Node__f__key, originalHash$2, improved$2);
          if (($n(curr).sci_BitmapIndexedSetNode__f_size === 0)) {
            var this$6 = $m_sci_HashSet$();
            return this$6.sci_HashSet$__f_EmptySet;
          }
        }
        return new $c_sci_HashSet(curr);
      }
    }
    return this;
  } else {
    var thatKnownSize = $n(that).knownSize__I();
    if ((thatKnownSize === 0)) {
      return this;
    } else if ((thatKnownSize <= $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size)) {
      return $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet(this, that);
    } else {
      var pred = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((elem$2$2) => $n(that).contains__O__Z(elem$2$2)));
      return this.filterImpl__F1__Z__sci_HashSet(pred, true);
    }
  }
});
$c_sci_HashSet.prototype.removedAll__sc_IterableOnce__sci_HashSet = (function(that) {
  if ($is_sc_Set(that)) {
    var x2 = $as_sc_Set(that);
    return this.diff__sc_Set__sci_HashSet(x2);
  }
  if (false) {
    var x3 = $as_sci_Range(that);
    if (($n(x3).length__I() > $n(this.sci_HashSet__f_rootNode).sci_BitmapIndexedSetNode__f_size)) {
      var pred = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x0$1$2$2) => {
        if ((!$isInt(x0$1$2$2))) {
          return true;
        } else {
          var x2$1 = $uI(x0$1$2$2);
          return (!$n(x3).contains__I__Z(x2$1));
        }
      }));
      return this.filterImpl__F1__Z__sci_HashSet(pred, false);
    }
  }
  return $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet(this, that);
});
$c_sci_HashSet.prototype.filterImpl__F1__Z__sci_HashSet = (function(pred, isFlipped) {
  var newRootNode = $n(this.sci_HashSet__f_rootNode).filterImpl__F1__Z__sci_BitmapIndexedSetNode(pred, isFlipped);
  if ((newRootNode === this.sci_HashSet__f_rootNode)) {
    return this;
  } else if (($n(newRootNode).sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet;
  } else {
    return new $c_sci_HashSet(newRootNode);
  }
});
$c_sci_HashSet.prototype.dropRight__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n));
});
$c_sci_HashSet.prototype.drop__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_IterableOps__drop__I__O(this, n));
});
$c_sci_HashSet.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return this.removedAll__sc_IterableOnce__sci_HashSet(that);
});
$c_sci_HashSet.prototype.tail__O = (function() {
  var elem = $n(this.iterator__sc_Iterator()).next__O();
  return this.excl__O__sci_HashSet(elem);
});
$c_sci_HashSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_HashSet(elem);
});
$c_sci_HashSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_HashSet(elem);
});
function $as_sci_HashSet(obj) {
  return (((obj instanceof $c_sci_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashSet"));
}
function $isArrayOf_sci_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashSet)));
}
function $asArrayOf_sci_HashSet(obj, depth) {
  return (($isArrayOf_sci_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashSet;", depth));
}
var $d_sci_HashSet = new $TypeData().initClass($c_sci_HashSet, "scala.collection.immutable.HashSet", ({
  sci_HashSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $as_sci_ListSet(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ListSet"));
}
function $isArrayOf_sci_ListSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListSet)));
}
function $asArrayOf_sci_ListSet(obj, depth) {
  return (($isArrayOf_sci_ListSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ListSet;", depth));
}
/** @constructor */
function $c_scm_AbstractSet() {
}
$c_scm_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_scm_AbstractSet.prototype.constructor = $c_scm_AbstractSet;
/** @constructor */
function $h_scm_AbstractSet() {
}
$h_scm_AbstractSet.prototype = $c_scm_AbstractSet.prototype;
$c_scm_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Set$();
});
$c_scm_AbstractSet.prototype.remove__O__Z = (function(elem) {
  return $f_scm_SetOps__remove__O__Z(this, elem);
});
$c_scm_AbstractSet.prototype.knownSize__I = (function() {
  return (-1);
});
$c_scm_AbstractSet.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_AbstractSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_AbstractSet.prototype.result__O = (function() {
  return this;
});
/** @constructor */
function $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME$2) {
  this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1 = null;
  this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1 = ME$2;
}
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype = new $h_O();
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.constructor = $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10;
/** @constructor */
function $h_Lcats_data_KleisliInstances0\uff3f5$$anon$10() {
}
$h_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype = $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype;
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $n(fa$1).map__F1__Lcats_Functor__Lcats_data_Kleisli(f, this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.unit__O = (function() {
  var this$1 = $m_Lcats_data_Kleisli$();
  var F = this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$1, (void 0), F);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this, a, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.raiseError__O__O = (function(e) {
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this, e);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var kb = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, kb, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.pure__O__O = (function(x) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var F = this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$1, x, F);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_data_KleisliApply__map2Eval__Lcats_data_Kleisli__Lcats_Eval__F2__Lcats_Eval(this, fa$1, fb, f);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.product__O__O__O = (function(fa, fb) {
  var fb$1 = $as_Lcats_data_Kleisli(fa);
  var fc = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_data_KleisliApply__product__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fb$1, fc);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $n(fa$1).map__F1__Lcats_Functor__Lcats_data_Kleisli(f, this.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$10.prototype.void__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_data_KleisliFunctor__void__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
var $d_Lcats_data_KleisliInstances0\uff3f5$$anon$10 = new $TypeData().initClass($c_Lcats_data_KleisliInstances0\uff3f5$$anon$10, "cats.data.KleisliInstances0_5$$anon$10", ({
  Lcats_data_KleisliInstances0\uff3f5$$anon$10: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_data_KleisliFunctor: 1,
  Lcats_data_KleisliApply: 1,
  Lcats_data_KleisliApplicative: 1,
  Lcats_data_KleisliApplicativeError: 1,
  Lcats_data_KleisliFlatMap: 1,
  Lcats_data_KleisliMonad: 1,
  Lcats_data_KleisliMonadError: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_GenConcurrent$$anon$3(F0$8) {
  this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3 = null;
  this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3 = F0$8;
}
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype = new $h_O();
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_GenConcurrent$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_GenConcurrent$$anon$3() {
}
$h_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype = $c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype;
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.F__Lcats_effect_kernel_GenSpawn = (function() {
  return this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.ref__O__O = (function(a) {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__ref__O__Lcats_data_Kleisli(this, a);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.deferred__O = (function() {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__deferred__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.racePair__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__unique__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__never__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.cede__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_GenConcurrent$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenConcurrent$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_GenConcurrent$$anon$3 = new $TypeData().initClass($c_Lcats_effect_kernel_GenConcurrent$$anon$3, "cats.effect.kernel.GenConcurrent$$anon$3", ({
  Lcats_effect_kernel_GenConcurrent$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_ResourceConcurrent() {
}
$c_Lcats_effect_kernel_ResourceConcurrent.prototype = new $h_Lcats_effect_kernel_ResourceMonadCancel();
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.constructor = $c_Lcats_effect_kernel_ResourceConcurrent;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceConcurrent() {
}
$h_Lcats_effect_kernel_ResourceConcurrent.prototype = $c_Lcats_effect_kernel_ResourceConcurrent.prototype;
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  return $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.racePair__O__O__O = (function(fa, fb) {
  return $f_Lcats_effect_kernel_GenConcurrent__racePair__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.unique__Lcats_effect_kernel_Resource = (function() {
  var F = this.F__Lcats_effect_kernel_GenConcurrent();
  var fa = $n(F).unique__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.never__Lcats_effect_kernel_Resource = (function() {
  var F = this.F__Lcats_effect_kernel_GenConcurrent();
  var fa = $n(F).never__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.unique__O = (function() {
  return this.unique__Lcats_effect_kernel_Resource();
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.never__O = (function() {
  return this.never__Lcats_effect_kernel_Resource();
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.cede__O = (function() {
  var F = this.F__Lcats_effect_kernel_GenConcurrent();
  var fa = $n(F).cede__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return $n(fa$1).start__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this.F__Lcats_effect_kernel_GenConcurrent());
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.deferred__O = (function() {
  return $m_Lcats_effect_kernel_Resource$().deferred__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this.F__Lcats_effect_kernel_GenConcurrent());
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.ref__O__O = (function(a) {
  return $m_Lcats_effect_kernel_Resource$().ref__O__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(a, this.F__Lcats_effect_kernel_GenConcurrent());
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var fb$1 = $as_Lcats_effect_kernel_Resource(fb);
  return $n(fa$1).both__Lcats_effect_kernel_Resource__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(fb$1, this.F__Lcats_effect_kernel_GenConcurrent());
});
function $p_sci_LazyList__initState__V($thiz) {
  if (($thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head === $m_sci_LazyList$Uninitialized$())) {
    if (($thiz.sci_LazyList__f__tail === $m_sci_LazyList$MidEvaluation$())) {
      throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "LazyList evaluation depends on its own result (self-reference); see docs for more info");
    }
    var fun = $as_F0($thiz.sci_LazyList__f__tail);
    $thiz.sci_LazyList__f__tail = $m_sci_LazyList$MidEvaluation$();
    try {
      var l = $n($as_sci_LazyList($n(fun).apply__O())).scala$collection$immutable$LazyList$$evaluated__sci_LazyList();
    } finally {
      $thiz.sci_LazyList__f__tail = fun;
    }
    $thiz.sci_LazyList__f__tail = $n(l).sci_LazyList__f__tail;
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head = $n(l).sci_LazyList__f_scala$collection$immutable$LazyList$$_head;
  }
}
function $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz, f) {
  $m_sci_LazyList$();
  var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if (($thiz.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    } else {
      $m_sci_LazyList$();
      var hd = $n(f).apply__O__O($thiz.head__O());
      var tl = $p_sci_LazyList__mapImpl__F1__sci_LazyList($n($thiz.tail__sci_LazyList()), f);
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
}
function $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList($thiz, scout) {
  var this$1 = $n(scout);
  if ((this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    $m_sci_LazyList$();
    var hd = $thiz.head__O();
    $m_sci_LazyList$();
    var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList($n($thiz.tail__sci_LazyList()), $n(scout).tail__sci_LazyList())));
    var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
  }
}
function $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz, n) {
  if ((n <= 0)) {
    return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      if (($thiz.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
        return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
      } else {
        $m_sci_LazyList$();
        var hd = $thiz.head__O();
        var tl = $p_sci_LazyList__takeImpl__I__sci_LazyList($n($thiz.tail__sci_LazyList()), ((n - 1) | 0));
        return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
      }
    }));
    return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
  }
}
function $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  var this$1 = $n(b);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if (($thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head === $m_sci_LazyList$Uninitialized$())) {
    var this$2 = $n(b);
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>");
  } else if (($thiz.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    var this$3 = $n(b);
    var obj = $thiz.head__O();
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var cursor = $thiz;
    var scout = $thiz.tail__sci_LazyList();
    if ((cursor !== scout)) {
      cursor = scout;
      var this$4 = $n(scout);
      if (((this$4.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this$4.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
        scout = $n(scout).tail__sci_LazyList();
        while (true) {
          if ((cursor !== scout)) {
            var this$5 = $n(scout);
            var $x_1 = ((this$5.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this$5.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            var c = cursor;
            var this$6 = $n(b);
            this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$1 = $n(c).head__O();
            this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
            cursor = $n(cursor).tail__sci_LazyList();
            scout = $n(scout).tail__sci_LazyList();
            var this$7 = $n(scout);
            if (((this$7.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this$7.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
              scout = $n(scout).tail__sci_LazyList();
            }
          } else {
            break;
          }
        }
      }
    }
    var this$8 = $n(scout);
    if ((!((this$8.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this$8.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)))) {
      while ((cursor !== scout)) {
        var c$1 = cursor;
        var this$9 = $n(b);
        this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var obj$2 = $n(c$1).head__O();
        this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
        cursor = $n(cursor).tail__sci_LazyList();
      }
      var this$10 = $n(cursor);
      if ((!(this$10.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()))) {
        var this$11 = $n(b);
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>");
      }
    } else {
      if ((cursor !== $thiz)) {
        var runner = $thiz;
        while ((runner !== scout)) {
          runner = $n(runner).tail__sci_LazyList();
          scout = $n(scout).tail__sci_LazyList();
        }
        while (true) {
          var ct = $n(cursor).tail__sci_LazyList();
          if ((ct !== scout)) {
            var c$2 = cursor;
            var this$12 = $n(b);
            this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$3 = $n(c$2).head__O();
            this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
          }
          cursor = ct;
          if ((cursor !== scout)) {
          } else {
            break;
          }
        }
      }
      var this$13 = $n(b);
      this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>");
    }
  }
  var this$14 = $n(b);
  this$14.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$14.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b;
}
function $ct_sci_LazyList__O__($thiz, lazyState) {
  $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head = ((lazyState === $m_sci_LazyList$EmptyMarker$()) ? null : $m_sci_LazyList$Uninitialized$());
  $thiz.sci_LazyList__f__tail = ((lazyState === $m_sci_LazyList$EmptyMarker$()) ? null : lazyState);
  return $thiz;
}
function $ct_sci_LazyList__O__sci_LazyList__($thiz, head, tail) {
  $ct_sci_LazyList__O__($thiz, $m_sci_LazyList$EmptyMarker$());
  $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head = head;
  $thiz.sci_LazyList__f__tail = tail;
  return $thiz;
}
/** @constructor */
function $c_sci_LazyList() {
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head = null;
  this.sci_LazyList__f__tail = null;
}
$c_sci_LazyList.prototype = new $h_sci_AbstractSeq();
$c_sci_LazyList.prototype.constructor = $c_sci_LazyList;
/** @constructor */
function $h_sci_LazyList() {
}
$h_sci_LazyList.prototype = $c_sci_LazyList.prototype;
$c_sci_LazyList.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_LazyList.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this);
});
$c_sci_LazyList.prototype.last__O = (function() {
  return $f_sc_LinearSeqOps__last__O(this);
});
$c_sci_LazyList.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$c_sci_LazyList.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_LazyList.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_LazyList.prototype.forall__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p);
});
$c_sci_LazyList.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p);
});
$c_sci_LazyList.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_LazyList.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_LazyList.prototype.scala$collection$immutable$LazyList$$evaluated__sci_LazyList = (function() {
  while (true) {
    if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$())) {
      return ((this.sci_LazyList__f__tail === null) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : this);
    } else {
      $p_sci_LazyList__initState__V(this);
    }
  }
});
$c_sci_LazyList.prototype.isEmpty__Z = (function() {
  return (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty);
});
$c_sci_LazyList.prototype.knownSize__I = (function() {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? 0 : (-1));
});
$c_sci_LazyList.prototype.head__O = (function() {
  if ((this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty lazy list");
  } else {
    return this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head;
  }
});
$c_sci_LazyList.prototype.tail__sci_LazyList = (function() {
  if ((this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty lazy list");
  } else {
    return $as_sci_LazyList(this.sci_LazyList__f__tail);
  }
});
$c_sci_LazyList.prototype.force__sci_LazyList = (function() {
  var these = this;
  var those = this;
  var this$1 = $n(these);
  if ((!(this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
    these = $n(these).tail__sci_LazyList();
  }
  while ((those !== these)) {
    var this$2 = $n(these);
    if ((this$2.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return this;
    }
    these = $n(these).tail__sci_LazyList();
    var this$3 = $n(these);
    if ((this$3.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return this;
    }
    these = $n(these).tail__sci_LazyList();
    if ((these === those)) {
      return this;
    }
    those = $n(those).tail__sci_LazyList();
  }
  return this;
});
$c_sci_LazyList.prototype.iterator__sc_Iterator = (function() {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_LazyList$LazyIterator(this));
});
$c_sci_LazyList.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    var this$1 = $n(_$this);
    if ((!(this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
      $n(f).apply__O__O($n(_$this).head__O());
      _$this = $n(_$this).tail__sci_LazyList();
      continue;
    }
    break;
  }
});
$c_sci_LazyList.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    var this$1 = $n(_$this);
    if ((this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return z;
    } else {
      var temp$_$this = $n(_$this).tail__sci_LazyList();
      var temp$z = $n(op).apply__O__O__O(z, $n(_$this).head__O());
      _$this = temp$_$this;
      z = temp$z;
    }
  }
});
$c_sci_LazyList.prototype.className__T = (function() {
  return "LazyList";
});
$c_sci_LazyList.prototype.lazyAppendedAll__F0__sci_LazyList = (function(suffix) {
  $m_sci_LazyList$();
  var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
    if ((this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      var x1 = $as_sc_IterableOnce($n(suffix).apply__O());
      if ((x1 instanceof $c_sci_LazyList)) {
        var x2 = $as_sci_LazyList(x1);
        return x2;
      } else {
        return (($n(x1).knownSize__I() === 0) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadFromIterator__sc_Iterator__sci_LazyList($n(x1).iterator__sc_Iterator()));
      }
    } else {
      $m_sci_LazyList$();
      var hd = this.head__O();
      var tl = $n(this.tail__sci_LazyList()).lazyAppendedAll__F0__sci_LazyList(suffix);
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__sci_LazyList = (function(suffix) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(suffix) : this.lazyAppendedAll__F0__sci_LazyList(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => suffix))));
});
$c_sci_LazyList.prototype.filter__F1__sci_LazyList = (function(pred) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(this, pred, false));
});
$c_sci_LazyList.prototype.map__F1__sci_LazyList = (function(f) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $p_sci_LazyList__mapImpl__F1__sci_LazyList(this, f));
});
$c_sci_LazyList.prototype.collect__s_PartialFunction__sci_LazyList = (function(pf) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$collectImpl__sci_LazyList__s_PartialFunction__sci_LazyList(this, pf));
});
$c_sci_LazyList.prototype.flatMap__F1__sci_LazyList = (function(f) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList(this, f));
});
$c_sci_LazyList.prototype.drop__I__sci_LazyList = (function(n) {
  return ((n <= 0) ? this : (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList(this, n)));
});
$c_sci_LazyList.prototype.dropRight__I__sci_LazyList = (function(n) {
  if ((n <= 0)) {
    return this;
  } else if (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
    return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => {
      var scout = this;
      var remaining = n;
      while (true) {
        if ((remaining > 0)) {
          var this$2 = $n(scout);
          var $x_1 = (!(this$2.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          remaining = ((remaining - 1) | 0);
          scout = $n(scout).tail__sci_LazyList();
        } else {
          break;
        }
      }
      return $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList(this, scout);
    }));
    return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
  }
});
$c_sci_LazyList.prototype.take__I__sci_LazyList = (function(n) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $p_sci_LazyList__takeImpl__I__sci_LazyList(this, n));
});
$c_sci_LazyList.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_LazyList();
  $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $n(sb).scm_StringBuilder__f_underlying, start, sep, end);
  return sb;
});
$c_sci_LazyList.prototype.toString__T = (function() {
  return $n($p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "LazyList"), "(", ", ", ")")).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sci_LazyList.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_LazyList.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_LazyList.prototype.take__I__O = (function(n) {
  return this.take__I__sci_LazyList(n);
});
$c_sci_LazyList.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_LazyList(n);
});
$c_sci_LazyList.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_LazyList(n);
});
$c_sci_LazyList.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_LazyList(f);
});
$c_sci_LazyList.prototype.collect__s_PartialFunction__O = (function(pf) {
  return this.collect__s_PartialFunction__sci_LazyList(pf);
});
$c_sci_LazyList.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_LazyList(f);
});
$c_sci_LazyList.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_LazyList(pred);
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_LazyList(suffix);
});
$c_sci_LazyList.prototype.tail__O = (function() {
  return this.tail__sci_LazyList();
});
$c_sci_LazyList.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_LazyList$();
});
function $as_sci_LazyList(obj) {
  return (((obj instanceof $c_sci_LazyList) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList"));
}
function $isArrayOf_sci_LazyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList)));
}
function $asArrayOf_sci_LazyList(obj, depth) {
  return (($isArrayOf_sci_LazyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList;", depth));
}
var $d_sci_LazyList = new $TypeData().initClass($c_sci_LazyList, "scala.collection.immutable.LazyList", ({
  sci_LazyList: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
}));
function $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  var this$1 = $n(b);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.isEmpty__Z())) {
    var this$2 = $n(b);
    var obj = $thiz.head__O();
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    if ($thiz.tailDefined__Z()) {
      var scout = $as_sci_Stream($thiz.tail__O());
      if (($as_sci_Stream(elem) !== scout)) {
        elem = scout;
        if ($n(scout).tailDefined__Z()) {
          scout = $as_sci_Stream($n(scout).tail__O());
          while ((($as_sci_Stream(elem) !== scout) && $n(scout).tailDefined__Z())) {
            var this$4 = $n(b);
            this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$1 = $n($as_sci_Stream(elem)).head__O();
            this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
            elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O());
            scout = $as_sci_Stream($n(scout).tail__O());
            if ($n(scout).tailDefined__Z()) {
              scout = $as_sci_Stream($n(scout).tail__O());
            }
          }
        }
      }
      if ((!$n(scout).tailDefined__Z())) {
        while (($as_sci_Stream(elem) !== scout)) {
          var this$5 = $n(b);
          this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$2 = $n($as_sci_Stream(elem)).head__O();
          this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
          elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O());
        }
        var this$6 = $n($as_sci_Stream(elem));
        if ((!this$6.isEmpty__Z())) {
          var this$7 = $n(b);
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$3 = $n($as_sci_Stream(elem)).head__O();
          this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$7.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
        }
      } else {
        var runner = $thiz;
        var k = 0;
        while ((runner !== scout)) {
          runner = $as_sci_Stream($n(runner).tail__O());
          scout = $as_sci_Stream($n(scout).tail__O());
          k = ((1 + k) | 0);
        }
        if ((($as_sci_Stream(elem) === scout) && (k > 0))) {
          var this$8 = $n(b);
          this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$4 = $n($as_sci_Stream(elem)).head__O();
          this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O());
        }
        while (($as_sci_Stream(elem) !== scout)) {
          var this$9 = $n(b);
          this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$5 = $n($as_sci_Stream(elem)).head__O();
          this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$5);
          elem = $as_sci_Stream($n($as_sci_Stream(elem)).tail__O());
        }
      }
    }
    var this$10 = $n($as_sci_Stream(elem));
    if ((!this$10.isEmpty__Z())) {
      if ((!$n($as_sci_Stream(elem)).tailDefined__Z())) {
        var this$11 = $n(b);
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$11.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>");
      } else {
        var this$12 = $n(b);
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>");
      }
    }
  }
  var this$13 = $n(b);
  this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$13.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b;
}
/** @constructor */
function $c_sci_Stream() {
}
$c_sci_Stream.prototype = new $h_sci_AbstractSeq();
$c_sci_Stream.prototype.constructor = $c_sci_Stream;
/** @constructor */
function $h_sci_Stream() {
}
$h_sci_Stream.prototype = $c_sci_Stream.prototype;
$c_sci_Stream.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_Stream.prototype.iterator__sc_Iterator = (function() {
  return $f_sc_LinearSeqOps__iterator__sc_Iterator(this);
});
$c_sci_Stream.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this);
});
$c_sci_Stream.prototype.last__O = (function() {
  return $f_sc_LinearSeqOps__last__O(this);
});
$c_sci_Stream.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$c_sci_Stream.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_Stream.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_Stream.prototype.forall__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p);
});
$c_sci_Stream.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p);
});
$c_sci_Stream.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_Stream.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_Stream.prototype.className__T = (function() {
  return "Stream";
});
$c_sci_Stream.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    if ((!$n(_$this).isEmpty__Z())) {
      $n(f).apply__O__O($n(_$this).head__O());
      _$this = $as_sci_Stream($n(_$this).tail__O());
      continue;
    }
    break;
  }
});
$c_sci_Stream.prototype.take__I__sci_Stream = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? $m_sci_Stream$Empty$() : ((n === 1) ? new $c_sci_Stream$Cons(this.head__O(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $m_sci_Stream$Empty$()))) : new $c_sci_Stream$Cons(this.head__O(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n($as_sci_Stream(this.tail__O())).take__I__sci_Stream(((n - 1) | 0)))))));
});
$c_sci_Stream.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return z;
    } else {
      var temp$_$this = $as_sci_Stream($n(_$this).tail__O());
      var temp$z = $n(op).apply__O__O__O(z, $n(_$this).head__O());
      _$this = temp$_$this;
      z = temp$z;
    }
  }
});
$c_sci_Stream.prototype.lazyAppendedAll__F0__sci_Stream = (function(suffix) {
  if (this.isEmpty__Z()) {
    var this$1 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce($n(suffix).apply__O());
    return this$1.from__sc_IterableOnce__sci_Stream(source);
  } else {
    var hd = this.head__O();
    var tl = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n($as_sci_Stream(this.tail__O())).lazyAppendedAll__F0__sci_Stream(suffix)));
    return new $c_sci_Stream$Cons(hd, tl);
  }
});
$c_sci_Stream.prototype.filterImpl__F1__Z__sci_Stream = (function(p, isFlipped) {
  var rest = this;
  while (true) {
    var this$1 = $n(rest);
    if (((!this$1.isEmpty__Z()) && ($uZ($n(p).apply__O__O($n(rest).head__O())) === isFlipped))) {
      rest = $as_sci_Stream($n(rest).tail__O());
    } else {
      break;
    }
  }
  var this$2 = $n(rest);
  if ((!this$2.isEmpty__Z())) {
    return $m_sci_Stream$().filteredTail__sci_Stream__F1__Z__sci_Stream(rest, p, isFlipped);
  } else {
    return $m_sci_Stream$Empty$();
  }
});
$c_sci_Stream.prototype.map__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$();
  } else {
    var hd = $n(f).apply__O__O(this.head__O());
    var tl = new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n($as_sci_Stream(this.tail__O())).map__F1__sci_Stream(f)));
    return new $c_sci_Stream$Cons(hd, tl);
  }
});
$c_sci_Stream.prototype.collect__s_PartialFunction__sci_Stream = (function(pf) {
  var _$this = this;
  while (true) {
    if ($n(_$this).isEmpty__Z()) {
      return $m_sci_Stream$Empty$();
    } else {
      var newHead = new $c_sr_ObjectRef(null);
      var runWith = $n(pf).runWith__F1__F1(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((newHead) => ((b$2$2) => {
        newHead.sr_ObjectRef__f_elem = b$2$2;
      }))(newHead)));
      if ($uZ($n(runWith).apply__O__O($n(_$this).head__O()))) {
        return $m_sci_Stream$().collectedTail__O__sci_Stream__s_PartialFunction__sci_Stream(newHead.sr_ObjectRef__f_elem, _$this, pf);
      } else {
        _$this = $as_sci_Stream($n(_$this).tail__O());
      }
    }
  }
});
$c_sci_Stream.prototype.flatMap__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$();
  } else {
    var nonEmptyPrefix = new $c_sr_ObjectRef(this);
    var this$3 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce($n(f).apply__O__O($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).head__O()));
    var prefix = this$3.from__sc_IterableOnce__sci_Stream(source);
    while (((!$n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).isEmpty__Z()) && $n(prefix).isEmpty__Z())) {
      nonEmptyPrefix.sr_ObjectRef__f_elem = $as_sci_Stream($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).tail__O());
      if ((!$n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).isEmpty__Z())) {
        var this$4 = $m_sci_Stream$();
        var source$1 = $as_sc_IterableOnce($n(f).apply__O__O($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).head__O()));
        prefix = this$4.from__sc_IterableOnce__sci_Stream(source$1);
      }
    }
    return ($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).isEmpty__Z() ? $m_sci_Stream$Empty$() : $n(prefix).lazyAppendedAll__F0__sci_Stream(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n($as_sci_Stream($n($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem)).tail__O())).flatMap__F1__sci_Stream(f)))));
  }
});
$c_sci_Stream.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_Stream();
  $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $n(sb).scm_StringBuilder__f_underlying, start, sep, end);
  return sb;
});
$c_sci_Stream.prototype.toString__T = (function() {
  return $n($p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "Stream"), "(", ", ", ")")).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sci_Stream.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_Stream.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_Stream.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_Stream(f);
});
$c_sci_Stream.prototype.collect__s_PartialFunction__O = (function(pf) {
  return this.collect__s_PartialFunction__sci_Stream(pf);
});
$c_sci_Stream.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Stream(f);
});
$c_sci_Stream.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Stream(pred, false);
});
$c_sci_Stream.prototype.take__I__O = (function(n) {
  return this.take__I__sci_Stream(n);
});
$c_sci_Stream.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Stream$();
});
function $as_sci_Stream(obj) {
  return (((obj instanceof $c_sci_Stream) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Stream"));
}
function $isArrayOf_sci_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Stream)));
}
function $asArrayOf_sci_Stream(obj, depth) {
  return (($isArrayOf_sci_Stream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Stream;", depth));
}
function $as_sci_WrappedString(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.WrappedString"));
}
function $isArrayOf_sci_WrappedString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_WrappedString)));
}
function $asArrayOf_sci_WrappedString(obj, depth) {
  return (($isArrayOf_sci_WrappedString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.WrappedString;", depth));
}
function $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, array) {
  $thiz.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = array;
  return $thiz;
}
function $ct_sjsr_WrappedVarArgs__($thiz) {
  $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, []);
  return $thiz;
}
/** @constructor */
function $c_sjsr_WrappedVarArgs() {
  this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = null;
}
$c_sjsr_WrappedVarArgs.prototype = new $h_O();
$c_sjsr_WrappedVarArgs.prototype.constructor = $c_sjsr_WrappedVarArgs;
/** @constructor */
function $h_sjsr_WrappedVarArgs() {
}
$h_sjsr_WrappedVarArgs.prototype = $c_sjsr_WrappedVarArgs.prototype;
$c_sjsr_WrappedVarArgs.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sjsr_WrappedVarArgs.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sjsr_WrappedVarArgs.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sjsr_WrappedVarArgs.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sjsr_WrappedVarArgs.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sjsr_WrappedVarArgs.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sjsr_WrappedVarArgs.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sjsr_WrappedVarArgs.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength;
});
$c_sjsr_WrappedVarArgs.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_sjsr_WrappedVarArgs.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sjsr_WrappedVarArgs.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sjsr_WrappedVarArgs.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sjsr_WrappedVarArgs.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_sjsr_WrappedVarArgs.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_sjsr_WrappedVarArgs.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sjsr_WrappedVarArgs.prototype.size__I = (function() {
  return this.length__I();
});
$c_sjsr_WrappedVarArgs.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  var this$2 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
  return $f_sc_Iterator__indexWhere__F1__I__I(this$2, p, from);
});
$c_sjsr_WrappedVarArgs.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1));
});
$c_sjsr_WrappedVarArgs.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sjsr_WrappedVarArgs.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sjsr_WrappedVarArgs.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sjsr_WrappedVarArgs.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sjsr_WrappedVarArgs.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $uZ(this.apply__I__O(v1));
});
$c_sjsr_WrappedVarArgs.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sjsr_WrappedVarArgs.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sjsr_WrappedVarArgs$().newBuilder__scm_Builder();
});
$c_sjsr_WrappedVarArgs.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sjsr_WrappedVarArgs.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sjsr_WrappedVarArgs.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sjsr_WrappedVarArgs.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sjsr_WrappedVarArgs.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sjsr_WrappedVarArgs.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sjsr_WrappedVarArgs.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
$c_sjsr_WrappedVarArgs.prototype.length__I = (function() {
  return $uI(this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array.length);
});
$c_sjsr_WrappedVarArgs.prototype.apply__I__O = (function(idx) {
  return this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array[idx];
});
$c_sjsr_WrappedVarArgs.prototype.className__T = (function() {
  return "WrappedVarArgs";
});
$c_sjsr_WrappedVarArgs.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sjsr_WrappedVarArgs$();
  return this$1.from__sc_IterableOnce__sjsr_WrappedVarArgs(coll);
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sjsr_WrappedVarArgs.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sjsr_WrappedVarArgs.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
function $as_sjsr_WrappedVarArgs(obj) {
  return (((obj instanceof $c_sjsr_WrappedVarArgs) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.runtime.WrappedVarArgs"));
}
function $isArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjsr_WrappedVarArgs)));
}
function $asArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (($isArrayOf_sjsr_WrappedVarArgs(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.runtime.WrappedVarArgs;", depth));
}
var $d_sjsr_WrappedVarArgs = new $TypeData().initClass($c_sjsr_WrappedVarArgs, "scala.scalajs.runtime.WrappedVarArgs", ({
  sjsr_WrappedVarArgs: 1,
  sci_IndexedSeq: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_SyncIO$SyncIOSync() {
  this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll = null;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
  this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll = new $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9();
}
$c_Lcats_effect_SyncIO$SyncIOSync.prototype = new $h_O();
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.constructor = $c_Lcats_effect_SyncIO$SyncIOSync;
/** @constructor */
function $h_Lcats_effect_SyncIO$SyncIOSync() {
}
$h_Lcats_effect_SyncIO$SyncIOSync.prototype = $c_Lcats_effect_SyncIO$SyncIOSync.prototype;
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Sync__unique__O(this);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$Sync$$Delay;
  return new $c_Lcats_effect_SyncIO$Suspend(hint, thunk);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.canceled__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__unit;
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.onCancel__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O(this, fa, fin);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.uncancelable__F1__O = (function(body) {
  return $n(body).apply__O__O(this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.pure__O__O = (function(x) {
  $m_Lcats_effect_SyncIO$();
  return new $c_Lcats_effect_SyncIO$Pure(x);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  $m_Lcats_effect_SyncIO$();
  return new $c_Lcats_effect_SyncIO$Error(e$1);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_SyncIO$HandleErrorWith(this$1, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_SyncIO$FlatMap(this$1, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.realTime__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f_realTime;
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return new $c_Lcats_effect_SyncIO$Suspend(hint, thunk);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.attempt__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_SyncIO$Attempt(this$1);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.unit__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__unit;
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  var fb$1 = $as_Lcats_effect_SyncIO(fb);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_SyncIO$Attempt(this$1).productR__Lcats_effect_SyncIO__Lcats_effect_SyncIO(fb$1);
});
var $d_Lcats_effect_SyncIO$SyncIOSync = new $TypeData().initClass($c_Lcats_effect_SyncIO$SyncIOSync, "cats.effect.SyncIO$SyncIOSync", ({
  Lcats_effect_SyncIO$SyncIOSync: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_effect_kernel_MonadCancel$Uncancelable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13(F0$13) {
  this.Lcats_effect_kernel_ResourceHOInstances2$$anon$13__f_F0$5 = null;
  this.Lcats_effect_kernel_ResourceHOInstances2$$anon$13__f_F0$5 = F0$13;
}
$c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype = new $h_Lcats_effect_kernel_ResourceConcurrent();
$c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype.constructor = $c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceHOInstances2$$anon$13() {
}
$h_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype = $c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype;
$c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances2$$anon$13__f_F0$5;
});
$c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances2$$anon$13__f_F0$5;
});
var $d_Lcats_effect_kernel_ResourceHOInstances2$$anon$13 = new $TypeData().initClass($c_Lcats_effect_kernel_ResourceHOInstances2$$anon$13, "cats.effect.kernel.ResourceHOInstances2$$anon$13", ({
  Lcats_effect_kernel_ResourceHOInstances2$$anon$13: 1,
  Lcats_effect_kernel_ResourceConcurrent: 1,
  Lcats_effect_kernel_ResourceMonadCancel: 1,
  Lcats_effect_kernel_ResourceMonad: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_ApplicativeError: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1
}));
function $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli($thiz, hint, thunk) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.F__Lcats_effect_kernel_Sync()).suspend__Lcats_effect_kernel_Sync$Type__F0__O(hint, thunk);
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
/** @constructor */
function $c_Lcats_instances_QueueInstances$$anon$1() {
}
$c_Lcats_instances_QueueInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_QueueInstances$$anon$1.prototype.constructor = $c_Lcats_instances_QueueInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_QueueInstances$$anon$1() {
}
$h_Lcats_instances_QueueInstances$$anon$1.prototype = $c_Lcats_instances_QueueInstances$$anon$1.prototype;
$c_Lcats_instances_QueueInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Queue(fa);
  var this$1 = $n(fa$1);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__map__F1__O(this$1, f));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_Queue__F1__Lcats_Applicative__O($as_sci_Queue(sa), f, evidence$1);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Queue((void 0));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.fromIterableOnce__sc_IterableOnce__sci_Queue = (function(as) {
  var builder = $m_sci_Queue$().newBuilder__scm_Builder();
  var this$1 = $n(builder);
  this$1.addAll__sc_IterableOnce__scm_Growable(as);
  return $as_sci_Queue($n(builder).result__O());
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.pure__O__sci_Queue = (function(x) {
  var xs = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  var $x_1 = $m_sci_Nil$();
  var this$2 = $n(xs);
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $x_1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__sci_Queue__sci_Queue__F2__sci_Queue = (function(fa, fb, f) {
  if ($n(fb).isEmpty__Z()) {
    return $m_sci_Queue$EmptyQueue$();
  } else {
    var this$2 = $n(fa);
    var b = $m_sci_Queue$().newBuilder__scm_Builder();
    var it = this$2.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var this$5 = $n(b);
      var x0 = $n(it).next__O();
      var this$3 = $n(fb);
      var b$1 = $m_sci_Queue$().newBuilder__scm_Builder();
      var it$1 = this$3.iterator__sc_Iterator();
      while ($n(it$1).hasNext__Z()) {
        var this$4 = $n(b$1);
        var x0$1 = $n(it$1).next__O();
        var elem = $n(f).apply__O__O__O(x0, x0$1);
        this$4.addOne__O__scm_Growable(elem);
      }
      var elems = $as_sc_IterableOnce($n(b$1).result__O());
      this$5.addAll__sc_IterableOnce__scm_Growable(elems);
    }
    return $as_sci_Queue($n(b).result__O());
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2Eval__sci_Queue__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if ($n(fa).isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_sci_Queue$EmptyQueue$();
    return new $c_Lcats_Now(a);
  } else {
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fb$2) => {
      var fb$1 = $as_sci_Queue(fb$2);
      return this.map2__sci_Queue__sci_Queue__F2__sci_Queue(fa, fb$1, f);
    })));
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.tailRecM__O__F1__sci_Queue = (function(a, f) {
  var bldr = $m_sci_Queue$().newBuilder__scm_Builder();
  var elem$2 = $as_sci_Queue($n(f).apply__O__O(a));
  var this$1 = $m_sci_Nil$();
  return $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__sci_Queue(bldr, f, new $c_sci_$colon$colon(elem$2, this$1));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lcats_instances_QueueInstances__loop$2__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb, f, fa)));
  return new $c_Lcats_Eval$$anon$5(a);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldMap__sci_Queue__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $x_1.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverse__sci_Queue__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($n(fa).isEmpty__Z()) {
    return $n(G).pure__O__O($m_sci_Queue$EmptyQueue$());
  } else if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $n(G).map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((c) => {
      var c$1 = $as_Lcats_data_Chain(c);
      return this.fromIterableOnce__sc_IterableOnce__sci_Queue($n(c$1).iterator__sc_Iterator());
    })));
  } else {
    var $x_2 = $n(G);
    var $x_1 = $m_Lcats_data_Chain$();
    var this$3 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$3.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    var this$4 = $n(as);
    this$4.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return $x_2.map__O__F1__O($x_1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((chain) => {
      var chain$1 = $as_Lcats_data_Chain(chain);
      var this$7 = $n(chain$1);
      var z = $m_sci_Queue$EmptyQueue$();
      var result = z;
      var iter = this$7.iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        var x0 = result;
        var x1 = $n(iter).next__O();
        var _$2 = $as_sci_Queue(x0);
        var this$8 = $n(_$2);
        result = this$8.enqueue__O__sci_Queue(x1);
      }
      return $as_sci_Queue(result);
    })));
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverseVoid__sci_Queue__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x);
  } else {
    $m_Lcats_Eval$();
    var a = $n(G).unit__O();
    return $n(this.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Now(a), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a$1, acc) => {
      var acc$1 = $as_Lcats_Eval(acc);
      return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), acc$1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$5, _$6) => {
        $as_jl_Void(_$6);
      })));
    })))).value__O();
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldM__sci_Queue__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $n(G).tailRecM__O__F1__O(new $c_T2(fa, z), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_QueueInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$2);
  })));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$();
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Queue(x);
  var y$1 = $as_sci_Queue(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Queue(y$1);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Queue(x);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Queue(fa);
  var this$1 = $n(fa$1);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__map__F1__O(this$1, f));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Queue(fa);
  var this$1 = $n(fa$1);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this$1, f));
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Queue__sci_Queue__F2__sci_Queue($as_sci_Queue(fa), $as_sci_Queue(fb), f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Queue__Lcats_Eval__F2__Lcats_Eval($as_sci_Queue(fa), fb, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Queue(a, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval($as_sci_Queue(fa), lb, f);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Queue__F1__Lcats_kernel_Monoid__O($as_sci_Queue(fa), f, B);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Queue__F1__Lcats_Applicative__O($as_sci_Queue(fa), f, evidence$1);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__sci_Queue__F1__Lcats_Applicative__O($as_sci_Queue(fa), f, G);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Queue__O__F2__Lcats_Monad__O($as_sci_Queue(fa), z, f, G);
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return $m_Lcats_kernel_instances_QueueMonoid$().Lcats_kernel_instances_QueueMonoid$__f_singleton;
});
var $d_Lcats_instances_QueueInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_QueueInstances$$anon$1, "cats.instances.QueueInstances$$anon$1", ({
  Lcats_instances_QueueInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1
}));
/** @constructor */
function $c_sci_HashMap(rootNode) {
  this.sci_HashMap__f_rootNode = null;
  this.sci_HashMap__f_rootNode = rootNode;
}
$c_sci_HashMap.prototype = new $h_sci_AbstractMap();
$c_sci_HashMap.prototype.constructor = $c_sci_HashMap;
/** @constructor */
function $h_sci_HashMap() {
}
$h_sci_HashMap.prototype = $c_sci_HashMap.prototype;
$c_sci_HashMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$c_sci_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_HashMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_HashMap.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashMap(pred, false);
});
$c_sci_HashMap.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashMap(pred, true);
});
$c_sci_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_HashMap$();
});
$c_sci_HashMap.prototype.knownSize__I = (function() {
  return $n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size;
});
$c_sci_HashMap.prototype.size__I = (function() {
  return $n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size;
});
$c_sci_HashMap.prototype.isEmpty__Z = (function() {
  return ($n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size === 0);
});
$c_sci_HashMap.prototype.keySet__sci_Set = (function() {
  return (($n(this.sci_HashMap__f_rootNode).sci_BitmapIndexedMapNode__f_size === 0) ? $m_sci_Set$EmptySet$() : new $c_sci_HashMap$HashKeySet(this));
});
$c_sci_HashMap.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyValueTupleIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.keysIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapValueIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.contains__O__Z = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).containsKey__O__I__I__I__Z(key, keyUnimprovedHash, keyHash, 0);
});
$c_sci_HashMap.prototype.apply__O__O = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).apply__O__I__I__I__O(key, keyUnimprovedHash, keyHash, 0);
});
$c_sci_HashMap.prototype.get__O__s_Option = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).get__O__I__I__I__s_Option(key, keyUnimprovedHash, keyHash, 0);
});
$c_sci_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return $n(this.sci_HashMap__f_rootNode).getOrElse__O__I__I__I__F0__O(key, keyUnimprovedHash, keyHash, 0, default$1);
});
$c_sci_HashMap.prototype.updated__O__O__sci_HashMap = (function(key, value) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = $n(this.sci_HashMap__f_rootNode).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0, true);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode));
});
$c_sci_HashMap.prototype.removed__O__sci_HashMap = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = $n(this.sci_HashMap__f_rootNode).removed__O__I__I__I__sci_BitmapIndexedMapNode(key, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode));
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sci_HashMap = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if (this.isEmpty__Z()) {
      return x2;
    } else {
      var newNode = $n(this.sci_HashMap__f_rootNode).concat__sci_MapNode__I__sci_BitmapIndexedMapNode($n(x2).sci_HashMap__f_rootNode, 0);
      return ((newNode === $n(x2).sci_HashMap__f_rootNode) ? x2 : ((newNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newNode)));
    }
  } else if ((that instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(that);
    var iter = $n(x3).nodeIterator__sc_Iterator();
    var current = this.sci_HashMap__f_rootNode;
    while ($n(iter).hasNext__Z()) {
      var next = $as_scm_HashMap$Node($n(iter).next__O());
      $n(x3);
      var improvedHash = $n(next).scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = $n(current).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode($n(next).scm_HashMap$Node__f__key, $n(next).scm_HashMap$Node__f__value, originalHash, improved, 0, true);
      if ((current !== this.sci_HashMap__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while ($n(iter).hasNext__Z()) {
          var next$2 = $as_scm_HashMap$Node($n(iter).next__O());
          $n(x3);
          var improvedHash$1 = $n(next$2).scm_HashMap$Node__f__hash;
          var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
          shallowlyMutableNodeMap = $n(current).updateWithShallowMutations__O__O__I__I__I__I__I($n(next$2).scm_HashMap$Node__f__key, $n(next$2).scm_HashMap$Node__f__value, originalHash$2, $m_sc_Hashing$().improve__I__I(originalHash$2), 0, shallowlyMutableNodeMap);
        }
        return new $c_sci_HashMap(current);
      }
    }
    return this;
  } else if (false) {
    var x4 = $as_scm_LinkedHashMap(that);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    var current$2 = this.sci_HashMap__f_rootNode;
    while ($n(iter$2).hasNext__Z()) {
      var next$3 = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
      var originalHash$3 = $n(x4).unimproveHash__I__I($n(next$3).hash__I());
      var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      current$2 = $n(current$2).updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode($n(next$3).key__O(), $n(next$3).value__O(), originalHash$3, improved$2, 0, true);
      if ((current$2 !== this.sci_HashMap__f_rootNode)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$2, 0));
        while ($n(iter$2).hasNext__Z()) {
          var next$4 = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
          var originalHash$4 = $n(x4).unimproveHash__I__I($n(next$4).hash__I());
          shallowlyMutableNodeMap$2 = $n(current$2).updateWithShallowMutations__O__O__I__I__I__I__I($n(next$4).key__O(), $n(next$4).value__O(), originalHash$4, $m_sc_Hashing$().improve__I__I(originalHash$4), 0, shallowlyMutableNodeMap$2);
        }
        return new $c_sci_HashMap(current$2);
      }
    }
    return this;
  } else if ($is_sci_Map(that)) {
    var x2$2 = $as_sci_Map(that);
    if ($n(x2$2).isEmpty__Z()) {
      return this;
    } else {
      var accum = new $c_sci_HashMap$accum$1(this);
      $n(x2$2).foreachEntry__F2__V(accum);
      var newRootNode = accum.sci_HashMap$accum$1__f_current;
      return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode));
    }
  } else {
    var it = $n(that).iterator__sc_Iterator();
    var this$3 = $n(it);
    if ((!this$3.hasNext__Z())) {
      return this;
    } else {
      var accum$2 = new $c_sci_HashMap$accum$1(this);
      $f_sc_IterableOnceOps__foreach__F1__V($n(it), accum$2);
      var newRootNode$1 = accum$2.sci_HashMap$accum$1__f_current;
      return ((newRootNode$1 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$1));
    }
  }
});
$c_sci_HashMap.prototype.tail__sci_HashMap = (function() {
  var key = $n($as_T2($n(this.iterator__sc_Iterator()).next__O()))._1__O();
  return this.removed__O__sci_HashMap(key);
});
$c_sci_HashMap.prototype.foreach__F1__V = (function(f) {
  $n(this.sci_HashMap__f_rootNode).foreach__F1__V(f);
});
$c_sci_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  $n(this.sci_HashMap__f_rootNode).foreachEntry__F2__V(f);
});
$c_sci_HashMap.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if ((this === x2)) {
      return true;
    } else {
      var x = this.sci_HashMap__f_rootNode;
      var x$2 = $n(x2).sci_HashMap__f_rootNode;
      return ((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2));
    }
  } else {
    return $f_sc_Map__equals__O__Z(this, that);
  }
});
$c_sci_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var hashIterator = new $c_sci_MapKeyValueTupleHashIterator(this.sci_HashMap__f_rootNode);
    var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
    return hash;
  }
});
$c_sci_HashMap.prototype.className__T = (function() {
  return "HashMap";
});
$c_sci_HashMap.prototype.filterImpl__F1__Z__sci_HashMap = (function(pred, isFlipped) {
  var newRootNode = $n(this.sci_HashMap__f_rootNode).filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped);
  if ((newRootNode === this.sci_HashMap__f_rootNode)) {
    return this;
  } else if (($n(newRootNode).sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap;
  } else {
    return new $c_sci_HashMap(newRootNode);
  }
});
$c_sci_HashMap.prototype.drop__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_IterableOps__drop__I__O(this, n));
});
$c_sci_HashMap.prototype.dropRight__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n));
});
$c_sci_HashMap.prototype.head__O = (function() {
  return $as_T2($n(this.iterator__sc_Iterator()).next__O());
});
$c_sci_HashMap.prototype.tail__O = (function() {
  return this.tail__sci_HashMap();
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_HashMap(suffix);
});
$c_sci_HashMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_HashMap(key);
});
$c_sci_HashMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_HashMap(key, value);
});
function $as_sci_HashMap(obj) {
  return (((obj instanceof $c_sci_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashMap"));
}
function $isArrayOf_sci_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap)));
}
function $asArrayOf_sci_HashMap(obj, depth) {
  return (($isArrayOf_sci_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashMap;", depth));
}
var $d_sci_HashMap = new $TypeData().initClass($c_sci_HashMap, "scala.collection.immutable.HashMap", ({
  sci_HashMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Stream$Cons(head, tl) {
  this.sci_Stream$Cons__f_head = null;
  this.sci_Stream$Cons__f_tlVal = null;
  this.sci_Stream$Cons__f_tlGen = null;
  this.sci_Stream$Cons__f_head = head;
  this.sci_Stream$Cons__f_tlGen = tl;
}
$c_sci_Stream$Cons.prototype = new $h_sci_Stream();
$c_sci_Stream$Cons.prototype.constructor = $c_sci_Stream$Cons;
/** @constructor */
function $h_sci_Stream$Cons() {
}
$h_sci_Stream$Cons.prototype = $c_sci_Stream$Cons.prototype;
$c_sci_Stream$Cons.prototype.head__O = (function() {
  return this.sci_Stream$Cons__f_head;
});
$c_sci_Stream$Cons.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Stream$Cons.prototype.tailDefined__Z = (function() {
  return (this.sci_Stream$Cons__f_tlGen === null);
});
$c_sci_Stream$Cons.prototype.tail__sci_Stream = (function() {
  if ((!this.tailDefined__Z())) {
    if ((!this.tailDefined__Z())) {
      this.sci_Stream$Cons__f_tlVal = $as_sci_Stream($n(this.sci_Stream$Cons__f_tlGen).apply__O());
      this.sci_Stream$Cons__f_tlGen = null;
    }
  }
  return this.sci_Stream$Cons__f_tlVal;
});
$c_sci_Stream$Cons.prototype.force__sci_Stream$Cons = (function() {
  var these = this;
  var those = this;
  if ((!$n(these).isEmpty__Z())) {
    these = $as_sci_Stream($n(these).tail__O());
  }
  while ((those !== these)) {
    if ($n(these).isEmpty__Z()) {
      return this;
    }
    these = $as_sci_Stream($n(these).tail__O());
    if ($n(these).isEmpty__Z()) {
      return this;
    }
    these = $as_sci_Stream($n(these).tail__O());
    if ((these === those)) {
      return this;
    }
    those = $as_sci_Stream($n(those).tail__O());
  }
  return this;
});
$c_sci_Stream$Cons.prototype.force__sci_Stream = (function() {
  return this.force__sci_Stream$Cons();
});
$c_sci_Stream$Cons.prototype.tail__O = (function() {
  return this.tail__sci_Stream();
});
var $d_sci_Stream$Cons = new $TypeData().initClass($c_sci_Stream$Cons, "scala.collection.immutable.Stream$Cons", ({
  sci_Stream$Cons: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Stream$Empty$() {
}
$c_sci_Stream$Empty$.prototype = new $h_sci_Stream();
$c_sci_Stream$Empty$.prototype.constructor = $c_sci_Stream$Empty$;
/** @constructor */
function $h_sci_Stream$Empty$() {
}
$h_sci_Stream$Empty$.prototype = $c_sci_Stream$Empty$.prototype;
$c_sci_Stream$Empty$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_Stream$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty stream");
});
$c_sci_Stream$Empty$.prototype.tail__sci_Stream = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty stream");
});
$c_sci_Stream$Empty$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Stream$Empty$.prototype.tailDefined__Z = (function() {
  return false;
});
$c_sci_Stream$Empty$.prototype.force__sci_Stream = (function() {
  return this;
});
$c_sci_Stream$Empty$.prototype.tail__O = (function() {
  return this.tail__sci_Stream();
});
$c_sci_Stream$Empty$.prototype.head__O = (function() {
  this.head__E();
});
var $d_sci_Stream$Empty$ = new $TypeData().initClass($c_sci_Stream$Empty$, "scala.collection.immutable.Stream$Empty$", ({
  sci_Stream$Empty$: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Stream$Empty$;
function $m_sci_Stream$Empty$() {
  if ((!$n_sci_Stream$Empty$)) {
    $n_sci_Stream$Empty$ = new $c_sci_Stream$Empty$();
  }
  return $n_sci_Stream$Empty$;
}
function $as_sci_TreeSeqMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSeqMap"));
}
function $isArrayOf_sci_TreeSeqMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSeqMap)));
}
function $asArrayOf_sci_TreeSeqMap(obj, depth) {
  return (($isArrayOf_sci_TreeSeqMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSeqMap;", depth));
}
function $as_sci_VectorMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.VectorMap"));
}
function $isArrayOf_sci_VectorMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorMap)));
}
function $asArrayOf_sci_VectorMap(obj, depth) {
  return (($isArrayOf_sci_VectorMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.VectorMap;", depth));
}
/** @constructor */
function $c_scm_AbstractBuffer() {
}
$c_scm_AbstractBuffer.prototype = new $h_scm_AbstractSeq();
$c_scm_AbstractBuffer.prototype.constructor = $c_scm_AbstractBuffer;
/** @constructor */
function $h_scm_AbstractBuffer() {
}
$h_scm_AbstractBuffer.prototype = $c_scm_AbstractBuffer.prototype;
$c_scm_AbstractBuffer.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return $f_scm_Buffer__subtractOne__O__scm_Buffer(this, x);
});
$c_scm_AbstractBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_AbstractBuffer.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_Buffer(elem);
});
/** @constructor */
function $c_scm_AbstractMap() {
}
$c_scm_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_scm_AbstractMap.prototype.constructor = $c_scm_AbstractMap;
/** @constructor */
function $h_scm_AbstractMap() {
}
$h_scm_AbstractMap.prototype = $c_scm_AbstractMap.prototype;
$c_scm_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_Map$();
});
$c_scm_AbstractMap.prototype.update__O__O__V = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value);
});
$c_scm_AbstractMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
});
$c_scm_AbstractMap.prototype.knownSize__I = (function() {
  return (-1);
});
$c_scm_AbstractMap.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_AbstractMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Iterable$();
});
$c_scm_AbstractMap.prototype.result__O = (function() {
  return this;
});
/** @constructor */
function $c_Lcats_data_ChainInstances$$anon$3() {
}
$c_Lcats_data_ChainInstances$$anon$3.prototype = new $h_O();
$c_Lcats_data_ChainInstances$$anon$3.prototype.constructor = $c_Lcats_data_ChainInstances$$anon$3;
/** @constructor */
function $h_Lcats_data_ChainInstances$$anon$3() {
}
$h_Lcats_data_ChainInstances$$anon$3.prototype = $c_Lcats_data_ChainInstances$$anon$3.prototype;
$c_Lcats_data_ChainInstances$$anon$3.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return $n(fa$1).map__F1__Lcats_data_Chain(f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O($as_Lcats_data_Chain(sa), f, evidence$1);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.unit__O = (function() {
  $m_Lcats_data_Chain$();
  return new $c_Lcats_data_Chain$Singleton((void 0));
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval(f, lb, fa)));
  return new $c_Lcats_Eval$$anon$5(a);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldMap__Lcats_data_Chain__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $x_1.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($n(fa).isEmpty__Z()) {
    return $n(G).pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil);
  } else if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O($n(fa).iterator__sc_Iterator(), f, x);
  } else {
    var $x_1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    var this$2 = $n(as);
    var elems$1 = $n(fa).iterator__sc_Iterator();
    this$2.addAll__sc_IterableOnce__scm_ArrayBuffer(elems$1);
    return $x_1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G);
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverseVoid__Lcats_data_Chain__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O($n(fa).iterator__sc_Iterator(), f, x);
  } else {
    var x$2 = $m_Lcats_data_Chain$Empty$();
    if (x$2.equals__O__Z(fa)) {
      return $n(G).unit__O();
    }
    if ((fa instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var ne = $as_Lcats_data_Chain$NonEmpty(fa);
      return $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$10__F1__Lcats_Applicative__Lcats_data_Chain$NonEmpty__Lcats_data_Chain__O__O(f, G, ne, $m_Lcats_data_Chain$Empty$(), $n(G).unit__O());
    }
    throw new $c_s_MatchError(fa);
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.tailRecM__O__F1__Lcats_data_Chain = (function(a, f) {
  var elem$4 = $as_Lcats_data_Chain($n(f).apply__O__O(a));
  var this$1 = $m_sci_Nil$();
  return $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$11__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f, new $c_sci_$colon$colon(elem$4, this$1), $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain = (function(fa, fb, f) {
  if ($n(fb).isEmpty__Z()) {
    return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  } else {
    var this$1 = $n(fa);
    var this$2 = $m_Lcats_data_Chain$();
    var result = this$2.Lcats_data_Chain$__f_nil;
    var iter = this$1.iterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var this$3 = $n(result);
      var x0 = $n(iter).next__O();
      var c = $n(fb).map__F1__Lcats_data_Chain(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((f, x0) => ((b) => $n(f).apply__O__O__O(x0, b)))(f, x0)));
      result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$3, c);
    }
    return result;
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if ($n(fa).isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
    return new $c_Lcats_Now(a);
  } else {
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fb$2) => {
      var fb$1 = $as_Lcats_data_Chain(fb$2);
      return this.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain(fa, fb$1, f);
    })));
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval($as_Lcats_data_Chain(fa), lb, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__Lcats_data_Chain__F1__Lcats_kernel_Monoid__O($as_Lcats_data_Chain(fa), f, B);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return $n(fa$1).map__F1__Lcats_data_Chain(f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O($as_Lcats_data_Chain(fa), f, evidence$1);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__Lcats_data_Chain__F1__Lcats_Applicative__O($as_Lcats_data_Chain(fa), f, G);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.empty__O = (function() {
  return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.combineK__O__O__O = (function(x, y) {
  var c = $as_Lcats_data_Chain(x);
  var c2 = $as_Lcats_data_Chain(y);
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(c, c2);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Chain$();
  return new $c_Lcats_data_Chain$Singleton(x);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return $n(fa$1).flatMap__F1__Lcats_data_Chain(f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_Chain(a, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain($as_Lcats_data_Chain(fa), $as_Lcats_data_Chain(fb), f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval($as_Lcats_data_Chain(fa), fb, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this);
});
var $d_Lcats_data_ChainInstances$$anon$3 = new $TypeData().initClass($c_Lcats_data_ChainInstances$$anon$3, "cats.data.ChainInstances$$anon$3", ({
  Lcats_data_ChainInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_Sync$$anon$6(F0$13) {
  this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6 = null;
  this.Lcats_effect_kernel_Sync$$anon$6__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6 = F0$13;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
}
$c_Lcats_effect_kernel_Sync$$anon$6.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.constructor = $c_Lcats_effect_kernel_Sync$$anon$6;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$$anon$6() {
}
$h_Lcats_effect_kernel_Sync$$anon$6.prototype = $c_Lcats_effect_kernel_Sync$$anon$6.prototype;
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_kernel_Sync$$anon$6__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Sync__unique__O(this);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_Sync$$anon$6__f_cats$effect$kernel$Sync$$Delay;
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.C__Lcats_effect_kernel_Clock = (function() {
  return this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.F__Lcats_effect_kernel_Sync = (function() {
  return this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.realTime__O = (function() {
  return $f_Lcats_effect_kernel_Clock$KleisliClock__realTime__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_Sync$$anon$6.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Sync$$anon$6__f_F0$6;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_Sync$$anon$6 = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$$anon$6, "cats.effect.kernel.Sync$$anon$6", ({
  Lcats_effect_kernel_Sync$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_Clock$KleisliClock: 1,
  Lcats_effect_kernel_Sync$KleisliSync: 1
}));
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$1() {
}
$c_Lcats_instances_LazyListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$1() {
}
$h_Lcats_instances_LazyListInstances$$anon$1.prototype = $c_Lcats_instances_LazyListInstances$$anon$1.prototype;
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).map__F1__sci_LazyList(f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_LazyList__F1__Lcats_Applicative__O($as_sci_LazyList(sa), f, evidence$1);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_LazyList((void 0));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__sci_LazyList__sci_LazyList__sci_LazyList = (function(x, y) {
  return $n(x).lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => y)));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__sci_LazyList = (function(x) {
  var this$1 = $m_sci_LazyList$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_LazyList(elems);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList = (function(fa, fb, f) {
  var this$1 = $n(fb);
  if ((this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    var this$2 = $m_sci_LazyList$();
    return this$2.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    return $n(fa).flatMap__F1__sci_LazyList(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n(fb).map__F1__sci_LazyList(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b) => $n(f).apply__O__O__O(a, b)))))));
  }
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var this$1 = $n(fa);
  if ((this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    $m_Lcats_Eval$();
    var this$2 = $m_sci_LazyList$();
    var a = this$2.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    return new $c_Lcats_Now(a);
  } else {
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fb$2) => {
      var fb$1 = $as_sci_LazyList(fb$2);
      return this.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList(fa, fb$1, f);
    })));
  }
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => {
    var s$1 = $as_sci_LazyList(s);
    var this$3 = $n(s$1);
    if ((this$3.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return lb;
    } else {
      var $x_1 = $n(s$1).head__O();
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($n(s$1).tail__sci_LazyList(), lb, f)));
      return $as_Lcats_Eval($n(f).apply__O__O__O($x_1, new $c_Lcats_Eval$$anon$5(a)));
    }
  })));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $x_1.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__sci_LazyList__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
    var $x_1 = $n(G);
    var this$1 = $m_sci_LazyList$();
    return $x_1.pure__O__O(this$1.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty);
  }));
  return $n(this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a$1, lgsb) => {
    var lgsb$1 = $as_Lcats_Eval(lgsb);
    return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), lgsb$1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$3, _$4) => {
      var _$4$1 = $as_sci_LazyList(_$4);
      $m_sci_LazyList$();
      var l = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => _$4$1));
      return $m_sci_LazyList$Deferrer$().$hash$colon$colon$extension__F0__F0__sci_LazyList(l, new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => _$3)));
    })));
  })))).value__O();
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__sci_LazyList = (function(a, fn) {
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_s_util_Left.getArrayOf().constr)([new $c_s_util_Left(a)]));
  var init = $n(xs).iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((it) => {
    var it$1 = $as_sc_Iterator(it);
    if ((!$n(it$1).hasNext__Z())) {
      return $m_s_None$();
    } else {
      var x1 = $as_s_util_Either($n(it$1).next__O());
      if ((x1 instanceof $c_s_util_Left)) {
        var a$1 = $n($as_s_util_Left(x1)).s_util_Left__f_value;
        var _1 = $m_s_None$();
        var this$3 = $n($n($as_sci_LazyList($n(fn).apply__O__O(a$1))).iterator__sc_Iterator());
        var xs$1 = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => it$1));
        var _2 = this$3.concat__F0__sc_Iterator(xs$1);
        var value = new $c_T2(_1, _2);
        return new $c_s_Some(value);
      }
      if ((x1 instanceof $c_s_util_Right)) {
        var b = $n($as_s_util_Right(x1)).s_util_Right__f_value;
        var _1$1 = new $c_s_Some(b);
        var value$1 = new $c_T2(_1$1, it$1);
        return new $c_s_Some(value$1);
      }
      throw new $c_s_MatchError(x1);
    }
  }));
  var kernel = new $c_sc_Iterator$UnfoldIterator(init, f);
  var $x_1 = $m_sci_LazyList$();
  var pf = new $c_Lcats_instances_LazyListInstances$$anon$2();
  return $x_1.from__sc_IterableOnce__sci_LazyList(new $c_sc_Iterator$$anon$7(kernel, pf));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldM__sci_LazyList__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $n(G).tailRecM__O__F1__O(new $c_T2(fa, z), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_LazyListInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$2);
  })));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.empty__O = (function() {
  var this$1 = $m_sci_LazyList$();
  return this$1.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_LazyList__sci_LazyList__sci_LazyList($as_sci_LazyList(x), $as_sci_LazyList(y));
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_LazyList(x);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).map__F1__sci_LazyList(f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return $n(fa$1).flatMap__F1__sci_LazyList(f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList($as_sci_LazyList(fa), $as_sci_LazyList(fb), f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($as_sci_LazyList(fa), fb, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($as_sci_LazyList(fa), lb, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O($as_sci_LazyList(fa), f, B);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_LazyList__F1__Lcats_Applicative__O($as_sci_LazyList(fa), f, evidence$1);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_LazyList(a, f);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_LazyList__O__F2__Lcats_Monad__O($as_sci_LazyList(fa), z, f, G);
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return $m_Lcats_kernel_instances_LazyListMonoid$().Lcats_kernel_instances_LazyListMonoid$__f_singleton;
});
var $d_Lcats_instances_LazyListInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_LazyListInstances$$anon$1, "cats.instances.LazyListInstances$$anon$1", ({
  Lcats_instances_LazyListInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_instances_ListInstances$$anon$1() {
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = null;
  this.Lcats_instances_ListInstances$$anon$1__f__unit = null;
  $m_Lcats_Eval$();
  var a = $m_sci_Nil$();
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = new $c_Lcats_Now(a);
  var this$3 = $m_sci_Nil$();
  this.Lcats_instances_ListInstances$$anon$1__f__unit = new $c_sci_$colon$colon((void 0), this$3);
}
$c_Lcats_instances_ListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_ListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_ListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_ListInstances$$anon$1() {
}
$h_Lcats_instances_ListInstances$$anon$1.prototype = $c_Lcats_instances_ListInstances$$anon$1.prototype;
$c_Lcats_instances_ListInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_List(fa);
  return $n(fa$1).map__F1__sci_List(f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_List__F1__Lcats_Applicative__O($as_sci_List(sa), f, evidence$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__sci_List__sci_List__F2__sci_List = (function(fa, fb, f) {
  if ($n(fb).isEmpty__Z()) {
    return $m_sci_Nil$();
  } else {
    var this$1 = $n(fa);
    var rest = this$1;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var x0 = $n(rest).head__O();
      var this$2 = $n(fb);
      var f$1 = ((f, x0) => ((b) => $n(f).apply__O__O__O(x0, b)))(f, x0);
      if ((this$2 === $m_sci_Nil$())) {
        var $x_1 = $m_sci_Nil$();
      } else {
        var x0$1 = this$2.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(this$2.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var x0$2 = $n(rest$1).head__O();
          var nx = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
          $n(t$1).sci_$colon$colon__f_next = nx;
          t$1 = nx;
          rest$1 = $as_sci_List($n(rest$1).tail__O());
        }
        var $x_1 = h$1;
      }
      var it = $x_1.iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx$1;
        } else {
          $n(t).sci_$colon$colon__f_next = nx$1;
        }
        t = nx$1;
      }
      rest = $as_sci_List($n(rest).tail__O());
    }
    return ((h === null) ? $m_sci_Nil$() : h);
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return ($n(fa).isEmpty__Z() ? this.Lcats_instances_ListInstances$$anon$1__f_evalNil : $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fb$2) => {
    var fb$1 = $as_sci_List(fb$2);
    return this.map2__sci_List__sci_List__F2__sci_List(fa, fb$1, f);
  }))));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__sci_List = (function(a, f) {
  var buf = new $c_scm_ListBuffer();
  var elem$2 = $as_sci_List($n(f).apply__O__O(a));
  var this$2 = $m_sci_Nil$();
  $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__V(buf, f, new $c_sci_$colon$colon(elem$2, this$2));
  return buf.toList__sci_List();
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval(lb, f, fa)));
  return new $c_Lcats_Eval$$anon$5(a);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldMap__sci_List__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $x_1.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__sci_List__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($n(fa).isEmpty__Z()) {
    return $n(G).pure__O__O($m_sci_Nil$());
  } else if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $n(x).map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
      var _$3$1 = $as_Lcats_data_Chain(_$3);
      return $n(_$3$1).toList__sci_List();
    })));
  } else {
    var $x_2 = $n(G);
    var $x_1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    var this$2 = $n(as);
    this$2.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return $x_2.map__O__F1__O($x_1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
      var _$4$1 = $as_Lcats_data_Chain(_$4);
      return $n(_$4$1).toList__sci_List();
    })));
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverseVoid__sci_List__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x);
  } else {
    var len = $n(fa).length__I();
    return ((len === 0) ? $n(G).unit__O() : $n($s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G, f, len, fa)).value__O());
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldM__sci_List__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $n(G).tailRecM__O__F1__O(new $c_T2(fa, z), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_ListInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$2);
  })));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.void__sci_List__sci_List = (function(fa) {
  return ($n(fa).isEmpty__Z() ? $m_sci_Nil$() : $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List($as_sci_List($n(fa).tail__O()), this.Lcats_instances_ListInstances$$anon$1__f__unit));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Nil$();
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_List(x);
  var y$1 = $as_sci_List(y);
  return $n(y$1).$colon$colon$colon__sci_List__sci_List(x$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  var this$1 = $m_sci_Nil$();
  return new $c_sci_$colon$colon(x, this$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return $n(fa$1).map__F1__sci_List(f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return $n(fa$1).flatMap__F1__sci_List(f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_List__sci_List__F2__sci_List($as_sci_List(fa), $as_sci_List(fb), f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval($as_sci_List(fa), fb, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_List(a, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval($as_sci_List(fa), lb, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_List__F1__Lcats_kernel_Monoid__O($as_sci_List(fa), f, B);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_List__F1__Lcats_Applicative__O($as_sci_List(fa), f, evidence$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__sci_List__F1__Lcats_Applicative__O($as_sci_List(fa), f, G);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_List__O__F2__Lcats_Monad__O($as_sci_List(fa), z, f, G);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return $m_Lcats_kernel_instances_ListMonoid$().Lcats_kernel_instances_ListMonoid$__f_singleton;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.unit__O = (function() {
  return this.Lcats_instances_ListInstances$$anon$1__f__unit;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return this.void__sci_List__sci_List($as_sci_List(fa));
});
var $d_Lcats_instances_ListInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_ListInstances$$anon$1, "cats.instances.ListInstances$$anon$1", ({
  Lcats_instances_ListInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$1() {
  this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty = null;
  $m_Lcats_Eval$();
  var a = $m_sci_Seq$().empty__sc_SeqOps();
  this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty = new $c_Lcats_Now(a);
}
$c_Lcats_instances_SeqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$1() {
}
$h_Lcats_instances_SeqInstances$$anon$1.prototype = $c_Lcats_instances_SeqInstances$$anon$1.prototype;
$c_Lcats_instances_SeqInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq($n(fa$1).map__F1__O(f));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_Seq__F1__Lcats_Applicative__O($as_sci_Seq(sa), f, evidence$1);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Seq((void 0));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.pure__O__sci_Seq = (function(x) {
  return $as_sci_Seq($m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]))));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__sci_Seq__sci_Seq__F2__sci_Seq = (function(fa, fb, f) {
  return ($n(fb).isEmpty__Z() ? $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps()) : $as_sci_Seq($n(fa).flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $as_sc_IterableOnce($n(fb).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b) => $n(f).apply__O__O__O(a, b))))))))));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2Eval__sci_Seq__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return ($n(fa).isEmpty__Z() ? this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty : $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fb$2) => {
    var fb$1 = $as_sci_Seq(fb$2);
    return this.map2__sci_Seq__sci_Seq__F2__sci_Seq(fa, fb$1, f);
  }))));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldMap__sci_Seq__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $x_1.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.tailRecM__O__F1__sci_Seq = (function(a, fn) {
  var buf = $m_sci_Seq$().newBuilder__scm_Builder();
  var elem = new $c_sci_$colon$colon($n($as_sc_IterableOnce($n(fn).apply__O__O(a))).iterator__sc_Iterator(), $m_sci_Nil$());
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    var x11 = $as_sci_List(elem$1);
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x11)) {
      break;
    }
    if ((x11 instanceof $c_sci_$colon$colon)) {
      var x15 = $as_sci_$colon$colon(x11);
      var x16 = $as_sc_Iterator($n(x15).sci_$colon$colon__f_head);
      var x17 = $n(x15).sci_$colon$colon__f_next;
      var this$2 = $n(x16);
      if ((!this$2.hasNext__Z())) {
        elem$1 = x17;
        continue;
      }
      var x6 = $as_s_util_Either($n(x16).next__O());
      if ((x6 instanceof $c_s_util_Right)) {
        var b = $n($as_s_util_Right(x6)).s_util_Right__f_value;
        var this$3 = $n(buf);
        this$3.addOne__O__scm_Growable(b);
        continue;
      }
      if ((x6 instanceof $c_s_util_Left)) {
        var a$1 = $n($as_s_util_Left(x6)).s_util_Left__f_value;
        var elem$1$1 = $n($as_sc_IterableOnce($n(fn).apply__O__O(a$1))).iterator__sc_Iterator();
        var this$4 = $n(x17);
        var this$5 = new $c_sci_$colon$colon(x16, this$4);
        elem$1 = new $c_sci_$colon$colon(elem$1$1, this$5);
        continue;
      }
      throw new $c_s_MatchError(x6);
    }
    throw new $c_s_MatchError(x11);
  }
  return $as_sci_Seq($n(buf).result__O());
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse__sci_Seq__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $n(x).map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
      var _$3$1 = $as_Lcats_data_Chain(_$3);
      return $n(_$3$1).toList__sci_List();
    })));
  } else {
    return $n(G).map__O__F1__O($m_Lcats_data_Chain$().traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O($n(fa).toIndexedSeq__sci_IndexedSeq(), f, G), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
      var _$4$1 = $as_Lcats_data_Chain(_$4);
      return $n(_$4$1).toList__sci_List();
    })));
  }
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverseVoid__sci_Seq__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x);
  } else {
    $m_Lcats_Eval$();
    var a = $n(G).unit__O();
    var lb = new $c_Lcats_Now(a);
    var f$1 = new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a$1, acc) => {
      var acc$1 = $as_Lcats_Eval(acc);
      return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), acc$1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$6, _$7) => {
        $as_jl_Void(_$7);
      })));
    }));
    return $n($m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(fa, lb, f$1)).value__O();
  }
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldM__sci_Seq__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  var length = $n(fa).length__I();
  return $n(G).tailRecM__O__F1__O(new $c_T2(z, 0), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var b = $n(x$1$1)._1__O();
      var i = $uI($n(x$1$1)._2__O());
      return ((i < length) ? $n(G).map__O__F1__O($n(f).apply__O__O__O(b, $n(fa).apply__I__O(i)), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b$2) => {
        var _2 = ((1 + i) | 0);
        var value = new $c_T2(b$2, _2);
        return new $c_s_util_Left(value);
      }))) : $n(G).pure__O__O(new $c_s_util_Right(b)));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.empty__O = (function() {
  return $as_sci_Seq($m_sci_Seq$().empty__sc_SeqOps());
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Seq(x);
  var y$1 = $as_sci_Seq(y);
  var this$1 = $n(x$1);
  return $as_sci_Seq(this$1.appendedAll__sc_IterableOnce__O(y$1));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Seq(x);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq($n(fa$1).map__F1__O(f));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $as_sci_Seq($n(fa$1).flatMap__F1__O(f));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Seq__sci_Seq__F2__sci_Seq($as_sci_Seq(fa), $as_sci_Seq(fb), f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Seq__Lcats_Eval__F2__Lcats_Eval($as_sci_Seq(fa), fb, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_sci_Seq(fa);
  return $m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(fa$1, lb, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Seq__F1__Lcats_kernel_Monoid__O($as_sci_Seq(fa), f, B);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Seq(a, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Seq__F1__Lcats_Applicative__O($as_sci_Seq(fa), f, evidence$1);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__sci_Seq__F1__Lcats_Applicative__O($as_sci_Seq(fa), f, G);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Seq__O__F2__Lcats_Monad__O($as_sci_Seq(fa), z, f, G);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  var this$1 = $m_Lcats_kernel_instances_SeqMonoid$();
  return $as_Lcats_kernel_instances_SeqMonoid(this$1.Lcats_kernel_instances_SeqMonoid$__f_singleton);
});
var $d_Lcats_instances_SeqInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_SeqInstances$$anon$1, "cats.instances.SeqInstances$$anon$1", ({
  Lcats_instances_SeqInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$1() {
}
$c_Lcats_instances_StreamInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_StreamInstances$$anon$1.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$1() {
}
$h_Lcats_instances_StreamInstances$$anon$1.prototype = $c_Lcats_instances_StreamInstances$$anon$1.prototype;
$c_Lcats_instances_StreamInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).map__F1__sci_Stream(f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_Stream__F1__Lcats_Applicative__O($as_sci_Stream(sa), f, evidence$1);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Stream((void 0));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.empty__sci_Stream = (function() {
  return $m_sci_Stream$Empty$();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__sci_Stream__sci_Stream__sci_Stream = (function(x, y) {
  var l = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => y));
  return $n(x).lazyAppendedAll__F0__sci_Stream(l);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__sci_Stream = (function(x) {
  var this$1 = $m_sci_Stream$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Stream(elems);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__sci_Stream__sci_Stream__F2__sci_Stream = (function(fa, fb, f) {
  return ($n(fb).isEmpty__Z() ? $m_sci_Stream$Empty$() : $n(fa).flatMap__F1__sci_Stream(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n(fb).map__F1__sci_Stream(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b) => $n(f).apply__O__O__O(a, b))))))));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if ($n(fa).isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_sci_Stream$Empty$();
    return new $c_Lcats_Now(a);
  } else {
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fb$2) => {
      var fb$1 = $as_sci_Stream(fb$2);
      return this.map2__sci_Stream__sci_Stream__F2__sci_Stream(fa, fb$1, f);
    })));
  }
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((s) => {
    var s$1 = $as_sci_Stream(s);
    if ($n(s$1).isEmpty__Z()) {
      return lb;
    } else {
      var $x_1 = $n(s$1).head__O();
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval($n(s$1).tail__sci_Stream(), lb, f)));
      return $as_Lcats_Eval($n(f).apply__O__O__O($x_1, new $c_Lcats_Eval$$anon$5(a)));
    }
  })));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n(fa);
  var this$2 = $n($f_sc_LinearSeqOps__iterator__sc_Iterator(this$1));
  return $x_1.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$2, f));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__sci_Stream__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $n(G).pure__O__O($m_sci_Stream$Empty$())));
  return $n(this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a$1, lgsb) => {
    var lgsb$1 = $as_Lcats_Eval(lgsb);
    return $n(G).map2Eval__O__Lcats_Eval__F2__Lcats_Eval($n(f).apply__O__O(a$1), lgsb$1, new $c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((_$2, _$3) => {
      var _$3$1 = $as_sci_Stream(_$3);
      var l = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => _$3$1));
      return new $c_sci_Stream$Cons(_$2, l);
    })));
  })))).value__O();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__sci_Stream = (function(a, fn) {
  var it = new $c_Lcats_instances_StreamInstances$$anon$2(fn, a);
  var factory = $m_sci_Stream$();
  var factory$1 = new $c_sc_IterableFactory$ToFactory(factory);
  return $as_sci_Stream(factory$1.fromSpecific__sc_IterableOnce__O(it));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldM__sci_Stream__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $n(G).tailRecM__O__F1__O(new $c_T2(fa, z), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((in$1) => {
    var in$2 = $as_T2(in$1);
    return $ps_Lcats_instances_StreamInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$2);
  })));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.empty__O = (function() {
  return this.empty__sci_Stream();
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__sci_Stream__sci_Stream__sci_Stream($as_sci_Stream(x), $as_sci_Stream(y));
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Stream(x);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).map__F1__sci_Stream(f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return $n(fa$1).flatMap__F1__sci_Stream(f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Stream__sci_Stream__F2__sci_Stream($as_sci_Stream(fa), $as_sci_Stream(fb), f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval($as_sci_Stream(fa), fb, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval($as_sci_Stream(fa), lb, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O($as_sci_Stream(fa), f, B);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Stream__F1__Lcats_Applicative__O($as_sci_Stream(fa), f, evidence$1);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Stream(a, f);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Stream__O__F2__Lcats_Monad__O($as_sci_Stream(fa), z, f, G);
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_kernel_instances_StreamMonoid();
});
var $d_Lcats_instances_StreamInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_StreamInstances$$anon$1, "cats.instances.StreamInstances$$anon$1", ({
  Lcats_instances_StreamInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_instances_VectorInstances$$anon$1() {
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = null;
  $m_Lcats_Eval$();
  $m_sci_Vector$();
  var a = $m_sci_Vector0$();
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = new $c_Lcats_Now(a);
}
$c_Lcats_instances_VectorInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_VectorInstances$$anon$1.prototype.constructor = $c_Lcats_instances_VectorInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_VectorInstances$$anon$1() {
}
$h_Lcats_instances_VectorInstances$$anon$1.prototype = $c_Lcats_instances_VectorInstances$$anon$1.prototype;
$c_Lcats_instances_VectorInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_sci_Vector(fa);
  return $as_sci_Vector($n(fa$1).map__F1__O(f));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(sa), f, evidence$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Vector((void 0));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__sci_Vector = (function(x) {
  var this$1 = $m_sci_Vector$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Vector(elems);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__sci_Vector__sci_Vector__F2__sci_Vector = (function(fa, fb, f) {
  var this$1 = $n(fb);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  } else {
    var this$3 = $n(fa);
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = this$3.iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var x0 = $n(it).next__O();
      var elems = $as_sc_IterableOnce($n(fb).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((f, x0) => ((b$1) => $n(f).apply__O__O__O(x0, b$1)))(f, x0))));
      b.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
    }
    return b.result__sci_Vector();
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var this$1 = $n(fa);
  if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
    return this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty;
  } else {
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((fb$2) => {
      var fb$1 = $as_sci_Vector(fb$2);
      return this.map2__sci_Vector__sci_Vector__F2__sci_Vector(fa, fb$1, f);
    })));
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval(fa, f, lb, 0)));
  return new $c_Lcats_Eval$$anon$5(a);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n($n(fa).iterator__sc_Iterator());
  return $x_1.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__sci_Vector = (function(a, fn) {
  $m_sci_Vector$();
  var buf = new $c_sci_VectorBuilder();
  var elem = new $c_sci_$colon$colon($n($as_sci_Vector($n(fn).apply__O__O(a))).iterator__sc_Iterator(), $m_sci_Nil$());
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    var x11 = $as_sci_List(elem$1);
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x11)) {
      break;
    }
    if ((x11 instanceof $c_sci_$colon$colon)) {
      var x15 = $as_sci_$colon$colon(x11);
      var x16 = $as_sc_Iterator($n(x15).sci_$colon$colon__f_head);
      var x17 = $n(x15).sci_$colon$colon__f_next;
      var this$3 = $n(x16);
      if ((!this$3.hasNext__Z())) {
        elem$1 = x17;
        continue;
      }
      var x6 = $as_s_util_Either($n(x16).next__O());
      if ((x6 instanceof $c_s_util_Right)) {
        var b = $n($as_s_util_Right(x6)).s_util_Right__f_value;
        buf.addOne__O__sci_VectorBuilder(b);
        continue;
      }
      if ((x6 instanceof $c_s_util_Left)) {
        var a$1 = $n($as_s_util_Left(x6)).s_util_Left__f_value;
        var elem$1$1 = $n($as_sci_Vector($n(fn).apply__O__O(a$1))).iterator__sc_Iterator();
        var this$4 = $n(x17);
        var this$5 = new $c_sci_$colon$colon(x16, this$4);
        elem$1 = new $c_sci_$colon$colon(elem$1$1, this$5);
        continue;
      }
      throw new $c_s_MatchError(x6);
    }
    throw new $c_s_MatchError(x11);
  }
  return buf.result__sci_Vector();
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $n(x).map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
      var _$3$1 = $as_Lcats_data_Chain(_$3);
      return $n(_$3$1).toVector__sci_Vector();
    })));
  } else {
    return $n(G).map__O__F1__O($m_Lcats_data_Chain$().traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(fa, f, G), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
      var _$4$1 = $as_Lcats_data_Chain(_$4);
      return $n(_$4$1).toVector__sci_Vector();
    })));
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverseVoid__sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    var x = $as_Lcats_StackSafeMonad(G);
    return $m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, x);
  } else {
    var len = $n(fa).length__I();
    return ((len === 0) ? $n(G).unit__O() : $n($s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G, fa, f, len, 0)).value__O());
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldM__sci_Vector__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  var length = $n(fa).length__I();
  return $n(G).tailRecM__O__F1__O(new $c_T2(z, 0), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var b = $n(x$1$1)._1__O();
      var i = $uI($n(x$1$1)._2__O());
      return ((i < length) ? $n(G).map__O__F1__O($n(f).apply__O__O__O(b, $n(fa).apply__I__O(i)), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b$2) => {
        var _2 = ((1 + i) | 0);
        var value = new $c_T2(b$2, _2);
        return new $c_s_util_Left(value);
      }))) : $n(G).pure__O__O(new $c_s_util_Right(b)));
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.empty__O = (function() {
  $m_sci_Vector$();
  return $m_sci_Vector0$();
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var x$1 = $as_sci_Vector(x);
  var y$1 = $as_sci_Vector(y);
  var this$1 = $n(x$1);
  return this$1.appendedAll__sc_IterableOnce__sci_Vector(y$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Vector(x);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  return $as_sci_Vector($n(fa$1).map__F1__O(f));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  var this$1 = $n(fa$1);
  return $as_sci_Vector($f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this$1, f));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Vector__sci_Vector__F2__sci_Vector($as_sci_Vector(fa), $as_sci_Vector(fb), f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval($as_sci_Vector(fa), fb, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval($as_sci_Vector(fa), lb, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O($as_sci_Vector(fa), f, B);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Vector(a, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(fa), f, evidence$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(fa), f, G);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Vector__O__F2__Lcats_Monad__O($as_sci_Vector(fa), z, f, G);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return $m_Lcats_kernel_instances_VectorMonoid$().Lcats_kernel_instances_VectorMonoid$__f_singleton;
});
var $d_Lcats_instances_VectorInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_VectorInstances$$anon$1, "cats.instances.VectorInstances$$anon$1", ({
  Lcats_instances_VectorInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
function $p_scm_HashSet__addElem__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (($n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length - 1) | 0));
  var x1 = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(idx);
  if ((x1 === null)) {
    $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(idx, new $c_scm_HashSet$Node(elem, hash, null));
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && ($n(n).scm_HashSet$Node__f__hash <= hash))) {
      if ((($n(n).scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(elem, $n(n).scm_HashSet$Node__f__key))) {
        return false;
      }
      prev = n;
      n = $n(n).scm_HashSet$Node__f__next;
    }
    if ((prev === null)) {
      $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(idx, new $c_scm_HashSet$Node(elem, hash, x1));
    } else {
      $n(prev).scm_HashSet$Node__f__next = new $c_scm_HashSet$Node(elem, hash, $n(prev).scm_HashSet$Node__f__next);
    }
  }
  $thiz.scm_HashSet__f_contentSize = ((1 + $thiz.scm_HashSet__f_contentSize) | 0);
  return true;
}
function $p_scm_HashSet__remove__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (($n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length - 1) | 0));
  var x1 = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(idx);
  if ((x1 !== null)) {
    if ((($n(x1).scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(x1).scm_HashSet$Node__f__key, elem))) {
      $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(idx, $n(x1).scm_HashSet$Node__f__next);
      $thiz.scm_HashSet__f_contentSize = (($thiz.scm_HashSet__f_contentSize - 1) | 0);
      return true;
    } else {
      var prev = x1;
      var next = $n(x1).scm_HashSet$Node__f__next;
      while (((next !== null) && ($n(next).scm_HashSet$Node__f__hash <= hash))) {
        if ((($n(next).scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(next).scm_HashSet$Node__f__key, elem))) {
          $n(prev).scm_HashSet$Node__f__next = $n(next).scm_HashSet$Node__f__next;
          $thiz.scm_HashSet__f_contentSize = (($thiz.scm_HashSet__f_contentSize - 1) | 0);
          return true;
        }
        prev = next;
        next = $n(next).scm_HashSet$Node__f__next;
      }
      return false;
    }
  } else {
    return false;
  }
}
function $p_scm_HashSet__growTable__I__V($thiz, newlen) {
  var oldlen = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length;
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashSet__f_contentSize === 0)) {
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)(newlen);
  } else {
    var original = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table;
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = $asArrayOf_scm_HashSet$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashSet$Node(null, 0, null);
    var preHigh = new $c_scm_HashSet$Node(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get(i);
        if ((old !== null)) {
          preLow.scm_HashSet$Node__f__next = null;
          preHigh.scm_HashSet$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = $n(n).scm_HashSet$Node__f__next;
            if ((($n(n).scm_HashSet$Node__f__hash & oldlen) === 0)) {
              $n(lastLow).scm_HashSet$Node__f__next = n;
              lastLow = n;
            } else {
              $n(lastHigh).scm_HashSet$Node__f__next = n;
              lastHigh = n;
            }
            n = next;
          }
          $n(lastLow).scm_HashSet$Node__f__next = null;
          if ((old !== preLow.scm_HashSet$Node__f__next)) {
            $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(i, preLow.scm_HashSet$Node__f__next);
          }
          if ((preHigh.scm_HashSet$Node__f__next !== null)) {
            $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).set(((i + oldlen) | 0), preHigh.scm_HashSet$Node__f__next);
            $n(lastHigh).scm_HashSet$Node__f__next = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
function $p_scm_HashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = ((capacity - 1) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_HashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashSet__f_loadFactor));
}
function $ct_scm_HashSet__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashSet__f_loadFactor = loadFactor;
  $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)($p_scm_HashSet__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, $n($thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length);
  $thiz.scm_HashSet__f_contentSize = 0;
  return $thiz;
}
function $ct_scm_HashSet__($thiz) {
  $ct_scm_HashSet__I__D__($thiz, 16, 0.75);
  return $thiz;
}
/** @constructor */
function $c_scm_HashSet() {
  this.scm_HashSet__f_loadFactor = 0.0;
  this.scm_HashSet__f_scala$collection$mutable$HashSet$$table = null;
  this.scm_HashSet__f_threshold = 0;
  this.scm_HashSet__f_contentSize = 0;
}
$c_scm_HashSet.prototype = new $h_scm_AbstractSet();
$c_scm_HashSet.prototype.constructor = $c_scm_HashSet;
/** @constructor */
function $h_scm_HashSet() {
}
$h_scm_HashSet.prototype = $c_scm_HashSet.prototype;
$c_scm_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_HashSet.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_scm_HashSet.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_HashSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_HashSet.prototype.size__I = (function() {
  return this.scm_HashSet__f_contentSize;
});
$c_scm_HashSet.prototype.scala$collection$mutable$HashSet$$improveHash__I__I = (function(originalHash) {
  return (originalHash ^ ((originalHash >>> 16) | 0));
});
$c_scm_HashSet.prototype.contains__O__Z = (function(elem) {
  var hash = this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem));
  var x1 = $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).get((hash & (($n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length - 1) | 0)));
  return (((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashSet$Node(elem, hash)) !== null);
});
$c_scm_HashSet.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashSet__f_loadFactor)));
  if ((target > $n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length)) {
    $p_scm_HashSet__growTable__I__V(this, target);
  }
});
$c_scm_HashSet.prototype.add__O__Z = (function(elem) {
  if ((((1 + this.scm_HashSet__f_contentSize) | 0) >= this.scm_HashSet__f_threshold)) {
    $p_scm_HashSet__growTable__I__V(this, ($n(this.scm_HashSet__f_scala$collection$mutable$HashSet$$table).u.length << 1));
  }
  return $p_scm_HashSet__addElem__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)));
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_HashSet = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    var this$2 = $n(x2);
    var f = new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((k$2$2, h$2$2) => {
      var h$2 = $uI(h$2$2);
      $p_scm_HashSet__addElem__O__I__Z(this, k$2$2, this.scala$collection$mutable$HashSet$$improveHash__I__I(h$2));
    }));
    $n(this$2.sci_HashSet__f_rootNode).foreachWithHash__F2__V(f);
    return this;
  } else if ((xs instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(xs);
    var this$3 = $n(x3);
    var iter = new $c_scm_HashSet$$anon$2(this$3);
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      $p_scm_HashSet__addElem__O__I__Z(this, $n(next).scm_HashSet$Node__f__key, $n(next).scm_HashSet$Node__f__hash);
    }
    return this;
  } else if (false) {
    var x4 = $as_scm_LinkedHashSet(xs);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    while ($n(iter$2).hasNext__Z()) {
      var next$2 = $as_scm_LinkedHashSet$Entry($n(iter$2).next__O());
      $p_scm_HashSet__addElem__O__I__Z(this, $n(next$2).key__O(), $n(next$2).hash__I());
    }
    return this;
  } else {
    return $as_scm_HashSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$c_scm_HashSet.prototype.remove__O__Z = (function(elem) {
  return $p_scm_HashSet__remove__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)));
});
$c_scm_HashSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_HashSet$$anon$1(this);
});
$c_scm_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$();
});
$c_scm_HashSet.prototype.knownSize__I = (function() {
  return this.scm_HashSet__f_contentSize;
});
$c_scm_HashSet.prototype.isEmpty__Z = (function() {
  return (this.scm_HashSet__f_contentSize === 0);
});
$c_scm_HashSet.prototype.className__T = (function() {
  return "HashSet";
});
$c_scm_HashSet.prototype.hashCode__I = (function() {
  var setIterator = new $c_scm_HashSet$$anon$1(this);
  var hashIterator = ((!setIterator.hasNext__Z()) ? setIterator : new $c_scm_HashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_scm_HashSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  this.remove__O__Z(elem);
  return this;
});
$c_scm_HashSet.prototype.addOne__O__scm_Growable = (function(elem) {
  this.add__O__Z(elem);
  return this;
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_HashSet(elems);
});
function $as_scm_HashSet(obj) {
  return (((obj instanceof $c_scm_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet"));
}
function $isArrayOf_scm_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet)));
}
function $asArrayOf_scm_HashSet(obj, depth) {
  return (($isArrayOf_scm_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet;", depth));
}
var $d_scm_HashSet = new $TypeData().initClass($c_scm_HashSet, "scala.collection.mutable.HashSet", ({
  scm_HashSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sjs_js_WrappedDictionary(dict) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = null;
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = dict;
}
$c_sjs_js_WrappedDictionary.prototype = new $h_scm_AbstractMap();
$c_sjs_js_WrappedDictionary.prototype.constructor = $c_sjs_js_WrappedDictionary;
/** @constructor */
function $h_sjs_js_WrappedDictionary() {
}
$h_sjs_js_WrappedDictionary.prototype = $c_sjs_js_WrappedDictionary.prototype;
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary = (function(coll) {
  var d = new $c_sjs_js_WrappedDictionary(({}));
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(d, coll);
  return d;
});
$c_sjs_js_WrappedDictionary.prototype.newSpecificBuilder__scm_Builder = (function() {
  return new $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder();
});
$c_sjs_js_WrappedDictionary.prototype.get__T__s_Option = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return new $c_s_Some(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]);
  } else {
    return $m_s_None$();
  }
});
$c_sjs_js_WrappedDictionary.prototype.apply__T__O = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sjs_js_WrappedDictionary.prototype.getOrElse__T__F0__O = (function(key, default$1) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  } else {
    return $n(default$1).apply__O();
  }
});
$c_sjs_js_WrappedDictionary.prototype.getOrElseUpdate__T__F0__O = (function(key, op) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  } else {
    var v = $n(op).apply__O();
    this.update__T__O__V(key, v);
    return v;
  }
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__T__sjs_js_WrappedDictionary = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    delete this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key];
  }
  return this;
});
$c_sjs_js_WrappedDictionary.prototype.update__T__O__V = (function(key, value) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key] = value;
});
$c_sjs_js_WrappedDictionary.prototype.addOne__T2__sjs_js_WrappedDictionary = (function(kv) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  var key = $as_T($n(kv)._1__O());
  var value = $n(kv)._2__O();
  dict[key] = value;
  return this;
});
$c_sjs_js_WrappedDictionary.prototype.iterator__sc_Iterator = (function() {
  return new $c_sjs_js_WrappedDictionary$DictionaryIterator(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict);
});
$c_sjs_js_WrappedDictionary.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary($as_T2(elem));
});
$c_sjs_js_WrappedDictionary.prototype.update__O__O__V = (function(key, value) {
  this.update__T__O__V($as_T(key), value);
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__T__sjs_js_WrappedDictionary($as_T(elem));
});
$c_sjs_js_WrappedDictionary.prototype.contains__O__Z = (function(key) {
  var key$1 = $as_T(key);
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  return $uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key$1));
});
$c_sjs_js_WrappedDictionary.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  return this.getOrElseUpdate__T__F0__O($as_T(key), defaultValue);
});
$c_sjs_js_WrappedDictionary.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return this.getOrElse__T__F0__O($as_T(key), default$1);
});
$c_sjs_js_WrappedDictionary.prototype.apply__O__O = (function(key) {
  return this.apply__T__O($as_T(key));
});
$c_sjs_js_WrappedDictionary.prototype.get__O__s_Option = (function(key) {
  return this.get__T__s_Option($as_T(key));
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll);
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll);
});
var $d_sjs_js_WrappedDictionary = new $TypeData().initClass($c_sjs_js_WrappedDictionary, "scala.scalajs.js.WrappedDictionary", ({
  sjs_js_WrappedDictionary: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1
}));
function $f_Lcats_effect_kernel_Async__asyncCheckAttempt__F1__O($thiz, k) {
  var body = new $c_Lcats_effect_kernel_Async$$anon$1(k);
  return $thiz.cont__Lcats_effect_kernel_Cont__O(body);
}
function $f_Lcats_effect_kernel_Async__async__F1__O($thiz, k) {
  return $thiz.asyncCheckAttempt__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cb) => {
    var cb$1 = $as_F1(cb);
    return $thiz.map__O__F1__O($n(k).apply__O__O(cb$1), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => {
      var _$3$1 = $as_s_Option(_$3);
      return new $c_s_util_Left(_$3$1);
    })));
  })));
}
function $f_Lcats_effect_kernel_Async__async___F1__O($thiz, k) {
  return $thiz.async__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((cb) => {
    var cb$1 = $as_F1(cb);
    return $thiz.as__O__O__O($thiz.delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
      $n(k).apply__O__O(cb$1);
    }))), $m_s_None$());
  })));
}
function $f_Lcats_effect_kernel_Async__never__O($thiz) {
  return $thiz.async__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
    $as_F1(_$4);
    var value = $thiz.unit__O();
    return $thiz.pure__O__O(new $c_s_Some(value));
  })));
}
function $is_Lcats_effect_kernel_Async(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Async)));
}
function $as_Lcats_effect_kernel_Async(obj) {
  return (($is_Lcats_effect_kernel_Async(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Async"));
}
function $isArrayOf_Lcats_effect_kernel_Async(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Async)));
}
function $asArrayOf_Lcats_effect_kernel_Async(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Async(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Async;", depth));
}
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JSetWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying = underlying;
}
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = new $h_scm_AbstractSet();
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JSetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JSetWrapper() {
}
$h_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.size__I = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).size__I();
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.isEmpty__Z = (function() {
  return $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).isEmpty__Z();
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.knownSize__I = (function() {
  return ($n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).isEmpty__Z() ? 0 : (-1));
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $m_s_jdk_CollectionConverters$();
  var i = $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).iterator__ju_Iterator();
  return new $c_sc_convert_AsScalaExtensions$IteratorHasAsScala(this$1, i).asScala__sc_Iterator();
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.contains__O__Z = (function(elem) {
  return $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).contains__O__Z(elem);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.addOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper = (function(elem) {
  $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying);
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.subtractOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper = (function(elem) {
  $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).remove__O__Z(elem);
  return this;
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.remove__O__Z = (function(elem) {
  return $n(this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying).remove__O__Z(elem);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$();
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper(elem);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper(elem);
});
function $as_sc_convert_JavaCollectionWrappers$JSetWrapper(obj) {
  return (((obj instanceof $c_sc_convert_JavaCollectionWrappers$JSetWrapper) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$JSetWrapper"));
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$JSetWrapper)));
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$JSetWrapper;", depth));
}
var $d_sc_convert_JavaCollectionWrappers$JSetWrapper = new $TypeData().initClass($c_sc_convert_JavaCollectionWrappers$JSetWrapper, "scala.collection.convert.JavaCollectionWrappers$JSetWrapper", ({
  sc_convert_JavaCollectionWrappers$JSetWrapper: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $as_sci_ListMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ListMap"));
}
function $isArrayOf_sci_ListMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListMap)));
}
function $asArrayOf_sci_ListMap(obj, depth) {
  return (($isArrayOf_sci_ListMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ListMap;", depth));
}
function $p_sci_NumericRange__length$lzycompute__I($thiz) {
  if (((((1 & $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.sci_NumericRange__f_length = $m_sci_NumericRange$().count__O__O__O__Z__s_math_Integral__I($thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step, $thiz.sci_NumericRange__f_isInclusive, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    $thiz.sci_NumericRange__f_bitmap$0 = (((1 | $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.sci_NumericRange__f_length;
}
function $p_sci_NumericRange__isEmpty$lzycompute__Z($thiz) {
  if (((((2 & $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0)) {
    if ($f_s_math_Ordering__gt__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end)) {
      var $x_4 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var $x_3 = $thiz.sci_NumericRange__f_step;
      var this$1 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var $x_2 = $f_s_math_Ordering__gt__O__O__Z($x_4, $x_3, this$1.fromInt__I__O(0));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var $x_1 = true;
    } else if ($f_s_math_Ordering__lt__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end)) {
      var $x_6 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var $x_5 = $thiz.sci_NumericRange__f_step;
      var this$2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var $x_1 = $f_s_math_Ordering__lt__O__O__Z($x_6, $x_5, this$2.fromInt__I__O(0));
    } else {
      var $x_1 = false;
    }
    $thiz.sci_NumericRange__f_isEmpty = ($x_1 || ($f_s_math_Ordering__equiv__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end) && (!$thiz.sci_NumericRange__f_isInclusive)));
    $thiz.sci_NumericRange__f_bitmap$0 = (((2 | $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.sci_NumericRange__f_isEmpty;
}
function $p_sci_NumericRange__locationAfterN__I__O($thiz, n) {
  var this$1 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  var lhs = $thiz.sci_NumericRange__f_start;
  var $x_1 = new $c_s_math_Integral$IntegralOps(this$1, lhs);
  var this$2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  var lhs$1 = $thiz.sci_NumericRange__f_step;
  return $x_1.$plus__O__O(new $c_s_math_Integral$IntegralOps(this$2, lhs$1).$times__O__O($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(n)));
}
function $p_sci_NumericRange__crossesTheEndAfterN__I__Z($thiz, n) {
  if ($f_s_math_Ordering__gt__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_start)) {
    var $x_3 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var $x_2 = $thiz.sci_NumericRange__f_step;
    var this$1 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var $x_1 = $f_s_math_Ordering__gt__O__O__Z($x_3, $x_2, this$1.fromInt__I__O(0));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var stepIsInTheSameDirectionAsStartToEndVector = true;
  } else if ($f_s_math_Ordering__lt__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_start)) {
    var $x_5 = $m_sr_BoxesRunTime$();
    var $x_4 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).sign__O__O($thiz.sci_NumericRange__f_step);
    var this$3 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var this$2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs = this$2.fromInt__I__O(1);
    var stepIsInTheSameDirectionAsStartToEndVector = $x_5.equals__O__O__Z($x_4, new $c_s_math_Integral$IntegralOps(this$3, lhs).unary_$minus__O());
  } else {
    var stepIsInTheSameDirectionAsStartToEndVector = false;
  }
  if ((($f_s_math_Ordering__equiv__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end) || (n <= 0)) || (!stepIsInTheSameDirectionAsStartToEndVector))) {
    return (n >= 1);
  }
  var sameSign = $f_s_math_Ordering__equiv__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).sign__O__O($thiz.sci_NumericRange__f_start), $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).sign__O__O($thiz.sci_NumericRange__f_end));
  if (sameSign) {
    var len = $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, $thiz);
    return ($p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, len) ? (n >= $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).toInt__O__I(len)) : $f_s_math_Ordering__gteq__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(n), len));
  } else {
    var stepsRemainderToZero = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).rem__O__O__O($thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_step);
    var $x_6 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var this$4 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var walksOnZero = $f_s_math_Ordering__equiv__O__O__Z($x_6, stepsRemainderToZero, this$4.fromInt__I__O(0));
    if (walksOnZero) {
      var this$5 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var lhs$1 = $thiz.sci_NumericRange__f_step;
      var closestToZero = new $c_s_math_Integral$IntegralOps(this$5, lhs$1).unary_$minus__O();
    } else {
      var closestToZero = stepsRemainderToZero;
    }
    var $x_8 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var $x_7 = $thiz.sci_NumericRange__f_start;
    var this$6 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    if ($f_s_math_Ordering__lt__O__O__Z($x_8, $x_7, this$6.fromInt__I__O(0))) {
      if (walksOnZero) {
        var twoStepsAfterLargestNegativeNumber = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).plus__O__O__O(closestToZero, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).times__O__O__O($thiz.sci_NumericRange__f_step, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(2)));
        $m_sci_NumericRange$();
        var start = $thiz.sci_NumericRange__f_start;
        var step = $thiz.sci_NumericRange__f_step;
        var num = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
        var x1 = new $c_T3(new $c_sci_NumericRange$Exclusive(start, closestToZero, step, num), $thiz.copy__O__O__O__sci_NumericRange(twoStepsAfterLargestNegativeNumber, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step), 2);
      } else {
        $m_sci_NumericRange$();
        var start$1 = $thiz.sci_NumericRange__f_start;
        var step$1 = $thiz.sci_NumericRange__f_step;
        var num$1 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
        var x1 = new $c_T3(new $c_sci_NumericRange$Exclusive(start$1, closestToZero, step$1, num$1), $thiz.copy__O__O__O__sci_NumericRange($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).plus__O__O__O(closestToZero, $thiz.sci_NumericRange__f_step), $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step), 1);
      }
    } else if (walksOnZero) {
      var twoStepsAfterZero = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).times__O__O__O($thiz.sci_NumericRange__f_step, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(2));
      var $x_9 = $thiz.copy__O__O__O__sci_NumericRange(twoStepsAfterZero, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step);
      $m_sci_NumericRange$();
      var start$2 = $thiz.sci_NumericRange__f_start;
      var this$9 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
      var lhs$2 = $thiz.sci_NumericRange__f_step;
      var end = new $c_s_math_Integral$IntegralOps(this$9, lhs$2).unary_$minus__O();
      var step$2 = $thiz.sci_NumericRange__f_step;
      var num$2 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var x1 = new $c_T3($x_9, new $c_sci_NumericRange$Inclusive(start$2, end, step$2, num$2), 2);
    } else {
      var twoStepsAfterSmallestPositiveNumber = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).plus__O__O__O(closestToZero, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).times__O__O__O($thiz.sci_NumericRange__f_step, $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(2)));
      var $x_10 = $thiz.copy__O__O__O__sci_NumericRange(twoStepsAfterSmallestPositiveNumber, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step);
      $m_sci_NumericRange$();
      var start$3 = $thiz.sci_NumericRange__f_start;
      var step$3 = $thiz.sci_NumericRange__f_step;
      var num$3 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var x1 = new $c_T3($x_10, new $c_sci_NumericRange$Inclusive(start$3, closestToZero, step$3, num$3), 2);
    }
    matchEnd6: {
      var x$1___1;
      var x$1___2;
      var x$1___3;
      var l = $as_sci_NumericRange(x1.T3__f__1);
      var r = $as_sci_NumericRange(x1.T3__f__2);
      var carry = $uI(x1.T3__f__3);
      if ((l !== null)) {
        if ((r !== null)) {
          var x$1___1 = l;
          var x$1___2 = r;
          var x$1___3 = carry;
          break matchEnd6;
        }
      }
      throw new $c_s_MatchError(x1);
    }
    var l$2 = $as_sci_NumericRange(x$1___1);
    var r$2 = $as_sci_NumericRange(x$1___2);
    var carry$2 = $uI(x$1___3);
    var leftLength = $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, l$2);
    var rightLength = $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, r$2);
    return (($p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, leftLength) && $p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, rightLength)) ? (((((n - $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).toInt__O__I(leftLength)) | 0) - carry$2) | 0) >= $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).toInt__O__I(rightLength)) : $f_s_math_Ordering__gteq__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).minus__O__O__O($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).minus__O__O__O($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(n), leftLength), $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O(carry$2)), rightLength));
  }
}
function $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive($thiz, value) {
  $m_sci_NumericRange$();
  var step = $thiz.sci_NumericRange__f_step;
  var num = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
  return new $c_sci_NumericRange$Exclusive(value, value, step, num);
}
function $p_sci_NumericRange__hashCode$lzycompute__I($thiz) {
  if (((((4 & $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.sci_NumericRange__f_hashCode = $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I($thiz);
    $thiz.sci_NumericRange__f_bitmap$0 = (((4 | $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.sci_NumericRange__f_hashCode;
}
function $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, r) {
  var diff = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).minus__O__O__O($n(r).sci_NumericRange__f_end, $n(r).sci_NumericRange__f_start);
  var quotient = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).quot__O__O__O(diff, $n(r).sci_NumericRange__f_step);
  var remainder = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).rem__O__O__O(diff, $n(r).sci_NumericRange__f_step);
  if ((!$n(r).sci_NumericRange__f_isInclusive)) {
    var $x_2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var this$1 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var $x_1 = $f_s_math_Ordering__equiv__O__O__Z($x_2, remainder, this$1.fromInt__I__O(0));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var $x_3 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var this$2 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    return $f_s_math_Ordering__max__O__O__O($x_3, quotient, this$2.fromInt__I__O(0));
  } else {
    var $x_6 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var $x_5 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var this$3 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var $x_4 = $x_5.plus__O__O__O(quotient, this$3.fromInt__I__O(1));
    var this$4 = $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    return $f_s_math_Ordering__max__O__O__O($x_6, $x_4, this$4.fromInt__I__O(0));
  }
}
function $p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, value) {
  return $f_s_math_Ordering__equiv__O__O__Z($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num), $n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).fromInt__I__O($n($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num).toInt__O__I(value)), value);
}
function $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__($thiz, start, end, step, isInclusive, num) {
  $thiz.sci_NumericRange__f_start = start;
  $thiz.sci_NumericRange__f_end = end;
  $thiz.sci_NumericRange__f_step = step;
  $thiz.sci_NumericRange__f_isInclusive = isInclusive;
  $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = num;
  return $thiz;
}
/** @constructor */
function $c_sci_NumericRange() {
  this.sci_NumericRange__f_length = 0;
  this.sci_NumericRange__f_isEmpty = false;
  this.sci_NumericRange__f_hashCode = 0;
  this.sci_NumericRange__f_start = null;
  this.sci_NumericRange__f_end = null;
  this.sci_NumericRange__f_step = null;
  this.sci_NumericRange__f_isInclusive = false;
  this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = null;
  this.sci_NumericRange__f_bitmap$0 = 0;
}
$c_sci_NumericRange.prototype = new $h_sci_AbstractSeq();
$c_sci_NumericRange.prototype.constructor = $c_sci_NumericRange;
/** @constructor */
function $h_sci_NumericRange() {
}
$h_sci_NumericRange.prototype = $c_sci_NumericRange.prototype;
$c_sci_NumericRange.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_NumericRange.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sci_NumericRange.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_NumericRange.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_NumericRange.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_NumericRange.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_NumericRange.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_NumericRange.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_NumericRange.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_NumericRange.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sci_NumericRange.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_NumericRange.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_NumericRange.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_NumericRange.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sci_NumericRange.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_NumericRange.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_NumericRange.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_NumericRange$NumericRangeIterator(this, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
});
$c_sci_NumericRange.prototype.length__I = (function() {
  return (((((1 & this.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0) ? $p_sci_NumericRange__length$lzycompute__I(this) : this.sci_NumericRange__f_length);
});
$c_sci_NumericRange.prototype.isEmpty__Z = (function() {
  return (((((2 & this.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0) ? $p_sci_NumericRange__isEmpty$lzycompute__Z(this) : this.sci_NumericRange__f_isEmpty);
});
$c_sci_NumericRange.prototype.last__O = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$().head__E() : $p_sci_NumericRange__locationAfterN__I__O(this, ((this.length__I() - 1) | 0)));
});
$c_sci_NumericRange.prototype.init__sci_NumericRange = (function() {
  if (this.isEmpty__Z()) {
    $m_sci_Nil$().init__E();
  } else {
    var $x_1 = this.sci_NumericRange__f_start;
    var this$1 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs = this.sci_NumericRange__f_end;
    return $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(new $c_sci_NumericRange(), $x_1, new $c_s_math_Integral$IntegralOps(this$1, lhs).$minus__O__O(this.sci_NumericRange__f_step), this.sci_NumericRange__f_step, this.sci_NumericRange__f_isInclusive, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  }
});
$c_sci_NumericRange.prototype.head__O = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$().head__E() : this.sci_NumericRange__f_start);
});
$c_sci_NumericRange.prototype.tail__sci_NumericRange = (function() {
  if (this.isEmpty__Z()) {
    $m_sci_Nil$().tail__E();
  } else if (this.sci_NumericRange__f_isInclusive) {
    var this$1 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs = this.sci_NumericRange__f_start;
    return new $c_sci_NumericRange$Inclusive(new $c_s_math_Integral$IntegralOps(this$1, lhs).$plus__O__O(this.sci_NumericRange__f_step), this.sci_NumericRange__f_end, this.sci_NumericRange__f_step, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  } else {
    var this$2 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs$1 = this.sci_NumericRange__f_start;
    return new $c_sci_NumericRange$Exclusive(new $c_s_math_Integral$IntegralOps(this$2, lhs$1).$plus__O__O(this.sci_NumericRange__f_step), this.sci_NumericRange__f_end, this.sci_NumericRange__f_step, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  }
});
$c_sci_NumericRange.prototype.copy__O__O__O__sci_NumericRange = (function(start, end, step) {
  return $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(new $c_sci_NumericRange(), start, end, step, this.sci_NumericRange__f_isInclusive, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
});
$c_sci_NumericRange.prototype.apply__I__O = (function(idx) {
  if (((idx < 0) || (idx >= this.length__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + ((this.length__I() - 1) | 0)) + ")"));
  } else {
    return $p_sci_NumericRange__locationAfterN__I__O(this, idx);
  }
});
$c_sci_NumericRange.prototype.foreach__F1__V = (function(f) {
  var count = 0;
  var current = this.sci_NumericRange__f_start;
  while ((count < this.length__I())) {
    $n(f).apply__O__O(current);
    var this$1 = $n(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    var lhs = current;
    current = new $c_s_math_Integral$IntegralOps(this$1, lhs).$plus__O__O(this.sci_NumericRange__f_step);
    count = ((1 + count) | 0);
  }
});
$c_sci_NumericRange.prototype.take__I__sci_NumericRange = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive(this, this.sci_NumericRange__f_start) : ($p_sci_NumericRange__crossesTheEndAfterN__I__Z(this, n) ? this : new $c_sci_NumericRange$Inclusive(this.sci_NumericRange__f_start, $p_sci_NumericRange__locationAfterN__I__O(this, ((n - 1) | 0)), this.sci_NumericRange__f_step, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num)));
});
$c_sci_NumericRange.prototype.drop__I__sci_NumericRange = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? this : ($p_sci_NumericRange__crossesTheEndAfterN__I__Z(this, n) ? $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive(this, this.sci_NumericRange__f_end) : this.copy__O__O__O__sci_NumericRange($p_sci_NumericRange__locationAfterN__I__O(this, n), this.sci_NumericRange__f_end, this.sci_NumericRange__f_step)));
});
$c_sci_NumericRange.prototype.hashCode__I = (function() {
  return (((((4 & this.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0) ? $p_sci_NumericRange__hashCode$lzycompute__I(this) : this.sci_NumericRange__f_hashCode);
});
$c_sci_NumericRange.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647;
});
$c_sci_NumericRange.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sci_NumericRange)) {
    var x2 = $as_sci_NumericRange(other);
    var this$1 = $n(x2);
    if (($f_sci_IndexedSeq__canEqual__O__Z(this$1, this) && (this.length__I() === $n(x2).length__I()))) {
      return (this.isEmpty__Z() || ($m_sr_BoxesRunTime$().equals__O__O__Z(this.sci_NumericRange__f_start, $n(x2).sci_NumericRange__f_start) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.last__O(), $n(x2).last__O())));
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, other);
  }
});
$c_sci_NumericRange.prototype.toString__T = (function() {
  var empty = (this.isEmpty__Z() ? "empty " : "");
  var preposition = (this.sci_NumericRange__f_isInclusive ? "to" : "until");
  var stepped = ($m_sr_BoxesRunTime$().equals__O__O__Z(this.sci_NumericRange__f_step, 1) ? "" : (" by " + this.sci_NumericRange__f_step));
  return (((((((empty + "NumericRange ") + this.sci_NumericRange__f_start) + " ") + preposition) + " ") + this.sci_NumericRange__f_end) + stepped);
});
$c_sci_NumericRange.prototype.className__T = (function() {
  return "NumericRange";
});
$c_sci_NumericRange.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_NumericRange.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_NumericRange(n);
});
$c_sci_NumericRange.prototype.take__I__O = (function(n) {
  return this.take__I__sci_NumericRange(n);
});
$c_sci_NumericRange.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_sci_NumericRange.prototype.tail__O = (function() {
  return this.tail__sci_NumericRange();
});
$c_sci_NumericRange.prototype.init__O = (function() {
  return this.init__sci_NumericRange();
});
function $as_sci_NumericRange(obj) {
  return (((obj instanceof $c_sci_NumericRange) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.NumericRange"));
}
function $isArrayOf_sci_NumericRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_NumericRange)));
}
function $asArrayOf_sci_NumericRange(obj, depth) {
  return (($isArrayOf_sci_NumericRange(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.NumericRange;", depth));
}
var $d_sci_NumericRange = new $TypeData().initClass($c_sci_NumericRange, "scala.collection.immutable.NumericRange", ({
  sci_NumericRange: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $as_sci_Range(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Range"));
}
function $isArrayOf_sci_Range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Range)));
}
function $asArrayOf_sci_Range(obj, depth) {
  return (($isArrayOf_sci_Range(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Range;", depth));
}
function $as_scm_LinkedHashSet(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashSet"));
}
function $isArrayOf_scm_LinkedHashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashSet)));
}
function $asArrayOf_scm_LinkedHashSet(obj, depth) {
  return (($isArrayOf_scm_LinkedHashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashSet;", depth));
}
/** @constructor */
function $c_scm_Map$WithDefault(underlying, defaultValue) {
  this.scm_Map$WithDefault__f_underlying = null;
  this.scm_Map$WithDefault__f_defaultValue = null;
  this.scm_Map$WithDefault__f_underlying = underlying;
  this.scm_Map$WithDefault__f_defaultValue = defaultValue;
}
$c_scm_Map$WithDefault.prototype = new $h_scm_AbstractMap();
$c_scm_Map$WithDefault.prototype.constructor = $c_scm_Map$WithDefault;
/** @constructor */
function $h_scm_Map$WithDefault() {
}
$h_scm_Map$WithDefault.prototype = $c_scm_Map$WithDefault.prototype;
$c_scm_Map$WithDefault.prototype.default__O__O = (function(key) {
  return $n(this.scm_Map$WithDefault__f_defaultValue).apply__O__O(key);
});
$c_scm_Map$WithDefault.prototype.iterator__sc_Iterator = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).iterator__sc_Iterator();
});
$c_scm_Map$WithDefault.prototype.isEmpty__Z = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).isEmpty__Z();
});
$c_scm_Map$WithDefault.prototype.knownSize__I = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).knownSize__I();
});
$c_scm_Map$WithDefault.prototype.mapFactory__sc_MapFactory = (function() {
  return $n(this.scm_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory();
});
$c_scm_Map$WithDefault.prototype.get__O__s_Option = (function(key) {
  return $n(this.scm_Map$WithDefault__f_underlying).get__O__s_Option(key);
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Map$WithDefault = (function(elem) {
  $n(this.scm_Map$WithDefault__f_underlying).subtractOne__O__scm_Shrinkable(elem);
  return this;
});
$c_scm_Map$WithDefault.prototype.addOne__T2__scm_Map$WithDefault = (function(elem) {
  $n(this.scm_Map$WithDefault__f_underlying).addOne__O__scm_Growable(elem);
  return this;
});
$c_scm_Map$WithDefault.prototype.concat__sc_IterableOnce__scm_Map = (function(suffix) {
  var this$1 = $n($as_scm_Map($n(this.scm_Map$WithDefault__f_underlying).concat__sc_IterableOnce__sc_IterableOps(suffix)));
  var d = this.scm_Map$WithDefault__f_defaultValue;
  return new $c_scm_Map$WithDefault(this$1, d);
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__scm_Map$WithDefault = (function(coll) {
  return new $c_scm_Map$WithDefault($as_scm_Map($n($n(this.scm_Map$WithDefault__f_underlying).mapFactory__sc_MapFactory()).from__sc_IterableOnce__O(coll)), this.scm_Map$WithDefault__f_defaultValue);
});
$c_scm_Map$WithDefault.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$2 = $n($m_scm_Map$().newBuilder__scm_Builder());
  var f = new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((p$2$2) => {
    var p$2 = $as_scm_Map(p$2$2);
    return new $c_scm_Map$WithDefault(p$2, this.scm_Map$WithDefault__f_defaultValue);
  }));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll);
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll);
});
$c_scm_Map$WithDefault.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__scm_Map(suffix);
});
$c_scm_Map$WithDefault.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_Map$WithDefault($as_T2(elem));
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_Map$WithDefault(elem);
});
var $d_scm_Map$WithDefault = new $TypeData().initClass($c_scm_Map$WithDefault, "scala.collection.mutable.Map$WithDefault", ({
  scm_Map$WithDefault: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  Ljava_io_Serializable: 1
}));
function $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq($thiz, that) {
  if ($f_sc_SeqOps__isEmpty__Z($thiz)) {
    return that;
  } else {
    var this$1 = $n(that);
    if ($f_sc_SeqOps__isEmpty__Z(this$1)) {
      return $thiz;
    } else {
      var thisIsObj = ($thiz.unsafeArray__O() instanceof $ac_O);
      var thatIsObj = ($n(that).unsafeArray__O() instanceof $ac_O);
      var mismatch = (thisIsObj !== thatIsObj);
      if (mismatch) {
        return null;
      } else if (thisIsObj) {
        var ax = $thiz.unsafeArray__O();
        var ay = $n(that).unsafeArray__O();
        var len = (($m_jl_reflect_Array$().getLength__O__I(ax) + $m_jl_reflect_Array$().getLength__O__I(ay)) | 0);
        var a = new $ac_O(len);
        var length = $m_jl_reflect_Array$().getLength__O__I(ax);
        $systemArraycopyFull($n(ax), 0, a, 0, length);
        var destPos = $m_jl_reflect_Array$().getLength__O__I(ax);
        var length$1 = $m_jl_reflect_Array$().getLength__O__I(ay);
        $systemArraycopyFull($n(ay), 0, a, destPos, length$1);
        return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a);
      } else {
        var ax$2 = $thiz.unsafeArray__O();
        var ay$2 = $n(that).unsafeArray__O();
        var len$2 = (($m_jl_reflect_Array$().getLength__O__I(ax$2) + $m_jl_reflect_Array$().getLength__O__I(ay$2)) | 0);
        var a$2 = $n($thiz.elemTag__s_reflect_ClassTag()).newArray__I__O(len$2);
        var length$2 = $m_jl_reflect_Array$().getLength__O__I(ax$2);
        $systemArraycopyFull($n(ax$2), 0, $n(a$2), 0, length$2);
        var destPos$1 = $m_jl_reflect_Array$().getLength__O__I(ax$2);
        var length$3 = $m_jl_reflect_Array$().getLength__O__I(ay$2);
        $systemArraycopyFull($n(ay$2), 0, $n(a$2), destPos$1, length$3);
        return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a$2);
      }
    }
  }
}
function $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq($thiz, suffix$1) {
  var k = $n(suffix$1).knownSize__I();
  if ((k === 0)) {
    return $thiz;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    if ((k >= 0)) {
      var xs = $thiz.unsafeArray__O();
      $m_jl_reflect_Array$().getLength__O__I(xs);
    }
    var xs$1 = $thiz.unsafeArray__O();
    var length = $m_jl_reflect_Array$().getLength__O__I(xs$1);
    var i = 0;
    while ((i < length)) {
      var elem = $m_sr_ScalaRunTime$().array_apply__O__I__O(xs$1, i);
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
      i = ((1 + i) | 0);
    }
    var it = $n(suffix$1).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var elem$1 = $n(it).next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems.push(unboxedElem$1);
    }
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(new $ac_O(jsElems));
  }
}
/** @constructor */
function $c_sci_ArraySeq() {
}
$c_sci_ArraySeq.prototype = new $h_sci_AbstractSeq();
$c_sci_ArraySeq.prototype.constructor = $c_sci_ArraySeq;
/** @constructor */
function $h_sci_ArraySeq() {
}
$h_sci_ArraySeq.prototype = $c_sci_ArraySeq.prototype;
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5);
});
$c_sci_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$12 = this.elemTag__s_reflect_ClassTag();
  return this$1.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12);
});
$c_sci_ArraySeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_ArraySeq.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_ArraySeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_ArraySeq.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_ArraySeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_ArraySeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sci_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sci_ArraySeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sci_ArraySeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sci_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged;
});
$c_sci_ArraySeq.prototype.map__F1__sci_ArraySeq = (function(f) {
  var a = new $ac_O(this.length__I());
  var i = 0;
  while ((i < a.u.length)) {
    a.set(i, $n(f).apply__O__O(this.apply__I__O(i)));
    i = ((1 + i) | 0);
  }
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a);
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__sci_ArraySeq = (function(suffix) {
  if ((suffix instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(suffix);
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq(this, x2);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix) : result);
  } else {
    return $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix);
  }
});
$c_sci_ArraySeq.prototype.take__I__sci_ArraySeq = (function(n) {
  var xs = this.unsafeArray__O();
  if (($m_jl_reflect_Array$().getLength__O__I(xs) <= n)) {
    return this;
  } else {
    var $x_1 = $m_sci_ArraySeq$();
    var this$ = this.unsafeArray__O();
    return $x_1.unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, n));
  }
});
$c_sci_ArraySeq.prototype.drop__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().drop$extension__O__I__O(this.unsafeArray__O(), n)));
});
$c_sci_ArraySeq.prototype.dropRight__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().dropRight$extension__O__I__O(this.unsafeArray__O(), n)));
});
$c_sci_ArraySeq.prototype.foldLeft__O__F2__O = (function(z, f) {
  var array = this.unsafeArray__O();
  var b = z;
  var i = 0;
  while ((i < $m_jl_reflect_Array$().getLength__O__I(array))) {
    var a = $m_sr_ScalaRunTime$().array_apply__O__I__O(array, i);
    b = $n(f).apply__O__O__O(b, a);
    i = ((1 + i) | 0);
  }
  return b;
});
$c_sci_ArraySeq.prototype.tail__sci_ArraySeq = (function() {
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().tail$extension__O__O(this.unsafeArray__O()));
});
$c_sci_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq";
});
$c_sci_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.unsafeArray__O(), 0, xs, start, copied);
  }
  return copied;
});
$c_sci_ArraySeq.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647;
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  var xs = this.unsafeArray__O();
  if (($m_jl_reflect_Array$().getLength__O__I(xs) <= 1)) {
    return this;
  } else {
    var original = this.unsafeArray__O();
    var newLength = this.length__I();
    var this$3 = $n(original);
    var this$4 = $n($objectGetClass(this$3));
    var that = this$4.data.getComponentType();
    if ($d_O.isAssignableFrom($n(that).data)) {
      var original$1 = $asArrayOf_O(original, 1);
      var a = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, $d_O.getArrayOf().getClassOf());
    } else {
      var dest = new $ac_O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(original));
      var a = dest;
    }
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5);
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq.prototype.tail__O = (function() {
  return this.tail__sci_ArraySeq();
});
$c_sci_ArraySeq.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_ArraySeq(n);
});
$c_sci_ArraySeq.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_ArraySeq(n);
});
$c_sci_ArraySeq.prototype.take__I__O = (function(n) {
  return this.take__I__sci_ArraySeq(n);
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_ArraySeq(suffix);
});
$c_sci_ArraySeq.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_ArraySeq(f);
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged;
});
function $as_sci_ArraySeq(obj) {
  return (((obj instanceof $c_sci_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq"));
}
function $isArrayOf_sci_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq)));
}
function $asArrayOf_sci_ArraySeq(obj, depth) {
  return (($isArrayOf_sci_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq;", depth));
}
/** @constructor */
function $c_sci_NumericRange$Exclusive(start, end, step, num) {
  this.sci_NumericRange__f_length = 0;
  this.sci_NumericRange__f_isEmpty = false;
  this.sci_NumericRange__f_hashCode = 0;
  this.sci_NumericRange__f_start = null;
  this.sci_NumericRange__f_end = null;
  this.sci_NumericRange__f_step = null;
  this.sci_NumericRange__f_isInclusive = false;
  this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = null;
  this.sci_NumericRange__f_bitmap$0 = 0;
  this.sci_NumericRange$Exclusive__f_num = null;
  this.sci_NumericRange$Exclusive__f_num = num;
  $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(this, start, end, step, false, num);
}
$c_sci_NumericRange$Exclusive.prototype = new $h_sci_NumericRange();
$c_sci_NumericRange$Exclusive.prototype.constructor = $c_sci_NumericRange$Exclusive;
/** @constructor */
function $h_sci_NumericRange$Exclusive() {
}
$h_sci_NumericRange$Exclusive.prototype = $c_sci_NumericRange$Exclusive.prototype;
$c_sci_NumericRange$Exclusive.prototype.copy__O__O__O__sci_NumericRange$Exclusive = (function(start, end, step) {
  $m_sci_NumericRange$();
  var num = this.sci_NumericRange$Exclusive__f_num;
  return new $c_sci_NumericRange$Exclusive(start, end, step, num);
});
$c_sci_NumericRange$Exclusive.prototype.copy__O__O__O__sci_NumericRange = (function(start, end, step) {
  return this.copy__O__O__O__sci_NumericRange$Exclusive(start, end, step);
});
var $d_sci_NumericRange$Exclusive = new $TypeData().initClass($c_sci_NumericRange$Exclusive, "scala.collection.immutable.NumericRange$Exclusive", ({
  sci_NumericRange$Exclusive: 1,
  sci_NumericRange: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_NumericRange$Inclusive(start, end, step, num) {
  this.sci_NumericRange__f_length = 0;
  this.sci_NumericRange__f_isEmpty = false;
  this.sci_NumericRange__f_hashCode = 0;
  this.sci_NumericRange__f_start = null;
  this.sci_NumericRange__f_end = null;
  this.sci_NumericRange__f_step = null;
  this.sci_NumericRange__f_isInclusive = false;
  this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = null;
  this.sci_NumericRange__f_bitmap$0 = 0;
  this.sci_NumericRange$Inclusive__f_num = null;
  this.sci_NumericRange$Inclusive__f_num = num;
  $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(this, start, end, step, true, num);
}
$c_sci_NumericRange$Inclusive.prototype = new $h_sci_NumericRange();
$c_sci_NumericRange$Inclusive.prototype.constructor = $c_sci_NumericRange$Inclusive;
/** @constructor */
function $h_sci_NumericRange$Inclusive() {
}
$h_sci_NumericRange$Inclusive.prototype = $c_sci_NumericRange$Inclusive.prototype;
$c_sci_NumericRange$Inclusive.prototype.copy__O__O__O__sci_NumericRange$Inclusive = (function(start, end, step) {
  $m_sci_NumericRange$();
  var num = this.sci_NumericRange$Inclusive__f_num;
  return new $c_sci_NumericRange$Inclusive(start, end, step, num);
});
$c_sci_NumericRange$Inclusive.prototype.copy__O__O__O__sci_NumericRange = (function(start, end, step) {
  return this.copy__O__O__O__sci_NumericRange$Inclusive(start, end, step);
});
var $d_sci_NumericRange$Inclusive = new $TypeData().initClass($c_sci_NumericRange$Inclusive, "scala.collection.immutable.NumericRange$Inclusive", ({
  sci_NumericRange$Inclusive: 1,
  sci_NumericRange: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sci_Vector__AO__($thiz, prefix1) {
  $thiz.sci_Vector__f_prefix1 = prefix1;
  return $thiz;
}
/** @constructor */
function $c_sci_Vector() {
  this.sci_Vector__f_prefix1 = null;
}
$c_sci_Vector.prototype = new $h_sci_AbstractSeq();
$c_sci_Vector.prototype.constructor = $c_sci_Vector;
/** @constructor */
function $h_sci_Vector() {
}
$h_sci_Vector.prototype = $c_sci_Vector.prototype;
$c_sci_Vector.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_Vector.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Vector.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Vector.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Vector(pred, false);
});
$c_sci_Vector.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_Vector.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_Vector.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sci_Vector.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_Vector.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_Vector.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sci_Vector.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_Vector.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_Vector.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Vector$();
});
$c_sci_Vector.prototype.length__I = (function() {
  return ((this instanceof $c_sci_BigVector) ? $n($as_sci_BigVector(this)).sci_BigVector__f_length0 : $n(this.sci_Vector__f_prefix1).u.length);
});
$c_sci_Vector.prototype.iterator__sc_Iterator = (function() {
  return (($m_sci_Vector0$() === this) ? $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator : new $c_sci_NewVectorIterator(this, this.length__I(), this.vectorSliceCount__I()));
});
$c_sci_Vector.prototype.filterImpl__F1__Z__sci_Vector = (function(pred, isFlipped) {
  var i = 0;
  var len = $n(this.sci_Vector__f_prefix1).u.length;
  while ((i !== len)) {
    if (($uZ($n(pred).apply__O__O($n(this.sci_Vector__f_prefix1).get(i))) === isFlipped)) {
      var bitmap = 0;
      var j = ((1 + i) | 0);
      while ((j < len)) {
        if (($uZ($n(pred).apply__O__O($n(this.sci_Vector__f_prefix1).get(j))) !== isFlipped)) {
          bitmap = (bitmap | (1 << j));
        }
        j = ((1 + j) | 0);
      }
      var $x_1 = i;
      var i$1 = bitmap;
      var newLen = (($x_1 + $m_jl_Integer$().bitCount__I__I(i$1)) | 0);
      if ((this instanceof $c_sci_BigVector)) {
        var b = new $c_sci_VectorBuilder();
        var k = 0;
        while ((k < i)) {
          b.addOne__O__sci_VectorBuilder($n(this.sci_Vector__f_prefix1).get(k));
          k = ((1 + k) | 0);
        }
        k = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k) & bitmap) !== 0)) {
            b.addOne__O__sci_VectorBuilder($n(this.sci_Vector__f_prefix1).get(k));
            i = ((1 + i) | 0);
          }
          k = ((1 + k) | 0);
        }
        $n($as_sci_BigVector(this)).foreachRest__F1__V(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pred, isFlipped, b) => ((v$2$2) => (($uZ($n(pred).apply__O__O(v$2$2)) !== isFlipped) ? b.addOne__O__sci_VectorBuilder(v$2$2) : (void 0))))(pred, isFlipped, b)));
        return b.result__sci_Vector();
      } else {
        if ((newLen === 0)) {
          return $m_sci_Vector0$();
        }
        var newData = new $ac_O(newLen);
        var src = this.sci_Vector__f_prefix1;
        var length = i;
        $systemArraycopyRefs($n(src), 0, newData, 0, length);
        var k$2 = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k$2) & bitmap) !== 0)) {
            newData.set(i, $n(this.sci_Vector__f_prefix1).get(k$2));
            i = ((1 + i) | 0);
          }
          k$2 = ((1 + k$2) | 0);
        }
        return new $c_sci_Vector1(newData);
      }
    }
    i = ((1 + i) | 0);
  }
  if ((this instanceof $c_sci_BigVector)) {
    var b$2 = new $c_sci_VectorBuilder();
    b$2.initFrom__AO__V(this.sci_Vector__f_prefix1);
    $n($as_sci_BigVector(this)).foreachRest__F1__V(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$2$2$1) => (($uZ($n(pred).apply__O__O(v$2$2$1)) !== isFlipped) ? b$2.addOne__O__sci_VectorBuilder(v$2$2$1) : (void 0)))));
    return b$2.result__sci_Vector();
  } else {
    return this;
  }
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__sci_Vector = (function(suffix) {
  var k = $n(suffix).knownSize__I();
  return ((k === 0) ? this : ((k < 0) ? $as_sci_Vector($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)) : this.appendedAll0__sc_IterableOnce__I__sci_Vector(suffix, k)));
});
$c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var tinyAppendLimit = ((4 + this.vectorSliceCount__I()) | 0);
  if ((k < tinyAppendLimit)) {
    var v = new $c_sr_ObjectRef(this);
    if ($is_sci_Iterable(suffix)) {
      var x2 = $as_sci_Iterable(suffix);
      $n(x2).foreach__F1__V(new $c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$2$2) => {
        v.sr_ObjectRef__f_elem = $n($as_sci_Vector(v.sr_ObjectRef__f_elem)).appended__O__sci_Vector(x$2$2);
      })));
    } else {
      var this$2 = $n($n(suffix).iterator__sc_Iterator());
      while (this$2.hasNext__Z()) {
        var x0 = this$2.next__O();
        v.sr_ObjectRef__f_elem = $n($as_sci_Vector(v.sr_ObjectRef__f_elem)).appended__O__sci_Vector(x0);
      }
    }
    return $as_sci_Vector(v.sr_ObjectRef__f_elem);
  } else if (((this.length__I() < ((k >>> 5) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$2 = $as_sci_Vector(suffix);
    var this$3 = new $c_sc_IndexedSeqView$Id(this);
    var ri = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$3);
    while ((ri.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
      v$2 = $n(v$2).prepended__O__sci_Vector(ri.next__O());
    }
    return v$2;
  } else if (((this.length__I() < ((k - 64) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$3 = $as_sci_Vector(suffix);
    return $n($n($n(new $c_sci_VectorBuilder().alignTo__I__sci_Vector__sci_VectorBuilder(this.length__I(), v$3)).addAll__sc_IterableOnce__sci_VectorBuilder(this)).addAll__sc_IterableOnce__sci_VectorBuilder(v$3)).result__sci_Vector();
  } else {
    return $n($n(new $c_sci_VectorBuilder().initFrom__sci_Vector__sci_VectorBuilder(this)).addAll__sc_IterableOnce__sci_VectorBuilder(suffix)).result__sci_Vector();
  }
});
$c_sci_Vector.prototype.className__T = (function() {
  return "Vector";
});
$c_sci_Vector.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $n(this.iterator__sc_Iterator()).copyToArray__O__I__I__I(xs, start, len);
});
$c_sci_Vector.prototype.toVector__sci_Vector = (function() {
  return this;
});
$c_sci_Vector.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength;
});
$c_sci_Vector.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, ((this.length__I() - 1) | 0));
});
$c_sci_Vector.prototype.head__O = (function() {
  if (($n(this.sci_Vector__f_prefix1).u.length === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.head");
  } else {
    return $n(this.sci_Vector__f_prefix1).get(0);
  }
});
$c_sci_Vector.prototype.last__O = (function() {
  if ((this instanceof $c_sci_BigVector)) {
    var suffix = $n($as_sci_BigVector(this)).sci_BigVector__f_suffix1;
    if (($n(suffix).u.length === 0)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.tail");
    } else {
      return $n(suffix).get((($n(suffix).u.length - 1) | 0));
    }
  } else {
    return $n(this.sci_Vector__f_prefix1).get((($n(this.sci_Vector__f_prefix1).u.length - 1) | 0));
  }
});
$c_sci_Vector.prototype.foreach__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 0;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = (((c + ((c >>> 31) | 0)) | 0) >> 1);
    var a = ((idx - c$1) | 0);
    var sign = (a >> 31);
    $x_1.foreachRec__I__AO__F1__V(((((((1 + c$1) | 0) - (((a ^ sign) - sign) | 0)) | 0) - 1) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0);
  }
});
$c_sci_Vector.prototype.dropRight__I__O = (function(n) {
  var until = ((this.length__I() - ((n > 0) ? n : 0)) | 0);
  return this.slice__I__I__sci_Vector(0, until);
});
$c_sci_Vector.prototype.drop__I__O = (function(n) {
  var until = this.length__I();
  return this.slice__I__I__sci_Vector(n, until);
});
$c_sci_Vector.prototype.take__I__O = (function(n) {
  return this.slice__I__I__sci_Vector(0, n);
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Vector(suffix);
});
$c_sci_Vector.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Vector$();
});
function $as_sci_Vector(obj) {
  return (((obj instanceof $c_sci_Vector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector"));
}
function $isArrayOf_sci_Vector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector)));
}
function $asArrayOf_sci_Vector(obj, depth) {
  return (($isArrayOf_sci_Vector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector;", depth));
}
/** @constructor */
function $c_scm_ArraySeq() {
}
$c_scm_ArraySeq.prototype = new $h_scm_AbstractSeq();
$c_scm_ArraySeq.prototype.constructor = $c_scm_ArraySeq;
/** @constructor */
function $h_scm_ArraySeq() {
}
$h_scm_ArraySeq.prototype = $c_scm_ArraySeq.prototype;
$c_scm_ArraySeq.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ArraySeq.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_scm_ArraySeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ArraySeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_scm_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_scm_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_scm_ArraySeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_ArraySeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_ArraySeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged;
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__scm_ArraySeq = (function(coll) {
  var evidence$1 = this.elemTag__s_reflect_ClassTag();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = $n(evidence$1).runtimeClass__jl_Class();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  jsElems = [];
  $n(coll).knownSize__I();
  var it = $n(coll).iterator__sc_Iterator();
  while ($n(it).hasNext__Z()) {
    var elem = $n(it).next__O();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? $n(elementClass).data.zero : elem));
    jsElems.push(unboxedElem);
  }
  var $x_1 = $m_scm_ArraySeq$();
  var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
  return $x_1.make__O__scm_ArraySeq($n(elemRuntimeClass).data.getArrayOf().wrapArray(jsElems));
});
$c_scm_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_scm_ArraySeq$().newBuilder__s_reflect_ClassTag__scm_Builder(this.elemTag__s_reflect_ClassTag());
});
$c_scm_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq";
});
$c_scm_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.array__O(), 0, xs, start, copied);
  }
  return copied;
});
$c_scm_ArraySeq.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_scm_ArraySeq)) {
    var x2 = $as_scm_ArraySeq(other);
    var xs = this.array__O();
    var $x_1 = $m_jl_reflect_Array$().getLength__O__I(xs);
    var xs$1 = $n(x2).array__O();
    if (($x_1 !== $m_jl_reflect_Array$().getLength__O__I(xs$1))) {
      return false;
    }
  }
  return $f_sc_Seq__equals__O__Z(this, other);
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__scm_ArraySeq = (function(ord) {
  var $x_2 = $m_scm_ArraySeq$();
  var $x_1 = $m_sc_ArrayOps$();
  var xs = this.array__O();
  return $x_2.make__O__scm_ArraySeq($x_1.sorted$extension__O__s_math_Ordering__O(xs, ord));
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__scm_ArraySeq(ord);
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll);
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll);
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged;
});
function $as_scm_ArraySeq(obj) {
  return (((obj instanceof $c_scm_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq"));
}
function $isArrayOf_scm_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq)));
}
function $asArrayOf_scm_ArraySeq(obj, depth) {
  return (($isArrayOf_scm_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq;", depth));
}
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances$$anon$2() {
  this.Lcats_NonEmptyReducible__f_G = null;
  $ct_Lcats_NonEmptyReducible__Lcats_Foldable__(this, ($m_Lcats_UnorderedFoldable$(), $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList)));
}
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype = new $h_Lcats_NonEmptyReducible();
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.constructor = $c_Lcats_data_NonEmptyListInstances$$anon$2;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances$$anon$2() {
}
$h_Lcats_data_NonEmptyListInstances$$anon$2.prototype = $c_Lcats_data_NonEmptyListInstances$$anon$2.prototype;
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).map__F1__Lcats_data_NonEmptyList(f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.unit__O = (function() {
  $m_Lcats_data_NonEmptyList$();
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_sci_Nil$();
  return new $c_Lcats_data_NonEmptyList((void 0), tail);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  var fa = $as_Lcats_data_NonEmptyList(sa);
  return $n(fa).traverse__F1__Lcats_Applicative__O(f, evidence$1);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldMap__Lcats_data_NonEmptyList__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var $x_1 = $n(B);
  var this$1 = $n(fa);
  var this$2 = $n(this$1.Lcats_data_NonEmptyList__f_tail);
  var elem = this$1.Lcats_data_NonEmptyList__f_head;
  var this$3 = new $c_sci_$colon$colon(elem, this$2);
  var this$4 = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
  return $x_1.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$4, f));
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.tailRecM__O__F1__Lcats_data_NonEmptyList = (function(a, f) {
  var buf = new $c_scm_ListBuffer();
  $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$2$$_$go$2__scm_ListBuffer__F1__Lcats_data_NonEmptyList__V(buf, f, $as_Lcats_data_NonEmptyList($n(f).apply__O__O(a)));
  return $m_Lcats_data_NonEmptyList$().fromListUnsafe__sci_List__Lcats_data_NonEmptyList(buf.toList__sci_List());
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).map__F1__Lcats_data_NonEmptyList(f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_NonEmptyList$();
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_sci_Nil$();
  return new $c_Lcats_data_NonEmptyList(x, tail);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).flatMap__F1__Lcats_data_NonEmptyList(f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).traverse__F1__Lcats_Applicative__O(f, evidence$1);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return $n(fa$1).foldRight__Lcats_Eval__F2__Lcats_Eval(lb, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__Lcats_data_NonEmptyList__F1__Lcats_kernel_Monoid__O($as_Lcats_data_NonEmptyList(fa), f, B);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_NonEmptyList(a, f);
});
var $d_Lcats_data_NonEmptyListInstances$$anon$2 = new $TypeData().initClass($c_Lcats_data_NonEmptyListInstances$$anon$2, "cats.data.NonEmptyListInstances$$anon$2", ({
  Lcats_data_NonEmptyListInstances$$anon$2: 1,
  Lcats_NonEmptyReducible: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_Reducible: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_Lcats_effect_IO$IOAsync() {
  this.Lcats_effect_IO$IOAsync__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_IO$IOAsync__f_executionContext = null;
  this.Lcats_effect_IO$IOAsync__f_realTime = null;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
  this.Lcats_effect_IO$IOAsync__f_executionContext = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$());
  $m_Lcats_effect_IO$();
  this.Lcats_effect_IO$IOAsync__f_realTime = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$RealTime$());
}
$c_Lcats_effect_IO$IOAsync.prototype = new $h_O();
$c_Lcats_effect_IO$IOAsync.prototype.constructor = $c_Lcats_effect_IO$IOAsync;
/** @constructor */
function $h_Lcats_effect_IO$IOAsync() {
}
$h_Lcats_effect_IO$IOAsync.prototype = $c_Lcats_effect_IO$IOAsync.prototype;
$c_Lcats_effect_IO$IOAsync.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).map__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_IO$IOAsync.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_IO$IOAsync.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_IO$IOAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_IO$IOAsync__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_IO$IOAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
});
$c_Lcats_effect_IO$IOAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_IO$IOAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_IO$IOAsync.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Sync__unique__O(this);
});
$c_Lcats_effect_IO$IOAsync.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  return $f_Lcats_effect_kernel_GenSpawn__raceOutcome__O__O__O(this, fa, fb);
});
$c_Lcats_effect_IO$IOAsync.prototype.both__O__O__O = (function(fa, fb) {
  return $f_Lcats_effect_kernel_GenSpawn__both__O__O__O(this, fa, fb);
});
$c_Lcats_effect_IO$IOAsync.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_Async__never__O(this);
});
$c_Lcats_effect_IO$IOAsync.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_effect_IO$IOAsync.prototype.map2Eval__Lcats_effect_IO__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, fn) {
  $m_Lcats_Eval$();
  var a$1 = $n(fa).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((a) => $n($as_Lcats_effect_IO($n(fb).value__O())).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((b) => $n(fn).apply__O__O__O(a, b)))))));
  return new $c_Lcats_Now(a$1);
});
$c_Lcats_effect_IO$IOAsync.prototype.asyncCheckAttempt__F1__O = (function(k) {
  return $m_Lcats_effect_IO$().asyncCheckAttempt__F1__Lcats_effect_IO(k);
});
$c_Lcats_effect_IO$IOAsync.prototype.async__F1__O = (function(k) {
  return $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(k);
});
$c_Lcats_effect_IO$IOAsync.prototype.async___F1__O = (function(k) {
  return $m_Lcats_effect_IO$().async___F1__Lcats_effect_IO(k);
});
$c_Lcats_effect_IO$IOAsync.prototype.as__O__O__O = (function(fa, b) {
  var ioa = $as_Lcats_effect_IO(fa);
  return $n(ioa).as__O__Lcats_effect_IO(b);
});
$c_Lcats_effect_IO$IOAsync.prototype.attempt__O__O = (function(fa) {
  var ioa = $as_Lcats_effect_IO(fa);
  var this$1 = $n(ioa);
  return new $c_Lcats_effect_IO$Attempt(this$1);
});
$c_Lcats_effect_IO$IOAsync.prototype.forceR__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  return $n(left).forceR__Lcats_effect_IO__Lcats_effect_IO(right);
});
$c_Lcats_effect_IO$IOAsync.prototype.pure__O__O = (function(x) {
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Pure(x);
});
$c_Lcats_effect_IO$IOAsync.prototype.unit__O = (function() {
  return $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
});
$c_Lcats_effect_IO$IOAsync.prototype.guarantee__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  var fin$1 = $as_Lcats_effect_IO(fin);
  return $n(fa$1).guarantee__Lcats_effect_IO__Lcats_effect_IO(fin$1);
});
$c_Lcats_effect_IO$IOAsync.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).guaranteeCase__F1__Lcats_effect_IO(fin);
});
$c_Lcats_effect_IO$IOAsync.prototype.handleError__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).handleError__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).onError__s_PartialFunction__Lcats_effect_IO(pf);
});
$c_Lcats_effect_IO$IOAsync.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).handleErrorWith__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Error(e$1);
});
$c_Lcats_effect_IO$IOAsync.prototype.cont__Lcats_effect_kernel_Cont__O = (function(body) {
  return $m_Lcats_effect_IO$().cont__Lcats_effect_kernel_Cont__Lcats_effect_IO(body);
});
$c_Lcats_effect_IO$IOAsync.prototype.executionContext__O = (function() {
  return this.Lcats_effect_IO$IOAsync__f_executionContext;
});
$c_Lcats_effect_IO$IOAsync.prototype.onCancel__O__O__O = (function(fa, fin) {
  var ioa = $as_Lcats_effect_IO(fa);
  var fin$1 = $as_Lcats_effect_IO(fin);
  var this$1 = $n(ioa);
  return new $c_Lcats_effect_IO$OnCancel(this$1, fin$1);
});
$c_Lcats_effect_IO$IOAsync.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $m_Lcats_effect_IO$().bracketFull__F1__F1__F2__Lcats_effect_IO(acquire, use, release);
});
$c_Lcats_effect_IO$IOAsync.prototype.realTime__O = (function() {
  return this.Lcats_effect_IO$IOAsync__f_realTime;
});
$c_Lcats_effect_IO$IOAsync.prototype.canceled__O = (function() {
  $m_Lcats_effect_IO$();
  return $m_Lcats_effect_IO$Canceled$();
});
$c_Lcats_effect_IO$IOAsync.prototype.cede__O = (function() {
  $m_Lcats_effect_IO$();
  return $m_Lcats_effect_IO$Cede$();
});
$c_Lcats_effect_IO$IOAsync.prototype.productL__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  return $n(left).productL__Lcats_effect_IO__Lcats_effect_IO(right);
});
$c_Lcats_effect_IO$IOAsync.prototype.productR__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  return $n(left).productR__Lcats_effect_IO__Lcats_effect_IO(right);
});
$c_Lcats_effect_IO$IOAsync.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  var this$1 = $n(fa$1);
  return new $c_Lcats_effect_IO$Start(this$1);
});
$c_Lcats_effect_IO$IOAsync.prototype.racePair__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$RacePair(left, right);
});
$c_Lcats_effect_IO$IOAsync.prototype.uncancelable__F1__O = (function(body) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(body);
});
$c_Lcats_effect_IO$IOAsync.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).map__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).flatMap__F1__Lcats_effect_IO(f);
});
$c_Lcats_effect_IO$IOAsync.prototype.delay__F0__O = (function(thunk) {
  var this$1 = $m_Lcats_effect_IO$();
  return this$1.delay__F0__Lcats_effect_IO(thunk);
});
$c_Lcats_effect_IO$IOAsync.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $m_Lcats_effect_IO$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_IO(hint, thunk);
});
$c_Lcats_effect_IO$IOAsync.prototype.void__O__O = (function(fa) {
  var ioa = $as_Lcats_effect_IO(fa);
  return $n(ioa).void__Lcats_effect_IO();
});
$c_Lcats_effect_IO$IOAsync.prototype.redeemWith__O__F1__F1__O = (function(fa, recover, bind) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return $n(fa$1).redeemWith__F1__F1__Lcats_effect_IO(recover, bind);
});
$c_Lcats_effect_IO$IOAsync.prototype.ref__O__O = (function(a) {
  return $m_Lcats_effect_IO$().ref__O__Lcats_effect_IO(a);
});
$c_Lcats_effect_IO$IOAsync.prototype.deferred__O = (function() {
  return $m_Lcats_effect_IO$().deferred__Lcats_effect_IO();
});
$c_Lcats_effect_IO$IOAsync.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__Lcats_effect_IO__Lcats_Eval__F2__Lcats_Eval($as_Lcats_effect_IO(fa), fb, f);
});
var $d_Lcats_effect_IO$IOAsync = new $TypeData().initClass($c_Lcats_effect_IO$IOAsync, "cats.effect.IO$IOAsync", ({
  Lcats_effect_IO$IOAsync: 1,
  Lcats_effect_kernel_AsyncPlatform: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_Async: 1,
  Lcats_StackSafeMonad: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_GenTemporal$$anon$3(F0$8) {
  this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3 = null;
  this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3 = F0$8;
}
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype = new $h_O();
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_GenTemporal$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_GenTemporal$$anon$3() {
}
$h_Lcats_effect_kernel_GenTemporal$$anon$3.prototype = $c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype;
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.C__Lcats_effect_kernel_Clock = (function() {
  return this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.F__Lcats_effect_kernel_GenSpawn = (function() {
  return this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.realTime__O = (function() {
  return $f_Lcats_effect_kernel_Clock$KleisliClock__realTime__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.ref__O__O = (function(a) {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__ref__O__Lcats_data_Kleisli(this, a);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.deferred__O = (function() {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__deferred__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.racePair__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__unique__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__never__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.cede__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_GenTemporal$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_GenTemporal$$anon$3__f_F0$3;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
var $d_Lcats_effect_kernel_GenTemporal$$anon$3 = new $TypeData().initClass($c_Lcats_effect_kernel_GenTemporal$$anon$3, "cats.effect.kernel.GenTemporal$$anon$3", ({
  Lcats_effect_kernel_GenTemporal$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent: 1,
  Lcats_effect_kernel_Clock$KleisliClock: 1,
  Lcats_effect_kernel_GenTemporal$KleisliTemporal: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofBoolean(unsafeArray) {
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = null;
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofBoolean.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofBoolean.prototype.constructor = $c_sci_ArraySeq$ofBoolean;
/** @constructor */
function $h_sci_ArraySeq$ofBoolean() {
}
$h_sci_ArraySeq$ofBoolean.prototype = $c_sci_ArraySeq$ofBoolean.prototype;
$c_sci_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofBoolean__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofBoolean)) {
    var x2 = $as_sci_ArraySeq$ofBoolean(that);
    var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofBoolean__f_unsafeArray;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if (($n(this.sci_ArraySeq$ofBoolean__f_unsafeArray).u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Boolean$())) {
    var this$1 = $n(this.sci_ArraySeq$ofBoolean__f_unsafeArray);
    var a = this$1.clone__O();
    var this$2 = $m_s_util_Sorting$();
    var evidence$3 = $m_s_math_Ordering$Boolean$();
    this$2.stableSort__O__I__I__s_math_Ordering__V(a, 0, a.u.length, evidence$3);
    return new $c_sci_ArraySeq$ofBoolean(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.sci_ArraySeq$ofBoolean__f_unsafeArray);
});
$c_sci_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(i) {
  return $n(this.sci_ArraySeq$ofBoolean__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcZI$sp__I__Z(i);
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i);
});
$c_sci_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$c_sci_ArraySeq$ofBoolean.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray;
});
function $as_sci_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofBoolean"));
}
function $isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofBoolean)));
}
function $asArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofBoolean;", depth));
}
var $d_sci_ArraySeq$ofBoolean = new $TypeData().initClass($c_sci_ArraySeq$ofBoolean, "scala.collection.immutable.ArraySeq$ofBoolean", ({
  sci_ArraySeq$ofBoolean: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofByte(unsafeArray) {
  this.sci_ArraySeq$ofByte__f_unsafeArray = null;
  this.sci_ArraySeq$ofByte__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofByte.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofByte.prototype.constructor = $c_sci_ArraySeq$ofByte;
/** @constructor */
function $h_sci_ArraySeq$ofByte() {
}
$h_sci_ArraySeq$ofByte.prototype = $c_sci_ArraySeq$ofByte.prototype;
$c_sci_ArraySeq$ofByte.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofByte__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__B = (function(i) {
  return $n(this.sci_ArraySeq$ofByte__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofByte)) {
    var x2 = $as_sci_ArraySeq$ofByte(that);
    var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofByte__f_unsafeArray;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if (($n(this.sci_ArraySeq$ofByte__f_unsafeArray).u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Byte$())) {
    var this$1 = $n(this.sci_ArraySeq$ofByte__f_unsafeArray);
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AB__V(a);
    return new $c_sci_ArraySeq$ofByte(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.sci_ArraySeq$ofByte__f_unsafeArray);
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1));
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i);
});
$c_sci_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$c_sci_ArraySeq$ofByte.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofByte__f_unsafeArray;
});
function $as_sci_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofByte"));
}
function $isArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofByte)));
}
function $asArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofByte;", depth));
}
var $d_sci_ArraySeq$ofByte = new $TypeData().initClass($c_sci_ArraySeq$ofByte, "scala.collection.immutable.ArraySeq$ofByte", ({
  sci_ArraySeq$ofByte: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofChar(unsafeArray) {
  this.sci_ArraySeq$ofChar__f_unsafeArray = null;
  this.sci_ArraySeq$ofChar__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofChar.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofChar.prototype.constructor = $c_sci_ArraySeq$ofChar;
/** @constructor */
function $h_sci_ArraySeq$ofChar() {
}
$h_sci_ArraySeq$ofChar.prototype = $c_sci_ArraySeq$ofChar.prototype;
$c_sci_ArraySeq$ofChar.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofChar__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__C = (function(i) {
  return $n(this.sci_ArraySeq$ofChar__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofChar)) {
    var x2 = $as_sci_ArraySeq$ofChar(that);
    var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofChar__f_unsafeArray;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if (($n(this.sci_ArraySeq$ofChar__f_unsafeArray).u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Char$())) {
    var this$1 = $n(this.sci_ArraySeq$ofChar__f_unsafeArray);
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AC__V(a);
    return new $c_sci_ArraySeq$ofChar(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.sci_ArraySeq$ofChar__f_unsafeArray);
});
$c_sci_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return new $c_scm_ArraySeq$ofChar(this.sci_ArraySeq$ofChar__f_unsafeArray).addString__scm_StringBuilder__T__T__T__scm_StringBuilder(sb, start, sep, end);
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)));
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i));
});
$c_sci_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$c_sci_ArraySeq$ofChar.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofChar__f_unsafeArray;
});
function $as_sci_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofChar"));
}
function $isArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofChar)));
}
function $asArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofChar;", depth));
}
var $d_sci_ArraySeq$ofChar = new $TypeData().initClass($c_sci_ArraySeq$ofChar, "scala.collection.immutable.ArraySeq$ofChar", ({
  sci_ArraySeq$ofChar: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofDouble(unsafeArray) {
  this.sci_ArraySeq$ofDouble__f_unsafeArray = null;
  this.sci_ArraySeq$ofDouble__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofDouble.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofDouble.prototype.constructor = $c_sci_ArraySeq$ofDouble;
/** @constructor */
function $h_sci_ArraySeq$ofDouble() {
}
$h_sci_ArraySeq$ofDouble.prototype = $c_sci_ArraySeq$ofDouble.prototype;
$c_sci_ArraySeq$ofDouble.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofDouble__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofDouble)) {
    var x2 = $as_sci_ArraySeq$ofDouble(that);
    var array = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var thatArray = $n(x2).sci_ArraySeq$ofDouble__f_unsafeArray;
    if ((array === thatArray)) {
      return true;
    } else if (($n(array).u.length === $n(thatArray).u.length)) {
      var i = 0;
      while (((i < $n(array).u.length) && ($n(array).get(i) === $n(thatArray).get(i)))) {
        i = ((1 + i) | 0);
      }
      return (i >= $n(array).u.length);
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.sci_ArraySeq$ofDouble__f_unsafeArray);
});
$c_sci_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(i) {
  return $n(this.sci_ArraySeq$ofDouble__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcDI$sp__I__D(i);
});
$c_sci_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i);
});
$c_sci_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$c_sci_ArraySeq$ofDouble.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray;
});
function $as_sci_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofDouble"));
}
function $isArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofDouble)));
}
function $asArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofDouble;", depth));
}
var $d_sci_ArraySeq$ofDouble = new $TypeData().initClass($c_sci_ArraySeq$ofDouble, "scala.collection.immutable.ArraySeq$ofDouble", ({
  sci_ArraySeq$ofDouble: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofFloat(unsafeArray) {
  this.sci_ArraySeq$ofFloat__f_unsafeArray = null;
  this.sci_ArraySeq$ofFloat__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofFloat.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofFloat.prototype.constructor = $c_sci_ArraySeq$ofFloat;
/** @constructor */
function $h_sci_ArraySeq$ofFloat() {
}
$h_sci_ArraySeq$ofFloat.prototype = $c_sci_ArraySeq$ofFloat.prototype;
$c_sci_ArraySeq$ofFloat.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofFloat__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofFloat)) {
    var x2 = $as_sci_ArraySeq$ofFloat(that);
    var array = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var thatArray = $n(x2).sci_ArraySeq$ofFloat__f_unsafeArray;
    if ((array === thatArray)) {
      return true;
    } else if (($n(array).u.length === $n(thatArray).u.length)) {
      var i = 0;
      while (((i < $n(array).u.length) && ($n(array).get(i) === $n(thatArray).get(i)))) {
        i = ((1 + i) | 0);
      }
      return (i >= $n(array).u.length);
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.sci_ArraySeq$ofFloat__f_unsafeArray);
});
$c_sci_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(i) {
  return $n(this.sci_ArraySeq$ofFloat__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcFI$sp__I__F(i);
});
$c_sci_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i);
});
$c_sci_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$c_sci_ArraySeq$ofFloat.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray;
});
function $as_sci_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofFloat"));
}
function $isArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofFloat)));
}
function $asArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofFloat;", depth));
}
var $d_sci_ArraySeq$ofFloat = new $TypeData().initClass($c_sci_ArraySeq$ofFloat, "scala.collection.immutable.ArraySeq$ofFloat", ({
  sci_ArraySeq$ofFloat: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofInt(unsafeArray) {
  this.sci_ArraySeq$ofInt__f_unsafeArray = null;
  this.sci_ArraySeq$ofInt__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofInt.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofInt.prototype.constructor = $c_sci_ArraySeq$ofInt;
/** @constructor */
function $h_sci_ArraySeq$ofInt() {
}
$h_sci_ArraySeq$ofInt.prototype = $c_sci_ArraySeq$ofInt.prototype;
$c_sci_ArraySeq$ofInt.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofInt__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofInt)) {
    var x2 = $as_sci_ArraySeq$ofInt(that);
    var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofInt__f_unsafeArray;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if (($n(this.sci_ArraySeq$ofInt__f_unsafeArray).u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Int$())) {
    var this$1 = $n(this.sci_ArraySeq$ofInt__f_unsafeArray);
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AI__V(a);
    return new $c_sci_ArraySeq$ofInt(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.sci_ArraySeq$ofInt__f_unsafeArray);
});
$c_sci_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(i) {
  return $n(this.sci_ArraySeq$ofInt__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcII$sp__I__I(i);
});
$c_sci_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i);
});
$c_sci_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$c_sci_ArraySeq$ofInt.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofInt__f_unsafeArray;
});
function $as_sci_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofInt"));
}
function $isArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofInt)));
}
function $asArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofInt;", depth));
}
var $d_sci_ArraySeq$ofInt = new $TypeData().initClass($c_sci_ArraySeq$ofInt, "scala.collection.immutable.ArraySeq$ofInt", ({
  sci_ArraySeq$ofInt: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofLong(unsafeArray) {
  this.sci_ArraySeq$ofLong__f_unsafeArray = null;
  this.sci_ArraySeq$ofLong__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofLong.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofLong.prototype.constructor = $c_sci_ArraySeq$ofLong;
/** @constructor */
function $h_sci_ArraySeq$ofLong() {
}
$h_sci_ArraySeq$ofLong.prototype = $c_sci_ArraySeq$ofLong.prototype;
$c_sci_ArraySeq$ofLong.prototype.length__I = (function() {
  return (($n(this.sci_ArraySeq$ofLong__f_unsafeArray).u.length >>> 1) | 0);
});
$c_sci_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofLong)) {
    var x2 = $as_sci_ArraySeq$ofLong(that);
    var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofLong__f_unsafeArray;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if (((($n(this.sci_ArraySeq$ofLong__f_unsafeArray).u.length >>> 1) | 0) <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Long$())) {
    var this$1 = $n(this.sci_ArraySeq$ofLong__f_unsafeArray);
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AJ__V(a);
    return new $c_sci_ArraySeq$ofLong(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.sci_ArraySeq$ofLong__f_unsafeArray);
});
$c_sci_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(i) {
  var $x_1 = $n(this.sci_ArraySeq$ofLong__f_unsafeArray).u;
  var $x_2 = $aJCheckGet($x_1, i);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcJI$sp__I__J(i);
});
$c_sci_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i);
});
$c_sci_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$c_sci_ArraySeq$ofLong.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofLong__f_unsafeArray;
});
function $as_sci_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofLong"));
}
function $isArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofLong)));
}
function $asArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofLong;", depth));
}
var $d_sci_ArraySeq$ofLong = new $TypeData().initClass($c_sci_ArraySeq$ofLong, "scala.collection.immutable.ArraySeq$ofLong", ({
  sci_ArraySeq$ofLong: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofRef(unsafeArray) {
  this.sci_ArraySeq$ofRef__f_unsafeArray = null;
  this.sci_ArraySeq$ofRef__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofRef.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofRef.prototype.constructor = $c_sci_ArraySeq$ofRef;
/** @constructor */
function $h_sci_ArraySeq$ofRef() {
}
$h_sci_ArraySeq$ofRef.prototype = $c_sci_ArraySeq$ofRef.prototype;
$c_sci_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $x_1 = $m_s_reflect_ClassTag$();
  var this$1 = $n(this.sci_ArraySeq$ofRef__f_unsafeArray);
  var this$2 = $objectGetClass(this$1);
  return $x_1.apply__jl_Class__s_reflect_ClassTag(this$2.data.getComponentType());
});
$c_sci_ArraySeq$ofRef.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofRef__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofRef.prototype.apply__I__O = (function(i) {
  return $n(this.sci_ArraySeq$ofRef__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofRef__f_unsafeArray;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofRef)) {
    var x2 = $as_sci_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.sci_ArraySeq$ofRef__f_unsafeArray, $n(x2).sci_ArraySeq$ofRef__f_unsafeArray);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq$ofRef = (function(ord) {
  if (($n(this.sci_ArraySeq$ofRef__f_unsafeArray).u.length <= 1)) {
    return this;
  } else {
    var this$1 = $n(this.sci_ArraySeq$ofRef__f_unsafeArray);
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$c_sci_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.sci_ArraySeq$ofRef__f_unsafeArray);
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord);
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord);
});
$c_sci_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_sci_ArraySeq$ofRef.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofRef__f_unsafeArray;
});
function $as_sci_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofRef"));
}
function $isArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofRef)));
}
function $asArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofRef;", depth));
}
var $d_sci_ArraySeq$ofRef = new $TypeData().initClass($c_sci_ArraySeq$ofRef, "scala.collection.immutable.ArraySeq$ofRef", ({
  sci_ArraySeq$ofRef: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofShort(unsafeArray) {
  this.sci_ArraySeq$ofShort__f_unsafeArray = null;
  this.sci_ArraySeq$ofShort__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofShort.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofShort.prototype.constructor = $c_sci_ArraySeq$ofShort;
/** @constructor */
function $h_sci_ArraySeq$ofShort() {
}
$h_sci_ArraySeq$ofShort.prototype = $c_sci_ArraySeq$ofShort.prototype;
$c_sci_ArraySeq$ofShort.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofShort__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__S = (function(i) {
  return $n(this.sci_ArraySeq$ofShort__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofShort)) {
    var x2 = $as_sci_ArraySeq$ofShort(that);
    var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var b = $n(x2).sci_ArraySeq$ofShort__f_unsafeArray;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if (($n(this.sci_ArraySeq$ofShort__f_unsafeArray).u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Short$())) {
    var this$1 = $n(this.sci_ArraySeq$ofShort__f_unsafeArray);
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AS__V(a);
    return new $c_sci_ArraySeq$ofShort(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.sci_ArraySeq$ofShort__f_unsafeArray);
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1));
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i);
});
$c_sci_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$c_sci_ArraySeq$ofShort.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofShort__f_unsafeArray;
});
function $as_sci_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofShort"));
}
function $isArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofShort)));
}
function $asArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofShort;", depth));
}
var $d_sci_ArraySeq$ofShort = new $TypeData().initClass($c_sci_ArraySeq$ofShort, "scala.collection.immutable.ArraySeq$ofShort", ({
  sci_ArraySeq$ofShort: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_ArraySeq$ofUnit(unsafeArray) {
  this.sci_ArraySeq$ofUnit__f_unsafeArray = null;
  this.sci_ArraySeq$ofUnit__f_unsafeArray = unsafeArray;
}
$c_sci_ArraySeq$ofUnit.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofUnit.prototype.constructor = $c_sci_ArraySeq$ofUnit;
/** @constructor */
function $h_sci_ArraySeq$ofUnit() {
}
$h_sci_ArraySeq$ofUnit.prototype = $c_sci_ArraySeq$ofUnit.prototype;
$c_sci_ArraySeq$ofUnit.prototype.length__I = (function() {
  return $n(this.sci_ArraySeq$ofUnit__f_unsafeArray).u.length;
});
$c_sci_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofUnit__f_unsafeArray;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofUnit)) {
    var x2 = $as_sci_ArraySeq$ofUnit(that);
    return ($n(this.sci_ArraySeq$ofUnit__f_unsafeArray).u.length === $n($n(x2).sci_ArraySeq$ofUnit__f_unsafeArray).u.length);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.sci_ArraySeq$ofUnit__f_unsafeArray);
});
$c_sci_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(i) {
  $n(this.sci_ArraySeq$ofUnit__f_unsafeArray).get(i);
});
$c_sci_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  this.apply$mcVI$sp__I__V(i);
});
$c_sci_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i);
});
$c_sci_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$c_sci_ArraySeq$ofUnit.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofUnit__f_unsafeArray;
});
function $as_sci_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofUnit"));
}
function $isArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofUnit)));
}
function $asArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofUnit;", depth));
}
var $d_sci_ArraySeq$ofUnit = new $TypeData().initClass($c_sci_ArraySeq$ofUnit, "scala.collection.immutable.ArraySeq$ofUnit", ({
  sci_ArraySeq$ofUnit: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
function $p_sci_List__filterCommon__F1__Z__sci_List($thiz, p, isFlipped) {
  var result = $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, $thiz, p, isFlipped);
  return result;
}
function $p_sci_List__loop$2__I__sci_List__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return ($n(xs).isEmpty__Z() ? 0 : 1);
    } else if ($n(xs).isEmpty__Z()) {
      return (-1);
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sci_List($n(xs).tail__O());
      i = temp$i;
      xs = temp$xs;
    }
  }
}
function $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, l, p$1, isFlipped$1) {
  while (true) {
    if ($n(l).isEmpty__Z()) {
      return $m_sci_Nil$();
    } else {
      var h = $n(l).head__O();
      var t = $as_sci_List($n(l).tail__O());
      if (($uZ($n(p$1).apply__O__O(h)) !== isFlipped$1)) {
        return $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, l, t, p$1, isFlipped$1);
      } else {
        l = t;
      }
    }
  }
}
function $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, start, remaining, p$1, isFlipped$1) {
  while (true) {
    if ($n(remaining).isEmpty__Z()) {
      return start;
    } else {
      var x = $n(remaining).head__O();
      if (($uZ($n(p$1).apply__O__O(x)) !== isFlipped$1)) {
        remaining = $as_sci_List($n(remaining).tail__O());
      } else {
        return $ps_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List(start, remaining, p$1, isFlipped$1);
      }
    }
  }
}
function $ps_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List(origStart, firstMiss, p$1, isFlipped$1) {
  var newHead = new $c_sci_$colon$colon($n(origStart).head__O(), $m_sci_Nil$());
  var toProcess = $as_sci_List($n(origStart).tail__O());
  var currentLast = newHead;
  while ((toProcess !== firstMiss)) {
    var newElem = new $c_sci_$colon$colon($n(toProcess).head__O(), $m_sci_Nil$());
    $n(currentLast).sci_$colon$colon__f_next = newElem;
    currentLast = newElem;
    toProcess = $as_sci_List($n(toProcess).tail__O());
  }
  var next = $as_sci_List($n(firstMiss).tail__O());
  var nextToCopy = next;
  while ((!$n(next).isEmpty__Z())) {
    var head = $n(next).head__O();
    if (($uZ($n(p$1).apply__O__O(head)) !== isFlipped$1)) {
      next = $as_sci_List($n(next).tail__O());
    } else {
      while ((nextToCopy !== next)) {
        var newElem$2 = new $c_sci_$colon$colon($n(nextToCopy).head__O(), $m_sci_Nil$());
        $n(currentLast).sci_$colon$colon__f_next = newElem$2;
        currentLast = newElem$2;
        nextToCopy = $as_sci_List($n(nextToCopy).tail__O());
      }
      nextToCopy = $as_sci_List($n(next).tail__O());
      next = $as_sci_List($n(next).tail__O());
    }
  }
  if ((!$n(nextToCopy).isEmpty__Z())) {
    $n(currentLast).sci_$colon$colon__f_next = nextToCopy;
  }
  return newHead;
}
function $p_sci_List__listEq$1__sci_List__sci_List__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true;
    } else {
      var aEmpty = $n(a).isEmpty__Z();
      var bEmpty = $n(b).isEmpty__Z();
      if (((!(aEmpty || bEmpty)) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(a).head__O(), $n(b).head__O()))) {
        var temp$a = $as_sci_List($n(a).tail__O());
        var temp$b = $as_sci_List($n(b).tail__O());
        a = temp$a;
        b = temp$b;
        continue;
      }
      return (aEmpty && bEmpty);
    }
  }
}
/** @constructor */
function $c_sci_List() {
}
$c_sci_List.prototype = new $h_sci_AbstractSeq();
$c_sci_List.prototype.constructor = $c_sci_List;
/** @constructor */
function $h_sci_List() {
}
$h_sci_List.prototype = $c_sci_List.prototype;
$c_sci_List.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_List.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this);
});
$c_sci_List.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_List.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_List.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_List.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_List.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op);
});
$c_sci_List.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_List.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_List.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_List$();
});
$c_sci_List.prototype.$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  if (this.isEmpty__Z()) {
    return prefix;
  } else if ($n(prefix).isEmpty__Z()) {
    return this;
  } else {
    var result = new $c_sci_$colon$colon($n(prefix).head__O(), this);
    var curr = result;
    var that = $as_sci_List($n(prefix).tail__O());
    while ((!$n(that).isEmpty__Z())) {
      var temp = new $c_sci_$colon$colon($n(that).head__O(), this);
      $n(curr).sci_$colon$colon__f_next = temp;
      curr = temp;
      that = $as_sci_List($n(that).tail__O());
    }
    return result;
  }
});
$c_sci_List.prototype.reverse_$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  var these = this;
  var pres = prefix;
  while ((!$n(pres).isEmpty__Z())) {
    var rassoc$1 = $n(pres).head__O();
    var this$1 = $n(these);
    these = new $c_sci_$colon$colon(rassoc$1, this$1);
    pres = $as_sci_List($n(pres).tail__O());
  }
  return these;
});
$c_sci_List.prototype.isEmpty__Z = (function() {
  return (this === $m_sci_Nil$());
});
$c_sci_List.prototype.prependedAll__sc_IterableOnce__sci_List = (function(prefix) {
  if ((prefix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(prefix);
    return this.$colon$colon$colon__sci_List__sci_List(x2);
  }
  if (($n(prefix).knownSize__I() === 0)) {
    return this;
  }
  if ((prefix instanceof $c_scm_ListBuffer)) {
    var x3 = $as_scm_ListBuffer(prefix);
    if (this.isEmpty__Z()) {
      return $n(x3).toList__sci_List();
    }
  }
  var iter = $n(prefix).iterator__sc_Iterator();
  if ($n(iter).hasNext__Z()) {
    var result = new $c_sci_$colon$colon($n(iter).next__O(), this);
    var curr = result;
    while ($n(iter).hasNext__Z()) {
      var temp = new $c_sci_$colon$colon($n(iter).next__O(), this);
      $n(curr).sci_$colon$colon__f_next = temp;
      curr = temp;
    }
    return result;
  } else {
    return this;
  }
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__sci_List = (function(suffix) {
  if ((suffix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(suffix);
    return $n(x2).$colon$colon$colon__sci_List__sci_List(this);
  } else {
    return $as_sci_List($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix));
  }
});
$c_sci_List.prototype.take__I__sci_List = (function(n) {
  if ((this.isEmpty__Z() || (n <= 0))) {
    return $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon(this.head__O(), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    var i = 1;
    while (true) {
      if ($n(rest).isEmpty__Z()) {
        return this;
      }
      if ((i < n)) {
        i = ((1 + i) | 0);
        var nx = new $c_sci_$colon$colon($n(rest).head__O(), $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List($n(rest).tail__O());
      } else {
        break;
      }
    }
    return h;
  }
});
$c_sci_List.prototype.splitAt__I__T2 = (function(n) {
  var b = new $c_scm_ListBuffer();
  var i = 0;
  var these = this;
  while (((!$n(these).isEmpty__Z()) && (i < n))) {
    i = ((1 + i) | 0);
    var elem = $n(these).head__O();
    b.addOne__O__scm_ListBuffer(elem);
    these = $as_sci_List($n(these).tail__O());
  }
  return new $c_T2(b.toList__sci_List(), these);
});
$c_sci_List.prototype.map__F1__sci_List = (function(f) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon($n(f).apply__O__O(this.head__O()), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var nx = new $c_sci_$colon$colon($n(f).apply__O__O($n(rest).head__O()), $m_sci_Nil$());
      $n(t).sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List($n(rest).tail__O());
    }
    return h;
  }
});
$c_sci_List.prototype.collect__s_PartialFunction__sci_List = (function(pf) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var rest = this;
    var h = null;
    var x = null;
    while ((h === null)) {
      x = $n(pf).applyOrElse__O__F1__O($n(rest).head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        h = new $c_sci_$colon$colon(x, $m_sci_Nil$());
      }
      rest = $as_sci_List($n(rest).tail__O());
      if ((rest === $m_sci_Nil$())) {
        return ((h === null) ? $m_sci_Nil$() : h);
      }
    }
    var t = h;
    while ((rest !== $m_sci_Nil$())) {
      x = $n(pf).applyOrElse__O__F1__O($n(rest).head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        var nx = new $c_sci_$colon$colon(x, $m_sci_Nil$());
        $n(t).sci_$colon$colon__f_next = nx;
        t = nx;
      }
      rest = $as_sci_List($n(rest).tail__O());
    }
    return h;
  }
});
$c_sci_List.prototype.flatMap__F1__sci_List = (function(f) {
  var rest = this;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $n($as_sc_IterableOnce($n(f).apply__O__O($n(rest).head__O()))).iterator__sc_Iterator();
    while ($n(it).hasNext__Z()) {
      var nx = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        $n(t).sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = $as_sci_List($n(rest).tail__O());
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$c_sci_List.prototype.foreach__F1__V = (function(f) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    $n(f).apply__O__O($n(these).head__O());
    these = $as_sci_List($n(these).tail__O());
  }
});
$c_sci_List.prototype.reverse__sci_List = (function() {
  var result = $m_sci_Nil$();
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    var rassoc$6 = $n(these).head__O();
    var this$1 = $n(result);
    result = new $c_sci_$colon$colon(rassoc$6, this$1);
    these = $as_sci_List($n(these).tail__O());
  }
  return result;
});
$c_sci_List.prototype.length__I = (function() {
  var these = this;
  var len = 0;
  while ((!$n(these).isEmpty__Z())) {
    len = ((1 + len) | 0);
    these = $as_sci_List($n(these).tail__O());
  }
  return len;
});
$c_sci_List.prototype.lengthCompare__I__I = (function(len) {
  return ((len < 0) ? 1 : $p_sci_List__loop$2__I__sci_List__I__I(this, 0, this, len));
});
$c_sci_List.prototype.forall__F1__Z = (function(p) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ((!$uZ($n(p).apply__O__O($n(these).head__O())))) {
      return false;
    }
    these = $as_sci_List($n(these).tail__O());
  }
  return true;
});
$c_sci_List.prototype.exists__F1__Z = (function(p) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ($uZ($n(p).apply__O__O($n(these).head__O()))) {
      return true;
    }
    these = $as_sci_List($n(these).tail__O());
  }
  return false;
});
$c_sci_List.prototype.contains__O__Z = (function(elem) {
  var these = this;
  while ((!$n(these).isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n(these).head__O(), elem)) {
      return true;
    }
    these = $as_sci_List($n(these).tail__O());
  }
  return false;
});
$c_sci_List.prototype.last__O = (function() {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "List.last");
  } else {
    var these = this;
    var scout = $as_sci_List(this.tail__O());
    while ((!$n(scout).isEmpty__Z())) {
      these = scout;
      scout = $as_sci_List($n(scout).tail__O());
    }
    return $n(these).head__O();
  }
});
$c_sci_List.prototype.className__T = (function() {
  return "List";
});
$c_sci_List.prototype.toList__sci_List = (function() {
  return this;
});
$c_sci_List.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_sci_List)) {
    var x2 = $as_sci_List(o);
    return $p_sci_List__listEq$1__sci_List__sci_List__Z(this, this, x2);
  } else {
    return $f_sc_Seq__equals__O__Z(this, o);
  }
});
$c_sci_List.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_List.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_List.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this);
});
$c_sci_List.prototype.filter__F1__O = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, false);
});
$c_sci_List.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_List(f);
});
$c_sci_List.prototype.collect__s_PartialFunction__O = (function(pf) {
  return this.collect__s_PartialFunction__sci_List(pf);
});
$c_sci_List.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_List(f);
});
$c_sci_List.prototype.take__I__O = (function(n) {
  return this.take__I__sci_List(n);
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_List(suffix);
});
$c_sci_List.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_List$();
});
function $as_sci_List(obj) {
  return (((obj instanceof $c_sci_List) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.List"));
}
function $isArrayOf_sci_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_List)));
}
function $asArrayOf_sci_List(obj, depth) {
  return (($isArrayOf_sci_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.List;", depth));
}
function $ps_sci_Queue__indexOutOfRange$1__I__E(n$1) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n$1));
}
function $ct_sci_Queue__sci_List__sci_List__($thiz, in$1, out) {
  $thiz.sci_Queue__f_in = in$1;
  $thiz.sci_Queue__f_out = out;
  return $thiz;
}
/** @constructor */
function $c_sci_Queue() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null;
}
$c_sci_Queue.prototype = new $h_sci_AbstractSeq();
$c_sci_Queue.prototype.constructor = $c_sci_Queue;
/** @constructor */
function $h_sci_Queue() {
}
$h_sci_Queue.prototype = $c_sci_Queue.prototype;
$c_sci_Queue.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_Queue.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Queue.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Queue.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Queue.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_Queue.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Queue.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_Queue.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$c_sci_Queue.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_Queue.prototype.foreach__F1__V = (function(f) {
  $f_sc_LinearSeqOps__foreach__F1__V(this, f);
});
$c_sci_Queue.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op);
});
$c_sci_Queue.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_Queue.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Queue$();
});
$c_sci_Queue.prototype.apply__I__O = (function(n) {
  var index = 0;
  var curr = this.sci_Queue__f_out;
  while (true) {
    if ((index < n)) {
      var this$1 = $n(curr);
      var $x_1 = (!this$1.isEmpty__Z());
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      index = ((1 + index) | 0);
      curr = $as_sci_List($n(curr).tail__O());
    } else {
      break;
    }
  }
  if ((index === n)) {
    var this$2 = $n(curr);
    if ((!this$2.isEmpty__Z())) {
      return $n(curr).head__O();
    } else {
      var this$3 = $n(this.sci_Queue__f_in);
      if ((!this$3.isEmpty__Z())) {
        return $n(this.sci_Queue__f_in).last__O();
      } else {
        $ps_sci_Queue__indexOutOfRange$1__I__E(n);
      }
    }
  } else {
    var indexFromBack = ((n - index) | 0);
    var inLength = $n(this.sci_Queue__f_in).length__I();
    if ((indexFromBack >= inLength)) {
      $ps_sci_Queue__indexOutOfRange$1__I__E(n);
    } else {
      var this$4 = $n(this.sci_Queue__f_in);
      var n$1 = ((((inLength - indexFromBack) | 0) - 1) | 0);
      return $f_sc_LinearSeqOps__apply__I__O(this$4, n$1);
    }
  }
});
$c_sci_Queue.prototype.iterator__sc_Iterator = (function() {
  return $n($n(this.sci_Queue__f_out).iterator__sc_Iterator()).concat__F0__sc_Iterator(new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => $n(this.sci_Queue__f_in).reverse__sci_List())));
});
$c_sci_Queue.prototype.isEmpty__Z = (function() {
  return ($n(this.sci_Queue__f_in).isEmpty__Z() && $n(this.sci_Queue__f_out).isEmpty__Z());
});
$c_sci_Queue.prototype.head__O = (function() {
  var this$1 = $n(this.sci_Queue__f_out);
  if ((!this$1.isEmpty__Z())) {
    return $n(this.sci_Queue__f_out).head__O();
  } else {
    var this$2 = $n(this.sci_Queue__f_in);
    if ((!this$2.isEmpty__Z())) {
      return $n(this.sci_Queue__f_in).last__O();
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head on empty queue");
    }
  }
});
$c_sci_Queue.prototype.tail__sci_Queue = (function() {
  var this$1 = $n(this.sci_Queue__f_out);
  if ((!this$1.isEmpty__Z())) {
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, $as_sci_List($n(this.sci_Queue__f_out).tail__O()));
  } else {
    var this$2 = $n(this.sci_Queue__f_in);
    if ((!this$2.isEmpty__Z())) {
      return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List($n($n(this.sci_Queue__f_in).reverse__sci_List()).tail__O()));
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "tail on empty queue");
    }
  }
});
$c_sci_Queue.prototype.last__O = (function() {
  var this$1 = $n(this.sci_Queue__f_in);
  if ((!this$1.isEmpty__Z())) {
    return $n(this.sci_Queue__f_in).head__O();
  } else {
    var this$2 = $n(this.sci_Queue__f_out);
    if ((!this$2.isEmpty__Z())) {
      return $n(this.sci_Queue__f_out).last__O();
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last on empty queue");
    }
  }
});
$c_sci_Queue.prototype.forall__F1__Z = (function(p) {
  return ($n(this.sci_Queue__f_in).forall__F1__Z(p) && $n(this.sci_Queue__f_out).forall__F1__Z(p));
});
$c_sci_Queue.prototype.exists__F1__Z = (function(p) {
  return ($n(this.sci_Queue__f_in).exists__F1__Z(p) || $n(this.sci_Queue__f_out).exists__F1__Z(p));
});
$c_sci_Queue.prototype.className__T = (function() {
  return "Queue";
});
$c_sci_Queue.prototype.length__I = (function() {
  return (($n(this.sci_Queue__f_in).length__I() + $n(this.sci_Queue__f_out).length__I()) | 0);
});
$c_sci_Queue.prototype.prepended__O__sci_Queue = (function(elem) {
  var $x_1 = this.sci_Queue__f_in;
  var this$1 = $n(this.sci_Queue__f_out);
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $x_1, new $c_sci_$colon$colon(elem, this$1));
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__sci_Queue = (function(that) {
  if ((that instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(that);
    var this$1 = $n($n(x2).sci_Queue__f_in);
    var rassoc$2 = $n(x2).sci_Queue__f_out;
    var suffix = $n(this.sci_Queue__f_in).reverse_$colon$colon$colon__sci_List__sci_List(rassoc$2);
    var newIn = this$1.appendedAll__sc_IterableOnce__sci_List(suffix);
  } else if ((that instanceof $c_sci_List)) {
    var x3 = $as_sci_List(that);
    var newIn = $n(this.sci_Queue__f_in).reverse_$colon$colon$colon__sci_List__sci_List(x3);
  } else {
    var result = this.sci_Queue__f_in;
    var iter = $n(that).iterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var rassoc$4 = $n(iter).next__O();
      var this$2 = $n(result);
      result = new $c_sci_$colon$colon(rassoc$4, this$2);
    }
    var newIn = result;
  }
  return ((newIn === this.sci_Queue__f_in) ? this : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), newIn, this.sci_Queue__f_out));
});
$c_sci_Queue.prototype.enqueue__O__sci_Queue = (function(elem) {
  var this$1 = $n(this.sci_Queue__f_in);
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), new $c_sci_$colon$colon(elem, this$1), this.sci_Queue__f_out);
});
$c_sci_Queue.prototype.dequeue__T2 = (function() {
  var x1 = this.sci_Queue__f_out;
  var x = $m_sci_Nil$();
  if ((x.equals__O__Z(x1) && (!$n(this.sci_Queue__f_in).isEmpty__Z()))) {
    var rev = $n(this.sci_Queue__f_in).reverse__sci_List();
    return new $c_T2($n(rev).head__O(), $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List($n(rev).tail__O())));
  } else if ((x1 instanceof $c_sci_$colon$colon)) {
    var x3 = $as_sci_$colon$colon(x1);
    var x$3 = $n(x3).sci_$colon$colon__f_head;
    var xs = $n(x3).sci_$colon$colon__f_next;
    return new $c_T2(x$3, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, xs));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "dequeue on empty queue");
  }
});
$c_sci_Queue.prototype.toString__T = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this, "Queue(", ", ", ")");
});
$c_sci_Queue.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_Queue.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this);
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Queue(suffix);
});
$c_sci_Queue.prototype.tail__O = (function() {
  return this.tail__sci_Queue();
});
$c_sci_Queue.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_sci_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Queue$();
});
function $as_sci_Queue(obj) {
  return (((obj instanceof $c_sci_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Queue"));
}
function $isArrayOf_sci_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Queue)));
}
function $asArrayOf_sci_Queue(obj, depth) {
  return (($isArrayOf_sci_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Queue;", depth));
}
var $d_sci_Queue = new $TypeData().initClass($c_sci_Queue, "scala.collection.immutable.Queue", ({
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_VectorImpl() {
  this.sci_Vector__f_prefix1 = null;
}
$c_sci_VectorImpl.prototype = new $h_sci_Vector();
$c_sci_VectorImpl.prototype.constructor = $c_sci_VectorImpl;
/** @constructor */
function $h_sci_VectorImpl() {
}
$h_sci_VectorImpl.prototype = $c_sci_VectorImpl.prototype;
$c_sci_VectorImpl.prototype.slice__I__I__sci_Vector = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = this.length__I();
  var hi = ((until < b) ? until : b);
  return ((hi <= lo) ? $m_sci_Vector0$() : ((((hi - lo) | 0) === this.length__I()) ? this : this.slice0__I__I__sci_Vector(lo, hi)));
});
/** @constructor */
function $c_scm_ArraySeq$ofBoolean(array) {
  this.scm_ArraySeq$ofBoolean__f_array = null;
  this.scm_ArraySeq$ofBoolean__f_array = array;
}
$c_scm_ArraySeq$ofBoolean.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofBoolean.prototype.constructor = $c_scm_ArraySeq$ofBoolean;
/** @constructor */
function $h_scm_ArraySeq$ofBoolean() {
}
$h_scm_ArraySeq$ofBoolean.prototype = $c_scm_ArraySeq$ofBoolean.prototype;
$c_scm_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofBoolean__f_array).u.length;
});
$c_scm_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofBoolean__f_array;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofBoolean)) {
    var x2 = $as_scm_ArraySeq$ofBoolean(that);
    var a = this.scm_ArraySeq$ofBoolean__f_array;
    var b = $n(x2).scm_ArraySeq$ofBoolean__f_array;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.scm_ArraySeq$ofBoolean__f_array);
});
$c_scm_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(index) {
  return $n(this.scm_ArraySeq$ofBoolean__f_array).get(index);
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcZI$sp__I__Z(index);
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i);
});
$c_scm_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$c_scm_ArraySeq$ofBoolean.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array;
});
function $as_scm_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofBoolean"));
}
function $isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofBoolean)));
}
function $asArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofBoolean;", depth));
}
var $d_scm_ArraySeq$ofBoolean = new $TypeData().initClass($c_scm_ArraySeq$ofBoolean, "scala.collection.mutable.ArraySeq$ofBoolean", ({
  scm_ArraySeq$ofBoolean: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofByte(array) {
  this.scm_ArraySeq$ofByte__f_array = null;
  this.scm_ArraySeq$ofByte__f_array = array;
}
$c_scm_ArraySeq$ofByte.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofByte.prototype.constructor = $c_scm_ArraySeq$ofByte;
/** @constructor */
function $h_scm_ArraySeq$ofByte() {
}
$h_scm_ArraySeq$ofByte.prototype = $c_scm_ArraySeq$ofByte.prototype;
$c_scm_ArraySeq$ofByte.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofByte__f_array).u.length;
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__B = (function(index) {
  return $n(this.scm_ArraySeq$ofByte__f_array).get(index);
});
$c_scm_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofByte__f_array;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofByte)) {
    var x2 = $as_scm_ArraySeq$ofByte(that);
    var a = this.scm_ArraySeq$ofByte__f_array;
    var b = $n(x2).scm_ArraySeq$ofByte__f_array;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.scm_ArraySeq$ofByte__f_array);
});
$c_scm_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1));
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i);
});
$c_scm_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$c_scm_ArraySeq$ofByte.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofByte__f_array;
});
function $as_scm_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofByte"));
}
function $isArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofByte)));
}
function $asArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofByte;", depth));
}
var $d_scm_ArraySeq$ofByte = new $TypeData().initClass($c_scm_ArraySeq$ofByte, "scala.collection.mutable.ArraySeq$ofByte", ({
  scm_ArraySeq$ofByte: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofChar(array) {
  this.scm_ArraySeq$ofChar__f_array = null;
  this.scm_ArraySeq$ofChar__f_array = array;
}
$c_scm_ArraySeq$ofChar.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofChar.prototype.constructor = $c_scm_ArraySeq$ofChar;
/** @constructor */
function $h_scm_ArraySeq$ofChar() {
}
$h_scm_ArraySeq$ofChar.prototype = $c_scm_ArraySeq$ofChar.prototype;
$c_scm_ArraySeq$ofChar.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofChar__f_array).u.length;
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__C = (function(index) {
  return $n(this.scm_ArraySeq$ofChar__f_array).get(index);
});
$c_scm_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofChar__f_array;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofChar)) {
    var x2 = $as_scm_ArraySeq$ofChar(that);
    var a = this.scm_ArraySeq$ofChar__f_array;
    var b = $n(x2).scm_ArraySeq$ofChar__f_array;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.scm_ArraySeq$ofChar__f_array);
});
$c_scm_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  var jsb = $n(sb).scm_StringBuilder__f_underlying;
  var this$1 = $n(start);
  if ((this$1.length !== 0)) {
    var this$2 = $n(jsb);
    this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  }
  var len = $n(this.scm_ArraySeq$ofChar__f_array).u.length;
  if ((len !== 0)) {
    var this$3 = $n(sep);
    if ((this$3 === "")) {
      $n(jsb).append__AC__jl_StringBuilder(this.scm_ArraySeq$ofChar__f_array);
    } else {
      $n(jsb);
      $n(jsb).length__I();
      $n(end);
      $n(sep);
      var this$6 = $n(jsb);
      var c = $n(this.scm_ArraySeq$ofChar__f_array).get(0);
      var str = ("" + $cToS(c));
      this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$6.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
      var i = 1;
      while ((i < len)) {
        var this$8 = $n(jsb);
        this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$8.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$9 = $n(jsb);
        var c$1 = $n(this.scm_ArraySeq$ofChar__f_array).get(i);
        var str$1 = ("" + $cToS(c$1));
        this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$9.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
        i = ((1 + i) | 0);
      }
    }
  }
  var this$11 = $n(end);
  if ((this$11.length !== 0)) {
    var this$12 = $n(jsb);
    this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$12.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  }
  return sb;
});
$c_scm_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)));
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i));
});
$c_scm_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$c_scm_ArraySeq$ofChar.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofChar__f_array;
});
function $as_scm_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofChar"));
}
function $isArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofChar)));
}
function $asArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofChar;", depth));
}
var $d_scm_ArraySeq$ofChar = new $TypeData().initClass($c_scm_ArraySeq$ofChar, "scala.collection.mutable.ArraySeq$ofChar", ({
  scm_ArraySeq$ofChar: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofDouble(array) {
  this.scm_ArraySeq$ofDouble__f_array = null;
  this.scm_ArraySeq$ofDouble__f_array = array;
}
$c_scm_ArraySeq$ofDouble.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofDouble.prototype.constructor = $c_scm_ArraySeq$ofDouble;
/** @constructor */
function $h_scm_ArraySeq$ofDouble() {
}
$h_scm_ArraySeq$ofDouble.prototype = $c_scm_ArraySeq$ofDouble.prototype;
$c_scm_ArraySeq$ofDouble.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofDouble__f_array).u.length;
});
$c_scm_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofDouble__f_array;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofDouble)) {
    var x2 = $as_scm_ArraySeq$ofDouble(that);
    var thatArray = $n(x2).scm_ArraySeq$ofDouble__f_array;
    if ((this.scm_ArraySeq$ofDouble__f_array === thatArray)) {
      return true;
    } else if (($n(this.scm_ArraySeq$ofDouble__f_array).u.length === $n(thatArray).u.length)) {
      var i = 0;
      while (((i < $n(this.scm_ArraySeq$ofDouble__f_array).u.length) && ($n(this.scm_ArraySeq$ofDouble__f_array).get(i) === $n(thatArray).get(i)))) {
        i = ((1 + i) | 0);
      }
      return (i >= $n(this.scm_ArraySeq$ofDouble__f_array).u.length);
    } else {
      return false;
    }
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.scm_ArraySeq$ofDouble__f_array);
});
$c_scm_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(index) {
  return $n(this.scm_ArraySeq$ofDouble__f_array).get(index);
});
$c_scm_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcDI$sp__I__D(index);
});
$c_scm_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i);
});
$c_scm_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$c_scm_ArraySeq$ofDouble.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofDouble__f_array;
});
function $as_scm_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofDouble"));
}
function $isArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofDouble)));
}
function $asArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofDouble;", depth));
}
var $d_scm_ArraySeq$ofDouble = new $TypeData().initClass($c_scm_ArraySeq$ofDouble, "scala.collection.mutable.ArraySeq$ofDouble", ({
  scm_ArraySeq$ofDouble: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofFloat(array) {
  this.scm_ArraySeq$ofFloat__f_array = null;
  this.scm_ArraySeq$ofFloat__f_array = array;
}
$c_scm_ArraySeq$ofFloat.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofFloat.prototype.constructor = $c_scm_ArraySeq$ofFloat;
/** @constructor */
function $h_scm_ArraySeq$ofFloat() {
}
$h_scm_ArraySeq$ofFloat.prototype = $c_scm_ArraySeq$ofFloat.prototype;
$c_scm_ArraySeq$ofFloat.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofFloat__f_array).u.length;
});
$c_scm_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofFloat__f_array;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofFloat)) {
    var x2 = $as_scm_ArraySeq$ofFloat(that);
    var thatArray = $n(x2).scm_ArraySeq$ofFloat__f_array;
    if ((this.scm_ArraySeq$ofFloat__f_array === thatArray)) {
      return true;
    } else if (($n(this.scm_ArraySeq$ofFloat__f_array).u.length === $n(thatArray).u.length)) {
      var i = 0;
      while (((i < $n(this.scm_ArraySeq$ofFloat__f_array).u.length) && ($n(this.scm_ArraySeq$ofFloat__f_array).get(i) === $n(thatArray).get(i)))) {
        i = ((1 + i) | 0);
      }
      return (i >= $n(this.scm_ArraySeq$ofFloat__f_array).u.length);
    } else {
      return false;
    }
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.scm_ArraySeq$ofFloat__f_array);
});
$c_scm_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(index) {
  return $n(this.scm_ArraySeq$ofFloat__f_array).get(index);
});
$c_scm_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcFI$sp__I__F(index);
});
$c_scm_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i);
});
$c_scm_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$c_scm_ArraySeq$ofFloat.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofFloat__f_array;
});
function $as_scm_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofFloat"));
}
function $isArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofFloat)));
}
function $asArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofFloat;", depth));
}
var $d_scm_ArraySeq$ofFloat = new $TypeData().initClass($c_scm_ArraySeq$ofFloat, "scala.collection.mutable.ArraySeq$ofFloat", ({
  scm_ArraySeq$ofFloat: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofInt(array) {
  this.scm_ArraySeq$ofInt__f_array = null;
  this.scm_ArraySeq$ofInt__f_array = array;
}
$c_scm_ArraySeq$ofInt.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofInt.prototype.constructor = $c_scm_ArraySeq$ofInt;
/** @constructor */
function $h_scm_ArraySeq$ofInt() {
}
$h_scm_ArraySeq$ofInt.prototype = $c_scm_ArraySeq$ofInt.prototype;
$c_scm_ArraySeq$ofInt.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofInt__f_array).u.length;
});
$c_scm_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofInt__f_array;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofInt)) {
    var x2 = $as_scm_ArraySeq$ofInt(that);
    var a = this.scm_ArraySeq$ofInt__f_array;
    var b = $n(x2).scm_ArraySeq$ofInt__f_array;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.scm_ArraySeq$ofInt__f_array);
});
$c_scm_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(index) {
  return $n(this.scm_ArraySeq$ofInt__f_array).get(index);
});
$c_scm_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcII$sp__I__I(index);
});
$c_scm_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i);
});
$c_scm_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$c_scm_ArraySeq$ofInt.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofInt__f_array;
});
function $as_scm_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofInt"));
}
function $isArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofInt)));
}
function $asArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofInt;", depth));
}
var $d_scm_ArraySeq$ofInt = new $TypeData().initClass($c_scm_ArraySeq$ofInt, "scala.collection.mutable.ArraySeq$ofInt", ({
  scm_ArraySeq$ofInt: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofLong(array) {
  this.scm_ArraySeq$ofLong__f_array = null;
  this.scm_ArraySeq$ofLong__f_array = array;
}
$c_scm_ArraySeq$ofLong.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofLong.prototype.constructor = $c_scm_ArraySeq$ofLong;
/** @constructor */
function $h_scm_ArraySeq$ofLong() {
}
$h_scm_ArraySeq$ofLong.prototype = $c_scm_ArraySeq$ofLong.prototype;
$c_scm_ArraySeq$ofLong.prototype.length__I = (function() {
  return (($n(this.scm_ArraySeq$ofLong__f_array).u.length >>> 1) | 0);
});
$c_scm_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofLong__f_array;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofLong)) {
    var x2 = $as_scm_ArraySeq$ofLong(that);
    var a = this.scm_ArraySeq$ofLong__f_array;
    var b = $n(x2).scm_ArraySeq$ofLong__f_array;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.scm_ArraySeq$ofLong__f_array);
});
$c_scm_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(index) {
  var $x_1 = $n(this.scm_ArraySeq$ofLong__f_array).u;
  var $x_2 = $aJCheckGet($x_1, index);
  return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
});
$c_scm_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcJI$sp__I__J(index);
});
$c_scm_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i);
});
$c_scm_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$c_scm_ArraySeq$ofLong.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofLong__f_array;
});
function $as_scm_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofLong"));
}
function $isArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofLong)));
}
function $asArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofLong;", depth));
}
var $d_scm_ArraySeq$ofLong = new $TypeData().initClass($c_scm_ArraySeq$ofLong, "scala.collection.mutable.ArraySeq$ofLong", ({
  scm_ArraySeq$ofLong: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofRef(array) {
  this.scm_ArraySeq$ofRef__f_array = null;
  this.scm_ArraySeq$ofRef__f_array = array;
}
$c_scm_ArraySeq$ofRef.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofRef.prototype.constructor = $c_scm_ArraySeq$ofRef;
/** @constructor */
function $h_scm_ArraySeq$ofRef() {
}
$h_scm_ArraySeq$ofRef.prototype = $c_scm_ArraySeq$ofRef.prototype;
$c_scm_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $x_1 = $m_s_reflect_ClassTag$();
  var this$1 = $n(this.scm_ArraySeq$ofRef__f_array);
  var this$2 = $objectGetClass(this$1);
  return $x_1.apply__jl_Class__s_reflect_ClassTag(this$2.data.getComponentType());
});
$c_scm_ArraySeq$ofRef.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofRef__f_array).u.length;
});
$c_scm_ArraySeq$ofRef.prototype.apply__I__O = (function(index) {
  return $n(this.scm_ArraySeq$ofRef__f_array).get(index);
});
$c_scm_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofRef__f_array;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofRef)) {
    var x2 = $as_scm_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.scm_ArraySeq$ofRef__f_array, $n(x2).scm_ArraySeq$ofRef__f_array);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.scm_ArraySeq$ofRef__f_array);
});
$c_scm_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
$c_scm_ArraySeq$ofRef.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofRef__f_array;
});
function $as_scm_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofRef"));
}
function $isArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofRef)));
}
function $asArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofRef;", depth));
}
var $d_scm_ArraySeq$ofRef = new $TypeData().initClass($c_scm_ArraySeq$ofRef, "scala.collection.mutable.ArraySeq$ofRef", ({
  scm_ArraySeq$ofRef: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofShort(array) {
  this.scm_ArraySeq$ofShort__f_array = null;
  this.scm_ArraySeq$ofShort__f_array = array;
}
$c_scm_ArraySeq$ofShort.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofShort.prototype.constructor = $c_scm_ArraySeq$ofShort;
/** @constructor */
function $h_scm_ArraySeq$ofShort() {
}
$h_scm_ArraySeq$ofShort.prototype = $c_scm_ArraySeq$ofShort.prototype;
$c_scm_ArraySeq$ofShort.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofShort__f_array).u.length;
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__S = (function(index) {
  return $n(this.scm_ArraySeq$ofShort__f_array).get(index);
});
$c_scm_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofShort__f_array;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofShort)) {
    var x2 = $as_scm_ArraySeq$ofShort(that);
    var a = this.scm_ArraySeq$ofShort__f_array;
    var b = $n(x2).scm_ArraySeq$ofShort__f_array;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.scm_ArraySeq$ofShort__f_array);
});
$c_scm_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1));
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i);
});
$c_scm_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$c_scm_ArraySeq$ofShort.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofShort__f_array;
});
function $as_scm_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofShort"));
}
function $isArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofShort)));
}
function $asArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofShort;", depth));
}
var $d_scm_ArraySeq$ofShort = new $TypeData().initClass($c_scm_ArraySeq$ofShort, "scala.collection.mutable.ArraySeq$ofShort", ({
  scm_ArraySeq$ofShort: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_ArraySeq$ofUnit(array) {
  this.scm_ArraySeq$ofUnit__f_array = null;
  this.scm_ArraySeq$ofUnit__f_array = array;
}
$c_scm_ArraySeq$ofUnit.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofUnit.prototype.constructor = $c_scm_ArraySeq$ofUnit;
/** @constructor */
function $h_scm_ArraySeq$ofUnit() {
}
$h_scm_ArraySeq$ofUnit.prototype = $c_scm_ArraySeq$ofUnit.prototype;
$c_scm_ArraySeq$ofUnit.prototype.length__I = (function() {
  return $n(this.scm_ArraySeq$ofUnit__f_array).u.length;
});
$c_scm_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofUnit__f_array;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofUnit)) {
    var x2 = $as_scm_ArraySeq$ofUnit(that);
    return ($n(this.scm_ArraySeq$ofUnit__f_array).u.length === $n($n(x2).scm_ArraySeq$ofUnit__f_array).u.length);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.scm_ArraySeq$ofUnit__f_array);
});
$c_scm_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(index) {
  $n(this.scm_ArraySeq$ofUnit__f_array).get(index);
});
$c_scm_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  this.apply$mcVI$sp__I__V(index);
});
$c_scm_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i);
});
$c_scm_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$c_scm_ArraySeq$ofUnit.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofUnit__f_array;
});
function $as_scm_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofUnit"));
}
function $isArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofUnit)));
}
function $asArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofUnit;", depth));
}
var $d_scm_ArraySeq$ofUnit = new $TypeData().initClass($c_scm_ArraySeq$ofUnit, "scala.collection.mutable.ArraySeq$ofUnit", ({
  scm_ArraySeq$ofUnit: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
function $p_scm_HashMap__put0__O__O__I__Z__s_Some($thiz, key, value, hash, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1));
  }
  var idx = (hash & (($n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length - 1) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx);
}
function $p_scm_HashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1));
  }
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var idx = (hash & (($n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length - 1) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx);
}
function $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(idx);
  if ((x1 === null)) {
    $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(idx, new $c_scm_HashMap$Node(key, hash, value, null));
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && ($n(n).scm_HashMap$Node__f__hash <= hash))) {
      if ((($n(n).scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, $n(n).scm_HashMap$Node__f__key))) {
        var old = $n(n).scm_HashMap$Node__f__value;
        $n(n).scm_HashMap$Node__f__value = value;
        return (getOld ? new $c_s_Some(old) : null);
      }
      prev = n;
      n = $n(n).scm_HashMap$Node__f__next;
    }
    if ((prev === null)) {
      $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(idx, new $c_scm_HashMap$Node(key, hash, value, x1));
    } else {
      $n(prev).scm_HashMap$Node__f__next = new $c_scm_HashMap$Node(key, hash, value, $n(prev).scm_HashMap$Node__f__next);
    }
  }
  $thiz.scm_HashMap__f_contentSize = ((1 + $thiz.scm_HashMap__f_contentSize) | 0);
  return null;
}
function $p_scm_HashMap__remove0__O__scm_HashMap$Node($thiz, elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  return $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)));
}
function $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, hash) {
  var idx = (hash & (($n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length - 1) | 0));
  var x1 = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(idx);
  if ((x1 === null)) {
    return null;
  } else if ((($n(x1).scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(x1).scm_HashMap$Node__f__key, elem))) {
    $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(idx, $n(x1).scm_HashMap$Node__f__next);
    $thiz.scm_HashMap__f_contentSize = (($thiz.scm_HashMap__f_contentSize - 1) | 0);
    return x1;
  } else {
    var prev = x1;
    var next = $n(x1).scm_HashMap$Node__f__next;
    while (((next !== null) && ($n(next).scm_HashMap$Node__f__hash <= hash))) {
      if ((($n(next).scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z($n(next).scm_HashMap$Node__f__key, elem))) {
        $n(prev).scm_HashMap$Node__f__next = $n(next).scm_HashMap$Node__f__next;
        $thiz.scm_HashMap__f_contentSize = (($thiz.scm_HashMap__f_contentSize - 1) | 0);
        return next;
      }
      prev = next;
      next = $n(next).scm_HashMap$Node__f__next;
    }
    return null;
  }
}
function $p_scm_HashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new HashMap table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashMap__f_contentSize === 0)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)(newlen);
  } else {
    var original = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = $asArrayOf_scm_HashMap$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashMap$Node(null, 0, null, null);
    var preHigh = new $c_scm_HashMap$Node(null, 0, null, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(i);
        if ((old !== null)) {
          preLow.scm_HashMap$Node__f__next = null;
          preHigh.scm_HashMap$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = $n(n).scm_HashMap$Node__f__next;
            if ((($n(n).scm_HashMap$Node__f__hash & oldlen) === 0)) {
              $n(lastLow).scm_HashMap$Node__f__next = n;
              lastLow = n;
            } else {
              $n(lastHigh).scm_HashMap$Node__f__next = n;
              lastHigh = n;
            }
            n = next;
          }
          $n(lastLow).scm_HashMap$Node__f__next = null;
          if ((old !== preLow.scm_HashMap$Node__f__next)) {
            $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(i, preLow.scm_HashMap$Node__f__next);
          }
          if ((preHigh.scm_HashMap$Node__f__next !== null)) {
            $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).set(((i + oldlen) | 0), preHigh.scm_HashMap$Node__f__next);
            $n(lastHigh).scm_HashMap$Node__f__next = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
function $p_scm_HashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = ((capacity - 1) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
function $p_scm_HashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashMap__f_loadFactor));
}
function $ct_scm_HashMap__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashMap__f_loadFactor = loadFactor;
  $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)($p_scm_HashMap__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, $n($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length);
  $thiz.scm_HashMap__f_contentSize = 0;
  return $thiz;
}
function $ct_scm_HashMap__($thiz) {
  $ct_scm_HashMap__I__D__($thiz, 16, 0.75);
  return $thiz;
}
/** @constructor */
function $c_scm_HashMap() {
  this.scm_HashMap__f_loadFactor = 0.0;
  this.scm_HashMap__f_scala$collection$mutable$HashMap$$table = null;
  this.scm_HashMap__f_threshold = 0;
  this.scm_HashMap__f_contentSize = 0;
}
$c_scm_HashMap.prototype = new $h_scm_AbstractMap();
$c_scm_HashMap.prototype.constructor = $c_scm_HashMap;
/** @constructor */
function $h_scm_HashMap() {
}
$h_scm_HashMap.prototype = $c_scm_HashMap.prototype;
$c_scm_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$c_scm_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_HashMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_scm_HashMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_HashMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_HashMap.prototype.size__I = (function() {
  return this.scm_HashMap__f_contentSize;
});
$c_scm_HashMap.prototype.contains__O__Z = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length - 1) | 0)));
  return (((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash)) !== null);
});
$c_scm_HashMap.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashMap__f_loadFactor)));
  if ((target > $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length)) {
    $p_scm_HashMap__growTable__I__V(this, target);
  }
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_HashMap = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    var this$2 = $n(x2);
    var f = new $c_sr_AbstractFunction3_$$Lambda$d1e06cbab540de4f9f09e7182f18ea80659b9825(((k$2$2, v$2$2, h$2$2) => {
      var h$2 = $uI(h$2$2);
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, k$2$2, v$2$2, (h$2 ^ ((h$2 >>> 16) | 0)), false);
    }));
    $n(this$2.sci_HashMap__f_rootNode).foreachWithHash__F3__V(f);
    return this;
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = $n(x3).nodeIterator__sc_Iterator();
    while ($n(iter).hasNext__Z()) {
      var next = $as_scm_HashMap$Node($n(iter).next__O());
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, $n(next).scm_HashMap$Node__f__key, $n(next).scm_HashMap$Node__f__value, $n(next).scm_HashMap$Node__f__hash, false);
    }
    return this;
  } else if (false) {
    var x4 = $as_scm_LinkedHashMap(xs);
    var iter$2 = $n(x4).entryIterator__sc_Iterator();
    while ($n(iter$2).hasNext__Z()) {
      var entry = $as_scm_LinkedHashMap$LinkedEntry($n(iter$2).next__O());
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, $n(entry).key__O(), $n(entry).value__O(), $n(entry).hash__I(), false);
    }
    return this;
  } else if ($is_scm_Map(xs)) {
    var x5 = $as_scm_Map(xs);
    $n(x5).foreachEntry__F2__V(new $c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((key$2$2, value$2$2) => {
      var originalHash = $m_sr_Statics$().anyHash__O__I(key$2$2);
      return $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, key$2$2, value$2$2, (originalHash ^ ((originalHash >>> 16) | 0)), false);
    })));
    return this;
  } else {
    return $as_scm_HashMap($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$c_scm_HashMap.prototype.iterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$1(this));
});
$c_scm_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$3(this));
});
$c_scm_HashMap.prototype.nodeIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$4(this));
});
$c_scm_HashMap.prototype.get__O__s_Option = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length - 1) | 0)));
  var x1$1 = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $m_s_None$() : new $c_s_Some($n(x1$1).scm_HashMap$Node__f__value));
});
$c_scm_HashMap.prototype.apply__O__O = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length - 1) | 0)));
  var x1$1 = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $f_sc_MapOps__default__O__O(this, key) : $n(x1$1).scm_HashMap$Node__f__value);
});
$c_scm_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get((hash & (($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length - 1) | 0)));
    var nd = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
    return ((nd === null) ? $n(default$1).apply__O() : $n(nd).scm_HashMap$Node__f__value);
  }
});
$c_scm_HashMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & (($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length - 1) | 0));
    var x1 = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(idx);
    var nd = ((x1 === null) ? null : $n(x1).findNode__O__I__scm_HashMap$Node(key, hash));
    if ((nd !== null)) {
      return $n(nd).scm_HashMap$Node__f__value;
    } else {
      var table0 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
      var default$1 = $n(defaultValue).apply__O();
      if ((((1 + this.scm_HashMap__f_contentSize) | 0) >= this.scm_HashMap__f_threshold)) {
        $p_scm_HashMap__growTable__I__V(this, ($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length << 1));
      }
      var newIdx = ((table0 === this.scm_HashMap__f_scala$collection$mutable$HashMap$$table) ? idx : (hash & (($n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length - 1) | 0)));
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, newIdx);
      return default$1;
    }
  }
});
$c_scm_HashMap.prototype.update__O__O__V = (function(key, value) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, false);
});
$c_scm_HashMap.prototype.addOne__T2__scm_HashMap = (function(elem) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, $n(elem)._1__O(), $n(elem)._2__O(), false);
  return this;
});
$c_scm_HashMap.prototype.subtractOne__O__scm_HashMap = (function(elem) {
  $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, elem);
  return this;
});
$c_scm_HashMap.prototype.knownSize__I = (function() {
  return this.scm_HashMap__f_contentSize;
});
$c_scm_HashMap.prototype.isEmpty__Z = (function() {
  return (this.scm_HashMap__f_contentSize === 0);
});
$c_scm_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  var len = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).u.length;
  var i = 0;
  while ((i < len)) {
    var n = $n(this.scm_HashMap__f_scala$collection$mutable$HashMap$$table).get(i);
    if ((n !== null)) {
      $n(n).foreachEntry__F2__V(f);
    }
    i = ((1 + i) | 0);
  }
});
$c_scm_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_HashMap$();
});
$c_scm_HashMap.prototype.stringPrefix__T = (function() {
  return "HashMap";
});
$c_scm_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var tupleHashIterator = new $c_scm_HashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
  }
});
$c_scm_HashMap.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_HashMap(elem);
});
$c_scm_HashMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_HashMap($as_T2(elem));
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_HashMap(elems);
});
function $as_scm_HashMap(obj) {
  return (((obj instanceof $c_scm_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap"));
}
function $isArrayOf_scm_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap)));
}
function $asArrayOf_scm_HashMap(obj, depth) {
  return (($isArrayOf_scm_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap;", depth));
}
var $d_scm_HashMap = new $TypeData().initClass($c_scm_HashMap, "scala.collection.mutable.HashMap", ({
  scm_HashMap: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedMapOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_package$$anon$1() {
}
$c_Lcats_package$$anon$1.prototype = new $h_O();
$c_Lcats_package$$anon$1.prototype.constructor = $c_Lcats_package$$anon$1;
/** @constructor */
function $h_Lcats_package$$anon$1() {
}
$h_Lcats_package$$anon$1.prototype = $c_Lcats_package$$anon$1.prototype;
$c_Lcats_package$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_package$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_package$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_package$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_package$$anon$1.prototype.unit__O = (function() {
  return (void 0);
});
$c_Lcats_package$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_package$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_package$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return $n(f).apply__O__O(sa);
});
$c_Lcats_package$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return $n(f).apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.pure__O__O = (function(a) {
  return a;
});
$c_Lcats_package$$anon$1.prototype.flatMap__O__F1__O = (function(a, f) {
  return $n(f).apply__O__O(a);
});
$c_Lcats_package$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  var a$tailLocal1 = a;
  while (true) {
    var x1 = $as_s_util_Either($n(f).apply__O__O(a$tailLocal1));
    if ((x1 instanceof $c_s_util_Left)) {
      var a1 = $n($as_s_util_Left(x1)).s_util_Left__f_value;
      a$tailLocal1 = a1;
      continue;
    }
    if ((x1 instanceof $c_s_util_Right)) {
      var b = $n($as_s_util_Right(x1)).s_util_Right__f_value;
      return b;
    }
    throw new $c_s_MatchError(x1);
  }
});
$c_Lcats_package$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return $n(f).apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return ffa;
});
$c_Lcats_package$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $n(f).apply__O__O__O(fa, fb);
});
$c_Lcats_package$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$8) => $n(f).apply__O__O__O(fa, _$8))));
});
$c_Lcats_package$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  return $n(f).apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(a, lb, f) {
  return $as_Lcats_Eval($n(f).apply__O__O__O(a, lb));
});
$c_Lcats_package$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return $n(f).apply__O__O(fa);
});
var $d_Lcats_package$$anon$1 = new $TypeData().initClass($c_Lcats_package$$anon$1, "cats.package$$anon$1", ({
  Lcats_package$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Reducible: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Distributive: 1
}));
function $ct_sci_BigVector__AO__AO__I__($thiz, _prefix1, suffix1, length0) {
  $thiz.sci_BigVector__f_suffix1 = suffix1;
  $thiz.sci_BigVector__f_length0 = length0;
  $ct_sci_Vector__AO__($thiz, _prefix1);
  return $thiz;
}
/** @constructor */
function $c_sci_BigVector() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
}
$c_sci_BigVector.prototype = new $h_sci_VectorImpl();
$c_sci_BigVector.prototype.constructor = $c_sci_BigVector;
/** @constructor */
function $h_sci_BigVector() {
}
$h_sci_BigVector.prototype = $c_sci_BigVector.prototype;
$c_sci_BigVector.prototype.foreachRest__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 1;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = (((c + ((c >>> 31) | 0)) | 0) >> 1);
    var a = ((idx - c$1) | 0);
    var sign = (a >> 31);
    $x_1.foreachRec__I__AO__F1__V(((((((1 + c$1) | 0) - (((a ^ sign) - sign) | 0)) | 0) - 1) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0);
  }
});
function $as_sci_BigVector(obj) {
  return (((obj instanceof $c_sci_BigVector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BigVector"));
}
function $isArrayOf_sci_BigVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BigVector)));
}
function $asArrayOf_sci_BigVector(obj, depth) {
  return (($isArrayOf_sci_BigVector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BigVector;", depth));
}
/** @constructor */
function $c_sci_Queue$EmptyQueue$() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null;
  $ct_sci_Queue__sci_List__sci_List__(this, $m_sci_Nil$(), $m_sci_Nil$());
}
$c_sci_Queue$EmptyQueue$.prototype = new $h_sci_Queue();
$c_sci_Queue$EmptyQueue$.prototype.constructor = $c_sci_Queue$EmptyQueue$;
/** @constructor */
function $h_sci_Queue$EmptyQueue$() {
}
$h_sci_Queue$EmptyQueue$.prototype = $c_sci_Queue$EmptyQueue$.prototype;
var $d_sci_Queue$EmptyQueue$ = new $TypeData().initClass($c_sci_Queue$EmptyQueue$, "scala.collection.immutable.Queue$EmptyQueue$", ({
  sci_Queue$EmptyQueue$: 1,
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Queue$EmptyQueue$;
function $m_sci_Queue$EmptyQueue$() {
  if ((!$n_sci_Queue$EmptyQueue$)) {
    $n_sci_Queue$EmptyQueue$ = new $c_sci_Queue$EmptyQueue$();
  }
  return $n_sci_Queue$EmptyQueue$;
}
/** @constructor */
function $c_sci_Vector1(_data1) {
  this.sci_Vector__f_prefix1 = null;
  $ct_sci_Vector__AO__(this, _data1);
}
$c_sci_Vector1.prototype = new $h_sci_VectorImpl();
$c_sci_Vector1.prototype.constructor = $c_sci_Vector1;
/** @constructor */
function $h_sci_Vector1() {
}
$h_sci_Vector1.prototype = $c_sci_Vector1.prototype;
$c_sci_Vector1.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < $n(this.sci_Vector__f_prefix1).u.length))) {
    return $n(this.sci_Vector__f_prefix1).get(index);
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector1.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < $n(this.sci_Vector__f_prefix1).u.length))) {
    var a1 = this.sci_Vector__f_prefix1;
    var this$2 = $n(a1);
    var a1c = this$2.clone__O();
    a1c.set(index, elem);
    return new $c_sci_Vector1(a1c);
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector1.prototype.appended__O__sci_Vector = (function(elem) {
  var len1 = $n(this.sci_Vector__f_prefix1).u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_Vector__f_prefix1, elem));
  } else {
    var $x_2 = this.sci_Vector__f_prefix1;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a = new $ac_O(1);
    a.set(0, elem);
    return new $c_sci_Vector2($x_2, 32, $x_1, a, 33);
  }
});
$c_sci_Vector1.prototype.prepended__O__sci_Vector = (function(elem) {
  var len1 = $n(this.sci_Vector__f_prefix1).u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1));
  } else {
    var a = new $ac_O(1);
    a.set(0, elem);
    return new $c_sci_Vector2(a, 1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2, this.sci_Vector__f_prefix1, ((1 + len1) | 0));
  }
});
$c_sci_Vector1.prototype.map__F1__sci_Vector = (function(f) {
  return new $c_sci_Vector1($m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f));
});
$c_sci_Vector1.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var original = this.sci_Vector__f_prefix1;
  return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, lo, hi));
});
$c_sci_Vector1.prototype.tail__sci_Vector = (function() {
  if (($n(this.sci_Vector__f_prefix1).u.length === 1)) {
    return $m_sci_Vector0$();
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to));
  }
});
$c_sci_Vector1.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_Vector__f_prefix1).u.length === 1)) {
    return $m_sci_Vector0$();
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = (($n(a).u.length - 1) | 0);
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to));
  }
});
$c_sci_Vector1.prototype.vectorSliceCount__I = (function() {
  return 1;
});
$c_sci_Vector1.prototype.vectorSlice__I__AO = (function(idx) {
  return this.sci_Vector__f_prefix1;
});
$c_sci_Vector1.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var data1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, suffix);
  return ((data1b !== null) ? new $c_sci_Vector1(data1b) : $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k));
});
$c_sci_Vector1.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector1.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector1.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector1.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector1.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < $n(this.sci_Vector__f_prefix1).u.length))) {
    return $n(this.sci_Vector__f_prefix1).get(index);
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector1(obj) {
  return (((obj instanceof $c_sci_Vector1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector1"));
}
function $isArrayOf_sci_Vector1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector1)));
}
function $asArrayOf_sci_Vector1(obj, depth) {
  return (($isArrayOf_sci_Vector1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector1;", depth));
}
var $d_sci_Vector1 = new $TypeData().initClass($c_sci_Vector1, "scala.collection.immutable.Vector1", ({
  sci_Vector1: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_$colon$colon(head, next) {
  this.sci_$colon$colon__f_head = null;
  this.sci_$colon$colon__f_next = null;
  this.sci_$colon$colon__f_head = head;
  this.sci_$colon$colon__f_next = next;
}
$c_sci_$colon$colon.prototype = new $h_sci_List();
$c_sci_$colon$colon.prototype.constructor = $c_sci_$colon$colon;
/** @constructor */
function $h_sci_$colon$colon() {
}
$h_sci_$colon$colon.prototype = $c_sci_$colon$colon.prototype;
$c_sci_$colon$colon.prototype.head__O = (function() {
  return this.sci_$colon$colon__f_head;
});
$c_sci_$colon$colon.prototype.productPrefix__T = (function() {
  return "::";
});
$c_sci_$colon$colon.prototype.productArity__I = (function() {
  return 2;
});
$c_sci_$colon$colon.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_$colon$colon__f_head;
      break;
    }
    case 1: {
      return this.sci_$colon$colon__f_next;
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_sci_$colon$colon.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_$colon$colon.prototype.tail__O = (function() {
  return this.sci_$colon$colon__f_next;
});
$c_sci_$colon$colon.prototype.headOption__s_Option = (function() {
  return new $c_s_Some(this.sci_$colon$colon__f_head);
});
function $as_sci_$colon$colon(obj) {
  return (((obj instanceof $c_sci_$colon$colon) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.$colon$colon"));
}
function $isArrayOf_sci_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_$colon$colon)));
}
function $asArrayOf_sci_$colon$colon(obj, depth) {
  return (($isArrayOf_sci_$colon$colon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.$colon$colon;", depth));
}
var $d_sci_$colon$colon = new $TypeData().initClass($c_sci_$colon$colon, "scala.collection.immutable.$colon$colon", ({
  sci_$colon$colon: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
}));
/** @constructor */
function $c_sci_Nil$() {
}
$c_sci_Nil$.prototype = new $h_sci_List();
$c_sci_Nil$.prototype.constructor = $c_sci_Nil$;
/** @constructor */
function $h_sci_Nil$() {
}
$h_sci_Nil$.prototype = $c_sci_Nil$.prototype;
$c_sci_Nil$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty list");
});
$c_sci_Nil$.prototype.tail__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty list");
});
$c_sci_Nil$.prototype.last__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty list");
});
$c_sci_Nil$.prototype.init__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "init of empty list");
});
$c_sci_Nil$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Nil$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Nil$.prototype.productPrefix__T = (function() {
  return "Nil";
});
$c_sci_Nil$.prototype.productArity__I = (function() {
  return 0;
});
$c_sci_Nil$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sci_Nil$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_Nil$.prototype.init__O = (function() {
  this.init__E();
});
$c_sci_Nil$.prototype.last__O = (function() {
  this.last__E();
});
$c_sci_Nil$.prototype.tail__O = (function() {
  this.tail__E();
});
$c_sci_Nil$.prototype.headOption__s_Option = (function() {
  return $m_s_None$();
});
$c_sci_Nil$.prototype.head__O = (function() {
  this.head__E();
});
var $d_sci_Nil$ = new $TypeData().initClass($c_sci_Nil$, "scala.collection.immutable.Nil$", ({
  sci_Nil$: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
}));
var $n_sci_Nil$;
function $m_sci_Nil$() {
  if ((!$n_sci_Nil$)) {
    $n_sci_Nil$ = new $c_sci_Nil$();
  }
  return $n_sci_Nil$;
}
/** @constructor */
function $c_sci_Vector0$() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  $ct_sci_BigVector__AO__AO__I__(this, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, 0);
}
$c_sci_Vector0$.prototype = new $h_sci_BigVector();
$c_sci_Vector0$.prototype.constructor = $c_sci_Vector0$;
/** @constructor */
function $h_sci_Vector0$() {
}
$h_sci_Vector0$.prototype = $c_sci_Vector0$.prototype;
$c_sci_Vector0$.prototype.apply__I__E = (function(index) {
  throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
});
$c_sci_Vector0$.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
});
$c_sci_Vector0$.prototype.appended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.set(0, elem);
  return new $c_sci_Vector1(a);
});
$c_sci_Vector0$.prototype.prepended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.set(0, elem);
  return new $c_sci_Vector1(a);
});
$c_sci_Vector0$.prototype.tail__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.tail");
});
$c_sci_Vector0$.prototype.init__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.init");
});
$c_sci_Vector0$.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  return this;
});
$c_sci_Vector0$.prototype.vectorSliceCount__I = (function() {
  return 0;
});
$c_sci_Vector0$.prototype.vectorSlice__I__AO = (function(idx) {
  return null;
});
$c_sci_Vector0$.prototype.equals__O__Z = (function(o) {
  return ((this === o) || ((!(o instanceof $c_sci_Vector)) && $f_sc_Seq__equals__O__Z(this, o)));
});
$c_sci_Vector0$.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(suffix);
});
$c_sci_Vector0$.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (empty vector)"));
});
$c_sci_Vector0$.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector0$.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector0$.prototype.map__F1__O = (function(f) {
  return this;
});
$c_sci_Vector0$.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector0$.prototype.apply__O__O = (function(v1) {
  this.apply__I__E($uI(v1));
});
$c_sci_Vector0$.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i);
});
var $d_sci_Vector0$ = new $TypeData().initClass($c_sci_Vector0$, "scala.collection.immutable.Vector0$", ({
  sci_Vector0$: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
var $n_sci_Vector0$;
function $m_sci_Vector0$() {
  if ((!$n_sci_Vector0$)) {
    $n_sci_Vector0$ = new $c_sci_Vector0$();
  }
  return $n_sci_Vector0$;
}
/** @constructor */
function $c_sci_Vector2(_prefix1, len1, data2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector2__f_len1 = 0;
  this.sci_Vector2__f_data2 = null;
  this.sci_Vector2__f_len1 = len1;
  this.sci_Vector2__f_data2 = data2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector2.prototype = new $h_sci_BigVector();
$c_sci_Vector2.prototype.constructor = $c_sci_Vector2;
/** @constructor */
function $h_sci_Vector2() {
}
$h_sci_Vector2.prototype = $c_sci_Vector2.prototype;
$c_sci_Vector2.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < $n(this.sci_Vector2__f_data2).u.length) ? $n($n(this.sci_Vector2__f_data2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get((31 & io)));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector2.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector2__f_len1)) {
      var io = ((index - this.sci_Vector2__f_len1) | 0);
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      if ((i2 < $n(this.sci_Vector2__f_data2).u.length)) {
        var a2 = this.sci_Vector2__f_data2;
        var this$2 = $n(a2);
        var a2c = this$2.clone__O();
        var a1 = a2c.get(i2);
        var this$3 = $n(a1);
        var a1c = this$3.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector2__f_len1;
        var x$4 = this.sci_BigVector__f_suffix1;
        var x$5 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$2, x$3, a2c, x$4, x$5);
      } else {
        var a1$1 = this.sci_BigVector__f_suffix1;
        var this$5 = $n(a1$1);
        var a1c$1 = this$5.clone__O();
        a1c$1.set(i1, elem);
        var x$7 = this.sci_Vector__f_prefix1;
        var x$8 = this.sci_Vector2__f_len1;
        var x$9 = this.sci_Vector2__f_data2;
        var x$10 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$7, x$8, x$9, a1c$1, x$10);
      }
    } else {
      var a1$2 = this.sci_Vector__f_prefix1;
      var this$7 = $n(a1$2);
      var a1c$2 = this$7.clone__O();
      a1c$2.set(index, elem);
      var len1 = this.sci_Vector2__f_len1;
      var data2 = this.sci_Vector2__f_data2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector2(a1c$2, len1, data2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector2.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2);
  } else if (($n(this.sci_Vector2__f_data2).u.length < 30)) {
    var x$6 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$8 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$9 = this.sci_Vector__f_prefix1;
    var x$10 = this.sci_Vector2__f_len1;
    return new $c_sci_Vector2(x$9, x$10, x$6, a, x$8);
  } else {
    var $x_5 = this.sci_Vector__f_prefix1;
    var $x_4 = this.sci_Vector2__f_len1;
    var $x_3 = this.sci_Vector2__f_data2;
    var $x_2 = this.sci_Vector2__f_len1;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = this.sci_BigVector__f_suffix1;
    var a$1 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$1.set(0, x);
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    return new $c_sci_Vector3($x_5, $x_4, $x_3, ((960 + $x_2) | 0), $x_1, a$1, a$2, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector2.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector2__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector2__f_len1) | 0);
    var x$3 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3);
  } else if (($n(this.sci_Vector2__f_data2).u.length < 30)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$8 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector2__f_data2), 2);
    var x$9 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$10 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(a, 1, x$8, x$10, x$9);
  } else {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x = this.sci_Vector__f_prefix1;
    var a$2 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$2.set(0, x);
    return new $c_sci_Vector3(a$1, 1, a$2, ((1 + this.sci_Vector2__f_len1) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3, this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector2.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector2__f_data2, f), 2);
  var x$3 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$4 = this.sci_Vector2__f_len1;
  var x$5 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector2(x$1, x$4, x$2, x$3, x$5);
});
$c_sci_Vector2.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector2__f_data2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector2.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector2__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = ((this.sci_Vector2__f_len1 - 1) | 0);
    var x$3 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector2.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (($n(a).u.length - 1) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, ((this.sci_BigVector__f_length0 - 1) | 0));
  }
});
$c_sci_Vector2.prototype.vectorSliceCount__I = (function() {
  return 3;
});
$c_sci_Vector2.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector2__f_data2;
      break;
    }
    case 2: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector2.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector2.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector2.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector2.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector2.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector2.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < $n(this.sci_Vector2__f_data2).u.length) ? $n($n(this.sci_Vector2__f_data2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get((31 & io)));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector2(obj) {
  return (((obj instanceof $c_sci_Vector2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector2"));
}
function $isArrayOf_sci_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector2)));
}
function $asArrayOf_sci_Vector2(obj, depth) {
  return (($isArrayOf_sci_Vector2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector2;", depth));
}
var $d_sci_Vector2 = new $TypeData().initClass($c_sci_Vector2, "scala.collection.immutable.Vector2", ({
  sci_Vector2: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Vector3(_prefix1, len1, prefix2, len12, data3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector3__f_len1 = 0;
  this.sci_Vector3__f_prefix2 = null;
  this.sci_Vector3__f_len12 = 0;
  this.sci_Vector3__f_data3 = null;
  this.sci_Vector3__f_suffix2 = null;
  this.sci_Vector3__f_len1 = len1;
  this.sci_Vector3__f_prefix2 = prefix2;
  this.sci_Vector3__f_len12 = len12;
  this.sci_Vector3__f_data3 = data3;
  this.sci_Vector3__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector3.prototype = new $h_sci_BigVector();
$c_sci_Vector3.prototype.constructor = $c_sci_Vector3;
/** @constructor */
function $h_sci_Vector3() {
}
$h_sci_Vector3.prototype = $c_sci_Vector3.prototype;
$c_sci_Vector3.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < $n(this.sci_Vector3__f_data3).u.length) ? $n($n($n(this.sci_Vector3__f_data3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector3__f_suffix2).u.length) ? $n($n(this.sci_Vector3__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)));
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return $n($n(this.sci_Vector3__f_prefix2).get(((io$2 >>> 5) | 0))).get((31 & io$2));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector3.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector3__f_len12)) {
      var io = ((index - this.sci_Vector3__f_len12) | 0);
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i3 < $n(this.sci_Vector3__f_data3).u.length)) {
        var a3 = this.sci_Vector3__f_data3;
        var this$2 = $n(a3);
        var a3c = this$2.clone__O();
        var a2 = a3c.get(i3);
        var this$3 = $n(a2);
        var a2c = this$3.clone__O();
        var a1 = a2c.get(i2);
        var this$4 = $n(a1);
        var a1c = this$4.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector3__f_len1;
        var x$4 = this.sci_Vector3__f_prefix2;
        var x$5 = this.sci_Vector3__f_len12;
        var x$6 = this.sci_Vector3__f_suffix2;
        var x$7 = this.sci_BigVector__f_suffix1;
        var x$8 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$2, x$3, x$4, x$5, a3c, x$6, x$7, x$8);
      } else if ((i2 < $n(this.sci_Vector3__f_suffix2).u.length)) {
        var a2$1 = this.sci_Vector3__f_suffix2;
        var this$6 = $n(a2$1);
        var a2c$1 = this$6.clone__O();
        var a1$1 = a2c$1.get(i2);
        var this$7 = $n(a1$1);
        var a1c$1 = this$7.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        var x$10 = this.sci_Vector__f_prefix1;
        var x$11 = this.sci_Vector3__f_len1;
        var x$12 = this.sci_Vector3__f_prefix2;
        var x$13 = this.sci_Vector3__f_len12;
        var x$14 = this.sci_Vector3__f_data3;
        var x$15 = this.sci_BigVector__f_suffix1;
        var x$16 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$10, x$11, x$12, x$13, x$14, a2c$1, x$15, x$16);
      } else {
        var a1$2 = this.sci_BigVector__f_suffix1;
        var this$9 = $n(a1$2);
        var a1c$2 = this$9.clone__O();
        a1c$2.set(i1, elem);
        var x$18 = this.sci_Vector__f_prefix1;
        var x$19 = this.sci_Vector3__f_len1;
        var x$20 = this.sci_Vector3__f_prefix2;
        var x$21 = this.sci_Vector3__f_len12;
        var x$22 = this.sci_Vector3__f_data3;
        var x$23 = this.sci_Vector3__f_suffix2;
        var x$24 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$18, x$19, x$20, x$21, x$22, x$23, a1c$2, x$24);
      }
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      var a2$2 = this.sci_Vector3__f_prefix2;
      var idx2 = ((io$2 >>> 5) | 0);
      var idx1 = (31 & io$2);
      var this$11 = $n(a2$2);
      var a2c$2 = this$11.clone__O();
      var a1$3 = a2c$2.get(idx2);
      var this$12 = $n(a1$3);
      var a1c$3 = this$12.clone__O();
      a1c$3.set(idx1, elem);
      a2c$2.set(idx2, a1c$3);
      var x$26 = this.sci_Vector__f_prefix1;
      var x$27 = this.sci_Vector3__f_len1;
      var x$28 = this.sci_Vector3__f_len12;
      var x$29 = this.sci_Vector3__f_data3;
      var x$30 = this.sci_Vector3__f_suffix2;
      var x$31 = this.sci_BigVector__f_suffix1;
      var x$32 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(x$26, x$27, a2c$2, x$28, x$29, x$30, x$31, x$32);
    } else {
      var a1$4 = this.sci_Vector__f_prefix1;
      var this$14 = $n(a1$4);
      var a1c$4 = this$14.clone__O();
      a1c$4.set(index, elem);
      var len1 = this.sci_Vector3__f_len1;
      var prefix2 = this.sci_Vector3__f_prefix2;
      var len12 = this.sci_Vector3__f_len12;
      var data3 = this.sci_Vector3__f_data3;
      var suffix2 = this.sci_Vector3__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(a1c$4, len1, prefix2, len12, data3, suffix2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector3.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2);
  } else if (($n(this.sci_Vector3__f_suffix2).u.length < 31)) {
    var x$9 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$11 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$12 = this.sci_Vector__f_prefix1;
    var x$13 = this.sci_Vector3__f_len1;
    var x$14 = this.sci_Vector3__f_prefix2;
    var x$15 = this.sci_Vector3__f_len12;
    var x$16 = this.sci_Vector3__f_data3;
    return new $c_sci_Vector3(x$12, x$13, x$14, x$15, x$16, x$9, a, x$11);
  } else if (($n(this.sci_Vector3__f_data3).u.length < 30)) {
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_data3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector3__f_len1;
    var x$23 = this.sci_Vector3__f_prefix2;
    var x$24 = this.sci_Vector3__f_len12;
    return new $c_sci_Vector3(x$21, x$22, x$23, x$24, x$17, x$18, a$1, x$20);
  } else {
    var $x_8 = this.sci_Vector__f_prefix1;
    var $x_7 = this.sci_Vector3__f_len1;
    var $x_6 = this.sci_Vector3__f_prefix2;
    var $x_5 = this.sci_Vector3__f_len12;
    var $x_4 = this.sci_Vector3__f_data3;
    var $x_3 = this.sci_Vector3__f_len12;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a$2 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$2.set(0, x);
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    return new $c_sci_Vector4($x_8, $x_7, $x_6, $x_5, $x_4, ((30720 + $x_3) | 0), $x_2, a$2, $x_1, a$3, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector3.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector3__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector3__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$4 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4);
  } else if ((this.sci_Vector3__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$11 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var x$12 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$13 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$14 = this.sci_Vector3__f_data3;
    var x$15 = this.sci_Vector3__f_suffix2;
    var x$16 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a, 1, x$11, x$12, x$14, x$15, x$16, x$13);
  } else if (($n(this.sci_Vector3__f_data3).u.length < 30)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$21 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), this.sci_Vector3__f_data3), 3);
    var x$22 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$23 = this.sci_Vector3__f_suffix2;
    var x$24 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a$1, 1, x$19, 1, x$21, x$23, x$24, x$22);
  } else {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.set(0, x);
    return new $c_sci_Vector4(a$2, 1, $x_1, 1, a$3, ((1 + this.sci_Vector3__f_len12) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4, this.sci_Vector3__f_data3, this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector3.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector3__f_data3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_suffix2, f), 2);
  var x$5 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$6 = this.sci_Vector3__f_len1;
  var x$7 = this.sci_Vector3__f_len12;
  var x$8 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector3(x$1, x$6, x$2, x$7, x$3, x$4, x$5, x$8);
});
$c_sci_Vector3.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector3__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector3__f_data3);
  b.consider__I__AO__V(2, this.sci_Vector3__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector3.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector3__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = ((this.sci_Vector3__f_len1 - 1) | 0);
    var x$3 = ((this.sci_Vector3__f_len12 - 1) | 0);
    var x$4 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector3.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (($n(a).u.length - 1) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, ((this.sci_BigVector__f_length0 - 1) | 0));
  }
});
$c_sci_Vector3.prototype.vectorSliceCount__I = (function() {
  return 5;
});
$c_sci_Vector3.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector3__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector3__f_data3;
      break;
    }
    case 3: {
      return this.sci_Vector3__f_suffix2;
      break;
    }
    case 4: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector3.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector3.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector3.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector3.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector3.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector3.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < $n(this.sci_Vector3__f_data3).u.length) ? $n($n($n(this.sci_Vector3__f_data3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector3__f_suffix2).u.length) ? $n($n(this.sci_Vector3__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)));
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return $n($n(this.sci_Vector3__f_prefix2).get(((io$2 >>> 5) | 0))).get((31 & io$2));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector3(obj) {
  return (((obj instanceof $c_sci_Vector3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector3"));
}
function $isArrayOf_sci_Vector3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector3)));
}
function $asArrayOf_sci_Vector3(obj, depth) {
  return (($isArrayOf_sci_Vector3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector3;", depth));
}
var $d_sci_Vector3 = new $TypeData().initClass($c_sci_Vector3, "scala.collection.immutable.Vector3", ({
  sci_Vector3: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Vector4(_prefix1, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector4__f_len1 = 0;
  this.sci_Vector4__f_prefix2 = null;
  this.sci_Vector4__f_len12 = 0;
  this.sci_Vector4__f_prefix3 = null;
  this.sci_Vector4__f_len123 = 0;
  this.sci_Vector4__f_data4 = null;
  this.sci_Vector4__f_suffix3 = null;
  this.sci_Vector4__f_suffix2 = null;
  this.sci_Vector4__f_len1 = len1;
  this.sci_Vector4__f_prefix2 = prefix2;
  this.sci_Vector4__f_len12 = len12;
  this.sci_Vector4__f_prefix3 = prefix3;
  this.sci_Vector4__f_len123 = len123;
  this.sci_Vector4__f_data4 = data4;
  this.sci_Vector4__f_suffix3 = suffix3;
  this.sci_Vector4__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector4.prototype = new $h_sci_BigVector();
$c_sci_Vector4.prototype.constructor = $c_sci_Vector4;
/** @constructor */
function $h_sci_Vector4() {
}
$h_sci_Vector4.prototype = $c_sci_Vector4.prototype;
$c_sci_Vector4.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < $n(this.sci_Vector4__f_data4).u.length) ? $n($n($n($n(this.sci_Vector4__f_data4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector4__f_suffix3).u.length) ? $n($n($n(this.sci_Vector4__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector4__f_suffix2).u.length) ? $n($n(this.sci_Vector4__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))));
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return $n($n($n(this.sci_Vector4__f_prefix3).get(((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return $n($n(this.sci_Vector4__f_prefix2).get(((io$3 >>> 5) | 0))).get((31 & io$3));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector4.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector4__f_len123)) {
      var io = ((index - this.sci_Vector4__f_len123) | 0);
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i4 < $n(this.sci_Vector4__f_data4).u.length)) {
        var a4 = this.sci_Vector4__f_data4;
        var this$2 = $n(a4);
        var a4c = this$2.clone__O();
        var a3 = a4c.get(i4);
        var this$3 = $n(a3);
        var a3c = this$3.clone__O();
        var a2 = a3c.get(i3);
        var this$4 = $n(a2);
        var a2c = this$4.clone__O();
        var a1 = a2c.get(i2);
        var this$5 = $n(a1);
        var a1c = this$5.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector4__f_len1;
        var x$4 = this.sci_Vector4__f_prefix2;
        var x$5 = this.sci_Vector4__f_len12;
        var x$6 = this.sci_Vector4__f_prefix3;
        var x$7 = this.sci_Vector4__f_len123;
        var x$8 = this.sci_Vector4__f_suffix3;
        var x$9 = this.sci_Vector4__f_suffix2;
        var x$10 = this.sci_BigVector__f_suffix1;
        var x$11 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$2, x$3, x$4, x$5, x$6, x$7, a4c, x$8, x$9, x$10, x$11);
      } else if ((i3 < $n(this.sci_Vector4__f_suffix3).u.length)) {
        var a3$1 = this.sci_Vector4__f_suffix3;
        var this$7 = $n(a3$1);
        var a3c$1 = this$7.clone__O();
        var a2$1 = a3c$1.get(i3);
        var this$8 = $n(a2$1);
        var a2c$1 = this$8.clone__O();
        var a1$1 = a2c$1.get(i2);
        var this$9 = $n(a1$1);
        var a1c$1 = this$9.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        var x$13 = this.sci_Vector__f_prefix1;
        var x$14 = this.sci_Vector4__f_len1;
        var x$15 = this.sci_Vector4__f_prefix2;
        var x$16 = this.sci_Vector4__f_len12;
        var x$17 = this.sci_Vector4__f_prefix3;
        var x$18 = this.sci_Vector4__f_len123;
        var x$19 = this.sci_Vector4__f_data4;
        var x$20 = this.sci_Vector4__f_suffix2;
        var x$21 = this.sci_BigVector__f_suffix1;
        var x$22 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$13, x$14, x$15, x$16, x$17, x$18, x$19, a3c$1, x$20, x$21, x$22);
      } else if ((i2 < $n(this.sci_Vector4__f_suffix2).u.length)) {
        var a2$2 = this.sci_Vector4__f_suffix2;
        var this$11 = $n(a2$2);
        var a2c$2 = this$11.clone__O();
        var a1$2 = a2c$2.get(i2);
        var this$12 = $n(a1$2);
        var a1c$2 = this$12.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        var x$24 = this.sci_Vector__f_prefix1;
        var x$25 = this.sci_Vector4__f_len1;
        var x$26 = this.sci_Vector4__f_prefix2;
        var x$27 = this.sci_Vector4__f_len12;
        var x$28 = this.sci_Vector4__f_prefix3;
        var x$29 = this.sci_Vector4__f_len123;
        var x$30 = this.sci_Vector4__f_data4;
        var x$31 = this.sci_Vector4__f_suffix3;
        var x$32 = this.sci_BigVector__f_suffix1;
        var x$33 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, a2c$2, x$32, x$33);
      } else {
        var a1$3 = this.sci_BigVector__f_suffix1;
        var this$14 = $n(a1$3);
        var a1c$3 = this$14.clone__O();
        a1c$3.set(i1, elem);
        var x$35 = this.sci_Vector__f_prefix1;
        var x$36 = this.sci_Vector4__f_len1;
        var x$37 = this.sci_Vector4__f_prefix2;
        var x$38 = this.sci_Vector4__f_len12;
        var x$39 = this.sci_Vector4__f_prefix3;
        var x$40 = this.sci_Vector4__f_len123;
        var x$41 = this.sci_Vector4__f_data4;
        var x$42 = this.sci_Vector4__f_suffix3;
        var x$43 = this.sci_Vector4__f_suffix2;
        var x$44 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, a1c$3, x$44);
      }
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      var a3$2 = this.sci_Vector4__f_prefix3;
      var idx3 = ((io$2 >>> 10) | 0);
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var this$16 = $n(a3$2);
      var a3c$2 = this$16.clone__O();
      var a2$3 = a3c$2.get(idx3);
      var this$17 = $n(a2$3);
      var a2c$3 = this$17.clone__O();
      var a1$4 = a2c$3.get(idx2);
      var this$18 = $n(a1$4);
      var a1c$4 = this$18.clone__O();
      a1c$4.set(idx1, elem);
      a2c$3.set(idx2, a1c$4);
      a3c$2.set(idx3, a2c$3);
      var x$46 = this.sci_Vector__f_prefix1;
      var x$47 = this.sci_Vector4__f_len1;
      var x$48 = this.sci_Vector4__f_prefix2;
      var x$49 = this.sci_Vector4__f_len12;
      var x$50 = this.sci_Vector4__f_len123;
      var x$51 = this.sci_Vector4__f_data4;
      var x$52 = this.sci_Vector4__f_suffix3;
      var x$53 = this.sci_Vector4__f_suffix2;
      var x$54 = this.sci_BigVector__f_suffix1;
      var x$55 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$46, x$47, x$48, x$49, a3c$2, x$50, x$51, x$52, x$53, x$54, x$55);
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      var a2$4 = this.sci_Vector4__f_prefix2;
      var idx2$1 = ((io$3 >>> 5) | 0);
      var idx1$1 = (31 & io$3);
      var this$20 = $n(a2$4);
      var a2c$4 = this$20.clone__O();
      var a1$5 = a2c$4.get(idx2$1);
      var this$21 = $n(a1$5);
      var a1c$5 = this$21.clone__O();
      a1c$5.set(idx1$1, elem);
      a2c$4.set(idx2$1, a1c$5);
      var x$57 = this.sci_Vector__f_prefix1;
      var x$58 = this.sci_Vector4__f_len1;
      var x$59 = this.sci_Vector4__f_len12;
      var x$60 = this.sci_Vector4__f_prefix3;
      var x$61 = this.sci_Vector4__f_len123;
      var x$62 = this.sci_Vector4__f_data4;
      var x$63 = this.sci_Vector4__f_suffix3;
      var x$64 = this.sci_Vector4__f_suffix2;
      var x$65 = this.sci_BigVector__f_suffix1;
      var x$66 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$57, x$58, a2c$4, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66);
    } else {
      var a1$6 = this.sci_Vector__f_prefix1;
      var this$23 = $n(a1$6);
      var a1c$6 = this$23.clone__O();
      a1c$6.set(index, elem);
      var len1 = this.sci_Vector4__f_len1;
      var prefix2 = this.sci_Vector4__f_prefix2;
      var len12 = this.sci_Vector4__f_len12;
      var prefix3 = this.sci_Vector4__f_prefix3;
      var len123 = this.sci_Vector4__f_len123;
      var data4 = this.sci_Vector4__f_data4;
      var suffix3 = this.sci_Vector4__f_suffix3;
      var suffix2 = this.sci_Vector4__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(a1c$6, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector4.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2);
  } else if (($n(this.sci_Vector4__f_suffix2).u.length < 31)) {
    var x$12 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$14 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$15 = this.sci_Vector__f_prefix1;
    var x$16 = this.sci_Vector4__f_len1;
    var x$17 = this.sci_Vector4__f_prefix2;
    var x$18 = this.sci_Vector4__f_len12;
    var x$19 = this.sci_Vector4__f_prefix3;
    var x$20 = this.sci_Vector4__f_len123;
    var x$21 = this.sci_Vector4__f_data4;
    var x$22 = this.sci_Vector4__f_suffix3;
    return new $c_sci_Vector4(x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$12, a, x$14);
  } else if (($n(this.sci_Vector4__f_suffix3).u.length < 31)) {
    var x$23 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$26 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$27 = this.sci_Vector__f_prefix1;
    var x$28 = this.sci_Vector4__f_len1;
    var x$29 = this.sci_Vector4__f_prefix2;
    var x$30 = this.sci_Vector4__f_len12;
    var x$31 = this.sci_Vector4__f_prefix3;
    var x$32 = this.sci_Vector4__f_len123;
    var x$33 = this.sci_Vector4__f_data4;
    return new $c_sci_Vector4(x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$23, x$24, a$1, x$26);
  } else if (($n(this.sci_Vector4__f_data4).u.length < 30)) {
    var x$34 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_data4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$35 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector4__f_len1;
    var x$41 = this.sci_Vector4__f_prefix2;
    var x$42 = this.sci_Vector4__f_len12;
    var x$43 = this.sci_Vector4__f_prefix3;
    var x$44 = this.sci_Vector4__f_len123;
    return new $c_sci_Vector4(x$39, x$40, x$41, x$42, x$43, x$44, x$34, x$35, x$36, a$2, x$38);
  } else {
    var $x_11 = this.sci_Vector__f_prefix1;
    var $x_10 = this.sci_Vector4__f_len1;
    var $x_9 = this.sci_Vector4__f_prefix2;
    var $x_8 = this.sci_Vector4__f_len12;
    var $x_7 = this.sci_Vector4__f_prefix3;
    var $x_6 = this.sci_Vector4__f_len123;
    var $x_5 = this.sci_Vector4__f_data4;
    var $x_4 = this.sci_Vector4__f_len123;
    var $x_3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.set(0, x);
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    return new $c_sci_Vector5($x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, ((983040 + $x_4) | 0), $x_3, a$3, $x_2, $x_1, a$4, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector4.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector4__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector4__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$5 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5);
  } else if ((this.sci_Vector4__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$14 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), 2);
    var x$15 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$16 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector4__f_prefix3;
    var x$19 = this.sci_Vector4__f_data4;
    var x$20 = this.sci_Vector4__f_suffix3;
    var x$21 = this.sci_Vector4__f_suffix2;
    var x$22 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a, 1, x$14, x$15, x$18, x$16, x$19, x$20, x$21, x$22, x$17);
  } else if ((this.sci_Vector4__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$27 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var x$28 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$29 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$30 = this.sci_Vector4__f_data4;
    var x$31 = this.sci_Vector4__f_suffix3;
    var x$32 = this.sci_Vector4__f_suffix2;
    var x$33 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$1, 1, x$25, 1, x$27, x$28, x$30, x$31, x$32, x$33, x$29);
  } else if (($n(this.sci_Vector4__f_data4).u.length < 30)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$38 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$40 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), this.sci_Vector4__f_data4), 4);
    var x$41 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$42 = this.sci_Vector4__f_suffix3;
    var x$43 = this.sci_Vector4__f_suffix2;
    var x$44 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$2, 1, x$36, 1, x$38, 1, x$40, x$42, x$43, x$44, x$41);
  } else {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.set(0, x);
    return new $c_sci_Vector5(a$3, 1, $x_2, 1, $x_1, 1, a$4, ((1 + this.sci_Vector4__f_len123) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5, this.sci_Vector4__f_data4, this.sci_Vector4__f_suffix3, this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector4.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector4__f_data4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_suffix3, f), 3);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_suffix2, f), 2);
  var x$7 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$8 = this.sci_Vector4__f_len1;
  var x$9 = this.sci_Vector4__f_len12;
  var x$10 = this.sci_Vector4__f_len123;
  var x$11 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector4(x$1, x$8, x$2, x$9, x$3, x$10, x$4, x$5, x$6, x$7, x$11);
});
$c_sci_Vector4.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector4__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector4__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector4__f_data4);
  b.consider__I__AO__V(3, this.sci_Vector4__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector4__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector4.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector4__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = ((this.sci_Vector4__f_len1 - 1) | 0);
    var x$3 = ((this.sci_Vector4__f_len12 - 1) | 0);
    var x$4 = ((this.sci_Vector4__f_len123 - 1) | 0);
    var x$5 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector4.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (($n(a).u.length - 1) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, ((this.sci_BigVector__f_length0 - 1) | 0));
  }
});
$c_sci_Vector4.prototype.vectorSliceCount__I = (function() {
  return 7;
});
$c_sci_Vector4.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector4__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector4__f_prefix3;
      break;
    }
    case 3: {
      return this.sci_Vector4__f_data4;
      break;
    }
    case 4: {
      return this.sci_Vector4__f_suffix3;
      break;
    }
    case 5: {
      return this.sci_Vector4__f_suffix2;
      break;
    }
    case 6: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector4.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector4.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector4.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector4.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector4.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector4.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < $n(this.sci_Vector4__f_data4).u.length) ? $n($n($n($n(this.sci_Vector4__f_data4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector4__f_suffix3).u.length) ? $n($n($n(this.sci_Vector4__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector4__f_suffix2).u.length) ? $n($n(this.sci_Vector4__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))));
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return $n($n($n(this.sci_Vector4__f_prefix3).get(((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return $n($n(this.sci_Vector4__f_prefix2).get(((io$3 >>> 5) | 0))).get((31 & io$3));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector4(obj) {
  return (((obj instanceof $c_sci_Vector4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector4"));
}
function $isArrayOf_sci_Vector4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector4)));
}
function $asArrayOf_sci_Vector4(obj, depth) {
  return (($isArrayOf_sci_Vector4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector4;", depth));
}
var $d_sci_Vector4 = new $TypeData().initClass($c_sci_Vector4, "scala.collection.immutable.Vector4", ({
  sci_Vector4: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Vector5(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector5__f_len1 = 0;
  this.sci_Vector5__f_prefix2 = null;
  this.sci_Vector5__f_len12 = 0;
  this.sci_Vector5__f_prefix3 = null;
  this.sci_Vector5__f_len123 = 0;
  this.sci_Vector5__f_prefix4 = null;
  this.sci_Vector5__f_len1234 = 0;
  this.sci_Vector5__f_data5 = null;
  this.sci_Vector5__f_suffix4 = null;
  this.sci_Vector5__f_suffix3 = null;
  this.sci_Vector5__f_suffix2 = null;
  this.sci_Vector5__f_len1 = len1;
  this.sci_Vector5__f_prefix2 = prefix2;
  this.sci_Vector5__f_len12 = len12;
  this.sci_Vector5__f_prefix3 = prefix3;
  this.sci_Vector5__f_len123 = len123;
  this.sci_Vector5__f_prefix4 = prefix4;
  this.sci_Vector5__f_len1234 = len1234;
  this.sci_Vector5__f_data5 = data5;
  this.sci_Vector5__f_suffix4 = suffix4;
  this.sci_Vector5__f_suffix3 = suffix3;
  this.sci_Vector5__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector5.prototype = new $h_sci_BigVector();
$c_sci_Vector5.prototype.constructor = $c_sci_Vector5;
/** @constructor */
function $h_sci_Vector5() {
}
$h_sci_Vector5.prototype = $c_sci_Vector5.prototype;
$c_sci_Vector5.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < $n(this.sci_Vector5__f_data5).u.length) ? $n($n($n($n($n(this.sci_Vector5__f_data5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector5__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector5__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector5__f_suffix3).u.length) ? $n($n($n(this.sci_Vector5__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector5__f_suffix2).u.length) ? $n($n(this.sci_Vector5__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)))));
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector5__f_prefix4).get(((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return $n($n($n(this.sci_Vector5__f_prefix3).get(((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3));
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return $n($n(this.sci_Vector5__f_prefix2).get(((io$4 >>> 5) | 0))).get((31 & io$4));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector5.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector5__f_len1234)) {
      var io = ((index - this.sci_Vector5__f_len1234) | 0);
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i5 < $n(this.sci_Vector5__f_data5).u.length)) {
        var a5 = this.sci_Vector5__f_data5;
        var this$2 = $n(a5);
        var a5c = this$2.clone__O();
        var a4 = a5c.get(i5);
        var this$3 = $n(a4);
        var a4c = this$3.clone__O();
        var a3 = a4c.get(i4);
        var this$4 = $n(a3);
        var a3c = this$4.clone__O();
        var a2 = a3c.get(i3);
        var this$5 = $n(a2);
        var a2c = this$5.clone__O();
        var a1 = a2c.get(i2);
        var this$6 = $n(a1);
        var a1c = this$6.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        a5c.set(i5, a4c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector5__f_len1;
        var x$4 = this.sci_Vector5__f_prefix2;
        var x$5 = this.sci_Vector5__f_len12;
        var x$6 = this.sci_Vector5__f_prefix3;
        var x$7 = this.sci_Vector5__f_len123;
        var x$8 = this.sci_Vector5__f_prefix4;
        var x$9 = this.sci_Vector5__f_len1234;
        var x$10 = this.sci_Vector5__f_suffix4;
        var x$11 = this.sci_Vector5__f_suffix3;
        var x$12 = this.sci_Vector5__f_suffix2;
        var x$13 = this.sci_BigVector__f_suffix1;
        var x$14 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, a5c, x$10, x$11, x$12, x$13, x$14);
      } else if ((i4 < $n(this.sci_Vector5__f_suffix4).u.length)) {
        var a4$1 = this.sci_Vector5__f_suffix4;
        var this$8 = $n(a4$1);
        var a4c$1 = this$8.clone__O();
        var a3$1 = a4c$1.get(i4);
        var this$9 = $n(a3$1);
        var a3c$1 = this$9.clone__O();
        var a2$1 = a3c$1.get(i3);
        var this$10 = $n(a2$1);
        var a2c$1 = this$10.clone__O();
        var a1$1 = a2c$1.get(i2);
        var this$11 = $n(a1$1);
        var a1c$1 = this$11.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        a4c$1.set(i4, a3c$1);
        var x$16 = this.sci_Vector__f_prefix1;
        var x$17 = this.sci_Vector5__f_len1;
        var x$18 = this.sci_Vector5__f_prefix2;
        var x$19 = this.sci_Vector5__f_len12;
        var x$20 = this.sci_Vector5__f_prefix3;
        var x$21 = this.sci_Vector5__f_len123;
        var x$22 = this.sci_Vector5__f_prefix4;
        var x$23 = this.sci_Vector5__f_len1234;
        var x$24 = this.sci_Vector5__f_data5;
        var x$25 = this.sci_Vector5__f_suffix3;
        var x$26 = this.sci_Vector5__f_suffix2;
        var x$27 = this.sci_BigVector__f_suffix1;
        var x$28 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, a4c$1, x$25, x$26, x$27, x$28);
      } else if ((i3 < $n(this.sci_Vector5__f_suffix3).u.length)) {
        var a3$2 = this.sci_Vector5__f_suffix3;
        var this$13 = $n(a3$2);
        var a3c$2 = this$13.clone__O();
        var a2$2 = a3c$2.get(i3);
        var this$14 = $n(a2$2);
        var a2c$2 = this$14.clone__O();
        var a1$2 = a2c$2.get(i2);
        var this$15 = $n(a1$2);
        var a1c$2 = this$15.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        a3c$2.set(i3, a2c$2);
        var x$30 = this.sci_Vector__f_prefix1;
        var x$31 = this.sci_Vector5__f_len1;
        var x$32 = this.sci_Vector5__f_prefix2;
        var x$33 = this.sci_Vector5__f_len12;
        var x$34 = this.sci_Vector5__f_prefix3;
        var x$35 = this.sci_Vector5__f_len123;
        var x$36 = this.sci_Vector5__f_prefix4;
        var x$37 = this.sci_Vector5__f_len1234;
        var x$38 = this.sci_Vector5__f_data5;
        var x$39 = this.sci_Vector5__f_suffix4;
        var x$40 = this.sci_Vector5__f_suffix2;
        var x$41 = this.sci_BigVector__f_suffix1;
        var x$42 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$30, x$31, x$32, x$33, x$34, x$35, x$36, x$37, x$38, x$39, a3c$2, x$40, x$41, x$42);
      } else if ((i2 < $n(this.sci_Vector5__f_suffix2).u.length)) {
        var a2$3 = this.sci_Vector5__f_suffix2;
        var this$17 = $n(a2$3);
        var a2c$3 = this$17.clone__O();
        var a1$3 = a2c$3.get(i2);
        var this$18 = $n(a1$3);
        var a1c$3 = this$18.clone__O();
        a1c$3.set(i1, elem);
        a2c$3.set(i2, a1c$3);
        var x$44 = this.sci_Vector__f_prefix1;
        var x$45 = this.sci_Vector5__f_len1;
        var x$46 = this.sci_Vector5__f_prefix2;
        var x$47 = this.sci_Vector5__f_len12;
        var x$48 = this.sci_Vector5__f_prefix3;
        var x$49 = this.sci_Vector5__f_len123;
        var x$50 = this.sci_Vector5__f_prefix4;
        var x$51 = this.sci_Vector5__f_len1234;
        var x$52 = this.sci_Vector5__f_data5;
        var x$53 = this.sci_Vector5__f_suffix4;
        var x$54 = this.sci_Vector5__f_suffix3;
        var x$55 = this.sci_BigVector__f_suffix1;
        var x$56 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$52, x$53, x$54, a2c$3, x$55, x$56);
      } else {
        var a1$4 = this.sci_BigVector__f_suffix1;
        var this$20 = $n(a1$4);
        var a1c$4 = this$20.clone__O();
        a1c$4.set(i1, elem);
        var x$58 = this.sci_Vector__f_prefix1;
        var x$59 = this.sci_Vector5__f_len1;
        var x$60 = this.sci_Vector5__f_prefix2;
        var x$61 = this.sci_Vector5__f_len12;
        var x$62 = this.sci_Vector5__f_prefix3;
        var x$63 = this.sci_Vector5__f_len123;
        var x$64 = this.sci_Vector5__f_prefix4;
        var x$65 = this.sci_Vector5__f_len1234;
        var x$66 = this.sci_Vector5__f_data5;
        var x$67 = this.sci_Vector5__f_suffix4;
        var x$68 = this.sci_Vector5__f_suffix3;
        var x$69 = this.sci_Vector5__f_suffix2;
        var x$70 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$69, a1c$4, x$70);
      }
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      var a4$2 = this.sci_Vector5__f_prefix4;
      var idx4 = ((io$2 >>> 15) | 0);
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var this$22 = $n(a4$2);
      var a4c$2 = this$22.clone__O();
      var a3$3 = a4c$2.get(idx4);
      var this$23 = $n(a3$3);
      var a3c$3 = this$23.clone__O();
      var a2$4 = a3c$3.get(idx3);
      var this$24 = $n(a2$4);
      var a2c$4 = this$24.clone__O();
      var a1$5 = a2c$4.get(idx2);
      var this$25 = $n(a1$5);
      var a1c$5 = this$25.clone__O();
      a1c$5.set(idx1, elem);
      a2c$4.set(idx2, a1c$5);
      a3c$3.set(idx3, a2c$4);
      a4c$2.set(idx4, a3c$3);
      var x$72 = this.sci_Vector__f_prefix1;
      var x$73 = this.sci_Vector5__f_len1;
      var x$74 = this.sci_Vector5__f_prefix2;
      var x$75 = this.sci_Vector5__f_len12;
      var x$76 = this.sci_Vector5__f_prefix3;
      var x$77 = this.sci_Vector5__f_len123;
      var x$78 = this.sci_Vector5__f_len1234;
      var x$79 = this.sci_Vector5__f_data5;
      var x$80 = this.sci_Vector5__f_suffix4;
      var x$81 = this.sci_Vector5__f_suffix3;
      var x$82 = this.sci_Vector5__f_suffix2;
      var x$83 = this.sci_BigVector__f_suffix1;
      var x$84 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$72, x$73, x$74, x$75, x$76, x$77, a4c$2, x$78, x$79, x$80, x$81, x$82, x$83, x$84);
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      var a3$4 = this.sci_Vector5__f_prefix3;
      var idx3$1 = ((io$3 >>> 10) | 0);
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var this$27 = $n(a3$4);
      var a3c$4 = this$27.clone__O();
      var a2$5 = a3c$4.get(idx3$1);
      var this$28 = $n(a2$5);
      var a2c$5 = this$28.clone__O();
      var a1$6 = a2c$5.get(idx2$1);
      var this$29 = $n(a1$6);
      var a1c$6 = this$29.clone__O();
      a1c$6.set(idx1$1, elem);
      a2c$5.set(idx2$1, a1c$6);
      a3c$4.set(idx3$1, a2c$5);
      var x$86 = this.sci_Vector__f_prefix1;
      var x$87 = this.sci_Vector5__f_len1;
      var x$88 = this.sci_Vector5__f_prefix2;
      var x$89 = this.sci_Vector5__f_len12;
      var x$90 = this.sci_Vector5__f_len123;
      var x$91 = this.sci_Vector5__f_prefix4;
      var x$92 = this.sci_Vector5__f_len1234;
      var x$93 = this.sci_Vector5__f_data5;
      var x$94 = this.sci_Vector5__f_suffix4;
      var x$95 = this.sci_Vector5__f_suffix3;
      var x$96 = this.sci_Vector5__f_suffix2;
      var x$97 = this.sci_BigVector__f_suffix1;
      var x$98 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$86, x$87, x$88, x$89, a3c$4, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98);
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      var a2$6 = this.sci_Vector5__f_prefix2;
      var idx2$2 = ((io$4 >>> 5) | 0);
      var idx1$2 = (31 & io$4);
      var this$31 = $n(a2$6);
      var a2c$6 = this$31.clone__O();
      var a1$7 = a2c$6.get(idx2$2);
      var this$32 = $n(a1$7);
      var a1c$7 = this$32.clone__O();
      a1c$7.set(idx1$2, elem);
      a2c$6.set(idx2$2, a1c$7);
      var x$100 = this.sci_Vector__f_prefix1;
      var x$101 = this.sci_Vector5__f_len1;
      var x$102 = this.sci_Vector5__f_len12;
      var x$103 = this.sci_Vector5__f_prefix3;
      var x$104 = this.sci_Vector5__f_len123;
      var x$105 = this.sci_Vector5__f_prefix4;
      var x$106 = this.sci_Vector5__f_len1234;
      var x$107 = this.sci_Vector5__f_data5;
      var x$108 = this.sci_Vector5__f_suffix4;
      var x$109 = this.sci_Vector5__f_suffix3;
      var x$110 = this.sci_Vector5__f_suffix2;
      var x$111 = this.sci_BigVector__f_suffix1;
      var x$112 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$100, x$101, a2c$6, x$102, x$103, x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, x$112);
    } else {
      var a1$8 = this.sci_Vector__f_prefix1;
      var this$34 = $n(a1$8);
      var a1c$8 = this$34.clone__O();
      a1c$8.set(index, elem);
      var len1 = this.sci_Vector5__f_len1;
      var prefix2 = this.sci_Vector5__f_prefix2;
      var len12 = this.sci_Vector5__f_len12;
      var prefix3 = this.sci_Vector5__f_prefix3;
      var len123 = this.sci_Vector5__f_len123;
      var prefix4 = this.sci_Vector5__f_prefix4;
      var len1234 = this.sci_Vector5__f_len1234;
      var data5 = this.sci_Vector5__f_data5;
      var suffix4 = this.sci_Vector5__f_suffix4;
      var suffix3 = this.sci_Vector5__f_suffix3;
      var suffix2 = this.sci_Vector5__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(a1c$8, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector5.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2);
  } else if (($n(this.sci_Vector5__f_suffix2).u.length < 31)) {
    var x$15 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector__f_prefix1;
    var x$19 = this.sci_Vector5__f_len1;
    var x$20 = this.sci_Vector5__f_prefix2;
    var x$21 = this.sci_Vector5__f_len12;
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_len123;
    var x$24 = this.sci_Vector5__f_prefix4;
    var x$25 = this.sci_Vector5__f_len1234;
    var x$26 = this.sci_Vector5__f_data5;
    var x$27 = this.sci_Vector5__f_suffix4;
    var x$28 = this.sci_Vector5__f_suffix3;
    return new $c_sci_Vector5(x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$15, a, x$17);
  } else if (($n(this.sci_Vector5__f_suffix3).u.length < 31)) {
    var x$29 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$30 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$32 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$33 = this.sci_Vector__f_prefix1;
    var x$34 = this.sci_Vector5__f_len1;
    var x$35 = this.sci_Vector5__f_prefix2;
    var x$36 = this.sci_Vector5__f_len12;
    var x$37 = this.sci_Vector5__f_prefix3;
    var x$38 = this.sci_Vector5__f_len123;
    var x$39 = this.sci_Vector5__f_prefix4;
    var x$40 = this.sci_Vector5__f_len1234;
    var x$41 = this.sci_Vector5__f_data5;
    var x$42 = this.sci_Vector5__f_suffix4;
    return new $c_sci_Vector5(x$33, x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$29, x$30, a$1, x$32);
  } else if (($n(this.sci_Vector5__f_suffix4).u.length < 31)) {
    var x$43 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$44 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$47 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$48 = this.sci_Vector__f_prefix1;
    var x$49 = this.sci_Vector5__f_len1;
    var x$50 = this.sci_Vector5__f_prefix2;
    var x$51 = this.sci_Vector5__f_len12;
    var x$52 = this.sci_Vector5__f_prefix3;
    var x$53 = this.sci_Vector5__f_len123;
    var x$54 = this.sci_Vector5__f_prefix4;
    var x$55 = this.sci_Vector5__f_len1234;
    var x$56 = this.sci_Vector5__f_data5;
    return new $c_sci_Vector5(x$48, x$49, x$50, x$51, x$52, x$53, x$54, x$55, x$56, x$43, x$44, x$45, a$2, x$47);
  } else if (($n(this.sci_Vector5__f_data5).u.length < 30)) {
    var x$57 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_data5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$58 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$60 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$62 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$63 = this.sci_Vector__f_prefix1;
    var x$64 = this.sci_Vector5__f_len1;
    var x$65 = this.sci_Vector5__f_prefix2;
    var x$66 = this.sci_Vector5__f_len12;
    var x$67 = this.sci_Vector5__f_prefix3;
    var x$68 = this.sci_Vector5__f_len123;
    var x$69 = this.sci_Vector5__f_prefix4;
    var x$70 = this.sci_Vector5__f_len1234;
    return new $c_sci_Vector5(x$63, x$64, x$65, x$66, x$67, x$68, x$69, x$70, x$57, x$58, x$59, x$60, a$3, x$62);
  } else {
    var $x_14 = this.sci_Vector__f_prefix1;
    var $x_13 = this.sci_Vector5__f_len1;
    var $x_12 = this.sci_Vector5__f_prefix2;
    var $x_11 = this.sci_Vector5__f_len12;
    var $x_10 = this.sci_Vector5__f_prefix3;
    var $x_9 = this.sci_Vector5__f_len123;
    var $x_8 = this.sci_Vector5__f_prefix4;
    var $x_7 = this.sci_Vector5__f_len1234;
    var $x_6 = this.sci_Vector5__f_data5;
    var $x_5 = this.sci_Vector5__f_len1234;
    var $x_4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.set(0, x);
    var $x_3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$5 = new $ac_O(1);
    a$5.set(0, elem);
    return new $c_sci_Vector6($x_14, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6, ((31457280 + $x_5) | 0), $x_4, a$4, $x_3, $x_2, $x_1, a$5, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector5.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector5__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector5__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$6 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6);
  } else if ((this.sci_Vector5__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), 2);
    var x$18 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$19 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$20 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$21 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_prefix4;
    var x$24 = this.sci_Vector5__f_data5;
    var x$25 = this.sci_Vector5__f_suffix4;
    var x$26 = this.sci_Vector5__f_suffix3;
    var x$27 = this.sci_Vector5__f_suffix2;
    var x$28 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a, 1, x$17, x$18, x$22, x$19, x$23, x$20, x$24, x$25, x$26, x$27, x$28, x$21);
  } else if ((this.sci_Vector5__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$31 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$33 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), 3);
    var x$34 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$35 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$36 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$37 = this.sci_Vector5__f_prefix4;
    var x$38 = this.sci_Vector5__f_data5;
    var x$39 = this.sci_Vector5__f_suffix4;
    var x$40 = this.sci_Vector5__f_suffix3;
    var x$41 = this.sci_Vector5__f_suffix2;
    var x$42 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$1, 1, x$31, 1, x$33, x$34, x$37, x$35, x$38, x$39, x$40, x$41, x$42, x$36);
  } else if ((this.sci_Vector5__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$47 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$49 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var x$50 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$51 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$52 = this.sci_Vector5__f_data5;
    var x$53 = this.sci_Vector5__f_suffix4;
    var x$54 = this.sci_Vector5__f_suffix3;
    var x$55 = this.sci_Vector5__f_suffix2;
    var x$56 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$2, 1, x$45, 1, x$47, 1, x$49, x$50, x$52, x$53, x$54, x$55, x$56, x$51);
  } else if (($n(this.sci_Vector5__f_data5).u.length < 30)) {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$61 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$63 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$65 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), this.sci_Vector5__f_data5), 5);
    var x$66 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$67 = this.sci_Vector5__f_suffix4;
    var x$68 = this.sci_Vector5__f_suffix3;
    var x$69 = this.sci_Vector5__f_suffix2;
    var x$70 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$3, 1, x$59, 1, x$61, 1, x$63, 1, x$65, x$67, x$68, x$69, x$70, x$66);
  } else {
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var $x_3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var a$5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$5.set(0, x);
    return new $c_sci_Vector6(a$4, 1, $x_3, 1, $x_2, 1, $x_1, 1, a$5, ((1 + this.sci_Vector5__f_len1234) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6, this.sci_Vector5__f_data5, this.sci_Vector5__f_suffix4, this.sci_Vector5__f_suffix3, this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector5.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector5__f_data5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_suffix4, f), 4);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_suffix3, f), 3);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_suffix2, f), 2);
  var x$9 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$10 = this.sci_Vector5__f_len1;
  var x$11 = this.sci_Vector5__f_len12;
  var x$12 = this.sci_Vector5__f_len123;
  var x$13 = this.sci_Vector5__f_len1234;
  var x$14 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector5(x$1, x$10, x$2, x$11, x$3, x$12, x$4, x$13, x$5, x$6, x$7, x$8, x$9, x$14);
});
$c_sci_Vector5.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector5__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector5__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector5__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector5__f_data5);
  b.consider__I__AO__V(4, this.sci_Vector5__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector5__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector5__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector5.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector5__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = ((this.sci_Vector5__f_len1 - 1) | 0);
    var x$3 = ((this.sci_Vector5__f_len12 - 1) | 0);
    var x$4 = ((this.sci_Vector5__f_len123 - 1) | 0);
    var x$5 = ((this.sci_Vector5__f_len1234 - 1) | 0);
    var x$6 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector5.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (($n(a).u.length - 1) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, ((this.sci_BigVector__f_length0 - 1) | 0));
  }
});
$c_sci_Vector5.prototype.vectorSliceCount__I = (function() {
  return 9;
});
$c_sci_Vector5.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector5__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector5__f_prefix3;
      break;
    }
    case 3: {
      return this.sci_Vector5__f_prefix4;
      break;
    }
    case 4: {
      return this.sci_Vector5__f_data5;
      break;
    }
    case 5: {
      return this.sci_Vector5__f_suffix4;
      break;
    }
    case 6: {
      return this.sci_Vector5__f_suffix3;
      break;
    }
    case 7: {
      return this.sci_Vector5__f_suffix2;
      break;
    }
    case 8: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector5.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector5.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector5.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector5.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector5.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector5.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < $n(this.sci_Vector5__f_data5).u.length) ? $n($n($n($n($n(this.sci_Vector5__f_data5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector5__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector5__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector5__f_suffix3).u.length) ? $n($n($n(this.sci_Vector5__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector5__f_suffix2).u.length) ? $n($n(this.sci_Vector5__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1)))));
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector5__f_prefix4).get(((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return $n($n($n(this.sci_Vector5__f_prefix3).get(((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3));
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return $n($n(this.sci_Vector5__f_prefix2).get(((io$4 >>> 5) | 0))).get((31 & io$4));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector5(obj) {
  return (((obj instanceof $c_sci_Vector5) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector5"));
}
function $isArrayOf_sci_Vector5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector5)));
}
function $asArrayOf_sci_Vector5(obj, depth) {
  return (($isArrayOf_sci_Vector5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector5;", depth));
}
var $d_sci_Vector5 = new $TypeData().initClass($c_sci_Vector5, "scala.collection.immutable.Vector5", ({
  sci_Vector5: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_Vector6(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector6__f_len1 = 0;
  this.sci_Vector6__f_prefix2 = null;
  this.sci_Vector6__f_len12 = 0;
  this.sci_Vector6__f_prefix3 = null;
  this.sci_Vector6__f_len123 = 0;
  this.sci_Vector6__f_prefix4 = null;
  this.sci_Vector6__f_len1234 = 0;
  this.sci_Vector6__f_prefix5 = null;
  this.sci_Vector6__f_len12345 = 0;
  this.sci_Vector6__f_data6 = null;
  this.sci_Vector6__f_suffix5 = null;
  this.sci_Vector6__f_suffix4 = null;
  this.sci_Vector6__f_suffix3 = null;
  this.sci_Vector6__f_suffix2 = null;
  this.sci_Vector6__f_len1 = len1;
  this.sci_Vector6__f_prefix2 = prefix2;
  this.sci_Vector6__f_len12 = len12;
  this.sci_Vector6__f_prefix3 = prefix3;
  this.sci_Vector6__f_len123 = len123;
  this.sci_Vector6__f_prefix4 = prefix4;
  this.sci_Vector6__f_len1234 = len1234;
  this.sci_Vector6__f_prefix5 = prefix5;
  this.sci_Vector6__f_len12345 = len12345;
  this.sci_Vector6__f_data6 = data6;
  this.sci_Vector6__f_suffix5 = suffix5;
  this.sci_Vector6__f_suffix4 = suffix4;
  this.sci_Vector6__f_suffix3 = suffix3;
  this.sci_Vector6__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
$c_sci_Vector6.prototype = new $h_sci_BigVector();
$c_sci_Vector6.prototype.constructor = $c_sci_Vector6;
/** @constructor */
function $h_sci_Vector6() {
}
$h_sci_Vector6.prototype = $c_sci_Vector6.prototype;
$c_sci_Vector6.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < $n(this.sci_Vector6__f_data6).u.length) ? $n($n($n($n($n($n(this.sci_Vector6__f_data6).get(i6)).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i5 < $n(this.sci_Vector6__f_suffix5).u.length) ? $n($n($n($n($n(this.sci_Vector6__f_suffix5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector6__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector6__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector6__f_suffix3).u.length) ? $n($n($n(this.sci_Vector6__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector6__f_suffix2).u.length) ? $n($n(this.sci_Vector6__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))))));
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return $n($n($n($n($n(this.sci_Vector6__f_prefix5).get(((io$2 >>> 20) | 0))).get((31 & ((io$2 >>> 15) | 0)))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector6__f_prefix4).get(((io$3 >>> 15) | 0))).get((31 & ((io$3 >>> 10) | 0)))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3));
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return $n($n($n(this.sci_Vector6__f_prefix3).get(((io$4 >>> 10) | 0))).get((31 & ((io$4 >>> 5) | 0)))).get((31 & io$4));
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return $n($n(this.sci_Vector6__f_prefix2).get(((io$5 >>> 5) | 0))).get((31 & io$5));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector6.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector6__f_len12345)) {
      var io = ((index - this.sci_Vector6__f_len12345) | 0);
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i6 < $n(this.sci_Vector6__f_data6).u.length)) {
        var a6 = this.sci_Vector6__f_data6;
        var this$2 = $n(a6);
        var a6c = this$2.clone__O();
        var a5 = a6c.get(i6);
        var this$3 = $n(a5);
        var a5c = this$3.clone__O();
        var a4 = a5c.get(i5);
        var this$4 = $n(a4);
        var a4c = this$4.clone__O();
        var a3 = a4c.get(i4);
        var this$5 = $n(a3);
        var a3c = this$5.clone__O();
        var a2 = a3c.get(i3);
        var this$6 = $n(a2);
        var a2c = this$6.clone__O();
        var a1 = a2c.get(i2);
        var this$7 = $n(a1);
        var a1c = this$7.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        a5c.set(i5, a4c);
        a6c.set(i6, a5c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector6__f_len1;
        var x$4 = this.sci_Vector6__f_prefix2;
        var x$5 = this.sci_Vector6__f_len12;
        var x$6 = this.sci_Vector6__f_prefix3;
        var x$7 = this.sci_Vector6__f_len123;
        var x$8 = this.sci_Vector6__f_prefix4;
        var x$9 = this.sci_Vector6__f_len1234;
        var x$10 = this.sci_Vector6__f_prefix5;
        var x$11 = this.sci_Vector6__f_len12345;
        var x$12 = this.sci_Vector6__f_suffix5;
        var x$13 = this.sci_Vector6__f_suffix4;
        var x$14 = this.sci_Vector6__f_suffix3;
        var x$15 = this.sci_Vector6__f_suffix2;
        var x$16 = this.sci_BigVector__f_suffix1;
        var x$17 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, a6c, x$12, x$13, x$14, x$15, x$16, x$17);
      } else if ((i5 < $n(this.sci_Vector6__f_suffix5).u.length)) {
        var a5$1 = this.sci_Vector6__f_suffix5;
        var this$9 = $n(a5$1);
        var a5c$1 = this$9.clone__O();
        var a4$1 = a5c$1.get(i5);
        var this$10 = $n(a4$1);
        var a4c$1 = this$10.clone__O();
        var a3$1 = a4c$1.get(i4);
        var this$11 = $n(a3$1);
        var a3c$1 = this$11.clone__O();
        var a2$1 = a3c$1.get(i3);
        var this$12 = $n(a2$1);
        var a2c$1 = this$12.clone__O();
        var a1$1 = a2c$1.get(i2);
        var this$13 = $n(a1$1);
        var a1c$1 = this$13.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        a4c$1.set(i4, a3c$1);
        a5c$1.set(i5, a4c$1);
        var x$19 = this.sci_Vector__f_prefix1;
        var x$20 = this.sci_Vector6__f_len1;
        var x$21 = this.sci_Vector6__f_prefix2;
        var x$22 = this.sci_Vector6__f_len12;
        var x$23 = this.sci_Vector6__f_prefix3;
        var x$24 = this.sci_Vector6__f_len123;
        var x$25 = this.sci_Vector6__f_prefix4;
        var x$26 = this.sci_Vector6__f_len1234;
        var x$27 = this.sci_Vector6__f_prefix5;
        var x$28 = this.sci_Vector6__f_len12345;
        var x$29 = this.sci_Vector6__f_data6;
        var x$30 = this.sci_Vector6__f_suffix4;
        var x$31 = this.sci_Vector6__f_suffix3;
        var x$32 = this.sci_Vector6__f_suffix2;
        var x$33 = this.sci_BigVector__f_suffix1;
        var x$34 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, a5c$1, x$30, x$31, x$32, x$33, x$34);
      } else if ((i4 < $n(this.sci_Vector6__f_suffix4).u.length)) {
        var a4$2 = this.sci_Vector6__f_suffix4;
        var this$15 = $n(a4$2);
        var a4c$2 = this$15.clone__O();
        var a3$2 = a4c$2.get(i4);
        var this$16 = $n(a3$2);
        var a3c$2 = this$16.clone__O();
        var a2$2 = a3c$2.get(i3);
        var this$17 = $n(a2$2);
        var a2c$2 = this$17.clone__O();
        var a1$2 = a2c$2.get(i2);
        var this$18 = $n(a1$2);
        var a1c$2 = this$18.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        a3c$2.set(i3, a2c$2);
        a4c$2.set(i4, a3c$2);
        var x$36 = this.sci_Vector__f_prefix1;
        var x$37 = this.sci_Vector6__f_len1;
        var x$38 = this.sci_Vector6__f_prefix2;
        var x$39 = this.sci_Vector6__f_len12;
        var x$40 = this.sci_Vector6__f_prefix3;
        var x$41 = this.sci_Vector6__f_len123;
        var x$42 = this.sci_Vector6__f_prefix4;
        var x$43 = this.sci_Vector6__f_len1234;
        var x$44 = this.sci_Vector6__f_prefix5;
        var x$45 = this.sci_Vector6__f_len12345;
        var x$46 = this.sci_Vector6__f_data6;
        var x$47 = this.sci_Vector6__f_suffix5;
        var x$48 = this.sci_Vector6__f_suffix3;
        var x$49 = this.sci_Vector6__f_suffix2;
        var x$50 = this.sci_BigVector__f_suffix1;
        var x$51 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, a4c$2, x$48, x$49, x$50, x$51);
      } else if ((i3 < $n(this.sci_Vector6__f_suffix3).u.length)) {
        var a3$3 = this.sci_Vector6__f_suffix3;
        var this$20 = $n(a3$3);
        var a3c$3 = this$20.clone__O();
        var a2$3 = a3c$3.get(i3);
        var this$21 = $n(a2$3);
        var a2c$3 = this$21.clone__O();
        var a1$3 = a2c$3.get(i2);
        var this$22 = $n(a1$3);
        var a1c$3 = this$22.clone__O();
        a1c$3.set(i1, elem);
        a2c$3.set(i2, a1c$3);
        a3c$3.set(i3, a2c$3);
        var x$53 = this.sci_Vector__f_prefix1;
        var x$54 = this.sci_Vector6__f_len1;
        var x$55 = this.sci_Vector6__f_prefix2;
        var x$56 = this.sci_Vector6__f_len12;
        var x$57 = this.sci_Vector6__f_prefix3;
        var x$58 = this.sci_Vector6__f_len123;
        var x$59 = this.sci_Vector6__f_prefix4;
        var x$60 = this.sci_Vector6__f_len1234;
        var x$61 = this.sci_Vector6__f_prefix5;
        var x$62 = this.sci_Vector6__f_len12345;
        var x$63 = this.sci_Vector6__f_data6;
        var x$64 = this.sci_Vector6__f_suffix5;
        var x$65 = this.sci_Vector6__f_suffix4;
        var x$66 = this.sci_Vector6__f_suffix2;
        var x$67 = this.sci_BigVector__f_suffix1;
        var x$68 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$53, x$54, x$55, x$56, x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, a3c$3, x$66, x$67, x$68);
      } else if ((i2 < $n(this.sci_Vector6__f_suffix2).u.length)) {
        var a2$4 = this.sci_Vector6__f_suffix2;
        var this$24 = $n(a2$4);
        var a2c$4 = this$24.clone__O();
        var a1$4 = a2c$4.get(i2);
        var this$25 = $n(a1$4);
        var a1c$4 = this$25.clone__O();
        a1c$4.set(i1, elem);
        a2c$4.set(i2, a1c$4);
        var x$70 = this.sci_Vector__f_prefix1;
        var x$71 = this.sci_Vector6__f_len1;
        var x$72 = this.sci_Vector6__f_prefix2;
        var x$73 = this.sci_Vector6__f_len12;
        var x$74 = this.sci_Vector6__f_prefix3;
        var x$75 = this.sci_Vector6__f_len123;
        var x$76 = this.sci_Vector6__f_prefix4;
        var x$77 = this.sci_Vector6__f_len1234;
        var x$78 = this.sci_Vector6__f_prefix5;
        var x$79 = this.sci_Vector6__f_len12345;
        var x$80 = this.sci_Vector6__f_data6;
        var x$81 = this.sci_Vector6__f_suffix5;
        var x$82 = this.sci_Vector6__f_suffix4;
        var x$83 = this.sci_Vector6__f_suffix3;
        var x$84 = this.sci_BigVector__f_suffix1;
        var x$85 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$70, x$71, x$72, x$73, x$74, x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, a2c$4, x$84, x$85);
      } else {
        var a1$5 = this.sci_BigVector__f_suffix1;
        var this$27 = $n(a1$5);
        var a1c$5 = this$27.clone__O();
        a1c$5.set(i1, elem);
        var x$87 = this.sci_Vector__f_prefix1;
        var x$88 = this.sci_Vector6__f_len1;
        var x$89 = this.sci_Vector6__f_prefix2;
        var x$90 = this.sci_Vector6__f_len12;
        var x$91 = this.sci_Vector6__f_prefix3;
        var x$92 = this.sci_Vector6__f_len123;
        var x$93 = this.sci_Vector6__f_prefix4;
        var x$94 = this.sci_Vector6__f_len1234;
        var x$95 = this.sci_Vector6__f_prefix5;
        var x$96 = this.sci_Vector6__f_len12345;
        var x$97 = this.sci_Vector6__f_data6;
        var x$98 = this.sci_Vector6__f_suffix5;
        var x$99 = this.sci_Vector6__f_suffix4;
        var x$100 = this.sci_Vector6__f_suffix3;
        var x$101 = this.sci_Vector6__f_suffix2;
        var x$102 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$87, x$88, x$89, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, a1c$5, x$102);
      }
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      var a5$2 = this.sci_Vector6__f_prefix5;
      var idx5 = ((io$2 >>> 20) | 0);
      var idx4 = (31 & ((io$2 >>> 15) | 0));
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var this$29 = $n(a5$2);
      var a5c$2 = this$29.clone__O();
      var a4$3 = a5c$2.get(idx5);
      var this$30 = $n(a4$3);
      var a4c$3 = this$30.clone__O();
      var a3$4 = a4c$3.get(idx4);
      var this$31 = $n(a3$4);
      var a3c$4 = this$31.clone__O();
      var a2$5 = a3c$4.get(idx3);
      var this$32 = $n(a2$5);
      var a2c$5 = this$32.clone__O();
      var a1$6 = a2c$5.get(idx2);
      var this$33 = $n(a1$6);
      var a1c$6 = this$33.clone__O();
      a1c$6.set(idx1, elem);
      a2c$5.set(idx2, a1c$6);
      a3c$4.set(idx3, a2c$5);
      a4c$3.set(idx4, a3c$4);
      a5c$2.set(idx5, a4c$3);
      var x$104 = this.sci_Vector__f_prefix1;
      var x$105 = this.sci_Vector6__f_len1;
      var x$106 = this.sci_Vector6__f_prefix2;
      var x$107 = this.sci_Vector6__f_len12;
      var x$108 = this.sci_Vector6__f_prefix3;
      var x$109 = this.sci_Vector6__f_len123;
      var x$110 = this.sci_Vector6__f_prefix4;
      var x$111 = this.sci_Vector6__f_len1234;
      var x$112 = this.sci_Vector6__f_len12345;
      var x$113 = this.sci_Vector6__f_data6;
      var x$114 = this.sci_Vector6__f_suffix5;
      var x$115 = this.sci_Vector6__f_suffix4;
      var x$116 = this.sci_Vector6__f_suffix3;
      var x$117 = this.sci_Vector6__f_suffix2;
      var x$118 = this.sci_BigVector__f_suffix1;
      var x$119 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, a5c$2, x$112, x$113, x$114, x$115, x$116, x$117, x$118, x$119);
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      var a4$4 = this.sci_Vector6__f_prefix4;
      var idx4$1 = ((io$3 >>> 15) | 0);
      var idx3$1 = (31 & ((io$3 >>> 10) | 0));
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var this$35 = $n(a4$4);
      var a4c$4 = this$35.clone__O();
      var a3$5 = a4c$4.get(idx4$1);
      var this$36 = $n(a3$5);
      var a3c$5 = this$36.clone__O();
      var a2$6 = a3c$5.get(idx3$1);
      var this$37 = $n(a2$6);
      var a2c$6 = this$37.clone__O();
      var a1$7 = a2c$6.get(idx2$1);
      var this$38 = $n(a1$7);
      var a1c$7 = this$38.clone__O();
      a1c$7.set(idx1$1, elem);
      a2c$6.set(idx2$1, a1c$7);
      a3c$5.set(idx3$1, a2c$6);
      a4c$4.set(idx4$1, a3c$5);
      var x$121 = this.sci_Vector__f_prefix1;
      var x$122 = this.sci_Vector6__f_len1;
      var x$123 = this.sci_Vector6__f_prefix2;
      var x$124 = this.sci_Vector6__f_len12;
      var x$125 = this.sci_Vector6__f_prefix3;
      var x$126 = this.sci_Vector6__f_len123;
      var x$127 = this.sci_Vector6__f_len1234;
      var x$128 = this.sci_Vector6__f_prefix5;
      var x$129 = this.sci_Vector6__f_len12345;
      var x$130 = this.sci_Vector6__f_data6;
      var x$131 = this.sci_Vector6__f_suffix5;
      var x$132 = this.sci_Vector6__f_suffix4;
      var x$133 = this.sci_Vector6__f_suffix3;
      var x$134 = this.sci_Vector6__f_suffix2;
      var x$135 = this.sci_BigVector__f_suffix1;
      var x$136 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$121, x$122, x$123, x$124, x$125, x$126, a4c$4, x$127, x$128, x$129, x$130, x$131, x$132, x$133, x$134, x$135, x$136);
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      var a3$6 = this.sci_Vector6__f_prefix3;
      var idx3$2 = ((io$4 >>> 10) | 0);
      var idx2$2 = (31 & ((io$4 >>> 5) | 0));
      var idx1$2 = (31 & io$4);
      var this$40 = $n(a3$6);
      var a3c$6 = this$40.clone__O();
      var a2$7 = a3c$6.get(idx3$2);
      var this$41 = $n(a2$7);
      var a2c$7 = this$41.clone__O();
      var a1$8 = a2c$7.get(idx2$2);
      var this$42 = $n(a1$8);
      var a1c$8 = this$42.clone__O();
      a1c$8.set(idx1$2, elem);
      a2c$7.set(idx2$2, a1c$8);
      a3c$6.set(idx3$2, a2c$7);
      var x$138 = this.sci_Vector__f_prefix1;
      var x$139 = this.sci_Vector6__f_len1;
      var x$140 = this.sci_Vector6__f_prefix2;
      var x$141 = this.sci_Vector6__f_len12;
      var x$142 = this.sci_Vector6__f_len123;
      var x$143 = this.sci_Vector6__f_prefix4;
      var x$144 = this.sci_Vector6__f_len1234;
      var x$145 = this.sci_Vector6__f_prefix5;
      var x$146 = this.sci_Vector6__f_len12345;
      var x$147 = this.sci_Vector6__f_data6;
      var x$148 = this.sci_Vector6__f_suffix5;
      var x$149 = this.sci_Vector6__f_suffix4;
      var x$150 = this.sci_Vector6__f_suffix3;
      var x$151 = this.sci_Vector6__f_suffix2;
      var x$152 = this.sci_BigVector__f_suffix1;
      var x$153 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$138, x$139, x$140, x$141, a3c$6, x$142, x$143, x$144, x$145, x$146, x$147, x$148, x$149, x$150, x$151, x$152, x$153);
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      var a2$8 = this.sci_Vector6__f_prefix2;
      var idx2$3 = ((io$5 >>> 5) | 0);
      var idx1$3 = (31 & io$5);
      var this$44 = $n(a2$8);
      var a2c$8 = this$44.clone__O();
      var a1$9 = a2c$8.get(idx2$3);
      var this$45 = $n(a1$9);
      var a1c$9 = this$45.clone__O();
      a1c$9.set(idx1$3, elem);
      a2c$8.set(idx2$3, a1c$9);
      var x$155 = this.sci_Vector__f_prefix1;
      var x$156 = this.sci_Vector6__f_len1;
      var x$157 = this.sci_Vector6__f_len12;
      var x$158 = this.sci_Vector6__f_prefix3;
      var x$159 = this.sci_Vector6__f_len123;
      var x$160 = this.sci_Vector6__f_prefix4;
      var x$161 = this.sci_Vector6__f_len1234;
      var x$162 = this.sci_Vector6__f_prefix5;
      var x$163 = this.sci_Vector6__f_len12345;
      var x$164 = this.sci_Vector6__f_data6;
      var x$165 = this.sci_Vector6__f_suffix5;
      var x$166 = this.sci_Vector6__f_suffix4;
      var x$167 = this.sci_Vector6__f_suffix3;
      var x$168 = this.sci_Vector6__f_suffix2;
      var x$169 = this.sci_BigVector__f_suffix1;
      var x$170 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$155, x$156, a2c$8, x$157, x$158, x$159, x$160, x$161, x$162, x$163, x$164, x$165, x$166, x$167, x$168, x$169, x$170);
    } else {
      var a1$10 = this.sci_Vector__f_prefix1;
      var this$47 = $n(a1$10);
      var a1c$10 = this$47.clone__O();
      a1c$10.set(index, elem);
      var len1 = this.sci_Vector6__f_len1;
      var prefix2 = this.sci_Vector6__f_prefix2;
      var len12 = this.sci_Vector6__f_len12;
      var prefix3 = this.sci_Vector6__f_prefix3;
      var len123 = this.sci_Vector6__f_len123;
      var prefix4 = this.sci_Vector6__f_prefix4;
      var len1234 = this.sci_Vector6__f_len1234;
      var prefix5 = this.sci_Vector6__f_prefix5;
      var len12345 = this.sci_Vector6__f_len12345;
      var data6 = this.sci_Vector6__f_data6;
      var suffix5 = this.sci_Vector6__f_suffix5;
      var suffix4 = this.sci_Vector6__f_suffix4;
      var suffix3 = this.sci_Vector6__f_suffix3;
      var suffix2 = this.sci_Vector6__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(a1c$10, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, suffix1, length0);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
$c_sci_Vector6.prototype.appended__O__sci_Vector = (function(elem) {
  if (($n(this.sci_BigVector__f_suffix1).u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2);
  } else if (($n(this.sci_Vector6__f_suffix2).u.length < 31)) {
    var x$18 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector6__f_len1;
    var x$23 = this.sci_Vector6__f_prefix2;
    var x$24 = this.sci_Vector6__f_len12;
    var x$25 = this.sci_Vector6__f_prefix3;
    var x$26 = this.sci_Vector6__f_len123;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_len1234;
    var x$29 = this.sci_Vector6__f_prefix5;
    var x$30 = this.sci_Vector6__f_len12345;
    var x$31 = this.sci_Vector6__f_data6;
    var x$32 = this.sci_Vector6__f_suffix5;
    var x$33 = this.sci_Vector6__f_suffix4;
    var x$34 = this.sci_Vector6__f_suffix3;
    return new $c_sci_Vector6(x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$18, a, x$20);
  } else if (($n(this.sci_Vector6__f_suffix3).u.length < 31)) {
    var x$35 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector6__f_len1;
    var x$41 = this.sci_Vector6__f_prefix2;
    var x$42 = this.sci_Vector6__f_len12;
    var x$43 = this.sci_Vector6__f_prefix3;
    var x$44 = this.sci_Vector6__f_len123;
    var x$45 = this.sci_Vector6__f_prefix4;
    var x$46 = this.sci_Vector6__f_len1234;
    var x$47 = this.sci_Vector6__f_prefix5;
    var x$48 = this.sci_Vector6__f_len12345;
    var x$49 = this.sci_Vector6__f_data6;
    var x$50 = this.sci_Vector6__f_suffix5;
    var x$51 = this.sci_Vector6__f_suffix4;
    return new $c_sci_Vector6(x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$35, x$36, a$1, x$38);
  } else if (($n(this.sci_Vector6__f_suffix4).u.length < 31)) {
    var x$52 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$53 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$56 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$57 = this.sci_Vector__f_prefix1;
    var x$58 = this.sci_Vector6__f_len1;
    var x$59 = this.sci_Vector6__f_prefix2;
    var x$60 = this.sci_Vector6__f_len12;
    var x$61 = this.sci_Vector6__f_prefix3;
    var x$62 = this.sci_Vector6__f_len123;
    var x$63 = this.sci_Vector6__f_prefix4;
    var x$64 = this.sci_Vector6__f_len1234;
    var x$65 = this.sci_Vector6__f_prefix5;
    var x$66 = this.sci_Vector6__f_len12345;
    var x$67 = this.sci_Vector6__f_data6;
    var x$68 = this.sci_Vector6__f_suffix5;
    return new $c_sci_Vector6(x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$52, x$53, x$54, a$2, x$56);
  } else if (($n(this.sci_Vector6__f_suffix5).u.length < 31)) {
    var x$69 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$70 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$72 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$74 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$75 = this.sci_Vector__f_prefix1;
    var x$76 = this.sci_Vector6__f_len1;
    var x$77 = this.sci_Vector6__f_prefix2;
    var x$78 = this.sci_Vector6__f_len12;
    var x$79 = this.sci_Vector6__f_prefix3;
    var x$80 = this.sci_Vector6__f_len123;
    var x$81 = this.sci_Vector6__f_prefix4;
    var x$82 = this.sci_Vector6__f_len1234;
    var x$83 = this.sci_Vector6__f_prefix5;
    var x$84 = this.sci_Vector6__f_len12345;
    var x$85 = this.sci_Vector6__f_data6;
    return new $c_sci_Vector6(x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, x$84, x$85, x$69, x$70, x$71, x$72, a$3, x$74);
  } else if (($n(this.sci_Vector6__f_data6).u.length < 62)) {
    var x$86 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_data6, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))))), 6);
    var x$87 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$89 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var x$92 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$93 = this.sci_Vector__f_prefix1;
    var x$94 = this.sci_Vector6__f_len1;
    var x$95 = this.sci_Vector6__f_prefix2;
    var x$96 = this.sci_Vector6__f_len12;
    var x$97 = this.sci_Vector6__f_prefix3;
    var x$98 = this.sci_Vector6__f_len123;
    var x$99 = this.sci_Vector6__f_prefix4;
    var x$100 = this.sci_Vector6__f_len1234;
    var x$101 = this.sci_Vector6__f_prefix5;
    var x$102 = this.sci_Vector6__f_len12345;
    return new $c_sci_Vector6(x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, x$102, x$86, x$87, x$88, x$89, x$90, a$4, x$92);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$c_sci_Vector6.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector6__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector6__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$6 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$7 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7);
  } else if ((this.sci_Vector6__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$20 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), 2);
    var x$21 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$22 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$23 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$24 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$25 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$26 = this.sci_Vector6__f_prefix3;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_prefix5;
    var x$29 = this.sci_Vector6__f_data6;
    var x$30 = this.sci_Vector6__f_suffix5;
    var x$31 = this.sci_Vector6__f_suffix4;
    var x$32 = this.sci_Vector6__f_suffix3;
    var x$33 = this.sci_Vector6__f_suffix2;
    var x$34 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a, 1, x$20, x$21, x$26, x$22, x$27, x$23, x$28, x$24, x$29, x$30, x$31, x$32, x$33, x$34, x$25);
  } else if ((this.sci_Vector6__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$37 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$39 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), 3);
    var x$40 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$41 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$42 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$43 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$44 = this.sci_Vector6__f_prefix4;
    var x$45 = this.sci_Vector6__f_prefix5;
    var x$46 = this.sci_Vector6__f_data6;
    var x$47 = this.sci_Vector6__f_suffix5;
    var x$48 = this.sci_Vector6__f_suffix4;
    var x$49 = this.sci_Vector6__f_suffix3;
    var x$50 = this.sci_Vector6__f_suffix2;
    var x$51 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$1, 1, x$37, 1, x$39, x$40, x$44, x$41, x$45, x$42, x$46, x$47, x$48, x$49, x$50, x$51, x$43);
  } else if ((this.sci_Vector6__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$56 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$58 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), 4);
    var x$59 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$60 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$61 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$62 = this.sci_Vector6__f_prefix5;
    var x$63 = this.sci_Vector6__f_data6;
    var x$64 = this.sci_Vector6__f_suffix5;
    var x$65 = this.sci_Vector6__f_suffix4;
    var x$66 = this.sci_Vector6__f_suffix3;
    var x$67 = this.sci_Vector6__f_suffix2;
    var x$68 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$2, 1, x$54, 1, x$56, 1, x$58, x$59, x$62, x$60, x$63, x$64, x$65, x$66, x$67, x$68, x$61);
  } else if ((this.sci_Vector6__f_len12345 < 33554432)) {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$73 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$75 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$77 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), 5);
    var x$78 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$79 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$80 = this.sci_Vector6__f_data6;
    var x$81 = this.sci_Vector6__f_suffix5;
    var x$82 = this.sci_Vector6__f_suffix4;
    var x$83 = this.sci_Vector6__f_suffix3;
    var x$84 = this.sci_Vector6__f_suffix2;
    var x$85 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$3, 1, x$71, 1, x$73, 1, x$75, 1, x$77, x$78, x$80, x$81, x$82, x$83, x$84, x$85, x$79);
  } else if (($n(this.sci_Vector6__f_data6).u.length < 62)) {
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$92 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$94 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$96 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), this.sci_Vector6__f_data6), 6);
    var x$97 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$98 = this.sci_Vector6__f_suffix5;
    var x$99 = this.sci_Vector6__f_suffix4;
    var x$100 = this.sci_Vector6__f_suffix3;
    var x$101 = this.sci_Vector6__f_suffix2;
    var x$102 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$4, 1, x$88, 1, x$90, 1, x$92, 1, x$94, 1, x$96, x$98, x$99, x$100, x$101, x$102, x$97);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$c_sci_Vector6.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_prefix5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(6, this.sci_Vector6__f_data6, f), 6);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_suffix5, f), 5);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_suffix4, f), 4);
  var x$9 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_suffix3, f), 3);
  var x$10 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_suffix2, f), 2);
  var x$11 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$12 = this.sci_Vector6__f_len1;
  var x$13 = this.sci_Vector6__f_len12;
  var x$14 = this.sci_Vector6__f_len123;
  var x$15 = this.sci_Vector6__f_len1234;
  var x$16 = this.sci_Vector6__f_len12345;
  var x$17 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector6(x$1, x$12, x$2, x$13, x$3, x$14, x$4, x$15, x$5, x$16, x$6, x$7, x$8, x$9, x$10, x$11, x$17);
});
$c_sci_Vector6.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector6__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector6__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector6__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector6__f_prefix5);
  b.consider__I__AO__V(6, this.sci_Vector6__f_data6);
  b.consider__I__AO__V(5, this.sci_Vector6__f_suffix5);
  b.consider__I__AO__V(4, this.sci_Vector6__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector6__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector6__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector6.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector6__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = $n(a).u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = ((this.sci_Vector6__f_len1 - 1) | 0);
    var x$3 = ((this.sci_Vector6__f_len12 - 1) | 0);
    var x$4 = ((this.sci_Vector6__f_len123 - 1) | 0);
    var x$5 = ((this.sci_Vector6__f_len1234 - 1) | 0);
    var x$6 = ((this.sci_Vector6__f_len12345 - 1) | 0);
    var x$7 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector6.prototype.init__sci_Vector = (function() {
  if (($n(this.sci_BigVector__f_suffix1).u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (($n(a).u.length - 1) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = ((this.sci_BigVector__f_length0 - 1) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, ((this.sci_BigVector__f_length0 - 1) | 0));
  }
});
$c_sci_Vector6.prototype.vectorSliceCount__I = (function() {
  return 11;
});
$c_sci_Vector6.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector6__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector6__f_prefix3;
      break;
    }
    case 3: {
      return this.sci_Vector6__f_prefix4;
      break;
    }
    case 4: {
      return this.sci_Vector6__f_prefix5;
      break;
    }
    case 5: {
      return this.sci_Vector6__f_data6;
      break;
    }
    case 6: {
      return this.sci_Vector6__f_suffix5;
      break;
    }
    case 7: {
      return this.sci_Vector6__f_suffix4;
      break;
    }
    case 8: {
      return this.sci_Vector6__f_suffix3;
      break;
    }
    case 9: {
      return this.sci_Vector6__f_suffix2;
      break;
    }
    case 10: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector6.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - $n(this.sci_BigVector__f_suffix1).u.length) | 0) + $n(suffix1b).u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector6.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector6.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector6.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector6.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector6.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < $n(this.sci_Vector6__f_data6).u.length) ? $n($n($n($n($n($n(this.sci_Vector6__f_data6).get(i6)).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i5 < $n(this.sci_Vector6__f_suffix5).u.length) ? $n($n($n($n($n(this.sci_Vector6__f_suffix5).get(i5)).get(i4)).get(i3)).get(i2)).get(i1) : ((i4 < $n(this.sci_Vector6__f_suffix4).u.length) ? $n($n($n($n(this.sci_Vector6__f_suffix4).get(i4)).get(i3)).get(i2)).get(i1) : ((i3 < $n(this.sci_Vector6__f_suffix3).u.length) ? $n($n($n(this.sci_Vector6__f_suffix3).get(i3)).get(i2)).get(i1) : ((i2 < $n(this.sci_Vector6__f_suffix2).u.length) ? $n($n(this.sci_Vector6__f_suffix2).get(i2)).get(i1) : $n(this.sci_BigVector__f_suffix1).get(i1))))));
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return $n($n($n($n($n(this.sci_Vector6__f_prefix5).get(((io$2 >>> 20) | 0))).get((31 & ((io$2 >>> 15) | 0)))).get((31 & ((io$2 >>> 10) | 0)))).get((31 & ((io$2 >>> 5) | 0)))).get((31 & io$2));
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return $n($n($n($n(this.sci_Vector6__f_prefix4).get(((io$3 >>> 15) | 0))).get((31 & ((io$3 >>> 10) | 0)))).get((31 & ((io$3 >>> 5) | 0)))).get((31 & io$3));
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return $n($n($n(this.sci_Vector6__f_prefix3).get(((io$4 >>> 10) | 0))).get((31 & ((io$4 >>> 5) | 0)))).get((31 & io$4));
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return $n($n(this.sci_Vector6__f_prefix2).get(((io$5 >>> 5) | 0))).get((31 & io$5));
    } else {
      return $n(this.sci_Vector__f_prefix1).get(index);
    }
  } else {
    throw $n(this.ioob__I__jl_IndexOutOfBoundsException(index));
  }
});
function $as_sci_Vector6(obj) {
  return (((obj instanceof $c_sci_Vector6) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector6"));
}
function $isArrayOf_sci_Vector6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector6)));
}
function $asArrayOf_sci_Vector6(obj, depth) {
  return (($isArrayOf_sci_Vector6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector6;", depth));
}
var $d_sci_Vector6 = new $TypeData().initClass($c_sci_Vector6, "scala.collection.immutable.Vector6", ({
  sci_Vector6: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_scm_StringBuilder__jl_StringBuilder__($thiz, underlying) {
  $thiz.scm_StringBuilder__f_underlying = underlying;
  return $thiz;
}
function $ct_scm_StringBuilder__($thiz) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz;
}
function $ct_scm_StringBuilder__I__($thiz, capacity) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), capacity));
  return $thiz;
}
function $ct_scm_StringBuilder__T__($thiz, str) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), str));
  return $thiz;
}
/** @constructor */
function $c_scm_StringBuilder() {
  this.scm_StringBuilder__f_underlying = null;
}
$c_scm_StringBuilder.prototype = new $h_scm_AbstractSeq();
$c_scm_StringBuilder.prototype.constructor = $c_scm_StringBuilder;
/** @constructor */
function $h_scm_StringBuilder() {
}
$h_scm_StringBuilder.prototype = $c_scm_StringBuilder.prototype;
$c_scm_StringBuilder.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_scm_StringBuilder.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_scm_StringBuilder.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_scm_StringBuilder.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_scm_StringBuilder.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_StringBuilder.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_scm_StringBuilder.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_scm_StringBuilder.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_StringBuilder.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_StringBuilder.prototype.lengthCompare__I__I = (function(len) {
  var x = $n(this.scm_StringBuilder__f_underlying).length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_StringBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_StringBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_StringBuilder.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()));
});
$c_scm_StringBuilder.prototype.length__I = (function() {
  return $n(this.scm_StringBuilder__f_underlying).length__I();
});
$c_scm_StringBuilder.prototype.knownSize__I = (function() {
  return $n(this.scm_StringBuilder__f_underlying).length__I();
});
$c_scm_StringBuilder.prototype.addOne__C__scm_StringBuilder = (function(x) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = ("" + $cToS(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_scm_StringBuilder.prototype.addAll__T__scm_StringBuilder = (function(s) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this;
});
$c_scm_StringBuilder.prototype.toString__T = (function() {
  return $n(this.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_scm_StringBuilder.prototype.toArray__s_reflect_ClassTag__O = (function(ct) {
  var x1 = $n(ct).runtimeClass__jl_Class();
  return ((x1 === $d_C.getClassOf()) ? this.toCharArray__AC() : $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, ct));
});
$c_scm_StringBuilder.prototype.toCharArray__AC = (function() {
  var len = $n(this.scm_StringBuilder__f_underlying).length__I();
  var arr = new $ac_C(len);
  $n(this.scm_StringBuilder__f_underlying).getChars__I__I__AC__I__V(0, len, arr, 0);
  return arr;
});
$c_scm_StringBuilder.prototype.append__T__scm_StringBuilder = (function(s) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this;
});
$c_scm_StringBuilder.prototype.appendAll__sc_IterableOnce__scm_StringBuilder = (function(xs) {
  if (false) {
    var x2 = $as_sci_WrappedString(xs);
    var this$3 = $n(this.scm_StringBuilder__f_underlying);
    var str = $n(x2).sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  } else if ((xs instanceof $c_scm_ArraySeq$ofChar)) {
    var x3 = $as_scm_ArraySeq$ofChar(xs);
    $n(this.scm_StringBuilder__f_underlying).append__AC__jl_StringBuilder($n(x3).scm_ArraySeq$ofChar__f_array);
  } else if ((xs instanceof $c_scm_StringBuilder)) {
    var x4 = $as_scm_StringBuilder(xs);
    var this$4 = $n(this.scm_StringBuilder__f_underlying);
    var s = $n(x4).scm_StringBuilder__f_underlying;
    this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  } else {
    var ks = $n(xs).knownSize__I();
    if ((ks !== 0)) {
      var b = this.scm_StringBuilder__f_underlying;
      if ((ks > 0)) {
        $n(b);
        $n(b).length__I();
      }
      var it = $n(xs).iterator__sc_Iterator();
      while ($n(it).hasNext__Z()) {
        var this$5 = $n(b);
        var c = $uC($n(it).next__O());
        var str$1 = ("" + $cToS(c));
        this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$5.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
      }
    }
  }
  return this;
});
$c_scm_StringBuilder.prototype.append__I__scm_StringBuilder = (function(x) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = ("" + x);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_scm_StringBuilder.prototype.append__J__scm_StringBuilder = (function(x_$_lo, x_$_hi) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = $m_RTLong$().toString__I__I__T(x_$_lo, x_$_hi);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this;
});
$c_scm_StringBuilder.prototype.append__C__scm_StringBuilder = (function(x) {
  var this$1 = $n(this.scm_StringBuilder__f_underlying);
  var str = ("" + $cToS(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_scm_StringBuilder.prototype.deleteCharAt__I__scm_StringBuilder = (function(index) {
  $n(this.scm_StringBuilder__f_underlying).deleteCharAt__I__jl_StringBuilder(index);
  return this;
});
$c_scm_StringBuilder.prototype.setCharAt__I__C__scm_StringBuilder = (function(index, ch) {
  $n(this.scm_StringBuilder__f_underlying).setCharAt__I__C__V(index, ch);
  return this;
});
$c_scm_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return $n(this.scm_StringBuilder__f_underlying).substring__I__I__T(start, end);
});
$c_scm_StringBuilder.prototype.isEmpty__Z = (function() {
  return ($n(this.scm_StringBuilder__f_underlying).length__I() === 0);
});
$c_scm_StringBuilder.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_IndexedSeq$();
});
$c_scm_StringBuilder.prototype.result__O = (function() {
  return $n(this.scm_StringBuilder__f_underlying).jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_scm_StringBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__C__scm_StringBuilder($uC(elem));
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll);
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll);
});
$c_scm_StringBuilder.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return $bC($n(this.scm_StringBuilder__f_underlying).charAt__I__C(i));
});
$c_scm_StringBuilder.prototype.apply__I__O = (function(i) {
  return $bC($n(this.scm_StringBuilder__f_underlying).charAt__I__C(i));
});
function $as_scm_StringBuilder(obj) {
  return (((obj instanceof $c_scm_StringBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.StringBuilder"));
}
function $isArrayOf_scm_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_StringBuilder)));
}
function $asArrayOf_scm_StringBuilder(obj, depth) {
  return (($isArrayOf_scm_StringBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.StringBuilder;", depth));
}
var $d_scm_StringBuilder = new $TypeData().initClass($c_scm_StringBuilder, "scala.collection.mutable.StringBuilder", ({
  scm_StringBuilder: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  jl_CharSequence: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_instances_OptionInstances$$anon$1() {
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = null;
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = new $c_s_Some((void 0));
}
$c_Lcats_instances_OptionInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OptionInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OptionInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OptionInstances$$anon$1() {
}
$h_Lcats_instances_OptionInstances$$anon$1.prototype = $c_Lcats_instances_OptionInstances$$anon$1.prototype;
$c_Lcats_instances_OptionInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.traverse__s_Option__F1__Lcats_Applicative__O($as_s_Option(sa), f, evidence$1);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__s_Option__s_Option__s_Option = (function(x, y) {
  var this$1 = $n(x);
  if ((!this$1.isEmpty__Z())) {
    return x;
  } else {
    return y;
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__s_Option = (function(a, f) {
  var a$tailLocal1 = a;
  while (true) {
    var x4 = $as_s_Option($n(f).apply__O__O(a$tailLocal1));
    var x = $m_s_None$();
    if ((x === x4)) {
      return $m_s_None$();
    }
    if ((x4 instanceof $c_s_Some)) {
      var x10 = $as_s_util_Either($n($as_s_Some(x4)).s_Some__f_value);
      if ((x10 instanceof $c_s_util_Left)) {
        var a1 = $n($as_s_util_Left(x10)).s_util_Left__f_value;
        a$tailLocal1 = a1;
        continue;
      }
      if ((x10 instanceof $c_s_util_Right)) {
        var b = $n($as_s_util_Right(x10)).s_util_Right__f_value;
        return new $c_s_Some(b);
      }
    }
    throw new $c_s_MatchError(x4);
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__s_Option__s_Option__F2__s_Option = (function(fa, fb, f) {
  var this$1 = $n(fa);
  if ((!this$1.isEmpty__Z())) {
    var this$2 = $n(fb);
    var $x_1 = (!this$2.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var value = $n(f).apply__O__O__O($n(fa).get__O(), $n(fb).get__O());
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__s_Option__s_Option__s_Option = (function(fa, fb) {
  var this$1 = $n(fa);
  if ((!this$1.isEmpty__Z())) {
    var this$2 = $n(fb);
    var $x_1 = (!this$2.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var _1 = $n(fa).get__O();
    var _2 = $n(fb).get__O();
    var value = new $c_T2(_1, _2);
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productR__s_Option__s_Option__s_Option = (function(fa, fb) {
  var this$1 = $n(fa);
  if ((!this$1.isEmpty__Z())) {
    return fb;
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productL__s_Option__s_Option__s_Option = (function(fa, fb) {
  var this$1 = $n(fb);
  if ((!this$1.isEmpty__Z())) {
    return fa;
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    var value = $m_s_None$();
    return new $c_Lcats_Now(value);
  }
  if ((fa instanceof $c_s_Some)) {
    var a = $n($as_s_Some(fa)).s_Some__f_value;
    return $n(fb).map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((x$1) => {
      var x$1$1 = $as_s_Option(x$1);
      if ((x$1$1 instanceof $c_s_Some)) {
        var b = $n($as_s_Some(x$1$1)).s_Some__f_value;
        var value$1 = $n(f).apply__O__O__O(a, b);
        return new $c_s_Some(value$1);
      }
      var x$2 = $m_s_None$();
      if ((x$2 === x$1$1)) {
        return $m_s_None$();
      }
      throw new $c_s_MatchError(x$1$1);
    })));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return lb;
  }
  if ((fa instanceof $c_s_Some)) {
    var a = $n($as_s_Some(fa)).s_Some__f_value;
    return $as_Lcats_Eval($n(f).apply__O__O__O(a, lb));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__s_Option__F1__s_Option = (function(fa, f) {
  var this$1 = $n(fa);
  return (this$1.isEmpty__Z() ? $as_s_Option($n(f).apply__O__O((void 0))) : this$1);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__s_Option__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return $n(evidence$1).pure__O__O($m_s_None$());
  }
  if ((fa instanceof $c_s_Some)) {
    var a = $n($as_s_Some(fa)).s_Some__f_value;
    return $n(evidence$1).map__O__F1__O($n(f).apply__O__O(a), new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => new $c_s_Some(_$2))));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldMap__s_Option__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = $n(fa);
  return (this$1.isEmpty__Z() ? $n(B).empty__O() : $n(f).apply__O__O(this$1.get__O()));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.void__s_Option__s_Option = (function(oa) {
  var this$1 = $n(oa);
  if ((!this$1.isEmpty__Z())) {
    return this.Lcats_instances_OptionInstances$$anon$1__f_someUnit;
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.empty__O = (function() {
  return $m_s_None$();
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.combineK__s_Option__s_Option__s_Option($as_s_Option(x), $as_s_Option(y));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $c_s_Some(x);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($n(f).apply__O__O(this$1.get__O())));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  var this$1 = $n(fa$1);
  return (this$1.isEmpty__Z() ? $m_s_None$() : $as_s_Option($n(f).apply__O__O(this$1.get__O())));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_Option(a, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__s_Option__s_Option__F2__s_Option($as_s_Option(fa), $as_s_Option(fb), f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return this.productR__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return this.productL__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval($as_s_Option(fa), fb, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval($as_s_Option(fa), lb, f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.raiseError__O__O = (function(e) {
  $as_jl_Void(e);
  return $m_s_None$();
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_Option__F1__s_Option($as_s_Option(fa), f);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_Option__F1__Lcats_Applicative__O($as_s_Option(fa), f, evidence$1);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__s_Option__F1__Lcats_kernel_Monoid__O($as_s_Option(fa), f, B);
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.unit__O = (function() {
  return this.Lcats_instances_OptionInstances$$anon$1__f_someUnit;
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return this.void__s_Option__s_Option($as_s_Option(fa));
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this);
});
var $d_Lcats_instances_OptionInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_OptionInstances$$anon$1, "cats.instances.OptionInstances$$anon$1", ({
  Lcats_instances_OptionInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
/** @constructor */
function $c_sci_BitSet() {
}
$c_sci_BitSet.prototype = new $h_sci_AbstractSet();
$c_sci_BitSet.prototype.constructor = $c_sci_BitSet;
/** @constructor */
function $h_sci_BitSet() {
}
$h_sci_BitSet.prototype = $c_sci_BitSet.prototype;
$c_sci_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet";
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  return $as_sc_BitSet($f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps(this, that));
});
$c_sci_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$();
});
$c_sci_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0);
});
$c_sci_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this);
});
$c_sci_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this);
});
$c_sci_BitSet.prototype.foreach__F1__V = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f);
});
$c_sci_BitSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_BitSet.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_BitSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, false);
});
$c_sci_BitSet.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_BitSet(pred, true);
});
$c_sci_BitSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$c_sci_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_BitSet$().newBuilder__scm_Builder();
});
$c_sci_BitSet.prototype.incl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0");
  }
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    return this;
  } else {
    var idx = (elem >> 6);
    var $x_1 = this.word__I__J(idx);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (x_$_lo | lo);
    var hi$1 = (x_$_hi | hi);
    return this.updateWord__I__J__sci_BitSet(idx, lo$1, hi$1);
  }
});
$c_sci_BitSet.prototype.excl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0");
  }
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var $x_1 = this.word__I__J(idx);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (x_$_lo & lo$1);
    var hi$2 = (x_$_hi & hi$1);
    return this.updateWord__I__J__sci_BitSet(idx, lo$2, hi$2);
  } else {
    return this;
  }
});
$c_sci_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1);
});
$c_sci_BitSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__I__sci_BitSet($uI(elem));
});
$c_sci_BitSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__I__sci_BitSet($uI(elem));
});
$c_sci_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll);
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll);
});
function $as_sci_BitSet(obj) {
  return (((obj instanceof $c_sci_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitSet"));
}
function $isArrayOf_sci_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitSet)));
}
function $asArrayOf_sci_BitSet(obj, depth) {
  return (($isArrayOf_sci_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitSet;", depth));
}
function $as_scm_LinkedHashMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.LinkedHashMap"));
}
function $isArrayOf_scm_LinkedHashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashMap)));
}
function $asArrayOf_scm_LinkedHashMap(obj, depth) {
  return (($isArrayOf_scm_LinkedHashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.LinkedHashMap;", depth));
}
function $p_scm_ListBuffer__copyElems__V($thiz) {
  var buf = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer($thiz);
  $thiz.scm_ListBuffer__f_first = $n(buf).scm_ListBuffer__f_first;
  $thiz.scm_ListBuffer__f_last0 = $n(buf).scm_ListBuffer__f_last0;
  $thiz.scm_ListBuffer__f_aliased = false;
}
function $p_scm_ListBuffer__ensureUnaliased__V($thiz) {
  $thiz.scm_ListBuffer__f_mutationCount = ((1 + $thiz.scm_ListBuffer__f_mutationCount) | 0);
  if ($thiz.scm_ListBuffer__f_aliased) {
    $p_scm_ListBuffer__copyElems__V($thiz);
  }
}
function $p_scm_ListBuffer__reduceLengthBy__I__V($thiz, num) {
  $thiz.scm_ListBuffer__f_len = (($thiz.scm_ListBuffer__f_len - num) | 0);
  if (($thiz.scm_ListBuffer__f_len <= 0)) {
    $thiz.scm_ListBuffer__f_last0 = null;
  }
}
function $p_scm_ListBuffer__predecessor__I__sci_$colon$colon($thiz, i) {
  if ((i === 0)) {
    return null;
  } else if ((i === $thiz.scm_ListBuffer__f_len)) {
    return $thiz.scm_ListBuffer__f_last0;
  } else {
    var j = ((i - 1) | 0);
    var p = $thiz.scm_ListBuffer__f_first;
    while ((j > 0)) {
      p = $as_sci_List($n(p).tail__O());
      j = ((j - 1) | 0);
    }
    return $as_sci_$colon$colon(p);
  }
}
function $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List($thiz, p) {
  return ((p === null) ? $thiz.scm_ListBuffer__f_first : $n(p).sci_$colon$colon__f_next);
}
/** @constructor */
function $c_scm_ListBuffer() {
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = null;
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = $m_sci_Nil$();
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
}
$c_scm_ListBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ListBuffer.prototype.constructor = $c_scm_ListBuffer;
/** @constructor */
function $h_scm_ListBuffer() {
}
$h_scm_ListBuffer.prototype = $c_scm_ListBuffer.prototype;
$c_scm_ListBuffer.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_ListBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ListBuffer.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_scm_ListBuffer.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ListBuffer.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ListBuffer.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_MutationTracker$CheckedIterator($n(this.scm_ListBuffer__f_first).iterator__sc_Iterator(), new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.scm_ListBuffer__f_mutationCount)));
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ListBuffer$();
});
$c_scm_ListBuffer.prototype.apply__I__O = (function(i) {
  var this$1 = $n(this.scm_ListBuffer__f_first);
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i);
});
$c_scm_ListBuffer.prototype.length__I = (function() {
  return this.scm_ListBuffer__f_len;
});
$c_scm_ListBuffer.prototype.knownSize__I = (function() {
  return this.scm_ListBuffer__f_len;
});
$c_scm_ListBuffer.prototype.isEmpty__Z = (function() {
  return (this.scm_ListBuffer__f_len === 0);
});
$c_scm_ListBuffer.prototype.toList__sci_List = (function() {
  this.scm_ListBuffer__f_aliased = (!this.isEmpty__Z());
  return this.scm_ListBuffer__f_first;
});
$c_scm_ListBuffer.prototype.addOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  var last1 = new $c_sci_$colon$colon(elem, $m_sci_Nil$());
  if ((this.scm_ListBuffer__f_len === 0)) {
    this.scm_ListBuffer__f_first = last1;
  } else {
    $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_next = last1;
  }
  this.scm_ListBuffer__f_last0 = last1;
  this.scm_ListBuffer__f_len = ((1 + this.scm_ListBuffer__f_len) | 0);
  return this;
});
$c_scm_ListBuffer.prototype.scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = $n(xs).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var len = 1;
    var last0 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
    this.scm_ListBuffer__f_first = last0;
    while ($n(it).hasNext__Z()) {
      var last1 = new $c_sci_$colon$colon($n(it).next__O(), $m_sci_Nil$());
      $n(last0).sci_$colon$colon__f_next = last1;
      last0 = last1;
      len = ((1 + len) | 0);
    }
    this.scm_ListBuffer__f_len = len;
    this.scm_ListBuffer__f_last0 = last0;
  }
  return this;
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = $n(xs).iterator__sc_Iterator();
  if ($n(it).hasNext__Z()) {
    var fresh = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(it);
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    if ((this.scm_ListBuffer__f_len === 0)) {
      this.scm_ListBuffer__f_first = $n(fresh).scm_ListBuffer__f_first;
    } else {
      $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_next = $n(fresh).scm_ListBuffer__f_first;
    }
    this.scm_ListBuffer__f_last0 = $n(fresh).scm_ListBuffer__f_last0;
    this.scm_ListBuffer__f_len = ((this.scm_ListBuffer__f_len + $n(fresh).scm_ListBuffer__f_len) | 0);
  }
  return this;
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if ((!this.isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($n(this.scm_ListBuffer__f_first).head__O(), elem)) {
      this.scm_ListBuffer__f_first = $as_sci_List($n(this.scm_ListBuffer__f_first).tail__O());
      $p_scm_ListBuffer__reduceLengthBy__I__V(this, 1);
    } else {
      var cursor = this.scm_ListBuffer__f_first;
      while (((!$n($as_sci_List($n(cursor).tail__O())).isEmpty__Z()) && (!$m_sr_BoxesRunTime$().equals__O__O__Z($n($as_sc_IterableOps($n(cursor).tail__O())).head__O(), elem)))) {
        cursor = $as_sci_List($n(cursor).tail__O());
      }
      if ((!$n($as_sci_List($n(cursor).tail__O())).isEmpty__Z())) {
        var z = $as_sci_$colon$colon(cursor);
        var x = $n(z).sci_$colon$colon__f_next;
        var x$2 = this.scm_ListBuffer__f_last0;
        if (((x === null) ? (x$2 === null) : $n(x).equals__O__Z(x$2))) {
          this.scm_ListBuffer__f_last0 = z;
        }
        $n(z).sci_$colon$colon__f_next = $as_sci_List($n($as_sc_IterableOps($n(cursor).tail__O())).tail__O());
        $p_scm_ListBuffer__reduceLengthBy__I__V(this, 1);
      }
    }
  }
  return this;
});
$c_scm_ListBuffer.prototype.remove__I__O = (function(idx) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if (((idx < 0) || (idx >= this.scm_ListBuffer__f_len))) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, ((this.scm_ListBuffer__f_len - 1) | 0)));
  }
  var p = $p_scm_ListBuffer__predecessor__I__sci_$colon$colon(this, idx);
  var nx = $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List(this, p);
  if ((p === null)) {
    this.scm_ListBuffer__f_first = $as_sci_List($n(nx).tail__O());
    if ($n(this.scm_ListBuffer__f_first).isEmpty__Z()) {
      this.scm_ListBuffer__f_last0 = null;
    }
  } else {
    if ((this.scm_ListBuffer__f_last0 === nx)) {
      this.scm_ListBuffer__f_last0 = p;
    }
    $n(p).sci_$colon$colon__f_next = $as_sci_List($n(nx).tail__O());
  }
  this.scm_ListBuffer__f_len = ((this.scm_ListBuffer__f_len - 1) | 0);
  return $n(nx).head__O();
});
$c_scm_ListBuffer.prototype.last__O = (function() {
  if ((this.scm_ListBuffer__f_last0 === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty ListBuffer");
  } else {
    return $n(this.scm_ListBuffer__f_last0).sci_$colon$colon__f_head;
  }
});
$c_scm_ListBuffer.prototype.stringPrefix__T = (function() {
  return "ListBuffer";
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_ListBuffer(elem);
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return this.subtractOne__O__scm_ListBuffer(x);
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ListBuffer(elems);
});
$c_scm_ListBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ListBuffer(elem);
});
$c_scm_ListBuffer.prototype.result__O = (function() {
  return this.toList__sci_List();
});
$c_scm_ListBuffer.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = $n(this.scm_ListBuffer__f_first);
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i);
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ListBuffer$();
});
function $as_scm_ListBuffer(obj) {
  return (((obj instanceof $c_scm_ListBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ListBuffer"));
}
function $isArrayOf_scm_ListBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ListBuffer)));
}
function $asArrayOf_scm_ListBuffer(obj, depth) {
  return (($isArrayOf_scm_ListBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ListBuffer;", depth));
}
var $d_scm_ListBuffer = new $TypeData().initClass($c_scm_ListBuffer, "scala.collection.mutable.ListBuffer", ({
  scm_ListBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_BitSet$BitSet1(elems_$_lo, elems_$_hi) {
  this.sci_BitSet$BitSet1__f_elems_$lo = 0;
  this.sci_BitSet$BitSet1__f_elems_$hi = 0;
  this.sci_BitSet$BitSet1__f_elems_$lo = elems_$_lo;
  this.sci_BitSet$BitSet1__f_elems_$hi = elems_$_hi;
}
$c_sci_BitSet$BitSet1.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet1.prototype.constructor = $c_sci_BitSet$BitSet1;
/** @constructor */
function $h_sci_BitSet$BitSet1() {
}
$h_sci_BitSet$BitSet1.prototype = $c_sci_BitSet$BitSet1.prototype;
$c_sci_BitSet$BitSet1.prototype.nwords__I = (function() {
  return 1;
});
$c_sci_BitSet$BitSet1.prototype.word__I__J = (function(idx) {
  if ((idx === 0)) {
    return $bL(this.sci_BitSet$BitSet1__f_elems_$lo, this.sci_BitSet$BitSet1__f_elems_$hi);
  } else {
    return $bL(0, 0);
  }
});
$c_sci_BitSet$BitSet1.prototype.updateWord__I__J__sci_BitSet = (function(idx, w_$_lo, w_$_hi) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet1(w_$_lo, w_$_hi);
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet1__f_elems_$lo, this.sci_BitSet$BitSet1__f_elems_$hi, w_$_lo, w_$_hi);
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J(new Int32Array([this.sci_BitSet$BitSet1__f_elems_$lo, this.sci_BitSet$BitSet1__f_elems_$hi])), idx, w_$_lo, w_$_hi);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
  }
});
$c_sci_BitSet$BitSet1.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var $x_1 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet1__f_elems_$lo, this.sci_BitSet$BitSet1__f_elems_$hi, 0);
  var _elems_$_lo = $x_1.l;
  var _elems_$_hi = $x_1.h;
  return (((_elems_$_lo | _elems_$_hi) === 0) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(_elems_$_lo, _elems_$_hi));
});
var $d_sci_BitSet$BitSet1 = new $TypeData().initClass($c_sci_BitSet$BitSet1, "scala.collection.immutable.BitSet$BitSet1", ({
  sci_BitSet$BitSet1: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_BitSet$BitSet2(elems0_$_lo, elems0_$_hi, elems1_$_lo, elems1_$_hi) {
  this.sci_BitSet$BitSet2__f_elems0_$lo = 0;
  this.sci_BitSet$BitSet2__f_elems0_$hi = 0;
  this.sci_BitSet$BitSet2__f_elems1_$lo = 0;
  this.sci_BitSet$BitSet2__f_elems1_$hi = 0;
  this.sci_BitSet$BitSet2__f_elems0_$lo = elems0_$_lo;
  this.sci_BitSet$BitSet2__f_elems0_$hi = elems0_$_hi;
  this.sci_BitSet$BitSet2__f_elems1_$lo = elems1_$_lo;
  this.sci_BitSet$BitSet2__f_elems1_$hi = elems1_$_hi;
}
$c_sci_BitSet$BitSet2.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet2.prototype.constructor = $c_sci_BitSet$BitSet2;
/** @constructor */
function $h_sci_BitSet$BitSet2() {
}
$h_sci_BitSet$BitSet2.prototype = $c_sci_BitSet$BitSet2.prototype;
$c_sci_BitSet$BitSet2.prototype.nwords__I = (function() {
  return 2;
});
$c_sci_BitSet$BitSet2.prototype.word__I__J = (function(idx) {
  if ((idx === 0)) {
    return $bL(this.sci_BitSet$BitSet2__f_elems0_$lo, this.sci_BitSet$BitSet2__f_elems0_$hi);
  } else if ((idx === 1)) {
    return $bL(this.sci_BitSet$BitSet2__f_elems1_$lo, this.sci_BitSet$BitSet2__f_elems1_$hi);
  } else {
    return $bL(0, 0);
  }
});
$c_sci_BitSet$BitSet2.prototype.updateWord__I__J__sci_BitSet = (function(idx, w_$_lo, w_$_hi) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet2(w_$_lo, w_$_hi, this.sci_BitSet$BitSet2__f_elems1_$lo, this.sci_BitSet$BitSet2__f_elems1_$hi);
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet2__f_elems0_$lo, this.sci_BitSet$BitSet2__f_elems0_$hi, w_$_lo, w_$_hi);
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J(new Int32Array([this.sci_BitSet$BitSet2__f_elems0_$lo, this.sci_BitSet$BitSet2__f_elems0_$hi, this.sci_BitSet$BitSet2__f_elems1_$lo, this.sci_BitSet$BitSet2__f_elems1_$hi])), idx, w_$_lo, w_$_hi);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
  }
});
$c_sci_BitSet$BitSet2.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var $x_1 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet2__f_elems0_$lo, this.sci_BitSet$BitSet2__f_elems0_$hi, 0);
  var _elems0_$_lo = $x_1.l;
  var _elems0_$_hi = $x_1.h;
  var $x_2 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, this.sci_BitSet$BitSet2__f_elems1_$lo, this.sci_BitSet$BitSet2__f_elems1_$hi, 1);
  var _elems1_$_lo = $x_2.l;
  var _elems1_$_hi = $x_2.h;
  return (((_elems1_$_lo | _elems1_$_hi) === 0) ? (((_elems0_$_lo | _elems0_$_hi) === 0) ? $m_sci_BitSet$().sci_BitSet$__f_empty : new $c_sci_BitSet$BitSet1(_elems0_$_lo, _elems0_$_hi)) : new $c_sci_BitSet$BitSet2(_elems0_$_lo, _elems0_$_hi, _elems1_$_lo, _elems1_$_hi));
});
var $d_sci_BitSet$BitSet2 = new $TypeData().initClass($c_sci_BitSet$BitSet2, "scala.collection.immutable.BitSet$BitSet2", ({
  sci_BitSet$BitSet2: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_sci_BitSet$BitSetN(elems) {
  this.sci_BitSet$BitSetN__f_elems = null;
  this.sci_BitSet$BitSetN__f_elems = elems;
}
$c_sci_BitSet$BitSetN.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSetN.prototype.constructor = $c_sci_BitSet$BitSetN;
/** @constructor */
function $h_sci_BitSet$BitSetN() {
}
$h_sci_BitSet$BitSetN.prototype = $c_sci_BitSet$BitSetN.prototype;
$c_sci_BitSet$BitSetN.prototype.nwords__I = (function() {
  return (($n(this.sci_BitSet$BitSetN__f_elems).u.length >>> 1) | 0);
});
$c_sci_BitSet$BitSetN.prototype.word__I__J = (function(idx) {
  if ((idx < (($n(this.sci_BitSet$BitSetN__f_elems).u.length >>> 1) | 0))) {
    var $x_1 = $n(this.sci_BitSet$BitSetN__f_elems).u;
    var $x_2 = $aJCheckGet($x_1, idx);
    return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
  } else {
    return $bL(0, 0);
  }
});
$c_sci_BitSet$BitSetN.prototype.updateWord__I__J__sci_BitSet = (function(idx, w_$_lo, w_$_hi) {
  var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(this.sci_BitSet$BitSetN__f_elems, idx, w_$_lo, w_$_hi);
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems);
});
$c_sci_BitSet$BitSetN.prototype.filterImpl__F1__Z__sci_BitSet = (function(pred, isFlipped) {
  var i = (((($n(this.sci_BitSet$BitSetN__f_elems).u.length >>> 1) | 0) - 1) | 0);
  var currentWord_$_lo = 0;
  var currentWord_$_hi = 0;
  var anyChanges = false;
  while (true) {
    if ((i >= 0)) {
      var x_$_lo = currentWord_$_lo;
      var x_$_hi = currentWord_$_hi;
      var $x_3 = ((x_$_lo | x_$_hi) === 0);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var $x_1 = this.word__I__J(i);
      var oldWord_$_lo = $x_1.l;
      var oldWord_$_hi = $x_1.h;
      var $x_2 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, oldWord_$_lo, oldWord_$_hi, i);
      currentWord_$_lo = $x_2.l;
      currentWord_$_hi = $x_2.h;
      if (anyChanges) {
        anyChanges = true;
      } else {
        var x$1_$_lo = currentWord_$_lo;
        var x$1_$_hi = currentWord_$_hi;
        anyChanges = (((x$1_$_lo ^ oldWord_$_lo) | (x$1_$_hi ^ oldWord_$_hi)) !== 0);
      }
      i = ((i - 1) | 0);
    } else {
      break;
    }
  }
  var x1 = i;
  switch (x1) {
    case (-1): {
      if (anyChanges) {
        var x$2_$_lo = currentWord_$_lo;
        var x$2_$_hi = currentWord_$_hi;
        if (((x$2_$_lo | x$2_$_hi) === 0)) {
          return $m_sci_BitSet$().sci_BitSet$__f_empty;
        } else {
          return new $c_sci_BitSet$BitSet1(currentWord_$_lo, currentWord_$_hi);
        }
      } else {
        return this;
      }
      break;
    }
    case 0: {
      var $x_4 = this.word__I__J(0);
      var oldFirstWord_$_lo = $x_4.l;
      var oldFirstWord_$_hi = $x_4.h;
      var $x_5 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, oldFirstWord_$_lo, oldFirstWord_$_hi, 0);
      var firstWord_$_lo = $x_5.l;
      var firstWord_$_hi = $x_5.h;
      anyChanges = (anyChanges || (((firstWord_$_lo ^ oldFirstWord_$_lo) | (firstWord_$_hi ^ oldFirstWord_$_hi)) !== 0));
      return (anyChanges ? new $c_sci_BitSet$BitSet2(firstWord_$_lo, firstWord_$_hi, currentWord_$_lo, currentWord_$_hi) : this);
      break;
    }
    default: {
      var minimumNonZeroIndex = ((1 + i) | 0);
      while (((!anyChanges) && (i >= 0))) {
        var $x_6 = this.word__I__J(i);
        var oldWord$2_$_lo = $x_6.l;
        var oldWord$2_$_hi = $x_6.h;
        var $x_7 = $m_sc_BitSetOps$().computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, oldWord$2_$_lo, oldWord$2_$_hi, i);
        currentWord_$_lo = $x_7.l;
        currentWord_$_hi = $x_7.h;
        if (anyChanges) {
          anyChanges = true;
        } else {
          var x$3_$_lo = currentWord_$_lo;
          var x$3_$_hi = currentWord_$_hi;
          anyChanges = (((x$3_$_lo ^ oldWord$2_$_lo) | (x$3_$_hi ^ oldWord$2_$_hi)) !== 0);
        }
        i = ((i - 1) | 0);
      }
      if (anyChanges) {
        var xs = this.sci_BitSet$BitSetN__f_elems;
        var n = ((1 + minimumNonZeroIndex) | 0);
        var newArray = $asArrayOf_J($m_sc_ArrayOps$().slice$extension__O__I__I__O(xs, 0, n), 1);
        $n(newArray).set(((1 + i) | 0), currentWord_$_lo, currentWord_$_hi);
        while ((i >= 0)) {
          var $x_12 = $n(newArray);
          var $x_11 = i;
          var $x_10 = $m_sc_BitSetOps$();
          var $x_9 = this.word__I__J(i);
          var $x_8 = $x_10.computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, $x_9.l, $x_9.h, i);
          $x_12.set($x_11, $x_8.l, $x_8.h);
          i = ((i - 1) | 0);
        }
        return new $c_sci_BitSet$BitSetN(newArray);
      } else {
        return this;
      }
    }
  }
});
var $d_sci_BitSet$BitSetN = new $TypeData().initClass($c_sci_BitSet$BitSetN, "scala.collection.immutable.BitSet$BitSetN", ({
  sci_BitSet$BitSetN: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
function $f_Lcats_effect_kernel_Async$KleisliAsync__unique__Lcats_data_Kleisli($thiz) {
  var thunk = new $c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => new $c_Lcats_effect_kernel_Unique$Token()));
  var hint = $thiz.Lcats_effect_kernel_Async$$anon$9__f_cats$effect$kernel$Sync$$Delay;
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli($thiz, hint, thunk);
}
function $f_Lcats_effect_kernel_Async$KleisliAsync__cont__Lcats_effect_kernel_Cont__Lcats_data_Kleisli($thiz, body) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((r) => $n($thiz.Lcats_effect_kernel_Async$$anon$9__f_F0$5).cont__Lcats_effect_kernel_Cont__O(new $c_Lcats_effect_kernel_Async$KleisliAsync$$anon$18(body, r))));
  return new $c_Lcats_data_Kleisli(run);
}
function $f_Lcats_effect_kernel_Async$KleisliAsync__executionContext__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.Lcats_effect_kernel_Async$$anon$9__f_F0$5).executionContext__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
function $f_Lcats_effect_kernel_Async$KleisliAsync__never__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $n($thiz.Lcats_effect_kernel_Async$$anon$9__f_F0$5).never__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x);
}
/** @constructor */
function $c_Lcats_effect_kernel_Async$$anon$9(F0$10) {
  this.Lcats_effect_kernel_Async$$anon$9__f_F0$5 = null;
  this.Lcats_effect_kernel_Async$$anon$9__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_kernel_Async$$anon$9__f_F0$5 = F0$10;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
}
$c_Lcats_effect_kernel_Async$$anon$9.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$$anon$9.prototype.constructor = $c_Lcats_effect_kernel_Async$$anon$9;
/** @constructor */
function $h_Lcats_effect_kernel_Async$$anon$9() {
}
$h_Lcats_effect_kernel_Async$$anon$9.prototype = $c_Lcats_effect_kernel_Async$$anon$9.prototype;
$c_Lcats_effect_kernel_Async$$anon$9.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.redeemWith__O__F1__F1__O = (function(fa, recover, bind) {
  return $f_Lcats_MonadError__redeemWith__O__F1__F1__O(this, fa, recover, bind);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_kernel_Async$$anon$9__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_Async$$anon$9__f_cats$effect$kernel$Sync$$Delay;
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.asyncCheckAttempt__F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__asyncCheckAttempt__F1__O(this, k);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.async__F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async__F1__O(this, k);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.async___F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async___F1__O(this, k);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.C__Lcats_effect_kernel_Clock = (function() {
  return this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.F__Lcats_effect_kernel_GenSpawn = (function() {
  return this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.F__Lcats_effect_kernel_Sync = (function() {
  return this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Async$KleisliAsync__unique__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.cont__Lcats_effect_kernel_Cont__O = (function(body) {
  return $f_Lcats_effect_kernel_Async$KleisliAsync__cont__Lcats_effect_kernel_Cont__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.executionContext__O = (function() {
  return $f_Lcats_effect_kernel_Async$KleisliAsync__executionContext__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_Async$KleisliAsync__never__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $n(fa$1).flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$10__f_ME$1);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e$1);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_Async$$anon$9__f_F0$5;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$10(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.ref__O__O = (function(a) {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__ref__O__Lcats_data_Kleisli(this, a);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.deferred__O = (function() {
  return $f_Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent__deferred__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.racePair__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__racePair__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__start__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.cede__O = (function() {
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__cede__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.both__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__both__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.raceOutcome__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_GenSpawn$KleisliGenSpawn__raceOutcome__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $f_Lcats_effect_kernel_Sync$KleisliSync__suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_data_Kleisli(this, hint, thunk);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.realTime__O = (function() {
  return $f_Lcats_effect_kernel_Clock$KleisliClock__realTime__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1);
});
$c_Lcats_effect_kernel_Async$$anon$9.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin);
});
var $d_Lcats_effect_kernel_Async$$anon$9 = new $TypeData().initClass($c_Lcats_effect_kernel_Async$$anon$9, "cats.effect.kernel.Async$$anon$9", ({
  Lcats_effect_kernel_Async$$anon$9: 1,
  Lcats_effect_kernel_AsyncPlatform: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_Async: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1,
  Lcats_effect_kernel_Clock$KleisliClock: 1,
  Lcats_effect_kernel_Sync$KleisliSync: 1,
  Lcats_effect_kernel_GenSpawn$KleisliGenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent$KleisliGenConcurrent: 1,
  Lcats_effect_kernel_GenTemporal$KleisliTemporal: 1,
  Lcats_effect_kernel_Async$KleisliAsync: 1
}));
function $ct_Lcats_effect_kernel_ResourceAsync__($thiz) {
  $f_Lcats_effect_kernel_Sync__$init$__V($thiz);
  return $thiz;
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceAsync() {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay = null;
}
$c_Lcats_effect_kernel_ResourceAsync.prototype = new $h_Lcats_effect_kernel_ResourceConcurrent();
$c_Lcats_effect_kernel_ResourceAsync.prototype.constructor = $c_Lcats_effect_kernel_ResourceAsync;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceAsync() {
}
$h_Lcats_effect_kernel_ResourceAsync.prototype = $c_Lcats_effect_kernel_ResourceAsync.prototype;
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay;
  return $m_Lcats_effect_kernel_Resource$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource(hint, thunk, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.asyncCheckAttempt__F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__asyncCheckAttempt__F1__O(this, k);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.async__F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async__F1__O(this, k);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.async___F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async___F1__O(this, k);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.unique__Lcats_effect_kernel_Resource = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).unique__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.never__Lcats_effect_kernel_Resource = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).never__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.unique__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).unique__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.never__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).never__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cont__Lcats_effect_kernel_Cont__O = (function(body) {
  return $m_Lcats_effect_kernel_Resource$().cont__Lcats_effect_kernel_Cont__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(body, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.executionContext__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).executionContext__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $m_Lcats_effect_kernel_Resource$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource(hint, thunk, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1);
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.realTime__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
  var fa = $n(F).realTime__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa);
});
function $p_scm_ArrayBuffer__reduceToSize__I__V($thiz, n) {
  $thiz.scm_ArrayBuffer__f_mutationCount = ((1 + $thiz.scm_ArrayBuffer__f_mutationCount) | 0);
  var a = $thiz.scm_ArrayBuffer__f_array;
  var toIndex = $thiz.scm_ArrayBuffer__f_size0;
  $m_ju_Arrays$().fill__AO__I__I__O__V(a, n, toIndex, null);
  $thiz.scm_ArrayBuffer__f_size0 = n;
}
function $p_scm_ArrayBuffer__foldl__I__I__O__F2__O($thiz, start, end, z, op) {
  while (true) {
    if ((start === end)) {
      return z;
    } else {
      var temp$start = ((1 + start) | 0);
      var temp$z = $n(op).apply__O__O__O(z, $n($thiz.scm_ArrayBuffer__f_array).get(start));
      start = temp$start;
      z = temp$z;
    }
  }
}
function $ct_scm_ArrayBuffer__AO__I__($thiz, initialElements, initialSize) {
  $thiz.scm_ArrayBuffer__f_mutationCount = 0;
  $thiz.scm_ArrayBuffer__f_array = initialElements;
  $thiz.scm_ArrayBuffer__f_size0 = initialSize;
  return $thiz;
}
function $ct_scm_ArrayBuffer__($thiz) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(16), 0);
  return $thiz;
}
function $ct_scm_ArrayBuffer__I__($thiz, initialSize) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(((initialSize > 1) ? initialSize : 1)), 0);
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayBuffer() {
  this.scm_ArrayBuffer__f_mutationCount = 0;
  this.scm_ArrayBuffer__f_array = null;
  this.scm_ArrayBuffer__f_size0 = 0;
}
$c_scm_ArrayBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayBuffer.prototype.constructor = $c_scm_ArrayBuffer;
/** @constructor */
function $h_scm_ArrayBuffer() {
}
$h_scm_ArrayBuffer.prototype = $c_scm_ArrayBuffer.prototype;
$c_scm_ArrayBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ArrayBuffer.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_scm_ArrayBuffer.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ArrayBuffer.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ArrayBuffer.prototype.iterator__sc_Iterator = (function() {
  return $n(this.view__scm_ArrayBufferView()).iterator__sc_Iterator();
});
$c_scm_ArrayBuffer.prototype.reverseIterator__sc_Iterator = (function() {
  return $n(this.view__scm_ArrayBufferView()).reverseIterator__sc_Iterator();
});
$c_scm_ArrayBuffer.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_scm_ArrayBuffer.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_ArrayBuffer.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_ArrayBuffer.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_ArrayBuffer.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_ArrayBuffer__f_size0;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_ArrayBuffer.prototype.knownSize__I = (function() {
  return this.scm_ArrayBuffer__f_size0;
});
$c_scm_ArrayBuffer.prototype.ensureSize__I__V = (function(n) {
  this.scm_ArrayBuffer__f_array = $m_scm_ArrayBuffer$().scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO(this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, n);
});
$c_scm_ArrayBuffer.prototype.sizeHint__I__V = (function(size) {
  if (((size > this.scm_ArrayBuffer__f_size0) && (size >= 1))) {
    this.ensureSize__I__V(size);
  }
});
$c_scm_ArrayBuffer.prototype.apply__I__O = (function(n) {
  var hi = ((1 + n) | 0);
  if ((n < 0)) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(n, ((this.scm_ArrayBuffer__f_size0 - 1) | 0)));
  }
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(((hi - 1) | 0), ((this.scm_ArrayBuffer__f_size0 - 1) | 0)));
  }
  return $n(this.scm_ArrayBuffer__f_array).get(n);
});
$c_scm_ArrayBuffer.prototype.update__I__O__V = (function(index, elem) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, ((this.scm_ArrayBuffer__f_size0 - 1) | 0)));
  }
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(((hi - 1) | 0), ((this.scm_ArrayBuffer__f_size0 - 1) | 0)));
  }
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  $n(this.scm_ArrayBuffer__f_array).set(index, elem);
});
$c_scm_ArrayBuffer.prototype.length__I = (function() {
  return this.scm_ArrayBuffer__f_size0;
});
$c_scm_ArrayBuffer.prototype.view__scm_ArrayBufferView = (function() {
  return new $c_scm_ArrayBufferView(this, new $c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => this.scm_ArrayBuffer__f_mutationCount)));
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayBuffer$();
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_ArrayBuffer = (function(elem) {
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  var newSize = ((1 + this.scm_ArrayBuffer__f_size0) | 0);
  if (($n(this.scm_ArrayBuffer__f_array).u.length <= ((newSize - 1) | 0))) {
    this.ensureSize__I__V(newSize);
  }
  this.scm_ArrayBuffer__f_size0 = newSize;
  $n(this.scm_ArrayBuffer__f_array).set(((newSize - 1) | 0), elem);
  return this;
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_ArrayBuffer = (function(elems) {
  if ((elems instanceof $c_scm_ArrayBuffer)) {
    var x2 = $as_scm_ArrayBuffer(elems);
    var elemsLength = $n(x2).scm_ArrayBuffer__f_size0;
    if ((elemsLength > 0)) {
      this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
      this.ensureSize__I__V(((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0));
      $m_s_Array$().copy__O__I__O__I__I__V($n(x2).scm_ArrayBuffer__f_array, 0, this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, elemsLength);
      this.scm_ArrayBuffer__f_size0 = ((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0);
    }
  } else {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
  }
  return this;
});
$c_scm_ArrayBuffer.prototype.remove__I__O = (function(index) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, ((this.scm_ArrayBuffer__f_size0 - 1) | 0)));
  }
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(((hi - 1) | 0), ((this.scm_ArrayBuffer__f_size0 - 1) | 0)));
  }
  var res = this.apply__I__O(index);
  $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, ((1 + index) | 0), this.scm_ArrayBuffer__f_array, index, ((this.scm_ArrayBuffer__f_size0 - ((1 + index) | 0)) | 0));
  $p_scm_ArrayBuffer__reduceToSize__I__V(this, ((this.scm_ArrayBuffer__f_size0 - 1) | 0));
  return res;
});
$c_scm_ArrayBuffer.prototype.stringPrefix__T = (function() {
  return "ArrayBuffer";
});
$c_scm_ArrayBuffer.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.scm_ArrayBuffer__f_size0;
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, 0, xs, start, copied);
  }
  return copied;
});
$c_scm_ArrayBuffer.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 0, this.scm_ArrayBuffer__f_size0, z, op);
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuffer(elems);
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuffer(elem);
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArrayBuffer$();
});
$c_scm_ArrayBuffer.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
function $as_scm_ArrayBuffer(obj) {
  return (((obj instanceof $c_scm_ArrayBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayBuffer"));
}
function $isArrayOf_scm_ArrayBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayBuffer)));
}
function $asArrayOf_scm_ArrayBuffer(obj, depth) {
  return (($isArrayOf_scm_ArrayBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayBuffer;", depth));
}
var $d_scm_ArrayBuffer = new $TypeData().initClass($c_scm_ArrayBuffer, "scala.collection.mutable.ArrayBuffer", ({
  scm_ArrayBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, array) {
  $thiz.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = array;
  return $thiz;
}
function $ct_sjs_js_WrappedArray__($thiz) {
  $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, []);
  return $thiz;
}
/** @constructor */
function $c_sjs_js_WrappedArray() {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = null;
}
$c_sjs_js_WrappedArray.prototype = new $h_scm_AbstractBuffer();
$c_sjs_js_WrappedArray.prototype.constructor = $c_sjs_js_WrappedArray;
/** @constructor */
function $h_sjs_js_WrappedArray() {
}
$h_sjs_js_WrappedArray.prototype = $c_sjs_js_WrappedArray.prototype;
$c_sjs_js_WrappedArray.prototype.sizeHint__I__V = (function(size) {
});
$c_sjs_js_WrappedArray.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sjs_js_WrappedArray.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_sjs_js_WrappedArray.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sjs_js_WrappedArray.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_sjs_js_WrappedArray.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_sjs_js_WrappedArray.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_sjs_js_WrappedArray.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_sjs_js_WrappedArray.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sjs_js_WrappedArray.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sjs_js_WrappedArray.prototype.lengthCompare__I__I = (function(len) {
  var x = $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sjs_js_WrappedArray.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sjs_js_WrappedArray.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjs_js_WrappedArray$();
});
$c_sjs_js_WrappedArray.prototype.apply__I__O = (function(index) {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index];
});
$c_sjs_js_WrappedArray.prototype.length__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
});
$c_sjs_js_WrappedArray.prototype.knownSize__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
});
$c_sjs_js_WrappedArray.prototype.remove__I__O = (function(n) {
  if (((n < 0) || (n >= $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.splice(n, 1)[0];
});
$c_sjs_js_WrappedArray.prototype.className__T = (function() {
  return "WrappedArray";
});
$c_sjs_js_WrappedArray.prototype.result__O = (function() {
  return this;
});
$c_sjs_js_WrappedArray.prototype.addOne__O__scm_Growable = (function(elem) {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.push(elem);
  return this;
});
$c_sjs_js_WrappedArray.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index];
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjs_js_WrappedArray$();
});
function $as_sjs_js_WrappedArray(obj) {
  return (((obj instanceof $c_sjs_js_WrappedArray) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.WrappedArray"));
}
function $isArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_WrappedArray)));
}
function $asArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (($isArrayOf_sjs_js_WrappedArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.WrappedArray;", depth));
}
var $d_sjs_js_WrappedArray = new $TypeData().initClass($c_sjs_js_WrappedArray, "scala.scalajs.js.WrappedArray", ({
  sjs_js_WrappedArray: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  scm_IndexedBuffer: 1,
  scm_Builder: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9(F0$9) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1 = null;
  this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1 = F0$9;
  $ct_Lcats_effect_kernel_ResourceAsync__(this);
}
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype = new $h_Lcats_effect_kernel_ResourceAsync();
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype.constructor = $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceHOInstances0$$anon$9() {
}
$h_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype = $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype;
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype.F__Lcats_effect_kernel_GenConcurrent = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
});
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances0$$anon$9__f_F0$1;
});
var $d_Lcats_effect_kernel_ResourceHOInstances0$$anon$9 = new $TypeData().initClass($c_Lcats_effect_kernel_ResourceHOInstances0$$anon$9, "cats.effect.kernel.ResourceHOInstances0$$anon$9", ({
  Lcats_effect_kernel_ResourceHOInstances0$$anon$9: 1,
  Lcats_effect_kernel_ResourceAsync: 1,
  Lcats_effect_kernel_ResourceConcurrent: 1,
  Lcats_effect_kernel_ResourceMonadCancel: 1,
  Lcats_effect_kernel_ResourceMonad: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_ApplicativeError: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_ResourceClock: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_ResourceTemporal: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_ResourceSync: 1,
  Lcats_effect_kernel_AsyncPlatform: 1,
  Lcats_effect_kernel_Async: 1
}));
function $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, array, start, end) {
  var assertion = (($n(array).u.length & (($n(array).u.length - 1) | 0)) === 0);
  if ((!assertion)) {
    throw new $c_jl_AssertionError("assertion failed: Array.length must be power of 2");
  }
  var until = $n(array).u.length;
  if (((start < 0) || (start >= until))) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(start, ((until - 1) | 0)));
  }
  var until$1 = $n(array).u.length;
  if (((end < 0) || (end >= until$1))) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(end, ((until$1 - 1) | 0)));
  }
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end;
}
function $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end) {
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end;
  $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, $thiz.scm_ArrayDeque__f_array, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end);
  return $thiz;
}
function $ct_scm_ArrayDeque__I__($thiz, initialSize) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, $m_scm_ArrayDeque$().alloc__I__AO(initialSize), 0, 0);
  return $thiz;
}
/** @constructor */
function $c_scm_ArrayDeque() {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0;
}
$c_scm_ArrayDeque.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayDeque.prototype.constructor = $c_scm_ArrayDeque;
/** @constructor */
function $h_scm_ArrayDeque() {
}
$h_scm_ArrayDeque.prototype = $c_scm_ArrayDeque.prototype;
$c_scm_ArrayDeque.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ArrayDeque.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_scm_ArrayDeque.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ArrayDeque.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ArrayDeque.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_scm_ArrayDeque.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_scm_ArrayDeque.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this);
});
$c_scm_ArrayDeque.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_ArrayDeque.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_ArrayDeque.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_ArrayDeque.prototype.lengthCompare__I__I = (function(len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var x = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_ArrayDeque.prototype.knownSize__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
});
$c_scm_ArrayDeque.prototype.apply__I__O = (function(idx) {
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var until = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, ((until - 1) | 0)));
  }
  return $n(this.scm_ArrayDeque__f_array).get((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0)));
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_ArrayDeque = (function(elem) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var hint = ((1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0))) | 0);
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0))) && (hint >= $n(this.scm_ArrayDeque__f_array).u.length))) {
    this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint);
  }
  $n(this.scm_ArrayDeque__f_array).set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end, elem);
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
  return this;
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_ArrayDeque = (function(elems) {
  var x1 = $n(elems).knownSize__I();
  if ((x1 > 0)) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var hint = ((x1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0))) | 0);
    var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0))) && (hint >= $n(this.scm_ArrayDeque__f_array).u.length))) {
      this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint);
    }
    var this$1 = $n($n(elems).iterator__sc_Iterator());
    while (this$1.hasNext__Z()) {
      var x0 = this$1.next__O();
      $n(this.scm_ArrayDeque__f_array).set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end, x0);
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
    }
  } else {
    var this$2 = $n($n(elems).iterator__sc_Iterator());
    while (this$2.hasNext__Z()) {
      var x0$1 = this$2.next__O();
      this.addOne__O__scm_ArrayDeque(x0$1);
    }
  }
  return this;
});
$c_scm_ArrayDeque.prototype.remove__I__I__V = (function(idx, count) {
  if ((count > 0)) {
    var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var until = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
    if (((idx < 0) || (idx >= until))) {
      throw $n($m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, ((until - 1) | 0)));
    }
    var idx$2 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var n = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$2) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
    var a = ((n - idx) | 0);
    var removals = ((a < count) ? a : count);
    var finalLength = ((n - removals) | 0);
    var suffixStart = ((idx + removals) | 0);
    if ((($n(this.scm_ArrayDeque__f_array).u.length > 128) && ((((($n(this.scm_ArrayDeque__f_array).u.length - finalLength) | 0) - (finalLength >> 1)) | 0) > finalLength))) {
      var array2 = $m_scm_ArrayDeque$().alloc__I__AO(finalLength);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, array2, 0, idx);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, suffixStart, array2, idx, n);
      $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, finalLength);
    } else if (((idx << 1) <= finalLength)) {
      var i = ((suffixStart - 1) | 0);
      while ((i >= removals)) {
        var idx$4 = i;
        var idx$3 = ((i - removals) | 0);
        var elem = $n(this.scm_ArrayDeque__f_array).get((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$3) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0)));
        $n(this.scm_ArrayDeque__f_array).set((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$4) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0)), elem);
        i = ((i - 1) | 0);
      }
      while ((i >= 0)) {
        var idx$5 = i;
        $n(this.scm_ArrayDeque__f_array).set((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$5) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0)), null);
        i = ((i - 1) | 0);
      }
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + removals) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
    } else {
      var i$2 = idx;
      while ((i$2 < finalLength)) {
        var idx$7 = i$2;
        var idx$6 = ((i$2 + removals) | 0);
        var elem$1 = $n(this.scm_ArrayDeque__f_array).get((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$6) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0)));
        $n(this.scm_ArrayDeque__f_array).set((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$7) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0)), elem$1);
        i$2 = ((1 + i$2) | 0);
      }
      while ((i$2 < n)) {
        var idx$8 = i$2;
        $n(this.scm_ArrayDeque__f_array).set((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$8) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0)), null);
        i$2 = ((1 + i$2) | 0);
      }
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - removals) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
    }
  } else {
    var requirement = (count === 0);
    if ((!requirement)) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "removing negative number of elements: ") + count));
    }
  }
});
$c_scm_ArrayDeque.prototype.remove__I__O = (function(idx) {
  var elem = this.apply__I__O(idx);
  this.remove__I__I__V(idx, 1);
  return elem;
});
$c_scm_ArrayDeque.prototype.subtractOne__O__scm_ArrayDeque = (function(elem) {
  var idx = $f_sc_SeqOps__indexOf__O__I__I(this, elem, 0);
  if ((idx >= 0)) {
    this.remove__I__I__V(idx, 1);
  }
  return this;
});
$c_scm_ArrayDeque.prototype.removeHead__Z__O = (function(resizeInternalRepr) {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty collection");
  } else {
    var elem = $n(this.scm_ArrayDeque__f_array).get(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start);
    $n(this.scm_ArrayDeque__f_array).set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start, null);
    this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
    if (resizeInternalRepr) {
      var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
      this.scala$collection$mutable$ArrayDeque$$resize__I__V((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0)));
    }
    return elem;
  }
});
$c_scm_ArrayDeque.prototype.length__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
});
$c_scm_ArrayDeque.prototype.isEmpty__Z = (function() {
  return (this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start === this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end);
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayDeque$();
});
$c_scm_ArrayDeque.prototype.copyToArray__O__I__I__I = (function(dest, destStart, len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var srcLen = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
  var destLen = $m_jl_reflect_Array$().getLength__O__I(dest);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((destStart < 0) ? destLen : ((destLen - destStart) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, destStart, len);
  }
  return copied;
});
$c_scm_ArrayDeque.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$1) {
  var $x_1 = $n(evidence$1);
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var dest = $x_1.newArray__I__O((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0)));
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var maxItems = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
  return $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, maxItems);
});
$c_scm_ArrayDeque.prototype.scala$collection$mutable$ArrayDeque$$resize__I__V = (function(len) {
  if (((len >= $n(this.scm_ArrayDeque__f_array).u.length) || (($n(this.scm_ArrayDeque__f_array).u.length > 16) && ((($n(this.scm_ArrayDeque__f_array).u.length - len) | 0) > len)))) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var n = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (($n(this.scm_ArrayDeque__f_array).u.length - 1) | 0));
    var dest = $m_scm_ArrayDeque$().alloc__I__AO(len);
    var array2 = $asArrayOf_O($f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, n), 1);
    $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, n);
  }
});
$c_scm_ArrayDeque.prototype.stringPrefix__T = (function() {
  return "ArrayDeque";
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_IterableFactory = (function() {
  return this.iterableFactory__sc_SeqFactory();
});
$c_scm_ArrayDeque.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_ArrayDeque(elem);
});
$c_scm_ArrayDeque.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return this.subtractOne__O__scm_ArrayDeque(x);
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayDeque(elems);
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayDeque(elem);
});
$c_scm_ArrayDeque.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1));
});
function $as_scm_ArrayDeque(obj) {
  return (((obj instanceof $c_scm_ArrayDeque) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayDeque"));
}
function $isArrayOf_scm_ArrayDeque(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayDeque)));
}
function $asArrayOf_scm_ArrayDeque(obj, depth) {
  return (($isArrayOf_scm_ArrayDeque(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayDeque;", depth));
}
var $d_scm_ArrayDeque = new $TypeData().initClass($c_scm_ArrayDeque, "scala.collection.mutable.ArrayDeque", ({
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_scm_BitSet__AJ__($thiz, elems) {
  $thiz.scm_BitSet__f_elems = elems;
  return $thiz;
}
function $ct_scm_BitSet__I__($thiz, initSize) {
  var x = (((63 + initSize) | 0) >> 6);
  $ct_scm_BitSet__AJ__($thiz, new $ac_J(((x > 1) ? x : 1)));
  return $thiz;
}
function $ct_scm_BitSet__($thiz) {
  $ct_scm_BitSet__I__($thiz, 0);
  return $thiz;
}
/** @constructor */
function $c_scm_BitSet() {
  this.scm_BitSet__f_elems = null;
}
$c_scm_BitSet.prototype = new $h_scm_AbstractSet();
$c_scm_BitSet.prototype.constructor = $c_scm_BitSet;
/** @constructor */
function $h_scm_BitSet() {
}
$h_scm_BitSet.prototype = $c_scm_BitSet.prototype;
$c_scm_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet";
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  var b = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(this);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(that);
  return $as_sc_BitSet($as_sc_SetOps(b.scm_GrowableBuilder__f_elems));
});
$c_scm_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$();
});
$c_scm_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0);
});
$c_scm_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this);
});
$c_scm_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this);
});
$c_scm_BitSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_BitSet.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_scm_BitSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__scm_BitSet(pred, false);
});
$c_scm_BitSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that);
});
$c_scm_BitSet.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
});
$c_scm_BitSet.prototype.nwords__I = (function() {
  return (($n(this.scm_BitSet__f_elems).u.length >>> 1) | 0);
});
$c_scm_BitSet.prototype.word__I__J = (function(idx) {
  if ((idx < (($n(this.scm_BitSet__f_elems).u.length >>> 1) | 0))) {
    var $x_1 = $n(this.scm_BitSet__f_elems).u;
    var $x_2 = $aJCheckGet($x_1, idx);
    return $bL($x_1[$x_2], $x_1[(($x_2 + 1) | 0)]);
  } else {
    return $bL(0, 0);
  }
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__scm_BitSet = (function(elems) {
  return (((($n(elems).u.length >>> 1) | 0) === 0) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : $ct_scm_BitSet__AJ__(new $c_scm_BitSet(), elems));
});
$c_scm_BitSet.prototype.addOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ((!$f_sc_BitSetOps__contains__I__Z(this, elem))) {
    var idx = (elem >> 6);
    var $x_1 = this.word__I__J(idx);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (x_$_lo | lo);
    var hi$1 = (x_$_hi | hi);
    this.updateWord__I__J__V(idx, lo$1, hi$1);
  }
  return this;
});
$c_scm_BitSet.prototype.subtractOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var $x_1 = this.word__I__J(idx);
    var x_$_lo = $x_1.l;
    var x_$_hi = $x_1.h;
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (x_$_lo & lo$1);
    var hi$2 = (x_$_hi & hi$1);
    this.updateWord__I__J__V(idx, lo$2, hi$2);
  }
  return this;
});
$c_scm_BitSet.prototype.updateWord__I__J__V = (function(idx, w_$_lo, w_$_hi) {
  this.ensureCapacity__I__V(idx);
  $n(this.scm_BitSet__f_elems).set(idx, w_$_lo, w_$_hi);
});
$c_scm_BitSet.prototype.ensureCapacity__I__V = (function(idx) {
  $m_s_Predef$().require__Z__V((idx < 33554432));
  if ((idx >= (($n(this.scm_BitSet__f_elems).u.length >>> 1) | 0))) {
    var newlen = (($n(this.scm_BitSet__f_elems).u.length >>> 1) | 0);
    while ((idx >= newlen)) {
      var x = (newlen << 1);
      newlen = ((x < 33554432) ? x : 33554432);
    }
    var elems1 = new $ac_J(newlen);
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_BitSet__f_elems, 0, elems1, 0, (($n(this.scm_BitSet__f_elems).u.length >>> 1) | 0));
    this.scm_BitSet__f_elems = elems1;
  }
});
$c_scm_BitSet.prototype.$bar$eq__sc_BitSet__scm_BitSet = (function(other) {
  this.ensureCapacity__I__V((($n(other).nwords__I() - 1) | 0));
  var i = 0;
  var othernwords = $n(other).nwords__I();
  while ((i < othernwords)) {
    var $x_5 = $n(this.scm_BitSet__f_elems);
    var $x_4 = i;
    var $x_1 = $n(this.scm_BitSet__f_elems).u;
    var $x_2 = $aJCheckGet($x_1, i);
    var x_$_lo = $x_1[$x_2];
    var x_$_hi = $x_1[(($x_2 + 1) | 0)];
    var $x_3 = $n(other).word__I__J(i);
    var x$1_$_lo = $x_3.l;
    var x$1_$_hi = $x_3.h;
    var lo = (x_$_lo | x$1_$_lo);
    var hi = (x_$_hi | x$1_$_hi);
    $x_5.set($x_4, lo, hi);
    i = ((1 + i) | 0);
  }
  return this;
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_BitSet = (function(xs) {
  if ($is_sc_BitSet(xs)) {
    var x2 = $as_sc_BitSet(xs);
    return this.$bar$eq__sc_BitSet__scm_BitSet(x2);
  } else if (false) {
    var x3 = $as_sci_Range(xs);
    var this$1 = $n(x3);
    if ((!this$1.sci_Range__f_isEmpty)) {
      var start = $n(x3).min__s_math_Ordering__I($m_s_math_Ordering$Int$());
      if ((start >= 0)) {
        var end = $n(x3).max__s_math_Ordering__I($m_s_math_Ordering$Int$());
        var endIdx = (end >> 6);
        this.ensureCapacity__I__V(endIdx);
        if ((($n(x3).sci_Range__f_step === 1) || ($n(x3).sci_Range__f_step === (-1)))) {
          var startIdx = (start >> 6);
          var wordStart = (startIdx << 6);
          var n = ((start - wordStart) | 0);
          var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
          var hi = (((32 & n) === 0) ? (((2147483647 >>> (~n)) | 0) | ((-1) << n)) : ((-1) << n));
          if ((endIdx > startIdx)) {
            var ev$1 = this.scm_BitSet__f_elems;
            var $x_3 = $n(ev$1);
            var $x_1 = $n(ev$1).u;
            var $x_2 = $aJCheckGet($x_1, startIdx);
            var x_$_lo = $x_1[$x_2];
            var x_$_hi = $x_1[(($x_2 + 1) | 0)];
            var lo$1 = (x_$_lo | lo);
            var hi$1 = (x_$_hi | hi);
            $x_3.set(startIdx, lo$1, hi$1);
            var a = this.scm_BitSet__f_elems;
            var fromIndex = ((1 + startIdx) | 0);
            $m_ju_Arrays$().fill__AJ__I__I__J__V(a, fromIndex, endIdx, (-1), (-1));
            var ev$2 = this.scm_BitSet__f_elems;
            var $x_6 = $n(ev$2);
            var $x_4 = $n(ev$2).u;
            var $x_5 = $aJCheckGet($x_4, endIdx);
            var x$1_$_lo = $x_4[$x_5];
            var x$1_$_hi = $x_4[(($x_5 + 1) | 0)];
            var n$1 = ((63 - ((end - (endIdx << 6)) | 0)) | 0);
            var lo$2 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << (~n$1))) : (((-1) >>> n$1) | 0));
            var hi$2 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
            var lo$3 = (x$1_$_lo | lo$2);
            var hi$3 = (x$1_$_hi | hi$2);
            $x_6.set(endIdx, lo$3, hi$3);
          } else {
            var ev$3 = this.scm_BitSet__f_elems;
            var $x_9 = $n(ev$3);
            var $x_7 = $n(ev$3).u;
            var $x_8 = $aJCheckGet($x_7, endIdx);
            var x$2_$_lo = $x_7[$x_8];
            var x$2_$_hi = $x_7[(($x_8 + 1) | 0)];
            var n$2 = ((63 - ((end - wordStart) | 0)) | 0);
            var lo$4 = (((32 & n$2) === 0) ? ((((-1) >>> n$2) | 0) | ((-2) << (~n$2))) : (((-1) >>> n$2) | 0));
            var hi$4 = (((32 & n$2) === 0) ? (((-1) >>> n$2) | 0) : 0);
            var lo$5 = (lo & lo$4);
            var hi$5 = (hi & hi$4);
            var lo$6 = (x$2_$_lo | lo$5);
            var hi$6 = (x$2_$_hi | hi$5);
            $x_9.set(endIdx, lo$6, hi$6);
          }
        } else {
          $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3);
        }
      } else {
        $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3);
      }
    }
    return this;
  } else if ($is_sc_SortedSet(xs)) {
    var x4 = $as_sc_SortedSet(xs);
    var this$9 = $n(x4);
    if ((!this$9.isEmpty__Z())) {
      var ord = $n(x4).ordering__s_math_Ordering();
      if ((ord === $m_s_math_Ordering$Int$())) {
        var this$10 = $n(x4);
        this.ensureCapacity__I__V(($uI(this$10.last__O()) >> 6));
      } else {
        var this$11 = $m_s_math_Ordering$Int$();
        if ((ord === this$11.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)) {
          var this$12 = $n(x4);
          this.ensureCapacity__I__V(($uI(this$12.head__O()) >> 6));
        }
      }
      var iter = $n(x4).iterator__sc_Iterator();
      while ($n(iter).hasNext__Z()) {
        this.addOne__I__scm_BitSet($uI($n(iter).next__O()));
      }
    }
    return this;
  } else {
    return $as_scm_BitSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$c_scm_BitSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  if ($is_sc_BitSet(that)) {
    var x2 = $as_sc_BitSet(that);
    var thisnwords = (($n(this.scm_BitSet__f_elems).u.length >>> 1) | 0);
    var bsnwords = $n(x2).nwords__I();
    var minWords = ((thisnwords < bsnwords) ? thisnwords : bsnwords);
    var i = bsnwords;
    while ((i < thisnwords)) {
      var $x_1 = this.word__I__J(i);
      var x_$_lo = $x_1.l;
      var x_$_hi = $x_1.h;
      if (((x_$_lo | x_$_hi) !== 0)) {
        return false;
      }
      i = ((1 + i) | 0);
    }
    var j = 0;
    while ((j < minWords)) {
      var $x_2 = this.word__I__J(j);
      var x$2_$_lo = $x_2.l;
      var x$2_$_hi = $x_2.h;
      var $x_3 = $n(x2).word__I__J(j);
      var x$1_$_lo = $x_3.l;
      var x$1_$_hi = $x_3.h;
      var lo = (~x$1_$_lo);
      var hi = (~x$1_$_hi);
      var lo$1 = (x$2_$_lo & lo);
      var hi$1 = (x$2_$_hi & hi);
      if (((lo$1 | hi$1) !== 0)) {
        return false;
      }
      j = ((1 + j) | 0);
    }
    return true;
  } else {
    return $f_sc_IterableOnceOps__forall__F1__Z(this, that);
  }
});
$c_scm_BitSet.prototype.filterImpl__F1__Z__scm_BitSet = (function(pred, isFlipped) {
  var i = (((($n(this.scm_BitSet__f_elems).u.length >>> 1) | 0) - 1) | 0);
  var newArray = null;
  while ((i >= 0)) {
    var $x_3 = $m_sc_BitSetOps$();
    var $x_2 = this.word__I__J(i);
    var $x_1 = $x_3.computeWordForFilter__F1__Z__J__I__J(pred, isFlipped, $x_2.l, $x_2.h, i);
    var w_$_lo = $x_1.l;
    var w_$_hi = $x_1.h;
    if (((w_$_lo | w_$_hi) !== 0)) {
      if ((newArray === null)) {
        newArray = new $ac_J(((1 + i) | 0));
      }
      $n(newArray).set(i, w_$_lo, w_$_hi);
    }
    i = ((i - 1) | 0);
  }
  return ((newArray === null) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : this.fromBitMaskNoCopy__AJ__scm_BitSet(newArray));
});
$c_scm_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1);
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_BitSet(elems);
});
$c_scm_BitSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__I__scm_BitSet($uI(elem));
});
$c_scm_BitSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__I__scm_BitSet($uI(elem));
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return this.fromBitMaskNoCopy__AJ__scm_BitSet(elems);
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll);
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll);
});
function $as_scm_BitSet(obj) {
  return (((obj instanceof $c_scm_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.BitSet"));
}
function $isArrayOf_scm_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_BitSet)));
}
function $asArrayOf_scm_BitSet(obj, depth) {
  return (($isArrayOf_scm_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.BitSet;", depth));
}
var $d_scm_BitSet = new $TypeData().initClass($c_scm_BitSet, "scala.collection.mutable.BitSet", ({
  scm_BitSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
}));
/** @constructor */
function $c_scm_Queue(initialSize) {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0;
  var array = $m_scm_ArrayDeque$().alloc__I__AO(initialSize);
  $ct_scm_ArrayDeque__AO__I__I__(this, array, 0, 0);
}
$c_scm_Queue.prototype = new $h_scm_ArrayDeque();
$c_scm_Queue.prototype.constructor = $c_scm_Queue;
/** @constructor */
function $h_scm_Queue() {
}
$h_scm_Queue.prototype = $c_scm_Queue.prototype;
$c_scm_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_Queue$();
});
$c_scm_Queue.prototype.stringPrefix__T = (function() {
  return "Queue";
});
$c_scm_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Queue$();
});
function $as_scm_Queue(obj) {
  return (((obj instanceof $c_scm_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Queue"));
}
function $isArrayOf_scm_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Queue)));
}
function $asArrayOf_scm_Queue(obj, depth) {
  return (($isArrayOf_scm_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Queue;", depth));
}
var $d_scm_Queue = new $TypeData().initClass($c_scm_Queue, "scala.collection.mutable.Queue", ({
  scm_Queue: 1,
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
function $ct_Lcats_instances_AllInstancesBinCompat__($thiz) {
  $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz);
  $f_Lcats_instances_Function1Instances__$init$__V($thiz);
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz);
  $f_Lcats_instances_LazyListInstances__$init$__V($thiz);
  new $c_Lcats_instances_ListInstances$$anon$1();
  new $c_Lcats_instances_OptionInstances$$anon$1();
  $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz);
  new $c_Lcats_instances_VectorInstances$$anon$1();
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
  new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3();
  new $c_Lcats_instances_ListInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz);
  $f_Lcats_instances_SeqInstances__$init$__V($thiz);
  $f_Lcats_instances_InvariantInstances__$init$__V($thiz);
  return $thiz;
}
/** @constructor */
function $c_Lcats_instances_AllInstancesBinCompat() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
}
$c_Lcats_instances_AllInstancesBinCompat.prototype = new $h_O();
$c_Lcats_instances_AllInstancesBinCompat.prototype.constructor = $c_Lcats_instances_AllInstancesBinCompat;
/** @constructor */
function $h_Lcats_instances_AllInstancesBinCompat() {
}
$h_Lcats_instances_AllInstancesBinCompat.prototype = $c_Lcats_instances_AllInstancesBinCompat.prototype;
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = x$0;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.catsStdInstancesForLazyList__Lcats_Align = (function() {
  return this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = x$0;
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForNumeric_$eq__Lcats_Invariant__V = (function(x$0) {
});
$c_Lcats_instances_AllInstancesBinCompat.prototype.cats$instances$InvariantInstances$_setter_$catsInvariantForIntegral_$eq__Lcats_Invariant__V = (function(x$0) {
});
/** @constructor */
function $c_Lcats_instances_package$all$() {
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForFunction1 = null;
  this.Lcats_instances_AllInstancesBinCompat__f_catsStdInstancesForLazyList = null;
  $ct_Lcats_instances_AllInstancesBinCompat__(this);
}
$c_Lcats_instances_package$all$.prototype = new $h_Lcats_instances_AllInstancesBinCompat();
$c_Lcats_instances_package$all$.prototype.constructor = $c_Lcats_instances_package$all$;
/** @constructor */
function $h_Lcats_instances_package$all$() {
}
$h_Lcats_instances_package$all$.prototype = $c_Lcats_instances_package$all$.prototype;
var $d_Lcats_instances_package$all$ = new $TypeData().initClass($c_Lcats_instances_package$all$, "cats.instances.package$all$", ({
  Lcats_instances_package$all$: 1,
  Lcats_instances_AllInstancesBinCompat: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_instances_ShowInstances: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances3: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_instances_AllInstancesBinCompat6: 1,
  Lcats_kernel_instances_SeqInstances2: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_instances_SeqInstances: 1,
  Lcats_instances_AllInstancesBinCompat7: 1,
  Lcats_instances_InvariantInstances: 1,
  Lcats_instances_AllInstancesBinCompat8: 1,
  Lcats_kernel_instances_DeadlineInstances: 1,
  Lcats_instances_DeadlineInstances: 1,
  Lcats_instances_AllInstancesBinCompat9: 1
}));
var $n_Lcats_instances_package$all$;
function $m_Lcats_instances_package$all$() {
  if ((!$n_Lcats_instances_package$all$)) {
    $n_Lcats_instances_package$all$ = new $c_Lcats_instances_package$all$();
  }
  return $n_Lcats_instances_package$all$;
}
/** @constructor */
function $c_Lcats_implicits$() {
  this.Lcats_implicits$__f_catsKernelStdOrderForInt = null;
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = null;
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = null;
  this.Lcats_implicits$__f_catsStdInstancesForList = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForString = null;
  $n_Lcats_implicits$ = this;
  $f_Lcats_kernel_instances_IntInstances__$init$__V(this);
  $f_Lcats_kernel_instances_ByteInstances__$init$__V(this);
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this);
  $f_Lcats_kernel_instances_ShortInstances__$init$__V(this);
  $f_Lcats_kernel_instances_FloatInstances__$init$__V(this);
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V(this);
  $f_Lcats_kernel_instances_UnitInstances__$init$__V(this);
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V(this);
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V(this);
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V(this);
  $f_Lcats_instances_Function1Instances__$init$__V(this);
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_LazyListInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdInstancesForList = new $c_Lcats_instances_ListInstances$$anon$1();
  new $c_Lcats_instances_OptionInstances$$anon$1();
  $f_Lcats_kernel_instances_StringInstances__$init$__V(this);
  new $c_Lcats_instances_VectorInstances$$anon$1();
  new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
  new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$3();
  new $c_Lcats_instances_ListInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6();
  new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$7();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V(this);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V(this);
}
$c_Lcats_implicits$.prototype = new $h_O();
$c_Lcats_implicits$.prototype.constructor = $c_Lcats_implicits$;
/** @constructor */
function $h_Lcats_implicits$() {
}
$h_Lcats_implicits$.prototype = $c_Lcats_implicits$.prototype;
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForInt = x$0;
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdOrderForByte_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ByteInstances$_setter_$catsKernelStdGroupForByte_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdOrderForShort_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$ShortInstances$_setter_$catsKernelStdGroupForShort_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdOrderForFloat_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FloatInstances$_setter_$catsKernelStdGroupForFloat_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdOrderForDouble_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DoubleInstances$_setter_$catsKernelStdGroupForDouble_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdOrderForUnit_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$UnitInstances$_setter_$catsKernelStdAlgebraForUnit_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdOrderForBigInt_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigIntInstances$_setter_$catsKernelStdGroupForBigInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdOrderForBigDecimal_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BigDecimalInstances$_setter_$catsKernelStdGroupForBigDecimal_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdOrderForBitSet_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$BitSetInstances$_setter_$catsKernelStdSemilatticeForBitSet_$eq__Lcats_kernel_BoundedSemilattice__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.catsStdInstancesForFunction1__Lcats_arrow_ArrowChoice = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForFunction1;
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdInstancesForFunction1_$eq__Lcats_arrow_ArrowChoice__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = x$0;
});
$c_Lcats_implicits$.prototype.cats$instances$Function1Instances$_setter_$catsStdMonoidKForFunction1_$eq__Lcats_MonoidK__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.catsStdInstancesForLazyList__Lcats_Align = (function() {
  return this.Lcats_implicits$__f_catsStdInstancesForLazyList;
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdInstancesForLazyList_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = x$0;
});
$c_Lcats_implicits$.prototype.cats$instances$LazyListInstances$_setter_$catsStdTraverseFilterForLazyList_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForString = x$0;
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdOrderForDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$DurationInstances$_setter_$catsKernelStdGroupForDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdOrderForFiniteDuration_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$FiniteDurationInstances$_setter_$catsKernelStdGroupForFiniteDuration_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
var $d_Lcats_implicits$ = new $TypeData().initClass($c_Lcats_implicits$, "cats.implicits$", ({
  Lcats_implicits$: 1,
  Lcats_syntax_AlternativeSyntax: 1,
  Lcats_syntax_NonEmptyAlternativeSyntax: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align$ToAlignOps: 1,
  Lcats_syntax_AlignSyntax: 1,
  Lcats_syntax_ApplicativeSyntax: 1,
  Lcats_syntax_ApplicativeErrorSyntax: 1,
  Lcats_syntax_TupleSemigroupalSyntax: 1,
  Lcats_syntax_FunctionApplySyntax: 1,
  Lcats_syntax_ApplySyntax: 1,
  Lcats_arrow_Arrow$ToArrowOps: 1,
  Lcats_syntax_ArrowSyntax: 1,
  Lcats_arrow_ArrowChoice$ToArrowChoiceOps: 1,
  Lcats_syntax_ArrowChoiceSyntax: 1,
  Lcats_Bifunctor$ToBifunctorOps: 1,
  Lcats_syntax_BifunctorSyntax: 1,
  Lcats_Bifoldable$ToBifoldableOps: 1,
  Lcats_syntax_BifoldableSyntax: 1,
  Lcats_syntax_BitraverseSyntax1: 1,
  Lcats_syntax_BitraverseSyntax: 1,
  Lcats_syntax_SemigroupalSyntax: 1,
  Lcats_CoflatMap$ToCoflatMapOps: 1,
  Lcats_syntax_CoflatMapSyntax: 1,
  Lcats_Comonad$ToComonadOps: 1,
  Lcats_syntax_ComonadSyntax: 1,
  Lcats_arrow_Compose$ToComposeOps: 1,
  Lcats_syntax_ComposeSyntax: 1,
  Lcats_Contravariant$ToContravariantOps: 1,
  Lcats_syntax_ContravariantSyntax: 1,
  Lcats_Distributive$ToDistributiveOps: 1,
  Lcats_syntax_DistributiveSyntax: 1,
  Lcats_syntax_ContravariantMonoidalSyntax: 1,
  Lcats_syntax_ContravariantSemigroupalSyntax: 1,
  Lcats_syntax_EitherKSyntax: 1,
  Lcats_syntax_EitherSyntax: 1,
  Lcats_syntax_EqSyntax: 1,
  Lcats_FlatMap$ToFlatMapOps: 1,
  Lcats_syntax_FlatMapSyntax: 1,
  Lcats_Foldable$ToFoldableOps: 1,
  Lcats_UnorderedFoldable$ToUnorderedFoldableOps: 1,
  Lcats_syntax_FoldableSyntax: 1,
  Lcats_Functor$ToFunctorOps: 1,
  Lcats_syntax_FunctorSyntax: 1,
  Lcats_syntax_SemigroupSyntax: 1,
  Lcats_syntax_GroupSyntax: 1,
  Lcats_syntax_HashSyntax: 1,
  Lcats_Invariant$ToInvariantOps: 1,
  Lcats_syntax_InvariantSyntax: 1,
  Lcats_syntax_IorSyntax: 1,
  Lcats_syntax_ListSyntax: 1,
  Lcats_syntax_MonadErrorSyntax: 1,
  Lcats_syntax_MonadSyntax: 1,
  Lcats_syntax_MonoidSyntax: 1,
  Lcats_syntax_OptionSyntax: 1,
  Lcats_syntax_PartialOrderSyntax: 1,
  Lcats_syntax_OrderSyntax: 1,
  Lcats_syntax_TupleParallelSyntax: 1,
  Lcats_syntax_ParallelSyntax: 1,
  Lcats_arrow_Profunctor$ToProfunctorOps: 1,
  Lcats_syntax_ProfunctorSyntax: 1,
  Lcats_Reducible$ToReducibleOps: 1,
  Lcats_syntax_ReducibleSyntax: 1,
  Lcats_SemigroupK$ToSemigroupKOps: 1,
  Lcats_syntax_SemigroupKSyntax: 1,
  Lcats_Show$ToShowOps: 1,
  Lcats_syntax_ShowSyntax: 1,
  Lcats_arrow_Strong$ToStrongOps: 1,
  Lcats_syntax_StrongSyntax: 1,
  Lcats_Traverse$ToTraverseOps: 1,
  Lcats_syntax_TraverseSyntax: 1,
  Lcats_NonEmptyTraverse$ToNonEmptyTraverseOps: 1,
  Lcats_syntax_NonEmptyTraverseSyntax: 1,
  Lcats_syntax_ValidatedSyntax: 1,
  Lcats_syntax_VectorSyntax: 1,
  Lcats_syntax_WriterSyntax: 1,
  Lcats_syntax_ParallelFoldMapASyntax: 1,
  Lcats_syntax_ParallelTraverseFilterSyntax: 1,
  Lcats_syntax_ParallelReduceMapASyntax: 1,
  Lcats_syntax_AllSyntax: 1,
  Lcats_UnorderedTraverse$ToUnorderedTraverseOps: 1,
  Lcats_syntax_UnorderedTraverseSyntax: 1,
  Lcats_syntax_ApplicativeErrorExtension: 1,
  Lcats_syntax_TrySyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat0: 1,
  Lcats_syntax_FlatMapOptionSyntax: 1,
  Lcats_arrow_Choice$ToChoiceOps: 1,
  Lcats_syntax_ChoiceSyntax: 1,
  Lcats_syntax_NestedSyntax: 1,
  Lcats_syntax_BinestedSyntax: 1,
  Lcats_syntax_ParallelFlatSyntax: 1,
  Lcats_syntax_SetSyntax: 1,
  Lcats_syntax_ValidatedExtensionSyntax: 1,
  Lcats_syntax_RepresentableSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat1: 1,
  Lcats_syntax_ParallelTraverseSyntax: 1,
  Lcats_TraverseFilter$ToTraverseFilterOps: 1,
  Lcats_syntax_TraverseFilterSyntax: 1,
  Lcats_FunctorFilter$ToFunctorFilterOps: 1,
  Lcats_syntax_FunctorFilterSyntax: 1,
  Lcats_syntax_EitherSyntaxBinCompat0: 1,
  Lcats_syntax_ListSyntaxBinCompat0: 1,
  Lcats_syntax_ValidatedSyntaxBincompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat2: 1,
  Lcats_syntax_UnorderedFoldableSyntax: 1,
  Lcats_syntax_Function1Syntax: 1,
  Lcats_syntax_AllSyntaxBinCompat3: 1,
  Lcats_syntax_TraverseFilterSyntaxBinCompat0: 1,
  Lcats_syntax_ApplySyntaxBinCompat0: 1,
  Lcats_syntax_ParallelApplySyntax: 1,
  Lcats_syntax_FoldableSyntaxBinCompat0: 1,
  Lcats_syntax_ReducibleSyntaxBinCompat0: 1,
  Lcats_syntax_FoldableSyntaxBinCompat1: 1,
  Lcats_syntax_BitraverseSyntaxBinCompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat4: 1,
  Lcats_syntax_ParallelBitraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat5: 1,
  Lcats_syntax_ParallelUnorderedTraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat6: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_instances_ShowInstances: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances3: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_instances_AllInstancesBinCompat6: 1
}));
var $n_Lcats_implicits$;
function $m_Lcats_implicits$() {
  if ((!$n_Lcats_implicits$)) {
    $n_Lcats_implicits$ = new $c_Lcats_implicits$();
  }
  return $n_Lcats_implicits$;
}
var $t_Ljava_time_DayOfWeek$__MONDAY = null;
var $t_Ljava_time_DayOfWeek$__TUESDAY = null;
var $t_Ljava_time_DayOfWeek$__WEDNESDAY = null;
var $t_Ljava_time_DayOfWeek$__THURSDAY = null;
var $t_Ljava_time_DayOfWeek$__FRIDAY = null;
var $t_Ljava_time_DayOfWeek$__SATURDAY = null;
var $t_Ljava_time_DayOfWeek$__SUNDAY = null;
var $t_Ljava_time_Month$__JANUARY = null;
var $t_Ljava_time_Month$__FEBRUARY = null;
var $t_Ljava_time_Month$__MARCH = null;
var $t_Ljava_time_Month$__APRIL = null;
var $t_Ljava_time_Month$__MAY = null;
var $t_Ljava_time_Month$__JUNE = null;
var $t_Ljava_time_Month$__JULY = null;
var $t_Ljava_time_Month$__AUGUST = null;
var $t_Ljava_time_Month$__SEPTEMBER = null;
var $t_Ljava_time_Month$__OCTOBER = null;
var $t_Ljava_time_Month$__NOVEMBER = null;
var $t_Ljava_time_Month$__DECEMBER = null;
var $t_Ljava_time_format_ResolverStyle$__STRICT = null;
var $t_Ljava_time_format_ResolverStyle$__SMART = null;
var $t_Ljava_time_format_ResolverStyle$__LENIENT = null;
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE = null;
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE = null;
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT = null;
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT = null;
var $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND = null;
var $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND = null;
var $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND = null;
var $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE = null;
var $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR = null;
var $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM = null;
var $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM = null;
var $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK = null;
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH = null;
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH = null;
var $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY = null;
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH = null;
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH = null;
var $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA = null;
var $t_Ljava_time_temporal_ChronoField$__YEAR = null;
var $t_Ljava_time_temporal_ChronoField$__ERA = null;
var $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS = null;
var $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS = null;
var $t_Ljava_time_temporal_ChronoUnit$__NANOS = null;
var $t_Ljava_time_temporal_ChronoUnit$__MICROS = null;
var $t_Ljava_time_temporal_ChronoUnit$__MILLIS = null;
var $t_Ljava_time_temporal_ChronoUnit$__SECONDS = null;
var $t_Ljava_time_temporal_ChronoUnit$__MINUTES = null;
var $t_Ljava_time_temporal_ChronoUnit$__HOURS = null;
var $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = null;
var $t_Ljava_time_temporal_ChronoUnit$__DAYS = null;
var $t_Ljava_time_temporal_ChronoUnit$__WEEKS = null;
var $t_Ljava_time_temporal_ChronoUnit$__MONTHS = null;
var $t_Ljava_time_temporal_ChronoUnit$__YEARS = null;
var $t_Ljava_time_temporal_ChronoUnit$__DECADES = null;
var $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = null;
var $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = null;
var $t_Ljava_time_temporal_ChronoUnit$__ERAS = null;
var $t_Ljava_time_temporal_ChronoUnit$__FOREVER = null;
var $t_ju_Locale$Category$__DISPLAY = null;
var $t_ju_Locale$Category$__FORMAT = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadGraphviz = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Reroll = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__Start = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ApplySnapshot = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SaveSnapshot = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__LoadSnapshot = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__SyncNodeColours = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__ClearLog = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Msg$__NoOp = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_Node$__Approval = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Pending = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Running = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Suspended = null;
var $t_Lnet_andimiller_hedgehogs_dag_visitor_State$__Done = null;
var $t_Ltyrian_runtime_RendererState$__Idle = null;
exports.TyrianApp = $m_Lnet_andimiller_hedgehogs_dag_visitor_Demo$();
//# sourceMappingURL=main.js.map
